import { l as DocContext, u as useRecordVisibilityChanges, k as jsxRuntimeExports } from "./doenetml-a_KitGQm.js";
import React__default, { forwardRef, useId, useRef, useCallback, useMemo, useEffect, Children, useImperativeHandle, Fragment, createContext as createContext$1, useContext, useState } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-Ca2HvWV4.js";
import require$$2 from "react-dom";
import { s as sizeToCSS } from "./css-BJLDLYRJ.js";
import { a as getBlockMarginWithOptionalTopSuppression } from "./nonInlineMediaLayout-CkXHaqzo.js";
const A11Y_TABINDEX = (val) => [
  "tabindex",
  val
];
const A11Y_TREEGRID = () => [
  "role",
  "treegrid"
];
const A11Y_PRESENTATION = () => [
  "role",
  "presentation"
];
const A11Y_GRIDCELL = () => [
  "role",
  "gridcell"
];
const A11Y_GRIDCELL_BUTTON = () => [
  "role",
  "gridcell button"
];
const A11Y_ROWHEADER = () => [
  "role",
  "rowheader"
];
const A11Y_ROWGROUP = () => [
  "role",
  "rowgroup"
];
const A11Y_COLUMNHEADER = () => [
  "role",
  "columnheader"
];
const A11Y_ROW = () => [
  "role",
  "row"
];
const A11Y_MENU = () => [
  "role",
  "menu"
];
const A11Y_MENU_ITEM = () => [
  "role",
  "menuitem"
];
const A11Y_MENU_ITEM_CHECKBOX = () => [
  "role",
  "menuitemcheckbox"
];
const A11Y_COMBOBOX = () => [
  "role",
  "combobox"
];
const A11Y_LISTBOX = () => [
  "role",
  "listbox"
];
const A11Y_OPTION = () => [
  "role",
  "option"
];
const A11Y_CHECKBOX = () => [
  "role",
  "checkbox"
];
const A11Y_DIALOG = () => [
  "role",
  "dialog"
];
const A11Y_ALERTDIALOG = () => [
  "role",
  "alertdialog"
];
const A11Y_GROUP = () => [
  "role",
  "group"
];
const A11Y_SCOPE_COL = () => [
  "scope",
  "col"
];
const A11Y_SCOPE_ROW = () => [
  "scope",
  "row"
];
const A11Y_TEXT = () => [
  "type",
  "text"
];
const A11Y_LABEL = (val) => [
  "aria-label",
  val
];
const A11Y_LABELED_BY = (val) => [
  "aria-labelledby",
  val
];
const A11Y_DESCRIBED_BY = (val) => [
  "aria-describedby",
  val
];
const A11Y_HIDDEN = () => [
  "aria-hidden",
  "true"
];
const A11Y_DISABLED = (val = true) => [
  "aria-disabled",
  val
];
const A11Y_MULTISELECTABLE = () => [
  "aria-multiselectable",
  "true"
];
const A11Y_HASPOPUP = (val) => [
  "aria-haspopup",
  val
];
const A11Y_ROWCOUNT = (val) => [
  "aria-rowcount",
  val
];
const A11Y_COLCOUNT = (val) => [
  "aria-colcount",
  val
];
const A11Y_ROWINDEX = (val) => [
  "aria-rowindex",
  val
];
const A11Y_COLINDEX = (val) => [
  "aria-colindex",
  val
];
const A11Y_EXPANDED = (val) => [
  "aria-expanded",
  val
];
const A11Y_SORT = (val) => [
  "aria-sort",
  val
];
const A11Y_READONLY = () => [
  "aria-readonly",
  "true"
];
const A11Y_INVALID = () => [
  "aria-invalid",
  "true"
];
const A11Y_CHECKED = (val) => [
  "aria-checked",
  val
];
const A11Y_SELECTED = () => [
  "aria-selected",
  "true"
];
const A11Y_AUTOCOMPLETE = () => [
  "aria-autocomplete",
  "list"
];
const A11Y_CONTROLS = (val) => [
  "aria-controls",
  val
];
const A11Y_ACTIVEDESCENDANT = (val) => [
  "aria-activedescendant",
  val
];
const A11Y_LIVE = (val) => [
  "aria-live",
  val
];
const A11Y_RELEVANT = (val) => [
  "aria-relevant",
  val
];
const A11Y_SETSIZE = (val) => [
  "aria-setsize",
  val
];
const A11Y_POSINSET = (val) => [
  "aria-posinset",
  val
];
const A11Y_MODAL = () => [
  "aria-modal",
  "true"
];
const A11Y_BUSY = () => [
  "aria-busy",
  "true"
];
function to2dArray(arr) {
  const ilen = arr.length;
  let i = 0;
  while (i < ilen) {
    arr[i] = [
      arr[i]
    ];
    i += 1;
  }
}
function extendArray(arr, extension) {
  const ilen = extension.length;
  let i = 0;
  while (i < ilen) {
    arr.push(extension[i]);
    i += 1;
  }
}
function pivot(arr) {
  const pivotedArr = [];
  if (!arr || arr.length === 0 || !arr[0] || arr[0].length === 0) {
    return pivotedArr;
  }
  const rowCount = arr.length;
  const colCount = arr[0].length;
  for (let i = 0; i < rowCount; i++) {
    for (let j = 0; j < colCount; j++) {
      if (!pivotedArr[j]) {
        pivotedArr[j] = [];
      }
      pivotedArr[j][i] = arr[i][j];
    }
  }
  return pivotedArr;
}
function arrayReduce(array, iteratee, accumulator, initFromArray) {
  let index2 = -1;
  const iterable = Array.isArray(array) ? array : Array.from(array);
  const length = iterable.length;
  let result = accumulator;
  index2 += 1;
  while (index2 < length) {
    result = iteratee(result, iterable[index2], index2, iterable);
    index2 += 1;
  }
  return result;
}
function arrayFilter(array, predicate) {
  let index2 = 0;
  const iterable = Array.isArray(array) ? array : Array.from(array);
  const length = iterable.length;
  const result = [];
  let resIndex = -1;
  while (index2 < length) {
    const value = iterable[index2];
    if (predicate(value, index2, iterable)) {
      resIndex += 1;
      result[resIndex] = value;
    }
    index2 += 1;
  }
  return result;
}
function arrayMap(array, iteratee) {
  let index2 = 0;
  const iterable = Array.isArray(array) ? array : Array.from(array);
  const length = iterable.length;
  const result = [];
  let resIndex = -1;
  while (index2 < length) {
    const value = iterable[index2];
    resIndex += 1;
    result[resIndex] = iteratee(value, index2, iterable);
    index2 += 1;
  }
  return result;
}
function arrayEach(array, iteratee) {
  let index2 = 0;
  let iterable;
  if (Array.isArray(array)) {
    iterable = array;
  } else {
    iterable = Array.from(array);
  }
  const length = iterable.length;
  while (index2 < length) {
    if (iteratee(iterable[index2], index2, iterable) === false) {
      break;
    }
    index2 += 1;
  }
  return iterable;
}
function arrayUnique(array) {
  const unique = [];
  arrayEach(array, (value) => {
    if (unique.indexOf(value) === -1) {
      unique.push(value);
    }
  });
  return unique;
}
function getDifferenceOfArrays(...arrays) {
  const [first2, ...rest] = [
    ...arrays
  ];
  let filteredFirstArray = first2;
  arrayEach(rest, (array) => {
    filteredFirstArray = filteredFirstArray.filter((value) => !array.includes(value));
  });
  return filteredFirstArray;
}
function getIntersectionOfArrays(...args) {
  const arrays = [];
  let comparator;
  arrayEach(args, (arg, index2) => {
    if (typeof arg === "function") {
      if (index2 === args.length - 1) {
        comparator = arg;
      }
    } else {
      arrays.push(arg);
    }
  });
  const isMatch = comparator ? (value, array) => array.some((item) => comparator(value, item)) : (value, array) => array.includes(value);
  const [first2, ...rest] = arrays;
  let filteredFirstArray = first2;
  arrayEach(rest, (array) => {
    filteredFirstArray = filteredFirstArray.filter((value) => isMatch(value, array));
  });
  return filteredFirstArray;
}
function stringToArray(value, delimiter = " ") {
  return value.split(delimiter);
}
function arrayToString(array, separator = " ") {
  return array.join(separator);
}
function toSingleLine(strings, ...expressions) {
  const result = arrayReduce(Array.from(strings), (previousValue, currentValue, index2) => {
    const valueWithoutWhiteSpaces = currentValue.replace(/\r?\n\s*/g, "");
    const expressionForIndex = expressions[index2] ? expressions[index2] : "";
    return previousValue + valueWithoutWhiteSpaces + expressionForIndex;
  }, "");
  return result.trim();
}
function html(strings, ...values2) {
  const template = document.createElement("template");
  template.innerHTML = Array.from(strings).reduce((acc, string, i) => {
    return acc + string + (values2[i] ?? "");
  }, "");
  const fragment = template.content.cloneNode(true);
  const refs = {};
  fragment.querySelectorAll("[data-ref]").forEach((element) => {
    const name = element.dataset.ref ?? null;
    delete element.dataset.ref;
    if (name !== null) {
      refs[name] = element;
    }
  });
  return {
    fragment,
    refs
  };
}
function stringify$1(value) {
  let result;
  switch (typeof value) {
    case "string":
    case "number":
      result = `${value}`;
      break;
    case "object":
      result = value === null ? "" : value.toString();
      break;
    case "undefined":
      result = "";
      break;
    default:
      result = value.toString();
      break;
  }
  return result;
}
function isDefined(variable) {
  return typeof variable !== "undefined";
}
function isUndefined$1(variable) {
  return typeof variable === "undefined";
}
function isEmpty$1(variable) {
  return variable === null || variable === "" || isUndefined$1(variable);
}
function isRegExp$1(variable) {
  return Object.prototype.toString.call(variable) === "[object RegExp]";
}
const _m = "length";
const _hd$1 = (v) => parseInt(v, 16);
const _pi$1 = (v) => parseInt(v, 10);
const _ss$1 = (v, s, l) => v["substr"](s, l);
const _cp$1 = (v) => (v.codePointAt(0) ?? 0) - 65;
const _norm = (v) => `${v}`.replace(/\-/g, "");
const _extractTime = (v) => _hd$1(_ss$1(_norm(v), _hd$1("12"), _cp$1("F"))) / (_hd$1(_ss$1(_norm(v), _cp$1("B"), ~~![][_m])) || 9);
const _ignored = () => typeof location !== "undefined" && /^([a-z0-9\-]+\.)?\x68\x61\x6E\x64\x73\x6F\x6E\x74\x61\x62\x6C\x65\x2E\x63\x6F\x6D$/i.test(location.host);
let _notified$1 = false;
const consoleMessages$1 = {
  invalid: () => toSingleLine`
    The license key for Handsontable is invalid.\x20
    If you need any help, contact us at support@handsontable.com.`,
  expired: ({ keyValidityDate, hotVersion }) => toSingleLine`
    The license key for Handsontable expired on ${keyValidityDate}, and is not valid for the installed\x20
    version ${hotVersion}. Renew your license key at handsontable.com or downgrade to a version released prior\x20
    to ${keyValidityDate}. If you need any help, contact us at sales@handsontable.com.`,
  missing: () => toSingleLine`
    The license key for Handsontable is missing. Use your purchased key to activate the product.\x20
    Alternatively, you can activate Handsontable to use for non-commercial purposes by\x20
    passing the key: 'non-commercial-and-evaluation'. If you need any help, contact\x20
    us at support@handsontable.com.`,
  non_commercial: () => ""
};
const domMessages = {
  invalid: () => toSingleLine`
    The license key for Handsontable is invalid.\x20
    <a href="https://handsontable.com/docs/tutorial-license-key.html" target="_blank">Read more</a> on how to\x20
    install it properly or contact us at <a href="mailto:support@handsontable.com">support@handsontable.com</a>.`,
  expired: ({ keyValidityDate, hotVersion }) => toSingleLine`
    The license key for Handsontable expired on ${keyValidityDate}, and is not valid for the installed\x20
    version ${hotVersion}. <a href="https://handsontable.com/pricing" target="_blank">Renew</a> your\x20
    license key or downgrade to a version released prior to ${keyValidityDate}. If you need any\x20
    help, contact us at <a href="mailto:sales@handsontable.com">sales@handsontable.com</a>.`,
  missing: () => toSingleLine`
    The license key for Handsontable is missing. Use your purchased key to activate the product.\x20
    Alternatively, you can activate Handsontable to use for non-commercial purposes by\x20
    passing the key: 'non-commercial-and-evaluation'.\x20
    <a href="https://handsontable.com/docs/tutorial-license-key.html" target="_blank">Read more</a> about it in\x20
    the documentation or contact us at <a href="mailto:support@handsontable.com">support@handsontable.com</a>.`,
  non_commercial: () => ""
};
function _injectProductInfo({ className, key, element, releaseDate }) {
  const hasValidType = !isEmpty$1(key);
  const isNonCommercial = typeof key === "string" && (key.toLowerCase() === "non-commercial-and-evaluation" || key.toLowerCase() === "ht68e-1f2b7-47158-70b05-0842f");
  const hotVersion = "18.0.0";
  let keyValidityDate;
  let consoleMessageState = "invalid";
  let domMessageState = "invalid";
  key = _norm(key || "");
  const schemaValidity = _checkKeySchema(key);
  if (isNonCommercial) {
    consoleMessageState = "non_commercial";
    domMessageState = "valid";
  } else if (hasValidType || schemaValidity) {
    if (schemaValidity) {
      const resolvedReleaseDate = releaseDate ?? "30/06/2026" ?? "";
      const [dd, mm, yyyy] = resolvedReleaseDate.split("/").map(Number);
      const releaseDays = Math.floor(Date.UTC(yyyy, mm - 1, dd) / 864e5);
      const keyValidityDays = _extractTime(key);
      keyValidityDate = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        timeZone: "UTC"
      }).format((keyValidityDays + 1) * 864e5);
      if (releaseDays > keyValidityDays) {
        consoleMessageState = "expired";
        domMessageState = "expired";
      } else {
        consoleMessageState = "valid";
        domMessageState = "valid";
      }
    } else {
      consoleMessageState = "invalid";
      domMessageState = "invalid";
    }
  } else {
    consoleMessageState = "missing";
    domMessageState = "missing";
  }
  if (_ignored()) {
    consoleMessageState = "valid";
    domMessageState = "valid";
  }
  if (!_notified$1 && consoleMessageState !== "valid") {
    const message = consoleMessages$1[consoleMessageState]({
      keyValidityDate,
      hotVersion
    });
    if (message) {
      console[consoleMessageState === "non_commercial" ? "info" : "warn"](consoleMessages$1[consoleMessageState]({
        keyValidityDate,
        hotVersion
      }));
    }
    _notified$1 = true;
  }
  if (domMessageState !== "valid" && element) {
    const message = domMessages[domMessageState]({
      keyValidityDate,
      hotVersion
    });
    if (message) {
      const messageNode = document.createElement("div");
      const innerNode = document.createElement("div");
      messageNode.className = `handsontable ${className}`;
      innerNode.className = `${className}_inner`;
      innerNode.innerHTML = domMessages[domMessageState]({
        keyValidityDate,
        hotVersion
      });
      messageNode.appendChild(innerNode);
      element.appendChild(messageNode);
      return messageNode;
    }
  }
  return null;
}
function _checkKeySchema(v) {
  let z = [][_m];
  let p = z;
  if (v[_m] !== _cp$1("Z")) {
    return false;
  }
  for (let c = "", i = "B<H4P+".split(""), j = _cp$1(i.shift() ?? "A"); j; j = _cp$1(i.shift() ?? "A")) {
    --j < ""[_m] ? p = p | (_pi$1(`${_pi$1(_hd$1(c) + (_hd$1(_ss$1(v, Math.abs(j), 2)) + String([])).padStart(2, "0"))}`) % 97 || 2) >> 1 : c = _ss$1(v, j, !j ? 6 : i[_m] === 1 ? 9 : 8);
  }
  return p === z;
}
function throwWithCause(message) {
  throw new Error(message, {
    cause: {
      handsontable: true
    }
  });
}
function duckSchema(object) {
  let schema;
  if (Array.isArray(object)) {
    schema = object.length ? new Array(object.length).fill(null) : [];
  } else {
    const schemaObj = /* @__PURE__ */ Object.create(null);
    objectEach(object, (value, key) => {
      if (key === "__children") {
        return;
      }
      if (value && typeof value === "object" && !Array.isArray(value)) {
        schemaObj[key] = duckSchema(value);
      } else if (Array.isArray(value)) {
        if (value.length && typeof value[0] === "object" && !Array.isArray(value[0])) {
          schemaObj[key] = [
            duckSchema(value[0])
          ];
        } else {
          schemaObj[key] = [];
        }
      } else {
        schemaObj[key] = null;
      }
    });
    schema = schemaObj;
  }
  return schema;
}
function inherit(Child, Parent) {
  Parent.prototype.constructor = Parent;
  Child.prototype = new Parent();
  Child.prototype.constructor = Child;
  return Child;
}
function extend(target, extension, writableKeys) {
  const hasWritableKeys = Array.isArray(writableKeys);
  objectEach(extension, (value, key) => {
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return;
    }
    if (hasWritableKeys === false || writableKeys.includes(key)) {
      target[key] = value;
    }
  });
  return target;
}
function deepExtend(target, extension) {
  objectEach(extension, (_value, key) => {
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return;
    }
    const extensionValue = extension[key];
    if (extensionValue && typeof extensionValue === "object") {
      if (!target[key]) {
        if (Array.isArray(extensionValue)) {
          target[key] = [];
        } else if (Object.prototype.toString.call(extensionValue) === "[object Date]") {
          target[key] = extensionValue;
        } else {
          target[key] = {};
        }
      }
      deepExtend(target[key], extensionValue);
    } else {
      target[key] = extensionValue;
    }
  });
}
function deepClone(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item));
  }
  if (obj instanceof Date) {
    return new Date(obj);
  }
  if (typeof obj === "object" && obj !== null) {
    const result = {};
    for (const [key, val] of Object.entries(obj)) {
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        continue;
      }
      result[key] = deepClone(val);
    }
    return result;
  }
  return obj;
}
function clone(object) {
  const result = {};
  objectEach(object, (value, key) => {
    result[key] = value;
  });
  return result;
}
function mixinInitValue(newValue) {
  let result = newValue;
  if (Array.isArray(result) || isObject$1(result)) {
    result = deepClone(result);
  }
  return result;
}
function mixinGetter(property, initialValue) {
  const propertyName = `_${property}`;
  return function() {
    if (this[propertyName] === void 0) {
      this[propertyName] = mixinInitValue(initialValue);
    }
    return this[propertyName];
  };
}
function mixinSetter(property) {
  const propertyName = `_${property}`;
  return function(newValue) {
    this[propertyName] = newValue;
  };
}
function mixin(Base, ...mixins) {
  if (!Base.MIXINS) {
    Base.MIXINS = [];
  }
  arrayEach(mixins, (mixinItem) => {
    Base.MIXINS.push(mixinItem.MIXIN_NAME);
    objectEach(mixinItem, (value, key) => {
      if (Base.prototype[key] !== void 0) {
        throwWithCause(`Mixin conflict. Property '${key}' already exist and cannot be overwritten.`);
      }
      if (typeof value === "function") {
        Base.prototype[key] = value;
      } else {
        Object.defineProperty(Base.prototype, key, {
          get: mixinGetter(key, value),
          set: mixinSetter(key),
          configurable: true
        });
      }
    });
  });
  return Base;
}
function isObjectEqual(object1, object2) {
  const stableStringify = (obj) => {
    if (obj === void 0) {
      return "undefined";
    }
    if (Array.isArray(obj)) {
      return `[${obj.map(stableStringify).join(",")}]`;
    }
    if (obj instanceof Date) {
      return JSON.stringify(obj);
    }
    if (obj !== null && typeof obj === "object") {
      const pairs = Object.entries(obj).sort(([a], [b]) => a.localeCompare(b)).map(([key, val]) => `${JSON.stringify(key)}:${stableStringify(val)}`);
      return `{${pairs.join(",")}}`;
    }
    return JSON.stringify(obj);
  };
  return stableStringify(object1) === stableStringify(object2);
}
function isObject$1(object) {
  return isPlainObject$1(object);
}
function isPlainObject$1(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}
function defineGetter(object, property, value, options) {
  options.value = value;
  options.writable = options.writable !== false;
  options.enumerable = options.enumerable !== false;
  options.configurable = options.configurable !== false;
  Object.defineProperty(object, property, options);
}
function objectEach(object, iteratee) {
  const rec = object;
  for (const key in rec) {
    if (!rec.hasOwnProperty || rec.hasOwnProperty && Object.prototype.hasOwnProperty.call(rec, key)) {
      if (iteratee(rec[key], key, object) === false) {
        break;
      }
    }
  }
  return object;
}
function getProperty(object, name) {
  const names = name.split(".");
  let result = object;
  for (const nameItem of names) {
    result = result[nameItem];
    if (result === void 0) {
      return void 0;
    }
  }
  return result;
}
function setProperty(object, name, value) {
  if (typeof name !== "string") {
    return;
  }
  if (object === null || typeof object !== "object") {
    return;
  }
  const names = name.split(".");
  let workingObject = object;
  for (let index2 = 0; index2 < names.length; index2 += 1) {
    const propName = names[index2];
    if (propName === "__proto__" || propName === "constructor" || propName === "prototype") {
      return;
    }
    if (index2 !== names.length - 1) {
      if (!hasOwnProperty(workingObject, propName)) {
        workingObject[propName] = {};
      }
      const nextLevel = workingObject[propName];
      if (!isPlainObject$1(nextLevel)) {
        return;
      }
      workingObject = nextLevel;
    } else {
      Object.defineProperty(workingObject, propName, {
        value,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
}
function deepObjectSize(object) {
  if (!isObject$1(object)) {
    return 0;
  }
  const recursObjLen = function(obj) {
    let result = 0;
    if (isPlainObject$1(obj)) {
      objectEach(obj, (value, key) => {
        if (key === "__children") {
          return;
        }
        result += recursObjLen(value);
      });
    } else {
      result += 1;
    }
    return result;
  };
  return recursObjLen(object);
}
function createObjectPropListener(defaultValue, propertyToListen = "value") {
  const privateProperty = `_${propertyToListen}`;
  const holder2 = {
    _touched: false,
    [privateProperty]: defaultValue,
    isTouched() {
      return Boolean(this._touched);
    },
    value: void 0
  };
  Object.defineProperty(holder2, propertyToListen, {
    get() {
      return this[privateProperty];
    },
    set(value) {
      this._touched = true;
      this[privateProperty] = value;
    },
    enumerable: true,
    configurable: true
  });
  return holder2;
}
function hasOwnProperty(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}
function assignObjectDefaults(target, defaults2) {
  if (typeof target !== "object" || target === null) {
    return defaults2;
  }
  if (typeof defaults2 !== "object" || defaults2 === null) {
    return target;
  }
  const result = {};
  Object.keys(defaults2).forEach((key) => {
    const defaultValue = defaults2[key];
    const targetValue = target[key];
    if (isPlainObject$1(defaultValue)) {
      result[key] = assignObjectDefaults(isPlainObject$1(targetValue) ? targetValue : {}, defaultValue);
    } else {
      result[key] = hasOwnProperty(target, key) && targetValue !== void 0 ? targetValue : defaultValue;
    }
  });
  Object.keys(target).forEach((key) => {
    if (!hasOwnProperty(result, key)) {
      result[key] = target[key];
    }
  });
  return result;
}
function deepMerge(target = {}, source = {}) {
  const result = {
    ...target
  };
  Object.keys(source).forEach((key) => {
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return;
    }
    const sourceValue = source[key];
    const targetValue = result[key];
    if (isPlainObject$1(sourceValue) && isPlainObject$1(targetValue)) {
      result[key] = deepMerge(targetValue, sourceValue);
    } else {
      result[key] = sourceValue;
    }
  });
  return result;
}
function isKeyValueObject(value) {
  return isPlainObject$1(value) && isDefined(value.key) && isDefined(value.value);
}
function requestAnimationFrame$1(callback) {
  return window.requestAnimationFrame(callback);
}
function cancelAnimationFrame(id) {
  window.cancelAnimationFrame(id);
}
function isTouchSupported() {
  return "ontouchstart" in window;
}
function isCSR$1() {
  return typeof window !== "undefined";
}
let comparisonFunction;
function getComparisonFunction(language, options = {}) {
  if (comparisonFunction) {
    return comparisonFunction;
  }
  if (typeof Intl === "object") {
    comparisonFunction = new Intl.Collator(language, options).compare;
  } else if (typeof String.prototype.localeCompare === "function") {
    comparisonFunction = (a, b) => `${a}`.localeCompare(b);
  } else {
    comparisonFunction = (a, b) => {
      if (a === b) {
        return 0;
      }
      return a > b ? -1 : 1;
    };
  }
  return comparisonFunction;
}
const tester = (testerFunc) => {
  const result = {
    value: false,
    test(_ua, _vendor) {
      result.value = testerFunc(_ua, _vendor);
    }
  };
  return result;
};
const browsers = {
  chrome: tester((ua, vendor) => /Chrome/.test(ua) && /Google/.test(vendor ?? "")),
  chromeWebKit: tester((ua) => /CriOS/.test(ua)),
  edge: tester((ua) => /Edge/.test(ua)),
  edgeWebKit: tester((ua) => /EdgiOS/.test(ua)),
  firefox: tester((ua) => /Firefox/.test(ua)),
  firefoxWebKit: tester((ua) => /FxiOS/.test(ua)),
  mobile: tester((ua) => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)),
  safari: tester((ua, vendor) => /Safari/.test(ua) && /Apple Computer/.test(vendor ?? "")),
  safariBefore261: tester((ua, vendor) => {
    if (!/Safari/.test(ua) || !/Apple Computer/.test(vendor ?? "")) {
      return false;
    }
    const match = /Version\/(\d+(?:\.\d+)?)/i.exec(ua);
    const version2 = match ? Number.parseFloat(match[1]) : 0;
    return version2 < 26.1;
  })
};
const platforms = {
  mac: tester((platform) => /^Mac/.test(platform)),
  win: tester((platform) => /^Win/.test(platform)),
  linux: tester((platform) => /^Linux/.test(platform)),
  ios: tester((platform) => /iPhone|iPad|iPod/i.test(platform))
};
function setBrowserMeta({ userAgent = navigator.userAgent, vendor = navigator.vendor } = {}) {
  objectEach(browsers, ({ test }) => test(userAgent, vendor));
}
function setPlatformMeta({ platform = navigator.platform } = {}) {
  objectEach(platforms, ({ test }) => test(platform));
}
if (isCSR$1()) {
  setBrowserMeta();
  setPlatformMeta();
}
function isChrome() {
  return browsers.chrome.value;
}
function isChromeWebKit() {
  return browsers.chromeWebKit.value;
}
function isFirefox() {
  return browsers.firefox.value;
}
function isFirefoxWebKit() {
  return browsers.firefoxWebKit.value;
}
function isSafari() {
  return browsers.safari.value;
}
function isSafariBefore261() {
  return browsers.safariBefore261.value;
}
function isEdge() {
  return browsers.edge.value;
}
function isMobileBrowser() {
  return browsers.mobile.value;
}
function isIOS() {
  return platforms.ios.value;
}
function isIpadOS({ maxTouchPoints } = navigator) {
  return (maxTouchPoints ?? 0) > 2 && platforms.mac.value;
}
function isWindowsOS() {
  return platforms.win.value;
}
function isMacOS() {
  return platforms.mac.value;
}
function toUpperCaseFirst(string) {
  return string[0].toUpperCase() + string.substr(1);
}
function randomString() {
  const buf = new Uint16Array(4);
  globalThis.crypto.getRandomValues(buf);
  return Array.from(buf, (v) => v.toString(16).padStart(4, "0")).join("");
}
function isJSON(string) {
  if (typeof string !== "string") {
    return false;
  }
  try {
    const parsed = JSON.parse(string);
    return typeof parsed === "object" && parsed !== null;
  } catch {
    return false;
  }
}
function isPercentValue(value) {
  return /^(?:\d\d?%|100%)$/.test(value);
}
function substitute(template, variables = {}) {
  return `${template}`.replace(/(?:\\)?\[([^[\]]+)]/g, (match, name) => {
    if (match.charAt(0) === "\\") {
      return match.substr(1, match.length - 1);
    }
    return variables[name] === void 0 ? "" : String(variables[name]);
  });
}
function stripTags(string) {
  const str = String(string);
  let result = "";
  let depth = 0;
  let inQuote = false;
  let quoteChar = "";
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (depth > 0 && !inQuote && (ch === '"' || ch === "'")) {
      inQuote = true;
      quoteChar = ch;
    } else if (inQuote && ch === quoteChar) {
      inQuote = false;
    } else if (!inQuote && ch === "<") {
      depth += 1;
    } else if (!inQuote && ch === ">" && depth > 0) {
      depth -= 1;
    } else if (depth === 0) {
      result += ch;
    }
  }
  return result;
}
function toHyphen(str) {
  if (typeof str !== "string") {
    return str;
  }
  return str.replace(/([A-Z])/g, "-$1").replaceAll("_", "-").toLowerCase();
}
const LOCALE_LOWERCASE_PROBE = "IİÌÍĨ";
const LOCALE_LOWERCASE_PROBE_DEFAULT = LOCALE_LOWERCASE_PROBE.toLowerCase();
const localeLowerCaseTailoringCache = /* @__PURE__ */ new Map();
function localeAffectsLowerCase(locale) {
  const cached = localeLowerCaseTailoringCache.get(locale);
  if (cached !== void 0) {
    return cached;
  }
  let affects;
  try {
    affects = LOCALE_LOWERCASE_PROBE.toLocaleLowerCase(locale) !== LOCALE_LOWERCASE_PROBE_DEFAULT;
  } catch {
    affects = false;
  }
  localeLowerCaseTailoringCache.set(locale, affects);
  return affects;
}
function localeLowerCase(value, locale) {
  return localeAffectsLowerCase(locale) ? value.toLocaleLowerCase(locale) : value.toLowerCase();
}
function log(...args) {
  if (isDefined(console)) {
    console.log(...args);
  }
}
function warn$1(...args) {
  if (isDefined(console)) {
    console.warn(...args);
  }
}
const warnedScopes = /* @__PURE__ */ new WeakMap();
function warnOnce(scope, key, ...args) {
  let warnedKeys = warnedScopes.get(scope);
  if (warnedKeys === void 0) {
    warnedKeys = /* @__PURE__ */ new Set();
    warnedScopes.set(scope, warnedKeys);
  }
  if (warnedKeys.has(key)) {
    return;
  }
  warnedKeys.add(key);
  warn$1(...args);
}
function deprecatedWarn(message) {
  if (isDefined(console)) {
    console.warn(`Deprecated: ${message}`);
  }
}
function error(...args) {
  if (isDefined(console)) {
    console.error(...args);
  }
}
function logAggregatedItems({ logFunction = log, message = "", items = [], maxSample = 5, itemFormatter = (item) => `${item}` } = {}) {
  if (!Array.isArray(items) || items.length === 0) {
    return;
  }
  const count = items.length;
  const formattedItems = items.slice(0, maxSample).map((item) => `  - ${itemFormatter(item)}`);
  const more = count > maxSample ? `  - ...and ${count - maxSample} more` : "";
  const affectedLines = [
    "Affected cells:",
    ...formattedItems,
    ...more ? [
      more
    ] : []
  ].join("\n");
  logFunction(substitute(message, {
    itemsCount: `${count} cell${count > 1 ? "s" : ""}`,
    affectedCells: affectedLines
  }));
}
function getParent(element, level = 0) {
  let iteration = -1;
  let parent = null;
  let elementToCheck = element;
  while (elementToCheck !== null) {
    if (iteration === level) {
      parent = isHTMLElement(elementToCheck) ? elementToCheck : null;
      break;
    }
    if (isShadowRoot(elementToCheck)) {
      elementToCheck = elementToCheck.host;
    } else {
      iteration += 1;
      elementToCheck = elementToCheck.parentNode;
    }
  }
  return parent;
}
function isInternalElement(element, thisHotContainer) {
  const closestHandsontableContainer = element.closest(".handsontable");
  return !!closestHandsontableContainer && (closestHandsontableContainer.parentNode === thisHotContainer || closestHandsontableContainer === thisHotContainer);
}
function eventTargetEl(event) {
  return event.target;
}
function getFrameElement(frame) {
  const { frameElement } = frame;
  return frame.parent && Object.getPrototypeOf(frame.parent) && frameElement instanceof HTMLIFrameElement ? frameElement : null;
}
function getParentWindow(frame) {
  return getFrameElement(frame) ? frame.parent : null;
}
function closest(element, nodes = [], until) {
  const { ELEMENT_NODE } = Node;
  let elementToCheck = element;
  while (elementToCheck !== null && elementToCheck !== void 0 && elementToCheck !== until) {
    const { nodeType, nodeName } = elementToCheck;
    if (nodeType === ELEMENT_NODE && isHTMLElement(elementToCheck) && (nodes.includes(nodeName) || nodes.includes(elementToCheck))) {
      return elementToCheck;
    }
    if (isShadowRoot(elementToCheck)) {
      elementToCheck = elementToCheck.host;
    } else {
      elementToCheck = elementToCheck.parentNode;
    }
  }
  return null;
}
function closestDown(element, nodes, until) {
  const matched = [];
  let elementToCheck = isHTMLElement(element) ? element : null;
  while (elementToCheck) {
    elementToCheck = closest(elementToCheck, nodes, until);
    if (!elementToCheck || until && !until.contains(elementToCheck)) {
      break;
    }
    matched.push(elementToCheck);
    if (isShadowRoot(elementToCheck)) {
      const { host } = elementToCheck;
      elementToCheck = isHTMLElement(host) ? host : null;
    } else {
      elementToCheck = elementToCheck.parentElement;
    }
  }
  const length = matched.length;
  return length ? matched[length - 1] : null;
}
function findFirstParentWithClass(element, className) {
  const matched = {
    element: void 0,
    classNames: []
  };
  let elementToCheck = element;
  while (elementToCheck !== null && elementToCheck !== element.ownerDocument.documentElement && !matched.element) {
    if (typeof className === "string" && elementToCheck.classList.contains(className)) {
      matched.element = elementToCheck;
      matched.classNames.push(className);
    } else if (className instanceof RegExp) {
      const matchingClasses = Array.from(elementToCheck.classList).filter((cls) => className.test(cls));
      if (matchingClasses.length) {
        matched.element = elementToCheck;
        matched.classNames.push(...matchingClasses);
      }
    }
    elementToCheck = elementToCheck.parentElement;
  }
  return matched;
}
function isChildOf(child, parent) {
  let node = child.parentNode;
  let queriedParents = [];
  if (typeof parent === "string") {
    if (child instanceof Document) {
      queriedParents = Array.from(child.querySelectorAll(parent));
    } else {
      queriedParents = Array.from(child.ownerDocument.querySelectorAll(parent));
    }
  } else {
    queriedParents.push(parent);
  }
  while (node !== null) {
    if (queriedParents.indexOf(node) > -1) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
function index(element) {
  let i = 0;
  let elementToCheck = element;
  if (elementToCheck.previousSibling) {
    while (elementToCheck = elementToCheck.previousSibling) {
      i += 1;
    }
  }
  return i;
}
function overlayContainsElement(overlayType, element, root) {
  const overlayElement = root.parentElement?.querySelector(`.ht_clone_${overlayType}`);
  return overlayElement ? overlayElement.contains(element) : false;
}
function isBottomMostColumnHeader(TH) {
  if (!TH || !TH.classList || !TH.parentNode || !TH.parentNode.parentNode) {
    return false;
  }
  if (TH.classList.contains("hiddenHeader") || TH.style.display === "none") {
    return false;
  }
  const headerRow = TH.parentNode;
  const headerRows = Array.from(headerRow?.parentNode?.childNodes ?? []);
  const headerLevel = headerRow ? headerRows.indexOf(headerRow) : -1;
  const rowspan = Number.parseInt(TH.getAttribute("rowspan") ?? "", 10) || 1;
  return headerLevel + rowspan >= headerRows.length;
}
function filterEmptyClassNames(classNames) {
  if (!classNames || !classNames.length) {
    return [];
  }
  return classNames.filter((x) => !!x);
}
function filterRegexes(list, returnBoth) {
  if (!list || !list.length) {
    return {
      regexFree: [],
      regexes: []
    };
  }
  const regexes = [];
  const regexFree = [];
  regexFree.push(...list.filter((entry) => {
    const isRegex = entry instanceof RegExp;
    if (isRegex && returnBoth) {
      regexes.push(entry);
    }
    return !isRegex;
  }));
  return {
    regexFree,
    regexes
  };
}
function hasClass(element, className) {
  if (element.classList === void 0 || typeof className !== "string" || className === "") {
    return false;
  }
  return element.classList.contains(className);
}
function addClass(element, className) {
  if (typeof className === "string") {
    className = className.split(" ");
  }
  className = filterEmptyClassNames(className);
  if (className.length > 0) {
    element.classList.add(...className);
  }
}
function removeClass(element, className) {
  if (typeof className === "string") {
    className = className.split(" ");
  } else if (className instanceof RegExp) {
    className = [
      className
    ];
  }
  let {
    regexFree: stringClasses,
    // eslint-disable-next-line prefer-const
    regexes: regexClasses
  } = filterRegexes(className, true);
  stringClasses = filterEmptyClassNames(stringClasses);
  if (stringClasses.length > 0) {
    element.classList.remove(...stringClasses);
  }
  regexClasses.forEach((regexClassName) => {
    element.classList.forEach((currentClassName) => {
      if (regexClassName.test(currentClassName)) {
        element.classList.remove(currentClassName);
      }
    });
  });
}
function setAttribute(domElement, attributes = [], attributeValue) {
  if (!Array.isArray(attributes)) {
    attributes = [
      [
        attributes,
        attributeValue ?? ""
      ]
    ];
  }
  attributes.forEach((attributeInfo) => {
    if (Array.isArray(attributeInfo) && attributeInfo[0] !== "") {
      domElement.setAttribute(attributeInfo[0], String(attributeInfo[1]));
    }
  });
}
function removeAttribute(domElement, attributesToRemove = []) {
  if (typeof attributesToRemove === "string") {
    attributesToRemove = attributesToRemove.split(" ");
  } else if (attributesToRemove instanceof RegExp) {
    attributesToRemove = [
      attributesToRemove
    ];
  }
  const { regexFree: stringAttributes, regexes: regexAttributes } = filterRegexes(attributesToRemove, true);
  stringAttributes.forEach((attributeNameToRemove) => {
    if (attributeNameToRemove !== "") {
      domElement.removeAttribute(attributeNameToRemove);
    }
  });
  if (regexAttributes.length > 0) {
    const attributeNames = domElement.getAttributeNames();
    for (let i = 0; i < attributeNames.length; i++) {
      const attributeName = attributeNames[i];
      for (let r = 0; r < regexAttributes.length; r++) {
        if (regexAttributes[r].test(attributeName)) {
          domElement.removeAttribute(attributeName);
          break;
        }
      }
    }
  }
}
function removeTextNodes(element) {
  if (element.nodeType === 3) {
    element.parentNode?.removeChild(element);
  } else if ([
    "TABLE",
    "THEAD",
    "TBODY",
    "TFOOT",
    "TR"
  ].indexOf(element.nodeName) > -1) {
    const childs = element.childNodes;
    for (let i = childs.length - 1; i >= 0; i--) {
      removeTextNodes(childs[i]);
    }
  }
}
function empty$1(element) {
  let child;
  while (child = element.lastChild) {
    element.removeChild(child);
  }
}
const HTML_CHARACTERS = /(<([^>]*)>|&([^;]*);)/;
const SANITIZER_WARN_KEY = "sanitizer";
const defaultSanitizerWarnScope = {};
function fastInnerHTML(element, content, sanitizer = true, context = "innerHTML", scope = defaultSanitizerWarnScope) {
  if (HTML_CHARACTERS.test(content)) {
    let sanitized;
    if (typeof sanitizer === "function") {
      sanitized = sanitizer(content, context);
    } else {
      if (sanitizer !== false) {
        warnOnce(scope, SANITIZER_WARN_KEY, `HTML content is being written to the DOM ("${context}") without a sanitizer. Configure the "sanitizer" option to prevent XSS vulnerabilities.`);
      }
      sanitized = content;
    }
    element.innerHTML = sanitized;
  } else {
    fastInnerText(element, content);
  }
}
function fastInnerText(element, content) {
  const child = element.firstChild;
  if (child && child.nodeType === 3 && child.nextSibling === null) {
    child.textContent = content;
  } else {
    empty$1(element);
    element.appendChild(element.ownerDocument.createTextNode(content));
  }
}
function isVisible(element) {
  if (typeof element.checkVisibility === "function") {
    return element.checkVisibility();
  }
  const documentElement = element.ownerDocument.documentElement;
  const windowElement = element.ownerDocument.defaultView;
  let next = element;
  while (next !== documentElement) {
    if (next === null) {
      return false;
    } else if (isShadowRoot(next)) {
      const host = next.host;
      if (host.impl) {
        return isVisible(host.impl);
      } else {
        return isVisible(host);
      }
    } else if (next.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      return false;
    } else if (next.nodeType === Node.ELEMENT_NODE && isHTMLElement(next) && windowElement?.getComputedStyle(next).display === "none") {
      return false;
    }
    next = next.parentNode;
  }
  return true;
}
function hasZeroHeight(element) {
  const rootDocument = element.ownerDocument;
  const rootWindow = rootDocument.defaultView;
  let currentElement = element;
  while (currentElement.parentElement) {
    if (currentElement.style.height === "0px" || currentElement.style.height === "0") {
      const computedOverflow = rootWindow?.getComputedStyle(currentElement).getPropertyValue("overflow");
      return computedOverflow === "hidden" || computedOverflow === "clip";
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function offset(element) {
  const rootDocument = element.ownerDocument;
  const rootWindow = rootDocument.defaultView;
  const documentElement = rootDocument.documentElement;
  let elementToCheck = element;
  let offsetLeft;
  let offsetTop;
  let lastElem;
  offsetLeft = elementToCheck.offsetLeft;
  offsetTop = elementToCheck.offsetTop;
  lastElem = elementToCheck;
  while (elementToCheck = isHTMLElement(elementToCheck.offsetParent) ? elementToCheck.offsetParent : null) {
    if (elementToCheck === rootDocument.body) {
      break;
    }
    if (!("offsetLeft" in elementToCheck)) {
      break;
    }
    offsetLeft += elementToCheck.offsetLeft;
    offsetTop += elementToCheck.offsetTop;
    lastElem = elementToCheck;
  }
  if (lastElem && lastElem.style.position === "fixed") {
    offsetLeft += (rootWindow?.pageXOffset ?? 0) || documentElement.scrollLeft;
    offsetTop += (rootWindow?.pageYOffset ?? 0) || documentElement.scrollTop;
  }
  return {
    left: offsetLeft,
    top: offsetTop
  };
}
function getWindowScrollTop(rootWindow = window) {
  return rootWindow.scrollY;
}
function getWindowScrollLeft(rootWindow = window) {
  return rootWindow.scrollX;
}
function getScrollTop$1(element, rootWindow = window) {
  if (element instanceof Window) {
    return getWindowScrollTop(rootWindow);
  }
  return element.scrollTop;
}
function getScrollLeft$1(element, rootWindow = window) {
  if (element instanceof Window) {
    return getWindowScrollLeft(rootWindow);
  }
  return element.scrollLeft;
}
function getScrollableElement(element) {
  const rootDocument = element.ownerDocument;
  const rootWindow = rootDocument.defaultView;
  const props = [
    "auto",
    "scroll"
  ];
  let el = element.parentElement;
  while (el && el.style && rootDocument.body !== el) {
    let { overflow, overflowX, overflowY } = el.style;
    if ([
      overflow,
      overflowX,
      overflowY
    ].includes("scroll")) {
      return el;
    } else {
      if (rootWindow) {
        ({ overflow, overflowX, overflowY } = rootWindow.getComputedStyle(el));
      }
      if (props.includes(overflow) || props.includes(overflowX) || props.includes(overflowY)) {
        return el;
      }
    }
    if (el.clientHeight <= el.scrollHeight + 1 && (props.includes(overflowY) || props.includes(overflow))) {
      return el;
    }
    if (el.clientWidth <= el.scrollWidth + 1 && (props.includes(overflowX) || props.includes(overflow))) {
      return el;
    }
    el = el.parentElement;
  }
  return rootWindow ?? rootDocument.documentElement;
}
function getMaximumScrollTop(element) {
  return element.scrollHeight - element.clientHeight;
}
function getMaximumScrollLeft(element) {
  return element.scrollWidth - element.clientWidth;
}
function getTrimmingContainer(base) {
  const rootDocument = base.ownerDocument;
  const rootWindow = rootDocument.defaultView;
  let el = base.parentElement;
  while (el && el.style && rootDocument.body !== el) {
    if (el.style.overflow !== "visible" && el.style.overflow !== "") {
      return el;
    }
    if (rootWindow) {
      const computedStyle = rootWindow.getComputedStyle(el);
      const allowedProperties = [
        "scroll",
        "hidden",
        "auto",
        "clip"
      ];
      const property = computedStyle.getPropertyValue("overflow");
      const propertyY = computedStyle.getPropertyValue("overflow-y");
      const propertyX = computedStyle.getPropertyValue("overflow-x");
      if (allowedProperties.includes(property) || allowedProperties.includes(propertyY) || allowedProperties.includes(propertyX)) {
        return el;
      }
    }
    el = el.parentElement;
  }
  return rootWindow ?? rootDocument.documentElement;
}
function getStyle(element, prop, rootWindow = window) {
  if (!element) {
    return;
  } else if (element instanceof Window) {
    if (prop === "width") {
      return `${element.innerWidth}px`;
    } else if (prop === "height") {
      return `${element.innerHeight}px`;
    }
    return;
  }
  const styleProp = element.style.getPropertyValue(prop) || element.style[prop];
  if (styleProp !== "" && styleProp !== void 0) {
    return styleProp;
  }
  const computedStyle = rootWindow.getComputedStyle(element);
  const computedProp = computedStyle.getPropertyValue(prop) || computedStyle[prop];
  if (computedProp !== "" && computedProp !== void 0) {
    return computedProp;
  }
}
function outerWidth(element) {
  return element.offsetWidth;
}
function outerHeight(element) {
  return element.offsetHeight;
}
function innerHeight(element) {
  return element instanceof Window ? element.innerHeight : element.clientHeight;
}
function innerWidth(element) {
  return element instanceof Window ? element.innerWidth : element.clientWidth;
}
function getCaretPosition(el) {
  if (el.selectionStart) {
    return el.selectionStart;
  }
  return 0;
}
function getSelectionEndPosition(el) {
  if (el.selectionEnd) {
    return el.selectionEnd;
  }
  return 0;
}
function clearTextSelection(rootWindow = window) {
  if (rootWindow.getSelection) {
    const sel = rootWindow.getSelection();
    if (sel?.empty) {
      sel.empty();
    } else if (sel?.removeAllRanges) {
      sel.removeAllRanges();
    }
  }
}
function setCaretPosition(element, pos, endPos) {
  if (endPos === void 0) {
    endPos = pos;
  }
  if (element.setSelectionRange) {
    element.focus();
    try {
      element.setSelectionRange(pos, endPos);
    } catch (err) {
      const elementParent = element.parentElement;
      if (elementParent) {
        const parentDisplayValue = elementParent.style.display;
        elementParent.style.display = "block";
        element.setSelectionRange(pos, endPos);
        elementParent.style.display = parentDisplayValue;
      }
    }
  }
}
let cachedScrollbarWidth;
function getFractionalScalingCompensation(rootDocument = document) {
  if (!isWindowsOS()) {
    return 0;
  }
  return Number.isInteger(rootDocument.defaultView?.devicePixelRatio || 1) ? 0 : 2;
}
function walkontableCalculateScrollbarWidth(rootDocument = document) {
  const calculateScrollbarWidth = (shouldForceWebkitScrollbarStyles = false) => {
    const inner = rootDocument.createElement("div");
    inner.style.height = "200px";
    inner.style.width = "100%";
    const outer = rootDocument.createElement("div");
    outer.classList.add("htScrollbarTest");
    if (shouldForceWebkitScrollbarStyles) {
      outer.classList.add("htScrollbarSafariTest");
    }
    outer.style.boxSizing = "content-box";
    outer.style.height = "150px";
    outer.style.left = "0px";
    outer.style.overflow = "hidden";
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.width = "200px";
    outer.style.visibility = "hidden";
    outer.appendChild(inner);
    rootDocument.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = "scroll";
    let w2 = inner.offsetWidth;
    if (w1 === w2) {
      w2 = outer.clientWidth;
    }
    rootDocument.body.removeChild(outer);
    return w1 - w2;
  };
  const defaultScrollbarWidth = calculateScrollbarWidth();
  if (defaultScrollbarWidth === 0 && isSafariBefore261() && !isMobileBrowser() && !isIpadOS()) {
    return calculateScrollbarWidth(true);
  }
  return defaultScrollbarWidth;
}
function getScrollbarWidth(rootDocument = document) {
  if (cachedScrollbarWidth === void 0) {
    cachedScrollbarWidth = walkontableCalculateScrollbarWidth(rootDocument);
  }
  return cachedScrollbarWidth;
}
function hasVerticalScrollbar(element) {
  if (element instanceof Window) {
    return element.document.body.scrollHeight > element.innerHeight;
  }
  return element.offsetWidth !== element.clientWidth;
}
function hasHorizontalScrollbar(element) {
  if (element instanceof Window) {
    return element.document.body.scrollWidth > element.innerWidth;
  }
  return element.offsetHeight !== element.clientHeight;
}
function setOverlayPosition(overlayElem, left2, top2) {
  overlayElem.style.transform = `translate3d(${left2},${top2},0)`;
}
function resetCssTransform(element) {
  if (element.style.transform && element.style.transform !== "") {
    element.style.transform = "";
  }
}
function isInput(element) {
  const inputs = [
    "INPUT",
    "SELECT",
    "TEXTAREA"
  ];
  return element && (inputs.indexOf(element.nodeName) > -1 || element.contentEditable === "true");
}
function isOutsideInput(element) {
  return isInput(element) && "hotInput" in element.dataset === false;
}
function isDetached(element) {
  return !element.parentNode;
}
function observeVisibilityChangeOnce(elementToBeObserved, callback) {
  const visibilityObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback();
        observer.disconnect();
      }
    });
  });
  visibilityObserver.observe(elementToBeObserved);
}
function makeElementContentEditableAndSelectItsContent(element, invisibleSelection = true, ariaHidden = true) {
  const ownerDocument = element.ownerDocument;
  const range = ownerDocument.createRange();
  const sel = ownerDocument.defaultView?.getSelection();
  setAttribute(element, "contenteditable", true);
  if (ariaHidden) {
    const hiddenAttr = A11Y_HIDDEN();
    setAttribute(element, hiddenAttr[0], hiddenAttr[1]);
  }
  if (invisibleSelection) {
    addClass(element, "invisibleSelection");
  }
  range.selectNodeContents(element);
  sel?.removeAllRanges();
  sel?.addRange(range);
}
function removeContentEditableFromElementAndDeselect(selectedElement, removeInvisibleSelectionClass = true) {
  const sel = selectedElement.ownerDocument.defaultView?.getSelection();
  if (selectedElement.hasAttribute("aria-hidden")) {
    selectedElement.removeAttribute("aria-hidden");
  }
  sel?.removeAllRanges();
  if (removeInvisibleSelectionClass) {
    removeClass(selectedElement, "invisibleSelection");
  }
  selectedElement.removeAttribute("contenteditable");
}
function runWithSelectedContendEditableElement(element, callback, invisibleSelection = true) {
  makeElementContentEditableAndSelectItsContent(element, invisibleSelection);
  callback();
  removeContentEditableFromElementAndDeselect(element, invisibleSelection);
}
function isHTMLElement(element) {
  if (typeof element !== "object" || element === null) {
    return false;
  }
  const OwnElement = element.ownerDocument?.defaultView?.Element;
  return !!(OwnElement && element instanceof OwnElement);
}
function isHTMLTableCellElement(element) {
  return isHTMLElement(element) && (element.tagName === "TD" || element.tagName === "TH");
}
function isShadowRoot(node) {
  return node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in node;
}
function isFunction$1(func) {
  return typeof func === "function";
}
function debounce(func, wait = 200) {
  let lastTimer = null;
  let result;
  function _debounce(...args) {
    if (lastTimer) {
      clearTimeout(lastTimer);
    }
    lastTimer = setTimeout(() => {
      lastTimer = null;
      result = func.apply(this, args);
    }, wait);
    return result;
  }
  function cancel() {
    if (lastTimer !== null) {
      clearTimeout(lastTimer);
      lastTimer = null;
    }
  }
  _debounce.cancel = cancel;
  return _debounce;
}
function curry(func) {
  const argsLength = func.length;
  function given(argsSoFar) {
    return function _curry(...params) {
      const passedArgsSoFar = argsSoFar.concat(params);
      let result;
      if (passedArgsSoFar.length >= argsLength) {
        result = func.apply(this, passedArgsSoFar);
      } else {
        result = given(passedArgsSoFar);
      }
      return result;
    };
  }
  return given([]);
}
function fastCall(func, context, arg1, arg2, arg3, arg4, arg5, arg6) {
  if (isDefined(arg6)) {
    return func.call(context, arg1, arg2, arg3, arg4, arg5, arg6);
  } else if (isDefined(arg5)) {
    return func.call(context, arg1, arg2, arg3, arg4, arg5);
  } else if (isDefined(arg4)) {
    return func.call(context, arg1, arg2, arg3, arg4);
  } else if (isDefined(arg3)) {
    return func.call(context, arg1, arg2, arg3);
  } else if (isDefined(arg2)) {
    return func.call(context, arg1, arg2);
  } else if (isDefined(arg1)) {
    return func.call(context, arg1);
  }
  return func.call(context);
}
const KEY_CODES = {
  ALT: 18,
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  AUDIO_DOWN: isFirefox() ? 182 : 174,
  AUDIO_MUTE: isFirefox() ? 181 : 173,
  AUDIO_UP: isFirefox() ? 183 : 175,
  BACKSPACE: 8,
  CAPS_LOCK: 20,
  COMMA: 188,
  COMMAND_LEFT: 91,
  COMMAND_RIGHT: 93,
  COMMAND_FIREFOX: 224,
  CONTROL: 17,
  DELETE: 46,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  HOME: 36,
  INSERT: 45,
  MEDIA_NEXT: 176,
  MEDIA_PLAY_PAUSE: 179,
  MEDIA_PREV: 177,
  MEDIA_STOP: 178,
  NULL: 0,
  NUM_LOCK: 144,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PAUSE: 19,
  PERIOD: 190,
  SCROLL_LOCK: 145,
  SHIFT: 16,
  SPACE: 32,
  TAB: 9,
  A: 65,
  C: 67,
  D: 68,
  F: 70,
  L: 76,
  O: 79,
  P: 80,
  S: 83,
  V: 86,
  X: 88,
  Y: 89,
  Z: 90
};
const FUNCTION_KEYS = [
  KEY_CODES.ALT,
  KEY_CODES.ARROW_DOWN,
  KEY_CODES.ARROW_LEFT,
  KEY_CODES.ARROW_RIGHT,
  KEY_CODES.ARROW_UP,
  KEY_CODES.AUDIO_DOWN,
  KEY_CODES.AUDIO_MUTE,
  KEY_CODES.AUDIO_UP,
  KEY_CODES.BACKSPACE,
  KEY_CODES.CAPS_LOCK,
  KEY_CODES.DELETE,
  KEY_CODES.END,
  KEY_CODES.ENTER,
  KEY_CODES.ESCAPE,
  KEY_CODES.F1,
  KEY_CODES.F2,
  KEY_CODES.F3,
  KEY_CODES.F4,
  KEY_CODES.F5,
  KEY_CODES.F6,
  KEY_CODES.F7,
  KEY_CODES.F8,
  KEY_CODES.F9,
  KEY_CODES.F10,
  KEY_CODES.F11,
  KEY_CODES.F12,
  KEY_CODES.F13,
  KEY_CODES.F14,
  KEY_CODES.F15,
  KEY_CODES.F16,
  KEY_CODES.F17,
  KEY_CODES.F18,
  KEY_CODES.F19,
  KEY_CODES.HOME,
  KEY_CODES.INSERT,
  KEY_CODES.MEDIA_NEXT,
  KEY_CODES.MEDIA_PLAY_PAUSE,
  KEY_CODES.MEDIA_PREV,
  KEY_CODES.MEDIA_STOP,
  KEY_CODES.NULL,
  KEY_CODES.NUM_LOCK,
  KEY_CODES.PAGE_DOWN,
  KEY_CODES.PAGE_UP,
  KEY_CODES.PAUSE,
  KEY_CODES.SCROLL_LOCK,
  KEY_CODES.SHIFT,
  KEY_CODES.TAB
];
function isPrintableChar(keyCode) {
  return keyCode === 32 || // space
  keyCode >= 48 && keyCode <= 57 || // 0-9
  keyCode >= 96 && keyCode <= 111 || // numpad
  keyCode >= 186 && keyCode <= 192 || // ;=,-./`
  keyCode >= 219 && keyCode <= 222 || // []{}\|"'
  keyCode >= 226 || // special chars (229 for Asian chars)
  keyCode >= 65 && keyCode <= 90;
}
function isFunctionKey(keyCode) {
  return FUNCTION_KEYS.includes(keyCode);
}
function isCtrlMetaKey(keyCode) {
  return [
    KEY_CODES.CONTROL,
    KEY_CODES.COMMAND_LEFT,
    KEY_CODES.COMMAND_RIGHT,
    KEY_CODES.COMMAND_FIREFOX
  ].includes(keyCode);
}
function isKey(keyCode, baseCode) {
  const keys2 = baseCode.split("|");
  let result = false;
  arrayEach(keys2, (key) => {
    if (keyCode === KEY_CODES[key]) {
      result = true;
      return false;
    }
  });
  return result;
}
function stopImmediatePropagation(event) {
  event.isImmediatePropagationEnabled = false;
  event.cancelBubble = true;
}
function isImmediatePropagationStopped(event) {
  return event.isImmediatePropagationEnabled === false;
}
function isRightClick(event) {
  return event.button === 2;
}
function isLeftClick(event) {
  return event.button === 0;
}
function isMiddleClick(event) {
  return event.button === 1;
}
function isTouchEvent(event) {
  return typeof TouchEvent !== "undefined" && event instanceof TouchEvent;
}
function offsetRelativeTo(event, untilElement) {
  const offset2 = {
    x: event.offsetX,
    y: event.offsetY
  };
  let element = eventTargetEl(event);
  if (!isHTMLElement(untilElement) || element !== untilElement && element.contains(untilElement)) {
    return offset2;
  }
  while (element !== untilElement) {
    offset2.x += element.offsetLeft;
    offset2.y += element.offsetTop;
    element = element.offsetParent;
  }
  return offset2;
}
const REGISTERED_HOOKS = [
  /**
  * Fired after resetting a cell's meta. This happens when the {@link Core#updateSettings} method is called.
  *
  * @event Hooks#afterCellMetaReset
  */
  "afterCellMetaReset",
  /**
  * Fired after one or more cells has been changed. The changes are triggered in any situation when the
  * value is entered using an editor or changed using API (e.q [`setDataAtCell`](@/api/core.md#setdataatcell) method).
  *
  * __Note:__ For performance reasons, the `changes` array is null for `"loadData"` source.
  *
  * @event Hooks#afterChange
  * @param {Array[]} changes 2D array containing information about each of the edited cells `[[row, prop, oldVal, newVal], ...]`. `row` is a visual row index.
  * @param {string} [source] String that identifies source of hook call ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @example
  * ::: only-for javascript
  * ```js
  * new Handsontable(element, {
  *   afterChange: (changes) => {
  *     changes?.forEach(([row, prop, oldValue, newValue]) => {
  *       // Some logic...
  *     });
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   afterChange={(changes, source) => {
  *     changes?.forEach(([row, prop, oldValue, newValue]) => {
  *       // Some logic...
  *     });
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   afterChange: (changes, source) => {
  *     changes?.forEach(([row, prop, oldValue, newValue]) => {
  *       // Some logic...
  *     });
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "afterChange",
  /**
  * Fired each time user opens {@link ContextMenu} and after setting up the context menu's default options. These options are a collection
  * which user can select by setting an array of keys or an array of objects in {@link Options#contextMenu} option.
  *
  * @event Hooks#afterContextMenuDefaultOptions
  * @param {Array} predefinedItems An array of objects containing information about the pre-defined context menu items.
  */
  "afterContextMenuDefaultOptions",
  /**
  * Fired each time user opens {@link ContextMenu} plugin before setting up the context menu's items but after filtering these options by
  * user ([`contextMenu`](@/api/options.md#contextmenu) option). This hook can by helpful to determine if user use specified menu item or to set up
  * one of the menu item to by always visible.
  *
  * @event Hooks#beforeContextMenuSetItems
  * @param {object[]} menuItems An array of objects containing information about to generated context menu items.
  */
  "beforeContextMenuSetItems",
  /**
  * Fired by {@link DropdownMenu} plugin after setting up the dropdown menu's default options. These options are a
  * collection which user can select by setting an array of keys or an array of objects in {@link Options#dropdownMenu}
  * option.
  *
  * @event Hooks#afterDropdownMenuDefaultOptions
  * @param {object[]} predefinedItems An array of objects containing information about the pre-defined dropdown menu items.
  */
  "afterDropdownMenuDefaultOptions",
  /**
  * Fired by {@link DropdownMenu} plugin before setting up the dropdown menu's items but after filtering these options
  * by user ([`dropdownMenu`](@/api/options.md#dropdownmenu) option). This hook can by helpful to determine if user use specified menu item or to set
  * up one of the menu item to by always visible.
  *
  * @event Hooks#beforeDropdownMenuSetItems
  * @param {object[]} menuItems An array of objects containing information about to generated dropdown menu items.
  */
  "beforeDropdownMenuSetItems",
  /**
  * Fired by {@link ContextMenu} plugin after hiding the context menu. This hook is fired when {@link Options#contextMenu}
  * option is enabled.
  *
  * @event Hooks#afterContextMenuHide
  * @param {object} context The {@link ContextMenu} plugin instance.
  */
  "afterContextMenuHide",
  /**
  * Fired by {@link ContextMenu} plugin before opening the context menu. This hook is fired when {@link Options#contextMenu}
  * option is enabled.
  *
  * @event Hooks#beforeContextMenuShow
  * @param {object} context The {@link ContextMenu} instance.
  */
  "beforeContextMenuShow",
  /**
  * Fired by {@link ContextMenu} plugin after opening the context menu. This hook is fired when {@link Options#contextMenu}
  * option is enabled.
  *
  * @event Hooks#afterContextMenuShow
  * @param {object} context The {@link ContextMenu} plugin instance.
  */
  "afterContextMenuShow",
  /**
  * Fired by {@link CopyPaste} plugin after reaching the copy limit while copying data. This hook is fired when
  * {@link Options#copyPaste} option is enabled.
  *
  * @event Hooks#afterCopyLimit
  * @param {number} selectedRows Count of selected copyable rows.
  * @param {number} selectedColumns Count of selected copyable columns.
  * @param {number} copyRowsLimit Current copy rows limit.
  * @param {number} copyColumnsLimit Current copy columns limit.
  */
  "afterCopyLimit",
  /**
  * Fired before created a new column.
  *
  * @event Hooks#beforeCreateCol
  * @param {number} index Represents the visual index of first newly created column in the data source array.
  * @param {number} amount Number of newly created columns in the data source array.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {*} If `false` then creating columns is cancelled.
  * @example
  * ::: only-for javascript
  * ```js
  * // Return `false` to cancel column inserting.
  * new Handsontable(element, {
  *   beforeCreateCol: function(data, coords) {
  *     return false;
  *   }
  * });
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * // Return `false` to cancel column inserting.
  * <HotTable
  *   beforeCreateCol={(data, coords) => {
  *     return false;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   beforeCreateCol: (data, coords) => {
  *     // Return `false` to cancel column inserting.
  *     return false;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "beforeCreateCol",
  /**
  * Fired after the cache of the column sequence has been updated.
  *
  * @since 16.2.0
  * @event Hooks#afterColumnSequenceCacheUpdate
  * @param {object} indexesChangesState Object containing information about the changes to the column sequence.
  * @param {boolean} indexesChangesState.indexesSequenceChanged Indicates if the sequence of indexes has changed.
  * @param {boolean} indexesChangesState.trimmedIndexesChanged Indicates if the trimmed indexes have changed.
  * @param {boolean} indexesChangesState.hiddenIndexesChanged Indicates if the hidden indexes have changed.
  */
  "afterColumnSequenceCacheUpdate",
  /**
  * Fired after the order of columns has changed.
  * This hook is fired by changing column indexes of any type supported by the {@link IndexMapper}.
  *
  * @event Hooks#afterColumnSequenceChange
  * @param {'init'|'remove'|'insert'|'move'|'update'} [source] A string that indicates what caused the change to the order of columns.
  */
  "afterColumnSequenceChange",
  /**
  * Fired after created a new column.
  *
  * @event Hooks#afterCreateCol
  * @param {number} index Represents the visual index of first newly created column in the data source.
  * @param {number} amount Number of newly created columns in the data source.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "afterCreateCol",
  /**
  * Fired before created a new row.
  *
  * @event Hooks#beforeCreateRow
  * @param {number} index Represents the visual index of first newly created row in the data source array.
  * @param {number} amount Number of newly created rows in the data source array.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeCreateRow",
  /**
  * Fired after created a new row.
  *
  * @event Hooks#afterCreateRow
  * @param {number} index Represents the visual index of first newly created row in the data source array.
  * @param {number} amount Number of newly created rows in the data source array.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "afterCreateRow",
  /**
  * Fired before an alter action is applied (e.g. `insert_row_above`, `insert_row_below`, `remove_row`).
  * Return `false` to cancel the default alter behavior (e.g. so a plugin can handle it via server-side CRUD).
  *
  * @event Hooks#beforeAlter
  * @since 17.1.0
  * @param {string} action The alter action: `'insert_row_above'`, `'insert_row_below'`, `'remove_row'`,
  *                        `'insert_col_start'`, `'insert_col_end'`, `'remove_col'`.
  * @param {number|Array} index Visual row/column index, or for remove actions an array of `[[index, amount], ...]`.
  * @param {number} amount Number of rows/columns to insert or remove (default 1).
  * @param {string} [source] Source of the alter call (e.g. `'ContextMenu.rowAbove'`).
  * @param {boolean} [keepEmptyRows] Whether to keep empty rows (remove_row only).
  * @returns {*|boolean} Return `false` to cancel the alter; the table will not be modified locally.
  */
  "beforeAlter",
  /**
  * Fired after all selected cells are deselected.
  *
  * @event Hooks#afterDeselect
  */
  "afterDeselect",
  /**
  * Fired after destroying the Handsontable instance.
  *
  * @event Hooks#afterDestroy
  */
  "afterDestroy",
  /**
  * Hook fired after `keydown` event is handled.
  *
  * @event Hooks#afterDocumentKeyDown
  * @param {Event} event A native `keydown` event object.
  */
  "afterDocumentKeyDown",
  /**
  * Fired inside the Walkontable's selection `draw` method. Can be used to add additional class names to cells, depending on the current selection.
  *
  * @event Hooks#afterDrawSelection
  * @param {number} currentRow Row index of the currently processed cell.
  * @param {number} currentColumn Column index of the currently cell.
  * @param {number[]} cornersOfSelection Array of the current selection in a form of `[startRow, startColumn, endRow, endColumn]`.
  * @param {number|undefined} layerLevel Number indicating which layer of selection is currently processed.
  * @since 0.38.1
  * @returns {string|undefined} Can return a `String`, which will act as an additional `className` to be added to the currently processed cell.
  */
  "afterDrawSelection",
  /**
  * Fired inside the Walkontable's `refreshSelections` method. Can be used to remove additional class names from all cells in the table.
  *
  * @event Hooks#beforeRemoveCellClassNames
  * @since 0.38.1
  * @returns {string[]|undefined} Can return an `Array` of `String`s. Each of these strings will act like class names to be removed from all the cells in the table.
  */
  "beforeRemoveCellClassNames",
  /**
  * Hook fired after `compositionstart` event is handled.
  *
  * @event Hooks#beforeCompositionStart
  * @since 15.3.0
  * @param {Event} event A native `composition` event object.
  */
  "beforeCompositionStart",
  /**
  * Fired after getting the cell settings.
  *
  * @event Hooks#afterGetCellMeta
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {object} cellProperties Object containing the cell properties.
  */
  "afterGetCellMeta",
  /**
  * Fired after retrieving information about a column header and appending it to the table header.
  *
  * @event Hooks#afterGetColHeader
  * @param {number} column Visual column index.
  * @param {HTMLTableCellElement} TH Header's TH element.
  * @param {number} [headerLevel=0] (Since 12.2.0) Header level index. Accepts positive (0 to n)
  *                                 and negative (-1 to -n) values. For positive values, 0 points to the
  *                                 topmost header. For negative values, -1 points to the bottom-most
  *                                 header (the header closest to the cells).
  */
  "afterGetColHeader",
  /**
  * Fired after retrieving information about a row header and appending it to the table header.
  *
  * @event Hooks#afterGetRowHeader
  * @param {number} row Visual row index.
  * @param {HTMLTableCellElement} TH Header's TH element.
  */
  "afterGetRowHeader",
  /**
  * Fired after the Handsontable instance is initiated.
  *
  * @event Hooks#afterInit
  */
  "afterInit",
  /**
  * Fired after Handsontable's [`data`](@/api/options.md#data)
  * gets modified by the [`loadData()`](@/api/core.md#loaddata) method
  * or the [`updateSettings()`](@/api/core.md#updatesettings) method.
  *
  * Read more:
  * - [Binding to data](@/guides/getting-started/binding-to-data/binding-to-data.md)
  * - [Saving data](@/guides/getting-started/saving-data/saving-data.md)
  *
  * @event Hooks#afterLoadData
  * @param {Array} sourceData An [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays), or an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects), that contains Handsontable's data
  * @param {boolean} initialLoad A flag that indicates whether the data was loaded at Handsontable's initialization (`true`) or later (`false`)
  * @param {string} source The source of the call
  */
  "afterLoadData",
  /**
  * Fired after the [`updateData()`](@/api/core.md#updatedata) method
  * modifies Handsontable's [`data`](@/api/options.md#data).
  *
  * Read more:
  * - [Binding to data](@/guides/getting-started/binding-to-data/binding-to-data.md)
  * - [Saving data](@/guides/getting-started/saving-data/saving-data.md)
  *
  * @event Hooks#afterUpdateData
  * @since 11.1.0
  * @param {Array} sourceData An [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays), or an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects), that contains Handsontable's data
  * @param {boolean} initialLoad A flag that indicates whether the data was loaded at Handsontable's initialization (`true`) or later (`false`)
  * @param {string} source The source of the call
  */
  "afterUpdateData",
  /**
  * Fired after the dataProvider has fetched and loaded data.
  *
  * @event Hooks#afterDataProviderFetch
  * @since 17.1.0
  * @param {object} result Result object: `{ rows, totalRows, queryParameters, columnSortConfig, filtersConditionsStack }`.
  */
  "afterDataProviderFetch",
  /**
  * Fired when the dataProvider fetch throws an error (e.g. network error).
  *
  * @event Hooks#afterDataProviderFetchError
  * @since 17.1.0
  * @param {Error} error The thrown error.
  * @param {object} queryParameters The query parameters that were used for the request.
  */
  "afterDataProviderFetchError",
  /**
  * Fired after a dataProvider `fetchRows` request ends without loading data because it was aborted
  * (superseded by a newer fetch, `AbortSignal`, or plugin disable/destroy).
  *
  * @event Hooks#afterDataProviderFetchAbort
  * @since 17.1.0
  * @param {object} queryParameters The query parameters that were used for the aborted request.
  * @param {Error|undefined} reason Abort reason when available (e.g. `AbortError`).
  */
  "afterDataProviderFetchAbort",
  /**
  * Queried to determine if the instance uses an external data source (complete [[Options#dataProvider]] configuration).
  * When the DataProvider plugin is enabled, it adds an instance handler in `enablePlugin()`. Callbacks may return
  * `true`, `false`, or `undefined`; the value propagates through the hook chain like other [[Hooks#run]] hooks.
  *
  * @event Hooks#hasExternalDataSource
  * @since 17.1.0
  * @returns {boolean|void}
  */
  "hasExternalDataSource",
  /**
  * Fired before rows mutation (create, update, remove) is sent to the server. Return `false` to cancel.
  *
  * @event Hooks#beforeRowsMutation
  * @since 17.1.0
  * @param {string} operation One of `'create'`, `'update'`, `'remove'`.
  * @param {object} payload Operation-specific payload (`{ rowsCreate }`, `{ rows: [...] }`, or `{ rowsRemove: [...] }`).
  */
  "beforeRowsMutation",
  /**
  * Fired after rows mutation (create, update, remove) succeeds on the server.
  *
  * @event Hooks#afterRowsMutation
  * @since 17.1.0
  * @param {string} operation One of `'create'`, `'update'`, `'remove'`.
  * @param {object} payload Operation-specific payload.
  */
  "afterRowsMutation",
  /**
  * Fired when rows mutation (create, update, remove) fails on the server.
  *
  * @event Hooks#afterRowsMutationError
  * @since 17.1.0
  * @param {string} operation One of `'create'`, `'update'`, `'remove'`.
  * @param {Error} error The thrown error.
  * @param {object} payload Operation-specific payload.
  */
  "afterRowsMutationError",
  /**
  * Fired after a scroll event, which is identified as a momentum scroll (e.g. on an iPad).
  *
  * @event Hooks#afterMomentumScroll
  */
  "afterMomentumScroll",
  /**
  * Fired after a `mousedown` event is triggered on the cell corner (the drag handle).
  *
  * @event Hooks#afterOnCellCornerMouseDown
  * @param {Event} event `mousedown` event object.
  */
  "afterOnCellCornerMouseDown",
  /**
  * Fired after a `dblclick` event is triggered on the cell corner (the drag handle).
  *
  * @event Hooks#afterOnCellCornerDblClick
  * @param {Event} event `dblclick` event object.
  */
  "afterOnCellCornerDblClick",
  /**
  * Fired after clicking on a cell or row/column header. In case the row/column header was clicked, the coordinate
  * indexes are negative.
  *
  * For example clicking on the row header of cell (0, 0) results with `afterOnCellMouseDown` called
  * with coordinates `{row: 0, col: -1}`.
  *
  * @event Hooks#afterOnCellMouseDown
  * @param {Event} event `mousedown` event object.
  * @param {CellCoords} coords Coordinates object containing the visual row and visual column indexes of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "afterOnCellMouseDown",
  /**
  * Fired after clicking on a cell or row/column header. In case the row/column header was clicked, the coordinate
  * indexes are negative.
  *
  * For example clicking on the row header of cell (0, 0) results with `afterOnCellMouseUp` called
  * with coordinates `{row: 0, col: -1}`.
  *
  * @event Hooks#afterOnCellMouseUp
  * @param {Event} event `mouseup` event object.
  * @param {CellCoords} coords Coordinates object containing the visual row and visual column indexes of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "afterOnCellMouseUp",
  /**
  * Fired after clicking right mouse button on a cell or row/column header.
  *
  * For example clicking on the row header of cell (0, 0) results with `afterOnCellContextMenu` called
  * with coordinates `{row: 0, col: -1}`.
  *
  * @event Hooks#afterOnCellContextMenu
  * @since 4.1.0
  * @param {Event} event `contextmenu` event object.
  * @param {CellCoords} coords Coordinates object containing the visual row and visual column indexes of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "afterOnCellContextMenu",
  /**
  * Fired after hovering a cell or row/column header with the mouse cursor. In case the row/column header was
  * hovered, the index is negative.
  *
  * For example, hovering over the row header of cell (0, 0) results with `afterOnCellMouseOver` called
  * with coords `{row: 0, col: -1}`.
  *
  * @event Hooks#afterOnCellMouseOver
  * @param {Event} event `mouseover` event object.
  * @param {CellCoords} coords Hovered cell's visual coordinate object.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "afterOnCellMouseOver",
  /**
  * Fired after leaving a cell or row/column header with the mouse cursor.
  *
  * @event Hooks#afterOnCellMouseOut
  * @param {Event} event `mouseout` event object.
  * @param {CellCoords} coords Leaved cell's visual coordinate object.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "afterOnCellMouseOut",
  /**
  * Fired after the mouse cursor moves outside the visible viewport while a mouse button is held down
  * (e.g. during a drag-to-scroll operation). The event fires once per mousemove tick for as long as
  * the cursor remains outside the viewport.
  *
  * @event Hooks#afterOnCellMouseOverOutside
  * @since 17.2.0
  * @param {Event} event `mousemove` event object.
  * @param {CellCoords} coords Visual coordinates of the nearest viewport-edge cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "afterOnCellMouseOverOutside",
  /**
  * Fired after one or more columns are removed.
  *
  * When consecutive columns are removed, this hook is fired once with the `amount` reflecting
  * the total number of removed columns. When non-consecutive columns are removed (for example,
  * by selecting columns with Ctrl/Cmd held), this hook is fired separately for each removed
  * column, with `amount` equal to `1` each time. This is by design.
  *
  * @event Hooks#afterRemoveCol
  * @param {number} index Visual index of starter column.
  * @param {number} amount An amount of removed columns.
  * @param {number[]} physicalColumns An array of physical columns removed from the data source.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "afterRemoveCol",
  /**
  * Fired after one or more rows are removed.
  *
  * When consecutive rows are removed, this hook is fired once with the `amount` reflecting
  * the total number of removed rows. When non-consecutive rows are removed (for example,
  * by selecting rows with Ctrl/Cmd held), this hook is fired separately for each removed
  * row, with `amount` equal to `1` each time. This is by design.
  *
  * @event Hooks#afterRemoveRow
  * @param {number} index Visual index of starter row.
  * @param {number} amount An amount of removed rows.
  * @param {number[]} physicalRows An array of physical rows removed from the data source.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "afterRemoveRow",
  /**
  * Fired before starting rendering the cell.
  *
  * @event Hooks#beforeRenderer
  * @param {HTMLTableCellElement} TD Currently rendered cell's TD element.
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string|number} prop Column property name or a column index, if datasource is an array of arrays.
  * @param {*} value Value of the rendered cell.
  * @param {object} cellProperties Object containing the cell's properties.
  */
  "beforeRenderer",
  /**
  * Fired after finishing rendering the cell (after the renderer finishes).
  *
  * @event Hooks#afterRenderer
  * @param {HTMLTableCellElement} TD Currently rendered cell's TD element.
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string|number} prop Column property name or a column index, if datasource is an array of arrays.
  * @param {*} value Value of the rendered cell.
  * @param {object} cellProperties Object containing the cell's properties.
  */
  "afterRenderer",
  /**
  * Fired after the cache of the row sequence has been updated.
  *
  * @since 16.2.0
  * @event Hooks#afterRowSequenceCacheUpdate
  * @param {object} indexesChangesState Object containing information about the changes to the row sequence.
  * @param {boolean} indexesChangesState.indexesSequenceChanged Indicates if the sequence of indexes has changed.
  * @param {boolean} indexesChangesState.trimmedIndexesChanged Indicates if the trimmed indexes have changed.
  * @param {boolean} indexesChangesState.hiddenIndexesChanged Indicates if the hidden indexes have changed.
  */
  "afterRowSequenceCacheUpdate",
  /**
  * Fired after the order of rows has changed.
  * This hook is fired by changing row indexes of any type supported by the {@link IndexMapper}.
  *
  * @event Hooks#afterRowSequenceChange
  * @param {'init'|'remove'|'insert'|'move'|'update'} [source] A string that indicates what caused the change to the order of rows.
  */
  "afterRowSequenceChange",
  /**
  * Fired before the vertical viewport scroll. Triggered by the [`scrollViewportTo()`](@/api/core.md#scrollviewportto)
  * method or table internals.
  *
  * @since 14.0.0
  * @event Hooks#beforeViewportScrollVertically
  * @param {number} visualRow Visual row index.
  * @param {'auto' | 'top' | 'bottom'} [snapping='auto'] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on
  * the bottom of the table. When `'auto'`, the viewport is scrolled only when the row is outside of
  * the viewport.
  * @returns {number | boolean} Returns modified row index (or the same as passed in the method argument) to which
  * the viewport will be scrolled. If the returned value is `false`, the scrolling will be canceled.
  */
  "beforeViewportScrollVertically",
  /**
  * Fired before the horizontal viewport scroll. Triggered by the [`scrollViewportTo()`](@/api/core.md#scrollviewportto)
  * method or table internals.
  *
  * @since 14.0.0
  * @event Hooks#beforeViewportScrollHorizontally
  * @param {number} visualColumn Visual column index.
  * @param {'auto' | 'start' | 'end'} [snapping='auto'] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @returns {number | boolean} Returns modified column index (or the same as passed in the method argument) to which
  * the viewport will be scrolled. If the returned value is `false`, the scrolling will be canceled.
  */
  "beforeViewportScrollHorizontally",
  /**
  * Fired before the vertical or horizontal viewport scroll. Triggered by the [`scrollViewportTo()`](@/api/core.md#scrollviewportto)
  * method or table internals.
  *
  * @since 14.0.0
  * @event Hooks#beforeViewportScroll
  */
  "beforeViewportScroll",
  /**
  * Fired after the horizontal scroll event.
  *
  * @event Hooks#afterScrollHorizontally
  */
  "afterScrollHorizontally",
  /**
  * Fired after the vertical scroll event.
  *
  * @event Hooks#afterScrollVertically
  */
  "afterScrollVertically",
  /**
  * Fired after the vertical or horizontal scroll event.
  *
  * @since 14.0.0
  * @event Hooks#afterScroll
  */
  "afterScroll",
  /**
  * Fired after one or more cells are selected (e.g. during mouse move).
  *
  * @event Hooks#afterSelection
  * @param {number} row Selection start visual row index.
  * @param {number} column Selection start visual column index.
  * @param {number} row2 Selection end visual row index.
  * @param {number} column2 Selection end visual column index.
  * @param {object} preventScrolling A reference to the observable object with the `value` property.
  *                                  Property `preventScrolling.value` expects a boolean value that
  *                                  Handsontable uses to control scroll behavior after selection.
  * @param {number} selectionLayerLevel The number which indicates what selection layer is currently modified.
  * @example
  * ::: only-for javascript
  * ```js
  * new Handsontable(element, {
  *   afterSelection: (row, column, row2, column2, preventScrolling, selectionLayerLevel) => {
  *     // If set to `false` (default): when cell selection is outside the viewport,
  *     // Handsontable scrolls the viewport to cell selection's end corner.
  *     // If set to `true`: when cell selection is outside the viewport,
  *     // Handsontable doesn't scroll to cell selection's end corner.
  *     preventScrolling.value = true;
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   afterSelection={(row, column, row2, column2, preventScrolling, selectionLayerLevel) => {
  *     // If set to `false` (default): when cell selection is outside the viewport,
  *     // Handsontable scrolls the viewport to cell selection's end corner.
  *     // If set to `true`: when cell selection is outside the viewport,
  *     // Handsontable doesn't scroll to cell selection's end corner.
  *     preventScrolling.value = true;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   afterSelection: (
  *     row,
  *     column,
  *     row2,
  *     column2,
  *     preventScrolling,
  *     selectionLayerLevel
  *   ) => {
  *     // If set to `false` (default): when cell selection is outside the viewport,
  *     // Handsontable scrolls the viewport to cell selection's end corner.
  *     // If set to `true`: when cell selection is outside the viewport,
  *     // Handsontable doesn't scroll to cell selection's end corner.
  *     preventScrolling.value = true;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "afterSelection",
  /**
  * Fired after one or more cells are selected.
  *
  * The `prop` and `prop2` arguments represent the source object property name instead of the column number.
  *
  * @event Hooks#afterSelectionByProp
  * @param {number} row Selection start visual row index.
  * @param {string} prop Selection start data source object property name.
  * @param {number} row2 Selection end visual row index.
  * @param {string} prop2 Selection end data source object property name.
  * @param {object} preventScrolling A reference to the observable object with the `value` property.
  *                                  Property `preventScrolling.value` expects a boolean value that
  *                                  Handsontable uses to control scroll behavior after selection.
  * @param {number} selectionLayerLevel The number which indicates what selection layer is currently modified.
  * @example
  * ```js
  * ::: only-for javascript
  * new Handsontable(element, {
  *   afterSelectionByProp: (row, column, row2, column2, preventScrolling, selectionLayerLevel) => {
  *     // setting if prevent scrolling after selection
  *     preventScrolling.value = true;
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   afterSelectionByProp={(row, column, row2, column2, preventScrolling, selectionLayerLevel) => {
  *     // setting if prevent scrolling after selection
  *     preventScrolling.value = true;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   afterSelectionByProp: (
  *     row,
  *     column,
  *     row2,
  *     column2,
  *     preventScrolling,
  *     selectionLayerLevel
  *   ) => {
  *     // Setting if prevent scrolling after selection
  *     preventScrolling.value = true;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "afterSelectionByProp",
  /**
  * Fired after one or more cells are selected (e.g. on mouse up).
  *
  * @event Hooks#afterSelectionEnd
  * @param {number} row Selection start visual row index.
  * @param {number} column Selection start visual column index.
  * @param {number} row2 Selection end visual row index.
  * @param {number} column2 Selection end visual column index.
  * @param {number} selectionLayerLevel The number which indicates what selection layer is currently modified.
  */
  "afterSelectionEnd",
  /**
  * Fired after one or more cells are selected (e.g. on mouse up).
  *
  * The `prop` and `prop2` arguments represent the source object property name instead of the column number.
  *
  * @event Hooks#afterSelectionEndByProp
  * @param {number} row Selection start visual row index.
  * @param {string} prop Selection start data source object property index.
  * @param {number} row2 Selection end visual row index.
  * @param {string} prop2 Selection end data source object property index.
  * @param {number} selectionLayerLevel The number which indicates what selection layer is currently modified.
  */
  "afterSelectionEndByProp",
  /**
  * Fired after the focus position within a selected range is changed.
  *
  * @since 14.3.0
  * @event Hooks#afterSelectionFocusSet
  * @param {number} row The focus visual row index position.
  * @param {number} column The focus visual column index position.
  * @param {object} preventScrolling A reference to the observable object with the `value` property.
  *                                  Property `preventScrolling.value` expects a boolean value that
  *                                  Handsontable uses to control scroll behavior after selection.
  * @example
  * ```js
  * ::: only-for javascript
  * new Handsontable(element, {
  *   afterSelectionFocusSet: (row, column, preventScrolling) => {
  *     // If set to `false` (default): when focused cell selection is outside the viewport,
  *     // Handsontable scrolls the viewport to that cell.
  *     // If set to `true`: when focused cell selection is outside the viewport,
  *     // Handsontable doesn't scroll the viewport.
  *     preventScrolling.value = true;
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   afterSelectionFocusSet={(row, column, preventScrolling) => {
  *     // If set to `false` (default): when focused cell selection is outside the viewport,
  *     // Handsontable scrolls the viewport to that cell.
  *     // If set to `true`: when focused cell selection is outside the viewport,
  *     // Handsontable doesn't scroll the viewport.
  *     preventScrolling.value = true;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   afterSelectionFocusSet: (row, column, preventScrolling) => {
  *     // If set to `false` (default): when focused cell selection is outside the viewport,
  *     // Handsontable scrolls the viewport to that cell.
  *     // If set to `true`: when focused cell selection is outside the viewport,
  *     // Handsontable doesn't scroll the viewport.
  *     preventScrolling.value = true;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "afterSelectionFocusSet",
  /**
  * Fired before one or more columns are selected (e.g. during mouse header click or {@link Core#selectColumns} API call).
  *
  * @since 14.0.0
  * @event Hooks#beforeSelectColumns
  * @param {CellCoords} from Selection start coords object.
  * @param {CellCoords} to Selection end coords object.
  * @param {CellCoords} highlight Selection cell focus coords object.
  * @example
  * ::: only-for javascript
  * ```js
  * new Handsontable(element, {
  *   beforeSelectColumns: (from, to, highlight) => {
  *     // Extend the column selection by one column left and one column right.
  *     from.col = Math.max(from.col - 1, 0);
  *     to.col = Math.min(to.col + 1, this.countCols() - 1);
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   beforeSelectColumns={(from, to, highlight) => {
  *     // Extend the column selection by one column left and one column right.
  *     from.col = Math.max(from.col - 1, 0);
  *     to.col = Math.min(to.col + 1, this.countCols() - 1);
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   beforeSelectColumns: (from, to, highlight) => {
  *     // Extend the column selection by one column left and one column right.
  *     from.col = Math.max(from.col - 1, 0);
  *     to.col = Math.min(to.col + 1, this.countCols() - 1);
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "beforeSelectColumns",
  /**
  * Fired after one or more columns are selected (e.g. during mouse header click or {@link Core#selectColumns} API call).
  *
  * @since 14.0.0
  * @event Hooks#afterSelectColumns
  * @param {CellCoords} from Selection start coords object.
  * @param {CellCoords} to Selection end coords object.
  * @param {CellCoords} highlight Selection cell focus coords object.
  */
  "afterSelectColumns",
  /**
  * Fired before one or more rows are selected (e.g. during mouse header click or {@link Core#selectRows} API call).
  *
  * @since 14.0.0
  * @event Hooks#beforeSelectRows
  * @param {CellCoords} from Selection start coords object.
  * @param {CellCoords} to Selection end coords object.
  * @param {CellCoords} highlight Selection cell focus coords object.
  * @example
  * ::: only-for javascript
  * ```js
  * new Handsontable(element, {
  *   beforeSelectRows: (from, to, highlight) => {
  *     // Extend the row selection by one row up and one row bottom more.
  *     from.row = Math.max(from.row - 1, 0);
  *     to.row = Math.min(to.row + 1, this.countRows() - 1);
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   beforeSelectRows={(from, to, highlight) => {
  *     // Extend the row selection by one row up and one row bottom more.
  *     from.row = Math.max(from.row - 1, 0);
  *     to.row = Math.min(to.row + 1, this.countRows() - 1);
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * settings = {
  *   beforeSelectRows: (from, to, highlight) => {
  *     // Extend the row selection by one row up and one row down.
  *     from.row = Math.max(from.row - 1, 0);
  *     to.row = Math.min(to.row + 1, this.countRows() - 1);
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings"></hot-table>
  * ```
  * :::
  */
  "beforeSelectRows",
  /**
  * Fired after one or more rows are selected (e.g. during mouse header click or {@link Core#selectRows} API call).
  *
  * @since 14.0.0
  * @event Hooks#afterSelectRows
  * @param {CellCoords} from Selection start coords object.
  * @param {CellCoords} to Selection end coords object.
  * @param {CellCoords} highlight Selection cell focus coords object.
  */
  "afterSelectRows",
  /**
  * Fired before all cells are selected (e.g. during mouse corner click or {@link Core#selectAll} API call).
  *
  * @since 16.1.0
  * @event Hooks#beforeSelectAll
  * @param {CellCoords} from Selection start coords object.
  * @param {CellCoords} to Selection end coords object.
  * @param {CellCoords} [highlight] Selection cell focus coords object.
  * @example
  * ::: only-for javascript
  * ```js
  * new Handsontable(element, {
  *   beforeSelectAll: (from, to, highlight) => {
  *     // moves the focus to a new position
  *     if (highlight) {
  *       highlight.row = 3;
  *       highlight.col = 3;
  *     }
  *   }
  * })
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * <HotTable
  *   beforeSelectAll={(from, to, highlight) => {
  *     // moves the focus to a new position
  *     if (highlight) {
  *       highlight.row = 3;
  *       highlight.col = 3;
  *     }
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  *```ts
  * settings = {
  *   beforeSelectAll: (from, to, highlight) => {
  *     // moves the focus to a new position
  *     if (highlight) {
  *       highlight.row = 3;
  *       highlight.col = 3;
  *     }
  *   },
  * };
  * ```
  * :::
  */
  "beforeSelectAll",
  /**
  * Fired after all cells are selected (e.g. during mouse corner click or {@link Core#selectAll} API call).
  *
  * @since 16.1.0
  * @event Hooks#afterSelectAll
  * @param {CellCoords} from Selection start coords object.
  * @param {CellCoords} to Selection end coords object.
  * @param {CellCoords} [highlight] Selection cell focus coords object.
  */
  "afterSelectAll",
  /**
  * Fired after cell meta is changed.
  *
  * @event Hooks#afterSetCellMeta
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string} key The updated meta key.
  * @param {*} value The updated meta value.
  */
  "afterSetCellMeta",
  /**
  * Fired after cell meta is removed.
  *
  * @event Hooks#afterRemoveCellMeta
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string} key The removed meta key.
  * @param {*} value Value which was under removed key of cell meta.
  */
  "afterRemoveCellMeta",
  /**
  * Fired after [`setDataAtCell`](@/api/core.md#setdataatcell) is called and changes are processed,
  * before they are validated and applied to the data source.
  * Use [`afterChange`](@/api/hooks.md#afterchange) if you need to react after the data has been written.
  *
  * @event Hooks#afterSetDataAtCell
  * @param {Array} changes An array of changes in format `[[row, column, oldValue, value], ...]`.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "afterSetDataAtCell",
  /**
  * Fired after [`setDataAtRowProp`](@/api/core.md#setdataatrowprop) is called and changes are processed,
  * before they are validated and applied to the data source.
  * Use [`afterChange`](@/api/hooks.md#afterchange) if you need to react after the data has been written.
  *
  * @event Hooks#afterSetDataAtRowProp
  * @param {Array} changes An array of changes in format `[[row, prop, oldValue, value], ...]`.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "afterSetDataAtRowProp",
  /**
  * Fired after cell source data was changed.
  *
  * @event Hooks#afterSetSourceDataAtCell
  * @since 8.0.0
  * @param {Array} changes An array of changes in format `[[row, column, oldValue, value], ...]`.
  * @param {string} [source] String that identifies source of hook call.
  */
  "afterSetSourceDataAtCell",
  /**
  * Fired after a theme is enabled, changed, or disabled.
  *
  * @since 15.0.0
  * @event Hooks#afterSetTheme
  * @param {string|boolean|undefined} themeName The theme name.
  * @param {boolean} firstRun `true` if it's the initial setting of the theme, `false` otherwise.
  */
  "afterSetTheme",
  /**
  * Fired after calling the [`updateSettings`](@/api/core.md#updatesettings) method.
  *
  * @event Hooks#afterUpdateSettings
  * @param {object} newSettings New settings object.
  */
  "afterUpdateSettings",
  /**
  * @description
  * A plugin hook executed after validator function, only if validator function is defined.
  * Validation result is the first parameter. This can be used to determinate if validation passed successfully or not.
  *
  * __Returning false from the callback will mark the cell as invalid__.
  *
  * @event Hooks#afterValidate
  * @param {boolean} isValid `true` if valid, `false` if not.
  * @param {*} value The value in question.
  * @param {number} row Visual row index.
  * @param {string|number} prop Property name / visual column index.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {undefined | boolean} If `false` the cell will be marked as invalid, `true` otherwise.
  */
  "afterValidate",
  /**
  * Fired before successful change of language (when proper language code was set).
  *
  * @event Hooks#beforeLanguageChange
  * @since 0.35.0
  * @param {string} languageCode New language code.
  */
  "beforeLanguageChange",
  /**
  * Fired after successful change of language (when proper language code was set).
  *
  * @event Hooks#afterLanguageChange
  * @since 0.35.0
  * @param {string} languageCode New language code.
  */
  "afterLanguageChange",
  /**
  * Fired by {@link Autofill} plugin before populating the data in the autofill feature. This hook is fired when
  * {@link Options#fillHandle} option is enabled.
  *
  * @event Hooks#beforeAutofill
  * @param {Array[]} selectionData Data the autofill operation will start from.
  * @param {CellRange} sourceRange The range values will be filled from.
  * @param {CellRange} targetRange The range new values will be filled into.
  * @param {string} direction Declares the direction of the autofill. Possible values: `up`, `down`, `left`, `right`.
  *
  * @returns {boolean|Array[]} If false, the operation is cancelled. If array of arrays, the returned data
  *                              will be passed into [`populateFromArray`](@/api/core.md#populatefromarray) instead of the default autofill
  *                              algorithm's result.
  */
  "beforeAutofill",
  /**
  * Fired by {@link Autofill} plugin after populating the data in the autofill feature. This hook is fired when
  * {@link Options#fillHandle} option is enabled.
  *
  * @event Hooks#afterAutofill
  * @since 8.0.0
  * @param {Array[]} fillData The data that was used to fill the `targetRange`. If `beforeAutofill` was used
  *                            and returned `[[]]`, this will be the same object that was returned from `beforeAutofill`.
  * @param {CellRange} sourceRange The range values will be filled from.
  * @param {CellRange} targetRange The range new values will be filled into.
  * @param {string} direction Declares the direction of the autofill. Possible values: `up`, `down`, `left`, `right`.
  */
  "afterAutofill",
  /**
  * Fired before aligning the cell contents.
  *
  * @event Hooks#beforeCellAlignment
  * @param {object} stateBefore An object with class names defining the cell alignment.
  * @param {CellRange[]} range An array of `CellRange` coordinates where the alignment will be applied.
  * @param {string} type Type of the alignment - either `horizontal` or `vertical`.
  * @param {string} alignmentClass String defining the alignment class added to the cell.
  * Possible values: `htLeft` , `htCenter`, `htRight`, `htJustify`, `htTop`, `htMiddle`, `htBottom`.
  */
  "beforeCellAlignment",
  /**
  * Fired before one or more cells are changed.
  *
  * Use this hook to silently alter the user's changes before Handsontable re-renders.
  *
  * To ignore the user's changes, use a nullified array or return `false`.
  *
  * @event Hooks#beforeChange
  * @param {Array[]} changes 2D array containing information about each of the edited cells `[[row, prop, oldVal, newVal], ...]`. `row` is a visual row index.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {undefined | boolean} If `false` all changes were cancelled, `true` otherwise.
  * @example
  * ::: only-for javascript
  * ```js
  * // to alter a single change, overwrite the value with `changes[i][3]`
  * new Handsontable(element, {
  *   beforeChange: (changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     changes[0][3] = 10;
  *   }
  * });
  *
  * // to ignore a single change, set `changes[i]` to `null`
  * // or remove `changes[i]` from the array, by using `changes.splice(i, 1)`
  * new Handsontable(element, {
  *   beforeChange: (changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     changes[0] = null;
  *   }
  * });
  *
  * // to ignore all changes, return `false`
  * // or set the array's length to 0, by using `changes.length = 0`
  * new Handsontable(element, {
  *   beforeChange: (changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     return false;
  *   }
  * });
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * // to alter a single change, overwrite the desired value with `changes[i][3]`
  * <HotTable
  *   beforeChange={(changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     changes[0][3] = 10;
  *   }}
  * />
  *
  * // to ignore a single change, set `changes[i]` to `null`
  * // or remove `changes[i]` from the array, by using changes.splice(i, 1).
  * <HotTable
  *   beforeChange={(changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     changes[0] = null;
  *   }}
  * />
  *
  * // to ignore all changes, return `false`
  * // or set the array's length to 0 (`changes.length = 0`)
  * <HotTable
  *   beforeChange={(changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     return false;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  *```ts
  * // To alter a single change, overwrite the desired value with `changes[i][3]`
  * settings1 = {
  *   beforeChange: (changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     changes[0][3] = 10;
  *   },
  * };
  *
  * // To ignore a single change, set `changes[i]` to `null`
  * // or remove `changes[i]` from the array, by using changes.splice(i, 1).
  * settings2 = {
  *   beforeChange: (changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     changes[0] = null;
  *   },
  * };
  *
  * // To ignore all changes, return `false`
  * // or set the array's length to 0 (`changes.length = 0`)
  * settings3 = {
  *   beforeChange: (changes, source) => {
  *     // [[row, prop, oldVal, newVal], ...]
  *     return false;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings1"></hot-table>
  * <hot-table [settings]="settings2"></hot-table>
  * <hot-table [settings]="settings3"></hot-table>
  * ```
  *
  * :::
  */
  "beforeChange",
  /**
  * Fired right before rendering the changes.
  *
  * @event Hooks#beforeChangeRender
  * @param {Array[]} changes Array in form of `[row, prop, oldValue, newValue]`.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "beforeChangeRender",
  /**
  * Fired before the height of the table is changed.
  *
  * @since 16.1.0
  * @event Hooks#beforeHeightChange
  * @param {number | string} height Table height.
  * @returns {number | string} Modified table height.
  */
  "beforeHeightChange",
  /**
  * Fired before the width of the table is changed.
  *
  * @since 16.1.0
  * @event Hooks#beforeWidthChange
  * @param {number | string} width Table width.
  * @returns {number | string} Modified table width.
  */
  "beforeWidthChange",
  /**
  * Fired before drawing the borders.
  *
  * @event Hooks#beforeDrawBorders
  * @param {Array} corners Array specifying the current selection borders.
  * @param {string} borderClassName Specifies the border class name.
  */
  "beforeDrawBorders",
  /**
  * Fired before getting cell settings.
  *
  * @event Hooks#beforeGetCellMeta
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {object} cellProperties Object containing the cell's properties.
  */
  "beforeGetCellMeta",
  /**
  * Fired before cell meta is removed.
  *
  * @event Hooks#beforeRemoveCellMeta
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string} key The removed meta key.
  * @param {*} value Value which is under removed key of cell meta.
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeRemoveCellMeta",
  /**
  * Fired before the Handsontable instance is initiated.
  *
  * @event Hooks#beforeInit
  */
  "beforeInit",
  /**
  * Fired before the Walkontable instance is initiated.
  *
  * @event Hooks#beforeInitWalkontable
  * @param {object} walkontableConfig Walkontable configuration object.
  */
  "beforeInitWalkontable",
  /**
  * Fired before Handsontable's [`data`](@/api/options.md#data)
  * gets modified by the [`loadData()`](@/api/core.md#loaddata) method
  * or the [`updateSettings()`](@/api/core.md#updatesettings) method.
  *
  * Read more:
  * - [Binding to data](@/guides/getting-started/binding-to-data/binding-to-data.md)
  * - [Saving data](@/guides/getting-started/saving-data/saving-data.md)
  *
  * @event Hooks#beforeLoadData
  * @since 8.0.0
  * @param {Array} sourceData An [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays), or an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects), that contains Handsontable's data
  * @param {boolean} initialLoad A flag that indicates whether the data was loaded at Handsontable's initialization (`true`) or later (`false`)
  * @param {string} source The source of the call
  * @returns {Array} The returned array will be used as Handsontable's new dataset.
  */
  "beforeLoadData",
  /**
  * Fired before the [`updateData()`](@/api/core.md#updatedata) method
  * modifies Handsontable's [`data`](@/api/options.md#data).
  *
  * Read more:
  * - [Binding to data](@/guides/getting-started/binding-to-data/binding-to-data.md)
  * - [Saving data](@/guides/getting-started/saving-data/saving-data.md)
  *
  * @event Hooks#beforeUpdateData
  * @since 11.1.0
  * @param {Array} sourceData An [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays), or an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects), that contains Handsontable's data
  * @param {boolean} initialLoad A flag that indicates whether the data was loaded at Handsontable's initialization (`true`) or later (`false`)
  * @param {string} source The source of the call
  * @returns {Array} The returned array will be used as Handsontable's new dataset.
  */
  "beforeUpdateData",
  /**
  * Fired before the dataProvider fetches data. Return `false` to cancel the fetch.
  *
  * @event Hooks#beforeDataProviderFetch
  * @since 17.1.0
  * @param {object} queryParameters Current query parameters: `{ page, pageSize, sort, filters }`. May include
  * `skipLoading` when the fetch was triggered internally (for example after column sort or CRUD); not sent to `fetchRows`.
  * @returns {*|boolean} Return `false` to cancel the fetch; otherwise the fetch proceeds.
  */
  "beforeDataProviderFetch",
  /**
  * Hook fired before `keydown` event is handled. It can be used to stop default key bindings.
  *
  * __Note__: To prevent default behavior you need to call `false` in your `beforeKeyDown` handler.
  *
  * @event Hooks#beforeKeyDown
  * @param {Event} event Original DOM event.
  */
  "beforeKeyDown",
  /**
  * Fired after the user clicked a cell, but before all the calculations related with it.
  *
  * @event Hooks#beforeOnCellMouseDown
  * @param {Event} event The `mousedown` event object.
  * @param {CellCoords} coords Cell coords object containing the visual coordinates of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  * @param {object} controller An object with properties `row`, `column` and `cell`. Each property contains
  *                            a boolean value that allows or disallows changing the selection for that particular area.
  */
  "beforeOnCellMouseDown",
  /**
  * Fired after the user clicked a cell.
  *
  * @event Hooks#beforeOnCellMouseUp
  * @param {Event} event The `mouseup` event object.
  * @param {CellCoords} coords Cell coords object containing the visual coordinates of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "beforeOnCellMouseUp",
  /**
  * Fired after the user clicked a cell, but before all the calculations related with it.
  *
  * @event Hooks#beforeOnCellContextMenu
  * @since 4.1.0
  * @param {Event} event The `contextmenu` event object.
  * @param {CellCoords} coords Cell coords object containing the visual coordinates of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "beforeOnCellContextMenu",
  /**
  * Fired after the user moved cursor over a cell, but before all the calculations related with it.
  *
  * @event Hooks#beforeOnCellMouseOver
  * @param {Event} event The `mouseover` event object.
  * @param {CellCoords} coords CellCoords object containing the visual coordinates of the clicked cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  * @param {object} controller An object with properties `row`, `column` and `cell`. Each property contains
  *                            a boolean value that allows or disallows changing the selection for that particular area.
  */
  "beforeOnCellMouseOver",
  /**
  * Fired after the user moved cursor out from a cell, but before all the calculations related with it.
  *
  * @event Hooks#beforeOnCellMouseOut
  * @param {Event} event The `mouseout` event object.
  * @param {CellCoords} coords CellCoords object containing the visual coordinates of the leaved cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  */
  "beforeOnCellMouseOut",
  /**
  * Fired when the mouse cursor moves outside the visible viewport while a mouse button is held down
  * (e.g. during a drag-to-scroll operation), before selection changes are applied. Use the `controller`
  * object to suppress row, column, or cell selection changes for this tick.
  *
  * @event Hooks#beforeOnCellMouseOverOutside
  * @since 17.2.0
  * @param {Event} event `mousemove` event object.
  * @param {CellCoords} coords Visual coordinates of the nearest viewport-edge cell.
  * @param {HTMLTableCellElement} TD Cell's TD (or TH) element.
  * @param {object} controller An object with properties `row`, `column` and `cell`. Each property contains
  *                            a boolean value that allows or disallows changing the selection for that particular area.
  */
  "beforeOnCellMouseOverOutside",
  /**
  * Fired before one or more columns are about to be removed.
  *
  * @event Hooks#beforeRemoveCol
  * @param {number} index Visual index of starter column.
  * @param {number} amount Amount of columns to be removed.
  * @param {number[]} physicalColumns An array of physical columns removed from the data source.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeRemoveCol",
  /**
  * Fired when one or more rows are about to be removed.
  *
  * @event Hooks#beforeRemoveRow
  * @param {number} index Visual index of starter row.
  * @param {number} amount Amount of rows to be removed.
  * @param {number[]} physicalRows An array of physical rows removed from the data source.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeRemoveRow",
  /**
  * Fired before Handsontable's view-rendering engine is rendered.
  *
  * __Note:__ In Handsontable 9.x and earlier, the `beforeViewRender` hook was named `beforeRender`.
  *
  * @event Hooks#beforeViewRender
  * @since 10.0.0
  * @param {boolean} isForced If set to `true`, the rendering gets triggered by a change of settings, a change of
  *                           data, or a logic that needs a full Handsontable render cycle.
  *                           If set to `false`, the rendering gets triggered by scrolling or moving the selection.
  * @param {object} skipRender Object with `skipRender` property, if it is set to `true ` the next rendering cycle will be skipped.
  */
  "beforeViewRender",
  /**
  * Fired after Handsontable's view-rendering engine is rendered,
  * but before redrawing the selection borders and before scroll syncing.
  *
  * __Note:__ In Handsontable 9.x and earlier, the `afterViewRender` hook was named `afterRender`.
  *
  * @event Hooks#afterViewRender
  * @since 10.0.0
  * @param {boolean} isForced If set to `true`, the rendering gets triggered by a change of settings, a change of
  *                           data, or a logic that needs a full Handsontable render cycle.
  *                           If set to `false`, the rendering gets triggered by scrolling or moving the selection.
  */
  "afterViewRender",
  /**
  * Fired before Handsontable's view-rendering engine updates the view.
  *
  * The `beforeRender` event is fired right after the Handsontable
  * business logic is executed and right before the rendering engine starts calling
  * the Core logic, renderers, cell meta objects etc. to update the view.
  *
  * @event Hooks#beforeRender
  * @param {boolean} isForced If set to `true`, the rendering gets triggered by a change of settings, a change of
  *                           data, or a logic that needs a full Handsontable render cycle.
  *                           If set to `false`, the rendering gets triggered by scrolling or moving the selection.
  */
  "beforeRender",
  /**
  * Fired after Handsontable's view-rendering engine updates the view.
  *
  * @event Hooks#afterRender
  * @param {boolean} isForced If set to `true`, the rendering gets triggered by a change of settings, a change of
  *                           data, or a logic that needs a full Handsontable render cycle.
  *                           If set to `false`, the rendering gets triggered by scrolling or moving the selection.
  */
  "afterRender",
  /**
  * When the focus position is moved to the next or previous row caused by the {@link Options#autoWrapRow} option
  * the hook is triggered.
  *
  * @since 14.0.0
  * @event Hooks#beforeRowWrap
  * @param {boolean} isWrapEnabled Tells whether the row wrapping is going to happen.
  * There may be situations where the option does not work even though it is enabled.
  * This is due to the priority of other options that may block the feature.
  * For example, when the {@link Options#minSpareCols} is defined, the {@link Options#autoWrapRow} option is not checked.
  * Thus, row wrapping is off.
  * @param {CellCoords} newCoords The new focus position. It is an object with keys `row` and `col`, where a value of `-1` indicates a header.
  * @param {boolean} isFlipped `true` if the row index was flipped, `false` otherwise.
  * Flipped index means that the user reached the last row and the focus is moved to the first row or vice versa.
  */
  "beforeRowWrap",
  /**
  * When the focus position is moved to the next or previous column caused by the {@link Options#autoWrapCol} option
  * the hook is triggered.
  *
  * @since 14.0.0
  * @event Hooks#beforeColumnWrap
  * @param {boolean} isWrapEnabled Tells whether the column wrapping is going to happen.
  * There may be situations where the option does not work even though it is enabled.
  * This is due to the priority of other options that may block the feature.
  * For example, when the {@link Options#minSpareRows} is defined, the {@link Options#autoWrapCol} option is not checked.
  * Thus, column wrapping is off.
  * @param {CellCoords} newCoords The new focus position. It is an object with keys `row` and `col`, where a value of `-1` indicates a header.
  * @param {boolean} isFlipped `true` if the column index was flipped, `false` otherwise.
  * Flipped index means that the user reached the last column and the focus is moved to the first column or vice versa.
  */
  "beforeColumnWrap",
  /**
  * Fired before cell meta is changed.
  *
  * @event Hooks#beforeSetCellMeta
  * @since 8.0.0
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string} key The updated meta key.
  * @param {*} value The updated meta value.
  * @returns {boolean|undefined} If false is returned the action is canceled.
  */
  "beforeSetCellMeta",
  /**
  * Fired before setting focus selection.
  *
  * @since 14.3.0
  * @event Hooks#beforeSelectionFocusSet
  * @param {CellCoords} coords CellCoords instance.
  */
  "beforeSelectionFocusSet",
  /**
  * Fired before setting range is started but not finished yet.
  *
  * @event Hooks#beforeSetRangeStartOnly
  * @param {CellCoords} coords `CellCoords` instance.
  */
  "beforeSetRangeStartOnly",
  /**
  * Fired before setting range is started.
  *
  * @event Hooks#beforeSetRangeStart
  * @param {CellCoords} coords `CellCoords` instance.
  */
  "beforeSetRangeStart",
  /**
  * Fired before setting range is ended.
  *
  * @event Hooks#beforeSetRangeEnd
  * @param {CellCoords} coords `CellCoords` instance.
  */
  "beforeSetRangeEnd",
  /**
  * Fired before applying selection coordinates to the renderable coordinates for Walkontable (rendering engine).
  * It occurs even when cell coordinates remain unchanged and activates during cell selection and drag selection.
  * The behavior of <kbd>**Shift**</kbd>+<kbd>**Tab**</kbd> differs from <kbd>**←**</kbd> when there's no further movement possible.
  *
  * @since 14.0.0
  * @event Hooks#beforeSelectionHighlightSet
  */
  "beforeSelectionHighlightSet",
  /**
  * Fired before the logic of handling a touch scroll, when user started scrolling on a touch-enabled device.
  *
  * @event Hooks#beforeTouchScroll
  */
  "beforeTouchScroll",
  /**
  * Fired before cell validation, only if validator function is defined. This can be used to manipulate the value
  * of changed cell before it is applied to the validator function.
  *
  * __Note:__ this will not affect values of changes. This will change value *ONLY* for validation.
  *
  * @event Hooks#beforeValidate
  * @param {*} value Value of the cell.
  * @param {number} row Visual row index.
  * @param {string|number} prop Property name / column index.
  * @param {string} [source] String that identifies source of hook call
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  */
  "beforeValidate",
  /**
  * Fired before cell value is rendered into the DOM (through renderer function). This can be used to manipulate the
  * value which is passed to the renderer without modifying the renderer itself.
  *
  * @event Hooks#beforeValueRender
  * @param {*} value Cell value to render.
  * @param {object} cellProperties An object containing the cell properties.
  */
  "beforeValueRender",
  /**
  * Fired after Handsontable instance is constructed (using `new` operator).
  *
  * @event Hooks#construct
  */
  "construct",
  /**
  * Fired after Handsontable instance is initiated but before table is rendered.
  *
  * @event Hooks#init
  */
  "init",
  /**
  * Fired when a column header index is about to be modified by a callback function.
  *
  * @event Hooks#modifyColHeader
  * @param {number} column Visual column header index.
  */
  "modifyColHeader",
  /**
  * Fired when a column width is about to be modified by a callback function.
  *
  * @event Hooks#modifyColWidth
  * @param {number} width Current column width.
  * @param {number} column Visual column index.
  * @param {string} [source] String that identifies source of hook call.
  */
  "modifyColWidth",
  /**
  * Fired when rendering the list of values in the multiple-selection component of the Filters dropdown.
  * The hook allows modifying the displayed values in that component.
  *
  * @since 14.2.0
  * @event Hooks#modifyFiltersMultiSelectValue
  * @param {object} item The item in the list of values.
  * @param {object} meta The cell properties object.
  */
  "modifyFiltersMultiSelectValue",
  /**
  * Fired when focusing a cell or a header element. Allows replacing the element to be focused by returning a
  * different HTML element.
  *
  * @since 14.0.0
  * @event Hooks#modifyFocusedElement
  * @param {number} row Row index.
  * @param {number} column Column index.
  * @param {HTMLElement|undefined} focusedElement The element to be focused. `null` for focusedElement is intended when focused cell is hidden.
  */
  "modifyFocusedElement",
  /**
  * Fired when a row header index is about to be modified by a callback function.
  *
  * @event Hooks#modifyRowHeader
  * @param {number} row Visual row header index.
  */
  "modifyRowHeader",
  /**
  * Fired when a row height is about to be modified by a callback function.
  *
  * @event Hooks#modifyRowHeight
  * @param {number} height Row height.
  * @param {number} row Visual row index.
  * @param {string} [source] String that identifies source of hook call.
  */
  "modifyRowHeight",
  /**
  * Fired when a row height is about to be modified by a callback function. The hook allows to change the row height
  * for the specified overlay type.
  *
  * @since 14.5.0
  * @event Hooks#modifyRowHeightByOverlayName
  * @param {number} height Row height.
  * @param {number} row Visual row index.
  * @param {'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'|'master'} overlayName Overlay name.
  */
  "modifyRowHeightByOverlayName",
  /**
  * Fired when a data was retrieved or modified.
  *
  * @event Hooks#modifyData
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {object} valueHolder Object which contains original value which can be modified by overwriting `.value` property.
  * @param {string} ioMode String which indicates for what operation hook is fired (`get` or `set`).
  */
  "modifyData",
  /**
  * Fired when a data was retrieved or modified from the source data set.
  *
  * @event Hooks#modifySourceData
  * @since 8.0.0
  * @param {number} row Physical row index.
  * @param {number} column Physical column index or property name.
  * @param {object} valueHolder Object which contains original value which can be modified by overwriting `.value` property.
  * @param {string} ioMode String which indicates for what operation hook is fired (`get` or `set`).
  */
  "modifySourceData",
  /**
  * Fired when a data was retrieved or modified.
  *
  * @event Hooks#modifyRowData
  * @param {number} row Physical row index.
  */
  "modifyRowData",
  /**
  * Used to modify the cell coordinates when using the [`getCell`](@/api/core.md#getcell) method, opening editor, getting value from the editor
  * and saving values from the closed editor.
  *
  * @event Hooks#modifyGetCellCoords
  * @since 0.36.0
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {boolean} topmost If set to `true`, it returns the TD element from the topmost overlay. For example,
  *                          if the wanted cell is in the range of fixed rows, it will return a TD element
  *                          from the `top` overlay.
  * @param {string} source String that identifies how this coords change will be processed. Possible values:
  *                        `meta` the change will affect the cell meta and data; `render` the change will affect the
  *                        DOM element that will be returned by the `getCell` method.
  * @returns {undefined|number[]}
  */
  "modifyGetCellCoords",
  /**
  * Used to modify the returned cell coordinates of clicked cells (TD or TH elements).
  *
  * @event Hooks#modifyGetCoordsElement
  * @since 14.6.0
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @returns {undefined|number[]}
  */
  "modifyGetCoordsElement",
  /**
  * Used to modify the cell coordinates when the table is activated (going into the listen mode).
  *
  * @event Hooks#modifyFocusOnTabNavigation
  * @since 14.0.0
  * @param {'from_above' | 'from_below'} tabActivationDir The browsers Tab navigation direction. Depending on
  * whether the user activated the table from the element above or below, another cell can be selected.
  * @param {CellCoords} visualCoords The coords that will be used to select a cell.
  * @returns {undefined|boolean} If `false` is returned, the table will not be focused.
  */
  "modifyFocusOnTabNavigation",
  /**
  * Allows modify the visual row index that is used to retrieve the row header element (TH) before it's
  * highlighted (proper CSS class names are added). Modifying the visual row index allows building a custom
  * implementation of the nested headers feature or other features that require highlighting other DOM
  * elements than that the rendering engine, by default, would have highlighted.
  *
  * @event Hooks#beforeHighlightingRowHeader
  * @since 8.4.0
  * @param {number} row Visual row index.
  * @param {number} headerLevel Column header level (0 = most distant to the table).
  * @param {object} highlightMeta An object that contains additional information about processed selection.
  * @returns {number|undefined}
  */
  "beforeHighlightingRowHeader",
  /**
  * Allows modify the visual column index that is used to retrieve the column header element (TH) before it's
  * highlighted (proper CSS class names are added). Modifying the visual column index allows building a custom
  * implementation of the nested headers feature or other features that require highlighting other DOM
  * elements than that the rendering engine, by default, would have highlighted.
  *
  * @event Hooks#beforeHighlightingColumnHeader
  * @since 8.4.0
  * @param {number} column Visual column index.
  * @param {number} headerLevel Row header level (0 = most distant to the table).
  * @param {object} highlightMeta An object that contains additional information about processed selection.
  * @returns {number|undefined}
  */
  "beforeHighlightingColumnHeader",
  /**
  * Fired by {@link ColumnSorting} and {@link MultiColumnSorting} plugins before sorting the column. If you return `false` value inside callback for hook, then sorting
  * will be not applied by the Handsontable (useful for server-side sorting).
  *
  * This hook is fired when {@link Options#columnSorting} or {@link Options#multiColumnSorting} option is enabled.
  *
  * @event Hooks#beforeColumnSort
  * @param {Array} currentSortConfig Current sort configuration (for all sorted columns).
  * @param {Array} destinationSortConfigs Destination sort configuration (for all sorted columns).
  * @returns {boolean | undefined} If `false` the column will not be sorted, `true` otherwise.
  */
  "beforeColumnSort",
  /**
  * Fired by {@link ColumnSorting} and {@link MultiColumnSorting} plugins after sorting the column. This hook is fired when {@link Options#columnSorting}
  * or {@link Options#multiColumnSorting} option is enabled.
  *
  * @event Hooks#afterColumnSort
  * @param {Array} currentSortConfig Current sort configuration (for all sorted columns).
  * @param {Array} destinationSortConfigs Destination sort configuration (for all sorted columns).
  */
  "afterColumnSort",
  /**
  * Fired by {@link Autofill} plugin to allow modifying the autofill range. This hook is fired when {@link Options#fillHandle}
  * option is enabled.
  *
  * @event Hooks#modifyAutofillRange
  * @param {number[]} entireArea Visual coordinates of the entire area of the drag-down operation (`[startRow, startColumn, endRow, endColumn]`).
  * @param {number[]} startArea Visual coordinates of the starting point for the drag-down operation (`[startRow, startColumn, endRow, endColumn]`).
  * @returns {number[]} The modified autofill range (`[startRow, startColumn, endRow, endColumn]`).
  */
  "modifyAutofillRange",
  /**
  * Fired to allow modifying the copyable range with a callback function.
  *
  * @event Hooks#modifyCopyableRange
  * @param {Array[]} copyableRanges Array of objects defining copyable cells.
  */
  "modifyCopyableRange",
  /**
  * Fired by {@link CopyPaste} plugin before copying the values to the clipboard and before clearing values of
  * the selected cells. This hook is fired when {@link Options#copyPaste} option is enabled.
  *
  * @event Hooks#beforeCut
  * @param {Array[]} data An array of arrays which contains data to cut.
  * @param {object[]} coords An array of objects with ranges of the visual indexes (`startRow`, `startCol`, `endRow`, `endCol`)
  *                       which will be cut out.
  * @returns {*} If returns `false` then operation of the cutting out is canceled.
  * @example
  * ::: only-for javascript
  * ```js
  * // To disregard a single row, remove it from the array using data.splice(i, 1).
  * new Handsontable(element, {
  *   beforeCut: function(data, coords) {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   }
  * });
  * // To cancel a cutting action, just return `false`.
  * new Handsontable(element, {
  *   beforeCut: function(data, coords) {
  *     return false;
  *   }
  * });
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * // To disregard a single row, remove it from the array using data.splice(i, 1).
  * <HotTable
  *   beforeCut={(data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   }}
  * />
  * // To cancel a cutting action, just return `false`.
  * <HotTable
  *   beforeCut={(data, coords) => {
  *     return false;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  *```ts
  * // To disregard a single row, remove it from the array using data.splice(i, 1).
  * settings1 = {
  *   beforeCut: (data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   },
  * };
  *
  * // To cancel a cutting action, just return `false`.
  * settings2 = {
  *   beforeCut: (data, coords) => {
  *     return false;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings1"></hot-table>
  * <hot-table [settings]="settings2"></hot-table>
  * ```
  * :::
  */
  "beforeCut",
  /**
  * Fired by {@link CopyPaste} plugin after data was cut out from the table. This hook is fired when
  * {@link Options#copyPaste} option is enabled.
  *
  * @event Hooks#afterCut
  * @param {Array[]} data An array of arrays with the cut data.
  * @param {object[]} coords An array of objects with ranges of the visual indexes (`startRow`, `startCol`, `endRow`, `endCol`)
  *                       which was cut out.
  */
  "afterCut",
  /**
  * Fired before values are copied to the clipboard.
  *
  * @event Hooks#beforeCopy
  * @param {Array[]} data An array of arrays which contains data to copied.
  * @param {object[]} coords An array of objects with ranges of the visual indexes (`startRow`, `startCol`, `endRow`, `endCol`)
  *                         which will copied.
  * @param {{ columnHeadersCount: number }} copiedHeadersCount (Since 12.3.0) The number of copied column headers.
  * @returns {*} If returns `false` then copying is canceled.
  *
  * @example
  * ::: only-for javascript
  * ```js
  * // To disregard a single row, remove it from array using data.splice(i, 1).
  * ...
  * new Handsontable(document.getElementById('example'), {
  *   beforeCopy: (data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   }
  * });
  * ...
  *
  * // To cancel copying, return false from the callback.
  * ...
  * new Handsontable(document.getElementById('example'), {
  *   beforeCopy: (data, coords) => {
  *     return false;
  *   }
  * });
  * ...
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * // To disregard a single row, remove it from array using data.splice(i, 1).
  * ...
  * <HotTable
  *   beforeCopy={(data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   }}
  * />
  * ...
  *
  * // To cancel copying, return false from the callback.
  * ...
  * <HotTable
  *   beforeCopy={(data, coords) => {
  *     return false;
  *   }}
  * />
  * ...
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * // To disregard a single row, remove it from the array using data.splice(i, 1).
  * settings1 = {
  *   beforeCopy: (data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   },
  * };
  *
  * // To cancel copying, return false from the callback.
  * settings2 = {
  *   beforeCopy: (data, coords) => {
  *     return false;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings1"></hot-table>
  * <hot-table [settings]="settings2"></hot-table>
  * ```
  * :::
  */
  "beforeCopy",
  /**
  * Fired by {@link CopyPaste} plugin after data are pasted into table. This hook is fired when {@link Options#copyPaste}
  * option is enabled.
  *
  * @event Hooks#afterCopy
  * @param {Array[]} data An array of arrays which contains the copied data.
  * @param {object[]} coords An array of objects with ranges of the visual indexes (`startRow`, `startCol`, `endRow`, `endCol`)
  *                         which was copied.
  * @param {{ columnHeadersCount: number }} copiedHeadersCount (Since 12.3.0) The number of copied column headers.
  */
  "afterCopy",
  /**
  * Fired by {@link CopyPaste} plugin before values are pasted into table. This hook is fired when
  * {@link Options#copyPaste} option is enabled.
  *
  * @event Hooks#beforePaste
  * @param {Array[]} data An array of arrays which contains data to paste.
  * @param {object[]} coords An array of objects with ranges of the visual indexes (`startRow`, `startCol`, `endRow`, `endCol`)
  *                       that correspond to the previously selected area.
  * @returns {*} If returns `false` then pasting is canceled.
  * @example
  * ```js
  * ::: only-for javascript
  * // To disregard a single row, remove it from array using data.splice(i, 1).
  * new Handsontable(example, {
  *   beforePaste: (data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   }
  * });
  * // To cancel pasting, return false from the callback.
  * new Handsontable(example, {
  *   beforePaste: (data, coords) => {
  *     return false;
  *   }
  * });
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * // To disregard a single row, remove it from array using data.splice(i, 1).
  * <HotTable
  *   beforePaste={(data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   }}
  * />
  * // To cancel pasting, return false from the callback.
  * <HotTable
  *   beforePaste={(data, coords) => {
  *     return false;
  *   }}
  * />
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * // To disregard a single row, remove it from the array using data.splice(i, 1).
  * settings1 = {
  *   beforePaste: (data, coords) => {
  *     // data -> [[1, 2, 3], [4, 5, 6]]
  *     data.splice(0, 1);
  *     // data -> [[4, 5, 6]]
  *     // coords -> [{startRow: 0, startCol: 0, endRow: 1, endCol: 2}]
  *   },
  * };
  *
  * // To cancel pasting, return false from the callback.
  * settings2 = {
  *   beforePaste: (data, coords) => {
  *     return false;
  *   },
  * };
  * ```
  *
  * ```html
  * <hot-table [settings]="settings1"></hot-table>
  * <hot-table [settings]="settings2"></hot-table>
  * ```
  * :::
  */
  "beforePaste",
  /**
  * Fired by {@link CopyPaste} plugin after values are pasted into table. This hook is fired when
  * {@link Options#copyPaste} option is enabled.
  *
  * @event Hooks#afterPaste
  * @param {Array[]} data An array of arrays with the pasted data.
  * @param {object[]} coords An array of objects with ranges of the visual indexes (`startRow`, `startCol`, `endRow`, `endCol`)
  *                       that correspond to the previously selected area.
  */
  "afterPaste",
  /**
  * Fired by the {@link ManualColumnFreeze} plugin, before freezing a column.
  *
  * @event Hooks#beforeColumnFreeze
  * @since 12.1.0
  * @param {number} column The visual index of the column that is going to freeze.
  * @param {boolean} freezePerformed If `true`: the column is going to freeze. If `false`: the column is not going to freeze (which might happen if the column is already frozen).
  * @returns {boolean|undefined} If `false`: the column is not going to freeze, and the `afterColumnFreeze` hook won't fire.
  */
  "beforeColumnFreeze",
  /**
  * Fired by the {@link ManualColumnFreeze} plugin, right after freezing a column.
  *
  * @event Hooks#afterColumnFreeze
  * @since 12.1.0
  * @param {number} column The visual index of the frozen column.
  * @param {boolean} freezePerformed If `true`: the column got successfully frozen. If `false`: the column didn't get frozen.
  */
  "afterColumnFreeze",
  /**
  * Fired by {@link ManualColumnMove} plugin before change order of the visual indexes. This hook is fired when
  * {@link Options#manualColumnMove} option is enabled.
  *
  * @event Hooks#beforeColumnMove
  * @param {Array} movedColumns Array of visual column indexes to be moved.
  * @param {number} finalIndex Visual column index, being a start index for the moved columns.
  *                            Points to where the elements will be placed after the moving action.
  *                            To check visualization of final index please take a look at
  *                            [documentation](@/guides/columns/column-moving/column-moving.md).
  * @param {number|undefined} dropIndex Visual column index, being a drop index for the moved columns.
  *                                     Points to where we are going to drop the moved elements. To check
  *                                     visualization of drop index please take a look at
  *                                     [documentation](@/guides/columns/column-moving/column-moving.md).
  *                                     It's `undefined` when `dragColumns` function wasn't called.
  * @param {boolean} movePossible Indicates if it's possible to move rows to the desired position.
  * @returns {undefined | boolean} If `false` the column will not be moved, `true` otherwise.
  */
  "beforeColumnMove",
  /**
  * Fired by {@link ManualColumnMove} plugin after changing order of the visual indexes.
  * This hook is fired when {@link Options#manualColumnMove} option is enabled.
  *
  * @event Hooks#afterColumnMove
  * @param {Array} movedColumns Array of visual column indexes to be moved.
  * @param {number} finalIndex Visual column index, being a start index for the moved columns.
  *                            Points to where the elements will be placed after the moving action.
  *                            To check visualization of final index please take a look at
  *                            [documentation](@/guides/columns/column-moving/column-moving.md).
  * @param {number|undefined} dropIndex Visual column index, being a drop index for the moved columns.
  *                                     Points to where we are going to drop the moved elements.
  *                                     To check visualization of drop index please take a look at
  *                                     [documentation](@/guides/columns/column-moving/column-moving.md).
  *                                     It's `undefined` when `dragColumns` function wasn't called.
  * @param {boolean} movePossible Indicates if it was possible to move columns to the desired position.
  * @param {boolean} orderChanged Indicates if order of columns was changed by move.
  */
  "afterColumnMove",
  /**
  * Fired by the {@link ManualColumnFreeze} plugin, before unfreezing a column.
  *
  * @event Hooks#beforeColumnUnfreeze
  * @since 12.1.0
  * @param {number} column The visual index of the column that is going to unfreeze.
  * @param {boolean} unfreezePerformed If `true`: the column is going to unfreeze. If `false`: the column is not going to unfreeze (which might happen if the column is already unfrozen).
  * @returns {boolean|undefined} If `false`: the column is not going to unfreeze, and the `afterColumnUnfreeze` hook won't fire.
  */
  "beforeColumnUnfreeze",
  /**
  * Fired by the {@link ManualColumnFreeze} plugin, right after unfreezing a column.
  *
  * @event Hooks#afterColumnUnfreeze
  * @since 12.1.0
  * @param {number} column The visual index of the unfrozen column.
  * @param {boolean} unfreezePerformed If `true`: the column got successfully unfrozen. If `false`: the column didn't get unfrozen.
  */
  "afterColumnUnfreeze",
  /**
  * Fired by {@link ManualRowMove} plugin before changing the order of the visual indexes. This hook is fired when
  * {@link Options#manualRowMove} option is enabled.
  *
  * @event Hooks#beforeRowMove
  * @param {Array} movedRows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows.
  *                            Points to where the elements will be placed after the moving action.
  *                            To check visualization of final index please take a look at
  *                            [documentation](@/guides/rows/row-moving/row-moving.md).
  * @param {number|undefined} dropIndex Visual row index, being a drop index for the moved rows.
  *                                     Points to where we are going to drop the moved elements.
  *                                     To check visualization of drop index please take a look at
  *                                     [documentation](@/guides/rows/row-moving/row-moving.md).
  *                                     It's `undefined` when `dragRows` function wasn't called.
  * @param {boolean} movePossible Indicates if it's possible to move rows to the desired position.
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeRowMove",
  /**
  * Fired by {@link ManualRowMove} plugin after changing the order of the visual indexes.
  * This hook is fired when {@link Options#manualRowMove} option is enabled.
  *
  * @event Hooks#afterRowMove
  * @param {Array} movedRows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows.
  *                            Points to where the elements will be placed after the moving action.
  *                            To check visualization of final index please take a look at
  *                            [documentation](@/guides/rows/row-moving/row-moving.md).
  * @param {number|undefined} dropIndex Visual row index, being a drop index for the moved rows.
  *                                     Points to where we are going to drop the moved elements.
  *                                     To check visualization of drop index please take a look at
  *                                     [documentation](@/guides/rows/row-moving/row-moving.md).
  *                                     It's `undefined` when `dragRows` function wasn't called.
  * @param {boolean} movePossible Indicates if it was possible to move rows to the desired position.
  * @param {boolean} orderChanged Indicates if order of rows was changed by move.
  */
  "afterRowMove",
  /**
  * Fired by {@link ManualColumnResize} plugin before rendering the table with modified column sizes. This hook is
  * fired when {@link Options#manualColumnResize} option is enabled.
  *
  * @event Hooks#beforeColumnResize
  * @param {number} newSize Calculated new column width.
  * @param {number} column Visual index of the resized column.
  * @param {boolean} isDoubleClick Flag that determines whether there was a double-click.
  * @returns {number|false|undefined} Returns a new column size, `false` to cancel the resize, or `undefined` to keep the size set by the drag or auto-calculation.
  */
  "beforeColumnResize",
  /**
  * Fired by {@link ManualColumnResize} plugin after rendering the table with modified column sizes. This hook is
  * fired when {@link Options#manualColumnResize} option is enabled.
  *
  * @event Hooks#afterColumnResize
  * @param {number} newSize Calculated new column width.
  * @param {number} column Visual index of the resized column.
  * @param {boolean} isDoubleClick Flag that determines whether there was a double-click.
  */
  "afterColumnResize",
  /**
  * Fired by {@link ManualRowResize} plugin before rendering the table with modified row sizes. This hook is
  * fired when {@link Options#manualRowResize} option is enabled.
  *
  * @event Hooks#beforeRowResize
  * @param {number} newSize Calculated new row height.
  * @param {number} row Visual index of the resized row.
  * @param {boolean} isDoubleClick Flag that determines whether there was a double-click.
  * @returns {number|false|undefined} Returns a new row size, `false` to cancel the resize, or `undefined` to keep the size set by the drag or auto-calculation.
  */
  "beforeRowResize",
  /**
  * Fired by {@link ManualRowResize} plugin after rendering the table with modified row sizes. This hook is
  * fired when {@link Options#manualRowResize} option is enabled.
  *
  * @event Hooks#afterRowResize
  * @param {number} newSize Calculated new row height.
  * @param {number} row Visual index of the resized row.
  * @param {boolean} isDoubleClick Flag that determines whether there was a double-click.
  */
  "afterRowResize",
  /**
  * Fired after getting the column header renderers.
  *
  * The `renderers` array initially contains one renderer function when [`colHeaders`](@/api/options.md#colheaders)
  * is enabled, or zero functions when it is disabled. Each function in the array renders one layer of
  * column headers above the grid. By pushing additional renderer functions to the array, you can display
  * more than one layer of column headers simultaneously.
  *
  * Each renderer function receives the following arguments:
  *
  * | Argument               | Type                    | Description                                |
  * | ---------------------- | ----------------------- | ------------------------------------------ |
  * | `renderedColumnIndex`  | `number`                | The renderable index of the column.        |
  * | `TH`                   | `HTMLTableCellElement`  | The `<th>` element to modify.              |
  *
  * ```js
  * new Handsontable(container, {
  *   colHeaders: true,
  *   afterGetColumnHeaderRenderers(renderers) {
  *     // Add a second layer of column headers above the default one.
  *     renderers.push((renderedColumnIndex, TH) => {
  *       TH.innerText = `Extra: ${renderedColumnIndex}`;
  *     });
  *   },
  * });
  * ```
  *
  * Read more:
  * - [Options: `colHeaders`](@/api/options.md#colheaders)
  * - [Guides: Column header](@/guides/columns/column-header/column-header.md)
  *
  * @event Hooks#afterGetColumnHeaderRenderers
  * @param {Function[]} renderers An array of the column header renderers.
  */
  "afterGetColumnHeaderRenderers",
  /**
  * Fired after getting the row header renderers.
  *
  * The `renderers` array initially contains one renderer function when [`rowHeaders`](@/api/options.md#rowheaders)
  * is enabled, or zero functions when it is disabled. Each function in the array renders one layer of
  * row headers to the left of the grid. By pushing additional renderer functions to the array, you can display
  * more than one layer of row headers simultaneously.
  *
  * Each renderer function receives the following arguments:
  *
  * | Argument              | Type                    | Description                             |
  * | --------------------- | ----------------------- | --------------------------------------- |
  * | `renderableRowIndex`  | `number`                | The renderable index of the row.        |
  * | `TH`                  | `HTMLTableCellElement`  | The `<th>` element to modify.           |
  *
  * ```js
  * new Handsontable(container, {
  *   rowHeaders: true,
  *   afterGetRowHeaderRenderers(renderers) {
  *     // Add a second layer of row headers next to the default one.
  *     renderers.push((renderableRowIndex, TH) => {
  *       TH.innerText = `Extra: ${renderableRowIndex}`;
  *     });
  *   },
  * });
  * ```
  *
  * Read more:
  * - [Options: `rowHeaders`](@/api/options.md#rowheaders)
  * - [Guides: Row header](@/guides/rows/row-header/row-header.md)
  *
  * @event Hooks#afterGetRowHeaderRenderers
  * @param {Function[]} renderers An array of the row header renderers.
  */
  "afterGetRowHeaderRenderers",
  /**
  * Fired before applying stretched column width to column.
  *
  * @event Hooks#beforeStretchingColumnWidth
  * @param {number} stretchedWidth Calculated width.
  * @param {number} column Visual column index.
  * @returns {number|undefined} Returns new width which will be applied to the column element.
  */
  "beforeStretchingColumnWidth",
  /**
  * Fired by the [`Filters`](@/api/filters.md) plugin,
  * before a [column filter](@/guides/columns/column-filter/column-filter.md) gets applied.
  *
  * [`beforeFilter`](#beforefilter) takes two arguments: `conditionsStack` and `previousConditionsStack`, both are
  * arrays of objects.
  *
  * Each object represents one of your [column filters](@/api/filters.md#addcondition),
  * and consists of the following properties:
  *
  * | Property     | Possible values                                                         | Description                                                                                                              |
  * | ------------ | ----------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------------------ |
  * | `column`     | Number                                                                  | A visual index of the column to which the filter will be applied.                                                        |
  * | `conditions` | Array of objects                                                        | Each object represents one condition. For details, see [`addCondition()`](@/api/filters.md#addcondition).                |
  * | `operation`  | `'conjunction'` \| `'disjunction'` \| `'disjunctionWithExtraCondition'` | An operation to perform on your set of `conditions`. For details, see [`addCondition()`](@/api/filters.md#addcondition). |
  *
  * An example of the format of the `conditionsStack` argument:
  *
  * ```js
  * [
  *   {
  *     column: 2,
  *     conditions: [
  *       {name: 'begins_with', args: [['S']]}
  *     ],
  *     operation: 'conjunction'
  *   },
  *   {
  *     column: 4,
  *     conditions: [
  *       {name: 'not_empty', args: []}
  *     ],
  *     operation: 'conjunction'
  *   },
  * ]
  * ```
  *
  * To perform server-side filtering (i.e., to not apply filtering to Handsontable's UI),
  * set [`beforeFilter`](#beforefilter) to return `false`:
  *
  * ```js
  * new Handsontable(document.getElementById('example'), {
  *   beforeFilter: (conditionsStack) => {
  *     return false;
  *   }
  * });
  *```
  *
  * Read more:
  * - [Guides: Column filter](@/guides/columns/column-filter/column-filter.md)
  * - [Hooks: `afterFilter`](#afterfilter)
  * - [Options: `filters`](@/api/options.md#filters)
  * - [Plugins: `Filters`](@/api/filters.md)
  * – [Plugin methods: `addCondition()`](@/api/filters.md#addcondition)
  *
  * @event Hooks#beforeFilter
  * @param {object[]} conditionsStack An array of objects with your [column filters](@/api/filters.md#addcondition).
  * @param {object[]|null} previousConditionsStack An array of objects with your previous [column filters](@/api/filters.md#addcondition). It can also be `null` if there was no previous filters applied or the conditions did not change between performing the `filter` action.
  * @returns {boolean} To perform server-side filtering (i.e., to not apply filtering to Handsontable's UI), return `false`.
  */
  "beforeFilter",
  /**
  * Fired by the [`Filters`](@/api/filters.md) plugin,
  * after a [column filter](@/guides/columns/column-filter/column-filter.md) gets applied.
  *
  * [`afterFilter`](#afterfilter) takes one argument (`conditionsStack`), which is an array of objects.
  * Each object represents one of your [column filters](@/api/filters.md#addcondition),
  * and consists of the following properties:
  *
  * | Property     | Possible values                                                         | Description                                                                                                              |
  * | ------------ | ----------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------------------ |
  * | `column`     | Number                                                                  | A visual index of the column to which the filter was applied.                                                            |
  * | `conditions` | Array of objects                                                        | Each object represents one condition. For details, see [`addCondition()`](@/api/filters.md#addcondition).                |
  * | `operation`  | `'conjunction'` \| `'disjunction'` \| `'disjunctionWithExtraCondition'` | An operation to perform on your set of `conditions`. For details, see [`addCondition()`](@/api/filters.md#addcondition). |
  *
  * An example of the format of the `conditionsStack` argument:
  *
  * ```js
  * [
  *   {
  *     column: 2,
  *     conditions: [
  *       {name: 'begins_with', args: [['S']]}
  *     ],
  *     operation: 'conjunction'
  *   },
  *   {
  *     column: 4,
  *     conditions: [
  *       {name: 'not_empty', args: []}
  *     ],
  *     operation: 'conjunction'
  *   },
  * ]
  * ```
  *
  * Read more:
  * - [Guides: Column filter](@/guides/columns/column-filter/column-filter.md)
  * - [Hooks: `beforeFilter`](#beforefilter)
  * - [Options: `filters`](@/api/options.md#filters)
  * - [Plugins: `Filters`](@/api/filters.md)
  * – [Plugin methods: `addCondition()`](@/api/filters.md#addcondition)
  *
  * @event Hooks#afterFilter
  * @param {object[]} conditionsStack An array of objects with your [column filters](@/api/filters.md#addcondition).
  */
  "afterFilter",
  /**
  * Fired by {@link Pagination} plugin before changing the page. This hook is fired when
  * {@link Options#pagination} option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#beforePageChange
  * @param {number} oldPage The old page number.
  * @param {number} newPage The new page number.
  * @returns {*|boolean} If `false` is returned the action is canceled.
  */
  "beforePageChange",
  /**
  * Fired by {@link Pagination} plugin after changing the page. This hook is fired when
  * {@link Options#pagination} option is enabled. When a complete [[Options#dataProvider]] configuration
  * handles paging, {@link DataProvider} loads the requested page via `fetchRows`. {@link Pagination} then aligns its
  * UI from [[Hooks#afterDataProviderFetch]].
  *
  * @since 16.1.0
  * @event Hooks#afterPageChange
  * @param {number} oldPage The old page number.
  * @param {number} newPage The new page number.
  */
  "afterPageChange",
  /**
  * Fired by {@link Pagination} plugin before changing the page size. This hook is fired when
  * {@link Options#pagination} option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#beforePageSizeChange
  * @param {number | 'auto'} oldPageSize The old page size.
  * @param {number | 'auto'} newPageSize The new page size.
  * @returns {*|boolean} If `false` is returned the action is canceled.
  */
  "beforePageSizeChange",
  /**
  * Fired by {@link Pagination} plugin after changing the page size. This hook is fired when
  * {@link Options#pagination} option is enabled. When a complete [[Options#dataProvider]] configuration
  * handles paging, {@link DataProvider} loads page 1 for the new size via `fetchRows`. {@link Pagination} then aligns
  * its UI from [[Hooks#afterDataProviderFetch]].
  *
  * @since 16.1.0
  * @event Hooks#afterPageSizeChange
  * @param {number | 'auto'} oldPageSize The old page size.
  * @param {number | 'auto'} newPageSize The new page size.
  */
  "afterPageSizeChange",
  /**
  * Fired by {@link Pagination} plugin after changing the visibility state of the page size section.
  * This hook is fired when {@link Options#pagination} option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterPageSizeVisibilityChange
  * @param {boolean} isVisible The visibility state of the page size section.
  */
  "afterPageSizeVisibilityChange",
  /**
  * Fired by {@link Pagination} plugin after changing the visibility state of the page counter section.
  * This hook is fired when {@link Options#pagination} option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterPageCounterVisibilityChange
  * @param {boolean} isVisible The visibility state of the page size section.
  */
  "afterPageCounterVisibilityChange",
  /**
  * Fired by {@link Pagination} plugin after changing the visibility state of the page navigation section.
  * This hook is fired when {@link Options#pagination} option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterPageNavigationVisibilityChange
  * @param {boolean} isVisible The visibility state of the page size section.
  */
  "afterPageNavigationVisibilityChange",
  /**
  * Fired by the {@link Formulas} plugin, when any cell value changes.
  *
  * Returns an array of objects that contains:
  * - The addresses (`sheet`, `row`, `col`) and new values (`newValue`) of the changed cells.
  * - The addresses and new values of any cells that had to be recalculated (because their formulas depend on the cells that changed).
  *
  * This hook gets also fired on Handsontable's initialization, returning the addresses and values of all cells.
  *
  * Read more:
  * - [Guides: Formula calculation](@/guides/formulas/formula-calculation/formula-calculation.md)
  * - [HyperFormula documentation: `valuesUpdated`](https://hyperformula.handsontable.com/api/interfaces/listeners.html#valuesupdated)
  *
  * @since 9.0.0
  * @event Hooks#afterFormulasValuesUpdate
  * @param {Array} changes The addresses and new values of all the changed and recalculated cells.
  */
  "afterFormulasValuesUpdate",
  /**
  * Fired by the {@link Formulas} plugin when a named expression is added to the engine instance.
  *
  * @since 9.0.0
  * @event Hooks#afterNamedExpressionAdded
  * @param {string} namedExpressionName The name of the added expression.
  * @param {Array} changes The values and location of applied changes.
  */
  "afterNamedExpressionAdded",
  /**
  * Fired by the {@link Formulas} plugin when a named expression is removed from the engine instance.
  *
  * @since 9.0.0
  * @event Hooks#afterNamedExpressionRemoved
  * @param {string} namedExpressionName The name of the removed expression.
  * @param {Array} changes The values and location of applied changes.
  */
  "afterNamedExpressionRemoved",
  /**
  * Fired by the {@link Formulas} plugin when a new sheet is added to the engine instance.
  *
  * @since 9.0.0
  * @event Hooks#afterSheetAdded
  * @param {string} addedSheetDisplayName The name of the added sheet.
  */
  "afterSheetAdded",
  /**
  * Fired by the {@link Formulas} plugin when a sheet in the engine instance is renamed.
  *
  * @since 9.0.0
  * @event Hooks#afterSheetRenamed
  * @param {string} oldDisplayName The old name of the sheet.
  * @param {string} newDisplayName The new name of the sheet.
  */
  "afterSheetRenamed",
  /**
  * Fired by the {@link Formulas} plugin when a sheet is removed from the engine instance.
  *
  * @since 9.0.0
  * @event Hooks#afterSheetRemoved
  * @param {string} removedSheetDisplayName The removed sheet name.
  * @param {Array} changes The values and location of applied changes.
  */
  "afterSheetRemoved",
  /**
  * Fired while retrieving the column header height.
  *
  * @event Hooks#modifyColumnHeaderHeight
  */
  "modifyColumnHeaderHeight",
  /**
  * Fired while retrieving a column header's value.
  *
  * @since 12.3.0
  * @event Hooks#modifyColumnHeaderValue
  * @param {string} value A column header value.
  * @param {number} visualColumnIndex A visual column index.
  * @param {number} [headerLevel=0] Header level index. Accepts positive (`0` to `n`)
  *                                 and negative (`-1` to `-n`) values. For positive values, `0` points to the
  *                                 topmost header. For negative values, `-1` points to the bottom-most
  *                                 header (the header closest to the cells).
  * @returns {string} The column header value to be updated.
  */
  "modifyColumnHeaderValue",
  /**
  * Fired by {@link UndoRedo} plugin before the undo action. Contains information about the action that is being undone.
  * This hook is fired when {@link Options#undo} option is enabled.
  *
  * @event Hooks#beforeUndo
  * @param {object} action The action object. Contains information about the action being undone. The `actionType`
  *                        property of the object specifies the type of the action in a String format. (e.g. `'remove_row'`).
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeUndo",
  /**
  * Fired by {@link UndoRedo} plugin before changing undo stack.
  *
  * @event Hooks#beforeUndoStackChange
  * @since 8.4.0
  * @param {Array} doneActions Stack of actions which may be undone.
  * @param {string} [source] String that identifies source of action
  *                          ([list of all available sources](@/guides/getting-started/events-and-hooks/events-and-hooks.md#definition-for-source-argument)).
  * @returns {*|boolean} If false is returned the action of changing undo stack is canceled.
  */
  "beforeUndoStackChange",
  /**
  * Fired by {@link UndoRedo} plugin after the undo action. Contains information about the action that is being undone.
  * This hook is fired when {@link Options#undo} option is enabled.
  *
  * @event Hooks#afterUndo
  * @param {object} action The action object. Contains information about the action being undone. The `actionType`
  *                        property of the object specifies the type of the action in a String format. (e.g. `'remove_row'`).
  */
  "afterUndo",
  /**
  * Fired by {@link UndoRedo} plugin after changing undo stack.
  *
  * @event Hooks#afterUndoStackChange
  * @since 8.4.0
  * @param {Array} doneActionsBefore Stack of actions which could be undone before performing new action.
  * @param {Array} doneActionsAfter Stack of actions which can be undone after performing new action.
  */
  "afterUndoStackChange",
  /**
  * Fired by {@link UndoRedo} plugin before the redo action. Contains information about the action that is being redone.
  * This hook is fired when {@link Options#undo} option is enabled.
  *
  * @event Hooks#beforeRedo
  * @param {object} action The action object. Contains information about the action being redone. The `actionType`
  *                        property of the object specifies the type of the action in a String format (e.g. `'remove_row'`).
  * @returns {*|boolean} If false is returned the action is canceled.
  */
  "beforeRedo",
  /**
  * Fired by {@link UndoRedo} plugin before changing redo stack.
  *
  * @event Hooks#beforeRedoStackChange
  * @since 8.4.0
  * @param {Array} undoneActions Stack of actions which may be redone.
  */
  "beforeRedoStackChange",
  /**
  * Fired by {@link UndoRedo} plugin after the redo action. Contains information about the action that is being redone.
  * This hook is fired when {@link Options#undo} option is enabled.
  *
  * @event Hooks#afterRedo
  * @param {object} action The action object. Contains information about the action being redone. The `actionType`
  *                        property of the object specifies the type of the action in a String format (e.g. `'remove_row'`).
  */
  "afterRedo",
  /**
  * Fired by {@link UndoRedo} plugin after changing redo stack.
  *
  * @event Hooks#afterRedoStackChange
  * @since 8.4.0
  * @param {Array} undoneActionsBefore Stack of actions which could be redone before performing new action.
  * @param {Array} undoneActionsAfter Stack of actions which can be redone after performing new action.
  */
  "afterRedoStackChange",
  /**
  * Fired while retrieving the row header width.
  *
  * @event Hooks#modifyRowHeaderWidth
  * @param {number} rowHeaderWidth Row header width.
  */
  "modifyRowHeaderWidth",
  /**
  * Fired when the focus of the selection is being modified (e.g. Moving the focus with the enter/tab keys).
  *
  * @since 14.3.0
  * @event Hooks#modifyTransformFocus
  * @param {CellCoords} delta Cell coords object declaring the delta of the new selection relative to the previous one.
  */
  "modifyTransformFocus",
  /**
  * Fired when the start of the selection is being modified (e.g. Moving the selection with the arrow keys).
  *
  * @event Hooks#modifyTransformStart
  * @param {CellCoords} delta Cell coords object declaring the delta of the new selection relative to the previous one.
  */
  "modifyTransformStart",
  /**
  * Fired when the end of the selection is being modified (e.g. Moving the selection with the arrow keys).
  *
  * @event Hooks#modifyTransformEnd
  * @param {CellCoords} delta Cell coords object declaring the delta of the new selection relative to the previous one.
  */
  "modifyTransformEnd",
  /**
  * Fired after the focus of the selection is being modified (e.g. Moving the focus with the enter/tab keys).
  *
  * @since 14.3.0
  * @event Hooks#afterModifyTransformFocus
  * @param {CellCoords} coords Coords of the freshly focused cell.
  * @param {number} rowTransformDir `-1` if trying to focus a cell with a negative row index. `0` otherwise.
  * @param {number} colTransformDir `-1` if trying to focus a cell with a negative column index. `0` otherwise.
  */
  "afterModifyTransformFocus",
  /**
  * Fired after the start of the selection is being modified (e.g. Moving the selection with the arrow keys).
  *
  * @event Hooks#afterModifyTransformStart
  * @param {CellCoords} coords Coords of the freshly selected cell.
  * @param {number} rowTransformDir `-1` if trying to select a cell with a negative row index. `0` otherwise.
  * @param {number} colTransformDir `-1` if trying to select a cell with a negative column index. `0` otherwise.
  */
  "afterModifyTransformStart",
  /**
  * Fired after the end of the selection is being modified (e.g. Moving the selection with the arrow keys).
  *
  * @event Hooks#afterModifyTransformEnd
  * @param {CellCoords} coords Visual coords of the freshly selected cell.
  * @param {number} rowTransformDir `-1` if trying to select a cell with a negative row index. `0` otherwise.
  * @param {number} colTransformDir `-1` if trying to select a cell with a negative column index. `0` otherwise.
  */
  "afterModifyTransformEnd",
  /**
  * Fired inside the `viewportRowCalculatorOverride` method. Allows modifying the row calculator parameters.
  *
  * @event Hooks#afterViewportRowCalculatorOverride
  * @param {object} calc The row calculator.
  */
  "afterViewportRowCalculatorOverride",
  /**
  * Fired inside the `viewportColumnCalculatorOverride` method. Allows modifying the row calculator parameters.
  *
  * @event Hooks#afterViewportColumnCalculatorOverride
  * @param {object} calc The row calculator.
  */
  "afterViewportColumnCalculatorOverride",
  /**
  * Fired after initializing all the plugins.
  * This hook should be added before Handsontable is initialized.
  *
  * @event Hooks#afterPluginsInitialized
  *
  * @example
  * ```js
  * Handsontable.hooks.add('afterPluginsInitialized', myCallback);
  * ```
  */
  "afterPluginsInitialized",
  /**
  * Fired by {@link HiddenRows} plugin before marking the rows as hidden. Fired only if the {@link Options#hiddenRows} option is enabled.
  * Returning `false` in the callback will prevent the hiding action from completing.
  *
  * @event Hooks#beforeHideRows
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical row indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical row indexes.
  * @param {boolean} actionPossible `true`, if provided row indexes are valid, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the hiding action will not be completed.
  */
  "beforeHideRows",
  /**
  * Fired by {@link HiddenRows} plugin after marking the rows as hidden. Fired only if the {@link Options#hiddenRows} option is enabled.
  *
  * @event Hooks#afterHideRows
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical row indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical row indexes.
  * @param {boolean} actionPossible `true`, if provided row indexes are valid, `false` otherwise.
  * @param {boolean} stateChanged `true`, if the action affected any non-hidden rows, `false` otherwise.
  */
  "afterHideRows",
  /**
  * Fired by {@link HiddenRows} plugin before marking the rows as not hidden. Fired only if the {@link Options#hiddenRows} option is enabled.
  * Returning `false` in the callback will prevent the row revealing action from completing.
  *
  * @event Hooks#beforeUnhideRows
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical row indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical row indexes.
  * @param {boolean} actionPossible `true`, if provided row indexes are valid, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the revealing action will not be completed.
  */
  "beforeUnhideRows",
  /**
  * Fired by {@link HiddenRows} plugin after marking the rows as not hidden. Fired only if the {@link Options#hiddenRows} option is enabled.
  *
  * @event Hooks#afterUnhideRows
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical row indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical row indexes.
  * @param {boolean} actionPossible `true`, if provided row indexes are valid, `false` otherwise.
  * @param {boolean} stateChanged `true`, if the action affected any hidden rows, `false` otherwise.
  */
  "afterUnhideRows",
  /**
  * Fired by {@link HiddenColumns} plugin before marking the columns as hidden. Fired only if the {@link Options#hiddenColumns} option is enabled.
  * Returning `false` in the callback will prevent the hiding action from completing.
  *
  * @event Hooks#beforeHideColumns
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical column indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical column indexes.
  * @param {boolean} actionPossible `true`, if the provided column indexes are valid, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the hiding action will not be completed.
  */
  "beforeHideColumns",
  /**
  * Fired by {@link HiddenColumns} plugin after marking the columns as hidden. Fired only if the {@link Options#hiddenColumns} option is enabled.
  *
  * @event Hooks#afterHideColumns
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical column indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical column indexes.
  * @param {boolean} actionPossible `true`, if the provided column indexes are valid, `false` otherwise.
  * @param {boolean} stateChanged `true`, if the action affected any non-hidden columns, `false` otherwise.
  */
  "afterHideColumns",
  /**
  * Fired by {@link HiddenColumns} plugin before marking the columns as not hidden. Fired only if the {@link Options#hiddenColumns} option is enabled.
  * Returning `false` in the callback will prevent the column revealing action from completing.
  *
  * @event Hooks#beforeUnhideColumns
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical column indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical column indexes.
  * @param {boolean} actionPossible `true`, if the provided column indexes are valid, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the hiding action will not be completed.
  */
  "beforeUnhideColumns",
  /**
  * Fired by {@link HiddenColumns} plugin after marking the columns as not hidden. Fired only if the {@link Options#hiddenColumns} option is enabled.
  *
  * @event Hooks#afterUnhideColumns
  * @param {Array} currentHideConfig Current hide configuration - a list of hidden physical column indexes.
  * @param {Array} destinationHideConfig Destination hide configuration - a list of hidden physical column indexes.
  * @param {boolean} actionPossible `true`, if the provided column indexes are valid, `false` otherwise.
  * @param {boolean} stateChanged `true`, if the action affected any hidden columns, `false` otherwise.
  */
  "afterUnhideColumns",
  /**
  * Fired by {@link TrimRows} plugin before trimming rows. This hook is fired when {@link Options#trimRows} option is enabled.
  *
  * @event Hooks#beforeTrimRow
  * @param {Array} currentTrimConfig Current trim configuration - a list of trimmed physical row indexes.
  * @param {Array} destinationTrimConfig Destination trim configuration - a list of trimmed physical row indexes.
  * @param {boolean} actionPossible `true`, if all of the row indexes are withing the bounds of the table, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the trimming action will not be completed.
  */
  "beforeTrimRow",
  /**
  * Fired by {@link TrimRows} plugin after trimming rows. This hook is fired when {@link Options#trimRows} option is enabled.
  *
  * @event Hooks#afterTrimRow
  * @param {Array} currentTrimConfig Current trim configuration - a list of trimmed physical row indexes.
  * @param {Array} destinationTrimConfig Destination trim configuration - a list of trimmed physical row indexes.
  * @param {boolean} actionPossible `true`, if all of the row indexes are withing the bounds of the table, `false` otherwise.
  * @param {boolean} stateChanged `true`, if the action affected any non-trimmed rows, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the trimming action will not be completed.
  */
  "afterTrimRow",
  /**
  * Fired by {@link TrimRows} plugin before untrimming rows. This hook is fired when {@link Options#trimRows} option is enabled.
  *
  * @event Hooks#beforeUntrimRow
  * @param {Array} currentTrimConfig Current trim configuration - a list of trimmed physical row indexes.
  * @param {Array} destinationTrimConfig Destination trim configuration - a list of trimmed physical row indexes.
  * @param {boolean} actionPossible `true`, if all of the row indexes are withing the bounds of the table, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the untrimming action will not be completed.
  */
  "beforeUntrimRow",
  /**
  * Fired by {@link TrimRows} plugin after untrimming rows. This hook is fired when {@link Options#trimRows} option is enabled.
  *
  * @event Hooks#afterUntrimRow
  * @param {Array} currentTrimConfig Current trim configuration - a list of trimmed physical row indexes.
  * @param {Array} destinationTrimConfig Destination trim configuration - a list of trimmed physical row indexes.
  * @param {boolean} actionPossible `true`, if all of the row indexes are withing the bounds of the table, `false` otherwise.
  * @param {boolean} stateChanged `true`, if the action affected any trimmed rows, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the untrimming action will not be completed.
  */
  "afterUntrimRow",
  /**
  * Fired by {@link DropdownMenu} plugin before opening the dropdown menu. This hook is fired when {@link Options#dropdownMenu}
  * option is enabled.
  *
  * @event Hooks#beforeDropdownMenuShow
  * @param {DropdownMenu} dropdownMenu The `DropdownMenu` instance.
  */
  "beforeDropdownMenuShow",
  /**
  * Fired by {@link DropdownMenu} plugin after opening the dropdown menu. This hook is fired when {@link Options#dropdownMenu}
  * option is enabled.
  *
  * @event Hooks#afterDropdownMenuShow
  * @param {DropdownMenu} dropdownMenu The `DropdownMenu` instance.
  */
  "afterDropdownMenuShow",
  /**
  * Fired by {@link DropdownMenu} plugin after hiding the dropdown menu. This hook is fired when {@link Options#dropdownMenu}
  * option is enabled.
  *
  * @event Hooks#afterDropdownMenuHide
  * @param {DropdownMenu} instance The `DropdownMenu` instance.
  */
  "afterDropdownMenuHide",
  /**
  * Fired by {@link NestedRows} plugin before adding a children to the `NestedRows` structure. This hook is fired when
  * {@link Options#nestedRows} option is enabled.
  *
  * @event Hooks#beforeAddChild
  * @param {object} parent The parent object.
  * @param {object|undefined} element The element added as a child. If `undefined`, a blank child was added.
  * @param {number|undefined} index The index within the parent where the new child was added. If `undefined`, the element was added as the last child.
  */
  "beforeAddChild",
  /**
  * Fired by {@link NestedRows} plugin after adding a children to the `NestedRows` structure. This hook is fired when
  * {@link Options#nestedRows} option is enabled.
  *
  * @event Hooks#afterAddChild
  * @param {object} parent The parent object.
  * @param {object|undefined} element The element added as a child. If `undefined`, a blank child was added.
  * @param {number|undefined} index The index within the parent where the new child was added. If `undefined`, the element was added as the last child.
  */
  "afterAddChild",
  /**
  * Fired by {@link NestedRows} plugin before detaching a child from its parent. This hook is fired when
  * {@link Options#nestedRows} option is enabled.
  *
  * @event Hooks#beforeDetachChild
  * @param {object} parent An object representing the parent from which the element is to be detached.
  * @param {object} element The detached element.
  */
  "beforeDetachChild",
  /**
  * Fired by {@link NestedRows} plugin after detaching a child from its parent. This hook is fired when
  * {@link Options#nestedRows} option is enabled.
  *
  * @event Hooks#afterDetachChild
  * @param {object} parent An object representing the parent from which the element was detached.
  * @param {object} element The detached element.
  * @param {number} finalElementPosition The final row index of the detached element.
  */
  "afterDetachChild",
  /**
  * Fired before the editor is opened and rendered.
  *
  * @since 14.2.0
  * @event Hooks#beforeBeginEditing
  * @param {number} row Visual row index of the edited cell.
  * @param {number} column Visual column index of the edited cell.
  * @param {*} initialValue The initial editor value.
  * @param {MouseEvent | KeyboardEvent} event The event which was responsible for opening the editor.
  * @param {boolean} fullEditMode `true` if the editor is opened in full edit mode, `false` otherwise.
  * Editor opened in full edit mode does not close after pressing Arrow keys.
  * @returns {boolean | undefined} If the callback returns `false,` the editor won't be opened after
  * the mouse double click or after pressing the <kbd>**Enter**</kbd> key. Returning `undefined` (or other value
  * than boolean) will result in default behavior, which disallows opening an editor for non-contiguous
  * selection (while pressing <kbd>**Ctrl**</kbd>/<kbd>**Cmd**</kbd>) and for multiple selected cells (while pressing <kbd>**Shift**</kbd>).
  * Returning `true` removes those restrictions.
  */
  "beforeBeginEditing",
  /**
  * Fired by {@link Dialog} plugin after hiding the dialog. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterDialogHide
  */
  "afterDialogHide",
  /**
  * Fired by {@link Dialog} plugin after showing the dialog. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterDialogShow
  */
  "afterDialogShow",
  /**
  * Fired by {@link Dialog} plugin before hiding the dialog. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#beforeDialogHide
  */
  "beforeDialogHide",
  /**
  * Fired by {@link Dialog} plugin before showing the dialog. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#beforeDialogShow
  */
  "beforeDialogShow",
  /**
  * Fired by {@link Dialog} plugin before focusing the previous element. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#dialogFocusPreviousElement
  */
  "dialogFocusPreviousElement",
  /**
  * Fired by {@link Dialog} plugin before focusing the next element. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#dialogFocusNextElement
  */
  "dialogFocusNextElement",
  /**
  * Fired by {@link Dialog} plugin when the focus is set. This hook is fired when {@link Options#dialog}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterDialogFocus
  * @param {'tab_from_above' | 'tab_from_below' | 'click' | 'show'} focusSource The source of the focus.
  */
  "afterDialogFocus",
  /**
  * Fired by {@link Loading} plugin before showing the loading indicator. This hook is fired when {@link Options#loading}
  * option is enabled. The callback can return `false` to prevent the loading indicator from being shown.
  *
  * @since 16.1.0
  * @event Hooks#beforeLoadingShow
  * @returns {boolean | undefined} If returns `false`, the action will be skipped.
  */
  "beforeLoadingShow",
  /**
  * Fired by {@link Loading} plugin after showing the loading indicator. This hook is fired when {@link Options#loading}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterLoadingShow
  */
  "afterLoadingShow",
  /**
  * Fired by {@link Loading} plugin before hiding the loading indicator. This hook is fired when {@link Options#loading}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#beforeLoadingHide
  * @returns {boolean | undefined} If returns `false`, the action will be skipped.
  */
  "beforeLoadingHide",
  /**
  * Fired by {@link Loading} plugin after hiding the loading indicator. This hook is fired when {@link Options#loading}
  * option is enabled.
  *
  * @since 16.1.0
  * @event Hooks#afterLoadingHide
  */
  "afterLoadingHide",
  /**
  * Fired by {@link EmptyDataState} plugin before showing the empty data state overlay. This hook is fired when {@link Options#emptyDataState}
  * option is enabled.
  *
  * @since 16.2.0
  * @event Hooks#beforeEmptyDataStateShow
  */
  "beforeEmptyDataStateShow",
  /**
  * Fired by {@link EmptyDataState} plugin after showing the empty data state overlay. This hook is fired when {@link Options#emptyDataState}
  * option is enabled.
  *
  * @since 16.2.0
  * @event Hooks#afterEmptyDataStateShow
  */
  "afterEmptyDataStateShow",
  /**
  * Fired by {@link EmptyDataState} plugin before hiding the empty data state overlay. This hook is fired when {@link Options#emptyDataState}
  * option is enabled.
  *
  * @since 16.2.0
  * @event Hooks#beforeEmptyDataStateHide
  */
  "beforeEmptyDataStateHide",
  /**
  * Fired by {@link EmptyDataState} plugin after hiding the empty data state overlay. This hook is fired when {@link Options#emptyDataState}
  * option is enabled.
  *
  * @since 16.2.0
  * @event Hooks#afterEmptyDataStateHide
  */
  "afterEmptyDataStateHide",
  /**
  * Fired by {@link Notification} plugin before a toast is shown or enqueued. This hook is fired when {@link Options#notification}
  * option is enabled. Return `false` to cancel {@link Notification#showMessage} (no id returned, nothing enqueued).
  * Queued toasts already passed this hook once when {@link Notification#showMessage} ran; it is not fired again when a slot opens.
  *
  * @since 17.1.0
  * @event Hooks#beforeNotificationShow
  * @param {object} options Normalized toast options including `id`, `variant`, `message`, `duration`, `position`, `closable`, and `actions`.
  * @returns {boolean | undefined} If returns `false`, the toast is not shown and not queued.
  */
  "beforeNotificationShow",
  /**
  * Fired by {@link Notification} plugin after a toast is shown.
  *
  * @since 17.1.0
  * @event Hooks#afterNotificationShow
  * @param {string} id Toast id.
  * @param {object} options Normalized toast options.
  */
  "afterNotificationShow",
  /**
  * Fired by {@link Notification} plugin before a toast is hidden. Return `false` to keep it visible.
  * Timed toasts keep their auto-dismiss countdown; if the hide was triggered because the countdown
  * reached zero, the countdown restarts from the configured duration.
  *
  * @since 17.1.0
  * @event Hooks#beforeNotificationHide
  * @param {string} id Toast id.
  * @returns {boolean | undefined} If returns `false`, the toast stays visible.
  */
  "beforeNotificationHide",
  /**
  * Fired by {@link Notification} plugin after a toast is hidden.
  *
  * @since 17.1.0
  * @event Hooks#afterNotificationHide
  * @param {string} id Toast id.
  */
  "afterNotificationHide",
  /**
  * Fired after the editor is opened and rendered.
  *
  * @event Hooks#afterBeginEditing
  * @param {number} row Visual row index of the edited cell.
  * @param {number} column Visual column index of the edited cell.
  */
  "afterBeginEditing",
  /**
  * Fired by {@link MergeCells} plugin before cell merging. This hook is fired when {@link Options#mergeCells}
  * option is enabled.
  *
  * @event Hooks#beforeMergeCells
  * @param {CellRange} cellRange Selection cell range.
  * @param {boolean} [auto=false] `true` if called automatically by the plugin.
  */
  "beforeMergeCells",
  /**
  * Fired by {@link MergeCells} plugin after cell merging. This hook is fired when {@link Options#mergeCells}
  * option is enabled.
  *
  * @event Hooks#afterMergeCells
  * @param {CellRange} cellRange Selection cell range.
  * @param {object} mergeParent The parent collection of the provided cell range.
  * @param {boolean} [auto=false] `true` if called automatically by the plugin.
  */
  "afterMergeCells",
  /**
  * Fired by {@link MergeCells} plugin before unmerging the cells. This hook is fired when {@link Options#mergeCells}
  * option is enabled.
  *
  * @event Hooks#beforeUnmergeCells
  * @param {CellRange} cellRange Selection cell range.
  * @param {boolean} [auto=false] `true` if called automatically by the plugin.
  */
  "beforeUnmergeCells",
  /**
  * Fired by {@link MergeCells} plugin after unmerging the cells. This hook is fired when {@link Options#mergeCells}
  * option is enabled.
  *
  * @event Hooks#afterUnmergeCells
  * @param {CellRange} cellRange Selection cell range.
  * @param {boolean} [auto=false] `true` if called automatically by the plugin.
  */
  "afterUnmergeCells",
  /**
  * Fired after the table was switched into listening mode. This allows Handsontable to capture keyboard events and
  * respond in the right way.
  *
  * @event Hooks#afterListen
  */
  "afterListen",
  /**
  * Fired after the table was switched off from the listening mode. This makes the Handsontable inert for any
  * keyboard events.
  *
  * @event Hooks#afterUnlisten
  */
  "afterUnlisten",
  /**
  * Fired after the window was resized or the size of the Handsontable root element was changed.
  *
  * @event Hooks#afterRefreshDimensions
  * @param {{ width: number, height: number }} previousDimensions Previous dimensions of the container.
  * @param {{ width: number, height: number }} currentDimensions Current dimensions of the container.
  * @param {boolean} stateChanged `true`, if the container was re-render, `false` otherwise.
  */
  "afterRefreshDimensions",
  /**
  * Cancellable hook, called after resizing a window or after detecting size change of the
  * Handsontable root element, but before redrawing a table.
  *
  * @event Hooks#beforeRefreshDimensions
  * @param {{ width: number, height: number }} previousDimensions Previous dimensions of the container.
  * @param {{ width: number, height: number }} currentDimensions Current dimensions of the container.
  * @param {boolean} actionPossible `true`, if current and previous dimensions are different, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the refresh action will not be completed.
  */
  "beforeRefreshDimensions",
  /**
  * Fired by {@link CollapsibleColumns} plugin before columns collapse. This hook is fired when {@link Options#collapsibleColumns} option is enabled.
  *
  * @event Hooks#beforeColumnCollapse
  * @since 8.0.0
  * @param {Array} currentCollapsedColumns Current collapsible configuration - a list of collapsible physical column indexes.
  * @param {Array} destinationCollapsedColumns Destination collapsible configuration - a list of collapsible physical column indexes.
  * @param {boolean} collapsePossible `true`, if all of the column indexes are withing the bounds of the collapsed sections, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the collapsing action will not be completed.
  */
  "beforeColumnCollapse",
  /**
  * Fired by {@link CollapsibleColumns} plugin before columns collapse. This hook is fired when {@link Options#collapsibleColumns} option is enabled.
  *
  * @event Hooks#afterColumnCollapse
  * @since 8.0.0
  * @param {Array} currentCollapsedColumns Current collapsible configuration - a list of collapsible physical column indexes.
  * @param {Array} destinationCollapsedColumns Destination collapsible configuration - a list of collapsible physical column indexes.
  * @param {boolean} collapsePossible `true`, if all of the column indexes are withing the bounds of the collapsed sections, `false` otherwise.
  * @param {boolean} successfullyCollapsed `true`, if the action affected any non-collapsible column, `false` otherwise.
  */
  "afterColumnCollapse",
  /**
  * Fired by {@link CollapsibleColumns} plugin before columns expand. This hook is fired when {@link Options#collapsibleColumns} option is enabled.
  *
  * @event Hooks#beforeColumnExpand
  * @since 8.0.0
  * @param {Array} currentCollapsedColumns Current collapsible configuration - a list of collapsible physical column indexes.
  * @param {Array} destinationCollapsedColumns Destination collapsible configuration - a list of collapsible physical column indexes.
  * @param {boolean} expandPossible `true`, if all of the column indexes are withing the bounds of the collapsed sections, `false` otherwise.
  * @returns {undefined|boolean} If the callback returns `false`, the expanding action will not be completed.
  */
  "beforeColumnExpand",
  /**
  * Fired by {@link CollapsibleColumns} plugin before columns expand. This hook is fired when {@link Options#collapsibleColumns} option is enabled.
  *
  * @event Hooks#afterColumnExpand
  * @since 8.0.0
  * @param {Array} currentCollapsedColumns Current collapsible configuration - a list of collapsible physical column indexes.
  * @param {Array} destinationCollapsedColumns Destination collapsible configuration - a list of collapsible physical column indexes.
  * @param {boolean} expandPossible `true`, if all of the column indexes are withing the bounds of the collapsed sections, `false` otherwise.
  * @param {boolean} successfullyExpanded `true`, if the action affected any non-collapsible column, `false` otherwise.
  */
  "afterColumnExpand",
  /**
  * Fired by {@link AutoColumnSize} plugin within SampleGenerator utility.
  *
  * @event Hooks#modifyAutoColumnSizeSeed
  * @since 8.4.0
  * @param {string|undefined} seed Seed ID, unique name to categorize samples.
  * @param {object} cellProperties Object containing the cell properties.
  * @param {*} cellValue Value of the cell.
  */
  "modifyAutoColumnSizeSeed"
];
const REMOVED_HOOKS = /* @__PURE__ */ new Map([
  [
    "modifyRow",
    "8.0.0"
  ],
  [
    "modifyCol",
    "8.0.0"
  ],
  [
    "unmodifyRow",
    "8.0.0"
  ],
  [
    "unmodifyCol",
    "8.0.0"
  ],
  [
    "skipLengthCache",
    "8.0.0"
  ],
  [
    "hiddenColumn",
    "8.0.0"
  ],
  [
    "hiddenRow",
    "8.0.0"
  ],
  [
    "persistentStateSave",
    "17.0.0"
  ],
  [
    "persistentStateLoad",
    "17.0.0"
  ],
  [
    "persistentStateReset",
    "17.0.0"
  ]
]);
const DEPRECATED_HOOKS = /* @__PURE__ */ new Map([]);
function _check_private_redeclaration$1J(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1s(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1s(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1s(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1s(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1s(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1s(receiver, descriptor);
}
function _class_private_field_init$1s(obj, privateMap, value) {
  _check_private_redeclaration$1J(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1s(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1s(receiver, privateMap, "set");
  _class_apply_descriptor_set$1s(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$1c(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$1c(obj, privateSet) {
  _check_private_redeclaration$1J(obj, privateSet);
  privateSet.add(obj);
}
const MAX_SKIPPED_HOOKS_COUNT = 100;
var _hooks$1 = /* @__PURE__ */ new WeakMap(), _skippedHooksCount = /* @__PURE__ */ new WeakMap(), _needsSort = /* @__PURE__ */ new WeakMap(), _createHooksCollection = /* @__PURE__ */ new WeakSet();
class HooksBucket {
  /**
  * Gets all hooks for the provided hook name.
  *
  * @param {string} hookName The name of the hook.
  * @returns {HookEntry[]}
  */
  getHooks(hookName) {
    return _class_private_field_get$1s(this, _hooks$1).get(hookName) ?? [];
  }
  /**
  * Adds a new hook to the collection.
  *
  * @param {string} hookName The name of the hook.
  * @param {Function} callback The callback function to add.
  * @param {{ orderIndex?: number, runOnce?: boolean, initialHook?: boolean }} options The options object.
  */
  add(hookName, callback, options = {}) {
    if (!_class_private_field_get$1s(this, _hooks$1).has(hookName)) {
      _class_private_method_get$1c(this, _createHooksCollection, createHooksCollection).call(this, hookName);
      REGISTERED_HOOKS.push(hookName);
    }
    const hooks = _class_private_field_get$1s(this, _hooks$1).get(hookName) ?? [];
    const existingHook = hooks.find((hook) => hook.callback === callback);
    if (existingHook) {
      if (existingHook.skip === true) {
        existingHook.skip = false;
      }
      return;
    }
    const orderIndex = Number.isInteger(options.orderIndex) ? options.orderIndex ?? 0 : 0;
    const runOnce = !!options.runOnce;
    const initialHook = !!options.initialHook;
    let foundInitialHook = false;
    if (initialHook) {
      const initialHookEntry = hooks.find((hook) => hook.initialHook);
      if (initialHookEntry) {
        initialHookEntry.callback = callback;
        foundInitialHook = true;
      }
    }
    if (!foundInitialHook) {
      hooks.push({
        callback,
        orderIndex,
        runOnce,
        initialHook,
        skip: false
      });
      let needsSort = _class_private_field_get$1s(this, _needsSort).has(hookName);
      if (!needsSort && orderIndex !== 0) {
        needsSort = true;
        _class_private_field_get$1s(this, _needsSort).add(hookName);
      }
      if (needsSort && hooks.length > 1) {
        _class_private_field_get$1s(this, _hooks$1).set(hookName, hooks.toSorted((a, b) => a.orderIndex - b.orderIndex));
      }
    }
  }
  /**
  * Checks if there are any hooks for the provided hook name.
  *
  * @param {string} hookName The name of the hook.
  * @returns {boolean}
  */
  has(hookName) {
    return _class_private_field_get$1s(this, _hooks$1).has(hookName) && (_class_private_field_get$1s(this, _hooks$1).get(hookName)?.length ?? 0) > 0;
  }
  /**
  * Removes a hook from the collection. If the hook was found and removed,
  * the method returns `true`, otherwise `false`.
  *
  * @param {string} hookName The name of the hook.
  * @param {*} callback The callback function to remove.
  * @returns {boolean}
  */
  remove(hookName, callback) {
    if (!_class_private_field_get$1s(this, _hooks$1).has(hookName)) {
      return false;
    }
    const hooks = _class_private_field_get$1s(this, _hooks$1).get(hookName) ?? [];
    const hookEntry = hooks.find((hook) => hook.callback === callback);
    if (hookEntry) {
      let skippedHooksCount = _class_private_field_get$1s(this, _skippedHooksCount).get(hookName) ?? 0;
      hookEntry.skip = true;
      skippedHooksCount += 1;
      if (skippedHooksCount > MAX_SKIPPED_HOOKS_COUNT) {
        _class_private_field_get$1s(this, _hooks$1).set(hookName, hooks.filter((hook) => !hook.skip));
        skippedHooksCount = 0;
      }
      _class_private_field_get$1s(this, _skippedHooksCount).set(hookName, skippedHooksCount);
      return true;
    }
    return false;
  }
  /**
  * Destroys the bucket.
  */
  destroy() {
    _class_private_field_get$1s(this, _hooks$1).clear();
    _class_private_field_get$1s(this, _skippedHooksCount).clear();
  }
  /**
  * Initializes the bucket and pre-creates empty hook collections for all currently registered hook names.
  */
  constructor() {
    _class_private_method_init$1c(this, _createHooksCollection);
    _class_private_field_init$1s(this, _hooks$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1s(this, _skippedHooksCount, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1s(this, _needsSort, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1s(this, _hooks$1, /* @__PURE__ */ new Map());
    _class_private_field_set$1s(this, _skippedHooksCount, /* @__PURE__ */ new Map());
    _class_private_field_set$1s(this, _needsSort, /* @__PURE__ */ new Set());
    REGISTERED_HOOKS.forEach((hookName) => _class_private_method_get$1c(this, _createHooksCollection, createHooksCollection).call(this, hookName));
  }
}
function createHooksCollection(hookName) {
  _class_private_field_get$1s(this, _hooks$1).set(hookName, []);
  _class_private_field_get$1s(this, _skippedHooksCount).set(hookName, 0);
}
function _check_private_redeclaration$1I(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$1b(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$1b(obj, privateSet) {
  _check_private_redeclaration$1I(obj, privateSet);
  privateSet.add(obj);
}
const REMOVED_MESSAGE = toSingleLine`The plugin hook "[hookName]" was removed in Handsontable [removedInVersion].\x20
  Please consult release notes https://github.com/handsontable/handsontable/releases/tag/[removedInVersion] to\x20
  learn about the migration path.`;
var _runHandlers = /* @__PURE__ */ new WeakSet();
class Hooks {
  /**
  * Returns the global singleton instance shared across all Handsontable instances.
  */
  static getSingleton() {
    return getGlobalSingleton();
  }
  /**
  * Get hook bucket based on the context of the object or if argument is missing, get the global hook bucket.
  *
  * @param {object} [context=null] A Handsontable instance.
  * @returns {HooksBucket} Returns a global or Handsontable instance bucket.
  */
  getBucket(context = null) {
    if (context) {
      if (!context.pluginHookBucket) {
        context.pluginHookBucket = new HooksBucket();
      }
      return context.pluginHookBucket;
    }
    return this.globalBucket;
  }
  /**
  * Adds a listener (globally or locally) to a specified hook name.
  * If the `context` parameter is provided, the hook will be added only to the instance it references.
  * Otherwise, the callback will be used every time the hook fires on any Handsontable instance.
  * You can provide an array of callback functions as the `callback` argument, this way they will all be fired
  * once the hook is triggered.
  *
  * @param {string} key Hook name.
  * @param {Function|Function[]} callback Callback function or an array of functions.
  * @param {object} [context=null] The context for the hook callback to be added - a Handsontable instance or leave empty.
  * @param {number} [orderIndex] Order index of the callback.
  *                              If > 0, the callback will be added after the others, for example, with an index of 1, the callback will be added before the ones with an index of 2, 3, etc., but after the ones with an index of 0 and lower.
  *                              If < 0, the callback will be added before the others, for example, with an index of -1, the callback will be added after the ones with an index of -2, -3, etc., but before the ones with an index of 0 and higher.
  *                              If 0 or no order index is provided, the callback will be added between the "negative" and "positive" indexes.
  * @returns {Hooks} Instance of Hooks.
  *
  * @example
  * ```js
  * // single callback, added locally
  * Handsontable.hooks.add('beforeInit', myCallback, hotInstance);
  *
  * // single callback, added globally
  * Handsontable.hooks.add('beforeInit', myCallback);
  *
  * // multiple callbacks, added locally
  * Handsontable.hooks.add('beforeInit', [myCallback, anotherCallback], hotInstance);
  *
  * // multiple callbacks, added globally
  * Handsontable.hooks.add('beforeInit', [myCallback, anotherCallback]);
  * ```
  */
  add(key, callback, context = null, orderIndex) {
    if (Array.isArray(callback)) {
      arrayEach(callback, (c) => this.add(key, c, context));
    } else {
      if (REMOVED_HOOKS.has(key)) {
        warn$1(substitute(REMOVED_MESSAGE, {
          hookName: key,
          removedInVersion: REMOVED_HOOKS.get(key)
        }));
      }
      if (DEPRECATED_HOOKS.has(key)) {
        warn$1(DEPRECATED_HOOKS.get(key));
      }
      this.getBucket(context).add(key, callback, {
        orderIndex,
        runOnce: false
      });
    }
    return this;
  }
  /**
  * Adds a listener to a specified hook. After the hook runs this listener will be automatically removed from the bucket.
  *
  * @param {string} key Hook/Event name.
  * @param {Function|Function[]} callback Callback function.
  * @param {object} [context=null] A Handsontable instance.
  * @param {number} [orderIndex] Order index of the callback.
  *                              If > 0, the callback will be added after the others, for example, with an index of 1, the callback will be added before the ones with an index of 2, 3, etc., but after the ones with an index of 0 and lower.
  *                              If < 0, the callback will be added before the others, for example, with an index of -1, the callback will be added after the ones with an index of -2, -3, etc., but before the ones with an index of 0 and higher.
  *                              If 0 or no order index is provided, the callback will be added between the "negative" and "positive" indexes.
  * @returns {Hooks} Instance of Hooks.
  *
  * @example
  * ```js
  * Handsontable.hooks.once('beforeInit', myCallback, hotInstance);
  * ```
  */
  once(key, callback, context = null, orderIndex) {
    if (Array.isArray(callback)) {
      arrayEach(callback, (c) => this.once(key, c, context));
    } else {
      this.getBucket(context).add(key, callback, {
        orderIndex,
        runOnce: true
      });
    }
    return this;
  }
  /**
  * Adds a listener to a specified hook. The added hook stays in the bucket at specified index position even after
  * adding another one with the same hook name.
  *
  * @param {string} key Hook/Event name.
  * @param {Function|Function[]} callback Callback function.
  * @param {object} [context=null] A Handsontable instance.
  * @returns {Hooks} Instance of Hooks.
  *
  * @example
  * ```js
  * Handsontable.hooks.addAsFixed('beforeInit', myCallback, hotInstance);
  * ```
  */
  addAsFixed(key, callback, context = null) {
    if (Array.isArray(callback)) {
      arrayEach(callback, (c) => this.addAsFixed(key, c, context));
    } else {
      this.getBucket(context).add(key, callback, {
        initialHook: true
      });
    }
    return this;
  }
  /**
  * Removes a listener from a hook with a given name. If the `context` argument is provided, it removes a listener from a local hook assigned to the given Handsontable instance.
  *
  * @param {string} key Hook/Event name.
  * @param {Function} callback Callback function (needs the be the function that was previously added to the hook).
  * @param {object} [context=null] Handsontable instance.
  * @returns {boolean} Returns `true` if hook was removed, `false` otherwise.
  *
  * @example
  * ```js
  * Handsontable.hooks.remove('beforeInit', myCallback);
  * ```
  */
  remove(key, callback, context = null) {
    return this.getBucket(context).remove(key, callback);
  }
  /**
  * Checks whether there are any registered listeners for the provided hook name.
  * If the `context` parameter is provided, it only checks for listeners assigned to the given Handsontable instance.
  *
  * @param {string} key Hook name.
  * @param {object} [context=null] A Handsontable instance.
  * @returns {boolean} `true` for success, `false` otherwise.
  */
  has(key, context = null) {
    return this.getBucket(context).has(key);
  }
  /**
  * Runs all local and global callbacks assigned to the hook identified by the `key` parameter.
  * It returns either a return value from the last called callback or the first parameter (`p1`) passed to the `run` function.
  *
  * @param {object} context Handsontable instance.
  * @param {string} key Hook/Event name.
  * @param {*} [p1] Parameter to be passed as an argument to the callback function.
  * @param {*} [p2] Parameter to be passed as an argument to the callback function.
  * @param {*} [p3] Parameter to be passed as an argument to the callback function.
  * @param {*} [p4] Parameter to be passed as an argument to the callback function.
  * @param {*} [p5] Parameter to be passed as an argument to the callback function.
  * @param {*} [p6] Parameter to be passed as an argument to the callback function.
  * @returns {*} Either a return value from the last called callback or `p1`.
  *
  * @example
  * ```js
  * Handsontable.hooks.run(hot, 'beforeInit');
  * ```
  */
  run(context, key, p1, p2, p3, p4, p5, p6) {
    p1 = _class_private_method_get$1b(this, _runHandlers, runHandlers).call(this, this.getBucket().getHooks(key), context, key, null, p1, p2, p3, p4, p5, p6);
    p1 = _class_private_method_get$1b(this, _runHandlers, runHandlers).call(this, this.getBucket(context).getHooks(key), context, key, context, p1, p2, p3, p4, p5, p6);
    return p1;
  }
  /**
  * Destroy all listeners connected to the context. If no context is provided, the global listeners will be destroyed.
  *
  * @param {object} [context=null] A Handsontable instance.
  * @example
  * ```js
  * // destroy the global listeners
  * Handsontable.hooks.destroy();
  *
  * // destroy the local listeners
  * Handsontable.hooks.destroy(hotInstance);
  * ```
  */
  destroy(context = null) {
    this.getBucket(context).destroy();
  }
  /**
  * Registers a hook name (adds it to the list of the known hook names). Used by plugins.
  * It is not necessary to call register, but if you use it, your plugin hook will be used returned by
  * the `getRegistered` method. (which itself is used in the [demo](@/guides/getting-started/events-and-hooks/events-and-hooks.md)).
  *
  * @param {string} key The hook name.
  *
  * @example
  * ```js
  * Handsontable.hooks.register('myHook');
  * ```
  */
  register(key) {
    if (!this.isRegistered(key)) {
      REGISTERED_HOOKS.push(key);
    }
  }
  /**
  * Deregisters a hook name (removes it from the list of known hook names).
  *
  * @param {string} key The hook name.
  *
  * @example
  * ```js
  * Handsontable.hooks.deregister('myHook');
  * ```
  */
  deregister(key) {
    if (this.isRegistered(key)) {
      REGISTERED_HOOKS.splice(REGISTERED_HOOKS.indexOf(key), 1);
    }
  }
  /**
  * Returns a boolean value depending on if a hook by such name has been removed or deprecated.
  *
  * @param {string} hookName The hook name to check.
  * @returns {boolean} Returns `true` if the provided hook name was marked as deprecated or
  * removed from API, `false` otherwise.
  * @example
  * ```js
  * Handsontable.hooks.isDeprecated('skipLengthCache');
  *
  * // Results:
  * true
  * ```
  */
  isDeprecated(hookName) {
    return DEPRECATED_HOOKS.has(hookName) || REMOVED_HOOKS.has(hookName);
  }
  /**
  * Returns a boolean depending on if a hook by such name has been registered.
  *
  * @param {string} hookName The hook name to check.
  * @returns {boolean} `true` for success, `false` otherwise.
  * @example
  * ```js
  * Handsontable.hooks.isRegistered('beforeInit');
  *
  * // Results:
  * true
  * ```
  */
  isRegistered(hookName) {
    return REGISTERED_HOOKS.indexOf(hookName) >= 0;
  }
  /**
  * Returns an array of registered hooks.
  *
  * @returns {Array} An array of registered hooks.
  *
  * @example
  * ```js
  * Handsontable.hooks.getRegistered();
  *
  * // Results:
  * [
  * ...
  *   'beforeInit',
  *   'beforeRender',
  *   'beforeSetRangeEnd',
  *   'beforeDrawBorders',
  *   'beforeChange',
  * ...
  * ]
  * ```
  */
  getRegistered() {
    return REGISTERED_HOOKS;
  }
  constructor() {
    _class_private_method_init$1b(this, _runHandlers);
    this.globalBucket = new HooksBucket();
  }
}
function runHandlers(handlers2, context, key, removeContext, p1, p2, p3, p4, p5, p6) {
  const length = handlers2 ? handlers2.length : 0;
  let index2 = 0;
  if (length) {
    while (index2 < length) {
      if (!handlers2[index2] || handlers2[index2].skip) {
        index2 += 1;
        continue;
      }
      const res = fastCall(handlers2[index2].callback, context, p1, p2, p3, p4, p5, p6);
      if (res !== void 0) {
        p1 = res;
      }
      if (handlers2[index2] && handlers2[index2].runOnce) {
        this.remove(key, handlers2[index2].callback, removeContext);
      }
      index2 += 1;
    }
  }
  return p1;
}
const globalSingleton = new Hooks();
function getGlobalSingleton() {
  return globalSingleton;
}
const collection = /* @__PURE__ */ new Map();
function staticRegister(namespace = "common") {
  if (!collection.has(namespace)) {
    collection.set(namespace, /* @__PURE__ */ new Map());
  }
  const subCollection = collection.get(namespace);
  function register2(name, item) {
    subCollection.set(name, item);
  }
  function getItem2(name) {
    return subCollection.get(name);
  }
  function hasItem2(name) {
    return subCollection.has(name);
  }
  function getNames2() {
    return [
      ...subCollection.keys()
    ];
  }
  function getValues2() {
    return [
      ...subCollection.values()
    ];
  }
  function clear() {
    collection.delete(namespace);
    subCollection.clear();
  }
  return {
    register: register2,
    getItem: getItem2,
    hasItem: hasItem2,
    getNames: getNames2,
    getValues: getValues2,
    clear
  };
}
function resolveWithInstance(hotInstance, name) {
  return collection?.get(hotInstance.guid)?.get(name);
}
function _check_private_redeclaration$1H(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1r(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1r(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1r(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1r(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1r(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1r(receiver, descriptor);
}
function _class_private_field_init$1r(obj, privateMap, value) {
  _check_private_redeclaration$1H(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1r(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1r(receiver, privateMap, "set");
  _class_apply_descriptor_set$1r(receiver, descriptor, value);
  return value;
}
const { register: register$5, getItem: getItem$4, hasItem: hasItem$4, getNames: getNames$4, getValues: getValues$4 } = staticRegister("editors");
var _editorClass = /* @__PURE__ */ new WeakMap(), _instances = /* @__PURE__ */ new WeakMap();
class RegisteredEditor {
  /**
  * Returns the underlying editor constructor.
  *
  * @returns {Function} The editor class.
  */
  getConstructor() {
    return _class_private_field_get$1r(this, _editorClass);
  }
  /**
  * Returns a memoized editor instance for the given Handsontable instance.
  *
  * @param {HotInstance} hotInstance The Handsontable instance.
  * @returns {object} The editor instance.
  */
  getInstance(hotInstance) {
    if (!(hotInstance.guid in _class_private_field_get$1r(this, _instances))) {
      _class_private_field_get$1r(this, _instances)[hotInstance.guid] = new (_class_private_field_get$1r(this, _editorClass))(hotInstance);
    }
    return _class_private_field_get$1r(this, _instances)[hotInstance.guid];
  }
  /**
  * Wraps the given editor class and registers an afterDestroy hook to clean up instances.
  */
  constructor(editorClass) {
    _class_private_field_init$1r(this, _editorClass, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1r(this, _instances, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1r(this, _instances, {});
    _class_private_field_set$1r(this, _editorClass, editorClass);
    const instances2 = _class_private_field_get$1r(this, _instances);
    Hooks.getSingleton().add("afterDestroy", function() {
      instances2[this.guid] = null;
    });
  }
}
const registeredEditorClasses = /* @__PURE__ */ new WeakMap();
function isEditorConstructor(value) {
  return typeof value === "function";
}
function toEditorConstructor(editorClass) {
  if (!isEditorConstructor(editorClass)) {
    throwWithCause("Editor class must be a constructor function.");
  }
  return editorClass;
}
function _getEditorInstance(name, hotInstance) {
  let editor;
  if (isEditorConstructor(name)) {
    if (!registeredEditorClasses.get(name)) {
      _register$3(null, name);
    }
    editor = registeredEditorClasses.get(name);
  } else if (typeof name === "string") {
    editor = getItem$4(name);
  } else {
    throwWithCause('Only strings and functions can be passed as "editor" parameter');
  }
  if (!editor) {
    throwWithCause(`No editor registered under name "${name}"`);
  }
  return editor.getInstance(hotInstance);
}
function _getItem$3(name) {
  if (typeof name !== "string") {
    return toEditorConstructor(name);
  }
  if (!hasItem$4(name)) {
    throwWithCause(`No registered editor found under "${name}" name`);
  }
  const wrapper = getItem$4(name);
  return wrapper.getConstructor();
}
function _register$3(name, editorClass) {
  let editorName = typeof name === "string" ? name : null;
  let resolvedClass = editorClass;
  if (name && isEditorConstructor(name)) {
    resolvedClass = name;
    editorName = name.EDITOR_TYPE ?? null;
  }
  if (!resolvedClass) {
    throwWithCause("Editor class is required to register an editor.");
  }
  const editorCtor = toEditorConstructor(resolvedClass);
  const editorWrapper = new RegisteredEditor(editorCtor);
  if (editorName !== null) {
    register$5(editorName, editorWrapper);
  }
  registeredEditorClasses.set(editorCtor, editorWrapper);
}
class EventManager {
  /**
  * Register specified listener (`eventName`) to the element.
  *
  * @param {Element} element Target element.
  * @param {string} eventName Event name.
  * @param {Function} callback Function which will be called after event occur.
  * @param {AddEventListenerOptions|boolean} [options] Listener options if object or useCapture if boolean.
  * @returns {Function} Returns function which you can easily call to remove that event.
  */
  addEventListener(element, eventName, callback, options = false) {
    if (!this.context) {
      return () => {
      };
    }
    const callbackRef = callback;
    function callbackProxy(event) {
      callbackRef.call(this, extendEvent(event));
    }
    this.context.eventListeners.push({
      element,
      event: eventName,
      callback,
      callbackProxy,
      options,
      eventManager: this
    });
    element.addEventListener(eventName, callbackProxy, options);
    return () => {
      this.removeEventListener(element, eventName, callback);
    };
  }
  /**
  * Remove the event listener previously registered.
  *
  * @param {Element} element Target element.
  * @param {string} eventName Event name.
  * @param {Function} callback Function to remove from the event target. It must be the same as during registration listener.
  * @param {boolean} [onlyOwnEvents] Whether whould remove only events registered using this instance of EventManager.
  */
  removeEventListener(element, eventName, callback, onlyOwnEvents = false) {
    if (!this.context) {
      return;
    }
    let len = this.context.eventListeners.length;
    let tmpEvent;
    while (len) {
      len -= 1;
      tmpEvent = this.context.eventListeners[len];
      if (tmpEvent.event === eventName && tmpEvent.element === element) {
        if (callback && callback !== tmpEvent.callback) {
          continue;
        }
        if (onlyOwnEvents && tmpEvent.eventManager !== this) {
          continue;
        }
        this.context.eventListeners.splice(len, 1);
        tmpEvent.element.removeEventListener(tmpEvent.event, tmpEvent.callbackProxy, tmpEvent.options);
      }
    }
  }
  /**
  * Clear all previously registered events.
  *
  * @private
  * @since 0.15.0-beta3
  * @param {boolean} [onlyOwnEvents] Whether whould remove only events registered using this instance of EventManager.
  */
  clearEvents(onlyOwnEvents = false) {
    if (!this.context) {
      return;
    }
    let len = this.context.eventListeners.length;
    while (len) {
      len -= 1;
      const event = this.context.eventListeners[len];
      if (onlyOwnEvents && event.eventManager !== this) {
        continue;
      }
      this.context.eventListeners.splice(len, 1);
      event.element.removeEventListener(event.event, event.callbackProxy, event.options);
    }
  }
  /**
  * Clear all previously registered events.
  */
  clear() {
    this.clearEvents();
  }
  /**
  * Destroy instance of EventManager, clearing all events of the context.
  */
  destroy() {
    this.clearEvents();
    this.context = null;
  }
  /**
  * Destroy instance of EventManager, clearing only the own events.
  */
  destroyWithOwnEventsOnly() {
    this.clearEvents(true);
    this.context = null;
  }
  /**
  * Trigger event at the specified target element.
  *
  * @param {Element} element Target element.
  * @param {string} eventName Event name.
  */
  fireEvent(element, eventName) {
    let rootDocument = "document" in element ? element.document : void 0;
    let rootWindow = "window" in element ? element : void 0;
    if (!rootDocument) {
      rootDocument = element.ownerDocument ? element.ownerDocument : element;
      rootWindow = rootDocument.defaultView;
    }
    const options = {
      bubbles: true,
      cancelable: eventName !== "mousemove",
      view: rootWindow,
      detail: 0,
      screenX: 0,
      screenY: 0,
      clientX: 1,
      clientY: 1,
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
      button: 0
    };
    let event;
    if (rootDocument.createEvent) {
      event = rootDocument.createEvent("MouseEvents");
      event.initMouseEvent(eventName, options.bubbles, options.cancelable, options.view, options.detail, options.screenX, options.screenY, options.clientX, options.clientY, options.ctrlKey, options.altKey, options.shiftKey, options.metaKey, options.button, rootDocument.body.parentNode);
    } else {
      event = rootDocument.createEventObject();
    }
    if (element.dispatchEvent) {
      element.dispatchEvent(event);
    } else {
      element.fireEvent(`on${eventName}`, event);
    }
  }
  /**
  * @param {object} [context=null] An object to which event listeners will be stored.
  */
  constructor(context = null) {
    this.context = context || this;
    if (!this.context.eventListeners) {
      this.context.eventListeners = [];
    }
  }
}
function extendEvent(event) {
  const nativeStopImmediatePropagation = event.stopImmediatePropagation;
  event.stopImmediatePropagation = function() {
    nativeStopImmediatePropagation.apply(this);
    stopImmediatePropagation(this);
  };
  return event;
}
function _check_private_redeclaration$1G(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$1a(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$1a(obj, privateSet) {
  _check_private_redeclaration$1G(obj, privateSet);
  privateSet.add(obj);
}
var _onAfterDocumentKeyDown$1 = /* @__PURE__ */ new WeakSet(), _onCellDblClick = /* @__PURE__ */ new WeakSet();
class EditorManager {
  /**
  * Get active editor.
  *
  * @returns {BaseEditor}
  */
  getActiveEditor() {
    return this.activeEditor;
  }
  /**
  * Prepare text input to be displayed at given grid cell.
  */
  prepareEditor() {
    if (this.activeEditor && this.activeEditor.isWaiting()) {
      this.closeEditor(false, false, (dataSaved) => {
        if (dataSaved) {
          this.prepareEditor();
        }
      });
      return;
    }
    const highlight = this.hot.getSelectedRangeActive()?.highlight;
    if (!highlight || highlight.isHeader()) {
      return;
    }
    const { row: rowNullable, col: colNullable } = highlight;
    const row = rowNullable;
    const col = colNullable;
    const modifiedCellCoords = this.hot.runHooks("modifyGetCellCoords", row, col, false, "meta");
    let visualRowToCheck = row;
    let visualColumnToCheck = col;
    if (Array.isArray(modifiedCellCoords)) {
      [visualRowToCheck, visualColumnToCheck] = modifiedCellCoords;
    }
    this.cellProperties = this.hot.getCellMeta(visualRowToCheck, visualColumnToCheck);
    if (!this.isCellEditable()) {
      this.clearActiveEditor();
      return;
    }
    const td = this.hot.getCell(row, col, true);
    if (td) {
      const editorClass = this.hot.getCellEditor(this.cellProperties);
      const prop = this.hot.colToProp(visualColumnToCheck);
      const originalValue = this.hot.getSourceDataAtCell(this.hot.toPhysicalRow(visualRowToCheck), visualColumnToCheck);
      this.activeEditor = _getEditorInstance(editorClass, this.hot);
      this.activeEditor.prepare(row, col, prop, td, originalValue, this.cellProperties);
    }
  }
  /**
  * Check is editor is opened/showed.
  *
  * @returns {boolean}
  */
  isEditorOpened() {
    return this.activeEditor && this.activeEditor.isOpened();
  }
  /**
  * Open editor with initial value.
  *
  * @param {null|string} newInitialValue New value from which editor will start if handled property it's not the `null`.
  * @param {Event} event The event object.
  * @param {boolean} [enableFullEditMode=false] When true, an editor works in full editing mode. Mode disallows closing an editor
  *                                             when arrow keys are pressed.
  */
  openEditor(newInitialValue, event, enableFullEditMode = false) {
    if (!this.isCellEditable()) {
      this.clearActiveEditor();
      return;
    }
    const selection = this.hot.getSelectedRangeActive();
    let allowOpening = this.hot.runHooks("beforeBeginEditing", selection.highlight.row, selection.highlight.col, newInitialValue, event, enableFullEditMode);
    if (event instanceof MouseEvent && typeof allowOpening !== "boolean") {
      allowOpening = this.hot.selection.getLayerLevel() === 0 && selection.isSingle();
    }
    if (allowOpening === false) {
      this.clearActiveEditor();
      return;
    }
    if (!this.activeEditor) {
      this.hot.scrollToFocusedCell();
      this.prepareEditor();
    }
    if (this.activeEditor) {
      if (enableFullEditMode) {
        this.activeEditor.enableFullEditMode();
      }
      this.activeEditor.beginEditing(newInitialValue, event);
    }
  }
  /**
  * Close editor, finish editing cell.
  *
  * @param {boolean} restoreOriginalValue If `true`, then closes editor without saving value from the editor into a cell.
  * @param {boolean} isCtrlPressed If `true`, then editor will save value to each cell in the last selected range.
  * @param {Function} callback The callback function, fired after editor closing.
  */
  closeEditor(restoreOriginalValue = false, isCtrlPressed = false, callback) {
    if (this.activeEditor) {
      this.activeEditor.finishEditing(restoreOriginalValue, isCtrlPressed, callback);
    } else if (callback) {
      callback(false);
    }
  }
  /**
  * Close editor and save changes.
  *
  * @param {boolean} isCtrlPressed If `true`, then editor will save value to each cell in the last selected range.
  */
  closeEditorAndSaveChanges(isCtrlPressed) {
    this.closeEditor(false, isCtrlPressed);
  }
  /**
  * Close editor and restore original value.
  *
  * @param {boolean} isCtrlPressed Indication of whether the CTRL button is pressed.
  */
  closeEditorAndRestoreOriginalValue(isCtrlPressed) {
    this.closeEditor(true, isCtrlPressed);
  }
  /**
  * Clears reference to an instance of the active editor.
  *
  * @private
  */
  clearActiveEditor() {
    this.activeEditor = void 0;
  }
  /**
  * Checks if the currently selected cell (pointed by selection highlight coords) is editable.
  * Editable cell is when:
  *   - the cell has defined an editor type;
  *   - the cell is not marked as read-only;
  *   - the cell is not hidden.
  *
  * @private
  * @returns {boolean}
  */
  isCellEditable() {
    const selection = this.hot.getSelectedRangeActive();
    if (!selection) {
      return false;
    }
    const editorClass = this.hot.getCellEditor(this.cellProperties);
    const { row, col } = selection.highlight;
    if (row === null || col === null) {
      return false;
    }
    const { rowIndexMapper, columnIndexMapper } = this.hot;
    const isCellHidden = rowIndexMapper.isHidden(this.hot.toPhysicalRow(row)) || columnIndexMapper.isHidden(this.hot.toPhysicalColumn(col));
    if (this.cellProperties.readOnly || !editorClass || isCellHidden) {
      return false;
    }
    return true;
  }
  /**
  * Controls selection's behavior after clicking `Enter`.
  *
  * @private
  * @param {KeyboardEvent} event The keyboard event object.
  */
  moveSelectionAfterEnter(event) {
    if (!this.hot.getSelected()) {
      return;
    }
    const enterMoves = {
      ...typeof this.tableMeta.enterMoves === "function" ? this.tableMeta.enterMoves(event) : this.tableMeta.enterMoves
    };
    if (event.shiftKey) {
      enterMoves.row = -(enterMoves.row ?? 0);
      enterMoves.col = -(enterMoves.col ?? 0);
    }
    if (this.hot.selection.isMultiple()) {
      this.selection.transformFocus(enterMoves.row ?? 0, enterMoves.col ?? 0);
    } else {
      this.selection.transformStart(enterMoves.row ?? 0, enterMoves.col ?? 0, true);
    }
  }
  /**
  * Destroy the instance.
  */
  destroy() {
    this.destroyed = true;
    this.eventManager.destroy();
  }
  /**
  * @param {Core} hotInstance The Handsontable instance.
  * @param {TableMeta} tableMeta The table meta instance.
  * @param {Selection} selection The selection instance.
  */
  constructor(hotInstance, tableMeta, selection) {
    _class_private_method_init$1a(this, _onAfterDocumentKeyDown$1);
    _class_private_method_init$1a(this, _onCellDblClick);
    this.destroyed = false;
    this.hot = hotInstance;
    this.tableMeta = tableMeta;
    this.selection = selection;
    this.eventManager = new EventManager(hotInstance);
    this.hot.addHook("afterDocumentKeyDown", (event) => _class_private_method_get$1a(this, _onAfterDocumentKeyDown$1, onAfterDocumentKeyDown).call(this, event));
    this.hot.addHook("beforeCompositionStart", (event) => _class_private_method_get$1a(this, _onAfterDocumentKeyDown$1, onAfterDocumentKeyDown).call(this, event));
    this.hot.view._wt.update("onCellDblClick", (event, coords, _elem) => _class_private_method_get$1a(this, _onCellDblClick, onCellDblClick).call(this, event, coords));
  }
}
function onAfterDocumentKeyDown(event) {
  const selection = this.hot.getSelectedRangeActive();
  if (!this.hot.isListening() || !selection || selection.highlight.isHeader() || isImmediatePropagationStopped(event)) {
    return;
  }
  const { keyCode } = event;
  const isCtrlPressed = (event.ctrlKey || event.metaKey) && !event.altKey;
  if (!this.activeEditor || this.activeEditor && !this.activeEditor.isWaiting()) {
    if (!isFunctionKey(keyCode) && !isCtrlMetaKey(keyCode) && !isCtrlPressed && !this.isEditorOpened()) {
      this.openEditor("", event);
    }
  }
}
function onCellDblClick(event, coords) {
  if (coords?.isCell()) {
    if (this.hot.getShortcutManager().isCtrlPressed()) {
      this.clearActiveEditor();
    } else {
      this.openEditor(null, event, true);
    }
  }
}
const instances = /* @__PURE__ */ new WeakMap();
EditorManager.getInstance = function(hotInstance, tableMeta, selection) {
  let editorManager = instances.get(hotInstance);
  if (!editorManager) {
    editorManager = new EditorManager(hotInstance, tableMeta, selection);
    instances.set(hotInstance, editorManager);
  }
  return editorManager;
};
const ESCAPED_HTML_CHARS = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">"
};
const regEscapedChars = new RegExp(Object.keys(ESCAPED_HTML_CHARS).map((key) => `(${key})`).join("|"), "gi");
function isHTMLTable(element) {
  return (element && element.nodeName || "") === "TABLE";
}
function instanceToHTML(instance) {
  const hasColumnHeaders = instance.hasColHeaders();
  const hasRowHeaders = instance.hasRowHeaders();
  const coords = [
    hasColumnHeaders ? -1 : 0,
    hasRowHeaders ? -1 : 0,
    instance.countRows() - 1,
    instance.countCols() - 1
  ];
  const data = instance.getData(...coords);
  const countRows = data.length;
  const countCols = countRows > 0 ? data[0].length : 0;
  const TABLE = [
    "<table>",
    "</table>"
  ];
  const THEAD = hasColumnHeaders ? [
    "<thead>",
    "</thead>"
  ] : [];
  const TBODY = [
    "<tbody>",
    "</tbody>"
  ];
  const rowModifier = hasRowHeaders ? 1 : 0;
  const columnModifier = hasColumnHeaders ? 1 : 0;
  for (let row = 0; row < countRows; row += 1) {
    const isColumnHeadersRow = hasColumnHeaders && row === 0;
    const CELLS = [];
    for (let column = 0; column < countCols; column += 1) {
      const isRowHeadersColumn = !isColumnHeadersRow && hasRowHeaders && column === 0;
      let cell = "";
      if (isColumnHeadersRow) {
        cell = `<th>${instance.getColHeader(column - rowModifier)}</th>`;
      } else if (isRowHeadersColumn) {
        cell = `<th>${instance.getRowHeader(row - columnModifier)}</th>`;
      } else {
        const cellData = data[row][column];
        const { hidden, rowspan, colspan } = instance.getCellMeta(row - columnModifier, column - rowModifier);
        if (!hidden) {
          const attrs = [];
          if (rowspan) {
            attrs.push(`rowspan="${rowspan}"`);
          }
          if (colspan) {
            attrs.push(`colspan="${colspan}"`);
          }
          if (isEmpty$1(cellData)) {
            cell = `<td ${attrs.join(" ")}></td>`;
          } else {
            const value = String(cellData).replaceAll("<", "&lt;").replaceAll(">", "&gt;").replace(/(<br(\s*|\/)>(\r\n|\n)?|\r\n|\n)/g, "<br>\r\n").replace(/\x20/gi, "&nbsp;").replace(/\t/gi, "&#9;");
            cell = `<td ${attrs.join(" ")}>${value}</td>`;
          }
        }
      }
      CELLS.push(cell);
    }
    const TR = [
      "<tr>",
      ...CELLS,
      "</tr>"
    ].join("");
    if (isColumnHeadersRow) {
      THEAD.splice(1, 0, TR);
    } else {
      TBODY.splice(-1, 0, TR);
    }
  }
  TABLE.splice(1, 0, THEAD.join(""), TBODY.join(""));
  return TABLE.join("");
}
function _dataToHTML(input) {
  const inputLen = input.length;
  const result = [
    "<table>"
  ];
  for (let row = 0; row < inputLen; row += 1) {
    const rowData = input[row];
    const columnsLen = rowData.length;
    const columnsResult = [];
    if (row === 0) {
      result.push("<tbody>");
    }
    for (let column = 0; column < columnsLen; column += 1) {
      const cellData = rowData[column];
      const parsedCellData = isEmpty$1(cellData) ? "" : cellData.toString().replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replace(/(<br(\s*|\/)>(\r\n|\n)?|\r\n|\n)/g, "<br>\r\n").replace(/\x20{2,}/gi, (substring) => {
        return `<span style="mso-spacerun: yes">${"&nbsp;".repeat(substring.length - 1)} </span>`;
      }).replace(/\t/gi, "&#9;");
      columnsResult.push(`<td>${parsedCellData}</td>`);
    }
    result.push("<tr>", ...columnsResult, "</tr>");
    if (row + 1 === inputLen) {
      result.push("</tbody>");
    }
  }
  result.push("</table>");
  return result.join("");
}
const TD_OPEN = /<td\b[^>]*>/i;
const TD_CLOSE = /<\/\s*td\s*>/i;
const paragraphRegexp = /<p.*?>/g;
function findMatchingTdClose(html2, openEndIndex) {
  let depth = 1;
  let searchStart = openEndIndex;
  while (depth > 0) {
    const tail = html2.substring(searchStart);
    const openMatch = tail.match(TD_OPEN);
    const closeMatch = tail.match(TD_CLOSE);
    if (!closeMatch) {
      return null;
    }
    const closeIndex = searchStart + (closeMatch.index ?? 0);
    const closeTagLength = closeMatch[0].length;
    const openIndex = openMatch ? searchStart + (openMatch.index ?? 0) : html2.length;
    if (openIndex < closeIndex) {
      depth += 1;
      searchStart = openIndex + (openMatch?.[0].length ?? 0);
    } else {
      depth -= 1;
      if (depth === 0) {
        return {
          start: closeIndex,
          length: closeTagLength
        };
      }
      searchStart = closeIndex + closeTagLength;
    }
  }
  return null;
}
function replaceTdCellsWithTextContent(html2) {
  const result = [];
  let pos = 0;
  while (pos < html2.length) {
    const openMatch = html2.substring(pos).match(TD_OPEN);
    if (!openMatch) {
      result.push(html2.substring(pos));
      break;
    }
    const openStart = pos + (openMatch.index ?? 0);
    const openTag = openMatch[0];
    const openEnd = openStart + openTag.length;
    result.push(html2.substring(pos, openStart));
    const closeInfo = findMatchingTdClose(html2, openEnd);
    if (!closeInfo) {
      result.push(html2.substring(openStart));
      break;
    }
    const cellFragment = html2.substring(openStart, closeInfo.start + closeInfo.length);
    const contentEnd = closeInfo.start - openStart;
    let rawContent = cellFragment.substring(openTag.length, contentEnd).trim().replaceAll(/\n\s+/g, " ").replaceAll(paragraphRegexp, "\n").replace(/^\n+/, "").replaceAll(/<\/(.*)>\s+$/mg, "</$1>");
    let prev;
    do {
      prev = rawContent;
      rawContent = rawContent.replace(/<(?!br\b)[^>]+>/gi, "");
    } while (rawContent !== prev);
    rawContent = rawContent.replaceAll(/^&nbsp;$/mg, "");
    result.push(`${openTag}${rawContent}</td>`);
    pos = closeInfo.start + closeInfo.length;
  }
  return result.join("");
}
function htmlToGridSettings(element, rootDocument = document) {
  const settingsObj = {};
  const fragment = rootDocument.createDocumentFragment();
  const tempElem = rootDocument.createElement("div");
  fragment.appendChild(tempElem);
  let checkElement = element;
  if (typeof checkElement === "string") {
    const normalizedHTML = replaceTdCellsWithTextContent(checkElement);
    tempElem.insertAdjacentHTML("afterbegin", normalizedHTML);
    checkElement = tempElem.querySelector("table");
  }
  if (!checkElement || !isHTMLTable(checkElement)) {
    return;
  }
  const el = checkElement;
  const generator = tempElem.querySelector('meta[name$="enerator"]');
  const hasRowHeaders = el.querySelector("tbody th") !== null;
  const trElement = el.querySelector("tr");
  const countCols = !trElement ? 0 : Array.from(trElement.cells).reduce((cols, cell) => cols + cell.colSpan, 0) - (hasRowHeaders ? 1 : 0);
  const fixedRowsBottom = el.tFoot && Array.from(el.tFoot.rows) || [];
  const fixedRowsTop = [];
  let hasColHeaders = false;
  let thRowsLen = 0;
  let countRows = 0;
  if (el.tHead) {
    const thRows = Array.from(el.tHead.rows).filter((tr) => {
      const isDataRow = tr.querySelector("td") !== null;
      if (isDataRow) {
        fixedRowsTop.push(tr);
      }
      return !isDataRow;
    });
    thRowsLen = thRows.length;
    hasColHeaders = thRowsLen > 0;
    if (thRowsLen > 1) {
      settingsObj.nestedHeaders = Array.from(thRows).reduce((rows, row) => {
        const headersRow = Array.from(row.cells).reduce((headers, header, currentIndex) => {
          if (hasRowHeaders && currentIndex === 0) {
            return headers;
          }
          const { colSpan: colspan, innerHTML } = header;
          const nextHeader = colspan > 1 ? {
            label: innerHTML,
            colspan
          } : innerHTML;
          headers.push(nextHeader);
          return headers;
        }, []);
        rows.push(headersRow);
        return rows;
      }, []);
    } else if (hasColHeaders) {
      settingsObj.colHeaders = Array.from(thRows[0].children).reduce((headers, header, index2) => {
        if (hasRowHeaders && index2 === 0) {
          return headers;
        }
        headers.push(header.innerHTML);
        return headers;
      }, []);
    }
  }
  if (fixedRowsTop.length) {
    settingsObj.fixedRowsTop = fixedRowsTop.length;
  }
  if (fixedRowsBottom.length) {
    settingsObj.fixedRowsBottom = fixedRowsBottom.length;
  }
  const dataRows = [
    ...fixedRowsTop,
    ...Array.from(el.tBodies).reduce((sections, section) => {
      Array.from(section.rows).forEach((row) => {
        sections.push(row);
      });
      return sections;
    }, []),
    ...fixedRowsBottom
  ];
  countRows = dataRows.length;
  const dataArr = Array.from({
    length: countRows
  }, () => Array.from({
    length: countCols
  }));
  const mergeCells = [];
  const rowHeaders = [];
  for (let row = 0; row < countRows; row++) {
    const tr = dataRows[row];
    const cells = Array.from(tr.cells);
    const cellsLen = cells.length;
    for (let cellId = 0; cellId < cellsLen; cellId++) {
      const cell = cells[cellId];
      const { nodeName, innerHTML, rowSpan: rowspan, colSpan: colspan } = cell;
      const col = dataArr[row].findIndex((value) => value === void 0);
      if (nodeName === "TD") {
        if (rowspan > 1 || colspan > 1) {
          for (let rstart = row; rstart < row + rowspan; rstart++) {
            if (rstart < countRows) {
              for (let cstart = col; cstart < col + colspan; cstart++) {
                dataArr[rstart][cstart] = null;
              }
            }
          }
          const styleAttr = cell.getAttribute("style");
          const ignoreMerge = styleAttr && styleAttr.includes("mso-ignore:colspan");
          if (!ignoreMerge) {
            mergeCells.push({
              col,
              row,
              rowspan,
              colspan
            });
          }
        }
        let cellValue = "";
        if (generator && /excel/gi.test(generator.content)) {
          cellValue = innerHTML.replace(/[\r\n][\x20]{0,2}/g, " ").replace(/<br(\s*|\/)>[\r\n]?[\x20]{0,3}/gim, "\r\n");
        } else {
          cellValue = innerHTML.replace(/<br(\s*|\/)>[\r\n]?/gim, "\r\n");
        }
        dataArr[row][col] = cellValue.replace(regEscapedChars, (match) => ESCAPED_HTML_CHARS[match]);
      } else {
        rowHeaders.push(innerHTML);
      }
    }
  }
  if (mergeCells.length) {
    settingsObj.mergeCells = mergeCells;
  }
  if (rowHeaders.length) {
    settingsObj.rowHeaders = rowHeaders;
  }
  if (dataArr.length) {
    settingsObj.data = dataArr;
  }
  return settingsObj;
}
function isNumeric(value, additionalDelimiters = []) {
  if (typeof value === "number") {
    return !isNaN(value) && isFinite(value);
  } else if (typeof value === "string") {
    if (value.length === 0) {
      return false;
    } else if (value.length === 1) {
      return /\d/.test(value);
    }
    const delimiter = Array.from(/* @__PURE__ */ new Set([
      ".",
      ...additionalDelimiters
    ])).map((d) => `\\${d}`).join("|");
    return new RegExp(`^[+-]?(((${delimiter})?\\d+((${delimiter})\\d+)?(e[+-]?\\d+)?)|(0x[a-f\\d]+))$`, "i").test(value.trim());
  } else if (typeof value === "object" && value !== null) {
    return typeof value.valueOf() === "number" && !(value instanceof Date);
  }
  return false;
}
function isNumericLike(value) {
  return isNumeric(value, [
    ","
  ]);
}
function isCommaThousandsGroupedInteger(value, decimalSeparator) {
  if (decimalSeparator !== "." || typeof value !== "string") {
    return false;
  }
  return /^[+-]?[1-9]\d{0,2}(,\d{3})+$/.test(value.trim());
}
function isDotThousandsGroupedInteger(value, decimalSeparator) {
  if (decimalSeparator !== "," || typeof value !== "string") {
    return false;
  }
  return /^[+-]?[1-9]\d{0,2}(\.\d{3})+$/.test(value.trim());
}
function isDotThousandsGroupedFloat(value, decimalSeparator) {
  if (decimalSeparator !== "," || typeof value !== "string") {
    return false;
  }
  return /^[+-]?[1-9]\d{0,2}(\.\d{3})+,\d+$/.test(value.trim());
}
function rangeEach(rangeFrom, rangeTo, iteratee) {
  let index2;
  let end;
  let fn;
  if (typeof rangeTo === "function") {
    index2 = -1;
    end = rangeFrom;
    fn = rangeTo;
  } else {
    index2 = rangeFrom - 1;
    end = rangeTo;
    fn = iteratee;
  }
  while (++index2 <= end) {
    if (fn(index2) === false) {
      break;
    }
  }
}
function rangeEachReverse(rangeFrom, rangeTo, iteratee) {
  let index2 = rangeFrom + 1;
  let end;
  let fn;
  if (typeof rangeTo === "function") {
    fn = rangeTo;
    end = 0;
  } else {
    fn = iteratee;
    end = rangeTo;
  }
  while (--index2 >= end) {
    if (fn(index2) === false) {
      break;
    }
  }
}
function valueAccordingPercent(value, percent) {
  percent = Number.parseInt(percent.toString().replace("%", ""), 10);
  percent = isNaN(percent) ? 0 : percent;
  return Number.parseInt(String(value * percent / 100), 10);
}
function clamp(value, minValue, maxValue) {
  if (Math.min(value, minValue) === value) {
    return minValue;
  } else if (Math.max(value, maxValue) === value) {
    return maxValue;
  }
  return value;
}
function getParsedNumber(numericData, options = {}) {
  const { decimalSeparator } = options;
  const normalizedNumericData = numericData.trim();
  if (isCommaThousandsGroupedInteger(numericData, decimalSeparator)) {
    return Number.parseFloat(normalizedNumericData.replaceAll(",", ""));
  }
  if (isDotThousandsGroupedInteger(numericData, decimalSeparator)) {
    return Number.parseFloat(normalizedNumericData.replaceAll(".", ""));
  }
  if (isDotThousandsGroupedFloat(numericData, decimalSeparator)) {
    return Number.parseFloat(normalizedNumericData.replaceAll(".", "").replace(",", "."));
  }
  const unifiedNumericData = normalizedNumericData.replace(",", ".");
  if (isNaN(Number.parseFloat(unifiedNumericData)) === false) {
    return Number.parseFloat(unifiedNumericData);
  }
  return null;
}
function isUnsignedNumber(value) {
  return Number.isInteger(value) && typeof value === "number" && value >= 0;
}
const ASC = "asc";
const DESC = "desc";
const ORDER_MAP = /* @__PURE__ */ new Map([
  [
    ASC,
    [
      -1,
      1
    ]
  ],
  [
    DESC,
    [
      1,
      -1
    ]
  ]
]);
const DEFAULT_ERROR_PRIORITY_EXISTS = (priority) => `The priority '${priority}' is already declared in a map.`;
const DEFAULT_ERROR_PRIORITY_NAN = (priority) => `The priority '${priority}' is not a number.`;
function createPriorityMap({ errorPriorityExists, errorPriorityNaN } = {}) {
  const priorityMap = /* @__PURE__ */ new Map();
  const errorExistsFn = isFunction$1(errorPriorityExists) ? errorPriorityExists : DEFAULT_ERROR_PRIORITY_EXISTS;
  const errorNaNFn = isFunction$1(errorPriorityNaN) ? errorPriorityNaN : DEFAULT_ERROR_PRIORITY_NAN;
  function addItem(priority, item) {
    if (!isNumeric(priority)) {
      throwWithCause(String(errorNaNFn(priority)));
    }
    if (priorityMap.has(priority)) {
      throwWithCause(String(errorExistsFn(priority)));
    }
    priorityMap.set(priority, item);
  }
  function getItems2(order = ASC) {
    const [left2, right2] = ORDER_MAP.get(order) || ORDER_MAP.get(ASC);
    return [
      ...priorityMap
    ].sort((a, b) => a[0] < b[0] ? left2 : right2).map((item) => item[1]);
  }
  return {
    addItem,
    getItems: getItems2
  };
}
const DEFAULT_ERROR_ID_EXISTS = (id) => `The id '${id}' is already declared in a map.`;
function createUniqueMap({ errorIdExists } = {}) {
  const uniqueMap = /* @__PURE__ */ new Map();
  const errorFn = isFunction$1(errorIdExists) ? errorIdExists : DEFAULT_ERROR_ID_EXISTS;
  function addItem(id, item) {
    if (hasItem2(id)) {
      throwWithCause(String(errorFn(id)));
    }
    uniqueMap.set(id, item);
  }
  function removeItem(id) {
    return uniqueMap.delete(id);
  }
  function clear() {
    uniqueMap.clear();
  }
  function getId(item) {
    const [itemId] = getItems2().find(([id, element]) => {
      if (item === element) {
        return id;
      }
      return false;
    }) || [
      null
    ];
    return itemId;
  }
  function getItem2(id) {
    return uniqueMap.get(id);
  }
  function getItems2() {
    return [
      ...uniqueMap
    ];
  }
  function getValues2() {
    return [
      ...uniqueMap.values()
    ];
  }
  function hasItem2(id) {
    return uniqueMap.has(id);
  }
  return {
    addItem,
    clear,
    getId,
    getItem: getItem2,
    getItems: getItems2,
    getValues: getValues2,
    hasItem: hasItem2,
    removeItem
  };
}
const DEFAULT_ERROR_ITEM_EXISTS = (item) => `'${item}' value is already declared in a unique set.`;
function createUniqueSet({ errorItemExists } = {}) {
  const uniqueSet = /* @__PURE__ */ new Set();
  const errorFn = isFunction$1(errorItemExists) ? errorItemExists : DEFAULT_ERROR_ITEM_EXISTS;
  function addItem(item) {
    if (uniqueSet.has(item)) {
      throwWithCause(String(errorFn(item)));
    }
    uniqueSet.add(item);
  }
  function getItems2() {
    return [
      ...uniqueSet
    ];
  }
  function clear() {
    uniqueSet.clear();
  }
  return {
    addItem,
    clear,
    getItems: getItems2
  };
}
const ERROR_PLUGIN_REGISTERED = (pluginName) => `There is already registered "${pluginName}" plugin.`;
const ERROR_PRIORITY_REGISTERED = (priority) => `There is already registered plugin on priority "${priority}".`;
const ERROR_PRIORITY_NAN = (priority) => `The priority "${priority}" is not a number.`;
const priorityPluginsQueue = createPriorityMap({
  errorPriorityExists: ERROR_PRIORITY_REGISTERED,
  errorPriorityNaN: ERROR_PRIORITY_NAN
});
const uniquePluginsQueue = createUniqueSet({
  errorItemExists: ERROR_PLUGIN_REGISTERED
});
const uniquePluginsList = createUniqueMap({
  errorIdExists: ERROR_PLUGIN_REGISTERED
});
function getPluginsNames() {
  return [
    ...priorityPluginsQueue.getItems(),
    ...uniquePluginsQueue.getItems()
  ];
}
function getPlugin(pluginName) {
  const unifiedPluginName = toUpperCaseFirst(pluginName);
  return uniquePluginsList.getItem(unifiedPluginName);
}
function hasPlugin(pluginName) {
  return getPlugin(pluginName) ? true : false;
}
function registerPlugin(pluginName, pluginClass, priority) {
  const [name, klass, prio] = unifyPluginArguments(pluginName, pluginClass, priority);
  if (getPlugin(name) === void 0) {
    _registerPlugin(name, klass, prio);
  }
}
function _registerPlugin(pluginName, pluginClass, priority) {
  const unifiedPluginName = toUpperCaseFirst(pluginName);
  if (uniquePluginsList.hasItem(unifiedPluginName)) {
    throwWithCause(ERROR_PLUGIN_REGISTERED(unifiedPluginName));
  }
  if (priority === void 0) {
    uniquePluginsQueue.addItem(unifiedPluginName);
  } else {
    priorityPluginsQueue.addItem(priority, unifiedPluginName);
  }
  uniquePluginsList.addItem(unifiedPluginName, pluginClass);
}
function unifyPluginArguments(pluginName, pluginClass, priority) {
  if (typeof pluginName === "function") {
    pluginClass = pluginName;
    pluginName = pluginClass.PLUGIN_KEY;
    priority = pluginClass.PLUGIN_PRIORITY;
  }
  return [
    pluginName,
    pluginClass,
    priority
  ];
}
const { register: register$4, getItem: getItem$3, hasItem: hasItem$3, getNames: getNames$3, getValues: getValues$3 } = staticRegister("renderers");
function _getItem$2(name) {
  if (typeof name === "function") {
    return name;
  }
  if (!hasItem$3(name)) {
    throwWithCause(`No registered renderer found under "${name}" name`);
  }
  return getItem$3(name);
}
function _register$2(name, renderer) {
  if (typeof name !== "string") {
    renderer = name;
    name = name.RENDERER_TYPE;
  }
  register$4(name, renderer);
}
const { register: register$3, getItem: getItem$2, hasItem: hasItem$2, getNames: getNames$2, getValues: getValues$2 } = staticRegister("validators");
function _getItem$1(name) {
  if (typeof name === "function") {
    return name;
  }
  if (!hasItem$2(name)) {
    throwWithCause(`No registered validator found under "${name}" name`);
  }
  return getItem$2(name);
}
function _register$1(name, validator) {
  if (typeof name !== "string") {
    validator = name;
    name = name.VALIDATOR_TYPE;
  }
  register$3(name, validator);
}
class FullyVisibleColumnsCalculationType {
  /**
  * Initializes the calculation.
  */
  initialize() {
  }
  /**
  * Processes the column.
  *
  * @param {number} column The column index.
  * @param {ViewportColumnsCalculator} viewportCalculator The viewport calculator object.
  */
  process(column, viewportCalculator) {
    const { totalCalculatedWidth, zeroBasedScrollOffset, viewportWidth, columnWidth } = viewportCalculator;
    const compensatedViewportWidth = zeroBasedScrollOffset > 0 ? viewportWidth + 1 : viewportWidth;
    if (totalCalculatedWidth >= zeroBasedScrollOffset && totalCalculatedWidth + columnWidth <= zeroBasedScrollOffset + compensatedViewportWidth) {
      if (this.startColumn === null || this.startColumn === void 0) {
        this.startColumn = column;
      }
      this.endColumn = column;
    }
  }
  /**
  * Finalizes the calculation.
  *
  * @param {ViewportColumnsCalculator} viewportCalculator The viewport calculator object.
  */
  finalize(viewportCalculator) {
    const { scrollOffset, viewportWidth, inlineStartOffset, zeroBasedScrollOffset, totalColumns, needReverse, positionCache, columnWidth } = viewportCalculator;
    if (!positionCache) {
      return;
    }
    if (this.endColumn === totalColumns - 1 && needReverse) {
      this.startColumn = this.endColumn;
      while (this.startColumn > 0) {
        const calculatedViewportHeight = positionCache.getOffset(this.endColumn) + columnWidth - positionCache.getOffset(this.startColumn - 1);
        if (calculatedViewportHeight <= viewportWidth) {
          this.startColumn -= 1;
        }
        if (calculatedViewportHeight >= viewportWidth) {
          break;
        }
      }
    }
    this.startPosition = this.startColumn !== null ? positionCache.getOffset(this.startColumn) : null;
    const compensatedViewportWidth = zeroBasedScrollOffset > 0 ? viewportWidth + 1 : viewportWidth;
    const mostRightScrollOffset = scrollOffset + viewportWidth - compensatedViewportWidth;
    const inlineStartColumnOffset = this.startColumn === null ? 0 : viewportCalculator.getColumnWidth(this.startColumn);
    if (
      // the table is to the left of the viewport
      mostRightScrollOffset < -1 * inlineStartOffset || scrollOffset > positionCache.getOffset(viewportCalculator.lastProcessedIndex) || // the table is to the right of the viewport
      -1 * scrollOffset - viewportWidth > -1 * inlineStartColumnOffset
    ) {
      this.isVisibleInTrimmingContainer = false;
    } else {
      this.isVisibleInTrimmingContainer = true;
    }
    if (this.endColumn !== null && totalColumns < this.endColumn) {
      this.endColumn = totalColumns - 1;
    }
    if (this.startColumn !== null && this.endColumn !== null) {
      this.count = this.endColumn - this.startColumn + 1;
    }
  }
  constructor() {
    this.count = 0;
    this.startColumn = null;
    this.endColumn = null;
    this.startPosition = null;
    this.isVisibleInTrimmingContainer = false;
  }
}
class FullyVisibleRowsCalculationType {
  /**
  * Initializes the calculation.
  */
  initialize() {
  }
  /**
  * Processes the row.
  *
  * @param {number} row The row index.
  * @param {ViewportRowsCalculator} viewportCalculator The viewport calculator object.
  */
  process(row, viewportCalculator) {
    const { totalCalculatedHeight, zeroBasedScrollOffset, innerViewportHeight, rowHeight } = viewportCalculator;
    if (totalCalculatedHeight >= zeroBasedScrollOffset && totalCalculatedHeight + rowHeight <= innerViewportHeight) {
      if (this.startRow === null) {
        this.startRow = row;
      }
      this.endRow = row;
    }
  }
  /**
  * Finalizes the calculation.
  *
  * @param {ViewportRowsCalculator} viewportCalculator The viewport calculator object.
  */
  finalize(viewportCalculator) {
    const { scrollOffset, viewportHeight, horizontalScrollbarHeight, totalRows, needReverse, positionCache, rowHeight } = viewportCalculator;
    if (!positionCache) {
      return;
    }
    if (this.endRow === totalRows - 1 && needReverse) {
      this.startRow = this.endRow;
      while (this.startRow > 0) {
        const calculatedViewportHeight = positionCache.getOffset(this.endRow) + rowHeight - positionCache.getOffset(this.startRow - 1);
        if (calculatedViewportHeight <= viewportHeight - horizontalScrollbarHeight) {
          this.startRow -= 1;
        }
        if (calculatedViewportHeight >= viewportHeight - horizontalScrollbarHeight) {
          break;
        }
      }
    }
    this.startPosition = this.startRow !== null ? positionCache.getOffset(this.startRow) : null;
    const mostBottomScrollOffset = scrollOffset + viewportHeight - horizontalScrollbarHeight;
    const topRowOffset = this.startRow === null ? 0 : viewportCalculator.getRowHeight(this.startRow);
    if (mostBottomScrollOffset < topRowOffset || scrollOffset > positionCache.getOffset(viewportCalculator.lastProcessedIndex)) {
      this.isVisibleInTrimmingContainer = false;
    } else {
      this.isVisibleInTrimmingContainer = true;
    }
    if (this.endRow !== null && totalRows < this.endRow) {
      this.endRow = totalRows - 1;
    }
    if (this.startRow !== null && this.endRow !== null) {
      this.count = this.endRow - this.startRow + 1;
    }
  }
  constructor() {
    this.count = 0;
    this.startRow = null;
    this.endRow = null;
    this.startPosition = null;
    this.isVisibleInTrimmingContainer = false;
  }
}
class PartiallyVisibleColumnsCalculationType {
  /**
  * Initializes the calculation.
  */
  initialize() {
  }
  /**
  * Processes the column.
  *
  * @param {number} column The column index.
  * @param {ViewportColumnsCalculator} viewportCalculator The viewport calculator object.
  */
  process(column, viewportCalculator) {
    const { totalCalculatedWidth, zeroBasedScrollOffset, viewportWidth } = viewportCalculator;
    if (totalCalculatedWidth <= zeroBasedScrollOffset) {
      this.startColumn = column;
    }
    const compensatedViewportWidth = zeroBasedScrollOffset > 0 ? viewportWidth + 1 : viewportWidth;
    if (totalCalculatedWidth >= zeroBasedScrollOffset && totalCalculatedWidth <= zeroBasedScrollOffset + compensatedViewportWidth) {
      if (this.startColumn === null || this.startColumn === void 0) {
        this.startColumn = column;
      }
    }
    this.endColumn = column;
  }
  /**
  * Finalizes the calculation.
  *
  * @param {ViewportColumnsCalculator} viewportCalculator The viewport calculator object.
  */
  finalize(viewportCalculator) {
    const { scrollOffset, viewportWidth, inlineStartOffset, zeroBasedScrollOffset, totalColumns, needReverse, positionCache, columnWidth } = viewportCalculator;
    if (!positionCache) {
      return;
    }
    if (this.endColumn === totalColumns - 1 && needReverse) {
      this.startColumn = this.endColumn;
      while (this.startColumn > 0) {
        const calculatedViewportWidth = positionCache.getOffset(this.endColumn) + columnWidth - positionCache.getOffset(this.startColumn - 1);
        this.startColumn -= 1;
        if (calculatedViewportWidth > viewportWidth) {
          break;
        }
      }
    }
    this.startPosition = this.startColumn !== null ? positionCache.getOffset(this.startColumn) : null;
    const compensatedViewportWidth = zeroBasedScrollOffset > 0 ? viewportWidth + 1 : viewportWidth;
    const mostRightScrollOffset = scrollOffset + viewportWidth - compensatedViewportWidth;
    if (
      // the table is to the left of the viewport
      mostRightScrollOffset < -1 * inlineStartOffset || scrollOffset > positionCache.getOffset(viewportCalculator.lastProcessedIndex) + columnWidth || // the table is to the right of the viewport
      -1 * scrollOffset - viewportWidth > 0
    ) {
      this.isVisibleInTrimmingContainer = false;
    } else {
      this.isVisibleInTrimmingContainer = true;
    }
    if (this.endColumn !== null && totalColumns < this.endColumn) {
      this.endColumn = totalColumns - 1;
    }
    if (this.startColumn !== null && this.endColumn !== null) {
      this.count = this.endColumn - this.startColumn + 1;
    }
  }
  constructor() {
    this.count = 0;
    this.startColumn = null;
    this.endColumn = null;
    this.startPosition = null;
    this.isVisibleInTrimmingContainer = false;
  }
}
class PartiallyVisibleRowsCalculationType {
  /**
  * Initializes the calculation.
  */
  initialize() {
  }
  /**
  * Processes the row.
  *
  * @param {number} row The row index.
  * @param {ViewportRowsCalculator} viewportCalculator The viewport calculator object.
  */
  process(row, viewportCalculator) {
    const { totalCalculatedHeight, zeroBasedScrollOffset, innerViewportHeight } = viewportCalculator;
    if (totalCalculatedHeight <= zeroBasedScrollOffset) {
      this.startRow = row;
    }
    if (totalCalculatedHeight >= zeroBasedScrollOffset && totalCalculatedHeight <= innerViewportHeight) {
      if (this.startRow === null) {
        this.startRow = row;
      }
    }
    this.endRow = row;
  }
  /**
  * Finalizes the calculation.
  *
  * @param {ViewportRowsCalculator} viewportCalculator The viewport calculator object.
  */
  finalize(viewportCalculator) {
    const { scrollOffset, viewportHeight, horizontalScrollbarHeight, totalRows, needReverse, positionCache, rowHeight } = viewportCalculator;
    if (!positionCache) {
      return;
    }
    if (this.endRow === totalRows - 1 && needReverse) {
      this.startRow = this.endRow;
      while (this.startRow > 0) {
        const calculatedViewportHeight = positionCache.getOffset(this.endRow) + rowHeight - positionCache.getOffset(this.startRow - 1);
        this.startRow -= 1;
        if (calculatedViewportHeight >= viewportHeight - horizontalScrollbarHeight) {
          break;
        }
      }
    }
    this.startPosition = this.startRow !== null ? positionCache.getOffset(this.startRow) : null;
    const mostBottomScrollOffset = scrollOffset + viewportHeight - horizontalScrollbarHeight;
    if (mostBottomScrollOffset < 0 || scrollOffset > positionCache.getOffset(viewportCalculator.lastProcessedIndex) + rowHeight) {
      this.isVisibleInTrimmingContainer = false;
    } else {
      this.isVisibleInTrimmingContainer = true;
    }
    if (this.endRow !== null && totalRows < this.endRow) {
      this.endRow = totalRows - 1;
    }
    if (this.startRow !== null && this.endRow !== null) {
      this.count = this.endRow - this.startRow + 1;
    }
  }
  constructor() {
    this.count = 0;
    this.startRow = null;
    this.endRow = null;
    this.startPosition = null;
    this.isVisibleInTrimmingContainer = false;
  }
}
class RenderedAllColumnsCalculationType {
  /**
  * Initializes the calculation.
  *
  * @param {ViewportColumnsCalculator} viewportCalculator The viewport calculator object.
  */
  initialize({ totalColumns }) {
    this.count = totalColumns;
    this.endColumn = this.count - 1;
  }
  /**
  * Processes the column.
  */
  process() {
  }
  /**
  * Finalizes the calculation.
  */
  finalize() {
  }
  constructor() {
    this.count = 0;
    this.startColumn = 0;
    this.endColumn = 0;
    this.startPosition = 0;
    this.isVisibleInTrimmingContainer = true;
  }
}
class RenderedAllRowsCalculationType {
  /**
  * Initializes the calculation.
  *
  * @param {ViewportRowsCalculator} viewportCalculator The viewport calculator object.
  */
  initialize({ totalRows }) {
    this.count = totalRows;
    this.endRow = this.count - 1;
  }
  /**
  * Processes the row.
  */
  process() {
  }
  /**
  * Finalizes the calculation.
  */
  finalize() {
  }
  constructor() {
    this.count = 0;
    this.startRow = 0;
    this.endRow = 0;
    this.startPosition = 0;
    this.isVisibleInTrimmingContainer = true;
  }
}
class RenderedColumnsCalculationType extends PartiallyVisibleColumnsCalculationType {
  /**
  * Finalizes the calculation.
  *
  * @param {ViewportColumnsCalculator} viewportCalculator The viewport calculator object.
  */
  finalize(viewportCalculator) {
    super.finalize(viewportCalculator);
    const { overrideFn, totalColumns, positionCache } = viewportCalculator;
    if (this.startColumn !== null && typeof overrideFn === "function") {
      const startColumn = this.startColumn;
      const endColumn = this.endColumn;
      overrideFn(this);
      this.columnStartOffset = startColumn - this.startColumn;
      this.columnEndOffset = this.endColumn !== null && endColumn !== null ? this.endColumn - endColumn : 0;
    }
    if (this.startColumn !== null && this.startColumn < 0) {
      this.startColumn = 0;
    }
    this.startPosition = this.startColumn !== null && positionCache ? positionCache.getOffset(this.startColumn) : null;
    if (this.endColumn !== null && totalColumns < this.endColumn) {
      this.endColumn = totalColumns - 1;
    }
    if (this.startColumn !== null && this.endColumn !== null) {
      this.count = this.endColumn - this.startColumn + 1;
    }
  }
  constructor(...args) {
    super(...args), /**
    * The property holds the offset applied in the `overrideFn` function to the `startColumn` value.
    *
    * @type {number}
    */
    this.columnStartOffset = 0, /**
    * The property holds the offset applied in the `overrideFn` function to the `endColumn` value.
    *
    * @type {number}
    */
    this.columnEndOffset = 0;
  }
}
class RenderedRowsCalculationType extends PartiallyVisibleRowsCalculationType {
  /**
  * Finalizes the calculation.
  *
  * @param {ViewportRowsCalculator} viewportCalculator The viewport calculator object.
  */
  finalize(viewportCalculator) {
    super.finalize(viewportCalculator);
    const { overrideFn, totalRows, positionCache } = viewportCalculator;
    if (this.startRow !== null && typeof overrideFn === "function") {
      const startRow = this.startRow;
      const endRow = this.endRow;
      overrideFn(this);
      this.rowStartOffset = startRow - this.startRow;
      this.rowEndOffset = this.endRow !== null && endRow !== null ? this.endRow - endRow : 0;
    }
    if (this.startRow !== null && this.startRow < 0) {
      this.startRow = 0;
    }
    this.startPosition = this.startRow !== null && positionCache ? positionCache.getOffset(this.startRow) : null;
    if (this.endRow !== null && totalRows < this.endRow) {
      this.endRow = totalRows - 1;
    }
    if (this.startRow !== null && this.endRow !== null) {
      this.count = this.endRow - this.startRow + 1;
    }
  }
  constructor(...args) {
    super(...args), /**
    * The property holds the offset applied in the `overrideFn` function to the `startColumn` value.
    *
    * @type {number}
    */
    this.rowStartOffset = 0, /**
    * The property holds the offset applied in the `overrideFn` function to the `endColumn` value.
    *
    * @type {number}
    */
    this.rowEndOffset = 0;
  }
}
function calculateAxis(context, { totalCount, zeroBasedScrollOffset, scrollEnd, positionCache, setSizeField, setTotalCalculated, getTotalCalculated }) {
  context._initialize(context);
  let startIndex = 0;
  if (zeroBasedScrollOffset > 0 && totalCount > 0) {
    const cachedIndex = positionCache.findIndexAtOffset(zeroBasedScrollOffset);
    startIndex = cachedIndex;
    setTotalCalculated(context, positionCache.getOffset(startIndex));
  }
  let lastProcessedIndex = -1;
  for (let i = startIndex; i < totalCount; i++) {
    const size = positionCache.getSizeAt(i);
    setSizeField(context, size);
    context._process(i, context);
    lastProcessedIndex = i;
    setTotalCalculated(context, getTotalCalculated(context) + size);
    if (getTotalCalculated(context) >= scrollEnd) {
      context.needReverse = false;
      break;
    }
  }
  context.lastProcessedIndex = lastProcessedIndex;
  context._finalize(context);
}
class ViewportBaseCalculator {
  /**
  * Initializes all calculators (triggers all calculators before calculating the rows/columns sizes).
  *
  * @param {*} context The context object (rows or columns viewport calculator).
  */
  _initialize(context) {
    this.calculationTypes.forEach(([id, calculator]) => {
      this.calculationResults.set(id, calculator);
      calculator.initialize(context);
    });
  }
  /**
  * Processes the row/column at the given index.
  *
  * @param {number} index The index of the row/column.
  * @param {*} context The context object (rows or columns viewport calculator).
  */
  _process(index2, context) {
    this.calculationTypes.forEach(([, calculator]) => calculator.process(index2, context));
  }
  /**
  * Finalizes all calculators (triggers all calculators after calculating the rows/columns sizes).
  *
  * @param {*} context The context object (rows or columns viewport calculator).
  */
  _finalize(context) {
    this.calculationTypes.forEach(([, calculator]) => calculator.finalize(context));
  }
  /**
  * Gets the results for the given calculator.
  *
  * @param {string} calculatorId The id of the calculator.
  * @returns {ColumnsCalculationType | RowsCalculationType}
  */
  getResultsFor(calculatorId) {
    return this.calculationResults.get(calculatorId);
  }
  /**
  * Creates a new ViewportBaseCalculator instance.
  *
  * @param {Array<[string, CalculationTypeLike]>} calculationTypes - The calculation types to be performed.
  */
  constructor(calculationTypes) {
    this.calculationTypes = [];
    this.calculationResults = /* @__PURE__ */ new Map();
    this.calculationTypes = calculationTypes;
  }
}
class ViewportColumnsCalculator extends ViewportBaseCalculator {
  /**
  * Calculates viewport.
  */
  calculate() {
    if (!this.positionCache) {
      return;
    }
    calculateAxis(this, {
      totalCount: this.totalColumns,
      zeroBasedScrollOffset: this.zeroBasedScrollOffset,
      scrollEnd: this.zeroBasedScrollOffset + this.viewportWidth,
      positionCache: this.positionCache,
      setSizeField: (ctx, size) => {
        ctx.columnWidth = size;
      },
      setTotalCalculated: (ctx, v) => {
        ctx.totalCalculatedWidth = v;
      },
      getTotalCalculated: (ctx) => ctx.totalCalculatedWidth
    });
  }
  /**
  * @param {string} calculatorId The id of the calculator.
  * @returns {ColumnsCalculationType | undefined}
  */
  getResultsFor(calculatorId) {
    return this.calculationResults.get(calculatorId);
  }
  /**
  * Gets the column width at the specified column index.
  *
  * @param {number} column Column index.
  * @returns {number}
  */
  getColumnWidth(column) {
    return this.positionCache?.getSizeAt(column) ?? 0;
  }
  /**
  * @param {ViewportColumnsCalculatorOptions} options Object with all options specified for column viewport calculation.
  */
  constructor({ calculationTypes, viewportWidth, scrollOffset, totalColumns, overrideFn, inlineStartOffset, columnWidthCache }) {
    super(calculationTypes), /**
    * @type {number}
    */
    this.viewportWidth = 0, /**
    * @type {number}
    */
    this.scrollOffset = 0, /**
    * @type {number}
    */
    this.zeroBasedScrollOffset = 0, /**
    * @type {number}
    */
    this.totalColumns = 0, /**
    * @type {number}
    */
    this.columnWidth = 0, /**
    * @type {((calc: unknown) => void) | null}
    */
    this.overrideFn = null, /**
    * @type {number}
    */
    this.inlineStartOffset = 0, /**
    * @type {number}
    */
    this.totalCalculatedWidth = 0, /**
    * @type {boolean}
    */
    this.needReverse = true, /**
    * @type {PositionCache | null}
    */
    this.positionCache = null, /**
    * @type {number}
    */
    this.lastProcessedIndex = -1;
    this.viewportWidth = viewportWidth;
    this.scrollOffset = scrollOffset;
    this.zeroBasedScrollOffset = Math.max(scrollOffset, 0);
    this.totalColumns = totalColumns;
    this.overrideFn = overrideFn;
    this.inlineStartOffset = inlineStartOffset;
    this.positionCache = columnWidthCache;
    this.calculate();
  }
}
class ViewportRowsCalculator extends ViewportBaseCalculator {
  /**
  * Calculates viewport.
  */
  calculate() {
    if (!this.positionCache) {
      return;
    }
    calculateAxis(this, {
      totalCount: this.totalRows,
      zeroBasedScrollOffset: this.zeroBasedScrollOffset,
      scrollEnd: this.innerViewportHeight,
      positionCache: this.positionCache,
      setSizeField: (ctx, size) => {
        ctx.rowHeight = size;
      },
      setTotalCalculated: (ctx, v) => {
        ctx.totalCalculatedHeight = v;
      },
      getTotalCalculated: (ctx) => ctx.totalCalculatedHeight
    });
  }
  /**
  * @param {string} calculatorId The id of the calculator.
  * @returns {RowsCalculationType | undefined}
  */
  getResultsFor(calculatorId) {
    return this.calculationResults.get(calculatorId);
  }
  /**
  * Gets the row height at the specified row index.
  *
  * @param {number} row Row index.
  * @returns {number}
  */
  getRowHeight(row) {
    return this.positionCache?.getSizeAt(row) ?? 0;
  }
  /**
  * @param {ViewportRowsCalculatorOptions} options Object with all options specified for row viewport calculation.
  */
  constructor({ calculationTypes, viewportHeight, scrollOffset, totalRows, overrideFn, horizontalScrollbarHeight, rowHeightCache }) {
    super(calculationTypes), /**
    * @type {number}
    */
    this.viewportHeight = 0, /**
    * @type {number}
    */
    this.scrollOffset = 0, /**
    * @type {number}
    */
    this.zeroBasedScrollOffset = 0, /**
    * @type {number}
    */
    this.totalRows = 0, /**
    * @type {number}
    */
    this.rowHeight = 0, /**
    * @type {((calc: unknown) => void) | null}
    */
    this.overrideFn = null, /**
    * @type {number}
    */
    this.horizontalScrollbarHeight = 0, /**
    * @type {number}
    */
    this.innerViewportHeight = 0, /**
    * @type {number}
    */
    this.totalCalculatedHeight = 0, /**
    * @type {boolean}
    */
    this.needReverse = true, /**
    * @type {PositionCache | null}
    */
    this.positionCache = null, /**
    * @type {number}
    */
    this.lastProcessedIndex = -1;
    this.viewportHeight = viewportHeight;
    this.scrollOffset = scrollOffset;
    this.zeroBasedScrollOffset = Math.max(scrollOffset, 0);
    this.totalRows = totalRows;
    this.overrideFn = overrideFn;
    this.horizontalScrollbarHeight = horizontalScrollbarHeight ?? 0;
    this.innerViewportHeight = this.zeroBasedScrollOffset + this.viewportHeight - this.horizontalScrollbarHeight;
    this.positionCache = rowHeightCache;
    this.calculate();
  }
}
const DEFAULT_COLUMN_WIDTH = 50;
function _check_private_redeclaration$1F(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1q(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1q(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1q(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1q(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1q(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1q(receiver, descriptor);
}
function _class_private_field_init$1q(obj, privateMap, value) {
  _check_private_redeclaration$1F(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1q(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1q(receiver, privateMap, "set");
  _class_apply_descriptor_set$1q(receiver, descriptor, value);
  return value;
}
var _isRtl$6 = /* @__PURE__ */ new WeakMap();
class CellCoords {
  /**
  * Checks if the coordinates in your `CellCoords` instance are valid
  * in the context of given table parameters.
  *
  * The `row` index:
  * - Must be an integer.
  * - Must be higher than the number of column headers in the table.
  * - Must be lower than the total number of rows in the table.
  *
  * The `col` index:
  * - Must be an integer.
  * - Must be higher than the number of row headers in the table.
  * - Must be lower than the total number of columns in the table.
  *
  * @param {object} [tableParams] An object with a defined table size.
  * @param {number} [tableParams.countRows=0] The total number of rows.
  * @param {number} [tableParams.countCols=0] The total number of columns.
  * @param {number} [tableParams.countRowHeaders=0] A number of row headers.
  * @param {number} [tableParams.countColHeaders=0] A number of column headers.
  * @returns {boolean} `true`: The coordinates are valid.
  */
  isValid(tableParams) {
    const { countRows, countCols, countRowHeaders, countColHeaders } = {
      countRows: 0,
      countCols: 0,
      countRowHeaders: 0,
      countColHeaders: 0,
      ...tableParams
    };
    if (!Number.isInteger(this.row) || !Number.isInteger(this.col)) {
      return false;
    }
    const row = this.row;
    const col = this.col;
    if (row < -countColHeaders || col < -countRowHeaders) {
      return false;
    }
    if (row >= countRows || col >= countCols) {
      return false;
    }
    return true;
  }
  /**
  * Checks whether both row and col coordinates are set (not null).
  *
  * @returns {boolean}
  */
  isSet() {
    return this.row !== null && this.col !== null;
  }
  /**
  * Checks if another set of coordinates (`coords`)
  * is equal to the coordinates in your `CellCoords` instance.
  *
  * @param {CellCoords} coords Coordinates to check.
  * @returns {boolean}
  */
  isEqual(coords) {
    if (coords === this) {
      return true;
    }
    return this.row === coords.row && this.col === coords.col;
  }
  /**
  * Checks if the coordinates point to the headers range. If one of the axis (row or col) point to
  * the header (negative value) then method returns `true`.
  *
  * @returns {boolean}
  */
  isHeader() {
    return !this.isCell();
  }
  /**
  * Checks if the coordinates point to the cells range. If all axis (row and col) point to
  * the cell (positive value) then method returns `true`.
  *
  * @returns {boolean}
  */
  isCell() {
    return this.row !== null && this.col !== null && this.row >= 0 && this.col >= 0;
  }
  /**
  * Checks if the coordinates runs in RTL mode.
  *
  * @returns {boolean}
  */
  isRtl() {
    return _class_private_field_get$1q(this, _isRtl$6);
  }
  /**
  * Checks if another set of coordinates (`testedCoords`)
  * is south-east of the coordinates in your `CellCoords` instance.
  *
  * @param {CellCoords} testedCoords Coordinates to check.
  * @returns {boolean}
  */
  isSouthEastOf(testedCoords) {
    if (this.row === null || this.col === null || testedCoords.row === null || testedCoords.col === null) {
      return false;
    }
    const row = this.row;
    const col = this.col;
    const testedRow = testedCoords.row;
    const testedCol = testedCoords.col;
    return row >= testedRow && (_class_private_field_get$1q(this, _isRtl$6) ? col <= testedCol : col >= testedCol);
  }
  /**
  * Checks if another set of coordinates (`testedCoords`)
  * is north-west of the coordinates in your `CellCoords` instance.
  *
  * @param {CellCoords} testedCoords Coordinates to check.
  * @returns {boolean}
  */
  isNorthWestOf(testedCoords) {
    if (this.row === null || this.col === null || testedCoords.row === null || testedCoords.col === null) {
      return false;
    }
    const row = this.row;
    const col = this.col;
    const testedRow = testedCoords.row;
    const testedCol = testedCoords.col;
    return row <= testedRow && (_class_private_field_get$1q(this, _isRtl$6) ? col >= testedCol : col <= testedCol);
  }
  /**
  * Checks if another set of coordinates (`testedCoords`)
  * is south-west of the coordinates in your `CellCoords` instance.
  *
  * @param {CellCoords} testedCoords Coordinates to check.
  * @returns {boolean}
  */
  isSouthWestOf(testedCoords) {
    if (this.row === null || this.col === null || testedCoords.row === null || testedCoords.col === null) {
      return false;
    }
    const row = this.row;
    const col = this.col;
    const testedRow = testedCoords.row;
    const testedCol = testedCoords.col;
    return row >= testedRow && (_class_private_field_get$1q(this, _isRtl$6) ? col >= testedCol : col <= testedCol);
  }
  /**
  * Checks if another set of coordinates (`testedCoords`)
  * is north-east of the coordinates in your `CellCoords` instance.
  *
  * @param {CellCoords} testedCoords Coordinates to check.
  * @returns {boolean}
  */
  isNorthEastOf(testedCoords) {
    if (this.row === null || this.col === null || testedCoords.row === null || testedCoords.col === null) {
      return false;
    }
    const row = this.row;
    const col = this.col;
    const testedRow = testedCoords.row;
    const testedCol = testedCoords.col;
    return row <= testedRow && (_class_private_field_get$1q(this, _isRtl$6) ? col <= testedCol : col >= testedCol);
  }
  /**
  * Normalizes the coordinates in your `CellCoords` instance to the nearest valid position.
  *
  * Coordinates that point to headers (negative values) are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  normalize() {
    this.row = this.row === null ? this.row : Math.max(this.row, 0);
    this.col = this.col === null ? this.col : Math.max(this.col, 0);
    return this;
  }
  /**
  * Assigns the coordinates from another `CellCoords` instance (or compatible literal object)
  * to your `CellCoords` instance.
  *
  * @param {CellCoords | { row: number | undefined, col: number | undefined }} coords The CellCoords
  * instance or compatible literal object.
  * @returns {CellCoords}
  */
  assign(coords) {
    if (Number.isInteger(coords?.row)) {
      this.row = coords.row;
    }
    if (Number.isInteger(coords?.col)) {
      this.col = coords.col;
    }
    if (coords instanceof CellCoords) {
      _class_private_field_set$1q(this, _isRtl$6, coords.isRtl());
    }
    return this;
  }
  /**
  * Clones your `CellCoords` instance.
  *
  * @returns {CellCoords}
  */
  clone() {
    return new CellCoords(this.row ?? void 0, this.col ?? void 0, _class_private_field_get$1q(this, _isRtl$6));
  }
  /**
  * Converts your `CellCoords` instance into an object literal with `row` and `col` properties.
  *
  * @returns {{row: number, col: number}} An object literal with `row` and `col` properties.
  */
  toObject() {
    return {
      row: this.row,
      col: this.col
    };
  }
  /**
  * Creates a new CellCoords instance.
  *
  * @param {number} [row] A visual row index.
  * @param {number} [column] A visual column index.
  * @param {boolean} [isRtl=false] A flag which determines if the coordinates run in RTL mode.
  */
  constructor(row, column, isRtl2 = false) {
    _class_private_field_init$1q(this, _isRtl$6, {
      writable: true,
      value: void 0
    });
    this.row = null;
    this.col = null;
    _class_private_field_set$1q(this, _isRtl$6, false);
    _class_private_field_set$1q(this, _isRtl$6, isRtl2);
    if (typeof row !== "undefined") {
      this.row = row;
    }
    if (typeof column !== "undefined") {
      this.col = column;
    }
  }
}
function _check_private_redeclaration$1E(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1p(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1p(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1p(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1p(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1p(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1p(receiver, descriptor);
}
function _class_private_field_init$1p(obj, privateMap, value) {
  _check_private_redeclaration$1E(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1p(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1p(receiver, privateMap, "set");
  _class_apply_descriptor_set$1p(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$19(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$19(obj, privateSet) {
  _check_private_redeclaration$1E(obj, privateSet);
  privateSet.add(obj);
}
var _isRtl$5 = /* @__PURE__ */ new WeakMap(), _n = /* @__PURE__ */ new WeakSet();
class CellRange {
  /**
  * Highlights cell selection at the `coords` coordinates.
  *
  * @param {CellCoords} coords Coordinates to use.
  * @returns {CellRange}
  */
  setHighlight(coords) {
    this.highlight = coords.clone();
    return this;
  }
  /**
  * Sets the `coords` coordinates as the start of your range.
  *
  * @param {CellCoords} coords Coordinates to use.
  * @returns {CellRange}
  */
  setFrom(coords) {
    this.from = coords.clone();
    return this;
  }
  /**
  * Sets the `coords` coordinates as the end of your range.
  *
  * @param {CellCoords} coords Coordinates to use.
  * @returns {CellRange}
  */
  setTo(coords) {
    this.to = coords.clone();
    return this;
  }
  /**
  * Normalizes the coordinates in your `CellRange` instance to the nearest valid position.
  *
  * Coordinates that point to headers (negative values) are normalized to `0`.
  *
  * @returns {CellRange}
  */
  normalize() {
    this.highlight.normalize();
    this.from.normalize();
    this.to.normalize();
    return this;
  }
  /**
  * Checks if the coordinates in your `CellRange` instance are valid
  * in the context of given table parameters.
  *
  * See the [`isValid()`](@/api/cellCoords.md#isvalid) method of the [`CellCoords`](@/api/cellCoords.md) class.
  *
  * @param {object} tableParams An object with a defined table size.
  * @param {number} tableParams.countRows The total number of rows.
  * @param {number} tableParams.countCols The total number of columns.
  * @param {number} tableParams.countRowHeaders A number of row headers.
  * @param {number} tableParams.countColHeaders A number of column headers.
  * @returns {boolean}
  */
  isValid(tableParams) {
    return this.from.isValid(tableParams) && this.to.isValid(tableParams);
  }
  /**
  * Checks if your range is just a single cell or header.
  *
  * @returns {boolean}
  */
  isSingle() {
    return this.isSingleCell() || this.isSingleHeader();
  }
  /**
  * Checks if your range is just a single cell.
  *
  * @returns {boolean}
  */
  isSingleCell() {
    if (this.from.row === null || this.from.col === null || this.to.row === null || this.to.col === null) {
      return false;
    }
    return _class_private_method_get$19(this, _n, n).call(this, this.from.row) >= 0 && this.from.row === this.to.row && _class_private_method_get$19(this, _n, n).call(this, this.from.col) >= 0 && this.from.col === this.to.col;
  }
  /**
  * Checks if your range is just a single header.
  *
  * @returns {boolean}
  */
  isSingleHeader() {
    if (this.from.row === null || this.from.col === null || this.to.row === null || this.to.col === null) {
      return false;
    }
    return (_class_private_method_get$19(this, _n, n).call(this, this.from.row) < 0 || _class_private_method_get$19(this, _n, n).call(this, this.from.col) < 0) && this.from.row === this.to.row && this.from.col === this.to.col;
  }
  /**
  * Checks if your range covers only headers range (negative coordinates, without any cells).
  *
  * @returns {boolean}
  */
  isHeader() {
    if (this.from.isHeader() && this.to.isHeader()) {
      return true;
    }
    return _class_private_method_get$19(this, _n, n).call(this, this.from.col) < 0 && _class_private_method_get$19(this, _n, n).call(this, this.to.col) < 0 || _class_private_method_get$19(this, _n, n).call(this, this.from.row) < 0 && _class_private_method_get$19(this, _n, n).call(this, this.to.row) < 0;
  }
  /**
  * Checks if your range overlaps headers range (negative coordinates).
  *
  * @returns {boolean}
  */
  containsHeaders() {
    return this.from.isHeader() || this.to.isHeader();
  }
  /**
  * Returns the height of your range (as a number of rows, including row headers).
  *
  * @returns {number}
  */
  getOuterHeight() {
    return Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)) - Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)) + 1;
  }
  /**
  * Returns the width of your range (as a number of columns, including column headers).
  *
  * @returns {number}
  */
  getOuterWidth() {
    return Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)) - Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)) + 1;
  }
  /**
  * Returns the height of your range (as a number of rows, excluding row headers).
  *
  * @returns {number}
  */
  getHeight() {
    if (_class_private_method_get$19(this, _n, n).call(this, this.from.row) < 0 && _class_private_method_get$19(this, _n, n).call(this, this.to.row) < 0) {
      return 0;
    }
    const fromRow = Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), 0);
    const toRow = Math.max(_class_private_method_get$19(this, _n, n).call(this, this.to.row), 0);
    return Math.max(fromRow, toRow) - Math.min(fromRow, toRow) + 1;
  }
  /**
  * Returns the width of your range (as a number of columns, excluding column headers).
  *
  * @returns {number}
  */
  getWidth() {
    if (_class_private_method_get$19(this, _n, n).call(this, this.from.col) < 0 && _class_private_method_get$19(this, _n, n).call(this, this.to.col) < 0) {
      return 0;
    }
    const fromCol = Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), 0);
    const toCol = Math.max(_class_private_method_get$19(this, _n, n).call(this, this.to.col), 0);
    return Math.max(fromCol, toCol) - Math.min(fromCol, toCol) + 1;
  }
  /**
  * Returns the number of cells within your range (excluding column and row headers).
  *
  * @returns {number}
  */
  getCellsCount() {
    return this.getWidth() * this.getHeight();
  }
  /**
  * Checks if another set of coordinates (`cellCoords`)
  * is within the `from` and `to` coordinates of your range.
  *
  * @param {CellCoords} cellCoords Coordinates to check.
  * @returns {boolean}
  */
  includes(cellCoords) {
    if (this.from.row === null || this.from.col === null || this.to.row === null || this.to.col === null || cellCoords.row === null || cellCoords.col === null) {
      return false;
    }
    const row = _class_private_method_get$19(this, _n, n).call(this, cellCoords.row);
    const col = _class_private_method_get$19(this, _n, n).call(this, cellCoords.col);
    const topStart = this.getOuterTopStartCorner();
    const bottomEnd = this.getOuterBottomEndCorner();
    return _class_private_method_get$19(this, _n, n).call(this, topStart.row) <= row && _class_private_method_get$19(this, _n, n).call(this, bottomEnd.row) >= row && _class_private_method_get$19(this, _n, n).call(this, topStart.col) <= col && _class_private_method_get$19(this, _n, n).call(this, bottomEnd.col) >= col;
  }
  /**
  * Checks if another range (`cellRange`) is within your range.
  *
  * @param {CellRange} cellRange A range to check.
  * @returns {boolean}
  */
  includesRange(cellRange) {
    return this.includes(cellRange.getOuterTopStartCorner()) && this.includes(cellRange.getOuterBottomEndCorner());
  }
  /**
  * Checks if another range (`cellRange`) is equal to your range.
  *
  * @param {CellRange} cellRange A range to check.
  * @returns {boolean}
  */
  isEqual(cellRange) {
    if (this.from.row === null || this.from.col === null || this.to.row === null || this.to.col === null || cellRange.from.row === null || cellRange.from.col === null || cellRange.to.row === null || cellRange.to.col === null) {
      return false;
    }
    const fromRowMin = Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row));
    const fromRowMax = Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row));
    const fromColMin = Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col));
    const fromColMax = Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col));
    const toRowMin = Math.min(_class_private_method_get$19(this, _n, n).call(this, cellRange.from.row), _class_private_method_get$19(this, _n, n).call(this, cellRange.to.row));
    const toRowMax = Math.max(_class_private_method_get$19(this, _n, n).call(this, cellRange.from.row), _class_private_method_get$19(this, _n, n).call(this, cellRange.to.row));
    const toColMin = Math.min(_class_private_method_get$19(this, _n, n).call(this, cellRange.from.col), _class_private_method_get$19(this, _n, n).call(this, cellRange.to.col));
    const toColMax = Math.max(_class_private_method_get$19(this, _n, n).call(this, cellRange.from.col), _class_private_method_get$19(this, _n, n).call(this, cellRange.to.col));
    return fromRowMin === toRowMin && fromRowMax === toRowMax && fromColMin === toColMin && fromColMax === toColMax;
  }
  /**
  * Checks if another range (`cellRange`) overlaps your range.
  *
  * Range A overlaps range B if the intersection of A and B (or B and A) is not empty.
  *
  * @param {CellRange} cellRange A range to check.
  * @returns {boolean}
  */
  overlaps(cellRange) {
    return cellRange.isSouthEastOf(this.getOuterTopLeftCorner()) && cellRange.isNorthWestOf(this.getOuterBottomRightCorner());
  }
  /**
  * Checks if coordinates point is south-east of your range.
  *
  * @param {CellCoords} cellCoords Coordinates to check.
  * @returns {boolean}
  */
  isSouthEastOf(cellCoords) {
    return this.getOuterTopLeftCorner().isSouthEastOf(cellCoords) || this.getOuterBottomRightCorner().isSouthEastOf(cellCoords);
  }
  /**
  * Checks if coordinates point is north-west of your range.
  *
  * @param {CellRange} cellCoords Coordinates to check.
  * @returns {boolean}
  */
  isNorthWestOf(cellCoords) {
    return this.getOuterTopLeftCorner().isNorthWestOf(cellCoords) || this.getOuterBottomRightCorner().isNorthWestOf(cellCoords);
  }
  /**
  * Checks if another range (`cellRange`) overlaps your range horizontally.
  *
  * For example: returns `true` if the last column of your range is `5`
  * and the first column of the `cellRange` range is `3`.
  *
  * @param {CellRange} cellRange A range to check.
  * @returns {boolean}
  */
  isOverlappingHorizontally(cellRange) {
    return _class_private_method_get$19(this, _n, n).call(this, this.getOuterTopEndCorner().col) >= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterTopStartCorner().col) && _class_private_method_get$19(this, _n, n).call(this, this.getOuterTopEndCorner().col) <= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterTopEndCorner().col) || _class_private_method_get$19(this, _n, n).call(this, this.getOuterTopStartCorner().col) <= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterTopEndCorner().col) && _class_private_method_get$19(this, _n, n).call(this, this.getOuterTopStartCorner().col) >= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterTopStartCorner().col);
  }
  /**
  * Checks if another range (`cellRange`) overlaps your range vertically.
  *
  * For example: returns `true` if the last row of your range is `5`
  * and the first row of the `cellRange` range is `3`.
  *
  * @param {CellRange} cellRange A range to check.
  * @returns {boolean}
  */
  isOverlappingVertically(cellRange) {
    return _class_private_method_get$19(this, _n, n).call(this, this.getOuterBottomStartCorner().row) >= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterTopRightCorner().row) && _class_private_method_get$19(this, _n, n).call(this, this.getOuterBottomStartCorner().row) <= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterBottomStartCorner().row) || _class_private_method_get$19(this, _n, n).call(this, this.getOuterTopEndCorner().row) <= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterBottomStartCorner().row) && _class_private_method_get$19(this, _n, n).call(this, this.getOuterTopEndCorner().row) >= _class_private_method_get$19(this, _n, n).call(this, cellRange.getOuterTopRightCorner().row);
  }
  /**
  * Adds a cell to your range, at `cellCoords` coordinates.
  *
  * The `cellCoords` coordinates must exceed a corner of your range.
  *
  * @param {CellCoords} cellCoords A new cell's coordinates.
  * @param {boolean} [changeDirection=true] If `true`, the direction of your range is changed to the direction
  * of the `cellCoords` coordinates.
  * @returns {boolean}
  */
  expand(cellCoords, changeDirection = true) {
    const topStart = this.getOuterTopStartCorner();
    const bottomEnd = this.getOuterBottomEndCorner();
    if (_class_private_method_get$19(this, _n, n).call(this, cellCoords.row) < _class_private_method_get$19(this, _n, n).call(this, topStart.row) || _class_private_method_get$19(this, _n, n).call(this, cellCoords.col) < _class_private_method_get$19(this, _n, n).call(this, topStart.col) || _class_private_method_get$19(this, _n, n).call(this, cellCoords.row) > _class_private_method_get$19(this, _n, n).call(this, bottomEnd.row) || _class_private_method_get$19(this, _n, n).call(this, cellCoords.col) > _class_private_method_get$19(this, _n, n).call(this, bottomEnd.col)) {
      const verticalDirection = this.getVerticalDirection();
      const horizontalDirection = this.getHorizontalDirection();
      this.from = this._createCellCoords(Math.min(_class_private_method_get$19(this, _n, n).call(this, topStart.row), _class_private_method_get$19(this, _n, n).call(this, cellCoords.row)), Math.min(_class_private_method_get$19(this, _n, n).call(this, topStart.col), _class_private_method_get$19(this, _n, n).call(this, cellCoords.col)));
      this.to = this._createCellCoords(Math.max(_class_private_method_get$19(this, _n, n).call(this, bottomEnd.row), _class_private_method_get$19(this, _n, n).call(this, cellCoords.row)), Math.max(_class_private_method_get$19(this, _n, n).call(this, bottomEnd.col), _class_private_method_get$19(this, _n, n).call(this, cellCoords.col)));
      if (changeDirection) {
        if (_class_private_method_get$19(this, _n, n).call(this, cellCoords.row) < _class_private_method_get$19(this, _n, n).call(this, topStart.row) && verticalDirection === "N-S") {
          this.flipDirectionVertically();
        } else if (_class_private_method_get$19(this, _n, n).call(this, cellCoords.row) > _class_private_method_get$19(this, _n, n).call(this, bottomEnd.row) && verticalDirection === "S-N") {
          this.flipDirectionVertically();
        }
        if (_class_private_method_get$19(this, _n, n).call(this, cellCoords.col) < _class_private_method_get$19(this, _n, n).call(this, topStart.col) && horizontalDirection === "W-E") {
          this.flipDirectionHorizontally();
        } else if (_class_private_method_get$19(this, _n, n).call(this, cellCoords.col) > _class_private_method_get$19(this, _n, n).call(this, bottomEnd.col) && horizontalDirection === "E-W") {
          this.flipDirectionHorizontally();
        }
      }
      return true;
    }
    return false;
  }
  /**
  * Expand your range with another range (`expandingRange`).
  *
  * @param {CellRange} expandingRange A new range.
  * @param {boolean} [changeDirection=true] If `true`, the direction of your range is changed to the direction
  * of the `expandingRange` range.
  * @returns {boolean}
  */
  expandByRange(expandingRange, changeDirection = true) {
    if (this.includesRange(expandingRange) || !this.overlaps(expandingRange)) {
      return false;
    }
    const topStart = this.getOuterTopStartCorner();
    const bottomEnd = this.getOuterBottomEndCorner();
    const initialDirection = this.getDirection();
    const expandingTopStart = expandingRange.getOuterTopStartCorner();
    const expandingBottomEnd = expandingRange.getOuterBottomEndCorner();
    const resultTopRow = Math.min(_class_private_method_get$19(this, _n, n).call(this, topStart.row), _class_private_method_get$19(this, _n, n).call(this, expandingTopStart.row));
    const resultTopCol = Math.min(_class_private_method_get$19(this, _n, n).call(this, topStart.col), _class_private_method_get$19(this, _n, n).call(this, expandingTopStart.col));
    const resultBottomRow = Math.max(_class_private_method_get$19(this, _n, n).call(this, bottomEnd.row), _class_private_method_get$19(this, _n, n).call(this, expandingBottomEnd.row));
    const resultBottomCol = Math.max(_class_private_method_get$19(this, _n, n).call(this, bottomEnd.col), _class_private_method_get$19(this, _n, n).call(this, expandingBottomEnd.col));
    const finalFrom = this._createCellCoords(resultTopRow, resultTopCol);
    const finalTo = this._createCellCoords(resultBottomRow, resultBottomCol);
    this.from = finalFrom;
    this.to = finalTo;
    this.setDirection(initialDirection);
    if (changeDirection) {
      if (this.highlight.row === this.getOuterBottomRightCorner().row && this.getVerticalDirection() === "N-S") {
        this.flipDirectionVertically();
      }
      if (this.highlight.col === this.getOuterTopRightCorner().col && this.getHorizontalDirection() === "W-E") {
        this.flipDirectionHorizontally();
      }
    }
    return true;
  }
  /**
  * Gets the direction of the selection.
  *
  * @returns {string} Returns one of the values: `'NW-SE'`, `'NE-SW'`, `'SE-NW'`, `'SW-NE'`.
  */
  getDirection() {
    if (this.from.isNorthWestOf(this.to)) {
      return "NW-SE";
    } else if (this.from.isNorthEastOf(this.to)) {
      return "NE-SW";
    } else if (this.from.isSouthEastOf(this.to)) {
      return "SE-NW";
    } else if (this.from.isSouthWestOf(this.to)) {
      return "SW-NE";
    }
    return "NW-SE";
  }
  /**
  * Sets the direction of the selection.
  *
  * @param {string} direction One of the values: `'NW-SE'`, `'NE-SW'`, `'SE-NW'`, `'SW-NE'`.
  */
  setDirection(direction) {
    switch (direction) {
      case "NW-SE":
        [this.from, this.to] = [
          this.getOuterTopLeftCorner(),
          this.getOuterBottomRightCorner()
        ];
        break;
      case "NE-SW":
        [this.from, this.to] = [
          this.getOuterTopRightCorner(),
          this.getOuterBottomLeftCorner()
        ];
        break;
      case "SE-NW":
        [this.from, this.to] = [
          this.getOuterBottomRightCorner(),
          this.getOuterTopLeftCorner()
        ];
        break;
      case "SW-NE":
        [this.from, this.to] = [
          this.getOuterBottomLeftCorner(),
          this.getOuterTopRightCorner()
        ];
        break;
    }
  }
  /**
  * Gets the vertical direction of the selection.
  *
  * @returns {string} Returns one of the values: `N-S` (north->south), `S-N` (south->north).
  */
  getVerticalDirection() {
    return [
      "NE-SW",
      "NW-SE"
    ].indexOf(this.getDirection()) > -1 ? "N-S" : "S-N";
  }
  /**
  * Gets the horizontal direction of the selection.
  *
  * @returns {string} Returns one of the values: `W-E` (west->east), `E-W` (east->west).
  */
  getHorizontalDirection() {
    return [
      "NW-SE",
      "SW-NE"
    ].indexOf(this.getDirection()) > -1 ? "W-E" : "E-W";
  }
  /**
  * Gets the inline (horizontal) direction of the selection.
  *
  * @returns {string} Returns one of the values: `start-end`, `end-start`.
  */
  getInlineDirection() {
    return this.getHorizontalDirection() === (_class_private_field_get$1p(this, _isRtl$5) ? "E-W" : "W-E") ? "start-end" : "end-start";
  }
  /**
  * Flips the direction of your range vertically (e.g., `NW-SE` changes to `SW-NE`).
  */
  flipDirectionVertically() {
    const direction = this.getDirection();
    switch (direction) {
      case "NW-SE":
        this.setDirection("SW-NE");
        break;
      case "NE-SW":
        this.setDirection("SE-NW");
        break;
      case "SE-NW":
        this.setDirection("NE-SW");
        break;
      case "SW-NE":
        this.setDirection("NW-SE");
        break;
    }
  }
  /**
  * Flips the direction of your range horizontally (e.g., `NW-SE` changes to `NE-SW`).
  */
  flipDirectionHorizontally() {
    const direction = this.getDirection();
    switch (direction) {
      case "NW-SE":
        this.setDirection("NE-SW");
        break;
      case "NE-SW":
        this.setDirection("NW-SE");
        break;
      case "SE-NW":
        this.setDirection("SW-NE");
        break;
      case "SW-NE":
        this.setDirection("SE-NW");
        break;
    }
  }
  /**
  * Gets the top-left (in LTR) or top-right (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getTopStartCorner() {
    return this._createCellCoords(Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col))).normalize();
  }
  /**
  * Gets the top-left corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getTopLeftCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getTopEndCorner() : this.getTopStartCorner();
  }
  /**
  * Gets the bottom right (in LTR) or bottom left (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getBottomEndCorner() {
    return this._createCellCoords(Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col))).normalize();
  }
  /**
  * Gets the bottom right corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getBottomRightCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getBottomStartCorner() : this.getBottomEndCorner();
  }
  /**
  * Gets the top right (in LTR) or top left (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getTopEndCorner() {
    return this._createCellCoords(Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col))).normalize();
  }
  /**
  * Gets the top right corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getTopRightCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getTopStartCorner() : this.getTopEndCorner();
  }
  /**
  * Gets the bottom left (in LTR) or bottom right (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getBottomStartCorner() {
    return this._createCellCoords(Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col))).normalize();
  }
  /**
  * Gets the bottom left corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the corner coordinates are normalized to `0`.
  *
  * @returns {CellCoords}
  */
  getBottomLeftCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getBottomEndCorner() : this.getBottomStartCorner();
  }
  /**
  * Gets the top left (in LTR) or top right (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the top and start coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterTopStartCorner() {
    return this._createCellCoords(Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)));
  }
  /**
  * Gets the top left corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the top and left coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterTopLeftCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getOuterTopEndCorner() : this.getOuterTopStartCorner();
  }
  /**
  * Gets the bottom right (in LTR) or bottom left (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the top and start coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterBottomEndCorner() {
    return this._createCellCoords(Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)));
  }
  /**
  * Gets the bottom right corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the top and left coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterBottomRightCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getOuterBottomStartCorner() : this.getOuterBottomEndCorner();
  }
  /**
  * Gets the top right (in LTR) or top left (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the top and start coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterTopEndCorner() {
    return this._createCellCoords(Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)));
  }
  /**
  * Gets the top right corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the top and left coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterTopRightCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getOuterTopStartCorner() : this.getOuterTopEndCorner();
  }
  /**
  * Gets the bottom left (in LTR) or bottom right (in RTL) corner coordinates of your range.
  *
  * If the corner contains header coordinates (negative values),
  * the top and start coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterBottomStartCorner() {
    return this._createCellCoords(Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)), Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)));
  }
  /**
  * Gets the bottom left corner coordinates of your range,
  * both in the LTR and RTL layout direction.
  *
  * If the corner contains header coordinates (negative values),
  * the top and left coordinates are pointed to that header.
  *
  * @returns {CellCoords}
  */
  getOuterBottomLeftCorner() {
    return _class_private_field_get$1p(this, _isRtl$5) ? this.getOuterBottomEndCorner() : this.getOuterBottomStartCorner();
  }
  /**
  * Checks if a set of coordinates (`coords`) matches one of the 4 corners of your range.
  *
  * @param {CellCoords} coords Coordinates to check.
  * @returns {boolean}
  */
  isCorner(coords) {
    return coords.isEqual(this.getOuterTopLeftCorner()) || coords.isEqual(this.getOuterTopRightCorner()) || coords.isEqual(this.getOuterBottomLeftCorner()) || coords.isEqual(this.getOuterBottomRightCorner());
  }
  /**
  * Gets the coordinates of a range corner opposite to the provided `coords`.
  *
  * For example: if the `coords` coordinates match the bottom-right corner of your range,
  * the coordinates of the top-left corner of your range are returned.
  *
  * @param {CellCoords} coords Coordinates to check.
  * @returns {CellCoords}
  */
  getOppositeCorner(coords) {
    if (!(coords instanceof CellCoords)) {
      return void 0;
    }
    if (coords.isEqual(this.getOuterBottomEndCorner())) {
      return this.getOuterTopStartCorner();
    } else if (coords.isEqual(this.getOuterTopStartCorner())) {
      return this.getOuterBottomEndCorner();
    } else if (coords.isEqual(this.getOuterTopEndCorner())) {
      return this.getOuterBottomStartCorner();
    } else if (coords.isEqual(this.getOuterBottomStartCorner())) {
      return this.getOuterTopEndCorner();
    }
    return void 0;
  }
  /**
  * Indicates which borders (top, right, bottom, left) are shared between
  * your `CellRange`instance and another `range` that's within your range.
  *
  * @param {CellRange} range A range to compare with.
  * @returns {Array<'top' | 'right' | 'bottom' | 'left'>}
  */
  getBordersSharedWith(range) {
    if (!this.includesRange(range)) {
      return [];
    }
    const thisBorders = {
      top: Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)),
      bottom: Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.row), _class_private_method_get$19(this, _n, n).call(this, this.to.row)),
      left: Math.min(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col)),
      right: Math.max(_class_private_method_get$19(this, _n, n).call(this, this.from.col), _class_private_method_get$19(this, _n, n).call(this, this.to.col))
    };
    const rangeBorders = {
      top: Math.min(_class_private_method_get$19(this, _n, n).call(this, range.from.row), _class_private_method_get$19(this, _n, n).call(this, range.to.row)),
      bottom: Math.max(_class_private_method_get$19(this, _n, n).call(this, range.from.row), _class_private_method_get$19(this, _n, n).call(this, range.to.row)),
      left: Math.min(_class_private_method_get$19(this, _n, n).call(this, range.from.col), _class_private_method_get$19(this, _n, n).call(this, range.to.col)),
      right: Math.max(_class_private_method_get$19(this, _n, n).call(this, range.from.col), _class_private_method_get$19(this, _n, n).call(this, range.to.col))
    };
    const result = [];
    if (thisBorders.top === rangeBorders.top) {
      result.push("top");
    }
    if (thisBorders.right === rangeBorders.right) {
      result.push(_class_private_field_get$1p(this, _isRtl$5) ? "left" : "right");
    }
    if (thisBorders.bottom === rangeBorders.bottom) {
      result.push("bottom");
    }
    if (thisBorders.left === rangeBorders.left) {
      result.push(_class_private_field_get$1p(this, _isRtl$5) ? "right" : "left");
    }
    return result;
  }
  /**
  * Gets the coordinates of the inner cells of your range.
  *
  * @returns {CellCoords[]}
  */
  getInner() {
    const topStart = this.getOuterTopStartCorner();
    const bottomEnd = this.getOuterBottomEndCorner();
    const out = [];
    if (topStart.row === null || topStart.col === null || bottomEnd.row === null || bottomEnd.col === null) {
      return out;
    }
    const tsRow = _class_private_method_get$19(this, _n, n).call(this, topStart.row);
    const tsCol = _class_private_method_get$19(this, _n, n).call(this, topStart.col);
    const beRow = _class_private_method_get$19(this, _n, n).call(this, bottomEnd.row);
    const beCol = _class_private_method_get$19(this, _n, n).call(this, bottomEnd.col);
    for (let r = tsRow; r <= beRow; r++) {
      for (let c = tsCol; c <= beCol; c++) {
        if (!(this.from.row === r && this.from.col === c) && !(this.to.row === r && this.to.col === c)) {
          out.push(this._createCellCoords(r, c));
        }
      }
    }
    return out;
  }
  /**
  * Gets the coordinates of all cells of your range.
  *
  * @returns {CellCoords[]}
  */
  getAll() {
    const topStart = this.getOuterTopStartCorner();
    const bottomEnd = this.getOuterBottomEndCorner();
    const out = [];
    if (topStart.row === null || topStart.col === null || bottomEnd.row === null || bottomEnd.col === null) {
      return out;
    }
    const tsRow = _class_private_method_get$19(this, _n, n).call(this, topStart.row);
    const tsCol = _class_private_method_get$19(this, _n, n).call(this, topStart.col);
    const beRow = _class_private_method_get$19(this, _n, n).call(this, bottomEnd.row);
    const beCol = _class_private_method_get$19(this, _n, n).call(this, bottomEnd.col);
    for (let r = tsRow; r <= beRow; r++) {
      for (let c = tsCol; c <= beCol; c++) {
        if (tsRow === r && tsCol === c) {
          out.push(topStart);
        } else if (beRow === r && beCol === c) {
          out.push(bottomEnd);
        } else {
          out.push(this._createCellCoords(r, c));
        }
      }
    }
    return out;
  }
  /**
  * Runs a callback function on all cells within your range.
  *
  * You can break the iteration by returning `false` in the callback function.
  *
  * @param {function(number, number): boolean} callback A callback function.
  */
  forAll(callback) {
    const topStart = this.getOuterTopStartCorner();
    const bottomEnd = this.getOuterBottomEndCorner();
    if (topStart.row === null || topStart.col === null || bottomEnd.row === null || bottomEnd.col === null) {
      return;
    }
    const tsRow = _class_private_method_get$19(this, _n, n).call(this, topStart.row);
    const tsCol = _class_private_method_get$19(this, _n, n).call(this, topStart.col);
    const beRow = _class_private_method_get$19(this, _n, n).call(this, bottomEnd.row);
    const beCol = _class_private_method_get$19(this, _n, n).call(this, bottomEnd.col);
    for (let r = tsRow; r <= beRow; r++) {
      for (let c = tsCol; c <= beCol; c++) {
        const breakIteration = callback(r, c);
        if (breakIteration === false) {
          return;
        }
      }
    }
  }
  /**
  * Clones your `CellRange` instance.
  *
  * @returns {CellRange}
  */
  clone() {
    return new CellRange(this.highlight, this.from, this.to, _class_private_field_get$1p(this, _isRtl$5));
  }
  /**
  * Converts your `CellRange` instance into an object literal with the following properties:
  *
  * - `from`
  *    - `row`
  *    - `col`
  * - `to`
  *    - `row`
  *    - `col`
  *
  * @returns {{from: {row: number, col: number}, to: {row: number, col: number}}} An object literal with `from` and `to` properties.
  */
  toObject() {
    return {
      from: this.from.toObject(),
      to: this.to.toObject()
    };
  }
  /**
  * Creates and returns a new instance of the `CellCoords` class.
  *
  * The new `CellCoords` instance automatically inherits the LTR/RTL flag
  * from your `CellRange` instance.
  *
  * @private
  * @param {number | null} row A row index.
  * @param {number | null} column A column index.
  * @returns {CellCoords}
  */
  _createCellCoords(row, column) {
    return new CellCoords(row ?? void 0, column ?? void 0, _class_private_field_get$1p(this, _isRtl$5));
  }
  /**
  * Creates a new CellRange instance.
  *
  * @param {CellCoords} highlight The cell where selection was started.
  * @param {CellCoords} from The start of the range.
  * @param {CellCoords} to The end of the range.
  * @param {boolean} isRtl A flag indicating whether to use right-to-left (RTL) layout.
  */
  constructor(highlight, from = highlight, to = highlight, isRtl2 = false) {
    _class_private_method_init$19(this, _n);
    _class_private_field_init$1p(this, _isRtl$5, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1p(this, _isRtl$5, false);
    this.highlight = highlight.clone();
    this.from = from.clone();
    this.to = to.clone();
    _class_private_field_set$1p(this, _isRtl$5, isRtl2);
  }
}
function n(v) {
  return v ?? 0;
}
function findColumnAtX$1(wotInstance, row, startColumn, endColumn, relativeX) {
  let accumulatedX = 0;
  for (let column = startColumn; column <= endColumn; column++) {
    const cellElement = wotInstance.getCell({
      row,
      col: column
    }, true);
    if (!(cellElement instanceof HTMLElement)) {
      continue;
    }
    const width = cellElement.offsetWidth;
    if (relativeX < accumulatedX + width) {
      return column;
    }
    accumulatedX += width;
  }
  return null;
}
function findRowAtY$1(wotInstance, column, startRow, endRow, relativeY) {
  let accumulatedY = 0;
  for (let row = startRow; row <= endRow; row++) {
    const cellElement = wotInstance.getCell({
      row,
      col: column
    }, true);
    if (!(cellElement instanceof HTMLElement)) {
      continue;
    }
    const height = cellElement.offsetHeight;
    if (relativeY < accumulatedY + height) {
      return row;
    }
    accumulatedY += height;
  }
  return null;
}
function _check_private_redeclaration$1D(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1o(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1o(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1o(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1o(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1o(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1o(receiver, descriptor);
}
function _class_private_field_init$1o(obj, privateMap, value) {
  _check_private_redeclaration$1D(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1o(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1o(receiver, privateMap, "set");
  _class_apply_descriptor_set$1o(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$18(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$18(obj, privateSet) {
  _check_private_redeclaration$1D(obj, privateSet);
  privateSet.add(obj);
}
const LONG_PRESS_DELAY = 500;
const LONG_PRESS_MOVE_THRESHOLD = 10;
var _wtSettings = /* @__PURE__ */ new WeakMap(), _domBindings = /* @__PURE__ */ new WeakMap(), _wtTable = /* @__PURE__ */ new WeakMap(), _selectionManager = /* @__PURE__ */ new WeakMap(), _parent$1 = /* @__PURE__ */ new WeakMap(), _eventManager$1 = /* @__PURE__ */ new WeakMap(), _facadeGetter = /* @__PURE__ */ new WeakMap(), _selectedCellBeforeTouchEnd = /* @__PURE__ */ new WeakMap(), _dblClickTimeout = /* @__PURE__ */ new WeakMap(), _dblClickOrigin = /* @__PURE__ */ new WeakMap(), _longPressTimeout = /* @__PURE__ */ new WeakMap(), _longPressFired = /* @__PURE__ */ new WeakMap(), _touchStartCoords = /* @__PURE__ */ new WeakMap(), _touchWasMoved = /* @__PURE__ */ new WeakMap(), _deferredTouchStartEvent = /* @__PURE__ */ new WeakMap(), _mouseDown$2 = /* @__PURE__ */ new WeakMap(), _mouseOverOutsideLastCoords = /* @__PURE__ */ new WeakMap(), _getCellCoordsFromMousePosition = /* @__PURE__ */ new WeakSet(), _startLongPressTimer = /* @__PURE__ */ new WeakSet(), _cancelLongPressTimer = /* @__PURE__ */ new WeakSet();
let Event$1 = class Event2 {
  /**
  * Adds listeners for mouse and touch events.
  *
  * @private
  */
  registerEvents() {
    _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "contextmenu", (event) => this.onContextMenu(event));
    _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).TABLE, "mouseover", (event) => this.onMouseOver(event));
    _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).TABLE, "mouseout", (event) => this.onMouseOut(event));
    if (_class_private_field_get$1o(this, _wtTable).isMaster) {
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _domBindings).rootDocument, "mousemove", (event) => this.onMouseMove(event));
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _domBindings).rootDocument, "mouseup", () => {
        _class_private_field_set$1o(this, _mouseDown$2, false);
        _class_private_field_set$1o(this, _mouseOverOutsideLastCoords, null);
      });
    }
    const initTouchEvents = () => {
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "touchstart", (event) => this.onTouchStart(event));
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "touchend", (event) => this.onTouchEnd(event));
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "touchmove", (event) => this.onTouchMove(event));
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "scroll", () => this.onHolderScroll());
    };
    const initMouseEvents = () => {
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "mouseup", (event) => this.onMouseUp(event));
      _class_private_field_get$1o(this, _eventManager$1).addEventListener(_class_private_field_get$1o(this, _wtTable).holder, "mousedown", (event) => this.onMouseDown(event));
    };
    if (isMobileBrowser()) {
      initTouchEvents();
    } else {
      if (isTouchSupported()) {
        initTouchEvents();
      }
      initMouseEvents();
    }
  }
  /**
  * Checks if an element is already selected.
  *
  * @private
  * @param {Element} touchTarget An element to check.
  * @returns {boolean}
  */
  selectedCellWasTouched(touchTarget) {
    const cellUnderFinger = this.parentCell(touchTarget);
    const coordsOfCellUnderFinger = cellUnderFinger.coords;
    if (_class_private_field_get$1o(this, _selectedCellBeforeTouchEnd) && coordsOfCellUnderFinger) {
      const [rowTouched, rowSelected] = [
        coordsOfCellUnderFinger.row,
        _class_private_field_get$1o(this, _selectedCellBeforeTouchEnd).from.row
      ];
      const [colTouched, colSelected] = [
        coordsOfCellUnderFinger.col,
        _class_private_field_get$1o(this, _selectedCellBeforeTouchEnd).from.col
      ];
      return rowTouched === rowSelected && colTouched === colSelected;
    }
    return false;
  }
  /**
  * Gets closest TD or TH element.
  *
  * @private
  * @param {Element} elem An element from the traversing starts.
  * @returns {object} Contains coordinates and reference to TD or TH if it exists. Otherwise it's empty object.
  */
  parentCell(elem) {
    const cell = {
      coords: null,
      TD: null
    };
    const TABLE = _class_private_field_get$1o(this, _wtTable).TABLE;
    const TD = closestDown(elem, [
      "TD",
      "TH"
    ], TABLE);
    const elemEl = elem;
    if (TD) {
      cell.coords = _class_private_field_get$1o(this, _wtTable).getCoords(TD);
      cell.TD = TD;
    } else if (hasClass(elemEl, "wtBorder") && hasClass(elemEl, "current")) {
      const focusCellRange = _class_private_field_get$1o(this, _selectionManager).getFocusSelection()?.cellRange;
      if (focusCellRange) {
        cell.coords = focusCellRange.highlight;
        cell.TD = _class_private_field_get$1o(this, _wtTable).getCell(cell.coords);
      }
    } else if (hasClass(elemEl, "wtBorder") && hasClass(elemEl, "area")) {
      const areaCellRange = _class_private_field_get$1o(this, _selectionManager).getAreaSelection()?.cellRange;
      if (areaCellRange) {
        cell.coords = areaCellRange.to;
        cell.TD = _class_private_field_get$1o(this, _wtTable).getCell(cell.coords);
      }
    }
    return cell;
  }
  /**
  * OnMouseDown callback.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onMouseDown(event) {
    const activeElement = _class_private_field_get$1o(this, _domBindings).rootDocument.activeElement;
    const targetEl = eventTargetEl(event);
    const getParentNode = (level) => getParent(targetEl, level);
    const realTarget = eventTargetEl(event);
    if (activeElement && ![
      "TD",
      "TH"
    ].includes(activeElement.nodeName) && (realTarget === activeElement || getParentNode(0) === activeElement || getParentNode(1) === activeElement)) {
      return;
    }
    const cell = this.parentCell(realTarget);
    if (hasClass(realTarget, "corner")) {
      _class_private_field_get$1o(this, _wtSettings).getSetting("onCellCornerMouseDown", event, realTarget);
    } else if (cell.TD) {
      _class_private_field_set$1o(this, _mouseDown$2, true);
      _class_private_field_set$1o(this, _mouseOverOutsideLastCoords, null);
      if (_class_private_field_get$1o(this, _wtSettings).has("onCellMouseDown")) {
        this.callListener("onCellMouseDown", event, cell.coords, cell.TD);
      }
    }
    if ((event.button === 0 || this.touchApplied) && cell.TD) {
      _class_private_field_get$1o(this, _dblClickOrigin)[0] = cell.TD;
      if (_class_private_field_get$1o(this, _dblClickTimeout)[0] !== null) {
        clearTimeout(_class_private_field_get$1o(this, _dblClickTimeout)[0]);
      }
      _class_private_field_get$1o(this, _dblClickTimeout)[0] = setTimeout(() => {
        _class_private_field_get$1o(this, _dblClickOrigin)[0] = null;
      }, 1e3);
    }
  }
  /**
  * OnContextMenu callback.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onContextMenu(event) {
    _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
    if (_class_private_field_get$1o(this, _wtSettings).has("onCellContextMenu")) {
      const cell = this.parentCell(eventTargetEl(event));
      if (cell.TD) {
        this.callListener("onCellContextMenu", event, cell.coords, cell.TD);
      }
    }
  }
  /**
  * OnMouseOver callback.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onMouseOver(event) {
    if (!_class_private_field_get$1o(this, _wtSettings).has("onCellMouseOver")) {
      return;
    }
    const table = _class_private_field_get$1o(this, _wtTable).TABLE;
    const td = closestDown(eventTargetEl(event), [
      "TD",
      "TH"
    ], table);
    const parent = _class_private_field_get$1o(this, _parent$1) || this;
    if (td && td !== parent.lastMouseOver && isChildOf(td, table)) {
      parent.lastMouseOver = td;
      const tdCoords = _class_private_field_get$1o(this, _wtTable).getCoords(td);
      if (tdCoords) {
        this.callListener("onCellMouseOver", event, tdCoords, td);
      }
    }
  }
  /**
  * OnMouseMove callback.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onMouseMove(event) {
    if (!_class_private_field_get$1o(this, _mouseDown$2)) {
      return;
    }
    const { coords, isOutside } = _class_private_method_get$18(this, _getCellCoordsFromMousePosition, getCellCoordsFromMousePosition$1).call(this, event.clientX, event.clientY);
    if (isOutside) {
      const lastCoords = _class_private_field_get$1o(this, _mouseOverOutsideLastCoords);
      if (!lastCoords || lastCoords.row !== coords.row || lastCoords.col !== coords.col) {
        const TD = _class_private_field_get$1o(this, _wtTable).getCell(coords);
        if (TD instanceof HTMLElement) {
          _class_private_field_set$1o(this, _mouseOverOutsideLastCoords, {
            row: coords.row,
            col: coords.col
          });
          this.callListener("onCellMouseOverOutside", event, coords, TD);
        }
      }
    } else {
      _class_private_field_set$1o(this, _mouseOverOutsideLastCoords, null);
    }
  }
  /**
  * OnMouseOut callback.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onMouseOut(event) {
    if (!_class_private_field_get$1o(this, _wtSettings).has("onCellMouseOut")) {
      return;
    }
    const table = _class_private_field_get$1o(this, _wtTable).TABLE;
    const lastTD = closestDown(eventTargetEl(event), [
      "TD",
      "TH"
    ], table);
    const nextTD = closestDown(event.relatedTarget, [
      "TD",
      "TH"
    ], table);
    const parent = _class_private_field_get$1o(this, _parent$1) || this;
    if (lastTD && lastTD !== nextTD && isChildOf(lastTD, table)) {
      const lastTDCoords = _class_private_field_get$1o(this, _wtTable).getCoords(lastTD);
      if (lastTDCoords) {
        this.callListener("onCellMouseOut", event, lastTDCoords, lastTD);
      }
      if (nextTD === null) {
        parent.lastMouseOver = null;
      }
    }
  }
  /**
  * OnMouseUp callback.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onMouseUp(event) {
    _class_private_field_set$1o(this, _mouseDown$2, false);
    _class_private_field_set$1o(this, _mouseOverOutsideLastCoords, null);
    const cell = this.parentCell(eventTargetEl(event));
    if (cell.TD && _class_private_field_get$1o(this, _wtSettings).has("onCellMouseUp")) {
      this.callListener("onCellMouseUp", event, cell.coords, cell.TD);
    }
    if (event.button !== 0 && !this.touchApplied) {
      return;
    }
    if (cell.TD && cell.TD === _class_private_field_get$1o(this, _dblClickOrigin)[0] && cell.TD === _class_private_field_get$1o(this, _dblClickOrigin)[1]) {
      if (hasClass(eventTargetEl(event), "corner")) {
        this.callListener("onCellCornerDblClick", event, cell.coords, cell.TD);
      } else {
        this.callListener("onCellDblClick", event, cell.coords, cell.TD);
      }
      _class_private_field_get$1o(this, _dblClickOrigin)[0] = null;
      _class_private_field_get$1o(this, _dblClickOrigin)[1] = null;
    } else if (cell.TD && cell.TD === _class_private_field_get$1o(this, _dblClickOrigin)[0]) {
      _class_private_field_get$1o(this, _dblClickOrigin)[1] = cell.TD;
      if (_class_private_field_get$1o(this, _dblClickTimeout)[1] !== null) {
        clearTimeout(_class_private_field_get$1o(this, _dblClickTimeout)[1]);
      }
      _class_private_field_get$1o(this, _dblClickTimeout)[1] = setTimeout(() => {
        _class_private_field_get$1o(this, _dblClickOrigin)[1] = null;
      }, 500);
    }
  }
  /**
  * OnTouchStart callback. Captures the gesture start so the synthesized mousedown can be
  * deferred to `touchend`; this lets a touch-drag gesture scroll the grid without
  * re-triggering the cell selection (see issue #11659).
  *
  * @private
  * @param {TouchEvent} event The touch event object.
  */
  onTouchStart(event) {
    _class_private_field_set$1o(this, _selectedCellBeforeTouchEnd, _class_private_field_get$1o(this, _selectionManager).getFocusSelection()?.cellRange ?? null);
    this.touchApplied = true;
    _class_private_field_set$1o(this, _touchWasMoved, false);
    _class_private_field_set$1o(this, _longPressFired, false);
    _class_private_field_set$1o(this, _deferredTouchStartEvent, event);
    _class_private_method_get$18(this, _startLongPressTimer, startLongPressTimer).call(this, event);
  }
  /**
  * OnTouchEnd callback. Fires the deferred mousedown only when the gesture is a tap
  * (no movement past the threshold and no long-press); for a scroll gesture the
  * selection stays untouched (see issue #11659).
  *
  * @private
  * @param {TouchEvent} event The touch event object.
  */
  onTouchEnd(event) {
    const wasScrolled = _class_private_field_get$1o(this, _touchWasMoved);
    const isTap = !wasScrolled && !_class_private_field_get$1o(this, _longPressFired) && _class_private_field_get$1o(this, _deferredTouchStartEvent) !== null;
    const deferredTouchStartEvent = _class_private_field_get$1o(this, _deferredTouchStartEvent);
    _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
    _class_private_field_set$1o(this, _deferredTouchStartEvent, null);
    if (isTap && deferredTouchStartEvent !== null) {
      this.onMouseDown(deferredTouchStartEvent);
    }
    const target = eventTargetEl(event);
    const parentCellCoords = this.parentCell(target)?.coords;
    const isCellsRange = parentCellCoords !== null && parentCellCoords !== void 0 && (parentCellCoords.row ?? -1) >= 0 && (parentCellCoords.col ?? -1) >= 0;
    const isEventCancelable = event.cancelable && isCellsRange && _class_private_field_get$1o(this, _wtSettings).getSetting("isDataViewInstance");
    if (isEventCancelable) {
      const interactiveElements = [
        "A",
        "BUTTON",
        "INPUT"
      ];
      if (isIOS() && (isChromeWebKit() || isFirefoxWebKit()) && this.selectedCellWasTouched(target) && !interactiveElements.includes(target.tagName)) {
        event.preventDefault();
      } else if (!this.selectedCellWasTouched(target) && !(target.tagName === "INPUT" && target.type === "checkbox")) {
        event.preventDefault();
      }
    }
    if (!wasScrolled || _class_private_field_get$1o(this, _longPressFired)) {
      this.onMouseUp(event);
    }
    this.touchApplied = false;
    _class_private_field_set$1o(this, _touchWasMoved, false);
    _class_private_field_set$1o(this, _longPressFired, false);
  }
  /**
  * Holder `scroll` callback. Cancels the long-press timer and runs the momentum-scroll
  * bookkeeping. When called during an active touch sequence it also marks the gesture
  * as a scroll so the deferred mousedown is not fired on `touchend` - native scrolling
  * can start at ~8px, before the 10px LONG_PRESS_MOVE_THRESHOLD that `onTouchMove`
  * watches (issue #11659).
  *
  * @private
  */
  onHolderScroll() {
    if (!this.momentumScrolling) {
      this.momentumScrolling = {};
    }
    if (this.touchApplied) {
      _class_private_field_set$1o(this, _touchWasMoved, true);
    }
    _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
    clearTimeout(this.momentumScrolling._timeout);
    if (!this.momentumScrolling.ongoing) {
      _class_private_field_get$1o(this, _wtSettings).getSetting("onBeforeTouchScroll");
    }
    this.momentumScrolling.ongoing = true;
    this.momentumScrolling._timeout = setTimeout(() => {
      if (!this.touchApplied) {
        this.momentumScrolling.ongoing = false;
        _class_private_field_get$1o(this, _wtSettings).getSetting("onAfterMomentumScroll");
      }
    }, 200);
  }
  /**
  * OnTouchMove callback. Once the finger moves beyond the threshold, marks the gesture as a
  * scroll so `touchend` skips firing the deferred mousedown, and cancels the long-press timer.
  *
  * @private
  * @param {TouchEvent} event The touch event object.
  */
  onTouchMove(event) {
    if (_class_private_field_get$1o(this, _touchStartCoords) === null) {
      return;
    }
    const touch = event.touches[0];
    if (!touch) {
      _class_private_field_set$1o(this, _touchWasMoved, true);
      _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
      return;
    }
    const dx = Math.abs(touch.clientX - _class_private_field_get$1o(this, _touchStartCoords).x);
    const dy = Math.abs(touch.clientY - _class_private_field_get$1o(this, _touchStartCoords).y);
    if (dx > LONG_PRESS_MOVE_THRESHOLD || dy > LONG_PRESS_MOVE_THRESHOLD) {
      _class_private_field_set$1o(this, _touchWasMoved, true);
      _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
    }
  }
  /**
  * Call listener with backward compatibility.
  *
  * @private
  * @param {string} name Name of listener.
  * @param {MouseEvent} event The event object.
  * @param {CellCoords} coords Coordinates.
  * @param {HTMLElement} target Event target.
  */
  callListener(name, event, coords, target) {
    const listener = _class_private_field_get$1o(this, _wtSettings).getSettingPure(name);
    if (listener) {
      listener(event, coords, target, _class_private_field_get$1o(this, _facadeGetter).call(this));
    }
  }
  /**
  * Clears double-click timeouts and destroys the internal eventManager instance.
  */
  destroy() {
    if (_class_private_field_get$1o(this, _dblClickTimeout)[0] !== null) {
      clearTimeout(_class_private_field_get$1o(this, _dblClickTimeout)[0]);
    }
    if (_class_private_field_get$1o(this, _dblClickTimeout)[1] !== null) {
      clearTimeout(_class_private_field_get$1o(this, _dblClickTimeout)[1]);
    }
    _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
    if (this.momentumScrolling) {
      clearTimeout(this.momentumScrolling._timeout);
    }
    _class_private_field_get$1o(this, _eventManager$1).destroy();
  }
  /**
  * @param {FacadeGetter} facadeGetter Gets an instance facade.
  * @param {DomBindings} domBindings Bindings into dom.
  * @param {Settings} wtSettings The walkontable settings.
  * @param {EventManager} eventManager The walkontable event manager.
  * @param {Table} wtTable The table.
  * @param {SelectionManager} selectionManager Selections.
  * @param {Event} [parent=null] The main Event instance.
  */
  constructor(facadeGetter, domBindings, wtSettings, eventManager, wtTable, selectionManager, parent = null) {
    _class_private_method_init$18(this, _getCellCoordsFromMousePosition);
    _class_private_method_init$18(this, _startLongPressTimer);
    _class_private_method_init$18(this, _cancelLongPressTimer);
    _class_private_field_init$1o(this, _wtSettings, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _domBindings, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _wtTable, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _selectionManager, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _parent$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _eventManager$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _facadeGetter, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _selectedCellBeforeTouchEnd, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _dblClickTimeout, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _dblClickOrigin, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _longPressTimeout, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _longPressFired, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _touchStartCoords, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _touchWasMoved, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _deferredTouchStartEvent, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _mouseDown$2, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1o(this, _mouseOverOutsideLastCoords, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1o(this, _selectedCellBeforeTouchEnd, null);
    _class_private_field_set$1o(this, _dblClickTimeout, [
      null,
      null
    ]);
    _class_private_field_set$1o(this, _dblClickOrigin, [
      null,
      null
    ]);
    _class_private_field_set$1o(this, _longPressTimeout, null);
    _class_private_field_set$1o(this, _longPressFired, false);
    _class_private_field_set$1o(this, _touchStartCoords, null);
    _class_private_field_set$1o(this, _touchWasMoved, false);
    _class_private_field_set$1o(this, _deferredTouchStartEvent, null);
    _class_private_field_set$1o(this, _mouseDown$2, false);
    _class_private_field_set$1o(this, _mouseOverOutsideLastCoords, null);
    _class_private_field_set$1o(this, _wtSettings, wtSettings);
    _class_private_field_set$1o(this, _domBindings, domBindings);
    _class_private_field_set$1o(this, _wtTable, wtTable);
    _class_private_field_set$1o(this, _selectionManager, selectionManager);
    _class_private_field_set$1o(this, _parent$1, parent);
    _class_private_field_set$1o(this, _eventManager$1, eventManager);
    _class_private_field_set$1o(this, _facadeGetter, facadeGetter);
    this.registerEvents();
  }
};
function getCellCoordsFromMousePosition$1(mouseX, mouseY) {
  const isRtl2 = _class_private_field_get$1o(this, _wtSettings).getSetting("rtlMode");
  const wot = _class_private_field_get$1o(this, _facadeGetter).call(this);
  const numberOfFixedColumnsStart = _class_private_field_get$1o(this, _wtSettings).getSetting("fixedColumnsStart");
  const numberOfFixedRowsTop = _class_private_field_get$1o(this, _wtSettings).getSetting("fixedRowsTop");
  const numberOfFixedRowsBottom = _class_private_field_get$1o(this, _wtSettings).getSetting("fixedRowsBottom");
  const firstPartiallyVisibleRow = wot.wtScroll.getFirstPartiallyVisibleRow();
  const lastPartiallyVisibleRow = wot.wtScroll.getLastPartiallyVisibleRow();
  const firstPartiallyVisibleColumn = wot.wtScroll.getFirstPartiallyVisibleColumn();
  const lastPartiallyVisibleColumn = wot.wtScroll.getLastPartiallyVisibleColumn();
  const tableOffset = _class_private_field_get$1o(this, _wtTable).wtRootElement.getBoundingClientRect();
  const columnHeaderHeight = _class_private_field_get$1o(this, _wtSettings).getSetting("columnHeaders").length > 0 ? wot.wtViewport.getColumnHeaderHeight() : 0;
  const rowHeaderWidth = _class_private_field_get$1o(this, _wtSettings).getSetting("rowHeaders").length > 0 ? wot.wtViewport.getRowHeaderWidth() : 0;
  const { rootWindow } = _class_private_field_get$1o(this, _domBindings);
  const tableViewportLeft = wot.wtViewport.isHorizontallyScrollableByWindow() ? Math.min(0, tableOffset.left) : tableOffset.left;
  const tableViewportTop = wot.wtViewport.isVerticallyScrollableByWindow() ? Math.min(0, tableOffset.top) : tableOffset.top;
  const tableViewportRight = wot.wtViewport.isHorizontallyScrollableByWindow() ? rootWindow.innerWidth : tableOffset.left + wot.wtViewport.getViewportWidth() + rowHeaderWidth;
  const tableViewportBottom = wot.wtViewport.isVerticallyScrollableByWindow() ? rootWindow.innerHeight : tableOffset.top + wot.wtViewport.getViewportHeight() + columnHeaderHeight;
  const clampedX = clamp(mouseX, tableViewportLeft, tableViewportRight);
  const clampedY = clamp(mouseY, tableViewportTop, tableViewportBottom);
  let foundColumn = null;
  if (numberOfFixedColumnsStart > 0) {
    const fixedCell = wot.getCell({
      row: firstPartiallyVisibleRow,
      col: 0
    }, true);
    if (fixedCell instanceof HTMLElement) {
      const fixedCellRect = fixedCell.getBoundingClientRect();
      const fixedRelativeX = isRtl2 ? fixedCellRect.right - clampedX : clampedX - fixedCellRect.left;
      foundColumn = findColumnAtX$1(wot, firstPartiallyVisibleRow, 0, numberOfFixedColumnsStart - 1, fixedRelativeX);
    }
  }
  if (foundColumn === null) {
    const scrollCell = wot.getCell({
      row: firstPartiallyVisibleRow,
      col: firstPartiallyVisibleColumn
    }, true);
    if (scrollCell instanceof HTMLElement) {
      const scrollCellRect = scrollCell.getBoundingClientRect();
      const scrollRelativeX = isRtl2 ? scrollCellRect.right - clampedX : clampedX - scrollCellRect.left;
      foundColumn = findColumnAtX$1(wot, firstPartiallyVisibleRow, firstPartiallyVisibleColumn, lastPartiallyVisibleColumn, scrollRelativeX);
      if (foundColumn === null) {
        foundColumn = scrollRelativeX < 0 ? firstPartiallyVisibleColumn : lastPartiallyVisibleColumn;
      }
    } else {
      foundColumn = firstPartiallyVisibleColumn;
    }
  }
  let foundRow = null;
  if (numberOfFixedRowsTop > 0) {
    const fixedCell = wot.getCell({
      row: 0,
      col: firstPartiallyVisibleColumn
    }, true);
    if (fixedCell instanceof HTMLElement) {
      const fixedCellRect = fixedCell.getBoundingClientRect();
      const fixedRelativeY = clampedY - fixedCellRect.top;
      foundRow = findRowAtY$1(wot, firstPartiallyVisibleColumn, 0, numberOfFixedRowsTop - 1, fixedRelativeY);
    }
  }
  if (foundRow === null && numberOfFixedRowsBottom > 0) {
    const totalRows = _class_private_field_get$1o(this, _wtSettings).getSetting("totalRows");
    const bottomStartRow = totalRows - numberOfFixedRowsBottom;
    const bottomEndRow = totalRows - 1;
    const fixedBottomCell = wot.getCell({
      row: bottomStartRow,
      col: firstPartiallyVisibleColumn
    }, true);
    if (fixedBottomCell instanceof HTMLElement) {
      const fixedBottomCellRect = fixedBottomCell.getBoundingClientRect();
      const fixedBottomRelativeY = clampedY - fixedBottomCellRect.top;
      if (fixedBottomRelativeY >= 0) {
        foundRow = findRowAtY$1(wot, firstPartiallyVisibleColumn, bottomStartRow, bottomEndRow, fixedBottomRelativeY);
        if (foundRow === null) {
          foundRow = bottomEndRow;
        }
      }
    }
  }
  if (foundRow === null) {
    const scrollCell = wot.getCell({
      row: firstPartiallyVisibleRow,
      col: firstPartiallyVisibleColumn
    }, true);
    if (scrollCell instanceof HTMLElement) {
      const scrollCellRect = scrollCell.getBoundingClientRect();
      const scrollRelativeY = clampedY - scrollCellRect.top;
      foundRow = findRowAtY$1(wot, firstPartiallyVisibleColumn, firstPartiallyVisibleRow, lastPartiallyVisibleRow, scrollRelativeY);
      if (foundRow === null) {
        foundRow = lastPartiallyVisibleRow;
      }
    } else {
      foundRow = firstPartiallyVisibleRow;
    }
  }
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    coords: wot.createCellCoords(foundRow, foundColumn),
    isOutside: mouseX < tableViewportLeft || mouseX > tableViewportRight || mouseY < tableViewportTop || mouseY > tableViewportBottom
  };
}
function startLongPressTimer(event) {
  _class_private_method_get$18(this, _cancelLongPressTimer, cancelLongPressTimer).call(this);
  const touch = event.touches[0];
  if (!touch) {
    return;
  }
  _class_private_field_set$1o(this, _touchStartCoords, {
    x: touch.clientX,
    y: touch.clientY
  });
  _class_private_field_set$1o(this, _longPressTimeout, setTimeout(() => {
    _class_private_field_set$1o(this, _longPressTimeout, null);
    _class_private_field_set$1o(this, _longPressFired, true);
    _class_private_field_set$1o(this, _touchStartCoords, null);
    this.onMouseDown(event);
    _class_private_field_get$1o(this, _dblClickOrigin)[0] = null;
    _class_private_field_get$1o(this, _dblClickOrigin)[1] = null;
    if (_class_private_field_get$1o(this, _dblClickTimeout)[0] !== null) {
      clearTimeout(_class_private_field_get$1o(this, _dblClickTimeout)[0]);
    }
    if (_class_private_field_get$1o(this, _dblClickTimeout)[1] !== null) {
      clearTimeout(_class_private_field_get$1o(this, _dblClickTimeout)[1]);
    }
    const target = event.target;
    if (!target) {
      return;
    }
    const contextMenuEvent = new MouseEvent("contextmenu", {
      bubbles: true,
      cancelable: true,
      clientX: touch.clientX,
      clientY: touch.clientY,
      screenX: touch.screenX,
      screenY: touch.screenY
    });
    target.dispatchEvent(contextMenuEvent);
  }, LONG_PRESS_DELAY));
}
function cancelLongPressTimer() {
  if (_class_private_field_get$1o(this, _longPressTimeout) !== null) {
    clearTimeout(_class_private_field_get$1o(this, _longPressTimeout));
    _class_private_field_set$1o(this, _longPressTimeout, null);
  }
  _class_private_field_set$1o(this, _touchStartCoords, null);
}
class ColumnFilter {
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  offsetted(index2) {
    return index2 + this.offset;
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  unOffsetted(index2) {
    return index2 - this.offset;
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  renderedToSource(index2) {
    return this.offsetted(index2);
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  sourceToRendered(index2) {
    return this.unOffsetted(index2);
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  offsettedTH(index2) {
    return index2 - this.countTH;
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  unOffsettedTH(index2) {
    return index2 + this.countTH;
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  visibleRowHeadedColumnToSourceColumn(index2) {
    return this.renderedToSource(this.offsettedTH(index2));
  }
  /**
  * @param {number} index The visual column index.
  * @returns {number}
  */
  sourceColumnToVisibleRowHeadedColumn(index2) {
    return this.unOffsettedTH(this.sourceToRendered(index2));
  }
  /**
  * @param {number} offset The scroll horizontal offset.
  * @param {number} total The total width of the table.
  * @param {number} countTH The number of rendered row headers.
  */
  constructor(offset2, total, countTH) {
    this.offset = offset2;
    this.total = total;
    this.countTH = countTH;
  }
}
class RowFilter {
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  offsetted(index2) {
    return index2 + this.offset;
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  unOffsetted(index2) {
    return index2 - this.offset;
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  renderedToSource(index2) {
    return this.offsetted(index2);
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  sourceToRendered(index2) {
    return this.unOffsetted(index2);
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  offsettedTH(index2) {
    return index2 - this.countTH;
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  unOffsettedTH(index2) {
    return index2 + this.countTH;
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  visibleColHeadedRowToSourceRow(index2) {
    return this.renderedToSource(this.offsettedTH(index2));
  }
  /**
  * @param {number} index The visual row index.
  * @returns {number}
  */
  sourceRowToVisibleColHeadedRow(index2) {
    return this.unOffsettedTH(this.sourceToRendered(index2));
  }
  /**
  * @param {number} offset The scroll vertical offset.
  * @param {number} total The total height of the table.
  * @param {number} countTH The number of rendered column headers.
  */
  constructor(offset2, total, countTH) {
    this.offset = offset2;
    this.total = total;
    this.countTH = countTH;
  }
}
class ViewSize {
  /**
  * Sets new size of the rendered DOM elements.
  *
  * @param {number} size The size.
  */
  setSize(size) {
    this.nextSize = size;
  }
  /**
  * Sets new offset.
  *
  * @param {number} offset The offset.
  */
  setOffset(offset2) {
    this.nextOffset = offset2;
  }
  constructor() {
    this.nextSize = 0;
    this.nextOffset = 0;
  }
}
const WORKING_SPACE_ALL = 0;
const WORKING_SPACE_TOP = 1;
const WORKING_SPACE_BOTTOM = 2;
class ViewSizeSet {
  /**
  * Sets the size for rendered elements. It can be a size for rows, cells or size for row
  * headers etc.
  *
  * @param {number} size The size.
  */
  setSize(size) {
    this.size.setSize(size);
  }
  /**
  * Sets the offset for rendered elements. The offset describes the shift between 0 and
  * the first rendered element according to the scroll position.
  *
  * @param {number} offset The offset.
  */
  setOffset(offset2) {
    this.size.setOffset(offset2);
  }
  /**
  * Returns ViewSize instance.
  *
  * @returns {ViewSize}
  */
  getViewSize() {
    return this.size;
  }
  /**
  * Checks if this ViewSizeSet is sharing the size with another instance.
  *
  * @returns {boolean}
  */
  isShared() {
    return this.sharedSize !== null;
  }
  /**
  * Checks what working space describes this size instance.
  *
  * @param {number} workingSpace The number which describes the type of the working space (see constants.js).
  * @returns {boolean}
  */
  isPlaceOn(workingSpace) {
    return this.workingSpace === workingSpace;
  }
  /**
  * Appends the ViewSizeSet instance to this instance that turns it into a shared mode.
  *
  * @param {ViewSizeSet} viewSize The instance of the ViewSizeSet class.
  */
  append(viewSize) {
    this.workingSpace = WORKING_SPACE_TOP;
    viewSize.workingSpace = WORKING_SPACE_BOTTOM;
    this.sharedSize = viewSize.getViewSize();
  }
  /**
  * Prepends the ViewSize instance to this instance that turns it into a shared mode.
  *
  * @param {ViewSizeSet} viewSize The instance of the ViewSizeSet class.
  */
  prepend(viewSize) {
    this.workingSpace = WORKING_SPACE_BOTTOM;
    viewSize.workingSpace = WORKING_SPACE_TOP;
    this.sharedSize = viewSize.getViewSize();
  }
  constructor() {
    this.size = new ViewSize();
    this.workingSpace = WORKING_SPACE_ALL;
    this.sharedSize = null;
  }
}
class OrderView {
  /**
  * Sets the size for rendered elements. It can be a size for rows, cells or size for row
  * headers etc. It depends for what table renderer this instance was created.
  *
  * @param {number} size The size.
  * @returns {OrderView}
  */
  setSize(size) {
    this.sizeSet.setSize(size);
    return this;
  }
  /**
  * Sets the offset for rendered elements. The offset describes the shift between 0 and
  * the first rendered element according to the scroll position.
  *
  * @param {number} offset The offset.
  * @returns {OrderView}
  */
  setOffset(offset2) {
    this.sizeSet.setOffset(offset2);
    return this;
  }
  /**
  * Checks if this instance of the view shares the root node with another instance. This happens only once when
  * a row (TR) as a root node is managed by two OrderView instances. If this happens another DOM injection
  * algorithm is performed to achieve consistent order.
  *
  * @returns {boolean}
  */
  isSharedViewSet() {
    return this.sizeSet.isShared();
  }
  /**
  * Returns rendered DOM element based on visual index.
  *
  * @param {number} visualIndex The visual index.
  * @returns {HTMLElement}
  */
  getNode(visualIndex) {
    return visualIndex < this.collectedNodes.length ? this.collectedNodes[visualIndex] : null;
  }
  /**
  * Returns currently processed DOM element.
  *
  * @returns {HTMLElement}
  */
  getCurrentNode() {
    const length = this.collectedNodes.length;
    return length > 0 ? this.collectedNodes[length - 1] : null;
  }
  /**
  * Returns the count of children in the root node that belong to this view (for shared root nodes
  * only the children matching this view's node type and working space are counted).
  *
  * @returns {number}
  */
  getRenderedChildCount() {
    const { rootNode, sizeSet } = this;
    let childElementCount = 0;
    if (this.isSharedViewSet()) {
      let element = rootNode.firstElementChild;
      while (element) {
        if (element.tagName === this.childNodeType) {
          childElementCount += 1;
        } else if (sizeSet.isPlaceOn(WORKING_SPACE_TOP)) {
          break;
        }
        element = element.nextElementSibling;
      }
    } else {
      childElementCount = rootNode.childElementCount;
    }
    return childElementCount;
  }
  /**
  * Setups and prepares all necessary properties and starts the rendering process. It adjusts the
  * number of children in the root node to the next view size, creating or removing nodes as needed.
  * This method has to be called only once (at the start) for the render cycle.
  */
  start() {
    this.collectedNodes.length = 0;
    this.visualIndex = 0;
    const { rootNode, sizeSet } = this;
    const isShared = this.isSharedViewSet();
    const { nextSize } = sizeSet.getViewSize();
    let childElementCount = this.getRenderedChildCount();
    while (childElementCount < nextSize) {
      const newNode = this.nodesPool();
      if (!isShared || sizeSet.isPlaceOn(WORKING_SPACE_BOTTOM)) {
        rootNode.appendChild(newNode);
      } else {
        rootNode.insertBefore(newNode, rootNode.firstChild);
      }
      childElementCount += 1;
    }
    const isSharedPlacedOnTop = isShared && sizeSet.isPlaceOn(WORKING_SPACE_TOP);
    while (childElementCount > nextSize) {
      const childToRemove = isSharedPlacedOnTop ? rootNode.firstChild : rootNode.lastChild;
      if (childToRemove) {
        rootNode.removeChild(childToRemove);
      }
      childElementCount -= 1;
    }
  }
  /**
  * Renders the DOM element for the current visual index by reusing the child already in place.
  * If a child of the wrong node type occupies the slot, it is replaced with a freshly created one.
  * This method has to be called as many times as the size count is met (to cover all previously rendered DOM elements).
  */
  render() {
    const { rootNode, sizeSet } = this;
    let visualIndex = this.visualIndex;
    if (this.isSharedViewSet() && sizeSet.isPlaceOn(WORKING_SPACE_BOTTOM) && sizeSet.sharedSize) {
      visualIndex += sizeSet.sharedSize.nextSize;
    }
    let node = rootNode.children[visualIndex];
    if (!node) {
      node = this.nodesPool();
      rootNode.appendChild(node);
    } else if (node.tagName !== this.childNodeType) {
      const newNode = this.nodesPool();
      node.replaceWith(newNode);
      node = newNode;
    }
    this.collectedNodes.push(node);
    this.visualIndex += 1;
  }
  /**
  * Ends the render process. No cleanup is required — all work is done in `start()` and `render()`.
  */
  end() {
  }
  /**
  * Creates a new OrderView instance.
  *
  * @param {HTMLElement} rootNode The root node to manage.
  * @param {function(): HTMLElement} nodesPool Factory for creating new DOM elements.
  * @param {string} childNodeType The type of child nodes to manage.
  */
  constructor(rootNode, nodesPool, childNodeType) {
    this.sizeSet = new ViewSizeSet();
    this.collectedNodes = [];
    this.visualIndex = 0;
    this.rootNode = rootNode;
    this.nodesPool = nodesPool;
    this.childNodeType = typeof childNodeType === "string" ? childNodeType.toUpperCase() : childNodeType;
  }
}
class SharedOrderView extends OrderView {
  /**
  * The method results in merging external order view into the current order. This happens only for order views which
  * operate on the same root node.
  *
  * In the table, there is only one scenario when this happens. TR root element
  * has a common root node with cells order view and row headers order view. Both classes have to share
  * information about their order sizes to make proper diff calculations.
  *
  * @param {OrderView} orderView The order view to merging with. The view will be added at the beginning of the list.
  * @returns {SharedOrderView}
  */
  prependView(orderView) {
    this.sizeSet.prepend(orderView.sizeSet);
    orderView.sizeSet.append(this.sizeSet);
    return this;
  }
  /**
  * The method results in merging external order view into the current order. This happens only for order views which
  * operate on the same root node.
  *
  * In the table, there is only one scenario when this happens. TR root element
  * has a common root node with cells order view and row headers order view. Both classes have to share
  * information about their order sizes to make proper diff calculations.
  *
  * @param {OrderView} orderView The order view to merging with. The view will be added at the end of the list.
  * @returns {SharedOrderView}
  */
  appendView(orderView) {
    this.sizeSet.append(orderView.sizeSet);
    orderView.sizeSet.prepend(this.sizeSet);
    return this;
  }
}
class NodesPool {
  /**
  * Set document owner for this instance.
  *
  * @param {Document} rootDocument The document window owner.
  */
  setRootDocument(rootDocument) {
    this.rootDocument = rootDocument;
  }
  /**
  * Creates and returns a new DOM element of the configured node type. The row/column arguments are
  * accepted for backward compatibility with the renderer factories and are ignored.
  *
  * @param {number} [_rowIndex] Ignored. Kept for call-site compatibility.
  * @param {number} [_columnIndex] Ignored. Kept for call-site compatibility.
  * @returns {HTMLElement}
  */
  obtain(_rowIndex, _columnIndex) {
    return this.rootDocument.createElement(this.nodeType);
  }
  /**
  * Creates a new NodesPool instance.
  *
  * @param {string} nodeType The type of DOM node to generate (e.g. 'TH', 'TD').
  */
  constructor(nodeType) {
    this.nodeType = nodeType.toUpperCase();
  }
}
class BaseRenderer {
  /**
  * Sets the table renderer instance to the current renderer.
  *
  * @param {TableRenderer} table The TableRenderer instance.
  */
  setTable(table) {
    if (this.nodesPool) {
      this.nodesPool.setRootDocument(table.rootDocument);
    }
    this.table = table;
  }
  /**
  * Renders the contents to the elements.
  */
  render() {
  }
  /**
  * Creates a new BaseRenderer instance.
  *
  * @param {string | null} nodeType - The node type which the renderer will manage while building the table (eg. 'TD', 'TR', 'TH'), or null.
  * @param {HTMLElement} rootNode - The root node to which newly created elements will be inserted.
  */
  constructor(nodeType, rootNode) {
    this.nodesPool = null;
    this.renderedNodes = 0;
    this.nodesPool = typeof nodeType === "string" ? new NodesPool(nodeType) : null;
    this.nodeType = nodeType;
    if (rootNode !== void 0) {
      this.rootNode = rootNode;
    }
  }
}
class RowHeadersRenderer extends BaseRenderer {
  /**
  * Obtains the instance of the SharedOrderView class which is responsible for rendering the nodes to the root node.
  *
  * @param {HTMLTableRowElement} rootNode The TR element, which is root element for row headers (TH).
  * @returns {SharedOrderView}
  */
  obtainOrderView(rootNode) {
    if (!this.orderViews.has(rootNode)) {
      this.orderViews.set(rootNode, new SharedOrderView(rootNode, () => this.nodesPool.obtain(), this.nodeType));
    }
    return this.orderViews.get(rootNode);
  }
  /**
  * Renders the cells.
  */
  render() {
    const { rowsToRender, rowHeaderFunctions, rowHeadersCount, rows, cells } = this.table;
    for (let visibleRowIndex = 0; visibleRowIndex < rowsToRender; visibleRowIndex++) {
      const sourceRowIndex = this.table.renderedRowToSource(visibleRowIndex);
      const TR = rows.getRenderedNode(visibleRowIndex);
      if (!TR) {
        continue;
      }
      const orderView = this.obtainOrderView(TR);
      const cellsView = cells.obtainOrderView(TR);
      orderView.appendView(cellsView).setSize(rowHeadersCount).setOffset(0).start();
      for (let visibleColumnIndex = 0; visibleColumnIndex < rowHeadersCount; visibleColumnIndex++) {
        orderView.render();
        const TH = orderView.getCurrentNode();
        if (!TH) {
          continue;
        }
        TH.className = "";
        TH.removeAttribute("style");
        removeAttribute(TH, [
          /aria-(.*)/,
          /role/
        ]);
        if (this.table.isAriaEnabled()) {
          setAttribute(TH, [
            A11Y_ROWHEADER(),
            A11Y_SCOPE_ROW(),
            A11Y_COLINDEX(visibleColumnIndex + 1),
            A11Y_TABINDEX(-1)
          ]);
        }
        rowHeaderFunctions[visibleColumnIndex](sourceRowIndex, TH, visibleColumnIndex);
      }
      orderView.end();
    }
  }
  /**
  * Creates a new RowHeadersRenderer instance.
  */
  constructor() {
    super("TH"), /**
    * Cache for OrderView classes connected to specified node.
    *
    * @type {WeakMap}
    */
    this.orderViews = /* @__PURE__ */ new WeakMap();
  }
}
class ColumnHeaderRowsRenderer extends BaseRenderer {
  /**
  * Returns currently rendered node.
  *
  * @param {number} visualIndex Visual index of the rendered node (it always goes from 0 to N).
  * @returns {HTMLTableRowElement}
  */
  getRenderedNode(visualIndex) {
    return this.orderView.getNode(visualIndex);
  }
  /**
  * Renders the TR elements.
  */
  render() {
    const { columnHeadersCount } = this.table;
    if (this.table.isAriaEnabled()) {
      setAttribute(this.rootNode, [
        A11Y_ROWGROUP()
      ]);
    }
    this.orderView.setSize(columnHeadersCount).setOffset(0).start();
    for (let visibleRowIndex = 0; visibleRowIndex < columnHeadersCount; visibleRowIndex++) {
      this.orderView.render();
      const TR = this.orderView.getCurrentNode();
      if (TR && this.table.isAriaEnabled()) {
        setAttribute(TR, [
          A11Y_ROW(),
          A11Y_ROWINDEX(visibleRowIndex + 1)
        ]);
      }
    }
    this.orderView.end();
  }
  /**
  * Creates a new ColumnHeaderRowsRenderer instance.
  *
  * @param {HTMLElement} rootNode - The root HTML element (THEAD) to manage TR elements within.
  */
  constructor(rootNode) {
    super("TR", rootNode);
    this.orderView = new OrderView(rootNode, () => this.nodesPool.obtain(), this.nodeType);
  }
}
class ColumnHeadersRenderer extends BaseRenderer {
  /**
  * Obtains the instance of the OrderView class which is responsible for rendering the nodes to the root node.
  *
  * @param {HTMLTableRowElement} rootNode The TR element, which is root element for column headers (TH).
  * @returns {OrderView}
  */
  obtainOrderView(rootNode) {
    if (!this.orderViews.has(rootNode)) {
      this.orderViews.set(rootNode, new OrderView(rootNode, () => this.nodesPool.obtain(), this.nodeType));
    }
    return this.orderViews.get(rootNode);
  }
  /**
  * Renders the TH elements.
  */
  render() {
    const { columnHeadersCount, columnHeaderFunctions, columnsToRender, rowHeadersCount, columnHeaderRows } = this.table;
    const allColumnsToRender = columnsToRender + rowHeadersCount;
    for (let visibleRowIndex = 0; visibleRowIndex < columnHeadersCount; visibleRowIndex++) {
      const TR = columnHeaderRows.getRenderedNode(visibleRowIndex);
      if (!TR) {
        continue;
      }
      const orderView = this.obtainOrderView(TR);
      orderView.setSize(allColumnsToRender).setOffset(0).start();
      for (let visibleColumnIndex = 0; visibleColumnIndex < allColumnsToRender; visibleColumnIndex++) {
        orderView.render();
        const renderedColumnIndex = visibleColumnIndex - rowHeadersCount;
        const sourceColumnIndex = this.table.renderedColumnToSource(renderedColumnIndex);
        const TH = orderView.getCurrentNode();
        if (!TH) {
          continue;
        }
        TH.className = "";
        TH.removeAttribute("style");
        removeAttribute(TH, [
          /aria-(.*)/,
          /role/
        ]);
        if (this.table.isAriaEnabled()) {
          setAttribute(TH, [
            A11Y_COLINDEX(visibleColumnIndex + 1),
            A11Y_TABINDEX(-1),
            A11Y_COLUMNHEADER(),
            ...renderedColumnIndex >= 0 ? [
              A11Y_SCOPE_COL()
            ] : [
              // Adding `role=row` to the corner headers to prevent
              // https://github.com/handsontable/dev-handsontable/issues/1574
              A11Y_GRIDCELL_BUTTON(),
              A11Y_LABEL("Select whole grid")
            ]
          ]);
        }
        columnHeaderFunctions[visibleRowIndex](sourceColumnIndex, TH, visibleRowIndex);
      }
      orderView.end();
    }
  }
  /**
  * Creates a new ColumnHeadersRenderer instance.
  */
  constructor() {
    super("TH"), /**
    * Cache for OrderView classes connected to specified node.
    *
    * @type {WeakMap}
    */
    this.orderViews = /* @__PURE__ */ new WeakMap();
  }
}
let performanceWarningAppeared$1 = false;
class ColGroupRenderer extends BaseRenderer {
  /**
  * Renders the col group elements.
  */
  render() {
    const { columnsToRender, rowHeadersCount } = this.table;
    const allColumnsToRender = columnsToRender + rowHeadersCount;
    if (!performanceWarningAppeared$1 && columnsToRender > 1e3) {
      performanceWarningAppeared$1 = true;
      warn$1(toSingleLine`Performance tip: Handsontable rendered more than 1000 visible columns.\x20
        Consider limiting the number of rendered columns by specifying the table width and/or\x20
        turning off the "renderAllColumns" option.`);
    }
    this.orderView.setSize(allColumnsToRender).setOffset(0).start();
    for (let visibleColumnIndex = 0; visibleColumnIndex < allColumnsToRender; visibleColumnIndex++) {
      this.orderView.render();
      const COL = this.orderView.getCurrentNode();
      if (!COL) {
        continue;
      }
      if (visibleColumnIndex < rowHeadersCount) {
        const sourceColumnIndex = this.table.renderedColumnToSource(visibleColumnIndex);
        COL.style.width = `${this.table.columnUtils.getHeaderWidth(sourceColumnIndex)}px`;
      } else {
        const sourceColumnIndex = this.table.renderedColumnToSource(visibleColumnIndex - rowHeadersCount);
        COL.style.width = `${this.table.columnUtils.getWidth(sourceColumnIndex)}px`;
      }
    }
    this.orderView.end();
    const firstChild = this.rootNode.firstChild;
    if (firstChild) {
      addClass(firstChild, "rowHeader");
    }
  }
  /**
  * Creates a new ColGroupRenderer instance.
  *
  * @param {HTMLElement} rootNode - The root HTML element (colgroup) for rendering COL elements.
  */
  constructor(rootNode) {
    super("COL", rootNode);
    this.orderView = new OrderView(rootNode, () => this.nodesPool.obtain(), this.nodeType);
  }
}
const ROW_CLASSNAMES = {
  rowEven: "ht__row_even",
  rowOdd: "ht__row_odd"
};
let performanceWarningAppeared = false;
class RowsRenderer extends BaseRenderer {
  /**
  * Returns currently rendered node.
  *
  * @param {string} visualIndex Visual index of the rendered node (it always goeas from 0 to N).
  * @returns {HTMLTableRowElement}
  */
  getRenderedNode(visualIndex) {
    return this.orderView.getNode(visualIndex);
  }
  /**
  * Renders the cells.
  */
  render() {
    const { rowsToRender } = this.table;
    if (!performanceWarningAppeared && rowsToRender > 1e3) {
      performanceWarningAppeared = true;
      warn$1(toSingleLine`Performance tip: Handsontable rendered more than 1000 visible rows.\x20
        Consider limiting the number of rendered rows by specifying the table height and/or\x20
        turning off the "renderAllRows" option.`);
    }
    if (this.table.isAriaEnabled()) {
      setAttribute(this.rootNode, [
        A11Y_ROWGROUP()
      ]);
    }
    this.orderView.setSize(rowsToRender).setOffset(this.table.renderedRowToSource(0)).start();
    for (let visibleRowIndex = 0; visibleRowIndex < rowsToRender; visibleRowIndex++) {
      this.orderView.render();
      const TR = this.orderView.getCurrentNode();
      const sourceRowIndex = this.table.renderedRowToSource(visibleRowIndex);
      if (!TR) {
        continue;
      }
      if (this.table.isAriaEnabled()) {
        setAttribute(TR, [
          A11Y_ROW(),
          // `aria-rowindex` is incremented by both tbody and thead rows.
          A11Y_ROWINDEX(sourceRowIndex + (this.table.rowUtils?.dataAccessObject?.columnHeaders?.length ?? 0) + 1)
        ]);
      }
      if ((sourceRowIndex + 1) % 2 === 0) {
        if (!hasClass(TR, ROW_CLASSNAMES.rowEven)) {
          removeClass(TR, ROW_CLASSNAMES.rowOdd);
          addClass(TR, ROW_CLASSNAMES.rowEven);
        }
      } else if (!hasClass(TR, ROW_CLASSNAMES.rowOdd)) {
        removeClass(TR, ROW_CLASSNAMES.rowEven);
        addClass(TR, ROW_CLASSNAMES.rowOdd);
      }
    }
    this.orderView.end();
  }
  /**
  * Creates a new RowsRenderer instance.
  *
  * @param {HTMLElement} rootNode - The root node (TBODY element) for managing TR elements.
  */
  constructor(rootNode) {
    super("TR", rootNode);
    this.orderView = new OrderView(rootNode, () => this.nodesPool.obtain(), this.nodeType);
  }
}
class CellsRenderer extends BaseRenderer {
  /**
  * Obtains the instance of the SharedOrderView class which is responsible for rendering the nodes to the root node.
  *
  * @param {HTMLTableRowElement} rootNode The TR element, which is root element for cells (TD).
  * @returns {SharedOrderView}
  */
  obtainOrderView(rootNode) {
    if (!this.orderViews.has(rootNode)) {
      this.orderViews.set(rootNode, new SharedOrderView(rootNode, () => this.nodesPool.obtain(), this.nodeType));
    }
    return this.orderViews.get(rootNode);
  }
  /**
  * Renders the cells.
  */
  render() {
    const { rowsToRender, columnsToRender, rows, rowHeaders } = this.table;
    for (let visibleRowIndex = 0; visibleRowIndex < rowsToRender; visibleRowIndex++) {
      const sourceRowIndex = this.table.renderedRowToSource(visibleRowIndex);
      const TR = rows.getRenderedNode(visibleRowIndex);
      if (!TR) {
        continue;
      }
      const orderView = this.obtainOrderView(TR);
      const rowHeadersView = rowHeaders.obtainOrderView(TR);
      orderView.prependView(rowHeadersView).setSize(columnsToRender).setOffset(0).start();
      for (let visibleColumnIndex = 0; visibleColumnIndex < columnsToRender; visibleColumnIndex++) {
        orderView.render();
        const sourceColumnIndex = this.table.renderedColumnToSource(visibleColumnIndex);
        const TD = orderView.getCurrentNode();
        if (!TD) {
          continue;
        }
        if (!hasClass(TD, "hide")) {
          TD.className = "";
        }
        TD.removeAttribute("style");
        TD.removeAttribute("dir");
        removeAttribute(TD, [
          /aria-(.*)/,
          /role/
        ]);
        this.table.cellRenderer(sourceRowIndex, sourceColumnIndex, TD);
        if (this.table.isAriaEnabled()) {
          setAttribute(TD, [
            ...TD.hasAttribute("role") ? [] : [
              A11Y_GRIDCELL()
            ],
            A11Y_TABINDEX(-1),
            // `aria-colindex` is incremented by both tbody and thead rows.
            A11Y_COLINDEX(sourceColumnIndex + (this.table.rowUtils?.dataAccessObject?.rowHeaders?.length ?? 0) + 1)
          ]);
        }
      }
      orderView.end();
    }
  }
  /**
  * Creates a new CellsRenderer instance.
  */
  constructor() {
    super("TD"), /**
    * Cache for OrderView classes connected to specified node.
    *
    * @type {WeakMap}
    */
    this.orderViews = /* @__PURE__ */ new WeakMap();
  }
}
class TableRenderer {
  /**
  * Sets the overlay that is currently rendered. If `null` is provided, the master overlay is set.
  *
  * @param {'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'|'master'} overlayName The overlay name.
  */
  setActiveOverlayName(overlayName) {
    this.activeOverlayName = overlayName;
  }
  /**
  * Set row and column util classes.
  *
  * @param {RowUtils} rowUtils RowUtils instance which provides useful methods related to row sizes.
  * @param {ColumnUtils} columnUtils ColumnUtils instance which provides useful methods related to row sizes.
  */
  setAxisUtils(rowUtils, columnUtils) {
    this.rowUtils = rowUtils;
    this.columnUtils = columnUtils;
  }
  /**
  * Sets viewport size of the table.
  *
  * @param {number} rowsCount An amount of rows to render.
  * @param {number} columnsCount An amount of columns to render.
  */
  setViewportSize(rowsCount, columnsCount) {
    this.rowsToRender = rowsCount;
    this.columnsToRender = columnsCount;
  }
  /**
  * Sets row and column filter instances.
  *
  * @param {RowFilter} rowFilter Row filter instance which contains all necessary information about row index transformation.
  * @param {ColumnFilter} columnFilter Column filter instance which contains all necessary information about row
  * index transformation.
  */
  setFilters(rowFilter, columnFilter) {
    this.rowFilter = rowFilter;
    this.columnFilter = columnFilter;
  }
  /**
  * Sets row and column header functions.
  *
  * @param {Function[]} rowHeaders Row header functions. Factories for creating content for row headers.
  * @param {Function[]} columnHeaders Column header functions. Factories for creating content for column headers.
  */
  setHeaderContentRenderers(rowHeaders, columnHeaders) {
    this.rowHeaderFunctions = rowHeaders;
    this.rowHeadersCount = rowHeaders.length;
    this.columnHeaderFunctions = columnHeaders;
    this.columnHeadersCount = columnHeaders.length;
  }
  /**
  * Sets table renderers.
  *
  * @param {renderers} renderers The renderer units.
  * @param {RowHeadersRenderer} renderers.rowHeaders Row headers renderer.
  * @param {ColumnHeaderRowsRenderer} renderers.columnHeaderRows Column header rows renderer.
  * @param {ColumnHeadersRenderer} renderers.columnHeaders Column headers renderer.
  * @param {ColGroupRenderer} renderers.colGroup Col group renderer.
  * @param {RowsRenderer} renderers.rows Rows renderer.
  * @param {CellsRenderer} renderers.cells Cells renderer.
  */
  setRenderers({ rowHeaders, columnHeaderRows, columnHeaders, colGroup, rows, cells }) {
    rowHeaders.setTable(this);
    columnHeaderRows.setTable(this);
    columnHeaders.setTable(this);
    colGroup.setTable(this);
    rows.setTable(this);
    cells.setTable(this);
    this.rowHeaders = rowHeaders;
    this.columnHeaderRows = columnHeaderRows;
    this.columnHeaders = columnHeaders;
    this.colGroup = colGroup;
    this.rows = rows;
    this.cells = cells;
  }
  /**
  * Transforms visual/rendered row index to source index.
  *
  * @param {number} rowIndex Rendered index.
  * @returns {number}
  */
  renderedRowToSource(rowIndex) {
    return this.rowFilter.renderedToSource(rowIndex);
  }
  /**
  * Transforms visual/rendered column index to source index.
  *
  * @param {number} columnIndex Rendered index.
  * @returns {number}
  */
  renderedColumnToSource(columnIndex) {
    return this.columnFilter.renderedToSource(columnIndex);
  }
  /**
  * Returns `true` if the accessibility-related ARIA tags should be added to the table, `false` otherwise.
  *
  * @returns {boolean}
  */
  isAriaEnabled() {
    return this.rowUtils.wtSettings.getSetting("ariaTags");
  }
  /**
  * Renders the table.
  */
  render() {
    this.columnHeaderRows.render();
    this.columnHeaders.render();
    this.rows.render();
    this.rowHeaders.render();
    this.cells.render();
    this.columnUtils.calculateWidths();
    this.colGroup.render();
    const { rowsToRender, rows } = this;
    for (let visibleRowIndex = 0; visibleRowIndex < rowsToRender; visibleRowIndex++) {
      const TR = rows.getRenderedNode(visibleRowIndex);
      const rowUtils = this.rowUtils;
      if (TR && TR.firstChild) {
        const sourceRowIndex = this.renderedRowToSource(visibleRowIndex);
        const rowHeight = rowUtils.getHeightByOverlayName(sourceRowIndex, this.activeOverlayName);
        const isBorderBoxSizing = this.stylesHandler.areCellsBorderBox();
        const borderCompensation = isBorderBoxSizing ? 0 : 1;
        if (rowHeight) {
          TR.firstChild.style.height = `${rowHeight - borderCompensation}px`;
        } else {
          TR.firstChild.style.height = "";
        }
      }
    }
  }
  /**
  * Creates a new TableRenderer instance.
  *
  * @param {HTMLTableElement} rootNode The HTML table element to use as the root node for rendering.
  * @param {object} options The configuration options.
  * @param {Function} [options.cellRenderer] The cell renderer function.
  * @param {StylesHandler} [options.stylesHandler] The styles handler instance.
  */
  constructor(rootNode, { cellRenderer, stylesHandler } = {}) {
    this.rowHeaders = null;
    this.columnHeaderRows = null;
    this.columnHeaders = null;
    this.colGroup = null;
    this.rows = null;
    this.cells = null;
    this.rowFilter = null;
    this.columnFilter = null;
    this.rowUtils = null;
    this.columnUtils = null;
    this.rowsToRender = 0;
    this.columnsToRender = 0;
    this.rowHeaderFunctions = [];
    this.rowHeadersCount = 0;
    this.columnHeaderFunctions = [];
    this.columnHeadersCount = 0;
    this.rootNode = rootNode;
    this.rootDocument = this.rootNode.ownerDocument;
    this.cellRenderer = cellRenderer;
    this.stylesHandler = stylesHandler;
  }
}
class Renderer {
  /**
  * Sets the overlay that is currently rendered. If `null` is provided, the master overlay is set.
  *
  * @param {'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'|'master'} overlayName The overlay name.
  * @returns {Renderer}
  */
  setActiveOverlayName(overlayName) {
    this.renderer.setActiveOverlayName(overlayName);
    return this;
  }
  /**
  * Sets filter calculators for newly calculated row and column position. The filters are used to transform visual
  * indexes (0 to N) to source indexes provided by Handsontable.
  *
  * @param {RowFilter} rowFilter The row filter instance.
  * @param {ColumnFilter} columnFilter The column filter instance.
  * @returns {Renderer}
  */
  setFilters(rowFilter, columnFilter) {
    this.renderer.setFilters(rowFilter, columnFilter);
    return this;
  }
  /**
  * Sets the viewport size of the rendered table.
  *
  * @param {number} rowsCount An amount of rows to render.
  * @param {number} columnsCount An amount of columns to render.
  * @returns {Renderer}
  */
  setViewportSize(rowsCount, columnsCount) {
    this.renderer.setViewportSize(rowsCount, columnsCount);
    return this;
  }
  /**
  * Sets row and column header functions.
  *
  * @param {Function[]} rowHeaders Row header functions. Factories for creating content for row headers.
  * @param {Function[]} columnHeaders Column header functions. Factories for creating content for column headers.
  * @returns {Renderer}
  */
  setHeaderContentRenderers(rowHeaders, columnHeaders) {
    this.renderer.setHeaderContentRenderers(rowHeaders, columnHeaders);
    return this;
  }
  /**
  * Renders the table.
  */
  render() {
    this.renderer.render();
  }
  /**
  * Creates a new Renderer instance.
  *
  * @param {RendererOptions} options The renderer configuration options.
  */
  constructor({ TABLE, THEAD, COLGROUP, TBODY, rowUtils, columnUtils, cellRenderer, stylesHandler } = {}) {
    this.renderer = new TableRenderer(TABLE, {
      cellRenderer,
      stylesHandler
    });
    this.renderer.setRenderers({
      rowHeaders: new RowHeadersRenderer(),
      columnHeaderRows: new ColumnHeaderRowsRenderer(THEAD),
      columnHeaders: new ColumnHeadersRenderer(),
      colGroup: new ColGroupRenderer(COLGROUP),
      rows: new RowsRenderer(TBODY),
      cells: new CellsRenderer()
    });
    this.renderer.setAxisUtils(rowUtils, columnUtils);
  }
}
class ColumnUtils {
  /**
  * Returns column width based on passed source index.
  *
  * @param {number} sourceIndex Column source index.
  * @returns {number}
  */
  getWidth(sourceIndex) {
    const width = this.wtSettings.getSetting("columnWidth", sourceIndex) || this.wtSettings.getSetting("defaultColumnWidth");
    return width;
  }
  /**
  * Returns column header height based on passed header level.
  *
  * @param {number} level Column header level.
  * @returns {number}
  */
  getHeaderHeight(level) {
    let height = this.wtSettings.getSetting("stylesHandler").getDefaultRowHeight();
    const oversizedHeight = this.dataAccessObject.wtViewport.oversizedColumnHeaders[level];
    if (oversizedHeight !== void 0) {
      height = height ? Math.max(height, oversizedHeight) : oversizedHeight;
    }
    return height;
  }
  /**
  * Returns column header width based on passed source index.
  *
  * @param {number} sourceIndex Column source index.
  * @returns {number}
  */
  getHeaderWidth(sourceIndex) {
    const { columnFilter } = this.dataAccessObject.wtTable;
    if (!columnFilter) {
      return void 0;
    }
    return this.headerWidths.get(columnFilter.sourceToRendered(sourceIndex));
  }
  /**
  * Calculates column header widths that can be retrieved from the cache.
  */
  calculateWidths() {
    const { wtSettings } = this;
    let rowHeaderWidthSetting = wtSettings.getSetting("rowHeaderWidth");
    rowHeaderWidthSetting = wtSettings.getSetting("onModifyRowHeaderWidth", rowHeaderWidthSetting);
    if (rowHeaderWidthSetting !== null && rowHeaderWidthSetting !== void 0) {
      const rowHeadersCount = wtSettings.getSetting("rowHeaders").length;
      const defaultColumnWidth = wtSettings.getSetting("defaultColumnWidth");
      for (let visibleColumnIndex = 0; visibleColumnIndex < rowHeadersCount; visibleColumnIndex++) {
        let width = Array.isArray(rowHeaderWidthSetting) ? rowHeaderWidthSetting[visibleColumnIndex] : rowHeaderWidthSetting;
        width = width === null || width === void 0 ? defaultColumnWidth : width;
        this.headerWidths.set(visibleColumnIndex, width);
      }
    }
  }
  /**
  * @param {TableDao} dataAccessObject The table Data Access Object.
  * @param {Settings} wtSettings The walkontable settings.
  */
  constructor(dataAccessObject, wtSettings) {
    this.headerWidths = /* @__PURE__ */ new Map();
    this.dataAccessObject = dataAccessObject;
    this.wtSettings = wtSettings;
  }
}
class RowUtils {
  /**
  * Returns row height based on passed source index.
  *
  * @param {number} sourceIndex Row source index.
  * @returns {number}
  */
  getHeight(sourceIndex) {
    let height = this.wtSettings.getSetting("rowHeight", sourceIndex);
    const oversizedHeight = this.dataAccessObject.wtViewport.oversizedRows[sourceIndex];
    if (oversizedHeight !== void 0) {
      height = height === void 0 ? oversizedHeight : Math.max(height, oversizedHeight);
    }
    return height;
  }
  /**
  * Returns row height based on passed source index for the specified overlay type.
  *
  * @param {number} sourceIndex Row source index.
  * @param {'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'|'master'} overlayName The overlay name.
  * @returns {number}
  */
  getHeightByOverlayName(sourceIndex, overlayName) {
    let height = this.wtSettings.getSetting("rowHeightByOverlayName", sourceIndex, overlayName);
    const oversizedHeight = this.dataAccessObject.wtViewport.oversizedRows[sourceIndex];
    if (oversizedHeight !== void 0) {
      height = height === void 0 ? oversizedHeight : Math.max(height, oversizedHeight);
    }
    return height;
  }
  /**
  * @param {TableDao} dataAccessObject The table Data Access Object.
  * @param {Settings} wtSettings The walkontable settings.
  */
  constructor(dataAccessObject, wtSettings) {
    this.dataAccessObject = dataAccessObject;
    this.wtSettings = wtSettings;
  }
}
class Table {
  // Methods defined in subclass MasterTable but called from Table via `this.isMaster` guards.
  /**
  * Aligns overlays with the trimming container.
  *
  * @returns {void}
  */
  alignOverlaysWithTrimmingContainer() {
  }
  /**
  * Marks oversized column headers.
  *
  * @returns {void}
  */
  markOversizedColumnHeaders() {
  }
  /**
  * Returns a boolean that is true if this Table represents a specific overlay, identified by the overlay name.
  * For MasterTable, it returns false.
  *
  * @param {string} overlayTypeName The overlay type.
  * @returns {boolean}
  */
  is(overlayTypeName) {
    return this.name === overlayTypeName;
  }
  /**
  *
  */
  fixTableDomTree() {
    const rootDocument = this.domBindings.rootDocument;
    this.TBODY = this.TABLE.querySelector("tbody");
    if (!this.TBODY) {
      this.TBODY = rootDocument.createElement("tbody");
      this.TABLE.appendChild(this.TBODY);
    }
    this.THEAD = this.TABLE.querySelector("thead");
    if (!this.THEAD) {
      this.THEAD = rootDocument.createElement("thead");
      this.TABLE.insertBefore(this.THEAD, this.TBODY);
    }
    this.COLGROUP = this.TABLE.querySelector("colgroup");
    if (!this.COLGROUP) {
      this.COLGROUP = rootDocument.createElement("colgroup");
      this.TABLE.insertBefore(this.COLGROUP, this.THEAD);
    }
  }
  /**
  * @param {HTMLTableElement} table An element to process.
  * @returns {HTMLElement}
  */
  createSpreader(table) {
    const parent = table.parentNode;
    let spreader;
    if (!parent || parent.nodeType !== Node.ELEMENT_NODE || !isHTMLElement(parent) || !hasClass(parent, "wtHolder")) {
      spreader = this.domBindings.rootDocument.createElement("div");
      spreader.className = "wtSpreader";
      if (parent) {
        table.before(spreader);
      }
      spreader.appendChild(table);
    }
    if (spreader) {
      spreader.style.position = "relative";
      if (this.wtSettings.getSetting("ariaTags")) {
        setAttribute(spreader, [
          A11Y_PRESENTATION()
        ]);
      }
    }
    return spreader;
  }
  /**
  * @param {HTMLElement} spreader An element to the hider element is injected.
  * @returns {HTMLElement}
  */
  createHider(spreader) {
    const parent = spreader.parentNode;
    let hider;
    if (!parent || parent.nodeType !== Node.ELEMENT_NODE || !isHTMLElement(parent) || !hasClass(parent, "wtHolder")) {
      hider = this.domBindings.rootDocument.createElement("div");
      hider.className = "wtHider";
      if (parent) {
        spreader.before(hider);
      }
      hider.appendChild(spreader);
    }
    if (hider && this.wtSettings.getSetting("ariaTags")) {
      setAttribute(hider, [
        A11Y_PRESENTATION()
      ]);
    }
    return hider;
  }
  /**
  *
  * @param {HTMLElement} hider An element to the holder element is injected.
  * @returns {HTMLElement}
  */
  createHolder(hider) {
    const parent = hider.parentNode;
    let holder2;
    if (!parent || parent.nodeType !== Node.ELEMENT_NODE || !isHTMLElement(parent) || !hasClass(parent, "wtHolder")) {
      holder2 = this.domBindings.rootDocument.createElement("div");
      holder2.style.position = "relative";
      holder2.className = "wtHolder";
      if (this.isMaster) {
        setAttribute(holder2, [
          A11Y_TABINDEX(-1)
        ]);
      }
      if (parent) {
        hider.before(holder2);
      }
      if (this.isMaster) {
        const holderParent = holder2.parentNode;
        if (isHTMLElement(holderParent)) {
          holderParent.className += "ht_master handsontable";
          holderParent.setAttribute("dir", this.wtSettings.getSettingPure("rtlMode") ? "rtl" : "ltr");
          if (this.wtSettings.getSetting("ariaTags")) {
            setAttribute(holderParent, [
              A11Y_PRESENTATION()
            ]);
          }
        }
      }
      holder2.appendChild(hider);
    }
    if (holder2 && this.wtSettings.getSetting("ariaTags")) {
      setAttribute(holder2, [
        A11Y_PRESENTATION()
      ]);
    }
    return holder2;
  }
  /**
  * Redraws the table.
  *
  * @param {boolean} [fastDraw=false] If TRUE, will try to avoid full redraw and only update the border positions.
  *                                   If FALSE or UNDEFINED, will perform a full redraw.
  * @returns {Table}
  */
  draw(fastDraw = false) {
    const { wtSettings } = this;
    const { wtOverlays, wtViewport } = this.dataAccessObject;
    wtSettings.getSetting("totalRows");
    wtSettings.getSetting("totalColumns");
    const rowHeaders = wtSettings.getSetting("rowHeaders");
    const rowHeadersCount = rowHeaders.length;
    const columnHeaders = wtSettings.getSetting("columnHeaders");
    const columnHeadersCount = columnHeaders.length;
    let runFastDraw = fastDraw;
    if (this.isMaster) {
      wtOverlays.beforeDraw();
      this.holderOffset = offset(this.holder);
      wtViewport.rowHeightCache.ensureBuilt();
      wtViewport.columnWidthCache.ensureBuilt();
      runFastDraw = wtViewport.createCalculators(runFastDraw);
      if (rowHeadersCount && !wtSettings.getSetting("fixedColumnsStart")) {
        const leftScrollPos = wtOverlays.inlineStartOverlay.getScrollPosition();
        const previousState = this.correctHeaderWidth;
        this.correctHeaderWidth = leftScrollPos !== 0;
        if (previousState !== this.correctHeaderWidth) {
          runFastDraw = false;
        }
      }
    }
    if (runFastDraw) {
      if (this.isMaster) {
        wtOverlays.refresh(true);
        this.syncOversizedColumnHeadersWithFrozenOverlays();
      }
    } else {
      if (this.isMaster) {
        this.tableOffset = offset(this.TABLE);
      } else {
        this.tableOffset = this.dataAccessObject.parentTableOffset;
      }
      const startRow = Math.max(this.getFirstRenderedRow(), 0);
      const startColumn = Math.max(this.getFirstRenderedColumn(), 0);
      this.rowFilter = new RowFilter(startRow, wtSettings.getSetting("totalRows"), columnHeadersCount);
      this.columnFilter = new ColumnFilter(startColumn, wtSettings.getSetting("totalColumns"), rowHeadersCount);
      let performRedraw = true;
      if (this.isMaster) {
        this.alignOverlaysWithTrimmingContainer();
        const skipRender = {};
        this.wtSettings.getSetting("beforeDraw", true, skipRender);
        performRedraw = skipRender.skipRender !== true;
      }
      if (performRedraw) {
        this.tableRenderer.setHeaderContentRenderers(rowHeaders, columnHeaders);
        if (this.is(CLONE_BOTTOM) || this.is(CLONE_BOTTOM_INLINE_START_CORNER)) {
          this.tableRenderer.setHeaderContentRenderers(rowHeaders, []);
        }
        this.resetOversizedRows();
        this.tableRenderer.setActiveOverlayName(this.name).setViewportSize(this.getRenderedRowsCount(), this.getRenderedColumnsCount()).setFilters(this.rowFilter, this.columnFilter).render();
        if (this.isMaster) {
          this.markOversizedColumnHeaders();
        }
        this.adjustColumnHeaderHeights();
        if (this.isMaster) {
          this.syncOversizedColumnHeadersWithDOM();
        }
        if (this.isMaster || this.is(CLONE_BOTTOM)) {
          this.markOversizedRows();
        }
        if (this.isMaster) {
          if (!this.wtSettings.getSetting("externalRowCalculator")) {
            wtViewport.rowHeightCache.ensureBuilt();
            wtViewport.columnWidthCache.ensureBuilt();
            wtViewport.createVisibleCalculators();
          }
          wtOverlays.refresh(false);
          this.syncOversizedColumnHeadersWithFrozenOverlays();
          wtOverlays.applyToDOM();
          this.wtSettings.getSetting("onDraw", true);
        } else if (this.is(CLONE_BOTTOM)) {
          this.dataAccessObject.cloneSource.wtOverlays.adjustElementsSize();
        }
      }
    }
    let positionChanged = false;
    if (this.isMaster) {
      positionChanged = wtOverlays.topOverlay.resetFixedPosition();
      if (wtOverlays.bottomOverlay.clone) {
        positionChanged = wtOverlays.bottomOverlay.resetFixedPosition() || positionChanged;
      }
      positionChanged = wtOverlays.inlineStartOverlay.resetFixedPosition() || positionChanged;
      if (wtOverlays.topInlineStartCornerOverlay) {
        wtOverlays.topInlineStartCornerOverlay.resetFixedPosition();
      }
      if (wtOverlays.bottomInlineStartCornerOverlay && wtOverlays.bottomInlineStartCornerOverlay.clone) {
        wtOverlays.bottomInlineStartCornerOverlay.resetFixedPosition();
      }
    }
    if (positionChanged) {
      wtOverlays.refreshAll();
      wtOverlays.adjustElementsSize();
    } else {
      this.dataAccessObject.selectionManager.setActiveOverlay(this.facadeGetter()).render(runFastDraw);
    }
    if (this.isMaster) {
      wtOverlays.afterDraw();
    }
    this.dataAccessObject.drawn = true;
    return this;
  }
  /**
  * @param {number} col The visual column index.
  */
  markIfOversizedColumnHeader(col) {
    const sourceColIndex = this.columnFilter.renderedToSource(col);
    let level = this.wtSettings.getSetting("columnHeaders").length;
    const defaultRowHeight = this.wtSettings.getSetting("stylesHandler").getDefaultRowHeight();
    let previousColHeaderHeight;
    let currentHeader;
    let currentHeaderHeight;
    const columnHeaderHeightSetting = this.wtSettings.getSetting("columnHeaderHeight") || [];
    while (level) {
      level -= 1;
      previousColHeaderHeight = this.getColumnHeaderHeight(level);
      currentHeader = this.getColumnHeader(sourceColIndex, level);
      if (!currentHeader) {
        continue;
      }
      currentHeaderHeight = innerHeight(currentHeader);
      if (!previousColHeaderHeight && defaultRowHeight < currentHeaderHeight || previousColHeaderHeight < currentHeaderHeight) {
        this.dataAccessObject.wtViewport.oversizedColumnHeaders[level] = currentHeaderHeight;
      }
      if (Array.isArray(columnHeaderHeightSetting)) {
        if (columnHeaderHeightSetting[level] !== null && columnHeaderHeightSetting[level] !== void 0) {
          this.dataAccessObject.wtViewport.oversizedColumnHeaders[level] = columnHeaderHeightSetting[level];
        }
      } else if (!isNaN(columnHeaderHeightSetting)) {
        this.dataAccessObject.wtViewport.oversizedColumnHeaders[level] = columnHeaderHeightSetting;
      }
      const headerHeightAtLevel = Array.isArray(columnHeaderHeightSetting) ? columnHeaderHeightSetting[level] ?? 0 : columnHeaderHeightSetting;
      if ((this.dataAccessObject.wtViewport.oversizedColumnHeaders[level] ?? 0) < headerHeightAtLevel) {
        this.dataAccessObject.wtViewport.oversizedColumnHeaders[level] = headerHeightAtLevel;
      }
    }
  }
  /**
  *
  */
  adjustColumnHeaderHeights() {
    const { wtSettings } = this;
    const children = this.THEAD.childNodes;
    const oversizedColumnHeaders = this.dataAccessObject.wtViewport.oversizedColumnHeaders;
    const columnHeaders = wtSettings.getSetting("columnHeaders");
    for (let i = 0, len = columnHeaders.length; i < len; i++) {
      if (oversizedColumnHeaders[i]) {
        if (!children[i] || children[i].childNodes.length === 0) {
          return;
        }
        const firstChild = children[i].childNodes[0];
        if (isHTMLElement(firstChild)) {
          firstChild.style.height = `${oversizedColumnHeaders[i]}px`;
        }
      }
    }
  }
  /**
  * After the master table applies `oversizedColumnHeaders` via `adjustColumnHeaderHeights`,
  * the actual THEAD row heights may exceed the stored values when header content (e.g.,
  * wrapping text) pushes cells taller than the configured `columnHeaderHeight`. This method
  * re-reads the rendered THEAD row heights and updates `oversizedColumnHeaders` so that
  * overlay tables receive the correct values during their own `adjustColumnHeaderHeights`.
  */
  syncOversizedColumnHeadersWithDOM() {
    const { wtSettings } = this;
    const children = this.THEAD.childNodes;
    const oversizedColumnHeaders = this.dataAccessObject.wtViewport.oversizedColumnHeaders;
    const columnHeaders = wtSettings.getSetting("columnHeaders");
    const borderCompensation = 1;
    for (let i = 0, len = columnHeaders.length; i < len; i++) {
      if (!children[i] || !oversizedColumnHeaders[i]) {
        continue;
      }
      const child = children[i];
      const actualRowHeight = isHTMLElement(child) ? innerHeight(child) : 0;
      if (actualRowHeight > (oversizedColumnHeaders[i] ?? 0) + borderCompensation) {
        oversizedColumnHeaders[i] = actualRowHeight;
      }
    }
  }
  /**
  * Frozen column headers (e.g., with `white-space: normal`) are rendered only in the frozen
  * overlays, never in the master table's THEAD. When such a header is taller than the headers
  * of the scrollable columns, the master and top overlay THEADs render shorter than the corner
  * and inline-start overlays, so the frozen overlay body rows sit shifted against the master.
  * The gap can be sub-pixel: under browser zoom the frozen header content is a fraction of a
  * pixel taller than the applied height, and that fraction accumulates into a visible 1px shift.
  *
  * This method runs after the frozen overlays have rendered. It reads the corner overlay's
  * content-driven THEAD row heights with sub-pixel precision and forces the matching master and
  * top overlay header cells to the same height so every overlay THEAD ends up the same height
  * and the body rows stay pixel-aligned.
  *
  * It deliberately does NOT write to `wtViewport.oversizedColumnHeaders`. That cache is applied
  * back to the corner overlay on the next render; growing it here would inflate the corner cell,
  * which would then be re-measured taller, ratcheting the height up every render. Reading the
  * corner's natural (content-driven) height and only adjusting the master/top side keeps the
  * synchronization stable and lets the header shrink again when the content allows.
  */
  syncOversizedColumnHeadersWithFrozenOverlays() {
    const { wtOverlays } = this.dataAccessObject;
    const cornerClone = wtOverlays.topInlineStartCornerOverlay?.clone;
    if (!cornerClone?.wtTable?.THEAD) {
      return;
    }
    const columnHeaders = this.wtSettings.getSetting("columnHeaders");
    if (!columnHeaders.length) {
      return;
    }
    const cornerChildren = cornerClone.wtTable.THEAD.childNodes;
    const topClone = wtOverlays.topOverlay?.clone;
    const targetTheads = [
      this.THEAD,
      topClone?.wtTable?.THEAD
    ];
    const epsilon = 0.1;
    for (let i = 0, len = columnHeaders.length; i < len; i++) {
      const cornerChild = cornerChildren[i];
      if (!(cornerChild instanceof HTMLElement)) {
        continue;
      }
      const cornerRowHeight = cornerChild.getBoundingClientRect().height;
      targetTheads.forEach((thead) => {
        const targetRow = thead?.childNodes[i];
        if (!(targetRow instanceof HTMLElement) || targetRow.childNodes.length === 0) {
          return;
        }
        const firstChild = targetRow.childNodes[0];
        if (!(firstChild instanceof HTMLElement)) {
          return;
        }
        if (Math.abs(targetRow.getBoundingClientRect().height - cornerRowHeight) > epsilon) {
          firstChild.style.height = `${cornerRowHeight}px`;
        }
      });
    }
  }
  /**
  * Resets cache of row heights. The cache should be cached for each render cycle in a case
  * when new cell values have content which increases/decreases cell height.
  */
  resetOversizedRows() {
    const { wtSettings } = this;
    const { wtViewport } = this.dataAccessObject;
    if (!this.isMaster && !this.is(CLONE_BOTTOM)) {
      return;
    }
    if (!wtSettings.getSetting("externalRowCalculator")) {
      const rowsToRender = this.getRenderedRowsCount();
      for (let visibleRowIndex = 0; visibleRowIndex < rowsToRender; visibleRowIndex++) {
        const sourceRow = this.rowFilter.renderedToSource(visibleRowIndex);
        if (wtViewport.oversizedRows && wtViewport.oversizedRows[sourceRow]) {
          wtViewport.oversizedRows[sourceRow] = void 0;
        }
      }
    }
  }
  /**
  * Get cell element at coords.
  * Negative coords.row or coords.col are used to retrieve header cells. If there are multiple header levels, the
  * negative value corresponds to the distance from the working area. For example, when there are 3 levels of column
  * headers, coords.col=-1 corresponds to the most inner header element, while coords.col=-3 corresponds to the
  * outmost header element.
  *
  * In case an element for the coords is not rendered, the method returns an error code.
  * To produce the error code, the input parameters are validated in the order in which they
  * are given. Thus, if both the row and the column coords are out of the rendered bounds,
  * the method returns the error code for the row.
  *
  * @param {CellCoords} coords The cell coordinates.
  * @returns {HTMLElement|number} HTMLElement on success or Number one of the exit codes on error:
  *  -1 row before viewport
  *  -2 row after viewport
  *  -3 column before viewport
  *  -4 column after viewport.
  */
  getCell(coords) {
    if (coords.row === null || coords.col === null) {
      return -5;
    }
    let row = coords.row;
    let column = coords.col;
    const hookResult = this.wtSettings.getSetting("onModifyGetCellCoords", row, column, !this.isMaster, "render");
    if (hookResult && Array.isArray(hookResult)) {
      [row, column] = hookResult;
    }
    if (this.isRowBeforeRenderedRows(row)) {
      return -1;
    } else if (this.isRowAfterRenderedRows(row)) {
      return -2;
    } else if (this.isColumnBeforeRenderedColumns(column)) {
      return -3;
    } else if (this.isColumnAfterRenderedColumns(column)) {
      return -4;
    }
    const TR = this.getRow(row);
    if (!TR && row >= 0) {
      throwWithCause("TR was expected to be rendered but is not");
    }
    const trElement = TR !== false ? TR : null;
    const TD = trElement?.childNodes[this.columnFilter.sourceColumnToVisibleRowHeadedColumn(column)];
    if (!TD && column >= 0) {
      throwWithCause("TD or TH was expected to be rendered but is not");
    }
    return TD;
  }
  /**
  * Get the DOM element of the row with the provided index.
  *
  * @param {number} rowIndex Row index.
  * @returns {HTMLTableRowElement|boolean} Return the row's DOM element or `false` if the row with the provided
  * index doesn't exist.
  */
  getRow(rowIndex) {
    let renderedRowIndex = null;
    let parentElement = null;
    if (rowIndex < 0) {
      renderedRowIndex = this.rowFilter?.sourceRowToVisibleColHeadedRow(rowIndex);
      parentElement = this.THEAD;
    } else {
      renderedRowIndex = this.rowFilter?.sourceToRendered(rowIndex);
      parentElement = this.TBODY;
    }
    if (renderedRowIndex !== void 0 && renderedRowIndex !== null && parentElement !== null) {
      if (parentElement.childNodes.length < renderedRowIndex + 1) {
        return false;
      } else {
        return parentElement.childNodes[renderedRowIndex];
      }
    }
    return false;
  }
  /**
  * GetColumnHeader.
  *
  * @param {number} col Column index.
  * @param {number} [level=0] Header level (0 = most distant to the table).
  * @returns {object} HTMLElement on success or undefined on error.
  */
  getColumnHeader(col, level = 0) {
    const TR = this.THEAD.childNodes[level];
    const TH = TR?.childNodes[this.columnFilter.sourceColumnToVisibleRowHeadedColumn(col)];
    return isHTMLElement(TH) ? TH : void 0;
  }
  /**
  * Gets all columns headers (TH elements) from the table.
  *
  * @param {number} column A source column index.
  * @returns {HTMLTableCellElement[]}
  */
  getColumnHeaders(column) {
    const THs = [];
    const visibleColumn = this.columnFilter.sourceColumnToVisibleRowHeadedColumn(column);
    this.THEAD.childNodes.forEach((TR) => {
      const TH = TR.childNodes[visibleColumn];
      if (isHTMLTableCellElement(TH)) {
        THs.push(TH);
      }
    });
    return THs;
  }
  /**
  * GetRowHeader.
  *
  * @param {number} row Row index.
  * @param {number} [level=0] Header level (0 = most distant to the table).
  * @returns {HTMLElement} HTMLElement on success or Number one of the exit codes on error: `null table doesn't have
  *   row headers`.
  */
  getRowHeader(row, level = 0) {
    const rowHeadersCount = this.wtSettings.getSetting("rowHeaders").length;
    if (level >= rowHeadersCount) {
      return void 0;
    }
    const renderedRow = this.rowFilter.sourceToRendered(row);
    const visibleRow = renderedRow < 0 ? this.rowFilter.sourceRowToVisibleColHeadedRow(row) : renderedRow;
    const parentElement = renderedRow < 0 ? this.THEAD : this.TBODY;
    const TR = parentElement?.childNodes[visibleRow];
    const TH = TR?.childNodes[level];
    return isHTMLElement(TH) ? TH : void 0;
  }
  /**
  * Gets all rows headers (TH elements) from the table.
  *
  * @param {number} row A source row index.
  * @returns {HTMLTableCellElement[]}
  */
  getRowHeaders(row) {
    const THs = [];
    const rowHeadersCount = this.wtSettings.getSetting("rowHeaders").length;
    for (let renderedRowIndex = 0; renderedRowIndex < rowHeadersCount; renderedRowIndex++) {
      const TR = this.TBODY.childNodes[this.rowFilter.sourceToRendered(row)];
      const TH = TR?.childNodes[renderedRowIndex];
      if (TH) {
        THs.push(TH);
      }
    }
    return THs;
  }
  /**
  * Returns cell coords object for a given TD (or a child element of a TD element).
  *
  * @param {HTMLTableCellElement} TD A cell DOM element (or a child of one).
  * @returns {CellCoords|null} The coordinates of the provided TD element (or the closest TD element) or null, if the
  *   provided element is not applicable.
  */
  getCoords(TD) {
    let cellElement = TD;
    if (cellElement.nodeName !== "TD" && cellElement.nodeName !== "TH") {
      cellElement = closest(cellElement, [
        "TD",
        "TH"
      ]);
    }
    if (cellElement === null) {
      return null;
    }
    const TR = cellElement.parentNode;
    if (!TR) {
      return null;
    }
    const CONTAINER = TR.parentNode;
    if (!CONTAINER) {
      return null;
    }
    let row = isHTMLElement(TR) ? index(TR) : 0;
    let col = isHTMLTableCellElement(cellElement) ? cellElement.cellIndex : 0;
    if (overlayContainsElement(CLONE_TOP_INLINE_START_CORNER, cellElement, this.wtRootElement) || overlayContainsElement(CLONE_TOP, cellElement, this.wtRootElement)) {
      if (CONTAINER.nodeName === "THEAD") {
        row -= CONTAINER.childNodes.length;
      }
    } else if (overlayContainsElement(CLONE_BOTTOM_INLINE_START_CORNER, cellElement, this.wtRootElement) || overlayContainsElement(CLONE_BOTTOM, cellElement, this.wtRootElement)) {
      const totalRows = this.wtSettings.getSetting("totalRows");
      row = totalRows - CONTAINER.childNodes.length + row;
    } else if (CONTAINER === this.THEAD) {
      row = this.rowFilter.visibleColHeadedRowToSourceRow(row);
    } else if (this.rowFilter) {
      row = this.rowFilter.renderedToSource(row);
    }
    if (overlayContainsElement(CLONE_TOP_INLINE_START_CORNER, cellElement, this.wtRootElement) || overlayContainsElement(CLONE_INLINE_START, cellElement, this.wtRootElement) || overlayContainsElement(CLONE_BOTTOM_INLINE_START_CORNER, cellElement, this.wtRootElement)) {
      col = this.columnFilter.offsettedTH(col);
    } else if (this.columnFilter) {
      col = this.columnFilter.visibleRowHeadedColumnToSourceColumn(col);
    }
    const hookResult = this.wtSettings.getSetting("onModifyGetCoordsElement", row, col);
    if (hookResult && Array.isArray(hookResult)) {
      [row, col] = hookResult;
    }
    return this.wot.createCellCoords(row, col);
  }
  /**
  * Check if any of the rendered rows is higher than expected, and if so, cache them.
  */
  markOversizedRows() {
    if (this.wtSettings.getSetting("externalRowCalculator")) {
      return;
    }
    let rowCount = this.TBODY.childNodes.length;
    const stylesHandler = this.wtSettings.getSetting("stylesHandler");
    const expectedTableHeight = rowCount * stylesHandler.getDefaultRowHeight();
    const actualTableHeight = innerHeight(this.TBODY) - 1;
    const borderBoxSizing = stylesHandler.areCellsBorderBox();
    const rowHeightFn = borderBoxSizing ? outerHeight : innerHeight;
    const borderCompensation = borderBoxSizing ? 0 : 1;
    const firstRowBorderCompensation = borderBoxSizing ? 1 : 0;
    let previousRowHeight;
    let rowCurrentHeight;
    let sourceRowIndex;
    let currentTr;
    let rowHeader;
    if (expectedTableHeight === actualTableHeight && !this.wtSettings.getSetting("fixedRowsBottom")) {
      return;
    }
    const { wtViewport } = this.dataAccessObject;
    let hasChanges = false;
    while (rowCount) {
      rowCount -= 1;
      sourceRowIndex = this.rowFilter.renderedToSource(rowCount);
      previousRowHeight = this.getRowHeight(sourceRowIndex);
      currentTr = this.getTrForRow(sourceRowIndex);
      rowHeader = currentTr.querySelector("th");
      const topBorderCompensation = rowCount === 0 ? firstRowBorderCompensation : 0;
      if (rowHeader) {
        rowCurrentHeight = rowHeightFn(rowHeader);
      } else {
        rowCurrentHeight = rowHeightFn(currentTr) - borderCompensation;
      }
      if (!previousRowHeight && stylesHandler.getDefaultRowHeight() < rowCurrentHeight - topBorderCompensation || previousRowHeight !== void 0 && previousRowHeight < rowCurrentHeight) {
        if (!borderBoxSizing) {
          rowCurrentHeight += 1;
        }
        wtViewport.oversizedRows[sourceRowIndex] = rowCurrentHeight;
        hasChanges = true;
      }
    }
    if (hasChanges) {
      wtViewport.rowHeightCache.invalidate();
    }
  }
  /**
  * @param {number} row The visual row index.
  * @returns {HTMLTableRowElement}
  */
  getTrForRow(row) {
    return this.TBODY.childNodes[this.rowFilter.sourceToRendered(row)];
  }
  /**
  * Checks if the column index (negative value from -1 to N) is rendered.
  *
  * @param {number} column The column index (negative value from -1 to N).
  * @returns {boolean}
  */
  isColumnHeaderRendered(column) {
    if (column >= 0) {
      return false;
    }
    const rowHeaders = this.wtSettings.getSetting("rowHeaders");
    const rowHeadersCount = rowHeaders.length;
    return Math.abs(column) <= rowHeadersCount;
  }
  /**
  * Checks if the row index (negative value from -1 to N) is rendered.
  *
  * @param {number} row The row index (negative value from -1 to N).
  * @returns {boolean}
  */
  isRowHeaderRendered(row) {
    if (row >= 0) {
      return false;
    }
    const columnHeaders = this.wtSettings.getSetting("columnHeaders");
    const columnHeadersCount = columnHeaders.length;
    return Math.abs(row) <= columnHeadersCount;
  }
  /**
  * Check if the given row index is lower than the index of the first row that
  * is currently rendered and return TRUE in that case, or FALSE otherwise.
  *
  * Negative row index is used to check the columns' headers.
  *
  *  Headers
  *           +--------------+                                     │
  *       -3  │    │    │    │                                     │
  *           +--------------+                                     │
  *       -2  │    │    │    │                                     │ TRUE
  *           +--------------+                                     │
  *       -1  │    │    │    │                                     │
  *  Cells  +==================+                                   │
  *        0  ┇    ┇    ┇    ┇ <--- For fixedRowsTop: 1            │
  *           +--------------+      the master overlay do       ---+ first rendered row (index 1)
  *        1  │ A2 │ B2 │ C2 │      not render the first row.      │
  *           +--------------+                                     │ FALSE
  *        2  │ A3 │ B3 │ C3 │                                     │
  *           +--------------+                                  ---+ last rendered row
  *                                                                │
  *                                                                │ FALSE
  *
  * @param {number} row The visual row index.
  * @memberof Table#
  * @function isRowBeforeRenderedRows
  * @returns {boolean}
  */
  isRowBeforeRenderedRows(row) {
    const first2 = this.getFirstRenderedRow();
    if (row < 0 && first2 <= 0) {
      return !this.isRowHeaderRendered(row);
    }
    return row < first2;
  }
  /**
  * Check if the given column index is greater than the index of the last column that
  * is currently rendered and return TRUE in that case, or FALSE otherwise.
  *
  * The negative row index is used to check the columns' headers. However,
  * keep in mind that for negative indexes, the method always returns FALSE as
  * it is not possible to render headers partially. The "after" index can not be
  * lower than -1.
  *
  *  Headers
  *           +--------------+                                     │
  *       -3  │    │    │    │                                     │
  *           +--------------+                                     │
  *       -2  │    │    │    │                                     │ FALSE
  *           +--------------+                                     │
  *       -1  │    │    │    │                                     │
  *  Cells  +==================+                                   │
  *        0  ┇    ┇    ┇    ┇ <--- For fixedRowsTop: 1            │
  *           +--------------+      the master overlay do       ---+ first rendered row (index 1)
  *        1  │ A2 │ B2 │ C2 │      not render the first rows      │
  *           +--------------+                                     │ FALSE
  *        2  │ A3 │ B3 │ C3 │                                     │
  *           +--------------+                                  ---+ last rendered row
  *                                                                │
  *                                                                │ TRUE
  *
  * @param {number} row The visual row index.
  * @memberof Table#
  * @function isRowAfterRenderedRows
  * @returns {boolean}
  */
  isRowAfterRenderedRows(row) {
    return row > this.getLastRenderedRow();
  }
  /**
  * Check if the given column index is lower than the index of the first column that
  * is currently rendered and return TRUE in that case, or FALSE otherwise.
  *
  * Negative column index is used to check the rows' headers.
  *
  *                            For fixedColumnsStart: 1 the master overlay
  *                            do not render this first columns.
  *  Headers    -3   -2   -1    |
  *           +----+----+----║┄ ┄ +------+------+
  *           │    │    │    ║    │  B1  │  C1  │
  *           +--------------║┄ ┄ --------------│
  *           │    │    │    ║    │  B2  │  C2  │
  *           +--------------║┄ ┄ --------------│
  *           │    │    │    ║    │  B3  │  C3  │
  *           +----+----+----║┄ ┄ +------+------+
  *                               ╷             ╷
  *      -------------------------+-------------+---------------->
  *          TRUE             first    FALSE   last         FALSE
  *                           rendered         rendered
  *                           column           column
  *
  * @param {number} column The visual column index.
  * @memberof Table#
  * @function isColumnBeforeRenderedColumns
  * @returns {boolean}
  */
  isColumnBeforeRenderedColumns(column) {
    const first2 = this.getFirstRenderedColumn();
    if (column < 0 && first2 <= 0) {
      return !this.isColumnHeaderRendered(column);
    }
    return column < first2;
  }
  /**
  * Check if the given column index is greater than the index of the last column that
  * is currently rendered and return TRUE in that case, or FALSE otherwise.
  *
  * The negative column index is used to check the rows' headers. However,
  * keep in mind that for negative indexes, the method always returns FALSE as
  * it is not possible to render headers partially. The "after" index can not be
  * lower than -1.
  *
  *                            For fixedColumnsStart: 1 the master overlay
  *                            do not render this first columns.
  *  Headers    -3   -2   -1    |
  *           +----+----+----║┄ ┄ +------+------+
  *           │    │    │    ║    │  B1  │  C1  │
  *           +--------------║┄ ┄ --------------│
  *           │    │    │    ║    │  B2  │  C2  │
  *           +--------------║┄ ┄ --------------│
  *           │    │    │    ║    │  B3  │  C3  │
  *           +----+----+----║┄ ┄ +------+------+
  *                               ╷             ╷
  *      -------------------------+-------------+---------------->
  *          FALSE             first    FALSE   last         TRUE
  *                           rendered         rendered
  *                           column           column
  *
  * @param {number} column The visual column index.
  * @memberof Table#
  * @function isColumnAfterRenderedColumns
  * @returns {boolean}
  */
  isColumnAfterRenderedColumns(column) {
    return this.columnFilter && column > this.getLastRenderedColumn();
  }
  /**
  * Checks if the column is after the last visible column.
  *
  * @param {number} column The visual column index.
  * @returns {boolean}
  */
  isColumnAfterViewport(column) {
    return this.columnFilter && column > this.getLastVisibleColumn();
  }
  /**
  * Checks if the row is after the last visible row.
  *
  * @param {number} row The visual row index.
  * @returns {boolean}
  */
  isRowAfterViewport(row) {
    return this.rowFilter && row > this.getLastVisibleRow();
  }
  /**
  * Checks if the column is before the first visible column.
  *
  * @param {number} column The visual column index.
  * @returns {boolean}
  */
  isColumnBeforeViewport(column) {
    return this.columnFilter && this.columnFilter.sourceToRendered(column) < 0 && column >= 0;
  }
  /**
  * Checks if the last row is fully visible.
  *
  * @returns {boolean}
  */
  isLastRowFullyVisible() {
    return this.getLastVisibleRow() === this.getLastRenderedRow();
  }
  /**
  * Checks if the last column is fully visible.
  *
  * @returns {boolean}
  */
  isLastColumnFullyVisible() {
    return this.getLastVisibleColumn() === this.getLastRenderedColumn();
  }
  /**
  * Checks if all rows fit in the viewport.
  *
  * @returns {boolean}
  */
  allRowsInViewport() {
    return this.wtSettings.getSetting("totalRows") === this.getVisibleRowsCount();
  }
  /**
  * Checks if all columns fit in the viewport.
  *
  * @returns {boolean}
  */
  allColumnsInViewport() {
    return this.wtSettings.getSetting("totalColumns") === this.getVisibleColumnsCount();
  }
  /**
  * Checks if any of the row's cells content exceeds its initial height, and if so, returns the oversized height.
  *
  * @param {number} sourceRow The physical row index.
  * @returns {number}
  */
  getRowHeight(sourceRow) {
    return this.rowUtils.getHeight(sourceRow);
  }
  /**
  * @param {number} level The column level.
  * @returns {number}
  */
  getColumnHeaderHeight(level) {
    return this.columnUtils.getHeaderHeight(level);
  }
  /**
  * @param {number} sourceColumn The physical column index.
  * @returns {number}
  */
  getColumnWidth(sourceColumn) {
    return this.columnUtils.getWidth(sourceColumn);
  }
  /**
  * Checks if the table has defined size. It returns `true` when the table has width and height
  * set bigger than `0px`.
  *
  * @returns {boolean}
  */
  hasDefinedSize() {
    return this.hasTableHeight && this.hasTableWidth;
  }
  /**
  * Gets table's width. The returned width is the width of the rendered cells that fit in the
  * current viewport. The value may change depends on the viewport position (scroll position).
  *
  * @returns {number}
  */
  getWidth() {
    return outerWidth(this.TABLE);
  }
  /**
  * Gets table's height. The returned height is the height of the rendered cells that fit in the
  * current viewport. The value may change depends on the viewport position (scroll position).
  *
  * @returns {number}
  */
  getHeight() {
    return outerHeight(this.TABLE);
  }
  /**
  * Gets table's total width. The returned width is the width of all rendered cells (including headers)
  * that can be displayed in the table.
  *
  * @returns {number}
  */
  getTotalWidth() {
    const width = outerWidth(this.hider);
    return width !== 0 ? width : this.getWidth();
  }
  /**
  * Gets table's total height. The returned height is the height of all rendered cells (including headers)
  * that can be displayed in the table.
  *
  * @returns {number}
  */
  getTotalHeight() {
    const height = outerHeight(this.hider);
    return height !== 0 ? height : this.getHeight();
  }
  /**
  * Checks if the table is visible. It returns `true` when the holder element (or its parents)
  * has CSS 'display' property different than 'none'.
  *
  * @returns {boolean}
  */
  isVisible() {
    return isVisible(this.TABLE);
  }
  /**
  * Modify row header widths provided by user in class contructor.
  *
  * @private
  * @param {Function | number | null} rowHeaderWidthFactory The function which can provide default width values for rows..
  * @returns {number}
  */
  _modifyRowHeaderWidth(rowHeaderWidthFactory) {
    const rawWidths = typeof rowHeaderWidthFactory === "function" ? rowHeaderWidthFactory() : rowHeaderWidthFactory;
    let widths = rawWidths;
    if (Array.isArray(widths)) {
      widths = [
        ...widths
      ];
      widths[widths.length - 1] = this._correctRowHeaderWidth(widths[widths.length - 1]);
    } else {
      widths = this._correctRowHeaderWidth(widths);
    }
    return widths;
  }
  /**
  * Correct row header width if necessary.
  *
  * @private
  * @param {number | null} width The width to process.
  * @returns {number}
  */
  _correctRowHeaderWidth(width) {
    let rowHeaderWidth = typeof width === "number" ? width : this.wtSettings.getSetting("defaultColumnWidth");
    if (this.correctHeaderWidth) {
      rowHeaderWidth += 1;
    }
    return rowHeaderWidth;
  }
  /**
  * Destroys the table instance. Overridden by MasterTable to release DOM resources.
  */
  destroy() {
  }
  /**
  *
  * @abstract
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {'master'|CLONE_TYPES_ENUM} name Overlay name.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings, name) {
    this.TBODY = null;
    this.THEAD = null;
    this.COLGROUP = null;
    this.hasTableHeight = true;
    this.hasTableWidth = true;
    this.isTableVisible = false;
    this.tableOffset = 0;
    this.holderOffset = 0;
    this.domBindings = domBindings;
    this.isMaster = name === "master";
    this.name = name;
    this.dataAccessObject = dataAccessObject;
    this.facadeGetter = facadeGetter;
    this.wtSettings = wtSettings;
    this.instance = this.dataAccessObject.wot;
    this.wot = this.dataAccessObject.wot;
    this.TABLE = domBindings.rootTable;
    removeTextNodes(this.TABLE);
    this.spreader = this.createSpreader(this.TABLE);
    this.hider = this.createHider(this.spreader);
    this.holder = this.createHolder(this.hider);
    this.wtRootElement = this.holder.parentNode;
    if (this.isMaster) {
      this.alignOverlaysWithTrimmingContainer();
    }
    this.fixTableDomTree();
    this.rowFilter = null;
    this.columnFilter = null;
    this.correctHeaderWidth = false;
    const origRowHeaderWidth = this.wtSettings.getSettingPure("rowHeaderWidth");
    this.wtSettings.update("rowHeaderWidth", () => this._modifyRowHeaderWidth(origRowHeaderWidth));
    this.rowUtils = new RowUtils(this.dataAccessObject, this.wtSettings);
    this.columnUtils = new ColumnUtils(this.dataAccessObject, this.wtSettings);
    this.tableRenderer = new Renderer({
      TABLE: this.TABLE,
      THEAD: this.THEAD ?? void 0,
      COLGROUP: this.COLGROUP ?? void 0,
      TBODY: this.TBODY ?? void 0,
      rowUtils: this.rowUtils,
      columnUtils: this.columnUtils,
      cellRenderer: this.wtSettings.getSettingPure("cellRenderer"),
      stylesHandler: this.wtSettings.getSetting("stylesHandler")
    });
  }
}
const MIXIN_NAME$6 = "stickyRowsBottom";
const stickyRowsBottom = {
  /**
  * Get the source index of the first rendered row. If no rows are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstRenderedRow() {
    const allStickyRows = this.getRenderedRowsCount();
    if (allStickyRows === 0) {
      return -1;
    }
    return (this.wtSettings.getSetting("totalRows") ?? 0) - allStickyRows;
  },
  /**
  * Get the source index of the first row fully visible in the viewport. If no rows are fully visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getFirstVisibleRow() {
    return this.getFirstRenderedRow();
  },
  /**
  * Get the source index of the first row partially visible in the viewport. If no rows are partially visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getFirstPartiallyVisibleRow() {
    return this.getFirstRenderedRow();
  },
  /**
  * Get the source index of the last rendered row. If no rows are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastRenderedRow() {
    const allStickyRows = this.getRenderedRowsCount();
    if (allStickyRows === 0) {
      return -1;
    }
    return (this.wtSettings.getSetting("totalRows") ?? 0) - 1;
  },
  /**
  * Get the source index of the last row fully visible in the viewport. If no rows are fully visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getLastVisibleRow() {
    return this.getLastRenderedRow();
  },
  /**
  * Get the source index of the last row partially visible in the viewport. If no rows are partially visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getLastPartiallyVisibleRow() {
    return this.getLastRenderedRow();
  },
  /**
  * Get the number of rendered rows.
  *
  * @returns {number}
  * @this Table
  */
  getRenderedRowsCount() {
    return Math.min(this.wtSettings.getSetting("totalRows") ?? 0, this.wtSettings.getSetting("fixedRowsBottom"));
  },
  /**
  * Get the number of fully visible rows in the viewport.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getVisibleRowsCount() {
    return this.getRenderedRowsCount();
  },
  /**
  * Get the number of rendered column headers.
  *
  * @returns {number}
  * @this Table
  */
  getColumnHeadersCount() {
    return 0;
  }
};
defineGetter(stickyRowsBottom, "MIXIN_NAME", MIXIN_NAME$6, {
  writable: false,
  enumerable: false
});
const MIXIN_NAME$5 = "stickyColumnsStart";
const stickyColumnsStart = {
  /**
  * Get the source index of the first rendered column. If no columns are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstRenderedColumn() {
    const allStickyColumns = this.getRenderedColumnsCount();
    if (allStickyColumns === 0) {
      return -1;
    }
    return 0;
  },
  /**
  * Get the source index of the first column fully visible in the viewport. If no columns are fully visible, returns an error code: -1.
  * Assumes that all rendered columns are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getFirstVisibleColumn() {
    return this.getFirstRenderedColumn();
  },
  /**
  * Get the source index of the first column partially visible in the viewport. If no columns are partially visible, returns an error code: -1.
  * Assumes that all rendered columns are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getFirstPartiallyVisibleColumn() {
    return this.getFirstRenderedColumn();
  },
  /**
  * Get the source index of the last rendered column. If no columns are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastRenderedColumn() {
    return this.getRenderedColumnsCount() - 1;
  },
  /**
  * Get the source index of the last column fully visible in the viewport. If no columns are fully visible, returns an error code: -1.
  * Assumes that all rendered columns are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getLastVisibleColumn() {
    return this.getLastRenderedColumn();
  },
  /**
  * Get the source index of the last column partially visible in the viewport. If no columns are partially visible, returns an error code: -1.
  * Assumes that all rendered columns are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getLastPartiallyVisibleColumn() {
    return this.getLastRenderedColumn();
  },
  /**
  * Get the number of rendered columns.
  *
  * @returns {number}
  * @this Table
  */
  getRenderedColumnsCount() {
    return Math.min(this.wtSettings.getSetting("totalColumns") ?? 0, this.wtSettings.getSetting("fixedColumnsStart"));
  },
  /**
  * Get the number of fully visible columns in the viewport.
  * Assumes that all rendered columns are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getVisibleColumnsCount() {
    return this.getRenderedColumnsCount();
  },
  /**
  * Get the number of rendered row headers.
  *
  * @returns {number}
  * @this Table
  */
  getRowHeadersCount() {
    return this.dataAccessObject.rowHeaders.length;
  }
};
defineGetter(stickyColumnsStart, "MIXIN_NAME", MIXIN_NAME$5, {
  writable: false,
  enumerable: false
});
class BottomInlineStartCornerOverlayTable extends Table {
  /**
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings) {
    super(dataAccessObject, facadeGetter, domBindings, wtSettings, CLONE_BOTTOM_INLINE_START_CORNER);
  }
}
mixin(BottomInlineStartCornerOverlayTable, stickyRowsBottom);
mixin(BottomInlineStartCornerOverlayTable, stickyColumnsStart);
const CLONE_TOP = "top";
const CLONE_BOTTOM = "bottom";
const CLONE_INLINE_START = "inline_start";
const CLONE_TOP_INLINE_START_CORNER = "top_inline_start_corner";
const CLONE_BOTTOM_INLINE_START_CORNER = "bottom_inline_start_corner";
const CLONE_TYPES = [
  CLONE_TOP,
  CLONE_BOTTOM,
  CLONE_INLINE_START,
  CLONE_TOP_INLINE_START_CORNER,
  CLONE_BOTTOM_INLINE_START_CORNER
];
const CLONE_CLASS_NAMES = /* @__PURE__ */ new Map([
  [
    CLONE_TOP,
    `ht_clone_${CLONE_TOP}`
  ],
  [
    CLONE_BOTTOM,
    `ht_clone_${CLONE_BOTTOM}`
  ],
  [
    CLONE_INLINE_START,
    `ht_clone_${CLONE_INLINE_START} ht_clone_left`
  ],
  [
    CLONE_TOP_INLINE_START_CORNER,
    `ht_clone_${CLONE_TOP_INLINE_START_CORNER} ht_clone_top_left_corner`
  ],
  [
    CLONE_BOTTOM_INLINE_START_CORNER,
    `ht_clone_${CLONE_BOTTOM_INLINE_START_CORNER} ht_clone_bottom_left_corner`
  ]
]);
function _check_private_redeclaration$1C(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$17(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$17(obj, privateSet) {
  _check_private_redeclaration$1C(obj, privateSet);
  privateSet.add(obj);
}
var _getLastColumnIndex = /* @__PURE__ */ new WeakSet(), _getLastRowIndex = /* @__PURE__ */ new WeakSet();
class Scroll {
  /**
  * Scrolls viewport to a cell.
  *
  * @param {CellCoords} coords The cell coordinates.
  * @param {'auto' | 'start' | 'end'} [horizontalSnap='auto'] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @param {'auto' | 'top' | 'bottom'} [verticalSnap='auto'] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on the bottom of
  * the table. When `'auto'`, the viewport is scrolled only when the row is outside of the viewport.
  * @returns {boolean}
  */
  scrollViewport(coords, horizontalSnap, verticalSnap) {
    if (coords.col < 0 || coords.row < 0) {
      return false;
    }
    const scrolledHorizontally = this.scrollViewportHorizontally(coords.col, horizontalSnap);
    const scrolledVertically = this.scrollViewportVertically(coords.row, verticalSnap);
    return scrolledHorizontally || scrolledVertically;
  }
  /**
  * Scrolls viewport to a column.
  *
  * @param {number} column Visual column index.
  * @param {'auto' | 'start' | 'end'} [snapping='auto'] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @returns {boolean}
  */
  scrollViewportHorizontally(column, snapping = "auto") {
    const { drawn, totalColumns } = this.dataAccessObject;
    if (!drawn) {
      return false;
    }
    const snappingObject = createObjectPropListener(snapping);
    column = this.dataAccessObject.wtSettings.getSetting("onBeforeViewportScrollHorizontally", column, snappingObject);
    if (!Number.isInteger(column) || column < 0 || column > totalColumns) {
      return false;
    }
    snapping = snappingObject.value;
    const { fixedColumnsStart, inlineStartOverlay } = this.dataAccessObject;
    const autoSnapping = snapping === "auto";
    if (autoSnapping && column < fixedColumnsStart) {
      return false;
    }
    const firstColumn = this.getFirstVisibleColumn();
    const lastColumn = this.getLastVisibleColumn();
    let result = false;
    if (autoSnapping && (column < firstColumn || column > lastColumn) || !autoSnapping) {
      result = inlineStartOverlay.scrollTo(column, autoSnapping ? column >= this.getLastPartiallyVisibleColumn() : snapping === "end");
    }
    return result;
  }
  /**
  * Scrolls viewport to a row.
  *
  * @param {number} row Visual row index.
  * @param {'auto' | 'top' | 'bottom'} [snapping='auto'] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on
  * the bottom of the table. When `'auto'`, the viewport is scrolled only when the row is outside of
  * the viewport.
  * @returns {boolean}
  */
  scrollViewportVertically(row, snapping = "auto") {
    const { drawn, totalRows } = this.dataAccessObject;
    if (!drawn) {
      return false;
    }
    const snappingObject = createObjectPropListener(snapping);
    row = this.dataAccessObject.wtSettings.getSetting("onBeforeViewportScrollVertically", row, snappingObject);
    if (!Number.isInteger(row) || row < 0 || row > totalRows) {
      return false;
    }
    snapping = snappingObject.value;
    const { fixedRowsBottom, fixedRowsTop, topOverlay } = this.dataAccessObject;
    const autoSnapping = snapping === "auto";
    if (autoSnapping && (row < fixedRowsTop || row > totalRows - fixedRowsBottom - 1)) {
      return false;
    }
    const firstRow = this.getFirstVisibleRow();
    const lastRow = this.getLastVisibleRow();
    let result = false;
    if (autoSnapping && (row < firstRow || row > lastRow) || !autoSnapping) {
      result = topOverlay.scrollTo(row, autoSnapping ? row >= this.getLastPartiallyVisibleRow() : snapping === "bottom");
    }
    return result;
  }
  /**
  * Get first visible row based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getFirstVisibleRow() {
    return this.dataAccessObject.wtTable.getFirstVisibleRow();
  }
  /**
  * Get last visible row based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getLastVisibleRow() {
    return _class_private_method_get$17(this, _getLastRowIndex, getLastRowIndex).call(this, this.dataAccessObject.wtTable.getLastVisibleRow());
  }
  /**
  * Get first partially visible row based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getFirstPartiallyVisibleRow() {
    return this.dataAccessObject.wtTable.getFirstPartiallyVisibleRow();
  }
  /**
  * Get last visible row based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getLastPartiallyVisibleRow() {
    return _class_private_method_get$17(this, _getLastRowIndex, getLastRowIndex).call(this, this.dataAccessObject.wtTable.getLastPartiallyVisibleRow());
  }
  /**
  * Get first visible column based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getFirstVisibleColumn() {
    return this.dataAccessObject.wtTable.getFirstVisibleColumn();
  }
  /**
  * Get last visible column based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getLastVisibleColumn() {
    return _class_private_method_get$17(this, _getLastColumnIndex, getLastColumnIndex).call(this, this.dataAccessObject.wtTable.getLastVisibleColumn());
  }
  /**
  * Get first partially visible column based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getFirstPartiallyVisibleColumn() {
    return this.dataAccessObject.wtTable.getFirstPartiallyVisibleColumn();
  }
  /**
  * Get last partially visible column based on virtual dom and how table is visible in browser window viewport.
  *
  * @returns {number}
  */
  getLastPartiallyVisibleColumn() {
    return _class_private_method_get$17(this, _getLastColumnIndex, getLastColumnIndex).call(this, this.dataAccessObject.wtTable.getLastPartiallyVisibleColumn());
  }
  /**
  * @param {ScrollDao} dataAccessObject Tha data access object.
  */
  constructor(dataAccessObject) {
    _class_private_method_init$17(this, _getLastColumnIndex);
    _class_private_method_init$17(this, _getLastRowIndex);
    this.dataAccessObject = dataAccessObject;
  }
}
function getLastColumnIndex(lastColumnIndex) {
  const { wtSettings, inlineStartOverlay, wtTable, wtViewport, totalColumns, rootWindow } = this.dataAccessObject;
  if (inlineStartOverlay.mainTableScrollableElement === rootWindow) {
    const isRtl2 = wtSettings.getSetting("rtlMode");
    let inlineStartRootElementOffset = null;
    if (isRtl2) {
      const tableRect = wtTable.TABLE.getBoundingClientRect();
      const rootDocument = rootWindow.document;
      const docOffsetWidth = rootDocument.documentElement.offsetWidth;
      inlineStartRootElementOffset = Math.abs(tableRect.right - docOffsetWidth);
    } else {
      const rootElementOffset = offset(wtTable.wtRootElement);
      inlineStartRootElementOffset = rootElementOffset.left;
    }
    const windowScrollLeft = Math.abs(getScrollLeft$1(rootWindow, rootWindow));
    if (inlineStartRootElementOffset > windowScrollLeft) {
      const windowWidth = innerWidth(rootWindow);
      let columnsWidth = wtViewport.getRowHeaderWidth();
      for (let column = 1; column <= totalColumns; column++) {
        columnsWidth += inlineStartOverlay.sumCellSizes(column - 1, column);
        if (inlineStartRootElementOffset + columnsWidth - windowScrollLeft >= windowWidth) {
          lastColumnIndex = column - 2;
          break;
        }
      }
    }
  }
  return lastColumnIndex;
}
function getLastRowIndex(lastRowIndex) {
  const { topOverlay, wtTable, wtViewport, totalRows, rootWindow } = this.dataAccessObject;
  if (topOverlay.mainTableScrollableElement === rootWindow) {
    const rootElementOffset = offset(wtTable.wtRootElement);
    const windowScrollTop = getScrollTop$1(rootWindow, rootWindow);
    if (rootElementOffset.top > windowScrollTop) {
      const windowHeight = innerHeight(rootWindow);
      let rowsHeight = wtViewport.getColumnHeaderHeight();
      for (let row = 1; row <= totalRows; row++) {
        rowsHeight += topOverlay.sumCellSizes(row - 1, row);
        if (rootElementOffset.top + rowsHeight - windowScrollTop >= windowHeight) {
          lastRowIndex = row - 2;
          break;
        }
      }
    }
  }
  return lastRowIndex;
}
class CoreAbstract {
  /**
  * Gets or creates the event manager instance.
  *
  * @returns {EventManager} The event manager instance.
  */
  get eventManager() {
    return new EventManager(this);
  }
  /**
  * Gets the root document from dom bindings.
  *
  * @returns {Document} The root document.
  */
  get rootDocument() {
    return this.domBindings.rootDocument;
  }
  /**
  * Gets the root window from dom bindings.
  *
  * @returns {Window} The root window.
  */
  get rootWindow() {
    return this.domBindings.rootWindow;
  }
  /**
  * Delegates to wtSettings.getSetting.
  *
  * @param {string} key The settings key.
  * @param {...unknown} args Additional arguments.
  * @returns {unknown}
  */
  getSetting(key, ...args) {
    return this.wtSettings.getSetting(key, ...args);
  }
  /**
  * Delegates to wtSettings.update.
  *
  * @param {string} key The settings key.
  * @param {unknown} value The value to set.
  */
  update(key, value) {
    this.wtSettings.update(key, value);
  }
  /**
  * Finds and stores original table headers, setting up column header rendering callbacks if not already configured.
  */
  findOriginalHeaders() {
    const originalHeaders = [];
    if (this.wtTable.THEAD && this.wtTable.THEAD.childNodes.length && this.wtTable.THEAD.childNodes[0].childNodes.length) {
      for (let c = 0, clen = this.wtTable.THEAD.childNodes[0].childNodes.length; c < clen; c++) {
        originalHeaders.push(this.wtTable.THEAD.childNodes[0].childNodes[c].innerHTML);
      }
      if (!this.wtSettings.getSetting("columnHeaders").length) {
        this.wtSettings.update("columnHeaders", [
          function(column, TH) {
            fastInnerText(TH, originalHeaders[column]);
          }
        ]);
      }
    }
  }
  /**
  * Creates and returns the CellCoords object.
  *
  * @param {*} row The row index.
  * @param {*} column The column index.
  * @returns {CellCoords}
  */
  createCellCoords(row, column) {
    return new CellCoords(row, column, this.wtSettings.getSetting("rtlMode"));
  }
  /**
  * Creates and returns the CellRange object.
  *
  * @param {CellCoords} highlight The highlight coordinates.
  * @param {CellCoords} from The from coordinates.
  * @param {CellCoords} to The to coordinates.
  * @returns {CellRange}
  */
  createCellRange(highlight, from, to) {
    return new CellRange(highlight, from, to, this.wtSettings.getSetting("rtlMode"));
  }
  /**
  * Force rerender of Walkontable.
  *
  * @param {boolean} [fastDraw=false] When `true`, try to refresh only the positions of borders without rerendering
  *                                   the data. It will only work if Table.draw() does not force
  *                                   rendering anyway.
  * @returns {Walkontable}
  */
  draw(fastDraw = false) {
    this.drawInterrupted = false;
    if (!this.wtTable.isVisible() || hasZeroHeight(this.wtTable.wtRootElement.parentNode)) {
      this.drawInterrupted = true;
    } else {
      this.wtTable.draw(fastDraw);
    }
    return this;
  }
  /**
  * Returns the TD at coords. If topmost is set to true, returns TD from the topmost overlay layer,
  * if not set or set to false, returns TD from the master table.
  *
  * @param {CellCoords} coords The cell coordinates.
  * @param {boolean} [topmost=false] If set to `true`, it returns the TD element from the topmost overlay. For example,
  *                                  if the wanted cell is in the range of fixed rows, it will return a TD element
  *                                  from the top overlay.
  * @returns {HTMLElement}
  */
  getCell(coords, topmost = false) {
    if (coords.row === null || coords.col === null) {
      return void 0;
    }
    if (!topmost) {
      return this.wtTable.getCell(coords);
    }
    const totalRows = this.wtSettings.getSetting("totalRows");
    const fixedRowsTop = this.wtSettings.getSetting("fixedRowsTop");
    const fixedRowsBottom = this.wtSettings.getSetting("fixedRowsBottom");
    const fixedColumnsStart = this.wtSettings.getSetting("fixedColumnsStart");
    if (coords.row < fixedRowsTop && coords.col < fixedColumnsStart) {
      return this.wtOverlays.topInlineStartCornerOverlay.clone?.wtTable.getCell(coords);
    } else if (coords.row < fixedRowsTop) {
      return this.wtOverlays.topOverlay.clone?.wtTable.getCell(coords);
    } else if (coords.col < fixedColumnsStart && coords.row >= totalRows - fixedRowsBottom) {
      return this.wtOverlays.bottomInlineStartCornerOverlay?.clone?.wtTable.getCell(coords);
    } else if (coords.col < fixedColumnsStart) {
      return this.wtOverlays.inlineStartOverlay.clone?.wtTable.getCell(coords);
    } else if (coords.row < totalRows && coords.row >= totalRows - fixedRowsBottom) {
      return this.wtOverlays.bottomOverlay?.clone?.wtTable.getCell(coords);
    }
    return this.wtTable.getCell(coords);
  }
  /**
  * Scrolls the viewport to a cell (rerenders if needed).
  *
  * @param {CellCoords} coords The cell coordinates to scroll to.
  * @param {'auto' | 'start' | 'end'} [horizontalSnap='auto'] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @param {'auto' | 'top' | 'bottom'} [verticalSnap='auto'] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on the bottom of
  * the table. When `'auto'`, the viewport is scrolled only when the row is outside of the viewport.
  * @returns {boolean}
  */
  scrollViewport(coords, horizontalSnap, verticalSnap) {
    if (coords.row === null || coords.col === null) {
      return false;
    }
    return this.wtScroll.scrollViewport(coords, horizontalSnap, verticalSnap);
  }
  /**
  * Scrolls the viewport to a column (rerenders if needed).
  *
  * @param {number} column Visual column index.
  * @param {'auto' | 'start' | 'end'} [snapping='auto'] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @returns {boolean}
  */
  scrollViewportHorizontally(column, snapping) {
    return this.wtScroll.scrollViewportHorizontally(column, snapping);
  }
  /**
  * Scrolls the viewport to a row (rerenders if needed).
  *
  * @param {number} row Visual row index.
  * @param {'auto' | 'top' | 'bottom'} [snapping='auto'] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on
  * the bottom of the table. When `'auto'`, the viewport is scrolled only when the row is outside of
  * the viewport.
  * @returns {boolean}
  */
  scrollViewportVertically(row, snapping) {
    return this.wtScroll.scrollViewportVertically(row, snapping);
  }
  /**
  * @returns {Array}
  */
  getViewport() {
    return [
      this.wtTable.getFirstVisibleRow(),
      this.wtTable.getFirstVisibleColumn(),
      this.wtTable.getLastVisibleRow(),
      this.wtTable.getLastVisibleColumn()
    ];
  }
  /**
  * Gets the overlay instance by its name. Returns null in the base implementation.
  *
  * @param {string} _overlayName The overlay name.
  * @returns {object | null}
  */
  getOverlayByName(_overlayName) {
    return null;
  }
  /**
  * Exports settings as CSS class names. No-op in the base implementation.
  */
  exportSettingsAsClassNames() {
  }
  /**
  * Destroy instance.
  */
  destroy() {
    this.wtOverlays.destroy();
    this.wtEvent.destroy();
  }
  /**
  * Create data access object for scroll.
  *
  * @protected
  * @returns {ScrollDao}
  */
  createScrollDao() {
    const wot = this;
    return {
      get drawn() {
        return wot.drawn;
      },
      get topOverlay() {
        return wot.wtOverlays.topOverlay;
      },
      get inlineStartOverlay() {
        return wot.wtOverlays.inlineStartOverlay;
      },
      get wtTable() {
        return wot.wtTable;
      },
      get wtViewport() {
        return wot.wtViewport;
      },
      get wtSettings() {
        return wot.wtSettings;
      },
      get rootWindow() {
        return wot.domBindings.rootWindow;
      },
      // TODO refactoring, consider about using injecting wtSettings into scroll (it'll enables remove dao layer)
      get totalRows() {
        return wot.wtSettings.getSetting("totalRows");
      },
      get totalColumns() {
        return wot.wtSettings.getSetting("totalColumns");
      },
      get fixedRowsTop() {
        return wot.wtSettings.getSetting("fixedRowsTop");
      },
      get fixedRowsBottom() {
        return wot.wtSettings.getSetting("fixedRowsBottom");
      },
      get fixedColumnsStart() {
        return wot.wtSettings.getSetting("fixedColumnsStart");
      }
    };
  }
  // TODO refactoring: it will be much better to not use DAO objects. They are needed for now to provide
  // dynamically access to related objects
  /**
  * Create data access object for wtTable.
  *
  * @protected
  * @returns {Record<string, unknown>}
  */
  getTableDao() {
    const wot = this;
    return {
      get wot() {
        return wot;
      },
      get parentTableOffset() {
        return wot.cloneSource.wtTable.tableOffset;
      },
      get cloneSource() {
        return wot.cloneSource;
      },
      get workspaceWidth() {
        return wot.wtViewport.getWorkspaceWidth();
      },
      get wtViewport() {
        return wot.wtViewport;
      },
      get wtOverlays() {
        return wot.wtOverlays;
      },
      get selectionManager() {
        return wot.selectionManager;
      },
      get drawn() {
        return wot.drawn;
      },
      set drawn(v) {
        wot.drawn = v;
      },
      get wtTable() {
        return wot.wtTable;
      },
      get startColumnRendered() {
        return wot.wtViewport.columnsRenderCalculator?.startColumn ?? null;
      },
      get startColumnVisible() {
        return wot.wtViewport.columnsVisibleCalculator?.startColumn ?? null;
      },
      get startColumnPartiallyVisible() {
        return wot.wtViewport.columnsPartiallyVisibleCalculator?.startColumn ?? null;
      },
      get endColumnRendered() {
        return wot.wtViewport.columnsRenderCalculator?.endColumn ?? null;
      },
      get endColumnVisible() {
        return wot.wtViewport.columnsVisibleCalculator?.endColumn ?? null;
      },
      get endColumnPartiallyVisible() {
        return wot.wtViewport.columnsPartiallyVisibleCalculator?.endColumn ?? null;
      },
      get countColumnsRendered() {
        return wot.wtViewport.columnsRenderCalculator?.count ?? 0;
      },
      get countColumnsVisible() {
        return wot.wtViewport.columnsVisibleCalculator?.count ?? 0;
      },
      get startRowRendered() {
        return wot.wtViewport.rowsRenderCalculator?.startRow ?? null;
      },
      get startRowVisible() {
        return wot.wtViewport.rowsVisibleCalculator?.startRow ?? null;
      },
      get startRowPartiallyVisible() {
        return wot.wtViewport.rowsPartiallyVisibleCalculator?.startRow ?? null;
      },
      get endRowRendered() {
        return wot.wtViewport.rowsRenderCalculator?.endRow ?? null;
      },
      get endRowVisible() {
        return wot.wtViewport.rowsVisibleCalculator?.endRow ?? null;
      },
      get endRowPartiallyVisible() {
        return wot.wtViewport.rowsPartiallyVisibleCalculator?.endRow ?? null;
      },
      get countRowsRendered() {
        return wot.wtViewport.rowsRenderCalculator?.count ?? 0;
      },
      get countRowsVisible() {
        return wot.wtViewport.rowsVisibleCalculator?.count ?? 0;
      },
      get columnHeaders() {
        return wot.wtSettings.getSetting("columnHeaders");
      },
      get rowHeaders() {
        return wot.wtSettings.getSetting("rowHeaders");
      }
    };
  }
  /**
  * @param {HTMLTableElement} table Main table.
  * @param {Settings} settings The Walkontable settings.
  */
  constructor(table, settings) {
    this.guid = `wt_${randomString()}`;
    this.drawInterrupted = false;
    this.drawn = false;
    this.activeOverlayName = "master";
    this.domBindings = {
      rootTable: table,
      rootDocument: table.ownerDocument,
      rootWindow: table.ownerDocument.defaultView
    };
    this.wtSettings = settings;
    this.wtScroll = new Scroll(this.createScrollDao());
  }
}
class Clone extends CoreAbstract {
  /**
  * @param {HTMLTableElement} table Main table.
  * @param {SettingsPure|Settings} settings The Walkontable settings.
  * @param {WalkontableCloneOptions} clone Clone data.
  */
  constructor(table, settings, clone2) {
    super(table, settings);
    const facadeGetter = this.wtSettings.getSetting("facade", this);
    this.cloneSource = clone2.source;
    this.cloneOverlay = clone2.overlay;
    this.wtTable = this.cloneOverlay.createTable(this.getTableDao(), facadeGetter, this.domBindings, this.wtSettings);
    this.wtViewport = clone2.viewport;
    this.selectionManager = clone2.selectionManager;
    this.wtEvent = new Event$1(facadeGetter, this.domBindings, this.wtSettings, this.eventManager, this.wtTable, this.selectionManager, clone2.event);
    this.findOriginalHeaders();
  }
}
class Overlay {
  /**
  * Checks if the overlay rendering state has changed.
  *
  * @returns {boolean}
  */
  hasRenderingStateChanged() {
    return this.needFullRender !== this.shouldBeRendered();
  }
  /**
  * Updates internal state with an information about the need of full rendering of the overlay in the next draw cycles.
  *
  * If the state is changed to render the overlay, the `needFullRender` property is set to `true` which means that
  * the overlay will be fully rendered in the current draw cycle. If the state is changed to not render the overlay,
  * the `needFullRender` property is set to `false` which means that the overlay will be fully rendered in the
  * current draw cycle but it will not be rendered in the next draw cycles.
  *
  * @param {'before' | 'after'} drawPhase The phase of the rendering process.
  */
  updateStateOfRendering(drawPhase) {
    if (drawPhase === "before" && this.shouldBeRendered()) {
      this.needFullRender = true;
    } else if (drawPhase === "after" && !this.shouldBeRendered()) {
      this.needFullRender = false;
    }
  }
  /**
  * Checks if overlay should be fully rendered.
  *
  * @returns {boolean}
  */
  shouldBeRendered() {
    return true;
  }
  /**
  * Update the trimming container.
  */
  updateTrimmingContainer() {
    this.trimmingContainer = getTrimmingContainer(this.hider.parentNode?.parentNode ?? this.hider);
  }
  /**
  * Update the main scrollable element.
  */
  updateMainScrollableElement() {
    const { wtTable } = this.wot;
    const { rootWindow } = this.domBindings;
    const computedOverflow = rootWindow.getComputedStyle(wtTable.wtRootElement.parentNode).getPropertyValue("overflow");
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    if (computedOverflow === "hidden" || computedOverflow === "clip") {
      this.mainTableScrollableElement = this.wot.wtTable.holder;
    } else if (preventOverflow === "horizontal" && this.type === CLONE_TOP || preventOverflow === "vertical" && this.type === CLONE_INLINE_START) {
      this.mainTableScrollableElement = rootWindow;
    } else {
      this.mainTableScrollableElement = getScrollableElement(wtTable.TABLE);
    }
  }
  /**
  * Calculates coordinates of the provided element, relative to the root Handsontable element.
  * NOTE: The element needs to be a child of the overlay in order for the method to work correctly.
  *
  * @param {HTMLElement} element The cell element to calculate the position for.
  * @param {number} rowIndex Visual row index.
  * @param {number} columnIndex Visual column index.
  * @returns {{top: number, start: number}|undefined}
  */
  getRelativeCellPosition(element, rowIndex, columnIndex) {
    if (!this.clone || this.clone.wtTable.holder.contains(element) === false) {
      warn$1(`The provided element is not a child of the ${this.type} overlay`);
      return;
    }
    const windowScroll = this.mainTableScrollableElement === this.domBindings.rootWindow;
    const fixedColumnStart = columnIndex < this.wtSettings.getSetting("fixedColumnsStart");
    const fixedRowTop = rowIndex < this.wtSettings.getSetting("fixedRowsTop");
    const fixedRowBottom = rowIndex >= this.wtSettings.getSetting("totalRows") - this.wtSettings.getSetting("fixedRowsBottom");
    const spreader = this.clone.wtTable.spreader;
    const spreaderOffset = {
      start: this.getRelativeStartPosition(spreader),
      top: spreader.offsetTop
    };
    const elementOffset = {
      start: this.getRelativeStartPosition(element),
      top: element.offsetTop
    };
    let offsetObject = null;
    if (windowScroll) {
      offsetObject = this.getRelativeCellPositionWithinWindow(fixedRowTop, fixedColumnStart, elementOffset, spreaderOffset);
    } else {
      offsetObject = this.getRelativeCellPositionWithinHolder(fixedRowTop, fixedRowBottom, fixedColumnStart, elementOffset, spreaderOffset);
    }
    return offsetObject;
  }
  /**
  * Get inline start value depending of direction.
  *
  * @param {HTMLElement} el Element.
  * @returns {number}
  */
  getRelativeStartPosition(el) {
    return this.isRtl() ? el.offsetParent.offsetWidth - el.offsetLeft - el.offsetWidth : el.offsetLeft;
  }
  /**
  * Calculates coordinates of the provided element, relative to the root Handsontable element within a table with window
  * as a scrollable element.
  *
  * @private
  * @param {boolean} onFixedRowTop `true` if the coordinates point to a place within the top fixed rows.
  * @param {boolean} onFixedColumn `true` if the coordinates point to a place within the fixed columns.
  * @param {number} elementOffset Offset position of the cell element.
  * @param {number} spreaderOffset Offset position of the spreader element.
  * @returns {{top: number, left: number}}
  */
  getRelativeCellPositionWithinWindow(onFixedRowTop, onFixedColumn, elementOffset, spreaderOffset) {
    const absoluteRootElementPosition = this.wot.wtTable.wtRootElement.getBoundingClientRect();
    const masterScrollsHolder = this.wot.wtOverlays.scrollableElement !== this.domBindings.rootWindow;
    const tableScrollPosition = {
      horizontal: masterScrollsHolder ? this.wot.wtOverlays.inlineStartOverlay.getScrollPosition() : 0,
      vertical: masterScrollsHolder ? this.wot.wtOverlays.topOverlay.getScrollPosition() : 0
    };
    let horizontalOffset = 0;
    let verticalOffset = 0;
    if (!onFixedColumn) {
      horizontalOffset = spreaderOffset.start - tableScrollPosition.horizontal;
    } else {
      let absoluteRootElementStartPosition = absoluteRootElementPosition.left;
      if (this.isRtl()) {
        absoluteRootElementStartPosition = this.domBindings.rootWindow.innerWidth - (absoluteRootElementPosition.left + absoluteRootElementPosition.width + getScrollbarWidth());
      }
      horizontalOffset = absoluteRootElementStartPosition <= 0 ? -1 * absoluteRootElementStartPosition : 0;
    }
    if (onFixedRowTop && this.clone) {
      const absoluteOverlayPosition = this.clone.wtTable.TABLE.getBoundingClientRect();
      verticalOffset = absoluteOverlayPosition.top - absoluteRootElementPosition.top;
    } else {
      verticalOffset = spreaderOffset.top - tableScrollPosition.vertical;
    }
    return {
      start: elementOffset.start + horizontalOffset,
      top: elementOffset.top + verticalOffset
    };
  }
  /**
  * Calculates coordinates of the provided element, relative to the root Handsontable element within a table with window
  * as a scrollable element.
  *
  * @private
  * @param {boolean} onFixedRowTop `true` if the coordinates point to a place within the top fixed rows.
  * @param {boolean} onFixedRowBottom `true` if the coordinates point to a place within the bottom fixed rows.
  * @param {boolean} onFixedColumn `true` if the coordinates point to a place within the fixed columns.
  * @param {number} elementOffset Offset position of the cell element.
  * @param {number} spreaderOffset Offset position of the spreader element.
  * @returns {{top: number, left: number}}
  */
  getRelativeCellPositionWithinHolder(onFixedRowTop, onFixedRowBottom, onFixedColumn, elementOffset, spreaderOffset) {
    const tableScrollPosition = {
      horizontal: this.wot.wtOverlays.inlineStartOverlay.getScrollPosition(),
      vertical: this.wot.wtOverlays.topOverlay.getScrollPosition()
    };
    let horizontalOffset = 0;
    let verticalOffset = 0;
    if (!onFixedColumn) {
      horizontalOffset = tableScrollPosition.horizontal - spreaderOffset.start;
    }
    if (onFixedRowBottom && this.clone) {
      const absoluteRootElementPosition = this.wot.wtTable.wtRootElement.getBoundingClientRect();
      const absoluteOverlayPosition = this.clone.wtTable.TABLE.getBoundingClientRect();
      verticalOffset = absoluteOverlayPosition.top * -1 + absoluteRootElementPosition.top;
    } else if (!onFixedRowTop) {
      verticalOffset = tableScrollPosition.vertical - spreaderOffset.top;
    }
    return {
      start: elementOffset.start - horizontalOffset,
      top: elementOffset.top - verticalOffset
    };
  }
  /**
  * Make a clone of table for overlay.
  *
  * @returns {Clone}
  */
  makeClone() {
    if (CLONE_TYPES.indexOf(this.type) === -1) {
      throwWithCause(`Clone type "${this.type}" is not supported.`);
    }
    const { wtTable, wtSettings } = this.wot;
    const { rootDocument, rootWindow } = this.domBindings;
    const clone2 = rootDocument.createElement("div");
    const clonedTable = rootDocument.createElement("table");
    const tableParent = wtTable.wtRootElement.parentNode;
    if (!tableParent) {
      throwWithCause("The Walkontable root element has no parent node.");
    }
    clone2.className = `${CLONE_CLASS_NAMES.get(this.type)} handsontable`;
    clone2.setAttribute("dir", this.isRtl() ? "rtl" : "ltr");
    clone2.style.position = "absolute";
    clone2.style.top = "0";
    clone2.style.overflow = "visible";
    if (this.isRtl()) {
      clone2.style.right = "0";
    } else {
      clone2.style.left = "0";
    }
    if (wtSettings.getSetting("ariaTags")) {
      setAttribute(clone2, [
        A11Y_PRESENTATION()
      ]);
    }
    clonedTable.className = wtTable.TABLE.className;
    const mainTableRole = wtTable.TABLE.getAttribute("role");
    if (mainTableRole) {
      clonedTable.setAttribute("role", mainTableRole);
    }
    clone2.appendChild(clonedTable);
    tableParent.appendChild(clone2);
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    const computedOverflow = rootWindow.getComputedStyle(tableParent).getPropertyValue("overflow");
    if (computedOverflow === "hidden" || computedOverflow === "clip") {
      this.mainTableScrollableElement = wtTable.holder;
    } else if (preventOverflow === "horizontal" && this.type === CLONE_TOP || preventOverflow === "vertical" && this.type === CLONE_INLINE_START) {
      this.mainTableScrollableElement = rootWindow;
    } else {
      this.mainTableScrollableElement = getScrollableElement(wtTable.TABLE);
    }
    return new Clone(clonedTable, this.wtSettings, {
      source: this.wot,
      overlay: this,
      viewport: this.wot.wtViewport,
      event: this.wot.wtEvent,
      selectionManager: this.wot.selectionManager
    });
  }
  /**
  * Refresh/Redraw overlay.
  *
  * @param {boolean} [fastDraw=false] When `true`, try to refresh only the positions of borders without rerendering
  *                                   the data. It will only work if Table.draw() does not force
  *                                   rendering anyway.
  */
  refresh(fastDraw = false) {
    if (this.needFullRender && this.clone) {
      const cloneSource = this.clone.cloneSource;
      cloneSource.activeOverlayName = this.clone.wtTable.name;
      this.clone.draw(fastDraw);
      cloneSource.activeOverlayName = "master";
    }
  }
  /**
  * Reset overlay styles to initial values.
  */
  reset() {
    if (!this.clone) {
      return;
    }
    const holder2 = this.clone.wtTable.holder;
    const hider = this.clone.wtTable.hider;
    const holderStyle = holder2.style;
    const hiderStyle = hider.style;
    const rootStyle = holder2.parentNode.style;
    [
      holderStyle,
      hiderStyle,
      rootStyle
    ].forEach((style) => {
      style.width = "";
      style.height = "";
    });
  }
  /**
  * Determine if Walkontable is running in RTL mode.
  *
  * @returns {boolean}
  */
  isRtl() {
    return this.wtSettings.getSetting("rtlMode");
  }
  /**
  * Destroy overlay instance.
  */
  destroy() {
    this.clone?.eventManager.destroy();
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @TODO refactoring: check if can be deleted.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {CLONE_TYPES_ENUM} type The overlay type name (clone name).
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {DomBindings} domBindings Dom elements bound to the current instance.
  */
  constructor(wotInstance, facadeGetter, type, wtSettings, domBindings) {
    defineGetter(this, "wot", wotInstance, {
      writable: false
    });
    this.domBindings = domBindings;
    this.facadeGetter = facadeGetter;
    this.wtSettings = wtSettings;
    const { TABLE, hider, spreader, holder: holder2, wtRootElement } = this.wot.wtTable;
    this.instance = this.wot;
    this.type = type;
    this.TABLE = TABLE;
    this.hider = hider;
    this.spreader = spreader;
    this.holder = holder2;
    this.wtRootElement = wtRootElement;
    this.trimmingContainer = getTrimmingContainer(this.hider.parentNode?.parentNode ?? this.hider);
    this.needFullRender = this.shouldBeRendered();
    this.clone = this.makeClone();
  }
}
class BottomInlineStartCornerOverlay extends Overlay {
  /**
  * Factory method to create a subclass of `Table` that is relevant to this overlay.
  *
  * @see Table#constructor
  * @param {...*} args Parameters that will be forwarded to the `Table` constructor.
  * @returns {BottomInlineStartCornerOverlayTable}
  */
  createTable(...args) {
    return new BottomInlineStartCornerOverlayTable(...args);
  }
  /**
  * Checks if overlay should be fully rendered.
  *
  * @returns {boolean}
  */
  shouldBeRendered() {
    return this.wtSettings.getSetting("shouldRenderBottomOverlay") && this.wtSettings.getSetting("shouldRenderInlineStartOverlay");
  }
  /**
  * Updates the corner overlay position.
  *
  * @returns {boolean}
  */
  resetFixedPosition() {
    const { wot } = this;
    this.updateTrimmingContainer();
    const { clone: clone2 } = this;
    if (!wot.wtTable.holder.parentNode || !clone2) {
      return false;
    }
    const overlayRoot = clone2.wtTable.holder.parentNode;
    overlayRoot.style.top = "";
    if (this.trimmingContainer === this.domBindings.rootWindow) {
      const inlineStartOffset = this.inlineStartOverlay.getOverlayOffset();
      const masterTableRect = this.wot.wtTable.TABLE.getBoundingClientRect();
      const masterHolderRect = this.wot.wtTable.holder.getBoundingClientRect();
      const masterTableOverflow = Math.max(0, masterTableRect.bottom - masterHolderRect.bottom);
      const bottom2 = this.bottomOverlay.getOverlayOffset() - masterTableOverflow;
      overlayRoot.style[this.isRtl() ? "right" : "left"] = `${inlineStartOffset}px`;
      overlayRoot.style.bottom = `${bottom2}px`;
    } else {
      resetCssTransform(overlayRoot);
      this.repositionOverlay();
    }
    let tableHeight = outerHeight(clone2.wtTable.TABLE);
    const tableWidth = outerWidth(clone2.wtTable.TABLE);
    if (!this.wot.wtTable.hasDefinedSize()) {
      tableHeight = 0;
    }
    overlayRoot.style.height = `${tableHeight}px`;
    overlayRoot.style.width = `${tableWidth}px`;
    return true;
  }
  /**
  * Sets the scroll position (no-op for corner overlay).
  * @param {number} _pos The scroll position (unused).
  * @returns {boolean} Always returns false.
  */
  setScrollPosition(_pos) {
    return false;
  }
  /**
  * Gets the scroll position (no-op for corner overlay).
  * @returns {number} Always returns 0.
  */
  getScrollPosition() {
    return 0;
  }
  /**
  * Gets the table parent offset (no-op for corner overlay).
  * @returns {number} Always returns 0.
  */
  getTableParentOffset() {
    return 0;
  }
  /**
  * Gets the overlay offset (no-op for corner overlay).
  * @returns {number} Always returns 0.
  */
  getOverlayOffset() {
    return 0;
  }
  /**
  * Handles scroll events (no-op for corner overlay).
  */
  onScroll() {
  }
  /**
  * Sums the size of cells between two indexes (no-op for corner overlay).
  * @param {number} _from The starting cell index (unused).
  * @param {number} _to The ending cell index (unused).
  * @returns {number} Always returns 0.
  */
  sumCellSizes(_from, _to) {
    return 0;
  }
  /**
  * Adjusts the size of overlay elements (intentionally empty).
  */
  adjustElementsSize() {
  }
  /**
  * Applies changes to the DOM (intentionally empty).
  */
  applyToDOM() {
  }
  /**
  * Scrolls to a specified cell index (no-op for corner overlay).
  * @param {number} _sourceIndex The source row or column index (unused).
  * @param {boolean} _snapToEdge Whether to snap to the edge (unused).
  * @returns {boolean} Always returns false.
  */
  scrollTo(_sourceIndex, _snapToEdge) {
    return false;
  }
  /**
  * Reposition the overlay.
  */
  repositionOverlay() {
    if (!this.clone) {
      return;
    }
    const { wtTable, wtViewport } = this.wot;
    const { rootDocument } = this.domBindings;
    const cloneRoot = this.clone.wtTable.holder.parentNode;
    let bottomOffset = 0;
    if (!wtViewport.hasVerticalScroll()) {
      bottomOffset += wtViewport.getWorkspaceHeight() - wtTable.getTotalHeight();
    }
    if (wtViewport.hasVerticalScroll() && wtViewport.hasHorizontalScroll()) {
      bottomOffset += getScrollbarWidth(rootDocument);
    }
    cloneRoot.style.bottom = `${bottomOffset}px`;
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @TODO refactoring: check if can be deleted.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {DomBindings} domBindings Dom elements bound to the current instance.
  * @param {BottomOverlay} bottomOverlay The instance of the Top overlay.
  * @param {InlineStartOverlay} inlineStartOverlay The instance of the InlineStart overlay.
  */
  constructor(wotInstance, facadeGetter, wtSettings, domBindings, bottomOverlay, inlineStartOverlay) {
    super(wotInstance, facadeGetter, CLONE_BOTTOM_INLINE_START_CORNER, wtSettings, domBindings);
    this.bottomOverlay = bottomOverlay;
    this.inlineStartOverlay = inlineStartOverlay;
  }
}
const MIXIN_NAME$4 = "calculatedColumns";
const calculatedColumns = {
  /**
  * Get the source index of the first rendered column. If no columns are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstRenderedColumn() {
    const startColumn = this.dataAccessObject.startColumnRendered;
    if (startColumn === null) {
      return -1;
    }
    return startColumn;
  },
  /**
  * Get the source index of the first column fully visible in the viewport. If no columns are fully visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstVisibleColumn() {
    const startColumn = this.dataAccessObject.startColumnVisible;
    if (startColumn === null) {
      return -1;
    }
    return startColumn;
  },
  /**
  * Get the source index of the first column partially visible in the viewport. If no columns are partially visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstPartiallyVisibleColumn() {
    const startColumn = this.dataAccessObject.startColumnPartiallyVisible;
    if (startColumn === null) {
      return -1;
    }
    return startColumn;
  },
  /**
  * Get the source index of the last rendered column. If no columns are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastRenderedColumn() {
    const endColumn = this.dataAccessObject.endColumnRendered;
    if (endColumn === null) {
      return -1;
    }
    return endColumn;
  },
  /**
  * Get the source index of the last column fully visible in the viewport. If no columns are fully visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastVisibleColumn() {
    const endColumn = this.dataAccessObject.endColumnVisible;
    if (endColumn === null) {
      return -1;
    }
    return endColumn;
  },
  /**
  * Get the source index of the last column partially visible in the viewport. If no columns are partially visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastPartiallyVisibleColumn() {
    const endColumn = this.dataAccessObject.endColumnPartiallyVisible;
    if (endColumn === null) {
      return -1;
    }
    return endColumn;
  },
  /**
  * Get the number of rendered columns.
  *
  * @returns {number}
  * @this Table
  */
  getRenderedColumnsCount() {
    return this.dataAccessObject.countColumnsRendered;
  },
  /**
  * Get the number of fully visible columns in the viewport.
  *
  * @returns {number}
  * @this Table
  */
  getVisibleColumnsCount() {
    return this.dataAccessObject.countColumnsVisible;
  },
  /**
  * Get the number of rendered row headers.
  *
  * @returns {number}
  * @this Table
  */
  getRowHeadersCount() {
    return this.dataAccessObject.rowHeaders.length;
  }
};
defineGetter(calculatedColumns, "MIXIN_NAME", MIXIN_NAME$4, {
  writable: false,
  enumerable: false
});
class BottomOverlayTable extends Table {
  /**
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings) {
    super(dataAccessObject, facadeGetter, domBindings, wtSettings, CLONE_BOTTOM);
  }
}
mixin(BottomOverlayTable, stickyRowsBottom);
mixin(BottomOverlayTable, calculatedColumns);
class BottomOverlay extends Overlay {
  /**
  * Factory method to create a subclass of `Table` that is relevant to this overlay.
  *
  * @see Table#constructor
  * @param {...*} args Parameters that will be forwarded to the `Table` constructor.
  * @returns {BottomOverlayTable}
  */
  createTable(...args) {
    return new BottomOverlayTable(...args);
  }
  /**
  * Checks if overlay should be fully rendered.
  *
  * @returns {boolean}
  */
  shouldBeRendered() {
    return this.wtSettings.getSetting("shouldRenderBottomOverlay");
  }
  /**
  * Updates the top overlay position.
  *
  * @returns {boolean}
  */
  resetFixedPosition() {
    if (!this.needFullRender || !this.shouldBeRendered() || !this.wot.wtTable.holder.parentNode || !this.clone) {
      return false;
    }
    const { rootWindow } = this.domBindings;
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    overlayRoot.style.top = "";
    let overlayPosition = 0;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    if (this.trimmingContainer === rootWindow && (!preventOverflow || preventOverflow !== "vertical")) {
      overlayPosition = this.getOverlayOffset();
      const masterTableRect = this.wot.wtTable.TABLE.getBoundingClientRect();
      const masterHolderRect = this.wot.wtTable.holder.getBoundingClientRect();
      const masterTableOverflow = Math.max(0, masterTableRect.bottom - masterHolderRect.bottom);
      overlayRoot.style.bottom = `${overlayPosition - masterTableOverflow}px`;
    } else {
      overlayPosition = this.getScrollPosition();
      this.repositionOverlay();
    }
    const positionChanged = this.adjustHeaderBordersPosition(overlayPosition);
    this.adjustElementsSize();
    return positionChanged;
  }
  /**
  * Updates the bottom overlay position.
  */
  repositionOverlay() {
    if (!this.clone) {
      return;
    }
    const { wtTable, wtViewport } = this.wot;
    const { rootDocument } = this.domBindings;
    const cloneRoot = this.clone.wtTable.holder.parentNode;
    let bottomOffset = 0;
    if (!wtViewport.hasVerticalScroll()) {
      bottomOffset += wtViewport.getWorkspaceHeight() - wtTable.getTotalHeight();
    }
    if (wtViewport.hasVerticalScroll() && wtViewport.hasHorizontalScroll()) {
      bottomOffset += getScrollbarWidth(rootDocument);
    }
    cloneRoot.style.bottom = `${bottomOffset}px`;
  }
  /**
  * Sets the main overlay's vertical scroll position.
  *
  * @param {number} pos The scroll position.
  * @returns {boolean}
  */
  setScrollPosition(pos) {
    const { rootWindow } = this.domBindings;
    const scrollableElement = this.mainTableScrollableElement;
    const scrollEl = scrollableElement;
    const getScrollPosition = () => {
      return scrollableElement === rootWindow ? rootWindow.scrollY : scrollEl.scrollTop;
    };
    const setScrollPosition2 = (newPosition) => {
      if (scrollableElement === rootWindow) {
        rootWindow.scrollTo(rootWindow.scrollX, newPosition);
      } else {
        scrollEl.scrollTop = newPosition;
      }
    };
    const oldScrollPosition = getScrollPosition();
    let result = false;
    if (pos !== oldScrollPosition) {
      setScrollPosition2(pos);
      result = oldScrollPosition !== getScrollPosition();
    }
    return result;
  }
  /**
  * Triggers onScroll hook callback.
  */
  onScroll() {
    this.wtSettings.getSetting("onScrollHorizontally");
  }
  /**
  * Calculates total sum cells height.
  *
  * @param {number} from Row index which calculates started from.
  * @param {number} to Row index where calculation is finished.
  * @returns {number} Height sum.
  */
  sumCellSizes(from, to) {
    const { wtTable, wtSettings } = this.wot;
    const defaultRowHeight = wtSettings.getSetting("stylesHandler").getDefaultRowHeight();
    let row = from;
    let sum2 = 0;
    while (row < to) {
      const height = wtTable.getRowHeight(row);
      sum2 += height === void 0 ? defaultRowHeight : height;
      row += 1;
    }
    return sum2;
  }
  /**
  * Adjust overlay root element, children and master table element sizes (width, height).
  */
  adjustElementsSize() {
    this.updateTrimmingContainer();
    if (this.needFullRender) {
      this.adjustRootElementSize();
      this.adjustRootChildrenSize();
    }
  }
  /**
  * Adjust overlay root element size (width and height).
  */
  adjustRootElementSize() {
    if (!this.clone) {
      return;
    }
    const { wtTable, wtViewport } = this.wot;
    const { rootDocument, rootWindow } = this.domBindings;
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    const overlayRootStyle = overlayRoot.style;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    if (this.trimmingContainer !== rootWindow || preventOverflow === "horizontal") {
      let width = wtViewport.getWorkspaceWidth();
      if (wtViewport.hasVerticalScroll()) {
        width -= getScrollbarWidth(rootDocument);
      }
      width = Math.min(width, wtTable.wtRootElement.scrollWidth);
      overlayRootStyle.width = `${width}px`;
    } else {
      overlayRootStyle.width = "";
    }
    this.clone.wtTable.holder.style.width = overlayRootStyle.width;
    let tableHeight = outerHeight(this.clone.wtTable.TABLE);
    if (!wtTable.hasDefinedSize()) {
      tableHeight = 0;
    }
    overlayRootStyle.height = `${tableHeight}px`;
  }
  /**
  * Adjust overlay root childs size.
  */
  adjustRootChildrenSize() {
    if (!this.clone) {
      return;
    }
    const { holder: holder2 } = this.clone.wtTable;
    this.clone.wtTable.hider.style.width = this.hider.style.width;
    const holderParent = holder2.parentNode;
    holder2.style.width = holderParent.style.width;
    holder2.style.height = holderParent.style.height;
  }
  /**
  * Adjust the overlay dimensions and position.
  */
  applyToDOM() {
    const total = this.wtSettings.getSetting("totalRows");
    if (typeof this.wot.wtViewport.rowsRenderCalculator?.startPosition === "number") {
      this.spreader.style.top = `${this.wot.wtViewport.rowsRenderCalculator.startPosition}px`;
    } else if (total === 0) {
      this.spreader.style.top = "0";
    } else {
      throwWithCause("Incorrect value of the rowsRenderCalculator");
    }
    this.spreader.style.bottom = "";
    if (this.needFullRender) {
      this.syncOverlayOffset();
    }
  }
  /**
  * Synchronize calculated left position to an element.
  */
  syncOverlayOffset() {
    if (!this.clone) {
      return;
    }
    const styleProperty = this.isRtl() ? "right" : "left";
    const { spreader } = this.clone.wtTable;
    if (typeof this.wot.wtViewport.columnsRenderCalculator?.startPosition === "number") {
      spreader.style[styleProperty] = `${this.wot.wtViewport.columnsRenderCalculator.startPosition}px`;
    } else {
      spreader.style[styleProperty] = "";
    }
  }
  /**
  * Scrolls vertically to a row.
  *
  * @param {number} sourceRow Row index which you want to scroll to.
  * @param {boolean} [bottomEdge=false] If `true`, scrolls according to the bottom edge (top edge is by default).
  */
  scrollTo(sourceRow, bottomEdge) {
    let newY = this.getTableParentOffset();
    const sourceInstance = this.wot.cloneSource ? this.wot.cloneSource : this.wot;
    const mainHolder = sourceInstance.wtTable.holder;
    let scrollbarCompensation = 0;
    if (bottomEdge && mainHolder.offsetHeight !== mainHolder.clientHeight) {
      scrollbarCompensation = getScrollbarWidth(this.domBindings.rootDocument);
    }
    if (bottomEdge) {
      newY += this.sumCellSizes(0, sourceRow + 1);
      newY -= this.wot.wtViewport.getViewportHeight();
      newY += 1;
    } else {
      newY += this.sumCellSizes(this.wtSettings.getSetting("fixedRowsBottom"), sourceRow);
    }
    newY += scrollbarCompensation;
    return this.setScrollPosition(newY);
  }
  /**
  * Gets table parent top position.
  *
  * @returns {number}
  */
  getTableParentOffset() {
    if (this.mainTableScrollableElement === this.domBindings.rootWindow) {
      return this.wot.wtTable.holderOffset.top;
    }
    return 0;
  }
  /**
  * Gets the main overlay's vertical scroll position.
  *
  * @returns {number} Main table's vertical scroll position.
  */
  getScrollPosition() {
    return getScrollTop$1(this.mainTableScrollableElement, this.domBindings.rootWindow);
  }
  /**
  * Gets the main overlay's vertical overlay offset.
  *
  * @returns {number} Main table's vertical overlay offset.
  */
  getOverlayOffset() {
    const { rootWindow } = this.domBindings;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let overlayOffset = 0;
    if (this.trimmingContainer === rootWindow && (!preventOverflow || preventOverflow !== "vertical") && this.clone) {
      const rootHeight = this.wot.wtTable.getTotalHeight();
      const overlayRootHeight = this.clone.wtTable.getTotalHeight();
      const maxOffset = rootHeight - overlayRootHeight;
      const docClientHeight = this.domBindings.rootDocument.documentElement.clientHeight;
      overlayOffset = Math.max(this.getTableParentOffset() - this.getScrollPosition() - docClientHeight + rootHeight, 0);
      if (overlayOffset > maxOffset) {
        overlayOffset = 0;
      }
    }
    return overlayOffset;
  }
  /**
  * Adds css classes to hide the header border's header (cell-selection border hiding issue).
  *
  * @param {number} position Header Y position if trimming container is window or scroll top if not.
  * @returns {boolean}
  */
  adjustHeaderBordersPosition(position) {
    const fixedRowsBottom = this.wtSettings.getSetting("fixedRowsBottom");
    const areFixedRowsBottomChanged = this.cachedFixedRowsBottom !== fixedRowsBottom;
    const columnHeaders = this.wtSettings.getSetting("columnHeaders");
    let positionChanged = false;
    if ((areFixedRowsBottomChanged || fixedRowsBottom === 0) && columnHeaders.length > 0) {
      const masterParent = this.wot.wtTable.holder.parentNode;
      const previousState = hasClass(masterParent, "innerBorderBottom");
      this.cachedFixedRowsBottom = this.wtSettings.getSetting("fixedRowsBottom");
      if (position || this.wtSettings.getSetting("totalRows") === 0) {
        addClass(masterParent, "innerBorderBottom");
        positionChanged = !previousState;
      } else {
        removeClass(masterParent, "innerBorderBottom");
        positionChanged = previousState;
      }
    }
    return positionChanged;
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @TODO refactoring: check if can be deleted.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {DomBindings} domBindings Dom elements bound to the current instance.
  */
  constructor(wotInstance, facadeGetter, wtSettings, domBindings) {
    super(wotInstance, facadeGetter, CLONE_BOTTOM, wtSettings, domBindings), /**
    * Cached value which holds the previous value of the `fixedRowsBottom` option.
    * It is used as a comparison value that can be used to detect changes in that value.
    *
    * @type {number}
    */
    this.cachedFixedRowsBottom = -1;
    this.cachedFixedRowsBottom = this.wtSettings.getSetting("fixedRowsBottom");
  }
}
const MIXIN_NAME$3 = "calculatedRows";
const calculatedRows = {
  /**
  * Get the source index of the first rendered row. If no rows are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstRenderedRow() {
    const startRow = this.dataAccessObject.startRowRendered;
    if (startRow === null) {
      return -1;
    }
    return startRow;
  },
  /**
  * Get the source index of the first row fully visible in the viewport. If no rows are fully visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstVisibleRow() {
    const startRow = this.dataAccessObject.startRowVisible;
    if (startRow === null) {
      return -1;
    }
    return startRow;
  },
  /**
  * Get the source index of the first row partially visible in the viewport. If no rows are partially visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstPartiallyVisibleRow() {
    const startRow = this.dataAccessObject.startRowPartiallyVisible;
    if (startRow === null) {
      return -1;
    }
    return startRow;
  },
  /**
  * Get the source index of the last rendered row. If no rows are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastRenderedRow() {
    const endRow = this.dataAccessObject.endRowRendered;
    if (endRow === null) {
      return -1;
    }
    return endRow;
  },
  /**
  * Get the source index of the last row fully visible in the viewport. If no rows are fully visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastVisibleRow() {
    const endRow = this.dataAccessObject.endRowVisible;
    if (endRow === null) {
      return -1;
    }
    return endRow;
  },
  /**
  * Get the source index of the last row partially visible in the viewport. If no rows are partially visible, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastPartiallyVisibleRow() {
    const endRow = this.dataAccessObject.endRowPartiallyVisible;
    if (endRow === null) {
      return -1;
    }
    return endRow;
  },
  /**
  * Get the number of rendered rows.
  *
  * @returns {number}
  * @this Table
  */
  getRenderedRowsCount() {
    return this.dataAccessObject.countRowsRendered;
  },
  /**
  * Get the number of fully visible rows in the viewport.
  *
  * @returns {number}
  * @this Table
  */
  getVisibleRowsCount() {
    return this.dataAccessObject.countRowsVisible;
  },
  /**
  * Get the number of rendered column headers.
  *
  * @returns {number}
  * @this Table
  */
  getColumnHeadersCount() {
    return this.dataAccessObject.columnHeaders.length;
  }
};
defineGetter(calculatedRows, "MIXIN_NAME", MIXIN_NAME$3, {
  writable: false,
  enumerable: false
});
class InlineStartOverlayTable extends Table {
  /**
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings) {
    super(dataAccessObject, facadeGetter, domBindings, wtSettings, CLONE_INLINE_START);
  }
}
mixin(InlineStartOverlayTable, calculatedRows);
mixin(InlineStartOverlayTable, stickyColumnsStart);
const MIXIN_NAME$2 = "localHooks";
const localHooks = {
  /**
  * Internal hooks storage.
  */
  _localHooks: /* @__PURE__ */ Object.create(null),
  /**
  * Add hook to the collection.
  *
  * @param {string} key The hook name.
  * @param {Function} callback The hook callback.
  * @returns {object}
  */
  addLocalHook(key, callback) {
    if (!this._localHooks[key]) {
      this._localHooks[key] = [];
    }
    this._localHooks[key].push(callback);
    return this;
  },
  /**
  * Removes the hook name associated with the callback function.
  *
  * @param {string} key The hook name.
  * @param {*} callback The hook callback.
  * @returns {object}
  */
  removeLocalHook(key, callback) {
    if (this._localHooks[key]) {
      const index2 = this._localHooks[key].indexOf(callback);
      if (index2 > -1) {
        this._localHooks[key].splice(index2, 1);
      }
    }
    return this;
  },
  /**
  * Run hooks.
  *
  * @param {string} key The name of the hook to run.
  * @param {*} [arg1] An additional parameter passed to the callback function.
  * @param {*} [arg2] An additional parameter passed to the callback function.
  * @param {*} [arg3] An additional parameter passed to the callback function.
  * @param {*} [arg4] An additional parameter passed to the callback function.
  * @param {*} [arg5] An additional parameter passed to the callback function.
  * @param {*} [arg6] An additional parameter passed to the callback function.
  */
  runLocalHooks(key, arg1, arg2, arg3, arg4, arg5, arg6) {
    if (this._localHooks[key]) {
      const length = this._localHooks[key].length;
      for (let i = 0; i < length; i++) {
        fastCall(this._localHooks[key][i], this, arg1, arg2, arg3, arg4, arg5, arg6);
      }
    }
  },
  /**
  * Clear all added hooks.
  *
  * @returns {object}
  */
  clearLocalHooks() {
    this._localHooks = {};
    return this;
  }
};
defineGetter(localHooks, "MIXIN_NAME", MIXIN_NAME$2, {
  writable: false,
  enumerable: false
});
let Selection$1 = class Selection {
  /**
  * Checks if selection is empty.
  *
  * @returns {boolean}
  */
  isEmpty() {
    return this.cellRange === null;
  }
  /**
  * Adds a cell coords to the selection.
  *
  * @param {CellCoords} coords The cell coordinates to add.
  * @returns {Selection}
  */
  add(coords) {
    if (this.isEmpty()) {
      this.cellRange = this.settings.createCellRange(coords);
    } else {
      this.cellRange.expand(coords);
    }
    return this;
  }
  /**
  * If selection range from or to property equals oldCoords, replace it with newCoords. Return boolean
  * information about success.
  *
  * @param {CellCoords} oldCoords An old cell coordinates to replace.
  * @param {CellCoords} newCoords The new cell coordinates.
  * @returns {boolean}
  */
  replace(oldCoords, newCoords) {
    if (!this.isEmpty()) {
      if (this.cellRange.from.isEqual(oldCoords)) {
        this.cellRange.from = newCoords;
        return true;
      }
      if (this.cellRange.to.isEqual(oldCoords)) {
        this.cellRange.to = newCoords;
        return true;
      }
    }
    return false;
  }
  /**
  * Clears selection.
  *
  * @returns {Selection}
  */
  clear() {
    this.cellRange = null;
    return this;
  }
  /**
  * Returns the top left (or top right in RTL) and bottom right (or bottom left in RTL) selection coordinates.
  *
  * @returns {number[]} Returns array of coordinates for example `[1, 1, 5, 5]`.
  */
  getCorners() {
    const topStart = this.cellRange.getOuterTopStartCorner();
    const bottomEnd = this.cellRange.getOuterBottomEndCorner();
    return [
      topStart.row ?? 0,
      topStart.col ?? 0,
      bottomEnd.row ?? 0,
      bottomEnd.col ?? 0
    ];
  }
  /**
  * Destroys the instance.
  */
  destroy() {
    this.runLocalHooks("destroy");
  }
  /**
  * @param {object} settings The selection settings object. @todo type.
  * @param {CellRange} cellRange The cell range instance.
  */
  constructor(settings, cellRange) {
    this.settings = settings;
    this.cellRange = cellRange || null;
  }
};
mixin(Selection$1, localHooks);
const ACTIVE_HEADER_TYPE = "active-header";
const HEADER_TYPE = "header";
const AREA_TYPE = "area";
const FOCUS_TYPE = "focus";
const FILL_TYPE = "fill";
const ROW_TYPE = "row";
const COLUMN_TYPE = "column";
const CUSTOM_SELECTION_TYPE = "custom-selection";
const getCornerStyle = (wot) => {
  const stylesHandler = wot.wtSettings.getSetting("stylesHandler");
  const cornerSizeFromVar = stylesHandler.getCSSVariableValue("cell-autofill-size");
  const cornerBorderWidthFromVar = stylesHandler.getCSSVariableValue("cell-autofill-border-width");
  const cornerColorFromVar = stylesHandler.getCSSVariableValue("cell-autofill-border-color");
  return Object.freeze({
    width: cornerSizeFromVar,
    height: cornerSizeFromVar,
    borderWidth: cornerBorderWidthFromVar,
    borderStyle: "solid",
    borderColor: cornerColorFromVar
  });
};
function _check_private_redeclaration$1B(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1n(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1n(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1n(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1n(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1n(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1n(receiver, descriptor);
}
function _class_private_field_init$1n(obj, privateMap, value) {
  _check_private_redeclaration$1B(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1n(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1n(receiver, privateMap, "set");
  _class_apply_descriptor_set$1n(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$16(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$16(obj, privateSet) {
  _check_private_redeclaration$1B(obj, privateSet);
  privateSet.add(obj);
}
var _selection = /* @__PURE__ */ new WeakMap(), _activeOverlaysWot$1 = /* @__PURE__ */ new WeakMap(), _scanCellsRange = /* @__PURE__ */ new WeakSet(), _scanViewportRange = /* @__PURE__ */ new WeakSet();
class SelectionScanner {
  /**
  * Sets the Walkontable instance that will be taking into account while scanning the table.
  *
  * @param {Walkontable} activeOverlaysWot The Walkontable instance.
  * @returns {SelectionScanner}
  */
  setActiveOverlay(activeOverlaysWot) {
    _class_private_field_set$1n(this, _activeOverlaysWot$1, activeOverlaysWot);
    return this;
  }
  /**
  * Sets the Selection instance to process.
  *
  * @param {Selection} selection The Selection instance.
  * @returns {SelectionScanner}
  */
  setActiveSelection(selection) {
    _class_private_field_set$1n(this, _selection, selection);
    return this;
  }
  /**
  * Scans the rendered table with selection and returns elements that intersects
  * with selection coordinates.
  *
  * @returns {HTMLTableElement[]}
  */
  scan() {
    const selectionType = _class_private_field_get$1n(this, _selection).settings.selectionType;
    const elements = /* @__PURE__ */ new Set();
    if (selectionType === "active-header") {
      this.scanColumnsInHeadersRange((element) => elements.add(element));
      this.scanRowsInHeadersRange((element) => elements.add(element));
    } else if (selectionType === "area") {
      this.scanCellsRange((element) => elements.add(element));
    } else if (selectionType === "focus") {
      this.scanColumnsInHeadersRange((element) => elements.add(element));
      this.scanRowsInHeadersRange((element) => elements.add(element));
      this.scanCellsRange((element) => elements.add(element));
    } else if (selectionType === "fill") {
      this.scanCellsRange((element) => elements.add(element));
    } else if (selectionType === "header") {
      this.scanColumnsInHeadersRange((element) => elements.add(element));
      this.scanRowsInHeadersRange((element) => elements.add(element));
    } else if (selectionType === "row") {
      this.scanRowsInHeadersRange((element) => elements.add(element));
      this.scanRowsInCellsRange((element) => elements.add(element));
    } else if (selectionType === "column") {
      this.scanColumnsInHeadersRange((element) => elements.add(element));
      this.scanColumnsInCellsRange((element) => elements.add(element));
    }
    return elements;
  }
  /**
  * Scans the table (only rendered headers) and collect all column headers (TH) that match
  * the coordinates passed in the Selection instance.
  *
  * @param {function(HTMLTableElement): void} callback The callback function to trigger.
  */
  scanColumnsInHeadersRange(callback) {
    const [topRow, topColumn, bottomRow, bottomColumn] = _class_private_field_get$1n(this, _selection).getCorners();
    const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
    const renderedColumnsCount = wtTable.getRenderedColumnsCount();
    const columnHeadersCount = wtTable.getColumnHeadersCount();
    let cursor = 0;
    for (let column = -wtTable.getRowHeadersCount(); column < renderedColumnsCount; column++) {
      const sourceColumn = wtTable.columnFilter.renderedToSource(column);
      if (sourceColumn < topColumn || sourceColumn > bottomColumn) {
        continue;
      }
      for (let headerLevel = -columnHeadersCount; headerLevel < 0; headerLevel++) {
        if (headerLevel < topRow || headerLevel > bottomRow) {
          continue;
        }
        const positiveBasedHeaderLevel = headerLevel + columnHeadersCount;
        let TH = wtTable.getColumnHeader(sourceColumn, positiveBasedHeaderLevel);
        const newSourceCol = _class_private_field_get$1n(this, _activeOverlaysWot$1).getSetting("onBeforeHighlightingColumnHeader", sourceColumn, positiveBasedHeaderLevel, {
          selectionType: _class_private_field_get$1n(this, _selection).settings.selectionType,
          columnCursor: cursor,
          selectionWidth: bottomColumn - topColumn + 1
        });
        if (newSourceCol === null) {
          continue;
        }
        if (newSourceCol !== sourceColumn) {
          TH = wtTable.getColumnHeader(newSourceCol, positiveBasedHeaderLevel);
        }
        if (isHTMLElement(TH)) {
          callback(TH);
        }
      }
      cursor += 1;
    }
  }
  /**
  * Scans the table (only rendered headers) and collect all row headers (TH) that match
  * the coordinates passed in the Selection instance.
  *
  * @param {function(HTMLTableElement): void} callback The callback function to trigger.
  */
  scanRowsInHeadersRange(callback) {
    const [topRow, topColumn, bottomRow, bottomColumn] = _class_private_field_get$1n(this, _selection).getCorners();
    const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
    const renderedRowsCount = wtTable.getRenderedRowsCount();
    const rowHeadersCount = wtTable.getRowHeadersCount();
    let cursor = 0;
    for (let row = -wtTable.getColumnHeadersCount(); row < renderedRowsCount; row++) {
      const sourceRow = wtTable.rowFilter.renderedToSource(row);
      if (sourceRow < topRow || sourceRow > bottomRow) {
        continue;
      }
      for (let headerLevel = -rowHeadersCount; headerLevel < 0; headerLevel++) {
        if (headerLevel < topColumn || headerLevel > bottomColumn) {
          continue;
        }
        const positiveBasedHeaderLevel = headerLevel + rowHeadersCount;
        let TH = wtTable.getRowHeader(sourceRow, positiveBasedHeaderLevel);
        const newSourceRow = _class_private_field_get$1n(this, _activeOverlaysWot$1).getSetting("onBeforeHighlightingRowHeader", sourceRow, positiveBasedHeaderLevel, {
          selectionType: _class_private_field_get$1n(this, _selection).settings.selectionType,
          rowCursor: cursor,
          selectionHeight: bottomRow - topRow + 1
        });
        if (newSourceRow === null) {
          continue;
        }
        if (newSourceRow !== sourceRow) {
          TH = wtTable.getRowHeader(newSourceRow, positiveBasedHeaderLevel);
        }
        if (isHTMLElement(TH)) {
          callback(TH);
        }
      }
      cursor += 1;
    }
  }
  /**
  * Scans the table (only rendered cells) and collect all cells (TR) that match
  * the coordinates passed in the Selection instance.
  *
  * @param {function(HTMLTableElement): void} callback The callback function to trigger.
  */
  scanCellsRange(callback) {
    const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
    _class_private_method_get$16(this, _scanCellsRange, scanCellsRange).call(this, (sourceRow, sourceColumn) => {
      const cell = wtTable.getCell(_class_private_field_get$1n(this, _activeOverlaysWot$1).createCellCoords(sourceRow, sourceColumn));
      if (!isHTMLElement(cell)) {
        return;
      }
      const additionalSelectionClass = _class_private_field_get$1n(this, _activeOverlaysWot$1).getSetting("onAfterDrawSelection", sourceRow, sourceColumn, _class_private_field_get$1n(this, _selection).settings.layerLevel);
      if (typeof additionalSelectionClass === "string") {
        addClass(cell, additionalSelectionClass);
      }
      callback(cell);
    });
  }
  /**
  * Scans the table (only rendered cells) and collects all cells (TR) that match the coordinates
  * passed in the Selection instance but only for the X axis (rows).
  *
  * @param {function(HTMLTableElement): void} callback The callback function to trigger.
  */
  scanRowsInCellsRange(callback) {
    const [topRow, , bottomRow] = _class_private_field_get$1n(this, _selection).getCorners();
    const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
    _class_private_method_get$16(this, _scanViewportRange, scanViewportRange).call(this, (sourceRow, sourceColumn) => {
      if (sourceRow >= topRow && sourceRow <= bottomRow) {
        const cell = wtTable.getCell(_class_private_field_get$1n(this, _activeOverlaysWot$1).createCellCoords(sourceRow, sourceColumn));
        if (isHTMLElement(cell)) {
          callback(cell);
        }
      }
    });
  }
  /**
  * Scans the table (only rendered cells) and collects all cells (TR) that match the coordinates
  * passed in the Selection instance but only for the Y axis (columns).
  *
  * @param {function(HTMLTableElement): void} callback The callback function to trigger.
  */
  scanColumnsInCellsRange(callback) {
    const [, topColumn, , bottomColumn] = _class_private_field_get$1n(this, _selection).getCorners();
    const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
    _class_private_method_get$16(this, _scanViewportRange, scanViewportRange).call(this, (sourceRow, sourceColumn) => {
      if (sourceColumn >= topColumn && sourceColumn <= bottomColumn) {
        const cell = wtTable.getCell(_class_private_field_get$1n(this, _activeOverlaysWot$1).createCellCoords(sourceRow, sourceColumn));
        if (isHTMLElement(cell)) {
          callback(cell);
        }
      }
    });
  }
  constructor() {
    _class_private_method_init$16(this, _scanCellsRange);
    _class_private_method_init$16(this, _scanViewportRange);
    _class_private_field_init$1n(this, _selection, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1n(this, _activeOverlaysWot$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1n(this, _selection, null);
    _class_private_field_set$1n(this, _activeOverlaysWot$1, null);
  }
}
function scanCellsRange(callback) {
  let [topRow, startColumn, bottomRow, endColumn] = _class_private_field_get$1n(this, _selection).getCorners();
  if (topRow < 0 && bottomRow < 0 || startColumn < 0 && endColumn < 0) {
    return;
  }
  const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
  const isMultiple = topRow !== bottomRow || startColumn !== endColumn;
  startColumn = Math.max(startColumn ?? 0, 0);
  endColumn = Math.max(endColumn ?? 0, 0);
  topRow = Math.max(topRow ?? 0, 0);
  bottomRow = Math.max(bottomRow ?? 0, 0);
  if (isMultiple) {
    startColumn = Math.max(startColumn, wtTable.getFirstRenderedColumn());
    endColumn = Math.min(endColumn, wtTable.getLastRenderedColumn());
    topRow = Math.max(topRow, wtTable.getFirstRenderedRow());
    bottomRow = Math.min(bottomRow, wtTable.getLastRenderedRow());
    if (endColumn < startColumn || bottomRow < topRow) {
      return;
    }
  } else {
    const cell = wtTable.getCell(_class_private_field_get$1n(this, _activeOverlaysWot$1).createCellCoords(topRow, startColumn));
    if (!isHTMLElement(cell)) {
      return;
    }
  }
  for (let row = topRow; row <= bottomRow; row += 1) {
    for (let column = startColumn; column <= endColumn; column += 1) {
      callback(row, column);
    }
  }
}
function scanViewportRange(callback) {
  const { wtTable } = _class_private_field_get$1n(this, _activeOverlaysWot$1);
  const renderedRowsCount = wtTable.getRenderedRowsCount();
  const renderedColumnsCount = wtTable.getRenderedColumnsCount();
  for (let row = 0; row < renderedRowsCount; row += 1) {
    const sourceRow = wtTable.rowFilter.renderedToSource(row);
    for (let column = 0; column < renderedColumnsCount; column += 1) {
      callback(sourceRow, wtTable.columnFilter.renderedToSource(column));
    }
  }
}
const BORDER_STYLE_CLASS_PREFIX = "ht-border-style-";
const BORDER_STYLE_VERTICAL_SUFFIX = "-vertical";
const BORDER_STYLE_HORIZONTAL_SUFFIX = "-horizontal";
class Border {
  /**
  * Register all necessary events.
  */
  registerListeners() {
    const documentBody = this.wot.rootDocument.body;
    this.eventManager.addEventListener(documentBody, "mousedown", () => this.onMouseDown());
    this.eventManager.addEventListener(documentBody, "mouseup", () => this.onMouseUp());
    if (this.main) {
      for (let c = 0, len = this.main.childNodes.length; c < len; c++) {
        const mainNode = this.main;
        const element = mainNode.childNodes[c];
        this.eventManager.addEventListener(element, "mouseenter", (event) => this.onMouseEnter(event, mainNode.childNodes[c]));
      }
    }
  }
  /**
  * Mouse down listener.
  *
  * @private
  */
  onMouseDown() {
    this.mouseDown = true;
  }
  /**
  * Mouse up listener.
  *
  * @private
  */
  onMouseUp() {
    this.mouseDown = false;
  }
  /**
  * Mouse enter listener for fragment selection functionality.
  *
  * @private
  * @param {Event} event Dom event.
  * @param {HTMLElement} parentElement Part of border element.
  */
  onMouseEnter(event, parentElement) {
    if (!this.mouseDown || !this.wot.getSetting("hideBorderOnMouseDownOver")) {
      return;
    }
    event.preventDefault();
    stopImmediatePropagation(event);
    const documentBody = this.wot.rootDocument.body;
    const bounds = parentElement.getBoundingClientRect();
    parentElement.style.display = "none";
    function isOutside(mouseEvent) {
      if (mouseEvent.clientY < Math.floor(bounds.top)) {
        return true;
      }
      if (mouseEvent.clientY > Math.ceil(bounds.top + bounds.height)) {
        return true;
      }
      if (mouseEvent.clientX < Math.floor(bounds.left)) {
        return true;
      }
      if (mouseEvent.clientX > Math.ceil(bounds.left + bounds.width)) {
        return true;
      }
    }
    const handler = (handlerEvent) => {
      if (isOutside(handlerEvent)) {
        this.eventManager.removeEventListener(documentBody, "mousemove", handler);
        parentElement.style.display = "block";
      }
    };
    this.eventManager.addEventListener(documentBody, "mousemove", handler);
  }
  /**
  * Create border elements.
  *
  * @param {object} settings The border settings.
  */
  createBorders(settings) {
    const { rootDocument } = this.wot;
    this.main = rootDocument.createElement("div");
    const borderDivs = [
      "top",
      "start",
      "bottom",
      "end",
      "corner"
    ];
    let style = this.main.style;
    style.position = "absolute";
    style.top = "0";
    style.left = "0";
    const createdDivs = [];
    for (let i = 0; i < 5; i++) {
      const position = borderDivs[i];
      const div2 = rootDocument.createElement("div");
      const getSettingsProperty = (property) => {
        const posSettings = this.settings[position];
        return posSettings && posSettings[property] ? posSettings[property] : settings.border?.[property];
      };
      div2.className = `wtBorder ${this.settings.className || ""}`;
      if (this.settings[position]?.hide) {
        div2.className += " hidden";
      }
      style = div2.style;
      const borderStyle = getSettingsProperty("style");
      if (borderStyle) {
        if ([
          "start",
          "end"
        ].includes(position)) {
          div2.className += ` ${BORDER_STYLE_CLASS_PREFIX}${borderStyle}${BORDER_STYLE_VERTICAL_SUFFIX}`;
        } else {
          div2.className += ` ${BORDER_STYLE_CLASS_PREFIX}${borderStyle}${BORDER_STYLE_HORIZONTAL_SUFFIX}`;
        }
        style.setProperty("--ht-custom-border-size", `${getSettingsProperty("width")}px`);
        style.setProperty("--ht-custom-border-color", String(getSettingsProperty("color") ?? ""));
      } else {
        style.backgroundColor = String(getSettingsProperty("color") ?? "");
      }
      style.height = `${getSettingsProperty("width")}px`;
      style.width = `${getSettingsProperty("width")}px`;
      createdDivs.push(div2);
      this.main.appendChild(div2);
    }
    this.top = createdDivs[0];
    this.start = createdDivs[1];
    this.bottom = createdDivs[2];
    this.end = createdDivs[3];
    this.topStyle = this.top.style;
    this.startStyle = this.start.style;
    this.bottomStyle = this.bottom.style;
    this.endStyle = this.end.style;
    this.corner = createdDivs[4];
    this.corner.className += " corner";
    this.cornerStyle = this.corner.style;
    this.cornerStyle.width = `${this.cornerDefaultStyle.width}px`;
    this.cornerStyle.height = `${this.cornerDefaultStyle.height}px`;
    this.cornerStyle.border = [
      `${this.cornerDefaultStyle.borderWidth}px`,
      this.cornerDefaultStyle.borderStyle,
      this.cornerDefaultStyle.borderColor
    ].join(" ");
    if (isMobileBrowser() && this.instance.getSetting("isDataViewInstance")) {
      this.createMultipleSelectorHandles();
    }
    this.disappear();
    const { wtTable } = this.wot;
    let bordersHolder = wtTable.bordersHolder;
    if (!bordersHolder) {
      bordersHolder = rootDocument.createElement("div");
      bordersHolder.className = "htBorders";
      wtTable.bordersHolder = bordersHolder;
      wtTable.spreader.appendChild(bordersHolder);
    }
    bordersHolder.appendChild(this.main);
  }
  /**
  * Create multiple selector handler for mobile devices.
  */
  createMultipleSelectorHandles() {
    const { rootDocument, wtSettings } = this.wot;
    const stylesHandler = wtSettings.getSetting("stylesHandler");
    const cellMobileHandleSize = stylesHandler.getCSSVariableValue("cell-mobile-handle-size");
    const cellMobileHandleBorderRadius = stylesHandler.getCSSVariableValue("cell-mobile-handle-border-radius");
    const cellMobileHandleBackgroundColor = stylesHandler.getCSSVariableValue("cell-mobile-handle-background-color");
    const cellMobileHandleBackgroundOpacity = stylesHandler.getCSSVariableValue("cell-mobile-handle-background-opacity");
    const cellMobileHandleBorderWidth = stylesHandler.getCSSVariableValue("cell-mobile-handle-border-width");
    const cellMobileHandleBorderColor = stylesHandler.getCSSVariableValue("cell-mobile-handle-border-color");
    this.selectionHandles = {
      top: rootDocument.createElement("div"),
      topHitArea: rootDocument.createElement("div"),
      bottom: rootDocument.createElement("div"),
      bottomHitArea: rootDocument.createElement("div"),
      styles: {}
    };
    const hitAreaWidth = 40;
    this.selectionHandles.top.className = "topSelectionHandle topLeftSelectionHandle";
    this.selectionHandles.topHitArea.className = "topSelectionHandle-HitArea topLeftSelectionHandle-HitArea";
    this.selectionHandles.bottom.className = "bottomSelectionHandle bottomRightSelectionHandle";
    this.selectionHandles.bottomHitArea.className = "bottomSelectionHandle-HitArea bottomRightSelectionHandle-HitArea";
    this.selectionHandles.styles = {
      top: this.selectionHandles.top.style,
      topHitArea: this.selectionHandles.topHitArea.style,
      bottom: this.selectionHandles.bottom.style,
      bottomHitArea: this.selectionHandles.bottomHitArea.style
    };
    const hitAreaTargets = [
      this.selectionHandles.styles.bottomHitArea,
      this.selectionHandles.styles.topHitArea
    ];
    for (const hitAreaStyleTarget of hitAreaTargets) {
      hitAreaStyleTarget.position = "absolute";
      hitAreaStyleTarget.height = `${hitAreaWidth}px`;
      hitAreaStyleTarget.width = `${hitAreaWidth}px`;
      hitAreaStyleTarget.borderRadius = `${parseInt(String(hitAreaWidth / 1.5), 10)}px`;
    }
    for (const handleStyleTarget of [
      this.selectionHandles.styles.bottom,
      this.selectionHandles.styles.top
    ]) {
      handleStyleTarget.position = "absolute";
      handleStyleTarget.height = `${cellMobileHandleSize}px`;
      handleStyleTarget.width = `${cellMobileHandleSize}px`;
      handleStyleTarget.borderRadius = `${cellMobileHandleBorderRadius}px`;
      handleStyleTarget.background = `color-mix(in srgb, ${cellMobileHandleBackgroundColor} ${cellMobileHandleBackgroundOpacity}%, transparent)`;
      handleStyleTarget.border = `${cellMobileHandleBorderWidth}px solid ${cellMobileHandleBorderColor}`;
    }
  }
  /**
  * Checks if the given coordinates are south-east of the area selection. If `true` then
  * the fill handler should be visible.
  *
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @returns {boolean}
  */
  isSouthEastOfAreaSelection(row, col) {
    const areaSelection = this.wot.selectionManager.getAreaSelection();
    if (!areaSelection) {
      return false;
    }
    if (!areaSelection.cellRange) {
      return true;
    }
    const bottomEndCorner = areaSelection.cellRange.getBottomEndCorner();
    return bottomEndCorner.row === row && bottomEndCorner.col === col;
  }
  /**
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number} top The top position of the handler.
  * @param {number} left The left position of the handler.
  * @param {number} width The width of the handler.
  * @param {number} height The height of the handler.
  */
  updateMultipleSelectionHandlesPosition(row, col, top2, left2, width, height) {
    const isRtl2 = this.wot.wtSettings.getSetting("rtlMode");
    const inlinePosProperty = isRtl2 ? "right" : "left";
    const { top: topStyles, topHitArea: topHitAreaStyles, bottom: bottomStyles, bottomHitArea: bottomHitAreaStyles } = this.selectionHandles.styles;
    const handleBorderSize = parseInt(topStyles.borderWidth, 10);
    const handleSize = parseInt(topStyles.width, 10);
    const hitAreaSize = parseInt(topHitAreaStyles.width, 10);
    const totalTableWidth = this.wot.wtTable.getWidth();
    const totalTableHeight = this.wot.wtTable.getHeight();
    topStyles.top = `${parseInt(String(top2 - handleSize - 1), 10)}px`;
    topStyles[inlinePosProperty] = `${parseInt(String(left2 - handleSize - 1), 10)}px`;
    topHitAreaStyles.top = `${parseInt(String(top2 - hitAreaSize / 4 * 3), 10)}px`;
    topHitAreaStyles[inlinePosProperty] = `${parseInt(String(left2 - hitAreaSize / 4 * 3), 10)}px`;
    const bottomHandlerInline = Math.min(parseInt(String(left2 + width), 10), totalTableWidth - handleSize - handleBorderSize * 2);
    const bottomHandlerAreaInline = Math.min(parseInt(String(left2 + width - hitAreaSize / 4), 10), totalTableWidth - hitAreaSize - handleBorderSize * 2);
    bottomStyles[inlinePosProperty] = `${bottomHandlerInline}px`;
    bottomHitAreaStyles[inlinePosProperty] = `${bottomHandlerAreaInline}px`;
    const bottomHandlerTop = Math.min(parseInt(String(top2 + height), 10), totalTableHeight - handleSize - handleBorderSize * 2);
    const bottomHandlerAreaTop = Math.min(parseInt(String(top2 + height - hitAreaSize / 4), 10), totalTableHeight - hitAreaSize - handleBorderSize * 2);
    bottomStyles.top = `${bottomHandlerTop}px`;
    bottomHitAreaStyles.top = `${bottomHandlerAreaTop}px`;
    const cornerVisible = this.settings.border?.cornerVisible;
    if (cornerVisible && typeof cornerVisible === "function" && cornerVisible()) {
      topStyles.display = "block";
      topHitAreaStyles.display = "block";
      if (this.isSouthEastOfAreaSelection(row, col)) {
        bottomStyles.display = "block";
        bottomHitAreaStyles.display = "block";
      } else {
        bottomStyles.display = "none";
        bottomHitAreaStyles.display = "none";
      }
    } else {
      topStyles.display = "none";
      bottomStyles.display = "none";
      topHitAreaStyles.display = "none";
      bottomHitAreaStyles.display = "none";
    }
    if (row === this.wot.wtSettings.getSetting("fixedRowsTop") || col === this.wot.wtSettings.getSetting("fixedColumnsStart")) {
      topStyles.zIndex = "9999";
      topHitAreaStyles.zIndex = "9999";
    } else {
      topStyles.zIndex = "";
      topHitAreaStyles.zIndex = "";
    }
  }
  /**
  * Show border around one or many cells.
  *
  * @param {Array} corners The corner coordinates.
  */
  appear(corners) {
    if (this.disabled) {
      return;
    }
    let [fromRow, fromColumn, toRow, toColumn] = corners;
    if (fromRow < 0 && toRow < 0 || fromColumn < 0 && toColumn < 0) {
      this.disappear();
      return;
    }
    const { wtTable, rootDocument, rootWindow } = this.wot;
    const isMultiple = fromRow !== toRow || fromColumn !== toColumn;
    const firstRenderedRow = wtTable.getFirstRenderedRow();
    const lastRenderedRow = wtTable.getLastRenderedRow();
    const firstRenderedColumn = wtTable.getFirstRenderedColumn();
    const lastRenderedColumn = wtTable.getLastRenderedColumn();
    if (firstRenderedColumn < 0 && lastRenderedColumn < 0 || firstRenderedRow < 0 && lastRenderedRow < 0) {
      this.disappear();
      return;
    }
    let fromTD;
    if (isMultiple) {
      fromColumn = Math.max(fromColumn, firstRenderedColumn);
      toColumn = Math.min(toColumn, lastRenderedColumn);
      fromRow = Math.max(fromRow, firstRenderedRow);
      toRow = Math.min(toRow, lastRenderedRow);
      if (toColumn < fromColumn || toRow < fromRow) {
        this.disappear();
        return;
      }
      fromTD = wtTable.getCell(this.wot.createCellCoords(fromRow, fromColumn));
      if (!isHTMLElement(fromTD)) {
        this.disappear();
        return;
      }
    } else {
      fromTD = wtTable.getCell(this.wot.createCellCoords(fromRow, fromColumn));
      if (!isHTMLElement(fromTD)) {
        this.disappear();
        return;
      }
    }
    const toTD = isMultiple ? wtTable.getCell(this.wot.createCellCoords(toRow, toColumn)) : fromTD;
    const fromTDEl = fromTD;
    const toTDEl = isHTMLElement(toTD) ? toTD : fromTDEl;
    const fromOffset = offset(fromTDEl);
    const toOffset = isMultiple ? offset(toTDEl) : fromOffset;
    const containerOffset = offset(wtTable.TABLE);
    const minTop = fromOffset.top;
    const minLeft = fromOffset.left;
    const isRtl2 = this.wot.wtSettings.getSetting("rtlMode");
    let inlineStartPos = 0;
    let width = 0;
    if (isRtl2) {
      const containerWidth = outerWidth(wtTable.TABLE);
      const fromWidth = outerWidth(fromTDEl);
      const gridRightPos = rootWindow.innerWidth - containerOffset.left - containerWidth;
      width = minLeft + fromWidth - toOffset.left;
      inlineStartPos = rootWindow.innerWidth - minLeft - fromWidth - gridRightPos - 1;
    } else {
      width = toOffset.left + outerWidth(toTDEl) - minLeft;
      inlineStartPos = minLeft - containerOffset.left - 1;
    }
    if (this.isEntireColumnSelected(fromRow, toRow)) {
      const rowHeader = fromRow;
      const modifiedValues = this.getDimensionsFromHeader("columns", fromColumn, toColumn, rowHeader, containerOffset);
      let fromTH = null;
      if (modifiedValues) {
        [fromTH, inlineStartPos, width] = modifiedValues;
      }
      if (fromTH) {
        fromTD = fromTH;
      }
    }
    let top2 = minTop - containerOffset.top - 1;
    let height = toOffset.top + outerHeight(toTDEl) - minTop;
    if (this.isEntireRowSelected(fromColumn, toColumn)) {
      const columnHeader = fromColumn;
      const modifiedValues = this.getDimensionsFromHeader("rows", fromRow, toRow, columnHeader, containerOffset);
      let fromTH = null;
      if (modifiedValues) {
        [fromTH, top2, height] = modifiedValues;
      }
      if (fromTH) {
        fromTD = fromTH;
      }
    }
    const style = rootWindow.getComputedStyle(fromTDEl);
    if (parseInt(style.borderTopWidth, 10) > 0) {
      top2 += 1;
      height = height > 0 ? height - 1 : 0;
    }
    if (parseInt(style[isRtl2 ? "borderRightWidth" : "borderLeftWidth"], 10) > 0) {
      inlineStartPos += 1;
      width = width > 0 ? width - 1 : 0;
    }
    const inlinePosProperty = isRtl2 ? "right" : "left";
    const delta = Math.ceil((this.settings.border?.width ?? 0) / 2);
    this.topStyle.top = `${top2}px`;
    this.topStyle[inlinePosProperty] = `${inlineStartPos}px`;
    this.topStyle.width = `${width + delta}px`;
    this.topStyle.display = "block";
    this.startStyle.top = `${top2}px`;
    this.startStyle[inlinePosProperty] = `${inlineStartPos}px`;
    this.startStyle.height = `${height + delta}px`;
    this.startStyle.display = "block";
    this.bottomStyle.top = `${top2 + height - parseInt(this.bottomStyle.height, 10) + delta}px`;
    this.bottomStyle[inlinePosProperty] = `${inlineStartPos}px`;
    this.bottomStyle.width = `${width + delta}px`;
    this.bottomStyle.display = "block";
    this.endStyle.top = `${top2}px`;
    this.endStyle[inlinePosProperty] = `${inlineStartPos + width - parseInt(this.endStyle.width, 10) + delta}px`;
    this.endStyle.height = `${height + delta}px`;
    this.endStyle.display = "block";
    let cornerVisibleSetting = this.settings.border?.cornerVisible;
    cornerVisibleSetting = typeof cornerVisibleSetting === "function" ? cornerVisibleSetting(this.settings.layerLevel) : cornerVisibleSetting;
    const hookResult = this.wot.getSetting("onModifyGetCellCoords", toRow, toColumn, false, "render");
    let [checkRow, checkCol] = [
      toRow,
      toColumn
    ];
    if (hookResult && Array.isArray(hookResult)) {
      [, , checkRow, checkCol] = hookResult;
    }
    if (isMobileBrowser() || !cornerVisibleSetting || !this.isSouthEastOfAreaSelection(checkRow, checkCol)) {
      this.cornerStyle.display = "none";
    } else {
      const cornerBorderWidth = Number(this.cornerDefaultStyle.borderWidth);
      this.cornerStyle.top = `${top2 + height + this.cornerCenterPointOffset - cornerBorderWidth}px`;
      this.cornerStyle[inlinePosProperty] = `${inlineStartPos + width + this.cornerCenterPointOffset - Number(this.cornerDefaultStyle.borderWidth)}px`;
      this.cornerStyle.borderRightWidth = `${this.cornerDefaultStyle.borderWidth}px`;
      this.cornerStyle.borderLeftWidth = `${this.cornerDefaultStyle.borderWidth}px`;
      this.cornerStyle.borderBottomWidth = `${this.cornerDefaultStyle.borderWidth}px`;
      this.cornerStyle.width = String(this.cornerDefaultStyle.width);
      this.cornerStyle.display = "none";
      let trimmingContainer = getTrimmingContainer(wtTable.TABLE);
      const trimToWindow = Object.is(trimmingContainer, rootWindow);
      if (trimToWindow) {
        trimmingContainer = rootDocument.documentElement;
      }
      const cornerBorderCompensation = parseInt(String(this.cornerDefaultStyle.borderWidth), 10) - 1;
      const cornerHalfWidth = Math.ceil(parseInt(String(this.cornerDefaultStyle.width), 10) / 2);
      Math.ceil(parseInt(String(this.cornerDefaultStyle.height), 10) / 2);
      if (toColumn === this.wot.getSetting("totalColumns") - 1) {
        const toTdOffsetLeft = trimToWindow ? toTDEl.getBoundingClientRect().left : toTDEl.offsetLeft;
        let cornerOverlappingContainer = false;
        let cornerEdge = 0;
        if (isRtl2) {
          cornerEdge = toTdOffsetLeft - parseInt(String(this.cornerDefaultStyle.width), 10) / 2;
          cornerOverlappingContainer = cornerEdge < 0;
        } else {
          cornerEdge = toTdOffsetLeft + outerWidth(toTDEl) + parseInt(String(this.cornerDefaultStyle.width), 10) / 2;
          cornerOverlappingContainer = cornerEdge >= innerWidth(trimmingContainer);
        }
        if (cornerOverlappingContainer) {
          const inlineStartPosition = Math.floor(inlineStartPos + width + this.cornerCenterPointOffset - cornerHalfWidth - cornerBorderCompensation);
          addClass(this.corner, "wtCornerInlineEndEdge");
          this.cornerStyle[inlinePosProperty] = `${inlineStartPosition - 1}px`;
        }
      } else {
        removeClass(this.corner, "wtCornerInlineEndEdge");
      }
      if (toRow === this.wot.getSetting("totalRows") - 1) {
        const toTdOffsetTop = trimToWindow ? toTDEl.getBoundingClientRect().top : toTDEl.offsetTop;
        const cornerHalfHeight = parseInt(String(this.cornerDefaultStyle.height), 10) / 2;
        const cornerBottomEdge = toTdOffsetTop + outerHeight(toTDEl) + cornerHalfHeight;
        const cornerOverlappingContainer = cornerBottomEdge >= innerHeight(trimmingContainer);
        if (cornerOverlappingContainer) {
          const cornerTopPosition = Math.floor(top2 + height + this.cornerCenterPointOffset - cornerHalfHeight - cornerBorderCompensation);
          addClass(this.corner, "wtCornerBlockEndEdge");
          this.cornerStyle.top = `${cornerTopPosition - 1}px`;
        }
      } else {
        removeClass(this.corner, "wtCornerBlockEndEdge");
      }
      this.cornerStyle.display = "block";
    }
    if (isMobileBrowser() && this.instance.getSetting("isDataViewInstance")) {
      this.updateMultipleSelectionHandlesPosition(toRow, toColumn, top2, inlineStartPos, width, height);
    }
  }
  /**
  * Check whether an entire column of cells is selected.
  *
  * @private
  * @param {number} startRowIndex Start row index.
  * @param {number} endRowIndex End row index.
  * @returns {boolean}
  */
  isEntireColumnSelected(startRowIndex, endRowIndex) {
    return startRowIndex === this.wot.wtTable.getFirstRenderedRow() && endRowIndex === this.wot.wtTable.getLastRenderedRow();
  }
  /**
  * Check whether an entire row of cells is selected.
  *
  * @private
  * @param {number} startColumnIndex Start column index.
  * @param {number} endColumnIndex End column index.
  * @returns {boolean}
  */
  isEntireRowSelected(startColumnIndex, endColumnIndex) {
    return startColumnIndex === this.wot.wtTable.getFirstRenderedColumn() && endColumnIndex === this.wot.wtTable.getLastRenderedColumn();
  }
  /**
  * Get left/top index and width/height depending on the `direction` provided.
  *
  * @private
  * @param {string} direction `rows` or `columns`, defines if an entire column or row is selected.
  * @param {number} fromIndex Start index of the selection.
  * @param {number} toIndex End index of the selection.
  * @param {number} headerIndex The header index as negative value.
  * @param {number} containerOffset Offset of the container.
  * @returns {Array|boolean} Returns an array of [headerElement, left, width] or [headerElement, top, height], depending on `direction` (`false` in case of an error getting the headers).
  */
  getDimensionsFromHeader(direction, fromIndex, toIndex, headerIndex, containerOffset) {
    const { wtTable } = this.wot;
    const rootHotElement = wtTable.wtRootElement.parentNode;
    let getHeaderFn = null;
    let dimensionFn = null;
    let entireSelectionClassname = null;
    let index2 = null;
    let dimension = null;
    let dimensionProperty = null;
    let startHeader = null;
    let endHeader = null;
    switch (direction) {
      case "rows":
        getHeaderFn = (...args) => wtTable.getRowHeader(args[0], args[1]);
        dimensionFn = (el) => outerHeight(el);
        entireSelectionClassname = "ht__selection--rows";
        dimensionProperty = "top";
        break;
      case "columns":
        getHeaderFn = (...args) => wtTable.getColumnHeader(args[0], args[1]);
        dimensionFn = (el) => outerWidth(el);
        entireSelectionClassname = "ht__selection--columns";
        dimensionProperty = "left";
        break;
    }
    if (entireSelectionClassname && rootHotElement.classList.contains(entireSelectionClassname)) {
      const columnHeaderLevelCount = this.wot.getSetting("columnHeaders").length;
      startHeader = getHeaderFn?.(fromIndex, columnHeaderLevelCount - headerIndex);
      endHeader = getHeaderFn?.(toIndex, columnHeaderLevelCount - headerIndex);
      if (!startHeader || !endHeader) {
        return false;
      }
      const startHeaderOffset = offset(startHeader);
      const endOffset = offset(endHeader);
      const startOff = startHeaderOffset[dimensionProperty];
      const endOff = endOffset[dimensionProperty];
      const contOff = containerOffset[dimensionProperty];
      index2 = startOff - contOff - 1;
      dimension = endOff + dimensionFn(endHeader) - startOff;
      return [
        startHeader,
        index2,
        dimension
      ];
    }
    return false;
  }
  /**
  * Change border style.
  *
  * @private
  * @param {string} borderElement Coordinate where add/remove border: top, bottom, start, end.
  * @param {object} border The border object descriptor.
  */
  changeBorderStyle(borderElement, border) {
    const element = this[borderElement];
    const style = element.style;
    const borderStyle = border[borderElement];
    if (!borderStyle || borderStyle.hide) {
      addClass(element, "hidden");
    } else {
      if (hasClass(element, "hidden")) {
        removeClass(element, "hidden");
      }
      style.backgroundColor = String(borderStyle.color ?? "");
      if (borderElement === "top" || borderElement === "bottom") {
        style.height = `${borderStyle.width}px`;
      }
      if (borderElement === "start" || borderElement === "end") {
        style.width = `${borderStyle.width}px`;
      }
    }
  }
  /**
  * Change border style to default.
  *
  * @private
  * @param {string} position The position type ("top", "bottom", "start", "end") to change.
  */
  changeBorderToDefaultStyle(position) {
    const defaultBorder = {
      width: 1,
      color: "#000"
    };
    const style = this[position].style;
    style.backgroundColor = defaultBorder.color;
    style.width = `${defaultBorder.width}px`;
    style.height = `${defaultBorder.width}px`;
  }
  /**
  * Toggle class 'hidden' to element.
  *
  * @private
  * @param {string} borderElement Coordinate where add/remove border: top, bottom, start, end.
  * @param {boolean} [remove] Defines type of the action to perform.
  */
  toggleHiddenClass(borderElement, remove) {
    this.changeBorderToDefaultStyle(borderElement);
    const element = this[borderElement];
    if (remove) {
      addClass(element, "hidden");
    } else {
      removeClass(element, "hidden");
    }
  }
  /**
  * Hide border.
  */
  disappear() {
    this.topStyle.display = "none";
    this.bottomStyle.display = "none";
    this.startStyle.display = "none";
    this.endStyle.display = "none";
    this.cornerStyle.display = "none";
    if (isMobileBrowser() && this.instance.getSetting("isDataViewInstance")) {
      this.selectionHandles.styles.top.display = "none";
      this.selectionHandles.styles.topHitArea.display = "none";
      this.selectionHandles.styles.bottom.display = "none";
      this.selectionHandles.styles.bottomHitArea.display = "none";
    }
  }
  /**
  * Cleans up all the DOM state related to a Border instance. Call this prior to deleting a Border instance.
  */
  destroy() {
    this.eventManager.destroyWithOwnEventsOnly();
    this.main?.parentNode?.removeChild(this.main);
  }
  // TODO As this is an internal class, should be designed for using {Walkontable}. It uses the facade,
  // TODO Con. Because the class is created on place where the instance reference comes from external origin.
  // TODO Imho, the discrimination for handling both, facade and non-facade should be handled.
  /**
  * @param {WalkontableFacade} wotInstance The Walkontable instance.
  * @param {object} settings The border settings.
  */
  constructor(wotInstance, settings) {
    if (!settings) {
      return;
    }
    this.eventManager = wotInstance.eventManager;
    this.instance = wotInstance;
    this.wot = wotInstance;
    this.settings = settings;
    this.mouseDown = false;
    this.main = null;
    this.top = null;
    this.bottom = null;
    this.start = null;
    this.end = null;
    this.topStyle = null;
    this.bottomStyle = null;
    this.startStyle = null;
    this.endStyle = null;
    this.cornerDefaultStyle = getCornerStyle(this.instance);
    this.cornerCenterPointOffset = -Math.ceil(parseInt(String(this.cornerDefaultStyle.width), 10) / 2);
    this.corner = null;
    this.cornerStyle = null;
    this.createBorders(settings);
    this.registerListeners();
  }
}
function _check_private_redeclaration$1A(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1m(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1m(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1m(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1m(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1m(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1m(receiver, descriptor);
}
function _class_private_field_init$1m(obj, privateMap, value) {
  _check_private_redeclaration$1A(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1m(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1m(receiver, privateMap, "set");
  _class_apply_descriptor_set$1m(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$15(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$15(obj, privateSet) {
  _check_private_redeclaration$1A(obj, privateSet);
  privateSet.add(obj);
}
var _activeOverlaysWot = /* @__PURE__ */ new WeakMap(), _selections = /* @__PURE__ */ new WeakMap(), _scanner = /* @__PURE__ */ new WeakMap(), _appliedClasses = /* @__PURE__ */ new WeakMap(), _destroyListeners = /* @__PURE__ */ new WeakMap(), _selectionBorders = /* @__PURE__ */ new WeakMap(), _resetCells = /* @__PURE__ */ new WeakSet();
class SelectionManager {
  /**
  * Sets the active Walkontable instance.
  *
  * @param {Walkontable} activeWot The overlays or master Walkontable instance.
  * @returns {SelectionManager}
  */
  setActiveOverlay(activeWot) {
    _class_private_field_set$1m(this, _activeOverlaysWot, activeWot);
    _class_private_field_get$1m(this, _scanner).setActiveOverlay(_class_private_field_get$1m(this, _activeOverlaysWot));
    if (!_class_private_field_get$1m(this, _appliedClasses).has(_class_private_field_get$1m(this, _activeOverlaysWot))) {
      _class_private_field_get$1m(this, _appliedClasses).set(_class_private_field_get$1m(this, _activeOverlaysWot), /* @__PURE__ */ new Set());
    }
    return this;
  }
  /**
  * Gets the Selection instance of the "focus" type.
  *
  * @returns {Selection|null}
  */
  getFocusSelection() {
    return _class_private_field_get$1m(this, _selections) !== null ? _class_private_field_get$1m(this, _selections).getFocus() : null;
  }
  /**
  * Gets the Selection instance of the "area" type.
  *
  * @returns {Selection|null}
  */
  getAreaSelection() {
    return _class_private_field_get$1m(this, _selections) !== null ? _class_private_field_get$1m(this, _selections).createLayeredArea() : null;
  }
  /**
  * Gets the Border instance associated with Selection instance.
  *
  * @param {Selection} selection The selection instance.
  * @returns {Border|null} Returns the Border instance (new for each overlay Walkontable instance).
  */
  getBorderInstance(selection) {
    if (!selection.settings.border) {
      return null;
    }
    if (_class_private_field_get$1m(this, _selectionBorders).has(selection)) {
      const borders = _class_private_field_get$1m(this, _selectionBorders).get(selection);
      if (borders.has(_class_private_field_get$1m(this, _activeOverlaysWot))) {
        return borders.get(_class_private_field_get$1m(this, _activeOverlaysWot));
      }
      const border2 = new Border(_class_private_field_get$1m(this, _activeOverlaysWot), selection.settings);
      borders.set(_class_private_field_get$1m(this, _activeOverlaysWot), border2);
      return border2;
    }
    const border = new Border(_class_private_field_get$1m(this, _activeOverlaysWot), selection.settings);
    _class_private_field_get$1m(this, _selectionBorders).set(selection, /* @__PURE__ */ new Map([
      [
        _class_private_field_get$1m(this, _activeOverlaysWot),
        border
      ]
    ]));
    return border;
  }
  /**
  * Gets all Border instances associated with Selection instance for all overlays.
  *
  * @param {Selection} selection The selection instance.
  * @returns {Border[]}
  */
  getBorderInstances(selection) {
    return Array.from(_class_private_field_get$1m(this, _selectionBorders).get(selection)?.values() ?? []);
  }
  /**
  * Destroys the Border instance associated with Selection instance.
  *
  * @param {Selection} selection The selection instance.
  */
  destroyBorders(selection) {
    _class_private_field_get$1m(this, _selectionBorders).get(selection)?.forEach((border) => border.destroy());
    _class_private_field_get$1m(this, _selectionBorders).delete(selection);
  }
  /**
  * Refreshes the multiple selector handle styles on all border instances after a theme change.
  */
  refreshAllBorderHandleStyles() {
    _class_private_field_get$1m(this, _selectionBorders).forEach((bordersMap) => {
      bordersMap.forEach((border) => {
        const hasMethod = "updateMultipleSelectorHandlesStyles" in border && typeof border.updateMultipleSelectorHandlesStyles === "function";
        if (hasMethod) {
          border.updateMultipleSelectorHandlesStyles();
        }
      });
    });
  }
  /**
  * Renders all the selections (add CSS classes to cells and draw borders).
  *
  * @param {boolean} fastDraw Indicates the render cycle type (fast/slow).
  */
  render(fastDraw) {
    if (_class_private_field_get$1m(this, _selections) === null) {
      return;
    }
    if (fastDraw) {
      _class_private_method_get$15(this, _resetCells, resetCells).call(this);
    }
    const selections = Array.from(_class_private_field_get$1m(this, _selections));
    const classNamesMap = /* @__PURE__ */ new Map();
    const headerAttributesMap = /* @__PURE__ */ new Map();
    for (let i = 0; i < selections.length; i++) {
      const selection = selections[i];
      const { className, headerAttributes, createLayers, selectionType } = selection.settings;
      if (!_class_private_field_get$1m(this, _destroyListeners).has(selection)) {
        _class_private_field_get$1m(this, _destroyListeners).add(selection);
        selection.addLocalHook("destroy", () => this.destroyBorders(selection));
      }
      const borderInstance = this.getBorderInstance(selection);
      if (selection.isEmpty()) {
        borderInstance?.disappear();
        continue;
      }
      if (className) {
        const elements = _class_private_field_get$1m(this, _scanner).setActiveSelection(selection).scan();
        elements.forEach((element) => {
          if (classNamesMap.has(element)) {
            const classNamesLayers = classNamesMap.get(element);
            if (classNamesLayers.has(className) && createLayers === true) {
              classNamesLayers.set(className, (classNamesLayers.get(className) ?? 0) + 1);
            } else {
              classNamesLayers.set(className, 1);
            }
          } else {
            classNamesMap.set(element, /* @__PURE__ */ new Map([
              [
                className,
                1
              ]
            ]));
          }
          if (headerAttributes) {
            if (!headerAttributesMap.has(element)) {
              headerAttributesMap.set(element, []);
            }
            if (element.nodeName === "TH") {
              const attrs = headerAttributes;
              headerAttributesMap.get(element).push(...attrs);
            }
          }
        });
      }
      const corners = selection.getCorners();
      _class_private_field_get$1m(this, _activeOverlaysWot).getSetting("onBeforeDrawBorders", corners, selectionType);
      borderInstance?.appear(corners);
    }
    classNamesMap.forEach((classNamesLayers, element) => {
      const classNames = Array.from(classNamesLayers).map(([className, occurrenceCount]) => {
        if (occurrenceCount === 1) {
          return className;
        }
        return [
          className,
          ...Array.from({
            length: occurrenceCount - 1
          }, (_, i) => `${className}-${i + 1}`)
        ];
      }).flat();
      classNames.forEach((className) => _class_private_field_get$1m(this, _appliedClasses).get(_class_private_field_get$1m(this, _activeOverlaysWot))?.add(className));
      addClass(element, classNames);
      if (element.nodeName === "TD" && Array.isArray(_class_private_field_get$1m(this, _selections).options?.cellAttributes)) {
        setAttribute(element, _class_private_field_get$1m(this, _selections).options.cellAttributes);
      }
    });
    Array.from(headerAttributesMap.keys()).forEach((element) => {
      setAttribute(element, [
        ...headerAttributesMap.get(element)
      ]);
    });
  }
  /**
  * Creates a new SelectionManager instance.
  *
  * @param {SelectionsContainer | null} selections The Highlight instance that holds Selection instances.
  */
  constructor(selections) {
    _class_private_method_init$15(this, _resetCells);
    _class_private_field_init$1m(this, _activeOverlaysWot, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1m(this, _selections, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1m(this, _scanner, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1m(this, _appliedClasses, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1m(this, _destroyListeners, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1m(this, _selectionBorders, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1m(this, _activeOverlaysWot, null);
    _class_private_field_set$1m(this, _scanner, new SelectionScanner());
    _class_private_field_set$1m(this, _appliedClasses, /* @__PURE__ */ new WeakMap());
    _class_private_field_set$1m(this, _destroyListeners, /* @__PURE__ */ new WeakSet());
    _class_private_field_set$1m(this, _selectionBorders, /* @__PURE__ */ new Map());
    _class_private_field_set$1m(this, _selections, selections);
  }
}
function resetCells() {
  const appliedOverlaysClasses = _class_private_field_get$1m(this, _appliedClasses).get(_class_private_field_get$1m(this, _activeOverlaysWot));
  if (!appliedOverlaysClasses) {
    return;
  }
  const classesToRemove = _class_private_field_get$1m(this, _activeOverlaysWot).wtSettings.getSetting("onBeforeRemoveCellClassNames");
  if (Array.isArray(classesToRemove)) {
    for (let i = 0; i < classesToRemove.length; i++) {
      appliedOverlaysClasses.add(classesToRemove[i]);
    }
  }
  appliedOverlaysClasses.forEach((className) => {
    const nodes = _class_private_field_get$1m(this, _activeOverlaysWot).wtTable.TABLE.querySelectorAll(`.${className}`);
    let cellAttributes = [];
    if (Array.isArray(_class_private_field_get$1m(this, _selections).options?.cellAttributes)) {
      cellAttributes = _class_private_field_get$1m(this, _selections).options.cellAttributes.map((el) => el[0]);
    }
    if (Array.isArray(_class_private_field_get$1m(this, _selections).options?.headerAttributes)) {
      cellAttributes = [
        ...cellAttributes,
        ..._class_private_field_get$1m(this, _selections).options.headerAttributes.map((el) => el[0])
      ];
    }
    for (let i = 0, len = nodes.length; i < len; i++) {
      removeClass(nodes[i], className);
      removeAttribute(nodes[i], cellAttributes);
    }
  });
  appliedOverlaysClasses.clear();
}
class InlineStartOverlay extends Overlay {
  /**
  * Factory method to create a subclass of `Table` that is relevant to this overlay.
  *
  * @see Table#constructor
  * @param {...*} args Parameters that will be forwarded to the `Table` constructor.
  * @returns {InlineStartOverlayTable}
  */
  createTable(...args) {
    return new InlineStartOverlayTable(...args);
  }
  /**
  * Checks if overlay should be fully rendered.
  *
  * @returns {boolean}
  */
  shouldBeRendered() {
    return this.wtSettings.getSetting("shouldRenderInlineStartOverlay");
  }
  /**
  * Updates the left overlay position.
  *
  * @returns {boolean}
  */
  resetFixedPosition() {
    const { wtTable } = this.wot;
    if (!this.needFullRender || !this.shouldBeRendered() || !wtTable.holder.parentNode) {
      return false;
    }
    if (!this.clone) {
      return false;
    }
    const { rootWindow } = this.domBindings;
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let overlayPosition = 0;
    if (this.trimmingContainer === rootWindow && (!preventOverflow || preventOverflow !== "horizontal")) {
      overlayPosition = this.getOverlayOffset() * (this.isRtl() ? -1 : 1);
      setOverlayPosition(overlayRoot, `${overlayPosition}px`, "0px");
    } else {
      overlayPosition = this.getScrollPosition();
      resetCssTransform(overlayRoot);
    }
    const positionChanged = this.adjustHeaderBordersPosition(overlayPosition);
    this.adjustElementsSize();
    return positionChanged;
  }
  /**
  * Sets the main overlay's horizontal scroll position.
  *
  * @param {number} pos The scroll position.
  * @returns {boolean}
  */
  setScrollPosition(pos) {
    const { rootWindow } = this.domBindings;
    const scrollableElement = this.mainTableScrollableElement;
    const scrollEl = scrollableElement;
    const getScrollPosition = () => {
      return scrollableElement === rootWindow ? rootWindow.scrollX : scrollEl.scrollLeft;
    };
    const setScrollPosition2 = (newPosition) => {
      if (scrollableElement === rootWindow) {
        rootWindow.scrollTo(newPosition, rootWindow.scrollY);
      } else {
        scrollEl.scrollLeft = newPosition;
      }
    };
    if (this.isRtl()) {
      pos = -pos;
    }
    const oldScrollPosition = getScrollPosition();
    let result = false;
    if (pos !== oldScrollPosition) {
      setScrollPosition2(pos);
      result = oldScrollPosition !== getScrollPosition();
    }
    return result;
  }
  /**
  * Triggers onScroll hook callback.
  */
  onScroll() {
    this.wtSettings.getSetting("onScrollVertically");
  }
  /**
  * Calculates total sum cells width.
  *
  * @param {number} from Column index which calculates started from.
  * @param {number} to Column index where calculation is finished.
  * @returns {number} Width sum.
  */
  sumCellSizes(from, to) {
    const defaultColumnWidth = this.wtSettings.getSetting("defaultColumnWidth");
    let column = from;
    let sum2 = 0;
    while (column < to) {
      sum2 += this.wot.wtTable.getColumnWidth(column) || defaultColumnWidth;
      column += 1;
    }
    return sum2;
  }
  /**
  * Adjust overlay root element, children and master table element sizes (width, height).
  */
  adjustElementsSize() {
    this.updateTrimmingContainer();
    if (this.needFullRender) {
      this.adjustRootElementSize();
      this.adjustRootChildrenSize();
    }
  }
  /**
  * Adjust overlay root element size (width and height).
  */
  adjustRootElementSize() {
    if (!this.clone) {
      return;
    }
    const { wtTable, wtViewport } = this.wot;
    const { rootDocument, rootWindow } = this.domBindings;
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    const overlayRootStyle = overlayRoot.style;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    if (this.trimmingContainer !== rootWindow || preventOverflow === "vertical") {
      let height = wtViewport.getWorkspaceHeight();
      if (wtViewport.hasHorizontalScroll()) {
        const masterClientHeight = wtTable.holder.clientHeight;
        height = masterClientHeight > 0 ? masterClientHeight : height - getScrollbarWidth(rootDocument);
      }
      height = Math.min(height, wtTable.wtRootElement.scrollHeight);
      overlayRootStyle.height = `${height}px`;
    } else {
      overlayRootStyle.height = "";
    }
    this.clone.wtTable.holder.style.height = overlayRootStyle.height;
    const tableWidth = outerWidth(this.clone.wtTable.TABLE);
    overlayRootStyle.width = `${tableWidth}px`;
  }
  /**
  * Adjust overlay root childs size.
  */
  adjustRootChildrenSize() {
    if (!this.clone) {
      return;
    }
    const { holder: holder2 } = this.clone.wtTable;
    const cornerStyle = getCornerStyle(this.wot);
    const selectionCornerOffset = this.wot.selectionManager.getFocusSelection() ? parseInt(cornerStyle.width, 10) / 2 : 0;
    this.clone.wtTable.hider.style.height = this.hider.style.height;
    const holderParent = holder2.parentNode;
    holder2.style.height = holderParent.style.height;
    holder2.style.width = `${parseInt(holderParent.style.width, 10) + selectionCornerOffset}px`;
  }
  /**
  * Adjust the overlay dimensions and position.
  */
  applyToDOM() {
    const total = this.wtSettings.getSetting("totalColumns");
    const styleProperty = this.isRtl() ? "right" : "left";
    if (typeof this.wot.wtViewport.columnsRenderCalculator?.startPosition === "number") {
      this.spreader.style[styleProperty] = `${this.wot.wtViewport.columnsRenderCalculator.startPosition}px`;
    } else if (total === 0) {
      this.spreader.style[styleProperty] = "0";
    } else {
      throwWithCause("Incorrect value of the columnsRenderCalculator");
    }
    if (this.isRtl()) {
      this.spreader.style.left = "";
    } else {
      this.spreader.style.right = "";
    }
    if (this.needFullRender) {
      this.syncOverlayOffset();
    }
  }
  /**
  * Synchronize calculated top position to an element.
  */
  syncOverlayOffset() {
    if (!this.clone) {
      return;
    }
    if (typeof this.wot.wtViewport.rowsRenderCalculator?.startPosition === "number") {
      this.clone.wtTable.spreader.style.top = `${this.wot.wtViewport.rowsRenderCalculator.startPosition}px`;
    } else {
      this.clone.wtTable.spreader.style.top = "";
    }
  }
  /**
  * Scrolls horizontally to a column at the left edge of the viewport.
  *
  * @param {number} sourceCol  Column index which you want to scroll to.
  * @param {boolean} [beyondRendered]  If `true`, scrolls according to the right
  *                                    edge (left edge is by default).
  * @returns {boolean}
  */
  scrollTo(sourceCol, beyondRendered) {
    const { wtSettings } = this;
    const rowHeaders = wtSettings.getSetting("rowHeaders");
    const fixedColumnsStart = wtSettings.getSetting("fixedColumnsStart");
    const sourceInstance = this.wot.cloneSource ? this.wot.cloneSource : this.wot;
    const mainHolder = sourceInstance.wtTable.holder;
    const rowHeaderBorderCompensation = fixedColumnsStart === 0 && rowHeaders.length > 0 && !hasClass(mainHolder.parentNode, "innerBorderInlineStart") ? 1 : 0;
    let newX = this.getTableParentOffset();
    let scrollbarCompensation = 0;
    if (beyondRendered) {
      const columnWidth = this.wot.wtTable.getColumnWidth(sourceCol);
      const viewportWidth = this.wot.wtViewport.getViewportWidth();
      if (columnWidth > viewportWidth) {
        beyondRendered = false;
      }
    }
    if (beyondRendered && mainHolder.offsetWidth !== mainHolder.clientWidth) {
      scrollbarCompensation = getScrollbarWidth(this.domBindings.rootDocument);
    }
    if (beyondRendered) {
      newX += this.sumCellSizes(0, sourceCol + 1);
      newX -= this.wot.wtViewport.getViewportWidth();
      newX += rowHeaderBorderCompensation;
    } else {
      newX += this.sumCellSizes(this.wtSettings.getSetting("fixedColumnsStart"), sourceCol);
    }
    newX += scrollbarCompensation;
    if (getMaximumScrollLeft(this.mainTableScrollableElement) === newX - rowHeaderBorderCompensation && rowHeaderBorderCompensation > 0) {
      this.wot.wtOverlays.expandHiderHorizontallyBy(rowHeaderBorderCompensation);
    }
    return this.setScrollPosition(newX);
  }
  /**
  * Gets table parent left position.
  *
  * @returns {number}
  */
  getTableParentOffset() {
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let offset2 = 0;
    if (!preventOverflow && this.trimmingContainer === this.domBindings.rootWindow) {
      offset2 = this.wot.wtTable.holderOffset.left;
    }
    return offset2;
  }
  /**
  * Gets the main overlay's horizontal scroll position.
  *
  * @returns {number} Main table's horizontal scroll position.
  */
  getScrollPosition() {
    return Math.abs(getScrollLeft$1(this.mainTableScrollableElement, this.domBindings.rootWindow));
  }
  /**
  * Gets the main overlay's horizontal overlay offset.
  *
  * @returns {number} Main table's horizontal overlay offset.
  */
  getOverlayOffset() {
    const { rootWindow } = this.domBindings;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let overlayOffset = 0;
    if (this.trimmingContainer === rootWindow && (!preventOverflow || preventOverflow !== "horizontal")) {
      if (this.isRtl()) {
        overlayOffset = Math.abs(Math.min(this.getTableParentOffset() - this.getScrollPosition(), 0));
      } else {
        overlayOffset = Math.max(this.getScrollPosition() - this.getTableParentOffset(), 0);
      }
      const rootWidth = this.wot.wtTable.getTotalWidth();
      const overlayRootWidth = this.clone ? this.clone.wtTable.getTotalWidth() : 0;
      const maxOffset = rootWidth - overlayRootWidth;
      if (overlayOffset > maxOffset) {
        overlayOffset = 0;
      }
    }
    return overlayOffset;
  }
  /**
  * Adds css classes to hide the header border's header (cell-selection border hiding issue).
  *
  * @param {number} position Header X position if trimming container is window or scroll top if not.
  * @returns {boolean}
  */
  adjustHeaderBordersPosition(position) {
    const { wtSettings } = this;
    const masterParent = this.wot.wtTable.holder.parentNode;
    const rowHeaders = wtSettings.getSetting("rowHeaders");
    const fixedColumnsStart = wtSettings.getSetting("fixedColumnsStart");
    const totalRows = wtSettings.getSetting("totalRows");
    const preventVerticalOverflow = wtSettings.getSetting("preventOverflow") === "vertical";
    if (totalRows) {
      removeClass(masterParent, "emptyRows");
    } else {
      addClass(masterParent, "emptyRows");
    }
    let positionChanged = false;
    if (!preventVerticalOverflow) {
      if (fixedColumnsStart && !rowHeaders.length) {
        addClass(masterParent, "innerBorderLeft innerBorderInlineStart");
      } else if (!fixedColumnsStart && rowHeaders.length) {
        const previousState = hasClass(masterParent, "innerBorderInlineStart");
        if (position) {
          addClass(masterParent, "innerBorderLeft innerBorderInlineStart");
          positionChanged = !previousState;
        } else {
          removeClass(masterParent, "innerBorderLeft innerBorderInlineStart");
          positionChanged = previousState;
        }
      }
    }
    return positionChanged;
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @TODO refactoring: check if can be deleted.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {DomBindings} domBindings Dom elements bound to the current instance.
  */
  constructor(wotInstance, facadeGetter, wtSettings, domBindings) {
    super(wotInstance, facadeGetter, CLONE_INLINE_START, wtSettings, domBindings);
  }
}
const MIXIN_NAME$1 = "stickyRowsTop";
const stickyRowsTop = {
  /**
  * Get the source index of the first rendered row. If no rows are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getFirstRenderedRow() {
    const allStickyRows = this.getRenderedRowsCount();
    if (allStickyRows === 0) {
      return -1;
    }
    return 0;
  },
  /**
  * Get the source index of the first row fully visible in the viewport. If no rows are fully visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getFirstVisibleRow() {
    return this.getFirstRenderedRow();
  },
  /**
  * Get the source index of the first row partially visible in the viewport. If no rows are partially visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getFirstPartiallyVisibleRow() {
    return this.getFirstRenderedRow();
  },
  /**
  * Get the source index of the last rendered row. If no rows are rendered, returns an error code: -1.
  *
  * @returns {number}
  * @this Table
  */
  getLastRenderedRow() {
    return this.getRenderedRowsCount() - 1;
  },
  /**
  * Get the source index of the last row fully visible in the viewport. If no rows are fully visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getLastVisibleRow() {
    return this.getLastRenderedRow();
  },
  /**
  * Get the source index of the last row partially visible in the viewport. If no rows are partially visible, returns an error code: -1.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getLastPartiallyVisibleRow() {
    return this.getLastRenderedRow();
  },
  /**
  * Get the number of rendered rows.
  *
  * @returns {number}
  * @this Table
  */
  getRenderedRowsCount() {
    return Math.min(this.wtSettings.getSetting("totalRows") ?? 0, this.wtSettings.getSetting("fixedRowsTop"));
  },
  /**
  * Get the number of fully visible rows in the viewport.
  * Assumes that all rendered rows are fully visible.
  *
  * @returns {number}
  * @this Table
  */
  getVisibleRowsCount() {
    return this.getRenderedRowsCount();
  },
  /**
  * Get the number of rendered column headers.
  *
  * @returns {number}
  * @this Table
  */
  getColumnHeadersCount() {
    return this.dataAccessObject.columnHeaders.length;
  }
};
defineGetter(stickyRowsTop, "MIXIN_NAME", MIXIN_NAME$1, {
  writable: false,
  enumerable: false
});
class TopInlineStartCornerOverlayTable extends Table {
  /**
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings) {
    super(dataAccessObject, facadeGetter, domBindings, wtSettings, CLONE_TOP_INLINE_START_CORNER);
  }
}
mixin(TopInlineStartCornerOverlayTable, stickyRowsTop);
mixin(TopInlineStartCornerOverlayTable, stickyColumnsStart);
class TopInlineStartCornerOverlay extends Overlay {
  /**
  * Factory method to create a subclass of `Table` that is relevant to this overlay.
  *
  * @see Table#constructor
  * @param {...*} args Parameters that will be forwarded to the `Table` constructor.
  * @returns {TopInlineStartCornerOverlayTable}
  */
  createTable(...args) {
    return new TopInlineStartCornerOverlayTable(...args);
  }
  /**
  * Checks if overlay should be fully rendered.
  *
  * @returns {boolean}
  */
  shouldBeRendered() {
    return this.wtSettings.getSetting("shouldRenderTopOverlay") && this.wtSettings.getSetting("shouldRenderInlineStartOverlay");
  }
  /**
  * Prevents scroll position changes for this overlay.
  * @param {number} _pos The scroll position to set (ignored).
  * @returns {boolean} Always returns false.
  */
  setScrollPosition(_pos) {
    return false;
  }
  /**
  * Gets the scroll position for this overlay.
  * @returns {number} Always returns 0.
  */
  getScrollPosition() {
    return 0;
  }
  /**
  * Gets the parent table offset for this overlay.
  * @returns {number} Always returns 0.
  */
  getTableParentOffset() {
    return 0;
  }
  /**
  * Gets the overlay offset for this corner overlay.
  * @returns {number} Always returns 0.
  */
  getOverlayOffset() {
    return 0;
  }
  /**
  * Handles scroll events (intentionally empty for corner overlay).
  */
  onScroll() {
  }
  /**
  * Sums cell sizes within a range.
  * @param {number} _from The starting cell index (ignored).
  * @param {number} _to The ending cell index (ignored).
  * @returns {number} Always returns 0.
  */
  sumCellSizes(_from, _to) {
    return 0;
  }
  /**
  * Adjusts overlay element sizes (intentionally empty for corner overlay).
  */
  adjustElementsSize() {
  }
  /**
  * Applies changes to the DOM (intentionally empty for corner overlay).
  */
  applyToDOM() {
  }
  /**
  * Scrolls the overlay to a specified position.
  * @param {number} _sourceIndex The source index to scroll to (ignored).
  * @param {boolean} _snapToEdge Whether to snap to edge (ignored).
  * @returns {boolean} Always returns false.
  */
  scrollTo(_sourceIndex, _snapToEdge) {
    return false;
  }
  /**
  * Updates the corner overlay position.
  *
  * @returns {boolean}
  */
  resetFixedPosition() {
    this.updateTrimmingContainer();
    if (!this.wot.wtTable.holder.parentNode || !this.clone) {
      return false;
    }
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    if (this.trimmingContainer === this.domBindings.rootWindow) {
      const left2 = this.inlineStartOverlay.getOverlayOffset() * (this.isRtl() ? -1 : 1);
      const top2 = this.topOverlay.getOverlayOffset();
      setOverlayPosition(overlayRoot, `${left2}px`, `${top2}px`);
    } else {
      resetCssTransform(overlayRoot);
    }
    let tableHeight = outerHeight(this.clone.wtTable.TABLE);
    const tableWidth = outerWidth(this.clone.wtTable.TABLE);
    if (!this.wot.wtTable.hasDefinedSize()) {
      tableHeight = 0;
    }
    overlayRoot.style.height = `${tableHeight}px`;
    overlayRoot.style.width = `${tableWidth}px`;
    return true;
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @TODO refactoring: check if can be deleted.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {DomBindings} domBindings Dom elements bound to the current instance.
  * @param {TopOverlay} topOverlay The instance of the Top overlay.
  * @param {InlineStartOverlay} inlineStartOverlay The instance of the InlineStart overlay.
  */
  constructor(wotInstance, facadeGetter, wtSettings, domBindings, topOverlay, inlineStartOverlay) {
    super(wotInstance, facadeGetter, CLONE_TOP_INLINE_START_CORNER, wtSettings, domBindings);
    this.topOverlay = topOverlay;
    this.inlineStartOverlay = inlineStartOverlay;
  }
}
class TopOverlayTable extends Table {
  /**
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings) {
    super(dataAccessObject, facadeGetter, domBindings, wtSettings, CLONE_TOP);
  }
}
mixin(TopOverlayTable, stickyRowsTop);
mixin(TopOverlayTable, calculatedColumns);
class TopOverlay extends Overlay {
  /**
  * Factory method to create a subclass of `Table` that is relevant to this overlay.
  *
  * @see Table#constructor
  * @param {...*} args Parameters that will be forwarded to the `Table` constructor.
  * @returns {TopOverlayTable}
  */
  createTable(...args) {
    return new TopOverlayTable(...args);
  }
  /**
  * Checks if overlay should be fully rendered.
  *
  * @returns {boolean}
  */
  shouldBeRendered() {
    return this.wtSettings.getSetting("shouldRenderTopOverlay");
  }
  /**
  * Updates the top overlay position.
  *
  * @returns {boolean}
  */
  resetFixedPosition() {
    if (!this.needFullRender || !this.shouldBeRendered() || !this.wot.wtTable.holder.parentNode || !this.clone) {
      return false;
    }
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    const { rootWindow } = this.domBindings;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let overlayPosition = 0;
    let skipInnerBorderAdjusting = false;
    if (this.trimmingContainer === rootWindow && (!preventOverflow || preventOverflow !== "vertical")) {
      const { wtTable } = this.wot;
      const hiderRect = wtTable.hider.getBoundingClientRect();
      const bottom2 = Math.ceil(hiderRect.bottom);
      const rootHeight = overlayRoot.offsetHeight;
      skipInnerBorderAdjusting = bottom2 === rootHeight;
      overlayPosition = this.getOverlayOffset();
      setOverlayPosition(overlayRoot, "0px", `${overlayPosition}px`);
    } else {
      overlayPosition = this.getScrollPosition();
      resetCssTransform(overlayRoot);
    }
    const positionChanged = this.adjustHeaderBordersPosition(overlayPosition, skipInnerBorderAdjusting);
    this.adjustElementsSize();
    return positionChanged;
  }
  /**
  * Sets the main overlay's vertical scroll position.
  *
  * @param {number} pos The scroll position.
  * @returns {boolean}
  */
  setScrollPosition(pos) {
    const { rootWindow } = this.domBindings;
    const scrollableElement = this.mainTableScrollableElement;
    const scrollEl = scrollableElement;
    const getScrollPosition = () => {
      return scrollableElement === rootWindow ? rootWindow.scrollY : scrollEl.scrollTop;
    };
    const setScrollPosition2 = (newPosition) => {
      if (scrollableElement === rootWindow) {
        rootWindow.scrollTo(rootWindow.scrollX, newPosition);
      } else {
        scrollEl.scrollTop = newPosition;
      }
    };
    const oldScrollPosition = getScrollPosition();
    let result = false;
    if (pos !== oldScrollPosition) {
      setScrollPosition2(pos);
      result = oldScrollPosition !== getScrollPosition();
    }
    return result;
  }
  /**
  * Triggers onScroll hook callback.
  */
  onScroll() {
    this.wtSettings.getSetting("onScrollHorizontally");
  }
  /**
  * Calculates total sum cells height.
  *
  * @param {number} from Row index which calculates started from.
  * @param {number} to Row index where calculation is finished.
  * @returns {number} Height sum.
  */
  sumCellSizes(from, to) {
    const stylesHandler = this.wtSettings.getSetting("stylesHandler");
    const defaultRowHeight = stylesHandler.getDefaultRowHeight();
    let row = from;
    let sum2 = 0;
    while (row < to) {
      const height = this.wot.wtTable.getRowHeight(row);
      sum2 += height === void 0 ? defaultRowHeight : height;
      row += 1;
    }
    return sum2;
  }
  /**
  * Adjust overlay root element, children and master table element sizes (width, height).
  */
  adjustElementsSize() {
    this.updateTrimmingContainer();
    if (this.needFullRender) {
      this.adjustRootElementSize();
      this.adjustRootChildrenSize();
    }
  }
  /**
  * Adjust overlay root element size (width and height).
  */
  adjustRootElementSize() {
    if (!this.clone) {
      return;
    }
    const { wtTable, wtViewport } = this.wot;
    const { rootDocument, rootWindow } = this.domBindings;
    const overlayRoot = this.clone.wtTable.holder.parentNode;
    const overlayRootStyle = overlayRoot.style;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    if (this.trimmingContainer !== rootWindow || preventOverflow === "horizontal") {
      let width = wtViewport.getWorkspaceWidth();
      if (wtViewport.hasVerticalScroll()) {
        width -= getScrollbarWidth(rootDocument);
      }
      width = Math.min(width, wtTable.wtRootElement.scrollWidth);
      overlayRootStyle.width = `${width}px`;
    } else {
      overlayRootStyle.width = "";
    }
    this.clone.wtTable.holder.style.width = overlayRootStyle.width;
    let tableHeight = outerHeight(this.clone.wtTable.TABLE);
    if (!wtTable.hasDefinedSize()) {
      tableHeight = 0;
    }
    overlayRootStyle.height = `${tableHeight}px`;
  }
  /**
  * Adjust overlay root childs size.
  */
  adjustRootChildrenSize() {
    if (!this.clone) {
      return;
    }
    const { holder: holder2 } = this.clone.wtTable;
    const cornerStyle = getCornerStyle(this.wot);
    const selectionCornerOffset = this.wot.selectionManager.getFocusSelection() ? parseInt(cornerStyle.height, 10) / 2 : 0;
    this.clone.wtTable.hider.style.width = this.hider.style.width;
    const holderParent = holder2.parentNode;
    holder2.style.width = holderParent.style.width;
    holder2.style.height = `${parseInt(holderParent.style.height, 10) + selectionCornerOffset}px`;
  }
  /**
  * Adjust the overlay dimensions and position.
  */
  applyToDOM() {
    const total = this.wtSettings.getSetting("totalRows") ?? 0;
    if (typeof this.wot.wtViewport.rowsRenderCalculator?.startPosition === "number") {
      this.spreader.style.top = `${this.wot.wtViewport.rowsRenderCalculator.startPosition}px`;
    } else if (total === 0) {
      this.spreader.style.top = "0";
    } else {
      throwWithCause("Incorrect value of the rowsRenderCalculator");
    }
    this.spreader.style.bottom = "";
    if (this.needFullRender) {
      this.syncOverlayOffset();
    }
  }
  /**
  * Synchronize calculated left position to an element.
  */
  syncOverlayOffset() {
    if (!this.clone) {
      return;
    }
    const styleProperty = this.isRtl() ? "right" : "left";
    const { spreader } = this.clone.wtTable;
    if (typeof this.wot.wtViewport.columnsRenderCalculator?.startPosition === "number") {
      spreader.style[styleProperty] = `${this.wot.wtViewport.columnsRenderCalculator.startPosition}px`;
    } else {
      spreader.style[styleProperty] = "";
    }
  }
  /**
  * Scrolls vertically to a row.
  *
  * @param {number} sourceRow Row index which you want to scroll to.
  * @param {boolean} [bottomEdge] If `true`, scrolls according to the bottom edge (top edge is by default).
  * @returns {boolean}
  */
  scrollTo(sourceRow, bottomEdge) {
    const { wot, wtSettings } = this;
    const sourceInstance = wot.cloneSource ? wot.cloneSource : wot;
    const mainHolder = sourceInstance.wtTable.holder;
    const columnHeaders = wtSettings.getSetting("columnHeaders");
    const fixedRowsTop = wtSettings.getSetting("fixedRowsTop");
    const columnHeaderBorderCompensation = fixedRowsTop === 0 && columnHeaders.length > 0 && !hasClass(mainHolder.parentNode, "innerBorderTop") ? 1 : 0;
    let newY = this.getTableParentOffset();
    let scrollbarCompensation = 0;
    if (bottomEdge) {
      const rowHeight = this.wot.wtTable.getRowHeight(sourceRow) ?? 0;
      const viewportHeight = this.wot.wtViewport.getViewportHeight();
      if (rowHeight > viewportHeight) {
        bottomEdge = false;
      }
    }
    if (bottomEdge && mainHolder.offsetHeight !== mainHolder.clientHeight) {
      scrollbarCompensation = getScrollbarWidth(this.domBindings.rootDocument);
    }
    if (bottomEdge) {
      const fixedRowsBottom = wtSettings.getSetting("fixedRowsBottom");
      const totalRows = wtSettings.getSetting("totalRows");
      newY += this.sumCellSizes(0, sourceRow + 1);
      newY -= wot.wtViewport.getViewportHeight() - this.sumCellSizes(totalRows - fixedRowsBottom, totalRows);
      newY += 1;
      newY += columnHeaderBorderCompensation;
    } else {
      newY += this.sumCellSizes(wtSettings.getSetting("fixedRowsTop"), sourceRow);
    }
    newY += scrollbarCompensation;
    if (getMaximumScrollTop(this.mainTableScrollableElement) === newY - columnHeaderBorderCompensation && columnHeaderBorderCompensation > 0) {
      this.wot.wtOverlays.expandHiderVerticallyBy(columnHeaderBorderCompensation);
    }
    return this.setScrollPosition(newY);
  }
  /**
  * Gets table parent top position.
  *
  * @returns {number}
  */
  getTableParentOffset() {
    if (this.mainTableScrollableElement === this.domBindings.rootWindow) {
      return this.wot.wtTable.holderOffset.top;
    }
    return 0;
  }
  /**
  * Gets the main overlay's vertical scroll position.
  *
  * @returns {number} Main table's vertical scroll position.
  */
  getScrollPosition() {
    return getScrollTop$1(this.mainTableScrollableElement, this.domBindings.rootWindow);
  }
  /**
  * Gets the main overlay's vertical overlay offset.
  *
  * @returns {number} Main table's vertical overlay offset.
  */
  getOverlayOffset() {
    const { rootWindow } = this.domBindings;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let overlayOffset = 0;
    if (this.trimmingContainer === rootWindow && (!preventOverflow || preventOverflow !== "vertical")) {
      const rootHeight = this.wot.wtTable.getTotalHeight();
      const overlayRootHeight = this.clone ? this.clone.wtTable.getTotalHeight() : 0;
      const maxOffset = rootHeight - overlayRootHeight;
      overlayOffset = Math.max(this.getScrollPosition() - this.getTableParentOffset(), 0);
      if (overlayOffset > maxOffset) {
        overlayOffset = 0;
      }
    }
    return overlayOffset;
  }
  /**
  * Adds css classes to hide the header border's header (cell-selection border hiding issue).
  *
  * @param {number} position Header Y position if trimming container is window or scroll top if not.
  * @param {boolean} [skipInnerBorderAdjusting=false] If `true` the inner border adjusting will be skipped.
  * @returns {boolean}
  */
  adjustHeaderBordersPosition(position, skipInnerBorderAdjusting = false) {
    const { wtSettings } = this;
    const masterParent = this.wot.wtTable.holder.parentNode;
    const totalColumns = wtSettings.getSetting("totalColumns") ?? 0;
    const preventHorizontalOverflow = wtSettings.getSetting("preventOverflow") === "horizontal";
    if (totalColumns) {
      removeClass(masterParent, "emptyColumns");
    } else {
      addClass(masterParent, "emptyColumns");
    }
    let positionChanged = false;
    if (!skipInnerBorderAdjusting && !preventHorizontalOverflow) {
      const fixedRowsTop = wtSettings.getSetting("fixedRowsTop");
      const areFixedRowsTopChanged = this.cachedFixedRowsTop !== fixedRowsTop;
      const columnHeaders = wtSettings.getSetting("columnHeaders");
      if ((areFixedRowsTopChanged || fixedRowsTop === 0) && columnHeaders.length > 0) {
        const previousState = hasClass(masterParent, "innerBorderTop");
        this.cachedFixedRowsTop = wtSettings.getSetting("fixedRowsTop");
        if (position || wtSettings.getSetting("totalRows") === 0) {
          addClass(masterParent, "innerBorderTop");
          positionChanged = !previousState;
        } else {
          removeClass(masterParent, "innerBorderTop");
          positionChanged = previousState;
        }
      }
    }
    return positionChanged;
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @TODO refactoring: check if can be deleted.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {DomBindings} domBindings Dom elements bound to the current instance.
  */
  constructor(wotInstance, facadeGetter, wtSettings, domBindings) {
    super(wotInstance, facadeGetter, CLONE_TOP, wtSettings, domBindings), /**
    * Cached value which holds the previous value of the `fixedRowsTop` option.
    * It is used as a comparison value that can be used to detect changes in this value.
    *
    * @type {number}
    */
    this.cachedFixedRowsTop = -1;
    this.cachedFixedRowsTop = this.wtSettings.getSetting("fixedRowsTop");
  }
}
function _check_private_redeclaration$1z(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1l(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1l(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1l(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1l(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1l(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1l(receiver, descriptor);
}
function _class_private_field_init$1l(obj, privateMap, value) {
  _check_private_redeclaration$1z(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1l(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1l(receiver, privateMap, "set");
  _class_apply_descriptor_set$1l(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$14(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$14(obj, privateSet) {
  _check_private_redeclaration$1z(obj, privateSet);
  privateSet.add(obj);
}
var _overlays$1 = /* @__PURE__ */ new WeakMap(), _active = /* @__PURE__ */ new WeakMap(), _mouseDown$1 = /* @__PURE__ */ new WeakMap(), _activate = /* @__PURE__ */ new WeakSet(), _getScrollTop = /* @__PURE__ */ new WeakSet(), _getScrollLeft = /* @__PURE__ */ new WeakSet(), _setScrollPosition = /* @__PURE__ */ new WeakSet(), _clearSpreaderInsetStyles = /* @__PURE__ */ new WeakSet(), _applySpreaderStyles = /* @__PURE__ */ new WeakSet(), _applyCloneSpreaderStyles = /* @__PURE__ */ new WeakSet(), _isScrollbarTarget = /* @__PURE__ */ new WeakSet(), _isWindowScroll = /* @__PURE__ */ new WeakSet(), _isRtl$4 = /* @__PURE__ */ new WeakSet();
class StickyScrollStrategy {
  /**
  * Registers mousedown/mouseup listeners for scrollbar drag detection.
  * Called from `Overlays.registerListeners()`.
  */
  registerListeners() {
    const { eventManager, domBindings: { rootDocument } } = _class_private_field_get$1l(this, _overlays$1);
    if (_class_private_field_get$1l(this, _active)) {
      _class_private_field_set$1l(this, _active, false);
      _class_private_method_get$14(this, _applySpreaderStyles, applySpreaderStyles).call(this, "relative", 0, 0);
    }
    _class_private_field_set$1l(this, _mouseDown$1, false);
    eventManager.addEventListener(rootDocument, "mousedown", (event) => {
      if (event instanceof MouseEvent) {
        _class_private_field_set$1l(this, _mouseDown$1, _class_private_method_get$14(this, _isScrollbarTarget, isScrollbarTarget).call(this, event));
      }
    });
    eventManager.addEventListener(rootDocument, "mouseup", () => {
      _class_private_field_set$1l(this, _mouseDown$1, false);
      if (_class_private_field_get$1l(this, _active)) {
        this.deactivate();
      }
    });
  }
  /**
  * Checks whether sticky-scroll should activate based on the current state.
  * Called from `Overlays.syncScrollPositions()` after scroll direction is determined.
  *
  * @param {boolean} verticalScrolling Whether vertical scrolling occurred.
  * @param {boolean} horizontalScrolling Whether horizontal scrolling occurred.
  */
  tryActivate(verticalScrolling, horizontalScrolling) {
    if (_class_private_field_get$1l(this, _mouseDown$1) && !_class_private_field_get$1l(this, _active) && !isSafari() && (verticalScrolling || horizontalScrolling)) {
      _class_private_method_get$14(this, _activate, activate).call(this);
    }
  }
  /**
  * Recalculates and applies sticky offsets on all spreaders. Called after
  * every render (both full and fast draws) to keep the sticky offset in
  * sync with the current scroll position.
  */
  syncOffsets() {
    if (!_class_private_field_get$1l(this, _active)) {
      return;
    }
    const overlays = _class_private_field_get$1l(this, _overlays$1);
    const { wtViewport } = overlays.wot;
    const startTop = wtViewport.rowsRenderCalculator?.startPosition;
    const startLeft = wtViewport.columnsRenderCalculator?.startPosition;
    if (typeof startTop !== "number" || typeof startLeft !== "number") {
      return;
    }
    const stickyTop = startTop - _class_private_method_get$14(this, _getScrollTop, getScrollTop).call(this);
    const stickyLeft = startLeft - _class_private_method_get$14(this, _getScrollLeft, getScrollLeft).call(this);
    _class_private_method_get$14(this, _applySpreaderStyles, applySpreaderStyles).call(this, "sticky", stickyTop, stickyLeft);
  }
  /**
  * Cleans up on destroy.
  */
  destroy() {
    if (_class_private_field_get$1l(this, _active)) {
      _class_private_method_get$14(this, _applySpreaderStyles, applySpreaderStyles).call(this, "relative", 0, 0);
    }
    _class_private_field_set$1l(this, _active, false);
    _class_private_field_set$1l(this, _mouseDown$1, false);
  }
  /**
  * Deactivates sticky-scroll mode: captures the current offsets, adjusts
  * the scroll position to match, then restores `position: relative` and
  * triggers a final full render.
  */
  deactivate() {
    const overlays = _class_private_field_get$1l(this, _overlays$1);
    const spreader = overlays.wtTable.spreader;
    const { wtViewport } = overlays.wot;
    const isRtl2 = overlays.wtSettings.getSetting("rtlMode");
    const leftProp = isRtl2 ? "right" : "left";
    overlays.refreshAll();
    const lastStickyTop = Number.parseInt(spreader.style.top, 10) || 0;
    const lastStickyLeft = Number.parseInt(spreader.style[leftProp], 10) || 0;
    const startTop = wtViewport.rowsRenderCalculator?.startPosition;
    const startLeft = wtViewport.columnsRenderCalculator?.startPosition;
    const targetScrollTop = typeof startTop === "number" ? startTop - lastStickyTop : _class_private_method_get$14(this, _getScrollTop, getScrollTop).call(this);
    const targetScrollLeft = typeof startLeft === "number" ? startLeft - lastStickyLeft : _class_private_method_get$14(this, _getScrollLeft, getScrollLeft).call(this);
    _class_private_method_get$14(this, _setScrollPosition, setScrollPosition).call(this, targetScrollTop, targetScrollLeft);
    _class_private_field_set$1l(this, _active, false);
    _class_private_method_get$14(this, _applySpreaderStyles, applySpreaderStyles).call(this, "relative", 0, 0);
    overlays.refreshAll();
    overlays.applyToDOM();
  }
  /**
  * @param {Overlays} overlays The parent Overlays instance.
  */
  constructor(overlays) {
    _class_private_method_init$14(this, _activate);
    _class_private_method_init$14(this, _getScrollTop);
    _class_private_method_init$14(this, _getScrollLeft);
    _class_private_method_init$14(this, _setScrollPosition);
    _class_private_method_init$14(this, _clearSpreaderInsetStyles);
    _class_private_method_init$14(this, _applySpreaderStyles);
    _class_private_method_init$14(this, _applyCloneSpreaderStyles);
    _class_private_method_init$14(this, _isScrollbarTarget);
    _class_private_method_init$14(this, _isWindowScroll);
    _class_private_method_init$14(this, _isRtl$4);
    _class_private_field_init$1l(this, _overlays$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1l(this, _active, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1l(this, _mouseDown$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1l(this, _active, false);
    _class_private_field_set$1l(this, _mouseDown$1, false);
    _class_private_field_set$1l(this, _overlays$1, overlays);
  }
}
function activate() {
  const overlays = _class_private_field_get$1l(this, _overlays$1);
  const spreader = overlays.wtTable.spreader;
  const isRtl2 = overlays.wtSettings.getSetting("rtlMode");
  const leftProp = isRtl2 ? "right" : "left";
  const startTop = Number.parseInt(spreader.style.top, 10) || 0;
  const stickyTop = startTop - _class_private_method_get$14(this, _getScrollTop, getScrollTop).call(this);
  const startLeft = Number.parseInt(spreader.style[leftProp], 10) || 0;
  const stickyLeft = startLeft - _class_private_method_get$14(this, _getScrollLeft, getScrollLeft).call(this);
  _class_private_field_set$1l(this, _active, true);
  _class_private_method_get$14(this, _applySpreaderStyles, applySpreaderStyles).call(this, "sticky", stickyTop, stickyLeft);
}
function getScrollTop() {
  const { topOverlay } = _class_private_field_get$1l(this, _overlays$1);
  return topOverlay.getScrollPosition() - topOverlay.getTableParentOffset();
}
function getScrollLeft() {
  const { inlineStartOverlay } = _class_private_field_get$1l(this, _overlays$1);
  if (_class_private_method_get$14(this, _isRtl$4, isRtl).call(this) && _class_private_method_get$14(this, _isWindowScroll, isWindowScroll).call(this)) {
    return Math.abs(inlineStartOverlay.getScrollPosition());
  }
  return Math.abs(inlineStartOverlay.getScrollPosition()) - inlineStartOverlay.getTableParentOffset();
}
function setScrollPosition(top2, left2) {
  const overlays = _class_private_field_get$1l(this, _overlays$1);
  if (_class_private_method_get$14(this, _isWindowScroll, isWindowScroll).call(this)) {
    const { rootWindow } = overlays.domBindings;
    const absoluteLeft = _class_private_method_get$14(this, _isRtl$4, isRtl).call(this) ? left2 : left2 + overlays.inlineStartOverlay.getTableParentOffset();
    rootWindow.scrollTo(absoluteLeft, top2 + overlays.topOverlay.getTableParentOffset());
  } else {
    overlays.wtTable.holder.scrollTop = top2;
    overlays.wtTable.holder.scrollLeft = _class_private_method_get$14(this, _isRtl$4, isRtl).call(this) ? -left2 : left2;
  }
}
function clearSpreaderInsetStyles(element) {
  element.style.top = "";
  element.style.bottom = "";
  element.style.left = "";
  element.style.right = "";
}
function applySpreaderStyles(position, stickyTop, stickyLeft) {
  const overlays = _class_private_field_get$1l(this, _overlays$1);
  const spreader = overlays.wtTable.spreader;
  const isRtl1 = _class_private_method_get$14(this, _isRtl$4, isRtl).call(this);
  const leftProp = isRtl1 ? "right" : "left";
  const isSticky = position === "sticky";
  spreader.style.position = position;
  if (isSticky) {
    spreader.style.top = `${stickyTop}px`;
    spreader.style.bottom = "";
    spreader.style[leftProp] = `${stickyLeft}px`;
    spreader.style[isRtl1 ? "left" : "right"] = "";
  } else {
    _class_private_method_get$14(this, _clearSpreaderInsetStyles, clearSpreaderInsetStyles).call(this, spreader);
  }
  if (_class_private_method_get$14(this, _isWindowScroll, isWindowScroll).call(this)) {
    return;
  }
  _class_private_method_get$14(this, _applyCloneSpreaderStyles, applyCloneSpreaderStyles).call(this, overlays.inlineStartOverlay, position, isSticky, stickyTop, null, isRtl1);
  _class_private_method_get$14(this, _applyCloneSpreaderStyles, applyCloneSpreaderStyles).call(this, overlays.topOverlay, position, isSticky, null, stickyLeft, isRtl1);
  _class_private_method_get$14(this, _applyCloneSpreaderStyles, applyCloneSpreaderStyles).call(this, overlays.bottomOverlay, position, isSticky, null, stickyLeft, isRtl1);
}
function applyCloneSpreaderStyles(overlay, position, isSticky, stickyTop, stickyLeft, isRtl2) {
  if (!overlay.needFullRender || !overlay.clone) {
    return;
  }
  const cloneSpreader = overlay.clone.wtTable.spreader;
  const leftProp = isRtl2 ? "right" : "left";
  cloneSpreader.style.position = position;
  if (isSticky) {
    if (stickyTop !== null) {
      cloneSpreader.style.top = `${stickyTop}px`;
    }
    if (stickyLeft !== null) {
      cloneSpreader.style[leftProp] = `${stickyLeft}px`;
      cloneSpreader.style[isRtl2 ? "left" : "right"] = "";
    }
  } else {
    _class_private_method_get$14(this, _clearSpreaderInsetStyles, clearSpreaderInsetStyles).call(this, cloneSpreader);
  }
}
function isScrollbarTarget(event) {
  if (_class_private_method_get$14(this, _isWindowScroll, isWindowScroll).call(this)) {
    return event.target === _class_private_field_get$1l(this, _overlays$1).domBindings.rootDocument.documentElement;
  }
  return event.target === _class_private_field_get$1l(this, _overlays$1).scrollableElement;
}
function isWindowScroll() {
  return _class_private_field_get$1l(this, _overlays$1).scrollableElement === _class_private_field_get$1l(this, _overlays$1).domBindings.rootWindow;
}
function isRtl() {
  return _class_private_field_get$1l(this, _overlays$1).wtSettings.getSetting("rtlMode");
}
function _check_private_redeclaration$1y(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1k(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1k(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1k(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1k(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1k(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1k(receiver, descriptor);
}
function _class_private_field_init$1k(obj, privateMap, value) {
  _check_private_redeclaration$1y(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1k(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1k(receiver, privateMap, "set");
  _class_apply_descriptor_set$1k(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$13(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$13(obj, privateSet) {
  _check_private_redeclaration$1y(obj, privateSet);
  privateSet.add(obj);
}
function isWheelEventWithLegacyDelta(event) {
  return "wheelDeltaY" in event || "wheelDeltaX" in event;
}
var _overlays = /* @__PURE__ */ new WeakMap(), _hasRenderingStateChanged = /* @__PURE__ */ new WeakMap(), _lastVerticalScrollPositionForCallback = /* @__PURE__ */ new WeakMap(), _lastHorizontalScrollPositionForCallback = /* @__PURE__ */ new WeakMap(), _containerDomResizeCount = /* @__PURE__ */ new WeakMap(), _containerDomResizeCountTimeout = /* @__PURE__ */ new WeakMap(), _postponedAdjustElementsSize = /* @__PURE__ */ new WeakMap(), _stickyScroll = /* @__PURE__ */ new WeakMap(), _cacheScrollCallbackPositions = /* @__PURE__ */ new WeakSet(), _didVerticalScrollPositionChange = /* @__PURE__ */ new WeakSet(), _didHorizontalScrollPositionChange = /* @__PURE__ */ new WeakSet(), _adjustElementsSizeIfNeeded = /* @__PURE__ */ new WeakSet();
class Overlays {
  /**
  * Get the list of references to all overlays.
  *
  * @param {boolean} [includeMaster = false] If set to `true`, the list will contain the master table as the last
  * element.
  * @returns {(TopOverlay|TopInlineStartCornerOverlay|InlineStartOverlay|BottomOverlay|BottomInlineStartCornerOverlay)[]}
  */
  getOverlays(includeMaster = false) {
    const overlays = [
      ..._class_private_field_get$1k(this, _overlays)
    ];
    if (includeMaster) {
      overlays.push(this.wtTable);
    }
    return overlays;
  }
  /**
  * Retrieve browser line height and apply its value to `browserLineHeight`.
  *
  * @private
  */
  initBrowserLineHeight() {
    const { rootWindow, rootDocument } = this.domBindings;
    const computedStyle = rootWindow.getComputedStyle(rootDocument.body);
    const lineHeight = parseInt(computedStyle.lineHeight, 10);
    const lineHeightFalback = parseInt(computedStyle.fontSize, 10) * 1.2;
    this.browserLineHeight = lineHeight || lineHeightFalback;
  }
  /**
  * Prepare overlays based on user settings.
  *
  * @private
  */
  initOverlays() {
    const args = [
      this.wot,
      this.facadeGetter,
      this.wtSettings,
      this.domBindings
    ];
    this.topOverlay = new TopOverlay(args[0], args[1], args[2], args[3]);
    this.bottomOverlay = new BottomOverlay(args[0], args[1], args[2], args[3]);
    this.inlineStartOverlay = new InlineStartOverlay(args[0], args[1], args[2], args[3]);
    this.topInlineStartCornerOverlay = new TopInlineStartCornerOverlay(args[0], args[1], args[2], args[3], this.topOverlay, this.inlineStartOverlay);
    this.bottomInlineStartCornerOverlay = new BottomInlineStartCornerOverlay(args[0], args[1], args[2], args[3], this.bottomOverlay, this.inlineStartOverlay);
    _class_private_field_set$1k(this, _overlays, [
      this.topOverlay,
      this.bottomOverlay,
      this.inlineStartOverlay,
      this.topInlineStartCornerOverlay,
      this.bottomInlineStartCornerOverlay
    ]);
  }
  /**
  * Runs logic for the overlays before the table is drawn.
  */
  beforeDraw() {
    _class_private_field_set$1k(this, _hasRenderingStateChanged, _class_private_field_get$1k(this, _overlays).reduce((acc, overlay) => {
      return overlay.hasRenderingStateChanged() || acc;
    }, false));
    _class_private_field_get$1k(this, _overlays).forEach((overlay) => overlay.updateStateOfRendering("before"));
  }
  /**
  * Runs logic for the overlays after the table is drawn.
  */
  afterDraw() {
    this.syncScrollWithMaster();
    _class_private_field_get$1k(this, _overlays).forEach((overlay) => {
      const hasRenderingStateChanged = overlay.hasRenderingStateChanged();
      overlay.updateStateOfRendering("after");
      if (hasRenderingStateChanged && !overlay.needFullRender) {
        overlay.reset();
      }
    });
  }
  /**
  * Refresh and redraw table.
  */
  refreshAll() {
    if (!this.wot.drawn) {
      return;
    }
    if (!this.wtTable.holder.parentNode) {
      this.destroy();
      return;
    }
    this.wot.draw(true);
    if (this.verticalScrolling && _class_private_method_get$13(this, _didVerticalScrollPositionChange, didVerticalScrollPositionChange).call(this)) {
      this.inlineStartOverlay.onScroll();
    }
    if (this.horizontalScrolling && _class_private_method_get$13(this, _didHorizontalScrollPositionChange, didHorizontalScrollPositionChange).call(this)) {
      this.topOverlay.onScroll();
    }
    this.verticalScrolling = false;
    this.horizontalScrolling = false;
  }
  /**
  * Register all necessary event listeners.
  */
  registerListeners() {
    const { rootDocument, rootWindow } = this.domBindings;
    const { mainTableScrollableElement: topOverlayScrollableElement } = this.topOverlay;
    const { mainTableScrollableElement: inlineStartOverlayScrollableElement } = this.inlineStartOverlay;
    this.eventManager.addEventListener(rootDocument.documentElement, "keydown", (event) => this.onKeyDown(event));
    this.eventManager.addEventListener(rootDocument.documentElement, "keyup", () => this.onKeyUp());
    this.eventManager.addEventListener(rootDocument, "visibilitychange", () => this.onKeyUp());
    _class_private_field_get$1k(this, _stickyScroll).registerListeners();
    this.eventManager.addEventListener(topOverlayScrollableElement, "scroll", (event) => this.onTableScroll(event), {
      passive: true
    });
    if (topOverlayScrollableElement !== inlineStartOverlayScrollableElement) {
      this.eventManager.addEventListener(inlineStartOverlayScrollableElement, "scroll", (event) => this.onTableScroll(event), {
        passive: true
      });
    }
    const isScrollOnWindow = this.scrollableElement === rootWindow;
    const preventWheel = this.wtSettings.getSetting("preventWheel");
    const wheelEventOptions = {
      passive: isScrollOnWindow
    };
    this.eventManager.addEventListener(this.wtTable.wtRootElement, "wheel", (event) => this.onCloneWheel(event, preventWheel), wheelEventOptions);
    const overlays = [
      this.topOverlay,
      this.bottomOverlay,
      this.inlineStartOverlay,
      this.topInlineStartCornerOverlay,
      this.bottomInlineStartCornerOverlay
    ];
    overlays.forEach((overlay) => {
      if (!overlay.clone) {
        return;
      }
      this.eventManager.addEventListener(overlay.clone.wtTable.holder, "wheel", (event) => this.onCloneWheel(event, preventWheel), wheelEventOptions);
    });
    let resizeTimeout;
    this.eventManager.addEventListener(rootWindow, "resize", () => {
      requestAnimationFrame$1(() => {
        clearTimeout(resizeTimeout);
        this.wtSettings.getSetting("onWindowResize");
        resizeTimeout = setTimeout(() => {
          _class_private_field_set$1k(this, _containerDomResizeCount, 0);
        }, 200);
      });
    });
    if (!isScrollOnWindow) {
      if (this.wtTable.wtRootElement.parentElement) {
        this.resizeObserver.observe(this.wtTable.wtRootElement.parentElement);
      }
    }
  }
  /**
  * Scroll listener.
  *
  * @param {Event} event The mouse event object.
  */
  onTableScroll(event) {
    const rootWindow = this.domBindings.rootWindow;
    const masterHorizontal = this.inlineStartOverlay.mainTableScrollableElement;
    const masterVertical = this.topOverlay.mainTableScrollableElement;
    const target = event.target;
    if (this.keyPressed) {
      if (masterVertical !== rootWindow && target !== rootWindow && !(masterVertical instanceof HTMLElement && eventTargetEl(event).contains(masterVertical)) || masterHorizontal !== rootWindow && target !== rootWindow && !(masterHorizontal instanceof HTMLElement && eventTargetEl(event).contains(masterHorizontal))) {
        return;
      }
    }
    this.syncScrollPositions();
  }
  /**
  * Wheel listener for cloned overlays.
  *
  * @param {Event} event The mouse event object.
  * @param {boolean} preventDefault If `true`, the `preventDefault` will be called on event object.
  */
  onCloneWheel(event, preventDefault) {
    if (event.ctrlKey) {
      return;
    }
    const { rootWindow } = this.domBindings;
    const masterHorizontal = this.inlineStartOverlay.mainTableScrollableElement;
    const masterVertical = this.topOverlay.mainTableScrollableElement;
    const target = event.target;
    const shouldNotWheelVertically = masterVertical !== rootWindow && target !== rootWindow && !(target instanceof Node && masterVertical instanceof HTMLElement && target.contains(masterVertical));
    const shouldNotWheelHorizontally = masterHorizontal !== rootWindow && target !== rootWindow && !(target instanceof Node && masterHorizontal instanceof HTMLElement && target.contains(masterHorizontal));
    if (this.keyPressed && (shouldNotWheelVertically || shouldNotWheelHorizontally) || this.scrollableElement === rootWindow) {
      return;
    }
    const isScrollPossible = this.translateMouseWheelToScroll(event);
    if (preventDefault || this.scrollableElement !== rootWindow && isScrollPossible) {
      event.preventDefault();
    }
  }
  /**
  * Key down listener.
  *
  * @param {Event} event The keyboard event object.
  */
  onKeyDown(event) {
    this.keyPressed = isKey(event.keyCode, "ARROW_UP|ARROW_RIGHT|ARROW_DOWN|ARROW_LEFT");
  }
  /**
  * Key up listener.
  */
  onKeyUp() {
    this.keyPressed = false;
  }
  /**
  * Translate wheel event into scroll event and sync scroll overlays position.
  *
  * @private
  * @param {Event} event The mouse event object.
  * @returns {boolean}
  */
  translateMouseWheelToScroll(event) {
    let deltaY;
    let deltaX;
    if (isWheelEventWithLegacyDelta(event)) {
      deltaY = isNaN(event.deltaY) ? -1 * (event.wheelDeltaY ?? 0) : event.deltaY;
      deltaX = isNaN(event.deltaX) ? -1 * (event.wheelDeltaX ?? 0) : event.deltaX;
    } else {
      deltaY = event.deltaY;
      deltaX = event.deltaX;
    }
    if (event.deltaMode === 1) {
      deltaX += deltaX * this.browserLineHeight;
      deltaY += deltaY * this.browserLineHeight;
    }
    const isScrollVerticallyPossible = this.scrollVertically(deltaY);
    const isScrollHorizontallyPossible = this.scrollHorizontally(deltaX);
    return isScrollVerticallyPossible || isScrollHorizontallyPossible;
  }
  /**
  * Scrolls main scrollable element horizontally.
  *
  * @param {number} delta Relative value to scroll.
  * @returns {boolean}
  */
  scrollVertically(delta) {
    if (!(this.scrollableElement instanceof HTMLElement)) {
      return false;
    }
    const el = this.scrollableElement;
    const previousScroll = el.scrollTop;
    el.scrollTop += delta;
    return previousScroll !== el.scrollTop;
  }
  /**
  * Scrolls main scrollable element horizontally.
  *
  * @param {number} delta Relative value to scroll.
  * @returns {boolean}
  */
  scrollHorizontally(delta) {
    if (!(this.scrollableElement instanceof HTMLElement)) {
      return false;
    }
    const el = this.scrollableElement;
    const previousScroll = el.scrollLeft;
    el.scrollLeft += delta;
    return previousScroll !== el.scrollLeft;
  }
  /**
  * Synchronize scroll position between master table and overlay table.
  *
  * @private
  */
  syncScrollPositions() {
    if (this.destroyed) {
      return;
    }
    const topHolder = this.topOverlay.clone?.wtTable.holder;
    const leftHolder = this.inlineStartOverlay.clone?.wtTable.holder;
    const preventOverflow = this.wtSettings.getSetting("preventOverflow");
    let scrollX = this.scrollableElement instanceof HTMLElement ? this.scrollableElement.scrollLeft : 0;
    let scrollY = this.scrollableElement instanceof HTMLElement ? this.scrollableElement.scrollTop : 0;
    if (this.wot.wtViewport.isHorizontallyScrollableByWindow() && (typeof preventOverflow === "boolean" && preventOverflow || preventOverflow !== "horizontal") && this.scrollableElement instanceof Window) {
      scrollX = this.scrollableElement.scrollX;
    }
    if (this.wot.wtViewport.isVerticallyScrollableByWindow() && (typeof preventOverflow === "boolean" && preventOverflow || preventOverflow !== "vertical") && this.scrollableElement instanceof Window) {
      scrollY = this.scrollableElement.scrollY;
    }
    this.horizontalScrolling = this.lastScrollX !== scrollX;
    this.verticalScrolling = this.lastScrollY !== scrollY;
    this.lastScrollX = scrollX;
    this.lastScrollY = scrollY;
    _class_private_field_get$1k(this, _stickyScroll).tryActivate(this.verticalScrolling, this.horizontalScrolling);
    if (this.horizontalScrolling) {
      if (isHTMLElement(topHolder)) {
        topHolder.scrollLeft = scrollX;
      }
      const bottomHolder = this.bottomOverlay.needFullRender ? this.bottomOverlay.clone?.wtTable.holder : null;
      if (bottomHolder) {
        bottomHolder.scrollLeft = scrollX;
      }
    }
    if (this.verticalScrolling) {
      if (isHTMLElement(leftHolder)) {
        if (this.wot.wtViewport.isVerticallyScrollableByWindow()) {
          leftHolder.scrollTop = 0;
        } else {
          leftHolder.scrollTop = scrollY;
        }
      }
    }
    this.refreshAll();
    _class_private_field_get$1k(this, _stickyScroll).syncOffsets();
  }
  /**
  * Synchronize overlay scrollbars with the master scrollbar.
  */
  syncScrollWithMaster() {
    if (!_class_private_field_get$1k(this, _hasRenderingStateChanged)) {
      return;
    }
    const masterScrollable = this.topOverlay.mainTableScrollableElement;
    if (!(masterScrollable instanceof HTMLElement)) {
      return;
    }
    const { scrollLeft, scrollTop } = masterScrollable;
    if (this.topOverlay.needFullRender && this.topOverlay.clone) {
      this.topOverlay.clone.wtTable.holder.scrollLeft = scrollLeft;
    }
    if (this.bottomOverlay.needFullRender && this.bottomOverlay.clone) {
      this.bottomOverlay.clone.wtTable.holder.scrollLeft = scrollLeft;
    }
    if (this.inlineStartOverlay.needFullRender && this.inlineStartOverlay.clone) {
      this.inlineStartOverlay.clone.wtTable.holder.scrollTop = scrollTop;
    }
    _class_private_field_set$1k(this, _hasRenderingStateChanged, false);
  }
  /**
  * Update the main scrollable elements for all the overlays.
  */
  updateMainScrollableElements() {
    this.eventManager.clearEvents(true);
    this.inlineStartOverlay.updateMainScrollableElement();
    this.topOverlay.updateMainScrollableElement();
    if (this.bottomOverlay.needFullRender) {
      this.bottomOverlay.updateMainScrollableElement();
    }
    const { wtTable } = this;
    const { rootWindow } = this.domBindings;
    const tableParentNode = wtTable.wtRootElement.parentNode;
    const computedOverflow = tableParentNode !== null && tableParentNode.nodeType === 1 ? rootWindow.getComputedStyle(tableParentNode).getPropertyValue("overflow") : "";
    if (computedOverflow === "hidden" || computedOverflow === "clip") {
      this.scrollableElement = wtTable.holder;
    } else {
      this.scrollableElement = getScrollableElement(wtTable.TABLE);
    }
    this.registerListeners();
  }
  /**
  *
  */
  destroy() {
    _class_private_field_get$1k(this, _postponedAdjustElementsSize).cancel();
    if (_class_private_field_get$1k(this, _containerDomResizeCountTimeout) !== null) {
      clearTimeout(_class_private_field_get$1k(this, _containerDomResizeCountTimeout));
      _class_private_field_set$1k(this, _containerDomResizeCountTimeout, null);
    }
    this.resizeObserver.disconnect();
    _class_private_field_get$1k(this, _stickyScroll).destroy();
    this.eventManager.destroy();
    this.topOverlay.destroy();
    if (this.bottomOverlay.clone) {
      this.bottomOverlay.destroy();
    }
    this.inlineStartOverlay.destroy();
    if (this.topInlineStartCornerOverlay) {
      this.topInlineStartCornerOverlay.destroy();
    }
    if (this.bottomInlineStartCornerOverlay && this.bottomInlineStartCornerOverlay.clone) {
      this.bottomInlineStartCornerOverlay.destroy();
    }
    this.destroyed = true;
  }
  /**
  * @param {boolean} [fastDraw=false] When `true`, try to refresh only the positions of borders without rerendering
  *                                   the data. It will only work if Table.draw() does not force
  *                                   rendering anyway.
  */
  refresh(fastDraw = false) {
    const isScrollTriggered = this.verticalScrolling || this.horizontalScrolling;
    if (isScrollTriggered) {
      _class_private_field_get$1k(this, _postponedAdjustElementsSize).call(this);
    } else {
      _class_private_method_get$13(this, _adjustElementsSizeIfNeeded, adjustElementsSizeIfNeeded).call(this);
    }
    if (this.bottomOverlay.clone) {
      this.bottomOverlay.refresh(fastDraw);
    }
    this.inlineStartOverlay.refresh(fastDraw);
    this.topOverlay.refresh(fastDraw);
    if (this.topInlineStartCornerOverlay) {
      this.topInlineStartCornerOverlay.refresh(fastDraw);
    }
    if (this.bottomInlineStartCornerOverlay && this.bottomInlineStartCornerOverlay.clone) {
      this.bottomInlineStartCornerOverlay.refresh(fastDraw);
    }
  }
  /**
  * Update the last cached spreader size with the current size.
  *
  * @returns {boolean} `true` if the lastSpreaderSize cache was updated, `false` otherwise.
  */
  updateLastSpreaderSize() {
    const spreader = this.wtTable.spreader;
    const width = spreader.clientWidth;
    const height = spreader.clientHeight;
    const needsUpdating = width !== this.spreaderLastSize.width || height !== this.spreaderLastSize.height;
    if (needsUpdating) {
      this.spreaderLastSize.width = width;
      this.spreaderLastSize.height = height;
    }
    return needsUpdating;
  }
  /**
  * Adjust overlays elements size and master table size.
  */
  adjustElementsSize() {
    const { wtViewport } = this.wot;
    const { wtTable } = this;
    const { rootWindow } = this.domBindings;
    const isWindowScrolled = this.scrollableElement === rootWindow;
    const totalColumns = this.wtSettings.getSetting("totalColumns");
    const totalRows = this.wtSettings.getSetting("totalRows");
    const headerRowSize = wtViewport.getRowHeaderWidth();
    const headerColumnSize = wtViewport.getColumnHeaderHeight();
    const hiderHeightComp = this.wtSettings.getSetting("externalRowCalculator") ? 0 : 1;
    const proposedHiderHeight = headerColumnSize + this.topOverlay.sumCellSizes(0, totalRows) + hiderHeightComp;
    const proposedHiderWidth = headerRowSize + this.inlineStartOverlay.sumCellSizes(0, totalColumns);
    const hiderElement = wtTable.hider;
    const hiderStyle = hiderElement.style;
    const isScrolledBeyondHiderHeight = () => {
      if (isWindowScrolled || !(this.scrollableElement instanceof HTMLElement)) {
        return false;
      }
      return this.scrollableElement.scrollTop > Math.max(0, proposedHiderHeight - wtTable.holder.clientHeight);
    };
    const isScrolledBeyondHiderWidth = () => {
      if (isWindowScrolled || !(this.scrollableElement instanceof HTMLElement)) {
        return false;
      }
      return this.scrollableElement.scrollLeft > Math.max(0, proposedHiderWidth - wtTable.holder.clientWidth);
    };
    const columnHeaderBorderCompensation = isScrolledBeyondHiderHeight() ? 1 : 0;
    const rowHeaderBorderCompensation = isScrolledBeyondHiderWidth() ? 1 : 0;
    hiderStyle.width = `${proposedHiderWidth + rowHeaderBorderCompensation}px`;
    hiderStyle.height = `${proposedHiderHeight + columnHeaderBorderCompensation}px`;
    this.topOverlay.adjustElementsSize();
    this.inlineStartOverlay.adjustElementsSize();
    this.bottomOverlay.adjustElementsSize();
  }
  /**
  * Expand the hider vertically element by the provided delta value.
  *
  * @param {number} heightDelta The delta value to expand the hider element by.
  */
  expandHiderVerticallyBy(heightDelta) {
    const { wtTable } = this;
    wtTable.hider.style.height = `${parseInt(wtTable.hider.style.height, 10) + heightDelta}px`;
  }
  /**
  * Expand the hider horizontally element by the provided delta value.
  *
  * @param {number} widthDelta The delta value to expand the hider element by.
  */
  expandHiderHorizontallyBy(widthDelta) {
    const { wtTable } = this;
    wtTable.hider.style.width = `${parseInt(wtTable.hider.style.width, 10) + widthDelta}px`;
  }
  /**
  *
  */
  applyToDOM() {
    if (!this.wtTable.isVisible()) {
      return;
    }
    this.topOverlay.applyToDOM();
    if (this.bottomOverlay.clone) {
      this.bottomOverlay.applyToDOM();
    }
    this.inlineStartOverlay.applyToDOM();
    _class_private_field_get$1k(this, _stickyScroll).syncOffsets();
  }
  /**
  * Get the parent overlay of the provided element.
  *
  * @param {HTMLElement} element An element to process.
  * @returns {WalkontableInstance|null}
  */
  getParentOverlay(element) {
    if (!element) {
      return null;
    }
    const overlays = [
      this.topOverlay,
      this.inlineStartOverlay,
      this.bottomOverlay,
      this.topInlineStartCornerOverlay,
      this.bottomInlineStartCornerOverlay
    ];
    let result = null;
    arrayEach(overlays, (overlay) => {
      if (!overlay) {
        return;
      }
      if (overlay.clone && overlay.clone.wtTable.TABLE.contains(element)) {
        result = overlay.clone;
      }
    });
    return result;
  }
  /**
  * Synchronize the class names between the main overlay table and the tables on the other overlays.
  *
  */
  syncOverlayTableClassNames() {
    const masterTable = this.wtTable.TABLE;
    const overlays = [
      this.topOverlay,
      this.inlineStartOverlay,
      this.bottomOverlay,
      this.topInlineStartCornerOverlay,
      this.bottomInlineStartCornerOverlay
    ];
    arrayEach(overlays, (elem) => {
      if (!elem) {
        return;
      }
      if (elem.clone) {
        elem.clone.wtTable.TABLE.className = masterTable.className;
      }
    });
  }
  /**
  * @param {Walkontable} wotInstance The Walkontable instance. @todo refactoring remove.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {EventManager} eventManager The walkontable event manager.
  * @param {MasterTable} wtTable The master table.
  */
  constructor(wotInstance, facadeGetter, domBindings, wtSettings, eventManager, wtTable) {
    _class_private_method_init$13(this, _cacheScrollCallbackPositions);
    _class_private_method_init$13(this, _didVerticalScrollPositionChange);
    _class_private_method_init$13(this, _didHorizontalScrollPositionChange);
    _class_private_method_init$13(this, _adjustElementsSizeIfNeeded);
    _class_private_field_init$1k(this, _overlays, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _hasRenderingStateChanged, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _lastVerticalScrollPositionForCallback, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _lastHorizontalScrollPositionForCallback, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _containerDomResizeCount, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _containerDomResizeCountTimeout, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _postponedAdjustElementsSize, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1k(this, _stickyScroll, {
      writable: true,
      value: void 0
    });
    this.scrollbarSize = 0;
    this.destroyed = false;
    this.keyPressed = false;
    this.spreaderLastSize = {
      width: null,
      height: null
    };
    this.verticalScrolling = false;
    this.horizontalScrolling = false;
    this.lastScrollX = 0;
    this.lastScrollY = 0;
    _class_private_field_set$1k(this, _overlays, []);
    _class_private_field_set$1k(this, _hasRenderingStateChanged, false);
    _class_private_field_set$1k(this, _lastVerticalScrollPositionForCallback, null);
    _class_private_field_set$1k(this, _lastHorizontalScrollPositionForCallback, null);
    _class_private_field_set$1k(this, _containerDomResizeCount, 0);
    _class_private_field_set$1k(this, _containerDomResizeCountTimeout, null);
    _class_private_field_set$1k(this, _postponedAdjustElementsSize, debounce(_class_private_method_get$13(this, _adjustElementsSizeIfNeeded, adjustElementsSizeIfNeeded).bind(this), 200));
    _class_private_field_set$1k(this, _stickyScroll, new StickyScrollStrategy(this));
    this.resizeObserver = new ResizeObserver((entries) => {
      requestAnimationFrame$1(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        _class_private_field_set$1k(this, _containerDomResizeCount, _class_private_field_get$1k(this, _containerDomResizeCount) + 1);
        if (_class_private_field_get$1k(this, _containerDomResizeCount) === 300) {
          warn$1("The ResizeObserver callback was fired too many times in direct succession.\nThis may be due to an infinite loop caused by setting a dynamic height/width (for example, with the `dvh` units) to a Handsontable container's parent. \nThe observer will be disconnected.");
          this.resizeObserver.disconnect();
        }
        if (_class_private_field_get$1k(this, _containerDomResizeCountTimeout) !== null) {
          clearTimeout(_class_private_field_get$1k(this, _containerDomResizeCountTimeout));
        }
        _class_private_field_set$1k(this, _containerDomResizeCountTimeout, setTimeout(() => {
          _class_private_field_set$1k(this, _containerDomResizeCount, 0);
        }, 100));
        this.wtSettings.getSetting("onContainerElementResize");
      });
    });
    this.wot = wotInstance;
    this.wtSettings = wtSettings;
    this.domBindings = domBindings;
    this.facadeGetter = facadeGetter;
    this.wtTable = wtTable;
    const { rootDocument, rootWindow } = this.domBindings;
    this.instance = this.wot;
    this.eventManager = eventManager;
    this.scrollbarSize = getScrollbarWidth(rootDocument);
    const rootElementParent = wtTable.wtRootElement.parentNode;
    const isOverflowClip = rootElementParent !== null && rootElementParent.nodeType === 1 && (() => {
      const overflow = rootWindow.getComputedStyle(rootElementParent).getPropertyValue("overflow");
      return overflow === "hidden" || overflow === "clip";
    })();
    this.scrollableElement = isOverflowClip ? wtTable.holder : getScrollableElement(wtTable.TABLE);
    this.initOverlays();
    _class_private_method_get$13(this, _cacheScrollCallbackPositions, cacheScrollCallbackPositions).call(this);
    this.destroyed = false;
    this.keyPressed = false;
    this.spreaderLastSize = {
      width: null,
      height: null
    };
    this.verticalScrolling = false;
    this.horizontalScrolling = false;
    this.initBrowserLineHeight();
    this.registerListeners();
    this.lastScrollX = rootWindow.scrollX;
    this.lastScrollY = rootWindow.scrollY;
  }
}
function cacheScrollCallbackPositions() {
  _class_private_field_set$1k(this, _lastVerticalScrollPositionForCallback, this.topOverlay.getScrollPosition());
  _class_private_field_set$1k(this, _lastHorizontalScrollPositionForCallback, this.inlineStartOverlay.getScrollPosition());
}
function didVerticalScrollPositionChange() {
  const current = this.topOverlay.getScrollPosition();
  if (_class_private_field_get$1k(this, _lastVerticalScrollPositionForCallback) === current) {
    return false;
  }
  _class_private_field_set$1k(this, _lastVerticalScrollPositionForCallback, current);
  return true;
}
function didHorizontalScrollPositionChange() {
  const current = this.inlineStartOverlay.getScrollPosition();
  if (_class_private_field_get$1k(this, _lastHorizontalScrollPositionForCallback) === current) {
    return false;
  }
  _class_private_field_set$1k(this, _lastHorizontalScrollPositionForCallback, current);
  return true;
}
function adjustElementsSizeIfNeeded() {
  if (this.destroyed) {
    return;
  }
  const wasSpreaderSizeUpdated = this.updateLastSpreaderSize();
  if (wasSpreaderSizeUpdated) {
    this.adjustElementsSize();
  }
}
class Settings {
  /**
  * Generate defaults for a settings.
  * Void 0 means it is required, null means it can be empty.
  *
  * @private
  * @returns {SettingsPure}
  */
  getDefaults() {
    return {
      facade: void 0,
      table: void 0,
      // Determines whether the Walkontable instance is used as dataset viewer. When its instance is used as
      // a context menu, autocomplete list, etc, the returned value is `false`.
      isDataViewInstance: true,
      // presentation mode
      externalRowCalculator: false,
      currentRowClassName: null,
      currentColumnClassName: null,
      preventOverflow() {
        return false;
      },
      preventWheel: false,
      // data source
      data: void 0,
      // Number of renderable columns for the left overlay.
      fixedColumnsStart: 0,
      // Number of renderable rows for the top overlay.
      fixedRowsTop: 0,
      // Number of renderable rows for the bottom overlay.
      fixedRowsBottom: 0,
      // Enable the inline start overlay when conditions are met (left for LTR and right for RTL document mode).
      shouldRenderInlineStartOverlay: () => {
        return this.getSetting("fixedColumnsStart") > 0 || this.getSetting("rowHeaders").length > 0;
      },
      // Enable the top overlay when conditions are met.
      shouldRenderTopOverlay: () => {
        return this.getSetting("fixedRowsTop") > 0 || this.getSetting("columnHeaders").length > 0;
      },
      // Enable the bottom overlay when conditions are met.
      shouldRenderBottomOverlay: () => {
        return this.getSetting("fixedRowsBottom") > 0;
      },
      minSpareRows: 0,
      // this must be array of functions: [function (row, TH) {}]
      rowHeaders() {
        return [];
      },
      // this must be array of functions: [function (column, TH) {}]
      columnHeaders() {
        return [];
      },
      totalRows: void 0,
      totalColumns: void 0,
      cellRenderer: (row, column, TD) => {
        const cellData = this.getSetting("data", row, column);
        fastInnerText(TD, cellData === void 0 || cellData === null ? "" : cellData);
      },
      // columnWidth: 50,
      columnWidth() {
      },
      rowHeight() {
      },
      rowHeightByOverlayName() {
      },
      defaultColumnWidth: 50,
      selections: null,
      hideBorderOnMouseDownOver: false,
      viewportRowCalculatorOverride: null,
      viewportColumnCalculatorOverride: null,
      viewportRowRenderingThreshold: null,
      viewportColumnRenderingThreshold: null,
      // callbacks
      onCellMouseDown: null,
      onCellContextMenu: null,
      onCellMouseOver: null,
      onCellMouseOverOutside: null,
      onCellMouseOut: null,
      onCellMouseUp: null,
      // onCellMouseOut: null,
      onCellDblClick: null,
      onCellCornerMouseDown: null,
      onCellCornerDblClick: null,
      beforeDraw: null,
      onDraw: null,
      onBeforeRemoveCellClassNames: null,
      onAfterDrawSelection: null,
      onBeforeDrawBorders: null,
      // viewport scroll hooks
      onBeforeViewportScrollHorizontally: (column) => column,
      onBeforeViewportScrollVertically: (row) => row,
      // native scroll hooks
      onScrollHorizontally: null,
      onScrollVertically: null,
      //
      onBeforeTouchScroll: null,
      onAfterMomentumScroll: null,
      onModifyRowHeaderWidth: null,
      onModifyGetCellCoords: null,
      onModifyGetCoordsElement: null,
      onModifyGetCoords: null,
      onBeforeHighlightingRowHeader: (sourceRow) => sourceRow,
      onBeforeHighlightingColumnHeader: (sourceCol) => sourceCol,
      onWindowResize: null,
      onContainerElementResize: null,
      renderAllColumns: false,
      renderAllRows: false,
      groups: false,
      rowHeaderWidth: null,
      columnHeaderHeight: null,
      headerClassName: null,
      rtlMode: false,
      ariaTags: true,
      stylesHandler: null
    };
  }
  /**
  * Update settings.
  *
  * @param {object|string} settings The singular settings to update or if passed as object to merge with.
  * @param {*} value The value to set if the first argument is passed as string.
  * @returns {Settings}
  */
  update(settings, value) {
    if (value === void 0) {
      objectEach(settings, (settingValue, key) => {
        this.settings[key] = settingValue;
      });
    } else {
      this.settings[settings] = value;
    }
    return this;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSetting(key, param1, param2, param3, param4) {
    if (typeof this.settings[key] === "function") {
      return this.settings[key](param1, param2, param3, param4);
    } else if (param1 !== void 0 && Array.isArray(this.settings[key])) {
      return this.settings[key][param1];
    }
    return this.settings[key];
  }
  // eslint-disable-next-line jsdoc/require-jsdoc -- TypeScript overload implementation; documented in the overload signature above
  getSettingPure(key) {
    return this.settings[key];
  }
  /**
  * Checks if setting exists.
  *
  * @param {boolean} key The settings key to check.
  * @returns {boolean}
  */
  has(key) {
    return !!this.settings[key];
  }
  /**
  * @param {SettingsPure} settings The user defined settings.
  */
  constructor(settings) {
    this.settings = {};
    this.defaults = Object.freeze(this.getDefaults());
    objectEach(this.defaults, (value, key) => {
      if (settings[key] !== void 0) {
        this.settings[key] = settings[key];
      } else if (value === void 0) {
        throwWithCause(`A required setting "${key}" was not provided`);
      } else {
        this.settings[key] = value;
      }
    });
  }
}
function _check_private_redeclaration$1x(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1j(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1j(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1j(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1j(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1j(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1j(receiver, descriptor);
}
function _class_private_field_init$1j(obj, privateMap, value) {
  _check_private_redeclaration$1x(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1j(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1j(receiver, privateMap, "set");
  _class_apply_descriptor_set$1j(receiver, descriptor, value);
  return value;
}
var _trimmingCache = /* @__PURE__ */ new WeakMap(), _trimmingContainerObserver = /* @__PURE__ */ new WeakMap(), _hiderObserver = /* @__PURE__ */ new WeakMap(), _observedTrimmingElement = /* @__PURE__ */ new WeakMap();
class MasterTable extends Table {
  /**
  * Aligns overlays with the trimming container, applying cached measurements when possible
  * or performing a full measurement of the container. Uses ResizeObservers to detect
  * container and hider size changes, and validates the table visibility.
  */
  alignOverlaysWithTrimmingContainer() {
    const fieldsInitialized = _trimmingCache.has(this);
    const trimmingElement = getTrimmingContainer(this.wtRootElement);
    const { rootWindow } = this.domBindings;
    if (!(trimmingElement instanceof HTMLElement)) {
      const preventOverflow = this.wtSettings.getSetting("preventOverflow");
      if (!preventOverflow) {
        this.holder.style.overflow = "visible";
        this.wtRootElement.style.overflow = "visible";
      }
    } else if (fieldsInitialized) {
      if (_class_private_field_get$1j(this, _observedTrimmingElement) !== trimmingElement) {
        _class_private_field_get$1j(this, _trimmingContainerObserver)?.disconnect();
        _class_private_field_get$1j(this, _hiderObserver)?.disconnect();
        _class_private_field_set$1j(this, _trimmingCache, null);
        _class_private_field_set$1j(this, _observedTrimmingElement, trimmingElement);
        const invalidate = () => {
          _class_private_field_set$1j(this, _trimmingCache, null);
        };
        const tcObserver = new ResizeObserver(invalidate);
        tcObserver.observe(trimmingElement);
        _class_private_field_set$1j(this, _trimmingContainerObserver, tcObserver);
        const hoObserver = new ResizeObserver(invalidate);
        hoObserver.observe(this.hider);
        _class_private_field_set$1j(this, _hiderObserver, hoObserver);
      }
      const trimmingOffsetWidth = trimmingElement.offsetWidth;
      const trimmingOffsetHeight = trimmingElement.offsetHeight;
      const trimmingScrollWidth = trimmingElement.scrollWidth;
      const trimmingScrollHeight = trimmingElement.scrollHeight;
      const trimmingOverflow = getStyle(trimmingElement, "overflow", rootWindow) ?? "";
      const trimmingHeight = getStyle(trimmingElement, "height", rootWindow) ?? "";
      const hiderOffsetHeight = this.hider.offsetHeight;
      const hiderOffsetWidth = this.hider.offsetWidth;
      const cache = _class_private_field_get$1j(this, _trimmingCache);
      const cacheValid = cache !== null && cache.trimmingOffsetWidth === trimmingOffsetWidth && cache.trimmingOffsetHeight === trimmingOffsetHeight && cache.trimmingScrollWidth === trimmingScrollWidth && cache.trimmingScrollHeight === trimmingScrollHeight && cache.trimmingOverflow === trimmingOverflow && cache.trimmingHeight === trimmingHeight && cache.hiderOffsetHeight === hiderOffsetHeight && cache.hiderOffsetWidth === hiderOffsetWidth;
      if (cacheValid) {
        const holderStyle = this.holder.style;
        holderStyle.width = cache.holderWidth;
        holderStyle.height = cache.holderHeight;
        holderStyle.overflow = "";
        this.hasTableHeight = cache.hasTableHeight;
        this.hasTableWidth = cache.hasTableWidth;
      } else {
        const trimmingElementParent = trimmingElement.parentElement;
        const holderStyle = this.holder.style;
        let width = trimmingOffsetWidth;
        let height = trimmingOffsetHeight;
        const overflowValues = [
          "auto",
          "hidden",
          "scroll",
          "clip"
        ];
        const hasScrollOverflow = trimmingOverflow ? trimmingOverflow.split(" ").some((v) => overflowValues.includes(v)) : [
          getStyle(trimmingElement, "overflowX", rootWindow),
          getStyle(trimmingElement, "overflowY", rootWindow)
        ].some((v) => v && overflowValues.includes(v));
        let useAutoHeight = trimmingHeight === "auto";
        if (trimmingElementParent && hasScrollOverflow) {
          const cloneNode = trimmingElement.cloneNode(false);
          cloneNode.style.overflow = "auto";
          cloneNode.style.position = "absolute";
          cloneNode.style.border = "0";
          cloneNode.style.padding = "0";
          if (trimmingElement.nextElementSibling) {
            trimmingElementParent.insertBefore(cloneNode, trimmingElement.nextElementSibling);
          } else {
            trimmingElementParent.appendChild(cloneNode);
          }
          const cloneHeight = parseInt(rootWindow.getComputedStyle(cloneNode).height, 10);
          trimmingElementParent.removeChild(cloneNode);
          if (cloneHeight === 0) {
            height = 0;
            const computedStyle = rootWindow.getComputedStyle(trimmingElement);
            const overflowX = computedStyle.overflowX;
            const overflowY = computedStyle.overflowY;
            if ((overflowX === "auto" || overflowX === "scroll") && overflowY !== "auto" && overflowY !== "scroll") {
              useAutoHeight = true;
            }
          }
        }
        height = Math.min(height, trimmingScrollHeight);
        width = Math.min(width, trimmingScrollWidth);
        const holderHeight = useAutoHeight ? "auto" : `${height}px`;
        const holderWidth = `${width}px`;
        const hasTableHeight = holderHeight === "auto" ? true : height > 0;
        const hasTableWidth = width > 0;
        holderStyle.height = holderHeight;
        holderStyle.width = holderWidth;
        holderStyle.overflow = "";
        this.hasTableHeight = hasTableHeight;
        this.hasTableWidth = hasTableWidth;
        if (width > 0) {
          _class_private_field_set$1j(this, _trimmingCache, {
            trimmingOffsetWidth,
            trimmingOffsetHeight,
            trimmingScrollWidth,
            trimmingScrollHeight,
            trimmingOverflow,
            trimmingHeight,
            hiderOffsetHeight,
            hiderOffsetWidth,
            holderWidth,
            holderHeight,
            hasTableHeight,
            hasTableWidth
          });
        }
      }
    }
    this.isTableVisible = isVisible(this.TABLE);
  }
  /**
  * Marks oversized column headers in the master overlay by iterating through all
  * rendered columns and marking those that exceed their container dimensions.
  */
  markOversizedColumnHeaders() {
    const { wtSettings } = this;
    const { wtViewport } = this.dataAccessObject;
    const overlayName = "master";
    const columnHeaders = wtSettings.getSetting("columnHeaders");
    const columnHeadersCount = columnHeaders.length;
    if (columnHeadersCount && !wtViewport.hasOversizedColumnHeadersMarked[overlayName]) {
      const rowHeaders = wtSettings.getSetting("rowHeaders");
      const rowHeaderCount = rowHeaders.length;
      const columnCount = this.getRenderedColumnsCount();
      for (let i = 0; i < columnHeadersCount; i++) {
        for (let renderedColumnIndex = -1 * rowHeaderCount; renderedColumnIndex < columnCount; renderedColumnIndex++) {
          this.markIfOversizedColumnHeader(renderedColumnIndex);
        }
      }
      wtViewport.hasOversizedColumnHeadersMarked[overlayName] = true;
    }
  }
  /**
  * Disconnects the ResizeObservers and drops cache references so the
  * MasterTable instance, the trimming container, and the hider can be
  * garbage-collected after Walkontable is destroyed.
  */
  destroy() {
    _class_private_field_get$1j(this, _trimmingContainerObserver)?.disconnect();
    _class_private_field_get$1j(this, _hiderObserver)?.disconnect();
    _class_private_field_set$1j(this, _trimmingCache, null);
    _class_private_field_set$1j(this, _trimmingContainerObserver, null);
    _class_private_field_set$1j(this, _hiderObserver, null);
    _class_private_field_set$1j(this, _observedTrimmingElement, null);
  }
  /**
  * @param {TableDao} dataAccessObject The data access object.
  * @param {FacadeGetter} facadeGetter Function which return proper facade.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  */
  constructor(dataAccessObject, facadeGetter, domBindings, wtSettings) {
    super(dataAccessObject, facadeGetter, domBindings, wtSettings, "master"), _class_private_field_init$1j(this, _trimmingCache, {
      writable: true,
      value: void 0
    }), _class_private_field_init$1j(this, _trimmingContainerObserver, {
      writable: true,
      value: void 0
    }), _class_private_field_init$1j(this, _hiderObserver, {
      writable: true,
      value: void 0
    }), _class_private_field_init$1j(this, _observedTrimmingElement, {
      writable: true,
      value: void 0
    }), _class_private_field_set$1j(this, _trimmingCache, null), _class_private_field_set$1j(this, _trimmingContainerObserver, null), _class_private_field_set$1j(this, _hiderObserver, null), _class_private_field_set$1j(this, _observedTrimmingElement, null);
  }
}
mixin(MasterTable, calculatedRows);
mixin(MasterTable, calculatedColumns);
function _check_private_redeclaration$1w(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1i(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1i(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1i(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1i(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1i(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1i(receiver, descriptor);
}
function _class_private_field_init$1i(obj, privateMap, value) {
  _check_private_redeclaration$1w(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1i(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1i(receiver, privateMap, "set");
  _class_apply_descriptor_set$1i(receiver, descriptor, value);
  return value;
}
var _totalItemsFn = /* @__PURE__ */ new WeakMap(), _sizeFn = /* @__PURE__ */ new WeakMap(), _defaultSizeFn = /* @__PURE__ */ new WeakMap();
class PositionCache {
  /**
  * Builds the prefix sum by reading the current total items, size function,
  * and default size from the configured providers.
  */
  build() {
    const totalItems = _class_private_field_get$1i(this, _totalItemsFn).call(this);
    const sizeFn = _class_private_field_get$1i(this, _sizeFn);
    const defaultSize = _class_private_field_get$1i(this, _defaultSizeFn).call(this);
    this.totalItems = totalItems;
    this.prefixSum = new Float64Array(totalItems + 1);
    this.prefixSum[0] = 0;
    for (let i = 0; i < totalItems; i++) {
      const s = sizeFn(i);
      this.prefixSum[i + 1] = this.prefixSum[i] + (isNaN(s) ? defaultSize : s);
    }
  }
  /**
  * Returns the cumulative size at an index (sum of items 0..index-1).
  *
  * @param {number} index The item index.
  * @returns {number} The cumulative size before this index.
  */
  getOffset(index2) {
    if (!this.prefixSum || index2 <= 0) {
      return 0;
    }
    if (index2 >= this.totalItems) {
      return this.prefixSum[this.totalItems];
    }
    return this.prefixSum[index2];
  }
  /**
  * Finds the item index at a given pixel offset using binary search.
  *
  * @param {number} offset The pixel offset.
  * @returns {number} The index whose cumulative start position is at or just before the offset.
  *   Returns `0` when there are no items (`totalItems === 0`), including when `offset > 0`.
  */
  findIndexAtOffset(offset2) {
    if (!this.isBuilt() || offset2 <= 0 || this.totalItems === 0) {
      return 0;
    }
    let lo = 0;
    let hi = this.totalItems;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (this.prefixSum[mid + 1] <= offset2) {
        lo = mid + 1;
      } else {
        hi = mid;
      }
    }
    return Math.min(lo, this.totalItems - 1);
  }
  /**
  * Returns the size of a single item at the given index.
  *
  * @param {number} index The item index.
  * @returns {number} The size of the item (difference between consecutive prefix sums).
  */
  getSizeAt(index2) {
    if (!this.prefixSum || index2 < 0 || index2 >= this.totalItems) {
      return 0;
    }
    return this.prefixSum[index2 + 1] - this.prefixSum[index2];
  }
  /**
  * Builds the prefix sum only when the cache is not yet built or the item
  * count has changed.
  */
  ensureBuilt() {
    if (!this.isBuilt() || this.totalItems !== _class_private_field_get$1i(this, _totalItemsFn).call(this)) {
      this.build();
    }
  }
  /**
  * Returns the total size of all items.
  *
  * @returns {number}
  */
  getTotalSize() {
    if (!this.prefixSum) {
      return 0;
    }
    return this.prefixSum[this.totalItems];
  }
  /**
  * Invalidates the cache so it will be rebuilt on the next
  * {@link PositionCache#ensureBuilt} call.
  */
  invalidate() {
    this.prefixSum = null;
    this.totalItems = 0;
  }
  /**
  * Returns whether the cache has been built.
  *
  * @returns {boolean}
  */
  isBuilt() {
    return this.prefixSum !== null;
  }
  /**
  * @param {object} config The configuration object.
  * @param {Function} config.totalItemsFn A function that returns the total number of items (rows or columns).
  * @param {Function} config.sizeFn A function that returns the size for a given index.
  * @param {Function} config.defaultSizeFn A function that returns the default size for items
  *   that return NaN/undefined.
  */
  constructor({ totalItemsFn, sizeFn, defaultSizeFn }) {
    _class_private_field_init$1i(this, _totalItemsFn, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1i(this, _sizeFn, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1i(this, _defaultSizeFn, {
      writable: true,
      value: void 0
    });
    this.prefixSum = null;
    this.totalItems = 0;
    _class_private_field_set$1i(this, _totalItemsFn, totalItemsFn);
    _class_private_field_set$1i(this, _sizeFn, sizeFn);
    _class_private_field_set$1i(this, _defaultSizeFn, defaultSizeFn);
  }
}
class Viewport {
  /**
  * @returns {number}
  */
  getWorkspaceHeight() {
    const currentDocument = this.domBindings.rootDocument;
    const trimmingContainer = this.dataAccessObject.topOverlayTrimmingContainer;
    let height = 0;
    if (trimmingContainer === this.domBindings.rootWindow) {
      height = currentDocument.documentElement.clientHeight;
    } else {
      const elemHeight = outerHeight(trimmingContainer);
      if (elemHeight > 0 && trimmingContainer.clientHeight > 0) {
        height = trimmingContainer.clientHeight;
      } else {
        height = Math.max(currentDocument.documentElement.clientHeight, 1);
      }
    }
    return height;
  }
  /**
  * @returns {number}
  */
  getViewportHeight() {
    let containerHeight = this.getWorkspaceHeight();
    const columnHeaderHeight = this.getColumnHeaderHeight();
    if (columnHeaderHeight > 0) {
      containerHeight -= columnHeaderHeight;
    }
    return containerHeight;
  }
  /**
  * Gets the width of the table workspace (in pixels). The workspace size in the current
  * implementation returns the width of the table holder element including scrollbar width when
  * the table has defined size and the width of the window excluding scrollbar width when
  * the table has no defined size (the window is a scrollable container).
  *
  * This is a bug, as the method should always return stable values, always without scrollbar width.
  * Changing this behavior would break the column calculators, which would also need to be adjusted.
  *
  * @returns {number}
  */
  getWorkspaceWidth() {
    const { rootDocument, rootWindow } = this.domBindings;
    const trimmingContainer = this.dataAccessObject.inlineStartOverlayTrimmingContainer;
    let width;
    if (trimmingContainer === rootWindow) {
      const totalColumns = this.wtSettings.getSetting("totalColumns");
      width = this.wtTable.holder.offsetWidth;
      if (this.getRowHeaderWidth() + this.sumColumnWidths(0, totalColumns) > width) {
        width = rootDocument.documentElement.clientWidth;
      }
    } else {
      width = trimmingContainer.clientWidth;
    }
    return width;
  }
  /**
  * @returns {number}
  */
  getViewportWidth() {
    const containerWidth = this.getWorkspaceWidth();
    const rowHeaderWidth = this.getRowHeaderWidth();
    if (rowHeaderWidth > 0) {
      return containerWidth - rowHeaderWidth;
    }
    return containerWidth;
  }
  /**
  * Checks if viewport has vertical scroll.
  *
  * @returns {boolean}
  */
  hasVerticalScroll() {
    if (this.isVerticallyScrollableByWindow()) {
      const documentElement = this.domBindings.rootDocument.documentElement;
      return documentElement.scrollHeight > documentElement.clientHeight;
    }
    const { holder: holder2, hider } = this.wtTable;
    const holderHeight = holder2.clientHeight;
    const hiderOffsetHeight = hider.offsetHeight;
    if (holderHeight < hiderOffsetHeight) {
      return true;
    }
    return hiderOffsetHeight > this.getWorkspaceHeight();
  }
  /**
  * Checks if viewport has horizontal scroll.
  *
  * @returns {boolean}
  */
  hasHorizontalScroll() {
    if (this.isVerticallyScrollableByWindow()) {
      const documentElement = this.domBindings.rootDocument.documentElement;
      return documentElement.scrollWidth > documentElement.clientWidth;
    }
    const { hider } = this.wtTable;
    const hiderOffsetWidth = hider.offsetWidth;
    const scrollbarWidth = this.hasVerticalScroll() ? getScrollbarWidth() : 0;
    return hiderOffsetWidth > this.getWorkspaceWidth() - scrollbarWidth;
  }
  /**
  * Checks if the table uses the window as a viewport and if there is a vertical scrollbar.
  *
  * @returns {boolean}
  */
  isVerticallyScrollableByWindow() {
    return this.dataAccessObject.topOverlayTrimmingContainer === this.domBindings.rootWindow;
  }
  /**
  * Checks if the table uses the window as a viewport and if there is a horizontal scrollbar.
  *
  * @returns {boolean}
  */
  isHorizontallyScrollableByWindow() {
    return this.dataAccessObject.inlineStartOverlayTrimmingContainer === this.domBindings.rootWindow;
  }
  /**
  * @param {number} from The visual column index from the width sum is start calculated.
  * @param {number} length The length of the column to traverse.
  * @returns {number}
  */
  sumColumnWidths(from, length) {
    let sum2 = 0;
    let column = from;
    while (column < length) {
      sum2 += this.wtTable.getColumnWidth(column);
      column += 1;
    }
    return sum2;
  }
  /**
  * @returns {number}
  */
  getWorkspaceOffset() {
    return offset(this.wtTable.holder);
  }
  /**
  * @returns {number}
  */
  getColumnHeaderHeight() {
    const columnHeaders = this.wtSettings.getSetting("columnHeaders");
    if (!columnHeaders.length) {
      this.columnHeaderHeight = 0;
    } else if (isNaN(this.columnHeaderHeight)) {
      this.columnHeaderHeight = this.wtTable.THEAD ? outerHeight(this.wtTable.THEAD) : 0;
    }
    return this.columnHeaderHeight;
  }
  /**
  * @returns {number}
  */
  getRowHeaderWidth() {
    const rowHeadersWidthSetting = this.wtSettings.getSetting("rowHeaderWidth");
    const rowHeaders = this.wtSettings.getSetting("rowHeaders");
    if (rowHeadersWidthSetting) {
      this.rowHeaderWidth = 0;
      for (let i = 0, len = rowHeaders.length; i < len; i++) {
        const w = Array.isArray(rowHeadersWidthSetting) ? rowHeadersWidthSetting[i] : rowHeadersWidthSetting;
        this.rowHeaderWidth += w ?? NaN;
      }
    }
    if (isNaN(this.rowHeaderWidth)) {
      if (rowHeaders.length) {
        let TH = this.wtTable.TABLE.querySelector("TH");
        this.rowHeaderWidth = 0;
        for (let i = 0, len = rowHeaders.length; i < len; i++) {
          if (TH) {
            this.rowHeaderWidth += outerWidth(TH);
            TH = TH.nextSibling;
          } else {
            this.rowHeaderWidth += 50;
          }
        }
      } else {
        this.rowHeaderWidth = 0;
      }
    }
    this.rowHeaderWidth = this.wtSettings.getSetting("onModifyRowHeaderWidth", this.rowHeaderWidth) || this.rowHeaderWidth;
    return this.rowHeaderWidth;
  }
  /**
  * Creates rows calculators. The type of the calculations can be chosen from the list:
  *  - 'rendered' Calculates rows that should be rendered within the current table's viewport;
  *  - 'fullyVisible' Calculates rows that are fully visible (used mostly for scrolling purposes);
  *  - 'partiallyVisible' Calculates rows that are partially visible (used mostly for scrolling purposes).
  *
  * @param {'rendered' | 'fullyVisible' | 'partiallyVisible'} calculatorTypes The list of the calculation types.
  * @returns {ViewportRowsCalculator}
  */
  createRowsCalculator(calculatorTypes = [
    "rendered",
    "fullyVisible",
    "partiallyVisible"
  ]) {
    const { wtSettings, wtTable } = this;
    const totalRows = wtSettings.getSetting("totalRows");
    let height = this.getViewportHeight();
    let scrollbarHeight;
    let fixedRowsHeight;
    this.rowHeaderWidth = NaN;
    let pos = this.dataAccessObject.topScrollPosition - this.dataAccessObject.topParentOffset;
    const fixedRowsTop = wtSettings.getSetting("fixedRowsTop");
    const fixedRowsBottom = wtSettings.getSetting("fixedRowsBottom");
    if (fixedRowsTop && pos >= 0) {
      fixedRowsHeight = this.dataAccessObject.topOverlay.sumCellSizes(0, fixedRowsTop);
      pos += fixedRowsHeight;
      height -= fixedRowsHeight;
    }
    if (fixedRowsBottom && this.dataAccessObject.bottomOverlay.clone) {
      fixedRowsHeight = this.dataAccessObject.bottomOverlay.sumCellSizes(totalRows - fixedRowsBottom, totalRows);
      height -= fixedRowsHeight;
    }
    if (wtTable.holder.clientHeight === wtTable.holder.offsetHeight) {
      scrollbarHeight = 0;
    } else {
      scrollbarHeight = getScrollbarWidth(this.domBindings.rootDocument);
    }
    return new ViewportRowsCalculator({
      calculationTypes: calculatorTypes.flatMap((type) => {
        const factory = this.rowsCalculatorTypes.get(type);
        return factory ? [
          [
            type,
            factory()
          ]
        ] : [];
      }),
      viewportHeight: height,
      scrollOffset: pos,
      totalRows,
      overrideFn: wtSettings.getSettingPure("viewportRowCalculatorOverride"),
      horizontalScrollbarHeight: scrollbarHeight,
      rowHeightCache: this.rowHeightCache
    });
  }
  /**
  * Creates columns calculators. The type of the calculations can be chosen from the list:
  *  - 'rendered' Calculates columns that should be rendered within the current table's viewport;
  *  - 'fullyVisible' Calculates columns that are fully visible (used mostly for scrolling purposes);
  *  - 'partiallyVisible' Calculates columns that are partially visible (used mostly for scrolling purposes).
  *
  * @param {'rendered' | 'fullyVisible' | 'partiallyVisible'} calculatorTypes The list of the calculation types.
  * @returns {ViewportColumnsCalculator}
  */
  createColumnsCalculator(calculatorTypes = [
    "rendered",
    "fullyVisible",
    "partiallyVisible"
  ]) {
    const { wtSettings, wtTable } = this;
    const totalColumns = wtSettings.getSetting("totalColumns");
    let width = this.getViewportWidth();
    let pos = Math.abs(this.dataAccessObject.inlineStartScrollPosition) - this.dataAccessObject.inlineStartParentOffset;
    this.columnHeaderHeight = NaN;
    const fixedColumnsStart = wtSettings.getSetting("fixedColumnsStart");
    if (fixedColumnsStart && pos >= 0) {
      const fixedColumnsWidth = this.dataAccessObject.inlineStartOverlay.sumCellSizes(0, fixedColumnsStart);
      pos += fixedColumnsWidth;
      width -= fixedColumnsWidth;
    }
    if (wtTable.holder.clientWidth !== wtTable.holder.offsetWidth) {
      width -= getScrollbarWidth(this.domBindings.rootDocument);
    }
    return new ViewportColumnsCalculator({
      calculationTypes: calculatorTypes.flatMap((type) => {
        const factory = this.columnsCalculatorTypes.get(type);
        return factory ? [
          [
            type,
            factory()
          ]
        ] : [];
      }),
      viewportWidth: width,
      scrollOffset: pos,
      totalColumns,
      overrideFn: wtSettings.getSettingPure("viewportColumnCalculatorOverride"),
      inlineStartOffset: this.dataAccessObject.inlineStartParentOffset,
      columnWidthCache: this.columnWidthCache
    });
  }
  /**
  * Creates rowsRenderCalculator and columnsRenderCalculator (before draw, to determine what rows and
  * cols should be rendered).
  *
  * @param {boolean} fastDraw If `true`, will try to avoid full redraw and only update the border positions.
  *                           If `false` or `undefined`, will perform a full redraw.
  * @returns {boolean} The fastDraw value, possibly modified.
  */
  createCalculators(fastDraw = false) {
    const { wtSettings } = this;
    const rowsCalculator = this.createRowsCalculator();
    const columnsCalculator = this.createColumnsCalculator();
    if (fastDraw && !wtSettings.getSetting("renderAllRows")) {
      const proposedFullyVisibleRowsCalculator = rowsCalculator.getResultsFor("fullyVisible");
      const proposedPartiallyVisibleRowsCalculator = rowsCalculator.getResultsFor("partiallyVisible");
      fastDraw = this.areAllProposedVisibleRowsAlreadyRendered(proposedFullyVisibleRowsCalculator, proposedPartiallyVisibleRowsCalculator);
    }
    if (fastDraw && !wtSettings.getSetting("renderAllColumns")) {
      const proposedFullyVisibleColumnsCalculator = columnsCalculator.getResultsFor("fullyVisible");
      const proposedPartiallyVisibleColumnsCalculator = columnsCalculator.getResultsFor("partiallyVisible");
      fastDraw = this.areAllProposedVisibleColumnsAlreadyRendered(proposedFullyVisibleColumnsCalculator, proposedPartiallyVisibleColumnsCalculator);
    }
    if (!fastDraw) {
      this.rowsRenderCalculator = rowsCalculator.getResultsFor("rendered") ?? null;
      this.columnsRenderCalculator = columnsCalculator.getResultsFor("rendered") ?? null;
    }
    this.rowsVisibleCalculator = rowsCalculator.getResultsFor("fullyVisible") ?? null;
    this.columnsVisibleCalculator = columnsCalculator.getResultsFor("fullyVisible") ?? null;
    this.rowsPartiallyVisibleCalculator = rowsCalculator.getResultsFor("partiallyVisible") ?? null;
    this.columnsPartiallyVisibleCalculator = columnsCalculator.getResultsFor("partiallyVisible") ?? null;
    return fastDraw;
  }
  /**
  * Creates rows and columns calculators (after draw, to determine what are
  * the actually fully visible and partially visible rows and columns).
  */
  createVisibleCalculators() {
    const rowsCalculator = this.createRowsCalculator([
      "fullyVisible",
      "partiallyVisible"
    ]);
    const columnsCalculator = this.createColumnsCalculator([
      "fullyVisible",
      "partiallyVisible"
    ]);
    this.rowsVisibleCalculator = rowsCalculator.getResultsFor("fullyVisible") ?? null;
    this.columnsVisibleCalculator = columnsCalculator.getResultsFor("fullyVisible") ?? null;
    this.rowsPartiallyVisibleCalculator = rowsCalculator.getResultsFor("partiallyVisible") ?? null;
    this.columnsPartiallyVisibleCalculator = columnsCalculator.getResultsFor("partiallyVisible") ?? null;
  }
  /**
  * Returns information whether proposedFullyVisibleRowsCalculator viewport
  * is contained inside rows rendered in previous draw (cached in rowsRenderCalculator).
  *
  * @param {ViewportRowsCalculator} proposedFullyVisibleRowsCalculator The instance of the fully visible rows viewport calculator to compare with.
  * @param {ViewportRowsCalculator} proposedPartiallyVisibleRowsCalculator The instance of the partially visible rows viewport calculator to compare with.
  * @returns {boolean} Returns `true` if all proposed visible rows are already rendered (meaning: redraw is not needed).
  *                    Returns `false` if at least one proposed visible row is not already rendered (meaning: redraw is needed).
  */
  areAllProposedVisibleRowsAlreadyRendered(proposedFullyVisibleRowsCalculator, proposedPartiallyVisibleRowsCalculator) {
    if (!this.rowsVisibleCalculator || !this.rowsRenderCalculator || !proposedFullyVisibleRowsCalculator || !proposedPartiallyVisibleRowsCalculator) {
      return false;
    }
    let { startRow, endRow } = proposedFullyVisibleRowsCalculator;
    const { startRow: partiallyVisibleStartRow, endRow: partiallyVisibleEndRow } = proposedPartiallyVisibleRowsCalculator;
    if (startRow === null && endRow === null) {
      if (!proposedFullyVisibleRowsCalculator.isVisibleInTrimmingContainer && partiallyVisibleStartRow !== null && !this.wtTable.isRowBeforeRenderedRows(partiallyVisibleStartRow) && partiallyVisibleEndRow !== null && !this.wtTable.isRowAfterRenderedRows(partiallyVisibleEndRow)) {
        return true;
      }
      startRow = partiallyVisibleStartRow;
      endRow = partiallyVisibleEndRow;
    }
    if (startRow === null || endRow === null) {
      return false;
    }
    const { startRow: renderedStartRow, endRow: renderedEndRow, rowStartOffset, rowEndOffset } = this.rowsRenderCalculator;
    if (renderedStartRow === null || renderedEndRow === null) {
      return false;
    }
    const totalRows = this.wtSettings.getSetting("totalRows") - 1;
    const renderingThreshold = this.wtSettings.getSetting("viewportRowRenderingThreshold");
    if (typeof renderingThreshold === "number" && Number.isInteger(renderingThreshold) && renderingThreshold > 0) {
      startRow = Math.max(0, startRow - Math.min(rowStartOffset, renderingThreshold));
      endRow = Math.min(totalRows, endRow + Math.min(rowEndOffset, renderingThreshold));
    } else if (renderingThreshold === "auto") {
      startRow = Math.max(0, startRow - Math.ceil(rowStartOffset / 2));
      endRow = Math.min(totalRows, endRow + Math.ceil(rowEndOffset / 2));
    }
    if (startRow < renderedStartRow || startRow === renderedStartRow && startRow > 0) {
      return false;
    } else if (endRow > renderedEndRow || endRow === renderedEndRow && endRow < totalRows) {
      return false;
    }
    return true;
  }
  /**
  * Returns information whether proposedFullyVisibleColumnsCalculator viewport
  * is contained inside column rendered in previous draw (cached in columnsRenderCalculator).
  *
  * @param {ViewportRowsCalculator} proposedFullyVisibleColumnsCalculator The instance of the fully visible columns viewport calculator to compare with.
  * @param {ViewportRowsCalculator} proposedPartiallyVisibleColumnsCalculator The instance of the partially visible columns viewport calculator to compare with.
  * @returns {boolean} Returns `true` if all proposed visible columns are already rendered (meaning: redraw is not needed).
  *                    Returns `false` if at least one proposed visible column is not already rendered (meaning: redraw is needed).
  */
  areAllProposedVisibleColumnsAlreadyRendered(proposedFullyVisibleColumnsCalculator, proposedPartiallyVisibleColumnsCalculator) {
    if (!this.columnsVisibleCalculator || !this.columnsRenderCalculator || !proposedFullyVisibleColumnsCalculator || !proposedPartiallyVisibleColumnsCalculator) {
      return false;
    }
    let { startColumn, endColumn } = proposedFullyVisibleColumnsCalculator;
    const { startColumn: partiallyVisibleStartColumn, endColumn: partiallyVisibleEndColumn } = proposedPartiallyVisibleColumnsCalculator;
    if (startColumn === null && endColumn === null) {
      if (!proposedFullyVisibleColumnsCalculator.isVisibleInTrimmingContainer && partiallyVisibleStartColumn !== null && !this.wtTable.isColumnBeforeRenderedColumns(partiallyVisibleStartColumn) && partiallyVisibleEndColumn !== null && !this.wtTable.isColumnAfterRenderedColumns(partiallyVisibleEndColumn)) {
        return true;
      }
      startColumn = partiallyVisibleStartColumn;
      endColumn = partiallyVisibleEndColumn;
    }
    if (startColumn === null || endColumn === null) {
      return false;
    }
    const { startColumn: renderedStartColumn, endColumn: renderedEndColumn, columnStartOffset, columnEndOffset } = this.columnsRenderCalculator;
    if (renderedStartColumn === null || renderedEndColumn === null) {
      return false;
    }
    const totalColumns = this.wtSettings.getSetting("totalColumns") - 1;
    const renderingThreshold = this.wtSettings.getSetting("viewportColumnRenderingThreshold");
    if (typeof renderingThreshold === "number" && Number.isInteger(renderingThreshold) && renderingThreshold > 0) {
      startColumn = Math.max(0, startColumn - Math.min(columnStartOffset, renderingThreshold));
      endColumn = Math.min(totalColumns, endColumn + Math.min(columnEndOffset, renderingThreshold));
    } else if (renderingThreshold === "auto") {
      startColumn = Math.max(0, startColumn - Math.ceil(columnStartOffset / 2));
      endColumn = Math.min(totalColumns, endColumn + Math.ceil(columnEndOffset / 2));
    }
    if (startColumn < renderedStartColumn || startColumn === renderedStartColumn && startColumn > 0) {
      return false;
    } else if (endColumn > renderedEndColumn || endColumn === renderedEndColumn && endColumn < totalColumns) {
      return false;
    }
    return true;
  }
  /**
  * Marks the row height position cache as stale. The cache will be rebuilt
  * on the next viewport calculation.
  */
  invalidateRowHeightCache() {
    this.rowHeightCache.invalidate();
  }
  /**
  * Marks the column width position cache as stale. The cache will be rebuilt
  * on the next viewport calculation.
  */
  invalidateColumnWidthCache() {
    this.columnWidthCache.invalidate();
  }
  /**
  * Marks both the row height and column width position caches as stale.
  */
  invalidateAllCaches() {
    this.rowHeightCache.invalidate();
    this.columnWidthCache.invalidate();
  }
  /**
  * Resets values in keys of the hasOversizedColumnHeadersMarked object after updateSettings.
  */
  resetHasOversizedColumnHeadersMarked() {
    objectEach(this.hasOversizedColumnHeadersMarked, (value, key, object) => {
      object[key] = void 0;
    });
  }
  /**
  * @param {ViewportDao} dataAccessObject The Walkontable instance.
  * @param {DomBindings} domBindings Bindings into DOM.
  * @param {Settings} wtSettings The Walkontable settings.
  * @param {EventManager} eventManager The instance event manager.
  * @param {Table} wtTable The table.
  */
  constructor(dataAccessObject, domBindings, wtSettings, eventManager, wtTable) {
    this.dataAccessObject = dataAccessObject;
    this.wot = dataAccessObject.wot;
    this.instance = this.wot;
    this.domBindings = domBindings;
    this.wtSettings = wtSettings;
    this.wtTable = wtTable;
    this.oversizedRows = {};
    this.oversizedColumnHeaders = {};
    this.hasOversizedColumnHeadersMarked = {};
    this.clientHeight = 0;
    this.rowHeaderWidth = NaN;
    this.rowsVisibleCalculator = null;
    this.columnsVisibleCalculator = null;
    this.rowsCalculatorTypes = /* @__PURE__ */ new Map([
      [
        "rendered",
        () => this.wtSettings.getSetting("renderAllRows") ? new RenderedAllRowsCalculationType() : new RenderedRowsCalculationType()
      ],
      [
        "fullyVisible",
        () => new FullyVisibleRowsCalculationType()
      ],
      [
        "partiallyVisible",
        () => new PartiallyVisibleRowsCalculationType()
      ]
    ]);
    this.columnsCalculatorTypes = /* @__PURE__ */ new Map([
      [
        "rendered",
        () => this.wtSettings.getSetting("renderAllColumns") ? new RenderedAllColumnsCalculationType() : new RenderedColumnsCalculationType()
      ],
      [
        "fullyVisible",
        () => new FullyVisibleColumnsCalculationType()
      ],
      [
        "partiallyVisible",
        () => new PartiallyVisibleColumnsCalculationType()
      ]
    ]);
    this.rowHeightCache = new PositionCache({
      totalItemsFn: () => wtSettings.getSetting("totalRows"),
      sizeFn: (sourceRow) => wtTable.getRowHeight(sourceRow) ?? NaN,
      defaultSizeFn: () => wtSettings.getSetting("stylesHandler").getDefaultRowHeight()
    });
    this.columnWidthCache = new PositionCache({
      totalItemsFn: () => wtSettings.getSetting("totalColumns"),
      sizeFn: (sourceCol) => wtTable.getColumnWidth(sourceCol),
      defaultSizeFn: () => DEFAULT_COLUMN_WIDTH
    });
    this.eventManager = eventManager;
    this.eventManager.addEventListener(this.domBindings.rootWindow, "resize", () => {
      this.clientHeight = this.getWorkspaceHeight();
    });
  }
}
class Walkontable extends CoreAbstract {
  /**
  * Export settings as class names added to the parent element of the table.
  */
  exportSettingsAsClassNames() {
    const toExport = {
      rowHeaders: "htRowHeaders",
      columnHeaders: "htColumnHeaders"
    };
    const allClassNames = [];
    const newClassNames = [];
    objectEach(toExport, (className, key) => {
      if (this.wtSettings.getSetting(key).length) {
        newClassNames.push(className);
      }
      allClassNames.push(className);
    });
    removeClass(this.wtTable.wtRootElement.parentNode, allClassNames);
    addClass(this.wtTable.wtRootElement.parentNode, newClassNames);
  }
  /**
  * Destroy instance.
  */
  destroy() {
    this.wtTable.destroy();
    super.destroy();
  }
  /**
  * Gets the overlay instance by its name.
  *
  * @param {'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'} overlayName The overlay name.
  * @returns {Overlay | null}
  */
  getOverlayByName(overlayName) {
    if (!CLONE_TYPES.includes(overlayName)) {
      return null;
    }
    const camelCaseOverlay = overlayName.replace(/_([a-z])/g, (_match, letter) => letter.toUpperCase());
    return this.wtOverlays[`${camelCaseOverlay}Overlay`] ?? null;
  }
  /**
  * @returns {Record<string, unknown>}
  */
  getViewportDao() {
    return /* @__PURE__ */ ((instance) => ({
      get wot() {
        return instance;
      },
      get topOverlayTrimmingContainer() {
        return instance.wtOverlays.topOverlay.trimmingContainer;
      },
      get inlineStartOverlayTrimmingContainer() {
        return instance.wtOverlays.inlineStartOverlay.trimmingContainer;
      },
      get topScrollPosition() {
        return instance.wtOverlays.topOverlay.getScrollPosition();
      },
      get topParentOffset() {
        return instance.wtOverlays.topOverlay.getTableParentOffset();
      },
      get inlineStartScrollPosition() {
        return instance.wtOverlays.inlineStartOverlay.getScrollPosition();
      },
      get inlineStartParentOffset() {
        return instance.wtOverlays.inlineStartOverlay.getTableParentOffset();
      },
      get topOverlay() {
        return instance.wtOverlays.topOverlay;
      },
      get inlineStartOverlay() {
        return instance.wtOverlays.inlineStartOverlay;
      },
      get bottomOverlay() {
        return instance.wtOverlays.bottomOverlay;
      }
    }))(this);
  }
  /**
  * @param {HTMLTableElement} table Main table.
  * @param {SettingsPure} settings The Walkontable settings.
  */
  constructor(table, settings) {
    super(table, new Settings(settings));
    const facadeGetter = this.wtSettings.getSetting("facade", this);
    this.wtTable = new MasterTable(this.getTableDao(), facadeGetter, this.domBindings, this.wtSettings);
    this.wtViewport = new Viewport(this.getViewportDao(), this.domBindings, this.wtSettings, this.eventManager, this.wtTable);
    this.selectionManager = new SelectionManager(this.wtSettings.getSetting("selections"));
    this.wtEvent = new Event$1(facadeGetter, this.domBindings, this.wtSettings, this.eventManager, this.wtTable, this.selectionManager);
    this.wtOverlays = new Overlays(
      // TODO create DAO and remove reference to the Walkontable instance.
      this,
      facadeGetter,
      this.domBindings,
      this.wtSettings,
      this.eventManager,
      this.wtTable
    );
    this.exportSettingsAsClassNames();
    this.findOriginalHeaders();
  }
}
class WalkontableFacade {
  /**
  * Initializes the facade from a settings object.
  *
  * @param {Record<string, any>} settings - The Walkontable settings configuration.
  */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _initFromSettings(settings) {
    settings.facade = (instance) => {
      const facade = new WalkontableFacade(instance);
      return () => facade;
    };
    this._wot = new Walkontable(settings.table, settings);
  }
  /**
  * Gets the unique identifier of the Walkontable instance.
  *
  * @returns {*} The unique identifier.
  */
  get guid() {
    return this._wot.guid;
  }
  /**
  * Gets the root document used by the Walkontable instance.
  *
  * @returns {*} The root document.
  */
  get rootDocument() {
    return this._wot.domBindings.rootDocument;
  }
  /**
  * Gets the root window used by the Walkontable instance.
  *
  * @returns {*} The root window.
  */
  get rootWindow() {
    return this._wot.domBindings.rootWindow;
  }
  /**
  * Gets the settings manager for the Walkontable instance.
  *
  * @returns {*} The settings manager.
  */
  get wtSettings() {
    return this._wot.wtSettings;
  }
  /**
  * Gets the clone source of the Walkontable instance.
  *
  * @returns {*} The clone source.
  */
  get cloneSource() {
    return this._wot.cloneSource;
  }
  /**
  * Gets the clone overlay of the Walkontable instance.
  *
  * @returns {Overlay} The clone overlay.
  */
  get cloneOverlay() {
    return this._wot.cloneOverlay;
  }
  /**
  * Gets the selection manager of the Walkontable instance.
  *
  * @returns {*} The selection manager.
  */
  get selectionManager() {
    return this._wot.selectionManager;
  }
  /**
  * Gets the viewport manager of the Walkontable instance.
  *
  * @returns {*} The viewport manager.
  */
  get wtViewport() {
    return this._wot.wtViewport;
  }
  /**
  * Gets the overlays manager of the Walkontable instance.
  *
  * @returns {*} The overlays manager.
  */
  get wtOverlays() {
    return this._wot.wtOverlays;
  }
  /**
  * Gets the table manager of the Walkontable instance.
  *
  * @returns {*} The table manager.
  */
  get wtTable() {
    return this._wot.wtTable;
  }
  /**
  * Gets the event manager of the Walkontable instance.
  *
  * @returns {*} The event manager.
  */
  get wtEvent() {
    return this._wot.wtEvent;
  }
  /**
  * Gets the scroll manager of the Walkontable instance.
  *
  * @returns {*} The scroll manager.
  */
  get wtScroll() {
    return this._wot.wtScroll;
  }
  /**
  * Gets whether the Walkontable instance has been drawn.
  *
  * @returns {*} True if drawn, false otherwise.
  */
  get drawn() {
    return this._wot.drawn;
  }
  /**
  * Sets whether the Walkontable instance has been drawn.
  *
  * @param {*} value - The drawn state.
  */
  set drawn(value) {
    this._wot.drawn = value;
  }
  /**
  * Gets the name of the active overlay.
  *
  * @returns {*} The active overlay name.
  */
  get activeOverlayName() {
    return this._wot.activeOverlayName;
  }
  /**
  * Gets whether drawing has been interrupted.
  *
  * @returns {*} True if drawing is interrupted, false otherwise.
  */
  get drawInterrupted() {
    return this._wot.drawInterrupted;
  }
  /**
  * Sets whether drawing has been interrupted.
  *
  * @param {*} value - The interrupted state.
  */
  set drawInterrupted(value) {
    this._wot.drawInterrupted = value;
  }
  /**
  * Gets the last element that was moused over.
  *
  * @returns {HTMLElement | null} The last moused-over element, or null.
  */
  get lastMouseOver() {
    return this._wot.lastMouseOver;
  }
  /**
  * Sets the last element that was moused over.
  *
  * @param {*} value - The element to set.
  */
  set lastMouseOver(value) {
    this._wot.lastMouseOver = value;
  }
  /**
  * Gets the momentum scrolling state.
  *
  * @returns {{ ongoing?: boolean; _timeout?: ReturnType<typeof setTimeout> }} The momentum scrolling state.
  */
  get momentumScrolling() {
    return this._wot.momentumScrolling;
  }
  /**
  * Sets the momentum scrolling state.
  *
  * @param {*} value - The momentum scrolling state.
  */
  set momentumScrolling(value) {
    this._wot.momentumScrolling = value;
  }
  /**
  * Gets whether touch input has been applied.
  *
  * @returns {boolean} True if touch was applied, false otherwise.
  */
  get touchApplied() {
    return this._wot.touchApplied;
  }
  /**
  * Sets whether touch input has been applied.
  *
  * @param {*} value - The touch applied state.
  */
  set touchApplied(value) {
    this._wot.touchApplied = value;
  }
  /**
  * Gets the DOM bindings configuration.
  *
  * @returns {*} The DOM bindings.
  */
  get domBindings() {
    return this._wot.domBindings;
  }
  /**
  * Gets the list of event listeners.
  *
  * @returns {unknown[]} The array of event listeners.
  */
  get eventListeners() {
    return this._wot.eventListeners;
  }
  /**
  * Sets the list of event listeners.
  *
  * @param {*} value - The event listeners array.
  */
  set eventListeners(value) {
    this._wot.eventListeners = value;
  }
  /**
  * Gets the event manager instance.
  *
  * @returns {*} The event manager.
  */
  get eventManager() {
    return this._wot.eventManager;
  }
  /**
  * Creates a new cell coordinates object.
  *
  * @param {number} row - The row index.
  * @param {number} column - The column index.
  * @returns {*} The new cell coordinates object.
  */
  createCellCoords(row, column) {
    return this._wot.createCellCoords(row, column);
  }
  /**
  * Creates a new cell range.
  *
  * @param {CellCoords} highlight - The highlighted cell coordinates.
  * @param {CellCoords} from - The starting cell coordinates.
  * @param {CellCoords} to - The ending cell coordinates.
  * @returns {*} The new cell range.
  */
  createCellRange(highlight, from, to) {
    return this._wot.createCellRange(highlight, from, to);
  }
  /**
  * Redraws the table.
  *
  * @param {boolean} [fastDraw=false] - Whether to perform a fast draw.
  * @returns {WalkontableFacade} This instance for method chaining.
  */
  draw(fastDraw = false) {
    this._wot.draw(fastDraw);
    return this;
  }
  /**
  * Gets the DOM cell element at the specified coordinates.
  *
  * @param {CellCoords} coords - The cell coordinates.
  * @param {boolean} [topmost=false] - Whether to get the topmost element.
  * @returns {*} The DOM cell element.
  */
  getCell(coords, topmost = false) {
    return this._wot.getCell(coords, topmost);
  }
  /**
  * Scrolls the viewport to the specified cell coordinates.
  *
  * @param {CellCoords} coords - The cell coordinates to scroll to.
  * @param {string} horizontalSnap - The horizontal snap setting.
  * @param {string} verticalSnap - The vertical snap setting.
  * @returns {*} The result of the scroll operation.
  */
  scrollViewport(coords, horizontalSnap, verticalSnap) {
    return this._wot.scrollViewport(coords, horizontalSnap, verticalSnap);
  }
  /**
  * Scrolls the viewport horizontally.
  *
  * @param {number} column - The column index to scroll to.
  * @param {string} snapping - The snapping setting.
  * @returns {*} The result of the scroll operation.
  */
  scrollViewportHorizontally(column, snapping) {
    return this._wot.scrollViewportHorizontally(column, snapping);
  }
  /**
  * Scrolls the viewport vertically.
  *
  * @param {number} row - The row index to scroll to.
  * @param {string} snapping - The snapping setting.
  * @returns {*} The result of the scroll operation.
  */
  scrollViewportVertically(row, snapping) {
    return this._wot.scrollViewportVertically(row, snapping);
  }
  /**
  * Gets the current viewport dimensions.
  *
  * @returns {*} The viewport dimensions.
  */
  getViewport() {
    return this._wot.getViewport();
  }
  /**
  * Gets the name of the currently active overlay.
  *
  * @returns {string} The overlay type name, or 'master' if no clone overlay.
  */
  getOverlayName() {
    return this._wot.cloneOverlay ? this._wot.cloneOverlay.type : "master";
  }
  /**
  * Gets an overlay by its name.
  *
  * @param {string} overlayName - The name of the overlay to retrieve.
  * @returns {Overlay | null} The overlay, or null if not found.
  */
  getOverlayByName(overlayName) {
    return this._wot.getOverlayByName(overlayName);
  }
  /**
  * Exports the current settings as CSS class names on the table element.
  */
  exportSettingsAsClassNames() {
    this._wot.exportSettingsAsClassNames();
  }
  /**
  * Updates Walkontable settings.
  *
  * @param {string | Record<string, unknown>} settings - The setting key or settings object.
  * @param {unknown} value - The value to set (when settings is a string).
  * @returns {WalkontableFacade} This instance for method chaining.
  */
  update(settings, value) {
    this._wot.wtSettings.update(settings, value);
    return this;
  }
  /**
  * Gets a setting value.
  *
  * @param {string} key - The setting key.
  * @param {unknown} param1 - Optional parameter.
  * @param {unknown} param2 - Optional parameter.
  * @param {unknown} param3 - Optional parameter.
  * @param {unknown} param4 - Optional parameter.
  * @returns {unknown} The setting value.
  */
  getSetting(key, param1, param2, param3, param4) {
    return this._wot.wtSettings.getSetting(key, param1, param2, param3, param4);
  }
  /**
  * Checks whether a setting exists.
  *
  * @param {string} key - The setting key.
  * @returns {*} True if the setting exists, false otherwise.
  */
  hasSetting(key) {
    return this._wot.wtSettings.has(key);
  }
  /**
  * Destroys the Walkontable instance and cleans up resources.
  */
  destroy() {
    this._wot.destroy();
  }
  /**
  * @param {SettingsPure|Walkontable} settingsOrInstance The Walkontable settings.
  */
  constructor(settingsOrInstance) {
    if (settingsOrInstance instanceof CoreAbstract) {
      this._wot = settingsOrInstance;
    } else {
      this._initFromSettings(settingsOrInstance);
    }
  }
}
function mouseDown({ isShiftKey, isLeftClick: isLeftClick2, isRightClick: isRightClick2, coords, selection, controller, cellCoordsFactory }) {
  const sel = selection;
  const currentSelection = sel.isSelected() ? sel.getSelectedRange().current() : null;
  const selectedCorner = sel.isSelectedByCorner();
  const selectedRow = sel.isSelectedByRowHeader();
  sel.markSource("mouse");
  const coordsRow = coords.row ?? -1;
  const coordsCol = coords.col ?? -1;
  if (isShiftKey && currentSelection) {
    if (coordsRow >= 0 && coordsCol >= 0 && !controller.cell) {
      sel.setRangeEnd(coords);
    } else if (selectedCorner && coordsRow < 0 && !controller.column) {
      sel.setRangeEnd(cellCoordsFactory(currentSelection.to.row ?? 0, coordsCol));
    } else if (selectedRow && coordsCol < 0 && !controller.row) {
      sel.setRangeEnd(cellCoordsFactory(coordsRow, currentSelection.to.col ?? 0));
    } else if ((!selectedCorner && !selectedRow && coordsCol < 0 || selectedCorner && coordsCol < 0) && !controller.row) {
      sel.selectRows(Math.max(currentSelection.from.row ?? 0, 0), coordsRow, coordsCol);
    } else if ((!selectedCorner && !selectedRow && coordsRow < 0 || selectedRow && coordsRow < 0) && !controller.column) {
      sel.selectColumns(Math.max(currentSelection.from.col ?? 0, 0), coordsCol, coordsRow);
    }
  } else {
    const allowRightClickSelection = !sel.inInSelection(coords);
    const performSelection = isLeftClick2 || isRightClick2 && allowRightClickSelection;
    if (coordsRow < 0 && coordsCol >= 0 && !controller.column) {
      if (performSelection) {
        sel.selectColumns(coordsCol, coordsCol, coordsRow);
      }
    } else if (coordsCol < 0 && coordsRow >= 0 && !controller.row) {
      if (performSelection) {
        sel.selectRows(coordsRow, coordsRow, coordsCol);
      }
    } else if (coordsCol >= 0 && coordsRow >= 0 && !controller.cell) {
      if (performSelection) {
        sel.setRangeStart(coords);
      }
    } else if (coordsCol < 0 && coordsRow < 0) {
      sel.selectAll(true, true, {
        disableHeadersHighlight: true,
        focusPosition: {
          row: 0,
          col: 0
        }
      });
    }
  }
  sel.markEndSource();
}
function mouseOver({ isLeftClick: isLeftClick2, coords, selection, controller, cellCoordsFactory }) {
  if (!isLeftClick2) {
    return;
  }
  const sel = selection;
  const selectedRow = sel.isSelectedByRowHeader();
  const selectedColumn = sel.isSelectedByColumnHeader();
  const countCols = sel.tableProps.countCols();
  const countRows = sel.tableProps.countRows();
  sel.markSource("mouse");
  if (selectedColumn && !controller.column) {
    sel.setRangeEnd(cellCoordsFactory(countRows - 1, coords.col ?? 0));
  } else if (selectedRow && !controller.row) {
    sel.setRangeEnd(cellCoordsFactory(coords.row ?? 0, countCols - 1));
  } else if (!controller.cell) {
    sel.setRangeEnd(coords);
  }
  sel.markEndSource();
}
function mouseUp({ isLeftClick: isLeftClick2, selection, cellRangeMapper }) {
  const sel = selection;
  const dvs = sel.settings.disableVisualSelection;
  const visualSelectionDisabled = dvs === true || typeof dvs === "string" && dvs.length > 0 || Array.isArray(dvs) && dvs.length > 0;
  if (!isLeftClick2 || sel.settings.selectionMode !== "multiple" || visualSelectionDisabled) {
    return;
  }
  const selectionRange = sel.getSelectedRange();
  const renderableRange = selectionRange.clone().map((range) => cellRangeMapper.toRenderable(range));
  const lastRenderableRange = renderableRange.current();
  if (lastRenderableRange && renderableRange.size() > 1 && !lastRenderableRange.isHeader() && !sel.isMultiple(lastRenderableRange)) {
    const ranges = renderableRange.findAll(lastRenderableRange);
    if (ranges.length === renderableRange.size()) {
      selection.markSource("deselect");
      selectionRange.pop();
      selection.refresh();
      selection.markEndSource();
    } else if (ranges.length > 1) {
      selection.markSource("deselect");
      selectionRange.removeLayers(ranges.map(({ layer }) => layer));
      selection.refresh();
      selection.markEndSource();
    }
  }
}
const handlers = /* @__PURE__ */ new Map([
  [
    "touchstart",
    mouseDown
  ],
  [
    "touchend",
    mouseUp
  ],
  [
    "mousedown",
    mouseDown
  ],
  [
    "mouseover",
    mouseOver
  ],
  [
    "mousemove",
    mouseOver
  ],
  [
    "mouseup",
    mouseUp
  ]
]);
function handleMouseEvent(event, options) {
  const handler = handlers.get(event.type);
  if (handler) {
    handler({
      isShiftKey: event.shiftKey,
      isLeftClick: isLeftClick(event) || event.type === "touchstart",
      isRightClick: isRightClick(event),
      ...options
    });
  }
}
const holder = /* @__PURE__ */ new WeakMap();
const rootInstanceSymbol = /* @__PURE__ */ Symbol("rootInstance");
function registerAsRootInstance(object) {
  holder.set(object, true);
}
function hasValidParameter(rootSymbol) {
  return rootSymbol === rootInstanceSymbol;
}
function isRootInstance(object) {
  return holder.has(object);
}
function _check_private_redeclaration$1v(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1h(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1h(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1h(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1h(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1h(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1h(receiver, descriptor);
}
function _class_private_field_init$1h(obj, privateMap, value) {
  _check_private_redeclaration$1v(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1h(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1h(receiver, privateMap, "set");
  _class_apply_descriptor_set$1h(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$12(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$12(obj, privateSet) {
  _check_private_redeclaration$1v(obj, privateSet);
  privateSet.add(obj);
}
var _columnHeadersCount = /* @__PURE__ */ new WeakMap(), _rowHeadersCount = /* @__PURE__ */ new WeakMap(), _selectionMouseDown = /* @__PURE__ */ new WeakMap(), _mouseDown = /* @__PURE__ */ new WeakMap(), _table = /* @__PURE__ */ new WeakMap(), _lastWidth = /* @__PURE__ */ new WeakMap(), _lastHeight = /* @__PURE__ */ new WeakMap(), _mouseDownLastPos = /* @__PURE__ */ new WeakMap(), _recentTouchEnd = /* @__PURE__ */ new WeakMap(), _recentTouchEndTimeout = /* @__PURE__ */ new WeakMap(), _isSyntheticMouseEvent = /* @__PURE__ */ new WeakSet(), _getAriaColcount = /* @__PURE__ */ new WeakSet(), _updateAriaColcount = /* @__PURE__ */ new WeakSet(), _updateScrollbarClassNames = /* @__PURE__ */ new WeakSet();
class TableView {
  /**
  * Renders WalkontableUI.
  */
  render() {
    if (!this.hot.isRenderSuspended()) {
      const isFullRender = this.hot.forceFullRender;
      this.hot.runHooks("beforeRender", isFullRender);
      this._wt.draw(!isFullRender);
      _class_private_method_get$12(this, _updateScrollbarClassNames, updateScrollbarClassNames).call(this);
      if (this.postponedAdjustElementsSize) {
        this.postponedAdjustElementsSize = false;
        this.adjustElementsSize(true);
      }
      this.hot.runHooks("afterRender", isFullRender);
      this.hot.forceFullRender = false;
    }
  }
  /**
  * Adjust overlays elements size and master table size. By default the internal `adjustElementsSize`
  * call of the Walkontable is postponed to the next render cycle. If `flush` is set to `true`, the method
  * will be executed immediately.
  *
  * TODO: This method should not exist. It is a workaround for the issue with updating the elements
  * size after render. It should be calculated and updated automatically in Walkontable.
  *
  * @param {boolean} [flush=false] If `true`, the method will be executed immediately.
  */
  adjustElementsSize(flush = false) {
    if (flush) {
      this._wt.wtOverlays.adjustElementsSize();
    } else {
      this.postponedAdjustElementsSize = true;
    }
  }
  /**
  * Returns td object given coordinates.
  *
  * @param {CellCoords} coords Renderable cell coordinates.
  * @param {boolean} topmost Indicates whether the cell should be calculated from the topmost.
  * @returns {HTMLTableCellElement|null}
  */
  getCellAtCoords(coords, topmost) {
    const td = this._wt.getCell(coords, topmost);
    if (typeof td === "number" && td < 0) {
      return null;
    }
    return td;
  }
  /**
  * Scroll viewport to a cell.
  *
  * @param {CellCoords} coords Renderable cell coordinates.
  * @param {'auto' | 'start' | 'end'} [horizontalSnap] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @param {'auto' | 'top' | 'bottom'} [verticalSnap] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on the bottom of
  * the table. When `'auto'`, the viewport is scrolled only when the row is outside of the viewport.
  * @returns {boolean}
  */
  scrollViewport(coords, horizontalSnap, verticalSnap) {
    return this._wt.scrollViewport(coords, horizontalSnap, verticalSnap);
  }
  /**
  * Scroll viewport to a column.
  *
  * @param {number} column Renderable column index.
  * @param {'auto' | 'start' | 'end'} [snap] If `'start'`, viewport is scrolled to show
  * the cell on the left of the table. If `'end'`, viewport is scrolled to show the cell on the right of
  * the table. When `'auto'`, the viewport is scrolled only when the column is outside of the viewport.
  * @returns {boolean}
  */
  scrollViewportHorizontally(column, snap) {
    return this._wt.scrollViewportHorizontally(column, snap);
  }
  /**
  * Scroll viewport to a row.
  *
  * @param {number} row Renderable row index.
  * @param {'auto' | 'top' | 'bottom'} [snap] If `'top'`, viewport is scrolled to show
  * the cell on the top of the table. If `'bottom'`, viewport is scrolled to show the cell on
  * the bottom of the table. When `'auto'`, the viewport is scrolled only when the row is outside of
  * the viewport.
  * @returns {boolean}
  */
  scrollViewportVertically(row, snap) {
    return this._wt.scrollViewportVertically(row, snap);
  }
  /**
  * Prepares DOMElements and adds correct className to the root element.
  *
  * @private
  */
  createElements() {
    const { rootElement, rootDocument } = this.hot;
    const originalStyle = rootElement.getAttribute("style");
    if (originalStyle) {
      rootElement.dataset.originalstyle = originalStyle;
    }
    addClass(rootElement, "handsontable");
    _class_private_field_set$1h(this, _table, rootDocument.createElement("table"));
    addClass(_class_private_field_get$1h(this, _table), "htCore");
    if (this.hot.getSettings().tableClassName) {
      addClass(_class_private_field_get$1h(this, _table), this.hot.getSettings().tableClassName);
    }
    if (this.settings.ariaTags) {
      setAttribute(_class_private_field_get$1h(this, _table), [
        A11Y_PRESENTATION()
      ]);
      setAttribute(rootElement, [
        A11Y_TREEGRID(),
        A11Y_ROWCOUNT(-1),
        A11Y_COLCOUNT(this.hot.countCols()),
        A11Y_MULTISELECTABLE()
      ]);
    }
    this.THEAD = rootDocument.createElement("thead");
    _class_private_field_get$1h(this, _table).appendChild(this.THEAD);
    this.TBODY = rootDocument.createElement("tbody");
    _class_private_field_get$1h(this, _table).appendChild(this.TBODY);
    this.hot.table = _class_private_field_get$1h(this, _table);
    this.hot.container.insertBefore(_class_private_field_get$1h(this, _table), this.hot.container.firstChild);
  }
  /**
  * Attaches necessary listeners.
  *
  * @private
  */
  registerEvents() {
    const { rootWrapperElement, rootElement, rootDocument, selection, rootWindow } = this.hot;
    const documentElement = rootDocument.documentElement;
    this.eventManager.addEventListener(rootElement, "mousedown", (event) => {
      if (_class_private_method_get$12(this, _isSyntheticMouseEvent, isSyntheticMouseEvent).call(this, event)) {
        return;
      }
      if (isMiddleClick(event)) {
        return;
      }
      _class_private_field_set$1h(this, _selectionMouseDown, true);
      if (!this.isTextSelectionAllowed(eventTargetEl(event))) {
        clearTextSelection(rootWindow);
        event.preventDefault();
        rootWindow.focus();
      }
    });
    this.eventManager.addEventListener(rootElement, "mouseup", (event) => {
      if (_class_private_method_get$12(this, _isSyntheticMouseEvent, isSyntheticMouseEvent).call(this, event)) {
        return;
      }
      _class_private_field_set$1h(this, _selectionMouseDown, false);
    });
    this.eventManager.addEventListener(rootElement, "mousemove", (event) => {
      if (_class_private_field_get$1h(this, _selectionMouseDown) && !this.isTextSelectionAllowed(eventTargetEl(event))) {
        if (this.settings.fragmentSelection) {
          clearTextSelection(rootWindow);
        }
        event.preventDefault();
      }
    });
    this.eventManager.addEventListener(documentElement, "keyup", (event) => {
      if (selection.isInProgress() && !event.shiftKey) {
        selection.finish();
      }
    });
    this.eventManager.addEventListener(documentElement, "mouseup", (event) => {
      if (selection.isInProgress() && isLeftClick(event)) {
        selection.finish();
      }
      _class_private_field_set$1h(this, _mouseDown, false);
      if (_class_private_method_get$12(this, _isSyntheticMouseEvent, isSyntheticMouseEvent).call(this, event)) {
        return;
      }
      const isOutsideInputElement = isOutsideInput(rootDocument.activeElement);
      if (isInput(rootDocument.activeElement) && !isOutsideInputElement) {
        return;
      }
      if (isOutsideInputElement || !selection.isSelected() && !selection.isSelectedByAnyHeader() && !(rootWrapperElement ?? rootElement).contains(event.target) && !isRightClick(event)) {
        this.hot.unlisten();
      }
    });
    this.eventManager.addEventListener(documentElement, "contextmenu", (event) => {
      if (selection.isInProgress() && isRightClick(event)) {
        selection.finish();
        _class_private_field_set$1h(this, _mouseDown, false);
      }
    });
    this.eventManager.addEventListener(documentElement, "touchend", () => {
      if (selection.isInProgress()) {
        selection.finish();
      }
      _class_private_field_set$1h(this, _mouseDown, false);
      _class_private_field_set$1h(this, _recentTouchEnd, true);
      if (_class_private_field_get$1h(this, _recentTouchEndTimeout) !== null) {
        clearTimeout(_class_private_field_get$1h(this, _recentTouchEndTimeout));
      }
      _class_private_field_set$1h(this, _recentTouchEndTimeout, this.hot._registerTimeout(() => {
        _class_private_field_set$1h(this, _recentTouchEnd, false);
        _class_private_field_set$1h(this, _recentTouchEndTimeout, null);
      }, 400));
    });
    this.eventManager.addEventListener(documentElement, "mousedown", (event) => {
      const originalTarget = event.target;
      const eventX = event.clientX;
      const eventY = event.clientY;
      let next = event.target;
      if (_class_private_field_get$1h(this, _mouseDown) || !rootElement || !this.hot.view) {
        return;
      }
      if (_class_private_method_get$12(this, _isSyntheticMouseEvent, isSyntheticMouseEvent).call(this, event)) {
        return;
      }
      const { holder: holder2 } = this._wt.wtTable;
      if (next === holder2) {
        const scrollbarWidth = getScrollbarWidth(rootDocument);
        if (rootDocument.elementFromPoint(eventX + scrollbarWidth, eventY) !== holder2 || rootDocument.elementFromPoint(eventX, eventY + scrollbarWidth) !== holder2) {
          return;
        }
      } else {
        const { rootPortalElement } = this.hot;
        while (next !== documentElement) {
          if (next === null) {
            if (event.isTargetWebComponent) {
              break;
            }
            return;
          }
          if (next === rootElement || next === rootPortalElement) {
            return;
          }
          next = next.parentNode;
        }
      }
      const outsideClickDeselects = typeof this.settings.outsideClickDeselects === "function" ? this.settings.outsideClickDeselects(originalTarget) : this.settings.outsideClickDeselects;
      if (outsideClickDeselects) {
        this.hot.deselectCell();
      } else {
        this.hot.destroyEditor(false, false);
      }
    });
    let parentWindow = getParentWindow(rootWindow);
    while (parentWindow !== null) {
      this.eventManager.addEventListener(parentWindow.document.documentElement, "click", () => {
        this.hot.unlisten();
      });
      parentWindow = getParentWindow(parentWindow);
    }
    this.eventManager.addEventListener(_class_private_field_get$1h(this, _table), "selectstart", (event) => {
      if (this.settings.fragmentSelection || isInput(eventTargetEl(event))) {
        return;
      }
      event.preventDefault();
    });
  }
  /**
  * Invalidates Walkontable viewport caches for row heights and column widths (per-index axis sizes).
  */
  invalidateIndexSizesCache() {
    this._wt.wtViewport.invalidateRowHeightCache();
    this._wt.wtViewport.invalidateColumnWidthCache();
  }
  /**
  * Invalidates Walkontable viewport cache for column widths.
  */
  invalidateColumnWidthCache() {
    this._wt.wtViewport.invalidateColumnWidthCache();
  }
  /**
  * Invalidates Walkontable viewport cache for row heights.
  */
  invalidateRowHeightCache() {
    this._wt.wtViewport.invalidateRowHeightCache();
  }
  /**
  * Translate renderable cell coordinates to visual coordinates.
  *
  * @param {CellCoords} coords The cell coordinates.
  * @returns {CellCoords}
  */
  translateFromRenderableToVisualCoords({ row, col }) {
    return this.hot._createCellCoords(...this.translateFromRenderableToVisualIndex(row, col));
  }
  /**
  * Translate renderable row and column indexes to visual row and column indexes.
  *
  * @param {number} renderableRow Renderable row index.
  * @param {number} renderableColumn Renderable columnIndex.
  * @returns {number[]}
  */
  translateFromRenderableToVisualIndex(renderableRow, renderableColumn) {
    const mappedRow = renderableRow >= 0 ? this.hot.rowIndexMapper.getVisualFromRenderableIndex(renderableRow) : renderableRow;
    const mappedColumn = renderableColumn >= 0 ? this.hot.columnIndexMapper.getVisualFromRenderableIndex(renderableColumn) : renderableColumn;
    const visualRow = mappedRow === null ? renderableRow : mappedRow;
    const visualColumn = mappedColumn === null ? renderableColumn : mappedColumn;
    return [
      visualRow,
      visualColumn
    ];
  }
  /**
  * Returns the number of renderable indexes.
  *
  * @private
  * @param {IndexMapper} indexMapper The IndexMapper instance for specific axis.
  * @param {number} maxElements Maximum number of elements (rows or columns).
  *
  * @returns {number|*}
  */
  countRenderableIndexes(indexMapper, maxElements) {
    const consideredElements = Math.min(indexMapper.getNotTrimmedIndexesLength(), maxElements);
    const firstNotHiddenIndex = indexMapper.getNearestNotHiddenIndex(consideredElements - 1, -1);
    if (firstNotHiddenIndex === null) {
      return 0;
    }
    return (indexMapper.getRenderableFromVisualIndex(firstNotHiddenIndex) ?? 0) + 1;
  }
  /**
  * Returns the number of renderable columns.
  *
  * @returns {number}
  */
  countRenderableColumns() {
    return this.countRenderableIndexes(this.hot.columnIndexMapper, this.settings.maxCols);
  }
  /**
  * Returns the number of renderable rows.
  *
  * @returns {number}
  */
  countRenderableRows() {
    return this.countRenderableIndexes(this.hot.rowIndexMapper, this.settings.maxRows);
  }
  /**
  * Returns number of not hidden row indexes counting from the passed starting index.
  * The counting direction can be controlled by `incrementBy` argument.
  *
  * @param {number} visualIndex The visual index from which the counting begins.
  * @param {number} incrementBy If `-1` then counting is backwards or forward when `1`.
  * @returns {number}
  */
  countNotHiddenRowIndexes(visualIndex, incrementBy) {
    return this.countNotHiddenIndexes(visualIndex, incrementBy, this.hot.rowIndexMapper, this.countRenderableRows());
  }
  /**
  * Returns number of not hidden column indexes counting from the passed starting index.
  * The counting direction can be controlled by `incrementBy` argument.
  *
  * @param {number} visualIndex The visual index from which the counting begins.
  * @param {number} incrementBy If `-1` then counting is backwards or forward when `1`.
  * @returns {number}
  */
  countNotHiddenColumnIndexes(visualIndex, incrementBy) {
    return this.countNotHiddenIndexes(visualIndex, incrementBy, this.hot.columnIndexMapper, this.countRenderableColumns());
  }
  /**
  * Returns number of not hidden indexes counting from the passed starting index.
  * The counting direction can be controlled by `incrementBy` argument.
  *
  * @param {number} visualIndex The visual index from which the counting begins.
  * @param {number} incrementBy If `-1` then counting is backwards or forward when `1`.
  * @param {IndexMapper} indexMapper The IndexMapper instance for specific axis.
  * @param {number} renderableIndexesCount Total count of renderable indexes for specific axis.
  * @returns {number}
  */
  countNotHiddenIndexes(visualIndex, incrementBy, indexMapper, renderableIndexesCount) {
    if (isNaN(visualIndex) || visualIndex < 0) {
      return 0;
    }
    const searchDirection = incrementBy < 0 ? -1 : 1;
    const firstVisibleIndex = indexMapper.getNearestNotHiddenIndex(visualIndex, searchDirection);
    const renderableIndex = indexMapper.getRenderableFromVisualIndex(firstVisibleIndex);
    if (renderableIndex === null || !Number.isInteger(renderableIndex)) {
      return 0;
    }
    let notHiddenIndexes = 0;
    if (incrementBy < 0) {
      notHiddenIndexes = renderableIndex + 1;
    } else if (incrementBy > 0) {
      notHiddenIndexes = renderableIndexesCount - renderableIndex;
    }
    return notHiddenIndexes;
  }
  /**
  * The function returns the number of not hidden column indexes that fit between the first and
  * last fixed column in the left (or right in RTL mode) overlay.
  *
  * @returns {number}
  */
  countNotHiddenFixedColumnsStart() {
    const countCols = this.hot.countCols();
    const visualFixedColumnsStart = Math.min(Number(this.settings.fixedColumnsStart) || 0, countCols) - 1;
    return this.countNotHiddenColumnIndexes(visualFixedColumnsStart, -1);
  }
  /**
  * The function returns the number of not hidden row indexes that fit between the first and
  * last fixed row in the top overlay.
  *
  * @returns {number}
  */
  countNotHiddenFixedRowsTop() {
    const countRows = this.hot.countRows();
    const visualFixedRowsTop = Math.min(Number(this.settings.fixedRowsTop) || 0, countRows) - 1;
    return this.countNotHiddenRowIndexes(visualFixedRowsTop, -1);
  }
  /**
  * The function returns the number of not hidden row indexes that fit between the first and
  * last fixed row in the bottom overlay.
  *
  * @returns {number}
  */
  countNotHiddenFixedRowsBottom() {
    const countRows = this.hot.countRows();
    const visualFixedRowsBottom = Math.max(countRows - (Number(this.settings.fixedRowsBottom) || 0), 0);
    return this.countNotHiddenRowIndexes(visualFixedRowsBottom, 1);
  }
  /**
  * The function returns the number of renderable column indexes within the passed range of the visual indexes.
  *
  * @param {number} columnStart The column visual start index.
  * @param {number} columnEnd The column visual end index.
  * @returns {number}
  */
  countRenderableColumnsInRange(columnStart, columnEnd) {
    let count = 0;
    for (let column = columnStart; column <= columnEnd; column++) {
      if (this.hot.columnIndexMapper.getRenderableFromVisualIndex(column) !== null) {
        count += 1;
      }
    }
    return count;
  }
  /**
  * The function returns the number of renderable row indexes within the passed range of the visual indexes.
  *
  * @param {number} rowStart The row visual start index.
  * @param {number} rowEnd The row visual end index.
  * @returns {number}
  */
  countRenderableRowsInRange(rowStart, rowEnd) {
    let count = 0;
    for (let row = rowStart; row <= rowEnd; row++) {
      if (this.hot.rowIndexMapper.getRenderableFromVisualIndex(row) !== null) {
        count += 1;
      }
    }
    return count;
  }
  /**
  * Checks if at least one cell than belongs to the main table is not covered by the top, left or
  * bottom overlay.
  *
  * @returns {boolean}
  */
  isMainTableNotFullyCoveredByOverlays() {
    const fixedAllRows = this.countNotHiddenFixedRowsTop() + this.countNotHiddenFixedRowsBottom();
    const fixedAllColumns = this.countNotHiddenFixedColumnsStart();
    return this.hot.countRenderedRows() > fixedAllRows && this.hot.countRenderedCols() > fixedAllColumns;
  }
  /**
  * Defines default configuration and initializes WalkOnTable instance.
  *
  * @private
  */
  initializeWalkontable() {
    const walkontableConfig = {
      ariaTags: this.settings.ariaTags,
      rtlMode: this.hot.isRtl(),
      externalRowCalculator: this.hot.getPlugin("autoRowSize") && this.hot.getPlugin("autoRowSize").isEnabled(),
      table: _class_private_field_get$1h(this, _table),
      isDataViewInstance: () => isRootInstance(this.hot),
      preventOverflow: () => this.settings.preventOverflow,
      preventWheel: () => this.settings.preventWheel,
      viewportColumnRenderingThreshold: () => this.settings.viewportColumnRenderingThreshold,
      viewportRowRenderingThreshold: () => this.settings.viewportRowRenderingThreshold,
      data: (renderableRow, renderableColumn) => {
        const [visualRow, visualCol] = this.translateFromRenderableToVisualIndex(renderableRow, renderableColumn);
        return this.hot.getDataAtCell(visualRow, visualCol);
      },
      totalRows: () => this.countRenderableRows(),
      totalColumns: () => this.countRenderableColumns(),
      // Number of renderable columns for the left overlay.
      fixedColumnsStart: () => this.countNotHiddenFixedColumnsStart(),
      // Number of renderable rows for the top overlay.
      fixedRowsTop: () => this.countNotHiddenFixedRowsTop(),
      // Number of renderable rows for the bottom overlay.
      fixedRowsBottom: () => this.countNotHiddenFixedRowsBottom(),
      // Enable the inline start overlay when conditions are met.
      shouldRenderInlineStartOverlay: () => {
        return (this.settings.fixedColumnsStart ?? 0) > 0 || walkontableConfig.rowHeaders().length > 0;
      },
      // Enable the top overlay when conditions are met.
      shouldRenderTopOverlay: () => {
        return (this.settings.fixedRowsTop ?? 0) > 0 || walkontableConfig.columnHeaders().length > 0;
      },
      // Enable the bottom overlay when conditions are met.
      shouldRenderBottomOverlay: () => {
        return (this.settings.fixedRowsBottom ?? 0) > 0;
      },
      minSpareRows: () => this.settings.minSpareRows,
      renderAllRows: this.settings.renderAllRows,
      renderAllColumns: this.settings.renderAllColumns,
      rowHeaders: () => {
        const headerRenderers = [];
        if (this.hot.hasRowHeaders()) {
          headerRenderers.push((renderableRowIndex, TH) => {
            const visualRowIndex = renderableRowIndex >= 0 ? this.hot.rowIndexMapper.getVisualFromRenderableIndex(renderableRowIndex) : renderableRowIndex;
            this.appendRowHeader(visualRowIndex, TH);
          });
        }
        this.hot.runHooks("afterGetRowHeaderRenderers", headerRenderers);
        _class_private_field_set$1h(this, _rowHeadersCount, headerRenderers.length);
        if (this.hot.getSettings().ariaTags) {
          if (_class_private_method_get$12(this, _getAriaColcount, getAriaColcount).call(this) === this.hot.countCols()) {
            _class_private_method_get$12(this, _updateAriaColcount, updateAriaColcount).call(this, _class_private_field_get$1h(this, _rowHeadersCount));
          }
        }
        return headerRenderers;
      },
      columnHeaders: () => {
        const headerRenderers = [];
        if (this.hot.hasColHeaders()) {
          headerRenderers.push((renderedColumnIndex, TH) => {
            const visualColumnsIndex = renderedColumnIndex >= 0 ? this.hot.columnIndexMapper.getVisualFromRenderableIndex(renderedColumnIndex) : renderedColumnIndex;
            this.appendColHeader(visualColumnsIndex, TH);
          });
        }
        this.hot.runHooks("afterGetColumnHeaderRenderers", headerRenderers);
        _class_private_field_set$1h(this, _columnHeadersCount, headerRenderers.length);
        return headerRenderers;
      },
      columnWidth: (renderedColumnIndex) => {
        const visualIndex = this.hot.columnIndexMapper.getVisualFromRenderableIndex(renderedColumnIndex);
        return this.hot.getColWidth(visualIndex === null ? renderedColumnIndex : visualIndex);
      },
      rowHeight: (renderedRowIndex) => {
        const visualIndex = this.hot.rowIndexMapper.getVisualFromRenderableIndex(renderedRowIndex);
        return this.hot.getRowHeight(visualIndex === null ? renderedRowIndex : visualIndex);
      },
      rowHeightByOverlayName: (renderedRowIndex, overlayType) => {
        const visualIndex = this.hot.rowIndexMapper.getVisualFromRenderableIndex(renderedRowIndex);
        const visualRowIndex = visualIndex === null ? renderedRowIndex : visualIndex;
        return this.hot.runHooks("modifyRowHeightByOverlayName", this.hot.getRowHeight(visualRowIndex), visualRowIndex, overlayType);
      },
      cellRenderer: (renderedRowIndex, renderedColumnIndex, TD) => {
        const [visualRowIndex, visualColumnIndex] = this.translateFromRenderableToVisualIndex(renderedRowIndex, renderedColumnIndex);
        const modifiedCellCoords = this.hot.runHooks("modifyGetCellCoords", visualRowIndex, visualColumnIndex, false, "meta");
        let visualRowToCheck = visualRowIndex;
        let visualColumnToCheck = visualColumnIndex;
        if (Array.isArray(modifiedCellCoords)) {
          [visualRowToCheck, visualColumnToCheck] = modifiedCellCoords;
        }
        const cellProperties = this.hot.getCellMeta(visualRowToCheck, visualColumnToCheck);
        const prop = this.hot.colToProp(visualColumnToCheck);
        let value = this.hot.getDataAtRowProp(visualRowToCheck, prop);
        if (this.hot.hasHook("beforeValueRender")) {
          value = this.hot.runHooks("beforeValueRender", value, cellProperties);
        }
        const renderer = this.hot.getCellRenderer(cellProperties);
        let formattedValue = value;
        if (typeof cellProperties.valueFormatter === "function") {
          formattedValue = cellProperties.valueFormatter(formattedValue, cellProperties);
        } else if (typeof renderer === "function" && "valueFormatter" in renderer) {
          const { valueFormatter: valueFormatter2 } = renderer;
          if (typeof valueFormatter2 === "function") {
            formattedValue = valueFormatter2.call(cellProperties, formattedValue, cellProperties);
          }
        }
        this.hot.runHooks("beforeRenderer", TD, visualRowIndex, visualColumnIndex, prop, value, cellProperties);
        const rendererArgs = [
          this.hot,
          TD,
          visualRowIndex,
          visualColumnIndex,
          prop,
          formattedValue,
          cellProperties
        ];
        renderer(...rendererArgs);
        if (!cellProperties._isBaseRendererCalled) {
          this.hot.getCellRenderer({
            renderer: "base"
          })(...rendererArgs);
        }
        this.hot.runHooks("afterRenderer", TD, visualRowIndex, visualColumnIndex, prop, value, cellProperties);
        cellProperties._isBaseRendererCalled = false;
      },
      selections: this.hot.selection.highlight,
      hideBorderOnMouseDownOver: () => this.settings.fragmentSelection,
      onWindowResize: () => {
        if (this.hot && !this.hot.isDestroyed) {
          this.hot.refreshDimensions();
        }
      },
      onContainerElementResize: () => {
        if (this.hot && !this.hot.isDestroyed && isVisible(this.hot.rootElement)) {
          this.hot.refreshDimensions();
        }
      },
      onCellMouseDown: (event, coords, TD, wt) => {
        const visualCoords = this.translateFromRenderableToVisualCoords(coords);
        const controller = {
          row: false,
          column: false,
          cell: false
        };
        this.hot.listen();
        this.activeWt = wt;
        _class_private_field_set$1h(this, _mouseDown, true);
        _class_private_field_set$1h(this, _mouseDownLastPos, {
          row: event.clientX,
          col: event.clientY
        });
        this.hot.runHooks("beforeOnCellMouseDown", event, visualCoords, TD, controller);
        if (isImmediatePropagationStopped(event)) {
          return;
        }
        handleMouseEvent(event, {
          coords: visualCoords,
          selection: this.hot.selection,
          controller,
          cellCoordsFactory: (row, column) => this.hot._createCellCoords(row, column)
        });
        this.hot.runHooks("afterOnCellMouseDown", event, visualCoords, TD);
        this.activeWt = this._wt;
      },
      onCellContextMenu: (event, coords, TD, wt) => {
        const visualCoords = this.translateFromRenderableToVisualCoords(coords);
        this.activeWt = wt;
        _class_private_field_set$1h(this, _mouseDown, false);
        if (this.hot.selection.isInProgress()) {
          this.hot.selection.finish();
        }
        this.hot.runHooks("beforeOnCellContextMenu", event, visualCoords, TD);
        if (isImmediatePropagationStopped(event)) {
          return;
        }
        this.hot.runHooks("afterOnCellContextMenu", event, visualCoords, TD);
        this.activeWt = this._wt;
      },
      onCellMouseOut: (event, coords, TD, wt) => {
        const visualCoords = this.translateFromRenderableToVisualCoords(coords);
        this.activeWt = wt;
        this.hot.runHooks("beforeOnCellMouseOut", event, visualCoords, TD);
        if (isImmediatePropagationStopped(event)) {
          return;
        }
        this.hot.runHooks("afterOnCellMouseOut", event, visualCoords, TD);
        this.activeWt = this._wt;
      },
      onCellMouseOver: (event, coords, TD, wt) => {
        const visualCoords = this.translateFromRenderableToVisualCoords(coords);
        const controller = {
          row: false,
          column: false,
          cell: false
        };
        this.activeWt = wt;
        this.hot.runHooks("beforeOnCellMouseOver", event, visualCoords, TD, controller);
        if (isImmediatePropagationStopped(event)) {
          return;
        }
        if (_class_private_field_get$1h(this, _mouseDown) && (!_class_private_field_get$1h(this, _mouseDownLastPos) || _class_private_field_get$1h(this, _mouseDownLastPos).row !== event.clientX || _class_private_field_get$1h(this, _mouseDownLastPos).col !== event.clientY)) {
          handleMouseEvent(event, {
            coords: visualCoords,
            selection: this.hot.selection,
            controller,
            cellCoordsFactory: (row, column) => this.hot._createCellCoords(row, column)
          });
        }
        this.hot.runHooks("afterOnCellMouseOver", event, visualCoords, TD);
        this.activeWt = this._wt;
        _class_private_field_set$1h(this, _mouseDownLastPos, null);
      },
      onCellMouseOverOutside: (event, coords, TD, wt) => {
        const visualCoords = this.translateFromRenderableToVisualCoords(coords);
        const controller = {
          row: false,
          column: false,
          cell: false
        };
        this.activeWt = wt;
        this.hot.runHooks("beforeOnCellMouseOverOutside", event, visualCoords, TD, controller);
        if (isImmediatePropagationStopped(event)) {
          return;
        }
        handleMouseEvent(event, {
          coords: visualCoords,
          selection: this.hot.selection,
          controller,
          cellCoordsFactory: (row, column) => this.hot._createCellCoords(row, column)
        });
        this.hot.runHooks("afterOnCellMouseOverOutside", event, visualCoords, TD);
        this.activeWt = this._wt;
        _class_private_field_set$1h(this, _mouseDownLastPos, null);
      },
      onCellMouseUp: (event, coords, TD, wt) => {
        const visualCoords = this.translateFromRenderableToVisualCoords(coords);
        this.activeWt = wt;
        this.hot.runHooks("beforeOnCellMouseUp", event, visualCoords, TD);
        if (isImmediatePropagationStopped(event) || this.hot.isDestroyed) {
          return;
        }
        handleMouseEvent(event, {
          coords: visualCoords,
          selection: this.hot.selection,
          cellRangeMapper: resolveWithInstance(this.hot, "cellRangeMapper")
        });
        this.hot.runHooks("afterOnCellMouseUp", event, visualCoords, TD);
        this.activeWt = this._wt;
      },
      onCellCornerMouseDown: (event) => {
        event.preventDefault();
        this.hot.runHooks("afterOnCellCornerMouseDown", event);
      },
      onCellCornerDblClick: (event) => {
        event.preventDefault();
        this.hot.runHooks("afterOnCellCornerDblClick", event);
      },
      beforeDraw: (force, skipRender) => this.beforeRender(force, skipRender),
      onDraw: (force) => this.afterRender(force),
      onBeforeViewportScrollVertically: (renderableRow, snapping) => {
        const rowMapper = this.hot.rowIndexMapper;
        const areColumnHeadersSelected = renderableRow < 0;
        let visualRow = renderableRow;
        if (!areColumnHeadersSelected) {
          const mappedRow = rowMapper.getVisualFromRenderableIndex(renderableRow);
          if (mappedRow === null) {
            return renderableRow;
          }
          visualRow = mappedRow;
        }
        visualRow = this.hot.runHooks("beforeViewportScrollVertically", visualRow, snapping);
        this.hot.runHooks("beforeViewportScroll");
        if (!areColumnHeadersSelected) {
          return rowMapper.getRenderableFromVisualIndex(visualRow);
        }
        return visualRow;
      },
      onBeforeViewportScrollHorizontally: (renderableColumn, snapping) => {
        const columnMapper = this.hot.columnIndexMapper;
        const areRowHeadersSelected = renderableColumn < 0;
        let visualColumn = renderableColumn;
        if (!areRowHeadersSelected) {
          const mappedColumn = columnMapper.getVisualFromRenderableIndex(renderableColumn);
          if (mappedColumn === null) {
            return renderableColumn;
          }
          visualColumn = mappedColumn;
        }
        visualColumn = this.hot.runHooks("beforeViewportScrollHorizontally", visualColumn, snapping);
        this.hot.runHooks("beforeViewportScroll");
        if (!areRowHeadersSelected) {
          return columnMapper.getRenderableFromVisualIndex(visualColumn);
        }
        return visualColumn;
      },
      onScrollVertically: () => {
        this.hot.runHooks("afterScrollVertically");
        this.hot.runHooks("afterScroll");
      },
      onScrollHorizontally: () => {
        this.hot.runHooks("afterScrollHorizontally");
        this.hot.runHooks("afterScroll");
      },
      onBeforeRemoveCellClassNames: () => this.hot.runHooks("beforeRemoveCellClassNames"),
      onBeforeHighlightingRowHeader: (renderableRow, headerLevel, highlightMeta) => {
        const rowMapper = this.hot.rowIndexMapper;
        const areColumnHeadersSelected = renderableRow < 0;
        let visualRow = renderableRow;
        if (!areColumnHeadersSelected) {
          visualRow = rowMapper.getVisualFromRenderableIndex(renderableRow) ?? renderableRow;
        }
        const newVisualRow = this.hot.runHooks("beforeHighlightingRowHeader", visualRow, headerLevel, highlightMeta);
        if (!areColumnHeadersSelected) {
          return rowMapper.getRenderableFromVisualIndex(rowMapper.getNearestNotHiddenIndex(newVisualRow, 1));
        }
        return newVisualRow;
      },
      onBeforeHighlightingColumnHeader: (renderableColumn, headerLevel, highlightMeta) => {
        const columnMapper = this.hot.columnIndexMapper;
        const areRowHeadersSelected = renderableColumn < 0;
        let visualColumn = renderableColumn;
        if (!areRowHeadersSelected) {
          visualColumn = columnMapper.getVisualFromRenderableIndex(renderableColumn) ?? renderableColumn;
        }
        const newVisualColumn = this.hot.runHooks("beforeHighlightingColumnHeader", visualColumn, headerLevel, highlightMeta);
        if (!areRowHeadersSelected) {
          return columnMapper.getRenderableFromVisualIndex(columnMapper.getNearestNotHiddenIndex(newVisualColumn, 1));
        }
        return newVisualColumn;
      },
      onAfterDrawSelection: (currentRow, currentColumn, layerLevel) => {
        let cornersOfSelection;
        const [visualRowIndex, visualColumnIndex] = this.translateFromRenderableToVisualIndex(currentRow, currentColumn);
        const selectedRange = this.hot.selection.getSelectedRange();
        const selectionRangeSize = selectedRange.size();
        if (selectionRangeSize > 0) {
          const selectionForLayer = selectedRange.peekByIndex(layerLevel ?? 0);
          cornersOfSelection = [
            selectionForLayer.from.row,
            selectionForLayer.from.col,
            selectionForLayer.to.row,
            selectionForLayer.to.col
          ];
        }
        return this.hot.runHooks("afterDrawSelection", visualRowIndex, visualColumnIndex, cornersOfSelection, layerLevel);
      },
      onBeforeDrawBorders: (corners, borderClassName) => {
        const [startRenderableRow, startRenderableColumn, endRenderableRow, endRenderableColumn] = corners;
        const visualCorners = [
          this.hot.rowIndexMapper.getVisualFromRenderableIndex(startRenderableRow),
          this.hot.columnIndexMapper.getVisualFromRenderableIndex(startRenderableColumn),
          this.hot.rowIndexMapper.getVisualFromRenderableIndex(endRenderableRow),
          this.hot.columnIndexMapper.getVisualFromRenderableIndex(endRenderableColumn)
        ];
        return this.hot.runHooks("beforeDrawBorders", visualCorners, borderClassName);
      },
      onBeforeTouchScroll: () => this.hot.runHooks("beforeTouchScroll"),
      onAfterMomentumScroll: () => this.hot.runHooks("afterMomentumScroll"),
      onModifyRowHeaderWidth: (rowHeaderWidth) => this.hot.runHooks("modifyRowHeaderWidth", rowHeaderWidth),
      onModifyGetCellCoords: (renderableRowIndex, renderableColumnIndex, topmost, source) => {
        const rowMapper = this.hot.rowIndexMapper;
        const columnMapper = this.hot.columnIndexMapper;
        const visualColumnIndex = renderableColumnIndex >= 0 ? columnMapper.getVisualFromRenderableIndex(renderableColumnIndex) : renderableColumnIndex;
        const visualRowIndex = renderableRowIndex >= 0 ? rowMapper.getVisualFromRenderableIndex(renderableRowIndex) : renderableRowIndex;
        const visualIndexes = this.hot.runHooks("modifyGetCellCoords", visualRowIndex, visualColumnIndex, topmost, source);
        if (Array.isArray(visualIndexes)) {
          const [visualRowFrom, visualColumnFrom, visualRowTo, visualColumnTo] = visualIndexes;
          return [
            visualRowFrom >= 0 ? rowMapper.getRenderableFromVisualIndex(rowMapper.getNearestNotHiddenIndex(visualRowFrom, 1)) : visualRowFrom,
            visualColumnFrom >= 0 ? columnMapper.getRenderableFromVisualIndex(columnMapper.getNearestNotHiddenIndex(visualColumnFrom, 1)) : visualColumnFrom,
            visualRowTo >= 0 ? rowMapper.getRenderableFromVisualIndex(rowMapper.getNearestNotHiddenIndex(visualRowTo, -1)) : visualRowTo,
            visualColumnTo >= 0 ? columnMapper.getRenderableFromVisualIndex(columnMapper.getNearestNotHiddenIndex(visualColumnTo, -1)) : visualColumnTo
          ];
        }
      },
      onModifyGetCoordsElement: (renderableRowIndex, renderableColumnIndex) => {
        const rowMapper = this.hot.rowIndexMapper;
        const columnMapper = this.hot.columnIndexMapper;
        const visualColumnIndex = renderableColumnIndex >= 0 ? columnMapper.getVisualFromRenderableIndex(renderableColumnIndex) : renderableColumnIndex;
        const visualRowIndex = renderableRowIndex >= 0 ? rowMapper.getVisualFromRenderableIndex(renderableRowIndex) : renderableRowIndex;
        const visualIndexes = this.hot.runHooks("modifyGetCoordsElement", visualRowIndex, visualColumnIndex);
        if (Array.isArray(visualIndexes)) {
          const [visualRow, visualColumn] = visualIndexes;
          return [
            visualRow >= 0 ? rowMapper.getRenderableFromVisualIndex(rowMapper.getNearestNotHiddenIndex(visualRow, 1)) : visualRow,
            visualColumn >= 0 ? columnMapper.getRenderableFromVisualIndex(columnMapper.getNearestNotHiddenIndex(visualColumn, 1)) : visualColumn
          ];
        }
      },
      viewportRowCalculatorOverride: (calc) => {
        const viewportOffset = this.settings.viewportRowRenderingOffset === "auto" ? 1 : this.settings.viewportRowRenderingOffset;
        if ((viewportOffset ?? 0) > 0) {
          const renderableRows = this.countRenderableRows();
          const firstRenderedRow = calc.startRow;
          const lastRenderedRow = calc.endRow;
          calc.startRow = Math.max(firstRenderedRow - (viewportOffset ?? 0), 0);
          calc.endRow = Math.min(lastRenderedRow + (viewportOffset ?? 0), renderableRows - 1);
        }
        this.hot.runHooks("afterViewportRowCalculatorOverride", calc);
      },
      viewportColumnCalculatorOverride: (calc) => {
        const viewportOffset = this.settings.viewportColumnRenderingOffset === "auto" ? 1 : this.settings.viewportColumnRenderingOffset;
        if ((viewportOffset ?? 0) > 0) {
          const renderableColumns = this.countRenderableColumns();
          const firstRenderedColumn = calc.startColumn;
          const lastRenderedColumn = calc.endColumn;
          calc.startColumn = Math.max(firstRenderedColumn - (viewportOffset ?? 0), 0);
          calc.endColumn = Math.min(lastRenderedColumn + (viewportOffset ?? 0), renderableColumns - 1);
        }
        this.hot.runHooks("afterViewportColumnCalculatorOverride", calc);
      },
      rowHeaderWidth: () => this.settings.rowHeaderWidth,
      columnHeaderHeight: () => {
        const columnHeaderHeight = this.hot.runHooks("modifyColumnHeaderHeight");
        return this.settings.columnHeaderHeight || columnHeaderHeight;
      },
      stylesHandler: () => {
        return this.hot.stylesHandler;
      }
    };
    this.hot.runHooks("beforeInitWalkontable", walkontableConfig);
    this._wt = new WalkontableFacade(walkontableConfig);
    this.activeWt = this._wt;
    const spreader = this._wt.wtTable.spreader;
    const { width, height } = this.hot.rootElement.getBoundingClientRect();
    this.setLastSize(width, height);
    this.eventManager.addEventListener(spreader, "mousedown", (event) => {
      if (event.target === spreader && event.which === 3) {
        event.stopPropagation();
      }
    });
    this.eventManager.addEventListener(spreader, "contextmenu", (event) => {
      if (event.target === spreader && event.which === 3) {
        event.stopPropagation();
      }
    });
    this.eventManager.addEventListener(this.hot.rootDocument.documentElement, "click", () => {
      if (this.settings.observeDOMVisibility) {
        if (this._wt.drawInterrupted) {
          this.hot.render();
        }
      }
    });
  }
  /**
  * Checks if it's possible to create text selection in element.
  *
  * @private
  * @param {HTMLElement} el The element to check.
  * @returns {boolean}
  */
  isTextSelectionAllowed(el) {
    if (isInput(el)) {
      return true;
    }
    const isChildOfTableBody = isChildOf(el, this._wt.wtTable.spreader);
    if (this.settings.fragmentSelection === true && isChildOfTableBody) {
      return true;
    }
    const isSingleCell = this.hot.getSelectedRangeActive()?.isSingleCell() ?? false;
    if (this.settings.fragmentSelection === "cell" && isSingleCell && isChildOfTableBody) {
      return true;
    }
    if (!this.settings.fragmentSelection && this.isCellEdited() && isSingleCell) {
      return true;
    }
    return false;
  }
  /**
  * Checks if user's been called mousedown.
  *
  * @private
  * @returns {boolean}
  */
  isMouseDown() {
    return _class_private_field_get$1h(this, _mouseDown);
  }
  /**
  * Checks if active cell is editing.
  *
  * @private
  * @returns {boolean}
  */
  isCellEdited() {
    const activeEditor = this.hot.getActiveEditor();
    return activeEditor?.isOpened();
  }
  /**
  * `beforeDraw` callback.
  *
  * @private
  * @param {boolean} force If `true` rendering was triggered by a change of settings or data or `false` if
  *                        rendering was triggered by scrolling or moving selection.
  * @param {object} skipRender Object with `skipRender` property, if it is set to `true ` the next rendering
  *                            cycle will be skipped.
  */
  beforeRender(force, skipRender) {
    if (force) {
      this.hot.runHooks("beforeViewRender", this.hot.forceFullRender, skipRender);
    }
  }
  /**
  * `afterRender` callback.
  *
  * @private
  * @param {boolean} force If `true` rendering was triggered by a change of settings or data or `false` if
  *                        rendering was triggered by scrolling or moving selection.
  */
  afterRender(force) {
    if (force) {
      this.hot.runHooks("afterViewRender", this.hot.forceFullRender);
    }
  }
  /**
  * Append row header to a TH element.
  *
  * @private
  * @param {number} visualRowIndex The visual row index.
  * @param {HTMLTableHeaderCellElement} TH The table header element.
  */
  appendRowHeader(visualRowIndex, TH) {
    if (TH.firstChild) {
      const container = TH.firstChild;
      if (!hasClass(container, "relative")) {
        empty$1(TH);
        this.appendRowHeader(visualRowIndex, TH);
        return;
      }
      this.updateCellHeader(container.querySelector(".rowHeader"), visualRowIndex, this.hot.getRowHeader);
    } else {
      const { rootDocument, getRowHeader } = this.hot;
      const div2 = rootDocument.createElement("div");
      const span = rootDocument.createElement("span");
      div2.className = "relative";
      span.className = "rowHeader";
      this.updateCellHeader(span, visualRowIndex, getRowHeader);
      div2.appendChild(span);
      TH.appendChild(div2);
    }
    this.hot.runHooks("afterGetRowHeader", visualRowIndex, TH);
  }
  /**
  * Append column header to a TH element.
  *
  * @private
  * @param {number} visualColumnIndex Visual column index.
  * @param {HTMLTableCellElement} TH The table header element.
  * @param {Function} [label] The function that returns the header label.
  * @param {number} [headerLevel=0] The index of header level counting from the top (positive
  *                                 values counting from 0 to N).
  */
  appendColHeader(visualColumnIndex, TH, label = this.hot.getColHeader, headerLevel = 0) {
    const getColumnHeaderClassNames = () => {
      const metaHeaderClassNames = visualColumnIndex >= 0 ? this.hot.getColumnMeta(visualColumnIndex).headerClassName : null;
      if (!metaHeaderClassNames) {
        return [];
      }
      const classes = Array.isArray(metaHeaderClassNames) ? metaHeaderClassNames : metaHeaderClassNames.split(" ");
      return classes.flatMap((cls) => cls.split(" ")).filter((cls) => cls.length > 0);
    };
    if (TH.firstChild) {
      const container = TH.firstChild;
      if (hasClass(container, "relative")) {
        this.updateCellHeader(container.querySelector(".colHeader"), visualColumnIndex, label, headerLevel);
        container.className = "";
        addClass(container, [
          "relative",
          ...getColumnHeaderClassNames()
        ]);
      } else {
        empty$1(TH);
        this.appendColHeader(visualColumnIndex, TH, label, headerLevel);
      }
    } else {
      const { rootDocument } = this.hot;
      const div2 = rootDocument.createElement("div");
      const span = rootDocument.createElement("span");
      const classNames = getColumnHeaderClassNames();
      div2.classList.add("relative", ...classNames);
      span.className = "colHeader";
      if (this.settings.ariaTags) {
        setAttribute(div2, [
          A11Y_PRESENTATION()
        ]);
        setAttribute(span, [
          A11Y_PRESENTATION()
        ]);
      }
      this.updateCellHeader(span, visualColumnIndex, label, headerLevel);
      div2.appendChild(span);
      TH.appendChild(div2);
    }
    this.hot.runHooks("afterGetColHeader", visualColumnIndex, TH, headerLevel);
  }
  /**
  * Updates header cell content.
  *
  * @private
  * @param {HTMLElement} element Element to update.
  * @param {number} index Row index or column index.
  * @param {Function} content Function which should be returns content for this cell.
  * @param {number} [headerLevel=0] The index of header level counting from the top (positive
  *                                 values counting from 0 to N).
  */
  updateCellHeader(element, index2, content, headerLevel = 0) {
    let renderedIndex = index2;
    const parentOverlay = this._wt.wtOverlays.getParentOverlay(element) || this._wt;
    if (element.parentNode) {
      if (hasClass(element, "colHeader")) {
        renderedIndex = parentOverlay.wtTable.columnFilter.sourceToRendered(index2);
      } else if (hasClass(element, "rowHeader")) {
        renderedIndex = parentOverlay.wtTable.rowFilter.sourceToRendered(index2);
      }
    }
    if (renderedIndex > -1) {
      fastInnerHTML(element, String(content(index2, headerLevel)), this.hot.getSettings().sanitizer ?? true, "header", this.hot.rootGridElement ?? void 0);
    } else {
      fastInnerText(element, String.fromCharCode(160));
      addClass(element, "cornerHeader");
    }
  }
  /**
  * Given a element's left (or right in RTL mode) position relative to the viewport, returns maximum
  * element width until the right (or left) edge of the viewport (before scrollbar).
  *
  * @private
  * @param {number} inlineOffset The left (or right in RTL mode) offset.
  * @returns {number}
  */
  maximumVisibleElementWidth(inlineOffset) {
    const workspaceWidth = this._wt.wtViewport.getWorkspaceWidth();
    const maxWidth = workspaceWidth - inlineOffset;
    return maxWidth > 0 ? maxWidth : 0;
  }
  /**
  * Given a element's top position relative to the viewport, returns maximum element height until the bottom
  * edge of the viewport (before scrollbar).
  *
  * @private
  * @param {number} topOffset The top offset.
  * @returns {number}
  */
  maximumVisibleElementHeight(topOffset) {
    const workspaceHeight = this._wt.wtViewport.getWorkspaceHeight();
    const maxHeight = workspaceHeight - topOffset;
    return maxHeight > 0 ? maxHeight : 0;
  }
  /**
  * Sets new dimensions of the container.
  *
  * @param {number} width The table width.
  * @param {number} height The table height.
  */
  setLastSize(width, height) {
    _class_private_field_set$1h(this, _lastWidth, width);
    _class_private_field_set$1h(this, _lastHeight, height);
  }
  /**
  * Returns cached dimensions.
  *
  * @returns {object}
  */
  getLastSize() {
    return {
      width: _class_private_field_get$1h(this, _lastWidth),
      height: _class_private_field_get$1h(this, _lastHeight)
    };
  }
  /**
  * Returns the first rendered row in the DOM (usually is not visible in the table's viewport).
  *
  * @returns {number | null}
  */
  getFirstRenderedVisibleRow() {
    if (!this._wt.wtViewport.rowsRenderCalculator) {
      return null;
    }
    const indexMapper = this.hot.rowIndexMapper;
    const visualRowIndex = indexMapper.getVisualFromRenderableIndex(this._wt.wtTable.getFirstRenderedRow());
    return indexMapper.getNearestNotHiddenIndex(visualRowIndex ?? 0, 1);
  }
  /**
  * Returns the last rendered row in the DOM (usually is not visible in the table's viewport).
  *
  * @returns {number | null}
  */
  getLastRenderedVisibleRow() {
    if (!this._wt.wtViewport.rowsRenderCalculator) {
      return null;
    }
    const indexMapper = this.hot.rowIndexMapper;
    const visualRowIndex = indexMapper.getVisualFromRenderableIndex(this._wt.wtTable.getLastRenderedRow());
    return indexMapper.getNearestNotHiddenIndex(visualRowIndex ?? this.hot.countRows() - 1, -1);
  }
  /**
  * Returns the first rendered column in the DOM (usually is not visible in the table's viewport).
  *
  * @returns {number | null}
  */
  getFirstRenderedVisibleColumn() {
    if (!this._wt.wtViewport.columnsRenderCalculator) {
      return null;
    }
    const indexMapper = this.hot.columnIndexMapper;
    const visualColumnIndex = indexMapper.getVisualFromRenderableIndex(this._wt.wtTable.getFirstRenderedColumn());
    return indexMapper.getNearestNotHiddenIndex(visualColumnIndex ?? 0, 1);
  }
  /**
  * Returns the last rendered column in the DOM (usually is not visible in the table's viewport).
  *
  * @returns {number | null}
  */
  getLastRenderedVisibleColumn() {
    if (!this._wt.wtViewport.columnsRenderCalculator) {
      return null;
    }
    const indexMapper = this.hot.columnIndexMapper;
    const visualColumnIndex = indexMapper.getVisualFromRenderableIndex(this._wt.wtTable.getLastRenderedColumn());
    return indexMapper.getNearestNotHiddenIndex(visualColumnIndex ?? this.hot.countCols() - 1, -1);
  }
  /**
  * Returns the first fully visible row in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getFirstFullyVisibleRow() {
    return this.hot.rowIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getFirstVisibleRow());
  }
  /**
  * Returns the last fully visible row in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getLastFullyVisibleRow() {
    return this.hot.rowIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getLastVisibleRow());
  }
  /**
  * Returns the first fully visible column in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getFirstFullyVisibleColumn() {
    return this.hot.columnIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getFirstVisibleColumn());
  }
  /**
  * Returns the last fully visible column in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getLastFullyVisibleColumn() {
    return this.hot.columnIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getLastVisibleColumn());
  }
  /**
  * Returns the first partially visible row in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getFirstPartiallyVisibleRow() {
    return this.hot.rowIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getFirstPartiallyVisibleRow());
  }
  /**
  * Returns the last partially visible row in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getLastPartiallyVisibleRow() {
    return this.hot.rowIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getLastPartiallyVisibleRow());
  }
  /**
  * Returns the first partially visible column in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getFirstPartiallyVisibleColumn() {
    return this.hot.columnIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getFirstPartiallyVisibleColumn());
  }
  /**
  * Returns the last partially visible column in the table viewport. When the table has overlays the method returns
  * the first row of the master table that is not overlapped by overlay.
  *
  * @returns {number}
  */
  getLastPartiallyVisibleColumn() {
    return this.hot.columnIndexMapper.getVisualFromRenderableIndex(this._wt.wtScroll.getLastPartiallyVisibleColumn());
  }
  /**
  * Returns the total count of the rendered column headers.
  *
  * @returns {number}
  */
  getColumnHeadersCount() {
    return _class_private_field_get$1h(this, _columnHeadersCount);
  }
  /**
  * Returns the total count of the rendered row headers.
  *
  * @returns {number}
  */
  getRowHeadersCount() {
    return _class_private_field_get$1h(this, _rowHeadersCount);
  }
  /**
  * Returns the table's viewport width. When the table has defined the size of the container,
  * and the columns do not fill the entire viewport, the viewport width is equal to the sum of
  * the columns' widths.
  *
  * @returns {number}
  */
  getViewportWidth() {
    return this._wt.wtViewport.getViewportWidth();
  }
  /**
  * Returns the table's total width including the scrollbar width.
  *
  * @returns {number}
  */
  getWorkspaceWidth() {
    return this._wt.wtViewport.getWorkspaceWidth();
  }
  /**
  * Returns the table's viewport height. When the table has defined the size of the container,
  * and the rows do not fill the entire viewport, the viewport height is equal to the sum of
  * the rows' heights.
  *
  * @returns {number}
  */
  getViewportHeight() {
    return this._wt.wtViewport.getViewportHeight();
  }
  /**
  * Returns the table's total height including the scrollbar height.
  *
  * @returns {number}
  */
  getWorkspaceHeight() {
    return this._wt.wtViewport.getWorkspaceHeight();
  }
  /**
  * Checks to what overlay the provided element belongs.
  *
  * @param {HTMLElement} element The DOM element to check.
  * @returns {'master'|'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'}
  */
  getElementOverlayName(element) {
    return (this._wt.wtOverlays.getParentOverlay(element) ?? this._wt).wtTable.name;
  }
  /**
  * Gets the overlay instance by its name.
  *
  * @param {'inline_start'|'top'|'top_inline_start_corner'|'bottom'|'bottom_inline_start_corner'} overlayName The overlay name.
  * @returns {Overlay | null}
  */
  getOverlayByName(overlayName) {
    return this._wt.getOverlayByName(overlayName);
  }
  /**
  * Gets the name of the overlay that currently renders the table. If the method is called out of the render cycle
  * the 'master' name is returned.
  *
  * @returns {string}
  */
  getActiveOverlayName() {
    return this._wt.activeOverlayName;
  }
  /**
  * Checks if the table is visible or not.
  *
  * @returns {boolean}
  */
  isVisible() {
    return this._wt.wtTable.isVisible();
  }
  /**
  * Checks if the table has a horizontal scrollbar.
  *
  * @returns {boolean}
  */
  hasVerticalScroll() {
    return this._wt.wtViewport.hasVerticalScroll();
  }
  /**
  * Checks if the table has a vertical scrollbar.
  *
  * @returns {boolean}
  */
  hasHorizontalScroll() {
    return this._wt.wtViewport.hasHorizontalScroll();
  }
  /**
  * Gets table's width. The returned width is the width of the rendered cells that fit in the
  * current viewport. The value may change depends on the viewport position (scroll position).
  *
  * @returns {boolean}
  */
  getTableWidth() {
    return this._wt.wtTable.getWidth();
  }
  /**
  * Gets table's height. The returned height is the height of the rendered cells that fit in the
  * current viewport. The value may change depends on the viewport position (scroll position).
  *
  * @returns {boolean}
  */
  getTableHeight() {
    return this._wt.wtTable.getHeight();
  }
  /**
  * Gets table's total width. The returned width is the width of all rendered cells (including headers)
  * that can be displayed in the table.
  *
  * @returns {boolean}
  */
  getTotalTableWidth() {
    return this._wt.wtTable.getTotalWidth();
  }
  /**
  * Gets table's total height. The returned height is the height of all rendered cells (including headers)
  * that can be displayed in the table.
  *
  * @returns {boolean}
  */
  getTotalTableHeight() {
    return this._wt.wtTable.getTotalHeight();
  }
  /**
  * Gets the table's offset.
  *
  * @returns {{ left: number, top: number }}
  */
  getTableOffset() {
    return this._wt.wtViewport.getWorkspaceOffset();
  }
  /**
  * Gets the current scroll position of the table.
  *
  * @returns {{ left: number, top: number }} The current scroll position.
  */
  getTableScrollPosition() {
    return {
      left: this._wt.wtTable.holder.scrollLeft,
      top: this._wt.wtTable.holder.scrollTop
    };
  }
  /**
  * Sets the table's scroll position.
  *
  * @param {{ left: number, top: number }} position The scroll position.
  */
  setTableScrollPosition(position) {
    this._wt.wtTable.holder.scrollLeft = position.left;
    this._wt.wtTable.holder.scrollTop = position.top;
  }
  /**
  * Gets the row header width. If there are multiple row headers, the width of
  * the sum of all of them is returned.
  *
  * @returns {number}
  */
  getRowHeaderWidth() {
    return this._wt.wtViewport.getRowHeaderWidth();
  }
  /**
  * Gets the column header height. If there are multiple column headers, the height
  * of the sum of all of them is returned.
  *
  * @returns {number}
  */
  getColumnHeaderHeight() {
    return this._wt.wtViewport.getColumnHeaderHeight();
  }
  /**
  * Checks if the table uses the window as a viewport and if there is a vertical scrollbar.
  *
  * @returns {boolean}
  */
  isVerticallyScrollableByWindow() {
    return this._wt.wtViewport.isVerticallyScrollableByWindow();
  }
  /**
  * Checks if the table uses the window as a viewport and if there is a horizontal scrollbar.
  *
  * @returns {boolean}
  */
  isHorizontallyScrollableByWindow() {
    return this._wt.wtViewport.isHorizontallyScrollableByWindow();
  }
  /**
  * Destroys internal WalkOnTable's instance. Detaches all of the bonded listeners.
  *
  * @private
  */
  destroy() {
    this._wt.destroy();
    this.eventManager.destroy();
  }
  /**
  * @param {Hanstontable} hotInstance Instance of {@link Handsontable}.
  */
  constructor(hotInstance) {
    _class_private_method_init$12(this, _isSyntheticMouseEvent);
    _class_private_method_init$12(this, _getAriaColcount);
    _class_private_method_init$12(this, _updateAriaColcount);
    _class_private_method_init$12(this, _updateScrollbarClassNames);
    _class_private_field_init$1h(this, _columnHeadersCount, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _rowHeadersCount, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _selectionMouseDown, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _mouseDown, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _table, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _lastWidth, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _lastHeight, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _mouseDownLastPos, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _recentTouchEnd, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1h(this, _recentTouchEndTimeout, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1h(this, _columnHeadersCount, 0);
    _class_private_field_set$1h(this, _rowHeadersCount, 0);
    this.postponedAdjustElementsSize = false;
    _class_private_field_set$1h(this, _selectionMouseDown, false);
    _class_private_field_set$1h(this, _mouseDown, false);
    _class_private_field_set$1h(this, _table, null);
    _class_private_field_set$1h(this, _lastWidth, 0);
    _class_private_field_set$1h(this, _lastHeight, 0);
    _class_private_field_set$1h(this, _mouseDownLastPos, null);
    _class_private_field_set$1h(this, _recentTouchEnd, false);
    _class_private_field_set$1h(this, _recentTouchEndTimeout, null);
    this.hot = hotInstance;
    this.eventManager = new EventManager(this.hot);
    this.settings = this.hot.getSettings();
    this.createElements();
    this.registerEvents();
    this.initializeWalkontable();
  }
}
function isSyntheticMouseEvent(event) {
  if (event.sourceCapabilities) {
    return event.sourceCapabilities.firesTouchEvents === true;
  }
  return _class_private_field_get$1h(this, _recentTouchEnd);
}
function getAriaColcount() {
  return parseInt(this.hot.rootElement.getAttribute("aria-colcount") ?? "0", 10);
}
function updateAriaColcount(delta) {
  const colCount = _class_private_method_get$12(this, _getAriaColcount, getAriaColcount).call(this) + delta;
  setAttribute(this.hot.rootElement, [
    A11Y_COLCOUNT(colCount)
  ]);
}
function updateScrollbarClassNames() {
  const rootElement = this.hot.rootElement;
  if (this.hasVerticalScroll()) {
    addClass(rootElement, "htHasScrollY");
  } else {
    removeClass(rootElement, "htHasScrollY");
  }
  if (this.isVerticallyScrollableByWindow()) {
    addClass(rootElement, "htVerticallyScrollableByWindow");
  } else {
    removeClass(rootElement, "htVerticallyScrollableByWindow");
  }
  if (this.hasHorizontalScroll()) {
    addClass(rootElement, "htHasScrollX");
  } else {
    removeClass(rootElement, "htHasScrollX");
  }
  if (this.isHorizontallyScrollableByWindow()) {
    addClass(rootElement, "htHorizontallyScrollableByWindow");
  } else {
    removeClass(rootElement, "htHorizontallyScrollableByWindow");
  }
  if (getScrollbarWidth() === 0) {
    addClass(rootElement, "htScrollbarHidden");
  } else {
    removeClass(rootElement, "htScrollbarHidden");
  }
}
const COLUMN_LABEL_BASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const COLUMN_LABEL_BASE_LENGTH = COLUMN_LABEL_BASE.length;
function spreadsheetColumnLabel(index2) {
  let dividend = index2 + 1;
  let columnLabel = "";
  let modulo;
  while (dividend > 0) {
    modulo = (dividend - 1) % COLUMN_LABEL_BASE_LENGTH;
    columnLabel = String.fromCharCode(65 + modulo) + columnLabel;
    dividend = parseInt(String((dividend - modulo) / COLUMN_LABEL_BASE_LENGTH), 10);
  }
  return columnLabel;
}
function dataRowToChangesArray(dataRow, rowOffset = 0) {
  let dataRows = dataRow;
  const changesArray = [];
  if (!Array.isArray(dataRow) || !Array.isArray(dataRow[0])) {
    dataRows = [
      dataRow
    ];
  }
  dataRows.forEach((row, rowIndex) => {
    if (Array.isArray(row)) {
      row.forEach((value, column) => {
        changesArray.push([
          rowIndex + rowOffset,
          column,
          value
        ]);
      });
    } else {
      Object.keys(row).forEach((propName) => {
        changesArray.push([
          rowIndex + rowOffset,
          propName,
          row[propName]
        ]);
      });
    }
  });
  return changesArray;
}
function hasChangeForCell(changes, visualRow, prop) {
  return changes.some(([changeRow, changeProp]) => changeRow === visualRow && changeProp === prop);
}
function countFirstRowKeys(data) {
  let result = 0;
  if (Array.isArray(data)) {
    if (data[0] && Array.isArray(data[0])) {
      result = data[0].length;
    } else if (data[0] && isObject$1(data[0])) {
      result = deepObjectSize(data[0]);
    }
  }
  return result;
}
function isArrayOfArrays(data) {
  return !!(Array.isArray(data) && data.length && data.every((el) => Array.isArray(el)));
}
function isArrayOfObjects(data) {
  return !!(Array.isArray(data) && data.length && data.every((el) => typeof el === "object" && !Array.isArray(el) && el !== null));
}
function cloneRow(row) {
  if (Array.isArray(row)) {
    return row.slice();
  }
  if (row !== null && typeof row === "object") {
    return {
      ...row
    };
  }
  return row;
}
class IndexMap {
  /**
  * Get full list of values for particular indexes.
  *
  * @param {*} [unused] Unused parameter for TypeScript compatibility.
  * @returns {Array}
  */
  getValues(unused) {
    return this.indexedValues;
  }
  /**
  * Get value for the particular index.
  *
  * @param {number} index Index for which value is got.
  * @returns {T | undefined}
  */
  getValueAtIndex(index2) {
    const values2 = this.indexedValues;
    if (index2 < values2.length) {
      return values2[index2];
    }
  }
  /**
  * Set new values for particular indexes.
  *
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @param {Array} values List of set values.
  */
  setValues(values2) {
    this.indexedValues = values2.slice();
    this.runLocalHooks("change");
  }
  /**
  * Set new value for the particular index.
  *
  * @param {number} index The index.
  * @param {*} value The value to save.
  *
  * Note: Please keep in mind that it is not possible to set value beyond the map (not respecting already set
  * map's size). Please use the `setValues` method when you would like to extend the map.
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @returns {boolean}
  */
  setValueAtIndex(index2, value) {
    if (index2 < this.indexedValues.length) {
      this.indexedValues[index2] = value;
      this.runLocalHooks("change");
      return true;
    }
    return false;
  }
  /**
  * Clear all values to the defaults.
  */
  clear() {
    this.setDefaultValues();
  }
  /**
  * Get length of the index map.
  *
  * @returns {number}
  */
  getLength() {
    return this.getValues().length;
  }
  /**
  * Set default values for elements from `0` to `n`, where `n` is equal to the handled variable.
  *
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @private
  * @param {number} [length] Length of list.
  */
  setDefaultValues(length = this.indexedValues.length) {
    this.indexedValues.length = 0;
    if (isFunction$1(this.initValueOrFn)) {
      rangeEach(0, length - 1, (index2) => this.indexedValues.push(this.initValueOrFn(index2)));
    } else {
      rangeEach(0, length - 1, () => this.indexedValues.push(this.initValueOrFn));
    }
    this.runLocalHooks("change");
  }
  /**
  * Initialize list with default values for particular indexes.
  *
  * @private
  * @param {number} length New length of indexed list.
  * @returns {IndexMap}
  */
  init(length) {
    this.setDefaultValues(length);
    this.runLocalHooks("init");
    return this;
  }
  /**
  * Add values to the list.
  *
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @private
  * @param {number} [insertionIndex] Position inside the list.
  * @param {Array} [insertedIndexes] List of inserted indexes.
  */
  insert(insertionIndex, insertedIndexes) {
    this.runLocalHooks("change");
  }
  /**
  * Remove values from the list.
  *
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @private
  * @param {Array} [removedIndexes] List of removed indexes.
  */
  remove(removedIndexes) {
    this.runLocalHooks("change");
  }
  /**
  * Destroys the Map instance.
  */
  destroy() {
    this.clearLocalHooks();
    this.indexedValues = [];
    this.initValueOrFn = null;
  }
  /**
  * Initializes the index map with an optional default value or factory function applied to each index.
  */
  constructor(initValueOrFn = null) {
    this.indexedValues = [];
    this.initValueOrFn = initValueOrFn;
  }
}
mixin(IndexMap, localHooks);
function getListWithInsertedItems$1(indexedValues, insertionIndex, insertedIndexes, insertedValuesMapping) {
  const firstInsertedIndex = insertedIndexes.length ? insertedIndexes[0] : void 0;
  return [
    ...indexedValues.slice(0, firstInsertedIndex),
    ...insertedIndexes.map((insertedIndex, ordinalNumber) => {
      if (isFunction$1(insertedValuesMapping)) {
        return insertedValuesMapping(insertedIndex, ordinalNumber);
      }
      return insertedValuesMapping;
    }),
    ...firstInsertedIndex === void 0 ? [] : indexedValues.slice(firstInsertedIndex)
  ];
}
function getListWithRemovedItems$1(indexedValues, removedIndexes) {
  return arrayFilter(indexedValues, (_, index2) => removedIndexes.includes(index2) === false);
}
class PhysicalIndexToValueMap extends IndexMap {
  /**
  * Add values to list and reorganize.
  *
  * @private
  * @param {number} insertionIndex Position inside the list.
  * @param {Array} insertedIndexes List of inserted indexes.
  */
  insert(insertionIndex, insertedIndexes) {
    this.indexedValues = getListWithInsertedItems$1(this.indexedValues, insertionIndex, insertedIndexes, this.initValueOrFn);
    super.insert(insertionIndex, insertedIndexes);
  }
  /**
  * Remove values from the list and reorganize.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  remove(removedIndexes) {
    this.indexedValues = getListWithRemovedItems$1(this.indexedValues, removedIndexes);
    super.remove(removedIndexes);
  }
}
class HidingMap extends PhysicalIndexToValueMap {
  /**
  * Get physical indexes which are hidden.
  *
  * Note: Indexes marked as hidden are included in a {@link DataMap}, but aren't rendered.
  *
  * @returns {Array}
  */
  getHiddenIndexes() {
    return arrayReduce(this.getValues(), (indexesList, isHidden, physicalIndex) => {
      if (isHidden) {
        indexesList.push(physicalIndex);
      }
      return indexesList;
    }, []);
  }
  /**
  * Initializes the hiding map with an optional default value, defaulting to `false` (not hidden).
  */
  constructor(initValueOrFn = false) {
    super(initValueOrFn);
  }
}
function getListWithInsertedItems(indexedValues, insertionIndex, insertedIndexes) {
  return [
    ...indexedValues.slice(0, insertionIndex),
    ...insertedIndexes,
    ...indexedValues.slice(insertionIndex)
  ];
}
function getListWithRemovedItems(indexedValues, removedIndexes) {
  return arrayFilter(indexedValues, (index2) => {
    return removedIndexes.includes(index2) === false;
  });
}
function getDecreasedIndexes(indexedValues, removedIndexes) {
  return arrayMap(indexedValues, (index2) => index2 - removedIndexes.filter((removedIndex) => removedIndex < index2).length);
}
function getIncreasedIndexes(indexedValues, insertedIndexes) {
  const firstInsertedIndex = insertedIndexes[0];
  const amountOfIndexes = insertedIndexes.length;
  return arrayMap(indexedValues, (index2) => {
    if (index2 >= firstInsertedIndex) {
      return index2 + amountOfIndexes;
    }
    return index2;
  });
}
class LinkedPhysicalIndexToValueMap extends IndexMap {
  /**
  * Get full list of ordered values for particular indexes.
  *
  * @returns {Array}
  */
  getValues() {
    return this.orderOfIndexes.map((physicalIndex) => this.indexedValues[physicalIndex]);
  }
  /**
  * Set new values for particular indexes. Entries are linked and stored in a certain order.
  *
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @param {Array} values List of set values.
  */
  setValues(values2) {
    this.orderOfIndexes = [
      ...Array(values2.length).keys()
    ];
    super.setValues(values2);
  }
  /**
  * Set value at index and add it to the linked list of entries. Entries are stored in a certain order.
  *
  * Note: Value will be added at the end of the queue.
  *
  * @param {number} index The index.
  * @param {*} value The value to save.
  * @param {number} position Position to which entry will be added.
  *
  * @returns {boolean}
  */
  setValueAtIndex(index2, value, position = this.orderOfIndexes.length) {
    if (index2 < this.indexedValues.length) {
      this.indexedValues[index2] = value;
      if (this.orderOfIndexes.includes(index2) === false) {
        this.orderOfIndexes.splice(position, 0, index2);
      }
      this.runLocalHooks("change");
      return true;
    }
    return false;
  }
  /**
  * Clear value for particular index.
  *
  * @param {number} physicalIndex Physical index.
  */
  clearValue(physicalIndex) {
    this.orderOfIndexes = getListWithRemovedItems(this.orderOfIndexes, [
      physicalIndex
    ]);
    if (isFunction$1(this.initValueOrFn)) {
      super.setValueAtIndex(physicalIndex, this.initValueOrFn(physicalIndex));
    } else {
      super.setValueAtIndex(physicalIndex, this.initValueOrFn);
    }
  }
  /**
  * Get length of the index map.
  *
  * @returns {number}
  */
  getLength() {
    return this.orderOfIndexes.length;
  }
  /**
  * Set default values for elements from `0` to `n`, where `n` is equal to the handled variable.
  *
  * Note: Please keep in mind that `change` hook triggered by the method may not update cache of a collection immediately.
  *
  * @private
  * @param {number} [length] Length of list.
  */
  setDefaultValues(length = this.indexedValues.length) {
    this.orderOfIndexes.length = 0;
    super.setDefaultValues(length);
  }
  /**
  * Add values to list and reorganize. It updates list of indexes related to ordered values.
  *
  * @private
  * @param {number} insertionIndex Position inside the list.
  * @param {Array} insertedIndexes List of inserted indexes.
  */
  insert(insertionIndex, insertedIndexes) {
    this.indexedValues = getListWithInsertedItems$1(this.indexedValues, insertionIndex, insertedIndexes, this.initValueOrFn);
    this.orderOfIndexes = getIncreasedIndexes(this.orderOfIndexes, insertedIndexes);
    super.insert(insertionIndex, insertedIndexes);
  }
  /**
  * Remove values from the list and reorganize. It updates list of indexes related to ordered values.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  remove(removedIndexes) {
    this.indexedValues = getListWithRemovedItems$1(this.indexedValues, removedIndexes);
    this.orderOfIndexes = getListWithRemovedItems(this.orderOfIndexes, removedIndexes);
    this.orderOfIndexes = getDecreasedIndexes(this.orderOfIndexes, removedIndexes);
    super.remove(removedIndexes);
  }
  /**
  * Get every entry containing index and value, respecting order of indexes.
  *
  * @returns {Array}
  */
  getEntries() {
    return this.orderOfIndexes.map((physicalIndex) => [
      physicalIndex,
      this.getValueAtIndex(physicalIndex)
    ]);
  }
  constructor(...args) {
    super(...args), /**
    * Indexes and values corresponding to them (entries) are stored in a certain order.
    *
    * @private
    * @type {Array<number>}
    */
    this.orderOfIndexes = [];
  }
}
class TrimmingMap extends PhysicalIndexToValueMap {
  /**
  * Get physical indexes which are trimmed.
  *
  * Note: Indexes marked as trimmed aren't included in a {@link DataMap} and aren't rendered.
  *
  * @returns {Array}
  */
  getTrimmedIndexes() {
    return arrayReduce(this.getValues(), (indexesList, isTrimmed, physicalIndex) => {
      if (isTrimmed) {
        indexesList.push(physicalIndex);
      }
      return indexesList;
    }, []);
  }
  /**
  * Initializes the trimming map with an optional default value, defaulting to `false` (not trimmed).
  */
  constructor(initValueOrFn = false) {
    super(initValueOrFn);
  }
}
class IndexesSequence extends IndexMap {
  /**
  * Get sequence of physical indexes.
  *
  * @returns {number[]} Physical indexes.
  */
  getValues() {
    return this.indexedValues;
  }
  /**
  * Add values to list and reorganize.
  *
  * @private
  * @param {number} insertionIndex Position inside the list.
  * @param {Array} insertedIndexes List of inserted indexes.
  */
  insert(insertionIndex, insertedIndexes) {
    const listAfterUpdate = getIncreasedIndexes(this.getValues(), insertedIndexes);
    this.indexedValues = getListWithInsertedItems(listAfterUpdate, insertionIndex, insertedIndexes);
    super.insert(insertionIndex, insertedIndexes);
  }
  /**
  * Remove values from the list and reorganize.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  remove(removedIndexes) {
    const listAfterUpdate = getListWithRemovedItems(this.getValues(), removedIndexes);
    this.indexedValues = getDecreasedIndexes(listAfterUpdate, removedIndexes);
    super.remove(removedIndexes);
  }
  /**
  * Initializes the sequence map with an identity function so each index maps to its own physical value.
  */
  constructor() {
    super((index2) => index2);
  }
}
const availableIndexMapTypes = /* @__PURE__ */ new Map([
  [
    "hiding",
    HidingMap
  ],
  [
    "index",
    IndexMap
  ],
  [
    "linkedPhysicalIndexToValue",
    LinkedPhysicalIndexToValueMap
  ],
  [
    "physicalIndexToValue",
    PhysicalIndexToValueMap
  ],
  [
    "trimming",
    TrimmingMap
  ]
]);
function createIndexMap(mapType, initValueOrFn = null) {
  if (!availableIndexMapTypes.has(mapType)) {
    throwWithCause(`The provided map type ("${mapType}") does not exist.`);
  }
  return new (availableIndexMapTypes.get(mapType))(initValueOrFn);
}
class MapCollection {
  /**
  * Register custom index map.
  *
  * @param {string} uniqueName Unique name of the index map.
  * @param {IndexMap} indexMap Index map containing miscellaneous (i.e. Meta data, indexes sequence), updated after remove and insert data actions.
  */
  register(uniqueName, indexMap) {
    if (this.collection.has(uniqueName) === false) {
      this.collection.set(uniqueName, indexMap);
      indexMap.addLocalHook("change", () => this.runLocalHooks("change", indexMap));
    }
  }
  /**
  * Unregister custom index map.
  *
  * @param {string} name Name of the index map.
  */
  unregister(name) {
    const indexMap = this.collection.get(name);
    if (indexMap !== void 0) {
      indexMap.destroy();
      this.collection.delete(name);
      this.runLocalHooks("change", indexMap);
    }
  }
  /**
  * Unregisters and destroys all collected index map instances.
  */
  unregisterAll() {
    this.collection.forEach((_indexMap, name) => this.unregister(name));
    this.collection.clear();
  }
  /**
  * Get index map for the provided name.
  *
  * @param {string} [name] Name of the index map.
  * @returns {Array|IndexMap}
  */
  get(name) {
    if (isUndefined$1(name)) {
      return Array.from(this.collection.values());
    }
    return this.collection.get(name);
  }
  /**
  * Get collection size.
  *
  * @returns {number}
  */
  getLength() {
    return this.collection.size;
  }
  /**
  * Remove some indexes and corresponding mappings and update values of the others within all collection's index maps.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  removeFromEvery(removedIndexes) {
    this.collection.forEach((indexMap) => {
      indexMap.remove(removedIndexes);
    });
  }
  /**
  * Insert new indexes and corresponding mapping and update values of the others all collection's index maps.
  *
  * @private
  * @param {number} insertionIndex Position inside the actual list.
  * @param {Array} insertedIndexes List of inserted indexes.
  */
  insertToEvery(insertionIndex, insertedIndexes) {
    this.collection.forEach((indexMap) => {
      indexMap.insert(insertionIndex, insertedIndexes);
    });
  }
  /**
  * Set default values to index maps within collection.
  *
  * @param {number} length Destination length for all stored maps.
  */
  initEvery(length) {
    this.collection.forEach((indexMap) => {
      indexMap.init(length);
    });
  }
  constructor() {
    this.collection = /* @__PURE__ */ new Map();
  }
}
mixin(MapCollection, localHooks);
class AggregatedCollection extends MapCollection {
  /**
  * Get merged values for all indexes.
  *
  * @param {boolean} [readFromCache=true] Determine if read results from the cache.
  * @returns {Array}
  */
  getMergedValues(readFromCache = true) {
    if (readFromCache === true) {
      return this.mergedValuesCache;
    }
    if (this.getLength() === 0) {
      return [];
    }
    const mapsValuesMatrix = arrayMap(this.get(), (map2) => map2.getValues());
    const indexesValuesMatrix = [];
    const mapsLength = isDefined(mapsValuesMatrix[0]) && mapsValuesMatrix[0].length || 0;
    for (let index2 = 0; index2 < mapsLength; index2 += 1) {
      const valuesForIndex = [];
      for (let mapIndex = 0; mapIndex < this.getLength(); mapIndex += 1) {
        valuesForIndex.push(mapsValuesMatrix[mapIndex][index2]);
      }
      indexesValuesMatrix.push(valuesForIndex);
    }
    return arrayMap(indexesValuesMatrix, this.aggregationFunction);
  }
  /**
  * Get merged value for particular index.
  *
  * @param {number} index Index for which we calculate single result.
  * @param {boolean} [readFromCache=true] Determine if read results from the cache.
  * @returns {*}
  */
  getMergedValueAtIndex(index2, readFromCache) {
    const valueAtIndex = this.getMergedValues(readFromCache)[index2];
    return isDefined(valueAtIndex) ? valueAtIndex : this.fallbackValue;
  }
  /**
  * Rebuild cache for the collection.
  */
  updateCache() {
    this.mergedValuesCache = this.getMergedValues(false);
  }
  /**
  * Initializes the aggregated collection with a function that combines per-index values and a fallback value for indexes with no data.
  */
  constructor(aggregationFunction, fallbackValue) {
    super(), /**
    * List of merged values. Value for each index is calculated using values inside registered maps.
    *
    * @type {Array}
    */
    this.mergedValuesCache = [];
    this.aggregationFunction = aggregationFunction;
    this.fallbackValue = fallbackValue;
  }
}
function _check_private_redeclaration$1u(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1g(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1g(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1g(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1g(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1g(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1g(receiver, descriptor);
}
function _class_private_field_init$1g(obj, privateMap, value) {
  _check_private_redeclaration$1u(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1g(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1g(receiver, privateMap, "set");
  _class_apply_descriptor_set$1g(receiver, descriptor, value);
  return value;
}
var _currentInitialChanges = /* @__PURE__ */ new WeakMap();
class ChangesObserver {
  /**
  * Subscribes to the observer.
  *
  * @param {Function} callback A function that will be called when the new changes will appear.
  * @returns {ChangesObserver}
  */
  subscribe(callback) {
    this.addLocalHook("change", callback);
    this._write(_class_private_field_get$1g(this, _currentInitialChanges));
    return this;
  }
  /**
  * Unsubscribes all subscriptions. After the method call, the observer would not produce
  * any new events.
  *
  * @returns {ChangesObserver}
  */
  unsubscribe() {
    this.runLocalHooks("unsubscribe");
    this.clearLocalHooks();
    return this;
  }
  /**
  * The write method is executed by the ChangesObservable module. The module produces all
  * changes events that are distributed further by the observer.
  *
  * @private
  * @param {object} changes The chunk of changes produced by the ChangesObservable module.
  * @returns {ChangesObserver}
  */
  _write(changes) {
    if (changes.length > 0) {
      this.runLocalHooks("change", changes);
    }
    return this;
  }
  /**
  * The write method is executed by the ChangesObservable module. The module produces initial
  * changes that will be used to notify new subscribers.
  *
  * @private
  * @param {object} initialChanges The chunk of changes produced by the ChangesObservable module.
  */
  _writeInitialChanges(initialChanges) {
    _class_private_field_set$1g(this, _currentInitialChanges, initialChanges);
  }
  constructor() {
    _class_private_field_init$1g(this, _currentInitialChanges, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1g(this, _currentInitialChanges, []);
  }
}
mixin(ChangesObserver, localHooks);
function arrayDiff(baseArray, newArray) {
  const changes = [];
  let i = 0;
  let j = 0;
  for (; i < baseArray.length && j < newArray.length; i++, j++) {
    if (baseArray[i] !== newArray[j]) {
      changes.push({
        op: "replace",
        index: j,
        oldValue: baseArray[i],
        newValue: newArray[j]
      });
    }
  }
  for (; i < newArray.length; i++) {
    changes.push({
      op: "insert",
      index: i,
      oldValue: void 0,
      newValue: newArray[i]
    });
  }
  for (; j < baseArray.length; j++) {
    changes.push({
      op: "remove",
      index: j,
      oldValue: baseArray[j],
      newValue: void 0
    });
  }
  return changes;
}
function _check_private_redeclaration$1t(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1f(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1f(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1f(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1f(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1f(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1f(receiver, descriptor);
}
function _class_private_field_init$1f(obj, privateMap, value) {
  _check_private_redeclaration$1t(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1f(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1f(receiver, privateMap, "set");
  _class_apply_descriptor_set$1f(receiver, descriptor, value);
  return value;
}
var _observers = /* @__PURE__ */ new WeakMap(), _indexMatrix = /* @__PURE__ */ new WeakMap(), _currentIndexState = /* @__PURE__ */ new WeakMap(), _isMatrixIndexesInitialized = /* @__PURE__ */ new WeakMap(), _initialIndexValue = /* @__PURE__ */ new WeakMap();
class ChangesObservable {
  /**
  * Creates and returns a new instance of the ChangesObserver object. The resource
  * allows subscribing to the index changes that during the code running may change.
  * Changes are emitted as an array of the index change. Each change is represented
  * separately as an object with `op`, `index`, `oldValue`, and `newValue` props.
  *
  * For example:
  * ```
  * [
  *   { op: 'replace', index: 1, oldValue: false, newValue: true },
  *   { op: 'replace', index: 3, oldValue: false, newValue: true },
  *   { op: 'insert', index: 4, oldValue: false, newValue: true },
  * ]
  * // or when the new index map changes have less indexes
  * [
  *   { op: 'replace', index: 1, oldValue: false, newValue: true },
  *   { op: 'remove', index: 4, oldValue: false, newValue: true },
  * ]
  * ```
  *
  * @returns {ChangesObserver}
  */
  createObserver() {
    const observer = new ChangesObserver();
    _class_private_field_get$1f(this, _observers).add(observer);
    observer.addLocalHook("unsubscribe", () => {
      _class_private_field_get$1f(this, _observers).delete(observer);
    });
    observer._writeInitialChanges(arrayDiff(_class_private_field_get$1f(this, _indexMatrix), _class_private_field_get$1f(this, _currentIndexState)));
    return observer;
  }
  /**
  * The method is an entry point for triggering new index map changes. Emitting the
  * changes triggers comparing algorithm which compares last saved state with a new
  * state. When there are some differences, the changes are sent to all subscribers.
  *
  * @param {Array} indexesState An array with index map state.
  */
  emit(indexesState) {
    let currentIndexState = _class_private_field_get$1f(this, _currentIndexState);
    if (!_class_private_field_get$1f(this, _isMatrixIndexesInitialized) || _class_private_field_get$1f(this, _indexMatrix).length !== indexesState.length) {
      if (indexesState.length === 0) {
        indexesState = new Array(currentIndexState.length).fill(_class_private_field_get$1f(this, _initialIndexValue));
      } else {
        _class_private_field_set$1f(this, _indexMatrix, new Array(indexesState.length).fill(_class_private_field_get$1f(this, _initialIndexValue)));
      }
      if (!_class_private_field_get$1f(this, _isMatrixIndexesInitialized)) {
        _class_private_field_set$1f(this, _isMatrixIndexesInitialized, true);
        currentIndexState = _class_private_field_get$1f(this, _indexMatrix);
      }
    }
    const changes = arrayDiff(currentIndexState, indexesState);
    _class_private_field_get$1f(this, _observers).forEach((observer) => observer._write(changes));
    _class_private_field_set$1f(this, _currentIndexState, indexesState);
  }
  /**
  * Initializes the observable with an optional initial index value used as the baseline for generating first-time change events.
  */
  constructor({ initialIndexValue } = {}) {
    _class_private_field_init$1f(this, _observers, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1f(this, _indexMatrix, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1f(this, _currentIndexState, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1f(this, _isMatrixIndexesInitialized, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1f(this, _initialIndexValue, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1f(this, _observers, /* @__PURE__ */ new Set());
    _class_private_field_set$1f(this, _indexMatrix, []);
    _class_private_field_set$1f(this, _currentIndexState, []);
    _class_private_field_set$1f(this, _isMatrixIndexesInitialized, false);
    _class_private_field_set$1f(this, _initialIndexValue, false);
    _class_private_field_set$1f(this, _initialIndexValue, initialIndexValue ?? false);
  }
}
function _check_private_redeclaration$1s(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1e(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1e(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1e(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1e(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1e(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1e(receiver, descriptor);
}
function _class_private_field_init$1e(obj, privateMap, value) {
  _check_private_redeclaration$1s(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1e(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1e(receiver, privateMap, "set");
  _class_apply_descriptor_set$1e(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$11(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$11(obj, privateSet) {
  _check_private_redeclaration$1s(obj, privateSet);
  privateSet.add(obj);
}
var _mapObservers = /* @__PURE__ */ new WeakMap(), _dirtyObservedMaps = /* @__PURE__ */ new WeakMap(), _handleObservedMapChange = /* @__PURE__ */ new WeakSet(), _notifyMapObservers = /* @__PURE__ */ new WeakSet(), _flushDirtyObservedMaps = /* @__PURE__ */ new WeakSet();
class IndexMapper {
  /**
  * Suspends the cache update for this map. The method is helpful to group multiple
  * operations, which affects the cache. In this case, the cache will be updated once after
  * calling the `resumeOperations` method.
  */
  suspendOperations() {
    this.isBatched = true;
  }
  /**
  * Resumes the cache update for this map. It recalculates the cache and restores the
  * default behavior where each map modification updates the cache.
  */
  resumeOperations() {
    this.isBatched = false;
    this.updateCache();
    _class_private_method_get$11(this, _flushDirtyObservedMaps, flushDirtyObservedMaps).call(this);
  }
  /**
  * It creates and returns the new instance of the ChangesObserver object. The object
  * allows listening to the index changes that happen while the Handsontable is running.
  *
  * @param {string} indexMapType The index map type which we want to observe.
  *                              Currently, only the 'hiding' index map types are observable.
  * @returns {ChangesObserver}
  */
  createChangesObserver(indexMapType) {
    if (indexMapType !== "hiding") {
      throwWithCause(`Unsupported index map type "${indexMapType}".`);
    }
    return this.hidingChangesObservable.createObserver();
  }
  createAndRegisterIndexMap(indexName, mapType, initValueOrFn) {
    return this.registerMap(indexName, createIndexMap(mapType, initValueOrFn));
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
  * Register map which provide some index mappings. Type of map determining to which collection it will be added.
  *
  * @param {string} uniqueName Name of the index map. It should be unique.
  * @param {IndexMap} indexMap Registered index map updated on items removal and insertion.
  * @returns {IndexMap}
  */
  registerMap(uniqueName, indexMap) {
    if (this.trimmingMapsCollection.get(uniqueName) || this.hidingMapsCollection.get(uniqueName) || this.variousMapsCollection.get(uniqueName)) {
      throwWithCause(`Map with name "${uniqueName}" has been already registered.`);
    }
    if (indexMap instanceof TrimmingMap) {
      this.trimmingMapsCollection.register(uniqueName, indexMap);
    } else if (indexMap instanceof HidingMap) {
      this.hidingMapsCollection.register(uniqueName, indexMap);
    } else {
      this.variousMapsCollection.register(uniqueName, indexMap);
    }
    const numberOfIndexes = this.getNumberOfIndexes();
    if (numberOfIndexes > 0) {
      indexMap.init(numberOfIndexes);
    }
    return indexMap;
  }
  /**
  * Unregister a map with given name.
  *
  * @param {string} name Name of the index map.
  */
  unregisterMap(name) {
    this.trimmingMapsCollection.unregister(name);
    this.hidingMapsCollection.unregister(name);
    this.variousMapsCollection.unregister(name);
  }
  /**
  * Unregisters all collected index map instances from all map collection types.
  */
  unregisterAll() {
    this.trimmingMapsCollection.unregisterAll();
    this.hidingMapsCollection.unregisterAll();
    this.variousMapsCollection.unregisterAll();
  }
  /**
  * Get a physical index corresponding to the given visual index.
  *
  * @param {number} visualIndex Visual index.
  * @returns {number|null} Returns translated index mapped by passed visual index.
  */
  getPhysicalFromVisualIndex(visualIndex) {
    const physicalIndex = this.notTrimmedIndexesCache[visualIndex];
    if (isDefined(physicalIndex)) {
      return physicalIndex;
    }
    return null;
  }
  /**
  * Get a physical index corresponding to the given renderable index.
  *
  * @param {number} renderableIndex Renderable index.
  * @returns {null|number}
  */
  getPhysicalFromRenderableIndex(renderableIndex) {
    const physicalIndex = this.renderablePhysicalIndexesCache[renderableIndex];
    if (isDefined(physicalIndex)) {
      return physicalIndex;
    }
    return null;
  }
  /**
  * Get a visual index corresponding to the given physical index.
  *
  * @param {number} physicalIndex Physical index to search.
  * @returns {number|null} Returns a visual index of the index mapper.
  */
  getVisualFromPhysicalIndex(physicalIndex) {
    const visualIndex = this.fromPhysicalToVisualIndexesCache.get(physicalIndex);
    return visualIndex ?? null;
  }
  /**
  * Get a visual index corresponding to the given renderable index.
  *
  * @param {number} renderableIndex Renderable index.
  * @returns {null|number}
  */
  getVisualFromRenderableIndex(renderableIndex) {
    return this.getVisualFromPhysicalIndex(this.getPhysicalFromRenderableIndex(renderableIndex));
  }
  /**
  * Get a renderable index corresponding to the given visual index.
  *
  * @param {number} visualIndex Visual index.
  * @returns {null|number}
  */
  getRenderableFromVisualIndex(visualIndex) {
    const renderableIndex = this.fromVisualToRenderableIndexesCache.get(visualIndex);
    return renderableIndex ?? null;
  }
  /**
  * Search for the nearest not-hidden row or column.
  *
  * @param {number} fromVisualIndex The visual index of the row or column from which the search starts.<br><br>
  * If the row or column from which the search starts is not hidden, the method simply returns the `fromVisualIndex` number.
  * @param {number} searchDirection The search direction.<br><br>`1`: search from `fromVisualIndex` to the end of the dataset.<br><br>
  * `-1`: search from `fromVisualIndex` to the beginning of the dataset (i.e., to the row or column at visual index `0`).
  * @param {boolean} searchAlsoOtherWayAround `true`: if a search in a first direction failed, try the opposite direction.<br><br>
  * `false`: search in one direction only.
  *
  * @returns {number|null} A visual index of a row or column, or `null`.
  */
  getNearestNotHiddenIndex(fromVisualIndex, searchDirection, searchAlsoOtherWayAround = false) {
    const physicalIndex = this.getPhysicalFromVisualIndex(fromVisualIndex);
    if (physicalIndex === null) {
      return null;
    }
    if (this.fromVisualToRenderableIndexesCache.has(fromVisualIndex)) {
      return fromVisualIndex;
    }
    const visibleIndexes = Array.from(this.fromVisualToRenderableIndexesCache.keys());
    let index2 = -1;
    if (searchDirection > 0) {
      index2 = visibleIndexes.findIndex((visualIndex) => visualIndex !== null && visualIndex > fromVisualIndex);
    } else {
      index2 = visibleIndexes.reverse().findIndex((visualIndex) => visualIndex !== null && visualIndex < fromVisualIndex);
    }
    if (index2 === -1) {
      if (searchAlsoOtherWayAround) {
        return this.getNearestNotHiddenIndex(fromVisualIndex, -searchDirection, false);
      }
      return null;
    }
    return visibleIndexes[index2];
  }
  /**
  * Set default values for all indexes in registered index maps.
  *
  * @param {number} [length] Destination length for all stored index maps.
  */
  initToLength(length = this.getNumberOfIndexes()) {
    this.notTrimmedIndexesCache = [
      ...new Array(length).keys()
    ];
    this.notHiddenIndexesCache = [
      ...new Array(length).keys()
    ];
    this.suspendOperations();
    this.indexesChangeSource = "init";
    this.indexesSequence.init(length);
    this.indexesChangeSource = void 0;
    this.trimmingMapsCollection.initEvery(length);
    this.resumeOperations();
    this.suspendOperations();
    this.hidingMapsCollection.initEvery(length);
    this.variousMapsCollection.initEvery(length);
    this.resumeOperations();
    this.runLocalHooks("init");
  }
  /**
  * Trim/extend the mappers to fit the desired length.
  *
  * @param {number} length New mapper length.
  */
  fitToLength(length) {
    const currentIndexCount = this.getNumberOfIndexes();
    if (length < currentIndexCount) {
      const indexesToBeRemoved = [
        ...Array(this.getNumberOfIndexes() - length).keys()
      ].map((i) => i + length);
      this.removeIndexes(indexesToBeRemoved);
    } else {
      this.insertIndexes(currentIndexCount, length - currentIndexCount);
    }
  }
  /**
  * Get sequence of indexes.
  *
  * @returns {Array} Physical indexes.
  */
  getIndexesSequence() {
    return this.indexesSequence.getValues();
  }
  /**
  * Set completely new indexes sequence.
  *
  * @param {Array} indexes Physical indexes.
  */
  setIndexesSequence(indexes) {
    if (this.indexesChangeSource === void 0) {
      this.indexesChangeSource = "update";
    }
    this.indexesSequence.setValues(indexes);
    if (this.indexesChangeSource === "update") {
      this.indexesChangeSource = void 0;
    }
  }
  /**
  * Get all NOT trimmed indexes.
  *
  * Note: Indexes marked as trimmed aren't included in a {@link DataMap} and aren't rendered.
  *
  * @param {boolean} [readFromCache=true] Determine if read indexes from cache.
  * @returns {Array} List of physical indexes. Index of this native array is a "visual index",
  * value of this native array is a "physical index".
  */
  getNotTrimmedIndexes(readFromCache = true) {
    if (readFromCache === true) {
      return this.notTrimmedIndexesCache;
    }
    const indexesSequence = this.getIndexesSequence();
    return indexesSequence.filter((physicalIndex) => this.isTrimmed(physicalIndex) === false);
  }
  /**
  * Get length of all NOT trimmed indexes.
  *
  * Note: Indexes marked as trimmed aren't included in a {@link DataMap} and aren't rendered.
  *
  * @returns {number}
  */
  getNotTrimmedIndexesLength() {
    return this.getNotTrimmedIndexes().length;
  }
  /**
  * Get all NOT hidden indexes.
  *
  * Note: Indexes marked as hidden are included in a {@link DataMap}, but aren't rendered.
  *
  * @param {boolean} [readFromCache=true] Determine if read indexes from cache.
  * @returns {Array} List of physical indexes. Please keep in mind that index of this native array IS NOT a "visual index".
  */
  getNotHiddenIndexes(readFromCache = true) {
    if (readFromCache === true) {
      return this.notHiddenIndexesCache;
    }
    const indexesSequence = this.getIndexesSequence();
    return indexesSequence.filter((physicalIndex) => this.isHidden(physicalIndex) === false);
  }
  /**
  * Get length of all NOT hidden indexes.
  *
  * Note: Indexes marked as hidden are included in a {@link DataMap}, but aren't rendered.
  *
  * @returns {number}
  */
  getNotHiddenIndexesLength() {
    return this.getNotHiddenIndexes().length;
  }
  /**
  * Get list of physical indexes (respecting the sequence of indexes) which may be rendered (when they are in a viewport).
  *
  * @param {boolean} [readFromCache=true] Determine if read indexes from cache.
  * @returns {Array} List of physical indexes. Index of this native array is a "renderable index",
  * value of this native array is a "physical index".
  */
  getRenderableIndexes(readFromCache = true) {
    if (readFromCache === true) {
      return this.renderablePhysicalIndexesCache;
    }
    const notTrimmedIndexes = this.getNotTrimmedIndexes();
    return notTrimmedIndexes.filter((physicalIndex) => this.isHidden(physicalIndex) === false);
  }
  /**
  * Get length of all NOT trimmed and NOT hidden indexes.
  *
  * @returns {number}
  */
  getRenderableIndexesLength() {
    return this.getRenderableIndexes().length;
  }
  /**
  * Get number of all indexes.
  *
  * @returns {number}
  */
  getNumberOfIndexes() {
    return this.getIndexesSequence().length;
  }
  /**
  * Move indexes in the index mapper.
  *
  * @param {number|Array} movedIndexes Visual index(es) to move.
  * @param {number} finalIndex Visual index being a start index for the moved elements.
  */
  moveIndexes(movedIndexes, finalIndex) {
    if (typeof movedIndexes === "number") {
      movedIndexes = [
        movedIndexes
      ];
    }
    const physicalMovedIndexes = arrayMap(movedIndexes, (visualIndex) => this.getPhysicalFromVisualIndex(visualIndex)).filter((index2) => index2 !== null);
    const notTrimmedIndexesLength = this.getNotTrimmedIndexesLength();
    const movedIndexesLength = movedIndexes.length;
    const notMovedIndexes = getListWithRemovedItems(this.getIndexesSequence(), physicalMovedIndexes);
    const notTrimmedNotMovedItems = notMovedIndexes.filter((index2) => this.isTrimmed(index2) === false);
    let destinationPosition = notMovedIndexes.indexOf(notTrimmedNotMovedItems[notTrimmedNotMovedItems.length - 1]) + 1;
    if (finalIndex + movedIndexesLength < notTrimmedIndexesLength) {
      const physicalIndex = notTrimmedNotMovedItems[finalIndex];
      destinationPosition = notMovedIndexes.indexOf(physicalIndex);
    }
    this.indexesChangeSource = "move";
    this.setIndexesSequence(getListWithInsertedItems(notMovedIndexes, destinationPosition, physicalMovedIndexes));
    this.indexesChangeSource = void 0;
  }
  /**
  * Get whether index is trimmed. Index marked as trimmed isn't included in a {@link DataMap} and isn't rendered.
  *
  * @param {number} physicalIndex Physical index.
  * @returns {boolean}
  */
  isTrimmed(physicalIndex) {
    return this.trimmingMapsCollection.getMergedValueAtIndex(physicalIndex);
  }
  /**
  * Get whether index is hidden. Index marked as hidden is included in a {@link DataMap}, but isn't rendered.
  *
  * @param {number} physicalIndex Physical index.
  * @returns {boolean}
  */
  isHidden(physicalIndex) {
    return this.hidingMapsCollection.getMergedValueAtIndex(physicalIndex);
  }
  /**
  * Insert new indexes and corresponding mapping and update values of the others, for all stored index maps.
  *
  * @private
  * @param {number} firstInsertedVisualIndex First inserted visual index.
  * @param {number} amountOfIndexes Amount of inserted indexes.
  * @param {'start' | 'end'} [mode] Sets where the column is inserted: at the start of the passed index or at the end.
  */
  insertIndexes(firstInsertedVisualIndex, amountOfIndexes, mode = "start") {
    const nthVisibleIndex = this.getNotTrimmedIndexes()[firstInsertedVisualIndex];
    const firstInsertedPhysicalIndex = isDefined(nthVisibleIndex) ? nthVisibleIndex : this.getNumberOfIndexes();
    const visualInsertionIndex = this.getIndexesSequence().includes(nthVisibleIndex) ? this.getIndexesSequence().indexOf(nthVisibleIndex) : this.getNumberOfIndexes();
    const insertedIndexes = arrayMap(new Array(amountOfIndexes).fill(firstInsertedPhysicalIndex), (nextIndex, stepsFromStart) => nextIndex + stepsFromStart);
    this.suspendOperations();
    this.indexesChangeSource = "insert";
    this.indexesSequence.insert(visualInsertionIndex, insertedIndexes);
    this.indexesChangeSource = void 0;
    const modInsertedIndexes = mode === "end" ? insertedIndexes.map((index2) => index2 + 1) : insertedIndexes;
    this.trimmingMapsCollection.insertToEvery(visualInsertionIndex, modInsertedIndexes);
    this.hidingMapsCollection.insertToEvery(visualInsertionIndex, modInsertedIndexes);
    this.variousMapsCollection.insertToEvery(visualInsertionIndex, modInsertedIndexes);
    this.resumeOperations();
  }
  /**
  * Remove some indexes and corresponding mappings and update values of the others, for all stored index maps.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  removeIndexes(removedIndexes) {
    this.suspendOperations();
    this.indexesChangeSource = "remove";
    this.indexesSequence.remove(removedIndexes);
    this.indexesChangeSource = void 0;
    this.trimmingMapsCollection.removeFromEvery(removedIndexes);
    this.hidingMapsCollection.removeFromEvery(removedIndexes);
    this.variousMapsCollection.removeFromEvery(removedIndexes);
    this.resumeOperations();
  }
  /**
  * Registers an observer for batched changes on a specific index map. During batched
  * operations ({@link IndexMapper#suspendOperations}/{@link IndexMapper#resumeOperations}),
  * changes are coalesced and the callback fires once when the batch completes. Outside of
  * batching, the callback fires immediately on each change.
  *
  * Works with maps registered in the various maps collection.
  *
  * @param {IndexMap} map The map instance to observe.
  * @param {Function} callback Called when the observed map's values change (coalesced during batches).
  * @returns {Function} Disposer function that removes the observer.
  */
  observeMapChange(map2, callback) {
    if (map2 instanceof TrimmingMap || map2 instanceof HidingMap) {
      throwWithCause('The "observeMapChange" method does not support trimming or hiding maps.');
    }
    if (!_class_private_field_get$1e(this, _mapObservers).has(map2)) {
      _class_private_field_get$1e(this, _mapObservers).set(map2, /* @__PURE__ */ new Set());
    }
    _class_private_field_get$1e(this, _mapObservers).get(map2).add(callback);
    return () => {
      const callbacks = _class_private_field_get$1e(this, _mapObservers).get(map2);
      if (callbacks) {
        callbacks.delete(callback);
        if (callbacks.size === 0) {
          _class_private_field_get$1e(this, _mapObservers).delete(map2);
        }
      }
    };
  }
  /**
  * Rebuild cache for some indexes. Every action on indexes sequence or indexes skipped in the process of rendering
  * by default reset cache, thus batching some index maps actions is recommended.
  *
  * @private
  * @param {boolean} [force=false] Determine if force cache update.
  */
  updateCache(force = false) {
    const anyCachedIndexChanged = this.indexesSequenceChanged || this.trimmedIndexesChanged || this.hiddenIndexesChanged;
    if (force === true || this.isBatched === false && anyCachedIndexChanged === true) {
      this.trimmingMapsCollection.updateCache();
      this.hidingMapsCollection.updateCache();
      this.notTrimmedIndexesCache = this.getNotTrimmedIndexes(false);
      this.notHiddenIndexesCache = this.getNotHiddenIndexes(false);
      this.renderablePhysicalIndexesCache = this.getRenderableIndexes(false);
      this.cacheFromPhysicalToVisualIndexes();
      this.cacheFromVisualToRenderableIndexes();
      if (this.hiddenIndexesChanged) {
        this.hidingChangesObservable.emit(this.hidingMapsCollection.getMergedValues());
      }
      this.runLocalHooks("cacheUpdated", {
        indexesSequenceChanged: this.indexesSequenceChanged,
        trimmedIndexesChanged: this.trimmedIndexesChanged,
        hiddenIndexesChanged: this.hiddenIndexesChanged
      });
      this.indexesSequenceChanged = false;
      this.trimmedIndexesChanged = false;
      this.hiddenIndexesChanged = false;
    }
  }
  /**
  * Update cache for translations from physical to visual indexes.
  *
  * @private
  */
  cacheFromPhysicalToVisualIndexes() {
    const nrOfNotTrimmedIndexes = this.getNotTrimmedIndexesLength();
    this.fromPhysicalToVisualIndexesCache.clear();
    for (let visualIndex = 0; visualIndex < nrOfNotTrimmedIndexes; visualIndex += 1) {
      const physicalIndex = this.getPhysicalFromVisualIndex(visualIndex);
      this.fromPhysicalToVisualIndexesCache.set(physicalIndex, visualIndex);
    }
  }
  /**
  * Update cache for translations from visual to renderable indexes.
  *
  * @private
  */
  cacheFromVisualToRenderableIndexes() {
    const nrOfRenderableIndexes = this.getRenderableIndexesLength();
    this.fromVisualToRenderableIndexesCache.clear();
    for (let renderableIndex = 0; renderableIndex < nrOfRenderableIndexes; renderableIndex += 1) {
      const physicalIndex = this.getPhysicalFromRenderableIndex(renderableIndex);
      const visualIndex = this.getVisualFromPhysicalIndex(physicalIndex);
      this.fromVisualToRenderableIndexesCache.set(visualIndex, renderableIndex);
    }
  }
  /**
  * Destroys the IndexMapper instance. Clears all registered map observers
  * and unregisters all maps from all collections.
  */
  destroy() {
    _class_private_field_set$1e(this, _mapObservers, /* @__PURE__ */ new WeakMap());
    _class_private_field_get$1e(this, _dirtyObservedMaps).clear();
    this.unregisterAll();
  }
  /**
  * Initializes the IndexMapper by wiring change listeners on the indexes sequence, trimming, and hiding map collections to keep caches up to date.
  */
  constructor() {
    _class_private_method_init$11(this, _handleObservedMapChange);
    _class_private_method_init$11(this, _notifyMapObservers);
    _class_private_method_init$11(this, _flushDirtyObservedMaps);
    _class_private_field_init$1e(this, _mapObservers, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1e(this, _dirtyObservedMaps, {
      writable: true,
      value: void 0
    });
    this.indexesSequence = new IndexesSequence();
    this.trimmingMapsCollection = new AggregatedCollection((valuesForIndex) => valuesForIndex.some((value) => value === true), false);
    this.hidingMapsCollection = new AggregatedCollection((valuesForIndex) => valuesForIndex.some((value) => value === true), false);
    this.variousMapsCollection = new MapCollection();
    this.hidingChangesObservable = new ChangesObservable({
      initialIndexValue: false
    });
    this.notTrimmedIndexesCache = [];
    this.notHiddenIndexesCache = [];
    this.isBatched = false;
    this.indexesSequenceChanged = false;
    this.indexesChangeSource = void 0;
    this.trimmedIndexesChanged = false;
    this.hiddenIndexesChanged = false;
    this.renderablePhysicalIndexesCache = [];
    this.fromPhysicalToVisualIndexesCache = /* @__PURE__ */ new Map();
    this.fromVisualToRenderableIndexesCache = /* @__PURE__ */ new Map();
    _class_private_field_set$1e(this, _mapObservers, /* @__PURE__ */ new WeakMap());
    _class_private_field_set$1e(this, _dirtyObservedMaps, /* @__PURE__ */ new Set());
    this.indexesSequence.addLocalHook("change", () => {
      this.indexesSequenceChanged = true;
      this.updateCache();
      this.runLocalHooks("indexesSequenceChange", this.indexesChangeSource);
      this.runLocalHooks("change", this.indexesSequence, null);
    });
    this.trimmingMapsCollection.addLocalHook("change", (changedMap) => {
      this.trimmedIndexesChanged = true;
      this.updateCache();
      this.runLocalHooks("change", changedMap, this.trimmingMapsCollection);
    });
    this.hidingMapsCollection.addLocalHook("change", (changedMap) => {
      this.hiddenIndexesChanged = true;
      this.updateCache();
      this.runLocalHooks("change", changedMap, this.hidingMapsCollection);
    });
    this.variousMapsCollection.addLocalHook("change", (changedMap) => {
      _class_private_method_get$11(this, _handleObservedMapChange, handleObservedMapChange).call(this, changedMap);
      this.runLocalHooks("change", changedMap, this.variousMapsCollection);
    });
  }
}
function handleObservedMapChange(changedMap) {
  if (_class_private_field_get$1e(this, _mapObservers).has(changedMap)) {
    if (this.isBatched) {
      _class_private_field_get$1e(this, _dirtyObservedMaps).add(changedMap);
    } else {
      _class_private_method_get$11(this, _notifyMapObservers, notifyMapObservers).call(this, changedMap);
    }
  }
}
function notifyMapObservers(map2) {
  const callbacks = _class_private_field_get$1e(this, _mapObservers).get(map2);
  if (callbacks) {
    callbacks.forEach((cb) => cb(map2));
  }
}
function flushDirtyObservedMaps() {
  if (_class_private_field_get$1e(this, _dirtyObservedMaps).size > 0) {
    _class_private_field_get$1e(this, _dirtyObservedMaps).forEach((map2) => _class_private_method_get$11(this, _notifyMapObservers, notifyMapObservers).call(this, map2));
    _class_private_field_get$1e(this, _dirtyObservedMaps).clear();
  }
}
mixin(IndexMapper, localHooks);
function extendNotExistingKeys(target, extension) {
  objectEach(extension, (value, key) => {
    if (isUndefined$1(target[key])) {
      target[key] = value;
    }
  });
  return target;
}
function normalizeLanguageCode(languageCode) {
  const languageCodePattern = /^([a-zA-Z]{2})-([a-zA-Z]{2})$/;
  const partsOfLanguageCode = languageCodePattern.exec(languageCode);
  if (partsOfLanguageCode) {
    return `${partsOfLanguageCode[1].toLowerCase()}-${partsOfLanguageCode[2].toUpperCase()}`;
  }
  return languageCode;
}
function warnUserAboutLanguageRegistration(languageCode) {
  if (isDefined(languageCode)) {
    error(toSingleLine`Language with code "${languageCode}" was not found. You should register particular language\x20
    before using it. Read more about this issue at: https://docs.handsontable.com/i18n/missing-language-code.`);
  }
}
function pluralize(phrasePropositions, pluralForm) {
  const isPluralizable = Array.isArray(phrasePropositions) && Number.isInteger(pluralForm);
  if (isPluralizable) {
    return phrasePropositions[pluralForm];
  }
  return phrasePropositions;
}
function substituteVariables(phrasePropositions, zippedVariablesAndValues) {
  if (Array.isArray(phrasePropositions)) {
    return phrasePropositions.map((phraseProposition) => substituteVariables(phraseProposition, zippedVariablesAndValues));
  }
  return substitute(phrasePropositions, zippedVariablesAndValues);
}
const { register: registerGloballyPhraseFormatter, getValues: getGlobalPhraseFormatters } = staticRegister("phraseFormatters");
function register$2(name, formatterFn) {
  registerGloballyPhraseFormatter(name, formatterFn);
}
function getAll() {
  return getGlobalPhraseFormatters();
}
register$2("pluralize", pluralize);
register$2("substitute", substituteVariables);
const COMMON_NAMESPACE = "Common:";
const OK = `${COMMON_NAMESPACE}ok`;
const CANCEL = `${COMMON_NAMESPACE}cancel`;
const CONTEXT_MENU_ITEMS_NAMESPACE = "ContextMenu:items";
const CM_ALIAS = CONTEXT_MENU_ITEMS_NAMESPACE;
const CONTEXTMENU_ITEMS_NO_ITEMS = `${CM_ALIAS}.noItems`;
const CONTEXTMENU_ITEMS_ROW_ABOVE = `${CM_ALIAS}.insertRowAbove`;
const CONTEXTMENU_ITEMS_ROW_BELOW = `${CM_ALIAS}.insertRowBelow`;
const CONTEXTMENU_ITEMS_INSERT_LEFT = `${CM_ALIAS}.insertColumnOnTheLeft`;
const CONTEXTMENU_ITEMS_INSERT_RIGHT = `${CM_ALIAS}.insertColumnOnTheRight`;
const CONTEXTMENU_ITEMS_REMOVE_ROW = `${CM_ALIAS}.removeRow`;
const CONTEXTMENU_ITEMS_REMOVE_COLUMN = `${CM_ALIAS}.removeColumn`;
const CONTEXTMENU_ITEMS_UNDO = `${CM_ALIAS}.undo`;
const CONTEXTMENU_ITEMS_REDO = `${CM_ALIAS}.redo`;
const CONTEXTMENU_ITEMS_READ_ONLY = `${CM_ALIAS}.readOnly`;
const CONTEXTMENU_ITEMS_CLEAR_COLUMN = `${CM_ALIAS}.clearColumn`;
const CONTEXTMENU_ITEMS_COPY = `${CM_ALIAS}.copy`;
const CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_HEADERS = `${CM_ALIAS}.copyWithHeaders`;
const CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_GROUP_HEADERS = `${CM_ALIAS}.copyWithGroupHeaders`;
const CONTEXTMENU_ITEMS_COPY_COLUMN_HEADERS_ONLY = `${CM_ALIAS}.copyHeadersOnly`;
const CONTEXTMENU_ITEMS_CUT = `${CM_ALIAS}.cut`;
const CONTEXTMENU_ITEMS_EXPORT = `${CM_ALIAS}.export`;
const CONTEXTMENU_ITEMS_EXPORT_FILE_CSV = `${CM_ALIAS}.exportFileCsv`;
const CONTEXTMENU_ITEMS_EXPORT_FILE_XLSX = `${CM_ALIAS}.exportFileXlsx`;
const CONTEXTMENU_ITEMS_FREEZE_COLUMN = `${CM_ALIAS}.freezeColumn`;
const CONTEXTMENU_ITEMS_UNFREEZE_COLUMN = `${CM_ALIAS}.unfreezeColumn`;
const CONTEXTMENU_ITEMS_MERGE_CELLS = `${CM_ALIAS}.mergeCells`;
const CONTEXTMENU_ITEMS_UNMERGE_CELLS = `${CM_ALIAS}.unmergeCells`;
const CONTEXTMENU_ITEMS_ADD_COMMENT = `${CM_ALIAS}.addComment`;
const CONTEXTMENU_ITEMS_EDIT_COMMENT = `${CM_ALIAS}.editComment`;
const CONTEXTMENU_ITEMS_REMOVE_COMMENT = `${CM_ALIAS}.removeComment`;
const CONTEXTMENU_ITEMS_READ_ONLY_COMMENT = `${CM_ALIAS}.readOnlyComment`;
const CONTEXTMENU_ITEMS_ALIGNMENT = `${CM_ALIAS}.align`;
const CONTEXTMENU_ITEMS_ALIGNMENT_LEFT = `${CM_ALIAS}.align.left`;
const CONTEXTMENU_ITEMS_ALIGNMENT_CENTER = `${CM_ALIAS}.align.center`;
const CONTEXTMENU_ITEMS_ALIGNMENT_RIGHT = `${CM_ALIAS}.align.right`;
const CONTEXTMENU_ITEMS_ALIGNMENT_JUSTIFY = `${CM_ALIAS}.align.justify`;
const CONTEXTMENU_ITEMS_ALIGNMENT_TOP = `${CM_ALIAS}.align.top`;
const CONTEXTMENU_ITEMS_ALIGNMENT_MIDDLE = `${CM_ALIAS}.align.middle`;
const CONTEXTMENU_ITEMS_ALIGNMENT_BOTTOM = `${CM_ALIAS}.align.bottom`;
const CONTEXTMENU_ITEMS_BORDERS = `${CM_ALIAS}.borders`;
const CONTEXTMENU_ITEMS_BORDERS_TOP = `${CM_ALIAS}.borders.top`;
const CONTEXTMENU_ITEMS_BORDERS_RIGHT = `${CM_ALIAS}.borders.right`;
const CONTEXTMENU_ITEMS_BORDERS_BOTTOM = `${CM_ALIAS}.borders.bottom`;
const CONTEXTMENU_ITEMS_BORDERS_LEFT = `${CM_ALIAS}.borders.left`;
const CONTEXTMENU_ITEMS_REMOVE_BORDERS = `${CM_ALIAS}.borders.remove`;
const CONTEXTMENU_ITEMS_NESTED_ROWS_INSERT_CHILD = `${CM_ALIAS}.nestedHeaders.insertChildRow`;
const CONTEXTMENU_ITEMS_NESTED_ROWS_DETACH_CHILD = `${CM_ALIAS}.nestedHeaders.detachFromParent`;
const CONTEXTMENU_ITEMS_HIDE_COLUMN = `${CM_ALIAS}.hideColumn`;
const CONTEXTMENU_ITEMS_SHOW_COLUMN = `${CM_ALIAS}.showColumn`;
const CONTEXTMENU_ITEMS_HIDE_ROW = `${CM_ALIAS}.hideRow`;
const CONTEXTMENU_ITEMS_SHOW_ROW = `${CM_ALIAS}.showRow`;
const FILTERS_NAMESPACE = "Filters:";
const FILTERS_CONDITIONS_NAMESPACE = `${FILTERS_NAMESPACE}conditions`;
const FILTERS_CONDITIONS_NONE = `${FILTERS_CONDITIONS_NAMESPACE}.none`;
const FILTERS_CONDITIONS_EMPTY = `${FILTERS_CONDITIONS_NAMESPACE}.isEmpty`;
const FILTERS_CONDITIONS_NOT_EMPTY = `${FILTERS_CONDITIONS_NAMESPACE}.isNotEmpty`;
const FILTERS_CONDITIONS_EQUAL = `${FILTERS_CONDITIONS_NAMESPACE}.isEqualTo`;
const FILTERS_CONDITIONS_NOT_EQUAL = `${FILTERS_CONDITIONS_NAMESPACE}.isNotEqualTo`;
const FILTERS_CONDITIONS_BEGINS_WITH = `${FILTERS_CONDITIONS_NAMESPACE}.beginsWith`;
const FILTERS_CONDITIONS_ENDS_WITH = `${FILTERS_CONDITIONS_NAMESPACE}.endsWith`;
const FILTERS_CONDITIONS_CONTAINS = `${FILTERS_CONDITIONS_NAMESPACE}.contains`;
const FILTERS_CONDITIONS_NOT_CONTAIN = `${FILTERS_CONDITIONS_NAMESPACE}.doesNotContain`;
const FILTERS_CONDITIONS_BY_VALUE = `${FILTERS_CONDITIONS_NAMESPACE}.byValue`;
const FILTERS_CONDITIONS_GREATER_THAN = `${FILTERS_CONDITIONS_NAMESPACE}.greaterThan`;
const FILTERS_CONDITIONS_GREATER_THAN_OR_EQUAL = `${FILTERS_CONDITIONS_NAMESPACE}.greaterThanOrEqualTo`;
const FILTERS_CONDITIONS_LESS_THAN = `${FILTERS_CONDITIONS_NAMESPACE}.lessThan`;
const FILTERS_CONDITIONS_LESS_THAN_OR_EQUAL = `${FILTERS_CONDITIONS_NAMESPACE}.lessThanOrEqualTo`;
const FILTERS_CONDITIONS_BETWEEN = `${FILTERS_CONDITIONS_NAMESPACE}.isBetween`;
const FILTERS_CONDITIONS_NOT_BETWEEN = `${FILTERS_CONDITIONS_NAMESPACE}.isNotBetween`;
const FILTERS_CONDITIONS_AFTER = `${FILTERS_CONDITIONS_NAMESPACE}.after`;
const FILTERS_CONDITIONS_AFTER_OR_EQUAL = `${FILTERS_CONDITIONS_NAMESPACE}.afterOrEqual`;
const FILTERS_CONDITIONS_BEFORE = `${FILTERS_CONDITIONS_NAMESPACE}.before`;
const FILTERS_CONDITIONS_BEFORE_OR_EQUAL = `${FILTERS_CONDITIONS_NAMESPACE}.beforeOrEqual`;
const FILTERS_CONDITIONS_TODAY = `${FILTERS_CONDITIONS_NAMESPACE}.today`;
const FILTERS_CONDITIONS_TOMORROW = `${FILTERS_CONDITIONS_NAMESPACE}.tomorrow`;
const FILTERS_CONDITIONS_YESTERDAY = `${FILTERS_CONDITIONS_NAMESPACE}.yesterday`;
const FILTERS_DIVS_FILTER_BY_CONDITION = `${FILTERS_NAMESPACE}labels.filterByCondition`;
const FILTERS_DIVS_FILTER_BY_VALUE = `${FILTERS_NAMESPACE}labels.filterByValue`;
const FILTERS_LABELS_CONJUNCTION = `${FILTERS_NAMESPACE}labels.conjunction`;
const FILTERS_LABELS_DISJUNCTION = `${FILTERS_NAMESPACE}labels.disjunction`;
const FILTERS_VALUES_BLANK_CELLS = `${FILTERS_NAMESPACE}values.blankCells`;
const FILTERS_BUTTONS_SELECT_ALL = `${FILTERS_NAMESPACE}buttons.selectAll`;
const FILTERS_BUTTONS_CLEAR = `${FILTERS_NAMESPACE}buttons.clear`;
const FILTERS_BUTTONS_OK = `${FILTERS_NAMESPACE}buttons.ok`;
const FILTERS_BUTTONS_CANCEL = `${FILTERS_NAMESPACE}buttons.cancel`;
const FILTERS_BUTTONS_PLACEHOLDER_SEARCH = `${FILTERS_NAMESPACE}buttons.placeholder.search`;
const FILTERS_BUTTONS_PLACEHOLDER_VALUE = `${FILTERS_NAMESPACE}buttons.placeholder.value`;
const FILTERS_BUTTONS_PLACEHOLDER_SECOND_VALUE = `${FILTERS_NAMESPACE}buttons.placeholder.secondValue`;
const PAGINATION_NAMESPACE = "Pagination:";
const PAGINATION_SECTION = `${PAGINATION_NAMESPACE}section.pagination`;
const PAGINATION_PAGE_SIZE_AUTO = `${PAGINATION_NAMESPACE}.pageSize.auto`;
const PAGINATION_PAGE_SIZE_SECTION = `${PAGINATION_NAMESPACE}section.pageSize`;
const PAGINATION_COUNTER_SECTION = `${PAGINATION_NAMESPACE}section.counter`;
const PAGINATION_NAV_SECTION = `${PAGINATION_NAMESPACE}section.navigation`;
const PAGINATION_FIRST_PAGE = `${PAGINATION_NAMESPACE}firstPage`;
const PAGINATION_PREV_PAGE = `${PAGINATION_NAMESPACE}prevPage`;
const PAGINATION_NEXT_PAGE = `${PAGINATION_NAMESPACE}nextPage`;
const PAGINATION_LAST_PAGE = `${PAGINATION_NAMESPACE}lastPage`;
const CHECKBOX_RENDERER_NAMESPACE = "CheckboxRenderer:";
const CHECKBOX_CHECKED = `${CHECKBOX_RENDERER_NAMESPACE}checked`;
const CHECKBOX_UNCHECKED = `${CHECKBOX_RENDERER_NAMESPACE}unchecked`;
const LOADING_NAMESPACE = "Loading:";
const LOADING_TITLE = `${LOADING_NAMESPACE}title`;
const NOTIFICATION_NAMESPACE = "Notification:";
const NOTIFICATION_BUTTONS_CLOSE = `${NOTIFICATION_NAMESPACE}buttons.close`;
const EXPORT_FILE_NAMESPACE = "ExportFile:";
const EXPORT_FILE_DIALOG_TITLE = `${EXPORT_FILE_NAMESPACE}dialog.title`;
const EMPTY_DATA_STATE_NAMESPACE = "EmptyDataState:";
const EMPTY_DATA_STATE_TITLE = `${EMPTY_DATA_STATE_NAMESPACE}title`;
const EMPTY_DATA_STATE_DESCRIPTION = `${EMPTY_DATA_STATE_NAMESPACE}description`;
const EMPTY_DATA_STATE_TITLE_FILTERS = `${EMPTY_DATA_STATE_NAMESPACE}title.filters`;
const EMPTY_DATA_STATE_DESCRIPTION_FILTERS = `${EMPTY_DATA_STATE_NAMESPACE}description.filters`;
const EMPTY_DATA_STATE_BUTTONS_FILTERS_RESET = `${EMPTY_DATA_STATE_NAMESPACE}buttons.filters.reset`;
const EMPTY_DATA_STATE_TITLE_LOADING = `${EMPTY_DATA_STATE_NAMESPACE}title.loading`;
const EMPTY_DATA_STATE_DESCRIPTION_LOADING = `${EMPTY_DATA_STATE_NAMESPACE}description.loading`;
const DATA_PROVIDER_NAMESPACE = "DataProvider:";
const DATA_PROVIDER_ERRORS_FETCH = `${DATA_PROVIDER_NAMESPACE}errors.fetch`;
const DATA_PROVIDER_ERRORS_CREATE = `${DATA_PROVIDER_NAMESPACE}errors.create`;
const DATA_PROVIDER_ERRORS_UPDATE = `${DATA_PROVIDER_NAMESPACE}errors.update`;
const DATA_PROVIDER_ERRORS_REMOVE = `${DATA_PROVIDER_NAMESPACE}errors.remove`;
const DATA_PROVIDER_ERRORS_REQUEST_FAILED = `${DATA_PROVIDER_NAMESPACE}errors.requestFailed`;
const DATA_PROVIDER_BUTTONS_REFETCH = `${DATA_PROVIDER_NAMESPACE}buttons.refetch`;
const dictionaryKeys = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CANCEL,
  CHECKBOX_CHECKED,
  CHECKBOX_RENDERER_NAMESPACE,
  CHECKBOX_UNCHECKED,
  COMMON_NAMESPACE,
  CONTEXTMENU_ITEMS_ADD_COMMENT,
  CONTEXTMENU_ITEMS_ALIGNMENT,
  CONTEXTMENU_ITEMS_ALIGNMENT_BOTTOM,
  CONTEXTMENU_ITEMS_ALIGNMENT_CENTER,
  CONTEXTMENU_ITEMS_ALIGNMENT_JUSTIFY,
  CONTEXTMENU_ITEMS_ALIGNMENT_LEFT,
  CONTEXTMENU_ITEMS_ALIGNMENT_MIDDLE,
  CONTEXTMENU_ITEMS_ALIGNMENT_RIGHT,
  CONTEXTMENU_ITEMS_ALIGNMENT_TOP,
  CONTEXTMENU_ITEMS_BORDERS,
  CONTEXTMENU_ITEMS_BORDERS_BOTTOM,
  CONTEXTMENU_ITEMS_BORDERS_LEFT,
  CONTEXTMENU_ITEMS_BORDERS_RIGHT,
  CONTEXTMENU_ITEMS_BORDERS_TOP,
  CONTEXTMENU_ITEMS_CLEAR_COLUMN,
  CONTEXTMENU_ITEMS_COPY,
  CONTEXTMENU_ITEMS_COPY_COLUMN_HEADERS_ONLY,
  CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_GROUP_HEADERS,
  CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_HEADERS,
  CONTEXTMENU_ITEMS_CUT,
  CONTEXTMENU_ITEMS_EDIT_COMMENT,
  CONTEXTMENU_ITEMS_EXPORT,
  CONTEXTMENU_ITEMS_EXPORT_FILE_CSV,
  CONTEXTMENU_ITEMS_EXPORT_FILE_XLSX,
  CONTEXTMENU_ITEMS_FREEZE_COLUMN,
  CONTEXTMENU_ITEMS_HIDE_COLUMN,
  CONTEXTMENU_ITEMS_HIDE_ROW,
  CONTEXTMENU_ITEMS_INSERT_LEFT,
  CONTEXTMENU_ITEMS_INSERT_RIGHT,
  CONTEXTMENU_ITEMS_MERGE_CELLS,
  CONTEXTMENU_ITEMS_NESTED_ROWS_DETACH_CHILD,
  CONTEXTMENU_ITEMS_NESTED_ROWS_INSERT_CHILD,
  CONTEXTMENU_ITEMS_NO_ITEMS,
  CONTEXTMENU_ITEMS_READ_ONLY,
  CONTEXTMENU_ITEMS_READ_ONLY_COMMENT,
  CONTEXTMENU_ITEMS_REDO,
  CONTEXTMENU_ITEMS_REMOVE_BORDERS,
  CONTEXTMENU_ITEMS_REMOVE_COLUMN,
  CONTEXTMENU_ITEMS_REMOVE_COMMENT,
  CONTEXTMENU_ITEMS_REMOVE_ROW,
  CONTEXTMENU_ITEMS_ROW_ABOVE,
  CONTEXTMENU_ITEMS_ROW_BELOW,
  CONTEXTMENU_ITEMS_SHOW_COLUMN,
  CONTEXTMENU_ITEMS_SHOW_ROW,
  CONTEXTMENU_ITEMS_UNDO,
  CONTEXTMENU_ITEMS_UNFREEZE_COLUMN,
  CONTEXTMENU_ITEMS_UNMERGE_CELLS,
  CONTEXT_MENU_ITEMS_NAMESPACE,
  DATA_PROVIDER_BUTTONS_REFETCH,
  DATA_PROVIDER_ERRORS_CREATE,
  DATA_PROVIDER_ERRORS_FETCH,
  DATA_PROVIDER_ERRORS_REMOVE,
  DATA_PROVIDER_ERRORS_REQUEST_FAILED,
  DATA_PROVIDER_ERRORS_UPDATE,
  DATA_PROVIDER_NAMESPACE,
  EMPTY_DATA_STATE_BUTTONS_FILTERS_RESET,
  EMPTY_DATA_STATE_DESCRIPTION,
  EMPTY_DATA_STATE_DESCRIPTION_FILTERS,
  EMPTY_DATA_STATE_DESCRIPTION_LOADING,
  EMPTY_DATA_STATE_NAMESPACE,
  EMPTY_DATA_STATE_TITLE,
  EMPTY_DATA_STATE_TITLE_FILTERS,
  EMPTY_DATA_STATE_TITLE_LOADING,
  EXPORT_FILE_DIALOG_TITLE,
  EXPORT_FILE_NAMESPACE,
  FILTERS_BUTTONS_CANCEL,
  FILTERS_BUTTONS_CLEAR,
  FILTERS_BUTTONS_OK,
  FILTERS_BUTTONS_PLACEHOLDER_SEARCH,
  FILTERS_BUTTONS_PLACEHOLDER_SECOND_VALUE,
  FILTERS_BUTTONS_PLACEHOLDER_VALUE,
  FILTERS_BUTTONS_SELECT_ALL,
  FILTERS_CONDITIONS_AFTER,
  FILTERS_CONDITIONS_AFTER_OR_EQUAL,
  FILTERS_CONDITIONS_BEFORE,
  FILTERS_CONDITIONS_BEFORE_OR_EQUAL,
  FILTERS_CONDITIONS_BEGINS_WITH,
  FILTERS_CONDITIONS_BETWEEN,
  FILTERS_CONDITIONS_BY_VALUE,
  FILTERS_CONDITIONS_CONTAINS,
  FILTERS_CONDITIONS_EMPTY,
  FILTERS_CONDITIONS_ENDS_WITH,
  FILTERS_CONDITIONS_EQUAL,
  FILTERS_CONDITIONS_GREATER_THAN,
  FILTERS_CONDITIONS_GREATER_THAN_OR_EQUAL,
  FILTERS_CONDITIONS_LESS_THAN,
  FILTERS_CONDITIONS_LESS_THAN_OR_EQUAL,
  FILTERS_CONDITIONS_NAMESPACE,
  FILTERS_CONDITIONS_NONE,
  FILTERS_CONDITIONS_NOT_BETWEEN,
  FILTERS_CONDITIONS_NOT_CONTAIN,
  FILTERS_CONDITIONS_NOT_EMPTY,
  FILTERS_CONDITIONS_NOT_EQUAL,
  FILTERS_CONDITIONS_TODAY,
  FILTERS_CONDITIONS_TOMORROW,
  FILTERS_CONDITIONS_YESTERDAY,
  FILTERS_DIVS_FILTER_BY_CONDITION,
  FILTERS_DIVS_FILTER_BY_VALUE,
  FILTERS_LABELS_CONJUNCTION,
  FILTERS_LABELS_DISJUNCTION,
  FILTERS_NAMESPACE,
  FILTERS_VALUES_BLANK_CELLS,
  LOADING_NAMESPACE,
  LOADING_TITLE,
  NOTIFICATION_BUTTONS_CLOSE,
  NOTIFICATION_NAMESPACE,
  OK,
  PAGINATION_COUNTER_SECTION,
  PAGINATION_FIRST_PAGE,
  PAGINATION_LAST_PAGE,
  PAGINATION_NAMESPACE,
  PAGINATION_NAV_SECTION,
  PAGINATION_NEXT_PAGE,
  PAGINATION_PAGE_SIZE_AUTO,
  PAGINATION_PAGE_SIZE_SECTION,
  PAGINATION_PREV_PAGE,
  PAGINATION_SECTION
}, Symbol.toStringTag, { value: "Module" }));
const dictionary$1 = {
  languageCode: "en-US",
  [OK]: "OK",
  [CANCEL]: "Cancel",
  [CONTEXTMENU_ITEMS_NO_ITEMS]: "No available options",
  [CONTEXTMENU_ITEMS_ROW_ABOVE]: "Insert row above",
  [CONTEXTMENU_ITEMS_ROW_BELOW]: "Insert row below",
  [CONTEXTMENU_ITEMS_INSERT_LEFT]: "Insert column left",
  [CONTEXTMENU_ITEMS_INSERT_RIGHT]: "Insert column right",
  [CONTEXTMENU_ITEMS_REMOVE_ROW]: [
    "Remove row",
    "Remove rows"
  ],
  [CONTEXTMENU_ITEMS_REMOVE_COLUMN]: [
    "Remove column",
    "Remove columns"
  ],
  [CONTEXTMENU_ITEMS_UNDO]: "Undo",
  [CONTEXTMENU_ITEMS_REDO]: "Redo",
  [CONTEXTMENU_ITEMS_READ_ONLY]: "Read only",
  [CONTEXTMENU_ITEMS_CLEAR_COLUMN]: "Clear column",
  [CONTEXTMENU_ITEMS_ALIGNMENT]: "Alignment",
  [CONTEXTMENU_ITEMS_ALIGNMENT_LEFT]: "Left",
  [CONTEXTMENU_ITEMS_ALIGNMENT_CENTER]: "Center",
  [CONTEXTMENU_ITEMS_ALIGNMENT_RIGHT]: "Right",
  [CONTEXTMENU_ITEMS_ALIGNMENT_JUSTIFY]: "Justify",
  [CONTEXTMENU_ITEMS_ALIGNMENT_TOP]: "Top",
  [CONTEXTMENU_ITEMS_ALIGNMENT_MIDDLE]: "Middle",
  [CONTEXTMENU_ITEMS_ALIGNMENT_BOTTOM]: "Bottom",
  [CONTEXTMENU_ITEMS_FREEZE_COLUMN]: "Freeze column",
  [CONTEXTMENU_ITEMS_UNFREEZE_COLUMN]: "Unfreeze column",
  [CONTEXTMENU_ITEMS_BORDERS]: "Borders",
  [CONTEXTMENU_ITEMS_BORDERS_TOP]: "Top",
  [CONTEXTMENU_ITEMS_BORDERS_RIGHT]: "Right",
  [CONTEXTMENU_ITEMS_BORDERS_BOTTOM]: "Bottom",
  [CONTEXTMENU_ITEMS_BORDERS_LEFT]: "Left",
  [CONTEXTMENU_ITEMS_REMOVE_BORDERS]: "Remove border(s)",
  [CONTEXTMENU_ITEMS_ADD_COMMENT]: "Add comment",
  [CONTEXTMENU_ITEMS_EDIT_COMMENT]: "Edit comment",
  [CONTEXTMENU_ITEMS_REMOVE_COMMENT]: "Delete comment",
  [CONTEXTMENU_ITEMS_READ_ONLY_COMMENT]: "Read-only comment",
  [CONTEXTMENU_ITEMS_MERGE_CELLS]: "Merge cells",
  [CONTEXTMENU_ITEMS_UNMERGE_CELLS]: "Unmerge cells",
  [CONTEXTMENU_ITEMS_COPY]: "Copy",
  [CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_HEADERS]: [
    "Copy with header",
    "Copy with headers"
  ],
  [CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_GROUP_HEADERS]: [
    "Copy with group header",
    "Copy with group headers"
  ],
  [CONTEXTMENU_ITEMS_COPY_COLUMN_HEADERS_ONLY]: [
    "Copy header only",
    "Copy headers only"
  ],
  [CONTEXTMENU_ITEMS_CUT]: "Cut",
  [CONTEXTMENU_ITEMS_EXPORT]: "Export",
  [CONTEXTMENU_ITEMS_EXPORT_FILE_CSV]: "To CSV",
  [CONTEXTMENU_ITEMS_EXPORT_FILE_XLSX]: "To Excel",
  [EXPORT_FILE_DIALOG_TITLE]: "Exporting…",
  [CONTEXTMENU_ITEMS_NESTED_ROWS_INSERT_CHILD]: "Insert child row",
  [CONTEXTMENU_ITEMS_NESTED_ROWS_DETACH_CHILD]: "Detach from parent",
  [CONTEXTMENU_ITEMS_HIDE_COLUMN]: [
    "Hide column",
    "Hide columns"
  ],
  [CONTEXTMENU_ITEMS_SHOW_COLUMN]: [
    "Show column",
    "Show columns"
  ],
  [CONTEXTMENU_ITEMS_HIDE_ROW]: [
    "Hide row",
    "Hide rows"
  ],
  [CONTEXTMENU_ITEMS_SHOW_ROW]: [
    "Show row",
    "Show rows"
  ],
  [FILTERS_CONDITIONS_NONE]: "None",
  [FILTERS_CONDITIONS_EMPTY]: "Is empty",
  [FILTERS_CONDITIONS_NOT_EMPTY]: "Is not empty",
  [FILTERS_CONDITIONS_EQUAL]: "Is equal to",
  [FILTERS_CONDITIONS_NOT_EQUAL]: "Is not equal to",
  [FILTERS_CONDITIONS_BEGINS_WITH]: "Begins with",
  [FILTERS_CONDITIONS_ENDS_WITH]: "Ends with",
  [FILTERS_CONDITIONS_CONTAINS]: "Contains",
  [FILTERS_CONDITIONS_NOT_CONTAIN]: "Does not contain",
  [FILTERS_CONDITIONS_GREATER_THAN]: "Greater than",
  [FILTERS_CONDITIONS_GREATER_THAN_OR_EQUAL]: "Greater than or equal to",
  [FILTERS_CONDITIONS_LESS_THAN]: "Less than",
  [FILTERS_CONDITIONS_LESS_THAN_OR_EQUAL]: "Less than or equal to",
  [FILTERS_CONDITIONS_BETWEEN]: "Is between",
  [FILTERS_CONDITIONS_NOT_BETWEEN]: "Is not between",
  [FILTERS_CONDITIONS_AFTER]: "After",
  [FILTERS_CONDITIONS_AFTER_OR_EQUAL]: "After or equal to",
  [FILTERS_CONDITIONS_BEFORE]: "Before",
  [FILTERS_CONDITIONS_BEFORE_OR_EQUAL]: "Before or equal to",
  [FILTERS_CONDITIONS_TODAY]: "Today",
  [FILTERS_CONDITIONS_TOMORROW]: "Tomorrow",
  [FILTERS_CONDITIONS_YESTERDAY]: "Yesterday",
  [FILTERS_VALUES_BLANK_CELLS]: "Blank cells",
  [FILTERS_DIVS_FILTER_BY_CONDITION]: "Filter by condition",
  [FILTERS_DIVS_FILTER_BY_VALUE]: "Filter by value",
  [FILTERS_LABELS_CONJUNCTION]: "And",
  [FILTERS_LABELS_DISJUNCTION]: "Or",
  [FILTERS_BUTTONS_SELECT_ALL]: "Select all",
  [FILTERS_BUTTONS_CLEAR]: "Clear",
  [FILTERS_BUTTONS_OK]: "OK",
  [FILTERS_BUTTONS_CANCEL]: "Cancel",
  [FILTERS_BUTTONS_PLACEHOLDER_SEARCH]: "Search",
  [FILTERS_BUTTONS_PLACEHOLDER_VALUE]: "Value",
  [FILTERS_BUTTONS_PLACEHOLDER_SECOND_VALUE]: "Second value",
  [PAGINATION_SECTION]: "Pagination",
  [PAGINATION_PAGE_SIZE_SECTION]: "Page size",
  [PAGINATION_PAGE_SIZE_AUTO]: "Auto",
  [PAGINATION_COUNTER_SECTION]: "[start] - [end] of [total]",
  [PAGINATION_NAV_SECTION]: "Page [currentPage] of [totalPages]",
  [PAGINATION_FIRST_PAGE]: "Go to first page",
  [PAGINATION_PREV_PAGE]: "Go to previous page",
  [PAGINATION_NEXT_PAGE]: "Go to next page",
  [PAGINATION_LAST_PAGE]: "Go to last page",
  [CHECKBOX_CHECKED]: "Checked",
  [CHECKBOX_UNCHECKED]: "Unchecked",
  [LOADING_TITLE]: "Loading...",
  [NOTIFICATION_BUTTONS_CLOSE]: "Close",
  [EMPTY_DATA_STATE_TITLE]: "No data available",
  [EMPTY_DATA_STATE_DESCRIPTION]: "There’s nothing to display yet.",
  [EMPTY_DATA_STATE_TITLE_FILTERS]: "No results found",
  [EMPTY_DATA_STATE_DESCRIPTION_FILTERS]: "It looks like your current filters are hiding all results.",
  [EMPTY_DATA_STATE_BUTTONS_FILTERS_RESET]: "Reset filters",
  [EMPTY_DATA_STATE_TITLE_LOADING]: "Loading data",
  [EMPTY_DATA_STATE_DESCRIPTION_LOADING]: "Please wait.",
  [DATA_PROVIDER_ERRORS_FETCH]: "Could not load data",
  [DATA_PROVIDER_ERRORS_CREATE]: "Could not create rows",
  [DATA_PROVIDER_ERRORS_UPDATE]: "Could not update rows",
  [DATA_PROVIDER_ERRORS_REMOVE]: "Could not remove rows",
  [DATA_PROVIDER_ERRORS_REQUEST_FAILED]: "Request failed",
  [DATA_PROVIDER_BUTTONS_REFETCH]: "Refetch"
};
const DEFAULT_LANGUAGE_CODE = dictionary$1.languageCode;
const { register: registerGloballyLanguageDictionary, getItem: getGlobalLanguageDictionary, hasItem: hasGlobalLanguageDictionary, getValues: getGlobalLanguagesDictionaries } = staticRegister("languagesDictionaries");
registerLanguageDictionary(dictionary$1);
function registerLanguageDictionary(languageCodeOrDictionary, dictionary2) {
  let languageCode = languageCodeOrDictionary;
  let dictionaryObject = dictionary2;
  if (isObject$1(languageCodeOrDictionary)) {
    dictionaryObject = languageCodeOrDictionary;
    languageCode = String(dictionaryObject.languageCode);
  }
  extendLanguageDictionary(languageCode, dictionaryObject);
  registerGloballyLanguageDictionary(languageCode, deepClone(dictionaryObject));
  return deepClone(dictionaryObject);
}
function extendLanguageDictionary(languageCode, dictionary2) {
  if (languageCode !== DEFAULT_LANGUAGE_CODE) {
    extendNotExistingKeys(dictionary2, getGlobalLanguageDictionary(DEFAULT_LANGUAGE_CODE));
  }
}
function getLanguageDictionary(languageCode) {
  if (!hasLanguageDictionary(languageCode)) {
    return null;
  }
  return deepClone(getGlobalLanguageDictionary(languageCode));
}
function hasLanguageDictionary(languageCode) {
  return hasGlobalLanguageDictionary(languageCode);
}
function getLanguagesDictionaries() {
  return getGlobalLanguagesDictionaries();
}
function getTranslatedPhrase(languageCode, dictionaryKey, argumentsForFormatters) {
  const languageDictionary = getLanguageDictionary(languageCode);
  if (languageDictionary === null) {
    return null;
  }
  const phrasePropositions = languageDictionary[dictionaryKey];
  if (isUndefined$1(phrasePropositions)) {
    return null;
  }
  const formattedPhrase = getFormattedPhrase(phrasePropositions, argumentsForFormatters);
  if (Array.isArray(formattedPhrase)) {
    return formattedPhrase[0];
  }
  return formattedPhrase;
}
function getFormattedPhrase(phrasePropositions, argumentsForFormatters) {
  return getAll().reduce((phrase, formatter) => {
    return formatter(phrase, argumentsForFormatters);
  }, phrasePropositions);
}
function getValidLanguageCode(languageCode) {
  let normalizedLanguageCode = normalizeLanguageCode(languageCode);
  if (!hasLanguageDictionary(normalizedLanguageCode)) {
    normalizedLanguageCode = DEFAULT_LANGUAGE_CODE;
    warnUserAboutLanguageRegistration(languageCode);
  }
  return normalizedLanguageCode;
}
class VisualSelection extends Selection$1 {
  /**
  * Adds a cell coords to the selection.
  *
  * @param {CellCoords} coords Visual coordinates of a cell.
  * @returns {VisualSelection}
  */
  add(coords) {
    if (this.visualCellRange === null) {
      this.visualCellRange = this.settings.createCellRange(coords);
    } else {
      this.visualCellRange.expand(coords);
    }
    return this;
  }
  /**
  * Clears visual and renderable selection.
  *
  * @returns {VisualSelection}
  */
  clear() {
    this.visualCellRange = null;
    return super.clear();
  }
  /**
  * Trims the passed cell range object by removing all coordinates that points to the hidden rows
  * or columns. The result is a new cell range object that points only to the visible indexes or `null`.
  *
  * @private
  * @param {CellRange} cellRange Cells range object to be trimmed.
  * @returns {CellRange} Visual non-hidden cells range coordinates.
  */
  trimToVisibleCellsRangeOnly(cellRange) {
    const { from, to } = cellRange;
    const rowDirection = cellRange.getVerticalDirection() === "N-S" ? 1 : -1;
    const columnDirection = cellRange.getInlineDirection() === "start-end" ? 1 : -1;
    const visibleFromCoords = this.getNearestNotHiddenCoords(from, rowDirection, columnDirection);
    const visibleToCoords = this.getNearestNotHiddenCoords(to, -rowDirection, -columnDirection);
    if (visibleFromCoords === null || visibleToCoords === null) {
      return null;
    }
    const fromRow = visibleFromCoords.row ?? 0;
    const toRow = visibleToCoords.row ?? 0;
    const fromCol = visibleFromCoords.col ?? 0;
    const toCol = visibleToCoords.col ?? 0;
    const rowCrossed = rowDirection === 1 && fromRow > toRow || rowDirection === -1 && fromRow < toRow;
    const colCrossed = columnDirection === 1 && fromCol > toCol || columnDirection === -1 && fromCol < toCol;
    if (rowCrossed || colCrossed) {
      return null;
    }
    return this.settings.createCellRange(visibleFromCoords, visibleFromCoords, visibleToCoords);
  }
  /**
  * Gets nearest coordinates that points to the visible row and column indexes. If there are no visible
  * rows and/or columns the `null` value is returned.
  *
  * @private
  * @param {CellCoords} coords The coords object as starting point for finding the nearest visible coordinates.
  * @param {1|-1} rowSearchDirection The search direction. For value 1, it means searching from top to bottom for
  *                                  rows and from left to right for columns. For -1, it is the other way around.
  * @param {1|-1} columnSearchDirection The same as above but for rows.
  * @returns {CellCoords|null} Visual cell coordinates.
  */
  getNearestNotHiddenCoords(coords, rowSearchDirection, columnSearchDirection = rowSearchDirection) {
    if (coords.row === null || coords.col === null) {
      return null;
    }
    const nextVisibleRow = this.getNearestNotHiddenIndex(this.settings.rowIndexMapper, coords.row, rowSearchDirection);
    if (nextVisibleRow === null) {
      return null;
    }
    const nextVisibleColumn = this.getNearestNotHiddenIndex(this.settings.columnIndexMapper, coords.col, columnSearchDirection);
    if (nextVisibleColumn === null) {
      return null;
    }
    return this.settings.createCellCoords(nextVisibleRow, nextVisibleColumn);
  }
  /**
  * Gets nearest visual index. If there are no visible rows or columns the `null` value is returned.
  *
  * @private
  * @param {IndexMapper} indexMapper The IndexMapper instance for specific axis.
  * @param {number} visualIndex The index as starting point for finding the nearest visible index.
  * @param {1|-1} searchDirection The search direction. For value 1, it means searching from top to bottom for
  *                               rows and from left to right for columns. For -1, it is the other way around.
  * @returns {number|null} Visual row/column index.
  */
  getNearestNotHiddenIndex(indexMapper, visualIndex, searchDirection) {
    if (visualIndex < 0) {
      return visualIndex;
    }
    return indexMapper.getNearestNotHiddenIndex(visualIndex, searchDirection);
  }
  /**
  * Override internally stored visual indexes added by the Selection's `add` function. It should be executed
  * at the end of process of adding visual selection coordinates.
  *
  * @returns {VisualSelection}
  */
  commit() {
    if (this.visualCellRange === null) {
      return this;
    }
    const trimmedCellRange = this.trimToVisibleCellsRangeOnly(this.visualCellRange);
    if (trimmedCellRange === null) {
      this.cellRange = null;
    } else {
      this.cellRange = this.createRenderableCellRange(trimmedCellRange.from, trimmedCellRange.to);
    }
    return this;
  }
  /**
  * Some selection may be a part of broader cell range. This function sync coordinates of current selection
  * and the broader cell range when needed (current selection can't be presented visually).
  *
  * @param {CellRange} broaderCellRange Visual range. Actual cell range may be contained in the broader cell range.
  * When there is no way to represent some cell range visually we try to find range containing just the first visible cell.
  *
  * Warn: Please keep in mind that this function may change coordinates of the handled broader range.
  *
  * @returns {VisualSelection}
  */
  syncWith(broaderCellRange) {
    const coordsFrom = broaderCellRange.from.clone().normalize();
    const rowDirection = broaderCellRange.getVerticalDirection() === "N-S" ? 1 : -1;
    const columnDirection = broaderCellRange.getHorizontalDirection() === "W-E" ? 1 : -1;
    const renderableHighlight = this.visualCellRange ? this.settings.visualToRenderableCoords(this.visualCellRange.highlight) : null;
    let cellCoordsVisual = null;
    if (renderableHighlight === null || renderableHighlight.col === null || renderableHighlight.row === null) {
      cellCoordsVisual = this.getNearestNotHiddenCoords(coordsFrom, rowDirection, columnDirection);
    }
    if (cellCoordsVisual !== null && broaderCellRange.includes(cellCoordsVisual)) {
      const currentHighlight = broaderCellRange.highlight.clone();
      if ((currentHighlight.row ?? -1) >= 0) {
        currentHighlight.row = cellCoordsVisual.row;
      }
      if ((currentHighlight.col ?? -1) >= 0) {
        currentHighlight.col = cellCoordsVisual.col;
      }
      if (this.cellRange === null) {
        const cellCoordsRenderable = this.settings.visualToRenderableCoords(currentHighlight);
        this.cellRange = this.settings.createCellRange(cellCoordsRenderable);
      }
      broaderCellRange.setHighlight(currentHighlight);
    }
    if (this.settings.selectionType === "focus" && renderableHighlight !== null && cellCoordsVisual === null && this.visualCellRange !== null) {
      broaderCellRange.setHighlight(this.visualCellRange.highlight);
    }
    return this;
  }
  /**
  * Returns the top left (TL) and bottom right (BR) selection coordinates (renderable indexes).
  * The method overwrites the original method to support header selection for hidden cells.
  * To make the header selection working, the CellCoords and CellRange have to support not
  * complete coordinates (`null` values for example, `row: null`, `col: 2`).
  *
  * @returns {Array} Returns array of coordinates for example `[1, 1, 5, 5]`.
  */
  getCorners() {
    const { from, to } = this.cellRange;
    return [
      Math.min(from.row ?? 0, to.row ?? 0),
      Math.min(from.col ?? 0, to.col ?? 0),
      Math.max(from.row ?? 0, to.row ?? 0),
      Math.max(from.col ?? 0, to.col ?? 0)
    ];
  }
  /**
  * Returns the top left (or top right in RTL) and bottom right (or bottom left in RTL) selection
  * coordinates (visual indexes).
  *
  * @returns {Array} Returns array of coordinates for example `[1, 1, 5, 5]`.
  */
  getVisualCorners() {
    const cellRange = this.cellRange;
    const topStart = this.settings.renderableToVisualCoords(cellRange.getTopStartCorner());
    const bottomEnd = this.settings.renderableToVisualCoords(cellRange.getBottomEndCorner());
    return [
      topStart.row,
      topStart.col,
      bottomEnd.row,
      bottomEnd.col
    ];
  }
  /**
  * Creates a new CellRange object based on visual coordinates which before object creation are
  * translated to renderable indexes.
  *
  * @param {CellCoords} visualFromCoords The CellCoords object which contains coordinates that
  *                                      points to the beginning of the selection.
  * @param {CellCoords} visualToCoords The CellCoords object which contains coordinates that
  *                                    points to the end of the selection.
  * @returns {CellRange|null}
  */
  createRenderableCellRange(visualFromCoords, visualToCoords) {
    const renderableFromCoords = this.settings.visualToRenderableCoords(visualFromCoords);
    const renderableToCoords = this.settings.visualToRenderableCoords(visualToCoords);
    if (renderableFromCoords.row === null || renderableFromCoords.col === null || renderableToCoords.row === null || renderableToCoords.col === null) {
      return null;
    }
    return this.settings.createCellRange(renderableFromCoords, renderableFromCoords, renderableToCoords);
  }
  /**
  * Initializes the visual selection with optional settings overrides and an initial visual cell range.
  */
  constructor(settings, visualCellRange) {
    super(settings, null), /**
    * Range of selection visually. Visual representation may have representation in a rendered selection.
    *
    * @type {null|CellRange}
    */
    this.visualCellRange = null;
    this.visualCellRange = visualCellRange || null;
    this.commit();
  }
}
function createHighlight$9({ activeHeaderClassName, ...restOptions }) {
  return new VisualSelection({
    className: activeHeaderClassName,
    ...restOptions,
    selectionType: ACTIVE_HEADER_TYPE
  });
}
function createHighlight$8({ areaCornerVisible, ...restOptions }) {
  return new VisualSelection({
    className: "area",
    createLayers: true,
    border: {
      width: 1,
      color: "#4b89ff",
      cornerVisible: areaCornerVisible
    },
    ...restOptions,
    selectionType: AREA_TYPE
  });
}
function createHighlight$7({ ...restOptions }) {
  return new VisualSelection({
    className: "highlight",
    ...restOptions,
    selectionType: AREA_TYPE
  });
}
function createHighlight$6({ columnClassName, ...restOptions }) {
  return new VisualSelection({
    className: columnClassName,
    ...restOptions,
    selectionType: COLUMN_TYPE
  });
}
function createHighlight$5({ cellCornerVisible, ...restOptions }) {
  return new VisualSelection({
    className: "current",
    headerAttributes: [
      A11Y_SELECTED()
    ],
    border: {
      width: 2,
      color: "#4b89ff",
      cornerVisible: cellCornerVisible
    },
    ...restOptions,
    selectionType: FOCUS_TYPE
  });
}
function createHighlight$4({ border, visualCellRange, ...restOptions }) {
  return new VisualSelection({
    ...border,
    ...restOptions,
    selectionType: CUSTOM_SELECTION_TYPE
  }, visualCellRange);
}
function createHighlight$3({ ...restOptions }) {
  return new VisualSelection({
    className: "fill",
    border: {
      width: 1,
      color: "#ff0000"
    },
    ...restOptions,
    selectionType: FILL_TYPE
  });
}
function createHighlight$2({ headerClassName, ...restOptions }) {
  return new VisualSelection({
    className: headerClassName,
    ...restOptions,
    selectionType: HEADER_TYPE
  });
}
function createHighlight$1({ rowClassName, ...restOptions }) {
  return new VisualSelection({
    className: rowClassName,
    ...restOptions,
    selectionType: ROW_TYPE
  });
}
function _check_private_redeclaration$1r(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$10(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$10(obj, privateSet) {
  _check_private_redeclaration$1r(obj, privateSet);
  privateSet.add(obj);
}
var _createHighlight = /* @__PURE__ */ new WeakSet();
class Highlight {
  /**
  * Check if highlight cell rendering is disabled for specified highlight type.
  *
  * @param {string} highlightType Highlight type. Possible values are: `cell`, `area`, `fill` or `header`.
  * @param {CellCoords} coords The CellCoords instance with defined visual coordinates.
  * @returns {boolean}
  */
  isEnabledFor(highlightType, coords) {
    let type = highlightType;
    if (highlightType === FOCUS_TYPE) {
      type = "current";
    }
    const disabledCellSelection = this.options.disabledCellSelection;
    if (typeof disabledCellSelection !== "function") {
      return true;
    }
    let disableHighlight = disabledCellSelection(coords.row, coords.col);
    if (typeof disableHighlight === "string") {
      disableHighlight = [
        disableHighlight
      ];
    }
    return !disableHighlight || Array.isArray(disableHighlight) && !disableHighlight.includes(type);
  }
  /**
  * Set a new layer level to make access to the desire `area` and `header` highlights.
  *
  * @param {number} [level=0] Layer level to use.
  * @returns {Highlight}
  */
  useLayerLevel(level = 0) {
    this.layerLevel = level;
    return this;
  }
  /**
  * Get Walkontable Selection instance created for controlling highlight of the currently
  * focused cell (or header).
  *
  * @returns {Selection}
  */
  getFocus() {
    return this.focus;
  }
  /**
  * Get Walkontable Selection instance created for controlling highlight of the autofill functionality.
  *
  * @returns {Selection}
  */
  getFill() {
    return this.fill;
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * `area` highlights.
  *
  * @returns {Selection}
  */
  createLayeredArea() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.layeredAreas, createHighlight$8);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the cells.
  *
  * @returns {Selection[]}
  */
  getLayeredAreas() {
    return [
      ...this.layeredAreas.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * `highlight` highlights.
  *
  * @returns {Selection}
  */
  createArea() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.areas, createHighlight$7);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the cells.
  *
  * @returns {Selection[]}
  */
  getAreas() {
    return [
      ...this.areas.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * header highlight for rows.
  *
  * @returns {Selection}
  */
  createRowHeader() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.rowHeaders, createHighlight$2);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the headers.
  *
  * @returns {Selection[]}
  */
  getRowHeaders() {
    return [
      ...this.rowHeaders.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * header highlight for columns.
  *
  * @returns {Selection}
  */
  createColumnHeader() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.columnHeaders, createHighlight$2);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the headers.
  *
  * @returns {Selection[]}
  */
  getColumnHeaders() {
    return [
      ...this.columnHeaders.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * highlight for active row headers.
  *
  * @returns {Selection}
  */
  createActiveRowHeader() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.activeRowHeaders, createHighlight$9);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the active headers.
  *
  * @returns {Selection[]}
  */
  getActiveRowHeaders() {
    return [
      ...this.activeRowHeaders.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * highlight for active column headers.
  *
  * @returns {Selection}
  */
  createActiveColumnHeader() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.activeColumnHeaders, createHighlight$9);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the active headers.
  *
  * @returns {Selection[]}
  */
  getActiveColumnHeaders() {
    return [
      ...this.activeColumnHeaders.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * highlight for the headers corner.
  *
  * @returns {Selection}
  */
  createActiveCornerHeader() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.activeCornerHeaders, createHighlight$9);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the visual highlight of the headers corner.
  *
  * @returns {Selection[]}
  */
  getActiveCornerHeaders() {
    return [
      ...this.activeCornerHeaders.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * highlight cells in a row.
  *
  * @returns {Selection}
  */
  createRowHighlight() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.rowHighlights, createHighlight$1);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the rows highlighting.
  *
  * @returns {Selection[]}
  */
  getRowHighlights() {
    return [
      ...this.rowHighlights.values()
    ];
  }
  /**
  * Creates (if not exist in the cache) Walkontable Selection instance created for controlling
  * highlight cells in a column.
  *
  * @returns {Selection}
  */
  createColumnHighlight() {
    return _class_private_method_get$10(this, _createHighlight, createHighlight).call(this, this.columnHighlights, createHighlight$6);
  }
  /**
  * Get all Walkontable Selection instances which describes the state of the columns highlighting.
  *
  * @returns {Selection[]}
  */
  getColumnHighlights() {
    return [
      ...this.columnHighlights.values()
    ];
  }
  /**
  * Get Walkontable Selection instance created for controlling highlight of the custom selection functionality.
  *
  * @returns {Selection}
  */
  getCustomSelections() {
    return [
      ...this.customSelections.values()
    ];
  }
  /**
  * Add selection to the custom selection instance. The new selection are added to the end of the selection collection.
  *
  * @param {object} selectionInstance The selection instance.
  */
  addCustomSelection(selectionInstance) {
    this.customSelections.push(createHighlight$4({
      ...this.options,
      ...selectionInstance
    }));
  }
  /**
  * Updates the CSS class names used for row, column, header, and active header highlights.
  * Necessary when the related settings change at runtime (e.g. via `updateSettings()`).
  *
  * @param {object} options Options with updated class names.
  * @param {string} [options.rowClassName] The new class name for row highlights.
  * @param {string} [options.columnClassName] The new class name for column highlights.
  * @param {string} [options.headerClassName] The new class name for header highlights.
  * @param {string} [options.activeHeaderClassName] The new class name for active header highlights.
  */
  updateHighlightClassNames(options) {
    if ("rowClassName" in options) {
      this.options.rowClassName = options.rowClassName;
      arrayEach(this.rowHighlights.values(), (h) => {
        h.settings.className = options.rowClassName;
      });
    }
    if ("columnClassName" in options) {
      this.options.columnClassName = options.columnClassName;
      arrayEach(this.columnHighlights.values(), (h) => {
        h.settings.className = options.columnClassName;
      });
    }
    if ("headerClassName" in options) {
      this.options.headerClassName = options.headerClassName;
      arrayEach(this.rowHeaders.values(), (h) => {
        h.settings.className = options.headerClassName;
      });
      arrayEach(this.columnHeaders.values(), (h) => {
        h.settings.className = options.headerClassName;
      });
    }
    if ("activeHeaderClassName" in options) {
      this.options.activeHeaderClassName = options.activeHeaderClassName;
      arrayEach(this.activeRowHeaders.values(), (h) => {
        h.settings.className = options.activeHeaderClassName;
      });
      arrayEach(this.activeColumnHeaders.values(), (h) => {
        h.settings.className = options.activeHeaderClassName;
      });
      arrayEach(this.activeCornerHeaders.values(), (h) => {
        h.settings.className = options.activeHeaderClassName;
      });
    }
  }
  /**
  * Perform cleaning visual highlights for the whole table.
  */
  clear() {
    this.focus.clear();
    this.fill.clear();
    this.areas.forEach((highlight) => highlight.clear());
    this.layeredAreas.forEach((highlight) => highlight.clear());
    this.rowHeaders.forEach((highlight) => highlight.clear());
    this.columnHeaders.forEach((highlight) => highlight.clear());
    this.activeRowHeaders.forEach((highlight) => highlight.clear());
    this.activeColumnHeaders.forEach((highlight) => highlight.clear());
    this.activeCornerHeaders.forEach((highlight) => highlight.clear());
    this.rowHighlights.forEach((highlight) => highlight.clear());
    this.columnHighlights.forEach((highlight) => highlight.clear());
  }
  /**
  * This object can be iterate over using `for of` syntax or using internal `arrayEach` helper.
  *
  * @returns {Selection[]}
  */
  [Symbol.iterator]() {
    return [
      this.focus,
      this.fill,
      ...this.areas.values(),
      ...this.layeredAreas.values(),
      ...this.rowHeaders.values(),
      ...this.columnHeaders.values(),
      ...this.activeRowHeaders.values(),
      ...this.activeColumnHeaders.values(),
      ...this.activeCornerHeaders.values(),
      ...this.rowHighlights.values(),
      ...this.columnHighlights.values(),
      ...this.customSelections
    ][Symbol.iterator]();
  }
  /**
  * Initializes the highlight manager with configuration options and creates the focus and fill highlight instances.
  */
  constructor(options) {
    _class_private_method_init$10(this, _createHighlight);
    this.layerLevel = 0;
    this.layeredAreas = /* @__PURE__ */ new Map();
    this.areas = /* @__PURE__ */ new Map();
    this.rowHeaders = /* @__PURE__ */ new Map();
    this.columnHeaders = /* @__PURE__ */ new Map();
    this.activeRowHeaders = /* @__PURE__ */ new Map();
    this.activeColumnHeaders = /* @__PURE__ */ new Map();
    this.activeCornerHeaders = /* @__PURE__ */ new Map();
    this.rowHighlights = /* @__PURE__ */ new Map();
    this.columnHighlights = /* @__PURE__ */ new Map();
    this.customSelections = [];
    this.options = options;
    this.focus = createHighlight$5(options);
    this.fill = createHighlight$3(options);
  }
}
function createHighlight(cacheMap, highlightFactory) {
  const layerLevel = this.layerLevel;
  if (cacheMap.has(layerLevel)) {
    return cacheMap.get(layerLevel);
  }
  const highlight = highlightFactory({
    layerLevel,
    ...this.options
  });
  cacheMap.set(layerLevel, highlight);
  return highlight;
}
class SelectionRange {
  /**
  * Check if selected range is empty.
  *
  * @returns {boolean}
  */
  isEmpty() {
    return this.size() === 0;
  }
  /**
  * Set coordinates to the class instance. It clears all previously added coordinates and push `coords`
  * to the collection.
  *
  * @param {CellCoords} coords The CellCoords instance with defined visual coordinates.
  * @returns {SelectionRange}
  */
  set(coords) {
    this.clear();
    this.ranges.push(this.createCellRange(coords));
    return this;
  }
  /**
  * Add coordinates to the class instance. The new coordinates are added to the end of the range collection.
  *
  * @param {CellCoords} coords The CellCoords instance with defined visual coordinates.
  * @returns {SelectionRange}
  */
  add(coords) {
    this.ranges.push(this.createCellRange(coords));
    return this;
  }
  /**
  * Pushes a new CellRange instance to the collection.
  *
  * @param {CellRange} cellRange The CellRange instance with defined visual coordinates.
  * @returns {SelectionRange}
  */
  push(cellRange) {
    this.ranges.push(cellRange);
    return this;
  }
  /**
  * Removes from the stack the last added coordinates.
  *
  * @returns {CellRange}
  */
  pop() {
    return this.ranges.pop();
  }
  /**
  * Get last added coordinates from ranges, it returns a CellRange instance.
  *
  * @returns {CellRange|undefined}
  */
  current() {
    return this.peekByIndex(this.size() - 1);
  }
  /**
  * Get previously added coordinates from ranges, it returns a CellRange instance.
  *
  * @returns {CellRange|undefined}
  */
  previous() {
    return this.peekByIndex(this.size() - 2);
  }
  /**
  * Returns `true` if coords is within any selection coords. This method iterates through
  * all selection layers to check if the coords object is within selection range.
  *
  * @param {CellCoords} coords The CellCoords instance with defined visual coordinates.
  * @param {function(CellRange, number): boolean} [criteria] The function that allows injecting custom criteria.
  * @returns {boolean}
  */
  includes(coords, criteria = () => true) {
    return this.ranges.some((cellRange, index2) => cellRange.includes(coords) && criteria(cellRange, index2));
  }
  /**
  * Find all ranges that are equal to the provided range.
  *
  * @param {CellRange} cellRange The CellRange instance with defined visual coordinates.
  * @returns {Array<{range: CellRange, layer: number}>}
  */
  findAll(cellRange) {
    const result = [];
    this.ranges.forEach((range, layer) => {
      if (range.isEqual(cellRange)) {
        result.push({
          range,
          layer
        });
      }
    });
    return result;
  }
  /**
  * Removes all ranges that are equal to the provided ranges.
  *
  * @param {CellRange[]} cellRanges The array of CellRange instances with defined visual coordinates.
  * @returns {SelectionRange}
  */
  remove(cellRanges) {
    this.ranges = this.ranges.filter((range) => !cellRanges.some((cellRange) => cellRange.isEqual(range)));
    return this;
  }
  /**
  * Removes the ranges based on the provided index layers (0 no N).
  *
  * @param {number[]} layerIndexes The array of indexes that will be removed from the selection.
  * @returns {SelectionRange}
  */
  removeLayers(layerIndexes) {
    this.ranges = this.ranges.filter((_, index2) => !layerIndexes.includes(index2));
    return this;
  }
  /**
  * Clear collection.
  *
  * @returns {SelectionRange}
  */
  clear() {
    this.ranges.length = 0;
    return this;
  }
  /**
  * Get count of added all coordinates added to the selection.
  *
  * @returns {number}
  */
  size() {
    return this.ranges.length;
  }
  /**
  * Creates a clone of this class.
  *
  * @returns {SelectionRange}
  */
  clone() {
    const clone2 = new SelectionRange(this.createCellRange);
    clone2.ranges = this.ranges.map((cellRange) => cellRange.clone());
    return clone2;
  }
  /**
  * Allows applying custom index translations for any range within the class instance.
  *
  * @param {function(CellRange): CellRange} mapFunction The function that allows injecting custom index translation logic.
  * @returns {SelectionRange}
  */
  map(mapFunction) {
    this.ranges = this.ranges.map((cellRange, index2) => mapFunction(cellRange, index2));
    return this;
  }
  /**
  * Peek the coordinates based on the index where that coordinate resides in the collection.
  *
  * @param {number} [index=0] An index where the coordinate will be retrieved from. The index '0' gets the
  * latest range.
  * @returns {CellRange|undefined}
  */
  peekByIndex(index2 = 0) {
    let cellRange;
    if (index2 >= 0 && index2 < this.size()) {
      cellRange = this.ranges[index2];
    }
    return cellRange;
  }
  /**
  * Returns an iterator over all CellRange entries stored in the collection, enabling use in for-of loops.
  */
  [Symbol.iterator]() {
    return this.ranges[Symbol.iterator]();
  }
  /**
  * Initializes the collection with a factory function used to create new CellRange instances.
  */
  constructor(createCellRange) {
    this.ranges = [];
    this.createCellRange = createCellRange;
  }
}
function _check_private_redeclaration$1q(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1d(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1d(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1d(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1d(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1d(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1d(receiver, descriptor);
}
function _class_private_field_init$1d(obj, privateMap, value) {
  _check_private_redeclaration$1q(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1d(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1d(receiver, privateMap, "set");
  _class_apply_descriptor_set$1d(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$$(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$$(obj, privateSet) {
  _check_private_redeclaration$1q(obj, privateSet);
  privateSet.add(obj);
}
var _range = /* @__PURE__ */ new WeakMap(), _activeLayerIndex = /* @__PURE__ */ new WeakMap(), _offset$1 = /* @__PURE__ */ new WeakMap(), _chooseNextSelectionLayer = /* @__PURE__ */ new WeakSet(), _choosePreviousSelectionLayer = /* @__PURE__ */ new WeakSet(), _clampCoords = /* @__PURE__ */ new WeakSet(), _getTableSize = /* @__PURE__ */ new WeakSet(), _findNonHiddenZeroBasedCoordsInSelection = /* @__PURE__ */ new WeakSet(), _findFirstNonHiddenZeroBasedRow = /* @__PURE__ */ new WeakSet(), _findFirstNonHiddenZeroBasedColumn = /* @__PURE__ */ new WeakSet(), _visualToZeroBasedCoords = /* @__PURE__ */ new WeakSet(), _zeroBasedToVisualCoords = /* @__PURE__ */ new WeakSet();
class BaseTransformation {
  /**
  * Sets the currently active selection layer index.
  *
  * @param {number} layerIndex The layer index to set as active.
  */
  setActiveLayerIndex(layerIndex) {
    _class_private_field_set$1d(this, _activeLayerIndex, layerIndex);
  }
  /**
  * Gets the currently active selection layer range.
  *
  * @returns {CellRange}
  */
  getCurrentSelection() {
    return _class_private_field_get$1d(this, _range).peekByIndex(_class_private_field_get$1d(this, _activeLayerIndex));
  }
  /**
  * Selects cell relative to the current cell (if possible).
  *
  * @param {number} rowDelta Rows number to move, value can be passed as negative number.
  * @param {number} colDelta Columns number to move, value can be passed as negative number.
  * @param {boolean} [createMissingRecords=false] If `true` the new rows/columns will be created if necessary. Otherwise, row/column will
  *                        be created according to `minSpareRows/minSpareCols` settings of Handsontable.
  * @returns {{selectionLayer: number, visualCoords: CellCoords}} Visual coordinates with selection layer after transformation.
  */
  transformStart(rowDelta, colDelta, createMissingRecords = false) {
    _class_private_field_set$1d(this, _offset$1, this.calculateOffset());
    const delta = this.tableApi.createCellCoords(rowDelta, colDelta);
    let visualCoords = this.getCurrentSelection().highlight;
    const highlightRenderableCoords = this.tableApi.visualToRenderableCoords(visualCoords);
    let rowTransformDir = 0;
    let colTransformDir = 0;
    this.runLocalHooks("beforeTransformStart", delta);
    if (highlightRenderableCoords.row !== null && highlightRenderableCoords.col !== null) {
      let { width, height } = _class_private_method_get$$(this, _getTableSize, getTableSize).call(this);
      const { row, col } = _class_private_method_get$$(this, _visualToZeroBasedCoords, visualToZeroBasedCoords).call(this, visualCoords);
      const fixedRowsBottom = this.tableApi.fixedRowsBottom();
      const minSpareRows = this.tableApi.minSpareRows();
      const minSpareCols = this.tableApi.minSpareCols();
      const autoWrapRow = this.tableApi.autoWrapRow();
      const autoWrapCol = this.tableApi.autoWrapCol();
      const zeroBasedCoords = this.tableApi.createCellCoords((row ?? 0) + (delta.row ?? 0), (col ?? 0) + (delta.col ?? 0));
      if ((zeroBasedCoords.row ?? 0) >= height) {
        const isActionInterrupted = createObjectPropListener(createMissingRecords && minSpareRows > 0 && fixedRowsBottom === 0);
        const nextColumn = (zeroBasedCoords.col ?? 0) + 1;
        const isColumnOutOfRange = nextColumn >= width;
        const newCoords = this.tableApi.createCellCoords((zeroBasedCoords.row ?? 0) - height, isColumnOutOfRange ? nextColumn - width : nextColumn);
        this.runLocalHooks("beforeColumnWrap", isActionInterrupted, _class_private_method_get$$(this, _zeroBasedToVisualCoords, zeroBasedToVisualCoords).call(this, newCoords), isColumnOutOfRange);
        if (isActionInterrupted.value) {
          this.runLocalHooks("insertRowRequire", this.countRenderableRows());
        } else if (autoWrapCol) {
          if (this.shouldSwitchSelectionLayer() && isColumnOutOfRange && _class_private_field_get$1d(this, _range).size() > 1) {
            _class_private_method_get$$(this, _chooseNextSelectionLayer, chooseNextSelectionLayer).call(this);
            const nextLayerCoords = _class_private_method_get$$(this, _findNonHiddenZeroBasedCoordsInSelection, findNonHiddenZeroBasedCoordsInSelection).call(this, "forward");
            if (nextLayerCoords !== null) {
              newCoords.assign(nextLayerCoords);
            }
          }
          zeroBasedCoords.assign(newCoords);
        }
      } else if ((zeroBasedCoords.row ?? 0) < 0) {
        const isActionInterrupted = createObjectPropListener(autoWrapCol);
        const previousColumn = (zeroBasedCoords.col ?? 0) - 1;
        const isColumnOutOfRange = previousColumn < 0;
        const newCoords = this.tableApi.createCellCoords(height + (zeroBasedCoords.row ?? 0), isColumnOutOfRange ? width + previousColumn : previousColumn);
        this.runLocalHooks("beforeColumnWrap", isActionInterrupted, _class_private_method_get$$(this, _zeroBasedToVisualCoords, zeroBasedToVisualCoords).call(this, newCoords), isColumnOutOfRange);
        if (autoWrapCol) {
          if (this.shouldSwitchSelectionLayer() && isColumnOutOfRange && _class_private_field_get$1d(this, _range).size() > 1) {
            _class_private_method_get$$(this, _choosePreviousSelectionLayer, choosePreviousSelectionLayer).call(this);
            const nextLayerCoords = _class_private_method_get$$(this, _findNonHiddenZeroBasedCoordsInSelection, findNonHiddenZeroBasedCoordsInSelection).call(this, "backward");
            if (nextLayerCoords !== null) {
              newCoords.assign(nextLayerCoords);
            }
          }
          zeroBasedCoords.assign(newCoords);
        }
      }
      ({ width, height } = _class_private_method_get$$(this, _getTableSize, getTableSize).call(this));
      if ((zeroBasedCoords.col ?? 0) >= width) {
        const isActionInterrupted = createObjectPropListener(createMissingRecords && minSpareCols > 0);
        const nextRow = (zeroBasedCoords.row ?? 0) + 1;
        const isRowOutOfRange = nextRow >= height;
        const newCoords = this.tableApi.createCellCoords(isRowOutOfRange ? nextRow - height : nextRow, (zeroBasedCoords.col ?? 0) - width);
        this.runLocalHooks("beforeRowWrap", isActionInterrupted, _class_private_method_get$$(this, _zeroBasedToVisualCoords, zeroBasedToVisualCoords).call(this, newCoords), isRowOutOfRange);
        if (isActionInterrupted.value) {
          this.runLocalHooks("insertColRequire", this.countRenderableColumns());
        } else if (autoWrapRow) {
          if (this.shouldSwitchSelectionLayer() && isRowOutOfRange && _class_private_field_get$1d(this, _range).size() > 1) {
            _class_private_method_get$$(this, _chooseNextSelectionLayer, chooseNextSelectionLayer).call(this);
            const nextLayerCoords = _class_private_method_get$$(this, _findNonHiddenZeroBasedCoordsInSelection, findNonHiddenZeroBasedCoordsInSelection).call(this, "forward");
            if (nextLayerCoords !== null) {
              newCoords.assign(nextLayerCoords);
            }
          }
          zeroBasedCoords.assign(newCoords);
        }
      } else if ((zeroBasedCoords.col ?? 0) < 0) {
        const isActionInterrupted = createObjectPropListener(autoWrapRow);
        const previousRow = (zeroBasedCoords.row ?? 0) - 1;
        const isRowOutOfRange = previousRow < 0;
        const newCoords = this.tableApi.createCellCoords(isRowOutOfRange ? height + previousRow : previousRow, width + (zeroBasedCoords.col ?? 0));
        this.runLocalHooks("beforeRowWrap", isActionInterrupted, _class_private_method_get$$(this, _zeroBasedToVisualCoords, zeroBasedToVisualCoords).call(this, newCoords), isRowOutOfRange);
        if (autoWrapRow) {
          if (this.shouldSwitchSelectionLayer() && isRowOutOfRange && _class_private_field_get$1d(this, _range).size() > 1) {
            _class_private_method_get$$(this, _choosePreviousSelectionLayer, choosePreviousSelectionLayer).call(this);
            const nextLayerCoords = _class_private_method_get$$(this, _findNonHiddenZeroBasedCoordsInSelection, findNonHiddenZeroBasedCoordsInSelection).call(this, "backward");
            if (nextLayerCoords !== null) {
              newCoords.assign(nextLayerCoords);
            }
          }
          zeroBasedCoords.assign(newCoords);
        }
      }
      const { rowDir, colDir } = _class_private_method_get$$(this, _clampCoords, clampCoords).call(this, zeroBasedCoords);
      rowTransformDir = rowDir;
      colTransformDir = colDir;
      visualCoords = _class_private_method_get$$(this, _zeroBasedToVisualCoords, zeroBasedToVisualCoords).call(this, zeroBasedCoords);
    }
    this.runLocalHooks("afterTransformStart", visualCoords, rowTransformDir, colTransformDir);
    return {
      selectionLayer: _class_private_field_get$1d(this, _activeLayerIndex),
      visualCoords
    };
  }
  /**
  * Sets selection end cell relative to the current selection end cell (if possible).
  *
  * @param {number} rowDelta Rows number to move, value can be passed as negative number.
  * @param {number} colDelta Columns number to move, value can be passed as negative number.
  * @returns {{selectionLayer: number, visualCoords: CellCoords}} Visual coordinates with selection layer after transformation.
  */
  transformEnd(rowDelta, colDelta) {
    _class_private_field_set$1d(this, _offset$1, this.calculateOffset());
    const delta = this.tableApi.createCellCoords(rowDelta, colDelta);
    const cellRange = this.getCurrentSelection();
    const highlightRenderableCoords = this.tableApi.visualToRenderableCoords(cellRange.highlight);
    const toRow = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedRow, findFirstNonHiddenZeroBasedRow).call(this, cellRange.to.row ?? 0, cellRange.from.row ?? 0);
    const toColumn = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedColumn, findFirstNonHiddenZeroBasedColumn).call(this, cellRange.to.col ?? 0, cellRange.from.col ?? 0);
    const visualCoords = cellRange.to.clone();
    let rowTransformDir = 0;
    let colTransformDir = 0;
    this.runLocalHooks("beforeTransformEnd", delta);
    if (highlightRenderableCoords.row !== null && highlightRenderableCoords.col !== null && toRow !== null && toColumn !== null) {
      const { row: highlightRow, col: highlightColumn } = _class_private_method_get$$(this, _visualToZeroBasedCoords, visualToZeroBasedCoords).call(this, cellRange.highlight);
      const coords = this.tableApi.createCellCoords(toRow + (delta.row ?? 0), toColumn + (delta.col ?? 0));
      const topStartCorner = cellRange.getTopStartCorner();
      const topEndCorner = cellRange.getTopEndCorner();
      const bottomEndCorner = cellRange.getBottomEndCorner();
      if ((delta.col ?? 0) < 0 && toColumn >= (highlightColumn ?? 0) && (coords.col ?? 0) < (highlightColumn ?? 0)) {
        const columnRestDelta = (coords.col ?? 0) - (highlightColumn ?? 0);
        const firstNonHidden = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedColumn, findFirstNonHiddenZeroBasedColumn).call(this, topStartCorner.col ?? 0, topEndCorner.col ?? 0);
        coords.col = (firstNonHidden ?? 0) + columnRestDelta;
      } else if ((delta.col ?? 0) > 0 && toColumn <= (highlightColumn ?? 0) && (coords.col ?? 0) > (highlightColumn ?? 0)) {
        const endColumnIndex = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedColumn, findFirstNonHiddenZeroBasedColumn).call(this, topEndCorner.col ?? 0, topStartCorner.col ?? 0);
        const columnRestDelta = Math.max((coords.col ?? 0) - (endColumnIndex ?? 0), 1);
        coords.col = (endColumnIndex ?? 0) + columnRestDelta;
      }
      if ((delta.row ?? 0) < 0 && toRow >= (highlightRow ?? 0) && (coords.row ?? 0) < (highlightRow ?? 0)) {
        const rowRestDelta = (coords.row ?? 0) - (highlightRow ?? 0);
        const firstNonHidden = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedRow, findFirstNonHiddenZeroBasedRow).call(this, topStartCorner.row ?? 0, bottomEndCorner.row ?? 0);
        coords.row = (firstNonHidden ?? 0) + rowRestDelta;
      } else if ((delta.row ?? 0) > 0 && toRow <= (highlightRow ?? 0) && (coords.row ?? 0) > (highlightRow ?? 0)) {
        const bottomRowIndex = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedRow, findFirstNonHiddenZeroBasedRow).call(this, bottomEndCorner.row ?? 0, topStartCorner.row ?? 0);
        const rowRestDelta = Math.max((coords.row ?? 0) - (bottomRowIndex ?? 0), 1);
        coords.row = (bottomRowIndex ?? 0) + rowRestDelta;
      }
      const { rowDir, colDir } = _class_private_method_get$$(this, _clampCoords, clampCoords).call(this, coords);
      rowTransformDir = rowDir;
      colTransformDir = colDir;
      const newVisualCoords = _class_private_method_get$$(this, _zeroBasedToVisualCoords, zeroBasedToVisualCoords).call(this, coords);
      if (delta.row === 0 && delta.col !== 0) {
        visualCoords.col = newVisualCoords.col;
      } else if (delta.row !== 0 && delta.col === 0) {
        visualCoords.row = newVisualCoords.row;
      } else {
        visualCoords.row = newVisualCoords.row;
        visualCoords.col = newVisualCoords.col;
      }
    }
    this.runLocalHooks("afterTransformEnd", visualCoords, rowTransformDir, colTransformDir);
    return {
      selectionLayer: _class_private_field_get$1d(this, _activeLayerIndex),
      visualCoords
    };
  }
  /**
  * Abstract method that child classes must implement to calculate offset coordinates based on
  * the current processed selection layer.
  */
  calculateOffset() {
    throwWithCause("`calculateOffset` is not implemented");
  }
  /**
  * Abstract method that child classes must implement to provide the count of renderable rows
  * based on their specific transformation logic.
  */
  countRenderableRows() {
    throwWithCause("`countRenderableRows` is not implemented");
  }
  /**
  * Abstract method that child classes must implement to provide the count of renderable columns
  * based on their specific transformation logic.
  */
  countRenderableColumns() {
    throwWithCause("`countRenderableColumns` is not implemented");
  }
  /**
  * Determines whether selection layer switching should occur during transformation.
  * Child classes can override this method to control the behavior.
  */
  shouldSwitchSelectionLayer() {
    throwWithCause("`shouldSwitchSelectionLayer` is not implemented");
  }
  /**
  * Initializes the transformation module with the selection range collection and the table API reference.
  */
  constructor(range, tableApi) {
    _class_private_method_init$$(this, _chooseNextSelectionLayer);
    _class_private_method_init$$(this, _choosePreviousSelectionLayer);
    _class_private_method_init$$(this, _clampCoords);
    _class_private_method_init$$(this, _getTableSize);
    _class_private_method_init$$(this, _findNonHiddenZeroBasedCoordsInSelection);
    _class_private_method_init$$(this, _findFirstNonHiddenZeroBasedRow);
    _class_private_method_init$$(this, _findFirstNonHiddenZeroBasedColumn);
    _class_private_method_init$$(this, _visualToZeroBasedCoords);
    _class_private_method_init$$(this, _zeroBasedToVisualCoords);
    _class_private_field_init$1d(this, _range, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1d(this, _activeLayerIndex, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1d(this, _offset$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1d(this, _activeLayerIndex, 0);
    _class_private_field_set$1d(this, _offset$1, {
      x: 0,
      y: 0
    });
    _class_private_field_set$1d(this, _range, range);
    this.tableApi = tableApi;
  }
}
function chooseNextSelectionLayer() {
  const layerIndex = _class_private_field_get$1d(this, _activeLayerIndex) + 1;
  this.setActiveLayerIndex(layerIndex >= _class_private_field_get$1d(this, _range).size() ? 0 : layerIndex);
  _class_private_field_set$1d(this, _offset$1, this.calculateOffset());
}
function choosePreviousSelectionLayer() {
  const layerIndex = _class_private_field_get$1d(this, _activeLayerIndex) - 1;
  this.setActiveLayerIndex(layerIndex < 0 ? _class_private_field_get$1d(this, _range).size() - 1 : layerIndex);
  _class_private_field_set$1d(this, _offset$1, this.calculateOffset());
}
function clampCoords(zeroBasedCoords) {
  const { width, height } = _class_private_method_get$$(this, _getTableSize, getTableSize).call(this);
  let rowDir = 0;
  let colDir = 0;
  if ((zeroBasedCoords.row ?? 0) < 0) {
    rowDir = -1;
    zeroBasedCoords.row = 0;
  } else if ((zeroBasedCoords.row ?? 0) > 0 && (zeroBasedCoords.row ?? 0) >= height) {
    rowDir = 1;
    zeroBasedCoords.row = height - 1;
  }
  if ((zeroBasedCoords.col ?? 0) < 0) {
    colDir = -1;
    zeroBasedCoords.col = 0;
  } else if ((zeroBasedCoords.col ?? 0) > 0 && (zeroBasedCoords.col ?? 0) >= width) {
    colDir = 1;
    zeroBasedCoords.col = width - 1;
  }
  return {
    rowDir,
    colDir
  };
}
function getTableSize() {
  return {
    width: _class_private_field_get$1d(this, _offset$1).x + this.countRenderableColumns(),
    height: _class_private_field_get$1d(this, _offset$1).y + this.countRenderableRows()
  };
}
function findNonHiddenZeroBasedCoordsInSelection(direction) {
  if (![
    "forward",
    "backward"
  ].includes(direction)) {
    return null;
  }
  const topStartCoords = this.getCurrentSelection().getTopStartCorner();
  const bottomEndCoords = this.getCurrentSelection().getBottomEndCorner();
  const [visualRowFrom, visualRowTo, visualColumnFrom, visualColumnTo] = direction === "forward" ? [
    topStartCoords.row,
    bottomEndCoords.row,
    topStartCoords.col,
    bottomEndCoords.col
  ] : [
    bottomEndCoords.row,
    topStartCoords.row,
    bottomEndCoords.col,
    topStartCoords.col
  ];
  const zeroBasedRow = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedRow, findFirstNonHiddenZeroBasedRow).call(this, visualRowFrom ?? 0, visualRowTo ?? 0);
  const zeroBasedCol = _class_private_method_get$$(this, _findFirstNonHiddenZeroBasedColumn, findFirstNonHiddenZeroBasedColumn).call(this, visualColumnFrom ?? 0, visualColumnTo ?? 0);
  if (zeroBasedRow === null || zeroBasedCol === null) {
    return null;
  }
  return this.tableApi.createCellCoords(zeroBasedRow, zeroBasedCol);
}
function findFirstNonHiddenZeroBasedRow(visualRowFrom, visualRowTo) {
  const row = this.tableApi.findFirstNonHiddenRenderableRow(visualRowFrom, visualRowTo);
  if (row === null) {
    return null;
  }
  return _class_private_field_get$1d(this, _offset$1).y + row;
}
function findFirstNonHiddenZeroBasedColumn(visualColumnFrom, visualColumnTo) {
  const column = this.tableApi.findFirstNonHiddenRenderableColumn(visualColumnFrom, visualColumnTo);
  if (column === null) {
    return null;
  }
  return _class_private_field_get$1d(this, _offset$1).x + column;
}
function visualToZeroBasedCoords(visualCoords) {
  const { row, col } = this.tableApi.visualToRenderableCoords(visualCoords);
  if (row === null || col === null) {
    throwWithCause("Renderable coords are not visible.");
  }
  return this.tableApi.createCellCoords(_class_private_field_get$1d(this, _offset$1).y + row, _class_private_field_get$1d(this, _offset$1).x + col);
}
function zeroBasedToVisualCoords(zeroBasedCoords) {
  const coords = zeroBasedCoords.clone();
  coords.col = (zeroBasedCoords.col ?? 0) - _class_private_field_get$1d(this, _offset$1).x;
  coords.row = (zeroBasedCoords.row ?? 0) - _class_private_field_get$1d(this, _offset$1).y;
  return this.tableApi.renderableToVisualCoords(coords);
}
mixin(BaseTransformation, localHooks);
class ExtenderTransformation extends BaseTransformation {
  /**
  * Calculates offset coordinates for extender selection.
  *
  * @returns {{x: number, y: number}}
  */
  calculateOffset() {
    return {
      x: this.tableApi.navigableHeaders() ? this.tableApi.countRowHeaders() : 0,
      y: this.tableApi.navigableHeaders() ? this.tableApi.countColHeaders() : 0
    };
  }
  /**
  * Gets the count of renderable rows for extender transformation.
  * Extender transformation operates on the full table size.
  *
  * @returns {number}
  */
  countRenderableRows() {
    return this.tableApi.countRenderableRows();
  }
  /**
  * Gets the count of renderable columns for extender transformation.
  * Extender transformation operates on the full table size.
  *
  * @returns {number}
  */
  countRenderableColumns() {
    return this.tableApi.countRenderableColumns();
  }
  /**
  * Changes the behavior of the transformation logic by not switching the selection layer
  * when the selection is out of range.
  *
  * @returns {boolean}
  */
  shouldSwitchSelectionLayer() {
    return false;
  }
}
class FocusTransformation extends BaseTransformation {
  /**
  * Calculates offset coordinates for focus selection based on the current selection state.
  * For header focus selection, calculates offset including headers.
  * For cell focus selection, calculates offset only for selected cells.
  *
  * @returns {{x: number, y: number}}
  */
  calculateOffset() {
    const range = this.getCurrentSelection();
    const { row, col } = range.getOuterTopStartCorner();
    const rowNum = row ?? 0;
    const colNum = col ?? 0;
    const columnsInRange = this.tableApi.countRenderableColumnsInRange(0, colNum - 1);
    const rowsInRange = this.tableApi.countRenderableRowsInRange(0, rowNum - 1);
    const isHeaderSelection = range.highlight.isHeader();
    const headerX = isHeaderSelection ? Math.abs(colNum) : 0;
    const headerY = isHeaderSelection ? Math.abs(rowNum) : 0;
    return {
      x: colNum < 0 ? headerX : -columnsInRange,
      y: rowNum < 0 ? headerY : -rowsInRange
    };
  }
  /**
  * Gets the count of renderable rows for focus transformation.
  * Focus transformation operates on the current selection range.
  *
  * @returns {number}
  */
  countRenderableRows() {
    const range = this.getCurrentSelection();
    return this.tableApi.countRenderableRowsInRange(0, range.getOuterBottomEndCorner().row ?? 0);
  }
  /**
  * Gets the count of renderable columns for focus transformation.
  * Focus transformation operates on the current selection range.
  *
  * @returns {number}
  */
  countRenderableColumns() {
    const range = this.getCurrentSelection();
    return this.tableApi.countRenderableColumnsInRange(0, range.getOuterBottomEndCorner().col ?? 0);
  }
  /**
  * Throws an error because focus transformation doesn't support `transformEnd`.
  */
  transformEnd(_rowDelta, _colDelta) {
    throwWithCause("`transformEnd` is not valid for focus selection use `transformStart` instead");
  }
  /**
  * Changes the behavior of the transformation logic by switching the selection layer
  * when the selection is out of range.
  *
  * @returns {boolean}
  */
  shouldSwitchSelectionLayer() {
    return true;
  }
}
const SELECTION_TYPE_UNRECOGNIZED = 0;
const SELECTION_TYPE_EMPTY = 1;
const SELECTION_TYPE_ARRAY = 2;
const SELECTION_TYPE_OBJECT = 3;
const SELECTION_TYPES = [
  SELECTION_TYPE_OBJECT,
  SELECTION_TYPE_ARRAY
];
const ARRAY_TYPE_PATTERN = [
  [
    "number"
  ],
  [
    "number",
    "string"
  ],
  [
    "number",
    "undefined"
  ],
  [
    "number",
    "string",
    "undefined"
  ]
];
const rootCall = /* @__PURE__ */ Symbol("root");
const childCall = /* @__PURE__ */ Symbol("child");
function detectSelectionType(selectionRanges, _callSymbol = rootCall) {
  if (_callSymbol !== rootCall && _callSymbol !== childCall) {
    throwWithCause("The second argument is used internally only and cannot be overwritten.");
  }
  const isArray2 = Array.isArray(selectionRanges);
  const isRootCall = _callSymbol === rootCall;
  let result = SELECTION_TYPE_UNRECOGNIZED;
  if (isArray2) {
    const firstItem = selectionRanges[0];
    if (selectionRanges.length === 0) {
      result = SELECTION_TYPE_EMPTY;
    } else if (isRootCall && firstItem instanceof CellRange) {
      result = SELECTION_TYPE_OBJECT;
    } else if (isRootCall && Array.isArray(firstItem)) {
      result = detectSelectionType(firstItem, childCall);
    } else if (selectionRanges.length >= 2 && selectionRanges.length <= 4) {
      const isArrayType = !selectionRanges.some((value, index2) => !ARRAY_TYPE_PATTERN[index2].includes(typeof value));
      if (isArrayType) {
        result = SELECTION_TYPE_ARRAY;
      }
    }
  }
  return result;
}
function normalizeSelectionFactory(type, { createCellCoords, createCellRange, keepDirection = false, propToCol } = {}) {
  if (!SELECTION_TYPES.includes(type)) {
    throwWithCause("Unsupported selection ranges schema type was provided.");
  }
  return function(selection) {
    const isObjectType = type === SELECTION_TYPE_OBJECT;
    const selArr = selection;
    let rowStart = isObjectType ? selection.from.row : selArr[0];
    let columnStart = isObjectType ? selection.from.col : selArr[1];
    let rowEnd = isObjectType ? selection.to.row : selArr[2];
    let columnEnd = isObjectType ? selection.to.col : selArr[3];
    if (typeof propToCol === "function") {
      if (typeof columnStart === "string") {
        columnStart = propToCol(columnStart);
      }
      if (typeof columnEnd === "string") {
        columnEnd = propToCol(columnEnd);
      }
    }
    if (isUndefined$1(rowEnd)) {
      rowEnd = rowStart;
    }
    if (isUndefined$1(columnEnd)) {
      columnEnd = columnStart;
    }
    let colStart = columnStart;
    let colEnd = columnEnd;
    if (!keepDirection) {
      const origRowStart = rowStart;
      const origRowEnd = rowEnd;
      const origColStart = colStart;
      const origColEnd = colEnd;
      rowStart = Math.min(origRowStart ?? 0, origRowEnd ?? 0);
      colStart = Math.min(origColStart ?? 0, origColEnd ?? 0);
      rowEnd = Math.max(origRowStart ?? 0, origRowEnd ?? 0);
      colEnd = Math.max(origColStart ?? 0, origColEnd ?? 0);
    }
    const highlight = isObjectType ? selection.highlight.clone() : createCellCoords(rowStart ?? 0, colStart ?? 0);
    const from = createCellCoords(rowStart ?? 0, colStart ?? 0);
    const to = createCellCoords(rowEnd ?? 0, colEnd ?? 0);
    return createCellRange(highlight, from, to);
  };
}
function transformSelectionToColumnDistance(hotInstance) {
  const selectionType = detectSelectionType(hotInstance.getSelected());
  if (selectionType === SELECTION_TYPE_UNRECOGNIZED || selectionType === SELECTION_TYPE_EMPTY) {
    return [];
  }
  const selectionSchemaNormalizer = normalizeSelectionFactory(selectionType, {
    createCellCoords: hotInstance._createCellCoords.bind(hotInstance),
    createCellRange: hotInstance._createCellRange.bind(hotInstance)
  });
  const unorderedIndexes = /* @__PURE__ */ new Set();
  arrayEach(hotInstance.getSelected() ?? [], (selection) => {
    const { from, to } = selectionSchemaNormalizer(selection);
    const columnNonHeaderStart = Math.max(from.col ?? 0, 0);
    const amount = (to.col ?? 0) - columnNonHeaderStart + 1;
    arrayEach(Array.from(new Array(amount), (_, i) => columnNonHeaderStart + i), (index2) => {
      if (!unorderedIndexes.has(index2)) {
        unorderedIndexes.add(index2);
      }
    });
  });
  const orderedIndexes = Array.from(unorderedIndexes).sort((a, b) => a - b);
  const normalizedColumnRanges = arrayReduce(orderedIndexes, (acc, visualColumnIndex, index2, array) => {
    if (index2 !== 0 && visualColumnIndex === array[index2 - 1] + 1) {
      acc[acc.length - 1][1] += 1;
    } else {
      acc.push([
        visualColumnIndex,
        1
      ]);
    }
    return acc;
  }, []);
  return normalizedColumnRanges;
}
function transformSelectionToRowDistance(hotInstance) {
  const selectionType = detectSelectionType(hotInstance.getSelected());
  if (selectionType === SELECTION_TYPE_UNRECOGNIZED || selectionType === SELECTION_TYPE_EMPTY) {
    return [];
  }
  const selectionSchemaNormalizer = normalizeSelectionFactory(selectionType, {
    createCellCoords: hotInstance._createCellCoords.bind(hotInstance),
    createCellRange: hotInstance._createCellRange.bind(hotInstance)
  });
  const unorderedIndexes = /* @__PURE__ */ new Set();
  arrayEach(hotInstance.getSelected() ?? [], (selection) => {
    const { from, to } = selectionSchemaNormalizer(selection);
    const rowNonHeaderStart = Math.max(from.row ?? 0, 0);
    const amount = (to.row ?? 0) - rowNonHeaderStart + 1;
    arrayEach(Array.from(new Array(amount), (_, i) => rowNonHeaderStart + i), (index2) => {
      if (!unorderedIndexes.has(index2)) {
        unorderedIndexes.add(index2);
      }
    });
  });
  const orderedIndexes = Array.from(unorderedIndexes).sort((a, b) => a - b);
  const normalizedRowRanges = arrayReduce(orderedIndexes, (acc, rowIndex, index2, array) => {
    if (index2 !== 0 && rowIndex === array[index2 - 1] + 1) {
      acc[acc.length - 1][1] += 1;
    } else {
      acc.push([
        rowIndex,
        1
      ]);
    }
    return acc;
  }, []);
  return normalizedRowRanges;
}
function _check_private_redeclaration$1p(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1c(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1c(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1c(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1c(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1c(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1c(receiver, descriptor);
}
function _class_private_field_init$1c(obj, privateMap, value) {
  _check_private_redeclaration$1p(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1c(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1c(receiver, privateMap, "set");
  _class_apply_descriptor_set$1c(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$_(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$_(obj, privateSet) {
  _check_private_redeclaration$1p(obj, privateSet);
  privateSet.add(obj);
}
function isFocusPositionObject(value) {
  return typeof value === "object" && value !== null && Number.isInteger(value.row) && Number.isInteger(value.col);
}
function snapToNearestVisible(indexMapper, index2, isSingleLine) {
  if (!isSingleLine || index2 < 0) {
    return index2;
  }
  const nearestIndex = indexMapper.getNearestNotHiddenIndex(index2, 1, true);
  return nearestIndex === null ? index2 : nearestIndex;
}
var _extenderTransformation = /* @__PURE__ */ new WeakMap(), _focusTransformation = /* @__PURE__ */ new WeakMap(), _isFocusSelectionChanged = /* @__PURE__ */ new WeakMap(), _disableHeadersHighlight = /* @__PURE__ */ new WeakMap(), _selectionSource = /* @__PURE__ */ new WeakMap(), _expectedLayersCount = /* @__PURE__ */ new WeakMap(), _activeSelectionLayer = /* @__PURE__ */ new WeakMap(), _applyHeaderHighlights = /* @__PURE__ */ new WeakSet();
class Selection2 {
  /**
  * Updates the CSS class names used for row, column, header, and active header highlights based on
  * the current settings. Call this after settings change via `updateSettings()`.
  */
  updateHighlightClassNames() {
    this.highlight.updateHighlightClassNames({
      rowClassName: this.settings.currentRowClassName,
      columnClassName: this.settings.currentColClassName,
      headerClassName: this.settings.currentHeaderClassName,
      activeHeaderClassName: this.settings.activeHeaderClassName
    });
  }
  /**
  * Gets all selection range layers of the selection.
  *
  * @returns {SelectionRange}
  */
  getSelectedRange() {
    return this.selectedRange;
  }
  /**
  * Gets the active selection range layer.
  *
  * @returns {CellRange}
  */
  getActiveSelectedRange() {
    return this.selectedRange.peekByIndex(_class_private_field_get$1c(this, _activeSelectionLayer));
  }
  /**
  * Gets the index of the active selection range layer.
  *
  * @returns {number}
  */
  getActiveSelectionLayerIndex() {
    return _class_private_field_get$1c(this, _activeSelectionLayer);
  }
  /**
  * Sets the index of the active selection range layer.
  *
  * @param {number} layerIndex The index of the active selection range layer.
  */
  setActiveSelectionLayerIndex(layerIndex) {
    _class_private_field_set$1c(this, _activeSelectionLayer, layerIndex);
  }
  /**
  * Marks the source of the selection. It can be one of the following values: `mouse`, or any other string.
  *
  * @param {'mouse' | 'unknown' | string} sourceName The source name.
  */
  markSource(sourceName) {
    _class_private_field_set$1c(this, _selectionSource, sourceName);
  }
  /**
  * Marks end of the selection source. It restores the selection source to default value which is 'unknown'.
  */
  markEndSource() {
    _class_private_field_set$1c(this, _selectionSource, "unknown");
  }
  /**
  * Returns the source of the selection.
  *
  * @returns {'mouse' | 'unknown' | string}
  */
  getSelectionSource() {
    return _class_private_field_get$1c(this, _selectionSource);
  }
  /**
  * Set the number of expected layers. The method is not obligatory to call. It is used mostly internally
  * to determine when the last selection layer of non-contiguous is applied, thus the viewport scroll is triggered.
  *
  * @param {number} layersCount The number of expected layers.
  */
  setExpectedLayers(layersCount) {
    _class_private_field_set$1c(this, _expectedLayersCount, layersCount);
  }
  /**
  * Indicate that selection process began. It sets internally `.inProgress` property to `true`.
  */
  begin() {
    this.inProgress = true;
  }
  /**
  * Indicate that selection process finished. It sets internally `.inProgress` property to `false`.
  */
  finish() {
    this.runLocalHooks("afterSelectionFinished", Array.from(this.selectedRange));
    this.inProgress = false;
    _class_private_field_set$1c(this, _expectedLayersCount, -1);
  }
  /**
  * Check if the process of selecting the cell/cells is in progress.
  *
  * @returns {boolean}
  */
  isInProgress() {
    return this.inProgress;
  }
  /**
  * Starts selection range on given coordinate object.
  *
  * @param {CellCoords} coords Visual coords.
  * @param {boolean} [multipleSelection] If `true`, selection will be worked in 'multiple' mode. This option works
  *                                      only when 'selectionMode' is set as 'multiple'. If the argument is not defined
  *                                      the default trigger will be used.
  * @param {boolean} [fragment=false] If `true`, the selection will be treated as a partial selection where the
  *                                   `setRangeEnd` method won't be called on every `setRangeStart` call.
  * @param {CellCoords} [highlightCoords] If set, allows changing the coordinates of the highlight/focus cell.
  */
  setRangeStart(coords, multipleSelection, fragment = false, highlightCoords = coords) {
    const isMultipleMode = this.settings.selectionMode === "multiple";
    const isMultipleSelection = isUndefined$1(multipleSelection) ? this.tableProps.getShortcutManager().isCtrlPressed() : multipleSelection;
    const coordsClone = coords.clone();
    _class_private_field_set$1c(this, _disableHeadersHighlight, false);
    _class_private_field_set$1c(this, _isFocusSelectionChanged, false);
    this.runLocalHooks(`beforeSetRangeStart${fragment ? "Only" : ""}`, coordsClone);
    if (!isMultipleMode || isMultipleMode && !isMultipleSelection && isUndefined$1(multipleSelection)) {
      this.selectedRange.clear();
      this.highlight.getAreas().forEach((highlight) => highlight.clear());
      this.highlight.getLayeredAreas().forEach((highlight) => highlight.clear());
      this.highlight.getRowHeaders().forEach((highlight) => highlight.clear());
      this.highlight.getColumnHeaders().forEach((highlight) => highlight.clear());
      this.highlight.getActiveRowHeaders().forEach((highlight) => highlight.clear());
      this.highlight.getActiveColumnHeaders().forEach((highlight) => highlight.clear());
      this.highlight.getActiveCornerHeaders().forEach((highlight) => highlight.clear());
      this.highlight.getRowHighlights().forEach((highlight) => highlight.clear());
      this.highlight.getColumnHighlights().forEach((highlight) => highlight.clear());
    }
    this.selectedRange.add(coordsClone).current()?.setHighlight(highlightCoords.clone());
    if (this.getLayerLevel() === 0) {
      this.selectedByRowHeader.clear();
      this.selectedByColumnHeader.clear();
    }
    if (!fragment) {
      this.setRangeEnd(coords);
    }
  }
  /**
  * Starts selection range on given coordinate object.
  *
  * @param {CellCoords} coords Visual coords.
  * @param {boolean} [multipleSelection] If `true`, selection will be worked in 'multiple' mode. This option works
  *                                      only when 'selectionMode' is set as 'multiple'. If the argument is not defined
  *                                      the default trigger will be used.
  * @param {CellCoords} [highlightCoords] If set, allows changing the coordinates of the highlight/focus cell.
  */
  setRangeStartOnly(coords, multipleSelection, highlightCoords = coords) {
    this.setRangeStart(coords, multipleSelection, true, highlightCoords);
  }
  /**
  * Ends selection range on given coordinate object.
  *
  * @param {CellCoords} coords Visual coords.
  * @param {number} [layerIndex] The layer index to set the end on. If not provided, the current layer level is used.
  */
  setRangeEnd(coords, layerIndex = this.getLayerLevel()) {
    if (this.selectedRange.isEmpty()) {
      return;
    }
    this.setActiveSelectionLayerIndex(layerIndex);
    const coordsClone = coords.clone();
    const countRows = this.tableProps.countRows();
    const countCols = this.tableProps.countCols();
    const isSingle = this.getActiveSelectedRange()?.clone().setTo(coords).isSingleHeader();
    if ((countRows > 0 || countCols > 0) && (countRows === 0 && (coordsClone.col ?? 0) < 0 && !isSingle || countCols === 0 && (coordsClone.row ?? 0) < 0 && !isSingle)) {
      return;
    }
    this.runLocalHooks("beforeSetRangeEnd", coordsClone);
    this.begin();
    const cellRange = this.getActiveSelectedRange();
    if (!cellRange) {
      return;
    }
    if (!this.settings.navigableHeaders) {
      cellRange.highlight.normalize();
    }
    if (this.settings.selectionMode === "single") {
      cellRange.setFrom(cellRange.highlight);
      cellRange.setTo(cellRange.highlight);
    } else {
      const horizontalDir = cellRange.getHorizontalDirection();
      const verticalDir = cellRange.getVerticalDirection();
      const isMultiple = this.isMultiple();
      cellRange.setTo(coordsClone);
      if (isMultiple && (horizontalDir !== cellRange.getHorizontalDirection() || cellRange.getWidth() === 1 && !cellRange.includes(cellRange.highlight))) {
        cellRange.from.assign({
          col: cellRange.highlight.col ?? void 0
        });
      }
      if (isMultiple && (verticalDir !== cellRange.getVerticalDirection() || cellRange.getHeight() === 1 && !cellRange.includes(cellRange.highlight))) {
        cellRange.from.assign({
          row: cellRange.highlight.row ?? void 0
        });
      }
    }
    if (countRows > 0 && countCols > 0) {
      if (!this.settings.navigableHeaders || this.settings.navigableHeaders && !cellRange.isSingleHeader()) {
        cellRange.to.normalize();
      }
    }
    this.runLocalHooks("beforeHighlightSet");
    this.setRangeFocus(this.getActiveSelectedRange()?.highlight ?? cellRange.highlight, layerIndex);
    this.applyAndCommit(this.getActiveSelectedRange() ?? cellRange, layerIndex);
    const isLastLayer = _class_private_field_get$1c(this, _expectedLayersCount) === -1 || this.selectedRange.size() === _class_private_field_get$1c(this, _expectedLayersCount);
    this.runLocalHooks("afterSetRangeEnd", coords, isLastLayer);
  }
  /**
  * Applies and commits the selection to all layers (using the Walkontable Selection API) based on the selection (CellRanges)
  * collected in the `selectedRange` module.
  *
  * @param {CellRange} [cellRange] The cell range to apply. If not provided, the current selection is used.
  * @param {number} [layerLevel] The layer level to apply. If not provided, the current layer level is used.
  */
  applyAndCommit(cellRange = this.getActiveSelectedRange(), layerLevel = this.getLayerLevel()) {
    if (!cellRange) {
      return;
    }
    const countRows = this.tableProps.countRows();
    const countCols = this.tableProps.countCols();
    this.highlight.useLayerLevel(layerLevel);
    const areaHighlight = this.highlight.createArea();
    const layeredAreaHighlight = this.highlight.createLayeredArea();
    const rowHeaderHighlight = this.highlight.createRowHeader();
    const columnHeaderHighlight = this.highlight.createColumnHeader();
    const activeRowHeaderHighlight = this.highlight.createActiveRowHeader();
    const activeColumnHeaderHighlight = this.highlight.createActiveColumnHeader();
    const activeCornerHeaderHighlight = this.highlight.createActiveCornerHeader();
    const rowHighlight = this.highlight.createRowHighlight();
    const columnHighlight = this.highlight.createColumnHighlight();
    areaHighlight?.clear();
    layeredAreaHighlight?.clear();
    rowHeaderHighlight?.clear();
    columnHeaderHighlight?.clear();
    activeRowHeaderHighlight?.clear();
    activeColumnHeaderHighlight?.clear();
    activeCornerHeaderHighlight?.clear();
    rowHighlight?.clear();
    columnHighlight?.clear();
    if (this.highlight.isEnabledFor(AREA_TYPE, cellRange.highlight) && (this.isMultiple() || layerLevel >= 1)) {
      areaHighlight?.add(cellRange.from).add(cellRange.to).commit();
      layeredAreaHighlight?.add(cellRange.from).add(cellRange.to).commit();
      if (layerLevel === 1) {
        const previousRange = this.selectedRange.peekByIndex(layerLevel - 1);
        if (previousRange) {
          this.highlight.useLayerLevel(layerLevel - 1);
          this.highlight.createArea()?.add(previousRange.from).commit().syncWith(previousRange);
          this.highlight.createLayeredArea()?.add(previousRange.from).commit().syncWith(previousRange);
          this.highlight.useLayerLevel(layerLevel);
        }
      }
    }
    if (this.highlight.isEnabledFor(HEADER_TYPE, cellRange.highlight)) {
      _class_private_method_get$_(this, _applyHeaderHighlights, applyHeaderHighlights).call(this, cellRange, countRows, countCols, rowHeaderHighlight, columnHeaderHighlight, activeRowHeaderHighlight, activeColumnHeaderHighlight, activeCornerHeaderHighlight, rowHighlight, columnHighlight);
    }
  }
  /**
  * Sets the selection focus position at the specified coordinates.
  *
  * @param {CellCoords} coords The CellCoords instance with defined visual coordinates.
  * @param {number} [layerIndex] The layer index to set the focus on.
  */
  setRangeFocus(coords, layerIndex = this.getLayerLevel()) {
    if (this.selectedRange.isEmpty()) {
      return;
    }
    this.setActiveSelectionLayerIndex(layerIndex);
    _class_private_field_get$1c(this, _extenderTransformation).setActiveLayerIndex(layerIndex);
    _class_private_field_get$1c(this, _focusTransformation).setActiveLayerIndex(layerIndex);
    const cellRange = this.getActiveSelectedRange();
    if (!this.inProgress) {
      this.runLocalHooks("beforeSetFocus", coords);
    }
    if (!cellRange) {
      return;
    }
    const focusHighlight = this.highlight.getFocus();
    focusHighlight.clear();
    cellRange.setHighlight(coords);
    if (!this.inProgress) {
      this.runLocalHooks("beforeHighlightSet");
    }
    if (this.highlight.isEnabledFor(FOCUS_TYPE, cellRange.highlight)) {
      focusHighlight.add(cellRange.highlight).commit().syncWith(cellRange);
    }
    if (!this.inProgress) {
      _class_private_field_set$1c(this, _isFocusSelectionChanged, true);
      this.runLocalHooks("afterSetFocus", cellRange.highlight);
    }
  }
  /**
  * Selects cell relative to the current cell (if possible).
  *
  * @param {number} rowDelta Rows number to move, value can be passed as negative number.
  * @param {number} colDelta Columns number to move, value can be passed as negative number.
  * @param {boolean} [createMissingRecords=false] If `true` the new rows/columns will be created if necessary.
  * Otherwise, row/column will be created according to `minSpareRows/minSpareCols` settings of Handsontable.
  */
  transformStart(rowDelta, colDelta, createMissingRecords = false) {
    if (!this.isSelected()) {
      return;
    }
    const { visualCoords } = _class_private_field_get$1c(this, _extenderTransformation).transformStart(rowDelta, colDelta, createMissingRecords);
    this.setRangeStart(visualCoords, void 0, false, visualCoords);
  }
  /**
  * Sets selection end cell relative to the current selection end cell (if possible).
  *
  * @param {number} rowDelta Rows number to move, value can be passed as negative number.
  * @param {number} colDelta Columns number to move, value can be passed as negative number.
  */
  transformEnd(rowDelta, colDelta) {
    if (!this.isSelected()) {
      return;
    }
    const { visualCoords, selectionLayer } = _class_private_field_get$1c(this, _extenderTransformation).transformEnd(rowDelta, colDelta);
    this.setRangeEnd(visualCoords, selectionLayer);
  }
  /**
  * Transforms the focus cell selection relative to the current focus position.
  *
  * @param {number} rowDelta Rows number to move, value can be passed as negative number.
  * @param {number} colDelta Columns number to move, value can be passed as negative number.
  */
  transformFocus(rowDelta, colDelta) {
    if (!this.isSelected()) {
      return;
    }
    const { selectionLayer, visualCoords } = _class_private_field_get$1c(this, _focusTransformation).transformStart(rowDelta, colDelta);
    this.setRangeFocus(visualCoords.normalize(), selectionLayer);
  }
  /**
  * Transforms the last selection layer down or up by the index count.
  *
  * @param {number} visualRowIndex Visual row index from which the selection will be shifted.
  * @param {number} amount The number of rows to shift the selection.
  */
  shiftRows(visualRowIndex, amount) {
    if (!this.isSelected()) {
      return;
    }
    const range = this.getActiveSelectedRange();
    if (this.isSelectedByCorner()) {
      this.selectAll(true, true, {
        disableHeadersHighlight: true
      });
    } else if (range && (this.isSelectedByColumnHeader() || (range.getOuterTopStartCorner().row ?? 0) >= visualRowIndex)) {
      const { from, to, highlight } = range;
      const countRows = this.tableProps.countRows();
      const isSelectedByRowHeader = this.isSelectedByRowHeader();
      const isSelectedByColumnHeader = this.isSelectedByColumnHeader();
      const minRow = isSelectedByColumnHeader ? -1 : 0;
      const coordsStartAmount = isSelectedByColumnHeader ? 0 : amount;
      const isSingleRow = from.row === to.row;
      const clampToVisibleRow = (visualRow) => snapToNearestVisible(this.tableProps.rowIndexMapper, visualRow, isSingleRow);
      this.getSelectedRange().pop();
      const coordsStart = this.tableProps.createCellCoords(clampToVisibleRow(clamp((from.row ?? 0) + coordsStartAmount, minRow, countRows - 1)), from.col ?? 0);
      const coordsEnd = this.tableProps.createCellCoords(clampToVisibleRow(clamp((to.row ?? 0) + amount, minRow, countRows - 1)), to.col ?? 0);
      this.markSource("shift");
      if ((highlight.row ?? 0) >= visualRowIndex) {
        this.setRangeStartOnly(coordsStart, true, this.tableProps.createCellCoords(clampToVisibleRow(clamp((highlight.row ?? 0) + amount, 0, countRows - 1)), highlight.col ?? 0));
      } else {
        this.setRangeStartOnly(coordsStart, true);
      }
      if (isSelectedByRowHeader) {
        this.selectedByRowHeader.add(this.getLayerLevel());
      }
      if (isSelectedByColumnHeader) {
        this.selectedByColumnHeader.add(this.getLayerLevel());
      }
      this.setRangeEnd(coordsEnd);
      this.markEndSource();
    }
  }
  /**
  * Transforms the last selection layer left or right by the index count.
  *
  * @param {number} visualColumnIndex Visual column index from which the selection will be shifted.
  * @param {number} amount The number of columns to shift the selection.
  */
  shiftColumns(visualColumnIndex, amount) {
    if (!this.isSelected()) {
      return;
    }
    const range = this.getActiveSelectedRange();
    if (this.isSelectedByCorner()) {
      this.selectAll(true, true, {
        disableHeadersHighlight: true
      });
    } else if (range && (this.isSelectedByRowHeader() || (range.getOuterTopStartCorner().col ?? 0) >= visualColumnIndex)) {
      const { from, to, highlight } = range;
      const countCols = this.tableProps.countCols();
      const isSelectedByRowHeader = this.isSelectedByRowHeader();
      const isSelectedByColumnHeader = this.isSelectedByColumnHeader();
      const minColumn = isSelectedByRowHeader ? -1 : 0;
      const coordsStartAmount = isSelectedByRowHeader ? 0 : amount;
      const isSingleColumn = from.col === to.col;
      const clampToVisibleColumn = (visualColumn) => snapToNearestVisible(this.tableProps.columnIndexMapper, visualColumn, isSingleColumn);
      this.getSelectedRange().pop();
      const coordsStart = this.tableProps.createCellCoords(from.row ?? 0, clampToVisibleColumn(clamp((from.col ?? 0) + coordsStartAmount, minColumn, countCols - 1)));
      const coordsEnd = this.tableProps.createCellCoords(to.row ?? 0, clampToVisibleColumn(clamp((to.col ?? 0) + amount, minColumn, countCols - 1)));
      this.markSource("shift");
      if ((highlight.col ?? 0) >= visualColumnIndex) {
        this.setRangeStartOnly(coordsStart, true, this.tableProps.createCellCoords(highlight.row ?? 0, clampToVisibleColumn(clamp((highlight.col ?? 0) + amount, 0, countCols - 1))));
      } else {
        this.setRangeStartOnly(coordsStart, true);
      }
      if (isSelectedByRowHeader) {
        this.selectedByRowHeader.add(this.getLayerLevel());
      }
      if (isSelectedByColumnHeader) {
        this.selectedByColumnHeader.add(this.getLayerLevel());
      }
      this.setRangeEnd(coordsEnd);
      this.markEndSource();
    }
  }
  /**
  * Returns currently used layer level.
  *
  * @returns {number} Returns layer level starting from 0. If no selection was added to the table -1 is returned.
  */
  getLayerLevel() {
    return this.selectedRange.size() - 1;
  }
  /**
  * Returns `true` if currently there is a selection on the screen, `false` otherwise.
  *
  * @returns {boolean}
  */
  isSelected() {
    return !this.selectedRange.isEmpty();
  }
  /**
  * Returns information if we have a multi-selection. This method check multi-selection only on the latest layer of
  * the selection.
  *
  * @param {CellRange} [cellRange] The cell range to check. If not provided, the latest selection layer is used.
  * @returns {boolean}
  */
  isMultiple(cellRange = this.getActiveSelectedRange()) {
    if (!this.isSelected() || !cellRange) {
      return false;
    }
    const isMultipleListener = createObjectPropListener(!cellRange.isSingle());
    this.runLocalHooks("afterIsMultipleSelection", isMultipleListener);
    return isMultipleListener.value;
  }
  /**
  * Checks if the last selection involves changing the focus cell position only.
  *
  * @returns {boolean}
  */
  isFocusSelectionChanged() {
    return this.isSelected() && _class_private_field_get$1c(this, _isFocusSelectionChanged);
  }
  /**
  * Returns `true` if the selection was applied by clicking to the row header. If the `layerLevel`
  * argument is passed then only that layer will be checked. Otherwise, it checks if any row header
  * was clicked on any selection layer level.
  *
  * @param {number} [layerLevel=this.getLayerLevel()] Selection layer level to check.
  * @returns {boolean}
  */
  isSelectedByRowHeader(layerLevel = this.getLayerLevel()) {
    return !this.isSelectedByCorner() && (layerLevel === -1 ? this.selectedByRowHeader.size > 0 : this.selectedByRowHeader.has(layerLevel));
  }
  /**
  * Returns `true` if the selection consists of entire rows (including their headers). If the `layerLevel`
  * argument is passed then only that layer will be checked. Otherwise, it checks the selection for all layers.
  *
  * @param {number} [layerLevel=this.getLayerLevel()] Selection layer level to check.
  * @returns {boolean}
  */
  isEntireRowSelected(layerLevel = this.getLayerLevel()) {
    const tester2 = (range2) => {
      const { col } = range2.getOuterTopStartCorner();
      const rowHeaders = this.tableProps.countRowHeaders();
      const countCols = this.tableProps.countCols();
      return (rowHeaders > 0 && (col ?? 0) < 0 || rowHeaders === 0) && range2.getWidth() === countCols;
    };
    if (layerLevel === -1) {
      return Array.from(this.selectedRange).some((range2) => tester2(range2));
    }
    const range = this.selectedRange.peekByIndex(layerLevel);
    return range ? tester2(range) : false;
  }
  /**
  * Returns `true` if the selection was applied by clicking to the column header. If the `layerLevel`
  * argument is passed then only that layer will be checked. Otherwise, it checks if any column header
  * was clicked on any selection layer level.
  *
  * @param {number} [layerLevel=this.getLayerLevel()] Selection layer level to check.
  * @returns {boolean}
  */
  isSelectedByColumnHeader(layerLevel = this.getLayerLevel()) {
    return !this.isSelectedByCorner() && (layerLevel === -1 ? this.selectedByColumnHeader.size > 0 : this.selectedByColumnHeader.has(layerLevel));
  }
  /**
  * Returns `true` if the selection consists of entire columns (including their headers). If the `layerLevel`
  * argument is passed then only that layer will be checked. Otherwise, it checks the selection for all layers.
  *
  * @param {number} [layerLevel=this.getLayerLevel()] Selection layer level to check.
  * @returns {boolean}
  */
  isEntireColumnSelected(layerLevel = this.getLayerLevel()) {
    const tester2 = (range2) => {
      const { row } = range2.getOuterTopStartCorner();
      const colHeaders = this.tableProps.countColHeaders();
      const countRows = this.tableProps.countRows();
      return (colHeaders > 0 && (row ?? 0) < 0 || colHeaders === 0) && range2.getHeight() === countRows;
    };
    if (layerLevel === -1) {
      return Array.from(this.selectedRange).some((range2) => tester2(range2));
    }
    const range = this.selectedRange.peekByIndex(layerLevel);
    return range ? tester2(range) : false;
  }
  /**
  * Returns `true` if the selection was applied by clicking on the row or column header on any layer level.
  *
  * @returns {boolean}
  */
  isSelectedByAnyHeader() {
    return this.isSelectedByRowHeader(-1) || this.isSelectedByColumnHeader(-1) || this.isSelectedByCorner();
  }
  /**
  * Returns `true` if the selection was applied by clicking on the left-top corner overlay.
  *
  * @returns {boolean}
  */
  isSelectedByCorner() {
    return this.selectedByColumnHeader.has(this.getLayerLevel()) && this.selectedByRowHeader.has(this.getLayerLevel());
  }
  /**
  * Returns `true` if coords is within selection coords. This method iterates through all selection layers to check if
  * the coords object is within selection range.
  *
  * @param {CellCoords} coords The CellCoords instance with defined visual coordinates.
  * @returns {boolean}
  */
  inInSelection(coords) {
    return this.selectedRange.includes(coords);
  }
  /**
  * Returns `true` if the cell corner should be visible.
  *
  * @private
  * @returns {boolean} `true` if the corner element has to be visible, `false` otherwise.
  */
  isCellCornerVisible() {
    return this.settings.fillHandle && !this.tableProps.isEditorOpened() && !this.isMultiple();
  }
  /**
  * Returns `true` if the cell coordinates are visible (renderable).
  *
  * @private
  * @param {CellCoords} coords The cell coordinates to check.
  * @returns {boolean}
  */
  isCellVisible(coords) {
    const renderableCoords = this.tableProps.visualToRenderableCoords(coords);
    return renderableCoords.row !== null && renderableCoords.col !== null;
  }
  /**
  * Returns `true` if the area corner should be visible.
  *
  * @param {number} layerLevel The layer level.
  * @returns {boolean} `true` if the corner element has to be visible, `false` otherwise.
  */
  isAreaCornerVisible(layerLevel) {
    if (Number.isInteger(layerLevel) && layerLevel !== this.getLayerLevel()) {
      return false;
    }
    return this.settings.fillHandle && !this.tableProps.isEditorOpened() && this.isMultiple();
  }
  /**
  * Clear the selection by resetting the collected ranges and highlights.
  */
  clear() {
    this.selectedRange.clear();
    this.highlight.clear();
  }
  /**
  * Deselects all selected cells.
  */
  deselect() {
    if (!this.isSelected()) {
      return;
    }
    this.inProgress = false;
    this.clear();
    this.runLocalHooks("afterDeselect");
  }
  /**
  * Selects all cells and headers.
  *
  * @param {boolean} [includeRowHeaders=false] `true` If the selection should include the row headers,
  * `false` otherwise.
  * @param {boolean} [includeColumnHeaders=false] `true` If the selection should include the column
  * headers, `false` otherwise.
  * @param {object} [options] Additional object with options.
  * @param {{row: number, col: number} | boolean} [options.focusPosition] The argument allows changing the cell/header
  * focus position. The value takes an object with a `row` and `col` properties from -N to N, where
  * negative values point to the headers and positive values point to the cell range. If `false`, the focus
  * position won't be changed.
  * @param {boolean} [options.disableHeadersHighlight] If `true`, disables highlighting the headers even when
  * the logical coordinates points on them.
  */
  selectAll(includeRowHeaders = false, includeColumnHeaders = false, options = {
    focusPosition: false,
    disableHeadersHighlight: false
  }) {
    const nrOfRows = this.tableProps.countRows();
    const nrOfColumns = this.tableProps.countCols();
    const countRowHeaders = this.tableProps.countRowHeaders();
    const countColHeaders = this.tableProps.countColHeaders();
    const rowFrom = includeColumnHeaders ? -countColHeaders : 0;
    const columnFrom = includeRowHeaders ? -countRowHeaders : 0;
    if (rowFrom === 0 && columnFrom === 0 && (nrOfRows === 0 || nrOfColumns === 0)) {
      return;
    }
    let highlight = this.getActiveSelectedRange()?.highlight;
    const { focusPosition, disableHeadersHighlight } = options;
    if (isFocusPositionObject(focusPosition)) {
      highlight = this.tableProps.createCellCoords(clamp(focusPosition.row, rowFrom, nrOfRows - 1), clamp(focusPosition.col, columnFrom, nrOfColumns - 1));
    }
    const startCoords = this.tableProps.createCellCoords(rowFrom, columnFrom);
    const endCoords = this.tableProps.createCellCoords(nrOfRows - 1, nrOfColumns - 1);
    this.clear();
    this.runLocalHooks("beforeSelectAll", startCoords, endCoords, highlight);
    this.setRangeStartOnly(startCoords, void 0, highlight);
    _class_private_field_set$1c(this, _disableHeadersHighlight, disableHeadersHighlight ?? false);
    if (columnFrom < 0) {
      this.selectedByRowHeader.add(this.getLayerLevel());
    }
    if (rowFrom < 0) {
      this.selectedByColumnHeader.add(this.getLayerLevel());
    }
    this.setRangeEnd(endCoords);
    this.runLocalHooks("afterSelectAll", startCoords, endCoords, highlight);
    this.finish();
  }
  /**
  * Make multiple, non-contiguous selection specified by `row` and `column` values or a range of cells
  * finishing at `endRow`, `endColumn`. The method supports two input formats, first as an array of arrays such
  * as `[[rowStart, columnStart, rowEnd, columnEnd]]` and second format as an array of CellRange objects.
  * If the passed ranges have another format the exception will be thrown.
  *
  * @param {Array[]|CellRange[]} selectionRanges The coordinates which define what the cells should be selected.
  * @returns {boolean} Returns `true` if selection was successful, `false` otherwise.
  */
  selectCells(selectionRanges) {
    const selectionType = detectSelectionType(selectionRanges);
    if (selectionType === SELECTION_TYPE_EMPTY) {
      return false;
    } else if (selectionType === SELECTION_TYPE_UNRECOGNIZED) {
      throwWithCause(toSingleLine`Unsupported format of the selection ranges was passed. To select cells pass\x20
        the coordinates as an array of arrays ([[rowStart, columnStart/columnPropStart, rowEnd,\x20
        columnEnd/columnPropEnd]]) or as an array of CellRange objects.`);
    }
    const selectionSchemaNormalizer = normalizeSelectionFactory(selectionType, {
      createCellCoords: (...args) => this.tableProps.createCellCoords(...args),
      createCellRange: (...args) => this.tableProps.createCellRange(...args),
      propToCol: (prop) => this.tableProps.propToCol(prop),
      keepDirection: true
    });
    const navigableHeaders = this.settings.navigableHeaders;
    const tableParams = {
      countRows: this.tableProps.countRows(),
      countCols: this.tableProps.countCols(),
      countRowHeaders: navigableHeaders ? this.tableProps.countRowHeaders() : 0,
      countColHeaders: navigableHeaders ? this.tableProps.countColHeaders() : 0
    };
    const isValid = !selectionRanges.some((selection) => {
      const cellRange = selectionSchemaNormalizer(selection);
      const rangeValidity = cellRange.isValid(tableParams);
      return !(rangeValidity && !cellRange.containsHeaders() || rangeValidity && cellRange.containsHeaders() && cellRange.isSingleHeader());
    });
    if (isValid) {
      this.clear();
      this.setExpectedLayers(selectionRanges.length);
      selectionRanges.forEach((selection) => {
        const { from, to } = selectionSchemaNormalizer(selection);
        this.setRangeStartOnly(from.clone(), false);
        this.setRangeEnd(to.clone());
      });
      this.finish();
    }
    return isValid;
  }
  /**
  * Select column specified by `startColumn` visual index or column property or a range of columns finishing at
  * `endColumn`.
  *
  * @param {number|string} startColumn Visual column index or column property from which the selection starts.
  * @param {number|string} [endColumn] Visual column index or column property from to the selection finishes.
  * @param {number | { row: number, col: number }} [focusPosition=0] The argument allows changing the cell/header focus
  * position. The value can take visual row index from -N to N, where negative values point to the headers and positive
  * values point to the cell range. An object with `row` and `col` properties also can be passed to change the focus
  * position horizontally.
  * @returns {boolean} Returns `true` if selection was successful, `false` otherwise.
  */
  selectColumns(startColumn, endColumn = startColumn, focusPosition = 0) {
    const start = typeof startColumn === "string" ? this.tableProps.propToCol(startColumn) : startColumn;
    const end = typeof endColumn === "string" ? this.tableProps.propToCol(endColumn) : endColumn;
    const countRows = this.tableProps.countRows();
    const countCols = this.tableProps.countCols();
    const countColHeaders = this.tableProps.countColHeaders();
    const columnHeaderLastIndex = countColHeaders === 0 ? 0 : -countColHeaders;
    const fromCoords = this.tableProps.createCellCoords(columnHeaderLastIndex, start);
    const toCoords = this.tableProps.createCellCoords(countRows - 1, end);
    const isValid = this.tableProps.createCellRange(fromCoords, fromCoords, toCoords).isValid({
      countRows,
      countCols,
      countRowHeaders: 0,
      countColHeaders
    });
    if (isValid) {
      let highlightRow = 0;
      let highlightColumn = 0;
      if (isFocusPositionObject(focusPosition)) {
        highlightRow = clamp(focusPosition.row ?? 0, columnHeaderLastIndex, countRows - 1);
        highlightColumn = clamp(focusPosition.col ?? 0, Math.min(start, end), Math.max(start, end));
      } else {
        highlightRow = clamp(typeof focusPosition === "number" ? focusPosition : 0, columnHeaderLastIndex, countRows - 1);
        highlightColumn = start;
      }
      const highlight = this.tableProps.createCellCoords(highlightRow, highlightColumn);
      const fromRow = countColHeaders === 0 ? 0 : clamp(highlight.row ?? 0, columnHeaderLastIndex, -1);
      const toRow = countRows - 1;
      const from = this.tableProps.createCellCoords(fromRow, start);
      const to = this.tableProps.createCellCoords(toRow, end);
      this.runLocalHooks("beforeSelectColumns", from, to, highlight);
      this.setRangeStartOnly(from, void 0, highlight);
      this.selectedByColumnHeader.add(this.getLayerLevel());
      this.setRangeEnd(to);
      this.runLocalHooks("afterSelectColumns", from, to, highlight);
      this.finish();
    }
    return isValid;
  }
  /**
  * Select row specified by `startRow` visual index or a range of rows finishing at `endRow`.
  *
  * @param {number} startRow Visual row index from which the selection starts.
  * @param {number} [endRow] Visual row index from to the selection finishes.
  * @param {number | { row: number, col: number }} [focusPosition=0] The argument allows changing the cell/header focus
  * position. The value can take visual row index from -N to N, where negative values point to the headers and positive
  * values point to the cell range. An object with `row` and `col` properties also can be passed to change the focus
  * position horizontally.
  * @returns {boolean} Returns `true` if selection was successful, `false` otherwise.
  */
  selectRows(startRow, endRow = startRow, focusPosition = 0) {
    const countRows = this.tableProps.countRows();
    const countCols = this.tableProps.countCols();
    const countRowHeaders = this.tableProps.countRowHeaders();
    const rowHeaderLastIndex = countRowHeaders === 0 ? 0 : -countRowHeaders;
    const fromCoords = this.tableProps.createCellCoords(startRow, rowHeaderLastIndex);
    const toCoords = this.tableProps.createCellCoords(endRow, countCols - 1);
    const isValid = this.tableProps.createCellRange(fromCoords, fromCoords, toCoords).isValid({
      countRows,
      countCols,
      countRowHeaders,
      countColHeaders: 0
    });
    if (isValid) {
      let highlightRow = 0;
      let highlightColumn = 0;
      if (isFocusPositionObject(focusPosition)) {
        highlightRow = clamp(focusPosition.row ?? 0, Math.min(startRow, endRow), Math.max(startRow, endRow));
        highlightColumn = clamp(focusPosition.col ?? 0, rowHeaderLastIndex, countCols - 1);
      } else {
        highlightRow = startRow;
        highlightColumn = clamp(typeof focusPosition === "number" ? focusPosition : 0, rowHeaderLastIndex, countCols - 1);
      }
      const highlight = this.tableProps.createCellCoords(highlightRow, highlightColumn);
      const fromColumn = countRowHeaders === 0 ? 0 : clamp(highlight.col ?? 0, rowHeaderLastIndex, -1);
      const toColumn = countCols - 1;
      const from = this.tableProps.createCellCoords(startRow, fromColumn);
      const to = this.tableProps.createCellCoords(endRow, toColumn);
      this.runLocalHooks("beforeSelectRows", from, to, highlight);
      this.setRangeStartOnly(from, void 0, highlight);
      this.selectedByRowHeader.add(this.getLayerLevel());
      this.setRangeEnd(to);
      this.runLocalHooks("afterSelectRows", from, to, highlight);
      this.finish();
    }
    return isValid;
  }
  /**
  * Allows importing the selection for all layers from the provided array of CellRange objects.
  * The method clears the current selection and sets the new one without triggering any
  * selection related hooks.
  *
  * @param {SelectionState} selectionState The selection state to import.
  */
  importSelection({ ranges, activeRange, activeSelectionLayer, selectedByRowHeader, selectedByColumnHeader, disableHeadersHighlight }) {
    if (ranges.length === 0) {
      return;
    }
    this.selectedRange.clear();
    this.highlight.clear();
    this.inProgress = false;
    _class_private_field_set$1c(this, _disableHeadersHighlight, disableHeadersHighlight);
    this.selectedByRowHeader = new Set(selectedByRowHeader);
    this.selectedByColumnHeader = new Set(selectedByColumnHeader);
    this.setActiveSelectionLayerIndex(0);
    ranges.forEach((cellRange, selectionLayerIndex) => {
      this.selectedRange.push(cellRange);
      this.applyAndCommit(cellRange, selectionLayerIndex);
    });
    this.setRangeFocus(activeRange.highlight, activeSelectionLayer);
    _class_private_field_set$1c(this, _disableHeadersHighlight, false);
    this.inProgress = false;
  }
  /**
  * Exports all selection layers with other properties related to the selection state.
  *
  * @returns {SelectionState}
  */
  exportSelection() {
    return {
      ranges: Array.from(this.selectedRange).map((range) => range.clone()),
      activeRange: this.getActiveSelectedRange(),
      activeSelectionLayer: this.getActiveSelectionLayerIndex(),
      selectedByRowHeader: Array.from(this.selectedByRowHeader),
      selectedByColumnHeader: Array.from(this.selectedByColumnHeader),
      disableHeadersHighlight: _class_private_field_get$1c(this, _disableHeadersHighlight)
    };
  }
  /**
  * Refreshes the whole selection by clearing, reapplying and committing (calculating visual to renderable indexes)
  * the selection by using already added visual ranges. The method can be useful when underneath some indexes
  * was hidden/showed or dataset size was changed or the range of the cell ranges was modified. Then, to see the
  * changes in the selection the method may be needed to be called. The method modifies the visual ranges if needed.
  */
  refresh() {
    if (!this.isSelected()) {
      return;
    }
    const countRows = this.tableProps.countRows();
    const countColumns = this.tableProps.countCols();
    if (countRows === 0 || countColumns === 0) {
      this.deselect();
      return;
    }
    const ranges = this.selectedRange.ranges.map((range) => range.clone());
    const selectionSource = this.getSelectionSource();
    if (selectionSource === "unknown") {
      this.markSource("refresh");
    }
    const selectedByRowHeader = new Set(this.selectedByRowHeader);
    const selectedByColumnHeader = new Set(this.selectedByColumnHeader);
    this.clear();
    this.setExpectedLayers(ranges.length);
    ranges.forEach((range) => {
      const { from, to, highlight } = range;
      const maxRows = countRows - 1;
      const maxColumns = countColumns - 1;
      highlight.assign({
        row: clamp(highlight.row ?? 0, this.settings.navigableHeaders ? -Infinity : 0, maxRows),
        col: clamp(highlight.col ?? 0, this.settings.navigableHeaders ? -Infinity : 0, maxColumns)
      });
      from.assign({
        row: clamp(from.row ?? 0, -Infinity, maxRows),
        col: clamp(from.col ?? 0, -Infinity, maxColumns)
      });
      to.assign({
        row: clamp(to.row ?? 0, -Infinity, maxRows),
        col: clamp(to.col ?? 0, -Infinity, maxColumns)
      });
      this.setRangeStartOnly(from, true, highlight);
      this.setRangeEnd(to);
    });
    this.selectedByRowHeader = selectedByRowHeader;
    this.selectedByColumnHeader = selectedByColumnHeader;
    this.finish();
    this.markEndSource();
  }
  /**
  * Refreshes the whole selection by only recommitting values. In terms of the selection the committing
  * values means that the cell ranges are again recalculated to the renderable indexes - the visual
  * indexes are not touched. The method can be useful when underneath some indexes was hidden/showed
  * which affects the selection. In that cases the method may be needed to be called.
  */
  commit() {
    const customSelections = this.highlight.getCustomSelections();
    customSelections.forEach((customSelection) => {
      customSelection.commit();
    });
    if (!this.isSelected()) {
      return;
    }
    const currentLayer = this.getLayerLevel();
    const cellRange = this.getActiveSelectedRange();
    if (cellRange && this.highlight.isEnabledFor(FOCUS_TYPE, cellRange.highlight)) {
      this.highlight.getFocus().commit().syncWith(cellRange);
    }
    for (let layerLevel = 0; layerLevel < this.selectedRange.size(); layerLevel += 1) {
      this.highlight.useLayerLevel(layerLevel);
      const areaHighlight = this.highlight.createArea();
      const areaLayeredHighlight = this.highlight.createLayeredArea();
      const rowHeaderHighlight = this.highlight.createRowHeader();
      const columnHeaderHighlight = this.highlight.createColumnHeader();
      const activeRowHeaderHighlight = this.highlight.createActiveRowHeader();
      const activeColumnHeaderHighlight = this.highlight.createActiveColumnHeader();
      const activeCornerHeaderHighlight = this.highlight.createActiveCornerHeader();
      const rowHighlight = this.highlight.createRowHighlight();
      const columnHighlight = this.highlight.createColumnHighlight();
      areaHighlight?.commit();
      areaLayeredHighlight?.commit();
      rowHeaderHighlight?.commit();
      columnHeaderHighlight?.commit();
      activeRowHeaderHighlight?.commit();
      activeColumnHeaderHighlight?.commit();
      activeCornerHeaderHighlight?.commit();
      rowHighlight?.commit();
      columnHighlight?.commit();
    }
    this.highlight.useLayerLevel(currentLayer);
  }
  /**
  * Initializes the Selection manager with grid settings and table API references, and sets up transformation modules and highlight layers.
  */
  constructor(settings, tableProps) {
    _class_private_method_init$_(this, _applyHeaderHighlights);
    _class_private_field_init$1c(this, _extenderTransformation, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1c(this, _focusTransformation, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1c(this, _isFocusSelectionChanged, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1c(this, _disableHeadersHighlight, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1c(this, _selectionSource, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1c(this, _expectedLayersCount, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1c(this, _activeSelectionLayer, {
      writable: true,
      value: void 0
    });
    this.inProgress = false;
    this.selectedRange = new SelectionRange((highlight, from, to) => {
      return this.tableProps.createCellRange(highlight, from, to);
    });
    this.selectedByRowHeader = /* @__PURE__ */ new Set();
    this.selectedByColumnHeader = /* @__PURE__ */ new Set();
    _class_private_field_set$1c(this, _isFocusSelectionChanged, false);
    _class_private_field_set$1c(this, _disableHeadersHighlight, false);
    _class_private_field_set$1c(this, _selectionSource, "unknown");
    _class_private_field_set$1c(this, _expectedLayersCount, -1);
    _class_private_field_set$1c(this, _activeSelectionLayer, 0);
    this.settings = settings;
    this.tableProps = tableProps;
    this.highlight = new Highlight({
      headerClassName: settings.currentHeaderClassName,
      activeHeaderClassName: settings.activeHeaderClassName,
      rowClassName: settings.currentRowClassName,
      columnClassName: settings.currentColClassName,
      cellAttributes: [
        A11Y_SELECTED()
      ],
      rowIndexMapper: this.tableProps.rowIndexMapper,
      columnIndexMapper: this.tableProps.columnIndexMapper,
      disabledCellSelection: (row, column) => this.tableProps.isDisabledCellSelection(row, column),
      cellCornerVisible: () => this.isCellCornerVisible(),
      areaCornerVisible: (layerLevel) => this.isAreaCornerVisible(layerLevel),
      visualToRenderableCoords: (coords) => this.tableProps.visualToRenderableCoords(coords),
      renderableToVisualCoords: (coords) => this.tableProps.renderableToVisualCoords(coords),
      createCellCoords: (row, column) => this.tableProps.createCellCoords(row, column),
      createCellRange: (highlight, from, to) => this.tableProps.createCellRange(highlight, from, to)
    });
    _class_private_field_set$1c(this, _extenderTransformation, new ExtenderTransformation(this.selectedRange, {
      ...this.tableProps,
      navigableHeaders: () => !!settings.navigableHeaders,
      fixedRowsBottom: () => Number(settings.fixedRowsBottom),
      minSpareRows: () => Number(settings.minSpareRows),
      minSpareCols: () => Number(settings.minSpareCols),
      autoWrapRow: () => !!settings.autoWrapRow,
      autoWrapCol: () => !!settings.autoWrapCol
    }));
    _class_private_field_set$1c(this, _focusTransformation, new FocusTransformation(this.selectedRange, {
      ...this.tableProps,
      navigableHeaders: () => !!settings.navigableHeaders,
      fixedRowsBottom: () => 0,
      minSpareRows: () => 0,
      minSpareCols: () => 0,
      autoWrapRow: () => true,
      autoWrapCol: () => true
    }));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("beforeTransformStart", (...args) => this.runLocalHooks("beforeModifyTransformStart", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("afterTransformStart", (...args) => this.runLocalHooks("afterModifyTransformStart", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("beforeTransformEnd", (...args) => this.runLocalHooks("beforeModifyTransformEnd", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("afterTransformEnd", (...args) => this.runLocalHooks("afterModifyTransformEnd", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("insertRowRequire", (...args) => this.runLocalHooks("insertRowRequire", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("insertColRequire", (...args) => this.runLocalHooks("insertColRequire", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("beforeRowWrap", (...args) => this.runLocalHooks("beforeRowWrap", ...args));
    _class_private_field_get$1c(this, _extenderTransformation).addLocalHook("beforeColumnWrap", (...args) => this.runLocalHooks("beforeColumnWrap", ...args));
    _class_private_field_get$1c(this, _focusTransformation).addLocalHook("beforeTransformStart", (...args) => this.runLocalHooks("beforeModifyTransformFocus", ...args));
    _class_private_field_get$1c(this, _focusTransformation).addLocalHook("afterTransformStart", (...args) => this.runLocalHooks("afterModifyTransformFocus", ...args));
  }
}
function applyHeaderHighlights(cellRange, countRows, countCols, rowHeaderHighlight, columnHeaderHighlight, activeRowHeaderHighlight, activeColumnHeaderHighlight, activeCornerHeaderHighlight, rowHighlight, columnHighlight) {
  if (!cellRange.isSingleHeader()) {
    const rowCoordsFrom = this.tableProps.createCellCoords(Math.max(cellRange.from.row ?? 0, 0), -1);
    const rowCoordsTo = this.tableProps.createCellCoords(cellRange.to.row ?? 0, -1);
    const columnCoordsFrom = this.tableProps.createCellCoords(-1, Math.max(cellRange.from.col ?? 0, 0));
    const columnCoordsTo = this.tableProps.createCellCoords(-1, cellRange.to.col ?? 0);
    if (this.settings.selectionMode === "single") {
      rowHeaderHighlight?.add(rowCoordsFrom).commit();
      columnHeaderHighlight?.add(columnCoordsFrom).commit();
      rowHighlight?.add(rowCoordsFrom).commit();
      columnHighlight?.add(columnCoordsFrom).commit();
    } else {
      rowHeaderHighlight?.add(rowCoordsFrom).add(rowCoordsTo).commit();
      columnHeaderHighlight?.add(columnCoordsFrom).add(columnCoordsTo).commit();
      rowHighlight?.add(rowCoordsFrom).add(rowCoordsTo).commit();
      columnHighlight?.add(columnCoordsFrom).add(columnCoordsTo).commit();
    }
  }
  const highlightRowHeaders = !_class_private_field_get$1c(this, _disableHeadersHighlight) && this.isEntireRowSelected() && (countCols > 0 && countCols === cellRange.getWidth() || countCols === 0 && this.isSelectedByRowHeader());
  const highlightColumnHeaders = !_class_private_field_get$1c(this, _disableHeadersHighlight) && this.isEntireColumnSelected() && (countRows > 0 && countRows === cellRange.getHeight() || countRows === 0 && this.isSelectedByColumnHeader());
  if (highlightRowHeaders) {
    activeRowHeaderHighlight?.add(this.tableProps.createCellCoords(Math.max(cellRange.from.row ?? 0, 0), Math.min(-this.tableProps.countRowHeaders(), -1))).add(this.tableProps.createCellCoords(Math.max(cellRange.to.row ?? 0, 0), -1)).commit();
  }
  if (highlightColumnHeaders) {
    activeColumnHeaderHighlight?.add(this.tableProps.createCellCoords(Math.min(-this.tableProps.countColHeaders(), -1), Math.max(cellRange.from.col ?? 0, 0))).add(this.tableProps.createCellCoords(-1, Math.max(cellRange.to.col ?? 0, 0))).commit();
  }
  if (highlightRowHeaders && highlightColumnHeaders) {
    activeCornerHeaderHighlight?.add(this.tableProps.createCellCoords(-this.tableProps.countColHeaders(), -this.tableProps.countRowHeaders())).add(this.tableProps.createCellCoords(-1, -1)).commit();
  }
}
mixin(Selection2, localHooks);
const regUniversalNewLine = /^(\r\n|\n\r|\r|\n)/;
const regNextCellNoQuotes = /^[^\t\r\n]+/;
const regNextEmptyCell = /^\t/;
function findQuoteCloseIndex(str) {
  let i = 0;
  while (i < str.length) {
    if (str[i] === '"') {
      if (str[i + 1] === '"') {
        i += 2;
        continue;
      }
      const next = str[i + 1];
      if (next === void 0 || next === "	" || next === "\r" || next === "\n") {
        return i;
      }
    }
    i += 1;
  }
  return -1;
}
function parse(str) {
  const arr = [
    [
      ""
    ]
  ];
  if (str.length === 0) {
    return arr;
  }
  let column = 0;
  let row = 0;
  let lastLength;
  while (str.length > 0) {
    if (lastLength === str.length) {
      break;
    }
    lastLength = str.length;
    if (str.match(regNextEmptyCell)) {
      str = str.replace(regNextEmptyCell, "");
      column += 1;
      arr[row][column] = "";
    } else if (str.match(regUniversalNewLine)) {
      str = str.replace(regUniversalNewLine, "");
      column = 0;
      row += 1;
      arr[row] = [
        ""
      ];
    } else {
      let nextCell = "";
      if (str.startsWith('"')) {
        const closeIndex = findQuoteCloseIndex(str.slice(1));
        if (closeIndex !== -1) {
          let i = 0;
          const content = str.slice(1);
          while (i < closeIndex) {
            if (content[i] === '"' && content[i + 1] === '"') {
              nextCell += '"';
              i += 2;
            } else {
              nextCell += content[i];
              i += 1;
            }
          }
          str = str.slice(closeIndex + 2);
        } else {
          let quoteNo = 0;
          let isStillCell = true;
          while (isStillCell) {
            const nextChar = str.slice(0, 1);
            if (nextChar === '"') {
              quoteNo += 1;
            }
            nextCell += nextChar;
            str = str.slice(1);
            if (str.length === 0 || str.match(/^[\t\r\n]/) && quoteNo % 2 === 0) {
              isStillCell = false;
            }
          }
          nextCell = nextCell.replace(/^"/, "").replace(/"$/, "").replace(/["]*/g, (match) => new Array(Math.floor(match.length / 2)).fill('"').join(""));
        }
      } else {
        const matchedText = str.match(regNextCellNoQuotes);
        nextCell = matchedText ? matchedText[0] : "";
        str = str.slice(nextCell.length);
      }
      arr[row][column] = nextCell;
    }
  }
  return arr;
}
function stringify(arr) {
  let r;
  let rLen;
  let c;
  let cLen;
  let str = "";
  let val;
  for (r = 0, rLen = arr.length; r < rLen; r += 1) {
    cLen = arr[r].length;
    for (c = 0; c < cLen; c += 1) {
      if (c > 0) {
        str += "	";
      }
      val = arr[r][c];
      if (typeof val === "string") {
        if (val.indexOf("\n") > -1) {
          str += `"${val.replaceAll('"', '""')}"`;
        } else {
          str += val;
        }
      } else if (val === null || val === void 0) {
        str += "";
      } else {
        str += val;
      }
    }
    if (r !== rLen - 1) {
      str += "\n";
    }
  }
  return str;
}
function getValueSetterValue(value, cellMeta) {
  const { instance, visualRow, visualCol, valueSetter: valueSetter2 } = cellMeta;
  if (isFunction$1(valueSetter2)) {
    return valueSetter2.call(instance, value, visualRow, visualCol, cellMeta);
  }
  return value;
}
function getValueGetterValue(value, cellMeta) {
  const { instance, visualRow, visualCol, valueGetter: valueGetter2 } = cellMeta;
  if (isFunction$1(valueGetter2)) {
    return valueGetter2.call(instance, value, visualRow, visualCol, cellMeta);
  }
  return value;
}
function _check_private_redeclaration$1o(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$Z(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$Z(obj, privateSet) {
  _check_private_redeclaration$1o(obj, privateSet);
  privateSet.add(obj);
}
var _buildColumnCache = /* @__PURE__ */ new WeakSet(), _insertColumnIntoDataSource = /* @__PURE__ */ new WeakSet(), _spliceRemovedColumns = /* @__PURE__ */ new WeakSet();
class DataMap {
  /**
  * @type {number}
  */
  static get DESTINATION_RENDERER() {
    return 1;
  }
  /**
  * @type {number}
  */
  static get DESTINATION_CLIPBOARD_GENERATOR() {
    return 2;
  }
  /**
  * Generates cache for property to and from column addressation.
  */
  createMap() {
    const schema = this.getSchema();
    if (typeof schema === "undefined") {
      throwWithCause("trying to create `columns` definition but you didn't provide `schema` nor `data`");
    }
    const columns = this.tableMeta.columns;
    this.colToPropCache = [];
    this.propToColCache = /* @__PURE__ */ new Map();
    if (columns) {
      _class_private_method_get$Z(this, _buildColumnCache, buildColumnCache).call(this, columns, schema);
    } else {
      this.recursiveDuckColumns(schema);
    }
  }
  /**
  * Get the amount of physical columns in the first data row.
  *
  * @returns {number} Amount of physical columns in the first data row.
  */
  countFirstRowKeys() {
    return countFirstRowKeys(this.dataSource ?? []);
  }
  /**
  * Generates columns' translation cache.
  *
  * @param {object} schema An object to generate schema from.
  * @param {number} lastCol The column index.
  * @param {number} parent The property cache for recursive calls.
  * @returns {number}
  */
  recursiveDuckColumns(schema, lastCol, parent) {
    let lastColumn = lastCol ?? 0;
    const propertyParent = parent ?? "";
    let prop;
    if (typeof schema === "object" && schema !== null && !Array.isArray(schema)) {
      objectEach(schema, (value, key) => {
        if (value === null) {
          prop = propertyParent + key;
          this.colToPropCache.push(prop);
          this.propToColCache.set(prop, lastColumn);
          lastColumn += 1;
        } else if (typeof value === "object" && value !== null) {
          lastColumn = this.recursiveDuckColumns(value, lastColumn, `${key}.`);
        }
      });
    }
    return lastColumn;
  }
  /**
  * Returns property name that corresponds with the given column index.
  *
  * @param {string|number} column Visual column index or another passed argument.
  * @returns {string|number} Column property, physical column index or passed argument.
  */
  colToProp(column) {
    if (Number.isInteger(column) === false) {
      return column;
    }
    const physicalColumn = this.hot.toPhysicalColumn(column);
    if (physicalColumn === null) {
      return column;
    }
    if (this.colToPropCache && isDefined(this.colToPropCache[physicalColumn])) {
      return this.colToPropCache[physicalColumn];
    }
    return physicalColumn;
  }
  /**
  * Translates property into visual column index.
  *
  * @param {string|number} prop Column property which may be also a physical column index.
  * @returns {string|number} Visual column index or passed argument.
  */
  propToCol(prop) {
    const cachedPhysicalIndex = this.propToColCache.get(prop);
    if (cachedPhysicalIndex !== void 0) {
      return this.hot.toVisualColumn(cachedPhysicalIndex);
    }
    if (typeof prop !== "number") {
      return prop;
    }
    const visualColumn = this.hot.toVisualColumn(prop);
    return visualColumn !== null ? visualColumn : prop;
  }
  /**
  * Returns data's schema.
  *
  * @returns {object}
  */
  getSchema() {
    const schema = this.tableMeta.dataSchema;
    if (schema) {
      if (typeof schema === "function") {
        return schema();
      }
      return schema;
    }
    return this.duckSchema;
  }
  /**
  * Creates the duck schema based on the current dataset.
  *
  * @returns {Array|object}
  */
  createDuckSchema() {
    return this.dataSource && this.dataSource[0] ? duckSchema(this.dataSource[0]) : {};
  }
  /**
  * Refresh the data schema.
  */
  refreshDuckSchema() {
    this.duckSchema = this.createDuckSchema();
  }
  /**
  * Creates row at the bottom of the data array.
  *
  * @param {number} [index] Physical index of the row before which the new row will be inserted.
  * @param {number} [amount=1] An amount of rows to add.
  * @param {object} [options] Additional options for created rows.
  * @param {string} [options.source] Source of method call.
  * @param {'above'|'below'} [options.mode] Sets where the row is inserted: above or below the passed index.
  * @fires Hooks#afterCreateRow
  * @returns {number} Returns number of created rows.
  */
  createRow(index2, amount = 1, { source, mode = "above" } = {}) {
    const sourceRowsCount = this.hot.countSourceRows();
    let physicalRowIndex = sourceRowsCount;
    let numberOfCreatedRows = 0;
    let rowIndex = index2;
    if (typeof rowIndex !== "number" || rowIndex >= sourceRowsCount) {
      rowIndex = sourceRowsCount;
    }
    if (rowIndex < this.hot.countRows()) {
      physicalRowIndex = this.hot.toPhysicalRow(rowIndex);
    }
    const continueProcess = this.hot.runHooks("beforeCreateRow", rowIndex, amount, source);
    if (continueProcess === false || physicalRowIndex === null) {
      return {
        delta: 0
      };
    }
    const maxRows = this.tableMeta.maxRows;
    const columnCount = this.getSchema().length;
    const rowsToAdd = [];
    while (numberOfCreatedRows < amount && sourceRowsCount + numberOfCreatedRows < (maxRows ?? Infinity)) {
      let row = null;
      if (this.hot.dataType === "array") {
        if (this.tableMeta.dataSchema) {
          row = deepClone(this.getSchema());
        } else {
          row = [];
          rangeEach(columnCount - 1, () => row.push(null));
        }
      } else if (this.hot.dataType === "function") {
        const dataSchemaFn = this.tableMeta.dataSchema;
        if (typeof dataSchemaFn !== "function") {
          throwWithCause("`dataSchema` must be a function when `dataType` is `function`");
        }
        row = dataSchemaFn(rowIndex + numberOfCreatedRows);
      } else {
        row = {};
        deepExtend(row, this.getSchema());
      }
      rowsToAdd.push(row);
      numberOfCreatedRows += 1;
    }
    this.hot.rowIndexMapper.insertIndexes(rowIndex, numberOfCreatedRows);
    if (mode === "below") {
      physicalRowIndex = Math.min(physicalRowIndex + 1, sourceRowsCount);
    }
    this.spliceData(physicalRowIndex, 0, rowsToAdd);
    const newVisualRowIndex = this.hot.toVisualRow(physicalRowIndex);
    if (this.hot.countSourceRows() === rowsToAdd.length) {
      this.hot.columnIndexMapper.initToLength(this.hot.getInitialColumnCount());
    }
    if (numberOfCreatedRows > 0) {
      if (index2 === void 0 || index2 === null) {
        this.metaManager.createRow(null, numberOfCreatedRows);
      } else if (source !== "auto") {
        this.metaManager.createRow(physicalRowIndex, amount);
      }
    }
    this.hot.runHooks("afterCreateRow", newVisualRowIndex, numberOfCreatedRows, source);
    return {
      delta: numberOfCreatedRows,
      startPhysicalIndex: physicalRowIndex
    };
  }
  /**
  * Creates column at the right of the data array.
  *
  * @param {number} [index] Visual index of the column before which the new column will be inserted.
  * @param {number} [amount=1] An amount of columns to add.
  * @param {object} [options] Additional options for created columns.
  * @param {string} [options.source] Source of method call.
  * @param {'start'|'end'} [options.mode] Sets where the column is inserted: at the start (left in [LTR](@/api/options.md#layoutdirection), right in [RTL](@/api/options.md#layoutdirection)) or at the end (right in LTR, left in LTR)
  * the passed index.
  * @fires Hooks#afterCreateCol
  * @returns {number} Returns number of created columns.
  */
  createCol(index2, amount = 1, { source, mode = "start" } = {}) {
    if (!this.hot.isColumnModificationAllowed()) {
      throwWithCause("Cannot create new column. When data source in an object, you can only have as much columns as defined in first data row, data schema or in the 'columns' setting.If you want to be able to add new columns, you have to use array datasource.");
    }
    const dataSource = this.dataSource ?? [];
    const maxCols = this.tableMeta.maxCols;
    const numberOfSourceCols = this.hot.countSourceCols();
    const numberOfVisualCols = this.hot.countCols();
    const numberOfSourceRows = this.hot.countSourceRows();
    const visualColumnIndex = typeof index2 === "number" && index2 <= numberOfSourceCols ? index2 : numberOfVisualCols;
    if (this.hot.runHooks("beforeCreateCol", visualColumnIndex, amount, source) === false) {
      return {
        delta: 0
      };
    }
    const physicalColumnIndex = visualColumnIndex < numberOfVisualCols ? this.hot.toPhysicalColumn(visualColumnIndex) : numberOfSourceCols;
    const firstNewPhysicalColumnIndex = mode === "end" ? Math.min(physicalColumnIndex + 1, numberOfSourceCols) : physicalColumnIndex;
    let numberOfCreatedCols = 0;
    for (let col = firstNewPhysicalColumnIndex; numberOfCreatedCols < amount && numberOfVisualCols + numberOfCreatedCols < (maxCols ?? Infinity); col++, numberOfCreatedCols++) {
      _class_private_method_get$Z(this, _insertColumnIntoDataSource, insertColumnIntoDataSource).call(this, dataSource, col, visualColumnIndex, numberOfVisualCols + numberOfCreatedCols, numberOfSourceRows);
    }
    if (numberOfCreatedCols > 0) {
      if (index2 === void 0 || index2 === null) {
        this.metaManager.createColumn(null, numberOfCreatedCols);
      } else if (source !== "auto") {
        this.metaManager.createColumn(firstNewPhysicalColumnIndex, amount);
      }
    }
    this.hot.columnIndexMapper.insertIndexes(visualColumnIndex, numberOfCreatedCols, mode);
    this.hot.runHooks("afterCreateCol", this.hot.toVisualColumn(firstNewPhysicalColumnIndex), numberOfCreatedCols, source);
    this.refreshDuckSchema();
    return {
      delta: numberOfCreatedCols,
      startPhysicalIndex: firstNewPhysicalColumnIndex
    };
  }
  /**
  * Removes row from the data array.
  *
  * @fires Hooks#beforeRemoveRow
  * @fires Hooks#afterRemoveRow
  * @param {number} [index] Visual index of the row to be removed. If not provided, the last row will be removed.
  * @param {number} [amount=1] Amount of the rows to be removed. If not provided, one row will be removed.
  * @param {string} [source] Source of method call.
  * @returns {boolean} Returns `false` when action was cancelled, otherwise `true`.
  */
  removeRow(index2, amount = 1, source) {
    let rowIndex = Number.isInteger(index2) ? index2 : -amount;
    const removedPhysicalIndexes = this.visualRowsToPhysical(rowIndex, amount);
    const visualRowsLength = this.hot.countRows();
    rowIndex = (visualRowsLength + rowIndex) % visualRowsLength;
    const actionWasNotCancelled = this.hot.runHooks("beforeRemoveRow", rowIndex, removedPhysicalIndexes.length, removedPhysicalIndexes, source);
    if (actionWasNotCancelled === false) {
      return false;
    }
    const numberOfRemovedIndexes = removedPhysicalIndexes.length;
    this.filterData(rowIndex, numberOfRemovedIndexes, removedPhysicalIndexes);
    if (rowIndex < this.hot.countRows()) {
      this.hot.rowIndexMapper.removeIndexes(removedPhysicalIndexes);
      const preserveColumns = isDefined(this.tableMeta.columns) || isDefined(this.tableMeta.dataSchema) || this.tableMeta.colHeaders;
      if (this.hot.rowIndexMapper.getNotTrimmedIndexesLength() === 0 && !preserveColumns) {
        this.hot.columnIndexMapper.setIndexesSequence([]);
      }
    }
    const descendingPhysicalRows = removedPhysicalIndexes.slice(0).sort((a, b) => b - a);
    descendingPhysicalRows.forEach((rowPhysicalIndex) => {
      this.metaManager.removeRow(rowPhysicalIndex, 1);
    });
    this.hot.runHooks("afterRemoveRow", rowIndex, numberOfRemovedIndexes, removedPhysicalIndexes, source);
    return true;
  }
  /**
  * Removes column from the data array.
  *
  * @fires Hooks#beforeRemoveCol
  * @fires Hooks#afterRemoveCol
  * @param {number} [index] Visual index of the column to be removed. If not provided, the last column will be removed.
  * @param {number} [amount=1] Amount of the columns to be removed. If not provided, one column will be removed.
  * @param {string} [source] Source of method call.
  * @returns {boolean} Returns `false` when action was cancelled, otherwise `true`.
  */
  removeCol(index2, amount = 1, source) {
    if (this.hot.dataType === "object" || this.tableMeta.columns) {
      throwWithCause("cannot remove column with object data source or columns option specified");
    }
    let columnIndex = typeof index2 !== "number" ? -amount : index2;
    columnIndex = (this.hot.countCols() + columnIndex) % this.hot.countCols();
    const removedPhysicalIndexes = this.visualColumnsToPhysical(columnIndex, amount);
    const descendingPhysicalColumns = removedPhysicalIndexes.slice(0).sort((a, b) => b - a);
    const actionWasNotCancelled = this.hot.runHooks("beforeRemoveCol", columnIndex, amount, removedPhysicalIndexes, source);
    if (actionWasNotCancelled === false) {
      return false;
    }
    let isTableUniform = true;
    const removedColumnsCount = descendingPhysicalColumns.length;
    const data = this.dataSource ?? [];
    for (let c = 0; c < removedColumnsCount; c++) {
      if (isTableUniform && removedPhysicalIndexes[0] !== removedPhysicalIndexes[c] - c) {
        isTableUniform = false;
      }
    }
    _class_private_method_get$Z(this, _spliceRemovedColumns, spliceRemovedColumns).call(this, data, isTableUniform, removedPhysicalIndexes, descendingPhysicalColumns, amount);
    if (columnIndex < this.hot.countCols()) {
      this.hot.columnIndexMapper.removeIndexes(removedPhysicalIndexes);
      if (!this.tableMeta.rowHeaders && this.hot.columnIndexMapper.getNotTrimmedIndexesLength() === 0) {
        this.hot.rowIndexMapper.setIndexesSequence([]);
      }
    }
    this.hot.runHooks("afterRemoveCol", columnIndex, amount, removedPhysicalIndexes, source);
    this.refreshDuckSchema();
    return true;
  }
  /**
  * Add/Removes data from the column.
  *
  * @param {number} col Physical index of column in which do you want to do splice.
  * @param {number} index Index at which to start changing the array. If negative, will begin that many elements from the end.
  * @param {number} amount An integer indicating the number of old array elements to remove. If amount is 0, no elements are removed.
  * @param {Array} [elements] The new columns to add.
  * @returns {Array} Returns removed portion of columns.
  */
  spliceCol(col, index2, amount, ...elements) {
    const colData = this.hot.getDataAtCol(col);
    const removed = colData.slice(index2, index2 + amount);
    const after = colData.slice(index2 + amount);
    extendArray(elements, after);
    let i = 0;
    while (i < amount) {
      elements.push(null);
      i += 1;
    }
    to2dArray(elements);
    this.hot.populateFromArray(index2, col, elements, void 0, void 0, "spliceCol");
    return removed;
  }
  /**
  * Add/Removes data from the row.
  *
  * @param {number} row Physical index of row in which do you want to do splice.
  * @param {number} index Index at which to start changing the array. If negative, will begin that many elements from the end.
  * @param {number} amount An integer indicating the number of old array elements to remove. If amount is 0, no elements are removed.
  * @param {Array} [elements] The new rows to add.
  * @returns {Array} Returns removed portion of rows.
  */
  spliceRow(row, index2, amount, ...elements) {
    const rowData = this.hot.getSourceDataAtRow(row);
    const removed = rowData.slice(index2, index2 + amount);
    const after = rowData.slice(index2 + amount);
    extendArray(elements, after);
    let i = 0;
    while (i < amount) {
      elements.push(null);
      i += 1;
    }
    this.hot.populateFromArray(row, index2, [
      elements
    ], void 0, void 0, "spliceRow");
    return removed;
  }
  /**
  * Add/remove row(s) to/from the data source.
  *
  * @param {number} index Physical index of the element to add/remove.
  * @param {number} deleteCount Number of rows to remove.
  * @param {Array<object>} elements Row elements to be added.
  */
  spliceData(index2, deleteCount, elements) {
    const continueSplicing = this.hot.runHooks("beforeDataSplice", index2, deleteCount, elements);
    if (continueSplicing !== false) {
      const newData = [
        ...this.dataSource.slice(0, index2),
        ...elements,
        ...this.dataSource.slice(index2)
      ];
      this.dataSource.length = 0;
      newData.forEach((row) => this.dataSource.push(row));
    }
  }
  /**
  * Filter unwanted data elements from the data source.
  *
  * @param {number} index Visual index of the element to remove.
  * @param {number} amount Number of rows to add/remove.
  * @param {number} physicalRows Physical row indexes.
  */
  filterData(index2, amount, physicalRows) {
    let data = this.hot.runHooks("filterData", index2, amount, physicalRows);
    if (Array.isArray(data) === false) {
      data = this.dataSource.filter((_row, rowIndex) => physicalRows.indexOf(rowIndex) === -1);
    }
    this.dataSource.length = 0;
    Array.prototype.push.apply(this.dataSource, data);
  }
  /**
  * Returns single value from the data array.
  *
  * @param {number} row Visual row index.
  * @param {number} prop The column property.
  * @returns {*}
  */
  get(row, prop) {
    const physicalRow = this.hot.toPhysicalRow(row);
    let dataRow = this.dataSource[physicalRow];
    const modifiedRowData = this.hot.runHooks("modifyRowData", physicalRow);
    dataRow = typeof modifiedRowData !== "number" ? modifiedRowData : dataRow;
    const { dataDotNotation } = this.hot.getSettings();
    let value = null;
    if (dataRow && hasOwnProperty(dataRow, prop)) {
      value = dataRow[prop];
    } else if (dataDotNotation && typeof prop === "string" && prop.indexOf(".") > -1) {
      let out = dataRow;
      if (!out) {
        return null;
      }
      const sliced = prop.split(".");
      for (let i = 0, ilen = sliced.length; i < ilen; i++) {
        out = out[sliced[i]];
        if (typeof out === "undefined") {
          return null;
        }
      }
      value = out;
    } else if (typeof prop === "function") {
      value = prop(this.dataSource.slice(physicalRow, physicalRow + 1)[0]);
    }
    const visualColumnIndex = this.propToCol(prop);
    const physicalColumn = typeof visualColumnIndex === "number" ? this.hot.toPhysicalColumn(visualColumnIndex) : null;
    if (isUnsignedNumber(physicalRow) && isUnsignedNumber(physicalColumn)) {
      value = getValueGetterValue(value, this.metaManager.getCellMeta(physicalRow, physicalColumn, {
        visualRow: row,
        visualColumn: visualColumnIndex,
        skipMetaExtension: true
      }));
    }
    if (this.hot.hasHook("modifyData")) {
      const valueHolder = createObjectPropListener(value);
      this.hot.runHooks("modifyData", row, visualColumnIndex, valueHolder, "get");
      if (valueHolder.isTouched()) {
        value = valueHolder.value;
      }
    }
    return value;
  }
  /**
  * Returns single value from the data array (intended for clipboard copy to an external application).
  *
  * @param {number} row Visual row index.
  * @param {number} prop The column property.
  * @returns {string}
  */
  getCopyable(row, prop) {
    const colIndex = this.propToCol(prop);
    if (typeof colIndex === "number" && this.hot.getCellMeta(row, colIndex).copyable) {
      return this.get(row, prop);
    }
    return "";
  }
  /**
  * Saves single value to the data array.
  *
  * @param {number} row Visual row index.
  * @param {number|string} prop The column property.
  * @param {string} value The value to set.
  */
  set(row, prop, value) {
    const physicalRow = this.hot.toPhysicalRow(row);
    let newValue = value;
    let dataRow = this.dataSource[physicalRow];
    const modifiedRowData = this.hot.runHooks("modifyRowData", physicalRow);
    dataRow = typeof modifiedRowData !== "number" ? modifiedRowData : dataRow;
    if (this.hot.hasHook("modifyData")) {
      const valueHolder = createObjectPropListener(newValue);
      this.hot.runHooks("modifyData", row, this.propToCol(prop), valueHolder, "set");
      if (valueHolder.isTouched()) {
        newValue = valueHolder.value;
      }
    }
    const { dataDotNotation } = this.hot.getSettings();
    if (dataRow && hasOwnProperty(dataRow, prop)) {
      dataRow[prop] = newValue;
    } else if (dataDotNotation && typeof prop === "string" && prop.indexOf(".") > -1) {
      let out = dataRow;
      let i = 0;
      let ilen;
      const sliced = prop.split(".");
      for (i = 0, ilen = sliced.length - 1; i < ilen; i++) {
        if (sliced[i] === "__proto__" || sliced[i] === "constructor" || sliced[i] === "prototype") {
          return;
        }
        if (typeof out[sliced[i]] === "undefined") {
          out[sliced[i]] = {};
        }
        out = out[sliced[i]];
      }
      out[sliced[i]] = newValue;
    } else if (typeof prop === "function") {
      prop(this.dataSource.slice(physicalRow, physicalRow + 1)[0], newValue);
    } else {
      if (prop === "__proto__" || prop === "constructor" || prop === "prototype") {
        return;
      }
      dataRow[prop] = newValue;
    }
  }
  /**
  * This ridiculous piece of code maps rows Id that are present in table data to those displayed for user.
  * The trick is, the physical row id (stored in settings.data) is not necessary the same
  * as the visual (displayed) row id (e.g. When sorting is applied).
  *
  * @param {number} index Visual row index.
  * @param {number} amount An amount of rows to translate.
  * @returns {number}
  */
  visualRowsToPhysical(index2, amount) {
    const totalRows = this.hot.countRows();
    const logicRows = [];
    let visualRow = (totalRows + index2) % totalRows;
    let rowsToRemove = amount;
    let row;
    while (visualRow < totalRows && rowsToRemove) {
      row = this.hot.toPhysicalRow(visualRow);
      logicRows.push(row);
      rowsToRemove -= 1;
      visualRow += 1;
    }
    return logicRows;
  }
  /**
  *
  * @param {number} index Visual column index.
  * @param {number} amount An amount of rows to translate.
  * @returns {Array}
  */
  visualColumnsToPhysical(index2, amount) {
    const totalCols = this.hot.countCols();
    const visualCols = [];
    let physicalCol = (totalCols + index2) % totalCols;
    let colsToRemove = amount;
    while (physicalCol < totalCols && colsToRemove) {
      const col = this.hot.toPhysicalColumn(physicalCol);
      visualCols.push(col);
      colsToRemove -= 1;
      physicalCol += 1;
    }
    return visualCols;
  }
  /**
  * Clears the data array.
  */
  clear() {
    for (let r = 0; r < this.hot.countSourceRows(); r++) {
      for (let c = 0; c < this.hot.countCols(); c++) {
        this.set(r, this.colToProp(c), "");
      }
    }
  }
  /**
  * Get data length.
  *
  * @returns {number}
  */
  getLength() {
    const maxRowsFromSettings = this.tableMeta.maxRows;
    let maxRows;
    if ((maxRowsFromSettings ?? 0) < 0 || maxRowsFromSettings === 0) {
      maxRows = 0;
    } else {
      maxRows = maxRowsFromSettings || Infinity;
    }
    const length = this.hot.rowIndexMapper.getNotTrimmedIndexesLength();
    return Math.min(length, maxRows);
  }
  /**
  * Returns the data array.
  *
  * @returns {Array}
  */
  getAll() {
    const start = {
      row: 0,
      col: 0
    };
    const end = {
      row: Math.max(this.hot.countRows() - 1, 0),
      col: Math.max(this.hot.countCols() - 1, 0)
    };
    if (start.row - end.row === 0 && !this.hot.countSourceRows()) {
      return [];
    }
    return this.getRange(start, end, DataMap.DESTINATION_RENDERER);
  }
  /**
  * Count the number of columns cached in the `colToProp` cache.
  *
  * @returns {number} Amount of cached columns.
  */
  countCachedColumns() {
    return this.colToPropCache.length;
  }
  /**
  * Returns data range as array.
  *
  * @param {object} [start] Start selection position. Visual indexes.
  * @param {object} [end] End selection position. Visual indexes.
  * @param {number} destination Destination of datamap.get.
  * @returns {Array}
  */
  getRange(start, end, destination) {
    const output = [];
    let r;
    let c;
    let row;
    const maxRows = this.tableMeta.maxRows;
    const maxCols = this.tableMeta.maxCols;
    if (maxRows === 0 || maxCols === 0) {
      return [];
    }
    const getFn = destination === DataMap.DESTINATION_CLIPBOARD_GENERATOR ? this.getCopyable : this.get;
    const rlen = Math.min(Math.max((maxRows ?? Infinity) - 1, 0), Math.max(start.row, end.row));
    const clen = Math.min(Math.max((maxCols ?? Infinity) - 1, 0), Math.max(start.col, end.col));
    for (r = Math.min(start.row, end.row); r <= rlen; r++) {
      row = [];
      const physicalRow = r >= 0 ? this.hot.toPhysicalRow(r) : r;
      for (c = Math.min(start.col, end.col); c <= clen; c++) {
        if (physicalRow === null) {
          break;
        }
        row.push(getFn.call(this, r, this.colToProp(c)));
      }
      if (physicalRow !== null) {
        output.push(row);
      }
    }
    return output;
  }
  /**
  * Return data as text (tab separated columns).
  *
  * @param {object} [start] Start selection position. Visual indexes.
  * @param {object} [end] End selection position. Visual indexes.
  * @returns {string}
  */
  getText(start, end) {
    return stringify(this.getRange(start, end, DataMap.DESTINATION_RENDERER));
  }
  /**
  * Return data as copyable text (tab separated columns intended for clipboard copy to an external application).
  *
  * @param {object} [start] Start selection position. Visual indexes.
  * @param {object} [end] End selection position. Visual indexes.
  * @returns {string}
  */
  getCopyableText(start, end) {
    return stringify(this.getRange(start, end, DataMap.DESTINATION_CLIPBOARD_GENERATOR));
  }
  /**
  * Destroy instance.
  */
  destroy() {
    this.hot = null;
    this.metaManager = null;
    this.dataSource = null;
    this.duckSchema = null;
    this.colToPropCache.length = 0;
    this.propToColCache.clear();
    this.propToColCache = void 0;
  }
  /**
  * @param {object} hotInstance Instance of Handsontable.
  * @param {Array} data Array of arrays or array of objects containing data.
  * @param {MetaManager} metaManager The meta manager instance.
  */
  constructor(hotInstance, data, metaManager) {
    _class_private_method_init$Z(this, _buildColumnCache);
    _class_private_method_init$Z(this, _insertColumnIntoDataSource);
    _class_private_method_init$Z(this, _spliceRemovedColumns);
    this.hot = hotInstance;
    this.metaManager = metaManager;
    this.tableMeta = metaManager.getTableMeta();
    this.dataSource = data;
    this.colToPropCache = [];
    this.propToColCache = /* @__PURE__ */ new Map();
    this.refreshDuckSchema();
    this.createMap();
  }
}
function buildColumnCache(columns, schema) {
  let columnsLen = 0;
  let filteredIndex = 0;
  const isColumnsFn = typeof columns === "function";
  if (isColumnsFn) {
    const schemaLen = deepObjectSize(schema);
    columnsLen = schemaLen > 0 ? schemaLen : this.countFirstRowKeys();
  } else {
    const maxCols = this.tableMeta.maxCols;
    columnsLen = Math.min(maxCols ?? Infinity, columns.length);
  }
  for (let i = 0; i < columnsLen; i++) {
    const column = isColumnsFn ? columns(i) : columns[i];
    if (isObject$1(column)) {
      if (typeof column.data !== "undefined") {
        const index2 = isColumnsFn ? filteredIndex : i;
        const columnData = column.data;
        this.colToPropCache[index2] = columnData;
        this.propToColCache.set(columnData, index2);
      }
      filteredIndex += 1;
    }
  }
}
function insertColumnIntoDataSource(dataSource, col, visualColumnIndex, currentVisualColCount, numberOfSourceRows) {
  if (typeof visualColumnIndex !== "number" || visualColumnIndex >= currentVisualColCount) {
    if (numberOfSourceRows > 0) {
      for (let row = 0; row < numberOfSourceRows; row += 1) {
        if (typeof dataSource[row] === "undefined") {
          dataSource[row] = [];
        }
        dataSource[row].push(null);
      }
    } else {
      dataSource.push([
        null
      ]);
    }
  } else {
    for (let row = 0; row < numberOfSourceRows; row++) {
      dataSource[row].splice(col, 0, null);
    }
  }
}
function spliceRemovedColumns(data, isTableUniform, removedPhysicalIndexes, descendingPhysicalColumns, amount) {
  if (isTableUniform) {
    for (let r = 0, rlen = this.hot.countSourceRows(); r < rlen; r++) {
      data[r].splice(removedPhysicalIndexes[0], amount);
      if (r === 0) {
        this.metaManager.removeColumn(removedPhysicalIndexes[0], amount);
      }
    }
  } else {
    const removedColumnsCount = descendingPhysicalColumns.length;
    for (let r = 0, rlen = this.hot.countSourceRows(); r < rlen; r++) {
      for (let c = 0; c < removedColumnsCount; c++) {
        data[r].splice(descendingPhysicalColumns[c], 1);
        if (r === 0) {
          this.metaManager.removeColumn(descendingPhysicalColumns[c], 1);
        }
      }
    }
  }
}
class DataSource {
  /**
  * Run the `modifyRowData` hook and return either the modified or the source data for the provided row.
  *
  * @private
  * @param {number} rowIndex Row index.
  * @returns {Array|object} Source or modified row of data.
  */
  modifyRowData(rowIndex) {
    let modifyRowData;
    if (this.hot.hasHook("modifyRowData")) {
      modifyRowData = this.hot.runHooks("modifyRowData", rowIndex);
    }
    return modifyRowData !== void 0 && !Number.isInteger(modifyRowData) ? modifyRowData : this.data[rowIndex];
  }
  /**
  * Get all data.
  *
  * Each call returns a fresh shallow clone of the source data so consumers can
  * safely mutate the returned array without affecting subsequent calls or the
  * underlying data. The fast path skips the per-cell hook lookups in
  * `getByRange()` and is taken when no `modifySourceData` / `modifyRowData`
  * hooks are registered and the caller does not request array-of-arrays
  * coercion (which needs the `colToProp` mapping `getByRange()` supplies).
  *
  * @param {boolean} [toArray=false] If `true` return source data as an array of arrays even when source data was provided
  *                                  in another format.
  * @returns {Array}
  */
  getData(toArray = false) {
    if (!this.data?.length) {
      return this.data;
    }
    if (!toArray && !this.hot.hasHook("modifySourceData") && !this.hot.hasHook("modifyRowData")) {
      return this.data.map(cloneRow);
    }
    return this.getByRange(null, null, toArray);
  }
  /**
  * Set new data source.
  *
  * @param {Array} data The new data.
  */
  setData(data) {
    this.data = data;
  }
  /**
  * Returns array of column values from the data source. `column` is the index of the row in the data source.
  *
  * @param {number} column Visual column index.
  * @returns {Array}
  */
  getAtColumn(column) {
    const result = [];
    arrayEach(this.data, (row, rowIndex) => {
      const value = this.getAtCell(rowIndex, column);
      result.push(value);
    });
    return result;
  }
  /**
  * Returns a single row of the data or a subset of its columns. If a column range or `toArray` arguments are provided, it
  * operates only on the columns declared by the `columns` setting or the data schema.
  *
  * @param {number} row Physical row index.
  * @param {number} [startColumn] Starting index for the column range (optional).
  * @param {number} [endColumn] Ending index for the column range (optional).
  * @param {boolean} [toArray=false] `true` if the returned value should be forced to be presented as an array.
  * @returns {Array|object}
  */
  getAtRow(row, startColumn, endColumn, toArray = false) {
    const getAllProps = startColumn === void 0 && endColumn === void 0;
    const { dataDotNotation } = this.hot.getSettings();
    let dataRow = null;
    let newDataRow = null;
    dataRow = this.modifyRowData(row);
    if (Array.isArray(dataRow)) {
      newDataRow = [];
      if (getAllProps) {
        dataRow.forEach((cell, column) => {
          newDataRow[column] = this.getAtPhysicalCell(row, column, dataRow);
        });
      } else {
        rangeEach(startColumn, endColumn, (column) => {
          newDataRow[column - startColumn] = this.getAtPhysicalCell(row, column, dataRow);
        });
      }
    } else if (isObject$1(dataRow) || isFunction$1(dataRow)) {
      if (toArray) {
        newDataRow = [];
      } else {
        newDataRow = {};
      }
      if (!getAllProps || toArray) {
        const rangeStart = 0;
        const rangeEnd = this.countFirstRowKeys() - 1;
        rangeEach(rangeStart, rangeEnd, (column) => {
          const prop = this.colToProp(column);
          if (column >= (startColumn || rangeStart) && column <= (endColumn || rangeEnd) && !Number.isInteger(prop)) {
            const cellValue = this.getAtPhysicalCell(row, prop, dataRow);
            if (toArray) {
              newDataRow.push(cellValue);
            } else if (dataDotNotation) {
              if (newDataRow !== null) {
                setProperty(newDataRow, prop, cellValue);
              }
            } else {
              newDataRow[prop] = cellValue;
            }
          }
        });
      } else {
        objectEach(dataRow, (value, prop) => {
          const cellValue = this.getAtPhysicalCell(row, prop, dataRow);
          if (dataDotNotation) {
            if (newDataRow !== null) {
              setProperty(newDataRow, prop, cellValue);
            }
          } else {
            newDataRow[prop] = cellValue;
          }
        });
      }
    }
    return newDataRow;
  }
  /**
  * Set the provided value in the source data set at the provided coordinates.
  *
  * @param {number|string} row Physical row index.
  * @param {number|string} column Property name / physical column index.
  * @param {*} value The value to be set at the provided coordinates.
  */
  setAtCell(row, column, value) {
    let normalizedRow;
    if (typeof row === "string") {
      const parsed = Number(row);
      if (Number.isNaN(parsed) || !Number.isInteger(parsed) || parsed < 0) {
        return;
      }
      normalizedRow = parsed;
    } else if (typeof row !== "number" || !Number.isInteger(row) || row < 0) {
      return;
    } else {
      normalizedRow = row;
    }
    if (normalizedRow >= this.countRows() || typeof column === "number" && column >= this.countFirstRowKeys()) {
      return;
    }
    if (this.hot.hasHook("modifySourceData")) {
      const valueHolder = createObjectPropListener(value);
      this.hot.runHooks("modifySourceData", normalizedRow, column, valueHolder, "set");
      if (valueHolder.isTouched()) {
        value = valueHolder.value;
      }
    }
    const dataRow = this.modifyRowData(normalizedRow);
    if (!Number.isInteger(column)) {
      if (Array.isArray(dataRow)) {
        const numericIndex = Number(column);
        if (!Number.isNaN(numericIndex) && Number.isInteger(numericIndex) && numericIndex >= 0 && numericIndex < this.countFirstRowKeys()) {
          dataRow[numericIndex] = value;
        }
      } else if (isObject$1(dataRow)) {
        setProperty(dataRow, String(column), value);
      }
    } else if (Array.isArray(dataRow)) {
      dataRow[column] = value;
    } else if (isObject$1(dataRow)) {
      setProperty(dataRow, String(column), value);
    }
  }
  /**
  * Get data from the source data set using the physical indexes.
  *
  * @private
  * @param {number} row Physical row index.
  * @param {string|number|Function} column Physical column index / property / function.
  * @param {Array|object} dataRow A representation of a data row.
  * @returns {*} Value at the provided coordinates.
  */
  getAtPhysicalCell(row, column, dataRow) {
    let result = null;
    if (dataRow) {
      if (typeof column === "string") {
        const { dataDotNotation } = this.hot.getSettings();
        result = dataDotNotation ? getProperty(dataRow, column) : dataRow[column];
      } else if (typeof column === "function") {
        result = column(dataRow);
      } else {
        result = dataRow[column];
      }
    }
    if (this.hot.hasHook("modifySourceData")) {
      const valueHolder = createObjectPropListener(result);
      this.hot.runHooks("modifySourceData", row, column, valueHolder, "get");
      if (valueHolder.isTouched()) {
        result = valueHolder.value;
      }
    }
    return result;
  }
  /**
  * Returns a single value from the data.
  *
  * @param {number} row Physical row index.
  * @param {number} columnOrProp Visual column index or property.
  * @returns {*}
  */
  getAtCell(row, columnOrProp) {
    const dataRow = this.modifyRowData(row);
    return this.getAtPhysicalCell(row, this.colToProp(columnOrProp), dataRow);
  }
  /**
  * Returns source data by passed range.
  *
  * @param {object} [start] Object with physical `row` and `col` keys (or visual column index, if data type is an array of objects).
  * @param {object} [end] Object with physical `row` and `col` keys (or visual column index, if data type is an array of objects).
  * @param {boolean} [toArray=false] If `true` return source data as an array of arrays even when source data was provided
  *                                  in another format.
  * @returns {Array}
  */
  getByRange(start = null, end = null, toArray = false) {
    let getAllProps = false;
    let startRow = null;
    let startCol = null;
    let endRow = null;
    let endCol = null;
    if (start === null || end === null) {
      getAllProps = true;
      startRow = 0;
      endRow = this.countRows() - 1;
    } else {
      startRow = Math.min(start.row, end.row);
      startCol = Math.min(start.col, end.col);
      endRow = Math.max(start.row, end.row);
      endCol = Math.max(start.col, end.col);
    }
    const result = [];
    rangeEach(startRow, endRow, (currentRow) => {
      result.push(getAllProps ? this.getAtRow(currentRow, void 0, void 0, toArray) : this.getAtRow(currentRow, startCol, endCol, toArray));
    });
    return result;
  }
  /**
  * Returns single value from the data array (intended for clipboard copy to an external application).
  *
  * @param {number} row Visual row index.
  * @param {number} prop The column property.
  * @since 16.1.0
  * @returns {string}
  */
  getCopyable(row, prop) {
    const visualColumn = this.propToCol(prop);
    if (typeof visualColumn === "number" && this.hot.getCellMeta(row, visualColumn).copyable) {
      return this.getAtCell(this.hot.toPhysicalRow(row), visualColumn);
    }
    return "";
  }
  /**
  * Count number of rows.
  *
  * @returns {number}
  */
  countRows() {
    if (this.hot.hasHook("modifySourceLength")) {
      const modifiedSourceLength = this.hot.runHooks("modifySourceLength");
      if (typeof modifiedSourceLength === "number" && Number.isInteger(modifiedSourceLength)) {
        return modifiedSourceLength;
      }
    }
    return this.data.length;
  }
  /**
  * Count number of columns.
  *
  * @returns {number}
  */
  countFirstRowKeys() {
    return countFirstRowKeys(this.data ?? []);
  }
  /**
  * Destroy instance.
  */
  destroy() {
    this.data = null;
    this.hot = null;
  }
  /**
  * Initializes the data source with a reference to the Handsontable instance and the raw data array.
  */
  constructor(hotInstance, dataSource = []) {
    this.dataType = "array";
    this.colToProp = (_column) => void 0;
    this.propToCol = (_prop) => void 0;
    this.hot = hotInstance;
    this.data = dataSource;
  }
}
const { register: register$1, getItem: getItem$1, hasItem: hasItem$1, getNames: getNames$1, getValues: getValues$1 } = staticRegister("cellTypes");
function _getItem(name) {
  if (!hasItem$1(name)) {
    throwWithCause(`You declared cell type "${name}" as a string that is not mapped to a known object.
                 Cell type must be an object or a string mapped to an object registered by
                 "Handsontable.cellTypes.registerCellType" method`);
  }
  return getItem$1(name);
}
function _register(name, type) {
  if (typeof name !== "string") {
    type = name;
    name = type.CELL_TYPE;
  }
  const { editor, renderer, validator } = type;
  if (editor) {
    _register$3(name, editor);
  }
  if (renderer) {
    _register$2(name, renderer);
  }
  if (validator) {
    _register$1(name, validator);
  }
  register$1(name, type);
}
function canBeOverwritten(propertyName, metaObject) {
  if (propertyName === "CELL_TYPE") {
    return false;
  }
  return metaObject._automaticallyAssignedMetaProps?.has(propertyName) || !hasOwnProperty(metaObject, propertyName);
}
function extendByMetaType(metaObject, settings, settingsToCompareWith = metaObject) {
  const validType = typeof settings.type === "string" ? _getItem(settings.type) : settings.type;
  if (metaObject._automaticallyAssignedMetaProps) {
    objectEach(settings, (_value, key) => {
      metaObject._automaticallyAssignedMetaProps.delete(key);
    });
  }
  if (!isObject$1(validType)) {
    return;
  }
  if (settingsToCompareWith === metaObject && !metaObject._automaticallyAssignedMetaProps) {
    metaObject._automaticallyAssignedMetaProps = /* @__PURE__ */ new Set();
  }
  const expandedType = {};
  objectEach(validType, (value, property) => {
    if (canBeOverwritten(property, settingsToCompareWith)) {
      expandedType[property] = value;
      metaObject._automaticallyAssignedMetaProps?.add(property);
    }
  });
  extend(metaObject, expandedType);
}
function columnFactory(TableMeta2, conflictList = []) {
  function ColumnMeta2() {
  }
  inherit(ColumnMeta2, TableMeta2);
  for (let i = 0; i < conflictList.length; i++) {
    ColumnMeta2.prototype[conflictList[i]] = void 0;
  }
  return ColumnMeta2;
}
function assert(condition2, errorMessage) {
  if (!condition2()) {
    throwWithCause(`Assertion failed: ${errorMessage}`);
  }
}
function isNullish(variable) {
  return variable === null || variable === void 0;
}
const metaSchemaFactory = (() => {
  return {
    /**
    * Information on which of the meta properties were added automatically.
    * For example: setting the `renderer` property directly won't extend the `_automaticallyAssignedMetaProps`
    * entry, but setting a `type` will modify it to `Set(3) {'renderer', 'editor', 'validator', ...}`.
    *
    * @private
    * @type {Set}
    * @default undefined
    */
    _automaticallyAssignedMetaProps: void 0,
    /**
    * Information on which of the cell meta properties were set imperatively through `setCellMeta`
    * (for example, by the user or by the context menu). These properties are preserved across
    * `updateSettings` calls, unlike the properties applied from the declarative `cell` option.
    *
    * @private
    * @type {Set}
    * @default undefined
    */
    _userDefinedMetaProps: void 0,
    /**
    * The `activeHeaderClassName` option lets you add a CSS class name
    * to every currently-active, currently-selected header (when a whole column or row is selected).
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * Read more:
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @since 0.38.2
    * @default 'ht__active_highlight'
    * @category Core
    *
    * @example
    * ```js
    * // add an `ht__active_highlight` CSS class name
    * // to every currently-active, currently-selected header
    * activeHeaderClassName: 'ht__active_highlight',
    * ```
    */
    activeHeaderClassName: "ht__active_highlight",
    /**
    * The `allowEmpty` option determines whether Handsontable accepts the following values:
    * - `null`
    * - `undefined`
    * - `''`
    *
    * You can set the `allowEmpty` option to one of the following:
    *
    * | Setting          | Description                                                                                                                          |
    * | ---------------- | ------------------------------------------------------------------------------------------------------------------------------------ |
    * | `true` (default) | - Accept `null`, `undefined` and `''` values<br>- Mark cells that contain `null`, `undefined` or `''` values as `valid`              |
    * | `false`          | - Don't accept `null`, `undefined` and `''` values<br>- Mark cells that contain `null`, `undefined` or `''` values with as `invalid` |
    *
    * ::: tip
    * To use the [`allowEmpty`](#allowempty) option, you need to set the [`validator`](#validator) option (or the [`type`](#type) option).
    * :::
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // allow empty values in each cell of the entire grid
    * allowEmpty: true,
    *
    * // or
    * columns: [
    *   {
    *     type: 'date',
    *     dateFormat: { day: '2-digit', month: '2-digit', year: 'numeric' },
    *     // allow empty values in each cell of the 'date' column
    *     allowEmpty: true
    *   }
    * ],
    *
    * // or, using the `cells` option
    * cells(row, col) {
    *   if (col === 2) {
    *     return { allowEmpty: false };
    *   }
    * },
    * ```
    */
    allowEmpty: true,
    /**
    * The `allowHtml` option configures whether [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * and [`dropdown`](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md) cells' [`source`](#source) data
    * is treated as HTML.
    *
    * You can set the `allowHtml` option to one of the following:
    *
    * | Setting           | Description                                         |
    * | ----------------- | --------------------------------------------------- |
    * | `false` (default) | The [`source`](#source) data is not treated as HTML |
    * | `true`            | The [`source`](#source) data is treated as HTML     |
    *
    * __Warning:__ Setting the `allowHtml` option to `true` can cause serious XSS vulnerabilities.
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [Dropdown cell type](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md)
    * - [`source`](#source)
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // set options available in every `autocomplete` cell of this column
    *   source: ['<strong>foo</strong>', '<strong>bar</strong>']
    *   // use HTML in the `source` list
    *   allowHtml: true,
    *   },
    * ],
    * ```
    */
    allowHtml: false,
    /**
    * If set to `true`, the `allowInsertColumn` option adds the following menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md):
    * - **Insert column left**
    * - **Insert column right**
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // hide the 'Insert column left' and 'Insert column right' menu items from the context menu
    * allowInsertColumn: false,
    * ```
    */
    allowInsertColumn: true,
    /**
    * If set to `true`, the `allowInsertRow` option adds the following menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md):
    * - **Insert row above**
    * - **Insert row below**
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // hide the 'Insert row above' and 'Insert row below' menu items from the context menu
    * allowInsertRow: false,
    * ```
    */
    allowInsertRow: true,
    /**
    * The `allowInvalid` option determines whether Handsontable accepts values
    * that were marked as `invalid` by the [cell validator](@/guides/cell-functions/cell-validator/cell-validator.md).
    *
    * You can set the `allowInvalid` option to one of the following:
    *
    * | Setting          | Description                                                                                                                                                                        |
    * | ---------------- | ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default) | - Accept `invalid` values<br>- Allow the user to close the [cell editor](@/guides/cell-functions/cell-editor/cell-editor.md) with `invalid` values<br>- Save `invalid` values into the data source                   |
    * | `false`          | - Don't accept `invalid` values<br>- Don't allow the user to close the [cell editor](@/guides/cell-functions/cell-editor/cell-editor.md) with `invalid` values<br>- Don't save `invalid` values into the data source |
    *
    * Setting the `allowInvalid` option to `false` can be useful when used with the [Autocomplete strict mode](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md#autocomplete-strict-mode).
    *
    * Read more:
    * - [Cell validator](@/guides/cell-functions/cell-validator/cell-validator.md)
    * - [Cell editor](@/guides/cell-functions/cell-editor/cell-editor.md)
    * - [Autocomplete strict mode](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md#autocomplete-strict-mode)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // don't accept `invalid` values
    * // don't allow the user to close the cell editor
    * // don't save `invalid` values into the data source
    * allowInvalid: false,
    * ```
    */
    allowInvalid: true,
    /**
    * If set to `true`, the `allowRemoveColumn` option adds the following menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md):
    * - **Remove column**
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * Read more:
    * - [Context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // hide the 'Remove column' menu item from the context menu
    * allowRemoveColumn: false,
    * ```
    */
    allowRemoveColumn: true,
    /**
    * If set to `true`, the `allowRemoveRow` option adds the following menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md):
    * - **Remove row**
    *
    * Read more:
    * - [Context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // hide the 'Remove row' menu item from the context menu
    * allowRemoveRow: false,
    * ```
    */
    allowRemoveRow: true,
    /**
    * If set to `true`, the accessibility-related ARIA tags will be added to the table. If set to `false`, they
    * will be omitted.
    * Defaults to `true`.
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    * @since 14.0.0
    */
    ariaTags: true,
    /**
    * The `autoColumnSize` option configures the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin.
    *
    * You can set the `autoColumnSize` option to one of the following:
    *
    * | Setting   | Description                                                                                  |
    * | --------- | -------------------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin                               |
    * | `true`    | Enable the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin with the default configuration |
    * | An object | Enable the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin and modify the plugin options  |
    *
    * If you set the `autoColumnSize` option to an object, you can set the following [`AutoColumnSize`](@/api/autoColumnSize.md) plugin options:
    *
    * | Property                | Possible values                 | Description                                                                                                    |
    * | ----------------------- | ------------------------------- | -------------------------------------------------------------------------------------------------------------- |
    * | `syncLimit`             | A number \| A percentage string | The number/percentage of columns to keep in sync<br>(default: `50`)                                            |
    * | `useHeaders`            | `true` \| `false`               | When calculating column widths:<br>`true`: use column headers<br>`false`: don't use column headers          |
    * | `samplingRatio`         | A number                        | The number of samples of the same length to be used in column width calculations                               |
    * | `allowSampleDuplicates` | `true` \| `false`               | When calculating column widths:<br>`true`: Allow duplicate samples<br>`false`: Don't allow duplicate samples |
    *
    * By default, the `autoColumnSize` option is set to `undefined`,
    * but the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin acts as enabled.
    * To disable the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin completely,
    * set the `autoColumnSize` option to `false`.
    *
    * Using the [`colWidths`](#colWidths) option forcibly disables the [`AutoColumnSize`](@/api/autoColumnSize.md) plugin.
    *
    * Read more:
    * - [Plugins: `AutoColumnSize`](@/api/autoColumnSize.md)
    *
    * @memberof Options#
    * @type {object|boolean}
    * @default undefined
    * @category AutoColumnSize
    *
    * @example
    * ```js
    * autoColumnSize: {
    *   // keep 40% of columns in sync (the rest of columns: async)
    *   syncLimit: '40%',
    *   // when calculating column widths, use column headers
    *   useHeaders: true,
    *   // when calculating column widths, use 10 samples of the same length
    *   samplingRatio: 10,
    *   // when calculating column widths, allow duplicate samples
    *   allowSampleDuplicates: true
    * },
    * ```
    */
    autoColumnSize: void 0,
    /**
    * The `autoRowSize` option configures the [`AutoRowSize`](@/api/autoRowSize.md) plugin.
    *
    * You can set the `autoRowSize` option to one of the following:
    *
    * | Setting   | Description                                                                            |
    * | --------- | -------------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`AutoRowSize`](@/api/autoRowSize.md) plugin                               |
    * | `true`    | Enable the [`AutoRowSize`](@/api/autoRowSize.md) plugin with the default configuration |
    * | An object | Enable the [`AutoRowSize`](@/api/autoRowSize.md) plugin and modify the plugin options  |
    *
    * To give Handsontable's scrollbar a proper size, set the `autoRowSize` option to `true`.
    *
    * If you set the `autoRowSize` option to an object, you can set the following [`AutoRowSize`](@/api/autoRowSize.md) plugin options:
    *
    * | Property    | Possible values                 | Description                                                       |
    * | ----------- | ------------------------------- | ----------------------------------------------------------------- |
    * | `syncLimit` | A number \| A percentage string | The number/percentage of rows to keep in sync<br>(default: `500`) |
    *
    * Using the [`rowHeights`](#rowHeights) option forcibly disables the [`AutoRowSize`](@/api/autoRowSize.md) plugin.
    *
    * Read more:
    * - [Plugins: `AutoRowSize`](@/api/autoRowSize.md)
    *
    * @memberof Options#
    * @type {object|boolean}
    * @default undefined
    * @category AutoRowSize
    *
    * @example
    * ```js
    * autoRowSize: {
    *   // keep 40% of rows in sync (the rest of rows: async)
    *   syncLimit: '40%'
    * },
    * ```
    */
    autoRowSize: void 0,
    /**
    * | Setting           | Description                                                                                                                                                                                                                                  |
    * | ----------------- | -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `false` (default) | When you select a bottom-most cell, pressing <kbd>**↓**</kbd> doesn't do anything.<br><br>When you select a top-most cell, pressing <kbd>**↑**</kbd> doesn't do anything.                                                                    |
    * | `true`            | When you select a bottom-most cell, pressing <kbd>**↓**</kbd> takes you to the top-most cell of the next column.<br><br>When you select a top-most cell, pressing <kbd>**↑**</kbd> takes you to the bottom-most cell of the previous column. |
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // when you select a bottom-most cell, pressing ⬇ doesn't do anything
    * // when you select a top-most cell, pressing ⬆ doesn't do anything
    * autoWrapCol: false, // default setting
    *
    * // when you select a bottom-most cell, pressing ⬇ takes you to the top-most cell of the next column
    * // when you select a top-most cell, pressing ⬆ takes you to the bottom-most cell of the previous column
    * autoWrapCol: true,
    * ```
    */
    autoWrapCol: false,
    /**
    * | Setting           | Description                                                                                                                                                                                                                                                                                                        |
    * | ----------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
    * | `false` (default) | When you select the first cell of a row, pressing <kbd>**←**</kbd>* (or <kbd>**Shift**</kbd>+<kbd>**Tab**</kbd>\*\*) doesn't do anything.<br><br>When you select the last cell of a row, pressing <kbd>**→**</kbd>* (or <kbd>**Tab**</kbd>**) doesn't do anything.                                                  |
    * | `true`            | When you select the first cell of a row, pressing <kbd>**←**</kbd>* (or <kbd>**Shift**</kbd>+<kbd>**Tab**</kbd>\*\*) takes you to the last cell of the row above.<br><br>When you select the last cell of a row, pressing <kbd>**→**</kbd>* (or <kbd>**Tab**</kbd>**) takes you to the first cell of the row below. |
    *
    * \* The exact key depends on your [`layoutDirection`](#layoutdirection) configuration.<br>
    * \*\* Unless [`tabNavigation`](#tabnavigation) is set to `false`.
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // when you select the first cell of a row, pressing ⬅ (or Shift+Tab) doesn't do anything
    * // when you select the last cell of a row, pressing ➡ (or Tab) doesn't do anything
    * autoWrapRow: false, // default setting
    *
    * // when you select the first cell of a row, pressing ⬅ (or Shift+Tab) takes you to the last cell of the row above
    * // when you select the last cell of a row, pressing ➡ (or Tab) takes you to the first cell of the row below
    * autoWrapRow: true,
    * ```
    */
    autoWrapRow: false,
    /**
    * @description
    * The `bindRowsWithHeaders` option configures the [`BindRowsWithHeaders`](@/api/bindRowsWithHeaders.md) plugin.
    *
    * When enabled, each row stays permanently linked to its row header label, regardless of row sorting or row moving.
    * Normally, row headers display the visual row index and update as rows are reordered; with this plugin enabled,
    * the header travels with the data row it was originally assigned to.
    *
    * You can set the `bindRowsWithHeaders` option to one of the following:
    *
    * | Setting | Description                                                                  |
    * | ------- | ---------------------------------------------------------------------------- |
    * | `false` | Disable the the [`BindRowsWithHeaders`](@/api/bindRowsWithHeaders.md) plugin |
    * | `true`  | Enable the the [`BindRowsWithHeaders`](@/api/bindRowsWithHeaders.md) plugin  |
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * Read more:
    * - [Plugins: `BindRowsWithHeaders`](@/api/bindRowsWithHeaders.md)
    *
    * @memberof Options#
    * @type {boolean|string}
    * @default undefined
    * @category BindRowsWithHeaders
    *
    * @example
    * ```js
    * // enable the `BindRowsWithHeaders` plugin
    * bindRowsWithHeaders: true
    * ```
    */
    bindRowsWithHeaders: void 0,
    /**
    * The `cell` option lets you apply [configuration options](@/guides/getting-started/configuration-options/configuration-options.md) to individual cells.
    *
    * The `cell` option overwrites the [top-level grid options](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options),
    * and the [`columns`](#columns) options.
    *
    * Read more:
    * - [Configuration options: Setting cell options](@/guides/getting-started/configuration-options/configuration-options.md#set-cell-options)
    * - [`columns`](#columns)
    *
    * @memberof Options#
    * @type {Array[]}
    * @default []
    * @category Core
    *
    * @example
    * ```js
    * // set the `cell` option to an array of objects
    * cell: [
    *   // make the cell with coordinates (0, 0) read-only
    *   {
    *     row: 0,
    *     col: 0,
    *     readOnly: true
    *   }
    * ],
    * ```
    */
    cell: [],
    /**
    * @description
    * The `cells` option lets you apply any other [configuration options](@/guides/getting-started/configuration-options/configuration-options.md) to
    * individual grid elements (columns, rows, cells), based on any logic you implement.
    *
    * The `cells` option overwrites all other options (including options set by [`columns`](#columns) and [`cell`](#cell)).
    * It takes the following parameters:
    *
    * | Parameter | Required | Type             | Description                                                                                                                                                                                                                                                                                                                             |
    * | --------- | -------- | ---------------- | --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `row`     | Yes      | Number           | A physical row index                                                                                                                                                                                                                                                                                                                    |
    * | `column`  | Yes      | Number           | A physical column index                                                                                                                                                                                                                                                                                                                 |
    * | `prop`    | No       | String \| Number | If [`data`](#data) is set to an [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays), `prop` is the same number as `column`.<br><br>If [`data`](#data) is set to an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects), `prop` is a property name for the column's data object. |
    *
    * Read more:
    * - [Configuration options: Implementing custom logic](@/guides/getting-started/configuration-options/configuration-options.md#implement-custom-logic)
    * - [Configuration options: Setting row options](@/guides/getting-started/configuration-options/configuration-options.md#set-row-options)
    * - [`columns`](#columns)
    * - [`cell`](#cell)
    *
    * @memberof Options#
    * @type {Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set the `cells` option to your custom function
    * cells(row, column, prop) {
    *   const cellProperties = { readOnly: false };
    *   const visualRowIndex = this.instance.toVisualRow(row);
    *   const visualColIndex = this.instance.toVisualColumn(column);
    *
    *   if (visualRowIndex === 0 && visualColIndex === 0) {
    *     cellProperties.readOnly = true;
    *   } else {
    *     cellProperties.readOnly = false;
    *   }
    *
    *   return cellProperties;
    * },
    * ```
    */
    cells: void 0,
    /**
    * The `checkedTemplate` option lets you configure what value
    * a checked [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cell has.
    *
    * You can set the `checkedTemplate` option to one of the following:
    *
    * | Setting          | Description                                                                                                                                                                              |
    * | ---------------- | ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default) | If a [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cell is checked,<br>the [`getDataAtCell`](@/api/core.md#getDataAtCell) method for this cell returns `true`                  |
    * | A string         | If a [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cell is checked,<br>the [`getDataAtCell`](@/api/core.md#getDataAtCell) method for this cell returns a string of your choice |
    *
    * ::: warning
    * When you set `checkedTemplate` to a custom string value (e.g. `'Yes'`), using `true` in your data source to
    * represent a checked state is no longer valid. Only the exact custom string value matches a checked checkbox.
    * Pair `checkedTemplate` with [`uncheckedTemplate`](#uncheckedTemplate) to define both states explicitly.
    * :::
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [Checkbox cell type: Checkbox template](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md#checkbox-template)
    * - [`getDataAtCell()`](@/api/core.md#getDataAtCell)
    * - [`uncheckedTemplate`](#uncheckedTemplate)
    *
    * @memberof Options#
    * @type {boolean|string|number}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // set the `type` of each cell in this column to `checkbox`
    *     // when checked, the cell's value is `true`
    *     // when unchecked, the cell's value is `false`
    *     type: 'checkbox',
    *   },
    *   {
    *     // set the `type` of each cell in this column to `checkbox`
    *     type: 'checkbox',
    *     // when checked, the cell's value is `'Yes'`
    *     checkedTemplate: 'Yes',
    *     // when unchecked, the cell's value is `'No'`
    *     uncheckedTemplate: 'No'
    *  }
    * ],
    * ```
    */
    checkedTemplate: void 0,
    /**
    * The `className` option lets you add CSS class names to every currently-selected element.
    *
    * You can set the `className` option to one of the following:
    *
    * | Setting             | Description                                                      |
    * | ------------------- | ---------------------------------------------------------------- |
    * | A string            | Add a single CSS class name to every currently-selected element  |
    * | An array of strings | Add multiple CSS class names to every currently-selected element |
    *
    * ::: tip
    * Don't change the `className` metadata of the [column summary](@/guides/columns/column-summary/column-summary.md) row.
    * To style the summary row, use the class name assigned automatically by the [`ColumnSummary`](@/api/columnSummary.md) plugin: `columnSummaryResult`.
    * :::
    *
    * To apply different CSS class names on different levels, use Handsontable's [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration).
    *
    * Read more:
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`TableClassName`](#TableClassName)
    *
    * @memberof Options#
    * @type {string|string[]}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // add a `your-class-name` CSS class name
    * // to every currently-selected element
    * className: 'your-class-name',
    *
    * // add `first-class-name` and `second-class-name` CSS class names
    * // to every currently-selected element
    * className: ['first-class-name', 'second-class-name'],
    * ```
    */
    className: void 0,
    /**
    * The `colHeaders` option configures your grid's column headers.
    *
    * You can set the `colHeaders` option to one of the following:
    *
    * | Setting  | Description                                                          |
    * | -------- | -------------------------------------------------------------------- |
    * | `true`   | Enable the default column headers ('A', 'B', 'C', ...)               |
    * | `false`  | Disable column headers                                               |
    * | An array | Define your own column headers (e.g. `['One', 'Two', 'Three', ...]`) |
    * | A function | Define your own column headers, using a function                     |
    *
    * Read more:
    * - [Column header](@/guides/columns/column-header/column-header.md)
    *
    * @memberof Options#
    * @type {boolean|string[]|Function}
    * @default null
    * @category Core
    *
    * @example
    * ```js
    * // enable the default column headers
    * colHeaders: true,
    *
    * // set your own column headers
    * colHeaders: ['One', 'Two', 'Three'],
    *
    * // set your own column headers, using a function
    * colHeaders: function(visualColumnIndex) {
    *   return `${visualColumnIndex} + : AB`;
    * },
    * ```
    */
    colHeaders: null,
    /**
    * @description
    * The `collapsibleColumns` option configures the [`CollapsibleColumns`](@/api/collapsibleColumns.md) plugin.
    *
    * You can set the `collapsibleColumns` option to one of the following:
    *
    * | Setting              | Description                                                                                       |
    * | -------------------- | ------------------------------------------------------------------------------------------------- |
    * | `false`              | Disable the [`CollapsibleColumns`](@/api/collapsibleColumns.md) plugin                            |
    * | `true`               | Enable the [`CollapsibleColumns`](@/api/collapsibleColumns.md) plugin                             |
    * | An array of objects  | Enable the [`CollapsibleColumns`](@/api/collapsibleColumns.md) plugin for selected column headers |
    *
    * When using an array of objects, specify the header to make collapsible using `row` and `col`.
    * The `row` value is a negative integer that counts header levels from the bottom of the header area:
    * `-1` is the header row closest to the data, `-2` is one level above, and so on.
    * This option requires the [`nestedHeaders`](#nestedHeaders) plugin to be configured.
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * Read more:
    * - [Plugins: `CollapsibleColumns`](@/api/collapsibleColumns.md)
    * - [`nestedHeaders`](#nestedHeaders)
    *
    * @memberof Options#
    * @type {boolean|object[]}
    * @default undefined
    * @category CollapsibleColumns
    *
    * @example
    * ```js
    * // enable column collapsing for all headers
    * collapsibleColumns: true,
    *
    * // enable column collapsing for selected headers
    * collapsibleColumns: [
    *   {row: -4, col: 1, collapsible: true},
    *   {row: -3, col: 5, collapsible: true}
    * ],
    * ```
    */
    collapsibleColumns: void 0,
    /**
    * @description
    * The `columnHeaderHeight` option configures the height of column headers.
    *
    * You can set the `columnHeaderHeight` option to one of the following:
    *
    * | Setting  | Description                                         |
    * | -------- | --------------------------------------------------- |
    * | A number | Set the same height for every column header         |
    * | An array | Set different heights for individual column headers |
    *
    * @memberof Options#
    * @type {number|number[]}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set the same height for every column header
    * columnHeaderHeight: 25,
    *
    * // set different heights for individual column headers
    * columnHeaderHeight: [25, 30, 55],
    * ```
    */
    columnHeaderHeight: void 0,
    /**
    * @description
    * The `columns` option lets you apply any other [configuration options](@/guides/getting-started/configuration-options/configuration-options.md) to individual columns (or ranges of columns).
    *
    * You can set the `columns` option to one of the following:
    * - An array of objects (each object represents one column)
    * - A function that returns an array of objects
    *
    * The `columns` option overwrites the [top-level grid options](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    *
    * When you use `columns`, the [`startCols`](#startCols), [`minCols`](#minCols), and [`maxCols`](#maxCols) options are ignored.
    *
    * Read more:
    * - [Configuration options: Setting column options](@/guides/getting-started/configuration-options/configuration-options.md#set-column-options)
    * - [`startCols`](#startCols)
    * - [`minCols`](#minCols)
    * - [`maxCols`](#maxCols)
    * - [`data`](#data)
    *
    * @memberof Options#
    * @type {object[]|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set the `columns` option to an array of objects
    * // each object represents one column
    * columns: [
    *   {
    *     // column options for the first (by physical index) column
    *     type: 'numeric',
    *     numericFormat: {
    *       style: 'currency',
    *       currency: 'USD',
    *       minimumFractionDigits: 2,
    *       maximumFractionDigits: 2
    *     }
    *   },
    *   {
    *     // column options for the second (by physical index) column
    *     type: 'text',
    *     readOnly: true
    *   }
    * ],
    *
    * // or set the `columns` option to a function, based on physical indexes
    * columns(index) {
    *   return {
    *     type: index > 0 ? 'numeric' : 'text',
    *     readOnly: index < 1
    *   }
    * }
    * ```
    */
    columns: void 0,
    /**
    * @description
    * The `columnSorting` option configures the [`ColumnSorting`](@/api/columnSorting.md) plugin.
    *
    * You can set the `columnSorting` option to one of the following:
    *
    * | Setting    | Description                                                                                                                            |
    * | ---------- | -------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true`     | Enable the [`ColumnSorting`](@/api/columnSorting.md) plugin with the default configuration                                             |
    * | `false`    | Disable the [`ColumnSorting`](@/api/columnSorting.md) plugin                                                                           |
    * | An object  | - Enable the [`ColumnSorting`](@/api/columnSorting.md) plugin<br>- Modify the [`ColumnSorting`](@/api/columnSorting.md) plugin options |
    *
    * If you set the `columnSorting` option to an object,
    * you can set the following [`ColumnSorting`](@/api/columnSorting.md) plugin options:
    *
    * | Option                   | Possible settings                                                                                                                                |
    * | ------------------------ | ------------------------------------------------------------------------------------------------------------------------------------------------ |
    * | `indicator`              | `true`: Display the arrow icon in the column header, to indicate a sortable column<br>`false`: Don't display the arrow icon in the column header  |
    * | `headerAction`           | `true`: Enable clicking on the column header to sort the column<br>`false`: Disable clicking on the column header to sort the column             |
    * | `sortEmptyCells`         | `true`: Sort empty cells as well<br>`false`: Place empty cells at the end                                                                        |
    * | `compareFunctionFactory` | A [custom compare function](@/guides/rows/rows-sorting/rows-sorting.md#add-a-custom-comparator)                                                                |
    *
    * If you set the `columnSorting` option to an object,
    * you can also sort individual columns at Handsontable's initialization.
    * In the `columnSorting` object, add an object named `initialConfig`,
    * with the following properties:
    *
    * | Option      | Possible settings   | Description                                                      |
    * | ----------- | ------------------- | ---------------------------------------------------------------- |
    * | `column`    | A number            | The index of the column that you want to sort at initialization  |
    * | `sortOrder` | `'asc'` \| `'desc'` | The sorting order:<br>`'asc'`: ascending<br>`'desc'`: descending |
    *
    * Read more:
    * - [Rows sorting](@/guides/rows/rows-sorting/rows-sorting.md)
    * - [Rows sorting: Custom compare functions](@/guides/rows/rows-sorting/rows-sorting.md#add-a-custom-comparator)
    * - [`multiColumnSorting`](#multiColumnSorting)
    *
    * @memberof Options#
    * @type {boolean|object}
    * @default undefined
    * @category ColumnSorting
    *
    * @example
    * ```js
    * // enable the `ColumnSorting` plugin
    * columnSorting: true
    *
    * // enable the `ColumnSorting` plugin with custom configuration
    * columnSorting: {
    *   // sort empty cells as well
    *   sortEmptyCells: true,
    *   // display the arrow icon in the column header
    *   indicator: true,
    *   // disable clicking on the column header to sort the column
    *   headerAction: false,
    *   // add a custom compare function
    *   compareFunctionFactory(sortOrder, columnMeta) {
    *     return function(value, nextValue) {
    *       // some value comparisons which will return -1, 0 or 1...
    *     }
    *   }
    * }
    *
    * // enable the `ColumnSorting` plugin with an initial sort order:
    * // sort column 1 in ascending order at initialization
    * columnSorting: {
    *   initialConfig: {
    *     column: 1,
    *     sortOrder: 'asc'
    *   }
    * }
    * ```
    */
    columnSorting: void 0,
    /**
    * @description
    * The `columnSummary` option configures the [`ColumnSummary`](@/api/columnSummary.md) plugin.
    *
    * You can set the `columnSummary` option to an array of objects.
    * Each object configures a single column summary, using the following properties:
    *
    * | Property                 | Possible values                                                         | Description                                                                                                                  |
    * | ------------------------ | ----------------------------------------------------------------------- | ---------------------------------------------------------------------------------------------------------------------------- |
    * | `sourceColumn`           | A number                                                                | [Column to summarize](@/guides/columns/column-summary/column-summary.md#step-2-select-cells-that-you-want-to-summarize)                     |
    * | `ranges`                 | An array                                                                | [Ranges of rows to summarize](@/guides/columns/column-summary/column-summary.md#step-2-select-cells-that-you-want-to-summarize)             |
    * | `type`                   | `'sum'` \| `'min'` \| `'max'` \| `'count'` \| `'average'` \| `'custom'` | [Summary function](@/guides/columns/column-summary/column-summary.md#step-3-calculate-your-summary)                                         |
    * | `destinationRow`         | A number                                                                | [Destination cell's row coordinate](@/guides/columns/column-summary/column-summary.md#step-4-provide-the-destination-cell-s-coordinates)    |
    * | `destinationColumn`      | A number                                                                | [Destination cell's column coordinate](@/guides/columns/column-summary/column-summary.md#step-4-provide-the-destination-cell-s-coordinates) |
    * | `forceNumeric`           | `true`  \| `false`                                                      | [Treat non-numerics as numerics](@/guides/columns/column-summary/column-summary.md#force-numeric-values)                                  |
    * | `reversedRowCoords`      | `true`  \| `false`                                                      | [Reverse row coordinates](@/guides/columns/column-summary/column-summary.md#step-5-make-room-for-the-destination-cell)                      |
    * | `suppressDataTypeErrors` | `true`  \| `false`                                                      | [Suppress data type errors](@/guides/columns/column-summary/column-summary.md#throw-data-type-errors)                                    |
    * | `readOnly`               | `true`  \| `false`                                                      | Make summary cell [read-only](@/api/options.md#readonly)                                                                                           |
    * | `roundFloat`             | `true`  \| `false`  \| A number                                         | [Round summary result](@/guides/columns/column-summary/column-summary.md#round-a-column-summary-result)                                  |
    * | `customFunction`         | A function                                                              | [Custom summary function](@/guides/columns/column-summary/column-summary.md#implement-a-custom-summary-function)                         |
    *
    * Read more:
    * - [Column summary](@/guides/columns/column-summary/column-summary.md)
    * - [Plugins: `ColumnSummary`](@/api/columnSummary.md)
    *
    * @memberof Options#
    * @type {object[]|Function}
    * @default undefined
    * @category ColumnSummary
    *
    * @example
    * ```js
    * columnSummary: [
    *   {
    *     sourceColumn: 0,
    *     ranges: [
    *       [0, 2], [4], [6, 8]
    *     ],
    *     type: 'custom',
    *     destinationRow: 4,
    *     destinationColumn: 1,
    *     forceNumeric: true,
    *     reversedRowCoords: true,
    *     suppressDataTypeErrors: false,
    *     readOnly: true,
    *     roundFloat: false,
    *     customFunction(endpoint) {
    *        return 100;
    *     }
    *   }
    * ],
    * ```
    */
    columnSummary: void 0,
    /**
    * The `colWidths` option sets columns' widths, in pixels.
    *
    * The default column width is 50px. To change it, set the `colWidths` option to one of the following:
    *
    * | Setting     | Description                                                                                          | Example                                                           |
    * | ----------- | ---------------------------------------------------------------------------------------------------- | ----------------------------------------------------------------- |
    * | A number    | Set the same width for every column                                                                  | `colWidths: 100`                                                  |
    * | A string    | Set the same width for every column                                                                  | `colWidths: '100px'`                                              |
    * | An array    | Set widths separately for each column                                                                | `colWidths: [100, 120, undefined]`                                |
    * | A function  | Set column widths dynamically,<br>on each render                                                     | `colWidths(visualColumnIndex) { return visualColumnIndex * 10; }` |
    * | `undefined` | Used by the [modifyColWidth](@/api/hooks.md#modifyColWidth) hook,<br>to detect column width changes. | `colWidths: undefined`                                            |
    *
    * Setting `colWidths` even for a single column disables the {@link AutoColumnSize} plugin
    * for all columns. For this reason, if you use `colWidths`, we recommend you set a width for each one
    * of your columns. Otherwise, every column with an undefined width defaults back to 50px,
    * which may cut longer columns names.
    *
    * Read more:
    * - [Column width](@/guides/columns/column-width/column-width.md)
    * - [Hooks: `modifyColWidth`](@/api/hooks.md#modifyColWidth)
    * - [`autoColumnSize`](#autoColumnSize)
    *
    * @memberof Options#
    * @type {number|number[]|string|string[]|Array<undefined>|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set every column's width to 100px
    * colWidths: 100,
    *
    * // set every column's width to 100px
    * colWidths: '100px',
    *
    * // set the first (by visual index) column's width to 100
    * // set the second (by visual index) column's width to 120
    * // set the third (by visual index) column's width to `undefined`, so that it defaults to 50px
    * // set any other column's width to the default 50px (note that longer cell values and column names can get cut)
    * colWidths: [100, 120, undefined],
    *
    * // set each column's width individually, using a function
    * colWidths(visualColumnIndex) {
    *   return visualColumnIndex * 10;
    * },
    * ```
    */
    colWidths: void 0,
    /**
    * The `commentedCellClassName` option lets you add a CSS class name to cells
    * that have comments.
    *
    * Read more:
    * - [Comments](@/guides/cell-features/comments/comments.md)
    * - [`comments`](#comments)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default 'htCommentCell'
    * @category Core
    *
    * @example
    * ```js
    * // add a `has-comment` CSS class name
    * // to each cell that has a comment
    * commentedCellClassName: 'has-comment',
    * ```
    */
    commentedCellClassName: "htCommentCell",
    /**
    * @description
    * The `comments` option configures the [`Comments`](@/api/comments.md) plugin.
    *
    * You can set the `comments` option to one of the following:
    *
    * | Setting   | Description                                                                                                                                                                           |
    * | --------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true`    | - Enable the [`Comments`](@/api/comments.md) plugin<br>- Add comment menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)                                 |
    * | `false`   | Disable the [`Comments`](@/api/comments.md) plugin                                                                                                                                    |
    * | An object | - Enable the [`Comments`](@/api/comments.md) plugin<br>- Add comment menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)<br>- Configure comment settings |
    *
    * If you set the `comments` option to an object, you can configure the following comment options:
    *
    * | Option         | Possible settings           | Description                                         |
    * | -------------- | --------------------------- | --------------------------------------------------- |
    * | `displayDelay` | A number (default: `250`)   | Display comments after a delay (in milliseconds)    |
    * | `readOnly`     | `true` \| `false` (default) | `true`: Make comments read-only                     |
    * | `style`        | An object                   | Set comment boxes' `width` and `height` (in pixels) |
    *
    * Read more:
    * - [Comments](@/guides/cell-features/comments/comments.md)
    * - [Context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)
    * - [`width`](#width)
    * - [`height`](#height)
    * - [`readOnly`](#readOnly)
    * - [`commentedCellClassName`](#commentedCellClassName)
    *
    * @memberof Options#
    * @type {boolean|object[]}
    * @default false
    * @category Comments
    *
    * @example
    * ```js
    * // enable the `Comments` plugin
    * comments: true,
    *
    * // enable the `Comments` plugin
    * // and configure its settings
    * comments: {
    *   // display all comments with a 1-second delay
    *   displayDelay: 1000,
    *   // make all comments read-only
    *   readOnly: true,
    *   // set the default size of all comment boxes
    *   style: {
    *     width: 300,
    *     height: 100
    *   }
    * }
    * ```
    */
    comments: false,
    /**
    * @description
    * The `contextMenu` option configures the [`ContextMenu`](@/api/contextMenu.md) plugin.
    *
    * You can set the `contextMenu` option to one of the following:
    *
    * | Setting   | Description                                                                                                                                                                                             |
    * | --------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`ContextMenu`](@/api/contextMenu.md) plugin                                                                                                                                                |
    * | `true`    | - Enable the [`ContextMenu`](@/api/contextMenu.md) plugin<br>- Use the [default context menu options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-default-options)                 |
    * | An array  | - Enable the [`ContextMenu`](@/api/contextMenu.md) plugin<br>- Modify [individual context menu options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-specific-options)              |
    * | An object | - Enable the [`ContextMenu`](@/api/contextMenu.md) plugin<br>- Apply a [custom context menu configuration](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-a-fully-custom-configuration) |
    *
    * Read more:
    * - [Context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)
    * - [Context menu: Context menu with default options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-default-options)
    * - [Context menu: Context menu with specific options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-specific-options)
    * - [Context menu: Context menu with fully custom configuration options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-a-fully-custom-configuration)
    * - [Plugins: `ContextMenu`](@/api/contextMenu.md)
    *
    * @memberof Options#
    * @type {boolean|string[]|object}
    * @default undefined
    * @category ContextMenu
    *
    * @example
    * ```js
    * // enable the `ContextMenu` plugin
    * // use the default context menu options
    * contextMenu: true,
    *
    * // enable the `ContextMenu` plugin
    * // and modify individual context menu options
    * contextMenu: ['row_above', 'row_below', '---------', 'undo', 'redo'],
    *
    * // enable the `ContextMenu` plugin
    * // and apply a custom context menu configuration
    * contextMenu: {
    *   items: {
    *     'option1': {
    *       name: 'Option 1'
    *     },
    *     'option2': {
    *       name: 'Option 2',
    *       submenu: {
    *         items: [
    *           {
    *             key: 'option2:suboption1',
    *             name: 'Suboption 1',
    *             callback: function(key, options) {
    *               ...
    *             }
    *           },
    *           ...
    *         ]
    *       }
    *     }
    *   }
    * },
    * ```
    */
    contextMenu: void 0,
    /**
    * @description
    * The `copyable` option determines whether a cell's value can be copied to the clipboard or not.
    *
    * You can set the `copyable` option to one of the following:
    *
    * | Setting                                                                                                        | Description                                                                                                            |
    * | -------------------------------------------------------------------------------------------------------------- | ---------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default)                                                                                               | - On pressing <kbd>**Ctrl**</kbd>/<kbd>**Cmd**</kbd>+<kbd>**C**</kbd>, add the cell's value to the clipboard         |
    * | `false`<br>(default for the [`password`](@/guides/cell-types/password-cell-type/password-cell-type.md) [cell type](#type))        | - On pressing <kbd>**Ctrl**</kbd>/<kbd>**Cmd**</kbd>+<kbd>**C**</kbd>, add an empty string (`""`) to the clipboard   |
    *
    * Read more:
    * - [Clipboard](@/guides/cell-features/clipboard/clipboard.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    * - [Password cell type](@/guides/cell-types/password-cell-type/password-cell-type.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // enable copying for each cell of the entire grid
    * copyable: true,
    *
    * // enable copying for individual columns
    * columns: [
    *   {
    *     // enable copying for each cell of this column
    *     copyable: true
    *   },
    *   {
    *     // disable copying for each cell of this column
    *     copyable: false
    *   }
    * ]
    *
    * // enable copying for specific cells
    * cell: [
    *   {
    *     col: 0,
    *     row: 0,
    *     // disable copying for cell (0, 0)
    *     copyable: false,
    *   }
    * ],
    * ```
    */
    copyable: true,
    /**
    * The `copyPaste` option configures the [`CopyPaste`](@/api/copyPaste.md) plugin.
    *
    * You can set the `copyPaste` option to one of the following:
    *
    * | Setting           | Description                                                                                                            |
    * | ----------------- | ---------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default)  | Enable the [`CopyPaste`](@/api/copyPaste.md) plugin with the default configuration                                     |
    * | `false`           | Disable the [`CopyPaste`](@/api/copyPaste.md) plugin                                                                   |
    * | An object         | - Enable the [`CopyPaste`](@/api/copyPaste.md) plugin<br>- Modify the [`CopyPaste`](@/api/copyPaste.md) plugin options |
    *
    * ##### copyPaste: Additional options
    *
    * If you set the `copyPaste` option to an object, you can set the following `CopyPaste` plugin options:
    *
    * | Option                   | Possible settings                                  | Description                                                                                                                                                                                         |
    * | ------------------------ | -------------------------------------------------- | --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `columnsLimit`           | A number (default: `Infinity`)                     | The maximum number of columns that can be copied                                                                                                                                                    |
    * | `rowsLimit`              | A number (default: `Infinity`)                     | The maximum number of columns that can be copied                                                                                                                                                    |
    * | `pasteMode`              | `'overwrite'` \| `'shift_down'` \| `'shift_right'` | When pasting:<br>`'overwrite'`: overwrite the currently-selected cells<br>`'shift_down'`: move the currently-selected cells down<br>`'shift_right'`: move the currently-selected cells to the right |
    * | `copyColumnHeaders`      | Boolean (default: `false`)                         | `true`: add a context menu option for copying cells along with their nearest column headers                                                                                                         |
    * | `copyColumnGroupHeaders` | Boolean (default: `false`)                         | `true`: add a context menu option for copying cells along with all their related columns headers                                                                                                    |
    * | `copyColumnHeadersOnly`  | Boolean (default: `false`)                         | `true`: add a context menu option for copying column headers nearest to the selected cells (without copying cells)                                                                    |
    * | `uiContainer`            | An HTML element                                    | The UI container for the secondary focusable element                                                                                                                                                |
    *
    * Read more:
    * - [Plugins: `CopyPaste`](@/api/copyPaste.md)
    * - [Guides: Clipboard](@/guides/cell-features/clipboard/clipboard.md)
    *
    * @memberof Options#
    * @type {object|boolean}
    * @default true
    * @category CopyPaste
    *
    * @example
    * ```js
    * // enable the plugin with the default configuration
    * copyPaste: true // set by default
    *
    * // disable the plugin
    * copyPaste: false,
    *
    * // enable the plugin with a custom configuration
    * copyPaste: {
    *   // set a maximum number of columns that can be copied
    *   columnsLimit: 25,
    *
    *   // set a maximum number of rows that can be copied
    *   rowsLimit: 50,
    *
    *   // set the paste behavior
    *   pasteMode: 'shift_down',
    *
    *   // add the option to copy cells along with their nearest column headers
    *   copyColumnHeaders: true,
    *
    *   // add the option to copy cells along with all their related columns headers
    *   copyColumnGroupHeaders: true,
    *
    *   // add the option to copy just column headers (without copying cells)
    *   copyColumnHeadersOnly: true,
    *
    *   // set a UI container
    *   uiContainer: document.body,
    * },
    * ```
    */
    copyPaste: true,
    /**
    * The `currentColClassName` option lets you add a CSS class name
    * to each cell of the currently-visible, currently-selected columns.
    *
    * Read more:
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // add a `your-class-name` CSS class name
    * // to each cell of the currently-visible, currently-selected columns
    * currentColClassName: 'your-class-name',
    * ```
    */
    currentColClassName: void 0,
    /**
    * The `currentHeaderClassName` option lets you add a CSS class name
    * to every currently-visible, currently-selected header.
    *
    * Read more:
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default 'ht__highlight'
    * @category Core
    *
    * @example
    * ```js
    * // add an `ht__highlight` CSS class name
    * // to every currently-visible, currently-selected header
    * currentHeaderClassName: 'ht__highlight',
    * ```
    */
    currentHeaderClassName: "ht__highlight",
    /**
    * The `currentRowClassName` option lets you add a CSS class name
    * to each cell of the currently-visible, currently-selected rows.
    *
    * Read more:
    * - [`currentColClassName`](#currentColClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // add a `your-class-name` CSS class name
    * // to each cell of the currently-visible, currently-selected rows
    * currentRowClassName: 'your-class-name',
    * ```
    */
    currentRowClassName: void 0,
    /**
    * @description
    * The `customBorders` option configures the [`CustomBorders`](@/api/customBorders.md) plugin.
    *
    * To enable the [`CustomBorders`](@/api/customBorders.md) plugin
    * (and add its menu items to the [context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)),
    * set the `customBorders` option to `true`.
    *
    * To enable the [`CustomBorders`](@/api/customBorders.md) plugin
    * and add a predefined border around a particular cell,
    * set the `customBorders` option to an array of objects.
    * Each object represents a border configuration for one cell, and has the following properties:
    *
    * | Property | Sub-properties                | Types                                                 | Description                                                       |
    * | -------- | ----------------------------- | ----------------------------------------------------- | ----------------------------------------------------------------- |
    * | `row`    | -                             | `row`: Number                                         | The cell's row coordinate.                                        |
    * | `col`    | -                             | `col`: Number                                         | The cell's column coordinate.                                     |
    * | `start`  | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default): `start` sets the width (`width`), color (`color`) and style (`style`) of the left-hand border.<br><br>If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL: `start` sets the width (`width`), color (`color`) and style (`style`) of the right-hand border. |
    * | `end`    | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default): `end` sets the width (`width`), color (`color`) and style (`style`) of the right-hand border.<br><br>If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL: `end` sets the width (`width`), color (`color`) and style (`style`) of the left-hand border. |
    * | `top`    | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | Sets the width (`width`), color (`color`) and style (`style`) of the top border. |
    * | `bottom` | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | Sets the width (`width`), color (`color`) and style (`style`) of the bottom border. |
    *
    * To enable the [`CustomBorders`](@/api/customBorders.md) plugin
    * and add a predefined border around a range of cells,
    * set the `customBorders` option to an array of objects.
    * Each object represents a border configuration for a single range of cells, and has the following properties:
    *
    * | Property | Sub-properties                               | Types                                                            | Description                                                                                  |
    * | -------- | -------------------------------------------- | ---------------------------------------------------------------- | -------------------------------------------------------------------------------------------- |
    * | `range`  | `from` {`row`, `col`}<br>`to` {`row`, `col`} | `from`: Object<br>`to`: Object<br>`row`: Number<br>`col`: Number | If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default):<br>- `from` selects the range's top-left corner.<br>- `to` selects the range's bottom-right corner.<br><br>If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL: <br>- `from` selects the range's top-right corner.<br>- `to` selects the range's bottom-left corner. |
    * | `start`  | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default): `start` sets the width (`width`), color (`color`) and style (`style`) of the left-hand border.<br><br>If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL: `start` sets the width (`width`), color (`color`) and style (`style`) of the right-hand border. |
    * | `end`    | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default): `end` sets the width (`width`), color (`color`) and style (`style`) of the right-hand border.<br><br>If the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL: `end` sets the width (`width`), color (`color`) and style (`style`) of the left-hand border. |
    * | `top`    | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | Sets the width (`width`), color (`color`) and style (`style`) of the top border. |
    * | `bottom` | `width`<br>`color`<br>`style` | `width`: Number<br>`color`: String<br>`style`: String | Sets the width (`width`), color (`color`) and style (`style`) of the bottom border. |
    *
    * Read more:
    * - [Formatting cells: Custom cell borders](@/guides/cell-features/formatting-cells/formatting-cells.md#custom-cell-borders)
    * - [Context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)
    * - [Plugins: `CustomBorders`](@/api/customBorders.md)
    * - [Layout direction](@/guides/internationalization/layout-direction/layout-direction.md)
    * - [`layoutDirection`](#layoutDirection)
    *
    * @memberof Options#
    * @type {boolean|object[]}
    * @default false
    * @category CustomBorders
    *
    * @example
    * ```js
    * // enable the `CustomBorders` plugin
    * customBorders: true,
    *
    * // enable the `CustomBorders` plugin
    * // and add a predefined border for a particular cell
    * customBorders: [
    *   // add an object with a border configuration for one cell
    *   {
    *     // set the cell's row coordinate
    *     row: 2,
    *     // set the cell's column coordinate
    *     col: 2,
    *     // set the left/right border's width and color
    *     start: {
    *       width: 2,
    *       color: 'red'
    *     },
    *     // set the right/left border's width, color and style
    *     end: {
    *       width: 1,
    *       color: 'green',
    *       style: 'dashed'
    *     },
    *     // set the top border's width and color
    *     top: '',
    *     // set the bottom border's width and color
    *     bottom: ''
    *   }
    * ],
    *
    * // enable the `CustomBorders` plugin
    * // and add a predefined border for a range of cells
    * customBorders: [
    *   // add an object with a border configuration for one range of cells
    *   {
    *     // select a range of cells
    *     range: {
    *       // set the range's top-left corner
    *       from: {
    *         row: 1,
    *         col: 1
    *       },
    *       // set the range's bottom-right corner
    *       to: {
    *         row: 3,
    *         col: 4
    *       }
    *     },
    *     // set the left/right border's width, color and style
    *     start: {
    *       width: 2,
    *       color: 'red',
    *       style: 'dashed'
    *     },
    *     // set the right/left border's width and color
    *     end: {},
    *     // set the top border's width and color
    *     top: {},
    *     // set the bottom border's width and color
    *     bottom: {}
    *   }
    * ],
    * ```
    */
    customBorders: false,
    /**
    * @description
    * The `data` option sets the initial [data](@/guides/getting-started/binding-to-data/binding-to-data.md) of your Handsontable instance.
    *
    * Handsontable's data is bound to your source data by reference (i.e. when you edit Handsontable's data, your source data alters as well).
    *
    * You can set the `data` option:
    * - Either to an [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays).
    * - Or to an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects).
    *
    * If you don't set the `data` option (or set it to `null`), Handsontable renders as an empty 5x5 grid by default.
    *
    * When used inside the [`columns`](#columns) option, `data` has a different meaning: it acts as a property name
    * (or a dot-separated path) pointing to the field in each data row object that this column reads from and writes to.
    * In this context, `data` is not the full dataset but a column accessor string.
    *
    * Read more:
    * - [Binding to data](@/guides/getting-started/binding-to-data/binding-to-data.md)
    * - [`dataSchema`](#dataSchema)
    * - [`startRows`](#startRows)
    * - [`startCols`](#startCols)
    *
    * @memberof Options#
    * @type {Array[]|object[]}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // as an array of arrays
    * data: [
    *   ['A', 'B', 'C'],
    *   ['D', 'E', 'F'],
    *   ['G', 'H', 'J']
    * ]
    *
    * // as an array of objects
    * data: [
    *   {id: 1, name: 'Ted Right'},
    *   {id: 2, name: 'Frank Honest'},
    *   {id: 3, name: 'Joan Well'},
    *   {id: 4, name: 'Gail Polite'},
    *   {id: 5, name: 'Michael Fair'},
    * ]
    *
    * // as a column accessor inside `columns`
    * columns: [
    *   { data: 'id' },
    *   { data: 'name' }
    * ]
    * ```
    */
    data: void 0,
    /**
    * @description
    * When set, the table loads data from an async provider (e.g. a REST API) instead of a static `data` array.
    * Use the **object** form with every key defined: **`rowId`**, **`fetchRows`**, **`onRowsCreate`**, **`onRowsUpdate`**,
    * and **`onRowsRemove`**. All five are required on that object so paging, row identity, and create, update, and remove
    * map cleanly to your backend. Pair with **`pagination`** for server-side paging.
    * Valid cell edits apply at once; if **`onRowsUpdate`** fails or **`beforeRowsMutation`** blocks the update, affected cells roll back.
    *
    * @since 17.1.0
    * @memberof Options#
    * @type {object}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * dataProvider: {
    *   rowId: 'id',
    *   fetchRows: async (queryParameters, { signal }) => {
    *     const { page, pageSize, sort, filters } = queryParameters;
    *     const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    *
    *     if (sort) {
    *       params.set('sortBy', sort.prop);
    *       params.set('sortDir', sort.order);
    *     }
    *
    *     const res = await fetch(`/api/products?${params}`, { signal });
    *     const json = await res.json();
    *
    *     return { rows: json.data, totalRows: json.total };
    *   },
    *   onRowsCreate: async ({ position, referenceRowId, rowsAmount }) => { ... },
    *   onRowsUpdate: async (rows) => { ... },
    *   onRowsRemove: async (rowIds) => { ... },
    * },
    * ```
    */
    dataProvider: void 0,
    /**
    * @description
    * If `true`, Handsontable will interpret the dots in the columns mapping as a nested object path. If your dataset contains
    * the dots in the object keys and you don't want Handsontable to interpret them as a nested object path, set this option to `false`.
    *
    * The option only works when defined in the global table settings.
    *
    * @since 14.4.0
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // All dots are interpreted as nested object paths
    * dataDotNotation: true,
    * data: [
    *   { id: 1, name: { first: 'Ted', last: 'Right' }, user: { address: '1234 Any Street' } },
    * ],
    * columns={[
    *   { data: 'name.first' },
    *   { data: 'user.address' },
    * ]},
    * ```
    * ```js
    * // All dots are interpreted as simple object keys
    * dataDotNotation: false,
    * data: [
    *   { id: 1, 'name.first': 'Ted', 'user.address': '1234 Any Street' },
    * ],
    * columns={[
    *   { data: 'name.first' },
    *   { data: 'user.address' },
    * ]},
    * ```
    */
    dataDotNotation: true,
    /**
    * @description
    * When the [`data`](#data) option is set to an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects)
    * (or is empty), the `dataSchema` option defines the structure of new rows.
    *
    * Using the `dataSchema` option, you can start out with an empty grid.
    *
    * You can set the `dataSchema` option to one of the following:
    * - An object
    * - A function
    *
    * Read more:
    * - [Binding to data: Array of objects with custom data schema](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects-with-custom-data-schema)
    * - [Binding to data: Function data source and schema](@/guides/getting-started/binding-to-data/binding-to-data.md#function-data-source-and-schema)
    * - [`data`](#data)
    *
    * @memberof Options#
    * @type {object|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // with `dataSchema`, you can start with an empty grid
    * data: null,
    * dataSchema: {id: null, name: {first: null, last: null}, address: null},
    * colHeaders: ['ID', 'First Name', 'Last Name', 'Address'],
    * columns: [
    *   {data: 'id'},
    *   {data: 'name.first'},
    *   {data: 'name.last'},
    *   {data: 'address'}
    * ],
    * startRows: 5,
    * minSpareRows: 1
    * ```
    */
    dataSchema: void 0,
    /**
    * Configures the date format for date cells using an
    * [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat)
    * options object.
    *
    * The locale is controlled separately via the [`locale`](@/api/options.md#locale) option.
    *
    * ::: tip Source data format
    * Source data must be in ISO 8601 date format (`YYYY-MM-DD`). Otherwise operations such
    * as sorting and filtering can be unstable or unpredictable. The `dateFormat` object affects only how dates are
    * displayed; the underlying value should remain ISO.
    * :::
    *
    * **Style shortcuts:**
    *
    * | Property     | Possible values                                    | Description                                              |
    * | ------------ | -------------------------------------------------- | -------------------------------------------------------- |
    * | `dateStyle`  | `'full'`, `'long'`, `'medium'`, `'short'`          | Date formatting style (expands to weekday, day, month, year, era) |
    *
    * **Date-time component options:**
    *
    * | Property                 | Possible values                                                                 | Description                          |
    * | ------------------------ | ------------------------------------------------------------------------------- | ------------------------------------ |
    * | `weekday`                | `'long'`, `'short'`, `'narrow'`                                                 | Representation of the weekday        |
    * | `era`                    | `'long'`, `'short'`, `'narrow'`                                                 | Representation of the era            |
    * | `year`                   | `'numeric'`, `'2-digit'`                                                        | Representation of the year           |
    * | `month`                  | `'numeric'`, `'2-digit'`, `'long'`, `'short'`, `'narrow'`                       | Representation of the month          |
    * | `day`                    | `'numeric'`, `'2-digit'`                                                        | Representation of the day            |
    * | `dayPeriod`              | `'narrow'`, `'short'`, `'long'`                                                 | Day period (e.g. "am", "noon")       |
    * | `hour`                   | `'numeric'`, `'2-digit'`                                                        | Representation of the hour           |
    * | `minute`                 | `'numeric'`, `'2-digit'`                                                        | Representation of the minute         |
    * | `second`                 | `'numeric'`, `'2-digit'`                                                        | Representation of the second         |
    * | `fractionalSecondDigits` | `1`, `2`, `3`                                                                   | Fraction-of-second digits            |
    * | `timeZoneName`           | `'long'`, `'short'`, `'shortOffset'`, `'longOffset'`, `'shortGeneric'`, `'longGeneric'` | Time zone display                 |
    *
    * **Locale and other options:**
    *
    * | Property          | Possible values                                    | Description                    |
    * | ----------------- | -------------------------------------------------- | ------------------------------ |
    * | `localeMatcher`   | `'best fit'` (default), `'lookup'`                  | Locale matching algorithm      |
    * | `calendar`        | `'chinese'`, `'gregory'`, `'persian'`, etc.        | Calendar to use                |
    * | `numberingSystem` | `'latn'`, `'arab'`, `'hans'`, etc.                 | Numbering system               |
    * | `timeZone`        | IANA time zone (e.g. `'UTC'`, `'America/New_York'`) | Time zone for formatting       |
    * | `hour12`          | `true`, `false`                                    | Use 12-hour vs 24-hour time   |
    * | `hourCycle`       | `'h11'`, `'h12'`, `'h23'`, `'h24'`                 | Hour cycle                     |
    * | `formatMatcher`   | `'basic'`, `'best fit'` (default)                  | Format matching algorithm      |
    *
    * For complete reference, see [MDN: Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat).
    *
    * Read more:
    * - [Date cell type](@/guides/cell-types/date-cell-type/date-cell-type.md)
    * - [`locale`](@/api/options.md#locale)
    *
    * @memberof Options#
    * @type {Intl.DateTimeFormatOptions}
    * @default { year: 'numeric', month: '2-digit', day: '2-digit' }
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'date',
    *     locale: 'en-US',
    *     dateFormat: {
    *       dateStyle: 'short'
    *     }
    *   }
    * ]
    * ```
    */
    dateFormat: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    /**
    * Configures the time format for `intl-time` cells using an
    * [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat)
    * options object. The locale is controlled separately via the [`locale`](@/api/options.md#locale) option.
    *
    * ::: tip Source data format
    * Source data must be in 24-hour time format (`HH:mm`, `HH:mm:ss`, or `HH:mm:ss.SSS`), matching
    * the HTML `input type="time"` value. Otherwise operations such as sorting and filtering can be unstable or unpredictable.
    * The `timeFormat` object affects only how times are displayed; the underlying value should remain in that format.
    * :::
    *
    * **Style shortcuts:**
    *
    * | Property     | Possible values                                    | Description                                              |
    * | ------------ | -------------------------------------------------- | -------------------------------------------------------- |
    * | `timeStyle`  | `'full'`, `'long'`, `'medium'`, `'short'`          | Time formatting style (expands to hour, minute, second, timeZoneName) |
    *
    * **Time component options:**
    *
    * | Property                 | Possible values                                                                 | Description                          |
    * | ------------------------ | ------------------------------------------------------------------------------- | ------------------------------------ |
    * | `hour`                   | `'numeric'`, `'2-digit'`                                                        | Representation of the hour           |
    * | `minute`                 | `'numeric'`, `'2-digit'`                                                        | Representation of the minute         |
    * | `second`                 | `'numeric'`, `'2-digit'`                                                        | Representation of the second         |
    * | `fractionalSecondDigits` | `1`, `2`, `3`                                                                   | Fraction-of-second digits            |
    * | `dayPeriod`              | `'narrow'`, `'short'`, `'long'`                                                 | Day period (e.g. "am", "noon")       |
    * | `timeZoneName`           | `'long'`, `'short'`, `'shortOffset'`, `'longOffset'`, `'shortGeneric'`, `'longGeneric'` | Time zone display                 |
    *
    * **Locale and other options:**
    *
    * | Property          | Possible values                                    | Description                    |
    * | ----------------- | -------------------------------------------------- | ------------------------------ |
    * | `localeMatcher`   | `'best fit'` (default), `'lookup'`                  | Locale matching algorithm      |
    * | `timeZone`        | IANA time zone (e.g. `'UTC'`, `'America/New_York'`) | Time zone for formatting       |
    * | `hour12`          | `true`, `false`                                    | Use 12-hour vs 24-hour time   |
    * | `hourCycle`       | `'h11'`, `'h12'`, `'h23'`, `'h24'`                 | Hour cycle                     |
    * | `formatMatcher`   | `'basic'`, `'best fit'` (default)                  | Format matching algorithm      |
    *
    * For complete reference, see [MDN: Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat).
    *
    * Read more:
    * - [Time cell type](@/guides/cell-types/time-cell-type/time-cell-type.md)
    * - [`locale`](@/api/options.md#locale)
    *
    * @memberof Options#
    * @type {object}
    * @default { hour: '2-digit', minute: '2-digit' }
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'intl-time',
    *     locale: 'en-US',
    *     timeFormat: {
    *       timeStyle: 'medium'
    *     }
    *   }
    * ]
    * ```
    */
    timeFormat: {
      hour: "2-digit",
      minute: "2-digit"
    },
    /**
    * The `defaultDate` option configures the date pre-selected in the date picker editor
    * when opening an empty [`date`](@/guides/cell-types/date-cell-type/date-cell-type.md) cell for editing.
    *
    * The option accepts a string in ISO 8601 format (`YYYY-MM-DD`).
    *
    * ::: tip
    * `defaultDate` affects only the date picker's initial selection when the cell is empty.
    * It does not automatically populate empty cells with this date - the cell's value remains empty
    * until the user confirms a selection.
    * :::
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [Date cell type](@/guides/cell-types/date-cell-type/date-cell-type.md)
    * - [`dateFormat`](#dateFormat)
    *
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'date',
    *     defaultDate: '2015-02-02'
    *   }
    * ],
    * ```
    */
    defaultDate: void 0,
    /**
    * @description
    * The `disableVisualSelection` option configures how
    * [selection](@/guides/cell-features/selection/selection.md) is shown.
    *
    * You can set the `disableVisualSelection` option to one of the following:
    *
    * | Setting           | Description                                                                                         |
    * | ----------------- | --------------------------------------------------------------------------------------------------- |
    * | `false` (default) | - Show single-cell selection<br>- Show range selection<br>- Show header selection                   |
    * | `true`            | - Don't show single-cell selection<br>- Don't show range selection<br>- Don't show header selection |
    * | `'current'`       | - Don't show single-cell selection<br>- Show range selection<br>- Show header selection             |
    * | `'area'`          | - Show single-cell selection<br>- Don't show range selection<br>- Show header selection             |
    * | `'header'`        | - Show single-cell selection<br>- Show range selection<br>- Don't show header selection             |
    * | An array          | A combination of `'current'`, `'area'`, and/or `'header'`                                           |
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * When set to any non-`false` value, the second-click deselect behavior
    * (Ctrl/Cmd+click on an already-selected cell removing it from a multi-cell selection)
    * is also skipped. Without visible feedback, toggling layers off can cause unexpected
    * highlight jumps.
    *
    * Read more:
    * - [Selection](@/guides/cell-features/selection/selection.md)
    *
    * @memberof Options#
    * @type {boolean|string|string[]}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // don't show single-cell selection
    * // don't show range selection
    * // don't show header selection
    * disableVisualSelection: true,
    *
    * // don't show single-cell selection
    * // show range selection
    * // show header selection
    * disableVisualSelection: 'current',
    *
    * // don't show single-cell selection
    * // don't show range selection
    * // show header selection
    * disableVisualSelection: ['current', 'area'],
    * ```
    */
    disableVisualSelection: false,
    /**
    * @description
    * The `dialog` option configures the [`Dialog`](@/api/dialog.md) plugin.
    *
    * You can set the `dialog` option to one of the following:
    *
    * | Setting   | Description                                                                 |
    * | --------- | --------------------------------------------------------------------------- |
    * | `false`   | Disable the [`Dialog`](@/api/dialog.md) plugin                              |
    * | `true`    | Enable the [`Dialog`](@/api/dialog.md) plugin with default options          |
    *
    * ##### dialog: Additional options
    *
    * | Option                   | Possible settings                                                                                                               | Description                             |
    * | ------------------------ | ------------------------------------------------------------------------------------------------------------------------------- | ----------------------------------------|
    * | `template`               | Object with the template configuration (default: `null`).                                                                       | The template of the dialog allows to use prebuild templates |
    * | `template.type`          | The type of the template ('confirm')                                                                                            | The type of the template                |
    * | `template.title`         | The title of the template                                                                                                       | The title of the template               |
    * | `template.description`   | The description of the template                                                                                                 | The description of the template         |
    * | `template.buttons`       | Array of objects with the buttons configuration (default: `[]`)                                                                 | The buttons of the template             |
    * | `template.buttons.text`  | The text of the button                                                                                                          | The text of the button                  |
    * | `template.buttons.type`  | The type of the button ('primary' | 'secondary')                                                                                | The type of the button                  |
    * | `template.buttons.callback` | The callback function to trigger when the button is clicked                                                                  | The callback function to trigger when the button is clicked |
    * | `content`                | A string, HTMLElement or DocumentFragment (default: `''`)                                                                       | The content of the dialog               |
    * | `customClassName`        | A string (default: `''`)                                                                                                        | The custom class name of the dialog     |
    * | `background`             | One of the options: `'solid'` or `'semi-transparent'` (default: `'solid'`)                                                      | The background of the dialog            |
    * | `contentBackground`      | Boolean (default: `false`)                                                                                                      | Whether to show the content background  |
    * | `animation`              | Boolean (default: `true`)                                                                                                       | Whether to show the animation           |
    * | `closable`               | Boolean (default: `false`)                                                                                                      | Whether to make the dialog closable     |
    * | `a11y`                   | Object with accessibility options (default: `{ role: 'dialog', ariaLabel: 'Dialog', ariaLabelledby: '', ariaDescribedby: '' }`) | Accessibility options for the dialog    |
    * | `a11y.role`              | The role of the dialog ('dialog' | 'alertdialog')                                                                               | The role of the dialog                  |
    * | `a11y.ariaLabel`         | The label of the dialog                                                                                                         | The label of the dialog                 |
    * | `a11y.ariaLabelledby`    | The ID of the element that labels the dialog                                                                                    | The ID of the element that labels the dialog |
    * | `a11y.ariaDescribedby`   | The ID of the element that describes the dialog                                                                                 | The ID of the element that describes the dialog |
    *
    * Read more:
    * - [Plugins: `Dialog`](@/api/dialog.md)
    *
    * @since 16.1.0
    * @memberof Options#
    * @type {boolean|object}
    * @default false
    * @category Dialog
    *
    * @example
    * ::: only-for javascript
    * ```js
    * // enable the Dialog plugin with default option
    * dialog: true,
    *
    * // enable the Dialog plugin with custom configuration
    * dialog: {
    *   content: 'Dialog content',
    *   customClassName: 'custom-dialog',
    *   background: 'semi-transparent',
    *   contentBackground: false,
    *   animation: false,
    *   closable: true,
    *   a11y: {
    *     role: 'dialog',
    *     ariaLabel: 'Dialog',
    *     ariaLabelledby: 'titleID',
    *     ariaDescribedby: 'descriptionID',
    *   }
    * }
    *
    * // enable the Dialog plugin using a template
    * dialog: {
    *   template: {
    *     type: 'confirm',
    *     title: 'Confirm',
    *     description: 'Do you want change the value?',
    *     buttons: [
    *       {
    *         text: 'Ok',
    *         type: 'primary',
    *         callback: () => {
    *           console.log('Ok');
    *         }
    *       },
    *     ],
    *   },
    * }
    * ```
    * :::
    *
    * ::: only-for react
    * ```jsx
    * // enable the Dialog plugin with default option
    * <HotTable
    *   dialog={true}
    * />
    *
    * // enable the Dialog plugin with custom configuration
    * <HotTable
    *   dialog={{
    *     content: 'Dialog content',
    *     customClassName: 'custom-dialog',
    *     background: 'semi-transparent',
    *     contentBackground: false,
    *     animation: false,
    *     closable: true,
    *     a11y: {
    *       role: 'dialog',
    *       ariaLabel: 'Dialog',
    *       ariaLabelledby: 'titleID',
    *       ariaDescribedby: 'descriptionID',
    *     }
    *   }
    *   }}
    * />
    *
    * // enable the Dialog plugin using a template
    * <HotTable
    *   dialog={{
    *     template: {
    *       type: 'confirm',
    *       title: 'Confirm',
    *       description: 'Do you want change the value?',
    *     }
    *   }}
    * />
    * ```
    * :::
    *
    * ::: only-for angular
    * ```ts
    * settings = {
    *   dialog: {
    *     content: 'Dialog content',
    *     customClassName: 'custom-dialog',
    *     background: 'semi-transparent',
    *     contentBackground: false,
    *     animation: false,
    *     closable: true,
    *     a11y: {
    *       role: 'dialog',
    *       ariaLabel: 'Dialog',
    *       ariaLabelledby: 'titleID',
    *       ariaDescribedby: 'descriptionID',
    *     }
    *   }
    * };
    *
    * // enable the Dialog plugin using a template
    * settings = {
    *   dialog: {
    *     template: {
    *       type: 'confirm',
    *       title: 'Confirm',
    *       description: 'Do you want change the value?',
    *     }
    *   }
    * };
    * ```
    *
    * ```html
    * <hot-table [settings]="settings" />
    * ```
    * :::
    *
    */
    dialog: false,
    /**
    * @description
    * The `dragToScroll` option configures the [`DragToScroll`](@/api/dragToScroll.md) plugin.
    *
    * You can set the `dragToScroll` option to one of the following:
    *
    * | Setting          | Description                                                                                                                                 |
    * | ---------------- | ------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default) | Enable with default auto-scroll settings                                                                                                    |
    * | `false`          | Disable the plugin entirely                                                                                                                 |
    * | Object           | Enable with custom auto-scroll settings (see below)                                                                                        |
    *
    * When passing an object, the following properties control the auto-scroll speed:
    *
    * ```js
    * dragToScroll: {
    *   interval: {
    *     min: 20,   // Fastest scroll interval in ms (reached at rampDistance)
    *     max: 500,  // Slowest scroll interval in ms (applied at the viewport edge)
    *   },
    *   rampDistance: 120,  // Pixels outside the edge over which speed ramps up
    * },
    * ```
    *
    * The viewport scrolls periodically while the mouse pointer stays outside the
    * viewport edge. Speed follows a logarithmic curve: slow at the edge, fast when
    * far outside. The active selection (regular drag-select or autofill drag)
    * extends to follow the scroll.
    *
    * Read more:
    * - [Plugins: `DragToScroll`](@/api/dragToScroll.md)
    *
    * @memberof Options#
    * @type {boolean|object}
    * @default true
    * @category DragToScroll
    *
    * @example
    * ```js
    * // Enable with default settings
    * dragToScroll: true,
    *
    * // Enable with custom scroll speed
    * dragToScroll: {
    *   interval: { min: 60, max: 300 },
    *   rampDistance: 60,
    * },
    *
    * // Disable
    * dragToScroll: false,
    * ```
    */
    dragToScroll: true,
    /**
    * The `dropdownMenu` option configures the [`DropdownMenu`](@/api/dropdownMenu.md) plugin.
    *
    * You can set the `dropdownMenu` option to one of the following:
    *
    * | Setting   | Description                                                                                                                                                                                  |
    * | --------- | -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`DropdownMenu`](@/api/dropdownMenu.md) plugin                                                                                                                                   |
    * | `true`    | - Enable the [`DropdownMenu`](@/api/dropdownMenu.md) plugin<br>- Use the [default context menu options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-default-options)    |
    * | An array  | - Enable the [`DropdownMenu`](@/api/dropdownMenu.md) plugin<br>- Modify [individual context menu options](@/guides/accessories-and-menus/context-menu/context-menu.md#context-menu-with-specific-options) |
    * | An object | - Enable the [`DropdownMenu`](@/api/dropdownMenu.md) plugin<br>- Apply a custom dropdown menu configuration                                                                                  |
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It is not possible to show or hide the dropdown menu icon for individual columns using this option.
    *
    * Read more:
    * - [Context menu](@/guides/accessories-and-menus/context-menu/context-menu.md)
    * - [Plugins: `DropdownMenu`](@/api/dropdownMenu.md)
    *
    * @memberof Options#
    * @type {boolean|object|string[]}
    * @default undefined
    * @category DropdownMenu
    *
    * @example
    * ```js
    * // enable the `DropdownMenu` plugin
    * // use the default context menu options
    * dropdownMenu: true,
    *
    * // enable the `DropdownMenu` plugin
    * // and modify individual context menu options
    * dropdownMenu: ['---------', 'undo', 'redo'],
    *
    * // enable the `DropdownMenu` plugin
    * // and apply a custom dropdown menu configuration
    * dropdownMenu: {
    *   items: {
    *     'option1': {
    *       name: 'Option 1'
    *     },
    *     'option2': {
    *       name: 'Option 2',
    *       submenu: {
    *         items: [
    *           {
    *             key: 'option2:suboption1',
    *             name: 'Suboption 1',
    *             callback(key, options) {
    *               ...
    *             }
    *           },
    *           ...
    *         ]
    *       }
    *     }
    *   }
    * },
    * ```
    */
    dropdownMenu: void 0,
    /**
    * The `editor` option sets a [cell editor](@/guides/cell-functions/cell-editor/cell-editor.md) for a cell.
    *
    * You can set the `editor` option to one of the following [cell editor aliases](@/guides/cell-functions/cell-editor/cell-editor.md):
    *
    * | Alias               | Cell editor function                                                       |
    * | ------------------- | -------------------------------------------------------------------------- |
    * | A custom alias      | Your [custom cell editor](@/guides/cell-functions/cell-editor/cell-editor.md) function |
    * | `'autocomplete'`    | `AutocompleteEditor`                                                       |
    * | `'base'`            | `BaseEditor`                                                               |
    * | `'checkbox'`        | `CheckboxEditor`                                                           |
    * | `'date'`            | `DateEditor`                                                               |
    * | `'intl-date'`       | `IntlDateEditor`                                                           |
    * | `'dropdown'`        | `DropdownEditor`                                                           |
    * | `'handsontable'`    | `HandsontableEditor`                                                       |
    * | `'numeric'`         | `NumericEditor`                                                            |
    * | `'password'`        | `PasswordEditor`                                                           |
    * | `'select'`          | `SelectEditor`                                                             |
    * | `'text'`            | `TextEditor`                                                               |
    * | `'time'`            | `TimeEditor`                                                               |
    * | `'intl-time'`       | `IntlTimeEditor`                                                           |
    *
    * To disable editing cells through cell editors,
    * set the `editor` option to `false`.
    * You'll still be able to change cells' content through Handsontable's API
    * or through plugins (e.g. [`CopyPaste`](@/api/copyPaste.md)), though.
    *
    * To set the [`editor`](#editor), [`renderer`](#renderer), and [`validator`](#validator)
    * options all at once, use the [`type`](#type) option.
    *
    * Read more:
    * - [Cell editor](@/guides/cell-functions/cell-editor/cell-editor.md)
    * - [Cell type](@/guides/cell-types/cell-type/cell-type.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    * - [`type`](#type)
    *
    * @memberof Options#
    * @type {string|Function|boolean}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // use the `numeric` editor for each cell of the entire grid
    * editor: 'numeric',
    *
    * // apply the `editor` option to individual columns
    * columns: [
    *   {
    *     // use the `autocomplete` editor for each cell of this column
    *     editor: 'autocomplete'
    *   },
    *   {
    *     // disable editing cells through cell editors for each cell of this column
    *     editor: false
    *   }
    * ]
    * ```
    */
    editor: void 0,
    /**
    * @description
    * The `emptyDataState` option configures the [`EmptyDataState`](@/api/emptyDataState.md) plugin.
    *
    * You can set the `emptyDataState` option to one of the following:
    *
    * | Setting   | Description                                                                        |
    * | --------- | ---------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`EmptyDataState`](@/api/emptyDataState.md) plugin                     |
    * | `true`    | Enable the [`EmptyDataState`](@/api/emptyDataState.md) plugin                      |
    * | An object | Enable the [`EmptyDataState`](@/api/emptyDataState.md) plugin with custom settings |
    *
    * If you set the `emptyDataState` option to an object, you can configure the following settings:
    *
    * | Property  | Possible values                    | Description                                         |
    * | --------  | ---------------------------------- | --------------------------------------------------- |
    * | `message` | `string` \| `object` \| `function` | Message to display in the empty data state overlay. |
    *
    * If you set the `message` option to an object, it have following properties:
    *
    * | Property      | Possible values | Description                                             |
    * | ------------- | --------------- | ------------------------------------------------------- |
    * | `title`       | `string`        | Title to display in the empty data state overlay.       |
    * | `description` | `string`        | Description to display in the empty data state overlay. |
    * | `buttons`     | `array`         | Buttons to display in the empty data state overlay.     |
    * | `loading`     | `boolean`       | When `true`, shows a loading spinner (used for server fetch state). |
    *
    * If you set the `message` option to a function, the `source` argument can be `"unknown"`, `"filters"`, or `"loading"`.
    * With [[Options#dataProvider]], the `"loading"` branch follows DataProvider fetch hooks (`beforeDataProviderFetch`,
    * `afterDataProviderFetch`, and related hooks) using the same rules as server-backed loading in the DataProvider plugin.
    * Internal refetches (for example after column sort or CRUD) set `skipLoading` on [[Hooks#beforeDataProviderFetch]] so the
    * EmptyDataState plugin can omit the loading overlay for those requests.
    *
    * If you set the `buttons` option to an array, each item requires following properties:
    *
    * | Property   | Possible values          | Description                                                  |
    * | ---------- | ------------------------ | ------------------------------------------------------------ |
    * | `text`     | `string`                 | Text to display in the button.                        |
    * | `type`     | 'primary' \| 'secondary' | Type of the button.                                   |
    * | `callback` | `function`               | Callback function to call when the button is clicked. |
    *
    * Read more:
    * - [Plugins: `EmptyDataState`](@/api/emptyDataState.md)
    *
    * @since 16.2.0
    * @memberof Options#
    * @type {boolean|object}
    * @default false
    * @category EmptyDataState
    *
    * @example
    * ```js
    * // Enable empty data state plugin with default messages
    * emptyDataState: true,
    *
    * // Enable empty data state plugin with custom message
    * emptyDataState: {
    *   message: 'No data available',
    * },
    *
    * // Enable empty data state plugin with custom message and buttons for any source
    * emptyDataState: {
    *   message: {
    *     title: 'No data available',
    *     description: 'There’s nothing to display yet.',
    *     buttons: [{ text: 'Reset filters', type: 'secondary', callback: () => {} }],
    *   },
    * },
    *
    * // Enable empty data state plugin with custom message and buttons for specific source
    * emptyDataState: {
    *   message: (source) => {
    *     switch (source) {
    *       case "filters":
    *         return {
    *           title: 'No data available',
    *           description: 'There’s nothing to display yet.',
    *           buttons: [{ text: 'Reset filters', type: 'secondary', callback: () => {} }],
    *         };
    *       case "loading":
    *         return {
    *           title: 'Loading data',
    *           description: 'Please wait.',
    *         };
    *       default:
    *         return {
    *           title: 'No data available',
    *           description: 'There’s nothing to display yet.',
    *         };
    *     }
    *   },
    * },
    * ```
    */
    emptyDataState: false,
    /**
    * The `enterBeginsEditing` option configures the action of the <kbd>**Enter**</kbd> key.
    *
    * You can set the `enterBeginsEditing` option to one of the following:
    *
    * | Setting          | Description                                                                                                                                                                                               |
    * | ---------------- | --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default) | - On pressing <kbd>**Enter**</kbd> once, enter the editing mode of the active cell<br>- On pressing <kbd>**Enter**</kbd> twice, move to another cell,<br>as configured by the [`enterMoves`](#enterMoves) setting |
    * | `false`          | - On pressing <kbd>**Enter**</kbd> once, move to another cell,<br>as configured by the [`enterMoves`](#enterMoves) setting                                                                                    |
    *
    * Read more:
    * - [`enterMoves`](#enterMoves)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // press Enter once to start editing
    * // press Enter twice to move to another cell
    * enterBeginsEditing: true,
    *
    * // press Enter once to move to another cell
    * enterBeginsEditing: false,
    * ```
    */
    enterBeginsEditing: true,
    /**
    * The `enterCommits` option configures whether the <kbd>**Enter**</kbd> key closes the [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md) editor.
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @since 17.0.0
    * @category Core
    * @example
    * ```js
    * columns: [{
    *   type: 'multiselect',
    *   // press Enter to close the `multiSelect` editor and Space to select an option
    *   enterCommits: true,
    * }, {
    *   type: 'multiselect',
    *   // press Enter to select an option
    *   enterCommits: false,
    * }],
    * ],
    * ```
    */
    enterCommits: true,
    /**
    * The `enterMoves` option configures the action of the <kbd>**Enter**</kbd> key.
    *
    * If the [`enterBeginsEditing`](#enterBeginsEditing) option is set to `true`,
    * the `enterMoves` setting applies to the **second** pressing of the <kbd>**Enter**</kbd> key.
    *
    * If the [`enterBeginsEditing`](#enterBeginsEditing) option is set to `false`,
    * the `enterMoves` setting applies to the **first** pressing of the <kbd>**Enter**</kbd> key.
    *
    * You can set the `enterMoves` option to an object with the following properties
    * (or to a function that returns such an object):
    *
    * | Property | Type   | Description                                                                                                                                              |
    * | -------- | ------ | -------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `col`    | Number | - On pressing <kbd>**Enter**</kbd>, move selection `col` columns right<br>- On pressing <kbd>**Shift**</kbd>+<kbd>**Enter**</kbd>, move selection `col` columns left |
    * | `row`    | Number | - On pressing <kbd>**Enter**</kbd>, move selection `row` rows down<br>- On pressing <kbd>**Shift**</kbd>+<kbd>**Enter**</kbd>, move selection `row` rows up          |
    *
    * Read more:
    * - [`enterBeginsEditing`](#enterBeginsEditing)
    *
    * @memberof Options#
    * @type {object|Function}
    * @default {col: 0, row: 1}
    * @category Core
    *
    * @example
    * ```js
    * // on pressing Enter, move selection 1 column right and 1 row down
    * // on pressing Shift+Enter, move selection 1 column left and 1 row up
    * enterMoves: {col: 1, row: 1},
    *
    * // the same setting, as a function
    * // `event` is a DOM Event object received on pressing Enter
    * // you can use it to check whether the user pressed Enter or Shift+Enter
    * enterMoves(event) {
    *   return {col: 1, row: 1};
    * },
    * ```
    */
    enterMoves: {
      col: 0,
      row: 1
    },
    /**
    * The `exportFile` option configures the [`ExportFile`](@/api/exportFile.md) plugin.
    *
    * You can set the `exportFile` option to one of the following:
    *
    * | Setting     | Description                                                                                |
    * | ----------- | ------------------------------------------------------------------------------------------ |
    * | `undefined` | Use the [`ExportFile`](@/api/exportFile.md) plugin with the default configuration          |
    * | An object   | Enable the [`ExportFile`](@/api/exportFile.md) plugin and modify the plugin options        |
    *
    * If you set the `exportFile` option to an object, you can configure the following options:
    *
    * | Option    | Type     | Default | Description                                                                         |
    * | --------- | -------- | ------- | ----------------------------------------------------------------------------------- |
    * | `engines` | `Object` | –       | A map of format keys to their engine constructors. Pass `{ xlsx: ExcelJS }` to enable XLSX export via [ExcelJS](https://github.com/exceljs/exceljs). |
    *
    * Read more:
    * - [Export to Excel](@/guides/accessories-and-menus/export-to-excel/export-to-excel.md)
    * - [Plugins: `ExportFile`](@/api/exportFile.md)
    *
    * @memberof Options#
    * @type {object}
    * @default undefined
    * @since 17.1.0
    * @category ExportFile
    *
    * @example
    * ```js
    * import ExcelJS from 'exceljs';
    *
    * // enable XLSX export
    * exportFile: {
    *   engines: { xlsx: ExcelJS },
    * },
    * ```
    */
    exportFile: void 0,
    /**
    * The `fillHandle` option configures the [Autofill](@/api/autofill.md) plugin.
    *
    * You can set the `fillHandle` option to one the following:
    *
    * | Setting        | Description                                                                |
    * | -------------- | -------------------------------------------------------------------------- |
    * | `true`         | - Enable autofill in all directions<br>- Add the fill handle               |
    * | `false`        | Disable autofill                                                           |
    * | `'vertical'`   | - Enable vertical autofill<br>- Add the fill handle                        |
    * | `'horizontal'` | - Enable horizontal autofill<br>- Add the fill handle                      |
    * | An object      | - Enable autofill<br>- Add the fill handle<br>- Configure autofill options |
    *
    * If you set the `fillHandle` option to an object, you can configure the following autofill options:
    *
    * | Option          | Possible settings              | Description                                                                                               |
    * | --------------- | ------------------------------ | --------------------------------------------------------------------------------------------------------- |
    * | `autoInsertRow` | `true` (default) \| `false`    | `true`: When you reach the grid's bottom, add new rows<br>`false`: When you reach the grid's bottom, stop |
    * | `direction`     | `'vertical'` \| `'horizontal'` | `'vertical'`: Enable vertical autofill<br>`'horizontal'`: Enable horizontal autofill                      |
    *
    * Read more:
    * - [AutoFill values](@/guides/cell-features/autofill-values/autofill-values.md)
    *
    * @memberof Options#
    * @type {boolean|string|object}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // enable autofill in all directions
    * // with `autoInsertRow` enabled
    * fillHandle: true,
    *
    * // enable vertical autofill
    * // with `autoInsertRow` enabled
    * fillHandle: 'vertical',
    *
    * // enable horizontal autofill
    * // with `autoInsertRow` enabled
    * fillHandle: 'horizontal',
    *
    * // enable autofill in all directions
    * // with `autoInsertRow` disabled
    * fillHandle: {
    *   autoInsertRow: false,
    * },
    *
    * // enable vertical autofill
    * // with `autoInsertRow` disabled
    * fillHandle: {
    *   autoInsertRow: false,
    *   direction: 'vertical'
    * },
    * ```
    */
    fillHandle: {
      autoInsertRow: false
    },
    /**
    * The `filter` option configures whether [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) cells'
    * lists are updated by the end user's input.
    *
    * You can set the `filter` option to one of the following:
    *
    * | Setting          | Description                                                                                                           |
    * | ---------------- | --------------------------------------------------------------------------------------------------------------------- |
    * | `true` (default) | When the end user types into the input area, only options matching the input are displayed                            |
    * | `false`          | When the end user types into the input area, all options are displayed<br>(options matching the input are put in bold |
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [`source`](#source)
    * - [`filteringCaseSensitive`](#filteringCaseSensitive)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * columns: [{
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // set options available in every `autocomplete` cell of this column
    *   source: ['A', 'B', 'C'],
    *   // when the end user types in `A`, display only the A option
    *   // when the end user types in `B`, display only the B option
    *   // when the end user types in `C`, display only the C option
    *   filter: true
    * }],
    * ```
    */
    filter: true,
    /**
    * The `filteringCaseSensitive` option configures whether [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) and [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md)-typed cells'
    * search inputs are case-sensitive.
    *
    * You can set the `filteringCaseSensitive` option to one of the following:
    *
    * | Setting           | Description                                                                                        |
    * | ----------------- | -------------------------------------------------------------------------------------------------- |
    * | `false` (default) | [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) cells' input is not case-sensitive |
    * | `true`            | [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) cells' input is case-sensitive     |
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [`source`](#source)
    * - [`filter`](#filter)
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'autocomplete',
    *     source: [ ... ],
    *     // match case while searching autocomplete options
    *     filteringCaseSensitive: true
    *   },
    *   {
    *     type: 'multiselect',
    *     source: [ ... ],
    *     // match case while searching multiSelect options
    *     filteringCaseSensitive: true
    *   }
    * ],
    * ```
    */
    filteringCaseSensitive: false,
    /**
    * The `filters` option configures the [`Filters`](@/api/filters.md) plugin.
    *
    * You can set the `filters` option to one of the following:
    *
    * | Setting   | Description                                                          |
    * | --------- | -------------------------------------------------------------------- |
    * | `false`   | Disable the [`Filters`](@/api/filters.md) plugin                     |
    * | `true`    | Enable the [`Filters`](@/api/filters.md) plugin                      |
    * | An object | Enable the [`Filters`](@/api/filters.md) plugin with custom settings |
    *
    * If you set the `filters` option to an object, you can configure the following settings:
    *
    * | Property                 | Possible values   | Description                            |
    * | ------------------------ | ----------------- | -------------------------------------- |
    * | `searchMode` | `'show'` \| `'apply'` | Enable filtering only visible elements |
    *
    * If filers is set to `true`, the `searchMode` option is set to `'show'` by default.
    *
    * Read more:
    * - [Column filter](@/guides/columns/column-filter/column-filter.md)
    * - [Plugins: `Filters`](@/api/filters.md)
    * - [`dropdownMenu`](#dropdownMenu)
    *
    * @memberof Options#
    * @type {boolean}
    * @default undefined
    * @category Filters
    *
    * @example
    * ```js
    * // enable the `Filters` plugin
    * filters: true,
    * ```
    */
    filters: void 0,
    /**
    * The `filterSelectedItems` option configures whether the selected items are filtered out of the dropdown, when using the search input of the [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md) editor.
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // filter out the selected items from the dropdown
    * filterSelectedItems: true,
    *
    * // keep the selected items in the dropdown
    * filterSelectedItems: false,
    */
    filterSelectedItems: true,
    /**
    * `fixedColumnsLeft` is a legacy option.
    *
    * If your grid's [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default), `fixedColumnsLeft` acts like the [`fixedColumnsStart`](#fixedColumnsStart) option.
    *
    * If your grid's [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL, using `fixedColumnsLeft` throws an error.
    *
    * Use [`fixedColumnsStart`](#fixedColumnsStart), which works in any layout direction.
    *
    * Read more:
    * - [`fixedColumnsStart`](#fixedcolumnsstart)
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // freeze the first 3 columns from the left
    * fixedColumnsLeft: 3,
    * ```
    */
    fixedColumnsLeft: 0,
    /**
    * If your grid's [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is LTR (default), the `fixedColumnsStart` option sets the number of [frozen columns](@/guides/columns/column-freezing/column-freezing.md) at the left-hand edge of the grid.
    *
    * If your grid's [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) is RTL, the `fixedColumnsStart` option sets the number of [frozen columns](@/guides/columns/column-freezing/column-freezing.md) at the right-hand edge of the grid.
    *
    * Read more:
    * - [Column freezing](@/guides/columns/column-freezing/column-freezing.md)
    * - [Layout direction](@/guides/internationalization/layout-direction/layout-direction.md)
    * - [`fixedColumnsLeft`](#fixedcolumnsleft)
    * - [`layoutDirection`](#layoutDirection)
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // when `layoutDirection` is set to `inherit` (default)
    * // freeze the first 3 columns from the left or from the right
    * // depending on your HTML document's `dir` attribute
    * layoutDirection: 'inherit',
    * fixedColumnsStart: 3,
    *
    * // when `layoutDirection` is set to `rtl`
    * // freeze the first 3 columns from the right
    * // regardless of your HTML document's `dir` attribute
    * layoutDirection: 'rtl',
    * fixedColumnsStart: 3,
    *
    * // when `layoutDirection` is set to `ltr`
    * // freeze the first 3 columns from the left
    * // regardless of your HTML document's `dir` attribute
    * layoutDirection: 'ltr',
    * fixedColumnsStart: 3,
    * ```
    */
    fixedColumnsStart: 0,
    /**
    * The `fixedRowsBottom` option sets the number of [frozen rows](@/guides/rows/row-freezing/row-freezing.md)
    * at the bottom of the grid.
    *
    * ::: tip
    * For the bottom frozen rows area to appear with a scroll separator, you must also set the [`height`](#height) option
    * in Handsontable's configuration. If the grid expands to fill its parent container without a defined height,
    * no vertical scrollbar is created and the fixed bottom rows area is not displayed.
    * :::
    *
    * Read more:
    * - [Row freezing](@/guides/rows/row-freezing/row-freezing.md)
    * - [`height`](#height)
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // freeze the bottom 3 rows
    * fixedRowsBottom: 3,
    * ```
    */
    fixedRowsBottom: 0,
    /**
    * The `fixedRowsTop` option sets the number of [frozen rows](@/guides/rows/row-freezing/row-freezing.md) at the top of the grid.
    *
    * ::: tip
    * For the top frozen rows area to be visually separated from the scrollable body, you must also set the [`height`](#height) option
    * in Handsontable's configuration. If the grid expands to fill its parent container without a defined height,
    * no vertical scrollbar is created and the fixed top rows area is not displayed.
    * :::
    *
    * Read more:
    * - [Row freezing](@/guides/rows/row-freezing/row-freezing.md)
    * - [`height`](#height)
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // freeze the top 3 rows
    * fixedRowsTop: 3,
    * ```
    */
    fixedRowsTop: 0,
    /**
    * The `formulas` option configures the [`Formulas`](@/api/formulas.md) plugin.
    *
    * The [`Formulas`](@/api/formulas.md) plugin uses the [HyperFormula](https://handsontable.github.io/hyperformula/) calculation engine.
    * To install [HyperFormula](https://handsontable.github.io/hyperformula/), read the following:
    * - [Formula calculation: Initialization methods](@/guides/formulas/formula-calculation/formula-calculation.md#initialization-methods)
    *
    * You can set the `formulas` option to an object with the following properties:
    *
    * | Property    | Possible values                                                                                                                                                                                                        |
    * | ----------- | ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `engine`    | `HyperFormula` \|<br>A [HyperFormula](https://handsontable.github.io/hyperformula/) instance \|<br>A [HyperFormula configuration](https://handsontable.github.io/hyperformula/api/interfaces/configparams.html) object |
    * | `sheetId`   | A number                                                                                                                                                                                                               |
    * | `sheetName` | A string                                                                                                                                                                                                               |
    *
    * Read more:
    * - [Plugins: `Formulas`](@/api/formulas.md)
    * - [Formula calculation](@/guides/formulas/formula-calculation/formula-calculation.md)
    * - [HyperFormula documentation: Client-side installation](https://handsontable.github.io/hyperformula/guide/client-side-installation)
    * - [HyperFormula documentation: Configuration options](https://handsontable.github.io/hyperformula/api/interfaces/configparams.html)
    *
    * @memberof Options#
    * @type {object}
    * @default undefined
    * @category Formulas
    *
    * @example
    * ```js
    * // either add the `HyperFormula` class
    * formulas: {
    *   // set `engine` to `HyperFormula`
    *   engine: HyperFormula,
    *   sheetId: 1,
    *   sheetName: 'Sheet 1'
    * }
    *
    * // or, add a HyperFormula instance
    * // initialized with the `'internal-use-in-handsontable'` license key
    * const hyperformulaInstance = HyperFormula.buildEmpty({
    *   licenseKey: 'internal-use-in-handsontable',
    * });
    *
    * formulas: {
    *   // set `engine` to a HyperFormula instance
    *   engine: hyperformulaInstance,
    *   sheetId: 1,
    *   sheetName: 'Sheet 1'
    * }
    *
    * // or, add a HyperFormula configuration object
    * formulas: {
    *   // set `engine` to a HyperFormula configuration object
    *   engine: {
    *     hyperformula: HyperFormula // or `engine: hyperformulaInstance`
    *     leapYear1900: false,       // this option comes from HyperFormula
    *     // add more HyperFormula configuration options
    *   },
    *   sheetId: 1,
    *   sheetName: 'Sheet 1'
    * }
    *
    * // use the same HyperFormula instance in multiple Handsontable instances
    *
    * // a Handsontable instance `hot1`
    * formulas: {
    *   engine: HyperFormula,
    *   sheetId: 1,
    *   sheetName: 'Sheet 1'
    * }
    *
    * // a Handsontable instance `hot2`
    * formulas: {
    *   engine: hot1.getPlugin('formulas').engine,
    *   sheetId: 1,
    *   sheetName: 'Sheet 1'
    * }
    * ```
    */
    formulas: void 0,
    /**
    * The `fragmentSelection` option configures text selection settings.
    *
    * You can set the `fragmentSelection` option to one of the following:
    *
    * | Setting           | Description                                        |
    * | ----------------- | ------------------------------------------------- |
    * | `false` (default) | Disable text selection                            |
    * | `true`            | Enable text selection in multiple cells at a time |
    * | `'cell'`          | Enable text selection in one cell at a time       |
    *
    * @memberof Options#
    * @type {boolean|string}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // enable text selection in multiple cells at a time
    * fragmentSelection: true,
    *
    * // enable text selection in one cell a time
    * fragmentSelection: 'cell',
    * ```
    */
    fragmentSelection: false,
    /**
    * The `hashLength` option sets a fixed display length for the hash mask used by the
    * [`password`](@/guides/cell-types/password-cell-type/password-cell-type.md) cell type.
    *
    * By default, the hash length equals the actual value length. Set `hashLength` to a positive
    * integer to always display that many hash symbols regardless of the real value length.
    *
    * @memberof Options#
    * @type {number}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'password',
    *     hashLength: 10,
    *   },
    * ],
    * ```
    */
    hashLength: void 0,
    /**
    * The `hashRevealDelay` option enables a brief character-reveal on each keystroke in the
    * [`password`](@/guides/cell-types/password-cell-type/password-cell-type.md) cell type editor.
    *
    * When set to a positive number (milliseconds), each typed character stays visible for that
    * duration and is then replaced by the `hashSymbol`. This lets the user confirm what they
    * typed without permanently exposing the value. Requires `type: 'password'`.
    *
    * @since 17.2.0
    * @memberof Options#
    * @type {number}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'password',
    *     hashRevealDelay: 1000,
    *   },
    * ],
    * ```
    */
    hashRevealDelay: void 0,
    /**
    * The `hashSymbol` option sets the character used as the hash mask in the
    * [`password`](@/guides/cell-types/password-cell-type/password-cell-type.md) cell type renderer.
    *
    * Defaults to `'*'`. You can use any character, HTML entity, or string.
    *
    * @memberof Options#
    * @type {string}
    * @default '*'
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'password',
    *     hashSymbol: '•',
    *   },
    * ],
    * ```
    */
    hashSymbol: "*",
    /**
    * The `headerClassName` option allows adding one or more class names to the column headers' inner `div` element.
    * It can be used to align the labels in the column headers to left, center or right by setting this option to
    * `htLeft`, `htCenter`, or `htRight` respectively.
    *
    * @since 14.5.0
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // Adding class names to all column headers
    * headerClassName: 'htRight my-class',
    *
    * columns: [
    *  {
    *    // Adding class names to the column header of a single column
    *    headerClassName: 'htRight my-class',
    *  }
    * ]
    * ```
    */
    headerClassName: void 0,
    /**
    * The `height` option configures the height of your grid.
    *
    * You can set the `height` option to one of the following:
    *
    * | Setting                                                                    | Example                    |
    * | -------------------------------------------------------------------------- | -------------------------- |
    * | A number of pixels                                                         | `height: 500`              |
    * | A string with a [CSS unit](https://www.w3schools.com/cssref/css_units.asp) | `height: '75vw'`           |
    * | `'auto'`                                                                   | `height: 'auto'`           |
    * | A function that returns a valid number or string                           | `height() { return 500; }` |
    *
    * ### How `'auto'` differs from leaving `height` unset
    *
    * When you set `height: 'auto'`, Handsontable writes `height: auto; overflow: clip;`
    * as inline styles on the root element. The grid then grows to match its content height.
    * No internal vertical scrollbar is created, so the page itself scrolls when the grid
    * exceeds the viewport.
    *
    * When you leave `height` unset, Handsontable does not touch the root element's inline
    * styles. Sizing is governed by your CSS, and the nearest ancestor with `overflow: auto`
    * or `overflow: hidden` becomes the scroll parent. If no such ancestor exists, the window
    * scrolls. See the [Grid size](@/guides/getting-started/grid-size/grid-size.md) guide for
    * details.
    *
    * ::: tip
    * With `height: 'auto'`, every row is laid out in the DOM at once. Row-level
    * virtualization is effectively disabled. Avoid `'auto'` for large datasets and set a
    * numeric `height` instead, so Handsontable can virtualize off-screen rows.
    * :::
    *
    * Read more:
    * - [Grid size](@/guides/getting-started/grid-size/grid-size.md)
    *
    * @memberof Options#
    * @type {number|'auto'|string|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set the grid's height to 500px
    * height: 500,
    *
    * // set the grid's height to 75vh
    * height: '75vh',
    *
    * // let the grid grow to fit all its rows (no internal vertical scroll)
    * height: 'auto',
    *
    * // set the grid's height to 500px, using a function
    * height() {
    *   return 500;
    * },
    * ```
    */
    height: void 0,
    /**
    * The `hiddenColumns` option configures the [`HiddenColumns`](@/api/hiddenColumns.md) plugin.
    *
    * You can set the `hiddenColumns` option to one of the following:
    *
    * | Setting   | Description                                                                                  |
    * | --------- | -------------------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`HiddenColumns`](@/api/hiddenColumns.md) plugin                                 |
    * | `true`    | Enable the [`HiddenColumns`](@/api/hiddenColumns.md) plugin with the default plugin options  |
    * | An object | - Enable the [`HiddenColumns`](@/api/hiddenColumns.md) plugin<br>- Modify the plugin options |
    *
    * If you set the `hiddenColumns` to an object, you can set the following [`HiddenColumns`](@/api/hiddenColumns.md) plugin options:
    *
    * | Property           | Possible values     | Description                                                                                                                                             |
    * | ------------------ | ------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `columns`          | An array of indexes | An array of indexes of columns that are hidden at initialization                                                                                        |
    * | `copyPasteEnabled` | `true` \| `false`   | `true`: when copying or pasting data, take hidden columns into account<br>`false`: when copying or pasting data, don't take hidden columns into account |
    * | `indicators`       | `true` \| `false`   | `true`: display UI markers to indicate the presence of hidden columns<br>`false`: display UI markers                                                    |
    *
    * Read more:
    * - [Plugins: `HiddenColumns`](@/api/hiddenColumns.md)
    * - [Column hiding](@/guides/columns/column-hiding/column-hiding.md)
    *
    * @memberof Options#
    * @type {boolean|object}
    * @default undefined
    * @category HiddenColumns
    *
    * @example
    * ```js
    * // enable the `HiddenColumns` plugin
    * hiddenColumns: true,
    *
    * // enable `HiddenColumns` plugin, and modify the plugin options
    * hiddenColumns: {
    *   // set columns that are hidden by default
    *   columns: [5, 10, 15],
    *   // when copying or pasting data, take hidden columns into account
    *   copyPasteEnabled: true,
    *   // show where hidden columns are
    *   indicators: true
    * }
    * ```
    */
    hiddenColumns: void 0,
    /**
    * The `hiddenRows` option configures the [`HiddenRows`](@/api/hiddenRows.md) plugin.
    *
    * You can set the `hiddenRows` option to one of the following:
    *
    * | Setting   | Description                                                                            |
    * | --------- | -------------------------------------------------------------------------------------- |
    * | `false`   | Disable the [`HiddenRows`](@/api/hiddenRows.md) plugin                                 |
    * | `true`    | Enable the [`HiddenRows`](@/api/hiddenRows.md) plugin with the default plugin options  |
    * | An object | - Enable the [`HiddenRows`](@/api/hiddenRows.md) plugin<br>- Modify the plugin options |
    *
    * If you set the `hiddenRows` to an object, you can set the following [`HiddenRows`](@/api/hiddenRows.md) plugin options:
    *
    * | Property           | Possible values     | Description                                                                                                                                       |
    * | ------------------ | ------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `rows   `          | An array of indexes | An array of indexes of rows that are hidden at initialization                                                                                     |
    * | `copyPasteEnabled` | `true` \| `false`   | `true`: when copying or pasting data, take hidden rows into account<br>`false`: when copying or pasting data, don't take hidden rows into account |
    * | `indicators`       | `true` \| `false`   | `true`: display UI markers to indicate the presence of hidden rows<br>`false`: display UI markers                                                 |
    *
    * Read more:
    * - [Plugins: `HiddenRows`](@/api/hiddenRows.md)
    * - [Row hiding](@/guides/rows/row-hiding/row-hiding.md)
    *
    * @memberof Options#
    * @type {boolean|object}
    * @default undefined
    * @category HiddenRows
    *
    * @example
    * ```js
    * // enable the `HiddenRows` plugin
    * hiddenRows: true,
    *
    * // enable `HiddenRows` plugin, and modify the plugin options
    * hiddenRows: {
    *   // set rows that are hidden by default
    *   rows: [5, 10, 15],
    *   // when copying or pasting data, take hidden rows into account
    *   copyPasteEnabled: true,
    *   // show where hidden rows are
    *   indicators: true
    * }
    * ```
    */
    hiddenRows: void 0,
    /**
    * The `initialState` option configures the grid's initial state.
    * This object accepts any grid configuration option. In case of conflicts between
    * `initialState` and table settings, the table settings take precedence.
    * Note: The `initialState` option is ignored when passed to the
    * [`updateSettings()`](@/api/core.md#updatesettings) method.
    *
    * @since 16.1.0
    * @memberof Options#
    * @type {object | undefined}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * initialState: {
    *   // configure initial column order
    *   manualColumnMove: [1, 0],
    * },
    * ```
    */
    initialState: void 0,
    /**
    * The `invalidCellClassName` option lets you add a CSS class name to cells
    * that were marked as `invalid` by the [cell validator](@/guides/cell-functions/cell-validator/cell-validator.md).
    *
    * Read more:
    * - [Cell validator](@/guides/cell-functions/cell-validator/cell-validator.md)
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default 'htInvalid'
    * @category Core
    *
    * @example
    * ```js
    * // add a `highlight-error` CSS class name
    * // to every `invalid` cell`
    * invalidCellClassName: 'highlight-error',
    * ```
    */
    invalidCellClassName: "htInvalid",
    /**
    * The `imeFastEdit` option allows using the "fast edit" feature for the IME users. It's disabled by default
    * because of its incompatibility with some of the accessibility features.
    *
    * Enabling this option can make a negative impact on how some screen readers handle reading the table cells.
    *
    * @since 14.0.0
    * @memberof Options#
    * @type {boolean}
    * @category Core
    */
    imeFastEdit: false,
    /**
    * The `isEmptyCol` option lets you define your own custom method
    * for checking if a column at a given visual index is empty.
    *
    * The `isEmptyCol` setting overwrites the built-in [`isEmptyCol`](@/api/core.md#isEmptyCol) method.
    * The function receives a visual column index and must return a `boolean`.
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * @memberof Options#
    * @type {Function}
    * @param {number} col Visual column index.
    * @returns {boolean}
    * @category Core
    *
    * @example
    * ```js
    * // overwrite the built-in `isEmptyCol` method
    * isEmptyCol(visualColumnIndex) {
    *    // your custom method
    *    ...
    * },
    * ```
    */
    isEmptyCol(col) {
      let row;
      let value;
      const hasExplicitSchema = !!this.getSettings().dataSchema;
      const schema = this.getSchema();
      const prop = this.colToProp(col);
      const rowLen = this.countRows();
      for (row = 0; row < rowLen; row++) {
        value = this.getDataAtCell(row, col);
        if (isEmpty$1(value) === false) {
          if (typeof value === "object") {
            if (isObjectEqual(schema[prop], value) === false) {
              return false;
            }
            continue;
          }
          if (hasExplicitSchema && schema[prop] === value) {
            continue;
          }
          return false;
        }
      }
      return true;
    },
    /**
    * The `isEmptyRow` option lets you define your own custom method
    * for checking if a row at a given visual index is empty.
    *
    * The `isEmptyRow` setting overwrites the built-in [`isEmptyRow`](@/api/core.md#isEmptyRow) method.
    * The function receives a visual row index and must return a `boolean`.
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * @memberof Options#
    * @type {Function}
    * @param {number} row Visual row index.
    * @returns {boolean}
    * @category Core
    *
    * @example
    * ```js
    * // overwrite the built-in `isEmptyRow` method
    * isEmptyRow(visualRowIndex) {
    *    // your custom method
    *    ...
    * },
    * ```
    */
    isEmptyRow(row) {
      let col;
      let value;
      const hasExplicitSchema = !!this.getSettings().dataSchema;
      const schema = this.getSchema();
      const colLen = this.countCols();
      for (col = 0; col < colLen; col++) {
        value = this.getDataAtCell(row, col);
        if (isEmpty$1(value) === false) {
          const prop = this.colToProp(col);
          if (typeof value === "object") {
            if (isObjectEqual(schema[prop], value) === false) {
              return false;
            }
            continue;
          }
          if (hasExplicitSchema && schema[prop] === value) {
            continue;
          }
          return false;
        }
      }
      return true;
    },
    /**
    * @description
    * The `label` option configures [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cells` labels.
    *
    * You can set the `label` option to an object with the following properties:
    *
    * | Property    | Possible values                   | Description                                                                                                                                                                                                             |
    * | ----------- | --------------------------------- | ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `position`  | `'after'` (default) \| `'before'` | `'after'`: place the label to the right of the checkbox<br>`'before'`: place the label to the left of the checkbox                                                                                                      |
    * | `value`     | A string \| A function            | The label's text                                                                                                                                                                                                        |
    * | `separated` | `false` (default) \| `true`       | `false`: don't separate the label from the checkbox<br>`true`: separate the label from the checkbox                                                                                                                     |
    * | `property`  | A string                          | - A [`data`](#data) object property name that's used as the label's text <br>- Works only when the [`data`](#data) option is set to an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects) |
    *
    * Read more:
    * - [Checkbox cell type: Checkbox labels](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md#checkbox-labels)
    *
    * @memberof Options#
    * @type {object}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [{
    *   type: 'checkbox',
    *   // add 'My label:' after the checkbox
    *   label: { position: 'before', value: 'My label: ', separated: true }
    * }],
    * ```
    */
    label: void 0,
    /**
    * The `language` option configures Handsontable's [language](@/guides/internationalization/language/language.md) settings.
    *
    * This option controls the language used for all built-in UI strings, including context menu labels,
    * column sorting labels, validation messages, and other user-visible text. It does not affect the locale
    * used for number or date formatting - use the [`locale`](#locale) option for that.
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * You can set the `language` option to one of the following:
    *
    * | Setting             | Description                 |
    * | ------------------- | --------------------------- |
    * | `'en-US'` (default) | English - United States     |
    * | `'ar-AR'`           | Arabic - Global<br><br>To properly render this language, set the [layout direction](@/guides/internationalization/layout-direction/layout-direction.md) to RTL. |
    * | `'cs-CZ'`           | Czech - Czech Republic      |
    * | `'de-CH'`           | German - Switzerland        |
    * | `'de-DE'`           | German - Germany            |
    * | `'es-MX'`           | Spanish - Mexico            |
    * | `'fa-IR'`           | Persian - Iran              |
    * | `'fr-FR'`           | French - France             |
    * | `'hr-HR'`           | Croatian - Croatia          |
    * | `'it-IT'`           | Italian - Italy             |
    * | `'ja-JP'`           | Japanese - Japan            |
    * | `'ko-KR'`           | Korean - Korea              |
    * | `'lv-LV'`           | Latvian - Latvia            |
    * | `'nb-NO'`           | Norwegian (Bokmål) - Norway |
    * | `'nl-NL'`           | Dutch - Netherlands         |
    * | `'pl-PL'`           | Polish - Poland             |
    * | `'pt-BR'`           | Portuguese - Brazil         |
    * | `'ru-RU'`           | Russian - Russia            |
    * | `'sr-SP'`           | Serbian (Latin) - Serbia    |
    * | `'zh-CN'`           | Chinese - China             |
    * | `'zh-TW'`           | Chinese - Taiwan            |
    *
    * Read more:
    * - [Language](@/guides/internationalization/language/language.md)
    * - [`locale`](#locale)
    * - [`layoutDirection`](#layoutdirection)
    *
    * @memberof Options#
    * @type {string}
    * @default 'en-US'
    * @category Core
    *
    * @example
    * ```js
    * // set Handsontable's language to Polish
    * language: 'pl-PL',
    * ```
    */
    language: "en-US",
    /**
    * The `layoutDirection` option configures whether Handsontable renders from the left to the right, or from the right to the left.
    *
    * You can set the layout direction only at Handsontable's [initialization](@/guides/getting-started/installation/installation.md#initialize-handsontable). Any change of the `layoutDirection` option after the initialization (e.g. using the [`updateSettings()`](@/api/core.md#updatesettings) method) is ignored.
    *
    * You can set the `layoutDirection` option only [for the entire grid](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * You can't set it for individual columns, rows, or cells.
    *
    * You can set the `layoutDirection` option to one of the following strings:
    *
    * | Setting             | Description                                                                                                                                                                                  |
    * | ------------------- | -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `inherit` (default) | Set Handsontable's layout direction automatically,<br>based on the value of your HTML document's [`dir`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir) attribute  |
    * | `rtl`               | Render Handsontable from the right to the left,<br>even when your HTML document's [`dir`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir) attribute is set to `ltr` |
    * | `ltr`               | Render Handsontable from the left to the right,<br>even when your HTML document's [`dir`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir) attribute is set to `rtl` |
    *
    * Read more:
    * - [Layout direction](@/guides/internationalization/layout-direction/layout-direction.md)
    * - [Language](@/guides/internationalization/language/language.md)
    * - [`language`](#language)
    * - [`locale`](#locale)
    * - [`fixedColumnsStart`](#fixedcolumnsstart)
    * - [`customBorders`](#customBorders)
    *
    * @memberof Options#
    * @type {string}
    * @default 'inherit'
    * @category Core
    *
    * @example
    * ```js
    * // inherit Handsontable's layout direction
    * // from the value of your HTML document's `dir` attribute
    * layoutDirection: 'inherit',
    *
    * // render Handsontable from the right to the left
    * // regardless of your HTML document's `dir`
    * layoutDirection: 'rtl',
    *
    * // render Handsontable from the left to the right
    * // regardless of your HTML document's `dir`
    * layoutDirection: 'ltr',
    * ```
    */
    layoutDirection: "inherit",
    /**
    * The `layout` option configures the order of plugin UI elements within the user-orderable
    * wrapper slots rendered around the grid: `top` and `bottom`. Each slot takes an ordered array
    * of element keys (for example `'pagination'`). Keys you list are placed first in that order;
    * any remaining elements follow by their default weight. The grid and the overlays layer (the
    * modal layer, such as the dialog) are not orderable through this option. The license
    * notification is not orderable either; it always renders last in the `bottom` slot.
    *
    * @since 18.0.0
    * @memberof Options#
    * @type {object}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // render pagination above a custom 'summary' element registered in the bottom slot
    * layout: {
    *   bottom: ['pagination', 'summary'],
    * },
    * ```
    */
    layout: void 0,
    /**
    * The `licenseKey` option sets your Handsontable license key.
    *
    * You can set the `licenseKey` option to one of the following:
    *
    * | Setting                                                                                                 | Description                                                                                       |
    * | ------------------------------------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------- |
    * | A string with your [commercial license key](@/guides/getting-started/license-key/license-key.md#commercial-license) | For [commercial use](@/guides/technical-specification/software-license/software-license.md#commercial-use)         |
    * | `'non-commercial-and-evaluation'`                                                                       | For [non-commercial use](@/guides/technical-specification/software-license/software-license.md#non-commercial-use) |
    *
    * Read more:
    * - [License key](@/guides/getting-started/license-key/license-key.md)
    *
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // for commercial use
    * licenseKey: 'xxxxx-xxxxx-xxxxx-xxxxx-xxxxx', // your commercial license key
    *
    * // for non-commercial use
    * licenseKey: 'non-commercial-and-evaluation',
    * ```
    */
    licenseKey: void 0,
    /**
    * The `locale` option configures Handsontable's [locale](@/guides/internationalization/locale/locale.md) settings.
    *
    * You can set the `locale` option to any valid and canonicalized Unicode BCP 47 locale tag,
    * both for the [entire grid](@/guides/internationalization/locale/locale.md#set-the-grid-s-locale),
    * and for [individual columns](@/guides/internationalization/locale/locale.md#set-a-column-s-locale).
    *
    * Read more:
    * - [Locale](@/guides/internationalization/locale/locale.md)
    * - [`language`](#language)
    * - [`layoutDirection`](#layoutdirection)
    *
    * @memberof Options#
    * @type {string}
    * @default 'en-US'
    * @category Core
    *
    * @example
    * ```js
    * // set the entire grid's locale to Polish
    * locale: 'pl-PL',
    *
    * // set individual columns' locales
    * columns: [
    *   {
    *     // set the first column's locale to Polish
    *     locale: 'pl-PL',
    *   },
    *   {
    *     // set the second column's locale to German
    *     locale: 'de-DE',
    *   },
    * ],
    * ```
    */
    locale: "en-US",
    /**
    * @description
    * The `loading` option configures the [`Loading`](@/api/loading.md) plugin.
    *
    * Loading plugin, automatically loads [`Dialog`](@/api/dialog.md) plugin.
    *
    * You can set the `loading` option to one of the following:
    *
    * | Setting   | Description                                                                 |
    * | --------- | --------------------------------------------------------------------------- |
    * | `false`   | Disable the [`Loading`](@/api/loading.md) plugin                           |
    * | `true`    | Enable the [`Loading`](@/api/loading.md) plugin with default configuration |
    * | An object | - Enable the [`Loading`](@/api/loading.md) plugin<br>- Apply custom configuration |
    *
    * If you set the `loading` option to an object, you can configure the following loading options:
    *
    * | Option        | Possible settings | Description                                               |
    * | ------------- | ----------------- | --------------------------------------------------------- |
    * | `icon`        | A string          | Custom loading icon to display (default: `<svg />`)       |
    * | `title`       | A string          | Custom loading title to display (default: `'Loading...'`) |
    * | `description` | A string          | Custom loading description to display (default: `''`)     |
    *
    * Read more:
    * - [Plugins: `Loading`](@/api/loading.md)
    * @since 16.1.0
    * @memberof Options#
    * @type {boolean|object}
    * @default false
    * @category Loading
    *
    * @example
    * ```js
    * // enable the `Loading` plugin with default configuration
    * loading: true,
    *
    * // enable the `Loading` plugin with custom configuration
    * loading: {
    *   icon: 'A custom loading icon in SVG format',
    *   title: 'Custom loading title',
    *   description: 'Custom loading description',
    * }
    * ```
    */
    loading: false,
    /**
    * @description
    * The `notification` option configures the [`Notification`](@/api/notification.md) plugin.
    *
    * You can set the `notification` option to one of the following:
    *
    * | Setting   | Description                                                                 |
    * | --------- | --------------------------------------------------------------------------- |
    * | `false`   | Disable the [`Notification`](@/api/notification.md) plugin                |
    * | `true`    | Enable the plugin with default options                                      |
    * | An object | Enable the plugin and set `stackLimit` and `animation`                      |
    *
    * ##### notification: Additional options
    *
    * | Option        | Type      | Default | Description |
    * | ------------- | --------- | ------- | ----------- |
    * | `stackLimit`  | `number`  | `10`    | Maximum visible toasts per corner. Extra requests are queued. |
    * | `animation`   | `boolean` | `true`  | Fade and slide animation when toasts appear. |
    *
    * Read more:
    * - [Plugins: `Notification`](@/api/notification.md)
    *
    * @since 17.1.0
    * @memberof Options#
    * @type {boolean|object}
    * @default false
    * @category Notification
    *
    * @example
    * ```js
    * notification: true,
    * ```
    */
    notification: false,
    /**
    * The `manualColumnFreeze` option configures the [`ManualColumnFreeze`](@/api/manualColumnFreeze.md) plugin.
    *
    * You can set the `manualColumnFreeze` option to one of the following:
    *
    * | Setting  | Description                                                            |
    * | -------- | ---------------------------------------------------------------------- |
    * | `true`   | Enable the [`ManualColumnFreeze`](@/api/manualColumnFreeze.md) plugin  |
    * | `false`  | Disable the [`ManualColumnFreeze`](@/api/manualColumnFreeze.md) plugin |
    *
    * Read more:
    * - [Column freezing](@/guides/columns/column-freezing/column-freezing.md#user-triggered-freeze)
    *
    * @memberof Options#
    * @type {boolean}
    * @default undefined
    * @category ManualColumnFreeze
    *
    * @example
    * ```js
    * // enable the `ManualColumnFreeze` plugin
    * manualColumnFreeze: true,
    * ```
    */
    manualColumnFreeze: void 0,
    /**
    * The `manualColumnMove` option configures the [`ManualColumnMove`](@/api/manualColumnMove.md) plugin.
    *
    * You can set the `manualColumnMove` option to one of the following:
    *
    * | Setting  | Description                                                                                                        |
    * | -------- | ------------------------------------------------------------------------------------------------------------------ |
    * | `true`   | Enable the [`ManualColumnMove`](@/api/manualColumnMove.md) plugin                                                  |
    * | `false`  | Disable the [`ManualColumnMove`](@/api/manualColumnMove.md) plugin                                                 |
    * | An array | - Enable the [`ManualColumnMove`](@/api/manualColumnMove.md) plugin<br>- Move individual columns at initialization |
    *
    * Read more:
    * - [Column moving](@/guides/columns/column-moving/column-moving.md)
    *
    * @memberof Options#
    * @type {boolean|number[]}
    * @default undefined
    * @category ManualColumnMove
    *
    * @example
    * ```js
    * // enable the `ManualColumnMove` plugin
    * manualColumnMove: true,
    *
    * // enable the `ManualColumnMove` plugin
    * // at initialization, move column 0 to 1
    * // at initialization, move column 1 to 4
    * // at initialization, move column 2 to 6
    * manualColumnMove: [1, 4, 6],
    * ```
    */
    manualColumnMove: void 0,
    /**
    * @description
    * The `manualColumnResize` option configures the [`ManualColumnResize`](@/api/manualColumnResize.md) plugin.
    *
    * You can set the `manualColumnResize` option to one of the following:
    *
    * | Setting  | Description                                                                                                           |
    * | -------- | --------------------------------------------------------------------------------------------------------------------- |
    * | `true`   | Enable the [`ManualColumnResize`](@/api/manualColumnResize.md) plugin                                                 |
    * | `false`  | Disable the [`ManualColumnResize`](@/api/manualColumnResize.md) plugin                                                |
    * | An array | - Enable the [`ManualColumnResize`](@/api/manualColumnResize.md) plugin<br>- Set initial widths of individual columns |
    *
    * Read more:
    * - [Column width: Column stretching](@/guides/columns/column-width/column-width.md#column-stretching)
    *
    * @memberof Options#
    * @type {boolean|number[]}
    * @default undefined
    * @category ManualColumnResize
    *
    * @example
    * ```js
    * // enable the `manualColumnResize` plugin
    * manualColumnResize: true,
    *
    * // enable the `manualColumnResize` plugin
    * // set the initial width of column 0 to 40 pixels
    * // set the initial width of column 1 to 50 pixels
    * // set the initial width of column 2 to 60 pixels
    * manualColumnResize: [40, 50, 60],
    * ```
    */
    manualColumnResize: void 0,
    /**
    * @description
    * The `manualRowMove` option configures the [`ManualRowMove`](@/api/manualRowMove.md) plugin.
    *
    * You can set the `manualRowMove` option to one of the following:
    *
    * | Setting  | Description                                                                                               |
    * | -------- | --------------------------------------------------------------------------------------------------------- |
    * | `true`   | Enable the [`ManualRowMove`](@/api/manualRowMove.md) plugin                                               |
    * | `false`  | Disable the [`ManualRowMove`](@/api/manualRowMove.md) plugin                                              |
    * | An array | - Enable the [`ManualRowMove`](@/api/manualRowMove.md) plugin<br>- Move individual rows at initialization |
    *
    * Read more:
    * - [Row moving](@/guides/rows/row-moving/row-moving.md)
    *
    * @memberof Options#
    * @type {boolean|number[]}
    * @default undefined
    * @category ManualRowMove
    *
    * @example
    * ```js
    * // enable the `ManualRowMove` plugin
    * manualRowMove: true,
    *
    * // enable the `ManualRowMove` plugin
    * // at initialization, move row 1 to 0
    * // at initialization, move row 4 to 1
    * // at initialization, move row 6 to 2
    * manualRowMove: [1, 4, 6],
    * ```
    */
    manualRowMove: void 0,
    /**
    * @description
    * The `manualRowResize` option configures the [`ManualRowResize`](@/api/manualRowResize.md) plugin.
    *
    * You can set the `manualRowResize` option to one of the following:
    *
    * | Setting  | Description                                                                                                   |
    * | -------- | ------------------------------------------------------------------------------------------------------------- |
    * | `true`   | Enable the [`ManualRowResize`](@/api/manualRowResize.md) plugin                                               |
    * | `false`  | Disable the [`ManualRowResize`](@/api/manualRowResize.md) plugin                                              |
    * | An array | - Enable the [`ManualRowResize`](@/api/manualRowResize.md) plugin<br>- Set initial heights of individual rows |
    *
    * Read more:
    * - [Row height: Adjust the row height manually](@/guides/rows/row-height/row-height.md#adjust-the-row-height-manually)
    *
    * @memberof Options#
    * @type {boolean|number[]}
    * @default undefined
    * @category ManualRowResize
    *
    * @example
    * ```js
    * // enable the `ManualRowResize` plugin
    * manualRowResize: true,
    *
    * // enable the `ManualRowResize` plugin
    * // set the initial height of row 0 to 40 pixels
    * // set the initial height of row 1 to 50 pixels
    * // set the initial height of row 2 to 60 pixels
    * manualRowResize: [40, 50, 60],
    * ```
    */
    manualRowResize: void 0,
    /**
    * The `maxCols` option sets a maximum number of columns.
    *
    * The `maxCols` option is used:
    * - At initialization: if the `maxCols` value is lower than the initial number of columns,
    * Handsontable trims columns from the right.
    * - At runtime: for example, when inserting columns.
    *
    * @memberof Options#
    * @type {number}
    * @default Infinity
    * @category Core
    *
    * @example
    * ```js
    * // set the maximum number of columns to 300
    * maxCols: 300,
    * ```
    */
    maxCols: Infinity,
    /**
    * The `maxRows` option sets a maximum number of rows.
    *
    * The `maxRows` option is used:
    * - At initialization: if the `maxRows` value is lower than the initial number of rows,
    * Handsontable trims rows from the bottom.
    * - At runtime: for example, when inserting rows.
    *
    * @memberof Options#
    * @type {number}
    * @default Infinity
    * @category Core
    *
    * @example
    * ```js
    * // set the maximum number of rows to 300
    * maxRows: 300,
    * ```
    */
    maxRows: Infinity,
    /**
    * The `maxSelections` option sets a maximum number of selections for the [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md)-typed cells.
    *
    * @since 17.0.0
    * @memberof Options#
    * @type {number}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [{
    *   // set the `type` of each cell in this column to `multiSelect`
    *   type: 'multiselect',
    *   // set the maximum number of selections to 3
    *   maxSelections: 3,
    * }],
    * ```
    */
    maxSelections: void 0,
    /**
    * @description
    * The `mergeCells` option configures the [`MergeCells`](@/api/mergeCells.md) plugin.
    *
    * You can set the `mergeCells` option to one of the following:
    *
    * | Setting               | Description                                                                                         |
    * | --------------------- | --------------------------------------------------------------------------------------------------- |
    * | `true`                | Enable the [`MergeCells`](@/api/mergeCells.md) plugin                                               |
    * | `false`               | Disable the [`MergeCells`](@/api/mergeCells.md) plugin                                              |
    * | An array of objects   | - Enable the [`MergeCells`](@/api/mergeCells.md) plugin<br>- Merge specific cells at initialization |
    * | { virtualized: true } | Enable the [`MergeCells`](@/api/mergeCells.md) plugin with enabled virtualization mode              |
    *
    *
    * To merge specific cells at Handsontable's initialization,
    * set the `mergeCells` option to an array of objects, with the following properties:
    *
    * | Property  | Description                                                |
    * | --------- | ---------------------------------------------------------- |
    * | `row`     | The row index of the merged section's beginning            |
    * | `col`     | The column index of the merged section's beginning         |
    * | `rowspan` | The width (as a number of rows) of the merged section      |
    * | `colspan` | The height (as a number of columns ) of the merged section |
    *
    * This option can only be set at the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options).
    * It has no effect when set in the [`columns`](#columns), [`cells`](#cells), or [`cell`](#cell) options.
    *
    * Read more:
    * - [Merge cells](@/guides/cell-features/merge-cells/merge-cells.md)
    *
    * @memberof Options#
    * @type {boolean|object[]}
    * @default false
    * @category MergeCells
    *
    * @example
    * ```js
    * // enable the `MergeCells` plugin
    * mergeCells: true,
    *
    * // enable the `MergeCells` plugin
    * // and merge specific cells at initialization
    * mergeCells: [
    *   // merge cells from cell (1,1) to cell (3,3)
    *   {row: 1, col: 1, rowspan: 3, colspan: 3},
    *   // merge cells from cell (3,4) to cell (2,2)
    *   {row: 3, col: 4, rowspan: 2, colspan: 2},
    *   // merge cells from cell (5,6) to cell (3,3)
    *   {row: 5, col: 6, rowspan: 3, colspan: 3}
    * ],
    *
    * // enable the `MergeCells` plugin with enabled virtualization mode
    * // and merge specific cells at initialization
    * mergeCells: {
    *   virtualized: true,
    *   cells: [
    *     // merge cells from cell (1,1) to cell (3,3)
    *     {row: 1, col: 1, rowspan: 3, colspan: 3},
    *     // merge cells from cell (3,4) to cell (2,2)
    *     {row: 3, col: 4, rowspan: 2, colspan: 2},
    *     // merge cells from cell (5,6) to cell (3,3)
    *     {row: 5, col: 6, rowspan: 3, colspan: 3}
    *   ],
    * },
    * ```
    */
    mergeCells: false,
    /**
    * The `minCols` option sets a minimum number of columns.
    *
    * The `minCols` option is used:
    * - At initialization: if the `minCols` value is higher than the initial number of columns,
    * Handsontable adds empty columns to the right.
    * - At runtime: for example, when removing columns.
    *
    * The `minCols` option works only when your [`data`](#data) is an [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays).
    * When your [`data`](#data) is an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects),
    * you can only have as many columns as defined in:
    * - The first data row
    * - The [`dataSchema`](#dataSchema) option
    * - The [`columns`](#columns) option
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // set the minimum number of columns to 10
    * minCols: 10,
    * ```
    */
    minCols: 0,
    /**
    * Alias for the [`rowHeights`](#rowHeights) option.
    *
    * See the [`rowHeights`](#rowHeights) option description for more information.
    *
    * @since 16.2.0
    * @memberof Options#
    * @type {number|number[]|string|string[]|Array<undefined>|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set every row's minimum height to 100px
    * minRowHeights: 100,
    *
    * // set every row's minimum height to 100px
    * minRowHeights: '100px',
    *
    * // set the first (by visual index) row's minimum height to 100
    * // set the second (by visual index) row's minimum height to 120
    * // set any other row's minimum height to the default height value
    * minRowHeights: [100, 120],
    *
    * // set each row's minimum height individually, using a function
    * minRowHeights(visualRowIndex) {
    *   return visualRowIndex * 10;
    * },
    * ```
    */
    minRowHeights: void 0,
    /**
    * The `minRows` option sets a minimum number of rows.
    *
    * The `minRows` option is used:
    * - At initialization: if the `minRows` value is higher than the initial number of rows,
    * Handsontable adds empty rows at the bottom.
    * - At runtime: for example, when removing rows.
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // set the minimum number of rows to 10
    * minRows: 10,
    * ```
    */
    minRows: 0,
    /**
    * The `minSpareCols` option sets a minimum number of empty columns
    * at the grid's right-hand end.
    *
    * If there already are other empty columns at the grid's right-hand end,
    * they are counted into the `minSpareCols` value.
    *
    * The total number of columns can't exceed the [`maxCols`](#maxCols) value.
    *
    * The `minSpareCols` option works only when your [`data`](#data) is an [array of arrays](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-arrays).
    * When your [`data`](#data) is an [array of objects](@/guides/getting-started/binding-to-data/binding-to-data.md#array-of-objects),
    * you can only have as many columns as defined in:
    * - The first data row
    * - The [`dataSchema`](#dataSchema) option
    * - The [`columns`](#columns) option
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // at Handsontable's initialization, add at least 3 empty columns on the right
    * minSpareCols: 3,
    * ```
    */
    minSpareCols: 0,
    /**
    * The `minSpareRows` option sets a minimum number of empty rows
    * at the bottom of the grid.
    *
    * If there already are other empty rows at the bottom,
    * they are counted into the `minSpareRows` value.
    *
    * The total number of rows can't exceed the [`maxRows`](#maxRows) value.
    *
    * @memberof Options#
    * @type {number}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // at Handsontable's initialization, add at least 3 empty rows at the bottom
    * minSpareRows: 3,
    * ```
    */
    minSpareRows: 0,
    /**
    * @description
    * The `multiColumnSorting` option configures the [`MultiColumnSorting`](@/api/multiColumnSorting.md) plugin.
    *
    * You can set the `multiColumnSorting` option to one of the following:
    *
    * | Setting    | Description                                                                                                                                                |
    * | ---------- | ---------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `true`     | Enable the [`MultiColumnSorting`](@/api/multiColumnSorting.md) plugin with the default configuration                                                       |
    * | `false`    | Disable the [`MultiColumnSorting`](@/api/multiColumnSorting.md) plugin                                                                                     |
    * | An object  | - Enable the [`MultiColumnSorting`](@/api/multiColumnSorting.md) plugin<br>- Modify the [`MultiColumnSorting`](@/api/multiColumnSorting.md) plugin options |
    *
    * If you set the `multiColumnSorting` option to an object,
    * you can set the following [`MultiColumnSorting`](@/api/multiColumnSorting.md) plugin options:
    *
    * | Option                   | Possible settings                                                                                                                                |
    * | ------------------------ | ------------------------------------------------------------------------------------------------------------------------------------------------ |
    * | `indicator`              | `true`: Display the arrow icon in the column header, to indicate a sortable column<br>`false`: Don't display the arrow icon in the column header |
    * | `headerAction`           | `true`: Enable clicking on the column header to sort the column<br>`false`: Disable clicking on the column header to sort the column             |
    * | `sortEmptyCells`         | `true`: Sort empty cells as well<br>`false`: Place empty cells at the end                                                                        |
    * | `compareFunctionFactory` | A [custom compare function](@/guides/rows/rows-sorting/rows-sorting.md#add-a-custom-comparator)                                                               |
    *
    * If you set the `multiColumnSorting` option to an object,
    * you can also sort individual columns at Handsontable's initialization.
    * In the `multiColumnSorting` object, add an object named `initialConfig`,
    * with the following properties:
    *
    * | Option      | Possible settings   | Description                                                      |
    * | ----------- | ------------------- | ---------------------------------------------------------------- |
    * | `column`    | A number            | The index of the column that you want to sort at initialization  |
    * | `sortOrder` | `'asc'` \| `'desc'` | The sorting order:<br>`'asc'`: ascending<br>`'desc'`: descending |
    *
    * Read more:
    * - [Rows sorting](@/guides/rows/rows-sorting/rows-sorting.md)
    * - [`columnSorting`](#columnSorting)
    *
    * @memberof Options#
    * @type {boolean|object}
    * @default undefined
    * @category MultiColumnSorting
    *
    * @example
    * ```js
    * // enable the `MultiColumnSorting` plugin
    * multiColumnSorting: true
    *
    * // enable the `MultiColumnSorting` plugin with custom configuration
    * multiColumnSorting: {
    *   // sort empty cells as well
    *   sortEmptyCells: true,
    *   // display the arrow icon in the column header
    *   indicator: true,
    *   // disable clicking on the column header to sort the column
    *   headerAction: false,
    *   // add a custom compare function
    *   compareFunctionFactory(sortOrder, columnMeta) {
    *     return function(value, nextValue) {
    *       // some value comparisons which will return -1, 0 or 1...
    *     }
    *   }
    * }
    *
    * // enable the `MultiColumnSorting` plugin with a multi-column initial sort order:
    * // sort column 1 ascending first, then column 2 descending
    * multiColumnSorting: {
    *   initialConfig: [
    *     { column: 1, sortOrder: 'asc' },
    *     { column: 2, sortOrder: 'desc' }
    *   ]
    * }
    * ```
    */
    multiColumnSorting: void 0,
    /**
    * When set to `true`, the `navigableHeaders` option lets you navigate [row headers](@/guides/rows/row-header/row-header.md) and [column headers](@/guides/columns/column-header/column-header.md), using the arrow keys or the <kbd>**Tab**</kbd> key (if the [`tabNavigation`](#tabNavigation) option is set to `true`).
    *
    * @since 14.0.0
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // you can navigate row and column headers with the keyboard
    * navigableHeaders: true,
    *
    * // default behavior: you can't navigate row and column headers with the keyboard
    * navigableHeaders: false,
    * ```
    */
    navigableHeaders: false,
    /**
    * When set to `false`, the `tabNavigation` option changes the behavior of the
    * <kbd>Tab</kbd> and <kbd>Shift</kbd>+<kbd>Tab</kbd> keyboard shortcuts. The Handsontable
    * no more captures that shortcuts to make the grid navigation available (`tabNavigation: true`)
    * but returns control to the browser so the native page navigation is possible.
    *
    * @since 14.0.0
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // you can't navigate row and column headers using <kbd>Tab</kbd> or <kbd>Shift</kbd>+<kbd>Tab</kbd> keyboard shortcuts
    * tabNavigation: false,
    *
    * // default behavior: you can navigate row and column headers using <kbd>Tab</kbd> or <kbd>Shift</kbd>+<kbd>Tab</kbd> keyboard shortcuts
    * tabNavigation: true,
    * ```
    */
    tabNavigation: true,
    /**
    * @description
    * The `nestedHeaders` option configures the [`NestedHeaders`](@/api/nestedHeaders.md) plugin.
    *
    * You can set the `nestedHeaders` option to one of the following:
    *
    * | Setting           | Description                                                                                                                           |
    * | ----------------- | ------------------------------------------------------------------------------------------------------------------------------------- |
    * | `false` (default) | Disable the [`NestedHeaders`](@/api/nestedHeaders.md) plugin                                                                          |
    * | `true`            | - Enable the [`NestedHeaders`](@/api/nestedHeaders.md) plugin<br>- Don't configure any nested headers                                 |
    * | Array of arrays   | - Enable the [`NestedHeaders`](@/api/nestedHeaders.md) plugin<br>- Configure headers that are nested on Handsontable's initialization |
    *
    * If you set the `nestedHeaders` option to an array of arrays, each array configures one row of
    * nested headers (top row first). Within a row, headers are listed left to right.
    *
    * Each array element configures one header, and can be one of the following:
    *
    * | Array element | Description                                               |
    * | ------------- | --------------------------------------------------------- |
    * | A string      | The header's label                                        |
    * | An object     | A header configuration object (see the properties below) |
    *
    * A header configuration object accepts the following properties:
    *
    * | Property          | Type      | Description                                                                                                                                                                                                                                                                                          |
    * | ----------------- | --------- | -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `label`           | `string`  | The header's label.                                                                                                                                                                                                                                                                                  |
    * | `colspan`         | `number`  | The number of data columns the header spans (an integer greater than `1`). Groups the columns it covers.                                                                                                                                                                                             |
    * | `rowspan`         | `number`  | The number of header rows the header spans (an integer greater than `1`).                                                                                                                                                                                                                            |
    * | `headerClassName` | `string`  | One or more space-separated CSS class names added to the header element (for example, `'htRight'`).                                                                                                                                                                                                  |
    * | `visibleWhen`     | `string`  | For a header inside a collapsible group, sets in which collapse state the header (and its columns) stays visible: `'collapsed'` (visible only while the group is collapsed), `'expanded'` (visible only while the group is expanded), or `'always'` (visible in both states). When omitted, a header in such a group defaults to `'expanded'` - it is hidden when the group collapses. At least one column of a group always stays visible. |
    *
    * ::: tip
    * A header group is made collapsible through the [`collapsibleColumns`](#collapsibleColumns) option, not through
    * `nestedHeaders`. Once a group is collapsible, mark the column(s) you want to keep visible when it collapses
    * with `visibleWhen: 'always'` (or `'collapsed'`); the remaining columns are hidden on collapse by default.
    * :::
    *
    * ::: tip
    * When `nestedHeaders` is configured, the `label` defined in the [`columns`](#columns) option for the same
    * column is replaced by the `label` from `nestedHeaders`. The `nestedHeaders` label takes precedence.
    * :::
    *
    * Read more:
    * - [Plugins: `NestedHeaders`](@/api/nestedHeaders.md)
    * - [Column groups: Nested headers](@/guides/columns/column-groups/column-groups.md#nested-headers)
    * - [Column groups: Choose which columns stay visible when collapsed](@/guides/columns/column-groups/column-groups.md#choose-which-columns-stay-visible-when-collapsed)
    *
    * @memberof Options#
    * @type {boolean|Array[]}
    * @default undefined
    * @category NestedHeaders
    *
    * @example
    * ```js
    * // group headers with `label` and `colspan`
    * nestedHeaders: [
    *   ['A', {label: 'B', colspan: 8}, 'C'],
    *   ['D', {label: 'E', colspan: 4}, {label: 'F', colspan: 4}, 'G'],
    *   ['H', 'I', 'J', 'K', 'L', 'M', 'N', 'R', 'S', 'T']
    * ],
    *
    * // choose which columns stay visible when a collapsible group is collapsed:
    * // unmarked headers (Jan, Feb, Mar) are hidden on collapse; `Total` appears only when collapsed
    * nestedHeaders: [
    *   ['Region', {label: 'Q1 2025', colspan: 4}],
    *   ['Region', 'Jan', 'Feb', 'Mar', {label: 'Total', visibleWhen: 'collapsed'}]
    * ],
    * collapsibleColumns: true,
    * ```
    */
    nestedHeaders: void 0,
    /**
    * @description
    * The `nestedRows` option configures the [`NestedRows`](@/api/nestedRows.md) plugin.
    *
    * You can set the `nestedRows` option to one of the following:
    *
    * | Setting           | Description                                            |
    * | ----------------- | ------------------------------------------------------ |
    * | `false` (default) | Disable the [`NestedRows`](@/api/nestedRows.md) plugin |
    * | `true`            | Enable the [`NestedRows`](@/api/nestedRows.md) plugin  |
    *
    * Read more:
    * - [Plugins: `NestedRows`](@/guides/rows/row-parent-child/row-parent-child.md)
    *
    * @example
    * ```js
    * // enable the `NestedRows` plugin
    * nestedRows: true,
    * ```
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category NestedRows
    */
    nestedRows: void 0,
    /**
    * The `noWordWrapClassName` option lets you add a CSS class name
    * to each cell that has the [`wordWrap`](#wordWrap) option set to `false`.
    *
    * Read more:
    * - [`wordWrap`](#wordWrap)
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default 'htNoWrap'
    * @category Core
    *
    * @example
    * ```js
    * // add an `is-noWrapCell` CSS class name
    * // to each cell that doesn't wrap content
    * noWordWrapClassName: 'is-noWrapCell',
    * ```
    */
    noWordWrapClassName: "htNoWrap",
    /**
    * Configures the number format for [`numeric`](@/guides/cell-types/numeric-cell-type/numeric-cell-type.md)
    * cells, including currency, units, precision, and other display options.
    *
    * Since v17.0.0, this option accepts all properties of the
    * [`Intl.NumberFormatOptions`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat)
    * object. The locale is controlled separately via the [`locale`](@/api/options.md#locale) option.
    *
    * **Style options:**
    *
    * | Property          | Possible values                                           | Description                                                    |
    * | ----------------- | --------------------------------------------------------- | -------------------------------------------------------------- |
    * | `style`           | `'decimal'` (default), `'currency'`, `'percent'`, `'unit'`| The formatting style to use                                    |
    * | `currency`        | ISO 4217 currency codes (e.g., `'USD'`, `'EUR'`, `'PLN'`) | Required when `style` is `'currency'`                          |
    * | `currencyDisplay` | `'symbol'` (default), `'narrowSymbol'`, `'code'`, `'name'`| How to display the currency                                    |
    * | `currencySign`    | `'standard'` (default), `'accounting'`                    | Use parentheses for negative values in accounting format       |
    * | `unit`            | Unit identifiers (e.g., `'kilometer'`, `'liter'`)         | Required when `style` is `'unit'`                              |
    * | `unitDisplay`     | `'short'` (default), `'narrow'`, `'long'`                 | How to display the unit                                        |
    *
    * **Notation options:**
    *
    * | Property          | Possible values                                               | Description                                              |
    * | ----------------- | ------------------------------------------------------------- | -------------------------------------------------------- |
    * | `notation`        | `'standard'` (default), `'scientific'`, `'engineering'`, `'compact'` | The formatting notation                           |
    * | `compactDisplay`  | `'short'` (default), `'long'`                                 | Display style for compact notation (e.g., `1.5M` vs `1.5 million`) |
    *
    * **Sign and grouping options:**
    *
    * | Property          | Possible values                                                     | Description                                        |
    * | ----------------- | ------------------------------------------------------------------- | -------------------------------------------------- |
    * | `signDisplay`     | `'auto'` (default), `'never'`, `'always'`, `'exceptZero'`, `'negative'` | When to display the sign                       |
    * | `useGrouping`     | `true`, `false` (default), `'always'`, `'auto'`, `'min2'`           | Whether to use grouping separators (e.g., `1,000`) |
    *
    * **Digit options:**
    *
    * | Property                  | Possible values | Description                                                   |
    * | ------------------------- | --------------- | ------------------------------------------------------------- |
    * | `minimumIntegerDigits`    | `1` to `21`     | Minimum number of integer digits (pads with zeros)            |
    * | `minimumFractionDigits`   | `0` to `100`    | Minimum number of fraction digits                             |
    * | `maximumFractionDigits`   | `0` to `100`    | Maximum number of fraction digits                             |
    * | `minimumSignificantDigits`| `1` to `21`     | Minimum number of significant digits                          |
    * | `maximumSignificantDigits`| `1` to `21`     | Maximum number of significant digits                          |
    *
    * **Rounding options:**
    *
    * | Property              | Possible values                                                                                     | Description                          |
    * | --------------------- | --------------------------------------------------------------------------------------------------- | ------------------------------------ |
    * | `roundingMode`        | `'halfExpand'` (default), `'ceil'`, `'floor'`, `'expand'`, `'trunc'`, `'halfCeil'`, `'halfFloor'`, `'halfTrunc'`, `'halfEven'` | Rounding algorithm |
    * | `roundingPriority`    | `'auto'` (default), `'morePrecision'`, `'lessPrecision'`                                            | Priority between fraction and significant digits |
    * | `roundingIncrement`   | `1`, `2`, `5`, `10`, `20`, `25`, `50`, `100`, `200`, `250`, `500`, `1000`, `2000`, `2500`, `5000`    | Increment for rounding (e.g., nickel rounding) |
    * | `trailingZeroDisplay` | `'auto'` (default), `'stripIfInteger'`                                                              | Whether to strip trailing zeros for integers |
    *
    * **Locale options:**
    *
    * | Property          | Possible values                                           | Description                                        |
    * | ----------------- | --------------------------------------------------------- | -------------------------------------------------- |
    * | `localeMatcher`   | `'best fit'` (default), `'lookup'`                        | Locale matching algorithm                          |
    * | `numberingSystem` | `'latn'`, `'arab'`, `'hans'`, `'deva'`, `'thai'`, etc.    | Numbering system to use                            |
    *
    * For complete reference, see [MDN: Intl.NumberFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options).
    *
    * This option affects only the displayed output in the cell renderer.
    * It has no effect on the numeric cell editor. In the source data, numeric values
    * are stored as JavaScript numbers.
    *
    * Read more:
    * - [`locale`](@/api/options.md#locale)
    * - [Numeric cell type](@/guides/cell-types/numeric-cell-type/numeric-cell-type.md)
    * - [Cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md)
    * - [Third-party licenses](@/guides/technical-specification/third-party-licenses/third-party-licenses.md)
    *
    * @memberof Options#
    * @since 0.35.0
    * @type {object}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'numeric',
    *     locale: 'en-US',
    *     numericFormat: {
    *       style: 'currency',
    *       currency: 'USD',
    *     }
    *   }
    * ],
    * ```
    */
    numericFormat: void 0,
    /**
    * If the `observeDOMVisibility` option is set to `true`,
    * Handsontable rerenders every time it detects that the grid was made visible in the DOM.
    *
    * Handsontable uses a `MutationObserver` to watch for CSS changes (such as `display: none` being removed)
    * on the container element and its ancestors. When visibility is restored after being hidden,
    * Handsontable automatically triggers a rerender to ensure correct layout and dimensions.
    * Set this option to `false` if you want to control rendering manually (e.g. by calling `render()` yourself).
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // don't rerender the grid on visibility changes
    * observeDOMVisibility: false,
    * ```
    */
    observeDOMVisibility: true,
    /**
    * The `outsideClickDeselects` option determines what happens to the current [selection](@/guides/cell-features/selection/selection.md)
    * when you click outside of the grid.
    *
    * You can set the `outsideClickDeselects` option to one of the following:
    *
    * | Setting          | Description                                                                                              |
    * | ---------------- | -------------------------------------------------------------------------------------------------------- |
    * | `true` (default) | On a mouse click outside of the grid, clear the current [selection](@/guides/cell-features/selection/selection.md) |
    * | `false`          | On a mouse click outside of the grid, keep the current [selection](@/guides/cell-features/selection/selection.md)  |
    * | A function       | A function that takes the click event target and returns a boolean                                       |
    *
    * @memberof Options#
    * @type {boolean|Function}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // on a mouse click outside of the grid, clear the current selection
    * outsideClickDeselects: true,
    *
    * // on a mouse click outside of the grid, keep the current selection
    * outsideClickDeselects: false,
    *
    * // take the click event target and return `false`
    * outsideClickDeselects(event) {
    *   return false;
    * }
    *
    * // take the click event target and return `true`
    * outsideClickDeselects(event) {
    *   return false;
    * }
    * ```
    */
    outsideClickDeselects: true,
    /**
    * @description
    * The `pagination` option configures the [`Pagination`](@/api/pagination.md) plugin.
    *
    * You can set the `pagination` option to one of the following:
    *
    * | Setting                          | Description                                                                                   |
    * | -------------------------------- | --------------------------------------------------------------------------------------------- |
    * | `false`                          | Disable the [`Pagination`](@/api/pagination.md) plugin                                            |
    * | `true`                           | Enable the [`Pagination`](@/api/pagination.md) plugin                                             |
    *
    * ##### pagination: Additional options
    *
    * If you set the `pagination` option to an object, you can set the following `Pagination` plugin options:
    *
    * | Option                   | Possible settings                                  | Description                                                                                                                                                      |
    * | ------------------------ | -------------------------------------------------- | ---------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `pageSize`               | A number or `auto` (default: `10`)                 | Sets the number of rows displayed per page. If `'auto'` is set, the page size will be calculated to match all rows to the currently set table's viewport height  |
    * | `pageSizeList`           | An array (default: `['auto', 5, 10, 20, 50, 100]`) | Defines the selectable values for page size in the UI                                                                                                            |
    * | `initialPage`            | A number (default: `1`)                            | Specifies which page to display on initial load                                                                                                                  |
    * | `showPageSize`           | Boolean (default: `true`)                          | Controls visibility of the "page size" section                                                                                                                   |
    * | `showCounter`            | Boolean (default: `true`)                          | Controls visibility of the "page counter" section (e.g., "1 - 10 of 50");                                                                                        |
    * | `showNavigation`         | Boolean (default: `true`)                          | Controls visibility of the "page navigation" section                                                                                                             |
    * | `uiContainer`            | An HTML element (default: `null`)                  | The container element where the pagination UI will be installed. If not provided, the pagination container will be injected below the root table element.        |
    *
    * Read more:
    * - [Rows pagination](@/guides/rows/rows-pagination/rows-pagination.md)
    * - [Plugins: `Pagination`](@/api/pagination.md)
    *
    * @since 16.1.0
    * @memberof Options#
    * @type {boolean}
    * @default undefined
    * @category Pagination
    *
    * @example
    * ```js
    * // enable the `Pagination` plugin
    * pagination: true,
    * ```
    */
    pagination: void 0,
    /**
    * The `placeholder` option lets you display placeholder text in every empty cell.
    *
    * You can set the `placeholder` option to one of the following:
    *
    * | Setting            | Example        | Description                                                           |
    * | ------------------ | -------------- | --------------------------------------------------------------------- |
    * | A non-empty string | `'Empty cell'` | Display `Empty cell` text in empty cells                              |
    * | A non-string value | `000`          | Display `000` text in empty cells (non-string values get stringified) |
    *
    * Read more:
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    *
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // display 'Empty cell' text
    * // in every empty cell of the entire grid
    * placeholder: 'Empty cell',
    *
    * // or
    * columns: [
    *   {
    *     data: 'date',
    *     dateFormat: { day: '2-digit', month: '2-digit', year: 'numeric' },
    *     // display 'Empty date cell' text
    *     // in every empty cell of the `date` column
    *     placeholder: 'Empty date cell'
    *   }
    * ],
    * ```
    */
    placeholder: void 0,
    /**
    * The `placeholderCellClassName` option lets you add a CSS class name to cells
    * that contain [`placeholder`](#placeholder) text.
    *
    * Read more:
    * - [Cell validator](@/guides/cell-functions/cell-validator/cell-validator.md)
    * - [`placeholder`](#placeholder)
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`TableClassName`](#TableClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string}
    * @default 'htPlaceholder'
    * @category Core
    *
    * @example
    * ```js
    * // add a `has-placeholder` CSS class name
    * // to each cell that contains `placeholder` text
    * placeholderCellClassName: 'has-placeholder',
    * ```
    */
    placeholderCellClassName: "htPlaceholder",
    /**
    * The `preventOverflow` option configures preventing Handsontable
    * from overflowing outside of its parent element.
    *
    * When enabled, Handsontable caps its own dimensions to match the parent container's size in the specified direction,
    * preventing the grid from extending beyond the visible bounds of its parent.
    * This is useful when the parent element has `overflow: hidden` or a fixed size and you want the grid to fit within it.
    *
    * You can set the `preventOverflow` option to one of the following:
    *
    * | Setting           | Description                      |
    * | ----------------- | -------------------------------- |
    * | `false` (default) | Don't prevent overflowing        |
    * | `'horizontal'`      | Prevent horizontal overflowing |
    * | `'vertical'`        | Prevent vertical overflowing   |
    *
    * @memberof Options#
    * @type {string|boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // prevent horizontal overflowing
    * preventOverflow: 'horizontal',
    * ```
    */
    preventOverflow: false,
    /**
    * The `preventWheel` option configures preventing the `wheel` event's default action
    * on overlays.
    *
    * You can set the `preventWheel` option to one of the following:
    *
    * | Setting           | Description                                      |
    * | ----------------- | ------------------------------------------------ |
    * | `false` (default) | Don't prevent the `wheel` event's default action |
    * | `true`            | Prevent the `wheel` event's default action       |
    *
    * @memberof Options#
    * @private
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // don't prevent the `wheel` event's default action
    * preventWheel: false,
    * ```
    */
    preventWheel: false,
    /**
    * @description
    * The `readOnly` option determines whether a [cell](@/guides/cell-features/disabled-cells/disabled-cells.md#read-only-specific-cells),
    * [comment](@/guides/cell-features/comments/comments.md#make-a-comment-read-only), [column](@/guides/cell-features/disabled-cells/disabled-cells.md#read-only-columns)
    * or the [entire grid](@/guides/cell-features/disabled-cells/disabled-cells.md#read-only-grid) is editable or not. You can configure it as follows:
    *
    * | Setting           | Description                                                                                                                |
    * | ----------------- | ------------------------------------------------------------------------------------------------------------------------- |
    * | `false` (default) | Set as editable                                                                                                           |
    * | `true`            | - Set as read-only<br>- Add the [`readOnlyCellClassName`](#readOnlyCellClassName) CSS class name (by default: `htDimmed`) |
    *
    * `readOnly` cells can't be changed by the [`populateFromArray()`](@/api/core.md#populatefromarray) method.
    *
    * Read more:
    * - [Disabled cells](@/guides/cell-features/disabled-cells/disabled-cells.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // make the entire grid read-only
    * const configurationOptions = {
    *   columnSorting: true,
    * };
    *
    * // make the third column read-only
    * const configurationOptions = {
    *   columns: [
    *     {},
    *     {},
    *     {
    *       readOnly: true,
    *     },
    *   ],
    * };
    *
    * // make a specific cell read-only
    * const configurationOptions = {
    *   cell: [
    *     {
    *       row: 0,
    *       col: 0,
    *       readOnly: true,
    *     },
    * };
    * ```
    */
    readOnly: false,
    /**
    * The `readOnlyCellClassName` option lets you add a CSS class name to [read-only](#readOnly) cells.
    *
    * Read more:
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`TableClassName`](#TableClassName)
    *
    * @memberof Options#
    * @type {string}
    * @default 'htDimmed'
    * @category Core
    *
    * @example
    * ```js
    * // add a `is-readOnly` CSS class name
    * // to every read-only cell
    * readOnlyCellClassName: 'is-readOnly',
    * ```
    */
    readOnlyCellClassName: "htDimmed",
    /**
    * The `renderAllRows` option controls Handsontable's [row virtualization](@/guides/rows/row-virtualization/row-virtualization.md).
    * You can configure it as follows:
    *
    * | Setting           | Description                                                                                                                                                                                     |
    * | ----------------- | ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `false` (default) | Enable [row virtualization](@/guides/rows/row-virtualization/row-virtualization.md), rendering only the visible rows for optimal performance with large datasets.                                                  |
    * | `true`            | Disable [row virtualization](@/guides/rows/row-virtualization/row-virtualization.md)<br>(render all rows of the grid), rendering all rows in the dataset for consistent rendering and screen reader accessibility. |
    *
    * Setting `renderAllRows` to `true` overwrites the [`viewportRowRenderingOffset`](#viewportRowRenderingOffset) setting.
    *
    * Read more:
    * - [Row virtualization](@/guides/rows/row-virtualization/row-virtualization.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // disable row virtualization
    * renderAllRows: true,
    * ```
    */
    renderAllRows: false,
    /**
    * The `renderAllColumns` option configures Handsontable's [column virtualization](@/guides/columns/column-virtualization/column-virtualization.md).
    *
    * You can set the `renderAllColumns` option to one of the following:
    *
    * | Setting           | Description                                                                                                                                                                                                                      |
    * | ----------------- | -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `false` (default) | Enable [column virtualization](@/guides/columns/column-virtualization/column-virtualization.md), rendering only visible columns for better performance with many columns.                                                                              |
    * | `true`            | Disable [column virtualization](@/guides/columns/column-virtualization/column-virtualization.md)<br>(render all columns of the grid), rendering all columns in the dataset, and ensuring all columns are available regardless of horizontal scrolling. |
    *
    * Setting `renderAllColumns` to `true` overwrites the [`viewportColumnRenderingOffset`](#viewportColumnRenderingOffset) setting.
    *
    * Read more:
    * - [Column virtualization](@/guides/columns/column-virtualization/column-virtualization.md)
    *
    * @since 14.1.0
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * // disable column virtualization
    * renderAllColumns: true,
    * ```
    */
    renderAllColumns: false,
    /**
    * @description
    * The `renderer` option sets a [cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md) for a cell.
    *
    * You can set the `renderer` option to one of the following:
    * - A custom renderer function
    * - One of the following [cell renderer aliases](@/guides/cell-functions/cell-renderer/cell-renderer.md):
    *
    * | Alias               | Cell renderer function                                                         |
    * | ------------------- | ------------------------------------------------------------------------------ |
    * | A custom alias      | Your [custom cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md) function |
    * | `'autocomplete'`    | `AutocompleteRenderer`                                                         |
    * | `'base'`            | `BaseRenderer`                                                                 |
    * | `'checkbox'`        | `CheckboxRenderer`                                                             |
    * | `'date'`            | `DateRenderer`                                                                 |
    * | `'intl-date'`       | `IntlDateRenderer`                                                             |
    * | `'dropdown'`        | `DropdownRenderer`                                                             |
    * | `'html'`            | `HtmlRenderer`                                                                 |
    * | `'numeric'`         | `NumericRenderer`                                                              |
    * | `'password'`        | `PasswordRenderer`                                                             |
    * | `'text'`            | `TextRenderer`                                                                 |
    * | `'time'`            | `TimeRenderer`                                                                 |
    * | `'intl-time'`       | `IntlTimeRenderer`                                                             |
    *
    * To set the [`renderer`](#renderer), [`editor`](#editor), and [`validator`](#validator)
    * options all at once, use the [`type`](#type) option.
    *
    * Read more:
    * - [Cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md)
    * - [Cell type](@/guides/cell-types/cell-type/cell-type.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    * - [`type`](#type)
    *
    * @memberof Options#
    * @type {string|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // use the `numeric` renderer for each cell of the entire grid
    * renderer: `'numeric'`,
    *
    * // add a custom renderer function
    * renderer(hotInstance, td, row, column, prop, value, cellProperties) {
    *   // your custom renderer's logic
    *   ...
    * }
    *
    * // apply the `renderer` option to individual columns
    * columns: [
    *   {
    *     // use the `autocomplete` renderer for each cell of this column
    *     renderer: 'autocomplete'
    *   },
    *   {
    *     // use the `myCustomRenderer` renderer for each cell of this column
    *     renderer: 'myCustomRenderer'
    *   }
    * ]
    * ```
    */
    renderer: void 0,
    /**
    * @description
    * The `valueFormatter` option sets a custom function for formatting cell values before display.
    *
    * Unlike the [`renderer`](#renderer) option, which is responsible for the complete cell rendering process
    * (DOM structure, performance-optimized content insertion via `innerText`/`innerHTML`, a11y attributes, applying
    * styles from `className`, `readOnlyCellClassName`, `textEllipsis`, and other options), the `valueFormatter`
    * focuses solely on transforming the cell's value.
    *
    * The `valueFormatter` function is called by the rendering engine right before the actual renderer function is
    * called. Separating the value formatting from the renderer logic allows for more flexibility and reuse.
    * This simplifies common formatting use cases where you only need to transform
    * the displayed value (e.g., adding units, formatting dates, or applying custom text transformations).
    *
    * **When to use `valueFormatter` vs `renderer`:**
    *
    * | Use case                                          | Recommended option   |
    * | ------------------------------------------------- | -------------------- |
    * | Transform displayed value (add prefix, units)     | `valueFormatter`     |
    * | Custom date/number/text formatting                | `valueFormatter`     |
    * | Modify DOM structure (add icons, custom elements) | `renderer`           |
    *
    * The function receives the raw value and cell properties, and should return the formatted value
    * to be displayed. The formatting can be applied to a single cell, column, or the entire grid.
    *
    * **Function signature:**
    * ```js
    * valueFormatter(value, cellProperties) => formattedValue
    * ```
    *
    * | Parameter        | Type       | Description                                    |
    * | ---------------- | ---------- | ---------------------------------------------- |
    * | `value`          | `*`        | The raw cell value                             |
    * | `cellProperties` | `object`   | The cell's meta object (see {@link Core#getCellMeta}) |
    * | Returns          | `*`        | The formatted value to display                 |
    *
    * Read more:
    * - [Cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    *
    * @memberof Options#
    * @since 17.0.0
    * @type {Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // add a currency symbol to numeric values
    * valueFormatter(value, cellProperties) {
    *   if (value === null || value === undefined) {
    *     return '';
    *   }
    *
    *   return `$${value}`;
    * }
    *
    * // format dates in a custom format
    * valueFormatter(value, cellProperties) {
    *   if (!value) {
    *     return '';
    *   }
    *
    *   const date = new Date(value);
    *
    *   return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    * }
    *
    * // apply valueFormatter to individual columns
    * columns: [
    *   {
    *     // add "kg" suffix to weight values
    *     valueFormatter(value) {
    *       return value ? `${value} kg` : '';
    *     }
    *   },
    *   {
    *     // format percentages
    *     valueFormatter(value) {
    *       return value !== null ? `${(value * 100).toFixed(1)}%` : '';
    *     }
    *   }
    * ]
    * ```
    */
    valueFormatter: void 0,
    /**
    * @description
    * The `valueParser` option sets a custom function for converting editor output into the source data format.
    *
    * Unlike [`valueFormatter`](#valueformatter), which formats values for display, `valueParser` runs only when a
    * value comes from the [cell editor](@/guides/cell-functions/cell-editor/cell-editor.md) - after the user finishes
    * editing. It maps whatever the editor returns (e.g. a localized date string, a formatted number) into the
    * canonical shape stored in the data source (e.g. ISO date string, raw number).
    *
    * **When to use `valueParser` vs `valueFormatter`:**
    *
    * | Use case                               | Option           |
    * | -------------------------------------- | ---------------- |
    * | Display: raw value -> shown text       | `valueFormatter` |
    * | Edit: editor value -> source data      | `valueParser`    |
    *
    * **Function signature:**
    * ```js
    * valueParser(value, cellProperties) => sourceValue
    * ```
    *
    * | Parameter        | Type     | Description                                    |
    * | ---------------- | -------- | ---------------------------------------------- |
    * | `value`          | `*`      | The value produced by the editor               |
    * | `cellProperties` | `object` | The cell's meta object (see {@link Core#getCellMeta}) |
    * | Returns          | `*`      | The value to store in the source data          |
    *
    * Read more:
    * - [Cell editor](@/guides/cell-functions/cell-editor/cell-editor.md)
    * - [`editor`](#editor)
    * - [`renderer`](#renderer)
    * - [`valueFormatter`](#valueformatter)
    * - [`sourceDataValidator`](#sourcedatavalidator)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    *
    * @memberof Options#
    * @since 17.0.0
    * @type {Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // parse editor string to ISO date (e.g. intl-date: display format => source format)
    * valueParser(value, cellProperties) {
    *   if (value == null || value === '') {
    *     return null;
    *   }
    *
    *   const date = new Date(value);
    *
    *   return Number.isNaN(date.getTime()) ? value : date.toISOString().slice(0, 10);
    * }
    *
    * // parse formatted number string to number
    * valueParser(value, cellProperties) {
    *   if (value == null || value === '') {
    *     return null;
    *   }
    *
    *   const num = Number(value.replace(/[^\d.-]/g, ''));
    *
    *   return Number.isNaN(num) ? value : num;
    * }
    *
    * // apply valueParser per column
    * columns: [
    *   { data: 'date', valueParser: (value) => value ? new Date(value).toISOString().slice(0, 10) : null },
    *   { data: 'amount', valueParser: (value) => value != null ? Number(value) : null }
    * ]
    * ```
    */
    valueParser: void 0,
    /**
    * The `rowHeaders` option configures your grid's row headers.
    *
    * You can set the `rowHeaders` option to one of the following:
    *
    * | Setting    | Description                                                       |
    * | ---------- | ----------------------------------------------------------------- |
    * | `true`     | Enable the default row headers ('1', '2', '3', ...)               |
    * | `false`    | Disable row headers                                               |
    * | An array   | Define your own row headers (e.g. `['One', 'Two', 'Three', ...]`) |
    * | A function | Define your own row headers, using a function                     |
    *
    * Read more:
    * - [Row header](@/guides/rows/row-header/row-header.md)
    *
    * @memberof Options#
    * @type {boolean|string[]|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // enable the default row headers
    * rowHeaders: true,
    *
    * // set your own row headers
    * rowHeaders: ['One', 'Two', 'Three'],
    *
    * // set your own row headers, using a function
    * rowHeaders: function(visualRowIndex) {
    *   return `${visualRowIndex}: AB`;
    * },
    * ```
    */
    rowHeaders: void 0,
    /**
    * @description
    * The `rowHeaderWidth` option configures the width of row headers.
    *
    * You can set the `rowHeaderWidth` option to one of the following:
    *
    * | Setting  | Description                                     |
    * | -------- | ----------------------------------------------- |
    * | A number | Set the same width for every row header         |
    * | An array | Set different widths for individual row headers |
    *
    * @memberof Options#
    * @type {number|number[]}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set the same width for every row header
    * rowHeaderWidth: 25,
    *
    * // set different widths for individual row headers
    * rowHeaderWidth: [25, 30, 55],
    * ```
    */
    rowHeaderWidth: void 0,
    /**
    * The `rowHeights` option sets rows' heights, in pixels.
    *
    * In the rendering process, the default row height is `classic: 26px`, `main: 29px`, `horizon: 37px` or whatever is defined in the used theme (based on the line height, vertical padding and cell borders).
    * You can change it to equal or greater than the default value, by setting the `rowHeights` option to one of the following:
    *
    * | Setting     | Description                                                                                         | Example                                                      |
    * | ----------- | --------------------------------------------------------------------------------------------------- | ------------------------------------------------------------ |
    * | A number    | Set the same height for every row                                                                   | `rowHeights: 100`                                            |
    * | A string    | Set the same height for every row                                                                   | `rowHeights: '100px'`                                        |
    * | An array    | Set heights separately for each row                                                                 | `rowHeights: [100, 120, undefined]`                          |
    * | A function  | Set row heights dynamically,<br>on each render                                                      | `rowHeights(visualRowIndex) { return visualRowIndex * 10; }` |
    * | `undefined` | Used by the [modifyRowHeight](@/api/hooks.md#modifyRowHeight) hook,<br>to detect row height changes | `rowHeights: undefined`                                      |
    *
    * The `rowHeights` option also sets the minimum row height that can be set
    * via the {@link ManualRowResize} and {@link AutoRowSize} plugins (if they are enabled).
    *
    * Read more:
    * - [Row height](@/guides/rows/row-height/row-height.md)
    *
    * @memberof Options#
    * @type {number|number[]|string|string[]|Array<undefined>|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set every row's height to 100px
    * rowHeights: 100,
    *
    * // set every row's height to 100px
    * rowHeights: '100px',
    *
    * // set the first (by visual index) row's height to 100
    * // set the second (by visual index) row's height to 120
    * // set the third (by visual index) row's height to `undefined`
    * // set any other row's height to the default height value
    * rowHeights: [100, 120, undefined],
    *
    * // set each row's height individually, using a function
    * rowHeights(visualRowIndex) {
    *   return visualRowIndex * 10;
    * },
    * ```
    */
    rowHeights: void 0,
    /**
    * @description
    * The `search` option enables and configures the [`Search`](@/api/search.md) plugin.
    *
    * | Setting           | Description                                                                    |
    * | ----------------- | ------------------------------------------------------------------------------ |
    * | `false` (default) | Disable the [`Search`](@/api/search.md) plugin                                 |
    * | `true`            | Enable the [`Search`](@/api/search.md) plugin with the default configuration   |
    * | An object         | Enable the [`Search`](@/api/search.md) plugin and apply a custom configuration |
    *
    * When set to an object, the following properties are supported:
    *
    * | Property            | Type       | Default                          | Description                                                                                                                                                        |
    * | ------------------- | ---------- | -------------------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
    * | `searchResultClass` | `string`   | `'htSearchResult'`               | CSS class name applied to every cell where `isSearchResult === true`.                                                                                              |
    * | `queryMethod`       | `Function` | Case-insensitive substring match | Tests whether the query string matches a cell value. Signature: `(queryStr: string, value: string\|number\|null, cellProperties: object) => boolean`.              |
    * | `callback`          | `Function` | Sets `isSearchResult` on cell metadata | Called for every cell after each test. Signature: `(instance: Handsontable, row: number, col: number, data: string\|number\|null, testResult: boolean) => void`. |
    *
    * Default `queryMethod` behavior: case-insensitive, locale-aware substring match using `toLocaleLowerCase()` with `cellProperties.locale`.
    *
    * Default `callback` behavior: sets `instance.getCellMeta(row, col).isSearchResult = testResult` on every cell.
    *
    * **Per-cell overrides:** `queryMethod` and `callback` can also be set on individual cells, columns, or rows
    * using the cascading configuration model. A cell-level `search.queryMethod` or `search.callback` takes
    * precedence over the plugin-level setting for that cell. `searchResultClass` does not support per-cell overrides.
    *
    * Read more:
    * - [Searching values](@/guides/navigation/searching-values/searching-values.md)
    * - [Custom query method](@/guides/navigation/searching-values/searching-values.md#custom-query-method)
    * - [Custom callback](@/guides/navigation/searching-values/searching-values.md#custom-callback)
    * - [Per-cell overrides](@/guides/navigation/searching-values/searching-values.md#per-cell-querymethod-and-callback)
    *
    * @memberof Options#
    * @type {boolean|object}
    * @default false
    * @category Search
    *
    * @example
    * ```js
    * // Enable with the default configuration
    * search: true,
    *
    * // Enable with a custom configuration
    * search: {
    *   // Apply a custom CSS class to matching cells instead of 'htSearchResult'
    *   searchResultClass: 'customClass',
    *   // Replace the built-in substring match with exact matching
    *   queryMethod(queryStr, value, cellProperties) {
    *     if (!queryStr || queryStr.length === 0) return false;
    *     if (value === undefined || value === null) return false;
    *
    *     return queryStr.toString() === value.toString();
    *   },
    *   // Count results while preserving default highlighting
    *   callback(instance, row, col, data, testResult) {
    *     // Preserve the default isSearchResult flag so highlighting still works
    *     instance.getCellMeta(row, col).isSearchResult = testResult;
    *
    *     if (testResult) {
    *       // Custom logic: e.g., increment a result counter
    *     }
    *   }
    * },
    *
    * // Override queryMethod for a specific column only (per-cell via cascading config)
    * columns: [
    *   {},
    *   {
    *     search: {
    *       queryMethod(queryStr, value) {
    *         return queryStr.toString() === value.toString(); // exact match for column 1
    *       }
    *     }
    *   }
    * ],
    * ```
    */
    search: false,
    /**
    * The `searchInput` option configures whether the [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md) editor's search input is visible.
    *
    * @since 17.0.0
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    * @example
    * ```js
    * columns: [{
    *   type: 'multiselect',
    *   // hide the `multiSelect` editor's search input
    *   searchInput: false,
    * }],
    * ```
    */
    searchInput: true,
    /**
    * @description
    * The `selectionMode` option configures how [selection](@/guides/cell-features/selection/selection.md) works.
    *
    * You can set the `selectionMode` option to one of the following:
    *
    * | Setting      | Description                                                  |
    * | ------------ | ------------------------------------------------------------ |
    * | `'single'`   | Allow the user to select only one cell at a time.            |
    * | `'range'`    | Allow the user to select one range of cells at a time.       |
    * | `'multiple'` | Allow the user to select multiple ranges of cells at a time. |
    *
    * Read more:
    * - [Selection: Selecting ranges](@/guides/cell-features/selection/selection.md#select-ranges)
    *
    * @memberof Options#
    * @type {string}
    * @default 'multiple'
    * @category Core
    *
    * @example
    * ```js
    * // you can only select one cell at at a time
    * selectionMode: 'single',
    *
    * // you can select one range of cells at a time
    * selectionMode: 'range',
    *
    * // you can select multiple ranges of cells at a time
    * selectionMode: 'multiple',
    * ```
    */
    selectionMode: "multiple",
    /**
    * The `selectOptions` option configures options that the end user can choose from in [`select`](@/guides/cell-types/select-cell-type/select-cell-type.md) cells.
    *
    * You can set the `selectOptions` option to one of the following:
    *
    * | Setting                         | Description                                                                   |
    * | ------------------------------- | ----------------------------------------------------------------------------- |
    * | An array of strings             | Each string is one option's value and label                                   |
    * | An object with key-string pairs | - Each key is one option's value<br>- The key's string is that option's label |
    * | A function                      | A function that returns an object with key-string pairs                       |
    *
    * Read more:
    * - [Select cell type](@/guides/cell-types/select-cell-type/select-cell-type.md)
    *
    * @memberof Options#
    * @type {string[]|object|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // set the `type` of each cell in this column to `select`
    *     type: 'select',
    *     // set the first option's value and label to `A`
    *     // set the second option's value and label to `B`
    *     // set the third option's value and label to `C`
    *     selectOptions: ['A', 'B', 'C'],
    *   },
    *   {
    *     // set the `type` of each cell in this column to `select`
    *     type: 'select',
    *     selectOptions: {
    *       // set the first option's value to `value1` and label to `Label 1`
    *       value1: 'Label 1',
    *       // set the second option's value to `value2` and label to `Label 2`
    *       value2: 'Label 2',
    *       // set the third option's value to `value3` and label to `Label 3`
    *       value3: 'Label 3',
    *     },
    *   },
    *   {
    *     // set the `type` of each cell in this column to `select`
    *     type: 'select',
    *     // set `selectOption` to a function that returns available options as an object
    *     selectOptions(visualRow, visualColumn, prop) {
    *       return {
    *         value1: 'Label 1',
    *         value2: 'Label 2',
    *         value3: 'Label 3',
    *       };
    *   },
    * ],
    * ```
    */
    selectOptions: void 0,
    /**
    * @description
    * The `skipColumnOnPaste` option determines whether you can paste data into a given column.
    *
    * You can only apply the `skipColumnOnPaste` option to an entire column, using the [`columns`](#columns) option. This option is not supported for the global table level settings.
    *
    * You can set the `skipColumnOnPaste` option to one of the following:
    *
    * | Setting           | Description                                                                                           |
    * | ----------------- | ----------------------------------------------------------------------------------------------------- |
    * | `false` (default) | Enable pasting data into this column                                                                  |
    * | `true`            | - Disable pasting data into this column<br>- On pasting, paste data into the next column to the right |
    *
    * Read more:
    * - [Configuration options: Setting column options](@/guides/getting-started/configuration-options/configuration-options.md#set-column-options)
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // disable pasting data into this column
    *     skipColumnOnPaste: true
    *   }
    * ],
    * ```
    */
    skipColumnOnPaste: false,
    /**
    * @description
    *
    * The `skipRowOnPaste` option determines whether you can paste data into a given row.
    *
    * You can only apply the `skipRowOnPaste` option to an entire row, using the [`cells`](#cells) option. This option is not supported for the global table level settings.
    *
    * You can set the `skipRowOnPaste` option to one of the following:
    *
    * | Setting           | Description                                                                         |
    * | ----------------- | ----------------------------------------------------------------------------------- |
    * | `false` (default) | Enable pasting data into this row                                                   |
    * | `true`            | - Disable pasting data into this row<br>- On pasting, paste data into the row below |
    *
    * Read more:
    * - [Configuration options: Setting row options](@/guides/getting-started/configuration-options/configuration-options.md#set-row-options)
    *
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * cells(row, column) {
    *  const cellProperties = {};
    *
    *  // disable pasting data into row 1
    *  if (row === 1) {
    *    cellProperties.skipRowOnPaste = true;
    *  }
    *
    *  return cellProperties;
    * }
    * ```
    */
    skipRowOnPaste: false,
    /**
    * The `sortByRelevance` option configures whether [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) cells'
    * lists are sorted in the same order as provided in the [`source`](#source) option.
    *
    * You can set the `sortByRelevance` option to one of the following:
    *
    * | Setting          | Description                                                                  |
    * | ---------------- | ---------------------------------------------------------------------------- |
    * | `true` (default) | Sort options in the same order as provided in the [`source`](#source) option |
    * | `false`          | Sort options alphabetically                                                  |
    *
    * Read more:
    * - [`source`](#source)
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * columns: [{
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // set options available in every `autocomplete` cell of this column
    *   source: ['D', 'C', 'B', 'A'],
    *   // sort the `autocomplete` option in this order: D, C, B, A
    *   sortByRelevance: true
    * }],
    * ```
    */
    sortByRelevance: true,
    /**
    * The `sourceSortFunction` option sets a function to sort the options available in [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md)-typed cells.
    *
    * @since 17.0.0
    * @memberof Options#
    * @type {Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [{
    *   // set the `type` of each cell in this column to `multiSelect`
    *   type: 'multiselect',
    *   // set options available in every `multiSelect` cell of this column
    *   source: ['A', 'B', 'C', 'D'],
    *   // sort the `multiSelect` options in this order: D, C, B, A
    *   sourceSortFunction: (entries) => {
    *     return entries.sort((a, b) => b.localeCompare(a));
    *   }
    * }],
    * ```
    */
    sourceSortFunction: void 0,
    /**
    * The `source` option sets options available in [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * and [`dropdown`](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md) cells.
    *
    * You can set the `source` option to one of the following:
    *
    * - An array of string values
    * - An array of objects with `key` and `value` properties
    * - A function
    *
    * Note: When defining the `source` option as an array of objects with `key` and `value` properties, the data format for that cell
    * needs to be an object with `key` and `value` properties as well.
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [Dropdown cell type](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md)
    * - [`strict`](#strict)
    * - [`allowHtml`](#allowHtml)
    * - [`filter`](#filter)
    * - [`sortByRelevance`](#sortByRelevance)
    *
    * @memberof Options#
    * @type {Array|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set `source` to an array of string values
    * columns: [{
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // set options available in every `autocomplete` cell of this column
    *   source: ['A', 'B', 'C', 'D']
    * }],
    *
    * // set `source` to an array of objects with `key` and `value` properties
    * columns: [{
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // set options available in every `autocomplete` cell of this column
    *   source: [{
    *     key: 'A',
    *     value: 'Label A'
    *   }, {
    *     key: 'B',
    *     value: 'Label B'
    *   }]
    * }],
    *
    * // set `source` to a function
    * columns: [{
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // for every `autocomplete` cell in this column, fetch data from an external source
    *   source(query, callback) {
    *     fetch('https://example.com/query?q=' + query, function(response) {
    *       callback(response.items);
    *     })
    *   }
    * }],
    * ```
    */
    source: void 0,
    /**
    * @description
    * If the [`data`](#data) option is not set, the `startCols` option sets the initial number of empty columns.
    *
    * The `startCols` option works only in Handsontable's constructor and only when [`data`](#data) is not provided.
    *
    * ::: tip
    * When [`minSpareCols`](#minSpareCols) is set alongside `startCols`, the `startCols` columns count toward the
    * minimum number of spare columns. As a result, the total initial column count will be the maximum of
    * `startCols` and `minSpareCols`.
    * :::
    *
    * @memberof Options#
    * @type {number}
    * @default 5
    * @category Core
    *
    * @example
    * ```js
    * // start with 15 empty columns
    * startCols: 15,
    * ```
    */
    startCols: 5,
    /**
    * @description
    * If the [`data`](#data) option is not set, the `startRows` option sets the initial number of empty rows.
    *
    * The `startRows` option works only in Handsontable's constructor and only when [`data`](#data) is not provided.
    *
    * ::: tip
    * When [`minSpareRows`](#minSpareRows) is set alongside `startRows`, the `startRows` rows count toward the
    * minimum number of spare rows. As a result, the total initial row count will be the maximum of
    * `startRows` and `minSpareRows`.
    * :::
    *
    * @memberof Options#
    * @type {number}
    * @default 5
    * @category Core
    *
    * @example
    * ```js
    * // start with 15 empty rows
    * startRows: 15,
    * ```
    */
    startRows: 5,
    /**
    * @description
    * The `stretchH` option determines what happens when the declared grid width
    * is different from the calculated sum of all column widths.
    *
    * You can set the `stretchH` option to one of the following:
    *
    * | Setting            | Description                                                       |
    * | ------------------ | ----------------------------------------------------------------- |
    * | `'none'` (default) | Don't fit the grid to the container (disable column stretching)   |
    * | `'last'`           | Fit the grid to the container, by stretching only the last column |
    * | `'all'`            | Fit the grid to the container, by stretching all columns evenly   |
    *
    * Read more:
    * - [Column width: Column stretching](@/guides/columns/column-width/column-width.md#column-stretching)
    *
    * @memberof Options#
    * @type {string}
    * @default 'none'
    * @category Core
    *
    * @example
    * ```js
    * // fit the grid to the container
    * // by stretching all columns evenly
    * stretchH: 'all',
    * ```
    */
    stretchH: "none",
    /**
    * The `strict` option configures the behavior of [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) cells.
    *
    * You can set the `strict` option to one of the following:
    *
    * | Setting | Mode                                                                                          | Description                                                                                |
    * | ------- | --------------------------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------ |
    * | `true`  | [Strict mode](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md#autocomplete-strict-mode)         | The end user:<br>- Can only choose one of suggested values<br>- Can't enter a custom value |
    * | `false` | [Flexible mode](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md#autocomplete-flexible-mode)     | The end user:<br>- Can choose one of suggested values<br>- Can enter a custom value        |
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [`source`](#source)
    *
    * @memberof Options#
    * @type {boolean}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *   // set the `type` of each cell in this column to `autocomplete`
    *   type: 'autocomplete',
    *   // set options available in every `autocomplete` cell of this column
    *   source: ['A', 'B', 'C'],
    *   // values entered must match `A`, `B`, or `C`
    *   strict: true
    *   },
    * ],
    * ```
    */
    strict: void 0,
    /**
    * The `tableClassName` option lets you add CSS class names
    * to every Handsontable instance inside the `container` element.
    *
    * You can set the `tableClassName` option to one of the following:
    *
    * | Setting             | Description                                                                                |
    * | ------------------- | ------------------------------------------------------------------------------------------ |
    * | A string            | Add a single CSS class name to every Handsontable instance inside the `container` element  |
    * | An array of strings | Add multiple CSS class names to every Handsontable instance inside the `container` element |
    *
    * Read more:
    * - [`currentRowClassName`](#currentRowClassName)
    * - [`currentColClassName`](#currentColClassName)
    * - [`currentHeaderClassName`](#currentHeaderClassName)
    * - [`activeHeaderClassName`](#activeHeaderClassName)
    * - [`invalidCellClassName`](#invalidCellClassName)
    * - [`placeholderCellClassName`](#placeholderCellClassName)
    * - [`readOnlyCellClassName`](#readOnlyCellClassName)
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    * - [`commentedCellClassName`](#commentedCellClassName)
    * - [`className`](#className)
    *
    * @memberof Options#
    * @type {string|string[]}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // add a `your-class-name` CSS class name
    * // to every Handsontable instance inside the `container` element
    * tableClassName: 'your-class-name',
    *
    * // add `first-class-name` and `second-class-name` CSS class names
    * // to every Handsontable instance inside the `container` element
    * tableClassName: ['first-class-name', 'second-class-name'],
    * ```
    */
    tableClassName: void 0,
    /**
    * The `textEllipsis` option configures whether the text content in the cells should be truncated with an ellipsis (three dots).
    *
    * You can set the `textEllipsis` option to one of the following:
    *
    * | Setting           | Description                                   |
    * | ----------------- | --------------------------------------------- |
    * | `false` (default) | Don't truncate text content with an ellipsis  |
    * | `true`            | Truncate text content with an ellipsis        |
    *
    * @since 16.0.0
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // truncate text content with an ellipsis
    *     textEllipsis: true,
    *   },
    *   {
    *     // don't truncate text content with an ellipsis
    *     textEllipsis: false,
    *   }
    * ],
    * ```
    */
    textEllipsis: false,
    /**
    * The `themeName` option allows enabling a theme by that name.
    *
    * Read more:
    * - [Themes](@/guides/styling/themes/themes.md)
    *
    * @memberof Options#
    * @type {string|undefined}
    * @default undefined
    * @category Core
    * @since 15.0.0
    *
    * @example
    * ```js
    * themeName: 'ht-theme-name',
    * ```
    */
    themeName: void 0,
    /**
    * The `theme` option configures the visual theme for your Handsontable instance.
    *
    * You can set the `theme` option to one of the following:
    *
    * | Setting                               | Description                                                                           |
    * | ------------------------------------- | ------------------------------------------------------------------------------------- |
    * | `undefined` (default)                 | Don't apply any theme and use the default main theme                                  |
    * | A string (e.g., `'ht-theme-horizon'`) | Apply a registered theme by name (required to import CSS file)                        |
    * | A plain theme config object           | Apply a theme with default settings (import and pass the config, e.g. `horizonTheme`) |
    * | A `ThemeBuilder` object               | Apply a theme with runtime configuration (recommended)                                |
    *
    * When using a `ThemeBuilder` object, you can configure the theme at runtime using these methods:
    *
    * | Method                           | Description                                                                                |
    * | -------------------------------- | ------------------------------------------------------------------------------------------ |
    * | `setColorScheme(mode)`           | Sets the color scheme: `'light'`, `'dark'`, or `'auto'` (default: `'auto'`)                |
    * | `setDensityType(type)`           | Sets the row density: `'compact'`, `'default'`, or `'comfortable'` (default: `'default'`)  |
    * | `params(paramsObject)`           | Sets custom theme parameters e.g. `icons`, `colors`, `tokens`                              |
    *
    * Read more:
    * - [Themes](@/guides/styling/themes/themes.md)
    * - [`themeName`](#themeName)
    *
    * @memberof Options#
    * @type {ThemeBuilder|string|undefined}
    * @default undefined
    * @category Core
    * @since 17.0.0
    *
    * @example
    * ```js
    * // Enable a theme by class name (requires loading the theme CSS)
    * theme: 'ht-theme-horizon',
    * ```
    * @example
    * ```js
    * // Pass a plain theme config object
    * import { horizonTheme } from 'handsontable/themes';
    *
    * const hot = new Handsontable(container, {
    *   theme: horizonTheme,
    * });
    * ```
    *
    * @example
    * ```js
    * // Pass a ThemeBuilder object (for customization before initialization)
    * import { horizonTheme, registerTheme } from 'handsontable/themes';
    *
    * const theme = registerTheme(horizonTheme)
    *   .setColorScheme('dark')
    *   .setDensityType('compact')
    *   .params({
    *     tokens: {
    *       fontSize: '14px',
    *       iconSize: 'size_5',
    *       borderColor: ['colors.palette.100', 'colors.palette.800'],
    *     },
    *   });
    *
    * const hot = new Handsontable(container, {
    *   theme,
    * });
    * ```
    */
    theme: void 0,
    /**
    * The `injectCoreCss` option controls whether Handsontable injects its core CSS into the document.
    *
    * You can set the `injectCoreCss` option to one of the following:
    *
    * | Setting            | Description                                                                                                      |
    * | ------------------ | ---------------------------------------------------------------------------------------------------------------- |
    * | `true` (default)   | Inject core styles into the document head                                                                        |
    * | `false`            | Do not inject core styles (use when you load CSS yourself, e.g. `import 'handsontable/styles/handsontable.css'`) |
    *
    * Read more:
    * - [Themes](@/guides/styling/themes/themes.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    * @since 17.0.0
    *
    * @example
    * ```js
    * // inject core CSS (default)
    * injectCoreCss: true,
    *
    * // skip injection when you load Handsontable CSS yourself
    * injectCoreCss: false,
    * ```
    */
    injectCoreCss: true,
    /**
    * The `tabMoves` option configures the action of the <kbd>**Tab**</kbd> key.
    *
    * You can set the `tabMoves` option to an object with the following properties
    * (or to a function that returns such an object):
    *
    * | Property | Type   | Description                                                                                                                                              |
    * | -------- | ------ | -------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | `row`    | Number | - On pressing <kbd>**Tab**</kbd>, move selection `row` rows down<br>- On pressing <kbd>**Shift**</kbd>+<kbd>**Tab**</kbd>, move selection `row` rows up              |
    * | `col`    | Number | - On pressing <kbd>**Tab**</kbd>, move selection `col` columns right<br>- On pressing <kbd>**Shift**</kbd>+<kbd>**Tab**</kbd>, move selection `col` columns left     |
    *
    * @memberof Options#
    * @type {object|Function}
    * @default {row: 0, col: 1}
    * @category Core
    *
    * @example
    * ```js
    * // on pressing Tab, move selection 2 rows down and 2 columns right
    * // on pressing Shift+Tab, move selection 2 rows up and 2 columns left
    * tabMoves: {row: 2, col: 2},
    *
    * // the same setting, as a function
    * // `event` is a DOM Event object received on pressing Tab
    * // you can use it to check whether the user pressed Tab or Shift+Tab
    * tabMoves(event) {
    *   return {row: 2, col: 2};
    * },
    * ```
    */
    tabMoves: {
      row: 0,
      col: 1
    },
    /**
    * @description
    * The `title` option configures [column header](@/guides/columns/column-header/column-header.md) names.
    *
    * You can set the `title` option to a string.
    *
    * Read more:
    * - [Column header](@/guides/columns/column-header/column-header.md)
    * - [`columns`](#columns)
    *
    * @memberof Options#
    * @type {string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // set the first column header name to `First name`
    *     title: 'First name',
    *     type: 'text',
    *   },
    *   {
    *     // set the second column header name to `Last name`
    *     title: 'Last name',
    *     type: 'text',
    *   }
    * ],
    * ```
    */
    title: void 0,
    /**
    * The `trimDropdown` option configures the width of the [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * and [`dropdown`](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md) lists.
    *
    * When set to `true` (default), the list is trimmed to match the width of the edited cell,
    * which can truncate long option labels. When set to `false`, the list expands to fit its
    * longest option, which may make the list wider than the cell.
    *
    * You can set the `trimDropdown` option to one of the following:
    *
    * | Setting          | Description                                                                     |
    * | ---------------- | ------------------------------------------------------------------------------- |
    * | `true` (default) | Make the dropdown/autocomplete list's width the same as the edited cell's width |
    * | `false`          | Scale the dropdown/autocomplete list's width to the list's content              |
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [Dropdown cell type](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'autocomplete',
    *     // for each cell of this column
    *     // make the `autocomplete` list's width the same as the edited cell's width
    *     trimDropdown: true,
    *   },
    *   {
    *     type: 'dropdown',
    *     // for each cell of this column
    *     // scale the `dropdown` list's width to the list's content
    *     trimDropdown: false,
    *   }
    * ],
    * ```
    */
    trimDropdown: true,
    /**
    * @description
    * The `trimRows` option configures the [`TrimRows`](@/api/trimRows.md) plugin.
    *
    * You can set the `trimRows` option to one of the following:
    *
    * | Setting                          | Description                                                                                   |
    * | -------------------------------- | --------------------------------------------------------------------------------------------- |
    * | `false`                          | Disable the [`TrimRows`](@/api/trimRows.md) plugin                                            |
    * | `true`                           | Enable the [`TrimRows`](@/api/trimRows.md) plugin                                             |
    * | An array of physical row indexes | - Enable the [`TrimRows`](@/api/trimRows.md) plugin<br>- Trim selected rows at initialization |
    *
    * Read more:
    * - [Plugins: `TrimRows`](@/api/trimRows.md)
    * - [Row trimming](@/guides/rows/row-trimming/row-trimming.md)
    *
    * @memberof Options#
    * @type {boolean|number[]}
    * @default undefined
    * @category TrimRows
    *
    * @example
    * ```js
    * // enable the `TrimRows` plugin
    * trimRows: true,
    *
    * // enable the `TrimRows` plugin
    * // at Handsontable's initialization, trim rows 5, 10, and 15
    * trimRows: [5, 10, 15],
    * ```
    */
    trimRows: void 0,
    /**
    * The `trimWhitespace` option configures automatic whitespace removal. This option
    * affects the cell renderer and the cell editor.
    *
    * You can set the `trimWhitespace` option to one of the following:
    *
    * | Setting          | Description                                                     |
    * | ---------------- | --------------------------------------------------------------- |
    * | `true` (default) | Remove whitespace at the beginning and at the end of each cell |
    * | `false`          | Don't remove whitespace                                         |
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // don't remove whitespace
    *     // from any cell of this column
    *     trimWhitespace: false
    *   }
    * ]
    * ```
    */
    trimWhitespace: true,
    /**
    * @description
    * The `type` option lets you set the [`renderer`](#renderer), [`editor`](#editor), and [`validator`](#validator)
    * options all at once, by selecting a [cell type](@/guides/cell-types/cell-type/cell-type.md).
    *
    * You can set the `type` option to one of the following:
    *
    * | Cell type                                                         | Renderer, editor & validator                                                                                                                                                                                                                       |
    * | ----------------------------------------------------------------- | -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
    * | A [custom cell type](@/guides/cell-types/cell-type/cell-type.md)            | Renderer: your [custom cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md)<br>Editor: your [custom cell editor](@/guides/cell-functions/cell-editor/cell-editor.md)<br>Validator: your [custom cell validator](@/guides/cell-functions/cell-validator/cell-validator.md) |
    * | [`'autocomplete'`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md) | Renderer: `AutocompleteRenderer`<br>Editor: `AutocompleteEditor`<br>Validator: `AutocompleteValidator`                                                                         |
    * | [`'checkbox'`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md)         | Renderer: `CheckboxRenderer`<br>Editor: `CheckboxEditor`<br>Validator: -                                                                                                                               |
    * | [`'date'`](@/guides/cell-types/date-cell-type/date-cell-type.md)                 | Renderer: `DateRenderer`<br>Editor: `DateEditor`<br>Validator: `DateValidator`                                                                                                 |
    * | [`'intl-date'`](@/guides/cell-types/date-cell-type/date-cell-type.md)                 | Renderer: `IntlDateRenderer`<br>Editor: `IntlDateEditor`<br>Validator: `IntlDateValidator`                                                                                                 |
    * | [`'dropdown'`](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md)         | Renderer: `DropdownRenderer`<br>Editor: `DropdownEditor`<br>Validator: `DropdownValidator`                                                                                     |
    * | [`'handsontable'`](@/guides/cell-types/handsontable-cell-type/handsontable-cell-type.md) | Renderer: `AutocompleteRenderer`<br>Editor: `HandsontableEditor`<br>Validator: -                                                                                                                       |
    * | [`'numeric'`](@/guides/cell-types/numeric-cell-type/numeric-cell-type.md)           | Renderer: `NumericRenderer`<br>Editor: `NumericEditor`<br>Validator: `NumericValidator`                                                                                        |
    * | [`'password'`](@/guides/cell-types/password-cell-type/password-cell-type.md)         | Renderer: `PasswordRenderer`<br>Editor: `PasswordEditor`<br>Validator: -                                                                                                                               |
    * | `'text'`                                                          | Renderer: `TextRenderer`<br>Editor: `TextEditor`<br>Validator: -                                                                                                                                       |
    * | [`'time`'](@/guides/cell-types/time-cell-type/time-cell-type.md)                 | Renderer: `TimeRenderer`<br>Editor: `TimeEditor`<br>Validator: `TimeValidator`                                                                                                 |
    * | [`'intl-time'`](@/guides/cell-types/time-cell-type/time-cell-type.md)                 | Renderer: `IntlTimeRenderer`<br>Editor: `IntlTimeEditor`<br>Validator: `IntlTimeValidator`                                                                                                 |
    *
    * Read more:
    * - [Cell type](@/guides/cell-types/cell-type/cell-type.md)
    * - [Cell renderer](@/guides/cell-functions/cell-renderer/cell-renderer.md)
    * - [Cell editor](@/guides/cell-functions/cell-editor/cell-editor.md)
    * - [Cell validator](@/guides/cell-functions/cell-validator/cell-validator.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    * - [`renderer`](#renderer)
    * - [`editor`](#editor)
    * - [`validator`](#validator)
    * - [`valueParser`](#valueparser)
    * - [`valueFormatter`](#valueformatter)
    *
    * @memberof Options#
    * @type {string}
    * @default 'text'
    * @category Core
    *
    * @example
    * ```js
    * // set the `numeric` cell type for each cell of the entire grid
    * type: `'numeric'`,
    *
    * // apply the `type` option to individual columns
    * columns: [
    *   {
    *     // set the `autocomplete` cell type for each cell of this column
    *     type: 'autocomplete'
    *   },
    *   {
    *     // set the `myCustomCellType` cell type for each cell of this column
    *     type: 'myCustomCellType'
    *   }
    * ]
    * ```
    */
    type: "text",
    /**
    * The `uncheckedTemplate` option lets you configure what value
    * an unchecked [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cell has.
    *
    * You can set the `uncheckedTemplate` option to one of the following:
    *
    * | Setting           | Description                                                                                                                                                                                |
    * | ----------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
    * | `false` (default) | If a [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cell is unchecked,<br>the [`getDataAtCell`](@/api/core.md#getDataAtCell) method for this cell returns `false`                 |
    * | A string          | If a [`checkbox`](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md) cell is unchecked,<br>the [`getDataAtCell`](@/api/core.md#getDataAtCell) method for this cell returns a string of your choice |
    *
    * ::: warning
    * When you set `uncheckedTemplate` to a custom string value (e.g. `'No'`), using `false` in your data source to
    * represent an unchecked state is no longer valid. Only the exact custom string value matches an unchecked checkbox.
    * Pair `uncheckedTemplate` with [`checkedTemplate`](#checkedTemplate) to define both states explicitly.
    * :::
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [Checkbox cell type: Checkbox template](@/guides/cell-types/checkbox-cell-type/checkbox-cell-type.md#checkbox-template)
    * - [`getDataAtCell()`](@/api/core.md#getDataAtCell)
    * - [`checkedTemplate`](#checkedTemplate)
    *
    * @memberof Options#
    * @type {boolean|string|number}
    * @default false
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     // set the `type` of each cell in this column to `checkbox`
    *     // when unchecked, the cell's value is `false`
    *     // when checked, the cell's value is `true`
    *     type: 'checkbox',
    *   },
    *   {
    *     // set the `type` of each cell in this column to `checkbox`
    *     // when unchecked, the cell's value is `'No'`
    *     // when checked, the cell's value is `'Yes'`
    *     type: 'checkbox',
    *     uncheckedTemplate: 'No'
    *     checkedTemplate: 'Yes',
    *  }
    * ],
    * ```
    */
    uncheckedTemplate: void 0,
    /**
    * The `undo` option configures the [`UndoRedo`](@/api/undoRedo.md) plugin.
    *
    * You can set the `undo` option to one of the following:
    *
    * | Setting | Description                                        |
    * | ------- | -------------------------------------------------- |
    * | `true`  | Enable the [`UndoRedo`](@/api/undoRedo.md) plugin  |
    * | `false` | Disable the [`UndoRedo`](@/api/undoRedo.md) plugin |
    *
    * By default, the `undo` option is set to `true`,
    * To disable the [`UndoRedo`](@/api/undoRedo.md) plugin completely,
    * set the `undo` option to `false`.
    *
    * Read more:
    * - [Undo and redo](@/guides/accessories-and-menus/undo-redo/undo-redo.md)
    *
    * @memberof Options#
    * @type {boolean}
    * @default undefined
    * @category UndoRedo
    *
    * @example
    * ```js
    * // enable the `UndoRedo` plugin
    * undo: true,
    * ```
    */
    undo: true,
    /**
    * @description
    * The `validator` option sets a [cell validator](@/guides/cell-functions/cell-validator/cell-validator.md) for a cell.
    *
    * You can set the `validator` option to one of the following:
    *
    * | Setting              | Description                                                                      |
    * | -------------------- | -------------------------------------------------------------------------------- |
    * | A string             | A [cell validator alias](@/guides/cell-functions/cell-validator/cell-validator.md)              |
    * | A function           | Your [custom cell validator function](@/guides/cell-functions/cell-validator/cell-validator.md) |
    * | A regular expression | A regular expression used for cell validation                                    |
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * By setting the `validator` option to a string,
    * you can use one of the following [cell validator aliases](@/guides/cell-functions/cell-validator/cell-validator.md):
    *
    * | Alias               | Cell validator function                                                 |
    * | ------------------- | ----------------------------------------------------------------------- |
    * | A custom alias      | Your [custom cell validator](@/guides/cell-functions/cell-validator/cell-validator.md) |
    * | `'autocomplete'`    | `AutocompleteValidator`                                                 |
    * | `'date'`            | `DateValidator`                                                         |
    * | `'intl-date'`       | `IntlDateValidator`                                                     |
    * | `'dropdown'`        | `DropdownValidator`                                                     |
    * | `'numeric'`         | `NumericValidator`                                                      |
    * | `'time'`            | `TimeValidator`                                                         |
    * | `'intl-time'`       | `IntlTimeValidator`                                                     |
    *
    * To set the [`editor`](#editor), [`renderer`](#renderer), and [`validator`](#validator)
    * options all at once, use the [`type`](#type) option.
    *
    * Read more:
    * - [Cell validator](@/guides/cell-functions/cell-validator/cell-validator.md)
    * - [Cell type](@/guides/cell-types/cell-type/cell-type.md)
    * - [Configuration options: Cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration)
    * - [`type`](#type)
    *
    * @memberof Options#
    * @type {Function|RegExp|string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *    {
    *      // use a built-in `numeric` cell validator
    *      validator: 'numeric'
    *    },
    *    {
    *      // validate against a regular expression
    *      validator: /^[0-9]$/
    *    },
    *    {
    *      // add a custom cell validator function
    *      validator(value, callback) {
    *          ...
    *      }
    *    },
    * ],
    * ```
    */
    validator: void 0,
    /**
    * @description
    * The [`sourceDataValidator`](@/api/options.md#sourcedatavalidator) option sets a function that validates values
    * when they are written to the source data layer. Validation runs on table initialization and when calling
    * [`loadData`](@/api/core.md#loaddata), [`updateData`](@/api/core.md#updatedata), or
    * [`setSourceDataAtCell`](@/api/core.md#setsourcedataatcell). It does not run for the `setData*` family of methods.
    *
    * Return `true` from the function to mark the value as valid, or `false` to mark it invalid. When a value is
    * invalid and [`allowInvalid`](@/api/options.md#allowinvalid) is `false`, it is replaced with `null` in the
    * source (on initialization and when calling `loadData` or `updateData`). When `allowInvalid` is `true`, invalid
    * values are kept; a warning is still logged when the validator returns `false`. An exception:
    * [`setSourceDataAtCell`](@/api/core.md#setsourcedataatcell) - when the validator returns `false`, the write is
    * skipped and the cell is not nullified; the previous value in the source remains unchanged. Use
    * [`allowEmpty`](@/api/options.md#allowempty) to treat `null`, `undefined`, or `''` as valid when appropriate.
    *
    * Optionally set [`sourceDataWarningMessage`](@/api/options.md#sourcedatawarningmessage) to customize the
    * message logged for invalid values.
    *
    * @example
    * ```js
    * sourceDataWarningMessage: 'The source data is invalid.',
    * sourceDataValidator: (value, cellMeta) => {
    *   if (cellMeta.allowEmpty && value == null) {
    *     return true;
    *   }
    *
    *   if (typeof value === 'string') {
    *     return true;
    *   }
    *
    *   return false;
    * }
    * ```
    *
    * @memberof Options#
    * @since 17.0.0
    * @type {function(*, CellMeta): (boolean)}
    * @default undefined
    * @category Core
    */
    sourceDataValidator: void 0,
    /**
    * @description
    * The [`sourceDataWarningMessage`](@/api/options.md#sourcedatawarningmessage) option sets the message used when
    * a value fails [`sourceDataValidator`](@/api/options.md#sourcedatavalidator). When not set, no message is logged.
    *
    * @example
    * ```js
    * sourceDataWarningMessage: 'The source data is invalid.',
    * ```
    *
    * @memberof Options#
    * @since 17.0.0
    * @type {string}
    * @default undefined
    * @category Core
    */
    sourceDataWarningMessage: void 0,
    /**
    * @description
    * The `valueGetter` option configures a function that defines what value will be used when displaying the cell content.
    * It can be used to modify the value of a cell before it is displayed (for example, for object-based data).
    *
    * @example
    * ```js
    * // use the `label` property of the value object with a fallback to the value itself
    * valueGetter: (value, row, column, cellMeta) => {
    *   return value?.label ?? value;
    * }
    * ```
    *
    * @memberof Options#
    * @type {function(*, number, number): *}
    * @param {*} value The value to be displayed in the cell.
    * @param {number} row The visual row index of the cell.
    * @param {number} column The visual column index of the cell.
    * @param {object} cellMeta The cell meta object.
    * @since 16.1.0
    * @default undefined
    * @category Core
    */
    valueGetter: void 0,
    /**
    * @description
    * The `valueSetter` option configures a function that defines what value will be used when setting the cell content.
    * It can be used to modify the value of a cell before it is saved (for example, for object-based data).
    *
    * @example
    * ```js
    * // Modify the value of a cell before it is saved
    * valueSetter: (value, row, column, cellMeta) => {
    *   return { id: value?.id ?? value, value: `${value?.value ?? value} at ${row}, ${column}` }
    * },
    * ```
    *
    * @memberof Options#
    * @type {function(*, number, number): *}
    * @param {*} value The value to be set to a cell.
    * @param {number} row The visual row index of the cell.
    * @param {number} column The visual column index of the cell.
    * @param {object} cellMeta The cell meta object.
    * @since 16.1.0
    * @default undefined
    * @category Core
    */
    valueSetter: void 0,
    /**
    * @description
    * The `viewportColumnRenderingOffset` option configures the number of columns
    * to be rendered outside of the grid's viewport.
    *
    * You can set the `viewportColumnRenderingOffset` option to one of the following:
    *
    * | Setting            | Description                                             |
    * | ------------------ | ------------------------------------------------------- |
    * | `auto` (default)   | Use the offset calculated automatically by Handsontable |
    * | A number           | Set the offset manually                                 |
    *
    * The `viewportColumnRenderingOffset` setting is ignored when [`renderAllColumns`](#renderAllColumns) is set to `true`.
    *
    * Read more:
    * - [Performance: Define the number of pre-rendered rows and columns](@/guides/optimization/performance/performance.md#define-the-number-of-pre-rendered-rows-and-columns)
    *
    * @memberof Options#
    * @type {number|'auto'}
    * @default 'auto'
    * @category Core
    *
    * @example
    * ```js
    * // render 70 columns outside of the grid's viewport
    * viewportColumnRenderingOffset: 70,
    * ```
    */
    viewportColumnRenderingOffset: "auto",
    /**
    * @description
    * The `viewportRowRenderingOffset` option configures the number of rows
    * to be rendered outside of the grid's viewport.
    *
    * You can set the `viewportRowRenderingOffset` option to one of the following:
    *
    * | Setting            | Description                                             |
    * | ------------------ | ------------------------------------------------------- |
    * | `auto` (default)   | Use the offset calculated automatically by Handsontable |
    * | A number           | Set the offset manually                                 |
    *
    * The `viewportRowRenderingOffset` setting is ignored when [`renderAllRows`](#renderAllRows) is set to `true`.
    *
    * Read more:
    * - [Performance: Define the number of pre-rendered rows and columns](@/guides/optimization/performance/performance.md#define-the-number-of-pre-rendered-rows-and-columns)
    * - [Column virtualization](@/guides/columns/column-virtualization/column-virtualization.md)
    *
    * @memberof Options#
    * @type {number|'auto'}
    * @default 'auto'
    * @category Core
    *
    * @example
    * ```js
    * // render 70 rows outside of the grid's viewport
    * viewportRowRenderingOffset: 70,
    * ```
    */
    viewportRowRenderingOffset: "auto",
    /**
    * @description
    * The `viewportColumnRenderingThreshold` option configures what column number starting from the left or right
    * (depends on the scroll direction) should trigger the rendering of columns outside of the grid's viewport.
    *
    * You can set the `viewportColumnRenderingThreshold` option to one of the following:
    *
    * | Setting            | Description                                             |
    * | ------------------ | ------------------------------------------------------- |
    * | `auto`             | Triggers rendering at half the offset defined by [`viewportColumnRenderingOffset`](#viewportColumnRenderingOffset) option |
    * | A number           | Sets the offset manually (`0` is a default)             |
    *
    * The `viewportColumnRenderingThreshold` setting is ignored when [`renderAllColumn`](#renderAllColumn) is set to `true`.
    *
    * Read more:
    * - [Performance: Define the number of pre-rendered rows and columns](@/guides/optimization/performance/performance.md#define-the-number-of-pre-rendered-rows-and-columns)
    * - [Column virtualization](@/guides/columns/column-virtualization/column-virtualization.md)
    *
    * @memberof Options#
    * @since 1.14.7
    * @type {number|'auto'}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // render 12 columns outside of the grid's viewport
    * viewportColumnRenderingOffset: 12,
    * // the columns outside of the viewport will be rendered when the user scrolls to the 8th column from/to
    * viewportColumnRenderingThreshold: 8,
    * ```
    */
    viewportColumnRenderingThreshold: 0,
    /**
    * @description
    * The `viewportRowRenderingThreshold` option configures what row number starting from the top or bottom
    * (depends on the scroll direction) should trigger the rendering of rows outside of the grid's viewport.
    *
    * You can set the `viewportRowRenderingThreshold` option to one of the following:
    *
    * | Setting            | Description                                             |
    * | ------------------ | ------------------------------------------------------- |
    * | `auto`             | Triggers rendering at half the offset defined by [`viewportRowRenderingOffset`](#viewportRowRenderingOffset) option |
    * | A number           | Sets the offset manually (`0` is a default)             |
    *
    * The `viewportRowRenderingThreshold` setting is ignored when [`renderAllRows`](#renderAllRows) is set to `true`.
    *
    * Read more:
    * - [Performance: Define the number of pre-rendered rows and columns](@/guides/optimization/performance/performance.md#define-the-number-of-pre-rendered-rows-and-columns)
    * - [Row virtualization](@/guides/rows/row-virtualization/row-virtualization.md)
    *
    * @memberof Options#
    * @since 1.14.7
    * @type {number|'auto'}
    * @default 0
    * @category Core
    *
    * @example
    * ```js
    * // render 12 rows outside of the grid's viewport
    * viewportRowRenderingOffset: 12,
    * // the rows outside of the viewport will be rendered when the user scrolls to the 8th row from/to
    * viewportRowRenderingThreshold: 8,
    * ```
    */
    viewportRowRenderingThreshold: 0,
    /**
    * The `visibleRows` option sets the height of the [`autocomplete`](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * , [`dropdown`](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md) and [`multiSelect`](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md)-typed cells' lists.
    *
    * When the number of list options exceeds the `visibleRows` number, a scrollbar appears.
    *
    * ::: tip
    * If the grid has a fixed [`height`](#height) set, the dropdown list may be visually constrained by the available
    * space and show fewer rows than the `visibleRows` value. In such cases, the list is clipped to fit within the grid.
    * :::
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [Autocomplete cell type](@/guides/cell-types/autocomplete-cell-type/autocomplete-cell-type.md)
    * - [Dropdown cell type](@/guides/cell-types/dropdown-cell-type/dropdown-cell-type.md)
    * - [MultiSelect cell type](@/guides/cell-types/multiselect-cell-type/multiselect-cell-type.md)
    *
    * @memberof Options#
    * @type {number}
    * @default 10
    * @category Core
    *
    * @example
    * ```js
    * columns: [
    *   {
    *     type: 'autocomplete',
    *     // set the `autocomplete` list's height to 15 options
    *     // for each cell of this column
    *     visibleRows: 15,
    *   },
    *   {
    *     type: 'dropdown',
    *     // set the `dropdown` list's height to 5 options
    *     // for each cell of this column
    *     visibleRows: 5,
    *   },
    *   {
    *     type: 'multiselect',
    *     // set the `multiSelect` list's height to 5 options
    *     // for each cell of this column
    *     visibleRows: 5,
    *   }
    * ],
    * ```
    */
    visibleRows: 10,
    /**
    * The `width` option configures the width of your grid.
    *
    * You can set the `width` option to one of the following:
    *
    * | Setting                                                                    | Example                   |
    * | -------------------------------------------------------------------------- | ------------------------- |
    * | A number of pixels                                                         | `width: 500`              |
    * | A string with a [CSS unit](https://www.w3schools.com/cssref/css_units.asp) | `width: '75vw'`           |
    * | `'auto'`                                                                   | `width: 'auto'`           |
    * | A function that returns a valid number or string                           | `width() { return 500; }` |
    *
    * With `width: 'auto'`, Handsontable writes `width: auto` as an inline style on the root
    * element. The grid then follows the width of its parent container. Use this value when
    * you want the grid to stay flexible horizontally while still setting an explicit
    * [`height`](#height).
    *
    * ::: tip
    * For horizontal scrolling to work, you must also set the [`height`](#height) option in Handsontable's configuration.
    * Setting `width` alone (without `height`) does not activate the scrollable viewport.
    * Setting the height via inline CSS on the container element is not supported - use the `height` configuration option instead.
    * :::
    *
    * Read more:
    * - [Grid size](@/guides/getting-started/grid-size/grid-size.md)
    *
    * @memberof Options#
    * @type {number|'auto'|string|Function}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // set the grid's width to 500px
    * width: 500,
    *
    * // set the grid's width to 75vw
    * width: '75vw',
    *
    * // let the grid follow its parent container's width
    * width: 'auto',
    *
    * // set the grid's width to 500px, using a function
    * width() {
    *   return 500;
    * },
    * ```
    */
    width: void 0,
    /**
    * The `wordWrap` option configures whether content that exceeds a column's width is wrapped or not.
    *
    * You can set the `wordWrap` option to one of the following:
    *
    * | Setting          | Description                                             |
    * | ---------------- | ------------------------------------------------------- |
    * | `true` (default) | If content exceeds the column's width, wrap the content |
    * | `false`          | Don't wrap content                                      |
    *
    * To style cells that don't wrap content, use the [`noWordWrapClassName`](#noWordWrapClassName) option.
    *
    * ::: tip
    * Word wrapping only applies to content that contains spaces or other soft-wrap opportunities.
    * A long unbroken string without spaces (e.g. a URL or a continuous number sequence) does not wrap
    * regardless of this setting.
    * :::
    *
    * This option can be set at any level of the [cascading configuration](@/guides/getting-started/configuration-options/configuration-options.md#cascading-configuration):
    * the [grid level](@/guides/getting-started/configuration-options/configuration-options.md#set-grid-options), the [`columns`](#columns) level, the [`cells`](#cells) level, and the [`cell`](#cell) level.
    *
    * Read more:
    * - [`noWordWrapClassName`](#noWordWrapClassName)
    *
    * @memberof Options#
    * @type {boolean}
    * @default true
    * @category Core
    *
    * @example
    * ```js
    * // set column width for every column of the entire grid
    * colWidths: 100,
    *
    * columns: [
    *   {
    *     // don't wrap content in this column
    *     wordWrap: false,
    *   },
    *   {
    *     // if content exceeds this column's width, wrap the content
    *     wordWrap: true,
    *   }
    * ],
    * ```
    */
    wordWrap: true,
    /**
    * The `sanitizer` option configures the function used to sanitize HTML before it is written to the DOM.
    * Whenever Handsontable sets HTML (e.g. cell content, headers, context menu labels, dialog content,
    * paste from clipboard), it can pass the string through this function first. Sanitization is important
    * when content comes from users or external sources to prevent XSS (e.g. script injection, event handlers).
    *
    * By default (when no sanitizer is set), HTML is applied as-is (pass-through). You are responsible for
    * XSS protection. Set a sanitizer when you need to allow rich content while stripping or neutralizing
    * dangerous markup.
    *
    * The function receives the raw HTML string and an optional second argument (source) indicating where
    * the content is used (e.g. `'innerHTML'`, `'CopyPaste.paste'`), so you can apply different rules per source.
    * It must return a string that is safe to assign to `innerHTML`.
    *
    * This option is only respected when set in the table settings. It does not work when defined per column
    * or per cell (e.g. in `columns` or cell meta).
    *
    * @since 17.0.0
    * @memberof Options#
    * @type {function(string, string): string}
    * @default undefined
    * @category Core
    *
    * @example
    * ```js
    * // Allowlist-based sanitization using a custom library
    * sanitizer: (content, source) => myLibrary.sanitize(content),
    * ```
    *
    * @example
    * ```js
    * // Maximum safety: strip all tags and escape output (no rich HTML)
    * sanitizer: (content, source) => {
    *   const tpl = document.createElement('template');
    *
    *   tpl.innerHTML = content;
    *
    *   const text = tpl.content.textContent ?? '';
    *
    *   return text
    *     .replace(/&/g, '&amp;')
    *     .replace(/</g, '&lt;')
    *     .replace(/>/g, '&gt;')
    *     .replace(/"/g, '&quot;')
    *     .replace(/'/g, '&#39;');
    * },
    * ```
    *
    * @example
    * ```js
    * // Trusted Types: wrap sanitization in a policy so the sink accepts the result.
    * // Add the policy name to the CSP trusted-types directive (e.g. trusted-types default handsontable).
    * const policy = window.trustedTypes?.createPolicy('handsontable', {
    *   createHTML: (input) => myLibrary.sanitize(input),
    * });
    *
    * sanitizer: (content, source) =>
    *   policy ? policy.createHTML(content) : myLibrary.sanitize(content),
    * ```
    */
    sanitizer: void 0,
    /**
    * The `parsePastedValue` option determines how pasted content is written to cells when the user pastes
    * from the clipboard into Handsontable (e.g. from another Handsontable instance or between cells in the same table).
    * It does not affect how other applications read or process the clipboard.
    *
    * When set to `false`, pasted content is written as plain strings. Non-scalar values (e.g. objects) are coerced
    * to string, so an object becomes `"[object Object]"`.
    *
    * When set to `true`, pasted text is parsed so that JSON-like (or other supported) values are converted to
    * JavaScript values and written to the data source. This allows copying and pasting more sophisticated JavaScript
    * structures (e.g. objects, arrays) between cells and between Handsontable instances. Cells then store the resulting
    * object (e.g. `{ id: 1, value: 'A1' }`). Schema validation is relaxed so object-based values can be pasted into
    * cells that would normally expect a scalar.
    *
    * You can set the `parsePastedValue` option to one of the following:
    *
    * | Setting           | Description                                      |
    * | ----------------- | ------------------------------------------------ |
    * | `false` (default) | Write pasted content as plain strings            |
    * | `true`            | Parse pasted text and write JavaScript values    |
    *
    * @since 17.0.0
    * @memberof Options#
    * @type {boolean}
    * @default false
    * @category CopyPaste
    *
    * @example
    * ```js
    * // write pasted content as strings (objects become "[object Object]")
    * parsePastedValue: false,
    * ```
    *
    * @example
    * ```js
    * // parse pasted text so cells receive JavaScript objects when pasted content is object-like
    * parsePastedValue: true,
    * ```
    */
    parsePastedValue: false
  };
});
function createTableMetaEmptyClass() {
  return class TableMeta {
  };
}
class GlobalMeta {
  /**
  * Gets constructor of the global meta object. Necessary for inheritance for creating the next meta layers.
  *
  * @returns {Function}
  */
  getMetaConstructor() {
    return this.metaCtor;
  }
  /**
  * Gets settings object for this layer.
  *
  * @returns {object}
  */
  getMeta() {
    return this.meta;
  }
  /**
  * Updates global settings object by merging settings with the current state.
  *
  * @param {object} settings An object to merge with.
  */
  updateMeta(settings) {
    extend(this.meta, settings);
    extendByMetaType(this.meta, {
      ...settings,
      type: settings.type ?? this.meta.type
    }, settings);
  }
  /**
  * Initializes the global meta layer, populates the meta prototype with schema defaults, and attaches the Handsontable instance reference.
  */
  constructor(hot) {
    this.metaCtor = createTableMetaEmptyClass();
    this.meta = this.metaCtor.prototype;
    extend(this.meta, metaSchemaFactory());
    this.meta.instance = hot;
  }
}
class TableMeta {
  /**
  * Gets settings object for this layer.
  *
  * @returns {TableMeta}
  */
  getMeta() {
    return this.meta;
  }
  /**
  * Updates table settings object by merging settings with the current state.
  *
  * @param {object} settings An object to merge with.
  */
  updateMeta(settings) {
    extend(this.meta, settings);
    extendByMetaType(this.meta, settings, settings);
  }
  /**
  * Initializes the table meta layer by instantiating a new meta object from the GlobalMeta constructor.
  */
  constructor(globalMeta) {
    const MetaCtor = globalMeta.getMetaConstructor();
    this.meta = new MetaCtor();
  }
}
class LazyFactoryMap {
  /**
  * Gets or if data not exist creates and returns new data.
  *
  * @param {number} key The item key as zero-based index.
  * @returns {*}
  */
  obtain(key) {
    assert(() => isUnsignedNumber(key), "Expecting an unsigned number.");
    const dataIndex = this._getStorageIndexByKey(key);
    let result;
    if (dataIndex >= 0) {
      result = this.data[dataIndex];
      if (result === void 0) {
        result = this.valueFactory(key);
        this.data[dataIndex] = result;
      }
    } else {
      result = this.valueFactory(key);
      const reuseIndex = this.holes.size > 0 ? this.holes.values().next().value : void 0;
      if (reuseIndex !== void 0) {
        this.holes.delete(reuseIndex);
        this.data[reuseIndex] = result;
        this.index[key] = reuseIndex;
      } else {
        this.data.push(result);
        this.index[key] = this.data.length - 1;
      }
    }
    return result;
  }
  /**
  * Inserts an empty data to the map. This method creates an empty space for obtaining
  * new data.
  *
  * @param {number} key The key as volatile zero-based index at which to begin inserting space for new data.
  * @param {number} [amount=1] Amount of data to insert.
  */
  insert(key, amount = 1) {
    assert(() => isUnsignedNumber(key) || isNullish(key), "Expecting an unsigned number or null/undefined argument.");
    const newIndexes = [];
    const dataLength = this.data.length;
    for (let i = 0; i < amount; i++) {
      newIndexes.push(dataLength + i);
      this.data.push(void 0);
    }
    const insertionIndex = isNullish(key) ? this.index.length : key;
    this.index = [
      ...this.index.slice(0, insertionIndex),
      ...newIndexes,
      ...this.index.slice(insertionIndex)
    ];
  }
  /**
  * Removes (soft remove) data from "index" and according to the amount of data.
  *
  * @param {number} key The key as volatile zero-based index at which to begin removing the data.
  * @param {number} [amount=1] Amount data to remove.
  */
  remove(key, amount = 1) {
    assert(() => isUnsignedNumber(key) || isNullish(key), "Expecting an unsigned number or null/undefined argument.");
    const removed = this.index.splice(isNullish(key) ? this.index.length - amount : key, amount);
    for (let i = 0; i < removed.length; i++) {
      const removedIndex = removed[i];
      if (typeof removedIndex === "number") {
        this.holes.add(removedIndex);
      }
    }
  }
  /**
  * Returns the size of the data which this map holds.
  *
  * @returns {number}
  */
  size() {
    return this.data.length - this.holes.size;
  }
  /**
  * Returns a new Iterator object that contains the values for each item in the LazyMap object.
  *
  * @returns {Iterator}
  */
  values() {
    return this.data.filter((meta, index2) => meta !== void 0 && !this.holes.has(index2))[Symbol.iterator]();
  }
  /**
  * Returns a new Iterator object that contains an array of `[index, value]` for each item in the LazyMap object.
  *
  * @returns {Iterator}
  */
  entries() {
    const validEntries = [];
    for (let i = 0; i < this.data.length; i++) {
      const keyIndex = this._getKeyByStorageIndex(i);
      const item = this.data[i];
      if (keyIndex !== -1 && item !== void 0) {
        validEntries.push([
          keyIndex,
          item
        ]);
      }
    }
    let dataIndex = 0;
    const iterator = {
      next() {
        if (dataIndex < validEntries.length) {
          const value = validEntries[dataIndex];
          dataIndex += 1;
          return {
            value,
            done: false
          };
        }
        return {
          done: true,
          value: void 0
        };
      },
      [Symbol.iterator]() {
        return iterator;
      }
    };
    return iterator;
  }
  /**
  * Clears the map.
  */
  clear() {
    this.data = [];
    this.index = [];
    this.holes.clear();
  }
  /**
  * Gets storage index calculated from the key associated with the specified value.
  *
  * @param {number} key Volatile zero-based index.
  * @returns {number} Returns index 0-N or -1 if no storage index found.
  */
  _getStorageIndexByKey(key) {
    return this.index.length > key ? this.index[key] : -1;
  }
  /**
  * Gets the key associated with the specified value calculated from storage index.
  *
  * @param {number} dataIndex Zero-based storage index.
  * @returns {number} Returns index 0-N or -1 if no key found.
  */
  _getKeyByStorageIndex(dataIndex) {
    return this.index.indexOf(dataIndex);
  }
  /**
  * Makes this object iterable.
  *
  * @returns {Iterator}
  */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
  * Initializes the map with the given factory function used to create values for new keys on first access.
  */
  constructor(valueFactory) {
    this.data = [];
    this.index = [];
    this.holes = /* @__PURE__ */ new Set();
    this.valueFactory = valueFactory;
  }
}
const COLUMNS_PROPS_CONFLICTS = [
  "data",
  "width"
];
class ColumnMeta {
  /**
  * Updates column meta object by merging settings with the current state.
  *
  * @param {number} physicalColumn The physical column index which points what column meta object is updated.
  * @param {object} settings An object to merge with.
  */
  updateMeta(physicalColumn, settings) {
    const meta = this.getMeta(physicalColumn);
    extend(meta, settings);
    extendByMetaType(meta, settings);
  }
  /**
  * Creates one or more columns at specific position.
  *
  * @param {number} physicalColumn The physical column index which points from what position the column is added.
  * @param {number} amount An amount of columns to add.
  */
  createColumn(physicalColumn, amount) {
    this.metas.insert(physicalColumn, amount);
  }
  /**
  * Removes one or more columns from the collection.
  *
  * @param {number} physicalColumn The physical column index which points from what position the column is removed.
  * @param {number} amount An amount columns to remove.
  */
  removeColumn(physicalColumn, amount) {
    this.metas.remove(physicalColumn, amount);
  }
  /**
  * Gets settings object for this layer.
  *
  * @param {number} physicalColumn The physical column index.
  * @returns {object}
  */
  getMeta(physicalColumn) {
    return this.metas.obtain(physicalColumn);
  }
  /**
  * Gets constructor of the column meta object. Necessary for inheritance - creating the next meta layers.
  *
  * @param {number} physicalColumn The physical column index.
  * @returns {Function}
  */
  getMetaConstructor(physicalColumn) {
    return this.metas.obtain(physicalColumn).constructor;
  }
  /**
  * Clears all saved column meta objects.
  */
  clearCache() {
    this.metas.clear();
  }
  /**
  * Creates and returns new column meta object with properties inherited from the global meta layer.
  *
  * @private
  * @returns {object}
  */
  _createMeta() {
    const factory = columnFactory(this.globalMeta.getMetaConstructor(), COLUMNS_PROPS_CONFLICTS);
    return factory.prototype;
  }
  /**
  * Initializes the column meta layer with a reference to the GlobalMeta layer and sets up the lazy map for per-column meta objects.
  */
  constructor(globalMeta) {
    this.metas = new LazyFactoryMap(() => this._createMeta());
    this.globalMeta = globalMeta;
    this.metas = new LazyFactoryMap(() => this._createMeta());
  }
}
function _check_private_redeclaration$1n(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1b(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1b(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1b(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1b(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1b(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1b(receiver, descriptor);
}
function _class_private_field_init$1b(obj, privateMap, value) {
  _check_private_redeclaration$1n(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1b(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1b(receiver, privateMap, "set");
  _class_apply_descriptor_set$1b(receiver, descriptor, value);
  return value;
}
var _userDefinedMetaRecordingSuspendCount = /* @__PURE__ */ new WeakMap();
class CellMeta {
  /**
  * Resumes tracking of user-defined cell meta properties by closing one suspension scope opened by
  * `disableUserDefinedMetaRecording`. Recording becomes active again only once every suspension has
  * been closed. Subsequent `setMeta` calls then mark their keys as user-defined, so they are
  * preserved across `updateSettings`.
  */
  enableUserDefinedMetaRecording() {
    if (_class_private_field_get$1b(this, _userDefinedMetaRecordingSuspendCount) > 0) {
      _class_private_field_set$1b(this, _userDefinedMetaRecordingSuspendCount, _class_private_field_get$1b(this, _userDefinedMetaRecordingSuspendCount) - 1);
    }
  }
  /**
  * Suspends tracking of user-defined cell meta properties. While suspended, `setMeta` calls are
  * treated as declarative writes and de-mark their keys, so they are not preserved across
  * `updateSettings`. Suspensions nest - each call must be matched by an `enableUserDefinedMetaRecording`
  * call before recording resumes.
  */
  disableUserDefinedMetaRecording() {
    _class_private_field_set$1b(this, _userDefinedMetaRecordingSuspendCount, _class_private_field_get$1b(this, _userDefinedMetaRecordingSuspendCount) + 1);
  }
  /**
  * Updates cell meta object by merging settings with the current state.
  *
  * @param {number} physicalRow The physical row index which points what cell meta object is updated.
  * @param {number} physicalColumn The physical column index which points what cell meta object is updated.
  * @param {object} settings An object to merge with.
  */
  updateMeta(physicalRow, physicalColumn, settings) {
    const meta = this.getMeta(physicalRow, physicalColumn);
    extend(meta, settings);
    extendByMetaType(meta, settings);
  }
  /**
  * Creates one or more rows at specific position.
  *
  * @param {number} physicalRow The physical row index which points from what position the row is added.
  * @param {number} amount An amount of rows to add.
  */
  createRow(physicalRow, amount) {
    this.metas.insert(physicalRow, amount);
  }
  /**
  * Creates one or more columns at specific position.
  *
  * @param {number} physicalColumn The physical column index which points from what position the column is added.
  * @param {number} amount An amount of columns to add.
  */
  createColumn(physicalColumn, amount) {
    for (let i = 0; i < this.metas.size(); i++) {
      this.metas.obtain(i).insert(physicalColumn, amount);
    }
  }
  /**
  * Removes one or more rows from the collection.
  *
  * @param {number} physicalRow The physical row index which points from what position the row is removed.
  * @param {number} amount An amount of rows to remove.
  */
  removeRow(physicalRow, amount) {
    this.metas.remove(physicalRow, amount);
  }
  /**
  * Removes one or more columns from the collection.
  *
  * @param {number} physicalColumn The physical column index which points from what position the column is removed.
  * @param {number} amount An amount of columns to remove.
  */
  removeColumn(physicalColumn, amount) {
    for (let i = 0; i < this.metas.size(); i++) {
      this.metas.obtain(i).remove(physicalColumn, amount);
    }
  }
  /**
  * Returns the cell meta object or a specific property value from it, depending on whether a key is provided.
  */
  getMeta(physicalRow, physicalColumn, key) {
    const cellMeta = this.metas.obtain(physicalRow).obtain(physicalColumn);
    if (key === void 0) {
      return cellMeta;
    }
    return cellMeta[key];
  }
  /**
  * Sets settings object for this layer defined by "key" property.
  *
  * @param {number} physicalRow The physical row index.
  * @param {number} physicalColumn The physical column index.
  * @param {string} key The property name to set.
  * @param {*} value Value to save.
  */
  setMeta(physicalRow, physicalColumn, key, value) {
    const cellMeta = this.metas.obtain(physicalRow).obtain(physicalColumn);
    cellMeta._automaticallyAssignedMetaProps?.delete(key);
    cellMeta[key] = value;
    if (_class_private_field_get$1b(this, _userDefinedMetaRecordingSuspendCount) === 0) {
      if (cellMeta._userDefinedMetaProps === void 0) {
        cellMeta._userDefinedMetaProps = /* @__PURE__ */ new Set();
      }
      cellMeta._userDefinedMetaProps.add(key);
    } else {
      cellMeta._userDefinedMetaProps?.delete(key);
    }
  }
  /**
  * Removes a property defined by the "key" argument from the cell meta object.
  *
  * @param {number} physicalRow The physical row index.
  * @param {number} physicalColumn The physical column index.
  * @param {string} key The property name to remove.
  */
  removeMeta(physicalRow, physicalColumn, key) {
    const cellMeta = this.metas.obtain(physicalRow).obtain(physicalColumn);
    delete cellMeta[key];
    cellMeta._userDefinedMetaProps?.delete(key);
  }
  /**
  * Returns all cell meta objects that were created during the Handsontable operation. As cell meta
  * objects are created lazy, the length of the returned collection depends on how and when the
  * table has asked for access to that meta objects.
  *
  * @returns {object[]}
  */
  getMetas() {
    const metas = [];
    const rows = Array.from(this.metas.values());
    for (let row = 0; row < rows.length; row++) {
      if (isDefined(rows[row])) {
        metas.push(...Array.from(rows[row].values()));
      }
    }
    return metas;
  }
  /**
  * Returns all cell meta objects that were created during the Handsontable operation but for
  * specific row index.
  *
  * @param {number} physicalRow The physical row index.
  * @returns {object[]}
  */
  getMetasAtRow(physicalRow) {
    assert(() => isUnsignedNumber(physicalRow), "Expecting an unsigned number.");
    const rowsMeta = new Map(this.metas);
    if (!rowsMeta.has(physicalRow)) {
      return [];
    }
    return Array.from(rowsMeta.get(physicalRow)).sort(([a], [b]) => a - b).map(([, meta]) => meta);
  }
  /**
  * Returns a flat snapshot of all cell meta properties that were set imperatively through
  * `setMeta` (tracked in each cell's `_userDefinedMetaProps`). The coordinates are read from the
  * map keys (physical indexes), not from the meta object's `row`/`col` properties, which are only
  * populated on `getCellMeta` and become stale after row or column shifts. Used to preserve
  * user-defined meta across a cache clear during `updateSettings`.
  *
  * @returns {{physicalRow: number, physicalColumn: number, key: string, value: *}[]}
  */
  getUserDefinedMetas() {
    const result = [];
    for (const [physicalRow, rowMap] of this.metas) {
      for (const [physicalColumn, meta] of rowMap) {
        const userDefinedProps = meta._userDefinedMetaProps;
        if (userDefinedProps === void 0) {
          continue;
        }
        userDefinedProps.forEach((key) => {
          if (hasOwnProperty(meta, key)) {
            result.push({
              physicalRow,
              physicalColumn,
              key,
              value: meta[key]
            });
          }
        });
      }
    }
    return result;
  }
  /**
  * Clears all saved cell meta objects.
  */
  clearCache() {
    this.metas.clear();
  }
  /**
  * Creates and returns new structure for cell meta objects stored in columnar axis.
  *
  * @private
  * @returns {object}
  */
  _createRow() {
    return new LazyFactoryMap((physicalColumn) => this._createMeta(physicalColumn));
  }
  /**
  * Creates and returns new cell meta object with properties inherited from the column meta layer.
  *
  * @private
  * @param {number} physicalColumn The physical column index.
  * @returns {object}
  */
  _createMeta(physicalColumn) {
    const ColumnMeta2 = this.columnMeta.getMetaConstructor(physicalColumn);
    return new ColumnMeta2();
  }
  /**
  * Initializes the cell meta layer with a reference to the ColumnMeta layer used as the prototype source for new cell meta objects.
  */
  constructor(columnMeta) {
    _class_private_field_init$1b(this, _userDefinedMetaRecordingSuspendCount, {
      writable: true,
      value: void 0
    });
    this.metas = new LazyFactoryMap(() => this._createRow());
    _class_private_field_set$1b(this, _userDefinedMetaRecordingSuspendCount, 0);
    this.columnMeta = columnMeta;
  }
}
class MetaManager {
  /**
  * Gets the global meta object that is a root of all default settings, which are recognizable by Handsontable.
  * Other layers inherites all properties from this. Adding, removing, or changing property in that
  * object has a direct reflection to all layers.
  *
  * @returns {object}
  */
  getGlobalMeta() {
    return this.globalMeta.getMeta();
  }
  /**
  * Updates global settings object by merging settings with the current state.
  *
  * @param {object} settings An object to merge with.
  */
  updateGlobalMeta(settings) {
    this.globalMeta.updateMeta(settings);
  }
  /**
  * Gets settings object that was passed in the Handsontable constructor. That layer contains all
  * default settings inherited from the GlobalMeta layer merged with settings passed by the developer.
  * Adding, removing, or changing property in that object has no direct reflection on any other layers.
  *
  * @returns {TableMeta}
  */
  getTableMeta() {
    return this.tableMeta.getMeta();
  }
  /**
  * Updates table settings object by merging settings with the current state.
  *
  * @param {object} settings An object to merge with.
  */
  updateTableMeta(settings) {
    this.tableMeta.updateMeta(settings);
  }
  /**
  * Gets column meta object that is a root of all settings defined in the column property of the Handsontable
  * settings. Each column in the Handsontable is associated with a unique meta object which identified by
  * the physical column index. Adding, removing, or changing property in that object has a direct reflection
  * only for the CellMeta layer. The reflection will be visible only if the property doesn't exist in the lower
  * layers (prototype lookup).
  *
  * @param {number} physicalColumn The physical column index.
  * @returns {object}
  */
  getColumnMeta(physicalColumn) {
    return this.columnMeta.getMeta(physicalColumn);
  }
  /**
  * Updates column meta object by merging settings with the current state.
  *
  * @param {number} physicalColumn The physical column index which points what column meta object is updated.
  * @param {object} settings An object to merge with.
  */
  updateColumnMeta(physicalColumn, settings) {
    this.columnMeta.updateMeta(physicalColumn, settings);
  }
  /**
  * Gets the cell meta object that is a root of all settings defined for the specific cell rendered by
  * the Handsontable. Each cell meta inherits settings from higher layers. When a property doesn't
  * exist in that layer, it is looked up through a prototype to the highest layer. Starting
  * from CellMeta -> ColumnMeta and ending to GlobalMeta, which stores default settings. Adding,
  * removing, or changing property in that object has no direct reflection on any other layers.
  *
  * @param {number} physicalRow The physical row index.
  * @param {number} physicalColumn The physical column index.
  * @param {object} options Options for the `getCellMeta` method.
  * @param {number} options.visualRow The visual row index of the currently requested cell meta object.
  * @param {number} options.visualColumn The visual column index of the currently requested cell meta object.
  * @param {boolean} [options.skipMetaExtension=false] If `true`, omits the `afterGetCellMeta` hook which calls the `extendCellMeta` method.
  * @returns {object}
  */
  getCellMeta(physicalRow, physicalColumn, options) {
    const cellMeta = this.cellMeta.getMeta(physicalRow, physicalColumn);
    cellMeta.visualRow = options.visualRow;
    cellMeta.visualCol = options.visualColumn;
    cellMeta.row = physicalRow;
    cellMeta.col = physicalColumn;
    if (!options.skipMetaExtension) {
      this.runLocalHooks("afterGetCellMeta", cellMeta);
    }
    return cellMeta;
  }
  /**
  * Gets a value (defined by the `key` property) from the cell meta object.
  *
  * @param {number} physicalRow The physical row index.
  * @param {number} physicalColumn The physical column index.
  * @param {string} key Defines the value that will be returned from the cell meta object.
  * @returns {*}
  */
  getCellMetaKeyValue(physicalRow, physicalColumn, key) {
    if (typeof key !== "string") {
      throwWithCause("The passed cell meta object key is not a string");
    }
    return this.cellMeta.getMeta(physicalRow, physicalColumn, key);
  }
  /**
  * Sets settings object for cell meta object defined by "key" property.
  *
  * @param {number} physicalRow The physical row index.
  * @param {number} physicalColumn The physical column index.
  * @param {string} key The property name to set.
  * @param {*} value Value to save.
  */
  setCellMeta(physicalRow, physicalColumn, key, value) {
    this.cellMeta.setMeta(physicalRow, physicalColumn, key, value);
  }
  /**
  * Updates cell meta object by merging settings with the current state.
  *
  * @param {number} physicalRow The physical row index which points what cell meta object is updated.
  * @param {number} physicalColumn The physical column index which points what cell meta object is updated.
  * @param {object} settings An object to merge with.
  */
  updateCellMeta(physicalRow, physicalColumn, settings) {
    this.cellMeta.updateMeta(physicalRow, physicalColumn, settings);
  }
  /**
  * Removes a property defined by the "key" argument from the cell meta object.
  *
  * @param {number} physicalRow The physical row index.
  * @param {number} physicalColumn The physical column index.
  * @param {string} key The property name to remove.
  */
  removeCellMeta(physicalRow, physicalColumn, key) {
    this.cellMeta.removeMeta(physicalRow, physicalColumn, key);
  }
  /**
  * Returns all cell meta objects that were created during the Handsontable operation. As cell meta
  * objects are created lazy, the length of the returned collection depends on how and when the
  * table has asked for access to that meta objects.
  *
  * @returns {object[]}
  */
  getCellsMeta() {
    return this.cellMeta.getMetas();
  }
  /**
  * Returns all cell meta objects that were created during the Handsontable operation but for
  * specific row index.
  *
  * @param {number} physicalRow The physical row index.
  * @returns {object[]}
  */
  getCellsMetaAtRow(physicalRow) {
    return this.cellMeta.getMetasAtRow(physicalRow);
  }
  /**
  * Returns a flat snapshot of all cell meta properties that were set imperatively through
  * `setCellMeta` (for example, by the user or by the context menu), keyed by physical coordinates.
  * Used to preserve user-defined meta across a `clearCache` call during `updateSettings`.
  *
  * @returns {{physicalRow: number, physicalColumn: number, key: string, value: *}[]}
  */
  getUserDefinedCellMetas() {
    return this.cellMeta.getUserDefinedMetas();
  }
  /**
  * Enables tracking of user-defined cell meta properties set through `setCellMeta`.
  */
  enableUserDefinedMetaRecording() {
    this.cellMeta.enableUserDefinedMetaRecording();
  }
  /**
  * Disables tracking of user-defined cell meta properties. Writes made while disabled are treated
  * as declarative (for example, the `cell` option applied during `updateSettings`).
  */
  disableUserDefinedMetaRecording() {
    this.cellMeta.disableUserDefinedMetaRecording();
  }
  /**
  * Creates one or more rows at specific position.
  *
  * @param {number} physicalRow The physical row index which points from what position the row is added.
  * @param {number} [amount=1] An amount of rows to add.
  */
  createRow(physicalRow, amount = 1) {
    this.cellMeta.createRow(physicalRow, amount);
  }
  /**
  * Removes one or more rows from the collection.
  *
  * @param {number} physicalRow The physical row index which points from what position the row is removed.
  * @param {number} [amount=1] An amount rows to remove.
  */
  removeRow(physicalRow, amount = 1) {
    this.cellMeta.removeRow(physicalRow, amount);
  }
  /**
  * Creates one or more columns at specific position.
  *
  * @param {number} physicalColumn The physical column index which points from what position the column is added.
  * @param {number} [amount=1] An amount of columns to add.
  */
  createColumn(physicalColumn, amount = 1) {
    this.cellMeta.createColumn(physicalColumn, amount);
    this.columnMeta.createColumn(physicalColumn, amount);
  }
  /**
  * Removes one or more columns from the collection.
  *
  * @param {number} physicalColumn The physical column index which points from what position the column is removed.
  * @param {number} [amount=1] An amount of columns to remove.
  */
  removeColumn(physicalColumn, amount = 1) {
    this.cellMeta.removeColumn(physicalColumn, amount);
    this.columnMeta.removeColumn(physicalColumn, amount);
  }
  /**
  * Clears all saved cell meta objects. It keeps column meta, table meta, and global meta intact.
  */
  clearCellsCache() {
    this.cellMeta.clearCache();
  }
  /**
  * Clears all saved cell and columns meta objects.
  */
  clearCache() {
    this.cellMeta.clearCache();
    this.columnMeta.clearCache();
  }
  /**
  * Initializes all meta layers, applies custom settings to global meta, and instantiates any meta modifier classes.
  */
  constructor(hot, customSettings = {}, metaMods = []) {
    this.hot = hot;
    this.globalMeta = new GlobalMeta(hot);
    this.tableMeta = new TableMeta(this.globalMeta);
    this.columnMeta = new ColumnMeta(this.globalMeta);
    this.cellMeta = new CellMeta(this.columnMeta);
    metaMods.forEach((ModifierClass) => new ModifierClass(this));
    this.globalMeta.updateMeta(customSettings);
  }
}
mixin(MetaManager, localHooks);
function _check_private_redeclaration$1m(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1a(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1a(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1a(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1a(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1a(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1a(receiver, descriptor);
}
function _class_private_field_init$1a(obj, privateMap, value) {
  _check_private_redeclaration$1m(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1a(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1a(receiver, privateMap, "set");
  _class_apply_descriptor_set$1a(receiver, descriptor, value);
  return value;
}
var _initOnlyCallback = /* @__PURE__ */ new WeakMap();
class ExtendMetaPropertiesMod {
  /**
  * Extends the meta options based on the object descriptors from the `propDescriptors` list.
  */
  extendMetaProps() {
    this.propDescriptors.forEach((descriptor, alias) => {
      const { initOnly, target, onChange: onChange2 } = descriptor;
      const hasTarget = typeof target === "string";
      const targetProp = hasTarget ? target : alias;
      const origProp = `_${targetProp}`;
      this.metaManager.globalMeta.meta[origProp] = this.metaManager.globalMeta.meta[targetProp];
      if (onChange2) {
        this.installPropWatcher(alias, origProp, onChange2);
        if (hasTarget) {
          this.installPropWatcher(target, origProp, onChange2);
        }
      } else if (initOnly) {
        this.installPropWatcher(alias, origProp, _class_private_field_get$1a(this, _initOnlyCallback));
        if (!this.metaManager.globalMeta.meta._initOnlySettings) {
          this.metaManager.globalMeta.meta._initOnlySettings = [];
        }
        this.metaManager.globalMeta.meta._initOnlySettings.push(alias);
      }
    });
  }
  /**
  * Installs the property watcher to the `propName` option and forwards getter and setter to
  * the new one.
  *
  * @param {string} propName The property to watch.
  * @param {string} origProp The property from/to the value is forwarded.
  * @param {Function} onChange The callback.
  */
  installPropWatcher(propName, origProp, onChange2) {
    const { usageTracker } = this;
    const boundOnChange = onChange2.bind(this);
    Object.defineProperty(this.metaManager.globalMeta.meta, propName, {
      get() {
        return this[origProp];
      },
      set(value) {
        const isInitialChange = !usageTracker.has(propName);
        usageTracker.add(propName);
        boundOnChange(propName, value, isInitialChange);
        this[origProp] = value;
      },
      enumerable: true,
      configurable: true
    });
  }
  /**
  * Initializes the modifier with a reference to the MetaManager and immediately extends the global meta with calculated property values.
  */
  constructor(metaManager) {
    _class_private_field_init$1a(this, _initOnlyCallback, {
      writable: true,
      value: void 0
    });
    this.usageTracker = /* @__PURE__ */ new Set();
    this.propDescriptors = /* @__PURE__ */ new Map([
      [
        "ariaTags",
        {
          initOnly: true
        }
      ],
      [
        "fixedColumnsLeft",
        {
          target: "fixedColumnsStart",
          onChange(propName) {
            const isRtl2 = this.metaManager.hot.isRtl();
            if (isRtl2 && propName === "fixedColumnsLeft") {
              throwWithCause("The `fixedColumnsLeft` is not supported for RTL. Please use option `fixedColumnsStart`.");
            }
            if (this.usageTracker.has("fixedColumnsLeft") && this.usageTracker.has("fixedColumnsStart")) {
              throwWithCause("The `fixedColumnsLeft` and `fixedColumnsStart` should not be used together. Please use only the option `fixedColumnsStart`.");
            }
          }
        }
      ],
      [
        "layoutDirection",
        {
          initOnly: true
        }
      ],
      [
        "renderAllColumns",
        {
          initOnly: true
        }
      ],
      [
        "renderAllRows",
        {
          initOnly: true
        }
      ]
    ]);
    _class_private_field_set$1a(this, _initOnlyCallback, (propName, value, isInitialChange) => {
      if (!isInitialChange) {
        throwWithCause(`The \`${propName}\` option can not be updated after the Handsontable is initialized.`);
      }
    });
    this.metaManager = metaManager;
    this.extendMetaProps();
  }
}
class DynamicCellMetaMod {
  /**
  * Extends the cell meta object by user-specific properties.
  *
  * The cell meta object can be extended dynamically,
  * either by Handsontable's hooks (`beforeGetCellMeta` and`afterGetCellMeta`),
  * or by Handsontable's `cells` option.
  *
  * To boost performance, the extending process is triggered only once per one slow Handsontable render cycle.
  *
  * @param {object} cellMeta The cell meta object.
  */
  extendCellMeta(cellMeta) {
    const physicalRow = cellMeta.row;
    const physicalColumn = cellMeta.col;
    if (this.metaSyncMemo.get(physicalRow)?.has(physicalColumn)) {
      return;
    }
    const visualRow = cellMeta.visualRow;
    const visualCol = cellMeta.visualCol;
    const hot = this.metaManager.hot;
    const prop = hot.colToProp(visualCol);
    cellMeta.prop = prop;
    hot.runHooks("beforeGetCellMeta", visualRow, visualCol, cellMeta);
    const cellType = hasOwnProperty(cellMeta, "type") ? cellMeta.type : null;
    let cellSettings = isFunction$1(cellMeta.cells) ? cellMeta.cells(physicalRow, physicalColumn, prop) : null;
    if (cellType) {
      if (cellSettings) {
        cellSettings.type = cellSettings.type ?? cellType;
      } else {
        cellSettings = {
          type: cellType
        };
      }
    }
    if (cellSettings) {
      this.metaManager.updateCellMeta(physicalRow, physicalColumn, cellSettings);
    }
    hot.runHooks("afterGetCellMeta", visualRow, visualCol, cellMeta);
    if (!this.metaSyncMemo.has(physicalRow)) {
      this.metaSyncMemo.set(physicalRow, /* @__PURE__ */ new Set());
    }
    this.metaSyncMemo.get(physicalRow).add(physicalColumn);
  }
  /**
  * Initializes the modifier, registers the `afterGetCellMeta` local hook, and subscribes to `beforeRender` to clear the memo on full renders.
  */
  constructor(metaManager) {
    this.metaSyncMemo = /* @__PURE__ */ new Map();
    this.metaManager = metaManager;
    metaManager.addLocalHook("afterGetCellMeta", (...args) => {
      this.extendCellMeta(args[0]);
    });
    Hooks.getSingleton().add("beforeRender", (forceFullRender) => {
      if (forceFullRender) {
        this.metaSyncMemo.clear();
      }
    }, this.metaManager.hot);
  }
}
function runSourceDataValidator(value, cellMeta, source) {
  const validator = cellMeta.sourceDataValidator;
  if (!isFunction$1(validator)) {
    return true;
  }
  const isValid = validator(value, cellMeta, source);
  if (isValid === true) {
    return true;
  }
  const { row, col, sourceDataWarningMessage, allowInvalid } = cellMeta;
  if (sourceDataWarningMessage) {
    logSourceDataWarning(sourceDataWarningMessage, [
      {
        row,
        col,
        value
      }
    ]);
  }
  return allowInvalid === true;
}
function validateSourceCell(cellMeta, value, physicalRow, physicalColumn, dataSource, invalidByMessageType, source) {
  const validator = cellMeta.sourceDataValidator;
  if (!isFunction$1(validator)) {
    return;
  }
  const isValid = validator(value, cellMeta, source);
  if (isValid === true) {
    return;
  }
  if (cellMeta.allowInvalid === false) {
    dataSource.setAtCell(physicalRow, physicalColumn, null);
  }
  const message = cellMeta.sourceDataWarningMessage;
  if (message) {
    const list = invalidByMessageType.get(message) ?? [];
    list.push({
      row: physicalRow,
      col: physicalColumn,
      value,
      message
    });
    invalidByMessageType.set(message, list);
  }
}
function collectColumnValidators(hotInstance, colSourceCount) {
  const sampleVisualRow = hotInstance.rowIndexMapper.getVisualFromPhysicalIndex(0);
  if (sampleVisualRow === null) {
    return {
      fullScan: true,
      columns: []
    };
  }
  const columns = [];
  for (let physicalColumn = 0; physicalColumn < colSourceCount; physicalColumn += 1) {
    const visualColumn = hotInstance.columnIndexMapper.getVisualFromPhysicalIndex(physicalColumn);
    if (visualColumn === null) {
      continue;
    }
    const cellMeta = hotInstance.getCellMeta(sampleVisualRow, visualColumn);
    const validator = cellMeta.sourceDataValidator;
    if (!isFunction$1(validator)) {
      continue;
    }
    if (validator.rowIndependent !== true) {
      return {
        fullScan: true,
        columns: []
      };
    }
    columns.push({
      physicalColumn,
      cellMeta
    });
  }
  return {
    fullScan: false,
    columns
  };
}
function validatePerCell(hotInstance, dataSource, rowSourceCount, colSourceCount, invalidByMessageType, source) {
  const { rowIndexMapper, columnIndexMapper } = hotInstance;
  for (let row = 0; row < rowSourceCount; row += 1) {
    for (let col = 0; col < colSourceCount; col += 1) {
      const visualRow = rowIndexMapper.getVisualFromPhysicalIndex(row);
      const visualColumn = columnIndexMapper.getVisualFromPhysicalIndex(col);
      if (visualRow === null || visualColumn === null) {
        continue;
      }
      const cellMeta = hotInstance.getCellMeta(visualRow, visualColumn);
      if (!isFunction$1(cellMeta.sourceDataValidator)) {
        continue;
      }
      const value = dataSource.getAtCell(row, col);
      validateSourceCell(cellMeta, value, row, col, dataSource, invalidByMessageType, source);
    }
  }
}
function validateBatched(columns, dataSource, rowSourceCount, toVisualRow, invalidByMessageType, source) {
  for (let row = 0; row < rowSourceCount; row += 1) {
    if (toVisualRow(row) === null) {
      continue;
    }
    for (let i = 0; i < columns.length; i += 1) {
      const { physicalColumn, cellMeta } = columns[i];
      const value = dataSource.getAtCell(row, physicalColumn);
      validateSourceCell(cellMeta, value, row, physicalColumn, dataSource, invalidByMessageType, source);
    }
  }
}
function hasRowVaryingMeta(hotInstance, settings) {
  return isFunction$1(settings.cells) || Array.isArray(settings.cell) && settings.cell.length > 0 || hotInstance.hasHook("beforeGetCellMeta") || hotInstance.hasHook("afterGetCellMeta") || hotInstance._getMetaManager().getUserDefinedCellMetas().length > 0;
}
function runSourceDataValidators(hotInstance, source) {
  const rowSourceCount = hotInstance.countSourceRows();
  const colSourceCount = hotInstance.countSourceCols();
  if (rowSourceCount === 0 || colSourceCount === 0) {
    return;
  }
  const settings = hotInstance.getSettings();
  const dataSource = hotInstance._getDataSource();
  const invalidByMessageType = /* @__PURE__ */ new Map();
  if (hasRowVaryingMeta(hotInstance, settings)) {
    validatePerCell(hotInstance, dataSource, rowSourceCount, colSourceCount, invalidByMessageType, source);
  } else {
    const { fullScan, columns } = collectColumnValidators(hotInstance, colSourceCount);
    if (fullScan) {
      validatePerCell(hotInstance, dataSource, rowSourceCount, colSourceCount, invalidByMessageType, source);
    } else {
      const toVisualRow = (row) => hotInstance.rowIndexMapper.getVisualFromPhysicalIndex(row);
      validateBatched(columns, dataSource, rowSourceCount, toVisualRow, invalidByMessageType, source);
    }
  }
  invalidByMessageType.forEach((items, message) => {
    logSourceDataWarning(message, items);
  });
}
function logSourceDataWarning(message, items) {
  logAggregatedItems({
    logFunction: warn$1,
    message,
    items,
    itemFormatter: (item) => {
      const { row, col, value } = item;
      const rawValue = stringify$1(value);
      const shortValue = rawValue.length > 64 ? `${rawValue.slice(0, 64)}...` : rawValue;
      return `row ${row}, col ${col}, value: "${shortValue}"`;
    }
  });
}
function buildNullData(hotInstance, newDataMap, tableMeta) {
  const dataSchema = newDataMap.getSchema();
  const data = [];
  for (let r = 0, rlen = tableMeta.startRows; r < rlen; r++) {
    let row;
    if ((hotInstance.dataType === "object" || hotInstance.dataType === "function") && tableMeta.dataSchema) {
      row = deepClone(dataSchema);
    } else if (hotInstance.dataType === "array") {
      row = deepClone(dataSchema[0]);
    } else {
      row = [];
      for (let c = 0, clen = tableMeta.startCols; c < clen; c++) {
        row.push(null);
      }
    }
    data.push(row);
  }
  return data;
}
function replaceData(data, setDataMapFunction, callbackFunction, config) {
  const { hotInstance, dataMap, dataSource, internalSource, source, metaManager, firstRun } = config;
  const capitalizedInternalSource = toUpperCaseFirst(internalSource);
  const tableMeta = hotInstance.getSettings();
  if (Array.isArray(tableMeta.dataSchema)) {
    hotInstance.dataType = "array";
  } else if (isFunction$1(tableMeta.dataSchema)) {
    hotInstance.dataType = "function";
  } else {
    hotInstance.dataType = "object";
  }
  if (dataMap) {
    dataMap.destroy();
  }
  data = hotInstance.runHooks(`before${capitalizedInternalSource}`, data, firstRun, source);
  const newDataMap = new DataMap(hotInstance, data, metaManager);
  setDataMapFunction(newDataMap);
  if (typeof data === "object" && data !== null) {
    if (!(data.push && data.splice)) {
      data = [
        data
      ];
    }
  } else if (data === null) {
    data = buildNullData(hotInstance, newDataMap, tableMeta);
  } else {
    throwWithCause(`${internalSource} only accepts array of objects or array of arrays (${typeof data} given)`);
  }
  if (Array.isArray(data[0])) {
    hotInstance.dataType = "array";
  }
  tableMeta.data = data;
  newDataMap.dataSource = data;
  dataSource.data = data;
  dataSource.dataType = hotInstance.dataType;
  dataSource.colToProp = (column) => newDataMap.colToProp(column);
  dataSource.propToCol = (prop) => newDataMap.propToCol(prop);
  dataSource.countCachedColumns = newDataMap.countCachedColumns.bind(newDataMap);
  callbackFunction(newDataMap);
  if (!firstRun) {
    runSourceDataValidators(hotInstance, internalSource);
  }
  hotInstance.runHooks(`after${capitalizedInternalSource}`, data, firstRun, source);
  if (!firstRun) {
    hotInstance.runHooks("afterChange", null, internalSource);
    hotInstance.view.adjustElementsSize();
    hotInstance.render();
  }
  if (hotInstance.getSettings().ariaTags) {
    setAttribute(hotInstance.rootElement, [
      A11Y_ROWCOUNT(-1),
      // If run after initialization, add the number of row headers.
      A11Y_COLCOUNT(hotInstance.countCols() + (hotInstance.view ? hotInstance.countRowHeaders() : 0))
    ]);
  }
}
function _check_private_redeclaration$1l(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$19(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$19(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$19(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$19(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$19(receiver, privateMap, "get");
  return _class_apply_descriptor_get$19(receiver, descriptor);
}
function _class_private_field_init$19(obj, privateMap, value) {
  _check_private_redeclaration$1l(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$19(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$19(receiver, privateMap, "set");
  _class_apply_descriptor_set$19(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$Y(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$Y(obj, privateSet) {
  _check_private_redeclaration$1l(obj, privateSet);
  privateSet.add(obj);
}
var _rowIndexMapper$1 = /* @__PURE__ */ new WeakMap(), _columnIndexMapper$1 = /* @__PURE__ */ new WeakMap(), _getNearestNotHiddenCoords = /* @__PURE__ */ new WeakSet(), _getNearestNotHiddenIndex = /* @__PURE__ */ new WeakSet();
class CellRangeToRenderableMapper {
  /**
  * Converts the visual coordinates of the CellRange instance to the renderable coordinates.
  *
  * @param {CellRange} range The CellRange instance with defined visual coordinates.
  * @returns {CellRange | null}
  */
  toRenderable(range) {
    const rowDirection = range.getVerticalDirection() === "N-S" ? 1 : -1;
    const columnDirection = range.getHorizontalDirection() === "W-E" ? 1 : -1;
    const from = _class_private_method_get$Y(this, _getNearestNotHiddenCoords, getNearestNotHiddenCoords).call(this, range.from, rowDirection, columnDirection);
    if (from === null) {
      return null;
    }
    const to = _class_private_method_get$Y(this, _getNearestNotHiddenCoords, getNearestNotHiddenCoords).call(this, range.to, -rowDirection, -columnDirection);
    if (to === null) {
      return null;
    }
    const newRange = range.clone();
    newRange.from = from;
    newRange.to = to;
    if (!newRange.includes(range.highlight)) {
      newRange.highlight = from;
    }
    return newRange;
  }
  /**
  * Initializes the mapper with the row and column IndexMapper instances used to resolve renderable coordinates.
  */
  constructor({ rowIndexMapper, columnIndexMapper }) {
    _class_private_method_init$Y(this, _getNearestNotHiddenCoords);
    _class_private_method_init$Y(this, _getNearestNotHiddenIndex);
    _class_private_field_init$19(this, _rowIndexMapper$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$19(this, _columnIndexMapper$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$19(this, _rowIndexMapper$1, rowIndexMapper);
    _class_private_field_set$19(this, _columnIndexMapper$1, columnIndexMapper);
  }
}
function getNearestNotHiddenCoords(coords, rowSearchDirection, columnSearchDirection = rowSearchDirection) {
  if (coords.row === null || coords.col === null) {
    return null;
  }
  const nextVisibleRow = _class_private_method_get$Y(this, _getNearestNotHiddenIndex, getNearestNotHiddenIndex).call(this, _class_private_field_get$19(this, _rowIndexMapper$1), coords.row, rowSearchDirection);
  if (nextVisibleRow === null) {
    return null;
  }
  const nextVisibleColumn = _class_private_method_get$Y(this, _getNearestNotHiddenIndex, getNearestNotHiddenIndex).call(this, _class_private_field_get$19(this, _columnIndexMapper$1), coords.col, columnSearchDirection);
  if (nextVisibleColumn === null) {
    return null;
  }
  return coords.clone().assign({
    row: nextVisibleRow,
    col: nextVisibleColumn
  });
}
function getNearestNotHiddenIndex(indexMapper, visualIndex, searchDirection) {
  if (visualIndex < 0) {
    return visualIndex;
  }
  return indexMapper.getNearestNotHiddenIndex(visualIndex, searchDirection);
}
function scrollWindowToCell(element) {
  if (isHTMLElement(element)) {
    element.scrollIntoView({
      block: "nearest",
      inline: "nearest"
    });
  }
}
function createScrollTargetCalculator(hotInstance) {
  const { selection, view } = hotInstance;
  const cellRange = hotInstance.getSelectedRangeActive();
  const source = selection.getSelectionSource();
  const firstVisibleColumn = view.getFirstFullyVisibleColumn() ?? -1;
  const lastVisibleColumn = view.getLastFullyVisibleColumn() ?? -1;
  const selectionFirstColumn = cellRange?.getTopStartCorner().col ?? -1;
  const selectionLastColumn = cellRange?.getBottomEndCorner().col ?? -1;
  const isSelectionOutsideStartViewport = selectionFirstColumn <= firstVisibleColumn;
  const isSelectionOutsideEndViewport = selectionLastColumn >= lastVisibleColumn;
  const firstVisibleRow = view.getFirstFullyVisibleRow() ?? -1;
  const lastVisibleRow = view.getLastFullyVisibleRow() ?? -1;
  const selectionFirstRow = cellRange?.getTopStartCorner().row ?? -1;
  const selectionLastRow = cellRange?.getBottomEndCorner().row ?? -1;
  const isSelectionOutsideTopViewport = selectionFirstRow <= firstVisibleRow;
  const isSelectionOutsideBottomViewport = selectionLastRow >= lastVisibleRow;
  return {
    /**
    * Calculates the target column for scrolling.
    *
    * @param {CellCoords} lastSelectionCoords The last selection coordinates.
    * @returns {number}
    */
    getComputedColumnTarget(lastSelectionCoords) {
      if (source === "mouse" || source === "keyboard") {
        return lastSelectionCoords.col ?? -1;
      }
      if (isSelectionOutsideStartViewport && isSelectionOutsideEndViewport) {
        return cellRange?.highlight.col ?? -1;
      }
      if (isSelectionOutsideStartViewport) {
        return selectionFirstColumn;
      }
      if (isSelectionOutsideEndViewport) {
        return selectionLastColumn;
      }
      return lastSelectionCoords.col ?? -1;
    },
    /**
    * Calculates the target row for scrolling.
    *
    * @param {CellCoords} lastSelectionCoords The last selection coordinates.
    * @returns {number}
    */
    getComputedRowTarget(lastSelectionCoords) {
      if (source === "mouse" || source === "keyboard") {
        return lastSelectionCoords.row ?? -1;
      }
      if (isSelectionOutsideTopViewport && isSelectionOutsideBottomViewport) {
        return cellRange?.highlight.row ?? -1;
      }
      if (isSelectionOutsideTopViewport) {
        return selectionFirstRow;
      }
      if (isSelectionOutsideBottomViewport) {
        return selectionLastRow;
      }
      return lastSelectionCoords.row ?? -1;
    }
  };
}
function columnHeaderScrollStrategy(hot) {
  return (cellCoords) => {
    const scrollColumnTarget = createScrollTargetCalculator(hot).getComputedColumnTarget(cellCoords);
    hot.scrollViewportTo({
      col: scrollColumnTarget
    }, () => {
      const hasColumnHeaders = !!hot.getSettings().colHeaders;
      scrollWindowToCell(hot.getCell(hasColumnHeaders ? -1 : 0, scrollColumnTarget, true));
    });
  };
}
function cornerHeaderScrollStrategy(_hot2) {
  return () => {
  };
}
function focusScrollStrategy(hot) {
  return (cellCoords) => {
    hot.scrollViewportTo(cellCoords.toObject(), () => {
      const activeRange = hot.getSelectedRangeActive();
      if (!activeRange) {
        return;
      }
      const { row, col } = activeRange.highlight;
      if (row !== null && col !== null) {
        scrollWindowToCell(hot.getCell(row, col, true));
      }
    });
  };
}
function multipleScrollStrategy(hot) {
  return (cellCoords) => {
    const scrollTargetCalc = createScrollTargetCalculator(hot);
    const targetScroll = {
      row: scrollTargetCalc.getComputedRowTarget(cellCoords),
      col: scrollTargetCalc.getComputedColumnTarget(cellCoords)
    };
    hot.scrollViewportTo(targetScroll, () => {
      const { row, col } = targetScroll;
      scrollWindowToCell(hot.getCell(row, col, true));
    });
  };
}
function noncontiguousScrollStrategy(hot) {
  return (cellCoords) => {
    const scrollTargetCalc = createScrollTargetCalculator(hot);
    const targetScroll = {
      row: scrollTargetCalc.getComputedRowTarget(cellCoords),
      col: scrollTargetCalc.getComputedColumnTarget(cellCoords)
    };
    hot.scrollViewportTo(targetScroll, () => {
      const { row, col } = targetScroll;
      scrollWindowToCell(hot.getCell(row, col, true));
    });
  };
}
function rowHeaderScrollStrategy(hot) {
  return (cellCoords) => {
    const scrollRowTarget = createScrollTargetCalculator(hot).getComputedRowTarget(cellCoords);
    hot.scrollViewportTo({
      row: scrollRowTarget
    }, () => {
      const hasRowHeaders = !!hot.getSettings().rowHeaders;
      scrollWindowToCell(hot.getCell(scrollRowTarget, hasRowHeaders ? -1 : 0, true));
    });
  };
}
function singleScrollStrategy(hot) {
  return (cellCoords) => {
    const selectionSource = hot.selection.getSelectionSource();
    const { row, col } = cellCoords;
    const scrollWindow = () => {
      scrollWindowToCell(hot.getCell(row, col, true));
    };
    if (row < 0 && col >= 0) {
      hot.scrollViewportTo({
        col
      }, scrollWindow);
    } else if (col < 0 && row >= 0) {
      hot.scrollViewportTo({
        row
      }, scrollWindow);
    } else {
      if (selectionSource === "mouse") {
        if (col === hot.view.getLastPartiallyVisibleColumn() || row === hot.view.getLastPartiallyVisibleRow()) {
          return;
        }
      }
      hot.scrollViewportTo({
        row,
        col
      }, scrollWindow);
    }
  };
}
function createViewportScroller(hot) {
  const { selection } = hot;
  let skipNextCall = false;
  let isSuspended = false;
  return {
    resume() {
      isSuspended = false;
    },
    suspend() {
      isSuspended = true;
    },
    skipNextScrollCycle() {
      skipNextCall = true;
    },
    scrollTo(cellCoords) {
      if (skipNextCall || isSuspended) {
        skipNextCall = false;
        return;
      }
      let scrollStrategy;
      if (selection.isFocusSelectionChanged()) {
        scrollStrategy = focusScrollStrategy(hot);
      } else if (selection.isSelectedByCorner()) {
        scrollStrategy = cornerHeaderScrollStrategy();
      } else if (selection.isSelectedByRowHeader()) {
        scrollStrategy = rowHeaderScrollStrategy(hot);
      } else if (selection.isSelectedByColumnHeader()) {
        scrollStrategy = columnHeaderScrollStrategy(hot);
      } else if (selection.getSelectedRange().size() === 1 && selection.isMultiple()) {
        scrollStrategy = multipleScrollStrategy(hot);
      } else if (selection.getSelectedRange().size() === 1 && !selection.isMultiple()) {
        scrollStrategy = singleScrollStrategy(hot);
      } else if (selection.getSelectedRange().size() > 1) {
        scrollStrategy = noncontiguousScrollStrategy(hot);
      }
      scrollStrategy?.(cellCoords);
    }
  };
}
const SCOPE_TYPES = Object.freeze({
  INLINE: "inline",
  MODAL: "modal"
});
const FOCUS_SOURCES = Object.freeze({
  UNKNOWN: "unknown",
  CLICK: "click",
  TAB_FROM_ABOVE: "tab_from_above",
  TAB_FROM_BELOW: "tab_from_below"
});
const DEFAULT_SHORTCUTS_CONTEXT = "grid";
function installFocusDetector(hot, wrapperElement) {
  const inputTrapTop = createInputElement(hot, FOCUS_SOURCES.TAB_FROM_ABOVE);
  const inputTrapBottom = createInputElement(hot, FOCUS_SOURCES.TAB_FROM_BELOW);
  wrapperElement.prepend(inputTrapTop);
  wrapperElement.append(inputTrapBottom);
  return {
    /**
    * Activates the detector by resetting the tabIndex of the input elements.
    */
    activate() {
      inputTrapTop.tabIndex = 0;
      inputTrapBottom.tabIndex = 0;
    },
    /**
    * Deactivates the detector by setting tabIndex to -1.
    */
    deactivate() {
      inputTrapTop.tabIndex = -1;
      inputTrapBottom.tabIndex = -1;
    },
    /**
    * Destroys the focus detector.
    */
    destroy() {
      inputTrapTop.remove();
      inputTrapBottom.remove();
    }
  };
}
function createInputElement(hot, focusSource) {
  const rootDocument = hot.rootDocument;
  const catcher = rootDocument.createElement("div");
  catcher.style.display = "none";
  catcher.classList.add("htFocusCatcher");
  catcher.dataset.htFocusSource = focusSource;
  return catcher;
}
function createFocusScope(hotInstance, container, options = {}) {
  const mergedOptions = {
    shortcutsContextName: DEFAULT_SHORTCUTS_CONTEXT,
    type: SCOPE_TYPES.INLINE,
    contains: (target) => target === container || container.contains(target),
    runOnlyIf: () => true,
    enableFocusCatchers: true,
    ...options
  };
  const focusCatchers = mergedOptions.enableFocusCatchers === false ? null : installFocusDetector(hotInstance, container);
  const contains2 = (target) => {
    return mergedOptions.contains(target);
  };
  const deactivateFocusCatchers = () => {
    focusCatchers?.deactivate();
  };
  const activateFocusCatchers = () => {
    focusCatchers?.activate();
  };
  const activate2 = (activationSource = FOCUS_SOURCES.UNKNOWN) => {
    mergedOptions.onActivate?.(activationSource);
  };
  const deactivate = () => {
    mergedOptions.onDeactivate?.();
  };
  const enable = () => {
    container.removeAttribute("inert");
  };
  const disable = () => {
    container.setAttribute("inert", "true");
  };
  const destroy = () => {
    focusCatchers?.destroy();
  };
  return {
    getType: () => mergedOptions.type,
    hasContainerDetached: () => !hotInstance.rootWrapperElement.contains(container),
    getShortcutsContextName: () => mergedOptions.shortcutsContextName,
    runOnlyIf: () => mergedOptions.runOnlyIf(),
    contains: contains2,
    activate: activate2,
    deactivate,
    activateFocusCatchers,
    deactivateFocusCatchers,
    enable,
    disable,
    destroy
  };
}
function useEventListener(ownerWindow, hooks = {}) {
  let mouseDown2 = false;
  function handleFocus(event) {
    if (!mouseDown2) {
      hooks.onFocus?.(event);
    }
  }
  function handleClick(event) {
    hooks.onClick?.(event);
  }
  function handleKeyDown(event) {
    if (event.key === "Tab") {
      hooks.onTabKeyDown?.(event);
    }
  }
  function handleMouseDown() {
    mouseDown2 = true;
  }
  function handleMouseUp() {
    mouseDown2 = false;
  }
  const mount = () => {
    let frameWindow = ownerWindow;
    while (frameWindow) {
      const { documentElement } = frameWindow.document;
      documentElement.addEventListener("focusin", handleFocus);
      documentElement.addEventListener("click", handleClick);
      documentElement.addEventListener("keydown", handleKeyDown);
      documentElement.addEventListener("mousedown", handleMouseDown);
      documentElement.addEventListener("mouseup", handleMouseUp);
      frameWindow = getParentWindow(frameWindow);
    }
  };
  const unmount = () => {
    let frameWindow = ownerWindow;
    while (frameWindow) {
      const { documentElement } = frameWindow.document;
      documentElement.removeEventListener("focusin", handleFocus);
      documentElement.removeEventListener("click", handleClick);
      documentElement.removeEventListener("keydown", handleKeyDown);
      documentElement.removeEventListener("mousedown", handleMouseDown);
      documentElement.removeEventListener("mouseup", handleMouseUp);
      frameWindow = getParentWindow(frameWindow);
    }
  };
  return {
    mount,
    unmount
  };
}
function createFocusScopeManager(hotInstance) {
  const SCOPES = createUniqueMap({
    errorIdExists: (name) => `The "${name}" focus scope is already registered.`
  });
  const shortcutManager = hotInstance.getShortcutManager();
  let activeScope = null;
  function getActiveScopeId() {
    if (!activeScope) {
      return null;
    }
    return SCOPES.getId(activeScope);
  }
  function registerScope(scopeId, container, options = {}) {
    if (SCOPES.hasItem(scopeId)) {
      throwWithCause(`Scope with id "${scopeId}" already registered`);
    }
    const scope = createFocusScope(hotInstance, container, options);
    SCOPES.addItem(scopeId, scope);
    shortcutManager.getOrCreateContext(scope.getShortcutsContextName());
  }
  function unregisterScope(scopeId) {
    if (!SCOPES.hasItem(scopeId)) {
      throwWithCause(`Scope with id "${scopeId}" not found`);
    }
    const scope = SCOPES.getItem(scopeId);
    scope.destroy();
    SCOPES.removeItem(scopeId);
  }
  function activateScopeById(scopeId, focusSource = FOCUS_SOURCES.UNKNOWN) {
    if (!SCOPES.hasItem(scopeId)) {
      throwWithCause(`Scope with id "${scopeId}" not found`);
    }
    const resolvedSource = focusSource ?? FOCUS_SOURCES.UNKNOWN;
    activateScope(SCOPES.getItem(scopeId), resolvedSource);
  }
  function deactivateScopeById(scopeId) {
    if (!SCOPES.hasItem(scopeId)) {
      throwWithCause(`Scope with id "${scopeId}" not found`);
    }
    deactivateScope(SCOPES.getItem(scopeId));
  }
  function activateScope(scope, focusSource = FOCUS_SOURCES.UNKNOWN) {
    if (activeScope === scope) {
      return;
    }
    if (activeScope !== null) {
      deactivateScope(activeScope);
    }
    activeScope = scope;
    activeScope.activate(focusSource);
    shortcutManager.setActiveContextName(scope.getShortcutsContextName());
  }
  function deactivateScope(scope) {
    updateScopesFocusVisibilityState();
    if (activeScope !== scope) {
      return;
    }
    activeScope = null;
    scope.deactivate();
  }
  function updateScopesFocusVisibilityState() {
    const scopes = SCOPES.getValues();
    const modalScopes = scopes.filter((scope) => scope.runOnlyIf() && scope.getType() === "modal");
    scopes.forEach((scope) => {
      if (modalScopes.length > 0 && modalScopes.includes(scope) || modalScopes.length === 0 || scope.hasContainerDetached()) {
        scope.enable();
      } else {
        scope.disable();
      }
      if (scope === activeScope) {
        if (scope.contains(hotInstance.rootDocument.activeElement)) {
          scope.deactivateFocusCatchers();
        } else {
          scope.activateFocusCatchers();
        }
      } else if (scope.runOnlyIf()) {
        scope.activateFocusCatchers();
      } else {
        scope.deactivateFocusCatchers();
      }
    });
  }
  function processScopes(target, focusSource) {
    if (!target.isConnected || !isVisible(target)) {
      return;
    }
    const allEnabledScopes = SCOPES.getValues().filter((scope) => scope.runOnlyIf());
    let hasActiveScope = false;
    allEnabledScopes.forEach((scope) => {
      if (!hasActiveScope && scope.contains(target)) {
        hasActiveScope = true;
        if (focusSource !== FOCUS_SOURCES.UNKNOWN) {
          hotInstance.listen();
        }
        activateScope(scope, focusSource);
      }
    });
    if (!hasActiveScope && activeScope) {
      deactivateScope(activeScope);
      hotInstance.unlisten();
    }
  }
  const eventListener = useEventListener(hotInstance.rootWindow, {
    onFocus: (event) => {
      processScopes(eventTargetEl(event), eventTargetEl(event).dataset.htFocusSource ?? FOCUS_SOURCES.UNKNOWN);
    },
    onClick: (event) => {
      processScopes(eventTargetEl(event), FOCUS_SOURCES.CLICK);
    },
    onTabKeyDown: () => {
      updateScopesFocusVisibilityState();
    }
  });
  eventListener.mount();
  return {
    getActiveScopeId,
    registerScope,
    unregisterScope,
    activateScope: (scopeId, focusSource) => activateScopeById(scopeId, focusSource),
    deactivateScope: (scopeId) => deactivateScopeById(scopeId),
    destroy: () => eventListener.unmount()
  };
}
function _check_private_redeclaration$1k(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$18(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$18(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$18(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$18(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$18(receiver, privateMap, "get");
  return _class_apply_descriptor_get$18(receiver, descriptor);
}
function _class_private_field_init$18(obj, privateMap, value) {
  _check_private_redeclaration$1k(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$18(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$18(receiver, privateMap, "set");
  _class_apply_descriptor_set$18(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$X(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$X(obj, privateSet) {
  _check_private_redeclaration$1k(obj, privateSet);
  privateSet.add(obj);
}
const FOCUS_MODES = Object.freeze({
  CELL: "cell",
  MIXED: "mixed"
});
var _hot$2 = /* @__PURE__ */ new WeakMap(), _focusMode = /* @__PURE__ */ new WeakMap(), _refocusDelay = /* @__PURE__ */ new WeakMap(), _refocusElementGetter = /* @__PURE__ */ new WeakMap(), _debouncedSelect = /* @__PURE__ */ new WeakMap(), _hasSelectionChange = /* @__PURE__ */ new WeakMap(), _isSuspended = /* @__PURE__ */ new WeakMap(), _getSelectedCell = /* @__PURE__ */ new WeakSet(), _focusCell = /* @__PURE__ */ new WeakSet(), _focusEditorElement = /* @__PURE__ */ new WeakSet(), _onAfterSelectionChange = /* @__PURE__ */ new WeakSet(), _onAfterRender$2 = /* @__PURE__ */ new WeakSet(), _onUpdateSettings = /* @__PURE__ */ new WeakSet();
class FocusGridManager {
  /**
  * Registers hooks to track selection changes and apply focus logic based on the configured focus mode.
  */
  init() {
    const hotSettings = _class_private_field_get$18(this, _hot$2).getSettings();
    _class_private_field_set$18(this, _focusMode, hotSettings.imeFastEdit ? FOCUS_MODES.MIXED : FOCUS_MODES.CELL);
    _class_private_field_get$18(this, _hot$2).addHook("afterUpdateSettings", (...args) => _class_private_method_get$X(this, _onUpdateSettings, onUpdateSettings).call(this, args[0]));
    _class_private_field_get$18(this, _hot$2).addHook("afterSelection", (...args) => _class_private_method_get$X(this, _onAfterSelectionChange, onAfterSelectionChange).call(this));
    _class_private_field_get$18(this, _hot$2).addHook("afterSelectionFocusSet", (...args) => _class_private_method_get$X(this, _onAfterSelectionChange, onAfterSelectionChange).call(this));
    _class_private_field_get$18(this, _hot$2).addHook("afterSelectionEnd", (...args) => _class_private_method_get$X(this, _focusEditorElement, focusEditorElement).call(this));
    _class_private_field_get$18(this, _hot$2).addHook("afterRender", (...args) => _class_private_method_get$X(this, _onAfterRender$2, onAfterRender).call(this));
  }
  /**
  * Get the current focus mode.
  *
  * @returns {'cell' | 'mixed'}
  */
  getFocusMode() {
    return _class_private_field_get$18(this, _focusMode);
  }
  /**
  * Set the focus mode.
  *
  * @param {'cell' | 'mixed'} focusMode The new focus mode.
  */
  setFocusMode(focusMode) {
    if (Object.values(FOCUS_MODES).includes(focusMode)) {
      _class_private_field_set$18(this, _focusMode, focusMode);
    } else {
      warn$1(`"${focusMode}" is not a valid focus mode.`);
    }
  }
  /**
  * Get the delay after which the focus will change from the cell elements to the active editor's `TEXTAREA`
  * element if the focus mode is set to 'mixed'.
  *
  * @returns {number} Delay in milliseconds.
  */
  getRefocusDelay() {
    return _class_private_field_get$18(this, _refocusDelay);
  }
  /**
  * Set the delay after which the focus will change from the cell elements to the active editor's `TEXTAREA`
  * element if the focus mode is set to 'mixed'.
  *
  * @param {number} delay Delay in milliseconds.
  */
  setRefocusDelay(delay) {
    _class_private_field_set$18(this, _refocusDelay, delay);
  }
  /**
  * Set the function to be used as the "refocus element" getter. It should return a focusable HTML element.
  *
  * @param {Function} getRefocusElementFunction The refocus element getter.
  */
  setRefocusElementGetter(getRefocusElementFunction) {
    _class_private_field_set$18(this, _refocusElementGetter, getRefocusElementFunction);
  }
  /**
  * Suspend automatic focus management until `resume()` is called. While suspended, an
  * externally focused element (input, textarea, select, or contenteditable located outside
  * Handsontable) keeps the browser focus when a programmatic selection is applied, and the
  * editor textarea is not auto-refocused (`imeFastEdit`). Used by `selectCells()` when
  * `changeListener` is `false`. Note: an `activeElement` of `<body>` or an `<iframe>` element
  * does not count as an external input - in those cases focus still moves to the cell.
  *
  * @since 17.0.2
  */
  suspend() {
    _class_private_field_set$18(this, _isSuspended, true);
  }
  /**
  * Resume automatic focus management. Pair with a prior `suspend()` call.
  *
  * @since 17.0.2
  */
  resume() {
    _class_private_field_set$18(this, _isSuspended, false);
  }
  /**
  * Get the element to be used when refocusing the browser after a delay in case of the focus mode being 'mixed'.
  *
  * @returns {HTMLTextAreaElement|HTMLElement|undefined}
  */
  getRefocusElement() {
    if (typeof _class_private_field_get$18(this, _refocusElementGetter) === "function") {
      return _class_private_field_get$18(this, _refocusElementGetter).call(this);
    }
    return _class_private_field_get$18(this, _hot$2).getActiveEditor()?.TEXTAREA;
  }
  /**
  * Moves the browser focus to a connected `HTMLElement`. Plugins should call this instead of
  * `element.focus()` so programmatic focus stays in the focus manager layer.
  *
  * @param {HTMLElement} element The element to focus.
  * @param {FocusOptions} [focusOptions] Optional arguments for the native `focus()` call.
  * @returns {boolean} `true` if `focus()` was called, `false` if `element` is not a connected `HTMLElement`.
  */
  focusElement(element, focusOptions) {
    if (!isHTMLElement(element) || !element.isConnected) {
      return false;
    }
    element.focus(focusOptions);
    return true;
  }
  /**
  * Set the browser's focus to the highlighted cell of the last selection.
  *
  * @param {HTMLTableCellElement} [selectedCell] The highlighted cell/header element.
  */
  focusOnHighlightedCell(selectedCell) {
    const focusElement = (element) => {
      const currentHighlightCoords = _class_private_field_get$18(this, _hot$2).getSelectedRangeActive()?.highlight;
      if (!currentHighlightCoords) {
        return;
      }
      let elementToBeFocused = _class_private_field_get$18(this, _hot$2).runHooks("modifyFocusedElement", currentHighlightCoords.row, currentHighlightCoords.col, element);
      if (!isHTMLElement(elementToBeFocused)) {
        elementToBeFocused = element;
      }
      if (elementToBeFocused && !_class_private_field_get$18(this, _hot$2).getActiveEditor()?.isOpened?.()) {
        this.focusElement(elementToBeFocused, {
          preventScroll: true
        });
      }
    };
    if (selectedCell) {
      focusElement(selectedCell);
    } else {
      _class_private_method_get$X(this, _getSelectedCell, getSelectedCell).call(this, (element) => focusElement(element));
    }
  }
  /**
  * Set the focus to the active editor's `TEXTAREA` element after the provided delay. If no delay is provided, it
  * will be taken from the manager's configuration.
  *
  * @param {number} [delay] Delay in milliseconds.
  */
  refocusToEditorTextarea(delay = _class_private_field_get$18(this, _refocusDelay)) {
    if (_class_private_field_get$18(this, _hot$2).getSettings().imeFastEdit && !_class_private_field_get$18(this, _hot$2).getActiveEditor()?.isOpened?.()) {
      _class_private_field_get$18(this, _hot$2).getActiveEditor()?.refreshValue?.();
      if (!_class_private_field_get$18(this, _debouncedSelect).has(delay)) {
        _class_private_field_get$18(this, _debouncedSelect).set(delay, debounce(() => {
          if (!_class_private_field_get$18(this, _hot$2).isDestroyed) {
            this.getRefocusElement()?.select();
          }
        }, delay));
      }
      _class_private_field_get$18(this, _debouncedSelect).get(delay)();
    }
  }
  /**
  * Initializes the manager with a reference to the Handsontable instance.
  */
  constructor(hotInstance) {
    _class_private_method_init$X(this, _getSelectedCell);
    _class_private_method_init$X(this, _focusCell);
    _class_private_method_init$X(this, _focusEditorElement);
    _class_private_method_init$X(this, _onAfterSelectionChange);
    _class_private_method_init$X(this, _onAfterRender$2);
    _class_private_method_init$X(this, _onUpdateSettings);
    _class_private_field_init$18(this, _hot$2, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$18(this, _focusMode, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$18(this, _refocusDelay, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$18(this, _refocusElementGetter, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$18(this, _debouncedSelect, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$18(this, _hasSelectionChange, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$18(this, _isSuspended, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$18(this, _refocusDelay, 1);
    _class_private_field_set$18(this, _refocusElementGetter, null);
    _class_private_field_set$18(this, _debouncedSelect, /* @__PURE__ */ new Map());
    _class_private_field_set$18(this, _hasSelectionChange, false);
    _class_private_field_set$18(this, _isSuspended, false);
    _class_private_field_set$18(this, _hot$2, hotInstance);
  }
}
function getSelectedCell(callback) {
  const highlight = _class_private_field_get$18(this, _hot$2).getSelectedRangeActive()?.highlight;
  if (!highlight || !_class_private_field_get$18(this, _hot$2).selection.isCellVisible(highlight)) {
    callback(null);
    return;
  }
  if (highlight.row === null || highlight.col === null) {
    callback(null);
    return;
  }
  const { row, col } = highlight;
  const cell = _class_private_field_get$18(this, _hot$2).getCell(row, col, true);
  if (cell === null) {
    _class_private_field_get$18(this, _hot$2).addHookOnce("afterScroll", () => {
      callback(_class_private_field_get$18(this, _hot$2).getCell(row, col, true));
    });
  } else {
    callback(cell);
  }
}
function focusCell() {
  const suspended = _class_private_field_get$18(this, _isSuspended);
  _class_private_method_get$X(this, _getSelectedCell, getSelectedCell).call(this, (selectedCell) => {
    const activeElement = _class_private_field_get$18(this, _hot$2).rootDocument.activeElement;
    if (suspended && activeElement && isOutsideInput(activeElement)) {
      return;
    }
    if (activeElement && isOutsideInput(activeElement)) {
      activeElement.blur();
    }
    this.focusOnHighlightedCell(selectedCell);
  });
}
function focusEditorElement() {
  if (_class_private_field_get$18(this, _isSuspended)) {
    const activeElement = _class_private_field_get$18(this, _hot$2).rootDocument.activeElement;
    if (activeElement && isOutsideInput(activeElement)) {
      return;
    }
  }
  _class_private_method_get$X(this, _getSelectedCell, getSelectedCell).call(this, (selectedCell) => {
    if (this.getFocusMode() === FOCUS_MODES.MIXED && selectedCell?.nodeName === "TD") {
      this.refocusToEditorTextarea();
    }
  });
}
function onAfterSelectionChange() {
  _class_private_field_set$18(this, _hasSelectionChange, true);
}
function onAfterRender() {
  if (_class_private_field_get$18(this, _hasSelectionChange)) {
    _class_private_field_set$18(this, _hasSelectionChange, false);
    _class_private_method_get$X(this, _focusCell, focusCell).call(this);
  }
}
function onUpdateSettings(newSettings) {
  if (typeof newSettings.imeFastEdit === "boolean") {
    this.setFocusMode(newSettings.imeFastEdit ? FOCUS_MODES.MIXED : FOCUS_MODES.CELL);
  }
}
function normalizeCoordsIfNeeded(hot) {
  return (coords) => {
    if (!coords) {
      return null;
    }
    const { rowIndexMapper, columnIndexMapper } = hot;
    if (rowIndexMapper.isHidden(coords.row) || columnIndexMapper.isHidden(coords.col)) {
      return null;
    }
    const mostTopStartCoords = getMostTopStartPosition(hot);
    const mostBottomEndCoords = getMostBottomEndPosition(hot);
    if (mostTopStartCoords === null || mostBottomEndCoords === null) {
      return null;
    }
    coords.row = clamp(coords.row, mostTopStartCoords.row ?? coords.row, mostBottomEndCoords.row ?? coords.row);
    coords.col = clamp(coords.col, mostTopStartCoords.col ?? coords.col, mostBottomEndCoords.col ?? coords.col);
    return coords;
  };
}
function getMostTopStartPosition(hot) {
  const { rowIndexMapper, columnIndexMapper } = hot;
  const { navigableHeaders } = hot.getSettings();
  const initialTopRow = navigableHeaders && hot.countColHeaders() > 0 ? -hot.countColHeaders() : 0;
  const initialStartColumn = navigableHeaders && hot.countRowHeaders() > 0 ? -hot.countRowHeaders() : 0;
  const topRow = initialTopRow === 0 ? rowIndexMapper.getVisualFromRenderableIndex(initialTopRow) : initialTopRow;
  const startColumn = initialStartColumn === 0 ? columnIndexMapper.getVisualFromRenderableIndex(initialStartColumn) : initialStartColumn;
  if (topRow === null || startColumn === null) {
    return null;
  }
  return hot._createCellCoords(topRow, startColumn);
}
function getMostBottomEndPosition(hot) {
  const { rowIndexMapper, columnIndexMapper } = hot;
  const { navigableHeaders } = hot.getSettings();
  let bottomRow = rowIndexMapper.getRenderableIndexesLength() - 1;
  let endColumn = columnIndexMapper.getRenderableIndexesLength() - 1;
  if (bottomRow < 0) {
    if (!navigableHeaders || hot.countColHeaders() === 0) {
      return null;
    }
    bottomRow = -1;
  }
  if (endColumn < 0) {
    if (!navigableHeaders || hot.countColHeaders() === 0) {
      return null;
    }
    endColumn = -1;
  }
  return hot._createCellCoords(rowIndexMapper.getVisualFromRenderableIndex(bottomRow) ?? bottomRow, columnIndexMapper.getVisualFromRenderableIndex(endColumn) ?? endColumn);
}
const GRID_GROUP = "gridDefault";
const GRID_SCOPE = "grid";
const GRID_TAB_NAVIGATION_GROUP = "grid.tabNavigation";
const EDITOR_EDIT_GROUP = "editorManager.handlingEditor";
const EDITOR_SCOPE = "editor";
const command$F = {
  name: "editorCloseAndSave",
  callback(hot) {
    const editorManager = hot._getEditorManager();
    editorManager.closeEditorAndSaveChanges();
  }
};
const MIXIN_NAME = "hooksRefRegisterer";
const hooksRefRegisterer = {
  /**
  * Internal hooks storage.
  */
  _hooksStorage: /* @__PURE__ */ Object.create(null),
  /**
  * Add hook to the collection.
  *
  * @param {string} key The hook name.
  * @param {Function} callback The hook callback.
  * @returns {object}
  */
  addHook(key, callback) {
    if (!this._hooksStorage[key]) {
      this._hooksStorage[key] = [];
    }
    this.hot.addHook(key, callback);
    this._hooksStorage[key].push(callback);
    return this;
  },
  /**
  * Remove all hooks listeners by hook name.
  *
  * @param {string} key The hook name.
  */
  removeHooksByKey(key) {
    arrayEach(this._hooksStorage[key] || [], (callback) => {
      this.hot.removeHook(key, callback);
    });
  },
  /**
  * Clear all added hooks.
  */
  clearHooks() {
    objectEach(this._hooksStorage, (callbacks, name) => this.removeHooksByKey(name));
    this._hooksStorage = {};
  }
};
defineGetter(hooksRefRegisterer, "MIXIN_NAME", MIXIN_NAME, {
  writable: false,
  enumerable: false
});
function _check_private_redeclaration$1j(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$W(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$W(obj, privateSet) {
  _check_private_redeclaration$1j(obj, privateSet);
  privateSet.add(obj);
}
const EDITOR_TYPE$d = "base";
const EDITOR_STATE = Object.freeze({
  VIRGIN: "STATE_VIRGIN",
  EDITING: "STATE_EDITING",
  WAITING: "STATE_WAITING",
  FINISHED: "STATE_FINISHED"
});
var _calcCellTopOffset = /* @__PURE__ */ new WeakSet(), _calcCellStartOffset = /* @__PURE__ */ new WeakSet();
class BaseEditor {
  /**
  * Returns the unique editor type identifier for the base editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$d;
  }
  /**
  * Fires callback after closing editor.
  *
  * @private
  * @param {boolean} result The editor value.
  */
  _fireCallbacks(result) {
    if (this._closeCallback) {
      this._closeCallback(result);
      this._closeCallback = null;
    }
  }
  /**
  * Initializes an editor's intance.
  */
  init() {
  }
  /**
  * Required method to get current value from editable element.
  */
  getValue() {
    throwWithCause("Editor getValue() method unimplemented");
  }
  /**
  * Required method to set new value into editable element.
  */
  setValue(_value) {
    throwWithCause("Editor setValue() method unimplemented");
  }
  /**
  * Required method to open editor.
  */
  open(_event) {
    throwWithCause("Editor open() method unimplemented");
  }
  /**
  * Required method to close editor.
  */
  close() {
    throwWithCause("Editor close() method unimplemented");
  }
  /**
  * Required method to focus editor.
  */
  focus() {
    throwWithCause("Editor focus() method unimplemented");
  }
  /**
  * Prepares editor's meta data.
  *
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number|string} prop The column property (passed when datasource is an array of objects).
  * @param {HTMLTableCellElement} td The rendered cell element.
  * @param {*} value The rendered value.
  * @param {object} cellProperties The cell meta object (see {@link Core#getCellMeta}).
  */
  prepare(row, col, prop, td, value, cellProperties) {
    this.TD = td;
    this.row = row;
    this.col = col;
    this.prop = prop;
    this.originalValue = value;
    this.cellProperties = cellProperties;
    this.state = this.isOpened() ? this.state : EDITOR_STATE.VIRGIN;
  }
  /**
  * Fallback method to provide extendable editors in ES5.
  *
  * @returns {Function}
  */
  extend() {
    return class Editor extends this.constructor {
    };
  }
  /**
  * Saves value from editor into data storage.
  *
  * @param {*} value The editor value.
  * @param {boolean} ctrlDown If `true`, applies value to each cell in the last selected range.
  */
  saveValue(value, ctrlDown) {
    let visualRowFrom;
    let visualColumnFrom;
    let visualRowTo;
    let visualColumnTo;
    if (ctrlDown) {
      const activeRange = this.hot.getSelectedRangeActive();
      const topStartCorner = activeRange?.getTopStartCorner();
      const bottomEndCorner = activeRange?.getBottomEndCorner();
      visualRowFrom = topStartCorner?.row ?? this.row;
      visualColumnFrom = topStartCorner?.col ?? this.col;
      visualRowTo = bottomEndCorner?.row ?? this.row;
      visualColumnTo = bottomEndCorner?.col ?? this.col;
    } else {
      [visualRowFrom, visualColumnFrom, visualRowTo, visualColumnTo] = [
        this.row,
        this.col,
        null,
        null
      ];
    }
    const modifiedCellCoords = this.hot.runHooks("modifyGetCellCoords", visualRowFrom, visualColumnFrom, false, "meta");
    if (Array.isArray(modifiedCellCoords)) {
      [visualRowFrom, visualColumnFrom] = modifiedCellCoords;
    }
    this.hot.populateFromArray(visualRowFrom, visualColumnFrom, value, visualRowTo, visualColumnTo, "edit");
  }
  /**
  * Begins editing on a highlighted cell and hides fillHandle corner if was present.
  *
  * @param {*} newInitialValue The initial editor value.
  * @param {Event} event The keyboard event object.
  */
  beginEditing(newInitialValue, event) {
    if (this.state !== EDITOR_STATE.VIRGIN) {
      return;
    }
    if (this.row === null || this.col === null) {
      warn$1("Editor opened without valid cell coordinates.");
      return;
    }
    const hotInstance = this.hot;
    const renderableRowIndex = hotInstance.rowIndexMapper.getRenderableFromVisualIndex(this.row);
    const renderableColumnIndex = hotInstance.columnIndexMapper.getRenderableFromVisualIndex(this.col);
    if (renderableRowIndex !== null && renderableColumnIndex !== null) {
      hotInstance.view.scrollViewport({
        row: renderableRowIndex,
        col: renderableColumnIndex
      });
    }
    this.state = EDITOR_STATE.EDITING;
    if (this.isInFullEditMode()) {
      const originalValue = getValueGetterValue(this.originalValue, this.hot.getCellMeta(this.row, this.col));
      const stringifiedInitialValue = typeof newInitialValue === "string" ? newInitialValue : stringify$1(originalValue);
      this.setValue(stringifiedInitialValue);
    }
    this.open(event);
    this._opened = true;
    this.focus();
    hotInstance.view.render();
    hotInstance.runHooks("afterBeginEditing", this.row, this.col);
    this.addHook("beforeDialogShow", () => this.cancelChanges());
  }
  /**
  * Finishes editing and start saving or restoring process for editing cell or last selected range.
  *
  * @param {boolean} restoreOriginalValue If true, then closes editor without saving value from the editor into a cell.
  * @param {boolean} ctrlDown If true, then saveValue will save editor's value to each cell in the last selected range.
  * @param {Function} callback The callback function, fired after editor closing.
  */
  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    if (callback) {
      const previousCloseCallback = this._closeCallback;
      this._closeCallback = (result) => {
        if (previousCloseCallback) {
          previousCloseCallback(result);
        }
        callback(result);
        this.hot.view.render();
      };
    }
    if (this.isWaiting()) {
      return;
    }
    if (this.state === EDITOR_STATE.VIRGIN) {
      this.hot._registerTimeout(() => {
        this._fireCallbacks(true);
      });
      return;
    }
    if (this.state === EDITOR_STATE.EDITING) {
      if (restoreOriginalValue) {
        this.cancelChanges();
        this.hot.view.render();
        return;
      }
      let value = this.getValue();
      if (this.cellProperties.trimWhitespace) {
        value = typeof value === "string" ? String.prototype.trim.call(value || "") : value;
      }
      if (typeof this.cellProperties.valueParser === "function") {
        value = this.cellProperties.valueParser(value, this.cellProperties);
      }
      this.state = EDITOR_STATE.WAITING;
      this.saveValue([
        [
          value
        ]
      ], ctrlDown);
      if (this.hot.getCellValidator(this.cellProperties)) {
        this.hot.addHookOnce("postAfterValidate", (result) => {
          this.state = EDITOR_STATE.FINISHED;
          this.discardEditor(result);
        });
      } else {
        this.state = EDITOR_STATE.FINISHED;
        this.discardEditor(true);
      }
    }
  }
  /**
  * Finishes editing without saving value.
  */
  cancelChanges() {
    this.state = EDITOR_STATE.FINISHED;
    this.discardEditor();
  }
  /**
  * Verifies result of validation or closes editor if user's cancelled changes.
  *
  * @param {boolean|undefined} result If `false` and the cell using allowInvalid option,
  *                                   then an editor won't be closed until validation is passed.
  */
  discardEditor(result) {
    if (this.state !== EDITOR_STATE.FINISHED) {
      return;
    }
    if (result === false && this.cellProperties.allowInvalid !== true) {
      if (this.row === null || this.col === null) {
        return;
      }
      this.hot.selectCell(this.row, this.col);
      this.focus();
      this.state = EDITOR_STATE.EDITING;
      this._fireCallbacks(false);
    } else {
      this.close();
      this._opened = false;
      this._fullEditMode = false;
      this.state = EDITOR_STATE.VIRGIN;
      this._fireCallbacks(true);
      const shortcutManager = this.hot.getShortcutManager();
      shortcutManager.setActiveContextName("grid");
    }
  }
  /**
  * Switch editor into full edit mode. In this state navigation keys don't close editor. This mode is activated
  * automatically after hit ENTER or F2 key on the cell or while editing cell press F2 key.
  */
  enableFullEditMode() {
    this._fullEditMode = true;
  }
  /**
  * Checks if editor is in full edit mode.
  *
  * @returns {boolean}
  */
  isInFullEditMode() {
    return this._fullEditMode;
  }
  /**
  * Returns information whether the editor is open.
  *
  * @returns {boolean}
  */
  isOpened() {
    return this._opened;
  }
  /**
  * Returns information whether the editor is waiting, eg.: for async validation.
  *
  * @returns {boolean}
  */
  isWaiting() {
    return this.state === EDITOR_STATE.WAITING;
  }
  /**
  * Gets the object that provides information about the edited cell size and its position
  * relative to the table viewport.
  *
  * The rectangle has six integer properties:
  *  - `top` The top position relative to the table viewport
  *  - `start` The left (or right in RTL) position relative to the table viewport
  *  - `width` The cell's current width;
  *  - `maxWidth` The maximum cell's width after which the editor goes out of the table viewport
  *  - `height` The cell's current height;
  *  - `maxHeight` The maximum cell's height after which the editor goes out of the table viewport
  *
  * @returns {{top: number, start: number, width: number, maxWidth: number, height: number, maxHeight: number} | undefined}
  */
  getEditedCellRect() {
    const TD = this.getEditedCell();
    if (!TD) {
      return;
    }
    const { wtOverlays, wtViewport } = this.hot.view._wt;
    const rootWindow = this.hot.rootWindow;
    const currentOffset = offset(TD);
    const cellWidth = outerWidth(TD);
    const containerOffset = offset(this.hot.rootElement);
    const containerWidth = outerWidth(this.hot.rootElement);
    const scrollableContainerTop = wtOverlays.topOverlay?.holder;
    const scrollableContainerLeft = wtOverlays.inlineStartOverlay?.holder;
    const containerScrollTop = scrollableContainerTop !== rootWindow ? scrollableContainerTop.scrollTop : 0;
    const containerScrollLeft = scrollableContainerLeft !== rootWindow ? scrollableContainerLeft.scrollLeft : 0;
    const gridMostRightPos = rootWindow.innerWidth - containerOffset.left - containerWidth;
    const { wtTable: overlayTable } = wtOverlays.getParentOverlay(TD) ?? this.hot.view._wt;
    const overlayName = overlayTable.name;
    const scrollTop = [
      "master",
      "inline_start"
    ].includes(overlayName) ? containerScrollTop : 0;
    const scrollLeft = [
      "master",
      "top",
      "bottom"
    ].includes(overlayName) ? containerScrollLeft : 0;
    const editTopModifier = currentOffset.top === containerOffset.top ? 0 : 1;
    let topPos = currentOffset.top - containerOffset.top - editTopModifier - scrollTop;
    let inlineStartPos = 0;
    if (this.hot.isRtl()) {
      inlineStartPos = rootWindow.innerWidth - currentOffset.left - cellWidth - gridMostRightPos - 1 + scrollLeft;
    } else {
      inlineStartPos = currentOffset.left - containerOffset.left - 1 - scrollLeft;
    }
    if ([
      "top",
      "top_inline_start_corner"
    ].includes(overlayName)) {
      topPos += wtOverlays.topOverlay?.getOverlayOffset() ?? 0;
    }
    if ([
      "inline_start",
      "top_inline_start_corner"
    ].includes(overlayName)) {
      inlineStartPos += Math.abs(wtOverlays.inlineStartOverlay?.getOverlayOffset() ?? 0);
    }
    const hasColumnHeaders = this.hot.hasColHeaders();
    const renderableRow = this.hot.rowIndexMapper.getRenderableFromVisualIndex(this.row ?? 0);
    const renderableColumn = this.hot.columnIndexMapper.getRenderableFromVisualIndex(this.col ?? 0);
    const nrOfRenderableRowIndexes = this.hot.rowIndexMapper.getRenderableIndexesLength();
    const firstRowIndexOfTheBottomOverlay = nrOfRenderableRowIndexes - this.hot.view._wt.getSetting("fixedRowsBottom");
    if (hasColumnHeaders && (renderableRow ?? 0) <= 0 || renderableRow === firstRowIndexOfTheBottomOverlay) {
      topPos += 1;
    }
    if ((renderableColumn ?? 0) <= 0) {
      inlineStartPos += 1;
    }
    const firstRowOffset = wtViewport.rowsRenderCalculator?.startPosition ?? 0;
    const firstColumnOffset = wtViewport.columnsRenderCalculator?.startPosition ?? 0;
    const horizontalScrollPosition = Math.abs(wtOverlays.inlineStartOverlay?.getScrollPosition() ?? 0);
    const verticalScrollPosition = wtOverlays.topOverlay?.getScrollPosition() ?? 0;
    const scrollbarWidth = getScrollbarWidth(this.hot.rootDocument);
    const cellTopOffset = _class_private_method_get$W(this, _calcCellTopOffset, calcCellTopOffset).call(this, TD, overlayName, firstRowOffset, verticalScrollPosition, scrollbarWidth);
    const cellStartOffset = _class_private_method_get$W(this, _calcCellStartOffset, calcCellStartOffset).call(this, TD, overlayName, overlayTable, cellWidth, firstColumnOffset, horizontalScrollPosition);
    const cellComputedStyle = rootWindow.getComputedStyle(TD);
    const borderPhysicalWidthProp = this.hot.isRtl() ? "borderRightWidth" : "borderLeftWidth";
    const inlineStartBorderCompensation = Number.parseInt(cellComputedStyle[borderPhysicalWidthProp], 10) > 0 ? 0 : 1;
    const topBorderCompensation = Number.parseInt(cellComputedStyle.borderTopWidth, 10) > 0 ? 0 : 1;
    const width = outerWidth(TD) + inlineStartBorderCompensation;
    const height = outerHeight(TD) + topBorderCompensation;
    const actualVerticalScrollbarWidth = scrollableContainerTop && hasVerticalScrollbar(scrollableContainerTop) ? scrollbarWidth : 0;
    const actualHorizontalScrollbarWidth = scrollableContainerLeft && hasHorizontalScrollbar(scrollableContainerLeft) ? scrollbarWidth : 0;
    const maxWidth = this.hot.view.maximumVisibleElementWidth(cellStartOffset) - actualVerticalScrollbarWidth + inlineStartBorderCompensation;
    const maxHeight = Math.max(this.hot.view.maximumVisibleElementHeight(cellTopOffset ?? 0) - actualHorizontalScrollbarWidth + topBorderCompensation, this.hot.stylesHandler.getDefaultRowHeight() ?? 0);
    return {
      top: topPos,
      start: inlineStartPos,
      height,
      maxHeight,
      width,
      maxWidth
    };
  }
  /**
  * Gets className of the edited cell if exist.
  *
  * @returns {string}
  */
  getEditedCellsLayerClass() {
    const editorSection = this.checkEditorSection();
    switch (editorSection) {
      case "inline-start":
        return "ht_clone_left ht_clone_inline_start";
      case "bottom":
        return "ht_clone_bottom";
      case "bottom-inline-start-corner":
        return "ht_clone_bottom_left_corner ht_clone_bottom_inline_start_corner";
      case "top":
        return "ht_clone_top";
      case "top-inline-start-corner":
        return "ht_clone_top_left_corner ht_clone_top_inline_start_corner";
      default:
        return "ht_clone_master";
    }
  }
  /**
  * Gets HTMLTableCellElement of the edited cell if exist.
  *
  * @returns {HTMLTableCellElement|null}
  */
  getEditedCell() {
    if (this.row === null || this.col === null) {
      return null;
    }
    return this.hot.getCell(this.row, this.col, true);
  }
  /**
  * Returns name of the overlay, where editor is placed.
  *
  * @private
  * @returns {string}
  */
  checkEditorSection() {
    if (this.row === null || this.col === null) {
      return "";
    }
    const totalRows = this.hot.countRows();
    const settings = this.hot.getSettings();
    let section = "";
    if (this.row < (settings.fixedRowsTop ?? 0)) {
      if (this.col < (settings.fixedColumnsStart ?? 0)) {
        section = "top-inline-start-corner";
      } else {
        section = "top";
      }
    } else if (settings.fixedRowsBottom && this.row >= totalRows - settings.fixedRowsBottom) {
      if (this.col < (settings.fixedColumnsStart ?? 0)) {
        section = "bottom-inline-start-corner";
      } else {
        section = "bottom";
      }
    } else if (this.col < (settings.fixedColumnsStart ?? 0)) {
      section = "inline-start";
    }
    return section;
  }
  /**
  * @param {Handsontable} hotInstance A reference to the source instance of the Handsontable.
  */
  constructor(hotInstance) {
    _class_private_method_init$W(this, _calcCellTopOffset);
    _class_private_method_init$W(this, _calcCellStartOffset);
    this.state = EDITOR_STATE.VIRGIN;
    this._opened = false;
    this._fullEditMode = false;
    this._closeCallback = null;
    this._closeAfterDataChange = true;
    this.TD = null;
    this.row = null;
    this.col = null;
    this.prop = null;
    this.originalValue = null;
    this.hot = hotInstance;
    this.init();
  }
}
function calcCellTopOffset(TD, overlayName, firstRowOffset, verticalScrollPosition, scrollbarWidth) {
  let cellTopOffset = TD.offsetTop;
  const { wtOverlays } = this.hot.view._wt;
  if ([
    "inline_start",
    "master"
  ].includes(overlayName)) {
    cellTopOffset += firstRowOffset - verticalScrollPosition;
  }
  if ([
    "bottom",
    "bottom_inline_start_corner"
  ].includes(overlayName) && wtOverlays.bottomOverlay?.clone) {
    const { wtViewport: bottomWtViewport, wtTable: bottomWtTable } = wtOverlays.bottomOverlay.clone;
    cellTopOffset += bottomWtViewport.getWorkspaceHeight() - bottomWtTable.getHeight() - scrollbarWidth;
  }
  return cellTopOffset;
}
function calcCellStartOffset(TD, overlayName, overlayTable, cellWidth, firstColumnOffset, horizontalScrollPosition) {
  let cellStartOffset = TD.offsetLeft;
  if (this.hot.isRtl()) {
    if (cellStartOffset >= 0) {
      cellStartOffset = overlayTable.getWidth() - TD.offsetLeft;
    } else {
      cellStartOffset = Math.abs(cellStartOffset);
    }
    cellStartOffset += firstColumnOffset - horizontalScrollPosition - cellWidth;
  } else if ([
    "top",
    "master",
    "bottom"
  ].includes(overlayName)) {
    cellStartOffset += firstColumnOffset - horizontalScrollPosition;
  }
  return cellStartOffset;
}
mixin(BaseEditor, hooksRefRegisterer);
const command$E = {
  name: "editorCloseAndSaveByArrowKeys",
  callback(hot, event, keys2) {
    const editorManager = hot._getEditorManager();
    const activeEditor = editorManager.getActiveEditor();
    if (activeEditor?.isInFullEditMode() && activeEditor?.state === EDITOR_STATE.EDITING) {
      return;
    }
    editorManager.closeEditorAndSaveChanges();
    if (hot.getSelected()) {
      if (keys2.includes("arrowdown")) {
        hot.selection.transformStart(1, 0);
      } else if (keys2.includes("arrowup")) {
        hot.selection.transformStart(-1, 0);
      } else if (keys2.includes("arrowleft")) {
        hot.selection.transformStart(0, -1 * hot.getDirectionFactor());
      } else if (keys2.includes("arrowright")) {
        hot.selection.transformStart(0, hot.getDirectionFactor());
      }
    }
    event.preventDefault();
  }
};
const command$D = {
  name: "editorCloseAndSaveByEnter",
  callback(hot, event) {
    const editorManager = hot._getEditorManager();
    editorManager.closeEditorAndSaveChanges(event.ctrlKey || event.metaKey);
    editorManager.moveSelectionAfterEnter(event);
  }
};
const command$C = {
  name: "editorCloseWithoutSaving",
  callback(hot) {
    const editorManager = hot._getEditorManager();
    editorManager.closeEditorAndRestoreOriginalValue(hot.getShortcutManager().isCtrlPressed());
    editorManager.activeEditor?.focus();
  }
};
const command$B = {
  name: "editorFastOpen",
  callback(hot, event) {
    const highlight = hot.getSelectedRangeActive()?.highlight;
    if (highlight?.isHeader()) {
      return;
    }
    hot._getEditorManager().openEditor(null, event, true);
  }
};
const command$A = {
  name: "editorOpen",
  callback(hot, event, keys2) {
    const { selection } = hot;
    const editorManager = hot._getEditorManager();
    const selectedRanges = hot.getSelectedRange();
    const selectedRange = hot.getSelectedRangeActive();
    const highlight = selectedRange?.highlight;
    if ((selectedRanges?.some((range) => selection.isMultiple(range)) || (selectedRanges?.length ?? 0) > 1) && !selectedRange?.isHeader() && hot.countRenderedCols() > 0 && hot.countRenderedRows() > 0) {
      const settings = hot.getSettings();
      const enterMoves = typeof settings.enterMoves === "function" ? settings.enterMoves(event) : settings.enterMoves;
      if (keys2.includes("shift")) {
        selection.transformFocus(-(enterMoves?.row ?? 0), -(enterMoves?.col ?? 0));
      } else {
        selection.transformFocus(enterMoves?.row ?? 0, enterMoves?.col ?? 0);
      }
      return;
    }
    if (highlight?.isHeader()) {
      return;
    }
    if (hot.getSettings().enterBeginsEditing) {
      if (editorManager.cellProperties.readOnly) {
        editorManager.moveSelectionAfterEnter(event);
      } else {
        editorManager.openEditor(null, event, true);
      }
    } else {
      editorManager.moveSelectionAfterEnter(event);
    }
    stopImmediatePropagation(event);
  }
};
function getAllCommands$2() {
  return [
    command$F,
    command$E,
    command$D,
    command$C,
    command$B,
    command$A
  ];
}
const command$z = {
  name: "extendCellsSelectionDown",
  callback(hot) {
    const { selection } = hot;
    const highlight = hot.getSelectedRangeActive()?.highlight;
    if (!selection.isSelectedByColumnHeader() && !selection.isSelectedByCorner() && (highlight?.isCell() || highlight?.isHeader() && selection.isSelectedByRowHeader())) {
      selection.markSource("keyboard");
      selection.transformEnd(1, 0);
      selection.markEndSource();
    }
  }
};
const command$y = {
  name: "extendCellsSelectionDownByViewportHeight",
  callback(hot) {
    const { selection, rowIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { to } = activeRange;
    const toRow = to.row ?? 0;
    const nextRowIndexToSelect = Math.min(toRow + hot.countVisibleRows(), hot.countRows() - 1);
    const row = rowIndexMapper.getNearestNotHiddenIndex(nextRowIndexToSelect, -1);
    if (row !== null) {
      const coords = hot._createCellCoords(row, to.col ?? 0);
      const scrollPadding = toRow - (hot.getFirstFullyVisibleRow() ?? 0);
      const nextVerticalScroll = Math.min((coords.row ?? 0) - scrollPadding, hot.countRows() - 1);
      selection.markSource("keyboard");
      selection.setRangeEnd(coords, hot.getActiveSelectionLayerIndex());
      selection.markEndSource();
      hot.scrollViewportTo({
        row: nextVerticalScroll,
        verticalSnap: "top",
        horizontalSnap: "start"
      });
    }
  }
};
const command$x = {
  name: "extendCellsSelectionLeft",
  callback(hot) {
    const { selection } = hot;
    const highlight = hot.getSelectedRangeActive()?.highlight;
    if (!selection.isSelectedByRowHeader() && !selection.isSelectedByCorner() && (highlight?.isCell() || highlight?.isHeader() && selection.isSelectedByColumnHeader())) {
      selection.markSource("keyboard");
      selection.transformEnd(0, -1 * hot.getDirectionFactor());
      selection.markEndSource();
    }
  }
};
const command$w = {
  name: "extendCellsSelectionRight",
  callback(hot) {
    const { selection } = hot;
    const highlight = hot.getSelectedRangeActive()?.highlight;
    if (!selection.isSelectedByRowHeader() && !selection.isSelectedByCorner() && (highlight?.isCell() || highlight?.isHeader() && selection.isSelectedByColumnHeader())) {
      selection.markSource("keyboard");
      selection.transformEnd(0, hot.getDirectionFactor());
      selection.markEndSource();
    }
  }
};
const command$v = {
  name: "extendCellsSelectionToColumns",
  callback(hot) {
    const { selection } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    selection.markSource("keyboard");
    if (selection.isSelectedByRowHeader()) {
      selection.selectAll(true, true);
    } else {
      hot.selectColumns(from.col ?? 0, to.col ?? 0, highlight);
    }
    selection.markEndSource();
  }
};
const command$u = {
  name: "extendCellsSelectionToMostBottom",
  callback(hot) {
    const { selection, rowIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    const isFocusHighlightedByHeader = highlight.isHeader() && selection.isSelectedByRowHeader();
    if (highlight.isCell() || isFocusHighlightedByHeader) {
      const row = rowIndexMapper.getNearestNotHiddenIndex(hot.countRows() - 1, -1);
      const newFrom = from.clone();
      newFrom.row = highlight.row;
      selection.markSource("keyboard");
      selection.setRangeStart(newFrom, void 0, false, highlight.clone());
      if (isFocusHighlightedByHeader) {
        selection.selectedByRowHeader.add(selection.getLayerLevel());
      }
      selection.setRangeEnd(hot._createCellCoords(row ?? 0, to.col ?? 0));
      selection.markEndSource();
    }
  }
};
const command$t = {
  name: "extendCellsSelectionToMostInlineEnd",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    if (!selection.isSelectedByRowHeader() && !selection.isSelectedByCorner() && highlight.isCell()) {
      const column = columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1);
      const newFrom = from.clone();
      newFrom.col = highlight.col;
      selection.markSource("keyboard");
      selection.setRangeStart(newFrom, void 0, false, highlight.clone());
      selection.setRangeEnd(hot._createCellCoords(to.row ?? 0, column ?? 0));
      selection.markEndSource();
    }
  }
};
const command$s = {
  name: "extendCellsSelectionToMostInlineStart",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    if (!selection.isSelectedByRowHeader() && !selection.isSelectedByCorner() && highlight.isCell()) {
      const fixedColumns = Number(hot.getSettings().fixedColumnsStart) || 0;
      const column = columnIndexMapper.getNearestNotHiddenIndex(fixedColumns, 1);
      const newFrom = from.clone();
      newFrom.col = highlight.col;
      selection.markSource("keyboard");
      selection.setRangeStart(newFrom, void 0, false, highlight.clone());
      selection.setRangeEnd(hot._createCellCoords(to.row ?? 0, column ?? 0));
      selection.markEndSource();
    }
  }
};
const command$r = {
  name: "extendCellsSelectionToMostLeft",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    const isFocusHighlightedByHeader = highlight.isHeader() && selection.isSelectedByColumnHeader();
    if (highlight.isCell() || isFocusHighlightedByHeader) {
      const column = hot.isRtl() ? columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1) : columnIndexMapper.getNearestNotHiddenIndex(0, 1);
      const newFrom = from.clone();
      newFrom.col = highlight.col;
      selection.markSource("keyboard");
      selection.setRangeStart(newFrom, void 0, false, highlight.clone());
      if (isFocusHighlightedByHeader) {
        selection.selectedByColumnHeader.add(selection.getLayerLevel());
      }
      selection.setRangeEnd(hot._createCellCoords(to.row ?? 0, column ?? 0));
      selection.markEndSource();
    }
  }
};
const command$q = {
  name: "extendCellsSelectionToMostRight",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    const isFocusHighlightedByHeader = highlight.isHeader() && selection.isSelectedByColumnHeader();
    if (highlight.isCell() || isFocusHighlightedByHeader) {
      const column = hot.isRtl() ? columnIndexMapper.getNearestNotHiddenIndex(0, 1) : columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1);
      const newFrom = from.clone();
      newFrom.col = highlight.col;
      selection.markSource("keyboard");
      selection.setRangeStart(newFrom, void 0, false, highlight.clone());
      if (isFocusHighlightedByHeader) {
        selection.selectedByColumnHeader.add(selection.getLayerLevel());
      }
      selection.setRangeEnd(hot._createCellCoords(to.row ?? 0, column ?? 0));
      selection.markEndSource();
    }
  }
};
const command$p = {
  name: "extendCellsSelectionToMostTop",
  callback(hot) {
    const { selection, rowIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { highlight, from, to } = activeRange;
    const isFocusHighlightedByHeader = highlight.isHeader() && selection.isSelectedByRowHeader();
    if (highlight.isCell() || isFocusHighlightedByHeader) {
      const row = rowIndexMapper.getNearestNotHiddenIndex(0, 1);
      const newFrom = from.clone();
      newFrom.row = highlight.row;
      selection.markSource("keyboard");
      selection.setRangeStart(newFrom, void 0, false, highlight.clone());
      if (isFocusHighlightedByHeader) {
        selection.selectedByRowHeader.add(selection.getLayerLevel());
      }
      selection.setRangeEnd(hot._createCellCoords(row ?? 0, to.col ?? 0));
      selection.markEndSource();
    }
  }
};
const command$o = {
  name: "extendCellsSelectionToRows",
  callback(hot) {
    const { selection } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      selection.markEndSource();
      return;
    }
    const { highlight, from, to } = activeRange;
    selection.markSource("keyboard");
    if (selection.isSelectedByColumnHeader()) {
      selection.selectAll(true, true);
    } else {
      hot.selectRows(from.row ?? 0, to.row ?? 0, highlight);
    }
    selection.markEndSource();
  }
};
const command$n = {
  name: "extendCellsSelectionUp",
  callback(hot) {
    const { selection } = hot;
    const highlight = hot.getSelectedRangeActive()?.highlight;
    if (!selection.isSelectedByColumnHeader() && !selection.isSelectedByCorner() && (highlight?.isCell() || highlight?.isHeader() && selection.isSelectedByRowHeader())) {
      selection.markSource("keyboard");
      selection.transformEnd(-1, 0);
      selection.markEndSource();
    }
  }
};
const command$m = {
  name: "extendCellsSelectionUpByViewportHeight",
  callback(hot) {
    const { selection, rowIndexMapper } = hot;
    const activeRange = hot.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { to } = activeRange;
    const toRow = to.row ?? 0;
    const nextRowIndexToSelect = Math.max(toRow - hot.countVisibleRows(), 0);
    const row = rowIndexMapper.getNearestNotHiddenIndex(nextRowIndexToSelect, 1);
    if (row !== null) {
      const coords = hot._createCellCoords(row, to.col ?? 0);
      const scrollPadding = toRow - (hot.getFirstFullyVisibleRow() ?? 0);
      const nextVerticalScroll = Math.max((coords.row ?? 0) - scrollPadding, 0);
      selection.markSource("keyboard");
      selection.setRangeEnd(coords, hot.getActiveSelectionLayerIndex());
      selection.markEndSource();
      hot.scrollViewportTo({
        row: nextVerticalScroll,
        verticalSnap: "top",
        horizontalSnap: "start"
      });
    }
  }
};
function getAllCommands$1() {
  return [
    command$z,
    command$y,
    command$x,
    command$w,
    command$v,
    command$u,
    command$t,
    command$s,
    command$r,
    command$q,
    command$p,
    command$o,
    command$n,
    command$m
  ];
}
const command$l = {
  name: "moveCellSelectionDown",
  callback({ selection }) {
    selection.markSource("keyboard");
    selection.transformStart(1, 0);
    selection.markEndSource();
  }
};
const command$k = {
  name: "moveCellSelectionDownByViewportHeight",
  callback(hot) {
    const { selection } = hot;
    const { navigableHeaders } = hot.getSettings();
    const columnHeadersCount = navigableHeaders ? hot.countColHeaders() : 0;
    const row = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    let rowsStep = hot.countVisibleRows() + columnHeadersCount;
    rowsStep = rowsStep === 0 ? 1 : rowsStep;
    if (row === hot.countRows() - 1) {
      rowsStep = 1;
    } else if (row + rowsStep > hot.countRows()) {
      rowsStep = hot.countRows() - row - 1;
    }
    selection.markSource("keyboard");
    selection.transformStart(rowsStep, 0);
    selection.markEndSource();
    const fixedRowsBottom = hot.getSettings().fixedRowsBottom ?? 0;
    const totalRows = hot.countRows();
    const currentRow = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    if (currentRow < 0) {
      hot.scrollViewportTo({
        row: 0
      });
    } else if (fixedRowsBottom > 0 && currentRow >= totalRows - fixedRowsBottom) {
      hot.scrollViewportTo({
        row: totalRows - fixedRowsBottom - 1,
        verticalSnap: "bottom"
      });
    }
  }
};
const command$j = {
  name: "moveCellSelectionInlineEnd",
  callback(hot, event) {
    const { selection } = hot;
    const settings = hot.getSettings();
    const selectedRanges = hot.getSelectedRange();
    const selectedRange = hot.getSelectedRangeActive();
    const tabMoves = typeof settings.tabMoves === "function" ? settings.tabMoves(event) : settings.tabMoves;
    selection.markSource("keyboard");
    if ((selectedRanges?.some((range) => selection.isMultiple(range)) || (selectedRanges?.length ?? 0) > 1) && !selectedRange?.isHeader() && hot.countRenderedCols() > 0 && hot.countRenderedRows() > 0) {
      selection.transformFocus(-(tabMoves?.row ?? 0), -(tabMoves?.col ?? 0));
    } else {
      selection.transformStart(-(tabMoves?.row ?? 0), -(tabMoves?.col ?? 0));
    }
    selection.markEndSource();
  }
};
const command$i = {
  name: "moveCellSelectionInlineStart",
  callback(hot, event) {
    const { selection } = hot;
    const settings = hot.getSettings();
    const selectedRanges = hot.getSelectedRange();
    const selectedRange = hot.getSelectedRangeActive();
    const tabMoves = typeof settings.tabMoves === "function" ? settings.tabMoves(event) : settings.tabMoves;
    selection.markSource("keyboard");
    if ((selectedRanges?.some((range) => selection.isMultiple(range)) || (selectedRanges?.length ?? 0) > 1) && !selectedRange?.isHeader() && hot.countRenderedCols() > 0 && hot.countRenderedRows() > 0) {
      selection.transformFocus(tabMoves?.row ?? 0, tabMoves?.col ?? 0);
    } else {
      selection.transformStart(tabMoves?.row ?? 0, tabMoves?.col ?? 0);
    }
    selection.markEndSource();
  }
};
const command$h = {
  name: "moveCellSelectionLeft",
  callback(hot) {
    const { selection } = hot;
    selection.markSource("keyboard");
    selection.transformStart(0, -1 * hot.getDirectionFactor());
    selection.markEndSource();
  }
};
const command$g = {
  name: "moveCellSelectionRight",
  callback(hot) {
    const { selection } = hot;
    selection.markSource("keyboard");
    selection.transformStart(0, hot.getDirectionFactor());
    selection.markEndSource();
  }
};
const command$f = {
  name: "moveCellSelectionToMostBottom",
  callback(hot) {
    const { selection } = hot;
    const col = hot.getSelectedRangeActive()?.highlight.col ?? 0;
    let row = hot.rowIndexMapper.getNearestNotHiddenIndex(hot.countRows() - 1, -1);
    if (row === null) {
      row = -1;
    }
    selection.setRangeStart(hot._createCellCoords(row, col));
  }
};
const command$e = {
  name: "moveCellSelectionToMostBottomInlineEnd",
  callback(hot) {
    const { selection, rowIndexMapper, columnIndexMapper } = hot;
    const fixedRows = Number(hot.getSettings().fixedRowsBottom) || 0;
    const row = rowIndexMapper.getNearestNotHiddenIndex(hot.countRows() - fixedRows - 1, -1);
    const column = columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1);
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(row ?? -1, column ?? -1));
    selection.markEndSource();
  }
};
const command$d = {
  name: "moveCellSelectionToMostInlineEnd",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(hot.getSelectedRangeActive()?.highlight.row ?? 0, columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1) ?? 0));
    selection.markEndSource();
  }
};
const command$c = {
  name: "moveCellSelectionToMostInlineStart",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const fixedColumns = Number(hot.getSettings().fixedColumnsStart) || 0;
    const row = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    const column = columnIndexMapper.getNearestNotHiddenIndex(fixedColumns, 1);
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(row, column ?? 0));
    selection.markEndSource();
  }
};
const command$b = {
  name: "moveCellSelectionToMostLeft",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const row = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    let column = hot.isRtl() ? columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1) : columnIndexMapper.getNearestNotHiddenIndex(0, 1);
    if (column === null) {
      column = hot.isRtl() ? -1 : -hot.countRowHeaders();
    }
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(row, column));
    selection.markEndSource();
  }
};
const command$a = {
  name: "moveCellSelectionToMostRight",
  callback(hot) {
    const { selection, columnIndexMapper } = hot;
    const row = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    let column = hot.isRtl() ? columnIndexMapper.getNearestNotHiddenIndex(0, 1) : columnIndexMapper.getNearestNotHiddenIndex(hot.countCols() - 1, -1);
    if (column === null) {
      column = hot.isRtl() ? -hot.countRowHeaders() : -1;
    }
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(row, column));
    selection.markEndSource();
  }
};
const command$9 = {
  name: "moveCellSelectionToMostTop",
  callback(hot) {
    const { selection } = hot;
    const col = hot.getSelectedRangeActive()?.highlight.col ?? 0;
    let row = hot.rowIndexMapper.getNearestNotHiddenIndex(0, 1);
    if (row === null) {
      row = -hot.countColHeaders();
    }
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(row, col));
    selection.markEndSource();
  }
};
const command$8 = {
  name: "moveCellSelectionToMostTopInlineStart",
  callback(hot) {
    const { selection, rowIndexMapper, columnIndexMapper } = hot;
    const fixedRows = Number(hot.getSettings().fixedRowsTop) || 0;
    const fixedColumns = Number(hot.getSettings().fixedColumnsStart) || 0;
    const row = rowIndexMapper.getNearestNotHiddenIndex(fixedRows, 1);
    const column = columnIndexMapper.getNearestNotHiddenIndex(fixedColumns, 1);
    selection.markSource("keyboard");
    selection.setRangeStart(hot._createCellCoords(row ?? 0, column ?? 0));
    selection.markEndSource();
  }
};
const command$7 = {
  name: "moveCellSelectionUp",
  callback({ selection }) {
    selection.markSource("keyboard");
    selection.transformStart(-1, 0);
    selection.markEndSource();
  }
};
const command$6 = {
  name: "moveCellSelectionUpByViewportHight",
  callback(hot) {
    const { selection } = hot;
    const { navigableHeaders } = hot.getSettings();
    const columnHeadersCount = navigableHeaders ? hot.countColHeaders() : 0;
    const row = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    let rowsStep = hot.countVisibleRows() + columnHeadersCount;
    rowsStep = rowsStep === 0 ? -1 : -rowsStep;
    if (row === -columnHeadersCount) {
      rowsStep = -1;
    } else if (row + rowsStep < columnHeadersCount) {
      rowsStep = -(row + columnHeadersCount);
    }
    selection.markSource("keyboard");
    selection.transformStart(rowsStep, 0);
    selection.markEndSource();
    const fixedRowsTop = hot.getSettings().fixedRowsTop ?? 0;
    const currentRow = hot.getSelectedRangeActive()?.highlight.row ?? 0;
    if (currentRow < fixedRowsTop) {
      hot.scrollViewportTo({
        row: fixedRowsTop,
        verticalSnap: "top"
      });
    }
  }
};
function getAllCommands() {
  return [
    command$l,
    command$k,
    command$j,
    command$i,
    command$h,
    command$g,
    command$f,
    command$e,
    command$d,
    command$c,
    command$b,
    command$a,
    command$9,
    command$8,
    command$7,
    command$6
  ];
}
const command$5 = {
  name: "emptySelectedCells",
  callback(hot) {
    hot.emptySelectedCells();
    hot._getEditorManager().prepareEditor();
  }
};
const command$4 = {
  name: "scrollToFocusedCell",
  callback(hot) {
    const highlight = hot.getSelectedRangeActive()?.highlight;
    if (!highlight) {
      return;
    }
    const firstVisibleRow = hot.getFirstFullyVisibleRow() - 1;
    const firstVisibleColumn = hot.getFirstFullyVisibleColumn() - 1;
    const lastVisibleRow = hot.getLastFullyVisibleRow() + 1;
    const lastVisibleColumn = hot.getLastFullyVisibleColumn() + 1;
    const visibleCoordsFrom = hot._createCellCoords(firstVisibleRow, firstVisibleColumn);
    const visibleCoordsTo = hot._createCellCoords(lastVisibleRow, lastVisibleColumn);
    const visibleRange = hot._createCellRange(visibleCoordsFrom, visibleCoordsFrom, visibleCoordsTo);
    if (!visibleRange.includes(highlight) && ((highlight.row ?? -1) >= 0 || (highlight.col ?? -1) >= 0)) {
      const scrollCoords = {};
      if ((highlight.col ?? -1) >= 0) {
        const offsetColumns = Math.floor(hot.countVisibleCols() / 2);
        scrollCoords.col = Math.max((highlight.col ?? 0) - offsetColumns, 0);
      }
      if ((highlight.row ?? -1) >= 0) {
        const offsetRows = Math.floor(hot.countVisibleRows() / 2);
        scrollCoords.row = Math.max((highlight.row ?? 0) - offsetRows, 0);
      }
      hot.scrollViewportTo({
        ...scrollCoords,
        verticalSnap: "top",
        horizontalSnap: "start"
      });
    }
  }
};
const command$3 = {
  name: "selectAllCells",
  callback({ selection }) {
    selection.markSource("keyboard");
    selection.selectAll(true, true, {
      disableHeadersHighlight: true
    });
    selection.markEndSource();
  }
};
const command$2 = {
  name: "selectAllCellsAndHeaders",
  callback({ selection }) {
    selection.markSource("keyboard");
    selection.selectAll(true, true, {
      disableHeadersHighlight: false
    });
    selection.markEndSource();
  }
};
const command$1 = {
  name: "populateSelectedCellsData",
  callback(hot) {
    const selectedRange = hot.getSelectedRange();
    if (!selectedRange) {
      return;
    }
    const normalizedHighlight = selectedRange[selectedRange.length - 1].highlight.normalize();
    const highlightRow = normalizedHighlight.row ?? 0;
    const highlightColumn = normalizedHighlight.col ?? 0;
    const valueToPopulate = hot.getDataAtCell(highlightRow, highlightColumn);
    const cellValues = /* @__PURE__ */ new Map();
    for (let i = 0; i < selectedRange.length; i++) {
      selectedRange[i].forAll((row, column) => {
        if (row >= 0 && column >= 0 && (row !== highlightRow || column !== highlightColumn)) {
          const { readOnly } = hot.getCellMeta(row, column);
          if (!readOnly) {
            cellValues.set(`${row}x${column}`, [
              row,
              column,
              valueToPopulate
            ]);
          }
        }
      });
    }
    hot.setDataAtCell(Array.from(cellValues.values()));
  }
};
const command = {
  name: "tabNavigation",
  callback(hot) {
    const rowWrapState = {
      wrapped: false,
      flipped: false
    };
    let isTabOrShiftTabPressed = false;
    let preventViewportScroll = false;
    hot.addHook("afterSelection", (row, column, row2, column2, preventScrolling) => {
      if (isTabOrShiftTabPressed && (rowWrapState.wrapped && rowWrapState.flipped || preventViewportScroll)) {
        preventViewportScroll = false;
        preventScrolling.value = true;
      }
    });
    hot.addHook("beforeRowWrap", (interruptedByAutoInsertMode, newCoords, isFlipped) => {
      rowWrapState.wrapped = true;
      rowWrapState.flipped = isFlipped;
    });
    return {
      before() {
        const { tabNavigation } = hot.getSettings();
        isTabOrShiftTabPressed = true;
        if (!tabNavigation) {
          preventViewportScroll = true;
        }
      },
      after(event) {
        const { tabNavigation, autoWrapRow } = hot.getSettings();
        isTabOrShiftTabPressed = false;
        if (!tabNavigation || !hot.selection.isSelected() || autoWrapRow && rowWrapState.wrapped && rowWrapState.flipped || !autoWrapRow && rowWrapState.wrapped) {
          rowWrapState.wrapped = false;
          rowWrapState.flipped = false;
          hot.deselectCell();
          return false;
        }
        event.preventDefault();
      }
    };
  }
};
const allCommands = [
  ...getAllCommands$2(),
  ...getAllCommands$1(),
  ...getAllCommands(),
  command$5,
  command$4,
  command$3,
  command$2,
  command$1,
  command
];
function createKeyboardShortcutCommandsPool(hot) {
  const commands = {};
  allCommands.forEach(({ name, callback }) => {
    commands[name] = (...args) => callback(hot, ...args);
  });
  return commands;
}
function shortcutsEditorContext(hot) {
  const context = hot.getShortcutManager().addContext(EDITOR_SCOPE);
  const commandsPool = createKeyboardShortcutCommandsPool(hot);
  const config = {
    group: EDITOR_EDIT_GROUP
  };
  context.addShortcuts([
    {
      keys: [
        [
          "Enter"
        ],
        [
          "Enter",
          "Shift"
        ]
      ],
      callback: (event, keys2) => commandsPool.editorCloseAndSaveByEnter(event, keys2)
    },
    {
      keys: [
        [
          "Enter",
          "Control/Meta"
        ],
        [
          "Enter",
          "Control/Meta",
          "Shift"
        ]
      ],
      captureCtrl: true,
      callback: (event, keys2) => commandsPool.editorCloseAndSaveByEnter(event, keys2)
    },
    {
      keys: [
        [
          "Tab"
        ],
        [
          "Tab",
          "Shift"
        ],
        [
          "PageDown"
        ],
        [
          "PageUp"
        ]
      ],
      forwardToContext: hot.getShortcutManager().getContext(GRID_SCOPE),
      callback: (event, keys2) => commandsPool.editorCloseAndSave(event, keys2)
    },
    {
      keys: [
        [
          "ArrowDown"
        ],
        [
          "ArrowUp"
        ],
        [
          "ArrowLeft"
        ],
        [
          "ArrowRight"
        ]
      ],
      preventDefault: false,
      callback: (event, keys2) => commandsPool.editorCloseAndSaveByArrowKeys(event, keys2)
    },
    {
      keys: [
        [
          "Escape"
        ],
        [
          "Escape",
          "Control/Meta"
        ]
      ],
      callback: () => commandsPool.editorCloseWithoutSaving()
    }
  ], config);
}
function shortcutsGridContext(hot) {
  const context = hot.getShortcutManager().addContext(GRID_SCOPE);
  const commandsPool = createKeyboardShortcutCommandsPool(hot);
  const config = {
    runOnlyIf: () => {
      const { navigableHeaders } = hot.getSettings();
      return isDefined(hot.getSelected()) && (navigableHeaders || !navigableHeaders && hot.countRenderedRows() > 0 && hot.countRenderedCols() > 0);
    },
    group: GRID_GROUP
  };
  context.addShortcuts([
    {
      keys: [
        [
          "F2"
        ]
      ],
      callback: (event) => commandsPool.editorFastOpen(event)
    },
    {
      keys: [
        [
          "Enter"
        ],
        [
          "Enter",
          "Shift"
        ]
      ],
      callback: (event, keys2) => commandsPool.editorOpen(event, keys2)
    },
    {
      keys: [
        [
          "Backspace"
        ],
        [
          "Delete"
        ]
      ],
      callback: () => commandsPool.emptySelectedCells()
    }
  ], {
    group: EDITOR_EDIT_GROUP,
    runOnlyIf: () => isDefined(hot.getSelected())
  });
  context.addShortcuts([
    {
      keys: [
        [
          "Control/Meta",
          "A"
        ]
      ],
      callback: () => commandsPool.selectAllCells(),
      runOnlyIf: () => isDefined(hot.getSelected()) && !hot.getSelectedRangeActive()?.highlight.isHeader()
    },
    {
      keys: [
        [
          "Control/Meta",
          "A"
        ]
      ],
      callback: () => {
      },
      runOnlyIf: () => !!(isDefined(hot.getSelected()) && hot.getSelectedRangeActive()?.highlight.isHeader()),
      preventDefault: true
    },
    {
      keys: [
        [
          "Control/Meta",
          "Shift",
          "Space"
        ]
      ],
      callback: () => commandsPool.selectAllCellsAndHeaders()
    },
    {
      keys: [
        [
          "Control/Meta",
          "Enter"
        ]
      ],
      callback: () => commandsPool.populateSelectedCellsData(),
      runOnlyIf: () => {
        return isDefined(hot.getSelected()) && !hot.getSelectedRangeActive()?.highlight.isHeader() && (hot.getSelectedRangeActive()?.getCellsCount() ?? 0) > 1;
      }
    },
    {
      keys: [
        [
          "Control",
          "Space"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.extendCellsSelectionToColumns()
    },
    {
      keys: [
        [
          "Shift",
          "Space"
        ]
      ],
      stopPropagation: true,
      callback: () => commandsPool.extendCellsSelectionToRows()
    },
    {
      keys: [
        [
          "ArrowUp"
        ]
      ],
      callback: () => commandsPool.moveCellSelectionUp()
    },
    {
      keys: [
        [
          "ArrowUp",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostTop()
    },
    {
      keys: [
        [
          "ArrowUp",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionUp()
    },
    {
      keys: [
        [
          "ArrowUp",
          "Shift",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.extendCellsSelectionToMostTop(),
      runOnlyIf: () => isDefined(hot.getSelected()) && !(hot.selection.isSelectedByCorner() || hot.selection.isSelectedByColumnHeader())
    },
    {
      keys: [
        [
          "ArrowDown"
        ]
      ],
      callback: () => commandsPool.moveCellSelectionDown()
    },
    {
      keys: [
        [
          "ArrowDown",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostBottom()
    },
    {
      keys: [
        [
          "ArrowDown",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionDown()
    },
    {
      keys: [
        [
          "ArrowDown",
          "Shift",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.extendCellsSelectionToMostBottom(),
      runOnlyIf: () => isDefined(hot.getSelected()) && !(hot.selection.isSelectedByCorner() || hot.selection.isSelectedByColumnHeader())
    },
    {
      keys: [
        [
          "ArrowLeft"
        ]
      ],
      callback: () => commandsPool.moveCellSelectionLeft()
    },
    {
      keys: [
        [
          "ArrowLeft",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostLeft()
    },
    {
      keys: [
        [
          "ArrowLeft",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionLeft()
    },
    {
      keys: [
        [
          "ArrowLeft",
          "Shift",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.extendCellsSelectionToMostLeft(),
      runOnlyIf: () => isDefined(hot.getSelected()) && !(hot.selection.isSelectedByCorner() || hot.selection.isSelectedByRowHeader())
    },
    {
      keys: [
        [
          "ArrowRight"
        ]
      ],
      callback: () => commandsPool.moveCellSelectionRight()
    },
    {
      keys: [
        [
          "ArrowRight",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostRight()
    },
    {
      keys: [
        [
          "ArrowRight",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionRight()
    },
    {
      keys: [
        [
          "ArrowRight",
          "Shift",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.extendCellsSelectionToMostRight(),
      runOnlyIf: () => isDefined(hot.getSelected()) && !(hot.selection.isSelectedByCorner() || hot.selection.isSelectedByRowHeader())
    },
    {
      keys: [
        [
          "Home"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostInlineStart(),
      runOnlyIf: () => isDefined(hot.getSelected()) && hot.view.isMainTableNotFullyCoveredByOverlays()
    },
    {
      keys: [
        [
          "Home",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionToMostInlineStart()
    },
    {
      keys: [
        [
          "Home",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostTopInlineStart(),
      runOnlyIf: () => isDefined(hot.getSelected()) && hot.view.isMainTableNotFullyCoveredByOverlays()
    },
    {
      keys: [
        [
          "End"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostInlineEnd(),
      runOnlyIf: () => isDefined(hot.getSelected()) && hot.view.isMainTableNotFullyCoveredByOverlays()
    },
    {
      keys: [
        [
          "End",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionToMostInlineEnd()
    },
    {
      keys: [
        [
          "End",
          "Control/Meta"
        ]
      ],
      captureCtrl: true,
      callback: () => commandsPool.moveCellSelectionToMostBottomInlineEnd(),
      runOnlyIf: () => isDefined(hot.getSelected()) && hot.view.isMainTableNotFullyCoveredByOverlays()
    },
    {
      keys: [
        [
          "PageUp"
        ]
      ],
      callback: () => commandsPool.moveCellSelectionUpByViewportHight()
    },
    {
      keys: [
        [
          "PageUp",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionUpByViewportHeight()
    },
    {
      keys: [
        [
          "PageDown"
        ]
      ],
      callback: () => commandsPool.moveCellSelectionDownByViewportHeight()
    },
    {
      keys: [
        [
          "PageDown",
          "Shift"
        ]
      ],
      callback: () => commandsPool.extendCellsSelectionDownByViewportHeight()
    },
    {
      keys: [
        [
          "Tab"
        ]
      ],
      preventDefault: false,
      callback: (event) => commandsPool.moveCellSelectionInlineStart(event)
    },
    {
      keys: [
        [
          "Shift",
          "Tab"
        ]
      ],
      preventDefault: false,
      callback: (event) => commandsPool.moveCellSelectionInlineEnd(event)
    },
    {
      keys: [
        [
          "Control/Meta",
          "Backspace"
        ]
      ],
      callback: () => commandsPool.scrollToFocusedCell()
    }
  ], config);
  const tabNavigationCommand = commandsPool.tabNavigation();
  context.addShortcuts([
    {
      keys: [
        [
          "Tab"
        ],
        [
          "Shift",
          "Tab"
        ]
      ],
      preventDefault: false,
      stopPropagation: false,
      relativeToGroup: GRID_GROUP,
      group: GRID_TAB_NAVIGATION_GROUP,
      position: "before",
      callback: (event) => tabNavigationCommand.before(event)
    },
    {
      keys: [
        [
          "Tab"
        ],
        [
          "Shift",
          "Tab"
        ]
      ],
      preventDefault: false,
      stopPropagation: false,
      relativeToGroup: GRID_GROUP,
      group: GRID_TAB_NAVIGATION_GROUP,
      callback: (event) => tabNavigationCommand.after(event),
      position: "after"
    }
  ]);
}
function registerAllShortcutContexts(hotInstance) {
  [
    shortcutsGridContext,
    shortcutsEditorContext
  ].forEach((context) => context(hotInstance));
}
function focusGridScope(hot) {
  const clampCoordsIfNeeded = normalizeCoordsIfNeeded(hot);
  const rowWrapState = {
    wrapped: false,
    flipped: false
  };
  let recentlyAddedFocusCoords;
  let isSavingCoordsEnabled = true;
  let isEmptyDataStateActive = false;
  hot.addHook("afterSelection", () => {
    if (isSavingCoordsEnabled) {
      recentlyAddedFocusCoords = hot.getSelectedRangeActive()?.highlight;
    }
  });
  hot.addHook("beforeRowWrap", (interruptedByAutoInsertMode, newCoords, isFlipped) => {
    rowWrapState.wrapped = true;
    rowWrapState.flipped = isFlipped;
  });
  hot.addHook("beforeEmptyDataStateShow", () => {
    isEmptyDataStateActive = true;
  });
  hot.addHook("beforeEmptyDataStateHide", () => {
    isEmptyDataStateActive = false;
  });
  const context = hot.getShortcutManager().getContext(GRID_SCOPE);
  context?.addShortcuts([
    {
      keys: [
        [
          "Tab"
        ],
        [
          "Shift",
          "Tab"
        ]
      ],
      preventDefault: false,
      stopPropagation: false,
      relativeToGroup: GRID_GROUP,
      group: GRID_TAB_NAVIGATION_GROUP,
      position: "before",
      callback() {
        const { tabNavigation } = hot.getSettings();
        if (hot.getSelectedRangeActive() && !tabNavigation) {
          isSavingCoordsEnabled = false;
        }
      }
    },
    {
      keys: [
        [
          "Tab"
        ],
        [
          "Shift",
          "Tab"
        ]
      ],
      preventDefault: false,
      stopPropagation: false,
      relativeToGroup: GRID_GROUP,
      group: GRID_TAB_NAVIGATION_GROUP,
      callback(event) {
        const { tabNavigation, autoWrapRow } = hot.getSettings();
        isSavingCoordsEnabled = true;
        if (!tabNavigation || !hot.selection.isSelected() || autoWrapRow && rowWrapState.wrapped && rowWrapState.flipped || !autoWrapRow && rowWrapState.wrapped) {
          if (autoWrapRow && rowWrapState.wrapped && rowWrapState.flipped) {
            const newCoords = event.shiftKey ? getMostTopStartPosition(hot) : getMostBottomEndPosition(hot);
            recentlyAddedFocusCoords = newCoords;
          }
          rowWrapState.wrapped = false;
          rowWrapState.flipped = false;
        }
      },
      position: "after"
    }
  ]);
  const container = hot.rootGridContentElement ?? hot.rootElement;
  hot.getFocusScopeManager().registerScope("grid", container, {
    contains: (target) => {
      if (container === target || container.contains(target)) {
        return true;
      }
      if (target.closest(".htMenu") !== null) {
        return false;
      }
      return hot.rootPortalElement.contains(target);
    },
    runOnlyIf: () => {
      const { navigableHeaders } = hot.getSettings();
      if ((isEmptyDataStateActive || !navigableHeaders) && hot.countRenderedRows() === 0 && hot.countRenderedCols() === 0 && hot.countRowHeaders() > 0 && hot.countColHeaders() > 0) {
        return false;
      }
      return !!(!navigableHeaders && hot.countRenderedRows() > 0 && hot.countRenderedCols() > 0 || navigableHeaders && (hot.countRowHeaders() > 0 || hot.countColHeaders() > 0));
    },
    onActivate: (focusSource) => {
      if (focusSource === "tab_from_above") {
        const mostTopStartCoords = clampCoordsIfNeeded(recentlyAddedFocusCoords) ?? getMostTopStartPosition(hot);
        if (mostTopStartCoords) {
          const result = hot.runHooks("modifyFocusOnTabNavigation", "from_above", mostTopStartCoords);
          const { row: topRow, col: topCol } = mostTopStartCoords;
          if (result !== false && topRow !== null && topCol !== null) {
            hot.selectCell(topRow, topCol);
            hot.getFocusManager().focusOnHighlightedCell();
          }
        }
      } else if (focusSource === "tab_from_below") {
        const mostBottomEndCoords = clampCoordsIfNeeded(recentlyAddedFocusCoords) ?? getMostBottomEndPosition(hot);
        if (mostBottomEndCoords) {
          const result = hot.runHooks("modifyFocusOnTabNavigation", "from_below", mostBottomEndCoords);
          const { row: bottomRow, col: bottomCol } = mostBottomEndCoords;
          if (result !== false && bottomRow !== null && bottomCol !== null) {
            hot.selectCell(bottomRow, bottomCol);
          }
        }
      }
    }
  });
}
function registerAllFocusScopes(hotInstance) {
  [
    focusGridScope
  ].forEach((scope) => scope(hotInstance));
}
const mappings = /* @__PURE__ */ new Map([
  [
    " ",
    "space"
  ],
  [
    "spacebar",
    "space"
  ],
  [
    "scroll",
    "scrolllock"
  ],
  [
    "del",
    "delete"
  ],
  [
    "esc",
    "escape"
  ],
  [
    "medianexttrack",
    "mediatracknext"
  ],
  [
    "mediaprevioustrack",
    "mediatrackprevious"
  ],
  [
    "volumeup",
    "audiovolumeup"
  ],
  [
    "volumedown",
    "audiovolumedown"
  ],
  [
    "volumemute",
    "audiovolumemute"
  ],
  [
    "multiply",
    "*"
  ],
  [
    "add",
    "+"
  ],
  [
    "divide",
    "/"
  ],
  [
    "subtract",
    "-"
  ],
  [
    "left",
    "arrowleft"
  ],
  [
    "right",
    "arrowright"
  ],
  [
    "up",
    "arrowup"
  ],
  [
    "down",
    "arrowdown"
  ]
]);
const normalizeKeys = (keys2) => {
  return keys2.map((key) => {
    const lowercaseKey = key.toLowerCase();
    if (mappings.has(lowercaseKey)) {
      return mappings.get(lowercaseKey) ?? lowercaseKey;
    }
    return lowercaseKey;
  }).sort((a, b) => a.localeCompare(b)).join("+");
};
const getKeysList = (normalizedKeys) => {
  return normalizedKeys.split("+");
};
const specialCharactersSet = /* @__PURE__ */ new Map([
  [
    96,
    "numpad0"
  ],
  [
    97,
    "numpad1"
  ],
  [
    98,
    "numpad2"
  ],
  [
    99,
    "numpad3"
  ],
  [
    100,
    "numpad4"
  ],
  [
    101,
    "numpad5"
  ],
  [
    102,
    "numpad6"
  ],
  [
    103,
    "numpad7"
  ],
  [
    104,
    "numpad8"
  ],
  [
    105,
    "numpad9"
  ],
  [
    106,
    "multiply"
  ],
  [
    107,
    "add"
  ],
  [
    108,
    "decimal"
  ],
  [
    109,
    "subtract"
  ],
  [
    110,
    "decimal"
  ],
  [
    111,
    "divide"
  ],
  [
    112,
    "f1"
  ],
  [
    113,
    "f2"
  ],
  [
    114,
    "f3"
  ],
  [
    115,
    "f4"
  ],
  [
    116,
    "f5"
  ],
  [
    117,
    "f6"
  ],
  [
    118,
    "f7"
  ],
  [
    119,
    "f8"
  ],
  [
    120,
    "f9"
  ],
  [
    121,
    "f10"
  ],
  [
    122,
    "f11"
  ],
  [
    123,
    "f12"
  ],
  [
    186,
    "semicolon"
  ],
  [
    187,
    "equal"
  ],
  [
    188,
    "comma"
  ],
  [
    189,
    "minus"
  ],
  [
    190,
    "period"
  ],
  [
    191,
    "slash"
  ],
  [
    192,
    "backquote"
  ],
  [
    219,
    "bracketleft"
  ],
  [
    220,
    "backslash"
  ],
  [
    221,
    "bracketright"
  ],
  [
    222,
    "quote"
  ]
]);
const normalizeEventKey = ({ which, key }) => {
  if (specialCharactersSet.has(which)) {
    return specialCharactersSet.get(which) ?? key.toLowerCase();
  }
  const normalizedKey = String.fromCharCode(which).toLowerCase();
  if (/^[a-z0-9]$/.test(normalizedKey)) {
    return normalizedKey;
  }
  return key.toLowerCase();
};
const MODIFIER_KEYS = [
  "meta",
  "alt",
  "shift",
  "control"
];
const isModifierKey = (pressedKey) => {
  return MODIFIER_KEYS.includes(pressedKey);
};
const getPressedModifierKeys = (event, mergeMetaKeys = false) => {
  const pressedModifierKeys = [];
  if (event.altKey) {
    pressedModifierKeys.push("alt");
  }
  if (mergeMetaKeys && (event.ctrlKey || event.metaKey)) {
    pressedModifierKeys.push("control/meta");
  } else {
    if (event.ctrlKey) {
      pressedModifierKeys.push("control");
    }
    if (event.metaKey) {
      pressedModifierKeys.push("meta");
    }
  }
  if (event.shiftKey) {
    pressedModifierKeys.push("shift");
  }
  return pressedModifierKeys;
};
const getEventKeyCombinations = (event, platformCheck) => {
  if (typeof event.key !== "string") {
    return [];
  }
  const pressedKey = normalizeEventKey(event);
  const modifier = isModifierKey(pressedKey);
  const modifiers = modifier ? [] : getPressedModifierKeys(event);
  const literal = [
    pressedKey
  ].concat(modifiers);
  const combinations = [
    literal
  ];
  if (!modifier) {
    const isMac = typeof platformCheck === "function" ? platformCheck() : false;
    const hasOsNativeModifier = isMac ? modifiers.includes("meta") : modifiers.includes("control");
    if (hasOsNativeModifier) {
      combinations.push([
        pressedKey
      ].concat(getPressedModifierKeys(event, true)));
    }
  }
  return combinations;
};
const __kindOf = /* @__PURE__ */ Symbol("shortcut-context");
function isContextObject(objectToCheck) {
  return isObject$1(objectToCheck) && objectToCheck.__kindOf === __kindOf;
}
const createContext = (name, scope = "table") => {
  const SHORTCUTS = createUniqueMap({
    errorIdExists: (keys2) => `The "${keys2}" shortcut is already registered in the "${name}" context.`
  });
  const addShortcut = ({ keys: keys2, callback, group, runOnlyIf = () => true, captureCtrl = false, preventDefault = true, stopPropagation = false, relativeToGroup, position, forwardToContext } = {}) => {
    if (isUndefined$1(group)) {
      throwWithCause("You need to define the shortcut's group.");
    }
    if (isFunction$1(callback) === false) {
      throwWithCause("The shortcut's callback needs to be a function.");
    }
    if (Array.isArray(keys2) === false) {
      throwWithCause(toSingleLine`Pass the shortcut\'s keys as an array of arrays,\x20
      using the KeyboardEvent.key properties:\x20
      declare https: //developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.`);
    }
    const newShortcut = {
      callback,
      group,
      runOnlyIf,
      captureCtrl,
      preventDefault,
      stopPropagation
    };
    if (isDefined(relativeToGroup)) {
      newShortcut.relativeToGroup = relativeToGroup;
      newShortcut.position = position;
    }
    if (isContextObject(forwardToContext)) {
      newShortcut.forwardToContext = forwardToContext;
    }
    keys2.forEach((keyCombination) => {
      const normalizedKeys = normalizeKeys(keyCombination);
      const hasKeyCombination = SHORTCUTS.hasItem(normalizedKeys);
      if (hasKeyCombination) {
        const shortcuts = SHORTCUTS.getItem(normalizedKeys);
        let insertionIndex = shortcuts.findIndex((shortcut) => shortcut.group === relativeToGroup);
        if (insertionIndex !== -1) {
          if (position === "before") {
            insertionIndex -= 1;
          } else {
            insertionIndex += 1;
          }
        } else {
          insertionIndex = shortcuts.length;
        }
        shortcuts.splice(insertionIndex, 0, newShortcut);
      } else {
        SHORTCUTS.addItem(normalizedKeys, [
          newShortcut
        ]);
      }
    });
  };
  const addShortcuts = (shortcuts, options = {}) => {
    shortcuts.forEach((shortcut) => {
      objectEach(options, (value, key) => {
        if (Object.prototype.hasOwnProperty.call(shortcut, key) === false) {
          shortcut[key] = options[key];
        }
      });
      addShortcut(shortcut);
    });
  };
  const removeShortcutsByKeys = (keys2) => {
    const normalizedKeys = normalizeKeys(keys2);
    SHORTCUTS.removeItem(normalizedKeys);
  };
  const removeShortcutsByGroup = (group) => {
    const shortcuts = SHORTCUTS.getItems();
    shortcuts.forEach(([normalizedKeys, shortcutOptions]) => {
      const typedOptions = shortcutOptions;
      const leftOptions = typedOptions.filter((option) => option.group !== group);
      if (leftOptions.length === 0) {
        removeShortcutsByKeys(getKeysList(normalizedKeys));
      } else {
        typedOptions.length = 0;
        typedOptions.push(...leftOptions);
      }
    });
  };
  const getShortcuts = (keys2) => {
    const normalizedKeys = normalizeKeys(keys2);
    const shortcuts = SHORTCUTS.getItem(normalizedKeys);
    return isDefined(shortcuts) ? shortcuts.slice() : [];
  };
  const hasShortcut = (keys2) => {
    const normalizedKeys = normalizeKeys(keys2);
    return SHORTCUTS.hasItem(normalizedKeys);
  };
  return {
    __kindOf,
    scope,
    addShortcut,
    addShortcuts,
    getShortcuts,
    hasShortcut,
    removeShortcutsByKeys,
    removeShortcutsByGroup
  };
};
function createKeysObserver() {
  const PRESSED_KEYS = /* @__PURE__ */ new Set();
  return {
    /**
    * Press a key.
    *
    * @param {string} key Names of the shortcut's keys,
    * (coming from [`KeyboardEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values)),
    * in lowercase or uppercase, unified across browsers
    */
    press(key) {
      PRESSED_KEYS.add(key);
    },
    /**
    * Release a pressed key.
    *
    * @param {string} key Names of the shortcut's keys,
    * (coming from [`KeyboardEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values)),
    * in lowercase or uppercase, unified across browsers
    */
    release(key) {
      PRESSED_KEYS.delete(key);
    },
    /**
    * Release all pressed keys.
    */
    releaseAll() {
      PRESSED_KEYS.clear();
    },
    /**
    * Check if a key is pressed.
    *
    * @param {string} key Names of the shortcut's keys,
    * (coming from [`KeyboardEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values)),
    * in lowercase or uppercase, unified across browsers
    * @returns {boolean}
    */
    isPressed(key) {
      return PRESSED_KEYS.has(key);
    }
  };
}
const modifierKeysObserver = createKeysObserver();
const modKeyListenerRefs = /* @__PURE__ */ new WeakMap();
const onkeydownForModKeys = (event) => {
  if (typeof event.key === "string") {
    const pressedKey = normalizeEventKey(event);
    if (isModifierKey(pressedKey)) {
      modifierKeysObserver.press(pressedKey);
    }
  }
};
const onkeyupForModKeys = (event) => {
  if (typeof event.key === "string") {
    const pressedKey = normalizeEventKey(event);
    if (isModifierKey(pressedKey)) {
      modifierKeysObserver.release(pressedKey);
    }
  }
};
function useRecorder(ownerWindow, handleEvent, beforeKeyDown, afterKeyDown, callback, dispatchGlobalShortcutsWhenTableBlocked = null) {
  const onkeydown = (event) => {
    const tableShortcutsAllowed = handleEvent(event) !== false;
    if (tableShortcutsAllowed) {
      const result = beforeKeyDown(event);
      if (result === false || event.keyCode === 229 || typeof event.key !== "string" || isImmediatePropagationStopped(event)) {
        return;
      }
      const pressedKey2 = normalizeEventKey(event);
      let extraModifierKeys2 = [];
      if (!isModifierKey(pressedKey2)) {
        extraModifierKeys2 = getPressedModifierKeys(event);
      }
      const pressedKeys2 = [
        pressedKey2
      ].concat(extraModifierKeys2);
      let isExecutionCancelled2 = callback(event, pressedKeys2);
      if (!isExecutionCancelled2 && (isMacOS() && extraModifierKeys2.includes("meta") || !isMacOS() && extraModifierKeys2.includes("control"))) {
        isExecutionCancelled2 = callback(event, [
          pressedKey2
        ].concat(getPressedModifierKeys(event, true)));
      }
      afterKeyDown(event);
      return;
    }
    if (isFunction$1(dispatchGlobalShortcutsWhenTableBlocked) === false) {
      return;
    }
    if (event.keyCode === 229 || typeof event.key !== "string" || isImmediatePropagationStopped(event)) {
      return;
    }
    const pressedKey = normalizeEventKey(event);
    let extraModifierKeys = [];
    if (!isModifierKey(pressedKey)) {
      extraModifierKeys = getPressedModifierKeys(event);
    }
    const pressedKeys = [
      pressedKey
    ].concat(extraModifierKeys);
    let isExecutionCancelled = dispatchGlobalShortcutsWhenTableBlocked(event, pressedKeys);
    if (!isExecutionCancelled && (isMacOS() && extraModifierKeys.includes("meta") || !isMacOS() && extraModifierKeys.includes("control"))) {
      isExecutionCancelled = dispatchGlobalShortcutsWhenTableBlocked(event, [
        pressedKey
      ].concat(getPressedModifierKeys(event, true)));
    }
    afterKeyDown(event);
  };
  const onblur = () => {
    modifierKeysObserver.releaseAll();
  };
  const mount = () => {
    let eventTarget = ownerWindow;
    while (eventTarget) {
      const { documentElement } = eventTarget.document;
      const refCount = modKeyListenerRefs.get(documentElement) ?? 0;
      if (refCount === 0) {
        documentElement.addEventListener("keydown", onkeydownForModKeys);
        documentElement.addEventListener("keyup", onkeyupForModKeys);
      }
      modKeyListenerRefs.set(documentElement, refCount + 1);
      documentElement.addEventListener("keydown", onkeydown);
      documentElement.addEventListener("blur", onblur);
      eventTarget = getParentWindow(eventTarget);
    }
  };
  const unmount = () => {
    let eventTarget = ownerWindow;
    while (eventTarget) {
      const { documentElement } = eventTarget.document;
      const refCount = modKeyListenerRefs.get(documentElement) ?? 0;
      if (refCount <= 1) {
        documentElement.removeEventListener("keydown", onkeydownForModKeys);
        documentElement.removeEventListener("keyup", onkeyupForModKeys);
        modKeyListenerRefs.delete(documentElement);
      } else {
        modKeyListenerRefs.set(documentElement, refCount - 1);
      }
      documentElement.removeEventListener("keydown", onkeydown);
      documentElement.removeEventListener("blur", onblur);
      eventTarget = getParentWindow(eventTarget);
    }
  };
  return {
    mount,
    unmount,
    isPressed: (key) => modifierKeysObserver.isPressed(key),
    releasePressedKeys: () => modifierKeysObserver.releaseAll()
  };
}
const createShortcutManager = ({ ownerWindow, handleEvent, beforeKeyDown, afterKeyDown }) => {
  const CONTEXTS = createUniqueMap({
    errorIdExists: (keys2) => `The "${keys2}" context name is already registered.`
  });
  let activeContextName = "grid";
  const addContext = (contextName, scope = "table") => {
    const context = createContext(contextName, scope);
    CONTEXTS.addItem(contextName, context);
    return context;
  };
  const getActiveContextName = () => {
    return activeContextName;
  };
  const getContext = (contextName) => {
    return CONTEXTS.getItem(contextName);
  };
  const getOrCreateContext = (contextName, scope = "table") => {
    return getContext(contextName) ?? addContext(contextName, scope);
  };
  const setActiveContextName = (contextName) => {
    if (!CONTEXTS.hasItem(contextName)) {
      throwWithCause(toSingleLine`You've tried to activate the "${contextName}" shortcut context\x20
        that does not exist. Before activation, register the context using the "addContext" method.`);
    }
    activeContextName = contextName;
  };
  let isCtrlKeySilenced = false;
  const recorderCallback = (event, keys2, context = getActiveContextName()) => {
    const activeContext = isContextObject(context) ? context : getContext(context);
    let isExecutionCancelled = false;
    if (!activeContext?.hasShortcut(keys2)) {
      return isExecutionCancelled;
    }
    const shortcuts = activeContext?.getShortcuts(keys2) ?? [];
    for (let index2 = 0; index2 < shortcuts.length; index2++) {
      const { callback, runOnlyIf, preventDefault, stopPropagation, captureCtrl, forwardToContext } = shortcuts[index2];
      if (runOnlyIf?.(event) === true) {
        isCtrlKeySilenced = captureCtrl ?? false;
        isExecutionCancelled = callback(event, keys2) === false;
        isCtrlKeySilenced = false;
        if (preventDefault) {
          event.preventDefault();
        }
        if (stopPropagation) {
          stopImmediatePropagation(event);
          event.stopPropagation();
        }
        if (isExecutionCancelled) {
          break;
        }
        if (forwardToContext) {
          recorderCallback(event, keys2, forwardToContext);
        }
      }
    }
    return isExecutionCancelled;
  };
  const handleEventWithScope = (event) => {
    const contextName = getActiveContextName();
    const activeContext = getContext(contextName);
    return handleEvent(event, activeContext?.scope ?? "table");
  };
  const runGlobalScopedShortcuts = (event, keys2) => {
    const items = CONTEXTS.getItems();
    for (let i = 0; i < items.length; i += 1) {
      const [, context] = items[i];
      if (context.scope !== "global") {
        continue;
      }
      if (recorderCallback(event, keys2, context)) {
        return true;
      }
    }
    return false;
  };
  const keyRecorder = useRecorder(ownerWindow, handleEventWithScope, beforeKeyDown, afterKeyDown, recorderCallback, runGlobalScopedShortcuts);
  keyRecorder.mount();
  const hasEventShortcut = (contextName, event) => {
    const context = getContext(contextName);
    if (!context) {
      return false;
    }
    const combinations = getEventKeyCombinations(event, isMacOS);
    return combinations.some((keys2) => context.hasShortcut(keys2));
  };
  return {
    addContext,
    getActiveContextName,
    getContext,
    getOrCreateContext,
    setActiveContextName,
    hasEventShortcut,
    /**
    * Returns whether `control` or `meta` keys are pressed.
    *
    * @memberof ShortcutManager#
    * @type {Function}
    * @returns {boolean}
    */
    isCtrlPressed: () => !isCtrlKeySilenced && (keyRecorder.isPressed("control") || keyRecorder.isPressed("meta")),
    /**
    * Release every previously pressed key.
    *
    * @type {Function}
    * @memberof ShortcutManager#
    */
    releasePressedKeys: () => keyRecorder.releasePressedKeys(),
    /**
    * Destroy a context manager instance.
    *
    * @type {Function}
    * @memberof ShortcutManager#
    */
    destroy: () => keyRecorder.unmount()
  };
};
function getThemeClassName(rootElement) {
  const { classNames } = findFirstParentWithClass(rootElement, /ht-theme-[a-zA-Z0-9_-]+/);
  return classNames.pop();
}
const handsontableStyles = '/*!\n * Copyright (c) HANDSONCODE sp. z o. o.\n *\n * HANDSONTABLE is a software distributed by HANDSONCODE sp. z o. o., a Polish corporation based in\n * Gdynia, Poland, at Aleja Zwyciestwa 96-98, registered by the District Court in Gdansk under number\n * 538651, EU tax ID number: PL5862294002, share capital: PLN 62,800.00.\n *\n * This software is protected by applicable copyright laws, including international treaties, and dual-\n * licensed - depending on whether your use for commercial purposes, meaning intended for or\n * resulting in commercial advantage or monetary compensation, or not.\n *\n * If your use is strictly personal or solely for evaluation purposes, meaning for the purposes of testing\n * the suitability, performance, and usefulness of this software outside the production environment,\n * you agree to be bound by the terms included in the "handsontable-non-commercial-license.pdf" file.\n *\n * Your use of this software for commercial purposes is subject to the terms included in an applicable\n * license agreement.\n *\n * In any case, you must not make any such use of this software as to develop software which may be\n * considered competitive with this software.\n *\n * UNLESS EXPRESSLY AGREED OTHERWISE, HANDSONCODE PROVIDES THIS SOFTWARE ON AN "AS IS"\n * BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, AND IN NO EVENT AND UNDER NO\n * LEGAL THEORY, SHALL HANDSONCODE BE LIABLE TO YOU FOR DAMAGES, INCLUDING ANY DIRECT,\n * INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY CHARACTER ARISING FROM\n * USE OR INABILITY TO USE THIS SOFTWARE.\n *\n * Version: 18.0.0\n * Release date: 30/06/2026 (built at 30/06/2026 08:45:31)\n */\n.ht-root-wrapper{font-family:var(--ht-font-family),-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;flex-direction:column;height:100%;display:flex;position:relative}:is(.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht-wrapper:not(.htHorizontallyScrollableByWindow) .ht_master .wtHolder,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht-wrapper:not(.htVerticallyScrollableByWindow) .ht_master .wtHolder,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .ht-wrapper:not(.htHorizontallyScrollableByWindow) .ht_master .wtHolder,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .ht-wrapper:not(.htVerticallyScrollableByWindow) .ht_master .wtHolder){background-color:var(--ht-background-color);box-shadow:inset 0 0 0 1px var(--ht-border-color)}.htFocusCatcher{opacity:0;z-index:-1;border:0;outline:0;width:0;height:0;margin:0;padding:0;position:absolute;display:block!important}.ht-grid{flex:auto;min-height:0;position:relative}.ht-grid-content{height:100%}.ht-slot-top,.ht-slot-bottom{flex:none}.ht-slot-element{box-sizing:border-box;border:1px solid var(--ht-border-color);width:100%}.ht-slot-top>.ht-slot-element:not(:first-of-type){border-top-width:0}.ht-slot-top>.ht-slot-element:last-of-type,.ht-slot-bottom>.ht-slot-element:not(:last-of-type){border-bottom-width:0}.ht-slot-bottom>.ht-slot-element:first-of-type{border-top-width:0}.htScrollbarTest{scrollbar-width:auto;scrollbar-color:var(--ht-scrollbar-thumb-color)var(--ht-scrollbar-track-color)}.htScrollbarSafariTest::-webkit-scrollbar{width:9px;height:9px}.handsontable{font-family:var(--ht-font-family),-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-size:var(--ht-font-size);line-height:var(--ht-line-height);font-weight:var(--ht-font-weight);letter-spacing:var(--ht-letter-spacing);color:var(--ht-foreground-color);touch-action:manipulation;position:relative}.handsontable .wtHolder{scrollbar-width:auto;scrollbar-color:var(--ht-scrollbar-thumb-color)var(--ht-scrollbar-track-color)}.handsontable .wtHolder::-webkit-scrollbar{width:9px;height:9px}.handsontable .wtHolder::-webkit-scrollbar-track{background:var(--ht-scrollbar-track-color);border-radius:var(--ht-scrollbar-border-radius)}.handsontable .wtHolder::-webkit-scrollbar-thumb{background-color:var(--ht-scrollbar-thumb-color);border-radius:var(--ht-scrollbar-border-radius)}.handsontable .wtHolder::-webkit-scrollbar-corner{background:var(--ht-scrollbar-track-color)}.handsontable .wtHolder:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))::-webkit-scrollbar-corner{border-bottom-right-radius:var(--ht-scrollbar-border-radius)}.handsontable .wtHolder:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))::-webkit-scrollbar-corner{border-bottom-left-radius:var(--ht-scrollbar-border-radius)}.handsontable.ht-wrapper{width:100%;height:100%}.handsontable.ht-wrapper:not(.htFirstDatasetColumnNotRendered) td:first-of-type{border-inline-start-width:1px}.handsontable.htGhostTable.htNestedHeaders table{border-spacing:0;border-collapse:collapse}.handsontable.htGhostTable table thead th{border-bottom-width:0}.handsontable.htGhostTable table tbody tr:first-of-type th:first-child,.handsontable.htGhostTable table tbody tr:first-of-type td:first-child{height:calc(var(--ht-cell-vertical-padding)*2 + var(--ht-line-height) + 1px)}.handsontable.htGhostTable table tbody tr th,.handsontable.htGhostTable table tbody tr td{height:calc(var(--ht-cell-vertical-padding)*2 + var(--ht-line-height) + 1px);border-top-width:0}.handsontable:not(.htHorizontallyScrollableByWindow).htHasScrollX .ht_master .wtHolder,.handsontable:not(.htHorizontallyScrollableByWindow).htHasScrollY .ht_master .wtHolder,.handsontable:not(.htVerticallyScrollableByWindow).htHasScrollX .ht_master .wtHolder,.handsontable:not(.htVerticallyScrollableByWindow).htHasScrollY .ht_master .wtHolder{background-color:var(--ht-background-color);box-shadow:inset 0 0 0 1px var(--ht-border-color)}.handsontable tr.ht__row_even th{background-color:var(--ht-row-header-even-background-color)}.handsontable tr.ht__row_even td{background-color:var(--ht-row-cell-even-background-color)}.handsontable tr.ht__row_odd th{background-color:var(--ht-row-header-odd-background-color)}.handsontable tr.ht__row_odd td{background-color:var(--ht-row-cell-odd-background-color)}.handsontable th,.handsontable td{height:calc(var(--ht-cell-vertical-padding)*2 + var(--ht-line-height) + 1px);padding:var(--ht-cell-vertical-padding)var(--ht-cell-horizontal-padding);vertical-align:top;border-top-width:0;border-inline-width:0 1px;font-size:var(--ht-font-size);line-height:var(--ht-line-height);white-space:pre-wrap;empty-cells:show;box-sizing:border-box;color:var(--ht-foreground-color);border-style:solid;border-bottom-width:1px;border-top-color:var(--ht-cell-vertical-border-color);border-bottom-color:var(--ht-cell-vertical-border-color);border-inline-start-color:var(--ht-cell-horizontal-border-color);border-inline-end-color:var(--ht-cell-horizontal-border-color);outline:0;overflow:hidden}.handsontable th.invisibleSelection,.handsontable td.invisibleSelection{outline:none}.handsontable th.invisibleSelection::selection,.handsontable td.invisibleSelection::selection{background:0 0}.handsontable th{text-align:center;font-weight:var(--ht-header-font-weight);white-space:nowrap;color:var(--ht-header-foreground-color);background-color:var(--ht-header-background-color);position:relative;overflow:visible}.handsontable th:last-child{border-inline-width:0 1px;border-bottom-width:1px;border-inline-end-color:var(--ht-border-color)}.handsontable th:last-child.ht__active_highlight{border-inline-end-color:var(--ht-header-active-border-color)}.handsontable th:first-child{border-inline-start-color:var(--ht-border-color)}.handsontable th:first-child.ht__active_highlight{border-inline-start-color:var(--ht-header-active-border-color)}.handsontable th:first-child,.handsontable th:nth-child(2){border-inline-start-width:1px}.handsontable th.current{box-shadow:inset 0 0 0 1px var(--ht-cell-selection-border-color)}.handsontable th.active{color:var(--ht-header-active-foreground-color);background-color:var(--ht-header-active-background-color)}.handsontable th.ht__highlight{color:var(--ht-header-highlighted-foreground-color);background-color:var(--ht-header-highlighted-background-color)}.handsontable th.ht__active_highlight{border-color:var(--ht-header-active-border-color);color:var(--ht-header-active-foreground-color);background-color:var(--ht-header-active-background-color)}.handsontable tbody tr.ht__row_odd th.ht__highlight,.handsontable tbody tr.ht__row_even th.ht__highlight{color:var(--ht-header-row-highlighted-foreground-color);background-color:var(--ht-header-row-highlighted-background-color)}.handsontable tbody tr.ht__row_odd th.ht__active_highlight,.handsontable tbody tr.ht__row_even th.ht__active_highlight{color:var(--ht-header-row-active-foreground-color);background-color:var(--ht-header-row-active-background-color)}.handsontable tbody tr:first-of-type th:first-child:empty:after,.handsontable tbody tr:first-of-type td:first-child:empty:after{content:"";min-height:var(--ht-line-height);display:block}.handsontable tbody tr th{color:var(--ht-header-row-foreground-color);background-color:var(--ht-header-row-background-color);padding:0}.handsontable tbody tr th.ht__active_highlight{box-shadow:0 -1px 0 0 var(--ht-header-active-border-color)}.handsontable tbody tr th .relative{padding:var(--ht-cell-vertical-padding)var(--ht-cell-horizontal-padding);min-height:100%}.handsontable tbody tr td:first-child{border-inline-start-color:var(--ht-border-color)}.handsontable tbody tr td:last-child{border-inline-end-color:var(--ht-border-color)}.handsontable thead tr th{padding:0}.handsontable thead tr th.ht__active_highlight{box-shadow:-1px 0 0 0 var(--ht-header-active-border-color)}.handsontable thead tr th .relative{padding:var(--ht-cell-vertical-padding)var(--ht-cell-horizontal-padding);flex-direction:row;align-items:center;gap:2px;display:flex}.handsontable thead tr th .relative .colHeader{text-overflow:ellipsis;vertical-align:top;flex:auto;min-width:0;overflow:hidden}.handsontable tr:first-child th,.handsontable tr:first-child td{border-top-color:var(--ht-border-color);border-top-width:1px}.handsontable tr:first-child th.ht__active_highlight,.handsontable tr:first-child td.ht__active_highlight{border-top-color:var(--ht-header-active-border-color)}.handsontable tr:last-child th,.handsontable tr:last-child td{border-bottom-color:var(--ht-border-color)}.handsontable tr:last-child th.ht__active_highlight,.handsontable tr:last-child td.ht__active_highlight{border-bottom-color:var(--ht-header-active-border-color)}.handsontable div[class^=ht_clone] thead .ht__highlight .relative:after{content:"";height:var(--ht-header-highlighted-shadow-size);background-color:var(--ht-accent-color);display:block;position:absolute;bottom:-1px;left:-1px;right:-1px}.handsontable div[class^=ht_clone] thead tr:only-of-type .ht__highlight .relative:after{bottom:0}.handsontable div[class^=ht_clone] tbody .ht__highlight .relative:after{content:"";width:var(--ht-header-highlighted-shadow-size);background-color:var(--ht-accent-color);display:block;position:absolute;top:-1px;bottom:-1px;right:-1px}.handsontable div[class^=ht_clone] td:first-of-type{border-inline-start-width:1px}.handsontable thead tr:not(:last-child) th{overflow:hidden}.handsontable .hide{display:none}.handsontable .relative{box-sizing:border-box;position:relative}.handsontable .wtHider{width:0}.handsontable .wtSpreader{width:0;height:auto;position:relative}.handsontable .htAutoSize{visibility:hidden;position:absolute;top:-99000px;left:-99000px}.handsontable .htTextEllipsis{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.handsontable table,.handsontable tbody,.handsontable thead,.handsontable input,.handsontable textarea,.handsontable div{box-sizing:content-box}.handsontable input,.handsontable textarea{min-height:initial}.handsontable .htCore{border-spacing:0;border-collapse:separate;table-layout:fixed;cursor:default;background-color:var(--ht-background-color);border-width:0;outline-width:0;width:0;margin:0}.handsontable col,.handsontable col.rowHeader{width:64px}.handsontable col.hidden{width:0!important}.handsontable span.colHeader,.handsontable span.rowHeader{font-size:var(--ht-font-size);line-height:var(--ht-line-height);display:inline-block}.handsontable tr.hidden,.handsontable tr.hidden td,.handsontable tr.hidden th{display:none}.handsontable a{color:var(--ht-link-color)}.handsontable a:hover{color:var(--ht-link-hover-color)}.handsontable .ht_clone_top th:nth-child(2),.handsontable .ht_clone_top_inline_start_corner th:nth-child(2){border-inline-width:0 1px}.handsontable.htRowHeaders thead tr th:nth-child(2){border-inline-start-width:1px}.handsontable .ht_master:not(.innerBorderInlineStart):not(.emptyColumns) tbody tr th,.handsontable .ht_master:not(.innerBorderInlineStart):not(.emptyColumns) thead tr th:first-child,.handsontable .ht_master:not(.innerBorderInlineStart):not(.emptyColumns)~.handsontable:not(.htGhostTable) tbody tr th,.handsontable .ht_master:not(.innerBorderInlineStart):not(.emptyColumns)~.handsontable:not(.ht_clone_top):not(.htGhostTable) thead tr th:first-child{border-inline-width:1px 0}.handsontable .ht_master:not(.innerBorderTop):not(.innerBorderBottom) thead tr:last-child th,.handsontable .ht_master:not(.innerBorderTop):not(.innerBorderBottom)~.handsontable thead tr:last-child th,.handsontable .ht_master:not(.innerBorderTop):not(.innerBorderBottom) thead tr.lastChild th,.handsontable .ht_master:not(.innerBorderTop):not(.innerBorderBottom)~.handsontable thead tr.lastChild th{border-bottom-width:0}.handsontable.htAutoRowSize .ht_master.innerBorderTop tbody tr:first-child th,.handsontable.htAutoRowSize .ht_master.innerBorderTop tbody tr:first-child td,.handsontable.htAutoRowSize .ht_master.innerBorderTop~.ht_clone_inline_start tbody tr:first-child th,.handsontable.htAutoRowSize .ht_master.innerBorderTop~.ht_clone_inline_start tbody tr:first-child td{border-top-width:0}.handsontable .ht_master table.htCore>thead,.handsontable .ht_master table.htCore>tbody>tr>th,.handsontable .ht_clone_inline_start table.htCore>thead{visibility:hidden}.ht_master,.ht_clone_inline_start,.ht_clone_top,.ht_clone_bottom,.ht_master .wtHolder,.ht_clone_inline_start .wtHolder,.ht_clone_top .wtHolder,.ht_clone_bottom .wtHolder{overflow:hidden}.ht_master .wtHolder{overflow:auto}[dir=rtl].handsontable td[dir=ltr]{border-inline-width:1px 0}[dir=rtl].handsontable tbody tr td[dir=ltr]:last-child{border-inline-start-color:var(--ht-border-color)}[dir=rtl].handsontable div[class^=ht_clone] tbody .ht__highlight .relative:after{left:-1px;right:auto}.handsontable.ht-wrapper{border-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_master .htCore tbody tr:first-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_master .htCore tbody tr:first-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_master .htCore tbody tr:first-child td:last-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_master .htCore tbody tr:first-child td:last-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_top_inline_start_corner .htCore tbody tr:first-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_top_inline_start_corner .htCore tbody tr:first-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_top .htCore tbody tr:first-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_top .htCore tbody tr:first-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_top .htCore tbody tr:first-child td:last-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_top .htCore tbody tr:first-child td:last-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_inline_start .htCore tbody tr:first-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_inline_start .htCore tbody tr:first-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-top-left-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_inline_start .htCore tbody tr:first-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper:not(.htColumnHeaders) .ht_clone_inline_start .htCore tbody tr:first-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .wtHolder,.handsontable.ht-wrapper .ht_master .htCore{border-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:first-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:first-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore tbody tr:last-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore tbody tr:last-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore tbody tr:last-child td:last-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_master .htCore tbody tr:last-child td:last-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top_inline_start_corner .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top_inline_start_corner .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top_inline_start_corner .htCore thead tr:first-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top_inline_start_corner .htCore thead tr:first-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius);border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius);border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top .htCore thead tr:first-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top .htCore thead tr:first-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_top .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_inline_start .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius);border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_inline_start .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius);border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_inline_start .htCore thead tr:first-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_inline_start .htCore thead tr:first-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_inline_start .htCore tbody tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_inline_start .htCore tbody tr:last-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-left-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_inline_start .htCore tbody tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_inline_start .htCore tbody tr:last-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_bottom_inline_start_corner .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_bottom_inline_start_corner .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_bottom_inline_start_corner .htCore tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_bottom_inline_start_corner .htCore tr:last-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-left-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_bottom_inline_start_corner .htCore tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_bottom_inline_start_corner .htCore tr:last-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-right-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_bottom .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:var(--ht-border-radius);border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper .ht_clone_bottom .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:var(--ht-border-radius);border-bottom-right-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-left-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-right-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child th:last-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child td:last-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-right-radius:var(--ht-border-radius)}:is(.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child th:last-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper .ht_clone_bottom .htCore tr:last-child td:last-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-left-radius:var(--ht-border-radius)}.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}:is(.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore thead tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child td:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-left-radius:0}:is(.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore thead tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child td:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi))){border-bottom-right-radius:0}:is(.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child td:last-child,.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child th:last-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0}:is(.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child td:last-child,.handsontable.ht-wrapper.htHasScrollX:not(.htHorizontallyScrollableByWindow) .htCore tbody tr:last-child th:last-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:0}.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:0;border-bottom-right-radius:0}.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-bottom-left-radius:0}:is(.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:first-child td:last-child,.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:first-child th:last-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:0}:is(.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:first-child td:last-child,.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:first-child th:last-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0}:is(.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:last-child td:last-child,.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:last-child th:last-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0}:is(.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:last-child td:last-child,.handsontable.ht-wrapper.htHasScrollY:not(.htVerticallyScrollableByWindow) .htCore tbody tr:last-child th:last-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:0}.ht-root-wrapper{border-radius:var(--ht-border-radius)}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht-wrapper:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht-wrapper:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht_master .wtHolder:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht_master .wtHolder:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore thead tr:last-child th:first-child,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child td:first-child,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child th:first-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore thead tr:last-child th:first-child,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child td:first-child,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child th:first-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child td:last-child,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child th:last-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore thead tr:last-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child td:last-child,.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .htCore tbody tr:last-child th:last-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .ht-wrapper:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .ht-wrapper:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .ht_master .wtHolder:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .ht_master .wtHolder:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore thead tr:first-child th:first-child,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child td:first-child,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child th:first-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore thead tr:first-child th:first-child,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child td:first-child,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child th:first-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child td:last-child,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child th:last-child):not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:0}:is(.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore thead tr:first-child th:not(.hiddenHeader):not(:has(~th:not(.hiddenHeader))),.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child td:last-child,.ht-root-wrapper:has(>.ht-slot-top>.ht-slot-element) .htCore tbody tr:first-child th:last-child):is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0}.ht-root-wrapper .ht-slot-element{border-radius:var(--ht-border-radius)}.ht-root-wrapper .ht-slot-bottom>.ht-slot-element:not(:last-of-type){border-radius:0}.ht-root-wrapper .ht-slot-bottom>.ht-slot-element:last-of-type:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.ht-root-wrapper .ht-slot-bottom>.ht-slot-element:last-of-type:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-root-wrapper .ht-slot-top>.ht-slot-element:not(:first-of-type){border-radius:0}.ht-root-wrapper .ht-slot-top>.ht-slot-element:first-of-type:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.ht-root-wrapper .ht-slot-top>.ht-slot-element:first-of-type:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.handsontable.mobile,.handsontable.mobile .wtHolder{-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:#0000;-webkit-overflow-scrolling:touch}.handsontable.mobile .handsontableInput:focus{box-shadow:inset 0 0 0 2px var(--ht-accent-color);-webkit-appearance:none}.handsontable .topSelectionHandle,.handsontable .topSelectionHandle-HitArea,.handsontable .bottomSelectionHandle,.handsontable .bottomSelectionHandle-HitArea{inset-inline-start:-10000px;inset-inline-end:unset;z-index:9999;top:-10000px}.handsontable.hide-tween{animation:.2s forwards opacity-hide}.handsontable.show-tween{animation:.3s forwards opacity-show}.ht_clone_master{z-index:100}.ht_clone_inline_start{z-index:120}.ht_clone_bottom{z-index:130}.ht_clone_bottom_inline_start_corner{z-index:150}.ht_clone_top{z-index:160}.ht_clone_top_inline_start_corner{z-index:180}.ht_editor_hidden{z-index:-1}.ht_editor_visible{z-index:200}.handsontable td.area{position:relative}.handsontable td.area:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-1{position:relative}.handsontable td.area-1:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-2{position:relative}.handsontable td.area-2:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-3{position:relative}.handsontable td.area-3:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-4{position:relative}.handsontable td.area-4:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-5{position:relative}.handsontable td.area-5:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-6{position:relative}.handsontable td.area-6:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area-7{position:relative}.handsontable td.area-7:before{content:"";background:var(--ht-cell-selection-background-color,#1a42e8);position:absolute;inset:0}.handsontable td.area:before{opacity:.14}.handsontable td.area-1:before{opacity:.21}.handsontable td.area-2:before{opacity:.28}.handsontable td.area-3:before{opacity:.35}.handsontable td.area-4:before{opacity:.42}.handsontable td.area-5:before{opacity:.49}.handsontable td.area-6:before{opacity:.56}.handsontable td.area-7:before{opacity:.63}.handsontable td.area{border-color:color-mix(in srgb,var(--ht-border-color),var(--ht-foreground-color)10%)}.handsontable .wtBorder{font-size:0;position:absolute}.handsontable .wtBorder:first-child,.handsontable .wtBorder:nth-child(3){z-index:2}.handsontable .wtBorder:nth-child(2),.handsontable .wtBorder:nth-child(4){z-index:1}.handsontable .wtBorder.hidden{display:none!important}.handsontable .wtBorder.current{z-index:10;background-color:var(--ht-cell-selection-border-color)!important}.handsontable .wtBorder.area{z-index:8;background-color:var(--ht-cell-selection-border-color)!important}.handsontable .wtBorder.fill{z-index:6;background-color:var(--ht-cell-autofill-fill-border-color,#68696c)!important}.handsontable .wtBorder.corner{cursor:crosshair;z-index:10;font-size:0;border-radius:var(--ht-cell-autofill-border-radius)!important;background-color:var(--ht-cell-autofill-background-color,#1a42e8)!important;border-color:var(--ht-cell-autofill-border-color)!important}.handsontable .wtBorder.corner:after{content:"";border-radius:var(--ht-cell-autofill-border-radius);inset:min(0px,(var(--ht-cell-autofill-size) - var(--ht-cell-autofill-hit-area-size))/2);background:0 0;position:absolute}.handsontable .wtBorder.corner.wtCornerInlineEndEdge:after{inset-inline-end:0}.handsontable .wtBorder.corner.wtCornerBlockEndEdge:after{inset-block-end:0}.hot-display-license-info{font-family:var(--ht-font-family),-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;padding:var(--ht-license-vertical-padding,16px)var(--ht-license-horizontal-padding,16px);font-size:var(--ht-font-size-small);line-height:var(--ht-line-height-small);color:var(--ht-license-foreground-color);background-color:var(--ht-license-background-color,#f7f7f9);text-align:left}.hot-display-license-info a{font-size:var(--ht-license-font-size);color:var(--ht-link-color)}.hot-display-license-info a:hover{color:var(--ht-link-hover-color)}.handsontable .htAutocompleteArrow{cursor:default;width:var(--ht-icon-size);height:var(--ht-icon-size);float:right;top:calc((var(--ht-line-height) - var(--ht-icon-size))/2);margin-inline-start:calc(var(--ht-gap-size)*2);margin-inline-end:1px;font-size:0;position:relative}.handsontable .htAutocompleteArrow:after{content:"";opacity:.6;display:block;position:absolute;top:0;left:0}[dir=rtl].handsontable .htAutocompleteArrow{float:left}.handsontable .htCheckboxRendererInput{width:var(--ht-checkbox-size);height:var(--ht-checkbox-size);vertical-align:middle;cursor:pointer;margin:0;outline:none;margin-top:-2px;display:inline-block;position:relative}.handsontable .htCheckboxRendererInput:first-child{margin-inline-end:var(--ht-gap-size)}.handsontable .htCheckboxRendererInput:last-child{margin-inline-start:var(--ht-gap-size)}.handsontable .htCheckboxRendererInput:before{content:"";width:var(--ht-checkbox-size);height:var(--ht-checkbox-size);border-radius:var(--ht-checkbox-border-radius);border:1px solid var(--ht-checkbox-border-color);background-color:var(--ht-checkbox-background-color);box-sizing:border-box;pointer-events:none;transition:all var(--ht-table-transition)ease-in-out;display:inline-block;position:absolute;top:0;left:0}.handsontable .htCheckboxRendererInput:after{content:"";color:var(--ht-checkbox-icon-color);pointer-events:none;display:block;position:absolute;top:0;left:0;width:var(--ht-checkbox-size)!important;height:var(--ht-checkbox-size)!important}.handsontable .htCheckboxRendererInput:checked:before{border-color:var(--ht-checkbox-checked-border-color);background-color:var(--ht-checkbox-checked-background-color)}.handsontable .htCheckboxRendererInput:checked:after{color:var(--ht-checkbox-checked-icon-color)}.handsontable .htCheckboxRendererInput:checked:disabled:before{border-color:var(--ht-checkbox-checked-disabled-border-color);background-color:var(--ht-checkbox-checked-disabled-background-color)}.handsontable .htCheckboxRendererInput:checked:disabled:after{color:var(--ht-checkbox-checked-disabled-icon-color)}.handsontable .htCheckboxRendererInput:checked:focus:before{border-color:var(--ht-checkbox-checked-focus-border-color);background-color:var(--ht-checkbox-checked-focus-background-color)}.handsontable .htCheckboxRendererInput:checked:focus:after{color:var(--ht-checkbox-checked-focus-icon-color)}.handsontable .htCheckboxRendererInput:focus:before{border-color:var(--ht-checkbox-focus-border-color);background-color:var(--ht-checkbox-focus-background-color);outline:1px solid var(--ht-checkbox-focus-ring-color)}.handsontable .htCheckboxRendererInput:focus:after{color:var(--ht-checkbox-focus-icon-color)}.handsontable .htCheckboxRendererInput:disabled{cursor:initial}.handsontable .htCheckboxRendererInput:disabled:before{border-color:var(--ht-checkbox-disabled-border-color);background-color:var(--ht-checkbox-disabled-background-color)}.handsontable .htCheckboxRendererInput:disabled:after{color:var(--ht-checkbox-disabled-icon-color)}.handsontable .htCheckboxRendererInput:indeterminate:before{border-color:var(--ht-checkbox-indeterminate-border-color);background-color:var(--ht-checkbox-indeterminate-background-color)}.handsontable .htCheckboxRendererInput:indeterminate:after{color:var(--ht-checkbox-indeterminate-icon-color)}.handsontable .htCheckboxRendererInput:indeterminate:disabled:before{border-color:var(--ht-checkbox-indeterminate-disabled-border-color);background-color:var(--ht-checkbox-indeterminate-disabled-background-color)}.handsontable .htCheckboxRendererInput:indeterminate:disabled:after{color:var(--ht-checkbox-indeterminate-disabled-icon-color)}.handsontable .htCheckboxRendererInput:indeterminate:focus:before{border-color:var(--ht-checkbox-indeterminate-focus-border-color);background-color:var(--ht-checkbox-indeterminate-focus-background-color)}.handsontable .htCheckboxRendererInput:indeterminate:focus:after{color:var(--ht-checkbox-indeterminate-focus-icon-color)}.handsontable .htCheckboxRendererInput.noValue{opacity:.5}.handsontable .htCheckboxRendererLabel{font-size:inherit;line-height:inherit;cursor:pointer;color:inherit;margin:0;display:inline-block;position:relative}.handsontable .htCheckboxRendererLabel.fullWidth{width:100%}.handsontable .htPlaceholder{color:var(--ht-placeholder-color)}.handsontable .htDimmed{color:var(--ht-read-only-color)!important;background-color:var(--ht-cell-read-only-background-color)!important}.handsontable .htLeft{text-align:left}.handsontable .htCenter{text-align:center}.handsontable .htRight{text-align:right}.handsontable .htJustify{text-align:justify}.handsontable .htTop{vertical-align:top}.handsontable .htMiddle{vertical-align:middle}.handsontable .htBottom{vertical-align:bottom}.handsontable .htInvalid{background-color:var(--ht-cell-error-background-color)!important}.handsontable .htNoWrap{white-space:nowrap}.handsontable .htSearchResult{background-color:var(--ht-cell-success-background-color)!important}.handsontable .ht-multi-select-renderer{padding:var(--ht-cell-vertical-padding)var(--ht-cell-horizontal-padding);overflow:hidden}.handsontable .ht-multi-select-chips-container{align-items:center;gap:var(--ht-gap-size);flex-wrap:nowrap;max-width:100%;display:flex;overflow:hidden}.handsontable .ht-multi-select-chip{align-items:center;gap:var(--ht-gap-size);padding:var(--ht-chip-vertical-padding)calc((var(--ht-line-height) - var(--ht-icon-size))/2)var(--ht-chip-vertical-padding)var(--ht-chip-horizontal-padding);border-radius:var(--ht-chip-border-radius);background:var(--ht-chip-background);white-space:nowrap;box-sizing:border-box;flex-shrink:0;max-width:100px;display:inline-flex}.handsontable .ht-multi-select-chip-label{text-overflow:ellipsis;color:var(--ht-foreground-color);font-style:normal;font-weight:var(--ht-font-weight);line-height:var(--ht-line-height,40px);letter-spacing:var(--ht-letter-spacing,0);padding:0 var(--ht-chip-gap);overflow:hidden}.handsontable .ht-multi-select-chip-remove{cursor:pointer;color:var(--ht-icon-button-icon-color);background-position:50%;background-repeat:no-repeat;background-size:contain;flex-shrink:0;justify-content:center;align-items:center;padding:0;display:flex;position:relative;width:var(--ht-icon-size)!important;height:var(--ht-icon-size)!important}.handsontable .ht-multi-select-chip-remove:before{content:"";display:block;position:absolute;top:0;left:0}.handsontable .ht-multi-select-chip-remove:hover{background-color:var(--ht-icon-button-hover-background-color)}.handsontable .ht-multi-select-overflow{padding:var(--ht-chip-vertical-padding)var(--ht-chip-horizontal-padding);background:var(--ht-chip-background);border-radius:var(--ht-chip-border-radius);color:var(--ht-foreground-color);white-space:nowrap;flex-shrink:0;justify-content:center;align-items:center;display:inline-flex}.handsontableInputHolder{position:absolute;top:0;left:0}.handsontableInputHolder .handsontableInput{padding:calc(var(--ht-cell-vertical-padding,4px) + 1px)calc(var(--ht-cell-horizontal-padding,8px) + 1px);color:var(--ht-cell-editor-foreground-color);background-color:var(--ht-cell-editor-background-color,#fff);box-shadow:inset 0 0 0 var(--ht-cell-editor-border-width,2px)var(--ht-cell-editor-border-color,#1a42e8),0 0 var(--ht-cell-editor-shadow-blur-radius,0)0 var(--ht-cell-editor-shadow-color,transparent);box-sizing:border-box;border:none;border-radius:0;outline-width:0;margin:0;display:block;font-family:inherit!important;font-size:inherit!important;line-height:inherit!important;-webkit-appearance:none!important}.handsontableInputHolder .handsontableInput:focus{outline:none}.htSelectEditor{position:absolute}.htSelectEditor select{width:100%;height:100%;padding:calc(var(--ht-cell-vertical-padding,4px) + 1px)calc(var(--ht-cell-horizontal-padding,8px) + 1px);white-space:nowrap;text-overflow:ellipsis;color:var(--ht-cell-editor-foreground-color);background-color:var(--ht-cell-editor-background-color,#fff);box-shadow:inset 0 0 0 var(--ht-cell-editor-border-width,2px)var(--ht-cell-editor-border-color,#1a42e8),0 0 var(--ht-cell-editor-shadow-blur-radius,0)0 var(--ht-cell-editor-shadow-color,transparent);box-sizing:border-box;border:none;border-radius:0;margin:0;padding-inline-end:26px;position:absolute;inset:0;overflow:hidden;font-family:inherit!important;font-size:inherit!important;line-height:inherit!important;-webkit-appearance:none!important}.htSelectEditor select:focus{outline:none}.htSelectEditor .htAutocompleteArrow{z-index:1;pointer-events:none;margin-inline-end:4px;top:50%;transform:translateY(-50%)}.handsontable.listbox{box-shadow:var(--ht-menu-shadow-x,0)var(--ht-menu-shadow-y,0)var(--ht-menu-shadow-blur,8px)color-mix(in srgb,var(--ht-menu-shadow-color,#000)var(--ht-menu-shadow-opacity,100%),transparent);border:var(--ht-menu-border-width,1px)solid var(--ht-menu-border-color,#e5e5e9);margin:0}.handsontable.listbox .ht_master{background-color:var(--ht-background-color);overflow:hidden}.handsontable.listbox .wtHolder{overflow:auto;border-radius:0!important}.handsontable.listbox .wtHider,.handsontable.listbox .htCore{border-radius:0!important}.handsontable.listbox table{overflow:hidden}.handsontable.listbox table th,.handsontable.listbox table tr:first-child th,.handsontable.listbox table tr:last-child th,.handsontable.listbox table tr:first-child td,.handsontable.listbox table td{border-color:#0000!important}.handsontable.listbox table th,.handsontable.listbox table td{white-space:nowrap;text-overflow:ellipsis;border-radius:0!important}.handsontable.listbox table .wtBorder{visibility:hidden}.handsontable.listbox table strong{color:inherit;font-weight:700}.handsontable.listbox table tr td:hover td{cursor:pointer;background:color-mix(in srgb,var(--ht-menu-item-hover-color)var(--ht-menu-item-hover-color-opacity,100%),transparent)!important;box-shadow:none!important}.handsontable.listbox table td{transition:var(--ht-table-transition)background ease-in-out}.handsontable.listbox table td:hover{cursor:pointer;background-color:color-mix(in srgb,var(--ht-menu-item-hover-color)var(--ht-menu-item-hover-color-opacity,100%),transparent)!important}.handsontable.listbox table td.current:not([aria-expanded=true]){box-shadow:inset 0 0 0 1px var(--ht-accent-color)}.handsontable.listbox table td.htDimmed{cursor:default;font-style:inherit;color:inherit!important}.handsontable.listbox table td.htDimmed:not(.handsontable.listbox table td:hover){background-color:inherit!important}.handsontable.listbox table thead th{text-align:left;height:auto!important}.handsontable.listbox table thead th .relative{padding-top:calc(var(--ht-cell-vertical-padding) + var(--ht-gap-size));padding-bottom:calc(var(--ht-cell-vertical-padding) + var(--ht-gap-size))}.handsontable.listbox .ht_clone_top .wtHider{overflow:hidden}.handsontable.listbox .ht_clone_top table{border-radius:0}.handsontable.listbox .htBorders div{background:0 0!important}.handsontable.autocompleteEditor tr.ht__row_even th,.handsontable.autocompleteEditor tr.ht__row_even td,.handsontable.autocompleteEditor tr.ht__row_odd th,.handsontable.autocompleteEditor tr.ht__row_odd td{background-color:var(--ht-background-color,#fff)}[dir=rtl].handsontable.listbox table thead th{text-align:right}.handsontableEditor{position:absolute}.handsontableEditor .ht-multi-select-editor{box-shadow:var(--ht-menu-shadow-x,0)var(--ht-menu-shadow-y,0)var(--ht-menu-shadow-blur,8px)color-mix(in srgb,var(--ht-menu-shadow-color,#000)var(--ht-menu-shadow-opacity,100%),transparent);scrollbar-width:auto;scrollbar-color:var(--ht-scrollbar-thumb-color)var(--ht-scrollbar-track-color);border-radius:0 0 var(--ht-menu-border-radius)var(--ht-menu-border-radius);border:var(--ht-menu-border-width)solid var(--ht-menu-border-color);background:var(--ht-background-color);width:max-content;min-width:120px;padding:var(--ht-menu-vertical-padding)var(--ht-menu-horizontal-padding);overflow-y:auto}.handsontableEditor .ht-multi-select-editor .ht-multi-select-editor-search-input-wrapper{padding:var(--ht-menu-item-vertical-padding)var(--ht-menu-item-horizontal-padding);align-items:center;gap:var(--ht-gap-size);align-self:stretch;display:flex;position:relative}.handsontableEditor .ht-multi-select-editor .ht-multi-select-editor-search-icon{left:calc(var(--ht-menu-item-horizontal-padding) + 10px);opacity:.5;pointer-events:none;z-index:1;background-position:50%;background-repeat:no-repeat;background-size:contain;width:16px;height:16px;position:absolute;top:50%;transform:translateY(-50%)}.handsontableEditor .ht-multi-select-editor input.ht-multi-select-editor-search-input{box-sizing:border-box;border-radius:var(--ht-input-border-radius);width:100%;color:var(--ht-input-foreground-color);background-color:var(--ht-input-background-color);border:1px solid var(--ht-input-border-color);transition:var(--ht-table-transition)all ease-in-out;line-height:var(--ht-line-height);font-size:var(--ht-font-size);padding:var(--ht-input-vertical-padding)var(--ht-menu-item-horizontal-padding)var(--ht-input-vertical-padding)32px}.handsontableEditor .ht-multi-select-editor input.ht-multi-select-editor-search-input:hover{border-color:var(--ht-input-hover-border-color);color:var(--ht-input-hover-foreground-color);background-color:var(--ht-input-hover-background-color)}.handsontableEditor .ht-multi-select-editor input.ht-multi-select-editor-search-input:disabled{border-color:var(--ht-input-disabled-border-color);color:var(--ht-input-disabled-foreground-color);background-color:var(--ht-input-disabled-background-color)}.handsontableEditor .ht-multi-select-editor input.ht-multi-select-editor-search-input:focus{border-color:var(--ht-input-focus-border-color);color:var(--ht-input-focus-foreground-color);background-color:var(--ht-input-focus-background-color);outline-offset:0;box-shadow:none;outline:none}.handsontableEditor .ht-multi-select-editor input.ht-multi-select-editor-search-input::placeholder{color:var(--ht-foreground-color);opacity:.6}.handsontableEditor .ht-multi-select-editor .ht-multi-select-editor-separator{background-color:var(--ht-menu-border-color);width:100%;height:1px;margin:var(--ht-menu-vertical-padding)0 var(--ht-menu-vertical-padding)0;padding:0}.handsontableEditor .ht-multi-select-editor ul{width:100%;padding:var(--ht-gap-size)var(--ht-menu-horizontal-padding);flex-direction:column;align-items:flex-start;margin:0;list-style:none;display:flex}.handsontableEditor .ht-multi-select-editor ul li{background:var(--ht-background-color);padding:var(--ht-menu-item-vertical-padding)var(--ht-menu-item-horizontal-padding);-webkit-user-select:none;user-select:none;cursor:pointer;align-self:stretch;align-items:center;display:flex}.handsontableEditor .ht-multi-select-editor ul li *{cursor:pointer}.handsontableEditor .ht-multi-select-editor ul li.ht-multi-select-editor-item-selected{background:color-mix(in srgb,var(--ht-menu-item-active-color)var(--ht-menu-item-active-color-opacity,100%),transparent)}.handsontableEditor .ht-multi-select-editor ul li div{flex:1 0 0;align-items:center;display:flex}.handsontableEditor .ht-multi-select-editor ul li div input{-webkit-appearance:none;appearance:none;width:var(--ht-checkbox-size);height:var(--ht-checkbox-size);margin:0;padding:0;display:flex;position:relative}.handsontableEditor .ht-multi-select-editor ul li div input:after{content:"";display:block;position:absolute;top:0;left:0}.handsontableEditor .ht-multi-select-editor ul li div input:before{content:"";box-sizing:border-box;width:var(--ht-checkbox-size);height:var(--ht-checkbox-size);border-radius:var(--ht-checkbox-border-radius);border:1px solid var(--ht-checkbox-border-color);background:var(--ht-checkbox-background-color);background-position:50%;background-repeat:no-repeat;display:block;position:absolute;top:0;left:0}.handsontableEditor .ht-multi-select-editor ul li div input:checked:before{border-color:var(--ht-checkbox-checked-border-color);background:var(--ht-checkbox-checked-background-color)}.handsontableEditor .ht-multi-select-editor ul li div input:checked:after{color:var(--ht-checkbox-checked-icon-color);background-color:currentColor}.handsontableEditor .ht-multi-select-editor ul li div input:focus{outline:none}.handsontableEditor .ht-multi-select-editor ul li div label{color:var(--ht-foreground-color);text-overflow:ellipsis;font-size:var(--ht-font-size);font-style:normal;font-weight:400;line-height:var(--ht-line-height);letter-spacing:var(--ht-letter-spacing);width:100%;padding:0 0 0 calc(var(--ht-gap-size)*2);overflow:hidden}.handsontableEditor .ht-multi-select-editor ul li:hover{background:color-mix(in srgb,var(--ht-menu-item-hover-color)var(--ht-menu-item-hover-color-opacity,100%),transparent)}.handsontableEditor .ht-multi-select-editor ul li:has(input:focus){background:color-mix(in srgb,var(--ht-menu-item-hover-color)var(--ht-menu-item-hover-color-opacity,100%),transparent)}.handsontable .htUISelectCaption{width:100%;padding:var(--ht-input-vertical-padding)var(--ht-input-horizontal-padding);font-family:inherit;font-size:var(--ht-font-size);line-height:var(--ht-line-height);font-weight:var(--ht-font-weight);border-radius:var(--ht-input-border-radius);box-sizing:border-box;cursor:pointer;border:var(--ht-input-border-width)solid var(--ht-input-border-color);color:var(--ht-input-foreground-color);background-color:var(--ht-input-background-color);text-overflow:ellipsis;white-space:nowrap;transition:var(--ht-table-transition)all ease-in-out;margin:0;padding-inline-end:calc(var(--ht-input-horizontal-padding) + var(--ht-icon-size));overflow:hidden;outline:none!important}.handsontable .htUISelectCaption:after{content:"";right:calc(var(--ht-input-horizontal-padding) - var(--ht-icon-size)/4);display:block;position:absolute;top:50%;transform:translateY(-50%)}.handsontable .htUISelectCaption:hover{border-color:var(--ht-input-hover-border-color);color:var(--ht-input-hover-foreground-color);background-color:var(--ht-input-hover-background-color)}.handsontable .htUISelectCaption:disabled{border-color:var(--ht-input-disabled-border-color);color:var(--ht-input-disabled-foreground-color);background-color:var(--ht-input-disabled-background-color)}.handsontable .htUISelectCaption:focus{border-color:var(--ht-input-focus-border-color);color:var(--ht-input-focus-foreground-color);background-color:var(--ht-input-focus-background-color)}.handsontable .htUISelect{cursor:pointer;position:relative;outline:none!important}.handsontable .htUISelect:focus .htUISelectCaption{border-color:var(--ht-input-focus-border-color);color:var(--ht-input-focus-foreground-color);background-color:var(--ht-input-focus-background-color)}[dir=rtl].handsontable .htUISelectCaption:after{right:auto;left:calc(var(--ht-input-horizontal-padding) - var(--ht-icon-size)/4)}.handsontable .htFiltersMenuCondition .htUIInput input,.handsontable .htFiltersMenuValue .htUIMultipleSelectSearch input{width:100%;padding:var(--ht-input-vertical-padding)var(--ht-input-horizontal-padding);font-family:inherit;font-size:var(--ht-font-size);line-height:var(--ht-line-height);font-weight:var(--ht-font-weight);border-radius:var(--ht-input-border-radius);box-sizing:border-box;cursor:pointer;border:var(--ht-input-border-width)solid var(--ht-input-border-color);color:var(--ht-input-foreground-color);background-color:var(--ht-input-background-color);transition:var(--ht-table-transition)all ease-in-out;outline:none!important}.handsontable .htFiltersMenuCondition .htUIInput input:hover,.handsontable .htFiltersMenuValue .htUIMultipleSelectSearch input:hover{border-color:var(--ht-input-hover-border-color);color:var(--ht-input-hover-foreground-color);background-color:var(--ht-input-hover-background-color)}.handsontable .htFiltersMenuCondition .htUIInput input:disabled,.handsontable .htFiltersMenuValue .htUIMultipleSelectSearch input:disabled{border-color:var(--ht-input-disabled-border-color);color:var(--ht-input-disabled-foreground-color);background-color:var(--ht-input-disabled-background-color)}.handsontable .htFiltersMenuCondition .htUIInput input:focus,.handsontable .htFiltersMenuValue .htUIMultipleSelectSearch input:focus{border-color:var(--ht-input-focus-border-color);color:var(--ht-input-focus-foreground-color);background-color:var(--ht-input-focus-background-color)}.handsontable .htUIInput{text-align:center;padding:0;position:relative;outline:none!important}.handsontable .htUIInputIcon{position:absolute}.handsontable .htUIInput.htUIButton input,.handsontable .ht-button{min-width:64px;padding:var(--ht-button-vertical-padding)var(--ht-button-horizontal-padding);font-family:inherit;font-size:var(--ht-font-size);line-height:var(--ht-line-height);font-weight:var(--ht-font-weight);border-radius:var(--ht-button-border-radius);box-sizing:border-box;cursor:pointer;transition:var(--ht-table-transition)all ease-in-out;border-style:solid;border-width:1px;outline:none!important}.handsontable .htUIInput.htUIButtonCancel input,.handsontable .ht-button--secondary{border-color:var(--ht-secondary-button-border-color);background-color:var(--ht-secondary-button-background-color);color:var(--ht-secondary-button-foreground-color)}.handsontable .htUIInput.htUIButtonCancel input:hover,.handsontable .ht-button--secondary:hover{border-color:var(--ht-secondary-button-hover-border-color);background-color:var(--ht-secondary-button-hover-background-color);color:var(--ht-secondary-button-hover-foreground-color)}.handsontable .htUIInput.htUIButtonCancel input:disabled,.handsontable .ht-button--secondary:disabled{border-color:var(--ht-secondary-button-disabled-border-color);background-color:var(--ht-secondary-button-disabled-background-color);color:var(--ht-secondary-button-disabled-foreground-color)}.handsontable .htUIInput.htUIButtonCancel input:focus,.handsontable .ht-button--secondary:focus{border-color:var(--ht-secondary-button-focus-border-color);background-color:var(--ht-secondary-button-focus-background-color);color:var(--ht-secondary-button-focus-foreground-color);box-shadow:0 0 0 1px var(--ht-accent-color)}.htUIInput.htUIButtonOK input,.ht-button--primary{border-color:var(--ht-primary-button-border-color);background-color:var(--ht-primary-button-background-color);color:var(--ht-primary-button-foreground-color)}.htUIInput.htUIButtonOK input:hover,.ht-button--primary:hover{border-color:var(--ht-primary-button-hover-border-color);background-color:var(--ht-primary-button-hover-background-color);color:var(--ht-primary-button-hover-foreground-color)}.htUIInput.htUIButtonOK input:disabled,.ht-button--primary:disabled{border-color:var(--ht-primary-button-disabled-border-color);background-color:var(--ht-primary-button-disabled-background-color);color:var(--ht-primary-button-disabled-foreground-color)}.htUIInput.htUIButtonOK input:focus,.ht-button--primary:focus{border-color:var(--ht-primary-button-focus-border-color);background-color:var(--ht-primary-button-focus-background-color);color:var(--ht-primary-button-focus-foreground-color);box-shadow:0 0 0 1px var(--ht-accent-color)}.handsontable .htUIRadio{padding:var(--ht-gap-size)calc(2*var(--ht-gap-size));align-items:center;gap:var(--ht-gap-size);cursor:pointer;margin:0;padding-bottom:0;display:inline-flex;position:relative}.handsontable .htUIRadio:first-child{padding-inline-start:0}.handsontable .htUIRadio>input[type=radio]{width:var(--ht-radio-size);height:var(--ht-radio-size);-webkit-appearance:none;appearance:none;cursor:pointer;border-radius:calc(.5*var(--ht-radio-size));outline:none;margin:0;position:relative}.handsontable .htUIRadio>input[type=radio]:before{content:"";border-radius:calc(.5*var(--ht-radio-size));border:1px solid var(--ht-radio-border-color);background-color:var(--ht-radio-background-color);display:block;position:absolute;inset:0}.handsontable .htUIRadio>input[type=radio]:after{content:"";color:var(--ht-radio-icon-color);display:block;position:absolute}.handsontable .htUIRadio>input[type=radio]:checked:before{border-color:var(--ht-radio-checked-border-color);background-color:var(--ht-radio-checked-background-color)}.handsontable .htUIRadio>input[type=radio]:checked:after{color:var(--ht-radio-checked-icon-color)}.handsontable .htUIRadio>input[type=radio]:checked:disabled{cursor:initial}.handsontable .htUIRadio>input[type=radio]:checked:disabled:before{border-color:var(--ht-radio-checked-disabled-border-color);background-color:var(--ht-radio-checked-disabled-background-color)}.handsontable .htUIRadio>input[type=radio]:checked:disabled:after{color:var(--ht-radio-checked-disabled-icon-color)}.handsontable .htUIRadio>input[type=radio]:checked:focus:before{border-color:var(--ht-radio-checked-focus-border-color);background-color:var(--ht-radio-checked-focus-background-color)}.handsontable .htUIRadio>input[type=radio]:checked:focus:after{color:var(--ht-radio-checked-focus-icon-color)}.handsontable .htUIRadio>input[type=radio]:disabled{cursor:initial}.handsontable .htUIRadio>input[type=radio]:disabled:before{border-color:var(--ht-radio-disabled-border-color);background-color:var(--ht-radio-disabled-background-color)}.handsontable .htUIRadio>input[type=radio]:disabled:after{color:var(--ht-radio-disabled-icon-color)}.handsontable .htUIRadio>input[type=radio]:focus:before{border-color:var(--ht-radio-focus-border-color);background-color:var(--ht-radio-focus-background-color);outline:1px solid var(--ht-radio-focus-ring-color)}.handsontable .htUIRadio>input[type=radio]:focus:after{color:var(--ht-radio-focus-icon-color)}.handsontable .htUIRadio label{vertical-align:middle;cursor:pointer;color:inherit}.handsontable .htUIRadio label:before{content:"";display:block;position:absolute;inset:0}.handsontable .collapsibleIndicator,.handsontable .ht_nestingButton{width:var(--ht-icon-button-hit-area-size);height:var(--ht-icon-button-hit-area-size);margin:calc(-1*(var(--ht-icon-button-hit-area-size) - var(--ht-icon-size))/2 + 1px);box-sizing:border-box;cursor:pointer;text-indent:-100px;flex-shrink:0;font-size:0;position:relative;overflow:visible}.handsontable .collapsibleIndicator:before,.handsontable .ht_nestingButton:before{content:"";width:var(--ht-icon-size);height:var(--ht-icon-size);margin-top:calc(-.5*var(--ht-icon-size));margin-left:calc(-.5*var(--ht-icon-size));border-radius:var(--ht-collapse-button-border-radius);transition:var(--ht-table-transition)all ease-in-out;z-index:1;display:block;position:absolute;top:50%;left:50%}.handsontable .collapsibleIndicator:after,.handsontable .ht_nestingButton:after{content:"";width:var(--ht-icon-size);height:var(--ht-icon-size);margin-top:calc(-.5*var(--ht-icon-size));margin-left:calc(-.5*var(--ht-icon-size));border-radius:var(--ht-collapse-button-border-radius);transition:var(--ht-table-transition)all ease-in-out;z-index:0;display:block;position:absolute;top:50%;left:50%}.handsontable .collapsibleIndicator.expanded:before,.handsontable .collapsibleIndicator.ht_nestingCollapse:before,.handsontable .ht_nestingButton.expanded:before,.handsontable .ht_nestingButton.ht_nestingCollapse:before{color:var(--ht-collapse-button-open-icon-color)}.handsontable .collapsibleIndicator.expanded:after,.handsontable .collapsibleIndicator.ht_nestingCollapse:after,.handsontable .ht_nestingButton.expanded:after,.handsontable .ht_nestingButton.ht_nestingCollapse:after{background-color:var(--ht-collapse-button-open-background-color);box-shadow:0 0 0 1px var(--ht-collapse-button-open-border-color)}.handsontable .collapsibleIndicator.expanded:hover:before,.handsontable .collapsibleIndicator.ht_nestingCollapse:hover:before,.handsontable .ht_nestingButton.expanded:hover:before,.handsontable .ht_nestingButton.ht_nestingCollapse:hover:before{color:var(--ht-collapse-button-open-hover-icon-color)}.handsontable .collapsibleIndicator.expanded:hover:after,.handsontable .collapsibleIndicator.ht_nestingCollapse:hover:after,.handsontable .ht_nestingButton.expanded:hover:after,.handsontable .ht_nestingButton.ht_nestingCollapse:hover:after{background-color:var(--ht-collapse-button-open-hover-background-color);box-shadow:0 0 0 1px var(--ht-collapse-button-open-hover-border-color)}.handsontable .collapsibleIndicator.collapsed:before,.handsontable .collapsibleIndicator.ht_nestingExpand:before,.handsontable .ht_nestingButton.collapsed:before,.handsontable .ht_nestingButton.ht_nestingExpand:before{color:var(--ht-collapse-button-close-icon-color)}.handsontable .collapsibleIndicator.collapsed:after,.handsontable .collapsibleIndicator.ht_nestingExpand:after,.handsontable .ht_nestingButton.collapsed:after,.handsontable .ht_nestingButton.ht_nestingExpand:after{background-color:var(--ht-collapse-button-close-background-color);box-shadow:0 0 0 1px var(--ht-collapse-button-close-border-color)}.handsontable .collapsibleIndicator.collapsed:hover:before,.handsontable .collapsibleIndicator.ht_nestingExpand:hover:before,.handsontable .ht_nestingButton.collapsed:hover:before,.handsontable .ht_nestingButton.ht_nestingExpand:hover:before{color:var(--ht-collapse-button-close-hover-icon-color)}.handsontable .collapsibleIndicator.collapsed:hover:after,.handsontable .collapsibleIndicator.ht_nestingExpand:hover:after,.handsontable .ht_nestingButton.collapsed:hover:after,.handsontable .ht_nestingButton.ht_nestingExpand:hover:after{background-color:var(--ht-collapse-button-close-hover-background-color);box-shadow:0 0 0 1px var(--ht-collapse-button-close-hover-border-color)}.handsontable th.ht__active_highlight .collapsibleIndicator.collapsed:before,.handsontable th.ht__active_highlight .collapsibleIndicator.ht_nestingExpand:before,.handsontable th.ht__active_highlight .ht_nestingButton.collapsed:before,.handsontable th.ht__active_highlight .ht_nestingButton.ht_nestingExpand:before{color:var(--ht-collapse-button-close-icon-active-color)}.handsontable th.ht__active_highlight .collapsibleIndicator.collapsed:hover:before,.handsontable th.ht__active_highlight .collapsibleIndicator.ht_nestingExpand:hover:before,.handsontable th.ht__active_highlight .ht_nestingButton.collapsed:hover:before,.handsontable th.ht__active_highlight .ht_nestingButton.ht_nestingExpand:hover:before{color:var(--ht-collapse-button-close-hover-icon-active-color)}.handsontable th.ht__active_highlight .collapsibleIndicator.expanded:before,.handsontable th.ht__active_highlight .collapsibleIndicator.ht_nestingCollapse:before,.handsontable th.ht__active_highlight .ht_nestingButton.expanded:before,.handsontable th.ht__active_highlight .ht_nestingButton.ht_nestingCollapse:before{color:var(--ht-collapse-button-open-icon-active-color)}.handsontable th.ht__active_highlight .collapsibleIndicator.expanded:hover:before,.handsontable th.ht__active_highlight .collapsibleIndicator.ht_nestingCollapse:hover:before,.handsontable th.ht__active_highlight .ht_nestingButton.expanded:hover:before,.handsontable th.ht__active_highlight .ht_nestingButton.ht_nestingCollapse:hover:before{color:var(--ht-collapse-button-open-hover-icon-active-color)}.handsontable thead th.htRowspanHeader+th{border-inline-start-width:0}.handsontable thead th.htRowspanHeader{vertical-align:bottom;height:auto;overflow:visible}.handsontable thead th.htRowspanHeader.ht__active_highlight{border-inline-start-color:var(--ht-header-active-border-color);z-index:1}.handsontable.htRowHeaders.htHasRowspanHeaders thead tr:last-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-left-radius:0}.handsontable.htRowHeaders.htHasRowspanHeaders thead tr:last-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0}.handsontable.htHasRowspanHeaders .ht_clone_inline_start .htCore tbody tr:first-child th:first-child:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0}.handsontable.htHasRowspanHeaders .ht_clone_inline_start .htCore tbody tr:first-child th:first-child:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:0}.handsontable .ht_master:not(.innerBorderTop):not(.innerBorderBottom) thead th.htRowspanBottomLevel,.handsontable .ht_master:not(.innerBorderTop):not(.innerBorderBottom)~.handsontable thead th.htRowspanBottomLevel{border-bottom-width:0}.handsontable thead th.hiddenHeader:not(:first-of-type){display:none}.handsontable thead th.hiddenHeaderText .colHeader{opacity:0}.handsontable th.ht_nestingLevels>.relative{align-items:center;gap:5px;display:flex}.handsontable th.ht_nestingLevels span:last-child{padding-left:calc(var(--ht-icon-size) + 5px)}.handsontable th.ht_nestingLevels span.ht_nestingLevel{display:inline-block}.handsontable th.ht_nestingLevels span.ht_nestingLevel_empty{order:-2;width:5px;height:1px;display:inline-block;position:relative}.handsontable th.ht_nestingLevels .ht_nestingButton{cursor:pointer;order:-1;position:relative}.handsontable th.beforeHiddenColumn,.handsontable th.afterHiddenColumn{position:relative}.handsontable th.beforeHiddenColumn:before,.handsontable th.beforeHiddenColumn:after,.handsontable th.afterHiddenColumn:before,.handsontable th.afterHiddenColumn:after{color:var(--ht-hidden-indicator-color);position:absolute;top:50%;transform:translateY(-50%);width:10px!important;height:10px!important}.handsontable th.beforeHiddenColumn:after{content:"";display:block;right:-2px}.handsontable th.afterHiddenColumn:before{content:"";display:block;left:-2px}.handsontable th.ht__active_highlight.beforeHiddenColumn:before,.handsontable th.ht__active_highlight.beforeHiddenColumn:after,.handsontable th.ht__active_highlight.afterHiddenColumn:before,.handsontable th.ht__active_highlight.afterHiddenColumn:after{color:var(--ht-icon-button-active-icon-color,var(--ht-icon-active-button-icon-color))}[dir=rtl].handsontable th.beforeHiddenColumn:after{right:initial;left:-2px;transform:translateY(-50%)rotate(180deg)}[dir=rtl].handsontable th.afterHiddenColumn:before{right:-2px;left:initial;transform:translateY(-50%)rotate(180deg)}.handsontable th.beforeHiddenRow,.handsontable th.afterHiddenRow{position:relative}.handsontable th.beforeHiddenRow:before,.handsontable th.beforeHiddenRow:after,.handsontable th.afterHiddenRow:before,.handsontable th.afterHiddenRow:after{color:var(--ht-hidden-indicator-color);position:absolute;left:50%;transform:translate(-50%);width:10px!important;height:10px!important}.handsontable th.beforeHiddenRow:after{content:"";display:block;bottom:-2px}.handsontable th.afterHiddenRow:before{content:"";display:block;top:-2px}.handsontable th.ht__active_highlight.beforeHiddenRow:before,.handsontable th.ht__active_highlight.beforeHiddenRow:after,.handsontable th.ht__active_highlight.afterHiddenRow:before,.handsontable th.ht__active_highlight.afterHiddenRow:after{color:var(--ht-icon-button-active-icon-color,var(--ht-icon-active-button-icon-color))}.handsontable .changeType{box-sizing:border-box;width:var(--ht-icon-button-hit-area-size);height:var(--ht-icon-button-hit-area-size);margin:calc(-1*(var(--ht-icon-button-hit-area-size) - var(--ht-icon-size))/2 + 1px);box-shadow:none;color:inherit;z-index:1;background:0 0;border:none;outline:none;flex-shrink:0;padding:0;position:relative;overflow:visible}.handsontable .changeType:before{content:"";width:var(--ht-icon-size);height:var(--ht-icon-size);margin-top:calc(-.5*var(--ht-icon-size));margin-left:calc(-.5*var(--ht-icon-size));color:var(--ht-icon-button-icon-color);z-index:1;display:block;position:absolute;top:50%;left:50%}.handsontable .changeType:after{content:"";width:var(--ht-icon-size);height:var(--ht-icon-size);margin-top:calc(-.5*var(--ht-icon-size));margin-left:calc(-.5*var(--ht-icon-size));border-radius:var(--ht-icon-button-border-radius);box-shadow:0 0 0 1px var(--ht-icon-button-border-color);background-color:var(--ht-icon-button-background-color);z-index:0;display:block;position:absolute;top:50%;left:50%}.handsontable .changeType:hover{cursor:pointer}.handsontable .changeType:hover:before{color:var(--ht-icon-button-hover-icon-color)}.handsontable .changeType:hover:after{box-shadow:0 0 0 1px var(--ht-icon-button-hover-border-color);background-color:var(--ht-icon-button-hover-background-color)}.handsontable .ht__active_highlight .changeType:before{color:var(--ht-icon-button-active-icon-color,var(--ht-icon-active-button-icon-color))}.handsontable .ht__active_highlight .changeType:after{box-shadow:0 0 0 1px var(--ht-icon-button-active-border-color,var(--ht-icon-active-button-border-color));background-color:var(--ht-icon-button-active-background-color,var(--ht-icon-active-button-background-color))}.handsontable .ht__active_highlight .changeType:hover:before{color:var(--ht-icon-button-active-hover-icon-color,var(--ht-icon-active-button-hover-icon-color))}.handsontable .ht__active_highlight .changeType:hover:after{box-shadow:0 0 0 1px var(--ht-icon-button-active-hover-border-color,var(--ht-icon-active-button-hover-border-color));background-color:var(--ht-icon-button-active-hover-background-color,var(--ht-icon-active-button-hover-background-color))}.handsontable th.htFiltersActive{background-color:var(--ht-header-filter-background-color)}.handsontable th.htFiltersActive.ht__active_highlight{background-color:color-mix(in srgb,var(--ht-header-active-background-color),var(--ht-header-filter-background-color)20%)}.handsontable.htDropdownMenu>.ht_master,.handsontable.htContextMenu>.ht_master,.handsontable.htFiltersConditionsMenu>.ht_master{box-shadow:var(--ht-menu-shadow-x,0)var(--ht-menu-shadow-y,0)var(--ht-menu-shadow-blur,8px)color-mix(in srgb,var(--ht-menu-shadow-color,#000)var(--ht-menu-shadow-opacity,100%),transparent);border:var(--ht-menu-border-width,1px)solid var(--ht-menu-border-color,#e5e5e9);border-radius:var(--ht-menu-border-radius);padding:var(--ht-menu-vertical-padding,8px)var(--ht-menu-horizontal-padding,0);background-color:var(--ht-background-color,#fff);overflow:hidden}.handsontable.htDropdownMenu:not(.htGhostTable),.handsontable.htContextMenu:not(.htGhostTable),.handsontable.htFiltersConditionsMenu:not(.htGhostTable){z-index:1060;display:none;position:absolute}.handsontable.htDropdownMenu .ht_clone_top,.handsontable.htDropdownMenu .ht_clone_bottom,.handsontable.htDropdownMenu .ht_clone_inline_start,.handsontable.htDropdownMenu .ht_clone_top_inline_start_corner,.handsontable.htDropdownMenu .ht_clone_bottom_inline_start_corner,.handsontable.htContextMenu .ht_clone_top,.handsontable.htContextMenu .ht_clone_bottom,.handsontable.htContextMenu .ht_clone_inline_start,.handsontable.htContextMenu .ht_clone_top_inline_start_corner,.handsontable.htContextMenu .ht_clone_bottom_inline_start_corner,.handsontable.htFiltersConditionsMenu .ht_clone_top,.handsontable.htFiltersConditionsMenu .ht_clone_bottom,.handsontable.htFiltersConditionsMenu .ht_clone_inline_start,.handsontable.htFiltersConditionsMenu .ht_clone_top_inline_start_corner,.handsontable.htFiltersConditionsMenu .ht_clone_bottom_inline_start_corner{display:none}.handsontable.htDropdownMenu table.htCore,.handsontable.htContextMenu table.htCore,.handsontable.htFiltersConditionsMenu table.htCore{overflow:hidden}.handsontable.htDropdownMenu .htCustomMenuRenderer .table.htCore,.handsontable.htContextMenu .htCustomMenuRenderer .table.htCore,.handsontable.htFiltersConditionsMenu .htCustomMenuRenderer .table.htCore{box-shadow:none}.handsontable.htDropdownMenu.handsontable:focus,.handsontable.htContextMenu.handsontable:focus,.handsontable.htFiltersConditionsMenu.handsontable:focus{outline:none}.handsontable.htDropdownMenu .wtBorder,.handsontable.htContextMenu .wtBorder,.handsontable.htFiltersConditionsMenu .wtBorder{visibility:hidden}.handsontable.htDropdownMenu tbody tr:first-of-type td:first-child,.handsontable.htDropdownMenu tbody tr:first-of-type th:first-child,.handsontable.htContextMenu tbody tr:first-of-type td:first-child,.handsontable.htContextMenu tbody tr:first-of-type th:first-child,.handsontable.htFiltersConditionsMenu tbody tr:first-of-type td:first-child,.handsontable.htFiltersConditionsMenu tbody tr:first-of-type th:first-child{height:calc(var(--ht-cell-vertical-padding)*2 + var(--ht-line-height) + 1px)}.handsontable.htDropdownMenu table tbody tr td,.handsontable.htContextMenu table tbody tr td,.handsontable.htFiltersConditionsMenu table tbody tr td{padding:var(--ht-menu-item-vertical-padding,4px)var(--ht-menu-item-horizontal-padding,8px);white-space:nowrap;text-overflow:ellipsis;background:var(--ht-background-color,#fff);cursor:pointer;transition:var(--ht-table-transition)background ease-in-out;border-width:0;position:relative;overflow:hidden}.handsontable.htDropdownMenu table tbody tr td:first-child,.handsontable.htContextMenu table tbody tr td:first-child,.handsontable.htFiltersConditionsMenu table tbody tr td:first-child{border-top-width:0;border-inline-end-width:0;border-bottom-width:0;border-inline-start-width:0}.handsontable.htDropdownMenu table tbody tr td.htDimmed,.handsontable.htContextMenu table tbody tr td.htDimmed,.handsontable.htFiltersConditionsMenu table tbody tr td.htDimmed{font-style:normal;color:inherit!important;background-color:inherit!important}.handsontable.htDropdownMenu table tbody tr td:not(.handsontable.htDropdownMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled):hover,.handsontable.htContextMenu table tbody tr td:not(.handsontable.htDropdownMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled):hover,.handsontable.htFiltersConditionsMenu table tbody tr td:not(.handsontable.htDropdownMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled):hover{cursor:pointer;background:color-mix(in srgb,var(--ht-menu-item-hover-color)var(--ht-menu-item-hover-color-opacity,100%),transparent)!important}.handsontable.htDropdownMenu table tbody tr td:not(.handsontable.htDropdownMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled).current:not([aria-expanded=true]),.handsontable.htContextMenu table tbody tr td:not(.handsontable.htDropdownMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled).current:not([aria-expanded=true]),.handsontable.htFiltersConditionsMenu table tbody tr td:not(.handsontable.htDropdownMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htCustomMenuRenderer,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled).current:not([aria-expanded=true]){box-shadow:inset 0 0 0 1px var(--ht-accent-color)}.handsontable.htDropdownMenu table tbody tr td.htSubmenu .htItemWrapper,.handsontable.htContextMenu table tbody tr td.htSubmenu .htItemWrapper,.handsontable.htFiltersConditionsMenu table tbody tr td.htSubmenu .htItemWrapper{margin-inline-end:calc(2*var(--ht-gap-size,4px) + var(--ht-icon-size))}.handsontable.htDropdownMenu table tbody tr td.htSubmenu .htItemWrapper:after,.handsontable.htContextMenu table tbody tr td.htSubmenu .htItemWrapper:after,.handsontable.htFiltersConditionsMenu table tbody tr td.htSubmenu .htItemWrapper:after{content:"";top:50%;right:calc(var(--ht-menu-item-horizontal-padding) + var(--ht-gap-size)*2);display:block;position:absolute;transform:translateY(-50%)}.handsontable.htDropdownMenu table tbody tr td.htSeparator,.handsontable.htContextMenu table tbody tr td.htSeparator,.handsontable.htFiltersConditionsMenu table tbody tr td.htSeparator{border-top:1px solid var(--ht-border-color);cursor:default;height:0;padding:0}.handsontable.htDropdownMenu table tbody tr td.htDisabled,.handsontable.htContextMenu table tbody tr td.htDisabled,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled{color:var(--ht-disabled-color);cursor:default}.handsontable.htDropdownMenu table tbody tr td.htDisabled:hover,.handsontable.htContextMenu table tbody tr td.htDisabled:hover,.handsontable.htFiltersConditionsMenu table tbody tr td.htDisabled:hover{background:var(--ht-background-color);color:var(--ht-disabled-color)}.handsontable.htDropdownMenu table tbody tr td.htHidden,.handsontable.htContextMenu table tbody tr td.htHidden,.handsontable.htFiltersConditionsMenu table tbody tr td.htHidden{display:none}:is(.handsontable.htDropdownMenu table tbody tr td:has(.htItemWrapper .selected),.handsontable.htContextMenu table tbody tr td:has(.htItemWrapper .selected),.handsontable.htFiltersConditionsMenu table tbody tr td:has(.htItemWrapper .selected)){background-color:color-mix(in srgb,var(--ht-menu-item-active-color)var(--ht-menu-item-active-color-opacity,100%),transparent)}.handsontable.htDropdownMenu table tbody tr td .htItemWrapper,.handsontable.htContextMenu table tbody tr td .htItemWrapper,.handsontable.htFiltersConditionsMenu table tbody tr td .htItemWrapper{margin-inline:calc(2*var(--ht-gap-size,4px))}.handsontable.htDropdownMenu table tbody tr td .htItemWrapper:before,.handsontable.htContextMenu table tbody tr td .htItemWrapper:before,.handsontable.htFiltersConditionsMenu table tbody tr td .htItemWrapper:before{vertical-align:text-bottom;margin-right:12px}.handsontable.htDropdownMenu table tbody tr td .htItemWrapper span.selected,.handsontable.htContextMenu table tbody tr td .htItemWrapper span.selected,.handsontable.htFiltersConditionsMenu table tbody tr td .htItemWrapper span.selected{font-size:0;inset:0}.handsontable.htDropdownMenu table tbody tr td .htItemWrapper span.selected:after,.handsontable.htContextMenu table tbody tr td .htItemWrapper span.selected:after,.handsontable.htFiltersConditionsMenu table tbody tr td .htItemWrapper span.selected:after{content:"";top:50%;right:calc(var(--ht-menu-item-horizontal-padding) + var(--ht-gap-size)*2);color:var(--ht-accent-color);display:block;position:absolute;transform:translateY(-50%)}.handsontable.htDropdownMenu table tbody tr td div span.selected,.handsontable.htContextMenu table tbody tr td div span.selected,.handsontable.htFiltersConditionsMenu table tbody tr td div span.selected{position:absolute;inset-inline-end:0}.handsontable.htDropdownMenu table tbody tr td .htUIButton,.handsontable.htContextMenu table tbody tr td .htUIButton,.handsontable.htFiltersConditionsMenu table tbody tr td .htUIButton{width:calc(50% - var(--ht-gap-size))}.handsontable.htDropdownMenu table tbody tr td .htUIButton input,.handsontable.htContextMenu table tbody tr td .htUIButton input,.handsontable.htFiltersConditionsMenu table tbody tr td .htUIButton input{width:100%}.handsontable .htUIClearAll a,.handsontable .htUISelectAll a{padding:var(--ht-gap-size);text-decoration:none;display:inline-block}.handsontable .htUIMultipleSelect .ht_master .wtHolder{background:0 0;border-radius:0!important;overflow-y:scroll!important}.handsontable .htUIMultipleSelect .ht_master .wtHolder .htCore{box-shadow:none}[dir=rtl].handsontable.htDropdownMenu table tbody tr td.htSubmenu .htItemWrapper:after,[dir=rtl].handsontable.htContextMenu table tbody tr td.htSubmenu .htItemWrapper:after,[dir=rtl].handsontable.htFiltersConditionsMenu table tbody tr td.htSubmenu .htItemWrapper:after{left:calc(4*var(--ht-gap-size));right:auto;transform:translateY(-50%)rotate(180deg)}[dir=rtl].handsontable.htDropdownMenu table tbody tr td .htItemWrapper span.selected:after,[dir=rtl].handsontable.htContextMenu table tbody tr td .htItemWrapper span.selected:after,[dir=rtl].handsontable.htFiltersConditionsMenu table tbody tr td .htItemWrapper span.selected:after{left:calc(4*var(--ht-gap-size));right:auto}.handsontable.htFiltersConditionsMenu:not(.htGhostTable){z-index:1070}.handsontable .ht_master table td.htCustomMenuRenderer{cursor:auto}.handsontable .ht_master table td.htCustomMenuRenderer.htFiltersMenuActionBar{padding-top:calc(var(--ht-menu-item-vertical-padding,4px)*2)}.handsontable .htFiltersMenuLabel{font-size:var(--ht-font-size-small);line-height:var(--ht-line-height-small);font-weight:var(--ht-font-weight);margin-bottom:calc(var(--ht-gap-size,2px)*2)}.handsontable .htFiltersMenuLabel:empty{display:none}.handsontable .htFiltersMenuCondition{padding-top:calc(var(--ht-gap-size,2px)*3)!important;padding-bottom:0!important}.handsontable .htFiltersMenuCondition .border{border-bottom:1px solid var(--ht-border-color)!important}.handsontable .htFiltersMenuCondition .htUIInput{margin-top:calc(var(--ht-gap-size,2px)*2)}.handsontable .htFiltersMenuValue{padding-top:calc(var(--ht-gap-size,2px)*3)!important;border-bottom:1px solid var(--ht-border-color)!important;padding-bottom:0!important}.handsontable .htFiltersMenuOperators{padding-top:calc(var(--ht-gap-size,2px)*2)!important;padding-bottom:0!important}.handsontable .htUISelectionControls{margin:0 calc(var(--ht-gap-size,2px)*-1);padding-top:calc(var(--ht-gap-size,2px)*2)!important;padding-bottom:var(--ht-gap-size,2px)!important}.handsontable .htUIMultipleSelectHot{--ht-cell-horizontal-padding:calc(var(--ht-menu-item-horizontal-padding,2px) + var(--ht-gap-size,2px)*2);width:calc(100% + var(--ht-menu-item-horizontal-padding,2px)*2 + var(--ht-gap-size,2px)*4);margin:0 calc((var(--ht-menu-item-horizontal-padding,2px) + var(--ht-gap-size,2px)*2)*-1);overflow:initial!important}.handsontable .htUIMultipleSelectHot:before{content:"";background-color:var(--ht-border-color);width:100%;height:1px;display:block;position:absolute;top:-1px;left:0}.handsontable .htUIMultipleSelectHot .wtHolder{box-sizing:border-box;padding:0;overflow-x:hidden}.handsontable .htUIMultipleSelectHot .wtHolder .wtSpreader{padding:calc(var(--ht-gap-size)*2)0}.handsontable .htUIMultipleSelectHot .wtHolder td{padding:4px var(--ht-cell-horizontal-padding);height:auto!important}.handsontable .htUIClearAll,.handsontable .htUISelectAll{margin-right:var(--ht-gap-size,4px);margin-bottom:var(--ht-gap-size,4px);display:inline-block}.handsontable .htUIClearAll a,.handsontable .htUISelectAll a{font-size:var(--ht-font-size);line-height:var(--ht-line-height);color:var(--ht-link-color);border-radius:var(--ht-button-border-radius)}.handsontable .htUIClearAll a:hover,.handsontable .htUISelectAll a:hover{color:var(--ht-link-hover-color)}.handsontable .htUIClearAll a:focus,.handsontable .htUISelectAll a:focus{outline:1px solid var(--ht-link-hover-color)}.handsontable .htUIMultipleSelect .ht_master .wtHolder{overflow:auto}.handsontable .htUIMultipleSelect .ht_master .wtHolder .wtHider,.handsontable .htUIMultipleSelect .ht_master .wtHolder .htCore,.handsontable .htUIMultipleSelect .ht_master .wtHolder tr,.handsontable .htUIMultipleSelect .ht_master .wtHolder td{background:0 0}.handsontable .htUIInput.htUIButton{cursor:pointer;display:inline-block}.handsontable .htUIInput.htUIButtonOK{margin-inline-start:0;margin-inline-end:calc(2*var(--ht-gap-size,2px))}.handsontable .htCommentCell{position:relative}.handsontable .htCommentCell:after{content:"";top:0;border-inline-start:var(--ht-comments-indicator-size,4px)solid #0000;border-inline-end:none;border-top:var(--ht-comments-indicator-size,4px)solid var(--ht-comments-indicator-color,#1a42e8);display:block;position:absolute;inset-inline-start:unset;inset-inline-end:0}.htCommentsContainer .htComments{z-index:1059;display:none;position:absolute}.htCommentsContainer .htCommentTextArea{font-family:var(--ht-font-family),-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-shadow:var(--ht-menu-shadow-x,0)var(--ht-menu-shadow-y,0)var(--ht-menu-shadow-blur,8px)color-mix(in srgb,var(--ht-menu-shadow-color,#000)var(--ht-menu-shadow-opacity,100%),transparent);width:240px;height:88px;font-size:var(--ht-font-size);line-height:var(--ht-line-height);font-weight:var(--ht-font-weight);padding:var(--ht-comments-textarea-vertical-padding)var(--ht-comments-textarea-horizontal-padding);border:var(--ht-comments-textarea-border-width,1px)solid var(--ht-comments-textarea-border-color,transparent);border-inline-start:var(--ht-comments-textarea-border-width,1px)solid var(--ht-comments-textarea-border-color,#1a42e8);color:var(--ht-comments-textarea-foreground-color);background-color:var(--ht-comments-textarea-background-color,#fff);box-sizing:border-box;-webkit-appearance:none;margin:0 -1px;outline:0!important}.htCommentsContainer .htCommentTextArea:focus{border:var(--ht-comments-textarea-focus-border-width,1px)solid var(--ht-comments-textarea-focus-border-color,#1a42e8);color:var(--ht-comments-textarea-focus-foreground-color);background-color:var(--ht-comments-textarea-focus-background-color,#fff)}.htBorders .wtBorder.ht-border-style-dashed-vertical{background-image:repeating-linear-gradient(to bottom,var(--ht-custom-border-color)0 5px,transparent 0 10px)}.htBorders .wtBorder.ht-border-style-dashed-horizontal{background-image:repeating-linear-gradient(to right,var(--ht-custom-border-color)0 5px,transparent 0 10px)}.htBorders .wtBorder.ht-border-style-dotted-horizontal{background-image:radial-gradient(circle,var(--ht-custom-border-color)calc(var(--ht-custom-border-size)/2),transparent 0);background-size:calc(var(--ht-custom-border-size)*2)var(--ht-custom-border-size);background-repeat:repeat-x}.htBorders .wtBorder.ht-border-style-dotted-vertical{background-image:radial-gradient(circle,var(--ht-custom-border-color)calc(var(--ht-custom-border-size)/2),transparent 0);background-size:var(--ht-custom-border-size)calc(var(--ht-custom-border-size)*2);background-repeat:repeat-y}.handsontable .columnSorting:not(.indicatorDisabled){position:relative}.handsontable .columnSorting:not(.indicatorDisabled).sortAction.ascending,.handsontable .columnSorting:not(.indicatorDisabled).sortAction.descending{padding-inline-end:calc(var(--ht-icon-size,16px) + 2px)}.handsontable .columnSorting:not(.indicatorDisabled).sortAction:hover{cursor:pointer;text-decoration:none}.handsontable .columnSorting:not(.indicatorDisabled).sortAction:before{content:"";width:var(--ht-icon-size,16px);text-align:right;display:block;position:absolute;top:50%;right:2px;transform:translateY(-50%)}.handsontable .htRight .columnSorting.sortAction.ascending,.handsontable .htRight .columnSorting.sortAction.descending{padding-inline-start:calc(var(--ht-icon-size,16px) + 2px);padding-inline-end:0}.handsontable .htRight .columnSorting.sortAction:before,[dir=rtl] .handsontable .columnSorting.sortAction:before{text-align:left;left:2px;right:auto}[dir=rtl] .handsontable .htRight .columnSorting.sortAction.ascending,[dir=rtl] .handsontable .htRight .columnSorting.sortAction.descending{padding-inline-start:0;padding-inline-end:calc(var(--ht-icon-size,16px) + 2px)}[dir=rtl] .handsontable .htLeft .columnSorting.sortAction.ascending,[dir=rtl] .handsontable .htLeft .columnSorting.sortAction.descending{padding-inline-start:calc(var(--ht-icon-size,16px) + 2px);padding-inline-end:0}[dir=rtl] .handsontable .htLeft .columnSorting.sortAction:before{text-align:right;left:auto;right:2px}.htGhostTable .htCore span.colHeader.columnSorting:not(.indicatorDisabled):before{content:"*";padding-inline-end:calc(var(--ht-icon-size,16px) + 2px);display:inline-block;position:relative}.handsontable .colHeader.columnSorting:after{content:"";text-align:right;width:8px;margin-top:4px;font-size:8px;display:block;position:absolute;top:50%;right:0;transform:translateY(-50%)}.handsontable .colHeader.columnSorting[class^=sort-]:after,.handsontable .colHeader.columnSorting[class*=\\ sort-]:after{content:"+"}.handsontable .colHeader.columnSorting.sort-1:after{content:"1"}.handsontable .colHeader.columnSorting.sort-2:after{content:"2"}.handsontable .colHeader.columnSorting.sort-3:after{content:"3"}.handsontable .colHeader.columnSorting.sort-4:after{content:"4"}.handsontable .colHeader.columnSorting.sort-5:after{content:"5"}.handsontable .colHeader.columnSorting.sort-6:after{content:"6"}.handsontable .colHeader.columnSorting.sort-7:after{content:"7"}.handsontable .htRight .colHeader.columnSorting:after,[dir=rtl] .handsontable .colHeader.columnSorting:after{text-align:left;left:0;right:auto}[dir=rtl] .handsontable .htLeft .colHeader.columnSorting:after{text-align:right;left:auto;right:0}.htGhostTable th div:has(.changeType) span.colHeader.columnSorting:not(.indicatorDisabled){padding-inline-end:var(--ht-gap-size)}.handsontable .htRowHeaders .ht_master.innerBorderInlineStart~.ht_clone_top_inline_start_corner th:nth-child(2),.handsontable .htRowHeaders .ht_master.innerBorderInlineStart~.ht_clone_inline_start td:first-of-type{border-left:0}.handsontable .ht_clone_top_inline_start_corner th.ht__active_highlight{box-shadow:none}.handsontable .manualColumnResizer{cursor:col-resize;opacity:0;z-index:210;background:0 0;width:10px;margin:0;position:absolute;top:0}.handsontable .manualColumnResizer:before,.handsontable .manualColumnResizer:after{content:"";background:var(--ht-resize-indicator-color);border-radius:2px;width:2px;height:calc(100% - 12px);max-height:16px;margin-top:.5px;display:block;position:absolute;top:50%;left:1px;transform:translateY(-50%)}.handsontable .manualColumnResizer:after{left:auto;right:0}.handsontable .manualColumnResizer:hover,.handsontable .manualColumnResizer.active{opacity:1}.handsontable .manualColumnResizerGuide{inset-inline-end:unset;width:0;border-inline-end:1px solid var(--ht-accent-color);border-inline-start:none;margin-inline-start:5px;margin-inline-end:unset;display:none;position:absolute;top:0}.handsontable .manualColumnResizerGuide.active{z-index:209;display:block}.handsontable .manualRowResizer{z-index:210;cursor:row-resize;opacity:0;background:0 0;height:10px;margin:0;position:absolute;left:0}.handsontable .manualRowResizer:before,.handsontable .manualRowResizer:after{content:"";background:var(--ht-resize-indicator-color);border-radius:2px;width:calc(100% - 12px);max-width:16px;height:2px;display:block;position:absolute;top:1px;left:50%;transform:translate(-50%)}.handsontable .manualRowResizer:after{top:auto;bottom:0}.handsontable .manualRowResizer:hover,.handsontable .manualRowResizer.active{opacity:1}.handsontable .manualRowResizerGuide{border-bottom:1px solid var(--ht-accent-color);border-top:none;height:0;margin-top:5px;display:none;position:absolute;bottom:0;left:0}.handsontable .manualRowResizerGuide.active{z-index:209;display:block}.handsontable tbody td[rowspan][class*=area][class*=highlight]:not([class*=fullySelectedMergedCell]):before{opacity:0}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-multiple]:before,.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-0]:before{opacity:.14}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-1]:before{opacity:.21}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-2]:before{opacity:.28}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-3]:before{opacity:.35}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-4]:before{opacity:.42}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-5]:before{opacity:.49}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-6]:before{opacity:.56}.handsontable tbody td[rowspan][class*=area][class*=highlight][class*=fullySelectedMergedCell-7]:before{opacity:.63}.handsontable .ht__manualColumnMove.after-selection--columns thead th.ht__highlight,.handsontable.ht__manualColumnMove.after-selection--columns thead th.ht__highlight{cursor:move;cursor:-moz-grab;cursor:-webkit-grab;cursor:grab}.handsontable .ht__manualColumnMove.on-moving--columns *,.handsontable .ht__manualColumnMove.on-moving--columns thead th.ht__highlight,.handsontable.ht__manualColumnMove.on-moving--columns *,.handsontable.ht__manualColumnMove.on-moving--columns thead th.ht__highlight{cursor:move;cursor:-moz-grabbing;cursor:-webkit-grabbing;cursor:grabbing}.handsontable .ht__manualColumnMove.on-moving--columns .manualColumnResizer,.handsontable.ht__manualColumnMove.on-moving--columns .manualColumnResizer{display:none}.handsontable .ht__manualColumnMove--guideline,.handsontable .ht__manualColumnMove--backlight,.handsontable.ht__manualColumnMove--guideline,.handsontable.ht__manualColumnMove--backlight{height:100%;display:none;position:absolute}.handsontable .ht__manualColumnMove--guideline,.handsontable.ht__manualColumnMove--guideline{z-index:205;background:var(--ht-move-indicator-color,#1a42e8);width:1px;margin-inline:-.5px 0;top:0}.handsontable .ht__manualColumnMove--backlight,.handsontable.ht__manualColumnMove--backlight{z-index:205;pointer-events:none;background:color-mix(in srgb,var(--ht-move-backlight-color)var(--ht-move-backlight-opacity,100%),transparent);display:none}.handsontable .on-moving--columns.show-ui .ht__manualColumnMove--guideline,.handsontable .on-moving--columns .ht__manualColumnMove--backlight,.handsontable.on-moving--columns.show-ui .ht__manualColumnMove--guideline,.handsontable.on-moving--columns .ht__manualColumnMove--backlight{display:block}.handsontable .wtHider{position:relative}.handsontable .ht__manualRowMove.after-selection--rows tbody th.ht__highlight,.handsontable.ht__manualRowMove.after-selection--rows tbody th.ht__highlight{cursor:move;cursor:-moz-grab;cursor:-webkit-grab;cursor:grab}.handsontable .ht__manualRowMove.on-moving--rows *,.handsontable .ht__manualRowMove.on-moving--rows tbody th.ht__highlight,.handsontable.ht__manualRowMove.on-moving--rows *,.handsontable.ht__manualRowMove.on-moving--rows tbody th.ht__highlight{cursor:move;cursor:-moz-grabbing;cursor:-webkit-grabbing;cursor:grabbing}.handsontable .ht__manualRowMove.on-moving--rows .manualRowResizer,.handsontable.ht__manualRowMove.on-moving--rows .manualRowResizer{display:none}.handsontable .ht__manualRowMove--guideline,.handsontable .ht__manualRowMove--backlight,.handsontable.ht__manualRowMove--guideline,.handsontable.ht__manualRowMove--backlight{width:100%;display:none;position:absolute}.handsontable .ht__manualRowMove--guideline,.handsontable.ht__manualRowMove--guideline{border-top:1px solid var(--ht-move-indicator-color);z-index:205;left:0}.handsontable .ht__manualRowMove--backlight,.handsontable.ht__manualRowMove--backlight{z-index:205;pointer-events:none;background:color-mix(in srgb,var(--ht-move-backlight-color)var(--ht-move-backlight-opacity,100%),transparent);display:none}.handsontable .on-moving--rows.show-ui .ht__manualRowMove--guideline,.handsontable .on-moving--rows .ht__manualRowMove--backlight,.handsontable.on-moving--rows.show-ui .ht__manualRowMove--guideline,.handsontable.on-moving--rows .ht__manualRowMove--backlight{display:block}.ht-dialog{scrollbar-width:auto;scrollbar-color:var(--ht-scrollbar-thumb-color)var(--ht-scrollbar-track-color);font-size:var(--ht-font-size);line-height:var(--ht-line-height);letter-spacing:var(--ht-letter-spacing);z-index:1060;opacity:0;border-radius:var(--ht-border-radius);border:1px solid var(--ht-border-color);width:100%;height:100%;display:none;position:absolute;top:0;left:0;overflow-y:auto;box-sizing:border-box!important}.ht-dialog[dir=rtl]{left:auto;right:0}.ht-dialog:focus{border:1px solid var(--ht-accent-color);outline:none}.ht-dialog:has(.htFocusCatcher:focus){border:1px solid var(--ht-accent-color);outline:none}.ht-dialog *{box-sizing:border-box!important}.ht-dialog--background-solid{background-color:var(--ht-dialog-solid-background-color)}.ht-dialog--background-semi-transparent{background-color:color-mix(in srgb,var(--ht-dialog-semi-transparent-background-color)var(--ht-dialog-semi-transparent-background-opacity,100%),transparent)}.ht-dialog--animation{transition:opacity var(--ht-table-transition)ease-in-out}.ht-dialog--show{opacity:1}.ht-dialog__content-wrapper{width:100%;min-height:100%;padding:calc(var(--ht-gap-size)*4);border-radius:var(--ht-border-radius);justify-content:center;align-items:center;display:flex}.ht-dialog__content{padding:var(--ht-dialog-content-padding-horizontal)var(--ht-dialog-content-padding-vertical);max-width:480px;color:var(--ht-foreground-color);position:relative}.ht-dialog__content--background{box-shadow:var(--ht-shadow-x,0)var(--ht-shadow-y,0)var(--ht-shadow-blur,8px)color-mix(in srgb,var(--ht-shadow-color,#000)var(--ht-shadow-opacity,100%),transparent);border-radius:var(--ht-dialog-content-border-radius);background-color:var(--ht-dialog-content-background-color)}.ht-dialog--confirm .ht-dialog__content-wrapper{text-align:center;padding:calc(var(--ht-gap-size)*2)}.ht-dialog--confirm .ht-dialog__content-wrapper-inner{max-width:480px;padding:calc(var(--ht-gap-size)*2);border-radius:var(--ht-border-radius);flex-direction:column;justify-content:center;align-items:center;display:flex}.ht-dialog--confirm .ht-dialog__content-wrapper-inner--background{box-shadow:var(--ht-shadow-x,0)var(--ht-shadow-y,0)var(--ht-shadow-blur,8px)color-mix(in srgb,var(--ht-shadow-color,#000)var(--ht-shadow-opacity,100%),transparent);border-radius:var(--ht-dialog-content-border-radius);background-color:var(--ht-dialog-content-background-color)}.ht-dialog--confirm .ht-dialog__content-wrapper-inner:focus{box-shadow:0 0 0 1px var(--ht-accent-color);outline:none}.ht-dialog--confirm .ht-dialog__content{justify-content:center;align-items:center;gap:var(--ht-gap-size);flex-direction:column;display:flex}.ht-dialog--confirm .ht-dialog__content:has(.ht-dialog__buttons){gap:calc(var(--ht-gap-size)*2)}.ht-dialog--confirm .ht-dialog__title{font-size:var(--ht-font-size);font-weight:var(--ht-font-weight);line-height:var(--ht-line-height);margin:0}.ht-dialog--confirm .ht-dialog__description{color:var(--ht-foreground-secondary-color);font-size:var(--ht-font-size-small);line-height:var(--ht-line-height-small);font-weight:var(--ht-font-weight);margin:0}.ht-dialog--confirm .ht-dialog__buttons{justify-content:center;gap:calc(var(--ht-gap-size)*2);flex-flow:wrap;display:flex}.ht-notification{z-index:1070;pointer-events:none;position:absolute;inset:0;overflow:visible}.ht-notification__stack{overscroll-behavior:contain;pointer-events:auto;-webkit-overflow-scrolling:touch;scrollbar-width:auto;scrollbar-color:var(--ht-scrollbar-thumb-color)var(--ht-scrollbar-track-color);flex-direction:column;gap:10px;max-width:min(420px,100% - 40px);min-height:0;padding:10px;display:flex;position:absolute;overflow:hidden auto}.ht-notification__stack--top-start{top:10px;align-items:flex-start;max-height:calc(100% - 40px);inset-inline-start:10px}.ht-notification__stack--top-end{top:10px;align-items:flex-end;max-height:calc(100% - 40px);inset-inline-end:10px}.ht-notification__stack--bottom-start{bottom:10px;align-items:flex-start;max-height:calc(100% - 40px);inset-inline-start:10px}.ht-notification__stack--bottom-end{bottom:10px;align-items:flex-end;max-height:calc(100% - 40px);inset-inline-end:10px}.ht-notification__toast{box-shadow:var(--ht-shadow-x,0)var(--ht-shadow-y,0)var(--ht-shadow-blur,8px)color-mix(in srgb,var(--ht-shadow-color,#000)var(--ht-shadow-opacity,100%),transparent);pointer-events:auto;max-width:100%;color:var(--ht-notification-foreground-color,var(--ht-foreground-color));background-color:var(--ht-notification-background-color,var(--ht-background-color));border:1px solid var(--ht-notification-border-color,var(--ht-border-color));border-radius:var(--ht-border-radius,4px);font-size:var(--ht-font-size);line-height:var(--ht-line-height);letter-spacing:var(--ht-letter-spacing);outline:none;flex-shrink:0;display:flex;position:relative}.ht-notification__toast:focus-visible{box-shadow:0 0 0 1px var(--ht-accent-color)}.ht-notification__toast--animate{opacity:0;transition:opacity var(--ht-table-transition,.15s)ease-out,transform var(--ht-table-transition,.15s)ease-out}.ht-notification__toast--animate.ht-notification__toast--stack-top:not(.ht-notification__toast--visible){transform:translateY(-6px)}.ht-notification__toast--animate.ht-notification__toast--stack-bottom:not(.ht-notification__toast--visible){transform:translateY(6px)}.ht-notification__toast--visible{opacity:1;transform:translateY(0)}.ht-notification__toast--info .ht-notification__accent{display:none}.ht-notification__toast--success .ht-notification__accent{background-color:var(--ht-notification-success-accent,#37bc6c)}.ht-notification__toast--warning .ht-notification__accent{background-color:var(--ht-notification-warning-accent,#fbe952)}.ht-notification__toast--error .ht-notification__accent{background-color:var(--ht-notification-error-accent,#fa4d32)}.ht-notification__toast-inner{width:100%;min-width:0;direction:inherit;flex-direction:row;align-items:stretch;gap:0;padding:10px;display:flex}.ht-notification__accent{box-sizing:border-box;border-radius:4px;flex:0 0 4px;align-self:stretch;margin-inline-end:10px}.ht-notification__body{flex:auto;min-width:0}.ht-notification__title{margin:0 0 var(--ht-gap-size);font-size:var(--ht-font-size);font-weight:var(--ht-font-weight,600)}.ht-notification__message{font-size:var(--ht-font-size-small);word-break:break-word;margin:0}.ht-notification__actions{gap:var(--ht-gap-size);margin-top:var(--ht-gap-size);flex-wrap:wrap;display:flex}.ht-notification__close{box-sizing:border-box;width:var(--ht-icon-button-hit-area-size);height:var(--ht-icon-button-hit-area-size);color:var(--ht-icon-button-icon-color,inherit);cursor:pointer;border-radius:var(--ht-icon-button-border-radius,var(--ht-border-radius,4px));background:0 0;border:none;flex:none;align-self:flex-start;margin-inline-start:4px;padding:0;position:relative;overflow:visible}.ht-notification__close:before{content:"";top:50%;margin-top:calc(-.5*var(--ht-icon-size));margin-inline-start:calc(-.5*var(--ht-icon-size));display:block;position:absolute;inset-inline-start:50%}.ht-notification__close:hover{color:var(--ht-icon-button-hover-icon-color,inherit);background-color:var(--ht-icon-button-hover-background-color,color-mix(in srgb,var(--ht-foreground-color)8%,transparent))}.ht-notification__close:focus-visible{outline:2px solid var(--ht-accent-color);outline-offset:2px}.handsontable.ht-pagination{width:100%;color:var(--ht-pagination-bar-foreground-color);background:var(--ht-pagination-bar-background-color);font-size:var(--ht-font-size);line-height:var(--ht-line-height);box-sizing:border-box;overflow-x:auto}.handsontable.ht-pagination:not(.ht-slot-element){border:1px solid var(--ht-border-color);border-radius:var(--ht-border-radius)}.handsontable.ht-pagination .ht-pagination__inner{justify-content:space-between;align-items:center;gap:calc(var(--ht-gap-size)*4);padding-inline:var(--ht-pagination-bar-horizontal-padding);padding-block:var(--ht-pagination-bar-vertical-padding);flex-wrap:wrap;min-width:230px;display:flex}.handsontable.ht-pagination .ht-page-size-section{align-items:center;gap:calc(var(--ht-gap-size)*2);display:flex}.handsontable.ht-pagination .ht-page-size-section__label{white-space:nowrap}.handsontable.ht-pagination .ht-page-size-section__select-wrapper{border-radius:var(--ht-input-border-radius);position:relative}.handsontable.ht-pagination .ht-page-size-section__select-wrapper select{padding-inline-start:var(--ht-gap-size);padding-inline-end:calc(var(--ht-gap-size) + var(--ht-icon-size));padding-top:var(--ht-gap-size);padding-bottom:var(--ht-gap-size);border-radius:var(--ht-input-border-radius);color:var(--ht-input-foreground-color);background-color:var(--ht-input-background-color);border:1px solid var(--ht-input-border-color);line-height:calc(var(--ht-line-height) - 4px);-webkit-appearance:none;font-size:inherit;cursor:pointer}.handsontable.ht-pagination .ht-page-size-section__select-wrapper select:disabled{opacity:.4;cursor:default;color:var(--ht-input-disabled-foreground-color);background-color:var(--ht-input-disabled-background-color);border-color:var(--ht-input-disabled-border-color)}.handsontable.ht-pagination .ht-page-size-section__select-wrapper select:hover:not(:disabled){color:var(--ht-input-hover-foreground-color);background-color:var(--ht-input-hover-background-color);border-color:var(--ht-input-hover-border-color)}.handsontable.ht-pagination .ht-page-size-section__select-wrapper select:focus{color:var(--ht-input-focus-foreground-color);background-color:var(--ht-input-focus-background-color);border-color:var(--ht-input-focus-border-color);outline:none}.handsontable.ht-pagination .ht-page-size-section__select-wrapper:after{content:"";background-color:var(--ht-foreground-color);pointer-events:none;display:block;position:absolute;inset-block-end:50%;inset-inline-end:var(--ht-gap-size);transform:translateY(50%)}.handsontable.ht-pagination .ht-page-counter-section{margin-inline-end:auto}.handsontable.ht-pagination .ht-page-navigation-section{align-items:center;gap:1px;display:flex}.handsontable.ht-pagination .ht-page-navigation-section__button{font-size:inherit;border:1px solid var(--ht-pagination-button-border-color);color:var(--ht-pagination-button-foreground-color);background-color:var(--ht-pagination-button-background-color);border-radius:var(--ht-icon-button-large-border-radius);padding:var(--ht-icon-button-large-padding);cursor:pointer}.handsontable.ht-pagination .ht-page-navigation-section__button:before{content:"";display:block}.handsontable.ht-pagination .ht-page-navigation-section__button--disabled{cursor:default;pointer-events:none;color:var(--ht-pagination-button-disabled-foreground-color);background-color:var(--ht-pagination-button-disabled-background-color);border-color:var(--ht-pagination-button-disabled-border-color)}.handsontable.ht-pagination .ht-page-navigation-section__button:hover:not(:disabled){border-color:var(--ht-pagination-button-hover-border-color);color:var(--ht-pagination-button-hover-foreground-color);background-color:var(--ht-pagination-button-hover-background-color)}.handsontable.ht-pagination .ht-page-navigation-section__button:focus{border-color:var(--ht-pagination-button-focus-border-color);color:var(--ht-pagination-button-focus-foreground-color);background-color:var(--ht-pagination-button-focus-background-color);outline:none}.handsontable.ht-pagination .ht-page-navigation-section__label{white-space:nowrap;text-align:center;min-width:100px}.ht-loading__icon-svg{width:var(--ht-icon-size);height:var(--ht-icon-size);color:var(--ht-accent-color);transform-origin:50%;animation:1s linear infinite ht-loading-spin;display:block}.ht-loading__content{align-items:center;gap:calc(var(--ht-gap-size)*2);display:flex}.ht-loading__title{font-size:var(--ht-font-size);font-weight:var(--ht-font-weight);line-height:var(--ht-line-height);margin:0}.ht-loading__description{color:var(--ht-foreground-secondary-color);font-size:var(--ht-font-size-small);line-height:var(--ht-line-height-small);font-weight:var(--ht-font-weight);margin:0}@keyframes ht-loading-spin{to{transform:rotate(360deg)}}.ht-empty-data-state{scrollbar-width:auto;scrollbar-color:var(--ht-scrollbar-thumb-color)var(--ht-scrollbar-track-color);z-index:999;border:1px solid var(--ht-border-color);border-radius:var(--ht-border-radius);box-sizing:border-box;background-color:var(--ht-background-color);width:100%;display:none;position:absolute;left:0;overflow-y:auto}.ht-empty-data-state *{box-sizing:border-box!important}.ht-empty-data-state__content-wrapper{text-align:center;width:100%;min-height:100%;padding:calc(var(--ht-gap-size)*2);border-radius:var(--ht-border-radius);justify-content:center;align-items:center;display:flex}.ht-empty-data-state__content-wrapper-inner{max-width:480px;padding:calc(var(--ht-gap-size)*2);border-radius:var(--ht-border-radius);flex-direction:column;justify-content:center;align-items:center;display:flex}.ht-empty-data-state__content-wrapper-inner:focus{box-shadow:0 0 0 1px var(--ht-accent-color);outline:none}.ht-empty-data-state__content{justify-content:center;align-items:center;gap:var(--ht-gap-size);flex-direction:column;display:flex}.ht-empty-data-state__title{font-size:var(--ht-font-size);font-weight:var(--ht-font-weight);line-height:var(--ht-line-height);margin:0}.ht-empty-data-state__description{color:var(--ht-foreground-secondary-color);font-size:var(--ht-font-size-small);line-height:var(--ht-line-height-small);font-weight:var(--ht-font-weight);margin:0}.ht-empty-data-state__buttons{justify-content:center;gap:calc(var(--ht-gap-size)*2);flex-flow:wrap;display:flex}.ht-empty-data-state__buttons--has-buttons{margin-top:calc(var(--ht-gap-size)*2)}.ht-empty-data-state__spinner{width:28px;height:28px;margin-bottom:calc(var(--ht-gap-size)*2);border:2px solid var(--ht-border-color);border-top-color:var(--ht-accent-color);border-radius:50%;flex-shrink:0;animation:.75s linear infinite ht-empty-data-state-spin}@media (prefers-reduced-motion:reduce){.ht-empty-data-state__spinner{border-top-color:var(--ht-border-color);animation:none}}.ht-empty-data-state--loading .ht-empty-data-state__content{gap:calc(var(--ht-gap-size)*.5)}.ht-empty-data-state--disable-top-border{border-top-width:0}.ht-empty-data-state--disable-top-border:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.ht-empty-data-state--disable-top-border:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-top-right-radius:0}.ht-empty-data-state--disable-inline-border{border-inline-start-width:0}.ht-empty-data-state--disable-inline-border:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-left-radius:0;border-bottom-left-radius:0}.ht-empty-data-state--disable-inline-border:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-top-right-radius:0;border-bottom-right-radius:0}.ht-empty-data-state--disable-bottom-border{border-bottom-width:0}.ht-empty-data-state--disable-bottom-border:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)),.ht-empty-data-state--disable-bottom-border:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht-empty-data-state:not(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}.ht-root-wrapper:has(>.ht-slot-bottom>.ht-slot-element) .ht-empty-data-state:is(:lang(ae),:lang(ar),:lang(arc),:lang(bcc),:lang(bqi),:lang(ckb),:lang(dv),:lang(fa),:lang(glk),:lang(he),:lang(ku),:lang(mzn),:lang(nqo),:lang(pnb),:lang(ps),:lang(sd),:lang(ug),:lang(ur),:lang(yi)){border-bottom-right-radius:0;border-bottom-left-radius:0}@keyframes ht-empty-data-state-spin{to{transform:rotate(360deg)}}';
function _check_private_redeclaration$1i(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$17(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$17(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$17(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$17(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$17(receiver, privateMap, "get");
  return _class_apply_descriptor_get$17(receiver, descriptor);
}
function _class_private_field_init$17(obj, privateMap, value) {
  _check_private_redeclaration$1i(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$17(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$17(receiver, privateMap, "set");
  _class_apply_descriptor_set$17(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$V(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$V(obj, privateSet) {
  _check_private_redeclaration$1i(obj, privateSet);
  privateSet.add(obj);
}
const CORE_STYLES_ID = "handsontable-core-styles";
var _hot$1 = /* @__PURE__ */ new WeakMap(), _themeName$1 = /* @__PURE__ */ new WeakMap(), _rootElement$1 = /* @__PURE__ */ new WeakMap(), _rootComputedStyle = /* @__PURE__ */ new WeakMap(), _rootDocument$3 = /* @__PURE__ */ new WeakMap(), _cssVars = /* @__PURE__ */ new WeakMap(), _computedStyles = /* @__PURE__ */ new WeakMap(), _onThemeChange = /* @__PURE__ */ new WeakMap(), _injectCoreStyles = /* @__PURE__ */ new WeakSet(), _calculateRowHeight = /* @__PURE__ */ new WeakSet(), _cacheStylesheetValues = /* @__PURE__ */ new WeakSet(), _getStylesForTD = /* @__PURE__ */ new WeakSet(), _getParsedNumericCSSValue = /* @__PURE__ */ new WeakSet(), _getCSSValue = /* @__PURE__ */ new WeakSet(), _clearCachedValues = /* @__PURE__ */ new WeakSet();
class StylesHandler {
  /**
  * Retrieves the value of a specified CSS variable.
  *
  * @param {string} variableName - The name of the CSS variable to retrieve.
  * @returns {number|null|undefined} The value of the specified CSS variable, or `undefined` if not found.
  */
  getCSSVariableValue(variableName) {
    if (_class_private_field_get$17(this, _cssVars)[`--ht-${variableName}`]) {
      return _class_private_field_get$17(this, _cssVars)[`--ht-${variableName}`];
    }
    const acquiredValue = _class_private_method_get$V(this, _getParsedNumericCSSValue, getParsedNumericCSSValue).call(this, `--ht-${variableName}`) ?? _class_private_method_get$V(this, _getCSSValue, getCSSValue).call(this, `--ht-${variableName}`);
    if (acquiredValue !== null) {
      _class_private_field_get$17(this, _cssVars)[`--ht-${variableName}`] = acquiredValue;
      return acquiredValue;
    }
  }
  /**
  * Retrieves the computed style value for a specified CSS property of a `td` element.
  *
  * @param {string} cssProperty - The CSS property to retrieve the value for.
  * @returns {number|string|undefined} The value of the specified CSS property, or `undefined` if not found.
  */
  getStyleForTD(cssProperty) {
    return _class_private_field_get$17(this, _computedStyles)?.td?.[cssProperty];
  }
  /**
  * Calculates the row height based on the current theme and CSS variables.
  *
  * @param {number} [visualRowIndex] The visual row index.
  * @returns {number} The calculated row height.
  */
  getDefaultRowHeight(visualRowIndex) {
    const rowHeight = _class_private_method_get$V(this, _calculateRowHeight, calculateRowHeight).call(this);
    if (visualRowIndex !== void 0 && visualRowIndex === _class_private_field_get$17(this, _hot$1).view.getFirstRenderedVisibleRow()) {
      return (rowHeight ?? 0) + 1;
    }
    return rowHeight;
  }
  /**
  * Checks if the cells are using the `border-box` box-sizing model.
  *
  * @returns {boolean}
  */
  areCellsBorderBox() {
    return this.getStyleForTD("box-sizing") === "border-box";
  }
  /**
  * Applies the specified theme to the instance.
  *
  * @param {string|undefined|boolean} [themeName] - The name of the theme to apply.
  */
  useTheme(themeName) {
    if (typeof themeName !== "string" || !/ht-theme-.*/.test(themeName)) {
      warn$1(`${themeName} isn't a valid theme name. Please ensure it follows the format ht-theme-<theme-name>.`);
      return;
    }
    _class_private_method_get$V(this, _clearCachedValues, clearCachedValues).call(this);
    if (themeName !== _class_private_field_get$17(this, _themeName$1)) {
      _class_private_field_set$17(this, _themeName$1, themeName);
    }
    _class_private_field_get$17(this, _onThemeChange).call(this, _class_private_field_get$17(this, _themeName$1));
    _class_private_method_get$V(this, _cacheStylesheetValues, cacheStylesheetValues).call(this);
  }
  /**
  * Gets the name of the theme.
  *
  * @returns {string|undefined}
  */
  getThemeName() {
    return _class_private_field_get$17(this, _themeName$1);
  }
  /**
  * Clears all cached CSS variable values and computed styles.
  * This should be called when theme CSS variables are dynamically updated.
  */
  clearCache() {
    _class_private_method_get$V(this, _clearCachedValues, clearCachedValues).call(this);
    _class_private_method_get$V(this, _cacheStylesheetValues, cacheStylesheetValues).call(this);
  }
  /**
  * Initializes a new instance of the `StylesHandler` class.
  *
  * @param {object} options The options for the `StylesHandler` instance.
  * @param {Core} options.hot The instance of the Handsontable.
  * @param {HTMLElement} options.rootElement The root element of the instance.
  * @param {Document} options.rootDocument The root document of the instance.
  * @param {function(string)} options.onThemeChange The callback function to be called when the theme changes.
  * @param {boolean} options.injectCoreCss Whether to inject the core styles into the document head.
  */
  constructor({ hot, rootElement, rootDocument, onThemeChange = (_) => {
  }, injectCoreCss = true }) {
    _class_private_method_init$V(this, _injectCoreStyles);
    _class_private_method_init$V(this, _calculateRowHeight);
    _class_private_method_init$V(this, _cacheStylesheetValues);
    _class_private_method_init$V(this, _getStylesForTD);
    _class_private_method_init$V(this, _getParsedNumericCSSValue);
    _class_private_method_init$V(this, _getCSSValue);
    _class_private_method_init$V(this, _clearCachedValues);
    _class_private_field_init$17(this, _hot$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _themeName$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _rootElement$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _rootComputedStyle, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _rootDocument$3, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _cssVars, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _computedStyles, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$17(this, _onThemeChange, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$17(this, _rootComputedStyle, null);
    _class_private_field_set$17(this, _cssVars, {});
    _class_private_field_set$17(this, _computedStyles, {});
    _class_private_field_set$17(this, _hot$1, hot);
    _class_private_field_set$17(this, _rootElement$1, rootElement);
    _class_private_field_set$17(this, _rootDocument$3, rootDocument);
    _class_private_field_set$17(this, _onThemeChange, onThemeChange);
    if (injectCoreCss) {
      _class_private_method_get$V(this, _injectCoreStyles, injectCoreStyles).call(this);
    }
  }
}
function injectCoreStyles() {
  if (!_class_private_field_get$17(this, _hot$1) || !_class_private_field_get$17(this, _rootDocument$3) || !_class_private_field_get$17(this, _rootDocument$3).head) {
    return;
  }
  const existing = _class_private_field_get$17(this, _rootDocument$3).getElementById(CORE_STYLES_ID);
  if (existing && existing instanceof HTMLStyleElement) {
    return;
  }
  const baseStyles = _class_private_field_get$17(this, _rootDocument$3).createElement("style");
  baseStyles.id = CORE_STYLES_ID;
  baseStyles.textContent = handsontableStyles;
  _class_private_field_get$17(this, _rootDocument$3).head.appendChild(baseStyles);
}
function calculateRowHeight() {
  const lineHeightVarValue = this.getCSSVariableValue("line-height");
  const verticalPaddingVarValue = this.getCSSVariableValue("cell-vertical-padding");
  const bottomBorderWidth = Math.round(Number.parseFloat(this.getStyleForTD("border-bottom-width") ?? ""));
  if (lineHeightVarValue === null || verticalPaddingVarValue === null || isNaN(bottomBorderWidth)) {
    return null;
  }
  return lineHeightVarValue + 2 * verticalPaddingVarValue + bottomBorderWidth;
}
function cacheStylesheetValues() {
  _class_private_field_set$17(this, _rootComputedStyle, getComputedStyle(_class_private_field_get$17(this, _rootElement$1)));
  const stylesForTD = _class_private_method_get$V(this, _getStylesForTD, getStylesForTD).call(this, [
    "box-sizing",
    "border-bottom-width"
  ]);
  _class_private_field_get$17(this, _computedStyles).td = {
    ..._class_private_field_get$17(this, _computedStyles).td,
    ...{
      "box-sizing": stylesForTD["box-sizing"],
      "border-bottom-width": stylesForTD["border-bottom-width"]
    }
  };
}
function getStylesForTD(cssProps) {
  const rootDocument = _class_private_field_get$17(this, _rootDocument$3);
  const rootElement = _class_private_field_get$17(this, _rootElement$1);
  const table = rootDocument.createElement("table");
  const tbody = rootDocument.createElement("tbody");
  const tr = rootDocument.createElement("tr");
  const tr2 = rootDocument.createElement("tr");
  const td = rootDocument.createElement("td");
  tr2.appendChild(td);
  tbody.appendChild(tr);
  tbody.appendChild(tr2);
  table.appendChild(tbody);
  rootElement.appendChild(table);
  const computedStyle = getComputedStyle(td);
  const returnObject = {};
  cssProps.forEach((prop) => {
    returnObject[prop] = computedStyle.getPropertyValue(prop);
  });
  rootElement.removeChild(table);
  return returnObject;
}
function getParsedNumericCSSValue(property) {
  const parsedValue = Math.ceil(Number.parseFloat(_class_private_method_get$V(this, _getCSSValue, getCSSValue).call(this, property) ?? ""));
  return Number.isNaN(parsedValue) ? null : parsedValue;
}
function getCSSValue(property) {
  const acquiredValue = _class_private_field_get$17(this, _rootComputedStyle)?.getPropertyValue(property) ?? null;
  return acquiredValue === "" ? null : acquiredValue;
}
function clearCachedValues() {
  _class_private_field_set$17(this, _computedStyles, {});
  _class_private_field_set$17(this, _cssVars, {});
}
let announcerElement = null;
let installCounter = 0;
function install(rootPortalElement) {
  const document2 = rootPortalElement.ownerDocument;
  if (!announcerElement) {
    announcerElement = document2.createElement("div");
    announcerElement.setAttribute("role", "status");
    announcerElement.setAttribute("aria-live", "assertive");
    announcerElement.setAttribute("aria-atomic", "true");
    const style = announcerElement.style;
    style.position = "absolute";
    style.width = "1px";
    style.height = "1px";
    style.margin = "-1px";
    style.overflow = "hidden";
    style.clipPath = "rect(0 0 0 0)";
    style.whiteSpace = "nowrap";
    rootPortalElement.appendChild(announcerElement);
  }
  installCounter += 1;
}
function uninstall() {
  if (installCounter === 0) {
    return;
  }
  if (installCounter === 1) {
    announcerElement.remove();
    announcerElement = null;
  }
  installCounter -= 1;
}
function announce(message) {
  if (!announcerElement) {
    return;
  }
  announcerElement.textContent = "";
  setTimeout(() => {
    if (announcerElement) {
      announcerElement.textContent = message;
    }
  }, 100);
}
const LAYOUT_SLOTS = {
  TOP: "top",
  BOTTOM: "bottom"
};
const SLOT_ITEM_CLASS = "ht-slot-element";
const SCOPE_ID = "licenseNotification";
const SHORTCUTS_CONTEXT_NAME$5 = `plugin:${SCOPE_ID}`;
const LICENSE_INFO_CLASS = "hot-display-license-info";
function getNotificationElement(hotInstance) {
  return hotInstance.rootSlotBottomElement?.querySelector(`.${LICENSE_INFO_CLASS}`) ?? null;
}
function getFocusableElements(hotInstance) {
  const notification = getNotificationElement(hotInstance);
  if (!notification) {
    return [];
  }
  return Array.from(notification.querySelectorAll("a[href]"));
}
function initLicenseNotification(hotInstance) {
  const container = hotInstance.rootSlotBottomElement;
  if (!container) {
    return;
  }
  const licenseKey = hotInstance.getSettings().licenseKey;
  const releaseDate = typeof process !== "undefined" && process.env?.HOT_RELEASE_DATE ? "30/06/2026" : "";
  const notificationElement = _injectProductInfo({
    className: LICENSE_INFO_CLASS,
    key: licenseKey,
    element: container,
    releaseDate
  });
  if (!notificationElement) {
    return;
  }
  notificationElement.classList.add(SLOT_ITEM_CLASS);
  container.appendChild(notificationElement);
  hotInstance.getFocusScopeManager().registerScope(SCOPE_ID, notificationElement, {
    shortcutsContextName: SHORTCUTS_CONTEXT_NAME$5,
    runOnlyIf: () => getNotificationElement(hotInstance) !== null,
    onActivate: (focusSource) => {
      const focusableElements = getFocusableElements(hotInstance);
      if (focusableElements.length > 0) {
        if (focusSource === "tab_from_above") {
          focusableElements.at(0)?.focus();
        } else if (focusSource === "tab_from_below") {
          focusableElements.at(-1)?.focus();
        }
      }
    }
  });
}
const sizing = {
  size_0: "0px",
  size_0_5: "2px",
  size_1: "4px",
  size_2: "8px",
  size_1_5: "6px",
  size_3: "12px",
  size_4: "16px",
  size_5: "20px",
  size_6: "24px",
  size_7: "28px",
  size_8: "32px",
  size_9: "36px",
  size_10: "40px",
  size_0_25: "1px"
};
const densitySizes = {
  default: {
    cellVertical: "sizing.size_1",
    cellHorizontal: "sizing.size_2",
    barsHorizontal: "sizing.size_4",
    barsVertical: "sizing.size_2",
    gap: "sizing.size_1",
    buttonHorizontal: "sizing.size_3",
    buttonVertical: "sizing.size_1_5",
    dialogHorizontal: "sizing.size_2",
    dialogVertical: "sizing.size_2",
    inputHorizontal: "sizing.size_3",
    inputVertical: "sizing.size_1_5",
    menuVertical: "sizing.size_2",
    menuHorizontal: "sizing.size_0",
    menuItemVertical: "sizing.size_1",
    menuItemHorizontal: "sizing.size_3"
  },
  compact: {
    cellVertical: "sizing.size_0_5",
    cellHorizontal: "sizing.size_1_5",
    barsHorizontal: "sizing.size_2",
    barsVertical: "sizing.size_1",
    gap: "sizing.size_0_5",
    buttonHorizontal: "sizing.size_2",
    buttonVertical: "sizing.size_0_5",
    dialogHorizontal: "sizing.size_1_5",
    dialogVertical: "sizing.size_1_5",
    inputHorizontal: "sizing.size_2",
    inputVertical: "sizing.size_0_5",
    menuVertical: "sizing.size_2",
    menuHorizontal: "sizing.size_0",
    menuItemVertical: "sizing.size_0_5",
    menuItemHorizontal: "sizing.size_2"
  },
  comfortable: {
    cellVertical: "sizing.size_2",
    cellHorizontal: "sizing.size_3",
    barsHorizontal: "sizing.size_4",
    barsVertical: "sizing.size_2",
    gap: "sizing.size_1_5",
    buttonHorizontal: "sizing.size_4",
    buttonVertical: "sizing.size_2",
    dialogHorizontal: "sizing.size_3",
    dialogVertical: "sizing.size_3",
    inputHorizontal: "sizing.size_4",
    inputVertical: "sizing.size_2",
    menuVertical: "sizing.size_3",
    menuHorizontal: "sizing.size_0",
    menuItemVertical: "sizing.size_2",
    menuItemHorizontal: "sizing.size_2"
  }
};
const VALID_PARAMS_KEYS = /* @__PURE__ */ new Set([
  "name",
  "sizing",
  "density",
  "icons",
  "colors",
  "tokens",
  "colorScheme"
]);
const VALID_COLOR_SCHEMES = /* @__PURE__ */ new Set([
  "light",
  "dark",
  "auto"
]);
const VALID_DENSITY_TYPES = /* @__PURE__ */ new Set([
  "default",
  "compact",
  "comfortable"
]);
const VALID_ICON_KEYS = /* @__PURE__ */ new Set([
  "arrowRight",
  "arrowRightWithBar",
  "arrowLeft",
  "arrowLeftWithBar",
  "arrowDown",
  "menu",
  "selectArrow",
  "arrowNarrowUp",
  "arrowNarrowDown",
  "check",
  "checkbox",
  "caretHiddenLeft",
  "caretHiddenRight",
  "caretHiddenUp",
  "caretHiddenDown",
  "collapseOff",
  "collapseOn",
  "radio",
  "chipClose",
  "search"
]);
const VALID_TOKEN_KEYS = /* @__PURE__ */ new Set([
  // Typography
  "fontFamily",
  "fontSize",
  "fontSizeSmall",
  "lineHeight",
  "lineHeightSmall",
  "fontWeight",
  "letterSpacing",
  // Layout
  "gapSize",
  "iconSize",
  "tableTransition",
  "borderRadius",
  // Base colors
  "borderColor",
  "accentColor",
  "foregroundColor",
  "foregroundSecondaryColor",
  "backgroundColor",
  "backgroundSecondaryColor",
  "placeholderColor",
  "readOnlyColor",
  "disabledColor",
  // Shadow
  "shadowColor",
  "shadowX",
  "shadowY",
  "shadowBlur",
  "shadowOpacity",
  // Bars
  "barForegroundColor",
  "barBackgroundColor",
  "barHorizontalPadding",
  "barVerticalPadding",
  // Cell
  "cellHorizontalBorderColor",
  "cellVerticalBorderColor",
  "cellHorizontalPadding",
  "cellVerticalPadding",
  // Row
  "rowHeaderOddBackgroundColor",
  "rowHeaderEvenBackgroundColor",
  "rowCellOddBackgroundColor",
  "rowCellEvenBackgroundColor",
  // Cell editor
  "cellEditorBorderWidth",
  "cellEditorBorderColor",
  "cellEditorForegroundColor",
  "cellEditorBackgroundColor",
  "cellEditorShadowBlurRadius",
  "cellEditorShadowColor",
  // Cell states
  "cellSuccessBackgroundColor",
  "cellErrorBackgroundColor",
  "cellReadOnlyBackgroundColor",
  // Cell selection
  "cellSelectionBorderColor",
  "cellSelectionBackgroundColor",
  // Cell autofill
  "cellAutofillSize",
  "cellAutofillHitAreaSize",
  "cellAutofillBorderWidth",
  "cellAutofillBorderRadius",
  "cellAutofillBorderColor",
  "cellAutofillBackgroundColor",
  "cellAutofillFillBorderColor",
  // Cell mobile
  "cellMobileHandleSize",
  "cellMobileHandleBorderWidth",
  "cellMobileHandleBorderRadius",
  "cellMobileHandleBorderColor",
  "cellMobileHandleBackgroundColor",
  "cellMobileHandleBackgroundOpacity",
  // Resize/Move indicators
  "resizeIndicatorColor",
  "moveBacklightColor",
  "moveBacklightOpacity",
  "moveIndicatorColor",
  "hiddenIndicatorColor",
  // Scrollbar
  "scrollbarBorderRadius",
  "scrollbarTrackColor",
  "scrollbarThumbColor",
  // Header
  "headerFontWeight",
  "headerForegroundColor",
  "headerBackgroundColor",
  "headerHighlightedShadowSize",
  "headerHighlightedForegroundColor",
  "headerHighlightedBackgroundColor",
  "headerActiveBorderColor",
  "headerActiveForegroundColor",
  "headerActiveBackgroundColor",
  "headerFilterBackgroundColor",
  // Header row
  "headerRowForegroundColor",
  "headerRowBackgroundColor",
  "headerRowHighlightedForegroundColor",
  "headerRowHighlightedBackgroundColor",
  "headerRowActiveForegroundColor",
  "headerRowActiveBackgroundColor",
  // Checkbox
  "checkboxSize",
  "checkboxBorderRadius",
  "checkboxBorderColor",
  "checkboxBackgroundColor",
  "checkboxIconColor",
  "checkboxFocusBorderColor",
  "checkboxFocusBackgroundColor",
  "checkboxFocusIconColor",
  "checkboxFocusRingColor",
  "checkboxDisabledBorderColor",
  "checkboxDisabledBackgroundColor",
  "checkboxDisabledIconColor",
  "checkboxCheckedBorderColor",
  "checkboxCheckedBackgroundColor",
  "checkboxCheckedIconColor",
  "checkboxCheckedFocusBorderColor",
  "checkboxCheckedFocusBackgroundColor",
  "checkboxCheckedFocusIconColor",
  "checkboxCheckedDisabledBorderColor",
  "checkboxCheckedDisabledBackgroundColor",
  "checkboxCheckedDisabledIconColor",
  "checkboxIndeterminateBorderColor",
  "checkboxIndeterminateBackgroundColor",
  "checkboxIndeterminateIconColor",
  "checkboxIndeterminateFocusBorderColor",
  "checkboxIndeterminateFocusBackgroundColor",
  "checkboxIndeterminateFocusIconColor",
  "checkboxIndeterminateDisabledBorderColor",
  "checkboxIndeterminateDisabledBackgroundColor",
  "checkboxIndeterminateDisabledIconColor",
  // Radio
  "radioSize",
  "radioBorderColor",
  "radioBackgroundColor",
  "radioIconColor",
  "radioFocusBorderColor",
  "radioFocusBackgroundColor",
  "radioFocusIconColor",
  "radioFocusRingColor",
  "radioDisabledBorderColor",
  "radioDisabledBackgroundColor",
  "radioDisabledIconColor",
  "radioCheckedBorderColor",
  "radioCheckedBackgroundColor",
  "radioCheckedIconColor",
  "radioCheckedFocusBorderColor",
  "radioCheckedFocusBackgroundColor",
  "radioCheckedFocusIconColor",
  "radioCheckedDisabledBorderColor",
  "radioCheckedDisabledBackgroundColor",
  "radioCheckedDisabledIconColor",
  // Icon button
  "iconButtonBorderRadius",
  "iconButtonLargeBorderRadius",
  "iconButtonLargePadding",
  "iconButtonBorderColor",
  "iconButtonBackgroundColor",
  "iconButtonIconColor",
  "iconButtonHitAreaSize",
  "iconButtonHoverBorderColor",
  "iconButtonHoverBackgroundColor",
  "iconButtonHoverIconColor",
  "iconButtonActiveBorderColor",
  "iconButtonActiveBackgroundColor",
  "iconButtonActiveIconColor",
  "iconButtonActiveHoverBorderColor",
  "iconButtonActiveHoverBackgroundColor",
  "iconButtonActiveHoverIconColor",
  // Collapse button
  "collapseButtonBorderRadius",
  "collapseButtonOpenBorderColor",
  "collapseButtonOpenBackgroundColor",
  "collapseButtonOpenIconColor",
  "collapseButtonOpenIconActiveColor",
  "collapseButtonOpenHoverBorderColor",
  "collapseButtonOpenHoverBackgroundColor",
  "collapseButtonOpenHoverIconColor",
  "collapseButtonOpenHoverIconActiveColor",
  "collapseButtonCloseBorderColor",
  "collapseButtonCloseBackgroundColor",
  "collapseButtonCloseIconColor",
  "collapseButtonCloseIconActiveColor",
  "collapseButtonCloseHoverBorderColor",
  "collapseButtonCloseHoverBackgroundColor",
  "collapseButtonCloseHoverIconColor",
  "collapseButtonCloseHoverIconActiveColor",
  // Button
  "buttonBorderRadius",
  "buttonHorizontalPadding",
  "buttonVerticalPadding",
  // Primary button
  "primaryButtonBorderColor",
  "primaryButtonForegroundColor",
  "primaryButtonBackgroundColor",
  "primaryButtonDisabledBorderColor",
  "primaryButtonDisabledForegroundColor",
  "primaryButtonDisabledBackgroundColor",
  "primaryButtonHoverBorderColor",
  "primaryButtonHoverForegroundColor",
  "primaryButtonHoverBackgroundColor",
  "primaryButtonFocusBorderColor",
  "primaryButtonFocusForegroundColor",
  "primaryButtonFocusBackgroundColor",
  // Secondary button
  "secondaryButtonBorderColor",
  "secondaryButtonForegroundColor",
  "secondaryButtonBackgroundColor",
  "secondaryButtonDisabledBorderColor",
  "secondaryButtonDisabledForegroundColor",
  "secondaryButtonDisabledBackgroundColor",
  "secondaryButtonHoverBorderColor",
  "secondaryButtonHoverForegroundColor",
  "secondaryButtonHoverBackgroundColor",
  "secondaryButtonFocusBorderColor",
  "secondaryButtonFocusForegroundColor",
  "secondaryButtonFocusBackgroundColor",
  // Comments
  "commentsTextareaHorizontalPadding",
  "commentsTextareaVerticalPadding",
  "commentsTextareaBorderWidth",
  "commentsTextareaBorderColor",
  "commentsTextareaForegroundColor",
  "commentsTextareaBackgroundColor",
  "commentsTextareaFocusBorderWidth",
  "commentsTextareaFocusBorderColor",
  "commentsTextareaFocusForegroundColor",
  "commentsTextareaFocusBackgroundColor",
  "commentsIndicatorSize",
  "commentsIndicatorColor",
  // License
  "licenseHorizontalPadding",
  "licenseVerticalPadding",
  "licenseForegroundColor",
  "licenseBackgroundColor",
  // Link
  "linkColor",
  "linkHoverColor",
  // Input
  "inputBorderWidth",
  "inputBorderRadius",
  "inputHorizontalPadding",
  "inputVerticalPadding",
  "inputBorderColor",
  "inputForegroundColor",
  "inputBackgroundColor",
  "inputHoverBorderColor",
  "inputHoverForegroundColor",
  "inputHoverBackgroundColor",
  "inputDisabledBorderColor",
  "inputDisabledForegroundColor",
  "inputDisabledBackgroundColor",
  "inputFocusBorderColor",
  "inputFocusForegroundColor",
  "inputFocusBackgroundColor",
  // Menu
  "menuBorderWidth",
  "menuBorderRadius",
  "menuHorizontalPadding",
  "menuVerticalPadding",
  "menuItemHorizontalPadding",
  "menuItemVerticalPadding",
  "menuBorderColor",
  "menuShadowX",
  "menuShadowY",
  "menuShadowBlur",
  "menuShadowColor",
  "menuShadowOpacity",
  "menuItemHoverColor",
  "menuItemHoverColorOpacity",
  "menuItemActiveColor",
  "menuItemActiveColorOpacity",
  // Dialog
  "dialogSemiTransparentBackgroundColor",
  "dialogSemiTransparentBackgroundOpacity",
  "dialogSolidBackgroundColor",
  "dialogContentPaddingHorizontal",
  "dialogContentPaddingVertical",
  "dialogContentBorderRadius",
  "dialogContentBackgroundColor",
  // Notification (toast)
  "notificationForegroundColor",
  "notificationBackgroundColor",
  "notificationBorderColor",
  "notificationSuccessAccent",
  "notificationWarningAccent",
  "notificationErrorAccent",
  // Pagination
  "paginationBarForegroundColor",
  "paginationBarBackgroundColor",
  "paginationBarHorizontalPadding",
  "paginationBarVerticalPadding",
  "paginationButtonBorderColor",
  "paginationButtonForegroundColor",
  "paginationButtonBackgroundColor",
  "paginationButtonHoverBorderColor",
  "paginationButtonHoverForegroundColor",
  "paginationButtonHoverBackgroundColor",
  "paginationButtonDisabledForegroundColor",
  "paginationButtonDisabledBackgroundColor",
  "paginationButtonDisabledBorderColor",
  "paginationButtonFocusBorderColor",
  "paginationButtonFocusForegroundColor",
  "paginationButtonFocusBackgroundColor",
  // Multiselect
  "chipBackground",
  "chipBorderRadius",
  "chipVerticalPadding",
  "chipHorizontalPadding",
  "chipGap"
]);
function validateName(name, context) {
  if (typeof name !== "string" || name.trim() === "") {
    throwWithCause(`[ThemeBuilder] ${context}.name must be a non-empty string.`);
  }
  return name;
}
function validateColorScheme(mode) {
  if (!VALID_COLOR_SCHEMES.has(mode)) {
    const validModes = [
      ...VALID_COLOR_SCHEMES
    ].join(", ");
    throwWithCause(`[ThemeBuilder] Invalid color scheme: "${mode}". Must be one of: ${validModes}.`);
  }
  return mode;
}
function validateDensityType(type) {
  if (!VALID_DENSITY_TYPES.has(type)) {
    const validTypes = [
      ...VALID_DENSITY_TYPES
    ].join(", ");
    throwWithCause(`[ThemeBuilder] Invalid density: "${type}". Must be one of: ${validTypes}.`);
  }
  return type;
}
function validateDensitySizes(sizes, context) {
  if (!isObject$1(sizes) || typeof sizes !== "object" || sizes === null) {
    throwWithCause(`[ThemeBuilder] ${context}.sizes must be an object.`);
    return;
  }
  Object.keys(sizes).forEach((key) => {
    if (!VALID_DENSITY_TYPES.has(key)) {
      warn$1(`[ThemeBuilder] Unknown density size key: "${key}" in ${context}.sizes. This may be a custom density size or a typo.`);
    }
  });
}
function validateDensityStructure(density, context) {
  if (isObject$1(density)) {
    const d = density;
    if (!d.type || !d.sizes) {
      throwWithCause(`[ThemeBuilder] ${context} must be a string or an object with a 'type' and 'sizes' property.`);
    }
    validateDensityType(String(d.type));
    validateDensitySizes(d.sizes, `${context}.sizes`);
  } else if (typeof density === "string") {
    validateDensityType(density);
  }
}
function validateColorsStructure(colors, context) {
  Object.entries(colors).forEach(([key, value]) => {
    const currentPath = `${context}.${key}`;
    if (typeof value === "string") {
      return;
    }
    if (isObject$1(value)) {
      validateColorsStructure(value, currentPath);
    } else {
      throwWithCause(`[ThemeBuilder] ${currentPath} must be a string or an object.`);
    }
  });
}
function validateKeys(obj, validKeys, context, options = {}) {
  const { type = "key", warnMissing = false } = options;
  if (!obj) {
    if (warnMissing) {
      warn$1(`[ThemeBuilder] No ${type}s provided in ${context}. All ${type}s are missing.`);
    }
    return;
  }
  const providedKeys = Object.keys(obj);
  providedKeys.forEach((key) => {
    if (!validKeys.has(key)) {
      warn$1(`[ThemeBuilder] Unknown ${type} key: "${key}" in ${context}. This may be a custom ${type} or a typo.`);
    }
  });
  if (warnMissing) {
    const missingKeys = [];
    validKeys.forEach((key) => {
      if (!(key in obj)) {
        missingKeys.push(key);
      }
    });
    if (missingKeys.length > 0) {
      warn$1(`[ThemeBuilder] Missing ${type}(s) in ${context}: ${missingKeys.join(", ")}`);
    }
  }
}
function validateParams(parameters, context, options = {}) {
  const { requiredFields = [] } = options;
  if (typeof parameters !== "object" || parameters === null) {
    throwWithCause(`[ThemeBuilder] ${context} must be an object.`);
  }
  const params = parameters;
  const { name, sizing: sizing2, density, icons, colors, tokens, colorScheme } = params;
  validateKeys(params, VALID_PARAMS_KEYS, context, {
    type: "param"
  });
  requiredFields.forEach((field) => {
    if (params[field] === void 0) {
      throwWithCause(`[ThemeBuilder] ${context}.${field} is required.`);
    }
  });
  if (name !== void 0) {
    validateName(name, context);
  }
  if (sizing2 !== void 0) {
    if (!isObject$1(sizing2)) {
      throwWithCause(`[ThemeBuilder] ${context}.sizing must be an object.`);
    }
  }
  if (density !== void 0) {
    if (!isObject$1(density) && typeof density !== "string") {
      throwWithCause(`[ThemeBuilder] ${context}.density must be a string or an object.`);
    }
    validateDensityStructure(density, `${context}.density`);
  }
  if (icons !== void 0) {
    if (!isObject$1(icons)) {
      throwWithCause(`[ThemeBuilder] ${context}.icons must be an object.`);
    }
    validateKeys(icons, VALID_ICON_KEYS, `${context}.icons`, {
      type: "icon",
      warnMissing: requiredFields.includes("icons")
    });
  }
  if (colors !== void 0) {
    if (!isObject$1(colors)) {
      throwWithCause(`[ThemeBuilder] ${context}.colors must be an object.`);
    }
    validateColorsStructure(colors, `${context}.colors`);
  }
  if (tokens !== void 0) {
    if (!isObject$1(tokens)) {
      throwWithCause(`[ThemeBuilder] ${context}.tokens must be an object.`);
    }
    validateKeys(tokens, VALID_TOKEN_KEYS, `${context}.tokens`, {
      type: "token",
      warnMissing: requiredFields.includes("tokens")
    });
  }
  if (colorScheme !== void 0) {
    validateColorScheme(String(colorScheme));
  }
}
function _check_private_redeclaration$1h(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$16(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$16(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$16(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$16(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$16(receiver, privateMap, "get");
  return _class_apply_descriptor_get$16(receiver, descriptor);
}
function _class_private_field_init$16(obj, privateMap, value) {
  _check_private_redeclaration$1h(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$16(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$16(receiver, privateMap, "set");
  _class_apply_descriptor_set$16(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$U(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$U(obj, privateSet) {
  _check_private_redeclaration$1h(obj, privateSet);
  privateSet.add(obj);
}
const MERGEABLE_CONFIG_KEYS = [
  "sizing",
  "icons",
  "colors",
  "tokens"
];
const REQUIRED_CONFIG_KEYS = [
  "name",
  "icons",
  "colors",
  "tokens"
];
var _initThemeConfig = /* @__PURE__ */ new WeakMap(), _themeConfig = /* @__PURE__ */ new WeakMap(), _listeners = /* @__PURE__ */ new WeakMap(), _colorScheme = /* @__PURE__ */ new WeakMap(), _densityType = /* @__PURE__ */ new WeakMap(), _notifyChange = /* @__PURE__ */ new WeakSet(), _applyDensityConfig = /* @__PURE__ */ new WeakSet(), _setParams = /* @__PURE__ */ new WeakSet();
class ThemeBuilder {
  /**
  * Subscribes to theme configuration changes.
  *
  * @param {Function} listener The callback invoked with the updated theme configuration.
  * @returns {Function} An unsubscribe function.
  */
  subscribe(listener) {
    if (typeof listener !== "function") {
      throwWithCause("[ThemeBuilder] listener must be a function.");
    }
    _class_private_field_get$16(this, _listeners).add(listener);
    return () => _class_private_field_get$16(this, _listeners).delete(listener);
  }
  /**
  * Sets theme configuration parameters.
  *
  * @param {object} paramsObject An object with theme configuration parameters.
  * @returns {ThemeBuilder} The ThemeBuilder instance for chaining.
  */
  params(paramsObject) {
    validateParams(paramsObject, "params");
    _class_private_method_get$U(this, _setParams, setParams).call(this, paramsObject);
    _class_private_method_get$U(this, _notifyChange, notifyChange).call(this);
    return this;
  }
  /**
  * Sets the color mode (light, dark, or auto).
  *
  * @param {string} mode The color mode ('light', 'dark', or 'auto').
  * @returns {ThemeBuilder} The ThemeBuilder instance for chaining.
  */
  setColorScheme(mode) {
    _class_private_field_set$16(this, _colorScheme, validateColorScheme(mode));
    _class_private_field_get$16(this, _themeConfig).colorScheme = _class_private_field_get$16(this, _colorScheme);
    _class_private_field_get$16(this, _initThemeConfig).colorScheme = _class_private_field_get$16(this, _colorScheme);
    _class_private_method_get$U(this, _notifyChange, notifyChange).call(this);
    return this;
  }
  /**
  * Sets the density type (compact, default, or comfortable).
  *
  * @param {string} type The density type ('compact', 'default', or 'comfortable').
  * @returns {ThemeBuilder} The ThemeBuilder instance for chaining.
  */
  setDensityType(type) {
    _class_private_field_set$16(this, _densityType, validateDensityType(type));
    _class_private_field_get$16(this, _themeConfig).density.type = _class_private_field_get$16(this, _densityType);
    _class_private_field_get$16(this, _initThemeConfig).density.type = _class_private_field_get$16(this, _densityType);
    _class_private_method_get$U(this, _notifyChange, notifyChange).call(this);
    return this;
  }
  /**
  * Gets the current theme configuration.
  *
  * @returns {ThemeConfig} The theme configuration object.
  */
  getThemeConfig() {
    return _class_private_field_get$16(this, _themeConfig);
  }
  /**
  * The theme builder constructor.
  *
  * @param {object} themeConfig - The theme config object with `name`, `sizing`, `density`, `icons`, `colors`, `tokens`, and `colorScheme` properties.
  */
  constructor(themeConfig) {
    _class_private_method_init$U(this, _notifyChange);
    _class_private_method_init$U(this, _applyDensityConfig);
    _class_private_method_init$U(this, _setParams);
    _class_private_field_init$16(this, _initThemeConfig, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$16(this, _themeConfig, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$16(this, _listeners, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$16(this, _colorScheme, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$16(this, _densityType, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$16(this, _listeners, /* @__PURE__ */ new Set());
    _class_private_field_set$16(this, _colorScheme, "auto");
    _class_private_field_set$16(this, _densityType, "default");
    validateParams(themeConfig, "themeConfig", {
      requiredFields: REQUIRED_CONFIG_KEYS
    });
    _class_private_field_set$16(this, _initThemeConfig, {
      name: void 0,
      sizing,
      density: {
        type: _class_private_field_get$16(this, _densityType),
        sizes: densitySizes
      },
      icons: {},
      colors: {},
      tokens: {},
      colorScheme: _class_private_field_get$16(this, _colorScheme)
    });
    _class_private_method_get$U(this, _setParams, setParams).call(this, themeConfig);
    _class_private_field_set$16(this, _initThemeConfig, _class_private_field_get$16(this, _themeConfig));
  }
}
function notifyChange() {
  const config = this.getThemeConfig();
  _class_private_field_get$16(this, _listeners).forEach((listener) => listener(config));
}
function applyDensityConfig(config, density) {
  if (typeof density !== "string") {
    const mergedDensity = deepMerge(config.density, density);
    config.density = mergedDensity;
    if (density.type !== void 0) {
      _class_private_field_set$16(this, _densityType, density.type);
      if (_class_private_field_get$16(this, _initThemeConfig)?.density) {
        _class_private_field_get$16(this, _initThemeConfig).density.type = density.type;
      }
    }
  } else {
    config.density.type = density;
    _class_private_field_set$16(this, _densityType, density);
    if (_class_private_field_get$16(this, _initThemeConfig)?.density) {
      _class_private_field_get$16(this, _initThemeConfig).density.type = density;
    }
  }
}
function setParams(paramsObject) {
  const config = deepClone(_class_private_field_get$16(this, _initThemeConfig));
  const paramsRecord = paramsObject;
  if (paramsObject.name !== void 0) {
    if (_class_private_field_get$16(this, _initThemeConfig).name !== void 0) {
      warn$1('[ThemeBuilder] The "name" property can only be set during `registerTheme()` and cannot be updated via `params()`.');
    } else {
      config.name = paramsObject.name;
    }
  }
  MERGEABLE_CONFIG_KEYS.forEach((key) => {
    if (paramsRecord[key] !== void 0 && isObject$1(paramsRecord[key])) {
      config[key] = deepMerge(config[key], paramsRecord[key]);
    }
  });
  if (paramsObject.density !== void 0) {
    _class_private_method_get$U(this, _applyDensityConfig, applyDensityConfig).call(this, config, paramsObject.density);
  }
  if (paramsObject.colorScheme !== void 0) {
    config.colorScheme = paramsObject.colorScheme;
    _class_private_field_set$16(this, _colorScheme, paramsObject.colorScheme);
    if (_class_private_field_get$16(this, _initThemeConfig)?.colorScheme) {
      _class_private_field_get$16(this, _initThemeConfig).colorScheme = paramsObject.colorScheme;
    }
  }
  _class_private_field_set$16(this, _themeConfig, config);
}
function createTheme(baseTheme) {
  return new ThemeBuilder(baseTheme);
}
const icon = (icons, name) => {
  return `width: var(--ht-icon-size);
  height: var(--ht-icon-size);
  -webkit-mask-size: contain;
  -webkit-mask-image: url("${icons[name]}");
  background-color: currentColor;`;
};
const iconsMap = (icons, themePrefix) => {
  const prefix = "";
  return `${prefix}.htDropdownMenu table tbody tr td.htSubmenu .htItemWrapper::after,
${prefix}.htContextMenu table tbody tr td.htSubmenu .htItemWrapper::after,
${prefix}.htFiltersConditionsMenu table tbody tr td.htSubmenu .htItemWrapper::after,
${prefix}.pika-single .pika-next {
  ${icon(icons, "arrowRight")}
}

${prefix}.pika-single .pika-prev {
  ${icon(icons, "arrowLeft")}
}

${prefix}.ht-page-size-section__select-wrapper::after {
  ${icon(icons, "arrowDown")}
}

${prefix}.changeType::before {
  ${icon(icons, "menu")}
}

${prefix}.htUISelectCaption::after,
.htAutocompleteArrow::after {
  ${icon(icons, "selectArrow")}
}

${prefix}.columnSorting.sortAction.ascending::before {
  ${icon(icons, "arrowNarrowUp")}
}

${prefix}.columnSorting.sortAction.descending::before {
  ${icon(icons, "arrowNarrowDown")}
}

${prefix}.ht-page-navigation-section .ht-page-first::before {
  ${icon(icons, "arrowLeftWithBar")}
}

${prefix}[dir="rtl"] .ht-page-navigation-section .ht-page-first::before {
  ${icon(icons, "arrowRightWithBar")}
}

${prefix}.ht-page-navigation-section .ht-page-prev::before {
  ${icon(icons, "arrowLeft")}
}

${prefix}[dir="rtl"] .ht-page-navigation-section .ht-page-prev::before {
  ${icon(icons, "arrowRight")}
}

${prefix}.ht-page-navigation-section .ht-page-next::before {
  ${icon(icons, "arrowRight")}
}

${prefix}[dir="rtl"] .ht-page-navigation-section .ht-page-next::before {
  ${icon(icons, "arrowLeft")}
}

${prefix}.ht-page-navigation-section .ht-page-last::before {
  ${icon(icons, "arrowRightWithBar")}
}

${prefix}[dir="rtl"] .ht-page-navigation-section .ht-page-last::before {
  ${icon(icons, "arrowLeftWithBar")}
}

${prefix}.htDropdownMenu table tbody tr td .htItemWrapper span.selected::after,
${prefix}.htContextMenu table tbody tr td .htItemWrapper span.selected::after,
${prefix}.htFiltersConditionsMenu table tbody tr td .htItemWrapper span.selected::after {
  ${icon(icons, "check")}
}

${prefix}.htCheckboxRendererInput {
  appearance: none;
}

${prefix}.htCheckboxRendererInput::after {
  ${icon(icons, "checkbox")}
}

${prefix}th.beforeHiddenColumn::after {
  ${icon(icons, "caretHiddenLeft")}
}

${prefix}th.afterHiddenColumn::before {
  ${icon(icons, "caretHiddenRight")}
}

${prefix}th.beforeHiddenRow::after {
  ${icon(icons, "caretHiddenUp")}
}

${prefix}th.afterHiddenRow::before {
  ${icon(icons, "caretHiddenDown")}
}

${prefix}.collapsibleIndicator::before,
${prefix}.ht_nestingButton::before {
  ${icon(icons, "collapseOff")}
}

${prefix}.collapsibleIndicator.collapsed::before,
${prefix}.ht_nestingButton.ht_nestingExpand::before {
  ${icon(icons, "collapseOn")}
}

${prefix}.htUIRadio > input[type="radio"]::after {
  ${icon(icons, "radio")}
}

${prefix}.ht-multi-select-chip-remove::before {
  ${icon(icons, "chipClose")}
}

${prefix}.ht-notification__close::before {
  ${icon(icons, "chipClose")}
}

${prefix}.ht-multi-select-editor-search-icon {
  ${icon(icons, "search")}
}

${prefix}.ht-multi-select-editor-item-selected input::after {
  ${icon(icons, "checkbox")}
}`;
};
const VAR_PREFIX = "--ht-";
const CSS_KEY_EXCEPTIONS = [
  "font-family"
];
const VAR_REFERENCE_PREFIXES = [
  "tokens.",
  "colors.",
  "sizing.",
  "density."
];
function isVarReference(value) {
  return typeof value === "string" && VAR_REFERENCE_PREFIXES.some((prefix) => value.includes(prefix));
}
function toVarReference(path) {
  if (path.includes("tokens.")) {
    return `var(${VAR_PREFIX}${toHyphen(path.split(".").slice(1).join("-"))})`;
  }
  return `var(${VAR_PREFIX}${toHyphen(path.split(".").join("-"))})`;
}
function toCssKey(prefix, key) {
  return `${VAR_PREFIX}${prefix ? `${prefix}-` : ""}${toHyphen(key)}`;
}
function toCssValue(value, key) {
  if (typeof value === "string" && isVarReference(value)) {
    return toVarReference(value);
  }
  if (Array.isArray(value)) {
    if (value.length >= 2) {
      const [light, dark] = value;
      if (typeof light === "string" && typeof dark === "string") {
        return `light-dark(${toCssValue(light, key)}, ${toCssValue(dark, key)})`;
      }
      if (typeof light === "string") {
        return toCssValue(light, key);
      }
      if (typeof dark === "string") {
        return toCssValue(dark, key);
      }
      return "";
    }
    return toCssValue(value[0], key);
  }
  if (key && CSS_KEY_EXCEPTIONS.includes(key)) {
    return String(value);
  }
  return toHyphen(String(value));
}
function toCssLine(prefix, key, value) {
  return `${toCssKey(prefix, key)}: ${toCssValue(value, key)};`;
}
function flattenCssVariables(cssVariables, prefix = "", parentKey = "") {
  let cssVars = "";
  Object.entries(cssVariables).forEach(([key, value]) => {
    const normalizedKey = toHyphen(key);
    const fullKey = parentKey ? `${parentKey}-${normalizedKey}` : normalizedKey;
    if (isObject$1(value)) {
      cssVars += flattenCssVariables(value, prefix, fullKey);
    } else {
      cssVars += `${toCssLine(prefix, fullKey, value)}
`;
    }
  });
  return cssVars;
}
function _check_private_redeclaration$1g(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$15(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$15(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$15(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$15(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$15(receiver, privateMap, "get");
  return _class_apply_descriptor_get$15(receiver, descriptor);
}
function _class_private_field_init$15(obj, privateMap, value) {
  _check_private_redeclaration$1g(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$15(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$15(receiver, privateMap, "set");
  _class_apply_descriptor_set$15(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$T(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$T(obj, privateSet) {
  _check_private_redeclaration$1g(obj, privateSet);
  privateSet.add(obj);
}
const THEME_PREFIX = "ht-theme-";
const THEME_STYLE_ATTRIBUTE = "data-hot-theme-style";
var _unsubscribeTheme = /* @__PURE__ */ new WeakMap(), _injectThemeStyles = /* @__PURE__ */ new WeakSet();
class ThemeManager {
  /**
  * Gets the theme class name.
  *
  * @returns {string} The theme class name.
  */
  getClassName() {
    return this.themeClassName;
  }
  /**
  * Updates the theme manager.
  *
  * @param {object} themeObject - The theme object.
  */
  update(themeObject) {
    var _this, _this1;
    if (!this.hot) {
      return;
    }
    if (themeObject.getThemeConfig === void 0) {
      throwWithCause('[ThemeManager] The "theme" option must be an instance of ThemeBuilder.');
    }
    this.themeConfig = themeObject.getThemeConfig();
    this.themeClassName = `${THEME_PREFIX}${this.themeConfig.name}`;
    if (typeof themeObject.subscribe === "function") {
      (_this = _class_private_field_get$15(_this1 = this, _unsubscribeTheme)) === null || _this === void 0 ? void 0 : _this.call(_this1);
      _class_private_field_set$15(this, _unsubscribeTheme, themeObject.subscribe((config) => {
        if (!this.hot?.stylesHandler) {
          return;
        }
        this.themeConfig = config;
        _class_private_method_get$T(this, _injectThemeStyles, injectThemeStyles).call(this);
        this.hot.stylesHandler.clearCache();
        this.hot.render();
        this.hot.runHooks("afterSetTheme", this.themeClassName, false);
      }));
    }
    this.mount();
    this.hot.runHooks("afterSetTheme", this.themeClassName, true);
  }
  /**
  * Mounts the theme manager.
  */
  mount() {
    _class_private_method_get$T(this, _injectThemeStyles, injectThemeStyles).call(this);
  }
  /**
  * Unmounts the theme manager.
  */
  unmount() {
    if (this.themeStyles) {
      this.themeStyles.remove();
    }
  }
  /**
  * Destroys the theme manager.
  */
  destroy() {
    var _this, _this1;
    (_this = _class_private_field_get$15(_this1 = this, _unsubscribeTheme)) === null || _this === void 0 ? void 0 : _this.call(_this1);
    this.unmount();
    this.hot.themeManager = null;
  }
  /**
  * The theme manager constructor.
  *
  * @param {object} options - The options object.
  * @param {Handsontable} options.hot - The Handsontable instance.
  * @param {object} options.themeObject - The theme object.
  */
  constructor({ hot, themeObject }) {
    _class_private_method_init$T(this, _injectThemeStyles);
    _class_private_field_init$15(this, _unsubscribeTheme, {
      writable: true,
      value: void 0
    });
    this.themeStyles = null;
    this.themeClassName = "";
    this.themeConfig = null;
    _class_private_field_set$15(this, _unsubscribeTheme, null);
    this.hot = hot;
    this.update(themeObject);
  }
}
function injectThemeStyles() {
  if (!this.themeConfig || !this.hot || !this.hot.rootDocument || !this.hot.rootWrapperElement) {
    return;
  }
  const colorScheme = this.themeConfig.colorScheme === "auto" ? "light dark" : this.themeConfig.colorScheme;
  if (!this.themeStyles) {
    this.themeStyles = this.hot.rootDocument.createElement("style");
    this.themeStyles.setAttribute(THEME_STYLE_ATTRIBUTE, "true");
  }
  this.themeStyles.textContent = `:where(.${this.themeClassName}) {
`;
  if (this.themeConfig.sizing) {
    this.themeStyles.textContent += flattenCssVariables(this.themeConfig.sizing, "sizing");
  }
  if (this.themeConfig.density && this.themeConfig.density.type && this.themeConfig.density.sizes && this.themeConfig.density.sizes[this.themeConfig.density.type]) {
    this.themeStyles.textContent += flattenCssVariables(this.themeConfig.density.sizes[this.themeConfig.density.type], "density");
  }
  if (this.themeConfig.colors) {
    this.themeStyles.textContent += flattenCssVariables(this.themeConfig.colors, "colors");
  }
  if (this.themeConfig.tokens) {
    this.themeStyles.textContent += flattenCssVariables(this.themeConfig.tokens);
  }
  if (this.themeConfig.icons) {
    this.themeStyles.textContent += iconsMap(this.themeConfig.icons);
  }
  this.themeStyles.textContent += "}\n";
  this.themeStyles.textContent += `.${this.themeClassName} {
color-scheme: ${colorScheme};
}`;
  if (this.themeStyles.parentNode !== this.hot.rootWrapperElement) {
    this.hot.rootWrapperElement.prepend(this.themeStyles);
  }
}
function createThemeManager({ hot, themeObject }) {
  return new ThemeManager({
    hot,
    themeObject
  });
}
function _check_private_redeclaration$1f(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$14(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$14(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$14(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$14(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$14(receiver, privateMap, "get");
  return _class_apply_descriptor_get$14(receiver, descriptor);
}
function _class_private_field_init$14(obj, privateMap, value) {
  _check_private_redeclaration$1f(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$14(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$14(receiver, privateMap, "set");
  _class_apply_descriptor_set$14(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$S(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$S(obj, privateSet) {
  _check_private_redeclaration$1f(obj, privateSet);
  privateSet.add(obj);
}
var _parent = /* @__PURE__ */ new WeakMap(), _entries = /* @__PURE__ */ new WeakMap(), _seq = /* @__PURE__ */ new WeakMap(), _order = /* @__PURE__ */ new WeakMap(), _itemClass = /* @__PURE__ */ new WeakMap(), _sortedKeys = /* @__PURE__ */ new WeakSet(), _reorder = /* @__PURE__ */ new WeakSet();
class DomSlot {
  /**
  * Returns the slot container element.
  *
  * @returns {HTMLElement} The container element.
  */
  getElement() {
    return _class_private_field_get$14(this, _parent);
  }
  /**
  * Checks whether a key is registered.
  *
  * @param {string} key The registration key.
  * @returns {boolean} `true` when the key is registered.
  */
  has(key) {
    return _class_private_field_get$14(this, _entries).has(key);
  }
  /**
  * Registers (or replaces) an element under a key and re-applies the slot order.
  *
  * @param {string} key The registration key.
  * @param {HTMLElement} element The element to insert.
  * @param {number} [weight=0] The ordering weight (lower comes first).
  * @returns {void}
  */
  add(key, element, weight = 0) {
    const existing = _class_private_field_get$14(this, _entries).get(key);
    const seq = existing ? existing.seq : _class_private_field_get$14(this, _seq);
    if (existing) {
      existing.element.remove();
    }
    if (_class_private_field_get$14(this, _itemClass)) {
      element.classList.add(_class_private_field_get$14(this, _itemClass));
    }
    _class_private_field_get$14(this, _entries).set(key, {
      element,
      weight,
      seq
    });
    if (!existing) {
      _class_private_field_set$14(this, _seq, _class_private_field_get$14(this, _seq) + 1);
    }
    _class_private_method_get$S(this, _reorder, reorder).call(this);
  }
  /**
  * Unregisters a key and detaches its element from the DOM.
  *
  * @param {string} key The registration key.
  * @returns {void}
  */
  remove(key) {
    const entry = _class_private_field_get$14(this, _entries).get(key);
    if (!entry) {
      return;
    }
    if (_class_private_field_get$14(this, _itemClass)) {
      entry.element.classList.remove(_class_private_field_get$14(this, _itemClass));
    }
    entry.element.remove();
    _class_private_field_get$14(this, _entries).delete(key);
  }
  /**
  * Sets the user-configured key order and re-applies it.
  *
  * @param {string[]} order The ordered list of keys.
  * @returns {void}
  */
  setOrder(order) {
    _class_private_field_set$14(this, _order, Array.isArray(order) ? order.slice() : []);
    _class_private_method_get$S(this, _reorder, reorder).call(this);
  }
  /**
  * Returns the current resolved key order.
  *
  * @returns {string[]} The ordered keys.
  */
  getOrder() {
    return _class_private_method_get$S(this, _sortedKeys, sortedKeys).call(this);
  }
  /**
  * Removes all registered elements and clears the registry.
  *
  * @returns {void}
  */
  clear() {
    _class_private_field_get$14(this, _entries).forEach((entry) => entry.element.remove());
    _class_private_field_get$14(this, _entries).clear();
  }
  /**
  * @param {HTMLElement} parent The slot container element.
  * @param {object} [options] Slot options.
  * @param {string} [options.itemClass=''] Class added to every registered element.
  */
  constructor(parent, { itemClass = "" } = {}) {
    _class_private_method_init$S(this, _sortedKeys);
    _class_private_method_init$S(this, _reorder);
    _class_private_field_init$14(this, _parent, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$14(this, _entries, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$14(this, _seq, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$14(this, _order, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$14(this, _itemClass, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$14(this, _entries, /* @__PURE__ */ new Map());
    _class_private_field_set$14(this, _seq, 0);
    _class_private_field_set$14(this, _order, []);
    _class_private_field_set$14(this, _parent, parent);
    _class_private_field_set$14(this, _itemClass, itemClass);
  }
}
function sortedKeys() {
  const order = _class_private_field_get$14(this, _order);
  return Array.from(_class_private_field_get$14(this, _entries).keys()).sort((a, b) => {
    const ai = order.indexOf(a);
    const bi = order.indexOf(b);
    if (ai !== -1 || bi !== -1) {
      return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
    }
    const ea = _class_private_field_get$14(this, _entries).get(a);
    const eb = _class_private_field_get$14(this, _entries).get(b);
    return ea.weight !== eb.weight ? ea.weight - eb.weight : ea.seq - eb.seq;
  });
}
function reorder() {
  let ref = _class_private_field_get$14(this, _parent).firstChild;
  _class_private_method_get$S(this, _sortedKeys, sortedKeys).call(this).forEach((key) => {
    const element = _class_private_field_get$14(this, _entries).get(key).element;
    if (element === ref) {
      ref = ref.nextSibling;
    } else {
      _class_private_field_get$14(this, _parent).insertBefore(element, ref);
    }
  });
}
function _check_private_redeclaration$1e(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$13(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$13(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$13(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$13(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$13(receiver, privateMap, "get");
  return _class_apply_descriptor_get$13(receiver, descriptor);
}
function _class_private_field_init$13(obj, privateMap, value) {
  _check_private_redeclaration$1e(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$13(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$13(receiver, privateMap, "set");
  _class_apply_descriptor_set$13(receiver, descriptor, value);
  return value;
}
var _slots = /* @__PURE__ */ new WeakMap();
class LayoutManager {
  /**
  * Returns the slot registered under the given name.
  *
  * @param {LayoutSlotName} name The slot name.
  * @returns {DomSlot} The slot.
  */
  getSlot(name) {
    const slot = _class_private_field_get$13(this, _slots).get(name);
    if (!slot) {
      throwWithCause(`Unknown layout slot "${name}".`);
    }
    return slot;
  }
  /**
  * Registers an element into a slot, owning both its DOM placement and its ordering. The element
  * is appended to the slot container in resolved order, so a contributor does not place it in the
  * DOM itself. Re-registering under the same key replaces the previous element.
  *
  * Each contributor owns its weight (lower comes first); pick weights with gaps (multiples of 100)
  * to leave room between contributors.
  *
  * @param {string} key The registration key (also used to remove and to order via the `layout` setting).
  * @param {HTMLElement} element The element to place.
  * @param {LayoutRegisterOptions} options The target slot and ordering weight.
  * @returns {void}
  */
  register(key, element, { side, weight = 0 }) {
    this.getSlot(side).add(key, element, weight);
  }
  /**
  * Unregisters a key from a slot and detaches its element from the DOM.
  *
  * @param {string} key The registration key.
  * @param {LayoutSide} side The slot the key was registered into.
  * @returns {void}
  */
  unregister(key, side) {
    this.getSlot(side).remove(key);
  }
  /**
  * Applies the per-slot key order from a layout configuration.
  *
  * @param {LayoutConfig} [config={}] The layout configuration.
  * @returns {void}
  */
  applyConfig(config = {}) {
    Object.values(LAYOUT_SLOTS).forEach((side) => this.getSlot(side).setOrder(config?.[side] ?? []));
  }
  /**
  * Clears all slot contents. The slot map is kept so late `getSlot` calls during teardown
  * (for example a plugin's `disablePlugin` running after the manager is destroyed) stay safe.
  *
  * @returns {void}
  */
  destroy() {
    _class_private_field_get$13(this, _slots).forEach((slot) => slot.clear());
  }
  /**
  * @param {Record<LayoutSlotName, HTMLElement>} elements The slot container elements, keyed by slot name.
  */
  constructor(elements) {
    _class_private_field_init$13(this, _slots, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$13(this, _slots, new Map(Object.keys(elements).map((name) => [
      name,
      new DomSlot(elements[name], {
        itemClass: SLOT_ITEM_CLASS
      })
    ])));
  }
}
const mainIcons = {
  arrowRight: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.64648 10.9393L9.93938 7.64644L6.64648 4.35354' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  arrowRightWithBar: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.9292 4.64188L8.27934 7.99203L4.9292 11.3422M11.0711 4.08353V11.3422' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E",
  arrowLeft: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.49268 11.2929L6.19978 8.00001L9.49268 4.70712' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  arrowLeftWithBar: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.0713 4.64188L7.72115 7.99203L11.0713 11.3422M4.92936 4.08353L4.92936 11.3422' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E",
  arrowDown: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.6'%3E%3Cpath d='M11.5859 6L8.29304 9.29289L5.00015 6' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E",
  menu: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.0002 6.66663C11.4262 6.66663 11.6487 7.15963 11.3917 7.47813L11.3537 7.52013L8.35372 10.5201C8.26762 10.6062 8.15307 10.6579 8.03156 10.6656C7.91005 10.6732 7.78992 10.6363 7.69372 10.5616L7.64672 10.5201L4.64672 7.52013L4.60522 7.47313L4.57822 7.43463L4.55122 7.38663L4.54272 7.36863L4.52922 7.33513L4.51322 7.28113L4.50822 7.25463L4.50322 7.22463L4.50122 7.19613V7.13713L4.50372 7.10813L4.50822 7.07813L4.51322 7.05213L4.52922 6.99813L4.54272 6.96463L4.57772 6.89863L4.61022 6.85363L4.64672 6.81313L4.69372 6.77163L4.73222 6.74463L4.78022 6.71763L4.79822 6.70913L4.83172 6.69563L4.88572 6.67963L4.91222 6.67463L4.94222 6.66963L4.97072 6.66763L11.0002 6.66663Z' fill='currentColor'/%3E%3C/svg%3E%0A",
  selectArrow: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.0002 6.66663C11.4262 6.66663 11.6487 7.15963 11.3917 7.47813L11.3537 7.52013L8.35372 10.5201C8.26762 10.6062 8.15307 10.6579 8.03156 10.6656C7.91005 10.6732 7.78992 10.6363 7.69372 10.5616L7.64672 10.5201L4.64672 7.52013L4.60522 7.47313L4.57822 7.43463L4.55122 7.38663L4.54272 7.36863L4.52922 7.33513L4.51322 7.28113L4.50822 7.25463L4.50322 7.22463L4.50122 7.19613V7.13713L4.50372 7.10813L4.50822 7.07813L4.51322 7.05213L4.52922 6.99813L4.54272 6.96463L4.57772 6.89863L4.61022 6.85363L4.64672 6.81313L4.69372 6.77163L4.73222 6.74463L4.78022 6.71763L4.79822 6.70913L4.83172 6.69563L4.88572 6.67963L4.91222 6.67463L4.94222 6.66963L4.97072 6.66763L11.0002 6.66663Z' fill='currentColor'/%3E%3C/svg%3E%0A",
  arrowNarrowUp: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.00008 12.6667L8.00008 3.33335M8.00008 3.33335L5.33342 6.00002M8.00008 3.33335L10.6667 6.00002' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  arrowNarrowDown: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.00004 3.33331V12.6666M8.00004 12.6666L10.6667 9.99998M8.00004 12.6666L5.33337 9.99998' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  check: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.33337 8.00002L6.66671 11.3334L13.3334 4.66669' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  checkbox: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 8L7 10L11 6' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  caretHiddenLeft: "data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.08482 1.35771L6.11503 1.3551H6.17649L6.2067 1.35771L6.23795 1.36239L6.26503 1.3676L6.32128 1.38427L6.35618 1.39833L6.42493 1.43479L6.4718 1.46864L6.51399 1.50667L6.55722 1.55562L6.58534 1.59573L6.61347 1.64573L6.62232 1.66448L6.63639 1.69937L6.65305 1.75562L6.65826 1.78323L6.66347 1.81448L6.66555 1.84417L6.66659 1.87489V8.12489C6.66659 8.56864 6.15305 8.80042 5.82128 8.53271L5.77753 8.49312L2.65253 5.36812C2.56286 5.27844 2.50899 5.15912 2.50103 5.03254C2.49307 4.90596 2.53157 4.78083 2.6093 4.68062L2.65253 4.63167L5.77753 1.50667L5.82649 1.46344L5.86659 1.43531L5.91659 1.40719L5.93534 1.39833L5.97024 1.38427L6.02649 1.3676L6.05409 1.36239L6.08482 1.35771Z' fill='currentColor'/%3E%3C/svg%3E",
  caretHiddenRight: "data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.33337 1.87499C3.33337 1.43124 3.84692 1.19947 4.17869 1.46718L4.22244 1.50676L7.34744 4.63176C7.43711 4.72145 7.49098 4.84077 7.49894 4.96735C7.5069 5.09392 7.4684 5.21905 7.39067 5.31926L7.34744 5.36822L4.22244 8.49322L4.17348 8.53645L4.13337 8.56457L4.08337 8.5927L4.06462 8.60155L4.02973 8.61562L3.97348 8.63228L3.94587 8.63749L3.91462 8.6427L3.88494 8.64478L3.85421 8.64582L3.82348 8.64478L3.79327 8.64218L3.76202 8.63749L3.73494 8.63228L3.67869 8.61562L3.64379 8.60155L3.57504 8.5651L3.52817 8.53124L3.48598 8.49322L3.44275 8.44426L3.41462 8.40416L3.3865 8.35416L3.37764 8.33541L3.36358 8.30051L3.34692 8.24426L3.34171 8.21666L3.3365 8.18541L3.33442 8.15572L3.33337 1.87499Z' fill='currentColor'/%3E%3C/svg%3E",
  caretHiddenUp: "data:image/svg+xml;charset=utf-8,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.76425 2.43099C3.82165 2.3736 3.89801 2.33913 3.97902 2.33403C4.06003 2.32894 4.14012 2.35358 4.20425 2.40333L4.23558 2.43099L6.23558 4.43099L6.26325 4.46233L6.28125 4.48799L6.29925 4.51999L6.30492 4.53199L6.31392 4.55433L6.32458 4.59033L6.32792 4.60799L6.33125 4.62799L6.33258 4.64699L6.33325 4.66666L6.33258 4.68633L6.33092 4.70566L6.32792 4.72566L6.32458 4.74299L6.31392 4.77899L6.30492 4.80133L6.28158 4.84533L6.25992 4.87533L6.23558 4.90233L6.20425 4.92999L6.17858 4.94799L6.14658 4.96599L6.13458 4.97166L6.11225 4.98066L6.07625 4.99133L6.05858 4.99466L6.03858 4.99799L6.01958 4.99933L5.99992 4.99999H1.99992C1.71592 4.99999 1.56758 4.67133 1.73892 4.45899L1.76425 4.43099L3.76425 2.43099Z' fill='currentColor'/%3E%3C/svg%3E%0A",
  caretHiddenDown: "data:image/svg+xml;charset=utf-8,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.9999 3C6.2839 3 6.43224 3.32867 6.2609 3.541L6.23557 3.569L4.23557 5.569C4.17817 5.62639 4.10181 5.66087 4.0208 5.66596C3.93979 5.67106 3.8597 5.64642 3.79557 5.59667L3.76424 5.569L1.76424 3.569L1.73657 3.53767L1.71857 3.512L1.70057 3.48L1.6949 3.468L1.6859 3.44567L1.67524 3.40967L1.6719 3.392L1.66857 3.372L1.66724 3.353V3.31367L1.6689 3.29433L1.6719 3.27433L1.67524 3.257L1.6859 3.221L1.6949 3.19867L1.71824 3.15467L1.7399 3.12467L1.76424 3.09767L1.79557 3.07L1.82124 3.052L1.85324 3.034L1.86524 3.02833L1.88757 3.01933L1.92357 3.00867L1.94124 3.00533L1.96124 3.002L1.98024 3.00067L5.9999 3Z' fill='currentColor'/%3E%3C/svg%3E%0A",
  collapseOff: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.33325 8H11.6666' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  collapseOn: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.49988 11.6667C7.49988 11.9428 7.72374 12.1667 7.99988 12.1667C8.27602 12.1667 8.49988 11.9428 8.49988 11.6667V8.50002H11.6666C11.9427 8.50002 12.1666 8.27616 12.1666 8.00002C12.1666 7.72388 11.9427 7.50002 11.6666 7.50002H8.49988V4.33337C8.49988 4.05723 8.27602 3.83337 7.99988 3.83337C7.72374 3.83337 7.49988 4.05723 7.49988 4.33337V7.50002H4.33325C4.05711 7.50002 3.83325 7.72388 3.83325 8.00002C3.83325 8.27616 4.05711 8.50002 4.33325 8.50002H7.49988V11.6667Z' fill='currentColor'/%3E%3C/svg%3E%0A",
  radio: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='4' fill='currentColor'/%3E%3C/svg%3E%0A",
  chipClose: "data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 4L4 12M4 4L12 12' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A",
  search: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'%3E%3Cg opacity='0.5'%3E%3Cpath d='M28 28L20 20M4 13.3333C4 14.559 4.24141 15.7727 4.71046 16.905C5.1795 18.0374 5.86699 19.0663 6.73367 19.933C7.60035 20.7997 8.62925 21.4872 9.76162 21.9562C10.894 22.4253 12.1077 22.6667 13.3333 22.6667C14.559 22.6667 15.7727 22.4253 16.905 21.9562C18.0374 21.4872 19.0663 20.7997 19.933 19.933C20.7997 19.0663 21.4872 18.0374 21.9562 16.905C22.4253 15.7727 22.6667 14.559 22.6667 13.3333C22.6667 12.1077 22.4253 10.894 21.9562 9.76162C21.4872 8.62925 20.7997 7.60035 19.933 6.73367C19.0663 5.86699 18.0374 5.1795 16.905 4.71046C15.7727 4.24141 14.559 4 13.3333 4C12.1077 4 10.894 4.24141 9.76162 4.71046C8.62925 5.1795 7.60035 5.86699 6.73367 6.73367C5.86699 7.60035 5.1795 8.62925 4.71046 9.76162C4.24141 10.894 4 12.1077 4 13.3333Z' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E"
};
const mainColors = {
  white: "#ffffffff",
  black: "#000000ff",
  primary: {
    100: "#6180ffff",
    200: "#5573f0ff",
    300: "#4669f6ff",
    400: "#2e56fcff",
    500: "#1a42e8ff",
    600: "#1535bcff"
  },
  palette: {
    50: "#f7f7f9ff",
    100: "#e7e7e9ff",
    200: "#b9b9bbff",
    300: "#a3a3a3ff",
    400: "#68696cff",
    500: "#404144ff",
    600: "#313132ff",
    700: "#282829ff",
    800: "#222222ff",
    900: "#1e1e1fff",
    950: "#050506ff"
  },
  transparent: "#ffffff00"
};
const mainTokens = {
  fontFamily: "Inter",
  fontSize: "14px",
  fontSizeSmall: "12px",
  lineHeight: "20px",
  lineHeightSmall: "18px",
  fontWeight: "400",
  letterSpacing: "0px",
  borderColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  accentColor: [
    "colors.primary.500",
    "colors.primary.300"
  ],
  foregroundColor: [
    "colors.palette.800",
    "colors.palette.200"
  ],
  foregroundSecondaryColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  backgroundColor: [
    "colors.white",
    "colors.palette.950"
  ],
  backgroundSecondaryColor: [
    "colors.palette.50",
    "colors.palette.900"
  ],
  placeholderColor: [
    "colors.palette.300",
    "colors.palette.400"
  ],
  readOnlyColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  disabledColor: [
    "colors.palette.300",
    "colors.palette.400"
  ],
  gapSize: "density.gap",
  iconSize: "sizing.size_4",
  tableTransition: "0.15s",
  borderRadius: "sizing.size_1",
  barForegroundColor: "tokens.foregroundColor",
  barBackgroundColor: "tokens.backgroundSecondaryColor",
  barHorizontalPadding: "density.barsHorizontal",
  barVerticalPadding: "density.barsVertical",
  shadowColor: [
    "colors.palette.800",
    "colors.palette.200"
  ],
  shadowX: "sizing.size_0",
  shadowY: "sizing.size_2",
  shadowBlur: "sizing.size_4",
  shadowOpacity: "8%",
  cellHorizontalPadding: "density.cellHorizontal",
  cellVerticalPadding: "density.cellVertical",
  cellHorizontalBorderColor: "tokens.borderColor",
  cellVerticalBorderColor: "tokens.borderColor",
  cellSelectionBorderColor: "tokens.accentColor",
  cellSelectionBackgroundColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  cellSuccessBackgroundColor: "#37bc6c33",
  cellErrorBackgroundColor: "#fa4d3233",
  cellReadOnlyBackgroundColor: "tokens.backgroundSecondaryColor",
  cellAutofillSize: "sizing.size_1_5",
  cellAutofillHitAreaSize: "sizing.size_3",
  cellAutofillBorderWidth: "sizing.size_0_25",
  cellAutofillBorderRadius: "sizing.size_1",
  cellAutofillBorderColor: "tokens.backgroundColor",
  cellAutofillBackgroundColor: "tokens.accentColor",
  cellAutofillFillBorderColor: "tokens.foregroundColor",
  cellEditorBorderWidth: "2px",
  cellEditorBorderColor: "tokens.accentColor",
  cellEditorForegroundColor: [
    "colors.palette.950",
    "colors.white"
  ],
  cellEditorBackgroundColor: "tokens.backgroundColor",
  cellEditorShadowBlurRadius: "0px",
  cellEditorShadowColor: "tokens.accentColor",
  cellMobileHandleSize: "sizing.size_3",
  cellMobileHandleBorderWidth: "sizing.size_0_25",
  cellMobileHandleBorderRadius: "sizing.size_3",
  cellMobileHandleBorderColor: "tokens.accentColor",
  cellMobileHandleBackgroundColor: "tokens.accentColor",
  cellMobileHandleBackgroundOpacity: "40%",
  headerFontWeight: "tokens.fontWeight",
  headerForegroundColor: "tokens.foregroundColor",
  headerBackgroundColor: "tokens.backgroundSecondaryColor",
  headerHighlightedShadowSize: "0px",
  headerHighlightedForegroundColor: [
    "colors.palette.950",
    "colors.white"
  ],
  headerHighlightedBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  headerActiveBorderColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  headerActiveForegroundColor: "colors.white",
  headerActiveBackgroundColor: "tokens.accentColor",
  headerFilterBackgroundColor: "tokens.cellSuccessBackgroundColor",
  headerRowForegroundColor: "tokens.foregroundColor",
  headerRowBackgroundColor: "tokens.backgroundSecondaryColor",
  headerRowHighlightedForegroundColor: [
    "colors.palette.950",
    "colors.white"
  ],
  headerRowHighlightedBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  headerRowActiveForegroundColor: "colors.white",
  headerRowActiveBackgroundColor: "tokens.accentColor",
  rowHeaderOddBackgroundColor: "tokens.headerRowBackgroundColor",
  rowHeaderEvenBackgroundColor: "tokens.headerRowBackgroundColor",
  rowCellOddBackgroundColor: "tokens.backgroundColor",
  rowCellEvenBackgroundColor: "tokens.backgroundColor",
  buttonBorderRadius: "sizing.size_1",
  buttonHorizontalPadding: "density.buttonHorizontal",
  buttonVerticalPadding: "density.buttonVertical",
  primaryButtonBorderColor: "colors.transparent",
  primaryButtonForegroundColor: "colors.white",
  primaryButtonBackgroundColor: "tokens.accentColor",
  primaryButtonDisabledBorderColor: "colors.transparent",
  primaryButtonDisabledForegroundColor: "tokens.disabledColor",
  primaryButtonDisabledBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  primaryButtonHoverBorderColor: "colors.transparent",
  primaryButtonHoverForegroundColor: "tokens.backgroundColor",
  primaryButtonHoverBackgroundColor: [
    "colors.primary.600",
    "colors.primary.100"
  ],
  primaryButtonFocusBorderColor: "tokens.backgroundColor",
  primaryButtonFocusForegroundColor: "tokens.backgroundColor",
  primaryButtonFocusBackgroundColor: "tokens.accentColor",
  secondaryButtonBorderColor: "tokens.borderColor",
  secondaryButtonForegroundColor: "tokens.foregroundColor",
  secondaryButtonBackgroundColor: "tokens.backgroundColor",
  secondaryButtonDisabledBorderColor: "tokens.borderColor",
  secondaryButtonDisabledForegroundColor: "tokens.disabledColor",
  secondaryButtonDisabledBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  secondaryButtonHoverBorderColor: "tokens.borderColor",
  secondaryButtonHoverForegroundColor: "tokens.foregroundColor",
  secondaryButtonHoverBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  secondaryButtonFocusBorderColor: "tokens.borderColor",
  secondaryButtonFocusForegroundColor: "tokens.foregroundColor",
  secondaryButtonFocusBackgroundColor: "tokens.backgroundColor",
  iconButtonBorderRadius: "sizing.size_0_5",
  iconButtonLargeBorderRadius: "sizing.size_1",
  iconButtonLargePadding: "sizing.size_1",
  iconButtonBorderColor: [
    "colors.palette.50",
    "colors.palette.900"
  ],
  iconButtonBackgroundColor: "tokens.backgroundSecondaryColor",
  iconButtonIconColor: [
    "colors.palette.300",
    "colors.palette.400"
  ],
  iconButtonHitAreaSize: "sizing.size_6",
  iconButtonHoverBorderColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  iconButtonHoverBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  iconButtonHoverIconColor: [
    "colors.palette.300",
    "colors.palette.400"
  ],
  iconButtonActiveBorderColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  iconButtonActiveBackgroundColor: "tokens.accentColor",
  iconButtonActiveIconColor: "colors.white",
  iconButtonActiveHoverBorderColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  iconButtonActiveHoverBackgroundColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  iconButtonActiveHoverIconColor: "colors.white",
  collapseButtonBorderRadius: "sizing.size_1",
  collapseButtonOpenBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  collapseButtonOpenBackgroundColor: [
    "colors.white",
    "colors.palette.950"
  ],
  collapseButtonOpenIconColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonOpenIconActiveColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonOpenHoverBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  collapseButtonOpenHoverBackgroundColor: [
    "colors.palette.50",
    "colors.palette.900"
  ],
  collapseButtonOpenHoverIconColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonOpenHoverIconActiveColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonCloseBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  collapseButtonCloseBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  collapseButtonCloseIconColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonCloseIconActiveColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonCloseHoverBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  collapseButtonCloseHoverBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  collapseButtonCloseHoverIconColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  collapseButtonCloseHoverIconActiveColor: [
    "colors.palette.400",
    "colors.palette.300"
  ],
  linkColor: [
    "colors.primary.600",
    "colors.primary.100"
  ],
  linkHoverColor: "tokens.accentColor",
  inputBorderWidth: "1px",
  inputBorderRadius: "sizing.size_1",
  inputHorizontalPadding: "density.inputHorizontal",
  inputVerticalPadding: "density.inputVertical",
  inputBorderColor: "tokens.borderColor",
  inputForegroundColor: "tokens.foregroundColor",
  inputBackgroundColor: "tokens.backgroundSecondaryColor",
  inputHoverBorderColor: "tokens.borderColor",
  inputHoverForegroundColor: "tokens.foregroundColor",
  inputHoverBackgroundColor: "tokens.backgroundColor",
  inputDisabledBorderColor: "tokens.borderColor",
  inputDisabledForegroundColor: "tokens.disabledColor",
  inputDisabledBackgroundColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  inputFocusBorderColor: "tokens.accentColor",
  inputFocusForegroundColor: "tokens.foregroundColor",
  inputFocusBackgroundColor: "tokens.backgroundColor",
  checkboxSize: "tokens.iconSize",
  checkboxBorderRadius: "sizing.size_1",
  checkboxBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  checkboxBackgroundColor: "tokens.backgroundColor",
  checkboxIconColor: "colors.transparent",
  checkboxFocusBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  checkboxFocusBackgroundColor: "tokens.backgroundColor",
  checkboxFocusIconColor: "colors.transparent",
  checkboxFocusRingColor: "tokens.accentColor",
  checkboxDisabledBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  checkboxDisabledBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  checkboxDisabledIconColor: "colors.transparent",
  checkboxCheckedBorderColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  checkboxCheckedBackgroundColor: "tokens.accentColor",
  checkboxCheckedIconColor: "colors.white",
  checkboxCheckedFocusBorderColor: "tokens.backgroundColor",
  checkboxCheckedFocusBackgroundColor: "tokens.accentColor",
  checkboxCheckedFocusIconColor: "colors.white",
  checkboxCheckedDisabledBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  checkboxCheckedDisabledBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  checkboxCheckedDisabledIconColor: "tokens.disabledColor",
  checkboxIndeterminateBorderColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  checkboxIndeterminateBackgroundColor: "tokens.accentColor",
  checkboxIndeterminateIconColor: "colors.white",
  checkboxIndeterminateFocusBorderColor: "tokens.backgroundColor",
  checkboxIndeterminateFocusBackgroundColor: "tokens.accentColor",
  checkboxIndeterminateFocusIconColor: "colors.white",
  checkboxIndeterminateDisabledBorderColor: [
    "colors.palette.200",
    "colors.palette.600"
  ],
  checkboxIndeterminateDisabledBackgroundColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  checkboxIndeterminateDisabledIconColor: "tokens.disabledColor",
  radioSize: "tokens.iconSize",
  radioBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  radioBackgroundColor: "tokens.backgroundColor",
  radioIconColor: "colors.transparent",
  radioFocusBorderColor: "tokens.borderColor",
  radioFocusBackgroundColor: "tokens.backgroundColor",
  radioFocusIconColor: "colors.transparent",
  radioFocusRingColor: "tokens.accentColor",
  radioDisabledBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  radioDisabledBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  radioDisabledIconColor: "colors.transparent",
  radioCheckedBorderColor: "tokens.accentColor",
  radioCheckedBackgroundColor: "tokens.backgroundColor",
  radioCheckedIconColor: "tokens.accentColor",
  radioCheckedFocusBorderColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  radioCheckedFocusBackgroundColor: "tokens.backgroundColor",
  radioCheckedFocusIconColor: [
    "colors.primary.400",
    "colors.primary.200"
  ],
  radioCheckedDisabledBorderColor: [
    "colors.palette.200",
    "colors.palette.500"
  ],
  radioCheckedDisabledBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  radioCheckedDisabledIconColor: "tokens.disabledColor",
  moveBacklightColor: [
    "colors.palette.800",
    "colors.palette.200"
  ],
  moveBacklightOpacity: "8%",
  moveIndicatorColor: "tokens.accentColor",
  resizeIndicatorColor: [
    "colors.palette.300",
    "colors.palette.400"
  ],
  hiddenIndicatorColor: [
    "colors.palette.300",
    "colors.palette.400"
  ],
  menuBorderWidth: "1px",
  menuBorderRadius: "sizing.size_1",
  menuHorizontalPadding: "density.menuHorizontal",
  menuVerticalPadding: "density.menuVertical",
  menuItemHorizontalPadding: "density.menuItemHorizontal",
  menuItemVerticalPadding: "density.menuItemVertical",
  menuBorderColor: "tokens.borderColor",
  menuShadowX: "tokens.shadowX",
  menuShadowY: "tokens.shadowY",
  menuShadowBlur: "tokens.shadowBlur",
  menuShadowColor: [
    "colors.palette.950",
    "colors.white"
  ],
  menuShadowOpacity: "8%",
  menuItemHoverColor: [
    "colors.palette.800",
    "colors.palette.200"
  ],
  menuItemHoverColorOpacity: "4%",
  menuItemActiveColor: "tokens.accentColor",
  menuItemActiveColorOpacity: "8%",
  commentsTextareaHorizontalPadding: "density.cellHorizontal",
  commentsTextareaVerticalPadding: "density.cellVertical",
  commentsTextareaBorderWidth: "1px",
  commentsTextareaBorderColor: "colors.transparent",
  commentsTextareaForegroundColor: "tokens.foregroundColor",
  commentsTextareaBackgroundColor: "tokens.backgroundSecondaryColor",
  commentsTextareaFocusBorderWidth: "1px",
  commentsTextareaFocusBorderColor: "tokens.accentColor",
  commentsTextareaFocusForegroundColor: "tokens.foregroundColor",
  commentsTextareaFocusBackgroundColor: "tokens.backgroundColor",
  commentsIndicatorSize: "sizing.size_1_5",
  commentsIndicatorColor: "tokens.accentColor",
  licenseHorizontalPadding: "tokens.barHorizontalPadding",
  licenseVerticalPadding: "tokens.barVerticalPadding",
  licenseForegroundColor: "tokens.barForegroundColor",
  licenseBackgroundColor: "tokens.barBackgroundColor",
  paginationBarForegroundColor: "tokens.barForegroundColor",
  paginationBarBackgroundColor: "tokens.barBackgroundColor",
  paginationBarHorizontalPadding: "tokens.barHorizontalPadding",
  paginationBarVerticalPadding: "tokens.barVerticalPadding",
  paginationButtonBorderColor: "tokens.paginationBarBackgroundColor",
  paginationButtonForegroundColor: "tokens.foregroundSecondaryColor",
  paginationButtonBackgroundColor: "tokens.paginationBarBackgroundColor",
  paginationButtonHoverBorderColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  paginationButtonHoverForegroundColor: "tokens.foregroundColor",
  paginationButtonHoverBackgroundColor: [
    "colors.palette.100",
    "colors.palette.700"
  ],
  paginationButtonDisabledBorderColor: "tokens.paginationBarBackgroundColor",
  paginationButtonDisabledForegroundColor: "tokens.disabledColor",
  paginationButtonDisabledBackgroundColor: "tokens.paginationBarBackgroundColor",
  paginationButtonFocusBorderColor: "tokens.accentColor",
  paginationButtonFocusForegroundColor: "tokens.foregroundColor",
  paginationButtonFocusBackgroundColor: "tokens.paginationBarBackgroundColor",
  dialogSemiTransparentBackgroundColor: [
    "colors.white",
    "colors.palette.950"
  ],
  dialogSemiTransparentBackgroundOpacity: "80%",
  dialogSolidBackgroundColor: [
    "colors.white",
    "colors.palette.950"
  ],
  dialogContentPaddingHorizontal: "density.dialogHorizontal",
  dialogContentPaddingVertical: "density.dialogVertical",
  dialogContentBorderRadius: "sizing.size_2",
  dialogContentBackgroundColor: "tokens.backgroundSecondaryColor",
  notificationForegroundColor: "tokens.foregroundColor",
  notificationBackgroundColor: "tokens.backgroundColor",
  notificationBorderColor: "tokens.backgroundColor",
  notificationSuccessAccent: "#37bc6cff",
  notificationWarningAccent: "#fbe952ff",
  notificationErrorAccent: "#fa4d32ff",
  chipBackground: "tokens.backgroundSecondaryColor",
  chipBorderRadius: "sizing.size_0_5",
  chipVerticalPadding: "sizing.size_0",
  chipHorizontalPadding: "sizing.size_0_5",
  chipGap: "sizing.size_1",
  scrollbarBorderRadius: "sizing.size_2",
  scrollbarTrackColor: "tokens.backgroundSecondaryColor",
  scrollbarThumbColor: [
    "colors.palette.300",
    "colors.palette.400"
  ]
};
const mainTheme = {
  name: "main",
  density: "default",
  icons: mainIcons,
  colors: mainColors,
  tokens: mainTokens
};
const { hasItem, getItem, getNames, getValues, register } = staticRegister("themes");
function hasTheme(themeName) {
  return hasItem(themeName);
}
function getTheme(themeName) {
  if (!hasTheme(themeName)) {
    warn$1(`Theme "${themeName}" is not registered. Please ensure it is registered before using it.`);
    return void 0;
  }
  return getItem(themeName);
}
function getThemeNames() {
  return getNames();
}
function getThemes() {
  return getValues();
}
function parseThemeArgs(themeNameOrConfig, themeConfig) {
  let themeName = themeNameOrConfig;
  let themeConfigObject = deepClone(themeConfig);
  if (typeof themeNameOrConfig === "string" && isObject$1(themeConfig)) {
    themeConfigObject.name = themeNameOrConfig;
  } else if (typeof themeNameOrConfig !== "string" && isObject$1(themeNameOrConfig)) {
    themeConfigObject = deepClone(themeNameOrConfig);
    themeName = themeConfigObject.name ?? "";
  }
  return {
    themeName,
    themeConfigObject
  };
}
function registerTheme(themeNameOrConfig, themeConfig) {
  const { themeName, themeConfigObject } = parseThemeArgs(themeNameOrConfig, themeConfig);
  const theme = createTheme(themeConfigObject);
  if (hasTheme(themeName)) {
    warn$1(`Theme "${themeName}" is already registered. Registration skipped.`);
    return getTheme(themeName);
  }
  register(themeName, theme);
  return theme;
}
function reinitTheme(themeNameOrConfig, themeConfig) {
  const { themeName, themeConfigObject } = parseThemeArgs(themeNameOrConfig, themeConfig);
  if (!hasTheme(themeName)) {
    warn$1(`Theme "${themeName}" is not registered. Cannot reinitialize a non-existent theme.`);
    return void 0;
  }
  const reinitializedTheme = createTheme(themeConfigObject);
  register(themeName, reinitializedTheme);
  return reinitializedTheme;
}
let activeGuid = null;
function normalizeIndexesGroup(indexes) {
  if (indexes.length === 0) {
    return [];
  }
  const sortedIndexes = [
    ...indexes
  ];
  sortedIndexes.sort(([indexA], [indexB]) => {
    if (indexA === indexB) {
      return 0;
    }
    return indexA > indexB ? 1 : -1;
  });
  const normalizedIndexes = arrayReduce(sortedIndexes, (acc, [groupIndex, groupAmount]) => {
    const previousItem = acc[acc.length - 1];
    const [prevIndex, prevAmount] = previousItem;
    const prevLastIndex = prevIndex + prevAmount;
    if (groupIndex <= prevLastIndex) {
      const amountToAdd = Math.max(groupAmount - (prevLastIndex - groupIndex), 0);
      previousItem[1] += amountToAdd;
    } else {
      acc.push([
        groupIndex,
        groupAmount
      ]);
    }
    return acc;
  }, [
    sortedIndexes[0]
  ]);
  return normalizedIndexes;
}
const foreignHotInstances = /* @__PURE__ */ new Map();
function Core(rootContainer, userSettings, rootInstanceSymbol2 = false) {
  let instance = this;
  const eventManager = new EventManager(instance);
  let datamap;
  let dataSource;
  let grid;
  let editorManager;
  let focusGridManager;
  let viewportScroller;
  let firstRun = true;
  const mergedUserSettings = {
    ...userSettings.initialState,
    ...userSettings
  };
  if (hasValidParameter(rootInstanceSymbol2)) {
    registerAsRootInstance(this);
  }
  this.rootContainer = rootContainer;
  this.rootWrapperElement = null;
  this.rootGridElement = null;
  this.rootGridContentElement = null;
  this.rootSlotTopElement = null;
  this.rootSlotBottomElement = null;
  this.rootOverlaysElement = null;
  this.rootPortalElement = null;
  this.rootElement = isRootInstance(this) ? rootContainer.ownerDocument.createElement("div") : rootContainer;
  this.rootDocument = rootContainer.ownerDocument;
  this.rootWindow = this.rootDocument.defaultView;
  if (isRootInstance(this)) {
    this.rootWrapperElement = this.rootDocument.createElement("div");
    this.rootSlotTopElement = this.rootDocument.createElement("div");
    this.rootGridElement = this.rootDocument.createElement("div");
    this.rootGridContentElement = this.rootDocument.createElement("div");
    this.rootOverlaysElement = this.rootDocument.createElement("div");
    this.rootSlotBottomElement = this.rootDocument.createElement("div");
    this.rootPortalElement = this.rootDocument.createElement("div");
    addClass(this.rootElement, [
      "ht-wrapper",
      "handsontable"
    ]);
    addClass(this.rootWrapperElement, "ht-root-wrapper");
    addClass(this.rootSlotTopElement, "ht-slot-top");
    addClass(this.rootGridElement, "ht-grid");
    addClass(this.rootGridContentElement, "ht-grid-content");
    addClass(this.rootOverlaysElement, "ht-overlay");
    addClass(this.rootSlotBottomElement, "ht-slot-bottom");
    this.rootGridContentElement.appendChild(this.rootElement);
    this.rootGridElement.appendChild(this.rootGridContentElement);
    this.rootWrapperElement.appendChild(this.rootSlotTopElement);
    this.rootWrapperElement.appendChild(this.rootGridElement);
    this.rootWrapperElement.appendChild(this.rootSlotBottomElement);
    this.rootWrapperElement.appendChild(this.rootOverlaysElement);
    this.rootContainer.appendChild(this.rootWrapperElement);
    this.rootWrapperElement.__hotInstance = this;
    addClass(this.rootPortalElement, "ht-portal");
    this.rootDocument.body.appendChild(this.rootPortalElement);
  }
  this.isDestroyed = false;
  this.renderSuspendedCounter = 0;
  this.executionSuspendedCounter = 0;
  const layoutDirection = mergedUserSettings?.layoutDirection ?? "inherit";
  const rootElementDirection = [
    "rtl",
    "ltr"
  ].includes(layoutDirection) ? layoutDirection : this.rootWindow.getComputedStyle(this.rootElement).direction;
  this.rootElement.setAttribute("dir", rootElementDirection);
  this.rootWrapperElement?.setAttribute("dir", rootElementDirection);
  this.isRtl = function() {
    return rootElementDirection === "rtl";
  };
  this.isLtr = function() {
    return !instance.isRtl();
  };
  this.getDirectionFactor = function() {
    return instance.isLtr() ? 1 : -1;
  };
  this.stylesHandler = new StylesHandler({
    hot: instance,
    rootElement: instance.rootElement,
    rootDocument: instance.rootDocument,
    onThemeChange: (themeName2) => {
      if (isRootInstance(this)) {
        removeClass(this.rootWrapperElement, /ht-theme-.*/g);
        removeClass(this.rootPortalElement, /ht-theme-.*/g);
        if (themeName2) {
          addClass(this.rootWrapperElement, themeName2);
          addClass(this.rootPortalElement, themeName2);
          if (!getComputedStyle(this.rootWrapperElement).getPropertyValue("--ht-line-height")) {
            warn$1(`The "${themeName2}" theme is enabled, but its stylesheets are missing or not imported correctly. Import the correct CSS files in order to use that theme.`);
          }
        }
        this.view?._wt?.selectionManager?.refreshAllBorderHandleStyles();
      }
    },
    injectCoreCss: typeof userSettings?.injectCoreCss === "boolean" ? userSettings.injectCoreCss : true
  });
  this.themeManager = null;
  mergedUserSettings.language = getValidLanguageCode(mergedUserSettings.language);
  const settingsWithoutHooks = Object.fromEntries(Object.entries(mergedUserSettings).filter(([key]) => {
    return !(Hooks.getSingleton().isRegistered(key) || Hooks.getSingleton().isDeprecated(key));
  }));
  const metaManager = new MetaManager(instance, settingsWithoutHooks, [
    DynamicCellMetaMod,
    ExtendMetaPropertiesMod
  ]);
  const tableMeta = metaManager.getTableMeta();
  const globalMeta = metaManager.getGlobalMeta();
  const pluginsRegistry = createUniqueMap();
  this.container = this.rootDocument.createElement("div");
  this.rootElement.insertBefore(this.container, this.rootElement.firstChild);
  this.guid = `ht_${randomString()}`;
  foreignHotInstances.set(this.guid, this);
  this.columnIndexMapper = new IndexMapper();
  this.rowIndexMapper = new IndexMapper();
  this.columnIndexMapper.addLocalHook("indexesSequenceChange", (source) => {
    instance.runHooks("afterColumnSequenceChange", source);
  });
  this.rowIndexMapper.addLocalHook("indexesSequenceChange", (source) => {
    instance.runHooks("afterRowSequenceChange", source);
  });
  eventManager.addEventListener(this.rootDocument.documentElement, "compositionstart", (event) => {
    instance.runHooks("beforeCompositionStart", event);
  });
  dataSource = new DataSource(instance);
  const moduleRegisterer = staticRegister(this.guid);
  moduleRegisterer.register("cellRangeMapper", new CellRangeToRenderableMapper({
    rowIndexMapper: this.rowIndexMapper,
    columnIndexMapper: this.columnIndexMapper
  }));
  if (!this.rootElement.id || this.rootElement.id.substring(0, 3) === "ht_") {
    this.rootElement.id = this.guid;
  }
  const visualToRenderableCoords = (coords) => {
    const { row: visualRow, col: visualColumn } = coords;
    return instance._createCellCoords(
      // We just store indexes for rows and columns without headers.
      visualRow >= 0 ? instance.rowIndexMapper.getRenderableFromVisualIndex(visualRow) : visualRow,
      visualColumn >= 0 ? instance.columnIndexMapper.getRenderableFromVisualIndex(visualColumn) : visualColumn
    );
  };
  const renderableToVisualCoords = (coords) => {
    const { row: renderableRow, col: renderableColumn } = coords;
    return instance._createCellCoords(
      // We just store indexes for rows and columns without headers.
      renderableRow >= 0 ? instance.rowIndexMapper.getVisualFromRenderableIndex(renderableRow) : renderableRow,
      renderableColumn >= 0 ? instance.columnIndexMapper.getVisualFromRenderableIndex(renderableColumn) : renderableColumn
      // eslint-disable-line max-len
    );
  };
  const findFirstNonHiddenRenderableRow = (visualRowFrom, visualRowTo) => {
    const dir = visualRowTo > visualRowFrom ? 1 : -1;
    const minIndex = Math.min(visualRowFrom, visualRowTo);
    const maxIndex = Math.max(visualRowFrom, visualRowTo);
    const rowIndex = instance.rowIndexMapper.getNearestNotHiddenIndex(visualRowFrom, dir);
    if (rowIndex === null || dir === 1 && rowIndex > maxIndex || dir === -1 && rowIndex < minIndex) {
      return null;
    }
    return rowIndex >= 0 ? instance.rowIndexMapper.getRenderableFromVisualIndex(rowIndex) : rowIndex;
  };
  const findFirstNonHiddenRenderableColumn = (visualColumnFrom, visualColumnTo) => {
    const dir = visualColumnTo > visualColumnFrom ? 1 : -1;
    const minIndex = Math.min(visualColumnFrom, visualColumnTo);
    const maxIndex = Math.max(visualColumnFrom, visualColumnTo);
    const columnIndex = instance.columnIndexMapper.getNearestNotHiddenIndex(visualColumnFrom, dir);
    if (columnIndex === null || dir === 1 && columnIndex > maxIndex || dir === -1 && columnIndex < minIndex) {
      return null;
    }
    return columnIndex >= 0 ? instance.columnIndexMapper.getRenderableFromVisualIndex(columnIndex) : columnIndex;
  };
  let selection = new Selection2(tableMeta, {
    rowIndexMapper: instance.rowIndexMapper,
    columnIndexMapper: instance.columnIndexMapper,
    countCols: () => instance.countCols(),
    countRows: () => instance.countRows(),
    propToCol: (prop) => datamap.propToCol(prop),
    isEditorOpened: () => {
      const editor = instance.getActiveEditor();
      return editor ? editor.isOpened() : false;
    },
    countRenderableColumns: () => instance.view.countRenderableColumns(),
    countRenderableRows: () => instance.view.countRenderableRows(),
    countRowHeaders: () => instance.countRowHeaders(),
    countColHeaders: () => instance.countColHeaders(),
    countRenderableRowsInRange: (rowStart, rowEnd) => instance.view.countRenderableRowsInRange(rowStart, rowEnd),
    countRenderableColumnsInRange: (columnStart, columnEnd) => instance.view.countRenderableColumnsInRange(columnStart, columnEnd),
    getShortcutManager: () => instance.getShortcutManager(),
    createCellCoords: (row, column) => instance._createCellCoords(row, column),
    createCellRange: (highlight, from, to) => instance._createCellRange(highlight, from, to),
    visualToRenderableCoords,
    renderableToVisualCoords,
    findFirstNonHiddenRenderableRow,
    findFirstNonHiddenRenderableColumn,
    isDisabledCellSelection: (visualRow, visualColumn) => {
      if (visualRow < 0 || visualColumn < 0) {
        return instance.getSettings().disableVisualSelection;
      }
      return instance.getCellMeta(visualRow, visualColumn).disableVisualSelection;
    }
  });
  this.selection = selection;
  const onIndexMapperCacheUpdate = ({ hiddenIndexesChanged }) => {
    this.forceFullRender = true;
    if (hiddenIndexesChanged) {
      this.selection.commit();
    }
  };
  this.columnIndexMapper.addLocalHook("cacheUpdated", (indexesChangesState) => {
    onIndexMapperCacheUpdate(indexesChangesState);
    this.runHooks("afterColumnSequenceCacheUpdate", indexesChangesState);
  });
  this.rowIndexMapper.addLocalHook("cacheUpdated", (indexesChangesState) => {
    onIndexMapperCacheUpdate(indexesChangesState);
    this.runHooks("afterRowSequenceCacheUpdate", indexesChangesState);
  });
  this.selection.addLocalHook("afterSetRangeEnd", (cellCoords, isLastSelectionLayer) => {
    const preventScrolling = createObjectPropListener(false);
    const selectionRange = this.selection.getSelectedRange();
    const { from, to } = selectionRange.current();
    const selectionLayerLevel = selectionRange.size() - 1;
    this.runHooks("afterSelection", from.row, from.col, to.row, to.col, preventScrolling, selectionLayerLevel);
    this.runHooks("afterSelectionByProp", from.row, instance.colToProp(from.col), to.row, instance.colToProp(to.col), preventScrolling, selectionLayerLevel);
    const selectionSource = selection.getSelectionSource();
    const ignoreScrollSources = [
      "loadData",
      "updateData",
      "deselect",
      "shift"
    ];
    if (isLastSelectionLayer && !ignoreScrollSources.includes(selectionSource) && (!preventScrolling.isTouched() || preventScrolling.isTouched() && !preventScrolling.value)) {
      viewportScroller.scrollTo(cellCoords);
    }
    const isSelectedByRowHeader = selection.isSelectedByRowHeader();
    const isSelectedByColumnHeader = selection.isSelectedByColumnHeader();
    if (isSelectedByRowHeader && isSelectedByColumnHeader) {
      addClass(this.rootElement, [
        "ht__selection--rows",
        "ht__selection--columns"
      ]);
    } else if (isSelectedByRowHeader) {
      removeClass(this.rootElement, "ht__selection--columns");
      addClass(this.rootElement, "ht__selection--rows");
    } else if (isSelectedByColumnHeader) {
      removeClass(this.rootElement, "ht__selection--rows");
      addClass(this.rootElement, "ht__selection--columns");
    } else {
      removeClass(this.rootElement, [
        "ht__selection--rows",
        "ht__selection--columns"
      ]);
    }
    if (![
      "shift",
      "refresh",
      "loadData",
      "updateData",
      "deselect"
    ].includes(selectionSource)) {
      editorManager.closeEditor();
    }
    if (![
      "refresh",
      "loadData",
      "updateData",
      "deselect"
    ].includes(selectionSource)) {
      instance.view.render();
      editorManager.prepareEditor();
    }
  });
  this.selection.addLocalHook("beforeSetFocus", (cellCoords) => {
    this.runHooks("beforeSelectionFocusSet", cellCoords.row, cellCoords.col);
  });
  this.selection.addLocalHook("afterSetFocus", (cellCoords) => {
    const preventScrolling = createObjectPropListener(false);
    this.runHooks("afterSelectionFocusSet", cellCoords.row, cellCoords.col, preventScrolling);
    if (!preventScrolling.isTouched() || preventScrolling.isTouched() && !preventScrolling.value) {
      viewportScroller.scrollTo(cellCoords);
    }
    editorManager.closeEditor();
    instance.view.render();
    editorManager.prepareEditor();
  });
  this.selection.addLocalHook("afterSelectionFinished", (cellRanges) => {
    const selectionLayerLevel = cellRanges.length - 1;
    const { from, to } = cellRanges[selectionLayerLevel];
    this.runHooks("afterSelectionEnd", from.row, from.col, to.row, to.col, selectionLayerLevel);
    this.runHooks("afterSelectionEndByProp", from.row, instance.colToProp(from.col), to.row, instance.colToProp(to.col), selectionLayerLevel);
    if ([
      "refresh",
      "deselect"
    ].includes(selection.getSelectionSource())) {
      instance.view.render();
      editorManager.prepareEditor();
    }
  });
  this.selection.addLocalHook("afterIsMultipleSelection", (isMultiple) => {
    const changedIsMultiple = this.runHooks("afterIsMultipleSelection", isMultiple.value);
    if (isMultiple.value) {
      isMultiple.value = changedIsMultiple;
    }
  });
  this.selection.addLocalHook("afterDeselect", () => {
    editorManager.closeEditor();
    instance.view.render();
    removeClass(this.rootElement, [
      "ht__selection--rows",
      "ht__selection--columns"
    ]);
    this.runHooks("afterDeselect");
  });
  this.selection.addLocalHook("beforeHighlightSet", () => instance.runHooks("beforeSelectionHighlightSet")).addLocalHook("beforeSetRangeStart", (...args) => instance.runHooks("beforeSetRangeStart", ...args)).addLocalHook("beforeSetRangeStartOnly", (...args) => instance.runHooks("beforeSetRangeStartOnly", ...args)).addLocalHook("beforeSetRangeEnd", (...args) => instance.runHooks("beforeSetRangeEnd", ...args)).addLocalHook("beforeSelectColumns", (...args) => instance.runHooks("beforeSelectColumns", ...args)).addLocalHook("afterSelectColumns", (...args) => instance.runHooks("afterSelectColumns", ...args)).addLocalHook("beforeSelectRows", (...args) => instance.runHooks("beforeSelectRows", ...args)).addLocalHook("afterSelectRows", (...args) => instance.runHooks("afterSelectRows", ...args)).addLocalHook("beforeSelectAll", (...args) => instance.runHooks("beforeSelectAll", ...args)).addLocalHook("afterSelectAll", (...args) => instance.runHooks("afterSelectAll", ...args)).addLocalHook("beforeModifyTransformStart", (...args) => instance.runHooks("modifyTransformStart", ...args)).addLocalHook("afterModifyTransformStart", (...args) => instance.runHooks("afterModifyTransformStart", ...args)).addLocalHook("beforeModifyTransformFocus", (...args) => instance.runHooks("modifyTransformFocus", ...args)).addLocalHook("afterModifyTransformFocus", (...args) => instance.runHooks("afterModifyTransformFocus", ...args)).addLocalHook("beforeModifyTransformEnd", (...args) => instance.runHooks("modifyTransformEnd", ...args)).addLocalHook("afterModifyTransformEnd", (...args) => instance.runHooks("afterModifyTransformEnd", ...args)).addLocalHook("beforeRowWrap", (...args) => instance.runHooks("beforeRowWrap", ...args)).addLocalHook("beforeColumnWrap", (...args) => instance.runHooks("beforeColumnWrap", ...args)).addLocalHook("insertRowRequire", (totalRows) => instance.alter("insert_row_above", totalRows, 1, "auto")).addLocalHook("insertColRequire", (totalCols) => instance.alter("insert_col_start", totalCols, 1, "auto"));
  grid = {
    /**
    * Inserts or removes rows and columns.
    *
    * @private
    * @param {string} action Possible values: "insert_row_above", "insert_row_below", "insert_col_start", "insert_col_end",
    *                        "remove_row", "remove_col".
    * @param {number|Array} index Row or column visual index which from the alter action will be triggered.
    *                             Alter actions such as "remove_row" and "remove_col" support array indexes in the
    *                             format `[[index, amount], [index, amount]...]` this can be used to remove
    *                             non-consecutive columns or rows in one call.
    * @param {number} [amount=1] Amount of rows or columns to remove.
    * @param {string} [source] Optional. Source of hook runner.
    * @param {boolean} [keepEmptyRows] Optional. Flag for preventing deletion of empty rows.
    */
    alter(action, index2, amount = 1, source, keepEmptyRows) {
      const skipAlter = instance.runHooks("beforeAlter", action, index2, amount, source, keepEmptyRows);
      if (skipAlter === false) {
        return;
      }
      switch (action) {
        case "insert_row_below":
        case "insert_row_above":
          const numberOfSourceRows = instance.countSourceRows();
          if (tableMeta.maxRows === numberOfSourceRows) {
            return;
          }
          const insertRowMode = action === "insert_row_below" ? "below" : "above";
          const defaultRowIndex = insertRowMode === "below" ? numberOfSourceRows : 0;
          const rowIndex = typeof index2 === "number" ? index2 : defaultRowIndex;
          const { delta: rowDelta, startPhysicalIndex: startRowPhysicalIndex } = datamap.createRow(rowIndex, amount, {
            source,
            mode: insertRowMode
          });
          selection.shiftRows(instance.toVisualRow(startRowPhysicalIndex), rowDelta);
          break;
        case "insert_col_start":
        case "insert_col_end":
          const insertColumnMode = action === "insert_col_end" ? "end" : "start";
          const defaultColIndex = insertColumnMode === "end" ? instance.countSourceCols() : 0;
          const colIndex = typeof index2 === "number" ? index2 : defaultColIndex;
          const { delta: colDelta, startPhysicalIndex: startColumnPhysicalIndex } = datamap.createCol(colIndex, amount, {
            source,
            mode: insertColumnMode
          });
          if (colDelta) {
            if (Array.isArray(tableMeta.colHeaders)) {
              const spliceArray = [
                instance.toVisualColumn(startColumnPhysicalIndex),
                0
              ];
              spliceArray.length += colDelta;
              Array.prototype.splice.apply(tableMeta.colHeaders, spliceArray);
            }
            selection.shiftColumns(instance.toVisualColumn(startColumnPhysicalIndex), colDelta);
          }
          break;
        case "remove_row":
          const removeRow = (indexes) => {
            let offset2 = 0;
            arrayEach(indexes, ([groupIndex, groupAmount]) => {
              const calcIndex = isEmpty$1(groupIndex) ? instance.countRows() - 1 : Math.max(groupIndex - offset2, 0);
              if (Number.isInteger(groupIndex)) {
                groupIndex = Math.max(groupIndex - offset2, 0);
              }
              const wasRemoved = datamap.removeRow(groupIndex, groupAmount, source);
              if (!wasRemoved) {
                return;
              }
              if (selection.isSelected()) {
                const { row } = instance.getSelectedRangeActive().highlight;
                if (row >= groupIndex && row <= groupIndex + groupAmount - 1) {
                  editorManager.closeEditor(true);
                }
              }
              const totalRows = instance.countRows();
              const fixedRowsTop = tableMeta.fixedRowsTop;
              if (fixedRowsTop >= calcIndex + 1) {
                tableMeta.fixedRowsTop -= Math.min(groupAmount, fixedRowsTop - calcIndex);
              }
              const fixedRowsBottom = tableMeta.fixedRowsBottom;
              if (fixedRowsBottom && calcIndex >= totalRows - fixedRowsBottom) {
                tableMeta.fixedRowsBottom -= Math.min(groupAmount, fixedRowsBottom);
              }
              if (totalRows === 0) {
                selection.deselect();
              } else if (source === "ContextMenu.removeRow") {
                const selectionRange = selection.getSelectedRange();
                const lastSelection = selectionRange.pop();
                selectionRange.clear().set(lastSelection.from).current().setTo(lastSelection.to);
                selection.refresh();
              } else {
                selection.shiftRows(groupIndex, -groupAmount);
              }
              offset2 += groupAmount;
            });
          };
          if (Array.isArray(index2)) {
            removeRow(normalizeIndexesGroup(index2));
          } else {
            removeRow([
              [
                index2,
                amount
              ]
            ]);
          }
          break;
        case "remove_col":
          const removeCol = (indexes) => {
            let offset2 = 0;
            arrayEach(indexes, ([groupIndex, groupAmount]) => {
              const calcIndex = isEmpty$1(groupIndex) ? instance.countCols() - 1 : Math.max(groupIndex - offset2, 0);
              let physicalColumnIndex = instance.toPhysicalColumn(calcIndex);
              if (Number.isInteger(groupIndex)) {
                groupIndex = Math.max(groupIndex - offset2, 0);
              }
              const wasRemoved = datamap.removeCol(groupIndex, groupAmount, source);
              if (!wasRemoved) {
                return;
              }
              if (selection.isSelected()) {
                const { col } = instance.getSelectedRangeActive().highlight;
                if (col >= groupIndex && col <= groupIndex + groupAmount - 1) {
                  editorManager.closeEditor(true);
                }
              }
              const totalColumns = instance.countCols();
              if (totalColumns === 0) {
                selection.deselect();
              } else if (source === "ContextMenu.removeColumn") {
                const selectionRange = selection.getSelectedRange();
                const lastSelection = selectionRange.pop();
                selectionRange.clear().set(lastSelection.from).current().setTo(lastSelection.to);
                selection.refresh();
              } else {
                selection.shiftColumns(groupIndex, -groupAmount);
              }
              const fixedColumnsStart = tableMeta.fixedColumnsStart;
              if (fixedColumnsStart >= calcIndex + 1) {
                tableMeta.fixedColumnsStart -= Math.min(groupAmount, fixedColumnsStart - calcIndex);
              }
              if (Array.isArray(tableMeta.colHeaders)) {
                if (typeof physicalColumnIndex === "undefined") {
                  physicalColumnIndex = -1;
                }
                tableMeta.colHeaders.splice(physicalColumnIndex, groupAmount);
              }
              offset2 += groupAmount;
            });
          };
          if (Array.isArray(index2)) {
            removeCol(normalizeIndexesGroup(index2));
          } else {
            removeCol([
              [
                index2,
                amount
              ]
            ]);
          }
          break;
        default:
          throwWithCause(`There is no such action "${action}"`);
      }
      if (!keepEmptyRows) {
        grid.adjustRowsAndCols();
      }
      instance.view.adjustElementsSize();
      instance.view.render();
    },
    /**
    * Makes sure there are empty rows at the bottom of the table.
    *
    * @private
    */
    adjustRowsAndCols() {
      const minRows = tableMeta.minRows;
      const minSpareRows = tableMeta.minSpareRows;
      const minCols = tableMeta.minCols;
      const minSpareCols = tableMeta.minSpareCols;
      if (minRows) {
        const nrOfRows = instance.countRows();
        if (nrOfRows < minRows) {
          datamap.createRow(nrOfRows, minRows - nrOfRows, {
            source: "auto"
          });
        }
      }
      if (minSpareRows) {
        const emptyRows = instance.countEmptyRows(true);
        if (emptyRows < minSpareRows) {
          const emptyRowsMissing = minSpareRows - emptyRows;
          const rowsToCreate = Math.min(emptyRowsMissing, tableMeta.maxRows - instance.countSourceRows());
          datamap.createRow(instance.countRows(), rowsToCreate, {
            source: "auto"
          });
        }
      }
      {
        let emptyCols = 0;
        if (minCols || minSpareCols) {
          emptyCols = instance.countEmptyCols(true);
        }
        let nrOfColumns = instance.countCols();
        if (minCols && !tableMeta.columns && nrOfColumns < minCols) {
          const colsToCreate = minCols - nrOfColumns;
          emptyCols += colsToCreate;
          datamap.createCol(nrOfColumns, colsToCreate, {
            source: "auto"
          });
        }
        if (minSpareCols && !tableMeta.columns && instance.dataType === "array" && emptyCols < minSpareCols) {
          nrOfColumns = instance.countCols();
          const emptyColsMissing = minSpareCols - emptyCols;
          const colsToCreate = Math.min(emptyColsMissing, tableMeta.maxCols - nrOfColumns);
          datamap.createCol(nrOfColumns, colsToCreate, {
            source: "auto"
          });
        }
      }
    },
    /**
    * Populate the data from the provided 2d array from the given cell coordinates.
    *
    * @private
    * @param {object} start Start selection position. Visual indexes.
    * @param {Array} input 2d data array.
    * @param {object} [end] End selection position (only for drag-down mode). Visual indexes.
    * @param {string} [source="populateFromArray"] Source information string.
    * @param {string} [method="overwrite"] Populate method. Possible options: `shift_down`, `shift_right`, `overwrite`.
    * @returns {object|undefined} Ending td in pasted area (only if any cell was changed).
    */
    populateFromArray(start, input, end, source, method) {
      let r;
      let rlen;
      let c;
      let clen;
      const setData = [];
      const current = {};
      const newDataByColumns = [];
      const startRow = start.row;
      const startColumn = start.col;
      rlen = input.length;
      if (rlen === 0) {
        return false;
      }
      let columnsPopulationEnd = 0;
      let rowsPopulationEnd = 0;
      if (isObject$1(end)) {
        columnsPopulationEnd = end.col - startColumn + 1;
        rowsPopulationEnd = end.row - startRow + 1;
      }
      switch (method) {
        case "shift_down":
          const populatedDataByColumns = pivot(input);
          const numberOfDataColumns = populatedDataByColumns.length;
          const numberOfColumnsToPopulate = Math.max(numberOfDataColumns, columnsPopulationEnd);
          const pushedDownDataByRows = instance.getData().slice(startRow);
          const pushedDownDataByColumns = pivot(pushedDownDataByRows).slice(startColumn, startColumn + numberOfColumnsToPopulate);
          for (c = 0; c < numberOfColumnsToPopulate; c += 1) {
            if (c < numberOfDataColumns) {
              for (r = 0, rlen = populatedDataByColumns[c].length; r < rowsPopulationEnd - rlen; r += 1) {
                populatedDataByColumns[c].push(populatedDataByColumns[c][r % rlen]);
              }
              if (c < pushedDownDataByColumns.length) {
                newDataByColumns.push(populatedDataByColumns[c].concat(pushedDownDataByColumns[c]));
              } else {
                newDataByColumns.push(populatedDataByColumns[c].concat(new Array(pushedDownDataByRows.length).fill(null)));
              }
            } else {
              newDataByColumns.push(populatedDataByColumns[c % numberOfDataColumns].concat(pushedDownDataByColumns[c]));
            }
          }
          instance.populateFromArray(startRow, startColumn, pivot(newDataByColumns));
          break;
        case "shift_right":
          const numberOfDataRows = input.length;
          const numberOfRowsToPopulate = Math.max(numberOfDataRows, rowsPopulationEnd);
          const pushedRightDataByRows = instance.getData().slice(startRow).map((rowData) => rowData.slice(startColumn));
          for (r = 0; r < numberOfRowsToPopulate; r += 1) {
            if (r < numberOfDataRows) {
              for (c = 0, clen = input[r].length; c < columnsPopulationEnd - clen; c += 1) {
                input[r].push(input[r][c % clen]);
              }
              if (r < pushedRightDataByRows.length) {
                for (let i = 0; i < pushedRightDataByRows[r].length; i += 1) {
                  input[r].push(pushedRightDataByRows[r][i]);
                }
              } else {
                input[r].push(...new Array(pushedRightDataByRows[0].length).fill(null));
              }
            } else {
              input.push(input[r % rlen].slice(0, numberOfRowsToPopulate).concat(pushedRightDataByRows[r]));
            }
          }
          instance.populateFromArray(startRow, startColumn, input);
          break;
        case "overwrite":
        default:
          current.row = start.row;
          current.col = start.col;
          let skippedRow = 0;
          let skippedColumn = 0;
          let pushData = true;
          let cellMeta;
          const isAutofillSource = source === "Autofill.fill" || source === "autofill.fill";
          const getInputValue = function getInputValue2(row, col = null) {
            const rowValue = input[row % input.length];
            if (col !== null) {
              return rowValue[col % rowValue.length];
            }
            return rowValue;
          };
          const rowInputLength = input.length;
          const rowSelectionLength = end ? end.row - start.row + 1 : 0;
          if (end) {
            rlen = rowSelectionLength;
          } else {
            rlen = Math.max(rowInputLength, rowSelectionLength);
          }
          for (r = 0; r < rlen; r++) {
            if (end && current.row > end.row && rowSelectionLength > rowInputLength || !tableMeta.allowInsertRow && current.row > instance.countRows() - 1 || current.row >= tableMeta.maxRows) {
              break;
            }
            const visualRow = r - skippedRow;
            const sourceRow = isAutofillSource ? r : visualRow;
            const colInputLength = getInputValue(sourceRow).length;
            const colSelectionLength = end ? end.col - start.col + 1 : 0;
            if (end) {
              clen = colSelectionLength;
            } else {
              clen = Math.max(colInputLength, colSelectionLength);
            }
            current.col = start.col;
            cellMeta = instance.getCellMeta(current.row, current.col);
            if ((source === "CopyPaste.paste" || source === "Autofill.fill" || source === "autofill.fill") && cellMeta.skipRowOnPaste) {
              skippedRow += 1;
              current.row += 1;
              if (source === "CopyPaste.paste") {
                rlen += 1;
              }
              continue;
            }
            skippedColumn = 0;
            for (c = 0; c < clen; c++) {
              if (end && current.col > end.col && colSelectionLength > colInputLength || !tableMeta.allowInsertColumn && current.col > instance.countCols() - 1 || current.col >= tableMeta.maxCols) {
                break;
              }
              cellMeta = instance.getCellMeta(current.row, current.col);
              if ((source === "CopyPaste.paste" || source === "Autofill.fill" || source === "autofill.fill") && cellMeta.skipColumnOnPaste) {
                skippedColumn += 1;
                current.col += 1;
                if (source === "CopyPaste.paste") {
                  clen += 1;
                }
                continue;
              }
              if (cellMeta.readOnly && source !== "UndoRedo.undo") {
                current.col += 1;
                continue;
              }
              const visualColumn = c - skippedColumn;
              const sourceColumn = isAutofillSource ? c : visualColumn;
              const hasValueSetter = !!cellMeta.valueSetter;
              let value = getInputValue(sourceRow, sourceColumn);
              let orgValue = instance.getSourceDataAtCell(current.row, current.col) ?? null;
              if (value !== null && typeof value === "object") {
                if (Array.isArray(value) && orgValue === null) {
                  orgValue = [];
                }
                if (!hasValueSetter && (typeof orgValue !== "object" || orgValue === null)) {
                  pushData = false;
                  if (cellMeta.parsePastedValue && source === "CopyPaste.paste") {
                    pushData = true;
                  }
                  if (source === "edit") {
                    pushData = true;
                    value = deepClone(value);
                  }
                } else if (orgValue !== null) {
                  const orgValueSchema = duckSchema(Array.isArray(orgValue) ? orgValue : orgValue[0] || orgValue);
                  const valueSchema = duckSchema(Array.isArray(value) ? value : value[0] || value);
                  if (hasValueSetter || // If the cell has a value setter, we don't know the value schema (it's dynamic)
                  source === "edit" || // Editor saves always accept the new value regardless of schema (#3234)
                  isObjectEqual(orgValueSchema, valueSchema) || Array.isArray(orgValueSchema) && Array.isArray(valueSchema)) {
                    value = deepClone(value);
                  } else {
                    pushData = false;
                  }
                }
              } else if (!hasValueSetter && orgValue !== null && typeof orgValue === "object") {
                pushData = false;
              }
              if (pushData) {
                setData.push([
                  current.row,
                  current.col,
                  value
                ]);
              }
              pushData = true;
              current.col += 1;
            }
            current.row += 1;
          }
          instance.setDataAtCell(setData, null, null, source || "populateFromArray");
          break;
      }
    }
  };
  function setLanguage(languageCode) {
    const normalizedLanguageCode = normalizeLanguageCode(languageCode);
    if (hasLanguageDictionary(normalizedLanguageCode)) {
      instance.runHooks("beforeLanguageChange", normalizedLanguageCode);
      globalMeta.language = normalizedLanguageCode;
      instance.runHooks("afterLanguageChange", normalizedLanguageCode);
    } else {
      warnUserAboutLanguageRegistration(languageCode);
    }
  }
  function setClassName(className, classSettings) {
    const element = className === "className" ? instance.rootElement : instance.table;
    if (firstRun) {
      if (classSettings !== void 0) {
        addClass(element, classSettings);
      }
    } else {
      let globalMetaSettingsArray = [];
      let settingsArray = [];
      if (globalMeta[className]) {
        const globalMetaValue = globalMeta[className];
        globalMetaSettingsArray = Array.isArray(globalMetaValue) ? globalMetaValue : stringToArray(String(globalMetaValue));
      }
      if (classSettings) {
        settingsArray = Array.isArray(classSettings) ? classSettings : stringToArray(classSettings);
      }
      const classNameToRemove = getDifferenceOfArrays(globalMetaSettingsArray, settingsArray);
      const classNameToAdd = getDifferenceOfArrays(settingsArray, globalMetaSettingsArray);
      if (classNameToRemove.length) {
        removeClass(element, classNameToRemove);
      }
      if (classNameToAdd.length) {
        addClass(element, classNameToAdd);
      }
    }
    globalMeta[className] = classSettings;
  }
  this.init = function() {
    const theme2 = tableMeta.theme;
    const themeName2 = tableMeta.themeName;
    const rootContainerThemeClassName2 = getThemeClassName(instance.rootContainer);
    if (isRootInstance(instance) && !rootContainerThemeClassName2 && (isObject$1(theme2) || !theme2 && !themeName2)) {
      initializeThemeManager(theme2);
    }
    dataSource.setData(tableMeta.data);
    instance.runHooks("beforeInit");
    if (isMobileBrowser() || isIpadOS()) {
      addClass(instance.rootElement, "mobile");
    }
    this.updateSettings(mergedUserSettings, true);
    this.view = new TableView(this);
    editorManager = EditorManager.getInstance(instance, tableMeta, selection);
    viewportScroller = createViewportScroller(instance);
    focusGridManager.init();
    if (isRootInstance(this)) {
      install(instance.rootPortalElement);
      initLicenseNotification(instance);
      const lastEdgeWidths = {
        top: -1,
        bottom: -1
      };
      const syncEdgeSlotsWidth = () => {
        if (instance.isDestroyed) {
          return;
        }
        const { view } = instance;
        if (!view) {
          return;
        }
        let width = view.isHorizontallyScrollableByWindow() ? view.getTotalTableWidth() : view.getWorkspaceWidth();
        if (width === 0 && instance.rootWrapperElement) {
          width = instance.rootWrapperElement.offsetWidth;
        }
        if (instance.rootSlotBottomElement && width !== lastEdgeWidths.bottom) {
          lastEdgeWidths.bottom = width;
          instance.rootSlotBottomElement.style.width = `${width}px`;
        }
        if (instance.rootSlotTopElement && width !== lastEdgeWidths.top) {
          lastEdgeWidths.top = width;
          instance.rootSlotTopElement.style.width = `${width}px`;
        }
      };
      this.addHook("afterRender", syncEdgeSlotsWidth);
    }
    instance.runHooks("init");
    this.render();
    if (!!firstRun && instance.rootElement.offsetParent === null) {
      observeVisibilityChangeOnce(instance.rootElement, () => {
        instance.view._wt.wtOverlays.updateLastSpreaderSize();
        instance.view.adjustElementsSize();
        instance.render();
      });
    }
    if (typeof firstRun === "object") {
      instance.runHooks("afterChange", firstRun[0], firstRun[1]);
      firstRun = false;
    }
    instance.runHooks("afterInit");
  };
  function initializeThemeManager(theme2) {
    let themeObject;
    if (typeof theme2 === "undefined") {
      if (hasTheme("main")) {
        themeObject = getTheme("main");
      } else {
        themeObject = registerTheme(mainTheme);
      }
      themeObject = getTheme("main");
    } else if (typeof theme2.getThemeConfig !== "function") {
      themeObject = registerTheme(theme2);
    } else {
      themeObject = theme2;
    }
    instance.themeManager = createThemeManager({
      hot: instance,
      themeObject
    });
  }
  function ValidatorsQueue() {
    let resolved = false;
    return {
      validatorsInQueue: 0,
      valid: true,
      addValidatorToQueue() {
        this.validatorsInQueue += 1;
        resolved = false;
      },
      removeValidatorFormQueue() {
        this.validatorsInQueue = this.validatorsInQueue - 1 < 0 ? 0 : this.validatorsInQueue - 1;
        this.checkIfQueueIsEmpty();
      },
      onQueueEmpty(_valid) {
      },
      checkIfQueueIsEmpty() {
        if (this.validatorsInQueue === 0 && resolved === false) {
          resolved = true;
          this.onQueueEmpty(this.valid);
        }
      }
    };
  }
  function doesChangeAffectOpenedEditor(changes, activeEditor) {
    if (!activeEditor?.isOpened()) {
      return false;
    }
    return hasChangeForCell(changes, activeEditor.row, activeEditor.prop);
  }
  function validateChanges(changes, source, callback) {
    if (!changes.length) {
      callback();
      return;
    }
    const activeEditor = instance.getActiveEditor();
    const waitingForValidator = ValidatorsQueue();
    let shouldBeCanceled = true;
    const applyValidatorCorrection = ([changedRow, changedProp, , correctedValue]) => {
      const idx = changes.findIndex(([row, prop]) => row === changedRow && prop === changedProp);
      if (idx !== -1) {
        changes[idx][3] = correctedValue;
      }
    };
    const onAfterChange = (afterChanges, afterSource) => {
      if (typeof afterSource !== "string" || !afterSource.endsWith("Validator")) {
        return;
      }
      afterChanges?.forEach(applyValidatorCorrection);
    };
    instance.addHook("afterChange", onAfterChange);
    waitingForValidator.onQueueEmpty = () => {
      instance.removeHook("afterChange", onAfterChange);
      if (activeEditor && shouldBeCanceled && activeEditor._closeAfterDataChange && doesChangeAffectOpenedEditor(changes, activeEditor)) {
        activeEditor.cancelChanges();
      }
      callback();
    };
    for (let i = changes.length - 1; i >= 0; i--) {
      const [row, prop, , newValue] = changes[i];
      const visualCol = datamap.propToCol(prop);
      let cellProperties;
      if (Number.isInteger(visualCol)) {
        cellProperties = instance.getCellMeta(row, visualCol);
      } else {
        cellProperties = {
          ...Object.getPrototypeOf(tableMeta),
          ...tableMeta
        };
      }
      if (instance.getCellValidator(cellProperties)) {
        waitingForValidator.addValidatorToQueue();
        instance.validateCell(newValue, cellProperties, /* @__PURE__ */ (function(index2, cellPropertiesReference) {
          return function(result) {
            if (typeof result !== "boolean") {
              throwWithCause("Validation error: result is not boolean");
            }
            if (result === false && cellPropertiesReference.allowInvalid === false) {
              shouldBeCanceled = false;
              changes.splice(index2, 1);
              cellPropertiesReference.valid = true;
            }
            waitingForValidator.removeValidatorFormQueue();
          };
        })(i, cellProperties), source);
      }
    }
    waitingForValidator.checkIfQueueIsEmpty();
  }
  function applyChanges(changes, source) {
    for (let i = changes.length - 1; i >= 0; i--) {
      let skipThisChange = false;
      if (changes[i] === null) {
        changes.splice(i, 1);
        continue;
      }
      if ((changes[i][2] === null || changes[i][2] === void 0) && (changes[i][3] === null || changes[i][3] === void 0)) {
        continue;
      }
      if (tableMeta.allowInsertRow) {
        while (changes[i][0] > instance.countRows() - 1) {
          const { delta: numberOfCreatedRows } = datamap.createRow(void 0, void 0, {
            source: "auto"
          });
          if (numberOfCreatedRows === 0) {
            skipThisChange = true;
            break;
          }
        }
      }
      if (instance.dataType === "array" && (!tableMeta.columns || tableMeta.columns.length === 0) && tableMeta.allowInsertColumn) {
        while (Number(datamap.propToCol(changes[i][1])) > instance.countCols() - 1) {
          const { delta: numberOfCreatedColumns } = datamap.createCol(void 0, void 0, {
            source: "auto"
          });
          if (numberOfCreatedColumns === 0) {
            skipThisChange = true;
            break;
          }
        }
      }
      if (skipThisChange) {
        continue;
      }
      datamap.set(changes[i][0], changes[i][1], changes[i][3]);
    }
    const hasChanges = changes.length > 0;
    const activeEditor = editorManager.getActiveEditor();
    const closeEditorAfterDataChange = activeEditor?._closeAfterDataChange;
    const isOpenedEditorAffectedByChanges = doesChangeAffectOpenedEditor(changes, activeEditor);
    if (hasChanges) {
      grid.adjustRowsAndCols();
      instance.runHooks("beforeChangeRender", changes, source);
      if (activeEditor?.isOpened() && closeEditorAfterDataChange && isOpenedEditorAffectedByChanges) {
        editorManager.closeEditor();
      }
      instance.view.adjustElementsSize();
      instance.render();
      if (activeEditor?.isOpened() && closeEditorAfterDataChange && isOpenedEditorAffectedByChanges || !activeEditor?.isOpened()) {
        editorManager.prepareEditor();
      }
      instance.runHooks("afterChange", changes, source || "edit");
      if (activeEditor && activeEditor.refreshValue !== void 0 && (!activeEditor.isOpened() || isOpenedEditorAffectedByChanges)) {
        activeEditor.refreshValue();
      }
    } else {
      instance.render();
    }
  }
  this._createCellCoords = function(row, column) {
    const view = instance.view;
    return view._wt.createCellCoords(row, column);
  };
  this._createCellRange = function(highlight, from, to) {
    const view = instance.view;
    return view._wt.createCellRange(highlight, from, to);
  };
  this.validateCell = function(value, cellProperties, callback, source) {
    let validator = instance.getCellValidator(cellProperties);
    function done(valid, canBeValidated = true) {
      if (!canBeValidated || cellProperties.hidden === true) {
        callback(valid);
        return;
      }
      const col = cellProperties.visualCol;
      const row = cellProperties.visualRow;
      const td = instance.getCell(row, col, true);
      if (td && td.nodeName !== "TH") {
        const renderableRow = instance.rowIndexMapper.getRenderableFromVisualIndex(row);
        const renderableColumn = instance.columnIndexMapper.getRenderableFromVisualIndex(col);
        instance.view._wt.getSetting("cellRenderer", renderableRow, renderableColumn, td);
      }
      callback(valid);
    }
    if (isRegExp$1(validator)) {
      validator = /* @__PURE__ */ (function(expression) {
        return function(cellValue, validatorCallback) {
          validatorCallback(expression.test(cellValue));
        };
      })(validator);
    }
    if (isFunction$1(validator)) {
      const colArg = isFunction$1(cellProperties.prop) ? cellProperties.visualCol : cellProperties.prop;
      value = instance.runHooks("beforeValidate", value, cellProperties.visualRow, colArg, source);
      instance._registerMicrotask(() => {
        validator.call(cellProperties, value, (valid) => {
          if (!instance) {
            return;
          }
          valid = instance.runHooks("afterValidate", valid, value, cellProperties.visualRow, colArg, source);
          cellProperties.valid = valid;
          done(valid);
          instance.runHooks("postAfterValidate", valid, value, cellProperties.visualRow, colArg, source);
        });
      });
    } else {
      instance._registerMicrotask(() => {
        cellProperties.valid = true;
        done(cellProperties.valid, false);
      });
    }
  };
  function setDataInputToArray(row, propOrCol, value) {
    if (Array.isArray(row)) {
      return row;
    }
    return [
      [
        row,
        propOrCol,
        value
      ]
    ];
  }
  function processChanges(changes, source) {
    const beforeChangeResult = instance.runHooks("beforeChange", changes, source || "edit");
    const filteredChanges = changes.filter((change) => change !== null);
    if (beforeChangeResult === false || filteredChanges.length === 0) {
      instance.getActiveEditor()?.cancelChanges();
      return [];
    }
    for (let i = filteredChanges.length - 1; i >= 0; i--) {
      const [row, prop, , newValue] = filteredChanges[i];
      const visualColumn = datamap.propToCol(prop);
      let cellProperties;
      if (Number.isInteger(visualColumn)) {
        cellProperties = instance.getCellMeta(row, visualColumn);
      } else {
        cellProperties = {
          ...Object.getPrototypeOf(tableMeta),
          ...tableMeta
        };
      }
      filteredChanges[i][3] = getValueSetterValue(newValue, cellProperties);
    }
    return filteredChanges;
  }
  this.setDataAtCell = function(row, column, value, source) {
    const input = setDataInputToArray(row, column, value);
    const changes = [];
    let changeSource = source;
    let i;
    let ilen;
    let prop;
    for (i = 0, ilen = input.length; i < ilen; i++) {
      const [visualRow, visualColumn, newValue] = input[i];
      if (typeof input[i] !== "object") {
        throwWithCause("Method `setDataAtCell` accepts row number or changes array of arrays as its first parameter");
      }
      if (typeof input[i][1] !== "number") {
        throwWithCause("Method `setDataAtCell` accepts row and column number as its parameters. If you want to use object property name, use method `setDataAtRowProp`");
      }
      const visualColumnIndex = typeof visualColumn === "number" ? visualColumn : 0;
      if (visualColumnIndex >= this.countCols()) {
        prop = visualColumnIndex;
      } else {
        prop = datamap.colToProp(visualColumnIndex);
      }
      changes.push([
        visualRow,
        prop,
        dataSource.getAtCell(this.toPhysicalRow(visualRow), visualColumn),
        newValue
      ]);
    }
    if (!changeSource && typeof row === "object") {
      changeSource = column;
    }
    const processedChanges = processChanges(changes, changeSource);
    instance.runHooks("afterSetDataAtCell", processedChanges, changeSource);
    validateChanges(processedChanges, changeSource, () => {
      applyChanges(processedChanges, changeSource);
    });
  };
  this.setDataAtRowProp = function(row, prop, value, source) {
    const input = setDataInputToArray(row, prop, value);
    const changes = [];
    let changeSource = source;
    let i;
    let ilen;
    for (i = 0, ilen = input.length; i < ilen; i++) {
      const [visualRow, inputProp, newValue] = input[i];
      changes.push([
        visualRow,
        inputProp,
        dataSource.getAtCell(this.toPhysicalRow(visualRow), inputProp),
        newValue
      ]);
    }
    if (!changeSource && typeof row === "object") {
      changeSource = prop;
    }
    const processedChanges = processChanges(changes, changeSource);
    instance.runHooks("afterSetDataAtRowProp", processedChanges, changeSource);
    validateChanges(processedChanges, changeSource, () => {
      applyChanges(processedChanges, changeSource);
    });
  };
  this.listen = function() {
    if (instance && !instance.isListening()) {
      foreignHotInstances.forEach((foreignHot) => {
        if (instance !== foreignHot) {
          foreignHot.unlisten();
        }
      });
      activeGuid = instance.guid;
      instance.runHooks("afterListen");
    }
  };
  this.unlisten = function() {
    if (this.isListening()) {
      activeGuid = null;
      instance.runHooks("afterUnlisten");
    }
  };
  this.isListening = function() {
    return activeGuid === instance.guid;
  };
  this.destroyEditor = function(revertOriginal = false, prepareEditorIfNeeded = true) {
    editorManager.closeEditor(revertOriginal);
    instance.view.render();
    if (prepareEditorIfNeeded && selection.isSelected()) {
      editorManager.prepareEditor();
    }
  };
  this.populateFromArray = function(row, column, input, endRow, endCol, source, method) {
    if (!(typeof input === "object" && typeof input[0] === "object")) {
      throwWithCause("populateFromArray parameter `input` must be an array of arrays");
    }
    const c = typeof endRow === "number" ? instance._createCellCoords(endRow, endCol) : void 0;
    return grid.populateFromArray(instance._createCellCoords(row, column), input, c, source, method);
  };
  this.spliceCol = function(column, index2, amount, ...elements) {
    return datamap.spliceCol(column, index2, amount, ...elements);
  };
  this.spliceRow = function(row, index2, amount, ...elements) {
    return datamap.spliceRow(row, index2, amount, ...elements);
  };
  this.getSelected = function() {
    if (selection.isSelected()) {
      return arrayMap(selection.getSelectedRange().ranges, ({ from, to }) => [
        from.row,
        from.col,
        to.row,
        to.col
      ]);
    }
  };
  this.getSelectedLast = function() {
    const selected = instance.getSelected();
    let result;
    if (selected && selected.length > 0) {
      result = selected[selected.length - 1];
    }
    return result;
  };
  this.getSelectedActive = function() {
    const activeRange = instance.getSelectedRangeActive();
    if (!activeRange) {
      return;
    }
    const { from, to } = activeRange;
    return [
      from.row,
      from.col,
      to.row,
      to.col
    ];
  };
  this.getSelectedRange = function() {
    if (selection.isSelected()) {
      return Array.from(selection.getSelectedRange());
    }
  };
  this.getSelectedRangeLast = function() {
    const selectedRange = instance.getSelectedRange();
    let result;
    if (selectedRange && selectedRange.length > 0) {
      result = selectedRange[selectedRange.length - 1];
    }
    return result;
  };
  this.getSelectedRangeActive = function() {
    return selection.getActiveSelectedRange();
  };
  this.getActiveSelectionLayerIndex = function() {
    return selection.getActiveSelectionLayerIndex();
  };
  this.emptySelectedCells = function(source) {
    if (!selection.isSelected() || this.countRows() === 0 || this.countCols() === 0) {
      return;
    }
    const changes = [];
    arrayEach(selection.getSelectedRange(), (cellRange) => {
      if (cellRange.isSingleHeader()) {
        return;
      }
      const topStart = cellRange.getTopStartCorner();
      const bottomEnd = cellRange.getBottomEndCorner();
      const fromRow = Math.max(topStart.row, 0);
      const toRow = Math.min(bottomEnd.row, this.countRows() - 1);
      const fromColumn = Math.max(topStart.col, 0);
      const toColumn = Math.min(bottomEnd.col, this.countCols() - 1);
      if (fromRow > toRow || fromColumn > toColumn) {
        return;
      }
      const collectEmptyCellChanges = (row) => {
        rangeEach(fromColumn, toColumn, (column) => {
          if (!this.getCellMeta(row, column).readOnly) {
            changes.push([
              row,
              column,
              null
            ]);
          }
        });
      };
      rangeEach(fromRow, toRow, collectEmptyCellChanges);
    });
    if (changes.length > 0) {
      this.setDataAtCell(changes, source);
    }
  };
  this.isRenderSuspended = function() {
    return this.renderSuspendedCounter > 0;
  };
  this.suspendRender = function() {
    this.renderSuspendedCounter += 1;
  };
  this.resumeRender = function() {
    const nextValue = this.renderSuspendedCounter - 1;
    this.renderSuspendedCounter = Math.max(nextValue, 0);
    if (!this.isRenderSuspended() && nextValue === this.renderSuspendedCounter) {
      instance.view.render();
    }
  };
  this.render = function() {
    if (this.view) {
      this.forceFullRender = true;
      if (!this.isRenderSuspended()) {
        instance.view.render();
      }
    }
  };
  this.batchRender = function(wrappedOperations) {
    instance.suspendRender();
    const result = wrappedOperations();
    instance.resumeRender();
    return result;
  };
  this.isExecutionSuspended = function() {
    return this.executionSuspendedCounter > 0;
  };
  this.suspendExecution = function() {
    this.executionSuspendedCounter += 1;
    this.columnIndexMapper.suspendOperations();
    this.rowIndexMapper.suspendOperations();
  };
  this.resumeExecution = function(forceFlushChanges = false) {
    const nextValue = this.executionSuspendedCounter - 1;
    this.executionSuspendedCounter = Math.max(nextValue, 0);
    if (!this.isExecutionSuspended() && nextValue === this.executionSuspendedCounter || forceFlushChanges) {
      this.columnIndexMapper.resumeOperations();
      this.rowIndexMapper.resumeOperations();
    }
  };
  this.batchExecution = function(wrappedOperations, forceFlushChanges = false) {
    instance.suspendExecution();
    const result = wrappedOperations();
    instance.resumeExecution(forceFlushChanges);
    return result;
  };
  this.batch = function(wrappedOperations) {
    instance.suspendRender();
    instance.suspendExecution();
    const result = wrappedOperations();
    instance.resumeExecution();
    instance.resumeRender();
    return result;
  };
  this.refreshDimensions = function() {
    if (!instance.view) {
      return;
    }
    const view = instance.view;
    const { width: lastWidth, height: lastHeight } = view.getLastSize();
    const { width, height } = instance.rootElement.getBoundingClientRect();
    const isSizeChanged = width !== lastWidth || height !== lastHeight;
    const isResizeBlocked = instance.runHooks("beforeRefreshDimensions", {
      width: lastWidth,
      height: lastHeight
    }, {
      width,
      height
    }, isSizeChanged) === false;
    if (isResizeBlocked) {
      return;
    }
    if (isSizeChanged || view._wt.wtOverlays.scrollableElement === instance.rootWindow) {
      view.setLastSize(width, height);
      view.adjustElementsSize();
      instance.render();
    }
    instance.runHooks("afterRefreshDimensions", {
      width: lastWidth,
      height: lastHeight
    }, {
      width,
      height
    }, isSizeChanged);
  };
  this.updateData = function(data, source) {
    replaceData(data, (newDataMap) => {
      datamap = newDataMap;
    }, (newDataMap) => {
      datamap = newDataMap;
      instance.columnIndexMapper.fitToLength(this.getInitialColumnCount());
      instance.rowIndexMapper.fitToLength(this.countSourceRows());
      grid.adjustRowsAndCols();
      selection.markSource("updateData");
      selection.refresh();
      selection.markEndSource();
    }, {
      hotInstance: instance,
      dataMap: datamap,
      dataSource,
      internalSource: "updateData",
      source,
      metaManager,
      firstRun
    });
  };
  this.loadData = function(data, source) {
    replaceData(data, (newDataMap) => {
      datamap = newDataMap;
    }, () => {
      metaManager.clearCellsCache();
      instance.initIndexMappers();
      grid.adjustRowsAndCols();
      selection.markSource("loadData");
      selection.refresh();
      selection.markEndSource();
      if (firstRun) {
        firstRun = [
          null,
          "loadData"
        ];
      }
    }, {
      hotInstance: instance,
      dataMap: datamap,
      dataSource,
      internalSource: "loadData",
      source,
      metaManager,
      firstRun
    });
  };
  this.getInitialColumnCount = function() {
    const columnsSettings = tableMeta.columns;
    let finalNrOfColumns = 0;
    if (Array.isArray(columnsSettings)) {
      finalNrOfColumns = columnsSettings.length;
    } else if (isFunction$1(columnsSettings)) {
      if (instance.dataType === "array") {
        const nrOfSourceColumns = instance.countSourceCols();
        for (let columnIndex = 0; columnIndex < nrOfSourceColumns; columnIndex += 1) {
          if (columnsSettings(columnIndex)) {
            finalNrOfColumns += 1;
          }
        }
      } else if (instance.dataType === "object" || instance.dataType === "function") {
        finalNrOfColumns = datamap.colToPropCache.length;
      }
    } else if (isDefined(tableMeta.dataSchema)) {
      const schema = datamap.getSchema();
      finalNrOfColumns = Array.isArray(schema) ? schema.length : deepObjectSize(schema);
    } else {
      finalNrOfColumns = instance.countSourceCols();
    }
    return finalNrOfColumns;
  };
  this.initIndexMappers = function() {
    this.columnIndexMapper.initToLength(this.getInitialColumnCount());
    this.rowIndexMapper.initToLength(this.countSourceRows());
  };
  this.getData = function(row, column, row2, column2) {
    if (isUndefined$1(row)) {
      return datamap.getAll();
    }
    return datamap.getRange(instance._createCellCoords(row, column), instance._createCellCoords(row2, column2), DataMap.DESTINATION_RENDERER);
  };
  this.getCopyableText = function(startRow, startCol, endRow, endCol) {
    return datamap.getCopyableText(instance._createCellCoords(startRow, startCol), instance._createCellCoords(endRow, endCol));
  };
  this.getCopyableData = function(row, column) {
    return datamap.getCopyable(row, datamap.colToProp(column));
  };
  this.getCopyableSourceData = function(row, column) {
    return dataSource.getCopyable(row, datamap.colToProp(column));
  };
  this.getSchema = function() {
    return datamap.getSchema();
  };
  this.updateSettings = function(settings, init = false) {
    const dataUpdateFunction = (firstRun ? instance.loadData : instance.updateData).bind(this);
    let i;
    let j;
    if (isDefined(settings.rows)) {
      throwWithCause('The "rows" setting is no longer supported. Do you mean startRows, minRows or maxRows?');
    }
    if (isDefined(settings.cols)) {
      throwWithCause('The "cols" setting is no longer supported. Do you mean startCols, minCols or maxCols?');
    }
    if (isDefined(settings.ganttChart)) {
      throwWithCause('Since 8.0.0 the "ganttChart" setting is no longer supported.');
    }
    if (isDefined(settings.rowHeights) && isDefined(settings.minRowHeights)) {
      warn$1("Both `rowHeights` and `minRowHeights` are defined in your configuration. As one is the alias of the other, only one of them can be used at a time. `rowHeights` will be used as the row height configuration.");
    }
    for (i in settings) {
      if (i === "data" || i === "language") ;
      else if (i === "className") {
        setClassName("className", settings.className);
      } else if (i === "tableClassName" && instance.table) {
        setClassName("tableClassName", settings.tableClassName);
        instance.view._wt.wtOverlays.syncOverlayTableClassNames();
      } else if (Hooks.getSingleton().isRegistered(i) || Hooks.getSingleton().isDeprecated(i)) {
        const hook = settings[i];
        if (isFunction$1(hook)) {
          Hooks.getSingleton().addAsFixed(i, hook, instance);
          tableMeta[i] = hook;
        } else if (Array.isArray(hook)) {
          Hooks.getSingleton().add(i, hook, instance);
          tableMeta[i] = hook;
        }
      } else if (!init && hasOwnProperty(settings, i)) {
        globalMeta[i] = settings[i];
      }
    }
    const rootContainerThemeClassName2 = getThemeClassName(instance.rootContainer);
    const themeNameOptionExists = hasOwnProperty(settings, "themeName");
    const themeOptionExists = hasOwnProperty(settings, "theme");
    if (themeNameOptionExists && themeOptionExists) {
      warn$1("Both `theme` and `themeName` are defined in your configuration. These options are aliases and cannot be used together. The `themeName` option will be ignored.");
    }
    if (init) {
      let themeName2;
      if (themeOptionExists && typeof settings.theme === "string") {
        themeName2 = settings.theme;
      } else if (themeNameOptionExists && typeof settings.themeName === "string" && settings.themeName && !themeOptionExists) {
        themeName2 = settings.themeName;
        tableMeta.theme = settings.themeName;
        tableMeta.themeName = void 0;
      } else if (rootContainerThemeClassName2) {
        themeName2 = rootContainerThemeClassName2;
      } else if (instance.themeManager) {
        themeName2 = instance.themeManager.getClassName();
      }
      instance.useTheme(themeName2 ?? null);
    } else {
      const currentThemeName = instance.getCurrentThemeName();
      if (themeOptionExists && typeof settings.theme === "string" && currentThemeName !== settings.theme) {
        instance.themeManager?.unmount();
        instance.themeManager = null;
        instance.useTheme(settings.theme);
      } else if (themeNameOptionExists && !themeOptionExists && currentThemeName !== settings.themeName) {
        instance.themeManager?.unmount();
        instance.themeManager = null;
        tableMeta.theme = settings.themeName;
        tableMeta.themeName = void 0;
        instance.useTheme(settings.themeName);
      } else if (isRootInstance(instance) && !rootContainerThemeClassName2 && isObject$1(settings.theme)) {
        if (instance.themeManager === null) {
          initializeThemeManager(settings.theme);
          instance.useTheme(instance.themeManager.getClassName());
        } else {
          let themeObject;
          if (typeof settings.theme.getThemeConfig !== "function") {
            themeObject = registerTheme(settings.theme);
          } else {
            themeObject = settings.theme;
          }
          instance.themeManager.update(themeObject);
          instance.useTheme(instance.themeManager.getClassName());
        }
      }
    }
    if (instance.runHooks("hasExternalDataSource") === true) {
      if (settings.data) {
        warn$1('The "data" setting is ignored when "hasExternalDataSource" returns `true`.');
      }
      const shouldSyncExternalPlaceholderData = init || hasOwnProperty(settings, "data") || hasOwnProperty(settings, "dataProvider");
      if (shouldSyncExternalPlaceholderData) {
        dataUpdateFunction([], "updateSettings");
      } else if (settings.columns !== void 0) {
        datamap.createMap();
        instance.initIndexMappers();
      }
    } else if (settings.data === void 0 && tableMeta.data === void 0) {
      dataUpdateFunction(null, "updateSettings");
    } else if (settings.data !== void 0) {
      dataUpdateFunction(settings.data, "updateSettings");
    } else if (settings.columns !== void 0) {
      datamap.createMap();
      instance.initIndexMappers();
    }
    if (!firstRun && settings.language) {
      setLanguage(settings.language);
    }
    const clen = instance.countCols();
    const columnSetting = tableMeta.columns;
    if (settings.cell !== void 0 || settings.cells !== void 0 || settings.columns !== void 0) {
      const userDefinedCellMetas = metaManager.getUserDefinedCellMetas();
      metaManager.clearCache();
      userDefinedCellMetas.forEach(({ physicalRow, physicalColumn, key, value }) => {
        metaManager.setCellMeta(physicalRow, physicalColumn, key, value);
      });
    }
    if (clen > 0) {
      for (i = 0, j = 0; i < clen; i++) {
        if (columnSetting) {
          const column = isFunction$1(columnSetting) ? columnSetting(i) : columnSetting[j];
          if (column) {
            metaManager.updateColumnMeta(j, column);
          }
        }
        j += 1;
      }
    }
    if (isDefined(settings.cell)) {
      metaManager.disableUserDefinedMetaRecording();
      try {
        settings.cell.forEach((cell) => {
          instance.setCellMetaObject(cell.row, cell.col, cell);
        });
      } finally {
        metaManager.enableUserDefinedMetaRecording();
      }
    }
    instance.runHooks("afterCellMetaReset");
    if (firstRun) {
      runSourceDataValidators(instance, "init");
    }
    let currentHeight = instance.rootElement.style.height;
    if (currentHeight !== "") {
      currentHeight = parseInt(instance.rootElement.style.height, 10);
    }
    if (init) {
      const initialStyle = instance.rootElement.getAttribute("style");
      if (initialStyle) {
        instance.rootElement.dataset.initialstyle = instance.rootElement.getAttribute("style") ?? "";
      }
    }
    let height = settings.height;
    if (typeof settings.height !== "undefined") {
      if (isFunction$1(height)) {
        height = height();
      }
      height = instance.runHooks("beforeHeightChange", height);
      if (height === null) {
        const initialStyle = instance.rootElement.dataset.initialstyle;
        if (initialStyle && (initialStyle.indexOf("height") > -1 || initialStyle.indexOf("overflow") > -1)) {
          instance.rootElement.setAttribute("style", initialStyle);
        } else {
          instance.rootElement.style.height = "";
          instance.rootElement.style.overflow = "";
        }
      } else if (height !== void 0) {
        instance.rootElement.style.height = isNaN(height) ? `${height}` : `${height}px`;
        instance.rootElement.style.overflow = "clip";
      }
    }
    if (typeof settings.width !== "undefined") {
      let width = settings.width;
      if (isFunction$1(width)) {
        width = width();
      }
      width = instance.runHooks("beforeWidthChange", width);
      instance.rootElement.style.width = isNaN(width) ? `${width}` : `${width}px`;
    }
    if (typeof settings.height !== "undefined" || typeof settings.width !== "undefined") {
      const effectiveHeight = instance.rootElement.style.height;
      const effectiveWidth = instance.rootElement.style.width;
      if (!effectiveHeight) {
        const currentOverflowX = instance.rootElement.style.overflowX;
        if (currentOverflowX === "" || currentOverflowX === "clip") {
          instance.rootElement.style.overflowX = effectiveWidth && effectiveWidth !== "auto" ? "clip" : "";
        }
      }
    }
    if (!init) {
      if (instance.view) {
        instance.view._wt.wtViewport.resetHasOversizedColumnHeadersMarked();
        instance.view._wt.exportSettingsAsClassNames();
        instance.view.invalidateIndexSizesCache();
      }
      selection.updateHighlightClassNames();
      instance.runHooks("afterUpdateSettings", settings);
    }
    grid.adjustRowsAndCols();
    if (instance.view && !firstRun) {
      instance.render();
      instance.view._wt.wtOverlays.adjustElementsSize();
    }
    if (!init && instance.view && (currentHeight === "" || height === "" || height === void 0) && currentHeight !== height) {
      instance.view._wt.wtOverlays.updateMainScrollableElements();
    }
    if (isRootInstance(instance)) {
      layoutManager?.applyConfig(tableMeta.layout);
    }
  };
  this.getValue = function() {
    const activeSelection = instance.getSelectedRangeActive();
    if (tableMeta.getValue) {
      if (isFunction$1(tableMeta.getValue)) {
        return tableMeta.getValue.call(instance);
      } else if (activeSelection && typeof tableMeta.getValue === "string") {
        const rowIndex = activeSelection.highlight.row ?? 0;
        const rowData = instance.getData()[rowIndex];
        return rowData[tableMeta.getValue];
      }
    } else if (activeSelection) {
      return instance.getDataAtCell(activeSelection.highlight.row, activeSelection.highlight.col);
    }
    return null;
  };
  this.getSettings = function() {
    return tableMeta;
  };
  this.clear = function() {
    this.selectAll();
    this.emptySelectedCells();
    this.deselectCell();
  };
  this.alter = function(action, index2, amount, source, keepEmptyRows) {
    grid.alter(action, index2, amount, source, keepEmptyRows);
  };
  this.getCell = function(row, column, topmost = false) {
    let renderableColumnIndex = column;
    let renderableRowIndex = row;
    if (column >= 0) {
      if (instance.columnIndexMapper.isHidden(instance.toPhysicalColumn(column))) {
        return null;
      }
      renderableColumnIndex = instance.columnIndexMapper.getRenderableFromVisualIndex(column);
    }
    if (row >= 0) {
      if (instance.rowIndexMapper.isHidden(instance.toPhysicalRow(row))) {
        return null;
      }
      renderableRowIndex = instance.rowIndexMapper.getRenderableFromVisualIndex(row);
    }
    if (renderableRowIndex === null || renderableColumnIndex === null || renderableRowIndex === void 0 || renderableColumnIndex === void 0) {
      return null;
    }
    return instance.view.getCellAtCoords(instance._createCellCoords(renderableRowIndex, renderableColumnIndex), topmost);
  };
  this.getCoords = function(element) {
    const renderableCoords = instance.view._wt.wtTable.getCoords(element);
    if (renderableCoords === null) {
      return null;
    }
    const { row: renderableRow, col: renderableColumn } = renderableCoords;
    let visualRow = renderableRow;
    let visualColumn = renderableColumn;
    if (renderableRow !== null && renderableRow >= 0) {
      visualRow = instance.rowIndexMapper.getVisualFromRenderableIndex(renderableRow);
    }
    if (renderableColumn !== null && renderableColumn >= 0) {
      visualColumn = instance.columnIndexMapper.getVisualFromRenderableIndex(renderableColumn);
    }
    return instance._createCellCoords(visualRow, visualColumn);
  };
  this.colToProp = function(column) {
    return datamap.colToProp(column);
  };
  this.propToCol = function(prop) {
    return datamap.propToCol(prop);
  };
  this.toVisualRow = (row) => instance.rowIndexMapper.getVisualFromPhysicalIndex(row);
  this.toVisualColumn = (column) => instance.columnIndexMapper.getVisualFromPhysicalIndex(column);
  this.toPhysicalRow = (row) => instance.rowIndexMapper.getPhysicalFromVisualIndex(row);
  this.toPhysicalColumn = (column) => instance.columnIndexMapper.getPhysicalFromVisualIndex(column);
  this.getDataAtCell = function(row, column) {
    return datamap.get(row, datamap.colToProp(column));
  };
  this.getDataAtRowProp = function(row, prop) {
    return datamap.get(row, prop);
  };
  this.getDataAtCol = function(column) {
    const columnData = [];
    const dataByRows = datamap.getRange(instance._createCellCoords(0, column), instance._createCellCoords(tableMeta.data.length - 1, column), DataMap.DESTINATION_RENDERER);
    for (let i = 0; i < dataByRows.length; i += 1) {
      for (let j = 0; j < dataByRows[i].length; j += 1) {
        columnData.push(dataByRows[i][j]);
      }
    }
    return columnData;
  };
  this.getDataAtProp = function(prop) {
    const columnData = [];
    const dataByRows = datamap.getRange(instance._createCellCoords(0, datamap.propToCol(prop)), instance._createCellCoords(tableMeta.data.length - 1, datamap.propToCol(prop)), DataMap.DESTINATION_RENDERER);
    for (let i = 0; i < dataByRows.length; i += 1) {
      for (let j = 0; j < dataByRows[i].length; j += 1) {
        columnData.push(dataByRows[i][j]);
      }
    }
    return columnData;
  };
  this.getSourceData = function(row, column, row2, column2) {
    let data;
    if (row === void 0) {
      data = dataSource.getData();
    } else {
      data = dataSource.getByRange(instance._createCellCoords(row, column ?? null), instance._createCellCoords(row2 ?? null, column2 ?? null));
    }
    return data;
  };
  this.getSourceDataArray = function(row, column, row2, column2) {
    let data;
    if (row === void 0) {
      data = dataSource.getData(true);
    } else {
      data = dataSource.getByRange(instance._createCellCoords(row, column ?? null), instance._createCellCoords(row2 ?? null, column2 ?? null), true);
    }
    return data;
  };
  this.getSourceDataAtCol = function(column) {
    return dataSource.getAtColumn(column);
  };
  this.setSourceDataAtCell = function(row, column, value, source) {
    const input = setDataInputToArray(row, column, value);
    const isThereAnySetSourceListener = instance.hasHook("afterSetSourceDataAtCell");
    const changesForHook = [];
    const getCellProperties = (changeRow, changeProp) => {
      const visualRow = instance.toVisualRow(changeRow);
      const visualColumn = instance.toVisualColumn(changeProp);
      if (Number.isInteger(visualColumn)) {
        return instance.getCellMeta(visualRow, visualColumn);
      }
      return {
        ...Object.getPrototypeOf(tableMeta),
        ...tableMeta
      };
    };
    if (isThereAnySetSourceListener) {
      arrayEach(input, ([changeRow, changeProp, changeValue]) => {
        const newValue = getValueSetterValue(changeValue, getCellProperties(changeRow, changeProp));
        changesForHook.push([
          changeRow,
          changeProp,
          dataSource.getAtCell(changeRow, changeProp),
          newValue
        ]);
      });
    }
    arrayEach(input, ([changeRow, changeProp, changeValue]) => {
      const cellMeta = getCellProperties(changeRow, changeProp);
      const newValue = getValueSetterValue(changeValue, cellMeta);
      if (runSourceDataValidator(newValue, cellMeta, source ?? "setSourceDataAtCell")) {
        dataSource.setAtCell(changeRow, changeProp, newValue);
      }
    });
    if (isThereAnySetSourceListener) {
      this.runHooks("afterSetSourceDataAtCell", changesForHook, source);
    }
    this.render();
    const activeEditor = instance.getActiveEditor();
    if (activeEditor && isDefined(activeEditor.refreshValue)) {
      activeEditor.refreshValue();
    }
  };
  this.getSourceDataAtRow = function(row) {
    return dataSource.getAtRow(row);
  };
  this.getSourceDataAtCell = function(row, column) {
    return dataSource.getAtCell(row, column);
  };
  this.getDataAtRow = function(row) {
    const data = datamap.getRange(instance._createCellCoords(row, 0), instance._createCellCoords(row, this.countCols() - 1), DataMap.DESTINATION_RENDERER);
    return data[0] || [];
  };
  this.getDataType = function(rowFrom, columnFrom, rowTo, columnTo) {
    const coords = rowFrom === void 0 ? [
      0,
      0,
      instance.countRows(),
      instance.countCols()
    ] : [
      rowFrom,
      columnFrom,
      rowTo,
      columnTo
    ];
    const [rowStart, columnStart] = coords;
    let [, , rowEnd, columnEnd] = coords;
    let previousType = null;
    let currentType = null;
    if (rowEnd === void 0) {
      rowEnd = rowStart;
    }
    if (columnEnd === void 0) {
      columnEnd = columnStart;
    }
    let type = "mixed";
    rangeEach(Math.max(Math.min(rowStart, rowEnd), 0), Math.max(rowStart, rowEnd), (row) => {
      let isTypeEqual = true;
      rangeEach(Math.max(Math.min(columnStart, columnEnd), 0), Math.max(columnStart, columnEnd), (column) => {
        const cellType = instance.getCellMeta(row, column);
        currentType = cellType.type ?? null;
        if (previousType) {
          isTypeEqual = previousType === currentType;
        } else {
          previousType = currentType;
        }
        return isTypeEqual;
      });
      type = isTypeEqual ? currentType ?? "mixed" : "mixed";
      return isTypeEqual;
    });
    return type;
  };
  this.removeCellMeta = function(row, column, key) {
    const [physicalRow, physicalColumn] = [
      instance.toPhysicalRow(row),
      instance.toPhysicalColumn(column)
    ];
    let cachedValue = metaManager.getCellMetaKeyValue(physicalRow, physicalColumn, key);
    const hookResult = instance.runHooks("beforeRemoveCellMeta", row, column, key, cachedValue);
    if (hookResult !== false) {
      metaManager.removeCellMeta(physicalRow, physicalColumn, key);
      instance.runHooks("afterRemoveCellMeta", row, column, key, cachedValue);
    }
    cachedValue = null;
  };
  this.spliceCellsMeta = function(visualIndex, deleteAmount = 0, ...cellMetaRows) {
    if (cellMetaRows.length > 0 && !Array.isArray(cellMetaRows[0])) {
      throwWithCause("The 3rd argument (cellMetaRows) has to be passed as an array of cell meta objects array.");
    }
    if (deleteAmount > 0) {
      metaManager.removeRow(instance.toPhysicalRow(visualIndex), deleteAmount);
    }
    if (cellMetaRows.length > 0) {
      arrayEach(cellMetaRows.reverse(), (cellMetaRow) => {
        metaManager.createRow(instance.toPhysicalRow(visualIndex));
        arrayEach(cellMetaRow, (cellMeta, columnIndex) => {
          this.setCellMetaObject(visualIndex, columnIndex, cellMeta);
        });
      });
    }
    instance.render();
  };
  this.setCellMetaObject = function(row, column, prop) {
    if (typeof prop === "object") {
      objectEach(prop, (value, key) => {
        this.setCellMeta(row, column, key, value);
      });
    }
  };
  this.setCellMeta = function(row, column, key, value) {
    const allowSetCellMeta = instance.runHooks("beforeSetCellMeta", row, column, key, value);
    if (allowSetCellMeta === false) {
      return;
    }
    let physicalRow = row;
    let physicalColumn = column;
    if (row < instance.countRows()) {
      physicalRow = instance.toPhysicalRow(row);
    }
    if (column < instance.countCols()) {
      physicalColumn = instance.toPhysicalColumn(column);
    }
    metaManager.setCellMeta(physicalRow, physicalColumn, key, value);
    instance.runHooks("afterSetCellMeta", row, column, key, value);
  };
  this.getCellsMeta = function() {
    return metaManager.getCellsMeta();
  };
  this.getCellMeta = function(row, column, options = {
    skipMetaExtension: false
  }) {
    let physicalRow = instance.toPhysicalRow(row);
    let physicalColumn = instance.toPhysicalColumn(column);
    if (physicalRow === null) {
      physicalRow = row;
    }
    if (physicalColumn === null) {
      physicalColumn = column;
    }
    return metaManager.getCellMeta(physicalRow, physicalColumn, {
      visualRow: row,
      visualColumn: column,
      ...options
    });
  };
  this.getColumnMeta = function(column) {
    return metaManager.getColumnMeta(instance.toPhysicalColumn(column));
  };
  this.getCellMetaAtRow = function(row) {
    return metaManager.getCellsMetaAtRow(row);
  };
  this.isColumnModificationAllowed = function() {
    return !(instance.dataType === "object" || tableMeta.columns);
  };
  this.getCellRenderer = function(rowOrMeta, column) {
    const cellRenderer = typeof rowOrMeta === "number" ? instance.getCellMeta(rowOrMeta, column).renderer : rowOrMeta.renderer;
    if (typeof cellRenderer === "string") {
      return _getItem$2(cellRenderer);
    }
    return isUndefined$1(cellRenderer) ? _getItem$2("text") : cellRenderer;
  };
  this.getCellEditor = function(rowOrMeta, column) {
    const cellEditor = typeof rowOrMeta === "number" ? instance.getCellMeta(rowOrMeta, column).editor : rowOrMeta.editor;
    if (typeof cellEditor === "string") {
      return _getItem$3(cellEditor);
    }
    return isUndefined$1(cellEditor) ? _getItem$3("text") : cellEditor;
  };
  this.getCellValidator = function(rowOrMeta, column) {
    const cellValidator = typeof rowOrMeta === "number" ? instance.getCellMeta(rowOrMeta, column).validator : rowOrMeta.validator;
    if (typeof cellValidator === "string") {
      return _getItem$1(cellValidator);
    }
    return cellValidator;
  };
  this.validateCells = function(callback) {
    this._validateCells(callback);
  };
  this.validateRows = function(rows, callback) {
    if (!Array.isArray(rows)) {
      throwWithCause("validateRows parameter `rows` must be an array");
    }
    this._validateCells(callback, rows);
  };
  this.validateColumns = function(columns, callback) {
    if (!Array.isArray(columns)) {
      throwWithCause("validateColumns parameter `columns` must be an array");
    }
    this._validateCells(callback, void 0, columns);
  };
  this._validateCells = function(callback, rows, columns) {
    const waitingForValidator = ValidatorsQueue();
    if (callback) {
      waitingForValidator.onQueueEmpty = callback;
    }
    let i = instance.countRows() - 1;
    while (i >= 0) {
      if (rows !== void 0 && rows.indexOf(i) === -1) {
        i -= 1;
        continue;
      }
      let j = instance.countCols() - 1;
      while (j >= 0) {
        if (columns !== void 0 && columns.indexOf(j) === -1) {
          j -= 1;
          continue;
        }
        waitingForValidator.addValidatorToQueue();
        instance.validateCell(instance.getDataAtCell(i, j), instance.getCellMeta(i, j), (result) => {
          if (typeof result !== "boolean") {
            throwWithCause("Validation error: result is not boolean");
          }
          if (result === false) {
            waitingForValidator.valid = false;
          }
          waitingForValidator.removeValidatorFormQueue();
        }, "validateCells");
        j -= 1;
      }
      i -= 1;
    }
    waitingForValidator.checkIfQueueIsEmpty();
  };
  this.getRowHeader = function(row) {
    let rowHeader = tableMeta.rowHeaders;
    let physicalRow = row;
    if (physicalRow !== void 0) {
      physicalRow = instance.runHooks("modifyRowHeader", physicalRow);
    }
    if (physicalRow === void 0) {
      const headers = [];
      rangeEach(instance.countRows() - 1, (i) => {
        headers.push(instance.getRowHeader(i));
      });
      rowHeader = headers;
    } else if (Array.isArray(rowHeader) && rowHeader[physicalRow] !== void 0) {
      rowHeader = rowHeader[physicalRow];
    } else if (isFunction$1(rowHeader)) {
      rowHeader = rowHeader(physicalRow);
    } else if (rowHeader && typeof rowHeader !== "string" && typeof rowHeader !== "number") {
      rowHeader = physicalRow + 1;
    }
    return rowHeader;
  };
  this.hasRowHeaders = function() {
    return !!tableMeta.rowHeaders;
  };
  this.hasColHeaders = function() {
    if (tableMeta.colHeaders !== void 0 && tableMeta.colHeaders !== null) {
      return !!tableMeta.colHeaders;
    }
    for (let i = 0, ilen = instance.countCols(); i < ilen; i++) {
      if (instance.getColHeader(i)) {
        return true;
      }
    }
    return false;
  };
  this.getColHeader = function(column, headerLevel = -1) {
    const columnIndex = instance.runHooks("modifyColHeader", column);
    if (columnIndex === void 0) {
      const out = [];
      const ilen = instance.countCols();
      for (let i = 0; i < ilen; i++) {
        out.push(instance.getColHeader(i));
      }
      return out;
    }
    let result = tableMeta.colHeaders;
    const columns = tableMeta.columns;
    const translateVisualIndexToColumns = function(visualColumnIndex) {
      const arr = [];
      const columnsLen = instance.countCols();
      let index2 = 0;
      for (; index2 < columnsLen; index2++) {
        if (isFunction$1(columns) && columns(index2)) {
          arr.push(index2);
        }
      }
      return arr[visualColumnIndex];
    };
    const physicalColumn = instance.toPhysicalColumn(columnIndex);
    const prop = translateVisualIndexToColumns(physicalColumn);
    if (tableMeta.colHeaders === false) {
      result = null;
    } else if (columns && isFunction$1(columns) && columns(prop) && columns(prop).title) {
      result = columns(prop).title;
    } else if (columns && !isFunction$1(columns) && columns[physicalColumn] && columns[physicalColumn].title) {
      result = columns[physicalColumn].title;
    } else if (Array.isArray(tableMeta.colHeaders) && tableMeta.colHeaders[physicalColumn] !== void 0) {
      result = tableMeta.colHeaders[physicalColumn];
    } else if (isFunction$1(tableMeta.colHeaders)) {
      result = tableMeta.colHeaders(physicalColumn);
    } else if (tableMeta.colHeaders && typeof tableMeta.colHeaders !== "string" && typeof tableMeta.colHeaders !== "number") {
      result = spreadsheetColumnLabel(columnIndex);
    }
    result = instance.runHooks("modifyColumnHeaderValue", result, column, headerLevel);
    return result;
  };
  this._getColWidthFromSettings = function(col) {
    let width;
    if (col >= 0) {
      const cellProperties = instance.getCellMeta(0, col);
      width = cellProperties.width;
    }
    if (width === void 0 || width === tableMeta.width) {
      width = tableMeta.colWidths;
    }
    if (width !== void 0 && width !== null) {
      switch (typeof width) {
        case "object":
          width = width[col];
          break;
        case "function":
          width = width(col);
          break;
      }
      if (typeof width === "string") {
        width = Number.parseInt(width, 10);
      }
    }
    return width;
  };
  this.getColWidth = function(column, source) {
    let width = instance._getColWidthFromSettings(column);
    width = instance.runHooks("modifyColWidth", width, column, source);
    if (width === void 0) {
      width = DEFAULT_COLUMN_WIDTH;
    }
    return width;
  };
  this._getRowHeightFromSettings = function(row) {
    const defaultRowHeight = instance.stylesHandler.getDefaultRowHeight(row);
    let height = tableMeta.rowHeights ?? tableMeta.minRowHeights;
    if (height !== void 0 && height !== null) {
      switch (typeof height) {
        case "object":
          height = height[row];
          break;
        case "function":
          height = height(row);
          break;
      }
      if (typeof height === "string") {
        height = Number.parseInt(height, 10);
      }
    }
    const numHeight = height;
    const numDefaultRowHeight = defaultRowHeight;
    return numHeight !== void 0 && numHeight !== null && numDefaultRowHeight !== null && numHeight < numDefaultRowHeight ? numDefaultRowHeight : numHeight;
  };
  this.getRowHeight = function(row, source) {
    let height = instance._getRowHeightFromSettings(row);
    height = instance.runHooks("modifyRowHeight", height, row, source);
    return height;
  };
  this.countSourceRows = function() {
    return dataSource.countRows();
  };
  this.countSourceCols = function() {
    return dataSource.countFirstRowKeys();
  };
  this.countRows = function() {
    return datamap.getLength();
  };
  this.countCols = function() {
    const maxCols = tableMeta.maxCols;
    const dataLen = instance.columnIndexMapper.getNotTrimmedIndexesLength();
    return Math.min(maxCols, dataLen);
  };
  this.countRenderedRows = function() {
    const view = instance.view;
    return view._wt.drawn ? view._wt.wtTable.getRenderedRowsCount() : -1;
  };
  this.countVisibleRows = function() {
    const view = instance.view;
    return view._wt.drawn ? view._wt.wtTable.getVisibleRowsCount() : -1;
  };
  this.countRenderedCols = function() {
    const view = instance.view;
    return view._wt.drawn ? view._wt.wtTable.getRenderedColumnsCount() : -1;
  };
  this.countVisibleCols = function() {
    const view = instance.view;
    return view._wt.drawn ? view._wt.wtTable.getVisibleColumnsCount() : -1;
  };
  this.countRowHeaders = function() {
    return instance.view.getRowHeadersCount();
  };
  this.countColHeaders = function() {
    return instance.view.getColumnHeadersCount();
  };
  this.countEmptyRows = function(ending = false) {
    let emptyRows = 0;
    rangeEachReverse(instance.countRows() - 1, (visualIndex) => {
      if (instance.isEmptyRow(visualIndex)) {
        emptyRows += 1;
      } else if (ending === true) {
        return false;
      }
    });
    return emptyRows;
  };
  this.countEmptyCols = function(ending = false) {
    let emptyColumns = 0;
    rangeEachReverse(instance.countCols() - 1, (visualIndex) => {
      if (instance.isEmptyCol(visualIndex)) {
        emptyColumns += 1;
      } else if (ending === true) {
        return false;
      }
    });
    return emptyColumns;
  };
  this.isEmptyRow = function(row) {
    return tableMeta.isEmptyRow.call(instance, row);
  };
  this.isEmptyCol = function(column) {
    return tableMeta.isEmptyCol.call(instance, column);
  };
  this.selectCell = function(row, column, endRow, endColumn, scrollToCell = true, changeListener = true) {
    if (isUndefined$1(row) || isUndefined$1(column)) {
      return false;
    }
    const rowNum = row === null || row === void 0 || Number.isNaN(Number(row)) ? 0 : Number(row);
    const col = column === null || column === void 0 || typeof column === "number" && Number.isNaN(column) ? 0 : column;
    const coords = [
      [
        rowNum,
        col,
        isUndefined$1(endRow) ? void 0 : endRow,
        isUndefined$1(endColumn) ? void 0 : endColumn
      ]
    ];
    return instance.selectCells(coords, scrollToCell, changeListener);
  };
  this.selectCells = function(coords = [
    []
  ], scrollToCell = true, changeListener = true) {
    if (scrollToCell === false) {
      viewportScroller.suspend();
    }
    if (changeListener === false) {
      focusGridManager.suspend();
    }
    let wasSelected;
    try {
      wasSelected = selection.selectCells(coords);
    } finally {
      viewportScroller.resume();
      focusGridManager.resume();
    }
    if (wasSelected && changeListener) {
      instance.listen();
    }
    return wasSelected;
  };
  this.selectColumns = function(startColumn, endColumn = startColumn, focusPosition) {
    return selection.selectColumns(startColumn, endColumn, focusPosition);
  };
  this.selectRows = function(startRow, endRow = startRow, focusPosition) {
    return selection.selectRows(startRow, endRow, focusPosition);
  };
  this.deselectCell = function() {
    selection.deselect();
  };
  this.selectAll = function(includeRowHeaders = true, includeColumnHeaders = includeRowHeaders, options) {
    viewportScroller.skipNextScrollCycle();
    selection.selectAll(includeRowHeaders, includeColumnHeaders, options);
  };
  const getIndexToScroll = (indexMapper, visualIndex) => {
    return indexMapper.getNearestNotHiddenIndex(visualIndex, 1, true);
  };
  const resolveRenderableScrollTarget = (row, col) => {
    const isValidRowGrid = row !== void 0 && Number.isInteger(row) && row >= 0;
    const isValidColumnGrid = col !== void 0 && Number.isInteger(col) && col >= 0;
    const visualRowToScroll = isValidRowGrid ? getIndexToScroll(instance.rowIndexMapper, row) : void 0;
    const visualColumnToScroll = isValidColumnGrid ? getIndexToScroll(instance.columnIndexMapper, col) : void 0;
    if (visualRowToScroll === null || visualColumnToScroll === null) {
      return false;
    }
    const renderableRow = isValidRowGrid ? instance.rowIndexMapper.getRenderableFromVisualIndex(visualRowToScroll) ?? void 0 : row;
    const renderableColumn = isValidColumnGrid ? instance.columnIndexMapper.getRenderableFromVisualIndex(visualColumnToScroll) ?? void 0 : col;
    return {
      renderableRow,
      renderableColumn
    };
  };
  this.scrollViewportTo = function(options, callback) {
    if (typeof options === "number") {
      options = {
        row: arguments[0],
        col: arguments[1],
        verticalSnap: arguments[2] ? "bottom" : "top",
        horizontalSnap: arguments[3] ? "end" : "start",
        considerHiddenIndexes: arguments[4] ?? true
      };
    }
    const { row, col, considerHiddenIndexes } = options ?? {};
    let renderableRow = row;
    let renderableColumn = col;
    if (isFunction$1(callback)) {
      this.addHookOnce("afterScroll", callback);
    }
    if (considerHiddenIndexes === void 0 || considerHiddenIndexes) {
      const resolved = resolveRenderableScrollTarget(row, col);
      if (resolved === false) {
        return false;
      }
      renderableRow = resolved.renderableRow;
      renderableColumn = resolved.renderableColumn;
    }
    const isRowInteger = Number.isInteger(renderableRow);
    const isColumnInteger = Number.isInteger(renderableColumn);
    let isScrolled = false;
    if (isRowInteger && renderableRow >= 0 && isColumnInteger && renderableColumn >= 0) {
      isScrolled = instance.view.scrollViewport(instance._createCellCoords(renderableRow, renderableColumn), options.horizontalSnap, options.verticalSnap);
    } else if (isRowInteger && renderableRow >= 0 && (isColumnInteger && renderableColumn < 0 || !isColumnInteger)) {
      isScrolled = instance.view.scrollViewportVertically(renderableRow, options.verticalSnap);
    } else if (isColumnInteger && renderableColumn >= 0 && (isRowInteger && renderableRow < 0 || !isRowInteger)) {
      isScrolled = instance.view.scrollViewportHorizontally(renderableColumn, options.horizontalSnap);
    }
    if (isFunction$1(callback)) {
      if (isScrolled) {
        this.view.render();
      } else {
        this.removeHook("afterScroll", callback);
        this._registerMicrotask(() => callback());
      }
    }
    return isScrolled;
  };
  this.scrollToFocusedCell = function(callback) {
    if (!instance.selection.isSelected()) {
      return false;
    }
    if (isFunction$1(callback)) {
      instance.addHookOnce("afterScroll", callback);
    }
    const { highlight } = instance.getSelectedRangeActive();
    const isScrolled = instance.scrollViewportTo(highlight.toObject());
    if (isScrolled) {
      instance.view.render();
    } else if (isFunction$1(callback)) {
      instance.removeHook("afterScroll", callback);
      instance._registerMicrotask(() => callback());
    }
    return isScrolled;
  };
  this.destroy = function() {
    instance._clearTimeouts();
    instance._clearMicrotasks();
    if (instance.view) {
      instance.view.destroy();
    }
    if (dataSource) {
      dataSource.destroy();
    }
    dataSource = null;
    if (isRootInstance(this)) {
      uninstall();
      this.getFocusScopeManager().destroy();
      layoutManager?.destroy();
      instance.themeManager?.destroy();
    }
    this.getShortcutManager().destroy();
    moduleRegisterer.clear();
    metaManager.clearCache();
    foreignHotInstances.delete(this.guid);
    eventManager.destroy();
    if (editorManager) {
      editorManager.destroy();
    }
    if (instance.rootContainer) {
      empty$1(instance.rootContainer);
    }
    if (instance.rootPortalElement) {
      instance.rootPortalElement.remove();
    }
    instance.batchExecution(() => {
      instance.rowIndexMapper.destroy();
      instance.columnIndexMapper.destroy();
      pluginsRegistry.getItems().forEach(([, plugin]) => {
        plugin.destroy();
      });
      pluginsRegistry.clear();
      instance.runHooks("afterDestroy");
    }, true);
    Hooks.getSingleton().destroy(instance);
    objectEach(instance, (property, key, obj) => {
      if (isFunction$1(property)) {
        obj[key] = postMortem2(key);
      } else if (key !== "guid") {
        obj[key] = null;
      }
    });
    instance.isDestroyed = true;
    if (datamap) {
      datamap.destroy();
    }
    datamap = null;
    grid = null;
    selection = null;
    editorManager = null;
    instance = null;
  };
  function postMortem2(method) {
    return () => {
      throwWithCause(`The "${method}" method cannot be called because this Handsontable instance has been destroyed`);
    };
  }
  this.getActiveEditor = function() {
    return editorManager?.getActiveEditor();
  };
  this.getFirstRenderedVisibleRow = function() {
    return instance.view.getFirstRenderedVisibleRow();
  };
  this.getLastRenderedVisibleRow = function() {
    return instance.view.getLastRenderedVisibleRow();
  };
  this.getFirstRenderedVisibleColumn = function() {
    return instance.view.getFirstRenderedVisibleColumn();
  };
  this.getLastRenderedVisibleColumn = function() {
    return instance.view.getLastRenderedVisibleColumn();
  };
  this.getFirstFullyVisibleRow = function() {
    return instance.view.getFirstFullyVisibleRow();
  };
  this.getLastFullyVisibleRow = function() {
    return instance.view.getLastFullyVisibleRow();
  };
  this.getFirstFullyVisibleColumn = function() {
    return instance.view.getFirstFullyVisibleColumn();
  };
  this.getLastFullyVisibleColumn = function() {
    return instance.view.getLastFullyVisibleColumn();
  };
  this.getFirstPartiallyVisibleRow = function() {
    return instance.view.getFirstPartiallyVisibleRow();
  };
  this.getLastPartiallyVisibleRow = function() {
    return instance.view.getLastPartiallyVisibleRow();
  };
  this.getFirstPartiallyVisibleColumn = function() {
    return instance.view.getFirstPartiallyVisibleColumn();
  };
  this.getLastPartiallyVisibleColumn = function() {
    return instance.view.getLastPartiallyVisibleColumn();
  };
  this.getPlugin = function(pluginName) {
    return pluginsRegistry.getItem(toUpperCaseFirst(pluginName));
  };
  this.getPluginName = function(plugin) {
    return pluginsRegistry.getId(plugin);
  };
  this.getInstance = function() {
    return instance;
  };
  this.addHook = function(key, callback, orderIndex) {
    Hooks.getSingleton().add(key, callback, instance, orderIndex);
  };
  this.hasHook = function(key) {
    return Hooks.getSingleton().has(key, instance) || Hooks.getSingleton().has(key);
  };
  this.addHookOnce = function(key, callback, orderIndex) {
    Hooks.getSingleton().once(key, callback, instance, orderIndex);
  };
  this.removeHook = function(key, callback) {
    Hooks.getSingleton().remove(key, callback, instance);
  };
  this.runHooks = function(key, p1, p2, p3, p4, p5, p6) {
    return Hooks.getSingleton().run(instance, key, p1, p2, p3, p4, p5, p6);
  };
  this.getTranslatedPhrase = function(dictionaryKey, extraArguments) {
    return getTranslatedPhrase(tableMeta.language, dictionaryKey, extraArguments);
  };
  this.toHTML = () => instanceToHTML(this);
  this.toTableElement = () => {
    const rootDocument = instance.rootDocument;
    const tempElement = rootDocument.createElement("div");
    tempElement.insertAdjacentHTML("afterbegin", instanceToHTML(instance));
    return tempElement.firstElementChild;
  };
  this.timeouts = [];
  this.useTheme = (themeName2) => {
    const isFirstRun = !!firstRun;
    this.stylesHandler.useTheme(themeName2 ?? void 0);
    const validThemeName = this.stylesHandler.getThemeName();
    if (!isFirstRun && validThemeName) {
      if (getThemeClassName(this.rootContainer)) {
        removeClass(this.rootContainer, /ht-theme-.*/g);
        addClass(this.rootContainer, validThemeName);
      }
      instance.render();
      instance.scrollViewportTo(0, 0);
    }
    this.runHooks("afterSetTheme", validThemeName, isFirstRun);
  };
  this.getCurrentThemeName = () => {
    return instance.stylesHandler.getThemeName() ?? null;
  };
  this.getTableHeight = () => {
    return instance.rootElement.offsetHeight;
  };
  this.getTableWidth = () => {
    return instance.rootElement.offsetWidth;
  };
  this._registerTimeout = function(handle, delay = 0) {
    let handleFunc = handle;
    if (typeof handleFunc === "function") {
      handleFunc = setTimeout(handleFunc, delay);
    }
    this.timeouts.push(handleFunc);
    return handleFunc;
  };
  this._clearTimeouts = function() {
    arrayEach(this.timeouts, (handler) => {
      clearTimeout(handler);
    });
  };
  this.microtasks = [];
  this._registerMicrotask = function(callback) {
    const entry = {
      cancelled: false
    };
    this.microtasks.push(entry);
    this.rootWindow.queueMicrotask(() => {
      if (!entry.cancelled) {
        callback();
      }
    });
  };
  this._clearMicrotasks = function() {
    arrayEach(this.microtasks, (entry) => {
      entry.cancelled = true;
    });
    this.microtasks.length = 0;
  };
  this._getEditorManager = function() {
    return editorManager;
  };
  this._getDataSource = function() {
    return dataSource;
  };
  this._getMetaManager = function() {
    return metaManager;
  };
  const shortcutManager = createShortcutManager({
    handleEvent(_event, scope) {
      if (scope === "global") {
        return true;
      }
      return instance.isListening();
    },
    beforeKeyDown: (event) => {
      return instance.runHooks("beforeKeyDown", event);
    },
    afterKeyDown: (event) => {
      if (this.isDestroyed) {
        return;
      }
      instance.runHooks("afterDocumentKeyDown", event);
    },
    ownerWindow: this.rootWindow
  });
  this.addHook("beforeOnCellMouseDown", (event) => {
    if (event.ctrlKey === false && event.metaKey === false) {
      shortcutManager.releasePressedKeys();
    }
  });
  this.getShortcutManager = function() {
    return shortcutManager;
  };
  focusGridManager = new FocusGridManager(instance);
  const focusScopeManager = isRootInstance(this) ? createFocusScopeManager(instance) : null;
  const layoutManager = isRootInstance(this) ? new LayoutManager({
    top: instance.rootSlotTopElement,
    bottom: instance.rootSlotBottomElement
  }) : null;
  this.getFocusManager = function() {
    return focusGridManager;
  };
  this.getFocusScopeManager = function() {
    if (!isRootInstance(instance)) {
      throwWithCause("The FocusScopeManager is only available for the main Handsontable instance.");
    }
    return focusScopeManager;
  };
  this.getLayoutManager = function() {
    if (!isRootInstance(instance)) {
      throwWithCause("The LayoutManager is only available for the main Handsontable instance.");
    }
    return layoutManager;
  };
  const theme = mergedUserSettings.theme;
  const themeName = mergedUserSettings.themeName;
  const rootContainerThemeClassName = getThemeClassName(instance.rootContainer);
  if (isRootInstance(instance) && !rootContainerThemeClassName && (isObject$1(theme) || !theme && !themeName)) {
    initializeThemeManager(theme);
  }
  getPluginsNames().forEach((pluginName) => {
    const PluginClass = getPlugin(pluginName);
    if (PluginClass) {
      pluginsRegistry.addItem(pluginName, new PluginClass(this));
    }
  });
  registerAllShortcutContexts(instance);
  if (isRootInstance(this)) {
    registerAllFocusScopes(instance);
  }
  shortcutManager.setActiveContextName("grid");
  Hooks.getSingleton().run(instance, "construct");
}
const RENDERER_TYPE$e = "base";
const TEXT_ELLIPSIS_CLASS_NAME = "htTextEllipsis";
function baseRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  const ariaEnabled = cellProperties.ariaTags;
  const classesToAdd = [];
  const classesToRemove = [];
  const attributesToRemove = [];
  const attributesToAdd = [];
  cellProperties._isBaseRendererCalled = true;
  if (cellProperties.className) {
    addClass(TD, cellProperties.className);
  }
  if (cellProperties.readOnly) {
    classesToAdd.push(cellProperties.readOnlyCellClassName);
    if (ariaEnabled) {
      attributesToAdd.push(A11Y_READONLY());
    }
  } else if (ariaEnabled) {
    attributesToRemove.push(A11Y_READONLY()[0]);
  }
  if (cellProperties.valid === false && cellProperties.invalidCellClassName) {
    classesToAdd.push(cellProperties.invalidCellClassName);
    if (ariaEnabled) {
      attributesToAdd.push(A11Y_INVALID());
    }
  } else {
    classesToRemove.push(cellProperties.invalidCellClassName);
    if (ariaEnabled) {
      attributesToRemove.push(A11Y_INVALID()[0]);
    }
  }
  if (cellProperties.wordWrap === false && cellProperties.noWordWrapClassName) {
    classesToAdd.push(cellProperties.noWordWrapClassName);
  }
  if (isEmpty$1(value) && cellProperties.placeholder) {
    classesToAdd.push(cellProperties.placeholderCellClassName);
  }
  if (cellProperties.textEllipsis) {
    classesToAdd.push(TEXT_ELLIPSIS_CLASS_NAME);
  }
  removeClass(TD, classesToRemove);
  addClass(TD, classesToAdd);
  removeAttribute(TD, attributesToRemove);
  setAttribute(TD, attributesToAdd);
}
baseRenderer.RENDERER_TYPE = RENDERER_TYPE$e;
function observe(element, eventName, handler) {
  element.addEventListener(eventName, handler, false);
}
function unObserve(element, eventName, handler) {
  element.removeEventListener(eventName, handler, false);
}
function getComputedStyle$1(element) {
  return element.ownerDocument.defaultView.getComputedStyle(element);
}
function createInputElementResizer(ownerDocument, initialOptions = {}) {
  const defaults2 = {
    minHeight: 200,
    maxHeight: 300,
    minWidth: 100,
    maxWidth: 300,
    textContent: (element) => element.value,
    ...initialOptions
  };
  const body = ownerDocument.body;
  const textHolder = ownerDocument.createTextNode("");
  const textContainer = ownerDocument.createElement("span");
  let observedElement;
  function resize() {
    textHolder.textContent = defaults2.textContent(observedElement);
    textContainer.style.position = "absolute";
    textContainer.style.fontSize = getComputedStyle$1(observedElement).fontSize;
    textContainer.style.fontFamily = getComputedStyle$1(observedElement).fontFamily;
    textContainer.style.whiteSpace = "pre";
    body.appendChild(textContainer);
    const paddingStart = Number.parseInt(getComputedStyle$1(observedElement)?.paddingInlineStart || "0", 10);
    const paddingEnd = Number.parseInt(getComputedStyle$1(observedElement)?.paddingInlineEnd || "0", 10);
    const width = textContainer.clientWidth + paddingStart + paddingEnd + 1;
    body.removeChild(textContainer);
    const elementStyle = observedElement.style;
    elementStyle.height = `${defaults2.minHeight}px`;
    if (defaults2.minWidth > width) {
      elementStyle.width = `${defaults2.minWidth}px`;
    } else if (width > defaults2.maxWidth) {
      elementStyle.width = `${defaults2.maxWidth}px`;
    } else {
      elementStyle.width = `${width}px`;
    }
    const scrollHeight = observedElement.scrollHeight ? observedElement.scrollHeight - 1 : 0;
    if (defaults2.minHeight > scrollHeight) {
      elementStyle.height = `${defaults2.minHeight}px`;
    } else if (defaults2.maxHeight < scrollHeight) {
      elementStyle.height = `${defaults2.maxHeight}px`;
      elementStyle.overflowY = "visible";
    } else {
      elementStyle.height = `${scrollHeight}px`;
    }
  }
  function delayedResize() {
    ownerDocument.defaultView.setTimeout(resize, 0);
  }
  function resolveDimensionValue(configValue, inheritValue) {
    if (configValue === "inherit") {
      return inheritValue;
    }
    const parsed = Number.parseInt(String(configValue), 10);
    if (!isNaN(parsed)) {
      return parsed;
    }
    return void 0;
  }
  function extendDefaults(config) {
    if (config && config.minHeight) {
      const value = resolveDimensionValue(config.minHeight, observedElement.clientHeight);
      if (value !== void 0) {
        defaults2.minHeight = value;
      }
    }
    if (config && config.maxHeight) {
      const value = resolveDimensionValue(config.maxHeight, observedElement.clientHeight);
      if (value !== void 0) {
        defaults2.maxHeight = value;
      }
    }
    if (config && config.minWidth) {
      const value = resolveDimensionValue(config.minWidth, observedElement.clientWidth);
      if (value !== void 0) {
        defaults2.minWidth = value;
      }
    }
    if (config && config.maxWidth) {
      const value = resolveDimensionValue(config.maxWidth, observedElement.clientWidth);
      if (value !== void 0) {
        defaults2.maxWidth = value;
      }
    }
    if (!textContainer.firstChild) {
      textContainer.className = "autoResize";
      textContainer.style.display = "inline-block";
      textContainer.appendChild(textHolder);
    }
  }
  function init(elementToObserve, config, doObserve = false) {
    observedElement = elementToObserve;
    extendDefaults(config);
    if (observedElement.nodeName === "TEXTAREA") {
      observedElement.style.resize = "none";
      observedElement.style.height = `${defaults2.minHeight}px`;
      observedElement.style.minWidth = `${defaults2.minWidth}px`;
      observedElement.style.maxWidth = `${defaults2.maxWidth}px`;
      observedElement.style.overflowY = "hidden";
    }
    if (doObserve) {
      observe(observedElement, "input", resize);
      observe(observedElement, "keydown", delayedResize);
    }
    resize();
  }
  return {
    init,
    resize,
    unObserve() {
      unObserve(observedElement, "input", resize);
      unObserve(observedElement, "keydown", delayedResize);
    }
  };
}
function updateCaretPosition(actionName, textareaElement) {
  const caretPosition = getCaretPosition(textareaElement);
  const textLines = textareaElement.value.split("\n");
  let newCaretPosition = caretPosition;
  let lineStartIndex = 0;
  for (let i = 0; i < textLines.length; i++) {
    const textLine = textLines[i];
    if (i !== 0) {
      lineStartIndex += textLines[i - 1].length + 1;
    }
    const lineEndIndex = lineStartIndex + textLine.length;
    if (actionName === "home") {
      newCaretPosition = lineStartIndex;
    } else if (actionName === "end") {
      newCaretPosition = lineEndIndex;
    }
    if (caretPosition <= lineEndIndex) {
      break;
    }
  }
  setCaretPosition(textareaElement, newCaretPosition, newCaretPosition);
}
const EDITOR_VISIBLE_CLASS_NAME$2 = "ht_editor_visible";
const EDITOR_HIDDEN_CLASS_NAME = "ht_editor_hidden";
const SHORTCUTS_GROUP$i = "textEditor";
const EDITOR_TYPE$c = "text";
class TextEditor extends BaseEditor {
  /**
  * Returns the unique editor type identifier for the text editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$c;
  }
  /**
  * Gets current value from editable element.
  *
  * @returns {number}
  */
  getValue() {
    return this.TEXTAREA.value;
  }
  /**
  * Sets new value into editable element.
  *
  * @param {*} newValue The editor value.
  */
  setValue(newValue) {
    this.TEXTAREA.value = newValue;
  }
  /**
  * Opens the editor and adjust its size.
  */
  open() {
    this._opened = true;
    this.refreshDimensions();
    this.showEditableElement();
    this.hot.getShortcutManager().setActiveContextName("editor");
    this.registerShortcuts();
  }
  /**
  * Closes the editor.
  */
  close() {
    this._opened = false;
    this.autoResize.unObserve();
    if (isInternalElement(this.hot.rootDocument.activeElement, this.hot.rootElement)) {
      this.hot.listen();
    }
    this.hideEditableElement();
    this.unregisterShortcuts();
  }
  /**
  * Prepares editor's meta data.
  *
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number|string} prop The column property (passed when datasource is an array of objects).
  * @param {HTMLTableCellElement} td The rendered cell element.
  * @param {*} value The rendered value.
  * @param {object} cellProperties The cell meta object (see {@link Core#getCellMeta}).
  */
  prepare(row, col, prop, td, value, cellProperties) {
    const previousState = this.state;
    super.prepare(row, col, prop, td, value, cellProperties);
    if (!cellProperties.readOnly) {
      this.refreshDimensions(true);
      const { allowInvalid } = cellProperties;
      if (allowInvalid && !this.isOpened()) {
        this.TEXTAREA.value = "";
      }
      if (previousState !== EDITOR_STATE.FINISHED && !this.isOpened()) {
        this.hideEditableElement();
      }
    }
  }
  /**
  * Begins editing on a highlighted cell and hides fillHandle corner if was present.
  *
  * @param {*} newInitialValue The editor initial value.
  * @param {Event} event The keyboard event object.
  */
  beginEditing(newInitialValue, event) {
    if (this.state !== EDITOR_STATE.VIRGIN) {
      return;
    }
    this.TEXTAREA.value = "";
    super.beginEditing(newInitialValue, event);
  }
  /**
  * Sets focus state on the select element.
  */
  focus() {
    this.TEXTAREA.select();
    setCaretPosition(this.TEXTAREA, this.TEXTAREA.value.length, this.TEXTAREA.value.length);
  }
  /**
  * Creates an editor's elements and adds necessary CSS classnames.
  *
  * @param {string} type The type of the element to create.
  */
  createElements(type = "textarea") {
    const { rootDocument } = this.hot;
    this.TEXTAREA = rootDocument.createElement(type);
    setAttribute(this.TEXTAREA, [
      [
        "data-hot-input",
        ""
      ],
      A11Y_TABINDEX(-1)
    ]);
    addClass(this.TEXTAREA, "handsontableInput");
    this.textareaStyle = this.TEXTAREA.style;
    this.textareaStyle.width = "0";
    this.textareaStyle.height = "0";
    this.textareaStyle.overflowY = "visible";
    this.TEXTAREA_PARENT = rootDocument.createElement("DIV");
    addClass(this.TEXTAREA_PARENT, "handsontableInputHolder");
    if (hasClass(this.TEXTAREA_PARENT, this.layerClass)) {
      removeClass(this.TEXTAREA_PARENT, this.layerClass);
    }
    addClass(this.TEXTAREA_PARENT, EDITOR_HIDDEN_CLASS_NAME);
    this.textareaParentStyle = this.TEXTAREA_PARENT.style;
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA);
    this.hot.rootElement.appendChild(this.TEXTAREA_PARENT);
  }
  /**
  * Moves an editable element out of the viewport, but element must be able to hold focus for IME support.
  *
  * @private
  */
  hideEditableElement() {
    if (isEdge()) {
      this.textareaStyle.textIndent = "-99999px";
    }
    this.textareaStyle.overflowY = "visible";
    this.textareaParentStyle.opacity = "0";
    this.textareaParentStyle.height = "1px";
    removeClass(this.TEXTAREA_PARENT, this.layerClass);
    addClass(this.TEXTAREA_PARENT, EDITOR_HIDDEN_CLASS_NAME);
  }
  /**
  * Resets an editable element position.
  *
  * @private
  */
  showEditableElement() {
    this.textareaParentStyle.height = "";
    this.textareaParentStyle.overflow = "";
    this.textareaParentStyle.position = "";
    this.textareaParentStyle[this.hot.isRtl() ? "left" : "right"] = "auto";
    this.textareaParentStyle.opacity = "1";
    this.textareaStyle.textIndent = "";
    const childNodes = this.TEXTAREA_PARENT.childNodes;
    let hasClassHandsontableEditor = false;
    rangeEach(childNodes.length - 1, (index2) => {
      const childNode = childNodes[index2];
      if (hasClass(childNode, "handsontableEditor")) {
        hasClassHandsontableEditor = true;
        return false;
      }
    });
    if (hasClass(this.TEXTAREA_PARENT, EDITOR_HIDDEN_CLASS_NAME)) {
      removeClass(this.TEXTAREA_PARENT, EDITOR_HIDDEN_CLASS_NAME);
    }
    if (hasClassHandsontableEditor) {
      this.layerClass = EDITOR_VISIBLE_CLASS_NAME$2;
      addClass(this.TEXTAREA_PARENT, this.layerClass);
    } else {
      this.layerClass = this.getEditedCellsLayerClass();
      addClass(this.TEXTAREA_PARENT, this.layerClass);
    }
  }
  /**
  * Refreshes editor's value using source data.
  *
  * @private
  */
  refreshValue() {
    const physicalRow = this.hot.toPhysicalRow(this.row);
    const sourceData = this.hot.getSourceDataAtCell(physicalRow, this.col);
    this.originalValue = sourceData;
    this.setValue(sourceData);
    this.refreshDimensions();
  }
  /**
  * Refreshes editor's size and position.
  *
  * @private
  * @param {boolean} force Indicates if the refreshing editor dimensions should be triggered.
  */
  refreshDimensions(force = false) {
    if (this.state !== EDITOR_STATE.EDITING && !force) {
      return;
    }
    this.TD = this.getEditedCell();
    if (!this.TD) {
      if (!force) {
        this.close();
      }
      return;
    }
    const cellRect = this.getEditedCellRect();
    if (!cellRect) {
      return;
    }
    const { top: top2, start, width, maxWidth, height, maxHeight } = cellRect;
    this.textareaParentStyle.top = `${top2}px`;
    this.textareaParentStyle[this.hot.isRtl() ? "right" : "left"] = `${start}px`;
    this.showEditableElement();
    const cellComputedStyle = this.hot.rootWindow.getComputedStyle(this.TD);
    this.TEXTAREA.style.fontSize = cellComputedStyle.fontSize;
    this.TEXTAREA.style.fontFamily = cellComputedStyle.fontFamily;
    this.TEXTAREA.style.backgroundColor = this.TD.style.backgroundColor;
    this.autoResize.init(this.TEXTAREA, {
      minWidth: Math.min(width, maxWidth),
      minHeight: Math.min(height, maxHeight),
      // TEXTAREA should never be wider than visible part of the viewport (should not cover the scrollbar)
      maxWidth,
      maxHeight
    }, true);
  }
  /**
  * Binds events and hooks.
  *
  * @private
  */
  bindEvents() {
    if (isIOS()) {
      this.eventManager.addEventListener(this.TEXTAREA, "focusout", () => this.finishEditing(false));
    }
    this.addHook("afterScrollHorizontally", () => this.refreshDimensions());
    this.addHook("afterScrollVertically", () => this.refreshDimensions());
    this.addHook("afterColumnResize", () => {
      this.refreshDimensions();
      if (this.state === EDITOR_STATE.EDITING) {
        this.focus();
      }
    });
    this.addHook("afterRowResize", () => {
      this.refreshDimensions();
      if (this.state === EDITOR_STATE.EDITING) {
        this.focus();
      }
    });
  }
  /**
  * Destroys the internal event manager and clears attached hooks.
  *
  * @private
  */
  destroy() {
    this.eventManager.destroy();
    this.clearHooks();
  }
  /**
  * Register shortcuts responsible for handling editor.
  *
  * @private
  */
  registerShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const editorContext = shortcutManager.getContext("editor");
    const contextConfig = {
      runOnlyIf: () => isDefined(this.hot.getSelected()),
      group: SHORTCUTS_GROUP$i
    };
    const insertNewLine = () => {
      this.hot.rootDocument.execCommand("insertText", false, "\n");
    };
    editorContext.addShortcuts([
      {
        keys: [
          [
            "Control",
            "Enter"
          ]
        ],
        callback: () => {
          insertNewLine();
          return false;
        },
        runOnlyIf: (event) => !this.hot.selection.isMultiple() && // We trigger a data population for multiple selection.
        // catch CTRL but not right ALT (which in some systems triggers ALT+CTRL)
        !event?.altKey
      },
      {
        keys: [
          [
            "Meta",
            "Enter"
          ]
        ],
        callback: () => {
          insertNewLine();
          return false;
        },
        runOnlyIf: () => !this.hot.selection.isMultiple()
      },
      {
        keys: [
          [
            "Alt",
            "Enter"
          ]
        ],
        callback: () => {
          insertNewLine();
          return false;
        }
      },
      {
        keys: [
          [
            "Home"
          ]
        ],
        callback: (_event, keys2) => {
          updateCaretPosition(keys2?.[0] ?? "", this.TEXTAREA);
        }
      },
      {
        keys: [
          [
            "End"
          ]
        ],
        callback: (_event, keys2) => {
          updateCaretPosition(keys2?.[0] ?? "", this.TEXTAREA);
        }
      }
    ], contextConfig);
  }
  /**
  * Unregister shortcuts responsible for handling editor.
  *
  * @private
  */
  unregisterShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const editorContext = shortcutManager.getContext("editor");
    editorContext.removeShortcutsByGroup(SHORTCUTS_GROUP$i);
  }
  /**
  * @param {Core} hotInstance The Handsontable instance.
  */
  constructor(hotInstance) {
    super(hotInstance), /**
    * Instance of {@link EventManager}.
    *
    * @private
    * @type {EventManager}
    */
    this.eventManager = new EventManager(this), /**
    * Autoresize instance. Automagically resizes editor after changes.
    *
    * @private
    * @type {Function}
    */
    this.autoResize = createInputElementResizer(this.hot.rootDocument);
    this.eventManager = new EventManager(this);
    this.createElements();
    this.bindEvents();
    this.hot.addHookOnce("afterDestroy", () => this.destroy());
  }
}
const RENDERER_TYPE$d = "text";
function textRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  let escaped = value;
  if (isEmpty$1(escaped) && cellProperties.placeholder) {
    escaped = cellProperties.placeholder;
  }
  const escapedStr = stringify$1(escaped);
  let finalStr = escapedStr;
  if (cellProperties.trimWhitespace) {
    finalStr = escapedStr.trim();
  }
  fastInnerText(TD, finalStr);
}
textRenderer.RENDERER_TYPE = RENDERER_TYPE$d;
const CELL_TYPE$c = "text";
const TextCellType = {
  CELL_TYPE: CELL_TYPE$c,
  editor: TextEditor,
  renderer: textRenderer
};
const CoreClass = Core;
_register(TextCellType);
_register$2(baseRenderer);
const Handsontable = function Handsontable2(rootElement, userSettings) {
  const instance = new CoreClass(rootElement, userSettings || {}, rootInstanceSymbol);
  instance.init();
  return instance;
};
Handsontable.editors = {
  BaseEditor,
  TextEditor
};
Handsontable.dom = {
  empty: empty$1
};
Handsontable.helper = {};
Handsontable.Core = function(rootElement, userSettings = {}) {
  return new CoreClass(rootElement, userSettings, rootInstanceSymbol);
};
Handsontable.DefaultSettings = metaSchemaFactory();
Handsontable.hooks = Hooks.getSingleton();
Handsontable.CellCoords = CellCoords;
Handsontable.CellRange = CellRange;
Handsontable.packageName = "handsontable";
Handsontable.buildDate = "30/06/2026 08:45:33";
Handsontable.version = "18.0.0";
Handsontable.languages = {
  dictionaryKeys,
  getLanguageDictionary,
  getLanguagesDictionaries,
  registerLanguageDictionary,
  getTranslatedPhrase
};
Handsontable.themes = {
  hasTheme,
  getTheme,
  getThemeNames,
  getThemes,
  registerTheme,
  reinitTheme
};
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n2 = Array(a); e < a; e++) n2[e] = r[e];
  return n2;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n2) {
  if (!(a instanceof n2)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n2[r] = t[r]);
    }
    return n2;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function() {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n2, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ;
      else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n2 = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n2;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n2.length; r++) o = n2[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n2 in r) if ({}.hasOwnProperty.call(r, n2)) {
    if (-1 !== e.indexOf(n2)) continue;
    t[n2] = r[n2];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var bulkComponentContainer = null;
var AUTOSIZE_WARNING = "Your `HotTable` configuration includes `autoRowSize`/`autoColumnSize` options, which are not compatible with  the component-based renderers`. Disable `autoRowSize` and `autoColumnSize` to prevent row and column misalignment.";
var OBSOLETE_HOTRENDERER_WARNING = "Providing a component-based renderer using `hot-renderer`-annotated component is no longer supported. Pass your component using `renderer` prop of the `HotTable` or `HotColumn` component instead.";
var OBSOLETE_HOTEDITOR_WARNING = "Providing a component-based editor using `hot-editor`-annotated component is no longer supported. Pass your component using `editor` prop of the `HotTable` or `HotColumn` component instead.";
var UNEXPECTED_HOTTABLE_CHILDREN_WARNING = "Unexpected children nodes found in HotTable component. Only HotColumn components are allowed.";
var UNEXPECTED_HOTCOLUMN_CHILDREN_WARNING = "Unexpected children nodes found in HotColumn component. HotColumn components do not support any children.";
var HOT_DESTROYED_WARNING = "The Handsontable instance bound to this component was destroyed and cannot be used properly.";
var DEFAULT_CLASSNAME = "hot-wrapper-editor-container";
function warn() {
  if (typeof console !== "undefined") {
    var _console;
    (_console = console).warn.apply(_console, arguments);
  }
}
function displayObsoleteRenderersEditorsWarning(children) {
  if (hasChildElementOfType(children, "hot-renderer")) {
    warn(OBSOLETE_HOTRENDERER_WARNING);
    return true;
  }
  if (hasChildElementOfType(children, "hot-editor")) {
    warn(OBSOLETE_HOTEDITOR_WARNING);
    return true;
  }
  return false;
}
function displayChildrenOfTypeWarning(children, Component) {
  var childrenArray = React__default.Children.toArray(children);
  if (childrenArray.some(function(child) {
    return child.type !== Component;
  })) {
    warn(UNEXPECTED_HOTTABLE_CHILDREN_WARNING);
    return true;
  }
  return false;
}
function displayAnyChildrenWarning(children) {
  var childrenArray = React__default.Children.toArray(children);
  if (childrenArray.length) {
    warn(UNEXPECTED_HOTCOLUMN_CHILDREN_WARNING);
    return true;
  }
  return false;
}
function hasChildElementOfType(children, type) {
  var childrenArray = React__default.Children.toArray(children);
  return childrenArray.some(function(child) {
    return child.props[type] !== void 0;
  });
}
function createEditorPortal(doc, Editor) {
  if (!doc || !Editor || typeof Editor === "boolean") {
    return null;
  }
  var editorElement = /* @__PURE__ */ React__default.createElement(Editor, null);
  var containerProps = getContainerAttributesProps({}, false);
  containerProps.className = "".concat(DEFAULT_CLASSNAME, " ").concat(containerProps.className);
  return /* @__PURE__ */ require$$2.createPortal(/* @__PURE__ */ React__default.createElement("div", containerProps, editorElement), doc.body);
}
function createPortal(rElement) {
  var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
  var portalKey = arguments.length > 2 ? arguments[2] : void 0;
  var cachedContainer = arguments.length > 3 ? arguments[3] : void 0;
  if (!ownerDocument) {
    ownerDocument = document;
  }
  var portalContainer = cachedContainer;
  if (!portalContainer) {
    if (!bulkComponentContainer) {
      bulkComponentContainer = ownerDocument.createDocumentFragment();
    }
    portalContainer = ownerDocument.createElement("DIV");
    bulkComponentContainer.appendChild(portalContainer);
  }
  return {
    portal: /* @__PURE__ */ require$$2.createPortal(rElement, portalContainer, portalKey),
    portalContainer
  };
}
function getContainerAttributesProps(props) {
  var randomizeId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return {
    id: props.id || (randomizeId ? "hot-" + Math.random().toString(36).substring(5) : void 0),
    className: props.className || "",
    style: props.style || {}
  };
}
function isCSR() {
  return typeof window !== "undefined";
}
function isObjectLike(value) {
  return _typeof(value) === "object" && value !== null;
}
function isPlainObject(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}
function isArray$1(value) {
  return Array.isArray(value);
}
function areEquivalentSettingsValue(previousValue, currentValue) {
  if (previousValue === currentValue) {
    return true;
  }
  if (previousValue instanceof RegExp || currentValue instanceof RegExp) {
    if (!(previousValue instanceof RegExp) || !(currentValue instanceof RegExp)) {
      return false;
    }
    return previousValue.source === currentValue.source && previousValue.flags === currentValue.flags;
  }
  if (isArray$1(previousValue) && isArray$1(currentValue)) {
    if (previousValue.length !== currentValue.length) {
      return false;
    }
    for (var index2 = 0; index2 < previousValue.length; index2++) {
      if (!areEquivalentSettingsValue(previousValue[index2], currentValue[index2])) {
        return false;
      }
    }
    return true;
  }
  if (isArray$1(previousValue) || isArray$1(currentValue)) {
    return false;
  }
  if (!isObjectLike(previousValue) || !isObjectLike(currentValue)) {
    return false;
  }
  if (!isPlainObject(previousValue) || !isPlainObject(currentValue)) {
    return false;
  }
  var previousKeys = Object.keys(previousValue);
  var currentKeys = Object.keys(currentValue);
  if (previousKeys.length !== currentKeys.length) {
    return false;
  }
  for (var _i = 0, _previousKeys = previousKeys; _i < _previousKeys.length; _i++) {
    var key = _previousKeys[_i];
    if (!Object.prototype.hasOwnProperty.call(currentValue, key)) {
      return false;
    }
    if (!areEquivalentSettingsValue(previousValue[key], currentValue[key])) {
      return false;
    }
  }
  return true;
}
function useUpdateEffect(effect, deps) {
  var notInitialRender = React__default.useRef(false);
  useEffect(function() {
    if (notInitialRender.current) {
      return effect();
    } else {
      notInitialRender.current = true;
    }
  }, deps);
}
var DEEP_COMPARABLE_SETTINGS = ["dataSchema", "columns"];
var SettingsMapper = /* @__PURE__ */ (function() {
  function SettingsMapper2() {
    _classCallCheck(this, SettingsMapper2);
  }
  return _createClass(SettingsMapper2, null, [{
    key: "getSettings",
    value: (
      /**
       * Parse component settings into Handsontable-compatible settings.
       *
       * @param {Object} properties Object containing properties from the HotTable object.
       * @param {Object} additionalSettings Additional settings.
       * @param {boolean} additionalSettings.isInit Flag determining whether the settings are being set during initialization.
       * @param {string[]} additionalSettings.initOnlySettingKeys Array of keys that can be set only during initialization.
       * @returns {Object} Handsontable-compatible settings object.
       */
      function getSettings(properties) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$prevProps = _ref.prevProps, prevProps = _ref$prevProps === void 0 ? {} : _ref$prevProps, _ref$isInit = _ref.isInit, isInit = _ref$isInit === void 0 ? false : _ref$isInit, _ref$initOnlySettingK = _ref.initOnlySettingKeys, initOnlySettingKeys = _ref$initOnlySettingK === void 0 ? [] : _ref$initOnlySettingK;
        var shouldSkipProp = function shouldSkipProp2(key2) {
          if (!isInit && DEEP_COMPARABLE_SETTINGS.includes(key2)) {
            return areEquivalentSettingsValue(prevProps[key2], properties[key2]);
          }
          if (!isInit && initOnlySettingKeys.includes(key2)) {
            return true;
          }
          return false;
        };
        var newSettings = {};
        for (var key in properties) {
          if (key !== "children" && !shouldSkipProp(key) && properties.hasOwnProperty(key)) {
            newSettings[key] = properties[key];
          }
        }
        return newSettings;
      }
    )
  }]);
})();
var HotTableContext = /* @__PURE__ */ createContext$1(void 0);
var HotTableContextProvider = function HotTableContextProvider2(_ref) {
  var children = _ref.children;
  var columnsSettings = useRef([]);
  var setHotColumnSettings = useCallback(function(columnSettings, columnIndex) {
    columnsSettings.current[columnIndex] = columnSettings;
  }, []);
  var trimColumnSettings = useCallback(function(length) {
    columnsSettings.current.length = length;
  }, []);
  var componentRendererColumns = useRef(/* @__PURE__ */ new Map());
  var renderedCellCache = useRef(/* @__PURE__ */ new Map());
  var clearRenderedCellCache = useCallback(function() {
    return renderedCellCache.current.clear();
  }, []);
  var portalCache = useRef(/* @__PURE__ */ new Map());
  var clearPortalCache = useCallback(function() {
    return portalCache.current.clear();
  }, []);
  var portalContainerCache = useRef(/* @__PURE__ */ new Map());
  var getRendererWrapper = useCallback(function(Renderer2) {
    return function __internalRenderer(instance, TD, row, col, prop, value, cellProperties) {
      var key = "".concat(row, "-").concat(col);
      var instanceGuid = instance.guid;
      var portalContainerKey = "".concat(instanceGuid, "-").concat(key);
      var portalKey = "".concat(key, "-").concat(instanceGuid);
      if (TD && !TD.getAttribute("ghost-table")) {
        var cachedPortalContainer = portalContainerCache.current.get(portalContainerKey);
        var containerInPlace = !!cachedPortalContainer && cachedPortalContainer.parentNode === TD;
        var rendererElement = /* @__PURE__ */ React__default.createElement(Renderer2, {
          instance,
          TD,
          row,
          col,
          prop,
          value,
          cellProperties
        });
        var _createPortal = createPortal(rendererElement, TD.ownerDocument, portalKey, cachedPortalContainer), portal = _createPortal.portal, portalContainer = _createPortal.portalContainer;
        if (!containerInPlace) {
          while (TD.firstChild) {
            TD.removeChild(TD.firstChild);
          }
          TD.appendChild(portalContainer);
        }
        portalContainerCache.current.set(portalContainerKey, portalContainer);
        portalCache.current.set(portalKey, portal);
      }
      renderedCellCache.current.set(key, TD);
      return TD;
    };
  }, []);
  var renderersPortalManager = useRef(function() {
    return void 0;
  });
  var setRenderersPortalManagerRef = useCallback(function(pmComponent) {
    renderersPortalManager.current = pmComponent;
  }, []);
  var pushCellPortalsIntoPortalManager = useCallback(function() {
    renderersPortalManager.current(_toConsumableArray(portalCache.current.values()));
  }, []);
  var contextImpl = useMemo(function() {
    return {
      componentRendererColumns: componentRendererColumns.current,
      columnsSettings: columnsSettings.current,
      emitColumnSettings: setHotColumnSettings,
      trimColumnSettings,
      getRendererWrapper,
      clearPortalCache,
      clearRenderedCellCache,
      setRenderersPortalManagerRef,
      pushCellPortalsIntoPortalManager
    };
  }, [setHotColumnSettings, trimColumnSettings, getRendererWrapper, clearRenderedCellCache, setRenderersPortalManagerRef, pushCellPortalsIntoPortalManager]);
  return /* @__PURE__ */ React__default.createElement(HotTableContext.Provider, {
    value: contextImpl
  }, children);
};
function useHotTableContext() {
  return useContext(HotTableContext);
}
var HotColumnContext = /* @__PURE__ */ createContext$1(void 0);
var HotColumnContextProvider = function HotColumnContextProvider2(_ref) {
  var columnIndex = _ref.columnIndex, getOwnerDocument = _ref.getOwnerDocument, children = _ref.children;
  var contextImpl = useMemo(function() {
    return {
      columnIndex,
      getOwnerDocument
    };
  }, [columnIndex, getOwnerDocument]);
  return /* @__PURE__ */ React__default.createElement(HotColumnContext.Provider, {
    value: contextImpl
  }, children);
};
var useHotColumnContext = function useHotColumnContext2() {
  return useContext(HotColumnContext);
};
var AbstractMethods = ["close", "focus", "open"];
var ExcludedMethods = ["getValue", "setValue"];
var MethodsMap = {
  open: "onOpen",
  close: "onClose",
  prepare: "onPrepare",
  focus: "onFocus"
};
function makeEditorClass(hooksRef, instanceRef) {
  return /* @__PURE__ */ (function(_Handsontable$editors) {
    function CustomEditor(hotInstance) {
      var _this;
      _classCallCheck(this, CustomEditor);
      _this = _callSuper(this, CustomEditor, [hotInstance]);
      instanceRef.current = _this;
      Object.getOwnPropertyNames(Handsontable.editors.BaseEditor.prototype).forEach(function(propName) {
        if (propName === "constructor" || ExcludedMethods.includes(propName)) {
          return;
        }
        var baseMethod = Handsontable.editors.BaseEditor.prototype[propName];
        CustomEditor.prototype[propName] = (function() {
          var _hooksRef$current;
          var result;
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (!AbstractMethods.includes(propName)) {
            var _ref;
            result = (_ref = baseMethod).call.apply(_ref, [this].concat(args));
          }
          if (MethodsMap[propName] && (_hooksRef$current = hooksRef.current) !== null && _hooksRef$current !== void 0 && _hooksRef$current[MethodsMap[propName]]) {
            var _ref2;
            result = (_ref2 = hooksRef.current[MethodsMap[propName]]).call.apply(_ref2, [this].concat(args));
          }
          return result;
        }).bind(_this);
      });
      return _this;
    }
    _inherits(CustomEditor, _Handsontable$editors);
    return _createClass(CustomEditor, [{
      key: "focus",
      value: function focus() {
      }
    }, {
      key: "getValue",
      value: function getValue() {
        return this.value;
      }
    }, {
      key: "setValue",
      value: function setValue(newValue) {
        this.value = newValue;
      }
    }, {
      key: "open",
      value: function open() {
      }
    }, {
      key: "close",
      value: function close() {
      }
    }]);
  })(Handsontable.editors.BaseEditor);
}
var EditorContext = /* @__PURE__ */ createContext$1(void 0);
var EditorContextProvider = function EditorContextProvider2(_ref3) {
  var hooksRef = _ref3.hooksRef, hotCustomEditorInstanceRef = _ref3.hotCustomEditorInstanceRef, children = _ref3.children;
  return /* @__PURE__ */ React__default.createElement(EditorContext.Provider, {
    value: {
      hooksRef,
      hotCustomEditorInstanceRef
    }
  }, children);
};
var isHotColumn = function isHotColumn2(childNode) {
  return childNode.type === HotColumn;
};
var internalProps = ["_columnIndex", "_getOwnerDocument", "children"];
var HotColumn = function HotColumn2(props) {
  var _useHotTableContext = useHotTableContext(), componentRendererColumns = _useHotTableContext.componentRendererColumns, emitColumnSettings = _useHotTableContext.emitColumnSettings, getRendererWrapper = _useHotTableContext.getRendererWrapper;
  var _useHotColumnContext = useHotColumnContext(), columnIndex = _useHotColumnContext.columnIndex, getOwnerDocument = _useHotColumnContext.getOwnerDocument;
  var localEditorHooksRef = useRef(null);
  var localEditorClassInstance = useRef(null);
  useEffect(function() {
    var getSettingsProps = function getSettingsProps2() {
      return Object.keys(props).filter(function(key) {
        return !internalProps.includes(key);
      }).reduce(function(obj, key) {
        obj[key] = props[key];
        return obj;
      }, {});
    };
    var createColumnSettings = function createColumnSettings2() {
      var columnSettings2 = SettingsMapper.getSettings(getSettingsProps());
      if (props.renderer) {
        columnSettings2.renderer = getRendererWrapper(props.renderer);
        componentRendererColumns.set(columnIndex, true);
      } else if (props.hotRenderer) {
        columnSettings2.renderer = props.hotRenderer;
      }
      if (props.editor) {
        columnSettings2.editor = makeEditorClass(localEditorHooksRef, localEditorClassInstance);
      } else if (props.hotEditor) {
        columnSettings2.editor = props.hotEditor;
      }
      return columnSettings2;
    };
    var columnSettings = createColumnSettings();
    emitColumnSettings(columnSettings, columnIndex);
    if (!displayObsoleteRenderersEditorsWarning(props.children)) {
      displayAnyChildrenWarning(props.children);
    }
  });
  var editorPortal = createEditorPortal(getOwnerDocument(), props.editor);
  return /* @__PURE__ */ React__default.createElement(EditorContextProvider, {
    hooksRef: localEditorHooksRef,
    hotCustomEditorInstanceRef: localEditorClassInstance
  }, editorPortal);
};
var version = "18.0.0";
var RenderersPortalManager = /* @__PURE__ */ forwardRef(function(_, ref) {
  var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), portals = _useState2[0], setPortals = _useState2[1];
  useImperativeHandle(ref, function() {
    return setPortals;
  });
  return /* @__PURE__ */ React__default.createElement(Fragment, null, portals);
});
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol["for"], c = b ? Symbol["for"]("react.element") : 60103, d = b ? Symbol["for"]("react.portal") : 60106, e = b ? Symbol["for"]("react.fragment") : 60107, f = b ? Symbol["for"]("react.strict_mode") : 60108, g = b ? Symbol["for"]("react.profiler") : 60114, h = b ? Symbol["for"]("react.provider") : 60109, k = b ? Symbol["for"]("react.context") : 60110, l = b ? Symbol["for"]("react.async_mode") : 60111, m = b ? Symbol["for"]("react.concurrent_mode") : 60111, n2 = b ? Symbol["for"]("react.forward_ref") : 60112, p = b ? Symbol["for"]("react.suspense") : 60113, q = b ? Symbol["for"]("react.suspense_list") : 60120, r = b ? Symbol["for"]("react.memo") : 60115, t = b ? Symbol["for"]("react.lazy") : 60116, v = b ? Symbol["for"]("react.block") : 60121, w = b ? Symbol["for"]("react.fundamental") : 60117, x = b ? Symbol["for"]("react.responder") : 60118, y = b ? Symbol["for"]("react.scope") : 60119;
  function z(a) {
    if ("object" === _typeof(a) && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n2:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === _typeof(a) && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n2;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n2 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (_typeof(object) === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return _typeof(object) === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$1;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has$1;
  hasRequiredHas = 1;
  has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$1;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function printWarning2() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function printWarning2(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location2, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error((componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(typeSpecs[typeSpecName]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning((componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + _typeof(error2) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning("Failed " + location2 + " type: " + error2.message + (stack != null ? stack : ""));
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs2 = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function printWarning2() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function printWarning2(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function factoryWithTypeCheckers2(isValidElement, throwOnDirectAccess2) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && _typeof(data) === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate2) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess2) {
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate2(props, propName, componentName, location2, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate2(props, propName, componentName, location2, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
            expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate2(props, propName, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error2 = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeChecker() {
      function validate2(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeTypeChecker() {
      function validate2(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        if (!ReactIs2.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate2(props, propName, componentName, location2, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate2(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer2(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate2(props, propName, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate2(props, propName, componentName, location2, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createNodeChecker() {
      function validate2(props, propName, componentName, location2, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function invalidValidatorError(componentName, location2, propFullName, key, type) {
      return new PropTypeError((componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate2(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate2(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function isNode(propValue) {
      switch (_typeof(propValue)) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = _typeof(propValue);
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function factoryWithThrowingShims2() {
    function shim(props, propName, componentName, location2, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var HotTableInner = /* @__PURE__ */ forwardRef(function(props, ref) {
  var __hotInstance = useRef(null);
  var hotElementRef = useRef(null);
  var globalEditorHooksRef = useRef(null);
  var globalEditorClassInstance = useRef(null);
  var prevProps = useRef();
  var context = useHotTableContext();
  var getHotInstance = useCallback(function() {
    if (!__hotInstance.current || !__hotInstance.current.isDestroyed) {
      return __hotInstance.current;
    } else {
      console.warn(HOT_DESTROYED_WARNING);
      return null;
    }
  }, [__hotInstance]);
  var isHotInstanceDestroyed = useCallback(function() {
    return !__hotInstance.current || __hotInstance.current.isDestroyed;
  }, [__hotInstance]);
  var clearCache = useCallback(function() {
    context.clearRenderedCellCache();
    context.componentRendererColumns.clear();
  }, [context]);
  var getOwnerDocument = useCallback(function() {
    if (isCSR()) {
      return hotElementRef.current ? hotElementRef.current.ownerDocument : document;
    }
    return null;
  }, [hotElementRef]);
  var createNewGlobalSettings = function createNewGlobalSettings2() {
    var _getHotInstance;
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var prevProps2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var initOnlySettingKeys = !isHotInstanceDestroyed() ? (
      // Needed for React's double-rendering.
      ((_getHotInstance = getHotInstance()) === null || _getHotInstance === void 0 || (_getHotInstance = _getHotInstance.getSettings()) === null || _getHotInstance === void 0 ? void 0 : _getHotInstance._initOnlySettings) || []
    ) : [];
    var newSettings = SettingsMapper.getSettings(props, {
      prevProps: prevProps2,
      isInit: init,
      initOnlySettingKeys
    });
    if (context.columnsSettings.length) {
      newSettings.columns = context.columnsSettings;
    }
    if (props.renderer) {
      newSettings.renderer = context.getRendererWrapper(props.renderer);
      context.componentRendererColumns.set("global", true);
    } else {
      newSettings.renderer = props.hotRenderer || _getItem$2("text");
    }
    if (props.editor) {
      newSettings.editor = makeEditorClass(globalEditorHooksRef, globalEditorClassInstance);
    } else {
      newSettings.editor = props.hotEditor || _getItem$3("text");
    }
    return newSettings;
  };
  var displayAutoSizeWarning = function displayAutoSizeWarning2(hotInstance) {
    var _hotInstance$getPlugi, _hotInstance$getPlugi2;
    if (hotInstance && ((_hotInstance$getPlugi = hotInstance.getPlugin("autoRowSize")) !== null && _hotInstance$getPlugi !== void 0 && _hotInstance$getPlugi.enabled || (_hotInstance$getPlugi2 = hotInstance.getPlugin("autoColumnSize")) !== null && _hotInstance$getPlugi2 !== void 0 && _hotInstance$getPlugi2.enabled)) {
      if (context.componentRendererColumns.size > 0) {
        warn(AUTOSIZE_WARNING);
      }
    }
  };
  useEffect(function() {
    var hotColumnCount = Children.toArray(props.children).filter(isHotColumn).length;
    context.trimColumnSettings(hotColumnCount);
    var newGlobalSettings = createNewGlobalSettings(true);
    prevProps.current = props;
    __hotInstance.current = new Handsontable.Core(hotElementRef.current, newGlobalSettings);
    __hotInstance.current.addHook("beforeViewRender", function() {
      context.clearPortalCache();
      context.clearRenderedCellCache();
    });
    __hotInstance.current.addHook("afterViewRender", function() {
      context.pushCellPortalsIntoPortalManager();
    });
    __hotInstance.current.init();
    displayAutoSizeWarning(__hotInstance.current);
    if (!displayObsoleteRenderersEditorsWarning(props.children)) {
      displayChildrenOfTypeWarning(props.children, HotColumn);
    }
    return function() {
      var _getHotInstance2;
      clearCache();
      (_getHotInstance2 = getHotInstance()) === null || _getHotInstance2 === void 0 || _getHotInstance2.destroy();
    };
  }, []);
  useUpdateEffect(function() {
    clearCache();
    var hotInstance = getHotInstance();
    var hotColumnCount = Children.toArray(props.children).filter(isHotColumn).length;
    context.trimColumnSettings(hotColumnCount);
    var newGlobalSettings = createNewGlobalSettings(false, prevProps.current);
    prevProps.current = props;
    hotInstance === null || hotInstance === void 0 || hotInstance.updateSettings(newGlobalSettings, false);
    displayAutoSizeWarning(hotInstance);
    displayObsoleteRenderersEditorsWarning(props.children);
  });
  useImperativeHandle(ref, function() {
    return {
      get hotElementRef() {
        return hotElementRef.current;
      },
      get hotInstance() {
        return getHotInstance();
      }
    };
  });
  var hotColumnWrapped = Children.toArray(props.children).filter(isHotColumn).map(function(childNode, columnIndex) {
    return /* @__PURE__ */ React__default.createElement(HotColumnContextProvider, {
      columnIndex,
      getOwnerDocument,
      key: columnIndex
    }, childNode);
  });
  var containerProps = getContainerAttributesProps(props);
  var editorPortal = createEditorPortal(getOwnerDocument(), props.editor);
  return /* @__PURE__ */ React__default.createElement(Fragment, null, /* @__PURE__ */ React__default.createElement("div", _extends({
    ref: hotElementRef
  }, containerProps, {
    style: _objectSpread2({
      height: "100%"
    }, containerProps.style)
  }), hotColumnWrapped), /* @__PURE__ */ React__default.createElement(RenderersPortalManager, {
    ref: context.setRenderersPortalManagerRef
  }), /* @__PURE__ */ React__default.createElement(EditorContextProvider, {
    hooksRef: globalEditorHooksRef,
    hotCustomEditorInstanceRef: globalEditorClassInstance
  }, editorPortal));
});
HotTableInner.propTypes = {
  style: PropTypes.object,
  id: PropTypes.string,
  className: PropTypes.string
};
var _excluded = ["children"];
var HotTable = /* @__PURE__ */ forwardRef(function(_ref, ref) {
  var _props$id;
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  var componentId = (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : useId();
  return /* @__PURE__ */ React__default.createElement(HotTableContextProvider, null, /* @__PURE__ */ React__default.createElement(HotTableInner, _extends({
    id: componentId
  }, props, {
    ref
  }), children));
});
HotTable.version = version;
var ReferenceType;
(function(ReferenceType2) {
  ReferenceType2["RELATIVE"] = "RELATIVE";
  ReferenceType2["ABSOLUTE"] = "ABSOLUTE";
})(ReferenceType || (ReferenceType = {}));
class ColumnAddress {
  constructor(type, col, sheet) {
    this.type = type;
    this.col = col;
    this.sheet = sheet;
  }
  static absolute(column, sheet) {
    return new ColumnAddress(ReferenceType.ABSOLUTE, column, sheet);
  }
  static relative(column, sheet) {
    return new ColumnAddress(ReferenceType.RELATIVE, column, sheet);
  }
  static compareByAbsoluteAddress(baseAddress) {
    return (colA, colB) => colA.toSimpleColumnAddress(baseAddress).col - colB.toSimpleColumnAddress(baseAddress).col;
  }
  isColumnAbsolute() {
    return this.type === ReferenceType.ABSOLUTE;
  }
  isColumnRelative() {
    return this.type === ReferenceType.RELATIVE;
  }
  isAbsolute() {
    return this.type === ReferenceType.ABSOLUTE && this.sheet !== void 0;
  }
  moved(toSheet, toRight, _toBottom) {
    const newSheet = this.sheet === void 0 ? void 0 : toSheet;
    return new ColumnAddress(this.type, this.col + toRight, newSheet);
  }
  shiftedByColumns(numberOfColumns) {
    return new ColumnAddress(this.type, this.col + numberOfColumns, this.sheet);
  }
  toSimpleColumnAddress(baseAddress) {
    const sheet = absoluteSheetReference(this, baseAddress);
    let column = this.col;
    if (this.isColumnRelative()) {
      column = baseAddress.col + this.col;
    }
    return simpleColumnAddress(sheet, column);
  }
  shiftRelativeDimensions(toRight, _toBottom) {
    const col = this.isColumnRelative() ? this.col + toRight : this.col;
    return new ColumnAddress(this.type, col, this.sheet);
  }
  shiftAbsoluteDimensions(toRight, _toBottom) {
    const col = this.isColumnAbsolute() ? this.col + toRight : this.col;
    return new ColumnAddress(this.type, col, this.sheet);
  }
  withSheet(sheet) {
    return new ColumnAddress(this.type, this.col, sheet);
  }
  isInvalid(baseAddress) {
    return this.toSimpleColumnAddress(baseAddress).col < 0;
  }
  hash(withSheet) {
    const sheetPart = withSheet && this.sheet !== void 0 ? `#${this.sheet}` : "";
    switch (this.type) {
      case ReferenceType.RELATIVE: {
        return `${sheetPart}#COLR${this.col}`;
      }
      case ReferenceType.ABSOLUTE: {
        return `${sheetPart}#COLA${this.col}`;
      }
    }
  }
  unparse(baseAddress) {
    const simpleAddress = this.toSimpleColumnAddress(baseAddress);
    if (invalidSimpleColumnAddress(simpleAddress)) {
      return void 0;
    }
    const column = columnIndexToLabel(simpleAddress.col);
    const dollar = this.type === ReferenceType.ABSOLUTE ? "$" : "";
    return `${dollar}${column}`;
  }
  exceedsSheetSizeLimits(maxColumns) {
    return this.col >= maxColumns;
  }
}
class RowAddress {
  constructor(type, row, sheet) {
    this.type = type;
    this.row = row;
    this.sheet = sheet;
  }
  static absolute(row, sheet) {
    return new RowAddress(ReferenceType.ABSOLUTE, row, sheet);
  }
  static relative(row, sheet) {
    return new RowAddress(ReferenceType.RELATIVE, row, sheet);
  }
  static compareByAbsoluteAddress(baseAddress) {
    return (rowA, rowB) => rowA.toSimpleRowAddress(baseAddress).row - rowB.toSimpleRowAddress(baseAddress).row;
  }
  isRowAbsolute() {
    return this.type === ReferenceType.ABSOLUTE;
  }
  isRowRelative() {
    return this.type === ReferenceType.RELATIVE;
  }
  isAbsolute() {
    return this.type === ReferenceType.ABSOLUTE && this.sheet !== void 0;
  }
  moved(toSheet, toRight, toBottom) {
    const newSheet = this.sheet === void 0 ? void 0 : toSheet;
    return new RowAddress(this.type, this.row + toBottom, newSheet);
  }
  shiftedByRows(numberOfColumns) {
    return new RowAddress(this.type, this.row + numberOfColumns, this.sheet);
  }
  toSimpleRowAddress(baseAddress) {
    const sheet = absoluteSheetReference(this, baseAddress);
    let row = this.row;
    if (this.isRowRelative()) {
      row = baseAddress.row + this.row;
    }
    return simpleRowAddress(sheet, row);
  }
  shiftRelativeDimensions(toRight, toBottom) {
    const row = this.isRowRelative() ? this.row + toBottom : this.row;
    return new RowAddress(this.type, row, this.sheet);
  }
  shiftAbsoluteDimensions(toRight, toBottom) {
    const row = this.isRowAbsolute() ? this.row + toBottom : this.row;
    return new RowAddress(this.type, row, this.sheet);
  }
  withSheet(sheet) {
    return new RowAddress(this.type, this.row, sheet);
  }
  isInvalid(baseAddress) {
    return this.toSimpleRowAddress(baseAddress).row < 0;
  }
  hash(withSheet) {
    const sheetPart = withSheet && this.sheet !== void 0 ? `#${this.sheet}` : "";
    switch (this.type) {
      case ReferenceType.RELATIVE: {
        return `${sheetPart}#ROWR${this.row}`;
      }
      case ReferenceType.ABSOLUTE: {
        return `${sheetPart}#ROWA${this.row}`;
      }
    }
  }
  unparse(baseAddress) {
    const simpleAddress = this.toSimpleRowAddress(baseAddress);
    if (invalidSimpleRowAddress(simpleAddress)) {
      return void 0;
    }
    const dollar = this.type === ReferenceType.ABSOLUTE ? "$" : "";
    return `${dollar}${simpleAddress.row + 1}`;
  }
  exceedsSheetSizeLimits(maxRows) {
    return this.row >= maxRows;
  }
}
var CellReferenceType;
(function(CellReferenceType2) {
  CellReferenceType2["CELL_REFERENCE_RELATIVE"] = "CELL_REFERENCE";
  CellReferenceType2["CELL_REFERENCE_ABSOLUTE"] = "CELL_REFERENCE_ABSOLUTE";
  CellReferenceType2["CELL_REFERENCE_ABSOLUTE_COL"] = "CELL_REFERENCE_ABSOLUTE_COL";
  CellReferenceType2["CELL_REFERENCE_ABSOLUTE_ROW"] = "CELL_REFERENCE_ABSOLUTE_ROW";
})(CellReferenceType || (CellReferenceType = {}));
class CellAddress {
  constructor(col, row, type, sheet) {
    this.col = col;
    this.row = row;
    this.type = type;
    this.sheet = sheet;
  }
  static fromColAndRow(col, row, sheet) {
    const factoryMethod = col.isColumnAbsolute() && row.isRowAbsolute() ? CellAddress.absolute.bind(this) : col.isColumnAbsolute() ? CellAddress.absoluteCol.bind(this) : row.isRowAbsolute() ? CellAddress.absoluteRow.bind(this) : CellAddress.relative.bind(this);
    return factoryMethod(col.col, row.row, sheet);
  }
  static relative(col, row, sheet) {
    return new CellAddress(col, row, CellReferenceType.CELL_REFERENCE_RELATIVE, sheet);
  }
  static absolute(col, row, sheet) {
    return new CellAddress(col, row, CellReferenceType.CELL_REFERENCE_ABSOLUTE, sheet);
  }
  static absoluteCol(col, row, sheet) {
    return new CellAddress(col, row, CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL, sheet);
  }
  static absoluteRow(col, row, sheet) {
    return new CellAddress(col, row, CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW, sheet);
  }
  /**
   * Converts R0C0 representation of cell address to simple object representation.
   *
   * @param baseAddress - base address for R0C0 shifts
   */
  toSimpleCellAddress(baseAddress) {
    const sheet = absoluteSheetReference(this, baseAddress);
    if (this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE) {
      return simpleCellAddress(sheet, this.col, this.row);
    } else if (this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW) {
      return simpleCellAddress(sheet, baseAddress.col + this.col, this.row);
    } else if (this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL) {
      return simpleCellAddress(sheet, this.col, baseAddress.row + this.row);
    } else {
      return simpleCellAddress(sheet, baseAddress.col + this.col, baseAddress.row + this.row);
    }
  }
  toColumnAddress() {
    const refType = this.isColumnRelative() ? ReferenceType.RELATIVE : ReferenceType.ABSOLUTE;
    return new ColumnAddress(refType, this.col, this.sheet);
  }
  toRowAddress() {
    const refType = this.isRowRelative() ? ReferenceType.RELATIVE : ReferenceType.ABSOLUTE;
    return new RowAddress(refType, this.row, this.sheet);
  }
  toSimpleColumnAddress(baseAddress) {
    const sheet = absoluteSheetReference(this, baseAddress);
    let column = this.col;
    if (this.isColumnRelative()) {
      column += baseAddress.col;
    }
    return simpleColumnAddress(sheet, column);
  }
  toSimpleRowAddress(baseAddress) {
    const sheet = absoluteSheetReference(this, baseAddress);
    let row = this.row;
    if (this.isRowRelative()) {
      row += baseAddress.row;
    }
    return simpleRowAddress(sheet, row);
  }
  isRowAbsolute() {
    return this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE || this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW;
  }
  isColumnAbsolute() {
    return this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE || this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL;
  }
  isColumnRelative() {
    return this.type === CellReferenceType.CELL_REFERENCE_RELATIVE || this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW;
  }
  isRowRelative() {
    return this.type === CellReferenceType.CELL_REFERENCE_RELATIVE || this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL;
  }
  isAbsolute() {
    return this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE && this.sheet !== void 0;
  }
  shiftedByRows(numberOfRows) {
    return new CellAddress(this.col, this.row + numberOfRows, this.type, this.sheet);
  }
  shiftedByColumns(numberOfColumns) {
    return new CellAddress(this.col + numberOfColumns, this.row, this.type, this.sheet);
  }
  moved(toSheet, toRight, toBottom) {
    const newSheet = this.sheet === void 0 ? void 0 : toSheet;
    return new CellAddress(this.col + toRight, this.row + toBottom, this.type, newSheet);
  }
  withSheet(sheet) {
    return new CellAddress(this.col, this.row, this.type, sheet);
  }
  isInvalid(baseAddress) {
    return isColOrRowInvalid(this.toSimpleCellAddress(baseAddress));
  }
  shiftRelativeDimensions(toRight, toBottom) {
    const col = this.isColumnAbsolute() ? this.col : this.col + toRight;
    const row = this.isRowAbsolute() ? this.row : this.row + toBottom;
    return new CellAddress(col, row, this.type, this.sheet);
  }
  shiftAbsoluteDimensions(toRight, toBottom) {
    const col = this.isColumnRelative() ? this.col : this.col + toRight;
    const row = this.isRowRelative() ? this.row : this.row + toBottom;
    return new CellAddress(col, row, this.type, this.sheet);
  }
  hash(withSheet) {
    const sheetPart = withSheet && this.sheet !== void 0 ? `#${this.sheet}` : "";
    switch (this.type) {
      case CellReferenceType.CELL_REFERENCE_RELATIVE: {
        return `${sheetPart}#${this.row}R${this.col}`;
      }
      case CellReferenceType.CELL_REFERENCE_ABSOLUTE: {
        return `${sheetPart}#${this.row}A${this.col}`;
      }
      case CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL: {
        return `${sheetPart}#${this.row}AC${this.col}`;
      }
      case CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW: {
        return `${sheetPart}#${this.row}AR${this.col}`;
      }
    }
  }
  unparse(baseAddress) {
    const simpleAddress = this.toSimpleCellAddress(baseAddress);
    if (isColOrRowInvalid(simpleAddress)) {
      return void 0;
    }
    const column = columnIndexToLabel(simpleAddress.col);
    const rowDollar = this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE || this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW ? "$" : "";
    const colDollar = this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE || this.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL ? "$" : "";
    return `${colDollar}${column}${rowDollar}${simpleAddress.row + 1}`;
  }
  exceedsSheetSizeLimits(maxColumns, maxRows) {
    return this.row >= maxRows || this.col >= maxColumns;
  }
}
const RANGE_OPERATOR = ":";
const ABSOLUTE_OPERATOR = "$";
const ALL_WHITESPACE_PATTERN = "\\s+";
const ODFF_WHITESPACE_PATTERN = "[ \\t\\n\\r]+";
const UNICODE_LETTER_PATTERN = "A-Za-zÀ-ʯ";
const NON_RESERVED_CHARACTER_PATTERN = `${UNICODE_LETTER_PATTERN}0-9_.`;
const UNQUOTED_SHEET_NAME_PATTERN = `[${UNICODE_LETTER_PATTERN}0-9_]+`;
const QUOTED_SHEET_NAME_PATTERN = "'(((?!').|'')*)'";
const SHEET_NAME_PATTERN = `(${UNQUOTED_SHEET_NAME_PATTERN}|${QUOTED_SHEET_NAME_PATTERN})!`;
const CELL_REFERENCE_PATTERN = `(${SHEET_NAME_PATTERN})?\\${ABSOLUTE_OPERATOR}?[A-Za-z]+\\${ABSOLUTE_OPERATOR}?[0-9]+`;
const COLUMN_REFERENCE_PATTERN = `(${SHEET_NAME_PATTERN})?\\${ABSOLUTE_OPERATOR}?[A-Za-z]+`;
const ROW_REFERENCE_PATTERN = `(${SHEET_NAME_PATTERN})?\\${ABSOLUTE_OPERATOR}?[0-9]+`;
const R1C1_CELL_REFERENCE_PATTERN = "[rR][0-9]*[cC][0-9]*";
const CELL_REFERENCE_WITH_NEXT_CHARACTER_PATTERN = `(${CELL_REFERENCE_PATTERN})[^${NON_RESERVED_CHARACTER_PATTERN}]`;
const NAMED_EXPRESSION_PATTERN = `[${UNICODE_LETTER_PATTERN}_][${NON_RESERVED_CHARACTER_PATTERN}]*`;
const ALL_DIGITS_ARRAY = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
const ALL_UNICODE_LETTERS_ARRAY = [...Array.from(Array(26)).map((_, i) => i + "A".charCodeAt(0)), ...Array.from(Array(26)).map((_, i) => i + "a".charCodeAt(0)), ...Array.from(Array(687 - 192 + 1)).map((_, i) => i + 192)].map((code) => String.fromCharCode(code));
const addressRegex = new RegExp(`^(${SHEET_NAME_PATTERN})?(\\${ABSOLUTE_OPERATOR}?)([A-Za-z]+)(\\${ABSOLUTE_OPERATOR}?)([0-9]+)$`);
const columnRegex = new RegExp(`^(${SHEET_NAME_PATTERN})?(\\${ABSOLUTE_OPERATOR}?)([A-Za-z]+)$`);
const rowRegex = new RegExp(`^(${SHEET_NAME_PATTERN})?(\\${ABSOLUTE_OPERATOR}?)([0-9]+)$`);
const simpleSheetNameRegex = new RegExp(`^${UNQUOTED_SHEET_NAME_PATTERN}$`);
const cellAddressFromString = (stringAddress, baseAddress, resolveSheetReference) => {
  const result = addressRegex.exec(stringAddress);
  if (!result) {
    return void 0;
  }
  const col = columnLabelToIndex(result[6]);
  const row = Number(result[8]) - 1;
  const sheetName = extractSheetName(result);
  const sheet = sheetNameToId(sheetName, resolveSheetReference);
  if (sheet === null) {
    return void 0;
  }
  if (result[5] === ABSOLUTE_OPERATOR && result[7] === ABSOLUTE_OPERATOR) {
    return CellAddress.absolute(col, row, sheet);
  } else if (result[5] === ABSOLUTE_OPERATOR) {
    return CellAddress.absoluteCol(col, row - baseAddress.row, sheet);
  } else if (result[7] === ABSOLUTE_OPERATOR) {
    return CellAddress.absoluteRow(col - baseAddress.col, row, sheet);
  } else {
    return CellAddress.relative(col - baseAddress.col, row - baseAddress.row, sheet);
  }
};
const columnAddressFromString = (stringAddress, baseAddress, resolveSheetReference) => {
  const result = columnRegex.exec(stringAddress);
  if (!result) {
    return void 0;
  }
  const col = columnLabelToIndex(result[6]);
  const sheetName = extractSheetName(result);
  const sheet = sheetNameToId(sheetName, resolveSheetReference);
  if (sheet === null) {
    return void 0;
  }
  if (result[5] === ABSOLUTE_OPERATOR) {
    return ColumnAddress.absolute(col, sheet);
  } else {
    return ColumnAddress.relative(col - baseAddress.col, sheet);
  }
};
const rowAddressFromString = (stringAddress, baseAddress, resolveSheetReference) => {
  const result = rowRegex.exec(stringAddress);
  if (!result) {
    return void 0;
  }
  const row = Number(result[6]) - 1;
  const sheetName = extractSheetName(result);
  const sheet = sheetNameToId(sheetName, resolveSheetReference);
  if (sheet === null) {
    return void 0;
  }
  if (result[5] === ABSOLUTE_OPERATOR) {
    return RowAddress.absolute(row, sheet);
  } else {
    return RowAddress.relative(row - baseAddress.row, sheet);
  }
};
const simpleCellAddressFromString = (resolveSheetReference, stringAddress, contextSheetId) => {
  const regExpExecArray = addressRegex.exec(stringAddress);
  if (!regExpExecArray) {
    return void 0;
  }
  const col = columnLabelToIndex(regExpExecArray[6]);
  const row = Number(regExpExecArray[8]) - 1;
  const sheetName = extractSheetName(regExpExecArray);
  const sheet = sheetNameToId(sheetName, resolveSheetReference);
  if (sheet === null) {
    return void 0;
  }
  const effectiveSheet = sheet === void 0 ? contextSheetId : sheet;
  return simpleCellAddress(effectiveSheet, col, row);
};
const simpleCellRangeFromString = (resolveSheetReference, stringAddress, contextSheetId) => {
  const split2 = stringAddress.split(RANGE_OPERATOR);
  if (split2.length !== 2) {
    return void 0;
  }
  const [startString, endString] = split2;
  const start = simpleCellAddressFromString(resolveSheetReference, startString, contextSheetId);
  if (start === void 0) {
    return void 0;
  }
  const end = simpleCellAddressFromString(resolveSheetReference, endString, start.sheet);
  if (end === void 0) {
    return void 0;
  }
  if (start.sheet !== end.sheet) {
    return void 0;
  }
  return simpleCellRange(start, end);
};
const simpleCellAddressToString = (sheetIndexMapping, address, sheetIndex) => {
  const column = columnIndexToLabel(address.col);
  const sheetName = sheetIndexToString(address.sheet, sheetIndexMapping);
  if (sheetName === void 0) {
    return void 0;
  }
  if (sheetIndex !== address.sheet) {
    return `${sheetName}!${column}${address.row + 1}`;
  } else {
    return `${column}${address.row + 1}`;
  }
};
const simpleCellRangeToString = (sheetIndexMapping, address, sheetIndex) => {
  const startString = simpleCellAddressToString(sheetIndexMapping, address.start, sheetIndex);
  const endString = simpleCellAddressToString(sheetIndexMapping, address.end, address.start.sheet);
  if (startString === void 0 || endString === void 0) {
    return void 0;
  } else {
    return `${startString}${RANGE_OPERATOR}${endString}`;
  }
};
function columnLabelToIndex(columnStringRepresentation) {
  if (columnStringRepresentation.length === 1) {
    return columnStringRepresentation.toUpperCase().charCodeAt(0) - 65;
  } else {
    return columnStringRepresentation.split("").reduce((currentColumn, nextLetter) => {
      return currentColumn * 26 + (nextLetter.toUpperCase().charCodeAt(0) - 64);
    }, 0) - 1;
  }
}
function columnIndexToLabel(column) {
  let result = "";
  while (column >= 0) {
    result = String.fromCharCode(column % 26 + 97) + result;
    column = Math.floor(column / 26) - 1;
  }
  return result.toUpperCase();
}
function sheetIndexToString(sheetId, sheetMappingFn) {
  let sheetName = sheetMappingFn(sheetId);
  if (sheetName === void 0) {
    return void 0;
  }
  if (simpleSheetNameRegex.test(sheetName)) {
    return sheetName;
  } else {
    sheetName = sheetName.replace(/'/g, "''");
    return `'${sheetName}'`;
  }
}
function extractSheetName(regexResult) {
  var _a;
  const maybeSheetName = (_a = regexResult[3]) !== null && _a !== void 0 ? _a : regexResult[2];
  return maybeSheetName ? maybeSheetName.replace(/''/g, "'") : null;
}
function sheetNameToId(sheetName, resolveSheetReference) {
  if (!sheetName) {
    return void 0;
  }
  const sheetId = resolveSheetReference(sheetName);
  return sheetId === void 0 ? null : sheetId;
}
function isEmpty(arr) {
  return arr && arr.length === 0;
}
function keys(obj) {
  if (obj === void 0 || obj === null) {
    return [];
  }
  return Object.keys(obj);
}
function values(obj) {
  var vals = [];
  var keys2 = Object.keys(obj);
  for (var i = 0; i < keys2.length; i++) {
    vals.push(obj[keys2[i]]);
  }
  return vals;
}
function mapValues(obj, callback) {
  var result = [];
  var objKeys = keys(obj);
  for (var idx = 0; idx < objKeys.length; idx++) {
    var currKey = objKeys[idx];
    result.push(callback.call(null, obj[currKey], currKey));
  }
  return result;
}
function map(arr, callback) {
  var result = [];
  for (var idx = 0; idx < arr.length; idx++) {
    result.push(callback.call(null, arr[idx], idx));
  }
  return result;
}
function flatten(arr) {
  var result = [];
  for (var idx = 0; idx < arr.length; idx++) {
    var currItem = arr[idx];
    if (Array.isArray(currItem)) {
      result = result.concat(flatten(currItem));
    } else {
      result.push(currItem);
    }
  }
  return result;
}
function first$1(arr) {
  return isEmpty(arr) ? void 0 : arr[0];
}
function last(arr) {
  var len = arr && arr.length;
  return len ? arr[len - 1] : void 0;
}
function forEach(collection2, iteratorCallback) {
  if (Array.isArray(collection2)) {
    for (var i = 0; i < collection2.length; i++) {
      iteratorCallback.call(null, collection2[i], i);
    }
  } else if (isObject(collection2)) {
    var colKeys = keys(collection2);
    for (var i = 0; i < colKeys.length; i++) {
      var key = colKeys[i];
      var value = collection2[key];
      iteratorCallback.call(null, value, key);
    }
  } else {
    throw Error("non exhaustive match");
  }
}
function isString(item) {
  return typeof item === "string";
}
function isUndefined(item) {
  return item === void 0;
}
function isFunction(item) {
  return item instanceof Function;
}
function drop(arr, howMuch) {
  if (howMuch === void 0) {
    howMuch = 1;
  }
  return arr.slice(howMuch, arr.length);
}
function dropRight(arr, howMuch) {
  if (howMuch === void 0) {
    howMuch = 1;
  }
  return arr.slice(0, arr.length - howMuch);
}
function filter(arr, predicate) {
  var result = [];
  if (Array.isArray(arr)) {
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (predicate.call(null, item)) {
        result.push(item);
      }
    }
  }
  return result;
}
function reject(arr, predicate) {
  return filter(arr, function(item) {
    return !predicate(item);
  });
}
function pick(obj, predicate) {
  var keys2 = Object.keys(obj);
  var result = {};
  for (var i = 0; i < keys2.length; i++) {
    var currKey = keys2[i];
    var currItem = obj[currKey];
    if (predicate(currItem)) {
      result[currKey] = currItem;
    }
  }
  return result;
}
function has(obj, prop) {
  if (isObject(obj)) {
    return obj.hasOwnProperty(prop);
  }
  return false;
}
function contains(arr, item) {
  return find(arr, function(currItem) {
    return currItem === item;
  }) !== void 0 ? true : false;
}
function cloneArr(arr) {
  var newArr = [];
  for (var i = 0; i < arr.length; i++) {
    newArr.push(arr[i]);
  }
  return newArr;
}
function cloneObj(obj) {
  var clonedObj = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = obj[key];
    }
  }
  return clonedObj;
}
function find(arr, predicate) {
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i];
    if (predicate.call(null, item)) {
      return item;
    }
  }
  return void 0;
}
function findAll(arr, predicate) {
  var found = [];
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i];
    if (predicate.call(null, item)) {
      found.push(item);
    }
  }
  return found;
}
function reduce(arrOrObj, iterator, initial) {
  var isArr = Array.isArray(arrOrObj);
  var vals = isArr ? arrOrObj : values(arrOrObj);
  var objKeys = isArr ? [] : keys(arrOrObj);
  var accumulator = initial;
  for (var i = 0; i < vals.length; i++) {
    accumulator = iterator.call(null, accumulator, vals[i], isArr ? i : objKeys[i]);
  }
  return accumulator;
}
function compact(arr) {
  return reject(arr, function(item) {
    return item === null || item === void 0;
  });
}
function uniq(arr, identity) {
  if (identity === void 0) {
    identity = function(item) {
      return item;
    };
  }
  var identities = [];
  return reduce(arr, function(result, currItem) {
    var currIdentity = identity(currItem);
    if (contains(identities, currIdentity)) {
      return result;
    } else {
      identities.push(currIdentity);
      return result.concat(currItem);
    }
  }, []);
}
function isArray(obj) {
  return Array.isArray(obj);
}
function isRegExp(obj) {
  return obj instanceof RegExp;
}
function isObject(obj) {
  return obj instanceof Object;
}
function every(arr, predicate) {
  for (var i = 0; i < arr.length; i++) {
    if (!predicate(arr[i], i)) {
      return false;
    }
  }
  return true;
}
function difference(arr, values2) {
  return reject(arr, function(item) {
    return contains(values2, item);
  });
}
function some(arr, predicate) {
  for (var i = 0; i < arr.length; i++) {
    if (predicate(arr[i])) {
      return true;
    }
  }
  return false;
}
function indexOf(arr, value) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === value) {
      return i;
    }
  }
  return -1;
}
function assign(target) {
  var sources = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }
  for (var i = 0; i < sources.length; i++) {
    var curSource = sources[i];
    var currSourceKeys = keys(curSource);
    for (var j = 0; j < currSourceKeys.length; j++) {
      var currKey = currSourceKeys[j];
      target[currKey] = curSource[currKey];
    }
  }
  return target;
}
function assignNoOverwrite(target) {
  var sources = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }
  for (var i = 0; i < sources.length; i++) {
    var curSource = sources[i];
    if (isUndefined(curSource)) {
      continue;
    }
    var currSourceKeys = keys(curSource);
    for (var j = 0; j < currSourceKeys.length; j++) {
      var currKey = currSourceKeys[j];
      if (!has(target, currKey)) {
        target[currKey] = curSource[currKey];
      }
    }
  }
  return target;
}
function defaults() {
  var sources = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }
  return assignNoOverwrite.apply(null, [{}].concat(sources));
}
function groupBy(arr, groupKeyFunc) {
  var result = {};
  forEach(arr, function(item) {
    var currGroupKey = groupKeyFunc(item);
    var currGroupArr = result[currGroupKey];
    if (currGroupArr) {
      currGroupArr.push(item);
    } else {
      result[currGroupKey] = [item];
    }
  });
  return result;
}
function merge(obj1, obj2) {
  var result = cloneObj(obj1);
  var keys2 = keys(obj2);
  for (var i = 0; i < keys2.length; i++) {
    var key = keys2[i];
    var value = obj2[key];
    result[key] = value;
  }
  return result;
}
function NOOP() {
}
function IDENTITY(item) {
  return item;
}
function packArray(holeyArr) {
  var result = [];
  for (var i = 0; i < holeyArr.length; i++) {
    var orgValue = holeyArr[i];
    result.push(orgValue !== void 0 ? orgValue : void 0);
  }
  return result;
}
function PRINT_ERROR(msg) {
  if (console && console.error) {
    console.error("Error: " + msg);
  }
}
function PRINT_WARNING(msg) {
  if (console && console.warn) {
    console.warn("Warning: " + msg);
  }
}
function isES2015MapSupported() {
  return typeof Map === "function";
}
function applyMixins(derivedCtor, baseCtors) {
  baseCtors.forEach(function(baseCtor) {
    var baseProto = baseCtor.prototype;
    Object.getOwnPropertyNames(baseProto).forEach(function(propName) {
      if (propName === "constructor") {
        return;
      }
      var basePropDescriptor = Object.getOwnPropertyDescriptor(baseProto, propName);
      if (basePropDescriptor && (basePropDescriptor.get || basePropDescriptor.set)) {
        Object.defineProperty(derivedCtor.prototype, propName, basePropDescriptor);
      } else {
        derivedCtor.prototype[propName] = baseCtor.prototype[propName];
      }
    });
  });
}
function toFastProperties(toBecomeFast) {
  function FakeConstructor() {
  }
  FakeConstructor.prototype = toBecomeFast;
  var fakeInstance = new FakeConstructor();
  function fakeAccess() {
    return typeof fakeInstance.bar;
  }
  fakeAccess();
  fakeAccess();
  return toBecomeFast;
}
function peek(arr) {
  return arr[arr.length - 1];
}
function timer(func) {
  var start = (/* @__PURE__ */ new Date()).getTime();
  var val = func();
  var end = (/* @__PURE__ */ new Date()).getTime();
  var total = end - start;
  return { time: total, value: val };
}
var regexpToAst$1 = { exports: {} };
var regexpToAst = regexpToAst$1.exports;
var hasRequiredRegexpToAst;
function requireRegexpToAst() {
  if (hasRequiredRegexpToAst) return regexpToAst$1.exports;
  hasRequiredRegexpToAst = 1;
  (function(module) {
    (function(root, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        root.regexpToAst = factory();
      }
    })(
      typeof self !== "undefined" ? (
        // istanbul ignore next
        self
      ) : regexpToAst,
      function() {
        function RegExpParser() {
        }
        RegExpParser.prototype.saveState = function() {
          return {
            idx: this.idx,
            input: this.input,
            groupIdx: this.groupIdx
          };
        };
        RegExpParser.prototype.restoreState = function(newState) {
          this.idx = newState.idx;
          this.input = newState.input;
          this.groupIdx = newState.groupIdx;
        };
        RegExpParser.prototype.pattern = function(input) {
          this.idx = 0;
          this.input = input;
          this.groupIdx = 0;
          this.consumeChar("/");
          var value = this.disjunction();
          this.consumeChar("/");
          var flags = {
            type: "Flags",
            global: false,
            ignoreCase: false,
            multiLine: false,
            unicode: false,
            sticky: false
          };
          while (this.isRegExpFlag()) {
            switch (this.popChar()) {
              case "g":
                addFlag(flags, "global");
                break;
              case "i":
                addFlag(flags, "ignoreCase");
                break;
              case "m":
                addFlag(flags, "multiLine");
                break;
              case "u":
                addFlag(flags, "unicode");
                break;
              case "y":
                addFlag(flags, "sticky");
                break;
            }
          }
          if (this.idx !== this.input.length) {
            throw Error(
              "Redundant input: " + this.input.substring(this.idx)
            );
          }
          return { type: "Pattern", flags, value };
        };
        RegExpParser.prototype.disjunction = function() {
          var alts = [];
          alts.push(this.alternative());
          while (this.peekChar() === "|") {
            this.consumeChar("|");
            alts.push(this.alternative());
          }
          return { type: "Disjunction", value: alts };
        };
        RegExpParser.prototype.alternative = function() {
          var terms = [];
          while (this.isTerm()) {
            terms.push(this.term());
          }
          return { type: "Alternative", value: terms };
        };
        RegExpParser.prototype.term = function() {
          if (this.isAssertion()) {
            return this.assertion();
          } else {
            return this.atom();
          }
        };
        RegExpParser.prototype.assertion = function() {
          switch (this.popChar()) {
            case "^":
              return { type: "StartAnchor" };
            case "$":
              return { type: "EndAnchor" };
            // '\b' or '\B'
            case "\\":
              switch (this.popChar()) {
                case "b":
                  return { type: "WordBoundary" };
                case "B":
                  return { type: "NonWordBoundary" };
              }
              throw Error("Invalid Assertion Escape");
            // '(?=' or '(?!'
            case "(":
              this.consumeChar("?");
              var type;
              switch (this.popChar()) {
                case "=":
                  type = "Lookahead";
                  break;
                case "!":
                  type = "NegativeLookahead";
                  break;
              }
              ASSERT_EXISTS(type);
              var disjunction = this.disjunction();
              this.consumeChar(")");
              return { type, value: disjunction };
          }
          ASSERT_NEVER_REACH_HERE();
        };
        RegExpParser.prototype.quantifier = function(isBacktracking) {
          var range;
          switch (this.popChar()) {
            case "*":
              range = {
                atLeast: 0,
                atMost: Infinity
              };
              break;
            case "+":
              range = {
                atLeast: 1,
                atMost: Infinity
              };
              break;
            case "?":
              range = {
                atLeast: 0,
                atMost: 1
              };
              break;
            case "{":
              var atLeast = this.integerIncludingZero();
              switch (this.popChar()) {
                case "}":
                  range = {
                    atLeast,
                    atMost: atLeast
                  };
                  break;
                case ",":
                  var atMost;
                  if (this.isDigit()) {
                    atMost = this.integerIncludingZero();
                    range = {
                      atLeast,
                      atMost
                    };
                  } else {
                    range = {
                      atLeast,
                      atMost: Infinity
                    };
                  }
                  this.consumeChar("}");
                  break;
              }
              if (isBacktracking === true && range === void 0) {
                return void 0;
              }
              ASSERT_EXISTS(range);
              break;
          }
          if (isBacktracking === true && range === void 0) {
            return void 0;
          }
          ASSERT_EXISTS(range);
          if (this.peekChar(0) === "?") {
            this.consumeChar("?");
            range.greedy = false;
          } else {
            range.greedy = true;
          }
          range.type = "Quantifier";
          return range;
        };
        RegExpParser.prototype.atom = function() {
          var atom;
          switch (this.peekChar()) {
            case ".":
              atom = this.dotAll();
              break;
            case "\\":
              atom = this.atomEscape();
              break;
            case "[":
              atom = this.characterClass();
              break;
            case "(":
              atom = this.group();
              break;
          }
          if (atom === void 0 && this.isPatternCharacter()) {
            atom = this.patternCharacter();
          }
          ASSERT_EXISTS(atom);
          if (this.isQuantifier()) {
            atom.quantifier = this.quantifier();
          }
          return atom;
        };
        RegExpParser.prototype.dotAll = function() {
          this.consumeChar(".");
          return {
            type: "Set",
            complement: true,
            value: [cc("\n"), cc("\r"), cc("\u2028"), cc("\u2029")]
          };
        };
        RegExpParser.prototype.atomEscape = function() {
          this.consumeChar("\\");
          switch (this.peekChar()) {
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
              return this.decimalEscapeAtom();
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
              return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
              return this.controlEscapeAtom();
            case "c":
              return this.controlLetterEscapeAtom();
            case "0":
              return this.nulCharacterAtom();
            case "x":
              return this.hexEscapeSequenceAtom();
            case "u":
              return this.regExpUnicodeEscapeSequenceAtom();
            default:
              return this.identityEscapeAtom();
          }
        };
        RegExpParser.prototype.decimalEscapeAtom = function() {
          var value = this.positiveInteger();
          return { type: "GroupBackReference", value };
        };
        RegExpParser.prototype.characterClassEscape = function() {
          var set;
          var complement = false;
          switch (this.popChar()) {
            case "d":
              set = digitsCharCodes;
              break;
            case "D":
              set = digitsCharCodes;
              complement = true;
              break;
            case "s":
              set = whitespaceCodes;
              break;
            case "S":
              set = whitespaceCodes;
              complement = true;
              break;
            case "w":
              set = wordCharCodes;
              break;
            case "W":
              set = wordCharCodes;
              complement = true;
              break;
          }
          ASSERT_EXISTS(set);
          return { type: "Set", value: set, complement };
        };
        RegExpParser.prototype.controlEscapeAtom = function() {
          var escapeCode;
          switch (this.popChar()) {
            case "f":
              escapeCode = cc("\f");
              break;
            case "n":
              escapeCode = cc("\n");
              break;
            case "r":
              escapeCode = cc("\r");
              break;
            case "t":
              escapeCode = cc("	");
              break;
            case "v":
              escapeCode = cc("\v");
              break;
          }
          ASSERT_EXISTS(escapeCode);
          return { type: "Character", value: escapeCode };
        };
        RegExpParser.prototype.controlLetterEscapeAtom = function() {
          this.consumeChar("c");
          var letter = this.popChar();
          if (/[a-zA-Z]/.test(letter) === false) {
            throw Error("Invalid ");
          }
          var letterCode = letter.toUpperCase().charCodeAt(0) - 64;
          return { type: "Character", value: letterCode };
        };
        RegExpParser.prototype.nulCharacterAtom = function() {
          this.consumeChar("0");
          return { type: "Character", value: cc("\0") };
        };
        RegExpParser.prototype.hexEscapeSequenceAtom = function() {
          this.consumeChar("x");
          return this.parseHexDigits(2);
        };
        RegExpParser.prototype.regExpUnicodeEscapeSequenceAtom = function() {
          this.consumeChar("u");
          return this.parseHexDigits(4);
        };
        RegExpParser.prototype.identityEscapeAtom = function() {
          var escapedChar = this.popChar();
          return { type: "Character", value: cc(escapedChar) };
        };
        RegExpParser.prototype.classPatternCharacterAtom = function() {
          switch (this.peekChar()) {
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case "]":
              throw Error("TBD");
            default:
              var nextChar = this.popChar();
              return { type: "Character", value: cc(nextChar) };
          }
        };
        RegExpParser.prototype.characterClass = function() {
          var set = [];
          var complement = false;
          this.consumeChar("[");
          if (this.peekChar(0) === "^") {
            this.consumeChar("^");
            complement = true;
          }
          while (this.isClassAtom()) {
            var from = this.classAtom();
            var isFromSingleChar = from.type === "Character";
            if (isFromSingleChar && this.isRangeDash()) {
              this.consumeChar("-");
              var to = this.classAtom();
              var isToSingleChar = to.type === "Character";
              if (isToSingleChar) {
                if (to.value < from.value) {
                  throw Error("Range out of order in character class");
                }
                set.push({ from: from.value, to: to.value });
              } else {
                insertToSet(from.value, set);
                set.push(cc("-"));
                insertToSet(to.value, set);
              }
            } else {
              insertToSet(from.value, set);
            }
          }
          this.consumeChar("]");
          return { type: "Set", complement, value: set };
        };
        RegExpParser.prototype.classAtom = function() {
          switch (this.peekChar()) {
            // istanbul ignore next
            case "]":
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
              throw Error("TBD");
            case "\\":
              return this.classEscape();
            default:
              return this.classPatternCharacterAtom();
          }
        };
        RegExpParser.prototype.classEscape = function() {
          this.consumeChar("\\");
          switch (this.peekChar()) {
            // Matches a backspace.
            // (Not to be confused with \b word boundary outside characterClass)
            case "b":
              this.consumeChar("b");
              return { type: "Character", value: cc("\b") };
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
              return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
              return this.controlEscapeAtom();
            case "c":
              return this.controlLetterEscapeAtom();
            case "0":
              return this.nulCharacterAtom();
            case "x":
              return this.hexEscapeSequenceAtom();
            case "u":
              return this.regExpUnicodeEscapeSequenceAtom();
            default:
              return this.identityEscapeAtom();
          }
        };
        RegExpParser.prototype.group = function() {
          var capturing = true;
          this.consumeChar("(");
          switch (this.peekChar(0)) {
            case "?":
              this.consumeChar("?");
              this.consumeChar(":");
              capturing = false;
              break;
            default:
              this.groupIdx++;
              break;
          }
          var value = this.disjunction();
          this.consumeChar(")");
          var groupAst = {
            type: "Group",
            capturing,
            value
          };
          if (capturing) {
            groupAst.idx = this.groupIdx;
          }
          return groupAst;
        };
        RegExpParser.prototype.positiveInteger = function() {
          var number = this.popChar();
          if (decimalPatternNoZero.test(number) === false) {
            throw Error("Expecting a positive integer");
          }
          while (decimalPattern.test(this.peekChar(0))) {
            number += this.popChar();
          }
          return parseInt(number, 10);
        };
        RegExpParser.prototype.integerIncludingZero = function() {
          var number = this.popChar();
          if (decimalPattern.test(number) === false) {
            throw Error("Expecting an integer");
          }
          while (decimalPattern.test(this.peekChar(0))) {
            number += this.popChar();
          }
          return parseInt(number, 10);
        };
        RegExpParser.prototype.patternCharacter = function() {
          var nextChar = this.popChar();
          switch (nextChar) {
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "^":
            // istanbul ignore next
            case "$":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case ".":
            // istanbul ignore next
            case "*":
            // istanbul ignore next
            case "+":
            // istanbul ignore next
            case "?":
            // istanbul ignore next
            case "(":
            // istanbul ignore next
            case ")":
            // istanbul ignore next
            case "[":
            // istanbul ignore next
            case "|":
              throw Error("TBD");
            default:
              return { type: "Character", value: cc(nextChar) };
          }
        };
        RegExpParser.prototype.isRegExpFlag = function() {
          switch (this.peekChar(0)) {
            case "g":
            case "i":
            case "m":
            case "u":
            case "y":
              return true;
            default:
              return false;
          }
        };
        RegExpParser.prototype.isRangeDash = function() {
          return this.peekChar() === "-" && this.isClassAtom(1);
        };
        RegExpParser.prototype.isDigit = function() {
          return decimalPattern.test(this.peekChar(0));
        };
        RegExpParser.prototype.isClassAtom = function(howMuch) {
          if (howMuch === void 0) {
            howMuch = 0;
          }
          switch (this.peekChar(howMuch)) {
            case "]":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
              return false;
            default:
              return true;
          }
        };
        RegExpParser.prototype.isTerm = function() {
          return this.isAtom() || this.isAssertion();
        };
        RegExpParser.prototype.isAtom = function() {
          if (this.isPatternCharacter()) {
            return true;
          }
          switch (this.peekChar(0)) {
            case ".":
            case "\\":
            // atomEscape
            case "[":
            // characterClass
            // TODO: isAtom must be called before isAssertion - disambiguate
            case "(":
              return true;
            default:
              return false;
          }
        };
        RegExpParser.prototype.isAssertion = function() {
          switch (this.peekChar(0)) {
            case "^":
            case "$":
              return true;
            // '\b' or '\B'
            case "\\":
              switch (this.peekChar(1)) {
                case "b":
                case "B":
                  return true;
                default:
                  return false;
              }
            // '(?=' or '(?!'
            case "(":
              return this.peekChar(1) === "?" && (this.peekChar(2) === "=" || this.peekChar(2) === "!");
            default:
              return false;
          }
        };
        RegExpParser.prototype.isQuantifier = function() {
          var prevState = this.saveState();
          try {
            return this.quantifier(true) !== void 0;
          } catch (e) {
            return false;
          } finally {
            this.restoreState(prevState);
          }
        };
        RegExpParser.prototype.isPatternCharacter = function() {
          switch (this.peekChar()) {
            case "^":
            case "$":
            case "\\":
            case ".":
            case "*":
            case "+":
            case "?":
            case "(":
            case ")":
            case "[":
            case "|":
            case "/":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
              return false;
            default:
              return true;
          }
        };
        RegExpParser.prototype.parseHexDigits = function(howMany) {
          var hexString = "";
          for (var i2 = 0; i2 < howMany; i2++) {
            var hexChar = this.popChar();
            if (hexDigitPattern.test(hexChar) === false) {
              throw Error("Expecting a HexDecimal digits");
            }
            hexString += hexChar;
          }
          var charCode = parseInt(hexString, 16);
          return { type: "Character", value: charCode };
        };
        RegExpParser.prototype.peekChar = function(howMuch) {
          if (howMuch === void 0) {
            howMuch = 0;
          }
          return this.input[this.idx + howMuch];
        };
        RegExpParser.prototype.popChar = function() {
          var nextChar = this.peekChar(0);
          this.consumeChar();
          return nextChar;
        };
        RegExpParser.prototype.consumeChar = function(char) {
          if (char !== void 0 && this.input[this.idx] !== char) {
            throw Error(
              "Expected: '" + char + "' but found: '" + this.input[this.idx] + "' at offset: " + this.idx
            );
          }
          if (this.idx >= this.input.length) {
            throw Error("Unexpected end of input");
          }
          this.idx++;
        };
        var hexDigitPattern = /[0-9a-fA-F]/;
        var decimalPattern = /[0-9]/;
        var decimalPatternNoZero = /[1-9]/;
        function cc(char) {
          return char.charCodeAt(0);
        }
        function insertToSet(item, set) {
          if (item.length !== void 0) {
            item.forEach(function(subItem) {
              set.push(subItem);
            });
          } else {
            set.push(item);
          }
        }
        function addFlag(flagObj, flagKey) {
          if (flagObj[flagKey] === true) {
            throw "duplicate flag " + flagKey;
          }
          flagObj[flagKey] = true;
        }
        function ASSERT_EXISTS(obj) {
          if (obj === void 0) {
            throw Error("Internal Error - Should never get here!");
          }
        }
        function ASSERT_NEVER_REACH_HERE() {
          throw Error("Internal Error - Should never get here!");
        }
        var i;
        var digitsCharCodes = [];
        for (i = cc("0"); i <= cc("9"); i++) {
          digitsCharCodes.push(i);
        }
        var wordCharCodes = [cc("_")].concat(digitsCharCodes);
        for (i = cc("a"); i <= cc("z"); i++) {
          wordCharCodes.push(i);
        }
        for (i = cc("A"); i <= cc("Z"); i++) {
          wordCharCodes.push(i);
        }
        var whitespaceCodes = [
          cc(" "),
          cc("\f"),
          cc("\n"),
          cc("\r"),
          cc("	"),
          cc("\v"),
          cc("	"),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc(" "),
          cc("\u2028"),
          cc("\u2029"),
          cc(" "),
          cc(" "),
          cc("　"),
          cc("\uFEFF")
        ];
        function BaseRegExpVisitor() {
        }
        BaseRegExpVisitor.prototype.visitChildren = function(node) {
          for (var key in node) {
            var child = node[key];
            if (node.hasOwnProperty(key)) {
              if (child.type !== void 0) {
                this.visit(child);
              } else if (Array.isArray(child)) {
                child.forEach(function(subChild) {
                  this.visit(subChild);
                }, this);
              }
            }
          }
        };
        BaseRegExpVisitor.prototype.visit = function(node) {
          switch (node.type) {
            case "Pattern":
              this.visitPattern(node);
              break;
            case "Flags":
              this.visitFlags(node);
              break;
            case "Disjunction":
              this.visitDisjunction(node);
              break;
            case "Alternative":
              this.visitAlternative(node);
              break;
            case "StartAnchor":
              this.visitStartAnchor(node);
              break;
            case "EndAnchor":
              this.visitEndAnchor(node);
              break;
            case "WordBoundary":
              this.visitWordBoundary(node);
              break;
            case "NonWordBoundary":
              this.visitNonWordBoundary(node);
              break;
            case "Lookahead":
              this.visitLookahead(node);
              break;
            case "NegativeLookahead":
              this.visitNegativeLookahead(node);
              break;
            case "Character":
              this.visitCharacter(node);
              break;
            case "Set":
              this.visitSet(node);
              break;
            case "Group":
              this.visitGroup(node);
              break;
            case "GroupBackReference":
              this.visitGroupBackReference(node);
              break;
            case "Quantifier":
              this.visitQuantifier(node);
              break;
          }
          this.visitChildren(node);
        };
        BaseRegExpVisitor.prototype.visitPattern = function(node) {
        };
        BaseRegExpVisitor.prototype.visitFlags = function(node) {
        };
        BaseRegExpVisitor.prototype.visitDisjunction = function(node) {
        };
        BaseRegExpVisitor.prototype.visitAlternative = function(node) {
        };
        BaseRegExpVisitor.prototype.visitStartAnchor = function(node) {
        };
        BaseRegExpVisitor.prototype.visitEndAnchor = function(node) {
        };
        BaseRegExpVisitor.prototype.visitWordBoundary = function(node) {
        };
        BaseRegExpVisitor.prototype.visitNonWordBoundary = function(node) {
        };
        BaseRegExpVisitor.prototype.visitLookahead = function(node) {
        };
        BaseRegExpVisitor.prototype.visitNegativeLookahead = function(node) {
        };
        BaseRegExpVisitor.prototype.visitCharacter = function(node) {
        };
        BaseRegExpVisitor.prototype.visitSet = function(node) {
        };
        BaseRegExpVisitor.prototype.visitGroup = function(node) {
        };
        BaseRegExpVisitor.prototype.visitGroupBackReference = function(node) {
        };
        BaseRegExpVisitor.prototype.visitQuantifier = function(node) {
        };
        return {
          RegExpParser,
          BaseRegExpVisitor,
          VERSION: "0.4.0"
        };
      }
    );
  })(regexpToAst$1);
  return regexpToAst$1.exports;
}
var regexpToAstExports = requireRegexpToAst();
var regExpAstCache = {};
var regExpParser = new regexpToAstExports.RegExpParser();
function getRegExpAst(regExp) {
  var regExpStr = regExp.toString();
  if (regExpAstCache.hasOwnProperty(regExpStr)) {
    return regExpAstCache[regExpStr];
  } else {
    var regExpAst = regExpParser.pattern(regExpStr);
    regExpAstCache[regExpStr] = regExpAst;
    return regExpAst;
  }
}
function clearRegExpParserCache() {
  regExpAstCache = {};
}
var __extends$a = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var complementErrorMessage = "Complement Sets are not supported for first char optimization";
var failedOptimizationPrefixMsg = 'Unable to use "first char" lexer optimizations:\n';
function getOptimizedStartCodesIndices(regExp, ensureOptimizations) {
  if (ensureOptimizations === void 0) {
    ensureOptimizations = false;
  }
  try {
    var ast = getRegExpAst(regExp);
    var firstChars = firstCharOptimizedIndices(ast.value, {}, ast.flags.ignoreCase);
    return firstChars;
  } catch (e) {
    if (e.message === complementErrorMessage) {
      if (ensureOptimizations) {
        PRINT_WARNING("" + failedOptimizationPrefixMsg + ("	Unable to optimize: < " + regExp.toString() + " >\n") + "	Complement Sets cannot be automatically optimized.\n	This will disable the lexer's first char optimizations.\n	See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#COMPLEMENT for details.");
      }
    } else {
      var msgSuffix = "";
      if (ensureOptimizations) {
        msgSuffix = "\n	This will disable the lexer's first char optimizations.\n	See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#REGEXP_PARSING for details.";
      }
      PRINT_ERROR(failedOptimizationPrefixMsg + "\n" + ("	Failed parsing: < " + regExp.toString() + " >\n") + ("	Using the regexp-to-ast library version: " + regexpToAstExports.VERSION + "\n") + "	Please open an issue at: https://github.com/bd82/regexp-to-ast/issues" + msgSuffix);
    }
  }
  return [];
}
function firstCharOptimizedIndices(ast, result, ignoreCase) {
  switch (ast.type) {
    case "Disjunction":
      for (var i = 0; i < ast.value.length; i++) {
        firstCharOptimizedIndices(ast.value[i], result, ignoreCase);
      }
      break;
    case "Alternative":
      var terms = ast.value;
      for (var i = 0; i < terms.length; i++) {
        var term = terms[i];
        switch (term.type) {
          case "EndAnchor":
          // A group back reference cannot affect potential starting char.
          // because if a back reference is the first production than automatically
          // the group being referenced has had to come BEFORE so its codes have already been added
          case "GroupBackReference":
          // assertions do not affect potential starting codes
          case "Lookahead":
          case "NegativeLookahead":
          case "StartAnchor":
          case "WordBoundary":
          case "NonWordBoundary":
            continue;
        }
        var atom = term;
        switch (atom.type) {
          case "Character":
            addOptimizedIdxToResult(atom.value, result, ignoreCase);
            break;
          case "Set":
            if (atom.complement === true) {
              throw Error(complementErrorMessage);
            }
            forEach(atom.value, function(code) {
              if (typeof code === "number") {
                addOptimizedIdxToResult(code, result, ignoreCase);
              } else {
                var range = code;
                if (ignoreCase === true) {
                  for (var rangeCode = range.from; rangeCode <= range.to; rangeCode++) {
                    addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                  }
                } else {
                  for (var rangeCode = range.from; rangeCode <= range.to && rangeCode < minOptimizationVal; rangeCode++) {
                    addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                  }
                  if (range.to >= minOptimizationVal) {
                    var minUnOptVal = range.from >= minOptimizationVal ? range.from : minOptimizationVal;
                    var maxUnOptVal = range.to;
                    var minOptIdx = charCodeToOptimizedIndex(minUnOptVal);
                    var maxOptIdx = charCodeToOptimizedIndex(maxUnOptVal);
                    for (var currOptIdx = minOptIdx; currOptIdx <= maxOptIdx; currOptIdx++) {
                      result[currOptIdx] = currOptIdx;
                    }
                  }
                }
              }
            });
            break;
          case "Group":
            firstCharOptimizedIndices(atom.value, result, ignoreCase);
            break;
          /* istanbul ignore next */
          default:
            throw Error("Non Exhaustive Match");
        }
        var isOptionalQuantifier = atom.quantifier !== void 0 && atom.quantifier.atLeast === 0;
        if (
          // A group may be optional due to empty contents /(?:)/
          // or if everything inside it is optional /((a)?)/
          atom.type === "Group" && isWholeOptional(atom) === false || // If this term is not a group it may only be optional if it has an optional quantifier
          atom.type !== "Group" && isOptionalQuantifier === false
        ) {
          break;
        }
      }
      break;
    /* istanbul ignore next */
    default:
      throw Error("non exhaustive match!");
  }
  return values(result);
}
function addOptimizedIdxToResult(code, result, ignoreCase) {
  var optimizedCharIdx = charCodeToOptimizedIndex(code);
  result[optimizedCharIdx] = optimizedCharIdx;
  if (ignoreCase === true) {
    handleIgnoreCase(code, result);
  }
}
function handleIgnoreCase(code, result) {
  var char = String.fromCharCode(code);
  var upperChar = char.toUpperCase();
  if (upperChar !== char) {
    var optimizedCharIdx = charCodeToOptimizedIndex(upperChar.charCodeAt(0));
    result[optimizedCharIdx] = optimizedCharIdx;
  } else {
    var lowerChar = char.toLowerCase();
    if (lowerChar !== char) {
      var optimizedCharIdx = charCodeToOptimizedIndex(lowerChar.charCodeAt(0));
      result[optimizedCharIdx] = optimizedCharIdx;
    }
  }
}
function findCode(setNode, targetCharCodes) {
  return find(setNode.value, function(codeOrRange) {
    if (typeof codeOrRange === "number") {
      return contains(targetCharCodes, codeOrRange);
    } else {
      var range_1 = codeOrRange;
      return find(targetCharCodes, function(targetCode) {
        return range_1.from <= targetCode && targetCode <= range_1.to;
      }) !== void 0;
    }
  });
}
function isWholeOptional(ast) {
  if (ast.quantifier && ast.quantifier.atLeast === 0) {
    return true;
  }
  if (!ast.value) {
    return false;
  }
  return isArray(ast.value) ? every(ast.value, isWholeOptional) : isWholeOptional(ast.value);
}
var CharCodeFinder = (
  /** @class */
  (function(_super) {
    __extends$a(CharCodeFinder2, _super);
    function CharCodeFinder2(targetCharCodes) {
      var _this = _super.call(this) || this;
      _this.targetCharCodes = targetCharCodes;
      _this.found = false;
      return _this;
    }
    CharCodeFinder2.prototype.visitChildren = function(node) {
      if (this.found === true) {
        return;
      }
      switch (node.type) {
        case "Lookahead":
          this.visitLookahead(node);
          return;
        case "NegativeLookahead":
          this.visitNegativeLookahead(node);
          return;
      }
      _super.prototype.visitChildren.call(this, node);
    };
    CharCodeFinder2.prototype.visitCharacter = function(node) {
      if (contains(this.targetCharCodes, node.value)) {
        this.found = true;
      }
    };
    CharCodeFinder2.prototype.visitSet = function(node) {
      if (node.complement) {
        if (findCode(node, this.targetCharCodes) === void 0) {
          this.found = true;
        }
      } else {
        if (findCode(node, this.targetCharCodes) !== void 0) {
          this.found = true;
        }
      }
    };
    return CharCodeFinder2;
  })(regexpToAstExports.BaseRegExpVisitor)
);
function canMatchCharCode(charCodes, pattern) {
  if (pattern instanceof RegExp) {
    var ast = getRegExpAst(pattern);
    var charCodeFinder = new CharCodeFinder(charCodes);
    charCodeFinder.visit(ast);
    return charCodeFinder.found;
  } else {
    return find(pattern, function(char) {
      return contains(charCodes, char.charCodeAt(0));
    }) !== void 0;
  }
}
var __extends$9 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var PATTERN = "PATTERN";
var DEFAULT_MODE = "defaultMode";
var MODES = "modes";
var SUPPORT_STICKY = typeof new RegExp("(?:)").sticky === "boolean";
function analyzeTokenTypes(tokenTypes, options) {
  options = defaults(options, {
    useSticky: SUPPORT_STICKY,
    debug: false,
    safeMode: false,
    positionTracking: "full",
    lineTerminatorCharacters: ["\r", "\n"],
    tracer: function(msg, action) {
      return action();
    }
  });
  var tracer = options.tracer;
  tracer("initCharCodeToOptimizedIndexMap", function() {
    initCharCodeToOptimizedIndexMap();
  });
  var onlyRelevantTypes;
  tracer("Reject Lexer.NA", function() {
    onlyRelevantTypes = reject(tokenTypes, function(currType) {
      return currType[PATTERN] === Lexer.NA;
    });
  });
  var hasCustom = false;
  var allTransformedPatterns;
  tracer("Transform Patterns", function() {
    hasCustom = false;
    allTransformedPatterns = map(onlyRelevantTypes, function(currType) {
      var currPattern = currType[PATTERN];
      if (isRegExp(currPattern)) {
        var regExpSource = currPattern.source;
        if (regExpSource.length === 1 && // only these regExp meta characters which can appear in a length one regExp
        regExpSource !== "^" && regExpSource !== "$" && regExpSource !== ".") {
          return regExpSource;
        } else if (regExpSource.length === 2 && regExpSource[0] === "\\" && // not a meta character
        !contains([
          "d",
          "D",
          "s",
          "S",
          "t",
          "r",
          "n",
          "t",
          "0",
          "c",
          "b",
          "B",
          "f",
          "v",
          "w",
          "W"
        ], regExpSource[1])) {
          return regExpSource[1];
        } else {
          return options.useSticky ? addStickyFlag(currPattern) : addStartOfInput(currPattern);
        }
      } else if (isFunction(currPattern)) {
        hasCustom = true;
        return { exec: currPattern };
      } else if (has(currPattern, "exec")) {
        hasCustom = true;
        return currPattern;
      } else if (typeof currPattern === "string") {
        if (currPattern.length === 1) {
          return currPattern;
        } else {
          var escapedRegExpString = currPattern.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
          var wrappedRegExp = new RegExp(escapedRegExpString);
          return options.useSticky ? addStickyFlag(wrappedRegExp) : addStartOfInput(wrappedRegExp);
        }
      } else {
        throw Error("non exhaustive match");
      }
    });
  });
  var patternIdxToType;
  var patternIdxToGroup;
  var patternIdxToLongerAltIdx;
  var patternIdxToPushMode;
  var patternIdxToPopMode;
  tracer("misc mapping", function() {
    patternIdxToType = map(onlyRelevantTypes, function(currType) {
      return currType.tokenTypeIdx;
    });
    patternIdxToGroup = map(onlyRelevantTypes, function(clazz) {
      var groupName = clazz.GROUP;
      if (groupName === Lexer.SKIPPED) {
        return void 0;
      } else if (isString(groupName)) {
        return groupName;
      } else if (isUndefined(groupName)) {
        return false;
      } else {
        throw Error("non exhaustive match");
      }
    });
    patternIdxToLongerAltIdx = map(onlyRelevantTypes, function(clazz) {
      var longerAltType = clazz.LONGER_ALT;
      if (longerAltType) {
        var longerAltIdx = indexOf(onlyRelevantTypes, longerAltType);
        return longerAltIdx;
      }
    });
    patternIdxToPushMode = map(onlyRelevantTypes, function(clazz) {
      return clazz.PUSH_MODE;
    });
    patternIdxToPopMode = map(onlyRelevantTypes, function(clazz) {
      return has(clazz, "POP_MODE");
    });
  });
  var patternIdxToCanLineTerminator;
  tracer("Line Terminator Handling", function() {
    var lineTerminatorCharCodes = getCharCodes(options.lineTerminatorCharacters);
    patternIdxToCanLineTerminator = map(onlyRelevantTypes, function(tokType) {
      return false;
    });
    if (options.positionTracking !== "onlyOffset") {
      patternIdxToCanLineTerminator = map(onlyRelevantTypes, function(tokType) {
        if (has(tokType, "LINE_BREAKS")) {
          return tokType.LINE_BREAKS;
        } else {
          if (checkLineBreaksIssues(tokType, lineTerminatorCharCodes) === false) {
            return canMatchCharCode(lineTerminatorCharCodes, tokType.PATTERN);
          }
        }
      });
    }
  });
  var patternIdxToIsCustom;
  var patternIdxToShort;
  var emptyGroups;
  var patternIdxToConfig;
  tracer("Misc Mapping #2", function() {
    patternIdxToIsCustom = map(onlyRelevantTypes, isCustomPattern);
    patternIdxToShort = map(allTransformedPatterns, isShortPattern);
    emptyGroups = reduce(onlyRelevantTypes, function(acc, clazz) {
      var groupName = clazz.GROUP;
      if (isString(groupName) && !(groupName === Lexer.SKIPPED)) {
        acc[groupName] = [];
      }
      return acc;
    }, {});
    patternIdxToConfig = map(allTransformedPatterns, function(x, idx) {
      return {
        pattern: allTransformedPatterns[idx],
        longerAlt: patternIdxToLongerAltIdx[idx],
        canLineTerminator: patternIdxToCanLineTerminator[idx],
        isCustom: patternIdxToIsCustom[idx],
        short: patternIdxToShort[idx],
        group: patternIdxToGroup[idx],
        push: patternIdxToPushMode[idx],
        pop: patternIdxToPopMode[idx],
        tokenTypeIdx: patternIdxToType[idx],
        tokenType: onlyRelevantTypes[idx]
      };
    });
  });
  var canBeOptimized = true;
  var charCodeToPatternIdxToConfig = [];
  if (!options.safeMode) {
    tracer("First Char Optimization", function() {
      charCodeToPatternIdxToConfig = reduce(onlyRelevantTypes, function(result, currTokType, idx) {
        if (typeof currTokType.PATTERN === "string") {
          var charCode = currTokType.PATTERN.charCodeAt(0);
          var optimizedIdx = charCodeToOptimizedIndex(charCode);
          addToMapOfArrays(result, optimizedIdx, patternIdxToConfig[idx]);
        } else if (isArray(currTokType.START_CHARS_HINT)) {
          var lastOptimizedIdx_1;
          forEach(currTokType.START_CHARS_HINT, function(charOrInt) {
            var charCode2 = typeof charOrInt === "string" ? charOrInt.charCodeAt(0) : charOrInt;
            var currOptimizedIdx = charCodeToOptimizedIndex(charCode2);
            if (lastOptimizedIdx_1 !== currOptimizedIdx) {
              lastOptimizedIdx_1 = currOptimizedIdx;
              addToMapOfArrays(result, currOptimizedIdx, patternIdxToConfig[idx]);
            }
          });
        } else if (isRegExp(currTokType.PATTERN)) {
          if (currTokType.PATTERN.unicode) {
            canBeOptimized = false;
            if (options.ensureOptimizations) {
              PRINT_ERROR("" + failedOptimizationPrefixMsg + ("	Unable to analyze < " + currTokType.PATTERN.toString() + " > pattern.\n") + "	The regexp unicode flag is not currently supported by the regexp-to-ast library.\n	This will disable the lexer's first char optimizations.\n	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#UNICODE_OPTIMIZE");
            }
          } else {
            var optimizedCodes = getOptimizedStartCodesIndices(currTokType.PATTERN, options.ensureOptimizations);
            if (isEmpty(optimizedCodes)) {
              canBeOptimized = false;
            }
            forEach(optimizedCodes, function(code) {
              addToMapOfArrays(result, code, patternIdxToConfig[idx]);
            });
          }
        } else {
          if (options.ensureOptimizations) {
            PRINT_ERROR("" + failedOptimizationPrefixMsg + ("	TokenType: <" + currTokType.name + "> is using a custom token pattern without providing <start_chars_hint> parameter.\n") + "	This will disable the lexer's first char optimizations.\n	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#CUSTOM_OPTIMIZE");
          }
          canBeOptimized = false;
        }
        return result;
      }, []);
    });
  }
  tracer("ArrayPacking", function() {
    charCodeToPatternIdxToConfig = packArray(charCodeToPatternIdxToConfig);
  });
  return {
    emptyGroups,
    patternIdxToConfig,
    charCodeToPatternIdxToConfig,
    hasCustom,
    canBeOptimized
  };
}
function validatePatterns(tokenTypes, validModesNames) {
  var errors = [];
  var missingResult = findMissingPatterns(tokenTypes);
  errors = errors.concat(missingResult.errors);
  var invalidResult = findInvalidPatterns(missingResult.valid);
  var validTokenTypes = invalidResult.valid;
  errors = errors.concat(invalidResult.errors);
  errors = errors.concat(validateRegExpPattern(validTokenTypes));
  errors = errors.concat(findInvalidGroupType(validTokenTypes));
  errors = errors.concat(findModesThatDoNotExist(validTokenTypes, validModesNames));
  errors = errors.concat(findUnreachablePatterns(validTokenTypes));
  return errors;
}
function validateRegExpPattern(tokenTypes) {
  var errors = [];
  var withRegExpPatterns = filter(tokenTypes, function(currTokType) {
    return isRegExp(currTokType[PATTERN]);
  });
  errors = errors.concat(findEndOfInputAnchor(withRegExpPatterns));
  errors = errors.concat(findStartOfInputAnchor(withRegExpPatterns));
  errors = errors.concat(findUnsupportedFlags(withRegExpPatterns));
  errors = errors.concat(findDuplicatePatterns(withRegExpPatterns));
  errors = errors.concat(findEmptyMatchRegExps(withRegExpPatterns));
  return errors;
}
function findMissingPatterns(tokenTypes) {
  var tokenTypesWithMissingPattern = filter(tokenTypes, function(currType) {
    return !has(currType, PATTERN);
  });
  var errors = map(tokenTypesWithMissingPattern, function(currType) {
    return {
      message: "Token Type: ->" + currType.name + "<- missing static 'PATTERN' property",
      type: LexerDefinitionErrorType.MISSING_PATTERN,
      tokenTypes: [currType]
    };
  });
  var valid = difference(tokenTypes, tokenTypesWithMissingPattern);
  return { errors, valid };
}
function findInvalidPatterns(tokenTypes) {
  var tokenTypesWithInvalidPattern = filter(tokenTypes, function(currType) {
    var pattern = currType[PATTERN];
    return !isRegExp(pattern) && !isFunction(pattern) && !has(pattern, "exec") && !isString(pattern);
  });
  var errors = map(tokenTypesWithInvalidPattern, function(currType) {
    return {
      message: "Token Type: ->" + currType.name + "<- static 'PATTERN' can only be a RegExp, a Function matching the {CustomPatternMatcherFunc} type or an Object matching the {ICustomPattern} interface.",
      type: LexerDefinitionErrorType.INVALID_PATTERN,
      tokenTypes: [currType]
    };
  });
  var valid = difference(tokenTypes, tokenTypesWithInvalidPattern);
  return { errors, valid };
}
var end_of_input = /[^\\][\$]/;
function findEndOfInputAnchor(tokenTypes) {
  var EndAnchorFinder = (
    /** @class */
    (function(_super) {
      __extends$9(EndAnchorFinder2, _super);
      function EndAnchorFinder2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.found = false;
        return _this;
      }
      EndAnchorFinder2.prototype.visitEndAnchor = function(node) {
        this.found = true;
      };
      return EndAnchorFinder2;
    })(regexpToAstExports.BaseRegExpVisitor)
  );
  var invalidRegex = filter(tokenTypes, function(currType) {
    var pattern = currType[PATTERN];
    try {
      var regexpAst = getRegExpAst(pattern);
      var endAnchorVisitor = new EndAnchorFinder();
      endAnchorVisitor.visit(regexpAst);
      return endAnchorVisitor.found;
    } catch (e) {
      return end_of_input.test(pattern.source);
    }
  });
  var errors = map(invalidRegex, function(currType) {
    return {
      message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain end of input anchor '$'\n	See sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#ANCHORS	for details.",
      type: LexerDefinitionErrorType.EOI_ANCHOR_FOUND,
      tokenTypes: [currType]
    };
  });
  return errors;
}
function findEmptyMatchRegExps(tokenTypes) {
  var matchesEmptyString = filter(tokenTypes, function(currType) {
    var pattern = currType[PATTERN];
    return pattern.test("");
  });
  var errors = map(matchesEmptyString, function(currType) {
    return {
      message: "Token Type: ->" + currType.name + "<- static 'PATTERN' must not match an empty string",
      type: LexerDefinitionErrorType.EMPTY_MATCH_PATTERN,
      tokenTypes: [currType]
    };
  });
  return errors;
}
var start_of_input = /[^\\[][\^]|^\^/;
function findStartOfInputAnchor(tokenTypes) {
  var StartAnchorFinder = (
    /** @class */
    (function(_super) {
      __extends$9(StartAnchorFinder2, _super);
      function StartAnchorFinder2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.found = false;
        return _this;
      }
      StartAnchorFinder2.prototype.visitStartAnchor = function(node) {
        this.found = true;
      };
      return StartAnchorFinder2;
    })(regexpToAstExports.BaseRegExpVisitor)
  );
  var invalidRegex = filter(tokenTypes, function(currType) {
    var pattern = currType[PATTERN];
    try {
      var regexpAst = getRegExpAst(pattern);
      var startAnchorVisitor = new StartAnchorFinder();
      startAnchorVisitor.visit(regexpAst);
      return startAnchorVisitor.found;
    } catch (e) {
      return start_of_input.test(pattern.source);
    }
  });
  var errors = map(invalidRegex, function(currType) {
    return {
      message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain start of input anchor '^'\n	See https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#ANCHORS	for details.",
      type: LexerDefinitionErrorType.SOI_ANCHOR_FOUND,
      tokenTypes: [currType]
    };
  });
  return errors;
}
function findUnsupportedFlags(tokenTypes) {
  var invalidFlags = filter(tokenTypes, function(currType) {
    var pattern = currType[PATTERN];
    return pattern instanceof RegExp && (pattern.multiline || pattern.global);
  });
  var errors = map(invalidFlags, function(currType) {
    return {
      message: "Token Type: ->" + currType.name + "<- static 'PATTERN' may NOT contain global('g') or multiline('m')",
      type: LexerDefinitionErrorType.UNSUPPORTED_FLAGS_FOUND,
      tokenTypes: [currType]
    };
  });
  return errors;
}
function findDuplicatePatterns(tokenTypes) {
  var found = [];
  var identicalPatterns = map(tokenTypes, function(outerType) {
    return reduce(tokenTypes, function(result, innerType) {
      if (outerType.PATTERN.source === innerType.PATTERN.source && !contains(found, innerType) && innerType.PATTERN !== Lexer.NA) {
        found.push(innerType);
        result.push(innerType);
        return result;
      }
      return result;
    }, []);
  });
  identicalPatterns = compact(identicalPatterns);
  var duplicatePatterns = filter(identicalPatterns, function(currIdenticalSet) {
    return currIdenticalSet.length > 1;
  });
  var errors = map(duplicatePatterns, function(setOfIdentical) {
    var tokenTypeNames = map(setOfIdentical, function(currType) {
      return currType.name;
    });
    var dupPatternSrc = first$1(setOfIdentical).PATTERN;
    return {
      message: "The same RegExp pattern ->" + dupPatternSrc + "<-" + ("has been used in all of the following Token Types: " + tokenTypeNames.join(", ") + " <-"),
      type: LexerDefinitionErrorType.DUPLICATE_PATTERNS_FOUND,
      tokenTypes: setOfIdentical
    };
  });
  return errors;
}
function findInvalidGroupType(tokenTypes) {
  var invalidTypes = filter(tokenTypes, function(clazz) {
    if (!has(clazz, "GROUP")) {
      return false;
    }
    var group = clazz.GROUP;
    return group !== Lexer.SKIPPED && group !== Lexer.NA && !isString(group);
  });
  var errors = map(invalidTypes, function(currType) {
    return {
      message: "Token Type: ->" + currType.name + "<- static 'GROUP' can only be Lexer.SKIPPED/Lexer.NA/A String",
      type: LexerDefinitionErrorType.INVALID_GROUP_TYPE_FOUND,
      tokenTypes: [currType]
    };
  });
  return errors;
}
function findModesThatDoNotExist(tokenTypes, validModes) {
  var invalidModes = filter(tokenTypes, function(clazz) {
    return clazz.PUSH_MODE !== void 0 && !contains(validModes, clazz.PUSH_MODE);
  });
  var errors = map(invalidModes, function(tokType) {
    var msg = "Token Type: ->" + tokType.name + "<- static 'PUSH_MODE' value cannot refer to a Lexer Mode ->" + tokType.PUSH_MODE + "<-which does not exist";
    return {
      message: msg,
      type: LexerDefinitionErrorType.PUSH_MODE_DOES_NOT_EXIST,
      tokenTypes: [tokType]
    };
  });
  return errors;
}
function findUnreachablePatterns(tokenTypes) {
  var errors = [];
  var canBeTested = reduce(tokenTypes, function(result, tokType, idx) {
    var pattern = tokType.PATTERN;
    if (pattern === Lexer.NA) {
      return result;
    }
    if (isString(pattern)) {
      result.push({ str: pattern, idx, tokenType: tokType });
    } else if (isRegExp(pattern) && noMetaChar(pattern)) {
      result.push({ str: pattern.source, idx, tokenType: tokType });
    }
    return result;
  }, []);
  forEach(tokenTypes, function(tokType, testIdx) {
    forEach(canBeTested, function(_a) {
      var str = _a.str, idx = _a.idx, tokenType = _a.tokenType;
      if (testIdx < idx && testTokenType(str, tokType.PATTERN)) {
        var msg = "Token: ->" + tokenType.name + "<- can never be matched.\n" + ("Because it appears AFTER the Token Type ->" + tokType.name + "<-") + "in the lexer's definition.\nSee https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#UNREACHABLE";
        errors.push({
          message: msg,
          type: LexerDefinitionErrorType.UNREACHABLE_PATTERN,
          tokenTypes: [tokType, tokenType]
        });
      }
    });
  });
  return errors;
}
function testTokenType(str, pattern) {
  if (isRegExp(pattern)) {
    var regExpArray = pattern.exec(str);
    return regExpArray !== null && regExpArray.index === 0;
  } else if (isFunction(pattern)) {
    return pattern(str, 0, [], {});
  } else if (has(pattern, "exec")) {
    return pattern.exec(str, 0, [], {});
  } else if (typeof pattern === "string") {
    return pattern === str;
  } else {
    throw Error("non exhaustive match");
  }
}
function noMetaChar(regExp) {
  var metaChars = [
    ".",
    "\\",
    "[",
    "]",
    "|",
    "^",
    "$",
    "(",
    ")",
    "?",
    "*",
    "+",
    "{"
  ];
  return find(metaChars, function(char) {
    return regExp.source.indexOf(char) !== -1;
  }) === void 0;
}
function addStartOfInput(pattern) {
  var flags = pattern.ignoreCase ? "i" : "";
  return new RegExp("^(?:" + pattern.source + ")", flags);
}
function addStickyFlag(pattern) {
  var flags = pattern.ignoreCase ? "iy" : "y";
  return new RegExp("" + pattern.source, flags);
}
function performRuntimeChecks(lexerDefinition, trackLines, lineTerminatorCharacters) {
  var errors = [];
  if (!has(lexerDefinition, DEFAULT_MODE)) {
    errors.push({
      message: "A MultiMode Lexer cannot be initialized without a <" + DEFAULT_MODE + "> property in its definition\n",
      type: LexerDefinitionErrorType.MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE
    });
  }
  if (!has(lexerDefinition, MODES)) {
    errors.push({
      message: "A MultiMode Lexer cannot be initialized without a <" + MODES + "> property in its definition\n",
      type: LexerDefinitionErrorType.MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY
    });
  }
  if (has(lexerDefinition, MODES) && has(lexerDefinition, DEFAULT_MODE) && !has(lexerDefinition.modes, lexerDefinition.defaultMode)) {
    errors.push({
      message: "A MultiMode Lexer cannot be initialized with a " + DEFAULT_MODE + ": <" + lexerDefinition.defaultMode + ">which does not exist\n",
      type: LexerDefinitionErrorType.MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST
    });
  }
  if (has(lexerDefinition, MODES)) {
    forEach(lexerDefinition.modes, function(currModeValue, currModeName) {
      forEach(currModeValue, function(currTokType, currIdx) {
        if (isUndefined(currTokType)) {
          errors.push({
            message: "A Lexer cannot be initialized using an undefined Token Type. Mode:" + ("<" + currModeName + "> at index: <" + currIdx + ">\n"),
            type: LexerDefinitionErrorType.LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED
          });
        }
      });
    });
  }
  return errors;
}
function performWarningRuntimeChecks(lexerDefinition, trackLines, lineTerminatorCharacters) {
  var warnings = [];
  var hasAnyLineBreak = false;
  var allTokenTypes = compact(flatten(mapValues(lexerDefinition.modes, function(tokTypes) {
    return tokTypes;
  })));
  var concreteTokenTypes = reject(allTokenTypes, function(currType) {
    return currType[PATTERN] === Lexer.NA;
  });
  var terminatorCharCodes = getCharCodes(lineTerminatorCharacters);
  if (trackLines) {
    forEach(concreteTokenTypes, function(tokType) {
      var currIssue = checkLineBreaksIssues(tokType, terminatorCharCodes);
      if (currIssue !== false) {
        var message = buildLineBreakIssueMessage(tokType, currIssue);
        var warningDescriptor = {
          message,
          type: currIssue.issue,
          tokenType: tokType
        };
        warnings.push(warningDescriptor);
      } else {
        if (has(tokType, "LINE_BREAKS")) {
          if (tokType.LINE_BREAKS === true) {
            hasAnyLineBreak = true;
          }
        } else {
          if (canMatchCharCode(terminatorCharCodes, tokType.PATTERN)) {
            hasAnyLineBreak = true;
          }
        }
      }
    });
  }
  if (trackLines && !hasAnyLineBreak) {
    warnings.push({
      message: "Warning: No LINE_BREAKS Found.\n	This Lexer has been defined to track line and column information,\n	But none of the Token Types can be identified as matching a line terminator.\n	See https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#LINE_BREAKS \n	for details.",
      type: LexerDefinitionErrorType.NO_LINE_BREAKS_FLAGS
    });
  }
  return warnings;
}
function cloneEmptyGroups(emptyGroups) {
  var clonedResult = {};
  var groupKeys = keys(emptyGroups);
  forEach(groupKeys, function(currKey) {
    var currGroupValue = emptyGroups[currKey];
    if (isArray(currGroupValue)) {
      clonedResult[currKey] = [];
    } else {
      throw Error("non exhaustive match");
    }
  });
  return clonedResult;
}
function isCustomPattern(tokenType) {
  var pattern = tokenType.PATTERN;
  if (isRegExp(pattern)) {
    return false;
  } else if (isFunction(pattern)) {
    return true;
  } else if (has(pattern, "exec")) {
    return true;
  } else if (isString(pattern)) {
    return false;
  } else {
    throw Error("non exhaustive match");
  }
}
function isShortPattern(pattern) {
  if (isString(pattern) && pattern.length === 1) {
    return pattern.charCodeAt(0);
  } else {
    return false;
  }
}
var LineTerminatorOptimizedTester = {
  // implements /\n|\r\n?/g.test
  test: function(text) {
    var len = text.length;
    for (var i = this.lastIndex; i < len; i++) {
      var c = text.charCodeAt(i);
      if (c === 10) {
        this.lastIndex = i + 1;
        return true;
      } else if (c === 13) {
        if (text.charCodeAt(i + 1) === 10) {
          this.lastIndex = i + 2;
        } else {
          this.lastIndex = i + 1;
        }
        return true;
      }
    }
    return false;
  },
  lastIndex: 0
};
function checkLineBreaksIssues(tokType, lineTerminatorCharCodes) {
  if (has(tokType, "LINE_BREAKS")) {
    return false;
  } else {
    if (isRegExp(tokType.PATTERN)) {
      try {
        canMatchCharCode(lineTerminatorCharCodes, tokType.PATTERN);
      } catch (e) {
        return {
          issue: LexerDefinitionErrorType.IDENTIFY_TERMINATOR,
          errMsg: e.message
        };
      }
      return false;
    } else if (isString(tokType.PATTERN)) {
      return false;
    } else if (isCustomPattern(tokType)) {
      return { issue: LexerDefinitionErrorType.CUSTOM_LINE_BREAK };
    } else {
      throw Error("non exhaustive match");
    }
  }
}
function buildLineBreakIssueMessage(tokType, details) {
  if (details.issue === LexerDefinitionErrorType.IDENTIFY_TERMINATOR) {
    return "Warning: unable to identify line terminator usage in pattern.\n" + ("	The problem is in the <" + tokType.name + "> Token Type\n") + ("	 Root cause: " + details.errMsg + ".\n") + "	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#IDENTIFY_TERMINATOR";
  } else if (details.issue === LexerDefinitionErrorType.CUSTOM_LINE_BREAK) {
    return "Warning: A Custom Token Pattern should specify the <line_breaks> option.\n" + ("	The problem is in the <" + tokType.name + "> Token Type\n") + "	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#CUSTOM_LINE_BREAK";
  } else {
    throw Error("non exhaustive match");
  }
}
function getCharCodes(charsOrCodes) {
  var charCodes = map(charsOrCodes, function(numOrString) {
    if (isString(numOrString) && numOrString.length > 0) {
      return numOrString.charCodeAt(0);
    } else {
      return numOrString;
    }
  });
  return charCodes;
}
function addToMapOfArrays(map2, key, value) {
  if (map2[key] === void 0) {
    map2[key] = [value];
  } else {
    map2[key].push(value);
  }
}
var minOptimizationVal = 256;
function charCodeToOptimizedIndex(charCode) {
  return charCode < minOptimizationVal ? charCode : charCodeToOptimizedIdxMap[charCode];
}
var charCodeToOptimizedIdxMap = [];
function initCharCodeToOptimizedIndexMap() {
  if (isEmpty(charCodeToOptimizedIdxMap)) {
    charCodeToOptimizedIdxMap = new Array(65536);
    for (var i = 0; i < 65536; i++) {
      charCodeToOptimizedIdxMap[i] = i > 255 ? 255 + ~~(i / 255) : i;
    }
  }
}
function tokenStructuredMatcher(tokInstance, tokConstructor) {
  var instanceType = tokInstance.tokenTypeIdx;
  if (instanceType === tokConstructor.tokenTypeIdx) {
    return true;
  } else {
    return tokConstructor.isParent === true && tokConstructor.categoryMatchesMap[instanceType] === true;
  }
}
function tokenStructuredMatcherNoCategories(token, tokType) {
  return token.tokenTypeIdx === tokType.tokenTypeIdx;
}
var tokenShortNameIdx = 1;
var tokenIdxToClass = {};
function augmentTokenTypes(tokenTypes) {
  var tokenTypesAndParents = expandCategories(tokenTypes);
  assignTokenDefaultProps(tokenTypesAndParents);
  assignCategoriesMapProp(tokenTypesAndParents);
  assignCategoriesTokensProp(tokenTypesAndParents);
  forEach(tokenTypesAndParents, function(tokType) {
    tokType.isParent = tokType.categoryMatches.length > 0;
  });
}
function expandCategories(tokenTypes) {
  var result = cloneArr(tokenTypes);
  var categories = tokenTypes;
  var searching = true;
  while (searching) {
    categories = compact(flatten(map(categories, function(currTokType) {
      return currTokType.CATEGORIES;
    })));
    var newCategories = difference(categories, result);
    result = result.concat(newCategories);
    if (isEmpty(newCategories)) {
      searching = false;
    } else {
      categories = newCategories;
    }
  }
  return result;
}
function assignTokenDefaultProps(tokenTypes) {
  forEach(tokenTypes, function(currTokType) {
    if (!hasShortKeyProperty(currTokType)) {
      tokenIdxToClass[tokenShortNameIdx] = currTokType;
      currTokType.tokenTypeIdx = tokenShortNameIdx++;
    }
    if (hasCategoriesProperty(currTokType) && !isArray(currTokType.CATEGORIES)) {
      currTokType.CATEGORIES = [currTokType.CATEGORIES];
    }
    if (!hasCategoriesProperty(currTokType)) {
      currTokType.CATEGORIES = [];
    }
    if (!hasExtendingTokensTypesProperty(currTokType)) {
      currTokType.categoryMatches = [];
    }
    if (!hasExtendingTokensTypesMapProperty(currTokType)) {
      currTokType.categoryMatchesMap = {};
    }
  });
}
function assignCategoriesTokensProp(tokenTypes) {
  forEach(tokenTypes, function(currTokType) {
    currTokType.categoryMatches = [];
    forEach(currTokType.categoryMatchesMap, function(val, key) {
      currTokType.categoryMatches.push(tokenIdxToClass[key].tokenTypeIdx);
    });
  });
}
function assignCategoriesMapProp(tokenTypes) {
  forEach(tokenTypes, function(currTokType) {
    singleAssignCategoriesToksMap([], currTokType);
  });
}
function singleAssignCategoriesToksMap(path, nextNode) {
  forEach(path, function(pathNode) {
    nextNode.categoryMatchesMap[pathNode.tokenTypeIdx] = true;
  });
  forEach(nextNode.CATEGORIES, function(nextCategory) {
    var newPath = path.concat(nextNode);
    if (!contains(newPath, nextCategory)) {
      singleAssignCategoriesToksMap(newPath, nextCategory);
    }
  });
}
function hasShortKeyProperty(tokType) {
  return has(tokType, "tokenTypeIdx");
}
function hasCategoriesProperty(tokType) {
  return has(tokType, "CATEGORIES");
}
function hasExtendingTokensTypesProperty(tokType) {
  return has(tokType, "categoryMatches");
}
function hasExtendingTokensTypesMapProperty(tokType) {
  return has(tokType, "categoryMatchesMap");
}
function isTokenType(tokType) {
  return has(tokType, "tokenTypeIdx");
}
var defaultLexerErrorProvider = {
  buildUnableToPopLexerModeMessage: function(token) {
    return "Unable to pop Lexer Mode after encountering Token ->" + token.image + "<- The Mode Stack is empty";
  },
  buildUnexpectedCharactersMessage: function(fullText, startOffset, length, line, column) {
    return "unexpected character: ->" + fullText.charAt(startOffset) + "<- at offset: " + startOffset + "," + (" skipped " + length + " characters.");
  }
};
var LexerDefinitionErrorType;
(function(LexerDefinitionErrorType2) {
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["MISSING_PATTERN"] = 0] = "MISSING_PATTERN";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["INVALID_PATTERN"] = 1] = "INVALID_PATTERN";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["EOI_ANCHOR_FOUND"] = 2] = "EOI_ANCHOR_FOUND";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["UNSUPPORTED_FLAGS_FOUND"] = 3] = "UNSUPPORTED_FLAGS_FOUND";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["DUPLICATE_PATTERNS_FOUND"] = 4] = "DUPLICATE_PATTERNS_FOUND";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["INVALID_GROUP_TYPE_FOUND"] = 5] = "INVALID_GROUP_TYPE_FOUND";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["PUSH_MODE_DOES_NOT_EXIST"] = 6] = "PUSH_MODE_DOES_NOT_EXIST";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE"] = 7] = "MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY"] = 8] = "MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST"] = 9] = "MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED"] = 10] = "LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["SOI_ANCHOR_FOUND"] = 11] = "SOI_ANCHOR_FOUND";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["EMPTY_MATCH_PATTERN"] = 12] = "EMPTY_MATCH_PATTERN";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["NO_LINE_BREAKS_FLAGS"] = 13] = "NO_LINE_BREAKS_FLAGS";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["UNREACHABLE_PATTERN"] = 14] = "UNREACHABLE_PATTERN";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["IDENTIFY_TERMINATOR"] = 15] = "IDENTIFY_TERMINATOR";
  LexerDefinitionErrorType2[LexerDefinitionErrorType2["CUSTOM_LINE_BREAK"] = 16] = "CUSTOM_LINE_BREAK";
})(LexerDefinitionErrorType || (LexerDefinitionErrorType = {}));
var DEFAULT_LEXER_CONFIG = {
  deferDefinitionErrorsHandling: false,
  positionTracking: "full",
  lineTerminatorsPattern: /\n|\r\n?/g,
  lineTerminatorCharacters: ["\n", "\r"],
  ensureOptimizations: false,
  safeMode: false,
  errorMessageProvider: defaultLexerErrorProvider,
  traceInitPerf: false,
  skipValidations: false
};
Object.freeze(DEFAULT_LEXER_CONFIG);
var Lexer = (
  /** @class */
  (function() {
    function Lexer2(lexerDefinition, config) {
      var _this = this;
      if (config === void 0) {
        config = DEFAULT_LEXER_CONFIG;
      }
      this.lexerDefinition = lexerDefinition;
      this.lexerDefinitionErrors = [];
      this.lexerDefinitionWarning = [];
      this.patternIdxToConfig = {};
      this.charCodeToPatternIdxToConfig = {};
      this.modes = [];
      this.emptyGroups = {};
      this.config = void 0;
      this.trackStartLines = true;
      this.trackEndLines = true;
      this.hasCustom = false;
      this.canModeBeOptimized = {};
      if (typeof config === "boolean") {
        throw Error("The second argument to the Lexer constructor is now an ILexerConfig Object.\na boolean 2nd argument is no longer supported");
      }
      this.config = merge(DEFAULT_LEXER_CONFIG, config);
      var traceInitVal = this.config.traceInitPerf;
      if (traceInitVal === true) {
        this.traceInitMaxIdent = Infinity;
        this.traceInitPerf = true;
      } else if (typeof traceInitVal === "number") {
        this.traceInitMaxIdent = traceInitVal;
        this.traceInitPerf = true;
      }
      this.traceInitIndent = -1;
      this.TRACE_INIT("Lexer Constructor", function() {
        var actualDefinition;
        var hasOnlySingleMode = true;
        _this.TRACE_INIT("Lexer Config handling", function() {
          if (_this.config.lineTerminatorsPattern === DEFAULT_LEXER_CONFIG.lineTerminatorsPattern) {
            _this.config.lineTerminatorsPattern = LineTerminatorOptimizedTester;
          } else {
            if (_this.config.lineTerminatorCharacters === DEFAULT_LEXER_CONFIG.lineTerminatorCharacters) {
              throw Error("Error: Missing <lineTerminatorCharacters> property on the Lexer config.\n	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#MISSING_LINE_TERM_CHARS");
            }
          }
          if (config.safeMode && config.ensureOptimizations) {
            throw Error('"safeMode" and "ensureOptimizations" flags are mutually exclusive.');
          }
          _this.trackStartLines = /full|onlyStart/i.test(_this.config.positionTracking);
          _this.trackEndLines = /full/i.test(_this.config.positionTracking);
          if (isArray(lexerDefinition)) {
            actualDefinition = { modes: {} };
            actualDefinition.modes[DEFAULT_MODE] = cloneArr(lexerDefinition);
            actualDefinition[DEFAULT_MODE] = DEFAULT_MODE;
          } else {
            hasOnlySingleMode = false;
            actualDefinition = cloneObj(lexerDefinition);
          }
        });
        if (_this.config.skipValidations === false) {
          _this.TRACE_INIT("performRuntimeChecks", function() {
            _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat(performRuntimeChecks(actualDefinition, _this.trackStartLines, _this.config.lineTerminatorCharacters));
          });
          _this.TRACE_INIT("performWarningRuntimeChecks", function() {
            _this.lexerDefinitionWarning = _this.lexerDefinitionWarning.concat(performWarningRuntimeChecks(actualDefinition, _this.trackStartLines, _this.config.lineTerminatorCharacters));
          });
        }
        actualDefinition.modes = actualDefinition.modes ? actualDefinition.modes : {};
        forEach(actualDefinition.modes, function(currModeValue, currModeName) {
          actualDefinition.modes[currModeName] = reject(currModeValue, function(currTokType) {
            return isUndefined(currTokType);
          });
        });
        var allModeNames = keys(actualDefinition.modes);
        forEach(actualDefinition.modes, function(currModDef, currModName) {
          _this.TRACE_INIT("Mode: <" + currModName + "> processing", function() {
            _this.modes.push(currModName);
            if (_this.config.skipValidations === false) {
              _this.TRACE_INIT("validatePatterns", function() {
                _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat(validatePatterns(currModDef, allModeNames));
              });
            }
            if (isEmpty(_this.lexerDefinitionErrors)) {
              augmentTokenTypes(currModDef);
              var currAnalyzeResult_1;
              _this.TRACE_INIT("analyzeTokenTypes", function() {
                currAnalyzeResult_1 = analyzeTokenTypes(currModDef, {
                  lineTerminatorCharacters: _this.config.lineTerminatorCharacters,
                  positionTracking: config.positionTracking,
                  ensureOptimizations: config.ensureOptimizations,
                  safeMode: config.safeMode,
                  tracer: _this.TRACE_INIT.bind(_this)
                });
              });
              _this.patternIdxToConfig[currModName] = currAnalyzeResult_1.patternIdxToConfig;
              _this.charCodeToPatternIdxToConfig[currModName] = currAnalyzeResult_1.charCodeToPatternIdxToConfig;
              _this.emptyGroups = merge(_this.emptyGroups, currAnalyzeResult_1.emptyGroups);
              _this.hasCustom = currAnalyzeResult_1.hasCustom || _this.hasCustom;
              _this.canModeBeOptimized[currModName] = currAnalyzeResult_1.canBeOptimized;
            }
          });
        });
        _this.defaultMode = actualDefinition.defaultMode;
        if (!isEmpty(_this.lexerDefinitionErrors) && !_this.config.deferDefinitionErrorsHandling) {
          var allErrMessages = map(_this.lexerDefinitionErrors, function(error2) {
            return error2.message;
          });
          var allErrMessagesString = allErrMessages.join("-----------------------\n");
          throw new Error("Errors detected in definition of Lexer:\n" + allErrMessagesString);
        }
        forEach(_this.lexerDefinitionWarning, function(warningDescriptor) {
          PRINT_WARNING(warningDescriptor.message);
        });
        _this.TRACE_INIT("Choosing sub-methods implementations", function() {
          if (SUPPORT_STICKY) {
            _this.chopInput = IDENTITY;
            _this.match = _this.matchWithTest;
          } else {
            _this.updateLastIndex = NOOP;
            _this.match = _this.matchWithExec;
          }
          if (hasOnlySingleMode) {
            _this.handleModes = NOOP;
          }
          if (_this.trackStartLines === false) {
            _this.computeNewColumn = IDENTITY;
          }
          if (_this.trackEndLines === false) {
            _this.updateTokenEndLineColumnLocation = NOOP;
          }
          if (/full/i.test(_this.config.positionTracking)) {
            _this.createTokenInstance = _this.createFullToken;
          } else if (/onlyStart/i.test(_this.config.positionTracking)) {
            _this.createTokenInstance = _this.createStartOnlyToken;
          } else if (/onlyOffset/i.test(_this.config.positionTracking)) {
            _this.createTokenInstance = _this.createOffsetOnlyToken;
          } else {
            throw Error('Invalid <positionTracking> config option: "' + _this.config.positionTracking + '"');
          }
          if (_this.hasCustom) {
            _this.addToken = _this.addTokenUsingPush;
            _this.handlePayload = _this.handlePayloadWithCustom;
          } else {
            _this.addToken = _this.addTokenUsingMemberAccess;
            _this.handlePayload = _this.handlePayloadNoCustom;
          }
        });
        _this.TRACE_INIT("Failed Optimization Warnings", function() {
          var unOptimizedModes = reduce(_this.canModeBeOptimized, function(cannotBeOptimized, canBeOptimized, modeName) {
            if (canBeOptimized === false) {
              cannotBeOptimized.push(modeName);
            }
            return cannotBeOptimized;
          }, []);
          if (config.ensureOptimizations && !isEmpty(unOptimizedModes)) {
            throw Error("Lexer Modes: < " + unOptimizedModes.join(", ") + ' > cannot be optimized.\n	 Disable the "ensureOptimizations" lexer config flag to silently ignore this and run the lexer in an un-optimized mode.\n	 Or inspect the console log for details on how to resolve these issues.');
          }
        });
        _this.TRACE_INIT("clearRegExpParserCache", function() {
          clearRegExpParserCache();
        });
        _this.TRACE_INIT("toFastProperties", function() {
          toFastProperties(_this);
        });
      });
    }
    Lexer2.prototype.tokenize = function(text, initialMode) {
      if (initialMode === void 0) {
        initialMode = this.defaultMode;
      }
      if (!isEmpty(this.lexerDefinitionErrors)) {
        var allErrMessages = map(this.lexerDefinitionErrors, function(error2) {
          return error2.message;
        });
        var allErrMessagesString = allErrMessages.join("-----------------------\n");
        throw new Error("Unable to Tokenize because Errors detected in definition of Lexer:\n" + allErrMessagesString);
      }
      var lexResult = this.tokenizeInternal(text, initialMode);
      return lexResult;
    };
    Lexer2.prototype.tokenizeInternal = function(text, initialMode) {
      var _this = this;
      var i, j, matchAltImage, longerAltIdx, matchedImage, payload, altPayload, imageLength, group, tokType, newToken, errLength, msg, match;
      var orgText = text;
      var orgLength = orgText.length;
      var offset2 = 0;
      var matchedTokensIndex = 0;
      var guessedNumberOfTokens = this.hasCustom ? 0 : Math.floor(text.length / 10);
      var matchedTokens = new Array(guessedNumberOfTokens);
      var errors = [];
      var line = this.trackStartLines ? 1 : void 0;
      var column = this.trackStartLines ? 1 : void 0;
      var groups = cloneEmptyGroups(this.emptyGroups);
      var trackLines = this.trackStartLines;
      var lineTerminatorPattern = this.config.lineTerminatorsPattern;
      var currModePatternsLength = 0;
      var patternIdxToConfig = [];
      var currCharCodeToPatternIdxToConfig = [];
      var modeStack = [];
      var emptyArray = [];
      Object.freeze(emptyArray);
      var getPossiblePatterns = void 0;
      function getPossiblePatternsSlow() {
        return patternIdxToConfig;
      }
      function getPossiblePatternsOptimized(charCode) {
        var optimizedCharIdx = charCodeToOptimizedIndex(charCode);
        var possiblePatterns = currCharCodeToPatternIdxToConfig[optimizedCharIdx];
        if (possiblePatterns === void 0) {
          return emptyArray;
        } else {
          return possiblePatterns;
        }
      }
      var pop_mode = function(popToken) {
        if (modeStack.length === 1 && // if we have both a POP_MODE and a PUSH_MODE this is in-fact a "transition"
        // So no error should occur.
        popToken.tokenType.PUSH_MODE === void 0) {
          var msg_1 = _this.config.errorMessageProvider.buildUnableToPopLexerModeMessage(popToken);
          errors.push({
            offset: popToken.startOffset,
            line: popToken.startLine !== void 0 ? popToken.startLine : void 0,
            column: popToken.startColumn !== void 0 ? popToken.startColumn : void 0,
            length: popToken.image.length,
            message: msg_1
          });
        } else {
          modeStack.pop();
          var newMode = last(modeStack);
          patternIdxToConfig = _this.patternIdxToConfig[newMode];
          currCharCodeToPatternIdxToConfig = _this.charCodeToPatternIdxToConfig[newMode];
          currModePatternsLength = patternIdxToConfig.length;
          var modeCanBeOptimized = _this.canModeBeOptimized[newMode] && _this.config.safeMode === false;
          if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) {
            getPossiblePatterns = getPossiblePatternsOptimized;
          } else {
            getPossiblePatterns = getPossiblePatternsSlow;
          }
        }
      };
      function push_mode(newMode) {
        modeStack.push(newMode);
        currCharCodeToPatternIdxToConfig = this.charCodeToPatternIdxToConfig[newMode];
        patternIdxToConfig = this.patternIdxToConfig[newMode];
        currModePatternsLength = patternIdxToConfig.length;
        currModePatternsLength = patternIdxToConfig.length;
        var modeCanBeOptimized = this.canModeBeOptimized[newMode] && this.config.safeMode === false;
        if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) {
          getPossiblePatterns = getPossiblePatternsOptimized;
        } else {
          getPossiblePatterns = getPossiblePatternsSlow;
        }
      }
      push_mode.call(this, initialMode);
      var currConfig;
      while (offset2 < orgLength) {
        matchedImage = null;
        var nextCharCode = orgText.charCodeAt(offset2);
        var chosenPatternIdxToConfig = getPossiblePatterns(nextCharCode);
        var chosenPatternsLength = chosenPatternIdxToConfig.length;
        for (i = 0; i < chosenPatternsLength; i++) {
          currConfig = chosenPatternIdxToConfig[i];
          var currPattern = currConfig.pattern;
          payload = null;
          var singleCharCode = currConfig.short;
          if (singleCharCode !== false) {
            if (nextCharCode === singleCharCode) {
              matchedImage = currPattern;
            }
          } else if (currConfig.isCustom === true) {
            match = currPattern.exec(orgText, offset2, matchedTokens, groups);
            if (match !== null) {
              matchedImage = match[0];
              if (match.payload !== void 0) {
                payload = match.payload;
              }
            } else {
              matchedImage = null;
            }
          } else {
            this.updateLastIndex(currPattern, offset2);
            matchedImage = this.match(currPattern, text, offset2);
          }
          if (matchedImage !== null) {
            longerAltIdx = currConfig.longerAlt;
            if (longerAltIdx !== void 0) {
              var longerAltConfig = patternIdxToConfig[longerAltIdx];
              var longerAltPattern = longerAltConfig.pattern;
              altPayload = null;
              if (longerAltConfig.isCustom === true) {
                match = longerAltPattern.exec(orgText, offset2, matchedTokens, groups);
                if (match !== null) {
                  matchAltImage = match[0];
                  if (match.payload !== void 0) {
                    altPayload = match.payload;
                  }
                } else {
                  matchAltImage = null;
                }
              } else {
                this.updateLastIndex(longerAltPattern, offset2);
                matchAltImage = this.match(longerAltPattern, text, offset2);
              }
              if (matchAltImage && matchAltImage.length > matchedImage.length) {
                matchedImage = matchAltImage;
                payload = altPayload;
                currConfig = longerAltConfig;
              }
            }
            break;
          }
        }
        if (matchedImage !== null) {
          imageLength = matchedImage.length;
          group = currConfig.group;
          if (group !== void 0) {
            tokType = currConfig.tokenTypeIdx;
            newToken = this.createTokenInstance(matchedImage, offset2, tokType, currConfig.tokenType, line, column, imageLength);
            this.handlePayload(newToken, payload);
            if (group === false) {
              matchedTokensIndex = this.addToken(matchedTokens, matchedTokensIndex, newToken);
            } else {
              groups[group].push(newToken);
            }
          }
          text = this.chopInput(text, imageLength);
          offset2 = offset2 + imageLength;
          column = this.computeNewColumn(column, imageLength);
          if (trackLines === true && currConfig.canLineTerminator === true) {
            var numOfLTsInMatch = 0;
            var foundTerminator = void 0;
            var lastLTEndOffset = void 0;
            lineTerminatorPattern.lastIndex = 0;
            do {
              foundTerminator = lineTerminatorPattern.test(matchedImage);
              if (foundTerminator === true) {
                lastLTEndOffset = lineTerminatorPattern.lastIndex - 1;
                numOfLTsInMatch++;
              }
            } while (foundTerminator === true);
            if (numOfLTsInMatch !== 0) {
              line = line + numOfLTsInMatch;
              column = imageLength - lastLTEndOffset;
              this.updateTokenEndLineColumnLocation(newToken, group, lastLTEndOffset, numOfLTsInMatch, line, column, imageLength);
            }
          }
          this.handleModes(currConfig, pop_mode, push_mode, newToken);
        } else {
          var errorStartOffset = offset2;
          var errorLine = line;
          var errorColumn = column;
          var foundResyncPoint = false;
          while (!foundResyncPoint && offset2 < orgLength) {
            orgText.charCodeAt(offset2);
            text = this.chopInput(text, 1);
            offset2++;
            for (j = 0; j < currModePatternsLength; j++) {
              var currConfig_1 = patternIdxToConfig[j];
              var currPattern = currConfig_1.pattern;
              var singleCharCode = currConfig_1.short;
              if (singleCharCode !== false) {
                if (orgText.charCodeAt(offset2) === singleCharCode) {
                  foundResyncPoint = true;
                }
              } else if (currConfig_1.isCustom === true) {
                foundResyncPoint = currPattern.exec(orgText, offset2, matchedTokens, groups) !== null;
              } else {
                this.updateLastIndex(currPattern, offset2);
                foundResyncPoint = currPattern.exec(text) !== null;
              }
              if (foundResyncPoint === true) {
                break;
              }
            }
          }
          errLength = offset2 - errorStartOffset;
          msg = this.config.errorMessageProvider.buildUnexpectedCharactersMessage(orgText, errorStartOffset, errLength, errorLine, errorColumn);
          errors.push({
            offset: errorStartOffset,
            line: errorLine,
            column: errorColumn,
            length: errLength,
            message: msg
          });
        }
      }
      if (!this.hasCustom) {
        matchedTokens.length = matchedTokensIndex;
      }
      return {
        tokens: matchedTokens,
        groups,
        errors
      };
    };
    Lexer2.prototype.handleModes = function(config, pop_mode, push_mode, newToken) {
      if (config.pop === true) {
        var pushMode = config.push;
        pop_mode(newToken);
        if (pushMode !== void 0) {
          push_mode.call(this, pushMode);
        }
      } else if (config.push !== void 0) {
        push_mode.call(this, config.push);
      }
    };
    Lexer2.prototype.chopInput = function(text, length) {
      return text.substring(length);
    };
    Lexer2.prototype.updateLastIndex = function(regExp, newLastIndex) {
      regExp.lastIndex = newLastIndex;
    };
    Lexer2.prototype.updateTokenEndLineColumnLocation = function(newToken, group, lastLTIdx, numOfLTsInMatch, line, column, imageLength) {
      var lastCharIsLT, fixForEndingInLT;
      if (group !== void 0) {
        lastCharIsLT = lastLTIdx === imageLength - 1;
        fixForEndingInLT = lastCharIsLT ? -1 : 0;
        if (!(numOfLTsInMatch === 1 && lastCharIsLT === true)) {
          newToken.endLine = line + fixForEndingInLT;
          newToken.endColumn = column - 1 + -fixForEndingInLT;
        }
      }
    };
    Lexer2.prototype.computeNewColumn = function(oldColumn, imageLength) {
      return oldColumn + imageLength;
    };
    Lexer2.prototype.createTokenInstance = function() {
      return null;
    };
    Lexer2.prototype.createOffsetOnlyToken = function(image, startOffset, tokenTypeIdx, tokenType) {
      return {
        image,
        startOffset,
        tokenTypeIdx,
        tokenType
      };
    };
    Lexer2.prototype.createStartOnlyToken = function(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn) {
      return {
        image,
        startOffset,
        startLine,
        startColumn,
        tokenTypeIdx,
        tokenType
      };
    };
    Lexer2.prototype.createFullToken = function(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn, imageLength) {
      return {
        image,
        startOffset,
        endOffset: startOffset + imageLength - 1,
        startLine,
        endLine: startLine,
        startColumn,
        endColumn: startColumn + imageLength - 1,
        tokenTypeIdx,
        tokenType
      };
    };
    Lexer2.prototype.addToken = function(tokenVector, index2, tokenToAdd) {
      return 666;
    };
    Lexer2.prototype.addTokenUsingPush = function(tokenVector, index2, tokenToAdd) {
      tokenVector.push(tokenToAdd);
      return index2;
    };
    Lexer2.prototype.addTokenUsingMemberAccess = function(tokenVector, index2, tokenToAdd) {
      tokenVector[index2] = tokenToAdd;
      index2++;
      return index2;
    };
    Lexer2.prototype.handlePayload = function(token, payload) {
    };
    Lexer2.prototype.handlePayloadNoCustom = function(token, payload) {
    };
    Lexer2.prototype.handlePayloadWithCustom = function(token, payload) {
      if (payload !== null) {
        token.payload = payload;
      }
    };
    Lexer2.prototype.match = function(pattern, text, offset2) {
      return null;
    };
    Lexer2.prototype.matchWithTest = function(pattern, text, offset2) {
      var found = pattern.test(text);
      if (found === true) {
        return text.substring(offset2, pattern.lastIndex);
      }
      return null;
    };
    Lexer2.prototype.matchWithExec = function(pattern, text) {
      var regExpArray = pattern.exec(text);
      return regExpArray !== null ? regExpArray[0] : regExpArray;
    };
    Lexer2.prototype.TRACE_INIT = function(phaseDesc, phaseImpl) {
      if (this.traceInitPerf === true) {
        this.traceInitIndent++;
        var indent = new Array(this.traceInitIndent + 1).join("	");
        if (this.traceInitIndent < this.traceInitMaxIdent) {
          console.log(indent + "--> <" + phaseDesc + ">");
        }
        var _a = timer(phaseImpl), time = _a.time, value = _a.value;
        var traceMethod = time > 10 ? console.warn : console.log;
        if (this.traceInitIndent < this.traceInitMaxIdent) {
          traceMethod(indent + "<-- <" + phaseDesc + "> time: " + time + "ms");
        }
        this.traceInitIndent--;
        return value;
      } else {
        return phaseImpl();
      }
    };
    Lexer2.SKIPPED = "This marks a skipped Token pattern, this means each token identified by it willbe consumed and then thrown into oblivion, this can be used to for example to completely ignore whitespace.";
    Lexer2.NA = /NOT_APPLICABLE/;
    return Lexer2;
  })()
);
function tokenLabel(tokType) {
  if (hasTokenLabel(tokType)) {
    return tokType.LABEL;
  } else {
    return tokType.name;
  }
}
function hasTokenLabel(obj) {
  return isString(obj.LABEL) && obj.LABEL !== "";
}
var PARENT = "parent";
var CATEGORIES = "categories";
var LABEL = "label";
var GROUP = "group";
var PUSH_MODE = "push_mode";
var POP_MODE = "pop_mode";
var LONGER_ALT = "longer_alt";
var LINE_BREAKS = "line_breaks";
var START_CHARS_HINT = "start_chars_hint";
function createToken(config) {
  return createTokenInternal(config);
}
function createTokenInternal(config) {
  var pattern = config.pattern;
  var tokenType = {};
  tokenType.name = config.name;
  if (!isUndefined(pattern)) {
    tokenType.PATTERN = pattern;
  }
  if (has(config, PARENT)) {
    throw "The parent property is no longer supported.\nSee: https://github.com/SAP/chevrotain/issues/564#issuecomment-349062346 for details.";
  }
  if (has(config, CATEGORIES)) {
    tokenType.CATEGORIES = config[CATEGORIES];
  }
  augmentTokenTypes([tokenType]);
  if (has(config, LABEL)) {
    tokenType.LABEL = config[LABEL];
  }
  if (has(config, GROUP)) {
    tokenType.GROUP = config[GROUP];
  }
  if (has(config, POP_MODE)) {
    tokenType.POP_MODE = config[POP_MODE];
  }
  if (has(config, PUSH_MODE)) {
    tokenType.PUSH_MODE = config[PUSH_MODE];
  }
  if (has(config, LONGER_ALT)) {
    tokenType.LONGER_ALT = config[LONGER_ALT];
  }
  if (has(config, LINE_BREAKS)) {
    tokenType.LINE_BREAKS = config[LINE_BREAKS];
  }
  if (has(config, START_CHARS_HINT)) {
    tokenType.START_CHARS_HINT = config[START_CHARS_HINT];
  }
  return tokenType;
}
var EOF = createToken({ name: "EOF", pattern: Lexer.NA });
augmentTokenTypes([EOF]);
function createTokenInstance(tokType, image, startOffset, endOffset, startLine, endLine, startColumn, endColumn) {
  return {
    image,
    startOffset,
    endOffset,
    startLine,
    endLine,
    startColumn,
    endColumn,
    tokenTypeIdx: tokType.tokenTypeIdx,
    tokenType: tokType
  };
}
function tokenMatcher(token, tokType) {
  return tokenStructuredMatcher(token, tokType);
}
var __extends$8 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var AbstractProduction = (
  /** @class */
  (function() {
    function AbstractProduction2(definition) {
      this.definition = definition;
    }
    AbstractProduction2.prototype.accept = function(visitor) {
      visitor.visit(this);
      forEach(this.definition, function(prod) {
        prod.accept(visitor);
      });
    };
    return AbstractProduction2;
  })()
);
var NonTerminal = (
  /** @class */
  (function(_super) {
    __extends$8(NonTerminal2, _super);
    function NonTerminal2(options) {
      var _this = _super.call(this, []) || this;
      _this.idx = 1;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    Object.defineProperty(NonTerminal2.prototype, "definition", {
      get: function() {
        if (this.referencedRule !== void 0) {
          return this.referencedRule.definition;
        }
        return [];
      },
      set: function(definition) {
      },
      enumerable: true,
      configurable: true
    });
    NonTerminal2.prototype.accept = function(visitor) {
      visitor.visit(this);
    };
    return NonTerminal2;
  })(AbstractProduction)
);
var Rule = (
  /** @class */
  (function(_super) {
    __extends$8(Rule2, _super);
    function Rule2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.orgText = "";
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return Rule2;
  })(AbstractProduction)
);
var Flat = (
  /** @class */
  (function(_super) {
    __extends$8(Flat2, _super);
    function Flat2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.ignoreAmbiguities = false;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return Flat2;
  })(AbstractProduction)
);
var Option$1 = (
  /** @class */
  (function(_super) {
    __extends$8(Option2, _super);
    function Option2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.idx = 1;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return Option2;
  })(AbstractProduction)
);
var RepetitionMandatory = (
  /** @class */
  (function(_super) {
    __extends$8(RepetitionMandatory2, _super);
    function RepetitionMandatory2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.idx = 1;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return RepetitionMandatory2;
  })(AbstractProduction)
);
var RepetitionMandatoryWithSeparator = (
  /** @class */
  (function(_super) {
    __extends$8(RepetitionMandatoryWithSeparator2, _super);
    function RepetitionMandatoryWithSeparator2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.idx = 1;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return RepetitionMandatoryWithSeparator2;
  })(AbstractProduction)
);
var Repetition = (
  /** @class */
  (function(_super) {
    __extends$8(Repetition2, _super);
    function Repetition2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.idx = 1;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return Repetition2;
  })(AbstractProduction)
);
var RepetitionWithSeparator = (
  /** @class */
  (function(_super) {
    __extends$8(RepetitionWithSeparator2, _super);
    function RepetitionWithSeparator2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.idx = 1;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return RepetitionWithSeparator2;
  })(AbstractProduction)
);
var Alternation = (
  /** @class */
  (function(_super) {
    __extends$8(Alternation2, _super);
    function Alternation2(options) {
      var _this = _super.call(this, options.definition) || this;
      _this.idx = 1;
      _this.ignoreAmbiguities = false;
      _this.hasPredicates = false;
      assign(_this, pick(options, function(v) {
        return v !== void 0;
      }));
      return _this;
    }
    return Alternation2;
  })(AbstractProduction)
);
var Terminal = (
  /** @class */
  (function() {
    function Terminal2(options) {
      this.idx = 1;
      assign(this, pick(options, function(v) {
        return v !== void 0;
      }));
    }
    Terminal2.prototype.accept = function(visitor) {
      visitor.visit(this);
    };
    return Terminal2;
  })()
);
function serializeGrammar(topRules) {
  return map(topRules, serializeProduction);
}
function serializeProduction(node) {
  function convertDefinition(definition) {
    return map(definition, serializeProduction);
  }
  if (node instanceof NonTerminal) {
    return {
      type: "NonTerminal",
      name: node.nonTerminalName,
      idx: node.idx
    };
  } else if (node instanceof Flat) {
    return {
      type: "Flat",
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof Option$1) {
    return {
      type: "Option",
      idx: node.idx,
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof RepetitionMandatory) {
    return {
      type: "RepetitionMandatory",
      name: node.name,
      idx: node.idx,
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof RepetitionMandatoryWithSeparator) {
    return {
      type: "RepetitionMandatoryWithSeparator",
      name: node.name,
      idx: node.idx,
      separator: serializeProduction(new Terminal({ terminalType: node.separator })),
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof RepetitionWithSeparator) {
    return {
      type: "RepetitionWithSeparator",
      name: node.name,
      idx: node.idx,
      separator: serializeProduction(new Terminal({ terminalType: node.separator })),
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof Repetition) {
    return {
      type: "Repetition",
      name: node.name,
      idx: node.idx,
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof Alternation) {
    return {
      type: "Alternation",
      name: node.name,
      idx: node.idx,
      definition: convertDefinition(node.definition)
    };
  } else if (node instanceof Terminal) {
    var serializedTerminal = {
      type: "Terminal",
      name: node.terminalType.name,
      label: tokenLabel(node.terminalType),
      idx: node.idx
    };
    var pattern = node.terminalType.PATTERN;
    if (node.terminalType.PATTERN) {
      serializedTerminal.pattern = isRegExp(pattern) ? pattern.source : pattern;
    }
    return serializedTerminal;
  } else if (node instanceof Rule) {
    return {
      type: "Rule",
      name: node.name,
      orgText: node.orgText,
      definition: convertDefinition(node.definition)
    };
  } else {
    throw Error("non exhaustive match");
  }
}
var RestWalker = (
  /** @class */
  (function() {
    function RestWalker2() {
    }
    RestWalker2.prototype.walk = function(prod, prevRest) {
      var _this = this;
      if (prevRest === void 0) {
        prevRest = [];
      }
      forEach(prod.definition, function(subProd, index2) {
        var currRest = drop(prod.definition, index2 + 1);
        if (subProd instanceof NonTerminal) {
          _this.walkProdRef(subProd, currRest, prevRest);
        } else if (subProd instanceof Terminal) {
          _this.walkTerminal(subProd, currRest, prevRest);
        } else if (subProd instanceof Flat) {
          _this.walkFlat(subProd, currRest, prevRest);
        } else if (subProd instanceof Option$1) {
          _this.walkOption(subProd, currRest, prevRest);
        } else if (subProd instanceof RepetitionMandatory) {
          _this.walkAtLeastOne(subProd, currRest, prevRest);
        } else if (subProd instanceof RepetitionMandatoryWithSeparator) {
          _this.walkAtLeastOneSep(subProd, currRest, prevRest);
        } else if (subProd instanceof RepetitionWithSeparator) {
          _this.walkManySep(subProd, currRest, prevRest);
        } else if (subProd instanceof Repetition) {
          _this.walkMany(subProd, currRest, prevRest);
        } else if (subProd instanceof Alternation) {
          _this.walkOr(subProd, currRest, prevRest);
        } else {
          throw Error("non exhaustive match");
        }
      });
    };
    RestWalker2.prototype.walkTerminal = function(terminal, currRest, prevRest) {
    };
    RestWalker2.prototype.walkProdRef = function(refProd, currRest, prevRest) {
    };
    RestWalker2.prototype.walkFlat = function(flatProd, currRest, prevRest) {
      var fullOrRest = currRest.concat(prevRest);
      this.walk(flatProd, fullOrRest);
    };
    RestWalker2.prototype.walkOption = function(optionProd, currRest, prevRest) {
      var fullOrRest = currRest.concat(prevRest);
      this.walk(optionProd, fullOrRest);
    };
    RestWalker2.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
      var fullAtLeastOneRest = [
        new Option$1({ definition: atLeastOneProd.definition })
      ].concat(currRest, prevRest);
      this.walk(atLeastOneProd, fullAtLeastOneRest);
    };
    RestWalker2.prototype.walkAtLeastOneSep = function(atLeastOneSepProd, currRest, prevRest) {
      var fullAtLeastOneSepRest = restForRepetitionWithSeparator(atLeastOneSepProd, currRest, prevRest);
      this.walk(atLeastOneSepProd, fullAtLeastOneSepRest);
    };
    RestWalker2.prototype.walkMany = function(manyProd, currRest, prevRest) {
      var fullManyRest = [
        new Option$1({ definition: manyProd.definition })
      ].concat(currRest, prevRest);
      this.walk(manyProd, fullManyRest);
    };
    RestWalker2.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
      var fullManySepRest = restForRepetitionWithSeparator(manySepProd, currRest, prevRest);
      this.walk(manySepProd, fullManySepRest);
    };
    RestWalker2.prototype.walkOr = function(orProd, currRest, prevRest) {
      var _this = this;
      var fullOrRest = currRest.concat(prevRest);
      forEach(orProd.definition, function(alt) {
        var prodWrapper = new Flat({ definition: [alt] });
        _this.walk(prodWrapper, fullOrRest);
      });
    };
    return RestWalker2;
  })()
);
function restForRepetitionWithSeparator(repSepProd, currRest, prevRest) {
  var repSepRest = [
    new Option$1({
      definition: [
        new Terminal({ terminalType: repSepProd.separator })
      ].concat(repSepProd.definition)
    })
  ];
  var fullRepSepRest = repSepRest.concat(currRest, prevRest);
  return fullRepSepRest;
}
var GAstVisitor = (
  /** @class */
  (function() {
    function GAstVisitor2() {
    }
    GAstVisitor2.prototype.visit = function(node) {
      var nodeAny = node;
      switch (nodeAny.constructor) {
        case NonTerminal:
          return this.visitNonTerminal(nodeAny);
        case Flat:
          return this.visitFlat(nodeAny);
        case Option$1:
          return this.visitOption(nodeAny);
        case RepetitionMandatory:
          return this.visitRepetitionMandatory(nodeAny);
        case RepetitionMandatoryWithSeparator:
          return this.visitRepetitionMandatoryWithSeparator(nodeAny);
        case RepetitionWithSeparator:
          return this.visitRepetitionWithSeparator(nodeAny);
        case Repetition:
          return this.visitRepetition(nodeAny);
        case Alternation:
          return this.visitAlternation(nodeAny);
        case Terminal:
          return this.visitTerminal(nodeAny);
        case Rule:
          return this.visitRule(nodeAny);
        /* istanbul ignore next */
        default:
          throw Error("non exhaustive match");
      }
    };
    GAstVisitor2.prototype.visitNonTerminal = function(node) {
    };
    GAstVisitor2.prototype.visitFlat = function(node) {
    };
    GAstVisitor2.prototype.visitOption = function(node) {
    };
    GAstVisitor2.prototype.visitRepetition = function(node) {
    };
    GAstVisitor2.prototype.visitRepetitionMandatory = function(node) {
    };
    GAstVisitor2.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
    };
    GAstVisitor2.prototype.visitRepetitionWithSeparator = function(node) {
    };
    GAstVisitor2.prototype.visitAlternation = function(node) {
    };
    GAstVisitor2.prototype.visitTerminal = function(node) {
    };
    GAstVisitor2.prototype.visitRule = function(node) {
    };
    return GAstVisitor2;
  })()
);
var __extends$7 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
function isSequenceProd(prod) {
  return prod instanceof Flat || prod instanceof Option$1 || prod instanceof Repetition || prod instanceof RepetitionMandatory || prod instanceof RepetitionMandatoryWithSeparator || prod instanceof RepetitionWithSeparator || prod instanceof Terminal || prod instanceof Rule;
}
function isOptionalProd(prod, alreadyVisited) {
  if (alreadyVisited === void 0) {
    alreadyVisited = [];
  }
  var isDirectlyOptional = prod instanceof Option$1 || prod instanceof Repetition || prod instanceof RepetitionWithSeparator;
  if (isDirectlyOptional) {
    return true;
  }
  if (prod instanceof Alternation) {
    return some(prod.definition, function(subProd) {
      return isOptionalProd(subProd, alreadyVisited);
    });
  } else if (prod instanceof NonTerminal && contains(alreadyVisited, prod)) {
    return false;
  } else if (prod instanceof AbstractProduction) {
    if (prod instanceof NonTerminal) {
      alreadyVisited.push(prod);
    }
    return every(prod.definition, function(subProd) {
      return isOptionalProd(subProd, alreadyVisited);
    });
  } else {
    return false;
  }
}
function isBranchingProd(prod) {
  return prod instanceof Alternation;
}
function getProductionDslName(prod) {
  if (prod instanceof NonTerminal) {
    return "SUBRULE";
  } else if (prod instanceof Option$1) {
    return "OPTION";
  } else if (prod instanceof Alternation) {
    return "OR";
  } else if (prod instanceof RepetitionMandatory) {
    return "AT_LEAST_ONE";
  } else if (prod instanceof RepetitionMandatoryWithSeparator) {
    return "AT_LEAST_ONE_SEP";
  } else if (prod instanceof RepetitionWithSeparator) {
    return "MANY_SEP";
  } else if (prod instanceof Repetition) {
    return "MANY";
  } else if (prod instanceof Terminal) {
    return "CONSUME";
  } else {
    throw Error("non exhaustive match");
  }
}
var DslMethodsCollectorVisitor = (
  /** @class */
  (function(_super) {
    __extends$7(DslMethodsCollectorVisitor2, _super);
    function DslMethodsCollectorVisitor2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.separator = "-";
      _this.dslMethods = {
        option: [],
        alternation: [],
        repetition: [],
        repetitionWithSeparator: [],
        repetitionMandatory: [],
        repetitionMandatoryWithSeparator: []
      };
      return _this;
    }
    DslMethodsCollectorVisitor2.prototype.reset = function() {
      this.dslMethods = {
        option: [],
        alternation: [],
        repetition: [],
        repetitionWithSeparator: [],
        repetitionMandatory: [],
        repetitionMandatoryWithSeparator: []
      };
    };
    DslMethodsCollectorVisitor2.prototype.visitTerminal = function(terminal) {
      var key = terminal.terminalType.name + this.separator + "Terminal";
      if (!has(this.dslMethods, key)) {
        this.dslMethods[key] = [];
      }
      this.dslMethods[key].push(terminal);
    };
    DslMethodsCollectorVisitor2.prototype.visitNonTerminal = function(subrule) {
      var key = subrule.nonTerminalName + this.separator + "Terminal";
      if (!has(this.dslMethods, key)) {
        this.dslMethods[key] = [];
      }
      this.dslMethods[key].push(subrule);
    };
    DslMethodsCollectorVisitor2.prototype.visitOption = function(option) {
      this.dslMethods.option.push(option);
    };
    DslMethodsCollectorVisitor2.prototype.visitRepetitionWithSeparator = function(manySep) {
      this.dslMethods.repetitionWithSeparator.push(manySep);
    };
    DslMethodsCollectorVisitor2.prototype.visitRepetitionMandatory = function(atLeastOne) {
      this.dslMethods.repetitionMandatory.push(atLeastOne);
    };
    DslMethodsCollectorVisitor2.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
      this.dslMethods.repetitionMandatoryWithSeparator.push(atLeastOneSep);
    };
    DslMethodsCollectorVisitor2.prototype.visitRepetition = function(many) {
      this.dslMethods.repetition.push(many);
    };
    DslMethodsCollectorVisitor2.prototype.visitAlternation = function(or) {
      this.dslMethods.alternation.push(or);
    };
    return DslMethodsCollectorVisitor2;
  })(GAstVisitor)
);
var collectorVisitor = new DslMethodsCollectorVisitor();
function collectMethods(rule) {
  collectorVisitor.reset();
  rule.accept(collectorVisitor);
  var dslMethods = collectorVisitor.dslMethods;
  collectorVisitor.reset();
  return dslMethods;
}
function first(prod) {
  if (prod instanceof NonTerminal) {
    return first(prod.referencedRule);
  } else if (prod instanceof Terminal) {
    return firstForTerminal(prod);
  } else if (isSequenceProd(prod)) {
    return firstForSequence(prod);
  } else if (isBranchingProd(prod)) {
    return firstForBranching(prod);
  } else {
    throw Error("non exhaustive match");
  }
}
function firstForSequence(prod) {
  var firstSet = [];
  var seq = prod.definition;
  var nextSubProdIdx = 0;
  var hasInnerProdsRemaining = seq.length > nextSubProdIdx;
  var currSubProd;
  var isLastInnerProdOptional = true;
  while (hasInnerProdsRemaining && isLastInnerProdOptional) {
    currSubProd = seq[nextSubProdIdx];
    isLastInnerProdOptional = isOptionalProd(currSubProd);
    firstSet = firstSet.concat(first(currSubProd));
    nextSubProdIdx = nextSubProdIdx + 1;
    hasInnerProdsRemaining = seq.length > nextSubProdIdx;
  }
  return uniq(firstSet);
}
function firstForBranching(prod) {
  var allAlternativesFirsts = map(prod.definition, function(innerProd) {
    return first(innerProd);
  });
  return uniq(flatten(allAlternativesFirsts));
}
function firstForTerminal(terminal) {
  return [terminal.terminalType];
}
var IN = "_~IN~_";
var __extends$6 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var ResyncFollowsWalker = (
  /** @class */
  (function(_super) {
    __extends$6(ResyncFollowsWalker2, _super);
    function ResyncFollowsWalker2(topProd) {
      var _this = _super.call(this) || this;
      _this.topProd = topProd;
      _this.follows = {};
      return _this;
    }
    ResyncFollowsWalker2.prototype.startWalking = function() {
      this.walk(this.topProd);
      return this.follows;
    };
    ResyncFollowsWalker2.prototype.walkTerminal = function(terminal, currRest, prevRest) {
    };
    ResyncFollowsWalker2.prototype.walkProdRef = function(refProd, currRest, prevRest) {
      var followName = buildBetweenProdsFollowPrefix(refProd.referencedRule, refProd.idx) + this.topProd.name;
      var fullRest = currRest.concat(prevRest);
      var restProd = new Flat({ definition: fullRest });
      var t_in_topProd_follows = first(restProd);
      this.follows[followName] = t_in_topProd_follows;
    };
    return ResyncFollowsWalker2;
  })(RestWalker)
);
function computeAllProdsFollows(topProductions) {
  var reSyncFollows = {};
  forEach(topProductions, function(topProd) {
    var currRefsFollow = new ResyncFollowsWalker(topProd).startWalking();
    assign(reSyncFollows, currRefsFollow);
  });
  return reSyncFollows;
}
function buildBetweenProdsFollowPrefix(inner, occurenceInParent) {
  return inner.name + occurenceInParent + IN;
}
var BITS_FOR_METHOD_TYPE = 4;
var BITS_FOR_OCCURRENCE_IDX = 8;
var BITS_FOR_ALT_IDX = 8;
var OR_IDX = 1 << BITS_FOR_OCCURRENCE_IDX;
var OPTION_IDX = 2 << BITS_FOR_OCCURRENCE_IDX;
var MANY_IDX = 3 << BITS_FOR_OCCURRENCE_IDX;
var AT_LEAST_ONE_IDX = 4 << BITS_FOR_OCCURRENCE_IDX;
var MANY_SEP_IDX = 5 << BITS_FOR_OCCURRENCE_IDX;
var AT_LEAST_ONE_SEP_IDX = 6 << BITS_FOR_OCCURRENCE_IDX;
function getKeyForAutomaticLookahead(ruleIdx, dslMethodIdx, occurrence) {
  return occurrence | dslMethodIdx | ruleIdx;
}
var BITS_START_FOR_ALT_IDX = 32 - BITS_FOR_ALT_IDX;
function getKeyForAltIndex(ruleIdx, dslMethodIdx, occurrence, altIdx) {
  var altIdxBitMap = altIdx + 1 << BITS_START_FOR_ALT_IDX;
  return getKeyForAutomaticLookahead(ruleIdx, dslMethodIdx, occurrence) | altIdxBitMap;
}
var __extends$5 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
function setNodeLocationOnlyOffset(currNodeLocation, newLocationInfo) {
  if (isNaN(currNodeLocation.startOffset) === true) {
    currNodeLocation.startOffset = newLocationInfo.startOffset;
    currNodeLocation.endOffset = newLocationInfo.endOffset;
  } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) {
    currNodeLocation.endOffset = newLocationInfo.endOffset;
  }
}
function setNodeLocationFull(currNodeLocation, newLocationInfo) {
  if (isNaN(currNodeLocation.startOffset) === true) {
    currNodeLocation.startOffset = newLocationInfo.startOffset;
    currNodeLocation.startColumn = newLocationInfo.startColumn;
    currNodeLocation.startLine = newLocationInfo.startLine;
    currNodeLocation.endOffset = newLocationInfo.endOffset;
    currNodeLocation.endColumn = newLocationInfo.endColumn;
    currNodeLocation.endLine = newLocationInfo.endLine;
  } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) {
    currNodeLocation.endOffset = newLocationInfo.endOffset;
    currNodeLocation.endColumn = newLocationInfo.endColumn;
    currNodeLocation.endLine = newLocationInfo.endLine;
  }
}
function addTerminalToCst(node, token, tokenTypeName) {
  if (node.children[tokenTypeName] === void 0) {
    node.children[tokenTypeName] = [token];
  } else {
    node.children[tokenTypeName].push(token);
  }
}
function addNoneTerminalToCst(node, ruleName, ruleResult) {
  if (node.children[ruleName] === void 0) {
    node.children[ruleName] = [ruleResult];
  } else {
    node.children[ruleName].push(ruleResult);
  }
}
var NamedDSLMethodsCollectorVisitor = (
  /** @class */
  (function(_super) {
    __extends$5(NamedDSLMethodsCollectorVisitor2, _super);
    function NamedDSLMethodsCollectorVisitor2(ruleIdx) {
      var _this = _super.call(this) || this;
      _this.result = [];
      _this.ruleIdx = ruleIdx;
      return _this;
    }
    NamedDSLMethodsCollectorVisitor2.prototype.collectNamedDSLMethod = function(node, newNodeConstructor, methodIdx) {
      if (!isUndefined(node.name)) {
        var nameLessNode = void 0;
        if (node instanceof Option$1 || node instanceof Repetition || node instanceof RepetitionMandatory || node instanceof Alternation) {
          nameLessNode = new newNodeConstructor({
            definition: node.definition,
            idx: node.idx
          });
        } else if (node instanceof RepetitionMandatoryWithSeparator || node instanceof RepetitionWithSeparator) {
          nameLessNode = new newNodeConstructor({
            definition: node.definition,
            idx: node.idx,
            separator: node.separator
          });
        } else {
          throw Error("non exhaustive match");
        }
        var def = [nameLessNode];
        var key = getKeyForAutomaticLookahead(this.ruleIdx, methodIdx, node.idx);
        this.result.push({ def, key, name: node.name, orgProd: node });
      }
    };
    NamedDSLMethodsCollectorVisitor2.prototype.visitOption = function(node) {
      this.collectNamedDSLMethod(node, Option$1, OPTION_IDX);
    };
    NamedDSLMethodsCollectorVisitor2.prototype.visitRepetition = function(node) {
      this.collectNamedDSLMethod(node, Repetition, MANY_IDX);
    };
    NamedDSLMethodsCollectorVisitor2.prototype.visitRepetitionMandatory = function(node) {
      this.collectNamedDSLMethod(node, RepetitionMandatory, AT_LEAST_ONE_IDX);
    };
    NamedDSLMethodsCollectorVisitor2.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
      this.collectNamedDSLMethod(node, RepetitionMandatoryWithSeparator, AT_LEAST_ONE_SEP_IDX);
    };
    NamedDSLMethodsCollectorVisitor2.prototype.visitRepetitionWithSeparator = function(node) {
      this.collectNamedDSLMethod(node, RepetitionWithSeparator, MANY_SEP_IDX);
    };
    NamedDSLMethodsCollectorVisitor2.prototype.visitAlternation = function(node) {
      var _this = this;
      this.collectNamedDSLMethod(node, Alternation, OR_IDX);
      var hasMoreThanOneAlternative = node.definition.length > 1;
      forEach(node.definition, function(currFlatAlt, altIdx) {
        if (!isUndefined(currFlatAlt.name)) {
          var def = currFlatAlt.definition;
          if (hasMoreThanOneAlternative) {
            def = [new Option$1({ definition: currFlatAlt.definition })];
          } else {
            def = currFlatAlt.definition;
          }
          var key = getKeyForAltIndex(_this.ruleIdx, OR_IDX, node.idx, altIdx);
          _this.result.push({
            def,
            key,
            name: currFlatAlt.name,
            orgProd: currFlatAlt
          });
        }
      });
    };
    return NamedDSLMethodsCollectorVisitor2;
  })(GAstVisitor)
);
function expandAllNestedRuleNames(topRules, fullToShortName) {
  var result = {
    allRuleNames: []
  };
  forEach(topRules, function(currTopRule) {
    var currTopRuleShortName = fullToShortName[currTopRule.name];
    result.allRuleNames.push(currTopRule.name);
    var namedCollectorVisitor = new NamedDSLMethodsCollectorVisitor(currTopRuleShortName);
    currTopRule.accept(namedCollectorVisitor);
    forEach(namedCollectorVisitor.result, function(_a) {
      _a.def;
      _a.key;
      var name = _a.name;
      result.allRuleNames.push(currTopRule.name + name);
    });
  });
  return result;
}
var __extends$4 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var AbstractNextPossibleTokensWalker = (
  /** @class */
  (function(_super) {
    __extends$4(AbstractNextPossibleTokensWalker2, _super);
    function AbstractNextPossibleTokensWalker2(topProd, path) {
      var _this = _super.call(this) || this;
      _this.topProd = topProd;
      _this.path = path;
      _this.possibleTokTypes = [];
      _this.nextProductionName = "";
      _this.nextProductionOccurrence = 0;
      _this.found = false;
      _this.isAtEndOfPath = false;
      return _this;
    }
    AbstractNextPossibleTokensWalker2.prototype.startWalking = function() {
      this.found = false;
      if (this.path.ruleStack[0] !== this.topProd.name) {
        throw Error("The path does not start with the walker's top Rule!");
      }
      this.ruleStack = cloneArr(this.path.ruleStack).reverse();
      this.occurrenceStack = cloneArr(this.path.occurrenceStack).reverse();
      this.ruleStack.pop();
      this.occurrenceStack.pop();
      this.updateExpectedNext();
      this.walk(this.topProd);
      return this.possibleTokTypes;
    };
    AbstractNextPossibleTokensWalker2.prototype.walk = function(prod, prevRest) {
      if (prevRest === void 0) {
        prevRest = [];
      }
      if (!this.found) {
        _super.prototype.walk.call(this, prod, prevRest);
      }
    };
    AbstractNextPossibleTokensWalker2.prototype.walkProdRef = function(refProd, currRest, prevRest) {
      if (refProd.referencedRule.name === this.nextProductionName && refProd.idx === this.nextProductionOccurrence) {
        var fullRest = currRest.concat(prevRest);
        this.updateExpectedNext();
        this.walk(refProd.referencedRule, fullRest);
      }
    };
    AbstractNextPossibleTokensWalker2.prototype.updateExpectedNext = function() {
      if (isEmpty(this.ruleStack)) {
        this.nextProductionName = "";
        this.nextProductionOccurrence = 0;
        this.isAtEndOfPath = true;
      } else {
        this.nextProductionName = this.ruleStack.pop();
        this.nextProductionOccurrence = this.occurrenceStack.pop();
      }
    };
    return AbstractNextPossibleTokensWalker2;
  })(RestWalker)
);
var NextAfterTokenWalker = (
  /** @class */
  (function(_super) {
    __extends$4(NextAfterTokenWalker2, _super);
    function NextAfterTokenWalker2(topProd, path) {
      var _this = _super.call(this, topProd, path) || this;
      _this.path = path;
      _this.nextTerminalName = "";
      _this.nextTerminalOccurrence = 0;
      _this.nextTerminalName = _this.path.lastTok.name;
      _this.nextTerminalOccurrence = _this.path.lastTokOccurrence;
      return _this;
    }
    NextAfterTokenWalker2.prototype.walkTerminal = function(terminal, currRest, prevRest) {
      if (this.isAtEndOfPath && terminal.terminalType.name === this.nextTerminalName && terminal.idx === this.nextTerminalOccurrence && !this.found) {
        var fullRest = currRest.concat(prevRest);
        var restProd = new Flat({ definition: fullRest });
        this.possibleTokTypes = first(restProd);
        this.found = true;
      }
    };
    return NextAfterTokenWalker2;
  })(AbstractNextPossibleTokensWalker)
);
var AbstractNextTerminalAfterProductionWalker = (
  /** @class */
  (function(_super) {
    __extends$4(AbstractNextTerminalAfterProductionWalker2, _super);
    function AbstractNextTerminalAfterProductionWalker2(topRule, occurrence) {
      var _this = _super.call(this) || this;
      _this.topRule = topRule;
      _this.occurrence = occurrence;
      _this.result = {
        token: void 0,
        occurrence: void 0,
        isEndOfRule: void 0
      };
      return _this;
    }
    AbstractNextTerminalAfterProductionWalker2.prototype.startWalking = function() {
      this.walk(this.topRule);
      return this.result;
    };
    return AbstractNextTerminalAfterProductionWalker2;
  })(RestWalker)
);
var NextTerminalAfterManyWalker = (
  /** @class */
  (function(_super) {
    __extends$4(NextTerminalAfterManyWalker2, _super);
    function NextTerminalAfterManyWalker2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterManyWalker2.prototype.walkMany = function(manyProd, currRest, prevRest) {
      if (manyProd.idx === this.occurrence) {
        var firstAfterMany = first$1(currRest.concat(prevRest));
        this.result.isEndOfRule = firstAfterMany === void 0;
        if (firstAfterMany instanceof Terminal) {
          this.result.token = firstAfterMany.terminalType;
          this.result.occurrence = firstAfterMany.idx;
        }
      } else {
        _super.prototype.walkMany.call(this, manyProd, currRest, prevRest);
      }
    };
    return NextTerminalAfterManyWalker2;
  })(AbstractNextTerminalAfterProductionWalker)
);
var NextTerminalAfterManySepWalker = (
  /** @class */
  (function(_super) {
    __extends$4(NextTerminalAfterManySepWalker2, _super);
    function NextTerminalAfterManySepWalker2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterManySepWalker2.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
      if (manySepProd.idx === this.occurrence) {
        var firstAfterManySep = first$1(currRest.concat(prevRest));
        this.result.isEndOfRule = firstAfterManySep === void 0;
        if (firstAfterManySep instanceof Terminal) {
          this.result.token = firstAfterManySep.terminalType;
          this.result.occurrence = firstAfterManySep.idx;
        }
      } else {
        _super.prototype.walkManySep.call(this, manySepProd, currRest, prevRest);
      }
    };
    return NextTerminalAfterManySepWalker2;
  })(AbstractNextTerminalAfterProductionWalker)
);
var NextTerminalAfterAtLeastOneWalker = (
  /** @class */
  (function(_super) {
    __extends$4(NextTerminalAfterAtLeastOneWalker2, _super);
    function NextTerminalAfterAtLeastOneWalker2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterAtLeastOneWalker2.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
      if (atLeastOneProd.idx === this.occurrence) {
        var firstAfterAtLeastOne = first$1(currRest.concat(prevRest));
        this.result.isEndOfRule = firstAfterAtLeastOne === void 0;
        if (firstAfterAtLeastOne instanceof Terminal) {
          this.result.token = firstAfterAtLeastOne.terminalType;
          this.result.occurrence = firstAfterAtLeastOne.idx;
        }
      } else {
        _super.prototype.walkAtLeastOne.call(this, atLeastOneProd, currRest, prevRest);
      }
    };
    return NextTerminalAfterAtLeastOneWalker2;
  })(AbstractNextTerminalAfterProductionWalker)
);
var NextTerminalAfterAtLeastOneSepWalker = (
  /** @class */
  (function(_super) {
    __extends$4(NextTerminalAfterAtLeastOneSepWalker2, _super);
    function NextTerminalAfterAtLeastOneSepWalker2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterAtLeastOneSepWalker2.prototype.walkAtLeastOneSep = function(atleastOneSepProd, currRest, prevRest) {
      if (atleastOneSepProd.idx === this.occurrence) {
        var firstAfterfirstAfterAtLeastOneSep = first$1(currRest.concat(prevRest));
        this.result.isEndOfRule = firstAfterfirstAfterAtLeastOneSep === void 0;
        if (firstAfterfirstAfterAtLeastOneSep instanceof Terminal) {
          this.result.token = firstAfterfirstAfterAtLeastOneSep.terminalType;
          this.result.occurrence = firstAfterfirstAfterAtLeastOneSep.idx;
        }
      } else {
        _super.prototype.walkAtLeastOneSep.call(this, atleastOneSepProd, currRest, prevRest);
      }
    };
    return NextTerminalAfterAtLeastOneSepWalker2;
  })(AbstractNextTerminalAfterProductionWalker)
);
function possiblePathsFrom(targetDef, maxLength, currPath) {
  if (currPath === void 0) {
    currPath = [];
  }
  currPath = cloneArr(currPath);
  var result = [];
  var i = 0;
  function remainingPathWith(nextDef) {
    return nextDef.concat(drop(targetDef, i + 1));
  }
  function getAlternativesForProd(definition) {
    var alternatives = possiblePathsFrom(remainingPathWith(definition), maxLength, currPath);
    return result.concat(alternatives);
  }
  while (currPath.length < maxLength && i < targetDef.length) {
    var prod = targetDef[i];
    if (prod instanceof Flat) {
      return getAlternativesForProd(prod.definition);
    } else if (prod instanceof NonTerminal) {
      return getAlternativesForProd(prod.definition);
    } else if (prod instanceof Option$1) {
      result = getAlternativesForProd(prod.definition);
    } else if (prod instanceof RepetitionMandatory) {
      var newDef = prod.definition.concat([
        new Repetition({
          definition: prod.definition
        })
      ]);
      return getAlternativesForProd(newDef);
    } else if (prod instanceof RepetitionMandatoryWithSeparator) {
      var newDef = [
        new Flat({ definition: prod.definition }),
        new Repetition({
          definition: [
            new Terminal({ terminalType: prod.separator })
          ].concat(prod.definition)
        })
      ];
      return getAlternativesForProd(newDef);
    } else if (prod instanceof RepetitionWithSeparator) {
      var newDef = prod.definition.concat([
        new Repetition({
          definition: [
            new Terminal({ terminalType: prod.separator })
          ].concat(prod.definition)
        })
      ]);
      result = getAlternativesForProd(newDef);
    } else if (prod instanceof Repetition) {
      var newDef = prod.definition.concat([
        new Repetition({
          definition: prod.definition
        })
      ]);
      result = getAlternativesForProd(newDef);
    } else if (prod instanceof Alternation) {
      forEach(prod.definition, function(currAlt) {
        result = getAlternativesForProd(currAlt.definition);
      });
      return result;
    } else if (prod instanceof Terminal) {
      currPath.push(prod.terminalType);
    } else {
      throw Error("non exhaustive match");
    }
    i++;
  }
  result.push({
    partialPath: currPath,
    suffixDef: drop(targetDef, i)
  });
  return result;
}
function nextPossibleTokensAfter(initialDef, tokenVector, tokMatcher, maxLookAhead) {
  var EXIT_NON_TERMINAL = "EXIT_NONE_TERMINAL";
  var EXIT_NON_TERMINAL_ARR = [EXIT_NON_TERMINAL];
  var EXIT_ALTERNATIVE = "EXIT_ALTERNATIVE";
  var foundCompletePath = false;
  var tokenVectorLength = tokenVector.length;
  var minimalAlternativesIndex = tokenVectorLength - maxLookAhead - 1;
  var result = [];
  var possiblePaths = [];
  possiblePaths.push({
    idx: -1,
    def: initialDef,
    ruleStack: [],
    occurrenceStack: []
  });
  while (!isEmpty(possiblePaths)) {
    var currPath = possiblePaths.pop();
    if (currPath === EXIT_ALTERNATIVE) {
      if (foundCompletePath && last(possiblePaths).idx <= minimalAlternativesIndex) {
        possiblePaths.pop();
      }
      continue;
    }
    var currDef = currPath.def;
    var currIdx = currPath.idx;
    var currRuleStack = currPath.ruleStack;
    var currOccurrenceStack = currPath.occurrenceStack;
    if (isEmpty(currDef)) {
      continue;
    }
    var prod = currDef[0];
    if (prod === EXIT_NON_TERMINAL) {
      var nextPath = {
        idx: currIdx,
        def: drop(currDef),
        ruleStack: dropRight(currRuleStack),
        occurrenceStack: dropRight(currOccurrenceStack)
      };
      possiblePaths.push(nextPath);
    } else if (prod instanceof Terminal) {
      if (currIdx < tokenVectorLength - 1) {
        var nextIdx = currIdx + 1;
        var actualToken = tokenVector[nextIdx];
        if (tokMatcher(actualToken, prod.terminalType)) {
          var nextPath = {
            idx: nextIdx,
            def: drop(currDef),
            ruleStack: currRuleStack,
            occurrenceStack: currOccurrenceStack
          };
          possiblePaths.push(nextPath);
        }
      } else if (currIdx === tokenVectorLength - 1) {
        result.push({
          nextTokenType: prod.terminalType,
          nextTokenOccurrence: prod.idx,
          ruleStack: currRuleStack,
          occurrenceStack: currOccurrenceStack
        });
        foundCompletePath = true;
      } else {
        throw Error("non exhaustive match");
      }
    } else if (prod instanceof NonTerminal) {
      var newRuleStack = cloneArr(currRuleStack);
      newRuleStack.push(prod.nonTerminalName);
      var newOccurrenceStack = cloneArr(currOccurrenceStack);
      newOccurrenceStack.push(prod.idx);
      var nextPath = {
        idx: currIdx,
        def: prod.definition.concat(EXIT_NON_TERMINAL_ARR, drop(currDef)),
        ruleStack: newRuleStack,
        occurrenceStack: newOccurrenceStack
      };
      possiblePaths.push(nextPath);
    } else if (prod instanceof Option$1) {
      var nextPathWithout = {
        idx: currIdx,
        def: drop(currDef),
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPathWithout);
      possiblePaths.push(EXIT_ALTERNATIVE);
      var nextPathWith = {
        idx: currIdx,
        def: prod.definition.concat(drop(currDef)),
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPathWith);
    } else if (prod instanceof RepetitionMandatory) {
      var secondIteration = new Repetition({
        definition: prod.definition,
        idx: prod.idx
      });
      var nextDef = prod.definition.concat([secondIteration], drop(currDef));
      var nextPath = {
        idx: currIdx,
        def: nextDef,
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPath);
    } else if (prod instanceof RepetitionMandatoryWithSeparator) {
      var separatorGast = new Terminal({
        terminalType: prod.separator
      });
      var secondIteration = new Repetition({
        definition: [separatorGast].concat(prod.definition),
        idx: prod.idx
      });
      var nextDef = prod.definition.concat([secondIteration], drop(currDef));
      var nextPath = {
        idx: currIdx,
        def: nextDef,
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPath);
    } else if (prod instanceof RepetitionWithSeparator) {
      var nextPathWithout = {
        idx: currIdx,
        def: drop(currDef),
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPathWithout);
      possiblePaths.push(EXIT_ALTERNATIVE);
      var separatorGast = new Terminal({
        terminalType: prod.separator
      });
      var nthRepetition = new Repetition({
        definition: [separatorGast].concat(prod.definition),
        idx: prod.idx
      });
      var nextDef = prod.definition.concat([nthRepetition], drop(currDef));
      var nextPathWith = {
        idx: currIdx,
        def: nextDef,
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPathWith);
    } else if (prod instanceof Repetition) {
      var nextPathWithout = {
        idx: currIdx,
        def: drop(currDef),
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPathWithout);
      possiblePaths.push(EXIT_ALTERNATIVE);
      var nthRepetition = new Repetition({
        definition: prod.definition,
        idx: prod.idx
      });
      var nextDef = prod.definition.concat([nthRepetition], drop(currDef));
      var nextPathWith = {
        idx: currIdx,
        def: nextDef,
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      };
      possiblePaths.push(nextPathWith);
    } else if (prod instanceof Alternation) {
      for (var i = prod.definition.length - 1; i >= 0; i--) {
        var currAlt = prod.definition[i];
        var currAltPath = {
          idx: currIdx,
          def: currAlt.definition.concat(drop(currDef)),
          ruleStack: currRuleStack,
          occurrenceStack: currOccurrenceStack
        };
        possiblePaths.push(currAltPath);
        possiblePaths.push(EXIT_ALTERNATIVE);
      }
    } else if (prod instanceof Flat) {
      possiblePaths.push({
        idx: currIdx,
        def: prod.definition.concat(drop(currDef)),
        ruleStack: currRuleStack,
        occurrenceStack: currOccurrenceStack
      });
    } else if (prod instanceof Rule) {
      possiblePaths.push(expandTopLevelRule(prod, currIdx, currRuleStack, currOccurrenceStack));
    } else {
      throw Error("non exhaustive match");
    }
  }
  return result;
}
function expandTopLevelRule(topRule, currIdx, currRuleStack, currOccurrenceStack) {
  var newRuleStack = cloneArr(currRuleStack);
  newRuleStack.push(topRule.name);
  var newCurrOccurrenceStack = cloneArr(currOccurrenceStack);
  newCurrOccurrenceStack.push(1);
  return {
    idx: currIdx,
    def: topRule.definition,
    ruleStack: newRuleStack,
    occurrenceStack: newCurrOccurrenceStack
  };
}
var __extends$3 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var PROD_TYPE;
(function(PROD_TYPE2) {
  PROD_TYPE2[PROD_TYPE2["OPTION"] = 0] = "OPTION";
  PROD_TYPE2[PROD_TYPE2["REPETITION"] = 1] = "REPETITION";
  PROD_TYPE2[PROD_TYPE2["REPETITION_MANDATORY"] = 2] = "REPETITION_MANDATORY";
  PROD_TYPE2[PROD_TYPE2["REPETITION_MANDATORY_WITH_SEPARATOR"] = 3] = "REPETITION_MANDATORY_WITH_SEPARATOR";
  PROD_TYPE2[PROD_TYPE2["REPETITION_WITH_SEPARATOR"] = 4] = "REPETITION_WITH_SEPARATOR";
  PROD_TYPE2[PROD_TYPE2["ALTERNATION"] = 5] = "ALTERNATION";
})(PROD_TYPE || (PROD_TYPE = {}));
function getProdType(prod) {
  if (prod instanceof Option$1) {
    return PROD_TYPE.OPTION;
  } else if (prod instanceof Repetition) {
    return PROD_TYPE.REPETITION;
  } else if (prod instanceof RepetitionMandatory) {
    return PROD_TYPE.REPETITION_MANDATORY;
  } else if (prod instanceof RepetitionMandatoryWithSeparator) {
    return PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR;
  } else if (prod instanceof RepetitionWithSeparator) {
    return PROD_TYPE.REPETITION_WITH_SEPARATOR;
  } else if (prod instanceof Alternation) {
    return PROD_TYPE.ALTERNATION;
  } else {
    throw Error("non exhaustive match");
  }
}
function buildLookaheadFuncForOr(occurrence, ruleGrammar, maxLookahead, hasPredicates, dynamicTokensEnabled, laFuncBuilder) {
  var lookAheadPaths = getLookaheadPathsForOr(occurrence, ruleGrammar, maxLookahead);
  var tokenMatcher2 = areTokenCategoriesNotUsed(lookAheadPaths) ? tokenStructuredMatcherNoCategories : tokenStructuredMatcher;
  return laFuncBuilder(lookAheadPaths, hasPredicates, tokenMatcher2, dynamicTokensEnabled);
}
function buildLookaheadFuncForOptionalProd(occurrence, ruleGrammar, k, dynamicTokensEnabled, prodType, lookaheadBuilder) {
  var lookAheadPaths = getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k);
  var tokenMatcher2 = areTokenCategoriesNotUsed(lookAheadPaths) ? tokenStructuredMatcherNoCategories : tokenStructuredMatcher;
  return lookaheadBuilder(lookAheadPaths[0], tokenMatcher2, dynamicTokensEnabled);
}
function buildAlternativesLookAheadFunc(alts, hasPredicates, tokenMatcher2, dynamicTokensEnabled) {
  var numOfAlts = alts.length;
  var areAllOneTokenLookahead = every(alts, function(currAlt) {
    return every(currAlt, function(currPath) {
      return currPath.length === 1;
    });
  });
  if (hasPredicates) {
    return function(orAlts) {
      var predicates = map(orAlts, function(currAlt2) {
        return currAlt2.GATE;
      });
      for (var t = 0; t < numOfAlts; t++) {
        var currAlt = alts[t];
        var currNumOfPaths = currAlt.length;
        var currPredicate = predicates[t];
        if (currPredicate !== void 0 && currPredicate.call(this) === false) {
          continue;
        }
        nextPath: for (var j = 0; j < currNumOfPaths; j++) {
          var currPath = currAlt[j];
          var currPathLength = currPath.length;
          for (var i = 0; i < currPathLength; i++) {
            var nextToken = this.LA(i + 1);
            if (tokenMatcher2(nextToken, currPath[i]) === false) {
              continue nextPath;
            }
          }
          return t;
        }
      }
      return void 0;
    };
  } else if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
    var singleTokenAlts = map(alts, function(currAlt) {
      return flatten(currAlt);
    });
    var choiceToAlt_1 = reduce(singleTokenAlts, function(result, currAlt, idx) {
      forEach(currAlt, function(currTokType) {
        if (!has(result, currTokType.tokenTypeIdx)) {
          result[currTokType.tokenTypeIdx] = idx;
        }
        forEach(currTokType.categoryMatches, function(currExtendingType) {
          if (!has(result, currExtendingType)) {
            result[currExtendingType] = idx;
          }
        });
      });
      return result;
    }, []);
    return function() {
      var nextToken = this.LA(1);
      return choiceToAlt_1[nextToken.tokenTypeIdx];
    };
  } else {
    return function() {
      for (var t = 0; t < numOfAlts; t++) {
        var currAlt = alts[t];
        var currNumOfPaths = currAlt.length;
        nextPath: for (var j = 0; j < currNumOfPaths; j++) {
          var currPath = currAlt[j];
          var currPathLength = currPath.length;
          for (var i = 0; i < currPathLength; i++) {
            var nextToken = this.LA(i + 1);
            if (tokenMatcher2(nextToken, currPath[i]) === false) {
              continue nextPath;
            }
          }
          return t;
        }
      }
      return void 0;
    };
  }
}
function buildSingleAlternativeLookaheadFunction(alt, tokenMatcher2, dynamicTokensEnabled) {
  var areAllOneTokenLookahead = every(alt, function(currPath) {
    return currPath.length === 1;
  });
  var numOfPaths = alt.length;
  if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
    var singleTokensTypes = flatten(alt);
    if (singleTokensTypes.length === 1 && isEmpty(singleTokensTypes[0].categoryMatches)) {
      var expectedTokenType = singleTokensTypes[0];
      var expectedTokenUniqueKey_1 = expectedTokenType.tokenTypeIdx;
      return function() {
        return this.LA(1).tokenTypeIdx === expectedTokenUniqueKey_1;
      };
    } else {
      var choiceToAlt_2 = reduce(singleTokensTypes, function(result, currTokType, idx) {
        result[currTokType.tokenTypeIdx] = true;
        forEach(currTokType.categoryMatches, function(currExtendingType) {
          result[currExtendingType] = true;
        });
        return result;
      }, []);
      return function() {
        var nextToken = this.LA(1);
        return choiceToAlt_2[nextToken.tokenTypeIdx] === true;
      };
    }
  } else {
    return function() {
      nextPath: for (var j = 0; j < numOfPaths; j++) {
        var currPath = alt[j];
        var currPathLength = currPath.length;
        for (var i = 0; i < currPathLength; i++) {
          var nextToken = this.LA(i + 1);
          if (tokenMatcher2(nextToken, currPath[i]) === false) {
            continue nextPath;
          }
        }
        return true;
      }
      return false;
    };
  }
}
var RestDefinitionFinderWalker = (
  /** @class */
  (function(_super) {
    __extends$3(RestDefinitionFinderWalker2, _super);
    function RestDefinitionFinderWalker2(topProd, targetOccurrence, targetProdType) {
      var _this = _super.call(this) || this;
      _this.topProd = topProd;
      _this.targetOccurrence = targetOccurrence;
      _this.targetProdType = targetProdType;
      return _this;
    }
    RestDefinitionFinderWalker2.prototype.startWalking = function() {
      this.walk(this.topProd);
      return this.restDef;
    };
    RestDefinitionFinderWalker2.prototype.checkIsTarget = function(node, expectedProdType, currRest, prevRest) {
      if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdType) {
        this.restDef = currRest.concat(prevRest);
        return true;
      }
      return false;
    };
    RestDefinitionFinderWalker2.prototype.walkOption = function(optionProd, currRest, prevRest) {
      if (!this.checkIsTarget(optionProd, PROD_TYPE.OPTION, currRest, prevRest)) {
        _super.prototype.walkOption.call(this, optionProd, currRest, prevRest);
      }
    };
    RestDefinitionFinderWalker2.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
      if (!this.checkIsTarget(atLeastOneProd, PROD_TYPE.REPETITION_MANDATORY, currRest, prevRest)) {
        _super.prototype.walkOption.call(this, atLeastOneProd, currRest, prevRest);
      }
    };
    RestDefinitionFinderWalker2.prototype.walkAtLeastOneSep = function(atLeastOneSepProd, currRest, prevRest) {
      if (!this.checkIsTarget(atLeastOneSepProd, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, currRest, prevRest)) {
        _super.prototype.walkOption.call(this, atLeastOneSepProd, currRest, prevRest);
      }
    };
    RestDefinitionFinderWalker2.prototype.walkMany = function(manyProd, currRest, prevRest) {
      if (!this.checkIsTarget(manyProd, PROD_TYPE.REPETITION, currRest, prevRest)) {
        _super.prototype.walkOption.call(this, manyProd, currRest, prevRest);
      }
    };
    RestDefinitionFinderWalker2.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
      if (!this.checkIsTarget(manySepProd, PROD_TYPE.REPETITION_WITH_SEPARATOR, currRest, prevRest)) {
        _super.prototype.walkOption.call(this, manySepProd, currRest, prevRest);
      }
    };
    return RestDefinitionFinderWalker2;
  })(RestWalker)
);
var InsideDefinitionFinderVisitor = (
  /** @class */
  (function(_super) {
    __extends$3(InsideDefinitionFinderVisitor2, _super);
    function InsideDefinitionFinderVisitor2(targetOccurrence, targetProdType, targetRef) {
      var _this = _super.call(this) || this;
      _this.targetOccurrence = targetOccurrence;
      _this.targetProdType = targetProdType;
      _this.targetRef = targetRef;
      _this.result = [];
      return _this;
    }
    InsideDefinitionFinderVisitor2.prototype.checkIsTarget = function(node, expectedProdName) {
      if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdName && (this.targetRef === void 0 || node === this.targetRef)) {
        this.result = node.definition;
      }
    };
    InsideDefinitionFinderVisitor2.prototype.visitOption = function(node) {
      this.checkIsTarget(node, PROD_TYPE.OPTION);
    };
    InsideDefinitionFinderVisitor2.prototype.visitRepetition = function(node) {
      this.checkIsTarget(node, PROD_TYPE.REPETITION);
    };
    InsideDefinitionFinderVisitor2.prototype.visitRepetitionMandatory = function(node) {
      this.checkIsTarget(node, PROD_TYPE.REPETITION_MANDATORY);
    };
    InsideDefinitionFinderVisitor2.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
      this.checkIsTarget(node, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR);
    };
    InsideDefinitionFinderVisitor2.prototype.visitRepetitionWithSeparator = function(node) {
      this.checkIsTarget(node, PROD_TYPE.REPETITION_WITH_SEPARATOR);
    };
    InsideDefinitionFinderVisitor2.prototype.visitAlternation = function(node) {
      this.checkIsTarget(node, PROD_TYPE.ALTERNATION);
    };
    return InsideDefinitionFinderVisitor2;
  })(GAstVisitor)
);
function initializeArrayOfArrays(size) {
  var result = new Array(size);
  for (var i = 0; i < size; i++) {
    result[i] = [];
  }
  return result;
}
function pathToHashKeys(path) {
  var keys2 = [""];
  for (var i = 0; i < path.length; i++) {
    var tokType = path[i];
    var longerKeys = [];
    for (var j = 0; j < keys2.length; j++) {
      var currShorterKey = keys2[j];
      longerKeys.push(currShorterKey + "_" + tokType.tokenTypeIdx);
      for (var t = 0; t < tokType.categoryMatches.length; t++) {
        var categoriesKeySuffix = "_" + tokType.categoryMatches[t];
        longerKeys.push(currShorterKey + categoriesKeySuffix);
      }
    }
    keys2 = longerKeys;
  }
  return keys2;
}
function isUniquePrefixHash(altKnownPathsKeys, searchPathKeys, idx) {
  for (var currAltIdx = 0; currAltIdx < altKnownPathsKeys.length; currAltIdx++) {
    if (currAltIdx === idx) {
      continue;
    }
    var otherAltKnownPathsKeys = altKnownPathsKeys[currAltIdx];
    for (var searchIdx = 0; searchIdx < searchPathKeys.length; searchIdx++) {
      var searchKey = searchPathKeys[searchIdx];
      if (otherAltKnownPathsKeys[searchKey] === true) {
        return false;
      }
    }
  }
  return true;
}
function lookAheadSequenceFromAlternatives(altsDefs, k) {
  var partialAlts = map(altsDefs, function(currAlt) {
    return possiblePathsFrom([currAlt], 1);
  });
  var finalResult = initializeArrayOfArrays(partialAlts.length);
  var altsHashes = map(partialAlts, function(currAltPaths) {
    var dict = {};
    forEach(currAltPaths, function(item) {
      var keys2 = pathToHashKeys(item.partialPath);
      forEach(keys2, function(currKey) {
        dict[currKey] = true;
      });
    });
    return dict;
  });
  var newData = partialAlts;
  for (var pathLength = 1; pathLength <= k; pathLength++) {
    var currDataset = newData;
    newData = initializeArrayOfArrays(currDataset.length);
    var _loop_1 = function(altIdx2) {
      var currAltPathsAndSuffixes = currDataset[altIdx2];
      for (var currPathIdx = 0; currPathIdx < currAltPathsAndSuffixes.length; currPathIdx++) {
        var currPathPrefix = currAltPathsAndSuffixes[currPathIdx].partialPath;
        var suffixDef = currAltPathsAndSuffixes[currPathIdx].suffixDef;
        var prefixKeys = pathToHashKeys(currPathPrefix);
        var isUnique = isUniquePrefixHash(altsHashes, prefixKeys, altIdx2);
        if (isUnique || isEmpty(suffixDef) || currPathPrefix.length === k) {
          var currAltResult = finalResult[altIdx2];
          if (containsPath(currAltResult, currPathPrefix) === false) {
            currAltResult.push(currPathPrefix);
            for (var j = 0; j < prefixKeys.length; j++) {
              var currKey = prefixKeys[j];
              altsHashes[altIdx2][currKey] = true;
            }
          }
        } else {
          var newPartialPathsAndSuffixes = possiblePathsFrom(suffixDef, pathLength + 1, currPathPrefix);
          newData[altIdx2] = newData[altIdx2].concat(newPartialPathsAndSuffixes);
          forEach(newPartialPathsAndSuffixes, function(item) {
            var prefixKeys2 = pathToHashKeys(item.partialPath);
            forEach(prefixKeys2, function(key) {
              altsHashes[altIdx2][key] = true;
            });
          });
        }
      }
    };
    for (var altIdx = 0; altIdx < currDataset.length; altIdx++) {
      _loop_1(altIdx);
    }
  }
  return finalResult;
}
function getLookaheadPathsForOr(occurrence, ruleGrammar, k, orProd) {
  var visitor = new InsideDefinitionFinderVisitor(occurrence, PROD_TYPE.ALTERNATION, orProd);
  ruleGrammar.accept(visitor);
  return lookAheadSequenceFromAlternatives(visitor.result, k);
}
function getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k) {
  var insideDefVisitor = new InsideDefinitionFinderVisitor(occurrence, prodType);
  ruleGrammar.accept(insideDefVisitor);
  var insideDef = insideDefVisitor.result;
  var afterDefWalker = new RestDefinitionFinderWalker(ruleGrammar, occurrence, prodType);
  var afterDef = afterDefWalker.startWalking();
  var insideFlat = new Flat({ definition: insideDef });
  var afterFlat = new Flat({ definition: afterDef });
  return lookAheadSequenceFromAlternatives([insideFlat, afterFlat], k);
}
function containsPath(alternative, searchPath) {
  compareOtherPath: for (var i = 0; i < alternative.length; i++) {
    var otherPath = alternative[i];
    if (otherPath.length !== searchPath.length) {
      continue;
    }
    for (var j = 0; j < otherPath.length; j++) {
      var searchTok = searchPath[j];
      var otherTok = otherPath[j];
      var matchingTokens = searchTok === otherTok || otherTok.categoryMatchesMap[searchTok.tokenTypeIdx] !== void 0;
      if (matchingTokens === false) {
        continue compareOtherPath;
      }
    }
    return true;
  }
  return false;
}
function isStrictPrefixOfPath(prefix, other) {
  return prefix.length < other.length && every(prefix, function(tokType, idx) {
    var otherTokType = other[idx];
    return tokType === otherTokType || otherTokType.categoryMatchesMap[tokType.tokenTypeIdx];
  });
}
function areTokenCategoriesNotUsed(lookAheadPaths) {
  return every(lookAheadPaths, function(singleAltPaths) {
    return every(singleAltPaths, function(singlePath) {
      return every(singlePath, function(token) {
        return isEmpty(token.categoryMatches);
      });
    });
  });
}
var __extends$2 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
function validateGrammar$1(topLevels, globalMaxLookahead, tokenTypes, ignoredIssues, errMsgProvider, grammarName) {
  var duplicateErrors = map(topLevels, function(currTopLevel) {
    return validateDuplicateProductions(currTopLevel, errMsgProvider);
  });
  var leftRecursionErrors = map(topLevels, function(currTopRule) {
    return validateNoLeftRecursion(currTopRule, currTopRule, errMsgProvider);
  });
  var emptyAltErrors = [];
  var ambiguousAltsErrors = [];
  var emptyRepetitionErrors = [];
  if (every(leftRecursionErrors, isEmpty)) {
    emptyAltErrors = map(topLevels, function(currTopRule) {
      return validateEmptyOrAlternative(currTopRule, errMsgProvider);
    });
    ambiguousAltsErrors = map(topLevels, function(currTopRule) {
      return validateAmbiguousAlternationAlternatives(currTopRule, globalMaxLookahead, ignoredIssues, errMsgProvider);
    });
    emptyRepetitionErrors = validateSomeNonEmptyLookaheadPath(topLevels, globalMaxLookahead, errMsgProvider);
  }
  var termsNamespaceConflictErrors = checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider);
  var tokenNameErrors = map(tokenTypes, function(currTokType) {
    return validateTokenName(currTokType, errMsgProvider);
  });
  var nestedRulesNameErrors = validateNestedRulesNames(topLevels, errMsgProvider);
  var nestedRulesDuplicateErrors = validateDuplicateNestedRules(topLevels, errMsgProvider);
  var tooManyAltsErrors = map(topLevels, function(curRule) {
    return validateTooManyAlts(curRule, errMsgProvider);
  });
  var ruleNameErrors = map(topLevels, function(curRule) {
    return validateRuleName(curRule, errMsgProvider);
  });
  var duplicateRulesError = map(topLevels, function(curRule) {
    return validateRuleDoesNotAlreadyExist(curRule, topLevels, grammarName, errMsgProvider);
  });
  return flatten(duplicateErrors.concat(tokenNameErrors, nestedRulesNameErrors, nestedRulesDuplicateErrors, emptyRepetitionErrors, leftRecursionErrors, emptyAltErrors, ambiguousAltsErrors, termsNamespaceConflictErrors, tooManyAltsErrors, ruleNameErrors, duplicateRulesError));
}
function validateNestedRulesNames(topLevels, errMsgProvider) {
  var result = [];
  forEach(topLevels, function(curTopLevel) {
    var namedCollectorVisitor = new NamedDSLMethodsCollectorVisitor("");
    curTopLevel.accept(namedCollectorVisitor);
    var nestedProds = map(namedCollectorVisitor.result, function(currItem) {
      return currItem.orgProd;
    });
    result.push(map(nestedProds, function(currNestedProd) {
      return validateNestedRuleName(curTopLevel, currNestedProd, errMsgProvider);
    }));
  });
  return flatten(result);
}
function validateDuplicateProductions(topLevelRule, errMsgProvider) {
  var collectorVisitor2 = new OccurrenceValidationCollector();
  topLevelRule.accept(collectorVisitor2);
  var allRuleProductions = collectorVisitor2.allProductions;
  var productionGroups = groupBy(allRuleProductions, identifyProductionForDuplicates);
  var duplicates = pick(productionGroups, function(currGroup) {
    return currGroup.length > 1;
  });
  var errors = map(values(duplicates), function(currDuplicates) {
    var firstProd = first$1(currDuplicates);
    var msg = errMsgProvider.buildDuplicateFoundError(topLevelRule, currDuplicates);
    var dslName = getProductionDslName(firstProd);
    var defError = {
      message: msg,
      type: ParserDefinitionErrorType.DUPLICATE_PRODUCTIONS,
      ruleName: topLevelRule.name,
      dslName,
      occurrence: firstProd.idx
    };
    var param = getExtraProductionArgument(firstProd);
    if (param) {
      defError.parameter = param;
    }
    return defError;
  });
  return errors;
}
function identifyProductionForDuplicates(prod) {
  return getProductionDslName(prod) + "_#_" + prod.idx + "_#_" + getExtraProductionArgument(prod);
}
function getExtraProductionArgument(prod) {
  if (prod instanceof Terminal) {
    return prod.terminalType.name;
  } else if (prod instanceof NonTerminal) {
    return prod.nonTerminalName;
  } else {
    return "";
  }
}
var OccurrenceValidationCollector = (
  /** @class */
  (function(_super) {
    __extends$2(OccurrenceValidationCollector2, _super);
    function OccurrenceValidationCollector2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.allProductions = [];
      return _this;
    }
    OccurrenceValidationCollector2.prototype.visitNonTerminal = function(subrule) {
      this.allProductions.push(subrule);
    };
    OccurrenceValidationCollector2.prototype.visitOption = function(option) {
      this.allProductions.push(option);
    };
    OccurrenceValidationCollector2.prototype.visitRepetitionWithSeparator = function(manySep) {
      this.allProductions.push(manySep);
    };
    OccurrenceValidationCollector2.prototype.visitRepetitionMandatory = function(atLeastOne) {
      this.allProductions.push(atLeastOne);
    };
    OccurrenceValidationCollector2.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
      this.allProductions.push(atLeastOneSep);
    };
    OccurrenceValidationCollector2.prototype.visitRepetition = function(many) {
      this.allProductions.push(many);
    };
    OccurrenceValidationCollector2.prototype.visitAlternation = function(or) {
      this.allProductions.push(or);
    };
    OccurrenceValidationCollector2.prototype.visitTerminal = function(terminal) {
      this.allProductions.push(terminal);
    };
    return OccurrenceValidationCollector2;
  })(GAstVisitor)
);
var validTermsPattern = /^[a-zA-Z_]\w*$/;
var validNestedRuleName = new RegExp(validTermsPattern.source.replace("^", "^\\$"));
function validateRuleName(rule, errMsgProvider) {
  var errors = [];
  var ruleName = rule.name;
  if (!ruleName.match(validTermsPattern)) {
    errors.push({
      message: errMsgProvider.buildInvalidRuleNameError({
        topLevelRule: rule,
        expectedPattern: validTermsPattern
      }),
      type: ParserDefinitionErrorType.INVALID_RULE_NAME,
      ruleName
    });
  }
  return errors;
}
function validateNestedRuleName(topLevel, nestedProd, errMsgProvider) {
  var errors = [];
  var errMsg;
  if (!nestedProd.name.match(validNestedRuleName)) {
    errMsg = errMsgProvider.buildInvalidNestedRuleNameError(topLevel, nestedProd);
    errors.push({
      message: errMsg,
      type: ParserDefinitionErrorType.INVALID_NESTED_RULE_NAME,
      ruleName: topLevel.name
    });
  }
  return errors;
}
function validateTokenName(tokenType, errMsgProvider) {
  var errors = [];
  var tokTypeName = tokenType.name;
  if (!tokTypeName.match(validTermsPattern)) {
    errors.push({
      message: errMsgProvider.buildTokenNameError({
        tokenType,
        expectedPattern: validTermsPattern
      }),
      type: ParserDefinitionErrorType.INVALID_TOKEN_NAME
    });
  }
  return errors;
}
function validateRuleDoesNotAlreadyExist(rule, allRules, className, errMsgProvider) {
  var errors = [];
  var occurrences = reduce(allRules, function(result, curRule) {
    if (curRule.name === rule.name) {
      return result + 1;
    }
    return result;
  }, 0);
  if (occurrences > 1) {
    var errMsg = errMsgProvider.buildDuplicateRuleNameError({
      topLevelRule: rule,
      grammarName: className
    });
    errors.push({
      message: errMsg,
      type: ParserDefinitionErrorType.DUPLICATE_RULE_NAME,
      ruleName: rule.name
    });
  }
  return errors;
}
function validateRuleIsOverridden(ruleName, definedRulesNames, className) {
  var errors = [];
  var errMsg;
  if (!contains(definedRulesNames, ruleName)) {
    errMsg = "Invalid rule override, rule: ->" + ruleName + "<- cannot be overridden in the grammar: ->" + className + "<-as it is not defined in any of the super grammars ";
    errors.push({
      message: errMsg,
      type: ParserDefinitionErrorType.INVALID_RULE_OVERRIDE,
      ruleName
    });
  }
  return errors;
}
function validateNoLeftRecursion(topRule, currRule, errMsgProvider, path) {
  if (path === void 0) {
    path = [];
  }
  var errors = [];
  var nextNonTerminals = getFirstNoneTerminal(currRule.definition);
  if (isEmpty(nextNonTerminals)) {
    return [];
  } else {
    var ruleName = topRule.name;
    var foundLeftRecursion = contains(nextNonTerminals, topRule);
    if (foundLeftRecursion) {
      errors.push({
        message: errMsgProvider.buildLeftRecursionError({
          topLevelRule: topRule,
          leftRecursionPath: path
        }),
        type: ParserDefinitionErrorType.LEFT_RECURSION,
        ruleName
      });
    }
    var validNextSteps = difference(nextNonTerminals, path.concat([topRule]));
    var errorsFromNextSteps = map(validNextSteps, function(currRefRule) {
      var newPath = cloneArr(path);
      newPath.push(currRefRule);
      return validateNoLeftRecursion(topRule, currRefRule, errMsgProvider, newPath);
    });
    return errors.concat(flatten(errorsFromNextSteps));
  }
}
function getFirstNoneTerminal(definition) {
  var result = [];
  if (isEmpty(definition)) {
    return result;
  }
  var firstProd = first$1(definition);
  if (firstProd instanceof NonTerminal) {
    result.push(firstProd.referencedRule);
  } else if (firstProd instanceof Flat || firstProd instanceof Option$1 || firstProd instanceof RepetitionMandatory || firstProd instanceof RepetitionMandatoryWithSeparator || firstProd instanceof RepetitionWithSeparator || firstProd instanceof Repetition) {
    result = result.concat(getFirstNoneTerminal(firstProd.definition));
  } else if (firstProd instanceof Alternation) {
    result = flatten(map(firstProd.definition, function(currSubDef) {
      return getFirstNoneTerminal(currSubDef.definition);
    }));
  } else if (firstProd instanceof Terminal) ;
  else {
    throw Error("non exhaustive match");
  }
  var isFirstOptional = isOptionalProd(firstProd);
  var hasMore = definition.length > 1;
  if (isFirstOptional && hasMore) {
    var rest = drop(definition);
    return result.concat(getFirstNoneTerminal(rest));
  } else {
    return result;
  }
}
var OrCollector = (
  /** @class */
  (function(_super) {
    __extends$2(OrCollector2, _super);
    function OrCollector2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.alternations = [];
      return _this;
    }
    OrCollector2.prototype.visitAlternation = function(node) {
      this.alternations.push(node);
    };
    return OrCollector2;
  })(GAstVisitor)
);
function validateEmptyOrAlternative(topLevelRule, errMsgProvider) {
  var orCollector = new OrCollector();
  topLevelRule.accept(orCollector);
  var ors = orCollector.alternations;
  var errors = reduce(ors, function(errors2, currOr) {
    var exceptLast = dropRight(currOr.definition);
    var currErrors = map(exceptLast, function(currAlternative, currAltIdx) {
      var possibleFirstInAlt = nextPossibleTokensAfter([currAlternative], [], null, 1);
      if (isEmpty(possibleFirstInAlt)) {
        return {
          message: errMsgProvider.buildEmptyAlternationError({
            topLevelRule,
            alternation: currOr,
            emptyChoiceIdx: currAltIdx
          }),
          type: ParserDefinitionErrorType.NONE_LAST_EMPTY_ALT,
          ruleName: topLevelRule.name,
          occurrence: currOr.idx,
          alternative: currAltIdx + 1
        };
      } else {
        return null;
      }
    });
    return errors2.concat(compact(currErrors));
  }, []);
  return errors;
}
function validateAmbiguousAlternationAlternatives(topLevelRule, globalMaxLookahead, ignoredIssues, errMsgProvider) {
  var orCollector = new OrCollector();
  topLevelRule.accept(orCollector);
  var ors = orCollector.alternations;
  var ignoredIssuesForCurrentRule = ignoredIssues[topLevelRule.name];
  if (ignoredIssuesForCurrentRule) {
    ors = reject(ors, function(currOr) {
      return ignoredIssuesForCurrentRule[getProductionDslName(currOr) + (currOr.idx === 0 ? "" : currOr.idx)];
    });
  }
  ors = reject(ors, function(currOr) {
    return currOr.ignoreAmbiguities === true;
  });
  var errors = reduce(ors, function(result, currOr) {
    var currOccurrence = currOr.idx;
    var actualMaxLookahead = currOr.maxLookahead || globalMaxLookahead;
    var alternatives = getLookaheadPathsForOr(currOccurrence, topLevelRule, actualMaxLookahead, currOr);
    var altsAmbiguityErrors = checkAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
    var altsPrefixAmbiguityErrors = checkPrefixAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
    return result.concat(altsAmbiguityErrors, altsPrefixAmbiguityErrors);
  }, []);
  return errors;
}
var RepetionCollector = (
  /** @class */
  (function(_super) {
    __extends$2(RepetionCollector2, _super);
    function RepetionCollector2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.allProductions = [];
      return _this;
    }
    RepetionCollector2.prototype.visitRepetitionWithSeparator = function(manySep) {
      this.allProductions.push(manySep);
    };
    RepetionCollector2.prototype.visitRepetitionMandatory = function(atLeastOne) {
      this.allProductions.push(atLeastOne);
    };
    RepetionCollector2.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
      this.allProductions.push(atLeastOneSep);
    };
    RepetionCollector2.prototype.visitRepetition = function(many) {
      this.allProductions.push(many);
    };
    return RepetionCollector2;
  })(GAstVisitor)
);
function validateTooManyAlts(topLevelRule, errMsgProvider) {
  var orCollector = new OrCollector();
  topLevelRule.accept(orCollector);
  var ors = orCollector.alternations;
  var errors = reduce(ors, function(errors2, currOr) {
    if (currOr.definition.length > 255) {
      errors2.push({
        message: errMsgProvider.buildTooManyAlternativesError({
          topLevelRule,
          alternation: currOr
        }),
        type: ParserDefinitionErrorType.TOO_MANY_ALTS,
        ruleName: topLevelRule.name,
        occurrence: currOr.idx
      });
    }
    return errors2;
  }, []);
  return errors;
}
function validateSomeNonEmptyLookaheadPath(topLevelRules, maxLookahead, errMsgProvider) {
  var errors = [];
  forEach(topLevelRules, function(currTopRule) {
    var collectorVisitor2 = new RepetionCollector();
    currTopRule.accept(collectorVisitor2);
    var allRuleProductions = collectorVisitor2.allProductions;
    forEach(allRuleProductions, function(currProd) {
      var prodType = getProdType(currProd);
      var actualMaxLookahead = currProd.maxLookahead || maxLookahead;
      var currOccurrence = currProd.idx;
      var paths = getLookaheadPathsForOptionalProd(currOccurrence, currTopRule, prodType, actualMaxLookahead);
      var pathsInsideProduction = paths[0];
      if (isEmpty(flatten(pathsInsideProduction))) {
        var errMsg = errMsgProvider.buildEmptyRepetitionError({
          topLevelRule: currTopRule,
          repetition: currProd
        });
        errors.push({
          message: errMsg,
          type: ParserDefinitionErrorType.NO_NON_EMPTY_LOOKAHEAD,
          ruleName: currTopRule.name
        });
      }
    });
  });
  return errors;
}
function checkAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
  var foundAmbiguousPaths = [];
  var identicalAmbiguities = reduce(alternatives, function(result, currAlt, currAltIdx) {
    if (alternation.definition[currAltIdx].ignoreAmbiguities === true) {
      return result;
    }
    forEach(currAlt, function(currPath) {
      var altsCurrPathAppearsIn = [currAltIdx];
      forEach(alternatives, function(currOtherAlt, currOtherAltIdx) {
        if (currAltIdx !== currOtherAltIdx && containsPath(currOtherAlt, currPath) && // ignore (skip) ambiguities with this "other" alternative
        alternation.definition[currOtherAltIdx].ignoreAmbiguities !== true) {
          altsCurrPathAppearsIn.push(currOtherAltIdx);
        }
      });
      if (altsCurrPathAppearsIn.length > 1 && !containsPath(foundAmbiguousPaths, currPath)) {
        foundAmbiguousPaths.push(currPath);
        result.push({
          alts: altsCurrPathAppearsIn,
          path: currPath
        });
      }
    });
    return result;
  }, []);
  var currErrors = map(identicalAmbiguities, function(currAmbDescriptor) {
    var ambgIndices = map(currAmbDescriptor.alts, function(currAltIdx) {
      return currAltIdx + 1;
    });
    var currMessage = errMsgProvider.buildAlternationAmbiguityError({
      topLevelRule: rule,
      alternation,
      ambiguityIndices: ambgIndices,
      prefixPath: currAmbDescriptor.path
    });
    return {
      message: currMessage,
      type: ParserDefinitionErrorType.AMBIGUOUS_ALTS,
      ruleName: rule.name,
      occurrence: alternation.idx,
      alternatives: [currAmbDescriptor.alts]
    };
  });
  return currErrors;
}
function checkPrefixAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
  var errors = [];
  var pathsAndIndices = reduce(alternatives, function(result, currAlt, idx) {
    var currPathsAndIdx = map(currAlt, function(currPath) {
      return { idx, path: currPath };
    });
    return result.concat(currPathsAndIdx);
  }, []);
  forEach(pathsAndIndices, function(currPathAndIdx) {
    var alternativeGast = alternation.definition[currPathAndIdx.idx];
    if (alternativeGast.ignoreAmbiguities === true) {
      return;
    }
    var targetIdx = currPathAndIdx.idx;
    var targetPath = currPathAndIdx.path;
    var prefixAmbiguitiesPathsAndIndices = findAll(pathsAndIndices, function(searchPathAndIdx) {
      return (
        // ignore (skip) ambiguities with this "other" alternative
        alternation.definition[searchPathAndIdx.idx].ignoreAmbiguities !== true && searchPathAndIdx.idx < targetIdx && // checking for strict prefix because identical lookaheads
        // will be be detected using a different validation.
        isStrictPrefixOfPath(searchPathAndIdx.path, targetPath)
      );
    });
    var currPathPrefixErrors = map(prefixAmbiguitiesPathsAndIndices, function(currAmbPathAndIdx) {
      var ambgIndices = [currAmbPathAndIdx.idx + 1, targetIdx + 1];
      var occurrence = alternation.idx === 0 ? "" : alternation.idx;
      var message = errMsgProvider.buildAlternationPrefixAmbiguityError({
        topLevelRule: rule,
        alternation,
        ambiguityIndices: ambgIndices,
        prefixPath: currAmbPathAndIdx.path
      });
      return {
        message,
        type: ParserDefinitionErrorType.AMBIGUOUS_PREFIX_ALTS,
        ruleName: rule.name,
        occurrence,
        alternatives: ambgIndices
      };
    });
    errors = errors.concat(currPathPrefixErrors);
  });
  return errors;
}
function checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider) {
  var errors = [];
  var tokenNames = map(tokenTypes, function(currToken) {
    return currToken.name;
  });
  forEach(topLevels, function(currRule) {
    var currRuleName = currRule.name;
    if (contains(tokenNames, currRuleName)) {
      var errMsg = errMsgProvider.buildNamespaceConflictError(currRule);
      errors.push({
        message: errMsg,
        type: ParserDefinitionErrorType.CONFLICT_TOKENS_RULES_NAMESPACE,
        ruleName: currRuleName
      });
    }
  });
  return errors;
}
function validateDuplicateNestedRules(topLevelRules, errMsgProvider) {
  var errors = [];
  forEach(topLevelRules, function(currTopRule) {
    var namedCollectorVisitor = new NamedDSLMethodsCollectorVisitor("");
    currTopRule.accept(namedCollectorVisitor);
    var prodsByGroup = groupBy(namedCollectorVisitor.result, function(item) {
      return item.name;
    });
    var duplicates = pick(prodsByGroup, function(currGroup) {
      return currGroup.length > 1;
    });
    forEach(values(duplicates), function(currDupGroup) {
      var currDupProds = map(currDupGroup, function(dupGroup) {
        return dupGroup.orgProd;
      });
      var errMsg = errMsgProvider.buildDuplicateNestedRuleNameError(currTopRule, currDupProds);
      errors.push({
        message: errMsg,
        type: ParserDefinitionErrorType.DUPLICATE_NESTED_NAME,
        ruleName: currTopRule.name
      });
    });
  });
  return errors;
}
var defaultParserErrorProvider = {
  buildMismatchTokenMessage: function(_a) {
    var expected = _a.expected, actual = _a.actual;
    _a.previous;
    _a.ruleName;
    var hasLabel = hasTokenLabel(expected);
    var expectedMsg = hasLabel ? "--> " + tokenLabel(expected) + " <--" : "token of type --> " + expected.name + " <--";
    var msg = "Expecting " + expectedMsg + " but found --> '" + actual.image + "' <--";
    return msg;
  },
  buildNotAllInputParsedMessage: function(_a) {
    var firstRedundant = _a.firstRedundant;
    _a.ruleName;
    return "Redundant input, expecting EOF but found: " + firstRedundant.image;
  },
  buildNoViableAltMessage: function(_a) {
    var expectedPathsPerAlt = _a.expectedPathsPerAlt, actual = _a.actual;
    _a.previous;
    var customUserDescription = _a.customUserDescription;
    _a.ruleName;
    var errPrefix = "Expecting: ";
    var actualText = first$1(actual).image;
    var errSuffix = "\nbut found: '" + actualText + "'";
    if (customUserDescription) {
      return errPrefix + customUserDescription + errSuffix;
    } else {
      var allLookAheadPaths = reduce(expectedPathsPerAlt, function(result, currAltPaths) {
        return result.concat(currAltPaths);
      }, []);
      var nextValidTokenSequences = map(allLookAheadPaths, function(currPath) {
        return "[" + map(currPath, function(currTokenType) {
          return tokenLabel(currTokenType);
        }).join(", ") + "]";
      });
      var nextValidSequenceItems = map(nextValidTokenSequences, function(itemMsg, idx) {
        return "  " + (idx + 1) + ". " + itemMsg;
      });
      var calculatedDescription = "one of these possible Token sequences:\n" + nextValidSequenceItems.join("\n");
      return errPrefix + calculatedDescription + errSuffix;
    }
  },
  buildEarlyExitMessage: function(_a) {
    var expectedIterationPaths = _a.expectedIterationPaths, actual = _a.actual, customUserDescription = _a.customUserDescription;
    _a.ruleName;
    var errPrefix = "Expecting: ";
    var actualText = first$1(actual).image;
    var errSuffix = "\nbut found: '" + actualText + "'";
    if (customUserDescription) {
      return errPrefix + customUserDescription + errSuffix;
    } else {
      var nextValidTokenSequences = map(expectedIterationPaths, function(currPath) {
        return "[" + map(currPath, function(currTokenType) {
          return tokenLabel(currTokenType);
        }).join(",") + "]";
      });
      var calculatedDescription = "expecting at least one iteration which starts with one of these possible Token sequences::\n  " + ("<" + nextValidTokenSequences.join(" ,") + ">");
      return errPrefix + calculatedDescription + errSuffix;
    }
  }
};
Object.freeze(defaultParserErrorProvider);
var defaultGrammarResolverErrorProvider = {
  buildRuleNotFoundError: function(topLevelRule, undefinedRule) {
    var msg = "Invalid grammar, reference to a rule which is not defined: ->" + undefinedRule.nonTerminalName + "<-\ninside top level rule: ->" + topLevelRule.name + "<-";
    return msg;
  }
};
var defaultGrammarValidatorErrorProvider = {
  buildDuplicateFoundError: function(topLevelRule, duplicateProds) {
    function getExtraProductionArgument2(prod) {
      if (prod instanceof Terminal) {
        return prod.terminalType.name;
      } else if (prod instanceof NonTerminal) {
        return prod.nonTerminalName;
      } else {
        return "";
      }
    }
    var topLevelName = topLevelRule.name;
    var duplicateProd = first$1(duplicateProds);
    var index2 = duplicateProd.idx;
    var dslName = getProductionDslName(duplicateProd);
    var extraArgument = getExtraProductionArgument2(duplicateProd);
    var hasExplicitIndex = index2 > 0;
    var msg = "->" + dslName + (hasExplicitIndex ? index2 : "") + "<- " + (extraArgument ? "with argument: ->" + extraArgument + "<-" : "") + "\n                  appears more than once (" + duplicateProds.length + " times) in the top level rule: ->" + topLevelName + "<-.                  \n                  For further details see: https://sap.github.io/chevrotain/docs/FAQ.html#NUMERICAL_SUFFIXES \n                  ";
    msg = msg.replace(/[ \t]+/g, " ");
    msg = msg.replace(/\s\s+/g, "\n");
    return msg;
  },
  buildInvalidNestedRuleNameError: function(topLevelRule, nestedProd) {
    var msg = "Invalid nested rule name: ->" + nestedProd.name + "<- inside rule: ->" + topLevelRule.name + "<-\n" + ("it must match the pattern: ->" + validNestedRuleName.toString() + "<-.\n") + "Note that this means a nested rule name must start with the '$'(dollar) sign.";
    return msg;
  },
  buildDuplicateNestedRuleNameError: function(topLevelRule, nestedProd) {
    var duplicateName = first$1(nestedProd).name;
    var errMsg = "Duplicate nested rule name: ->" + duplicateName + "<- inside rule: ->" + topLevelRule.name + "<-\nA nested name must be unique in the scope of a top level grammar rule.";
    return errMsg;
  },
  buildNamespaceConflictError: function(rule) {
    var errMsg = "Namespace conflict found in grammar.\n" + ("The grammar has both a Terminal(Token) and a Non-Terminal(Rule) named: <" + rule.name + ">.\n") + "To resolve this make sure each Terminal and Non-Terminal names are unique\nThis is easy to accomplish by using the convention that Terminal names start with an uppercase letter\nand Non-Terminal names start with a lower case letter.";
    return errMsg;
  },
  buildAlternationPrefixAmbiguityError: function(options) {
    var pathMsg = map(options.prefixPath, function(currTok) {
      return tokenLabel(currTok);
    }).join(", ");
    var occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
    var errMsg = "Ambiguous alternatives: <" + options.ambiguityIndices.join(" ,") + "> due to common lookahead prefix\n" + ("in <OR" + occurrence + "> inside <" + options.topLevelRule.name + "> Rule,\n") + ("<" + pathMsg + "> may appears as a prefix path in all these alternatives.\n") + "See: https://sap.github.io/chevrotain/docs/guide/resolving_grammar_errors.html#COMMON_PREFIX\nFor Further details.";
    return errMsg;
  },
  buildAlternationAmbiguityError: function(options) {
    var pathMsg = map(options.prefixPath, function(currtok) {
      return tokenLabel(currtok);
    }).join(", ");
    var occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
    var currMessage = "Ambiguous Alternatives Detected: <" + options.ambiguityIndices.join(" ,") + "> in <OR" + occurrence + ">" + (" inside <" + options.topLevelRule.name + "> Rule,\n") + ("<" + pathMsg + "> may appears as a prefix path in all these alternatives.\n");
    currMessage = currMessage + "See: https://sap.github.io/chevrotain/docs/guide/resolving_grammar_errors.html#AMBIGUOUS_ALTERNATIVES\nFor Further details.";
    return currMessage;
  },
  buildEmptyRepetitionError: function(options) {
    var dslName = getProductionDslName(options.repetition);
    if (options.repetition.idx !== 0) {
      dslName += options.repetition.idx;
    }
    var errMsg = "The repetition <" + dslName + "> within Rule <" + options.topLevelRule.name + "> can never consume any tokens.\nThis could lead to an infinite loop.";
    return errMsg;
  },
  buildTokenNameError: function(options) {
    var tokTypeName = options.tokenType.name;
    var errMsg = "Invalid Grammar Token name: ->" + tokTypeName + "<- it must match the pattern: ->" + options.expectedPattern.toString() + "<-";
    return errMsg;
  },
  buildEmptyAlternationError: function(options) {
    var errMsg = "Ambiguous empty alternative: <" + (options.emptyChoiceIdx + 1) + ">" + (" in <OR" + options.alternation.idx + "> inside <" + options.topLevelRule.name + "> Rule.\n") + "Only the last alternative may be an empty alternative.";
    return errMsg;
  },
  buildTooManyAlternativesError: function(options) {
    var errMsg = "An Alternation cannot have more than 256 alternatives:\n" + ("<OR" + options.alternation.idx + "> inside <" + options.topLevelRule.name + "> Rule.\n has " + (options.alternation.definition.length + 1) + " alternatives.");
    return errMsg;
  },
  buildLeftRecursionError: function(options) {
    var ruleName = options.topLevelRule.name;
    var pathNames = map(options.leftRecursionPath, function(currRule) {
      return currRule.name;
    });
    var leftRecursivePath = ruleName + " --> " + pathNames.concat([ruleName]).join(" --> ");
    var errMsg = "Left Recursion found in grammar.\n" + ("rule: <" + ruleName + "> can be invoked from itself (directly or indirectly)\n") + ("without consuming any Tokens. The grammar path that causes this is: \n " + leftRecursivePath + "\n") + " To fix this refactor your grammar to remove the left recursion.\nsee: https://en.wikipedia.org/wiki/LL_parser#Left_Factoring.";
    return errMsg;
  },
  buildInvalidRuleNameError: function(options) {
    var ruleName = options.topLevelRule.name;
    var expectedPatternString = options.expectedPattern.toString();
    var errMsg = "Invalid grammar rule name: ->" + ruleName + "<- it must match the pattern: ->" + expectedPatternString + "<-";
    return errMsg;
  },
  buildDuplicateRuleNameError: function(options) {
    var ruleName;
    if (options.topLevelRule instanceof Rule) {
      ruleName = options.topLevelRule.name;
    } else {
      ruleName = options.topLevelRule;
    }
    var errMsg = "Duplicate definition, rule: ->" + ruleName + "<- is already defined in the grammar: ->" + options.grammarName + "<-";
    return errMsg;
  }
};
var __extends$1 = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
function resolveGrammar$1(topLevels, errMsgProvider) {
  var refResolver = new GastRefResolverVisitor(topLevels, errMsgProvider);
  refResolver.resolveRefs();
  return refResolver.errors;
}
var GastRefResolverVisitor = (
  /** @class */
  (function(_super) {
    __extends$1(GastRefResolverVisitor2, _super);
    function GastRefResolverVisitor2(nameToTopRule, errMsgProvider) {
      var _this = _super.call(this) || this;
      _this.nameToTopRule = nameToTopRule;
      _this.errMsgProvider = errMsgProvider;
      _this.errors = [];
      return _this;
    }
    GastRefResolverVisitor2.prototype.resolveRefs = function() {
      var _this = this;
      forEach(values(this.nameToTopRule), function(prod) {
        _this.currTopLevel = prod;
        prod.accept(_this);
      });
    };
    GastRefResolverVisitor2.prototype.visitNonTerminal = function(node) {
      var ref = this.nameToTopRule[node.nonTerminalName];
      if (!ref) {
        var msg = this.errMsgProvider.buildRuleNotFoundError(this.currTopLevel, node);
        this.errors.push({
          message: msg,
          type: ParserDefinitionErrorType.UNRESOLVED_SUBRULE_REF,
          ruleName: this.currTopLevel.name,
          unresolvedRefName: node.nonTerminalName
        });
      } else {
        node.referencedRule = ref;
      }
    };
    return GastRefResolverVisitor2;
  })(GAstVisitor)
);
function resolveGrammar(options) {
  options = defaults(options, {
    errMsgProvider: defaultGrammarResolverErrorProvider
  });
  var topRulesTable = {};
  forEach(options.rules, function(rule) {
    topRulesTable[rule.name] = rule;
  });
  return resolveGrammar$1(topRulesTable, options.errMsgProvider);
}
function validateGrammar(options) {
  options = defaults(options, {
    errMsgProvider: defaultGrammarValidatorErrorProvider,
    ignoredIssues: {}
  });
  return validateGrammar$1(options.rules, options.maxLookahead, options.tokenTypes, options.ignoredIssues, options.errMsgProvider, options.grammarName);
}
var MISMATCHED_TOKEN_EXCEPTION = "MismatchedTokenException";
var NO_VIABLE_ALT_EXCEPTION = "NoViableAltException";
var EARLY_EXIT_EXCEPTION = "EarlyExitException";
var NOT_ALL_INPUT_PARSED_EXCEPTION = "NotAllInputParsedException";
var RECOGNITION_EXCEPTION_NAMES = [
  MISMATCHED_TOKEN_EXCEPTION,
  NO_VIABLE_ALT_EXCEPTION,
  EARLY_EXIT_EXCEPTION,
  NOT_ALL_INPUT_PARSED_EXCEPTION
];
Object.freeze(RECOGNITION_EXCEPTION_NAMES);
function isRecognitionException(error2) {
  return contains(RECOGNITION_EXCEPTION_NAMES, error2.name);
}
function MismatchedTokenException(message, token, previousToken) {
  this.name = MISMATCHED_TOKEN_EXCEPTION;
  this.message = message;
  this.token = token;
  this.previousToken = previousToken;
  this.resyncedTokens = [];
}
MismatchedTokenException.prototype = Error.prototype;
function NoViableAltException(message, token, previousToken) {
  this.name = NO_VIABLE_ALT_EXCEPTION;
  this.message = message;
  this.token = token;
  this.previousToken = previousToken;
  this.resyncedTokens = [];
}
NoViableAltException.prototype = Error.prototype;
function NotAllInputParsedException(message, token) {
  this.name = NOT_ALL_INPUT_PARSED_EXCEPTION;
  this.message = message;
  this.token = token;
  this.resyncedTokens = [];
}
NotAllInputParsedException.prototype = Error.prototype;
function EarlyExitException(message, token, previousToken) {
  this.name = EARLY_EXIT_EXCEPTION;
  this.message = message;
  this.token = token;
  this.previousToken = previousToken;
  this.resyncedTokens = [];
}
EarlyExitException.prototype = Error.prototype;
var EOF_FOLLOW_KEY = {};
var IN_RULE_RECOVERY_EXCEPTION = "InRuleRecoveryException";
function InRuleRecoveryException(message) {
  this.name = IN_RULE_RECOVERY_EXCEPTION;
  this.message = message;
}
InRuleRecoveryException.prototype = Error.prototype;
var Recoverable = (
  /** @class */
  (function() {
    function Recoverable2() {
    }
    Recoverable2.prototype.initRecoverable = function(config) {
      this.firstAfterRepMap = {};
      this.resyncFollows = {};
      this.recoveryEnabled = has(config, "recoveryEnabled") ? config.recoveryEnabled : DEFAULT_PARSER_CONFIG.recoveryEnabled;
      if (this.recoveryEnabled) {
        this.attemptInRepetitionRecovery = attemptInRepetitionRecovery;
      }
    };
    Recoverable2.prototype.getTokenToInsert = function(tokType) {
      var tokToInsert = createTokenInstance(tokType, "", NaN, NaN, NaN, NaN, NaN, NaN);
      tokToInsert.isInsertedInRecovery = true;
      return tokToInsert;
    };
    Recoverable2.prototype.canTokenTypeBeInsertedInRecovery = function(tokType) {
      return true;
    };
    Recoverable2.prototype.tryInRepetitionRecovery = function(grammarRule, grammarRuleArgs, lookAheadFunc, expectedTokType) {
      var _this = this;
      var reSyncTokType = this.findReSyncTokenType();
      var savedLexerState = this.exportLexerState();
      var resyncedTokens = [];
      var passedResyncPoint = false;
      var nextTokenWithoutResync = this.LA(1);
      var currToken = this.LA(1);
      var generateErrorMessage = function() {
        var previousToken = _this.LA(0);
        var msg = _this.errorMessageProvider.buildMismatchTokenMessage({
          expected: expectedTokType,
          actual: nextTokenWithoutResync,
          previous: previousToken,
          ruleName: _this.getCurrRuleFullName()
        });
        var error2 = new MismatchedTokenException(msg, nextTokenWithoutResync, _this.LA(0));
        error2.resyncedTokens = dropRight(resyncedTokens);
        _this.SAVE_ERROR(error2);
      };
      while (!passedResyncPoint) {
        if (this.tokenMatcher(currToken, expectedTokType)) {
          generateErrorMessage();
          return;
        } else if (lookAheadFunc.call(this)) {
          generateErrorMessage();
          grammarRule.apply(this, grammarRuleArgs);
          return;
        } else if (this.tokenMatcher(currToken, reSyncTokType)) {
          passedResyncPoint = true;
        } else {
          currToken = this.SKIP_TOKEN();
          this.addToResyncTokens(currToken, resyncedTokens);
        }
      }
      this.importLexerState(savedLexerState);
    };
    Recoverable2.prototype.shouldInRepetitionRecoveryBeTried = function(expectTokAfterLastMatch, nextTokIdx, notStuck) {
      if (notStuck === false) {
        return false;
      }
      if (expectTokAfterLastMatch === void 0 || nextTokIdx === void 0) {
        return false;
      }
      if (this.tokenMatcher(this.LA(1), expectTokAfterLastMatch)) {
        return false;
      }
      if (this.isBackTracking()) {
        return false;
      }
      if (this.canPerformInRuleRecovery(expectTokAfterLastMatch, this.getFollowsForInRuleRecovery(expectTokAfterLastMatch, nextTokIdx))) {
        return false;
      }
      return true;
    };
    Recoverable2.prototype.getFollowsForInRuleRecovery = function(tokType, tokIdxInRule) {
      var grammarPath = this.getCurrentGrammarPath(tokType, tokIdxInRule);
      var follows = this.getNextPossibleTokenTypes(grammarPath);
      return follows;
    };
    Recoverable2.prototype.tryInRuleRecovery = function(expectedTokType, follows) {
      if (this.canRecoverWithSingleTokenInsertion(expectedTokType, follows)) {
        var tokToInsert = this.getTokenToInsert(expectedTokType);
        return tokToInsert;
      }
      if (this.canRecoverWithSingleTokenDeletion(expectedTokType)) {
        var nextTok = this.SKIP_TOKEN();
        this.consumeToken();
        return nextTok;
      }
      throw new InRuleRecoveryException("sad sad panda");
    };
    Recoverable2.prototype.canPerformInRuleRecovery = function(expectedToken, follows) {
      return this.canRecoverWithSingleTokenInsertion(expectedToken, follows) || this.canRecoverWithSingleTokenDeletion(expectedToken);
    };
    Recoverable2.prototype.canRecoverWithSingleTokenInsertion = function(expectedTokType, follows) {
      var _this = this;
      if (!this.canTokenTypeBeInsertedInRecovery(expectedTokType)) {
        return false;
      }
      if (isEmpty(follows)) {
        return false;
      }
      var mismatchedTok = this.LA(1);
      var isMisMatchedTokInFollows = find(follows, function(possibleFollowsTokType) {
        return _this.tokenMatcher(mismatchedTok, possibleFollowsTokType);
      }) !== void 0;
      return isMisMatchedTokInFollows;
    };
    Recoverable2.prototype.canRecoverWithSingleTokenDeletion = function(expectedTokType) {
      var isNextTokenWhatIsExpected = this.tokenMatcher(this.LA(2), expectedTokType);
      return isNextTokenWhatIsExpected;
    };
    Recoverable2.prototype.isInCurrentRuleReSyncSet = function(tokenTypeIdx) {
      var followKey = this.getCurrFollowKey();
      var currentRuleReSyncSet = this.getFollowSetFromFollowKey(followKey);
      return contains(currentRuleReSyncSet, tokenTypeIdx);
    };
    Recoverable2.prototype.findReSyncTokenType = function() {
      var allPossibleReSyncTokTypes = this.flattenFollowSet();
      var nextToken = this.LA(1);
      var k = 2;
      while (true) {
        var nextTokenType = nextToken.tokenType;
        if (contains(allPossibleReSyncTokTypes, nextTokenType)) {
          return nextTokenType;
        }
        nextToken = this.LA(k);
        k++;
      }
    };
    Recoverable2.prototype.getCurrFollowKey = function() {
      if (this.RULE_STACK.length === 1) {
        return EOF_FOLLOW_KEY;
      }
      var currRuleShortName = this.getLastExplicitRuleShortName();
      var currRuleIdx = this.getLastExplicitRuleOccurrenceIndex();
      var prevRuleShortName = this.getPreviousExplicitRuleShortName();
      return {
        ruleName: this.shortRuleNameToFullName(currRuleShortName),
        idxInCallingRule: currRuleIdx,
        inRule: this.shortRuleNameToFullName(prevRuleShortName)
      };
    };
    Recoverable2.prototype.buildFullFollowKeyStack = function() {
      var _this = this;
      var explicitRuleStack = this.RULE_STACK;
      var explicitOccurrenceStack = this.RULE_OCCURRENCE_STACK;
      if (!isEmpty(this.LAST_EXPLICIT_RULE_STACK)) {
        explicitRuleStack = map(this.LAST_EXPLICIT_RULE_STACK, function(idx) {
          return _this.RULE_STACK[idx];
        });
        explicitOccurrenceStack = map(this.LAST_EXPLICIT_RULE_STACK, function(idx) {
          return _this.RULE_OCCURRENCE_STACK[idx];
        });
      }
      return map(explicitRuleStack, function(ruleName, idx) {
        if (idx === 0) {
          return EOF_FOLLOW_KEY;
        }
        return {
          ruleName: _this.shortRuleNameToFullName(ruleName),
          idxInCallingRule: explicitOccurrenceStack[idx],
          inRule: _this.shortRuleNameToFullName(explicitRuleStack[idx - 1])
        };
      });
    };
    Recoverable2.prototype.flattenFollowSet = function() {
      var _this = this;
      var followStack = map(this.buildFullFollowKeyStack(), function(currKey) {
        return _this.getFollowSetFromFollowKey(currKey);
      });
      return flatten(followStack);
    };
    Recoverable2.prototype.getFollowSetFromFollowKey = function(followKey) {
      if (followKey === EOF_FOLLOW_KEY) {
        return [EOF];
      }
      var followName = followKey.ruleName + followKey.idxInCallingRule + IN + followKey.inRule;
      return this.resyncFollows[followName];
    };
    Recoverable2.prototype.addToResyncTokens = function(token, resyncTokens) {
      if (!this.tokenMatcher(token, EOF)) {
        resyncTokens.push(token);
      }
      return resyncTokens;
    };
    Recoverable2.prototype.reSyncTo = function(tokType) {
      var resyncedTokens = [];
      var nextTok = this.LA(1);
      while (this.tokenMatcher(nextTok, tokType) === false) {
        nextTok = this.SKIP_TOKEN();
        this.addToResyncTokens(nextTok, resyncedTokens);
      }
      return dropRight(resyncedTokens);
    };
    Recoverable2.prototype.attemptInRepetitionRecovery = function(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
    };
    Recoverable2.prototype.getCurrentGrammarPath = function(tokType, tokIdxInRule) {
      var pathRuleStack = this.getHumanReadableRuleStack();
      var pathOccurrenceStack = cloneArr(this.RULE_OCCURRENCE_STACK);
      var grammarPath = {
        ruleStack: pathRuleStack,
        occurrenceStack: pathOccurrenceStack,
        lastTok: tokType,
        lastTokOccurrence: tokIdxInRule
      };
      return grammarPath;
    };
    Recoverable2.prototype.getHumanReadableRuleStack = function() {
      var _this = this;
      if (!isEmpty(this.LAST_EXPLICIT_RULE_STACK)) {
        return map(this.LAST_EXPLICIT_RULE_STACK, function(currIdx) {
          return _this.shortRuleNameToFullName(_this.RULE_STACK[currIdx]);
        });
      } else {
        return map(this.RULE_STACK, function(currShortName) {
          return _this.shortRuleNameToFullName(currShortName);
        });
      }
    };
    return Recoverable2;
  })()
);
function attemptInRepetitionRecovery(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
  var key = this.getKeyForAutomaticLookahead(dslMethodIdx, prodOccurrence);
  var firstAfterRepInfo = this.firstAfterRepMap[key];
  if (firstAfterRepInfo === void 0) {
    var currRuleName = this.getCurrRuleFullName();
    var ruleGrammar = this.getGAstProductions()[currRuleName];
    var walker = new nextToksWalker(ruleGrammar, prodOccurrence);
    firstAfterRepInfo = walker.startWalking();
    this.firstAfterRepMap[key] = firstAfterRepInfo;
  }
  var expectTokAfterLastMatch = firstAfterRepInfo.token;
  var nextTokIdx = firstAfterRepInfo.occurrence;
  var isEndOfRule = firstAfterRepInfo.isEndOfRule;
  if (this.RULE_STACK.length === 1 && isEndOfRule && expectTokAfterLastMatch === void 0) {
    expectTokAfterLastMatch = EOF;
    nextTokIdx = 1;
  }
  if (this.shouldInRepetitionRecoveryBeTried(expectTokAfterLastMatch, nextTokIdx, notStuck)) {
    this.tryInRepetitionRecovery(prodFunc, args, lookaheadFunc, expectTokAfterLastMatch);
  }
}
var LooksAhead = (
  /** @class */
  (function() {
    function LooksAhead2() {
    }
    LooksAhead2.prototype.initLooksAhead = function(config) {
      this.dynamicTokensEnabled = has(config, "dynamicTokensEnabled") ? config.dynamicTokensEnabled : DEFAULT_PARSER_CONFIG.dynamicTokensEnabled;
      this.maxLookahead = has(config, "maxLookahead") ? config.maxLookahead : DEFAULT_PARSER_CONFIG.maxLookahead;
      this.lookAheadFuncsCache = isES2015MapSupported() ? /* @__PURE__ */ new Map() : [];
      if (isES2015MapSupported()) {
        this.getLaFuncFromCache = this.getLaFuncFromMap;
        this.setLaFuncCache = this.setLaFuncCacheUsingMap;
      } else {
        this.getLaFuncFromCache = this.getLaFuncFromObj;
        this.setLaFuncCache = this.setLaFuncUsingObj;
      }
    };
    LooksAhead2.prototype.preComputeLookaheadFunctions = function(rules) {
      var _this = this;
      forEach(rules, function(currRule) {
        _this.TRACE_INIT(currRule.name + " Rule Lookahead", function() {
          var _a = collectMethods(currRule), alternation = _a.alternation, repetition = _a.repetition, option = _a.option, repetitionMandatory = _a.repetitionMandatory, repetitionMandatoryWithSeparator = _a.repetitionMandatoryWithSeparator, repetitionWithSeparator = _a.repetitionWithSeparator;
          forEach(alternation, function(currProd) {
            var prodIdx = currProd.idx === 0 ? "" : currProd.idx;
            _this.TRACE_INIT("" + getProductionDslName(currProd) + prodIdx, function() {
              var laFunc = buildLookaheadFuncForOr(currProd.idx, currRule, currProd.maxLookahead || _this.maxLookahead, currProd.hasPredicates, _this.dynamicTokensEnabled, _this.lookAheadBuilderForAlternatives);
              var key = getKeyForAutomaticLookahead(_this.fullRuleNameToShort[currRule.name], OR_IDX, currProd.idx);
              _this.setLaFuncCache(key, laFunc);
            });
          });
          forEach(repetition, function(currProd) {
            _this.computeLookaheadFunc(currRule, currProd.idx, MANY_IDX, PROD_TYPE.REPETITION, currProd.maxLookahead, getProductionDslName(currProd));
          });
          forEach(option, function(currProd) {
            _this.computeLookaheadFunc(currRule, currProd.idx, OPTION_IDX, PROD_TYPE.OPTION, currProd.maxLookahead, getProductionDslName(currProd));
          });
          forEach(repetitionMandatory, function(currProd) {
            _this.computeLookaheadFunc(currRule, currProd.idx, AT_LEAST_ONE_IDX, PROD_TYPE.REPETITION_MANDATORY, currProd.maxLookahead, getProductionDslName(currProd));
          });
          forEach(repetitionMandatoryWithSeparator, function(currProd) {
            _this.computeLookaheadFunc(currRule, currProd.idx, AT_LEAST_ONE_SEP_IDX, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, currProd.maxLookahead, getProductionDslName(currProd));
          });
          forEach(repetitionWithSeparator, function(currProd) {
            _this.computeLookaheadFunc(currRule, currProd.idx, MANY_SEP_IDX, PROD_TYPE.REPETITION_WITH_SEPARATOR, currProd.maxLookahead, getProductionDslName(currProd));
          });
        });
      });
    };
    LooksAhead2.prototype.computeLookaheadFunc = function(rule, prodOccurrence, prodKey, prodType, prodMaxLookahead, dslMethodName) {
      var _this = this;
      this.TRACE_INIT("" + dslMethodName + (prodOccurrence === 0 ? "" : prodOccurrence), function() {
        var laFunc = buildLookaheadFuncForOptionalProd(prodOccurrence, rule, prodMaxLookahead || _this.maxLookahead, _this.dynamicTokensEnabled, prodType, _this.lookAheadBuilderForOptional);
        var key = getKeyForAutomaticLookahead(_this.fullRuleNameToShort[rule.name], prodKey, prodOccurrence);
        _this.setLaFuncCache(key, laFunc);
      });
    };
    LooksAhead2.prototype.lookAheadBuilderForOptional = function(alt, tokenMatcher2, dynamicTokensEnabled) {
      return buildSingleAlternativeLookaheadFunction(alt, tokenMatcher2, dynamicTokensEnabled);
    };
    LooksAhead2.prototype.lookAheadBuilderForAlternatives = function(alts, hasPredicates, tokenMatcher2, dynamicTokensEnabled) {
      return buildAlternativesLookAheadFunc(alts, hasPredicates, tokenMatcher2, dynamicTokensEnabled);
    };
    LooksAhead2.prototype.getKeyForAutomaticLookahead = function(dslMethodIdx, occurrence) {
      var currRuleShortName = this.getLastExplicitRuleShortName();
      return getKeyForAutomaticLookahead(currRuleShortName, dslMethodIdx, occurrence);
    };
    LooksAhead2.prototype.getLaFuncFromCache = function(key) {
      return void 0;
    };
    LooksAhead2.prototype.getLaFuncFromMap = function(key) {
      return this.lookAheadFuncsCache.get(key);
    };
    LooksAhead2.prototype.getLaFuncFromObj = function(key) {
      return this.lookAheadFuncsCache[key];
    };
    LooksAhead2.prototype.setLaFuncCache = function(key, value) {
    };
    LooksAhead2.prototype.setLaFuncCacheUsingMap = function(key, value) {
      this.lookAheadFuncsCache.set(key, value);
    };
    LooksAhead2.prototype.setLaFuncUsingObj = function(key, value) {
      this.lookAheadFuncsCache[key] = value;
    };
    return LooksAhead2;
  })()
);
function classNameFromInstance(instance) {
  return functionName(instance.constructor);
}
var FUNC_NAME_REGEXP = /^\s*function\s*(\S*)\s*\(/;
var NAME = "name";
function functionName(func) {
  var existingNameProp = func.name;
  if (existingNameProp) {
    return existingNameProp;
  }
  var computedName = func.toString().match(FUNC_NAME_REGEXP)[1];
  return computedName;
}
function defineNameProp(obj, nameValue) {
  var namePropDescriptor = Object.getOwnPropertyDescriptor(obj, NAME);
  if (isUndefined(namePropDescriptor) || namePropDescriptor.configurable) {
    Object.defineProperty(obj, NAME, {
      enumerable: false,
      configurable: true,
      writable: false,
      value: nameValue
    });
    return true;
  }
  return false;
}
function defaultVisit(ctx, param) {
  var childrenNames = keys(ctx);
  var childrenNamesLength = childrenNames.length;
  for (var i = 0; i < childrenNamesLength; i++) {
    var currChildName = childrenNames[i];
    var currChildArray = ctx[currChildName];
    var currChildArrayLength = currChildArray.length;
    for (var j = 0; j < currChildArrayLength; j++) {
      var currChild = currChildArray[j];
      if (currChild.tokenTypeIdx === void 0) {
        if (currChild.fullName !== void 0) {
          this[currChild.fullName](currChild.children, param);
        } else {
          this[currChild.name](currChild.children, param);
        }
      }
    }
  }
  return void 0;
}
function createBaseSemanticVisitorConstructor(grammarName, ruleNames) {
  var derivedConstructor = function() {
  };
  defineNameProp(derivedConstructor, grammarName + "BaseSemantics");
  var semanticProto = {
    visit: function(cstNode, param) {
      if (isArray(cstNode)) {
        cstNode = cstNode[0];
      }
      if (isUndefined(cstNode)) {
        return void 0;
      }
      if (cstNode.fullName !== void 0) {
        return this[cstNode.fullName](cstNode.children, param);
      } else {
        return this[cstNode.name](cstNode.children, param);
      }
    },
    validateVisitor: function() {
      var semanticDefinitionErrors = validateVisitor(this, ruleNames);
      if (!isEmpty(semanticDefinitionErrors)) {
        var errorMessages = map(semanticDefinitionErrors, function(currDefError) {
          return currDefError.msg;
        });
        throw Error("Errors Detected in CST Visitor <" + functionName(this.constructor) + ">:\n	" + ("" + errorMessages.join("\n\n").replace(/\n/g, "\n	")));
      }
    }
  };
  derivedConstructor.prototype = semanticProto;
  derivedConstructor.prototype.constructor = derivedConstructor;
  derivedConstructor._RULE_NAMES = ruleNames;
  return derivedConstructor;
}
function createBaseVisitorConstructorWithDefaults(grammarName, ruleNames, baseConstructor) {
  var derivedConstructor = function() {
  };
  defineNameProp(derivedConstructor, grammarName + "BaseSemanticsWithDefaults");
  var withDefaultsProto = Object.create(baseConstructor.prototype);
  forEach(ruleNames, function(ruleName) {
    withDefaultsProto[ruleName] = defaultVisit;
  });
  derivedConstructor.prototype = withDefaultsProto;
  derivedConstructor.prototype.constructor = derivedConstructor;
  return derivedConstructor;
}
var CstVisitorDefinitionError;
(function(CstVisitorDefinitionError2) {
  CstVisitorDefinitionError2[CstVisitorDefinitionError2["REDUNDANT_METHOD"] = 0] = "REDUNDANT_METHOD";
  CstVisitorDefinitionError2[CstVisitorDefinitionError2["MISSING_METHOD"] = 1] = "MISSING_METHOD";
})(CstVisitorDefinitionError || (CstVisitorDefinitionError = {}));
function validateVisitor(visitorInstance, ruleNames) {
  var missingErrors = validateMissingCstMethods(visitorInstance, ruleNames);
  var redundantErrors = validateRedundantMethods(visitorInstance, ruleNames);
  return missingErrors.concat(redundantErrors);
}
function validateMissingCstMethods(visitorInstance, ruleNames) {
  var errors = map(ruleNames, function(currRuleName) {
    if (!isFunction(visitorInstance[currRuleName])) {
      return {
        msg: "Missing visitor method: <" + currRuleName + "> on " + functionName(visitorInstance.constructor) + " CST Visitor.",
        type: CstVisitorDefinitionError.MISSING_METHOD,
        methodName: currRuleName
      };
    }
  });
  return compact(errors);
}
var VALID_PROP_NAMES = ["constructor", "visit", "validateVisitor"];
function validateRedundantMethods(visitorInstance, ruleNames) {
  var errors = [];
  for (var prop in visitorInstance) {
    if (validTermsPattern.test(prop) && isFunction(visitorInstance[prop]) && !contains(VALID_PROP_NAMES, prop) && !contains(ruleNames, prop)) {
      errors.push({
        msg: "Redundant visitor method: <" + prop + "> on " + functionName(visitorInstance.constructor) + " CST Visitor\nThere is no Grammar Rule corresponding to this method's name.\n" + ("For utility methods on visitor classes use methods names that do not match /" + validTermsPattern.source + "/."),
        type: CstVisitorDefinitionError.REDUNDANT_METHOD,
        methodName: prop
      });
    }
  }
  return errors;
}
var TreeBuilder = (
  /** @class */
  (function() {
    function TreeBuilder2() {
    }
    TreeBuilder2.prototype.initTreeBuilder = function(config) {
      this.LAST_EXPLICIT_RULE_STACK = [];
      this.CST_STACK = [];
      this.outputCst = has(config, "outputCst") ? config.outputCst : DEFAULT_PARSER_CONFIG.outputCst;
      this.nodeLocationTracking = has(config, "nodeLocationTracking") ? config.nodeLocationTracking : DEFAULT_PARSER_CONFIG.nodeLocationTracking;
      if (!this.outputCst) {
        this.cstInvocationStateUpdate = NOOP;
        this.cstFinallyStateUpdate = NOOP;
        this.cstPostTerminal = NOOP;
        this.cstPostNonTerminal = NOOP;
        this.cstPostRule = NOOP;
        this.getLastExplicitRuleShortName = this.getLastExplicitRuleShortNameNoCst;
        this.getPreviousExplicitRuleShortName = this.getPreviousExplicitRuleShortNameNoCst;
        this.getLastExplicitRuleOccurrenceIndex = this.getLastExplicitRuleOccurrenceIndexNoCst;
        this.manyInternal = this.manyInternalNoCst;
        this.orInternal = this.orInternalNoCst;
        this.optionInternal = this.optionInternalNoCst;
        this.atLeastOneInternal = this.atLeastOneInternalNoCst;
        this.manySepFirstInternal = this.manySepFirstInternalNoCst;
        this.atLeastOneSepFirstInternal = this.atLeastOneSepFirstInternalNoCst;
      } else {
        if (/full/i.test(this.nodeLocationTracking)) {
          if (this.recoveryEnabled) {
            this.setNodeLocationFromToken = setNodeLocationFull;
            this.setNodeLocationFromNode = setNodeLocationFull;
            this.cstPostRule = NOOP;
            this.setInitialNodeLocation = this.setInitialNodeLocationFullRecovery;
          } else {
            this.setNodeLocationFromToken = NOOP;
            this.setNodeLocationFromNode = NOOP;
            this.cstPostRule = this.cstPostRuleFull;
            this.setInitialNodeLocation = this.setInitialNodeLocationFullRegular;
          }
        } else if (/onlyOffset/i.test(this.nodeLocationTracking)) {
          if (this.recoveryEnabled) {
            this.setNodeLocationFromToken = setNodeLocationOnlyOffset;
            this.setNodeLocationFromNode = setNodeLocationOnlyOffset;
            this.cstPostRule = NOOP;
            this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRecovery;
          } else {
            this.setNodeLocationFromToken = NOOP;
            this.setNodeLocationFromNode = NOOP;
            this.cstPostRule = this.cstPostRuleOnlyOffset;
            this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRegular;
          }
        } else if (/none/i.test(this.nodeLocationTracking)) {
          this.setNodeLocationFromToken = NOOP;
          this.setNodeLocationFromNode = NOOP;
          this.cstPostRule = NOOP;
          this.setInitialNodeLocation = NOOP;
        } else {
          throw Error('Invalid <nodeLocationTracking> config option: "' + config.nodeLocationTracking + '"');
        }
      }
    };
    TreeBuilder2.prototype.setInitialNodeLocationOnlyOffsetRecovery = function(cstNode) {
      cstNode.location = {
        startOffset: NaN,
        endOffset: NaN
      };
    };
    TreeBuilder2.prototype.setInitialNodeLocationOnlyOffsetRegular = function(cstNode) {
      cstNode.location = {
        // without error recovery the starting Location of a new CstNode is guaranteed
        // To be the next Token's startOffset (for valid inputs).
        // For invalid inputs there won't be any CSTOutput so this potential
        // inaccuracy does not matter
        startOffset: this.LA(1).startOffset,
        endOffset: NaN
      };
    };
    TreeBuilder2.prototype.setInitialNodeLocationFullRecovery = function(cstNode) {
      cstNode.location = {
        startOffset: NaN,
        startLine: NaN,
        startColumn: NaN,
        endOffset: NaN,
        endLine: NaN,
        endColumn: NaN
      };
    };
    TreeBuilder2.prototype.setInitialNodeLocationFullRegular = function(cstNode) {
      var nextToken = this.LA(1);
      cstNode.location = {
        startOffset: nextToken.startOffset,
        startLine: nextToken.startLine,
        startColumn: nextToken.startColumn,
        endOffset: NaN,
        endLine: NaN,
        endColumn: NaN
      };
    };
    TreeBuilder2.prototype.cstNestedInvocationStateUpdate = function(nestedName, shortName) {
      var cstNode = {
        name: nestedName,
        fullName: this.shortRuleNameToFull[this.getLastExplicitRuleShortName()] + nestedName,
        children: {}
      };
      this.setInitialNodeLocation(cstNode);
      this.CST_STACK.push(cstNode);
    };
    TreeBuilder2.prototype.cstInvocationStateUpdate = function(fullRuleName, shortName) {
      this.LAST_EXPLICIT_RULE_STACK.push(this.RULE_STACK.length - 1);
      var cstNode = {
        name: fullRuleName,
        children: {}
      };
      this.setInitialNodeLocation(cstNode);
      this.CST_STACK.push(cstNode);
    };
    TreeBuilder2.prototype.cstFinallyStateUpdate = function() {
      this.LAST_EXPLICIT_RULE_STACK.pop();
      this.CST_STACK.pop();
    };
    TreeBuilder2.prototype.cstNestedFinallyStateUpdate = function() {
      var lastCstNode = this.CST_STACK.pop();
      this.cstPostRule(lastCstNode);
    };
    TreeBuilder2.prototype.cstPostRuleFull = function(ruleCstNode) {
      var prevToken = this.LA(0);
      var loc = ruleCstNode.location;
      if (loc.startOffset <= prevToken.startOffset === true) {
        loc.endOffset = prevToken.endOffset;
        loc.endLine = prevToken.endLine;
        loc.endColumn = prevToken.endColumn;
      } else {
        loc.startOffset = NaN;
        loc.startLine = NaN;
        loc.startColumn = NaN;
      }
    };
    TreeBuilder2.prototype.cstPostRuleOnlyOffset = function(ruleCstNode) {
      var prevToken = this.LA(0);
      var loc = ruleCstNode.location;
      if (loc.startOffset <= prevToken.startOffset === true) {
        loc.endOffset = prevToken.endOffset;
      } else {
        loc.startOffset = NaN;
      }
    };
    TreeBuilder2.prototype.cstPostTerminal = function(key, consumedToken) {
      var rootCst = this.CST_STACK[this.CST_STACK.length - 1];
      addTerminalToCst(rootCst, consumedToken, key);
      this.setNodeLocationFromToken(rootCst.location, consumedToken);
    };
    TreeBuilder2.prototype.cstPostNonTerminal = function(ruleCstResult, ruleName) {
      if (this.isBackTracking() !== true) {
        var preCstNode = this.CST_STACK[this.CST_STACK.length - 1];
        addNoneTerminalToCst(preCstNode, ruleName, ruleCstResult);
        this.setNodeLocationFromNode(preCstNode.location, ruleCstResult.location);
      }
    };
    TreeBuilder2.prototype.getBaseCstVisitorConstructor = function() {
      if (isUndefined(this.baseCstVisitorConstructor)) {
        var newBaseCstVisitorConstructor = createBaseSemanticVisitorConstructor(this.className, this.allRuleNames);
        this.baseCstVisitorConstructor = newBaseCstVisitorConstructor;
        return newBaseCstVisitorConstructor;
      }
      return this.baseCstVisitorConstructor;
    };
    TreeBuilder2.prototype.getBaseCstVisitorConstructorWithDefaults = function() {
      if (isUndefined(this.baseCstVisitorWithDefaultsConstructor)) {
        var newConstructor = createBaseVisitorConstructorWithDefaults(this.className, this.allRuleNames, this.getBaseCstVisitorConstructor());
        this.baseCstVisitorWithDefaultsConstructor = newConstructor;
        return newConstructor;
      }
      return this.baseCstVisitorWithDefaultsConstructor;
    };
    TreeBuilder2.prototype.nestedRuleBeforeClause = function(methodOpts, laKey) {
      var nestedName;
      if (methodOpts.NAME !== void 0) {
        nestedName = methodOpts.NAME;
        this.nestedRuleInvocationStateUpdate(nestedName, laKey);
        return nestedName;
      } else {
        return void 0;
      }
    };
    TreeBuilder2.prototype.nestedAltBeforeClause = function(methodOpts, occurrence, methodKeyIdx, altIdx) {
      var ruleIdx = this.getLastExplicitRuleShortName();
      var shortName = getKeyForAltIndex(ruleIdx, methodKeyIdx, occurrence, altIdx);
      var nestedName;
      if (methodOpts.NAME !== void 0) {
        nestedName = methodOpts.NAME;
        this.nestedRuleInvocationStateUpdate(nestedName, shortName);
        return {
          shortName,
          nestedName
        };
      } else {
        return void 0;
      }
    };
    TreeBuilder2.prototype.nestedRuleFinallyClause = function(laKey, nestedName) {
      var cstStack = this.CST_STACK;
      var nestedRuleCst = cstStack[cstStack.length - 1];
      this.nestedRuleFinallyStateUpdate();
      var parentCstNode = cstStack[cstStack.length - 1];
      addNoneTerminalToCst(parentCstNode, nestedName, nestedRuleCst);
      this.setNodeLocationFromNode(parentCstNode.location, nestedRuleCst.location);
    };
    TreeBuilder2.prototype.getLastExplicitRuleShortName = function() {
      var lastExplictIndex = this.LAST_EXPLICIT_RULE_STACK[this.LAST_EXPLICIT_RULE_STACK.length - 1];
      return this.RULE_STACK[lastExplictIndex];
    };
    TreeBuilder2.prototype.getLastExplicitRuleShortNameNoCst = function() {
      var ruleStack = this.RULE_STACK;
      return ruleStack[ruleStack.length - 1];
    };
    TreeBuilder2.prototype.getPreviousExplicitRuleShortName = function() {
      var lastExplicitIndex = this.LAST_EXPLICIT_RULE_STACK[this.LAST_EXPLICIT_RULE_STACK.length - 2];
      return this.RULE_STACK[lastExplicitIndex];
    };
    TreeBuilder2.prototype.getPreviousExplicitRuleShortNameNoCst = function() {
      var ruleStack = this.RULE_STACK;
      return ruleStack[ruleStack.length - 2];
    };
    TreeBuilder2.prototype.getLastExplicitRuleOccurrenceIndex = function() {
      var lastExplicitIndex = this.LAST_EXPLICIT_RULE_STACK[this.LAST_EXPLICIT_RULE_STACK.length - 1];
      return this.RULE_OCCURRENCE_STACK[lastExplicitIndex];
    };
    TreeBuilder2.prototype.getLastExplicitRuleOccurrenceIndexNoCst = function() {
      var occurrenceStack = this.RULE_OCCURRENCE_STACK;
      return occurrenceStack[occurrenceStack.length - 1];
    };
    TreeBuilder2.prototype.nestedRuleInvocationStateUpdate = function(nestedRuleName, shortNameKey) {
      this.RULE_OCCURRENCE_STACK.push(1);
      this.RULE_STACK.push(shortNameKey);
      this.cstNestedInvocationStateUpdate(nestedRuleName, shortNameKey);
    };
    TreeBuilder2.prototype.nestedRuleFinallyStateUpdate = function() {
      this.RULE_STACK.pop();
      this.RULE_OCCURRENCE_STACK.pop();
      this.cstNestedFinallyStateUpdate();
    };
    return TreeBuilder2;
  })()
);
var LexerAdapter = (
  /** @class */
  (function() {
    function LexerAdapter2() {
    }
    LexerAdapter2.prototype.initLexerAdapter = function() {
      this.tokVector = [];
      this.tokVectorLength = 0;
      this.currIdx = -1;
    };
    Object.defineProperty(LexerAdapter2.prototype, "input", {
      get: function() {
        return this.tokVector;
      },
      set: function(newInput) {
        if (this.selfAnalysisDone !== true) {
          throw Error("Missing <performSelfAnalysis> invocation at the end of the Parser's constructor.");
        }
        this.reset();
        this.tokVector = newInput;
        this.tokVectorLength = newInput.length;
      },
      enumerable: true,
      configurable: true
    });
    LexerAdapter2.prototype.SKIP_TOKEN = function() {
      if (this.currIdx <= this.tokVector.length - 2) {
        this.consumeToken();
        return this.LA(1);
      } else {
        return END_OF_FILE;
      }
    };
    LexerAdapter2.prototype.LA = function(howMuch) {
      var soughtIdx = this.currIdx + howMuch;
      if (soughtIdx < 0 || this.tokVectorLength <= soughtIdx) {
        return END_OF_FILE;
      } else {
        return this.tokVector[soughtIdx];
      }
    };
    LexerAdapter2.prototype.consumeToken = function() {
      this.currIdx++;
    };
    LexerAdapter2.prototype.exportLexerState = function() {
      return this.currIdx;
    };
    LexerAdapter2.prototype.importLexerState = function(newState) {
      this.currIdx = newState;
    };
    LexerAdapter2.prototype.resetLexerState = function() {
      this.currIdx = -1;
    };
    LexerAdapter2.prototype.moveToTerminatedState = function() {
      this.currIdx = this.tokVector.length - 1;
    };
    LexerAdapter2.prototype.getLexerPosition = function() {
      return this.exportLexerState();
    };
    return LexerAdapter2;
  })()
);
var RecognizerApi = (
  /** @class */
  (function() {
    function RecognizerApi2() {
    }
    RecognizerApi2.prototype.ACTION = function(impl) {
      return impl.call(this);
    };
    RecognizerApi2.prototype.consume = function(idx, tokType, options) {
      return this.consumeInternal(tokType, idx, options);
    };
    RecognizerApi2.prototype.subrule = function(idx, ruleToCall, options) {
      return this.subruleInternal(ruleToCall, idx, options);
    };
    RecognizerApi2.prototype.option = function(idx, actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, idx);
    };
    RecognizerApi2.prototype.or = function(idx, altsOrOpts) {
      return this.orInternal(altsOrOpts, idx);
    };
    RecognizerApi2.prototype.many = function(idx, actionORMethodDef) {
      return this.manyInternal(idx, actionORMethodDef);
    };
    RecognizerApi2.prototype.atLeastOne = function(idx, actionORMethodDef) {
      return this.atLeastOneInternal(idx, actionORMethodDef);
    };
    RecognizerApi2.prototype.CONSUME = function(tokType, options) {
      return this.consumeInternal(tokType, 0, options);
    };
    RecognizerApi2.prototype.CONSUME1 = function(tokType, options) {
      return this.consumeInternal(tokType, 1, options);
    };
    RecognizerApi2.prototype.CONSUME2 = function(tokType, options) {
      return this.consumeInternal(tokType, 2, options);
    };
    RecognizerApi2.prototype.CONSUME3 = function(tokType, options) {
      return this.consumeInternal(tokType, 3, options);
    };
    RecognizerApi2.prototype.CONSUME4 = function(tokType, options) {
      return this.consumeInternal(tokType, 4, options);
    };
    RecognizerApi2.prototype.CONSUME5 = function(tokType, options) {
      return this.consumeInternal(tokType, 5, options);
    };
    RecognizerApi2.prototype.CONSUME6 = function(tokType, options) {
      return this.consumeInternal(tokType, 6, options);
    };
    RecognizerApi2.prototype.CONSUME7 = function(tokType, options) {
      return this.consumeInternal(tokType, 7, options);
    };
    RecognizerApi2.prototype.CONSUME8 = function(tokType, options) {
      return this.consumeInternal(tokType, 8, options);
    };
    RecognizerApi2.prototype.CONSUME9 = function(tokType, options) {
      return this.consumeInternal(tokType, 9, options);
    };
    RecognizerApi2.prototype.SUBRULE = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 0, options);
    };
    RecognizerApi2.prototype.SUBRULE1 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 1, options);
    };
    RecognizerApi2.prototype.SUBRULE2 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 2, options);
    };
    RecognizerApi2.prototype.SUBRULE3 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 3, options);
    };
    RecognizerApi2.prototype.SUBRULE4 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 4, options);
    };
    RecognizerApi2.prototype.SUBRULE5 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 5, options);
    };
    RecognizerApi2.prototype.SUBRULE6 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 6, options);
    };
    RecognizerApi2.prototype.SUBRULE7 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 7, options);
    };
    RecognizerApi2.prototype.SUBRULE8 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 8, options);
    };
    RecognizerApi2.prototype.SUBRULE9 = function(ruleToCall, options) {
      return this.subruleInternal(ruleToCall, 9, options);
    };
    RecognizerApi2.prototype.OPTION = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 0);
    };
    RecognizerApi2.prototype.OPTION1 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 1);
    };
    RecognizerApi2.prototype.OPTION2 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 2);
    };
    RecognizerApi2.prototype.OPTION3 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 3);
    };
    RecognizerApi2.prototype.OPTION4 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 4);
    };
    RecognizerApi2.prototype.OPTION5 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 5);
    };
    RecognizerApi2.prototype.OPTION6 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 6);
    };
    RecognizerApi2.prototype.OPTION7 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 7);
    };
    RecognizerApi2.prototype.OPTION8 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 8);
    };
    RecognizerApi2.prototype.OPTION9 = function(actionORMethodDef) {
      return this.optionInternal(actionORMethodDef, 9);
    };
    RecognizerApi2.prototype.OR = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 0);
    };
    RecognizerApi2.prototype.OR1 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 1);
    };
    RecognizerApi2.prototype.OR2 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 2);
    };
    RecognizerApi2.prototype.OR3 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 3);
    };
    RecognizerApi2.prototype.OR4 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 4);
    };
    RecognizerApi2.prototype.OR5 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 5);
    };
    RecognizerApi2.prototype.OR6 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 6);
    };
    RecognizerApi2.prototype.OR7 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 7);
    };
    RecognizerApi2.prototype.OR8 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 8);
    };
    RecognizerApi2.prototype.OR9 = function(altsOrOpts) {
      return this.orInternal(altsOrOpts, 9);
    };
    RecognizerApi2.prototype.MANY = function(actionORMethodDef) {
      this.manyInternal(0, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY1 = function(actionORMethodDef) {
      this.manyInternal(1, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY2 = function(actionORMethodDef) {
      this.manyInternal(2, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY3 = function(actionORMethodDef) {
      this.manyInternal(3, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY4 = function(actionORMethodDef) {
      this.manyInternal(4, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY5 = function(actionORMethodDef) {
      this.manyInternal(5, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY6 = function(actionORMethodDef) {
      this.manyInternal(6, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY7 = function(actionORMethodDef) {
      this.manyInternal(7, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY8 = function(actionORMethodDef) {
      this.manyInternal(8, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY9 = function(actionORMethodDef) {
      this.manyInternal(9, actionORMethodDef);
    };
    RecognizerApi2.prototype.MANY_SEP = function(options) {
      this.manySepFirstInternal(0, options);
    };
    RecognizerApi2.prototype.MANY_SEP1 = function(options) {
      this.manySepFirstInternal(1, options);
    };
    RecognizerApi2.prototype.MANY_SEP2 = function(options) {
      this.manySepFirstInternal(2, options);
    };
    RecognizerApi2.prototype.MANY_SEP3 = function(options) {
      this.manySepFirstInternal(3, options);
    };
    RecognizerApi2.prototype.MANY_SEP4 = function(options) {
      this.manySepFirstInternal(4, options);
    };
    RecognizerApi2.prototype.MANY_SEP5 = function(options) {
      this.manySepFirstInternal(5, options);
    };
    RecognizerApi2.prototype.MANY_SEP6 = function(options) {
      this.manySepFirstInternal(6, options);
    };
    RecognizerApi2.prototype.MANY_SEP7 = function(options) {
      this.manySepFirstInternal(7, options);
    };
    RecognizerApi2.prototype.MANY_SEP8 = function(options) {
      this.manySepFirstInternal(8, options);
    };
    RecognizerApi2.prototype.MANY_SEP9 = function(options) {
      this.manySepFirstInternal(9, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE = function(actionORMethodDef) {
      this.atLeastOneInternal(0, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE1 = function(actionORMethodDef) {
      return this.atLeastOneInternal(1, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE2 = function(actionORMethodDef) {
      this.atLeastOneInternal(2, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE3 = function(actionORMethodDef) {
      this.atLeastOneInternal(3, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE4 = function(actionORMethodDef) {
      this.atLeastOneInternal(4, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE5 = function(actionORMethodDef) {
      this.atLeastOneInternal(5, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE6 = function(actionORMethodDef) {
      this.atLeastOneInternal(6, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE7 = function(actionORMethodDef) {
      this.atLeastOneInternal(7, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE8 = function(actionORMethodDef) {
      this.atLeastOneInternal(8, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE9 = function(actionORMethodDef) {
      this.atLeastOneInternal(9, actionORMethodDef);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP = function(options) {
      this.atLeastOneSepFirstInternal(0, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP1 = function(options) {
      this.atLeastOneSepFirstInternal(1, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP2 = function(options) {
      this.atLeastOneSepFirstInternal(2, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP3 = function(options) {
      this.atLeastOneSepFirstInternal(3, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP4 = function(options) {
      this.atLeastOneSepFirstInternal(4, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP5 = function(options) {
      this.atLeastOneSepFirstInternal(5, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP6 = function(options) {
      this.atLeastOneSepFirstInternal(6, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP7 = function(options) {
      this.atLeastOneSepFirstInternal(7, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP8 = function(options) {
      this.atLeastOneSepFirstInternal(8, options);
    };
    RecognizerApi2.prototype.AT_LEAST_ONE_SEP9 = function(options) {
      this.atLeastOneSepFirstInternal(9, options);
    };
    RecognizerApi2.prototype.RULE = function(name, implementation, config) {
      if (config === void 0) {
        config = DEFAULT_RULE_CONFIG;
      }
      if (contains(this.definedRulesNames, name)) {
        var errMsg = defaultGrammarValidatorErrorProvider.buildDuplicateRuleNameError({
          topLevelRule: name,
          grammarName: this.className
        });
        var error2 = {
          message: errMsg,
          type: ParserDefinitionErrorType.DUPLICATE_RULE_NAME,
          ruleName: name
        };
        this.definitionErrors.push(error2);
      }
      this.definedRulesNames.push(name);
      var ruleImplementation = this.defineRule(name, implementation, config);
      this[name] = ruleImplementation;
      return ruleImplementation;
    };
    RecognizerApi2.prototype.OVERRIDE_RULE = function(name, impl, config) {
      if (config === void 0) {
        config = DEFAULT_RULE_CONFIG;
      }
      var ruleErrors = [];
      ruleErrors = ruleErrors.concat(validateRuleIsOverridden(name, this.definedRulesNames, this.className));
      this.definitionErrors.push.apply(this.definitionErrors, ruleErrors);
      var ruleImplementation = this.defineRule(name, impl, config);
      this[name] = ruleImplementation;
      return ruleImplementation;
    };
    RecognizerApi2.prototype.BACKTRACK = function(grammarRule, args) {
      return function() {
        this.isBackTrackingStack.push(1);
        var orgState = this.saveRecogState();
        try {
          grammarRule.apply(this, args);
          return true;
        } catch (e) {
          if (isRecognitionException(e)) {
            return false;
          } else {
            throw e;
          }
        } finally {
          this.reloadRecogState(orgState);
          this.isBackTrackingStack.pop();
        }
      };
    };
    RecognizerApi2.prototype.getGAstProductions = function() {
      return this.gastProductionsCache;
    };
    RecognizerApi2.prototype.getSerializedGastProductions = function() {
      return serializeGrammar(values(this.gastProductionsCache));
    };
    return RecognizerApi2;
  })()
);
var RecognizerEngine = (
  /** @class */
  (function() {
    function RecognizerEngine2() {
    }
    RecognizerEngine2.prototype.initRecognizerEngine = function(tokenVocabulary, config) {
      this.className = classNameFromInstance(this);
      this.shortRuleNameToFull = {};
      this.fullRuleNameToShort = {};
      this.ruleShortNameIdx = 256;
      this.tokenMatcher = tokenStructuredMatcherNoCategories;
      this.definedRulesNames = [];
      this.tokensMap = {};
      this.allRuleNames = [];
      this.isBackTrackingStack = [];
      this.RULE_STACK = [];
      this.RULE_OCCURRENCE_STACK = [];
      this.gastProductionsCache = {};
      if (has(config, "serializedGrammar")) {
        throw Error("The Parser's configuration can no longer contain a <serializedGrammar> property.\n	See: https://sap.github.io/chevrotain/docs/changes/BREAKING_CHANGES.html#_6-0-0\n	For Further details.");
      }
      if (isArray(tokenVocabulary)) {
        if (isEmpty(tokenVocabulary)) {
          throw Error("A Token Vocabulary cannot be empty.\n	Note that the first argument for the parser constructor\n	is no longer a Token vector (since v4.0).");
        }
        if (typeof tokenVocabulary[0].startOffset === "number") {
          throw Error("The Parser constructor no longer accepts a token vector as the first argument.\n	See: https://sap.github.io/chevrotain/docs/changes/BREAKING_CHANGES.html#_4-0-0\n	For Further details.");
        }
      }
      if (isArray(tokenVocabulary)) {
        this.tokensMap = reduce(tokenVocabulary, function(acc, tokType) {
          acc[tokType.name] = tokType;
          return acc;
        }, {});
      } else if (has(tokenVocabulary, "modes") && every(flatten(values(tokenVocabulary.modes)), isTokenType)) {
        var allTokenTypes = flatten(values(tokenVocabulary.modes));
        var uniqueTokens = uniq(allTokenTypes);
        this.tokensMap = reduce(uniqueTokens, function(acc, tokType) {
          acc[tokType.name] = tokType;
          return acc;
        }, {});
      } else if (isObject(tokenVocabulary)) {
        this.tokensMap = cloneObj(tokenVocabulary);
      } else {
        throw new Error("<tokensDictionary> argument must be An Array of Token constructors, A dictionary of Token constructors or an IMultiModeLexerDefinition");
      }
      this.tokensMap["EOF"] = EOF;
      var noTokenCategoriesUsed = every(values(tokenVocabulary), function(tokenConstructor) {
        return isEmpty(tokenConstructor.categoryMatches);
      });
      this.tokenMatcher = noTokenCategoriesUsed ? tokenStructuredMatcherNoCategories : tokenStructuredMatcher;
      augmentTokenTypes(values(this.tokensMap));
    };
    RecognizerEngine2.prototype.defineRule = function(ruleName, impl, config) {
      if (this.selfAnalysisDone) {
        throw Error("Grammar rule <" + ruleName + "> may not be defined after the 'performSelfAnalysis' method has been called'\nMake sure that all grammar rule definitions are done before 'performSelfAnalysis' is called.");
      }
      var resyncEnabled = has(config, "resyncEnabled") ? config.resyncEnabled : DEFAULT_RULE_CONFIG.resyncEnabled;
      var recoveryValueFunc = has(config, "recoveryValueFunc") ? config.recoveryValueFunc : DEFAULT_RULE_CONFIG.recoveryValueFunc;
      var shortName = this.ruleShortNameIdx << BITS_FOR_METHOD_TYPE + BITS_FOR_OCCURRENCE_IDX;
      this.ruleShortNameIdx++;
      this.shortRuleNameToFull[shortName] = ruleName;
      this.fullRuleNameToShort[ruleName] = shortName;
      function invokeRuleWithTry(args) {
        try {
          if (this.outputCst === true) {
            impl.apply(this, args);
            var cst = this.CST_STACK[this.CST_STACK.length - 1];
            this.cstPostRule(cst);
            return cst;
          } else {
            return impl.apply(this, args);
          }
        } catch (e) {
          return this.invokeRuleCatch(e, resyncEnabled, recoveryValueFunc);
        } finally {
          this.ruleFinallyStateUpdate();
        }
      }
      var wrappedGrammarRule;
      wrappedGrammarRule = function(idxInCallingRule, args) {
        if (idxInCallingRule === void 0) {
          idxInCallingRule = 0;
        }
        this.ruleInvocationStateUpdate(shortName, ruleName, idxInCallingRule);
        return invokeRuleWithTry.call(this, args);
      };
      var ruleNamePropName = "ruleName";
      wrappedGrammarRule[ruleNamePropName] = ruleName;
      wrappedGrammarRule["originalGrammarAction"] = impl;
      return wrappedGrammarRule;
    };
    RecognizerEngine2.prototype.invokeRuleCatch = function(e, resyncEnabledConfig, recoveryValueFunc) {
      var isFirstInvokedRule = this.RULE_STACK.length === 1;
      var reSyncEnabled = resyncEnabledConfig && !this.isBackTracking() && this.recoveryEnabled;
      if (isRecognitionException(e)) {
        var recogError = e;
        if (reSyncEnabled) {
          var reSyncTokType = this.findReSyncTokenType();
          if (this.isInCurrentRuleReSyncSet(reSyncTokType)) {
            recogError.resyncedTokens = this.reSyncTo(reSyncTokType);
            if (this.outputCst) {
              var partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
              partialCstResult.recoveredNode = true;
              return partialCstResult;
            } else {
              return recoveryValueFunc();
            }
          } else {
            if (this.outputCst) {
              var partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
              partialCstResult.recoveredNode = true;
              recogError.partialCstResult = partialCstResult;
            }
            throw recogError;
          }
        } else if (isFirstInvokedRule) {
          this.moveToTerminatedState();
          return recoveryValueFunc();
        } else {
          throw recogError;
        }
      } else {
        throw e;
      }
    };
    RecognizerEngine2.prototype.optionInternal = function(actionORMethodDef, occurrence) {
      var key = this.getKeyForAutomaticLookahead(OPTION_IDX, occurrence);
      var nestedName = this.nestedRuleBeforeClause(actionORMethodDef, key);
      try {
        return this.optionInternalLogic(actionORMethodDef, occurrence, key);
      } finally {
        if (nestedName !== void 0) {
          this.nestedRuleFinallyClause(key, nestedName);
        }
      }
    };
    RecognizerEngine2.prototype.optionInternalNoCst = function(actionORMethodDef, occurrence) {
      var key = this.getKeyForAutomaticLookahead(OPTION_IDX, occurrence);
      return this.optionInternalLogic(actionORMethodDef, occurrence, key);
    };
    RecognizerEngine2.prototype.optionInternalLogic = function(actionORMethodDef, occurrence, key) {
      var _this = this;
      var lookAheadFunc = this.getLaFuncFromCache(key);
      var action;
      var predicate;
      if (actionORMethodDef.DEF !== void 0) {
        action = actionORMethodDef.DEF;
        predicate = actionORMethodDef.GATE;
        if (predicate !== void 0) {
          var orgLookaheadFunction_1 = lookAheadFunc;
          lookAheadFunc = function() {
            return predicate.call(_this) && orgLookaheadFunction_1.call(_this);
          };
        }
      } else {
        action = actionORMethodDef;
      }
      if (lookAheadFunc.call(this) === true) {
        return action.call(this);
      }
      return void 0;
    };
    RecognizerEngine2.prototype.atLeastOneInternal = function(prodOccurrence, actionORMethodDef) {
      var laKey = this.getKeyForAutomaticLookahead(AT_LEAST_ONE_IDX, prodOccurrence);
      var nestedName = this.nestedRuleBeforeClause(actionORMethodDef, laKey);
      try {
        return this.atLeastOneInternalLogic(prodOccurrence, actionORMethodDef, laKey);
      } finally {
        if (nestedName !== void 0) {
          this.nestedRuleFinallyClause(laKey, nestedName);
        }
      }
    };
    RecognizerEngine2.prototype.atLeastOneInternalNoCst = function(prodOccurrence, actionORMethodDef) {
      var key = this.getKeyForAutomaticLookahead(AT_LEAST_ONE_IDX, prodOccurrence);
      this.atLeastOneInternalLogic(prodOccurrence, actionORMethodDef, key);
    };
    RecognizerEngine2.prototype.atLeastOneInternalLogic = function(prodOccurrence, actionORMethodDef, key) {
      var _this = this;
      var lookAheadFunc = this.getLaFuncFromCache(key);
      var action;
      var predicate;
      if (actionORMethodDef.DEF !== void 0) {
        action = actionORMethodDef.DEF;
        predicate = actionORMethodDef.GATE;
        if (predicate !== void 0) {
          var orgLookaheadFunction_2 = lookAheadFunc;
          lookAheadFunc = function() {
            return predicate.call(_this) && orgLookaheadFunction_2.call(_this);
          };
        }
      } else {
        action = actionORMethodDef;
      }
      if (lookAheadFunc.call(this) === true) {
        var notStuck = this.doSingleRepetition(action);
        while (lookAheadFunc.call(this) === true && notStuck === true) {
          notStuck = this.doSingleRepetition(action);
        }
      } else {
        throw this.raiseEarlyExitException(prodOccurrence, PROD_TYPE.REPETITION_MANDATORY, actionORMethodDef.ERR_MSG);
      }
      this.attemptInRepetitionRecovery(this.atLeastOneInternal, [prodOccurrence, actionORMethodDef], lookAheadFunc, AT_LEAST_ONE_IDX, prodOccurrence, NextTerminalAfterAtLeastOneWalker);
    };
    RecognizerEngine2.prototype.atLeastOneSepFirstInternal = function(prodOccurrence, options) {
      var laKey = this.getKeyForAutomaticLookahead(AT_LEAST_ONE_SEP_IDX, prodOccurrence);
      var nestedName = this.nestedRuleBeforeClause(options, laKey);
      try {
        this.atLeastOneSepFirstInternalLogic(prodOccurrence, options, laKey);
      } finally {
        if (nestedName !== void 0) {
          this.nestedRuleFinallyClause(laKey, nestedName);
        }
      }
    };
    RecognizerEngine2.prototype.atLeastOneSepFirstInternalNoCst = function(prodOccurrence, options) {
      var laKey = this.getKeyForAutomaticLookahead(AT_LEAST_ONE_SEP_IDX, prodOccurrence);
      this.atLeastOneSepFirstInternalLogic(prodOccurrence, options, laKey);
    };
    RecognizerEngine2.prototype.atLeastOneSepFirstInternalLogic = function(prodOccurrence, options, key) {
      var _this = this;
      var action = options.DEF;
      var separator = options.SEP;
      var firstIterationLookaheadFunc = this.getLaFuncFromCache(key);
      if (firstIterationLookaheadFunc.call(this) === true) {
        action.call(this);
        var separatorLookAheadFunc = function() {
          return _this.tokenMatcher(_this.LA(1), separator);
        };
        while (this.tokenMatcher(this.LA(1), separator) === true) {
          this.CONSUME(separator);
          action.call(this);
        }
        this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
          prodOccurrence,
          separator,
          separatorLookAheadFunc,
          action,
          NextTerminalAfterAtLeastOneSepWalker
        ], separatorLookAheadFunc, AT_LEAST_ONE_SEP_IDX, prodOccurrence, NextTerminalAfterAtLeastOneSepWalker);
      } else {
        throw this.raiseEarlyExitException(prodOccurrence, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, options.ERR_MSG);
      }
    };
    RecognizerEngine2.prototype.manyInternal = function(prodOccurrence, actionORMethodDef) {
      var laKey = this.getKeyForAutomaticLookahead(MANY_IDX, prodOccurrence);
      var nestedName = this.nestedRuleBeforeClause(actionORMethodDef, laKey);
      try {
        return this.manyInternalLogic(prodOccurrence, actionORMethodDef, laKey);
      } finally {
        if (nestedName !== void 0) {
          this.nestedRuleFinallyClause(laKey, nestedName);
        }
      }
    };
    RecognizerEngine2.prototype.manyInternalNoCst = function(prodOccurrence, actionORMethodDef) {
      var laKey = this.getKeyForAutomaticLookahead(MANY_IDX, prodOccurrence);
      return this.manyInternalLogic(prodOccurrence, actionORMethodDef, laKey);
    };
    RecognizerEngine2.prototype.manyInternalLogic = function(prodOccurrence, actionORMethodDef, key) {
      var _this = this;
      var lookaheadFunction = this.getLaFuncFromCache(key);
      var action;
      var predicate;
      if (actionORMethodDef.DEF !== void 0) {
        action = actionORMethodDef.DEF;
        predicate = actionORMethodDef.GATE;
        if (predicate !== void 0) {
          var orgLookaheadFunction_3 = lookaheadFunction;
          lookaheadFunction = function() {
            return predicate.call(_this) && orgLookaheadFunction_3.call(_this);
          };
        }
      } else {
        action = actionORMethodDef;
      }
      var notStuck = true;
      while (lookaheadFunction.call(this) === true && notStuck === true) {
        notStuck = this.doSingleRepetition(action);
      }
      this.attemptInRepetitionRecovery(
        this.manyInternal,
        [prodOccurrence, actionORMethodDef],
        lookaheadFunction,
        MANY_IDX,
        prodOccurrence,
        NextTerminalAfterManyWalker,
        // The notStuck parameter is only relevant when "attemptInRepetitionRecovery"
        // is invoked from manyInternal, in the MANY_SEP case and AT_LEAST_ONE[_SEP]
        // An infinite loop cannot occur as:
        // - Either the lookahead is guaranteed to consume something (Single Token Separator)
        // - AT_LEAST_ONE by definition is guaranteed to consume something (or error out).
        notStuck
      );
    };
    RecognizerEngine2.prototype.manySepFirstInternal = function(prodOccurrence, options) {
      var laKey = this.getKeyForAutomaticLookahead(MANY_SEP_IDX, prodOccurrence);
      var nestedName = this.nestedRuleBeforeClause(options, laKey);
      try {
        this.manySepFirstInternalLogic(prodOccurrence, options, laKey);
      } finally {
        if (nestedName !== void 0) {
          this.nestedRuleFinallyClause(laKey, nestedName);
        }
      }
    };
    RecognizerEngine2.prototype.manySepFirstInternalNoCst = function(prodOccurrence, options) {
      var laKey = this.getKeyForAutomaticLookahead(MANY_SEP_IDX, prodOccurrence);
      this.manySepFirstInternalLogic(prodOccurrence, options, laKey);
    };
    RecognizerEngine2.prototype.manySepFirstInternalLogic = function(prodOccurrence, options, key) {
      var _this = this;
      var action = options.DEF;
      var separator = options.SEP;
      var firstIterationLaFunc = this.getLaFuncFromCache(key);
      if (firstIterationLaFunc.call(this) === true) {
        action.call(this);
        var separatorLookAheadFunc = function() {
          return _this.tokenMatcher(_this.LA(1), separator);
        };
        while (this.tokenMatcher(this.LA(1), separator) === true) {
          this.CONSUME(separator);
          action.call(this);
        }
        this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
          prodOccurrence,
          separator,
          separatorLookAheadFunc,
          action,
          NextTerminalAfterManySepWalker
        ], separatorLookAheadFunc, MANY_SEP_IDX, prodOccurrence, NextTerminalAfterManySepWalker);
      }
    };
    RecognizerEngine2.prototype.repetitionSepSecondInternal = function(prodOccurrence, separator, separatorLookAheadFunc, action, nextTerminalAfterWalker) {
      while (separatorLookAheadFunc()) {
        this.CONSUME(separator);
        action.call(this);
      }
      this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
        prodOccurrence,
        separator,
        separatorLookAheadFunc,
        action,
        nextTerminalAfterWalker
      ], separatorLookAheadFunc, AT_LEAST_ONE_SEP_IDX, prodOccurrence, nextTerminalAfterWalker);
    };
    RecognizerEngine2.prototype.doSingleRepetition = function(action) {
      var beforeIteration = this.getLexerPosition();
      action.call(this);
      var afterIteration = this.getLexerPosition();
      return afterIteration > beforeIteration;
    };
    RecognizerEngine2.prototype.orInternalNoCst = function(altsOrOpts, occurrence) {
      var alts = isArray(altsOrOpts) ? altsOrOpts : altsOrOpts.DEF;
      var laKey = this.getKeyForAutomaticLookahead(OR_IDX, occurrence);
      var laFunc = this.getLaFuncFromCache(laKey);
      var altIdxToTake = laFunc.call(this, alts);
      if (altIdxToTake !== void 0) {
        var chosenAlternative = alts[altIdxToTake];
        return chosenAlternative.ALT.call(this);
      }
      this.raiseNoAltException(occurrence, altsOrOpts.ERR_MSG);
    };
    RecognizerEngine2.prototype.orInternal = function(altsOrOpts, occurrence) {
      var laKey = this.getKeyForAutomaticLookahead(OR_IDX, occurrence);
      var nestedName = this.nestedRuleBeforeClause(altsOrOpts, laKey);
      try {
        var alts = isArray(altsOrOpts) ? altsOrOpts : altsOrOpts.DEF;
        var laFunc = this.getLaFuncFromCache(laKey);
        var altIdxToTake = laFunc.call(this, alts);
        if (altIdxToTake !== void 0) {
          var chosenAlternative = alts[altIdxToTake];
          var nestedAltBeforeClauseResult = this.nestedAltBeforeClause(chosenAlternative, occurrence, OR_IDX, altIdxToTake);
          try {
            return chosenAlternative.ALT.call(this);
          } finally {
            if (nestedAltBeforeClauseResult !== void 0) {
              this.nestedRuleFinallyClause(nestedAltBeforeClauseResult.shortName, nestedAltBeforeClauseResult.nestedName);
            }
          }
        }
        this.raiseNoAltException(occurrence, altsOrOpts.ERR_MSG);
      } finally {
        if (nestedName !== void 0) {
          this.nestedRuleFinallyClause(laKey, nestedName);
        }
      }
    };
    RecognizerEngine2.prototype.ruleFinallyStateUpdate = function() {
      this.RULE_STACK.pop();
      this.RULE_OCCURRENCE_STACK.pop();
      this.cstFinallyStateUpdate();
      if (this.RULE_STACK.length === 0 && this.isAtEndOfInput() === false) {
        var firstRedundantTok = this.LA(1);
        var errMsg = this.errorMessageProvider.buildNotAllInputParsedMessage({
          firstRedundant: firstRedundantTok,
          ruleName: this.getCurrRuleFullName()
        });
        this.SAVE_ERROR(new NotAllInputParsedException(errMsg, firstRedundantTok));
      }
    };
    RecognizerEngine2.prototype.subruleInternal = function(ruleToCall, idx, options) {
      var ruleResult;
      try {
        var args = options !== void 0 ? options.ARGS : void 0;
        ruleResult = ruleToCall.call(this, idx, args);
        this.cstPostNonTerminal(ruleResult, options !== void 0 && options.LABEL !== void 0 ? options.LABEL : ruleToCall.ruleName);
        return ruleResult;
      } catch (e) {
        this.subruleInternalError(e, options, ruleToCall.ruleName);
      }
    };
    RecognizerEngine2.prototype.subruleInternalError = function(e, options, ruleName) {
      if (isRecognitionException(e) && e.partialCstResult !== void 0) {
        this.cstPostNonTerminal(e.partialCstResult, options !== void 0 && options.LABEL !== void 0 ? options.LABEL : ruleName);
        delete e.partialCstResult;
      }
      throw e;
    };
    RecognizerEngine2.prototype.consumeInternal = function(tokType, idx, options) {
      var consumedToken;
      try {
        var nextToken = this.LA(1);
        if (this.tokenMatcher(nextToken, tokType) === true) {
          this.consumeToken();
          consumedToken = nextToken;
        } else {
          this.consumeInternalError(tokType, nextToken, options);
        }
      } catch (eFromConsumption) {
        consumedToken = this.consumeInternalRecovery(tokType, idx, eFromConsumption);
      }
      this.cstPostTerminal(options !== void 0 && options.LABEL !== void 0 ? options.LABEL : tokType.name, consumedToken);
      return consumedToken;
    };
    RecognizerEngine2.prototype.consumeInternalError = function(tokType, nextToken, options) {
      var msg;
      var previousToken = this.LA(0);
      if (options !== void 0 && options.ERR_MSG) {
        msg = options.ERR_MSG;
      } else {
        msg = this.errorMessageProvider.buildMismatchTokenMessage({
          expected: tokType,
          actual: nextToken,
          previous: previousToken,
          ruleName: this.getCurrRuleFullName()
        });
      }
      throw this.SAVE_ERROR(new MismatchedTokenException(msg, nextToken, previousToken));
    };
    RecognizerEngine2.prototype.consumeInternalRecovery = function(tokType, idx, eFromConsumption) {
      if (this.recoveryEnabled && // TODO: more robust checking of the exception type. Perhaps Typescript extending expressions?
      eFromConsumption.name === "MismatchedTokenException" && !this.isBackTracking()) {
        var follows = this.getFollowsForInRuleRecovery(tokType, idx);
        try {
          return this.tryInRuleRecovery(tokType, follows);
        } catch (eFromInRuleRecovery) {
          if (eFromInRuleRecovery.name === IN_RULE_RECOVERY_EXCEPTION) {
            throw eFromConsumption;
          } else {
            throw eFromInRuleRecovery;
          }
        }
      } else {
        throw eFromConsumption;
      }
    };
    RecognizerEngine2.prototype.saveRecogState = function() {
      var savedErrors = this.errors;
      var savedRuleStack = cloneArr(this.RULE_STACK);
      return {
        errors: savedErrors,
        lexerState: this.exportLexerState(),
        RULE_STACK: savedRuleStack,
        CST_STACK: this.CST_STACK,
        LAST_EXPLICIT_RULE_STACK: this.LAST_EXPLICIT_RULE_STACK
      };
    };
    RecognizerEngine2.prototype.reloadRecogState = function(newState) {
      this.errors = newState.errors;
      this.importLexerState(newState.lexerState);
      this.RULE_STACK = newState.RULE_STACK;
    };
    RecognizerEngine2.prototype.ruleInvocationStateUpdate = function(shortName, fullName, idxInCallingRule) {
      this.RULE_OCCURRENCE_STACK.push(idxInCallingRule);
      this.RULE_STACK.push(shortName);
      this.cstInvocationStateUpdate(fullName, shortName);
    };
    RecognizerEngine2.prototype.isBackTracking = function() {
      return this.isBackTrackingStack.length !== 0;
    };
    RecognizerEngine2.prototype.getCurrRuleFullName = function() {
      var shortName = this.getLastExplicitRuleShortName();
      return this.shortRuleNameToFull[shortName];
    };
    RecognizerEngine2.prototype.shortRuleNameToFullName = function(shortName) {
      return this.shortRuleNameToFull[shortName];
    };
    RecognizerEngine2.prototype.isAtEndOfInput = function() {
      return this.tokenMatcher(this.LA(1), EOF);
    };
    RecognizerEngine2.prototype.reset = function() {
      this.resetLexerState();
      this.isBackTrackingStack = [];
      this.errors = [];
      this.RULE_STACK = [];
      this.LAST_EXPLICIT_RULE_STACK = [];
      this.CST_STACK = [];
      this.RULE_OCCURRENCE_STACK = [];
    };
    return RecognizerEngine2;
  })()
);
var ErrorHandler = (
  /** @class */
  (function() {
    function ErrorHandler2() {
    }
    ErrorHandler2.prototype.initErrorHandler = function(config) {
      this._errors = [];
      this.errorMessageProvider = defaults(config.errorMessageProvider, DEFAULT_PARSER_CONFIG.errorMessageProvider);
    };
    ErrorHandler2.prototype.SAVE_ERROR = function(error2) {
      if (isRecognitionException(error2)) {
        error2.context = {
          ruleStack: this.getHumanReadableRuleStack(),
          ruleOccurrenceStack: cloneArr(this.RULE_OCCURRENCE_STACK)
        };
        this._errors.push(error2);
        return error2;
      } else {
        throw Error("Trying to save an Error which is not a RecognitionException");
      }
    };
    Object.defineProperty(ErrorHandler2.prototype, "errors", {
      // TODO: extract these methods to ErrorHandler Trait?
      get: function() {
        return cloneArr(this._errors);
      },
      set: function(newErrors) {
        this._errors = newErrors;
      },
      enumerable: true,
      configurable: true
    });
    ErrorHandler2.prototype.raiseEarlyExitException = function(occurrence, prodType, userDefinedErrMsg) {
      var ruleName = this.getCurrRuleFullName();
      var ruleGrammar = this.getGAstProductions()[ruleName];
      var lookAheadPathsPerAlternative = getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, this.maxLookahead);
      var insideProdPaths = lookAheadPathsPerAlternative[0];
      var actualTokens = [];
      for (var i = 1; i <= this.maxLookahead; i++) {
        actualTokens.push(this.LA(i));
      }
      var msg = this.errorMessageProvider.buildEarlyExitMessage({
        expectedIterationPaths: insideProdPaths,
        actual: actualTokens,
        previous: this.LA(0),
        customUserDescription: userDefinedErrMsg,
        ruleName
      });
      throw this.SAVE_ERROR(new EarlyExitException(msg, this.LA(1), this.LA(0)));
    };
    ErrorHandler2.prototype.raiseNoAltException = function(occurrence, errMsgTypes) {
      var ruleName = this.getCurrRuleFullName();
      var ruleGrammar = this.getGAstProductions()[ruleName];
      var lookAheadPathsPerAlternative = getLookaheadPathsForOr(occurrence, ruleGrammar, this.maxLookahead);
      var actualTokens = [];
      for (var i = 1; i <= this.maxLookahead; i++) {
        actualTokens.push(this.LA(i));
      }
      var previousToken = this.LA(0);
      var errMsg = this.errorMessageProvider.buildNoViableAltMessage({
        expectedPathsPerAlt: lookAheadPathsPerAlternative,
        actual: actualTokens,
        previous: previousToken,
        customUserDescription: errMsgTypes,
        ruleName: this.getCurrRuleFullName()
      });
      throw this.SAVE_ERROR(new NoViableAltException(errMsg, this.LA(1), previousToken));
    };
    return ErrorHandler2;
  })()
);
var ContentAssist = (
  /** @class */
  (function() {
    function ContentAssist2() {
    }
    ContentAssist2.prototype.initContentAssist = function() {
    };
    ContentAssist2.prototype.computeContentAssist = function(startRuleName, precedingInput) {
      var startRuleGast = this.gastProductionsCache[startRuleName];
      if (isUndefined(startRuleGast)) {
        throw Error("Rule ->" + startRuleName + "<- does not exist in this grammar.");
      }
      return nextPossibleTokensAfter([startRuleGast], precedingInput, this.tokenMatcher, this.maxLookahead);
    };
    ContentAssist2.prototype.getNextPossibleTokenTypes = function(grammarPath) {
      var topRuleName = first$1(grammarPath.ruleStack);
      var gastProductions = this.getGAstProductions();
      var topProduction = gastProductions[topRuleName];
      var nextPossibleTokenTypes = new NextAfterTokenWalker(topProduction, grammarPath).startWalking();
      return nextPossibleTokenTypes;
    };
    return ContentAssist2;
  })()
);
var RECORDING_NULL_OBJECT = {
  description: "This Object indicates the Parser is during Recording Phase"
};
Object.freeze(RECORDING_NULL_OBJECT);
var HANDLE_SEPARATOR = true;
var MAX_METHOD_IDX = Math.pow(2, BITS_FOR_OCCURRENCE_IDX) - 1;
var RFT = createToken({ name: "RECORDING_PHASE_TOKEN", pattern: Lexer.NA });
augmentTokenTypes([RFT]);
var RECORDING_PHASE_TOKEN = createTokenInstance(
  RFT,
  "This IToken indicates the Parser is in Recording Phase\n	See: https://sap.github.io/chevrotain/docs/guide/internals.html#grammar-recording for details",
  // Using "-1" instead of NaN (as in EOF) because an actual number is less likely to
  // cause errors if the output of LA or CONSUME would be (incorrectly) used during the recording phase.
  -1,
  -1,
  -1,
  -1,
  -1,
  -1
);
Object.freeze(RECORDING_PHASE_TOKEN);
var RECORDING_PHASE_CSTNODE = {
  name: "This CSTNode indicates the Parser is in Recording Phase\n	See: https://sap.github.io/chevrotain/docs/guide/internals.html#grammar-recording for details",
  children: {}
};
var GastRecorder = (
  /** @class */
  (function() {
    function GastRecorder2() {
    }
    GastRecorder2.prototype.initGastRecorder = function(config) {
      this.recordingProdStack = [];
      this.RECORDING_PHASE = false;
    };
    GastRecorder2.prototype.enableRecording = function() {
      var _this = this;
      this.RECORDING_PHASE = true;
      this.TRACE_INIT("Enable Recording", function() {
        var _loop_1 = function(i2) {
          var idx = i2 > 0 ? i2 : "";
          _this["CONSUME" + idx] = function(arg1, arg2) {
            return this.consumeInternalRecord(arg1, i2, arg2);
          };
          _this["SUBRULE" + idx] = function(arg1, arg2) {
            return this.subruleInternalRecord(arg1, i2, arg2);
          };
          _this["OPTION" + idx] = function(arg1) {
            return this.optionInternalRecord(arg1, i2);
          };
          _this["OR" + idx] = function(arg1) {
            return this.orInternalRecord(arg1, i2);
          };
          _this["MANY" + idx] = function(arg1) {
            this.manyInternalRecord(i2, arg1);
          };
          _this["MANY_SEP" + idx] = function(arg1) {
            this.manySepFirstInternalRecord(i2, arg1);
          };
          _this["AT_LEAST_ONE" + idx] = function(arg1) {
            this.atLeastOneInternalRecord(i2, arg1);
          };
          _this["AT_LEAST_ONE_SEP" + idx] = function(arg1) {
            this.atLeastOneSepFirstInternalRecord(i2, arg1);
          };
        };
        for (var i = 0; i < 10; i++) {
          _loop_1(i);
        }
        _this["consume"] = function(idx, arg1, arg2) {
          return this.consumeInternalRecord(arg1, idx, arg2);
        };
        _this["subrule"] = function(idx, arg1, arg2) {
          return this.subruleInternalRecord(arg1, idx, arg2);
        };
        _this["option"] = function(idx, arg1) {
          return this.optionInternalRecord(arg1, idx);
        };
        _this["or"] = function(idx, arg1) {
          return this.orInternalRecord(arg1, idx);
        };
        _this["many"] = function(idx, arg1) {
          this.manyInternalRecord(idx, arg1);
        };
        _this["atLeastOne"] = function(idx, arg1) {
          this.atLeastOneInternalRecord(idx, arg1);
        };
        _this.ACTION = _this.ACTION_RECORD;
        _this.BACKTRACK = _this.BACKTRACK_RECORD;
        _this.LA = _this.LA_RECORD;
      });
    };
    GastRecorder2.prototype.disableRecording = function() {
      var _this = this;
      this.RECORDING_PHASE = false;
      this.TRACE_INIT("Deleting Recording methods", function() {
        for (var i = 0; i < 10; i++) {
          var idx = i > 0 ? i : "";
          delete _this["CONSUME" + idx];
          delete _this["SUBRULE" + idx];
          delete _this["OPTION" + idx];
          delete _this["OR" + idx];
          delete _this["MANY" + idx];
          delete _this["MANY_SEP" + idx];
          delete _this["AT_LEAST_ONE" + idx];
          delete _this["AT_LEAST_ONE_SEP" + idx];
        }
        delete _this["consume"];
        delete _this["subrule"];
        delete _this["option"];
        delete _this["or"];
        delete _this["many"];
        delete _this["atLeastOne"];
        delete _this.ACTION;
        delete _this.BACKTRACK;
        delete _this.LA;
      });
    };
    GastRecorder2.prototype.ACTION_RECORD = function(impl) {
      return;
    };
    GastRecorder2.prototype.BACKTRACK_RECORD = function(grammarRule, args) {
      return function() {
        return true;
      };
    };
    GastRecorder2.prototype.LA_RECORD = function(howMuch) {
      return END_OF_FILE;
    };
    GastRecorder2.prototype.topLevelRuleRecord = function(name, def) {
      try {
        var newTopLevelRule = new Rule({ definition: [], name });
        newTopLevelRule.name = name;
        this.recordingProdStack.push(newTopLevelRule);
        def.call(this);
        this.recordingProdStack.pop();
        return newTopLevelRule;
      } catch (originalError) {
        if (originalError.KNOWN_RECORDER_ERROR !== true) {
          try {
            originalError.message = originalError.message + '\n	 This error was thrown during the "grammar recording phase" For more info see:\n	https://sap.github.io/chevrotain/docs/guide/internals.html#grammar-recording';
          } catch (mutabilityError) {
            throw originalError;
          }
        }
        throw originalError;
      }
    };
    GastRecorder2.prototype.optionInternalRecord = function(actionORMethodDef, occurrence) {
      return recordProd.call(this, Option$1, actionORMethodDef, occurrence);
    };
    GastRecorder2.prototype.atLeastOneInternalRecord = function(occurrence, actionORMethodDef) {
      recordProd.call(this, RepetitionMandatory, actionORMethodDef, occurrence);
    };
    GastRecorder2.prototype.atLeastOneSepFirstInternalRecord = function(occurrence, options) {
      recordProd.call(this, RepetitionMandatoryWithSeparator, options, occurrence, HANDLE_SEPARATOR);
    };
    GastRecorder2.prototype.manyInternalRecord = function(occurrence, actionORMethodDef) {
      recordProd.call(this, Repetition, actionORMethodDef, occurrence);
    };
    GastRecorder2.prototype.manySepFirstInternalRecord = function(occurrence, options) {
      recordProd.call(this, RepetitionWithSeparator, options, occurrence, HANDLE_SEPARATOR);
    };
    GastRecorder2.prototype.orInternalRecord = function(altsOrOpts, occurrence) {
      return recordOrProd.call(this, altsOrOpts, occurrence);
    };
    GastRecorder2.prototype.subruleInternalRecord = function(ruleToCall, occurrence, options) {
      assertMethodIdxIsValid(occurrence);
      if (!ruleToCall || has(ruleToCall, "ruleName") === false) {
        var error2 = new Error("<SUBRULE" + getIdxSuffix(occurrence) + "> argument is invalid" + (" expecting a Parser method reference but got: <" + JSON.stringify(ruleToCall) + ">") + ("\n inside top level rule: <" + this.recordingProdStack[0].name + ">"));
        error2.KNOWN_RECORDER_ERROR = true;
        throw error2;
      }
      var prevProd = peek(this.recordingProdStack);
      var ruleName = ruleToCall["ruleName"];
      var newNoneTerminal = new NonTerminal({
        idx: occurrence,
        nonTerminalName: ruleName,
        // The resolving of the `referencedRule` property will be done once all the Rule's GASTs have been created
        referencedRule: void 0
      });
      prevProd.definition.push(newNoneTerminal);
      return this.outputCst ? RECORDING_PHASE_CSTNODE : RECORDING_NULL_OBJECT;
    };
    GastRecorder2.prototype.consumeInternalRecord = function(tokType, occurrence, options) {
      assertMethodIdxIsValid(occurrence);
      if (!hasShortKeyProperty(tokType)) {
        var error2 = new Error("<CONSUME" + getIdxSuffix(occurrence) + "> argument is invalid" + (" expecting a TokenType reference but got: <" + JSON.stringify(tokType) + ">") + ("\n inside top level rule: <" + this.recordingProdStack[0].name + ">"));
        error2.KNOWN_RECORDER_ERROR = true;
        throw error2;
      }
      var prevProd = peek(this.recordingProdStack);
      var newNoneTerminal = new Terminal({
        idx: occurrence,
        terminalType: tokType
      });
      prevProd.definition.push(newNoneTerminal);
      return RECORDING_PHASE_TOKEN;
    };
    return GastRecorder2;
  })()
);
function recordProd(prodConstructor, mainProdArg, occurrence, handleSep) {
  if (handleSep === void 0) {
    handleSep = false;
  }
  assertMethodIdxIsValid(occurrence);
  var prevProd = peek(this.recordingProdStack);
  var grammarAction = isFunction(mainProdArg) ? mainProdArg : mainProdArg.DEF;
  var newProd = new prodConstructor({ definition: [], idx: occurrence });
  if (has(mainProdArg, "NAME")) {
    newProd.name = mainProdArg.NAME;
  }
  if (handleSep) {
    newProd.separator = mainProdArg.SEP;
  }
  if (has(mainProdArg, "MAX_LOOKAHEAD")) {
    newProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
  }
  this.recordingProdStack.push(newProd);
  grammarAction.call(this);
  prevProd.definition.push(newProd);
  this.recordingProdStack.pop();
  return RECORDING_NULL_OBJECT;
}
function recordOrProd(mainProdArg, occurrence) {
  var _this = this;
  assertMethodIdxIsValid(occurrence);
  var prevProd = peek(this.recordingProdStack);
  var hasOptions = isArray(mainProdArg) === false;
  var alts = hasOptions === false ? mainProdArg : mainProdArg.DEF;
  var newOrProd = new Alternation({
    definition: [],
    idx: occurrence,
    ignoreAmbiguities: hasOptions && mainProdArg.IGNORE_AMBIGUITIES === true
  });
  if (has(mainProdArg, "NAME")) {
    newOrProd.name = mainProdArg.NAME;
  }
  if (has(mainProdArg, "MAX_LOOKAHEAD")) {
    newOrProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
  }
  var hasPredicates = some(alts, function(currAlt) {
    return isFunction(currAlt.GATE);
  });
  newOrProd.hasPredicates = hasPredicates;
  prevProd.definition.push(newOrProd);
  forEach(alts, function(currAlt) {
    var currAltFlat = new Flat({ definition: [] });
    newOrProd.definition.push(currAltFlat);
    if (has(currAlt, "NAME")) {
      currAltFlat.name = currAlt.NAME;
    }
    if (has(currAlt, "IGNORE_AMBIGUITIES")) {
      currAltFlat.ignoreAmbiguities = currAlt.IGNORE_AMBIGUITIES;
    } else if (has(currAlt, "GATE")) {
      currAltFlat.ignoreAmbiguities = true;
    }
    _this.recordingProdStack.push(currAltFlat);
    currAlt.ALT.call(_this);
    _this.recordingProdStack.pop();
  });
  return RECORDING_NULL_OBJECT;
}
function getIdxSuffix(idx) {
  return idx === 0 ? "" : "" + idx;
}
function assertMethodIdxIsValid(idx) {
  if (idx < 0 || idx > MAX_METHOD_IDX) {
    var error2 = new Error(
      // The stack trace will contain all the needed details
      "Invalid DSL Method idx value: <" + idx + ">\n	" + ("Idx value must be a none negative value smaller than " + (MAX_METHOD_IDX + 1))
    );
    error2.KNOWN_RECORDER_ERROR = true;
    throw error2;
  }
}
var PerformanceTracer = (
  /** @class */
  (function() {
    function PerformanceTracer2() {
    }
    PerformanceTracer2.prototype.initPerformanceTracer = function(config) {
      if (has(config, "traceInitPerf")) {
        var userTraceInitPerf = config.traceInitPerf;
        var traceIsNumber = typeof userTraceInitPerf === "number";
        this.traceInitMaxIdent = traceIsNumber ? userTraceInitPerf : Infinity;
        this.traceInitPerf = traceIsNumber ? userTraceInitPerf > 0 : userTraceInitPerf;
      } else {
        this.traceInitMaxIdent = 0;
        this.traceInitPerf = DEFAULT_PARSER_CONFIG.traceInitPerf;
      }
      this.traceInitIndent = -1;
    };
    PerformanceTracer2.prototype.TRACE_INIT = function(phaseDesc, phaseImpl) {
      if (this.traceInitPerf === true) {
        this.traceInitIndent++;
        var indent = new Array(this.traceInitIndent + 1).join("	");
        if (this.traceInitIndent < this.traceInitMaxIdent) {
          console.log(indent + "--> <" + phaseDesc + ">");
        }
        var _a = timer(phaseImpl), time = _a.time, value = _a.value;
        var traceMethod = time > 10 ? console.warn : console.log;
        if (this.traceInitIndent < this.traceInitMaxIdent) {
          traceMethod(indent + "<-- <" + phaseDesc + "> time: " + time + "ms");
        }
        this.traceInitIndent--;
        return value;
      } else {
        return phaseImpl();
      }
    };
    return PerformanceTracer2;
  })()
);
var __extends = /* @__PURE__ */ (function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var END_OF_FILE = createTokenInstance(EOF, "", NaN, NaN, NaN, NaN, NaN, NaN);
Object.freeze(END_OF_FILE);
var DEFAULT_PARSER_CONFIG = Object.freeze({
  recoveryEnabled: false,
  maxLookahead: 4,
  ignoredIssues: {},
  dynamicTokensEnabled: false,
  outputCst: true,
  errorMessageProvider: defaultParserErrorProvider,
  nodeLocationTracking: "none",
  traceInitPerf: false,
  skipValidations: false
});
var DEFAULT_RULE_CONFIG = Object.freeze({
  recoveryValueFunc: function() {
    return void 0;
  },
  resyncEnabled: true
});
var ParserDefinitionErrorType;
(function(ParserDefinitionErrorType2) {
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_RULE_NAME"] = 0] = "INVALID_RULE_NAME";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["DUPLICATE_RULE_NAME"] = 1] = "DUPLICATE_RULE_NAME";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_RULE_OVERRIDE"] = 2] = "INVALID_RULE_OVERRIDE";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["DUPLICATE_PRODUCTIONS"] = 3] = "DUPLICATE_PRODUCTIONS";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["UNRESOLVED_SUBRULE_REF"] = 4] = "UNRESOLVED_SUBRULE_REF";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["LEFT_RECURSION"] = 5] = "LEFT_RECURSION";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["NONE_LAST_EMPTY_ALT"] = 6] = "NONE_LAST_EMPTY_ALT";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["AMBIGUOUS_ALTS"] = 7] = "AMBIGUOUS_ALTS";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["CONFLICT_TOKENS_RULES_NAMESPACE"] = 8] = "CONFLICT_TOKENS_RULES_NAMESPACE";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_TOKEN_NAME"] = 9] = "INVALID_TOKEN_NAME";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_NESTED_RULE_NAME"] = 10] = "INVALID_NESTED_RULE_NAME";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["DUPLICATE_NESTED_NAME"] = 11] = "DUPLICATE_NESTED_NAME";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["NO_NON_EMPTY_LOOKAHEAD"] = 12] = "NO_NON_EMPTY_LOOKAHEAD";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["AMBIGUOUS_PREFIX_ALTS"] = 13] = "AMBIGUOUS_PREFIX_ALTS";
  ParserDefinitionErrorType2[ParserDefinitionErrorType2["TOO_MANY_ALTS"] = 14] = "TOO_MANY_ALTS";
})(ParserDefinitionErrorType || (ParserDefinitionErrorType = {}));
function EMPTY_ALT(value) {
  if (value === void 0) {
    value = void 0;
  }
  return function() {
    return value;
  };
}
var Parser = (
  /** @class */
  (function() {
    function Parser2(tokenVocabulary, config) {
      if (config === void 0) {
        config = DEFAULT_PARSER_CONFIG;
      }
      this.ignoredIssues = DEFAULT_PARSER_CONFIG.ignoredIssues;
      this.definitionErrors = [];
      this.selfAnalysisDone = false;
      var that = this;
      that.initErrorHandler(config);
      that.initLexerAdapter();
      that.initLooksAhead(config);
      that.initRecognizerEngine(tokenVocabulary, config);
      that.initRecoverable(config);
      that.initTreeBuilder(config);
      that.initContentAssist();
      that.initGastRecorder(config);
      that.initPerformanceTracer(config);
      if (has(config, "ignoredIssues") && config.ignoredIssues !== DEFAULT_PARSER_CONFIG.ignoredIssues) {
        PRINT_WARNING("The <ignoredIssues> IParserConfig property is soft-deprecated and will be removed in future versions.\n	Please use the <IGNORE_AMBIGUITIES> flag on the relevant DSL method instead.");
      }
      this.ignoredIssues = has(config, "ignoredIssues") ? config.ignoredIssues : DEFAULT_PARSER_CONFIG.ignoredIssues;
      this.skipValidations = has(config, "skipValidations") ? config.skipValidations : DEFAULT_PARSER_CONFIG.skipValidations;
    }
    Parser2.performSelfAnalysis = function(parserInstance) {
      parserInstance.performSelfAnalysis();
    };
    Parser2.prototype.performSelfAnalysis = function() {
      var _this = this;
      this.TRACE_INIT("performSelfAnalysis", function() {
        var defErrorsMsgs;
        _this.selfAnalysisDone = true;
        var className = _this.className;
        _this.TRACE_INIT("toFastProps", function() {
          toFastProperties(_this);
        });
        _this.TRACE_INIT("Grammar Recording", function() {
          try {
            _this.enableRecording();
            forEach(_this.definedRulesNames, function(currRuleName) {
              var wrappedRule = _this[currRuleName];
              var originalGrammarAction = wrappedRule["originalGrammarAction"];
              var recordedRuleGast = void 0;
              _this.TRACE_INIT(currRuleName + " Rule", function() {
                recordedRuleGast = _this.topLevelRuleRecord(currRuleName, originalGrammarAction);
              });
              _this.gastProductionsCache[currRuleName] = recordedRuleGast;
            });
          } finally {
            _this.disableRecording();
          }
        });
        var resolverErrors = [];
        _this.TRACE_INIT("Grammar Resolving", function() {
          resolverErrors = resolveGrammar({
            rules: values(_this.gastProductionsCache)
          });
          _this.definitionErrors.push.apply(_this.definitionErrors, resolverErrors);
        });
        _this.TRACE_INIT("Grammar Validations", function() {
          if (isEmpty(resolverErrors) && _this.skipValidations === false) {
            var validationErrors = validateGrammar({
              rules: values(_this.gastProductionsCache),
              maxLookahead: _this.maxLookahead,
              tokenTypes: values(_this.tokensMap),
              ignoredIssues: _this.ignoredIssues,
              errMsgProvider: defaultGrammarValidatorErrorProvider,
              grammarName: className
            });
            _this.definitionErrors.push.apply(_this.definitionErrors, validationErrors);
          }
        });
        if (isEmpty(_this.definitionErrors)) {
          if (_this.recoveryEnabled) {
            _this.TRACE_INIT("computeAllProdsFollows", function() {
              var allFollows = computeAllProdsFollows(values(_this.gastProductionsCache));
              _this.resyncFollows = allFollows;
            });
          }
          _this.TRACE_INIT("ComputeLookaheadFunctions", function() {
            _this.preComputeLookaheadFunctions(values(_this.gastProductionsCache));
          });
        }
        _this.TRACE_INIT("expandAllNestedRuleNames", function() {
          var cstAnalysisResult = expandAllNestedRuleNames(values(_this.gastProductionsCache), _this.fullRuleNameToShort);
          _this.allRuleNames = cstAnalysisResult.allRuleNames;
        });
        if (!Parser2.DEFER_DEFINITION_ERRORS_HANDLING && !isEmpty(_this.definitionErrors)) {
          defErrorsMsgs = map(_this.definitionErrors, function(defError) {
            return defError.message;
          });
          throw new Error("Parser Definition Errors detected:\n " + defErrorsMsgs.join("\n-------------------------------\n"));
        }
      });
    };
    Parser2.DEFER_DEFINITION_ERRORS_HANDLING = false;
    return Parser2;
  })()
);
applyMixins(Parser, [
  Recoverable,
  LooksAhead,
  TreeBuilder,
  LexerAdapter,
  RecognizerEngine,
  RecognizerApi,
  ErrorHandler,
  ContentAssist,
  GastRecorder,
  PerformanceTracer
]);
(function(_super) {
  __extends(CstParser, _super);
  function CstParser(tokenVocabulary, config) {
    if (config === void 0) {
      config = DEFAULT_PARSER_CONFIG;
    }
    var _this = this;
    var configClone = cloneObj(config);
    configClone.outputCst = true;
    _this = _super.call(this, tokenVocabulary, configClone) || this;
    return _this;
  }
  return CstParser;
})(Parser);
var EmbeddedActionsParser = (
  /** @class */
  (function(_super) {
    __extends(EmbeddedActionsParser2, _super);
    function EmbeddedActionsParser2(tokenVocabulary, config) {
      if (config === void 0) {
        config = DEFAULT_PARSER_CONFIG;
      }
      var _this = this;
      var configClone = cloneObj(config);
      configClone.outputCst = false;
      _this = _super.call(this, tokenVocabulary, configClone) || this;
      return _this;
    }
    return EmbeddedActionsParser2;
  })(Parser)
);
const parsingError = (type, message) => ({
  type,
  message
});
var ParsingErrorType;
(function(ParsingErrorType2) {
  ParsingErrorType2["LexingError"] = "LexingError";
  ParsingErrorType2["ParserError"] = "ParsingError";
  ParsingErrorType2["StaticOffsetError"] = "StaticOffsetError";
  ParsingErrorType2["StaticOffsetOutOfRangeError"] = "StaticOffsetOutOfRangeError";
  ParsingErrorType2["RangeOffsetNotAllowed"] = "RangeOffsetNotAllowed";
  ParsingErrorType2["InvalidRangeSize"] = "InvalidRangeSize";
})(ParsingErrorType || (ParsingErrorType = {}));
var AstNodeType;
(function(AstNodeType2) {
  AstNodeType2["EMPTY"] = "EMPTY";
  AstNodeType2["NUMBER"] = "NUMBER";
  AstNodeType2["STRING"] = "STRING";
  AstNodeType2["MINUS_UNARY_OP"] = "MINUS_UNARY_OP";
  AstNodeType2["PLUS_UNARY_OP"] = "PLUS_UNARY_OP";
  AstNodeType2["PERCENT_OP"] = "PERCENT_OP";
  AstNodeType2["CONCATENATE_OP"] = "CONCATENATE_OP";
  AstNodeType2["EQUALS_OP"] = "EQUALS_OP";
  AstNodeType2["NOT_EQUAL_OP"] = "NOT_EQUAL_OP";
  AstNodeType2["GREATER_THAN_OP"] = "GREATER_THAN_OP";
  AstNodeType2["LESS_THAN_OP"] = "LESS_THAN_OP";
  AstNodeType2["GREATER_THAN_OR_EQUAL_OP"] = "GREATER_THAN_OR_EQUAL_OP";
  AstNodeType2["LESS_THAN_OR_EQUAL_OP"] = "LESS_THAN_OR_EQUAL_OP";
  AstNodeType2["PLUS_OP"] = "PLUS_OP";
  AstNodeType2["MINUS_OP"] = "MINUS_OP";
  AstNodeType2["TIMES_OP"] = "TIMES_OP";
  AstNodeType2["DIV_OP"] = "DIV_OP";
  AstNodeType2["POWER_OP"] = "POWER_OP";
  AstNodeType2["FUNCTION_CALL"] = "FUNCTION_CALL";
  AstNodeType2["NAMED_EXPRESSION"] = "NAMED_EXPRESSION";
  AstNodeType2["PARENTHESIS"] = "PARENTHESES";
  AstNodeType2["CELL_REFERENCE"] = "CELL_REFERENCE";
  AstNodeType2["CELL_RANGE"] = "CELL_RANGE";
  AstNodeType2["COLUMN_RANGE"] = "COLUMN_RANGE";
  AstNodeType2["ROW_RANGE"] = "ROW_RANGE";
  AstNodeType2["ERROR"] = "ERROR";
  AstNodeType2["ERROR_WITH_RAW_INPUT"] = "ERROR_WITH_RAW_INPUT";
  AstNodeType2["ARRAY"] = "ARRAY";
})(AstNodeType || (AstNodeType = {}));
var RangeSheetReferenceType;
(function(RangeSheetReferenceType2) {
  RangeSheetReferenceType2[RangeSheetReferenceType2["RELATIVE"] = 0] = "RELATIVE";
  RangeSheetReferenceType2[RangeSheetReferenceType2["START_ABSOLUTE"] = 1] = "START_ABSOLUTE";
  RangeSheetReferenceType2[RangeSheetReferenceType2["BOTH_ABSOLUTE"] = 2] = "BOTH_ABSOLUTE";
})(RangeSheetReferenceType || (RangeSheetReferenceType = {}));
const buildEmptyArgAst = (leadingWhitespace) => ({
  type: AstNodeType.EMPTY,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildNumberAst = (value, leadingWhitespace) => ({
  type: AstNodeType.NUMBER,
  value,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildStringAst = (token) => {
  var _a;
  return {
    type: AstNodeType.STRING,
    value: token.image.slice(1, -1),
    leadingWhitespace: (_a = token.leadingWhitespace) === null || _a === void 0 ? void 0 : _a.image
  };
};
const buildCellReferenceAst = (reference, leadingWhitespace) => ({
  type: AstNodeType.CELL_REFERENCE,
  reference,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildCellRangeAst = (start, end, sheetReferenceType, leadingWhitespace) => {
  assertRangeConsistency(start, end, sheetReferenceType);
  return {
    type: AstNodeType.CELL_RANGE,
    start,
    end,
    sheetReferenceType,
    leadingWhitespace
  };
};
const buildColumnRangeAst = (start, end, sheetReferenceType, leadingWhitespace) => {
  assertRangeConsistency(start, end, sheetReferenceType);
  return {
    type: AstNodeType.COLUMN_RANGE,
    start,
    end,
    sheetReferenceType,
    leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
  };
};
const buildRowRangeAst = (start, end, sheetReferenceType, leadingWhitespace) => {
  assertRangeConsistency(start, end, sheetReferenceType);
  return {
    type: AstNodeType.ROW_RANGE,
    start,
    end,
    sheetReferenceType,
    leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
  };
};
const buildConcatenateOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.CONCATENATE_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildEqualsOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.EQUALS_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildNotEqualOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.NOT_EQUAL_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildGreaterThanOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.GREATER_THAN_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildLessThanOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.LESS_THAN_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildGreaterThanOrEqualOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.GREATER_THAN_OR_EQUAL_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildLessThanOrEqualOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.LESS_THAN_OR_EQUAL_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildPlusOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.PLUS_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildMinusOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.MINUS_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildTimesOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.TIMES_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildDivOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.DIV_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildPowerOpAst = (left2, right2, leadingWhitespace) => ({
  type: AstNodeType.POWER_OP,
  left: left2,
  right: right2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildMinusUnaryOpAst = (value, leadingWhitespace) => ({
  type: AstNodeType.MINUS_UNARY_OP,
  value,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildPlusUnaryOpAst = (value, leadingWhitespace) => ({
  type: AstNodeType.PLUS_UNARY_OP,
  value,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildPercentOpAst = (value, leadingWhitespace) => ({
  type: AstNodeType.PERCENT_OP,
  value,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildProcedureAst = (procedureName, args, leadingWhitespace, internalWhitespace, hyperlink) => ({
  type: AstNodeType.FUNCTION_CALL,
  procedureName,
  args,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image,
  internalWhitespace: internalWhitespace === null || internalWhitespace === void 0 ? void 0 : internalWhitespace.image,
  hyperlink
});
const buildArrayAst = (args, leadingWhitespace, internalWhitespace) => ({
  type: AstNodeType.ARRAY,
  args,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image,
  internalWhitespace: internalWhitespace === null || internalWhitespace === void 0 ? void 0 : internalWhitespace.image
});
const buildNamedExpressionAst = (expressionName, leadingWhitespace) => ({
  type: AstNodeType.NAMED_EXPRESSION,
  expressionName,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildParenthesisAst = (expression, leadingWhitespace, internalWhitespace) => ({
  type: AstNodeType.PARENTHESIS,
  expression,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image,
  internalWhitespace: internalWhitespace === null || internalWhitespace === void 0 ? void 0 : internalWhitespace.image
});
const buildCellErrorAst = (error2, leadingWhitespace) => ({
  type: AstNodeType.ERROR,
  error: error2,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildErrorWithRawInputAst = (rawInput, error2, leadingWhitespace) => ({
  type: AstNodeType.ERROR_WITH_RAW_INPUT,
  error: error2,
  rawInput,
  leadingWhitespace: leadingWhitespace === null || leadingWhitespace === void 0 ? void 0 : leadingWhitespace.image
});
const buildParsingErrorAst = () => ({
  type: AstNodeType.ERROR,
  error: CellError.parsingError()
});
function assertRangeConsistency(start, end, sheetReferenceType) {
  if (start.sheet !== void 0 && end.sheet === void 0 || start.sheet === void 0 && end.sheet !== void 0) {
    throw new Error("Start address inconsistent with end address");
  }
  if (start.sheet === void 0 && sheetReferenceType !== RangeSheetReferenceType.RELATIVE || start.sheet !== void 0 && sheetReferenceType === RangeSheetReferenceType.RELATIVE) {
    throw new Error("Sheet address inconsistent with sheet reference type");
  }
}
function imageWithWhitespace(image, leadingWhitespace) {
  return (leadingWhitespace !== null && leadingWhitespace !== void 0 ? leadingWhitespace : "") + image;
}
const binaryOpTokenMap = {
  [AstNodeType.PLUS_OP]: "+",
  [AstNodeType.MINUS_OP]: "-",
  [AstNodeType.TIMES_OP]: "*",
  [AstNodeType.DIV_OP]: "/",
  [AstNodeType.CONCATENATE_OP]: "&",
  [AstNodeType.POWER_OP]: "^",
  [AstNodeType.EQUALS_OP]: "=",
  [AstNodeType.NOT_EQUAL_OP]: "<>",
  [AstNodeType.GREATER_THAN_OP]: ">",
  [AstNodeType.GREATER_THAN_OR_EQUAL_OP]: ">=",
  [AstNodeType.LESS_THAN_OP]: "<",
  [AstNodeType.LESS_THAN_OR_EQUAL_OP]: "<="
};
const buildCacheEntry = (ast, relativeDependencies, hasVolatileFunction, hasStructuralChangeFunction) => ({
  ast,
  relativeDependencies,
  hasVolatileFunction,
  hasStructuralChangeFunction
});
class Cache {
  constructor(functionRegistry) {
    this.functionRegistry = functionRegistry;
    this.cache = /* @__PURE__ */ new Map();
  }
  set(hash, ast) {
    const astRelativeDependencies = collectDependencies(ast, this.functionRegistry);
    const cacheEntry = buildCacheEntry(ast, astRelativeDependencies, doesContainFunctions(ast, this.functionRegistry.isFunctionVolatile), doesContainFunctions(ast, this.functionRegistry.isFunctionDependentOnSheetStructureChange));
    this.cache.set(hash, cacheEntry);
    return cacheEntry;
  }
  get(hash) {
    return this.cache.get(hash);
  }
  maybeSetAndThenGet(hash, ast) {
    const entryFromCache = this.cache.get(hash);
    if (entryFromCache !== void 0) {
      return entryFromCache.ast;
    } else {
      this.set(hash, ast);
      return ast;
    }
  }
}
const doesContainFunctions = (ast, functionCriterion) => {
  switch (ast.type) {
    case AstNodeType.EMPTY:
    case AstNodeType.NUMBER:
    case AstNodeType.STRING:
    case AstNodeType.ERROR:
    case AstNodeType.ERROR_WITH_RAW_INPUT:
    case AstNodeType.CELL_REFERENCE:
    case AstNodeType.CELL_RANGE:
    case AstNodeType.COLUMN_RANGE:
    case AstNodeType.ROW_RANGE:
    case AstNodeType.NAMED_EXPRESSION:
      return false;
    case AstNodeType.PERCENT_OP:
    case AstNodeType.PLUS_UNARY_OP:
    case AstNodeType.MINUS_UNARY_OP: {
      return doesContainFunctions(ast.value, functionCriterion);
    }
    case AstNodeType.CONCATENATE_OP:
    case AstNodeType.EQUALS_OP:
    case AstNodeType.NOT_EQUAL_OP:
    case AstNodeType.LESS_THAN_OP:
    case AstNodeType.GREATER_THAN_OP:
    case AstNodeType.LESS_THAN_OR_EQUAL_OP:
    case AstNodeType.GREATER_THAN_OR_EQUAL_OP:
    case AstNodeType.MINUS_OP:
    case AstNodeType.PLUS_OP:
    case AstNodeType.TIMES_OP:
    case AstNodeType.DIV_OP:
    case AstNodeType.POWER_OP:
      return doesContainFunctions(ast.left, functionCriterion) || doesContainFunctions(ast.right, functionCriterion);
    case AstNodeType.PARENTHESIS:
      return doesContainFunctions(ast.expression, functionCriterion);
    case AstNodeType.FUNCTION_CALL: {
      if (functionCriterion(ast.procedureName)) {
        return true;
      }
      return ast.args.some((arg) => doesContainFunctions(arg, functionCriterion));
    }
    case AstNodeType.ARRAY: {
      return ast.args.some((row) => row.some((arg) => doesContainFunctions(arg, functionCriterion)));
    }
  }
};
class ErrorMessage {
}
ErrorMessage.DistinctSigns = "Distinct signs.";
ErrorMessage.WrongArgNumber = "Wrong number of arguments.";
ErrorMessage.EmptyArg = "Empty function argument.";
ErrorMessage.EmptyArray = "Empty array not allowed.";
ErrorMessage.ArrayDimensions = "Array dimensions are not compatible.";
ErrorMessage.NoSpaceForArrayResult = "No space for array result.";
ErrorMessage.ValueSmall = "Value too small.";
ErrorMessage.ValueLarge = "Value too large.";
ErrorMessage.BadCriterion = "Incorrect criterion.";
ErrorMessage.RangeManySheets = "Range spans more than one sheet.";
ErrorMessage.CellRangeExpected = "Cell range expected.";
ErrorMessage.WrongDimension = "Wrong range dimension.";
ErrorMessage.ScalarExpected = "Cell range not allowed.";
ErrorMessage.NumberCoercion = "Value cannot be coerced to number.";
ErrorMessage.NumberExpected = "Number argument expected.";
ErrorMessage.IntegerExpected = "Value needs to be an integer.";
ErrorMessage.BadMode = "Mode not recognized.";
ErrorMessage.DateBounds = "Date outside of bounds.";
ErrorMessage.OutOfSheet = "Resulting reference is out of the sheet.";
ErrorMessage.WrongType = "Wrong type of argument.";
ErrorMessage.NaN = "NaN or infinite value encountered.";
ErrorMessage.EqualLength = "Ranges need to be of equal length.";
ErrorMessage.Negative = "Value cannot be negative.";
ErrorMessage.NotBinary = "String does not represent a binary number.";
ErrorMessage.NotOctal = "String does not represent an octal number.";
ErrorMessage.NotHex = "String does not represent a hexadecimal number.";
ErrorMessage.EndStartPeriod = "End period needs to be at least start period.";
ErrorMessage.CellRefExpected = "Cell reference expected.";
ErrorMessage.EmptyRange = "Empty range not allowed.";
ErrorMessage.BadRef = "Address is not correct.";
ErrorMessage.NumberRange = "Number-only range expected.";
ErrorMessage.ValueNotFound = "Value not found.";
ErrorMessage.ValueBaseLarge = "Value in base too large.";
ErrorMessage.ValueBaseSmall = "Value in base too small.";
ErrorMessage.ValueBaseLong = "Value in base too long.";
ErrorMessage.NegativeLength = "Length cannot be negative.";
ErrorMessage.PatternNotFound = "Pattern not found.";
ErrorMessage.OneValue = "Needs at least one value.";
ErrorMessage.TwoValues = "Range needs to contain at least two elements.";
ErrorMessage.ThreeValues = "Range needs to contain at least three elements.";
ErrorMessage.IndexBounds = "Index out of bounds.";
ErrorMessage.IndexLarge = "Index too large.";
ErrorMessage.Formula = "Expected formula.";
ErrorMessage.NegativeCount = "Count cannot be negative.";
ErrorMessage.ParseError = "Parsing error.";
ErrorMessage.SheetRef = "Sheet does not exist.";
ErrorMessage.PeriodLong = "Period number cannot exceed life length.";
ErrorMessage.InvalidDate = "Invalid date.";
ErrorMessage.BitshiftLong = "Result of bitshift is too long.";
ErrorMessage.EmptyString = "Empty-string argument not allowed.";
ErrorMessage.LengthBounds = "Length out of bounds.";
ErrorMessage.NegativeTime = "Time cannot be negative.";
ErrorMessage.NoDefault = "No default option.";
ErrorMessage.NoConditionMet = "None of the conditions were met.";
ErrorMessage.Selector = "Selector cannot exceed the number of arguments.";
ErrorMessage.StartEndDate = "Start date needs to be earlier than end date.";
ErrorMessage.IncorrectDateTime = "String does not represent correct DateTime.";
ErrorMessage.CharacterCodeBounds = "Character code out of bounds.";
ErrorMessage.NonZero = "Argument cannot be 0.";
ErrorMessage.LessThanOne = "Argument cannot be less than 1.";
ErrorMessage.WeekendString = "Incorrect weekend bitmask string.";
ErrorMessage.InvalidRoman = "Invalid roman numeral.";
ErrorMessage.WrongOrder = "Wrong order of values.";
ErrorMessage.ComplexNumberExpected = "Complex number expected.";
ErrorMessage.ShouldBeIorJ = "Should be 'i' or 'j'.";
ErrorMessage.SizeMismatch = "Array dimensions mismatched.";
ErrorMessage.ResultTooLong = "Result exceeds the maximum allowed length.";
ErrorMessage.FunctionName = (arg) => `Function name ${arg} not recognized.`;
ErrorMessage.NamedExpressionName = (arg) => `Named expression ${arg} not recognized.`;
ErrorMessage.LicenseKey = (arg) => `License key is ${arg}.`;
class CellReferenceMatcher {
  constructor() {
    this.POSSIBLE_START_CHARACTERS = [...ALL_UNICODE_LETTERS_ARRAY, ...ALL_DIGITS_ARRAY, ABSOLUTE_OPERATOR, "'", "_"];
    this.cellReferenceRegexp = new RegExp(CELL_REFERENCE_WITH_NEXT_CHARACTER_PATTERN, "y");
  }
  /**
   * Method used by the lexer to recognize CellReference token in text
   *
   * Note: using 'y' sticky flag for a named expression which is not supported on IE11...
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky
   */
  match(text, startOffset) {
    this.cellReferenceRegexp.lastIndex = startOffset;
    const execResult = this.cellReferenceRegexp.exec(text + "@");
    if (execResult == null || execResult[1] == null) {
      return null;
    }
    execResult[0] = execResult[1];
    return execResult;
  }
}
class NamedExpressionMatcher {
  constructor() {
    this.POSSIBLE_START_CHARACTERS = [...ALL_UNICODE_LETTERS_ARRAY, "_"];
    this.namedExpressionRegexp = new RegExp(NAMED_EXPRESSION_PATTERN, "y");
    this.r1c1CellRefRegexp = new RegExp(`^${R1C1_CELL_REFERENCE_PATTERN}$`);
  }
  /**
   * Method used by the lexer to recognize NamedExpression token in text
   *
   * Note: using 'y' sticky flag for a named expression which is not supported on IE11...
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky
   */
  match(text, startOffset) {
    this.namedExpressionRegexp.lastIndex = startOffset;
    const execResult = this.namedExpressionRegexp.exec(text);
    if (execResult == null || execResult[0] == null) {
      return null;
    }
    if (this.r1c1CellRefRegexp.test(execResult[0])) {
      return null;
    }
    return execResult;
  }
}
const AdditionOp = createToken({
  name: "AdditionOp",
  pattern: Lexer.NA
});
const PlusOp = createToken({
  name: "PlusOp",
  pattern: /\+/,
  categories: AdditionOp
});
const MinusOp = createToken({
  name: "MinusOp",
  pattern: /-/,
  categories: AdditionOp
});
const MultiplicationOp = createToken({
  name: "MultiplicationOp",
  pattern: Lexer.NA
});
const TimesOp = createToken({
  name: "TimesOp",
  pattern: /\*/,
  categories: MultiplicationOp
});
const DivOp = createToken({
  name: "DivOp",
  pattern: /\//,
  categories: MultiplicationOp
});
const PowerOp = createToken({
  name: "PowerOp",
  pattern: /\^/
});
const PercentOp = createToken({
  name: "PercentOp",
  pattern: /%/
});
const BooleanOp = createToken({
  name: "BooleanOp",
  pattern: Lexer.NA
});
const EqualsOp = createToken({
  name: "EqualsOp",
  pattern: /=/,
  categories: BooleanOp
});
const NotEqualOp = createToken({
  name: "NotEqualOp",
  pattern: /<>/,
  categories: BooleanOp
});
const GreaterThanOp = createToken({
  name: "GreaterThanOp",
  pattern: />/,
  categories: BooleanOp
});
const LessThanOp = createToken({
  name: "LessThanOp",
  pattern: /</,
  categories: BooleanOp
});
const GreaterThanOrEqualOp = createToken({
  name: "GreaterThanOrEqualOp",
  pattern: />=/,
  categories: BooleanOp
});
const LessThanOrEqualOp = createToken({
  name: "LessThanOrEqualOp",
  pattern: /<=/,
  categories: BooleanOp
});
const ConcatenateOp = createToken({
  name: "ConcatenateOp",
  pattern: /&/
});
const LParen = createToken({
  name: "LParen",
  pattern: /\(/
});
const RParen = createToken({
  name: "RParen",
  pattern: /\)/
});
const ArrayLParen = createToken({
  name: "ArrayLParen",
  pattern: /{/
});
const ArrayRParen = createToken({
  name: "ArrayRParen",
  pattern: /}/
});
const StringLiteral = createToken({
  name: "StringLiteral",
  pattern: /"([^"\\]*(\\.[^"\\]*)*)"/
});
const ErrorLiteral = createToken({
  name: "ErrorLiteral",
  pattern: /#[A-Za-z0-9\/]+[?!]?/
});
const RangeSeparator = createToken({
  name: "RangeSeparator",
  pattern: new RegExp(RANGE_OPERATOR)
});
const ColumnRange = createToken({
  name: "ColumnRange",
  pattern: new RegExp(`${COLUMN_REFERENCE_PATTERN}${RANGE_OPERATOR}${COLUMN_REFERENCE_PATTERN}`)
});
const RowRange = createToken({
  name: "RowRange",
  pattern: new RegExp(`${ROW_REFERENCE_PATTERN}${RANGE_OPERATOR}${ROW_REFERENCE_PATTERN}`)
});
const ProcedureName = createToken({
  name: "ProcedureName",
  pattern: new RegExp(`([${UNICODE_LETTER_PATTERN}][${NON_RESERVED_CHARACTER_PATTERN}]*)\\(`)
});
const cellReferenceMatcher = new CellReferenceMatcher();
const CellReference = createToken({
  name: "CellReference",
  pattern: cellReferenceMatcher.match.bind(cellReferenceMatcher),
  start_chars_hint: cellReferenceMatcher.POSSIBLE_START_CHARACTERS,
  line_breaks: false
});
const namedExpressionMatcher = new NamedExpressionMatcher();
const NamedExpression = createToken({
  name: "NamedExpression",
  pattern: namedExpressionMatcher.match.bind(namedExpressionMatcher),
  start_chars_hint: namedExpressionMatcher.POSSIBLE_START_CHARACTERS,
  line_breaks: false
});
const buildLexerConfig = (config) => {
  const offsetProcedureNameLiteral = config.translationPackage.getFunctionTranslation("OFFSET");
  const errorMapping = config.errorMapping;
  const functionMapping = config.translationPackage.buildFunctionMapping();
  const whitespaceTokenRegexp = new RegExp(config.ignoreWhiteSpace === "standard" ? ODFF_WHITESPACE_PATTERN : ALL_WHITESPACE_PATTERN);
  const WhiteSpace = createToken({
    name: "WhiteSpace",
    pattern: whitespaceTokenRegexp
  });
  const ArrayRowSeparator = createToken({
    name: "ArrayRowSep",
    pattern: config.arrayRowSeparator
  });
  const ArrayColSeparator = createToken({
    name: "ArrayColSep",
    pattern: config.arrayColumnSeparator
  });
  const NumberLiteral = createToken({
    name: "NumberLiteral",
    pattern: new RegExp(`(([${config.decimalSeparator}]\\d+)|(\\d+([${config.decimalSeparator}]\\d*)?))(e[+-]?\\d+)?`)
  });
  const OffsetProcedureName = createToken({
    name: "OffsetProcedureName",
    pattern: new RegExp(offsetProcedureNameLiteral, "i")
  });
  let ArgSeparator;
  let inject;
  if (config.functionArgSeparator === config.arrayColumnSeparator) {
    ArgSeparator = ArrayColSeparator;
    inject = [];
  } else if (config.functionArgSeparator === config.arrayRowSeparator) {
    ArgSeparator = ArrayRowSeparator;
    inject = [];
  } else {
    ArgSeparator = createToken({
      name: "ArgSeparator",
      pattern: config.functionArgSeparator
    });
    inject = [ArgSeparator];
  }
  const allTokens = [WhiteSpace, PlusOp, MinusOp, TimesOp, DivOp, PowerOp, EqualsOp, NotEqualOp, PercentOp, GreaterThanOrEqualOp, LessThanOrEqualOp, GreaterThanOp, LessThanOp, LParen, RParen, ArrayLParen, ArrayRParen, OffsetProcedureName, ProcedureName, RangeSeparator, ...inject, ColumnRange, RowRange, NumberLiteral, StringLiteral, ErrorLiteral, ConcatenateOp, BooleanOp, AdditionOp, MultiplicationOp, CellReference, NamedExpression, ArrayRowSeparator, ArrayColSeparator];
  return {
    ArgSeparator,
    NumberLiteral,
    OffsetProcedureName,
    ArrayRowSeparator,
    ArrayColSeparator,
    WhiteSpace,
    allTokens,
    errorMapping,
    functionMapping,
    decimalSeparator: config.decimalSeparator,
    maxColumns: config.maxColumns,
    maxRows: config.maxRows
  };
};
class FormulaParser extends EmbeddedActionsParser {
  constructor(lexerConfig, resolveSheetReference) {
    super(lexerConfig.allTokens, {
      outputCst: false,
      maxLookahead: 7
    });
    this.resolveSheetReference = resolveSheetReference;
    this.booleanExpressionOrEmpty = this.RULE("booleanExpressionOrEmpty", () => {
      return this.OR([{
        ALT: () => this.SUBRULE(this.booleanExpression)
      }, {
        ALT: EMPTY_ALT(buildEmptyArgAst())
      }]);
    });
    this.procedureExpression = this.RULE("procedureExpression", () => {
      var _a;
      const procedureNameToken = this.CONSUME(ProcedureName);
      const procedureName = procedureNameToken.image.toUpperCase().slice(0, -1);
      const canonicalProcedureName = (_a = this.lexerConfig.functionMapping[procedureName]) !== null && _a !== void 0 ? _a : procedureName;
      const args = [];
      let argument = this.SUBRULE(this.booleanExpressionOrEmpty);
      this.MANY(() => {
        var _a2;
        const separator = this.CONSUME(this.lexerConfig.ArgSeparator);
        if (argument.type === AstNodeType.EMPTY) {
          argument.leadingWhitespace = (_a2 = separator.leadingWhitespace) === null || _a2 === void 0 ? void 0 : _a2.image;
        }
        args.push(argument);
        argument = this.SUBRULE2(this.booleanExpressionOrEmpty);
      });
      args.push(argument);
      if (args.length === 1 && args[0].type === AstNodeType.EMPTY) {
        args.length = 0;
      }
      const rParenToken = this.CONSUME(RParen);
      return buildProcedureAst(canonicalProcedureName, args, procedureNameToken.leadingWhitespace, rParenToken.leadingWhitespace);
    });
    this.namedExpressionExpression = this.RULE("namedExpressionExpression", () => {
      const name = this.CONSUME(NamedExpression);
      return buildNamedExpressionAst(name.image, name.leadingWhitespace);
    });
    this.offsetProcedureExpression = this.RULE("offsetProcedureExpression", () => {
      const args = [];
      this.CONSUME(this.lexerConfig.OffsetProcedureName);
      this.CONSUME(LParen);
      this.MANY_SEP({
        SEP: this.lexerConfig.ArgSeparator,
        DEF: () => {
          args.push(this.SUBRULE(this.booleanExpression));
        }
      });
      this.CONSUME(RParen);
      return this.handleOffsetHeuristic(args);
    });
    this.columnRangeExpression = this.RULE("columnRangeExpression", () => {
      const range = this.CONSUME(ColumnRange);
      const [startImage, endImage] = range.image.split(":");
      const firstAddress = this.ACTION(() => columnAddressFromString(startImage, this.formulaAddress, this.resolveSheetReference));
      const secondAddress = this.ACTION(() => columnAddressFromString(endImage, this.formulaAddress, this.resolveSheetReference));
      if (firstAddress === void 0 || secondAddress === void 0) {
        return buildCellErrorAst(new CellError(ErrorType.REF));
      }
      if (firstAddress.exceedsSheetSizeLimits(this.lexerConfig.maxColumns) || secondAddress.exceedsSheetSizeLimits(this.lexerConfig.maxColumns)) {
        return buildErrorWithRawInputAst(range.image, new CellError(ErrorType.NAME), range.leadingWhitespace);
      }
      if (firstAddress.sheet === void 0 && secondAddress.sheet !== void 0) {
        return this.parsingError(ParsingErrorType.ParserError, "Malformed range expression");
      }
      const {
        firstEnd,
        secondEnd,
        sheetRefType
      } = FormulaParser.fixSheetIdsForRangeEnds(firstAddress, secondAddress);
      return buildColumnRangeAst(firstEnd, secondEnd, sheetRefType, range.leadingWhitespace);
    });
    this.rowRangeExpression = this.RULE("rowRangeExpression", () => {
      const range = this.CONSUME(RowRange);
      const [startImage, endImage] = range.image.split(":");
      const firstAddress = this.ACTION(() => rowAddressFromString(startImage, this.formulaAddress, this.resolveSheetReference));
      const secondAddress = this.ACTION(() => rowAddressFromString(endImage, this.formulaAddress, this.resolveSheetReference));
      if (firstAddress === void 0 || secondAddress === void 0) {
        return buildCellErrorAst(new CellError(ErrorType.REF));
      }
      if (firstAddress.exceedsSheetSizeLimits(this.lexerConfig.maxRows) || secondAddress.exceedsSheetSizeLimits(this.lexerConfig.maxRows)) {
        return buildErrorWithRawInputAst(range.image, new CellError(ErrorType.NAME), range.leadingWhitespace);
      }
      if (firstAddress.sheet === void 0 && secondAddress.sheet !== void 0) {
        return this.parsingError(ParsingErrorType.ParserError, "Malformed range expression");
      }
      const {
        firstEnd,
        secondEnd,
        sheetRefType
      } = FormulaParser.fixSheetIdsForRangeEnds(firstAddress, secondAddress);
      return buildRowRangeAst(firstEnd, secondEnd, sheetRefType, range.leadingWhitespace);
    });
    this.cellReference = this.RULE("cellReference", () => {
      const cell = this.CONSUME(CellReference);
      const address = this.ACTION(() => {
        return cellAddressFromString(cell.image, this.formulaAddress, this.resolveSheetReference);
      });
      if (address === void 0) {
        return buildErrorWithRawInputAst(cell.image, new CellError(ErrorType.REF), cell.leadingWhitespace);
      } else if (address.exceedsSheetSizeLimits(this.lexerConfig.maxColumns, this.lexerConfig.maxRows)) {
        return buildErrorWithRawInputAst(cell.image, new CellError(ErrorType.NAME), cell.leadingWhitespace);
      } else {
        return buildCellReferenceAst(address, cell.leadingWhitespace);
      }
    });
    this.endRangeReference = this.RULE("endRangeReference", (start) => {
      var _a;
      const end = this.CONSUME(CellReference);
      const startAddress = this.ACTION(() => {
        return cellAddressFromString(start.image, this.formulaAddress, this.resolveSheetReference);
      });
      const endAddress = this.ACTION(() => {
        return cellAddressFromString(end.image, this.formulaAddress, this.resolveSheetReference);
      });
      if (startAddress === void 0 || endAddress === void 0) {
        return this.ACTION(() => {
          return buildErrorWithRawInputAst(`${start.image}:${end.image}`, new CellError(ErrorType.REF), start.leadingWhitespace);
        });
      } else if (startAddress.exceedsSheetSizeLimits(this.lexerConfig.maxColumns, this.lexerConfig.maxRows) || endAddress.exceedsSheetSizeLimits(this.lexerConfig.maxColumns, this.lexerConfig.maxRows)) {
        return this.ACTION(() => {
          return buildErrorWithRawInputAst(`${start.image}:${end.image}`, new CellError(ErrorType.NAME), start.leadingWhitespace);
        });
      }
      return this.buildCellRange(startAddress, endAddress, (_a = start.leadingWhitespace) === null || _a === void 0 ? void 0 : _a.image);
    });
    this.endOfRangeExpression = this.RULE("endOfRangeExpression", (start) => {
      return this.OR([{
        ALT: () => {
          return this.SUBRULE(this.endRangeReference, {
            ARGS: [start]
          });
        }
      }, {
        ALT: () => {
          var _a;
          const offsetProcedure = this.SUBRULE(this.offsetProcedureExpression);
          const startAddress = this.ACTION(() => {
            return cellAddressFromString(start.image, this.formulaAddress, this.resolveSheetReference);
          });
          if (startAddress === void 0) {
            return buildCellErrorAst(new CellError(ErrorType.REF));
          }
          if (offsetProcedure.type === AstNodeType.CELL_REFERENCE) {
            return this.buildCellRange(startAddress, offsetProcedure.reference, (_a = start.leadingWhitespace) === null || _a === void 0 ? void 0 : _a.image);
          } else {
            return this.parsingError(ParsingErrorType.RangeOffsetNotAllowed, "Range offset not allowed here");
          }
        }
      }]);
    });
    this.cellRangeExpression = this.RULE("cellRangeExpression", () => {
      const start = this.CONSUME(CellReference);
      this.CONSUME2(RangeSeparator);
      return this.SUBRULE(this.endOfRangeExpression, {
        ARGS: [start]
      });
    });
    this.endRangeWithOffsetStartReference = this.RULE("endRangeWithOffsetStartReference", (start) => {
      const end = this.CONSUME(CellReference);
      const endAddress = this.ACTION(() => {
        return cellAddressFromString(end.image, this.formulaAddress, this.resolveSheetReference);
      });
      if (endAddress === void 0) {
        return this.ACTION(() => {
          return buildCellErrorAst(new CellError(ErrorType.REF));
        });
      }
      return this.buildCellRange(start.reference, endAddress, start.leadingWhitespace);
    });
    this.endOfRangeWithOffsetStartExpression = this.RULE("endOfRangeWithOffsetStartExpression", (start) => {
      return this.OR([{
        ALT: () => {
          return this.SUBRULE(this.endRangeWithOffsetStartReference, {
            ARGS: [start]
          });
        }
      }, {
        ALT: () => {
          const offsetProcedure = this.SUBRULE(this.offsetProcedureExpression);
          if (offsetProcedure.type === AstNodeType.CELL_REFERENCE) {
            return this.buildCellRange(start.reference, offsetProcedure.reference, start.leadingWhitespace);
          } else {
            return this.parsingError(ParsingErrorType.RangeOffsetNotAllowed, "Range offset not allowed here");
          }
        }
      }]);
    });
    this.offsetExpression = this.RULE("offsetExpression", () => {
      const offsetProcedure = this.SUBRULE(this.offsetProcedureExpression);
      let end;
      this.OPTION(() => {
        this.CONSUME(RangeSeparator);
        if (offsetProcedure.type === AstNodeType.CELL_RANGE) {
          end = this.parsingError(ParsingErrorType.RangeOffsetNotAllowed, "Range offset not allowed here");
        } else {
          end = this.SUBRULE(this.endOfRangeWithOffsetStartExpression, {
            ARGS: [offsetProcedure]
          });
        }
      });
      if (end !== void 0) {
        return end;
      }
      return offsetProcedure;
    });
    this.insideArrayExpression = this.RULE("insideArrayExpression", () => {
      const ret = [[]];
      ret[ret.length - 1].push(this.SUBRULE(this.booleanExpression));
      this.MANY(() => {
        this.OR([{
          ALT: () => {
            this.CONSUME(this.lexerConfig.ArrayColSeparator);
            ret[ret.length - 1].push(this.SUBRULE2(this.booleanExpression));
          }
        }, {
          ALT: () => {
            this.CONSUME(this.lexerConfig.ArrayRowSeparator);
            ret.push([]);
            ret[ret.length - 1].push(this.SUBRULE3(this.booleanExpression));
          }
        }]);
      });
      return buildArrayAst(ret);
    });
    this.parenthesisExpression = this.RULE("parenthesisExpression", () => {
      const lParenToken = this.CONSUME(LParen);
      const expression = this.SUBRULE(this.booleanExpression);
      const rParenToken = this.CONSUME(RParen);
      return buildParenthesisAst(expression, lParenToken.leadingWhitespace, rParenToken.leadingWhitespace);
    });
    this.arrayExpression = this.RULE("arrayExpression", () => {
      return this.OR([{
        ALT: () => {
          const ltoken = this.CONSUME(ArrayLParen);
          const ret = this.SUBRULE(this.insideArrayExpression);
          const rtoken = this.CONSUME(ArrayRParen);
          return buildArrayAst(ret.args, ltoken.leadingWhitespace, rtoken.leadingWhitespace);
        }
      }, {
        ALT: () => this.SUBRULE(this.parenthesisExpression)
      }]);
    });
    this.numericStringToNumber = (input) => {
      const normalized = input.replace(this.lexerConfig.decimalSeparator, ".");
      return Number(normalized);
    };
    this.positiveAtomicExpression = this.RULE("positiveAtomicExpression", () => {
      var _a;
      return this.OR((_a = this.atomicExpCache) !== null && _a !== void 0 ? _a : this.atomicExpCache = [{
        ALT: () => this.SUBRULE(this.arrayExpression)
      }, {
        ALT: () => this.SUBRULE(this.cellRangeExpression)
      }, {
        ALT: () => this.SUBRULE(this.columnRangeExpression)
      }, {
        ALT: () => this.SUBRULE(this.rowRangeExpression)
      }, {
        ALT: () => this.SUBRULE(this.offsetExpression)
      }, {
        ALT: () => this.SUBRULE(this.cellReference)
      }, {
        ALT: () => this.SUBRULE(this.procedureExpression)
      }, {
        ALT: () => this.SUBRULE(this.namedExpressionExpression)
      }, {
        ALT: () => {
          const number = this.CONSUME(this.lexerConfig.NumberLiteral);
          return buildNumberAst(this.numericStringToNumber(number.image), number.leadingWhitespace);
        }
      }, {
        ALT: () => {
          const str = this.CONSUME(StringLiteral);
          return buildStringAst(str);
        }
      }, {
        ALT: () => {
          const token = this.CONSUME(ErrorLiteral);
          const errString = token.image.toUpperCase();
          const errorType = this.lexerConfig.errorMapping[errString];
          if (errorType) {
            return buildCellErrorAst(new CellError(errorType), token.leadingWhitespace);
          } else {
            return this.parsingError(ParsingErrorType.ParserError, "Unknown error literal");
          }
        }
      }]);
    });
    this.rightUnaryOpAtomicExpression = this.RULE("rightUnaryOpAtomicExpression", () => {
      const positiveAtomicExpression = this.SUBRULE(this.positiveAtomicExpression);
      const percentage = this.OPTION(() => {
        return this.CONSUME(PercentOp);
      });
      if (percentage) {
        return buildPercentOpAst(positiveAtomicExpression, percentage.leadingWhitespace);
      }
      return positiveAtomicExpression;
    });
    this.atomicExpression = this.RULE("atomicExpression", () => {
      return this.OR([{
        ALT: () => {
          const op = this.CONSUME(AdditionOp);
          const value = this.SUBRULE(this.atomicExpression);
          if (tokenMatcher(op, PlusOp)) {
            return buildPlusUnaryOpAst(value, op.leadingWhitespace);
          } else if (tokenMatcher(op, MinusOp)) {
            return buildMinusUnaryOpAst(value, op.leadingWhitespace);
          } else {
            this.customParsingError = parsingError(ParsingErrorType.ParserError, "Mismatched token type");
            return this.customParsingError;
          }
        }
      }, {
        ALT: () => this.SUBRULE2(this.rightUnaryOpAtomicExpression)
      }]);
    });
    this.powerExpression = this.RULE("powerExpression", () => {
      let lhs = this.SUBRULE(this.atomicExpression);
      this.MANY(() => {
        const op = this.CONSUME(PowerOp);
        const rhs = this.SUBRULE2(this.atomicExpression);
        if (tokenMatcher(op, PowerOp)) {
          lhs = buildPowerOpAst(lhs, rhs, op.leadingWhitespace);
        } else {
          this.ACTION(() => {
            throw Error("Operator not supported");
          });
        }
      });
      return lhs;
    });
    this.multiplicationExpression = this.RULE("multiplicationExpression", () => {
      let lhs = this.SUBRULE(this.powerExpression);
      this.MANY(() => {
        const op = this.CONSUME(MultiplicationOp);
        const rhs = this.SUBRULE2(this.powerExpression);
        if (tokenMatcher(op, TimesOp)) {
          lhs = buildTimesOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, DivOp)) {
          lhs = buildDivOpAst(lhs, rhs, op.leadingWhitespace);
        } else {
          this.ACTION(() => {
            throw Error("Operator not supported");
          });
        }
      });
      return lhs;
    });
    this.additionExpression = this.RULE("additionExpression", () => {
      let lhs = this.SUBRULE(this.multiplicationExpression);
      this.MANY(() => {
        const op = this.CONSUME(AdditionOp);
        const rhs = this.SUBRULE2(this.multiplicationExpression);
        if (tokenMatcher(op, PlusOp)) {
          lhs = buildPlusOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, MinusOp)) {
          lhs = buildMinusOpAst(lhs, rhs, op.leadingWhitespace);
        } else {
          this.ACTION(() => {
            throw Error("Operator not supported");
          });
        }
      });
      return lhs;
    });
    this.concatenateExpression = this.RULE("concatenateExpression", () => {
      let lhs = this.SUBRULE(this.additionExpression);
      this.MANY(() => {
        const op = this.CONSUME(ConcatenateOp);
        const rhs = this.SUBRULE2(this.additionExpression);
        lhs = buildConcatenateOpAst(lhs, rhs, op.leadingWhitespace);
      });
      return lhs;
    });
    this.booleanExpression = this.RULE("booleanExpression", () => {
      let lhs = this.SUBRULE(this.concatenateExpression);
      this.MANY(() => {
        const op = this.CONSUME(BooleanOp);
        const rhs = this.SUBRULE2(this.concatenateExpression);
        if (tokenMatcher(op, EqualsOp)) {
          lhs = buildEqualsOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, NotEqualOp)) {
          lhs = buildNotEqualOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, GreaterThanOp)) {
          lhs = buildGreaterThanOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, LessThanOp)) {
          lhs = buildLessThanOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, GreaterThanOrEqualOp)) {
          lhs = buildGreaterThanOrEqualOpAst(lhs, rhs, op.leadingWhitespace);
        } else if (tokenMatcher(op, LessThanOrEqualOp)) {
          lhs = buildLessThanOrEqualOpAst(lhs, rhs, op.leadingWhitespace);
        } else {
          this.ACTION(() => {
            throw Error("Operator not supported");
          });
        }
      });
      return lhs;
    });
    this.formula = this.RULE("formula", () => {
      this.CONSUME(EqualsOp);
      return this.SUBRULE(this.booleanExpression);
    });
    this.lexerConfig = lexerConfig;
    this.formulaAddress = simpleCellAddress(0, 0, 0);
    this.performSelfAnalysis();
  }
  /**
   * Parses tokenized formula and builds abstract syntax tree
   *
   * @param {ExtendedToken[]} tokens - tokenized formula
   * @param {SimpleCellAddress} formulaAddress - address of the cell in which formula is located
   */
  parseFromTokens(tokens, formulaAddress) {
    this.input = tokens;
    let ast = this.formulaWithContext(formulaAddress);
    let errors = [];
    if (this.customParsingError) {
      errors.push(this.customParsingError);
    }
    errors = errors.concat(this.errors.map((e) => ({
      type: ParsingErrorType.ParserError,
      message: e.message
    })));
    if (errors.length > 0) {
      ast = buildParsingErrorAst();
    }
    return {
      ast,
      errors
    };
  }
  reset() {
    super.reset();
    this.customParsingError = void 0;
  }
  /**
   * Entry rule wrapper that sets formula address
   *
   * @param {SimpleCellAddress} address - address of the cell in which formula is located
   */
  formulaWithContext(address) {
    this.formulaAddress = address;
    return this.formula();
  }
  buildCellRange(firstAddress, secondAddress, leadingWhitespace) {
    if (firstAddress.sheet === void 0 && secondAddress.sheet !== void 0) {
      return this.parsingError(ParsingErrorType.ParserError, "Malformed range expression");
    }
    const {
      firstEnd,
      secondEnd,
      sheetRefType
    } = FormulaParser.fixSheetIdsForRangeEnds(firstAddress, secondAddress);
    return buildCellRangeAst(firstEnd, secondEnd, sheetRefType, leadingWhitespace);
  }
  static fixSheetIdsForRangeEnds(firstEnd, secondEnd) {
    const sheetRefType = FormulaParser.rangeSheetReferenceType(firstEnd.sheet, secondEnd.sheet);
    const secondEndFixed = firstEnd.sheet !== void 0 && secondEnd.sheet === void 0 ? secondEnd.withSheet(firstEnd.sheet) : secondEnd;
    return {
      firstEnd,
      secondEnd: secondEndFixed,
      sheetRefType
    };
  }
  /**
   * Returns {@link CellReferenceAst} or {@link CellRangeAst} based on OFFSET function arguments
   *
   * @param {Ast[]} args - OFFSET function arguments
   */
  handleOffsetHeuristic(args) {
    var _a;
    const cellArg = args[0];
    if (cellArg.type !== AstNodeType.CELL_REFERENCE) {
      return this.parsingError(ParsingErrorType.StaticOffsetError, "First argument to OFFSET is not a reference");
    }
    const rowsArg = args[1];
    let rowShift;
    if (rowsArg.type === AstNodeType.NUMBER && Number.isInteger(rowsArg.value)) {
      rowShift = rowsArg.value;
    } else if (rowsArg.type === AstNodeType.PLUS_UNARY_OP && rowsArg.value.type === AstNodeType.NUMBER && Number.isInteger(rowsArg.value.value)) {
      rowShift = rowsArg.value.value;
    } else if (rowsArg.type === AstNodeType.MINUS_UNARY_OP && rowsArg.value.type === AstNodeType.NUMBER && Number.isInteger(rowsArg.value.value)) {
      rowShift = -rowsArg.value.value;
    } else {
      return this.parsingError(ParsingErrorType.StaticOffsetError, "Second argument to OFFSET is not a static number");
    }
    const columnsArg = args[2];
    let colShift;
    if (columnsArg.type === AstNodeType.NUMBER && Number.isInteger(columnsArg.value)) {
      colShift = columnsArg.value;
    } else if (columnsArg.type === AstNodeType.PLUS_UNARY_OP && columnsArg.value.type === AstNodeType.NUMBER && Number.isInteger(columnsArg.value.value)) {
      colShift = columnsArg.value.value;
    } else if (columnsArg.type === AstNodeType.MINUS_UNARY_OP && columnsArg.value.type === AstNodeType.NUMBER && Number.isInteger(columnsArg.value.value)) {
      colShift = -columnsArg.value.value;
    } else {
      return this.parsingError(ParsingErrorType.StaticOffsetError, "Third argument to OFFSET is not a static number");
    }
    const heightArg = args[3];
    let height;
    if (heightArg === void 0) {
      height = 1;
    } else if (heightArg.type === AstNodeType.NUMBER) {
      height = heightArg.value;
      if (height < 1) {
        return this.parsingError(ParsingErrorType.StaticOffsetError, "Fourth argument to OFFSET is too small number");
      } else if (!Number.isInteger(height)) {
        return this.parsingError(ParsingErrorType.StaticOffsetError, "Fourth argument to OFFSET is not integer");
      }
    } else {
      return this.parsingError(ParsingErrorType.StaticOffsetError, "Fourth argument to OFFSET is not a static number");
    }
    const widthArg = args[4];
    let width;
    if (widthArg === void 0) {
      width = 1;
    } else if (widthArg.type === AstNodeType.NUMBER) {
      width = widthArg.value;
      if (width < 1) {
        return this.parsingError(ParsingErrorType.StaticOffsetError, "Fifth argument to OFFSET is too small number");
      } else if (!Number.isInteger(width)) {
        return this.parsingError(ParsingErrorType.StaticOffsetError, "Fifth argument to OFFSET is not integer");
      }
    } else {
      return this.parsingError(ParsingErrorType.StaticOffsetError, "Fifth argument to OFFSET is not a static number");
    }
    const topLeftCorner = new CellAddress(cellArg.reference.col + colShift, cellArg.reference.row + rowShift, cellArg.reference.type, (_a = cellArg.reference.sheet) !== null && _a !== void 0 ? _a : void 0);
    let absoluteCol = topLeftCorner.col;
    let absoluteRow = topLeftCorner.row;
    if (cellArg.reference.type === CellReferenceType.CELL_REFERENCE_RELATIVE || cellArg.reference.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_COL) {
      absoluteRow = absoluteRow + this.formulaAddress.row;
    }
    if (cellArg.reference.type === CellReferenceType.CELL_REFERENCE_RELATIVE || cellArg.reference.type === CellReferenceType.CELL_REFERENCE_ABSOLUTE_ROW) {
      absoluteCol = absoluteCol + this.formulaAddress.col;
    }
    if (absoluteCol < 0 || absoluteRow < 0) {
      return buildCellErrorAst(new CellError(ErrorType.REF, ErrorMessage.OutOfSheet));
    }
    if (width === 1 && height === 1) {
      return buildCellReferenceAst(topLeftCorner);
    } else {
      const bottomRightCorner = new CellAddress(topLeftCorner.col + width - 1, topLeftCorner.row + height - 1, topLeftCorner.type, topLeftCorner.sheet);
      const rangeSheetReferenceType = cellArg.reference.sheet == null ? RangeSheetReferenceType.RELATIVE : RangeSheetReferenceType.BOTH_ABSOLUTE;
      return buildCellRangeAst(topLeftCorner, bottomRightCorner, rangeSheetReferenceType);
    }
  }
  parsingError(type, message) {
    this.customParsingError = parsingError(type, message);
    return buildParsingErrorAst();
  }
  static rangeSheetReferenceType(start, end) {
    if (start === void 0) {
      return RangeSheetReferenceType.RELATIVE;
    } else if (end === void 0) {
      return RangeSheetReferenceType.START_ABSOLUTE;
    } else {
      return RangeSheetReferenceType.BOTH_ABSOLUTE;
    }
  }
}
class FormulaLexer {
  constructor(lexerConfig) {
    this.lexerConfig = lexerConfig;
    this.lexer = new Lexer(lexerConfig.allTokens, {
      ensureOptimizations: true
    });
  }
  /**
   * Returns Lexer tokens from formula string
   *
   * @param {string} text - string representation of a formula
   */
  tokenizeFormula(text) {
    const lexingResult = this.lexer.tokenize(text);
    let tokens = lexingResult.tokens;
    tokens = this.trimTrailingWhitespaces(tokens);
    tokens = this.skipWhitespacesInsideRanges(tokens);
    tokens = this.skipWhitespacesBeforeArgSeparators(tokens);
    lexingResult.tokens = tokens;
    return lexingResult;
  }
  skipWhitespacesInsideRanges(tokens) {
    return FormulaLexer.filterTokensByNeighbors(tokens, (previous, current, next) => {
      return (tokenMatcher(previous, CellReference) || tokenMatcher(previous, RangeSeparator)) && tokenMatcher(current, this.lexerConfig.WhiteSpace) && (tokenMatcher(next, CellReference) || tokenMatcher(next, RangeSeparator));
    });
  }
  skipWhitespacesBeforeArgSeparators(tokens) {
    return FormulaLexer.filterTokensByNeighbors(tokens, (previous, current, next) => {
      return !tokenMatcher(previous, this.lexerConfig.ArgSeparator) && tokenMatcher(current, this.lexerConfig.WhiteSpace) && tokenMatcher(next, this.lexerConfig.ArgSeparator);
    });
  }
  static filterTokensByNeighbors(tokens, shouldBeSkipped) {
    if (tokens.length < 3) {
      return tokens;
    }
    let i = 0;
    const filteredTokens = [tokens[i++]];
    while (i < tokens.length - 1) {
      if (!shouldBeSkipped(tokens[i - 1], tokens[i], tokens[i + 1])) {
        filteredTokens.push(tokens[i]);
      }
      ++i;
    }
    filteredTokens.push(tokens[i]);
    return filteredTokens;
  }
  trimTrailingWhitespaces(tokens) {
    if (tokens.length > 0 && tokenMatcher(tokens[tokens.length - 1], this.lexerConfig.WhiteSpace)) {
      tokens.pop();
    }
    return tokens;
  }
}
class Unparser {
  constructor(config, sheetMapping, namedExpressions) {
    this.config = config;
    this.sheetMapping = sheetMapping;
    this.namedExpressions = namedExpressions;
  }
  unparse(ast, address) {
    return "=" + this.unparseAst(ast, address);
  }
  unparseAst(ast, address) {
    var _a, _b;
    switch (ast.type) {
      case AstNodeType.EMPTY: {
        return imageWithWhitespace("", ast.leadingWhitespace);
      }
      case AstNodeType.NUMBER: {
        return imageWithWhitespace(formatNumber(ast.value, this.config.decimalSeparator), ast.leadingWhitespace);
      }
      case AstNodeType.STRING: {
        return imageWithWhitespace('"' + ast.value + '"', ast.leadingWhitespace);
      }
      case AstNodeType.FUNCTION_CALL: {
        const args = ast.args.map((arg) => arg !== void 0 ? this.unparseAst(arg, address) : "").join(this.config.functionArgSeparator);
        const procedureName = this.config.translationPackage.isFunctionTranslated(ast.procedureName) ? this.config.translationPackage.getFunctionTranslation(ast.procedureName) : ast.procedureName;
        const rightPart = procedureName + "(" + args + imageWithWhitespace(")", ast.internalWhitespace);
        return imageWithWhitespace(rightPart, ast.leadingWhitespace);
      }
      case AstNodeType.NAMED_EXPRESSION: {
        const originalNamedExpressionName = (_a = this.namedExpressions.nearestNamedExpression(ast.expressionName, address.sheet)) === null || _a === void 0 ? void 0 : _a.displayName;
        return imageWithWhitespace(originalNamedExpressionName || ast.expressionName, ast.leadingWhitespace);
      }
      case AstNodeType.CELL_REFERENCE: {
        let image;
        if (ast.reference.sheet !== void 0) {
          image = this.unparseSheetName(ast.reference.sheet) + "!";
        } else {
          image = "";
        }
        image += (_b = ast.reference.unparse(address)) !== null && _b !== void 0 ? _b : this.config.translationPackage.getErrorTranslation(ErrorType.REF);
        return imageWithWhitespace(image, ast.leadingWhitespace);
      }
      case AstNodeType.COLUMN_RANGE:
      case AstNodeType.ROW_RANGE:
      case AstNodeType.CELL_RANGE: {
        return imageWithWhitespace(this.formatRange(ast, address), ast.leadingWhitespace);
      }
      case AstNodeType.PLUS_UNARY_OP: {
        const unparsedExpr = this.unparseAst(ast.value, address);
        return imageWithWhitespace("+", ast.leadingWhitespace) + unparsedExpr;
      }
      case AstNodeType.MINUS_UNARY_OP: {
        const unparsedExpr = this.unparseAst(ast.value, address);
        return imageWithWhitespace("-", ast.leadingWhitespace) + unparsedExpr;
      }
      case AstNodeType.PERCENT_OP: {
        return this.unparseAst(ast.value, address) + imageWithWhitespace("%", ast.leadingWhitespace);
      }
      case AstNodeType.ERROR: {
        const image = this.config.translationPackage.getErrorTranslation(ast.error ? ast.error.type : ErrorType.ERROR);
        return imageWithWhitespace(image, ast.leadingWhitespace);
      }
      case AstNodeType.ERROR_WITH_RAW_INPUT: {
        return imageWithWhitespace(ast.rawInput, ast.leadingWhitespace);
      }
      case AstNodeType.PARENTHESIS: {
        const expression = this.unparseAst(ast.expression, address);
        const rightPart = "(" + expression + imageWithWhitespace(")", ast.internalWhitespace);
        return imageWithWhitespace(rightPart, ast.leadingWhitespace);
      }
      case AstNodeType.ARRAY: {
        const ret = "{" + ast.args.map((row) => row.map((val) => this.unparseAst(val, address)).join(this.config.arrayColumnSeparator)).join(this.config.arrayRowSeparator) + imageWithWhitespace("}", ast.internalWhitespace);
        return imageWithWhitespace(ret, ast.leadingWhitespace);
      }
      default: {
        const left2 = this.unparseAst(ast.left, address);
        const right2 = this.unparseAst(ast.right, address);
        return left2 + imageWithWhitespace(binaryOpTokenMap[ast.type], ast.leadingWhitespace) + right2;
      }
    }
  }
  /**
   * Unparses a sheet name.
   * @param {number} sheetId - the ID of the sheet
   * @returns {string} the unparsed sheet name
   */
  unparseSheetName(sheetId) {
    const sheetName = sheetIndexToString(sheetId, (id) => this.sheetMapping.getSheetNameOrThrowError(id, {
      includePlaceholders: true
    }));
    if (sheetName === void 0) {
      throw new NoSheetWithIdError(sheetId);
    }
    return sheetName;
  }
  formatRange(ast, baseAddress) {
    let startSheeet = "";
    let endSheet = "";
    if (ast.start.sheet !== void 0 && ast.sheetReferenceType !== RangeSheetReferenceType.RELATIVE) {
      startSheeet = this.unparseSheetName(ast.start.sheet) + "!";
    }
    if (ast.end.sheet !== void 0 && ast.sheetReferenceType === RangeSheetReferenceType.BOTH_ABSOLUTE) {
      endSheet = this.unparseSheetName(ast.end.sheet) + "!";
    }
    const unparsedStart = ast.start.unparse(baseAddress);
    const unparsedEnd = ast.end.unparse(baseAddress);
    if (unparsedStart === void 0 || unparsedEnd === void 0) {
      return this.config.translationPackage.getErrorTranslation(ErrorType.REF);
    }
    return `${startSheeet}${unparsedStart}:${endSheet}${unparsedEnd}`;
  }
}
function formatNumber(number, decimalSeparator) {
  const numericString = number.toString();
  return numericString.replace(".", decimalSeparator);
}
class ParserWithCaching {
  constructor(config, functionRegistry, resolveSheetReference) {
    this.config = config;
    this.functionRegistry = functionRegistry;
    this.resolveSheetReference = resolveSheetReference;
    this.statsCacheUsed = 0;
    this.lexerConfig = buildLexerConfig(config);
    this.lexer = new FormulaLexer(this.lexerConfig);
    this.formulaParser = new FormulaParser(this.lexerConfig, this.resolveSheetReference);
    this.cache = new Cache(this.functionRegistry);
  }
  /**
   * Parses a formula.
   *
   * @param text - formula to parse
   * @param formulaAddress - address with regard to which formula should be parsed. Impacts computed addresses in R0C0 format.
   */
  parse(text, formulaAddress) {
    this.formulaAddress = formulaAddress;
    const lexerResult = this.tokenizeFormula(text);
    if (lexerResult.errors.length > 0) {
      const errors = lexerResult.errors.map((e) => ({
        type: ParsingErrorType.LexingError,
        message: e.message
      }));
      return {
        ast: buildParsingErrorAst(),
        errors,
        hasVolatileFunction: false,
        hasStructuralChangeFunction: false,
        dependencies: []
      };
    }
    const hash = this.computeHashFromTokens(lexerResult.tokens, formulaAddress);
    let cacheResult = this.cache.get(hash);
    if (cacheResult !== void 0) {
      ++this.statsCacheUsed;
    } else {
      const processedTokens = this.bindWhitespacesToTokens(lexerResult.tokens);
      const parsingResult = this.formulaParser.parseFromTokens(processedTokens, formulaAddress);
      if (parsingResult.errors.length > 0) {
        return Object.assign(Object.assign({}, parsingResult), {
          hasVolatileFunction: false,
          hasStructuralChangeFunction: false,
          dependencies: []
        });
      } else {
        cacheResult = this.cache.set(hash, parsingResult.ast);
      }
    }
    const {
      ast,
      hasVolatileFunction,
      hasStructuralChangeFunction
    } = cacheResult;
    const astWithNoReversedRanges = this.convertReversedRangesToRegularRanges(ast);
    const dependencies = collectDependencies(astWithNoReversedRanges, this.functionRegistry);
    return {
      ast: astWithNoReversedRanges,
      errors: [],
      hasVolatileFunction,
      hasStructuralChangeFunction,
      dependencies
    };
  }
  convertReversedRangesToRegularRanges(ast) {
    switch (ast.type) {
      case AstNodeType.EMPTY:
      case AstNodeType.NUMBER:
      case AstNodeType.STRING:
      case AstNodeType.ERROR:
      case AstNodeType.ERROR_WITH_RAW_INPUT:
      case AstNodeType.CELL_REFERENCE:
      case AstNodeType.NAMED_EXPRESSION:
        return ast;
      case AstNodeType.CELL_RANGE: {
        const {
          start,
          end
        } = ast;
        const orderedEnds = this.orderCellRangeEnds(start, end);
        return Object.assign(Object.assign({}, ast), {
          start: orderedEnds.start,
          end: orderedEnds.end
        });
      }
      case AstNodeType.COLUMN_RANGE: {
        const {
          start,
          end
        } = ast;
        const orderedEnds = this.orderColumnRangeEnds(start, end);
        return Object.assign(Object.assign({}, ast), {
          start: orderedEnds.start,
          end: orderedEnds.end
        });
      }
      case AstNodeType.ROW_RANGE: {
        const {
          start,
          end
        } = ast;
        const orderedEnds = this.orderRowRangeEnds(start, end);
        return Object.assign(Object.assign({}, ast), {
          start: orderedEnds.start,
          end: orderedEnds.end
        });
      }
      case AstNodeType.PERCENT_OP:
      case AstNodeType.PLUS_UNARY_OP:
      case AstNodeType.MINUS_UNARY_OP: {
        const valueFixed = this.convertReversedRangesToRegularRanges(ast.value);
        return Object.assign(Object.assign({}, ast), {
          value: valueFixed
        });
      }
      case AstNodeType.CONCATENATE_OP:
      case AstNodeType.EQUALS_OP:
      case AstNodeType.NOT_EQUAL_OP:
      case AstNodeType.LESS_THAN_OP:
      case AstNodeType.GREATER_THAN_OP:
      case AstNodeType.LESS_THAN_OR_EQUAL_OP:
      case AstNodeType.GREATER_THAN_OR_EQUAL_OP:
      case AstNodeType.MINUS_OP:
      case AstNodeType.PLUS_OP:
      case AstNodeType.TIMES_OP:
      case AstNodeType.DIV_OP:
      case AstNodeType.POWER_OP: {
        const leftFixed = this.convertReversedRangesToRegularRanges(ast.left);
        const rightFixed = this.convertReversedRangesToRegularRanges(ast.right);
        return Object.assign(Object.assign({}, ast), {
          left: leftFixed,
          right: rightFixed
        });
      }
      case AstNodeType.PARENTHESIS: {
        const exprFixed = this.convertReversedRangesToRegularRanges(ast.expression);
        return Object.assign(Object.assign({}, ast), {
          expression: exprFixed
        });
      }
      case AstNodeType.FUNCTION_CALL: {
        const argsFixed = ast.args.map((arg) => this.convertReversedRangesToRegularRanges(arg));
        return Object.assign(Object.assign({}, ast), {
          args: argsFixed
        });
      }
      case AstNodeType.ARRAY: {
        const argsFixed = ast.args.map((argsRow) => argsRow.map((arg) => this.convertReversedRangesToRegularRanges(arg)));
        return Object.assign(Object.assign({}, ast), {
          args: argsFixed
        });
      }
    }
  }
  orderCellRangeEnds(endA, endB) {
    const ends = [endA, endB];
    const [startCol, endCol] = ends.map((e) => e.toColumnAddress()).sort(ColumnAddress.compareByAbsoluteAddress(this.formulaAddress));
    const [startRow, endRow] = ends.map((e) => e.toRowAddress()).sort(RowAddress.compareByAbsoluteAddress(this.formulaAddress));
    const [startSheet, endSheet] = ends.map((e) => e.sheet).sort(ParserWithCaching.compareSheetIds.bind(this));
    return {
      start: CellAddress.fromColAndRow(startCol, startRow, startSheet),
      end: CellAddress.fromColAndRow(endCol, endRow, endSheet)
    };
  }
  orderColumnRangeEnds(endA, endB) {
    const ends = [endA, endB];
    const [startCol, endCol] = ends.sort(ColumnAddress.compareByAbsoluteAddress(this.formulaAddress));
    const [startSheet, endSheet] = ends.map((e) => e.sheet).sort(ParserWithCaching.compareSheetIds.bind(this));
    return {
      start: new ColumnAddress(startCol.type, startCol.col, startSheet),
      end: new ColumnAddress(endCol.type, endCol.col, endSheet)
    };
  }
  orderRowRangeEnds(endA, endB) {
    const ends = [endA, endB];
    const [startRow, endRow] = ends.sort(RowAddress.compareByAbsoluteAddress(this.formulaAddress));
    const [startSheet, endSheet] = ends.map((e) => e.sheet).sort(ParserWithCaching.compareSheetIds.bind(this));
    return {
      start: new RowAddress(startRow.type, startRow.row, startSheet),
      end: new RowAddress(endRow.type, endRow.row, endSheet)
    };
  }
  static compareSheetIds(sheetA, sheetB) {
    sheetA = sheetA != null ? sheetA : Infinity;
    sheetB = sheetB != null ? sheetB : Infinity;
    return sheetA - sheetB;
  }
  fetchCachedResultForAst(ast) {
    const hash = this.computeHashFromAst(ast);
    return this.fetchCachedResult(hash);
  }
  fetchCachedResult(hash) {
    const cacheResult = this.cache.get(hash);
    if (cacheResult === void 0) {
      throw new Error("There is no AST with such key in the cache");
    } else {
      const {
        ast,
        hasVolatileFunction,
        hasStructuralChangeFunction,
        relativeDependencies
      } = cacheResult;
      return {
        ast,
        errors: [],
        hasVolatileFunction,
        hasStructuralChangeFunction,
        dependencies: relativeDependencies
      };
    }
  }
  computeHashFromTokens(tokens, baseAddress) {
    var _a;
    let hash = "";
    let idx = 0;
    while (idx < tokens.length) {
      const token = tokens[idx];
      if (tokenMatcher(token, CellReference)) {
        const cellAddress = cellAddressFromString(token.image, baseAddress, this.resolveSheetReference);
        if (cellAddress === void 0) {
          hash = hash.concat(token.image);
        } else {
          hash = hash.concat(cellAddress.hash(true));
        }
      } else if (tokenMatcher(token, ProcedureName)) {
        const procedureName = token.image.toUpperCase().slice(0, -1);
        const canonicalProcedureName = (_a = this.lexerConfig.functionMapping[procedureName]) !== null && _a !== void 0 ? _a : procedureName;
        hash = hash.concat(canonicalProcedureName, "(");
      } else if (tokenMatcher(token, ColumnRange)) {
        const [start, end] = token.image.split(":");
        const startAddress = columnAddressFromString(start, baseAddress, this.resolveSheetReference);
        const endAddress = columnAddressFromString(end, baseAddress, this.resolveSheetReference);
        if (startAddress === void 0 || endAddress === void 0) {
          hash = hash.concat("!REF");
        } else {
          hash = hash.concat(startAddress.hash(true), ":", endAddress.hash(true));
        }
      } else if (tokenMatcher(token, RowRange)) {
        const [start, end] = token.image.split(":");
        const startAddress = rowAddressFromString(start, baseAddress, this.resolveSheetReference);
        const endAddress = rowAddressFromString(end, baseAddress, this.resolveSheetReference);
        if (startAddress === void 0 || endAddress === void 0) {
          hash = hash.concat("!REF");
        } else {
          hash = hash.concat(startAddress.hash(true), ":", endAddress.hash(true));
        }
      } else {
        hash = hash.concat(token.image);
      }
      idx++;
    }
    return hash;
  }
  rememberNewAst(ast) {
    const hash = this.computeHashFromAst(ast);
    return this.cache.maybeSetAndThenGet(hash, ast);
  }
  computeHashFromAst(ast) {
    return "=" + this.computeHashOfAstNode(ast);
  }
  computeHashOfAstNode(ast) {
    switch (ast.type) {
      case AstNodeType.EMPTY: {
        return ast.leadingWhitespace || "";
      }
      case AstNodeType.NUMBER: {
        return imageWithWhitespace(formatNumber(ast.value, this.config.decimalSeparator), ast.leadingWhitespace);
      }
      case AstNodeType.STRING: {
        return imageWithWhitespace('"' + ast.value + '"', ast.leadingWhitespace);
      }
      case AstNodeType.NAMED_EXPRESSION: {
        return imageWithWhitespace(ast.expressionName, ast.leadingWhitespace);
      }
      case AstNodeType.FUNCTION_CALL: {
        const args = ast.args.map((arg) => this.computeHashOfAstNode(arg)).join(this.config.functionArgSeparator);
        const rightPart = ast.procedureName + "(" + args + imageWithWhitespace(")", ast.internalWhitespace);
        return imageWithWhitespace(rightPart, ast.leadingWhitespace);
      }
      case AstNodeType.CELL_REFERENCE: {
        return imageWithWhitespace(ast.reference.hash(true), ast.leadingWhitespace);
      }
      case AstNodeType.COLUMN_RANGE:
      case AstNodeType.ROW_RANGE:
      case AstNodeType.CELL_RANGE: {
        const start = ast.start.hash(ast.sheetReferenceType !== RangeSheetReferenceType.RELATIVE);
        const end = ast.end.hash(ast.sheetReferenceType === RangeSheetReferenceType.BOTH_ABSOLUTE);
        return imageWithWhitespace(start + ":" + end, ast.leadingWhitespace);
      }
      case AstNodeType.MINUS_UNARY_OP: {
        return imageWithWhitespace("-" + this.computeHashOfAstNode(ast.value), ast.leadingWhitespace);
      }
      case AstNodeType.PLUS_UNARY_OP: {
        return imageWithWhitespace("+" + this.computeHashOfAstNode(ast.value), ast.leadingWhitespace);
      }
      case AstNodeType.PERCENT_OP: {
        return this.computeHashOfAstNode(ast.value) + imageWithWhitespace("%", ast.leadingWhitespace);
      }
      case AstNodeType.ERROR: {
        const image = this.config.translationPackage.getErrorTranslation(ast.error ? ast.error.type : ErrorType.ERROR);
        return imageWithWhitespace(image, ast.leadingWhitespace);
      }
      case AstNodeType.ERROR_WITH_RAW_INPUT: {
        return imageWithWhitespace(ast.rawInput, ast.leadingWhitespace);
      }
      case AstNodeType.ARRAY: {
        const args = ast.args.map((row) => row.map((val) => this.computeHashOfAstNode(val)).join(",")).join(";");
        return imageWithWhitespace("{" + args + imageWithWhitespace("}", ast.internalWhitespace), ast.leadingWhitespace);
      }
      case AstNodeType.PARENTHESIS: {
        const expression = this.computeHashOfAstNode(ast.expression);
        const rightPart = "(" + expression + imageWithWhitespace(")", ast.internalWhitespace);
        return imageWithWhitespace(rightPart, ast.leadingWhitespace);
      }
      default: {
        return this.computeHashOfAstNode(ast.left) + imageWithWhitespace(binaryOpTokenMap[ast.type], ast.leadingWhitespace) + this.computeHashOfAstNode(ast.right);
      }
    }
  }
  bindWhitespacesToTokens(tokens) {
    const processedTokens = [];
    const first2 = tokens[0];
    if (!tokenMatcher(first2, this.lexerConfig.WhiteSpace)) {
      processedTokens.push(first2);
    }
    for (let i = 1; i < tokens.length; ++i) {
      const current = tokens[i];
      if (tokenMatcher(current, this.lexerConfig.WhiteSpace)) {
        continue;
      }
      const previous = tokens[i - 1];
      if (tokenMatcher(previous, this.lexerConfig.WhiteSpace)) {
        current.leadingWhitespace = previous;
      }
      processedTokens.push(current);
    }
    return processedTokens;
  }
  tokenizeFormula(text) {
    return this.lexer.tokenizeFormula(text);
  }
}
const collectDependenciesFn = (ast, functionRegistry, dependenciesSet, needArgument) => {
  switch (ast.type) {
    case AstNodeType.EMPTY:
    case AstNodeType.NUMBER:
    case AstNodeType.STRING:
    case AstNodeType.ERROR:
      return;
    case AstNodeType.NAMED_EXPRESSION: {
      if (needArgument) {
        dependenciesSet.push(new NamedExpressionDependency(ast.expressionName));
      }
      return;
    }
    case AstNodeType.CELL_REFERENCE: {
      if (needArgument) {
        dependenciesSet.push(new AddressDependency(ast.reference));
      }
      return;
    }
    case AstNodeType.CELL_RANGE: {
      if (needArgument && ast.start.sheet === ast.end.sheet) {
        dependenciesSet.push(new CellRangeDependency(ast.start, ast.end));
      }
      return;
    }
    case AstNodeType.COLUMN_RANGE: {
      if (needArgument && ast.start.sheet === ast.end.sheet) {
        dependenciesSet.push(new ColumnRangeDependency(ast.start, ast.end));
      }
      return;
    }
    case AstNodeType.ROW_RANGE: {
      if (needArgument && ast.start.sheet === ast.end.sheet) {
        dependenciesSet.push(new RowRangeDependency(ast.start, ast.end));
      }
      return;
    }
    case AstNodeType.PERCENT_OP:
    case AstNodeType.PLUS_UNARY_OP:
    case AstNodeType.MINUS_UNARY_OP: {
      collectDependenciesFn(ast.value, functionRegistry, dependenciesSet, true);
      return;
    }
    case AstNodeType.CONCATENATE_OP:
    case AstNodeType.EQUALS_OP:
    case AstNodeType.NOT_EQUAL_OP:
    case AstNodeType.LESS_THAN_OP:
    case AstNodeType.GREATER_THAN_OP:
    case AstNodeType.LESS_THAN_OR_EQUAL_OP:
    case AstNodeType.GREATER_THAN_OR_EQUAL_OP:
    case AstNodeType.MINUS_OP:
    case AstNodeType.PLUS_OP:
    case AstNodeType.TIMES_OP:
    case AstNodeType.DIV_OP:
    case AstNodeType.POWER_OP:
      collectDependenciesFn(ast.left, functionRegistry, dependenciesSet, true);
      collectDependenciesFn(ast.right, functionRegistry, dependenciesSet, true);
      return;
    case AstNodeType.PARENTHESIS:
      collectDependenciesFn(ast.expression, functionRegistry, dependenciesSet, needArgument);
      return;
    case AstNodeType.FUNCTION_CALL: {
      const functionNeedArgument = !functionRegistry.doesFunctionNeedArgumentToBeComputed(ast.procedureName);
      ast.args.forEach((argAst) => collectDependenciesFn(argAst, functionRegistry, dependenciesSet, functionNeedArgument));
      return;
    }
  }
};
const collectDependencies = (ast, functionRegistry) => {
  const result = new Array();
  collectDependenciesFn(ast, functionRegistry, result, true);
  return result;
};
class AddressDependency {
  constructor(dependency) {
    this.dependency = dependency;
  }
  absolutize(baseAddress) {
    return this.dependency.toSimpleCellAddress(baseAddress);
  }
}
class CellRangeDependency {
  constructor(start, end) {
    this.start = start;
    this.end = end;
  }
  absolutize(baseAddress) {
    return new AbsoluteCellRange(this.start.toSimpleCellAddress(baseAddress), this.end.toSimpleCellAddress(baseAddress));
  }
}
class ColumnRangeDependency {
  constructor(start, end) {
    this.start = start;
    this.end = end;
  }
  absolutize(baseAddress) {
    const start = this.start.toSimpleColumnAddress(baseAddress);
    const end = this.end.toSimpleColumnAddress(baseAddress);
    return new AbsoluteColumnRange(start.sheet, start.col, end.col);
  }
}
class RowRangeDependency {
  constructor(start, end) {
    this.start = start;
    this.end = end;
  }
  absolutize(baseAddress) {
    const start = this.start.toSimpleRowAddress(baseAddress);
    const end = this.end.toSimpleRowAddress(baseAddress);
    return new AbsoluteRowRange(start.sheet, start.row, end.row);
  }
}
class NamedExpressionDependency {
  constructor(name) {
    this.name = name;
  }
  absolutize(_baseAddress) {
    return this;
  }
}
const absolutizeDependencies = (deps, baseAddress) => {
  return deps.map((dep) => dep.absolutize(baseAddress));
};
const filterDependenciesOutOfScope = (deps) => {
  return deps.filter((dep) => {
    if (dep instanceof NamedExpressionDependency) {
      return true;
    }
    if (dep instanceof AbsoluteCellRange) {
      return !(isColOrRowInvalid(dep.start) || isColOrRowInvalid(dep.end));
    } else {
      return !isColOrRowInvalid(dep);
    }
  });
};
const EmptyValue = /* @__PURE__ */ Symbol("Empty value");
function getRawValue(num) {
  if (num instanceof RichNumber) {
    return num.val;
  } else {
    return num;
  }
}
class RichNumber {
  constructor(val, format2) {
    this.val = val;
    this.format = format2;
  }
  fromNumber(val) {
    return new this.constructor(val);
  }
}
function cloneNumber(val, newVal) {
  if (typeof val === "number") {
    return newVal;
  } else {
    const ret = val.fromNumber(newVal);
    ret.format = val.format;
    return ret;
  }
}
class DateNumber extends RichNumber {
  getDetailedType() {
    return NumberType.NUMBER_DATE;
  }
}
class CurrencyNumber extends RichNumber {
  getDetailedType() {
    return NumberType.NUMBER_CURRENCY;
  }
}
class TimeNumber extends RichNumber {
  getDetailedType() {
    return NumberType.NUMBER_TIME;
  }
}
class DateTimeNumber extends RichNumber {
  getDetailedType() {
    return NumberType.NUMBER_DATETIME;
  }
}
class PercentNumber extends RichNumber {
  getDetailedType() {
    return NumberType.NUMBER_PERCENT;
  }
}
function isExtendedNumber(val) {
  return typeof val === "number" || val instanceof RichNumber;
}
var NumberType;
(function(NumberType2) {
  NumberType2["NUMBER_RAW"] = "NUMBER_RAW";
  NumberType2["NUMBER_DATE"] = "NUMBER_DATE";
  NumberType2["NUMBER_TIME"] = "NUMBER_TIME";
  NumberType2["NUMBER_DATETIME"] = "NUMBER_DATETIME";
  NumberType2["NUMBER_CURRENCY"] = "NUMBER_CURRENCY";
  NumberType2["NUMBER_PERCENT"] = "NUMBER_PERCENT";
})(NumberType || (NumberType = {}));
function getTypeOfExtendedNumber(num) {
  if (num instanceof RichNumber) {
    return num.getDetailedType();
  } else {
    return NumberType.NUMBER_RAW;
  }
}
function getFormatOfExtendedNumber(num) {
  if (num instanceof RichNumber) {
    return num.format;
  } else {
    return void 0;
  }
}
function getTypeFormatOfExtendedNumber(num) {
  if (num instanceof RichNumber) {
    return {
      type: num.getDetailedType(),
      format: num.format
    };
  } else {
    return {
      type: NumberType.NUMBER_RAW
    };
  }
}
class SimpleRangeValue {
  /**
   * In most cases, it's more convenient to create a `SimpleRangeValue` object
   * by calling one of the [static factory methods](#fromrange).
   */
  constructor(_data2, range, dependencyGraph, _hasOnlyNumbers) {
    this._data = _data2;
    this.range = range;
    this.dependencyGraph = dependencyGraph;
    this._hasOnlyNumbers = _hasOnlyNumbers;
    this.size = _data2 === void 0 ? new ArraySize(range.effectiveWidth(dependencyGraph), range.effectiveHeight(dependencyGraph)) : new ArraySize(_data2[0].length, _data2.length);
  }
  /**
   * Returns the range data as a 2D array.
   */
  get data() {
    this.ensureThatComputed();
    return this._data;
  }
  /**
   * A factory method. Returns a `SimpleRangeValue` object with the provided range address and the provided data.
   */
  static fromRange(data, range, dependencyGraph) {
    return new SimpleRangeValue(data, range, dependencyGraph, true);
  }
  /**
   * A factory method. Returns a `SimpleRangeValue` object with the provided numeric data.
   */
  static onlyNumbers(data) {
    return new SimpleRangeValue(data, void 0, void 0, true);
  }
  /**
   * A factory method. Returns a `SimpleRangeValue` object with the provided data.
   */
  static onlyValues(data) {
    return new SimpleRangeValue(data, void 0, void 0, void 0);
  }
  /**
   * A factory method. Returns a `SimpleRangeValue` object with the provided range address.
   */
  static onlyRange(range, dependencyGraph) {
    return new SimpleRangeValue(void 0, range, dependencyGraph, void 0);
  }
  /**
   * A factory method. Returns a `SimpleRangeValue` object that contains a single value.
   */
  static fromScalar(scalar) {
    return new SimpleRangeValue([[scalar]], void 0, void 0, void 0);
  }
  /**
   * Returns `true` if and only if the `SimpleRangeValue` has no address set.
   */
  isAdHoc() {
    return this.range === void 0;
  }
  /**
   * Returns the number of columns contained in the range.
   */
  width() {
    return this.size.width;
  }
  /**
   * Returns the number of rows contained in the range.
   */
  height() {
    return this.size.height;
  }
  /**
   * Returns the range data as a 1D array.
   */
  valuesFromTopLeftCorner() {
    this.ensureThatComputed();
    const ret = [];
    for (let i = 0; i < this._data.length; i++) {
      for (let j = 0; j < this._data[0].length; j++) {
        ret.push(this._data[i][j]);
      }
    }
    return ret;
  }
  /**
   * Generates the addresses of the cells contained in the range assuming the provided address is the left corner of the range.
   */
  *effectiveAddressesFromData(leftCorner) {
    for (let row = 0; row < this.data.length; ++row) {
      const rowData = this.data[row];
      for (let col = 0; col < rowData.length; ++col) {
        yield simpleCellAddress(leftCorner.sheet, leftCorner.col + col, leftCorner.row + row);
      }
    }
  }
  /**
   * Generates values and addresses of the cells contained in the range assuming the provided address is the left corner of the range.
   *
   * This method combines the functionalities of [`iterateValuesFromTopLeftCorner()`](#iteratevaluesfromtopleftcorner) and [`effectiveAddressesFromData()`](#effectiveaddressesfromdata).
   */
  *entriesFromTopLeftCorner(leftCorner) {
    this.ensureThatComputed();
    for (let row = 0; row < this.size.height; ++row) {
      for (let col = 0; col < this.size.width; ++col) {
        yield [this._data[row][col], simpleCellAddress(leftCorner.sheet, leftCorner.col + col, leftCorner.row + row)];
      }
    }
  }
  /**
   * Generates the values of the cells contained in the range assuming the provided address is the left corner of the range.
   */
  *iterateValuesFromTopLeftCorner() {
    yield* this.valuesFromTopLeftCorner();
  }
  /**
   * Returns the number of cells contained in the range.
   */
  numberOfElements() {
    return this.size.width * this.size.height;
  }
  /**
   * Returns `true` if and only if the range contains only numeric values.
   */
  hasOnlyNumbers() {
    if (this._hasOnlyNumbers === void 0) {
      this._hasOnlyNumbers = true;
      for (const row of this.data) {
        for (const v of row) {
          if (typeof v !== "number") {
            this._hasOnlyNumbers = false;
            return false;
          }
        }
      }
    }
    return this._hasOnlyNumbers;
  }
  /**
   * Returns the range data as a 2D array of numbers.
   *
   * Internal use only.
   */
  rawNumbers() {
    return this._data;
  }
  /**
   * Returns the range data as a 2D array.
   *
   * Internal use only.
   */
  rawData() {
    var _a;
    this.ensureThatComputed();
    return (_a = this._data) !== null && _a !== void 0 ? _a : [];
  }
  /**
   * Returns `true` if and only if the range has the same width and height as the `other` range object.
   */
  sameDimensionsAs(other) {
    return this.width() === other.width() && this.height() === other.height();
  }
  /**
   * Computes the range data if it is not computed yet.
   */
  ensureThatComputed() {
    if (this._data !== void 0) {
      return;
    }
    this._hasOnlyNumbers = true;
    this._data = this.range.addressesArrayMap(this.dependencyGraph, (cellFromRange) => {
      const value = this.dependencyGraph.getCellValue(cellFromRange);
      if (value instanceof SimpleRangeValue) {
        this._hasOnlyNumbers = false;
        return new CellError(ErrorType.VALUE, ErrorMessage.ScalarExpected);
      } else if (isExtendedNumber(value)) {
        return value;
      } else {
        this._hasOnlyNumbers = false;
        return value;
      }
    });
  }
}
class ContentChanges {
  constructor() {
    this.changes = /* @__PURE__ */ new Map();
  }
  static empty() {
    return new ContentChanges();
  }
  addAll(other) {
    for (const change of other.changes.values()) {
      this.add(change.address, change);
    }
    return this;
  }
  addChange(newValue, address, oldValue) {
    this.addInterpreterValue(newValue, address, oldValue);
  }
  exportChanges(exporter) {
    let ret = [];
    this.changes.forEach((e) => {
      const change = exporter.exportChange(e);
      if (Array.isArray(change)) {
        ret = ret.concat(change);
      } else {
        ret.push(change);
      }
    });
    return ret;
  }
  getChanges() {
    return Array.from(this.changes.values());
  }
  isEmpty() {
    return this.changes.size === 0;
  }
  add(address, change) {
    const value = change.value;
    if (value instanceof SimpleRangeValue) {
      for (const cellAddress of value.effectiveAddressesFromData(address)) {
        this.changes.delete(addressKey(cellAddress));
      }
    }
    this.changes.set(addressKey(address), change);
  }
  addInterpreterValue(value, address, oldValue) {
    this.add(address, {
      address,
      value,
      oldValue
    });
  }
}
class InternalNamedExpression {
  constructor(displayName, address, added, options) {
    this.displayName = displayName;
    this.address = address;
    this.added = added;
    this.options = options;
  }
  normalizeExpressionName() {
    return this.displayName.toLowerCase();
  }
  copy() {
    return new InternalNamedExpression(this.displayName, this.address, this.added, this.options);
  }
}
class WorkbookStore {
  constructor() {
    this.mapping = /* @__PURE__ */ new Map();
  }
  has(expressionName) {
    return this.mapping.has(this.normalizeExpressionName(expressionName));
  }
  isNameAvailable(expressionName) {
    const normalizedExpressionName = this.normalizeExpressionName(expressionName);
    const namedExpression = this.mapping.get(normalizedExpressionName);
    return !(namedExpression && namedExpression.added);
  }
  add(namedExpression) {
    this.mapping.set(namedExpression.normalizeExpressionName(), namedExpression);
  }
  get(expressionName) {
    return this.mapping.get(this.normalizeExpressionName(expressionName));
  }
  getExisting(expressionName) {
    const namedExpression = this.mapping.get(this.normalizeExpressionName(expressionName));
    if (namedExpression && namedExpression.added) {
      return namedExpression;
    } else {
      return void 0;
    }
  }
  remove(expressionName) {
    const normalizedExpressionName = this.normalizeExpressionName(expressionName);
    const namedExpression = this.mapping.get(normalizedExpressionName);
    if (namedExpression) {
      namedExpression.added = false;
    }
  }
  getAllNamedExpressions() {
    return Array.from(this.mapping.values()).filter((ne) => ne.added);
  }
  normalizeExpressionName(expressionName) {
    return expressionName.toLowerCase();
  }
}
class WorksheetStore {
  constructor() {
    this.mapping = /* @__PURE__ */ new Map();
  }
  add(namedExpression) {
    this.mapping.set(this.normalizeExpressionName(namedExpression.displayName), namedExpression);
  }
  get(expressionName) {
    return this.mapping.get(this.normalizeExpressionName(expressionName));
  }
  has(expressionName) {
    return this.mapping.has(this.normalizeExpressionName(expressionName));
  }
  getAllNamedExpressions() {
    return Array.from(this.mapping.values()).filter((ne) => ne.added);
  }
  isNameAvailable(expressionName) {
    const normalizedExpressionName = this.normalizeExpressionName(expressionName);
    return !this.mapping.has(normalizedExpressionName);
  }
  remove(expressionName) {
    const normalizedExpressionName = this.normalizeExpressionName(expressionName);
    const namedExpression = this.mapping.get(normalizedExpressionName);
    if (namedExpression) {
      this.mapping.delete(normalizedExpressionName);
    }
  }
  normalizeExpressionName(expressionName) {
    return expressionName.toLowerCase();
  }
}
class NamedExpressions {
  constructor() {
    this.nextNamedExpressionRow = 0;
    this.workbookStore = new WorkbookStore();
    this.worksheetStores = /* @__PURE__ */ new Map();
    this.addressCache = /* @__PURE__ */ new Map();
  }
  isNameAvailable(expressionName, sheetId) {
    var _a, _b;
    if (sheetId === void 0) {
      return this.workbookStore.isNameAvailable(expressionName);
    } else {
      return (_b = (_a = this.worksheetStore(sheetId)) === null || _a === void 0 ? void 0 : _a.isNameAvailable(expressionName)) !== null && _b !== void 0 ? _b : true;
    }
  }
  namedExpressionInAddress(row) {
    const namedExpression = this.addressCache.get(row);
    if (namedExpression && namedExpression.added) {
      return namedExpression;
    } else {
      return void 0;
    }
  }
  namedExpressionForScope(expressionName, sheetId) {
    var _a;
    if (sheetId === void 0) {
      return this.workbookStore.getExisting(expressionName);
    } else {
      return (_a = this.worksheetStore(sheetId)) === null || _a === void 0 ? void 0 : _a.get(expressionName);
    }
  }
  nearestNamedExpression(expressionName, sheetId) {
    var _a, _b;
    return (_b = (_a = this.worksheetStore(sheetId)) === null || _a === void 0 ? void 0 : _a.get(expressionName)) !== null && _b !== void 0 ? _b : this.workbookStore.getExisting(expressionName);
  }
  isExpressionInScope(expressionName, sheetId) {
    var _a, _b;
    return (_b = (_a = this.worksheetStore(sheetId)) === null || _a === void 0 ? void 0 : _a.has(expressionName)) !== null && _b !== void 0 ? _b : false;
  }
  /**
   * Checks the validity of a named-expression's name.
   *
   * The name:
   * - Must start with a Unicode letter or with an underscore (`_`).
   * - Can contain only Unicode letters, numbers, underscores, and periods (`.`).
   * - Can't be the same as any possible reference in the A1 notation (`[A-Za-z]+[0-9]+`).
   * - Can't be the same as any possible reference in the R1C1 notation (`[rR][0-9]*[cC][0-9]*`).
   *
   * The naming rules follow the [OpenDocument](https://docs.oasis-open.org/office/OpenDocument/v1.3/os/part4-formula/OpenDocument-v1.3-os-part4-formula.html#__RefHeading__1017964_715980110) standard.
   */
  isNameValid(expressionName) {
    const a1CellRefRegexp = new RegExp(`^${CELL_REFERENCE_PATTERN}$`);
    const r1c1CellRefRegexp = new RegExp(`^${R1C1_CELL_REFERENCE_PATTERN}$`);
    const namedExpRegexp = new RegExp(`^${NAMED_EXPRESSION_PATTERN}$`);
    if (a1CellRefRegexp.test(expressionName) || r1c1CellRefRegexp.test(expressionName)) {
      return false;
    }
    return namedExpRegexp.test(expressionName);
  }
  addNamedExpression(expressionName, sheetId, options) {
    const store = sheetId === void 0 ? this.workbookStore : this.worksheetStoreOrCreate(sheetId);
    let namedExpression = store.get(expressionName);
    if (namedExpression !== void 0) {
      namedExpression.added = true;
      namedExpression.displayName = expressionName;
      namedExpression.options = options;
    } else {
      namedExpression = new InternalNamedExpression(expressionName, this.nextAddress(), true, options);
      store.add(namedExpression);
    }
    this.addressCache.set(namedExpression.address.row, namedExpression);
    return namedExpression;
  }
  restoreNamedExpression(namedExpression, sheetId) {
    const store = sheetId === void 0 ? this.workbookStore : this.worksheetStoreOrCreate(sheetId);
    namedExpression.added = true;
    store.add(namedExpression);
    this.addressCache.set(namedExpression.address.row, namedExpression);
    return namedExpression;
  }
  namedExpressionOrPlaceholder(expressionName, sheetId) {
    var _a;
    return (_a = this.worksheetStoreOrCreate(sheetId).get(expressionName)) !== null && _a !== void 0 ? _a : this.workbookNamedExpressionOrPlaceholder(expressionName);
  }
  workbookNamedExpressionOrPlaceholder(expressionName) {
    let namedExpression = this.workbookStore.get(expressionName);
    if (namedExpression === void 0) {
      namedExpression = new InternalNamedExpression(expressionName, this.nextAddress(), false);
      this.workbookStore.add(namedExpression);
    }
    return namedExpression;
  }
  remove(expressionName, sheetId) {
    let store;
    if (sheetId === void 0) {
      store = this.workbookStore;
    } else {
      store = this.worksheetStore(sheetId);
    }
    const namedExpression = store === null || store === void 0 ? void 0 : store.get(expressionName);
    if (store === void 0 || namedExpression === void 0 || !namedExpression.added) {
      throw Error("Named expression does not exist");
    }
    store.remove(expressionName);
    if (store instanceof WorksheetStore && store.mapping.size === 0) {
      this.worksheetStores.delete(sheetId);
    }
    this.addressCache.delete(namedExpression.address.row);
  }
  getAllNamedExpressionsNamesInScope(sheetId) {
    return this.getAllNamedExpressions().filter(({
      scope
    }) => scope === sheetId).map((ne) => ne.expression.displayName);
  }
  getAllNamedExpressionsNames() {
    return this.getAllNamedExpressions().map((ne) => ne.expression.displayName);
  }
  getAllNamedExpressions() {
    const storedNamedExpressions = [];
    this.workbookStore.getAllNamedExpressions().forEach((expr) => {
      storedNamedExpressions.push({
        expression: expr,
        scope: void 0
      });
    });
    this.worksheetStores.forEach((store, sheetNum) => {
      store.getAllNamedExpressions().forEach((expr) => {
        storedNamedExpressions.push({
          expression: expr,
          scope: sheetNum
        });
      });
    });
    return storedNamedExpressions;
  }
  getAllNamedExpressionsForScope(scope) {
    var _a, _b;
    if (scope === void 0) {
      return this.workbookStore.getAllNamedExpressions();
    } else {
      return (_b = (_a = this.worksheetStores.get(scope)) === null || _a === void 0 ? void 0 : _a.getAllNamedExpressions()) !== null && _b !== void 0 ? _b : [];
    }
  }
  worksheetStoreOrCreate(sheetId) {
    let store = this.worksheetStores.get(sheetId);
    if (!store) {
      store = new WorksheetStore();
      this.worksheetStores.set(sheetId, store);
    }
    return store;
  }
  worksheetStore(sheetId) {
    return this.worksheetStores.get(sheetId);
  }
  nextAddress() {
    return simpleCellAddress(NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS, 0, this.nextNamedExpressionRow++);
  }
}
NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS = -1;
const doesContainRelativeReferences = (ast) => {
  switch (ast.type) {
    case AstNodeType.EMPTY:
    case AstNodeType.NUMBER:
    case AstNodeType.STRING:
    case AstNodeType.ERROR:
    case AstNodeType.ERROR_WITH_RAW_INPUT:
      return false;
    case AstNodeType.CELL_REFERENCE:
      return !ast.reference.isAbsolute();
    case AstNodeType.CELL_RANGE:
    case AstNodeType.COLUMN_RANGE:
    case AstNodeType.ROW_RANGE:
      return !ast.start.isAbsolute();
    case AstNodeType.NAMED_EXPRESSION:
      return false;
    case AstNodeType.PERCENT_OP:
    case AstNodeType.PLUS_UNARY_OP:
    case AstNodeType.MINUS_UNARY_OP: {
      return doesContainRelativeReferences(ast.value);
    }
    case AstNodeType.CONCATENATE_OP:
    case AstNodeType.EQUALS_OP:
    case AstNodeType.NOT_EQUAL_OP:
    case AstNodeType.LESS_THAN_OP:
    case AstNodeType.GREATER_THAN_OP:
    case AstNodeType.LESS_THAN_OR_EQUAL_OP:
    case AstNodeType.GREATER_THAN_OR_EQUAL_OP:
    case AstNodeType.MINUS_OP:
    case AstNodeType.PLUS_OP:
    case AstNodeType.TIMES_OP:
    case AstNodeType.DIV_OP:
    case AstNodeType.POWER_OP:
      return doesContainRelativeReferences(ast.left) || doesContainRelativeReferences(ast.right);
    case AstNodeType.PARENTHESIS:
      return doesContainRelativeReferences(ast.expression);
    case AstNodeType.FUNCTION_CALL: {
      return ast.args.some((arg) => doesContainRelativeReferences(arg));
    }
    case AstNodeType.ARRAY: {
      return ast.args.some((row) => row.some((arg) => doesContainRelativeReferences(arg)));
    }
  }
};
class RowsSpan {
  constructor(sheet, rowStart, rowEnd) {
    this.sheet = sheet;
    this.rowStart = rowStart;
    this.rowEnd = rowEnd;
    if (rowStart < 0) {
      throw Error("Starting row cant be less than 0");
    }
    if (rowEnd < rowStart) {
      throw Error("Row span cant end before start");
    }
  }
  get numberOfRows() {
    return this.rowEnd - this.rowStart + 1;
  }
  get start() {
    return this.rowStart;
  }
  get end() {
    return this.rowEnd;
  }
  static fromNumberOfRows(sheet, rowStart, numberOfRows) {
    return new RowsSpan(sheet, rowStart, rowStart + numberOfRows - 1);
  }
  static fromRowStartAndEnd(sheet, rowStart, rowEnd) {
    return new RowsSpan(sheet, rowStart, rowEnd);
  }
  *rows() {
    for (let col = this.rowStart; col <= this.rowEnd; ++col) {
      yield col;
    }
  }
  intersect(otherSpan) {
    if (this.sheet !== otherSpan.sheet) {
      throw Error("Can't intersect spans from different sheets");
    }
    const start = Math.max(this.rowStart, otherSpan.rowStart);
    const end = Math.min(this.rowEnd, otherSpan.rowEnd);
    if (start > end) {
      return null;
    }
    return new RowsSpan(this.sheet, start, end);
  }
  firstRow() {
    return new RowsSpan(this.sheet, this.rowStart, this.rowStart);
  }
}
class ColumnsSpan {
  constructor(sheet, columnStart, columnEnd) {
    this.sheet = sheet;
    this.columnStart = columnStart;
    this.columnEnd = columnEnd;
    if (columnStart < 0) {
      throw Error("Starting column cant be less than 0");
    }
    if (columnEnd < columnStart) {
      throw Error("Column span cant end before start");
    }
  }
  get numberOfColumns() {
    return this.columnEnd - this.columnStart + 1;
  }
  get start() {
    return this.columnStart;
  }
  get end() {
    return this.columnEnd;
  }
  static fromNumberOfColumns(sheet, columnStart, numberOfColumns) {
    return new ColumnsSpan(sheet, columnStart, columnStart + numberOfColumns - 1);
  }
  static fromColumnStartAndEnd(sheet, columnStart, columnEnd) {
    return new ColumnsSpan(sheet, columnStart, columnEnd);
  }
  *columns() {
    for (let col = this.columnStart; col <= this.columnEnd; ++col) {
      yield col;
    }
  }
  intersect(otherSpan) {
    if (this.sheet !== otherSpan.sheet) {
      throw Error("Can't intersect spans from different sheets");
    }
    const start = Math.max(this.columnStart, otherSpan.columnStart);
    const end = Math.min(this.columnEnd, otherSpan.columnEnd);
    if (start > end) {
      return null;
    }
    return new ColumnsSpan(this.sheet, start, end);
  }
  firstColumn() {
    return new ColumnsSpan(this.sheet, this.columnStart, this.columnStart);
  }
}
var StatType;
(function(StatType2) {
  StatType2["BUILD_ENGINE_TOTAL"] = "BUILD_ENGINE_TOTAL";
  StatType2["PARSER"] = "PARSER";
  StatType2["GRAPH_BUILD"] = "GRAPH_BUILD";
  StatType2["COLLECT_DEPENDENCIES"] = "COLLECT_DEPENDENCIES";
  StatType2["PROCESS_DEPENDENCIES"] = "PROCESS_DEPENDENCIES";
  StatType2["TOP_SORT"] = "TOP_SORT";
  StatType2["BUILD_COLUMN_INDEX"] = "BUILD_COLUMN_INDEX";
  StatType2["EVALUATION"] = "EVALUATION";
  StatType2["VLOOKUP"] = "VLOOKUP";
  StatType2["TRANSFORM_ASTS"] = "TRANSFORM_ASTS";
  StatType2["TRANSFORM_ASTS_POSTPONED"] = "TRANSFORM_ASTS_POSTPONED";
  StatType2["ADJUSTING_ADDRESS_MAPPING"] = "ADJUSTING_ADDRESS_MAPPING";
  StatType2["ADJUSTING_ARRAY_MAPPING"] = "ADJUSTING_ARRAY_MAPPING";
  StatType2["ADJUSTING_RANGES"] = "ADJUSTING_RANGES";
  StatType2["ADJUSTING_GRAPH"] = "ADJUSTING_GRAPH";
  StatType2["CRITERION_FUNCTION_FULL_CACHE_USED"] = "CRITERION_FUNCTION_FULL_CACHE_USED";
  StatType2["CRITERION_FUNCTION_PARTIAL_CACHE_USED"] = "CRITERION_FUNCTION_PARTIAL_CACHE_USED";
})(StatType || (StatType = {}));
class Statistics {
  constructor() {
    this.stats = /* @__PURE__ */ new Map([[StatType.CRITERION_FUNCTION_FULL_CACHE_USED, 0], [StatType.CRITERION_FUNCTION_PARTIAL_CACHE_USED, 0]]);
    this.startTimes = /* @__PURE__ */ new Map();
  }
  incrementCriterionFunctionFullCacheUsed() {
    var _a;
    const newValue = ((_a = this.stats.get(StatType.CRITERION_FUNCTION_FULL_CACHE_USED)) !== null && _a !== void 0 ? _a : 0) + 1;
    this.stats.set(StatType.CRITERION_FUNCTION_FULL_CACHE_USED, newValue);
  }
  incrementCriterionFunctionPartialCacheUsed() {
    var _a;
    const newValue = ((_a = this.stats.get(StatType.CRITERION_FUNCTION_PARTIAL_CACHE_USED)) !== null && _a !== void 0 ? _a : 0) + 1;
    this.stats.set(StatType.CRITERION_FUNCTION_PARTIAL_CACHE_USED, newValue);
  }
  /**
   * Resets statistics
   */
  reset() {
    this.stats.clear();
    this.startTimes.clear();
    this.stats.set(StatType.CRITERION_FUNCTION_FULL_CACHE_USED, 0);
    this.stats.set(StatType.CRITERION_FUNCTION_PARTIAL_CACHE_USED, 0);
  }
  /**
   * Starts tracking particular statistic.
   *
   * @param name - statistic to start tracking
   */
  start(name) {
    if (this.startTimes.get(name)) {
      throw Error(`Statistics ${name} already started`);
    } else {
      this.startTimes.set(name, Date.now());
    }
  }
  /**
   * Stops tracking particular statistic.
   * Raise error if tracking statistic wasn't started.
   *
   * @param name - statistic to stop tracking
   */
  end(name) {
    var _a;
    const now = Date.now();
    const startTime = this.startTimes.get(name);
    if (startTime) {
      let values2 = (_a = this.stats.get(name)) !== null && _a !== void 0 ? _a : 0;
      values2 += now - startTime;
      this.stats.set(name, values2);
      this.startTimes.delete(name);
    } else {
      throw Error(`Statistics ${name} not started`);
    }
  }
  /**
   * Measure given statistic as execution of given function.
   *
   * @param name - statistic to track
   * @param func - function to call
   * @returns result of the function call
   */
  measure(name, func) {
    this.start(name);
    const result = func();
    this.end(name);
    return result;
  }
  /**
   * Returns the snapshot of current results
   */
  snapshot() {
    return new Map(this.stats);
  }
}
class EmptyStatistics extends Statistics {
  /** @inheritDoc */
  incrementCriterionFunctionFullCacheUsed() {
  }
  /** @inheritDoc */
  incrementCriterionFunctionPartialCacheUsed() {
  }
  /** @inheritDoc */
  start(_name) {
  }
  /** @inheritDoc */
  end(_name) {
  }
}
class NoSheetWithIdError extends Error {
  constructor(sheetId) {
    super(`There's no sheet with id = ${sheetId}`);
  }
}
class NoSheetWithNameError extends Error {
  constructor(sheetName) {
    super(`There's no sheet with name '${sheetName}'`);
  }
}
class SheetNameAlreadyTakenError extends Error {
  constructor(sheetName) {
    super(`Sheet with name ${sheetName} already exists`);
  }
}
class SheetSizeLimitExceededError extends Error {
  constructor() {
    super("Sheet size limit exceeded");
  }
}
class NotAFormulaError extends Error {
  constructor() {
    super("This is not a formula");
  }
}
class InvalidAddressError extends Error {
  constructor(address) {
    super(`Address (row = ${address.row}, col = ${address.col}) is invalid`);
  }
}
class InvalidArgumentsError extends Error {
  constructor(expectedArguments) {
    super(`Invalid arguments, expected ${expectedArguments}`);
  }
}
class SheetsNotEqual extends Error {
  constructor(sheet1, sheet2) {
    super(`Sheets ${sheet1} and ${sheet2} are not equal.`);
  }
}
class NamedExpressionNameIsAlreadyTakenError extends Error {
  constructor(expressionName) {
    super(`Name of Named Expression '${expressionName}' is already present`);
  }
}
class NamedExpressionNameIsInvalidError extends Error {
  constructor(expressionName) {
    super(`Name of Named Expression '${expressionName}' is invalid`);
  }
}
class NamedExpressionDoesNotExistError extends Error {
  constructor(expressionName) {
    super(`Named Expression '${expressionName}' does not exist`);
  }
}
class NoOperationToUndoError extends Error {
  constructor() {
    super("There is no operation to undo");
  }
}
class NoOperationToRedoError extends Error {
  constructor() {
    super("There is no operation to redo");
  }
}
class NothingToPasteError extends Error {
  constructor() {
    super("There is nothing to paste");
  }
}
function replacer(key, val) {
  switch (typeof val) {
    case "function":
    case "symbol":
      return val.toString();
    case "bigint":
      return "BigInt(" + val.toString() + ")";
    default: {
      if (val instanceof RegExp) {
        return "RegExp(" + val.toString() + ")";
      } else {
        return val;
      }
    }
  }
}
class UnableToParseError extends Error {
  constructor(value) {
    super(`Unable to parse value: ${JSON.stringify(value, replacer, 4)}`);
  }
}
class ExpectedValueOfTypeError extends Error {
  constructor(expectedType, paramName) {
    super(`Expected value of type: ${expectedType} for config parameter: ${paramName}`);
  }
}
class ConfigValueEmpty extends Error {
  constructor(paramName) {
    super(`Config parameter ${paramName} cannot be empty.`);
  }
}
class ConfigValueTooSmallError extends Error {
  constructor(paramName, minimum) {
    super(`Config parameter ${paramName} should be at least ${minimum}`);
  }
}
class ConfigValueTooBigError extends Error {
  constructor(paramName, maximum) {
    super(`Config parameter ${paramName} should be at most ${maximum}`);
  }
}
class ExpectedOneOfValuesError extends Error {
  constructor(values2, paramName) {
    super(`Expected one of ${values2} for config parameter: ${paramName}`);
  }
}
class EvaluationSuspendedError extends Error {
  constructor() {
    super("Computations are suspended");
  }
}
class MissingTranslationError extends Error {
  constructor(key) {
    super(`Translation for ${key} is missing in the translation package you're using.`);
  }
}
class ProtectedFunctionTranslationError extends Error {
  constructor(key) {
    super(`Cannot register translation for function with id: ${key}`);
  }
}
class LanguageNotRegisteredError extends Error {
  constructor() {
    super("Language not registered.");
  }
}
class LanguageAlreadyRegisteredError extends Error {
  constructor() {
    super("Language already registered.");
  }
}
class FunctionPluginValidationError extends Error {
  static functionNotDeclaredInPlugin(functionId, pluginName) {
    return new FunctionPluginValidationError(`Function with id ${functionId} not declared in plugin ${pluginName}`);
  }
  static functionMethodNotFound(functionName2, pluginName) {
    return new FunctionPluginValidationError(`Function method ${functionName2} not found in plugin ${pluginName}`);
  }
}
class ProtectedFunctionError extends Error {
  static cannotRegisterFunctionWithId(functionId) {
    return new ProtectedFunctionError(`Cannot register function with id ${functionId}`);
  }
  static cannotUnregisterFunctionWithId(functionId) {
    return new ProtectedFunctionError(`Cannot unregister function with id ${functionId}`);
  }
  static cannotUnregisterProtectedPlugin() {
    return new ProtectedFunctionError("Cannot unregister protected plugin");
  }
}
class SourceLocationHasArrayError extends Error {
  constructor() {
    super("Cannot perform this operation, source location has an array inside.");
  }
}
class TargetLocationHasArrayError extends Error {
  constructor() {
    super("Cannot perform this operation, target location has an array inside.");
  }
}
class NoRelativeAddressesAllowedError extends Error {
  constructor() {
    super("Relative addresses not allowed in named expressions.");
  }
}
class AliasAlreadyExisting extends Error {
  constructor(name, pluginName) {
    super(`Alias id ${name} in plugin ${pluginName} already defined as a function or alias.`);
  }
}
class AddressMapping {
  constructor(policy) {
    this.policy = policy;
    this.mapping = /* @__PURE__ */ new Map();
  }
  /**
   * Gets the cell vertex at the specified address.
   */
  getCell(address, options = {}) {
    const sheetMapping = this.mapping.get(address.sheet);
    if (!sheetMapping) {
      if (options.throwIfSheetNotExists) {
        throw new NoSheetWithIdError(address.sheet);
      }
      return void 0;
    }
    const cell = sheetMapping.getCell(address);
    if (!cell && options.throwIfCellNotExists) {
      throw Error("Vertex for address missing in AddressMapping");
    }
    return cell;
  }
  /**
   * Gets the cell vertex at the specified address or throws if it doesn't exist.
   * @throws {NoSheetWithIdError} if sheet doesn't exist
   * @throws {Error} if cell doesn't exist
   */
  getCellOrThrow(address) {
    const sheetMapping = this.mapping.get(address.sheet);
    if (!sheetMapping) {
      throw new NoSheetWithIdError(address.sheet);
    }
    const cell = sheetMapping.getCell(address);
    if (!cell) {
      throw Error("Vertex for address missing in AddressMapping");
    }
    return cell;
  }
  /**
   * Gets the address mapping strategy for the specified sheet.
   * @throws {NoSheetWithIdError} if sheet doesn't exist
   */
  getStrategyForSheetOrThrow(sheetId) {
    const strategy = this.mapping.get(sheetId);
    if (strategy === void 0) {
      throw new NoSheetWithIdError(sheetId);
    }
    return strategy;
  }
  /**
   * Adds a new sheet with the specified strategy.
   * @throws {Error} if sheet is already added and throwIfSheetAlreadyExists is true
   */
  addSheetWithStrategy(sheetId, strategy, options = {
    throwIfSheetAlreadyExists: true
  }) {
    const strategyFound = this.mapping.get(sheetId);
    if (strategyFound) {
      if (options.throwIfSheetAlreadyExists) {
        throw Error("Sheet already added");
      }
      return strategyFound;
    }
    this.mapping.set(sheetId, strategy);
    return strategy;
  }
  /**
   * Adds a sheet or changes the strategy for an existing sheet.
   * Designed for the purpose of exchanging the placeholder strategy for a real strategy.
   */
  addSheetOrChangeStrategy(sheetId, sheetBoundaries) {
    const newStrategy = this.createStrategyBasedOnBoundaries(sheetBoundaries);
    const strategyPlaceholder = this.mapping.get(sheetId);
    if (!strategyPlaceholder) {
      this.mapping.set(sheetId, newStrategy);
      return newStrategy;
    }
    if (newStrategy instanceof DenseStrategy) {
      return strategyPlaceholder;
    }
    this.moveStrategyContent(strategyPlaceholder, newStrategy, sheetId);
    this.mapping.set(sheetId, newStrategy);
    return newStrategy;
  }
  /**
   * Moves the content of the source strategy to the target strategy.
   */
  moveStrategyContent(sourceStrategy, targetStrategy, sheetContext) {
    const sourceVertices = sourceStrategy.getEntries(sheetContext);
    for (const [address, vertex] of sourceVertices) {
      targetStrategy.setCell(address, vertex);
    }
  }
  /**
   * Adds a sheet and sets the strategy based on the sheet boundaries.
   * @throws {Error} if sheet already exists and throwIfSheetAlreadyExists is true
   */
  addSheetAndSetStrategyBasedOnBoundaries(sheetId, sheetBoundaries, options = {
    throwIfSheetAlreadyExists: true
  }) {
    this.addSheetWithStrategy(sheetId, this.createStrategyBasedOnBoundaries(sheetBoundaries), options);
  }
  /**
   * Creates a strategy based on the sheet boundaries.
   */
  createStrategyBasedOnBoundaries(sheetBoundaries) {
    const {
      height,
      width,
      fill
    } = sheetBoundaries;
    const strategyConstructor = this.policy.call(fill);
    return new strategyConstructor(width, height);
  }
  /**
   * Adds a placeholder strategy (DenseStrategy) for a sheet. If the sheet already exists, does nothing.
   */
  addSheetStrategyPlaceholderIfNotExists(sheetId) {
    if (this.mapping.has(sheetId)) {
      return;
    }
    this.mapping.set(sheetId, new DenseStrategy(0, 0));
  }
  /**
   * Removes a sheet from the address mapping.
   * If sheet does not exist, does nothing.
   * @returns {boolean} true if sheet was removed, false if it did not exist.
   */
  removeSheetIfExists(sheetId) {
    return this.mapping.delete(sheetId);
  }
  /**
   * Gets the interpreter value of a cell at the specified address.
   * @returns {InterpreterValue} The interpreter value (returns EmptyValue if cell doesn't exist)
   */
  getCellValue(address) {
    const vertex = this.getCell(address);
    if (vertex === void 0) {
      return EmptyValue;
    } else if (vertex instanceof ArrayFormulaVertex) {
      return vertex.getArrayCellValue(address);
    } else {
      return vertex.getCellValue();
    }
  }
  /**
   * Gets the raw cell content at the specified address.
   * @returns {RawCellContent} The raw cell content or null if cell doesn't exist or is not a value cell
   */
  getRawValue(address) {
    const vertex = this.getCell(address);
    if (vertex instanceof ValueCellVertex) {
      return vertex.getValues().rawValue;
    } else if (vertex instanceof ArrayFormulaVertex) {
      return vertex.getArrayCellRawValue(address);
    } else {
      return null;
    }
  }
  /**
   * Sets a cell vertex at the specified address.
   * @throws {Error} if sheet not initialized
   */
  setCell(address, newVertex) {
    const sheetMapping = this.mapping.get(address.sheet);
    if (!sheetMapping) {
      throw Error("Sheet not initialized");
    }
    sheetMapping.setCell(address, newVertex);
  }
  /**
   * Moves a cell from source address to destination address.
   * Supports cross-sheet moves (used for placeholder sheet merging).
   * @throws {Error} if source sheet not initialized
   * @throws {Error} if destination occupied
   * @throws {Error} if source cell doesn't exist
   */
  moveCell(source, destination) {
    const sheetMapping = this.mapping.get(source.sheet);
    if (!sheetMapping) {
      throw Error("Sheet not initialized.");
    }
    if (this.has(destination)) {
      throw new Error("Cannot move cell. Destination already occupied.");
    }
    const vertex = sheetMapping.getCell(source);
    if (vertex === void 0) {
      throw new Error("Cannot move cell. No cell with such address.");
    }
    this.setCell(destination, vertex);
    this.removeCell(source);
  }
  /**
   * Removes a cell at the specified address.
   * @throws Error if sheet not initialized
   */
  removeCell(address) {
    const sheetMapping = this.mapping.get(address.sheet);
    if (!sheetMapping) {
      throw Error("Sheet not initialized");
    }
    sheetMapping.removeCell(address);
  }
  /**
   * Checks if a cell exists at the specified address.
   */
  has(address) {
    const sheetMapping = this.mapping.get(address.sheet);
    if (sheetMapping === void 0) {
      return false;
    }
    return sheetMapping.has(address);
  }
  /**
   * Gets the height of the specified sheet.
   */
  getSheetHeight(sheetId) {
    const sheetMapping = this.getStrategyForSheetOrThrow(sheetId);
    return sheetMapping.getHeight();
  }
  /**
   * Gets the width of the specified sheet.
   */
  getSheetWidth(sheetId) {
    const sheetMapping = this.getStrategyForSheetOrThrow(sheetId);
    return sheetMapping.getWidth();
  }
  /**
   * Adds rows to a sheet.
   */
  addRows(sheetId, row, numberOfRows) {
    const sheetMapping = this.getStrategyForSheetOrThrow(sheetId);
    sheetMapping.addRows(row, numberOfRows);
  }
  /**
   * Removes rows from a sheet.
   */
  removeRows(removedRows) {
    const sheetMapping = this.getStrategyForSheetOrThrow(removedRows.sheet);
    sheetMapping.removeRows(removedRows);
  }
  /**
   * Adds columns to a sheet starting at the specified column index.
   */
  addColumns(sheetId, column, numberOfColumns) {
    const sheetMapping = this.getStrategyForSheetOrThrow(sheetId);
    sheetMapping.addColumns(column, numberOfColumns);
  }
  /**
   * Removes columns from a sheet.
   */
  removeColumns(removedColumns) {
    const sheetMapping = this.getStrategyForSheetOrThrow(removedColumns.sheet);
    sheetMapping.removeColumns(removedColumns);
  }
  /**
   * Returns an iterator of cell vertices within the specified rows span.
   */
  *verticesFromRowsSpan(rowsSpan) {
    yield* this.mapping.get(rowsSpan.sheet).verticesFromRowsSpan(rowsSpan);
  }
  /**
   * Returns an iterator of cell vertices within the specified columns span.
   */
  *verticesFromColumnsSpan(columnsSpan) {
    yield* this.mapping.get(columnsSpan.sheet).verticesFromColumnsSpan(columnsSpan);
  }
  /**
   * Returns an iterator of address-vertex pairs within the specified rows span.
   */
  *entriesFromRowsSpan(rowsSpan) {
    const sheetMapping = this.getStrategyForSheetOrThrow(rowsSpan.sheet);
    yield* sheetMapping.entriesFromRowsSpan(rowsSpan);
  }
  /**
   * Returns an iterator of address-vertex pairs within the specified columns span.
   */
  *entriesFromColumnsSpan(columnsSpan) {
    const sheetMapping = this.getStrategyForSheetOrThrow(columnsSpan.sheet);
    yield* sheetMapping.entriesFromColumnsSpan(columnsSpan);
  }
  /**
   * Returns an iterator of all address-vertex pairs across all sheets.
   * @returns {IterableIterator<[SimpleCellAddress, Maybe<CellVertex>]>} Iterator of [address, vertex] tuples
   */
  *entries() {
    for (const [sheet, mapping] of this.mapping.entries()) {
      yield* mapping.getEntries(sheet);
    }
  }
  /**
   * Returns an iterator of address-vertex pairs for a specific sheet.
   * @returns {IterableIterator<[SimpleCellAddress, CellVertex]>} Iterator of [address, vertex] tuples
   * @throws {NoSheetWithIdError} if sheet doesn't exist
   */
  *sheetEntries(sheetId) {
    const sheetMapping = this.getStrategyForSheetOrThrow(sheetId);
    yield* sheetMapping.getEntries(sheetId);
  }
  /**
   * Checks if a sheet has any entries.
   * @throws {NoSheetWithIdError} if sheet doesn't exist
   */
  hasAnyEntries(sheetId) {
    const iterator = this.sheetEntries(sheetId);
    return !iterator.next().done;
  }
}
class ArrayMapping {
  constructor() {
    this.arrayMapping = /* @__PURE__ */ new Map();
  }
  getArray(range) {
    const array = this.getArrayByCorner(range.start);
    if (array === null || array === void 0 ? void 0 : array.getRange().sameAs(range)) {
      return array;
    }
    return;
  }
  getArrayByCorner(address) {
    return this.arrayMapping.get(addressKey(address));
  }
  setArray(range, vertex) {
    this.arrayMapping.set(addressKey(range.start), vertex);
  }
  removeArray(range) {
    if (typeof range === "string") {
      this.arrayMapping.delete(range);
    } else {
      this.arrayMapping.delete(addressKey(range.start));
    }
  }
  count() {
    return this.arrayMapping.size;
  }
  *arraysInRows(rowsSpan) {
    for (const [mtxKey, mtx] of this.arrayMapping.entries()) {
      if (mtx.spansThroughSheetRows(rowsSpan.sheet, rowsSpan.rowStart, rowsSpan.rowEnd)) {
        yield [mtxKey, mtx];
      }
    }
  }
  *arraysInCols(col) {
    for (const [mtxKey, mtx] of this.arrayMapping.entries()) {
      if (mtx.spansThroughSheetColumn(col.sheet, col.columnStart, col.columnEnd)) {
        yield [mtxKey, mtx];
      }
    }
  }
  isFormulaArrayInRow(sheet, row) {
    for (const mtx of this.arrayMapping.values()) {
      if (mtx.spansThroughSheetRows(sheet, row)) {
        return true;
      }
    }
    return false;
  }
  isFormulaArrayInAllRows(span) {
    let result = true;
    for (const row of span.rows()) {
      if (!this.isFormulaArrayInRow(span.sheet, row)) {
        result = false;
      }
    }
    return result;
  }
  isFormulaArrayInColumn(sheet, column) {
    for (const mtx of this.arrayMapping.values()) {
      if (mtx.spansThroughSheetColumn(sheet, column)) {
        return true;
      }
    }
    return false;
  }
  isFormulaArrayInAllColumns(span) {
    let result = true;
    for (const col of span.columns()) {
      if (!this.isFormulaArrayInColumn(span.sheet, col)) {
        result = false;
      }
    }
    return result;
  }
  isFormulaArrayInRange(range) {
    for (const mtx of this.arrayMapping.values()) {
      if (mtx.getRange().doesOverlap(range)) {
        return true;
      }
    }
    return false;
  }
  isFormulaArrayAtAddress(address) {
    for (const mtx of this.arrayMapping.values()) {
      if (mtx.getRange().addressInRange(address)) {
        return true;
      }
    }
    return false;
  }
  moveArrayVerticesAfterRowByRows(sheet, row, numberOfRows) {
    this.updateArrayVerticesInSheet(sheet, (key, vertex) => {
      const range = vertex.getRange();
      return row <= range.start.row ? [range.shifted(0, numberOfRows), vertex] : void 0;
    });
  }
  moveArrayVerticesAfterColumnByColumns(sheet, column, numberOfColumns) {
    this.updateArrayVerticesInSheet(sheet, (key, vertex) => {
      const range = vertex.getRange();
      return column <= range.start.col ? [range.shifted(numberOfColumns, 0), vertex] : void 0;
    });
  }
  updateArrayVerticesInSheet(sheet, fn) {
    const updated = Array();
    for (const [key, vertex] of this.arrayMapping.entries()) {
      if (vertex.sheet !== sheet) {
        continue;
      }
      const result = fn(key, vertex);
      if (result !== void 0) {
        this.removeArray(key);
        updated.push(result);
      }
    }
    updated.forEach(([range, array]) => {
      this.setArray(range, array);
    });
  }
}
class NotComputedArray {
  constructor(size) {
    this.size = size;
  }
  width() {
    return this.size.width;
  }
  height() {
    return this.size.height;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  get(col, row) {
    throw Error("Array not computed yet.");
  }
  simpleRangeValue() {
    throw Error("Array not computed yet.");
  }
}
class ArrayValue {
  constructor(array) {
    this.size = new ArraySize(array.length > 0 ? array[0].length : 0, array.length);
    this.array = array;
    if (this.size.width <= 0 || this.size.height <= 0) {
      throw Error("Incorrect array size");
    }
  }
  static fromInterpreterValue(value) {
    if (value instanceof SimpleRangeValue) {
      return new ArrayValue(value.data);
    } else {
      return new ArrayValue([[value]]);
    }
  }
  simpleRangeValue() {
    return SimpleRangeValue.onlyValues(this.array);
  }
  addRows(aboveRow, numberOfRows) {
    this.array.splice(aboveRow, 0, ...this.nullArrays(numberOfRows, this.width()));
    this.size.height += numberOfRows;
  }
  addColumns(aboveColumn, numberOfColumns) {
    for (let i = 0; i < this.height(); i++) {
      this.array[i].splice(aboveColumn, 0, ...new Array(numberOfColumns).fill(EmptyValue));
    }
    this.size.width += numberOfColumns;
  }
  removeRows(startRow, endRow) {
    if (this.outOfBound(0, startRow) || this.outOfBound(0, endRow)) {
      throw Error("Array index out of bound");
    }
    const numberOfRows = endRow - startRow + 1;
    this.array.splice(startRow, numberOfRows);
    this.size.height -= numberOfRows;
  }
  removeColumns(leftmostColumn, rightmostColumn) {
    if (this.outOfBound(leftmostColumn, 0) || this.outOfBound(rightmostColumn, 0)) {
      throw Error("Array index out of bound");
    }
    const numberOfColumns = rightmostColumn - leftmostColumn + 1;
    for (const row of this.array) {
      row.splice(leftmostColumn, numberOfColumns);
    }
    this.size.width -= numberOfColumns;
  }
  nullArrays(count, size) {
    const result = [];
    for (let i = 0; i < count; ++i) {
      result.push(new Array(size).fill(EmptyValue));
    }
    return result;
  }
  get(col, row) {
    if (this.outOfBound(col, row)) {
      throw Error("Array index out of bound");
    }
    return this.array[row][col];
  }
  set(col, row, value) {
    if (this.outOfBound(col, row)) {
      throw Error("Array index out of bound");
    }
    this.array[row][col] = value;
  }
  width() {
    return this.size.width;
  }
  height() {
    return this.size.height;
  }
  raw() {
    return this.array;
  }
  resize(newSize) {
    if (this.height() < newSize.height && isFinite(newSize.height)) {
      this.addRows(this.height(), newSize.height - this.height());
    }
    if (this.height() > newSize.height) {
      throw Error("Resizing to smaller array");
    }
    if (this.width() < newSize.width && isFinite(newSize.width)) {
      this.addColumns(this.width(), newSize.width - this.width());
    }
    if (this.width() > newSize.width) {
      throw Error("Resizing to smaller array");
    }
  }
  outOfBound(col, row) {
    return col < 0 || row < 0 || row > this.size.height - 1 || col > this.size.width - 1;
  }
}
class ErroredArray {
  constructor(error2, size) {
    this.error = error2;
    this.size = size;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  get(col, row) {
    return this.error;
  }
  width() {
    return this.size.width;
  }
  height() {
    return this.size.height;
  }
  simpleRangeValue() {
    return this.error;
  }
}
class Vertex {
}
class CellVertex extends Vertex {
  constructor() {
    super();
  }
}
class FormulaVertex extends CellVertex {
  constructor(formula, cellAddress, version2) {
    super();
    this.formula = formula;
    this.cellAddress = cellAddress;
    this.version = version2;
  }
  get width() {
    return 1;
  }
  get height() {
    return 1;
  }
  static fromAst(formula, address, size, version2) {
    if (size.isScalar()) {
      return new ScalarFormulaVertex(formula, address, version2);
    } else {
      return new ArrayFormulaVertex(formula, address, size, version2);
    }
  }
  /**
   * Returns formula stored in this vertex
   */
  getFormula(updatingService) {
    this.ensureRecentData(updatingService);
    return this.formula;
  }
  ensureRecentData(updatingService) {
    if (this.version != updatingService.version()) {
      const [newAst, newAddress, newVersion] = updatingService.applyTransformations(this.formula, this.cellAddress, this.version);
      this.formula = newAst;
      this.cellAddress = newAddress;
      this.version = newVersion;
    }
  }
  /**
   * Returns address of the cell associated with vertex
   */
  getAddress(updatingService) {
    this.ensureRecentData(updatingService);
    return this.cellAddress;
  }
}
class ArrayFormulaVertex extends FormulaVertex {
  constructor(formula, cellAddress, size, version2 = 0) {
    super(formula, cellAddress, version2);
    if (size.isRef) {
      this.array = new ErroredArray(new CellError(ErrorType.REF, ErrorMessage.NoSpaceForArrayResult), ArraySize.error());
    } else {
      this.array = new NotComputedArray(size);
    }
  }
  get width() {
    return this.array.width();
  }
  get height() {
    return this.array.height();
  }
  get sheet() {
    return this.cellAddress.sheet;
  }
  get leftCorner() {
    return this.cellAddress;
  }
  setCellValue(value) {
    if (value instanceof CellError) {
      this.setErrorValue(value);
      return value;
    }
    const array = ArrayValue.fromInterpreterValue(value);
    array.resize(this.array.size);
    this.array = array;
    return value;
  }
  getCellValue() {
    if (this.array instanceof NotComputedArray) {
      throw Error("Array not computed yet.");
    }
    return this.array.simpleRangeValue();
  }
  valueOrUndef() {
    if (this.array instanceof NotComputedArray) {
      return void 0;
    }
    return this.array.simpleRangeValue();
  }
  getArrayCellValue(address) {
    const col = address.col - this.cellAddress.col;
    const row = address.row - this.cellAddress.row;
    try {
      return this.array.get(col, row);
    } catch (e) {
      return new CellError(ErrorType.REF);
    }
  }
  getArrayCellRawValue(address) {
    const val = this.getArrayCellValue(address);
    if (val instanceof CellError || val === EmptyValue) {
      return void 0;
    } else {
      return getRawValue(val);
    }
  }
  setArrayCellValue(address, value) {
    const col = address.col - this.cellAddress.col;
    const row = address.row - this.cellAddress.row;
    if (this.array instanceof ArrayValue) {
      this.array.set(col, row, value);
    }
  }
  setNoSpace() {
    this.array = new ErroredArray(new CellError(ErrorType.SPILL, ErrorMessage.NoSpaceForArrayResult), ArraySize.error());
    return this.getCellValue();
  }
  getRange() {
    return AbsoluteCellRange.spanFrom(this.cellAddress, this.width, this.height);
  }
  getRangeOrUndef() {
    return AbsoluteCellRange.spanFromOrUndef(this.cellAddress, this.width, this.height);
  }
  setAddress(address) {
    this.cellAddress = address;
  }
  setFormula(newFormula) {
    this.formula = newFormula;
  }
  spansThroughSheetRows(sheet, startRow, endRow = startRow) {
    return this.cellAddress.sheet === sheet && this.cellAddress.row <= endRow && startRow < this.cellAddress.row + this.height;
  }
  spansThroughSheetColumn(sheet, col, columnEnd = col) {
    return this.cellAddress.sheet === sheet && this.cellAddress.col <= columnEnd && col < this.cellAddress.col + this.width;
  }
  isComputed() {
    return !(this.array instanceof NotComputedArray);
  }
  columnsFromArray() {
    return ColumnsSpan.fromNumberOfColumns(this.cellAddress.sheet, this.cellAddress.col, this.width);
  }
  rowsFromArray() {
    return RowsSpan.fromNumberOfRows(this.cellAddress.sheet, this.cellAddress.row, this.height);
  }
  /**
   * No-op as array vertices are transformed eagerly.
   */
  ensureRecentData(_updatingService) {
  }
  isLeftCorner(address) {
    return equalSimpleCellAddress(this.cellAddress, address);
  }
  setErrorValue(error2) {
    this.array = new ErroredArray(error2, this.array.size);
  }
}
class ScalarFormulaVertex extends FormulaVertex {
  constructor(formula, address, version2) {
    super(formula, address, version2);
  }
  valueOrUndef() {
    return this.cachedCellValue;
  }
  /**
   * Sets computed cell value stored in this vertex
   */
  setCellValue(cellValue) {
    this.cachedCellValue = cellValue;
    return this.cachedCellValue;
  }
  /**
   * Returns cell value stored in vertex
   */
  getCellValue() {
    if (this.cachedCellValue !== void 0) {
      return this.cachedCellValue;
    } else {
      throw Error("Value of the formula cell is not computed.");
    }
  }
  isComputed() {
    return this.cachedCellValue !== void 0;
  }
}
class RangeVertex extends Vertex {
  constructor(range) {
    super();
    this.range = range;
    this.functionCache = /* @__PURE__ */ new Map();
    this.criterionFunctionCache = /* @__PURE__ */ new Map();
    this.dependentCacheRanges = /* @__PURE__ */ new Set();
    this.bruteForce = false;
  }
  get start() {
    return this.range.start;
  }
  get end() {
    return this.range.end;
  }
  get sheet() {
    return this.range.start.sheet;
  }
  /**
   * Returns cached value stored for given function
   *
   * @param functionName - name of the function
   */
  getFunctionValue(functionName2) {
    return this.functionCache.get(functionName2);
  }
  /**
   * Stores cached value for given function
   *
   * @param functionName - name of the function
   * @param value - cached value
   */
  setFunctionValue(functionName2, value) {
    this.functionCache.set(functionName2, value);
  }
  /**
   * Returns cached value for given cache key and criterion text representation
   *
   * @param cacheKey - key to retrieve from the cache
   * @param criterionString - criterion text (ex. '<=5')
   */
  getCriterionFunctionValue(cacheKey, criterionString) {
    var _a;
    return (_a = this.getCriterionFunctionValues(cacheKey).get(criterionString)) === null || _a === void 0 ? void 0 : _a[0];
  }
  /**
   * Returns all cached values stored for given criterion function
   *
   * @param cacheKey - key to retrieve from the cache
   */
  getCriterionFunctionValues(cacheKey) {
    var _a;
    return (_a = this.criterionFunctionCache.get(cacheKey)) !== null && _a !== void 0 ? _a : /* @__PURE__ */ new Map();
  }
  /**
   * Stores all values for given criterion function
   *
   * @param cacheKey - key to store in the cache
   * @param values - map with values
   */
  setCriterionFunctionValues(cacheKey, values2) {
    this.criterionFunctionCache.set(cacheKey, values2);
  }
  addDependentCacheRange(dependentRange) {
    if (dependentRange !== this) {
      this.dependentCacheRanges.add(dependentRange);
    }
  }
  /**
   * Clears function cache
   */
  clearCache() {
    this.functionCache.clear();
    this.criterionFunctionCache.clear();
    this.dependentCacheRanges.forEach((range) => range.criterionFunctionCache.clear());
    this.dependentCacheRanges.clear();
  }
}
const collectAddressesDependentToRange = (functionRegistry, vertex, range, lazilyTransformingAstService, dependencyGraph) => {
  if (vertex instanceof RangeVertex) {
    const intersection = vertex.range.intersectionWith(range);
    if (intersection !== void 0) {
      return Array.from(intersection.addresses(dependencyGraph));
    } else {
      return [];
    }
  }
  let formula;
  let address;
  if (vertex instanceof FormulaVertex) {
    formula = vertex.getFormula(lazilyTransformingAstService);
    address = vertex.getAddress(lazilyTransformingAstService);
  } else {
    return [];
  }
  return collectDependencies(formula, functionRegistry).filter((d) => d instanceof AddressDependency).map((d) => d.dependency.toSimpleCellAddress(address)).filter((d) => range.addressInRange(d));
};
var NodeVisitStatus;
(function(NodeVisitStatus2) {
  NodeVisitStatus2[NodeVisitStatus2["ON_STACK"] = 0] = "ON_STACK";
  NodeVisitStatus2[NodeVisitStatus2["PROCESSED"] = 1] = "PROCESSED";
  NodeVisitStatus2[NodeVisitStatus2["POPPED"] = 2] = "POPPED";
})(NodeVisitStatus || (NodeVisitStatus = {}));
class TopSort {
  constructor(nodesSparseArray = [], edgesSparseArray = []) {
    this.nodesSparseArray = nodesSparseArray;
    this.edgesSparseArray = edgesSparseArray;
    this.entranceTime = [];
    this.low = [];
    this.parent = [];
    this.inSCC = [];
    this.nodeStatus = [];
    this.order = [];
    this.sccNonSingletons = [];
    this.timeCounter = 0;
  }
  /**
   * An iterative implementation of Tarjan's algorithm for finding strongly connected components.
   * Returns vertices in order of topological sort, but vertices that are on cycles are kept separate.
   *
   * @param modifiedNodes - seed for computation. During engine init run, all of the vertices of grap. In recomputation run, changed vertices.
   * @param operatingFunction - recomputes value of a node, and returns whether a change occurred
   * @param onCycle - action to be performed when node is on cycle
   */
  getTopSortedWithSccSubgraphFrom(modifiedNodeIds, operatingFunction, onCycle) {
    const modifiedNodeIdsReversed = modifiedNodeIds.reverse();
    modifiedNodeIdsReversed.forEach((id) => this.runDFS(id));
    return this.postprocess(modifiedNodeIdsReversed, onCycle, operatingFunction);
  }
  /**
   * Returns adjacent nodes of a given node.
   */
  getAdjacentNodeIds(id) {
    return this.edgesSparseArray[id].filter((adjacentId) => adjacentId !== void 0 && this.nodesSparseArray[adjacentId]);
  }
  /**
   * Runs DFS starting from a given node.
   */
  runDFS(v) {
    if (this.nodeStatus[v] !== void 0) {
      return;
    }
    this.nodeStatus[v] = NodeVisitStatus.ON_STACK;
    const DFSstack = [v];
    const SCCstack = [];
    while (DFSstack.length > 0) {
      const u = DFSstack[DFSstack.length - 1];
      switch (this.nodeStatus[u]) {
        case NodeVisitStatus.ON_STACK: {
          this.handleOnStack(u, SCCstack, DFSstack);
          break;
        }
        case NodeVisitStatus.PROCESSED: {
          this.handleProcessed(u, SCCstack, DFSstack);
          break;
        }
        case NodeVisitStatus.POPPED: {
          DFSstack.pop();
          break;
        }
      }
    }
  }
  /**
   * Handles a node that is on stack.
   */
  handleOnStack(u, SCCstack, DFSstack) {
    this.entranceTime[u] = this.timeCounter;
    this.low[u] = this.timeCounter;
    this.timeCounter++;
    SCCstack.push(u);
    this.getAdjacentNodeIds(u).forEach((t) => {
      if (this.entranceTime[t] === void 0) {
        DFSstack.push(t);
        this.parent[t] = u;
        this.nodeStatus[t] = NodeVisitStatus.ON_STACK;
      }
    });
    this.nodeStatus[u] = NodeVisitStatus.PROCESSED;
  }
  /**
   * Handles a node that is already processed.
   */
  handleProcessed(u, SCCstack, DFSstack) {
    let uLow = this.entranceTime[u];
    this.getAdjacentNodeIds(u).forEach((t) => {
      if (this.inSCC[t]) {
        return;
      }
      uLow = this.parent[t] === u ? Math.min(uLow, this.low[t]) : Math.min(uLow, this.entranceTime[t]);
    });
    this.low[u] = uLow;
    if (uLow === this.entranceTime[u]) {
      const currentSCC = [];
      do {
        currentSCC.push(SCCstack[SCCstack.length - 1]);
        SCCstack.pop();
      } while (currentSCC[currentSCC.length - 1] !== u);
      currentSCC.forEach((t) => {
        this.inSCC[t] = true;
      });
      this.order.push(...currentSCC);
      if (currentSCC.length > 1) {
        currentSCC.forEach((t) => {
          this.sccNonSingletons[t] = true;
        });
      }
    }
    DFSstack.pop();
    this.nodeStatus[u] = NodeVisitStatus.POPPED;
  }
  /**
   * Postprocesses the result of Tarjan's algorithm.
   */
  postprocess(modifiedNodeIds, onCycle, operatingFunction) {
    const shouldBeUpdatedMapping = [];
    modifiedNodeIds.forEach((t) => {
      shouldBeUpdatedMapping[t] = true;
    });
    const sorted = [];
    const cycled = [];
    this.order.reverse();
    this.order.forEach((t) => {
      const adjacentNodes = this.getAdjacentNodeIds(t);
      if (this.sccNonSingletons[t] || adjacentNodes.includes(t)) {
        cycled.push(this.nodesSparseArray[t]);
        onCycle(this.nodesSparseArray[t]);
        adjacentNodes.forEach((s) => shouldBeUpdatedMapping[s] = true);
      } else {
        sorted.push(this.nodesSparseArray[t]);
        if (shouldBeUpdatedMapping[t] && operatingFunction(this.nodesSparseArray[t])) {
          adjacentNodes.forEach((s) => shouldBeUpdatedMapping[s] = true);
        }
      }
    });
    return {
      sorted,
      cycled
    };
  }
}
class ProcessableValue {
  constructor(rawValue, processFn) {
    this.rawValue = rawValue;
    this.processFn = processFn;
    this.processedValue = null;
  }
  getProcessedValue() {
    if (this.processedValue === null) {
      this.processedValue = this.processFn(this.rawValue);
    }
    return this.processedValue;
  }
  markAsModified() {
    this.processedValue = null;
  }
}
class Graph {
  constructor(dependencyQuery) {
    this.dependencyQuery = dependencyQuery;
    this.nodesSparseArray = [];
    this.edgesSparseArray = [];
    this.dirtyAndVolatileNodeIds = new ProcessableValue({
      dirty: [],
      volatile: []
    }, (r) => this.processDirtyAndVolatileNodeIds(r));
    this.infiniteRangeIds = /* @__PURE__ */ new Set();
    this.changingWithStructureNodeIds = [];
    this.nextId = 0;
  }
  /**
   * Iterate over all nodes the in graph
   */
  getNodes() {
    return this.nodesSparseArray.filter((node) => node !== void 0);
  }
  /**
   * Checks whether a node is present in graph
   *
   * @param {Node} node - node to check
   */
  hasNode(node) {
    return node.idInGraph != null;
  }
  /**
   * Checks whether exists edge between nodes. If one or both of nodes are not present in graph, returns false.
   *
   * @param {Node} fromNode - node from which edge is outcoming
   * @param {Node} toNode - node to which edge is incoming
   */
  existsEdge(fromNode, toNode) {
    const fromId = fromNode.idInGraph;
    const toId = toNode.idInGraph;
    if (fromId === void 0 || toId === void 0) {
      return false;
    }
    return this.edgesSparseArray[fromId].includes(toId);
  }
  /**
   * Returns nodes adjacent to given node. May contain removed nodes.
   *
   * @param {Node} node - node to which adjacent nodes we want to retrieve
   *
   * Idea for performance improvement:
   * - return an array instead of set
   */
  adjacentNodes(node) {
    const nodeId = node.idInGraph;
    if (nodeId === void 0) {
      throw this.missingNodeError(node);
    }
    return new Set(this.edgesSparseArray[nodeId].filter((id) => id !== void 0).map((id) => this.nodesSparseArray[id]).filter((node2) => node2 !== void 0));
  }
  /**
   * Returns number of nodes adjacent to given node. Contrary to adjacentNodes(), this method returns only nodes that are present in graph.
   *
   * @param {Node} node - node to which adjacent nodes we want to retrieve
   */
  adjacentNodesCount(node) {
    const id = node.idInGraph;
    if (id === void 0) {
      throw this.missingNodeError(node);
    }
    return this.fixEdgesArrayForNode(id).length;
  }
  /**
   * Adds node to a graph if it does not exist yet.
   *
   * @param {Node} node - a node to be added
   * @returns {NodeId} - the id of the added node
   */
  addNodeIfNotExists(node) {
    const idOfExistingNode = node.idInGraph;
    if (idOfExistingNode !== void 0) {
      return idOfExistingNode;
    }
    const newId = this.nextId;
    this.nextId++;
    this.nodesSparseArray[newId] = node;
    this.edgesSparseArray[newId] = [];
    node.idInGraph = newId;
    return newId;
  }
  /**
   * Adds edge between nodes.
   *
   * The nodes had to be added to the graph before, or the error will be raised
   *
   * @param {Node | NodeId} fromNode - node from which edge is outcoming
   * @param {Node | NodeId} toNode - node to which edge is incoming
   */
  addEdge(fromNode, toNode) {
    const fromId = this.getNodeIdIfNotNumber(fromNode);
    const toId = this.getNodeIdIfNotNumber(toNode);
    if (fromId === void 0) {
      throw this.missingNodeError(fromNode);
    }
    if (toId === void 0) {
      throw this.missingNodeError(toNode);
    }
    if (this.edgesSparseArray[fromId].includes(toId)) {
      return;
    }
    this.edgesSparseArray[fromId].push(toId);
  }
  /**
   * Removes node from graph
   */
  removeNode(node) {
    const id = node.idInGraph;
    if (id === void 0) {
      throw this.missingNodeError(node);
    }
    if (this.edgesSparseArray[id].length > 0) {
      this.edgesSparseArray[id].forEach((adjacentId) => this.dirtyAndVolatileNodeIds.rawValue.dirty.push(adjacentId));
      this.dirtyAndVolatileNodeIds.markAsModified();
    }
    const dependencies = this.removeDependencies(node);
    delete this.nodesSparseArray[id];
    delete this.edgesSparseArray[id];
    this.infiniteRangeIds.delete(id);
    node.idInGraph = void 0;
    return dependencies;
  }
  /**
   * Removes edge between nodes.
   */
  removeEdge(fromNode, toNode) {
    const fromId = this.getNodeIdIfNotNumber(fromNode);
    const toId = this.getNodeIdIfNotNumber(toNode);
    if (fromId === void 0) {
      throw this.missingNodeError(fromNode);
    }
    if (toId === void 0) {
      throw this.missingNodeError(toNode);
    }
    const indexOfToId = this.edgesSparseArray[fromId].indexOf(toId);
    if (indexOfToId === -1) {
      throw new Error("Edge does not exist");
    }
    delete this.edgesSparseArray[fromId][indexOfToId];
  }
  /**
   * Removes edge between nodes if it exists.
   */
  removeEdgeIfExists(fromNode, toNode) {
    const fromId = this.getNodeIdIfNotNumber(fromNode);
    const toId = this.getNodeIdIfNotNumber(toNode);
    if (fromId === void 0) {
      return;
    }
    if (toId === void 0) {
      return;
    }
    const indexOfToId = this.edgesSparseArray[fromId].indexOf(toId);
    if (indexOfToId === -1) {
      return;
    }
    delete this.edgesSparseArray[fromId][indexOfToId];
  }
  /**
   * Sorts the whole graph topologically. Nodes that are on cycles are kept separate.
   */
  topSortWithScc() {
    return this.getTopSortedWithSccSubgraphFrom(this.getNodes(), () => true, () => {
    });
  }
  /**
   * Sorts the graph topologically. Nodes that are on cycles are kept separate.
   *
   * @param {Node[]} modifiedNodes - seed for computation. The algorithm assumes that only these nodes have changed since the last run.
   * @param {(node: Node) => boolean} operatingFunction - recomputes value of a node, and returns whether a change occurred
   * @param {(node: Node) => void} onCycle - action to be performed when node is on cycle
   */
  getTopSortedWithSccSubgraphFrom(modifiedNodes, operatingFunction, onCycle) {
    const topSortAlgorithm = new TopSort(this.nodesSparseArray, this.edgesSparseArray);
    const modifiedNodesIds = modifiedNodes.map((node) => node.idInGraph).filter((id) => id !== void 0);
    return topSortAlgorithm.getTopSortedWithSccSubgraphFrom(modifiedNodesIds, operatingFunction, onCycle);
  }
  /**
   * Marks node as volatile.
   */
  markNodeAsVolatile(node) {
    const id = node.idInGraph;
    if (id === void 0) {
      return;
    }
    this.dirtyAndVolatileNodeIds.rawValue.volatile.push(id);
    this.dirtyAndVolatileNodeIds.markAsModified();
  }
  /**
   * Marks node as dirty.
   */
  markNodeAsDirty(node) {
    const id = node.idInGraph;
    if (id === void 0) {
      return;
    }
    this.dirtyAndVolatileNodeIds.rawValue.dirty.push(id);
    this.dirtyAndVolatileNodeIds.markAsModified();
  }
  /**
   * Returns an array of nodes that are marked as dirty and/or volatile.
   */
  getDirtyAndVolatileNodes() {
    return this.dirtyAndVolatileNodeIds.getProcessedValue();
  }
  /**
   * Clears dirty nodes.
   */
  clearDirtyNodes() {
    this.dirtyAndVolatileNodeIds.rawValue.dirty = [];
    this.dirtyAndVolatileNodeIds.markAsModified();
  }
  /**
   * Marks node as changingWithStructure.
   */
  markNodeAsChangingWithStructure(node) {
    const id = node.idInGraph;
    if (id === void 0) {
      return;
    }
    this.changingWithStructureNodeIds.push(id);
  }
  /**
   * Marks all nodes marked as changingWithStructure as dirty.
   */
  markChangingWithStructureNodesAsDirty() {
    if (this.changingWithStructureNodeIds.length <= 0) {
      return;
    }
    this.dirtyAndVolatileNodeIds.rawValue.dirty = [...this.dirtyAndVolatileNodeIds.rawValue.dirty, ...this.changingWithStructureNodeIds];
    this.dirtyAndVolatileNodeIds.markAsModified();
  }
  /**
   * Marks node as infinite range.
   */
  markNodeAsInfiniteRange(node) {
    const id = this.getNodeIdIfNotNumber(node);
    if (id === void 0) {
      return;
    }
    this.infiniteRangeIds.add(id);
  }
  /**
   * Returns an array of nodes marked as infinite ranges
   */
  getInfiniteRanges() {
    return [...this.infiniteRangeIds].map((id) => this.nodesSparseArray[id]);
  }
  /**
   *
   */
  getNodeIdIfNotNumber(node) {
    return typeof node === "number" ? node : node.idInGraph;
  }
  /**
   * Removes invalid neighbors of a given node from the edges array and returns adjacent nodes for the input node.
   */
  fixEdgesArrayForNode(id) {
    const adjacentNodeIds = this.edgesSparseArray[id];
    this.edgesSparseArray[id] = adjacentNodeIds.filter((adjacentId) => adjacentId !== void 0 && this.nodesSparseArray[adjacentId]);
    return this.edgesSparseArray[id];
  }
  /**
   * Removes edges from the given node to its dependencies based on the dependencyQuery function.
   */
  removeDependencies(node) {
    const dependencies = this.dependencyQuery(node);
    dependencies.forEach(([_, dependency]) => {
      this.removeEdgeIfExists(dependency, node);
    });
    return dependencies;
  }
  /**
   * processFn for dirtyAndVolatileNodeIds ProcessableValue instance
   * @private
   */
  processDirtyAndVolatileNodeIds({
    dirty,
    volatile
  }) {
    return [.../* @__PURE__ */ new Set([...dirty, ...volatile])].map((id) => this.nodesSparseArray[id]).filter((node) => node !== void 0);
  }
  /**
   * Returns error for missing node.
   */
  missingNodeError(node) {
    return new Error(`Unknown node ${JSON.stringify(node)}`);
  }
}
class RangeMapping {
  constructor() {
    this.rangeMapping = /* @__PURE__ */ new Map();
  }
  /**
   * Returns number of ranges in the sheet or 0 if the sheet does not exist
   */
  getNumberOfRangesInSheet(sheet) {
    var _a, _b;
    return (_b = (_a = this.rangeMapping.get(sheet)) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0;
  }
  /**
   * Adds or updates vertex in the mapping
   */
  addOrUpdateVertex(vertex) {
    let sheetMap = this.rangeMapping.get(vertex.sheet);
    if (sheetMap === void 0) {
      sheetMap = /* @__PURE__ */ new Map();
      this.rangeMapping.set(vertex.sheet, sheetMap);
    }
    const key = RangeMapping.calculateRangeKey(vertex.start, vertex.end);
    sheetMap.set(key, vertex);
  }
  /**
   * Removes vertex from the mapping if it exists
   */
  removeVertexIfExists(vertex) {
    const sheet = vertex.sheet;
    const sheetMap = this.rangeMapping.get(sheet);
    if (sheetMap === void 0) {
      return;
    }
    const key = RangeMapping.calculateRangeKey(vertex.start, vertex.end);
    sheetMap.delete(key);
    if (sheetMap.size === 0) {
      this.rangeMapping.delete(sheet);
    }
  }
  /**
   * Returns associated vertex for given range
   */
  getRangeVertex(start, end) {
    const sheetMap = this.rangeMapping.get(start.sheet);
    const key = RangeMapping.calculateRangeKey(start, end);
    return sheetMap === null || sheetMap === void 0 ? void 0 : sheetMap.get(key);
  }
  /**
   * Returns associated vertex for given range or throws an error if not found
   */
  getVertexOrThrow(start, end) {
    const maybeRange = this.getRangeVertex(start, end);
    if (!maybeRange) {
      throw Error("Range does not exist");
    }
    return maybeRange;
  }
  truncateRanges(span, coordinate) {
    const verticesToRemove = Array();
    const updated = Array();
    const verticesWithChangedSize = Array();
    const sheet = span.sheet;
    for (const [key, vertex] of this.entriesFromSheet(span.sheet)) {
      const range = vertex.range;
      if (span.start <= coordinate(vertex.range.end)) {
        range.removeSpan(span);
        if (range.shouldBeRemoved()) {
          this.removeByKey(sheet, key);
          verticesToRemove.push(vertex);
        } else {
          updated.push([key, vertex]);
        }
        verticesWithChangedSize.push(vertex);
      }
    }
    const verticesToMerge = [];
    updated.sort((left2, right2) => RangeMapping.compareBy(left2[1], right2[1], coordinate));
    for (const [oldKey, vertex] of updated) {
      const newKey = RangeMapping.calculateRangeKey(vertex.range.start, vertex.range.end);
      if (newKey === oldKey) {
        continue;
      }
      const existingVertex = this.getByKey(sheet, newKey);
      this.removeByKey(sheet, oldKey);
      if (existingVertex !== void 0 && vertex != existingVertex) {
        verticesToMerge.push([existingVertex, vertex]);
      } else {
        this.addOrUpdateVertex(vertex);
      }
    }
    return {
      verticesToRemove,
      verticesToMerge,
      verticesWithChangedSize
    };
  }
  moveAllRangesInSheetAfterAddingRows(sheet, row, numberOfRows) {
    return this.updateVerticesFromSheet(sheet, (key, vertex) => {
      if (row <= vertex.start.row) {
        vertex.range.shiftByRows(numberOfRows);
        return {
          changedSize: false,
          vertex
        };
      } else if (row > vertex.start.row && row <= vertex.end.row) {
        vertex.range.expandByRows(numberOfRows);
        return {
          changedSize: true,
          vertex
        };
      } else {
        return void 0;
      }
    });
  }
  moveAllRangesInSheetAfterAddingColumns(sheet, column, numberOfColumns) {
    return this.updateVerticesFromSheet(sheet, (key, vertex) => {
      if (column <= vertex.start.col) {
        vertex.range.shiftByColumns(numberOfColumns);
        return {
          changedSize: false,
          vertex
        };
      } else if (column > vertex.start.col && column <= vertex.end.col) {
        vertex.range.expandByColumns(numberOfColumns);
        return {
          changedSize: true,
          vertex
        };
      } else {
        return void 0;
      }
    });
  }
  moveRangesInsideSourceRange(sourceRange, toRight, toBottom, toSheet) {
    this.updateVerticesFromSheet(sourceRange.sheet, (key, vertex) => {
      if (sourceRange.containsRange(vertex.range)) {
        vertex.range.shiftByColumns(toRight);
        vertex.range.shiftByRows(toBottom);
        vertex.range.moveToSheet(toSheet);
        return {
          changedSize: false,
          vertex
        };
      } else {
        return void 0;
      }
    });
  }
  *rangesInSheet(sheet) {
    const sheetMap = this.rangeMapping.get(sheet);
    if (!sheetMap) {
      return;
    }
    yield* sheetMap.values();
  }
  *rangeVerticesContainedInRange(sourceRange) {
    for (const rangeVertex of this.rangesInSheet(sourceRange.sheet)) {
      if (sourceRange.containsRange(rangeVertex.range)) {
        yield rangeVertex;
      }
    }
  }
  /**
   * Finds smaller range if exists.
   */
  findSmallerRange(range) {
    if (range.height() > 1 && Number.isFinite(range.height())) {
      const valuesRangeEndRowLess = simpleCellAddress(range.end.sheet, range.end.col, range.end.row - 1);
      const rowLessVertex = this.getRangeVertex(range.start, valuesRangeEndRowLess);
      if (rowLessVertex !== void 0) {
        const restRange = AbsoluteCellRange.fromSimpleCellAddresses(simpleCellAddress(range.start.sheet, range.start.col, range.end.row), range.end);
        return {
          smallerRangeVertex: rowLessVertex,
          restRange
        };
      }
    }
    return {
      restRange: range
    };
  }
  /**
   * Calculates a string key from start and end addresses
   */
  static calculateRangeKey(start, end) {
    return `${start.col},${start.row},${end.col},${end.row}`;
  }
  /**
   * Compares two range vertices by their start and end addresses using the provided coordinate function
   */
  static compareBy(left2, right2, coordinate) {
    const leftStart = coordinate(left2.range.start);
    const rightStart = coordinate(right2.range.start);
    if (leftStart === rightStart) {
      const leftEnd = coordinate(left2.range.end);
      const rightEnd = coordinate(right2.range.end);
      return leftEnd - rightEnd;
    } else {
      return leftStart - rightStart;
    }
  }
  *entriesFromSheet(sheet) {
    const sheetMap = this.rangeMapping.get(sheet);
    if (!sheetMap) {
      return;
    }
    yield* sheetMap.entries();
  }
  removeByKey(sheet, key) {
    const sheetMap = this.rangeMapping.get(sheet);
    if (!sheetMap) {
      throw new Error(`Sheet ${sheet} not found`);
    }
    sheetMap.delete(key);
  }
  getByKey(sheet, key) {
    var _a;
    return (_a = this.rangeMapping.get(sheet)) === null || _a === void 0 ? void 0 : _a.get(key);
  }
  updateVerticesFromSheet(sheet, fn) {
    const updated = Array();
    for (const [key, vertex] of this.entriesFromSheet(sheet)) {
      const result = fn(key, vertex);
      if (result !== void 0) {
        this.removeByKey(sheet, key);
        updated.push(result);
      }
    }
    updated.forEach((entry) => {
      this.addOrUpdateVertex(entry.vertex);
    });
    return {
      verticesWithChangedSize: updated.filter((entry) => entry.changedSize).map((entry) => entry.vertex)
    };
  }
}
class TranslationPackage {
  constructor(functions, errors, ui) {
    this.functions = functions;
    this.errors = errors;
    this.ui = ui;
    this._protectedTranslations = {
      "VERSION": "VERSION"
    };
    this.checkUI();
    this.checkErrors();
    this.checkFunctionTranslations(this.functions);
    Object.assign(this.functions, this._protectedTranslations);
  }
  extendFunctions(additionalFunctionTranslations) {
    this.checkFunctionTranslations(additionalFunctionTranslations);
    Object.assign(this.functions, additionalFunctionTranslations);
  }
  buildFunctionMapping() {
    return Object.keys(this.functions).reduce((ret, key) => {
      ret[this.functions[key]] = key;
      return ret;
    }, {});
  }
  buildErrorMapping() {
    return Object.keys(this.errors).reduce((ret, key) => {
      ret[this.errors[key]] = key;
      return ret;
    }, {});
  }
  isFunctionTranslated(key) {
    return this.functions[key] !== void 0;
  }
  getFunctionTranslations(functionIds) {
    const translations = [];
    for (const functionId of functionIds) {
      if (this.isFunctionTranslated(functionId)) {
        translations.push(this.functions[functionId]);
      }
    }
    return translations;
  }
  getFunctionTranslation(key) {
    const val = this.functions[key];
    if (val === void 0) {
      throw new MissingTranslationError(`functions.${key}`);
    } else {
      return val;
    }
  }
  getMaybeFunctionTranslation(key) {
    return this.functions[key];
  }
  getErrorTranslation(key) {
    if (key === ErrorType.LIC) {
      return `#${ErrorType.LIC}!`;
    }
    const val = this.errors[key];
    if (val === void 0) {
      throw new MissingTranslationError(`errors.${key}`);
    } else {
      return val;
    }
  }
  getUITranslation(key) {
    const val = this.ui[key];
    if (val === void 0) {
      throw new MissingTranslationError(`ui.${key}`);
    } else {
      return val;
    }
  }
  checkUI() {
    for (const key of Object.values(UIElement)) {
      if (!(key in this.ui)) {
        throw new MissingTranslationError(`ui.${key}`);
      }
    }
  }
  checkErrors() {
    for (const key of Object.values(ErrorType)) {
      if (!(key in this.errors) && key !== ErrorType.LIC) {
        throw new MissingTranslationError(`errors.${key}`);
      }
    }
  }
  checkFunctionTranslations(functions) {
    const functionNames = new Set(Object.getOwnPropertyNames(functions));
    for (const protectedTranslation of Object.getOwnPropertyNames(this._protectedTranslations)) {
      if (functionNames.has(protectedTranslation)) {
        throw new ProtectedFunctionTranslationError(protectedTranslation);
      }
    }
  }
}
function buildTranslationPackage(rawTranslationPackage) {
  return new TranslationPackage(Object.assign({}, rawTranslationPackage.functions), Object.assign({}, rawTranslationPackage.errors), Object.assign({}, rawTranslationPackage.ui));
}
var UIElement;
(function(UIElement2) {
  UIElement2["NEW_SHEET_PREFIX"] = "NEW_SHEET_PREFIX";
})(UIElement || (UIElement = {}));
class Sheet {
  constructor(id, displayName, isPlaceholder = false) {
    this.id = id;
    this.displayName = displayName;
    this.isPlaceholder = isPlaceholder;
  }
  /**
   * Returns the canonical (normalized) name of the sheet.
   */
  get canonicalName() {
    return SheetMapping.canonicalizeSheetName(this.displayName);
  }
}
class SheetMapping {
  constructor(languages) {
    this.lastSheetId = -1;
    this.mappingFromCanonicalNameToId = /* @__PURE__ */ new Map();
    this.allSheets = /* @__PURE__ */ new Map();
    this.sheetNamePrefix = languages.getUITranslation(UIElement.NEW_SHEET_PREFIX);
  }
  /**
   * Converts sheet name to canonical/normalized form.
   * @static
   */
  static canonicalizeSheetName(sheetDisplayName) {
    return sheetDisplayName.toLowerCase();
  }
  /**
   * Returns sheet ID for the given name. By default excludes placeholders.
   */
  getSheetId(sheetName, options = {}) {
    var _a;
    return (_a = this._getSheetByName(sheetName, options)) === null || _a === void 0 ? void 0 : _a.id;
  }
  /**
   * Returns sheet ID for the given name. Excludes placeholders.
   *
   * @throws {NoSheetWithNameError} if the sheet with the given name does not exist.
   */
  getSheetIdOrThrowError(sheetName) {
    const sheet = this._getSheetByName(sheetName, {});
    if (sheet === void 0) {
      throw new NoSheetWithNameError(sheetName);
    }
    return sheet.id;
  }
  /**
   * Returns display name for the given sheet ID. Excludes placeholders.
   *
   * @returns {Maybe<string>} the display name, or undefined if the sheet with the given ID does not exist.
   */
  getSheetName(sheetId) {
    var _a;
    return (_a = this._getSheet(sheetId, {})) === null || _a === void 0 ? void 0 : _a.displayName;
  }
  /**
   * Returns display name for the given sheet ID. Excludes placeholders.
   *
   * @throws {NoSheetWithIdError} if the sheet with the given ID does not exist.
   */
  getSheetNameOrThrowError(sheetId, options = {}) {
    return this._getSheetOrThrowError(sheetId, options).displayName;
  }
  /**
   * Iterates over all sheet display names. By default excludes placeholders.
   */
  *iterateSheetNames(options = {}) {
    for (const sheet of this.allSheets.values()) {
      if (options.includePlaceholders || !sheet.isPlaceholder) {
        yield sheet.displayName;
      }
    }
  }
  /**
   * Returns array of all sheet display names. By default excludes placeholders.
   */
  getSheetNames(options = {}) {
    return Array.from(this.iterateSheetNames(options));
  }
  /**
   * Returns total count of sheets. By default excludes placeholders.
   */
  numberOfSheets(options = {}) {
    return this.getSheetNames(options).length;
  }
  /**
   * Checks if sheet with given ID exists. By default excludes placeholders.
   */
  hasSheetWithId(sheetId, options = {}) {
    return this._getSheet(sheetId, options) !== void 0;
  }
  /**
   * Checks if sheet with given name exists (case-insensitive). Excludes placeholders.
   */
  hasSheetWithName(sheetName) {
    return this._getSheetByName(sheetName, {}) !== void 0;
  }
  /**
   * Adds new sheet with optional name and returns its ID.
   * If called with a name of an existing placeholder sheet, converts the placeholder sheet to a real sheet.
   *
   * @throws {SheetNameAlreadyTakenError} if the sheet with the given name already exists.
   */
  addSheet(newSheetDisplayName = `${this.sheetNamePrefix}${this.lastSheetId + 2}`) {
    const sheetWithConflictingName = this._getSheetByName(newSheetDisplayName, {
      includePlaceholders: true
    });
    if (sheetWithConflictingName) {
      if (!sheetWithConflictingName.isPlaceholder) {
        throw new SheetNameAlreadyTakenError(newSheetDisplayName);
      }
      sheetWithConflictingName.isPlaceholder = false;
      return sheetWithConflictingName.id;
    }
    this.lastSheetId++;
    const sheet = new Sheet(this.lastSheetId, newSheetDisplayName);
    this._storeSheetInMappings(sheet);
    return sheet.id;
  }
  /**
   * Adds a sheet with a specific ID and name. Used for redo operations.
   * If called with a name of an existing placeholder sheet, converts the placeholder sheet to a real sheet.
   *
   * @throws {SheetNameAlreadyTakenError} if the sheet with the given name already exists.
   */
  addSheetWithId(sheetId, sheetDisplayName) {
    const sheetWithConflictingName = this._getSheetByName(sheetDisplayName, {
      includePlaceholders: true
    });
    if (sheetWithConflictingName) {
      if (sheetWithConflictingName.id !== sheetId) {
        throw new SheetNameAlreadyTakenError(sheetDisplayName);
      }
      if (!sheetWithConflictingName.isPlaceholder) {
        throw new SheetNameAlreadyTakenError(sheetDisplayName);
      }
      sheetWithConflictingName.isPlaceholder = false;
      return;
    }
    if (sheetId > this.lastSheetId) {
      this.lastSheetId = sheetId;
    }
    const sheet = new Sheet(sheetId, sheetDisplayName);
    this._storeSheetInMappings(sheet);
  }
  /**
   * Adds a placeholder sheet with the given name if it does not exist yet
   */
  addPlaceholderIfNotExists(sheetName) {
    const sheetWithConflictingName = this._getSheetByName(sheetName, {
      includePlaceholders: true
    });
    if (sheetWithConflictingName) {
      return sheetWithConflictingName.id;
    }
    this.lastSheetId++;
    const sheet = new Sheet(this.lastSheetId, sheetName, true);
    this._storeSheetInMappings(sheet);
    return sheet.id;
  }
  /**
   * Adds a placeholder sheet with a specific ID and name.
   * Used for undo operations to restore previously merged placeholder sheets.
   *
   * @throws {SheetNameAlreadyTakenError} if the sheet with the given name already exists.
   */
  addPlaceholderWithId(sheetId, sheetDisplayName) {
    const sheetWithConflictingName = this._getSheetByName(sheetDisplayName, {
      includePlaceholders: true
    });
    if (sheetWithConflictingName) {
      throw new SheetNameAlreadyTakenError(sheetDisplayName);
    }
    if (this.hasSheetWithId(sheetId, {
      includePlaceholders: true
    })) {
      throw new Error(`Sheet with id ${sheetId} already exists`);
    }
    if (sheetId > this.lastSheetId) {
      this.lastSheetId = sheetId;
    }
    const sheet = new Sheet(sheetId, sheetDisplayName, true);
    this._storeSheetInMappings(sheet);
  }
  /**
   *
   * Removes sheet with given ID.
   * If sheet does not exist, does nothing.
   * @returns {boolean} true if sheet was removed, false if it did not exist.
   */
  removeSheetIfExists(sheetId, options = {}) {
    const sheet = this._getSheet(sheetId, options);
    if (!sheet) {
      return false;
    }
    this.allSheets.delete(sheetId);
    this.mappingFromCanonicalNameToId.delete(sheet.canonicalName);
    if (sheetId === this.lastSheetId) {
      this.lastSheetId--;
    }
    return true;
  }
  /**
   * Marks sheet with given ID as a placeholder.
   * @throws {NoSheetWithIdError} if the sheet with the given ID does not exist
   */
  markSheetAsPlaceholder(sheetId) {
    const sheet = this._getSheetOrThrowError(sheetId, {});
    sheet.isPlaceholder = true;
  }
  /**
   * Renames sheet.
   * - If called with sheetId of a placeholder sheet, throws {NoSheetWithIdError}.
   * - If newDisplayName is conflicting with an existing sheet, throws {SheetNameAlreadyTakenError}.
   * - If newDisplayName is conflicting with a placeholder sheet name, deletes the placeholder sheet and returns its id as mergedWithPlaceholderSheet.
   *
   * @throws {SheetNameAlreadyTakenError} if the sheet with the given name already exists.
   * @throws {NoSheetWithIdError} if the sheet with the given ID does not exist.
   */
  renameSheet(sheetId, newDisplayName) {
    const sheet = this._getSheetOrThrowError(sheetId, {});
    const currentDisplayName = sheet.displayName;
    if (currentDisplayName === newDisplayName) {
      return {
        previousDisplayName: void 0
      };
    }
    const sheetWithConflictingName = this._getSheetByName(newDisplayName, {
      includePlaceholders: true
    });
    let mergedWithPlaceholderSheet = void 0;
    if (sheetWithConflictingName !== void 0 && sheetWithConflictingName.id !== sheet.id) {
      if (!sheetWithConflictingName.isPlaceholder) {
        throw new SheetNameAlreadyTakenError(newDisplayName);
      } else {
        this.mappingFromCanonicalNameToId.delete(sheetWithConflictingName.canonicalName);
        this.allSheets.delete(sheetWithConflictingName.id);
        if (sheetWithConflictingName.id === this.lastSheetId) {
          this.lastSheetId--;
        }
        mergedWithPlaceholderSheet = sheetWithConflictingName.id;
      }
    }
    const currentCanonicalName = sheet.canonicalName;
    this.mappingFromCanonicalNameToId.delete(currentCanonicalName);
    sheet.displayName = newDisplayName;
    this._storeSheetInMappings(sheet);
    return {
      previousDisplayName: currentDisplayName,
      mergedWithPlaceholderSheet
    };
  }
  /**
   * Stores sheet in both internal mappings.
   * - If ID exists, it is updated. If not, it is added.
   * - If canonical name exists, it is updated. If not, it is added.
   *
   * @internal
   */
  _storeSheetInMappings(sheet) {
    this.allSheets.set(sheet.id, sheet);
    this.mappingFromCanonicalNameToId.set(sheet.canonicalName, sheet.id);
  }
  /**
   * Returns sheet by ID
   *
   * @returns {Maybe<Sheet>} the sheet, or undefined if not found.
   * @internal
   */
  _getSheet(sheetId, options) {
    const retrievedSheet = this.allSheets.get(sheetId);
    if (retrievedSheet === void 0) {
      return void 0;
    }
    return options.includePlaceholders || !retrievedSheet.isPlaceholder ? retrievedSheet : void 0;
  }
  /**
   * Returns sheet by name
   *
   * @returns {Maybe<Sheet>} the sheet, or undefined if not found.
   * @internal
   */
  _getSheetByName(sheetName, options) {
    const sheetId = this.mappingFromCanonicalNameToId.get(SheetMapping.canonicalizeSheetName(sheetName));
    if (sheetId === void 0) {
      return void 0;
    }
    return this._getSheet(sheetId, options);
  }
  /**
   * Returns sheet by ID
   *
   * @throws {NoSheetWithIdError} if the sheet with the given ID does not exist.
   * @internal
   */
  _getSheetOrThrowError(sheetId, options) {
    const sheet = this._getSheet(sheetId, options);
    if (sheet === void 0) {
      throw new NoSheetWithIdError(sheetId);
    }
    return sheet;
  }
}
class SheetReferenceRegistrar {
  constructor(sheetMapping, addressMapping) {
    this.sheetMapping = sheetMapping;
    this.addressMapping = addressMapping;
  }
  /**
   * Adds placeholder sheet if it doesn't exist and adds placeholder strategy to address mapping.
   * @returns {number} sheet id
   */
  ensureSheetRegistered(sheetName) {
    const sheetId = this.sheetMapping.addPlaceholderIfNotExists(sheetName);
    this.addressMapping.addSheetStrategyPlaceholderIfNotExists(sheetId);
    return sheetId;
  }
}
function validateAsSheet(sheet) {
  if (!Array.isArray(sheet)) {
    throw new InvalidArgumentsError("an array of arrays.");
  }
  for (let i = 0; i < sheet.length; i++) {
    if (!Array.isArray(sheet[i])) {
      throw new InvalidArgumentsError("an array of arrays.");
    }
  }
}
function findBoundaries(sheet) {
  let width = 0;
  let height = 0;
  let cellsCount = 0;
  for (let currentRow = 0; currentRow < sheet.length; currentRow++) {
    let currentRowWidth = 0;
    for (let currentCol = 0; currentCol < sheet[currentRow].length; currentCol++) {
      const currentValue = sheet[currentRow][currentCol];
      if (currentValue === void 0 || currentValue === null) {
        continue;
      }
      currentRowWidth = currentCol + 1;
      ++cellsCount;
    }
    width = Math.max(width, currentRowWidth);
    if (currentRowWidth > 0) {
      height = currentRow + 1;
    }
  }
  const sheetSize = width * height;
  return {
    height,
    width,
    fill: sheetSize === 0 ? 0 : cellsCount / sheetSize
  };
}
class DependencyGraph {
  constructor(addressMapping, rangeMapping, sheetMapping, arrayMapping, stats, lazilyTransformingAstService, functionRegistry, namedExpressions) {
    this.addressMapping = addressMapping;
    this.rangeMapping = rangeMapping;
    this.sheetMapping = sheetMapping;
    this.arrayMapping = arrayMapping;
    this.stats = stats;
    this.lazilyTransformingAstService = lazilyTransformingAstService;
    this.functionRegistry = functionRegistry;
    this.namedExpressions = namedExpressions;
    this.changes = ContentChanges.empty();
    this.dependencyQueryAddresses = (vertex) => {
      if (vertex instanceof RangeVertex) {
        return this.rangeDependencyQuery(vertex).map(([address, _]) => address);
      } else {
        const dependenciesResult = this.formulaDependencyQuery(vertex);
        if (dependenciesResult !== void 0) {
          const [address, dependencies] = dependenciesResult;
          return dependencies.map((dependency) => {
            if (dependency instanceof NamedExpressionDependency) {
              return this.namedExpressions.namedExpressionOrPlaceholder(dependency.name, address.sheet).address;
            } else if (isSimpleCellAddress(dependency)) {
              return dependency;
            } else {
              return simpleCellRange(dependency.start, dependency.end);
            }
          });
        } else {
          return [];
        }
      }
    };
    this.dependencyQueryVertices = (vertex) => {
      if (vertex instanceof RangeVertex) {
        return this.rangeDependencyQuery(vertex);
      } else {
        const dependenciesResult = this.formulaDependencyQuery(vertex);
        if (dependenciesResult !== void 0) {
          const [address, dependencies] = dependenciesResult;
          return dependencies.map((dependency) => {
            if (dependency instanceof AbsoluteCellRange) {
              return [dependency.start, this.rangeMapping.getVertexOrThrow(dependency.start, dependency.end)];
            } else if (dependency instanceof NamedExpressionDependency) {
              const namedExpression = this.namedExpressions.namedExpressionOrPlaceholder(dependency.name, address.sheet);
              return [namedExpression.address, this.addressMapping.getCellOrThrow(namedExpression.address)];
            } else {
              return [dependency, this.addressMapping.getCellOrThrow(dependency)];
            }
          });
        } else {
          return [];
        }
      }
    };
    this.rangeDependencyQuery = (vertex) => {
      const allDeps = [];
      const {
        smallerRangeVertex,
        restRange
      } = this.rangeMapping.findSmallerRange(vertex.range);
      let range;
      if (smallerRangeVertex !== void 0 && this.graph.adjacentNodes(smallerRangeVertex).has(vertex)) {
        range = restRange;
        allDeps.push([new AbsoluteCellRange(smallerRangeVertex.start, smallerRangeVertex.end), smallerRangeVertex]);
      } else {
        range = vertex.range;
      }
      for (const address of range.addresses(this)) {
        const cell = this.addressMapping.getCell(address);
        if (cell !== void 0) {
          allDeps.push([address, cell]);
        }
      }
      return allDeps;
    };
    this.formulaDependencyQuery = (vertex) => {
      let formula;
      let address;
      if (vertex instanceof FormulaVertex) {
        address = vertex.getAddress(this.lazilyTransformingAstService);
        formula = vertex.getFormula(this.lazilyTransformingAstService);
      } else {
        return void 0;
      }
      const deps = collectDependencies(formula, this.functionRegistry);
      return [address, absolutizeDependencies(deps, address)];
    };
    this.graph = new Graph(this.dependencyQueryVertices);
    this.sheetReferenceRegistrar = new SheetReferenceRegistrar(sheetMapping, addressMapping);
  }
  /**
   * Invariants:
   * - empty cell has associated EmptyCellVertex if and only if it is a dependency (possibly indirect, through range) to some formula
   */
  static buildEmpty(lazilyTransformingAstService, config, functionRegistry, namedExpressions, stats) {
    return new DependencyGraph(new AddressMapping(config.chooseAddressMappingPolicy), new RangeMapping(), new SheetMapping(config.translationPackage), new ArrayMapping(), stats, lazilyTransformingAstService, functionRegistry, namedExpressions);
  }
  setFormulaToCell(address, ast, dependencies, size, hasVolatileFunction, hasStructuralChangeFunction) {
    const newVertex = FormulaVertex.fromAst(ast, address, size, this.lazilyTransformingAstService.version());
    this.exchangeOrAddFormulaVertex(newVertex);
    this.processCellDependencies(dependencies, newVertex);
    this.graph.markNodeAsDirty(newVertex);
    if (hasVolatileFunction) {
      this.markAsVolatile(newVertex);
    }
    if (hasStructuralChangeFunction) {
      this.markAsDependentOnStructureChange(newVertex);
    }
    this.correctInfiniteRangesDependency(address);
    return this.getAndClearContentChanges();
  }
  setParsingErrorToCell(address, errorVertex) {
    const vertex = this.shrinkPossibleArrayAndGetCell(address);
    this.exchangeOrAddGraphNode(vertex, errorVertex);
    this.addressMapping.setCell(address, errorVertex);
    this.graph.markNodeAsDirty(errorVertex);
    this.correctInfiniteRangesDependency(address);
    return this.getAndClearContentChanges();
  }
  setValueToCell(address, value) {
    const vertex = this.shrinkPossibleArrayAndGetCell(address);
    if (vertex instanceof ArrayFormulaVertex) {
      this.arrayMapping.removeArray(vertex.getRange());
    }
    if (vertex instanceof ValueCellVertex) {
      const oldValues = vertex.getValues();
      if (oldValues.rawValue !== value.rawValue) {
        vertex.setValues(value);
        this.graph.markNodeAsDirty(vertex);
      }
    } else {
      const newVertex = new ValueCellVertex(value.parsedValue, value.rawValue);
      this.exchangeOrAddGraphNode(vertex, newVertex);
      this.addressMapping.setCell(address, newVertex);
      this.graph.markNodeAsDirty(newVertex);
    }
    this.correctInfiniteRangesDependency(address);
    return this.getAndClearContentChanges();
  }
  /**
   * Sets a cell empty.
   * - if vertex has no dependents, removes it from graph, address mapping and range mapping and cleans up its dependencies
   * - if vertex has dependents, exchanges it for an EmptyCellVertex and marks it as dirty
   */
  setCellEmpty(address) {
    const vertex = this.shrinkPossibleArrayAndGetCell(address);
    if (vertex === void 0) {
      return ContentChanges.empty();
    }
    if (this.graph.adjacentNodes(vertex).size > 0) {
      const emptyVertex = new EmptyCellVertex();
      this.exchangeGraphNode(vertex, emptyVertex);
      if (this.graph.adjacentNodesCount(emptyVertex) === 0) {
        this.removeVertex(emptyVertex);
        this.addressMapping.removeCell(address);
      } else {
        this.graph.markNodeAsDirty(emptyVertex);
        this.addressMapping.setCell(address, emptyVertex);
      }
    } else {
      this.removeVertex(vertex);
      this.addressMapping.removeCell(address);
    }
    return this.getAndClearContentChanges();
  }
  clearDirtyVertices() {
    this.graph.clearDirtyNodes();
  }
  verticesToRecompute() {
    return this.graph.getDirtyAndVolatileNodes();
  }
  processCellDependencies(cellDependencies, endVertex) {
    const endVertexId = endVertex.idInGraph;
    if (endVertexId === void 0) {
      throw new Error("End vertex not found");
    }
    cellDependencies.forEach((dep) => {
      if (dep instanceof AbsoluteCellRange) {
        const range = dep;
        let rangeVertex = this.getRange(range.start, range.end);
        if (rangeVertex === void 0) {
          rangeVertex = new RangeVertex(range);
          this.rangeMapping.addOrUpdateVertex(rangeVertex);
        }
        this.graph.addNodeIfNotExists(rangeVertex);
        const rangeVertexId = rangeVertex.idInGraph;
        if (rangeVertexId === void 0) {
          throw new Error("Range vertex not found");
        }
        if (!range.isFinite()) {
          this.graph.markNodeAsInfiniteRange(rangeVertexId);
        }
        const {
          smallerRangeVertex,
          restRange
        } = this.rangeMapping.findSmallerRange(range);
        if (smallerRangeVertex !== void 0) {
          this.graph.addEdge(smallerRangeVertex, rangeVertexId);
          if (rangeVertex.bruteForce) {
            rangeVertex.bruteForce = false;
            for (const cellFromRange of range.addresses(this)) {
              this.graph.removeEdge(this.fetchCell(cellFromRange), rangeVertexId);
            }
          }
        } else {
          rangeVertex.bruteForce = true;
        }
        const array = this.arrayMapping.getArray(restRange);
        if (array !== void 0) {
          this.graph.addEdge(array, rangeVertexId);
        } else {
          for (const cellFromRange of restRange.addresses(this)) {
            const {
              vertex,
              id
            } = this.fetchCellOrCreateEmpty(cellFromRange);
            this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, rangeVertexId);
          }
        }
        this.graph.addEdge(rangeVertexId, endVertexId);
        if (range.isFinite()) {
          this.correctInfiniteRangesDependenciesByRangeVertex(rangeVertex);
        }
      } else if (dep instanceof NamedExpressionDependency) {
        const sheetOfVertex = endVertex.getAddress(this.lazilyTransformingAstService).sheet;
        const {
          vertex,
          id
        } = this.fetchNamedExpressionVertex(dep.name, sheetOfVertex);
        this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, endVertexId);
      } else {
        const {
          vertex,
          id
        } = this.fetchCellOrCreateEmpty(dep);
        this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, endVertexId);
      }
    });
  }
  fetchNamedExpressionVertex(expressionName, sheetId) {
    const namedExpression = this.namedExpressions.namedExpressionOrPlaceholder(expressionName, sheetId);
    return this.fetchCellOrCreateEmpty(namedExpression.address);
  }
  exchangeNode(addressFrom, addressTo) {
    const vertexFrom = this.fetchCellOrCreateEmpty(addressFrom).vertex;
    const vertexTo = this.fetchCellOrCreateEmpty(addressTo).vertex;
    this.addressMapping.removeCell(addressFrom);
    this.exchangeGraphNode(vertexFrom, vertexTo);
  }
  fetchCellOrCreateEmpty(address) {
    const existingVertex = this.addressMapping.getCell(address);
    if (existingVertex !== void 0) {
      return {
        vertex: existingVertex,
        id: void 0
      };
    }
    const newVertex = new EmptyCellVertex();
    const newVertexId = this.graph.addNodeIfNotExists(newVertex);
    this.addressMapping.setCell(address, newVertex);
    return {
      vertex: newVertex,
      id: newVertexId
    };
  }
  removeRows(removedRows) {
    this.stats.measure(StatType.ADJUSTING_GRAPH, () => {
      for (const [address, vertex] of this.addressMapping.entriesFromRowsSpan(removedRows)) {
        for (const adjacentNode of this.graph.adjacentNodes(vertex)) {
          this.graph.markNodeAsDirty(adjacentNode);
        }
        if (vertex instanceof ArrayFormulaVertex) {
          if (vertex.isLeftCorner(address)) {
            this.shrinkArrayToCorner(vertex);
            this.arrayMapping.removeArray(vertex.getRange());
          } else {
            continue;
          }
        }
        this.removeVertex(vertex);
      }
    });
    this.stats.measure(StatType.ADJUSTING_ADDRESS_MAPPING, () => {
      this.addressMapping.removeRows(removedRows);
    });
    const affectedArrays = this.stats.measure(StatType.ADJUSTING_RANGES, () => {
      const affectedRanges = this.truncateRanges(removedRows, (address) => address.row);
      return this.getArrayVerticesRelatedToRanges(affectedRanges);
    });
    this.stats.measure(StatType.ADJUSTING_ARRAY_MAPPING, () => {
      this.fixArraysAfterRemovingRows(removedRows.sheet, removedRows.rowStart, removedRows.numberOfRows);
    });
    this.addStructuralNodesToChangeSet();
    return {
      affectedArrays,
      contentChanges: this.getAndClearContentChanges()
    };
  }
  /**
   * Adds a new sheet to the graph.
   * If the sheetId was a placeholder sheet, marks its vertices as dirty.
   */
  addSheet(sheetId) {
    this.addressMapping.addSheetOrChangeStrategy(sheetId, findBoundaries([]));
    this.stats.measure(StatType.ADJUSTING_ADDRESS_MAPPING, () => {
      this.markAllCellsAsDirtyInSheet(sheetId);
    });
    this.stats.measure(StatType.ADJUSTING_RANGES, () => {
      this.markAllRangesAsDirtyInSheet(sheetId);
    });
  }
  /**
   * Removes all vertices without dependents in other sheets from address mapping, range mapping and array mapping.
   * - If nothing is left, removes the sheet from sheet mapping and address mapping.
   * - Otherwise, marks it as placeholder.
   */
  removeSheet(sheetId) {
    this.clearSheet(sheetId);
    const addressMappingCleared = !this.addressMapping.hasAnyEntries(sheetId);
    const rangeMappingCleared = this.rangeMapping.getNumberOfRangesInSheet(sheetId) === 0;
    if (addressMappingCleared && rangeMappingCleared) {
      this.sheetMapping.removeSheetIfExists(sheetId);
      this.addressMapping.removeSheetIfExists(sheetId);
    } else {
      this.sheetMapping.markSheetAsPlaceholder(sheetId);
    }
  }
  /**
   * Removes placeholderSheetToDelete and reroutes edges to the corresponding vertices in sheetToKeep
   *
   * Assumptions about placeholderSheetToDelete:
   * - is empty (contains only empty cell vertices and range vertices),
   * - empty cell vertices have no dependencies,
   * - range vertices have dependencies only in placeholderSheetToDelete,
   * - vertices may have dependents in placeholderSheetToDelete and other sheets,
   */
  mergeSheets(sheetToKeep, placeholderSheetToDelete) {
    if (!this.isPlaceholder(placeholderSheetToDelete)) {
      throw new Error(`Cannot merge sheets: sheet ${placeholderSheetToDelete} is not a placeholder`);
    }
    this.mergeRangeVertices(sheetToKeep, placeholderSheetToDelete);
    this.mergeCellVertices(sheetToKeep, placeholderSheetToDelete);
    this.addressMapping.removeSheetIfExists(placeholderSheetToDelete);
    this.addStructuralNodesToChangeSet();
  }
  /**
   * Clears the sheet content.
   * - removes all cell vertices without dependents
   * - removes all array vertices
   * - for vertices with dependents, exchanges them for EmptyCellVertex and marks them as dirty
   */
  clearSheet(sheetId) {
    const arrays = /* @__PURE__ */ new Set();
    for (const [address, vertex] of this.addressMapping.sheetEntries(sheetId)) {
      if (vertex instanceof ArrayFormulaVertex) {
        arrays.add(vertex);
      } else {
        this.setCellEmpty(address);
      }
    }
    for (const array of arrays.values()) {
      this.setArrayEmpty(array);
    }
    this.addStructuralNodesToChangeSet();
  }
  removeColumns(removedColumns) {
    this.stats.measure(StatType.ADJUSTING_GRAPH, () => {
      for (const [address, vertex] of this.addressMapping.entriesFromColumnsSpan(removedColumns)) {
        for (const adjacentNode of this.graph.adjacentNodes(vertex)) {
          this.graph.markNodeAsDirty(adjacentNode);
        }
        if (vertex instanceof ArrayFormulaVertex) {
          if (vertex.isLeftCorner(address)) {
            this.shrinkArrayToCorner(vertex);
            this.arrayMapping.removeArray(vertex.getRange());
          } else {
            continue;
          }
        }
        this.removeVertex(vertex);
      }
    });
    this.stats.measure(StatType.ADJUSTING_ADDRESS_MAPPING, () => {
      this.addressMapping.removeColumns(removedColumns);
    });
    const affectedArrays = this.stats.measure(StatType.ADJUSTING_RANGES, () => {
      const affectedRanges = this.truncateRanges(removedColumns, (address) => address.col);
      return this.getArrayVerticesRelatedToRanges(affectedRanges);
    });
    this.stats.measure(StatType.ADJUSTING_ARRAY_MAPPING, () => {
      return this.fixArraysAfterRemovingColumns(removedColumns.sheet, removedColumns.columnStart, removedColumns.numberOfColumns);
    });
    this.addStructuralNodesToChangeSet();
    return {
      affectedArrays,
      contentChanges: this.getAndClearContentChanges()
    };
  }
  addRows(addedRows) {
    this.stats.measure(StatType.ADJUSTING_ADDRESS_MAPPING, () => {
      this.addressMapping.addRows(addedRows.sheet, addedRows.rowStart, addedRows.numberOfRows);
    });
    const affectedArrays = this.stats.measure(StatType.ADJUSTING_RANGES, () => {
      const result = this.rangeMapping.moveAllRangesInSheetAfterAddingRows(addedRows.sheet, addedRows.rowStart, addedRows.numberOfRows);
      this.fixRangesWhenAddingRows(addedRows.sheet, addedRows.rowStart, addedRows.numberOfRows);
      return this.getArrayVerticesRelatedToRanges(result.verticesWithChangedSize);
    });
    this.stats.measure(StatType.ADJUSTING_ARRAY_MAPPING, () => {
      this.fixArraysAfterAddingRow(addedRows.sheet, addedRows.rowStart, addedRows.numberOfRows);
    });
    for (const vertex of this.addressMapping.verticesFromRowsSpan(addedRows)) {
      this.graph.markNodeAsDirty(vertex);
    }
    this.addStructuralNodesToChangeSet();
    return {
      affectedArrays
    };
  }
  addColumns(addedColumns) {
    this.stats.measure(StatType.ADJUSTING_ADDRESS_MAPPING, () => {
      this.addressMapping.addColumns(addedColumns.sheet, addedColumns.columnStart, addedColumns.numberOfColumns);
    });
    const affectedArrays = this.stats.measure(StatType.ADJUSTING_RANGES, () => {
      const result = this.rangeMapping.moveAllRangesInSheetAfterAddingColumns(addedColumns.sheet, addedColumns.columnStart, addedColumns.numberOfColumns);
      this.fixRangesWhenAddingColumns(addedColumns.sheet, addedColumns.columnStart, addedColumns.numberOfColumns);
      return this.getArrayVerticesRelatedToRanges(result.verticesWithChangedSize);
    });
    this.stats.measure(StatType.ADJUSTING_ARRAY_MAPPING, () => {
      return this.fixArraysAfterAddingColumn(addedColumns.sheet, addedColumns.columnStart, addedColumns.numberOfColumns);
    });
    for (const vertex of this.addressMapping.verticesFromColumnsSpan(addedColumns)) {
      this.graph.markNodeAsDirty(vertex);
    }
    this.addStructuralNodesToChangeSet();
    return {
      affectedArrays,
      contentChanges: this.getAndClearContentChanges()
    };
  }
  isThereSpaceForArray(arrayVertex) {
    const range = arrayVertex.getRangeOrUndef();
    if (range === void 0) {
      return false;
    }
    for (const address of range.addresses(this)) {
      const vertexUnderAddress = this.addressMapping.getCell(address);
      if (vertexUnderAddress !== void 0 && !(vertexUnderAddress instanceof EmptyCellVertex) && vertexUnderAddress !== arrayVertex) {
        return false;
      }
    }
    return true;
  }
  moveCells(sourceRange, toRight, toBottom, toSheet) {
    for (const sourceAddress of sourceRange.addressesWithDirection(toRight, toBottom, this)) {
      const targetAddress = simpleCellAddress(toSheet, sourceAddress.col + toRight, sourceAddress.row + toBottom);
      let sourceVertex = this.addressMapping.getCell(sourceAddress);
      const targetVertex = this.addressMapping.getCell(targetAddress);
      this.addressMapping.removeCell(sourceAddress);
      if (sourceVertex !== void 0) {
        this.graph.markNodeAsDirty(sourceVertex);
        this.addressMapping.setCell(targetAddress, sourceVertex);
        let emptyVertex = void 0;
        for (const adjacentNode of this.graph.adjacentNodes(sourceVertex)) {
          if (adjacentNode instanceof RangeVertex && !sourceRange.containsRange(adjacentNode.range)) {
            emptyVertex = emptyVertex !== null && emptyVertex !== void 0 ? emptyVertex : this.fetchCellOrCreateEmpty(sourceAddress).vertex;
            this.graph.addEdge(emptyVertex, adjacentNode);
            this.graph.removeEdge(sourceVertex, adjacentNode);
          }
        }
        if (emptyVertex) {
          this.graph.markNodeAsDirty(emptyVertex);
          this.addressMapping.setCell(sourceAddress, emptyVertex);
        }
      }
      if (targetVertex !== void 0) {
        if (sourceVertex === void 0) {
          this.addressMapping.removeCell(targetAddress);
        }
        for (const adjacentNode of this.graph.adjacentNodes(targetVertex)) {
          sourceVertex = sourceVertex !== null && sourceVertex !== void 0 ? sourceVertex : this.fetchCellOrCreateEmpty(targetAddress).vertex;
          this.graph.addEdge(sourceVertex, adjacentNode);
          this.graph.markNodeAsDirty(sourceVertex);
        }
        this.removeVertex(targetVertex);
      }
    }
    for (const rangeVertex of this.rangeMapping.rangeVerticesContainedInRange(sourceRange)) {
      for (const adjacentNode of this.graph.adjacentNodes(rangeVertex)) {
        if (adjacentNode instanceof RangeVertex && !sourceRange.containsRange(adjacentNode.range)) {
          this.graph.removeEdge(rangeVertex, adjacentNode);
          for (const address of rangeVertex.range.addresses(this)) {
            const {
              vertex,
              id
            } = this.fetchCellOrCreateEmpty(address);
            this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, adjacentNode);
            this.addressMapping.setCell(address, vertex);
            this.graph.markNodeAsDirty(vertex);
          }
        }
      }
    }
    this.rangeMapping.moveRangesInsideSourceRange(sourceRange, toRight, toBottom, toSheet);
  }
  /**
   * Sets an array empty.
   * - removes all corresponding entries from address mapping
   * - reroutes the edges
   * - removes vertex from graph and cleans up its dependencies
   * - removes vertex from range mapping and array mapping
   */
  setArrayEmpty(arrayVertex) {
    const arrayRange = AbsoluteCellRange.spanFrom(arrayVertex.getAddress(this.lazilyTransformingAstService), arrayVertex.width, arrayVertex.height);
    const dependentVertices = this.graph.adjacentNodes(arrayVertex);
    for (const address of arrayRange.addresses(this)) {
      this.addressMapping.removeCell(address);
    }
    for (const adjacentNode of dependentVertices.values()) {
      const nodeDependencies = collectAddressesDependentToRange(this.functionRegistry, adjacentNode, arrayVertex.getRange(), this.lazilyTransformingAstService, this);
      for (const address of nodeDependencies) {
        const {
          vertex,
          id
        } = this.fetchCellOrCreateEmpty(address);
        this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, adjacentNode);
      }
      if (nodeDependencies.length > 0) {
        this.graph.markNodeAsDirty(adjacentNode);
      }
    }
    this.removeVertex(arrayVertex);
    this.arrayMapping.removeArray(arrayVertex.getRange());
  }
  addVertex(address, vertex) {
    this.graph.addNodeIfNotExists(vertex);
    this.addressMapping.setCell(address, vertex);
  }
  addArrayVertex(address, vertex) {
    this.graph.addNodeIfNotExists(vertex);
    this.setAddressMappingForArrayVertex(vertex, address);
  }
  /**
   * Iterator over all array formula nodes in the graph.
   */
  *arrayFormulaNodes() {
    for (const vertex of this.graph.getNodes()) {
      if (vertex instanceof ArrayFormulaVertex) {
        yield vertex;
      }
    }
  }
  *entriesFromRowsSpan(rowsSpan) {
    yield* this.addressMapping.entriesFromRowsSpan(rowsSpan);
  }
  *entriesFromColumnsSpan(columnsSpan) {
    yield* this.addressMapping.entriesFromColumnsSpan(columnsSpan);
  }
  fetchCell(address) {
    return this.addressMapping.getCellOrThrow(address);
  }
  /**
   * Gets the cell vertex at the specified address.
   * @throws {NoSheetWithIdError} if sheet doesn't exist
   */
  getCell(address) {
    return this.addressMapping.getCell(address, {
      throwIfSheetNotExists: true
    });
  }
  getCellValue(address) {
    if (this.isPlaceholder(address.sheet)) {
      return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
    }
    return this.addressMapping.getCellValue(address);
  }
  getRawValue(address) {
    if (this.isPlaceholder(address.sheet)) {
      return null;
    }
    return this.addressMapping.getRawValue(address);
  }
  getScalarValue(address) {
    if (this.isPlaceholder(address.sheet)) {
      return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
    }
    const value = this.addressMapping.getCellValue(address);
    if (value instanceof SimpleRangeValue) {
      return new CellError(ErrorType.VALUE, ErrorMessage.ScalarExpected);
    }
    return value;
  }
  existsEdge(fromNode, toNode) {
    return this.graph.existsEdge(fromNode, toNode);
  }
  getSheetId(sheetName) {
    return this.sheetMapping.getSheetIdOrThrowError(sheetName);
  }
  getSheetHeight(sheet) {
    return this.addressMapping.getSheetHeight(sheet);
  }
  getSheetWidth(sheet) {
    return this.addressMapping.getSheetWidth(sheet);
  }
  getArray(range) {
    return this.arrayMapping.getArray(range);
  }
  getRange(start, end) {
    return this.rangeMapping.getRangeVertex(start, end);
  }
  topSortWithScc() {
    return this.graph.topSortWithScc();
  }
  markAsVolatile(vertex) {
    this.graph.markNodeAsVolatile(vertex);
  }
  markAsDependentOnStructureChange(vertex) {
    this.graph.markNodeAsChangingWithStructure(vertex);
  }
  forceApplyPostponedTransformations() {
    for (const vertex of this.graph.getNodes()) {
      if (vertex instanceof ScalarFormulaVertex) {
        vertex.ensureRecentData(this.lazilyTransformingAstService);
      }
    }
  }
  *rawValuesFromRange(range) {
    for (const address of range.addresses(this)) {
      const value = this.getScalarValue(address);
      if (value !== EmptyValue) {
        yield [getRawValue(value), address];
      }
    }
  }
  computeListOfValuesInRange(range) {
    const values2 = [];
    for (const cellFromRange of range.addresses(this)) {
      const value = this.getScalarValue(cellFromRange);
      values2.push(value);
    }
    return values2;
  }
  shrinkArrayToCorner(array) {
    this.cleanAddressMappingUnderArray(array);
    for (const adjacentVertex of this.adjacentArrayVertices(array)) {
      let relevantDependencies;
      if (adjacentVertex instanceof FormulaVertex) {
        relevantDependencies = this.formulaDirectDependenciesToArray(adjacentVertex, array);
      } else {
        relevantDependencies = this.rangeDirectDependenciesToArray(adjacentVertex, array);
      }
      let dependentToCorner = false;
      for (const [address, vertex] of relevantDependencies) {
        if (array.isLeftCorner(address)) {
          dependentToCorner = true;
        }
        this.graph.addEdge(vertex, adjacentVertex);
        this.graph.markNodeAsDirty(vertex);
      }
      if (!dependentToCorner) {
        this.graph.removeEdge(array, adjacentVertex);
      }
    }
    this.graph.markNodeAsDirty(array);
  }
  isArrayInternalCell(address) {
    const vertex = this.getCell(address);
    return vertex instanceof ArrayFormulaVertex && !vertex.isLeftCorner(address);
  }
  getAndClearContentChanges() {
    const changes = this.changes;
    this.changes = ContentChanges.empty();
    return changes;
  }
  getAdjacentNodesAddresses(inputVertex) {
    const deps = this.graph.adjacentNodes(inputVertex);
    const ret = [];
    deps.forEach((vertex) => {
      if (vertex instanceof RangeVertex) {
        ret.push(simpleCellRange(vertex.start, vertex.end));
      } else if (vertex instanceof FormulaVertex) {
        ret.push(vertex.getAddress(this.lazilyTransformingAstService));
      }
    });
    return ret;
  }
  /**
   * Marks all cell vertices in the sheet as dirty.
   */
  markAllCellsAsDirtyInSheet(sheetId) {
    const sheetCells = this.addressMapping.sheetEntries(sheetId);
    for (const [, vertex] of sheetCells) {
      this.graph.markNodeAsDirty(vertex);
    }
  }
  /**
   * Marks all range vertices in the sheet as dirty.
   */
  markAllRangesAsDirtyInSheet(sheetId) {
    const sheetRanges = this.rangeMapping.rangesInSheet(sheetId);
    for (const vertex of sheetRanges) {
      this.graph.markNodeAsDirty(vertex);
    }
  }
  /**
   * For each range vertex in placeholderSheetToDelete:
   * - reroutes dependencies and dependents of range vertex to the corresponding vertex in sheetToKeep
   * - removes range vertex from graph and range mapping
   * - cleans up dependencies of the removed vertex
   */
  mergeRangeVertices(sheetToKeep, placeholderSheetToDelete) {
    const rangeVertices = Array.from(this.rangeMapping.rangesInSheet(placeholderSheetToDelete));
    for (const vertexToDelete of rangeVertices) {
      if (!this.graph.hasNode(vertexToDelete)) {
        continue;
      }
      const start = vertexToDelete.start;
      const end = vertexToDelete.end;
      if (start.sheet !== placeholderSheetToDelete && end.sheet !== placeholderSheetToDelete) {
        continue;
      }
      const targetStart = simpleCellAddress(sheetToKeep, start.col, start.row);
      const targetEnd = simpleCellAddress(sheetToKeep, end.col, end.row);
      const vertexToKeep = this.rangeMapping.getRangeVertex(targetStart, targetEnd);
      if (vertexToKeep) {
        this.rerouteDependents(vertexToDelete, vertexToKeep);
        this.removeVertexAndRerouteDependencies(vertexToDelete, vertexToKeep);
        this.rangeMapping.removeVertexIfExists(vertexToDelete);
        this.graph.markNodeAsDirty(vertexToKeep);
      } else {
        this.rangeMapping.removeVertexIfExists(vertexToDelete);
        vertexToDelete.range.moveToSheet(sheetToKeep);
        this.rangeMapping.addOrUpdateVertex(vertexToDelete);
        this.graph.markNodeAsDirty(vertexToDelete);
      }
    }
  }
  /**
   * For each cell vertex in placeholderSheetToDelete:
   * - reroutes dependents of cell vertex to the corresponding vertex in sheetToKeep
   * - removes cell vertex from graph and address mapping
   * - cleans up dependencies of the removed vertex
   */
  mergeCellVertices(sheetToKeep, placeholderSheetToDelete) {
    const cellVertices = Array.from(this.addressMapping.sheetEntries(placeholderSheetToDelete));
    for (const [addressToDelete, vertexToDelete] of cellVertices) {
      const addressToKeep = simpleCellAddress(sheetToKeep, addressToDelete.col, addressToDelete.row);
      const vertexToKeep = this.getCell(addressToKeep);
      if (vertexToKeep) {
        this.rerouteDependents(vertexToDelete, vertexToKeep);
        this.removeVertexAndCleanupDependencies(vertexToDelete);
        this.addressMapping.removeCell(addressToDelete);
        this.graph.markNodeAsDirty(vertexToKeep);
      } else {
        this.addressMapping.moveCell(addressToDelete, addressToKeep);
        this.graph.markNodeAsDirty(vertexToDelete);
      }
    }
  }
  /**
   * Checks if the given sheet ID refers to a placeholder sheet (doesn't exist but is referenced by other sheets)
   */
  isPlaceholder(sheetId) {
    return sheetId !== NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS && !this.sheetMapping.hasSheetWithId(sheetId, {
      includePlaceholders: false
    });
  }
  exchangeGraphNode(oldNode, newNode) {
    this.graph.addNodeIfNotExists(newNode);
    const adjNodesStored = this.graph.adjacentNodes(oldNode);
    this.removeVertex(oldNode);
    adjNodesStored.forEach((adjacentNode) => {
      if (this.graph.hasNode(adjacentNode)) {
        this.graph.addEdge(newNode, adjacentNode);
      }
    });
  }
  setArray(range, vertex) {
    this.arrayMapping.setArray(range, vertex);
  }
  correctInfiniteRangesDependency(address) {
    const relevantInfiniteRanges = this.graph.getInfiniteRanges().filter((node) => node.range.addressInRange(address));
    if (relevantInfiniteRanges.length <= 0) {
      return;
    }
    const {
      vertex,
      id: maybeVertexId
    } = this.fetchCellOrCreateEmpty(address);
    const vertexId = maybeVertexId !== null && maybeVertexId !== void 0 ? maybeVertexId : vertex.idInGraph;
    if (vertexId === void 0) {
      throw new Error("Vertex not found");
    }
    relevantInfiniteRanges.forEach((node) => {
      this.graph.addEdge(vertexId, node);
    });
  }
  exchangeOrAddGraphNode(oldNode, newNode) {
    if (oldNode) {
      this.exchangeGraphNode(oldNode, newNode);
    } else {
      this.graph.addNodeIfNotExists(newNode);
    }
  }
  getArrayVerticesRelatedToRanges(ranges) {
    const arrayVertices = /* @__PURE__ */ new Set();
    ranges.forEach((range) => {
      if (!this.graph.hasNode(range)) {
        return;
      }
      this.graph.adjacentNodes(range).forEach((adjacentVertex) => {
        if (adjacentVertex instanceof ArrayFormulaVertex) {
          arrayVertices.add(adjacentVertex);
        }
      });
    });
    return arrayVertices;
  }
  correctInfiniteRangesDependenciesByRangeVertex(vertex) {
    this.graph.getInfiniteRanges().forEach((infiniteRangeVertex) => {
      const intersection = vertex.range.intersectionWith(infiniteRangeVertex.range);
      if (intersection === void 0) {
        return;
      }
      intersection.addresses(this).forEach((address) => {
        const {
          vertex: vertex2,
          id
        } = this.fetchCellOrCreateEmpty(address);
        this.graph.addEdge(id !== null && id !== void 0 ? id : vertex2, infiniteRangeVertex);
      });
    });
  }
  cleanAddressMappingUnderArray(vertex) {
    const arrayRange = vertex.getRange();
    for (const address of arrayRange.addresses(this)) {
      const oldValue = vertex.getArrayCellValue(address);
      if (this.getCell(address) === vertex) {
        if (vertex.isLeftCorner(address)) {
          this.changes.addChange(new CellError(ErrorType.REF), address, oldValue);
        } else {
          this.addressMapping.removeCell(address);
          this.changes.addChange(EmptyValue, address, oldValue);
        }
      } else {
        this.changes.addChange(EmptyValue, address, oldValue);
      }
    }
  }
  *formulaDirectDependenciesToArray(vertex, array) {
    var _a;
    const [, formulaDependencies] = (_a = this.formulaDependencyQuery(vertex)) !== null && _a !== void 0 ? _a : [];
    if (formulaDependencies === void 0) {
      return;
    }
    for (const dependency of formulaDependencies) {
      if (dependency instanceof NamedExpressionDependency || dependency instanceof AbsoluteCellRange) {
        continue;
      }
      if (array.getRange().addressInRange(dependency)) {
        const vertex2 = this.fetchCellOrCreateEmpty(dependency).vertex;
        yield [dependency, vertex2];
      }
    }
  }
  *rangeDirectDependenciesToArray(vertex, array) {
    const {
      restRange: range
    } = this.rangeMapping.findSmallerRange(vertex.range);
    for (const address of range.addresses(this)) {
      if (array.getRange().addressInRange(address)) {
        const cell = this.fetchCellOrCreateEmpty(address).vertex;
        yield [address, cell];
      }
    }
  }
  *adjacentArrayVertices(vertex) {
    const adjacentNodes = this.graph.adjacentNodes(vertex);
    for (const item of adjacentNodes) {
      if (item instanceof FormulaVertex || item instanceof RangeVertex) {
        yield item;
      }
    }
  }
  addStructuralNodesToChangeSet() {
    this.graph.markChangingWithStructureNodesAsDirty();
  }
  fixRangesWhenAddingRows(sheet, row, numberOfRows) {
    const originalValues = Array.from(this.rangeMapping.rangesInSheet(sheet));
    for (const rangeVertex of originalValues) {
      if (rangeVertex.range.includesRow(row + numberOfRows)) {
        if (rangeVertex.bruteForce) {
          const addedSubrangeInThatRange = rangeVertex.range.rangeWithSameWidth(row, numberOfRows);
          for (const address of addedSubrangeInThatRange.addresses(this)) {
            const {
              vertex,
              id
            } = this.fetchCellOrCreateEmpty(address);
            this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, rangeVertex);
          }
        } else {
          let currentRangeVertex = rangeVertex;
          let find2 = this.rangeMapping.findSmallerRange(currentRangeVertex.range);
          if (find2.smallerRangeVertex !== void 0) {
            continue;
          }
          while (find2.smallerRangeVertex === void 0) {
            const newRangeVertex = new RangeVertex(AbsoluteCellRange.spanFrom(currentRangeVertex.range.start, currentRangeVertex.range.width(), currentRangeVertex.range.height() - 1));
            this.rangeMapping.addOrUpdateVertex(newRangeVertex);
            this.graph.addNodeIfNotExists(newRangeVertex);
            const restRange = new AbsoluteCellRange(simpleCellAddress(currentRangeVertex.range.start.sheet, currentRangeVertex.range.start.col, currentRangeVertex.range.end.row), currentRangeVertex.range.end);
            this.addAllFromRange(restRange, currentRangeVertex);
            this.graph.addEdge(newRangeVertex, currentRangeVertex);
            currentRangeVertex = newRangeVertex;
            find2 = this.rangeMapping.findSmallerRange(currentRangeVertex.range);
          }
          this.graph.addEdge(find2.smallerRangeVertex, currentRangeVertex);
          this.addAllFromRange(find2.restRange, currentRangeVertex);
          this.graph.removeEdge(find2.smallerRangeVertex, rangeVertex);
        }
      }
    }
  }
  addAllFromRange(range, rangeVertex) {
    for (const address of range.addresses(this)) {
      const {
        vertex,
        id
      } = this.fetchCellOrCreateEmpty(address);
      this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, rangeVertex);
    }
  }
  fixRangesWhenAddingColumns(sheet, column, numberOfColumns) {
    for (const rangeVertex of this.rangeMapping.rangesInSheet(sheet)) {
      if (rangeVertex.range.includesColumn(column + numberOfColumns)) {
        let subrange;
        if (rangeVertex.bruteForce) {
          subrange = rangeVertex.range.rangeWithSameHeight(column, numberOfColumns);
        } else {
          subrange = AbsoluteCellRange.spanFrom(simpleCellAddress(sheet, column, rangeVertex.range.end.row), numberOfColumns, 1);
        }
        for (const address of subrange.addresses(this)) {
          const {
            vertex,
            id
          } = this.fetchCellOrCreateEmpty(address);
          this.graph.addEdge(id !== null && id !== void 0 ? id : vertex, rangeVertex);
        }
      }
    }
  }
  exchangeOrAddFormulaVertex(vertex) {
    const address = vertex.getAddress(this.lazilyTransformingAstService);
    const range = AbsoluteCellRange.spanFrom(address, vertex.width, vertex.height);
    const oldNode = this.shrinkPossibleArrayAndGetCell(address);
    if (vertex instanceof ArrayFormulaVertex) {
      this.setArray(range, vertex);
    }
    this.exchangeOrAddGraphNode(oldNode, vertex);
    this.addressMapping.setCell(address, vertex);
    if (vertex instanceof ArrayFormulaVertex) {
      if (!this.isThereSpaceForArray(vertex)) {
        return;
      }
      for (const cellAddress of range.addresses(this)) {
        if (vertex.isLeftCorner(cellAddress)) {
          continue;
        }
        const old = this.getCell(cellAddress);
        this.exchangeOrAddGraphNode(old, vertex);
      }
    }
    for (const cellAddress of range.addresses(this)) {
      this.addressMapping.setCell(cellAddress, vertex);
    }
  }
  setAddressMappingForArrayVertex(vertex, formulaAddress) {
    this.addressMapping.setCell(formulaAddress, vertex);
    if (!(vertex instanceof ArrayFormulaVertex)) {
      return;
    }
    const range = AbsoluteCellRange.spanFromOrUndef(formulaAddress, vertex.width, vertex.height);
    if (range === void 0) {
      return;
    }
    this.setArray(range, vertex);
    if (!this.isThereSpaceForArray(vertex)) {
      return;
    }
    for (const address of range.addresses(this)) {
      this.addressMapping.setCell(address, vertex);
    }
  }
  truncateRanges(span, coordinate) {
    const {
      verticesToRemove,
      verticesToMerge,
      verticesWithChangedSize
    } = this.rangeMapping.truncateRanges(span, coordinate);
    for (const [existingVertex, mergedVertex] of verticesToMerge) {
      this.rerouteDependents(mergedVertex, existingVertex);
      this.removeVertexAndCleanupDependencies(mergedVertex);
    }
    for (const rangeVertex of verticesToRemove) {
      this.removeVertexAndCleanupDependencies(rangeVertex);
    }
    return verticesWithChangedSize;
  }
  fixArraysAfterAddingRow(sheet, rowStart, numberOfRows) {
    this.arrayMapping.moveArrayVerticesAfterRowByRows(sheet, rowStart, numberOfRows);
    if (rowStart <= 0) {
      return;
    }
    for (const [, array] of this.arrayMapping.arraysInRows(RowsSpan.fromRowStartAndEnd(sheet, rowStart - 1, rowStart - 1))) {
      const arrayRange = array.getRange();
      for (let col = arrayRange.start.col; col <= arrayRange.end.col; ++col) {
        for (let row = rowStart; row <= arrayRange.end.row; ++row) {
          const destination = simpleCellAddress(sheet, col, row);
          const source = simpleCellAddress(sheet, col, row + numberOfRows);
          const value = array.getArrayCellValue(destination);
          this.addressMapping.moveCell(source, destination);
          this.changes.addChange(EmptyValue, source, value);
        }
      }
    }
  }
  fixArraysAfterRemovingRows(sheet, rowStart, numberOfRows) {
    this.arrayMapping.moveArrayVerticesAfterRowByRows(sheet, rowStart, -numberOfRows);
    if (rowStart <= 0) {
      return;
    }
    for (const [, array] of this.arrayMapping.arraysInRows(RowsSpan.fromRowStartAndEnd(sheet, rowStart - 1, rowStart - 1))) {
      if (this.isThereSpaceForArray(array)) {
        for (const address of array.getRange().addresses(this)) {
          this.addressMapping.setCell(address, array);
        }
      } else {
        this.setNoSpaceIfArray(array);
      }
    }
  }
  fixArraysAfterAddingColumn(sheet, columnStart, numberOfColumns) {
    this.arrayMapping.moveArrayVerticesAfterColumnByColumns(sheet, columnStart, numberOfColumns);
    if (columnStart <= 0) {
      return;
    }
    for (const [, array] of this.arrayMapping.arraysInCols(ColumnsSpan.fromColumnStartAndEnd(sheet, columnStart - 1, columnStart - 1))) {
      const arrayRange = array.getRange();
      for (let row = arrayRange.start.row; row <= arrayRange.end.row; ++row) {
        for (let col = columnStart; col <= arrayRange.end.col; ++col) {
          const destination = simpleCellAddress(sheet, col, row);
          const source = simpleCellAddress(sheet, col + numberOfColumns, row);
          const value = array.getArrayCellValue(destination);
          this.addressMapping.moveCell(source, destination);
          this.changes.addChange(EmptyValue, source, value);
        }
      }
    }
  }
  fixArraysAfterRemovingColumns(sheet, columnStart, numberOfColumns) {
    this.arrayMapping.moveArrayVerticesAfterColumnByColumns(sheet, columnStart, -numberOfColumns);
    if (columnStart <= 0) {
      return;
    }
    for (const [, array] of this.arrayMapping.arraysInCols(ColumnsSpan.fromColumnStartAndEnd(sheet, columnStart - 1, columnStart - 1))) {
      if (this.isThereSpaceForArray(array)) {
        for (const address of array.getRange().addresses(this)) {
          this.addressMapping.setCell(address, array);
        }
      } else {
        this.setNoSpaceIfArray(array);
      }
    }
  }
  shrinkPossibleArrayAndGetCell(address) {
    const vertex = this.getCell(address);
    if (!(vertex instanceof ArrayFormulaVertex)) {
      return vertex;
    }
    this.setNoSpaceIfArray(vertex);
    return this.getCell(address);
  }
  setNoSpaceIfArray(vertex) {
    if (vertex instanceof ArrayFormulaVertex) {
      this.shrinkArrayToCorner(vertex);
      vertex.setNoSpace();
    }
  }
  /**
   * Removes a vertex from the graph and range mapping and cleans up its dependencies.
   */
  removeVertex(vertex) {
    this.removeVertexAndCleanupDependencies(vertex);
    if (vertex instanceof RangeVertex) {
      this.rangeMapping.removeVertexIfExists(vertex);
    }
  }
  /**
   * Reroutes dependent vertices of source to target. Also removes the edge target -> source if it exists.
   */
  rerouteDependents(source, target) {
    const dependents = this.graph.adjacentNodes(source);
    this.graph.removeEdgeIfExists(target, source);
    dependents.forEach((adjacentNode) => {
      if (this.graph.hasNode(adjacentNode)) {
        this.graph.addEdge(target, adjacentNode);
      }
    });
  }
  /**
   * Removes a vertex from graph and reroutes its dependencies to other vertex. Also removes the edge vertexToKeep -> vertexToDelete if it exists.
   */
  removeVertexAndRerouteDependencies(vertexToDelete, vertexToKeep) {
    const dependencies = this.graph.removeNode(vertexToDelete);
    this.graph.removeEdgeIfExists(vertexToKeep, vertexToDelete);
    dependencies.forEach(([_, dependency]) => {
      if (this.graph.hasNode(dependency)) {
        this.graph.addEdge(dependency, vertexToKeep);
      }
    });
  }
  /**
   * Removes a vertex from graph and cleans up its dependencies.
   * Dependency clean up = remove all RangeVertex and EmptyCellVertex dependencies if no other vertex depends on them.
   * Also cleans up placeholder sheets that have no remaining vertices (not needed anymore)
   */
  removeVertexAndCleanupDependencies(inputVertex) {
    const dependencies = new Set(this.graph.removeNode(inputVertex));
    const affectedSheets = /* @__PURE__ */ new Set();
    while (dependencies.size > 0) {
      const dependency = dependencies.values().next().value;
      dependencies.delete(dependency);
      const [address, vertex] = dependency;
      if (this.graph.hasNode(vertex) && this.graph.adjacentNodesCount(vertex) === 0) {
        if (vertex instanceof RangeVertex || vertex instanceof EmptyCellVertex) {
          this.graph.removeNode(vertex).forEach((candidate) => dependencies.add(candidate));
        }
        if (vertex instanceof RangeVertex) {
          this.rangeMapping.removeVertexIfExists(vertex);
          affectedSheets.add(vertex.sheet);
        } else if (vertex instanceof EmptyCellVertex && isSimpleCellAddress(address)) {
          this.addressMapping.removeCell(address);
          affectedSheets.add(address.sheet);
        }
      }
    }
    this.cleanupPlaceholderSheets(affectedSheets);
  }
  /**
   * Removes placeholder sheets that have no remaining vertices.
   */
  cleanupPlaceholderSheets(sheetIds) {
    for (const sheetId of sheetIds) {
      if (this.isPlaceholder(sheetId) && !this.addressMapping.hasAnyEntries(sheetId) && this.rangeMapping.getNumberOfRangesInSheet(sheetId) === 0) {
        this.sheetMapping.removeSheetIfExists(sheetId, {
          includePlaceholders: true
        });
        this.addressMapping.removeSheetIfExists(sheetId);
      }
    }
  }
}
class EmptyCellVertex extends CellVertex {
  constructor() {
    super();
  }
  /**
   * Retrieves cell value bound to that singleton
   */
  getCellValue() {
    return EmptyValue;
  }
}
class ValueCellVertex extends CellVertex {
  /** Static cell value. */
  constructor(parsedValue, rawValue) {
    super();
    this.parsedValue = parsedValue;
    this.rawValue = rawValue;
  }
  getValues() {
    return {
      parsedValue: this.parsedValue,
      rawValue: this.rawValue
    };
  }
  setValues(values2) {
    this.parsedValue = values2.parsedValue;
    this.rawValue = values2.rawValue;
  }
  /**
   * Returns cell value stored in vertex
   */
  getCellValue() {
    return this.parsedValue;
  }
}
class ParsingErrorVertex extends CellVertex {
  /**
   * Constructor
   */
  constructor(errors, rawInput) {
    super();
    this.errors = errors;
    this.rawInput = rawInput;
  }
  /**
   * Returns the value of the cell.
   */
  getCellValue() {
    const firstNonemptyMessage = this.errors.map((error2) => error2.message).find((msg) => msg);
    return CellError.parsingError(firstNonemptyMessage);
  }
  /**
   * Returns the formula of the cell.
   */
  getFormula() {
    return this.rawInput;
  }
}
class SparseStrategy {
  constructor(width, height) {
    this.width = width;
    this.height = height;
    this.mapping = /* @__PURE__ */ new Map();
  }
  /** @inheritDoc */
  getCell(address) {
    var _a;
    return (_a = this.mapping.get(address.col)) === null || _a === void 0 ? void 0 : _a.get(address.row);
  }
  /** @inheritDoc */
  setCell(address, newVertex) {
    this.width = Math.max(this.width, address.col + 1);
    this.height = Math.max(this.height, address.row + 1);
    let colMapping = this.mapping.get(address.col);
    if (!colMapping) {
      colMapping = /* @__PURE__ */ new Map();
      this.mapping.set(address.col, colMapping);
    }
    colMapping.set(address.row, newVertex);
  }
  /** @inheritDoc */
  has(address) {
    var _a;
    return !!((_a = this.mapping.get(address.col)) === null || _a === void 0 ? void 0 : _a.get(address.row));
  }
  /** @inheritDoc */
  getHeight() {
    return this.height;
  }
  /** @inheritDoc */
  getWidth() {
    return this.width;
  }
  removeCell(address) {
    var _a;
    (_a = this.mapping.get(address.col)) === null || _a === void 0 ? void 0 : _a.delete(address.row);
  }
  addRows(row, numberOfRows) {
    this.mapping.forEach((rowMapping) => {
      const tmpMapping = /* @__PURE__ */ new Map();
      rowMapping.forEach((vertex, rowNumber) => {
        if (rowNumber >= row) {
          tmpMapping.set(rowNumber + numberOfRows, vertex);
          rowMapping.delete(rowNumber);
        }
      });
      tmpMapping.forEach((vertex, rowNumber) => {
        rowMapping.set(rowNumber, vertex);
      });
    });
    this.height += numberOfRows;
  }
  addColumns(column, numberOfColumns) {
    const tmpMapping = /* @__PURE__ */ new Map();
    this.mapping.forEach((rowMapping, colNumber) => {
      if (colNumber >= column) {
        tmpMapping.set(colNumber + numberOfColumns, rowMapping);
        this.mapping.delete(colNumber);
      }
    });
    tmpMapping.forEach((rowMapping, colNumber) => {
      this.mapping.set(colNumber, rowMapping);
    });
    this.width += numberOfColumns;
  }
  removeRows(removedRows) {
    this.mapping.forEach((rowMapping) => {
      const tmpMapping = /* @__PURE__ */ new Map();
      rowMapping.forEach((vertex, rowNumber) => {
        if (rowNumber >= removedRows.rowStart) {
          rowMapping.delete(rowNumber);
          if (rowNumber > removedRows.rowEnd) {
            tmpMapping.set(rowNumber - removedRows.numberOfRows, vertex);
          }
        }
      });
      tmpMapping.forEach((vertex, rowNumber) => {
        rowMapping.set(rowNumber, vertex);
      });
    });
    const rightmostRowRemoved = Math.min(this.height - 1, removedRows.rowEnd);
    const numberOfRowsRemoved = Math.max(0, rightmostRowRemoved - removedRows.rowStart + 1);
    this.height = Math.max(0, this.height - numberOfRowsRemoved);
  }
  removeColumns(removedColumns) {
    const tmpMapping = /* @__PURE__ */ new Map();
    this.mapping.forEach((rowMapping, colNumber) => {
      if (colNumber >= removedColumns.columnStart) {
        this.mapping.delete(colNumber);
        if (colNumber > removedColumns.columnEnd) {
          tmpMapping.set(colNumber - removedColumns.numberOfColumns, rowMapping);
        }
      }
    });
    tmpMapping.forEach((rowMapping, colNumber) => {
      this.mapping.set(colNumber, rowMapping);
    });
    const rightmostColumnRemoved = Math.min(this.width - 1, removedColumns.columnEnd);
    const numberOfColumnsRemoved = Math.max(0, rightmostColumnRemoved - removedColumns.columnStart + 1);
    this.width = Math.max(0, this.width - numberOfColumnsRemoved);
  }
  *getEntries(sheet) {
    for (const [colNumber, col] of this.mapping) {
      for (const [rowNumber, value] of col) {
        yield [simpleCellAddress(sheet, colNumber, rowNumber), value];
      }
    }
  }
  *verticesFromColumn(column) {
    const colMapping = this.mapping.get(column);
    if (colMapping === void 0) {
      return;
    }
    for (const [_, vertex] of colMapping) {
      yield vertex;
    }
  }
  *verticesFromRow(row) {
    for (const colMapping of this.mapping.values()) {
      const rowVertex = colMapping.get(row);
      if (rowVertex !== void 0) {
        yield rowVertex;
      }
    }
  }
  *verticesFromColumnsSpan(columnsSpan) {
    for (const column of columnsSpan.columns()) {
      const colMapping = this.mapping.get(column);
      if (colMapping === void 0) {
        continue;
      }
      for (const [_, vertex] of colMapping) {
        yield vertex;
      }
    }
  }
  *verticesFromRowsSpan(rowsSpan) {
    for (const colMapping of this.mapping.values()) {
      for (const row of rowsSpan.rows()) {
        const rowVertex = colMapping.get(row);
        if (rowVertex !== void 0) {
          yield rowVertex;
        }
      }
    }
  }
  *entriesFromRowsSpan(rowsSpan) {
    for (const [col, colMapping] of this.mapping.entries()) {
      for (const row of rowsSpan.rows()) {
        const rowVertex = colMapping.get(row);
        if (rowVertex !== void 0) {
          yield [simpleCellAddress(rowsSpan.sheet, col, row), rowVertex];
        }
      }
    }
  }
  *entriesFromColumnsSpan(columnsSpan) {
    for (const col of columnsSpan.columns()) {
      const colMapping = this.mapping.get(col);
      if (colMapping !== void 0) {
        for (const [row, vertex] of colMapping.entries()) {
          yield [simpleCellAddress(columnsSpan.sheet, col, row), vertex];
        }
      }
    }
  }
  *vertices() {
    for (const [_, col] of this.mapping) {
      for (const [_2, value] of col) {
        if (value !== void 0) {
          yield value;
        }
      }
    }
  }
}
class DenseStrategy {
  /**
   * @param width - width of the stored sheet
   * @param height - height of the stored sheet
   */
  constructor(width, height) {
    this.width = width;
    this.height = height;
    this.mapping = new Array(height);
    for (let i = 0; i < height; i++) {
      this.mapping[i] = new Array(width);
    }
  }
  /** @inheritDoc */
  getCell(address) {
    return this.getCellVertex(address.col, address.row);
  }
  /** @inheritDoc */
  setCell(address, newVertex) {
    this.width = Math.max(this.width, address.col + 1);
    this.height = Math.max(this.height, address.row + 1);
    const rowMapping = this.mapping[address.row];
    if (!rowMapping) {
      this.mapping[address.row] = new Array(this.width);
    }
    this.mapping[address.row][address.col] = newVertex;
  }
  /** @inheritDoc */
  has(address) {
    const row = this.mapping[address.row];
    if (!row) {
      return false;
    }
    return !!row[address.col];
  }
  /** @inheritDoc */
  getHeight() {
    return this.height;
  }
  /** @inheritDoc */
  getWidth() {
    return this.width;
  }
  removeCell(address) {
    if (this.mapping[address.row] !== void 0) {
      delete this.mapping[address.row][address.col];
    }
  }
  addRows(row, numberOfRows) {
    const newRows = [];
    for (let i = 0; i < numberOfRows; i++) {
      newRows.push(new Array(this.width));
    }
    this.mapping.splice(row, 0, ...newRows);
    this.height += numberOfRows;
  }
  addColumns(column, numberOfColumns) {
    for (let i = 0; i < this.height; i++) {
      if (this.mapping[i] !== void 0) {
        this.mapping[i].splice(column, 0, ...new Array(numberOfColumns));
      }
    }
    this.width += numberOfColumns;
  }
  removeRows(removedRows) {
    this.mapping.splice(removedRows.rowStart, removedRows.numberOfRows);
    const rightmostRowRemoved = Math.min(this.height - 1, removedRows.rowEnd);
    const numberOfRowsRemoved = Math.max(0, rightmostRowRemoved - removedRows.rowStart + 1);
    this.height = Math.max(0, this.height - numberOfRowsRemoved);
  }
  removeColumns(removedColumns) {
    for (let i = 0; i < this.height; i++) {
      if (this.mapping[i] !== void 0) {
        this.mapping[i].splice(removedColumns.columnStart, removedColumns.numberOfColumns);
      }
    }
    const rightmostColumnRemoved = Math.min(this.width - 1, removedColumns.columnEnd);
    const numberOfColumnsRemoved = Math.max(0, rightmostColumnRemoved - removedColumns.columnStart + 1);
    this.width = Math.max(0, this.width - numberOfColumnsRemoved);
  }
  *getEntries(sheet) {
    for (let y = 0; y < this.height; ++y) {
      for (let x = 0; x < this.width; ++x) {
        const vertex = this.getCellVertex(x, y);
        if (vertex) {
          yield [simpleCellAddress(sheet, x, y), vertex];
        }
      }
    }
  }
  *verticesFromColumn(column) {
    for (let y = 0; y < this.height; ++y) {
      const vertex = this.getCellVertex(column, y);
      if (vertex) {
        yield vertex;
      }
    }
  }
  *verticesFromRow(row) {
    for (let x = 0; x < this.width; ++x) {
      const vertex = this.getCellVertex(x, row);
      if (vertex) {
        yield vertex;
      }
    }
  }
  *verticesFromColumnsSpan(columnsSpan) {
    for (let x = columnsSpan.columnStart; x <= columnsSpan.columnEnd; ++x) {
      for (let y = 0; y < this.height; ++y) {
        const vertex = this.getCellVertex(x, y);
        if (vertex) {
          yield vertex;
        }
      }
    }
  }
  *verticesFromRowsSpan(rowsSpan) {
    for (let x = 0; x < this.width; ++x) {
      for (let y = rowsSpan.rowStart; y <= rowsSpan.rowEnd; ++y) {
        const vertex = this.getCellVertex(x, y);
        if (vertex) {
          yield vertex;
        }
      }
    }
  }
  *entriesFromRowsSpan(rowsSpan) {
    for (let x = 0; x < this.width; ++x) {
      for (let y = rowsSpan.rowStart; y <= rowsSpan.rowEnd; ++y) {
        const vertex = this.getCellVertex(x, y);
        if (vertex) {
          yield [simpleCellAddress(rowsSpan.sheet, x, y), vertex];
        }
      }
    }
  }
  *entriesFromColumnsSpan(columnsSpan) {
    for (let x = columnsSpan.columnStart; x <= columnsSpan.columnEnd; ++x) {
      for (let y = 0; y < this.height; ++y) {
        const vertex = this.getCellVertex(x, y);
        if (vertex) {
          yield [simpleCellAddress(columnsSpan.sheet, x, y), vertex];
        }
      }
    }
  }
  *vertices() {
    for (let y = 0; y < this.height; ++y) {
      for (let x = 0; x < this.width; ++x) {
        const vertex = this.getCellVertex(x, y);
        if (vertex) {
          yield vertex;
        }
      }
    }
  }
  getCellVertex(x, y) {
    var _a;
    return (_a = this.mapping[y]) === null || _a === void 0 ? void 0 : _a[x];
  }
}
var ErrorType;
(function(ErrorType2) {
  ErrorType2["DIV_BY_ZERO"] = "DIV_BY_ZERO";
  ErrorType2["NAME"] = "NAME";
  ErrorType2["VALUE"] = "VALUE";
  ErrorType2["NUM"] = "NUM";
  ErrorType2["NA"] = "NA";
  ErrorType2["CYCLE"] = "CYCLE";
  ErrorType2["REF"] = "REF";
  ErrorType2["SPILL"] = "SPILL";
  ErrorType2["LIC"] = "LIC";
  ErrorType2["ERROR"] = "ERROR";
})(ErrorType || (ErrorType = {}));
var CellType;
(function(CellType2) {
  CellType2["FORMULA"] = "FORMULA";
  CellType2["VALUE"] = "VALUE";
  CellType2["ARRAY"] = "ARRAY";
  CellType2["EMPTY"] = "EMPTY";
  CellType2["ARRAYFORMULA"] = "ARRAYFORMULA";
})(CellType || (CellType = {}));
const getCellType = (vertex, address) => {
  if (vertex instanceof ArrayFormulaVertex) {
    if (vertex.isLeftCorner(address)) {
      return CellType.ARRAYFORMULA;
    } else {
      return CellType.ARRAY;
    }
  }
  if (vertex instanceof ScalarFormulaVertex || vertex instanceof ParsingErrorVertex) {
    return CellType.FORMULA;
  }
  if (vertex instanceof ValueCellVertex) {
    return CellType.VALUE;
  }
  return CellType.EMPTY;
};
var CellValueNoNumber;
(function(CellValueNoNumber2) {
  CellValueNoNumber2["EMPTY"] = "EMPTY";
  CellValueNoNumber2["NUMBER"] = "NUMBER";
  CellValueNoNumber2["STRING"] = "STRING";
  CellValueNoNumber2["BOOLEAN"] = "BOOLEAN";
  CellValueNoNumber2["ERROR"] = "ERROR";
})(CellValueNoNumber || (CellValueNoNumber = {}));
var CellValueJustNumber;
(function(CellValueJustNumber2) {
  CellValueJustNumber2["NUMBER"] = "NUMBER";
})(CellValueJustNumber || (CellValueJustNumber = {}));
const CellValueType = Object.assign(Object.assign({}, CellValueNoNumber), CellValueJustNumber);
const CellValueDetailedType = Object.assign(Object.assign({}, CellValueNoNumber), NumberType);
const CellValueTypeOrd = (arg) => {
  switch (arg) {
    case CellValueType.EMPTY:
      return 0;
    case CellValueType.NUMBER:
      return 1;
    case CellValueType.STRING:
      return 2;
    case CellValueType.BOOLEAN:
      return 3;
    case CellValueType.ERROR:
      return 4;
  }
  throw new Error("Cell value not computed");
};
const getCellValueType = (cellValue) => {
  if (cellValue === EmptyValue) {
    return CellValueType.EMPTY;
  }
  if (cellValue instanceof CellError || cellValue instanceof SimpleRangeValue) {
    return CellValueType.ERROR;
  }
  if (typeof cellValue === "string") {
    return CellValueType.STRING;
  } else if (isExtendedNumber(cellValue)) {
    return CellValueType.NUMBER;
  } else if (typeof cellValue === "boolean") {
    return CellValueType.BOOLEAN;
  }
  throw new Error("Cell value not computed");
};
const getCellValueDetailedType = (cellValue) => {
  if (isExtendedNumber(cellValue)) {
    return getTypeOfExtendedNumber(cellValue);
  } else {
    return getCellValueType(cellValue);
  }
};
const getCellValueFormat = (cellValue) => {
  if (isExtendedNumber(cellValue)) {
    return getFormatOfExtendedNumber(cellValue);
  } else {
    return void 0;
  }
};
class CellError {
  constructor(type, message, root) {
    this.type = type;
    this.message = message;
    this.root = root;
  }
  /**
   * Returns a CellError with a given message.
   * @param {string} detailedMessage - message to be displayed
   */
  static parsingError(detailedMessage) {
    return new CellError(ErrorType.ERROR, `${ErrorMessage.ParseError}${detailedMessage ? " " + detailedMessage : ""}`);
  }
  attachRootVertex(vertex) {
    if (this.root === void 0) {
      return new CellError(this.type, this.message, vertex);
    } else {
      return this;
    }
  }
}
const simpleRowAddress = (sheet, row) => ({
  sheet,
  row
});
const invalidSimpleRowAddress = (address) => address.row < 0;
const simpleColumnAddress = (sheet, col) => ({
  sheet,
  col
});
const invalidSimpleColumnAddress = (address) => address.col < 0;
const simpleCellAddress = (sheet, col, row) => ({
  sheet,
  col,
  row
});
const isColOrRowInvalid = (address) => address.col < 0 || address.row < 0;
const movedSimpleCellAddress = (address, toSheet, toRight, toBottom) => {
  return simpleCellAddress(toSheet, address.col + toRight, address.row + toBottom);
};
const addressKey = (address) => `${address.sheet},${address.row},${address.col}`;
function isSimpleCellAddress(obj) {
  var _a, _b, _c;
  return obj && (typeof obj === "object" || typeof obj === "function") && typeof ((_a = obj) === null || _a === void 0 ? void 0 : _a.sheet) === "number" && typeof ((_b = obj) === null || _b === void 0 ? void 0 : _b.col) === "number" && typeof ((_c = obj) === null || _c === void 0 ? void 0 : _c.row) === "number";
}
const absoluteSheetReference = (address, baseAddress) => {
  var _a;
  return (_a = address.sheet) !== null && _a !== void 0 ? _a : baseAddress.sheet;
};
const equalSimpleCellAddress = (left2, right2) => {
  return left2.sheet === right2.sheet && left2.col === right2.col && left2.row === right2.row;
};
const WRONG_RANGE_SIZE = "AbsoluteCellRange: Wrong range size";
function isSimpleCellRange(val) {
  if (val && (typeof val === "object" || typeof val === "function")) {
    const obj = val;
    return "start" in obj && isSimpleCellAddress(obj.start) && "end" in obj && isSimpleCellAddress(obj.end);
  } else {
    return false;
  }
}
const simpleCellRange = (start, end) => ({
  start,
  end
});
class AbsoluteCellRange {
  constructor(start, end) {
    if (start.sheet !== end.sheet) {
      throw new SheetsNotEqual(start.sheet, end.sheet);
    }
    this.start = simpleCellAddress(start.sheet, start.col, start.row);
    this.end = simpleCellAddress(end.sheet, end.col, end.row);
  }
  get sheet() {
    return this.start.sheet;
  }
  static fromSimpleCellAddresses(start, end) {
    if (start.sheet !== end.sheet) {
      throw new SheetsNotEqual(start.sheet, end.sheet);
    }
    const width = end.col - start.col;
    const height = end.row - start.row;
    if (Number.isFinite(height) && Number.isFinite(width)) {
      return new AbsoluteCellRange(start, end);
    }
    if (Number.isFinite(height)) {
      return new AbsoluteRowRange(start.sheet, start.row, end.row);
    }
    return new AbsoluteColumnRange(start.sheet, start.col, end.col);
  }
  static fromAst(ast, baseAddress) {
    if (ast.type === AstNodeType.CELL_RANGE) {
      return AbsoluteCellRange.fromCellRange(ast, baseAddress);
    } else if (ast.type === AstNodeType.COLUMN_RANGE) {
      return AbsoluteColumnRange.fromColumnRange(ast, baseAddress);
    } else {
      return AbsoluteRowRange.fromRowRangeAst(ast, baseAddress);
    }
  }
  static fromAstOrUndef(ast, baseAddress) {
    try {
      return AbsoluteCellRange.fromAst(ast, baseAddress);
    } catch (_e) {
      return void 0;
    }
  }
  static fromCellRange(x, baseAddress) {
    return new AbsoluteCellRange(x.start.toSimpleCellAddress(baseAddress), x.end.toSimpleCellAddress(baseAddress));
  }
  static spanFrom(topLeftCorner, width, height) {
    const ret = AbsoluteCellRange.spanFromOrUndef(topLeftCorner, width, height);
    if (ret === void 0) {
      throw new Error(WRONG_RANGE_SIZE);
    }
    return ret;
  }
  static spanFromOrUndef(topLeftCorner, width, height) {
    if (!Number.isFinite(width) && Number.isFinite(height)) {
      if (topLeftCorner.col !== 0) {
        return void 0;
      }
      return new AbsoluteRowRange(topLeftCorner.sheet, topLeftCorner.row, topLeftCorner.row + height - 1);
    } else if (!Number.isFinite(height) && Number.isFinite(width)) {
      if (topLeftCorner.row !== 0) {
        return void 0;
      }
      return new AbsoluteColumnRange(topLeftCorner.sheet, topLeftCorner.col, topLeftCorner.col + width - 1);
    } else if (Number.isFinite(height) && Number.isFinite(width)) {
      return new AbsoluteCellRange(topLeftCorner, simpleCellAddress(topLeftCorner.sheet, topLeftCorner.col + width - 1, topLeftCorner.row + height - 1));
    }
    return void 0;
  }
  static fromCoordinates(sheet, x1, y1, x2, y2) {
    return new AbsoluteCellRange(simpleCellAddress(sheet, x1, y1), simpleCellAddress(sheet, x2, y2));
  }
  isFinite() {
    return Number.isFinite(this.size());
  }
  doesOverlap(other) {
    if (this.start.sheet != other.start.sheet) {
      return false;
    }
    if (this.end.row < other.start.row || this.start.row > other.end.row) {
      return false;
    }
    if (this.end.col < other.start.col || this.start.col > other.end.col) {
      return false;
    }
    return true;
  }
  addressInRange(address) {
    if (this.sheet !== address.sheet) {
      return false;
    }
    return this.start.row <= address.row && this.end.row >= address.row && this.start.col <= address.col && this.end.col >= address.col;
  }
  columnInRange(address) {
    if (this.sheet !== address.sheet) {
      return false;
    }
    return this.start.col <= address.col && this.end.col >= address.col;
  }
  rowInRange(address) {
    if (this.sheet !== address.sheet) {
      return false;
    }
    return this.start.row <= address.row && this.end.row >= address.row;
  }
  containsRange(range) {
    return this.addressInRange(range.start) && this.addressInRange(range.end);
  }
  intersectionWith(other) {
    if (this.sheet !== other.start.sheet) {
      return void 0;
    }
    const startRow = Math.max(this.start.row, other.start.row);
    const endRow = Math.min(this.end.row, other.end.row);
    const startCol = Math.max(this.start.col, other.start.col);
    const endCol = Math.min(this.end.col, other.end.col);
    if (startRow > endRow || startCol > endCol) {
      return void 0;
    }
    return new AbsoluteCellRange(simpleCellAddress(this.sheet, startCol, startRow), simpleCellAddress(this.sheet, endCol, endRow));
  }
  includesRow(row) {
    return this.start.row < row && this.end.row >= row;
  }
  includesColumn(column) {
    return this.start.col < column && this.end.col >= column;
  }
  shiftByRows(numberOfRows) {
    this.start.row += numberOfRows;
    this.end.row += numberOfRows;
  }
  expandByRows(numberOfRows) {
    this.end.row += numberOfRows;
  }
  shiftByColumns(numberOfColumns) {
    this.start.col += numberOfColumns;
    this.end.col += numberOfColumns;
  }
  shifted(byCols, byRows) {
    return AbsoluteCellRange.spanFrom(simpleCellAddress(this.sheet, this.start.col + byCols, this.start.row + byRows), this.width(), this.height());
  }
  expandByColumns(numberOfColumns) {
    this.end.col += numberOfColumns;
  }
  moveToSheet(toSheet) {
    this.start.sheet = toSheet;
    this.end.sheet = toSheet;
  }
  removeSpan(span) {
    if (span instanceof RowsSpan) {
      this.removeRows(span.start, span.end);
    } else {
      this.removeColumns(span.start, span.end);
    }
  }
  shouldBeRemoved() {
    return this.width() <= 0 || this.height() <= 0;
  }
  rangeWithSameWidth(startRow, numberOfRows) {
    return AbsoluteCellRange.spanFrom(simpleCellAddress(this.sheet, this.start.col, startRow), this.width(), numberOfRows);
  }
  rangeWithSameHeight(startColumn, numberOfColumns) {
    return AbsoluteCellRange.spanFrom(simpleCellAddress(this.sheet, startColumn, this.start.row), numberOfColumns, this.height());
  }
  toString() {
    return `${this.start.sheet},${this.start.col},${this.start.row},${this.end.col},${this.end.row}`;
  }
  width() {
    return this.end.col - this.start.col + 1;
  }
  height() {
    return this.end.row - this.start.row + 1;
  }
  size() {
    return this.height() * this.width();
  }
  arrayOfAddressesInRange() {
    const result = [];
    for (let y = 0; y < this.height(); ++y) {
      result[y] = [];
      for (let x = 0; x < this.width(); ++x) {
        const value = simpleCellAddress(this.sheet, this.start.col + x, this.start.row + y);
        result[y].push(value);
      }
    }
    return result;
  }
  withStart(newStart) {
    return new AbsoluteCellRange(newStart, this.end);
  }
  sameDimensionsAs(other) {
    return this.width() === other.width() && this.height() === other.height();
  }
  sameAs(other) {
    return equalSimpleCellAddress(this.start, other.start) && equalSimpleCellAddress(this.end, other.end);
  }
  addressesArrayMap(dependencyGraph, op) {
    const ret = [];
    let currentRow = this.start.row;
    while (currentRow <= this.effectiveEndRow(dependencyGraph)) {
      let currentColumn = this.start.col;
      const tmp = [];
      while (currentColumn <= this.effectiveEndColumn(dependencyGraph)) {
        tmp.push(op(simpleCellAddress(this.start.sheet, currentColumn, currentRow)));
        currentColumn++;
      }
      ret.push(tmp);
      currentRow++;
    }
    return ret;
  }
  addresses(dependencyGraph) {
    const ret = [];
    let currentRow = this.start.row;
    const limitRow = this.effectiveEndRow(dependencyGraph);
    const limitColumn = this.effectiveEndColumn(dependencyGraph);
    while (currentRow <= limitRow) {
      let currentColumn = this.start.col;
      while (currentColumn <= limitColumn) {
        ret.push(simpleCellAddress(this.start.sheet, currentColumn, currentRow));
        currentColumn++;
      }
      currentRow++;
    }
    return ret;
  }
  *addressesWithDirection(right2, bottom2, dependencyGraph) {
    if (right2 > 0) {
      if (bottom2 > 0) {
        let currentRow = this.effectiveEndRow(dependencyGraph);
        while (currentRow >= this.start.row) {
          let currentColumn = this.effectiveEndColumn(dependencyGraph);
          while (currentColumn >= this.start.col) {
            yield simpleCellAddress(this.start.sheet, currentColumn, currentRow);
            currentColumn -= 1;
          }
          currentRow -= 1;
        }
      } else {
        let currentRow = this.start.row;
        while (currentRow <= this.effectiveEndRow(dependencyGraph)) {
          let currentColumn = this.effectiveEndColumn(dependencyGraph);
          while (currentColumn >= this.start.col) {
            yield simpleCellAddress(this.start.sheet, currentColumn, currentRow);
            currentColumn -= 1;
          }
          currentRow += 1;
        }
      }
    } else {
      if (bottom2 > 0) {
        let currentRow = this.effectiveEndRow(dependencyGraph);
        while (currentRow >= this.start.row) {
          let currentColumn = this.start.col;
          while (currentColumn <= this.effectiveEndColumn(dependencyGraph)) {
            yield simpleCellAddress(this.start.sheet, currentColumn, currentRow);
            currentColumn += 1;
          }
          currentRow -= 1;
        }
      } else {
        let currentRow = this.start.row;
        while (currentRow <= this.effectiveEndRow(dependencyGraph)) {
          let currentColumn = this.start.col;
          while (currentColumn <= this.effectiveEndColumn(dependencyGraph)) {
            yield simpleCellAddress(this.start.sheet, currentColumn, currentRow);
            currentColumn += 1;
          }
          currentRow += 1;
        }
      }
    }
  }
  getAddress(col, row) {
    if (col < 0 || row < 0 || row > this.height() - 1 || col > this.width() - 1) {
      throw Error("Index out of bound");
    }
    return simpleCellAddress(this.start.sheet, this.start.col + col, this.start.row + row);
  }
  exceedsSheetSizeLimits(maxColumns, maxRows) {
    return this.end.col >= maxColumns || this.end.row >= maxRows;
  }
  effectiveEndColumn(_dependencyGraph) {
    return this.end.col;
  }
  effectiveEndRow(_dependencyGraph) {
    return this.end.row;
  }
  effectiveWidth(_dependencyGraph) {
    return this.width();
  }
  effectiveHeight(_dependencyGraph) {
    return this.height();
  }
  removeRows(rowStart, rowEnd) {
    if (rowStart > this.end.row) {
      return;
    }
    if (rowEnd < this.start.row) {
      const numberOfRows = rowEnd - rowStart + 1;
      return this.shiftByRows(-numberOfRows);
    }
    if (rowStart <= this.start.row) {
      this.start.row = rowStart;
    }
    this.end.row -= Math.min(rowEnd, this.end.row) - rowStart + 1;
  }
  removeColumns(columnStart, columnEnd) {
    if (columnStart > this.end.col) {
      return;
    }
    if (columnEnd < this.start.col) {
      const numberOfColumns = columnEnd - columnStart + 1;
      return this.shiftByColumns(-numberOfColumns);
    }
    if (columnStart <= this.start.col) {
      this.start.col = columnStart;
    }
    this.end.col -= Math.min(columnEnd, this.end.col) - columnStart + 1;
  }
}
class AbsoluteColumnRange extends AbsoluteCellRange {
  constructor(sheet, columnStart, columnEnd) {
    super(simpleCellAddress(sheet, columnStart, 0), simpleCellAddress(sheet, columnEnd, Number.POSITIVE_INFINITY));
  }
  static fromColumnRange(x, baseAddress) {
    const start = x.start.toSimpleColumnAddress(baseAddress);
    const end = x.end.toSimpleColumnAddress(baseAddress);
    if (start.sheet !== end.sheet) {
      throw new SheetsNotEqual(start.sheet, end.sheet);
    }
    return new AbsoluteColumnRange(start.sheet, start.col, end.col);
  }
  shouldBeRemoved() {
    return this.width() <= 0;
  }
  shiftByRows(_numberOfRows) {
    return;
  }
  expandByRows(_numberOfRows) {
    return;
  }
  shifted(byCols, _byRows) {
    return new AbsoluteColumnRange(this.sheet, this.start.col + byCols, this.end.col + byCols);
  }
  rangeWithSameHeight(startColumn, numberOfColumns) {
    return new AbsoluteColumnRange(this.sheet, startColumn, startColumn + numberOfColumns - 1);
  }
  exceedsSheetSizeLimits(maxColumns, _maxRows) {
    return this.end.col >= maxColumns;
  }
  effectiveEndRow(dependencyGraph) {
    return this.effectiveHeight(dependencyGraph) - 1;
  }
  effectiveHeight(dependencyGraph) {
    return dependencyGraph.getSheetHeight(this.sheet);
  }
  removeRows(_rowStart, _rowEnd) {
    return;
  }
}
class AbsoluteRowRange extends AbsoluteCellRange {
  constructor(sheet, rowStart, rowEnd) {
    super(simpleCellAddress(sheet, 0, rowStart), simpleCellAddress(sheet, Number.POSITIVE_INFINITY, rowEnd));
  }
  static fromRowRangeAst(x, baseAddress) {
    const start = x.start.toSimpleRowAddress(baseAddress);
    const end = x.end.toSimpleRowAddress(baseAddress);
    if (start.sheet !== end.sheet) {
      throw new SheetsNotEqual(start.sheet, end.sheet);
    }
    return new AbsoluteRowRange(start.sheet, start.row, end.row);
  }
  shouldBeRemoved() {
    return this.height() <= 0;
  }
  shiftByColumns(_numberOfColumns) {
    return;
  }
  expandByColumns(_numberOfColumns) {
    return;
  }
  shifted(byCols, byRows) {
    return new AbsoluteRowRange(this.sheet, this.start.row + byRows, this.end.row + byRows);
  }
  rangeWithSameWidth(startRow, numberOfRows) {
    return new AbsoluteRowRange(this.sheet, startRow, startRow + numberOfRows - 1);
  }
  exceedsSheetSizeLimits(_maxColumns, maxRows) {
    return this.end.row >= maxRows;
  }
  effectiveEndColumn(dependencyGraph) {
    return this.effectiveWidth(dependencyGraph) - 1;
  }
  effectiveWidth(dependencyGraph) {
    return dependencyGraph.getSheetWidth(this.sheet);
  }
  removeColumns(_columnStart, _columnEnd) {
    return;
  }
}
class InterpreterState {
  constructor(formulaAddress, arraysFlag, formulaVertex) {
    this.formulaAddress = formulaAddress;
    this.arraysFlag = arraysFlag;
    this.formulaVertex = formulaVertex;
  }
}
function collatorFromConfig(config) {
  const sensitivity = config.caseSensitive ? config.accentSensitive ? "variant" : "case" : config.accentSensitive ? "accent" : "base";
  const caseFirst = config.caseFirst;
  const ignorePunctuation = config.ignorePunctuation;
  return new Intl.Collator(config.localeLang, {
    sensitivity,
    caseFirst,
    ignorePunctuation
  });
}
const COMPLEX_NUMBER_SYMBOL = "i";
const complexParsingRegexp = /^\s*([+-]?)\s*(([\d\.,]+(e[+-]?\d+)?)\s*([ij]?)|([ij]))\s*(([+-])\s*([+-]?)\s*(([\d\.,]+(e[+-]?\d+)?)\s*([ij]?)|([ij])))?$/;
class ArithmeticHelper {
  constructor(config, dateTimeHelper, numberLiteralsHelper) {
    this.config = config;
    this.dateTimeHelper = dateTimeHelper;
    this.numberLiteralsHelper = numberLiteralsHelper;
    this.lt = (left2, right2) => {
      return this.compare(left2, right2) < 0;
    };
    this.leq = (left2, right2) => {
      return this.compare(left2, right2) <= 0;
    };
    this.gt = (left2, right2) => {
      return this.compare(left2, right2) > 0;
    };
    this.geq = (left2, right2) => {
      return this.compare(left2, right2) >= 0;
    };
    this.eq = (left2, right2) => {
      return this.compare(left2, right2) === 0;
    };
    this.neq = (left2, right2) => {
      return this.compare(left2, right2) !== 0;
    };
    this.pow = (left2, right2) => {
      return Math.pow(getRawValue(left2), getRawValue(right2));
    };
    this.addWithEpsilonRaw = (left2, right2) => {
      const ret = left2 + right2;
      if (Math.abs(ret) < this.actualEps * Math.abs(left2)) {
        return 0;
      } else {
        return ret;
      }
    };
    this.addWithEpsilon = (left2, right2) => {
      const typeOfResult = inferExtendedNumberTypeAdditive(left2, right2);
      return this.ExtendedNumberFactory(this.addWithEpsilonRaw(getRawValue(left2), getRawValue(right2)), typeOfResult);
    };
    this.unaryMinus = (arg) => {
      return cloneNumber(arg, -getRawValue(arg));
    };
    this.unaryPlus = (arg) => arg;
    this.unaryPercent = (arg) => {
      return new PercentNumber(getRawValue(arg) / 100);
    };
    this.concat = (left2, right2) => {
      return left2.concat(right2);
    };
    this.nonstrictadd = (left2, right2) => {
      if (left2 instanceof CellError) {
        return left2;
      } else if (right2 instanceof CellError) {
        return right2;
      } else if (typeof left2 === "number") {
        if (typeof right2 === "number") {
          return this.addWithEpsilonRaw(left2, right2);
        } else {
          return left2;
        }
      } else if (typeof right2 === "number") {
        return right2;
      } else {
        return 0;
      }
    };
    this.subtract = (leftArg, rightArg) => {
      const typeOfResult = inferExtendedNumberTypeAdditive(leftArg, rightArg);
      const left2 = getRawValue(leftArg);
      const right2 = getRawValue(rightArg);
      let ret = left2 - right2;
      if (Math.abs(ret) < this.actualEps * Math.abs(left2)) {
        ret = 0;
      }
      return this.ExtendedNumberFactory(ret, typeOfResult);
    };
    this.divide = (leftArg, rightArg) => {
      const left2 = getRawValue(leftArg);
      const right2 = getRawValue(rightArg);
      if (right2 === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      } else {
        const typeOfResult = inferExtendedNumberTypeMultiplicative(leftArg, rightArg);
        return this.ExtendedNumberFactory(left2 / right2, typeOfResult);
      }
    };
    this.multiply = (left2, right2) => {
      const typeOfResult = inferExtendedNumberTypeMultiplicative(left2, right2);
      return this.ExtendedNumberFactory(getRawValue(left2) * getRawValue(right2), typeOfResult);
    };
    this.manyToExactComplex = (args) => {
      const ret = [];
      for (const arg of args) {
        if (arg instanceof CellError) {
          return arg;
        } else if (isExtendedNumber(arg) || typeof arg === "string") {
          const coerced = this.coerceScalarToComplex(arg);
          if (!(coerced instanceof CellError)) {
            ret.push(coerced);
          }
        }
      }
      return ret;
    };
    this.coerceNumbersExactRanges = (args) => this.manyToNumbers(args, this.manyToExactNumbers);
    this.coerceNumbersCoerceRangesDropNulls = (args) => this.manyToNumbers(args, this.manyToCoercedNumbersDropNulls);
    this.manyToExactNumbers = (args) => {
      const ret = [];
      for (const arg of args) {
        if (arg instanceof CellError) {
          return arg;
        } else if (isExtendedNumber(arg)) {
          ret.push(getRawValue(arg));
        }
      }
      return ret;
    };
    this.manyToOnlyNumbersDropNulls = (args) => {
      const ret = [];
      for (const arg of args) {
        if (arg instanceof CellError) {
          return arg;
        } else if (isExtendedNumber(arg)) {
          ret.push(getRawValue(arg));
        } else if (arg !== EmptyValue) {
          return new CellError(ErrorType.VALUE, ErrorMessage.NumberExpected);
        }
      }
      return ret;
    };
    this.manyToCoercedNumbersDropNulls = (args) => {
      const ret = [];
      for (const arg of args) {
        if (arg instanceof CellError) {
          return arg;
        }
        if (arg === EmptyValue) {
          continue;
        }
        const coerced = this.coerceScalarToNumberOrError(arg);
        if (isExtendedNumber(coerced)) {
          ret.push(getRawValue(coerced));
        }
      }
      return ret;
    };
    this.collator = collatorFromConfig(config);
    this.actualEps = config.smartRounding ? config.precisionEpsilon : 0;
  }
  eqMatcherFunction(pattern) {
    const regexp = this.buildRegex(pattern);
    return (cellValue) => typeof cellValue === "string" && regexp.test(this.normalizeString(cellValue));
  }
  neqMatcherFunction(pattern) {
    const regexp = this.buildRegex(pattern);
    return (cellValue) => {
      return !(typeof cellValue === "string") || !regexp.test(this.normalizeString(cellValue));
    };
  }
  searchString(pattern, text) {
    var _a;
    const regexp = this.buildRegex(pattern, false);
    const result = regexp.exec(text);
    return (_a = result === null || result === void 0 ? void 0 : result.index) !== null && _a !== void 0 ? _a : -1;
  }
  requiresRegex(pattern) {
    if (!this.config.useRegularExpressions && !this.config.useWildcards) {
      return !this.config.matchWholeCell;
    }
    for (let i = 0; i < pattern.length; i++) {
      const c = pattern.charAt(i);
      if (isWildcard(c) || this.config.useRegularExpressions && needsEscape(c)) {
        return true;
      }
    }
    return false;
  }
  floatCmp(leftArg, rightArg) {
    const left2 = getRawValue(leftArg);
    const right2 = getRawValue(rightArg);
    const mod = 1 + this.actualEps;
    if (right2 >= 0 && left2 * mod >= right2 && left2 <= right2 * mod) {
      return 0;
    } else if (right2 <= 0 && left2 * mod <= right2 && left2 >= right2 * mod) {
      return 0;
    } else if (left2 > right2) {
      return 1;
    } else {
      return -1;
    }
  }
  coerceScalarToNumberOrError(arg) {
    var _a;
    if (arg instanceof CellError) {
      return arg;
    }
    return (_a = this.coerceToMaybeNumber(arg)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.VALUE, ErrorMessage.NumberCoercion);
  }
  coerceToMaybeNumber(arg) {
    var _a;
    return (_a = this.coerceNonDateScalarToMaybeNumber(arg)) !== null && _a !== void 0 ? _a : typeof arg === "string" ? this.dateTimeHelper.dateStringToDateNumber(arg) : void 0;
  }
  coerceNonDateScalarToMaybeNumber(arg) {
    if (arg === EmptyValue) {
      return 0;
    } else if (typeof arg === "string") {
      if (arg === "") {
        return 0;
      }
      const maybePercentNumber = this.coerceStringToMaybePercentNumber(arg);
      if (maybePercentNumber !== void 0) {
        return maybePercentNumber;
      }
      const maybeCurrencyNumber = this.coerceStringToMaybeCurrencyNumber(arg);
      if (maybeCurrencyNumber !== void 0) {
        return maybeCurrencyNumber;
      }
      return this.numberLiteralsHelper.numericStringToMaybeNumber(arg.trim());
    } else if (isExtendedNumber(arg)) {
      return arg;
    } else if (typeof arg === "boolean") {
      return Number(arg);
    } else {
      return void 0;
    }
  }
  coerceStringToMaybePercentNumber(input) {
    const trimmedInput = input.trim();
    if (trimmedInput.endsWith("%")) {
      const numOfPercents = trimmedInput.slice(0, trimmedInput.length - 1).trim();
      const parsedNumOfPercents = this.numberLiteralsHelper.numericStringToMaybeNumber(numOfPercents);
      if (parsedNumOfPercents !== void 0) {
        return new PercentNumber(parsedNumOfPercents / 100);
      }
    }
    return void 0;
  }
  coerceStringToMaybeCurrencyNumber(input) {
    const matchedCurrency = this.currencyMatcher(input.trim());
    if (matchedCurrency !== void 0) {
      const [currencySymbol, currencyValue] = matchedCurrency;
      const parsedCurrencyValue = this.numberLiteralsHelper.numericStringToMaybeNumber(currencyValue);
      if (parsedCurrencyValue !== void 0) {
        return new CurrencyNumber(parsedCurrencyValue, currencySymbol);
      }
    }
    return void 0;
  }
  currencyMatcher(token) {
    for (const currency of this.config.currencySymbol) {
      if (token.startsWith(currency)) {
        return [currency, token.slice(currency.length).trim()];
      }
      if (token.endsWith(currency)) {
        return [currency, token.slice(0, token.length - currency.length).trim()];
      }
    }
    return void 0;
  }
  coerceComplexExactRanges(args) {
    const vals = [];
    for (const arg of args) {
      if (arg instanceof SimpleRangeValue) {
        vals.push(arg);
      } else if (arg !== EmptyValue) {
        const coerced = this.coerceScalarToComplex(arg);
        if (coerced instanceof CellError) {
          return coerced;
        } else {
          vals.push(coerced);
        }
      }
    }
    const expandedVals = [];
    for (const val of vals) {
      if (val instanceof SimpleRangeValue) {
        const arr = this.manyToExactComplex(val.valuesFromTopLeftCorner());
        if (arr instanceof CellError) {
          return arr;
        } else {
          expandedVals.push(...arr);
        }
      } else {
        expandedVals.push(val);
      }
    }
    return expandedVals;
  }
  coerceScalarToComplex(arg) {
    if (arg instanceof CellError) {
      return arg;
    } else if (arg === EmptyValue) {
      return [0, 0];
    } else if (isExtendedNumber(arg)) {
      return [getRawValue(arg), 0];
    } else if (typeof arg === "string") {
      return this.coerceStringToComplex(arg);
    } else {
      return new CellError(ErrorType.NUM, ErrorMessage.ComplexNumberExpected);
    }
  }
  ExtendedNumberFactory(value, typeFormat) {
    const {
      type,
      format: format2
    } = typeFormat;
    switch (type) {
      case NumberType.NUMBER_RAW:
        return value;
      case NumberType.NUMBER_CURRENCY: {
        return new CurrencyNumber(value, format2 !== null && format2 !== void 0 ? format2 : this.config.currencySymbol[0]);
      }
      case NumberType.NUMBER_DATE:
        return new DateNumber(value, format2);
      case NumberType.NUMBER_DATETIME:
        return new DateTimeNumber(value, format2);
      case NumberType.NUMBER_TIME:
        return new TimeNumber(value, format2);
      case NumberType.NUMBER_PERCENT:
        return new PercentNumber(value, format2);
    }
  }
  buildRegex(pattern, matchWholeCell = true) {
    pattern = this.normalizeString(pattern);
    let regexpStr;
    let useWildcards = this.config.useWildcards;
    let useRegularExpressions = this.config.useRegularExpressions;
    if (useRegularExpressions) {
      try {
        RegExp(pattern);
      } catch (e) {
        useRegularExpressions = false;
        useWildcards = false;
      }
    }
    if (useRegularExpressions) {
      regexpStr = escapeNoCharacters(pattern, this.config.caseSensitive);
    } else if (useWildcards) {
      regexpStr = escapeNonWildcards(pattern, this.config.caseSensitive);
    } else {
      regexpStr = escapeAllCharacters(pattern, this.config.caseSensitive);
    }
    if (this.config.matchWholeCell && matchWholeCell) {
      return RegExp("^(" + regexpStr + ")$");
    } else {
      return RegExp(regexpStr);
    }
  }
  normalizeString(str) {
    if (!this.config.caseSensitive) {
      str = str.toLowerCase();
    }
    if (!this.config.accentSensitive) {
      str = normalizeString(str, "nfd").replace(/[\u0300-\u036f]/g, "");
    }
    return str;
  }
  compare(left2, right2) {
    if (typeof left2 === "string" || typeof right2 === "string") {
      const leftTmp = typeof left2 === "string" ? this.dateTimeHelper.dateStringToDateNumber(left2) : left2;
      const rightTmp = typeof right2 === "string" ? this.dateTimeHelper.dateStringToDateNumber(right2) : right2;
      if (isExtendedNumber(leftTmp) && isExtendedNumber(rightTmp)) {
        return this.floatCmp(leftTmp, rightTmp);
      }
    }
    if (left2 === EmptyValue) {
      left2 = coerceEmptyToValue(right2);
    } else if (right2 === EmptyValue) {
      right2 = coerceEmptyToValue(left2);
    }
    if (typeof left2 === "string" && typeof right2 === "string") {
      return this.stringCmp(left2, right2);
    } else if (typeof left2 === "boolean" && typeof right2 === "boolean") {
      return numberCmp(coerceBooleanToNumber(left2), coerceBooleanToNumber(right2));
    } else if (isExtendedNumber(left2) && isExtendedNumber(right2)) {
      return this.floatCmp(left2, right2);
    } else if (left2 === EmptyValue && right2 === EmptyValue) {
      return 0;
    } else {
      return numberCmp(CellValueTypeOrd(getCellValueType(left2)), CellValueTypeOrd(getCellValueType(right2)));
    }
  }
  stringCmp(left2, right2) {
    return this.collator.compare(left2, right2);
  }
  manyToNumbers(args, rangeFn) {
    const vals = [];
    for (const arg of args) {
      if (arg instanceof SimpleRangeValue) {
        vals.push(arg);
      } else {
        const coerced = getRawValue(this.coerceScalarToNumberOrError(arg));
        if (coerced instanceof CellError) {
          return coerced;
        } else {
          vals.push(coerced);
        }
      }
    }
    const expandedVals = [];
    for (const val of vals) {
      if (val instanceof SimpleRangeValue) {
        const arr = rangeFn(val.valuesFromTopLeftCorner());
        if (arr instanceof CellError) {
          return arr;
        } else {
          expandedVals.push(...arr);
        }
      } else {
        expandedVals.push(val);
      }
    }
    return expandedVals;
  }
  coerceStringToComplex(arg) {
    const match = complexParsingRegexp.exec(arg);
    if (match === null) {
      return new CellError(ErrorType.NUM, ErrorMessage.ComplexNumberExpected);
    }
    let val1;
    if (match[6] !== void 0) {
      val1 = match[1] === "-" ? [0, -1] : [0, 1];
    } else {
      val1 = this.parseComplexToken(match[1] + match[3], match[5]);
    }
    if (val1 instanceof CellError) {
      return val1;
    }
    if (match[8] === void 0) {
      return val1;
    }
    let val2;
    if (match[14] !== void 0) {
      val2 = match[9] === "-" ? [0, -1] : [0, 1];
    } else {
      val2 = this.parseComplexToken(match[9] + match[11], match[13]);
    }
    if (val2 instanceof CellError) {
      return val2;
    }
    if (match[5] !== "" || match[13] === "") {
      return new CellError(ErrorType.NUM, ErrorMessage.ComplexNumberExpected);
    }
    if (match[8] === "+") {
      return [val1[0] + val2[0], val1[1] + val2[1]];
    } else {
      return [val1[0] - val2[0], val1[1] - val2[1]];
    }
  }
  parseComplexToken(arg, mod) {
    const val = getRawValue(this.coerceNonDateScalarToMaybeNumber(arg));
    if (val === void 0) {
      return new CellError(ErrorType.NUM, ErrorMessage.ComplexNumberExpected);
    }
    if (mod === "") {
      return [val, 0];
    } else {
      return [0, val];
    }
  }
}
function coerceComplexToString([re, im], symb) {
  if (!isFinite(re) || !isFinite(im)) {
    return new CellError(ErrorType.NUM, ErrorMessage.NaN);
  }
  symb = symb !== null && symb !== void 0 ? symb : COMPLEX_NUMBER_SYMBOL;
  if (im === 0) {
    return `${re}`;
  }
  const imStr = `${im === -1 || im === 1 ? "" : Math.abs(im)}${symb}`;
  if (re === 0) {
    return `${im < 0 ? "-" : ""}${imStr}`;
  }
  return `${re}${im < 0 ? "-" : "+"}${imStr}`;
}
function coerceToRange(arg) {
  if (arg instanceof SimpleRangeValue) {
    return arg;
  } else {
    return SimpleRangeValue.fromScalar(arg);
  }
}
function coerceBooleanToNumber(arg) {
  return Number(arg);
}
function coerceEmptyToValue(arg) {
  if (typeof arg === "string") {
    return "";
  } else if (isExtendedNumber(arg)) {
    return 0;
  } else if (typeof arg === "boolean") {
    return false;
  } else {
    return EmptyValue;
  }
}
function coerceScalarToBoolean(arg) {
  if (arg instanceof CellError || typeof arg === "boolean") {
    return arg;
  } else if (arg === EmptyValue) {
    return false;
  } else if (isExtendedNumber(arg)) {
    return getRawValue(arg) !== 0;
  } else {
    const argUppered = arg.toUpperCase();
    if (argUppered === "TRUE") {
      return true;
    } else if (argUppered === "FALSE") {
      return false;
    } else if (argUppered === "") {
      return false;
    } else {
      return void 0;
    }
  }
}
function coerceScalarToString(arg) {
  if (arg instanceof CellError || typeof arg === "string") {
    return arg;
  } else if (arg === EmptyValue) {
    return "";
  } else if (isExtendedNumber(arg)) {
    return getRawValue(arg).toString();
  } else {
    return arg ? "TRUE" : "FALSE";
  }
}
function zeroIfEmpty(arg) {
  return arg === EmptyValue ? 0 : arg;
}
function numberCmp(leftArg, rightArg) {
  const left2 = getRawValue(leftArg);
  const right2 = getRawValue(rightArg);
  if (left2 > right2) {
    return 1;
  } else if (left2 < right2) {
    return -1;
  } else {
    return 0;
  }
}
function isNumberOverflow(arg) {
  return isNaN(arg) || arg === Infinity || arg === -Infinity;
}
function fixNegativeZero(arg) {
  if (arg === 0) {
    return 0;
  } else {
    return arg;
  }
}
function isWildcard(c) {
  return ["*", "?"].includes(c);
}
const escapedCharacters = ["{", "}", "[", "]", "(", ")", "<", ">", "=", ".", "+", "-", ",", "\\", "$", "^", "!"];
function needsEscape(c) {
  return escapedCharacters.includes(c);
}
function escapeNonWildcards(pattern, caseSensitive) {
  let str = "";
  for (let i = 0; i < pattern.length; i++) {
    const c = pattern.charAt(i);
    if (c === "~") {
      if (i == pattern.length - 1) {
        str += "~";
        continue;
      }
      const d = pattern.charAt(i + 1);
      if (isWildcard(d) || needsEscape(d)) {
        str += "\\" + d;
        i++;
      } else {
        str += d;
        i++;
      }
    } else if (isWildcard(c)) {
      str += "." + c;
    } else if (needsEscape(c)) {
      str += "\\" + c;
    } else if (caseSensitive) {
      str += c;
    } else {
      str += c.toLowerCase();
    }
  }
  return str;
}
function escapeAllCharacters(pattern, caseSensitive) {
  let str = "";
  for (let i = 0; i < pattern.length; i++) {
    const c = pattern.charAt(i);
    if (isWildcard(c) || needsEscape(c)) {
      str += "\\" + c;
    } else if (caseSensitive) {
      str += c;
    } else {
      str += c.toLowerCase();
    }
  }
  return str;
}
function escapeNoCharacters(pattern, caseSensitive) {
  let str = "";
  for (let i = 0; i < pattern.length; i++) {
    const c = pattern.charAt(i);
    if (isWildcard(c) || needsEscape(c)) {
      str += c;
    } else if (caseSensitive) {
      str += c;
    } else {
      str += c.toLowerCase();
    }
  }
  return str;
}
function inferExtendedNumberTypeAdditive(leftArg, rightArg) {
  const {
    type: leftType,
    format: leftFormat
  } = getTypeFormatOfExtendedNumber(leftArg);
  const {
    type: rightType,
    format: rightFormat
  } = getTypeFormatOfExtendedNumber(rightArg);
  if (leftType === NumberType.NUMBER_RAW) {
    return {
      type: rightType,
      format: rightFormat
    };
  }
  if (rightType === NumberType.NUMBER_RAW) {
    return {
      type: leftType,
      format: leftFormat
    };
  }
  if ((leftType === NumberType.NUMBER_DATETIME || leftType === NumberType.NUMBER_DATE) && (rightType === NumberType.NUMBER_DATETIME || rightType === NumberType.NUMBER_DATE)) {
    return {
      type: NumberType.NUMBER_RAW
    };
  }
  if (leftType === NumberType.NUMBER_TIME) {
    if (rightType === NumberType.NUMBER_DATE) {
      return {
        type: NumberType.NUMBER_DATETIME,
        format: `${rightFormat} ${leftFormat}`
      };
    }
    if (rightType === NumberType.NUMBER_DATETIME) {
      return {
        type: NumberType.NUMBER_DATETIME,
        format: rightFormat
      };
    }
  }
  if (rightType === NumberType.NUMBER_TIME) {
    if (leftType === NumberType.NUMBER_DATE) {
      return {
        type: NumberType.NUMBER_DATETIME,
        format: `${leftFormat} ${rightFormat}`
      };
    }
    if (leftType === NumberType.NUMBER_DATETIME) {
      return {
        type: NumberType.NUMBER_DATETIME,
        format: leftFormat
      };
    }
  }
  return {
    type: leftType,
    format: leftFormat
  };
}
function inferExtendedNumberTypeMultiplicative(leftArg, rightArg) {
  let {
    type: leftType,
    format: leftFormat
  } = getTypeFormatOfExtendedNumber(leftArg);
  let {
    type: rightType,
    format: rightFormat
  } = getTypeFormatOfExtendedNumber(rightArg);
  if (leftType === NumberType.NUMBER_PERCENT) {
    leftType = NumberType.NUMBER_RAW;
    leftFormat = void 0;
  }
  if (rightType === NumberType.NUMBER_PERCENT) {
    rightType = NumberType.NUMBER_RAW;
    rightFormat = void 0;
  }
  if (leftType === NumberType.NUMBER_RAW) {
    return {
      type: rightType,
      format: rightFormat
    };
  }
  if (rightType === NumberType.NUMBER_RAW) {
    return {
      type: leftType,
      format: leftFormat
    };
  }
  return {
    type: NumberType.NUMBER_RAW
  };
}
function forceNormalizeString(str) {
  return normalizeString(str.toLowerCase(), "nfd").replace(/[\u0300-\u036f]/g, "");
}
function coerceRangeToScalar(arg, state) {
  var _a;
  if (arg.isAdHoc()) {
    return (_a = arg.data[0]) === null || _a === void 0 ? void 0 : _a[0];
  }
  const range = arg.range;
  if (state.formulaAddress.sheet === range.sheet) {
    if (range.width() === 1) {
      const offset2 = state.formulaAddress.row - range.start.row;
      if (offset2 >= 0 && offset2 < range.height()) {
        return arg.data[offset2][0];
      }
    } else if (range.height() === 1) {
      const offset2 = state.formulaAddress.col - range.start.col;
      if (offset2 >= 0 && offset2 < range.width()) {
        return arg.data[0][offset2];
      }
    }
  }
  return void 0;
}
function normalizeString(str, form) {
  return str.normalize(form.toUpperCase());
}
var FunctionArgumentType;
(function(FunctionArgumentType2) {
  FunctionArgumentType2["STRING"] = "STRING";
  FunctionArgumentType2["NUMBER"] = "NUMBER";
  FunctionArgumentType2["BOOLEAN"] = "BOOLEAN";
  FunctionArgumentType2["SCALAR"] = "SCALAR";
  FunctionArgumentType2["NOERROR"] = "NOERROR";
  FunctionArgumentType2["RANGE"] = "RANGE";
  FunctionArgumentType2["INTEGER"] = "INTEGER";
  FunctionArgumentType2["COMPLEX"] = "COMPLEX";
  FunctionArgumentType2["ANY"] = "ANY";
})(FunctionArgumentType || (FunctionArgumentType = {}));
class FunctionPlugin {
  constructor(interpreter) {
    this.coerceScalarToNumberOrError = (arg) => this.arithmeticHelper.coerceScalarToNumberOrError(arg);
    this.runFunction = (args, state, metadata, functionImplementation) => {
      const evaluatedArguments = this.evaluateArguments(args, state, metadata);
      const argumentValues = evaluatedArguments.map(([value]) => value);
      const argumentIgnorableFlags = evaluatedArguments.map(([, ignorable]) => ignorable);
      const syntacticallyEmptyFlags = evaluatedArguments.map(([, , empty2]) => empty2);
      const argumentMetadata = this.buildMetadataForEachArgumentValue(argumentValues.length, metadata);
      const isVectorizationOn = state.arraysFlag && !metadata.vectorizationForbidden;
      if (!this.isNumberOfArgumentValuesValid(argumentMetadata, argumentValues.length)) {
        return new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber);
      }
      const [resultArrayHeight, resultArrayWidth] = isVectorizationOn ? this.calculateSizeOfVectorizedResultArray(argumentValues, argumentMetadata) : [1, 1];
      if (resultArrayHeight === 1 && resultArrayWidth === 1) {
        const vectorizedArguments = this.vectorizeAndBroadcastArgumentsIfNecessary(isVectorizationOn, argumentValues, argumentMetadata, 0, 0);
        return this.calculateSingleCellOfResultArray(state, vectorizedArguments, argumentMetadata, argumentIgnorableFlags, syntacticallyEmptyFlags, functionImplementation, metadata.returnNumberType);
      }
      const resultArray = [...Array(resultArrayHeight).keys()].map((row) => [...Array(resultArrayWidth).keys()].map((col) => {
        const vectorizedArguments = this.vectorizeAndBroadcastArgumentsIfNecessary(isVectorizationOn, argumentValues, argumentMetadata, row, col);
        const result = this.calculateSingleCellOfResultArray(state, vectorizedArguments, argumentMetadata, argumentIgnorableFlags, syntacticallyEmptyFlags, functionImplementation, metadata.returnNumberType);
        if (result instanceof SimpleRangeValue) {
          throw new Error("Function returning array cannot be vectorized.");
        }
        return result;
      }));
      return SimpleRangeValue.onlyValues(resultArray);
    };
    this.runFunctionWithReferenceArgument = (args, state, metadata, noArgCallback, referenceCallback, nonReferenceCallback = () => new CellError(ErrorType.NA, ErrorMessage.CellRefExpected)) => {
      if (args.length === 0) {
        return this.returnNumberWrapper(noArgCallback(), metadata.returnNumberType);
      } else if (args.length > 1) {
        return new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber);
      }
      let arg = args[0];
      while (arg.type === AstNodeType.PARENTHESIS) {
        arg = arg.expression;
      }
      let cellReference;
      if (arg.type === AstNodeType.CELL_REFERENCE) {
        cellReference = arg.reference.toSimpleCellAddress(state.formulaAddress);
      } else if (arg.type === AstNodeType.CELL_RANGE || arg.type === AstNodeType.COLUMN_RANGE || arg.type === AstNodeType.ROW_RANGE) {
        try {
          cellReference = AbsoluteCellRange.fromAst(arg, state.formulaAddress).start;
        } catch (e) {
          return new CellError(ErrorType.REF, ErrorMessage.CellRefExpected);
        }
      }
      if (cellReference !== void 0) {
        return this.returnNumberWrapper(referenceCallback(cellReference), metadata.returnNumberType);
      }
      return this.runFunction(args, state, metadata, nonReferenceCallback);
    };
    this.interpreter = interpreter;
    this.dependencyGraph = interpreter.dependencyGraph;
    this.columnSearch = interpreter.columnSearch;
    this.config = interpreter.config;
    this.serialization = interpreter.serialization;
    this.arraySizePredictor = interpreter.arraySizePredictor;
    this.dateTimeHelper = interpreter.dateTimeHelper;
    this.arithmeticHelper = interpreter.arithmeticHelper;
  }
  evaluateAst(ast, state) {
    return this.interpreter.evaluateAst(ast, state);
  }
  arraySizeForAst(ast, state) {
    return this.arraySizePredictor.checkArraySizeForAst(ast, state);
  }
  listOfScalarValues(asts, state) {
    const ret = [];
    for (const argAst of asts) {
      const isSyntacticallyEmpty = argAst.type === AstNodeType.EMPTY;
      const value = this.evaluateAst(argAst, state);
      if (value instanceof SimpleRangeValue) {
        for (const scalarValue of value.valuesFromTopLeftCorner()) {
          ret.push([scalarValue, true, isSyntacticallyEmpty]);
        }
      } else {
        ret.push([value, false, isSyntacticallyEmpty]);
      }
    }
    return ret;
  }
  coerceToType(arg, coercedType, state) {
    let ret;
    if (arg instanceof SimpleRangeValue) {
      switch (coercedType.argumentType) {
        case FunctionArgumentType.RANGE:
        case FunctionArgumentType.ANY:
          ret = arg;
          break;
        default: {
          const coerce = coerceRangeToScalar(arg, state);
          if (coerce === void 0) {
            return void 0;
          }
          arg = coerce;
        }
      }
    }
    if (!(arg instanceof SimpleRangeValue)) {
      switch (coercedType.argumentType) {
        case FunctionArgumentType.INTEGER:
        case FunctionArgumentType.NUMBER:
          const coerced = this.coerceScalarToNumberOrError(arg);
          if (!isExtendedNumber(coerced)) {
            ret = coerced;
            break;
          }
          const value = getRawValue(coerced);
          if (coercedType.maxValue !== void 0 && value > coercedType.maxValue) {
            return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
          }
          if (coercedType.minValue !== void 0 && value < coercedType.minValue) {
            return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
          }
          if (coercedType.lessThan !== void 0 && value >= coercedType.lessThan) {
            return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
          }
          if (coercedType.greaterThan !== void 0 && value <= coercedType.greaterThan) {
            return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
          }
          if (coercedType.argumentType === FunctionArgumentType.INTEGER && !Number.isInteger(value)) {
            return new CellError(ErrorType.NUM, ErrorMessage.IntegerExpected);
          }
          ret = coerced;
          break;
        case FunctionArgumentType.STRING:
          ret = coerceScalarToString(arg);
          break;
        case FunctionArgumentType.BOOLEAN:
          ret = coerceScalarToBoolean(arg);
          break;
        case FunctionArgumentType.SCALAR:
        case FunctionArgumentType.NOERROR:
        case FunctionArgumentType.ANY:
          ret = arg;
          break;
        case FunctionArgumentType.RANGE:
          if (arg instanceof CellError) {
            return arg;
          }
          ret = coerceToRange(arg);
          break;
        case FunctionArgumentType.COMPLEX:
          return this.arithmeticHelper.coerceScalarToComplex(getRawValue(arg));
      }
    }
    if (coercedType.passSubtype || ret === void 0) {
      return ret;
    } else {
      return getRawValue(ret);
    }
  }
  calculateSingleCellOfResultArray(state, vectorizedArguments, argumentsMetadata, argumentIgnorableFlags, syntacticallyEmptyFlags, functionImplementation, returnNumberType) {
    const coercedArguments = this.coerceArgumentsToRequiredTypes(state, vectorizedArguments, argumentsMetadata, argumentIgnorableFlags, syntacticallyEmptyFlags);
    if (coercedArguments instanceof CellError) {
      return coercedArguments;
    }
    const functionCalculationResult = functionImplementation(...coercedArguments);
    return this.returnNumberWrapper(functionCalculationResult, returnNumberType);
  }
  coerceArgumentsToRequiredTypes(state, vectorizedArguments, argumentsMetadata, argumentIgnorableFlags, syntacticallyEmptyFlags) {
    const coercedArguments = [];
    for (let i = 0; i < argumentsMetadata.length; i++) {
      const argumentMetadata = argumentsMetadata[i];
      const rawArg = vectorizedArguments[i];
      const argumentValue = rawArg === void 0 ? argumentMetadata === null || argumentMetadata === void 0 ? void 0 : argumentMetadata.defaultValue : syntacticallyEmptyFlags[i] && (argumentMetadata === null || argumentMetadata === void 0 ? void 0 : argumentMetadata.emptyAsDefault) && (argumentMetadata === null || argumentMetadata === void 0 ? void 0 : argumentMetadata.defaultValue) !== void 0 ? argumentMetadata.defaultValue : rawArg;
      if (argumentValue === void 0) {
        coercedArguments.push(void 0);
        continue;
      }
      const coercedValue = this.coerceToType(argumentValue, argumentMetadata, state);
      if (coercedValue === void 0 && !argumentIgnorableFlags[i]) {
        return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
      }
      if (coercedValue instanceof CellError && argumentMetadata.argumentType !== FunctionArgumentType.SCALAR) {
        return coercedValue;
      }
      coercedArguments.push(coercedValue);
    }
    return coercedArguments;
  }
  vectorizeAndBroadcastArgumentsIfNecessary(isVectorizationOn, argumentValues, argumentMetadata, row, col) {
    return argumentValues.map((value, i) => isVectorizationOn && this.isRangePassedAsAScalarArgument(value, argumentMetadata[i]) ? this.vectorizeAndBroadcastRangeArgument(value, row, col) : value);
  }
  vectorizeAndBroadcastRangeArgument(argumentValue, rowNum, colNum) {
    var _a;
    const targetRowNum = argumentValue.height() === 1 ? 0 : rowNum;
    const targetColNum = argumentValue.width() === 1 ? 0 : colNum;
    return (_a = argumentValue.data[targetRowNum]) === null || _a === void 0 ? void 0 : _a[targetColNum];
  }
  evaluateArguments(args, state, metadata) {
    return metadata.expandRanges ? this.listOfScalarValues(args, state) : args.map((ast) => [this.evaluateAst(ast, state), false, ast.type === AstNodeType.EMPTY]);
  }
  buildMetadataForEachArgumentValue(numberOfArgumentValuesPassed, metadata) {
    const argumentsMetadata = metadata.parameters ? [...metadata.parameters] : [];
    const isRepeatLastArgsValid = metadata.repeatLastArgs !== void 0 && Number.isInteger(metadata.repeatLastArgs) && metadata.repeatLastArgs > 0;
    if (isRepeatLastArgsValid) {
      while (numberOfArgumentValuesPassed > argumentsMetadata.length) {
        argumentsMetadata.push(...argumentsMetadata.slice(argumentsMetadata.length - metadata.repeatLastArgs));
      }
    }
    return argumentsMetadata;
  }
  isNumberOfArgumentValuesValid(argumentsMetadata, numberOfArgumentValuesPassed) {
    if (numberOfArgumentValuesPassed > argumentsMetadata.length) {
      return false;
    }
    if (numberOfArgumentValuesPassed < argumentsMetadata.length) {
      const metadataForMissingArguments = argumentsMetadata.slice(numberOfArgumentValuesPassed);
      const areMissingArgumentsOptional = metadataForMissingArguments.every((argMetadata) => (argMetadata === null || argMetadata === void 0 ? void 0 : argMetadata.optionalArg) || (argMetadata === null || argMetadata === void 0 ? void 0 : argMetadata.defaultValue) !== void 0);
      return areMissingArgumentsOptional;
    }
    return true;
  }
  calculateSizeOfVectorizedResultArray(argumentValues, argumentMetadata) {
    const argumentsThatRequireVectorization = argumentValues.filter((value, i) => this.isRangePassedAsAScalarArgument(value, argumentMetadata[i]));
    const height = Math.max(1, ...argumentsThatRequireVectorization.map((val) => val.height()));
    const width = Math.max(1, ...argumentsThatRequireVectorization.map((val) => val.width()));
    return [height, width];
  }
  isRangePassedAsAScalarArgument(argumentValue, argumentMetadata) {
    if (argumentValue == null || argumentMetadata == null) {
      return false;
    }
    return argumentValue instanceof SimpleRangeValue && ![FunctionArgumentType.RANGE, FunctionArgumentType.ANY].includes(argumentMetadata.argumentType);
  }
  metadata(name) {
    const params = this.constructor.implementedFunctions[name];
    if (params !== void 0) {
      return params;
    }
    throw new Error(`No metadata for function ${name}.`);
  }
  returnNumberWrapper(val, type, format2) {
    if (type !== void 0 && isExtendedNumber(val)) {
      return this.arithmeticHelper.ExtendedNumberFactory(getRawValue(val), {
        type,
        format: format2
      });
    } else {
      return val;
    }
  }
}
class ArraySize {
  constructor(width, height, isRef = false) {
    this.width = width;
    this.height = height;
    this.isRef = isRef;
  }
  static error() {
    return new ArraySize(1, 1, true);
  }
  static scalar() {
    return new ArraySize(1, 1, false);
  }
  isScalar() {
    return this.width === 1 && this.height === 1 || this.isRef;
  }
}
function arraySizeForBinaryOp(leftArraySize, rightArraySize) {
  return new ArraySize(Math.max(leftArraySize.width, rightArraySize.width), Math.max(leftArraySize.height, rightArraySize.height));
}
function arraySizeForUnaryOp(arraySize) {
  return new ArraySize(arraySize.width, arraySize.height);
}
class ArraySizePredictor {
  constructor(config, functionRegistry) {
    this.config = config;
    this.functionRegistry = functionRegistry;
  }
  checkArraySize(ast, formulaAddress) {
    return this.checkArraySizeForAst(ast, {
      formulaAddress,
      arraysFlag: this.config.useArrayArithmetic
    });
  }
  checkArraySizeForAst(ast, state) {
    switch (ast.type) {
      case AstNodeType.FUNCTION_CALL: {
        return this.checkArraySizeForFunction(ast, state);
      }
      case AstNodeType.COLUMN_RANGE:
      case AstNodeType.ROW_RANGE:
      case AstNodeType.CELL_RANGE: {
        const range = AbsoluteCellRange.fromAstOrUndef(ast, state.formulaAddress);
        if (range === void 0) {
          return ArraySize.error();
        } else {
          return new ArraySize(range.width(), range.height(), true);
        }
      }
      case AstNodeType.ARRAY: {
        const heights = [];
        const widths = [];
        for (const row of ast.args) {
          const sizes = row.map((ast2) => this.checkArraySizeForAst(ast2, state));
          const h = Math.min(...sizes.map((size) => size.height));
          const w = sizes.reduce((total, size) => total + size.width, 0);
          heights.push(h);
          widths.push(w);
        }
        const height = heights.reduce((total, h) => total + h, 0);
        const width = Math.min(...widths);
        return new ArraySize(width, height);
      }
      case AstNodeType.STRING:
      case AstNodeType.NUMBER:
        return ArraySize.scalar();
      case AstNodeType.CELL_REFERENCE:
        return new ArraySize(1, 1, true);
      case AstNodeType.DIV_OP:
      case AstNodeType.CONCATENATE_OP:
      case AstNodeType.EQUALS_OP:
      case AstNodeType.GREATER_THAN_OP:
      case AstNodeType.GREATER_THAN_OR_EQUAL_OP:
      case AstNodeType.LESS_THAN_OP:
      case AstNodeType.LESS_THAN_OR_EQUAL_OP:
      case AstNodeType.MINUS_OP:
      case AstNodeType.NOT_EQUAL_OP:
      case AstNodeType.PLUS_OP:
      case AstNodeType.POWER_OP:
      case AstNodeType.TIMES_OP: {
        const left2 = this.checkArraySizeForAst(ast.left, state);
        const right2 = this.checkArraySizeForAst(ast.right, state);
        if (!state.arraysFlag && (left2.height > 1 || left2.width > 1 || right2.height > 1 || right2.width > 1)) {
          return ArraySize.error();
        }
        return arraySizeForBinaryOp(left2, right2);
      }
      case AstNodeType.MINUS_UNARY_OP:
      case AstNodeType.PLUS_UNARY_OP:
      case AstNodeType.PERCENT_OP: {
        const val = this.checkArraySizeForAst(ast.value, state);
        if (!state.arraysFlag && (val.height > 1 || val.width > 1)) {
          return ArraySize.error();
        }
        return arraySizeForUnaryOp(val);
      }
      case AstNodeType.PARENTHESIS: {
        return this.checkArraySizeForAst(ast.expression, state);
      }
      case AstNodeType.EMPTY:
        return ArraySize.error();
      default:
        return ArraySize.error();
    }
  }
  checkArraySizeForFunction(ast, state) {
    const pluginArraySizeFunction = this.functionRegistry.getArraySizeFunction(ast.procedureName);
    if (pluginArraySizeFunction !== void 0) {
      return pluginArraySizeFunction(ast, state);
    }
    const metadata = this.functionRegistry.getMetadata(ast.procedureName);
    if (metadata === void 0 || metadata.expandRanges || !state.arraysFlag || metadata.vectorizationForbidden || metadata.parameters === void 0) {
      return new ArraySize(1, 1);
    }
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.checkArraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    const argumentDefinitions = [...metadata.parameters];
    if (metadata.repeatLastArgs !== void 0 && argumentDefinitions.length < subChecks.length && (subChecks.length - argumentDefinitions.length) % metadata.repeatLastArgs !== 0) {
      return ArraySize.error();
    }
    while (argumentDefinitions.length < subChecks.length) {
      if (metadata.repeatLastArgs === void 0) {
        return ArraySize.error();
      }
      argumentDefinitions.push(...argumentDefinitions.slice(argumentDefinitions.length - metadata.repeatLastArgs));
    }
    let maxWidth = 1;
    let maxHeight = 1;
    for (let i = 0; i < subChecks.length; i++) {
      if (argumentDefinitions[i].argumentType !== FunctionArgumentType.RANGE && argumentDefinitions[i].argumentType !== FunctionArgumentType.ANY) {
        maxHeight = Math.max(maxHeight, subChecks[i].height);
        maxWidth = Math.max(maxWidth, subChecks[i].width);
      }
    }
    return new ArraySize(maxWidth, maxHeight);
  }
}
class DetailedCellError {
  constructor(error2, value, address) {
    var _a;
    this.value = value;
    this.address = address;
    this.type = error2.type;
    this.message = (_a = error2.message) !== null && _a !== void 0 ? _a : "";
  }
  toString() {
    return this.value;
  }
  valueOf() {
    return this.value;
  }
}
function configValueFromParam(inputValue, expectedType, paramName) {
  if (typeof inputValue === "undefined") {
    return Config.defaultConfig[paramName];
  } else if (typeof expectedType === "string") {
    if (typeof inputValue === expectedType) {
      return inputValue;
    } else {
      throw new ExpectedValueOfTypeError(expectedType, paramName);
    }
  } else {
    if (expectedType.includes(inputValue)) {
      return inputValue;
    } else {
      throw new ExpectedOneOfValuesError(expectedType.map((val) => `'${val}'`).join(" "), paramName);
    }
  }
}
function validateNumberToBeAtLeast(value, paramName, minimum) {
  if (value < minimum) {
    throw new ConfigValueTooSmallError(paramName, minimum);
  }
}
function validateNumberToBeAtMost(value, paramName, maximum) {
  if (value > maximum) {
    throw new ConfigValueTooBigError(paramName, maximum);
  }
}
function configValueFromParamCheck(inputValue, typeCheck, expectedType, paramName) {
  if (typeCheck(inputValue)) {
    return inputValue;
  } else if (typeof inputValue === "undefined") {
    return Config.defaultConfig[paramName];
  } else {
    throw new ExpectedValueOfTypeError(expectedType, paramName);
  }
}
function configCheckIfParametersNotInConflict(...params) {
  const valuesMap = /* @__PURE__ */ new Map();
  params.forEach((param) => {
    const names = valuesMap.get(param.value) || [];
    names.push(param.name);
    valuesMap.set(param.value, names);
  });
  const duplicates = [];
  for (const entry of valuesMap.values()) {
    if (entry.length > 1) {
      duplicates.push(entry);
    }
  }
  if (duplicates.length > 0) {
    duplicates.forEach((entry) => entry.sort());
    const paramNames = duplicates.map((entry) => `[${entry}]`).join("; ");
    throw new Error(`Config initialization failed. Parameters in conflict: ${paramNames}`);
  }
}
function validateArgToType(inputValue, expectedType, paramName) {
  if (typeof inputValue !== expectedType) {
    throw new ExpectedValueOfTypeError(expectedType, paramName);
  }
}
const TIME_FORMAT_SECONDS_ITEM_REGEXP = new RegExp("^ss(\\.(s+|0+))?$");
const QUICK_CHECK_REGEXP = new RegExp("^[0-9/.\\-: ]+[ap]?m?$");
const WHITESPACE_REGEXP = new RegExp("\\s+");
const DATE_SEPARATOR_REGEXP = new RegExp("[ /.-]");
const TIME_SEPARATOR = ":";
const SECONDS_PRECISION = 1e3;
const memoizedParseTimeFormat = memoize(parseTimeFormat);
const memoizedParseDateFormat = memoize(parseDateFormat);
function defaultParseToDateTime(text, dateFormat, timeFormat) {
  if (dateFormat === void 0 && timeFormat === void 0) {
    return void 0;
  }
  let dateTimeString = text.replace(WHITESPACE_REGEXP, " ").trim().toLowerCase();
  if (!doesItLookLikeADateTimeQuickCheck(dateTimeString)) {
    return void 0;
  }
  let ampmToken = dateTimeString.substring(dateTimeString.length - 2);
  if (ampmToken === "am" || ampmToken === "pm") {
    dateTimeString = dateTimeString.substring(0, dateTimeString.length - 2).trim();
  } else {
    ampmToken = dateTimeString.substring(dateTimeString.length - 1);
    if (ampmToken === "a" || ampmToken === "p") {
      dateTimeString = dateTimeString.substring(0, dateTimeString.length - 1).trim();
    } else {
      ampmToken = void 0;
    }
  }
  const dateItems = dateTimeString.split(DATE_SEPARATOR_REGEXP);
  if (dateItems.length >= 2 && dateItems[dateItems.length - 2].includes(TIME_SEPARATOR)) {
    dateItems[dateItems.length - 2] = dateItems[dateItems.length - 2] + "." + dateItems[dateItems.length - 1];
    dateItems.pop();
  }
  const timeItems = dateItems[dateItems.length - 1].split(TIME_SEPARATOR);
  if (ampmToken !== void 0) {
    timeItems.push(ampmToken);
  }
  if (dateItems.length === 1) {
    return defaultParseToTime(timeItems, timeFormat);
  }
  if (timeItems.length === 1) {
    return defaultParseToDate(dateItems, dateFormat);
  }
  const parsedDate = defaultParseToDate(dateItems.slice(0, dateItems.length - 1), dateFormat);
  const parsedTime = defaultParseToTime(timeItems, timeFormat);
  if (parsedDate === void 0) {
    return void 0;
  } else if (parsedTime === void 0) {
    return void 0;
  } else {
    return Object.assign(Object.assign({}, parsedDate), parsedTime);
  }
}
function defaultParseToTime(timeItems, timeFormat) {
  var _a, _b, _c;
  if (timeFormat === void 0) {
    return void 0;
  }
  const {
    itemsCount,
    hourItem,
    minuteItem,
    secondItem
  } = memoizedParseTimeFormat(timeFormat);
  let ampm = void 0;
  if (timeItems[timeItems.length - 1] === "am" || timeItems[timeItems.length - 1] === "a") {
    ampm = false;
    timeItems.pop();
  } else if (timeItems[timeItems.length - 1] === "pm" || timeItems[timeItems.length - 1] === "p") {
    ampm = true;
    timeItems.pop();
  }
  if (timeItems.length !== itemsCount) {
    return void 0;
  }
  const secondsParsed = Number((_a = timeItems[secondItem]) !== null && _a !== void 0 ? _a : "0");
  if (!Number.isFinite(secondsParsed)) {
    return void 0;
  }
  const seconds = Math.round(secondsParsed * SECONDS_PRECISION) / SECONDS_PRECISION;
  const minutes = Number((_b = timeItems[minuteItem]) !== null && _b !== void 0 ? _b : "0");
  if (!(Number.isFinite(minutes) && Number.isInteger(minutes))) {
    return void 0;
  }
  const hoursParsed = Number((_c = timeItems[hourItem]) !== null && _c !== void 0 ? _c : "0");
  if (!(Number.isFinite(hoursParsed) && Number.isInteger(hoursParsed))) {
    return void 0;
  }
  if (ampm !== void 0 && (hoursParsed < 0 || hoursParsed > 12)) {
    return void 0;
  }
  const hours = ampm !== void 0 ? hoursParsed % 12 + (ampm ? 12 : 0) : hoursParsed;
  return {
    hours,
    minutes,
    seconds
  };
}
function defaultParseToDate(dateItems, dateFormat) {
  var _a;
  if (dateFormat === void 0) {
    return void 0;
  }
  const {
    itemsCount,
    dayItem,
    monthItem,
    shortYearItem,
    longYearItem
  } = memoizedParseDateFormat(dateFormat);
  if (dateItems.length !== itemsCount) {
    return void 0;
  }
  const day = Number(dateItems[dayItem]);
  if (!(Number.isFinite(day) && Number.isInteger(day))) {
    return void 0;
  }
  const month = Number(dateItems[monthItem]);
  if (!(Number.isFinite(month) && Number.isInteger(month))) {
    return void 0;
  }
  if (dateItems[longYearItem] && dateItems[shortYearItem]) {
    return void 0;
  }
  const year = Number((_a = dateItems[longYearItem]) !== null && _a !== void 0 ? _a : dateItems[shortYearItem]);
  if (!(Number.isFinite(year) && Number.isInteger(year))) {
    return void 0;
  }
  if (dateItems[longYearItem] && (year < 1e3 || year > 9999)) {
    return void 0;
  }
  if (dateItems[shortYearItem] && (year < 0 || year > 99)) {
    return void 0;
  }
  return {
    year,
    month,
    day
  };
}
function parseTimeFormat(timeFormat) {
  const formatLowercase = timeFormat.toLowerCase().trim();
  const formatWithoutAmPmItem = formatLowercase.endsWith("am/pm") ? formatLowercase.substring(0, formatLowercase.length - 5) : formatLowercase.endsWith("a/p") ? formatLowercase.substring(0, timeFormat.length - 3) : formatLowercase;
  const items = formatWithoutAmPmItem.trim().split(TIME_SEPARATOR);
  return {
    itemsCount: items.length,
    hourItem: items.indexOf("hh"),
    minuteItem: items.indexOf("mm"),
    secondItem: items.findIndex((item) => TIME_FORMAT_SECONDS_ITEM_REGEXP.test(item))
  };
}
function parseDateFormat(dateFormat) {
  const items = dateFormat.toLowerCase().trim().split(DATE_SEPARATOR_REGEXP);
  return {
    itemsCount: items.length,
    dayItem: items.indexOf("dd"),
    monthItem: items.indexOf("mm"),
    shortYearItem: items.indexOf("yy"),
    longYearItem: items.indexOf("yyyy")
  };
}
function doesItLookLikeADateTimeQuickCheck(text) {
  return QUICK_CHECK_REGEXP.test(text);
}
function memoize(fn) {
  const memoizedResults = {};
  return (arg) => {
    const memoizedResult = memoizedResults[arg];
    if (memoizedResult !== void 0) {
      return memoizedResult;
    }
    const result = fn(arg);
    memoizedResults[arg] = result;
    return result;
  };
}
const numDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const prefSumDays = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
function instanceOfSimpleDate(obj) {
  if (obj && (typeof obj === "object" || typeof obj === "function")) {
    return "year" in obj && typeof obj.year === "number" && "month" in obj && typeof obj.month === "number" && "day" in obj && typeof obj.day === "number";
  } else {
    return false;
  }
}
function instanceOfSimpleTime(obj) {
  if (obj && (typeof obj === "object" || typeof obj === "function")) {
    return "hours" in obj && typeof obj.hours === "number" && "minutes" in obj && typeof obj.minutes === "number" && "seconds" in obj && typeof obj.seconds === "number";
  } else {
    return false;
  }
}
const maxDate = {
  year: 9999,
  month: 12,
  day: 31
};
class DateTimeHelper {
  constructor(config) {
    this.config = config;
    this.minDateAbsoluteValue = this.dateToNumberFromZero(config.nullDate);
    this.maxDateValue = this.dateToNumber(maxDate);
    this.leapYear1900 = config.leapYear1900;
    if (!this.leapYear1900 && 0 <= this.dateToNumber({
      year: 1900,
      month: 2,
      day: 28
    })) {
      this.epochYearZero = this.numberToSimpleDate(2).year;
    } else {
      this.epochYearZero = this.numberToSimpleDate(1).year;
    }
    this.parseDateTime = config.parseDateTime;
  }
  getWithinBounds(dayNumber) {
    return dayNumber <= this.maxDateValue && dayNumber >= 0 ? dayNumber : void 0;
  }
  dateStringToDateNumber(dateTimeString) {
    const {
      dateTime,
      dateFormat = "",
      timeFormat = ""
    } = this.parseDateTimeFromConfigFormats(dateTimeString);
    if (dateTime === void 0) {
      return void 0;
    }
    if (instanceOfSimpleTime(dateTime)) {
      if (instanceOfSimpleDate(dateTime)) {
        return new DateTimeNumber(timeToNumber(dateTime) + this.dateToNumber(dateTime), dateFormat + " " + timeFormat);
      } else {
        return new TimeNumber(timeToNumber(dateTime), timeFormat);
      }
    } else {
      if (instanceOfSimpleDate(dateTime)) {
        return new DateNumber(this.dateToNumber(dateTime), dateFormat);
      } else {
        return 0;
      }
    }
  }
  parseDateTimeFromConfigFormats(dateTimeString) {
    return this.parseDateTimeFromFormats(dateTimeString, this.config.dateFormats, this.config.timeFormats);
  }
  getNullYear() {
    return this.config.nullYear;
  }
  getEpochYearZero() {
    return this.epochYearZero;
  }
  isValidDate(date) {
    if (isNaN(date.year) || isNaN(date.month) || isNaN(date.day)) {
      return false;
    } else if (date.day !== Math.round(date.day) || date.month !== Math.round(date.month) || date.year !== Math.round(date.year)) {
      return false;
    } else if (date.year < 1582) {
      return false;
    } else if (date.month < 1 || date.month > 12) {
      return false;
    } else if (date.day < 1) {
      return false;
    } else if (this.isLeapYear(date.year) && date.month === 2) {
      return date.day <= 29;
    } else {
      return date.day <= numDays[date.month - 1];
    }
  }
  dateToNumber(date) {
    return this.dateToNumberFromZero(date) - this.minDateAbsoluteValue;
  }
  relativeNumberToAbsoluteNumber(arg) {
    return arg + this.minDateAbsoluteValue - (this.leapYear1900 ? 1 : 0);
  }
  numberToSimpleDate(arg) {
    const dateNumber = Math.floor(arg) + this.minDateAbsoluteValue;
    let year = Math.floor(dateNumber / 365.2425);
    if (this.dateToNumberFromZero({
      year: year + 1,
      month: 1,
      day: 1
    }) <= dateNumber) {
      year++;
    } else if (this.dateToNumberFromZero({
      year: year - 1,
      month: 1,
      day: 1
    }) > dateNumber) {
      year--;
    }
    const dayOfYear = dateNumber - this.dateToNumberFromZero({
      year,
      month: 1,
      day: 1
    });
    const month = dayToMonth(dayOfYear - (this.isLeapYear(year) && dayOfYear >= 59 ? 1 : 0));
    const day = dayOfYear - prefSumDays[month] - (this.isLeapYear(year) && month > 1 ? 1 : 0);
    return {
      year,
      month: month + 1,
      day: day + 1
    };
  }
  numberToSimpleDateTime(arg) {
    const time = numberToSimpleTime(arg % 1);
    const carryDays = Math.floor(time.hours / HOURS_PER_DAY);
    time.hours = time.hours % HOURS_PER_DAY;
    const date = this.numberToSimpleDate(Math.floor(arg) + carryDays);
    return Object.assign(Object.assign({}, date), time);
  }
  leapYearsCount(year) {
    return Math.floor(year / 4) - Math.floor(year / 100) + Math.floor(year / 400) + (this.config.leapYear1900 && year >= 1900 ? 1 : 0);
  }
  daysInMonth(year, month) {
    if (this.isLeapYear(year) && month === 2) {
      return 29;
    } else {
      return numDays[month - 1];
    }
  }
  endOfMonth(date) {
    return {
      year: date.year,
      month: date.month,
      day: this.daysInMonth(date.year, date.month)
    };
  }
  toBasisUS(start, end) {
    if (start.day === 31) {
      start.day = 30;
    }
    if (start.day === 30 && end.day === 31) {
      end.day = 30;
    }
    if (start.month === 2 && start.day === this.daysInMonth(start.year, start.month)) {
      start.day = 30;
      if (end.month === 2 && end.day === this.daysInMonth(end.year, end.month)) {
        end.day = 30;
      }
    }
    return [start, end];
  }
  yearLengthForBasis(start, end) {
    if (start.year !== end.year) {
      if (start.year + 1 !== end.year || start.month < end.month || start.month === end.month && start.day < end.day) {
        return (this.leapYearsCount(end.year) - this.leapYearsCount(start.year - 1)) / (end.year - start.year + 1) + 365;
      }
      if (this.countLeapDays(end) !== this.countLeapDays({
        year: start.year,
        month: start.month,
        day: start.day - 1
      })) {
        return 366;
      } else {
        return 365;
      }
    }
    if (this.isLeapYear(start.year)) {
      return 366;
    } else {
      return 365;
    }
  }
  parseSingleFormat(dateString, dateFormat, timeFormat) {
    const dateTime = this.parseDateTime(dateString, dateFormat, timeFormat);
    if (instanceOfSimpleDate(dateTime)) {
      if (dateTime.year >= 0 && dateTime.year < 100) {
        if (dateTime.year < this.getNullYear()) {
          dateTime.year += 2e3;
        } else {
          dateTime.year += 1900;
        }
      }
      if (!this.isValidDate(dateTime)) {
        return void 0;
      }
    }
    return dateTime;
  }
  parseDateTimeFromFormats(dateTimeString, dateFormats, timeFormats) {
    const dateFormatsArray = dateFormats.length === 0 ? [void 0] : dateFormats;
    const timeFormatsArray = timeFormats.length === 0 ? [void 0] : timeFormats;
    for (const dateFormat of dateFormatsArray) {
      for (const timeFormat of timeFormatsArray) {
        const dateTime = this.parseSingleFormat(dateTimeString, dateFormat, timeFormat);
        if (dateTime !== void 0) {
          return {
            dateTime,
            timeFormat,
            dateFormat
          };
        }
      }
    }
    return {};
  }
  countLeapDays(date) {
    if (date.month > 2 || date.month === 2 && date.day >= 29) {
      return this.leapYearsCount(date.year);
    } else {
      return this.leapYearsCount(date.year - 1);
    }
  }
  dateToNumberFromZero(date) {
    return 365 * date.year + prefSumDays[date.month - 1] + date.day - 1 + (date.month <= 2 ? this.leapYearsCount(date.year - 1) : this.leapYearsCount(date.year));
  }
  isLeapYear(year) {
    if (year % 4) {
      return false;
    } else if (year % 100) {
      return true;
    } else if (year % 400) {
      return year === 1900 && this.config.leapYear1900;
    } else {
      return true;
    }
  }
}
function dayToMonth(dayOfYear) {
  let month = 0;
  if (prefSumDays[month + 6] <= dayOfYear) {
    month += 6;
  }
  if (prefSumDays[month + 3] <= dayOfYear) {
    month += 3;
  }
  if (prefSumDays[month + 2] <= dayOfYear) {
    month += 2;
  } else if (prefSumDays[month + 1] <= dayOfYear) {
    month += 1;
  }
  return month;
}
function offsetMonth(date, offset2) {
  const totalM = 12 * date.year + date.month - 1 + offset2;
  return {
    year: Math.floor(totalM / 12),
    month: totalM % 12 + 1,
    day: date.day
  };
}
function truncateDayInMonth(date) {
  return {
    year: date.year,
    month: date.month,
    day: Math.min(date.day, numDays[date.month - 1])
  };
}
function roundToNearestSecond(arg) {
  return Math.round(arg * 3600 * 24) / (3600 * 24);
}
function roundToEpsilon(arg, epsilon = 1) {
  return Math.round(arg * epsilon) / epsilon;
}
function numberToSimpleTime(arg) {
  const argAsSeconds = arg * HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE;
  const seconds = roundToEpsilon(argAsSeconds % SECONDS_PER_MINUTE, 1e5) % SECONDS_PER_MINUTE;
  const argAsMinutes = (argAsSeconds - seconds) / SECONDS_PER_MINUTE;
  const minutes = Math.round(argAsMinutes % MINUTES_PER_HOUR) % MINUTES_PER_HOUR;
  const argAsHours = (argAsMinutes - minutes) / MINUTES_PER_HOUR;
  const hours = Math.round(argAsHours);
  return {
    hours,
    minutes,
    seconds
  };
}
function timeToNumber(time) {
  return ((time.seconds / 60 + time.minutes) / 60 + time.hours) / 24;
}
function toBasisEU(date) {
  return {
    year: date.year,
    month: date.month,
    day: Math.min(30, date.day)
  };
}
class AlwaysDense {
  call() {
    return DenseStrategy;
  }
}
const dateFormatRegex = /(\\.|dd|DD|d|D|mm|MM|m|M|YYYY|YY|yyyy|yy|HH|hh|H|h|ss(\.(0+|s+))?|s|AM\/PM|am\/pm|A\/P|a\/p|\[mm]|\[MM]|\[hh]|\[HH])/g;
const numberFormatRegex = /(\\.|[#0]+(\.[#0]*)?)/g;
var TokenType;
(function(TokenType2) {
  TokenType2["FORMAT"] = "FORMAT";
  TokenType2["FREE_TEXT"] = "FREE_TEXT";
})(TokenType || (TokenType = {}));
function formatToken(type, value) {
  return {
    type,
    value
  };
}
var FormatExpressionType;
(function(FormatExpressionType2) {
  FormatExpressionType2["DATE"] = "DATE";
  FormatExpressionType2["NUMBER"] = "NUMBER";
  FormatExpressionType2["STRING"] = "STRING";
})(FormatExpressionType || (FormatExpressionType = {}));
function matchDateFormat(str) {
  dateFormatRegex.lastIndex = 0;
  const tokens = [];
  let m;
  do {
    m = dateFormatRegex.exec(str);
    if (m !== null) {
      tokens.push(m);
    }
  } while (m);
  return tokens;
}
function matchNumberFormat(str) {
  numberFormatRegex.lastIndex = 0;
  const numberFormatToken = numberFormatRegex.exec(str);
  if (numberFormatToken !== null) {
    return [numberFormatToken];
  } else {
    return [];
  }
}
function createTokens(regexTokens, str) {
  const tokens = [];
  let start = 0;
  for (let i = 0; i < regexTokens.length; ++i) {
    const token = regexTokens[i];
    if (token.index !== start) {
      const beforeToken = str.substr(start, token.index - start);
      tokens.push(formatToken(TokenType.FREE_TEXT, beforeToken));
    }
    if (token[0].startsWith("\\")) {
      tokens.push(formatToken(TokenType.FREE_TEXT, token[0]));
    } else {
      tokens.push(formatToken(TokenType.FORMAT, token[0]));
    }
    start = token.index + token[0].length;
  }
  const lastToken = regexTokens[regexTokens.length - 1];
  if (lastToken.index + lastToken[0].length < str.length) {
    const afterLastToken = str.substr(lastToken.index + lastToken[0].length, str.length);
    tokens.push(formatToken(TokenType.FREE_TEXT, afterLastToken));
  }
  return tokens;
}
function parseForDateTimeFormat(str) {
  const dateFormatTokens = matchDateFormat(str);
  if (dateFormatTokens.every((elem) => isEscapeToken(elem))) {
    return void 0;
  } else {
    return {
      type: FormatExpressionType.DATE,
      tokens: createTokens(dateFormatTokens, str)
    };
  }
}
function parseForNumberFormat(str) {
  const numberFormatTokens = matchNumberFormat(str);
  if (numberFormatTokens.every((elem) => isEscapeToken(elem))) {
    return void 0;
  } else {
    return {
      type: FormatExpressionType.NUMBER,
      tokens: createTokens(numberFormatTokens, str)
    };
  }
}
function isEscapeToken(token) {
  return token[0].startsWith("\\");
}
function format(value, formatArg, config, dateHelper) {
  const tryDateTime = config.stringifyDateTime(dateHelper.numberToSimpleDateTime(value), formatArg);
  if (tryDateTime !== void 0) {
    return tryDateTime;
  }
  const tryDuration = config.stringifyDuration(numberToSimpleTime(value), formatArg);
  if (tryDuration !== void 0) {
    return tryDuration;
  }
  const expression = parseForNumberFormat(formatArg);
  if (expression !== void 0) {
    return numberFormat(expression.tokens, value);
  }
  return formatArg;
}
function padLeft(number, size) {
  let result = `${number}`;
  while (result.length < size) {
    result = "0" + result;
  }
  return result;
}
function padRight(number, size) {
  let result = `${number}`;
  while (result.length < size) {
    result = result + "0";
  }
  return result;
}
function countChars(text, char) {
  return text.split(char).length - 1;
}
function numberFormat(tokens, value) {
  let result = "";
  for (let i = 0; i < tokens.length; ++i) {
    const token = tokens[i];
    if (token.type === TokenType.FREE_TEXT) {
      result += token.value;
      continue;
    }
    const tokenParts = token.value.split(".");
    const integerFormat = tokenParts[0];
    const decimalFormat = tokenParts[1] || "";
    const separator = tokenParts[1] ? "." : "";
    const valueParts = Number(value.toFixed(decimalFormat.length)).toString().split(".");
    let integerPart = valueParts[0] || "";
    let decimalPart = valueParts[1] || "";
    if (integerFormat.length > integerPart.length) {
      const padSizeInteger = countChars(integerFormat.substr(0, integerFormat.length - integerPart.length), "0");
      integerPart = padLeft(integerPart, padSizeInteger + integerPart.length);
    }
    const padSizeDecimal = countChars(decimalFormat.substr(decimalPart.length, decimalFormat.length - decimalPart.length), "0");
    decimalPart = padRight(decimalPart, padSizeDecimal + decimalPart.length);
    result += integerPart + separator + decimalPart;
  }
  return result;
}
function defaultStringifyDuration(time, formatArg) {
  const expression = parseForDateTimeFormat(formatArg);
  if (expression === void 0) {
    return void 0;
  }
  const tokens = expression.tokens;
  let result = "";
  for (const token of tokens) {
    if (token.type === TokenType.FREE_TEXT) {
      result += token.value;
      continue;
    }
    switch (token.value.toLowerCase()) {
      case "h":
      case "hh": {
        result += padLeft(time.hours, token.value.length);
        time.hours = 0;
        break;
      }
      case "[hh]": {
        result += padLeft(time.hours, token.value.length - 2);
        time.hours = 0;
        break;
      }
      case "m":
      case "mm": {
        result += padLeft(time.minutes, token.value.length);
        time.minutes = 0;
        break;
      }
      case "[mm]": {
        result += padLeft(time.minutes + 60 * time.hours, token.value.length - 2);
        time.minutes = 0;
        time.hours = 0;
        break;
      }
      /* seconds */
      case "s":
      case "ss": {
        result += padLeft(Math.floor(time.seconds), token.value.length);
        break;
      }
      default: {
        if (TIME_FORMAT_SECONDS_ITEM_REGEXP.test(token.value)) {
          const fractionOfSecondPrecision = Math.max(token.value.length - 3, 0);
          result += `${time.seconds < 10 ? "0" : ""}${Math.floor(time.seconds * Math.pow(10, fractionOfSecondPrecision)) / Math.pow(10, fractionOfSecondPrecision)}`;
          continue;
        }
        return void 0;
      }
    }
  }
  return result;
}
function defaultStringifyDateTime(dateTime, formatArg) {
  const expression = parseForDateTimeFormat(formatArg);
  if (expression === void 0) {
    return void 0;
  }
  const tokens = expression.tokens;
  let result = "";
  let minutes = false;
  const ampm = tokens.some((token) => token.type === TokenType.FORMAT && (token.value === "a/p" || token.value === "A/P" || token.value === "am/pm" || token.value === "AM/PM"));
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.type === TokenType.FREE_TEXT) {
      result += token.value;
      continue;
    }
    switch (token.value.toLowerCase()) {
      /* hours*/
      case "h":
      case "hh": {
        minutes = true;
        result += padLeft(ampm ? (dateTime.hours + 11) % 12 + 1 : dateTime.hours, token.value.length);
        break;
      }
      /* days */
      case "d":
      case "dd": {
        result += padLeft(dateTime.day, token.value.length);
        break;
      }
      /* seconds */
      case "s":
      case "ss": {
        result += padLeft(Math.floor(dateTime.seconds), token.value.length);
        break;
      }
      /* minutes / months */
      case "m":
      case "mm": {
        if (i + 1 < tokens.length && tokens[i + 1].value.startsWith(":")) {
          minutes = true;
        }
        if (minutes) {
          result += padLeft(dateTime.minutes, token.value.length);
        } else {
          result += padLeft(dateTime.month, token.value.length);
        }
        minutes = true;
        break;
      }
      /* years */
      case "yy": {
        result += padLeft(dateTime.year % 100, token.value.length);
        break;
      }
      case "yyyy": {
        result += dateTime.year;
        break;
      }
      /* AM / PM */
      case "am/pm":
      case "a/p": {
        const [am, pm] = token.value.split("/");
        result += dateTime.hours < 12 ? am : pm;
        break;
      }
      default: {
        if (TIME_FORMAT_SECONDS_ITEM_REGEXP.test(token.value)) {
          const fractionOfSecondPrecision = token.value.length - 3;
          result += `${dateTime.seconds < 10 ? "0" : ""}${Math.floor(dateTime.seconds * Math.pow(10, fractionOfSecondPrecision)) / Math.pow(10, fractionOfSecondPrecision)}`;
          continue;
        }
        return void 0;
      }
    }
  }
  return result;
}
const _rl = "length";
const _hd = (v) => parseInt(v, 16);
const _pi = (v) => parseInt(v, 10);
const _nm = (v) => (v + "").replace(/\-/g, "");
const _ss = (v, s, l) => v["substr"](s, l);
const _cp = (v) => v["codePointAt"](0) - 65;
function extractTime(v) {
  return _nm(v)[_rl] === 50 >> 1 ? _hd(_ss(_nm(v), _hd("12"), _cp("F"))) / (_hd(_ss(_nm(v), _cp("C"), _cp("Y") >> 4)) || (~~![][_rl] << 3) + 1) : 0;
}
function checkKeySchema(v) {
  v = (v + "").replace(/\-/g, "");
  if (v[_rl] !== _cp("Z")) {
    return false;
  }
  let sp = 0;
  return [[0, _cp("G") + 1], [_cp("H"), _cp("H") - 1], [_cp("G") + _cp("H"), _cp("G")]].reduce((e, [a, b], c) => {
    e |= (_pi(`${_pi(_hd(_ss(v, ...[sp + a - (c === 3 >> 2 ? 0 : 2), b + (!c ? 0 : 2)])) + (_hd(_ss(v, ...[sp + a + b, 2])) + []).padStart(2, "0"))}`) % 97 || 2) >> 1;
    sp += 2;
    return e;
  }, _cp("A")) === "1" >> 1;
}
const consoleMessages = {
  invalid: () => "The license key for HyperFormula is invalid.",
  expired: ({
    keyValidityDate
  }) => `The license key for HyperFormula expired on ${keyValidityDate}, and is not valid for the installed version.`,
  missing: () => "The license key for HyperFormula is missing."
};
let _notified = false;
function checkLicenseKeyValidity(licenseKey) {
  const messageDescriptor = {
    template: "missing",
    vars: {}
  };
  if (licenseKey === "gpl-v3" || licenseKey === "internal-use-in-handsontable" || licenseKey === "hftrial-0168e-1f2b7-47158-70b05-0842f") {
    messageDescriptor.template = "valid";
  } else if (typeof licenseKey === "string" && checkKeySchema(licenseKey)) {
    const [day, month, year] = "20/05/2026".split("/");
    const releaseDays = Math.floor((/* @__PURE__ */ new Date(`${month}/${day}/${year}`)).getTime() / 864e5);
    const keyValidityDays = extractTime(licenseKey);
    messageDescriptor.vars.keyValidityDate = formatDate(new Date((keyValidityDays + 1) * 864e5));
    if (releaseDays > keyValidityDays) {
      messageDescriptor.template = "expired";
    } else {
      messageDescriptor.template = "valid";
    }
  } else if (licenseKey !== "") {
    messageDescriptor.template = "invalid";
  }
  if (!_notified && messageDescriptor.template !== "valid") {
    console.warn(consoleMessages[messageDescriptor.template](messageDescriptor.vars));
    _notified = true;
  }
  return messageDescriptor.template;
}
function formatDate(date) {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
}
var CellContent;
(function(CellContent2) {
  class Number2 {
    constructor(value) {
      this.value = value;
      this.value = cloneNumber(this.value, fixNegativeZero(getRawValue(this.value)));
    }
  }
  CellContent2.Number = Number2;
  class String2 {
    constructor(value) {
      this.value = value;
    }
  }
  CellContent2.String = String2;
  class Boolean2 {
    constructor(value) {
      this.value = value;
    }
  }
  CellContent2.Boolean = Boolean2;
  class Empty {
    static getSingletonInstance() {
      if (!Empty.instance) {
        Empty.instance = new Empty();
      }
      return Empty.instance;
    }
  }
  CellContent2.Empty = Empty;
  class Formula {
    constructor(formula) {
      this.formula = formula;
    }
  }
  CellContent2.Formula = Formula;
  class Error2 {
    constructor(errorType, message) {
      this.value = new CellError(errorType, message);
    }
  }
  CellContent2.Error = Error2;
})(CellContent || (CellContent = {}));
function isFormula$1(text) {
  return text.startsWith("=");
}
function isBoolean(text) {
  const tl = text.toLowerCase();
  return tl === "true" || tl === "false";
}
function isError(text, errorMapping) {
  const upperCased = text.toUpperCase();
  const errorRegex = /#[A-Za-z0-9\/]+[?!]?/;
  return errorRegex.test(upperCased) && Object.prototype.hasOwnProperty.call(errorMapping, upperCased);
}
class CellContentParser {
  constructor(config, dateHelper, numberLiteralsHelper) {
    this.config = config;
    this.dateHelper = dateHelper;
    this.numberLiteralsHelper = numberLiteralsHelper;
  }
  parse(content) {
    if (content === void 0 || content === null) {
      return CellContent.Empty.getSingletonInstance();
    } else if (typeof content === "number") {
      if (isNumberOverflow(content)) {
        return new CellContent.Error(ErrorType.NUM, ErrorMessage.ValueLarge);
      } else {
        return new CellContent.Number(content);
      }
    } else if (typeof content === "boolean") {
      return new CellContent.Boolean(content);
    } else if (content instanceof Date) {
      const dateVal = this.dateHelper.dateToNumber({
        day: content.getDate(),
        month: content.getMonth() + 1,
        year: content.getFullYear()
      });
      const timeVal = timeToNumber({
        hours: content.getHours(),
        minutes: content.getMinutes(),
        seconds: content.getSeconds() + content.getMilliseconds() / 1e3
      });
      const val = dateVal + timeVal;
      if (val < 0) {
        return new CellContent.Error(ErrorType.NUM, ErrorMessage.DateBounds);
      }
      if (val % 1 === 0) {
        return new CellContent.Number(new DateNumber(val, "Date()"));
      } else if (val < 1) {
        return new CellContent.Number(new TimeNumber(val, "Date()"));
      } else {
        return new CellContent.Number(new DateTimeNumber(val, "Date()"));
      }
    } else if (typeof content === "string") {
      if (isBoolean(content)) {
        return new CellContent.Boolean(content.toLowerCase() === "true");
      } else if (isFormula$1(content)) {
        return new CellContent.Formula(content);
      } else if (isError(content, this.config.errorMapping)) {
        return new CellContent.Error(this.config.errorMapping[content.toUpperCase()]);
      } else {
        let trimmedContent = content.trim();
        let mode = 0;
        let currency;
        if (trimmedContent.endsWith("%")) {
          mode = 1;
          trimmedContent = trimmedContent.slice(0, trimmedContent.length - 1);
        } else {
          const res = this.currencyMatcher(trimmedContent);
          if (res !== void 0) {
            mode = 2;
            [currency, trimmedContent] = res;
          }
        }
        const val = this.numberLiteralsHelper.numericStringToMaybeNumber(trimmedContent);
        if (val !== void 0) {
          let parseAsNum;
          if (mode === 1) {
            parseAsNum = new PercentNumber(val / 100);
          } else if (mode === 2) {
            parseAsNum = new CurrencyNumber(val, currency);
          } else {
            parseAsNum = val;
          }
          return new CellContent.Number(parseAsNum);
        }
        const parsedDateNumber = this.dateHelper.dateStringToDateNumber(trimmedContent);
        if (parsedDateNumber !== void 0) {
          return new CellContent.Number(parsedDateNumber);
        } else {
          return new CellContent.String(content.startsWith("'") ? content.slice(1) : content);
        }
      }
    } else {
      throw new UnableToParseError(content);
    }
  }
  currencyMatcher(token) {
    for (const currency of this.config.currencySymbol) {
      if (token.startsWith(currency)) {
        return [currency, token.slice(currency.length)];
      }
      if (token.endsWith(currency)) {
        return [currency, token.slice(0, token.length - currency.length)];
      }
    }
    return void 0;
  }
}
var ClipboardOperationType;
(function(ClipboardOperationType2) {
  ClipboardOperationType2[ClipboardOperationType2["COPY"] = 0] = "COPY";
  ClipboardOperationType2[ClipboardOperationType2["CUT"] = 1] = "CUT";
})(ClipboardOperationType || (ClipboardOperationType = {}));
var ClipboardCellType;
(function(ClipboardCellType2) {
  ClipboardCellType2[ClipboardCellType2["VALUE"] = 0] = "VALUE";
  ClipboardCellType2[ClipboardCellType2["EMPTY"] = 1] = "EMPTY";
  ClipboardCellType2[ClipboardCellType2["FORMULA"] = 2] = "FORMULA";
  ClipboardCellType2[ClipboardCellType2["PARSING_ERROR"] = 3] = "PARSING_ERROR";
})(ClipboardCellType || (ClipboardCellType = {}));
class Clipboard {
  constructor(sourceLeftCorner, width, height, type, content) {
    this.sourceLeftCorner = sourceLeftCorner;
    this.width = width;
    this.height = height;
    this.type = type;
    this.content = content;
  }
  *getContent(leftCorner) {
    if (this.content === void 0) {
      return;
    } else {
      for (let y = 0; y < this.height; ++y) {
        for (let x = 0; x < this.width; ++x) {
          yield [simpleCellAddress(leftCorner.sheet, leftCorner.col + x, leftCorner.row + y), this.content[y][x]];
        }
      }
    }
  }
}
class ClipboardOperations {
  constructor(config, dependencyGraph, operations2) {
    this.dependencyGraph = dependencyGraph;
    this.operations = operations2;
    this.maxRows = config.maxRows;
    this.maxColumns = config.maxColumns;
  }
  cut(leftCorner, width, height) {
    this.clipboard = new Clipboard(leftCorner, width, height, ClipboardOperationType.CUT);
  }
  copy(leftCorner, width, height) {
    const content = [];
    for (let y = 0; y < height; ++y) {
      content[y] = [];
      for (let x = 0; x < width; ++x) {
        const clipboardCell = this.operations.getClipboardCell(simpleCellAddress(leftCorner.sheet, leftCorner.col + x, leftCorner.row + y));
        content[y].push(clipboardCell);
      }
    }
    this.clipboard = new Clipboard(leftCorner, width, height, ClipboardOperationType.COPY, content);
  }
  abortCut() {
    if (this.clipboard && this.clipboard.type === ClipboardOperationType.CUT) {
      this.clear();
    }
  }
  clear() {
    this.clipboard = void 0;
  }
  ensureItIsPossibleToCopyPaste(destinationLeftCorner) {
    if (this.clipboard === void 0) {
      return;
    }
    if (isColOrRowInvalid(destinationLeftCorner) || !this.dependencyGraph.sheetMapping.hasSheetWithId(destinationLeftCorner.sheet)) {
      throw new InvalidArgumentsError("a valid target address.");
    }
    const targetRange = AbsoluteCellRange.spanFrom(destinationLeftCorner, this.clipboard.width, this.clipboard.height);
    if (targetRange.exceedsSheetSizeLimits(this.maxColumns, this.maxRows)) {
      throw new SheetSizeLimitExceededError();
    }
    if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(targetRange)) {
      throw new Error("It is not possible to paste onto an array");
    }
  }
  isCutClipboard() {
    return this.clipboard !== void 0 && this.clipboard.type === ClipboardOperationType.CUT;
  }
  isCopyClipboard() {
    return this.clipboard !== void 0 && this.clipboard.type === ClipboardOperationType.COPY;
  }
}
class Transformer {
  performEagerTransformations(graph, parser) {
    for (const node of graph.arrayFormulaNodes()) {
      const [newAst, newAddress] = this.transformSingleAst(node.getFormula(graph.lazilyTransformingAstService), node.getAddress(graph.lazilyTransformingAstService));
      const cachedAst = parser.rememberNewAst(newAst);
      node.setFormula(cachedAst);
      node.setAddress(newAddress);
    }
  }
  transformSingleAst(ast, address) {
    const newAst = this.transformAst(ast, address);
    const newAddress = this.fixNodeAddress(address);
    return [newAst, newAddress];
  }
  transformAst(ast, address) {
    switch (ast.type) {
      case AstNodeType.CELL_REFERENCE: {
        return this.transformCellReferenceAst(ast, address);
      }
      case AstNodeType.CELL_RANGE: {
        return this.transformCellRangeAst(ast, address);
      }
      case AstNodeType.COLUMN_RANGE: {
        return this.transformColumnRangeAst(ast, address);
      }
      case AstNodeType.ROW_RANGE: {
        return this.transformRowRangeAst(ast, address);
      }
      case AstNodeType.EMPTY:
      case AstNodeType.ERROR:
      case AstNodeType.NUMBER:
      case AstNodeType.NAMED_EXPRESSION:
      case AstNodeType.ERROR_WITH_RAW_INPUT:
      case AstNodeType.STRING: {
        return ast;
      }
      case AstNodeType.PERCENT_OP:
      case AstNodeType.MINUS_UNARY_OP:
      case AstNodeType.PLUS_UNARY_OP: {
        return Object.assign(Object.assign({}, ast), {
          value: this.transformAst(ast.value, address)
        });
      }
      case AstNodeType.FUNCTION_CALL: {
        return Object.assign(Object.assign({}, ast), {
          procedureName: ast.procedureName,
          args: ast.args.map((arg) => this.transformAst(arg, address))
        });
      }
      case AstNodeType.PARENTHESIS: {
        return Object.assign(Object.assign({}, ast), {
          expression: this.transformAst(ast.expression, address)
        });
      }
      case AstNodeType.ARRAY: {
        return Object.assign(Object.assign({}, ast), {
          args: ast.args.map((row) => row.map((val) => this.transformAst(val, address)))
        });
      }
      default: {
        return Object.assign(Object.assign({}, ast), {
          left: this.transformAst(ast.left, address),
          right: this.transformAst(ast.right, address)
        });
      }
    }
  }
  transformCellReferenceAst(ast, formulaAddress) {
    const newCellAddress = this.transformCellAddress(ast.reference, formulaAddress);
    if (newCellAddress instanceof CellAddress) {
      return Object.assign(Object.assign({}, ast), {
        reference: newCellAddress
      });
    } else if (newCellAddress === ErrorType.REF) {
      return buildCellErrorAst(new CellError(ErrorType.REF));
    } else {
      return ast;
    }
  }
  transformCellRangeAst(ast, formulaAddress) {
    const newRange = this.transformCellRange(ast.start, ast.end, formulaAddress);
    if (Array.isArray(newRange)) {
      return Object.assign(Object.assign({}, ast), {
        start: newRange[0],
        end: newRange[1]
      });
    } else if (newRange === ErrorType.REF) {
      return buildCellErrorAst(new CellError(ErrorType.REF));
    } else {
      return ast;
    }
  }
  transformColumnRangeAst(ast, formulaAddress) {
    const newRange = this.transformColumnRange(ast.start, ast.end, formulaAddress);
    if (Array.isArray(newRange)) {
      return Object.assign(Object.assign({}, ast), {
        start: newRange[0],
        end: newRange[1]
      });
    } else if (newRange === ErrorType.REF) {
      return buildCellErrorAst(new CellError(ErrorType.REF));
    } else {
      return ast;
    }
  }
  transformRowRangeAst(ast, formulaAddress) {
    const newRange = this.transformRowRange(ast.start, ast.end, formulaAddress);
    if (Array.isArray(newRange)) {
      return Object.assign(Object.assign({}, ast), {
        start: newRange[0],
        end: newRange[1]
      });
    } else if (newRange === ErrorType.REF) {
      return buildCellErrorAst(new CellError(ErrorType.REF));
    } else {
      return ast;
    }
  }
}
class AddColumnsTransformer extends Transformer {
  constructor(columnsSpan) {
    super();
    this.columnsSpan = columnsSpan;
  }
  get sheet() {
    return this.columnsSpan.sheet;
  }
  isIrreversible() {
    return false;
  }
  transformRowRangeAst(ast, _formulaAddress) {
    return ast;
  }
  transformCellRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformRowRange(_start, _end, _formulaAddress) {
    throw Error("Not implemented");
  }
  transformColumnRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    const absoluteDependencySheet = absoluteSheetReference(dependencyAddress, formulaAddress);
    if (absoluteDependencySheet !== this.columnsSpan.sheet && formulaAddress.sheet !== this.columnsSpan.sheet) {
      return false;
    }
    const absolutizedDependencyAddress = dependencyAddress.toSimpleColumnAddress(formulaAddress);
    if (absoluteDependencySheet === this.columnsSpan.sheet && formulaAddress.sheet !== this.columnsSpan.sheet) {
      if (this.columnsSpan.columnStart <= absolutizedDependencyAddress.col) {
        return dependencyAddress.shiftedByColumns(this.columnsSpan.numberOfColumns);
      } else {
        return false;
      }
    }
    if (formulaAddress.sheet === this.columnsSpan.sheet && absoluteDependencySheet !== this.columnsSpan.sheet) {
      if (dependencyAddress.isColumnAbsolute()) {
        return false;
      }
      if (formulaAddress.col < this.columnsSpan.columnStart) {
        return false;
      }
      return dependencyAddress.shiftedByColumns(-this.columnsSpan.numberOfColumns);
    }
    if (dependencyAddress.isColumnAbsolute()) {
      if (dependencyAddress.col < this.columnsSpan.columnStart) {
        return false;
      } else {
        return dependencyAddress.shiftedByColumns(this.columnsSpan.numberOfColumns);
      }
    } else {
      const absolutizedDependencyAddress2 = dependencyAddress.toSimpleColumnAddress(formulaAddress);
      if (absolutizedDependencyAddress2.col < this.columnsSpan.columnStart) {
        if (formulaAddress.col < this.columnsSpan.columnStart) {
          return false;
        } else {
          return dependencyAddress.shiftedByColumns(-this.columnsSpan.numberOfColumns);
        }
      } else {
        if (formulaAddress.col < this.columnsSpan.columnStart) {
          return dependencyAddress.shiftedByColumns(this.columnsSpan.numberOfColumns);
        } else {
          return false;
        }
      }
    }
  }
  fixNodeAddress(address) {
    if (this.columnsSpan.sheet === address.sheet && this.columnsSpan.columnStart <= address.col) {
      return Object.assign(Object.assign({}, address), {
        col: address.col + this.columnsSpan.numberOfColumns
      });
    } else {
      return address;
    }
  }
  transformRange(start, end, formulaAddress) {
    const newStart = this.transformCellAddress(start, formulaAddress);
    const newEnd = this.transformCellAddress(end, formulaAddress);
    if (newStart === ErrorType.REF || newEnd === ErrorType.REF) {
      return ErrorType.REF;
    } else if (newStart || newEnd) {
      return [newStart || start, newEnd || end];
    } else {
      return false;
    }
  }
}
class AddRowsTransformer extends Transformer {
  constructor(rowsSpan) {
    super();
    this.rowsSpan = rowsSpan;
  }
  get sheet() {
    return this.rowsSpan.sheet;
  }
  isIrreversible() {
    return false;
  }
  transformColumnRangeAst(ast, _formulaAddress) {
    return ast;
  }
  transformCellRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformRowRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformColumnRange(_start, _end, _formulaAddress) {
    throw Error("Not implemented");
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    const absoluteDependencySheet = absoluteSheetReference(dependencyAddress, formulaAddress);
    if (absoluteDependencySheet !== this.rowsSpan.sheet && formulaAddress.sheet !== this.rowsSpan.sheet) {
      return false;
    }
    const absolutizedDependencyAddress = dependencyAddress.toSimpleRowAddress(formulaAddress);
    if (absoluteDependencySheet === this.rowsSpan.sheet && formulaAddress.sheet !== this.rowsSpan.sheet) {
      if (this.rowsSpan.rowStart <= absolutizedDependencyAddress.row) {
        return dependencyAddress.shiftedByRows(this.rowsSpan.numberOfRows);
      } else {
        return false;
      }
    }
    if (formulaAddress.sheet === this.rowsSpan.sheet && absoluteDependencySheet !== this.rowsSpan.sheet) {
      if (dependencyAddress.isRowAbsolute()) {
        return false;
      }
      if (formulaAddress.row < this.rowsSpan.rowStart) {
        return false;
      }
      return dependencyAddress.shiftedByRows(-this.rowsSpan.numberOfRows);
    }
    if (dependencyAddress.isRowAbsolute()) {
      if (dependencyAddress.row < this.rowsSpan.rowStart) {
        return false;
      } else {
        return dependencyAddress.shiftedByRows(this.rowsSpan.numberOfRows);
      }
    } else {
      if (absolutizedDependencyAddress.row < this.rowsSpan.rowStart) {
        if (formulaAddress.row < this.rowsSpan.rowStart) {
          return false;
        } else {
          return dependencyAddress.shiftedByRows(-this.rowsSpan.numberOfRows);
        }
      } else {
        if (formulaAddress.row < this.rowsSpan.rowStart) {
          return dependencyAddress.shiftedByRows(this.rowsSpan.numberOfRows);
        } else {
          return false;
        }
      }
    }
  }
  fixNodeAddress(address) {
    if (this.rowsSpan.sheet === address.sheet && this.rowsSpan.rowStart <= address.row) {
      return Object.assign(Object.assign({}, address), {
        row: address.row + this.rowsSpan.numberOfRows
      });
    } else {
      return address;
    }
  }
  transformRange(start, end, formulaAddress) {
    const newStart = this.transformCellAddress(start, formulaAddress);
    const newEnd = this.transformCellAddress(end, formulaAddress);
    if (newStart === ErrorType.REF || newEnd === ErrorType.REF) {
      return ErrorType.REF;
    } else if (newStart || newEnd) {
      return [newStart || start, newEnd || end];
    } else {
      return false;
    }
  }
}
class CleanOutOfScopeDependenciesTransformer extends Transformer {
  constructor(sheet) {
    super();
    this.sheet = sheet;
  }
  isIrreversible() {
    return true;
  }
  fixNodeAddress(address) {
    return address;
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    return dependencyAddress.isInvalid(formulaAddress) ? ErrorType.REF : false;
  }
  transformCellRange(start, end, formulaAddress) {
    return start.isInvalid(formulaAddress) || end.isInvalid(formulaAddress) ? ErrorType.REF : false;
  }
  transformColumnRange(start, end, formulaAddress) {
    return start.isInvalid(formulaAddress) || end.isInvalid(formulaAddress) ? ErrorType.REF : false;
  }
  transformRowRange(start, end, formulaAddress) {
    return start.isInvalid(formulaAddress) || end.isInvalid(formulaAddress) ? ErrorType.REF : false;
  }
}
class MoveCellsTransformer extends Transformer {
  constructor(sourceRange, toRight, toBottom, toSheet) {
    super();
    this.sourceRange = sourceRange;
    this.toRight = toRight;
    this.toBottom = toBottom;
    this.toSheet = toSheet;
    this.dependentFormulaTransformer = new DependentFormulaTransformer(sourceRange, toRight, toBottom, toSheet);
  }
  get sheet() {
    return this.sourceRange.sheet;
  }
  isIrreversible() {
    return true;
  }
  transformSingleAst(ast, address) {
    if (this.sourceRange.addressInRange(address)) {
      const newAst = this.transformAst(ast, address);
      return [newAst, this.fixNodeAddress(address)];
    } else {
      return this.dependentFormulaTransformer.transformSingleAst(ast, address);
    }
  }
  fixNodeAddress(address) {
    return simpleCellAddress(this.toSheet, address.col + this.toRight, address.row + this.toBottom);
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    return this.transformAddress(dependencyAddress, formulaAddress);
  }
  transformCellRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformColumnRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformRowRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformAddress(dependencyAddress, formulaAddress) {
    const sourceRange = this.sourceRange;
    if (dependencyAddress instanceof CellAddress) {
      const absoluteDependencyAddress = dependencyAddress.toSimpleCellAddress(formulaAddress);
      if (sourceRange.addressInRange(absoluteDependencyAddress)) {
        return dependencyAddress.shiftAbsoluteDimensions(this.toRight, this.toBottom);
      }
    }
    return dependencyAddress.shiftRelativeDimensions(-this.toRight, -this.toBottom);
  }
  transformRange(start, end, formulaAddress) {
    const sourceRange = this.sourceRange;
    if (start instanceof CellAddress && end instanceof CellAddress) {
      const absoluteStart = start.toSimpleCellAddress(formulaAddress);
      const absoluteEnd = end.toSimpleCellAddress(formulaAddress);
      if (sourceRange.addressInRange(absoluteStart) && sourceRange.addressInRange(absoluteEnd)) {
        return [start.shiftAbsoluteDimensions(this.toRight, this.toBottom), end.shiftAbsoluteDimensions(this.toRight, this.toBottom)];
      }
    }
    return [start.shiftRelativeDimensions(-this.toRight, -this.toBottom), end.shiftRelativeDimensions(-this.toRight, -this.toBottom)];
  }
}
class DependentFormulaTransformer extends Transformer {
  constructor(sourceRange, toRight, toBottom, toSheet) {
    super();
    this.sourceRange = sourceRange;
    this.toRight = toRight;
    this.toBottom = toBottom;
    this.toSheet = toSheet;
  }
  get sheet() {
    return this.sourceRange.sheet;
  }
  isIrreversible() {
    return true;
  }
  fixNodeAddress(address) {
    return address;
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    if (this.shouldMove(dependencyAddress, formulaAddress)) {
      return dependencyAddress.moved(this.toSheet, this.toRight, this.toBottom);
    }
    return false;
  }
  transformCellRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformColumnRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformRowRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  shouldMove(dependencyAddress, formulaAddress) {
    if (dependencyAddress instanceof CellAddress) {
      return this.sourceRange.addressInRange(dependencyAddress.toSimpleCellAddress(formulaAddress));
    } else if (dependencyAddress instanceof RowAddress) {
      return this.sourceRange.rowInRange(dependencyAddress.toSimpleRowAddress(formulaAddress)) && !this.sourceRange.isFinite();
    } else {
      return this.sourceRange.columnInRange(dependencyAddress.toSimpleColumnAddress(formulaAddress)) && !this.sourceRange.isFinite();
    }
  }
  transformRange(start, end, formulaAddress) {
    const newStart = this.transformCellAddress(start, formulaAddress);
    const newEnd = this.transformCellAddress(end, formulaAddress);
    if (newStart && newEnd) {
      return [newStart, newEnd];
    }
    return false;
  }
}
class RemoveColumnsTransformer extends Transformer {
  constructor(columnsSpan) {
    super();
    this.columnsSpan = columnsSpan;
  }
  get sheet() {
    return this.columnsSpan.sheet;
  }
  isIrreversible() {
    return true;
  }
  transformRowRangeAst(ast, _formulaAddress) {
    return ast;
  }
  transformCellRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformRowRange(_start, _end, _formulaAddress) {
    throw Error("Not implemented");
  }
  transformColumnRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    const absoluteDependencySheet = absoluteSheetReference(dependencyAddress, formulaAddress);
    if (this.columnsSpan.sheet !== formulaAddress.sheet && this.columnsSpan.sheet !== absoluteDependencySheet) {
      return false;
    }
    if (this.columnsSpan.sheet !== formulaAddress.sheet && this.columnsSpan.sheet === absoluteDependencySheet) {
      const absoluteDependencyAddress = dependencyAddress.toSimpleColumnAddress(formulaAddress);
      if (absoluteDependencyAddress.col < this.columnsSpan.columnStart) {
        return false;
      } else if (absoluteDependencyAddress.col > this.columnsSpan.columnEnd) {
        return dependencyAddress.shiftedByColumns(-this.columnsSpan.numberOfColumns);
      }
    }
    if (this.columnsSpan.sheet === formulaAddress.sheet && this.columnsSpan.sheet !== absoluteDependencySheet) {
      if (dependencyAddress.isColumnAbsolute()) {
        return false;
      } else {
        if (formulaAddress.col < this.columnsSpan.columnStart) {
          return false;
        } else if (formulaAddress.col > this.columnsSpan.columnEnd) {
          return dependencyAddress.shiftedByColumns(this.columnsSpan.numberOfColumns);
        }
      }
    }
    if (this.columnsSpan.sheet === formulaAddress.sheet && this.columnsSpan.sheet === absoluteDependencySheet) {
      if (dependencyAddress.isColumnAbsolute()) {
        if (dependencyAddress.col < this.columnsSpan.columnStart) {
          return false;
        } else if (dependencyAddress.col > this.columnsSpan.columnEnd) {
          return dependencyAddress.shiftedByColumns(-this.columnsSpan.numberOfColumns);
        }
      } else {
        const absoluteDependencyAddress = dependencyAddress.toSimpleColumnAddress(formulaAddress);
        if (absoluteDependencyAddress.col < this.columnsSpan.columnStart) {
          if (formulaAddress.col < this.columnsSpan.columnStart) {
            return false;
          } else if (formulaAddress.col > this.columnsSpan.columnEnd) {
            return dependencyAddress.shiftedByColumns(this.columnsSpan.numberOfColumns);
          }
        } else if (absoluteDependencyAddress.col > this.columnsSpan.columnEnd) {
          if (formulaAddress.col < this.columnsSpan.columnStart) {
            return dependencyAddress.shiftedByColumns(-this.columnsSpan.numberOfColumns);
          } else if (formulaAddress.col > this.columnsSpan.columnEnd) {
            return false;
          }
        }
      }
    }
    return ErrorType.REF;
  }
  fixNodeAddress(address) {
    if (this.columnsSpan.sheet === address.sheet && this.columnsSpan.columnStart <= address.col) {
      return Object.assign(Object.assign({}, address), {
        col: address.col - this.columnsSpan.numberOfColumns
      });
    } else {
      return address;
    }
  }
  transformRange(start, end, formulaAddress) {
    const startSheet = absoluteSheetReference(start, formulaAddress);
    let actualStart = start;
    let actualEnd = end;
    if (this.columnsSpan.sheet === startSheet) {
      const startSCA = start.toSimpleColumnAddress(formulaAddress);
      const endSCA = end.toSimpleColumnAddress(formulaAddress);
      if (this.columnsSpan.columnStart <= startSCA.col && this.columnsSpan.columnEnd >= endSCA.col) {
        return ErrorType.REF;
      }
      if (startSCA.col >= this.columnsSpan.columnStart && startSCA.col <= this.columnsSpan.columnEnd) {
        actualStart = start.shiftedByColumns(this.columnsSpan.columnEnd - startSCA.col + 1);
      }
      if (endSCA.col >= this.columnsSpan.columnStart && endSCA.col <= this.columnsSpan.columnEnd) {
        actualEnd = end.shiftedByColumns(-(endSCA.col - this.columnsSpan.columnStart + 1));
      }
    }
    const newStart = this.transformCellAddress(actualStart, formulaAddress);
    const newEnd = this.transformCellAddress(actualEnd, formulaAddress);
    if (newStart === false && newEnd === false) {
      return [actualStart, actualEnd];
    } else if (newStart === ErrorType.REF || newEnd === ErrorType.REF) {
      throw Error("Cannot happen");
    } else {
      return [newStart || actualStart, newEnd || actualEnd];
    }
  }
}
class RemoveRowsTransformer extends Transformer {
  constructor(rowsSpan) {
    super();
    this.rowsSpan = rowsSpan;
  }
  get sheet() {
    return this.rowsSpan.sheet;
  }
  isIrreversible() {
    return true;
  }
  transformColumnRangeAst(ast, _formulaAddress) {
    return ast;
  }
  transformCellAddress(dependencyAddress, formulaAddress) {
    const absoluteDependencySheet = absoluteSheetReference(dependencyAddress, formulaAddress);
    if (this.rowsSpan.sheet !== formulaAddress.sheet && this.rowsSpan.sheet !== absoluteDependencySheet) {
      return false;
    }
    if (this.rowsSpan.sheet !== formulaAddress.sheet && this.rowsSpan.sheet === absoluteDependencySheet) {
      const absoluteDependencyAddress = dependencyAddress.toSimpleRowAddress(formulaAddress);
      if (absoluteDependencyAddress.row < this.rowsSpan.rowStart) {
        return false;
      } else if (absoluteDependencyAddress.row > this.rowsSpan.rowEnd) {
        return dependencyAddress.shiftedByRows(-this.rowsSpan.numberOfRows);
      }
    }
    if (this.rowsSpan.sheet === formulaAddress.sheet && this.rowsSpan.sheet !== absoluteDependencySheet) {
      if (dependencyAddress.isRowAbsolute()) {
        return false;
      } else {
        if (formulaAddress.row < this.rowsSpan.rowStart) {
          return false;
        } else if (formulaAddress.row > this.rowsSpan.rowEnd) {
          return dependencyAddress.shiftedByRows(this.rowsSpan.numberOfRows);
        }
      }
    }
    if (this.rowsSpan.sheet === formulaAddress.sheet && this.rowsSpan.sheet === absoluteDependencySheet) {
      if (dependencyAddress.isRowAbsolute()) {
        if (dependencyAddress.row < this.rowsSpan.rowStart) {
          return false;
        } else if (dependencyAddress.row > this.rowsSpan.rowEnd) {
          return dependencyAddress.shiftedByRows(-this.rowsSpan.numberOfRows);
        }
      } else {
        const absoluteDependencyAddress = dependencyAddress.toSimpleRowAddress(formulaAddress);
        if (absoluteDependencyAddress.row < this.rowsSpan.rowStart) {
          if (formulaAddress.row < this.rowsSpan.rowStart) {
            return false;
          } else if (formulaAddress.row > this.rowsSpan.rowEnd) {
            return dependencyAddress.shiftedByRows(this.rowsSpan.numberOfRows);
          }
        } else if (absoluteDependencyAddress.row > this.rowsSpan.rowEnd) {
          if (formulaAddress.row < this.rowsSpan.rowStart) {
            return dependencyAddress.shiftedByRows(-this.rowsSpan.numberOfRows);
          } else if (formulaAddress.row > this.rowsSpan.rowEnd) {
            return false;
          }
        }
      }
    }
    return ErrorType.REF;
  }
  transformCellRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformRowRange(start, end, formulaAddress) {
    return this.transformRange(start, end, formulaAddress);
  }
  transformColumnRange(_start, _end, _formulaAddress) {
    throw Error("Not implemented");
  }
  fixNodeAddress(address) {
    if (this.rowsSpan.sheet === address.sheet && this.rowsSpan.rowStart <= address.row) {
      return Object.assign(Object.assign({}, address), {
        row: address.row - this.rowsSpan.numberOfRows
      });
    } else {
      return address;
    }
  }
  transformRange(start, end, formulaAddress) {
    const startSheet = absoluteSheetReference(start, formulaAddress);
    let actualStart = start;
    let actualEnd = end;
    if (this.rowsSpan.sheet === startSheet) {
      const startSCA = start.toSimpleRowAddress(formulaAddress);
      const endSCA = end.toSimpleRowAddress(formulaAddress);
      if (this.rowsSpan.rowStart <= startSCA.row && this.rowsSpan.rowEnd >= endSCA.row) {
        return ErrorType.REF;
      }
      if (startSCA.row >= this.rowsSpan.rowStart && startSCA.row <= this.rowsSpan.rowEnd) {
        actualStart = start.shiftedByRows(this.rowsSpan.rowEnd - startSCA.row + 1);
      }
      if (endSCA.row >= this.rowsSpan.rowStart && endSCA.row <= this.rowsSpan.rowEnd) {
        actualEnd = end.shiftedByRows(-(endSCA.row - this.rowsSpan.rowStart + 1));
      }
    }
    const newStart = this.transformCellAddress(actualStart, formulaAddress);
    const newEnd = this.transformCellAddress(actualEnd, formulaAddress);
    if (newStart === false && newEnd === false) {
      return [actualStart, actualEnd];
    } else if (newStart === ErrorType.REF || newEnd === ErrorType.REF) {
      return ErrorType.REF;
    } else {
      return [newStart || actualStart, newEnd || actualEnd];
    }
  }
}
class RenameSheetTransformer extends Transformer {
  constructor(sheetIdToKeep, sheetBeingMerged) {
    super();
    this.sheetIdToKeep = sheetIdToKeep;
    this.sheetBeingMerged = sheetBeingMerged;
  }
  /**
   * Returns id of sheet that survives merge operation.
   *
   * @returns {number} sheet identifier.
   */
  get sheet() {
    return this.sheetIdToKeep;
  }
  /**
   * Sheet merge cannot be undone because original sheet id is lost.
   *
   * @returns {boolean} always true to indicate transformation irreversibility.
   */
  isIrreversible() {
    return true;
  }
  /**
   * Updates cell address sheet when it points to merged sheet.
   *
   * @param {T} dependencyAddress - dependency address needing sheet update.
   * @param {SimpleCellAddress} _formulaAddress - location of formula (unused but required by base class).
   * @returns {T | false} updated address or false when nothing changes.
   */
  transformCellAddress(dependencyAddress, _formulaAddress) {
    return this.updateSheetInAddress(dependencyAddress);
  }
  /**
   * Updates sheet for both ends of cell range.
   *
   * @param {CellAddress} start - start address of range.
   * @param {CellAddress} end - end address of range.
   * @param {SimpleCellAddress} _formulaAddress - formula location (unused).
   * @returns {[CellAddress, CellAddress] | false} updated range tuple or false when unchanged.
   */
  transformCellRange(start, end, _formulaAddress) {
    return this.transformRange(start, end);
  }
  /**
   * Updates sheet for both ends of column range.
   *
   * @param {ColumnAddress} start - beginning column of range.
   * @param {ColumnAddress} end - ending column of range.
   * @param {SimpleCellAddress} _formulaAddress - formula location (unused).
   * @returns {[ColumnAddress, ColumnAddress] | false} updated column range or false.
   */
  transformColumnRange(start, end, _formulaAddress) {
    return this.transformRange(start, end);
  }
  /**
   * Updates sheet for both ends of row range.
   *
   * @param {RowAddress} start - beginning row address.
   * @param {RowAddress} end - ending row address.
   * @param {SimpleCellAddress} _formulaAddress - formula location (unused).
   * @returns {[RowAddress, RowAddress] | false} updated row range or false.
   */
  transformRowRange(start, end, _formulaAddress) {
    return this.transformRange(start, end);
  }
  /**
   * Node addresses are already absolute, so no change is needed.
   *
   * @param {SimpleCellAddress} address - node address to inspect.
   * @returns {SimpleCellAddress} original address unchanged.
   */
  fixNodeAddress(address) {
    return address;
  }
  /**
   * Updates sheet identifier for both range ends if needed.
   *
   * @param {T} start - range start address.
   * @param {T} end - range end address.
   * @returns {[T, T] | false} tuple with updated addresses or false when no updates happen.
   */
  transformRange(start, end) {
    const newStart = this.updateSheetInAddress(start);
    const newEnd = this.updateSheetInAddress(end);
    if (newStart || newEnd) {
      return [newStart || start, newEnd || end];
    }
    return false;
  }
  /**
   * Replaces sheet id in address when it points to merged sheet.
   *
   * @param {T} address - address to update.
   * @returns {T | false} address with new sheet id or false when no change occurs.
   */
  updateSheetInAddress(address) {
    if (address.sheet === this.sheetBeingMerged) {
      return address.withSheet(this.sheetIdToKeep);
    }
    return false;
  }
}
class RemoveRowsCommand {
  constructor(sheet, indexes) {
    this.sheet = sheet;
    this.indexes = indexes;
  }
  normalizedIndexes() {
    return normalizeRemovedIndexes(this.indexes);
  }
  rowsSpans() {
    return this.normalizedIndexes().map((normalizedIndex) => RowsSpan.fromNumberOfRows(this.sheet, normalizedIndex[0], normalizedIndex[1]));
  }
}
class AddRowsCommand {
  constructor(sheet, indexes) {
    this.sheet = sheet;
    this.indexes = indexes;
  }
  normalizedIndexes() {
    return normalizeAddedIndexes(this.indexes);
  }
  rowsSpans() {
    return this.normalizedIndexes().map((normalizedIndex) => RowsSpan.fromNumberOfRows(this.sheet, normalizedIndex[0], normalizedIndex[1]));
  }
}
class AddColumnsCommand {
  constructor(sheet, indexes) {
    this.sheet = sheet;
    this.indexes = indexes;
  }
  normalizedIndexes() {
    return normalizeAddedIndexes(this.indexes);
  }
  columnsSpans() {
    return this.normalizedIndexes().map((normalizedIndex) => ColumnsSpan.fromNumberOfColumns(this.sheet, normalizedIndex[0], normalizedIndex[1]));
  }
}
class RemoveColumnsCommand {
  constructor(sheet, indexes) {
    this.sheet = sheet;
    this.indexes = indexes;
  }
  normalizedIndexes() {
    return normalizeRemovedIndexes(this.indexes);
  }
  columnsSpans() {
    return this.normalizedIndexes().map((normalizedIndex) => ColumnsSpan.fromNumberOfColumns(this.sheet, normalizedIndex[0], normalizedIndex[1]));
  }
}
class Operations {
  constructor(config, dependencyGraph, columnSearch, cellContentParser, parser, stats, lazilyTransformingAstService, namedExpressions, arraySizePredictor) {
    this.dependencyGraph = dependencyGraph;
    this.columnSearch = columnSearch;
    this.cellContentParser = cellContentParser;
    this.parser = parser;
    this.stats = stats;
    this.lazilyTransformingAstService = lazilyTransformingAstService;
    this.namedExpressions = namedExpressions;
    this.arraySizePredictor = arraySizePredictor;
    this.changes = ContentChanges.empty();
    this.allocateNamedExpressionAddressSpace();
    this.maxColumns = config.maxColumns;
    this.maxRows = config.maxRows;
  }
  get sheetMapping() {
    return this.dependencyGraph.sheetMapping;
  }
  get addressMapping() {
    return this.dependencyGraph.addressMapping;
  }
  removeRows(cmd) {
    const rowsRemovals = [];
    for (const rowsToRemove of cmd.rowsSpans()) {
      const rowsRemoval = this.doRemoveRows(rowsToRemove);
      if (rowsRemoval) {
        rowsRemovals.push(rowsRemoval);
      }
    }
    return rowsRemovals;
  }
  addRows(cmd) {
    for (const addedRows of cmd.rowsSpans()) {
      this.doAddRows(addedRows);
    }
  }
  addColumns(cmd) {
    for (const addedColumns of cmd.columnsSpans()) {
      this.doAddColumns(addedColumns);
    }
  }
  removeColumns(cmd) {
    const columnsRemovals = [];
    for (const columnsToRemove of cmd.columnsSpans()) {
      const columnsRemoval = this.doRemoveColumns(columnsToRemove);
      if (columnsRemoval) {
        columnsRemovals.push(columnsRemoval);
      }
    }
    return columnsRemovals;
  }
  /**
   * Clears the sheet content.
   */
  clearSheet(sheetId) {
    this.dependencyGraph.clearSheet(sheetId);
    this.columnSearch.removeSheet(sheetId);
  }
  /**
   * Adds a new sheet to the workbook.
   */
  addSheet(name) {
    const sheetId = this.sheetMapping.addSheet(name);
    this.dependencyGraph.addSheet(sheetId);
    return {
      sheetName: this.sheetMapping.getSheetNameOrThrowError(sheetId),
      sheetId
    };
  }
  /**
   * Adds a sheet with a specific ID for redo operations.
   */
  addSheetWithId(sheetId, name) {
    this.sheetMapping.addSheetWithId(sheetId, name);
    this.dependencyGraph.addSheet(sheetId);
  }
  /**
   * Adds a placeholder sheet with a specific ID for undo operations.
   * Used to restore previously merged placeholder sheets.
   *
   * Note: Unlike `addSheetWithId`, this does NOT call `dependencyGraph.addSheet()`
   * because placeholders don't need dirty marking or strategy changes - they only
   * need to exist in the mappings so formulas can reference them again.
   */
  addPlaceholderSheetWithId(sheetId, name) {
    this.sheetMapping.addPlaceholderWithId(sheetId, name);
    this.addressMapping.addSheetStrategyPlaceholderIfNotExists(sheetId);
  }
  /**
   * Removes a sheet from the workbook.
   */
  removeSheet(sheetId) {
    this.dependencyGraph.removeSheet(sheetId);
    this.columnSearch.removeSheet(sheetId);
    const scopedNamedExpressions = this.namedExpressions.getAllNamedExpressionsForScope(sheetId).map((namedExpression) => this.removeNamedExpression(namedExpression.normalizeExpressionName(), sheetId));
    return scopedNamedExpressions;
  }
  /**
   * Removes a sheet from the workbook by name.
   */
  removeSheetByName(sheetName) {
    const sheetId = this.sheetMapping.getSheetIdOrThrowError(sheetName);
    return this.removeSheet(sheetId);
  }
  /**
   * Renames a sheet in the workbook.
   */
  renameSheet(sheetId, newName) {
    const {
      previousDisplayName,
      mergedWithPlaceholderSheet
    } = this.sheetMapping.renameSheet(sheetId, newName);
    let version2;
    if (mergedWithPlaceholderSheet !== void 0) {
      this.dependencyGraph.mergeSheets(sheetId, mergedWithPlaceholderSheet);
      this.stats.measure(StatType.TRANSFORM_ASTS, () => {
        const transformation = new RenameSheetTransformer(sheetId, mergedWithPlaceholderSheet);
        transformation.performEagerTransformations(this.dependencyGraph, this.parser);
        version2 = this.lazilyTransformingAstService.addTransformation(transformation);
      });
    }
    return {
      previousDisplayName,
      version: version2,
      mergedPlaceholderSheetId: mergedWithPlaceholderSheet
    };
  }
  moveRows(sheet, startRow, numberOfRows, targetRow) {
    const rowsToAdd = RowsSpan.fromNumberOfRows(sheet, targetRow, numberOfRows);
    this.lazilyTransformingAstService.beginCombinedMode(sheet);
    this.doAddRows(rowsToAdd);
    if (targetRow < startRow) {
      startRow += numberOfRows;
    }
    const startAddress = simpleCellAddress(sheet, 0, startRow);
    const targetAddress = simpleCellAddress(sheet, 0, targetRow);
    this.moveCells(startAddress, Number.POSITIVE_INFINITY, numberOfRows, targetAddress);
    const rowsToRemove = RowsSpan.fromNumberOfRows(sheet, startRow, numberOfRows);
    this.doRemoveRows(rowsToRemove);
    return this.lazilyTransformingAstService.commitCombinedMode();
  }
  moveColumns(sheet, startColumn, numberOfColumns, targetColumn) {
    const columnsToAdd = ColumnsSpan.fromNumberOfColumns(sheet, targetColumn, numberOfColumns);
    this.lazilyTransformingAstService.beginCombinedMode(sheet);
    this.doAddColumns(columnsToAdd);
    if (targetColumn < startColumn) {
      startColumn += numberOfColumns;
    }
    const startAddress = simpleCellAddress(sheet, startColumn, 0);
    const targetAddress = simpleCellAddress(sheet, targetColumn, 0);
    this.moveCells(startAddress, numberOfColumns, Number.POSITIVE_INFINITY, targetAddress);
    const columnsToRemove = ColumnsSpan.fromNumberOfColumns(sheet, startColumn, numberOfColumns);
    this.doRemoveColumns(columnsToRemove);
    return this.lazilyTransformingAstService.commitCombinedMode();
  }
  moveCells(sourceLeftCorner, width, height, destinationLeftCorner) {
    this.ensureItIsPossibleToMoveCells(sourceLeftCorner, width, height, destinationLeftCorner);
    const sourceRange = AbsoluteCellRange.spanFrom(sourceLeftCorner, width, height);
    const targetRange = AbsoluteCellRange.spanFrom(destinationLeftCorner, width, height);
    const toRight = destinationLeftCorner.col - sourceLeftCorner.col;
    const toBottom = destinationLeftCorner.row - sourceLeftCorner.row;
    const toSheet = destinationLeftCorner.sheet;
    const currentDataAtTarget = this.getRangeClipboardCells(targetRange);
    const valuesToRemove = this.dependencyGraph.rawValuesFromRange(targetRange);
    this.columnSearch.removeValues(valuesToRemove);
    const valuesToMove = this.dependencyGraph.rawValuesFromRange(sourceRange);
    this.columnSearch.moveValues(valuesToMove, toRight, toBottom, toSheet);
    let version2 = 0;
    this.stats.measure(StatType.TRANSFORM_ASTS, () => {
      const transformation = new MoveCellsTransformer(sourceRange, toRight, toBottom, toSheet);
      transformation.performEagerTransformations(this.dependencyGraph, this.parser);
      version2 = this.lazilyTransformingAstService.addTransformation(transformation);
    });
    this.dependencyGraph.moveCells(sourceRange, toRight, toBottom, toSheet);
    const addedGlobalNamedExpressions = this.updateNamedExpressionsForMovedCells(sourceLeftCorner, width, height, destinationLeftCorner);
    return {
      version: version2,
      overwrittenCellsData: currentDataAtTarget,
      addedGlobalNamedExpressions
    };
  }
  setRowOrder(sheetId, rowMapping) {
    const buffer = [];
    let oldContent = [];
    for (const [source, target] of rowMapping) {
      if (source !== target) {
        const rowRange = AbsoluteCellRange.spanFrom({
          sheet: sheetId,
          col: 0,
          row: source
        }, Infinity, 1);
        const row = this.getRangeClipboardCells(rowRange);
        oldContent = oldContent.concat(row);
        buffer.push(row.map(([{
          sheet,
          col
        }, cell]) => [{
          sheet,
          col,
          row: target
        }, cell]));
      }
    }
    buffer.forEach((row) => this.restoreClipboardCells(sheetId, row.values()));
    return oldContent;
  }
  setColumnOrder(sheetId, columnMapping) {
    const buffer = [];
    let oldContent = [];
    for (const [source, target] of columnMapping) {
      if (source !== target) {
        const rowRange = AbsoluteCellRange.spanFrom({
          sheet: sheetId,
          col: source,
          row: 0
        }, 1, Infinity);
        const column = this.getRangeClipboardCells(rowRange);
        oldContent = oldContent.concat(column);
        buffer.push(column.map(([{
          sheet,
          col: _col,
          row
        }, cell]) => [{
          sheet,
          col: target,
          row
        }, cell]));
      }
    }
    buffer.forEach((column) => this.restoreClipboardCells(sheetId, column.values()));
    return oldContent;
  }
  addNamedExpression(expressionName, expression, sheetId, options) {
    const namedExpression = this.namedExpressions.addNamedExpression(expressionName, sheetId, options);
    this.storeNamedExpressionInCell(namedExpression.address, expression);
    this.adjustNamedExpressionEdges(namedExpression, expressionName, sheetId);
  }
  restoreNamedExpression(namedExpression, content, sheetId) {
    const expressionName = namedExpression.displayName;
    this.restoreCell(namedExpression.address, content);
    const restoredNamedExpression = this.namedExpressions.restoreNamedExpression(namedExpression, sheetId);
    this.adjustNamedExpressionEdges(restoredNamedExpression, expressionName, sheetId);
  }
  changeNamedExpressionExpression(expressionName, newExpression, sheetId, options) {
    const namedExpression = this.namedExpressions.namedExpressionForScope(expressionName, sheetId);
    if (!namedExpression) {
      throw new NamedExpressionDoesNotExistError(expressionName);
    }
    const oldNamedExpression = namedExpression.copy();
    namedExpression.options = options;
    const content = this.getClipboardCell(namedExpression.address);
    this.storeNamedExpressionInCell(namedExpression.address, newExpression);
    return [oldNamedExpression, content];
  }
  removeNamedExpression(expressionName, sheetId) {
    const namedExpression = this.namedExpressions.namedExpressionForScope(expressionName, sheetId);
    if (!namedExpression) {
      throw new NamedExpressionDoesNotExistError(expressionName);
    }
    this.namedExpressions.remove(namedExpression.displayName, sheetId);
    const content = this.getClipboardCell(namedExpression.address);
    if (sheetId !== void 0) {
      const globalNamedExpression = this.namedExpressions.workbookNamedExpressionOrPlaceholder(expressionName);
      this.dependencyGraph.exchangeNode(namedExpression.address, globalNamedExpression.address);
    } else {
      this.dependencyGraph.setCellEmpty(namedExpression.address);
    }
    return [namedExpression, content];
  }
  ensureItIsPossibleToMoveCells(sourceLeftCorner, width, height, destinationLeftCorner) {
    if (isColOrRowInvalid(sourceLeftCorner) || !(isPositiveInteger$1(width) && isPositiveInteger$1(height) || isRowOrColumnRange(sourceLeftCorner, width, height)) || isColOrRowInvalid(destinationLeftCorner) || !this.sheetMapping.hasSheetWithId(sourceLeftCorner.sheet) || !this.sheetMapping.hasSheetWithId(destinationLeftCorner.sheet)) {
      throw new InvalidArgumentsError("a valid range of cells to move.");
    }
    const sourceRange = AbsoluteCellRange.spanFrom(sourceLeftCorner, width, height);
    const targetRange = AbsoluteCellRange.spanFrom(destinationLeftCorner, width, height);
    if (targetRange.exceedsSheetSizeLimits(this.maxColumns, this.maxRows)) {
      throw new SheetSizeLimitExceededError();
    }
    if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(sourceRange)) {
      throw new SourceLocationHasArrayError();
    }
    if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(targetRange)) {
      throw new TargetLocationHasArrayError();
    }
  }
  restoreClipboardCells(sourceSheetId, cells) {
    const addedNamedExpressions = [];
    for (const [address, clipboardCell] of cells) {
      this.restoreCell(address, clipboardCell);
      if (clipboardCell.type === ClipboardCellType.FORMULA) {
        const {
          dependencies
        } = this.parser.fetchCachedResult(clipboardCell.hash);
        addedNamedExpressions.push(...this.updateNamedExpressionsForTargetAddress(sourceSheetId, address, dependencies));
      }
    }
    return addedNamedExpressions;
  }
  /**
   * Restores a single cell.
   */
  restoreCell(address, clipboardCell) {
    switch (clipboardCell.type) {
      case ClipboardCellType.VALUE: {
        this.setValueToCell(clipboardCell, address);
        break;
      }
      case ClipboardCellType.FORMULA: {
        this.setFormulaToCellFromCache(clipboardCell.hash, address);
        break;
      }
      case ClipboardCellType.EMPTY: {
        this.setCellEmpty(address);
        break;
      }
      case ClipboardCellType.PARSING_ERROR: {
        this.setParsingErrorToCell(clipboardCell.rawInput, clipboardCell.errors, address);
        break;
      }
    }
  }
  getOldContent(address) {
    const vertex = this.dependencyGraph.getCell(address);
    if (vertex === void 0 || vertex instanceof EmptyCellVertex) {
      return [address, {
        type: ClipboardCellType.EMPTY
      }];
    } else if (vertex instanceof ValueCellVertex) {
      return [address, Object.assign({
        type: ClipboardCellType.VALUE
      }, vertex.getValues())];
    } else if (vertex instanceof FormulaVertex) {
      return [vertex.getAddress(this.lazilyTransformingAstService), {
        type: ClipboardCellType.FORMULA,
        hash: this.parser.computeHashFromAst(vertex.getFormula(this.lazilyTransformingAstService))
      }];
    } else if (vertex instanceof ParsingErrorVertex) {
      return [address, {
        type: ClipboardCellType.PARSING_ERROR,
        rawInput: vertex.rawInput,
        errors: vertex.errors
      }];
    }
    throw Error("Trying to copy unsupported type");
  }
  getClipboardCell(address) {
    const vertex = this.dependencyGraph.getCell(address);
    if (vertex === void 0 || vertex instanceof EmptyCellVertex) {
      return {
        type: ClipboardCellType.EMPTY
      };
    } else if (vertex instanceof ValueCellVertex) {
      return Object.assign({
        type: ClipboardCellType.VALUE
      }, vertex.getValues());
    } else if (vertex instanceof ArrayFormulaVertex) {
      const val = vertex.getArrayCellValue(address);
      if (val === EmptyValue) {
        return {
          type: ClipboardCellType.EMPTY
        };
      }
      return {
        type: ClipboardCellType.VALUE,
        parsedValue: val,
        rawValue: vertex.getArrayCellRawValue(address)
      };
    } else if (vertex instanceof ScalarFormulaVertex) {
      return {
        type: ClipboardCellType.FORMULA,
        hash: this.parser.computeHashFromAst(vertex.getFormula(this.lazilyTransformingAstService))
      };
    } else if (vertex instanceof ParsingErrorVertex) {
      return {
        type: ClipboardCellType.PARSING_ERROR,
        rawInput: vertex.rawInput,
        errors: vertex.errors
      };
    }
    throw Error("Trying to copy unsupported type");
  }
  getSheetClipboardCells(sheet) {
    const sheetHeight = this.dependencyGraph.getSheetHeight(sheet);
    const sheetWidth = this.dependencyGraph.getSheetWidth(sheet);
    const arr = new Array(sheetHeight);
    for (let i = 0; i < sheetHeight; i++) {
      arr[i] = new Array(sheetWidth);
      for (let j = 0; j < sheetWidth; j++) {
        const address = simpleCellAddress(sheet, j, i);
        arr[i][j] = this.getClipboardCell(address);
      }
    }
    return arr;
  }
  getRangeClipboardCells(range) {
    const result = [];
    for (const address of range.addresses(this.dependencyGraph)) {
      result.push([address, this.getClipboardCell(address)]);
    }
    return result;
  }
  setCellContent(address, newCellContent) {
    const parsedCellContent = this.cellContentParser.parse(newCellContent);
    const oldContent = this.getOldContent(address);
    if (parsedCellContent instanceof CellContent.Formula) {
      const parserResult = this.parser.parse(parsedCellContent.formula, address);
      const {
        ast,
        errors
      } = parserResult;
      if (errors.length > 0) {
        this.setParsingErrorToCell(parsedCellContent.formula, errors, address);
      } else {
        try {
          const size = this.arraySizePredictor.checkArraySize(ast, address);
          if (size.width <= 0 || size.height <= 0) {
            throw Error("Incorrect array size");
          }
          this.setFormulaToCell(address, size, parserResult);
        } catch (error2) {
          if (!error2.message) {
            throw error2;
          }
          const parsingError2 = {
            type: ParsingErrorType.InvalidRangeSize,
            message: "Invalid range size."
          };
          this.setParsingErrorToCell(parsedCellContent.formula, [parsingError2], address);
        }
      }
    } else if (parsedCellContent instanceof CellContent.Empty) {
      this.setCellEmpty(address);
    } else {
      this.setValueToCell({
        parsedValue: parsedCellContent.value,
        rawValue: newCellContent
      }, address);
    }
    return oldContent;
  }
  setSheetContent(sheetId, newSheetContent) {
    this.clearSheet(sheetId);
    for (let i = 0; i < newSheetContent.length; i++) {
      for (let j = 0; j < newSheetContent[i].length; j++) {
        const address = simpleCellAddress(sheetId, j, i);
        this.setCellContent(address, newSheetContent[i][j]);
      }
    }
  }
  /**
   * Sets cell content to an instance of parsing error.
   * Creates a ParsingErrorVertex and updates the dependency graph and column search index.
   */
  setParsingErrorToCell(rawInput, errors, address) {
    this.removeCellValueFromColumnSearch(address);
    const vertex = new ParsingErrorVertex(errors, rawInput);
    const arrayChanges = this.dependencyGraph.setParsingErrorToCell(address, vertex);
    this.columnSearch.applyChanges(arrayChanges.getChanges());
    this.changes.addAll(arrayChanges);
    this.changes.addChange(vertex.getCellValue(), address);
  }
  /**
   * Sets cell content to a formula.
   * Creates a ScalarFormulaVertex and updates the dependency graph and column search index.
   */
  setFormulaToCell(address, size, {
    ast,
    hasVolatileFunction,
    hasStructuralChangeFunction,
    dependencies
  }) {
    this.removeCellValueFromColumnSearch(address);
    const arrayChanges = this.dependencyGraph.setFormulaToCell(address, ast, absolutizeDependencies(dependencies, address), size, hasVolatileFunction, hasStructuralChangeFunction);
    this.columnSearch.applyChanges(arrayChanges.getChanges());
    this.changes.addAll(arrayChanges);
  }
  /**
   * Sets cell content to a value.
   * Creates a ValueCellVertex and updates the dependency graph and column search index.
   */
  setValueToCell(value, address) {
    this.changeCellValueInColumnSearch(address, value.parsedValue);
    const arrayChanges = this.dependencyGraph.setValueToCell(address, value);
    this.columnSearch.applyChanges(arrayChanges.getChanges().filter((change) => !equalSimpleCellAddress(change.address, address)));
    this.changes.addAll(arrayChanges);
    this.changes.addChange(value.parsedValue, address);
  }
  /**
   * Sets cell content to an empty value.
   * Creates an EmptyCellVertex and updates the dependency graph and column search index.
   */
  setCellEmpty(address) {
    if (this.dependencyGraph.isArrayInternalCell(address)) {
      return;
    }
    this.removeCellValueFromColumnSearch(address);
    const arrayChanges = this.dependencyGraph.setCellEmpty(address);
    this.columnSearch.applyChanges(arrayChanges.getChanges());
    this.changes.addAll(arrayChanges);
    this.changes.addChange(EmptyValue, address);
  }
  setFormulaToCellFromCache(formulaHash, address) {
    const {
      ast,
      hasVolatileFunction,
      hasStructuralChangeFunction,
      dependencies
    } = this.parser.fetchCachedResult(formulaHash);
    const absoluteDependencies = absolutizeDependencies(dependencies, address);
    const [cleanedAst] = new CleanOutOfScopeDependenciesTransformer(address.sheet).transformSingleAst(ast, address);
    this.parser.rememberNewAst(cleanedAst);
    const cleanedDependencies = filterDependenciesOutOfScope(absoluteDependencies);
    const size = this.arraySizePredictor.checkArraySize(ast, address);
    this.dependencyGraph.setFormulaToCell(address, cleanedAst, cleanedDependencies, size, hasVolatileFunction, hasStructuralChangeFunction);
  }
  /**
   * Returns true if row number is outside of given sheet.
   * @param {number} row - row number
   * @param {number} sheet - sheet ID number
   */
  rowEffectivelyNotInSheet(row, sheet) {
    const height = this.dependencyGraph.addressMapping.getSheetHeight(sheet);
    return row >= height;
  }
  getAndClearContentChanges() {
    const changes = this.changes;
    this.changes = ContentChanges.empty();
    return changes;
  }
  /**
   * Forces all formula vertices and column index entries to apply pending lazy
   * transformations, bringing them up to the current LazilyTransformingAstService version.
   * Called before undo of move operations and before compaction.
   */
  forceApplyPostponedTransformations() {
    this.dependencyGraph.forceApplyPostponedTransformations();
    this.columnSearch.forceApplyPostponedTransformations();
  }
  /**
   * Removes multiple rows from sheet. </br>
   * Does nothing if rows are outside of effective sheet size.
   * @param {RowsSpan} rowsToRemove - rows to remove
   */
  doRemoveRows(rowsToRemove) {
    if (this.rowEffectivelyNotInSheet(rowsToRemove.rowStart, rowsToRemove.sheet)) {
      return;
    }
    const removedCells = [];
    for (const [address] of this.dependencyGraph.entriesFromRowsSpan(rowsToRemove)) {
      removedCells.push({
        address,
        cellType: this.getClipboardCell(address)
      });
    }
    const {
      affectedArrays,
      contentChanges
    } = this.dependencyGraph.removeRows(rowsToRemove);
    this.columnSearch.applyChanges(contentChanges.getChanges());
    let version2 = 0;
    this.stats.measure(StatType.TRANSFORM_ASTS, () => {
      const transformation = new RemoveRowsTransformer(rowsToRemove);
      transformation.performEagerTransformations(this.dependencyGraph, this.parser);
      version2 = this.lazilyTransformingAstService.addTransformation(transformation);
    });
    this.rewriteAffectedArrays(affectedArrays);
    return {
      version: version2,
      removedCells,
      rowFrom: rowsToRemove.rowStart,
      rowCount: rowsToRemove.numberOfRows
    };
  }
  /**
   * Removes multiple columns from sheet. </br>
   * Does nothing if columns are outside of effective sheet size.
   * @param {ColumnsSpan} columnsToRemove - columns to remove
   */
  doRemoveColumns(columnsToRemove) {
    if (this.columnEffectivelyNotInSheet(columnsToRemove.columnStart, columnsToRemove.sheet)) {
      return;
    }
    const removedCells = [];
    for (const [address] of this.dependencyGraph.entriesFromColumnsSpan(columnsToRemove)) {
      removedCells.push({
        address,
        cellType: this.getClipboardCell(address)
      });
    }
    const {
      affectedArrays,
      contentChanges
    } = this.dependencyGraph.removeColumns(columnsToRemove);
    this.columnSearch.applyChanges(contentChanges.getChanges());
    this.columnSearch.removeColumns(columnsToRemove);
    let version2 = 0;
    this.stats.measure(StatType.TRANSFORM_ASTS, () => {
      const transformation = new RemoveColumnsTransformer(columnsToRemove);
      transformation.performEagerTransformations(this.dependencyGraph, this.parser);
      version2 = this.lazilyTransformingAstService.addTransformation(transformation);
    });
    this.rewriteAffectedArrays(affectedArrays);
    return {
      version: version2,
      removedCells,
      columnFrom: columnsToRemove.columnStart,
      columnCount: columnsToRemove.numberOfColumns
    };
  }
  /**
   * Add multiple rows to sheet. </br>
   * Does nothing if rows are outside of effective sheet size.
   * @param {RowsSpan} addedRows - rows to add
   */
  doAddRows(addedRows) {
    if (this.rowEffectivelyNotInSheet(addedRows.rowStart, addedRows.sheet)) {
      return;
    }
    const {
      affectedArrays
    } = this.dependencyGraph.addRows(addedRows);
    this.stats.measure(StatType.TRANSFORM_ASTS, () => {
      const transformation = new AddRowsTransformer(addedRows);
      transformation.performEagerTransformations(this.dependencyGraph, this.parser);
      this.lazilyTransformingAstService.addTransformation(transformation);
    });
    this.rewriteAffectedArrays(affectedArrays);
  }
  rewriteAffectedArrays(affectedArrays) {
    for (const arrayVertex of affectedArrays.values()) {
      if (arrayVertex.array.size.isRef) {
        continue;
      }
      const ast = arrayVertex.getFormula(this.lazilyTransformingAstService);
      const address = arrayVertex.getAddress(this.lazilyTransformingAstService);
      const hash = this.parser.computeHashFromAst(ast);
      this.setFormulaToCellFromCache(hash, address);
    }
  }
  /**
   * Add multiple columns to sheet </br>
   * Does nothing if columns are outside of effective sheet size
   * @param {ColumnsSpan} addedColumns - object containing information about columns to add
   */
  doAddColumns(addedColumns) {
    if (this.columnEffectivelyNotInSheet(addedColumns.columnStart, addedColumns.sheet)) {
      return;
    }
    const {
      affectedArrays,
      contentChanges
    } = this.dependencyGraph.addColumns(addedColumns);
    this.columnSearch.addColumns(addedColumns);
    this.columnSearch.applyChanges(contentChanges.getChanges());
    this.stats.measure(StatType.TRANSFORM_ASTS, () => {
      const transformation = new AddColumnsTransformer(addedColumns);
      transformation.performEagerTransformations(this.dependencyGraph, this.parser);
      this.lazilyTransformingAstService.addTransformation(transformation);
    });
    this.rewriteAffectedArrays(affectedArrays);
  }
  /**
   * Returns true if row number is outside of given sheet.
   * @param {number} column - row number
   * @param {number} sheet - sheet ID number
   */
  columnEffectivelyNotInSheet(column, sheet) {
    const width = this.dependencyGraph.addressMapping.getSheetWidth(sheet);
    return column >= width;
  }
  adjustNamedExpressionEdges(namedExpression, expressionName, sheetId) {
    if (sheetId === void 0) {
      return;
    }
    const {
      vertex: localVertex,
      id: maybeLocalVertexId
    } = this.dependencyGraph.fetchCellOrCreateEmpty(namedExpression.address);
    const localVertexId = maybeLocalVertexId !== null && maybeLocalVertexId !== void 0 ? maybeLocalVertexId : localVertex.idInGraph;
    const globalNamedExpression = this.namedExpressions.workbookNamedExpressionOrPlaceholder(expressionName);
    const {
      vertex: globalVertex,
      id: maybeGlobalVertexId
    } = this.dependencyGraph.fetchCellOrCreateEmpty(globalNamedExpression.address);
    const globalVertexId = maybeGlobalVertexId !== null && maybeGlobalVertexId !== void 0 ? maybeGlobalVertexId : globalVertex.idInGraph;
    for (const adjacentNode of this.dependencyGraph.graph.adjacentNodes(globalVertex)) {
      if (adjacentNode instanceof ScalarFormulaVertex && adjacentNode.getAddress(this.lazilyTransformingAstService).sheet === sheetId) {
        const ast = adjacentNode.getFormula(this.lazilyTransformingAstService);
        const formulaAddress = adjacentNode.getAddress(this.lazilyTransformingAstService);
        const {
          dependencies
        } = this.parser.fetchCachedResultForAst(ast);
        for (const dependency of absolutizeDependencies(dependencies, formulaAddress)) {
          if (dependency instanceof NamedExpressionDependency && dependency.name.toLowerCase() === namedExpression.displayName.toLowerCase()) {
            this.dependencyGraph.graph.removeEdgeIfExists(globalVertexId, adjacentNode);
            this.dependencyGraph.graph.addEdge(localVertexId, adjacentNode);
          }
        }
      }
    }
  }
  storeNamedExpressionInCell(address, expression) {
    const parsedCellContent = this.cellContentParser.parse(expression);
    if (parsedCellContent instanceof CellContent.Formula) {
      const parsingResult = this.parser.parse(parsedCellContent.formula, simpleCellAddress(-1, 0, 0));
      if (doesContainRelativeReferences(parsingResult.ast)) {
        throw new NoRelativeAddressesAllowedError();
      }
      const {
        ast,
        hasVolatileFunction,
        hasStructuralChangeFunction,
        dependencies
      } = parsingResult;
      this.dependencyGraph.setFormulaToCell(address, ast, absolutizeDependencies(dependencies, address), ArraySize.scalar(), hasVolatileFunction, hasStructuralChangeFunction);
    } else if (parsedCellContent instanceof CellContent.Empty) {
      this.setCellEmpty(address);
    } else {
      this.setValueToCell({
        parsedValue: parsedCellContent.value,
        rawValue: expression
      }, address);
    }
  }
  updateNamedExpressionsForMovedCells(sourceLeftCorner, width, height, destinationLeftCorner) {
    if (sourceLeftCorner.sheet === destinationLeftCorner.sheet) {
      return [];
    }
    const addedGlobalNamedExpressions = [];
    const targetRange = AbsoluteCellRange.spanFrom(destinationLeftCorner, width, height);
    for (const formulaAddress of targetRange.addresses(this.dependencyGraph)) {
      const vertex = this.addressMapping.getCell(formulaAddress, {
        throwIfCellNotExists: true
      });
      if (vertex instanceof ScalarFormulaVertex && formulaAddress.sheet !== sourceLeftCorner.sheet) {
        const ast = vertex.getFormula(this.lazilyTransformingAstService);
        const {
          dependencies
        } = this.parser.fetchCachedResultForAst(ast);
        addedGlobalNamedExpressions.push(...this.updateNamedExpressionsForTargetAddress(sourceLeftCorner.sheet, formulaAddress, dependencies));
      }
    }
    return addedGlobalNamedExpressions;
  }
  updateNamedExpressionsForTargetAddress(sourceSheet, targetAddress, dependencies) {
    if (sourceSheet === targetAddress.sheet) {
      return [];
    }
    const addedGlobalNamedExpressions = [];
    const vertex = this.addressMapping.getCellOrThrow(targetAddress);
    for (const namedExpressionDependency of absolutizeDependencies(dependencies, targetAddress)) {
      if (!(namedExpressionDependency instanceof NamedExpressionDependency)) {
        continue;
      }
      const expressionName = namedExpressionDependency.name;
      const sourceVertex = this.dependencyGraph.fetchNamedExpressionVertex(expressionName, sourceSheet).vertex;
      const namedExpressionInTargetScope = this.namedExpressions.isExpressionInScope(expressionName, targetAddress.sheet);
      const targetScopeExpressionVertex = namedExpressionInTargetScope ? this.dependencyGraph.fetchNamedExpressionVertex(expressionName, targetAddress.sheet).vertex : this.copyOrFetchGlobalNamedExpressionVertex(expressionName, sourceVertex, addedGlobalNamedExpressions);
      if (targetScopeExpressionVertex !== sourceVertex) {
        this.dependencyGraph.graph.removeEdgeIfExists(sourceVertex, vertex);
        this.dependencyGraph.graph.addEdge(targetScopeExpressionVertex, vertex);
      }
    }
    return addedGlobalNamedExpressions;
  }
  allocateNamedExpressionAddressSpace() {
    this.dependencyGraph.addressMapping.addSheetWithStrategy(NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS, new SparseStrategy(0, 0));
  }
  copyOrFetchGlobalNamedExpressionVertex(expressionName, sourceVertex, addedNamedExpressions) {
    let expression = this.namedExpressions.namedExpressionForScope(expressionName);
    if (expression === void 0) {
      expression = this.namedExpressions.addNamedExpression(expressionName);
      addedNamedExpressions.push(expression.normalizeExpressionName());
      if (sourceVertex instanceof ScalarFormulaVertex) {
        const parsingResult = this.parser.fetchCachedResultForAst(sourceVertex.getFormula(this.lazilyTransformingAstService));
        const {
          ast,
          hasVolatileFunction,
          hasStructuralChangeFunction,
          dependencies
        } = parsingResult;
        this.dependencyGraph.setFormulaToCell(expression.address, ast, absolutizeDependencies(dependencies, expression.address), ArraySize.scalar(), hasVolatileFunction, hasStructuralChangeFunction);
      } else if (sourceVertex instanceof EmptyCellVertex) {
        this.setCellEmpty(expression.address);
      } else if (sourceVertex instanceof ValueCellVertex) {
        this.setValueToCell(sourceVertex.getValues(), expression.address);
      }
    }
    return this.dependencyGraph.fetchCellOrCreateEmpty(expression.address).vertex;
  }
  /**
   * Removes a cell value from the columnSearch index.
   * Ignores the non-computed formula vertices.
   */
  removeCellValueFromColumnSearch(address) {
    if (this.isNotComputed(address)) {
      return;
    }
    const oldValue = this.dependencyGraph.getCellValue(address);
    this.columnSearch.remove(getRawValue(oldValue), address);
  }
  /**
   * Changes a cell value in the columnSearch index.
   * Ignores the non-computed formula vertices.
   */
  changeCellValueInColumnSearch(address, newValue) {
    if (this.isNotComputed(address)) {
      return;
    }
    const oldValue = this.dependencyGraph.getCellValue(address);
    this.columnSearch.change(getRawValue(oldValue), getRawValue(newValue), address);
  }
  /**
   * Checks if the ScalarFormulaVertex or ArrayFormulaVertex at the given address is not computed.
   */
  isNotComputed(address) {
    const vertex = this.dependencyGraph.getCell(address);
    if (!vertex) {
      return false;
    }
    return vertex instanceof FormulaVertex && !vertex.isComputed();
  }
}
function normalizeRemovedIndexes(indexes) {
  if (indexes.length <= 1) {
    return indexes;
  }
  const sorted = [...indexes].sort(([a], [b]) => a - b);
  const merged = sorted.reduce((acc, [startIndex, amount]) => {
    const previous = acc[acc.length - 1];
    const lastIndex = previous[0] + previous[1];
    if (startIndex <= lastIndex) {
      previous[1] += Math.max(0, amount - (lastIndex - startIndex));
    } else {
      acc.push([startIndex, amount]);
    }
    return acc;
  }, [sorted[0]]);
  let shift = 0;
  for (let i = 0; i < merged.length; ++i) {
    merged[i][0] -= shift;
    shift += merged[i][1];
  }
  return merged;
}
function normalizeAddedIndexes(indexes) {
  if (indexes.length <= 1) {
    return indexes;
  }
  const sorted = [...indexes].sort(([a], [b]) => a - b);
  const merged = sorted.reduce((acc, [startIndex, amount]) => {
    const previous = acc[acc.length - 1];
    if (startIndex === previous[0]) {
      previous[1] = Math.max(previous[1], amount);
    } else {
      acc.push([startIndex, amount]);
    }
    return acc;
  }, [sorted[0]]);
  let shift = 0;
  for (let i = 0; i < merged.length; ++i) {
    merged[i][0] += shift;
    shift += merged[i][1];
  }
  return merged;
}
function isPositiveInteger$1(n2) {
  return Number.isInteger(n2) && n2 > 0;
}
function isRowOrColumnRange(leftCorner, width, height) {
  return leftCorner.row === 0 && isPositiveInteger$1(width) && height === Number.POSITIVE_INFINITY || leftCorner.col === 0 && isPositiveInteger$1(height) && width === Number.POSITIVE_INFINITY;
}
class BaseUndoEntry {
  /**
   * Returns LazilyTransformingAstService version keys referenced by this entry's oldData.
   * Default implementation returns empty — override in entries that store oldData.
   */
  getReferencedOldDataVersions() {
    return [];
  }
}
class RemoveRowsUndoEntry extends BaseUndoEntry {
  constructor(command2, rowsRemovals) {
    super();
    this.command = command2;
    this.rowsRemovals = rowsRemovals;
  }
  doUndo(undoRedo) {
    undoRedo.undoRemoveRows(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoRemoveRows(this);
  }
  getReferencedOldDataVersions() {
    return this.rowsRemovals.filter((r) => r.version > 0).map((r) => r.version - 1);
  }
}
class MoveCellsUndoEntry extends BaseUndoEntry {
  constructor(sourceLeftCorner, width, height, destinationLeftCorner, overwrittenCellsData, addedGlobalNamedExpressions, version2) {
    super();
    this.sourceLeftCorner = sourceLeftCorner;
    this.width = width;
    this.height = height;
    this.destinationLeftCorner = destinationLeftCorner;
    this.overwrittenCellsData = overwrittenCellsData;
    this.addedGlobalNamedExpressions = addedGlobalNamedExpressions;
    this.version = version2;
  }
  doUndo(undoRedo) {
    undoRedo.undoMoveCells(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoMoveCells(this);
  }
  getReferencedOldDataVersions() {
    return this.version > 0 ? [this.version - 1] : [];
  }
}
class AddRowsUndoEntry extends BaseUndoEntry {
  constructor(command2) {
    super();
    this.command = command2;
  }
  doUndo(undoRedo) {
    undoRedo.undoAddRows(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoAddRows(this);
  }
}
class SetRowOrderUndoEntry extends BaseUndoEntry {
  constructor(sheetId, rowMapping, oldContent) {
    super();
    this.sheetId = sheetId;
    this.rowMapping = rowMapping;
    this.oldContent = oldContent;
  }
  doUndo(undoRedo) {
    undoRedo.undoSetRowOrder(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoSetRowOrder(this);
  }
}
class SetColumnOrderUndoEntry extends BaseUndoEntry {
  constructor(sheetId, columnMapping, oldContent) {
    super();
    this.sheetId = sheetId;
    this.columnMapping = columnMapping;
    this.oldContent = oldContent;
  }
  doUndo(undoRedo) {
    undoRedo.undoSetColumnOrder(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoSetColumnOrder(this);
  }
}
class SetSheetContentUndoEntry extends BaseUndoEntry {
  constructor(sheetId, oldSheetContent, newSheetContent) {
    super();
    this.sheetId = sheetId;
    this.oldSheetContent = oldSheetContent;
    this.newSheetContent = newSheetContent;
  }
  doUndo(undoRedo) {
    undoRedo.undoSetSheetContent(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoSetSheetContent(this);
  }
}
class MoveRowsUndoEntry extends BaseUndoEntry {
  constructor(sheet, startRow, numberOfRows, targetRow, version2) {
    super();
    this.sheet = sheet;
    this.startRow = startRow;
    this.numberOfRows = numberOfRows;
    this.targetRow = targetRow;
    this.version = version2;
    this.undoStart = this.startRow < this.targetRow ? this.targetRow - this.numberOfRows : this.targetRow;
    this.undoEnd = this.startRow > this.targetRow ? this.startRow + this.numberOfRows : this.startRow;
  }
  doUndo(undoRedo) {
    undoRedo.undoMoveRows(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoMoveRows(this);
  }
  getReferencedOldDataVersions() {
    return this.version > 0 ? [this.version - 1] : [];
  }
}
class MoveColumnsUndoEntry extends BaseUndoEntry {
  constructor(sheet, startColumn, numberOfColumns, targetColumn, version2) {
    super();
    this.sheet = sheet;
    this.startColumn = startColumn;
    this.numberOfColumns = numberOfColumns;
    this.targetColumn = targetColumn;
    this.version = version2;
    this.undoStart = this.startColumn < this.targetColumn ? this.targetColumn - this.numberOfColumns : this.targetColumn;
    this.undoEnd = this.startColumn > this.targetColumn ? this.startColumn + this.numberOfColumns : this.startColumn;
  }
  doUndo(undoRedo) {
    undoRedo.undoMoveColumns(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoMoveColumns(this);
  }
  getReferencedOldDataVersions() {
    return this.version > 0 ? [this.version - 1] : [];
  }
}
class AddColumnsUndoEntry extends BaseUndoEntry {
  constructor(command2) {
    super();
    this.command = command2;
  }
  doUndo(undoRedo) {
    undoRedo.undoAddColumns(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoAddColumns(this);
  }
}
class RemoveColumnsUndoEntry extends BaseUndoEntry {
  constructor(command2, columnsRemovals) {
    super();
    this.command = command2;
    this.columnsRemovals = columnsRemovals;
  }
  doUndo(undoRedo) {
    undoRedo.undoRemoveColumns(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoRemoveColumns(this);
  }
  getReferencedOldDataVersions() {
    return this.columnsRemovals.filter((r) => r.version > 0).map((r) => r.version - 1);
  }
}
class AddSheetUndoEntry extends BaseUndoEntry {
  constructor(sheetName, sheetId) {
    super();
    this.sheetName = sheetName;
    this.sheetId = sheetId;
  }
  doUndo(undoRedo) {
    undoRedo.undoAddSheet(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoAddSheet(this);
  }
}
class RemoveSheetUndoEntry extends BaseUndoEntry {
  constructor(sheetName, sheetId, oldSheetContent, scopedNamedExpressions) {
    super();
    this.sheetName = sheetName;
    this.sheetId = sheetId;
    this.oldSheetContent = oldSheetContent;
    this.scopedNamedExpressions = scopedNamedExpressions;
  }
  doUndo(undoRedo) {
    undoRedo.undoRemoveSheet(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoRemoveSheet(this);
  }
}
class RenameSheetUndoEntry extends BaseUndoEntry {
  constructor(sheetId, oldName, newName, version2, mergedPlaceholderSheetId) {
    super();
    this.sheetId = sheetId;
    this.oldName = oldName;
    this.newName = newName;
    this.version = version2;
    this.mergedPlaceholderSheetId = mergedPlaceholderSheetId;
  }
  doUndo(undoRedo) {
    undoRedo.undoRenameSheet(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoRenameSheet(this);
  }
  getReferencedOldDataVersions() {
    return this.version !== void 0 && this.version > 0 ? [this.version - 1] : [];
  }
}
class ClearSheetUndoEntry extends BaseUndoEntry {
  constructor(sheetId, oldSheetContent) {
    super();
    this.sheetId = sheetId;
    this.oldSheetContent = oldSheetContent;
  }
  doUndo(undoRedo) {
    undoRedo.undoClearSheet(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoClearSheet(this);
  }
}
class SetCellContentsUndoEntry extends BaseUndoEntry {
  constructor(cellContents) {
    super();
    this.cellContents = cellContents;
  }
  doUndo(undoRedo) {
    undoRedo.undoSetCellContents(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoSetCellContents(this);
  }
}
class PasteUndoEntry extends BaseUndoEntry {
  constructor(targetLeftCorner, oldContent, newContent, addedGlobalNamedExpressions) {
    super();
    this.targetLeftCorner = targetLeftCorner;
    this.oldContent = oldContent;
    this.newContent = newContent;
    this.addedGlobalNamedExpressions = addedGlobalNamedExpressions;
  }
  doUndo(undoRedo) {
    undoRedo.undoPaste(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoPaste(this);
  }
}
class AddNamedExpressionUndoEntry extends BaseUndoEntry {
  constructor(name, newContent, scope, options) {
    super();
    this.name = name;
    this.newContent = newContent;
    this.scope = scope;
    this.options = options;
  }
  doUndo(undoRedo) {
    undoRedo.undoAddNamedExpression(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoAddNamedExpression(this);
  }
}
class RemoveNamedExpressionUndoEntry extends BaseUndoEntry {
  constructor(namedExpression, content, scope) {
    super();
    this.namedExpression = namedExpression;
    this.content = content;
    this.scope = scope;
  }
  doUndo(undoRedo) {
    undoRedo.undoRemoveNamedExpression(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoRemoveNamedExpression(this);
  }
}
class ChangeNamedExpressionUndoEntry extends BaseUndoEntry {
  constructor(namedExpression, newContent, oldContent, scope, options) {
    super();
    this.namedExpression = namedExpression;
    this.newContent = newContent;
    this.oldContent = oldContent;
    this.scope = scope;
    this.options = options;
  }
  doUndo(undoRedo) {
    undoRedo.undoChangeNamedExpression(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoChangeNamedExpression(this);
  }
}
class BatchUndoEntry extends BaseUndoEntry {
  constructor() {
    super(...arguments);
    this.operations = [];
  }
  add(operation) {
    this.operations.push(operation);
  }
  *reversedOperations() {
    for (let i = this.operations.length - 1; i >= 0; i--) {
      yield this.operations[i];
    }
  }
  doUndo(undoRedo) {
    undoRedo.undoBatch(this);
  }
  doRedo(undoRedo) {
    undoRedo.redoBatch(this);
  }
  getReferencedOldDataVersions() {
    return this.operations.flatMap((op) => op.getReferencedOldDataVersions());
  }
}
let UndoRedo$1 = class UndoRedo {
  constructor(config, operations2) {
    this.operations = operations2;
    this.oldData = /* @__PURE__ */ new Map();
    this.undoStack = [];
    this.redoStack = [];
    this.undoLimit = config.undoLimit;
  }
  saveOperation(operation) {
    if (this.batchUndoEntry !== void 0) {
      this.batchUndoEntry.add(operation);
    } else {
      this.addUndoEntry(operation);
    }
  }
  beginBatchMode() {
    this.batchUndoEntry = new BatchUndoEntry();
  }
  commitBatchMode() {
    if (this.batchUndoEntry === void 0) {
      throw Error("Batch mode wasn't started");
    }
    this.addUndoEntry(this.batchUndoEntry);
    this.batchUndoEntry = void 0;
  }
  /**
   * Stores a formula AST hash snapshot for the given LazilyTransformingAstService version.
   * Skipped when `undoLimit` is 0 (undo disabled) to avoid storing data that would never be used.
   */
  storeDataForVersion(version2, address, astHash) {
    if (this.undoLimit === 0) {
      return;
    }
    if (!this.oldData.has(version2)) {
      this.oldData.set(version2, []);
    }
    const currentOldData = this.oldData.get(version2);
    currentOldData.push([address, astHash]);
  }
  /** Clears the redo stack and removes oldData entries no longer referenced by any remaining entry. */
  clearRedoStack() {
    this.cleanupOldDataForEntries(this.redoStack, this.undoStack);
    this.redoStack = [];
  }
  /** Clears the undo stack and removes oldData entries no longer referenced by any remaining entry. */
  clearUndoStack() {
    this.cleanupOldDataForEntries(this.undoStack, this.redoStack);
    this.undoStack = [];
  }
  isUndoStackEmpty() {
    return this.undoStack.length === 0;
  }
  isRedoStackEmpty() {
    return this.redoStack.length === 0;
  }
  undo() {
    const operation = this.undoStack.pop();
    if (!operation) {
      throw Error("Attempted to undo without operation on stack");
    }
    this.undoEntry(operation);
    this.redoStack.push(operation);
  }
  undoBatch(batchOperation) {
    for (const operation of batchOperation.reversedOperations()) {
      this.undoEntry(operation);
    }
  }
  undoRemoveRows(operation) {
    this.operations.forceApplyPostponedTransformations();
    const {
      command: {
        sheet
      },
      rowsRemovals
    } = operation;
    for (let i = rowsRemovals.length - 1; i >= 0; --i) {
      const rowsRemoval = rowsRemovals[i];
      this.operations.addRows(new AddRowsCommand(sheet, [[rowsRemoval.rowFrom, rowsRemoval.rowCount]]));
      for (const {
        address,
        cellType
      } of rowsRemoval.removedCells) {
        this.operations.restoreCell(address, cellType);
      }
      this.restoreOldDataFromVersion(rowsRemoval.version - 1);
    }
  }
  undoRemoveColumns(operation) {
    this.operations.forceApplyPostponedTransformations();
    const {
      command: {
        sheet
      },
      columnsRemovals
    } = operation;
    for (let i = columnsRemovals.length - 1; i >= 0; --i) {
      const columnsRemoval = columnsRemovals[i];
      this.operations.addColumns(new AddColumnsCommand(sheet, [[columnsRemoval.columnFrom, columnsRemoval.columnCount]]));
      for (const {
        address,
        cellType
      } of columnsRemoval.removedCells) {
        this.operations.restoreCell(address, cellType);
      }
      this.restoreOldDataFromVersion(columnsRemoval.version - 1);
    }
  }
  undoAddRows(operation) {
    const addedRowsSpans = operation.command.rowsSpans();
    for (let i = addedRowsSpans.length - 1; i >= 0; --i) {
      const addedRows = addedRowsSpans[i];
      this.operations.removeRows(new RemoveRowsCommand(operation.command.sheet, [[addedRows.rowStart, addedRows.numberOfRows]]));
    }
  }
  undoAddColumns(operation) {
    const addedColumnsSpans = operation.command.columnsSpans();
    for (let i = addedColumnsSpans.length - 1; i >= 0; --i) {
      const addedColumns = addedColumnsSpans[i];
      this.operations.removeColumns(new RemoveColumnsCommand(operation.command.sheet, [[addedColumns.columnStart, addedColumns.numberOfColumns]]));
    }
  }
  undoSetCellContents(operation) {
    for (const cellContentData of operation.cellContents) {
      const address = cellContentData.address;
      const [oldContentAddress, oldContent] = cellContentData.oldContent;
      if (!equalSimpleCellAddress(address, oldContentAddress)) {
        this.operations.setCellEmpty(address);
      }
      this.operations.restoreCell(oldContentAddress, oldContent);
    }
  }
  undoPaste(operation) {
    this.restoreOperationOldContent(operation.oldContent);
    for (const namedExpression of operation.addedGlobalNamedExpressions) {
      this.operations.removeNamedExpression(namedExpression);
    }
  }
  undoMoveRows(operation) {
    this.operations.forceApplyPostponedTransformations();
    const {
      sheet
    } = operation;
    this.operations.moveRows(sheet, operation.undoStart, operation.numberOfRows, operation.undoEnd);
    this.restoreOldDataFromVersion(operation.version - 1);
  }
  undoMoveColumns(operation) {
    this.operations.forceApplyPostponedTransformations();
    const {
      sheet
    } = operation;
    this.operations.moveColumns(sheet, operation.undoStart, operation.numberOfColumns, operation.undoEnd);
    this.restoreOldDataFromVersion(operation.version - 1);
  }
  undoMoveCells(operation) {
    this.operations.forceApplyPostponedTransformations();
    this.operations.moveCells(operation.destinationLeftCorner, operation.width, operation.height, operation.sourceLeftCorner);
    this.restoreOperationOldContent(operation.overwrittenCellsData);
    this.restoreOldDataFromVersion(operation.version - 1);
    for (const namedExpression of operation.addedGlobalNamedExpressions) {
      this.operations.removeNamedExpression(namedExpression);
    }
  }
  undoAddSheet(operation) {
    const {
      sheetName
    } = operation;
    this.operations.removeSheetByName(sheetName);
  }
  undoRemoveSheet(operation) {
    this.operations.forceApplyPostponedTransformations();
    const {
      oldSheetContent,
      sheetId,
      scopedNamedExpressions,
      sheetName
    } = operation;
    this.operations.addSheetWithId(sheetId, sheetName);
    for (let rowIndex = 0; rowIndex < oldSheetContent.length; rowIndex++) {
      const row = oldSheetContent[rowIndex];
      for (let col = 0; col < row.length; col++) {
        const cellType = row[col];
        const address = simpleCellAddress(sheetId, col, rowIndex);
        this.operations.restoreCell(address, cellType);
      }
    }
    for (const [namedexpression, content] of scopedNamedExpressions) {
      this.operations.restoreNamedExpression(namedexpression, content, sheetId);
    }
  }
  undoRenameSheet(operation) {
    this.operations.forceApplyPostponedTransformations();
    this.operations.renameSheet(operation.sheetId, operation.oldName);
    if (operation.mergedPlaceholderSheetId !== void 0 && operation.version !== void 0) {
      this.operations.addPlaceholderSheetWithId(operation.mergedPlaceholderSheetId, operation.newName);
      this.restoreOldDataFromVersion(operation.version - 1);
    }
  }
  undoClearSheet(operation) {
    const {
      oldSheetContent,
      sheetId
    } = operation;
    for (let rowIndex = 0; rowIndex < oldSheetContent.length; rowIndex++) {
      const row = oldSheetContent[rowIndex];
      for (let col = 0; col < row.length; col++) {
        const cellType = row[col];
        const address = simpleCellAddress(sheetId, col, rowIndex);
        this.operations.restoreCell(address, cellType);
      }
    }
  }
  undoSetSheetContent(operation) {
    const {
      oldSheetContent,
      sheetId
    } = operation;
    this.operations.clearSheet(sheetId);
    for (let rowIndex = 0; rowIndex < oldSheetContent.length; rowIndex++) {
      const row = oldSheetContent[rowIndex];
      for (let col = 0; col < row.length; col++) {
        const cellType = row[col];
        const address = simpleCellAddress(sheetId, col, rowIndex);
        this.operations.restoreCell(address, cellType);
      }
    }
  }
  undoAddNamedExpression(operation) {
    this.operations.removeNamedExpression(operation.name, operation.scope);
  }
  undoRemoveNamedExpression(operation) {
    this.operations.restoreNamedExpression(operation.namedExpression, operation.content, operation.scope);
  }
  undoChangeNamedExpression(operation) {
    this.operations.restoreNamedExpression(operation.namedExpression, operation.oldContent, operation.scope);
  }
  undoSetRowOrder(operation) {
    this.restoreOperationOldContent(operation.oldContent);
  }
  undoSetColumnOrder(operation) {
    this.restoreOperationOldContent(operation.oldContent);
  }
  redo() {
    const operation = this.redoStack.pop();
    if (!operation) {
      throw Error("Attempted to redo without operation on stack");
    }
    this.redoEntry(operation);
    this.undoStack.push(operation);
  }
  redoBatch(batchOperation) {
    for (const operation of batchOperation.operations) {
      this.redoEntry(operation);
    }
  }
  redoRemoveRows(operation) {
    this.operations.removeRows(operation.command);
  }
  redoMoveCells(operation) {
    this.operations.moveCells(operation.sourceLeftCorner, operation.width, operation.height, operation.destinationLeftCorner);
  }
  redoRemoveColumns(operation) {
    this.operations.removeColumns(operation.command);
  }
  redoPaste(operation) {
    const {
      targetLeftCorner,
      newContent
    } = operation;
    const height = newContent.length;
    const width = newContent[0].length;
    for (let y = 0; y < height; ++y) {
      for (let x = 0; x < width; ++x) {
        const address = simpleCellAddress(targetLeftCorner.sheet, targetLeftCorner.col + x, targetLeftCorner.row + y);
        this.operations.restoreCell(address, newContent[y][x]);
      }
    }
  }
  redoSetCellContents(operation) {
    for (const cellContentData of operation.cellContents) {
      this.operations.setCellContent(cellContentData.address, cellContentData.newContent);
    }
  }
  redoAddRows(operation) {
    this.operations.addRows(operation.command);
  }
  redoAddColumns(operation) {
    this.operations.addColumns(operation.command);
  }
  redoRemoveSheet(operation) {
    this.operations.removeSheetByName(operation.sheetName);
  }
  redoAddSheet(operation) {
    this.operations.addSheetWithId(operation.sheetId, operation.sheetName);
  }
  redoRenameSheet(operation) {
    this.operations.renameSheet(operation.sheetId, operation.newName);
  }
  redoMoveRows(operation) {
    this.operations.moveRows(operation.sheet, operation.startRow, operation.numberOfRows, operation.targetRow);
  }
  redoMoveColumns(operation) {
    this.operations.moveColumns(operation.sheet, operation.startColumn, operation.numberOfColumns, operation.targetColumn);
  }
  redoClearSheet(operation) {
    this.operations.clearSheet(operation.sheetId);
  }
  redoSetSheetContent(operation) {
    const {
      sheetId,
      newSheetContent
    } = operation;
    this.operations.setSheetContent(sheetId, newSheetContent);
  }
  redoAddNamedExpression(operation) {
    this.operations.addNamedExpression(operation.name, operation.newContent, operation.scope, operation.options);
  }
  redoRemoveNamedExpression(operation) {
    this.operations.removeNamedExpression(operation.namedExpression.displayName, operation.scope);
  }
  redoChangeNamedExpression(operation) {
    this.operations.changeNamedExpressionExpression(operation.namedExpression.displayName, operation.newContent, operation.scope, operation.options);
  }
  redoSetRowOrder(operation) {
    this.operations.setRowOrder(operation.sheetId, operation.rowMapping);
  }
  redoSetColumnOrder(operation) {
    this.operations.setColumnOrder(operation.sheetId, operation.columnMapping);
  }
  /**
   * Adds an entry to the undo stack, evicting the oldest entries when undoLimit is exceeded.
   * Evicted entries have their oldData keys cleaned up to prevent memory leaks.
   */
  addUndoEntry(operation) {
    this.undoStack.push(operation);
    const evictCount = Math.max(0, this.undoStack.length - this.undoLimit);
    if (evictCount > 0) {
      const evicted = this.undoStack.splice(0, evictCount);
      this.cleanupOldDataForEntries(evicted, [...this.undoStack, ...this.redoStack]);
    }
  }
  /**
   * Removes oldData entries whose version keys are not referenced by any
   * entry on the undo stack, redo stack, or in-progress batch. Called after
   * compaction forces lazy formula evaluation, which may insert oldData for
   * already-evicted entries.
   */
  cleanupOrphanedOldData() {
    const referencedVersions = this.collectReferencedOldDataVersions(this.undoStack, this.redoStack);
    for (const version2 of this.oldData.keys()) {
      if (!referencedVersions.has(version2)) {
        this.oldData.delete(version2);
      }
    }
  }
  /**
   * Removes oldData entries referenced by permanently discarded undo/redo entries,
   * but only if not still referenced by entries remaining on the other stack or
   * in-progress batch.
   */
  cleanupOldDataForEntries(discardedEntries, retainedEntries) {
    const retainedVersions = this.collectReferencedOldDataVersions(retainedEntries);
    for (const entry of discardedEntries) {
      for (const version2 of entry.getReferencedOldDataVersions()) {
        if (!retainedVersions.has(version2)) {
          this.oldData.delete(version2);
        }
      }
    }
  }
  /** Collects all oldData version keys referenced by the given entry lists and in-progress batch. */
  collectReferencedOldDataVersions(...entryLists) {
    var _a, _b;
    return /* @__PURE__ */ new Set([...entryLists.flatMap((list) => list.flatMap((e) => e.getReferencedOldDataVersions())), ...(_b = (_a = this.batchUndoEntry) === null || _a === void 0 ? void 0 : _a.getReferencedOldDataVersions()) !== null && _b !== void 0 ? _b : []]);
  }
  undoEntry(operation) {
    operation.doUndo(this);
  }
  restoreOperationOldContent(oldContent) {
    for (const [address, clipboardCell] of oldContent) {
      this.operations.restoreCell(address, clipboardCell);
    }
  }
  redoEntry(operation) {
    operation.doRedo(this);
  }
  restoreOldDataFromVersion(version2) {
    const oldDataToRestore = this.oldData.get(version2) || [];
    for (const entryToRestore of oldDataToRestore) {
      const [address, hash] = entryToRestore;
      this.operations.setFormulaToCellFromCache(hash, address);
    }
  }
};
class CrudOperations {
  constructor(config, operations2, undoRedo, clipboardOperations, dependencyGraph, columnSearch, parser, cellContentParser, lazilyTransformingAstService, namedExpressions) {
    this.operations = operations2;
    this.undoRedo = undoRedo;
    this.clipboardOperations = clipboardOperations;
    this.dependencyGraph = dependencyGraph;
    this.columnSearch = columnSearch;
    this.parser = parser;
    this.cellContentParser = cellContentParser;
    this.lazilyTransformingAstService = lazilyTransformingAstService;
    this.namedExpressions = namedExpressions;
    this.maxRows = config.maxRows;
    this.maxColumns = config.maxColumns;
  }
  get sheetMapping() {
    return this.dependencyGraph.sheetMapping;
  }
  addRows(sheet, ...indexes) {
    const addRowsCommand = new AddRowsCommand(sheet, indexes);
    this.ensureItIsPossibleToAddRows(sheet, ...indexes);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    this.operations.addRows(addRowsCommand);
    this.undoRedo.saveOperation(new AddRowsUndoEntry(addRowsCommand));
  }
  removeRows(sheet, ...indexes) {
    const removeRowsCommand = new RemoveRowsCommand(sheet, indexes);
    this.ensureItIsPossibleToRemoveRows(sheet, ...indexes);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const rowsRemovals = this.operations.removeRows(removeRowsCommand);
    this.undoRedo.saveOperation(new RemoveRowsUndoEntry(removeRowsCommand, rowsRemovals));
  }
  addColumns(sheet, ...indexes) {
    const addColumnsCommand = new AddColumnsCommand(sheet, indexes);
    this.ensureItIsPossibleToAddColumns(sheet, ...indexes);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    this.operations.addColumns(addColumnsCommand);
    this.undoRedo.saveOperation(new AddColumnsUndoEntry(addColumnsCommand));
  }
  removeColumns(sheet, ...indexes) {
    const removeColumnsCommand = new RemoveColumnsCommand(sheet, indexes);
    this.ensureItIsPossibleToRemoveColumns(sheet, ...indexes);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const columnsRemovals = this.operations.removeColumns(removeColumnsCommand);
    this.undoRedo.saveOperation(new RemoveColumnsUndoEntry(removeColumnsCommand, columnsRemovals));
  }
  moveCells(sourceLeftCorner, width, height, destinationLeftCorner) {
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const {
      version: version2,
      overwrittenCellsData,
      addedGlobalNamedExpressions
    } = this.operations.moveCells(sourceLeftCorner, width, height, destinationLeftCorner);
    this.undoRedo.saveOperation(new MoveCellsUndoEntry(sourceLeftCorner, width, height, destinationLeftCorner, overwrittenCellsData, addedGlobalNamedExpressions, version2));
  }
  moveRows(sheet, startRow, numberOfRows, targetRow) {
    this.ensureItIsPossibleToMoveRows(sheet, startRow, numberOfRows, targetRow);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const version2 = this.operations.moveRows(sheet, startRow, numberOfRows, targetRow);
    this.undoRedo.saveOperation(new MoveRowsUndoEntry(sheet, startRow, numberOfRows, targetRow, version2));
  }
  moveColumns(sheet, startColumn, numberOfColumns, targetColumn) {
    this.ensureItIsPossibleToMoveColumns(sheet, startColumn, numberOfColumns, targetColumn);
    this.undoRedo.clearRedoStack();
    const version2 = this.operations.moveColumns(sheet, startColumn, numberOfColumns, targetColumn);
    this.undoRedo.saveOperation(new MoveColumnsUndoEntry(sheet, startColumn, numberOfColumns, targetColumn, version2));
  }
  cut(sourceLeftCorner, width, height) {
    this.clipboardOperations.cut(sourceLeftCorner, width, height);
  }
  ensureItIsPossibleToCopy(sourceLeftCorner, width, height) {
    if (!isPositiveInteger(width)) {
      throw new InvalidArgumentsError("width to be positive integer.");
    }
    if (!isPositiveInteger(height)) {
      throw new InvalidArgumentsError("height to be positive integer.");
    }
  }
  copy(sourceLeftCorner, width, height) {
    this.ensureItIsPossibleToCopy(sourceLeftCorner, width, height);
    this.clipboardOperations.copy(sourceLeftCorner, width, height);
  }
  paste(targetLeftCorner) {
    const clipboard = this.clipboardOperations.clipboard;
    if (clipboard === void 0) {
      throw new NothingToPasteError();
    } else if (this.clipboardOperations.isCutClipboard()) {
      this.moveCells(clipboard.sourceLeftCorner, clipboard.width, clipboard.height, targetLeftCorner);
    } else if (this.clipboardOperations.isCopyClipboard()) {
      this.clipboardOperations.ensureItIsPossibleToCopyPaste(targetLeftCorner);
      const targetRange = AbsoluteCellRange.spanFrom(targetLeftCorner, clipboard.width, clipboard.height);
      const oldContent = this.operations.getRangeClipboardCells(targetRange);
      this.undoRedo.clearRedoStack();
      const addedGlobalNamedExpressions = this.operations.restoreClipboardCells(clipboard.sourceLeftCorner.sheet, clipboard.getContent(targetLeftCorner));
      this.undoRedo.saveOperation(new PasteUndoEntry(targetLeftCorner, oldContent, clipboard.content, addedGlobalNamedExpressions));
    }
  }
  beginUndoRedoBatchMode() {
    this.undoRedo.beginBatchMode();
  }
  commitUndoRedoBatchMode() {
    this.undoRedo.commitBatchMode();
  }
  isClipboardEmpty() {
    return this.clipboardOperations.clipboard === void 0;
  }
  clearClipboard() {
    this.clipboardOperations.clear();
  }
  addSheet(name) {
    if (name !== void 0) {
      this.ensureItIsPossibleToAddSheet(name);
    }
    this.undoRedo.clearRedoStack();
    const {
      sheetName,
      sheetId
    } = this.operations.addSheet(name);
    this.undoRedo.saveOperation(new AddSheetUndoEntry(sheetName, sheetId));
    return sheetName;
  }
  removeSheet(sheetId) {
    this.ensureScopeIdIsValid(sheetId);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const originalName = this.sheetMapping.getSheetNameOrThrowError(sheetId);
    const oldSheetContent = this.operations.getSheetClipboardCells(sheetId);
    const scopedNamedExpressions = this.operations.removeSheet(sheetId);
    this.undoRedo.saveOperation(new RemoveSheetUndoEntry(originalName, sheetId, oldSheetContent, scopedNamedExpressions));
  }
  renameSheet(sheetId, newName) {
    this.ensureItIsPossibleToRenameSheet(sheetId, newName);
    const {
      previousDisplayName,
      version: version2,
      mergedPlaceholderSheetId
    } = this.operations.renameSheet(sheetId, newName);
    if (previousDisplayName !== void 0) {
      this.undoRedo.clearRedoStack();
      this.undoRedo.saveOperation(new RenameSheetUndoEntry(sheetId, previousDisplayName, newName, version2, mergedPlaceholderSheetId));
    }
    return previousDisplayName;
  }
  clearSheet(sheetId) {
    this.ensureScopeIdIsValid(sheetId);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const oldSheetContent = this.operations.getSheetClipboardCells(sheetId);
    this.operations.clearSheet(sheetId);
    this.undoRedo.saveOperation(new ClearSheetUndoEntry(sheetId, oldSheetContent));
  }
  setCellContents(topLeftCornerAddress, cellContents) {
    if (!(cellContents instanceof Array)) {
      cellContents = [[cellContents]];
    } else {
      for (let i = 0; i < cellContents.length; i++) {
        if (!(cellContents[i] instanceof Array)) {
          throw new InvalidArgumentsError("an array of arrays or a raw cell value.");
        }
      }
    }
    this.ensureItIsPossibleToChangeCellContents(topLeftCornerAddress, cellContents);
    this.undoRedo.clearRedoStack();
    const oldContents = [];
    for (let i = 0; i < cellContents.length; i++) {
      for (let j = 0; j < cellContents[i].length; j++) {
        const address = {
          sheet: topLeftCornerAddress.sheet,
          row: topLeftCornerAddress.row + i,
          col: topLeftCornerAddress.col + j
        };
        const newContent = cellContents[i][j];
        this.clipboardOperations.abortCut();
        const oldContent = this.operations.setCellContent(address, newContent);
        oldContents.push({
          address,
          newContent,
          oldContent
        });
      }
    }
    this.undoRedo.saveOperation(new SetCellContentsUndoEntry(oldContents));
  }
  setSheetContent(sheetId, values2) {
    this.ensureScopeIdIsValid(sheetId);
    this.ensureItIsPossibleToChangeSheetContents(sheetId, values2);
    validateAsSheet(values2);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const oldSheetContent = this.operations.getSheetClipboardCells(sheetId);
    this.operations.setSheetContent(sheetId, values2);
    this.undoRedo.saveOperation(new SetSheetContentUndoEntry(sheetId, oldSheetContent, values2));
  }
  setRowOrder(sheetId, rowMapping) {
    this.validateSwapRowIndexes(sheetId, rowMapping);
    this.testRowOrderForArrays(sheetId, rowMapping);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const oldContent = this.operations.setRowOrder(sheetId, rowMapping);
    this.undoRedo.saveOperation(new SetRowOrderUndoEntry(sheetId, rowMapping, oldContent));
  }
  validateSwapRowIndexes(sheetId, rowMapping) {
    if (!this.sheetMapping.hasSheetWithId(sheetId)) {
      throw new NoSheetWithIdError(sheetId);
    }
    this.validateRowOrColumnMapping(sheetId, rowMapping, "row");
  }
  testColumnOrderForArrays(sheetId, columnMapping) {
    for (const [source, target] of columnMapping) {
      if (source !== target) {
        const rowRange = AbsoluteCellRange.spanFrom({
          sheet: sheetId,
          col: source,
          row: 0
        }, 1, Infinity);
        if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(rowRange)) {
          throw new SourceLocationHasArrayError();
        }
      }
    }
  }
  setColumnOrder(sheetId, columnMapping) {
    this.validateSwapColumnIndexes(sheetId, columnMapping);
    this.testColumnOrderForArrays(sheetId, columnMapping);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    const oldContent = this.operations.setColumnOrder(sheetId, columnMapping);
    this.undoRedo.saveOperation(new SetColumnOrderUndoEntry(sheetId, columnMapping, oldContent));
  }
  validateSwapColumnIndexes(sheetId, columnMapping) {
    if (!this.sheetMapping.hasSheetWithId(sheetId)) {
      throw new NoSheetWithIdError(sheetId);
    }
    this.validateRowOrColumnMapping(sheetId, columnMapping, "column");
  }
  testRowOrderForArrays(sheetId, rowMapping) {
    for (const [source, target] of rowMapping) {
      if (source !== target) {
        const rowRange = AbsoluteCellRange.spanFrom({
          sheet: sheetId,
          col: 0,
          row: source
        }, Infinity, 1);
        if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(rowRange)) {
          throw new SourceLocationHasArrayError();
        }
      }
    }
  }
  mappingFromOrder(sheetId, newOrder, rowOrColumn) {
    if (!this.sheetMapping.hasSheetWithId(sheetId)) {
      throw new NoSheetWithIdError(sheetId);
    }
    const limit = rowOrColumn === "row" ? this.dependencyGraph.getSheetHeight(sheetId) : this.dependencyGraph.getSheetWidth(sheetId);
    if (newOrder.length !== limit) {
      throw new InvalidArgumentsError(`number of ${rowOrColumn}s provided to be sheet ${rowOrColumn === "row" ? "height" : "width"}.`);
    }
    const ret = [];
    for (let i = 0; i < limit; i++) {
      if (newOrder[i] !== i) {
        ret.push([i, newOrder[i]]);
      }
    }
    return ret;
  }
  undo() {
    if (this.undoRedo.isUndoStackEmpty()) {
      throw new NoOperationToUndoError();
    }
    this.clipboardOperations.abortCut();
    this.undoRedo.undo();
  }
  redo() {
    if (this.undoRedo.isRedoStackEmpty()) {
      throw new NoOperationToRedoError();
    }
    this.clipboardOperations.abortCut();
    this.undoRedo.redo();
  }
  addNamedExpression(expressionName, expression, sheetId, options) {
    this.ensureItIsPossibleToAddNamedExpression(expressionName, expression, sheetId);
    this.operations.addNamedExpression(expressionName, expression, sheetId, options);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    this.undoRedo.saveOperation(new AddNamedExpressionUndoEntry(expressionName, expression, sheetId, options));
  }
  changeNamedExpressionExpression(expressionName, sheetId, newExpression, options) {
    this.ensureItIsPossibleToChangeNamedExpression(expressionName, newExpression, sheetId);
    const [oldNamedExpression, content] = this.operations.changeNamedExpressionExpression(expressionName, newExpression, sheetId, options);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    this.undoRedo.saveOperation(new ChangeNamedExpressionUndoEntry(oldNamedExpression, newExpression, content, sheetId, options));
  }
  removeNamedExpression(expressionName, sheetId) {
    this.ensureScopeIdIsValid(sheetId);
    const [namedExpression, content] = this.operations.removeNamedExpression(expressionName, sheetId);
    this.undoRedo.clearRedoStack();
    this.clipboardOperations.abortCut();
    this.undoRedo.saveOperation(new RemoveNamedExpressionUndoEntry(namedExpression, content, sheetId));
    return namedExpression;
  }
  ensureItIsPossibleToAddNamedExpression(expressionName, expression, sheetId) {
    this.ensureScopeIdIsValid(sheetId);
    this.ensureNamedExpressionNameIsValid(expressionName, sheetId);
    this.ensureNamedExpressionIsValid(expression);
  }
  ensureItIsPossibleToChangeNamedExpression(expressionName, expression, sheetId) {
    this.ensureScopeIdIsValid(sheetId);
    if (this.namedExpressions.namedExpressionForScope(expressionName, sheetId) === void 0) {
      throw new NamedExpressionDoesNotExistError(expressionName);
    }
    this.ensureNamedExpressionIsValid(expression);
  }
  isItPossibleToRemoveNamedExpression(expressionName, sheetId) {
    this.ensureScopeIdIsValid(sheetId);
    if (this.namedExpressions.namedExpressionForScope(expressionName, sheetId) === void 0) {
      throw new NamedExpressionDoesNotExistError(expressionName);
    }
  }
  ensureItIsPossibleToAddRows(sheet, ...indexes) {
    if (!this.sheetMapping.hasSheetWithId(sheet)) {
      throw new NoSheetWithIdError(sheet);
    }
    const sheetHeight = this.dependencyGraph.getSheetHeight(sheet);
    const newRowsCount = indexes.map((index2) => index2[1]).reduce((a, b) => a + b, 0);
    if (sheetHeight + newRowsCount > this.maxRows) {
      throw new SheetSizeLimitExceededError();
    }
    for (const [row, numberOfRowsToAdd] of indexes) {
      if (!isNonnegativeInteger(row) || !isPositiveInteger(numberOfRowsToAdd)) {
        throw new InvalidArgumentsError("row number to be nonnegative and number of rows to add to be positive.");
      }
    }
  }
  ensureItIsPossibleToRemoveRows(sheet, ...indexes) {
    for (const [rowStart, numberOfRows] of indexes) {
      const rowEnd = rowStart + numberOfRows - 1;
      if (!isNonnegativeInteger(rowStart) || !isNonnegativeInteger(rowEnd)) {
        throw new InvalidArgumentsError("starting and ending row to be nonnegative.");
      }
      if (rowEnd < rowStart) {
        throw new InvalidArgumentsError("starting row to be smaller than the ending row.");
      }
      if (!this.sheetMapping.hasSheetWithId(sheet)) {
        throw new NoSheetWithIdError(sheet);
      }
    }
  }
  ensureItIsPossibleToAddColumns(sheet, ...indexes) {
    if (!this.sheetMapping.hasSheetWithId(sheet)) {
      throw new NoSheetWithIdError(sheet);
    }
    const sheetWidth = this.dependencyGraph.getSheetWidth(sheet);
    const newColumnsCount = indexes.map((index2) => index2[1]).reduce((a, b) => a + b, 0);
    if (sheetWidth + newColumnsCount > this.maxColumns) {
      throw new SheetSizeLimitExceededError();
    }
    for (const [column, numberOfColumnsToAdd] of indexes) {
      if (!isNonnegativeInteger(column) || !isPositiveInteger(numberOfColumnsToAdd)) {
        throw new InvalidArgumentsError("column number to be nonnegative and number of columns to add to be positive.");
      }
    }
  }
  ensureItIsPossibleToRemoveColumns(sheet, ...indexes) {
    for (const [columnStart, numberOfColumns] of indexes) {
      const columnEnd = columnStart + numberOfColumns - 1;
      if (!isNonnegativeInteger(columnStart) || !isNonnegativeInteger(columnEnd)) {
        throw new InvalidArgumentsError("starting and ending column to be nonnegative.");
      }
      if (columnEnd < columnStart) {
        throw new InvalidArgumentsError("starting column to be smaller than the ending column.");
      }
      if (!this.sheetMapping.hasSheetWithId(sheet)) {
        throw new NoSheetWithIdError(sheet);
      }
    }
  }
  ensureItIsPossibleToMoveRows(sheet, startRow, numberOfRows, targetRow) {
    this.ensureItIsPossibleToAddRows(sheet, [targetRow, numberOfRows]);
    const sourceStart = simpleCellAddress(sheet, 0, startRow);
    const targetStart = simpleCellAddress(sheet, 0, targetRow);
    if (!this.sheetMapping.hasSheetWithId(sheet) || isColOrRowInvalid(sourceStart) || isColOrRowInvalid(targetStart) || !isPositiveInteger(numberOfRows) || targetRow <= startRow + numberOfRows && targetRow >= startRow) {
      throw new InvalidArgumentsError("a valid range of rows to move.");
    }
    const width = this.dependencyGraph.getSheetWidth(sheet);
    const sourceRange = AbsoluteCellRange.spanFrom(sourceStart, width, numberOfRows);
    if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(sourceRange)) {
      throw new SourceLocationHasArrayError();
    }
    if (targetRow > 0 && this.dependencyGraph.arrayMapping.isFormulaArrayInAllRows(RowsSpan.fromNumberOfRows(sheet, targetRow - 1, 2))) {
      throw new TargetLocationHasArrayError();
    }
  }
  ensureItIsPossibleToMoveColumns(sheet, startColumn, numberOfColumns, targetColumn) {
    this.ensureItIsPossibleToAddColumns(sheet, [targetColumn, numberOfColumns]);
    const sourceStart = simpleCellAddress(sheet, startColumn, 0);
    const targetStart = simpleCellAddress(sheet, targetColumn, 0);
    if (!this.sheetMapping.hasSheetWithId(sheet) || isColOrRowInvalid(sourceStart) || isColOrRowInvalid(targetStart) || !isPositiveInteger(numberOfColumns) || targetColumn <= startColumn + numberOfColumns && targetColumn >= startColumn) {
      throw new InvalidArgumentsError("a valid range of columns to move.");
    }
    const sheetHeight = this.dependencyGraph.getSheetHeight(sheet);
    const sourceRange = AbsoluteCellRange.spanFrom(sourceStart, numberOfColumns, sheetHeight);
    if (this.dependencyGraph.arrayMapping.isFormulaArrayInRange(sourceRange)) {
      throw new SourceLocationHasArrayError();
    }
    if (targetColumn > 0 && this.dependencyGraph.arrayMapping.isFormulaArrayInAllColumns(ColumnsSpan.fromNumberOfColumns(sheet, targetColumn - 1, 2))) {
      throw new TargetLocationHasArrayError();
    }
  }
  ensureItIsPossibleToAddSheet(name) {
    if (this.sheetMapping.hasSheetWithName(name)) {
      throw new SheetNameAlreadyTakenError(name);
    }
  }
  ensureItIsPossibleToRenameSheet(sheetId, name) {
    if (!this.sheetMapping.hasSheetWithId(sheetId)) {
      throw new NoSheetWithIdError(sheetId);
    }
    const existingSheetId = this.sheetMapping.getSheetId(name);
    if (existingSheetId !== void 0 && existingSheetId !== sheetId) {
      throw new SheetNameAlreadyTakenError(name);
    }
  }
  ensureItIsPossibleToChangeContent(address) {
    if (isColOrRowInvalid(address)) {
      throw new InvalidAddressError(address);
    }
    if (!this.sheetMapping.hasSheetWithId(address.sheet)) {
      throw new NoSheetWithIdError(address.sheet);
    }
  }
  ensureItIsPossibleToChangeCellContents(inputAddress, content) {
    const boundaries = findBoundaries(content);
    const targetRange = AbsoluteCellRange.spanFrom(inputAddress, boundaries.width, boundaries.height);
    this.ensureRangeInSizeLimits(targetRange);
    for (const address of targetRange.addresses(this.dependencyGraph)) {
      this.ensureItIsPossibleToChangeContent(address);
    }
  }
  ensureItIsPossibleToChangeSheetContents(sheetId, content) {
    const boundaries = findBoundaries(content);
    const targetRange = AbsoluteCellRange.spanFrom(simpleCellAddress(sheetId, 0, 0), boundaries.width, boundaries.height);
    this.ensureRangeInSizeLimits(targetRange);
  }
  ensureRangeInSizeLimits(range) {
    if (range.exceedsSheetSizeLimits(this.maxColumns, this.maxRows)) {
      throw new SheetSizeLimitExceededError();
    }
  }
  isThereSomethingToUndo() {
    return !this.undoRedo.isUndoStackEmpty();
  }
  isThereSomethingToRedo() {
    return !this.undoRedo.isRedoStackEmpty();
  }
  getAndClearContentChanges() {
    return this.operations.getAndClearContentChanges();
  }
  ensureScopeIdIsValid(scopeId) {
    if (scopeId !== void 0 && !this.sheetMapping.hasSheetWithId(scopeId)) {
      throw new NoSheetWithIdError(scopeId);
    }
  }
  validateRowOrColumnMapping(sheetId, rowMapping, rowOrColumn) {
    const limit = rowOrColumn === "row" ? this.dependencyGraph.getSheetHeight(sheetId) : this.dependencyGraph.getSheetWidth(sheetId);
    const sources = rowMapping.map(([a, _]) => a).sort((a, b) => a - b);
    const targets = rowMapping.map(([_, b]) => b).sort((a, b) => a - b);
    for (let i = 0; i < sources.length; i++) {
      if (!isNonnegativeInteger(sources[i]) || sources[i] >= limit) {
        throw new InvalidArgumentsError(`${rowOrColumn} numbers to be nonnegative integers and less than sheet ${rowOrColumn === "row" ? "height" : "width"}.`);
      }
      if (sources[i] === sources[i + 1]) {
        throw new InvalidArgumentsError(`source ${rowOrColumn} numbers to be unique.`);
      }
      if (sources[i] !== targets[i]) {
        throw new InvalidArgumentsError(`target ${rowOrColumn} numbers to be permutation of source ${rowOrColumn} numbers.`);
      }
    }
  }
  ensureNamedExpressionNameIsValid(expressionName, sheetId) {
    if (!this.namedExpressions.isNameValid(expressionName)) {
      throw new NamedExpressionNameIsInvalidError(expressionName);
    }
    if (!this.namedExpressions.isNameAvailable(expressionName, sheetId)) {
      throw new NamedExpressionNameIsAlreadyTakenError(expressionName);
    }
  }
  ensureNamedExpressionIsValid(expression) {
    const parsedExpression = this.cellContentParser.parse(expression);
    if (parsedExpression instanceof CellContent.Formula) {
      const parsingResult = this.parser.parse(parsedExpression.formula, simpleCellAddress(-1, 0, 0));
      if (doesContainRelativeReferences(parsingResult.ast)) {
        throw new NoRelativeAddressesAllowedError();
      }
    }
  }
}
function isPositiveInteger(x) {
  return Number.isInteger(x) && x > 0;
}
function isNonnegativeInteger(x) {
  return Number.isInteger(x) && x >= 0;
}
class Evaluator {
  constructor(config, stats, interpreter, lazilyTransformingAstService, dependencyGraph, columnSearch) {
    this.config = config;
    this.stats = stats;
    this.interpreter = interpreter;
    this.lazilyTransformingAstService = lazilyTransformingAstService;
    this.dependencyGraph = dependencyGraph;
    this.columnSearch = columnSearch;
  }
  run() {
    this.stats.start(StatType.TOP_SORT);
    const {
      sorted,
      cycled
    } = this.dependencyGraph.topSortWithScc();
    this.stats.end(StatType.TOP_SORT);
    this.stats.measure(StatType.EVALUATION, () => {
      this.recomputeFormulas(cycled, sorted);
    });
  }
  partialRun(vertices) {
    const changes = ContentChanges.empty();
    this.stats.measure(StatType.EVALUATION, () => {
      this.dependencyGraph.graph.getTopSortedWithSccSubgraphFrom(vertices, (vertex) => this.recomputeVertex(vertex, changes), (vertex) => this.processVertexOnCycle(vertex, changes));
    });
    return changes;
  }
  runAndForget(ast, address, dependencies) {
    const tmpRanges = [];
    for (const dep of absolutizeDependencies(dependencies, address)) {
      if (dep instanceof AbsoluteCellRange) {
        const range = dep;
        if (this.dependencyGraph.getRange(range.start, range.end) === void 0) {
          const rangeVertex = new RangeVertex(range);
          this.dependencyGraph.rangeMapping.addOrUpdateVertex(rangeVertex);
          tmpRanges.push(rangeVertex);
        }
      }
    }
    const ret = this.evaluateAstToCellValue(ast, new InterpreterState(address, this.config.useArrayArithmetic));
    tmpRanges.forEach((rangeVertex) => {
      this.dependencyGraph.rangeMapping.removeVertexIfExists(rangeVertex);
    });
    return ret;
  }
  /**
   * Recalculates the value of a single vertex assuming its dependencies have already been recalculated
   */
  recomputeVertex(vertex, changes) {
    if (vertex instanceof FormulaVertex) {
      const currentValue = vertex.isComputed() ? vertex.getCellValue() : void 0;
      const newCellValue = this.recomputeFormulaVertexValue(vertex);
      if (newCellValue !== currentValue) {
        const address = vertex.getAddress(this.lazilyTransformingAstService);
        changes.addChange(newCellValue, address);
        this.columnSearch.change(getRawValue(currentValue), getRawValue(newCellValue), address);
        return true;
      }
      return false;
    } else if (vertex instanceof RangeVertex) {
      vertex.clearCache();
      return true;
    } else {
      return true;
    }
  }
  /**
   * Processes a vertex that is part of a cycle in dependency graph
   */
  processVertexOnCycle(vertex, changes) {
    if (vertex instanceof RangeVertex) {
      vertex.clearCache();
    } else if (vertex instanceof FormulaVertex) {
      const address = vertex.getAddress(this.lazilyTransformingAstService);
      this.columnSearch.remove(getRawValue(vertex.valueOrUndef()), address);
      const error2 = new CellError(ErrorType.CYCLE, void 0, vertex);
      vertex.setCellValue(error2);
      changes.addChange(error2, address);
    }
  }
  /**
   * Recalculates formulas in the topological sort order
   */
  recomputeFormulas(cycled, sorted) {
    cycled.forEach((vertex) => {
      if (vertex instanceof FormulaVertex) {
        vertex.setCellValue(new CellError(ErrorType.CYCLE, void 0, vertex));
      }
    });
    sorted.forEach((vertex) => {
      if (vertex instanceof FormulaVertex) {
        const newCellValue = this.recomputeFormulaVertexValue(vertex);
        const address = vertex.getAddress(this.lazilyTransformingAstService);
        this.columnSearch.add(getRawValue(newCellValue), address);
      } else if (vertex instanceof RangeVertex) {
        vertex.clearCache();
      }
    });
  }
  recomputeFormulaVertexValue(vertex) {
    const address = vertex.getAddress(this.lazilyTransformingAstService);
    if (vertex instanceof ArrayFormulaVertex && (vertex.array.size.isRef || !this.dependencyGraph.isThereSpaceForArray(vertex))) {
      return vertex.setNoSpace();
    } else {
      const formula = vertex.getFormula(this.lazilyTransformingAstService);
      const newCellValue = this.evaluateAstToCellValue(formula, new InterpreterState(address, this.config.useArrayArithmetic, vertex));
      return vertex.setCellValue(newCellValue);
    }
  }
  evaluateAstToCellValue(ast, state) {
    const interpreterValue = this.interpreter.evaluateAst(ast, state);
    if (interpreterValue instanceof SimpleRangeValue) {
      return interpreterValue;
    } else if (interpreterValue === EmptyValue && this.config.evaluateNullToZero) {
      return 0;
    } else {
      return interpreterValue;
    }
  }
}
class ExportedCellChange {
  constructor(address, newValue) {
    this.address = address;
    this.newValue = newValue;
  }
  get col() {
    return this.address.col;
  }
  get row() {
    return this.address.row;
  }
  get sheet() {
    return this.address.sheet;
  }
  get value() {
    return this.newValue;
  }
}
class ExportedNamedExpressionChange {
  constructor(name, newValue) {
    this.name = name;
    this.newValue = newValue;
  }
}
class Exporter {
  constructor(config, namedExpressions, sheetMapping, lazilyTransformingService) {
    this.config = config;
    this.namedExpressions = namedExpressions;
    this.sheetMapping = sheetMapping;
    this.lazilyTransformingService = lazilyTransformingService;
  }
  exportChange(change) {
    const value = change.value;
    const address = change.address;
    if (address.sheet === NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS) {
      const namedExpression = this.namedExpressions.namedExpressionInAddress(address.row);
      if (!namedExpression) {
        throw new Error("Missing named expression");
      }
      return new ExportedNamedExpressionChange(namedExpression.displayName, this.exportScalarOrRange(value));
    } else if (value instanceof SimpleRangeValue) {
      const result = [];
      for (const [cellValue, cellAddress] of value.entriesFromTopLeftCorner(address)) {
        result.push(new ExportedCellChange(cellAddress, this.exportValue(cellValue)));
      }
      return result;
    } else {
      return new ExportedCellChange(address, this.exportValue(value));
    }
  }
  exportValue(value) {
    if (value instanceof SimpleRangeValue) {
      return this.detailedError(new CellError(ErrorType.VALUE, ErrorMessage.ScalarExpected));
    } else if (this.config.smartRounding && isExtendedNumber(value)) {
      return this.cellValueRounding(getRawValue(value));
    } else if (value instanceof CellError) {
      return this.detailedError(value);
    } else if (value === EmptyValue) {
      return null;
    } else {
      return getRawValue(value);
    }
  }
  exportScalarOrRange(value) {
    if (value instanceof SimpleRangeValue) {
      return value.rawData().map((row) => row.map((v) => this.exportValue(v)));
    } else {
      return this.exportValue(value);
    }
  }
  detailedError(error2) {
    var _a, _b;
    let address = void 0;
    const originAddress = (_a = error2.root) === null || _a === void 0 ? void 0 : _a.getAddress(this.lazilyTransformingService);
    if (originAddress !== void 0) {
      if (originAddress.sheet === NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS) {
        address = (_b = this.namedExpressions.namedExpressionInAddress(originAddress.row)) === null || _b === void 0 ? void 0 : _b.displayName;
      } else {
        address = simpleCellAddressToString(this.sheetMapping.getSheetNameOrThrowError.bind(this.sheetMapping), originAddress, -1);
      }
    }
    return new DetailedCellError(error2, this.config.translationPackage.getErrorTranslation(error2.type), address);
  }
  cellValueRounding(value) {
    if (value === 0) {
      return value;
    }
    const magnitudeMultiplierExponent = Math.floor(Math.log10(Math.abs(value)));
    const placesMultiplier = Math.pow(10, this.config.precisionRounding - magnitudeMultiplierExponent);
    if (value < 0) {
      return -Math.round(-value * placesMultiplier) / placesMultiplier;
    } else {
      return Math.round(value * placesMultiplier) / placesMultiplier;
    }
  }
}
class GraphBuilder {
  /**
   * Configures the building service.
   */
  constructor(dependencyGraph, columnSearch, parser, cellContentParser, stats, arraySizePredictor) {
    this.dependencyGraph = dependencyGraph;
    this.columnSearch = columnSearch;
    this.parser = parser;
    this.cellContentParser = cellContentParser;
    this.stats = stats;
    this.arraySizePredictor = arraySizePredictor;
    this.buildStrategy = new SimpleStrategy(dependencyGraph, columnSearch, parser, stats, cellContentParser, arraySizePredictor);
  }
  /**
   * Builds graph.
   */
  buildGraph(sheets, stats) {
    const dependencies = stats.measure(StatType.COLLECT_DEPENDENCIES, () => this.buildStrategy.run(sheets));
    this.dependencyGraph.getAndClearContentChanges();
    stats.measure(StatType.PROCESS_DEPENDENCIES, () => this.processDependencies(dependencies));
  }
  processDependencies(dependencies) {
    dependencies.forEach((cellDependencies, endVertex) => {
      this.dependencyGraph.processCellDependencies(cellDependencies, endVertex);
    });
  }
}
class SimpleStrategy {
  constructor(dependencyGraph, columnIndex, parser, stats, cellContentParser, arraySizePredictor) {
    this.dependencyGraph = dependencyGraph;
    this.columnIndex = columnIndex;
    this.parser = parser;
    this.stats = stats;
    this.cellContentParser = cellContentParser;
    this.arraySizePredictor = arraySizePredictor;
  }
  run(sheets) {
    const dependencies = /* @__PURE__ */ new Map();
    for (const sheetName in sheets) {
      const sheetId = this.dependencyGraph.getSheetId(sheetName);
      const sheet = sheets[sheetName];
      for (let i = 0; i < sheet.length; ++i) {
        const row = sheet[i];
        for (let j = 0; j < row.length; ++j) {
          const cellContent = row[j];
          const address = simpleCellAddress(sheetId, j, i);
          const parsedCellContent = this.cellContentParser.parse(cellContent);
          if (parsedCellContent instanceof CellContent.Formula) {
            const parseResult = this.stats.measure(StatType.PARSER, () => this.parser.parse(parsedCellContent.formula, address));
            if (parseResult.errors.length > 0) {
              this.shrinkArrayIfNeeded(address);
              const vertex = new ParsingErrorVertex(parseResult.errors, parsedCellContent.formula);
              this.dependencyGraph.addVertex(address, vertex);
            } else {
              this.shrinkArrayIfNeeded(address);
              const size = this.arraySizePredictor.checkArraySize(parseResult.ast, address);
              if (size.isScalar()) {
                const vertex = new ScalarFormulaVertex(parseResult.ast, address, 0);
                dependencies.set(vertex, absolutizeDependencies(parseResult.dependencies, address));
                this.dependencyGraph.addVertex(address, vertex);
                if (parseResult.hasVolatileFunction) {
                  this.dependencyGraph.markAsVolatile(vertex);
                }
                if (parseResult.hasStructuralChangeFunction) {
                  this.dependencyGraph.markAsDependentOnStructureChange(vertex);
                }
              } else {
                const vertex = new ArrayFormulaVertex(parseResult.ast, address, new ArraySize(size.width, size.height));
                dependencies.set(vertex, absolutizeDependencies(parseResult.dependencies, address));
                this.dependencyGraph.addArrayVertex(address, vertex);
              }
            }
          } else if (parsedCellContent instanceof CellContent.Empty) ;
          else {
            this.shrinkArrayIfNeeded(address);
            const vertex = new ValueCellVertex(parsedCellContent.value, cellContent);
            this.columnIndex.add(getRawValue(parsedCellContent.value), address);
            this.dependencyGraph.addVertex(address, vertex);
          }
        }
      }
    }
    return dependencies;
  }
  shrinkArrayIfNeeded(address) {
    const vertex = this.dependencyGraph.getCell(address);
    if (vertex instanceof ArrayFormulaVertex) {
      this.dependencyGraph.shrinkArrayToCorner(vertex);
    }
  }
}
const LICENSE_STATUS_MAP = /* @__PURE__ */ new Map([["gpl-v3", 1], ["missing", 2], ["invalid", 3], ["expired", 4]]);
class VersionPlugin extends FunctionPlugin {
  version(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("VERSION"), () => {
      const {
        licenseKeyValidityState: validityState,
        licenseKey
      } = this.config;
      let status;
      if (LICENSE_STATUS_MAP.has(licenseKey)) {
        status = LICENSE_STATUS_MAP.get(licenseKey);
      } else if (LICENSE_STATUS_MAP.has(validityState)) {
        status = LICENSE_STATUS_MAP.get(validityState);
      } else if (validityState === "valid") {
        status = licenseKey.slice(-5);
      }
      return `HyperFormula v${HyperFormula.version}, ${status}`;
    });
  }
}
VersionPlugin.implementedFunctions = {
  "VERSION": {
    method: "version",
    parameters: []
  }
};
function validateAndReturnMetadataFromName(functionId, plugin) {
  var _a;
  let entry = plugin.implementedFunctions[functionId];
  const key = (_a = plugin.aliases) === null || _a === void 0 ? void 0 : _a[functionId];
  if (key !== void 0) {
    if (entry !== void 0) {
      throw new AliasAlreadyExisting(functionId, plugin.name);
    }
    entry = plugin.implementedFunctions[key];
  }
  if (entry === void 0) {
    throw FunctionPluginValidationError.functionNotDeclaredInPlugin(functionId, plugin.name);
  }
  return entry;
}
class FunctionRegistry {
  constructor(config) {
    this.config = config;
    this.functions = /* @__PURE__ */ new Map();
    this.arraySizeFunctions = /* @__PURE__ */ new Map();
    this.volatileFunctions = /* @__PURE__ */ new Set();
    this.arrayFunctions = /* @__PURE__ */ new Set();
    this.structuralChangeFunctions = /* @__PURE__ */ new Set();
    this.functionsWhichDoesNotNeedArgumentsToBeComputed = /* @__PURE__ */ new Set();
    this.functionsMetadata = /* @__PURE__ */ new Map();
    this.doesFunctionNeedArgumentToBeComputed = (functionId) => this.functionsWhichDoesNotNeedArgumentsToBeComputed.has(functionId);
    this.isFunctionVolatile = (functionId) => this.volatileFunctions.has(functionId);
    this.isArrayFunction = (functionId) => this.arrayFunctions.has(functionId);
    this.isFunctionDependentOnSheetStructureChange = (functionId) => this.structuralChangeFunctions.has(functionId);
    if (config.functionPlugins.length > 0) {
      this.instancePlugins = /* @__PURE__ */ new Map();
      for (const plugin of config.functionPlugins) {
        FunctionRegistry.loadPluginFunctions(plugin, this.instancePlugins);
      }
    } else {
      this.instancePlugins = new Map(FunctionRegistry.plugins);
    }
    for (const [functionId, plugin] of FunctionRegistry.protectedFunctions()) {
      FunctionRegistry.loadFunctionUnprotected(plugin, functionId, this.instancePlugins);
    }
    for (const [functionId, plugin] of this.instancePlugins.entries()) {
      this.categorizeFunction(functionId, validateAndReturnMetadataFromName(functionId, plugin));
    }
  }
  static registerFunctionPlugin(plugin, translations) {
    this.loadPluginFunctions(plugin, this.plugins);
    if (translations !== void 0) {
      this.loadTranslations(translations);
    }
  }
  static registerFunction(functionId, plugin, translations) {
    this.loadPluginFunction(plugin, functionId, this.plugins);
    if (translations !== void 0) {
      this.loadTranslations(translations);
    }
  }
  static unregisterFunction(functionId) {
    if (this.functionIsProtected(functionId)) {
      throw ProtectedFunctionError.cannotUnregisterFunctionWithId(functionId);
    }
    this.plugins.delete(functionId);
  }
  static unregisterFunctionPlugin(plugin) {
    for (const protectedPlugin of this.protectedPlugins()) {
      if (protectedPlugin === plugin) {
        throw ProtectedFunctionError.cannotUnregisterProtectedPlugin();
      }
    }
    for (const [functionId, registeredPlugin] of this.plugins.entries()) {
      if (registeredPlugin === plugin) {
        this.plugins.delete(functionId);
      }
    }
  }
  static unregisterAll() {
    this.plugins.clear();
  }
  static getRegisteredFunctionIds() {
    return [...Array.from(this.plugins.keys()), ...Array.from(this._protectedPlugins.keys())];
  }
  static getPlugins() {
    return Array.from(new Set(this.plugins.values()).values());
  }
  static getFunctionPlugin(functionId) {
    if (this.functionIsProtected(functionId)) {
      return void 0;
    } else {
      return this.plugins.get(functionId);
    }
  }
  static functionIsProtected(functionId) {
    return this._protectedPlugins.has(functionId);
  }
  static loadTranslations(translations) {
    const registeredLanguages = new Set(HyperFormula.getRegisteredLanguagesCodes());
    Object.keys(translations).forEach((code) => {
      if (registeredLanguages.has(code)) {
        HyperFormula.getLanguage(code).extendFunctions(translations[code]);
      }
    });
  }
  static loadPluginFunctions(plugin, registry) {
    Object.keys(plugin.implementedFunctions).forEach((functionName2) => {
      this.loadPluginFunction(plugin, functionName2, registry);
    });
    if (plugin.aliases !== void 0) {
      Object.keys(plugin.aliases).forEach((functionName2) => {
        this.loadPluginFunction(plugin, functionName2, registry);
      });
    }
  }
  static loadPluginFunction(plugin, functionId, registry) {
    if (this.functionIsProtected(functionId)) {
      throw ProtectedFunctionError.cannotRegisterFunctionWithId(functionId);
    } else {
      this.loadFunctionUnprotected(plugin, functionId, registry);
    }
  }
  /**
   * Handles deprecated metadata properties.
   */
  static handleDeprecatedMetadata(functionId, metadata) {
    if (metadata && metadata.arrayFunction !== void 0) {
      console.warn(`${functionId}: 'arrayFunction' parameter is deprecated since 3.1.0; Use 'enableArrayArithmeticForArguments' instead.`);
      metadata.enableArrayArithmeticForArguments = metadata.arrayFunction;
    }
    if (metadata && metadata.arraySizeMethod !== void 0) {
      console.warn(`${functionId}: 'arraySizeMethod' parameter is deprecated since 3.1.0; Use 'sizeOfResultArrayMethod' instead.`);
      metadata.sizeOfResultArrayMethod = metadata.arraySizeMethod;
    }
  }
  /**
   * Loads a function into the registry.
   */
  static loadFunctionUnprotected(plugin, functionId, registry) {
    const metadata = validateAndReturnMetadataFromName(functionId, plugin);
    const methodName = metadata.method;
    this.handleDeprecatedMetadata(functionId, metadata);
    if (Object.prototype.hasOwnProperty.call(plugin.prototype, methodName)) {
      registry.set(functionId, plugin);
    } else {
      throw FunctionPluginValidationError.functionMethodNotFound(methodName, plugin.name);
    }
  }
  static *protectedFunctions() {
    for (const [functionId, plugin] of this._protectedPlugins) {
      if (plugin !== void 0) {
        yield [functionId, plugin];
      }
    }
  }
  static *protectedPlugins() {
    for (const [, plugin] of this._protectedPlugins) {
      if (plugin !== void 0) {
        yield plugin;
      }
    }
  }
  initializePlugins(interpreter) {
    const instances2 = [];
    for (const [functionId, plugin] of this.instancePlugins.entries()) {
      let foundPluginInstance = instances2.find((pluginInstance) => pluginInstance instanceof plugin);
      if (foundPluginInstance === void 0) {
        foundPluginInstance = new plugin(interpreter);
        instances2.push(foundPluginInstance);
      }
      const metadata = validateAndReturnMetadataFromName(functionId, plugin);
      const methodName = metadata.method;
      this.functions.set(functionId, [methodName, foundPluginInstance]);
      const arraySizeMethodName = metadata.sizeOfResultArrayMethod;
      if (arraySizeMethodName !== void 0) {
        this.arraySizeFunctions.set(functionId, [arraySizeMethodName, foundPluginInstance]);
      }
    }
  }
  getFunctionPlugin(functionId) {
    if (FunctionRegistry.functionIsProtected(functionId)) {
      return void 0;
    }
    return this.instancePlugins.get(functionId);
  }
  getFunction(functionId) {
    const pluginEntry = this.functions.get(functionId);
    if (pluginEntry !== void 0 && this.config.translationPackage.isFunctionTranslated(functionId)) {
      const [pluginFunction, pluginInstance] = pluginEntry;
      return (ast, state) => pluginInstance[pluginFunction](ast, state);
    } else {
      return void 0;
    }
  }
  getArraySizeFunction(functionId) {
    const pluginEntry = this.arraySizeFunctions.get(functionId);
    if (pluginEntry !== void 0 && this.config.translationPackage.isFunctionTranslated(functionId)) {
      const [pluginArraySizeFunction, pluginInstance] = pluginEntry;
      return (ast, state) => pluginInstance[pluginArraySizeFunction](ast, state);
    } else {
      return void 0;
    }
  }
  getMetadata(functionId) {
    return this.functionsMetadata.get(functionId);
  }
  getPlugins() {
    const plugins2 = /* @__PURE__ */ new Set();
    for (const [functionId, plugin] of this.instancePlugins) {
      if (!FunctionRegistry.functionIsProtected(functionId)) {
        plugins2.add(plugin);
      }
    }
    return Array.from(plugins2);
  }
  getRegisteredFunctionIds() {
    return Array.from(this.functions.keys());
  }
  categorizeFunction(functionId, functionMetadata) {
    if (functionMetadata.isVolatile) {
      this.volatileFunctions.add(functionId);
    }
    if (functionMetadata.enableArrayArithmeticForArguments) {
      this.arrayFunctions.add(functionId);
    }
    if (functionMetadata.doesNotNeedArgumentsToBeComputed) {
      this.functionsWhichDoesNotNeedArgumentsToBeComputed.add(functionId);
    }
    if (functionMetadata.isDependentOnSheetStructureChange) {
      this.structuralChangeFunctions.add(functionId);
    }
    this.functionsMetadata.set(functionId, functionMetadata);
  }
}
FunctionRegistry.plugins = /* @__PURE__ */ new Map();
FunctionRegistry._protectedPlugins = /* @__PURE__ */ new Map([["VERSION", VersionPlugin], ["OFFSET", void 0]]);
var CriterionType;
(function(CriterionType2) {
  CriterionType2["GREATER_THAN"] = "GREATER_THAN";
  CriterionType2["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
  CriterionType2["LESS_THAN"] = "LESS_THAN";
  CriterionType2["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
  CriterionType2["NOT_EQUAL"] = "NOT_EQUAL";
  CriterionType2["EQUAL"] = "EQUAL";
})(CriterionType || (CriterionType = {}));
const buildCriterion = (operator, value) => ({
  operator,
  value
});
class CriterionBuilder {
  constructor(config) {
    var _a, _b, _c, _d;
    this.trueString = (_b = (_a = config.translationPackage.getMaybeFunctionTranslation("TRUE")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "true";
    this.falseString = (_d = (_c = config.translationPackage.getMaybeFunctionTranslation("FALSE")) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : "false";
  }
  fromCellValue(raw, arithmeticHelper) {
    if (typeof raw !== "string" && typeof raw !== "boolean" && typeof raw !== "number") {
      return void 0;
    }
    const criterion = this.parseCriterion(raw, arithmeticHelper);
    if (criterion === void 0) {
      return void 0;
    }
    return {
      raw,
      lambda: buildCriterionLambda(criterion, arithmeticHelper)
    };
  }
  parseCriterion(criterion, arithmeticHelper) {
    if (typeof criterion === "number" || typeof criterion === "boolean") {
      return buildCriterion(CriterionType.EQUAL, criterion);
    } else if (typeof criterion === "string") {
      const regexResult = ANY_CRITERION_REGEX.exec(criterion);
      let criterionValue;
      let criterionType;
      if (regexResult) {
        criterionType = StrToCriterionType(regexResult[1]);
        criterionValue = regexResult[2];
      } else {
        criterionType = CriterionType.EQUAL;
        criterionValue = criterion;
      }
      const value = arithmeticHelper.coerceToMaybeNumber(criterionValue);
      const boolvalue = criterionValue.toLowerCase() === this.trueString ? true : criterionValue.toLowerCase() === this.falseString ? false : void 0;
      if (criterionType === void 0) {
        return void 0;
      }
      if (criterionValue === "") {
        return buildCriterion(criterionType, null);
      } else if (value === void 0) {
        if (criterionType === CriterionType.EQUAL || criterionType === CriterionType.NOT_EQUAL) {
          return buildCriterion(criterionType, boolvalue !== null && boolvalue !== void 0 ? boolvalue : criterionValue);
        }
      } else {
        return buildCriterion(criterionType, getRawValue(value));
      }
    }
    return void 0;
  }
}
const ANY_CRITERION_REGEX = /([<>=]+)(.*)/;
function StrToCriterionType(str) {
  switch (str) {
    case ">":
      return CriterionType.GREATER_THAN;
    case ">=":
      return CriterionType.GREATER_THAN_OR_EQUAL;
    case "<":
      return CriterionType.LESS_THAN;
    case "<=":
      return CriterionType.LESS_THAN_OR_EQUAL;
    case "<>":
      return CriterionType.NOT_EQUAL;
    case "=":
      return CriterionType.EQUAL;
    default:
      return void 0;
  }
}
const buildCriterionLambda = (criterion, arithmeticHelper) => {
  switch (criterion.operator) {
    case CriterionType.GREATER_THAN: {
      if (typeof criterion.value === "number") {
        return (cellValue) => typeof cellValue === "number" && arithmeticHelper.floatCmp(cellValue, criterion.value) > 0;
      } else {
        return (_cellValue) => false;
      }
    }
    case CriterionType.GREATER_THAN_OR_EQUAL: {
      if (typeof criterion.value === "number") {
        return (cellValue) => typeof cellValue === "number" && arithmeticHelper.floatCmp(cellValue, criterion.value) >= 0;
      } else {
        return (_cellValue) => false;
      }
    }
    case CriterionType.LESS_THAN: {
      if (typeof criterion.value === "number") {
        return (cellValue) => typeof cellValue === "number" && arithmeticHelper.floatCmp(cellValue, criterion.value) < 0;
      } else {
        return (_cellValue) => false;
      }
    }
    case CriterionType.LESS_THAN_OR_EQUAL: {
      if (typeof criterion.value === "number") {
        return (cellValue) => typeof cellValue === "number" && arithmeticHelper.floatCmp(cellValue, criterion.value) <= 0;
      } else {
        return (_cellValue) => false;
      }
    }
    case CriterionType.EQUAL: {
      if (typeof criterion.value === "number") {
        return (cellValue) => {
          if (typeof cellValue === "number") {
            return arithmeticHelper.floatCmp(cellValue, criterion.value) === 0;
          } else if (typeof cellValue === "string") {
            if (cellValue === "") {
              return false;
            }
            const val = arithmeticHelper.coerceToMaybeNumber(cellValue);
            if (val === void 0) {
              return false;
            }
            return arithmeticHelper.floatCmp(val, criterion.value) === 0;
          } else {
            return false;
          }
        };
      } else if (typeof criterion.value === "string") {
        return arithmeticHelper.eqMatcherFunction(criterion.value);
      } else if (typeof criterion.value === "boolean") {
        return (cellValue) => typeof cellValue === "boolean" && cellValue === criterion.value;
      } else {
        return (cellValue) => cellValue === EmptyValue;
      }
    }
    case CriterionType.NOT_EQUAL: {
      if (typeof criterion.value === "number") {
        return (cellValue) => {
          if (typeof cellValue === "number") {
            return arithmeticHelper.floatCmp(cellValue, criterion.value) !== 0;
          } else if (typeof cellValue === "string") {
            if (cellValue === "") {
              return true;
            }
            const val = arithmeticHelper.coerceToMaybeNumber(cellValue);
            if (val === void 0) {
              return true;
            }
            return arithmeticHelper.floatCmp(val, criterion.value) !== 0;
          } else {
            return true;
          }
        };
      } else if (typeof criterion.value === "string") {
        return arithmeticHelper.neqMatcherFunction(criterion.value);
      } else if (typeof criterion.value === "boolean") {
        return (cellValue) => typeof cellValue !== "boolean" || cellValue !== criterion.value;
      } else {
        return (cellValue) => cellValue !== EmptyValue;
      }
    }
  }
};
class Interpreter {
  constructor(config, dependencyGraph, columnSearch, stats, arithmeticHelper, functionRegistry, namedExpressions, serialization, arraySizePredictor, dateTimeHelper) {
    this.config = config;
    this.dependencyGraph = dependencyGraph;
    this.columnSearch = columnSearch;
    this.stats = stats;
    this.arithmeticHelper = arithmeticHelper;
    this.functionRegistry = functionRegistry;
    this.namedExpressions = namedExpressions;
    this.serialization = serialization;
    this.arraySizePredictor = arraySizePredictor;
    this.dateTimeHelper = dateTimeHelper;
    this.equalOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.eq, arg1, arg2);
    this.notEqualOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.neq, arg1, arg2);
    this.greaterThanOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.gt, arg1, arg2);
    this.lessThanOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.lt, arg1, arg2);
    this.greaterThanOrEqualOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.geq, arg1, arg2);
    this.lessThanOrEqualOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.leq, arg1, arg2);
    this.concatOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.concat, coerceScalarToString(arg1), coerceScalarToString(arg2));
    this.plusOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.addWithEpsilon, this.arithmeticHelper.coerceScalarToNumberOrError(arg1), this.arithmeticHelper.coerceScalarToNumberOrError(arg2));
    this.minusOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.subtract, this.arithmeticHelper.coerceScalarToNumberOrError(arg1), this.arithmeticHelper.coerceScalarToNumberOrError(arg2));
    this.timesOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.multiply, this.arithmeticHelper.coerceScalarToNumberOrError(arg1), this.arithmeticHelper.coerceScalarToNumberOrError(arg2));
    this.powerOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.pow, this.arithmeticHelper.coerceScalarToNumberOrError(arg1), this.arithmeticHelper.coerceScalarToNumberOrError(arg2));
    this.divOp = (arg1, arg2) => binaryErrorWrapper(this.arithmeticHelper.divide, this.arithmeticHelper.coerceScalarToNumberOrError(arg1), this.arithmeticHelper.coerceScalarToNumberOrError(arg2));
    this.unaryMinusOp = (arg) => unaryErrorWrapper(this.arithmeticHelper.unaryMinus, this.arithmeticHelper.coerceScalarToNumberOrError(arg));
    this.percentOp = (arg) => unaryErrorWrapper(this.arithmeticHelper.unaryPercent, this.arithmeticHelper.coerceScalarToNumberOrError(arg));
    this.unaryPlusOp = (arg) => this.arithmeticHelper.unaryPlus(arg);
    this.functionRegistry.initializePlugins(this);
    this.criterionBuilder = new CriterionBuilder(config);
  }
  evaluateAst(ast, state) {
    let val = this.evaluateAstWithoutPostprocessing(ast, state);
    if (isExtendedNumber(val)) {
      if (isNumberOverflow(getRawValue(val))) {
        return new CellError(ErrorType.NUM, ErrorMessage.NaN);
      } else {
        val = cloneNumber(val, fixNegativeZero(getRawValue(val)));
      }
    }
    if (val instanceof SimpleRangeValue && val.height() === 1 && val.width() === 1) {
      [[val]] = val.data;
    }
    return wrapperForRootVertex(val, state.formulaVertex);
  }
  /**
   * Calculates cell value from formula abstract syntax tree
   *
   * @param {Ast} ast - abstract syntax tree of formula
   * @param {InterpreterState} state - interpreter state
   */
  evaluateAstWithoutPostprocessing(ast, state) {
    switch (ast.type) {
      case AstNodeType.EMPTY: {
        return EmptyValue;
      }
      case AstNodeType.CELL_REFERENCE: {
        const address = ast.reference.toSimpleCellAddress(state.formulaAddress);
        if (isColOrRowInvalid(address)) {
          return new CellError(ErrorType.REF, ErrorMessage.BadRef);
        }
        if (!this.isSheetValid(ast.reference)) {
          return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
        }
        return this.dependencyGraph.getCellValue(address);
      }
      case AstNodeType.NUMBER:
      case AstNodeType.STRING: {
        return ast.value;
      }
      case AstNodeType.CONCATENATE_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.concatOp, leftResult, rightResult, state);
      }
      case AstNodeType.EQUALS_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.equalOp, leftResult, rightResult, state);
      }
      case AstNodeType.NOT_EQUAL_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.notEqualOp, leftResult, rightResult, state);
      }
      case AstNodeType.GREATER_THAN_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.greaterThanOp, leftResult, rightResult, state);
      }
      case AstNodeType.LESS_THAN_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.lessThanOp, leftResult, rightResult, state);
      }
      case AstNodeType.GREATER_THAN_OR_EQUAL_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.greaterThanOrEqualOp, leftResult, rightResult, state);
      }
      case AstNodeType.LESS_THAN_OR_EQUAL_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.lessThanOrEqualOp, leftResult, rightResult, state);
      }
      case AstNodeType.PLUS_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.plusOp, leftResult, rightResult, state);
      }
      case AstNodeType.MINUS_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.minusOp, leftResult, rightResult, state);
      }
      case AstNodeType.TIMES_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.timesOp, leftResult, rightResult, state);
      }
      case AstNodeType.POWER_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.powerOp, leftResult, rightResult, state);
      }
      case AstNodeType.DIV_OP: {
        const leftResult = this.evaluateAst(ast.left, state);
        const rightResult = this.evaluateAst(ast.right, state);
        return this.binaryRangeWrapper(this.divOp, leftResult, rightResult, state);
      }
      case AstNodeType.PLUS_UNARY_OP: {
        const result = this.evaluateAst(ast.value, state);
        return this.unaryRangeWrapper(this.unaryPlusOp, result, state);
      }
      case AstNodeType.MINUS_UNARY_OP: {
        const result = this.evaluateAst(ast.value, state);
        return this.unaryRangeWrapper(this.unaryMinusOp, result, state);
      }
      case AstNodeType.PERCENT_OP: {
        const result = this.evaluateAst(ast.value, state);
        return this.unaryRangeWrapper(this.percentOp, result, state);
      }
      case AstNodeType.FUNCTION_CALL: {
        if (this.config.licenseKeyValidityState !== "valid" && !FunctionRegistry.functionIsProtected(ast.procedureName)) {
          return new CellError(ErrorType.LIC, ErrorMessage.LicenseKey(this.config.licenseKeyValidityState));
        }
        const pluginFunction = this.functionRegistry.getFunction(ast.procedureName);
        if (pluginFunction !== void 0) {
          return pluginFunction(ast, new InterpreterState(state.formulaAddress, state.arraysFlag || this.functionRegistry.isArrayFunction(ast.procedureName), state.formulaVertex));
        } else {
          return new CellError(ErrorType.NAME, ErrorMessage.FunctionName(ast.procedureName));
        }
      }
      case AstNodeType.NAMED_EXPRESSION: {
        const namedExpression = this.namedExpressions.nearestNamedExpression(ast.expressionName, state.formulaAddress.sheet);
        if (namedExpression) {
          return this.dependencyGraph.getCellValue(namedExpression.address);
        } else {
          return new CellError(ErrorType.NAME, ErrorMessage.NamedExpressionName(ast.expressionName));
        }
      }
      case AstNodeType.CELL_RANGE: {
        if (!this.isSheetValid(ast.start) || !this.isSheetValid(ast.end)) {
          return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
        }
        if (!this.rangeSpansOneSheet(ast)) {
          return new CellError(ErrorType.REF, ErrorMessage.RangeManySheets);
        }
        const range = AbsoluteCellRange.fromCellRange(ast, state.formulaAddress);
        const arrayVertex = this.dependencyGraph.getArray(range);
        if (arrayVertex) {
          const array = arrayVertex.array;
          if (array instanceof NotComputedArray) {
            throw new Error("Array should be already computed");
          } else if (array instanceof CellError) {
            return array;
          } else if (array instanceof ArrayValue) {
            return SimpleRangeValue.fromRange(array.raw(), range, this.dependencyGraph);
          } else {
            throw new Error("Unknown array");
          }
        }
        return SimpleRangeValue.onlyRange(range, this.dependencyGraph);
      }
      case AstNodeType.COLUMN_RANGE: {
        if (!this.isSheetValid(ast.start) || !this.isSheetValid(ast.end)) {
          return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
        }
        if (!this.rangeSpansOneSheet(ast)) {
          return new CellError(ErrorType.REF, ErrorMessage.RangeManySheets);
        }
        const range = AbsoluteColumnRange.fromColumnRange(ast, state.formulaAddress);
        return SimpleRangeValue.onlyRange(range, this.dependencyGraph);
      }
      case AstNodeType.ROW_RANGE: {
        if (!this.isSheetValid(ast.start) || !this.isSheetValid(ast.end)) {
          return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
        }
        if (!this.rangeSpansOneSheet(ast)) {
          return new CellError(ErrorType.REF, ErrorMessage.RangeManySheets);
        }
        const range = AbsoluteRowRange.fromRowRangeAst(ast, state.formulaAddress);
        return SimpleRangeValue.onlyRange(range, this.dependencyGraph);
      }
      case AstNodeType.PARENTHESIS: {
        return this.evaluateAst(ast.expression, state);
      }
      case AstNodeType.ARRAY: {
        let totalWidth = void 0;
        const ret = [];
        for (const astRow of ast.args) {
          let rowHeight = void 0;
          const rowRet = [];
          for (const astIt of astRow) {
            const arr = coerceToRange(this.evaluateAst(astIt, state));
            const height = arr.height();
            if (rowHeight === void 0) {
              rowHeight = height;
              rowRet.push(...arr.data);
            } else if (rowHeight === height) {
              for (let i = 0; i < height; i++) {
                rowRet[i].push(...arr.data[i]);
              }
            } else {
              return new CellError(ErrorType.REF, ErrorMessage.SizeMismatch);
            }
          }
          const width = rowRet[0].length;
          if (totalWidth === void 0) {
            totalWidth = width;
            ret.push(...rowRet);
          } else if (totalWidth === width) {
            ret.push(...rowRet);
          } else {
            return new CellError(ErrorType.REF, ErrorMessage.SizeMismatch);
          }
        }
        return SimpleRangeValue.onlyValues(ret);
      }
      case AstNodeType.ERROR_WITH_RAW_INPUT:
      case AstNodeType.ERROR: {
        return ast.error;
      }
    }
  }
  /**
   * Sheet is valid if:
   * - sheet is undefined OR
   * - sheet is a named expressions store OR
   * - sheet exists in sheet mapping
   * - sheet is not a placeholder
   */
  isSheetValid(address) {
    return address.sheet === void 0 || address.sheet === NamedExpressions.SHEET_FOR_WORKBOOK_EXPRESSIONS || this.dependencyGraph.sheetMapping.hasSheetWithId(address.sheet, {
      includePlaceholders: false
    });
  }
  rangeSpansOneSheet(ast) {
    return ast.start.sheet === ast.end.sheet;
  }
  unaryRangeWrapper(op, arg, state) {
    var _a;
    if (arg instanceof SimpleRangeValue && !state.arraysFlag) {
      arg = (_a = coerceRangeToScalar(arg, state)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.VALUE, ErrorMessage.ScalarExpected);
    }
    if (arg instanceof CellError) {
      return arg;
    }
    if (arg instanceof SimpleRangeValue) {
      const newRaw = arg.data.map((row) => row.map(op));
      return SimpleRangeValue.onlyValues(newRaw);
    }
    return op(arg);
  }
  binaryRangeWrapper(op, arg1, arg2, state) {
    var _a, _b;
    if (arg1 instanceof SimpleRangeValue && !state.arraysFlag) {
      arg1 = (_a = coerceRangeToScalar(arg1, state)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.VALUE, ErrorMessage.ScalarExpected);
    }
    if (arg1 instanceof CellError) {
      return arg1;
    }
    if (arg2 instanceof SimpleRangeValue && !state.arraysFlag) {
      arg2 = (_b = coerceRangeToScalar(arg2, state)) !== null && _b !== void 0 ? _b : new CellError(ErrorType.VALUE, ErrorMessage.ScalarExpected);
    }
    if (arg2 instanceof CellError) {
      return arg2;
    }
    if (arg1 instanceof SimpleRangeValue || arg2 instanceof SimpleRangeValue) {
      if (!(arg1 instanceof SimpleRangeValue)) {
        if (arg2.isAdHoc()) {
          const raw2 = arg2.data;
          for (let i = 0; i < raw2.length; i++) {
            for (let j = 0; j < raw2[0].length; j++) {
              raw2[i][j] = op(arg1, raw2[i][j]);
            }
          }
          return SimpleRangeValue.onlyValues(raw2);
        } else {
          arg1 = SimpleRangeValue.fromScalar(arg1);
        }
      }
      if (!(arg2 instanceof SimpleRangeValue)) {
        if (arg1.isAdHoc()) {
          const raw1 = arg1.data;
          for (let i = 0; i < raw1.length; i++) {
            for (let j = 0; j < raw1[0].length; j++) {
              raw1[i][j] = op(raw1[i][j], arg2);
            }
          }
          return SimpleRangeValue.onlyValues(raw1);
        } else {
          arg2 = SimpleRangeValue.fromScalar(arg2);
        }
      }
      if (arg1.width() === arg2.width() && arg1.height() === arg2.height()) {
        if (arg1.isAdHoc()) {
          const raw1 = arg1.data;
          const raw2 = arg2.data;
          for (let i = 0; i < raw1.length; i++) {
            for (let j = 0; j < raw1[0].length; j++) {
              raw1[i][j] = op(raw1[i][j], raw2[i][j]);
            }
          }
          return SimpleRangeValue.onlyValues(raw1);
        }
        if (arg2.isAdHoc()) {
          const raw1 = arg1.data;
          const raw2 = arg2.data;
          for (let i = 0; i < raw1.length; i++) {
            for (let j = 0; j < raw1[0].length; j++) {
              raw2[i][j] = op(raw1[i][j], raw2[i][j]);
            }
          }
          return SimpleRangeValue.onlyValues(raw2);
        }
      }
      const width = Math.max(arg1.width(), arg2.width());
      const height = Math.max(arg1.height(), arg2.height());
      const ret = Array(height);
      for (let i = 0; i < height; i++) {
        ret[i] = Array(width);
      }
      for (let i = 0; i < height; i++) {
        const i1 = arg1.height() !== 1 ? i : 0;
        const i2 = arg2.height() !== 1 ? i : 0;
        for (let j = 0; j < width; j++) {
          const j1 = arg1.width() !== 1 ? j : 0;
          const j2 = arg2.width() !== 1 ? j : 0;
          if (i1 < arg1.height() && i2 < arg2.height() && j1 < arg1.width() && j2 < arg2.width()) {
            ret[i][j] = op(arg1.data[i1][j1], arg2.data[i2][j2]);
          } else {
            ret[i][j] = new CellError(ErrorType.NA);
          }
        }
      }
      return SimpleRangeValue.onlyValues(ret);
    }
    return op(arg1, arg2);
  }
}
function unaryErrorWrapper(op, arg) {
  if (arg instanceof CellError) {
    return arg;
  } else {
    return op(arg);
  }
}
function binaryErrorWrapper(op, arg1, arg2) {
  if (arg1 instanceof CellError) {
    return arg1;
  } else if (arg2 instanceof CellError) {
    return arg2;
  } else {
    return op(arg1, arg2);
  }
}
function wrapperForRootVertex(val, vertex) {
  if (val instanceof CellError && vertex !== void 0) {
    return val.attachRootVertex(vertex);
  }
  return val;
}
class CombinedTransformer {
  constructor(sheet) {
    this.sheet = sheet;
    this.transformations = [];
  }
  add(transformation) {
    this.transformations.push(transformation);
  }
  performEagerTransformations(graph, parser) {
    this.transformations.forEach((transformation) => transformation.performEagerTransformations(graph, parser));
  }
  transformSingleAst(ast, address) {
    let [transformedAst, transformedAddress] = [ast, address];
    this.transformations.forEach((transformation) => {
      [transformedAst, transformedAddress] = transformation.transformSingleAst(transformedAst, transformedAddress);
    });
    return [transformedAst, transformedAddress];
  }
  isIrreversible() {
    return true;
  }
}
class LazilyTransformingAstService {
  constructor(stats, maxPendingLazyTransformations) {
    this.stats = stats;
    this.maxPendingLazyTransformations = maxPendingLazyTransformations;
    this.transformations = [];
    this.versionOffset = 0;
  }
  version() {
    return this.versionOffset + this.transformations.length;
  }
  addTransformation(transformation) {
    if (this.combinedTransformer !== void 0) {
      this.combinedTransformer.add(transformation);
    } else {
      this.transformations.push(transformation);
    }
    return this.version();
  }
  beginCombinedMode(sheet) {
    this.combinedTransformer = new CombinedTransformer(sheet);
  }
  commitCombinedMode() {
    if (this.combinedTransformer === void 0) {
      throw Error("Combined mode wasn't started");
    }
    this.transformations.push(this.combinedTransformer);
    this.combinedTransformer = void 0;
    return this.version();
  }
  applyTransformations(ast, address, version2) {
    this.stats.start(StatType.TRANSFORM_ASTS_POSTPONED);
    const currentVersion = this.version();
    for (let v = Math.max(version2, this.versionOffset); v < currentVersion; v++) {
      const transformation = this.transformations[v - this.versionOffset];
      if (transformation.isIrreversible()) {
        this.undoRedo.storeDataForVersion(v, address, this.parser.computeHashFromAst(ast));
        this.parser.rememberNewAst(ast);
      }
      const [newAst, newAddress] = transformation.transformSingleAst(ast, address);
      ast = newAst;
      address = newAddress;
    }
    const cachedAst = this.parser.rememberNewAst(ast);
    this.stats.end(StatType.TRANSFORM_ASTS_POSTPONED);
    return [cachedAst, address, currentVersion];
  }
  *getTransformationsFrom(version2, filter2) {
    const currentVersion = this.version();
    for (let v = Math.max(version2, this.versionOffset); v < currentVersion; v++) {
      const transformation = this.transformations[v - this.versionOffset];
      if (!filter2 || filter2(transformation)) {
        yield transformation;
      }
    }
  }
  /**
   * Returns true when enough transformations have accumulated to justify the cost
   * of forcing all consumers (FormulaVertex, ColumnIndex) to apply pending changes.
   */
  needsCompaction() {
    return this.transformations.length >= this.maxPendingLazyTransformations;
  }
  /**
   * Compacts the transformations array by discarding all entries that have already
   * been applied by every consumer. Safe to call only after all FormulaVertex and
   * ColumnIndex consumers have been brought up to the current version.
   * After calling, UndoRedo.cleanupOrphanedOldData() must be invoked to remove
   * oldData entries written during forceApplyPostponedTransformations for
   * already-evicted undo entries.
   */
  compact() {
    this.versionOffset += this.transformations.length;
    this.transformations = [];
  }
}
const NOT_FOUND$1 = -1;
function findLastOccurrenceInOrderedRange(searchKey, range, {
  searchCoordinate,
  orderingDirection,
  ifNoMatch
}, dependencyGraph) {
  const start = range.start[searchCoordinate];
  const end = searchCoordinate === "col" ? range.effectiveEndColumn(dependencyGraph) : range.effectiveEndRow(dependencyGraph);
  const getValueFromIndexFn = searchCoordinate === "col" ? (index2) => getRawValue(dependencyGraph.getCellValue(simpleCellAddress(range.sheet, index2, range.start.row))) : (index2) => getRawValue(dependencyGraph.getCellValue(simpleCellAddress(range.sheet, range.start.col, index2)));
  const compareFn = orderingDirection === "asc" ? (left2, right2) => compare(left2, right2) : (left2, right2) => -compare(left2, right2);
  const foundIndex = findLastMatchingIndex((index2) => compareFn(searchKey, getValueFromIndexFn(index2)) >= 0, start, end);
  const foundValue = getValueFromIndexFn(foundIndex);
  if (foundValue === searchKey) {
    return foundIndex - start;
  }
  if (ifNoMatch === "returnLowerBound") {
    if (foundIndex === NOT_FOUND$1) {
      return orderingDirection === "asc" ? NOT_FOUND$1 : 0;
    }
    if (typeof foundValue !== typeof searchKey) {
      return NOT_FOUND$1;
    }
    if (orderingDirection === "asc") {
      return foundIndex - start;
    }
    const nextIndex = foundIndex + 1;
    return nextIndex <= end ? nextIndex - start : NOT_FOUND$1;
  }
  if (ifNoMatch === "returnUpperBound") {
    if (foundIndex === NOT_FOUND$1) {
      return orderingDirection === "asc" ? 0 : NOT_FOUND$1;
    }
    if (typeof foundValue !== typeof searchKey) {
      return NOT_FOUND$1;
    }
    if (orderingDirection === "desc") {
      return foundIndex - start;
    }
    const nextIndex = foundIndex + 1;
    return nextIndex <= end ? nextIndex - start : NOT_FOUND$1;
  }
  return NOT_FOUND$1;
}
function findLastMatchingIndex(predicate, startRange, endRange) {
  let start = startRange;
  let end = endRange;
  while (start < end) {
    const pivot2 = Math.ceil((start + end) / 2);
    if (predicate(pivot2)) {
      start = pivot2;
    } else {
      end = pivot2 - 1;
    }
  }
  if (start === end && predicate(start)) {
    return start;
  }
  return NOT_FOUND$1;
}
function compare(left2, right2) {
  if (typeof left2 === typeof right2) {
    if (left2 === EmptyValue) {
      return 0;
    }
    return left2 < right2 ? -1 : left2 > right2 ? 1 : 0;
  }
  if (left2 === EmptyValue) {
    return -1;
  }
  if (right2 === EmptyValue) {
    return 1;
  }
  if (right2 instanceof CellError) {
    return -1;
  }
  if (typeof left2 === "number" && typeof right2 === "string") {
    return -1;
  }
  if (typeof left2 === "number" && typeof right2 === "boolean") {
    return -1;
  }
  if (typeof left2 === "string" && typeof right2 === "number") {
    return 1;
  }
  if (typeof left2 === "string" && typeof right2 === "boolean") {
    return -1;
  }
  return 1;
}
const NOT_FOUND = -1;
class AdvancedFind {
  constructor(dependencyGraph) {
    this.dependencyGraph = dependencyGraph;
  }
  advancedFind(keyMatcher, rangeValue, {
    returnOccurrence
  } = {
    returnOccurrence: "first"
  }) {
    const range = rangeValue.range;
    const values2 = range === void 0 ? rangeValue.valuesFromTopLeftCorner() : this.dependencyGraph.computeListOfValuesInRange(range);
    const initialIterationIndex = returnOccurrence === "first" ? 0 : values2.length - 1;
    const iterationCondition = returnOccurrence === "first" ? (i) => i < values2.length : (i) => i >= 0;
    const incrementIndex = returnOccurrence === "first" ? (i) => i + 1 : (i) => i - 1;
    for (let i = initialIterationIndex; iterationCondition(i); i = incrementIndex(i)) {
      if (keyMatcher(getRawValue(values2[i]))) {
        return i;
      }
    }
    return NOT_FOUND;
  }
  basicFind(searchKey, rangeValue, searchCoordinate, {
    ordering,
    ifNoMatch,
    returnOccurrence
  }) {
    const normalizedSearchKey = typeof searchKey === "string" ? forceNormalizeString(searchKey) : searchKey;
    const range = rangeValue.range;
    if (range === void 0) {
      return this.findNormalizedValue(normalizedSearchKey, rangeValue.valuesFromTopLeftCorner(), ifNoMatch, returnOccurrence);
    }
    if (ordering === "none") {
      return this.findNormalizedValue(normalizedSearchKey, this.dependencyGraph.computeListOfValuesInRange(range), ifNoMatch, returnOccurrence);
    }
    return findLastOccurrenceInOrderedRange(normalizedSearchKey, range, {
      searchCoordinate,
      orderingDirection: ordering,
      ifNoMatch
    }, this.dependencyGraph);
  }
  findNormalizedValue(searchKey, searchArray, ifNoMatch = "returnNotFound", returnOccurrence = "first") {
    const normalizedArray = searchArray.map(getRawValue).map((val) => typeof val === "string" ? forceNormalizeString(val) : val);
    if (ifNoMatch === "returnNotFound") {
      return returnOccurrence === "first" ? normalizedArray.indexOf(searchKey) : normalizedArray.lastIndexOf(searchKey);
    }
    const compareFn = ifNoMatch === "returnLowerBound" ? (left2, right2) => compare(left2, right2) : (left2, right2) => -compare(left2, right2);
    let bestValue = ifNoMatch === "returnLowerBound" ? -Infinity : Infinity;
    let bestIndex = NOT_FOUND;
    const initialIterationIndex = returnOccurrence === "first" ? 0 : normalizedArray.length - 1;
    const iterationCondition = returnOccurrence === "first" ? (i) => i < normalizedArray.length : (i) => i >= 0;
    const incrementIndex = returnOccurrence === "first" ? (i) => i + 1 : (i) => i - 1;
    for (let i = initialIterationIndex; iterationCondition(i); i = incrementIndex(i)) {
      const value = normalizedArray[i];
      if (value === searchKey) {
        return i;
      }
      if (compareFn(value, searchKey) > 0) {
        continue;
      }
      if (compareFn(bestValue, value) < 0) {
        bestValue = value;
        bestIndex = i;
      }
    }
    return bestIndex;
  }
}
class ColumnBinarySearch extends AdvancedFind {
  constructor(dependencyGraph) {
    super(dependencyGraph);
    this.dependencyGraph = dependencyGraph;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars 
  add(value, address) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  remove(value, address) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  change(oldValue, newValue, address) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  applyChanges(contentChanges) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addColumns(columnsSpan) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeColumns(columnsSpan) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeSheet(sheetId) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  moveValues(sourceRange, toRight, toBottom, toSheet) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeValues(range) {
  }
  /**
   * No-op: ColumnBinarySearch reads cell values directly from the dependency graph
   * on every lookup, so it has no cached data that could become stale.
   * Unlike ColumnIndex, which maintains a separate value-to-address index that
   * must be kept in sync with lazy transformations, binary search always operates
   * on the current graph state.
   */
  forceApplyPostponedTransformations() {
  }
  /*
   * WARNING: Finding lower/upper bounds in unordered ranges is not supported. When ordering === 'none', assumes matchExactly === true
   */
  find(searchKey, rangeValue, searchOptions) {
    return this.basicFind(searchKey, rangeValue, "row", searchOptions);
  }
}
class ColumnIndex {
  constructor(dependencyGraph, config, stats) {
    this.dependencyGraph = dependencyGraph;
    this.config = config;
    this.stats = stats;
    this.index = /* @__PURE__ */ new Map();
    this.transformingService = this.dependencyGraph.lazilyTransformingAstService;
    this.binarySearchStrategy = new ColumnBinarySearch(dependencyGraph);
  }
  add(value, address) {
    if (value === EmptyValue || value instanceof CellError) {
      return;
    } else if (value instanceof SimpleRangeValue) {
      for (const [arrayValue, cellAddress] of value.entriesFromTopLeftCorner(address)) {
        this.addSingleCellValue(getRawValue(arrayValue), cellAddress);
      }
    } else {
      this.addSingleCellValue(value, address);
    }
  }
  remove(value, address) {
    if (value === void 0) {
      return;
    }
    if (value instanceof SimpleRangeValue) {
      for (const [arrayValue, cellAddress] of value.entriesFromTopLeftCorner(address)) {
        this.removeSingleValue(getRawValue(arrayValue), cellAddress);
      }
    } else {
      this.removeSingleValue(value, address);
    }
  }
  change(oldValue, newValue, address) {
    if (oldValue === newValue) {
      return;
    }
    this.remove(oldValue, address);
    this.add(newValue, address);
  }
  applyChanges(contentChanges) {
    for (const change of contentChanges) {
      if (change.oldValue !== void 0) {
        this.change(getRawValue(change.oldValue), getRawValue(change.value), change.address);
      }
    }
  }
  moveValues(sourceRange, toRight, toBottom, toSheet) {
    for (const [value, address] of sourceRange) {
      const targetAddress = movedSimpleCellAddress(address, toSheet, toRight, toBottom);
      this.remove(value, address);
      this.add(value, targetAddress);
    }
  }
  removeValues(range) {
    for (const [value, address] of range) {
      this.remove(value, address);
    }
  }
  find(searchKey, rangeValue, {
    ordering,
    ifNoMatch,
    returnOccurrence
  }) {
    if (returnOccurrence == null) {
      returnOccurrence = ordering === "none" ? "first" : "last";
    }
    const resultUsingColumnIndex = this.findUsingColumnIndex(searchKey, rangeValue, returnOccurrence);
    return resultUsingColumnIndex !== void 0 ? resultUsingColumnIndex : this.binarySearchStrategy.find(searchKey, rangeValue, {
      ordering,
      ifNoMatch,
      returnOccurrence
    });
  }
  findUsingColumnIndex(key, rangeValue, returnOccurrence) {
    const range = rangeValue.range;
    if (range === void 0) {
      return void 0;
    }
    this.ensureRecentData(range.sheet, range.start.col, key);
    const columnMap = this.getColumnMap(range.sheet, range.start.col);
    if (!columnMap) {
      return -1;
    }
    const normalizedKey = typeof key === "string" ? forceNormalizeString(key) : key;
    const valueIndexForTheKey = columnMap.get(normalizedKey);
    if (!valueIndexForTheKey || !valueIndexForTheKey.index || valueIndexForTheKey.index.length === 0) {
      return void 0;
    }
    const rowNumber = ColumnIndex.findRowBelongingToRange(valueIndexForTheKey, range, returnOccurrence);
    return rowNumber !== void 0 ? rowNumber - range.start.row : void 0;
  }
  static findRowBelongingToRange(valueIndex, range, returnOccurrence) {
    const start = range.start.row;
    const end = range.end.row;
    const positionInIndex = returnOccurrence === "first" ? findInOrderedArray(start, valueIndex.index, "upperBound") : findInOrderedArray(end, valueIndex.index, "lowerBound");
    if (positionInIndex === -1) {
      return void 0;
    }
    const rowNumber = valueIndex.index[positionInIndex];
    const isRowNumberBelongingToRange = rowNumber >= start && rowNumber <= end;
    return isRowNumberBelongingToRange ? rowNumber : void 0;
  }
  advancedFind(keyMatcher, range, options = {
    returnOccurrence: "first"
  }) {
    return this.binarySearchStrategy.advancedFind(keyMatcher, range, options);
  }
  addColumns(columnsSpan) {
    const sheetIndex = this.index.get(columnsSpan.sheet);
    if (!sheetIndex) {
      return;
    }
    sheetIndex.splice(columnsSpan.columnStart, 0, ...Array(columnsSpan.numberOfColumns));
  }
  removeColumns(columnsSpan) {
    const sheetIndex = this.index.get(columnsSpan.sheet);
    if (!sheetIndex) {
      return;
    }
    sheetIndex.splice(columnsSpan.columnStart, columnsSpan.numberOfColumns);
  }
  removeSheet(sheetId) {
    this.index.delete(sheetId);
  }
  /**
   * Forces all ValueIndex entries to apply any pending lazy transformations,
   * bringing every entry up to the current LazilyTransformingAstService version.
   * Must be called before compacting LazilyTransformingAstService.
   */
  forceApplyPostponedTransformations() {
    for (const [sheet, sheetIndex] of this.index) {
      sheetIndex.forEach((columnMap, col) => {
        if (!columnMap) {
          return;
        }
        for (const value of columnMap.keys()) {
          this.ensureRecentData(sheet, col, value);
        }
      });
    }
  }
  getColumnMap(sheet, col) {
    if (!this.index.has(sheet)) {
      this.index.set(sheet, []);
    }
    const sheetMap = this.index.get(sheet);
    let columnMap = sheetMap[col];
    if (!columnMap) {
      columnMap = /* @__PURE__ */ new Map();
      sheetMap[col] = columnMap;
    }
    return columnMap;
  }
  getValueIndex(sheet, col, value) {
    const columnMap = this.getColumnMap(sheet, col);
    let index2 = this.getColumnMap(sheet, col).get(value);
    if (!index2) {
      index2 = {
        version: this.transformingService.version(),
        index: []
      };
      columnMap.set(value, index2);
    }
    return index2;
  }
  ensureRecentData(sheet, col, value) {
    const valueIndex = this.getValueIndex(sheet, col, value);
    const actualVersion = this.transformingService.version();
    if (valueIndex.version === actualVersion) {
      return;
    }
    const relevantTransformations = this.transformingService.getTransformationsFrom(valueIndex.version, (transformation) => {
      return transformation.sheet === sheet && (transformation instanceof AddRowsTransformer || transformation instanceof RemoveRowsTransformer);
    });
    for (const transformation of relevantTransformations) {
      if (transformation instanceof AddRowsTransformer) {
        this.addRows(col, transformation.rowsSpan, value);
      } else if (transformation instanceof RemoveRowsTransformer) {
        this.removeRows(col, transformation.rowsSpan, value);
      }
    }
    valueIndex.version = actualVersion;
  }
  addSingleCellValue(value, address) {
    this.stats.measure(StatType.BUILD_COLUMN_INDEX, () => {
      this.ensureRecentData(address.sheet, address.col, value);
      if (typeof value === "string") {
        value = forceNormalizeString(value);
      }
      const valueIndex = this.getValueIndex(address.sheet, address.col, value);
      ColumnIndex.addValue(valueIndex, address.row);
    });
  }
  removeSingleValue(value, address) {
    this.stats.measure(StatType.BUILD_COLUMN_INDEX, () => {
      this.ensureRecentData(address.sheet, address.col, value);
      const columnMap = this.getColumnMap(address.sheet, address.col);
      if (typeof value === "string") {
        value = forceNormalizeString(value);
      }
      const valueIndex = columnMap.get(value);
      if (!valueIndex) {
        return;
      }
      const positionInIndex = findInOrderedArray(address.row, valueIndex.index);
      if (positionInIndex > -1) {
        valueIndex.index.splice(positionInIndex, 1);
      }
      if (valueIndex.index.length === 0) {
        columnMap.delete(value);
      }
      if (columnMap.size === 0) {
        delete this.index.get(address.sheet)[address.col];
      }
    });
  }
  addRows(col, rowsSpan, value) {
    const valueIndex = this.getValueIndex(rowsSpan.sheet, col, value);
    ColumnIndex.shiftRows(valueIndex, rowsSpan.rowStart, rowsSpan.numberOfRows);
  }
  removeRows(col, rowsSpan, value) {
    const valueIndex = this.getValueIndex(rowsSpan.sheet, col, value);
    ColumnIndex.removeRowsFromValues(valueIndex, rowsSpan);
    ColumnIndex.shiftRows(valueIndex, rowsSpan.rowEnd + 1, -rowsSpan.numberOfRows);
  }
  static addValue(valueIndex, rowNumber) {
    const rowIndex = findInOrderedArray(rowNumber, valueIndex.index, "lowerBound");
    const isRowNumberAlreadyInIndex = valueIndex.index[rowIndex] === rowNumber;
    if (!isRowNumberAlreadyInIndex) {
      valueIndex.index.splice(rowIndex + 1, 0, rowNumber);
    }
  }
  static removeRowsFromValues(valueIndex, rowsSpan) {
    const start = findInOrderedArray(rowsSpan.rowStart, valueIndex.index, "upperBound");
    const end = findInOrderedArray(rowsSpan.rowEnd, valueIndex.index, "lowerBound");
    const isFoundSpanValid = start > -1 && end > -1 && start <= end && valueIndex.index[start] <= rowsSpan.rowEnd;
    if (isFoundSpanValid) {
      valueIndex.index.splice(start, end - start + 1);
    }
  }
  static shiftRows(valueIndex, afterRow, numberOfRows) {
    const positionInIndex = findInOrderedArray(afterRow, valueIndex.index, "upperBound");
    if (positionInIndex === -1) {
      return;
    }
    for (let i = positionInIndex; i < valueIndex.index.length; ++i) {
      valueIndex.index[i] += numberOfRows;
    }
  }
}
function findInOrderedArray(key, values2, handlingMisses = "upperBound") {
  let start = 0;
  let end = values2.length - 1;
  while (start <= end) {
    const center = Math.floor((start + end) / 2);
    if (key > values2[center]) {
      start = center + 1;
    } else if (key < values2[center]) {
      end = center - 1;
    } else {
      return center;
    }
  }
  const foundIndex = handlingMisses === "lowerBound" ? end : start;
  const isIndexInRange = foundIndex >= 0 && foundIndex <= values2.length;
  return isIndexInRange ? foundIndex : -1;
}
function buildColumnSearchStrategy(dependencyGraph, config, statistics) {
  if (config.useColumnIndex) {
    return new ColumnIndex(dependencyGraph, config, statistics);
  } else {
    return new ColumnBinarySearch(dependencyGraph);
  }
}
class NumberLiteralHelper {
  constructor(config) {
    this.config = config;
    const thousandSeparator = this.config.thousandSeparator === "." ? `\\${this.config.thousandSeparator}` : this.config.thousandSeparator;
    const decimalSeparator = this.config.decimalSeparator === "." ? `\\${this.config.decimalSeparator}` : this.config.decimalSeparator;
    this.numberPattern = new RegExp(`^([+-]?((${decimalSeparator}\\d+)|(\\d+(${thousandSeparator}\\d{3,})*(${decimalSeparator}\\d*)?)))([eE][+-]?\\d+)?$`);
    this.allThousandSeparatorsRegex = new RegExp(`${thousandSeparator}`, "g");
  }
  numericStringToMaybeNumber(input) {
    if (this.numberPattern.test(input)) {
      const num = this.numericStringToNumber(input);
      if (isNaN(num)) {
        return void 0;
      }
      return num;
    }
    return void 0;
  }
  numericStringToNumber(input) {
    const normalized = input.replace(this.allThousandSeparatorsRegex, "").replace(this.config.decimalSeparator, ".");
    return Number(normalized);
  }
}
class Serialization {
  constructor(dependencyGraph, unparser, exporter) {
    this.dependencyGraph = dependencyGraph;
    this.unparser = unparser;
    this.exporter = exporter;
  }
  getCellHyperlink(address) {
    const formulaVertex = this.dependencyGraph.getCell(address);
    if (formulaVertex instanceof ScalarFormulaVertex) {
      const formula = formulaVertex.getFormula(this.dependencyGraph.lazilyTransformingAstService);
      if ("HYPERLINK" === formula.procedureName) {
        return formula.hyperlink;
      }
    }
    return void 0;
  }
  getCellFormula(address, targetAddress) {
    const formulaVertex = this.dependencyGraph.getCell(address);
    if (formulaVertex instanceof ScalarFormulaVertex) {
      const formula = formulaVertex.getFormula(this.dependencyGraph.lazilyTransformingAstService);
      targetAddress = targetAddress !== null && targetAddress !== void 0 ? targetAddress : address;
      return this.unparser.unparse(formula, targetAddress);
    } else if (formulaVertex instanceof ArrayFormulaVertex) {
      const arrayVertexAddress = formulaVertex.getAddress(this.dependencyGraph.lazilyTransformingAstService);
      if (arrayVertexAddress.row !== address.row || arrayVertexAddress.col !== address.col || arrayVertexAddress.sheet !== address.sheet) {
        return void 0;
      }
      targetAddress = targetAddress !== null && targetAddress !== void 0 ? targetAddress : address;
      const formula = formulaVertex.getFormula(this.dependencyGraph.lazilyTransformingAstService);
      if (formula !== void 0) {
        return this.unparser.unparse(formula, targetAddress);
      }
    } else if (formulaVertex instanceof ParsingErrorVertex) {
      return formulaVertex.getFormula();
    }
    return void 0;
  }
  getCellSerialized(address, targetAddress) {
    var _a;
    return (_a = this.getCellFormula(address, targetAddress)) !== null && _a !== void 0 ? _a : this.getRawValue(address);
  }
  getCellValue(address) {
    return this.exporter.exportValue(this.dependencyGraph.getScalarValue(address));
  }
  getRawValue(address) {
    return this.dependencyGraph.getRawValue(address);
  }
  getSheetValues(sheet) {
    return this.genericSheetGetter(sheet, (arg) => this.getCellValue(arg));
  }
  getSheetFormulas(sheet) {
    return this.genericSheetGetter(sheet, (arg) => this.getCellFormula(arg));
  }
  genericSheetGetter(sheet, getter) {
    const sheetHeight = this.dependencyGraph.getSheetHeight(sheet);
    const sheetWidth = this.dependencyGraph.getSheetWidth(sheet);
    const arr = new Array(sheetHeight);
    for (let i = 0; i < sheetHeight; i++) {
      arr[i] = new Array(sheetWidth);
      for (let j = 0; j < sheetWidth; j++) {
        const address = simpleCellAddress(sheet, j, i);
        arr[i][j] = getter(address);
      }
      for (let j = sheetWidth - 1; j >= 0; j--) {
        if (arr[i][j] === null || arr[i][j] === void 0) {
          arr[i].pop();
        } else {
          break;
        }
      }
    }
    for (let i = sheetHeight - 1; i >= 0; i--) {
      if (arr[i].length === 0) {
        arr.pop();
      } else {
        break;
      }
    }
    return arr;
  }
  genericAllSheetsGetter(sheetGetter) {
    const result = {};
    for (const sheetName of this.dependencyGraph.sheetMapping.iterateSheetNames()) {
      const sheetId = this.dependencyGraph.sheetMapping.getSheetIdOrThrowError(sheetName);
      result[sheetName] = sheetGetter(sheetId);
    }
    return result;
  }
  getSheetSerialized(sheet) {
    return this.genericSheetGetter(sheet, (arg) => this.getCellSerialized(arg));
  }
  getAllSheetsValues() {
    return this.genericAllSheetsGetter((arg) => this.getSheetValues(arg));
  }
  getAllSheetsFormulas() {
    return this.genericAllSheetsGetter((arg) => this.getSheetFormulas(arg));
  }
  getAllSheetsSerialized() {
    return this.genericAllSheetsGetter((arg) => this.getSheetSerialized(arg));
  }
  getAllNamedExpressionsSerialized() {
    const idMap = [];
    let id = 0;
    for (const sheetName of this.dependencyGraph.sheetMapping.iterateSheetNames()) {
      const sheetId = this.dependencyGraph.sheetMapping.getSheetIdOrThrowError(sheetName);
      idMap[sheetId] = id;
      id++;
    }
    return this.dependencyGraph.namedExpressions.getAllNamedExpressions().map((entry) => {
      return {
        name: entry.expression.displayName,
        expression: this.getCellSerialized(entry.expression.address),
        scope: entry.scope !== void 0 ? idMap[entry.scope] : void 0,
        options: entry.expression.options
      };
    });
  }
  withNewConfig(newConfig, namedExpressions) {
    const newUnparser = new Unparser(newConfig, this.dependencyGraph.sheetMapping, namedExpressions);
    return new Serialization(this.dependencyGraph, newUnparser, this.exporter);
  }
}
class BuildEngineFactory {
  static buildFromSheets(sheets, configInput = {}, namedExpressions = []) {
    const config = new Config(configInput);
    return this.buildEngine(config, sheets, namedExpressions);
  }
  static buildFromSheet(sheet, configInput = {}, namedExpressions = []) {
    const config = new Config(configInput);
    const newsheetprefix = config.translationPackage.getUITranslation(UIElement.NEW_SHEET_PREFIX) + "1";
    return this.buildEngine(config, {
      [newsheetprefix]: sheet
    }, namedExpressions);
  }
  static buildEmpty(configInput = {}, namedExpressions = []) {
    return this.buildEngine(new Config(configInput), {}, namedExpressions);
  }
  static rebuildWithConfig(config, sheets, namedExpressions, stats) {
    return this.buildEngine(config, sheets, namedExpressions, stats);
  }
  static buildEngine(config, sheets = {}, inputNamedExpressions = [], stats = config.useStats ? new Statistics() : new EmptyStatistics()) {
    stats.start(StatType.BUILD_ENGINE_TOTAL);
    const namedExpressions = new NamedExpressions();
    const functionRegistry = new FunctionRegistry(config);
    const lazilyTransformingAstService = new LazilyTransformingAstService(stats, config.maxPendingLazyTransformations);
    const dependencyGraph = DependencyGraph.buildEmpty(lazilyTransformingAstService, config, functionRegistry, namedExpressions, stats);
    const columnSearch = buildColumnSearchStrategy(dependencyGraph, config, stats);
    const sheetMapping = dependencyGraph.sheetMapping;
    const addressMapping = dependencyGraph.addressMapping;
    for (const sheetName in sheets) {
      if (Object.prototype.hasOwnProperty.call(sheets, sheetName)) {
        const sheet = sheets[sheetName];
        validateAsSheet(sheet);
        const boundaries = findBoundaries(sheet);
        if (boundaries.height > config.maxRows || boundaries.width > config.maxColumns) {
          throw new SheetSizeLimitExceededError();
        }
        const sheetId = sheetMapping.addSheet(sheetName);
        addressMapping.addSheetAndSetStrategyBasedOnBoundaries(sheetId, boundaries, {
          throwIfSheetAlreadyExists: true
        });
      }
    }
    const parser = new ParserWithCaching(config, functionRegistry, dependencyGraph.sheetReferenceRegistrar.ensureSheetRegistered.bind(dependencyGraph.sheetReferenceRegistrar));
    lazilyTransformingAstService.parser = parser;
    const unparser = new Unparser(config, sheetMapping, namedExpressions);
    const dateTimeHelper = new DateTimeHelper(config);
    const numberLiteralHelper = new NumberLiteralHelper(config);
    const arithmeticHelper = new ArithmeticHelper(config, dateTimeHelper, numberLiteralHelper);
    const cellContentParser = new CellContentParser(config, dateTimeHelper, numberLiteralHelper);
    const arraySizePredictor = new ArraySizePredictor(config, functionRegistry);
    const operations2 = new Operations(config, dependencyGraph, columnSearch, cellContentParser, parser, stats, lazilyTransformingAstService, namedExpressions, arraySizePredictor);
    const undoRedo = new UndoRedo$1(config, operations2);
    lazilyTransformingAstService.undoRedo = undoRedo;
    const clipboardOperations = new ClipboardOperations(config, dependencyGraph, operations2);
    const crudOperations = new CrudOperations(config, operations2, undoRedo, clipboardOperations, dependencyGraph, columnSearch, parser, cellContentParser, lazilyTransformingAstService, namedExpressions);
    const exporter = new Exporter(config, namedExpressions, sheetMapping, lazilyTransformingAstService);
    const serialization = new Serialization(dependencyGraph, unparser, exporter);
    const interpreter = new Interpreter(config, dependencyGraph, columnSearch, stats, arithmeticHelper, functionRegistry, namedExpressions, serialization, arraySizePredictor, dateTimeHelper);
    stats.measure(StatType.GRAPH_BUILD, () => {
      const graphBuilder = new GraphBuilder(dependencyGraph, columnSearch, parser, cellContentParser, stats, arraySizePredictor);
      graphBuilder.buildGraph(sheets, stats);
    });
    inputNamedExpressions.forEach((entry) => {
      crudOperations.ensureItIsPossibleToAddNamedExpression(entry.name, entry.expression, entry.scope);
      crudOperations.operations.addNamedExpression(entry.name, entry.expression, entry.scope, entry.options);
    });
    const evaluator = new Evaluator(config, stats, interpreter, lazilyTransformingAstService, dependencyGraph, columnSearch);
    evaluator.run();
    stats.end(StatType.BUILD_ENGINE_TOTAL);
    return {
      config,
      stats,
      dependencyGraph,
      columnSearch,
      parser,
      unparser,
      cellContentParser,
      evaluator,
      lazilyTransformingAstService,
      crudOperations,
      exporter,
      namedExpressions,
      serialization,
      functionRegistry
    };
  }
}
function objectDestroy(object) {
  for (const [key, value] of Object.entries(object)) {
    if (value instanceof Function) {
      object[key] = postMortem(value);
    } else {
      delete object[key];
    }
  }
}
function postMortem(method) {
  return () => {
    throw new Error(`The "${method}" method cannot be called because this HyperFormula instance has been destroyed`);
  };
}
var tinyEmitter = { exports: {} };
var hasRequiredTinyEmitter;
function requireTinyEmitter() {
  if (hasRequiredTinyEmitter) return tinyEmitter.exports;
  hasRequiredTinyEmitter = 1;
  function E() {
  }
  E.prototype = {
    on: function(name, callback, ctx) {
      var e = this.e || (this.e = {});
      (e[name] || (e[name] = [])).push({
        fn: callback,
        ctx
      });
      return this;
    },
    once: function(name, callback, ctx) {
      var self2 = this;
      function listener() {
        self2.off(name, listener);
        callback.apply(ctx, arguments);
      }
      listener._ = callback;
      return this.on(name, listener, ctx);
    },
    emit: function(name) {
      var data = [].slice.call(arguments, 1);
      var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
      var i = 0;
      var len = evtArr.length;
      for (i; i < len; i++) {
        evtArr[i].fn.apply(evtArr[i].ctx, data);
      }
      return this;
    },
    off: function(name, callback) {
      var e = this.e || (this.e = {});
      var evts = e[name];
      var liveEvents = [];
      if (evts && callback) {
        for (var i = 0, len = evts.length; i < len; i++) {
          if (evts[i].fn !== callback && evts[i].fn._ !== callback)
            liveEvents.push(evts[i]);
        }
      }
      liveEvents.length ? e[name] = liveEvents : delete e[name];
      return this;
    }
  };
  tinyEmitter.exports = E;
  tinyEmitter.exports.TinyEmitter = E;
  return tinyEmitter.exports;
}
var tinyEmitterExports = requireTinyEmitter();
var Events;
(function(Events2) {
  Events2["SheetAdded"] = "sheetAdded";
  Events2["SheetRemoved"] = "sheetRemoved";
  Events2["SheetRenamed"] = "sheetRenamed";
  Events2["NamedExpressionAdded"] = "namedExpressionAdded";
  Events2["NamedExpressionRemoved"] = "namedExpressionRemoved";
  Events2["ValuesUpdated"] = "valuesUpdated";
  Events2["EvaluationSuspended"] = "evaluationSuspended";
  Events2["EvaluationResumed"] = "evaluationResumed";
})(Events || (Events = {}));
class Emitter extends tinyEmitterExports.TinyEmitter {
  emit(event, ...args) {
    super.emit(event, ...args);
    return this;
  }
}
class HyperFormula {
  /**
   * Constructor
   *
   * @internal
   */
  constructor(_config2, _stats, _dependencyGraph, _columnSearch, _parser, _unparser, _cellContentParser, _evaluator, _lazilyTransformingAstService, _crudOperations, _exporter, _namedExpressions, _serialization, _functionRegistry) {
    this._config = _config2;
    this._stats = _stats;
    this._dependencyGraph = _dependencyGraph;
    this._columnSearch = _columnSearch;
    this._parser = _parser;
    this._unparser = _unparser;
    this._cellContentParser = _cellContentParser;
    this._evaluator = _evaluator;
    this._lazilyTransformingAstService = _lazilyTransformingAstService;
    this._crudOperations = _crudOperations;
    this._exporter = _exporter;
    this._namedExpressions = _namedExpressions;
    this._serialization = _serialization;
    this._functionRegistry = _functionRegistry;
    this._emitter = new Emitter();
    this._evaluationSuspended = false;
  }
  /**
   * Returns all of HyperFormula's default [configuration options](/guide/configuration-options.md).
   *
   * @example
   * ```js
   * // returns all default configuration options
   * const defaultConfig = HyperFormula.defaultConfig;
   * ```
   *
   * @category Static Accessors
   */
  static get defaultConfig() {
    return getDefaultConfig();
  }
  /**
   * Calls the `graph` method on the dependency graph.
   * Allows for executing `graph` directly, without a need to refer to `dependencyGraph`.
   *
   * @internal
   */
  get graph() {
    return this.dependencyGraph.graph;
  }
  /**
   * Calls the `rangeMapping` method on the dependency graph.
   * Allows for executing `rangeMapping` directly, without a need to refer to `dependencyGraph`.
   *
   * @internal
   */
  get rangeMapping() {
    return this.dependencyGraph.rangeMapping;
  }
  /**
   * Calls the `arrayMapping` method on the dependency graph.
   * Allows for executing `arrayMapping` directly, without a need to refer to `dependencyGraph`.
   *
   * @internal
   */
  get arrayMapping() {
    return this.dependencyGraph.arrayMapping;
  }
  /**
   * Calls the `sheetMapping` method on the dependency graph.
   * Allows for executing `sheetMapping` directly, without a need to refer to `dependencyGraph`.
   *
   * @internal
   */
  get sheetMapping() {
    return this.dependencyGraph.sheetMapping;
  }
  /**
   * Calls the `addressMapping` method on the dependency graph.
   * Allows for executing `addressMapping` directly, without a need to refer to `dependencyGraph`.
   *
   * @internal
   */
  get addressMapping() {
    return this.dependencyGraph.addressMapping;
  }
  /** @internal */
  get dependencyGraph() {
    return this._dependencyGraph;
  }
  /** @internal */
  get evaluator() {
    return this._evaluator;
  }
  /** @internal */
  get columnSearch() {
    return this._columnSearch;
  }
  /** @internal */
  get lazilyTransformingAstService() {
    return this._lazilyTransformingAstService;
  }
  /**
   * Returns state of the validity of the license key.
   *
   * @internal
   */
  get licenseKeyValidityState() {
    return this._config.licenseKeyValidityState;
  }
  /**
   * Builds the engine for a sheet from a two-dimensional array representation.
   * The engine is created with a single sheet.
   * Can be configured with the optional second parameter that represents a [[ConfigParams]].
   * If not specified, the engine will be built with the default configuration.
   *
   * @param {Sheet} sheet - two-dimensional array representation of sheet
   * @param {Partial<ConfigParams>} configInput - engine configuration
   * @param {SerializedNamedExpression[]} namedExpressions - starting named expressions
   *
   * @throws [[SheetSizeLimitExceededError]] when sheet size exceeds the limits
   * @throws [[InvalidArgumentsError]] when sheet is not an array of arrays
   * @throws [[FunctionPluginValidationError]] when plugin class definition is not consistent with metadata
   *
   * @example
   * ```js
   * // data represented as an array
   * const sheetData = [
   *  ['0', '=SUM(1, 2, 3)', '52'],
   *  ['=SUM(A1:C1)', '', '=A1'],
   *  ['2', '=SUM(A1:C1)', '=theUltimateQuestionOfLife'],
   * ];
   *
   * const namedExpressions = [
   *  {
   *    name: 'theUltimateQuestionOfLife',
   *    expression: '=42',
   *  },
   * ];
   *
   * // method with optional config parameter maxColumns
   * const hfInstance = HyperFormula.buildFromArray(sheetData, { maxColumns: 1000 }, namedExpressions);
   * ```
   *
   * @category Factories
   */
  static buildFromArray(sheet, configInput = {}, namedExpressions = []) {
    return this.buildFromEngineState(BuildEngineFactory.buildFromSheet(sheet, configInput, namedExpressions));
  }
  /**
   * Builds the engine from an object containing multiple sheets with names.
   * The engine is created with one or more sheets.
   * Can be configured with the optional second parameter that represents a [[ConfigParams]].
   * If not specified the engine will be built with the default configuration.
   *
   * @param {Sheet} sheets - object with sheets definition
   * @param {Partial<ConfigParams>} configInput - engine configuration
   * @param {SerializedNamedExpression[]} namedExpressions - starting named expressions
   *
   * @throws [[SheetSizeLimitExceededError]] when sheet size exceeds the limits
   * @throws [[InvalidArgumentsError]] when any sheet is not an array of arrays
   * @throws [[FunctionPluginValidationError]] when plugin class definition is not consistent with metadata
   *
   * @example
   * ```js
   * // data represented as an object with sheets: Sheet1 and Sheet2
   * const sheetData = {
   *  'Sheet1': [
   *    ['1', '', '=Sheet2!$A1'],
   *    ['', '2', '=SUM(1, 2, 3)'],
   *    ['=Sheet2!$A2', '2', ''],
   *   ],
   *  'Sheet2': [
   *    ['', '4', '=Sheet1!$B1'],
   *    ['', '8', '=SUM(9, 3, 3)'],
   *    ['=Sheet1!$B1', '2', '=theUltimateQuestionOfLife'],
   *   ],
   * };
   *
   * const namedExpressions = [
   *  {
   *    name: 'theUltimateQuestionOfLife',
   *    expression: '=42',
   *  },
   * ];
   *
   * // method with optional config parameter useColumnIndex
   * const hfInstance = HyperFormula.buildFromSheets(sheetData, { useColumnIndex: true }, namedExpressions);
   * ```
   *
   * @category Factories
   */
  static buildFromSheets(sheets, configInput = {}, namedExpressions = []) {
    return this.buildFromEngineState(BuildEngineFactory.buildFromSheets(sheets, configInput, namedExpressions));
  }
  /**
   * Builds an empty engine instance.
   * Can be configured with the optional parameter that represents a [[ConfigParams]].
   * If not specified the engine will be built with the default configuration.
   *
   * @param {Partial<ConfigParams>} configInput - engine configuration
   * @param {SerializedNamedExpression[]} namedExpressions - starting named expressions
   *
   * @example
   * ```js
   * const namedExpressions = [
   *  {
   *    name: 'theUltimateQuestionOfLife',
   *    expression: '=42',
   *  },
   * ];
   *
   * // build with no initial data and with optional config parameter maxColumns
   * const hfInstance = HyperFormula.buildEmpty({ maxColumns: 1000 }, namedExpressions);
   * ```
   *
   * @category Factories
   */
  static buildEmpty(configInput = {}, namedExpressions = []) {
    return this.buildFromEngineState(BuildEngineFactory.buildEmpty(configInput, namedExpressions));
  }
  /**
   * Returns registered language from its code string.
   *
   * For more information, see the [Localizing functions guide](/guide/localizing-functions.md).
   *
   * @param {string} languageCode - code string of the translation package
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[LanguageNotRegisteredError]] when trying to retrieve not registered language
   *
   * @example
   * ```js
   * // return registered language
   * const language = HyperFormula.getLanguage('enGB');
   * ```
   *
   * @category Static Methods
   */
  static getLanguage(languageCode) {
    validateArgToType(languageCode, "string", "languageCode");
    const val = this.registeredLanguages.get(languageCode);
    if (val === void 0) {
      throw new LanguageNotRegisteredError();
    } else {
      return val;
    }
  }
  /**
   * Registers language under given code string.
   *
   * For more information, see the [Localizing functions guide](/guide/localizing-functions.md).
   *
   * @param {string} languageCode - code string of the translation package
   * @param {RawTranslationPackage} languagePackage - translation package to be registered
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[ProtectedFunctionTranslationError]] when trying to register translation for protected function
   * @throws [[LanguageAlreadyRegisteredError]] when given language is already registered
   *
   * @example
   * ```js
   * // return registered language
   * HyperFormula.registerLanguage('enUS', enUS);
   * const engine = HyperFormula.buildEmpty({language: 'enUS'});
   * ```
   *
   * @category Static Methods
   */
  static registerLanguage(languageCode, languagePackage) {
    validateArgToType(languageCode, "string", "languageCode");
    if (this.registeredLanguages.has(languageCode)) {
      throw new LanguageAlreadyRegisteredError();
    } else {
      this.registeredLanguages.set(languageCode, buildTranslationPackage(languagePackage));
    }
  }
  /**
   * Unregisters language that is registered under given code string.
   *
   * For more information, see the [Localizing functions guide](/guide/localizing-functions.md).
   *
   * @param {string} languageCode - code string of the translation package
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[LanguageNotRegisteredError]] when given language is not registered
   *
   * @example
   * ```js
   * // register the language for the instance
   * HyperFormula.registerLanguage('plPL', plPL);
   *
   * // unregister plPL
   * HyperFormula.unregisterLanguage('plPL');
   * ```
   *
   * @category Static Methods
   */
  static unregisterLanguage(languageCode) {
    validateArgToType(languageCode, "string", "languageCode");
    if (this.registeredLanguages.has(languageCode)) {
      this.registeredLanguages.delete(languageCode);
    } else {
      throw new LanguageNotRegisteredError();
    }
  }
  /**
   * Returns all registered languages codes.
   *
   * @example
   * ```js
   * // should return all registered language codes: ['enGB', 'plPL']
   * const registeredLanguages = HyperFormula.getRegisteredLanguagesCodes();
   * ```
   *
   * @category Static Methods
   */
  static getRegisteredLanguagesCodes() {
    return Array.from(this.registeredLanguages.keys());
  }
  /**
   * Registers all functions in a given plugin with optional translations.
   *
   * For more information, see the [Custom functions guide](/guide/custom-functions.md).
   *
   * Note: FunctionPlugins must be registered prior to the creation of HyperFormula instances in which they are used.
   * HyperFormula instances created prior to the registration of a FunctionPlugin are unable to access the FunctionPlugin.
   * Registering a FunctionPlugin with [[custom-functions]] requires the translations parameter.
   *
   * @param {FunctionPluginDefinition} plugin - plugin class
   * @param {FunctionTranslationsPackage} translations - optional package of function names translations
   *
   * @throws [[FunctionPluginValidationError]] when plugin class definition is not consistent with metadata
   * @throws [[ProtectedFunctionTranslationError]] when trying to register translation for protected function
   *
   * @example
   * ```js
   * // import your own plugin
   * import { MyExamplePlugin } from './file_with_your_plugin';
   *
   * // register the plugin
   * HyperFormula.registerFunctionPlugin(MyExamplePlugin);
   * ```
   *
   * @category Static Methods
   */
  static registerFunctionPlugin(plugin, translations) {
    FunctionRegistry.registerFunctionPlugin(plugin, translations);
  }
  /**
   * Unregisters all functions defined in given plugin.
   *
   * For more information, see the [Custom functions guide](/guide/custom-functions.md).
   *
   * Note: This method does not affect the existing HyperFormula instances.
   *
   * @param {FunctionPluginDefinition} plugin - plugin class
   *
   * @example
   * ```js
   * // get the class of a plugin
   * const registeredPluginClass = HyperFormula.getFunctionPlugin('EXAMPLE');
   *
   * // unregister all functions defined in a plugin of ID 'EXAMPLE'
   * HyperFormula.unregisterFunctionPlugin(registeredPluginClass);
   * ```
   *
   * @category Static Methods
   */
  static unregisterFunctionPlugin(plugin) {
    FunctionRegistry.unregisterFunctionPlugin(plugin);
  }
  /**
   * Registers a function with a given id if such exists in a plugin.
   *
   * For more information, see the [Custom functions guide](/guide/custom-functions.md).
   *
   * Note: This method does not affect the existing HyperFormula instances.
   *
   * @param {string} functionId - function id, e.g., 'SUMIF'
   * @param {FunctionPluginDefinition} plugin - plugin class
   * @param {FunctionTranslationsPackage} translations - translations for the function name
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[FunctionPluginValidationError]] when function with a given id does not exist in plugin or plugin class definition is not consistent with metadata
   * @throws [[ProtectedFunctionTranslationError]] when trying to register translation for protected function
   *
   * @example
   * ```js
   * // import your own plugin
   * import { MyExamplePlugin } from './file_with_your_plugin';
   *
   * // register a function
   * HyperFormula.registerFunction('EXAMPLE', MyExamplePlugin);
   * ```
   *
   * @category Static Methods
   */
  static registerFunction(functionId, plugin, translations) {
    validateArgToType(functionId, "string", "functionId");
    FunctionRegistry.registerFunction(functionId, plugin, translations);
  }
  /**
   * Unregisters a function with a given id.
   *
   * For more information, see the [Custom functions guide](/guide/custom-functions.md).
   *
   * Note: This method does not affect the existing HyperFormula instances.
   *
   * @param {string} functionId - function id, e.g., 'SUMIF'
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * // import your own plugin
   * import { MyExamplePlugin } from './file_with_your_plugin';
   *
   * // register a function
   * HyperFormula.registerFunction('EXAMPLE', MyExamplePlugin);
   *
   * // unregister a function
   * HyperFormula.unregisterFunction('EXAMPLE');
   * ```
   *
   * @category Static Methods
   */
  static unregisterFunction(functionId) {
    validateArgToType(functionId, "string", "functionId");
    FunctionRegistry.unregisterFunction(functionId);
  }
  /**
   * Clears function registry.
   *
   * Note: This method does not affect the existing HyperFormula instances.
   *
   * @example
   * ```js
   * HyperFormula.unregisterAllFunctions();
   * ```
   *
   * @category Static Methods
   */
  static unregisterAllFunctions() {
    FunctionRegistry.unregisterAll();
  }
  /**
   * Returns translated names of all registered functions for a given language
   *
   * @param {string} code - language code
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * // return a list of function names registered for enGB
   * const allNames = HyperFormula.getRegisteredFunctionNames('enGB');
   * ```
   *
   * @category Static Methods
   */
  static getRegisteredFunctionNames(code) {
    validateArgToType(code, "string", "code");
    const functionIds = FunctionRegistry.getRegisteredFunctionIds();
    const language = this.getLanguage(code);
    return language.getFunctionTranslations(functionIds);
  }
  /**
   * Returns class of a plugin used by function with given id
   *
   * For more information, see the [Custom functions guide](/guide/custom-functions.md).
   *
   * @param {string} functionId - id of a function, e.g., 'SUMIF'
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * // import your own plugin
   * import { MyExamplePlugin } from './file_with_your_plugin';
   *
   * // register a plugin
   * HyperFormula.registerFunctionPlugin(MyExamplePlugin);
   *
   * // return the class of a given plugin
   * const myFunctionClass = HyperFormula.getFunctionPlugin('EXAMPLE');
   * ```
   *
   * @category Static Methods
   */
  static getFunctionPlugin(functionId) {
    validateArgToType(functionId, "string", "functionId");
    return FunctionRegistry.getFunctionPlugin(functionId);
  }
  /**
   * Returns classes of all plugins registered in HyperFormula.
   *
   * @example
   * ```js
   * // return classes of all plugins
   * const allClasses = HyperFormula.getAllFunctionPlugins();
   * ```
   *
   * @category Static Methods
   */
  static getAllFunctionPlugins() {
    return FunctionRegistry.getPlugins();
  }
  /**
   * @internal
   */
  static buildFromEngineState(engine) {
    return new HyperFormula(engine.config, engine.stats, engine.dependencyGraph, engine.columnSearch, engine.parser, engine.unparser, engine.cellContentParser, engine.evaluator, engine.lazilyTransformingAstService, engine.crudOperations, engine.exporter, engine.namedExpressions, engine.serialization, engine.functionRegistry);
  }
  /**
   * Returns the cell value of a given address.
   * Applies rounding and post-processing.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[ExpectedValueOfTypeError]] when cellAddress is of incorrect type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2, 3)', '2'],
   * ]);
   *
   * // get value of A1 cell, should be '6'
   * const A1Value = hfInstance.getCellValue({ sheet: 0, col: 0, row: 0 });
   *
   * // get value of B1 cell, should be '2'
   * const B1Value = hfInstance.getCellValue({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellValue(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getCellValue(cellAddress);
  }
  /**
   * Returns a normalized formula string from the cell of a given address or `undefined` for an address that does not exist and empty values.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] when cellAddress is of incorrect type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2, 3)', '0'],
   * ]);
   *
   * // should return a normalized A1 cell formula: '=SUM(1, 2, 3)'
   * const A1Formula = hfInstance.getCellFormula({ sheet: 0, col: 0, row: 0 });
   *
   * // should return a normalized B1 cell formula: 'undefined'
   * const B1Formula = hfInstance.getCellFormula({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellFormula(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    return this._serialization.getCellFormula(cellAddress);
  }
  /**
   * Returns the `HYPERLINK` url for a cell of a given address or `undefined` for an address that does not exist or a cell that is not `HYPERLINK`
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] when cellAddress is of incorrect type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=HYPERLINK("https://hyperformula.handsontable.com/", "HyperFormula")', '0'],
   * ]);
   *
   * // should return url of 'HYPERLINK': https://hyperformula.handsontable.com/
   * const A1Hyperlink = hfInstance.getCellHyperlink({ sheet: 0, col: 0, row: 0 });
   *
   * // should return 'undefined' for a cell that is not 'HYPERLINK'
   * const B1Hyperlink = hfInstance.getCellHyperlink({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellHyperlink(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getCellHyperlink(cellAddress);
  }
  /**
   * Returns [[RawCellContent]] with a serialized content of the cell of a given address: either a cell formula, an explicit value, or an error.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[ExpectedValueOfTypeError]] when cellAddress is of incorrect type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2, 3)', '0'],
   * ]);
   *
   * // should return serialized content of A1 cell: '=SUM(1, 2, 3)'
   * const cellA1Serialized = hfInstance.getCellSerialized({ sheet: 0, col: 0, row: 0 });
   *
   * // should return serialized content of B1 cell: '0'
   * const cellB1Serialized = hfInstance.getCellSerialized({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellSerialized(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getCellSerialized(cellAddress);
  }
  /**
   * Returns an array of arrays of [[CellValue]] with values of all cells from [[Sheet]].
   * Applies rounding and post-processing.
   *
   * @param {number} sheetId - sheet ID number
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['0', '=SUM(1, 2, 3)', '=A1'],
   *  ['1', '=TEXT(A2, "0.0%")', '=C1'],
   *  ['2', '=SUM(A1:C1)', '=C1'],
   * ]);
   *
   * // should return all values of a sheet: [[0, 6, 0], [1, '1.0%', 0], [2, 6, 0]]
   * const sheetValues = hfInstance.getSheetValues(0);
   * ```
   *
   * @category Sheets
   */
  getSheetValues(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getSheetValues(sheetId);
  }
  /**
   * Returns an array with normalized formula strings from [[Sheet]] or `undefined` for a cells that have no value.
   *
   * @param {SimpleCellAddress} sheetId - sheet ID number
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['0', '=SUM(1, 2, 3)', '=A1'],
   *  ['1', '=TEXT(A2, "0.0%")', '=C1'],
   *  ['2', '=SUM(A1:C1)', '=C1'],
   * ]);
   *
   * // should return all formulas of a sheet:
   * // [
   * //  [undefined, '=SUM(1, 2, 3)', '=A1'],
   * //  [undefined, '=TEXT(A2, "0.0%")', '=C1'],
   * //  [undefined, '=SUM(A1:C1)', '=C1'],
   * // ];
   * const sheetFormulas = hfInstance.getSheetFormulas(0);
   * ```
   *
   * @category Sheets
   */
  getSheetFormulas(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    return this._serialization.getSheetFormulas(sheetId);
  }
  /**
   * Returns an array of arrays of [[RawCellContent]] with serialized content of cells from [[Sheet]], either a cell formula or an explicit value.
   *
   * @param {SimpleCellAddress} sheetId - sheet ID number
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['0', '=SUM(1, 2, 3)', '=A1'],
   *  ['1', '=TEXT(A2, "0.0%")', '=C1'],
   *  ['2', '=SUM(A1:C1)', '=C1'],
   * ]);
   *
   * // should return:
   * // [
   * //  ['0', '=SUM(1, 2, 3)', '=A1'],
   * //  ['1', '=TEXT(A2, "0.0%")', '=C1'],
   * //  ['2', '=SUM(A1:C1)', '=C1'],
   * // ];
   * const serializedContent = hfInstance.getSheetSerialized(0);
   * ```
   *
   * @category Sheets
   */
  getSheetSerialized(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getSheetSerialized(sheetId);
  }
  /**
   * Returns a map containing dimensions of all sheets for the engine instance represented as a key-value pairs where keys are sheet IDs and dimensions are returned as numbers, width and height respectively.
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *   Sheet1: [
   *    ['1', '2', '=Sheet2!$A1'],
   *   ],
   *   Sheet2: [
   *    ['3'],
   *    ['4'],
   *   ],
   * });
   *
   * // should return the dimensions of all sheets:
   * // { Sheet1: { width: 3, height: 1 }, Sheet2: { width: 1, height: 2 } }
   * const allSheetsDimensions = hfInstance.getAllSheetsDimensions();
   * ```
   *
   * @category Sheets
   */
  getAllSheetsDimensions() {
    return this._serialization.genericAllSheetsGetter((arg) => this.getSheetDimensions(arg));
  }
  /**
   * Returns dimensions of a specified sheet.
   * The sheet dimensions is represented with numbers: width and height.
   *
   * Note: Due to the memory optimizations, some of the empty bottom rows and rightmost columns are not counted to the dimensions.
   *
   * @param {number} sheetId - sheet ID number
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *    ['1', '2', '=Sheet2!$A1'],
   * ]);
   *
   * // should return provided sheet's dimensions: { width: 3, height: 1 }
   * const sheetDimensions = hfInstance.getSheetDimensions(0);
   * ```
   *
   * @category Sheets
   */
  getSheetDimensions(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    return {
      width: this.dependencyGraph.getSheetWidth(sheetId),
      height: this.dependencyGraph.getSheetHeight(sheetId)
    };
  }
  /**
   * Returns values of all sheets in a form of an object which property keys are strings and values are 2D arrays of [[CellValue]].
   *
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '=A1+10', '3'],
   * ]);
   *
   * // should return all sheets values: { Sheet1: [ [ 1, 11, 3 ] ] }
   * const allSheetsValues = hfInstance.getAllSheetsValues();
   * ```
   *
   * @category Sheets
   */
  getAllSheetsValues() {
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getAllSheetsValues();
  }
  /**
   * Returns formulas of all sheets in a form of an object which property keys are strings and values are 2D arrays of strings or possibly `undefined` when the call does not contain a formula.
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2', '=A1+10'],
   * ]);
   *
   * // should return only formulas: { Sheet1: [ [ undefined, undefined, '=A1+10' ] ] }
   * const allSheetsFormulas = hfInstance.getAllSheetsFormulas();
   * ```
   * @category Sheets
   */
  getAllSheetsFormulas() {
    return this._serialization.getAllSheetsFormulas();
  }
  /**
   * Returns formulas or values of all sheets in a form of an object which property keys are strings and values are 2D arrays of [[RawCellContent]].
   *
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2', '=A1+10'],
   * ]);
   *
   * // should return all sheets serialized content: { Sheet1: [ [ 1, 2, '=A1+10' ] ] }
   * const allSheetsSerialized = hfInstance.getAllSheetsSerialized();
   * ```
   *
   * @category Sheets
   */
  getAllSheetsSerialized() {
    this.ensureEvaluationIsNotSuspended();
    return this._serialization.getAllSheetsSerialized();
  }
  /**
   * Updates the config with given new metadata. It is an expensive operation, as it might trigger rebuilding the engine and recalculation of all formulas.
   *
   * For more information, see the [Configuration options guide](/guide/configuration-options.md).
   *
   * @param {Partial<ConfigParams>} newParams configuration options to be updated or added
   *
   * @throws [[ExpectedValueOfTypeError]] when some parameters of config are of wrong type (e.g., currencySymbol)
   * @throws [[ConfigValueEmpty]] when some parameters of config are of invalid value (e.g., currencySymbol)
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // add a config param, for example maxColumns,
   * // you can check the configuration with getConfig method
   * hfInstance.updateConfig({ maxColumns: 1000 });
   * ```
   *
   * @category Instance
   */
  updateConfig(newParams) {
    const isNewConfigTheSame = Object.entries(newParams).every(([key, value]) => this._config[key] === value);
    if (isNewConfigTheSame) {
      return;
    }
    this.rebuildWithConfig(newParams);
  }
  /**
   * Returns current configuration of the engine instance.
   *
   * For more information, see the [Configuration options guide](/guide/configuration-options.md).
   *
   * @example
   * ```js
   * // should return all config metadata including default and those which were added
   * const hfConfig = hfInstance.getConfig();
   * ```
   *
   * @category Instance
   */
  getConfig() {
    return this._config.getConfig();
  }
  /**
   * Rebuilds the HyperFormula instance preserving the current sheets data.
   *
   * @example
   * ```js
   * hfInstance.rebuildAndRecalculate();
   * ```
   *
   * @category Instance
   */
  rebuildAndRecalculate() {
    this.rebuildWithConfig({});
  }
  /**
   * Returns a snapshot of computation time statistics.
   * It returns a map with key-value pairs where keys are enums for stat type and time (number).
   *
   * @internal
   *
   * @category Instance
   */
  getStats() {
    return this._stats.snapshot();
  }
  /**
   * Undo the previous operation.
   *
   * For more information, see the [Undo-Redo guide](/guide/undo-redo.md).
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoOperationToUndoError]] when there is no operation running that can be undone
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   *  ['3', ''],
   * ]);
   *
   * // perform CRUD operation, for example remove the second row
   * hfInstance.removeRows(0, [1, 1]);
   *
   * // undo the operation, it should return the changes
   * const changes = hfInstance.undo();
   * ```
   *
   * @category Undo and Redo
   */
  undo() {
    this._crudOperations.undo();
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Re-do recently undone operation.
   *
   * For more information, see the [Undo-Redo guide](/guide/undo-redo.md).
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoOperationToRedoError]] when there is no operation running that can be re-done
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   *  ['3'],
   * ]);
   *
   * // perform CRUD operation, for example remove the second row
   * hfInstance.removeRows(0, [1, 1]);
   *
   * // undo the operation, it should return previous values: [['1'], ['2'], ['3']]
   * hfInstance.undo();
   *
   * // do a redo, it should return the values after removing the second row: [['1'], ['3']]
   * const changes = hfInstance.redo();
   * ```
   *
   * @category Undo and Redo
   */
  redo() {
    this._crudOperations.redo();
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Checks if there is at least one operation that can be undone.
   *
   * For more information, see the [Undo-Redo guide](/guide/undo-redo.md).
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   *  ['3'],
   * ]);
   *
   * // perform CRUD operation, for example remove the second row
   * hfInstance.removeRows(0, [1, 1]);
   *
   * // should return 'true', it is possible to undo last operation
   * // which is removing rows in this example
   * const isSomethingToUndo = hfInstance.isThereSomethingToUndo();
   * ```
   *
   * @category Undo and Redo
   */
  isThereSomethingToUndo() {
    return this._crudOperations.isThereSomethingToUndo();
  }
  /**
   * Checks if there is at least one operation that can be re-done.
   *
   * For more information, see the [Undo-Redo guide](/guide/undo-redo.md).
   *
   * @example
   * ```js
   * hfInstance.undo();
   *
   * // when there is an action to redo, this returns 'true'
   * const isSomethingToRedo = hfInstance.isThereSomethingToRedo();
   * ```
   *
   * @category Undo and Redo
   */
  isThereSomethingToRedo() {
    return this._crudOperations.isThereSomethingToRedo();
  }
  /**
   * Returns information whether it is possible to change the content in a rectangular area bounded by the box.
   * If returns `true`, doing [[setCellContents]] operation won't throw any errors.
   * Returns `false` if the address is invalid or the sheet does not exist.
   *
   * @param {SimpleCellAddress | SimpleCellRange} address - single cell or block of cells to check
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // top left corner
   * const address1 = { col: 0, row: 0, sheet: 0 };
   * // bottom right corner
   * const address2 = { col: 1, row: 0, sheet: 0 };
   *
   * // should return 'true' for this example, it is possible to set content of
   * // width 2, height 1 in the first row and column of sheet 0
   * const isSettable = hfInstance.isItPossibleToSetCellContents({ start: address1, end: address2 });
   * ```
   *
   * @category Cells
   */
  isItPossibleToSetCellContents(address) {
    let range;
    if (isSimpleCellAddress(address)) {
      range = new AbsoluteCellRange(address, address);
    } else if (isSimpleCellRange(address)) {
      range = new AbsoluteCellRange(address.start, address.end);
    } else {
      throw new ExpectedValueOfTypeError("SimpleCellAddress | SimpleCellRange", "address");
    }
    try {
      this._crudOperations.ensureRangeInSizeLimits(range);
      for (const it of range.addresses(this._dependencyGraph)) {
        this._crudOperations.ensureItIsPossibleToChangeContent(it);
      }
    } catch (e) {
      return false;
    }
    return true;
  }
  /**
   * Sets the content for a block of cells of a given coordinates.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {SimpleCellAddress} topLeftCornerAddress - top left corner of block of cells
   * @param {(RawCellContent[][]|RawCellContent)} cellContents - array with content
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when the value is not an array of arrays or a raw cell value
   * @throws [[SheetSizeLimitExceededError]] when performing this operation would result in sheet size limits exceeding
   * @throws [[ExpectedValueOfTypeError]] if topLeftCornerAddress argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2', '=A1'],
   * ]);
   *
   * // should set the content, returns:
   * // [{
   * //   address: { sheet: 0, col: 3, row: 0 },
   * //   newValue: 2,
   * // }]
   * const changes = hfInstance.setCellContents({ col: 3, row: 0, sheet: 0 }, [['=B1']]);
   * ```
   *
   * @category Cells
   */
  setCellContents(topLeftCornerAddress, cellContents) {
    this._crudOperations.setCellContents(topLeftCornerAddress, cellContents);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Reorders rows of a sheet according to a source-target mapping.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {[number, number][]} rowMapping - array mapping original positions to final positions of rows
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when rowMapping does not define correct row permutation for some subset of rows of the given sheet
   * @throws [[SourceLocationHasArrayError]] when the selected position has array inside
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  [1],
   *  [2],
   *  [4, 5],
   * ]);
   *
   * // should set swap rows 0 and 2 in place, returns:
   * // [{
   * //   address: { sheet: 0, col: 0, row: 2 },
   * //   newValue: 1,
   * // },
   * // {
   * //   address: { sheet: 0, col: 1, row: 2 },
   * //   newValue: null,
   * // },
   * // {
   * //   address: { sheet: 0, col: 0, row: 0 },
   * //   newValue: 4,
   * // },
   * // {
   * //   address: { sheet: 0, col: 1, row: 0 },
   * //   newValue: 5,
   * // }]
   * const changes = hfInstance.swapRowIndexes(0, [[0, 2], [2, 0]]);
   * ```
   *
   * @category Rows
   */
  swapRowIndexes(sheetId, rowMapping) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.setRowOrder(sheetId, rowMapping);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Checks if it is possible to reorder rows of a sheet according to a source-target mapping.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {[number, number][]} rowMapping - array mapping original positions to final positions of rows
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  [1],
   *  [2],
   *  [4, 5],
   * ]);
   *
   * // returns true
   * const isSwappable = hfInstance.isItPossibleToSwapRowIndexes(0, [[0, 2], [2, 0]]);
   *
   * // returns false
   * const isSwappable = hfInstance.isItPossibleToSwapRowIndexes(0, [[0, 1]]);
   * ```
   *
   * @category Rows
   */
  isItPossibleToSwapRowIndexes(sheetId, rowMapping) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      this._crudOperations.validateSwapRowIndexes(sheetId, rowMapping);
      this._crudOperations.testRowOrderForArrays(sheetId, rowMapping);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Reorders rows of a sheet according to a permutation of 0-based indexes.
   * Parameter `newRowOrder` should have a form `[ newPositionForRow0, newPositionForRow1, newPositionForRow2, ... ]`.
   * This method might be used to [sort the rows of a sheet](../../guide/sorting-data.md).
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note: This method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {number[]} newRowOrder - permutation of rows; array length must match the number of rows returned by [getSheetDimensions()](#getsheetdimensions)
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when rowMapping does not define correct row permutation for some subset of rows of the given sheet
   * @throws [[SourceLocationHasArrayError]] when the selected position has array inside
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['A'],
   *  ['B'],
   *  ['C'],
   *  ['D']
   * ]);
   *
   * const newRowOrder = [0, 3, 2, 1]; // [ newPosForA, newPosForB, newPosForC, newPosForD ]
   *
   * const changes = hfInstance.setRowOrder(0, newRowOrder);
   *
   * // Sheet after this operation: [['A'], ['D'], ['C'], ['B']]
   * ```
   *
   * @category Rows
   */
  setRowOrder(sheetId, newRowOrder) {
    validateArgToType(sheetId, "number", "sheetId");
    const mapping = this._crudOperations.mappingFromOrder(sheetId, newRowOrder, "row");
    return this.swapRowIndexes(sheetId, mapping);
  }
  /**
   * Checks if it is possible to reorder rows of a sheet according to a permutation.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {number[]} newRowOrder - permutation of rows
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  [1],
   *  [2],
   *  [4, 5],
   * ]);
   *
   * // returns true
   * hfInstance.isItPossibleToSetRowOrder(0, [2, 1, 0]);
   *
   * // returns false
   * hfInstance.isItPossibleToSetRowOrder(0, [2]);
   * ```
   *
   * @category Rows
   */
  isItPossibleToSetRowOrder(sheetId, newRowOrder) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      const rowMapping = this._crudOperations.mappingFromOrder(sheetId, newRowOrder, "row");
      this._crudOperations.validateSwapRowIndexes(sheetId, rowMapping);
      this._crudOperations.testRowOrderForArrays(sheetId, rowMapping);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Reorders columns of a sheet according to a source-target mapping.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {[number, number][]} columnMapping - array mapping original positions to final positions of columns
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when columnMapping does not define correct column permutation for some subset of columns of the given sheet
   * @throws [[SourceLocationHasArrayError]] when the selected position has array inside
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  [1, 2, 4],
   *  [5]
   * ]);
   *
   * // should set swap columns 0 and 2 in place, returns:
   * // [{
   * //   address: { sheet: 0, col: 2, row: 0 },
   * //   newValue: 1,
   * // },
   * // {
   * //   address: { sheet: 0, col: 2, row: 1 },
   * //   newValue: 5,
   * // },
   * // {
   * //   address: { sheet: 0, col: 0, row: 0 },
   * //   newValue: 4,
   * // },
   * // {
   * //   address: { sheet: 0, col: 0, row: 1 },
   * //   newValue: null,
   * // }]
   * const changes = hfInstance.swapColumnIndexes(0, [[0, 2], [2, 0]]);
   * ```
   *
   * @category Columns
   */
  swapColumnIndexes(sheetId, columnMapping) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.setColumnOrder(sheetId, columnMapping);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Checks if it is possible to reorder columns of a sheet according to a source-target mapping.
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  [1, 2, 4],
   *  [5]
   * ]);
   *
   * // returns true
   * hfInstance.isItPossibleToSwapColumnIndexes(0, [[0, 2], [2, 0]]);
   *
   * // returns false
   * hfInstance.isItPossibleToSwapColumnIndexes(0, [[0, 1]]);
   * ```
   *
   * @category Columns
   */
  isItPossibleToSwapColumnIndexes(sheetId, columnMapping) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      this._crudOperations.validateSwapColumnIndexes(sheetId, columnMapping);
      this._crudOperations.testColumnOrderForArrays(sheetId, columnMapping);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Reorders columns of a sheet according to a permutation of 0-based indexes.
   * Parameter `newColumnOrder` should have a form `[ newPositionForColumn0, newPositionForColumn1, newPositionForColumn2, ... ]`.
   * This method might be used to [sort the columns of a sheet](../../guide/sorting-data.md).
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note: This method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {number[]} newColumnOrder - permutation of columns; array length must match the number of columns returned by [getSheetDimensions()](#getsheetdimensions)
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when columnMapping does not define correct column permutation for some subset of columns of the given sheet
   * @throws [[SourceLocationHasArrayError]] when the selected position has array inside
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   ['A', 'B', 'C', 'D']
   * ]);
   *
   * const newColumnOrder = [0, 3, 2, 1]; // [ newPosForA, newPosForB, newPosForC, newPosForD ]
   *
   * const changes = hfInstance.setColumnOrder(0, newColumnOrder);
   *
   * // Sheet after this operation: [['A', 'D', 'C', 'B']]
   * ```
   *
   * @category Columns
   */
  setColumnOrder(sheetId, newColumnOrder) {
    validateArgToType(sheetId, "number", "sheetId");
    const mapping = this._crudOperations.mappingFromOrder(sheetId, newColumnOrder, "column");
    return this.swapColumnIndexes(sheetId, mapping);
  }
  /**
   * Checks if it is possible to reorder columns of a sheet according to a permutation.
   *
   * @param {number} sheetId - ID of a sheet to operate on
   * @param {number[]} newColumnOrder - permutation of columns
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  [1, 2, 4],
   *  [5]
   * ]);
   *
   * // returns true
   * hfInstance.isItPossibleToSetColumnOrder(0, [2, 1, 0]);
   *
   * // returns false
   * hfInstance.isItPossibleToSetColumnOrder(0, [1]);
   * ```
   *
   * @category Columns
   */
  isItPossibleToSetColumnOrder(sheetId, newColumnOrder) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      const columnMapping = this._crudOperations.mappingFromOrder(sheetId, newColumnOrder, "column");
      this._crudOperations.validateSwapColumnIndexes(sheetId, columnMapping);
      this._crudOperations.testColumnOrderForArrays(sheetId, columnMapping);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Returns information whether it is possible to add rows into a specified position in a given sheet.
   * Checks against particular rules to ascertain that addRows can be called.
   * If returns `true`, doing [[addRows]] operation won't throw any errors.
   * Returns `false` if adding rows would exceed the sheet size limit or given arguments are invalid.
   *
   * @param {number} sheetId - sheet ID in which rows will be added
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format [row, amount], where row is a row number above which the rows will be added
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2', '3'],
   * ]);
   *
   * // should return 'true' for this example,
   * // it is possible to add one row in the second row of sheet 0
   * const isAddable = hfInstance.isItPossibleToAddRows(0, [1, 1]);
   * ```
   *
   * @category Rows
   */
  isItPossibleToAddRows(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    const normalizedIndexes = normalizeAddedIndexes(indexes);
    try {
      this._crudOperations.ensureItIsPossibleToAddRows(sheetId, ...normalizedIndexes);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Adds multiple rows into a specified position in a given sheet.
   * Does nothing if rows are outside effective sheet size.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - sheet ID in which rows will be added
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format [row, amount], where row is a row number above which the rows will be added
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[SheetSizeLimitExceededError]] when performing this operation would result in sheet size limits exceeding
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   * ]);
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values
   * const changes = hfInstance.addRows(0, [0, 1]);
   * ```
   *
   * @category Rows
   */
  addRows(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.addRows(sheetId, ...indexes);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to remove rows from a specified position in a given sheet.
   * Checks against particular rules to ascertain that removeRows can be called.
   * If returns `true`, doing [[removeRows]] operation won't throw any errors.
   * Returns `false` if given arguments are invalid.
   *
   * @param {number} sheetId - sheet ID from which rows will be removed
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format: [row, amount]
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   * ]);
   *
   * // should return 'true' for this example
   * // it is possible to remove one row from row 1 of sheet 0
   * const isRemovable = hfInstance.isItPossibleToRemoveRows(0, [1, 1]);
   * ```
   *
   * @category Rows
   */
  isItPossibleToRemoveRows(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    const normalizedIndexes = normalizeRemovedIndexes(indexes);
    try {
      this._crudOperations.ensureItIsPossibleToRemoveRows(sheetId, ...normalizedIndexes);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Removes multiple rows from a specified position in a given sheet.
   * Does nothing if rows are outside the effective sheet size.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - sheet ID from which rows will be removed
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format: [row, amount]
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[InvalidArgumentsError]] when the given arguments are invalid
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   * ]);
   *
   * // should return: [{ sheet: 0, col: 1, row: 2, value: null }] for this example
   * const changes = hfInstance.removeRows(0, [1, 1]);
   * ```
   *
   * @category Rows
   */
  removeRows(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.removeRows(sheetId, ...indexes);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to add columns into a specified position in a given sheet.
   * Checks against particular rules to ascertain that addColumns can be called.
   * If returns `true`, doing [[addColumns]] operation won't throw any errors.
   * Returns `false` if adding columns would exceed the sheet size limit or given arguments are invalid.
   *
   * @param {number} sheetId - sheet ID in which columns will be added
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format: [column, amount], where column is a column number from which new columns will be added
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // should return 'true' for this example,
   * // it is possible to add 1 column in sheet 0, at column 1
   * const isAddable = hfInstance.isItPossibleToAddColumns(0, [1, 1]);
   * ```
   *
   * @category Columns
   */
  isItPossibleToAddColumns(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    const normalizedIndexes = normalizeAddedIndexes(indexes);
    try {
      this._crudOperations.ensureItIsPossibleToAddColumns(sheetId, ...normalizedIndexes);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Adds multiple columns into a specified position in a given sheet.
   * Does nothing if the columns are outside the effective sheet size.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - sheet ID in which columns will be added
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format: [column, amount], where column is a column number from which new columns will be added
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when the given arguments are invalid
   * @throws [[SheetSizeLimitExceededError]] when performing this operation would result in sheet size limits exceeding
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=RAND()', '42'],
   * ]);
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values, for this example:
   * // [{
   * //   address: { sheet: 0, col: 1, row: 0 },
   * //   newValue: 0.92754862796338,
   * // }]
   * const changes = hfInstance.addColumns(0, [0, 1]);
   * ```
   *
   * @category Columns
   */
  addColumns(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.addColumns(sheetId, ...indexes);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to remove columns from a specified position in a given sheet.
   * Checks against particular rules to ascertain that removeColumns can be called.
   * If returns `true`, doing [[removeColumns]] operation won't throw any errors.
   * Returns `false` if given arguments are invalid.
   *
   * @param {number} sheetId - sheet ID from which columns will be removed
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format [column, amount]
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // should return 'true' for this example
   * // it is possible to remove one column, in place of the second column of sheet 0
   * const isRemovable = hfInstance.isItPossibleToRemoveColumns(0, [1, 1]);
   * ```
   *
   * @category Columns
   */
  isItPossibleToRemoveColumns(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    const normalizedIndexes = normalizeRemovedIndexes(indexes);
    try {
      this._crudOperations.ensureItIsPossibleToRemoveColumns(sheetId, ...normalizedIndexes);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Removes multiple columns from a specified position in a given sheet.
   * Does nothing if columns are outside the effective sheet size.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - sheet ID from which columns will be removed
   * @param {ColumnRowIndex[]} indexes - non-contiguous indexes with format: [column, amount]
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when the given arguments are invalid
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['0', '=SUM(1, 2, 3)', '=A1'],
   * ]);
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values, in this example it will return:
   * // [{
   * //   address: { sheet: 0, col: 1, row: 0 },
   * //   newValue: { error: [CellError], value: '#REF!' },
   * // }]
   * const changes = hfInstance.removeColumns(0, [0, 1]);
   * ```
   *
   * @category Columns
   */
  removeColumns(sheetId, ...indexes) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.removeColumns(sheetId, ...indexes);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to move cells to a specified position in a given sheet.
   * Checks against particular rules to ascertain that moveCells can be called.
   * If returns `true`, doing [[moveCells]] operation won't throw any errors.
   * Returns `false` if the operation might be disrupted and causes side effects by the fact that there is an array inside the selected columns, the target location includes an array or the provided address is invalid.
   *
   * @param {SimpleCellRange} source - range for a moved block
   * @param {SimpleCellAddress} destinationLeftCorner - upper left address of the target cell block
   *
   * @throws [[ExpectedValueOfTypeError]] if destinationLeftCorner, source, or any of basic type arguments are of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // choose the coordinates and assign them to variables
   * const source = { sheet: 0, col: 1, row: 0 };
   * const destination = { sheet: 0, col: 3, row: 0 };
   *
   * // should return 'true' for this example
   * // it is possible to move a block of width 1 and height 1
   * // from the corner: column 1 and row 0 of sheet 0
   * // into destination corner: column 3, row 0 of sheet 0
   * const isMovable = hfInstance.isItPossibleToMoveCells({ start: source, end: source }, destination);
   * ```
   * @category Cells
   */
  isItPossibleToMoveCells(source, destinationLeftCorner) {
    if (!isSimpleCellAddress(destinationLeftCorner)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "destinationLeftCorner");
    }
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    try {
      const range = new AbsoluteCellRange(source.start, source.end);
      this._crudOperations.operations.ensureItIsPossibleToMoveCells(range.start, range.width(), range.height(), destinationLeftCorner);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Moves the content of a cell block from source to the target location.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {SimpleCellRange} source - range for a moved block
   * @param {SimpleCellAddress} destinationLeftCorner - upper left address of the target cell block
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if destinationLeftCorner or source are of wrong type
   * @throws [[InvalidArgumentsError]] when the given arguments are invalid
   * @throws [[SheetSizeLimitExceededError]] when performing this operation would result in sheet size limits exceeding
   * @throws [[SourceLocationHasArrayError]] when the source location has array inside - array cannot be moved
   * @throws [[TargetLocationHasArrayError]] when the target location has array inside - cells cannot be replaced by the array
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=RAND()', '42'],
   * ]);
   *
   * // choose the coordinates and assign them to variables
   * const source = { sheet: 0, col: 1, row: 0 };
   * const destination = { sheet: 0, col: 3, row: 0 };
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values, for this example:
   * // [{
   * //   address: { sheet: 0, col: 0, row: 0 },
   * //   newValue: 0.93524248002062,
   * // }]
   * const changes = hfInstance.moveCells({ start: source, end: source }, destination);
   * ```
   *
   * @category Cells
   */
  moveCells(source, destinationLeftCorner) {
    if (!isSimpleCellAddress(destinationLeftCorner)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "destinationLeftCorner");
    }
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    const range = new AbsoluteCellRange(source.start, source.end);
    this._crudOperations.moveCells(range.start, range.width(), range.height(), destinationLeftCorner);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to move a particular number of rows to a specified position in a given sheet.
   * Checks against particular rules to ascertain that moveRows can be called.
   * If returns `true`, doing [[moveRows]] operation won't throw any errors.
   * Returns `false` if the operation might be disrupted and causes side effects by the fact that there is an array inside the selected rows, the target location includes an array or the provided address is invalid.
   *
   * @param {number} sheetId - a sheet number in which the operation will be performed
   * @param {number} startRow - number of the first row to move
   * @param {number} numberOfRows - number of rows to move
   * @param {number} targetRow - row number before which rows will be moved
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   * ]);
   *
   * // should return 'true' for this example
   * // it is possible to move one row from row 0 into row 2
   * const isMovable = hfInstance.isItPossibleToMoveRows(0, 0, 1, 2);
   * ```
   *
   * @category Rows
   */
  isItPossibleToMoveRows(sheetId, startRow, numberOfRows, targetRow) {
    validateArgToType(sheetId, "number", "sheetId");
    validateArgToType(startRow, "number", "startRow");
    validateArgToType(numberOfRows, "number", "numberOfRows");
    validateArgToType(targetRow, "number", "targetRow");
    try {
      this._crudOperations.ensureItIsPossibleToMoveRows(sheetId, startRow, numberOfRows, targetRow);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Moves a particular number of rows to a specified position in a given sheet.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - a sheet number in which the operation will be performed
   * @param {number} startRow - number of the first row to move
   * @param {number} numberOfRows - number of rows to move
   * @param {number} targetRow - row number before which rows will be moved
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[InvalidArgumentsError]] when the given arguments are invalid
   * @throws [[SourceLocationHasArrayError]] when the source location has array inside - array cannot be moved
   * @throws [[TargetLocationHasArrayError]] when the target location has array inside - cells cannot be replaced by the array
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1'],
   *  ['2'],
   * ]);
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values
   * const changes = hfInstance.moveRows(0, 0, 1, 2);
   * ```
   *
   * @category Rows
   */
  moveRows(sheetId, startRow, numberOfRows, targetRow) {
    validateArgToType(sheetId, "number", "sheetId");
    validateArgToType(startRow, "number", "startRow");
    validateArgToType(numberOfRows, "number", "numberOfRows");
    validateArgToType(targetRow, "number", "targetRow");
    this._crudOperations.moveRows(sheetId, startRow, numberOfRows, targetRow);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to move a particular number of columns to a specified position in a given sheet.
   * Checks against particular rules to ascertain that moveColumns can be called.
   * If returns `true`, doing [[moveColumns]] operation won't throw any errors.
   * Returns `false` if the operation might be disrupted and causes side effects by the fact that there is an array inside the selected columns, the target location includes an array or the provided address is invalid.
   *
   * @param {number} sheetId - a sheet number in which the operation will be performed
   * @param {number} startColumn - number of the first column to move
   * @param {number} numberOfColumns - number of columns to move
   * @param {number} targetColumn - column number before which columns will be moved
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // should return 'true' for this example
   * // it is possible to move one column from column 1 into column 2 of sheet 0
   * const isMovable = hfInstance.isItPossibleToMoveColumns(0, 1, 1, 2);
   * ```
   *
   * @category Columns
   */
  isItPossibleToMoveColumns(sheetId, startColumn, numberOfColumns, targetColumn) {
    validateArgToType(sheetId, "number", "sheetId");
    validateArgToType(startColumn, "number", "startColumn");
    validateArgToType(numberOfColumns, "number", "numberOfColumns");
    validateArgToType(targetColumn, "number", "targetColumn");
    try {
      this._crudOperations.ensureItIsPossibleToMoveColumns(sheetId, startColumn, numberOfColumns, targetColumn);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Moves a particular number of columns to a specified position in a given sheet.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - a sheet number in which the operation will be performed
   * @param {number} startColumn - number of the first column to move
   * @param {number} numberOfColumns - number of columns to move
   * @param {number} targetColumn - column number before which columns will be moved
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[InvalidArgumentsError]] when the given arguments are invalid
   * @throws [[SourceLocationHasArrayError]] when the source location has array inside - array cannot be moved
   * @throws [[TargetLocationHasArrayError]] when the target location has array inside - cells cannot be replaced by the array
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2', '3', '=RAND()', '=SUM(A1:C1)'],
   * ]);
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values, for this example:
   * // [{
   * //   address: { sheet: 0, col: 1, row: 0 },
   * //   newValue: 0.16210054671639,
   * //  }, {
   * //   address: { sheet: 0, col: 4, row: 0 },
   * //   newValue: 6.16210054671639,
   * // }]
   * const changes = hfInstance.moveColumns(0, 1, 1, 2);
   * ```
   *
   * @category Columns
   */
  moveColumns(sheetId, startColumn, numberOfColumns, targetColumn) {
    validateArgToType(sheetId, "number", "sheetId");
    validateArgToType(startColumn, "number", "startColumn");
    validateArgToType(numberOfColumns, "number", "numberOfColumns");
    validateArgToType(targetColumn, "number", "targetColumn");
    this._crudOperations.moveColumns(sheetId, startColumn, numberOfColumns, targetColumn);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Stores a copy of the cell block in internal clipboard for the further paste.
   * Returns the copied values for use in external clipboard.
   *
   * For more information, see the [Clipboard Operations guide](/guide/clipboard-operations.md).
   *
   * @param {SimpleCellRange} source - rectangle range to copy
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if source is of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   ['1', '2'],
   * ]);
   *
   * // it copies [ [ 2 ] ]
   * const clipboardContent = hfInstance.copy({
   *   start: { sheet: 0, col: 1, row: 0 },
   *   end: { sheet: 0, col: 1, row: 0 },
   * });
   * ```
   *
   * The usage of the internal clipboard is described thoroughly in the [Clipboard Operations guide](../../guide/clipboard-operations.md).
   *
   * @category Clipboard
   */
  copy(source) {
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    const range = new AbsoluteCellRange(source.start, source.end);
    this._crudOperations.copy(range.start, range.width(), range.height());
    return this.getRangeValues(source);
  }
  /**
   * Stores information of the cell block in internal clipboard for further paste.
   * Calling [[paste]] right after this method is equivalent to call [[moveCells]].
   * Almost any CRUD operation called after this method will abort the cut operation.
   * Returns the cut values for use in external clipboard.
   *
   * For more information, see the [Clipboard Operations guide](/guide/clipboard-operations.md).
   *
   * @param {SimpleCellRange} source - rectangle range to cut
   *
   * @throws [[ExpectedValueOfTypeError]] if source is of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   ['1', '2'],
   * ]);
   *
   * // returns the values that were cut: [ [ 1 ] ]
   * const clipboardContent = hfInstance.cut({
   *   start: { sheet: 0, col: 0, row: 0 },
   *   end: { sheet: 0, col: 0, row: 0 },
   * });
   * ```
   *
   * The usage of the internal clipboard is described thoroughly in the [Clipboard Operations guide](../../guide/clipboard-operations.md).
   *
   * @category Clipboard
   */
  cut(source) {
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    const range = new AbsoluteCellRange(source.start, source.end);
    this._crudOperations.cut(range.start, range.width(), range.height());
    return this.getRangeValues(source);
  }
  /**
   * When called after [[copy]] it pastes copied values and formulas into a cell block.
   * When called after [[cut]] it performs [[moveCells]] operation into the cell block.
   * Does nothing if the clipboard is empty.
   *
   * For more information, see the [Clipboard Operations guide](/guide/clipboard-operations.md).
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {SimpleCellAddress} targetLeftCorner - upper left address of the target cell block
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[SheetSizeLimitExceededError]] when performing this operation would result in sheet size limits exceeding
   * @throws [[NothingToPasteError]] when clipboard is empty
   * @throws [[TargetLocationHasArrayError]] when the selected target area has array inside
   * @throws [[ExpectedValueOfTypeError]] if targetLeftCorner is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   ['1', '2'],
   * ]);
   *
   * // [ [ 2 ] ] was copied
   * const clipboardContent = hfInstance.copy({
   *   start: { sheet: 0, col: 1, row: 0 },
   *   end: { sheet: 0, col: 1, row: 0 },
   * });
   *
   * // returns a list of modified cells: their absolute addresses and new values
   * const changes = hfInstance.paste({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * The usage of the internal clipboard is described thoroughly in the [Clipboard Operations guide](../../guide/clipboard-operations.md).
   *
   * @category Clipboard
   */
  paste(targetLeftCorner) {
    if (!isSimpleCellAddress(targetLeftCorner)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "targetLeftCorner");
    }
    this.ensureEvaluationIsNotSuspended();
    this._crudOperations.paste(targetLeftCorner);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether there is something in the clipboard.
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // copy desired content
   * const clipboardContent = hfInstance.copy({
   *   start: { sheet: 0, col: 1, row: 0 },
   *   end: { sheet: 0, col: 1, row: 0 },
   * });
   *
   * // returns 'false', there is content in the clipboard
   * const isClipboardEmpty = hfInstance.isClipboardEmpty();
   * ```
   *
   * The usage of the internal clipboard is described thoroughly in the [Clipboard Operations guide](../../guide/clipboard-operations.md).
   *
   * @category Clipboard
   */
  isClipboardEmpty() {
    return this._crudOperations.isClipboardEmpty();
  }
  /**
   * Clears the clipboard content.
   *
   * @example
   * ```js
   * // clears the clipboard, isClipboardEmpty() should return true if called afterwards
   * hfInstance.clearClipboard();
   * ```
   *
   * The usage of the internal clipboard is described thoroughly in the [Clipboard Operations guide](../../guide/clipboard-operations.md).
   *
   * @category Clipboard
   */
  clearClipboard() {
    this._crudOperations.clearClipboard();
  }
  /**
   * Clears the redo stack in undoRedo history.
   *
   * For more information, see the [Undo-Redo guide](/guide/undo-redo.md).
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   ['1', '2', '3'],
   * ]);
   *
   * // do an operation, for example remove columns
   * hfInstance.removeColumns(0, [0, 1]);
   *
   * // undo the operation
   * hfInstance.undo();
   *
   * // redo the operation
   * hfInstance.redo();
   *
   * // clear the redo stack
   * hfInstance.clearRedoStack();
   * ```
   *
   * @category Undo and Redo
   */
  clearRedoStack() {
    this._crudOperations.undoRedo.clearRedoStack();
  }
  /**
   * Clears the undo stack in undoRedo history.
   *
   * For more information, see the [Undo-Redo guide](/guide/undo-redo.md).
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   ['1', '2', '3'],
   * ]);
   *
   * // do an operation, for example remove columns
   * hfInstance.removeColumns(0, [0, 1]);
   *
   * // undo the operation
   * hfInstance.undo();
   *
   * // clear the undo stack
   * hfInstance.clearUndoStack();
   * ```
   *
   * @category Undo and Redo
   */
  clearUndoStack() {
    this._crudOperations.undoRedo.clearUndoStack();
  }
  /**
   * Returns the cell content of a given range in a [[CellValue]][][] format.
   *
   * @param {SimpleCellRange} source - rectangular range
   *
   * @throws [[ExpectedValueOfTypeError]] if source is of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2)', '2', '10'],
   *  ['5', '6', '7'],
   *  ['40', '30', '20'],
   * ]);
   *
   *
   * // returns calculated cells content: [ [ 3, 2 ], [ 5, 6 ] ]
   * const rangeValues = hfInstance.getRangeValues({ start: { sheet: 0, col: 0, row: 0 }, end: { sheet: 0, col: 1, row: 1 } });
   * ```
   *
   * @category Ranges
   */
  getRangeValues(source) {
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    const cellRange = new AbsoluteCellRange(source.start, source.end);
    return cellRange.arrayOfAddressesInRange().map((subarray) => subarray.map((address) => this.getCellValue(address)));
  }
  /**
   * Returns cell formulas in given range.
   *
   * @param {SimpleCellRange} source - rectangular range
   *
   * @throws [[ExpectedValueOfTypeError]] if source is of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2)', '2', '10'],
   *  ['5', '6', '7'],
   *  ['40', '30', '20'],
   * ]);
   *
   * // returns cell formulas of a given range only:
   * // [ [ '=SUM(1, 2)', undefined ], [ undefined, undefined ] ]
   * const rangeFormulas = hfInstance.getRangeFormulas({ start: { sheet: 0, col: 0, row: 0 }, end: { sheet: 0, col: 1, row: 1 } });
   * ```
   *
   * @category Ranges
   */
  getRangeFormulas(source) {
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    const cellRange = new AbsoluteCellRange(source.start, source.end);
    return cellRange.arrayOfAddressesInRange().map((subarray) => subarray.map((address) => this.getCellFormula(address)));
  }
  /**
   * Returns serialized cells in given range.
   *
   * @param {SimpleCellRange} source - rectangular range
   *
   * @throws [[ExpectedValueOfTypeError]] if source is of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2)', '2', '10'],
   *  ['5', '6', '7'],
   *  ['40', '30', '20'],
   * ]);
   *
   * // should return serialized cell content for the given range:
   * // [ [ '=SUM(1, 2)', 2 ], [ 5, 6 ] ]
   * const rangeSerialized = hfInstance.getRangeSerialized({ start: { sheet: 0, col: 0, row: 0 }, end: { sheet: 0, col: 1, row: 1 } });
   * ```
   *
   * @category Ranges
   */
  getRangeSerialized(source) {
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    const cellRange = new AbsoluteCellRange(source.start, source.end);
    return cellRange.arrayOfAddressesInRange().map((subarray) => subarray.map((address) => this.getCellSerialized(address)));
  }
  /**
   * Returns values to fill target range using source range, with properly extending the range using wrap-around heuristic.
   *
   * @param {SimpleCellRange} source of data
   * @param {SimpleCellRange} target range where data is intended to be put
   * @param {boolean} offsetsFromTarget if true, offsets are computed from target corner, otherwise from source corner
   *
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[ExpectedValueOfTypeError]] if source or target are of wrong type
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([[1, '=A1'], ['=$A$1', '2']]);
   *
   * // should return [['2', '=$A$1', '2'], ['=A3', 1, '=C3'], ['2', '=$A$1', '2']]
   * hfInstance.getFillRangeData( {start: {sheet: 0, row: 0, col: 0}, end: {sheet: 0, row: 1, col: 1}},
   * {start: {sheet: 0, row: 1, col: 1}, end: {sheet: 0, row: 3, col: 3}});
   * ```
   *
   * @category Ranges
   */
  getFillRangeData(source, target, offsetsFromTarget = false) {
    if (!isSimpleCellRange(source)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "source");
    }
    if (!isSimpleCellRange(target)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "target");
    }
    const sourceRange = new AbsoluteCellRange(source.start, source.end);
    const targetRange = new AbsoluteCellRange(target.start, target.end);
    this.ensureEvaluationIsNotSuspended();
    return targetRange.arrayOfAddressesInRange().map((subarray) => subarray.map((address) => {
      const row = ((address.row - (offsetsFromTarget ? target : source).start.row) % sourceRange.height() + sourceRange.height()) % sourceRange.height() + source.start.row;
      const col = ((address.col - (offsetsFromTarget ? target : source).start.col) % sourceRange.width() + sourceRange.width()) % sourceRange.width() + source.start.col;
      return this._serialization.getCellSerialized({
        row,
        col,
        sheet: sourceRange.sheet
      }, address);
    }));
  }
  /**
   * Returns information whether it is possible to add a sheet to the engine.
   * Checks against particular rules to ascertain that addSheet can be called.
   * If returns `true`, doing [[addSheet]] operation won't throw any errors, and it is possible to add sheet with provided name.
   * Returns `false` if the chosen name is already used.
   *
   * @param {string} sheetName - sheet name, case-insensitive
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *   MySheet1: [ ['1'] ],
   *   MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'false' because 'MySheet2' already exists
   * const isAddable = hfInstance.isItPossibleToAddSheet('MySheet2');
   * ```
   *
   * @category Sheets
   */
  isItPossibleToAddSheet(sheetName) {
    validateArgToType(sheetName, "string", "sheetName");
    try {
      this._crudOperations.ensureItIsPossibleToAddSheet(sheetName);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Adds a new sheet to the HyperFormula instance. Returns given or autogenerated name of a new sheet.
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {string} [sheetName] - if not specified, name is autogenerated
   *
   * @fires [[sheetAdded]] after the sheet was added
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[SheetNameAlreadyTakenError]] when sheet with a given name already exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'MySheet3'
   * const nameProvided = hfInstance.addSheet('MySheet3');
   *
   * // should return autogenerated 'Sheet4'
   * // because no name was provided and 3 other ones already exist
   * const generatedName = hfInstance.addSheet();
   * ```
   *
   * @category Sheets
   */
  addSheet(sheetName) {
    if (sheetName !== void 0) {
      validateArgToType(sheetName, "string", "sheetName");
    }
    const addedSheetName = this._crudOperations.addSheet(sheetName);
    this.recomputeIfDependencyGraphNeedsIt();
    this._emitter.emit(Events.SheetAdded, addedSheetName);
    return addedSheetName;
  }
  /**
   * Returns information whether it is possible to remove sheet for the engine.
   * Returns `true` if the provided sheet exists, and therefore it can be removed, doing [[removeSheet]] operation won't throw any errors.
   * Returns `false` otherwise
   *
   * @param {number} sheetId - sheet ID.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'true' because sheet with ID 1 exists and is removable
   * const isRemovable = hfInstance.isItPossibleToRemoveSheet(1);
   * ```
   *
   * @category Sheets
   */
  isItPossibleToRemoveSheet(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      this._crudOperations.ensureScopeIdIsValid(sheetId);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Removes a sheet
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - sheet ID.
   *
   * @fires [[sheetRemoved]] after the sheet was removed
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['=SUM(MySheet2!A1:A2)'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values, in this example it will return:
   * // [{
   * //   address: { sheet: 0, col: 0, row: 0 },
   * //   newValue: { error: [CellError], value: '#REF!' },
   * // }]
   * const changes = hfInstance.removeSheet(1);
   * ```
   *
   * @category Sheets
   */
  removeSheet(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    const displayName = this.sheetMapping.getSheetName(sheetId);
    this._crudOperations.removeSheet(sheetId);
    const changes = this.recomputeIfDependencyGraphNeedsIt();
    this._emitter.emit(Events.SheetRemoved, displayName, changes);
    return changes;
  }
  /**
   * Returns information whether it is possible to clear a specified sheet.
   * If returns `true`, doing [[clearSheet]] operation won't throw any errors, provided sheet exists and its content can be cleared.
   * Returns `false` otherwise
   *
   * @param {number} sheetId - sheet ID.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'true' because 'MySheet2' exists and can be cleared
   * const isClearable = hfInstance.isItPossibleToClearSheet(1);
   * ```
   *
   * @category Sheets
   */
  isItPossibleToClearSheet(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      this._crudOperations.ensureScopeIdIsValid(sheetId);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Clears the sheet content. Double-checks if the sheet exists.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - sheet ID.
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['=SUM(MySheet2!A1:A2)'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values, in this example it will return:
   * // [{
   * //   address: { sheet: 0, col: 0, row: 0 },
   * //   newValue: 0,
   * // }]
   * const changes = hfInstance.clearSheet(0);
   * ```
   *
   * @category Sheets
   */
  clearSheet(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.clearSheet(sheetId);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to replace the sheet content.
   * If returns `true`, doing [[setSheetContent]] operation won't throw any errors, the provided sheet exists and then its content can be replaced.
   * Returns `false` otherwise
   *
   * @param {number} sheetId - sheet ID.
   * @param {RawCellContent[][]} values - array of new values
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'true' because sheet of ID 0 exists
   * // and the provided content can be placed in this sheet
   * const isReplaceable = hfInstance.isItPossibleToReplaceSheetContent(0, [['50'], ['60']]);
   * ```
   *
   * @category Sheets
   */
  isItPossibleToReplaceSheetContent(sheetId, values2) {
    validateArgToType(sheetId, "number", "sheetId");
    try {
      this._crudOperations.ensureScopeIdIsValid(sheetId);
      this._crudOperations.ensureItIsPossibleToChangeSheetContents(sheetId, values2);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Replaces the sheet content with new values.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * @param {number} sheetId - sheet ID.
   * @param {RawCellContent[][]} values - array of new values
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[InvalidArgumentsError]] when values argument is not an array of arrays
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return a list of cells which values changed after the operation,
   * // their absolute addresses and new values
   * const changes = hfInstance.setSheetContent(0, [['50'], ['60']]);
   * ```
   *
   * @category Sheets
   */
  setSheetContent(sheetId, values2) {
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.setSheetContent(sheetId, values2);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Computes the simple (absolute) address of a cell address, based on its string representation.
   * - If a sheet name is present in the string representation but is not present in the engine, returns `undefined`.
   * - If no sheet name is present in the string representation, uses `contextSheetId` as a sheet id in the returned address.
   *
   * For more information, see the [Cell references guide](/guide/cell-references.md).
   *
   * @param {string} cellAddress - string representation of cell address in A1 notation
   * @param {number} contextSheetId - sheet id used to construct the simple address in case of missing sheet name in `cellAddress` argument
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   * hfInstance.addSheet('Sheet0'); //sheetId = 0
   *
   * // returns { sheet: 42, col: 0, row: 0 }
   * const simpleCellAddress = hfInstance.simpleCellAddressFromString('A1', 42);
   *
   * // returns { sheet: 0, col: 0, row: 5 }
   * const simpleCellAddress = hfInstance.simpleCellAddressFromString('Sheet0!A6', 42);
   *
   * // returns { sheet: 0, col: 0, row: 5 }
   * const simpleCellAddress = hfInstance.simpleCellAddressFromString('Sheet0!$A$6', 42);
   *
   * // returns 'undefined', as there's no 'Sheet 2' in the HyperFormula instance
   * const simpleCellAddress = hfInstance.simpleCellAddressFromString('Sheet2!A6', 42);
   * ```
   *
   * @category Helpers
   */
  simpleCellAddressFromString(cellAddress, contextSheetId) {
    validateArgToType(cellAddress, "string", "cellAddress");
    validateArgToType(contextSheetId, "number", "sheetId");
    return simpleCellAddressFromString(this.sheetMapping.getSheetId.bind(this.sheetMapping), cellAddress, contextSheetId);
  }
  /**
   * Computes simple (absolute) address of a cell range based on its string representation.
   * If sheet name is present in string representation but not present in the engine, returns `undefined`.
   *
   * For more information, see the [Cell references guide](/guide/cell-references.md).
   *
   * @param {string} cellRange - string representation of cell range in A1 notation
   * @param {number} contextSheetId - sheet id used to construct the simple address in case of missing sheet name in `cellRange` argument
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   * hfInstance.addSheet('Sheet0'); //sheetId = 0
   *
   * // should return { start: { sheet: 0, col: 0, row: 0 }, end: { sheet: 0, col: 1, row: 0 } }
   * const simpleCellAddress = hfInstance.simpleCellRangeFromString('A1:A2', 0);
   * ```
   *
   * @category Helpers
   */
  simpleCellRangeFromString(cellRange, contextSheetId) {
    validateArgToType(cellRange, "string", "cellRange");
    validateArgToType(contextSheetId, "number", "sheetId");
    return simpleCellRangeFromString(this.sheetMapping.getSheetId.bind(this.sheetMapping), cellRange, contextSheetId);
  }
  /**
   * Computes string representation of an absolute address in A1 notation. If `cellAddress.sheet` is not present in the engine, returns `undefined`.
   *
   * For more information, see the [Cell references guide](/guide/cell-references.md).
   *
   * @param {SimpleCellAddress} cellAddress - object representation of an absolute address
   * @param {object | number} optionsOrContextSheetId - options object or number used as context sheet id to construct the string address (see examples)
   *
   * @throws [[ExpectedValueOfTypeError]] if its arguments are of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   * hfInstance.addSheet('Sheet0'); //sheetId = 0
   * const addr = { sheet: 0, col: 1, row: 1 };
   *
   * // should return 'B2'
   * const A1Notation = hfInstance.simpleCellAddressToString(addr);
   *
   * // should return 'B2'
   * const A1Notation = hfInstance.simpleCellAddressToString(addr, { includeSheetName: false });
   *
   * // should return 'Sheet0!B2'
   * const A1Notation = hfInstance.simpleCellAddressToString(addr, { includeSheetName: true });
   *
   * // should return 'B2' as context sheet id is the same as addr.sheet
   * const A1Notation = hfInstance.simpleCellAddressToString(addr, 0);
   *
   * // should return 'Sheet0!B2' as context sheet id is different from addr.sheet
   * const A1Notation = hfInstance.simpleCellAddressToString(addr, 42);
   * ```
   *
   * @category Helpers
   */
  simpleCellAddressToString(cellAddress, optionsOrContextSheetId = {}) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    const contextSheetId = typeof optionsOrContextSheetId === "number" ? optionsOrContextSheetId : optionsOrContextSheetId.includeSheetName ? cellAddress.sheet + 1 : cellAddress.sheet;
    return simpleCellAddressToString(this.sheetMapping.getSheetNameOrThrowError.bind(this.sheetMapping), cellAddress, contextSheetId);
  }
  /**
   * Computes string representation of an absolute range in A1 notation.
   * Returns `undefined` if:
   * - `cellRange` is not a valid range,
   * - `cellRange.start.sheet` and `cellRange.start.end` are different,
   * - `cellRange.start.sheet` is not present in the engine,
   * - `cellRange.start.end` is not present in the engine.
   *
   * Note: This method is useful only for cell ranges; does not work with column ranges and row ranges.
   *
   * For more information, see the [Cell references guide](/guide/cell-references.md).
   *
   * @param {SimpleCellRange} cellRange - object representation of an absolute range
   * @param {object | number} optionsOrContextSheetId - options object or number used as context sheet id to construct the string address (see examples)
   *
   * @throws [[ExpectedValueOfTypeError]] if its arguments are of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   * hfInstance.addSheet('Sheet0'); //sheetId = 0
   * const range = { start: { sheet: 0, col: 1, row: 1 }, end: { sheet: 0, col: 2, row: 1 } };
   *
   * // should return 'B2:C2'
   * const A1Notation = hfInstance.simpleCellRangeToString(range);
   *
   * // should return 'B2:C2'
   * const A1Notation = hfInstance.simpleCellRangeToString(range, { includeSheetName: false });
   *
   * // should return 'Sheet0!B2:C2'
   * const A1Notation = hfInstance.simpleCellRangeToString(range, { includeSheetName: true });
   *
   * // should return 'B2:C2' as context sheet id is the same as range.start.sheet and range.end.sheet
   * const A1Notation = hfInstance.simpleCellRangeToString(range, 0);
   *
   * // should return 'Sheet0!B2:C2' as context sheet id is different from range.start.sheet and range.end.sheet
   * const A1Notation = hfInstance.simpleCellRangeToString(range, 42);
   * ```
   *
   * @category Helpers
   */
  simpleCellRangeToString(cellRange, optionsOrContextSheetId = {}) {
    if (!isSimpleCellRange(cellRange)) {
      throw new ExpectedValueOfTypeError("SimpleCellRange", "cellRange");
    }
    const contextSheetId = typeof optionsOrContextSheetId === "number" ? optionsOrContextSheetId : optionsOrContextSheetId.includeSheetName ? cellRange.start.sheet + cellRange.end.sheet + 1 : cellRange.start.sheet;
    return simpleCellRangeToString(this.sheetMapping.getSheetNameOrThrowError.bind(this.sheetMapping), cellRange, contextSheetId);
  }
  /**
   * Returns all the out-neighbors in the [dependency graph](../../guide/dependency-graph.md) for a given cell address or range. Including:
   * - All cells with formulas that contain the given cell address or range
   * - Some of the ranges that contain the given cell address or range
   *
   * The exact result depends on the optimizations applied by the HyperFormula to the dependency graph, some of which are described in the section ["Optimizations for large ranges"](../../guide/dependency-graph.md#optimizations-for-large-ranges).
   *
   * The returned array includes also named expression dependents. They are represented as cell references with sheet ID `-1`.
   *
   * @param {SimpleCellAddress | SimpleCellRange} address - object representation of an absolute address or range of addresses
   *
   * @throws [[ExpectedValueOfTypeError]] if address is not [[SimpleCellAddress]] or [[SimpleCellRange]]
   * @throws [[SheetsNotEqual]] if range provided has distinct sheet numbers for start and end
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray( [ ['1', '=A1', '=A1+B1'] ] );
   *
   * hfInstance.getCellDependents({ sheet: 0, col: 0, row: 0});
   * // returns [{ sheet: 0, col: 1, row: 0}, { sheet: 0, col: 2, row: 0}]
   * ```
   *
   * @category Helpers
   */
  getCellDependents(address) {
    let vertex;
    if (isSimpleCellAddress(address)) {
      vertex = this._dependencyGraph.addressMapping.getCell(address);
    } else if (isSimpleCellRange(address)) {
      vertex = this._dependencyGraph.rangeMapping.getRangeVertex(address.start, address.end);
    } else {
      throw new ExpectedValueOfTypeError("SimpleCellAddress | SimpleCellRange", address);
    }
    if (vertex === void 0) {
      return [];
    }
    return this._dependencyGraph.getAdjacentNodesAddresses(vertex);
  }
  /**
   * Returns all the in-neighbors in the [dependency graph](../../guide/dependency-graph.md) for a given cell address or range. In particular:
   * - If the argument is a single cell, `getCellPrecedents()` returns all cells and ranges contained in that cell's formula.
   * - If the argument is a range of cells, `getCellPrecedents()` returns some of the cell addresses and smaller ranges contained in that range (but not all of them). The exact result depends on the optimizations applied by the HyperFormula to the dependency graph, some of which are described in the section ["Optimizations for large ranges"](../../guide/dependency-graph.md#optimizations-for-large-ranges).
   *
   * The returned array includes also named expression precedents. They are represented as cell references with sheet ID `-1`.
   *
   * @param {SimpleCellAddress | SimpleCellRange} address - object representation of an absolute address or range of addresses
   *
   * @throws [[ExpectedValueOfTypeError]] if address is of wrong type
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray( [ ['1', '=A1', '=A1+B1'] ] );
   *
   * hfInstance.getCellPrecedents({ sheet: 0, col: 2, row: 0});
   * // returns [{ sheet: 0, col: 0, row: 0}, { sheet: 0, col: 1, row: 0}]
   * ```
   *
   * @category Helpers
   */
  getCellPrecedents(address) {
    let vertex;
    if (isSimpleCellAddress(address)) {
      vertex = this._dependencyGraph.addressMapping.getCell(address);
    } else if (isSimpleCellRange(address)) {
      vertex = this._dependencyGraph.rangeMapping.getRangeVertex(address.start, address.end);
    } else {
      throw new ExpectedValueOfTypeError("SimpleCellAddress | SimpleCellRange", address);
    }
    if (vertex === void 0) {
      return [];
    }
    return this._dependencyGraph.dependencyQueryAddresses(vertex);
  }
  /**
   * Returns a unique sheet name assigned to the sheet of a given ID or `undefined` if the there is no sheet with a given ID.
   *
   * @param {number} sheetId - ID of the sheet, for which we want to retrieve name
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'MySheet2' as this sheet is the second one
   * const sheetName = hfInstance.getSheetName(1);
   * ```
   *
   * @category Sheets
   */
  getSheetName(sheetId) {
    validateArgToType(sheetId, "number", "sheetId");
    return this.sheetMapping.getSheetName(sheetId);
  }
  /**
   * List all sheet names.
   * Returns an array of sheet names as strings.
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // should return all sheets names: ['MySheet1', 'MySheet2']
   * const sheetNames = hfInstance.getSheetNames();
   * ```
   *
   * @category Sheets
   */
  getSheetNames() {
    return this.sheetMapping.getSheetNames();
  }
  /**
   * Returns a unique sheet ID assigned to the sheet with a given name or `undefined` if the sheet does not exist.
   *
   * @param {string} sheetName - name of the sheet, for which we want to retrieve ID, case-insensitive.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *   MySheet1: [ ['1'] ],
   *   MySheet2: [ ['10'] ],
   * });
   *
   * // should return '0' because 'MySheet1' is of ID '0'
   * const sheetID = hfInstance.getSheetId('MySheet1');
   * ```
   *
   * @category Sheets
   */
  getSheetId(sheetName) {
    validateArgToType(sheetName, "string", "sheetName");
    return this.sheetMapping.getSheetId(sheetName);
  }
  /**
   * Returns `true` whether sheet with a given name exists. The method accepts sheet name to be checked.
   *
   * @param {string} sheetName - name of the sheet, case-insensitive.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *   MySheet1: [ ['1'] ],
   *   MySheet2: [ ['10'] ],
   * });
   *
   * // should return 'true' since 'MySheet1' exists
   * const sheetExist = hfInstance.doesSheetExist('MySheet1');
   * ```
   *
   * @category Sheets
   */
  doesSheetExist(sheetName) {
    validateArgToType(sheetName, "string", "sheetName");
    return this.sheetMapping.hasSheetWithName(sheetName);
  }
  /**
   * Returns the type of a cell at a given address.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(A2:A3)', '2'],
   * ]);
   *
   * // should return 'FORMULA', the cell of given coordinates is of this type
   * const cellA1Type = hfInstance.getCellType({ sheet: 0, col: 0, row: 0 });
   *
   * // should return 'VALUE', the cell of given coordinates is of this type
   * const cellB1Type = hfInstance.getCellType({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellType(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    const vertex = this.dependencyGraph.getCell(cellAddress);
    return getCellType(vertex, cellAddress);
  }
  /**
   * Returns `true` if the specified cell contains a simple value.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(A2:A3)', '2'],
   * ]);
   *
   * // should return 'true' since the selected cell contains a simple value
   * const isA1Simple = hfInstance.doesCellHaveSimpleValue({ sheet: 0, col: 0, row: 0 });
   *
   * // should return 'false' since the selected cell does not contain a simple value
   * const isB1Simple = hfInstance.doesCellHaveSimpleValue({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  doesCellHaveSimpleValue(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    return this.getCellType(cellAddress) === CellType.VALUE;
  }
  /**
   * Returns `true` if the specified cell contains a formula.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(A2:A3)', '2'],
   * ]);
   *
   * // should return 'true' since the A1 cell contains a formula
   * const A1Formula = hfInstance.doesCellHaveFormula({ sheet: 0, col: 0, row: 0 });
   *
   * // should return 'false' since the B1 cell does not contain a formula
   * const B1NoFormula = hfInstance.doesCellHaveFormula({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  doesCellHaveFormula(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    const cellType = this.getCellType(cellAddress);
    return cellType === CellType.FORMULA || cellType === CellType.ARRAYFORMULA;
  }
  /**
   * Returns`true` if the specified cell is empty.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *   [null, '1'],
   * ]);
   *
   * // should return 'true', cell of provided coordinates is empty
   * const isEmpty = hfInstance.isCellEmpty({ sheet: 0, col: 0, row: 0 });
   *
   * // should return 'false', cell of provided coordinates is not empty
   * const isNotEmpty = hfInstance.isCellEmpty({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  isCellEmpty(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    return this.getCellType(cellAddress) === CellType.EMPTY;
  }
  /**
   * Returns `true` if a given cell is a part of an array.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *    ['{=TRANSPOSE(B1:B1)}'],
   * ]);
   *
   * // should return 'true', cell of provided coordinates is a part of an array
   * const isPartOfArray = hfInstance.isCellPartOfArray({ sheet: 0, col: 0, row: 0 });
   * ```
   *
   * @category Cells
   */
  isCellPartOfArray(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    const cellType = this.getCellType(cellAddress);
    return cellType === CellType.ARRAY || cellType === CellType.ARRAYFORMULA;
  }
  /**
   * Returns type of the cell value of a given address.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * For more information, see the [Types of values guide](/guide/types-of-values.md).
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['=SUM(1, 2, 3)', '2'],
   * ]);
   *
   * // should return 'NUMBER', cell value type of provided coordinates is a number
   * const cellValue = hfInstance.getCellValueType({ sheet: 0, col: 1, row: 0 });
   *
   * // should return 'NUMBER', cell value type of provided coordinates is a number
   * const cellValue = hfInstance.getCellValueType({ sheet: 0, col: 0, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellValueType(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    this.ensureEvaluationIsNotSuspended();
    const value = this.dependencyGraph.getCellValue(cellAddress);
    return getCellValueType(value);
  }
  /**
   * Returns detailed type of the cell value of a given address.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * For more information, see the [Types of values guide](/guide/types-of-values.md).
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1%', '1$'],
   * ]);
   *
   * // should return 'NUMBER_PERCENT', cell value type of provided coordinates is a number with a format inference percent.
   * const cellType = hfInstance.getCellValueDetailedType({ sheet: 0, col: 0, row: 0 });
   *
   * // should return 'NUMBER_CURRENCY', cell value type of provided coordinates is a number with a format inference currency.
   * const cellType = hfInstance.getCellValueDetailedType({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellValueDetailedType(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    this.ensureEvaluationIsNotSuspended();
    const value = this.dependencyGraph.getCellValue(cellAddress);
    return getCellValueDetailedType(value);
  }
  /**
   * Returns auxiliary format information of the cell value of a given address.
   * The method accepts cell coordinates as object with column, row and sheet numbers.
   *
   * @param {SimpleCellAddress} cellAddress - cell coordinates
   *
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[EvaluationSuspendedError]] when the evaluation is suspended
   * @throws [[ExpectedValueOfTypeError]] if cellAddress is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1$', '1'],
   * ]);
   *
   * // should return '$', cell value type of provided coordinates is a number with a format inference currency, parsed as using '$' as currency.
   * const cellFormat = hfInstance.getCellValueFormat({ sheet: 0, col: 0, row: 0 });
   *
   * // should return undefined, cell value type of provided coordinates is a number with no format information.
   * const cellFormat = hfInstance.getCellValueFormat({ sheet: 0, col: 1, row: 0 });
   * ```
   *
   * @category Cells
   */
  getCellValueFormat(cellAddress) {
    if (!isSimpleCellAddress(cellAddress)) {
      throw new ExpectedValueOfTypeError("SimpleCellAddress", "cellAddress");
    }
    this.ensureEvaluationIsNotSuspended();
    const value = this.dependencyGraph.getCellValue(cellAddress);
    return getCellValueFormat(value);
  }
  /**
   * Returns the number of existing sheets.
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['1', '2'],
   * ]);
   *
   * // should return the number of sheets which is '1'
   * const sheetsCount = hfInstance.countSheets();
   * ```
   *
   * @category Sheets
   */
  countSheets() {
    return this.sheetMapping.numberOfSheets();
  }
  /**
   * Returns information whether it is possible to rename sheet.
   * Returns `true` if the sheet with provided id exists and new name is available
   * Returns `false` if sheet cannot be renamed
   *
   * @param {number} sheetId - a sheet number
   * @param {string} newName - a name of the sheet to be given
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *   MySheet1: [ ['1'] ],
   *   MySheet2: [ ['10'] ],
   * });
   *
   * // returns true
   * hfInstance.isItPossibleToRenameSheet(0, 'MySheet0');
   * ```
   *
   * @category Sheets
   */
  isItPossibleToRenameSheet(sheetId, newName) {
    validateArgToType(sheetId, "number", "sheetId");
    validateArgToType(newName, "string", "newName");
    try {
      this._crudOperations.ensureItIsPossibleToRenameSheet(sheetId, newName);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Renames a specified sheet.
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {number} sheetId - a sheet ID
   * @param {string} newName - a name of the sheet to be given, if is the same as the old one the method does nothing
   *
   * @fires [[sheetRenamed]] after the sheet was renamed
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] when the given sheet ID does not exist
   * @throws [[SheetNameAlreadyTakenError]] when the provided sheet name already exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *   MySheet1: [ ['1'] ],
   *   MySheet2: [ ['10'] ],
   * });
   *
   * // renames the sheet 'MySheet1'
   * hfInstance.renameSheet(0, 'MySheet0');
   * ```
   *
   * @category Sheets
   */
  renameSheet(sheetId, newName) {
    validateArgToType(sheetId, "number", "sheetId");
    validateArgToType(newName, "string", "newName");
    const oldName = this._crudOperations.renameSheet(sheetId, newName);
    this.recomputeIfDependencyGraphNeedsIt();
    if (oldName !== void 0) {
      this._emitter.emit(Events.SheetRenamed, oldName, newName);
    }
  }
  /**
   * Runs the provided callback as a single [batch operation](../../guide/batch-operations.md) and returns the changed cells.
   *
   * Returns [an array of cells whose values changed as a result of all batched operations](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {() => void} batchOperations - a function with operations to be performed
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   * @fires [[evaluationSuspended]] always
   * @fires [[evaluationResumed]] after the recomputation of necessary values
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // multiple operations in a single callback will trigger evaluation only once
   * // and only one set of changes is returned as a combined result of all
   * // the operations that were triggered within the callback
   * const changes = hfInstance.batch(() => {
   *  hfInstance.setCellContents({ col: 3, row: 0, sheet: 0 }, [['=B1']]);
   *  hfInstance.setCellContents({ col: 4, row: 0, sheet: 0 }, [['=A1']]);
   * });
   * ```
   *
   * @category Batch
   */
  batch(batchOperations) {
    this.suspendEvaluation();
    this._crudOperations.beginUndoRedoBatchMode();
    try {
      batchOperations();
    } catch (e) {
      this._crudOperations.commitUndoRedoBatchMode();
      this.resumeEvaluation();
      throw e;
    }
    this._crudOperations.commitUndoRedoBatchMode();
    return this.resumeEvaluation();
  }
  /**
   * Suspends the dependency graph recalculation to start a [batch operation](../../guide/batch-operations.md).
   * It allows optimizing the performance.
   * With this method, multiple CRUD operations can be done without triggering recalculation after every operation.
   * Suspending evaluation should result in an overall faster calculation compared to recalculating after each operation separately.
   * To resume the evaluation use [[resumeEvaluation]].
   *
   * @fires [[evaluationSuspended]] always
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // similar to batch() but operations are not within a callback,
   * // one method suspends the recalculation
   * // the second will resume calculations and return the changes
   *
   * // suspend the evaluation with this method
   * hfInstance.suspendEvaluation();
   *
   * // perform operations
   * hfInstance.setCellContents({ col: 3, row: 0, sheet: 0 }, [['=B1']]);
   * hfInstance.setSheetContent(1, [['50'], ['60']]);
   *
   * // use resumeEvaluation to resume
   * const changes = hfInstance.resumeEvaluation();
   * ```
   *
   * @category Batch
   */
  suspendEvaluation() {
    this._evaluationSuspended = true;
    this._emitter.emit(Events.EvaluationSuspended);
  }
  /**
   * Resumes the dependency graph recalculation that was [suspended](../../guide/batch-operations.md) with [[suspendEvaluation]].
   * It also triggers the recalculation and returns [an array of cells whose values changed as a result of all batched operations](/guide/basic-operations.md#changes-array).
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   * @fires [[evaluationResumed]] after the recomputation of necessary values
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  MySheet1: [ ['1'] ],
   *  MySheet2: [ ['10'] ],
   * });
   *
   * // similar to batch() but operations are not within a callback,
   * // one method suspends the recalculation
   * // the second will resume calculations and return the changes
   *
   * // first, suspend the evaluation
   * hfInstance.suspendEvaluation();
   *
   * // perform operations
   * hfInstance.setCellContents({ col: 3, row: 0, sheet: 0 }, [['=B1']]);
   * hfInstance.setSheetContent(1, [['50'], ['60']]);
   *
   * // resume the evaluation
   * const changes = hfInstance.resumeEvaluation();
   * ```
   *
   * @category Batch
   */
  resumeEvaluation() {
    this._evaluationSuspended = false;
    const changes = this.recomputeIfDependencyGraphNeedsIt();
    this._emitter.emit(Events.EvaluationResumed, changes);
    return changes;
  }
  /**
   * Checks if the dependency graph recalculation process is [suspended](../../guide/batch-operations.md) or not.
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // suspend the evaluation
   * hfInstance.suspendEvaluation();
   *
   * // between suspendEvaluation() and resumeEvaluation()
   * // or inside batch() callback it will return 'true', otherwise 'false'
   * const isEvaluationSuspended = hfInstance.isEvaluationSuspended();
   *
   * const changes = hfInstance.resumeEvaluation();
   * ```
   *
   * @category Batch
   */
  isEvaluationSuspended() {
    return this._evaluationSuspended;
  }
  /**
   * Returns information whether it is possible to add named expression into a specific scope.
   * Checks against particular rules to ascertain that addNamedExpression can be called.
   * If returns `true`, doing [[addNamedExpression]] operation won't throw any errors.
   * Returns `false` if the operation might be disrupted.
   *
   * @param {string} expressionName - a name of the expression to be added
   * @param {RawCellContent} expression - the expression
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // should return 'true' for this example,
   * // it is possible to add named expression to global scope
   * const isAddable = hfInstance.isItPossibleToAddNamedExpression('prettyName', '=Sheet1!$A$1+100');
   * ```
   *
   * @category Named Expressions
   */
  isItPossibleToAddNamedExpression(expressionName, expression, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    try {
      this._crudOperations.ensureItIsPossibleToAddNamedExpression(expressionName, expression, scope);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Adds a specified named expression.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {string} expressionName - a name of the expression to be added
   * @param {RawCellContent} expression - the expression
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   * @param {NamedExpressionOptions?} options - additional metadata related to named expression
   *
   * @fires [[namedExpressionAdded]] always, unless [[batch]] mode is used
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NamedExpressionNameIsAlreadyTakenError]] when the named-expression name is not available.
   * @throws [[NamedExpressionNameIsInvalidError]] when the named-expression name is not valid
   * @throws [[NoRelativeAddressesAllowedError]] when the named-expression formula contains relative references
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add own expression, scope limited to 'Sheet1' (sheetId=0), the method should return a list of cells which values
   * // changed after the operation, their absolute addresses and new values
   * // for this example:
   * // [{
   * //   name: 'prettyName',
   * //   newValue: 142,
   * // }]
   * const changes = hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100', 0);
   * ```
   *
   * @category Named Expressions
   */
  addNamedExpression(expressionName, expression, scope, options) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    this._crudOperations.addNamedExpression(expressionName, expression, scope, options);
    const changes = this.recomputeIfDependencyGraphNeedsIt();
    this._emitter.emit(Events.NamedExpressionAdded, expressionName, changes);
    return changes;
  }
  /**
   * Gets specified named expression value.
   * Returns a [[CellValue]] or undefined if the given named expression does not exist.
   *
   * For more information, see the [Named expressions guide](/guide/named-expressions.md).
   *
   * @param {string} expressionName - expression name, case-insensitive.
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression, only 'Sheet1' (sheetId=0) considered as it is the scope
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100', 'Sheet1');
   *
   * // returns the calculated value of a passed named expression, '142' for this example
   * const myFormula = hfInstance.getNamedExpressionValue('prettyName', 'Sheet1');
   * ```
   *
   * @category Named Expressions
   */
  getNamedExpressionValue(expressionName, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    this.ensureEvaluationIsNotSuspended();
    this._crudOperations.ensureScopeIdIsValid(scope);
    const namedExpression = this._namedExpressions.namedExpressionForScope(expressionName, scope);
    if (namedExpression) {
      return this._serialization.getCellValue(namedExpression.address);
    } else {
      return void 0;
    }
  }
  /**
   * Returns a normalized formula string for given named expression, or `undefined` for a named expression that does not exist or does not hold a formula.
   *
   * For more information, see the [Named expressions guide](/guide/named-expressions.md).
   *
   * @param {string} expressionName - expression name, case-insensitive.
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression in 'Sheet1' (sheetId=0)
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100', 0);
   *
   * // returns a normalized formula string corresponding to the passed name from 'Sheet1' (sheetId=0),
   * // '=Sheet1!A1+100' for this example
   * const myFormula = hfInstance.getNamedExpressionFormula('prettyName', 0);
   * ```
   *
   * @category Named Expressions
   */
  getNamedExpressionFormula(expressionName, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    this._crudOperations.ensureScopeIdIsValid(scope);
    const namedExpression = this._namedExpressions.namedExpressionForScope(expressionName, scope);
    if (namedExpression === void 0) {
      return void 0;
    } else {
      return this._serialization.getCellFormula(namedExpression.address);
    }
  }
  /**
   * Returns a named expression, or `undefined` for a named expression that does not exist or does not hold a formula.
   *
   * For more information, see the [Named expressions guide](/guide/named-expressions.md).
   *
   * @param {string} expressionName - expression name, case-insensitive.
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression in 'Sheet1' (sheetId=0)
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100', 0);
   *
   * // returns a named expression that corresponds to the passed name from 'Sheet1' (sheetId=0)
   * // for this example, returns:
   * // {name: 'prettyName', expression: '=Sheet1!$A$1+100', options: undefined, scope: 0}
   * const myFormula = hfInstance.getNamedExpression('prettyName', 0);
   *
   * // for a named expression that doesn't exist, returns 'undefined':
   * const myFormulaTwo = hfInstance.getNamedExpression('uglyName', 0);
   * ```
   *
   * @category Named Expressions
   */
  getNamedExpression(expressionName, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    const namedExpression = this._namedExpressions.namedExpressionForScope(expressionName, scope);
    if (namedExpression === void 0) {
      return void 0;
    }
    const expression = this._serialization.getCellFormula(namedExpression.address);
    return {
      name: expressionName,
      scope,
      expression,
      options: namedExpression.options
    };
  }
  /**
   * Returns information whether it is possible to change named expression in a specific scope.
   * Checks against particular rules to ascertain that changeNamedExpression can be called.
   * If returns `true`, doing [[changeNamedExpression]] operation won't throw any errors.
   * Returns `false` if the operation might be disrupted.
   *
   * @param {string} expressionName - an expression name, case-insensitive.
   * @param {RawCellContent} newExpression - a new expression
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100');
   *
   * // should return 'true' for this example,
   * // it is possible to change named expression
   * const isAddable = hfInstance.isItPossibleToChangeNamedExpression('prettyName', '=Sheet1!$A$1+100');
   * ```
   *
   * @category Named Expressions
   */
  isItPossibleToChangeNamedExpression(expressionName, newExpression, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    try {
      this._crudOperations.ensureItIsPossibleToChangeNamedExpression(expressionName, newExpression, scope);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Changes a given named expression to a specified formula.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {string} expressionName - an expression name, case-insensitive.
   * @param {RawCellContent} newExpression - a new expression
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   * @param {NamedExpressionOptions?} options - additional metadata related to named expression
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NamedExpressionDoesNotExistError]] when the given expression does not exist.
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   * @throws [[ArrayFormulasNotSupportedError]] when the named expression formula is an array formula
   * @throws [[NoRelativeAddressesAllowedError]] when the named expression formula contains relative references
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression, scope limited to 'Sheet1' (sheetId=0)
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100', 0);
   *
   * // change the named expression
   * const changes = hfInstance.changeNamedExpression('prettyName', '=Sheet1!$A$1+200');
   * ```
   *
   * @category Named Expressions
   */
  changeNamedExpression(expressionName, newExpression, scope, options) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    this._crudOperations.changeNamedExpressionExpression(expressionName, scope, newExpression, options);
    return this.recomputeIfDependencyGraphNeedsIt();
  }
  /**
   * Returns information whether it is possible to remove named expression from a specific scope.
   * Checks against particular rules to ascertain that removeNamedExpression can be called.
   * If returns `true`, doing [[removeNamedExpression]] operation won't throw any errors.
   * Returns `false` if the operation might be disrupted.
   *
   * @param {string} expressionName - an expression name, case-insensitive.
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100');
   *
   * // should return 'true' for this example,
   * // it is possible to change named expression
   * const isAddable = hfInstance.isItPossibleToRemoveNamedExpression('prettyName');
   * ```
   *
   * @category Named Expressions
   */
  isItPossibleToRemoveNamedExpression(expressionName, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    try {
      this._crudOperations.isItPossibleToRemoveNamedExpression(expressionName, scope);
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Removes a named expression.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @param {string} expressionName - expression name, case-insensitive.
   * @param {number?} scope - scope definition, `sheetId` for local scope or `undefined` for global scope
   *
   * @fires [[namedExpressionRemoved]] after the expression was removed
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NamedExpressionDoesNotExistError]] when the given expression does not exist.
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   * ]);
   *
   * // add a named expression
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100', 0);
   *
   * // remove the named expression
   * const changes = hfInstance.removeNamedExpression('prettyName', 0);
   * ```
   *
   * @category Named Expressions
   */
  removeNamedExpression(expressionName, scope) {
    validateArgToType(expressionName, "string", "expressionName");
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    const removedNamedExpression = this._crudOperations.removeNamedExpression(expressionName, scope);
    if (removedNamedExpression) {
      const changes = this.recomputeIfDependencyGraphNeedsIt();
      this._emitter.emit(Events.NamedExpressionRemoved, removedNamedExpression.displayName, changes);
      return changes;
    } else {
      return [];
    }
  }
  /**
   * Lists named expressions.
   * - If scope parameter is provided, returns an array of expression names defined for this scope.
   * - If scope parameter is undefined, returns an array of global expression names.
   *
   * For more information, see the [Named expressions guide](/guide/named-expressions.md).
   *
   * @param {number?} scope - scope of the named expressions, `sheetId` for local scope or `undefined` for global scope
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NoSheetWithIdError]] if no sheet with given sheetId exists
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   *  ['50'],
   *  ['60'],
   * ]);
   *
   * // add two named expressions and one scoped
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100');
   * hfInstance.addNamedExpression('anotherPrettyName', '=Sheet1!$A$2+100');
   * hfInstance.addNamedExpression('alsoPrettyName', '=Sheet1!$A$3+100', 0);
   *
   * // list the expressions, should return: ['prettyName', 'anotherPrettyName'] for this example
   * const listOfExpressions = hfInstance.listNamedExpressions();
   *
   *  // list the expressions, should return: ['alsoPrettyName'] for this example
   * const listOfExpressions = hfInstance.listNamedExpressions(0);
   * ```
   *
   * @category Named Expressions
   */
  listNamedExpressions(scope) {
    if (scope !== void 0) {
      validateArgToType(scope, "number", "scope");
    }
    this._crudOperations.ensureScopeIdIsValid(scope);
    return this._namedExpressions.getAllNamedExpressionsNamesInScope(scope);
  }
  /**
   * Returns all named expressions serialized.
   *
   * For more information, see the [Named expressions guide](/guide/named-expressions.md).
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   *  ['50'],
   *  ['60'],
   * ]);
   *
   * // add two named expressions and one scoped
   * hfInstance.addNamedExpression('prettyName', '=Sheet1!$A$1+100');
   * hfInstance.addNamedExpression('anotherPrettyName', '=Sheet1!$A$2+100');
   * hfInstance.addNamedExpression('prettyName3', '=Sheet1!$A$3+100', 0);
   *
   * // get all expressions serialized
   * // should return:
   * // [
   * // {name: 'prettyName', expression: '=Sheet1!$A$1+100', options: undefined, scope: undefined},
   * // {name: 'anotherPrettyName', expression: '=Sheet1!$A$2+100', options: undefined, scope: undefined},
   * // {name: 'alsoPrettyName', expression: '=Sheet1!$A$3+100', options: undefined, scope: 0}
   * // ]
   * const allExpressions = hfInstance.getAllNamedExpressionsSerialized();
   * ```
   *
   * @category Named Expressions
   */
  getAllNamedExpressionsSerialized() {
    return this._serialization.getAllNamedExpressionsSerialized();
  }
  /**
   * Parses and then unparses a formula.
   * Returns a normalized formula (e.g., restores the original capitalization of sheet names, function names, cell addresses, and named expressions).
   *
   * @param {string} formulaString - a formula in a proper format - it must start with "="
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   * @throws [[NotAFormulaError]] when the provided string is not a valid formula, i.e., does not start with "="
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromArray([
   *  ['42'],
   *  ['50'],
   * ]);
   *
   * // returns '=Sheet1!$A$1+10'
   * const normalizedFormula = hfInstance.normalizeFormula('=SHEET1!$A$1+10');
   *
   * // returns '=3*$A$1'
   * const normalizedFormula = hfInstance.normalizeFormula('=3*$a$1');
   * ```
   *
   * @category Helpers
   */
  normalizeFormula(formulaString) {
    validateArgToType(formulaString, "string", "formulaString");
    const {
      ast,
      address
    } = this.extractTemporaryFormula(formulaString);
    if (ast === void 0) {
      throw new NotAFormulaError();
    }
    return this._unparser.unparse(ast, address);
  }
  /**
   * Calculates fire-and-forget formula, returns the calculated value.
   *
   * @param {string} formulaString - A formula in a proper format, starting with `=`.
   * @param {number} sheetId - The ID of a sheet in context of which the formula gets evaluated.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type arguments is of wrong type.
   * @throws [[NotAFormulaError]] when the provided string is not a valid formula (i.e., doesn't start with `=`).
   * @throws [[NoSheetWithIdError]] when the provided `sheetID` doesn't exist.
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildFromSheets({
   *  Sheet1: [['58']],
   *  Sheet2: [['1', '2', '3'], ['4', '5', '6']]
   * });
   *
   * // returns the calculated formula's value
   * // for this example, returns `68`
   * const calculatedFormula = hfInstance.calculateFormula('=A1+10', 0);
   *
   * // for this example, returns [['11', '12', '13'], ['14', '15', '16']]
   * const calculatedFormula = hfInstance.calculateFormula('=A1:B3+10', 1);
   * ```
   *
   * @category Helpers
   */
  calculateFormula(formulaString, sheetId) {
    validateArgToType(formulaString, "string", "formulaString");
    validateArgToType(sheetId, "number", "sheetId");
    this._crudOperations.ensureScopeIdIsValid(sheetId);
    const {
      ast,
      address,
      dependencies
    } = this.extractTemporaryFormula(formulaString, sheetId);
    if (ast === void 0) {
      throw new NotAFormulaError();
    }
    const internalCellValue = this.evaluator.runAndForget(ast, address, dependencies);
    return this._exporter.exportScalarOrRange(internalCellValue);
  }
  /**
   * Return a list of named expressions used by a formula.
   *
   * @param {string} formulaString - A formula in a proper format, starting with `=`.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type arguments is of wrong type.
   * @throws [[NotAFormulaError]] when the provided string is not a valid formula (i.e., doesn't start with `=`).
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // returns a list of named expressions used by a formula
   * // for this example, returns ['foo', 'bar']
   * const namedExpressions = hfInstance.getNamedExpressionsFromFormula('=foo+bar*2');
   * ```
   *
   * @category Helpers
   */
  getNamedExpressionsFromFormula(formulaString) {
    validateArgToType(formulaString, "string", "formulaString");
    const {
      ast,
      dependencies
    } = this.extractTemporaryFormula(formulaString);
    if (ast === void 0) {
      throw new NotAFormulaError();
    }
    const namedExpressionDependencies = dependencies.filter((dep) => dep instanceof NamedExpressionDependency).map((namedExpr) => namedExpr.name);
    const uniqueNamedExpressionDependencies = [...new Set(namedExpressionDependencies)];
    return uniqueNamedExpressionDependencies;
  }
  /**
   * Validates the formula.
   * If the provided string starts with "=" and is a parsable formula, the method returns `true`.
   * The validation is purely grammatical: the method doesn't verify if the formula can be calculated or not.
   *
   * @param {string} formulaString -  a formula in a proper format - it must start with "="
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * // checks if the given string is a valid formula, should return 'true' for this example
   * const isFormula = hfInstance.validateFormula('=SUM(1, 2)');
   * ```
   *
   * @category Helpers
   */
  validateFormula(formulaString) {
    validateArgToType(formulaString, "string", "formulaString");
    const {
      ast
    } = this.extractTemporaryFormula(formulaString);
    return ast !== void 0;
  }
  /**
   * Returns translated names of all functions registered in this instance of HyperFormula
   * according to the language set in the configuration
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // return translated names of all functions, assign to a variable
   * const allNames = hfInstance.getRegisteredFunctionNames();
   * ```
   *
   * @category Custom Functions
   */
  getRegisteredFunctionNames() {
    const language = HyperFormula.getLanguage(this._config.language);
    return language.getFunctionTranslations(this._functionRegistry.getRegisteredFunctionIds());
  }
  /**
   * Returns class of a plugin used by function with given id
   *
   * For more information, see the [Custom functions guide](/guide/custom-functions.md).
   *
   * @param {string} functionId - id of a function, e.g., 'SUMIF'
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * // import your own plugin
   * import { MyExamplePlugin } from './file_with_your_plugin';
   *
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // register a plugin
   * HyperFormula.registerFunctionPlugin(MyExamplePlugin);
   *
   * // get the plugin
   * const myPlugin = hfInstance.getFunctionPlugin('EXAMPLE');
   * ```
   *
   * @category Custom Functions
   */
  getFunctionPlugin(functionId) {
    validateArgToType(functionId, "string", "functionId");
    return this._functionRegistry.getFunctionPlugin(functionId);
  }
  /**
   * Returns classes of all plugins registered in this instance of HyperFormula
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // return classes of all plugins registered, assign to a variable
   * const allNames = hfInstance.getAllFunctionPlugins();
   * ```
   *
   * @category Custom Functions
   */
  getAllFunctionPlugins() {
    return this._functionRegistry.getPlugins();
  }
  /**
   * Interprets number as a date + time.
   *
   * For more information, see the [Date and time handling guide](/guide/date-and-time-handling.md).
   *
   * @param {number} inputNumber - number of days since nullDate, should be non-negative, fractions are interpreted as hours/minutes/seconds.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // pass the number of days since nullDate
   * // the method should return formatted date and time, for this example:
   * // {year: 2020, month: 1, day: 15, hours: 2, minutes: 24, seconds: 0}
   * const dateTimeFromNumber = hfInstance.numberToDateTime(43845.1);
   *
   * ```
   *
   * @category Helpers
   */
  numberToDateTime(inputNumber) {
    validateArgToType(inputNumber, "number", "val");
    return this._evaluator.interpreter.dateTimeHelper.numberToSimpleDateTime(inputNumber);
  }
  /**
   * Interprets number as a date.
   *
   * For more information, see the [Date and time handling guide](/guide/date-and-time-handling.md).
   *
   * @param {number} inputNumber - number of days since nullDate, should be non-negative, fractions are ignored.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // pass the number of days since nullDate
   * // the method should return formatted date, for this example:
   * // {year: 2020, month: 1, day: 15}
   * const dateFromNumber = hfInstance.numberToDate(43845);
   * ```
   *
   * @category Helpers
   */
  numberToDate(inputNumber) {
    validateArgToType(inputNumber, "number", "val");
    return this._evaluator.interpreter.dateTimeHelper.numberToSimpleDate(inputNumber);
  }
  /**
   * Interprets number as a time (hours/minutes/seconds).
   *
   * For more information, see the [Date and time handling guide](/guide/date-and-time-handling.md).
   *
   * @param {number} inputNumber - time in 24h units.
   *
   * @throws [[ExpectedValueOfTypeError]] if any of its basic type argument is of wrong type
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // pass a number to be interpreted as a time
   * // should return {hours: 26, minutes: 24} for this example
   * const timeFromNumber = hfInstance.numberToTime(1.1);
   * ```
   *
   * @category Helpers
   */
  numberToTime(inputNumber) {
    validateArgToType(inputNumber, "number", "val");
    return numberToSimpleTime(inputNumber);
  }
  /**
   * Subscribes to an event.
   * For the list of all available events, see [[Listeners]].
   *
   * @param {Event} event the name of the event to subscribe to
   * @param {Listener} listener to be called when event is emitted
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // subscribe to a 'sheetAdded', pass a simple handler
   * hfInstance.on('sheetAdded', ( ) => { console.log('foo') });
   *
   * // add a sheet to trigger an event,
   * // console should print 'foo' after each time sheet is added in this example
   * hfInstance.addSheet('FooBar');
   * ```
   *
   * @category Events
   */
  on(event, listener) {
    this._emitter.on(event, listener);
  }
  /**
   * Subscribes to an event once.
   * For the list of all available events, see [[Listeners]].
   *
   * @param {Event} event the name of the event to subscribe to
   * @param {Listener} listener to be called when event is emitted
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // subscribe to a 'sheetAdded', pass a simple handler
   * hfInstance.once('sheetAdded', ( ) => { console.log('foo') });
   *
   * // call addSheet twice,
   * // console should print 'foo' only once when the sheet is added in this example
   * hfInstance.addSheet('FooBar');
   * hfInstance.addSheet('FooBaz');
   * ```
   *
   * @category Events
   */
  once(event, listener) {
    this._emitter.once(event, listener);
  }
  /**
   * Unsubscribes from an event or from all events.
   * For the list of all available events, see [[Listeners]].
   *
   * @param {Event} event the name of the event to subscribe to
   * @param {Listener} listener to be called when event is emitted
   *
   * @example
   * ```js
   * const hfInstance = HyperFormula.buildEmpty();
   *
   * // define a simple function to be called upon emitting an event
   * const handler = ( ) => { console.log('baz') }
   *
   * // subscribe to a 'sheetAdded', pass the handler
   * hfInstance.on('sheetAdded', handler);
   *
   * // add a sheet to trigger an event,
   * // console should print 'baz' each time a sheet is added
   * hfInstance.addSheet('FooBar');
   *
   * // unsubscribe from a 'sheetAdded'
   * hfInstance.off('sheetAdded', handler);
   *
   * // add a sheet, the console should not print anything
   * hfInstance.addSheet('FooBaz');
   * ```
   *
   * @category Events
   */
  off(event, listener) {
    this._emitter.off(event, listener);
  }
  /**
   * Destroys instance of HyperFormula.
   *
   * @example
   * ```js
   * // destroys the instance
   * hfInstance.destroy();
   * ```
   *
   * @category Instance
   */
  destroy() {
    objectDestroy(this);
  }
  /**
   * Throws an error if evaluation is suspended.
   *
   * @internal
   */
  ensureEvaluationIsNotSuspended() {
    if (this._evaluationSuspended) {
      throw new EvaluationSuspendedError();
    }
  }
  /**
   * Parses a formula string and extracts its AST and dependencies.
   *
   * @internal
   */
  extractTemporaryFormula(formulaString, sheetId = 1) {
    const parsedCellContent = this._cellContentParser.parse(formulaString);
    const address = {
      sheet: sheetId,
      col: 0,
      row: 0
    };
    if (!(parsedCellContent instanceof CellContent.Formula)) {
      return {
        address,
        dependencies: []
      };
    }
    const {
      ast,
      errors,
      dependencies
    } = this._parser.parse(parsedCellContent.formula, address);
    if (errors.length > 0) {
      return {
        address,
        dependencies: []
      };
    }
    return {
      ast,
      address,
      dependencies
    };
  }
  /**
   * Rebuilds the engine with new configuration.
   */
  rebuildWithConfig(newParams) {
    const newConfig = this._config.mergeConfig(newParams);
    const configNewLanguage = this._config.mergeConfig({
      language: newParams.language
    });
    const serializedSheets = this._serialization.withNewConfig(configNewLanguage, this._namedExpressions).getAllSheetsSerialized();
    const serializedNamedExpressions = this._serialization.getAllNamedExpressionsSerialized();
    const newEngine = BuildEngineFactory.rebuildWithConfig(newConfig, serializedSheets, serializedNamedExpressions, this._stats);
    this._config = newEngine.config;
    this._stats = newEngine.stats;
    this._dependencyGraph = newEngine.dependencyGraph;
    this._columnSearch = newEngine.columnSearch;
    this._parser = newEngine.parser;
    this._unparser = newEngine.unparser;
    this._cellContentParser = newEngine.cellContentParser;
    this._evaluator = newEngine.evaluator;
    this._lazilyTransformingAstService = newEngine.lazilyTransformingAstService;
    this._crudOperations = newEngine.crudOperations;
    this._exporter = newEngine.exporter;
    this._namedExpressions = newEngine.namedExpressions;
    this._serialization = newEngine.serialization;
    this._functionRegistry = newEngine.functionRegistry;
  }
  /**
   * When enough transformations have accumulated, forces all formula vertices and
   * column index entries to apply pending lazy transformations, then compacts the
   * transformation history and cleans up orphaned undo oldData entries.
   */
  compactLazyTransformationsIfNeeded() {
    var _a;
    if (this._lazilyTransformingAstService.needsCompaction()) {
      this._dependencyGraph.forceApplyPostponedTransformations();
      this._columnSearch.forceApplyPostponedTransformations();
      this._lazilyTransformingAstService.compact();
      (_a = this._lazilyTransformingAstService.undoRedo) === null || _a === void 0 ? void 0 : _a.cleanupOrphanedOldData();
    }
  }
  /**
   * Runs a recomputation starting from recently changed vertices.
   *
   * Returns [an array of cells whose values changed as a result of this operation](/guide/basic-operations.md#changes-array).
   *
   * Note that this method may trigger dependency graph recalculation.
   *
   * @fires [[valuesUpdated]] if recalculation was triggered by this change
   */
  recomputeIfDependencyGraphNeedsIt() {
    if (!this._evaluationSuspended) {
      const changes = this._crudOperations.getAndClearContentChanges();
      const verticesToRecomputeFrom = this.dependencyGraph.verticesToRecompute();
      this.dependencyGraph.clearDirtyVertices();
      this.compactLazyTransformationsIfNeeded();
      if (verticesToRecomputeFrom.length > 0) {
        changes.addAll(this.evaluator.partialRun(verticesToRecomputeFrom));
      }
      const exportedChanges = changes.exportChanges(this._exporter);
      if (!changes.isEmpty()) {
        this._emitter.emit(Events.ValuesUpdated, exportedChanges);
      }
      return exportedChanges;
    } else {
      return [];
    }
  }
}
HyperFormula.version = "3.3.0";
HyperFormula.buildDate = "20/05/2026 14:43:58";
HyperFormula.releaseDate = "20/05/2026";
HyperFormula.languages = {};
HyperFormula.registeredLanguages = /* @__PURE__ */ new Map();
const privatePool = /* @__PURE__ */ new WeakMap();
class Config {
  constructor(options = {}, showDeprecatedWarns = true) {
    const {
      accentSensitive,
      caseSensitive,
      caseFirst,
      chooseAddressMappingPolicy,
      context,
      currencySymbol,
      dateFormats,
      decimalSeparator,
      evaluateNullToZero,
      functionArgSeparator,
      functionPlugins,
      ignorePunctuation,
      leapYear1900,
      localeLang,
      language,
      ignoreWhiteSpace,
      licenseKey,
      matchWholeCell,
      arrayColumnSeparator,
      arrayRowSeparator,
      maxRows,
      maxColumns,
      nullYear,
      nullDate,
      parseDateTime,
      precisionEpsilon,
      precisionRounding,
      stringifyDateTime,
      stringifyDuration,
      smartRounding,
      timeFormats,
      thousandSeparator,
      useArrayArithmetic,
      useStats,
      undoLimit,
      maxPendingLazyTransformations,
      useColumnIndex,
      useRegularExpressions,
      useWildcards
    } = options;
    this.useArrayArithmetic = configValueFromParam(useArrayArithmetic, "boolean", "useArrayArithmetic");
    this.accentSensitive = configValueFromParam(accentSensitive, "boolean", "accentSensitive");
    this.caseSensitive = configValueFromParam(caseSensitive, "boolean", "caseSensitive");
    this.caseFirst = configValueFromParam(caseFirst, ["upper", "lower", "false"], "caseFirst");
    this.ignorePunctuation = configValueFromParam(ignorePunctuation, "boolean", "ignorePunctuation");
    this.chooseAddressMappingPolicy = chooseAddressMappingPolicy !== null && chooseAddressMappingPolicy !== void 0 ? chooseAddressMappingPolicy : Config.defaultConfig.chooseAddressMappingPolicy;
    this.dateFormats = [...configValueFromParamCheck(dateFormats, Array.isArray, "array", "dateFormats")];
    this.timeFormats = [...configValueFromParamCheck(timeFormats, Array.isArray, "array", "timeFormats")];
    this.functionArgSeparator = configValueFromParam(functionArgSeparator, "string", "functionArgSeparator");
    this.decimalSeparator = configValueFromParam(decimalSeparator, [".", ","], "decimalSeparator");
    this.language = configValueFromParam(language, "string", "language");
    this.ignoreWhiteSpace = configValueFromParam(ignoreWhiteSpace, ["standard", "any"], "ignoreWhiteSpace");
    this.licenseKey = configValueFromParam(licenseKey, "string", "licenseKey");
    this.thousandSeparator = configValueFromParam(thousandSeparator, ["", ",", " ", "."], "thousandSeparator");
    this.arrayColumnSeparator = configValueFromParam(arrayColumnSeparator, [",", ";"], "arrayColumnSeparator");
    this.arrayRowSeparator = configValueFromParam(arrayRowSeparator, [";", "|"], "arrayRowSeparator");
    this.localeLang = configValueFromParam(localeLang, "string", "localeLang");
    this.functionPlugins = [...functionPlugins !== null && functionPlugins !== void 0 ? functionPlugins : Config.defaultConfig.functionPlugins];
    this.smartRounding = configValueFromParam(smartRounding, "boolean", "smartRounding");
    this.evaluateNullToZero = configValueFromParam(evaluateNullToZero, "boolean", "evaluateNullToZero");
    this.nullYear = configValueFromParam(nullYear, "number", "nullYear");
    validateNumberToBeAtLeast(this.nullYear, "nullYear", 0);
    validateNumberToBeAtMost(this.nullYear, "nullYear", 100);
    this.precisionRounding = configValueFromParam(precisionRounding, "number", "precisionRounding");
    validateNumberToBeAtLeast(this.precisionRounding, "precisionRounding", 0);
    this.precisionEpsilon = configValueFromParam(precisionEpsilon, "number", "precisionEpsilon");
    validateNumberToBeAtLeast(this.precisionEpsilon, "precisionEpsilon", 0);
    this.useColumnIndex = configValueFromParam(useColumnIndex, "boolean", "useColumnIndex");
    this.useStats = configValueFromParam(useStats, "boolean", "useStats");
    this.parseDateTime = configValueFromParam(parseDateTime, "function", "parseDateTime");
    this.stringifyDateTime = configValueFromParam(stringifyDateTime, "function", "stringifyDateTime");
    this.stringifyDuration = configValueFromParam(stringifyDuration, "function", "stringifyDuration");
    this.translationPackage = HyperFormula.getLanguage(this.language);
    this.errorMapping = this.translationPackage.buildErrorMapping();
    this.nullDate = configValueFromParamCheck(nullDate, instanceOfSimpleDate, "IDate", "nullDate");
    this.leapYear1900 = configValueFromParam(leapYear1900, "boolean", "leapYear1900");
    this.undoLimit = configValueFromParam(undoLimit, "number", "undoLimit");
    this.maxPendingLazyTransformations = configValueFromParam(maxPendingLazyTransformations, "number", "maxPendingLazyTransformations");
    this.useRegularExpressions = configValueFromParam(useRegularExpressions, "boolean", "useRegularExpressions");
    this.useWildcards = configValueFromParam(useWildcards, "boolean", "useWildcards");
    this.matchWholeCell = configValueFromParam(matchWholeCell, "boolean", "matchWholeCell");
    validateNumberToBeAtLeast(this.undoLimit, "undoLimit", 0);
    validateNumberToBeAtLeast(this.maxPendingLazyTransformations, "maxPendingLazyTransformations", 1);
    this.maxRows = configValueFromParam(maxRows, "number", "maxRows");
    validateNumberToBeAtLeast(this.maxRows, "maxRows", 1);
    this.maxColumns = configValueFromParam(maxColumns, "number", "maxColumns");
    this.currencySymbol = this.setupCurrencySymbol(currencySymbol);
    validateNumberToBeAtLeast(this.maxColumns, "maxColumns", 1);
    this.context = context;
    privatePool.set(this, {
      licenseKeyValidityState: checkLicenseKeyValidity(this.licenseKey)
    });
    configCheckIfParametersNotInConflict({
      value: this.decimalSeparator,
      name: "decimalSeparator"
    }, {
      value: this.functionArgSeparator,
      name: "functionArgSeparator"
    }, {
      value: this.thousandSeparator,
      name: "thousandSeparator"
    });
    configCheckIfParametersNotInConflict({
      value: this.arrayRowSeparator,
      name: "arrayRowSeparator"
    }, {
      value: this.arrayColumnSeparator,
      name: "arrayColumnSeparator"
    });
  }
  setupCurrencySymbol(currencySymbol) {
    const valueAfterCheck = [...configValueFromParamCheck(currencySymbol, Array.isArray, "array", "currencySymbol")];
    valueAfterCheck.forEach((val) => {
      if (typeof val !== "string") {
        throw new ExpectedValueOfTypeError("string[]", "currencySymbol");
      }
      if (val === "") {
        throw new ConfigValueEmpty("currencySymbol");
      }
    });
    return valueAfterCheck;
  }
  /**
   * Proxied property to its private counterpart. This makes the property
   * as accessible as the other Config options but without ability to change the value.
   *
   * @internal
   */
  get licenseKeyValidityState() {
    return privatePool.get(this).licenseKeyValidityState;
  }
  getConfig() {
    return getFullConfigFromPartial(this);
  }
  mergeConfig(init) {
    const mergedConfig = Object.assign({}, this.getConfig(), init);
    return new Config(mergedConfig, false);
  }
  static warnDeprecatedOptions(options) {
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static warnDeprecatedIfUsed(inputValue, paramName, fromVersion, replacementName) {
    if (inputValue !== void 0) {
      if (replacementName === void 0) {
        console.warn(`${paramName} option is deprecated since ${fromVersion}`);
      } else {
        console.warn(`${paramName} option is deprecated since ${fromVersion}, please use ${replacementName}`);
      }
    }
  }
}
Config.defaultConfig = {
  accentSensitive: false,
  currencySymbol: ["$"],
  caseSensitive: false,
  caseFirst: "lower",
  context: void 0,
  chooseAddressMappingPolicy: new AlwaysDense(),
  dateFormats: ["DD/MM/YYYY", "DD/MM/YY"],
  decimalSeparator: ".",
  evaluateNullToZero: false,
  functionArgSeparator: ",",
  functionPlugins: [],
  ignorePunctuation: false,
  language: "enGB",
  ignoreWhiteSpace: "standard",
  licenseKey: "",
  leapYear1900: false,
  localeLang: "en",
  matchWholeCell: true,
  arrayColumnSeparator: ",",
  arrayRowSeparator: ";",
  maxRows: 4e4,
  maxColumns: 18278,
  nullYear: 30,
  nullDate: {
    year: 1899,
    month: 12,
    day: 30
  },
  parseDateTime: defaultParseToDateTime,
  precisionEpsilon: 1e-13,
  precisionRounding: 10,
  smartRounding: true,
  stringifyDateTime: defaultStringifyDateTime,
  stringifyDuration: defaultStringifyDuration,
  timeFormats: ["hh:mm", "hh:mm:ss.sss"],
  thousandSeparator: "",
  undoLimit: 20,
  maxPendingLazyTransformations: 50,
  useRegularExpressions: false,
  useWildcards: true,
  useColumnIndex: false,
  useStats: false,
  useArrayArithmetic: false
};
function getFullConfigFromPartial(partialConfig) {
  var _a;
  const ret = {};
  for (const key in Config.defaultConfig) {
    const val = (_a = partialConfig[key]) !== null && _a !== void 0 ? _a : Config.defaultConfig[key];
    if (Array.isArray(val)) {
      ret[key] = [...val];
    } else {
      ret[key] = val;
    }
  }
  return ret;
}
function getDefaultConfig() {
  return getFullConfigFromPartial({});
}
const dictionary = {
  errors: {
    CYCLE: "#CYCLE!",
    DIV_BY_ZERO: "#DIV/0!",
    ERROR: "#ERROR!",
    NA: "#N/A",
    NAME: "#NAME?",
    NUM: "#NUM!",
    REF: "#REF!",
    SPILL: "#SPILL!",
    VALUE: "#VALUE!"
  },
  functions: {
    FILTER: "FILTER",
    ADDRESS: "ADDRESS",
    "ARRAY_CONSTRAIN": "ARRAY_CONSTRAIN",
    ARRAYFORMULA: "ARRAYFORMULA",
    ABS: "ABS",
    ACOS: "ACOS",
    ACOSH: "ACOSH",
    ACOT: "ACOT",
    ACOTH: "ACOTH",
    AND: "AND",
    ARABIC: "ARABIC",
    ASIN: "ASIN",
    ASINH: "ASINH",
    ATAN2: "ATAN2",
    ATAN: "ATAN",
    ATANH: "ATANH",
    AVERAGE: "AVERAGE",
    AVERAGEA: "AVERAGEA",
    AVERAGEIF: "AVERAGEIF",
    BASE: "BASE",
    BIN2DEC: "BIN2DEC",
    BIN2HEX: "BIN2HEX",
    BIN2OCT: "BIN2OCT",
    BITAND: "BITAND",
    BITLSHIFT: "BITLSHIFT",
    BITOR: "BITOR",
    BITRSHIFT: "BITRSHIFT",
    BITXOR: "BITXOR",
    CEILING: "CEILING",
    CHAR: "CHAR",
    CHOOSE: "CHOOSE",
    CLEAN: "CLEAN",
    CODE: "CODE",
    COLUMN: "COLUMN",
    COLUMNS: "COLUMNS",
    CONCATENATE: "CONCATENATE",
    CORREL: "CORREL",
    COS: "COS",
    COSH: "COSH",
    COT: "COT",
    COTH: "COTH",
    COUNT: "COUNT",
    COUNTA: "COUNTA",
    COUNTBLANK: "COUNTBLANK",
    COUNTIF: "COUNTIF",
    COUNTIFS: "COUNTIFS",
    COUNTUNIQUE: "COUNTUNIQUE",
    CSC: "CSC",
    CSCH: "CSCH",
    CUMIPMT: "CUMIPMT",
    CUMPRINC: "CUMPRINC",
    DATE: "DATE",
    DATEDIF: "DATEDIF",
    DATEVALUE: "DATEVALUE",
    DAY: "DAY",
    DAYS360: "DAYS360",
    DAYS: "DAYS",
    DB: "DB",
    DAVERAGE: "DAVERAGE",
    DCOUNT: "DCOUNT",
    DCOUNTA: "DCOUNTA",
    DGET: "DGET",
    DMAX: "DMAX",
    DMIN: "DMIN",
    DPRODUCT: "DPRODUCT",
    DSTDEV: "DSTDEV",
    DSTDEVP: "DSTDEVP",
    DSUM: "DSUM",
    DVAR: "DVAR",
    DVARP: "DVARP",
    DDB: "DDB",
    DEC2BIN: "DEC2BIN",
    DEC2HEX: "DEC2HEX",
    DEC2OCT: "DEC2OCT",
    DECIMAL: "DECIMAL",
    DEGREES: "DEGREES",
    DELTA: "DELTA",
    DOLLARDE: "DOLLARDE",
    DOLLARFR: "DOLLARFR",
    EDATE: "EDATE",
    EFFECT: "EFFECT",
    EOMONTH: "EOMONTH",
    ERF: "ERF",
    ERFC: "ERFC",
    EVEN: "EVEN",
    EXACT: "EXACT",
    EXP: "EXP",
    FALSE: "FALSE",
    FIND: "FIND",
    FORMULATEXT: "FORMULATEXT",
    FV: "FV",
    FVSCHEDULE: "FVSCHEDULE",
    HEX2BIN: "HEX2BIN",
    HEX2DEC: "HEX2DEC",
    HEX2OCT: "HEX2OCT",
    HLOOKUP: "HLOOKUP",
    HOUR: "HOUR",
    HYPERLINK: "HYPERLINK",
    IF: "IF",
    IFERROR: "IFERROR",
    IFNA: "IFNA",
    IFS: "IFS",
    INDEX: "INDEX",
    INT: "INT",
    INTERVAL: "INTERVAL",
    IPMT: "IPMT",
    IRR: "IRR",
    ISBINARY: "ISBINARY",
    ISBLANK: "ISBLANK",
    ISERR: "ISERR",
    ISERROR: "ISERROR",
    ISEVEN: "ISEVEN",
    ISFORMULA: "ISFORMULA",
    ISLOGICAL: "ISLOGICAL",
    ISNA: "ISNA",
    ISNONTEXT: "ISNONTEXT",
    ISNUMBER: "ISNUMBER",
    ISODD: "ISODD",
    ISOWEEKNUM: "ISOWEEKNUM",
    ISPMT: "ISPMT",
    ISREF: "ISREF",
    ISTEXT: "ISTEXT",
    LEFT: "LEFT",
    LEN: "LEN",
    LN: "LN",
    LOG10: "LOG10",
    LOG: "LOG",
    LOWER: "LOWER",
    MATCH: "MATCH",
    MAX: "MAX",
    MAXA: "MAXA",
    MAXIFS: "MAXIFS",
    MAXPOOL: "MAXPOOL",
    MEDIAN: "MEDIAN",
    MEDIANPOOL: "MEDIANPOOL",
    MID: "MID",
    MIN: "MIN",
    MINA: "MINA",
    MINIFS: "MINIFS",
    MINUTE: "MINUTE",
    MIRR: "MIRR",
    MMULT: "MMULT",
    MOD: "MOD",
    MONTH: "MONTH",
    N: "N",
    NA: "NA",
    NETWORKDAYS: "NETWORKDAYS",
    "NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
    NOMINAL: "NOMINAL",
    NOT: "NOT",
    NOW: "NOW",
    NPER: "NPER",
    NPV: "NPV",
    OCT2BIN: "OCT2BIN",
    OCT2DEC: "OCT2DEC",
    OCT2HEX: "OCT2HEX",
    ODD: "ODD",
    OFFSET: "OFFSET",
    OR: "OR",
    PI: "PI",
    PMT: "PMT",
    PDURATION: "PDURATION",
    PRODUCT: "PRODUCT",
    POWER: "POWER",
    PPMT: "PPMT",
    PROPER: "PROPER",
    PV: "PV",
    RADIANS: "RADIANS",
    RAND: "RAND",
    RATE: "RATE",
    REPLACE: "REPLACE",
    REPT: "REPT",
    RIGHT: "RIGHT",
    ROMAN: "ROMAN",
    ROUND: "ROUND",
    ROUNDDOWN: "ROUNDDOWN",
    ROUNDUP: "ROUNDUP",
    ROW: "ROW",
    ROWS: "ROWS",
    RRI: "RRI",
    SEARCH: "SEARCH",
    SEC: "SEC",
    SECH: "SECH",
    SECOND: "SECOND",
    SEQUENCE: "SEQUENCE",
    SHEET: "SHEET",
    SHEETS: "SHEETS",
    SIN: "SIN",
    SINH: "SINH",
    SLN: "SLN",
    SPLIT: "SPLIT",
    SQRT: "SQRT",
    STDEVA: "STDEVA",
    "STDEV.P": "STDEV.P",
    STDEVPA: "STDEVPA",
    "STDEV.S": "STDEV.S",
    SUBSTITUTE: "SUBSTITUTE",
    SUBTOTAL: "SUBTOTAL",
    SUM: "SUM",
    SUMIF: "SUMIF",
    SUMIFS: "SUMIFS",
    SUMPRODUCT: "SUMPRODUCT",
    SUMSQ: "SUMSQ",
    SWITCH: "SWITCH",
    SYD: "SYD",
    T: "T",
    TAN: "TAN",
    TANH: "TANH",
    TBILLEQ: "TBILLEQ",
    TBILLPRICE: "TBILLPRICE",
    TBILLYIELD: "TBILLYIELD",
    TEXT: "TEXT",
    TEXTJOIN: "TEXTJOIN",
    TIME: "TIME",
    TIMEVALUE: "TIMEVALUE",
    TODAY: "TODAY",
    TRANSPOSE: "TRANSPOSE",
    TRIM: "TRIM",
    TRUE: "TRUE",
    TRUNC: "TRUNC",
    UNICHAR: "UNICHAR",
    UNICODE: "UNICODE",
    UPPER: "UPPER",
    VALUE: "VALUE",
    VARA: "VARA",
    "VAR.P": "VAR.P",
    VARPA: "VARPA",
    "VAR.S": "VAR.S",
    VLOOKUP: "VLOOKUP",
    WEEKDAY: "WEEKDAY",
    WEEKNUM: "WEEKNUM",
    WORKDAY: "WORKDAY",
    "WORKDAY.INTL": "WORKDAY.INTL",
    XNPV: "XNPV",
    XOR: "XOR",
    XLOOKUP: "XLOOKUP",
    YEAR: "YEAR",
    YEARFRAC: "YEARFRAC",
    "HF.ADD": "HF.ADD",
    "HF.CONCAT": "HF.CONCAT",
    "HF.DIVIDE": "HF.DIVIDE",
    "HF.EQ": "HF.EQ",
    "HF.GT": "HF.GT",
    "HF.GTE": "HF.GTE",
    "HF.LT": "HF.LT",
    "HF.LTE": "HF.LTE",
    "HF.MINUS": "HF.MINUS",
    "HF.MULTIPLY": "HF.MULTIPLY",
    "HF.NE": "HF.NE",
    "HF.POW": "HF.POW",
    "HF.UMINUS": "HF.UMINUS",
    "HF.UNARY_PERCENT": "HF.UNARY_PERCENT",
    "HF.UPLUS": "HF.UPLUS",
    VARP: "VARP",
    VAR: "VAR",
    STDEVP: "STDEVP",
    STDEV: "STDEV",
    "EXPON.DIST": "EXPON.DIST",
    FISHER: "FISHER",
    FISHERINV: "FISHERINV",
    GAMMA: "GAMMA",
    "GAMMA.DIST": "GAMMA.DIST",
    GAMMALN: "GAMMALN",
    "GAMMALN.PRECISE": "GAMMALN.PRECISE",
    "GAMMA.INV": "GAMMA.INV",
    GAUSS: "GAUSS",
    FACT: "FACT",
    FACTDOUBLE: "FACTDOUBLE",
    COMBIN: "COMBIN",
    COMBINA: "COMBINA",
    GCD: "GCD",
    LCM: "LCM",
    MROUND: "MROUND",
    MULTINOMIAL: "MULTINOMIAL",
    QUOTIENT: "QUOTIENT",
    RANDBETWEEN: "RANDBETWEEN",
    SERIESSUM: "SERIESSUM",
    SIGN: "SIGN",
    SQRTPI: "SQRTPI",
    SUMX2MY2: "SUMX2MY2",
    SUMX2PY2: "SUMX2PY2",
    SUMXMY2: "SUMXMY2",
    "EXPONDIST": "EXPONDIST",
    GAMMADIST: "GAMMADIST",
    GAMMAINV: "GAMMAINV",
    "BETA.DIST": "BETA.DIST",
    BETADIST: "BETADIST",
    "BETA.INV": "BETA.INV",
    BETAINV: "BETAINV",
    "BINOM.DIST": "BINOM.DIST",
    BINOMDIST: "BINOMDIST",
    "BINOM.INV": "BINOM.INV",
    BESSELI: "BESSELI",
    BESSELJ: "BESSELJ",
    BESSELK: "BESSELK",
    BESSELY: "BESSELY",
    "CHISQ.DIST": "CHISQ.DIST",
    "CHISQ.DIST.RT": "CHISQ.DIST.RT",
    "CHISQ.INV": "CHISQ.INV",
    "CHISQ.INV.RT": "CHISQ.INV.RT",
    CHIDIST: "CHIDIST",
    CHIINV: "CHIINV",
    "F.DIST": "F.DIST",
    "F.DIST.RT": "F.DIST.RT",
    "F.INV": "F.INV",
    "F.INV.RT": "F.INV.RT",
    FDIST: "FDIST",
    FINV: "FINV",
    WEIBULL: "WEIBULL",
    "WEIBULL.DIST": "WEIBULL.DIST",
    POISSON: "POISSON",
    "POISSON.DIST": "POISSON.DIST",
    "HYPGEOM.DIST": "HYPGEOM.DIST",
    HYPGEOMDIST: "HYPGEOMDIST",
    "T.DIST": "T.DIST",
    "T.DIST.2T": "T.DIST.2T",
    "T.DIST.RT": "T.DIST.RT",
    "T.INV": "T.INV",
    "T.INV.2T": "T.INV.2T",
    TDIST: "TDIST",
    TINV: "TINV",
    LOGINV: "LOGINV",
    "LOGNORM.DIST": "LOGNORM.DIST",
    "LOGNORM.INV": "LOGNORM.INV",
    LOGNORMDIST: "LOGNORMDIST",
    "NORM.DIST": "NORM.DIST",
    "NORM.INV": "NORM.INV",
    "NORM.S.DIST": "NORM.S.DIST",
    "NORM.S.INV": "NORM.S.INV",
    NORMDIST: "NORMDIST",
    NORMINV: "NORMINV",
    NORMSDIST: "NORMSDIST",
    NORMSINV: "NORMSINV",
    PHI: "PHI",
    "NEGBINOM.DIST": "NEGBINOM.DIST",
    "NEGBINOMDIST": "NEGBINOMDIST",
    COMPLEX: "COMPLEX",
    IMABS: "IMABS",
    IMAGINARY: "IMAGINARY",
    IMARGUMENT: "IMARGUMENT",
    IMCONJUGATE: "IMCONJUGATE",
    IMCOS: "IMCOS",
    IMCOSH: "IMCOSH",
    IMCOT: "IMCOT",
    IMCSC: "IMCSC",
    IMCSCH: "IMCSCH",
    IMDIV: "IMDIV",
    IMEXP: "IMEXP",
    IMLN: "IMLN",
    IMLOG10: "IMLOG10",
    IMLOG2: "IMLOG2",
    IMPOWER: "IMPOWER",
    IMPRODUCT: "IMPRODUCT",
    IMREAL: "IMREAL",
    IMSEC: "IMSEC",
    IMSECH: "IMSECH",
    IMSIN: "IMSIN",
    IMSINH: "IMSINH",
    IMSQRT: "IMSQRT",
    IMSUB: "IMSUB",
    IMSUM: "IMSUM",
    IMTAN: "IMTAN",
    LARGE: "LARGE",
    SMALL: "SMALL",
    PERCENTILE: "PERCENTILE",
    "PERCENTILE.INC": "PERCENTILE.INC",
    "PERCENTILE.EXC": "PERCENTILE.EXC",
    QUARTILE: "QUARTILE",
    "QUARTILE.INC": "QUARTILE.INC",
    "QUARTILE.EXC": "QUARTILE.EXC",
    AVEDEV: "AVEDEV",
    CONFIDENCE: "CONFIDENCE",
    "CONFIDENCE.NORM": "CONFIDENCE.NORM",
    "CONFIDENCE.T": "CONFIDENCE.T",
    DEVSQ: "DEVSQ",
    GEOMEAN: "GEOMEAN",
    HARMEAN: "HARMEAN",
    CRITBINOM: "CRITBINOM",
    "COVARIANCE.P": "COVARIANCE.P",
    "COVARIANCE.S": "COVARIANCE.S",
    "COVAR": "COVAR",
    PEARSON: "PEARSON",
    RSQ: "RSQ",
    STANDARDIZE: "STANDARDIZE",
    "Z.TEST": "Z.TEST",
    ZTEST: "ZTEST",
    "F.TEST": "F.TEST",
    FTEST: "FTEST",
    STEYX: "STEYX",
    SLOPE: "SLOPE",
    "CHISQ.TEST": "CHISQ.TEST",
    CHITEST: "CHITEST",
    "T.TEST": "T.TEST",
    TTEST: "TTEST",
    SKEW: "SKEW",
    "SKEW.P": "SKEW.P",
    WEIBULLDIST: "WEIBULLDIST",
    VARS: "VARS",
    TINV2T: "TINV2T",
    TDISTRT: "TDISTRT",
    TDIST2T: "TDIST2T",
    STDEVS: "STDEVS",
    FINVRT: "FINVRT",
    FDISTRT: "FDISTRT",
    CHIDISTRT: "CHIDISTRT",
    CHIINVRT: "CHIINVRT",
    COVARIANCEP: "COVARIANCEP",
    COVARIANCES: "COVARIANCES",
    LOGNORMINV: "LOGNORMINV",
    POISSONDIST: "POISSONDIST",
    SKEWP: "SKEWP",
    "CEILING.MATH": "CEILING.MATH",
    FLOOR: "FLOOR",
    "FLOOR.MATH": "FLOOR.MATH",
    "CEILING.PRECISE": "CEILING.PRECISE",
    "FLOOR.PRECISE": "FLOOR.PRECISE",
    "ISO.CEILING": "ISO.CEILING"
  },
  langCode: "enGB",
  ui: {
    NEW_SHEET_PREFIX: "Sheet"
  }
};
var AbsStyle;
(function(AbsStyle2) {
  AbsStyle2[AbsStyle2["FullyAbsolute"] = 1] = "FullyAbsolute";
  AbsStyle2[AbsStyle2["RowAbsoluteColRelative"] = 2] = "RowAbsoluteColRelative";
  AbsStyle2[AbsStyle2["RowRelativeColAbsolute"] = 3] = "RowRelativeColAbsolute";
  AbsStyle2[AbsStyle2["FullyRelative"] = 4] = "FullyRelative";
})(AbsStyle || (AbsStyle = {}));
class AddressPlugin extends FunctionPlugin {
  verifyAddressArguments(row, col, abs2, useA1Style) {
    if (useA1Style) {
      if (row < 1 || col < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
    } else {
      if (AbsStyle.FullyAbsolute == abs2) {
        if (row < 1 || col < 1) {
          return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
        }
      } else if (AbsStyle.RowAbsoluteColRelative == abs2) {
        if (row < 1) {
          return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
        }
      } else if (AbsStyle.RowRelativeColAbsolute == abs2) {
        if (col < 1) {
          return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
        }
      }
    }
    return void 0;
  }
  address(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ADDRESS"), (row, col, abs2, useA1Style, sheetName) => {
      const argumentError = this.verifyAddressArguments(row, col, abs2, useA1Style);
      if (argumentError !== void 0) {
        return argumentError;
      }
      const colLetter = columnIndexToLabel(col - 1);
      let sheetPrefix = "";
      if (sheetName !== void 0 && sheetName !== null) {
        sheetPrefix = `${sheetName}!`;
      }
      const r1c1ColSegment = col == 0 ? "C" : `C[${col}]`;
      const r1c1RowSegment = row == 0 ? "R" : `R[${row}]`;
      if (AbsStyle.FullyRelative == abs2) {
        return useA1Style ? `${sheetPrefix}${colLetter}${row}` : `${sheetPrefix}${r1c1RowSegment}${r1c1ColSegment}`;
      } else if (AbsStyle.RowRelativeColAbsolute == abs2) {
        return useA1Style ? `${sheetPrefix}$${colLetter}${row}` : `${sheetPrefix}${r1c1RowSegment}C${col}`;
      } else if (AbsStyle.RowAbsoluteColRelative == abs2) {
        return useA1Style ? `${sheetPrefix}${colLetter}$${row}` : `${sheetPrefix}R${row}${r1c1ColSegment}`;
      }
      return useA1Style ? `${sheetPrefix}$${colLetter}$${row}` : `${sheetPrefix}R${row}C${col}`;
    });
  }
}
AddressPlugin.implementedFunctions = {
  "ADDRESS": {
    method: "address",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      defaultValue: 1,
      minValue: 1,
      maxValue: 4,
      emptyAsDefault: true
    }, {
      argumentType: FunctionArgumentType.BOOLEAN,
      optionalArg: true,
      defaultValue: true,
      emptyAsDefault: true
    }, {
      argumentType: FunctionArgumentType.STRING,
      optionalArg: true
    }]
  }
};
class ArrayPlugin extends FunctionPlugin {
  arrayformula(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ARRAYFORMULA"), (value) => value);
  }
  arrayformulaArraySize(ast, state) {
    if (ast.args.length !== 1) {
      return ArraySize.error();
    }
    const metadata = this.metadata("ARRAYFORMULA");
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.arraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    return subChecks[0];
  }
  arrayconstrain(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ARRAY_CONSTRAIN"), (range, numRows, numCols) => {
      numRows = Math.min(numRows, range.height());
      numCols = Math.min(numCols, range.width());
      const data = range.data;
      const ret = [];
      for (let i = 0; i < numRows; i++) {
        ret.push(data[i].slice(0, numCols));
      }
      return SimpleRangeValue.onlyValues(ret);
    });
  }
  arrayconstrainArraySize(ast, state) {
    if (ast.args.length !== 3) {
      return ArraySize.error();
    }
    const metadata = this.metadata("ARRAY_CONSTRAIN");
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.arraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    let {
      height,
      width
    } = subChecks[0];
    if (ast.args[1].type === AstNodeType.NUMBER) {
      height = Math.min(height, ast.args[1].value);
    }
    if (ast.args[2].type === AstNodeType.NUMBER) {
      width = Math.min(width, ast.args[2].value);
    }
    if (height < 1 || width < 1 || !Number.isInteger(height) || !Number.isInteger(width)) {
      return ArraySize.error();
    }
    return new ArraySize(width, height);
  }
  filter(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FILTER"), (rangeVals, ...rangeFilters) => {
      for (const filter2 of rangeFilters) {
        if (rangeVals.width() !== filter2.width() || rangeVals.height() !== filter2.height()) {
          return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
        }
      }
      if (rangeVals.width() > 1 && rangeVals.height() > 1) {
        return new CellError(ErrorType.NA, ErrorMessage.WrongDimension);
      }
      const vals = rangeVals.data;
      const ret = [];
      for (let i = 0; i < rangeVals.height(); i++) {
        const row = [];
        for (let j = 0; j < rangeVals.width(); j++) {
          let ok = true;
          for (const filter2 of rangeFilters) {
            const val = coerceScalarToBoolean(filter2.data[i][j]);
            if (val !== true) {
              ok = false;
              break;
            }
          }
          if (ok) {
            row.push(vals[i][j]);
          }
        }
        if (row.length > 0) {
          ret.push(row);
        }
      }
      if (ret.length > 0) {
        return SimpleRangeValue.onlyValues(ret);
      } else {
        return new CellError(ErrorType.NA, ErrorMessage.EmptyRange);
      }
    });
  }
  filterArraySize(ast, state) {
    if (ast.args.length <= 1) {
      return ArraySize.error();
    }
    const metadata = this.metadata("FILTER");
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.arraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    const width = Math.max(...subChecks.map((val) => val.width));
    const height = Math.max(...subChecks.map((val) => val.height));
    return new ArraySize(width, height);
  }
}
ArrayPlugin.implementedFunctions = {
  "ARRAYFORMULA": {
    method: "arrayformula",
    sizeOfResultArrayMethod: "arrayformulaArraySize",
    enableArrayArithmeticForArguments: true,
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }]
  },
  "ARRAY_CONSTRAIN": {
    method: "arrayconstrain",
    sizeOfResultArrayMethod: "arrayconstrainArraySize",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }],
    vectorizationForbidden: true
  },
  "FILTER": {
    method: "filter",
    sizeOfResultArrayMethod: "filterArraySize",
    enableArrayArithmeticForArguments: true,
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }],
    repeatLastArgs: 1
  }
};
class AbsPlugin extends FunctionPlugin {
  abs(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ABS"), Math.abs);
  }
}
AbsPlugin.implementedFunctions = {
  "ABS": {
    method: "abs",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
const MAX_48BIT_INTEGER = 281474976710655;
const SHIFT_MIN_POSITIONS = -53;
const SHIFT_MAX_POSITIONS = 53;
class BitShiftPlugin extends FunctionPlugin {
  bitlshift(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BITLSHIFT"), shiftLeft);
  }
  bitrshift(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BITRSHIFT"), shiftRight);
  }
}
BitShiftPlugin.implementedFunctions = {
  "BITLSHIFT": {
    method: "bitlshift",
    parameters: [{
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: SHIFT_MIN_POSITIONS,
      maxValue: SHIFT_MAX_POSITIONS
    }]
  },
  "BITRSHIFT": {
    method: "bitrshift",
    parameters: [{
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: SHIFT_MIN_POSITIONS,
      maxValue: SHIFT_MAX_POSITIONS
    }]
  }
};
function shiftLeft(value, positions) {
  if (positions < 0) {
    return shiftRight(value, -positions);
  } else {
    return validate(value * Math.pow(2, positions));
  }
}
function shiftRight(value, positions) {
  if (positions < 0) {
    return shiftLeft(value, -positions);
  } else {
    return validate(Math.floor(value / Math.pow(2, positions)));
  }
}
function validate(result) {
  if (result > MAX_48BIT_INTEGER) {
    return new CellError(ErrorType.NUM, ErrorMessage.BitshiftLong);
  } else {
    return result;
  }
}
class BitwiseLogicOperationsPlugin extends FunctionPlugin {
  bitand(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BITAND"), (left2, right2) => left2 & right2);
  }
  bitor(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BITOR"), (left2, right2) => left2 | right2);
  }
  bitxor(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BITXOR"), (left2, right2) => left2 ^ right2);
  }
}
BitwiseLogicOperationsPlugin.implementedFunctions = {
  "BITAND": {
    method: "bitand",
    parameters: [{
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }]
  },
  "BITOR": {
    method: "bitor",
    parameters: [{
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }]
  },
  "BITXOR": {
    method: "bitxor",
    parameters: [{
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }]
  }
};
class BooleanPlugin extends FunctionPlugin {
  /**
   * Corresponds to TRUE()
   *
   * Returns the logical true
   *
   * @param ast
   * @param state
   */
  literalTrue(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TRUE"), () => true);
  }
  /**
   * Corresponds to FALSE()
   *
   * Returns the logical false
   *
   * @param ast
   * @param state
   */
  literalFalse(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FALSE"), () => false);
  }
  /**
   * Corresponds to IF(expression, value_if_true, value_if_false)
   *
   * Returns value specified as second argument if expression is true and third argument if expression is false
   *
   * @param ast
   * @param state
   */
  conditionalIf(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IF"), (condition2, arg2, arg3) => {
      return condition2 ? arg2 : arg3;
    });
  }
  /**
   * Implementation for the IFS function. Returns the value that corresponds to the first true condition.
   *
   * @param ast
   * @param state
   */
  ifs(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IFS"), (...args) => {
      for (let idx = 0; idx < args.length; idx += 2) {
        if (args[idx]) {
          return args[idx + 1];
        }
      }
      return new CellError(ErrorType.NA, ErrorMessage.NoConditionMet);
    });
  }
  /**
   * Corresponds to AND(expression1, [expression2, ...])
   *
   * Returns true if all of the provided arguments are logically true, and false if any of it is logically false
   *
   * @param ast
   * @param state
   */
  and(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("AND"), (...args) => args.filter((arg) => arg !== void 0).every((arg) => !!arg));
  }
  /**
   * Corresponds to OR(expression1, [expression2, ...])
   *
   * Returns true if any of the provided arguments are logically true, and false otherwise
   *
   * @param ast
   * @param state
   */
  or(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("OR"), (...args) => args.filter((arg) => arg !== void 0).some((arg) => arg));
  }
  not(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NOT"), (arg) => !arg);
  }
  xor(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("XOR"), (...args) => {
      let cnt = 0;
      args.filter((arg) => arg !== void 0).forEach((arg) => {
        if (arg) {
          cnt++;
        }
      });
      return cnt % 2 === 1;
    });
  }
  switch(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SWITCH"), (selector, ...args) => {
      const n2 = args.length;
      let i = 0;
      for (; i + 1 < n2; i += 2) {
        if (args[i] instanceof CellError) {
          continue;
        }
        if (this.arithmeticHelper.eq(selector, args[i])) {
          return args[i + 1];
        }
      }
      if (i < n2) {
        return args[i];
      } else {
        return new CellError(ErrorType.NA, ErrorMessage.NoDefault);
      }
    });
  }
  iferror(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IFERROR"), (arg1, arg2) => {
      if (arg1 instanceof CellError) {
        return arg2;
      } else {
        return arg1;
      }
    });
  }
  ifna(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IFNA"), (arg1, arg2) => {
      if (arg1 instanceof CellError && arg1.type === ErrorType.NA) {
        return arg2;
      } else {
        return arg1;
      }
    });
  }
  choose(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHOOSE"), (selector, ...args) => {
      if (selector > args.length) {
        return new CellError(ErrorType.NUM, ErrorMessage.Selector);
      }
      return args[selector - 1];
    });
  }
}
BooleanPlugin.implementedFunctions = {
  "TRUE": {
    method: "literalTrue",
    parameters: []
  },
  "FALSE": {
    method: "literalFalse",
    parameters: []
  },
  "IF": {
    method: "conditionalIf",
    parameters: [{
      argumentType: FunctionArgumentType.BOOLEAN
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      defaultValue: false,
      passSubtype: true
    }]
  },
  "IFS": {
    method: "ifs",
    parameters: [{
      argumentType: FunctionArgumentType.BOOLEAN
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }],
    repeatLastArgs: 2
  },
  "AND": {
    method: "and",
    parameters: [{
      argumentType: FunctionArgumentType.BOOLEAN
    }],
    repeatLastArgs: 1,
    expandRanges: true
  },
  "OR": {
    method: "or",
    parameters: [{
      argumentType: FunctionArgumentType.BOOLEAN
    }],
    repeatLastArgs: 1,
    expandRanges: true
  },
  "XOR": {
    method: "xor",
    parameters: [{
      argumentType: FunctionArgumentType.BOOLEAN
    }],
    repeatLastArgs: 1,
    expandRanges: true
  },
  "NOT": {
    method: "not",
    parameters: [{
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "SWITCH": {
    method: "switch",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }],
    repeatLastArgs: 1
  },
  "IFERROR": {
    method: "iferror",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }]
  },
  "IFNA": {
    method: "ifna",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }]
  },
  "CHOOSE": {
    method: "choose",
    parameters: [{
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.SCALAR,
      passSubtype: true
    }],
    repeatLastArgs: 1
  }
};
class CharPlugin extends FunctionPlugin {
  char(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHAR"), (value) => {
      if (value < 1 || value >= 256) {
        return new CellError(ErrorType.VALUE, ErrorMessage.CharacterCodeBounds);
      }
      return String.fromCharCode(Math.trunc(value));
    });
  }
  unichar(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHAR"), (value) => {
      if (value < 1 || value >= 1114112) {
        return new CellError(ErrorType.VALUE, ErrorMessage.CharacterCodeBounds);
      }
      return String.fromCodePoint(Math.trunc(value));
    });
  }
}
CharPlugin.implementedFunctions = {
  "CHAR": {
    method: "char",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "UNICHAR": {
    method: "unichar",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class CodePlugin extends FunctionPlugin {
  code(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CODE"), (value) => {
      if (value.length === 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.EmptyString);
      }
      return value.charCodeAt(0);
    });
  }
  unicode(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("UNICODE"), (value) => {
      var _a;
      return (_a = value.codePointAt(0)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.VALUE, ErrorMessage.EmptyString);
    });
  }
}
CodePlugin.implementedFunctions = {
  "CODE": {
    method: "code",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "UNICODE": {
    method: "unicode",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  }
};
class CountBlankPlugin extends FunctionPlugin {
  countblank(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COUNTBLANK"), (...args) => {
      let counter = 0;
      args.forEach((arg) => {
        if (arg === EmptyValue) {
          counter++;
        }
      });
      return counter;
    });
  }
}
CountBlankPlugin.implementedFunctions = {
  "COUNTBLANK": {
    method: "countblank",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }],
    repeatLastArgs: 1,
    expandRanges: true
  }
};
class CountUniquePlugin extends FunctionPlugin {
  /**
   * Corresponds to COUNTUNIQUE(Number1, Number2, ...).
   *
   * Returns number of unique numbers from arguments
   *
   * @param ast
   * @param state
   */
  countunique(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COUNTUNIQUE"), (...args) => {
      const valuesSet = /* @__PURE__ */ new Set();
      const errorsSet = /* @__PURE__ */ new Set();
      for (const scalarValue of args) {
        if (scalarValue instanceof CellError) {
          errorsSet.add(scalarValue.type);
        } else if (scalarValue !== "") {
          valuesSet.add(scalarValue);
        }
      }
      return valuesSet.size + errorsSet.size;
    });
  }
}
CountUniquePlugin.implementedFunctions = {
  "COUNTUNIQUE": {
    method: "countunique",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }],
    repeatLastArgs: 1,
    expandRanges: true
  }
};
const databaseFunctionParameters = [{
  argumentType: FunctionArgumentType.RANGE
}, {
  argumentType: FunctionArgumentType.SCALAR
}, {
  argumentType: FunctionArgumentType.RANGE
}];
class DatabasePlugin extends FunctionPlugin {
  /**
   * Resolves field index and criteria, then delegates to the callback with the parsed database arguments.
   * Shared boilerplate for all 12 database functions.
   */
  withDatabaseArgs(ast, state, functionName2, callback) {
    return this.runFunction(ast.args, state, this.metadata(functionName2), (database, field, criteria) => {
      const fieldIndex = this.resolveFieldIndex(database, field);
      if (fieldIndex instanceof CellError) {
        return fieldIndex;
      }
      const criteriaRows = this.buildDatabaseCriteria(database, criteria);
      if (criteriaRows instanceof CellError) {
        return criteriaRows;
      }
      return callback(database.data, fieldIndex, criteriaRows);
    });
  }
  /**
   * Counts cells containing numbers in the specified field of a database range,
   * for rows that match all criteria.
   *
   * DCOUNT(database, field, criteria)
   */
  dcount(ast, state) {
    return this.withDatabaseArgs(ast, state, "DCOUNT", (dbData, fieldIndex, criteriaRows) => {
      let count = 0;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (isExtendedNumber(cellValue)) {
            count++;
          }
        }
      }
      return count;
    });
  }
  /**
   * Counts all non-blank cells in the specified field of a database range,
   * for rows that match all criteria.
   *
   * DCOUNTA(database, field, criteria)
   */
  dcounta(ast, state) {
    return this.withDatabaseArgs(ast, state, "DCOUNTA", (dbData, fieldIndex, criteriaRows) => {
      let count = 0;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (cellValue !== EmptyValue && cellValue !== void 0 && cellValue !== null) {
            count++;
          }
        }
      }
      return count;
    });
  }
  /**
   * Returns the product of numeric values in the specified field of a database range,
   * for rows that match all criteria.
   *
   * DPRODUCT(database, field, criteria)
   */
  dproduct(ast, state) {
    return this.withDatabaseArgs(ast, state, "DPRODUCT", (dbData, fieldIndex, criteriaRows) => {
      let product2 = 1;
      let hasNumeric = false;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (isExtendedNumber(cellValue)) {
            product2 *= getRawValue(cellValue);
            hasNumeric = true;
          }
        }
      }
      return hasNumeric ? product2 : 0;
    });
  }
  /**
   * Returns the sum of numeric values in the specified field of a database range,
   * for rows that match all criteria.
   *
   * DSUM(database, field, criteria)
   */
  dsum(ast, state) {
    return this.withDatabaseArgs(ast, state, "DSUM", (dbData, fieldIndex, criteriaRows) => {
      let sum2 = 0;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (isExtendedNumber(cellValue)) {
            sum2 += getRawValue(cellValue);
          }
        }
      }
      return sum2;
    });
  }
  /**
   * Returns the average of numeric values in the specified field of a database range,
   * for rows that match all criteria.
   * Returns #DIV/0! when no numeric values are found.
   *
   * DAVERAGE(database, field, criteria)
   */
  daverage(ast, state) {
    return this.withDatabaseArgs(ast, state, "DAVERAGE", (dbData, fieldIndex, criteriaRows) => {
      let sum2 = 0;
      let count = 0;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (isExtendedNumber(cellValue)) {
            sum2 += getRawValue(cellValue);
            count++;
          }
        }
      }
      if (count === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return sum2 / count;
    });
  }
  /**
   * Returns a single value from the specified field of a database range,
   * for the row that matches all criteria.
   * Returns #VALUE! if no rows match, #NUM! if more than one row matches.
   *
   * DGET(database, field, criteria)
   */
  dget(ast, state) {
    return this.withDatabaseArgs(ast, state, "DGET", (dbData, fieldIndex, criteriaRows) => {
      let matchedValue;
      let matchCount = 0;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          matchCount++;
          if (matchCount > 1) {
            return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
          }
          matchedValue = dbData[rowIdx][fieldIndex];
        }
      }
      if (matchCount === 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
      }
      if (matchedValue instanceof CellError) {
        return matchedValue;
      }
      return matchedValue === EmptyValue || matchedValue === void 0 || matchedValue === null ? 0 : matchedValue;
    });
  }
  /**
   * Returns the maximum numeric value in the specified field of a database range,
   * for rows that match all criteria.
   * Returns 0 when no numeric values are found (Excel behavior).
   *
   * DMAX(database, field, criteria)
   */
  dmax(ast, state) {
    return this.withDatabaseArgs(ast, state, "DMAX", (dbData, fieldIndex, criteriaRows) => {
      let max = -Infinity;
      let hasNumeric = false;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (isExtendedNumber(cellValue)) {
            const numValue = getRawValue(cellValue);
            if (numValue > max) {
              max = numValue;
            }
            hasNumeric = true;
          }
        }
      }
      return hasNumeric ? max : 0;
    });
  }
  /**
   * Returns the minimum numeric value in the specified field of a database range,
   * for rows that match all criteria.
   * Returns 0 when no numeric values are found (Excel behavior).
   *
   * DMIN(database, field, criteria)
   */
  dmin(ast, state) {
    return this.withDatabaseArgs(ast, state, "DMIN", (dbData, fieldIndex, criteriaRows) => {
      let min = Infinity;
      let hasNumeric = false;
      for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
        if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
          const cellValue = dbData[rowIdx][fieldIndex];
          if (cellValue instanceof CellError) {
            return cellValue;
          }
          if (isExtendedNumber(cellValue)) {
            const numValue = getRawValue(cellValue);
            if (numValue < min) {
              min = numValue;
            }
            hasNumeric = true;
          }
        }
      }
      return hasNumeric ? min : 0;
    });
  }
  /**
   * Returns the sample standard deviation of numeric values in the specified field
   * of a database range, for rows that match all criteria.
   * Returns #DIV/0! when fewer than 2 numeric values are found.
   *
   * DSTDEV(database, field, criteria)
   */
  dstdev(ast, state) {
    return this.withDatabaseArgs(ast, state, "DSTDEV", (dbData, fieldIndex, criteriaRows) => {
      const values2 = this.collectNumericValues(dbData, fieldIndex, criteriaRows);
      if (values2 instanceof CellError) {
        return values2;
      }
      if (values2.length <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const mean2 = values2.reduce((a, b) => a + b, 0) / values2.length;
      const variance2 = values2.reduce((sum2, v) => sum2 + Math.pow(v - mean2, 2), 0) / (values2.length - 1);
      return Math.sqrt(variance2);
    });
  }
  /**
   * Returns the population standard deviation of numeric values in the specified field
   * of a database range, for rows that match all criteria.
   * Returns #DIV/0! when no numeric values are found.
   * Returns 0 when exactly one numeric value is found.
   *
   * DSTDEVP(database, field, criteria)
   */
  dstdevp(ast, state) {
    return this.withDatabaseArgs(ast, state, "DSTDEVP", (dbData, fieldIndex, criteriaRows) => {
      const values2 = this.collectNumericValues(dbData, fieldIndex, criteriaRows);
      if (values2 instanceof CellError) {
        return values2;
      }
      if (values2.length === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const mean2 = values2.reduce((a, b) => a + b, 0) / values2.length;
      const variance2 = values2.reduce((sum2, v) => sum2 + Math.pow(v - mean2, 2), 0) / values2.length;
      return Math.sqrt(variance2);
    });
  }
  /**
   * Returns the sample variance of numeric values in the specified field
   * of a database range, for rows that match all criteria.
   * Returns #DIV/0! when fewer than 2 numeric values are found.
   *
   * DVAR(database, field, criteria)
   */
  dvar(ast, state) {
    return this.withDatabaseArgs(ast, state, "DVAR", (dbData, fieldIndex, criteriaRows) => {
      const values2 = this.collectNumericValues(dbData, fieldIndex, criteriaRows);
      if (values2 instanceof CellError) {
        return values2;
      }
      if (values2.length <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const mean2 = values2.reduce((a, b) => a + b, 0) / values2.length;
      return values2.reduce((sum2, v) => sum2 + Math.pow(v - mean2, 2), 0) / (values2.length - 1);
    });
  }
  /**
   * Returns the population variance of numeric values in the specified field
   * of a database range, for rows that match all criteria.
   * Returns #DIV/0! when no numeric values are found.
   * Returns 0 when exactly one numeric value is found.
   *
   * DVARP(database, field, criteria)
   */
  dvarp(ast, state) {
    return this.withDatabaseArgs(ast, state, "DVARP", (dbData, fieldIndex, criteriaRows) => {
      const values2 = this.collectNumericValues(dbData, fieldIndex, criteriaRows);
      if (values2 instanceof CellError) {
        return values2;
      }
      if (values2.length === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const mean2 = values2.reduce((a, b) => a + b, 0) / values2.length;
      return values2.reduce((sum2, v) => sum2 + Math.pow(v - mean2, 2), 0) / values2.length;
    });
  }
  /**
   * Collects numeric values from the specified field column of matching database rows.
   *
   * @param dbData - Full database data including header row.
   * @param fieldIndex - 0-based column index of the target field.
   * @param criteriaRows - Parsed criteria rows.
   * @returns Array of numeric values from matching rows, or the first CellError
   *   encountered in a matching field cell (propagated per Excel semantics).
   */
  collectNumericValues(dbData, fieldIndex, criteriaRows) {
    const values2 = [];
    for (let rowIdx = 1; rowIdx < dbData.length; rowIdx++) {
      if (this.rowMatchesCriteria(dbData[rowIdx], criteriaRows)) {
        const cellValue = dbData[rowIdx][fieldIndex];
        if (cellValue instanceof CellError) {
          return cellValue;
        }
        if (isExtendedNumber(cellValue)) {
          values2.push(getRawValue(cellValue));
        }
      }
    }
    return values2;
  }
  /**
   * Resolves the field argument to a 0-based column index within the database range.
   *
   * @param database - The database range (first row = headers).
   * @param field - A string (header name, case-insensitive) or number (1-based column index).
   *   Booleans are coerced to numbers (TRUE → 1, FALSE → 0) per Excel convention.
   * @returns 0-based column index, or CellError if field is invalid.
   */
  resolveFieldIndex(database, field) {
    if (field instanceof CellError) {
      return field;
    }
    const headers = database.data[0];
    if (typeof field === "string") {
      const lowerField = field.toLowerCase();
      for (let i = 0; i < headers.length; i++) {
        const header = headers[i];
        if (typeof header === "string" && header.toLowerCase() === lowerField) {
          return i;
        }
      }
      return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
    }
    const numericField = typeof field === "boolean" ? Number(field) : field;
    if (isExtendedNumber(numericField)) {
      const index2 = Math.trunc(getRawValue(numericField));
      if (!Number.isFinite(index2) || index2 < 1 || index2 > headers.length) {
        return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
      }
      return index2 - 1;
    }
    return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
  }
  /**
   * Parses the criteria range into an array of criteria rows.
   * Each row is a list of AND-ed conditions. Rows are OR-ed together.
   *
   * @param database - The database range (first row = headers).
   * @param criteria - The criteria range (first row = header labels, subsequent rows = conditions).
   * @returns Array of criteria rows, or CellError if a criterion cannot be parsed.
   */
  buildDatabaseCriteria(database, criteria) {
    var _a;
    const dbHeaders = database.data[0];
    const criteriaData = criteria.data;
    const criteriaHeaders = criteriaData[0];
    for (const criteriaHeader of criteriaHeaders) {
      if (criteriaHeader instanceof CellError) {
        return criteriaHeader;
      }
    }
    const criteriaColumnMapping = criteriaHeaders.map((criteriaHeader) => {
      if (typeof criteriaHeader !== "string") {
        return -1;
      }
      const lowerHeader = criteriaHeader.toLowerCase();
      return dbHeaders.findIndex((dbHeader) => typeof dbHeader === "string" && dbHeader.toLowerCase() === lowerHeader);
    });
    const rows = [];
    for (let rowIdx = 1; rowIdx < criteriaData.length; rowIdx++) {
      const row = [];
      for (let colIdx = 0; colIdx < criteriaHeaders.length; colIdx++) {
        const dbColIndex = criteriaColumnMapping[colIdx];
        if (dbColIndex === -1) {
          continue;
        }
        const criterionValue = (_a = criteriaData[rowIdx]) === null || _a === void 0 ? void 0 : _a[colIdx];
        if (criterionValue === EmptyValue || criterionValue === void 0 || criterionValue === null) {
          continue;
        }
        if (criterionValue instanceof CellError) {
          return criterionValue;
        }
        const rawCriterionValue = isExtendedNumber(criterionValue) ? getRawValue(criterionValue) : criterionValue;
        const criterionPackage = this.interpreter.criterionBuilder.fromCellValue(rawCriterionValue, this.arithmeticHelper);
        if (criterionPackage === void 0) {
          return new CellError(ErrorType.VALUE, ErrorMessage.BadCriterion);
        }
        row.push({
          columnIndex: dbColIndex,
          lambda: criterionPackage.lambda
        });
      }
      rows.push(row);
    }
    return rows;
  }
  /**
   * Tests whether a database data row matches any of the criteria rows (OR logic).
   * Within each criteria row, all conditions must match (AND logic).
   *
   * @param dataRow - A single row of data from the database (excluding the header row).
   * @param criteriaRows - Parsed criteria rows.
   * @returns true if the row qualifies, false otherwise.
   */
  rowMatchesCriteria(dataRow, criteriaRows) {
    if (criteriaRows.length === 0) {
      return false;
    }
    return criteriaRows.some((criteriaRow) => {
      if (criteriaRow.length === 0) {
        return true;
      }
      return criteriaRow.every((entry) => {
        const cellValue = dataRow[entry.columnIndex];
        const rawValue = isExtendedNumber(cellValue) ? getRawValue(cellValue) : cellValue;
        return entry.lambda(rawValue);
      });
    });
  }
}
DatabasePlugin.implementedFunctions = {
  "DCOUNT": {
    method: "dcount",
    parameters: databaseFunctionParameters
  },
  "DCOUNTA": {
    method: "dcounta",
    parameters: databaseFunctionParameters
  },
  "DPRODUCT": {
    method: "dproduct",
    parameters: databaseFunctionParameters
  },
  "DSTDEV": {
    method: "dstdev",
    parameters: databaseFunctionParameters
  },
  "DSTDEVP": {
    method: "dstdevp",
    parameters: databaseFunctionParameters
  },
  "DSUM": {
    method: "dsum",
    parameters: databaseFunctionParameters
  },
  "DVAR": {
    method: "dvar",
    parameters: databaseFunctionParameters
  },
  "DVARP": {
    method: "dvarp",
    parameters: databaseFunctionParameters
  },
  "DAVERAGE": {
    method: "daverage",
    parameters: databaseFunctionParameters
  },
  "DGET": {
    method: "dget",
    parameters: databaseFunctionParameters
  },
  "DMAX": {
    method: "dmax",
    parameters: databaseFunctionParameters
  },
  "DMIN": {
    method: "dmin",
    parameters: databaseFunctionParameters
  }
};
class DateTimePlugin extends FunctionPlugin {
  constructor() {
    super(...arguments);
    this.isoweeknumCore = (day) => {
      const absoluteDay = Math.floor(this.dateTimeHelper.relativeNumberToAbsoluteNumber(day));
      const date = this.dateTimeHelper.numberToSimpleDate(day);
      const yearStart = this.dateTimeHelper.dateToNumber({
        year: date.year,
        month: 1,
        day: 1
      });
      const yearStartAbsolute = this.dateTimeHelper.relativeNumberToAbsoluteNumber(yearStart);
      const firstThursdayAbs = yearStartAbsolute + ((4 - yearStartAbsolute) % 7 + 7) % 7;
      const ret = Math.floor((absoluteDay - 1) / 7) - Math.floor((firstThursdayAbs - 1) / 7) + 1;
      if (ret === 0) {
        return this.isoweeknumCore(day - 7) + 1;
      }
      return ret;
    };
    this.days360Core = (startDate, endDate, mode) => {
      const start = this.dateTimeHelper.numberToSimpleDate(startDate);
      const end = this.dateTimeHelper.numberToSimpleDate(endDate);
      let nStart, nEnd;
      if (mode) {
        nStart = toBasisEU(start);
        nEnd = toBasisEU(end);
      } else {
        [nStart, nEnd] = this.dateTimeHelper.toBasisUS(start, end);
      }
      return 360 * (nEnd.year - nStart.year) + 30 * (nEnd.month - nStart.month) + nEnd.day - nStart.day;
    };
  }
  /**
   * Corresponds to DATE(year, month, day)
   *
   * Converts a provided year, month and day into date
   *
   * @param ast
   * @param state
   */
  date(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DATE"), (year, month, day) => {
      const d = Math.trunc(day);
      let m = Math.trunc(month);
      let y = Math.trunc(year);
      if (y < this.dateTimeHelper.getEpochYearZero()) {
        y += this.dateTimeHelper.getEpochYearZero();
      }
      const delta = Math.floor((m - 1) / 12);
      y += delta;
      m -= delta * 12;
      const date = {
        year: y,
        month: m,
        day: 1
      };
      if (this.dateTimeHelper.isValidDate(date)) {
        let ret = this.dateTimeHelper.dateToNumber(date) + (d - 1);
        ret = this.dateTimeHelper.getWithinBounds(ret);
        if (ret === void 0) {
          return new CellError(ErrorType.NUM, ErrorMessage.DateBounds);
        }
        return ret;
      }
      return new CellError(ErrorType.VALUE, ErrorMessage.InvalidDate);
    });
  }
  time(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TIME"), (h, m, s) => {
      const ret = timeToNumber({
        hours: Math.trunc(h),
        minutes: Math.trunc(m),
        seconds: Math.trunc(s)
      });
      if (ret < 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NegativeTime);
      }
      return ret % 1;
    });
  }
  /**
   * Implementation for the EOMONTH function
   */
  eomonth(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EOMONTH"), (dateNumber, numberOfMonthsToShift) => {
      const date = this.dateTimeHelper.numberToSimpleDate(dateNumber);
      let ret = this.dateTimeHelper.dateToNumber(this.dateTimeHelper.endOfMonth(offsetMonth(date, numberOfMonthsToShift)));
      ret = this.dateTimeHelper.getWithinBounds(ret);
      if (ret === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.DateBounds);
      }
      return ret;
    });
  }
  day(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DAY"), (dateNumber) => this.dateTimeHelper.numberToSimpleDate(dateNumber).day);
  }
  days(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DAYS"), (endDate, startDate) => Math.trunc(endDate) - Math.trunc(startDate));
  }
  /**
   * Corresponds to MONTH(date)
   *
   * Returns the month of the year specified by a given date
   *
   * @param ast
   * @param state
   */
  month(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MONTH"), (dateNumber) => this.dateTimeHelper.numberToSimpleDate(dateNumber).month);
  }
  /**
   * Corresponds to YEAR(date)
   *
   * Returns the year specified by a given date
   *
   * @param ast
   * @param state
   */
  year(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("YEAR"), (dateNumber) => this.dateTimeHelper.numberToSimpleDate(dateNumber).year);
  }
  hour(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HOUR"), (timeNumber) => numberToSimpleTime(roundToNearestSecond(timeNumber) % 1).hours);
  }
  minute(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MINUTE"), (timeNumber) => numberToSimpleTime(roundToNearestSecond(timeNumber) % 1).minutes);
  }
  second(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SECOND"), (timeNumber) => numberToSimpleTime(roundToNearestSecond(timeNumber) % 1).seconds);
  }
  /**
   * Corresponds to TEXT(number, format)
   *
   * Tries to convert number to specified date format.
   *
   * @param ast
   * @param state
   */
  text(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TEXT"), (numberRepresentation, formatArg) => format(numberRepresentation, formatArg, this.config, this.dateTimeHelper));
  }
  weekday(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("WEEKDAY"), (day, type) => {
      const absoluteDay = Math.floor(this.dateTimeHelper.relativeNumberToAbsoluteNumber(day));
      if (type === 3) {
        return (absoluteDay - 1) % 7;
      }
      const offset2 = weekdayOffsets.get(type);
      if (offset2 === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.BadMode);
      }
      return (absoluteDay - offset2) % 7 + 1;
    });
  }
  weeknum(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("WEEKNUM"), (day, type) => {
      const absoluteDay = Math.floor(this.dateTimeHelper.relativeNumberToAbsoluteNumber(day));
      const date = this.dateTimeHelper.numberToSimpleDate(day);
      const yearStart = this.dateTimeHelper.dateToNumber({
        year: date.year,
        month: 1,
        day: 1
      });
      const yearStartAbsolute = this.dateTimeHelper.relativeNumberToAbsoluteNumber(yearStart);
      if (type === 21) {
        return this.isoweeknumCore(day);
      }
      const offset2 = weekdayOffsets.get(type);
      if (offset2 === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.BadMode);
      }
      return Math.floor((absoluteDay - offset2) / 7) - Math.floor((yearStartAbsolute - offset2) / 7) + 1;
    });
  }
  isoweeknum(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISOWEEKNUM"), this.isoweeknumCore);
  }
  datevalue(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DATEVALUE"), (date) => {
      const {
        dateTime
      } = this.dateTimeHelper.parseDateTimeFromConfigFormats(date);
      if (dateTime === void 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.IncorrectDateTime);
      }
      if (!instanceOfSimpleDate(dateTime)) {
        return 0;
      }
      return (instanceOfSimpleTime(dateTime) ? Math.trunc(timeToNumber(dateTime)) : 0) + this.dateTimeHelper.dateToNumber(dateTime);
    });
  }
  timevalue(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TIMEVALUE"), (date) => {
      const dateNumber = this.dateTimeHelper.dateStringToDateNumber(date);
      if (dateNumber === void 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.IncorrectDateTime);
      }
      return getRawValue(dateNumber) % 1;
    });
  }
  now(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NOW"), () => {
      const now = new Date(Date.now());
      return timeToNumber({
        hours: now.getHours(),
        minutes: now.getMinutes(),
        seconds: now.getSeconds()
      }) + this.dateTimeHelper.dateToNumber({
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate()
      });
    });
  }
  today(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TODAY"), () => {
      const now = new Date(Date.now());
      return this.dateTimeHelper.dateToNumber({
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate()
      });
    });
  }
  edate(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EDATE"), (dateNumber, delta) => {
      const date = this.dateTimeHelper.numberToSimpleDate(dateNumber);
      const newDate = truncateDayInMonth(offsetMonth(date, delta));
      let ret = this.dateTimeHelper.dateToNumber(newDate);
      ret = this.dateTimeHelper.getWithinBounds(ret);
      if (ret === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.DateBounds);
      }
      return ret;
    });
  }
  datedif(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DATEDIF"), (startDate, endDate, unit) => {
      if (startDate > endDate) {
        return new CellError(ErrorType.NUM, ErrorMessage.StartEndDate);
      }
      if (unit === "D") {
        return Math.floor(endDate) - Math.floor(startDate);
      }
      const start = this.dateTimeHelper.numberToSimpleDate(startDate);
      const end = this.dateTimeHelper.numberToSimpleDate(endDate);
      switch (unit) {
        case "M":
          return (end.year - start.year) * 12 + (end.month - start.month) - (end.day < start.day ? 1 : 0);
        case "YM":
          return (12 + (end.month - start.month) - (end.day < start.day ? 1 : 0)) % 12;
        case "Y":
          if (end.month > start.month || end.month === start.month && end.day >= start.day) {
            return end.year - start.year;
          } else {
            return end.year - start.year - 1;
          }
        case "MD":
          if (end.day >= start.day) {
            return end.day - start.day;
          } else {
            const m = end.month === 1 ? 12 : end.month - 1;
            const y = end.month === 1 ? end.year - 1 : end.year;
            return this.dateTimeHelper.daysInMonth(y, m) + end.day - start.day;
          }
        case "YD":
          if (end.month > start.month || end.month === start.month && end.day >= start.day) {
            return Math.floor(endDate) - this.dateTimeHelper.dateToNumber({
              year: end.year,
              month: start.month,
              day: start.day
            });
          } else {
            return Math.floor(endDate) - Math.floor(startDate) - 365 * (end.year - start.year - 1) - this.dateTimeHelper.leapYearsCount(end.year - 1) + this.dateTimeHelper.leapYearsCount(start.year);
          }
        default:
          return new CellError(ErrorType.NUM, ErrorMessage.BadMode);
      }
    });
  }
  days360(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DAYS360"), this.days360Core);
  }
  yearfrac(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("YEARFRAC"), (startDate, endDate, mode) => {
      startDate = Math.trunc(startDate);
      endDate = Math.trunc(endDate);
      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }
      switch (mode) {
        case 0:
          return this.days360Core(startDate, endDate, false) / 360;
        case 1:
          return (endDate - startDate) / this.dateTimeHelper.yearLengthForBasis(this.dateTimeHelper.numberToSimpleDate(startDate), this.dateTimeHelper.numberToSimpleDate(endDate));
        case 2:
          return (endDate - startDate) / 360;
        case 3:
          return (endDate - startDate) / 365;
        case 4:
          return this.days360Core(startDate, endDate, true) / 360;
      }
      throw new Error("Should not be reachable.");
    });
  }
  interval(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("INTERVAL"), (arg) => {
      arg = Math.trunc(arg);
      const second = arg % 60;
      arg = Math.trunc(arg / 60);
      const minute = arg % 60;
      arg = Math.trunc(arg / 60);
      const hour = arg % 24;
      arg = Math.trunc(arg / 24);
      const day = arg % 30;
      arg = Math.trunc(arg / 30);
      const month = arg % 12;
      const year = Math.trunc(arg / 12);
      return "P" + (year > 0 ? `${year}Y` : "") + (month > 0 ? `${month}M` : "") + (day > 0 ? `${day}D` : "") + "T" + (hour > 0 ? `${hour}H` : "") + (minute > 0 ? `${minute}M` : "") + (second > 0 ? `${second}S` : "");
    });
  }
  networkdays(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NETWORKDAYS"), (start, end, holidays) => this.networkdayscore(start, end, 1, holidays));
  }
  networkdaysintl(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NETWORKDAYS.INTL"), (start, end, weekend, holidays) => this.networkdayscore(start, end, weekend, holidays));
  }
  workday(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("WORKDAY"), (start, end, holidays) => this.workdaycore(start, end, 1, holidays));
  }
  workdayintl(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("WORKDAY.INTL"), (start, end, weekend, holidays) => this.workdaycore(start, end, weekend, holidays));
  }
  networkdayscore(start, end, weekend, holidays) {
    start = Math.trunc(start);
    end = Math.trunc(end);
    let multiplier = 1;
    if (start > end) {
      [start, end] = [end, start];
      multiplier = -1;
    }
    const weekendPattern = computeWeekendPattern(weekend);
    if (weekendPattern instanceof CellError) {
      return weekendPattern;
    }
    const filteredHolidays = this.simpleRangeToFilteredHolidays(weekendPattern, holidays);
    if (filteredHolidays instanceof CellError) {
      return filteredHolidays;
    }
    return multiplier * this.countWorkdays(start, end, weekendPattern, filteredHolidays);
  }
  workdaycore(start, delta, weekend, holidays) {
    start = Math.trunc(start);
    delta = Math.trunc(delta);
    const weekendPattern = computeWeekendPattern(weekend);
    if (weekendPattern instanceof CellError) {
      return weekendPattern;
    }
    const filteredHolidays = this.simpleRangeToFilteredHolidays(weekendPattern, holidays);
    if (filteredHolidays instanceof CellError) {
      return filteredHolidays;
    }
    if (delta > 0) {
      let upper = 1;
      while (this.countWorkdays(start + 1, start + upper, weekendPattern, filteredHolidays) < delta) {
        upper *= 2;
      }
      let lower = 1;
      while (lower + 1 < upper) {
        const mid = Math.trunc((lower + upper) / 2);
        if (this.countWorkdays(start + 1, start + mid, weekendPattern, filteredHolidays) < delta) {
          lower = mid;
        } else {
          upper = mid;
        }
      }
      return start + upper;
    } else if (delta < 0) {
      delta *= -1;
      let upper = 1;
      while (this.countWorkdays(start - upper, start - 1, weekendPattern, filteredHolidays) < delta) {
        upper *= 2;
      }
      let lower = 1;
      while (lower + 1 < upper) {
        const mid = Math.trunc((lower + upper) / 2);
        if (this.countWorkdays(start - mid, start - 1, weekendPattern, filteredHolidays) < delta) {
          lower = mid;
        } else {
          upper = mid;
        }
      }
      return start - upper;
    } else {
      return start;
    }
  }
  countWorkdays(start, end, weekendPattern, sortedHolidays) {
    const absoluteEnd = Math.floor(this.dateTimeHelper.relativeNumberToAbsoluteNumber(end));
    const absoluteStart = Math.floor(this.dateTimeHelper.relativeNumberToAbsoluteNumber(start));
    let ans = 0;
    for (let i = 0; i < 7; i++) {
      if (weekendPattern.charAt(i) === "0") {
        ans += Math.floor((absoluteEnd + 6 - i) / 7);
        ans -= Math.floor((absoluteStart - 1 + 6 - i) / 7);
      }
    }
    ans -= lowerBound(end + 1, sortedHolidays) - lowerBound(start, sortedHolidays);
    return ans;
  }
  simpleRangeToFilteredHolidays(weekendPattern, holidays) {
    var _a;
    const holidaysArr = (_a = holidays === null || holidays === void 0 ? void 0 : holidays.valuesFromTopLeftCorner()) !== null && _a !== void 0 ? _a : [];
    for (const val of holidaysArr) {
      if (val instanceof CellError) {
        return val;
      }
    }
    const processedHolidays = [];
    for (const val of holidaysArr) {
      if (val === EmptyValue) {
        continue;
      }
      if (isExtendedNumber(val)) {
        processedHolidays.push(Math.trunc(getRawValue(val)));
      } else {
        return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
      }
    }
    return [...new Set(processedHolidays)].sort((a, b) => a - b).filter((arg) => {
      const val = this.dateTimeHelper.relativeNumberToAbsoluteNumber(arg);
      const i = (val - 1) % 7;
      return weekendPattern.charAt(i) === "0";
    });
  }
}
DateTimePlugin.implementedFunctions = {
  "DATE": {
    method: "date",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_DATE
  },
  "TIME": {
    method: "time",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_TIME
  },
  "MONTH": {
    method: "month",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "YEAR": {
    method: "year",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "HOUR": {
    method: "hour",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "MINUTE": {
    method: "minute",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "SECOND": {
    method: "second",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "TEXT": {
    method: "text",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "EOMONTH": {
    method: "eomonth",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_DATE
  },
  "DAY": {
    method: "day",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "DAYS": {
    method: "days",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "WEEKDAY": {
    method: "weekday",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "WEEKNUM": {
    method: "weeknum",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "ISOWEEKNUM": {
    method: "isoweeknum",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "DATEVALUE": {
    method: "datevalue",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }],
    returnNumberType: NumberType.NUMBER_DATE
  },
  "TIMEVALUE": {
    method: "timevalue",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }],
    returnNumberType: NumberType.NUMBER_TIME
  },
  "NOW": {
    method: "now",
    parameters: [],
    isVolatile: true,
    returnNumberType: NumberType.NUMBER_DATETIME
  },
  "TODAY": {
    method: "today",
    parameters: [],
    isVolatile: true,
    returnNumberType: NumberType.NUMBER_DATE
  },
  "EDATE": {
    method: "edate",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_DATE
  },
  "DAYS360": {
    method: "days360",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN,
      defaultValue: false
    }]
  },
  "DATEDIF": {
    method: "datedif",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "YEARFRAC": {
    method: "yearfrac",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      defaultValue: 0,
      minValue: 0,
      maxValue: 4
    }]
  },
  "INTERVAL": {
    method: "interval",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "NETWORKDAYS": {
    method: "networkdays",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.RANGE,
      optionalArg: true
    }]
  },
  "NETWORKDAYS.INTL": {
    method: "networkdaysintl",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      defaultValue: 1
    }, {
      argumentType: FunctionArgumentType.RANGE,
      optionalArg: true
    }]
  },
  "WORKDAY": {
    method: "workday",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.RANGE,
      optionalArg: true
    }]
  },
  "WORKDAY.INTL": {
    method: "workdayintl",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      defaultValue: 1
    }, {
      argumentType: FunctionArgumentType.RANGE,
      optionalArg: true
    }]
  }
};
function lowerBound(val, sortedArray) {
  if (sortedArray.length === 0) {
    return 0;
  }
  if (val <= sortedArray[0]) {
    return 0;
  }
  if (sortedArray[sortedArray.length - 1] < val) {
    return sortedArray.length;
  }
  let lower = 0;
  let upper = sortedArray.length - 1;
  while (lower + 1 < upper) {
    const mid = Math.floor((upper + lower) / 2);
    if (sortedArray[mid] >= val) {
      upper = mid;
    } else {
      lower = mid;
    }
  }
  return upper;
}
function computeWeekendPattern(weekend) {
  var _a;
  if (typeof weekend !== "number" && typeof weekend !== "string") {
    return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
  }
  if (typeof weekend === "string") {
    if (weekend.length !== 7 || !/^(0|1)*$/.test(weekend) || weekend === "1111111") {
      return new CellError(ErrorType.NUM, ErrorMessage.WeekendString);
    } else {
      return weekend;
    }
  } else {
    return (_a = workdayPatterns.get(weekend)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.NUM, ErrorMessage.BadMode);
  }
}
const weekdayOffsets = /* @__PURE__ */ new Map([[1, 0], [2, 1], [11, 1], [12, 2], [13, 3], [14, 4], [15, 5], [16, 6], [17, 0]]);
const workdayPatterns = /* @__PURE__ */ new Map([[1, "0000011"], [2, "1000001"], [3, "1100000"], [4, "0110000"], [5, "0011000"], [6, "0001100"], [7, "0000110"], [11, "0000001"], [12, "1000000"], [13, "0100000"], [14, "0010000"], [15, "0001000"], [16, "0000100"], [17, "0000010"]]);
class DegreesPlugin extends FunctionPlugin {
  degrees(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DEGREES"), (arg) => arg * (180 / Math.PI));
  }
}
DegreesPlugin.implementedFunctions = {
  "DEGREES": {
    method: "degrees",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class DeltaPlugin extends FunctionPlugin {
  delta(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DELTA"), (left2, right2) => left2 === right2 ? 1 : 0);
  }
}
DeltaPlugin.implementedFunctions = {
  "DELTA": {
    method: "delta",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  }
};
class ExpPlugin extends FunctionPlugin {
  /**
   * Corresponds to EXP(value)
   *
   * Calculates the exponent for basis e
   *
   * @param ast
   * @param state
   */
  exp(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EXP"), Math.exp);
  }
}
ExpPlugin.implementedFunctions = {
  "EXP": {
    method: "exp",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class FinancialPlugin extends FunctionPlugin {
  pmt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PMT"), pmtCore);
  }
  ipmt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IPMT"), ipmtCore);
  }
  ppmt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PPMT"), ppmtCore);
  }
  fv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FV"), fvCore);
  }
  cumipmt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CUMIPMT"), (rate, periods, value, start, end, type) => {
      if (start > end) {
        return new CellError(ErrorType.NUM, ErrorMessage.EndStartPeriod);
      }
      let acc = 0;
      for (let i = start; i <= end; i++) {
        acc += ipmtCore(rate, i, periods, value, 0, type);
      }
      return acc;
    });
  }
  cumprinc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CUMPRINC"), (rate, periods, value, start, end, type) => {
      if (start > end) {
        return new CellError(ErrorType.NUM, ErrorMessage.EndStartPeriod);
      }
      let acc = 0;
      for (let i = start; i <= end; i++) {
        acc += ppmtCore(rate, i, periods, value, 0, type);
      }
      return acc;
    });
  }
  db(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DB"), (cost, salvage, life, period, month) => {
      if (month === 12 && period > life || period > life + 1) {
        return new CellError(ErrorType.NUM, ErrorMessage.PeriodLong);
      }
      if (salvage >= cost) {
        return 0;
      }
      const rate = Math.round((1 - Math.pow(salvage / cost, 1 / life)) * 1e3) / 1e3;
      const initial = cost * rate * month / 12;
      if (period === 1) {
        return initial;
      }
      let total = initial;
      for (let i = 0; i < period - 2; i++) {
        total += (cost - total) * rate;
      }
      if (period === life + 1) {
        return (cost - total) * rate * (12 - month) / 12;
      }
      return (cost - total) * rate;
    });
  }
  ddb(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DDB"), (cost, salvage, life, period, factor) => {
      if (period > life) {
        return new CellError(ErrorType.NUM);
      }
      let rate = factor / life;
      let oldValue;
      if (rate >= 1) {
        rate = 1;
        if (period === 1) {
          oldValue = cost;
        } else {
          oldValue = 0;
        }
      } else {
        oldValue = cost * Math.pow(1 - rate, period - 1);
      }
      const newValue = cost * Math.pow(1 - rate, period);
      return Math.max(oldValue - Math.max(salvage, newValue), 0);
    });
  }
  dollarde(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DOLLARDE"), (dollar, fraction) => {
      if (fraction < 1) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      fraction = Math.trunc(fraction);
      while (fraction > 10) {
        fraction /= 10;
      }
      return Math.trunc(dollar) + (dollar - Math.trunc(dollar)) * 10 / fraction;
    });
  }
  dollarfr(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DOLLARFR"), (dollar, fraction) => {
      if (fraction < 1) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      fraction = Math.trunc(fraction);
      while (fraction > 10) {
        fraction /= 10;
      }
      return Math.trunc(dollar) + (dollar - Math.trunc(dollar)) * fraction / 10;
    });
  }
  effect(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EFFECT"), (rate, periods) => {
      periods = Math.trunc(periods);
      return Math.pow(1 + rate / periods, periods) - 1;
    });
  }
  ispmt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISPMT"), (rate, period, periods, value) => {
      if (periods === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return value * rate * (period / periods - 1);
    });
  }
  nominal(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NOMINAL"), (rate, periods) => {
      periods = Math.trunc(periods);
      return (Math.pow(rate + 1, 1 / periods) - 1) * periods;
    });
  }
  nper(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NPER"), (rate, payment, present, future, type) => {
      if (rate === 0) {
        if (payment === 0) {
          return new CellError(ErrorType.DIV_BY_ZERO);
        }
        return (-present - future) / payment;
      }
      if (type) {
        payment *= 1 + rate;
      }
      return Math.log((payment - future * rate) / (present * rate + payment)) / Math.log(1 + rate);
    });
  }
  rate(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RATE"), (periods, payment, present, future, type, guess) => {
      if (guess <= -1) {
        return new CellError(ErrorType.VALUE);
      }
      const epsMax = 1e-7;
      const iterMax = 50;
      let rate = guess;
      type = type ? 1 : 0;
      for (let i = 0; i < iterMax; i++) {
        if (rate <= -1) {
          return new CellError(ErrorType.NUM);
        }
        let y;
        if (Math.abs(rate) < epsMax) {
          y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
        } else {
          const f = Math.pow(1 + rate, periods);
          y = present * f + payment * (1 / rate + type) * (f - 1) + future;
        }
        if (Math.abs(y) < epsMax) {
          return rate;
        }
        let dy;
        if (Math.abs(rate) < epsMax) {
          dy = present * periods + payment * type * periods;
        } else {
          const f = Math.pow(1 + rate, periods);
          const df = periods * Math.pow(1 + rate, periods - 1);
          dy = present * df + payment * (1 / rate + type) * df + payment * (-1 / (rate * rate)) * (f - 1);
        }
        rate -= y / dy;
      }
      return new CellError(ErrorType.NUM);
    });
  }
  pv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PV"), (rate, periods, payment, future, type) => {
      type = type ? 1 : 0;
      if (rate === -1) {
        if (periods === 0) {
          return new CellError(ErrorType.NUM);
        } else {
          return new CellError(ErrorType.DIV_BY_ZERO);
        }
      }
      if (rate === 0) {
        return -payment * periods - future;
      } else {
        return ((1 - Math.pow(1 + rate, periods)) * payment * (1 + rate * type) / rate - future) / Math.pow(1 + rate, periods);
      }
    });
  }
  rri(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RRI"), (periods, present, future) => {
      if (present === 0 || future < 0 && present > 0 || future > 0 && present < 0) {
        return new CellError(ErrorType.NUM);
      }
      return Math.pow(future / present, 1 / periods) - 1;
    });
  }
  sln(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SLN"), (cost, salvage, life) => {
      if (life === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return (cost - salvage) / life;
    });
  }
  syd(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SYD"), (cost, salvage, life, period) => {
      if (period > life) {
        return new CellError(ErrorType.NUM);
      }
      return (cost - salvage) * (life - period + 1) * 2 / (life * (life + 1));
    });
  }
  tbilleq(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TBILLEQ"), (settlement, maturity, discount) => {
      settlement = Math.round(settlement);
      maturity = Math.round(maturity);
      if (settlement >= maturity) {
        return new CellError(ErrorType.NUM);
      }
      const startDate = this.dateTimeHelper.numberToSimpleDate(settlement);
      const endDate = this.dateTimeHelper.numberToSimpleDate(maturity);
      if (endDate.year > startDate.year + 1 || endDate.year === startDate.year + 1 && (endDate.month > startDate.month || endDate.month === startDate.month && endDate.day > startDate.day)) {
        return new CellError(ErrorType.NUM);
      }
      const denom = 360 - discount * (maturity - settlement);
      if (denom === 0) {
        return 0;
      }
      if (denom < 0) {
        return new CellError(ErrorType.NUM);
      }
      return 365 * discount / denom;
    });
  }
  tbillprice(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TBILLPRICE"), (settlement, maturity, discount) => {
      settlement = Math.round(settlement);
      maturity = Math.round(maturity);
      if (settlement >= maturity) {
        return new CellError(ErrorType.NUM);
      }
      const startDate = this.dateTimeHelper.numberToSimpleDate(settlement);
      const endDate = this.dateTimeHelper.numberToSimpleDate(maturity);
      if (endDate.year > startDate.year + 1 || endDate.year === startDate.year + 1 && (endDate.month > startDate.month || endDate.month === startDate.month && endDate.day > startDate.day)) {
        return new CellError(ErrorType.NUM);
      }
      const denom = 360 - discount * (maturity - settlement);
      if (denom === 0) {
        return 0;
      }
      if (denom < 0) {
        return new CellError(ErrorType.NUM);
      }
      return 100 * (1 - discount * (maturity - settlement) / 360);
    });
  }
  tbillyield(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TBILLYIELD"), (settlement, maturity, price) => {
      settlement = Math.round(settlement);
      maturity = Math.round(maturity);
      if (settlement >= maturity) {
        return new CellError(ErrorType.NUM);
      }
      const startDate = this.dateTimeHelper.numberToSimpleDate(settlement);
      const endDate = this.dateTimeHelper.numberToSimpleDate(maturity);
      if (endDate.year > startDate.year + 1 || endDate.year === startDate.year + 1 && (endDate.month > startDate.month || endDate.month === startDate.month && endDate.day > startDate.day)) {
        return new CellError(ErrorType.NUM);
      }
      return (100 - price) * 360 / (price * (maturity - settlement));
    });
  }
  fvschedule(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FVSCHEDULE"), (value, ratios) => {
      const vals = ratios.valuesFromTopLeftCorner();
      for (const val of vals) {
        if (val instanceof CellError) {
          return val;
        }
      }
      for (const val of vals) {
        if (isExtendedNumber(val)) {
          value *= 1 + getRawValue(val);
        } else if (val !== EmptyValue) {
          return new CellError(ErrorType.VALUE, ErrorMessage.NumberExpected);
        }
      }
      return value;
    });
  }
  npv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NPV"), (rate, ...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      return npvCore(rate, coerced);
    });
  }
  mirr(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MIRR"), (range, frate, rrate) => {
      const vals = this.arithmeticHelper.manyToExactNumbers(range.valuesFromTopLeftCorner());
      if (vals instanceof CellError) {
        return vals;
      }
      let posFlag = false;
      let negFlag = false;
      const posValues = [];
      const negValues = [];
      for (const val of vals) {
        if (val > 0) {
          posFlag = true;
          posValues.push(val);
          negValues.push(0);
        } else if (val < 0) {
          negFlag = true;
          negValues.push(val);
          posValues.push(0);
        } else {
          negValues.push(0);
          posValues.push(0);
        }
      }
      if (!posFlag || !negFlag) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const n2 = vals.length;
      const nom = npvCore(rrate, posValues);
      if (nom instanceof CellError) {
        return nom;
      }
      const denom = npvCore(frate, negValues);
      if (denom instanceof CellError) {
        return denom;
      }
      return Math.pow(-nom * Math.pow(1 + rrate, n2) / denom / (1 + frate), 1 / (n2 - 1)) - 1;
    });
  }
  pduration(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PDURATION"), (rate, pv, fv) => (Math.log(fv) - Math.log(pv)) / Math.log(1 + rate));
  }
  xnpv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("XNPV"), (rate, values2, dates) => {
      const valArr = values2.valuesFromTopLeftCorner();
      for (const val of valArr) {
        if (typeof val !== "number") {
          return new CellError(ErrorType.VALUE, ErrorMessage.NumberExpected);
        }
      }
      const valArrNum = valArr;
      const dateArr = dates.valuesFromTopLeftCorner();
      for (const date of dateArr) {
        if (typeof date !== "number") {
          return new CellError(ErrorType.VALUE, ErrorMessage.NumberExpected);
        }
      }
      const dateArrNum = dateArr;
      if (dateArrNum.length !== valArrNum.length) {
        return new CellError(ErrorType.NUM, ErrorMessage.EqualLength);
      }
      const n2 = dateArrNum.length;
      let ret = 0;
      if (dateArrNum[0] < 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
      }
      for (let i = 0; i < n2; i++) {
        dateArrNum[i] = Math.floor(dateArrNum[i]);
        if (dateArrNum[i] < dateArrNum[0]) {
          return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
        }
        ret += valArrNum[i] / Math.pow(1 + rate, (dateArrNum[i] - dateArrNum[0]) / 365);
      }
      return ret;
    });
  }
  /**
   * Calculates the internal rate of return for a series of cash flows.
   * @param {ProcedureAst} ast - The AST node representing the function call.
   * @param {InterpreterState} state - The interpreter state.
   * @returns {InterpreterValue} The internal rate of return.
   */
  irr(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IRR"), (range, guess) => {
      if (guess <= -1) {
        return new CellError(ErrorType.VALUE);
      }
      const vals = this.arithmeticHelper.manyToExactNumbers(range.valuesFromTopLeftCorner());
      if (vals instanceof CellError) {
        return vals;
      }
      const hasPositive = vals.some((val) => val > 0);
      const hasNegative = vals.some((val) => val < 0);
      if (!hasPositive || !hasNegative) {
        return new CellError(ErrorType.NUM);
      }
      return irrCore(vals, guess);
    });
  }
}
FinancialPlugin.implementedFunctions = {
  "PMT": {
    method: "pmt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "IPMT": {
    method: "ipmt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "PPMT": {
    method: "ppmt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "FV": {
    method: "fv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "CUMIPMT": {
    method: "cumipmt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0,
      maxValue: 1
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "CUMPRINC": {
    method: "cumprinc",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0,
      maxValue: 1
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "DB": {
    method: "db",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1,
      maxValue: 12,
      defaultValue: 12
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "DDB": {
    method: "ddb",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      defaultValue: 2
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "DOLLARDE": {
    method: "dollarde",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "DOLLARFR": {
    method: "dollarfr",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "EFFECT": {
    method: "effect",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "ISPMT": {
    method: "ispmt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "NOMINAL": {
    method: "nominal",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "NPER": {
    method: "nper",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  },
  "PV": {
    method: "pv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "RATE": {
    method: "rate",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0.1
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "RRI": {
    method: "rri",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "SLN": {
    method: "sln",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "SYD": {
    method: "syd",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "TBILLEQ": {
    method: "tbilleq",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "TBILLPRICE": {
    method: "tbillprice",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "TBILLYIELD": {
    method: "tbillyield",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "FVSCHEDULE": {
    method: "fvschedule",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.RANGE
    }],
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "NPV": {
    method: "npv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1,
    returnNumberType: NumberType.NUMBER_CURRENCY
  },
  "MIRR": {
    method: "mirr",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  },
  "PDURATION": {
    method: "pduration",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }]
  },
  "XNPV": {
    method: "xnpv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: -1
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "IRR": {
    method: "irr",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0.1
    }],
    returnNumberType: NumberType.NUMBER_PERCENT
  }
};
function pmtCore(rate, periods, present, future, type) {
  if (rate === 0) {
    return (-present - future) / periods;
  } else {
    const term = Math.pow(1 + rate, periods);
    return (future * rate + present * rate * term) * (type ? 1 / (1 + rate) : 1) / (1 - term);
  }
}
function ipmtCore(rate, period, periods, present, future, type) {
  const payment = pmtCore(rate, periods, present, future, type);
  if (period === 1) {
    return rate * (type ? 0 : -present);
  } else {
    return rate * (type ? fvCore(rate, period - 2, payment, present, type) - payment : fvCore(rate, period - 1, payment, present, type));
  }
}
function fvCore(rate, periods, payment, value, type) {
  if (rate === 0) {
    return -value - payment * periods;
  } else {
    const term = Math.pow(1 + rate, periods);
    return payment * (type ? 1 + rate : 1) * (1 - term) / rate - value * term;
  }
}
function ppmtCore(rate, period, periods, present, future, type) {
  return pmtCore(rate, periods, present, future, type) - ipmtCore(rate, period, periods, present, future, type);
}
function npvCore(rate, args) {
  let acc = 0;
  for (let i = args.length - 1; i >= 0; i--) {
    acc += args[i];
    if (rate === -1) {
      if (acc === 0) {
        continue;
      } else {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
    }
    acc /= 1 + rate;
  }
  return acc;
}
function irrCore(values2, guess) {
  const epsMax = 1e-10;
  const iterMax = 50;
  let rate = guess;
  for (let iter = 0; iter < iterMax; iter++) {
    let npv = 0;
    let dnpv = 0;
    for (let i = 0; i < values2.length; i++) {
      const factor = Math.pow(1 + rate, i);
      if (!isFinite(factor) || factor === 0) {
        return new CellError(ErrorType.NUM);
      }
      npv += values2[i] / factor;
      if (i > 0) {
        dnpv -= i * values2[i] / (factor * (1 + rate));
      }
    }
    if (Math.abs(npv) < epsMax) {
      return rate;
    }
    if (Math.abs(dnpv) < epsMax) {
      return new CellError(ErrorType.NUM);
    }
    let newRate = rate - npv / dnpv;
    if (!isFinite(newRate)) {
      return new CellError(ErrorType.NUM);
    }
    if (newRate <= -1) {
      newRate = (rate - 1) / 2;
    }
    if (Math.abs(newRate - rate) < epsMax) {
      return newRate;
    }
    rate = newRate;
  }
  return new CellError(ErrorType.NUM);
}
class FormulaTextPlugin extends FunctionPlugin {
  /**
   * Corresponds to FORMULATEXT(value)
   *
   * Returns a formula in a given cell as a string.
   *
   * @param ast
   * @param state
   */
  formulatext(ast, state) {
    return this.runFunctionWithReferenceArgument(ast.args, state, this.metadata("FORMULATEXT"), () => new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber), (cellReference) => {
      var _a;
      return (_a = this.serialization.getCellFormula(cellReference)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.NA, ErrorMessage.Formula);
    });
  }
}
FormulaTextPlugin.implementedFunctions = {
  "FORMULATEXT": {
    method: "formulatext",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR
    }],
    doesNotNeedArgumentsToBeComputed: true,
    isDependentOnSheetStructureChange: true,
    vectorizationForbidden: true
  }
};
class HyperlinkPlugin extends FunctionPlugin {
  hyperlink(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HYPERLINK"), (url, linkLabel) => {
      ast.hyperlink = url;
      return linkLabel !== null && linkLabel !== void 0 ? linkLabel : url;
    });
  }
}
HyperlinkPlugin.implementedFunctions = {
  "HYPERLINK": {
    method: "hyperlink",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.STRING,
      optionalArg: true
    }]
  }
};
class InformationPlugin extends FunctionPlugin {
  /**
   * Corresponds to ISBINARY(value)
   *
   * Returns true if provided value is a valid binary number
   *
   * @param ast
   * @param state
   */
  isbinary(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISBINARY"), (arg) => /^[01]{1,10}$/.test(arg));
  }
  /**
   * Corresponds to ISERR(value)
   *
   * Returns true if provided value is an error except #N/A!
   *
   * @param ast
   * @param state
   */
  iserr(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISERR"), (arg) => arg instanceof CellError && arg.type !== ErrorType.NA);
  }
  /**
   * Corresponds to ISERROR(value)
   *
   * Checks whether provided value is an error
   *
   * @param ast
   * @param state
   */
  iserror(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISERROR"), (arg) => arg instanceof CellError);
  }
  /**
   * Corresponds to ISFORMULA(value)
   *
   * Checks whether referenced cell is a formula
   *
   * @param ast
   * @param state
   */
  isformula(ast, state) {
    return this.runFunctionWithReferenceArgument(ast.args, state, this.metadata("ISFORMULA"), () => new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber), (reference) => {
      const vertex = this.dependencyGraph.addressMapping.getCell(reference);
      return vertex instanceof FormulaVertex;
    });
  }
  /**
   * Corresponds to ISBLANK(value)
   *
   * Checks whether provided cell reference is empty
   *
   * @param ast
   * @param state
   */
  isblank(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISBLANK"), (arg) => arg === EmptyValue);
  }
  /**
   * Corresponds to ISNA(value)
   *
   * Returns true if provided value is #N/A! error
   *
   * @param ast
   * @param state
   */
  isna(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISNA"), (arg) => arg instanceof CellError && arg.type == ErrorType.NA);
  }
  /**
   * Corresponds to ISNUMBER(value)
   *
   * Checks whether provided cell reference is a number
   *
   * @param ast
   * @param state
   */
  isnumber(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISNUMBER"), isExtendedNumber);
  }
  /**
   * Corresponds to ISLOGICAL(value)
   *
   * Checks whether provided cell reference is of logical type
   *
   * @param ast
   * @param state
   */
  islogical(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISLOGICAL"), (arg) => typeof arg === "boolean");
  }
  /**
   * Corresponds to ISREF(value)
   *
   * Returns true if provided value is #REF! error
   *
   * @param ast
   * @param state
   */
  isref(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISREF"), (arg) => arg instanceof CellError && (arg.type == ErrorType.REF || arg.type == ErrorType.CYCLE));
  }
  /**
   * Corresponds to ISTEXT(value)
   *
   * Checks whether provided cell reference is of logical type
   *
   * @param ast
   * @param state
   */
  istext(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISTEXT"), (arg) => typeof arg === "string");
  }
  /**
   * Corresponds to ISNONTEXT(value)
   *
   * Checks whether provided cell reference is of logical type
   *
   * @param ast
   * @param state
   */
  isnontext(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISNONTEXT"), (arg) => !(typeof arg === "string"));
  }
  /**
   * Corresponds to COLUMN(reference)
   *
   * Returns column number of a reference or a formula cell if reference not provided
   *
   * @param ast
   * @param state
   */
  column(ast, state) {
    return this.runFunctionWithReferenceArgument(ast.args, state, this.metadata("COLUMN"), () => state.formulaAddress.col + 1, (reference) => reference.col + 1);
  }
  /**
   * Corresponds to COLUMNS(range)
   *
   * Returns number of columns in provided range of cells
   *
   * @param ast
   * @param state
   */
  columns(ast, state) {
    if (ast.args.length !== 1) {
      return new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber);
    }
    if (ast.args.some((astIt) => astIt.type === AstNodeType.EMPTY)) {
      return new CellError(ErrorType.NUM, ErrorMessage.EmptyArg);
    }
    let argAst = ast.args[0];
    while (argAst.type === AstNodeType.PARENTHESIS) {
      argAst = argAst.expression;
    }
    if (argAst.type === AstNodeType.CELL_RANGE || argAst.type === AstNodeType.COLUMN_RANGE) {
      return argAst.end.col - argAst.start.col + 1;
    } else if (argAst.type === AstNodeType.CELL_REFERENCE) {
      return 1;
    } else if (argAst.type === AstNodeType.ROW_RANGE) {
      return this.config.maxColumns;
    } else {
      const val = this.evaluateAst(argAst, state);
      if (val instanceof SimpleRangeValue) {
        return val.width();
      } else if (val instanceof CellError) {
        return val;
      } else {
        return 1;
      }
    }
  }
  /**
   * Corresponds to ROW(reference)
   *
   * Returns row number of a reference or a formula cell if reference not provided
   *
   * @param ast
   * @param state
   */
  row(ast, state) {
    return this.runFunctionWithReferenceArgument(ast.args, state, this.metadata("ROW"), () => state.formulaAddress.row + 1, (reference) => reference.row + 1);
  }
  /**
   * Corresponds to ROWS(range)
   *
   * Returns number of rows in provided range of cells
   *
   * @param ast
   * @param state
   */
  rows(ast, state) {
    if (ast.args.length !== 1) {
      return new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber);
    }
    if (ast.args.some((astIt) => astIt.type === AstNodeType.EMPTY)) {
      return new CellError(ErrorType.NUM, ErrorMessage.EmptyArg);
    }
    let argAst = ast.args[0];
    while (argAst.type === AstNodeType.PARENTHESIS) {
      argAst = argAst.expression;
    }
    if (argAst.type === AstNodeType.CELL_RANGE || argAst.type === AstNodeType.ROW_RANGE) {
      return argAst.end.row - argAst.start.row + 1;
    } else if (argAst.type === AstNodeType.CELL_REFERENCE) {
      return 1;
    } else if (argAst.type === AstNodeType.COLUMN_RANGE) {
      return this.config.maxRows;
    } else {
      const val = this.evaluateAst(argAst, state);
      if (val instanceof SimpleRangeValue) {
        return val.height();
      } else if (val instanceof CellError) {
        return val;
      } else {
        return 1;
      }
    }
  }
  /**
   * Corresponds to INDEX
   *
   * Returns specific position in 2d array.
   *
   * @param ast
   * @param state
   */
  index(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("INDEX"), (rangeValue, row, col) => {
      var _a, _b, _c, _d, _e, _f;
      if (col < 1 || row < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      if (col > rangeValue.width() || row > rangeValue.height()) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      return (_f = (_c = (_b = (_a = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.data) === null || _a === void 0 ? void 0 : _a[row - 1]) === null || _b === void 0 ? void 0 : _b[col - 1]) !== null && _c !== void 0 ? _c : (_e = (_d = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.data) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : new CellError(ErrorType.VALUE, ErrorMessage.CellRangeExpected);
    });
  }
  /**
   * Corresponds to NA()
   *
   * Returns #N/A!
   *
   * @param _ast
   * @param _state
   */
  na(_ast, _state) {
    return new CellError(ErrorType.NA);
  }
  /**
   * Corresponds to SHEET(value)
   *
   * Returns sheet number of a given value or a formula sheet number if no argument is provided
   *
   * @param ast
   * @param state
   */
  sheet(ast, state) {
    return this.runFunctionWithReferenceArgument(ast.args, state, this.metadata("SHEET"), () => state.formulaAddress.sheet + 1, (reference) => reference.sheet + 1, (value) => {
      const sheetNumber = this.dependencyGraph.sheetMapping.getSheetId(value);
      if (sheetNumber !== void 0) {
        return sheetNumber + 1;
      } else {
        return new CellError(ErrorType.NA, ErrorMessage.SheetRef);
      }
    });
  }
  /**
   * Corresponds to SHEETS(value)
   *
   * Returns number of sheet of a given reference or number of all sheets in workbook when no argument is provided.
   * It returns always 1 for a valid reference as 3D references are not supported.
   *
   * @param ast
   * @param state
   */
  sheets(ast, state) {
    return this.runFunctionWithReferenceArgument(
      ast.args,
      state,
      this.metadata("SHEETS"),
      () => this.dependencyGraph.sheetMapping.numberOfSheets(),
      // return number of sheets if no argument
      () => 1,
      // return 1 for valid reference
      () => new CellError(ErrorType.VALUE, ErrorMessage.CellRefExpected)
      // error otherwise
    );
  }
}
InformationPlugin.implementedFunctions = {
  "COLUMN": {
    method: "column",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      optionalArg: true
    }],
    isDependentOnSheetStructureChange: true,
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  },
  "COLUMNS": {
    method: "columns",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }],
    isDependentOnSheetStructureChange: true,
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  },
  "ISBINARY": {
    method: "isbinary",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "ISERR": {
    method: "iserr",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISFORMULA": {
    method: "isformula",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR
    }],
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  },
  "ISNA": {
    method: "isna",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISREF": {
    method: "isref",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }],
    vectorizationForbidden: true
  },
  "ISERROR": {
    method: "iserror",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISBLANK": {
    method: "isblank",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISNUMBER": {
    method: "isnumber",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISLOGICAL": {
    method: "islogical",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISTEXT": {
    method: "istext",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "ISNONTEXT": {
    method: "isnontext",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "INDEX": {
    method: "index",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "NA": {
    method: "na",
    parameters: []
  },
  "ROW": {
    method: "row",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      optionalArg: true
    }],
    isDependentOnSheetStructureChange: true,
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  },
  "ROWS": {
    method: "rows",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }],
    isDependentOnSheetStructureChange: true,
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  },
  "SHEET": {
    method: "sheet",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }],
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  },
  "SHEETS": {
    method: "sheets",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }],
    doesNotNeedArgumentsToBeComputed: true,
    vectorizationForbidden: true
  }
};
class IsEvenPlugin extends FunctionPlugin {
  iseven(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISEVEN"), (val) => val % 2 === 0);
  }
}
IsEvenPlugin.implementedFunctions = {
  "ISEVEN": {
    method: "iseven",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class IsOddPlugin extends FunctionPlugin {
  isodd(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ISODD"), (val) => val % 2 === 1);
  }
}
IsOddPlugin.implementedFunctions = {
  "ISODD": {
    method: "isodd",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class LogarithmPlugin extends FunctionPlugin {
  log10(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LOG10"), Math.log10);
  }
  log(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LOG"), (arg, base) => Math.log(arg) / Math.log(base));
  }
  ln(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LN"), Math.log);
  }
}
LogarithmPlugin.implementedFunctions = {
  "LOG10": {
    method: "log10",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "LOG": {
    method: "log",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 10,
      greaterThan: 0
    }]
  },
  "LN": {
    method: "ln",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
const PI = parseFloat(Math.PI.toFixed(14));
class MathConstantsPlugin extends FunctionPlugin {
  pi(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PI"), () => PI);
  }
  sqrtpi(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SQRTPI"), (arg) => Math.sqrt(PI * arg));
  }
}
MathConstantsPlugin.implementedFunctions = {
  "PI": {
    method: "pi",
    parameters: []
  },
  "SQRTPI": {
    method: "sqrtpi",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  }
};
function arraySizeForMultiplication(leftArraySize, rightArraySize) {
  return new ArraySize(rightArraySize.width, leftArraySize.height);
}
function arraySizeForPoolFunction(inputArray, windowSize, stride) {
  return new ArraySize(1 + (inputArray.width - windowSize) / stride, 1 + (inputArray.height - windowSize) / stride);
}
class MatrixPlugin extends FunctionPlugin {
  mmult(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MMULT"), (leftMatrix, rightMatrix) => {
      if (!leftMatrix.hasOnlyNumbers() || !rightMatrix.hasOnlyNumbers()) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NumberRange);
      }
      if (rightMatrix.height() !== leftMatrix.width()) {
        return new CellError(ErrorType.VALUE, ErrorMessage.ArrayDimensions);
      }
      const outputSize = arraySizeForMultiplication(leftMatrix.size, rightMatrix.size);
      const result = this.createKernel(function(a, b, width) {
        let sum2 = 0;
        for (let i = 0; i < width; ++i) {
          sum2 += a[this.thread.y][i] * b[i][this.thread.x];
        }
        return sum2;
      }, outputSize)(leftMatrix.rawNumbers(), rightMatrix.rawNumbers(), leftMatrix.width());
      return SimpleRangeValue.onlyNumbers(result);
    });
  }
  mmultArraySize(ast, state) {
    if (ast.args.length !== 2) {
      return ArraySize.error();
    }
    const metadata = this.metadata("MMULT");
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.arraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    const [left2, right2] = subChecks;
    return arraySizeForMultiplication(left2, right2);
  }
  maxpool(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MAXPOOL"), (matrix, windowSize, stride = windowSize) => {
      if (!matrix.hasOnlyNumbers()) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NumberRange);
      }
      const outputSize = arraySizeForPoolFunction(matrix.size, windowSize, stride);
      const result = this.createKernel(function(a, windowSize2, stride2) {
        const leftCornerX = this.thread.x * stride2;
        const leftCornerY = this.thread.y * stride2;
        let currentMax = a[leftCornerY][leftCornerX];
        for (let i = 0; i < windowSize2; i++) {
          for (let j = 0; j < windowSize2; j++) {
            currentMax = Math.max(currentMax, a[leftCornerY + i][leftCornerX + j]);
          }
        }
        return currentMax;
      }, outputSize)(matrix.rawNumbers(), windowSize, stride);
      return SimpleRangeValue.onlyNumbers(result);
    });
  }
  medianpool(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MEDIANPOOL"), (matrix, windowSize, stride = windowSize) => {
      if (!matrix.hasOnlyNumbers()) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NumberRange);
      }
      const outputSize = arraySizeForPoolFunction(matrix.size, windowSize, stride);
      const result = this.createKernel(function(a, windowSize2, stride2) {
        const leftCornerX = this.thread.x * stride2;
        const leftCornerY = this.thread.y * stride2;
        let currentMax = a[leftCornerY][leftCornerX];
        for (let i = 0; i < windowSize2; i++) {
          for (let j = 0; j < windowSize2; j++) {
            currentMax = Math.max(currentMax, a[leftCornerY + i][leftCornerX + j]);
          }
        }
        let currentMin = a[leftCornerY][leftCornerX];
        for (let i2 = 0; i2 < windowSize2; i2++) {
          for (let j2 = 0; j2 < windowSize2; j2++) {
            currentMin = Math.min(currentMin, a[leftCornerY + i2][leftCornerX + j2]);
          }
        }
        const numberOfElements = windowSize2 * windowSize2;
        let leftEnd = currentMin;
        let rightEnd = currentMax;
        let result2 = 42;
        for (let iter = 0; iter < 32; iter++) {
          const medianGuess = (leftEnd + rightEnd) / 2;
          let medianGuessCount = 0;
          for (let i3 = 0; i3 < windowSize2; i3++) {
            for (let j3 = 0; j3 < windowSize2; j3++) {
              if (a[leftCornerY + i3][leftCornerX + j3] > medianGuess) {
                medianGuessCount++;
              }
            }
          }
          if (windowSize2 % 2 === 0) {
            if (medianGuessCount === numberOfElements / 2) {
              result2 = medianGuess;
              break;
            } else if (medianGuessCount > numberOfElements / 2) {
              leftEnd = medianGuess;
            } else {
              rightEnd = medianGuess;
            }
          } else {
            if (medianGuessCount === (numberOfElements - 1) / 2) {
              result2 = medianGuess;
              break;
            } else if (medianGuessCount > (numberOfElements - 1) / 2) {
              leftEnd = medianGuess;
            } else {
              rightEnd = medianGuess;
            }
          }
        }
        return result2;
      }, outputSize)(matrix.rawNumbers(), windowSize, stride);
      return SimpleRangeValue.onlyNumbers(result);
    });
  }
  maxpoolArraySize(ast, state) {
    if (ast.args.length < 2 || ast.args.length > 3) {
      return ArraySize.error();
    }
    const metadata = this.metadata("MAXPOOL");
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.arraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    const array = subChecks[0];
    const windowArg = ast.args[1];
    let window2;
    if (windowArg.type === AstNodeType.NUMBER) {
      window2 = windowArg.value;
    } else {
      window2 = 1;
    }
    let stride = window2;
    if (ast.args.length === 3) {
      const strideArg = ast.args[2];
      if (strideArg.type === AstNodeType.NUMBER) {
        stride = strideArg.value;
      } else {
        stride = 1;
      }
    }
    if (window2 > array.width || window2 > array.height || stride > window2 || (array.width - window2) % stride !== 0 || (array.height - window2) % stride !== 0) {
      return ArraySize.error();
    }
    return arraySizeForPoolFunction(array, window2, stride);
  }
  medianpoolArraySize(ast, state) {
    return this.maxpoolArraySize(ast, state);
  }
  transpose(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TRANSPOSE"), (matrix) => {
      const input = matrix.rawData();
      const inputSize = matrix.size;
      const result = [];
      for (let i = 0; i < inputSize.width; ++i) {
        result[i] = [];
        for (let j = 0; j < inputSize.height; ++j) {
          result[i][j] = input[j][i];
        }
      }
      return SimpleRangeValue.onlyValues(result);
    });
  }
  transposeArraySize(ast, state) {
    if (ast.args.length !== 1) {
      return ArraySize.error();
    }
    const metadata = this.metadata("TRANSPOSE");
    const subChecks = ast.args.map((arg) => {
      var _a;
      return this.arraySizeForAst(arg, new InterpreterState(state.formulaAddress, state.arraysFlag || ((_a = metadata === null || metadata === void 0 ? void 0 : metadata.enableArrayArithmeticForArguments) !== null && _a !== void 0 ? _a : false)));
    });
    const [size] = subChecks;
    return new ArraySize(size.height, size.width);
  }
  createKernel(kernel, outputSize) {
    return function(...args) {
      const result = [];
      for (let y = 0; y < outputSize.height; ++y) {
        result.push([]);
        for (let x = 0; x < outputSize.width; ++x) {
          result[y][x] = kernel.apply({
            thread: {
              x,
              y
            }
          }, args);
        }
      }
      return result;
    };
  }
}
MatrixPlugin.implementedFunctions = {
  "MMULT": {
    method: "mmult",
    sizeOfResultArrayMethod: "mmultArraySize",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }],
    vectorizationForbidden: true
  },
  "TRANSPOSE": {
    method: "transpose",
    sizeOfResultArrayMethod: "transposeArraySize",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }],
    vectorizationForbidden: true
  },
  "MAXPOOL": {
    method: "maxpool",
    sizeOfResultArrayMethod: "maxpoolArraySize",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true
    }],
    vectorizationForbidden: true
  },
  "MEDIANPOOL": {
    method: "medianpool",
    sizeOfResultArrayMethod: "medianpoolArraySize",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true
    }],
    vectorizationForbidden: true
  }
};
class MedianPlugin extends FunctionPlugin {
  /**
   * Corresponds to MEDIAN(Number1, Number2, ...).
   *
   * Returns a median of given numbers.
   *
   * @param ast
   * @param state
   */
  median(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MEDIAN"), (...args) => {
      const values2 = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (values2 instanceof CellError) {
        return values2;
      }
      if (values2.length === 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.OneValue);
      }
      values2.sort((a, b) => a - b);
      if (values2.length % 2 === 0) {
        return (values2[values2.length / 2 - 1] + values2[values2.length / 2]) / 2;
      } else {
        return values2[Math.floor(values2.length / 2)];
      }
    });
  }
  large(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LARGE"), (range, n2) => {
      const vals = this.arithmeticHelper.manyToExactNumbers(range.valuesFromTopLeftCorner());
      if (vals instanceof CellError) {
        return vals;
      }
      vals.sort((a, b) => a - b);
      n2 = Math.trunc(n2);
      if (n2 > vals.length) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      return vals[vals.length - n2];
    });
  }
  small(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SMALL"), (range, n2) => {
      const vals = this.arithmeticHelper.manyToExactNumbers(range.valuesFromTopLeftCorner());
      if (vals instanceof CellError) {
        return vals;
      }
      vals.sort((a, b) => a - b);
      n2 = Math.trunc(n2);
      if (n2 > vals.length) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      return vals[n2 - 1];
    });
  }
}
MedianPlugin.implementedFunctions = {
  "MEDIAN": {
    method: "median",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "LARGE": {
    method: "large",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "SMALL": {
    method: "small",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  }
};
class ModuloPlugin extends FunctionPlugin {
  mod(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MOD"), (dividend, divisor) => {
      if (divisor === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      } else {
        return dividend % divisor;
      }
    });
  }
}
ModuloPlugin.implementedFunctions = {
  "MOD": {
    method: "mod",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
function percentileInclusive(sortedVals, k) {
  const n2 = sortedVals.length;
  const rank = k * (n2 - 1);
  const lowerIndex = Math.floor(rank);
  const fraction = rank - lowerIndex;
  if (lowerIndex + 1 < n2) {
    return sortedVals[lowerIndex] + fraction * (sortedVals[lowerIndex + 1] - sortedVals[lowerIndex]);
  }
  return sortedVals[lowerIndex];
}
function percentileExclusive(sortedVals, k) {
  const n2 = sortedVals.length;
  const rank = k * (n2 + 1);
  if (rank < 1) {
    return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
  }
  if (rank > n2) {
    return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
  }
  const lowerIndex = Math.floor(rank);
  const fraction = rank - lowerIndex;
  if (lowerIndex < n2) {
    return sortedVals[lowerIndex - 1] + fraction * (sortedVals[lowerIndex] - sortedVals[lowerIndex - 1]);
  }
  return sortedVals[lowerIndex - 1];
}
class PercentilePlugin extends FunctionPlugin {
  /**
   * Corresponds to PERCENTILE(array, k) and PERCENTILE.INC(array, k).
   *
   * Returns the k-th percentile of values in a range using inclusive interpolation.
   *
   * @param ast - procedure AST node
   * @param state - interpreter state
   * @returns interpolated percentile value, or CellError on invalid input
   */
  percentile(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PERCENTILE.INC"), (range, k) => {
      const vals = this.getSortedValues(range);
      if (vals instanceof CellError) {
        return vals;
      }
      return percentileInclusive(vals, k);
    });
  }
  /**
   * Corresponds to PERCENTILE.EXC(array, k).
   *
   * Returns the k-th percentile of values in a range using exclusive interpolation.
   *
   * @param ast - procedure AST node
   * @param state - interpreter state
   * @returns interpolated percentile value, or CellError on invalid input
   */
  percentileExc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PERCENTILE.EXC"), (range, k) => {
      const vals = this.getSortedValues(range);
      if (vals instanceof CellError) {
        return vals;
      }
      return percentileExclusive(vals, k);
    });
  }
  /**
   * Corresponds to QUARTILE(array, quart) and QUARTILE.INC(array, quart).
   *
   * Returns the quartile of a data set using inclusive interpolation.
   * quart is truncated to an integer and validated in [0, 4].
   *
   * @param ast - procedure AST node
   * @param state - interpreter state
   * @returns quartile value, or CellError on invalid input
   */
  quartile(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("QUARTILE.INC"), (range, quart) => {
      quart = Math.trunc(quart);
      if (quart < 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
      }
      if (quart > 4) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      const vals = this.getSortedValues(range);
      if (vals instanceof CellError) {
        return vals;
      }
      return percentileInclusive(vals, quart / 4);
    });
  }
  /**
   * Corresponds to QUARTILE.EXC(array, quart).
   *
   * Returns the quartile of a data set using exclusive interpolation.
   * quart is truncated to an integer and validated in [1, 3].
   *
   * @param ast - procedure AST node
   * @param state - interpreter state
   * @returns quartile value, or CellError on invalid input
   */
  quartileExc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("QUARTILE.EXC"), (range, quart) => {
      quart = Math.trunc(quart);
      if (quart < 1) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
      }
      if (quart > 3) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      const vals = this.getSortedValues(range);
      if (vals instanceof CellError) {
        return vals;
      }
      return percentileExclusive(vals, quart / 4);
    });
  }
  /**
   * Extracts numeric values from a range, filters non-numbers, and returns them sorted.
   * Returns CellError if the range contains an error, or if no numeric values exist.
   *
   * @param range - input range from the spreadsheet
   * @returns sorted numeric values (ascending), or CellError
   */
  getSortedValues(range) {
    const vals = this.arithmeticHelper.manyToExactNumbers(range.valuesFromTopLeftCorner());
    if (vals instanceof CellError) {
      return vals;
    }
    if (vals.length === 0) {
      return new CellError(ErrorType.NUM, ErrorMessage.OneValue);
    }
    vals.sort((a, b) => a - b);
    return vals;
  }
}
PercentilePlugin.implementedFunctions = {
  "PERCENTILE.INC": {
    method: "percentile",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }]
  },
  "PERCENTILE.EXC": {
    method: "percentileExc",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }]
  },
  "QUARTILE.INC": {
    method: "quartile",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "QUARTILE.EXC": {
    method: "quartileExc",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
PercentilePlugin.aliases = {
  PERCENTILE: "PERCENTILE.INC",
  QUARTILE: "QUARTILE.INC"
};
function zeroForInfinite$1(value) {
  if (isExtendedNumber(value) && !Number.isFinite(getRawValue(value))) {
    return 0;
  } else {
    return value;
  }
}
class MomentsAggregate {
  constructor(sumsq, sum2, count) {
    this.sumsq = sumsq;
    this.sum = sum2;
    this.count = count;
  }
  static single(arg) {
    return new MomentsAggregate(arg * arg, arg, 1);
  }
  compose(other) {
    return new MomentsAggregate(this.sumsq + other.sumsq, this.sum + other.sum, this.count + other.count);
  }
  averageValue() {
    if (this.count > 0) {
      return this.sum / this.count;
    } else {
      return void 0;
    }
  }
  varSValue() {
    if (this.count > 1) {
      return (this.sumsq - this.sum * this.sum / this.count) / (this.count - 1);
    } else {
      return void 0;
    }
  }
  varPValue() {
    if (this.count > 0) {
      return (this.sumsq - this.sum * this.sum / this.count) / this.count;
    } else {
      return void 0;
    }
  }
}
MomentsAggregate.empty = new MomentsAggregate(0, 0, 0);
class NumericAggregationPlugin extends FunctionPlugin {
  constructor() {
    super(...arguments);
    this.addWithEpsilonRaw = (left2, right2) => this.arithmeticHelper.addWithEpsilonRaw(left2, right2);
  }
  /**
   * Corresponds to SUM(Number1, Number2, ...).
   *
   * Returns a sum of given numbers.
   *
   * @param ast
   * @param state
   */
  sum(ast, state) {
    return this.doSum(ast.args, state);
  }
  sumsq(ast, state) {
    return this.reduce(ast.args, state, 0, "SUMSQ", this.addWithEpsilonRaw, (arg) => Math.pow(getRawValue(arg), 2), strictlyNumbers);
  }
  /**
   * Corresponds to MAX(Number1, Number2, ...).
   *
   * Returns a max of given numbers.
   *
   * @param ast
   * @param state
   */
  max(ast, state) {
    return this.doMax(ast.args, state);
  }
  maxa(ast, state) {
    const value = this.reduce(ast.args, state, Number.NEGATIVE_INFINITY, "MAXA", (left2, right2) => Math.max(left2, right2), getRawValue, numbersBooleans);
    return zeroForInfinite$1(value);
  }
  /**
   * Corresponds to MIN(Number1, Number2, ...).
   *
   * Returns a min of given numbers.
   *
   * @param ast
   * @param state
   */
  min(ast, state) {
    return this.doMin(ast.args, state);
  }
  mina(ast, state) {
    const value = this.reduce(ast.args, state, Number.POSITIVE_INFINITY, "MINA", (left2, right2) => Math.min(left2, right2), getRawValue, numbersBooleans);
    return zeroForInfinite$1(value);
  }
  count(ast, state) {
    return this.doCount(ast.args, state);
  }
  counta(ast, state) {
    return this.doCounta(ast.args, state);
  }
  average(ast, state) {
    return this.doAverage(ast.args, state);
  }
  averagea(ast, state) {
    var _a;
    const result = this.reduce(ast.args, state, MomentsAggregate.empty, "_AGGREGATE_A", (left2, right2) => left2.compose(right2), (arg) => MomentsAggregate.single(getRawValue(arg)), numbersBooleans);
    if (result instanceof CellError) {
      return result;
    } else {
      return (_a = result.averageValue()) !== null && _a !== void 0 ? _a : new CellError(ErrorType.DIV_BY_ZERO);
    }
  }
  vars(ast, state) {
    return this.doVarS(ast.args, state);
  }
  varp(ast, state) {
    return this.doVarP(ast.args, state);
  }
  vara(ast, state) {
    var _a;
    const result = this.reduceAggregateA(ast.args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      return (_a = result.varSValue()) !== null && _a !== void 0 ? _a : new CellError(ErrorType.DIV_BY_ZERO);
    }
  }
  varpa(ast, state) {
    var _a;
    const result = this.reduceAggregateA(ast.args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      return (_a = result.varPValue()) !== null && _a !== void 0 ? _a : new CellError(ErrorType.DIV_BY_ZERO);
    }
  }
  stdevs(ast, state) {
    return this.doStdevS(ast.args, state);
  }
  stdevp(ast, state) {
    return this.doStdevP(ast.args, state);
  }
  stdeva(ast, state) {
    const result = this.reduceAggregateA(ast.args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      const val = result.varSValue();
      return val === void 0 ? new CellError(ErrorType.DIV_BY_ZERO) : Math.sqrt(val);
    }
  }
  stdevpa(ast, state) {
    const result = this.reduceAggregateA(ast.args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      const val = result.varPValue();
      return val === void 0 ? new CellError(ErrorType.DIV_BY_ZERO) : Math.sqrt(val);
    }
  }
  product(ast, state) {
    return this.doProduct(ast.args, state);
  }
  subtotal(ast, state) {
    if (ast.args.length < 2) {
      return new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber);
    }
    const functionType = this.coerceToType(this.evaluateAst(ast.args[0], state), {
      argumentType: FunctionArgumentType.NUMBER
    }, state);
    const args = ast.args.slice(1);
    switch (functionType) {
      case 1:
      case 101:
        return this.doAverage(args, state);
      case 2:
      case 102:
        return this.doCount(args, state);
      case 3:
      case 103:
        return this.doCounta(args, state);
      case 4:
      case 104:
        return this.doMax(args, state);
      case 5:
      case 105:
        return this.doMin(args, state);
      case 6:
      case 106:
        return this.doProduct(args, state);
      case 7:
      case 107:
        return this.doStdevS(args, state);
      case 8:
      case 108:
        return this.doStdevP(args, state);
      case 9:
      case 109:
        return this.doSum(args, state);
      case 10:
      case 110:
        return this.doVarS(args, state);
      case 11:
      case 111:
        return this.doVarP(args, state);
      default:
        return new CellError(ErrorType.VALUE, ErrorMessage.BadMode);
    }
  }
  reduceAggregate(args, state) {
    return this.reduce(args, state, MomentsAggregate.empty, "_AGGREGATE", (left2, right2) => {
      return left2.compose(right2);
    }, (arg) => {
      return MomentsAggregate.single(getRawValue(arg));
    }, strictlyNumbers);
  }
  reduceAggregateA(args, state) {
    return this.reduce(args, state, MomentsAggregate.empty, "_AGGREGATE_A", (left2, right2) => {
      return left2.compose(right2);
    }, (arg) => {
      return MomentsAggregate.single(getRawValue(arg));
    }, numbersBooleans);
  }
  doAverage(args, state) {
    var _a;
    const result = this.reduceAggregate(args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      return (_a = result.averageValue()) !== null && _a !== void 0 ? _a : new CellError(ErrorType.DIV_BY_ZERO);
    }
  }
  doVarS(args, state) {
    var _a;
    const result = this.reduceAggregate(args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      return (_a = result.varSValue()) !== null && _a !== void 0 ? _a : new CellError(ErrorType.DIV_BY_ZERO);
    }
  }
  doVarP(args, state) {
    var _a;
    const result = this.reduceAggregate(args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      return (_a = result.varPValue()) !== null && _a !== void 0 ? _a : new CellError(ErrorType.DIV_BY_ZERO);
    }
  }
  doStdevS(args, state) {
    const result = this.reduceAggregate(args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      const val = result.varSValue();
      return val === void 0 ? new CellError(ErrorType.DIV_BY_ZERO) : Math.sqrt(val);
    }
  }
  doStdevP(args, state) {
    const result = this.reduceAggregate(args, state);
    if (result instanceof CellError) {
      return result;
    } else {
      const val = result.varPValue();
      return val === void 0 ? new CellError(ErrorType.DIV_BY_ZERO) : Math.sqrt(val);
    }
  }
  doCount(args, state) {
    return this.reduce(args, state, 0, "COUNT", (left2, right2) => left2 + right2, getRawValue, (arg) => isExtendedNumber(arg) ? 1 : 0);
  }
  doCounta(args, state) {
    return this.reduce(args, state, 0, "COUNTA", (left2, right2) => left2 + right2, getRawValue, (arg) => arg === EmptyValue ? 0 : 1);
  }
  doMax(args, state) {
    const value = this.reduce(args, state, Number.NEGATIVE_INFINITY, "MAX", (left2, right2) => Math.max(left2, right2), getRawValue, strictlyNumbers);
    return zeroForInfinite$1(value);
  }
  doMin(args, state) {
    const value = this.reduce(args, state, Number.POSITIVE_INFINITY, "MIN", (left2, right2) => Math.min(left2, right2), getRawValue, strictlyNumbers);
    return zeroForInfinite$1(value);
  }
  doSum(args, state) {
    return this.reduce(args, state, 0, "SUM", this.addWithEpsilonRaw, getRawValue, strictlyNumbers);
  }
  doProduct(args, state) {
    return this.reduce(args, state, 1, "PRODUCT", (left2, right2) => left2 * right2, getRawValue, strictlyNumbers);
  }
  /**
   * Reduces procedure arguments with given reducing function
   *
   * @param args
   * @param state
   * @param initialAccValue - "neutral" value (equivalent of 0)
   * @param functionName - function name to use as cache key
   * @param reducingFunction - reducing function
   * @param mapFunction
   * @param coercionFunction
   */
  reduce(args, state, initialAccValue, functionName2, reducingFunction, mapFunction, coercionFunction) {
    if (args.length < 1) {
      return new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber);
    }
    return args.reduce((acc, arg) => {
      if (acc instanceof CellError) {
        return acc;
      }
      if (arg.type === AstNodeType.CELL_RANGE || arg.type === AstNodeType.COLUMN_RANGE || arg.type === AstNodeType.ROW_RANGE) {
        const val = this.evaluateRange(arg, state, initialAccValue, functionName2, reducingFunction, mapFunction, coercionFunction);
        if (val instanceof CellError) {
          return val;
        }
        return reducingFunction(val, acc);
      }
      let value;
      value = this.evaluateAst(arg, state);
      if (value instanceof SimpleRangeValue) {
        const coercedRangeValues = Array.from(value.valuesFromTopLeftCorner()).map(coercionFunction).filter((arg2) => arg2 !== void 0);
        return coercedRangeValues.map((arg2) => {
          if (arg2 instanceof CellError) {
            return arg2;
          } else {
            return mapFunction(arg2);
          }
        }).reduce((left2, right2) => {
          if (left2 instanceof CellError) {
            return left2;
          } else if (right2 instanceof CellError) {
            return right2;
          } else {
            return reducingFunction(left2, right2);
          }
        }, acc);
      } else if (arg.type === AstNodeType.CELL_REFERENCE) {
        value = coercionFunction(value);
        if (value === void 0) {
          return acc;
        }
      } else {
        value = this.coerceScalarToNumberOrError(value);
        value = coercionFunction(value);
        if (value === void 0) {
          return acc;
        }
      }
      if (value instanceof CellError) {
        return value;
      }
      return reducingFunction(acc, mapFunction(value));
    }, initialAccValue);
  }
  /**
   * Performs range operation on given range
   *
   * @param {CellRangeAst | ColumnRangeAst | RowRangeAst} ast - cell range ast
   * @param {InterpreterState} state - interpreter state
   * @param {T} initialAccValue - initial accumulator value for reducing function
   * @param {string} functionName - function name to use as cache key
   * @param {BinaryOperation<T>} reducingFunction - reducing function
   * @param {MapOperation<T>} mapFunction - mapper transforming coerced scalar
   * @param {coercionOperation} coercionFunction - scalar-to-number coercer
   */
  evaluateRange(ast, state, initialAccValue, functionName2, reducingFunction, mapFunction, coercionFunction) {
    let range;
    try {
      range = AbsoluteCellRange.fromAst(ast, state.formulaAddress);
    } catch (err) {
      if (err instanceof SheetsNotEqual) {
        return new CellError(ErrorType.REF, ErrorMessage.RangeManySheets);
      } else {
        throw err;
      }
    }
    if (!this.isSheetValid(range)) {
      return new CellError(ErrorType.REF, ErrorMessage.SheetRef);
    }
    const rangeVertex = this.dependencyGraph.getRange(range.start, range.end);
    if (rangeVertex === void 0) {
      throw new Error("Range does not exists in graph");
    }
    let value = rangeVertex.getFunctionValue(functionName2);
    if (value === void 0) {
      const rangeValues = this.getRangeValues(functionName2, range, rangeVertex, mapFunction, coercionFunction);
      value = rangeValues.reduce((arg1, arg2) => {
        if (arg1 instanceof CellError) {
          return arg1;
        } else if (arg2 instanceof CellError) {
          return arg2;
        } else {
          return reducingFunction(arg1, arg2);
        }
      }, initialAccValue);
      rangeVertex.setFunctionValue(functionName2, value);
    }
    return value;
  }
  /**
   * Checks whether both ends of a range point to existing sheets (placeholders excluded).
   */
  isSheetValid(range) {
    return this.dependencyGraph.sheetMapping.hasSheetWithId(range.start.sheet, {
      includePlaceholders: false
    }) && this.dependencyGraph.sheetMapping.hasSheetWithId(range.end.sheet, {
      includePlaceholders: false
    });
  }
  /**
   * Returns list of values for given range and function name
   *
   * If range is dependent on smaller range, list will contain value of smaller range for this function
   * and values of cells that are not present in smaller range
   *
   * @param functionName - function name (e.g., SUM)
   * @param range - cell range
   * @param rangeVertex
   * @param mapFunction
   * @param coercionFunction
   */
  getRangeValues(functionName2, range, rangeVertex, mapFunction, coercionFunction) {
    const rangeResult = [];
    const {
      smallerRangeVertex,
      restRange
    } = this.dependencyGraph.rangeMapping.findSmallerRange(range);
    let actualRange;
    if (smallerRangeVertex !== void 0 && this.dependencyGraph.existsEdge(smallerRangeVertex, rangeVertex)) {
      const cachedValue = smallerRangeVertex.getFunctionValue(functionName2);
      if (cachedValue !== void 0) {
        rangeResult.push(cachedValue);
      } else {
        for (const cellFromRange of smallerRangeVertex.range.addresses(this.dependencyGraph)) {
          const val = coercionFunction(this.dependencyGraph.getScalarValue(cellFromRange));
          if (val instanceof CellError) {
            rangeResult.push(val);
          } else if (val !== void 0) {
            rangeResult.push(mapFunction(val));
          }
        }
      }
      actualRange = restRange;
    } else {
      actualRange = range;
    }
    for (const cellFromRange of actualRange.addresses(this.dependencyGraph)) {
      const val = coercionFunction(this.dependencyGraph.getScalarValue(cellFromRange));
      if (val instanceof CellError) {
        rangeResult.push(val);
      } else if (val !== void 0) {
        rangeResult.push(mapFunction(val));
      }
    }
    return rangeResult;
  }
}
NumericAggregationPlugin.implementedFunctions = {
  "SUM": {
    method: "sum",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "SUMSQ": {
    method: "sumsq",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "MAX": {
    method: "max",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "MIN": {
    method: "min",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "MAXA": {
    method: "maxa",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "MINA": {
    method: "mina",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "COUNT": {
    method: "count",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "COUNTA": {
    method: "counta",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "AVERAGE": {
    method: "average",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "AVERAGEA": {
    method: "averagea",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "PRODUCT": {
    method: "product",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "VAR.S": {
    method: "vars",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "VAR.P": {
    method: "varp",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "VARA": {
    method: "vara",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "VARPA": {
    method: "varpa",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "STDEV.S": {
    method: "stdevs",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "STDEV.P": {
    method: "stdevp",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "STDEVA": {
    method: "stdeva",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "STDEVPA": {
    method: "stdevpa",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "SUBTOTAL": {
    method: "subtotal",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  }
};
NumericAggregationPlugin.aliases = {
  VAR: "VAR.S",
  VARP: "VAR.P",
  STDEV: "STDEV.S",
  STDEVP: "STDEV.P",
  VARS: "VAR.S",
  STDEVS: "STDEV.S"
};
function strictlyNumbers(arg) {
  if (isExtendedNumber(arg) || arg instanceof CellError) {
    return arg;
  } else {
    return void 0;
  }
}
function numbersBooleans(arg) {
  if (typeof arg === "boolean") {
    return coerceBooleanToNumber(arg);
  } else if (isExtendedNumber(arg) || arg instanceof CellError) {
    return arg;
  } else if (typeof arg === "string") {
    return 0;
  } else {
    return void 0;
  }
}
class PowerPlugin extends FunctionPlugin {
  power(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("POWER"), Math.pow);
  }
}
PowerPlugin.implementedFunctions = {
  "POWER": {
    method: "power",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class RadiansPlugin extends FunctionPlugin {
  radians(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RADIANS"), (arg) => arg * (Math.PI / 180));
  }
}
RadiansPlugin.implementedFunctions = {
  "RADIANS": {
    method: "radians",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
const MAX_LENGTH = 10;
const DECIMAL_NUMBER_OF_BITS = 255;
const MIN_BASE = 2;
const MAX_BASE = 36;
const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
class RadixConversionPlugin extends FunctionPlugin {
  dec2bin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DEC2BIN"), (value, places) => decimalToBaseWithExactPadding(value, 2, places));
  }
  dec2oct(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DEC2OCT"), (value, places) => decimalToBaseWithExactPadding(value, 8, places));
  }
  dec2hex(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DEC2HEX"), (value, places) => decimalToBaseWithExactPadding(value, 16, places));
  }
  bin2dec(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BIN2DEC"), (binary) => {
      const binaryWithSign = coerceStringToBase(binary, 2, MAX_LENGTH);
      if (binaryWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotBinary);
      }
      return twoComplementToDecimal(binaryWithSign, 2);
    });
  }
  bin2oct(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BIN2OCT"), (binary, places) => {
      const binaryWithSign = coerceStringToBase(binary, 2, MAX_LENGTH);
      if (binaryWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotBinary);
      }
      return decimalToBaseWithExactPadding(twoComplementToDecimal(binaryWithSign, 2), 8, places);
    });
  }
  bin2hex(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BIN2HEX"), (binary, places) => {
      const binaryWithSign = coerceStringToBase(binary, 2, MAX_LENGTH);
      if (binaryWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotBinary);
      }
      return decimalToBaseWithExactPadding(twoComplementToDecimal(binaryWithSign, 2), 16, places);
    });
  }
  oct2dec(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("OCT2DEC"), (octal) => {
      const octalWithSign = coerceStringToBase(octal, 8, MAX_LENGTH);
      if (octalWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotOctal);
      }
      return twoComplementToDecimal(octalWithSign, 8);
    });
  }
  oct2bin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("OCT2BIN"), (octal, places) => {
      const octalWithSign = coerceStringToBase(octal, 8, MAX_LENGTH);
      if (octalWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotOctal);
      }
      return decimalToBaseWithExactPadding(twoComplementToDecimal(octalWithSign, 8), 2, places);
    });
  }
  oct2hex(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("OCT2HEX"), (octal, places) => {
      const octalWithSign = coerceStringToBase(octal, 8, MAX_LENGTH);
      if (octalWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotOctal);
      }
      return decimalToBaseWithExactPadding(twoComplementToDecimal(octalWithSign, 8), 16, places);
    });
  }
  hex2dec(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HEX2DEC"), (hexadecimal) => {
      const hexadecimalWithSign = coerceStringToBase(hexadecimal, 16, MAX_LENGTH);
      if (hexadecimalWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotHex);
      }
      return twoComplementToDecimal(hexadecimalWithSign, 16);
    });
  }
  hex2bin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HEX2BIN"), (hexadecimal, places) => {
      const hexadecimalWithSign = coerceStringToBase(hexadecimal, 16, MAX_LENGTH);
      if (hexadecimalWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotHex);
      }
      return decimalToBaseWithExactPadding(twoComplementToDecimal(hexadecimalWithSign, 16), 2, places);
    });
  }
  hex2oct(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HEX2OCT"), (hexadecimal, places) => {
      const hexadecimalWithSign = coerceStringToBase(hexadecimal, 16, MAX_LENGTH);
      if (hexadecimalWithSign === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotHex);
      }
      return decimalToBaseWithExactPadding(twoComplementToDecimal(hexadecimalWithSign, 16), 8, places);
    });
  }
  base(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BASE"), decimalToBaseWithMinimumPadding);
  }
  decimal(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DECIMAL"), (arg, base) => {
      const input = coerceStringToBase(arg, base, DECIMAL_NUMBER_OF_BITS);
      if (input === void 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NotHex);
      }
      return parseInt(input, base);
    });
  }
}
RadixConversionPlugin.implementedFunctions = {
  "DEC2BIN": {
    method: "dec2bin",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 1,
      maxValue: 10
    }]
  },
  "DEC2OCT": {
    method: "dec2oct",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 1,
      maxValue: 10
    }]
  },
  "DEC2HEX": {
    method: "dec2hex",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 1,
      maxValue: 10
    }]
  },
  "BIN2DEC": {
    method: "bin2dec",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "BIN2OCT": {
    method: "bin2oct",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: MAX_LENGTH
    }]
  },
  "BIN2HEX": {
    method: "bin2hex",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: MAX_LENGTH
    }]
  },
  "OCT2DEC": {
    method: "oct2dec",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "OCT2BIN": {
    method: "oct2bin",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: MAX_LENGTH
    }]
  },
  "OCT2HEX": {
    method: "oct2hex",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: MAX_LENGTH
    }]
  },
  "HEX2DEC": {
    method: "hex2dec",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "HEX2BIN": {
    method: "hex2bin",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: MAX_LENGTH
    }]
  },
  "HEX2OCT": {
    method: "hex2oct",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: MAX_LENGTH
    }]
  },
  "DECIMAL": {
    method: "decimal",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: MIN_BASE,
      maxValue: MAX_BASE
    }]
  },
  "BASE": {
    method: "base",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: MIN_BASE,
      maxValue: MAX_BASE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true,
      minValue: 0,
      maxValue: DECIMAL_NUMBER_OF_BITS
    }]
  }
};
function coerceStringToBase(value, base, maxLength) {
  const baseAlphabet = ALPHABET.substr(0, base);
  const regex = new RegExp(`^[${baseAlphabet}]+$`);
  if (value.length > maxLength || !regex.test(value)) {
    return void 0;
  }
  return value;
}
function decimalToBaseWithExactPadding(value, base, places) {
  if (value > maxValFromBase(base)) {
    return new CellError(ErrorType.NUM, ErrorMessage.ValueBaseLarge);
  }
  if (value < minValFromBase(base)) {
    return new CellError(ErrorType.NUM, ErrorMessage.ValueBaseSmall);
  }
  const result = decimalToRadixComplement(value, base);
  if (places === void 0 || value < 0) {
    return result;
  } else if (result.length > places) {
    return new CellError(ErrorType.NUM, ErrorMessage.ValueBaseLong);
  } else {
    return padLeft(result, places);
  }
}
function minValFromBase(base) {
  return -Math.pow(base, MAX_LENGTH) / 2;
}
function maxValFromBase(base) {
  return -minValFromBase(base) - 1;
}
function decimalToBaseWithMinimumPadding(value, base, places) {
  const result = decimalToRadixComplement(value, base);
  if (places !== void 0 && places > result.length) {
    return padLeft(result, places);
  } else {
    return result;
  }
}
function decimalToRadixComplement(value, base) {
  const offset2 = value < 0 ? Math.pow(base, MAX_LENGTH) : 0;
  return (value + offset2).toString(base).toUpperCase();
}
function twoComplementToDecimal(value, base) {
  const parsed = parseInt(value, base);
  const offset2 = Math.pow(base, MAX_LENGTH);
  return parsed >= offset2 / 2 ? parsed - offset2 : parsed;
}
class RandomPlugin extends FunctionPlugin {
  /**
   * Corresponds to RAND()
   *
   * Returns a pseudo-random floating-point random number
   * in the range [0,1).
   *
   * @param ast
   * @param state
   */
  rand(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RAND"), Math.random);
  }
  randbetween(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RANDBETWEEN"), (lower, upper) => {
      if (upper < lower) {
        return new CellError(ErrorType.NUM, ErrorMessage.WrongOrder);
      }
      lower = Math.ceil(lower);
      upper = Math.floor(upper) + 1;
      if (lower === upper) {
        upper += 1;
      }
      return lower + Math.floor(Math.random() * (upper - lower));
    });
  }
}
RandomPlugin.implementedFunctions = {
  "RAND": {
    method: "rand",
    parameters: [],
    isVolatile: true
  },
  "RANDBETWEEN": {
    method: "randbetween",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }],
    isVolatile: true
  }
};
class SequencePlugin extends FunctionPlugin {
  /** Returns true when `n` is a finite number at least {@link MIN_DIMENSION}. */
  static isValidDimension(n2) {
    return Number.isFinite(n2) && n2 >= SequencePlugin.MIN_DIMENSION;
  }
  /**
   * Parses a literal dimension from an AST node at parse time.
   * Handles NUMBER nodes directly, STRING nodes via numeric coercion,
   * PLUS/MINUS_UNARY_OP wrapping a NUMBER (e.g. `+3`, `-2`),
   * and TRUE()/FALSE() function calls (returning 1/0).
   * Returns undefined for non-literal nodes (cell refs, formulas, binary ops).
   */
  static parseLiteralDimension(node) {
    if (node.type === AstNodeType.NUMBER) {
      return Math.trunc(node.value);
    }
    if (node.type === AstNodeType.STRING) {
      const parsed = Number(node.value);
      return Number.isFinite(parsed) ? Math.trunc(parsed) : void 0;
    }
    if (node.type === AstNodeType.PLUS_UNARY_OP && node.value.type === AstNodeType.NUMBER) {
      return Math.trunc(node.value.value);
    }
    if (node.type === AstNodeType.MINUS_UNARY_OP && node.value.type === AstNodeType.NUMBER) {
      return Math.trunc(-node.value.value);
    }
    if (node.type === AstNodeType.FUNCTION_CALL) {
      if (node.procedureName === "TRUE" && node.args.length === 0) {
        return 1;
      }
      if (node.procedureName === "FALSE" && node.args.length === 0) {
        return 0;
      }
    }
    return void 0;
  }
  /**
   * Corresponds to SEQUENCE(rows, [cols], [start], [step])
   *
   * Returns a rows×cols array of sequential numbers starting at `start`
   * and incrementing by `step`, filled row-major.
   *
   * Note: dynamic arguments (cell references, formulas) for `rows` or `cols`
   * cause a size mismatch between parse-time prediction and runtime result,
   * which results in a #VALUE! error. Use literal numbers for rows and cols.
   *
   * @param {ProcedureAst} ast - The parsed function call AST node.
   * @param {InterpreterState} state - Current interpreter evaluation state.
   */
  sequence(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SEQUENCE"), (rows, cols, start, step) => {
      if (!Number.isFinite(rows) || !Number.isFinite(cols)) {
        return new CellError(ErrorType.VALUE, ErrorMessage.ValueLarge);
      }
      if (rows < 0 || cols < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      const numRows = Math.trunc(rows);
      const numCols = Math.trunc(cols);
      if (!SequencePlugin.isValidDimension(numRows) || !SequencePlugin.isValidDimension(numCols)) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      if (numRows > this.config.maxRows || numCols > this.config.maxColumns) {
        return new CellError(ErrorType.VALUE, ErrorMessage.ValueLarge);
      }
      const result = [];
      for (let r = 0; r < numRows; r++) {
        const row = [];
        for (let c = 0; c < numCols; c++) {
          row.push(start + (r * numCols + c) * step);
        }
        result.push(row);
      }
      return SimpleRangeValue.onlyNumbers(result);
    });
  }
  /**
   * Predicts the output array size for SEQUENCE at parse time.
   *
   * Handles NUMBER and STRING literals for rows/cols via `parseLiteralDimension`.
   * Non-literal args (cell refs, formulas, unary/binary ops) fall back to 1,
   * which will cause a size mismatch at eval time when the actual result is larger.
   *
   * @param {ProcedureAst} ast - The parsed function call AST node.
   * @param {InterpreterState} _state - Current interpreter evaluation state (unused).
   */
  sequenceArraySize(ast, _state) {
    if (ast.args.length < 1 || ast.args.length > 4) {
      return ArraySize.error();
    }
    const rowsArg = ast.args[0];
    const colsArg = ast.args.length > 1 ? ast.args[1] : void 0;
    if (rowsArg.type === AstNodeType.EMPTY) {
      return ArraySize.error();
    }
    const rows = SequencePlugin.parseLiteralDimension(rowsArg);
    if (rows === void 0) {
      return ArraySize.error();
    }
    const cols = colsArg === void 0 || colsArg.type === AstNodeType.EMPTY ? 1 : SequencePlugin.parseLiteralDimension(colsArg);
    if (cols === void 0) {
      return ArraySize.error();
    }
    if (!SequencePlugin.isValidDimension(rows) || !SequencePlugin.isValidDimension(cols)) {
      return ArraySize.error();
    }
    if (rows > this.config.maxRows || cols > this.config.maxColumns) {
      return ArraySize.error();
    }
    return new ArraySize(cols, rows);
  }
}
SequencePlugin.MIN_DIMENSION = 1;
SequencePlugin.implementedFunctions = {
  "SEQUENCE": {
    method: "sequence",
    sizeOfResultArrayMethod: "sequenceArraySize",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1,
      emptyAsDefault: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1,
      emptyAsDefault: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1,
      emptyAsDefault: true
    }],
    vectorizationForbidden: true
  }
};
function findNextOddNumber(arg) {
  const ceiled = Math.ceil(arg);
  return ceiled % 2 === 1 ? ceiled : ceiled + 1;
}
function findNextEvenNumber(arg) {
  const ceiled = Math.ceil(arg);
  return ceiled % 2 === 0 ? ceiled : ceiled + 1;
}
class RoundingPlugin extends FunctionPlugin {
  roundup(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ROUNDDOWN"), (numberToRound, places) => {
      const placesMultiplier = Math.pow(10, places);
      if (numberToRound < 0) {
        return -Math.ceil(-numberToRound * placesMultiplier) / placesMultiplier;
      } else {
        return Math.ceil(numberToRound * placesMultiplier) / placesMultiplier;
      }
    });
  }
  rounddown(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ROUNDDOWN"), (numberToRound, places) => {
      const placesMultiplier = Math.pow(10, places);
      if (numberToRound < 0) {
        return -Math.floor(-numberToRound * placesMultiplier) / placesMultiplier;
      } else {
        return Math.floor(numberToRound * placesMultiplier) / placesMultiplier;
      }
    });
  }
  round(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ROUND"), (numberToRound, places) => {
      const placesMultiplier = Math.pow(10, places);
      if (numberToRound < 0) {
        return -Math.round(-numberToRound * placesMultiplier) / placesMultiplier;
      } else {
        return Math.round(numberToRound * placesMultiplier) / placesMultiplier;
      }
    });
  }
  intFunc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("INT"), (coercedNumberToRound) => {
      if (coercedNumberToRound < 0) {
        return -Math.floor(-coercedNumberToRound);
      } else {
        return Math.floor(coercedNumberToRound);
      }
    });
  }
  even(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EVEN"), (coercedNumberToRound) => {
      if (coercedNumberToRound < 0) {
        return -findNextEvenNumber(-coercedNumberToRound);
      } else {
        return findNextEvenNumber(coercedNumberToRound);
      }
    });
  }
  odd(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ODD"), (coercedNumberToRound) => {
      if (coercedNumberToRound < 0) {
        return -findNextOddNumber(-coercedNumberToRound);
      } else {
        return findNextOddNumber(coercedNumberToRound);
      }
    });
  }
  ceilingmath(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CEILING.MATH"), (value, significance, mode) => {
      if (significance === 0 || value === 0) {
        return 0;
      }
      significance = Math.abs(significance);
      if (mode === 1 && value < 0) {
        significance = -significance;
      }
      return Math.ceil(value / significance) * significance;
    });
  }
  ceiling(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CEILING"), (value, significance) => {
      if (value === 0) {
        return 0;
      }
      if (significance === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      if (value > 0 && significance < 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.DistinctSigns);
      }
      return Math.ceil(value / significance) * significance;
    });
  }
  ceilingprecise(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CEILING.PRECISE"), (value, significance) => {
      if (significance === 0 || value === 0) {
        return 0;
      }
      significance = Math.abs(significance);
      return Math.ceil(value / significance) * significance;
    });
  }
  floormath(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FLOOR.MATH"), (value, significance, mode) => {
      if (significance === 0 || value === 0) {
        return 0;
      }
      significance = Math.abs(significance);
      if (mode === 1 && value < 0) {
        significance *= -1;
      }
      return Math.floor(value / significance) * significance;
    });
  }
  floor(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FLOOR"), (value, significance) => {
      if (value === 0) {
        return 0;
      }
      if (significance === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      if (value > 0 && significance < 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.DistinctSigns);
      }
      return Math.floor(value / significance) * significance;
    });
  }
  floorprecise(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FLOOR.PRECISE"), (value, significance) => {
      if (significance === 0 || value === 0) {
        return 0;
      }
      significance = Math.abs(significance);
      return Math.floor(value / significance) * significance;
    });
  }
}
RoundingPlugin.implementedFunctions = {
  "ROUNDUP": {
    method: "roundup",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  },
  "ROUNDDOWN": {
    method: "rounddown",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  },
  "ROUND": {
    method: "round",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  },
  "INT": {
    method: "intFunc",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "EVEN": {
    method: "even",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ODD": {
    method: "odd",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "CEILING.MATH": {
    method: "ceilingmath",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  },
  "CEILING": {
    method: "ceiling",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "CEILING.PRECISE": {
    method: "ceilingprecise",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "FLOOR.MATH": {
    method: "floormath",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }]
  },
  "FLOOR": {
    method: "floor",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "FLOOR.PRECISE": {
    method: "floorprecise",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  }
};
RoundingPlugin.aliases = {
  "ISO.CEILING": "CEILING.PRECISE",
  "TRUNC": "ROUNDDOWN"
};
class SqrtPlugin extends FunctionPlugin {
  sqrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SQRT"), Math.sqrt);
  }
}
SqrtPlugin.implementedFunctions = {
  "SQRT": {
    method: "sqrt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
function* empty() {
}
function split(iterable) {
  const iterator = iterable[Symbol.iterator]();
  const {
    done,
    value
  } = iterator.next();
  if (done) {
    return {
      rest: empty()
    };
  } else {
    return {
      value,
      rest: iterator
    };
  }
}
const findSmallerRangeForMany = (dependencyGraph, conditionRanges, valuesRange) => {
  if (valuesRange.end.row > valuesRange.start.row) {
    const valuesRangeEndRowLess = simpleCellAddress(valuesRange.end.sheet, valuesRange.end.col, valuesRange.end.row - 1);
    const rowLessVertex = dependencyGraph.getRange(valuesRange.start, valuesRangeEndRowLess);
    if (rowLessVertex !== void 0) {
      return {
        smallerRangeVertex: rowLessVertex,
        restValuesRange: valuesRange.withStart(simpleCellAddress(valuesRange.start.sheet, valuesRange.start.col, valuesRange.end.row)),
        restConditionRanges: conditionRanges.map((conditionRange) => conditionRange.withStart(simpleCellAddress(conditionRange.start.sheet, conditionRange.start.col, conditionRange.end.row)))
      };
    }
  }
  return {
    restValuesRange: valuesRange,
    restConditionRanges: conditionRanges
  };
};
class CriterionFunctionCompute {
  constructor(interpreter, cacheKey, reduceInitialValue, composeFunction, mapFunction) {
    this.interpreter = interpreter;
    this.cacheKey = cacheKey;
    this.reduceInitialValue = reduceInitialValue;
    this.composeFunction = composeFunction;
    this.mapFunction = mapFunction;
    this.dependencyGraph = this.interpreter.dependencyGraph;
  }
  compute(simpleValuesRange, conditions2) {
    for (const condition2 of conditions2) {
      if (!condition2.conditionRange.sameDimensionsAs(simpleValuesRange)) {
        return new CellError(ErrorType.VALUE, ErrorMessage.EqualLength);
      }
    }
    const valuesRangeVertex = this.tryToGetRangeVertexForRangeValue(simpleValuesRange);
    const conditionsVertices = conditions2.map((c) => this.tryToGetRangeVertexForRangeValue(c.conditionRange));
    if (valuesRangeVertex && conditionsVertices.every((e) => e !== void 0)) {
      const fullCriterionString = conditions2.map((c) => c.criterionPackage.raw).join(",");
      const cachedResult = this.findAlreadyComputedValueInCache(valuesRangeVertex, this.cacheKey(conditions2), fullCriterionString);
      if (cachedResult !== void 0) {
        this.interpreter.stats.incrementCriterionFunctionFullCacheUsed();
        return cachedResult;
      }
      const cache = this.buildNewCriterionCache(this.cacheKey(conditions2), conditions2.map((c) => c.conditionRange.range), simpleValuesRange.range);
      if (!cache.has(fullCriterionString)) {
        cache.set(fullCriterionString, [this.evaluateRangeValue(simpleValuesRange, conditions2), conditions2.map((condition2) => condition2.criterionPackage.lambda)]);
      }
      valuesRangeVertex.setCriterionFunctionValues(this.cacheKey(conditions2), cache);
      conditionsVertices.forEach((range) => {
        if (range !== void 0) {
          range.addDependentCacheRange(valuesRangeVertex);
        }
      });
      return cache.get(fullCriterionString)[0];
    } else {
      return this.evaluateRangeValue(simpleValuesRange, conditions2);
    }
  }
  tryToGetRangeVertexForRangeValue(rangeValue) {
    const maybeRange = rangeValue.range;
    if (maybeRange === void 0) {
      return void 0;
    } else {
      return this.dependencyGraph.getRange(maybeRange.start, maybeRange.end);
    }
  }
  reduceFunction(iterable) {
    let acc = this.reduceInitialValue;
    for (const val of iterable) {
      acc = this.composeFunction(acc, val);
    }
    return acc;
  }
  findAlreadyComputedValueInCache(rangeVertex, cacheKey, criterionString) {
    return rangeVertex.getCriterionFunctionValue(cacheKey, criterionString);
  }
  evaluateRangeValue(simpleValuesRange, conditions2) {
    const criterionLambdas = conditions2.map((condition2) => condition2.criterionPackage.lambda);
    const values2 = Array.from(simpleValuesRange.valuesFromTopLeftCorner()).map(this.mapFunction)[Symbol.iterator]();
    const conditionsIterators = conditions2.map((condition2) => condition2.conditionRange.iterateValuesFromTopLeftCorner());
    const filteredValues = ifFilter(criterionLambdas, conditionsIterators, values2);
    return this.reduceFunction(filteredValues);
  }
  buildNewCriterionCache(cacheKey, simpleConditionRanges, simpleValuesRange) {
    const currentRangeVertex = this.dependencyGraph.getRange(simpleValuesRange.start, simpleValuesRange.end);
    const {
      smallerRangeVertex,
      restConditionRanges,
      restValuesRange
    } = findSmallerRangeForMany(this.dependencyGraph, simpleConditionRanges, simpleValuesRange);
    let smallerCache;
    if (smallerRangeVertex !== void 0 && this.dependencyGraph.existsEdge(smallerRangeVertex, currentRangeVertex)) {
      smallerCache = smallerRangeVertex.getCriterionFunctionValues(cacheKey);
    } else {
      smallerCache = /* @__PURE__ */ new Map();
    }
    const newCache = /* @__PURE__ */ new Map();
    smallerCache.forEach(([value, criterionLambdas], key) => {
      const filteredValues = ifFilter(criterionLambdas, restConditionRanges.map((rcr) => getRangeValues(this.dependencyGraph, rcr)), Array.from(getRangeValues(this.dependencyGraph, restValuesRange)).map(this.mapFunction)[Symbol.iterator]());
      const newCacheValue = this.composeFunction(value, this.reduceFunction(filteredValues));
      this.interpreter.stats.incrementCriterionFunctionPartialCacheUsed();
      newCache.set(key, [newCacheValue, criterionLambdas]);
    });
    return newCache;
  }
}
class Condition {
  constructor(conditionRange, criterionPackage) {
    this.conditionRange = conditionRange;
    this.criterionPackage = criterionPackage;
  }
}
function* getRangeValues(dependencyGraph, cellRange) {
  for (const cellFromRange of cellRange.addresses(dependencyGraph)) {
    yield getRawValue(dependencyGraph.getScalarValue(cellFromRange));
  }
}
function* ifFilter(criterionLambdas, conditionalIterables, computableIterable) {
  for (const computable of computableIterable) {
    const conditionalSplits = conditionalIterables.map((conditionalIterable) => split(conditionalIterable));
    if (!conditionalSplits.every((cs) => Object.prototype.hasOwnProperty.call(cs, "value"))) {
      return;
    }
    const conditionalFirsts = conditionalSplits.map((cs) => getRawValue(cs.value));
    if (zip(conditionalFirsts, criterionLambdas).every(([conditionalFirst, criterionLambda]) => criterionLambda(conditionalFirst))) {
      yield computable;
    }
    conditionalIterables = conditionalSplits.map((cs) => cs.rest);
  }
}
function zip(arr1, arr2) {
  const result = [];
  for (let i = 0; i < Math.min(arr1.length, arr2.length); i++) {
    result.push([arr1[i], arr2[i]]);
  }
  return result;
}
class AverageResult {
  constructor(sum2, count) {
    this.sum = sum2;
    this.count = count;
  }
  static single(arg) {
    return new AverageResult(arg, 1);
  }
  compose(other) {
    return new AverageResult(this.sum + other.sum, this.count + other.count);
  }
  averageValue() {
    if (this.count > 0) {
      return this.sum / this.count;
    } else {
      return void 0;
    }
  }
}
AverageResult.empty = new AverageResult(0, 0);
function conditionalAggregationFunctionCacheKey(functionName2) {
  return (conditions2) => {
    const conditionsStrings = conditions2.map((c) => `${c.conditionRange.range.sheet},${c.conditionRange.range.start.col},${c.conditionRange.range.start.row}`);
    return [functionName2, ...conditionsStrings].join(",");
  };
}
function zeroForInfinite(value) {
  if (isExtendedNumber(value) && !Number.isFinite(getRawValue(value))) {
    return 0;
  } else {
    return value;
  }
}
function mapToRawScalarValue(arg) {
  if (arg instanceof CellError) {
    return arg;
  }
  if (isExtendedNumber(arg)) {
    return getRawValue(arg);
  }
  return void 0;
}
class ConditionalAggregationPlugin extends FunctionPlugin {
  /**
   * Corresponds to SUMIF(Range, Criterion, SumRange)
   *
   * Range is the range to which criterion is to be applied.
   * Criterion is the criteria used to choose which cells will be included in sum.
   * SumRange is the range on which adding will be performed.
   *
   * @param ast
   * @param state
   */
  sumif(ast, state) {
    const functionName2 = "SUMIF";
    const computeFn = (conditionRange, criterion, values2) => this.computeConditionalAggregationFunction(values2 !== null && values2 !== void 0 ? values2 : conditionRange, [conditionRange, criterion], functionName2, 0, (left2, right2) => this.arithmeticHelper.nonstrictadd(left2, right2), mapToRawScalarValue);
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  sumifs(ast, state) {
    const functionName2 = "SUMIFS";
    const computeFn = (values2, ...args) => this.computeConditionalAggregationFunction(values2, args, functionName2, 0, (left2, right2) => this.arithmeticHelper.nonstrictadd(left2, right2), mapToRawScalarValue);
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  averageif(ast, state) {
    const functionName2 = "AVERAGEIF";
    const computeFn = (conditionRange, criterion, values2) => {
      const averageResult = this.computeConditionalAggregationFunction(values2 !== null && values2 !== void 0 ? values2 : conditionRange, [conditionRange, criterion], functionName2, AverageResult.empty, (left2, right2) => left2.compose(right2), (arg) => isExtendedNumber(arg) ? AverageResult.single(getRawValue(arg)) : AverageResult.empty);
      if (averageResult instanceof CellError) {
        return averageResult;
      } else {
        return averageResult.averageValue() || new CellError(ErrorType.DIV_BY_ZERO);
      }
    };
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  /**
   * Corresponds to COUNTIF(Range, Criterion)
   *
   * Range is the range to which criterion is to be applied.
   * Criterion is the criteria used to choose which cells will be included in sum.
   *
   * Returns number of cells on which criteria evaluate to true.
   *
   * @param ast
   * @param state
   */
  countif(ast, state) {
    const functionName2 = "COUNTIF";
    const computeFn = (conditionRange, criterion) => this.computeConditionalAggregationFunction(conditionRange, [conditionRange, criterion], functionName2, 0, (left2, right2) => left2 + right2, () => 1);
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  countifs(ast, state) {
    const functionName2 = "COUNTIFS";
    const computeFn = (...args) => this.computeConditionalAggregationFunction(args[0], args, functionName2, 0, (left2, right2) => left2 + right2, () => 1);
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  minifs(ast, state) {
    const functionName2 = "MINIFS";
    const composeFunction = (left2, right2) => {
      if (right2 === void 0 || left2 === void 0) {
        return right2 === void 0 ? left2 : right2;
      }
      return Math.min(left2, right2);
    };
    const computeFn = (values2, ...args) => {
      const minResult = this.computeConditionalAggregationFunction(values2, args, functionName2, Number.POSITIVE_INFINITY, composeFunction, mapToRawScalarValue);
      return zeroForInfinite(minResult);
    };
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  maxifs(ast, state) {
    const functionName2 = "MAXIFS";
    const composeFunction = (left2, right2) => {
      if (right2 === void 0 || left2 === void 0) {
        return right2 === void 0 ? left2 : right2;
      }
      return Math.max(left2, right2);
    };
    const computeFn = (values2, ...args) => {
      const maxResult = this.computeConditionalAggregationFunction(values2, args, functionName2, Number.NEGATIVE_INFINITY, composeFunction, mapToRawScalarValue);
      return zeroForInfinite(maxResult);
    };
    return this.runFunction(ast.args, state, this.metadata(functionName2), computeFn);
  }
  computeConditionalAggregationFunction(valuesRange, conditionArgs, functionName2, reduceInitialValue, composeFunction, mapFunction) {
    const conditions2 = [];
    for (let i = 0; i < conditionArgs.length; i += 2) {
      const conditionArg = conditionArgs[i];
      const criterionPackage = this.interpreter.criterionBuilder.fromCellValue(conditionArgs[i + 1], this.arithmeticHelper);
      if (criterionPackage === void 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.BadCriterion);
      }
      conditions2.push(new Condition(conditionArg, criterionPackage));
    }
    return new CriterionFunctionCompute(this.interpreter, conditionalAggregationFunctionCacheKey(functionName2), reduceInitialValue, composeFunction, mapFunction).compute(valuesRange, conditions2);
  }
}
ConditionalAggregationPlugin.implementedFunctions = {
  SUMIF: {
    method: "sumif",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }, {
      argumentType: FunctionArgumentType.RANGE,
      optionalArg: true
    }]
  },
  COUNTIF: {
    method: "countif",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }]
  },
  AVERAGEIF: {
    method: "averageif",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }, {
      argumentType: FunctionArgumentType.RANGE,
      optionalArg: true
    }]
  },
  SUMIFS: {
    method: "sumifs",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }],
    repeatLastArgs: 2
  },
  COUNTIFS: {
    method: "countifs",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }],
    repeatLastArgs: 2
  },
  MINIFS: {
    method: "minifs",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }],
    repeatLastArgs: 2
  },
  MAXIFS: {
    method: "maxifs",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NOERROR
    }],
    repeatLastArgs: 2
  }
};
class SumprodPlugin extends FunctionPlugin {
  sumproduct(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SUMPRODUCT"), (...args) => {
      const width = args[0].width();
      const height = args[0].height();
      for (const arg of args) {
        if (arg.width() !== width || arg.height() !== height) {
          return new CellError(ErrorType.VALUE, ErrorMessage.EqualLength);
        }
      }
      let ret = 0;
      const iterators = args.map((arg) => arg.iterateValuesFromTopLeftCorner());
      for (let i = 0; i < width * height; i++) {
        let acc = 1;
        for (const it of iterators) {
          const val = it.next().value;
          if (val instanceof CellError) {
            return val;
          }
          const coercedVal = this.coerceScalarToNumberOrError(val);
          if (isExtendedNumber(coercedVal)) {
            acc *= getRawValue(coercedVal);
          } else {
            acc = 0;
          }
        }
        ret += acc;
      }
      return ret;
    });
  }
}
SumprodPlugin.implementedFunctions = {
  "SUMPRODUCT": {
    method: "sumproduct",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }],
    repeatLastArgs: 1
  }
};
class TextPlugin extends FunctionPlugin {
  /**
   * Corresponds to CONCATENATE(value1, [value2, ...])
   *
   * Concatenates provided arguments to one string.
   *
   * @param {ProcedureAst} ast - The procedure AST node
   * @param {InterpreterState} state - The interpreter state
   */
  concatenate(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CONCATENATE"), (...args) => {
      return "".concat(...args);
    });
  }
  /**
   * Corresponds to SPLIT(string, index)
   *
   * Splits provided string using space separator and returns chunk at zero-based position specified by second argument
   *
   * @param {ProcedureAst} ast - The procedure AST node
   * @param {InterpreterState} state - The interpreter state
   */
  split(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SPLIT"), (stringToSplit, indexToUse) => {
      const splittedString = stringToSplit.split(" ");
      if (indexToUse >= splittedString.length || indexToUse < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.IndexBounds);
      }
      return splittedString[indexToUse];
    });
  }
  len(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LEN"), (arg) => {
      return arg.length;
    });
  }
  lower(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LOWER"), (arg) => {
      return arg.toLowerCase();
    });
  }
  trim(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TRIM"), (arg) => {
      return arg.replace(/^ +/g, "").replace(/ +$/g, "").replace(/ +/g, " ");
    });
  }
  proper(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PROPER"), (arg) => {
      return arg.replace(new RegExp("\\p{L}+", "gu"), (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
    });
  }
  clean(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CLEAN"), (arg) => {
      return arg.replace(/[\u0000-\u001F]/g, "");
    });
  }
  exact(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EXACT"), (left2, right2) => {
      return left2 === right2;
    });
  }
  rept(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("REPT"), (text, count) => {
      if (count < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NegativeCount);
      }
      return text.repeat(count);
    });
  }
  right(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RIGHT"), (text, length) => {
      if (length < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NegativeLength);
      } else if (length === 0) {
        return "";
      }
      return text.slice(-length);
    });
  }
  left(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LEFT"), (text, length) => {
      if (length < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NegativeLength);
      }
      return text.slice(0, length);
    });
  }
  mid(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MID"), (text, startPosition, numberOfChars) => {
      if (startPosition < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      if (numberOfChars < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NegativeLength);
      }
      return text.substring(startPosition - 1, startPosition + numberOfChars - 1);
    });
  }
  replace(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("REPLACE"), (text, startPosition, numberOfChars, newText) => {
      if (startPosition < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      if (numberOfChars < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.NegativeLength);
      }
      return text.substring(0, startPosition - 1) + newText + text.substring(startPosition + numberOfChars - 1);
    });
  }
  search(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SEARCH"), (pattern, text, startIndex) => {
      if (startIndex < 1 || startIndex > text.length) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LengthBounds);
      }
      const normalizedPattern = pattern.toLowerCase();
      const normalizedText = text.substring(startIndex - 1).toLowerCase();
      const index2 = this.arithmeticHelper.requiresRegex(normalizedPattern) ? this.arithmeticHelper.searchString(normalizedPattern, normalizedText) : normalizedText.indexOf(normalizedPattern);
      return index2 > -1 ? index2 + startIndex : new CellError(ErrorType.VALUE, ErrorMessage.PatternNotFound);
    });
  }
  substitute(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SUBSTITUTE"), (text, searchString, replacementString, occurrenceNum) => {
      const escapedSearchString = this.escapeRegExpSpecialCharacters(searchString);
      const searchRegExp = new RegExp(escapedSearchString, "g");
      if (occurrenceNum === void 0) {
        return text.replace(searchRegExp, replacementString);
      }
      if (occurrenceNum < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      let match;
      let i = 0;
      while ((match = searchRegExp.exec(text)) !== null) {
        if (occurrenceNum === ++i) {
          return text.substring(0, match.index) + replacementString + text.substring(searchRegExp.lastIndex);
        }
      }
      return text;
    });
  }
  find(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FIND"), (pattern, text, startIndex) => {
      if (startIndex < 1 || startIndex > text.length) {
        return new CellError(ErrorType.VALUE, ErrorMessage.IndexBounds);
      }
      const shiftedText = text.substring(startIndex - 1);
      const index2 = shiftedText.indexOf(pattern) + startIndex;
      return index2 > 0 ? index2 : new CellError(ErrorType.VALUE, ErrorMessage.PatternNotFound);
    });
  }
  t(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T"), (arg) => {
      if (arg instanceof CellError) {
        return arg;
      }
      return typeof arg === "string" ? arg : "";
    });
  }
  /**
   * Corresponds to N(value)
   *
   * Converts a value to a number according to Excel specification:
   * - Numbers return themselves
   * - Dates return their serial number (stored as numbers internally)
   * - TRUE returns 1, FALSE returns 0
   * - Error values propagate
   * - Anything else (text, empty) returns 0
   * - For ranges, uses the first cell value
   */
  n(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("N"), (arg) => {
      var _a;
      const value = arg instanceof SimpleRangeValue ? (_a = arg.data[0]) === null || _a === void 0 ? void 0 : _a[0] : arg;
      if (value instanceof CellError) {
        return value;
      }
      if (typeof value === "number") {
        return value;
      }
      if (typeof value === "boolean") {
        return value ? 1 : 0;
      }
      return 0;
    });
  }
  upper(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("UPPER"), (arg) => {
      return arg.toUpperCase();
    });
  }
  /**
   * Corresponds to VALUE(text)
   *
   * Converts a text string that represents a number to a number.
   *
   * @param {ProcedureAst} ast - The procedure AST node
   * @param {InterpreterState} state - The interpreter state
   */
  value(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("VALUE"), (arg) => {
      if (arg instanceof CellError) {
        return arg;
      }
      if (isExtendedNumber(arg)) {
        return arg;
      }
      if (typeof arg !== "string") {
        return new CellError(ErrorType.VALUE, ErrorMessage.NumberCoercion);
      }
      const trimmedArg = arg.trim();
      const parenthesesMatch = /^\(([^()]+)\)$/.exec(trimmedArg);
      if (parenthesesMatch) {
        const innerValue = this.parseStringToNumber(parenthesesMatch[1]);
        if (innerValue !== void 0) {
          return -innerValue;
        }
      }
      const parsedValue = this.parseStringToNumber(trimmedArg);
      if (parsedValue !== void 0) {
        return parsedValue;
      }
      return new CellError(ErrorType.VALUE, ErrorMessage.NumberCoercion);
    });
  }
  /**
   * Corresponds to TEXTJOIN(delimiter, ignore_empty, text1, [text2], …)
   *
   * Joins text from multiple strings/ranges with a configurable delimiter.
   * Supports array/range delimiters that cycle through gaps between text values.
   * When ignore_empty is TRUE, empty strings are skipped.
   * Returns #VALUE! if the result exceeds 32,767 characters (Excel cell content limit).
   *
   * @param {ProcedureAst} ast - The procedure AST node
   * @param {InterpreterState} state - The interpreter state
   */
  textjoin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TEXTJOIN"), (delimiterArg, ignoreEmpty, ...textArgs) => {
      const delimiters = this.flattenArgToStrings(delimiterArg);
      if (delimiters instanceof CellError) {
        return delimiters;
      }
      const texts = [];
      for (const arg of textArgs) {
        const coerced = this.flattenArgToStrings(arg);
        if (coerced instanceof CellError) {
          return coerced;
        }
        texts.push(...coerced);
      }
      const parts = ignoreEmpty ? texts.filter((t) => t !== "") : texts;
      if (parts.length === 0) {
        return "";
      }
      const result = parts.reduce((acc, part, i) => i === 0 ? part : acc + delimiters[(i - 1) % delimiters.length] + part, "");
      if (result.length > 32767) {
        return new CellError(ErrorType.VALUE, ErrorMessage.ResultTooLong);
      }
      return result;
    });
  }
  /**
   * Flattens a scalar or range argument into an array of coerced strings.
   * Returns a CellError immediately if any value in the argument is an error or cannot be coerced.
   *
   * @param {InternalScalarValue | SimpleRangeValue} arg - Scalar or range to flatten
   * @returns {string[] | CellError} - Array of string values, or the first error encountered
   */
  flattenArgToStrings(arg) {
    const values2 = arg instanceof SimpleRangeValue ? arg.valuesFromTopLeftCorner() : [arg];
    const result = [];
    for (const val of values2) {
      if (val instanceof CellError) {
        return val;
      }
      const coerced = coerceScalarToString(val);
      if (coerced instanceof CellError) {
        return coerced;
      }
      result.push(coerced);
    }
    return result;
  }
  /**
   * Parses a string to a numeric value, handling whitespace trimming and empty string validation.
   *
   * @param {string} input - The string to parse
   * @returns {Maybe<ExtendedNumber>} The parsed number or undefined if parsing fails or input is empty
   */
  parseStringToNumber(input) {
    const trimmedInput = input.trim();
    if (trimmedInput === "") {
      return void 0;
    }
    return this.arithmeticHelper.coerceToMaybeNumber(trimmedInput);
  }
  escapeRegExpSpecialCharacters(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
}
TextPlugin.implementedFunctions = {
  "CONCATENATE": {
    method: "concatenate",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }],
    repeatLastArgs: 1,
    expandRanges: true
  },
  "EXACT": {
    method: "exact",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "SPLIT": {
    method: "split",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "LEN": {
    method: "len",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "LOWER": {
    method: "lower",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "MID": {
    method: "mid",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "TRIM": {
    method: "trim",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "T": {
    method: "t",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "N": {
    method: "n",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }]
  },
  "PROPER": {
    method: "proper",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "CLEAN": {
    method: "clean",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "REPT": {
    method: "rept",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "RIGHT": {
    method: "right",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "LEFT": {
    method: "left",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "REPLACE": {
    method: "replace",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "SEARCH": {
    method: "search",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "SUBSTITUTE": {
    method: "substitute",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true
    }]
  },
  "FIND": {
    method: "find",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.STRING
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "UPPER": {
    method: "upper",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  },
  "VALUE": {
    method: "value",
    parameters: [{
      argumentType: FunctionArgumentType.SCALAR
    }]
  },
  "TEXTJOIN": {
    method: "textjoin",
    repeatLastArgs: 1,
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }, {
      argumentType: FunctionArgumentType.ANY
    }]
  }
};
class TrigonometryPlugin extends FunctionPlugin {
  /**
   * Corresponds to ACOS(value)
   *
   * Returns the arc cosine (or inverse cosine) of a number.
   *
   * @param ast
   * @param state
   */
  acos(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ACOS"), Math.acos);
  }
  asin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ASIN"), Math.asin);
  }
  cos(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COS"), Math.cos);
  }
  sin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SIN"), Math.sin);
  }
  tan(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TAN"), Math.tan);
  }
  atan(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ATAN"), Math.atan);
  }
  atan2(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ATAN2"), (x, y) => {
      if (x === 0 && y === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return Math.atan2(y, x);
    });
  }
  cot(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COT"), (arg) => arg === 0 ? new CellError(ErrorType.DIV_BY_ZERO) : 1 / Math.tan(arg));
  }
  acot(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ACOT"), (arg) => arg === 0 ? PI / 2 : Math.atan(1 / arg));
  }
  sec(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SEC"), (arg) => 1 / Math.cos(arg));
  }
  csc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CSC"), (arg) => arg === 0 ? new CellError(ErrorType.DIV_BY_ZERO) : 1 / Math.sin(arg));
  }
  sinh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SINH"), Math.sinh);
  }
  asinh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ASINH"), Math.asinh);
  }
  cosh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COSH"), Math.cosh);
  }
  acosh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ACOSH"), Math.acosh);
  }
  tanh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TANH"), Math.tanh);
  }
  atanh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ATANH"), Math.atanh);
  }
  coth(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COTH"), (arg) => arg === 0 ? new CellError(ErrorType.DIV_BY_ZERO) : 1 / Math.tanh(arg));
  }
  acoth(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ACOTH"), (arg) => arg === 0 ? new CellError(ErrorType.NUM, ErrorMessage.NonZero) : Math.atanh(1 / arg));
  }
  sech(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SECH"), (arg) => 1 / Math.cosh(arg));
  }
  csch(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CSCH"), (arg) => arg === 0 ? new CellError(ErrorType.DIV_BY_ZERO) : 1 / Math.sinh(arg));
  }
}
TrigonometryPlugin.implementedFunctions = {
  "ACOS": {
    method: "acos",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ASIN": {
    method: "asin",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "COS": {
    method: "cos",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "SIN": {
    method: "sin",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "TAN": {
    method: "tan",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ATAN": {
    method: "atan",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ATAN2": {
    method: "atan2",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "COT": {
    method: "cot",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "SEC": {
    method: "sec",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "CSC": {
    method: "csc",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "SINH": {
    method: "sinh",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "COSH": {
    method: "cosh",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "TANH": {
    method: "tanh",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "COTH": {
    method: "coth",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "SECH": {
    method: "sech",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "CSCH": {
    method: "csch",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ACOT": {
    method: "acot",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ASINH": {
    method: "asinh",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ACOSH": {
    method: "acosh",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ATANH": {
    method: "atanh",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "ACOTH": {
    method: "acoth",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  }
};
class RowSearchStrategy extends AdvancedFind {
  constructor(dependencyGraph) {
    super(dependencyGraph);
    this.dependencyGraph = dependencyGraph;
  }
  /*
   * WARNING: Finding lower/upper bounds in unordered ranges is not supported. When ordering === 'none', assumes matchExactly === true
   */
  find(searchKey, rangeValue, searchOptions) {
    return this.basicFind(searchKey, rangeValue, "col", searchOptions);
  }
}
class LookupPlugin extends FunctionPlugin {
  constructor() {
    super(...arguments);
    this.rowSearch = new RowSearchStrategy(this.dependencyGraph);
  }
  /**
   * Corresponds to VLOOKUP(key, range, index, [sorted])
   *
   * @param ast
   * @param state
   */
  vlookup(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("VLOOKUP"), (key, rangeValue, index2, sorted) => {
      const range = rangeValue.range;
      if (range === void 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
      }
      if (index2 < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      if (index2 > range.width()) {
        return new CellError(ErrorType.REF, ErrorMessage.IndexLarge);
      }
      const searchOptions = {
        ordering: sorted ? "asc" : "none",
        ifNoMatch: sorted ? "returnLowerBound" : "returnNotFound"
      };
      return this.doVlookup(zeroIfEmpty(key), rangeValue, index2 - 1, searchOptions);
    });
  }
  /**
   * Corresponds to HLOOKUP(key, range, index, [sorted])
   *
   * @param ast
   * @param state
   */
  hlookup(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HLOOKUP"), (key, rangeValue, index2, sorted) => {
      const range = rangeValue.range;
      if (range === void 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
      }
      if (index2 < 1) {
        return new CellError(ErrorType.VALUE, ErrorMessage.LessThanOne);
      }
      if (index2 > range.height()) {
        return new CellError(ErrorType.REF, ErrorMessage.IndexLarge);
      }
      const searchOptions = {
        ordering: sorted ? "asc" : "none",
        ifNoMatch: sorted ? "returnLowerBound" : "returnNotFound"
      };
      return this.doHlookup(zeroIfEmpty(key), rangeValue, index2 - 1, searchOptions);
    });
  }
  /**
   * Corresponds to XLOOKUP(lookup_value, lookup_array, return_array, [if_not_found], [match_mode], [search_mode])
   *
   * @param ast
   * @param state
   */
  xlookup(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("XLOOKUP"), (key, lookupRangeValue, returnRangeValue, notFoundFlag, matchMode, searchMode) => {
      if (![0, -1, 1, 2].includes(matchMode)) {
        return new CellError(ErrorType.VALUE, ErrorMessage.BadMode);
      }
      if (![1, -1, 2, -2].includes(searchMode)) {
        return new CellError(ErrorType.VALUE, ErrorMessage.BadMode);
      }
      const lookupRange = lookupRangeValue instanceof SimpleRangeValue ? lookupRangeValue : SimpleRangeValue.fromScalar(lookupRangeValue);
      const returnRange = returnRangeValue instanceof SimpleRangeValue ? returnRangeValue : SimpleRangeValue.fromScalar(returnRangeValue);
      const isWildcardMatchMode = matchMode === 2;
      const searchOptions = {
        ordering: searchMode === 2 ? "asc" : searchMode === -2 ? "desc" : "none",
        returnOccurrence: searchMode === -1 ? "last" : "first",
        ifNoMatch: matchMode === -1 ? "returnLowerBound" : matchMode === 1 ? "returnUpperBound" : "returnNotFound"
      };
      return this.doXlookup(zeroIfEmpty(key), lookupRange, returnRange, notFoundFlag, isWildcardMatchMode, searchOptions);
    });
  }
  xlookupArraySize(ast) {
    var _a, _b;
    const lookupRange = (_a = ast === null || ast === void 0 ? void 0 : ast.args) === null || _a === void 0 ? void 0 : _a[1];
    const returnRange = (_b = ast === null || ast === void 0 ? void 0 : ast.args) === null || _b === void 0 ? void 0 : _b[2];
    if ((lookupRange === null || lookupRange === void 0 ? void 0 : lookupRange.start) == null || (lookupRange === null || lookupRange === void 0 ? void 0 : lookupRange.end) == null || (returnRange === null || returnRange === void 0 ? void 0 : returnRange.start) == null || (returnRange === null || returnRange === void 0 ? void 0 : returnRange.end) == null) {
      return ArraySize.error();
    }
    const lookupRangeHeight = lookupRange.end.row - lookupRange.start.row + 1;
    const lookupRangeWidth = lookupRange.end.col - lookupRange.start.col + 1;
    const returnRangeHeight = returnRange.end.row - returnRange.start.row + 1;
    const returnRangeWidth = returnRange.end.col - returnRange.start.col + 1;
    const isVerticalSearch = lookupRangeWidth === 1 && returnRangeHeight === lookupRangeHeight;
    const isHorizontalSearch = lookupRangeHeight === 1 && returnRangeWidth === lookupRangeWidth;
    if (!isVerticalSearch && !isHorizontalSearch) {
      return ArraySize.error();
    }
    if (isVerticalSearch) {
      return new ArraySize(returnRangeWidth, 1);
    }
    return new ArraySize(1, returnRangeHeight);
  }
  match(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MATCH"), (key, rangeValue, type) => {
      return this.doMatch(zeroIfEmpty(key), rangeValue, type);
    });
  }
  searchInRange(key, range, isWildcardMatchMode, searchOptions, searchStrategy) {
    if (isWildcardMatchMode && typeof key === "string" && this.arithmeticHelper.requiresRegex(key)) {
      return searchStrategy.advancedFind(this.arithmeticHelper.eqMatcherFunction(key), range, {
        returnOccurrence: searchOptions.returnOccurrence
      });
    }
    return searchStrategy.find(key, range, searchOptions);
  }
  doVlookup(key, rangeValue, index2, searchOptions) {
    this.dependencyGraph.stats.start(StatType.VLOOKUP);
    const range = rangeValue.range;
    let searchedRange;
    if (range === void 0) {
      searchedRange = SimpleRangeValue.onlyValues(rangeValue.data.map((arg) => [arg[0]]));
    } else {
      searchedRange = SimpleRangeValue.onlyRange(AbsoluteCellRange.spanFrom(range.start, 1, range.height()), this.dependencyGraph);
    }
    const rowIndex = this.searchInRange(key, searchedRange, searchOptions.ordering === "none", searchOptions, this.columnSearch);
    this.dependencyGraph.stats.end(StatType.VLOOKUP);
    if (rowIndex === -1) {
      return new CellError(ErrorType.NA, ErrorMessage.ValueNotFound);
    }
    let value;
    if (range === void 0) {
      value = rangeValue.data[rowIndex][index2];
    } else {
      const address = simpleCellAddress(range.sheet, range.start.col + index2, range.start.row + rowIndex);
      value = this.dependencyGraph.getCellValue(address);
    }
    if (value instanceof SimpleRangeValue) {
      return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
    }
    return value;
  }
  doHlookup(key, rangeValue, index2, searchOptions) {
    const range = rangeValue.range;
    let searchedRange;
    if (range === void 0) {
      searchedRange = SimpleRangeValue.onlyValues([rangeValue.data[0]]);
    } else {
      searchedRange = SimpleRangeValue.onlyRange(AbsoluteCellRange.spanFrom(range.start, range.width(), 1), this.dependencyGraph);
    }
    const colIndex = this.searchInRange(key, searchedRange, searchOptions.ordering === "none", searchOptions, this.rowSearch);
    if (colIndex === -1) {
      return new CellError(ErrorType.NA, ErrorMessage.ValueNotFound);
    }
    let value;
    if (range === void 0) {
      value = rangeValue.data[index2][colIndex];
    } else {
      const address = simpleCellAddress(range.sheet, range.start.col + colIndex, range.start.row + index2);
      value = this.dependencyGraph.getCellValue(address);
    }
    if (value instanceof SimpleRangeValue) {
      return new CellError(ErrorType.VALUE, ErrorMessage.WrongType);
    }
    return value;
  }
  doXlookup(key, lookupRange, returnRange, notFoundFlag, isWildcardMatchMode, searchOptions) {
    const isVerticalSearch = lookupRange.width() === 1 && returnRange.height() === lookupRange.height();
    const isHorizontalSearch = lookupRange.height() === 1 && returnRange.width() === lookupRange.width();
    if (!isVerticalSearch && !isHorizontalSearch) {
      return new CellError(ErrorType.VALUE, ErrorMessage.WrongDimension);
    }
    const searchStrategy = isVerticalSearch ? this.columnSearch : this.rowSearch;
    const indexFound = this.searchInRange(key, lookupRange, isWildcardMatchMode, searchOptions, searchStrategy);
    if (indexFound === -1) {
      return notFoundFlag == ErrorType.NA ? new CellError(ErrorType.NA, ErrorMessage.ValueNotFound) : notFoundFlag;
    }
    const returnValues = isVerticalSearch ? [returnRange.data[indexFound]] : returnRange.data.map((row) => [row[indexFound]]);
    return SimpleRangeValue.onlyValues(returnValues);
  }
  doMatch(key, rangeValue, type) {
    if (![-1, 0, 1].includes(type)) {
      return new CellError(ErrorType.VALUE, ErrorMessage.BadMode);
    }
    if (rangeValue.width() > 1 && rangeValue.height() > 1) {
      return new CellError(ErrorType.NA);
    }
    const searchStrategy = rangeValue.width() === 1 ? this.columnSearch : this.rowSearch;
    const searchOptions = type === 0 ? {
      ordering: "none",
      ifNoMatch: "returnNotFound"
    } : {
      ordering: type === -1 ? "desc" : "asc",
      ifNoMatch: type === -1 ? "returnUpperBound" : "returnLowerBound"
    };
    const index2 = searchStrategy.find(key, rangeValue, searchOptions);
    if (index2 === -1) {
      return new CellError(ErrorType.NA, ErrorMessage.ValueNotFound);
    }
    return index2 + 1;
  }
}
LookupPlugin.implementedFunctions = {
  "VLOOKUP": {
    method: "vlookup",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.BOOLEAN,
      defaultValue: true
    }]
  },
  "HLOOKUP": {
    method: "hlookup",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.BOOLEAN,
      defaultValue: true
    }]
  },
  "XLOOKUP": {
    method: "xlookup",
    sizeOfResultArrayMethod: "xlookupArraySize",
    parameters: [
      // lookup_value
      {
        argumentType: FunctionArgumentType.NOERROR
      },
      // lookup_array
      {
        argumentType: FunctionArgumentType.RANGE
      },
      // return_array
      {
        argumentType: FunctionArgumentType.RANGE
      },
      // [if_not_found]
      {
        argumentType: FunctionArgumentType.SCALAR,
        optionalArg: true,
        defaultValue: ErrorType.NA
      },
      // [match_mode]
      {
        argumentType: FunctionArgumentType.NUMBER,
        optionalArg: true,
        defaultValue: 0
      },
      // [search_mode]
      {
        argumentType: FunctionArgumentType.NUMBER,
        optionalArg: true,
        defaultValue: 1
      }
    ]
  },
  "MATCH": {
    method: "match",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  }
};
class RomanPlugin extends FunctionPlugin {
  roman(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ROMAN"), (val, mode) => {
      val = Math.trunc(val);
      if (mode === false) {
        mode = 4;
      } else if (mode === true) {
        mode = 0;
      }
      mode = getRawValue(this.coerceScalarToNumberOrError(mode));
      if (mode instanceof CellError) {
        return mode;
      }
      mode = Math.trunc(mode);
      if (mode < 0) {
        return new CellError(ErrorType.VALUE, ErrorMessage.ValueSmall);
      }
      if (mode > 4) {
        return new CellError(ErrorType.VALUE, ErrorMessage.ValueLarge);
      }
      return romanMode(val, mode);
    });
  }
  arabic(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ARABIC"), (inputString) => {
      inputString = inputString.trim().toUpperCase();
      let minusSign = false;
      if (inputString.startsWith("-")) {
        inputString = inputString.slice(1);
        minusSign = true;
        if (inputString === "") {
          return new CellError(ErrorType.VALUE, ErrorMessage.InvalidRoman);
        }
      }
      const work = {
        input: inputString,
        acc: 0
      };
      eatToken(work, {
        token: "MMM",
        val: 3e3
      }, {
        token: "MM",
        val: 2e3
      }, {
        token: "M",
        val: 1e3
      });
      eatToken(work, {
        token: "IM",
        val: 999
      }, {
        token: "VM",
        val: 995
      }, {
        token: "XM",
        val: 990
      }, {
        token: "LM",
        val: 950
      }, {
        token: "CM",
        val: 900
      });
      eatToken(work, {
        token: "D",
        val: 500
      }, {
        token: "ID",
        val: 499
      }, {
        token: "VD",
        val: 495
      }, {
        token: "XD",
        val: 490
      }, {
        token: "LD",
        val: 450
      }, {
        token: "CD",
        val: 400
      });
      eatToken(work, {
        token: "CCC",
        val: 300
      }, {
        token: "CC",
        val: 200
      }, {
        token: "C",
        val: 100
      });
      eatToken(work, {
        token: "IC",
        val: 99
      }, {
        token: "VC",
        val: 95
      }, {
        token: "XC",
        val: 90
      });
      eatToken(work, {
        token: "L",
        val: 50
      }, {
        token: "IL",
        val: 49
      }, {
        token: "VL",
        val: 45
      }, {
        token: "XL",
        val: 40
      });
      eatToken(work, {
        token: "XXX",
        val: 30
      }, {
        token: "XX",
        val: 20
      }, {
        token: "X",
        val: 10
      });
      eatToken(work, {
        token: "IX",
        val: 9
      });
      eatToken(work, {
        token: "V",
        val: 5
      }, {
        token: "IV",
        val: 4
      });
      eatToken(work, {
        token: "III",
        val: 3
      }, {
        token: "II",
        val: 2
      }, {
        token: "I",
        val: 1
      });
      if (work.input !== "") {
        return new CellError(ErrorType.VALUE, ErrorMessage.InvalidRoman);
      } else {
        return minusSign ? -work.acc : work.acc;
      }
    });
  }
}
RomanPlugin.implementedFunctions = {
  "ROMAN": {
    method: "roman",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1,
      lessThan: 4e3
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      optionalArg: true,
      defaultValue: 0
    }]
  },
  "ARABIC": {
    method: "arabic",
    parameters: [{
      argumentType: FunctionArgumentType.STRING
    }]
  }
};
function eatToken(inputAcc, ...tokens) {
  for (const token of tokens) {
    if (inputAcc.input.startsWith(token.token)) {
      inputAcc.input = inputAcc.input.slice(token.token.length);
      inputAcc.acc += token.val;
      break;
    }
  }
}
function romanMode(input, mode) {
  const work = {
    val: input % 1e3,
    acc: "M".repeat(Math.floor(input / 1e3))
  };
  if (mode === 4) {
    absorb(work, "IM", 999, 1e3);
    absorb(work, "ID", 499, 500);
  }
  if (mode >= 3) {
    absorb(work, "VM", 995, 1e3);
    absorb(work, "VD", 495, 500);
  }
  if (mode >= 2) {
    absorb(work, "XM", 990, 1e3);
    absorb(work, "XD", 490, 500);
  }
  if (mode >= 1) {
    absorb(work, "LM", 950, 1e3);
    absorb(work, "LD", 450, 500);
  }
  absorb(work, "CM", 900, 1e3);
  absorb(work, "CD", 400, 500);
  absorb(work, "D", 500, 900);
  work.acc += "C".repeat(Math.floor(work.val / 100));
  work.val %= 100;
  if (mode >= 2) {
    absorb(work, "IC", 99, 100);
    absorb(work, "IL", 49, 50);
  }
  if (mode >= 1) {
    absorb(work, "VC", 95, 100);
    absorb(work, "VL", 45, 50);
  }
  absorb(work, "XC", 90, 100);
  absorb(work, "XL", 40, 50);
  absorb(work, "L", 50, 90);
  work.acc += "X".repeat(Math.floor(work.val / 10));
  work.val %= 10;
  absorb(work, "IX", 9, 10);
  absorb(work, "IV", 4, 5);
  absorb(work, "V", 5, 9);
  work.acc += "I".repeat(work.val);
  return work.acc;
}
function absorb(valAcc, token, lower, upper) {
  if (valAcc.val >= lower && valAcc.val < upper) {
    valAcc.val -= lower;
    valAcc.acc += token;
  }
}
class SimpleArithmerticPlugin extends FunctionPlugin {
  add(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.ADD"), this.arithmeticHelper.addWithEpsilon);
  }
  concat(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.CONCAT"), this.arithmeticHelper.concat);
  }
  divide(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.DIVIDE"), this.arithmeticHelper.divide);
  }
  eq(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.EQ"), this.arithmeticHelper.eq);
  }
  gt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.GT"), this.arithmeticHelper.gt);
  }
  gte(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.GTE"), this.arithmeticHelper.geq);
  }
  lt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.LT"), this.arithmeticHelper.lt);
  }
  lte(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.LTE"), this.arithmeticHelper.leq);
  }
  minus(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.MINUS"), this.arithmeticHelper.subtract);
  }
  multiply(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.MULTIPLY"), this.arithmeticHelper.multiply);
  }
  ne(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.NE"), this.arithmeticHelper.neq);
  }
  pow(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.POW"), this.arithmeticHelper.pow);
  }
  uminus(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.UMINUS"), this.arithmeticHelper.unaryMinus);
  }
  upercent(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.UNARY_PERCENT"), this.arithmeticHelper.unaryPercent);
  }
  uplus(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HF.UPLUS"), this.arithmeticHelper.unaryPlus);
  }
}
SimpleArithmerticPlugin.implementedFunctions = {
  "HF.ADD": {
    method: "add",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.CONCAT": {
    method: "concat",
    parameters: [{
      argumentType: FunctionArgumentType.STRING,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.STRING,
      passSubtype: true
    }]
  },
  "HF.DIVIDE": {
    method: "divide",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.EQ": {
    method: "eq",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }]
  },
  "HF.GT": {
    method: "gt",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }]
  },
  "HF.GTE": {
    method: "gte",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }]
  },
  "HF.LT": {
    method: "lt",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }]
  },
  "HF.LTE": {
    method: "lte",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }]
  },
  "HF.MINUS": {
    method: "minus",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.MULTIPLY": {
    method: "multiply",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.NE": {
    method: "ne",
    parameters: [{
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NOERROR,
      passSubtype: true
    }]
  },
  "HF.POW": {
    method: "pow",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.UMINUS": {
    method: "uminus",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.UNARY_PERCENT": {
    method: "upercent",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  },
  "HF.UPLUS": {
    method: "uplus",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      passSubtype: true
    }]
  }
};
var M = Math;
function _horner(arr, v) {
  for (var i = 0, z = 0; i < arr.length; ++i) {
    z = v * z + arr[i];
  }
  return z;
}
function _bessel_iter(x, n2, f0, f1, sign) {
  if (n2 === 0) {
    return f0;
  }
  if (n2 === 1) {
    return f1;
  }
  var tdx = 2 / x, f2 = f1;
  for (var o = 1; o < n2; ++o) {
    f2 = f1 * o * tdx + sign * f0;
    f0 = f1;
    f1 = f2;
  }
  return f2;
}
function _bessel_wrap(bessel0, bessel1, name, nonzero, sign) {
  return function bessel(x, n2) {
    if (nonzero) {
      if (x === 0) {
        return nonzero == 1 ? -Infinity : Infinity;
      } else if (x < 0) {
        return NaN;
      }
    }
    if (n2 === 0) {
      return bessel0(x);
    }
    if (n2 === 1) {
      return bessel1(x);
    }
    if (n2 < 0) {
      return NaN;
    }
    n2 |= 0;
    var b0 = bessel0(x), b1 = bessel1(x);
    return _bessel_iter(x, n2, b0, b1, sign);
  };
}
var besselj = (function() {
  var W = 0.636619772;
  var b0_a1a = [57568490574, -13362590354, 6516196407e-1, -1121442418e-2, 77392.33017, -184.9052456].reverse();
  var b0_a2a = [57568490411, 1029532985, 9494680718e-3, 59272.64853, 267.8532712, 1].reverse();
  var b0_a1b = [1, -0.001098628627, 2734510407e-14, -2073370639e-15, 2093887211e-16].reverse();
  var b0_a2b = [-0.01562499995, 1430488765e-13, -6911147651e-15, 7621095161e-16, -934935152e-16].reverse();
  function bessel0(x) {
    var a = 0, a1 = 0, a2 = 0, y = x * x;
    if (x < 8) {
      a1 = _horner(b0_a1a, y);
      a2 = _horner(b0_a2a, y);
      a = a1 / a2;
    } else {
      var xx = x - 0.785398164;
      y = 64 / y;
      a1 = _horner(b0_a1b, y);
      a2 = _horner(b0_a2b, y);
      a = M.sqrt(W / x) * (M.cos(xx) * a1 - M.sin(xx) * a2 * 8 / x);
    }
    return a;
  }
  var b1_a1a = [72362614232, -7895059235, 2423968531e-1, -2972611439e-3, 15704.4826, -30.16036606].reverse();
  var b1_a2a = [144725228442, 2300535178, 1858330474e-2, 99447.43394, 376.9991397, 1].reverse();
  var b1_a1b = [1, 183105e-8, -3516396496e-14, 2457520174e-15, -240337019e-15].reverse();
  var b1_a2b = [0.04687499995, -2002690873e-13, 8449199096e-15, -88228987e-14, 105787412e-15].reverse();
  function bessel1(x) {
    var a = 0, a1 = 0, a2 = 0, y = x * x, xx = M.abs(x) - 2.356194491;
    if (Math.abs(x) < 8) {
      a1 = x * _horner(b1_a1a, y);
      a2 = _horner(b1_a2a, y);
      a = a1 / a2;
    } else {
      y = 64 / y;
      a1 = _horner(b1_a1b, y);
      a2 = _horner(b1_a2b, y);
      a = M.sqrt(W / M.abs(x)) * (M.cos(xx) * a1 - M.sin(xx) * a2 * 8 / M.abs(x));
      if (x < 0) {
        a = -a;
      }
    }
    return a;
  }
  return function besselj2(x, n2) {
    n2 = Math.round(n2);
    if (!isFinite(x)) {
      return isNaN(x) ? x : 0;
    }
    if (n2 < 0) {
      return (n2 % 2 ? -1 : 1) * besselj2(x, -n2);
    }
    if (x < 0) {
      return (n2 % 2 ? -1 : 1) * besselj2(-x, n2);
    }
    if (n2 === 0) {
      return bessel0(x);
    }
    if (n2 === 1) {
      return bessel1(x);
    }
    if (x === 0) {
      return 0;
    }
    var ret = 0;
    if (x > n2) {
      ret = _bessel_iter(x, n2, bessel0(x), bessel1(x), -1);
    } else {
      var m = 2 * M.floor((n2 + M.floor(M.sqrt(40 * n2))) / 2);
      var jsum = false;
      var bjp = 0, sum2 = 0;
      var bj = 1, bjm = 0;
      var tox = 2 / x;
      for (var j = m; j > 0; j--) {
        bjm = j * tox * bj - bjp;
        bjp = bj;
        bj = bjm;
        if (M.abs(bj) > 1e10) {
          bj *= 1e-10;
          bjp *= 1e-10;
          ret *= 1e-10;
          sum2 *= 1e-10;
        }
        if (jsum) {
          sum2 += bj;
        }
        jsum = !jsum;
        if (j == n2) {
          ret = bjp;
        }
      }
      sum2 = 2 * sum2 - bj;
      ret /= sum2;
    }
    return ret;
  };
})();
var bessely = (function() {
  var W = 0.636619772;
  var b0_a1a = [-2957821389, 7062834065, -5123598036e-1, 1087988129e-2, -86327.92757, 228.4622733].reverse();
  var b0_a2a = [40076544269, 7452499648e-1, 7189466438e-3, 47447.2647, 226.1030244, 1].reverse();
  var b0_a1b = [1, -0.001098628627, 2734510407e-14, -2073370639e-15, 2093887211e-16].reverse();
  var b0_a2b = [-0.01562499995, 1430488765e-13, -6911147651e-15, 7621095161e-16, -934945152e-16].reverse();
  function bessel0(x) {
    var a = 0, a1 = 0, a2 = 0, y = x * x, xx = x - 0.785398164;
    if (x < 8) {
      a1 = _horner(b0_a1a, y);
      a2 = _horner(b0_a2a, y);
      a = a1 / a2 + W * besselj(x, 0) * M.log(x);
    } else {
      y = 64 / y;
      a1 = _horner(b0_a1b, y);
      a2 = _horner(b0_a2b, y);
      a = M.sqrt(W / x) * (M.sin(xx) * a1 + M.cos(xx) * a2 * 8 / x);
    }
    return a;
  }
  var b1_a1a = [-4900604943e3, 127527439e4, -51534381390, 7349264551e-1, -4237922726e-3, 8511.937935].reverse();
  var b1_a2a = [249958057e5, 424441966400, 3733650367, 2245904002e-2, 102042.605, 354.9632885, 1].reverse();
  var b1_a1b = [1, 183105e-8, -3516396496e-14, 2457520174e-15, -240337019e-15].reverse();
  var b1_a2b = [0.04687499995, -2002690873e-13, 8449199096e-15, -88228987e-14, 105787412e-15].reverse();
  function bessel1(x) {
    var a = 0, a1 = 0, a2 = 0, y = x * x, xx = x - 2.356194491;
    if (x < 8) {
      a1 = x * _horner(b1_a1a, y);
      a2 = _horner(b1_a2a, y);
      a = a1 / a2 + W * (besselj(x, 1) * M.log(x) - 1 / x);
    } else {
      y = 64 / y;
      a1 = _horner(b1_a1b, y);
      a2 = _horner(b1_a2b, y);
      a = M.sqrt(W / x) * (M.sin(xx) * a1 + M.cos(xx) * a2 * 8 / x);
    }
    return a;
  }
  return _bessel_wrap(bessel0, bessel1, "BESSELY", 1, -1);
})();
var besseli = (function() {
  var b0_a = [1, 3.5156229, 3.0899424, 1.2067492, 0.2659732, 0.0360768, 45813e-7].reverse();
  var b0_b = [0.39894228, 0.01328592, 225319e-8, -157565e-8, 916281e-8, -0.02057706, 0.02635537, -0.01647633, 392377e-8].reverse();
  function bessel0(x) {
    if (x <= 3.75) {
      return _horner(b0_a, x * x / (3.75 * 3.75));
    }
    return M.exp(M.abs(x)) / M.sqrt(M.abs(x)) * _horner(b0_b, 3.75 / M.abs(x));
  }
  var b1_a = [0.5, 0.87890594, 0.51498869, 0.15084934, 0.02658733, 301532e-8, 32411e-8].reverse();
  var b1_b = [0.39894228, -0.03988024, -362018e-8, 163801e-8, -0.01031555, 0.02282967, -0.02895312, 0.01787654, -420059e-8].reverse();
  function bessel1(x) {
    if (x < 3.75) {
      return x * _horner(b1_a, x * x / (3.75 * 3.75));
    }
    return (x < 0 ? -1 : 1) * M.exp(M.abs(x)) / M.sqrt(M.abs(x)) * _horner(b1_b, 3.75 / M.abs(x));
  }
  return function besseli2(x, n2) {
    n2 = Math.round(n2);
    if (n2 === 0) {
      return bessel0(x);
    }
    if (n2 === 1) {
      return bessel1(x);
    }
    if (n2 < 0) {
      return NaN;
    }
    if (M.abs(x) === 0) {
      return 0;
    }
    if (x == Infinity) {
      return Infinity;
    }
    var ret = 0, j, tox = 2 / M.abs(x), bip = 0, bi = 1, bim = 0;
    var m = 2 * M.round((n2 + M.round(M.sqrt(40 * n2))) / 2);
    for (j = m; j > 0; j--) {
      bim = j * tox * bi + bip;
      bip = bi;
      bi = bim;
      if (M.abs(bi) > 1e10) {
        bi *= 1e-10;
        bip *= 1e-10;
        ret *= 1e-10;
      }
      if (j == n2) {
        ret = bip;
      }
    }
    ret *= besseli2(x, 0) / bi;
    return x < 0 && n2 % 2 ? -ret : ret;
  };
})();
var besselk = (function() {
  var b0_a = [-0.57721566, 0.4227842, 0.23069756, 0.0348859, 262698e-8, 1075e-7, 74e-7].reverse();
  var b0_b = [1.25331414, -0.07832358, 0.02189568, -0.01062446, 587872e-8, -25154e-7, 53208e-8].reverse();
  function bessel0(x) {
    if (x <= 2) {
      return -M.log(x / 2) * besseli(x, 0) + _horner(b0_a, x * x / 4);
    }
    return M.exp(-x) / M.sqrt(x) * _horner(b0_b, 2 / x);
  }
  var b1_a = [1, 0.15443144, -0.67278579, -0.18156897, -0.01919402, -110404e-8, -4686e-8].reverse();
  var b1_b = [1.25331414, 0.23498619, -0.0365562, 0.01504268, -780353e-8, 325614e-8, -68245e-8].reverse();
  function bessel1(x) {
    if (x <= 2) {
      return M.log(x / 2) * besseli(x, 1) + 1 / x * _horner(b1_a, x * x / 4);
    }
    return M.exp(-x) / M.sqrt(x) * _horner(b1_b, 2 / x);
  }
  return _bessel_wrap(bessel0, bessel1, "BESSELK", 2, 1);
})();
function erf(x) {
  const cof = [-1.3026537197817094, 0.6419697923564902, 0.019476473204185836, -0.00956151478680863, -946595344482036e-18, 366839497852761e-18, 42523324806907e-18, -20278578112534e-18, -1624290004647e-18, 130365583558e-17, 15626441722e-18, -85238095915e-18, 6529054439e-18, 5059343495e-18, -991364156e-18, -227365122e-18, 96467911e-18, 2394038e-18, -6886027e-18, 894487e-18, 313092e-18, -112708e-18, 381e-18, 7106e-18, -1523e-18, -94e-18, 121e-18, -28e-18];
  let j = cof.length - 1;
  let isneg = false;
  let d = 0;
  let dd = 0;
  let t, ty, tmp, res;
  if (x === 0) {
    return 0;
  }
  if (x < 0) {
    x = -x;
    isneg = true;
  }
  t = 2 / (2 + x);
  ty = 4 * t - 2;
  for (; j > 0; j--) {
    tmp = d;
    d = ty * d - dd + cof[j];
    dd = tmp;
  }
  res = t * Math.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
  return isneg ? res - 1 : 1 - res;
}
function erfc(x) {
  return 1 - erf(x);
}
function erfcinv(p) {
  let j = 0;
  let x, err, t, pp;
  if (p >= 2) {
    return -100;
  }
  if (p <= 0) {
    return 100;
  }
  pp = p < 1 ? p : 2 - p;
  t = Math.sqrt(-2 * Math.log(pp / 2));
  x = -0.70711 * ((2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t);
  for (; j < 2; j++) {
    err = erfc(x) - pp;
    x += err / (1.1283791670955126 * Math.exp(-x * x) - x * err);
  }
  return p < 1 ? x : -x;
}
const exponential = {
  pdf: (x, rate) => {
    return x < 0 ? 0 : rate * Math.exp(-rate * x);
  },
  cdf: (x, rate) => {
    return x < 0 ? 0 : 1 - Math.exp(-rate * x);
  }
};
function gammafn(x) {
  const p = [-1.716185138865495, 24.76565080557592, -379.80425647094563, 629.3311553128184, 866.9662027904133, -31451.272968848367, -36144.413418691176, 66456.14382024054];
  const q = [-30.8402300119739, 315.35062697960416, -1015.1563674902192, -3107.771671572311, 22538.11842098015, 4755.846277527881, -134659.9598649693, -115132.2596755535];
  let fact = false;
  let n2 = 0;
  let xden = 0;
  let xnum = 0;
  let y = x;
  let i, z, yi, res;
  if (x > 171.6243769536076) {
    return Infinity;
  }
  if (y <= 0) {
    res = y % 1;
    if (res) {
      fact = (!(y & 1) ? 1 : -1) * Math.PI / Math.sin(Math.PI * res);
      y = 1 - y;
    } else {
      return Infinity;
    }
  }
  yi = y;
  if (y < 1) {
    z = y++;
  } else {
    z = (y -= n2 = (y | 0) - 1) - 1;
  }
  for (i = 0; i < 8; ++i) {
    xnum = (xnum + p[i]) * z;
    xden = xden * z + q[i];
  }
  res = xnum / xden + 1;
  if (yi < y) {
    res /= yi;
  } else if (yi > y) {
    for (i = 0; i < n2; ++i) {
      res *= y;
      y++;
    }
  }
  if (fact) {
    res = fact / res;
  }
  return res;
}
const gamma = {
  pdf: function pdf(x, shape, scale) {
    if (x < 0) {
      return 0;
    }
    return x === 0 && shape === 1 ? 1 / scale : Math.exp((shape - 1) * Math.log(x) - x / scale - gammaln(shape) - shape * Math.log(scale));
  },
  cdf: function cdf(x, shape, scale) {
    if (x < 0) {
      return 0;
    }
    return lowRegGamma(shape, x / scale);
  },
  inv: function(p, shape, scale) {
    return gammapinv(p, shape) * scale;
  }
};
function gammaln(x) {
  let j = 0;
  const cof = [76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
  let ser = 1.000000000190015;
  let xx, y, tmp;
  tmp = (y = xx = x) + 5.5;
  tmp -= (xx + 0.5) * Math.log(tmp);
  for (; j < 6; j++) {
    ser += cof[j] / ++y;
  }
  return Math.log(2.5066282746310007 * ser / xx) - tmp;
}
function lowRegGamma(a, x) {
  const aln = gammaln(a);
  let ap = a;
  let sum2 = 1 / a;
  let del = sum2;
  let b = x + 1 - a;
  let c = 1 / 1e-30;
  let d = 1 / b;
  let h = d;
  let i = 1;
  const ITMAX = -~(Math.log(a >= 1 ? a : 1 / a) * 8.5 + a * 0.4 + 17);
  let an;
  if (x < 0 || a <= 0) {
    return NaN;
  } else if (x < a + 1) {
    for (; i <= ITMAX; i++) {
      sum2 += del *= x / ++ap;
    }
    return sum2 * Math.exp(-x + a * Math.log(x) - aln);
  }
  for (; i <= ITMAX; i++) {
    an = -i * (i - a);
    b += 2;
    d = an * d + b;
    c = b + an / c;
    d = 1 / d;
    h *= d * c;
  }
  return 1 - h * Math.exp(-x + a * Math.log(x) - aln);
}
function gammapinv(p, a) {
  let j = 0;
  const a1 = a - 1;
  const EPS = 1e-8;
  const gln = gammaln(a);
  let x, err, t, u, pp;
  let lna1;
  let afac;
  if (p >= 1) {
    return Math.max(100, a + 100 * Math.sqrt(a));
  }
  if (p <= 0) {
    return 0;
  }
  if (a > 1) {
    lna1 = Math.log(a1);
    afac = Math.exp(a1 * (lna1 - 1) - gln);
    pp = p < 0.5 ? p : 1 - p;
    t = Math.sqrt(-2 * Math.log(pp));
    x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
    if (p < 0.5) {
      x = -x;
    }
    x = Math.max(1e-3, a * Math.pow(1 - 1 / (9 * a) - x / (3 * Math.sqrt(a)), 3));
  } else {
    t = 1 - a * (0.253 + a * 0.12);
    if (p < t) {
      x = Math.pow(p / t, 1 / a);
    } else {
      x = 1 - Math.log(1 - (p - t) / (1 - t));
    }
  }
  for (; j < 12; j++) {
    if (x <= 0) {
      return 0;
    }
    err = lowRegGamma(a, x) - p;
    if (a > 1) {
      t = afac * Math.exp(-(x - a1) + a1 * (Math.log(x) - lna1));
    } else {
      t = Math.exp(-x + a1 * Math.log(x) - gln);
    }
    u = err / t;
    x -= t = u / (1 - 0.5 * Math.min(1, u * ((a - 1) / x - 1)));
    if (x <= 0) {
      x = 0.5 * (x + t);
    }
    if (Math.abs(t) < EPS * x) {
      break;
    }
  }
  return x;
}
const normal = {
  pdf: function pdf2(x, mean2, std) {
    return Math.exp(-0.5 * Math.log(2 * Math.PI) - Math.log(std) - Math.pow(x - mean2, 2) / (2 * std * std));
  },
  cdf: function cdf2(x, mean2, std) {
    return 0.5 * (1 + erf((x - mean2) / Math.sqrt(2 * std * std)));
  },
  inv: function(p, mean2, std) {
    return -1.4142135623730951 * std * erfcinv(2 * p) + mean2;
  }
};
const beta = {
  pdf: function pdf3(x, alpha, beta2) {
    if (x > 1 || x < 0) {
      return 0;
    }
    if (alpha == 1 && beta2 == 1) {
      return 1;
    }
    if (alpha < 512 && beta2 < 512) {
      return Math.pow(x, alpha - 1) * Math.pow(1 - x, beta2 - 1) / betafn(alpha, beta2);
    } else {
      return Math.exp((alpha - 1) * Math.log(x) + (beta2 - 1) * Math.log(1 - x) - betaln(alpha, beta2));
    }
  },
  cdf: function cdf3(x, alpha, beta2) {
    return x > 1 || x < 0 ? +(x > 1) : ibeta(x, alpha, beta2);
  },
  inv: function inv(x, alpha, beta2) {
    return ibetainv(x, alpha, beta2);
  }
};
function betafn(x, y) {
  if (x <= 0 || y <= 0) {
    return void 0;
  }
  return x + y > 170 ? Math.exp(betaln(x, y)) : gammafn(x) * gammafn(y) / gammafn(x + y);
}
function betaln(x, y) {
  return gammaln(x) + gammaln(y) - gammaln(x + y);
}
function ibetainv(p, a, b) {
  var EPS = 1e-8;
  var a1 = a - 1;
  var b1 = b - 1;
  var j = 0;
  var lna, lnb, pp, t, u, err, x, al, h, w, afac;
  if (p <= 0) {
    return 0;
  }
  if (p >= 1) {
    return 1;
  }
  if (a >= 1 && b >= 1) {
    pp = p < 0.5 ? p : 1 - p;
    t = Math.sqrt(-2 * Math.log(pp));
    x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
    if (p < 0.5) {
      x = -x;
    }
    al = (x * x - 3) / 6;
    h = 2 / (1 / (2 * a - 1) + 1 / (2 * b - 1));
    w = x * Math.sqrt(al + h) / h - (1 / (2 * b - 1) - 1 / (2 * a - 1)) * (al + 5 / 6 - 2 / (3 * h));
    x = a / (a + b * Math.exp(2 * w));
  } else {
    lna = Math.log(a / (a + b));
    lnb = Math.log(b / (a + b));
    t = Math.exp(a * lna) / a;
    u = Math.exp(b * lnb) / b;
    w = t + u;
    if (p < t / w) {
      x = Math.pow(a * w * p, 1 / a);
    } else {
      x = 1 - Math.pow(b * w * (1 - p), 1 / b);
    }
  }
  afac = -gammaln(a) - gammaln(b) + gammaln(a + b);
  for (; j < 10; j++) {
    if (x === 0 || x === 1) {
      return x;
    }
    err = ibeta(x, a, b) - p;
    t = Math.exp(a1 * Math.log(x) + b1 * Math.log(1 - x) + afac);
    u = err / t;
    x -= t = u / (1 - 0.5 * Math.min(1, u * (a1 / x - b1 / (1 - x))));
    if (x <= 0) {
      x = 0.5 * (x + t);
    }
    if (x >= 1) {
      x = 0.5 * (x + t + 1);
    }
    if (Math.abs(t) < EPS * x && j > 0) {
      break;
    }
  }
  return x;
}
function ibeta(x, a, b) {
  var bt = x === 0 || x === 1 ? 0 : Math.exp(gammaln(a + b) - gammaln(a) - gammaln(b) + a * Math.log(x) + b * Math.log(1 - x));
  if (x < 0 || x > 1) {
    return false;
  }
  if (x < (a + 1) / (a + b + 2)) {
    return bt * betacf(x, a, b) / a;
  }
  return 1 - bt * betacf(1 - x, b, a) / b;
}
function betacf(x, a, b) {
  var fpmin = 1e-30;
  var m = 1;
  var qab = a + b;
  var qap = a + 1;
  var qam = a - 1;
  var c = 1;
  var d = 1 - qab * x / qap;
  var m2, aa, del, h;
  if (Math.abs(d) < fpmin) {
    d = fpmin;
  }
  d = 1 / d;
  h = d;
  for (; m <= 100; m++) {
    m2 = 2 * m;
    aa = m * (b - m) * x / ((qam + m2) * (a + m2));
    d = 1 + aa * d;
    if (Math.abs(d) < fpmin) {
      d = fpmin;
    }
    c = 1 + aa / c;
    if (Math.abs(c) < fpmin) {
      c = fpmin;
    }
    d = 1 / d;
    h *= d * c;
    aa = -(a + m) * (qab + m) * x / ((a + m2) * (qap + m2));
    d = 1 + aa * d;
    if (Math.abs(d) < fpmin) {
      d = fpmin;
    }
    c = 1 + aa / c;
    if (Math.abs(c) < fpmin) {
      c = fpmin;
    }
    d = 1 / d;
    del = d * c;
    h *= del;
    if (Math.abs(del - 1) < 3e-7) {
      break;
    }
  }
  return h;
}
const binomial = {
  pdf: function(k, n2, p) {
    return p === 0 || p === 1 ? n2 * p === k ? 1 : 0 : combination(n2, k) * Math.pow(p, k) * Math.pow(1 - p, n2 - k);
  },
  cdf: function(x, n2, p) {
    var betacdf;
    var eps = 1e-10;
    if (x < 0) {
      return 0;
    }
    if (x >= n2) {
      return 1;
    }
    if (p < 0 || p > 1 || n2 <= 0) {
      return NaN;
    }
    x = Math.floor(x);
    var z = p;
    var a = x + 1;
    var b = n2 - x;
    var s = a + b;
    var bt = Math.exp(gammaln(s) - gammaln(b) - gammaln(a) + a * Math.log(z) + b * Math.log(1 - z));
    if (z < (a + 1) / (s + 2)) {
      betacdf = bt * betinc(z, a, b, eps);
    } else {
      betacdf = 1 - bt * betinc(1 - z, b, a, eps);
    }
    return Math.round((1 - betacdf) * (1 / eps)) / (1 / eps);
  }
};
function betinc(x, a, b, eps) {
  var a0 = 0;
  var b0 = 1;
  var a1 = 1;
  var b1 = 1;
  var m9 = 0;
  var a2 = 0;
  var c9;
  while (Math.abs((a1 - a2) / a1) > eps) {
    a2 = a1;
    c9 = -(a + m9) * (a + b + m9) * x / (a + 2 * m9) / (a + 2 * m9 + 1);
    a0 = a1 + c9 * a0;
    b0 = b1 + c9 * b0;
    m9 = m9 + 1;
    c9 = m9 * (b - m9) * x / (a + 2 * m9 - 1) / (a + 2 * m9);
    a1 = a0 + c9 * a1;
    b1 = b0 + c9 * b1;
    a0 = a0 / b1;
    b0 = b0 / b1;
    a1 = a1 / b1;
    b1 = 1;
  }
  return a1 / a;
}
function combination(n2, m) {
  return n2 > 170 || m > 170 ? Math.exp(combinationln(n2, m)) : factorial(n2) / factorial(m) / factorial(n2 - m);
}
function combinationln(n2, m) {
  return factorialln(n2) - factorialln(m) - factorialln(n2 - m);
}
function factorialln(n2) {
  return n2 < 0 ? NaN : gammaln(n2 + 1);
}
function factorial(n2) {
  return n2 < 0 ? NaN : gammafn(n2 + 1);
}
const chisquare = {
  pdf: function pdf4(x, dof) {
    if (x < 0) {
      return 0;
    }
    return x === 0 && dof === 2 ? 0.5 : Math.exp((dof / 2 - 1) * Math.log(x) - x / 2 - dof / 2 * Math.log(2) - gammaln(dof / 2));
  },
  cdf: function cdf4(x, dof) {
    if (x < 0) {
      return 0;
    }
    return lowRegGamma(dof / 2, x / 2);
  },
  inv: function(p, dof) {
    return 2 * gammapinv(p, 0.5 * dof);
  }
};
const centralF = {
  // This implementation of the pdf function avoids float overflow
  // See the way that R calculates this value:
  // https://svn.r-project.org/R/trunk/src/nmath/df.c
  pdf: function pdf5(x, df1, df2) {
    var p, q, f;
    if (x < 0) {
      return 0;
    }
    if (df1 <= 2) {
      if (x === 0 && df1 < 2) {
        return Infinity;
      }
      if (x === 0 && df1 === 2) {
        return 1;
      }
      return 1 / betafn(df1 / 2, df2 / 2) * Math.pow(df1 / df2, df1 / 2) * Math.pow(x, df1 / 2 - 1) * Math.pow(1 + df1 / df2 * x, -(df1 + df2) / 2);
    }
    p = df1 * x / (df2 + x * df1);
    q = df2 / (df2 + x * df1);
    f = df1 * q / 2;
    return f * binomial.pdf((df1 - 2) / 2, (df1 + df2 - 2) / 2, p);
  },
  cdf: function cdf5(x, df1, df2) {
    if (x < 0) {
      return 0;
    }
    return ibeta(df1 * x / (df1 * x + df2), df1 / 2, df2 / 2);
  },
  inv: function inv2(x, df1, df2) {
    return df2 / (df1 * (1 / ibetainv(x, df1 / 2, df2 / 2) - 1));
  }
};
const weibull = {
  pdf: function pdf6(x, scale, shape) {
    if (x < 0 || scale < 0 || shape < 0) {
      return 0;
    }
    return shape / scale * Math.pow(x / scale, shape - 1) * Math.exp(-Math.pow(x / scale, shape));
  },
  cdf: function cdf6(x, scale, shape) {
    return x < 0 ? 0 : 1 - Math.exp(-Math.pow(x / scale, shape));
  }
};
const poisson = {
  pdf: function pdf7(k, l) {
    if (l < 0 || k % 1 !== 0 || k < 0) {
      return 0;
    }
    return Math.pow(l, k) * Math.exp(-l) / factorial(k);
  },
  cdf: function cdf7(x, l) {
    var k = 0;
    if (x < 0) {
      return 0;
    }
    var sum2 = 0;
    for (; k <= x; k++) {
      sum2 += poisson.pdf(k, l);
    }
    return sum2;
  }
};
const hypgeom = {
  pdf: function pdf8(k, N, m, n2) {
    if (k < 0 || k < m - (N - n2)) {
      return 0;
    } else if (k > n2 || k > m) {
      return 0;
    } else if (m * 2 > N) {
      if (n2 * 2 > N) {
        return hypgeom.pdf(N - m - n2 + k, N, N - m, N - n2);
      } else {
        return hypgeom.pdf(n2 - k, N, N - m, n2);
      }
    } else if (n2 * 2 > N) {
      return hypgeom.pdf(m - k, N, m, N - n2);
    } else if (m < n2) {
      return hypgeom.pdf(k, N, n2, m);
    } else {
      var scaledPDF = 1;
      var samplesDone = 0;
      for (var i = 0; i < k; i++) {
        while (scaledPDF > 1 && samplesDone < n2) {
          scaledPDF *= 1 - m / (N - samplesDone);
          samplesDone++;
        }
        scaledPDF *= (n2 - i) * (m - i) / ((i + 1) * (N - m - n2 + i + 1));
      }
      for (; samplesDone < n2; samplesDone++) {
        scaledPDF *= 1 - m / (N - samplesDone);
      }
      return Math.min(1, Math.max(0, scaledPDF));
    }
  },
  cdf: function cdf8(x, N, m, n2) {
    if (x < 0 || x < m - (N - n2)) {
      return 0;
    } else if (x >= n2 || x >= m) {
      return 1;
    } else if (m * 2 > N) {
      if (n2 * 2 > N) {
        return cdf8(N - m - n2 + x, N, N - m, N - n2);
      } else {
        return 1 - hypgeom.cdf(n2 - x - 1, N, N - m, n2);
      }
    } else if (n2 * 2 > N) {
      return 1 - hypgeom.cdf(m - x - 1, N, m, N - n2);
    } else if (m < n2) {
      return hypgeom.cdf(x, N, n2, m);
    } else {
      var scaledCDF = 1;
      var scaledPDF = 1;
      var samplesDone = 0;
      for (var i = 0; i < x; i++) {
        while (scaledCDF > 1 && samplesDone < n2) {
          var factor = 1 - m / (N - samplesDone);
          scaledPDF *= factor;
          scaledCDF *= factor;
          samplesDone++;
        }
        scaledPDF *= (n2 - i) * (m - i) / ((i + 1) * (N - m - n2 + i + 1));
        scaledCDF += scaledPDF;
      }
      for (; samplesDone < n2; samplesDone++) {
        scaledCDF *= 1 - m / (N - samplesDone);
      }
      return Math.min(1, Math.max(0, scaledCDF));
    }
  }
};
const studentt = {
  pdf: function pdf9(x, dof) {
    dof = dof > 1e100 ? 1e100 : dof;
    return 1 / (Math.sqrt(dof) * betafn(0.5, dof / 2)) * Math.pow(1 + x * x / dof, -((dof + 1) / 2));
  },
  cdf: function cdf9(x, dof) {
    var dof2 = dof / 2;
    return ibeta((x + Math.sqrt(x * x + dof)) / (2 * Math.sqrt(x * x + dof)), dof2, dof2);
  },
  inv: function(p, dof) {
    var x = ibetainv(2 * Math.min(p, 1 - p), 0.5 * dof, 0.5);
    x = Math.sqrt(dof * (1 - x) / x);
    return p > 0.5 ? x : -x;
  }
};
const lognormal = {
  pdf: function pdf10(x, mu, sigma) {
    if (x <= 0) {
      return 0;
    }
    return Math.exp(-Math.log(x) - 0.5 * Math.log(2 * Math.PI) - Math.log(sigma) - Math.pow(Math.log(x) - mu, 2) / (2 * sigma * sigma));
  },
  cdf: function cdf10(x, mu, sigma) {
    if (x < 0) {
      return 0;
    }
    return 0.5 + 0.5 * erf((Math.log(x) - mu) / Math.sqrt(2 * sigma * sigma));
  },
  inv: function(p, mu, sigma) {
    return Math.exp(-1.4142135623730951 * sigma * erfcinv(2 * p) + mu);
  }
};
const negbin = {
  pdf: function pdf11(k, r, p) {
    if (k !== k >>> 0) {
      return false;
    }
    if (k < 0) {
      return 0;
    }
    return combination(k + r - 1, r - 1) * Math.pow(1 - p, k) * Math.pow(p, r);
  },
  cdf: function cdf11(x, r, p) {
    var sum2 = 0, k = 0;
    if (x < 0) {
      return 0;
    }
    for (; k <= x; k++) {
      sum2 += negbin.pdf(k, r, p);
    }
    return sum2;
  }
};
function sum(arr) {
  var sum2 = 0;
  var i = arr.length;
  while (--i >= 0) {
    sum2 += arr[i];
  }
  return sum2;
}
function mean(arr) {
  return sum(arr) / arr.length;
}
function sumsqerr(arr) {
  var meanv = mean(arr);
  var sum2 = 0;
  var i = arr.length;
  var tmp;
  while (--i >= 0) {
    tmp = arr[i] - meanv;
    sum2 += tmp * tmp;
  }
  return sum2;
}
function variance(arr, flag) {
  return sumsqerr(arr) / (arr.length - (flag ? 1 : 0));
}
function stdev(arr, flag) {
  return Math.sqrt(variance(arr, flag));
}
function normalci() {
  var args = [].slice.call(arguments), ans = new Array(2), change;
  if (args.length === 4) {
    change = Math.abs(normal.inv(args[1] / 2, 0, 1) * args[2] / Math.sqrt(args[3]));
  } else {
    change = Math.abs(normal.inv(args[1] / 2, 0, 1) * stdev(args[2]) / Math.sqrt(args[2].length));
  }
  ans[0] = args[0] - change;
  ans[1] = args[0] + change;
  return ans;
}
function tci() {
  var args = [].slice.call(arguments), ans = new Array(2), change;
  if (args.length === 4) {
    change = Math.abs(studentt.inv(args[1] / 2, args[3] - 1) * args[2] / Math.sqrt(args[3]));
  } else {
    change = Math.abs(studentt.inv(args[1] / 2, args[2].length - 1) * stdev(args[2], true) / Math.sqrt(args[2].length));
  }
  ans[0] = args[0] - change;
  ans[1] = args[0] + change;
  return ans;
}
function product(arr) {
  var prod = 1;
  var i = arr.length;
  while (--i >= 0) {
    prod *= arr[i];
  }
  return prod;
}
function geomean(arr) {
  return Math.pow(product(arr), 1 / arr.length);
}
function covariance(arr1, arr2) {
  var u = mean(arr1);
  var v = mean(arr2);
  var arr1Len = arr1.length;
  var sq_dev = new Array(arr1Len);
  var i;
  for (i = 0; i < arr1Len; i++) {
    sq_dev[i] = (arr1[i] - u) * (arr2[i] - v);
  }
  return sum(sq_dev) / (arr1Len - 1);
}
function corrcoeff(arr1, arr2) {
  return covariance(arr1, arr2) / stdev(arr1, 1) / stdev(arr2, 1);
}
class StatisticalPlugin extends FunctionPlugin {
  erf(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ERF"), (lowerBound2, upperBound) => {
      if (upperBound === void 0) {
        return erf(lowerBound2);
      } else {
        return erf(upperBound) - erf(lowerBound2);
      }
    });
  }
  erfc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("ERFC"), erfc);
  }
  expondist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("EXPON.DIST"), (x, lambda, cumulative) => {
      if (cumulative) {
        return exponential.cdf(x, lambda);
      } else {
        return exponential.pdf(x, lambda);
      }
    });
  }
  fisher(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FISHER"), (x) => Math.log((1 + x) / (1 - x)) / 2);
  }
  fisherinv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FISHERINV"), (y) => 1 - 2 / (Math.exp(2 * y) + 1));
  }
  gamma(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GAMMA"), gammafn);
  }
  gammadist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GAMMA.DIST"), (value, alphaVal, betaVal, cumulative) => {
      if (cumulative) {
        return gamma.cdf(value, alphaVal, betaVal);
      } else {
        return gamma.pdf(value, alphaVal, betaVal);
      }
    });
  }
  gammaln(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GAMMALN"), gammaln);
  }
  gammainv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GAMMA.INV"), gamma.inv);
  }
  gauss(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GAUSS"), (z) => normal.cdf(z, 0, 1) - 0.5);
  }
  betadist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BETA.DIST"), (x, alphaVal, betaVal, cumulative, A, B) => {
      if (x <= A) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
      } else if (x >= B) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      x = (x - A) / (B - A);
      if (cumulative) {
        return beta.cdf(x, alphaVal, betaVal);
      } else {
        return beta.pdf(x, alphaVal, betaVal);
      }
    });
  }
  betainv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BETA.INV"), (x, alphaVal, betaVal, A, B) => {
      if (A >= B) {
        return new CellError(ErrorType.NUM, ErrorMessage.WrongOrder);
      } else {
        return beta.inv(x, alphaVal, betaVal) * (B - A) + A;
      }
    });
  }
  binomialdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BINOM.DIST"), (succ, trials, prob, cumulative) => {
      if (succ > trials) {
        return new CellError(ErrorType.NUM, ErrorMessage.WrongOrder);
      }
      succ = Math.trunc(succ);
      trials = Math.trunc(trials);
      if (cumulative) {
        return binomial.cdf(succ, trials, prob);
      } else {
        return binomial.pdf(succ, trials, prob);
      }
    });
  }
  binomialinv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BINOM.INV"), (trials, prob, alpha) => {
      trials = Math.trunc(trials);
      let lower = -1;
      let upper = trials;
      while (upper > lower + 1) {
        const mid = Math.trunc((lower + upper) / 2);
        if (binomial.cdf(mid, trials, prob) >= alpha) {
          upper = mid;
        } else {
          lower = mid;
        }
      }
      return upper;
    });
  }
  besselifn(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BESSELI"), (x, n2) => besseli(x, Math.trunc(n2)));
  }
  besseljfn(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BESSELJ"), (x, n2) => besselj(x, Math.trunc(n2)));
  }
  besselkfn(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BESSELK"), (x, n2) => besselk(x, Math.trunc(n2)));
  }
  besselyfn(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("BESSELY"), (x, n2) => bessely(x, Math.trunc(n2)));
  }
  chisqdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHISQ.DIST"), (x, deg, cumulative) => {
      deg = Math.trunc(deg);
      if (cumulative) {
        return chisquare.cdf(x, deg);
      } else {
        return chisquare.pdf(x, deg);
      }
    });
  }
  chisqdistrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHISQ.DIST.RT"), (x, deg) => 1 - chisquare.cdf(x, Math.trunc(deg)));
  }
  chisqinv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHISQ.INV"), (p, deg) => chisquare.inv(p, Math.trunc(deg)));
  }
  chisqinvrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHISQ.INV.RT"), (p, deg) => chisquare.inv(1 - p, Math.trunc(deg)));
  }
  fdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("F.DIST"), (x, deg1, deg2, cumulative) => {
      deg1 = Math.trunc(deg1);
      deg2 = Math.trunc(deg2);
      if (cumulative) {
        return centralF.cdf(x, deg1, deg2);
      } else {
        return centralF.pdf(x, deg1, deg2);
      }
    });
  }
  fdistrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("F.DIST.RT"), (x, deg1, deg2) => 1 - centralF.cdf(x, Math.trunc(deg1), Math.trunc(deg2)));
  }
  finv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("F.INV"), (p, deg1, deg2) => centralF.inv(p, Math.trunc(deg1), Math.trunc(deg2)));
  }
  finvrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("F.INV.RT"), (p, deg1, deg2) => centralF.inv(1 - p, Math.trunc(deg1), Math.trunc(deg2)));
  }
  weibulldist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("WEIBULL.DIST"), (x, shape, scale, cumulative) => {
      if (cumulative) {
        return weibull.cdf(x, scale, shape);
      } else {
        return weibull.pdf(x, scale, shape);
      }
    });
  }
  poissondist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("POISSON.DIST"), (x, mean2, cumulative) => {
      x = Math.trunc(x);
      if (cumulative) {
        return poisson.cdf(x, mean2);
      } else {
        return poisson.pdf(x, mean2);
      }
    });
  }
  hypgeomdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HYPGEOM.DIST"), (s, numberS, populationS, numberPop, cumulative) => {
      if (s > numberS || s > populationS || numberS > numberPop || populationS > numberPop) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      if (s + numberPop < populationS + numberS) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      s = Math.trunc(s);
      numberS = Math.trunc(numberS);
      populationS = Math.trunc(populationS);
      numberPop = Math.trunc(numberPop);
      if (cumulative) {
        return hypgeom.cdf(s, numberPop, populationS, numberS);
      } else {
        return hypgeom.pdf(s, numberPop, populationS, numberS);
      }
    });
  }
  tdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T.DIST"), (x, deg, cumulative) => {
      deg = Math.trunc(deg);
      if (cumulative) {
        return studentt.cdf(x, deg);
      } else {
        return studentt.pdf(x, deg);
      }
    });
  }
  tdist2t(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T.DIST.2T"), (x, deg) => (1 - studentt.cdf(x, Math.trunc(deg))) * 2);
  }
  tdistrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T.DIST.RT"), (x, deg) => 1 - studentt.cdf(x, Math.trunc(deg)));
  }
  tdistold(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("TDIST"), (x, deg, mode) => mode * (1 - studentt.cdf(x, Math.trunc(deg))));
  }
  tinv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T.INV"), (p, deg) => studentt.inv(p, Math.trunc(deg)));
  }
  tinv2t(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T.INV.2T"), (p, deg) => studentt.inv(1 - p / 2, Math.trunc(deg)));
  }
  lognormdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LOGNORM.DIST"), (x, mean2, stddev, cumulative) => {
      if (cumulative) {
        return lognormal.cdf(x, mean2, stddev);
      } else {
        return lognormal.pdf(x, mean2, stddev);
      }
    });
  }
  lognorminv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LOGNORM.INV"), (p, mean2, stddev) => lognormal.inv(p, mean2, stddev));
  }
  normdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NORM.DIST"), (x, mean2, stddev, cumulative) => {
      if (cumulative) {
        return normal.cdf(x, mean2, stddev);
      } else {
        return normal.pdf(x, mean2, stddev);
      }
    });
  }
  norminv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NORM.INV"), (p, mean2, stddev) => normal.inv(p, mean2, stddev));
  }
  normsdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NORM.S.DIST"), (x, cumulative) => {
      if (cumulative) {
        return normal.cdf(x, 0, 1);
      } else {
        return normal.pdf(x, 0, 1);
      }
    });
  }
  normsinv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NORM.S.INV"), (p) => normal.inv(p, 0, 1));
  }
  phi(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("PHI"), (x) => normal.pdf(x, 0, 1));
  }
  negbinomdist(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("NEGBINOM.DIST"), (nf, ns, p, cumulative) => {
      nf = Math.trunc(nf);
      ns = Math.trunc(ns);
      if (cumulative) {
        return negbin.cdf(nf, ns, p);
      } else {
        return negbin.pdf(nf, ns, p);
      }
    });
  }
  confidencenorm(ast, state) {
    return this.runFunction(
      ast.args,
      state,
      this.metadata("CONFIDENCE.NORM"),
      // eslint-disable-next-line
      // @ts-ignore
      (alpha, stddev, size) => normalci(1, alpha, stddev, Math.trunc(size))[1] - 1
    );
  }
  confidencet(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CONFIDENCE.T"), (alpha, stddev, size) => {
      size = Math.trunc(size);
      if (size === 1) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return tci(1, alpha, stddev, size)[1] - 1;
    });
  }
  standardize(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("STANDARDIZE"), (x, mean2, stddev) => (x - mean2) / stddev);
  }
}
StatisticalPlugin.implementedFunctions = {
  "ERF": {
    method: "erf",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true
    }]
  },
  "ERFC": {
    method: "erfc",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "EXPON.DIST": {
    method: "expondist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "FISHER": {
    method: "fisher",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: -1,
      lessThan: 1
    }]
  },
  "FISHERINV": {
    method: "fisherinv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "GAMMA": {
    method: "gamma",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "GAMMA.DIST": {
    method: "gammadist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "GAMMALN": {
    method: "gammaln",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }]
  },
  "GAMMA.INV": {
    method: "gammainv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      lessThan: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }]
  },
  "GAUSS": {
    method: "gauss",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "BETA.DIST": {
    method: "betadist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "BETA.INV": {
    method: "betainv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      defaultValue: 1
    }]
  },
  "BINOM.DIST": {
    method: "binomialdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "BINOM.INV": {
    method: "binomialinv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }]
  },
  "BESSELI": {
    method: "besselifn",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "BESSELJ": {
    method: "besseljfn",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "BESSELK": {
    method: "besselkfn",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "BESSELY": {
    method: "besselyfn",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "CHISQ.DIST": {
    method: "chisqdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1,
      maxValue: 1e10
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "CHISQ.DIST.RT": {
    method: "chisqdistrt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1,
      maxValue: 1e10
    }]
  },
  "CHISQ.INV": {
    method: "chisqinv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1,
      maxValue: 1e10
    }]
  },
  "CHISQ.INV.RT": {
    method: "chisqinvrt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "F.DIST": {
    method: "fdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "F.DIST.RT": {
    method: "fdistrt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "F.INV": {
    method: "finv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "F.INV.RT": {
    method: "finvrt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "WEIBULL.DIST": {
    method: "weibulldist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "POISSON.DIST": {
    method: "poissondist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "HYPGEOM.DIST": {
    method: "hypgeomdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "T.DIST": {
    method: "tdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "T.DIST.2T": {
    method: "tdist2t",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "T.DIST.RT": {
    method: "tdistrt",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "TDIST": {
    method: "tdistold",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1,
      maxValue: 2
    }]
  },
  "T.INV": {
    method: "tinv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "T.INV.2T": {
    method: "tinv2t",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "LOGNORM.DIST": {
    method: "lognormdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "LOGNORM.INV": {
    method: "lognorminv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }]
  },
  "NORM.DIST": {
    method: "normdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "NORM.INV": {
    method: "norminv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }]
  },
  "NORM.S.DIST": {
    method: "normsdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "NORM.S.INV": {
    method: "normsinv",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }]
  },
  "PHI": {
    method: "phi",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "NEGBINOM.DIST": {
    method: "negbinomdist",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 1
    }, {
      argumentType: FunctionArgumentType.BOOLEAN
    }]
  },
  "CONFIDENCE.NORM": {
    method: "confidencenorm",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "CONFIDENCE.T": {
    method: "confidencet",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0,
      lessThan: 1
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 1
    }]
  },
  "STANDARDIZE": {
    method: "standardize",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      greaterThan: 0
    }]
  }
};
StatisticalPlugin.aliases = {
  NEGBINOMDIST: "NEGBINOM.DIST",
  EXPONDIST: "EXPON.DIST",
  BETADIST: "BETA.DIST",
  NORMDIST: "NORM.DIST",
  NORMINV: "NORM.INV",
  NORMSDIST: "NORM.S.DIST",
  NORMSINV: "NORM.S.INV",
  LOGNORMDIST: "LOGNORM.DIST",
  LOGINV: "LOGNORM.INV",
  TINV: "T.INV.2T",
  HYPGEOMDIST: "HYPGEOM.DIST",
  POISSON: "POISSON.DIST",
  WEIBULL: "WEIBULL.DIST",
  FINV: "F.INV.RT",
  FDIST: "F.DIST.RT",
  CHIDIST: "CHISQ.DIST.RT",
  CHIINV: "CHISQ.INV.RT",
  GAMMADIST: "GAMMA.DIST",
  "GAMMALN.PRECISE": "GAMMALN",
  GAMMAINV: "GAMMA.INV",
  BETAINV: "BETA.INV",
  BINOMDIST: "BINOM.DIST",
  CONFIDENCE: "CONFIDENCE.NORM",
  CRITBINOM: "BINOM.INV",
  WEIBULLDIST: "WEIBULL.DIST",
  TINV2T: "T.INV.2T",
  TDISTRT: "T.DIST.RT",
  TDIST2T: "T.DIST.2T",
  FINVRT: "F.INV.RT",
  FDISTRT: "F.DIST.RT",
  CHIDISTRT: "CHISQ.DIST.RT",
  CHIINVRT: "CHISQ.INV.RT",
  LOGNORMINV: "LOGNORM.INV",
  POISSONDIST: "POISSON.DIST"
};
class MathPlugin extends FunctionPlugin {
  fact(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FACT"), (arg) => {
      arg = Math.trunc(arg);
      let ret = 1;
      for (let i = 1; i <= arg; i++) {
        ret *= i;
      }
      return ret;
    });
  }
  factdouble(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("FACTDOUBLE"), (arg) => {
      arg = Math.trunc(arg);
      let ret = 1;
      for (let i = arg; i >= 1; i -= 2) {
        ret *= i;
      }
      return ret;
    });
  }
  combin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COMBIN"), (n2, m) => {
      if (m > n2) {
        return new CellError(ErrorType.NUM, ErrorMessage.WrongOrder);
      }
      n2 = Math.trunc(n2);
      m = Math.trunc(m);
      return combin(n2, m);
    });
  }
  combina(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COMBINA"), (n2, m) => {
      n2 = Math.trunc(n2);
      m = Math.trunc(m);
      if (n2 + m - 1 >= 1030) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      if (n2 === 0 && m === 0) {
        return 1;
      }
      return combin(n2 + m - 1, m);
    });
  }
  gcd(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GCD"), (...args) => {
      const processedArgs = this.arithmeticHelper.coerceNumbersCoerceRangesDropNulls(args);
      if (processedArgs instanceof CellError) {
        return processedArgs;
      }
      let ret = 0;
      for (const val of processedArgs) {
        if (val < 0) {
          return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
        }
        ret = binaryGCD(ret, Math.trunc(val));
      }
      if (ret > Number.MAX_SAFE_INTEGER) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      return ret;
    });
  }
  lcm(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("LCM"), (...args) => {
      const processedArgs = this.arithmeticHelper.coerceNumbersCoerceRangesDropNulls(args);
      if (processedArgs instanceof CellError) {
        return processedArgs;
      }
      let ret = 1;
      for (const val of processedArgs) {
        if (val < 0) {
          return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
        }
        ret = binaryLCM(ret, Math.trunc(val));
      }
      if (ret > Number.MAX_SAFE_INTEGER) {
        return new CellError(ErrorType.NUM, ErrorMessage.ValueLarge);
      }
      return ret;
    });
  }
  mround(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MROUND"), (nom, denom) => {
      if (denom === 0) {
        return 0;
      }
      if (nom > 0 && denom < 0 || nom < 0 && denom > 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.DistinctSigns);
      }
      return Math.round(nom / denom) * denom;
    });
  }
  multinomial(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("MULTINOMIAL"), (...args) => {
      let n2 = 0;
      let ans = 1;
      for (let arg of args) {
        if (arg < 0) {
          return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
        }
        arg = Math.trunc(arg);
        for (let i = 1; i <= arg; i++) {
          ans *= (n2 + i) / i;
        }
        n2 += arg;
      }
      return Math.round(ans);
    });
  }
  quotient(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("QUOTIENT"), (nom, denom) => {
      if (denom === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return Math.trunc(nom / denom);
    });
  }
  seriessum(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SERIESSUM"), (x, n2, m, range) => {
      const coefs = this.arithmeticHelper.manyToOnlyNumbersDropNulls(range.valuesFromTopLeftCorner());
      if (coefs instanceof CellError) {
        return coefs;
      }
      let ret = 0;
      coefs.reverse();
      for (const coef of coefs) {
        ret *= Math.pow(x, m);
        ret += coef;
      }
      return ret * Math.pow(x, n2);
    });
  }
  sign(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SIGN"), (arg) => {
      if (arg > 0) {
        return 1;
      } else if (arg < 0) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  sumx2my2(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SUMX2MY2"), (rangeX, rangeY) => {
      const valsX = rangeX.valuesFromTopLeftCorner();
      const valsY = rangeY.valuesFromTopLeftCorner();
      if (valsX.length !== valsY.length) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const n2 = valsX.length;
      let ret = 0;
      for (let i = 0; i < n2; i++) {
        const valX = valsX[i];
        const valY = valsY[i];
        if (valX instanceof CellError) {
          return valX;
        }
        if (valY instanceof CellError) {
          return valY;
        }
        if (typeof valX === "number" && typeof valY === "number") {
          ret += Math.pow(valX, 2) - Math.pow(valY, 2);
        }
      }
      return ret;
    });
  }
  sumx2py2(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SUMX2PY2"), (rangeX, rangeY) => {
      const valsX = rangeX.valuesFromTopLeftCorner();
      const valsY = rangeY.valuesFromTopLeftCorner();
      if (valsX.length !== valsY.length) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const n2 = valsX.length;
      let ret = 0;
      for (let i = 0; i < n2; i++) {
        const valX = valsX[i];
        const valY = valsY[i];
        if (valX instanceof CellError) {
          return valX;
        }
        if (valY instanceof CellError) {
          return valY;
        }
        if (typeof valX === "number" && typeof valY === "number") {
          ret += Math.pow(valX, 2) + Math.pow(valY, 2);
        }
      }
      return ret;
    });
  }
  sumxmy2(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SUMXMY2"), (rangeX, rangeY) => {
      const valsX = rangeX.valuesFromTopLeftCorner();
      const valsY = rangeY.valuesFromTopLeftCorner();
      if (valsX.length !== valsY.length) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const n2 = valsX.length;
      let ret = 0;
      for (let i = 0; i < n2; i++) {
        const valX = valsX[i];
        const valY = valsY[i];
        if (valX instanceof CellError) {
          return valX;
        }
        if (valY instanceof CellError) {
          return valY;
        }
        if (typeof valX === "number" && typeof valY === "number") {
          ret += Math.pow(valX - valY, 2);
        }
      }
      return ret;
    });
  }
}
MathPlugin.implementedFunctions = {
  "FACT": {
    method: "fact",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 170
    }]
  },
  "FACTDOUBLE": {
    method: "factdouble",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      maxValue: 288
    }]
  },
  "COMBIN": {
    method: "combin",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0,
      lessThan: 1030
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "COMBINA": {
    method: "combina",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      minValue: 0
    }]
  },
  "GCD": {
    method: "gcd",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "LCM": {
    method: "lcm",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "MROUND": {
    method: "mround",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "MULTINOMIAL": {
    method: "multinomial",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }],
    repeatLastArgs: 1,
    expandRanges: true
  },
  "QUOTIENT": {
    method: "quotient",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "SERIESSUM": {
    method: "seriessum",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "SIGN": {
    method: "sign",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "SUMX2MY2": {
    method: "sumx2my2",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "SUMX2PY2": {
    method: "sumx2py2",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "SUMXMY2": {
    method: "sumxmy2",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  }
};
function combin(n2, m) {
  if (2 * m > n2) {
    m = n2 - m;
  }
  let ret = 1;
  for (let i = 1; i <= m; i++) {
    ret *= (n2 - m + i) / i;
  }
  return Math.round(ret);
}
function binaryGCD(a, b) {
  if (a < b) {
    [a, b] = [b, a];
  }
  while (b > 0) {
    [a, b] = [b, a % b];
  }
  return a;
}
function binaryLCM(a, b) {
  if (a === 0 || b === 0) {
    return 0;
  }
  return a * (b / binaryGCD(a, b));
}
class ComplexPlugin extends FunctionPlugin {
  complex(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COMPLEX"), (re, im, unit) => {
      if (unit !== "i" && unit !== "j") {
        return new CellError(ErrorType.VALUE, ErrorMessage.ShouldBeIorJ);
      }
      return coerceComplexToString([re, im], unit);
    });
  }
  imabs(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMABS"), abs);
  }
  imaginary(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMAGINARY"), ([_re, im]) => im);
  }
  imreal(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMREAL"), ([re, _im]) => re);
  }
  imargument(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMARGUMENT"), ([re, im]) => {
      if (re === 0 && im === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return Math.atan2(im, re);
    });
  }
  imconjugate(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMCONJUGATE"), ([re, im]) => coerceComplexToString([re, -im]));
  }
  imcos(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMCOS"), (arg) => coerceComplexToString(cos(arg)));
  }
  imcosh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMCOSH"), (arg) => coerceComplexToString(cosh(arg)));
  }
  imcot(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMCOT"), (arg) => coerceComplexToString(div(cos(arg), sin(arg))));
  }
  imcsc(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMCSC"), (arg) => coerceComplexToString(div([1, 0], sin(arg))));
  }
  imcsch(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMCSCH"), (arg) => coerceComplexToString(div([1, 0], sinh(arg))));
  }
  imsec(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSEC"), (arg) => coerceComplexToString(div([1, 0], cos(arg))));
  }
  imsech(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSECH"), (arg) => coerceComplexToString(div([1, 0], cosh(arg))));
  }
  imsin(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSIN"), (arg) => coerceComplexToString(sin(arg)));
  }
  imsinh(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSINH"), (arg) => coerceComplexToString(sinh(arg)));
  }
  imtan(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMTAN"), (arg) => coerceComplexToString(div(sin(arg), cos(arg))));
  }
  imdiv(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMDIV"), (arg1, arg2) => coerceComplexToString(div(arg1, arg2)));
  }
  improduct(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMPRODUCT"), (...args) => {
      const coerced = this.arithmeticHelper.coerceComplexExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      let prod = [1, 0];
      for (const val of coerced) {
        prod = mul(prod, val);
      }
      return coerceComplexToString(prod);
    });
  }
  imsum(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSUM"), (...args) => {
      const coerced = this.arithmeticHelper.coerceComplexExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      let sum2 = [0, 0];
      for (const val of coerced) {
        sum2 = add(sum2, val);
      }
      return coerceComplexToString(sum2);
    });
  }
  imsub(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSUB"), (arg1, arg2) => coerceComplexToString(sub(arg1, arg2)));
  }
  imexp(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMEXP"), (arg) => coerceComplexToString(exp(arg)));
  }
  imln(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMLN"), (arg) => coerceComplexToString(ln(arg)));
  }
  imlog10(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMLOG10"), (arg) => {
      const [re, im] = ln(arg);
      const c = Math.log(10);
      return coerceComplexToString([re / c, im / c]);
    });
  }
  imlog2(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMLOG2"), (arg) => {
      const [re, im] = ln(arg);
      const c = Math.log(2);
      return coerceComplexToString([re / c, im / c]);
    });
  }
  impower(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMPOWER"), (arg, n2) => coerceComplexToString(power(arg, n2)));
  }
  imsqrt(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("IMSQRT"), (arg) => coerceComplexToString(power(arg, 0.5)));
  }
}
ComplexPlugin.implementedFunctions = {
  "COMPLEX": {
    method: "complex",
    parameters: [{
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.STRING,
      defaultValue: "i"
    }]
  },
  "IMABS": {
    method: "imabs",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMAGINARY": {
    method: "imaginary",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMREAL": {
    method: "imreal",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMARGUMENT": {
    method: "imargument",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMCONJUGATE": {
    method: "imconjugate",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMCOS": {
    method: "imcos",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMCOSH": {
    method: "imcosh",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMCOT": {
    method: "imcot",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMCSC": {
    method: "imcsc",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMCSCH": {
    method: "imcsch",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMSEC": {
    method: "imsec",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMSECH": {
    method: "imsech",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMSIN": {
    method: "imsin",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMSINH": {
    method: "imsinh",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMTAN": {
    method: "imtan",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMDIV": {
    method: "imdiv",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }, {
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMPRODUCT": {
    method: "improduct",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "IMSUM": {
    method: "imsum",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "IMSUB": {
    method: "imsub",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }, {
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMEXP": {
    method: "imexp",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMLN": {
    method: "imln",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMLOG10": {
    method: "imlog10",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMLOG2": {
    method: "imlog2",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  },
  "IMPOWER": {
    method: "impower",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }]
  },
  "IMSQRT": {
    method: "imsqrt",
    parameters: [{
      argumentType: FunctionArgumentType.COMPLEX
    }]
  }
};
function add([re1, im1], [re2, im2]) {
  return [re1 + re2, im1 + im2];
}
function sub([re1, im1], [re2, im2]) {
  return [re1 - re2, im1 - im2];
}
function mul([re1, im1], [re2, im2]) {
  return [re1 * re2 - im1 * im2, re1 * im2 + re2 * im1];
}
function div([re1, im1], [re2, im2]) {
  const denom = Math.pow(re2, 2) + Math.pow(im2, 2);
  const [nomRe, nomIm] = mul([re1, im1], [re2, -im2]);
  return [nomRe / denom, nomIm / denom];
}
function cos([re, im]) {
  return [Math.cos(re) * Math.cosh(im), -Math.sin(re) * Math.sinh(im)];
}
function cosh([re, im]) {
  return [Math.cosh(re) * Math.cos(im), Math.sinh(re) * Math.sin(im)];
}
function sin([re, im]) {
  return [Math.sin(re) * Math.cosh(im), Math.cos(re) * Math.sinh(im)];
}
function sinh([re, im]) {
  return [Math.sinh(re) * Math.cos(im), Math.cosh(re) * Math.sin(im)];
}
function exp([re, im]) {
  return [Math.exp(re) * Math.cos(im), Math.exp(re) * Math.sin(im)];
}
function abs([re, im]) {
  return Math.sqrt(re * re + im * im);
}
function ln([re, im]) {
  return [Math.log(abs([re, im])), Math.atan2(im, re)];
}
function power(arg, n2) {
  const [re, im] = ln(arg);
  return exp([n2 * re, n2 * im]);
}
class StatisticalAggregationPlugin extends FunctionPlugin {
  avedev(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("AVEDEV"), (...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      if (coerced.length === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const avg = mean(coerced);
      return coerced.reduce((a, b) => a + Math.abs(b - avg), 0) / coerced.length;
    });
  }
  devsq(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("DEVSQ"), (...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      if (coerced.length === 0) {
        return 0;
      }
      return sumsqerr(coerced);
    });
  }
  geomean(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("GEOMEAN"), (...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      if (coerced.length === 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.OneValue);
      }
      for (const val of coerced) {
        if (val <= 0) {
          return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
        }
      }
      return geomean(coerced);
    });
  }
  harmean(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("HARMEAN"), (...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      if (coerced.length === 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.OneValue);
      }
      for (const val of coerced) {
        if (val <= 0) {
          return new CellError(ErrorType.NUM, ErrorMessage.ValueSmall);
        }
      }
      return coerced.length / coerced.reduce((a, b) => a + 1 / b, 0);
    });
  }
  correl(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CORREL"), (dataX, dataY) => {
      if (dataX.numberOfElements() !== dataY.numberOfElements()) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      const n2 = ret[0].length;
      if (n2 <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
      }
      return corrcoeff(ret[0], ret[1]);
    });
  }
  rsq(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("RSQ"), (dataX, dataY) => {
      if (dataX.numberOfElements() !== dataY.numberOfElements()) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      const n2 = ret[0].length;
      if (n2 <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
      }
      return Math.pow(corrcoeff(ret[0], ret[1]), 2);
    });
  }
  covariancep(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COVARIANCE.P"), (dataX, dataY) => {
      if (dataX.numberOfElements() !== dataY.numberOfElements()) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      const n2 = ret[0].length;
      if (n2 < 1) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.OneValue);
      }
      if (n2 === 1) {
        return 0;
      }
      return covariance(ret[0], ret[1]) * (n2 - 1) / n2;
    });
  }
  covariances(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("COVARIANCE.S"), (dataX, dataY) => {
      if (dataX.numberOfElements() !== dataY.numberOfElements()) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      const n2 = ret[0].length;
      if (n2 <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
      }
      return covariance(ret[0], ret[1]);
    });
  }
  ztest(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("Z.TEST"), (range, x, sigma) => {
      const vals = this.arithmeticHelper.manyToExactNumbers(range.valuesFromTopLeftCorner());
      if (vals instanceof CellError) {
        return vals;
      }
      const n2 = vals.length;
      if (sigma === void 0) {
        if (n2 < 2) {
          return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
        }
        sigma = stdev(vals, true);
      }
      if (n2 < 1) {
        return new CellError(ErrorType.NA, ErrorMessage.OneValue);
      }
      if (sigma === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return 1 - normal.cdf((mean(vals) - x) / (sigma / Math.sqrt(n2)), 0, 1);
    });
  }
  ftest(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("F.TEST"), (dataX, dataY) => {
      const arrX = this.arithmeticHelper.manyToExactNumbers(dataX.valuesFromTopLeftCorner());
      const arrY = this.arithmeticHelper.manyToExactNumbers(dataY.valuesFromTopLeftCorner());
      if (arrX instanceof CellError) {
        return arrX;
      }
      if (arrY instanceof CellError) {
        return arrY;
      }
      if (arrX.length <= 1 || arrY.length <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const vx = variance(arrX, true);
      const vy = variance(arrY, true);
      if (vx === 0 || vy === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      const r = vx / vy;
      const v = centralF.cdf(r, arrX.length - 1, arrY.length - 1);
      return 2 * Math.min(v, 1 - v);
    });
  }
  steyx(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("STEYX"), (dataX, dataY) => {
      if (dataX.numberOfElements() !== dataY.numberOfElements()) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      const n2 = ret[0].length;
      if (n2 <= 2) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.ThreeValues);
      }
      return Math.sqrt((sumsqerr(ret[0]) - Math.pow(covariance(ret[0], ret[1]) * (n2 - 1), 2) / sumsqerr(ret[1])) / (n2 - 2));
    });
  }
  slope(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SLOPE"), (dataX, dataY) => {
      if (dataX.numberOfElements() !== dataY.numberOfElements()) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      const n2 = ret[0].length;
      if (n2 <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
      }
      return covariance(ret[0], ret[1]) * (n2 - 1) / sumsqerr(ret[1]);
    });
  }
  chisqtest(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("CHISQ.TEST"), (dataX, dataY) => {
      const r = dataX.height();
      const c = dataX.width();
      if (dataY.height() !== r || dataY.width() !== c) {
        return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
      }
      const ret = parseTwoArrays(dataX, dataY);
      if (ret instanceof CellError) {
        return ret;
      }
      if (ret[0].length <= 1) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
      }
      let sum2 = 0;
      for (let i = 0; i < ret[0].length; i++) {
        if (ret[1][i] === 0) {
          return new CellError(ErrorType.DIV_BY_ZERO);
        }
        sum2 += Math.pow(ret[0][i] - ret[1][i], 2) / ret[1][i];
      }
      if (sum2 < 0) {
        return new CellError(ErrorType.NUM, ErrorMessage.NaN);
      }
      return 1 - chisquare.cdf(sum2, r > 1 && c > 1 ? (r - 1) * (c - 1) : r * c - 1);
    });
  }
  ttest(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("T.TEST"), (dataX, dataY, tails, type) => {
      const arrX = this.arithmeticHelper.manyToExactNumbers(dataX.valuesFromTopLeftCorner());
      const arrY = this.arithmeticHelper.manyToExactNumbers(dataY.valuesFromTopLeftCorner());
      if (arrX instanceof CellError) {
        return arrX;
      }
      if (arrY instanceof CellError) {
        return arrY;
      }
      const n2 = arrX.length;
      const m = arrY.length;
      if (type === 1) {
        if (m !== n2) {
          return new CellError(ErrorType.NA, ErrorMessage.EqualLength);
        }
        if (n2 <= 1) {
          return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
        }
        const sub2 = Array(n2);
        for (let i = 0; i < n2; i++) {
          sub2[i] = arrX[i] - arrY[i];
        }
        const s = stdev(sub2, true);
        if (s === 0) {
          return new CellError(ErrorType.DIV_BY_ZERO);
        }
        const t = Math.abs(Math.sqrt(n2) * mean(sub2) / s);
        return tails * (1 - studentt.cdf(t, n2 - 1));
      } else if (type === 2) {
        if (n2 <= 1 || m <= 1) {
          return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
        }
        const s = (sumsqerr(arrX) + sumsqerr(arrY)) / (n2 + m - 2);
        if (s === 0) {
          return new CellError(ErrorType.DIV_BY_ZERO);
        }
        const t = Math.abs((mean(arrX) - mean(arrY)) / Math.sqrt(s * (1 / n2 + 1 / m)));
        return tails * (1 - studentt.cdf(t, n2 + m - 2));
      } else {
        if (n2 <= 1 || m <= 1) {
          return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.TwoValues);
        }
        const sx = variance(arrX, true);
        const sy = variance(arrY, true);
        if (sx === 0 && sy === 0) {
          return new CellError(ErrorType.DIV_BY_ZERO);
        }
        const t = Math.abs((mean(arrX) - mean(arrY)) / Math.sqrt(sx / n2 + sy / m));
        const v = Math.pow(sx / n2 + sy / m, 2) / (Math.pow(sx / n2, 2) / (n2 - 1) + Math.pow(sy / m, 2) / (m - 1));
        return tails * (1 - studentt.cdf(t, v));
      }
    });
  }
  skew(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SKEW"), (...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      const n2 = coerced.length;
      if (n2 < 3) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.ThreeValues);
      }
      const avg = mean(coerced);
      const s = stdev(coerced, true);
      if (s === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return coerced.reduce((a, b) => a + Math.pow((b - avg) / s, 3), 0) * n2 / (n2 - 1) / (n2 - 2);
    });
  }
  skewp(ast, state) {
    return this.runFunction(ast.args, state, this.metadata("SKEW.P"), (...args) => {
      const coerced = this.arithmeticHelper.coerceNumbersExactRanges(args);
      if (coerced instanceof CellError) {
        return coerced;
      }
      const n2 = coerced.length;
      if (n2 < 3) {
        return new CellError(ErrorType.DIV_BY_ZERO, ErrorMessage.ThreeValues);
      }
      const avg = mean(coerced);
      const s = stdev(coerced, false);
      if (s === 0) {
        return new CellError(ErrorType.DIV_BY_ZERO);
      }
      return coerced.reduce((a, b) => a + Math.pow((b - avg) / s, 3), 0) / n2;
    });
  }
}
StatisticalAggregationPlugin.implementedFunctions = {
  "AVEDEV": {
    method: "avedev",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "DEVSQ": {
    method: "devsq",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "GEOMEAN": {
    method: "geomean",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "HARMEAN": {
    method: "harmean",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "CORREL": {
    method: "correl",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "RSQ": {
    method: "rsq",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "COVARIANCE.P": {
    method: "covariancep",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "COVARIANCE.S": {
    method: "covariances",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "Z.TEST": {
    method: "ztest",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.NUMBER
    }, {
      argumentType: FunctionArgumentType.NUMBER,
      optionalArg: true
    }]
  },
  "F.TEST": {
    method: "ftest",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "STEYX": {
    method: "steyx",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "SLOPE": {
    method: "slope",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "CHISQ.TEST": {
    method: "chisqtest",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }]
  },
  "T.TEST": {
    method: "ttest",
    parameters: [{
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.RANGE
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1,
      maxValue: 2
    }, {
      argumentType: FunctionArgumentType.INTEGER,
      minValue: 1,
      maxValue: 3
    }]
  },
  "SKEW": {
    method: "skew",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  },
  "SKEW.P": {
    method: "skewp",
    parameters: [{
      argumentType: FunctionArgumentType.ANY
    }],
    repeatLastArgs: 1
  }
};
StatisticalAggregationPlugin.aliases = {
  COVAR: "COVARIANCE.P",
  FTEST: "F.TEST",
  PEARSON: "CORREL",
  ZTEST: "Z.TEST",
  CHITEST: "CHISQ.TEST",
  TTEST: "T.TEST",
  COVARIANCEP: "COVARIANCE.P",
  COVARIANCES: "COVARIANCE.S",
  SKEWP: "SKEW.P"
};
function parseTwoArrays(dataX, dataY) {
  const xit = dataX.iterateValuesFromTopLeftCorner();
  const yit = dataY.iterateValuesFromTopLeftCorner();
  let x, y;
  const arrX = [];
  const arrY = [];
  while (x = xit.next(), y = yit.next(), !x.done && !y.done) {
    const xval = x.value;
    const yval = y.value;
    if (xval instanceof CellError) {
      return xval;
    } else if (yval instanceof CellError) {
      return yval;
    } else if (isExtendedNumber(xval) && isExtendedNumber(yval)) {
      arrX.push(getRawValue(xval));
      arrY.push(getRawValue(yval));
    }
  }
  return [arrX, arrY];
}
const plugins = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbsPlugin,
  AddressPlugin,
  ArrayPlugin,
  BitShiftPlugin,
  BitwiseLogicOperationsPlugin,
  BooleanPlugin,
  CharPlugin,
  CodePlugin,
  ComplexPlugin,
  ConditionalAggregationPlugin,
  CountBlankPlugin,
  CountUniquePlugin,
  DatabasePlugin,
  DateTimePlugin,
  DegreesPlugin,
  DeltaPlugin,
  ExpPlugin,
  FinancialPlugin,
  FormulaTextPlugin,
  HyperlinkPlugin,
  InformationPlugin,
  IsEvenPlugin,
  IsOddPlugin,
  LogarithmPlugin,
  LookupPlugin,
  MathConstantsPlugin,
  MathPlugin,
  MatrixPlugin,
  MedianPlugin,
  ModuloPlugin,
  NumericAggregationPlugin,
  PercentilePlugin,
  PowerPlugin,
  RadiansPlugin,
  RadixConversionPlugin,
  RandomPlugin,
  RomanPlugin,
  RoundingPlugin,
  SequencePlugin,
  SimpleArithmerticPlugin,
  SqrtPlugin,
  StatisticalAggregationPlugin,
  StatisticalPlugin,
  SumprodPlugin,
  TextPlugin,
  TrigonometryPlugin
}, Symbol.toStringTag, { value: "Module" }));
class HyperFormulaNS extends HyperFormula {
}
HyperFormulaNS.HyperFormula = HyperFormula;
HyperFormulaNS.ErrorType = ErrorType;
HyperFormulaNS.CellError = CellError;
HyperFormulaNS.CellType = CellType;
HyperFormulaNS.CellValueType = CellValueType;
HyperFormulaNS.CellValueDetailedType = CellValueDetailedType;
HyperFormulaNS.DetailedCellError = DetailedCellError;
HyperFormulaNS.ExportedCellChange = ExportedCellChange;
HyperFormulaNS.ExportedNamedExpressionChange = ExportedNamedExpressionChange;
HyperFormulaNS.ConfigValueTooBigError = ConfigValueTooBigError;
HyperFormulaNS.ConfigValueTooSmallError = ConfigValueTooSmallError;
HyperFormulaNS.EvaluationSuspendedError = EvaluationSuspendedError;
HyperFormulaNS.ExpectedOneOfValuesError = ExpectedOneOfValuesError;
HyperFormulaNS.ExpectedValueOfTypeError = ExpectedValueOfTypeError;
HyperFormulaNS.ArraySize = ArraySize;
HyperFormulaNS.SimpleRangeValue = SimpleRangeValue;
HyperFormulaNS.EmptyValue = EmptyValue;
HyperFormulaNS.FunctionPlugin = FunctionPlugin;
HyperFormulaNS.FunctionArgumentType = FunctionArgumentType;
HyperFormulaNS.FunctionPluginValidationError = FunctionPluginValidationError;
HyperFormulaNS.InvalidAddressError = InvalidAddressError;
HyperFormulaNS.InvalidArgumentsError = InvalidArgumentsError;
HyperFormulaNS.LanguageNotRegisteredError = LanguageNotRegisteredError;
HyperFormulaNS.LanguageAlreadyRegisteredError = LanguageAlreadyRegisteredError;
HyperFormulaNS.MissingTranslationError = MissingTranslationError;
HyperFormulaNS.NamedExpressionDoesNotExistError = NamedExpressionDoesNotExistError;
HyperFormulaNS.NamedExpressionNameIsAlreadyTakenError = NamedExpressionNameIsAlreadyTakenError;
HyperFormulaNS.NamedExpressionNameIsInvalidError = NamedExpressionNameIsInvalidError;
HyperFormulaNS.NoOperationToRedoError = NoOperationToRedoError;
HyperFormulaNS.NoOperationToUndoError = NoOperationToUndoError;
HyperFormulaNS.NoRelativeAddressesAllowedError = NoRelativeAddressesAllowedError;
HyperFormulaNS.NoSheetWithIdError = NoSheetWithIdError;
HyperFormulaNS.NoSheetWithNameError = NoSheetWithNameError;
HyperFormulaNS.NotAFormulaError = NotAFormulaError;
HyperFormulaNS.NothingToPasteError = NothingToPasteError;
HyperFormulaNS.ProtectedFunctionTranslationError = ProtectedFunctionTranslationError;
HyperFormulaNS.SheetNameAlreadyTakenError = SheetNameAlreadyTakenError;
HyperFormulaNS.SheetSizeLimitExceededError = SheetSizeLimitExceededError;
HyperFormulaNS.SourceLocationHasArrayError = SourceLocationHasArrayError;
HyperFormulaNS.TargetLocationHasArrayError = TargetLocationHasArrayError;
HyperFormulaNS.UnableToParseError = UnableToParseError;
const defaultLanguage = Config.defaultConfig.language;
HyperFormula.registerLanguage(defaultLanguage, dictionary);
HyperFormula.languages[dictionary.langCode] = dictionary;
for (const pluginName of Object.getOwnPropertyNames(plugins)) {
  if (!pluginName.startsWith("_")) {
    HyperFormula.registerFunctionPlugin(plugins[pluginName]);
  }
}
const SHORTCUTS_GROUP$h = "handsontableEditor";
const EDITOR_TYPE$b = "handsontable";
class HandsontableEditor extends TextEditor {
  /**
  * Returns the unique editor type identifier for the Handsontable editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$b;
  }
  /**
  * Opens the editor and adjust its size.
  */
  open() {
    super.open();
    const containerStyle = this.htContainer.style;
    if (this.htEditor) {
      this.htEditor.rootPortalElement = null;
      this.htEditor.destroy();
      containerStyle.width = "";
      containerStyle.height = "";
      containerStyle.overflow = "";
    }
    if (containerStyle.display === "none") {
      containerStyle.display = "";
    }
    this.htEditor = new this.hot.constructor(this.htContainer, this.htOptions);
    this.htEditor.rootPortalElement = this.hot.rootPortalElement;
    this.htEditor.init();
    this.htEditor.rootElement.style.display = "";
    if (this.cellProperties.strict) {
      this.htEditor.selectCell(0, 0);
    } else {
      this.htEditor.deselectCell();
    }
    setCaretPosition(this.TEXTAREA, 0, this.TEXTAREA.value.length);
    this.htEditor.updateSettings({
      width: this.getTargetDropdownWidth(),
      height: this.getTargetDropdownHeight()
    });
    this.refreshDimensions();
    this.flipDropdownVerticallyIfNeeded();
    this.flipDropdownHorizontallyIfNeeded();
  }
  /**
  * Closes the editor.
  */
  close() {
    if (this.htEditor) {
      this.htEditor.rootElement.style.display = "none";
    }
    this.removeHooksByKey("beforeKeyDown");
    super.close();
  }
  /**
  * Prepares editor's meta data and configuration of the internal Handsontable's instance.
  *
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number|string} prop The column property (passed when datasource is an array of objects).
  * @param {HTMLTableCellElement} td The rendered cell element.
  * @param {*} value The rendered value.
  * @param {object} cellProperties The cell meta object (see {@link Core#getCellMeta}).
  */
  prepare(row, col, prop, td, value, cellProperties) {
    super.prepare(row, col, prop, td, value, cellProperties);
    const { hot } = this;
    const setValue = this.setValue.bind(this);
    const options = {
      startRows: 0,
      startCols: 0,
      minRows: 0,
      minCols: 0,
      className: "listbox",
      copyPaste: false,
      autoColumnSize: false,
      autoRowSize: false,
      readOnly: true,
      fillHandle: false,
      autoWrapCol: false,
      autoWrapRow: false,
      ariaTags: false,
      themeName: this.hot.getCurrentThemeName(),
      afterOnCellMouseDown(_, coords) {
        if (coords.row < 0 || coords.col < 0) {
          return;
        }
        const sourceValue = this.getDataAtCell(coords.row, coords.col);
        if (sourceValue !== void 0) {
          setValue(sourceValue);
        }
        hot.destroyEditor();
      },
      preventWheel: true,
      layoutDirection: this.hot.isRtl() ? "rtl" : "ltr"
    };
    if (this.cellProperties.handsontable) {
      extend(options, cellProperties.handsontable);
    }
    this.htOptions = options;
  }
  /**
  * Begins editing on a highlighted cell and hides fillHandle corner if was present.
  *
  * @param {*} newInitialValue The editor initial value.
  * @param {*} event The keyboard event object.
  */
  beginEditing(newInitialValue, event) {
    const onBeginEditing = this.hot.getSettings().onBeginEditing;
    if (onBeginEditing && onBeginEditing() === false) {
      return;
    }
    super.beginEditing(newInitialValue, event);
  }
  /**
  * Creates an editor's elements and adds necessary CSS classnames.
  */
  createElements() {
    super.createElements();
    const DIV = this.hot.rootDocument.createElement("DIV");
    DIV.className = "handsontableEditor";
    this.TEXTAREA_PARENT.appendChild(DIV);
    this.htContainer = DIV;
    this.assignHooks();
  }
  /**
  * Finishes editing and start saving or restoring process for editing cell or last selected range.
  *
  * @param {boolean} restoreOriginalValue If true, then closes editor without saving value from the editor into a cell.
  * @param {boolean} ctrlDown If true, then saveValue will save editor's value to each cell in the last selected range.
  * @param {Function} callback The callback function, fired after editor closing.
  */
  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    if (this.htEditor && this.htEditor.isListening()) {
      this.hot.listen();
    }
    if (this.htEditor && this.htEditor.getSelectedActive()) {
      const value = this.htEditor.getValue();
      if (value !== void 0) {
        this.setValue(value);
      }
    }
    super.finishEditing(restoreOriginalValue, ctrlDown, callback);
  }
  /**
  * Calculates the space above and below the editor and flips it vertically if needed.
  *
  * @private
  * @returns {{ isFlipped: boolean, spaceAbove: number, spaceBelow: number}}
  */
  flipDropdownVerticallyIfNeeded() {
    const { view } = this.hot;
    const cellRect = this.getEditedCellRect();
    if (!cellRect) {
      return {
        isFlipped: false,
        spaceAbove: 0,
        spaceBelow: 0
      };
    }
    let spaceAbove = cellRect.top;
    if (view.isVerticallyScrollableByWindow()) {
      const topOffset = view.getTableOffset().top - this.hot.rootWindow.scrollY;
      spaceAbove = Math.max(spaceAbove + topOffset, 0);
    }
    const dropdownTargetHeight = this.getDropdownHeight();
    const spaceBelow = view.getWorkspaceHeight() - spaceAbove - cellRect.height;
    const flipNeeded = dropdownTargetHeight > spaceBelow && spaceAbove > spaceBelow + cellRect.height;
    if (flipNeeded) {
      this.flipDropdownVertically();
    } else {
      this.unflipDropdownVertically();
    }
    return {
      isFlipped: flipNeeded,
      spaceAbove,
      spaceBelow
    };
  }
  /**
  * Adjusts the editor's container to flip vertically, positioning it from
  * the bottom to the top of the edited cell.
  *
  * @private
  */
  flipDropdownVertically() {
    const dropdownStyle = this.htEditor.rootElement.style;
    dropdownStyle.position = "absolute";
    dropdownStyle.top = `${-this.getDropdownHeight()}px`;
    this.isFlippedVertically = true;
  }
  /**
  * Adjusts the editor's container to unflip vertically, positioning it from
  * the top to the bottom of the edited cell.
  *
  * @private
  */
  unflipDropdownVertically() {
    const dropdownStyle = this.htEditor.rootElement.style;
    dropdownStyle.position = "absolute";
    dropdownStyle.top = "";
    this.isFlippedVertically = false;
  }
  /**
  * Calculates the space above and below the editor and flips it vertically if needed.
  *
  * @private
  * @returns {{ isFlipped: boolean, spaceInlineStart: number, spaceInlineEnd: number}}
  */
  flipDropdownHorizontallyIfNeeded() {
    const { view } = this.hot;
    const cellRect = this.getEditedCellRect();
    if (!cellRect) {
      return {
        isFlipped: false,
        spaceInlineStart: 0,
        spaceInlineEnd: 0
      };
    }
    let spaceInlineStart = cellRect.start + cellRect.width;
    let workspaceWidth = view.getWorkspaceWidth();
    if (view.isHorizontallyScrollableByWindow()) {
      const inlineStartOffset = view.getTableOffset().left - this.hot.rootWindow.scrollX;
      spaceInlineStart = Math.max(spaceInlineStart + inlineStartOffset, 0);
      workspaceWidth = this.hot.rootDocument.documentElement.clientWidth;
    }
    const dropdownTargetWidth = this.getDropdownWidth();
    const spaceInlineEnd = workspaceWidth - spaceInlineStart + cellRect.width;
    const flipNeeded = dropdownTargetWidth > spaceInlineEnd && spaceInlineStart > spaceInlineEnd;
    if (flipNeeded) {
      this.flipDropdownHorizontally();
    } else {
      this.unflipDropdownHorizontally();
    }
    return {
      isFlipped: flipNeeded,
      spaceInlineStart,
      spaceInlineEnd
    };
  }
  /**
  * Adjusts the editor's container to flip horizontally, positioning it from
  * the inline end (right) to the inline start (left) of the edited cell.
  *
  * @private
  */
  flipDropdownHorizontally() {
    const dropdownStyle = this.htEditor.rootElement.style;
    const { width } = this.getEditedCellRect() ?? {
      width: 0
    };
    dropdownStyle.position = "absolute";
    dropdownStyle[this.hot.isRtl() ? "right" : "left"] = `${-(this.getDropdownWidth() - width)}px`;
    this.isFlippedHorizontally = true;
  }
  /**
  * Adjusts the editor's container to unflip horizontally, positioning it from
  * the inline start (left) to the inline end (right) of the edited cell.
  *
  * @private
  */
  unflipDropdownHorizontally() {
    const dropdownStyle = this.htEditor.rootElement.style;
    dropdownStyle.position = "absolute";
    dropdownStyle[this.hot.isRtl() ? "right" : "left"] = "";
    this.isFlippedHorizontally = false;
  }
  /**
  * Return the DOM height of the editor's container.
  *
  * @returns {number}
  */
  getDropdownHeight() {
    return this.htEditor.getTableHeight();
  }
  /**
  * Return the DOM width of the editor's container.
  *
  * @returns {number}
  */
  getDropdownWidth() {
    return this.htEditor.getTableWidth();
  }
  /**
  * Calculates the proposed/target editor width that should be set once the editor is opened.
  * The method may be overwritten in the child class to provide a custom size logic.
  *
  * @returns {number}
  */
  getTargetDropdownWidth() {
    return this.htEditor.view.getTableWidth();
  }
  /**
  * Calculates the proposed/target editor height that should be set once the editor is opened.
  * The method may be overwritten in the child class to provide a custom size logic.
  *
  * @returns {number}
  */
  getTargetDropdownHeight() {
    return this.htEditor.view.getTableHeight() + 1;
  }
  /**
  * Assigns afterDestroy callback to prevent memory leaks.
  *
  * @private
  */
  assignHooks() {
    this.hot.addHook("afterDestroy", () => {
      if (this.htEditor) {
        this.htEditor.rootPortalElement = null;
        this.htEditor.destroy();
      }
    });
    this.hot.addHook("afterSetTheme", (themeName, firstRun) => {
      if (!firstRun) {
        this.close();
      }
    });
  }
  /**
  * Register shortcuts responsible for handling editor.
  *
  * @private
  */
  registerShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const editorContext = shortcutManager.getContext("editor");
    super.registerShortcuts();
    const contextConfig = {
      group: SHORTCUTS_GROUP$h,
      relativeToGroup: EDITOR_EDIT_GROUP,
      position: "before"
    };
    const action = (rowToSelect, event) => {
      const innerHOT = this.htEditor;
      if (rowToSelect !== void 0) {
        if (rowToSelect < 0 || this.isFlippedVertically && rowToSelect > innerHOT.countRows() - 1) {
          innerHOT.deselectCell();
        } else {
          innerHOT.selectCell(rowToSelect, 0);
        }
        if (innerHOT.getData().length) {
          event.preventDefault();
          stopImmediatePropagation(event);
          this.hot.listen();
          this.TEXTAREA.focus();
          return false;
        }
      }
    };
    editorContext.addShortcuts([
      {
        keys: [
          [
            "ArrowUp"
          ]
        ],
        callback: (event) => {
          const innerHOT = this.htEditor;
          let rowToSelect;
          let selectedRow;
          if (!innerHOT.getSelectedActive() && this.isFlippedVertically) {
            rowToSelect = innerHOT.countRows() - 1;
          } else if (innerHOT.getSelectedActive()) {
            const active = innerHOT.getSelectedActive();
            if (this.isFlippedVertically) {
              selectedRow = active[0];
              rowToSelect = Math.max(0, selectedRow - 1);
            } else {
              selectedRow = active[0];
              rowToSelect = selectedRow - 1;
            }
          }
          return action(rowToSelect, event);
        },
        preventDefault: false
      },
      {
        keys: [
          [
            "ArrowDown"
          ]
        ],
        callback: (event) => {
          const innerHOT = this.htEditor;
          let rowToSelect;
          let selectedRow;
          if (!innerHOT.getSelectedActive() && !this.isFlippedVertically) {
            rowToSelect = 0;
          } else if (innerHOT.getSelectedActive()) {
            const active = innerHOT.getSelectedActive();
            if (this.isFlippedVertically) {
              rowToSelect = active[0] + 1;
            } else if (!this.isFlippedVertically) {
              const lastRow = innerHOT.countRows() - 1;
              selectedRow = active[0];
              rowToSelect = Math.min(lastRow, selectedRow + 1);
            }
          }
          return action(rowToSelect, event);
        },
        preventDefault: false
      }
    ], contextConfig);
  }
  /**
  * Unregister shortcuts responsible for handling editor.
  *
  * @private
  */
  unregisterShortcuts() {
    super.unregisterShortcuts();
    const shortcutManager = this.hot.getShortcutManager();
    const editorContext = shortcutManager.getContext("editor");
    editorContext.removeShortcutsByGroup(SHORTCUTS_GROUP$h);
  }
  constructor(...args) {
    super(...args), /**
    * The flag determining if the editor is flipped vertically (rendered on
    * the top of the edited cell) or not.
    *
    * @type {boolean}
    */
    this.isFlippedVertically = false, /**
    * The flag determining if the editor is flipped horizontally (rendered on
    * the inline start of the edited cell) or not.
    *
    * @type {boolean}
    */
    this.isFlippedHorizontally = false;
  }
}
function _check_private_redeclaration$1d(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$12(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$12(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$12(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$12(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$12(receiver, privateMap, "get");
  return _class_apply_descriptor_get$12(receiver, descriptor);
}
function _class_private_field_init$12(obj, privateMap, value) {
  _check_private_redeclaration$1d(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$12(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$12(receiver, privateMap, "set");
  _class_apply_descriptor_set$12(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$R(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$R(obj, privateSet) {
  _check_private_redeclaration$1d(obj, privateSet);
  privateSet.add(obj);
}
const EDITOR_TYPE$a = "autocomplete";
var _idPrefix = /* @__PURE__ */ new WeakMap(), _focusDebounced = /* @__PURE__ */ new WeakMap(), _fixDropdownWidth = /* @__PURE__ */ new WeakSet(), _isKeyValueObject = /* @__PURE__ */ new WeakSet();
class AutocompleteEditor extends HandsontableEditor {
  /**
  * Returns the unique editor type identifier for the autocomplete editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$a;
  }
  /**
  * Gets current value from editable element.
  *
  * @returns {string}
  */
  getValue() {
    const selectedValue = this.rawChoices.find((value) => {
      const strippedValue = this.stripValueIfNeeded(value);
      const resolvedValue = _class_private_method_get$R(this, _isKeyValueObject, isKeyValueObject1).call(this, strippedValue) ? strippedValue.value : strippedValue;
      return resolvedValue === this.TEXTAREA.value;
    });
    if (isDefined(selectedValue)) {
      return selectedValue;
    }
    return this.TEXTAREA.value;
  }
  /**
  * Creates an editor's elements and adds necessary CSS classnames.
  */
  createElements() {
    super.createElements();
    addClass(this.htContainer, "autocompleteEditor");
    addClass(this.htContainer, this.hot.rootWindow.navigator.platform.indexOf("Mac") === -1 ? "" : "htMacScroll");
    if (this.hot.getSettings().ariaTags) {
      setAttribute(this.TEXTAREA, [
        A11Y_TEXT(),
        A11Y_COMBOBOX(),
        A11Y_HASPOPUP("listbox"),
        A11Y_AUTOCOMPLETE()
      ]);
    }
  }
  /**
  * Prepares editor's metadata and configuration of the internal Handsontable's instance.
  *
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number|string} prop The column property (passed when datasource is an array of objects).
  * @param {HTMLTableCellElement} td The rendered cell element.
  * @param {*} value The rendered value.
  * @param {object} cellProperties The cell meta object (see {@link Core#getCellMeta}).
  */
  prepare(row, col, prop, td, value, cellProperties) {
    super.prepare(row, col, prop, td, value, cellProperties);
    if (this.hot.getSettings().ariaTags) {
      setAttribute(this.TEXTAREA, [
        A11Y_EXPANDED("false"),
        A11Y_CONTROLS(`${_class_private_field_get$12(this, _idPrefix)}-listbox-${row}-${col}`)
      ]);
    }
    this.htOptions = {
      ...this.htOptions,
      valueGetter: (cellValue) => _class_private_method_get$R(this, _isKeyValueObject, isKeyValueObject1).call(this, cellValue) ? cellValue.value : cellValue
    };
  }
  /**
  * Opens the editor and adjust its size and internal Handsontable's instance.
  */
  open() {
    super.open();
    const trimDropdownSetting = this.cellProperties.trimDropdown;
    const trimDropdown = trimDropdownSetting === void 0 ? true : trimDropdownSetting;
    const rootInstanceAriaTagsEnabled = this.hot.getSettings().ariaTags;
    const sourceArray = Array.isArray(this.cellProperties.source) ? this.cellProperties.source : null;
    const sourceSize = sourceArray?.length;
    const { row: rowIndex, col: colIndex } = this;
    this.showEditableElement();
    this.focus();
    this.addHook("beforeKeyDown", (event) => this.onBeforeKeyDown(event));
    this.htEditor.addHook("afterScroll", _class_private_field_get$12(this, _focusDebounced));
    this.htEditor.updateSettings({
      colWidths: trimDropdown ? [
        outerWidth(this.TEXTAREA) - 2
      ] : void 0,
      autoColumnSize: true,
      renderer: (hotInstance, TD, row, col, prop, value, cellProperties) => {
        textRenderer(hotInstance, TD, row, col, prop, value, cellProperties);
        const { filteringCaseSensitive, allowHtml } = this.cellProperties;
        const locale = this.cellProperties.locale;
        const query = this.query;
        const cellValue = stringify$1(value);
        if (allowHtml) {
          TD.innerHTML = cellValue;
        } else if (cellValue && query && query.length > 0) {
          const indexOfMatch = filteringCaseSensitive === true ? cellValue.indexOf(query) : localeLowerCase(cellValue, locale).indexOf(localeLowerCase(query, locale));
          if (indexOfMatch !== -1) {
            const match = cellValue.slice(indexOfMatch, indexOfMatch + query.length);
            const { rootDocument } = hotInstance;
            TD.innerHTML = "";
            TD.appendChild(rootDocument.createTextNode(cellValue.slice(0, indexOfMatch)));
            const strong = rootDocument.createElement("strong");
            strong.textContent = match;
            TD.appendChild(strong);
            TD.appendChild(rootDocument.createTextNode(cellValue.slice(indexOfMatch + query.length)));
          }
        }
        if (rootInstanceAriaTagsEnabled) {
          setAttribute(TD, [
            A11Y_OPTION(),
            // Add `setsize` and `posinset` only if the source is an array.
            ...sourceArray ? [
              A11Y_SETSIZE(sourceSize ?? 0)
            ] : [],
            ...sourceArray ? [
              A11Y_POSINSET(sourceArray.indexOf(value) + 1)
            ] : [],
            [
              "id",
              `${this.htEditor.rootElement.id}_${row}-${col}`
            ]
          ]);
        }
      },
      afterSelectionEnd: (startRow, startCol) => {
        if (rootInstanceAriaTagsEnabled) {
          const setA11yAttributes = (TD2) => {
            setAttribute(TD2, [
              A11Y_SELECTED()
            ]);
            setAttribute(this.TEXTAREA, ...A11Y_ACTIVEDESCENDANT(TD2.id));
          };
          const TD = this.htEditor.getCell(startRow, startCol, true);
          if (TD !== null) {
            setA11yAttributes(TD);
          } else {
            this.htEditor.addHookOnce("afterScrollVertically", () => {
              const renderedTD = this.htEditor.getCell(startRow, startCol, true);
              if (renderedTD !== null) {
                setA11yAttributes(renderedTD);
              }
            });
          }
        }
      }
    });
    if (rootInstanceAriaTagsEnabled) {
      const a11yPres = A11Y_PRESENTATION();
      setAttribute(this.htEditor.view._wt.wtOverlays.wtTable.TABLE, a11yPres[0], a11yPres[1]);
      setAttribute(this.htEditor.rootElement, [
        A11Y_LISTBOX(),
        A11Y_LIVE("polite"),
        A11Y_RELEVANT("text"),
        [
          "id",
          `${_class_private_field_get$12(this, _idPrefix)}-listbox-${rowIndex}-${colIndex}`
        ]
      ]);
      setAttribute(this.TEXTAREA, ...A11Y_EXPANDED("true"));
    }
    this.hot._registerTimeout(() => {
      this.queryChoices(this.TEXTAREA.value);
    });
  }
  /**
  * Closes the editor.
  */
  close() {
    this.removeHooksByKey("beforeKeyDown");
    super.close();
    if (this.hot.getSettings().ariaTags) {
      setAttribute(this.TEXTAREA, [
        A11Y_EXPANDED("false")
      ]);
    }
  }
  /**
  * Verifies result of validation or closes editor if user's cancelled changes.
  *
  * @param {boolean|undefined} result If `false` and the cell using allowInvalid option,
  *                                   then an editor won't be closed until validation is passed.
  */
  discardEditor(result) {
    super.discardEditor(result);
    this.hot.view.render();
  }
  /**
  * Prepares choices list based on applied argument.
  *
  * @param {string} query The query.
  */
  queryChoices(query) {
    const source = this.cellProperties.source;
    this.query = query;
    if (typeof source === "function") {
      source.call(this.cellProperties, query, (choices) => {
        this.rawChoices = choices;
        this.updateChoicesList(this.stripValuesIfNeeded(choices));
      });
    } else if (Array.isArray(source)) {
      this.rawChoices = source;
      this.updateChoicesList(this.stripValuesIfNeeded(source));
    } else {
      this.updateChoicesList([]);
    }
  }
  /**
  * Updates list of the possible completions to choose.
  *
  * @param {Array} choicesList The choices list to process.
  */
  updateChoicesList(choicesList) {
    const pos = getCaretPosition(this.TEXTAREA);
    const endPos = getSelectionEndPosition(this.TEXTAREA);
    const sortByRelevanceSetting = this.cellProperties.sortByRelevance;
    const filterSetting = this.cellProperties.filter;
    const value = this.stripValueIfNeeded(this.getValue());
    const comparableValue = _class_private_method_get$R(this, _isKeyValueObject, isKeyValueObject1).call(this, value) ? value.value : value;
    let highlightIndex = null;
    let choices = choicesList;
    if (!sortByRelevanceSetting) {
      choices = choices.toSorted((a, b) => stringify$1(a).localeCompare(stringify$1(b)));
    }
    const filteredChoiceIndexes = [];
    const locale = this.cellProperties.locale;
    const filteringCaseSensitive = this.cellProperties.filteringCaseSensitive;
    const valueToMatch = filteringCaseSensitive ? comparableValue : localeLowerCase(String(comparableValue), locale);
    for (let i = 0; i < choices.length; i++) {
      const currentItem = _class_private_method_get$R(this, _isKeyValueObject, isKeyValueObject1).call(this, choices[i]) ? stripTags(stringify$1(choices[i].value)) : stripTags(stringify$1(choices[i]));
      const itemToMatch = filteringCaseSensitive ? currentItem : localeLowerCase(currentItem, locale);
      if (itemToMatch.indexOf(String(valueToMatch)) !== -1) {
        filteredChoiceIndexes.push(i);
        if (filterSetting === false) {
          break;
        }
      }
    }
    if (filterSetting === false) {
      if (String(value).length > 0) {
        highlightIndex = filteredChoiceIndexes[0];
      }
    } else {
      choices = filteredChoiceIndexes.map((index2) => choices[index2]);
      highlightIndex = choices.indexOf(valueToMatch) > -1 ? choices.indexOf(valueToMatch) : 0;
    }
    this.strippedChoices = choices;
    if (choices.length === 0) {
      this.htEditor.rootElement.style.display = "none";
    } else {
      this.htEditor.rootElement.style.display = "";
    }
    this.htEditor.loadData(pivot([
      choices
    ]));
    if (choices.length > 0) {
      this.updateDropdownDimensions();
      this.flipDropdownVerticallyIfNeeded();
      this.flipDropdownHorizontallyIfNeeded();
      if (this.cellProperties.strict === true) {
        this.highlightBestMatchingChoice(highlightIndex ?? void 0);
      }
    }
    this.hot.listen();
    setCaretPosition(this.TEXTAREA, pos, pos === endPos ? void 0 : endPos);
  }
  /**
  * Calculates the space above and below the editor and flips it vertically if needed.
  *
  * @private
  * @returns {{ isFlipped: boolean, spaceAbove: number, spaceBelow: number}}
  */
  flipDropdownVerticallyIfNeeded() {
    const result = super.flipDropdownVerticallyIfNeeded();
    const { isFlipped, spaceAbove, spaceBelow } = result;
    this.limitDropdownIfNeeded(isFlipped ? spaceAbove : spaceBelow);
    return result;
  }
  /**
  * Checks if the internal table should generate scrollbar or could be rendered without it.
  *
  * @private
  * @param {number} spaceAvailable The free space as height defined in px available for dropdown list.
  */
  limitDropdownIfNeeded(spaceAvailable) {
    const dropdownHeight = this.getDropdownHeight();
    if (dropdownHeight > spaceAvailable) {
      let tempHeight = 0;
      let lastRowHeight = 0;
      let height = 0;
      do {
        lastRowHeight = this.htEditor.stylesHandler.getDefaultRowHeight() ?? 0;
        tempHeight += lastRowHeight;
      } while (tempHeight < spaceAvailable);
      height = tempHeight - lastRowHeight;
      if (this.isFlippedVertically) {
        this.htEditor.rootElement.style.top = `${parseInt(this.htEditor.rootElement.style.top, 10) + dropdownHeight - height}px`;
      }
      this.setDropdownHeight(tempHeight - lastRowHeight);
    }
  }
  /**
  * Updates width and height of the internal Handsontable's instance.
  *
  * @private
  */
  updateDropdownDimensions() {
    const fractionalScalingCompensation = getFractionalScalingCompensation();
    const targetWidth = this.getTargetEditorWidth() + fractionalScalingCompensation;
    const targetHeight = this.getTargetEditorHeight() + fractionalScalingCompensation;
    this.htEditor.updateSettings({
      width: targetWidth,
      height: targetHeight
    });
    _class_private_method_get$R(this, _fixDropdownWidth, fixDropdownWidth).call(this);
    this.htEditor.view._wt.wtTable.alignOverlaysWithTrimmingContainer();
  }
  /**
  * Sets new height of the internal Handsontable's instance.
  *
  * @private
  * @param {number} height The new dropdown height.
  */
  setDropdownHeight(height) {
    this.htEditor.updateSettings({
      height
    });
    _class_private_method_get$R(this, _fixDropdownWidth, fixDropdownWidth).call(this);
    this.htEditor.view._wt.wtTable.alignOverlaysWithTrimmingContainer();
  }
  /**
  * Creates new selection on specified row index, or deselects selected cells.
  *
  * @private
  * @param {number|undefined} index The visual row index.
  */
  highlightBestMatchingChoice(index2) {
    if (typeof index2 === "number") {
      this.htEditor.selectCell(index2, 0, void 0, void 0, void 0, false);
    } else {
      this.htEditor.deselectCell();
    }
  }
  /**
  * Calculates the proposed/target editor height that should be set once the editor is opened.
  * The method may be overwritten in the child class to provide a custom size logic.
  *
  * @returns {number}
  */
  getTargetEditorHeight() {
    let borderCompensation = 0;
    if (!this.hot.getCurrentThemeName()) {
      const htCoreElement = this.htContainer.querySelector(".htCore");
      if (htCoreElement) {
        const containerStyle = this.hot.rootWindow.getComputedStyle(htCoreElement);
        borderCompensation = parseInt(containerStyle.borderTopWidth, 10) + parseInt(containerStyle.borderBottomWidth, 10);
      }
    }
    const maxItems = Math.min(this.cellProperties.visibleRows, this.strippedChoices.length);
    const height = Array.from({
      length: maxItems
    }, (_, i) => i).reduce((totalHeight, index2) => {
      const rowHeight = (this.hot.stylesHandler.getDefaultRowHeight() ?? 0) + (index2 === 0 ? 1 : 0);
      return totalHeight + rowHeight;
    }, 0);
    return height + borderCompensation;
  }
  /**
  * Calculates the proposed/target editor width that should be set once the editor is opened.
  * The method may be overwritten in the child class to provide a custom size logic.
  *
  * @returns {number}
  */
  getTargetEditorWidth() {
    let borderCompensation = 0;
    if (!this.hot.getCurrentThemeName()) {
      const htCoreElement = this.htContainer.querySelector(".htCore");
      if (htCoreElement) {
        const containerStyle = this.hot.rootWindow.getComputedStyle(htCoreElement);
        borderCompensation = parseInt(containerStyle.borderInlineStartWidth, 10) + parseInt(containerStyle.borderInlineEndWidth, 10);
      }
    }
    return this.htEditor.getColWidth(0) + borderCompensation;
  }
  /**
  * Sanitizes value from potential dangerous tags.
  *
  * @private
  * @param {string} value The value to sanitize.
  * @returns {string}
  */
  stripValueIfNeeded(value) {
    return this.stripValuesIfNeeded([
      value
    ])[0];
  }
  /**
  * Sanitizes an array of the values from potential dangerous tags.
  *
  * @private
  * @param {string[]} values The value to sanitize.
  * @returns {Array<string|{key: string, value: string}>}
  */
  stripValuesIfNeeded(values2) {
    const { allowHtml } = this.cellProperties;
    const processValue = (value) => stringify$1(allowHtml ? value : stripTags(String(value)));
    if (values2.every((value) => isKeyValueObject(value))) {
      return values2.map((value) => {
        const obj = value;
        return {
          key: processValue(obj.key),
          value: processValue(obj.value)
        };
      });
    }
    return values2.map((value) => processValue(value));
  }
  /**
  * OnBeforeKeyDown callback.
  *
  * @private
  * @param {KeyboardEvent} event The keyboard event object.
  */
  onBeforeKeyDown(event) {
    if (isPrintableChar(event.keyCode) || event.keyCode === KEY_CODES.BACKSPACE || event.keyCode === KEY_CODES.DELETE || event.keyCode === KEY_CODES.INSERT) {
      let timeOffset = 10;
      if (event.keyCode === KEY_CODES.C && (event.ctrlKey || event.metaKey)) {
        return;
      }
      if (!this.isOpened()) {
        timeOffset += 10;
      }
      if (this.htEditor) {
        this.hot._registerTimeout(() => {
          this.queryChoices(this.TEXTAREA.value);
        }, timeOffset);
      }
    }
  }
  constructor(...args) {
    super(...args), _class_private_method_init$R(this, _fixDropdownWidth), _class_private_method_init$R(this, _isKeyValueObject), _class_private_field_init$12(this, _idPrefix, {
      writable: true,
      value: void 0
    }), _class_private_field_init$12(this, _focusDebounced, {
      writable: true,
      value: void 0
    }), /**
    * Query string to turn available values over.
    *
    * @type {string}
    */
    this.query = null, /**
    * Contains stripped choices.
    *
    * @type {string[]}
    */
    this.strippedChoices = [], /**
    * Contains raw choices.
    *
    * @type {Array}
    */
    this.rawChoices = [], _class_private_field_set$12(this, _idPrefix, this.hot.guid.slice(0, 9)), _class_private_field_set$12(this, _focusDebounced, debounce(() => {
      this.focus();
    }, 100));
  }
}
function fixDropdownWidth() {
  if (this.htEditor.view.hasVerticalScroll()) {
    this.htEditor.updateSettings({
      width: this.getTargetEditorWidth() + getScrollbarWidth(this.hot.rootDocument)
    });
  }
}
function isKeyValueObject1(value) {
  const rec = value;
  return isObject$1(value) && isDefined(rec.key) && isDefined(rec.value);
}
const EDITOR_TYPE$9 = "checkbox";
class CheckboxEditor extends BaseEditor {
  /**
  * Returns the unique editor type identifier for the checkbox editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$9;
  }
  /**
  * Handles the mouseup event on the cell TD element to trigger a checkbox click via a double-click interaction.
  */
  beginEditing(initialValue, event) {
    if (event && event.type === "mouseup" && eventTargetEl(event).nodeName === "TD") {
      const checkbox = this.TD.querySelector('input[type="checkbox"]');
      if (!hasClass(checkbox, "htBadValue")) {
        checkbox.click();
      }
    }
  }
  /**
  * No-op override — the checkbox editor does not perform a finish step.
  */
  finishEditing() {
  }
  /**
  * No-op override — the checkbox editor requires no DOM initialization.
  */
  init() {
  }
  /**
  * No-op override — the checkbox editor has no visible editing element to open.
  */
  open() {
  }
  /**
  * No-op override — the checkbox editor has no visible editing element to close.
  */
  close() {
  }
  /**
  * Returns undefined because checkbox state is written directly to the cell; no separate value is held.
  */
  getValue() {
    return void 0;
  }
  /**
  * No-op override — the checkbox editor writes its value directly via DOM events.
  */
  setValue() {
  }
  /**
  * No-op override — the checkbox editor delegates focus to the native checkbox element.
  */
  focus() {
  }
}
const ISO_DATE_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
function parseToLocalDate(value) {
  if (isEmpty$1(value)) {
    return null;
  }
  if (typeof value === "string" && ISO_DATE_REGEX.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return null;
}
function isValidISODate(value) {
  if (typeof value !== "string" || !ISO_DATE_REGEX.test(value)) {
    return false;
  }
  const date = new Date(value);
  return !Number.isNaN(date.getTime()) && value === date.toISOString().slice(0, 10);
}
const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d)(?:\.(\d{1,3}))?)?$/;
function parseToLocalTime(value) {
  if (isEmpty$1(value)) {
    return null;
  }
  if (typeof value !== "string") {
    return null;
  }
  const match = TIME_REGEX.exec(value);
  if (!match) {
    return null;
  }
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = match[3] !== void 0 ? Number(match[3]) : 0;
  const msString = match[4];
  const milliseconds = msString !== void 0 ? Number(msString.padEnd(3, "0").slice(0, 3)) : 0;
  return new Date(1970, 0, 1, hours, minutes, seconds, milliseconds);
}
function isValidTime(value) {
  return typeof value === "string" && TIME_REGEX.test(value);
}
function getTodayLocalDate() {
  const now = /* @__PURE__ */ new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}
function getRelativeLocalDate(days) {
  const result = getTodayLocalDate();
  result.setDate(result.getDate() + days);
  return result;
}
function isSameLocalDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
const EDITOR_TYPE$8 = "date";
class DateEditor extends TextEditor {
  /**
  * Returns the unique editor type identifier for the date editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$8;
  }
  /**
  * Initializes the editor and registers an afterSetTheme hook to close on theme changes.
  */
  init() {
    super.init();
    this.hot.addHook("afterSetTheme", (themeName, firstRun) => {
      if (!firstRun) {
        this.close();
      }
    });
  }
  /**
  * Prepares the editor, replacing the display value with the raw ISO source data for the native date input.
  */
  prepare(row, col, prop, td, value, cellProperties) {
    super.prepare(row, col, prop, td, value, cellProperties);
    if (cellProperties.datePickerConfig !== void 0) {
      warnOnce(this.hot.rootElement, "datePickerConfig", 'The "datePickerConfig" option is not supported. The native date input is used instead of Pikaday.');
    }
    const physicalRow = this.hot.toPhysicalRow(row);
    this.originalValue = this.hot.getSourceDataAtCell(physicalRow, col);
  }
  /**
  * Creates the editor's textarea element as a native date input.
  */
  createElements(type) {
    super.createElements("input");
    this.TEXTAREA.setAttribute("type", "date");
  }
  /**
  * Sets the editor value, falling back to `defaultDate` when the value is empty, and warns if the value is not a valid ISO date string.
  */
  setValue(value) {
    if (isEmpty$1(value)) {
      value = this.cellProperties.defaultDate;
    }
    if (!isValidISODate(value)) {
      warn$1(toSingleLine`DateEditor: value must be in ISO date format ("YYYY-MM-DD")\x20
        required by the native date input. Received:`, value);
      super.setValue("");
      return;
    }
    super.setValue(value);
  }
  /**
  * Selects all text in the date input element when the editor receives focus.
  */
  focus() {
    this.TEXTAREA.select();
  }
  /**
  * Opens the editor and programmatically invokes the native date picker via showPicker().
  */
  open() {
    super.open();
    try {
      this.TEXTAREA.showPicker();
    } catch {
    }
  }
}
const EDITOR_TYPE$7 = "dropdown";
class DropdownEditor extends AutocompleteEditor {
  /**
  * Returns the unique editor type identifier for the dropdown editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$7;
  }
  /**
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number|string} prop The column property (passed when datasource is an array of objects).
  * @param {HTMLTableCellElement} td The rendered cell element.
  * @param {*} value The rendered value.
  * @param {object} cellProperties The cell meta object (see {@link Core#getCellMeta}).
  */
  prepare(row, col, prop, td, value, cellProperties) {
    cellProperties.filter = false;
    cellProperties.strict = true;
    super.prepare(row, col, prop, td, value, cellProperties);
  }
  /**
  * Finishes editing and start saving or restoring process for editing cell or last selected range.
  *
  * @param {boolean} restoreOriginalValue If true, then closes editor without saving value from the editor into a cell.
  * @param {boolean} ctrlDown If true, then saveValue will save editor's value to each cell in the last selected range.
  * @param {Function} callback The callback function, fired after editor closing.
  */
  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    if (this.isOpened()) {
      const lastSelectedRange = this.hot.getSelectedRangeActive();
      if (isUndefined$1(lastSelectedRange) || isDefined(lastSelectedRange) && !lastSelectedRange.includes(this.hot._createCellCoords(this.row, this.col))) {
        restoreOriginalValue = true;
      }
    }
    super.finishEditing(restoreOriginalValue, ctrlDown, callback);
  }
}
const EDITOR_TYPE$6 = "intl-date";
class IntlDateEditor extends DateEditor {
  /**
  * Returns the unique editor type identifier for the intl-date editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$6;
  }
}
const EDITOR_TYPE$5 = "time";
class TimeEditor extends TextEditor {
  /**
  * Returns the unique editor type identifier for the time editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$5;
  }
  /**
  * Initializes the editor and registers an afterSetTheme hook to close on theme changes.
  */
  init() {
    super.init();
    this.hot.addHook("afterSetTheme", (themeName, firstRun) => {
      if (!firstRun) {
        this.close();
      }
    });
  }
  /**
  * Creates the editor's textarea element as a native time input.
  */
  createElements(type) {
    super.createElements("input");
    this.TEXTAREA.setAttribute("type", "time");
    this.TEXTAREA.setAttribute("dir", "ltr");
  }
  /**
  * Sets the editor value and warns if the value does not match the 24-hour time format required by the native time input.
  */
  setValue(value) {
    if (!isValidTime(value)) {
      warn$1(toSingleLine`TimeEditor: value must be in 24-hour time format ("HH:mm", "HH:mm:ss" or "HH:mm:ss.SSS")\x20
        required by the native time input. Received:`, value);
      super.setValue("");
      return;
    }
    super.setValue(value);
  }
  /**
  * Selects all text in the time input element when the editor receives focus.
  */
  focus() {
    this.TEXTAREA.select();
  }
  /**
  * Opens the editor and programmatically invokes the native time picker via showPicker().
  */
  open() {
    super.open();
    try {
      this.TEXTAREA.showPicker();
    } catch {
    }
  }
}
const EDITOR_TYPE$4 = "intl-time";
class IntlTimeEditor extends TimeEditor {
  /**
  * Returns the unique editor type identifier for the intl-time editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$4;
  }
}
const EDITOR_TYPE$3 = "numeric";
class NumericEditor extends TextEditor {
  /**
  * Returns the unique editor type identifier for the numeric editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$3;
  }
}
function _check_private_redeclaration$1c(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$11(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$11(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$11(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$11(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$11(receiver, privateMap, "get");
  return _class_apply_descriptor_get$11(receiver, descriptor);
}
function _class_private_field_init$11(obj, privateMap, value) {
  _check_private_redeclaration$1c(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$11(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$11(receiver, privateMap, "set");
  _class_apply_descriptor_set$11(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$Q(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$Q(obj, privateSet) {
  _check_private_redeclaration$1c(obj, privateSet);
  privateSet.add(obj);
}
const EDITOR_TYPE$2 = "password";
var _realValue = /* @__PURE__ */ new WeakMap(), _revealTimer = /* @__PURE__ */ new WeakMap(), _onInput$1 = /* @__PURE__ */ new WeakMap(), _inRevealMode = /* @__PURE__ */ new WeakMap(), _handleRevealInput = /* @__PURE__ */ new WeakSet();
class PasswordEditor extends TextEditor {
  /**
  * @returns {string}
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$2;
  }
  /**
  * Creates the editor's DOM elements. Replaces the `<textarea>` from `TextEditor` with an
  * `<input type="password">` element so that the browser masks its content natively.
  */
  createElements() {
    super.createElements();
    this.TEXTAREA = this.hot.rootDocument.createElement("input");
    this.TEXTAREA.setAttribute("type", "password");
    this.TEXTAREA.dataset.hotInput = "";
    this.TEXTAREA.className = "handsontableInput";
    this.textareaStyle = this.TEXTAREA.style;
    this.textareaStyle.width = "0";
    this.textareaStyle.height = "0";
    empty$1(this.TEXTAREA_PARENT);
    const tabIndexAttr = A11Y_TABINDEX(-1);
    this.TEXTAREA.setAttribute(tabIndexAttr[0], String(tabIndexAttr[1]));
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA);
  }
  /**
  * Opens the editor. When `hashRevealDelay` is set, switches the input to `type="text"` and
  * installs a manual masking handler so each typed character is briefly visible before being
  * replaced by `hashSymbol`.
  */
  open() {
    super.open();
    const hashRevealDelay = this.cellProperties.hashRevealDelay;
    const hashSymbol = String(this.cellProperties.hashSymbol || "*");
    if (hashRevealDelay > 0) {
      _class_private_field_set$11(this, _inRevealMode, true);
      const maskChar = hashSymbol[0];
      this.TEXTAREA.setAttribute("type", "text");
      this.TEXTAREA.setAttribute("autocomplete", "off");
      this.TEXTAREA.setAttribute("spellcheck", "false");
      this.TEXTAREA.setAttribute("autocapitalize", "off");
      this.TEXTAREA.setAttribute("autocorrect", "off");
      this.TEXTAREA.value = maskChar.repeat(_class_private_field_get$11(this, _realValue).length);
      _class_private_field_set$11(this, _onInput$1, (event) => _class_private_method_get$Q(this, _handleRevealInput, handleRevealInput).call(this, event, maskChar, hashRevealDelay));
      this.TEXTAREA.addEventListener("input", _class_private_field_get$11(this, _onInput$1));
    }
  }
  /**
  * Closes the editor. Removes the input event listener, cancels any pending reveal timer,
  * resets reveal-mode state, and restores the input to `type="password"`.
  */
  close() {
    if (_class_private_field_get$11(this, _onInput$1)) {
      this.TEXTAREA.removeEventListener("input", _class_private_field_get$11(this, _onInput$1));
      _class_private_field_set$11(this, _onInput$1, null);
    }
    if (_class_private_field_get$11(this, _revealTimer) !== null) {
      clearTimeout(_class_private_field_get$11(this, _revealTimer));
      _class_private_field_set$11(this, _revealTimer, null);
    }
    _class_private_field_set$11(this, _inRevealMode, false);
    _class_private_field_set$11(this, _realValue, "");
    this.TEXTAREA.setAttribute("type", "password");
    this.TEXTAREA.removeAttribute("autocomplete");
    this.TEXTAREA.removeAttribute("spellcheck");
    this.TEXTAREA.removeAttribute("autocapitalize");
    this.TEXTAREA.removeAttribute("autocorrect");
    super.close();
  }
  /**
  * Returns the current editor value. In reveal-delay mode returns the real (unmasked) value
  * stored in `#realValue` rather than reading the input's display value, which may contain
  * hash symbols.
  *
  * @returns {string}
  */
  getValue() {
    if (_class_private_field_get$11(this, _inRevealMode)) {
      return _class_private_field_get$11(this, _realValue);
    }
    return super.getValue();
  }
  /**
  * Sets the editor value. In reveal-delay mode stores the plain value in `#realValue` and
  * updates the input display with masked characters. When called from `beginEditing()` before
  * `open()` has set `#inRevealMode`, pre-populates `#realValue` so `open()` can mask it
  * immediately on display.
  *
  * @param {string} [value] The value to set.
  */
  setValue(value) {
    if (_class_private_field_get$11(this, _inRevealMode)) {
      _class_private_field_set$11(this, _realValue, value ?? "");
      const maskChar = String(this.cellProperties.hashSymbol || "*")[0];
      this.TEXTAREA.value = maskChar.repeat(_class_private_field_get$11(this, _realValue).length);
    } else if (this.cellProperties?.hashRevealDelay > 0) {
      _class_private_field_set$11(this, _realValue, value ?? "");
    } else {
      super.setValue(value);
    }
  }
  constructor(...args) {
    super(...args), _class_private_method_init$Q(this, _handleRevealInput), _class_private_field_init$11(this, _realValue, {
      writable: true,
      value: void 0
    }), _class_private_field_init$11(this, _revealTimer, {
      writable: true,
      value: void 0
    }), _class_private_field_init$11(this, _onInput$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$11(this, _inRevealMode, {
      writable: true,
      value: void 0
    }), /**
    * Autoresize instance for resizing the editor to the size of the entered text. Its overwrites the default
    * resizer of the TextEditor.
    *
    * @private
    * @type {Function}
    */
    this.autoResize = createInputElementResizer(this.hot.rootDocument, {
      textContent: (element) => "•".repeat(element.value.length)
    }), _class_private_field_set$11(this, _realValue, ""), _class_private_field_set$11(this, _revealTimer, null), _class_private_field_set$11(this, _onInput$1, null), _class_private_field_set$11(this, _inRevealMode, false);
  }
}
function handleRevealInput(event, maskChar, delay) {
  const { inputType, data } = event;
  const isInsertWithData = data && (inputType === "insertText" || inputType === "insertFromPaste" || inputType === "insertFromDrop" || inputType === "insertReplacementText" || inputType === "insertCompositionText");
  if (isInsertWithData) {
    const cursorAfter = this.TEXTAREA.selectionStart ?? 0;
    const insertionStart = cursorAfter - data.length;
    const maskedSuffix = this.TEXTAREA.value.length - cursorAfter;
    _class_private_field_set$11(this, _realValue, _class_private_field_get$11(this, _realValue).slice(0, insertionStart) + data + _class_private_field_get$11(this, _realValue).slice(_class_private_field_get$11(this, _realValue).length - maskedSuffix));
    this.TEXTAREA.value = maskChar.repeat(insertionStart) + data + maskChar.repeat(maskedSuffix);
    this.TEXTAREA.setSelectionRange(cursorAfter, cursorAfter);
    if (_class_private_field_get$11(this, _revealTimer) !== null) {
      clearTimeout(_class_private_field_get$11(this, _revealTimer));
    }
    _class_private_field_set$11(this, _revealTimer, this.hot._registerTimeout(() => {
      const cursor = this.TEXTAREA.selectionStart;
      this.TEXTAREA.value = maskChar.repeat(_class_private_field_get$11(this, _realValue).length);
      this.TEXTAREA.setSelectionRange(cursor, cursor);
      _class_private_field_set$11(this, _revealTimer, null);
    }, delay));
  } else if (inputType?.startsWith("delete")) {
    const prevRealLength = _class_private_field_get$11(this, _realValue).length;
    const cursorAfter = this.TEXTAREA.selectionStart ?? 0;
    const deletedCount = prevRealLength - this.TEXTAREA.value.length;
    _class_private_field_set$11(this, _realValue, _class_private_field_get$11(this, _realValue).slice(0, cursorAfter) + _class_private_field_get$11(this, _realValue).slice(cursorAfter + deletedCount));
    this.TEXTAREA.value = maskChar.repeat(_class_private_field_get$11(this, _realValue).length);
    this.TEXTAREA.setSelectionRange(cursorAfter, cursorAfter);
    if (_class_private_field_get$11(this, _revealTimer) !== null) {
      clearTimeout(_class_private_field_get$11(this, _revealTimer));
      _class_private_field_set$11(this, _revealTimer, null);
    }
  } else {
    const prevLength = _class_private_field_get$11(this, _realValue).length;
    const displayValue = this.TEXTAREA.value;
    if (displayValue.length > prevLength) {
      const newChars = displayValue.slice(prevLength);
      _class_private_field_set$11(this, _realValue, _class_private_field_get$11(this, _realValue) + newChars);
      this.TEXTAREA.value = maskChar.repeat(prevLength) + newChars;
      if (_class_private_field_get$11(this, _revealTimer) !== null) {
        clearTimeout(_class_private_field_get$11(this, _revealTimer));
      }
      _class_private_field_set$11(this, _revealTimer, this.hot._registerTimeout(() => {
        this.TEXTAREA.value = maskChar.repeat(_class_private_field_get$11(this, _realValue).length);
        _class_private_field_set$11(this, _revealTimer, null);
      }, delay));
    } else {
      _class_private_field_set$11(this, _realValue, _class_private_field_get$11(this, _realValue).slice(0, displayValue.length));
      this.TEXTAREA.value = maskChar.repeat(_class_private_field_get$11(this, _realValue).length);
      if (_class_private_field_get$11(this, _revealTimer) !== null) {
        clearTimeout(_class_private_field_get$11(this, _revealTimer));
        _class_private_field_set$11(this, _revealTimer, null);
      }
    }
  }
}
const EDITOR_VISIBLE_CLASS_NAME$1 = "ht_editor_visible";
const SHORTCUTS_GROUP$g = "selectEditor";
const EDITOR_TYPE$1 = "select";
class SelectEditor extends BaseEditor {
  /**
  * Returns the unique editor type identifier for the select editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE$1;
  }
  /**
  * Initializes editor instance, DOM Element and mount hooks.
  */
  init() {
    this.selectWrapper = this.hot.rootDocument.createElement("div");
    this.select = this.hot.rootDocument.createElement("select");
    this.select.dataset.hotInput = "true";
    this.selectWrapper.style.display = "none";
    const ARROW = this.hot.rootDocument.createElement("DIV");
    const isAriaEnabled = this.hot.getSettings().ariaTags;
    ARROW.className = "htAutocompleteArrow";
    if (isAriaEnabled) {
      ARROW.setAttribute(...A11Y_HIDDEN());
    }
    ARROW.appendChild(this.hot.rootDocument.createTextNode(String.fromCharCode(9660)));
    addClass(this.selectWrapper, "htSelectEditor");
    this.selectWrapper.appendChild(this.select);
    this.selectWrapper.insertBefore(ARROW, this.selectWrapper.firstChild);
    this.hot.rootElement.appendChild(this.selectWrapper);
    this.registerHooks();
    this.hot.addHookOnce("afterDestroy", () => this.destroy());
  }
  /**
  * Returns select's value.
  *
  * @returns {*}
  */
  getValue() {
    return this.select.value;
  }
  /**
  * Sets value in the select element.
  *
  * @param {*} value A new select's value.
  */
  setValue(value) {
    this.select.value = value === null || value === void 0 ? "" : String(value);
  }
  /**
  * Opens the editor and adjust its size.
  */
  open() {
    this._opened = true;
    this.refreshDimensions();
    this.selectWrapper.style.display = "";
    const shortcutManager = this.hot.getShortcutManager();
    shortcutManager.setActiveContextName("editor");
    this.registerShortcuts();
  }
  /**
  * Closes the editor.
  */
  close() {
    this._opened = false;
    this.selectWrapper.style.display = "none";
    if (hasClass(this.selectWrapper, EDITOR_VISIBLE_CLASS_NAME$1)) {
      removeClass(this.selectWrapper, EDITOR_VISIBLE_CLASS_NAME$1);
    }
    this.unregisterShortcuts();
    this.removeHooksByKey("beforeDialogShow");
  }
  /**
  * Sets focus state on the select element.
  */
  focus() {
    this.select.focus();
  }
  /**
  * Binds hooks to refresh editor's size after scrolling of the viewport or resizing of columns/rows.
  *
  * @private
  */
  registerHooks() {
    this.addHook("afterScrollHorizontally", () => this.refreshDimensions());
    this.addHook("afterScrollVertically", () => this.refreshDimensions());
    this.addHook("afterColumnResize", () => this.refreshDimensions());
    this.addHook("afterRowResize", () => this.refreshDimensions());
  }
  /**
  * Prepares editor's meta data and a list of available options.
  *
  * @param {number} row The visual row index.
  * @param {number} col The visual column index.
  * @param {number|string} prop The column property (passed when datasource is an array of objects).
  * @param {HTMLTableCellElement} td The rendered cell element.
  * @param {*} value The rendered value.
  * @param {object} cellProperties The cell meta object (see {@link Core#getCellMeta}).
  */
  prepare(row, col, prop, td, value, cellProperties) {
    super.prepare(row, col, prop, td, value, cellProperties);
    const selectOptions = this.cellProperties.selectOptions;
    let options;
    if (typeof selectOptions === "function") {
      options = this.prepareOptions(selectOptions(this.row, this.col, this.prop));
    } else {
      options = this.prepareOptions(selectOptions);
    }
    empty$1(this.select);
    const { sanitizer } = this.hot.getSettings();
    if (Array.isArray(options)) {
      for (let i = 0; i < options.length; i++) {
        const optionElement = this.hot.rootDocument.createElement("OPTION");
        optionElement.value = String(options[i]);
        fastInnerHTML(optionElement, String(options[i]), sanitizer, "selectEditor", this.hot.rootElement);
        this.select.appendChild(optionElement);
      }
    } else {
      objectEach(options, (optionValue, key) => {
        const optionElement = this.hot.rootDocument.createElement("OPTION");
        optionElement.value = key;
        fastInnerHTML(optionElement, String(optionValue), sanitizer, "selectEditor", this.hot.rootElement);
        this.select.appendChild(optionElement);
      });
    }
  }
  /**
  * Creates consistent list of available options.
  *
  * @private
  * @param {Array|object} optionsToPrepare The list of the values to render in the select element.
  * @returns {Array|object}
  */
  prepareOptions(optionsToPrepare) {
    if (Array.isArray(optionsToPrepare)) {
      return optionsToPrepare;
    }
    if (typeof optionsToPrepare === "object") {
      return optionsToPrepare;
    }
    return {};
  }
  /**
  * Refreshes editor's value using source data.
  *
  * @private
  */
  refreshValue() {
    const sourceData = this.hot.getSourceDataAtCell(this.row, this.prop);
    this.originalValue = sourceData;
    this.setValue(sourceData);
    this.refreshDimensions();
  }
  /**
  * Refreshes editor's size and position.
  *
  * @private
  */
  refreshDimensions() {
    if (this.state !== EDITOR_STATE.EDITING) {
      return;
    }
    this.TD = this.getEditedCell();
    if (!this.TD) {
      this.close();
      return;
    }
    const cellRect = this.getEditedCellRect();
    if (!cellRect) {
      return;
    }
    const { top: top2, start, width, height } = cellRect;
    const selectStyle = this.selectWrapper.style;
    selectStyle.height = `${height}px`;
    selectStyle.width = `${width}px`;
    selectStyle.top = `${top2}px`;
    selectStyle[this.hot.isRtl() ? "right" : "left"] = `${start}px`;
    selectStyle.margin = "0px";
    addClass(this.selectWrapper, EDITOR_VISIBLE_CLASS_NAME$1);
  }
  /**
  * Register shortcuts responsible for handling editor.
  *
  * @private
  */
  registerShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const editorContext = shortcutManager.getContext("editor");
    const contextConfig = {
      group: SHORTCUTS_GROUP$g
    };
    if (this.isInFullEditMode()) {
      editorContext.addShortcuts([
        {
          keys: [
            [
              "ArrowUp"
            ]
          ],
          callback: () => {
            const previousOptionIndex = this.select.selectedIndex - 1;
            if (previousOptionIndex >= 0) {
              this.select[previousOptionIndex].selected = true;
            }
          }
        },
        {
          keys: [
            [
              "ArrowDown"
            ]
          ],
          callback: () => {
            const nextOptionIndex = this.select.selectedIndex + 1;
            if (nextOptionIndex <= this.select.length - 1) {
              this.select[nextOptionIndex].selected = true;
            }
          }
        }
      ], contextConfig);
    }
  }
  /**
  * Unregister shortcuts responsible for handling editor.
  *
  * @private
  */
  unregisterShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const editorContext = shortcutManager.getContext("editor");
    editorContext.removeShortcutsByGroup(SHORTCUTS_GROUP$g);
  }
  /**
  * Clears all attached hooks.
  *
  * @private
  */
  destroy() {
    this.clearHooks();
  }
}
function getCheckboxElement(itemElement) {
  return itemElement.querySelector('input[type="checkbox"]');
}
function parseStringifiedValue(value) {
  return typeof value === "string" && isJSON(value) ? JSON.parse(value) : value;
}
function getValuesIntersection(valuesArray, source) {
  return getIntersectionOfArrays(valuesArray, source, (a, b) => JSON.stringify(a) === JSON.stringify(b));
}
function includesValue(array, element) {
  if (isKeyValueObject(element)) {
    return Array.isArray(array) && array.some((value) => {
      return isKeyValueObject(value) ? isObjectEqual(value, element) : value === element;
    });
  }
  return array.includes(element);
}
function _check_private_redeclaration$1b(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$P(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$P(obj, privateSet) {
  _check_private_redeclaration$1b(obj, privateSet);
  privateSet.add(obj);
}
var _triggerFilter = /* @__PURE__ */ new WeakSet();
class InputController {
  /**
  * Returns the underlying `<input>` element managed by this controller.
  */
  getInputElement() {
    return this.input;
  }
  /**
  * Writes the given string into the input element's value property without firing a DOM input event.
  */
  setValue(value) {
    this.input.value = value;
  }
  /**
  * Enables or disables the input controller: passes `true` to start listening for input events,
  * `false` to stop.
  */
  toggle(enabled) {
    this.enabled = enabled;
    if (this.input) {
      if (enabled) {
        this.listen();
      } else {
        this.unlisten();
      }
    }
  }
  /**
  * Registers the native `input` event listener on the managed element so that typing triggers `triggerFilter`.
  */
  listen() {
    this.eventManager.addEventListener(this.input, "input", this.onInput);
  }
  /**
  * Removes the previously registered `input` event listener from the managed element.
  */
  unlisten() {
    this.eventManager.removeEventListener(this.input, "input", this.onInput);
  }
  /**
  * Handles the native input event and delegates to the internal filter trigger.
  */
  _onInput() {
    _class_private_method_get$P(this, _triggerFilter, triggerFilter).call(this, this.input.value);
  }
  /**
  * Wires the given input element and event manager, and enables the controller immediately.
  */
  constructor({ input, eventManager }) {
    _class_private_method_init$P(this, _triggerFilter);
    this.onInput = this._onInput.bind(this);
    this.input = input;
    this.eventManager = eventManager;
    this.enabled = true;
  }
}
function triggerFilter(value) {
  this.runLocalHooks("triggerFilter", value);
}
mixin(InputController, localHooks);
const classPrefix = "ht-multi-select-editor";
const SEARCH_INPUT_WRAPPER_CLASS = `${classPrefix}-search-input-wrapper`;
const SEARCH_ICON_CLASS = `${classPrefix}-search-icon`;
const SEARCH_INPUT_CLASS = `${classPrefix}-search-input`;
const SEPARATOR_CLASS = `${classPrefix}-separator`;
const SEARCH_INPUT_PLACEHOLDER = "Search...";
const SEARCH_INPUT_ARIA_LABEL = "Search options";
const CHECKBOX_ID_PREFIX = `${classPrefix}-item-`;
const SELECTED_ITEM_CLASS = `${classPrefix}-item-selected`;
function selectItem(itemElement) {
  const checkbox = getCheckboxElement(itemElement);
  addClass(itemElement, SELECTED_ITEM_CLASS);
  if (checkbox && !checkbox.checked) {
    checkbox.checked = true;
  }
}
function deselectItem(itemElement) {
  const checkbox = getCheckboxElement(itemElement);
  removeClass(itemElement, SELECTED_ITEM_CLASS);
  if (checkbox && checkbox.checked) {
    checkbox.checked = false;
  }
}
function createSearchInputWrapper({ root }) {
  const wrapperElement = root.createElement("div");
  wrapperElement.className = SEARCH_INPUT_WRAPPER_CLASS;
  return wrapperElement;
}
function createSearchIcon({ root }) {
  const iconElement = root.createElement("div");
  addClass(iconElement, SEARCH_ICON_CLASS);
  setAttribute(iconElement, [
    A11Y_HIDDEN()
  ]);
  return iconElement;
}
function createSearchInputElement({ root }) {
  const inputElement = root.createElement("input");
  setAttribute(inputElement, [
    A11Y_LABEL(SEARCH_INPUT_ARIA_LABEL),
    [
      "type",
      "text"
    ],
    [
      "size",
      3
    ],
    [
      "placeholder",
      SEARCH_INPUT_PLACEHOLDER
    ],
    [
      "id",
      SEARCH_INPUT_CLASS
    ]
  ]);
  addClass(inputElement, SEARCH_INPUT_CLASS);
  return inputElement;
}
function createSeparatorElement({ root }) {
  const separatorElement = root.createElement("div");
  separatorElement.className = SEPARATOR_CLASS;
  return separatorElement;
}
function createListElement({ root }) {
  return root.createElement("ul");
}
function getDropdownWidth({ dropdownListElement }) {
  return dropdownListElement.offsetWidth;
}
function deselectAllItems({ dropdownListElement }) {
  dropdownListElement.querySelectorAll(`.${SELECTED_ITEM_CLASS}`).forEach((itemElement) => deselectItem(itemElement));
}
function defocusItem({ dropdownListElement, index: index2 }) {
  const itemElement = dropdownListElement.children[index2];
  if (itemElement) {
    const checkbox = getCheckboxElement(itemElement);
    if (checkbox) {
      checkbox.blur();
    }
  }
}
function focusItemAt({ dropdownListElement, index: index2 }) {
  const itemElement = dropdownListElement.children[index2];
  if (itemElement) {
    const checkbox = getCheckboxElement(itemElement);
    if (checkbox) {
      checkbox.focus();
    }
  }
}
function disableUncheckedCheckboxes({ dropdownListElement }) {
  dropdownListElement.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach((checkbox) => {
    checkbox.dataset.disabled = "true";
  });
}
function enableAllCheckboxes({ dropdownListElement }) {
  dropdownListElement.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
    checkbox.dataset.disabled = "false";
  });
}
function createListItemElement({ rootDocument, instanceId, itemKey, itemValue, indexWithinList, checked = false, disabled = false }) {
  const itemElement = rootDocument.createElement("li");
  const innerContainer = rootDocument.createElement("div");
  const checkboxElement = rootDocument.createElement("input");
  const labelElement = rootDocument.createElement("label");
  checkboxElement.id = `${instanceId}-${CHECKBOX_ID_PREFIX}${indexWithinList}`;
  checkboxElement.type = "checkbox";
  checkboxElement.dataset.value = itemValue;
  checkboxElement.dataset.index = String(indexWithinList);
  checkboxElement.dataset.disabled = disabled && !checked ? "true" : "false";
  if (itemKey) {
    checkboxElement.dataset.key = itemKey;
  }
  labelElement.htmlFor = checkboxElement.id;
  labelElement.textContent = itemValue;
  innerContainer.appendChild(checkboxElement);
  innerContainer.appendChild(labelElement);
  itemElement.appendChild(innerContainer);
  return itemElement;
}
function _check_private_redeclaration$1a(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$10(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$10(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$10(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$10(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$10(receiver, privateMap, "get");
  return _class_apply_descriptor_get$10(receiver, descriptor);
}
function _class_private_field_init$10(obj, privateMap, value) {
  _check_private_redeclaration$1a(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$10(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$10(receiver, privateMap, "set");
  _class_apply_descriptor_set$10(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$O(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$O(obj, privateSet) {
  _check_private_redeclaration$1a(obj, privateSet);
  privateSet.add(obj);
}
var _instanceId = /* @__PURE__ */ new WeakMap(), _containerElement = /* @__PURE__ */ new WeakMap(), _dropdownListElement = /* @__PURE__ */ new WeakMap(), _searchInputElement = /* @__PURE__ */ new WeakMap(), _separatorElement = /* @__PURE__ */ new WeakMap(), _searchInputWrapper = /* @__PURE__ */ new WeakMap(), _inputController = /* @__PURE__ */ new WeakMap(), _rootDocument$2 = /* @__PURE__ */ new WeakMap(), _eventManager = /* @__PURE__ */ new WeakMap(), _cache = /* @__PURE__ */ new WeakMap(), _focusItem = /* @__PURE__ */ new WeakSet(), _requiresFlippingVertically = /* @__PURE__ */ new WeakSet(), _toggleVerticalFlip = /* @__PURE__ */ new WeakSet(), _getEntryHeight = /* @__PURE__ */ new WeakSet(), _getListHeight = /* @__PURE__ */ new WeakSet(), _getSearchInputWrapperHeight = /* @__PURE__ */ new WeakSet(), _addDropdownItem = /* @__PURE__ */ new WeakSet(), _registerEvents$1 = /* @__PURE__ */ new WeakSet(), _unregisterEvents = /* @__PURE__ */ new WeakSet(), _resetCache = /* @__PURE__ */ new WeakSet();
class DropdownController {
  /**
  * Builds required DOM elements and inserts them into the container.
  */
  init() {
    if (!_class_private_field_get$10(this, _rootDocument$2) || !_class_private_field_get$10(this, _containerElement)) {
      return;
    }
    _class_private_field_set$10(this, _dropdownListElement, createListElement({
      root: _class_private_field_get$10(this, _rootDocument$2)
    }));
    _class_private_field_set$10(this, _searchInputElement, createSearchInputElement({
      root: _class_private_field_get$10(this, _rootDocument$2)
    }));
    const searchIcon = createSearchIcon({
      root: _class_private_field_get$10(this, _rootDocument$2)
    });
    _class_private_field_set$10(this, _searchInputWrapper, createSearchInputWrapper({
      root: _class_private_field_get$10(this, _rootDocument$2)
    }));
    _class_private_field_set$10(this, _separatorElement, createSeparatorElement({
      root: _class_private_field_get$10(this, _rootDocument$2)
    }));
    _class_private_field_get$10(this, _searchInputWrapper).appendChild(searchIcon);
    _class_private_field_get$10(this, _searchInputWrapper).appendChild(_class_private_field_get$10(this, _searchInputElement));
    _class_private_field_get$10(this, _containerElement).appendChild(_class_private_field_get$10(this, _searchInputWrapper));
    _class_private_field_get$10(this, _containerElement).appendChild(_class_private_field_get$10(this, _separatorElement));
    _class_private_field_get$10(this, _containerElement).appendChild(_class_private_field_get$10(this, _dropdownListElement));
    _class_private_field_set$10(this, _inputController, new InputController({
      input: _class_private_field_get$10(this, _searchInputElement),
      eventManager: _class_private_field_get$10(this, _eventManager)
    }));
  }
  /**
  * Stores the maximum number of visible rows used when constraining the dropdown's rendered height.
  */
  setVisibleRowsNumberSetting(visibleRowsNumber) {
    _class_private_field_get$10(this, _cache).visibleRowsNumberSetting = visibleRowsNumber;
  }
  /**
  * Stores a comparator function applied to the source entries before rendering; pass null to remove sorting.
  */
  setSourceSortFunction(sourceSortFunction) {
    _class_private_field_get$10(this, _cache).sourceSortFunction = sourceSortFunction ?? null;
  }
  /**
  * Shows or hides the search input and separator elements and toggles the input controller's listener.
  */
  setSearchInputVisibility(searchInput = true) {
    if (!_class_private_field_get$10(this, _searchInputWrapper) || !_class_private_field_get$10(this, _separatorElement) || !_class_private_field_get$10(this, _inputController)) {
      return;
    }
    _class_private_field_get$10(this, _searchInputWrapper).style.display = searchInput ? "" : "none";
    _class_private_field_get$10(this, _separatorElement).style.display = searchInput ? "" : "none";
    _class_private_field_get$10(this, _inputController).toggle(searchInput);
  }
  /**
  * Populates the dropdown with provided entries and marks selected ones.
  *
  * @param {string[]|object[]} entries Collection of primitive values or `[value, label]` tuples.
  * @param {Array<*>} [checkedValues=[]] Values that should be rendered as checked.
  */
  fillDropdown(entries, checkedValues = []) {
    this.removeAllDropdownItems();
    _class_private_field_get$10(this, _cache).currentlySelectedItemIndex = 0;
    if (!Array.isArray(checkedValues)) {
      checkedValues = [];
    }
    let sortedEntries = entries;
    if (_class_private_field_get$10(this, _cache).sourceSortFunction) {
      sortedEntries = _class_private_field_get$10(this, _cache).sourceSortFunction(entries.slice());
    }
    if (!_class_private_field_get$10(this, _rootDocument$2) || !_class_private_field_get$10(this, _dropdownListElement) || _class_private_field_get$10(this, _instanceId) === null) {
      return;
    }
    sortedEntries.forEach((elem, indexWithinList) => {
      const itemValue = typeof elem === "object" && elem !== null && "value" in elem ? elem.value : elem;
      _class_private_method_get$O(this, _addDropdownItem, addDropdownItem).call(this, {
        rootDocument: _class_private_field_get$10(this, _rootDocument$2),
        itemKey: typeof elem === "object" && elem !== null && "key" in elem ? elem.key : void 0,
        itemValue: String(itemValue ?? elem),
        indexWithinList,
        checked: includesValue(checkedValues, elem),
        disabled: _class_private_field_get$10(this, _cache).areCheckboxesDisabled
      });
    });
    _class_private_field_get$10(this, _cache).entriesCount = sortedEntries.length;
    this.runLocalHooks("afterDropdownFill");
  }
  /**
  * Controls dropdown height based on entry count and configured visible rows.
  *
  * @param {object} availableSpace Available space object.
  * @param {boolean} noFlip If true, the dropdown will not be flipped vertically.
  */
  updateDimensions(availableSpace, noFlip = false) {
    const entryHeight = _class_private_method_get$O(this, _getEntryHeight, getEntryHeight).call(this);
    const requiresFlippingVertically1 = _class_private_method_get$O(this, _requiresFlippingVertically, requiresFlippingVertically).call(this, availableSpace);
    const availableHeight = requiresFlippingVertically1 ? availableSpace.spaceAbove : availableSpace.spaceBelow;
    if (!noFlip && requiresFlippingVertically1) {
      _class_private_field_get$10(this, _cache).flippedVertically = true;
    }
    if (_class_private_field_get$10(this, _cache).entriesCount > 0 && availableHeight < this.getHeight(true)) {
      const maxRenderableItems = Math.max(Math.floor((availableHeight - _class_private_method_get$O(this, _getSearchInputWrapperHeight, getSearchInputWrapperHeight).call(this)) / entryHeight) - 1, 1);
      _class_private_field_get$10(this, _cache).actualRenderedItemsCount = _class_private_field_get$10(this, _cache).visibleRowsNumberSetting ? Math.min(maxRenderableItems, _class_private_field_get$10(this, _cache).visibleRowsNumberSetting) : maxRenderableItems;
    } else {
      _class_private_field_get$10(this, _cache).actualRenderedItemsCount = Math.min(_class_private_field_get$10(this, _cache).entriesCount, _class_private_field_get$10(this, _cache).visibleRowsNumberSetting ?? _class_private_field_get$10(this, _cache).entriesCount);
    }
    if (!_class_private_field_get$10(this, _containerElement)) {
      return;
    }
    if (_class_private_field_get$10(this, _cache).actualRenderedItemsCount && _class_private_field_get$10(this, _cache).entriesCount > _class_private_field_get$10(this, _cache).actualRenderedItemsCount) {
      _class_private_field_get$10(this, _containerElement).style.height = `${this.getHeight()}px`;
    } else {
      _class_private_field_get$10(this, _containerElement).style.height = "";
    }
    _class_private_method_get$O(this, _toggleVerticalFlip, toggleVerticalFlip).call(this, availableSpace);
    _class_private_field_get$10(this, _containerElement).scrollTop = 0;
  }
  /**
  * Returns the pixel width of the dropdown list element, or 0 if the list is not yet mounted.
  */
  getDropdownWidth() {
    return _class_private_field_get$10(this, _dropdownListElement) ? getDropdownWidth({
      dropdownListElement: _class_private_field_get$10(this, _dropdownListElement)
    }) : 0;
  }
  /**
  * Unchecks all checkboxes in the dropdown list.
  */
  deselectAllItems() {
    if (_class_private_field_get$10(this, _dropdownListElement)) {
      deselectAllItems({
        dropdownListElement: _class_private_field_get$10(this, _dropdownListElement)
      });
    }
  }
  /**
  * Focuses the first item in the dropdown list if at least one entry exists.
  */
  focusFirstItem() {
    if (_class_private_field_get$10(this, _cache).entriesCount > 0) {
      _class_private_method_get$O(this, _focusItem, focusItem).call(this, 0);
    }
  }
  /**
  * Focuses the dropdown item at the given absolute index.
  */
  focusItem(index2) {
    _class_private_method_get$O(this, _focusItem, focusItem).call(this, index2);
  }
  /**
  * Moves focus to the previous item, or to the search input when already at the first item.
  */
  focusPreviousItem() {
    if (!_class_private_field_get$10(this, _dropdownListElement)) {
      return;
    }
    if (_class_private_field_get$10(this, _cache).currentlySelectedItemIndex === 0) {
      this.focusSearchInput();
      return;
    }
    defocusItem({
      dropdownListElement: _class_private_field_get$10(this, _dropdownListElement),
      index: _class_private_field_get$10(this, _cache).currentlySelectedItemIndex
    });
    _class_private_method_get$O(this, _focusItem, focusItem).call(this, _class_private_field_get$10(this, _cache).currentlySelectedItemIndex - 1);
  }
  /**
  * Moves focus to the next item in the list, stopping at the last entry.
  */
  focusNextItem() {
    if (!_class_private_field_get$10(this, _dropdownListElement)) {
      return;
    }
    if (_class_private_field_get$10(this, _cache).currentlySelectedItemIndex === _class_private_field_get$10(this, _cache).entriesCount - 1) {
      return;
    }
    defocusItem({
      dropdownListElement: _class_private_field_get$10(this, _dropdownListElement),
      index: _class_private_field_get$10(this, _cache).currentlySelectedItemIndex
    });
    _class_private_method_get$O(this, _focusItem, focusItem).call(this, _class_private_field_get$10(this, _cache).currentlySelectedItemIndex + 1);
  }
  /**
  * Transfers DOM focus to the search input element.
  */
  focusSearchInput() {
    if (_class_private_field_get$10(this, _searchInputElement)) {
      _class_private_field_get$10(this, _searchInputElement).focus();
    }
  }
  /**
  * Clears all dropdown items, resets internal cache state, clears the search input value, and resets container styles.
  */
  reset() {
    this.removeAllDropdownItems();
    _class_private_method_get$O(this, _resetCache, resetCache).call(this);
    if (_class_private_field_get$10(this, _searchInputElement)) {
      _class_private_field_get$10(this, _searchInputElement).value = "";
    }
    if (_class_private_field_get$10(this, _containerElement)) {
      _class_private_field_get$10(this, _containerElement).style.position = "";
      _class_private_field_get$10(this, _containerElement).style.top = "";
      _class_private_field_get$10(this, _containerElement).style.height = "";
      _class_private_field_get$10(this, _containerElement).scrollTop = 0;
    }
  }
  /**
  * Returns true when the dropdown is currently rendered above the edited cell instead of below.
  */
  isFlippedVertically() {
    return _class_private_field_get$10(this, _cache).flippedVertically;
  }
  /**
  * Calculates the total pixel height of the dropdown including the item list and search input wrapper.
  */
  getHeight(maxRowsCalculation = false, outerWidth2 = false) {
    if (!_class_private_field_get$10(this, _rootDocument$2) || !_class_private_field_get$10(this, _containerElement)) {
      return 0;
    }
    const computedStyle = _class_private_field_get$10(this, _rootDocument$2).defaultView.getComputedStyle(_class_private_field_get$10(this, _containerElement));
    return _class_private_method_get$O(this, _getListHeight, getListHeight).call(this, maxRowsCalculation) + _class_private_method_get$O(this, _getSearchInputWrapperHeight, getSearchInputWrapperHeight).call(this) + (outerWidth2 === true ? 2 * parseInt(computedStyle.getPropertyValue("--ht-menu-vertical-padding"), 10) : 0);
  }
  /**
  * Returns the InputController instance that manages the search input, or null if not yet initialized.
  */
  getInputController() {
    return _class_private_field_get$10(this, _inputController);
  }
  /**
  * Removes all list items from the dropdown, unregisters their event listeners, and clears the checkbox listener cache.
  */
  removeAllDropdownItems() {
    if (!_class_private_field_get$10(this, _dropdownListElement)) {
      return;
    }
    Array.from(_class_private_field_get$10(this, _dropdownListElement).children).forEach((itemElement) => _class_private_method_get$O(this, _unregisterEvents, unregisterEvents).call(this, itemElement));
    _class_private_field_get$10(this, _cache).checkboxChangeListeners.clear();
    _class_private_field_get$10(this, _dropdownListElement).innerHTML = "";
  }
  /**
  * Disables all unchecked checkboxes in the dropdown and sets the internal disabled flag.
  */
  disableCheckboxes() {
    _class_private_field_get$10(this, _cache).areCheckboxesDisabled = true;
    if (_class_private_field_get$10(this, _dropdownListElement)) {
      disableUncheckedCheckboxes({
        dropdownListElement: _class_private_field_get$10(this, _dropdownListElement)
      });
    }
  }
  /**
  * Re-enables all checkboxes in the dropdown and clears the internal disabled flag.
  */
  enableCheckboxes() {
    _class_private_field_get$10(this, _cache).areCheckboxesDisabled = false;
    if (_class_private_field_get$10(this, _dropdownListElement)) {
      enableAllCheckboxes({
        dropdownListElement: _class_private_field_get$10(this, _dropdownListElement)
      });
    }
  }
  /**
  * Creates a dropdown renderer attached to the provided container.
  *
  * @param {HTMLDivElement} containerElement Host element created by the editor.
  * @param {string} instanceId Handsontable instance id.
  */
  constructor(containerElement, instanceId) {
    _class_private_method_init$O(this, _focusItem);
    _class_private_method_init$O(this, _requiresFlippingVertically);
    _class_private_method_init$O(this, _toggleVerticalFlip);
    _class_private_method_init$O(this, _getEntryHeight);
    _class_private_method_init$O(this, _getListHeight);
    _class_private_method_init$O(this, _getSearchInputWrapperHeight);
    _class_private_method_init$O(this, _addDropdownItem);
    _class_private_method_init$O(this, _registerEvents$1);
    _class_private_method_init$O(this, _unregisterEvents);
    _class_private_method_init$O(this, _resetCache);
    _class_private_field_init$10(this, _instanceId, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _containerElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _dropdownListElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _searchInputElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _separatorElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _searchInputWrapper, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _inputController, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _rootDocument$2, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _eventManager, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$10(this, _cache, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$10(this, _instanceId, null);
    _class_private_field_set$10(this, _containerElement, null);
    _class_private_field_set$10(this, _dropdownListElement, null);
    _class_private_field_set$10(this, _searchInputElement, null);
    _class_private_field_set$10(this, _separatorElement, null);
    _class_private_field_set$10(this, _searchInputWrapper, null);
    _class_private_field_set$10(this, _inputController, null);
    _class_private_field_set$10(this, _rootDocument$2, null);
    _class_private_field_set$10(this, _eventManager, new EventManager(this));
    _class_private_field_set$10(this, _cache, {
      visibleRowsNumberSetting: null,
      entriesCount: 0,
      flippedVertically: false,
      currentlySelectedItemIndex: 0,
      checkboxChangeListeners: /* @__PURE__ */ new Map(),
      areCheckboxesDisabled: false,
      sourceSortFunction: null
    });
    _class_private_field_set$10(this, _containerElement, containerElement);
    _class_private_field_set$10(this, _rootDocument$2, _class_private_field_get$10(this, _containerElement).ownerDocument);
    _class_private_field_set$10(this, _instanceId, instanceId);
    this.init();
  }
}
function focusItem(index2) {
  _class_private_field_get$10(this, _cache).currentlySelectedItemIndex = index2;
  if (_class_private_field_get$10(this, _dropdownListElement)) {
    focusItemAt({
      dropdownListElement: _class_private_field_get$10(this, _dropdownListElement),
      index: index2
    });
  }
}
function requiresFlippingVertically(availableSpace) {
  const { spaceAbove, spaceBelow, cellHeight } = availableSpace;
  return this.getHeight(true) > spaceBelow && spaceAbove > spaceBelow + cellHeight;
}
function toggleVerticalFlip(availableSpace) {
  if (!_class_private_field_get$10(this, _containerElement)) {
    return;
  }
  const { cellHeight } = availableSpace;
  const flipNeeded = _class_private_field_get$10(this, _cache).flippedVertically;
  if (flipNeeded) {
    _class_private_field_get$10(this, _containerElement).style.position = "absolute";
    _class_private_field_get$10(this, _containerElement).style.top = `${-this.getHeight(false, true) - cellHeight - 2}px`;
  } else {
    _class_private_field_get$10(this, _containerElement).style.position = "";
    _class_private_field_get$10(this, _containerElement).style.top = "";
  }
}
function getEntryHeight() {
  if (!_class_private_field_get$10(this, _rootDocument$2) || !_class_private_field_get$10(this, _containerElement)) {
    return 0;
  }
  const computedStyle = _class_private_field_get$10(this, _rootDocument$2).defaultView.getComputedStyle(_class_private_field_get$10(this, _containerElement));
  return 2 * parseInt(computedStyle.getPropertyValue("--ht-menu-item-vertical-padding"), 10) + parseInt(computedStyle.getPropertyValue("--ht-line-height"), 10);
}
function getListHeight(maxRowsCalculation) {
  const maxRenderedItems = _class_private_field_get$10(this, _cache).entriesCount;
  const actualRenderedItems = maxRowsCalculation ? maxRenderedItems : _class_private_field_get$10(this, _cache).actualRenderedItemsCount ?? maxRenderedItems;
  const entryHeight = _class_private_method_get$O(this, _getEntryHeight, getEntryHeight).call(this);
  return actualRenderedItems * entryHeight;
}
function getSearchInputWrapperHeight() {
  if (!_class_private_field_get$10(this, _inputController)?.enabled || !_class_private_field_get$10(this, _searchInputWrapper) || !_class_private_field_get$10(this, _separatorElement) || !_class_private_field_get$10(this, _rootDocument$2) || !_class_private_field_get$10(this, _containerElement)) {
    return 0;
  }
  const computedStyle = _class_private_field_get$10(this, _rootDocument$2).defaultView.getComputedStyle(_class_private_field_get$10(this, _containerElement));
  const searchInputWrapperHeight = _class_private_field_get$10(this, _searchInputWrapper).offsetHeight;
  const separatorHeight = _class_private_field_get$10(this, _separatorElement).offsetHeight + 2 * parseInt(computedStyle.getPropertyValue("--ht-menu-vertical-padding"), 10);
  return searchInputWrapperHeight + separatorHeight;
}
function addDropdownItem({ rootDocument, itemKey, itemValue, indexWithinList, checked = false, disabled = false }) {
  if (!_class_private_field_get$10(this, _dropdownListElement) || _class_private_field_get$10(this, _instanceId) === null) {
    return;
  }
  const itemElement = createListItemElement({
    rootDocument,
    instanceId: _class_private_field_get$10(this, _instanceId),
    itemKey,
    itemValue,
    indexWithinList,
    checked,
    disabled
  });
  if (checked) {
    selectItem(itemElement);
  }
  _class_private_method_get$O(this, _registerEvents$1, registerEvents$2).call(this, itemElement);
  _class_private_field_get$10(this, _dropdownListElement).appendChild(itemElement);
}
function registerEvents$2(itemElement) {
  const checkbox = getCheckboxElement(itemElement);
  if (!checkbox || !_class_private_field_get$10(this, _dropdownListElement)) {
    return;
  }
  const checkboxChangeListener = () => {
    if (checkbox.dataset.disabled === "true" && checkbox.checked) {
      checkbox.checked = false;
      return;
    }
    if (checkbox.checked) {
      selectItem(itemElement);
      this.runLocalHooks("afterDropdownItemChecked", checkbox.dataset.key, checkbox.dataset.value);
    } else {
      deselectItem(itemElement);
      this.runLocalHooks("afterDropdownItemUnchecked", checkbox.dataset.key, checkbox.dataset.value);
    }
  };
  const itemClickListener = (event) => {
    const target = eventTargetEl(event);
    if (target === checkbox || checkbox.dataset.disabled === "true" || target.tagName === "LABEL") {
      return;
    }
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event("change"));
  };
  _class_private_field_get$10(this, _cache).checkboxChangeListeners.set(checkbox, {
    change: checkboxChangeListener,
    click: itemClickListener
  });
  _class_private_field_get$10(this, _eventManager).addEventListener(checkbox, "change", checkboxChangeListener);
  _class_private_field_get$10(this, _eventManager).addEventListener(itemElement, "click", itemClickListener);
}
function unregisterEvents(itemElement) {
  const checkbox = getCheckboxElement(itemElement);
  if (!checkbox) {
    return;
  }
  const checkboxListeners = _class_private_field_get$10(this, _cache).checkboxChangeListeners.get(checkbox);
  if (checkboxListeners) {
    _class_private_field_get$10(this, _eventManager).removeEventListener(checkbox, "change", checkboxListeners.change);
    _class_private_field_get$10(this, _eventManager).removeEventListener(itemElement, "click", checkboxListeners.click);
    _class_private_field_get$10(this, _cache).checkboxChangeListeners.delete(checkbox);
  }
}
function resetCache() {
  _class_private_field_get$10(this, _cache).visibleRowsNumberSetting = null;
  _class_private_field_get$10(this, _cache).entriesCount = 0;
  _class_private_field_get$10(this, _cache).flippedVertically = false;
  _class_private_field_get$10(this, _cache).currentlySelectedItemIndex = 0;
  _class_private_field_get$10(this, _cache).checkboxChangeListeners.clear();
  _class_private_field_get$10(this, _cache).areCheckboxesDisabled = false;
  _class_private_field_get$10(this, _cache).sourceSortFunction = null;
}
mixin(DropdownController, localHooks);
class SelectedItemsController {
  /**
  * Sets the maximum number of selections.
  */
  setMaxSelectionCount(maxSelectionsCount) {
    this.maxSelectionsCount = maxSelectionsCount;
  }
  /**
  * Adds selected values (single or array) to the set.
  *
  * @param {string|object|Array<string|object>} items Items to add.
  */
  add(items) {
    if (this.selectedItems.size >= this.maxSelectionsCount) {
      return;
    }
    if (Array.isArray(items)) {
      items.forEach((item) => this.selectedItems.add(item));
    } else {
      this.selectedItems.add(items);
    }
  }
  /**
  * Removes a selected value from the set.
  *
  * @param {string|object} item Item to remove.
  * @returns {boolean} True if the item was removed, false otherwise.
  */
  remove(item) {
    if (isKeyValueObject(item)) {
      const itemsArray = Array.from(this.selectedItems);
      const foundItem = itemsArray.find((selectedItem) => isObjectEqual(selectedItem, item));
      if (foundItem !== void 0) {
        this.selectedItems.delete(foundItem);
        return true;
      }
    } else {
      return this.selectedItems.delete(item);
    }
    return false;
  }
  /**
  * Checks if a value is in the set.
  *
  * @param {*} value Value to check.
  * @returns {boolean}
  */
  has(value) {
    return includesValue(this.getItemsArray(), value);
  }
  /**
  * Clears the set.
  */
  clear() {
    this.selectedItems.clear();
  }
  /**
  * Gets the number of selected items.
  *
  * @returns {number}
  */
  getSize() {
    return this.selectedItems.size;
  }
  /**
  * Gets the elements of the set.
  *
  * @returns {Array<*>}
  */
  getItemsArray() {
    return Array.from(this.selectedItems);
  }
  /**
  * Creates a new SelectedItemsController.
  *
  * @param {Array<*>|undefined} selectedItems Array of selected items.
  */
  constructor(selectedItems) {
    if (Array.isArray(selectedItems)) {
      this.selectedItems = new Set(selectedItems);
    } else {
      this.selectedItems = /* @__PURE__ */ new Set();
    }
    this.maxSelectionsCount = Infinity;
  }
}
function _check_private_redeclaration$19(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$$(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$$(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$$(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$$(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$$(receiver, privateMap, "get");
  return _class_apply_descriptor_get$$(receiver, descriptor);
}
function _class_private_field_init$$(obj, privateMap, value) {
  _check_private_redeclaration$19(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$$(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$$(receiver, privateMap, "set");
  _class_apply_descriptor_set$$(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$N(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$N(obj, privateSet) {
  _check_private_redeclaration$19(obj, privateSet);
  privateSet.add(obj);
}
const EDITOR_TYPE = "multiselect";
const DROPDOWN_ELEMENT_CSS_CLASSNAME = "ht-multi-select-editor";
const DROPDOWN_ARIA_LABEL = "Select options";
const SHORTCUTS_GROUP$f = "multiselectEditor";
const EDITOR_VISIBLE_CLASS_NAME = "ht_editor_visible";
var _selectedItems = /* @__PURE__ */ new WeakMap(), _editorContainer = /* @__PURE__ */ new WeakMap(), _getSource = /* @__PURE__ */ new WeakSet(), _registerShortcuts$1 = /* @__PURE__ */ new WeakSet(), _unregisterShortcuts$1 = /* @__PURE__ */ new WeakSet(), _showEditableElement = /* @__PURE__ */ new WeakSet(), _hideEditableElement = /* @__PURE__ */ new WeakSet(), _blockNewSelections = /* @__PURE__ */ new WeakSet(), _unblockNewSelections = /* @__PURE__ */ new WeakSet(), _filterEntries = /* @__PURE__ */ new WeakSet(), _getAvailableSpace = /* @__PURE__ */ new WeakSet(), _saveCurrentSelection = /* @__PURE__ */ new WeakSet(), _addSelectedValue = /* @__PURE__ */ new WeakSet(), _removeSelectedValue = /* @__PURE__ */ new WeakSet(), _syncSelectedValues = /* @__PURE__ */ new WeakSet(), _getEditorSetting = /* @__PURE__ */ new WeakSet(), _onAfterSetSourceDataAtCell$1 = /* @__PURE__ */ new WeakSet();
class MultiSelectEditor extends BaseEditor {
  /**
  * Returns the unique editor type identifier for the multiselect editor.
  */
  static get EDITOR_TYPE() {
    return EDITOR_TYPE;
  }
  /**
  * Creates the outer container, dropdown container, accessibility attributes, and the DropdownController instance.
  */
  createElements() {
    const { rootDocument } = this.hot;
    _class_private_field_set$$(this, _editorContainer, rootDocument.createElement("div"));
    _class_private_field_get$$(this, _editorContainer).style.display = "none";
    addClass(_class_private_field_get$$(this, _editorContainer), "handsontableEditor");
    this.dropdownContainerElement = this.hot.rootDocument.createElement("div");
    addClass(this.dropdownContainerElement, `${DROPDOWN_ELEMENT_CSS_CLASSNAME} handsontableEditor`);
    setAttribute(this.dropdownContainerElement, [
      A11Y_LABEL(DROPDOWN_ARIA_LABEL),
      A11Y_GROUP()
    ]);
    _class_private_field_get$$(this, _editorContainer).appendChild(this.dropdownContainerElement);
    this.hot.rootElement.appendChild(_class_private_field_get$$(this, _editorContainer));
    this.dropdownController = new DropdownController(this.dropdownContainerElement, this.hot.guid);
  }
  /**
  * Prepares the editor for the given cell, resets the dropdown, syncs the current selection, and applies cell settings.
  */
  prepare(row, col, prop, td, value, cellProperties) {
    super.prepare(row, col, prop, td, value, cellProperties);
    const parsedValue = parseStringifiedValue(value);
    const valuesArray = Array.isArray(parsedValue) ? parsedValue : [
      parsedValue
    ];
    const valuesIntersection = getValuesIntersection(valuesArray, _class_private_method_get$N(this, _getSource, getSource).call(this));
    this.dropdownController.reset();
    if (valuesIntersection.length >= _class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "maxSelections")) {
      _class_private_method_get$N(this, _blockNewSelections, blockNewSelections).call(this);
    }
    _class_private_method_get$N(this, _syncSelectedValues, syncSelectedValues).call(this, valuesIntersection);
    this.dropdownController.setSourceSortFunction(_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "sourceSortFunction") ?? null);
    this.dropdownController.fillDropdown(_class_private_method_get$N(this, _getSource, getSource).call(this), valuesIntersection);
    this.dropdownController.setVisibleRowsNumberSetting(_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "visibleRows"));
    this.dropdownController.setSearchInputVisibility(_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "searchInput"));
    if (cellProperties.maxSelections !== void 0) {
      _class_private_field_get$$(this, _selectedItems).setMaxSelectionCount(_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "maxSelections"));
    }
  }
  /**
  * Delegates to the base finishEditing to complete saving or restoring the cell value.
  */
  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    super.finishEditing(restoreOriginalValue, ctrlDown, callback);
  }
  /**
  * Wires dropdown check/uncheck hooks, scroll hooks, destroy cleanup, and the search filter trigger.
  */
  bindEvents() {
    this.dropdownController.addLocalHook("afterDropdownItemChecked", (selectedKey, selectedValue) => {
      _class_private_method_get$N(this, _addSelectedValue, addSelectedValue).call(this, selectedKey, selectedValue);
      if (_class_private_field_get$$(this, _selectedItems).getSize() >= _class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "maxSelections")) {
        _class_private_method_get$N(this, _blockNewSelections, blockNewSelections).call(this);
      }
    });
    this.dropdownController.addLocalHook("afterDropdownItemUnchecked", (deselectedKey, deselectedValue) => {
      _class_private_method_get$N(this, _removeSelectedValue, removeSelectedValue).call(this, deselectedKey, deselectedValue);
      if (_class_private_field_get$$(this, _selectedItems).getSize() < _class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "maxSelections")) {
        _class_private_method_get$N(this, _unblockNewSelections, unblockNewSelections).call(this);
      }
    });
    this.addHook("afterDestroy", () => this.destroy());
    this.addHook("afterSetSourceDataAtCell", (changes, source) => _class_private_method_get$N(this, _onAfterSetSourceDataAtCell$1, onAfterSetSourceDataAtCell).call(this, changes, source));
    this.addHook("afterScrollHorizontally", () => this.refreshDimensions());
    this.addHook("afterScrollVertically", () => this.refreshDimensions());
    this.dropdownController.getInputController().addLocalHook("triggerFilter", (value) => _class_private_method_get$N(this, _filterEntries, filterEntries).call(this, value));
  }
  /**
  * Shows the dropdown, positions it next to the edited cell, registers keyboard shortcuts, and focuses the appropriate element.
  */
  open(event) {
    const keyCode = event && "keyCode" in event ? event.keyCode : 0;
    const keyStr = event && "key" in event ? event.key : "";
    if (keyCode && isPrintableChar(keyCode)) {
      const character = keyStr.length === 1 ? keyStr : String.fromCharCode(keyCode);
      if (this.dropdownController.getInputController().enabled) {
        this.dropdownController.getInputController().setValue(character);
        _class_private_method_get$N(this, _filterEntries, filterEntries).call(this, character);
      }
      event?.preventDefault();
      this.enableFullEditMode();
    }
    _class_private_method_get$N(this, _showEditableElement, showEditableElement).call(this);
    this.refreshDimensions();
    this.hot.getShortcutManager().setActiveContextName("editor");
    _class_private_method_get$N(this, _registerShortcuts$1, registerShortcuts$1).call(this);
    this.dropdownController.getInputController().listen();
    this.dropdownController.updateDimensions(_class_private_method_get$N(this, _getAvailableSpace, getAvailableSpace).call(this));
  }
  /**
  * Hides the dropdown element, unregisters keyboard shortcuts, and stops the search input listener.
  */
  close() {
    _class_private_method_get$N(this, _hideEditableElement, hideEditableElement).call(this);
    _class_private_method_get$N(this, _unregisterShortcuts$1, unregisterShortcuts$1).call(this);
    this.dropdownController.getInputController().unlisten();
  }
  /**
  * Returns the currently selected values as an array to be written to the cell.
  */
  getValue() {
    return _class_private_field_get$$(this, _selectedItems).getItemsArray();
  }
  /**
  * No-op override — MultiSelectEditor saves data immediately on each check/uncheck event.
  */
  setValue() {
  }
  /**
  * Repositions the dropdown next to the edited cell; closes the editor if the cell is no longer rendered.
  */
  refreshDimensions() {
    if (!this.getEditedCell()) {
      this.close();
      return;
    }
    const { top: top2, start, height } = this.getEditedCellRect();
    const editorStyle = _class_private_field_get$$(this, _editorContainer).style;
    editorStyle.top = `${top2 + height}px`;
    editorStyle[this.hot.isRtl() ? "right" : "left"] = `${start}px`;
    addClass(_class_private_field_get$$(this, _editorContainer), EDITOR_VISIBLE_CLASS_NAME);
  }
  /**
  * Focuses the first dropdown item when search input is disabled, or the search input otherwise.
  */
  focus() {
    if (_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "searchInput") === false) {
      this.dropdownController.focusFirstItem();
    } else {
      this.dropdownController.focusSearchInput();
    }
  }
  /**
  * Returns the underlying search input element from the dropdown's input controller.
  */
  getInputElement() {
    return this.dropdownController.getInputController().getInputElement();
  }
  /**
  * Closes the editor and resets the dropdown controller state, releasing DOM resources.
  */
  destroy() {
    this.close();
    this.dropdownController.reset();
  }
  /**
  * Initializes the editor, creates DOM elements, and binds dropdown and hook events.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$N(this, _getSource), _class_private_method_init$N(this, _registerShortcuts$1), _class_private_method_init$N(this, _unregisterShortcuts$1), _class_private_method_init$N(this, _showEditableElement), _class_private_method_init$N(this, _hideEditableElement), _class_private_method_init$N(this, _blockNewSelections), _class_private_method_init$N(this, _unblockNewSelections), _class_private_method_init$N(this, _filterEntries), _class_private_method_init$N(this, _getAvailableSpace), _class_private_method_init$N(this, _saveCurrentSelection), _class_private_method_init$N(this, _addSelectedValue), _class_private_method_init$N(this, _removeSelectedValue), _class_private_method_init$N(this, _syncSelectedValues), _class_private_method_init$N(this, _getEditorSetting), _class_private_method_init$N(this, _onAfterSetSourceDataAtCell$1), _class_private_field_init$$(this, _selectedItems, {
      writable: true,
      value: void 0
    }), _class_private_field_init$$(this, _editorContainer, {
      writable: true,
      value: void 0
    }), /**
    * Overrides the base flag to keep the editor open after data changes — multiselect saves on each selection.
    */
    this._closeAfterDataChange = false, _class_private_field_set$$(this, _selectedItems, new SelectedItemsController()), _class_private_field_set$$(this, _editorContainer, null), /**
    * The container element passed to `DropdownController` that holds the dropdown UI.
    */
    this.dropdownContainerElement = null, /**
    * The controller responsible for rendering and managing the dropdown list.
    */
    this.dropdownController = null;
    this.eventManager = new EventManager(this);
    this.createElements();
    this.bindEvents();
  }
}
function getSource() {
  return this.cellProperties.source ?? [];
}
function registerShortcuts$1() {
  const shortcutManager = this.hot.getShortcutManager();
  const editorContext = shortcutManager.getContext("editor");
  editorContext.addShortcuts([
    {
      keys: [
        [
          "ArrowUp"
        ]
      ],
      callback: () => {
        this.dropdownController.focusPreviousItem();
      }
    },
    {
      keys: [
        [
          "ArrowDown"
        ]
      ],
      callback: () => {
        if (this.hot.rootDocument.activeElement === this.getInputElement()) {
          this.dropdownController.focusFirstItem();
        } else {
          this.dropdownController.focusNextItem();
        }
      }
    }
  ], {
    group: SHORTCUTS_GROUP$f
  });
  editorContext.addShortcuts([
    {
      keys: [
        [
          "enter"
        ],
        [
          "shift",
          "enter"
        ],
        [
          "control/meta",
          "enter"
        ],
        [
          "control/meta",
          "shift",
          "enter"
        ]
      ],
      runOnlyIf: () => !_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "enterCommits"),
      callback: (event) => {
        const activeElement = this.hot.rootDocument.activeElement;
        if (activeElement instanceof HTMLInputElement && activeElement.type === "checkbox") {
          activeElement.checked = !activeElement.checked;
          activeElement.dispatchEvent(new Event("change"));
        }
        event.preventDefault();
        return false;
      }
    },
    {
      keys: [
        [
          "space"
        ]
      ],
      runOnlyIf: () => !_class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "enterCommits"),
      callback: (event) => {
        event.preventDefault();
      }
    }
  ], {
    group: SHORTCUTS_GROUP$f,
    relativeToGroup: EDITOR_EDIT_GROUP,
    position: "before"
  });
}
function unregisterShortcuts$1() {
  const shortcutManager = this.hot.getShortcutManager();
  const editorContext = shortcutManager.getContext("editor");
  editorContext.removeShortcutsByGroup(SHORTCUTS_GROUP$f);
}
function showEditableElement() {
  _class_private_field_get$$(this, _editorContainer).style.display = "";
}
function hideEditableElement() {
  _class_private_field_get$$(this, _editorContainer).style.display = "none";
}
function blockNewSelections() {
  this.dropdownController.disableCheckboxes();
}
function unblockNewSelections() {
  this.dropdownController.enableCheckboxes();
}
function filterEntries(query, filterSelectedItems = _class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "filterSelectedItems") ?? true) {
  const filteredItems = _class_private_method_get$N(this, _getSource, getSource).call(this).filter((item) => {
    const value = typeof item === "object" && item !== null && "value" in item ? item.value : item;
    if (!filterSelectedItems && _class_private_field_get$$(this, _selectedItems).has(item)) {
      return true;
    }
    if (this.cellProperties.filteringCaseSensitive) {
      return String(value).includes(query);
    }
    return String(value).toLowerCase().includes(query.toLowerCase());
  });
  this.dropdownController.fillDropdown(filteredItems, _class_private_field_get$$(this, _selectedItems).getItemsArray());
  this.dropdownController.updateDimensions(_class_private_method_get$N(this, _getAvailableSpace, getAvailableSpace).call(this), true);
}
function getAvailableSpace() {
  const cellRect = this.getEditedCellRect();
  const isVerticallyScrollableByWindow = this.hot.view.isVerticallyScrollableByWindow();
  const workspaceHeight = this.hot.view.getWorkspaceHeight();
  let spaceAbove = cellRect.top;
  if (isVerticallyScrollableByWindow) {
    const topOffset = this.hot.view.getTableOffset().top - this.hot.rootWindow.scrollY;
    spaceAbove = Math.max(spaceAbove + topOffset, 0);
  }
  const spaceBelow = workspaceHeight - spaceAbove - cellRect.height;
  return {
    spaceAbove,
    spaceBelow,
    cellHeight: cellRect.height
  };
}
function saveCurrentSelection() {
  const value = _class_private_field_get$$(this, _selectedItems).getItemsArray();
  this.saveValue([
    [
      value
    ]
  ]);
}
function addSelectedValue(selectedKey, selectedValue) {
  if (selectedKey) {
    _class_private_field_get$$(this, _selectedItems).add({
      key: selectedKey,
      value: selectedValue
    });
  } else {
    _class_private_field_get$$(this, _selectedItems).add(selectedValue);
  }
  _class_private_method_get$N(this, _saveCurrentSelection, saveCurrentSelection).call(this);
  this.refreshDimensions();
}
function removeSelectedValue(deselectedKey, deselectedValue) {
  if (deselectedKey) {
    _class_private_field_get$$(this, _selectedItems).remove({
      key: deselectedKey,
      value: deselectedValue
    });
  } else {
    _class_private_field_get$$(this, _selectedItems).remove(deselectedValue);
  }
  _class_private_method_get$N(this, _saveCurrentSelection, saveCurrentSelection).call(this);
  this.refreshDimensions();
}
function syncSelectedValues(valuesArray) {
  if (valuesArray.length > 0) {
    _class_private_field_set$$(this, _selectedItems, new SelectedItemsController(valuesArray));
  } else {
    _class_private_field_set$$(this, _selectedItems, new SelectedItemsController());
  }
}
function getEditorSetting(settingKey) {
  return this.cellProperties[settingKey];
}
function onAfterSetSourceDataAtCell(changes, source) {
  if (this.isOpened() && source === `${EDITOR_TYPE}-renderer` && parseInt(String(changes[0][0]), 10) === this.cellProperties.visualRow && parseInt(String(changes[0][1]), 10) === this.cellProperties.visualCol) {
    _class_private_method_get$N(this, _syncSelectedValues, syncSelectedValues).call(this, changes[0][3]);
    this.dropdownController.fillDropdown(_class_private_method_get$N(this, _getSource, getSource).call(this), _class_private_field_get$$(this, _selectedItems).getItemsArray());
    this.dropdownController.focusItem(0);
    if (_class_private_field_get$$(this, _selectedItems).getSize() >= _class_private_method_get$N(this, _getEditorSetting, getEditorSetting).call(this, "maxSelections")) {
      _class_private_method_get$N(this, _blockNewSelections, blockNewSelections).call(this);
    } else {
      _class_private_method_get$N(this, _unblockNewSelections, unblockNewSelections).call(this);
    }
  }
}
function registerAllEditors() {
  _register$3(BaseEditor);
  _register$3(AutocompleteEditor);
  _register$3(CheckboxEditor);
  _register$3(DateEditor);
  _register$3(DropdownEditor);
  _register$3(HandsontableEditor);
  _register$3(IntlDateEditor);
  _register$3(IntlTimeEditor);
  _register$3(NumericEditor);
  _register$3(PasswordEditor);
  _register$3(SelectEditor);
  _register$3(TextEditor);
  _register$3(TimeEditor);
  _register$3(MultiSelectEditor);
}
const RENDERER_TYPE$c = "html";
function htmlRenderer(hotInstance, TD, row, col, prop, value, _cellProperties) {
  fastInnerHTML(TD, value === null || value === void 0 ? "" : value, false);
}
htmlRenderer.RENDERER_TYPE = RENDERER_TYPE$c;
const RENDERER_TYPE$b = "autocomplete";
function autocompleteRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  const { rootDocument } = hotInstance;
  const rendererFunc = cellProperties.allowHtml ? htmlRenderer : textRenderer;
  const ARROW = rootDocument.createElement("DIV");
  const isAriaEnabled = hotInstance.getSettings().ariaTags;
  ARROW.className = "htAutocompleteArrow";
  if (isAriaEnabled) {
    ARROW.setAttribute(...A11Y_HIDDEN());
  }
  ARROW.appendChild(rootDocument.createTextNode(String.fromCharCode(9660)));
  rendererFunc.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
  if (!TD.firstChild) {
    TD.appendChild(rootDocument.createTextNode(String.fromCharCode(160)));
  }
  TD.insertBefore(ARROW, TD.firstChild);
  addClass(TD, "htAutocomplete");
  if (!hotInstance.acArrowListener) {
    const eventManager = new EventManager(hotInstance);
    hotInstance.acArrowListener = function(event) {
      if (hasClass(eventTargetEl(event), "htAutocompleteArrow")) {
        hotInstance.view._wt.getSetting("onCellDblClick", null, hotInstance._createCellCoords(row, col), TD);
      }
    };
    eventManager.addEventListener(hotInstance.rootElement, "mousedown", hotInstance.acArrowListener);
    hotInstance.addHookOnce("afterDestroy", () => {
      eventManager.destroy();
    });
  }
}
autocompleteRenderer.RENDERER_TYPE = RENDERER_TYPE$b;
const RENDERER_TYPE$a = "dropdown";
function dropdownRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  autocompleteRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
dropdownRenderer.RENDERER_TYPE = RENDERER_TYPE$a;
const BAD_VALUE_TEXT = "#bad-value#";
const LOADING_CLASS_NAME = "ht-loading";
const isListeningKeyDownEvent = /* @__PURE__ */ new WeakMap();
const isCheckboxListenerAdded = /* @__PURE__ */ new WeakMap();
const BAD_VALUE_CLASS = "htBadValue";
const ATTR_ROW = "data-row";
const ATTR_COLUMN = "data-col";
const SHORTCUTS_GROUP$e = "checkboxRenderer";
const RENDERER_TYPE$9 = "checkbox";
Hooks.getSingleton().add("modifyAutoColumnSizeSeed", function(_bundleSeed, cellMeta, cellValue) {
  const { label, type, row, column, prop } = cellMeta;
  if (type !== RENDERER_TYPE$9 || !label) {
    return;
  }
  const labelObj = label;
  const { value: labelValue, property: labelProperty } = labelObj;
  let labelText = cellValue;
  if (labelValue) {
    labelText = typeof labelValue === "function" ? labelValue(row, column, prop, cellValue) : labelValue;
  } else if (labelProperty) {
    const labelData = this.getDataAtRowProp(row, String(labelProperty));
    labelText = labelData !== null ? labelData : cellValue;
  }
  return `${stringify$1(labelText).length}`;
});
function checkboxRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  const { rootDocument } = hotInstance;
  const ariaEnabled = hotInstance.getSettings().ariaTags;
  registerEvents$1(hotInstance);
  const input = createInput(rootDocument);
  let inputOrWrapper = input;
  const labelOptions = cellProperties.label;
  let badValue = false;
  if (typeof cellProperties.checkedTemplate === "undefined") {
    cellProperties.checkedTemplate = true;
  }
  if (typeof cellProperties.uncheckedTemplate === "undefined") {
    cellProperties.uncheckedTemplate = false;
  }
  empty$1(TD);
  const locale = cellProperties.locale;
  applyCheckedState();
  applyLabelOptions();
  function applyCheckedState() {
    if (value === cellProperties.checkedTemplate || localeLowerCase(stringify$1(value), locale) === localeLowerCase(stringify$1(cellProperties.checkedTemplate), locale)) {
      input.checked = true;
    } else if (value === cellProperties.uncheckedTemplate || localeLowerCase(stringify$1(value), locale) === localeLowerCase(stringify$1(cellProperties.uncheckedTemplate), locale)) {
      input.checked = false;
    } else if (isEmpty$1(value)) {
      addClass(input, "noValue");
    } else {
      input.style.display = "none";
      addClass(input, BAD_VALUE_CLASS);
      badValue = true;
    }
    setAttribute(input, [
      [
        ATTR_ROW,
        row
      ],
      [
        ATTR_COLUMN,
        col
      ]
    ]);
    if (ariaEnabled) {
      setAttribute(input, [
        A11Y_LABEL(input.checked ? hotInstance.getTranslatedPhrase(CHECKBOX_CHECKED) : hotInstance.getTranslatedPhrase(CHECKBOX_UNCHECKED)),
        A11Y_CHECKED(input.checked),
        A11Y_CHECKBOX()
      ]);
    }
  }
  function applyLabelOptions() {
    if (!badValue && labelOptions) {
      let labelText = "";
      if (labelOptions.value) {
        const labelFn = labelOptions.value;
        labelText = typeof labelOptions.value === "function" ? String(labelFn(row, col, prop, value)) : String(labelOptions.value);
      } else if (labelOptions.property) {
        const labelValue = hotInstance.getDataAtRowProp(row, String(labelOptions.property));
        labelText = labelValue !== null ? String(labelValue) : "";
      }
      const label = createLabel(rootDocument, labelText, labelOptions.separated !== true);
      if (labelOptions.position === "before") {
        if (labelOptions.separated) {
          TD.appendChild(label);
          TD.appendChild(input);
        } else {
          label.appendChild(input);
          inputOrWrapper = label;
        }
      } else if (!labelOptions.position || labelOptions.position === "after") {
        if (labelOptions.separated) {
          TD.appendChild(input);
          TD.appendChild(label);
        } else {
          label.insertBefore(input, label.firstChild);
          inputOrWrapper = label;
        }
      }
    }
  }
  if (!labelOptions || labelOptions && !labelOptions.separated) {
    TD.appendChild(inputOrWrapper);
  }
  if (badValue) {
    TD.appendChild(rootDocument.createTextNode(BAD_VALUE_TEXT));
  }
  if (!isListeningKeyDownEvent.has(hotInstance)) {
    isListeningKeyDownEvent.set(hotInstance, true);
    registerShortcuts2();
  }
  function registerShortcuts2() {
    const shortcutManager = hotInstance.getShortcutManager();
    const gridContext = shortcutManager.getContext("grid");
    const config = {
      group: SHORTCUTS_GROUP$e,
      relativeToGroup: EDITOR_EDIT_GROUP,
      position: "before"
    };
    gridContext?.addShortcuts([
      {
        keys: [
          [
            "space"
          ]
        ],
        callback: () => {
          changeSelectedCheckboxesState();
          return !areSelectedCheckboxCells();
        },
        runOnlyIf: () => !!hotInstance.getSelectedRangeActive()?.highlight.isCell()
      },
      {
        keys: [
          [
            "enter"
          ]
        ],
        callback: () => {
          changeSelectedCheckboxesState();
          return !areSelectedCheckboxCells();
        },
        runOnlyIf: () => {
          const range = hotInstance.getSelectedRangeActive();
          return !!(hotInstance.getSettings().enterBeginsEditing && range?.highlight.isCell() && !hotInstance.selection.isMultiple());
        }
      },
      {
        keys: [
          [
            "delete"
          ],
          [
            "backspace"
          ]
        ],
        callback: () => {
          changeSelectedCheckboxesState(true);
          return !areSelectedCheckboxCells();
        },
        runOnlyIf: () => !!hotInstance.getSelectedRangeActive()?.highlight.isCell()
      }
    ], config);
  }
  function changeSelectedCheckboxesState(uncheckCheckbox = false) {
    const selRange = hotInstance.getSelectedRange();
    const changesPerSubSelection = [];
    const nonCheckboxChanges = /* @__PURE__ */ new Map();
    let changes = [];
    let changeCounter = 0;
    if (!selRange) {
      return;
    }
    for (let key = 0; key < selRange.length; key++) {
      const { row: startRow, col: startColumn } = selRange[key].getTopStartCorner();
      const { row: endRow, col: endColumn } = selRange[key].getBottomEndCorner();
      if (startRow === null || startColumn === null || endRow === null || endColumn === null) {
        continue;
      }
      for (let visualRow = startRow; visualRow <= endRow; visualRow += 1) {
        for (let visualColumn = startColumn; visualColumn <= endColumn; visualColumn += 1) {
          const cachedCellProperties = hotInstance.getCellMeta(visualRow, visualColumn);
          if (cachedCellProperties.hidden) {
            continue;
          }
          const templates = {
            checkedTemplate: cachedCellProperties.checkedTemplate,
            uncheckedTemplate: cachedCellProperties.uncheckedTemplate
          };
          if (cachedCellProperties.type !== "checkbox") {
            if (uncheckCheckbox === true && !cachedCellProperties.readOnly) {
              if (nonCheckboxChanges.has(changesPerSubSelection.length)) {
                nonCheckboxChanges.set(changesPerSubSelection.length, [
                  ...nonCheckboxChanges.get(changesPerSubSelection.length),
                  [
                    visualRow,
                    visualColumn,
                    null
                  ]
                ]);
              } else {
                nonCheckboxChanges.set(changesPerSubSelection.length, [
                  [
                    visualRow,
                    visualColumn,
                    null
                  ]
                ]);
              }
            }
            continue;
          }
          if (cachedCellProperties.readOnly === true) {
            continue;
          }
          if (typeof cachedCellProperties.checkedTemplate === "undefined") {
            cachedCellProperties.checkedTemplate = true;
          }
          if (typeof cachedCellProperties.uncheckedTemplate === "undefined") {
            cachedCellProperties.uncheckedTemplate = false;
          }
          const dataAtCell = hotInstance.getDataAtCell(visualRow, visualColumn);
          if (uncheckCheckbox === false) {
            if ([
              cachedCellProperties.checkedTemplate,
              String(cachedCellProperties.checkedTemplate)
            ].includes(dataAtCell)) {
              changes.push([
                visualRow,
                visualColumn,
                cachedCellProperties.uncheckedTemplate,
                templates
              ]);
            } else if ([
              cachedCellProperties.uncheckedTemplate,
              String(cachedCellProperties.uncheckedTemplate),
              null,
              void 0
            ].includes(dataAtCell)) {
              changes.push([
                visualRow,
                visualColumn,
                cachedCellProperties.checkedTemplate,
                templates
              ]);
            }
          } else {
            changes.push([
              visualRow,
              visualColumn,
              cachedCellProperties.uncheckedTemplate,
              templates
            ]);
          }
          changeCounter += 1;
        }
      }
      changesPerSubSelection.push(changeCounter);
      changeCounter = 0;
    }
    if (!changes.every(([, , cellValue]) => cellValue === changes[0][2])) {
      changes = changes.map(([visualRow, visualColumn, , templates]) => [
        visualRow,
        visualColumn,
        templates?.checkedTemplate
      ]);
    } else {
      changes = changes.map(([visualRow, visualColumn, cellValue]) => [
        visualRow,
        visualColumn,
        cellValue
      ]);
    }
    if (changes.length > 0) {
      const changesChunks = [];
      changesPerSubSelection.forEach((changesCount, sectionCount) => {
        let changesChunk = changes.splice(0, changesCount);
        if (nonCheckboxChanges.size && nonCheckboxChanges.has(sectionCount)) {
          const nonCheckboxChunk = nonCheckboxChanges.get(sectionCount) ?? [];
          changesChunk = [
            ...changesChunk,
            ...nonCheckboxChunk
          ];
        }
        changesChunks.push(changesChunk);
      });
      if (uncheckCheckbox) {
        const allChanges = [];
        changesChunks.forEach((changesChunk) => {
          changesChunk.forEach((change) => {
            allChanges.push(change);
          });
        });
        if (allChanges.length > 0) {
          hotInstance.setDataAtCell(allChanges);
        }
      } else {
        changesChunks.forEach((changesChunk) => {
          if (changesChunk.length > 0) {
            hotInstance.setDataAtCell(changesChunk);
          }
        });
      }
    }
  }
  function areSelectedCheckboxCells() {
    const selRange = hotInstance.getSelectedRange();
    if (!selRange) {
      return;
    }
    for (let key = 0; key < selRange.length; key++) {
      const topLeft = selRange[key].getTopStartCorner();
      const bottomRight = selRange[key].getBottomEndCorner();
      if (topLeft.row === null || topLeft.col === null || bottomRight.row === null || bottomRight.col === null) {
        continue;
      }
      for (let visualRow = topLeft.row; visualRow <= bottomRight.row; visualRow++) {
        for (let visualColumn = topLeft.col; visualColumn <= bottomRight.col; visualColumn++) {
          const cellMeta = hotInstance.getCellMeta(visualRow, visualColumn);
          if (cellMeta.readOnly) {
            continue;
          }
          const cell = hotInstance.getCell(visualRow, visualColumn);
          if (isHTMLElement(cell)) {
            const checkboxes = cell.querySelectorAll("input[type=checkbox]");
            if (checkboxes.length > 0) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
}
checkboxRenderer.RENDERER_TYPE = RENDERER_TYPE$9;
function registerEvents$1(instance) {
  let eventManager = isCheckboxListenerAdded.get(instance);
  if (!eventManager) {
    const { rootElement } = instance;
    eventManager = new EventManager(instance);
    eventManager.addEventListener(rootElement, "click", (event) => onClick$1(event, instance));
    eventManager.addEventListener(rootElement, "mouseup", (event) => onMouseUp$6(event, instance));
    eventManager.addEventListener(rootElement, "change", (event) => onChange(event, instance));
    isCheckboxListenerAdded.set(instance, eventManager);
  }
  return eventManager;
}
function createInput(rootDocument) {
  const input = rootDocument.createElement("input");
  input.className = "htCheckboxRendererInput";
  input.type = "checkbox";
  input.setAttribute("tabindex", "-1");
  return input.cloneNode(false);
}
function createLabel(rootDocument, text, fullWidth) {
  const label = rootDocument.createElement("label");
  label.className = `htCheckboxRendererLabel ${fullWidth ? "fullWidth" : ""}`;
  const textNode = rootDocument.createTextNode(text);
  if (fullWidth) {
    const span = rootDocument.createElement("span");
    span.appendChild(textNode);
    label.appendChild(span);
  } else {
    label.appendChild(textNode);
  }
  return label.cloneNode(true);
}
function onMouseUp$6(event, instance) {
  const target = eventTargetEl(event);
  if (!isCheckboxInput(target)) {
    return;
  }
  if (!target.hasAttribute(ATTR_ROW) || !target.hasAttribute(ATTR_COLUMN)) {
    return;
  }
  setTimeout(instance.listen, 10);
}
function onClick$1(event, instance) {
  const target = eventTargetEl(event);
  if (!isCheckboxInput(target)) {
    return;
  }
  if (!target.hasAttribute(ATTR_ROW) || !target.hasAttribute(ATTR_COLUMN)) {
    return;
  }
  const row = Number.parseInt(target.getAttribute(ATTR_ROW), 10);
  const col = Number.parseInt(target.getAttribute(ATTR_COLUMN), 10);
  const cellProperties = instance.getCellMeta(row, col);
  if (cellProperties.readOnly) {
    event.preventDefault();
  }
}
function onChange(event, instance) {
  const target = eventTargetEl(event);
  if (!isCheckboxInput(target)) {
    return;
  }
  if (!target.hasAttribute(ATTR_ROW) || !target.hasAttribute(ATTR_COLUMN)) {
    return;
  }
  const row = Number.parseInt(target.getAttribute(ATTR_ROW), 10);
  const col = Number.parseInt(target.getAttribute(ATTR_COLUMN), 10);
  const cellProperties = instance.getCellMeta(row, col);
  if (!cellProperties.readOnly) {
    let newCheckboxValue = null;
    if (target.checked) {
      newCheckboxValue = cellProperties.uncheckedTemplate === void 0 ? true : cellProperties.checkedTemplate;
    } else {
      newCheckboxValue = cellProperties.uncheckedTemplate === void 0 ? false : cellProperties.uncheckedTemplate;
    }
    instance.setDataAtCell(row, col, newCheckboxValue);
  }
}
function isCheckboxInput(element) {
  return element.tagName === "INPUT" && element.getAttribute("type") === "checkbox";
}
const RENDERER_TYPE$8 = "handsontable";
function handsontableRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  autocompleteRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
handsontableRenderer.RENDERER_TYPE = RENDERER_TYPE$8;
const RENDERER_TYPE$7 = "date";
const DEFAULT_INTL_FORMAT$2 = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
};
const stringFormatWarnShown$1 = /* @__PURE__ */ new WeakSet();
function valueFormatter$3(value, cellProperties) {
  const { dateFormat, locale, allowEmpty, instance } = cellProperties;
  if (isEmpty$1(value)) {
    return allowEmpty ? value : BAD_VALUE_TEXT;
  }
  if (typeof dateFormat === "string") {
    if (instance && !stringFormatWarnShown$1.has(instance)) {
      stringFormatWarnShown$1.add(instance);
      warn$1("The dateFormat option as a string is not supported. Use an Intl.DateTimeFormatOptions object instead.");
    }
    return value;
  }
  const date = parseToLocalDate(value);
  if (date === null) {
    return BAD_VALUE_TEXT;
  }
  const intlFormat = isObject$1(dateFormat) ? dateFormat : DEFAULT_INTL_FORMAT$2;
  return new Intl.DateTimeFormat(locale, intlFormat).format(date);
}
function _dateRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  textRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
_dateRenderer.valueFormatter = valueFormatter$3;
_dateRenderer.RENDERER_TYPE = RENDERER_TYPE$7;
const dateRenderer = _dateRenderer;
const RENDERER_TYPE$6 = "intl-date";
function _intlDateRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  dateRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
_intlDateRenderer.valueFormatter = valueFormatter$3;
_intlDateRenderer.RENDERER_TYPE = RENDERER_TYPE$6;
const intlDateRenderer = _intlDateRenderer;
const RENDERER_TYPE$5 = "time";
const DEFAULT_INTL_FORMAT$1 = {
  hour: "numeric",
  minute: "2-digit"
};
const stringFormatWarnShown = /* @__PURE__ */ new WeakSet();
function valueFormatter$2(value, cellProperties) {
  const { timeFormat, locale, allowEmpty, instance } = cellProperties;
  if (isEmpty$1(value)) {
    return allowEmpty ? value : BAD_VALUE_TEXT;
  }
  const time = parseToLocalTime(value);
  if (time === null) {
    return BAD_VALUE_TEXT;
  }
  if (typeof timeFormat === "string" && instance && !stringFormatWarnShown.has(instance)) {
    stringFormatWarnShown.add(instance);
    warn$1("The timeFormat option as a string is not supported. Use an Intl.DateTimeFormatOptions object instead.");
  }
  const intlFormat = isObject$1(timeFormat) ? timeFormat : DEFAULT_INTL_FORMAT$1;
  return new Intl.DateTimeFormat(locale, intlFormat).format(time);
}
function _timeRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  textRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
  TD.dir = "ltr";
}
_timeRenderer.valueFormatter = valueFormatter$2;
_timeRenderer.RENDERER_TYPE = RENDERER_TYPE$5;
const timeRenderer = _timeRenderer;
const RENDERER_TYPE$4 = "intl-time";
function _intlTimeRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  timeRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
_intlTimeRenderer.RENDERER_TYPE = RENDERER_TYPE$4;
const intlTimeRenderer = _intlTimeRenderer;
const DEFAULT_INTL_FORMAT = {
  useGrouping: false,
  maximumFractionDigits: 20
};
const formatterCache = /* @__PURE__ */ new Map();
function intlFormatter(value, cellProperties) {
  const { numericFormat, locale } = cellProperties;
  const options = numericFormat ?? DEFAULT_INTL_FORMAT;
  const cacheKey = `${locale ?? ""}:${JSON.stringify(options)}`;
  let formatter = formatterCache.get(cacheKey);
  if (formatter === void 0) {
    formatter = new Intl.NumberFormat(locale, options);
    formatterCache.set(cacheKey, formatter);
  }
  return formatter.format(value);
}
const RENDERER_TYPE$3 = "numeric";
const unsupportedFormatMessageShown = /* @__PURE__ */ new WeakSet();
function valueFormatter$1(value, cellProperties) {
  if (isNumeric(value)) {
    value = intlFormatter(value, cellProperties);
  }
  return value;
}
function numericRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  const numericFormat = cellProperties.numericFormat;
  const hasUnsupportedFormat = numericFormat?.pattern !== void 0 || numericFormat?.culture !== void 0;
  if (hasUnsupportedFormat) {
    const instance = cellProperties.instance;
    if (!unsupportedFormatMessageShown.has(instance)) {
      unsupportedFormatMessageShown.add(instance);
      warn$1("The numericFormat.pattern and numericFormat.culture options are not supported. Use Intl.NumberFormat options instead (numericFormat: { style, currency, ... }).");
    }
  }
  if (isNumeric(hotInstance.getDataAtCell(row, col))) {
    let classArr = [];
    if (Array.isArray(cellProperties.className)) {
      classArr = cellProperties.className;
    } else {
      const className = cellProperties.className ?? "";
      if (className.length) {
        classArr = className.split(" ");
      }
    }
    if (classArr.indexOf("htLeft") < 0 && classArr.indexOf("htCenter") < 0 && classArr.indexOf("htRight") < 0 && classArr.indexOf("htJustify") < 0) {
      classArr.push("htRight");
    }
    if (classArr.indexOf("htNumeric") < 0) {
      classArr.push("htNumeric");
    }
    cellProperties.className = classArr.join(" ");
    TD.dir = "ltr";
  }
  textRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
numericRenderer.valueFormatter = valueFormatter$1;
numericRenderer.RENDERER_TYPE = RENDERER_TYPE$3;
const RENDERER_TYPE$2 = "password";
function valueFormatter(value, cellProperties) {
  const hashLength = cellProperties.hashLength || stringify$1(value).length;
  const hashSymbol = String(cellProperties.hashSymbol ?? "*");
  let hash = "";
  for (let i = 0; i < hashLength; i++) {
    hash += hashSymbol;
  }
  return hash;
}
function passwordRenderer(hotInstance, TD, row, col, prop, value) {
  fastInnerHTML(TD, value);
}
passwordRenderer.valueFormatter = valueFormatter;
passwordRenderer.RENDERER_TYPE = RENDERER_TYPE$2;
const RENDERER_TYPE$1 = "select";
function selectRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  textRenderer.apply(this, [
    hotInstance,
    TD,
    row,
    col,
    prop,
    value,
    cellProperties
  ]);
}
selectRenderer.RENDERER_TYPE = RENDERER_TYPE$1;
function registerAllRenderers() {
  _register$2(autocompleteRenderer);
  _register$2(baseRenderer);
  _register$2(checkboxRenderer);
  _register$2(dropdownRenderer);
  _register$2(handsontableRenderer);
  _register$2(htmlRenderer);
  _register$2(intlDateRenderer);
  _register$2(intlTimeRenderer);
  _register$2(numericRenderer);
  _register$2(passwordRenderer);
  _register$2(selectRenderer);
  _register$2(textRenderer);
  _register$2(timeRenderer);
  _register$2(dateRenderer);
}
const VALIDATOR_TYPE$7 = "autocomplete";
function autocompleteValidator(value, callback) {
  const isKeyValueObject2 = (obj) => {
    const rec = obj;
    return isObject$1(obj) && isDefined(rec.key) && isDefined(rec.value);
  };
  const isNullOrUndefined = (val) => {
    if (isKeyValueObject2(val)) {
      const rec = val;
      return isNullOrUndefined(rec.key) && isNullOrUndefined(rec.value);
    }
    return val === null || val === void 0;
  };
  let valueToValidate = value;
  if (isNullOrUndefined(valueToValidate)) {
    valueToValidate = "";
  }
  if (valueToValidate === "") {
    callback(!!this.allowEmpty);
    return;
  }
  if (this.strict && this.source) {
    if (typeof this.source === "function") {
      this.source(valueToValidate, process$2(valueToValidate, callback));
    } else {
      process$2(valueToValidate, callback)(this.source);
    }
  } else {
    callback(true);
  }
}
autocompleteValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$7;
function process$2(value, callback) {
  const originalVal = value;
  return function(source) {
    let found = false;
    for (let s = 0, slen = source.length; s < slen; s++) {
      if (isObjectEqual(originalVal, source[s])) {
        found = true;
        break;
      }
    }
    callback(found);
  };
}
const VALIDATOR_TYPE$6 = "date";
const SOURCE_DATA_WARNING_MESSAGE$3 = 'Source data warning ([itemsCount]). Invalid value for "date" cell type.\n\n[affectedCells]\n\nExpected a value compatible with the ISO 8601 date format ("YYYY-MM-DD").';
function sourceDataValidator$1(value, cellMeta) {
  if (cellMeta.allowEmpty && isEmpty$1(value)) {
    return true;
  }
  if (typeof value === "string" && value.startsWith("=")) {
    return true;
  }
  return isValidISODate(value);
}
sourceDataValidator$1.rowIndependent = true;
function dateValidator(value, callback) {
  if (this.allowEmpty && isEmpty$1(value)) {
    callback(true);
    return;
  }
  callback(isValidISODate(value));
}
dateValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$6;
const VALIDATOR_TYPE$5 = "dropdown";
function dropdownValidator(value, callback) {
  autocompleteValidator.apply(this, [
    value,
    callback
  ]);
}
dropdownValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$5;
const VALIDATOR_TYPE$4 = "intl-date";
const SOURCE_DATA_WARNING_MESSAGE$2 = 'Source data warning ([itemsCount]). Invalid value for "intl-date" cell type.\n\n[affectedCells]\n\nExpected a value compatible with the ISO 8601 date format ("YYYY-MM-DD").';
function intlDateValidator(value, callback) {
  dateValidator.call(this, value, callback);
}
intlDateValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$4;
const VALIDATOR_TYPE$3 = "time";
const SOURCE_DATA_WARNING_MESSAGE$1 = 'Source data warning ([itemsCount]). Invalid value for "time" cell type.\n\n[affectedCells]\n\nExpected a value compatible with the 24-hour time format ("HH:mm", "HH:mm:ss" or "HH:mm:ss.SSS").';
function sourceDataValidator(value, cellMeta) {
  if (cellMeta.allowEmpty && isEmpty$1(value)) {
    return true;
  }
  if (typeof value === "string" && value.startsWith("=")) {
    return true;
  }
  return isValidTime(value);
}
sourceDataValidator.rowIndependent = true;
function timeValidator(value, callback) {
  if (this.allowEmpty && isEmpty$1(value)) {
    callback(true);
    return;
  }
  callback(isValidTime(value));
}
timeValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$3;
const VALIDATOR_TYPE$2 = "intl-time";
const SOURCE_DATA_WARNING_MESSAGE = 'Source data warning ([itemsCount]). Invalid value for "intl-time" cell type.\n\n[affectedCells]\n\nExpected a value compatible with the 24-hour time format ("HH:mm", "HH:mm:ss" or "HH:mm:ss.SSS").';
function intlTimeValidator(value, callback) {
  timeValidator.call(this, value, callback);
}
intlTimeValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$2;
const VALIDATOR_TYPE$1 = "multiselect";
function multiSelectValidator(value, callback) {
  let valueToValidate = value;
  if (valueToValidate === null || valueToValidate === void 0) {
    valueToValidate = "";
  }
  if (this.allowEmpty && valueToValidate === "") {
    callback(true);
    return;
  }
  if (!this.allowEmpty && valueToValidate === "") {
    callback(false);
    return;
  }
  if (!Array.isArray(valueToValidate)) {
    callback(false);
    return;
  }
  if (valueToValidate.length === 0) {
    callback(true);
    return;
  }
  if (this.source) {
    if (typeof this.source === "function") {
      this.source(valueToValidate, process$1(valueToValidate, callback));
    } else {
      process$1(valueToValidate, callback)(this.source);
    }
  } else {
    callback(true);
  }
}
multiSelectValidator.VALIDATOR_TYPE = VALIDATOR_TYPE$1;
function process$1(value, callback) {
  const originalVal = value;
  return function(source) {
    let allValid = true;
    for (let i = 0, len = originalVal.length; i < len; i++) {
      let found = false;
      for (let s = 0, slen = source.length; s < slen; s++) {
        if (isKeyValueObject(originalVal[i]) && !isKeyValueObject(source[s]) || !isKeyValueObject(originalVal[i]) && isKeyValueObject(source[s])) {
          found = false;
          break;
        } else if (isKeyValueObject(originalVal[i]) && isKeyValueObject(source[s]) && isObjectEqual(originalVal[i], source[s])) {
          found = true;
        } else if (typeof originalVal[i] === "string" && typeof source[s] === "string" && originalVal[i] === source[s]) {
          found = true;
        }
      }
      if (!found) {
        allValid = false;
        break;
      }
    }
    callback(allValid);
  };
}
const VALIDATOR_TYPE = "numeric";
function numericValidator(value, callback) {
  let valueToValidate = value;
  if (valueToValidate === null || valueToValidate === void 0) {
    valueToValidate = "";
  }
  if (this.allowEmpty && valueToValidate === "") {
    callback(true);
  } else if (valueToValidate === "") {
    callback(false);
  } else {
    callback(isNumeric(value));
  }
}
numericValidator.VALIDATOR_TYPE = VALIDATOR_TYPE;
function registerAllValidators() {
  _register$1(autocompleteValidator);
  _register$1(dropdownValidator);
  _register$1(dateValidator);
  _register$1(intlDateValidator);
  _register$1(intlTimeValidator);
  _register$1(multiSelectValidator);
  _register$1(numericValidator);
  _register$1(timeValidator);
}
function valueGetter$2(value) {
  const rec = value;
  return isObject$1(value) && rec.value !== void 0 ? rec.value : value;
}
function valueSetter$4(newValue, row, column) {
  const sourceDataAtCell = this.getSourceDataAtCell(this.toPhysicalRow(row), this.toPhysicalColumn(column));
  if (isKeyValueObject(sourceDataAtCell)) {
    return isKeyValueObject(newValue) ? newValue : {
      key: newValue,
      value: newValue
    };
  }
  return newValue;
}
const CELL_TYPE$b = "autocomplete";
const AutocompleteCellType = {
  CELL_TYPE: CELL_TYPE$b,
  editor: AutocompleteEditor,
  renderer: autocompleteRenderer,
  validator: autocompleteValidator,
  valueGetter: valueGetter$2,
  valueSetter: valueSetter$4,
  parsePastedValue: true
};
function valueSetter$3(newValue, row, column) {
  const { checkedTemplate, uncheckedTemplate } = this.getCellMeta(row, column);
  const stringifiedValue = stringify$1(newValue);
  const isChecked = stringifiedValue === stringify$1(checkedTemplate);
  const isUnchecked = stringifiedValue === stringify$1(uncheckedTemplate);
  if (isChecked || isUnchecked) {
    return isChecked ? checkedTemplate : uncheckedTemplate;
  }
  return newValue;
}
const CELL_TYPE$a = "checkbox";
const CheckboxCellType = {
  CELL_TYPE: CELL_TYPE$a,
  editor: CheckboxEditor,
  renderer: checkboxRenderer,
  valueSetter: valueSetter$3
};
const CELL_TYPE$9 = "date";
const DateCellType = {
  CELL_TYPE: CELL_TYPE$9,
  editor: DateEditor,
  renderer: dateRenderer,
  validator: dateValidator,
  sourceDataValidator: sourceDataValidator$1,
  sourceDataWarningMessage: SOURCE_DATA_WARNING_MESSAGE$3,
  valueFormatter: valueFormatter$3
};
function valueGetter$1(value) {
  return valueGetter$2.call(this, value);
}
function valueSetter$2(newValue, row, column, cellMeta) {
  return valueSetter$4.call(this, newValue, row, column);
}
const CELL_TYPE$8 = "dropdown";
const DropdownCellType = {
  CELL_TYPE: CELL_TYPE$8,
  editor: DropdownEditor,
  renderer: dropdownRenderer,
  validator: dropdownValidator,
  filter: false,
  strict: true,
  valueGetter: valueGetter$1,
  valueSetter: valueSetter$2,
  parsePastedValue: true
};
const CELL_TYPE$7 = "handsontable";
const HandsontableCellType = {
  CELL_TYPE: CELL_TYPE$7,
  editor: HandsontableEditor,
  // displays small gray arrow on right side of the cell
  renderer: handsontableRenderer
};
const CELL_TYPE$6 = "intl-date";
const IntlDateCellType = {
  CELL_TYPE: CELL_TYPE$6,
  editor: IntlDateEditor,
  renderer: intlDateRenderer,
  validator: intlDateValidator,
  sourceDataValidator: sourceDataValidator$1,
  sourceDataWarningMessage: SOURCE_DATA_WARNING_MESSAGE$2,
  valueFormatter: valueFormatter$3
};
const CELL_TYPE$5 = "intl-time";
const IntlTimeCellType = {
  CELL_TYPE: CELL_TYPE$5,
  editor: IntlTimeEditor,
  renderer: intlTimeRenderer,
  validator: intlTimeValidator,
  sourceDataValidator,
  sourceDataWarningMessage: SOURCE_DATA_WARNING_MESSAGE,
  valueFormatter: valueFormatter$2
};
const CLASS_PREFIX = "ht-multi-select";
const CHIP_CLASS = `${CLASS_PREFIX}-chip`;
const CHIP_REMOVE_CLASS = `${CLASS_PREFIX}-chip-remove`;
const CHIP_LABEL_CLASS = `${CLASS_PREFIX}-chip-label`;
const OVERFLOW_INDICATOR_CLASS = `${CLASS_PREFIX}-overflow`;
const beforeColumnResizeHookRegistered = /* @__PURE__ */ new WeakSet();
const latestColumnWidthCache = /* @__PURE__ */ new WeakMap();
const chipsEventManagers = /* @__PURE__ */ new WeakMap();
function getItemProperty(item, property) {
  return isKeyValueObject(item) ? item[property] : item;
}
function parseValue(value) {
  if (value === null || value === void 0 || value === "") {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      const parsedArray = parsed;
      return Array.isArray(parsed) ? parsedArray : [
        parsed
      ];
    } catch {
      return value.trim() ? [
        value
      ] : [];
    }
  }
  return [
    value
  ];
}
function createChipElement(rootDocument, item, isAriaEnabled, row, prop) {
  const chip = rootDocument.createElement("span");
  const textContent = getItemProperty(item, "value");
  addClass(chip, CHIP_CLASS);
  chip.dataset.row = String(row);
  chip.dataset.prop = String(prop);
  chip.title = textContent;
  const label = rootDocument.createElement("span");
  addClass(label, CHIP_LABEL_CLASS);
  label.textContent = textContent;
  chip.appendChild(label);
  const removeBtn = rootDocument.createElement("span");
  addClass(removeBtn, CHIP_REMOVE_CLASS);
  if (isAriaEnabled) {
    removeBtn.setAttribute(...A11Y_HIDDEN());
  }
  chip.dataset.key = getItemProperty(item, "key");
  chip.appendChild(removeBtn);
  return chip;
}
function createOverflowIndicator(rootDocument, count) {
  const indicator = rootDocument.createElement("span");
  addClass(indicator, OVERFLOW_INDICATOR_CLASS);
  indicator.textContent = `+${count}`;
  return indicator;
}
function registerChipRemovingEvents(hotInstance, rendererType) {
  if (chipsEventManagers.has(hotInstance)) {
    return;
  }
  chipsEventManagers.set(hotInstance, new EventManager(hotInstance));
  const eventManager = chipsEventManagers.get(hotInstance);
  eventManager.addEventListener(hotInstance.rootElement, "click", (event) => {
    if (!hasClass(eventTargetEl(event), CHIP_REMOVE_CLASS)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const chip = eventTargetEl(event).closest(`.${CHIP_CLASS}`);
    if (!chip) {
      return;
    }
    const rowIndex = chip.dataset.row;
    const columnProp = chip.dataset.prop;
    const physicalRow = hotInstance.toPhysicalRow(Number(rowIndex ?? 0));
    const physicalColumn = typeof columnProp === "string" ? columnProp : hotInstance.toPhysicalColumn(Number(columnProp));
    const visualColumn = hotInstance.propToCol(columnProp ?? "");
    const currentData = hotInstance.getSourceDataAtCell(physicalRow, visualColumn);
    const keyToRemove = chip.dataset.key;
    const newData = removeValueByKey(parseValue(currentData), keyToRemove);
    hotInstance.setSourceDataAtCell(physicalRow, physicalColumn, newData, `${rendererType}-renderer`);
    hotInstance.render();
  });
  hotInstance.addHook("beforeOnCellMouseDown", (...args) => {
    const event = args[0];
    if (hasClass(eventTargetEl(event), CHIP_REMOVE_CLASS)) {
      stopImmediatePropagation(event);
    }
  });
}
function cacheColumnWidthAndRegisterResizeHook(hotInstance, col) {
  const currentWidth = hotInstance.getColWidth(col);
  if (!latestColumnWidthCache.has(hotInstance)) {
    latestColumnWidthCache.set(hotInstance, {
      [col]: {
        width: currentWidth
      }
    });
  } else {
    const cache = latestColumnWidthCache.get(hotInstance);
    if (cache[col]?.width !== currentWidth) {
      latestColumnWidthCache.set(hotInstance, {
        ...cache,
        [col]: {
          width: currentWidth
        }
      });
    }
  }
  if (!beforeColumnResizeHookRegistered.has(hotInstance)) {
    hotInstance.addHook("beforeColumnResize", (...args) => {
      const newSize = args[0];
      const columnIndex = args[1];
      const cache = latestColumnWidthCache.get(hotInstance);
      if (cache?.[columnIndex]?.width !== newSize) {
        latestColumnWidthCache.set(hotInstance, {
          ...cache,
          [columnIndex]: {
            width: newSize
          }
        });
      }
    });
    beforeColumnResizeHookRegistered.add(hotInstance);
  }
  return latestColumnWidthCache.get(hotInstance)?.[col]?.width ?? currentWidth;
}
function recalculateChipsVisibility(columnWidth, chipsContainer, rootDocument) {
  const containerWidth = columnWidth;
  const chips = chipsContainer.querySelectorAll(`.${CHIP_CLASS}`);
  for (let i = 0; i < chips.length; i++) {
    chips[i].style.display = "";
  }
  if (containerWidth === null || chips.length === 0) {
    return;
  }
  let indicator = chipsContainer.querySelector(`.${OVERFLOW_INDICATOR_CLASS}`);
  if (!indicator) {
    indicator = createOverflowIndicator(rootDocument, chips.length);
    indicator.style.visibility = "hidden";
    chipsContainer.appendChild(indicator);
  } else {
    indicator.style.display = "";
    indicator.style.visibility = "hidden";
  }
  const containerStyles = rootDocument.defaultView.getComputedStyle(chipsContainer);
  const gap = parseFloat(containerStyles.gap) || 0;
  const indicatorWidth = indicator.offsetWidth;
  let totalWidth = 0;
  let visibleCount = 0;
  for (let i = 0; i < chips.length; i++) {
    const chipWidth = chips[i].offsetWidth;
    const chipGap = i < chips.length - 1 ? gap : 0;
    const nextWidth = totalWidth + chipWidth + chipGap;
    const needsIndicatorSpace = i < chips.length - 1;
    const availableWidth = containerWidth - (needsIndicatorSpace ? indicatorWidth + gap : 0);
    if (nextWidth <= availableWidth) {
      totalWidth = nextWidth;
      visibleCount += 1;
    } else {
      break;
    }
  }
  const hiddenCount = chips.length - visibleCount;
  if (hiddenCount > 0) {
    for (let i = visibleCount; i < chips.length; i++) {
      chips[i].style.display = "none";
    }
    indicator.textContent = `+${hiddenCount}`;
    indicator.style.visibility = "visible";
  } else {
    indicator.style.display = "none";
  }
}
function handleChipsOverflow(columnWidth, chipsContainer, rootDocument) {
  recalculateChipsVisibility(columnWidth, chipsContainer, rootDocument);
}
function removeValueByKey(array, keyToRemove) {
  return array.filter((item) => getItemProperty(item, "key") !== keyToRemove);
}
const RENDERER_TYPE = "multiselect";
const MULTISELECT_RENDERER_CLASS = "ht-multi-select-renderer";
const CHIPS_CONTAINER_CLASS = "ht-multi-select-chips-container";
function multiSelectRenderer(hotInstance, TD, row, col, prop, value, cellProperties) {
  baseRenderer(hotInstance, TD, row, col, prop, value, cellProperties);
  let escaped = value;
  if (isEmpty$1(escaped) && cellProperties.placeholder) {
    escaped = cellProperties.placeholder;
    escaped = stringify$1(escaped);
    fastInnerText(TD, escaped);
    return;
  }
  const { rootDocument } = hotInstance;
  const isAriaEnabled = hotInstance.getSettings().ariaTags;
  const physicalRow = hotInstance.toPhysicalRow(row);
  const physicalColumn = typeof col === "string" ? col : hotInstance.toPhysicalColumn(col);
  const sourceData = hotInstance.getSourceDataAtCell(physicalRow, physicalColumn);
  const values2 = parseValue(sourceData);
  empty$1(TD);
  addClass(TD, MULTISELECT_RENDERER_CLASS);
  if (values2.length === 0) {
    TD.appendChild(rootDocument.createTextNode(""));
    return;
  }
  const chipsContainer = rootDocument.createElement("div");
  chipsContainer.className = CHIPS_CONTAINER_CLASS;
  values2.forEach((item) => {
    const chip = createChipElement(rootDocument, item, isAriaEnabled ?? false, row, prop);
    chipsContainer.appendChild(chip);
  });
  TD.appendChild(chipsContainer);
  registerChipRemovingEvents(hotInstance, RENDERER_TYPE);
  const columnWidth = cacheColumnWidthAndRegisterResizeHook(hotInstance, col);
  handleChipsOverflow(columnWidth, chipsContainer, rootDocument);
}
function valueGetter(value) {
  if (Array.isArray(value)) {
    return arrayToString(value.map((val) => {
      return isKeyValueObject(val) ? val.value : val;
    }), ", ");
  }
  return value;
}
function valueSetter$1(newValue, row, column) {
  if (Array.isArray(newValue)) {
    const sourceDataAtCell = this.getSourceDataAtCell(this.toPhysicalRow(row), column);
    if (Array.isArray(sourceDataAtCell) && sourceDataAtCell.length > 0 && isKeyValueObject(sourceDataAtCell[0])) {
      return newValue.map((val) => {
        return isKeyValueObject(val) ? val : {
          key: val,
          value: val
        };
      });
    }
  }
  return newValue;
}
const CELL_TYPE$4 = "multiselect";
const MultiSelectCellType = {
  CELL_TYPE: CELL_TYPE$4,
  _complexDataFormat: true,
  editor: MultiSelectEditor,
  renderer: multiSelectRenderer,
  validator: multiSelectValidator,
  valueGetter,
  valueSetter: valueSetter$1,
  parsePastedValue: true
};
function getCellDecimalSeparator(cellMeta) {
  const numericFormat = cellMeta?.numericFormat;
  const locale = numericFormat?.culture ?? cellMeta?.locale;
  if (typeof locale === "string" && locale.length > 0) {
    try {
      const decimalPart = new Intl.NumberFormat(locale).formatToParts(1.1).find(({ type }) => type === "decimal");
      if (decimalPart?.value === "." || decimalPart?.value === ",") {
        return decimalPart.value;
      }
    } catch {
    }
  }
  const pattern = numericFormat?.pattern;
  if (typeof pattern === "string") {
    const dotIndex = pattern.lastIndexOf(".");
    const commaIndex = pattern.lastIndexOf(",");
    if (dotIndex > -1 && commaIndex > -1) {
      return dotIndex > commaIndex ? "." : ",";
    }
    if (commaIndex > -1 && dotIndex === -1) {
      return ".";
    }
    if (dotIndex > -1 && commaIndex === -1) {
      return ".";
    }
  }
}
function valueSetter(newValue, _row, _column, cellMeta) {
  if (typeof newValue !== "string") {
    return newValue;
  }
  const decimalSeparator = getCellDecimalSeparator(cellMeta);
  if (isNumericLike(newValue) || isCommaThousandsGroupedInteger(newValue, decimalSeparator) || isDotThousandsGroupedInteger(newValue, decimalSeparator) || isDotThousandsGroupedFloat(newValue, decimalSeparator)) {
    const parsedNumber = getParsedNumber(newValue, {
      decimalSeparator
    });
    return isNullish(parsedNumber) ? newValue : parsedNumber;
  }
  return newValue;
}
const CELL_TYPE$3 = "numeric";
const NumericCellType = {
  CELL_TYPE: CELL_TYPE$3,
  editor: NumericEditor,
  renderer: numericRenderer,
  validator: numericValidator,
  dataType: "number",
  valueSetter,
  valueFormatter: valueFormatter$1
};
const CELL_TYPE$2 = "password";
const PasswordCellType = {
  CELL_TYPE: CELL_TYPE$2,
  editor: PasswordEditor,
  renderer: passwordRenderer,
  copyable: false
};
const CELL_TYPE$1 = "select";
const SelectCellType = {
  CELL_TYPE: CELL_TYPE$1,
  editor: SelectEditor,
  renderer: selectRenderer
};
const CELL_TYPE = "time";
const TimeCellType = {
  CELL_TYPE,
  editor: TimeEditor,
  renderer: timeRenderer,
  validator: timeValidator,
  sourceDataValidator,
  sourceDataWarningMessage: SOURCE_DATA_WARNING_MESSAGE$1,
  valueFormatter: valueFormatter$2
};
function registerAllCellTypes() {
  _register(AutocompleteCellType);
  _register(CheckboxCellType);
  _register(DateCellType);
  _register(DropdownCellType);
  _register(HandsontableCellType);
  _register(IntlDateCellType);
  _register(IntlTimeCellType);
  _register(MultiSelectCellType);
  _register(NumericCellType);
  _register(PasswordCellType);
  _register(SelectCellType);
  _register(TextCellType);
  _register(TimeCellType);
}
const hardConflicts = [];
function isIncompatibleSettingActive(settings, incompatibleSettingKey) {
  return !!settings[incompatibleSettingKey];
}
function registerConflict(blockedTargetKeyOrKeys, incompatibleSettingKeys) {
  if (Array.isArray(blockedTargetKeyOrKeys)) {
    if (typeof incompatibleSettingKeys !== "string") {
      throwWithCause("registerConflict(blockedTargetKeys[], incompatibleSettingKeys) expects incompatibleSettingKeys to be a string.");
    }
    for (let i = 0; i < blockedTargetKeyOrKeys.length; i += 1) {
      hardConflicts.push({
        blockedKey: blockedTargetKeyOrKeys[i],
        incompatibleSettingKey: incompatibleSettingKeys
      });
    }
    return;
  }
  if (typeof blockedTargetKeyOrKeys !== "string") {
    throwWithCause("registerConflict expects a string blocked target key when the first argument is not an array.");
  }
  const blockedKey = blockedTargetKeyOrKeys;
  if (Array.isArray(incompatibleSettingKeys)) {
    for (let i = 0; i < incompatibleSettingKeys.length; i += 1) {
      const incompatibleSettingKey = incompatibleSettingKeys[i];
      if (typeof incompatibleSettingKey !== "string") {
        throwWithCause("registerConflict(blockedTargetKey, incompatibleSettingKeys) expects incompatibleSettingKeys to be a string array.");
      }
      hardConflicts.push({
        blockedKey,
        incompatibleSettingKey
      });
    }
    return;
  }
  if (typeof incompatibleSettingKeys === "string") {
    hardConflicts.push({
      blockedKey,
      incompatibleSettingKey: incompatibleSettingKeys
    });
    return;
  }
  throwWithCause("Invalid registerConflict arguments.");
}
function getHardConflict(settings, blockedKey) {
  for (let i = 0; i < hardConflicts.length; i += 1) {
    const entry = hardConflicts[i];
    if (entry.blockedKey === blockedKey && isIncompatibleSettingActive(settings, entry.incompatibleSettingKey)) {
      return entry;
    }
  }
  return null;
}
function _check_private_redeclaration$18(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$_(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$_(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$_(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$_(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$_(receiver, privateMap, "get");
  return _class_apply_descriptor_get$_(receiver, descriptor);
}
function _class_private_field_init$_(obj, privateMap, value) {
  _check_private_redeclaration$18(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$_(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$_(receiver, privateMap, "set");
  _class_apply_descriptor_set$_(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$M(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$M(obj, privateSet) {
  _check_private_redeclaration$18(obj, privateSet);
  privateSet.add(obj);
}
const DEPS_TYPE_CHECKERS = /* @__PURE__ */ new Map([
  [
    "plugin",
    hasPlugin
  ],
  [
    "cell-type",
    hasItem$1
  ],
  [
    "editor",
    hasItem$4
  ],
  [
    "renderer",
    hasItem$3
  ],
  [
    "validator",
    hasItem$2
  ]
]);
const defaultMainSettingSymbol = /* @__PURE__ */ Symbol("mainSetting");
const PLUGIN_KEY$D = "base";
const missingDepsMsgs = [];
let initializedPlugins = null;
var _pluginSettings = /* @__PURE__ */ new WeakMap(), _hooks = /* @__PURE__ */ new WeakMap(), _wrapSettingWithValidator = /* @__PURE__ */ new WeakSet(), _isRelevantToSettings = /* @__PURE__ */ new WeakSet();
class BasePlugin {
  /**
  * Returns the plugin key used to identify and look up this plugin in Handsontable settings and the plugin registry.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$D;
  }
  /**
  * The SETTING_KEYS getter defines the keys that, when present in the config object, trigger the plugin update
  * after the updateSettings calls.
  * - When it returns true, the plugin updates after all updateSettings calls, regardless of the contents of the
  * config object.
  * - When it returns false, the plugin never updates on updateSettings calls.
  *
  * @returns {string[] | boolean}
  */
  static get SETTING_KEYS() {
    return [
      this.PLUGIN_KEY
    ];
  }
  /**
  * The DEFAULT_SETTINGS getter defines the plugin default settings.
  *
  * @returns {object}
  */
  static get DEFAULT_SETTINGS() {
    return {};
  }
  /**
  * Validators for plugin settings.
  *
  * @type {Function|object|null}
  */
  static get SETTINGS_VALIDATORS() {
    return null;
  }
  /**
  * Initializes the plugin by resolving its name, applying settings, and checking required dependencies.
  */
  init() {
    this.pluginName = this.hot.getPluginName(this);
    this.updatePluginSettings(this.hot.getSettings()[this.constructor.PLUGIN_KEY]);
    const pluginDeps = this.constructor.PLUGIN_DEPS;
    const deps = Array.isArray(pluginDeps) ? pluginDeps : [];
    if (deps.length > 0) {
      const missingDependencies = [];
      deps.forEach((dependency) => {
        const [type, moduleName] = dependency.split(":");
        if (!DEPS_TYPE_CHECKERS.has(type)) {
          throwWithCause(`Unknown plugin dependency type "${type}" was found.`);
        }
        if (!DEPS_TYPE_CHECKERS.get(type)(moduleName)) {
          missingDependencies.push(` - ${moduleName} (${type})`);
        }
      });
      if (missingDependencies.length > 0) {
        const errorMsg = [
          `The ${this.pluginName} plugin requires the following modules:
`,
          `${missingDependencies.join("\n")}
`
        ].join("");
        missingDepsMsgs.push(errorMsg);
      }
    }
    if (!initializedPlugins) {
      initializedPlugins = getPluginsNames();
    }
    if (initializedPlugins.indexOf(this.pluginName) >= 0) {
      initializedPlugins.splice(initializedPlugins.indexOf(this.pluginName), 1);
    }
    this.hot.addHookOnce("afterPluginsInitialized", () => {
      if (this.isEnabled && this.isEnabled()) {
        if (this.isHardConflictBlocked()) {
          this.hot.getSettings()[this.constructor.PLUGIN_KEY] = false;
          return;
        }
        this.enablePlugin();
      }
    });
    const isAllPluginsAreInitialized = initializedPlugins.length === 0;
    if (isAllPluginsAreInitialized) {
      if (missingDepsMsgs.length > 0) {
        const errorMsg = [
          `${missingDepsMsgs.join("\n")}
`,
          "You have to import and register them manually."
        ].join("");
        missingDepsMsgs.length = 0;
        throwWithCause(errorMsg);
      }
      this.hot.runHooks("afterPluginsInitialized");
    }
    this.initialized = true;
  }
  /**
  * Whether this plugin is blocked by a registered hard conflict (another top-level setting is truthy; for example
  * nestedRows blocks pagination, or manualRowMove blocks dataProvider). Emits a console warning when blocked.
  *
  * @returns {boolean} true if the plugin must not enable.
  */
  isHardConflictBlocked() {
    const pluginKey = this.constructor.PLUGIN_KEY;
    const conflict = getHardConflict(this.hot.getSettings(), pluginKey);
    if (conflict) {
      const { incompatibleSettingKey } = conflict;
      warn$1(toSingleLine`The \`${pluginKey}\` plugin cannot be used with the \`${incompatibleSettingKey}\` option.\x20
        This combination is not supported. The plugin will remain disabled.`);
      return true;
    }
    return false;
  }
  /**
  * Enable plugin for this Handsontable instance.
  */
  enablePlugin() {
    this.enabled = true;
  }
  /**
  * Disable plugin for this Handsontable instance.
  */
  disablePlugin() {
    this.eventManager?.clear();
    this.clearHooks();
    this.enabled = false;
  }
  /**
  * Gets the plugin settings. If there is no setting under the provided key, it returns the default setting
  * provided by the DEFAULT_SETTINGS static property of the class.
  *
  * @param {string} [settingName] The setting name. If the setting name is not provided, it returns
  * the whole plugin's settings object.
  * @returns {T}
  */
  getSetting(settingName) {
    const defaultSettings = this.constructor.DEFAULT_SETTINGS;
    const settingsValidators = this.constructor.SETTINGS_VALIDATORS;
    if (settingName === void 0) {
      if (isPlainObject$1(_class_private_field_get$_(this, _pluginSettings))) {
        return assignObjectDefaults(_class_private_field_get$_(this, _pluginSettings), defaultSettings);
      }
      return _class_private_field_get$_(this, _pluginSettings);
    }
    let settingValue;
    if ((Array.isArray(_class_private_field_get$_(this, _pluginSettings)) || isPlainObject$1(_class_private_field_get$_(this, _pluginSettings))) && defaultSettings[defaultMainSettingSymbol] === settingName) {
      if (Array.isArray(_class_private_field_get$_(this, _pluginSettings))) {
        settingValue = _class_private_field_get$_(this, _pluginSettings);
      } else {
        settingValue = _class_private_field_get$_(this, _pluginSettings)[settingName] ?? defaultSettings[settingName];
      }
    } else if (settingName.includes(".")) {
      const pluginValue = isPlainObject$1(_class_private_field_get$_(this, _pluginSettings)) ? getProperty(_class_private_field_get$_(this, _pluginSettings), settingName) : void 0;
      const defaultValue = getProperty(defaultSettings, settingName);
      if (isPlainObject$1(pluginValue)) {
        settingValue = assignObjectDefaults(pluginValue, isPlainObject$1(defaultValue) ? defaultValue : {});
      } else {
        settingValue = pluginValue !== void 0 ? pluginValue : defaultValue;
      }
    } else if (isPlainObject$1(_class_private_field_get$_(this, _pluginSettings))) {
      settingValue = assignObjectDefaults(_class_private_field_get$_(this, _pluginSettings), defaultSettings)[settingName];
    } else {
      settingValue = defaultSettings[settingName];
    }
    if (typeof settingValue === "function" && settingsValidators && typeof settingsValidators === "object") {
      const validator = settingsValidators[settingName];
      if (validator && typeof validator === "function") {
        const wrappedFn = settingValue;
        return _class_private_method_get$M(this, _wrapSettingWithValidator, wrapSettingWithValidator).call(this, wrappedFn, validator, settingName);
      }
    }
    return settingValue;
  }
  /**
  * Update plugin settings.
  *
  * @param {*} newSettings New settings.
  * @returns {object} Updated settings object.
  */
  updatePluginSettings(newSettings) {
    const settingsValidators = this.constructor.SETTINGS_VALIDATORS;
    if (settingsValidators && typeof settingsValidators === "function" && typeof newSettings !== "object") {
      const isValid = settingsValidators(newSettings);
      if (isValid === false) {
        warn$1(`${this.pluginName} Plugin: option is not valid and it will be ignored.`);
        return;
      }
      _class_private_field_set$_(this, _pluginSettings, newSettings);
      return _class_private_field_get$_(this, _pluginSettings);
    }
    if (settingsValidators && typeof settingsValidators === "object" && isPlainObject$1(newSettings)) {
      if (!isPlainObject$1(_class_private_field_get$_(this, _pluginSettings))) {
        _class_private_field_set$_(this, _pluginSettings, {
          ...this.constructor.DEFAULT_SETTINGS
        });
      }
      const currentSettings = isPlainObject$1(_class_private_field_get$_(this, _pluginSettings)) ? _class_private_field_get$_(this, _pluginSettings) : {};
      Object.keys(settingsValidators).forEach((key) => {
        if (!(key in newSettings)) {
          return;
        }
        const validator = settingsValidators[key];
        const isValid = validator ? validator(newSettings[key]) : true;
        if (isValid === false) {
          warn$1(`${this.pluginName} Plugin: "${key}" option is not valid and it will be ignored.`);
          return;
        }
        currentSettings[key] = newSettings[key];
      });
      return _class_private_field_get$_(this, _pluginSettings);
    }
    _class_private_field_set$_(this, _pluginSettings, newSettings);
    return newSettings;
  }
  /**
  * Registers a hook listener and tracks it so it can be removed automatically when the plugin is disabled.
  */
  addHook(name, callback, orderIndex) {
    _class_private_field_get$_(this, _hooks)[name] = _class_private_field_get$_(this, _hooks)[name] || [];
    const hooks = _class_private_field_get$_(this, _hooks)[name];
    this.hot.addHook(name, callback, orderIndex);
    hooks.push(callback);
    _class_private_field_get$_(this, _hooks)[name] = hooks;
  }
  /**
  * Remove all hooks listeners by hook name.
  *
  * @param {string} name The hook name.
  */
  removeHooks(name) {
    arrayEach(_class_private_field_get$_(this, _hooks)[name] || [], (callback) => {
      this.hot.removeHook(name, callback);
    });
  }
  /**
  * Clear all hooks.
  */
  clearHooks() {
    const hooks = _class_private_field_get$_(this, _hooks);
    objectEach(hooks, (callbacks, name) => this.removeHooks(name));
    Object.keys(hooks).forEach((key) => delete hooks[key]);
  }
  /**
  * Register function which will be immediately called after all plugins initialized.
  *
  * @param {Function} callback The listener function to add.
  */
  callOnPluginsReady(callback) {
    if (this.isPluginsReady) {
      callback();
    } else {
      this.pluginsInitializedCallbacks.push(callback);
    }
  }
  /**
  * On after plugins initialized listener.
  *
  * @private
  */
  onAfterPluginsInitialized() {
    arrayEach(this.pluginsInitializedCallbacks, (callback) => callback());
    this.pluginsInitializedCallbacks.length = 0;
    this.isPluginsReady = true;
  }
  /**
  * On update settings listener. Re-applies hard conflict rules when settings change so a plugin that is already
  * enabled disables if a conflicting top-level setting becomes truthy, even when this plugin's SETTING_KEYS do not
  * overlap the updateSettings payload.
  *
  * @private
  * @param {object} newSettings New set of settings passed to the updateSettings method.
  */
  onUpdateSettings(newSettings) {
    if (!this.isEnabled) {
      return;
    }
    const relevantToSettings = _class_private_method_get$M(this, _isRelevantToSettings, isRelevantToSettings).call(this, newSettings);
    if (this.enabled && !this.isEnabled()) {
      this.disablePlugin();
    }
    if (!this.enabled && this.isEnabled()) {
      if (this.isHardConflictBlocked()) {
        return;
      }
      this.enablePlugin();
    }
    if (this.enabled && this.isEnabled() && this.isHardConflictBlocked()) {
      this.disablePlugin();
      return;
    }
    if (this.enabled && this.isEnabled() && relevantToSettings) {
      this.updatePluginSettings(newSettings[this.constructor.PLUGIN_KEY]);
      this.updatePlugin(newSettings);
    }
  }
  /**
  * Updates the plugin to use the latest options you have specified.
  *
  * @private
  */
  updatePlugin(newSettings) {
  }
  /**
  * Destroy plugin.
  */
  destroy() {
    _class_private_field_set$_(this, _pluginSettings, null);
    this.eventManager?.destroy();
    this.clearHooks();
    objectEach(this, (_value, property) => {
      if (property !== "hot") {
        Reflect.set(this, property, null);
      }
    });
    delete this.t;
    Reflect.deleteProperty(this, "hot");
  }
  /**
  * @param {object} hotInstance Handsontable instance.
  */
  constructor(hotInstance) {
    _class_private_method_init$M(this, _wrapSettingWithValidator);
    _class_private_method_init$M(this, _isRelevantToSettings);
    _class_private_field_init$_(this, _pluginSettings, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$_(this, _hooks, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$_(this, _pluginSettings, null);
    this.eventManager = new EventManager(this);
    this.pluginName = null;
    this.pluginsInitializedCallbacks = [];
    this.isPluginsReady = false;
    this.enabled = false;
    this.initialized = false;
    _class_private_field_set$_(this, _hooks, {});
    defineGetter(this, "hot", hotInstance, {
      writable: false
    });
    initializedPlugins = null;
    this.hot.addHook("afterPluginsInitialized", () => this.onAfterPluginsInitialized());
    this.hot.addHook("afterUpdateSettings", (newSettings) => {
      this.onUpdateSettings(newSettings);
    });
    this.hot.addHook("beforeInit", () => this.init());
  }
}
function wrapSettingWithValidator(settingFn, validator, settingName) {
  return (...args) => {
    const result = settingFn(...args);
    const isValid = validator(result);
    if (isValid === false) {
      const formattedArgs = args.map((arg) => typeof arg === "string" ? `"${arg}"` : "").join(", ");
      const source = args.length > 0 ? formattedArgs : "";
      warn$1(`${this.pluginName} Plugin: "${settingName}" function (${source}) result                is not valid and will be ignored.`);
      return;
    }
    return result;
  };
}
function isRelevantToSettings(settings) {
  if (!settings) {
    return false;
  }
  const settingKeys = this.constructor.SETTING_KEYS;
  if (typeof settingKeys === "boolean") {
    return settingKeys;
  }
  for (let i = 0; i < settingKeys.length; i++) {
    if (settings[settingKeys[i]] !== void 0) {
      return true;
    }
  }
  return false;
}
let GhostTable$1 = class GhostTable {
  /**
  * Add row.
  *
  * @param {number} row Visual row index.
  * @param {Map} samples Samples Map object.
  */
  addRow(row, samples) {
    if (this.columns.length) {
      throwWithCause("Doesn't support multi-dimensional table");
    }
    if (!this.rows.length) {
      this.container = this.createContainer(this.hot.rootElement.className);
    }
    const rowObject = {
      row
    };
    this.rows.push(rowObject);
    this.samples = samples;
    this.table = this.createTable(this.hot.table.className);
    this.table.colGroup.appendChild(this.createColGroupsCol(row));
    this.table.tr.appendChild(this.createRow(row));
    this.container.container.appendChild(this.table.fragment);
    rowObject.table = this.table.table;
  }
  /**
  * Add a row consisting of the column headers.
  *
  * @param {Map} samples A map with sampled table values.
  */
  addColumnHeadersRow(samples) {
    const colHeader = this.hot.getColHeader(0);
    if (colHeader !== null && colHeader !== void 0) {
      const rowObject = {
        row: -1
      };
      this.rows.push(rowObject);
      this.container = this.createContainer(this.hot.rootElement.className);
      this.samples = samples;
      this.table = this.createTable(this.hot.table.className);
      this.table.colGroup.appendChild(this.createColGroupsCol());
      this.appendColumnHeadersRow();
      this.container.container.appendChild(this.table.fragment);
      rowObject.table = this.table.table;
    }
  }
  /**
  * Add column.
  *
  * @param {number} column Visual column index.
  * @param {Map} samples A map with sampled table values.
  */
  addColumn(column, samples) {
    if (this.rows.length) {
      throwWithCause("Doesn't support multi-dimensional table");
    }
    if (!this.columns.length) {
      this.container = this.createContainer(this.hot.rootElement.className);
    }
    const columnObject = {
      col: column
    };
    this.columns.push(columnObject);
    this.samples = samples;
    this.table = this.createTable(this.hot.table.className);
    if (this.getSetting("useHeaders") && this.hot.getColHeader(column) !== null) {
      this.hot.view.appendColHeader(column, this.table.th, void 0, -1);
    }
    this.table.tBody.appendChild(this.createCol(column));
    this.container.container.appendChild(this.table.fragment);
    columnObject.table = this.table.table;
  }
  /**
  * Get calculated heights.
  *
  * @param {Function} callback Callback which will be fired for each calculated row.
  */
  getHeights(callback) {
    if (!this.injected) {
      this.injectTable();
    }
    arrayEach(this.rows, (row) => {
      const { height } = row.table.getBoundingClientRect();
      callback(row.row, Math.round(height));
    });
  }
  /**
  * Get calculated widths.
  *
  * @param {Function} callback Callback which will be fired for each calculated column.
  */
  getWidths(callback) {
    if (!this.injected) {
      this.injectTable();
    }
    arrayEach(this.columns, (column) => {
      const { width } = column.table.getBoundingClientRect();
      callback(column.col, Math.ceil(width));
    });
  }
  /**
  * Set the Ghost Table settings to the provided object.
  *
  * @param {object} settings New Ghost Table Settings.
  */
  setSettings(settings) {
    this.settings = settings;
  }
  /**
  * Set a single setting of the Ghost Table.
  *
  * @param {string} name Setting name.
  * @param {*} value Setting value.
  */
  setSetting(name, value) {
    if (!this.settings) {
      this.settings = {
        useHeaders: true
      };
    }
    this.settings[name] = value;
  }
  /**
  * Get the Ghost Table settings.
  *
  * @returns {object|null}
  */
  getSettings() {
    return this.settings;
  }
  /**
  * Get a single Ghost Table setting.
  *
  * @param {string} name The setting name to get.
  * @returns {boolean|null}
  */
  getSetting(name) {
    if (this.settings) {
      return this.settings[name];
    }
    return null;
  }
  /**
  * Create colgroup col elements.
  *
  * @param {number} row Visual row index.
  * @returns {DocumentFragment}
  */
  createColGroupsCol(row) {
    const fragment = this.hot.rootDocument.createDocumentFragment();
    if (this.hot.hasRowHeaders()) {
      fragment.appendChild(this.createColElement(-1, -1));
    }
    this.samples.forEach((sample) => {
      arrayEach(sample.strings, (string) => {
        fragment.appendChild(this.createColElement(string.col, row));
      });
    });
    return fragment;
  }
  /**
  * Create table row element.
  *
  * @param {number} row Visual row index.
  * @returns {DocumentFragment} Returns created table row elements.
  */
  createRow(row) {
    const rootDocument = this.hot.rootDocument;
    const fragment = rootDocument.createDocumentFragment();
    const th = rootDocument.createElement("th");
    if (this.hot.hasRowHeaders()) {
      this.hot.view.appendRowHeader(row, th);
      fragment.appendChild(th);
    }
    this.samples.forEach((sample) => {
      arrayEach(sample.strings, (string) => {
        const column = string.col;
        const cellProperties = this.hot.getCellMeta(row, column);
        const renderer = this.hot.getCellRenderer(cellProperties);
        const td = rootDocument.createElement("td");
        td.setAttribute("ghost-table", "1");
        renderer(this.hot, td, row, column, this.hot.colToProp(column), string.value, cellProperties);
        fragment.appendChild(td);
      });
    });
    return fragment;
  }
  /**
  * Creates DOM elements for headers and appends them to the THEAD element of the table.
  */
  appendColumnHeadersRow() {
    const rootDocument = this.hot.rootDocument;
    const domFragment = rootDocument.createDocumentFragment();
    const columnHeaders = [];
    if (this.hot.hasRowHeaders()) {
      const th = rootDocument.createElement("th");
      columnHeaders.push([
        -1,
        th
      ]);
      domFragment.appendChild(th);
    }
    this.samples.forEach((sample) => {
      arrayEach(sample.strings, (string) => {
        const column = string.col;
        const th = rootDocument.createElement("th");
        columnHeaders.push([
          column,
          th
        ]);
        domFragment.appendChild(th);
      });
    });
    this.table.tHead.appendChild(domFragment);
    arrayEach(columnHeaders, (columnHeader) => {
      const [column, th] = columnHeader;
      this.hot.view.appendColHeader(column, th);
    });
  }
  /**
  * Create table column elements.
  *
  * @param {number} column Visual column index.
  * @returns {DocumentFragment} Returns created column table column elements.
  */
  createCol(column) {
    const rootDocument = this.hot.rootDocument;
    const fragment = rootDocument.createDocumentFragment();
    this.samples.forEach((sample) => {
      arrayEach(sample.strings, (string) => {
        const row = string.row;
        const cellProperties = this.hot.getCellMeta(row, column);
        const renderer = this.hot.getCellRenderer(cellProperties);
        const td = rootDocument.createElement("td");
        const tr = rootDocument.createElement("tr");
        td.setAttribute("ghost-table", "1");
        renderer(this.hot, td, row, column, this.hot.colToProp(column), string.value, cellProperties);
        tr.appendChild(td);
        fragment.appendChild(tr);
      });
    });
    return fragment;
  }
  /**
  * Remove table from document and reset internal state.
  */
  clean() {
    this.rows.length = 0;
    this.rows[-1] = void 0;
    this.columns.length = 0;
    if (this.samples) {
      this.samples.clear();
    }
    this.samples = null;
    this.removeTable();
  }
  /**
  * Inject generated table into document.
  *
  * @param {HTMLElement} [parent=null] The element to which the ghost table is injected.
  */
  injectTable(parent = null) {
    if (!this.injected) {
      (parent || this.hot.rootElement).appendChild(this.container.fragment);
      this.injected = true;
    }
  }
  /**
  * Remove table from document.
  */
  removeTable() {
    if (this.injected && this.container.container.parentNode) {
      this.container.container.parentNode.removeChild(this.container.container);
      this.container = null;
      this.injected = false;
    }
  }
  /**
  * Create col element.
  *
  * @param {number} column Visual column index.
  * @param {number} row Visual row index.
  * @returns {HTMLElement}
  */
  createColElement(column, row) {
    const col = this.hot.rootDocument.createElement("col");
    let colspan = 0;
    if (row >= 0 && column >= 0) {
      colspan = Number(this.hot.getCellMeta(row, column).colspan);
    }
    let width = this.hot.getColWidth(column);
    if (colspan > 1) {
      for (let nextColumn = column + 1; nextColumn < column + colspan; nextColumn++) {
        width += this.hot.getColWidth(nextColumn);
      }
    }
    col.style.width = `${width}px`;
    return col;
  }
  /**
  * Create table element.
  *
  * @param {string} className The CSS classes to add.
  * @returns {object}
  */
  createTable(className = "") {
    const rootDocument = this.hot.rootDocument;
    const fragment = rootDocument.createDocumentFragment();
    const table = rootDocument.createElement("table");
    const tHead = rootDocument.createElement("thead");
    const tBody = rootDocument.createElement("tbody");
    const colGroup = rootDocument.createElement("colgroup");
    const tr = rootDocument.createElement("tr");
    const th = rootDocument.createElement("th");
    if (this.isVertical()) {
      table.appendChild(colGroup);
    }
    if (this.isHorizontal()) {
      tr.appendChild(th);
      tHead.appendChild(tr);
      table.style.tableLayout = "auto";
      table.style.width = "auto";
    }
    table.appendChild(tHead);
    if (this.isVertical()) {
      tBody.appendChild(tr);
    }
    table.appendChild(tBody);
    addClass(table, className);
    fragment.appendChild(table);
    return {
      fragment,
      table,
      tHead,
      tBody,
      colGroup,
      tr,
      th
    };
  }
  /**
  * Create container for tables.
  *
  * @param {string} className The CSS classes to add.
  * @returns {object}
  */
  createContainer(className = "") {
    const rootDocument = this.hot.rootDocument;
    const fragment = rootDocument.createDocumentFragment();
    const container = rootDocument.createElement("div");
    const containerClassName = `htGhostTable htAutoSize ${className.trim()}`;
    addClass(container, containerClassName);
    fragment.appendChild(container);
    return {
      fragment,
      container
    };
  }
  /**
  * Checks if table is raised vertically (checking rows).
  *
  * @returns {boolean}
  */
  isVertical() {
    return !!(this.rows.length && !this.columns.length);
  }
  /**
  * Checks if table is raised horizontally (checking columns).
  *
  * @returns {boolean}
  */
  isHorizontal() {
    return !!(this.columns.length && !this.rows.length);
  }
  /**
  * Initializes the ghost table utility with a reference to the Handsontable instance used for DOM context.
  */
  constructor(hotInstance) {
    this.hot = null;
    this.container = null;
    this.injected = false;
    this.rows = [];
    this.columns = [];
    this.samples = null;
    this.settings = {
      useHeaders: true
    };
    this.table = null;
    this.hot = hotInstance;
  }
};
class SamplesGenerator {
  /**
  * Number of samples to take of each value length.
  *
  * @type {number}
  */
  static get SAMPLE_COUNT() {
    return 3;
  }
  /**
  * Get the sample count for this instance.
  *
  * @returns {number}
  */
  getSampleCount() {
    if (this.customSampleCount) {
      return this.customSampleCount;
    }
    return SamplesGenerator.SAMPLE_COUNT;
  }
  /**
  * Set the sample count.
  *
  * @param {number} sampleCount Number of samples to be collected.
  */
  setSampleCount(sampleCount) {
    this.customSampleCount = sampleCount;
  }
  /**
  * Set if the generator should accept duplicate values.
  *
  * @param {boolean} allowDuplicates `true` to allow duplicate values.
  */
  setAllowDuplicates(allowDuplicates) {
    this.allowDuplicates = allowDuplicates;
  }
  /**
  * Sets the sampler to the mode where it will generate samples for hidden indexes.
  *
  * @param {boolean} includeHidden `true` to include hidden indexes, `false` otherwise.
  */
  setIncludeHidden(includeHidden) {
    this.includeHidden = includeHidden;
  }
  /**
  * Generate samples for row. You can control which area should be sampled by passing `rowRange` object and `colRange` object.
  *
  * @param {object|number} rowRange The rows range to generate the samples.
  * @param {object} colRange The column range to generate the samples.
  * @returns {object}
  */
  generateRowSamples(rowRange, colRange) {
    return this.generateSamples("row", colRange, rowRange);
  }
  /**
  * Generate samples for column. You can control which area should be sampled by passing `colRange` object and `rowRange` object.
  *
  * @param {object} colRange Column index.
  * @param {object} rowRange Column index.
  * @returns {object}
  */
  generateColumnSamples(colRange, rowRange) {
    return this.generateSamples("col", rowRange, colRange);
  }
  /**
  * Generate collection of samples.
  *
  * @param {string} type Type to generate. Can be `col` or `row`.
  * @param {object} range The range to generate the samples.
  * @param {object|number} specifierRange The range to generate the samples.
  * @returns {Map}
  */
  generateSamples(type, range, specifierRange) {
    const samples = /* @__PURE__ */ new Map();
    const { from, to } = typeof specifierRange === "number" ? {
      from: specifierRange,
      to: specifierRange
    } : specifierRange;
    rangeEach(from, to, (index2) => {
      const sample = this.generateSample(type, range, index2);
      samples.set(index2, sample);
    });
    return samples;
  }
  /**
  * Generate sample for specified type (`row` or `col`).
  *
  * @param {string} type Samples type `row` or `col`.
  * @param {object} range The range to generate the samples.
  * @param {number} specifierValue The range to generate the samples.
  * @returns {Map}
  */
  generateSample(type, range, specifierValue) {
    if (type !== "row" && type !== "col") {
      throwWithCause("Unsupported sample type");
    }
    const samples = /* @__PURE__ */ new Map();
    const computedKey = type === "row" ? "col" : "row";
    const sampledValues = [];
    rangeEach(range.from, range.to, (index2) => {
      const data = type === "row" ? this.dataFactory(specifierValue, index2, this) : this.dataFactory(index2, specifierValue, this);
      if (data === false) {
        return;
      }
      const { value, bundleSeed } = data;
      const hasCustomBundleSeed = typeof bundleSeed === "string" && bundleSeed.length > 0;
      let seed;
      if (hasCustomBundleSeed) {
        seed = bundleSeed;
      } else if (isPlainObject$1(value)) {
        seed = `${Object.keys(value).length}`;
      } else if (Array.isArray(value)) {
        seed = `${value.length}`;
      } else {
        seed = `${stringify$1(value).length}`;
      }
      if (!samples.has(seed)) {
        samples.set(seed, {
          needed: this.getSampleCount(),
          strings: []
        });
      }
      const sample = samples.get(seed);
      if (sample && sample.needed) {
        const duplicate = sampledValues.indexOf(value) > -1;
        if (!duplicate || this.allowDuplicates || hasCustomBundleSeed) {
          sample.strings.push({
            value,
            [computedKey]: index2
          });
          sampledValues.push(value);
          sample.needed -= 1;
        }
      }
    });
    return samples;
  }
  /**
  * Initializes the samples generator with the data factory function used to retrieve cell values during sampling.
  */
  constructor(dataFactory) {
    this.samples = null;
    this.dataFactory = null;
    this.customSampleCount = null;
    this.allowDuplicates = false;
    this.includeHidden = false;
    this.dataFactory = dataFactory;
  }
}
function _check_private_redeclaration$17(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$Z(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$Z(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$Z(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$Z(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$Z(receiver, privateMap, "get");
  return _class_apply_descriptor_get$Z(receiver, descriptor);
}
function _class_private_field_init$Z(obj, privateMap, value) {
  _check_private_redeclaration$17(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$Z(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$Z(receiver, privateMap, "set");
  _class_apply_descriptor_set$Z(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$L(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$L(obj, privateSet) {
  _check_private_redeclaration$17(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("modifyAutoColumnSizeSeed");
const PLUGIN_KEY$C = "autoColumnSize";
const PLUGIN_PRIORITY$C = 10;
const COLUMN_SIZE_MAP_NAME = "autoColumnSize";
var _isInitialized$1 = /* @__PURE__ */ new WeakMap(), _cachedColumnHeaders = /* @__PURE__ */ new WeakMap(), _visualColumnsToRefresh = /* @__PURE__ */ new WeakMap(), _disposeMapObserver$3 = /* @__PURE__ */ new WeakMap(), _calculateSpecificColumnsWidth = /* @__PURE__ */ new WeakSet(), _fillGhostTableWithSamples = /* @__PURE__ */ new WeakSet(), _updateColumnWidthsMapBasedOnGhostTable = /* @__PURE__ */ new WeakSet(), _onBeforeRender$2 = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$8 = /* @__PURE__ */ new WeakMap(), _onBeforeChange$1 = /* @__PURE__ */ new WeakMap(), _onBeforeColumnResize$1 = /* @__PURE__ */ new WeakMap(), _onInit$4 = /* @__PURE__ */ new WeakMap(), _onAfterFormulasValuesUpdate$2 = /* @__PURE__ */ new WeakMap();
class AutoColumnSize extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$C;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$C;
  }
  /**
  * Returns `true` so the plugin updates on every `updateSettings` call, regardless of config object contents.
  */
  static get SETTING_KEYS() {
    return true;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      useHeaders: true,
      samplingRatio: null,
      allowSampleDuplicates: false
    };
  }
  /**
  * Returns the number of columns processed in a single calculation step during asynchronous sizing.
  */
  static get CALCULATION_STEP() {
    return 50;
  }
  /**
  * Returns the maximum number of columns whose widths are calculated synchronously before switching to async mode.
  */
  static get SYNC_CALCULATION_LIMIT() {
    return 50;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link #enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return this.hot.getSettings()[PLUGIN_KEY$C] !== false && !this.hot.getSettings().colWidths;
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.ghostTable.setSetting("useHeaders", this.getSetting("useHeaders"));
    this.samplesGenerator.setAllowDuplicates(this.getSetting("allowSampleDuplicates"));
    const samplingRatio = this.getSetting("samplingRatio");
    if (samplingRatio && !isNaN(samplingRatio)) {
      this.samplesGenerator.setSampleCount(parseInt(String(samplingRatio), 10));
    }
    this.addHook("afterLoadData", _class_private_field_get$Z(this, _onAfterLoadData$8));
    this.addHook("beforeChangeRender", _class_private_field_get$Z(this, _onBeforeChange$1));
    this.addHook("afterFormulasValuesUpdate", _class_private_field_get$Z(this, _onAfterFormulasValuesUpdate$2));
    this.addHook("beforeRender", _class_private_field_get$Z(this, _onBeforeRender$2));
    this.addHook("modifyColWidth", (width, col) => this.getColumnWidth(col, width), -10);
    this.addHook("init", _class_private_field_get$Z(this, _onInit$4));
    _class_private_field_set$Z(this, _disposeMapObserver$3, this.hot.columnIndexMapper.observeMapChange(this.columnWidthsMap, () => {
      this.hot.view?.invalidateColumnWidthCache();
    }));
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state. This method is executed when {@link Core#updateSettings} is invoked.
  */
  updatePlugin() {
    _class_private_field_set$Z(this, _visualColumnsToRefresh, this.findColumnsWhereHeaderWasChanged());
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    if (_class_private_field_get$Z(this, _disposeMapObserver$3)) {
      _class_private_field_get$Z(this, _disposeMapObserver$3).call(this);
      _class_private_field_set$Z(this, _disposeMapObserver$3, null);
    }
    super.disablePlugin();
    this.addHook("beforeColumnResize", _class_private_field_get$Z(this, _onBeforeColumnResize$1));
  }
  /**
  * Calculates widths for visible columns in the viewport only.
  */
  calculateVisibleColumnsWidth() {
    if (!this.hot.countRows()) {
      return;
    }
    const firstVisibleColumn = this.getFirstVisibleColumn();
    const lastVisibleColumn = this.getLastVisibleColumn();
    if (firstVisibleColumn === -1 || lastVisibleColumn === -1) {
      return;
    }
    const overwriteCache = this.hot.forceFullRender;
    this.calculateColumnsWidth({
      from: firstVisibleColumn,
      to: lastVisibleColumn
    }, void 0, overwriteCache);
  }
  /**
  * Calculates a columns width.
  *
  * @param {number|object} colRange Visual column index or an object with `from` and `to` visual indexes as a range.
  * @param {number|object} rowRange Visual row index or an object with `from` and `to` visual indexes as a range.
  * @param {boolean} [overwriteCache=false] If `true` the calculation will be processed regardless of whether the width exists in the cache.
  */
  calculateColumnsWidth(colRange = {
    from: 0,
    to: this.hot.countCols() - 1
  }, rowRange = {
    from: 0,
    to: this.hot.countRows() - 1
  }, overwriteCache = false) {
    const columnsRange = typeof colRange === "number" ? {
      from: colRange,
      to: colRange
    } : colRange;
    const rowsRange = typeof rowRange === "number" ? {
      from: rowRange,
      to: rowRange
    } : rowRange;
    rangeEach(columnsRange.from, columnsRange.to, (visualColumn) => {
      let physicalColumn = this.hot.toPhysicalColumn(visualColumn);
      if (physicalColumn === null) {
        physicalColumn = visualColumn;
      }
      if (overwriteCache || this.columnWidthsMap.getValueAtIndex(physicalColumn) === null && !this.hot._getColWidthFromSettings(physicalColumn)) {
        _class_private_method_get$L(this, _fillGhostTableWithSamples, fillGhostTableWithSamples).call(this, visualColumn, rowsRange);
      }
    });
    if (this.ghostTable.columns.length) {
      _class_private_method_get$L(this, _updateColumnWidthsMapBasedOnGhostTable, updateColumnWidthsMapBasedOnGhostTable).call(this);
      this.measuredColumns = columnsRange.to + 1;
      this.ghostTable.clean();
    }
  }
  /**
  * Calculates all columns width. The calculated column will be cached in the {@link AutoColumnSize#widths} property.
  * To retrieve width for specified column use {@link AutoColumnSize#getColumnWidth} method.
  *
  * @param {object|number} rowRange Row index or an object with `from` and `to` properties which define row range.
  * @param {boolean} [overwriteCache] If `true` the calculation will be processed regardless of whether the width exists in the cache.
  */
  calculateAllColumnsWidth(rowRange = {
    from: 0,
    to: this.hot.countRows() - 1
  }, overwriteCache = false) {
    let current = 0;
    const length = this.hot.countCols() - 1;
    let timer2 = 0;
    this.inProgress = true;
    const loop = () => {
      if (!this.hot) {
        cancelAnimationFrame(timer2);
        this.inProgress = false;
        return;
      }
      this.calculateColumnsWidth({
        from: current,
        to: Math.min(current + AutoColumnSize.CALCULATION_STEP, length)
      }, rowRange, overwriteCache);
      current = current + AutoColumnSize.CALCULATION_STEP + 1;
      if (current < length) {
        timer2 = requestAnimationFrame$1(loop);
      } else {
        cancelAnimationFrame(timer2);
        this.inProgress = false;
        this.hot.view.adjustElementsSize();
      }
    };
    const syncLimit = this.getSyncCalculationLimit();
    if (syncLimit >= 0) {
      this.calculateColumnsWidth({
        from: 0,
        to: syncLimit
      }, rowRange, overwriteCache);
      current = syncLimit + 1;
    }
    if (current < length) {
      loop();
    } else {
      this.inProgress = false;
    }
  }
  /**
  * Recalculates all columns width (overwrite cache values).
  */
  recalculateAllColumnsWidth() {
    if (this.hot.view.isVisible()) {
      this.calculateAllColumnsWidth({
        from: 0,
        to: this.hot.countRows() - 1
      }, true);
    }
  }
  /**
  * Gets value which tells how many columns should be calculated synchronously (rest of the columns will be calculated
  * asynchronously). The limit is calculated based on `syncLimit` set to `autoColumnSize` option (see {@link Options#autoColumnSize}).
  *
  * @returns {number}
  */
  getSyncCalculationLimit() {
    const settings = this.hot.getSettings()[PLUGIN_KEY$C];
    let limit = AutoColumnSize.SYNC_CALCULATION_LIMIT;
    const colsLimit = this.hot.countCols() - 1;
    if (isObject$1(settings)) {
      const syncLimit = settings.syncLimit;
      if (typeof syncLimit === "string" && isPercentValue(syncLimit)) {
        limit = valueAccordingPercent(colsLimit, syncLimit);
      } else {
        const numericSyncLimit = Number(syncLimit);
        limit = Number.isFinite(numericSyncLimit) ? Math.trunc(numericSyncLimit) : 0;
      }
    }
    return Math.min(limit, colsLimit);
  }
  /**
  * Gets the calculated column width.
  *
  * @param {number} column Visual column index.
  * @param {number} [defaultWidth] Default column width. It will be picked up if no calculated width found.
  * @param {boolean} [keepMinimum=true] If `true` then returned value won't be smaller then 50 (default column width).
  * @returns {number}
  */
  getColumnWidth(column, defaultWidth, keepMinimum = true) {
    let width = defaultWidth;
    if (width === void 0) {
      width = this.columnWidthsMap.getValueAtIndex(this.hot.toPhysicalColumn(column));
      if (keepMinimum && typeof width === "number") {
        width = Math.max(width, DEFAULT_COLUMN_WIDTH);
      }
    }
    return width;
  }
  /**
  * Gets the first visible column.
  *
  * @returns {number} Returns visual column index, -1 if table is not rendered or if there are no columns to base the the calculations on.
  */
  getFirstVisibleColumn() {
    return this.hot.getFirstRenderedVisibleColumn() ?? -1;
  }
  /**
  * Gets the last visible column.
  *
  * @returns {number} Returns visual column index or -1 if table is not rendered.
  */
  getLastVisibleColumn() {
    return this.hot.getLastRenderedVisibleColumn() ?? -1;
  }
  /**
  * Collects all columns which titles has been changed in comparison to the previous state.
  *
  * @private
  * @returns {Array} It returns an array of visual column indexes.
  */
  findColumnsWhereHeaderWasChanged() {
    const columnHeaders = this.hot.getColHeader();
    const changedColumns = columnHeaders.reduce((acc, columnTitle, physicalColumn) => {
      const cachedColumnsLength = _class_private_field_get$Z(this, _cachedColumnHeaders).length;
      if (cachedColumnsLength - 1 < physicalColumn || _class_private_field_get$Z(this, _cachedColumnHeaders)[physicalColumn] !== columnTitle) {
        const visualColumn = this.hot.toVisualColumn(physicalColumn);
        if (visualColumn !== null) {
          acc.push(visualColumn);
        }
      }
      if (cachedColumnsLength - 1 < physicalColumn) {
        _class_private_field_get$Z(this, _cachedColumnHeaders).push(columnTitle);
      } else {
        _class_private_field_get$Z(this, _cachedColumnHeaders)[physicalColumn] = columnTitle;
      }
      return acc;
    }, []);
    return changedColumns;
  }
  /**
  * Clears cache of calculated column widths. If you want to clear only selected columns pass an array with their indexes.
  * Otherwise whole cache will be cleared.
  *
  * @param {number[]} [physicalColumns] List of physical column indexes to clear.
  */
  clearCache(physicalColumns) {
    if (Array.isArray(physicalColumns)) {
      this.hot.batchExecution(() => {
        physicalColumns.forEach((physicalIndex) => {
          this.columnWidthsMap.setValueAtIndex(physicalIndex, null);
        });
      }, true);
    } else {
      this.columnWidthsMap.clear();
    }
  }
  /**
  * Checks if all widths were calculated. If not then return `true` (need recalculate).
  *
  * @returns {boolean}
  */
  isNeedRecalculate() {
    return !!this.columnWidthsMap.getValues().slice(0, this.measuredColumns).filter((item) => item === null).length;
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    this.ghostTable.clean();
    super.destroy();
  }
  /**
  * Initializes the plugin, registers the column widths map, and sets up the column resize hook.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$L(this, _calculateSpecificColumnsWidth), _class_private_method_init$L(this, _fillGhostTableWithSamples), _class_private_method_init$L(this, _updateColumnWidthsMapBasedOnGhostTable), _class_private_field_init$Z(this, _isInitialized$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _cachedColumnHeaders, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _visualColumnsToRefresh, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _disposeMapObserver$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _onBeforeRender$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _onAfterLoadData$8, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _onBeforeChange$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _onBeforeColumnResize$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _onInit$4, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Z(this, _onAfterFormulasValuesUpdate$2, {
      writable: true,
      value: void 0
    }), /**
    * Instance of {@link GhostTable} for rows and columns size calculations.
    *
    * @private
    * @type {GhostTable}
    */
    this.ghostTable = new GhostTable$1(this.hot), /**
    * Instance of {@link SamplesGenerator} for generating samples necessary for columns width calculations.
    *
    * @private
    * @type {SamplesGenerator}
    * @fires Hooks#modifyAutoColumnSizeSeed
    */
    this.samplesGenerator = new SamplesGenerator((row, column) => {
      const physicalRow = this.hot.toPhysicalRow(row);
      const physicalColumn = this.hot.toPhysicalColumn(column);
      if (this.hot.rowIndexMapper.isHidden(physicalRow) || this.hot.columnIndexMapper.isHidden(physicalColumn)) {
        return false;
      }
      const cellMeta = this.hot.getCellMeta(row, column);
      let cellValue = "";
      let seedValue = "";
      if (cellMeta.hidden) {
        return false;
      }
      if (!cellMeta.spanned) {
        seedValue = this.hot.getDataAtCell(row, column);
        cellValue = seedValue;
        if (typeof cellMeta.valueFormatter === "function") {
          cellValue = cellMeta.valueFormatter(cellValue, cellMeta);
          seedValue = cellValue;
        }
      }
      let bundleSeed = "";
      if (this.hot.hasHook("modifyAutoColumnSizeSeed")) {
        bundleSeed = String(this.hot.runHooks("modifyAutoColumnSizeSeed", bundleSeed, cellMeta, seedValue) ?? bundleSeed);
      }
      return {
        value: cellValue,
        bundleSeed
      };
    }), /**
    * `true` if the size calculation is in progress.
    *
    * @type {boolean}
    */
    this.inProgress = false, /**
    * Number of already measured columns (we already know their sizes).
    *
    * @type {number}
    */
    this.measuredColumns = 0, /**
    * PhysicalIndexToValueMap to keep and track widths for physical column indexes.
    *
    * @private
    * @type {PhysicalIndexToValueMap}
    */
    this.columnWidthsMap = new PhysicalIndexToValueMap(), _class_private_field_set$Z(this, _isInitialized$1, false), _class_private_field_set$Z(this, _cachedColumnHeaders, []), _class_private_field_set$Z(this, _visualColumnsToRefresh, []), _class_private_field_set$Z(this, _disposeMapObserver$3, null), _class_private_field_set$Z(this, _onBeforeRender$2, () => {
      this.calculateVisibleColumnsWidth();
      if (!this.inProgress) {
        _class_private_method_get$L(this, _calculateSpecificColumnsWidth, calculateSpecificColumnsWidth).call(this, _class_private_field_get$Z(this, _visualColumnsToRefresh));
        _class_private_field_set$Z(this, _visualColumnsToRefresh, []);
      }
    }), _class_private_field_set$Z(this, _onAfterLoadData$8, (_sourceData, isFirstLoad) => {
      if (!isFirstLoad) {
        this.recalculateAllColumnsWidth();
      }
    }), _class_private_field_set$Z(this, _onBeforeChange$1, (changes) => {
      const changedColumns = changes.reduce((acc, [, columnProperty]) => {
        const visualColumn = this.hot.propToCol(columnProperty);
        if (visualColumn !== null && Number.isInteger(visualColumn) && acc.indexOf(visualColumn) === -1) {
          acc.push(visualColumn);
        }
        return acc;
      }, []);
      _class_private_field_get$Z(this, _visualColumnsToRefresh).push(...changedColumns);
    }), _class_private_field_set$Z(this, _onBeforeColumnResize$1, (size, column, isDblClick) => {
      let newSize = size;
      if (isDblClick) {
        this.calculateColumnsWidth(column, void 0, true);
        newSize = this.getColumnWidth(column, void 0, false) ?? newSize;
      }
      return newSize;
    }), _class_private_field_set$Z(this, _onInit$4, () => {
      _class_private_field_set$Z(this, _cachedColumnHeaders, this.hot.getColHeader());
      this.recalculateAllColumnsWidth();
      _class_private_field_set$Z(this, _isInitialized$1, true);
    }), _class_private_field_set$Z(this, _onAfterFormulasValuesUpdate$2, (changes) => {
      if (!_class_private_field_get$Z(this, _isInitialized$1)) {
        return;
      }
      const formulasPlugin = this.hot.getPlugin("formulas");
      const sheetId = formulasPlugin?.sheetId;
      const changedColumns = changes.reduce((acc, change) => {
        const changeRecord = change;
        if (sheetId !== null && sheetId !== void 0 && changeRecord.address?.sheet !== sheetId) {
          return acc;
        }
        const physicalColumn = Number(changeRecord.address?.col);
        if (Number.isInteger(physicalColumn)) {
          const visualColumn = this.hot.toVisualColumn(physicalColumn);
          if (visualColumn !== null && acc.indexOf(visualColumn) === -1) {
            acc.push(visualColumn);
          }
        }
        return acc;
      }, []);
      _class_private_field_get$Z(this, _visualColumnsToRefresh).push(...changedColumns);
    });
    this.hot.columnIndexMapper.registerMap(COLUMN_SIZE_MAP_NAME, this.columnWidthsMap);
    this.addHook("beforeColumnResize", _class_private_field_get$Z(this, _onBeforeColumnResize$1));
  }
}
function calculateSpecificColumnsWidth(visualColumns) {
  const rowsRange = {
    from: 0,
    to: this.hot.countRows() - 1
  };
  visualColumns.forEach((visualColumn) => {
    const physicalColumn = this.hot.toPhysicalColumn(visualColumn);
    if (physicalColumn === null) {
      return;
    }
    if (!this.hot._getColWidthFromSettings(physicalColumn)) {
      _class_private_method_get$L(this, _fillGhostTableWithSamples, fillGhostTableWithSamples).call(this, visualColumn, rowsRange);
    }
  });
  if (this.ghostTable.columns.length) {
    _class_private_method_get$L(this, _updateColumnWidthsMapBasedOnGhostTable, updateColumnWidthsMapBasedOnGhostTable).call(this);
    this.ghostTable.clean();
  }
}
function fillGhostTableWithSamples(visualColumn, rowsRange) {
  const samples = this.samplesGenerator.generateColumnSamples(visualColumn, rowsRange);
  samples.forEach((sample, column) => this.ghostTable.addColumn(column, sample));
}
function updateColumnWidthsMapBasedOnGhostTable() {
  this.hot.batchExecution(() => {
    this.ghostTable.getWidths((visualColumn, width) => {
      const physicalColumn = this.hot.toPhysicalColumn(visualColumn);
      this.columnWidthsMap.setValueAtIndex(physicalColumn, width);
    });
  }, true);
}
function findColumnAtX(hotInstance, row, startColumn, endColumn, relativeX) {
  let accumulatedX = 0;
  for (let column = startColumn; column <= endColumn; column++) {
    const cellElement = hotInstance.getCell(row, column, true);
    if (!cellElement) {
      continue;
    }
    const width = cellElement.offsetWidth;
    if (relativeX < accumulatedX + width) {
      return column;
    }
    accumulatedX += width;
    const { colspan } = hotInstance.getCellMeta(row, column);
    if (colspan !== void 0 && colspan > 1) {
      column += colspan - 1;
    }
  }
  return null;
}
function findRowAtY(hotInstance, column, startRow, endRow, relativeY) {
  let accumulatedY = 0;
  for (let row = startRow; row <= endRow; row++) {
    const cellElement = hotInstance.getCell(row, column, true);
    if (!cellElement) {
      continue;
    }
    const height = cellElement.offsetHeight;
    if (relativeY < accumulatedY + height) {
      return row;
    }
    accumulatedY += height;
    const { rowspan } = hotInstance.getCellMeta(row, column);
    if (rowspan !== void 0 && rowspan > 1) {
      row += rowspan - 1;
    }
  }
  return null;
}
function getCellCoordsFromMousePosition(hotInstance, mouseX, mouseY) {
  const { view, columnIndexMapper, rowIndexMapper } = hotInstance;
  const isRtl2 = hotInstance.isRtl();
  const numberOfFixedColumnsStart = view.countNotHiddenFixedColumnsStart();
  const numberOfFixedRowsTop = view.countNotHiddenFixedRowsTop();
  const numberOfFixedRowsBottom = view.countNotHiddenFixedRowsBottom();
  const firstPartiallyVisibleRow = hotInstance.getFirstPartiallyVisibleRow();
  const lastPartiallyVisibleRow = hotInstance.getLastPartiallyVisibleRow();
  const firstPartiallyVisibleColumn = hotInstance.getFirstPartiallyVisibleColumn();
  const lastPartiallyVisibleColumn = hotInstance.getLastPartiallyVisibleColumn();
  const tableOffset = hotInstance.rootElement.getBoundingClientRect();
  const columnHeaderHeight = hotInstance.hasColHeaders() ? view.getColumnHeaderHeight() : 0;
  const rowHeaderWidth = hotInstance.hasRowHeaders() ? view.getRowHeaderWidth() : 0;
  const { rootWindow } = hotInstance;
  const tableViewportLeft = view.isHorizontallyScrollableByWindow() ? Math.min(0, tableOffset.left) : tableOffset.left;
  const tableViewportTop = view.isVerticallyScrollableByWindow() ? Math.min(0, tableOffset.top) : tableOffset.top;
  const tableViewportRight = view.isHorizontallyScrollableByWindow() ? rootWindow.innerWidth : tableOffset.left + view.getViewportWidth() + rowHeaderWidth;
  const tableViewportBottom = view.isVerticallyScrollableByWindow() ? rootWindow.innerHeight : tableOffset.top + view.getViewportHeight() + columnHeaderHeight;
  const clampedX = clamp(mouseX, tableViewportLeft, tableViewportRight);
  const clampedY = clamp(mouseY, tableViewportTop, tableViewportBottom);
  let foundColumn = null;
  if (numberOfFixedColumnsStart > 0) {
    const firstFixedColumn = columnIndexMapper.getVisualFromRenderableIndex(0);
    const lastFixedColumn = columnIndexMapper.getVisualFromRenderableIndex(numberOfFixedColumnsStart - 1);
    const firstNonHiddenColumn = firstFixedColumn !== null ? columnIndexMapper.getNearestNotHiddenIndex(firstFixedColumn, 1) : null;
    if (firstNonHiddenColumn !== null && lastFixedColumn !== null) {
      const fixedCell = hotInstance.getCell(firstPartiallyVisibleRow, firstNonHiddenColumn, true);
      if (fixedCell instanceof HTMLElement) {
        const fixedCellRect = fixedCell.getBoundingClientRect();
        const fixedRelativeX = isRtl2 ? fixedCellRect.right - clampedX : clampedX - fixedCellRect.left;
        foundColumn = findColumnAtX(hotInstance, firstPartiallyVisibleRow, firstNonHiddenColumn, lastFixedColumn, fixedRelativeX);
      }
    }
  }
  if (foundColumn === null) {
    const scrollCell = hotInstance.getCell(firstPartiallyVisibleRow, firstPartiallyVisibleColumn, true);
    if (scrollCell instanceof HTMLElement) {
      const scrollCellRect = scrollCell.getBoundingClientRect();
      const scrollRelativeX = isRtl2 ? scrollCellRect.right - clampedX : clampedX - scrollCellRect.left;
      foundColumn = findColumnAtX(hotInstance, firstPartiallyVisibleRow, firstPartiallyVisibleColumn, lastPartiallyVisibleColumn, scrollRelativeX);
      if (foundColumn === null) {
        foundColumn = scrollRelativeX < 0 ? firstPartiallyVisibleColumn ?? 0 : lastPartiallyVisibleColumn ?? hotInstance.countCols() - 1;
      }
    } else {
      foundColumn = firstPartiallyVisibleColumn ?? 0;
    }
  }
  let foundRow = null;
  if (numberOfFixedRowsTop > 0) {
    const firstFixedRow = rowIndexMapper.getVisualFromRenderableIndex(0);
    const lastFixedRow = rowIndexMapper.getVisualFromRenderableIndex(numberOfFixedRowsTop - 1);
    const firstNonHiddenRow = firstFixedRow !== null ? rowIndexMapper.getNearestNotHiddenIndex(firstFixedRow, 1) : null;
    if (firstNonHiddenRow !== null && lastFixedRow !== null) {
      const fixedCell = hotInstance.getCell(firstNonHiddenRow, firstPartiallyVisibleColumn, true);
      if (fixedCell instanceof HTMLElement) {
        const fixedCellRect = fixedCell.getBoundingClientRect();
        const fixedRelativeY = clampedY - fixedCellRect.top;
        foundRow = findRowAtY(hotInstance, firstPartiallyVisibleColumn, firstNonHiddenRow, lastFixedRow, fixedRelativeY);
      }
    }
  }
  if (foundRow === null && numberOfFixedRowsBottom > 0) {
    const totalSourceRows = rowIndexMapper.getNotHiddenIndexesLength();
    const bottomStartRow = rowIndexMapper.getVisualFromRenderableIndex(totalSourceRows - numberOfFixedRowsBottom);
    const bottomEndRow = rowIndexMapper.getVisualFromRenderableIndex(totalSourceRows - 1);
    const bottomStartNonHiddenRow = bottomStartRow !== null ? rowIndexMapper.getNearestNotHiddenIndex(bottomStartRow, 1) : null;
    const bottomEndNonHiddenRow = bottomEndRow !== null ? rowIndexMapper.getNearestNotHiddenIndex(bottomEndRow, -1) : null;
    if (bottomStartNonHiddenRow !== null && bottomEndNonHiddenRow !== null) {
      const fixedBottomCell = hotInstance.getCell(bottomStartNonHiddenRow, firstPartiallyVisibleColumn, true);
      if (fixedBottomCell instanceof HTMLElement) {
        const fixedBottomCellRect = fixedBottomCell.getBoundingClientRect();
        const fixedBottomRelativeY = clampedY - fixedBottomCellRect.top;
        if (fixedBottomRelativeY >= 0) {
          foundRow = findRowAtY(hotInstance, firstPartiallyVisibleColumn, bottomStartNonHiddenRow, bottomEndNonHiddenRow, fixedBottomRelativeY);
          if (foundRow === null) {
            foundRow = bottomEndNonHiddenRow;
          }
        }
      }
    }
  }
  if (foundRow === null) {
    const scrollCell = hotInstance.getCell(firstPartiallyVisibleRow, firstPartiallyVisibleColumn, true);
    if (scrollCell instanceof HTMLElement) {
      const scrollCellRect = scrollCell.getBoundingClientRect();
      const scrollRelativeY = clampedY - scrollCellRect.top;
      foundRow = findRowAtY(hotInstance, firstPartiallyVisibleColumn, firstPartiallyVisibleRow, lastPartiallyVisibleRow, scrollRelativeY);
      if (foundRow === null) {
        foundRow = scrollRelativeY < 0 ? firstPartiallyVisibleRow ?? 0 : lastPartiallyVisibleRow ?? hotInstance.countRows() - 1;
      }
    } else {
      foundRow = firstPartiallyVisibleRow ?? 0;
    }
  }
  if (foundRow === null || foundColumn === null) {
    throwWithCause("Failed to resolve cell coordinates from mouse position.");
  }
  return hotInstance._createCellCoords(foundRow, foundColumn);
}
function getDragDirectionAndRange(startSelection, endSelection, cellCoordsFactory) {
  let startOfDragCoords;
  let endOfDragCoords;
  let directionOfDrag;
  if (endSelection[0] === startSelection[0] && endSelection[1] < startSelection[1]) {
    directionOfDrag = "left";
    startOfDragCoords = cellCoordsFactory(endSelection[0], endSelection[1]);
    endOfDragCoords = cellCoordsFactory(endSelection[2], startSelection[1] - 1);
  } else if (endSelection[2] === startSelection[2] && endSelection[0] === startSelection[0] && endSelection[3] > startSelection[3]) {
    directionOfDrag = "right";
    startOfDragCoords = cellCoordsFactory(endSelection[0], startSelection[3] + 1);
    endOfDragCoords = cellCoordsFactory(endSelection[2], endSelection[3]);
  } else if (endSelection[0] < startSelection[0] && endSelection[1] === startSelection[1]) {
    directionOfDrag = "up";
    startOfDragCoords = cellCoordsFactory(endSelection[0], endSelection[1]);
    endOfDragCoords = cellCoordsFactory(startSelection[0] - 1, endSelection[3]);
  } else if (endSelection[2] > startSelection[2] && endSelection[1] === startSelection[1]) {
    directionOfDrag = "down";
    startOfDragCoords = cellCoordsFactory(startSelection[2] + 1, endSelection[1]);
    endOfDragCoords = cellCoordsFactory(endSelection[2], endSelection[3]);
  }
  if (startOfDragCoords) {
    startOfDragCoords.normalize();
  }
  if (endOfDragCoords) {
    endOfDragCoords.normalize();
  }
  return {
    directionOfDrag,
    startOfDragCoords,
    endOfDragCoords
  };
}
const DIRECTIONS = Object.freeze({
  horizontal: "horizontal",
  vertical: "vertical"
});
function _check_private_redeclaration$16(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$Y(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$Y(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$Y(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$Y(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$Y(receiver, privateMap, "get");
  return _class_apply_descriptor_get$Y(receiver, descriptor);
}
function _class_private_field_init$Y(obj, privateMap, value) {
  _check_private_redeclaration$16(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$Y(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$Y(receiver, privateMap, "set");
  _class_apply_descriptor_set$Y(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$K(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$K(obj, privateSet) {
  _check_private_redeclaration$16(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("modifyAutofillRange");
Hooks.getSingleton().register("beforeAutofill");
Hooks.getSingleton().register("afterAutofill");
const PLUGIN_KEY$B = "autofill";
const PLUGIN_PRIORITY$B = 20;
const SETTING_KEY = "fillHandle";
const INSERT_ROW_ALTER_ACTION_NAME = "insert_row_below";
const INTERVAL_FOR_ADDING_ROW = 200;
var _currentDragDirection = /* @__PURE__ */ new WeakMap(), _lastMouseClientPosition = /* @__PURE__ */ new WeakMap(), _adjustFillDataForDirection = /* @__PURE__ */ new WeakSet(), _applySourceDataExtension = /* @__PURE__ */ new WeakSet(), _extendFillDataWithSourceData = /* @__PURE__ */ new WeakSet(), _onCellCornerDblClick = /* @__PURE__ */ new WeakMap(), _onAfterCellCornerMouseDown = /* @__PURE__ */ new WeakMap(), _onBeforeCellMouseOver = /* @__PURE__ */ new WeakSet(), _onMouseUp$5 = /* @__PURE__ */ new WeakSet(), _onMouseMove$5 = /* @__PURE__ */ new WeakSet(), _onAfterScroll$2 = /* @__PURE__ */ new WeakMap();
class Autofill extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$B;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$B;
  }
  /**
  * Returns the setting keys that trigger a plugin update when changed via `updateSettings`.
  */
  static get SETTING_KEYS() {
    return [
      SETTING_KEY
    ];
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      direction: void 0,
      autoInsertRow: true
    };
  }
  /**
  * Returns validator functions for each plugin setting to verify their values are valid before applying them.
  */
  static get SETTINGS_VALIDATORS() {
    return {
      direction: (value) => value === void 0 || typeof value === "string" && Object.values(DIRECTIONS).includes(value),
      autoInsertRow: (value) => typeof value === "boolean"
    };
  }
  /**
  * Checks if the plugin is enabled in the Handsontable settings.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[SETTING_KEY];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const settings = this.hot.getSettings()[SETTING_KEY];
    const pluginSettings = {};
    if (typeof settings === "string") {
      pluginSettings.direction = settings;
    } else if (settings && typeof settings === "object") {
      Object.assign(pluginSettings, settings);
    }
    this.updatePluginSettings(pluginSettings);
    if (this.getSetting("direction")) {
      this.directions = [
        this.getSetting("direction")
      ];
    } else {
      this.directions = Object.values(DIRECTIONS);
    }
    this.autoInsertRow = this.getSetting("autoInsertRow");
    if (this.directions.length === 1 && this.directions.includes("horizontal")) {
      this.autoInsertRow = false;
    }
    this.registerEvents();
    this.addHook("afterOnCellCornerMouseDown", _class_private_field_get$Y(this, _onAfterCellCornerMouseDown));
    this.addHook("afterOnCellCornerDblClick", _class_private_field_get$Y(this, _onCellCornerDblClick));
    this.addHook("beforeOnCellMouseOver", (_, coords) => _class_private_method_get$K(this, _onBeforeCellMouseOver, onBeforeCellMouseOver).call(this, coords));
    this.addHook("afterScroll", _class_private_field_get$Y(this, _onAfterScroll$2));
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - `autofill`
  *  - [`fillHandle`](@/api/options.md#fillhandle)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
  }
  /**
  * Gets selection data.
  *
  * @private
  * @param {boolean} [useSource=false] If `true`, returns copyable source data instead of copyable data.
  * @returns {object[]} Ranges Array of objects with properties `startRow`, `startCol`, `endRow` and `endCol`.
  */
  getSelectionData(useSource = false) {
    const selection = this.hot.getSelectedRangeLast();
    if (!selection) {
      return [];
    }
    const { row: startRow, col: startCol } = selection.getTopStartCorner();
    const { row: endRow, col: endCol } = selection.getBottomEndCorner();
    const copyableRanges = this.hot.runHooks("modifyCopyableRange", [
      {
        startRow,
        startCol,
        endRow,
        endCol
      }
    ]);
    const copyableRows = [];
    const copyableColumns = [];
    const data = [];
    arrayEach(copyableRanges, (range) => {
      for (let visualRow = range.startRow; visualRow <= range.endRow; visualRow += 1) {
        if (copyableRows.indexOf(visualRow) === -1) {
          copyableRows.push(visualRow);
        }
      }
      for (let visualColumn = range.startCol; visualColumn <= range.endCol; visualColumn += 1) {
        if (copyableColumns.indexOf(visualColumn) === -1) {
          copyableColumns.push(visualColumn);
        }
      }
    });
    arrayEach(copyableRows, (row) => {
      const rowSet = [];
      arrayEach(copyableColumns, (column) => {
        const r = row;
        const c = column;
        const sourceDataAtSource = useSource ? this.hot.getSourceDataAtCell(r, c) : null;
        if (useSource && (isObject$1(sourceDataAtSource) || Array.isArray(sourceDataAtSource))) {
          rowSet.push(this.hot.getCopyableSourceData(r, c));
        } else {
          rowSet.push(this.hot.getCopyableData(r, c));
        }
      });
      data.push(rowSet);
    });
    return data;
  }
  /**
  * Try to apply fill values to the area in fill border, omitting the selection border.
  *
  * @private
  * @returns {boolean} Reports if fill was applied.
  *
  * @fires Hooks#modifyAutofillRange
  * @fires Hooks#beforeAutofill
  * @fires Hooks#afterAutofill
  */
  fillIn() {
    if (this.hot.selection.highlight.getFill().isEmpty()) {
      return false;
    }
    const [fillStartRow, fillStartColumn, fillEndRow, fillEndColumn] = this.hot.selection.highlight.getFill().getVisualCorners();
    const selectionRangeLast = this.hot.getSelectedRangeLast();
    if (!selectionRangeLast) {
      return false;
    }
    const topStartCorner = selectionRangeLast.getTopStartCorner();
    const bottomEndCorner = selectionRangeLast.getBottomEndCorner();
    this.resetSelectionOfDraggedArea();
    const cornersOfSelectedCells = [
      topStartCorner.row ?? 0,
      topStartCorner.col ?? 0,
      bottomEndCorner.row ?? 0,
      bottomEndCorner.col ?? 0
    ];
    const cornersOfSelectionAndDragAreas = this.hot.runHooks("modifyAutofillRange", [
      Math.min(topStartCorner.row ?? 0, fillStartRow ?? 0),
      Math.min(topStartCorner.col ?? 0, fillStartColumn ?? 0),
      Math.max(bottomEndCorner.row ?? 0, fillEndRow ?? 0),
      Math.max(bottomEndCorner.col ?? 0, fillEndColumn ?? 0)
    ], cornersOfSelectedCells);
    const { directionOfDrag, startOfDragCoords, endOfDragCoords } = getDragDirectionAndRange(cornersOfSelectedCells, cornersOfSelectionAndDragAreas, (row, column) => this.hot._createCellCoords(row, column));
    if (startOfDragCoords && endOfDragCoords && startOfDragCoords.row !== null && startOfDragCoords.col !== null && endOfDragCoords.row !== null && endOfDragCoords.col !== null && startOfDragCoords.row > -1 && startOfDragCoords.col > -1) {
      const startRow = startOfDragCoords.row;
      const startCol = startOfDragCoords.col;
      const endRow = endOfDragCoords.row;
      const endCol = endOfDragCoords.col;
      const startCoords = {
        row: startRow,
        col: startCol
      };
      const endCoords = {
        row: endRow,
        col: endCol
      };
      const selectionData = this.getSelectionData();
      const selectionSourceData = this.getSelectionData(true);
      const sourceRange = selectionRangeLast.clone();
      const targetRange = this.hot._createCellRange(startOfDragCoords, startOfDragCoords, endOfDragCoords);
      const beforeAutofillHookResult = this.hot.runHooks("beforeAutofill", selectionData, sourceRange, targetRange, directionOfDrag);
      if (beforeAutofillHookResult === false) {
        this.hot.selection.highlight.getFill().clear();
        this.hot.render();
        return false;
      }
      let fillData = beforeAutofillHookResult;
      const res = beforeAutofillHookResult;
      fillData = _class_private_method_get$K(this, _adjustFillDataForDirection, adjustFillDataForDirection).call(this, res, fillData, directionOfDrag, startRow, endRow, startCol, endCol);
      fillData = _class_private_method_get$K(this, _applySourceDataExtension, applySourceDataExtension).call(this, fillData, selectionSourceData, startCoords, endCoords, directionOfDrag);
      this.hot.populateFromArray(startRow, startCol, fillData, endRow, endCol, `${this.pluginName}.fill`, void 0);
      this.setSelection(cornersOfSelectionAndDragAreas, sourceRange);
      this.hot.runHooks("afterAutofill", fillData, sourceRange, targetRange, directionOfDrag);
      this.hot.render();
    } else {
      this.hot.view.render();
    }
    return true;
  }
  /**
  * Add new row.
  *
  * @private
  */
  addRow() {
    this.hot._registerTimeout(() => {
      this.hot.alter(INSERT_ROW_ALTER_ACTION_NAME, void 0, 1, `${this.pluginName}.fill`);
      this.addingStarted = false;
    }, INTERVAL_FOR_ADDING_ROW);
  }
  /**
  * Add new rows if they are needed to continue auto-filling values.
  *
  * @private
  */
  addNewRowIfNeeded() {
    if (!this.hot.selection.highlight.getFill().isEmpty() && this.addingStarted === false && this.autoInsertRow) {
      const bottomRow = this.hot.getSelectedRangeLast()?.getBottomEndCorner().row ?? null;
      const cornersOfSelectedDragArea = this.hot.selection.highlight.getFill().getVisualCorners();
      const nrOfTableRows = this.hot.countRows();
      if (bottomRow !== null && bottomRow < nrOfTableRows - 1 && cornersOfSelectedDragArea[2] === nrOfTableRows - 1) {
        this.addingStarted = true;
        this.addRow();
      }
    }
  }
  /**
  * Get index of last adjacent filled in row.
  *
  * @private
  * @param {Array} cornersOfSelectedCells Indexes of selection corners.
  * @returns {number} Gives number greater than or equal to zero when selection adjacent can be applied.
  *                   Or -1 when selection adjacent can't be applied.
  */
  getIndexOfLastAdjacentFilledInRow(cornersOfSelectedCells) {
    const data = this.hot.getData();
    const nrOfTableRows = this.hot.countRows();
    let lastFilledInRowIndex;
    for (let rowIndex = cornersOfSelectedCells[2] + 1; rowIndex < nrOfTableRows; rowIndex++) {
      for (let columnIndex = cornersOfSelectedCells[1]; columnIndex <= cornersOfSelectedCells[3]; columnIndex++) {
        const dataInCell = data[rowIndex][columnIndex];
        if (!isEmpty$1(dataInCell)) {
          return -1;
        }
      }
      const dataInNextLeftCell = data[rowIndex][cornersOfSelectedCells[1] - 1];
      const dataInNextRightCell = data[rowIndex][cornersOfSelectedCells[3] + 1];
      if (!isEmpty$1(dataInNextLeftCell) || !isEmpty$1(dataInNextRightCell)) {
        lastFilledInRowIndex = rowIndex;
      }
    }
    return lastFilledInRowIndex;
  }
  /**
  * Adds a selection from the start area to the specific row index.
  *
  * @private
  * @param {Array} selectStartArea Selection area from which we start to create more comprehensive selection.
  * @param {number} rowIndex The row index into the selection will be added.
  */
  addSelectionFromStartAreaToSpecificRowIndex(selectStartArea, rowIndex) {
    this.hot.selection.highlight.getFill().clear().add(this.hot._createCellCoords(selectStartArea[0], selectStartArea[1])).add(this.hot._createCellCoords(rowIndex, selectStartArea[3])).commit();
  }
  /**
  * Sets selection based on passed corners.
  *
  * When `sourceRange` is provided, the active cell (`from`) is anchored to the corner
  * of the merged selection that wasn't extended by the autofill drag. This keeps the
  * highlight at its pre-fill position instead of flipping to the top-start corner,
  * matching Google Sheets and Excel behavior.
  *
  * @private
  * @param {Array} cornersOfArea An array witch defines selection.
  * @param {CellRange} [sourceRange] Pre-fill selection range used to preserve the
  *                                  original `from` corner orientation.
  */
  setSelection(cornersOfArea, sourceRange) {
    const mappedCorners = arrayMap(cornersOfArea, (index2) => Math.max(index2, 0));
    const minRow = mappedCorners[0];
    const minCol = mappedCorners[1];
    const maxRow = mappedCorners[2];
    const maxCol = mappedCorners[3];
    let fromRow = minRow;
    let fromCol = minCol;
    let toRow = maxRow;
    let toCol = maxCol;
    if (sourceRange) {
      const { row: preMinRowOrNull, col: preMinColOrNull } = sourceRange.getTopStartCorner();
      const { row: preMaxRowOrNull, col: preMaxColOrNull } = sourceRange.getBottomEndCorner();
      const preMinRow = preMinRowOrNull ?? 0;
      const preMinCol = preMinColOrNull ?? 0;
      const preMaxRow = preMaxRowOrNull ?? 0;
      const preMaxCol = preMaxColOrNull ?? 0;
      if (minRow < preMinRow) {
        fromRow = maxRow;
      } else if (maxRow > preMaxRow) {
        fromRow = minRow;
      } else {
        fromRow = sourceRange.from.row === preMinRow ? minRow : maxRow;
      }
      if (minCol < preMinCol) {
        fromCol = maxCol;
      } else if (maxCol > preMaxCol) {
        fromCol = minCol;
      } else {
        fromCol = sourceRange.from.col === preMinCol ? minCol : maxCol;
      }
      toRow = fromRow === minRow ? maxRow : minRow;
      toCol = fromCol === minCol ? maxCol : minCol;
    }
    this.hot.selectCell(fromRow, fromCol, toRow, toCol, false, false);
  }
  /**
  * Try to select cells down to the last row in the left column and then returns if selection was applied.
  *
  * @private
  * @returns {boolean}
  */
  selectAdjacent() {
    const range = this.hot.getSelectedRangeLast();
    if (!range) {
      return false;
    }
    const topStart = range.getTopStartCorner();
    const bottomEnd = range.getBottomEndCorner();
    const cornersOfSelectedCells = [
      topStart.row ?? 0,
      topStart.col ?? 0,
      bottomEnd.row ?? 0,
      bottomEnd.col ?? 0
    ];
    const lastFilledInRowIndex = this.getIndexOfLastAdjacentFilledInRow(cornersOfSelectedCells);
    if (lastFilledInRowIndex === -1 || lastFilledInRowIndex === void 0) {
      return false;
    }
    this.addSelectionFromStartAreaToSpecificRowIndex(cornersOfSelectedCells, lastFilledInRowIndex);
    return true;
  }
  /**
  * Resets selection of dragged area.
  *
  * @private
  */
  resetSelectionOfDraggedArea() {
    this.handleDraggedCells = 0;
    this.hot.selection.highlight.getFill().clear();
  }
  /**
  * Redraws borders.
  *
  * @private
  * @param {CellCoords} cellCoords `CellCoords` coord object.
  */
  redrawBorders(cellCoords) {
    const allowedDirections = this.directions;
    const lastRange = this.hot.getSelectedRangeLast();
    if (!lastRange || !cellCoords || cellCoords.row === null || cellCoords.col === null) {
      return;
    }
    const coords = this.hot._createCellCoords(cellCoords.row, cellCoords.col);
    const highlight = lastRange.getBottomEndCorner();
    const topStartCorner = lastRange.getTopStartCorner();
    const bottomEndCorner = lastRange.getBottomEndCorner();
    const rowChanged = (coords.row ?? 0) < (topStartCorner.row ?? 0) || (coords.row ?? 0) > (bottomEndCorner.row ?? 0);
    const colChanged = (coords.col ?? 0) < (topStartCorner.col ?? 0) || (coords.col ?? 0) > (bottomEndCorner.col ?? 0);
    const isAtHighlightPosition = lastRange.includes(coords);
    if (isAtHighlightPosition) {
      _class_private_field_set$Y(this, _currentDragDirection, null);
    }
    if (_class_private_field_get$Y(this, _currentDragDirection) === "vertical" && !rowChanged && colChanged) {
      if (allowedDirections.includes("horizontal")) {
        _class_private_field_set$Y(this, _currentDragDirection, "horizontal");
      }
    } else if (_class_private_field_get$Y(this, _currentDragDirection) === "horizontal" && !colChanged && rowChanged) {
      if (allowedDirections.includes("vertical")) {
        _class_private_field_set$Y(this, _currentDragDirection, "vertical");
      }
    }
    let toRow = highlight.row;
    let toCol = highlight.col;
    if (_class_private_field_get$Y(this, _currentDragDirection) === null) {
      if (rowChanged && !colChanged && allowedDirections.includes("vertical")) {
        _class_private_field_set$Y(this, _currentDragDirection, "vertical");
      } else if (colChanged && !rowChanged && allowedDirections.includes("horizontal")) {
        _class_private_field_set$Y(this, _currentDragDirection, "horizontal");
      }
    }
    if (_class_private_field_get$Y(this, _currentDragDirection) === "vertical" && allowedDirections.includes("vertical")) {
      toRow = coords.row ?? 0;
      toCol = topStartCorner.col ?? 0;
    } else if (_class_private_field_get$Y(this, _currentDragDirection) === "horizontal" && allowedDirections.includes("horizontal")) {
      toRow = topStartCorner.row ?? 0;
      toCol = coords.col ?? 0;
    }
    const to = this.hot._createCellCoords(toRow ?? 0, toCol ?? 0);
    this.hot.selection.highlight.getFill().clear().add(lastRange.from).add(lastRange.to).add(to).commit();
    this.hot.view.render();
  }
  /**
  * Get if mouse was dragged outside.
  *
  * @private
  * @param {MouseEvent} event `mousemove` event properties.
  * @returns {boolean}
  */
  getIfMouseWasDraggedOutside(event) {
    const { documentElement } = this.hot.rootDocument;
    const tableBottom = offset(this.hot.table).top - (this.hot.rootWindow.pageYOffset || documentElement.scrollTop) + outerHeight(this.hot.table);
    const tableRight = offset(this.hot.table).left - (this.hot.rootWindow.pageXOffset || documentElement.scrollLeft) + outerWidth(this.hot.table);
    return event.clientY > tableBottom && event.clientX <= tableRight;
  }
  /**
  * Bind the events used by the plugin.
  *
  * @private
  */
  registerEvents() {
    const { documentElement } = this.hot.rootDocument;
    this.eventManager.addEventListener(documentElement, "mouseup", () => _class_private_method_get$K(this, _onMouseUp$5, onMouseUp$5).call(this));
    this.eventManager.addEventListener(documentElement, "mousemove", (event) => _class_private_method_get$K(this, _onMouseMove$5, onMouseMove$5).call(this, event));
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$K(this, _adjustFillDataForDirection), _class_private_method_init$K(this, _applySourceDataExtension), _class_private_method_init$K(this, _extendFillDataWithSourceData), _class_private_method_init$K(this, _onBeforeCellMouseOver), _class_private_method_init$K(this, _onMouseUp$5), _class_private_method_init$K(this, _onMouseMove$5), _class_private_field_init$Y(this, _currentDragDirection, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Y(this, _lastMouseClientPosition, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Y(this, _onCellCornerDblClick, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Y(this, _onAfterCellCornerMouseDown, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Y(this, _onAfterScroll$2, {
      writable: true,
      value: void 0
    }), /**
    * Specifies if adding new row started.
    *
    * @private
    * @type {boolean}
    */
    this.addingStarted = false, /**
    * Specifies if there was mouse down on the cell corner.
    *
    * @private
    * @type {boolean}
    */
    this.mouseDownOnCellCorner = false, /**
    * Specifies if mouse was dragged outside Handsontable.
    *
    * @private
    * @type {boolean}
    */
    this.mouseDragOutside = false, /**
    * Specifies how many cell levels were dragged using the handle.
    *
    * @private
    * @type {boolean}
    */
    this.handleDraggedCells = 0, /**
    * Specifies allowed directions of drag (`'horizontal'` or '`vertical`').
    *
    * @private
    * @type {string[]}
    */
    this.directions = [], /**
    * Specifies if can insert new rows if needed.
    *
    * @private
    * @type {boolean}
    */
    this.autoInsertRow = false, _class_private_field_set$Y(this, _currentDragDirection, null), _class_private_field_set$Y(this, _lastMouseClientPosition, {
      clientX: 0,
      clientY: 0
    }), _class_private_field_set$Y(this, _onCellCornerDblClick, () => {
      const selectionApplied = this.selectAdjacent();
      if (selectionApplied) {
        this.fillIn();
      }
    }), _class_private_field_set$Y(this, _onAfterCellCornerMouseDown, () => {
      this.handleDraggedCells = 1;
      this.mouseDownOnCellCorner = true;
      _class_private_field_set$Y(this, _currentDragDirection, null);
    }), _class_private_field_set$Y(this, _onAfterScroll$2, () => {
      if (this.mouseDownOnCellCorner) {
        _class_private_method_get$K(this, _onMouseMove$5, onMouseMove$5).call(this, _class_private_field_get$Y(this, _lastMouseClientPosition));
      }
    });
  }
}
function adjustFillDataForDirection(res, fillData, directionOfDrag, startRow, endRow, startCol, endCol) {
  if (directionOfDrag !== "up" && directionOfDrag !== "left" || res.length === 1 && res[0].length === 0) {
    return fillData;
  }
  const result = [];
  if (directionOfDrag === "up") {
    const dragLength = endRow - startRow + 1;
    const fillOffset = dragLength % res.length;
    for (let i = 0; i < dragLength; i++) {
      result.push(res[(i + (res.length - fillOffset)) % res.length]);
    }
  } else {
    const dragLength = endCol - startCol + 1;
    const fillOffset = dragLength % res[0].length;
    for (let i = 0; i < res.length; i++) {
      result.push([]);
      for (let j = 0; j < dragLength; j++) {
        result[i].push(res[i][(j + (res[i].length - fillOffset)) % res[i].length]);
      }
    }
  }
  return result;
}
function applySourceDataExtension(fillData, selectionSourceData, startCoords, endCoords, directionOfDrag) {
  const hasComplexCells = selectionSourceData.some((row) => row.some((cell) => isObject$1(cell) || Array.isArray(cell)));
  if (!hasComplexCells) {
    return fillData;
  }
  const fullFillData = _class_private_method_get$K(this, _extendFillDataWithSourceData, extendFillDataWithSourceData).call(this, fillData, selectionSourceData, startCoords, endCoords, directionOfDrag);
  return fullFillData.length ? fullFillData : fillData;
}
function extendFillDataWithSourceData(fillData, selectionSourceData, startOfDragCoords, endOfDragCoords, _directionOfDrag) {
  const fullFillData = [];
  for (let rowIndex = Math.min(startOfDragCoords.row, endOfDragCoords.row); rowIndex <= Math.max(startOfDragCoords.row, endOfDragCoords.row); rowIndex += 1) {
    fullFillData.push([]);
    for (let columnIndex = Math.min(startOfDragCoords.col, endOfDragCoords.col); columnIndex <= Math.max(startOfDragCoords.col, endOfDragCoords.col); columnIndex += 1) {
      const targetCellSourceData = this.hot.getSourceDataAtCell(rowIndex, columnIndex);
      const cellMeta = this.hot.getCellMeta(rowIndex, columnIndex);
      const cellSource = cellMeta.source;
      const cellSourceFirstItem = Array.isArray(cellSource) ? cellSource[0] : void 0;
      const isComplexDataFormatCell = cellMeta._complexDataFormat || isObject$1(cellSourceFirstItem) || Array.isArray(cellSourceFirstItem);
      const relativeRowIndex = rowIndex - Math.min(startOfDragCoords.row, endOfDragCoords.row);
      const relativeColumnIndex = columnIndex - Math.min(startOfDragCoords.col, endOfDragCoords.col);
      const modRelativeRowIndex = relativeRowIndex % selectionSourceData.length;
      const selectionFirstRow = selectionSourceData[0];
      const modRelativeColumnIndex = relativeColumnIndex % selectionFirstRow.length;
      if (isObject$1(targetCellSourceData) || Array.isArray(targetCellSourceData) || isComplexDataFormatCell) {
        fullFillData[relativeRowIndex][relativeColumnIndex] = selectionSourceData[modRelativeRowIndex][modRelativeColumnIndex];
      } else {
        fullFillData[relativeRowIndex][relativeColumnIndex] = fillData[modRelativeRowIndex][modRelativeColumnIndex];
      }
    }
  }
  return fullFillData;
}
function onBeforeCellMouseOver(coords) {
  if (this.mouseDownOnCellCorner && !this.hot.view.isMouseDown() && this.handleDraggedCells) {
    this.handleDraggedCells += 1;
    if (this.hot.selection.highlight.getFill().isEmpty()) {
      this.redrawBorders(coords);
    }
    this.addNewRowIfNeeded();
  }
}
function onMouseUp$5() {
  if (this.handleDraggedCells) {
    if (this.handleDraggedCells > 1) {
      this.fillIn();
    }
    this.handleDraggedCells = 0;
    this.mouseDownOnCellCorner = false;
    _class_private_field_set$Y(this, _currentDragDirection, null);
  }
}
function onMouseMove$5(event) {
  if (this.mouseDownOnCellCorner) {
    const { clientX, clientY } = event;
    const cellCoords = getCellCoordsFromMousePosition(this.hot, clientX, clientY);
    _class_private_field_set$Y(this, _lastMouseClientPosition, {
      clientX,
      clientY
    });
    this.redrawBorders(cellCoords);
  }
  const mouseWasDraggedOutside = this.getIfMouseWasDraggedOutside(event);
  if (this.addingStarted === false && this.handleDraggedCells > 0 && mouseWasDraggedOutside) {
    this.mouseDragOutside = true;
    this.addingStarted = true;
  } else {
    this.mouseDragOutside = false;
  }
  if (this.mouseDragOutside && this.autoInsertRow) {
    this.addRow();
  }
}
function _check_private_redeclaration$15(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$X(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$X(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$X(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$X(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$X(receiver, privateMap, "get");
  return _class_apply_descriptor_get$X(receiver, descriptor);
}
function _class_private_field_init$X(obj, privateMap, value) {
  _check_private_redeclaration$15(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$X(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$X(receiver, privateMap, "set");
  _class_apply_descriptor_set$X(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$J(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$J(obj, privateSet) {
  _check_private_redeclaration$15(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$A = "autoRowSize";
const PLUGIN_PRIORITY$A = 40;
const ROW_WIDTHS_MAP_NAME = "autoRowSize";
const FIRST_COLUMN_NOT_RENDERED_CLASS_NAME = "htFirstDatasetColumnNotRendered";
const AUTO_ROW_SIZE_CLASS_NAME = "htAutoRowSize";
var _visualRowsToRefresh = /* @__PURE__ */ new WeakMap(), _disposeMapObserver$2 = /* @__PURE__ */ new WeakMap(), _isInitialized = /* @__PURE__ */ new WeakMap(), _calculateSpecificRowsHeight = /* @__PURE__ */ new WeakSet(), _toggleFirstDatasetColumnRenderedClassName = /* @__PURE__ */ new WeakSet(), _onBeforeViewRender$2 = /* @__PURE__ */ new WeakMap(), _onBeforeRender$1 = /* @__PURE__ */ new WeakMap(), _onBeforeRowResize = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$7 = /* @__PURE__ */ new WeakMap(), _onBeforeChange = /* @__PURE__ */ new WeakMap(), _onInit$3 = /* @__PURE__ */ new WeakMap(), _onAfterFormulasValuesUpdate$1 = /* @__PURE__ */ new WeakMap();
class AutoRowSize extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$A;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$A;
  }
  /**
  * Returns `true` so the plugin updates on every `updateSettings` call, regardless of config object contents.
  */
  static get SETTING_KEYS() {
    return true;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      useHeaders: true,
      samplingRatio: null,
      allowSampleDuplicates: false
    };
  }
  /**
  * Returns the number of rows processed in a single calculation step during asynchronous sizing.
  */
  static get CALCULATION_STEP() {
    return 50;
  }
  /**
  * Returns the maximum number of rows whose heights are calculated synchronously before switching to async mode.
  */
  static get SYNC_CALCULATION_LIMIT() {
    return 500;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link AutoRowSize#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    const settings = this.hot.getSettings()[PLUGIN_KEY$A];
    return settings === true || isObject$1(settings);
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.samplesGenerator.setAllowDuplicates(this.getSetting("allowSampleDuplicates"));
    const samplingRatio = this.getSetting("samplingRatio");
    if (samplingRatio && !isNaN(samplingRatio)) {
      this.samplesGenerator.setSampleCount(samplingRatio);
    }
    this.addHook("afterLoadData", _class_private_field_get$X(this, _onAfterLoadData$7));
    this.addHook("beforeChangeRender", _class_private_field_get$X(this, _onBeforeChange));
    this.addHook("beforeColumnResize", () => this.recalculateAllRowsHeight());
    this.addHook("afterFormulasValuesUpdate", _class_private_field_get$X(this, _onAfterFormulasValuesUpdate$1));
    this.addHook("beforeViewRender", _class_private_field_get$X(this, _onBeforeViewRender$2));
    this.addHook("beforeRender", _class_private_field_get$X(this, _onBeforeRender$1));
    this.addHook("modifyRowHeight", (height, row) => this.getRowHeight(row, height));
    this.addHook("init", _class_private_field_get$X(this, _onInit$3));
    this.addHook("modifyColumnHeaderHeight", () => this.getColumnHeaderHeight());
    _class_private_field_set$X(this, _disposeMapObserver$2, this.hot.rowIndexMapper.observeMapChange(this.rowHeightsMap, () => {
      this.hot.view?.invalidateRowHeightCache();
    }));
    addClass(this.hot.rootElement, AUTO_ROW_SIZE_CLASS_NAME);
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    if (_class_private_field_get$X(this, _disposeMapObserver$2)) {
      _class_private_field_get$X(this, _disposeMapObserver$2).call(this);
      _class_private_field_set$X(this, _disposeMapObserver$2, null);
    }
    this.headerHeight = null;
    removeClass(this.hot.rootElement, AUTO_ROW_SIZE_CLASS_NAME);
    super.disablePlugin();
    _class_private_method_get$J(this, _toggleFirstDatasetColumnRenderedClassName, toggleFirstDatasetColumnRenderedClassName).call(this, false);
    this.addHook("beforeRowResize", _class_private_field_get$X(this, _onBeforeRowResize));
  }
  /**
  * Calculates heights for visible rows in the viewport only.
  */
  calculateVisibleRowsHeight() {
    if (!this.hot.countCols()) {
      return;
    }
    const firstVisibleRow = this.getFirstVisibleRow();
    const lastVisibleRow = this.getLastVisibleRow();
    if (firstVisibleRow === -1 || lastVisibleRow === -1) {
      return;
    }
    const overwriteCache = this.hot.forceFullRender;
    this.calculateRowsHeight({
      from: firstVisibleRow,
      to: lastVisibleRow
    }, void 0, overwriteCache);
  }
  /**
  * Calculate a given rows height.
  *
  * @param {number|object} rowRange Row index or an object with `from` and `to` indexes as a range.
  * @param {number|object} colRange Column index or an object with `from` and `to` indexes as a range.
  * @param {boolean} [overwriteCache=false] If `true` the calculation will be processed regardless of whether the width exists in the cache.
  */
  calculateRowsHeight(rowRange = {
    from: 0,
    to: this.hot.countRows() - 1
  }, colRange = {
    from: 0,
    to: this.hot.countCols() - 1
  }, overwriteCache = false) {
    const rowsRange = typeof rowRange === "number" ? {
      from: rowRange,
      to: rowRange
    } : rowRange;
    const columnsRange = typeof colRange === "number" ? {
      from: colRange,
      to: colRange
    } : colRange;
    if (this.hot.getColHeader(0) !== null) {
      const samples = this.samplesGenerator.generateRowSamples(-1, columnsRange);
      this.ghostTable.addColumnHeadersRow(samples.get(-1));
    }
    rangeEach(rowsRange.from, rowsRange.to, (visualRow) => {
      let physicalRow = this.hot.toPhysicalRow(visualRow);
      if (physicalRow === null) {
        physicalRow = visualRow;
      }
      if (overwriteCache || this.rowHeightsMap.getValueAtIndex(physicalRow) === null) {
        const samples = this.samplesGenerator.generateRowSamples(visualRow, columnsRange);
        samples.forEach((sample, row) => this.ghostTable.addRow(row, sample));
      }
    });
    if (this.ghostTable.rows.length) {
      this.hot.batchExecution(() => {
        this.ghostTable.getHeights((row, height) => {
          if (row < 0) {
            this.headerHeight = height;
          } else {
            this.rowHeightsMap.setValueAtIndex(this.hot.toPhysicalRow(row), height);
          }
        });
      }, true);
      this.measuredRows = rowsRange.to + 1;
      this.ghostTable.clean();
    }
  }
  /**
  * Calculate all rows heights. The calculated row will be cached in the {@link AutoRowSize#heights} property.
  * To retrieve height for specified row use {@link AutoRowSize#getRowHeight} method.
  *
  * @param {object|number} colRange Row index or an object with `from` and `to` properties which define row range.
  * @param {boolean} [overwriteCache] If `true` the calculation will be processed regardless of whether the width exists in the cache.
  */
  calculateAllRowsHeight(colRange = {
    from: 0,
    to: this.hot.countCols() - 1
  }, overwriteCache = false) {
    let current = 0;
    const length = this.hot.countRows() - 1;
    let timer2 = 0;
    this.inProgress = true;
    const loop = () => {
      if (!this.hot) {
        cancelAnimationFrame(timer2);
        this.inProgress = false;
        return;
      }
      this.calculateRowsHeight({
        from: current,
        to: Math.min(current + AutoRowSize.CALCULATION_STEP, length)
      }, colRange, overwriteCache);
      current = current + AutoRowSize.CALCULATION_STEP + 1;
      if (current < length) {
        timer2 = requestAnimationFrame$1(loop);
      } else {
        cancelAnimationFrame(timer2);
        this.inProgress = false;
        this.hot.view.adjustElementsSize();
      }
    };
    const syncLimit = this.getSyncCalculationLimit();
    if (syncLimit >= 0) {
      this.calculateRowsHeight({
        from: 0,
        to: syncLimit
      }, colRange, overwriteCache);
      current = syncLimit + 1;
    }
    if (current < length) {
      loop();
    } else {
      this.inProgress = false;
      this.hot.view.adjustElementsSize();
    }
  }
  /**
  * Recalculates all rows height (overwrite cache values).
  */
  recalculateAllRowsHeight() {
    if (this.hot.view.isVisible()) {
      this.calculateAllRowsHeight({
        from: 0,
        to: this.hot.countCols() - 1
      }, true);
    }
  }
  /**
  * Gets value which tells how many rows should be calculated synchronously (rest of the rows will be calculated
  * asynchronously). The limit is calculated based on `syncLimit` set to autoRowSize option (see {@link Options#autoRowSize}).
  *
  * @returns {number}
  */
  getSyncCalculationLimit() {
    const settings = this.hot.getSettings()[PLUGIN_KEY$A];
    let limit = AutoRowSize.SYNC_CALCULATION_LIMIT;
    const rowsLimit = this.hot.countRows() - 1;
    if (isObject$1(settings)) {
      limit = this.getSetting("syncLimit");
      if (isPercentValue(limit)) {
        limit = valueAccordingPercent(rowsLimit, limit);
      } else {
        const numericLimit = Number(limit);
        limit = Number.isFinite(numericLimit) ? Math.trunc(numericLimit) : 0;
      }
    }
    return Math.min(limit, rowsLimit);
  }
  /**
  * Get a row's height, as measured in the DOM.
  *
  * The height returned includes 1 px of the row's bottom border.
  *
  * Mind that this method is different from the
  * [`getRowHeight()`](@/api/core.md#getrowheight) method
  * of Handsontable's [Core](@/api/core.md).
  *
  * @param {number} row A visual row index.
  * @param {number} [defaultHeight] If no height is found, `defaultHeight` is returned instead.
  * @returns {number} The height of the specified row, in pixels.
  */
  getRowHeight(row, defaultHeight = this.hot.stylesHandler.getDefaultRowHeight(row) ?? 0) {
    if (row < 0) {
      return this.headerHeight ?? defaultHeight;
    }
    const physicalRow = this.hot.toPhysicalRow(row);
    if (this.hot.rowIndexMapper.isHidden(physicalRow)) {
      return defaultHeight;
    }
    const cachedHeight = this.rowHeightsMap.getValueAtIndex(physicalRow);
    let height = defaultHeight;
    if (cachedHeight !== void 0 && cachedHeight !== null && cachedHeight > defaultHeight) {
      height = cachedHeight;
      if (row === this.hot.view.getFirstRenderedVisibleRow()) {
        height += 1;
      }
    }
    return height;
  }
  /**
  * Get the calculated column header height.
  *
  * @returns {number|undefined}
  */
  getColumnHeaderHeight() {
    return this.headerHeight;
  }
  /**
  * Get the first visible row.
  *
  * @returns {number} Returns row index, -1 if table is not rendered or if there are no rows to base the the calculations on.
  */
  getFirstVisibleRow() {
    return this.hot.getFirstRenderedVisibleRow() ?? -1;
  }
  /**
  * Gets the last visible row.
  *
  * @returns {number} Returns row index or -1 if table is not rendered.
  */
  getLastVisibleRow() {
    return this.hot.getLastRenderedVisibleRow() ?? -1;
  }
  /**
  * Clears cache of calculated row heights. If you want to clear only selected rows pass an array with their indexes.
  * Otherwise whole cache will be cleared.
  *
  * @param {number[]} [physicalRows] List of physical row indexes to clear.
  */
  clearCache(physicalRows) {
    this.headerHeight = null;
    if (Array.isArray(physicalRows)) {
      this.hot.batchExecution(() => {
        physicalRows.forEach((physicalIndex) => {
          this.rowHeightsMap.setValueAtIndex(physicalIndex, null);
        });
      }, true);
    } else {
      this.rowHeightsMap.clear();
    }
  }
  /**
  * Clears cache by range.
  *
  * @param {object|number} range Row index or an object with `from` and `to` properties which define row range.
  */
  clearCacheByRange(range) {
    const { from, to } = typeof range === "number" ? {
      from: range,
      to: range
    } : range;
    this.hot.batchExecution(() => {
      rangeEach(Math.min(from, to), Math.max(from, to), (row) => {
        this.rowHeightsMap.setValueAtIndex(row, null);
      });
    }, true);
  }
  /**
  * Checks if all heights were calculated. If not then return `true` (need recalculate).
  *
  * @returns {boolean}
  */
  isNeedRecalculate() {
    return !!this.rowHeightsMap.getValues().slice(0, this.measuredRows).filter((item) => item === null).length;
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    this.ghostTable.clean();
    super.destroy();
  }
  /**
  * Initializes the plugin, registers the row heights map, and sets up the row resize hook.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$J(this, _calculateSpecificRowsHeight), _class_private_method_init$J(this, _toggleFirstDatasetColumnRenderedClassName), _class_private_field_init$X(this, _visualRowsToRefresh, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _disposeMapObserver$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _isInitialized, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onBeforeViewRender$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onBeforeRender$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onBeforeRowResize, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onAfterLoadData$7, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onBeforeChange, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onInit$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$X(this, _onAfterFormulasValuesUpdate$1, {
      writable: true,
      value: void 0
    }), /**
    * Columns header's height cache.
    *
    * @private
    * @type {number}
    */
    this.headerHeight = null, /**
    * Instance of {@link GhostTable} for rows and columns size calculations.
    *
    * @private
    * @type {GhostTable}
    */
    this.ghostTable = new GhostTable$1(this.hot), /**
    * Instance of {@link SamplesGenerator} for generating samples necessary for rows height calculations.
    *
    * @private
    * @type {SamplesGenerator}
    */
    this.samplesGenerator = new SamplesGenerator((row, column) => {
      const physicalColumn = this.hot.toPhysicalColumn(column);
      if (this.hot.columnIndexMapper.isHidden(physicalColumn)) {
        return false;
      }
      let cellMeta;
      if (row >= 0 && column >= 0) {
        cellMeta = this.hot.getCellMeta(row, column);
        if (cellMeta.hidden) {
          return false;
        }
      }
      let cellValue;
      if (row >= 0) {
        cellValue = this.hot.getDataAtCell(row, column);
        if (typeof cellMeta?.valueFormatter === "function") {
          cellValue = cellMeta.valueFormatter(cellValue, cellMeta);
        }
      } else if (row === -1) {
        cellValue = this.hot.getColHeader(column);
      }
      return {
        value: cellValue
      };
    }), /**
    * `true` if the size calculation is in progress.
    *
    * @type {boolean}
    */
    this.inProgress = false, /**
    * Number of already measured rows (we already know their sizes).
    *
    * @type {number}
    */
    this.measuredRows = 0, /**
    * PhysicalIndexToValueMap to keep and track heights for physical row indexes.
    *
    * @private
    * @type {PhysicalIndexToValueMap}
    */
    this.rowHeightsMap = new PhysicalIndexToValueMap(), _class_private_field_set$X(this, _visualRowsToRefresh, []), _class_private_field_set$X(this, _disposeMapObserver$2, null), _class_private_field_set$X(this, _isInitialized, false), _class_private_field_set$X(this, _onBeforeViewRender$2, () => {
      _class_private_method_get$J(this, _toggleFirstDatasetColumnRenderedClassName, toggleFirstDatasetColumnRenderedClassName).call(this);
    }), _class_private_field_set$X(this, _onBeforeRender$1, () => {
      this.calculateVisibleRowsHeight();
      if (!this.inProgress) {
        _class_private_method_get$J(this, _calculateSpecificRowsHeight, calculateSpecificRowsHeight).call(this, _class_private_field_get$X(this, _visualRowsToRefresh));
        _class_private_field_set$X(this, _visualRowsToRefresh, []);
      }
    }), _class_private_field_set$X(this, _onBeforeRowResize, (size, row, isDblClick) => {
      let newSize = size;
      if (isDblClick) {
        this.calculateRowsHeight(row, void 0, true);
        newSize = this.getRowHeight(row);
      }
      return newSize;
    }), _class_private_field_set$X(this, _onAfterLoadData$7, (_sourceData, isFirstLoad) => {
      if (!isFirstLoad) {
        this.recalculateAllRowsHeight();
      }
    }), _class_private_field_set$X(this, _onBeforeChange, (changes) => {
      const changedRows = changes.reduce((acc, [row]) => {
        const rowIndex = Number(row);
        if (acc.indexOf(rowIndex) === -1) {
          acc.push(rowIndex);
        }
        return acc;
      }, []);
      _class_private_field_get$X(this, _visualRowsToRefresh).push(...changedRows);
    }), _class_private_field_set$X(this, _onInit$3, () => {
      this.recalculateAllRowsHeight();
      _class_private_field_set$X(this, _isInitialized, true);
    }), _class_private_field_set$X(this, _onAfterFormulasValuesUpdate$1, (changes) => {
      if (!_class_private_field_get$X(this, _isInitialized)) {
        return;
      }
      const formulasPlugin = this.hot.getPlugin("formulas");
      const sheetId = formulasPlugin?.sheetId;
      const changedRows = changes.reduce((acc, change) => {
        const changeRecord = change;
        if (sheetId !== null && sheetId !== void 0 && changeRecord.address?.sheet !== sheetId) {
          return acc;
        }
        const physicalRow = Number(changeRecord.address?.row);
        if (Number.isInteger(physicalRow)) {
          const visualRow = this.hot.toVisualRow(physicalRow);
          if (visualRow !== null && acc.indexOf(visualRow) === -1) {
            acc.push(visualRow);
          }
        }
        return acc;
      }, []);
      _class_private_field_get$X(this, _visualRowsToRefresh).push(...changedRows);
    });
    this.hot.rowIndexMapper.registerMap(ROW_WIDTHS_MAP_NAME, this.rowHeightsMap);
    this.addHook("beforeRowResize", _class_private_field_get$X(this, _onBeforeRowResize));
  }
}
function calculateSpecificRowsHeight(visualRows) {
  const columnsRange = {
    from: 0,
    to: this.hot.countCols() - 1
  };
  visualRows.forEach((visualRow) => {
    const samples = this.samplesGenerator.generateRowSamples(visualRow, columnsRange);
    samples.forEach((sample, row) => this.ghostTable.addRow(row, sample));
  });
  if (this.ghostTable.rows.length) {
    this.hot.batchExecution(() => {
      this.ghostTable.getHeights((visualRow, height) => {
        const physicalRow = this.hot.toPhysicalRow(visualRow);
        this.rowHeightsMap.setValueAtIndex(physicalRow, height);
      });
    }, true);
    this.ghostTable.clean();
  }
}
function toggleFirstDatasetColumnRenderedClassName(forceState) {
  const firstRenderedColumnVisualIndex = this.hot.getFirstRenderedVisibleColumn();
  const firstRenderedColumnPhysicalIndex = this.hot.columnIndexMapper.getPhysicalFromVisualIndex(firstRenderedColumnVisualIndex);
  if (forceState === false || firstRenderedColumnPhysicalIndex === this.hot.columnIndexMapper.getPhysicalFromRenderableIndex(0)) {
    removeClass(this.hot.rootElement, FIRST_COLUMN_NOT_RENDERED_CLASS_NAME);
  } else {
    addClass(this.hot.rootElement, FIRST_COLUMN_NOT_RENDERED_CLASS_NAME);
  }
}
class LooseBindsMap extends IndexMap {
  /**
  * Add values to list and reorganize.
  *
  * @private
  * @param {number} insertionIndex Position inside the list.
  * @param {Array} insertedIndexes List of inserted indexes.
  */
  insert(insertionIndex, insertedIndexes) {
    const listAfterUpdate = getIncreasedIndexes(this.indexedValues, insertedIndexes);
    this.indexedValues = getListWithInsertedItems$1(listAfterUpdate, insertionIndex, insertedIndexes, this.initValueOrFn);
    super.insert(insertionIndex, insertedIndexes);
  }
  /**
  * Remove values from the list and reorganize.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  remove(removedIndexes) {
    const listAfterUpdate = getListWithRemovedItems$1(this.indexedValues, removedIndexes);
    this.indexedValues = getDecreasedIndexes(listAfterUpdate, removedIndexes);
    super.remove(removedIndexes);
  }
  /**
  * Initializes the loose binds map with an identity function so each row header index initially maps to itself.
  */
  constructor() {
    super((index2) => index2);
  }
}
class StrictBindsMap extends IndexMap {
  /**
  * Add values to list and reorganize.
  *
  * @private
  * @param {number} insertionIndex Position inside the list.
  * @param {Array} insertedIndexes List of inserted indexes.
  */
  insert(insertionIndex, insertedIndexes) {
    this.indexedValues = getListWithInsertedItems$1(this.indexedValues, insertionIndex, insertedIndexes, (_, ordinalNumber) => this.getNextValue(ordinalNumber));
    super.insert(insertionIndex, insertedIndexes);
  }
  /**
  * Remove values from the list and reorganize.
  *
  * @private
  * @param {Array} removedIndexes List of removed indexes.
  */
  remove(removedIndexes) {
    this.indexedValues = getListWithRemovedItems$1(this.indexedValues, removedIndexes);
    super.remove(removedIndexes);
  }
  /**
  * Get next values, which should be greater than actual maximum value in the list.
  *
  * @param {number} ordinalNumber Position in the list.
  * @returns {number}
  */
  getNextValue(ordinalNumber) {
    return Math.max(...this.getValues()) + 1 + ordinalNumber;
  }
  /**
  * Initializes the strict binds map with an identity function so each row header index initially maps to itself.
  */
  constructor() {
    super((index2) => index2);
  }
}
function _check_private_redeclaration$14(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$W(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$W(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$W(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$W(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$W(receiver, privateMap, "get");
  return _class_apply_descriptor_get$W(receiver, descriptor);
}
function _class_private_field_init$W(obj, privateMap, value) {
  _check_private_redeclaration$14(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$W(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$W(receiver, privateMap, "set");
  _class_apply_descriptor_set$W(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$z = "bindRowsWithHeaders";
const PLUGIN_PRIORITY$z = 210;
const DEFAULT_BIND = "loose";
const bindTypeToMapStrategy = /* @__PURE__ */ new Map([
  [
    "loose",
    LooseBindsMap
  ],
  [
    "strict",
    StrictBindsMap
  ]
]);
var _onModifyRowHeader$1 = /* @__PURE__ */ new WeakMap();
class BindRowsWithHeaders extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$z;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$z;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link BindRowsWithHeaders#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$z];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const selfWithGetSetting = this;
    const MapStrategy = bindTypeToMapStrategy.get(selfWithGetSetting.getSetting()) ?? bindTypeToMapStrategy.get(DEFAULT_BIND);
    if (!MapStrategy) {
      return;
    }
    this.headerIndexes = this.hot.rowIndexMapper.registerMap("bindRowsWithHeaders", new MapStrategy());
    this.addHook("modifyRowHeader", _class_private_field_get$W(this, _onModifyRowHeader$1));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.hot.rowIndexMapper.unregisterMap("bindRowsWithHeaders");
    super.disablePlugin();
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$W(this, _onModifyRowHeader$1, {
      writable: true,
      value: void 0
    }), /**
    * Plugin indexes cache.
    *
    * @private
    * @type {null|IndexMap}
    */
    this.headerIndexes = null, _class_private_field_set$W(this, _onModifyRowHeader$1, (row) => {
      return this.headerIndexes.getValueAtIndex(this.hot.toPhysicalRow(row));
    });
  }
}
function _check_private_redeclaration$13(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$V(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$V(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$V(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$V(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$V(receiver, privateMap, "get");
  return _class_apply_descriptor_get$V(receiver, descriptor);
}
function _class_private_field_init$V(obj, privateMap, value) {
  _check_private_redeclaration$13(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$V(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$V(receiver, privateMap, "set");
  _class_apply_descriptor_set$V(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$I(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$I(obj, privateSet) {
  _check_private_redeclaration$13(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$y = "collapsibleColumns";
const PLUGIN_PRIORITY$y = 290;
const SETTING_KEYS$2 = [
  "nestedHeaders"
];
const COLLAPSIBLE_ELEMENT_CLASS = "collapsibleIndicator";
const VISIBLE_WHEN_MAP_NAME = "collapsibleColumns.visibleWhen";
const SHORTCUTS_GROUP$d = PLUGIN_KEY$y;
const actionDictionary = /* @__PURE__ */ new Map([
  [
    "collapse",
    {
      hideColumn: true,
      beforeHook: "beforeColumnCollapse",
      afterHook: "afterColumnCollapse"
    }
  ],
  [
    "expand",
    {
      hideColumn: false,
      beforeHook: "beforeColumnExpand",
      afterHook: "afterColumnExpand"
    }
  ]
]);
var _collapsedColumnsMap = /* @__PURE__ */ new WeakMap(), _visibleWhenMap = /* @__PURE__ */ new WeakMap(), _checkIsActionPossible = /* @__PURE__ */ new WeakSet(), _adjustSelectionAfterHide = /* @__PURE__ */ new WeakSet(), _refreshVisibleWhenColumns = /* @__PURE__ */ new WeakSet(), _onAfterColumnStructureChange = /* @__PURE__ */ new WeakMap(), _onAfterGetColHeader$4 = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseDown$6 = /* @__PURE__ */ new WeakMap(), _onInit$2 = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$6 = /* @__PURE__ */ new WeakMap();
class CollapsibleColumns extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$y;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$y;
  }
  /**
  * Returns the list of plugin dependencies required before this plugin can be initialized.
  */
  static get PLUGIN_DEPS() {
    return [
      "plugin:NestedHeaders"
    ];
  }
  /**
  * Returns the setting keys that trigger a plugin update when changed via `updateSettings`.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$y,
      ...SETTING_KEYS$2
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link CollapsibleColumns#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$y];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const { nestedHeaders } = this.hot.getSettings();
    if (!nestedHeaders) {
      warn$1("You need to configure the Nested Headers plugin in order to use collapsible headers.");
    }
    if (this.pluginName) {
      _class_private_field_set$V(this, _collapsedColumnsMap, this.hot.columnIndexMapper.createAndRegisterIndexMap(this.pluginName, "hiding"));
    }
    _class_private_field_set$V(this, _visibleWhenMap, this.hot.columnIndexMapper.createAndRegisterIndexMap(VISIBLE_WHEN_MAP_NAME, "hiding"));
    this.nestedHeadersPlugin = this.hot.getPlugin("nestedHeaders");
    this.headerStateManager = this.nestedHeadersPlugin.getStateManager();
    this.addHook("init", _class_private_field_get$V(this, _onInit$2));
    this.addHook("afterLoadData", _class_private_field_get$V(this, _onAfterLoadData$6));
    this.addHook("afterGetColHeader", _class_private_field_get$V(this, _onAfterGetColHeader$4));
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$V(this, _onBeforeOnCellMouseDown$6));
    this.addHook("afterCreateCol", _class_private_field_get$V(this, _onAfterColumnStructureChange));
    this.addHook("afterRemoveCol", _class_private_field_get$V(this, _onAfterColumnStructureChange));
    this.registerShortcuts();
    super.enablePlugin();
    this.updatePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *   - [`collapsibleColumns`](@/api/options.md#collapsiblecolumns)
  *   - [`nestedHeaders`](@/api/options.md#nestedheaders)
  */
  updatePlugin() {
    if (!this.hot.view) {
      return;
    }
    if (!this.nestedHeadersPlugin?.detectedOverlappedHeaders) {
      const { collapsibleColumns } = this.hot.getSettings();
      if (typeof collapsibleColumns === "boolean") {
        this.headerStateManager?.mapState((headerSettings) => {
          return {
            collapsible: Number(headerSettings.origColspan) > 1
          };
        });
      } else if (Array.isArray(collapsibleColumns)) {
        this.headerStateManager?.mapState(() => {
          return {
            collapsible: false
          };
        });
        this.headerStateManager?.mergeStateWith(collapsibleColumns);
      }
    }
    _class_private_method_get$I(this, _refreshVisibleWhenColumns, refreshVisibleWhenColumns).call(this);
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    if (this.pluginName) {
      this.hot.columnIndexMapper.unregisterMap(this.pluginName);
    }
    this.hot.columnIndexMapper.unregisterMap(VISIBLE_WHEN_MAP_NAME);
    _class_private_field_set$V(this, _collapsedColumnsMap, null);
    _class_private_field_set$V(this, _visibleWhenMap, null);
    this.nestedHeadersPlugin = null;
    this.unregisterShortcuts();
    this.clearButtons();
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for toggling collapsible columns.
  *
  * @private
  */
  registerShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.addShortcut({
      keys: [
        [
          "Enter"
        ]
      ],
      callback: () => {
        const activeRange = this.hot.getSelectedRangeActive();
        if (!activeRange) {
          return;
        }
        const { row, col } = activeRange.highlight;
        if (row === null || col === null) {
          return;
        }
        const nodeData = this.headerStateManager?.getHeaderTreeNodeData(row, col) ?? {
          collapsible: false,
          isCollapsed: false,
          columnIndex: 0
        };
        const { collapsible, isCollapsed, columnIndex } = nodeData;
        if (!collapsible) {
          return;
        }
        if (isCollapsed) {
          this.expandSection({
            row,
            col: columnIndex
          });
        } else {
          this.collapseSection({
            row,
            col: columnIndex
          });
        }
        return false;
      },
      runOnlyIf: () => !!(this.hot.getSelectedRangeActive()?.isSingle() && this.hot.getSelectedRangeActive()?.highlight.isHeader()),
      group: SHORTCUTS_GROUP$d,
      relativeToGroup: EDITOR_EDIT_GROUP,
      position: "before"
    });
  }
  /**
  * Unregister shortcuts responsible for toggling collapsible columns.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$d);
  }
  /**
  * Clears the expand/collapse buttons.
  *
  * @private
  */
  clearButtons() {
    if (!this.hot.view) {
      return;
    }
    const headerLevels = this.hot.view._wt.getSetting("columnHeaders").length;
    const mainHeaders = this.hot.view._wt.wtTable.THEAD;
    const topHeaders = this.hot.view._wt.wtOverlays.topOverlay?.clone?.wtTable.THEAD ?? null;
    const topLeftCornerHeaders = this.hot.view._wt.wtOverlays.topInlineStartCornerOverlay ? this.hot.view._wt.wtOverlays.topInlineStartCornerOverlay.clone?.wtTable.THEAD ?? null : null;
    const removeButton = function(button) {
      if (button && button.parentNode) {
        button.parentNode.removeChild(button);
      }
    };
    if (!mainHeaders || !topHeaders) {
      return;
    }
    rangeEach(0, headerLevels - 1, (i) => {
      const masterLevel = mainHeaders.childNodes[i];
      const topLevel = topHeaders.childNodes[i];
      const topLeftCornerLevel = topLeftCornerHeaders ? topLeftCornerHeaders.childNodes[i] : null;
      rangeEach(0, masterLevel.childNodes.length - 1, (j) => {
        let button = masterLevel.childNodes[j].querySelector(`.${COLLAPSIBLE_ELEMENT_CLASS}`);
        removeButton(button);
        if (topLevel && topLevel.childNodes[j]) {
          button = topLevel.childNodes[j].querySelector(`.${COLLAPSIBLE_ELEMENT_CLASS}`);
          removeButton(button);
        }
        if (topLeftCornerHeaders && topLeftCornerLevel && topLeftCornerLevel.childNodes[j]) {
          button = topLeftCornerLevel.childNodes[j].querySelector(`.${COLLAPSIBLE_ELEMENT_CLASS}`);
          removeButton(button);
        }
      });
    });
  }
  /**
  * Expands section at the provided coords. `coords.col` may be any column the group's header spans,
  * not only its first (anchor) column - it resolves to the owning collapsible group.
  *
  * @param {object} coords Contains coordinates information. (`coords.row`, `coords.col`).
  */
  expandSection(coords) {
    this.toggleCollapsibleSection([
      coords
    ], "expand");
  }
  /**
  * Collapses section at the provided coords. `coords.col` may be any column the group's header spans,
  * not only its first (anchor) column - it resolves to the owning collapsible group.
  *
  * @param {object} coords Contains coordinates information. (`coords.row`, `coords.col`).
  */
  collapseSection(coords) {
    this.toggleCollapsibleSection([
      coords
    ], "collapse");
  }
  /**
  * Collapses or expand all collapsible sections, depending on the action parameter.
  *
  * @param {string} action 'collapse' or 'expand'.
  */
  toggleAllCollapsibleSections(action) {
    const coords = this.headerStateManager?.mapNodes((headerSettings) => {
      const { collapsible, origColspan, headerLevel, columnIndex, isCollapsed } = headerSettings;
      if (collapsible === true && Number(origColspan) > 1 && (isCollapsed && action === "expand" || !isCollapsed && action === "collapse")) {
        return {
          row: this.headerStateManager?.levelToRowCoords(Number(headerLevel)) ?? 0,
          col: columnIndex
        };
      }
    });
    this.toggleCollapsibleSection(coords, action);
  }
  /**
  * Collapses all collapsible sections.
  */
  collapseAll() {
    this.toggleAllCollapsibleSections("collapse");
  }
  /**
  * Expands all collapsible sections.
  */
  expandAll() {
    this.toggleAllCollapsibleSections("expand");
  }
  /**
  * Collapses/Expands a section.
  *
  * @param {Array} coords Array of coords - section coordinates.
  * @param {string} [action] Action definition ('collapse' or 'expand').
  * @fires Hooks#beforeColumnCollapse
  * @fires Hooks#beforeColumnExpand
  * @fires Hooks#afterColumnCollapse
  * @fires Hooks#afterColumnExpand
  */
  toggleCollapsibleSection(coords, action) {
    if (action === void 0 || !actionDictionary.has(action)) {
      throwWithCause(`Unsupported action is passed (${action}).`);
    }
    if (!Array.isArray(coords)) {
      return;
    }
    const filteredCoords = arrayFilter(coords, ({ row }) => row < 0);
    const isActionPossible = _class_private_method_get$I(this, _checkIsActionPossible, checkIsActionPossible).call(this, filteredCoords, action);
    const nodeModRollbacks = [];
    const affectedColumnsIndexes = [];
    const visibleWhenHiddenBefore = this.headerStateManager?.getVisibleWhenHiddenColumns() ?? [];
    if (isActionPossible) {
      arrayEach(filteredCoords, ({ row, col: column }) => {
        const { affectedColumns, rollbackModification } = this.headerStateManager?.triggerNodeModification(action, row, column) ?? {
          affectedColumns: [],
          rollbackModification: () => {
          }
        };
        nodeModRollbacks.push(rollbackModification);
        if (affectedColumns.length > 0) {
          affectedColumnsIndexes.push(...affectedColumns);
        }
      });
    }
    const currentCollapsedColumns = this.getCollapsedColumns();
    let destinationCollapsedColumns = [];
    if (action === "collapse") {
      destinationCollapsedColumns = arrayUnique([
        ...currentCollapsedColumns,
        ...affectedColumnsIndexes
      ]);
    } else if (action === "expand") {
      destinationCollapsedColumns = arrayFilter(currentCollapsedColumns, (index2) => !affectedColumnsIndexes.includes(index2));
    }
    const actionTranslator = actionDictionary.get(action);
    const isActionAllowed = this.hot.runHooks(actionTranslator.beforeHook, currentCollapsedColumns, destinationCollapsedColumns, isActionPossible);
    if (isActionAllowed === false) {
      arrayEach(nodeModRollbacks, (nodeModRollback) => {
        nodeModRollback();
      });
      return;
    }
    this.hot.batchExecution(() => {
      arrayEach(affectedColumnsIndexes, (visualColumn) => {
        _class_private_field_get$V(this, _collapsedColumnsMap)?.setValueAtIndex(this.hot.toPhysicalColumn(visualColumn), actionTranslator.hideColumn);
      });
    }, true);
    const visibleWhenHiddenAfter = this.headerStateManager?.getVisibleWhenHiddenColumns() ?? [];
    const newlyHiddenByVisibleWhen = getDifferenceOfArrays(visibleWhenHiddenAfter, visibleWhenHiddenBefore);
    const isVisibleWhenChanged = newlyHiddenByVisibleWhen.length > 0 || visibleWhenHiddenAfter.length !== visibleWhenHiddenBefore.length;
    if (isVisibleWhenChanged) {
      _class_private_method_get$I(this, _refreshVisibleWhenColumns, refreshVisibleWhenColumns).call(this, visibleWhenHiddenAfter);
    }
    const isActionPerformed = this.getCollapsedColumns().length !== currentCollapsedColumns.length || isVisibleWhenChanged;
    const newlyHiddenColumns = action === "collapse" ? arrayUnique([
      ...affectedColumnsIndexes,
      ...newlyHiddenByVisibleWhen
    ]) : newlyHiddenByVisibleWhen;
    if (isActionPerformed && newlyHiddenColumns.length > 0) {
      _class_private_method_get$I(this, _adjustSelectionAfterHide, adjustSelectionAfterHide).call(this, newlyHiddenColumns);
    }
    this.hot.runHooks(actionTranslator.afterHook, currentCollapsedColumns, destinationCollapsedColumns, isActionPossible, isActionPerformed);
    this.hot.view.adjustElementsSize();
    this.hot.render();
  }
  /**
  * Gets an array of physical indexes of collapsed columns.
  *
  * @private
  * @returns {number[]}
  */
  getCollapsedColumns() {
    return _class_private_field_get$V(this, _collapsedColumnsMap)?.getHiddenIndexes() ?? [];
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_set$V(this, _collapsedColumnsMap, null);
    _class_private_field_set$V(this, _visibleWhenMap, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$I(this, _checkIsActionPossible), _class_private_method_init$I(this, _adjustSelectionAfterHide), _class_private_method_init$I(this, _refreshVisibleWhenColumns), _class_private_field_init$V(this, _collapsedColumnsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$V(this, _visibleWhenMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$V(this, _onAfterColumnStructureChange, {
      writable: true,
      value: void 0
    }), _class_private_field_init$V(this, _onAfterGetColHeader$4, {
      writable: true,
      value: void 0
    }), _class_private_field_init$V(this, _onBeforeOnCellMouseDown$6, {
      writable: true,
      value: void 0
    }), _class_private_field_init$V(this, _onInit$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$V(this, _onAfterLoadData$6, {
      writable: true,
      value: void 0
    }), /**
    * Cached reference to the NestedHeaders plugin.
    *
    * @private
    * @type {NestedHeaders}
    */
    this.nestedHeadersPlugin = null, /**
    * The NestedHeaders plugin StateManager instance.
    *
    * @private
    * @type {StateManager}
    */
    this.headerStateManager = null, _class_private_field_set$V(this, _collapsedColumnsMap, null), _class_private_field_set$V(this, _visibleWhenMap, null), _class_private_field_set$V(this, _onAfterColumnStructureChange, () => {
      _class_private_method_get$I(this, _refreshVisibleWhenColumns, refreshVisibleWhenColumns).call(this);
    }), _class_private_field_set$V(this, _onAfterGetColHeader$4, (column, TH, headerLevel) => {
      const headerSettings = this.headerStateManager?.getHeaderSettings(headerLevel, column);
      const { collapsible, origColspan, isCollapsed } = headerSettings ?? {};
      const isNodeCollapsible = collapsible === true && (origColspan ?? 0) > 1 && column >= (this.hot.getSettings().fixedColumnsStart ?? 0);
      const isAriaTagsEnabled = this.hot.getSettings().ariaTags;
      let collapsibleElement = TH.querySelector(`.${COLLAPSIBLE_ELEMENT_CLASS}`);
      removeAttribute(TH, [
        A11Y_EXPANDED("")[0]
      ]);
      if (isNodeCollapsible) {
        if (!collapsibleElement) {
          collapsibleElement = this.hot.rootDocument.createElement("div");
          addClass(collapsibleElement, COLLAPSIBLE_ELEMENT_CLASS);
          TH.querySelector("div:first-child")?.appendChild(collapsibleElement);
        }
        const el = collapsibleElement;
        removeClass(el, [
          "collapsed",
          "expanded"
        ]);
        if (isCollapsed) {
          addClass(el, "collapsed");
          fastInnerText(el, "+");
          if (isAriaTagsEnabled) {
            setAttribute(TH, ...A11Y_EXPANDED(false));
          }
        } else {
          addClass(el, "expanded");
          fastInnerText(el, "-");
          if (isAriaTagsEnabled) {
            setAttribute(TH, ...A11Y_EXPANDED(true));
          }
        }
        if (isAriaTagsEnabled) {
          setAttribute(el, ...A11Y_HIDDEN());
        }
      } else {
        collapsibleElement?.remove();
      }
    }), _class_private_field_set$V(this, _onBeforeOnCellMouseDown$6, (event, coords) => {
      const target = eventTargetEl(event);
      if (hasClass(target, COLLAPSIBLE_ELEMENT_CLASS)) {
        if (hasClass(target, "expanded")) {
          this.eventManager.fireEvent(target, "mouseup");
          this.toggleCollapsibleSection([
            coords
          ], "collapse");
        } else if (hasClass(target, "collapsed")) {
          this.eventManager.fireEvent(target, "mouseup");
          this.toggleCollapsibleSection([
            coords
          ], "expand");
        }
        stopImmediatePropagation(event);
      }
    }), _class_private_field_set$V(this, _onInit$2, () => {
      this.updatePlugin();
    }), _class_private_field_set$V(this, _onAfterLoadData$6, (_sourceData, initialLoad) => {
      if (!initialLoad) {
        this.updatePlugin();
      }
    });
  }
}
function checkIsActionPossible(filteredCoords, action) {
  if (filteredCoords.length === 0) {
    return false;
  }
  let isActionPossible = true;
  arrayEach(filteredCoords, ({ row, col: column }) => {
    const { collapsible, isCollapsed } = this.headerStateManager?.getHeaderTreeNodeData(row, column) ?? {};
    if (!collapsible || isCollapsed && action === "collapse" || !isCollapsed && action === "expand") {
      isActionPossible = false;
      return false;
    }
  });
  return isActionPossible;
}
function adjustSelectionAfterHide(hiddenColumnsIndexes) {
  const selectionRange = this.hot.getSelectedRangeActive();
  if (!selectionRange) {
    return;
  }
  const { row, col } = selectionRange.highlight;
  if (row === null || col === null) {
    return;
  }
  const isHidden = this.hot.rowIndexMapper.isHidden(row) || this.hot.columnIndexMapper.isHidden(col);
  if (isHidden && hiddenColumnsIndexes.includes(col)) {
    const nextRow = row >= 0 ? this.hot.rowIndexMapper.getNearestNotHiddenIndex(row, 1, true) : row;
    const nextColumn = col >= 0 ? this.hot.columnIndexMapper.getNearestNotHiddenIndex(col, 1, true) : col;
    if (nextRow !== null && nextColumn !== null) {
      this.hot.selectCell(nextRow, nextColumn);
    }
  }
}
function refreshVisibleWhenColumns(visualColumnsToHide = this.headerStateManager?.getVisibleWhenHiddenColumns() ?? []) {
  if (!_class_private_field_get$V(this, _visibleWhenMap)) {
    return;
  }
  const visibleWhenMap = _class_private_field_get$V(this, _visibleWhenMap);
  const nextHiddenColumns = arrayMap(visualColumnsToHide, (visualColumn) => this.hot.toPhysicalColumn(visualColumn));
  const currentHiddenColumns = visibleWhenMap.getHiddenIndexes();
  const isUnchanged = nextHiddenColumns.length === currentHiddenColumns.length && getDifferenceOfArrays(nextHiddenColumns, currentHiddenColumns).length === 0;
  if (isUnchanged) {
    return;
  }
  this.hot.batchExecution(() => {
    visibleWhenMap.clear();
    arrayEach(nextHiddenColumns, (physicalColumn) => {
      visibleWhenMap.setValueAtIndex(physicalColumn, true);
    });
  }, true);
}
const inheritedColumnProperties = [
  "sortEmptyCells",
  "indicator",
  "headerAction",
  "compareFunctionFactory"
];
const SORT_EMPTY_CELLS_DEFAULT = false;
const SHOW_SORT_INDICATOR_DEFAULT = true;
const HEADER_ACTION_DEFAULT = true;
class ColumnStatesManager {
  /**
  * Update column properties which affect the sorting result.
  *
  * **Note**: All column properties can be overwritten by {@link Options#columns} option.
  *
  * @param {object} allSortSettings Column sorting plugin's configuration object.
  */
  updateAllColumnsProperties(allSortSettings) {
    if (!isObject$1(allSortSettings)) {
      return;
    }
    objectEach(allSortSettings, (newValue, propertyName) => {
      if (inheritedColumnProperties.includes(propertyName)) {
        this[propertyName] = newValue;
      }
    });
  }
  /**
  * Get all column properties which affect the sorting result.
  *
  * @returns {object}
  */
  getAllColumnsProperties() {
    const columnProperties = {
      sortEmptyCells: this.sortEmptyCells,
      indicator: this.indicator,
      headerAction: this.headerAction
    };
    if (typeof this.compareFunctionFactory === "function") {
      columnProperties.compareFunctionFactory = this.compareFunctionFactory;
    }
    return columnProperties;
  }
  /**
  * Get sort order of column.
  *
  * @param {number} searchedColumn Visual column index.
  * @returns {string|undefined} Sort order (`asc` for ascending, `desc` for descending and undefined for not sorted).
  */
  getSortOrderOfColumn(searchedColumn) {
    return this.sortingStates.getValueAtIndex(this.hot.toPhysicalColumn(searchedColumn))?.sortOrder;
  }
  /**
  * Get order of particular column in the states queue.
  *
  * @param {number} column Visual column index.
  * @returns {number}
  */
  getIndexOfColumnInSortQueue(column) {
    column = this.hot.toPhysicalColumn(column);
    return this.sortingStates.getEntries().findIndex(([physicalColumn]) => physicalColumn === column);
  }
  /**
  * Get number of sorted columns.
  *
  * @returns {number}
  */
  getNumberOfSortedColumns() {
    return this.sortingStates.getLength();
  }
  /**
  * Get if list of sorted columns is empty.
  *
  * @returns {boolean}
  */
  isListOfSortedColumnsEmpty() {
    return this.getNumberOfSortedColumns() === 0;
  }
  /**
  * Get if particular column is sorted.
  *
  * @param {number} column Visual column index.
  * @returns {boolean}
  */
  isColumnSorted(column) {
    return isObject$1(this.sortingStates.getValueAtIndex(this.hot.toPhysicalColumn(column)));
  }
  /**
  * Queue of sort states containing sorted columns and their orders (Array of objects containing `column` and `sortOrder` properties).
  *
  * **Note**: Please keep in mind that returned objects expose **visual** column index under the `column` key.
  *
  * @returns {Array<object>}
  */
  getSortStates() {
    if (this.sortingStates === null) {
      return [];
    }
    const sortingStatesQueue = this.sortingStates.getEntries();
    return sortingStatesQueue.map(([physicalColumn, value]) => ({
      column: this.hot.toVisualColumn(physicalColumn),
      ...value
    }));
  }
  /**
  * Get sort state for particular column. Object contains `column` and `sortOrder` properties.
  *
  * **Note**: Please keep in mind that returned objects expose **visual** column index under the `column` key.
  *
  * @param {number} column Visual column index.
  * @returns {object|undefined}
  */
  getColumnSortState(column) {
    const sortOrder = this.getSortOrderOfColumn(column);
    if (sortOrder !== void 0) {
      return {
        column,
        sortOrder
      };
    }
  }
  /**
  * Set all column states.
  *
  * @param {Array} sortStates Sort states.
  */
  setSortStates(sortStates) {
    this.sortingStates.clear();
    for (let i = 0; i < sortStates.length; i += 1) {
      const state = sortStates[i];
      this.sortingStates.setValueAtIndex(this.hot.toPhysicalColumn(state.column), {
        sortOrder: state.sortOrder
      });
    }
  }
  /**
  * Destroy the state manager.
  */
  destroy() {
    this.hot.columnIndexMapper.unregisterMap(this.mapName);
    Reflect.set(this, "sortingStates", null);
  }
  /**
  * Initializes the column states manager with the Handsontable instance and registers the sorting states index map under the given map name.
  */
  constructor(hot, mapName) {
    this.sortingStates = new LinkedPhysicalIndexToValueMap();
    this.sortEmptyCells = SORT_EMPTY_CELLS_DEFAULT;
    this.indicator = SHOW_SORT_INDICATOR_DEFAULT;
    this.headerAction = HEADER_ACTION_DEFAULT;
    this.hot = hot;
    this.mapName = mapName;
    this.hot.columnIndexMapper.registerMap(mapName, this.sortingStates);
  }
}
function normalizeValue(value, locale) {
  if (typeof value === "boolean") {
    return Number(value);
  }
  if (typeof value === "string") {
    return localeLowerCase(value, locale);
  }
  return value;
}
function compareNonEmptyValues(value, nextValue, sortOrder) {
  const valueIsNaN = isNaN(value);
  const nextValueIsNaN = isNaN(nextValue);
  if (valueIsNaN && !nextValueIsNaN) {
    return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
  }
  if (!valueIsNaN && nextValueIsNaN) {
    return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
  }
  let comparableValue = value;
  let comparableNextValue = nextValue;
  if (!valueIsNaN && !nextValueIsNaN) {
    comparableValue = parseFloat(String(value));
    comparableNextValue = parseFloat(String(nextValue));
  }
  const a = comparableValue;
  const b = comparableNextValue;
  if (a < b) {
    return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
  }
  if (a > b) {
    return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
  }
  return DO_NOT_SWAP;
}
function compareFunctionFactory$6(sortOrder, columnMeta, columnPluginSettings) {
  const locale = columnMeta.locale;
  return function(value, nextValue) {
    const { sortEmptyCells } = columnPluginSettings;
    const normalizedValue = normalizeValue(value, locale);
    const normalizedNextValue = normalizeValue(nextValue, locale);
    if (normalizedValue === normalizedNextValue) {
      return DO_NOT_SWAP;
    }
    if (isEmpty$1(normalizedValue)) {
      if (isEmpty$1(normalizedNextValue)) {
        return DO_NOT_SWAP;
      }
      if (sortEmptyCells) {
        return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
      }
      return FIRST_AFTER_SECOND;
    }
    if (isEmpty$1(normalizedNextValue)) {
      if (sortEmptyCells) {
        return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
      }
      return FIRST_BEFORE_SECOND;
    }
    return compareNonEmptyValues(normalizedValue, normalizedNextValue, sortOrder);
  };
}
const COLUMN_DATA_TYPE$6 = "default";
function compareFunctionFactory$5(sortOrder, columnMeta, columnPluginSettings) {
  return function(value, nextValue) {
    const parsedFirstValue = parseFloat(value);
    const parsedSecondValue = parseFloat(nextValue);
    const { sortEmptyCells } = columnPluginSettings;
    if (parsedFirstValue === parsedSecondValue || isNaN(parsedFirstValue) && isNaN(parsedSecondValue)) {
      return DO_NOT_SWAP;
    }
    if (sortEmptyCells) {
      if (isEmpty$1(value)) {
        return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
      }
      if (isEmpty$1(nextValue)) {
        return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
      }
    }
    if (isNaN(parsedFirstValue)) {
      return FIRST_AFTER_SECOND;
    }
    if (isNaN(parsedSecondValue)) {
      return FIRST_BEFORE_SECOND;
    }
    if (parsedFirstValue < parsedSecondValue) {
      return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
    } else if (parsedFirstValue > parsedSecondValue) {
      return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
    }
    return DO_NOT_SWAP;
  };
}
const COLUMN_DATA_TYPE$5 = "numeric";
function compareTemplateValues(unifiedValue, unifiedNextValue, checkedTemplate, uncheckedTemplate, sortOrder) {
  if (unifiedValue === uncheckedTemplate && unifiedNextValue === checkedTemplate) {
    return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
  }
  if (unifiedValue === checkedTemplate && unifiedNextValue === uncheckedTemplate) {
    return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
  }
  return DO_NOT_SWAP;
}
function compareBadValues(isValueFromTemplate, isNextValueFromTemplate, sortOrder, columnMeta, columnPluginSettings, value, nextValue) {
  if (isValueFromTemplate === false && isNextValueFromTemplate) {
    return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
  }
  if (isValueFromTemplate && isNextValueFromTemplate === false) {
    return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
  }
  if (isValueFromTemplate === false && isNextValueFromTemplate === false) {
    return compareFunctionFactory$6(sortOrder, columnMeta, columnPluginSettings)(value, nextValue);
  }
  return null;
}
function compareFunctionFactory$4(sortOrder, columnMeta, columnPluginSettings) {
  const checkedTemplate = columnMeta.checkedTemplate;
  const uncheckedTemplate = columnMeta.uncheckedTemplate;
  const { sortEmptyCells } = columnPluginSettings;
  return function(value, nextValue) {
    const isEmptyValue = isEmpty$1(value);
    const isEmptyNextValue = isEmpty$1(nextValue);
    const unifiedValue = isEmptyValue ? uncheckedTemplate : value;
    const unifiedNextValue = isEmptyNextValue ? uncheckedTemplate : nextValue;
    const isValueFromTemplate = unifiedValue === uncheckedTemplate || unifiedValue === checkedTemplate;
    const isNextValueFromTemplate = unifiedNextValue === uncheckedTemplate || unifiedNextValue === checkedTemplate;
    if (sortEmptyCells === false) {
      if (isEmptyValue && isEmptyNextValue === false) {
        return FIRST_AFTER_SECOND;
      }
      if (isEmptyValue === false && isEmptyNextValue) {
        return FIRST_BEFORE_SECOND;
      }
    }
    const badValueResult = compareBadValues(isValueFromTemplate, isNextValueFromTemplate, sortOrder, columnMeta, columnPluginSettings, value, nextValue);
    if (badValueResult !== null) {
      return badValueResult;
    }
    return compareTemplateValues(unifiedValue, unifiedNextValue, checkedTemplate, uncheckedTemplate, sortOrder);
  };
}
const COLUMN_DATA_TYPE$4 = "checkbox";
function compareFunctionFactory$3(sortOrder, _columnMeta, columnPluginSettings) {
  return createIntlDateCompareFunction(sortOrder, columnPluginSettings);
}
const COLUMN_DATA_TYPE$3 = "date";
function compareFunctionFactory$2(sortOrder, _columnMeta, columnPluginSettings) {
  return createIntlDateCompareFunction(sortOrder, columnPluginSettings);
}
const COLUMN_DATA_TYPE$2 = "intl-date";
function compareFunctionFactory$1(sortOrder, _columnMeta, columnPluginSettings) {
  return createIntlTimeCompareFunction(sortOrder, columnPluginSettings);
}
const COLUMN_DATA_TYPE$1 = "time";
function compareFunctionFactory(sortOrder, _columnMeta, columnPluginSettings) {
  return createIntlTimeCompareFunction(sortOrder, columnPluginSettings);
}
const COLUMN_DATA_TYPE = "intl-time";
const { register: registerCompareFunctionFactory, getItem: getGloballyCompareFunctionFactory, hasItem: hasGloballyCompareFunctionFactory } = staticRegister("sorting.compareFunctionFactory");
const { register: registerRootComparator, getItem: getRootComparator } = staticRegister("sorting.mainSortComparator");
function getCompareFunctionFactory(type) {
  if (hasGloballyCompareFunctionFactory(type)) {
    return getGloballyCompareFunctionFactory(type);
  }
  return getGloballyCompareFunctionFactory(COLUMN_DATA_TYPE$6);
}
registerCompareFunctionFactory(COLUMN_DATA_TYPE$4, compareFunctionFactory$4);
registerCompareFunctionFactory(COLUMN_DATA_TYPE$3, compareFunctionFactory$3);
registerCompareFunctionFactory(COLUMN_DATA_TYPE$2, compareFunctionFactory$2);
registerCompareFunctionFactory(COLUMN_DATA_TYPE$6, compareFunctionFactory$6);
registerCompareFunctionFactory(COLUMN_DATA_TYPE$5, compareFunctionFactory$5);
registerCompareFunctionFactory(COLUMN_DATA_TYPE$1, compareFunctionFactory$1);
registerCompareFunctionFactory(COLUMN_DATA_TYPE, compareFunctionFactory);
const DO_NOT_SWAP = 0;
const FIRST_BEFORE_SECOND = -1;
const FIRST_AFTER_SECOND = 1;
function sort(indexesWithData, rootComparatorId, ...argsForRootComparator) {
  const rootComparator2 = getRootComparator(rootComparatorId);
  indexesWithData.sort(rootComparator2(...argsForRootComparator));
}
const ASC_SORT_STATE = "asc";
const DESC_SORT_STATE = "desc";
const HEADER_SPAN_CLASS = "colHeader";
function isValidColumnState(columnState) {
  if (isObject$1(columnState) === false) {
    return false;
  }
  const { column, sortOrder } = columnState;
  return Number.isInteger(column) && [
    ASC_SORT_STATE,
    DESC_SORT_STATE
  ].includes(sortOrder);
}
function areValidSortStates(sortStates) {
  if (sortStates.some((columnState) => isValidColumnState(columnState) === false)) {
    return false;
  }
  const validStates = sortStates.filter(isValidColumnState);
  const sortedColumns = validStates.map((state) => state.column);
  return new Set(sortedColumns).size === sortedColumns.length;
}
function getNextSortOrder(sortOrder) {
  if (sortOrder === DESC_SORT_STATE) {
    return;
  } else if (sortOrder === ASC_SORT_STATE) {
    return DESC_SORT_STATE;
  }
  return ASC_SORT_STATE;
}
function getHeaderSpanElement(TH) {
  const headerSpanElement = TH.querySelector(`.${HEADER_SPAN_CLASS}`);
  return headerSpanElement;
}
function isFirstLevelColumnHeader(column, TH) {
  if (column < 0) {
    return false;
  }
  return isBottomMostColumnHeader(TH);
}
function wasHeaderClickedProperly(row, column, clickEvent) {
  if (column < 0 || row >= 0 || isRightClick(clickEvent)) {
    return false;
  }
  if (row === -1) {
    return true;
  }
  const targetHeader = typeof eventTargetEl(clickEvent)?.closest === "function" ? eventTargetEl(clickEvent).closest("th") : null;
  return targetHeader !== null && isBottomMostColumnHeader(targetHeader);
}
function createIntlDateCompareFunction(sortOrder, columnPluginSettings) {
  return function(value, nextValue) {
    const { sortEmptyCells } = columnPluginSettings;
    if (value === nextValue) {
      return DO_NOT_SWAP;
    }
    if (isEmpty$1(value)) {
      if (isEmpty$1(nextValue)) {
        return DO_NOT_SWAP;
      }
      if (sortEmptyCells) {
        return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
      }
      return FIRST_AFTER_SECOND;
    }
    if (isEmpty$1(nextValue)) {
      if (sortEmptyCells) {
        return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
      }
      return FIRST_BEFORE_SECOND;
    }
    const firstDate = parseToLocalDate(value);
    const nextDate = parseToLocalDate(nextValue);
    if (firstDate === null) {
      return FIRST_AFTER_SECOND;
    }
    if (nextDate === null) {
      return FIRST_BEFORE_SECOND;
    }
    if (nextDate > firstDate) {
      return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
    }
    if (nextDate < firstDate) {
      return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
    }
    return DO_NOT_SWAP;
  };
}
function createIntlTimeCompareFunction(sortOrder, columnPluginSettings) {
  return function(value, nextValue) {
    const { sortEmptyCells } = columnPluginSettings;
    if (value === nextValue) {
      return DO_NOT_SWAP;
    }
    if (isEmpty$1(value)) {
      if (isEmpty$1(nextValue)) {
        return DO_NOT_SWAP;
      }
      if (sortEmptyCells) {
        return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
      }
      return FIRST_AFTER_SECOND;
    }
    if (isEmpty$1(nextValue)) {
      if (sortEmptyCells) {
        return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
      }
      return FIRST_BEFORE_SECOND;
    }
    const firstDate = parseToLocalTime(value);
    const nextDate = parseToLocalTime(nextValue);
    if (firstDate === null) {
      return FIRST_AFTER_SECOND;
    }
    if (nextDate === null) {
      return FIRST_BEFORE_SECOND;
    }
    if (nextDate > firstDate) {
      return sortOrder === "asc" ? FIRST_BEFORE_SECOND : FIRST_AFTER_SECOND;
    }
    if (nextDate < firstDate) {
      return sortOrder === "asc" ? FIRST_AFTER_SECOND : FIRST_BEFORE_SECOND;
    }
    return DO_NOT_SWAP;
  };
}
function warnAboutPluginsConflict(workingPlugin, disabledPlugin) {
  warn$1(toSingleLine`Plugins \`columnSorting\` and \`multiColumnSorting\` should not be enabled simultaneously.\x20
    Only \`${workingPlugin}\` will work. The \`${disabledPlugin}\` plugin will remain disabled.`);
}
const HEADER_CLASS_ASC_SORT = "ascending";
const HEADER_CLASS_DESC_SORT = "descending";
const HEADER_CLASS_INDICATOR_DISABLED = "indicatorDisabled";
const HEADER_SORT_CLASS = "columnSorting";
const HEADER_ACTION_CLASS = "sortAction";
const orderToCssClass = /* @__PURE__ */ new Map([
  [
    ASC_SORT_STATE,
    HEADER_CLASS_ASC_SORT
  ],
  [
    DESC_SORT_STATE,
    HEADER_CLASS_DESC_SORT
  ]
]);
function getClassesToAdd$1(columnStatesManager, column, showSortIndicator, headerAction) {
  const cssClasses = [
    HEADER_SORT_CLASS
  ];
  if (headerAction) {
    cssClasses.push(HEADER_ACTION_CLASS);
  }
  if (showSortIndicator === false) {
    cssClasses.push(HEADER_CLASS_INDICATOR_DISABLED);
    return cssClasses;
  }
  const columnOrder = columnStatesManager.getSortOrderOfColumn(column);
  if (columnOrder !== void 0) {
    const cssClass = orderToCssClass.get(columnOrder);
    if (cssClass !== void 0) {
      cssClasses.push(cssClass);
    }
  }
  return cssClasses;
}
function getClassesToRemove$1(_headerSpanElement) {
  return Array.from(orderToCssClass.values()).concat(HEADER_ACTION_CLASS, HEADER_CLASS_INDICATOR_DISABLED, HEADER_SORT_CLASS);
}
function rootComparator$1(sortingOrders, columnMetas) {
  return function(rowIndexWithValues, nextRowIndexWithValues) {
    const [, ...values2] = rowIndexWithValues;
    const [, ...nextValues] = nextRowIndexWithValues;
    return (function getCompareResult(column) {
      const sortingOrder = sortingOrders[column];
      const columnMeta = columnMetas[column];
      const value = values2[column];
      const nextValue = nextValues[column];
      const typedMeta = columnMeta;
      const pluginSettings = typedMeta.columnSorting;
      const compareFunctionFactory2 = pluginSettings?.compareFunctionFactory ? pluginSettings.compareFunctionFactory : getCompareFunctionFactory(typedMeta.type ?? "");
      const compareResult = compareFunctionFactory2(sortingOrder, columnMeta, pluginSettings)(value, nextValue);
      return compareResult;
    })(0);
  };
}
function _check_private_redeclaration$12(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$U(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$U(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$U(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$U(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$U(receiver, privateMap, "get");
  return _class_apply_descriptor_get$U(receiver, descriptor);
}
function _class_private_field_init$U(obj, privateMap, value) {
  _check_private_redeclaration$12(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$U(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$U(receiver, privateMap, "set");
  _class_apply_descriptor_set$U(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$x = "columnSorting";
const PLUGIN_PRIORITY$x = 50;
const APPEND_COLUMN_CONFIG_STRATEGY = "append";
const REPLACE_COLUMN_CONFIG_STRATEGY = "replace";
const SHORTCUTS_GROUP$c = PLUGIN_KEY$x;
registerRootComparator(PLUGIN_KEY$x, rootComparator$1);
Hooks.getSingleton().register("beforeColumnSort");
Hooks.getSingleton().register("afterColumnSort");
const pluginConflictsState = /* @__PURE__ */ new WeakMap();
var _loadOrSortBySettings = /* @__PURE__ */ new WeakMap(), _onAfterGetColHeader$3 = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$5 = /* @__PURE__ */ new WeakMap(), _onAfterDataProviderFetch$2 = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseDown$5 = /* @__PURE__ */ new WeakMap();
class ColumnSorting extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$x;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$x;
  }
  /**
  * Checks if the plugin is enabled in the Handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ColumnSorting#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[this.pluginKey];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (pluginConflictsState.has(this.hot) && pluginConflictsState.get(this.hot) !== this.pluginKey) {
      this.hot.updateSettings({
        [this.pluginKey]: false
      });
      warnAboutPluginsConflict(pluginConflictsState.get(this.hot), this.pluginKey);
      return;
    }
    if (this.enabled) {
      return;
    }
    pluginConflictsState.set(this.hot, this.pluginKey);
    this.columnStatesManager = new ColumnStatesManager(this.hot, `${this.pluginKey}.sortingStates`);
    this.columnMetaCache = new PhysicalIndexToValueMap((physicalIndex) => {
      let visualIndex = this.hot.toVisualColumn(physicalIndex);
      if (visualIndex === null) {
        visualIndex = physicalIndex;
      }
      return this.getMergedPluginSettings(visualIndex);
    });
    this.hot.columnIndexMapper.registerMap(`${this.pluginKey}.columnMeta`, this.columnMetaCache);
    this.addHook("afterGetColHeader", _class_private_field_get$U(this, _onAfterGetColHeader$3));
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$U(this, _onBeforeOnCellMouseDown$5));
    this.addHook("afterOnCellMouseDown", (event, target) => this.onAfterOnCellMouseDown(event, target));
    this.addHook("afterInit", _class_private_field_get$U(this, _loadOrSortBySettings));
    this.addHook("afterLoadData", _class_private_field_get$U(this, _onAfterLoadData$5));
    this.addHook("afterDataProviderFetch", _class_private_field_get$U(this, _onAfterDataProviderFetch$2), -1);
    if (this.hot.view) {
      _class_private_field_get$U(this, _loadOrSortBySettings).call(this);
    }
    this.registerShortcuts();
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    const clearColHeader = (column, TH) => {
      const headerSpanElement = getHeaderSpanElement(TH);
      if (isFirstLevelColumnHeader(column, TH) === false || headerSpanElement === null) {
        return;
      }
      this.updateHeaderClasses(headerSpanElement);
    };
    pluginConflictsState.delete(this.hot);
    this.hot.addHook("afterGetColHeader", clearColHeader);
    this.hot.addHookOnce("afterViewRender", () => {
      this.hot.removeHook("afterGetColHeader", clearColHeader);
    });
    this.hot.batchExecution(() => {
      if (this.indexesSequenceCache !== null) {
        this.hot.rowIndexMapper.setIndexesSequence(this.indexesSequenceCache.getValues());
        this.hot.rowIndexMapper.unregisterMap(this.pluginKey);
        this.indexesSequenceCache = null;
      }
    }, true);
    this.hot.columnIndexMapper.unregisterMap(`${this.pluginKey}.columnMeta`);
    this.columnStatesManager?.destroy();
    this.columnMetaCache = null;
    this.columnStatesManager = null;
    this.unregisterShortcuts();
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for toggling column sorting functionality.
  *
  * @private
  */
  registerShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.addShortcut({
      keys: [
        [
          "Enter"
        ]
      ],
      callback: () => {
        const activeRange = this.hot.getSelectedRangeActive();
        if (!activeRange) {
          return false;
        }
        const { highlight } = activeRange;
        this.sort(this.getColumnNextConfig(highlight.col ?? 0));
        return false;
      },
      runOnlyIf: () => {
        const highlight = this.hot.getSelectedRangeActive()?.highlight;
        const highlightedHeaderElement = highlight && highlight.row !== null && highlight.col !== null ? this.hot.getCell(highlight.row, highlight.col, true) : null;
        return !!(highlight && this.hot.getSelectedRangeActive()?.isSingle() && this.hot.selection.isCellVisible(highlight) && highlight.row !== null && highlight.row < 0 && highlight.col !== null && highlight.col >= 0 && highlightedHeaderElement && isBottomMostColumnHeader(highlightedHeaderElement));
      },
      relativeToGroup: EDITOR_EDIT_GROUP,
      position: "before",
      group: SHORTCUTS_GROUP$c
    });
  }
  /**
  * Unregister shortcuts responsible for toggling column sorting functionality.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$c);
  }
  // DIFF - MultiColumnSorting & ColumnSorting: changed function documentation.
  /**
  * Sorts the table by chosen columns and orders.
  *
  * @param {undefined|object} sortConfig Single column sort configuration. The configuration object contains `column` and `sortOrder` properties.
  * First of them contains visual column index, the second one contains sort order (`asc` for ascending, `desc` for descending).
  *
  * **Note**: Please keep in mind that every call of `sort` function set an entirely new sort order. Previous sort configs aren't preserved.
  *
  * @example
  * ```js
  * // sort ascending first visual column
  * hot.getPlugin('columnSorting').sort({ column: 0, sortOrder: 'asc' });
  * ```
  *
  * @fires Hooks#beforeColumnSort
  * @fires Hooks#afterColumnSort
  */
  sort(sortConfig) {
    const currentSortConfig = this.columnStatesManager.getSortStates();
    const destinationSortConfigs = this.getNormalizedSortConfigs(sortConfig);
    const sortPossible = this.areValidSortConfigs(destinationSortConfigs);
    const allowSort = this.hot.runHooks("beforeColumnSort", currentSortConfig, destinationSortConfigs, sortPossible);
    if (allowSort === false) {
      return;
    }
    if (currentSortConfig.length === 0 && this.indexesSequenceCache === null) {
      this.indexesSequenceCache = this.hot.rowIndexMapper.registerMap(this.pluginKey, new IndexesSequence());
      this.indexesSequenceCache.setValues(this.hot.rowIndexMapper.getIndexesSequence());
    }
    if (sortPossible) {
      this.columnStatesManager?.setSortStates(destinationSortConfigs);
      this.sortByPresetSortStates(destinationSortConfigs);
    }
    this.hot.runHooks("afterColumnSort", currentSortConfig, sortPossible ? destinationSortConfigs : currentSortConfig, sortPossible);
    if (sortPossible) {
      this.hot.render();
    }
  }
  /**
  * Clear the sort performed on the table.
  */
  clearSort() {
    this.sort([]);
  }
  /**
  * Checks if the table is sorted (any column have to be sorted).
  *
  * @returns {boolean}
  */
  isSorted() {
    return this.enabled && !this.columnStatesManager?.isListOfSortedColumnsEmpty();
  }
  /**
  * Get sort configuration for particular column or for all sorted columns. Objects contain `column` and `sortOrder` properties.
  *
  * **Note**: Please keep in mind that returned objects expose **visual** column index under the `column` key. They are handled by the `sort` function.
  *
  * @param {number} [column] Visual column index.
  * @returns {undefined|object|Array}
  */
  getSortConfig(column) {
    if (column !== void 0) {
      return this.columnStatesManager?.getColumnSortState(column);
    }
    return this.columnStatesManager?.getSortStates();
  }
  /**
  * @description
  * Warn: Useful mainly for providing server side sort implementation (see in the example below). It doesn't sort the data set. It just sets sort configuration for all sorted columns.
  * Note: Please keep in mind that this method doesn't re-render the table.
  *
  * @example
  * ```js
  * beforeColumnSort: function(currentSortConfig, destinationSortConfigs) {
  *   const columnSortPlugin = this.getPlugin('columnSorting');
  *
  *   columnSortPlugin.setSortConfig(destinationSortConfigs);
  *
  *   // const newData = ... // Calculated data set, ie. from an AJAX call.
  *
  *   this.updateData(newData); // Update data set and re-render the table.
  *
  *   return false; // The blockade for the default sort action.
  * }
  * ```
  *
  * @param {undefined|object|Array} sortConfig Single column sort configuration or full sort configuration (for all sorted columns).
  * The configuration object contains `column` and `sortOrder` properties. First of them contains visual column index, the second one contains
  * sort order (`asc` for ascending, `desc` for descending).
  */
  setSortConfig(sortConfig) {
    const destinationSortConfigs = this.getNormalizedSortConfigs(sortConfig);
    if (this.areValidSortConfigs(destinationSortConfigs)) {
      this.columnStatesManager?.setSortStates(destinationSortConfigs);
    }
  }
  /**
  * Get normalized sort configs.
  *
  * @private
  * @param {object|Array} [sortConfig=[]] Single column sort configuration or full sort configuration (for all sorted columns).
  * The configuration object contains `column` and `sortOrder` properties. First of them contains visual column index, the second one contains
  * sort order (`asc` for ascending, `desc` for descending).
  * @returns {Array}
  */
  getNormalizedSortConfigs(sortConfig = []) {
    if (Array.isArray(sortConfig)) {
      return sortConfig.slice(0, 1);
    }
    return [
      sortConfig
    ];
  }
  /**
  * Get if sort configs are valid.
  *
  * @private
  * @param {Array} sortConfigs Sort configuration for all sorted columns. Objects contain `column` and `sortOrder` properties.
  * @returns {boolean}
  */
  areValidSortConfigs(sortConfigs) {
    const numberOfColumns = this.hot.countCols();
    return areValidSortStates(sortConfigs) && sortConfigs.every(({ column }) => column <= numberOfColumns && column >= 0);
  }
  /**
  * Get next sort configuration for particular column. Object contain `column` and `sortOrder` properties.
  *
  * **Note**: Please keep in mind that returned object expose **visual** column index under the `column` key.
  *
  * @private
  * @param {number} column Visual column index.
  * @returns {undefined|object}
  */
  getColumnNextConfig(column) {
    const sortOrder = this.columnStatesManager?.getSortOrderOfColumn(column);
    if (isDefined(sortOrder)) {
      const nextSortOrder = getNextSortOrder(sortOrder);
      if (nextSortOrder !== void 0) {
        return {
          column,
          sortOrder: nextSortOrder
        };
      }
      return;
    }
    const nrOfColumns = this.hot.countCols();
    if (Number.isInteger(column) && column >= 0 && column < nrOfColumns) {
      return {
        column,
        sortOrder: getNextSortOrder() ?? "asc"
      };
    }
  }
  /**
  * Get sort configuration with "next order" for particular column.
  *
  * @private
  * @param {number} columnToChange Visual column index of column which order will be changed.
  * @param {string} strategyId ID of strategy. Possible values: 'append' and 'replace'. The first one
  * change order of particular column and change it's position in the sort queue to the last one. The second one
  * just change order of particular column.
  *
  * **Note**: Please keep in mind that returned objects expose **visual** column index under the `column` key.
  *
  * @returns {Array}
  */
  getNextSortConfig(columnToChange, strategyId = APPEND_COLUMN_CONFIG_STRATEGY) {
    const indexOfColumnToChange = this.columnStatesManager.getIndexOfColumnInSortQueue(columnToChange);
    const isColumnSorted = indexOfColumnToChange !== -1;
    const currentSortConfig = this.columnStatesManager.getSortStates();
    const nextColumnConfig = this.getColumnNextConfig(columnToChange);
    if (isColumnSorted) {
      if (isUndefined$1(nextColumnConfig)) {
        return [
          ...currentSortConfig.slice(0, indexOfColumnToChange),
          ...currentSortConfig.slice(indexOfColumnToChange + 1)
        ];
      }
      if (strategyId === APPEND_COLUMN_CONFIG_STRATEGY) {
        return [
          ...currentSortConfig.slice(0, indexOfColumnToChange),
          ...currentSortConfig.slice(indexOfColumnToChange + 1),
          nextColumnConfig
        ];
      } else if (strategyId === REPLACE_COLUMN_CONFIG_STRATEGY) {
        return [
          ...currentSortConfig.slice(0, indexOfColumnToChange),
          nextColumnConfig,
          ...currentSortConfig.slice(indexOfColumnToChange + 1)
        ];
      }
    }
    if (nextColumnConfig !== void 0) {
      return currentSortConfig.concat(nextColumnConfig);
    }
    return currentSortConfig;
  }
  /**
  * Get plugin's column config for the specified column index.
  *
  * @private
  * @param {object} columnConfig Configuration inside `columns` property for the specified column index.
  * @returns {object}
  */
  getPluginColumnConfig(columnConfig) {
    if (isObject$1(columnConfig)) {
      const pluginColumnConfig = columnConfig[this.pluginKey];
      if (isObject$1(pluginColumnConfig)) {
        return pluginColumnConfig;
      }
    }
    return {};
  }
  /**
  * Get plugin settings related properties, properly merged from cascade settings.
  *
  * @private
  * @param {number} column Visual column index.
  * @returns {object}
  */
  getMergedPluginSettings(column) {
    const pluginMainSettings = this.hot.getSettings()[this.pluginKey];
    const storedColumnProperties = this.columnStatesManager?.getAllColumnsProperties() ?? {};
    const cellMeta = this.hot.getCellMeta(0, column);
    const columnMeta = Object.getPrototypeOf(cellMeta);
    if (Array.isArray(columnMeta.columns)) {
      return Object.assign(storedColumnProperties, pluginMainSettings, this.getPluginColumnConfig(columnMeta.columns[column]));
    } else if (isFunction$1(columnMeta.columns)) {
      const columnConfig = columnMeta.columns(column);
      return Object.assign(storedColumnProperties, pluginMainSettings, this.getPluginColumnConfig(columnConfig));
    }
    return Object.assign(storedColumnProperties, pluginMainSettings);
  }
  /**
  * Get copy of settings for first cell in the column.
  *
  * @private
  * @param {number} column Visual column index.
  * @returns {object}
  */
  // TODO: Workaround. Inheriting of non-primitive cell meta values doesn't work. Instead of getting properties from column meta we call this function.
  // TODO: Remove test named: "should not break the dataset when inserted new row" (#5431).
  getFirstCellSettings(column) {
    const cellMeta = this.hot.getCellMeta(0, column);
    const cellMetaCopy = Object.create(cellMeta);
    cellMetaCopy[this.pluginKey] = this.columnMetaCache?.getValueAtIndex(this.hot.toPhysicalColumn(column));
    return cellMetaCopy;
  }
  /**
  * Get number of rows which should be sorted.
  *
  * @private
  * @param {number} numberOfRows Total number of displayed rows.
  * @returns {number}
  */
  getNumberOfRowsToSort(numberOfRows) {
    const settings = this.hot.getSettings();
    const fixedRowsBottom = settings.fixedRowsBottom || 0;
    if ((settings.maxRows ?? Infinity) <= numberOfRows) {
      return Math.max(0, (settings.maxRows ?? 0) - fixedRowsBottom);
    }
    return Math.max(0, numberOfRows - (settings.minSpareRows ?? 0) - fixedRowsBottom);
  }
  /**
  * Performs the sorting using a stable sort function basing on internal state of sorting.
  *
  * @param {Array} sortConfigs Sort configuration for all sorted columns. Objects contain `column` and `sortOrder` properties.
  * @private
  */
  sortByPresetSortStates(sortConfigs) {
    this.hot.rowIndexMapper.setIndexesSequence(this.indexesSequenceCache.getValues());
    if (sortConfigs.length === 0) {
      return;
    }
    const indexesWithData = [];
    const numberOfRows = this.hot.countRows();
    const settings = this.hot.getSettings();
    const fixedRowsTop = settings.fixedRowsTop || 0;
    const upperBound = this.getNumberOfRowsToSort(numberOfRows);
    const getDataForSortedColumns = (visualRowIndex) => arrayMap(sortConfigs, (sortConfig) => this.hot.getDataAtCell(visualRowIndex, sortConfig.column));
    for (let visualRowIndex = fixedRowsTop; visualRowIndex < upperBound; visualRowIndex += 1) {
      indexesWithData.push([
        this.hot.toPhysicalRow(visualRowIndex),
        ...getDataForSortedColumns(visualRowIndex)
      ]);
    }
    const indexesBefore = arrayMap(indexesWithData, (indexWithData) => indexWithData[0]);
    sort(indexesWithData, this.pluginKey, arrayMap(sortConfigs, (sortConfig) => sortConfig.sortOrder), arrayMap(sortConfigs, (sortConfig) => this.getFirstCellSettings(sortConfig.column)));
    for (let visualRowIndex = upperBound; visualRowIndex < numberOfRows; visualRowIndex += 1) {
      indexesWithData.push([
        visualRowIndex,
        ...getDataForSortedColumns(visualRowIndex)
      ]);
    }
    const indexesAfter = arrayMap(indexesWithData, (indexWithData) => indexWithData[0]);
    const indexMapping = new Map(arrayMap(indexesBefore, (indexBefore, indexInsideArray) => [
      indexBefore,
      indexesAfter[indexInsideArray]
    ]));
    const newIndexesSequence = arrayMap(this.hot.rowIndexMapper.getIndexesSequence(), (physicalIndex) => {
      return indexMapping.get(physicalIndex) ?? physicalIndex;
    });
    this.hot.rowIndexMapper.setIndexesSequence(newIndexesSequence);
  }
  /**
  * Sort the table by provided configuration.
  *
  * @private
  * @param {object} allSortSettings All sort config settings. Object may contain `initialConfig`, `indicator`,
  * `sortEmptyCells`, `headerAction` and `compareFunctionFactory` properties.
  */
  sortBySettings(allSortSettings) {
    if (isPlainObject$1(allSortSettings)) {
      this.columnStatesManager.updateAllColumnsProperties(allSortSettings);
      const { initialConfig } = allSortSettings;
      if (Array.isArray(initialConfig) || isPlainObject$1(initialConfig)) {
        this.sort(initialConfig);
      }
    } else {
      this.hot.render();
    }
  }
  /**
  * Update header classes.
  *
  * @private
  * @param {HTMLElement} headerSpanElement Header span element.
  * @param {...*} args Extra arguments for helpers.
  */
  updateHeaderClasses(headerSpanElement, columnStatesManager, column, showSortIndicator, headerActionEnabled) {
    removeClass(headerSpanElement, getClassesToRemove$1());
    if (this.enabled !== false && columnStatesManager !== void 0 && column !== void 0) {
      addClass(headerSpanElement, getClassesToAdd$1(columnStatesManager, column, showSortIndicator ?? false, headerActionEnabled ?? false));
    }
  }
  /**
  * Overwriting base plugin's `onUpdateSettings` method. Please keep in mind that `onAfterUpdateSettings` isn't called
  * for `updateSettings` in specific situations.
  *
  * @private
  * @param {object} newSettings New settings object.
  */
  onUpdateSettings(newSettings) {
    super.onUpdateSettings(newSettings);
    if (this.columnMetaCache !== null) {
      this.columnMetaCache.init(this.hot.columnIndexMapper.getNumberOfIndexes());
    }
    const pluginSettings = newSettings[this.pluginKey];
    if (isDefined(pluginSettings)) {
      this.sortBySettings(pluginSettings);
    }
  }
  /**
  * Indicates if clickable header was clicked.
  *
  * @private
  * @param {MouseEvent} event The `mousedown` event.
  * @param {number} column Visual column index.
  * @returns {boolean}
  */
  wasClickableHeaderClicked(event, column) {
    const columnSettings = this.getFirstCellSettings(column);
    const pluginSettingsForColumn = columnSettings[this.pluginKey];
    const headerActionEnabled = pluginSettingsForColumn.headerAction;
    return headerActionEnabled && hasClass(eventTargetEl(event), HEADER_SPAN_CLASS);
  }
  /**
  * Callback for the `onAfterOnCellMouseDown` hook.
  *
  * @private
  * @param {Event} event Event which are provided by hook.
  * @param {CellCoords} coords Visual coords of the selected cell.
  */
  onAfterOnCellMouseDown(event, coords) {
    if (wasHeaderClickedProperly(coords.row, coords.col, event) === false) {
      return;
    }
    if (this.wasClickableHeaderClicked(event, coords.col)) {
      if (this.hot.getShortcutManager().isCtrlPressed()) {
        this.hot.deselectCell();
        this.hot.selectColumns(coords.col);
      }
      const activeEditor = this.hot.getActiveEditor();
      const nextConfig = this.getColumnNextConfig(coords.col);
      if (activeEditor?.isOpened() && this.hot.getCellValidator(activeEditor.row, activeEditor.col)) {
        this.hot.addHookOnce("postAfterValidate", () => {
          this.sort(nextConfig);
        });
      } else {
        this.sort(nextConfig);
      }
    }
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    this.columnStatesManager?.destroy();
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$U(this, _loadOrSortBySettings, {
      writable: true,
      value: void 0
    }), _class_private_field_init$U(this, _onAfterGetColHeader$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$U(this, _onAfterLoadData$5, {
      writable: true,
      value: void 0
    }), /**
    * Callback for the `afterDataProviderFetch` hook.
    * Keeps header sort state in sync with query `sort` after server-backed `loadData` (same timing as Pagination).
    *
    * @param {object} result [[Hooks#afterDataProviderFetch]] payload; reads `columnSortConfig` only.
    */
    _class_private_field_init$U(this, _onAfterDataProviderFetch$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$U(this, _onBeforeOnCellMouseDown$5, {
      writable: true,
      value: void 0
    }), /**
    * Instance of column state manager.
    *
    * @private
    * @type {null|ColumnStatesManager}
    */
    this.columnStatesManager = null, /**
    * Cached column properties from plugin like i.e. `indicator`, `headerAction`.
    *
    * @private
    * @type {null|PhysicalIndexToValueMap}
    */
    this.columnMetaCache = null, /**
    * Main settings key designed for the plugin.
    *
    * @private
    * @type {string}
    */
    this.pluginKey = PLUGIN_KEY$x, /**
    * Plugin indexes cache.
    *
    * @private
    * @type {null|IndexesSequence}
    */
    this.indexesSequenceCache = null, _class_private_field_set$U(this, _loadOrSortBySettings, () => {
      const allSortSettings = this.hot.getSettings()[this.pluginKey];
      this.sortBySettings(allSortSettings);
    }), _class_private_field_set$U(this, _onAfterGetColHeader$3, (column, TH) => {
      const headerSpanElement = getHeaderSpanElement(TH);
      if (isFirstLevelColumnHeader(column, TH) === false || headerSpanElement === null) {
        return;
      }
      const columnSettings = this.getFirstCellSettings(column);
      const pluginSettingsForColumn = columnSettings[this.pluginKey];
      const showSortIndicator = pluginSettingsForColumn.indicator;
      const headerActionEnabled = pluginSettingsForColumn.headerAction;
      this.updateHeaderClasses(headerSpanElement, this.columnStatesManager ?? void 0, column, showSortIndicator, headerActionEnabled);
      if (this.hot.getSettings().ariaTags) {
        const currentSortState = this.columnStatesManager?.getSortOrderOfColumn(column);
        setAttribute(TH, ...A11Y_SORT(currentSortState ? `${currentSortState}ending` : "none"));
      }
    }), _class_private_field_set$U(this, _onAfterLoadData$5, (initialLoad) => {
      if (initialLoad === true) {
        if (this.hot.view) {
          _class_private_field_get$U(this, _loadOrSortBySettings).call(this);
        }
      }
    }), _class_private_field_set$U(this, _onAfterDataProviderFetch$2, (result) => {
      this.setSortConfig(result?.columnSortConfig ?? []);
    }), _class_private_field_set$U(this, _onBeforeOnCellMouseDown$5, (event, coords, TD, controller) => {
      if (wasHeaderClickedProperly(coords.row, coords.col, event) === false) {
        return;
      }
      if (this.wasClickableHeaderClicked(event, coords.col) && this.hot.getShortcutManager().isCtrlPressed()) {
        controller.column = true;
      }
    });
  }
}
function isNullishOrNaN(value) {
  return value === null || value === void 0 || isNaN(value);
}
function roundFloat(value, option) {
  if (typeof value !== "number") {
    return value;
  }
  const stringifyValue = (number) => number.toString();
  switch (typeof option) {
    case "number":
      return value.toFixed(Math.min(Math.max(0, option), 100));
    case "boolean":
      return option ? stringifyValue(Math.round(value)) : value;
    case "string":
      if (option === "auto") {
        const integerDigits = Math.round(value).toString().length;
        return value.toFixed(8 - integerDigits);
      }
      return value;
    default:
      return value;
  }
}
class Endpoints {
  /**
  * Initialize the endpoints provided in the settings.
  */
  initEndpoints() {
    this.endpoints = this.parseSettings();
    this.refreshAllEndpoints();
  }
  /**
  * Get a single endpoint object.
  *
  * @param {number} index Index of the endpoint.
  * @returns {object}
  */
  getEndpoint(index2) {
    if (this.settingsType === "function") {
      return this.fillMissingEndpointData(this.settings)[index2];
    }
    return this.endpoints[index2];
  }
  /**
  * Get an array with all the endpoints.
  *
  * @returns {Array}
  */
  getAllEndpoints() {
    if (this.settingsType === "function") {
      return this.fillMissingEndpointData(this.settings);
    }
    return this.endpoints;
  }
  /**
  * Used to fill the blanks in the endpoint data provided by a settings function.
  *
  * @private
  * @param {Function} func Function provided in the HOT settings.
  * @returns {Array} An array of endpoints.
  */
  fillMissingEndpointData(func) {
    return this.parseSettings(func.call(this));
  }
  /**
  * Parse plugin's settings.
  *
  * @param {Array} settings The settings array.
  * @returns {object[]}
  */
  parseSettings(settings) {
    const endpointsArray = [];
    let settingsArray = settings;
    if (!settingsArray && typeof this.settings === "function") {
      this.settingsType = "function";
      return;
    }
    if (!settingsArray) {
      settingsArray = this.settings;
    }
    arrayEach(settingsArray, (val) => {
      const newEndpoint = {};
      this.assignSetting(val, newEndpoint, "ranges", [
        [
          0,
          this.hot.countRows() - 1
        ]
      ]);
      this.assignSetting(val, newEndpoint, "reversedRowCoords", false);
      this.assignSetting(val, newEndpoint, "destinationRow", new Error(`
        You must provide a destination row for the Column Summary plugin in order to work properly!
      `));
      this.assignSetting(val, newEndpoint, "destinationColumn", new Error(`
        You must provide a destination column for the Column Summary plugin in order to work properly!
      `));
      this.assignSetting(val, newEndpoint, "sourceColumn", val.destinationColumn);
      this.assignSetting(val, newEndpoint, "type", "sum");
      this.assignSetting(val, newEndpoint, "forceNumeric", false);
      this.assignSetting(val, newEndpoint, "suppressDataTypeErrors", true);
      this.assignSetting(val, newEndpoint, "customFunction", null);
      this.assignSetting(val, newEndpoint, "readOnly", true);
      this.assignSetting(val, newEndpoint, "roundFloat", false);
      endpointsArray.push(newEndpoint);
    });
    return endpointsArray;
  }
  /**
  * Setter for the internal setting objects.
  *
  * @param {object} settings Object with the settings.
  * @param {object} endpoint Contains information about the endpoint for the the calculation.
  * @param {string} name Settings name.
  * @param {object} defaultValue Default value for the settings.
  */
  assignSetting(settings, endpoint, name, defaultValue) {
    if (name === "ranges" && settings[name] === void 0) {
      endpoint[name] = defaultValue;
      return;
    } else if (name === "ranges" && settings[name].length === 0) {
      return;
    }
    if (settings[name] === void 0) {
      if (defaultValue instanceof Error) {
        throw defaultValue;
      }
      endpoint[name] = defaultValue;
    } else {
      if (name === "destinationRow" && endpoint.reversedRowCoords) {
        endpoint[name] = this.hot.countRows() - settings[name] - 1;
      } else {
        endpoint[name] = settings[name];
      }
    }
  }
  /**
  * Resets the endpoint setup before the structure alteration (like inserting or removing rows/columns). Used for settings provided as a function.
  *
  * @private
  * @param {string} action Type of the action performed.
  * @param {number} index Row/column index.
  * @param {number} number Number of rows/columns added/removed.
  */
  resetSetupBeforeStructureAlteration(action, index2, number) {
    if (this.settingsType !== "function") {
      return;
    }
    const type = action.indexOf("row") > -1 ? "row" : "col";
    const endpoints = this.getAllEndpoints();
    arrayEach(endpoints, (val) => {
      if (type === "row" && val.destinationRow >= index2) {
        if (action === "insert_row") {
          val.alterRowOffset = number;
        } else if (action === "remove_row") {
          val.alterRowOffset = -1 * number;
        }
      }
      if (type === "col" && val.destinationColumn >= index2) {
        if (action === "insert_col") {
          val.alterColumnOffset = number;
        } else if (action === "remove_col") {
          val.alterColumnOffset = -1 * number;
        }
      }
    });
    this.resetAllEndpoints(endpoints, false);
  }
  /**
  * AfterCreateRow/afterCreateRow/afterRemoveRow/afterRemoveCol hook callback. Reset and reenables the summary functionality
  * after changing the table structure.
  *
  * @private
  * @param {string} action Type of the action performed.
  * @param {number} index Row/column index.
  * @param {number} number Number of rows/columns added/removed.
  * @param {Array} [logicRows] Array of the logical indexes.
  * @param {string} [source] Source of change.
  * @param {boolean} [forceRefresh] `true` of the endpoints should refresh after completing the function.
  */
  resetSetupAfterStructureAlteration(action, index2, number, logicRows, source, forceRefresh = true) {
    if (source === "auto") {
      return;
    }
    if (this.settingsType === "function") {
      const beforeViewRenderCallback = () => {
        this.hot.removeHook("beforeViewRender", beforeViewRenderCallback);
        return this.refreshAllEndpoints();
      };
      this.hot.addHookOnce("beforeViewRender", beforeViewRenderCallback);
      return;
    }
    const type = action.indexOf("row") > -1 ? "row" : "col";
    const multiplier = action.indexOf("remove") > -1 ? -1 : 1;
    const endpoints = this.getAllEndpoints();
    const rowMoving = action.indexOf("move_row") === 0;
    const placeOfAlteration = index2;
    arrayEach(endpoints, (val) => {
      if (type === "row" && val.destinationRow >= placeOfAlteration) {
        val.alterRowOffset = multiplier * number;
      }
      if (type === "col" && val.destinationColumn >= placeOfAlteration) {
        val.alterColumnOffset = multiplier * number;
      }
    });
    this.resetAllEndpoints(endpoints, !rowMoving);
    if (rowMoving) {
      arrayEach(endpoints, (endpoint) => {
        this.extendEndpointRanges(endpoint, placeOfAlteration, logicRows?.[0] ?? 0, logicRows?.length ?? 0);
        this.recreatePhysicalRanges(endpoint);
        this.clearOffsetInformation(endpoint);
      });
    } else {
      arrayEach(endpoints, (endpoint) => {
        this.shiftEndpointCoordinates(endpoint, placeOfAlteration);
      });
    }
    if (forceRefresh) {
      this.refreshAllEndpoints();
    }
  }
  /**
  * Clear the offset information from the endpoint object.
  *
  * @private
  * @param {object} endpoint And endpoint object.
  */
  clearOffsetInformation(endpoint) {
    endpoint.alterRowOffset = void 0;
    endpoint.alterColumnOffset = void 0;
  }
  /**
  * Extend the row ranges for the provided endpoint.
  *
  * @private
  * @param {object} endpoint The endpoint object.
  * @param {number} placeOfAlteration Index of the row where the alteration takes place.
  * @param {number} previousPosition Previous endpoint result position.
  * @param {number} offset Offset generated by the alteration.
  */
  extendEndpointRanges(endpoint, placeOfAlteration, previousPosition, offset2) {
    arrayEach(endpoint.ranges, (range) => {
      if (range[1]) {
        if (placeOfAlteration >= range[0] && placeOfAlteration <= range[1]) {
          if (previousPosition > range[1]) {
            range[1] += offset2;
          } else if (previousPosition < range[0]) {
            range[0] -= offset2;
          }
        } else if (previousPosition >= range[0] && previousPosition <= range[1]) {
          range[1] -= offset2;
          if (placeOfAlteration <= range[0]) {
            range[0] += 1;
            range[1] += 1;
          }
        }
      }
    });
  }
  /**
  * Recreate the physical ranges for the provided endpoint. Used (for example) when a row gets moved and extends an existing range.
  *
  * @private
  * @param {object} endpoint An endpoint object.
  */
  recreatePhysicalRanges(endpoint) {
    const ranges = endpoint.ranges;
    const newRanges = [];
    const allIndexes = [];
    arrayEach(ranges, (range) => {
      const newRange = [];
      if (range[1]) {
        for (let i = range[0]; i <= range[1]; i++) {
          newRange.push(this.hot.toPhysicalRow(i));
        }
      } else {
        newRange.push(this.hot.toPhysicalRow(range[0]));
      }
      allIndexes.push(newRange);
    });
    arrayEach(allIndexes, (range) => {
      let newRange = [];
      arrayEach(range, (coord, index2) => {
        if (index2 === 0) {
          newRange.push(coord);
        } else if (range[index2] !== range[index2 - 1] + 1) {
          newRange.push(range[index2 - 1]);
          newRanges.push(newRange);
          newRange = [];
          newRange.push(coord);
        }
        if (index2 === range.length - 1) {
          newRange.push(coord);
          newRanges.push(newRange);
        }
      });
    });
    endpoint.ranges = newRanges;
  }
  /**
  * Shifts the endpoint coordinates by the defined offset.
  *
  * @private
  * @param {object} endpoint Endpoint object.
  * @param {number} offsetStartIndex Index of the performed change (if the change is located after the endpoint, nothing about the endpoint has to be changed.
  */
  shiftEndpointCoordinates(endpoint, offsetStartIndex) {
    if (endpoint.alterRowOffset && endpoint.alterRowOffset !== 0) {
      endpoint.destinationRow += endpoint.alterRowOffset || 0;
      arrayEach(endpoint.ranges, (element) => {
        arrayEach(element, (subElement, j) => {
          if (subElement >= offsetStartIndex) {
            element[j] += endpoint.alterRowOffset || 0;
          }
        });
      });
    } else if (endpoint.alterColumnOffset && endpoint.alterColumnOffset !== 0) {
      endpoint.destinationColumn += endpoint.alterColumnOffset || 0;
      endpoint.sourceColumn += endpoint.alterColumnOffset || 0;
    }
  }
  /**
  * Resets (removes) the endpoints from the table.
  *
  * @param {Array} [endpoints] Array containing the endpoints.
  * @param {boolean} [useOffset=true] Use the cell offset value.
  */
  resetAllEndpoints(endpoints = this.getAllEndpoints(), useOffset = true) {
    const anyEndpointOutOfRange = endpoints.some((endpoint) => {
      const alterRowOffset = endpoint.alterRowOffset || 0;
      const alterColOffset = endpoint.alterColumnOffset || 0;
      if (endpoint.destinationRow + alterRowOffset >= this.hot.countRows() || endpoint.destinationColumn + alterColOffset >= this.hot.countCols()) {
        return true;
      }
      return false;
    });
    if (anyEndpointOutOfRange) {
      return;
    }
    this.cellsToSetCache = [];
    arrayEach(endpoints, (endpoint) => {
      this.resetEndpointValue(endpoint, useOffset);
    });
    if (this.cellsToSetCache.length) {
      this.hot.setDataAtCell(this.cellsToSetCache, null, void 0, "ColumnSummary.reset");
    }
    this.cellsToSetCache = [];
  }
  /**
  * Calculate and refresh all defined endpoints.
  */
  refreshAllEndpoints() {
    this.cellsToSetCache = [];
    arrayEach(this.getAllEndpoints(), (value) => {
      this.currentEndpoint = value;
      this.plugin.calculate(value);
      this.setEndpointValue(value, "init");
    });
    this.currentEndpoint = null;
    if (this.cellsToSetCache.length) {
      this.hot.setDataAtCell(this.cellsToSetCache, null, void 0, "ColumnSummary.reset");
    }
    this.cellsToSetCache = [];
  }
  /**
  * Calculate and refresh endpoints only in the changed columns.
  *
  * @param {Array} changes Array of changes from the `afterChange` hook.
  */
  refreshChangedEndpoints(changes) {
    const needToRefresh = [];
    this.cellsToSetCache = [];
    arrayEach(changes, (value, key, changesObj) => {
      const change = value;
      if (`${change[2] || ""}` === `${change[3]}`) {
        return;
      }
      arrayEach(this.getAllEndpoints(), (endpoint, j) => {
        if (this.hot.propToCol(changesObj[key][1]) === endpoint.sourceColumn && needToRefresh.indexOf(j) === -1) {
          needToRefresh.push(j);
        }
      });
    });
    arrayEach(needToRefresh, (value) => {
      this.refreshEndpoint(this.getEndpoint(value));
    });
    if (this.cellsToSetCache.length) {
      this.hot.setDataAtCell(this.cellsToSetCache, null, void 0, "ColumnSummary.reset");
    }
    this.cellsToSetCache = [];
  }
  /**
  * Calculate and refresh endpoints whose `sourceColumn` (visual) matches any of the provided columns.
  *
  * @param {Set<number>|number[]} visualColumns Visual column indexes to match against.
  */
  refreshEndpointsBySourceColumns(visualColumns) {
    const columnsSet = visualColumns instanceof Set ? visualColumns : new Set(visualColumns);
    const matched = this.getAllEndpoints().filter((endpoint) => columnsSet.has(endpoint.sourceColumn));
    if (matched.length === 0) {
      return;
    }
    this.cellsToSetCache = [];
    arrayEach(matched, (endpoint) => {
      this.refreshEndpoint(endpoint);
    });
    if (this.cellsToSetCache.length) {
      this.hot.setDataAtCell(this.cellsToSetCache, null, void 0, "ColumnSummary.reset");
    }
    this.cellsToSetCache = [];
  }
  /**
  * Refreshes the cell meta information for the all endpoints after the `updateSettings` method call which in some
  * cases (call with `columns` option) can reset the cell metas to the initial state.
  */
  refreshCellMetas() {
    this.endpoints.forEach((endpoint) => {
      const destinationVisualRow = this.hot.toVisualRow(endpoint.destinationRow);
      if (destinationVisualRow !== null) {
        const cellMeta = this.hot.getCellMeta(destinationVisualRow, endpoint.destinationColumn);
        cellMeta.readOnly = endpoint.readOnly;
        cellMeta.className = "columnSummaryResult";
      }
    });
  }
  /**
  * Calculate and refresh a single endpoint.
  *
  * @param {object} endpoint Contains the endpoint information.
  */
  refreshEndpoint(endpoint) {
    this.currentEndpoint = endpoint;
    this.plugin.calculate(endpoint);
    this.setEndpointValue(endpoint, void 0);
    this.currentEndpoint = null;
  }
  /**
  * Reset the endpoint value.
  *
  * @param {object} endpoint Contains the endpoint information.
  * @param {boolean} [useOffset=true] Use the cell offset value.
  */
  resetEndpointValue(endpoint, useOffset = true) {
    const alterRowOffset = endpoint.alterRowOffset || 0;
    const alterColOffset = endpoint.alterColumnOffset || 0;
    this.cellsToSetCache.push([
      this.hot.toVisualRow(endpoint.destinationRow + (useOffset ? alterRowOffset : 0)),
      this.hot.toVisualColumn(endpoint.destinationColumn + (useOffset ? alterColOffset : 0)),
      ""
    ]);
  }
  /**
  * Set the endpoint value.
  *
  * @param {object} endpoint Contains the endpoint information.
  * @param {string} [source] Source of the call information.
  * @param {boolean} [render=false] `true` if it needs to render the table afterwards.
  */
  setEndpointValue(endpoint, source, render = false) {
    const visualEndpointRowIndex = this.hot.toVisualRow(endpoint.destinationRow);
    if (endpoint.destinationRow >= this.hot.countRows() || endpoint.destinationColumn >= this.hot.countCols()) {
      this.throwOutOfBoundsWarning();
      return;
    }
    const destinationVisualRow = this.hot.toVisualRow(endpoint.destinationRow);
    if (destinationVisualRow !== null) {
      const cellMeta = this.hot.getCellMeta(destinationVisualRow, endpoint.destinationColumn);
      if (source === "init" || cellMeta.readOnly !== endpoint.readOnly) {
        cellMeta.readOnly = endpoint.readOnly;
        cellMeta.className = "columnSummaryResult";
      }
    }
    endpoint.result = roundFloat(endpoint.result, endpoint.roundFloat);
    if (render) {
      this.hot.setDataAtCell(visualEndpointRowIndex, endpoint.destinationColumn, endpoint.result, "ColumnSummary.set");
    } else {
      this.cellsToSetCache.push([
        visualEndpointRowIndex,
        endpoint.destinationColumn,
        endpoint.result
      ]);
    }
    endpoint.alterRowOffset = void 0;
    endpoint.alterColumnOffset = void 0;
  }
  /**
  * Throw an error for the calculation range being out of boundaries.
  *
  * @private
  */
  throwOutOfBoundsWarning() {
    warn$1("One of the Column Summary plugins' destination points you provided is beyond the table boundaries!");
  }
  /**
  * Initializes the endpoints manager with a reference to the ColumnSummary plugin and the summary endpoint configuration.
  */
  constructor(plugin, settings) {
    this.endpoints = [];
    this.settingsType = "array";
    this.currentEndpoint = null;
    this.cellsToSetCache = [];
    this.plugin = plugin;
    this.hot = this.plugin.hot;
    this.settings = settings;
  }
}
function _check_private_redeclaration$11(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$T(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$T(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$T(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$T(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$T(receiver, privateMap, "get");
  return _class_apply_descriptor_get$T(receiver, descriptor);
}
function _class_private_field_init$T(obj, privateMap, value) {
  _check_private_redeclaration$11(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$T(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$T(receiver, privateMap, "set");
  _class_apply_descriptor_set$T(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$w = "columnSummary";
const PLUGIN_PRIORITY$w = 220;
var _refreshingFromFormulas = /* @__PURE__ */ new WeakMap(), _onAfterInit$5 = /* @__PURE__ */ new WeakMap(), _onAfterUpdateSettings$1 = /* @__PURE__ */ new WeakMap(), _onAfterChange$3 = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$4 = /* @__PURE__ */ new WeakMap(), _onAfterUpdateData$1 = /* @__PURE__ */ new WeakMap(), _onAfterFormulasValuesUpdate = /* @__PURE__ */ new WeakMap(), _onAfterRowMove$1 = /* @__PURE__ */ new WeakMap();
class ColumnSummary extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$w;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$w;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ColumnSummary#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$w];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.settings = this.hot.getSettings()[PLUGIN_KEY$w];
    this.endpoints = new Endpoints(this, this.settings);
    this.addHook("afterInit", _class_private_field_get$T(this, _onAfterInit$5));
    this.addHook("afterChange", _class_private_field_get$T(this, _onAfterChange$3));
    this.addHook("afterUpdateSettings", _class_private_field_get$T(this, _onAfterUpdateSettings$1));
    this.addHook("afterLoadData", _class_private_field_get$T(this, _onAfterLoadData$4));
    this.addHook("afterUpdateData", _class_private_field_get$T(this, _onAfterUpdateData$1));
    this.addHook("beforeCreateRow", (index2, amount) => {
      this.endpoints.resetSetupBeforeStructureAlteration("insert_row", index2, amount);
    });
    this.addHook("beforeCreateCol", (index2, amount) => {
      this.endpoints.resetSetupBeforeStructureAlteration("insert_col", index2, amount);
    });
    this.addHook("beforeRemoveRow", (index2, amount) => {
      this.endpoints.resetSetupBeforeStructureAlteration("remove_row", index2, amount);
    });
    this.addHook("beforeRemoveCol", (index2, amount) => {
      this.endpoints.resetSetupBeforeStructureAlteration("remove_col", index2, amount);
    });
    this.addHook("afterCreateRow", (index2, amount, source) => {
      this.endpoints.resetSetupAfterStructureAlteration("insert_row", index2, amount, null, source);
    });
    this.addHook("afterCreateCol", (index2, amount, source) => {
      this.endpoints.resetSetupAfterStructureAlteration("insert_col", index2, amount, null, source);
    });
    this.addHook("afterRemoveRow", (index2, amount, physicalRows, source) => this.endpoints.resetSetupAfterStructureAlteration("remove_row", index2, amount, physicalRows, source));
    this.addHook("afterRemoveCol", (index2, amount, physicalColumns, source) => this.endpoints.resetSetupAfterStructureAlteration("remove_col", index2, amount, physicalColumns, source));
    this.addHook("afterRowMove", _class_private_field_get$T(this, _onAfterRowMove$1));
    this.addHook("afterFormulasValuesUpdate", _class_private_field_get$T(this, _onAfterFormulasValuesUpdate));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.endpoints = null;
    this.settings = null;
    this.currentEndpoint = null;
    super.disablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`columnSummary`](@/api/options.md#columnsummary)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    this.endpoints.initEndpoints();
    super.updatePlugin();
  }
  /**
  * Calculates math for a single endpoint.
  *
  * @private
  * @param {object} endpoint Contains information about the endpoint.
  */
  calculate(endpoint) {
    switch (endpoint.type.toLowerCase()) {
      case "sum":
        endpoint.result = this.calculateSum(endpoint);
        break;
      case "min":
        endpoint.result = this.calculateMinMax(endpoint, endpoint.type);
        break;
      case "max":
        endpoint.result = this.calculateMinMax(endpoint, endpoint.type);
        break;
      case "count":
        endpoint.result = this.countEntries(endpoint);
        break;
      case "average":
        endpoint.result = this.calculateAverage(endpoint);
        break;
      case "custom":
        endpoint.result = endpoint.customFunction.call(this, endpoint);
        break;
    }
  }
  /**
  * Calculates sum of the values contained in ranges provided in the plugin config.
  *
  * @private
  * @param {object} endpoint Contains the endpoint information.
  * @returns {number} Sum for the selected range.
  */
  calculateSum(endpoint) {
    let sum2 = 0;
    for (const range of endpoint.ranges) {
      sum2 += this.getPartialSum(range, endpoint.sourceColumn);
    }
    return sum2;
  }
  /**
  * Returns partial sum of values from a single row range.
  *
  * @private
  * @param {Array} rowRange Range for the sum.
  * @param {number} col Column index.
  * @returns {number} The partial sum.
  */
  getPartialSum(rowRange, col) {
    let sum2 = 0;
    let i = rowRange[1] || rowRange[0];
    let cellValue = null;
    let biggestDecimalPlacesCount = 0;
    do {
      const rawValue = this.getCellValue(i, col);
      cellValue = isNullishOrNaN(rawValue) ? null : Number(rawValue);
      if (cellValue !== null) {
        const decimalPlaces = (`${cellValue}`.split(".")[1] || []).length || 1;
        if (decimalPlaces > biggestDecimalPlacesCount) {
          biggestDecimalPlacesCount = decimalPlaces;
        }
      }
      sum2 += cellValue ?? 0;
      i -= 1;
    } while (i >= rowRange[0]);
    return Math.round(sum2 * 10 ** biggestDecimalPlacesCount) / 10 ** biggestDecimalPlacesCount;
  }
  /**
  * Calculates the minimal value for the selected ranges.
  *
  * @private
  * @param {object} endpoint Contains the endpoint information.
  * @param {string} type `'min'` or `'max'`.
  * @returns {number} Min or Max value.
  */
  calculateMinMax(endpoint, type) {
    let result = null;
    for (const range of endpoint.ranges) {
      const partialResult = this.getPartialMinMax(range, endpoint.sourceColumn, type);
      if (result === null && partialResult !== null) {
        result = partialResult;
      }
      if (partialResult !== null) {
        switch (type) {
          case "min":
            result = Math.min(result, partialResult);
            break;
          case "max":
            result = Math.max(result, partialResult);
            break;
        }
      }
    }
    return result === null ? "Not enough data" : result;
  }
  /**
  * Returns a local minimum of the provided sub-range.
  *
  * @private
  * @param {Array} rowRange Range for the calculation.
  * @param {number} col Column index.
  * @param {string} type `'min'` or `'max'`.
  * @returns {number|null} Min or max value.
  */
  getPartialMinMax(rowRange, col, type) {
    let result = null;
    let i = rowRange[1] || rowRange[0];
    let cellValue;
    do {
      const rawValue = this.getCellValue(i, col);
      cellValue = isNullishOrNaN(rawValue) ? null : Number(rawValue);
      if (result === null) {
        result = cellValue;
      } else if (cellValue !== null) {
        switch (type) {
          case "min":
            result = Math.min(result, cellValue);
            break;
          case "max":
            result = Math.max(result, cellValue);
            break;
        }
      }
      i -= 1;
    } while (i >= rowRange[0]);
    return result;
  }
  /**
  * Counts empty cells in the provided row range.
  *
  * @private
  * @param {Array} rowRange Row range for the calculation.
  * @param {number} col Column index.
  * @returns {number} Empty cells count.
  */
  countEmpty(rowRange, col) {
    let cellValue;
    let counter = 0;
    let i = rowRange[1] || rowRange[0];
    do {
      cellValue = this.getCellValue(i, col);
      cellValue = isNullishOrNaN(cellValue) ? null : cellValue;
      if (cellValue === null) {
        counter += 1;
      }
      i -= 1;
    } while (i >= rowRange[0]);
    return counter;
  }
  /**
  * Counts non-empty cells in the provided row range.
  *
  * @private
  * @param {object} endpoint Contains the endpoint information.
  * @returns {number} Entry count.
  */
  countEntries(endpoint) {
    let result = 0;
    const ranges = endpoint.ranges;
    for (const range of ranges) {
      const partial = range[1] === void 0 ? 1 : range[1] - range[0] + 1;
      const emptyCount = this.countEmpty(range, endpoint.sourceColumn);
      result += partial;
      result -= emptyCount;
    }
    return result;
  }
  /**
  * Calculates the average value from the cells in the range.
  *
  * @private
  * @param {object} endpoint Contains the endpoint information.
  * @returns {number} Avarage value.
  */
  calculateAverage(endpoint) {
    const sum2 = this.calculateSum(endpoint);
    const entriesCount = this.countEntries(endpoint);
    return sum2 / entriesCount;
  }
  /**
  * Returns a cell value, taking into consideration a basic validation.
  *
  * @private
  * @param {number} row Row index.
  * @param {number} col Column index.
  * @returns {string} The cell value.
  */
  getCellValue(row, col) {
    const visualRowIndex = this.hot.toVisualRow(row);
    let cellValue = visualRowIndex !== null ? this.hot.getDataAtCell(visualRowIndex, col) : this.hot.getSourceDataAtCell(row, col);
    let cellClassName = "";
    if (visualRowIndex !== null) {
      cellClassName = this.hot.getCellMeta(visualRowIndex, col).className || "";
    }
    if (cellClassName.indexOf("columnSummaryResult") > -1) {
      return null;
    }
    if (this.endpoints.currentEndpoint.forceNumeric) {
      if (typeof cellValue === "string") {
        cellValue = cellValue.replace(/,/, ".");
      }
      cellValue = parseFloat(cellValue);
    }
    if (isNaN(Number(cellValue))) {
      if (!this.endpoints.currentEndpoint.suppressDataTypeErrors) {
        throwWithCause(toSingleLine`ColumnSummary plugin: cell at (${row}, ${col}) is not in a\x20
          numeric format. Cannot do the calculation.`);
      }
    }
    return cellValue;
  }
  constructor(...args) {
    super(...args), _class_private_field_init$T(this, _refreshingFromFormulas, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterInit$5, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterUpdateSettings$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterChange$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterLoadData$4, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterUpdateData$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterFormulasValuesUpdate, {
      writable: true,
      value: void 0
    }), _class_private_field_init$T(this, _onAfterRowMove$1, {
      writable: true,
      value: void 0
    }), /**
    * The Endpoints class instance. Used to make all endpoint-related operations.
    *
    * @private
    * @type {null|Endpoints}
    */
    this.endpoints = null, _class_private_field_set$T(this, _refreshingFromFormulas, false), _class_private_field_set$T(this, _onAfterInit$5, () => {
      this.endpoints.initEndpoints();
    }), _class_private_field_set$T(this, _onAfterUpdateSettings$1, (settings) => {
      if (settings.columns !== void 0) {
        this.endpoints.refreshCellMetas();
      }
    }), _class_private_field_set$T(this, _onAfterChange$3, (changes, source) => {
      if (changes && source !== "ColumnSummary.reset" && source !== "ColumnSummary.set" && source !== "loadData") {
        this.endpoints.refreshChangedEndpoints(changes);
      }
    }), _class_private_field_set$T(this, _onAfterLoadData$4, (data, firstRun) => {
      if (!firstRun) {
        this.endpoints.refreshAllEndpoints();
      }
    }), _class_private_field_set$T(this, _onAfterUpdateData$1, (data, firstRun) => {
      if (!firstRun) {
        this.endpoints.refreshAllEndpoints();
      }
    }), _class_private_field_set$T(this, _onAfterFormulasValuesUpdate, (changes) => {
      if (_class_private_field_get$T(this, _refreshingFromFormulas) || !this.endpoints || !changes?.length) {
        return;
      }
      const formulasPlugin = this.hot.getPlugin("formulas");
      if (!formulasPlugin?.enabled) {
        return;
      }
      const sheetId = formulasPlugin.sheetId;
      const changedHfColumns = /* @__PURE__ */ new Set();
      changes.forEach((change) => {
        if (change?.address?.sheet === sheetId) {
          changedHfColumns.add(change.address.col);
        }
      });
      if (changedHfColumns.size === 0) {
        return;
      }
      const changedVisualColumns = /* @__PURE__ */ new Set();
      this.endpoints.getAllEndpoints().forEach((endpoint) => {
        const hfSourceColumn = formulasPlugin.columnAxisSyncer.getHfIndexFromVisualIndex(endpoint.sourceColumn ?? 0);
        if (changedHfColumns.has(hfSourceColumn)) {
          changedVisualColumns.add(endpoint.sourceColumn ?? 0);
        }
      });
      if (changedVisualColumns.size === 0) {
        return;
      }
      _class_private_field_set$T(this, _refreshingFromFormulas, true);
      try {
        this.endpoints.refreshEndpointsBySourceColumns(changedVisualColumns);
      } finally {
        _class_private_field_set$T(this, _refreshingFromFormulas, false);
      }
    }), _class_private_field_set$T(this, _onAfterRowMove$1, (rows, finalIndex) => {
      this.endpoints.resetSetupBeforeStructureAlteration("move_row", rows[0], rows.length);
      this.endpoints.resetSetupAfterStructureAlteration("move_row", finalIndex, rows.length, rows, this.pluginName);
    });
  }
}
function _check_private_redeclaration$10(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$S(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$S(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$S(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$S(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$S(receiver, privateMap, "get");
  return _class_apply_descriptor_get$S(receiver, descriptor);
}
function _class_private_field_init$S(obj, privateMap, value) {
  _check_private_redeclaration$10(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$S(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$S(receiver, privateMap, "set");
  _class_apply_descriptor_set$S(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$H(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$H(obj, privateSet) {
  _check_private_redeclaration$10(obj, privateSet);
  privateSet.add(obj);
}
var _ignoreInitialCall = /* @__PURE__ */ new WeakMap(), _observedElement = /* @__PURE__ */ new WeakMap(), _observer = /* @__PURE__ */ new WeakMap(), _onResize = /* @__PURE__ */ new WeakSet();
class EditorResizeObserver {
  /**
  * Sets the observed element.
  *
  * @param {HTMLElement} element The element to observe.
  */
  setObservedElement(element) {
    _class_private_field_set$S(this, _observedElement, element);
  }
  /**
  * Stops observing the element.
  */
  unobserve() {
    if (_class_private_field_get$S(this, _observedElement)) {
      _class_private_field_get$S(this, _observer).unobserve(_class_private_field_get$S(this, _observedElement));
    }
  }
  /**
  * Starts observing the element.
  */
  observe() {
    _class_private_field_set$S(this, _ignoreInitialCall, true);
    if (_class_private_field_get$S(this, _observedElement)) {
      _class_private_field_get$S(this, _observer).observe(_class_private_field_get$S(this, _observedElement));
    }
  }
  /**
  * Destroys the observer.
  */
  destroy() {
    _class_private_field_get$S(this, _observer).disconnect();
  }
  constructor() {
    _class_private_method_init$H(this, _onResize);
    _class_private_field_init$S(this, _ignoreInitialCall, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$S(this, _observedElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$S(this, _observer, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$S(this, _ignoreInitialCall, true);
    _class_private_field_set$S(this, _observedElement, null);
    _class_private_field_set$S(this, _observer, new ResizeObserver((entries) => _class_private_method_get$H(this, _onResize, onResize).call(this, entries)));
  }
}
function onResize(entries) {
  if (_class_private_field_get$S(this, _ignoreInitialCall) || !Array.isArray(entries) || !entries.length) {
    _class_private_field_set$S(this, _ignoreInitialCall, false);
    return;
  }
  entries.forEach(({ borderBoxSize }) => {
    const { inlineSize, blockSize } = borderBoxSize[0];
    this.runLocalHooks("resize", inlineSize, blockSize);
  });
}
mixin(EditorResizeObserver, localHooks);
function _check_private_redeclaration$$(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$R(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$R(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$R(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$R(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$R(receiver, privateMap, "get");
  return _class_apply_descriptor_get$R(receiver, descriptor);
}
function _class_private_field_init$R(obj, privateMap, value) {
  _check_private_redeclaration$$(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$R(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$R(receiver, privateMap, "set");
  _class_apply_descriptor_set$R(receiver, descriptor, value);
  return value;
}
var _rootDocument$1 = /* @__PURE__ */ new WeakMap(), _rootPortalElement = /* @__PURE__ */ new WeakMap(), _isRtl$3 = /* @__PURE__ */ new WeakMap(), _container$1 = /* @__PURE__ */ new WeakMap(), _editor$1 = /* @__PURE__ */ new WeakMap(), _editorStyle = /* @__PURE__ */ new WeakMap(), _hidden = /* @__PURE__ */ new WeakMap(), _resizeObserver$1 = /* @__PURE__ */ new WeakMap();
class CommentEditor {
  /**
  * Returns the CSS class name applied to the outer comments container element.
  */
  static get CLASS_EDITOR_CONTAINER() {
    return "htCommentsContainer";
  }
  /**
  * Returns the CSS class name applied to the comment editor element.
  */
  static get CLASS_EDITOR() {
    return "htComments";
  }
  /**
  * Returns the CSS class name applied to the comment textarea input element.
  */
  static get CLASS_INPUT() {
    return "htCommentTextArea";
  }
  /**
  * Returns the CSS class name applied to cells that have comments attached.
  */
  static get CLASS_CELL() {
    return "htCommentCell";
  }
  /**
  * Set position of the comments editor according to the  provided x and y coordinates.
  *
  * @param {number} x X position (in pixels).
  * @param {number} y Y position (in pixels).
  */
  setPosition(x, y) {
    if (_class_private_field_get$R(this, _editorStyle)) {
      _class_private_field_get$R(this, _editorStyle).left = `${x}px`;
      _class_private_field_get$R(this, _editorStyle).top = `${y}px`;
    }
  }
  /**
  * Set the editor size according to the provided arguments.
  *
  * @param {number} width Width in pixels.
  * @param {number} height Height in pixels.
  */
  setSize(width, height) {
    if (width && height) {
      const input = this.getInputElement();
      input.style.width = `${width}px`;
      input.style.height = `${height}px`;
    }
  }
  /**
  * Returns the size of the comments editor.
  *
  * @returns {{ width: number, height: number }}
  */
  getSize() {
    return {
      width: outerWidth(this.getInputElement()),
      height: outerHeight(this.getInputElement())
    };
  }
  /**
  * Starts observing the editor size.
  */
  observeSize() {
    _class_private_field_get$R(this, _resizeObserver$1).observe();
  }
  /**
  * Reset the editor size to its initial state.
  */
  resetSize() {
    const input = this.getInputElement();
    input.style.width = "";
    input.style.height = "";
  }
  /**
  * Set the read-only state for the comments editor.
  *
  * @param {boolean} state The new read only state.
  */
  setReadOnlyState(state) {
    const input = this.getInputElement();
    input.readOnly = state;
  }
  /**
  * Show the comments editor.
  */
  show() {
    if (_class_private_field_get$R(this, _editorStyle)) {
      _class_private_field_get$R(this, _editorStyle).display = "block";
    }
    _class_private_field_set$R(this, _hidden, false);
  }
  /**
  * Hide the comments editor.
  */
  hide() {
    _class_private_field_get$R(this, _resizeObserver$1).unobserve();
    if (!_class_private_field_get$R(this, _hidden)) {
      if (_class_private_field_get$R(this, _editorStyle)) {
        _class_private_field_get$R(this, _editorStyle).display = "none";
      }
    }
    _class_private_field_set$R(this, _hidden, true);
  }
  /**
  * Checks if the editor is visible.
  *
  * @returns {boolean}
  */
  isVisible() {
    return _class_private_field_get$R(this, _editorStyle)?.display === "block";
  }
  /**
  * Set the comment value.
  *
  * @param {string} [value] The value to use.
  */
  setValue(value = "") {
    const comment = value || "";
    this.getInputElement().value = comment;
  }
  /**
  * Get the comment value.
  *
  * @returns {string}
  */
  getValue() {
    return this.getInputElement().value;
  }
  /**
  * Checks if the comment input element is focused.
  *
  * @returns {boolean}
  */
  isFocused() {
    return _class_private_field_get$R(this, _rootDocument$1).activeElement === this.getInputElement();
  }
  /**
  * Focus the comments input element.
  */
  focus() {
    this.getInputElement().focus();
  }
  /**
  * Create the `textarea` to be used as a comments editor.
  *
  * @returns {HTMLElement}
  */
  createEditor() {
    const editor = _class_private_field_get$R(this, _rootDocument$1).createElement("div");
    const textarea = _class_private_field_get$R(this, _rootDocument$1).createElement("textarea");
    editor.style.display = "none";
    _class_private_field_set$R(this, _container$1, _class_private_field_get$R(this, _rootDocument$1).createElement("div"));
    _class_private_field_get$R(this, _container$1).setAttribute("dir", _class_private_field_get$R(this, _isRtl$3) ? "rtl" : "ltr");
    addClass(_class_private_field_get$R(this, _container$1), CommentEditor.CLASS_EDITOR_CONTAINER);
    _class_private_field_get$R(this, _rootPortalElement).appendChild(_class_private_field_get$R(this, _container$1));
    addClass(editor, CommentEditor.CLASS_EDITOR);
    addClass(textarea, CommentEditor.CLASS_INPUT);
    textarea.dataset.hotInput = "true";
    editor.appendChild(textarea);
    _class_private_field_get$R(this, _container$1).appendChild(editor);
    return editor;
  }
  /**
  * Get the input element.
  *
  * @returns {HTMLTextAreaElement | null}
  */
  getInputElement() {
    return _class_private_field_get$R(this, _editor$1)?.querySelector(`.${CommentEditor.CLASS_INPUT}`) ?? null;
  }
  /**
  * Get the editor element.
  *
  * @returns {HTMLElement} The editor element.
  */
  getEditorElement() {
    return _class_private_field_get$R(this, _editor$1);
  }
  /**
  * Destroy the comments editor.
  */
  destroy() {
    const containerParentElement = _class_private_field_get$R(this, _container$1) ? _class_private_field_get$R(this, _container$1).parentNode : null;
    _class_private_field_get$R(this, _editor$1)?.parentNode?.removeChild(_class_private_field_get$R(this, _editor$1));
    _class_private_field_set$R(this, _editor$1, null);
    _class_private_field_set$R(this, _editorStyle, null);
    _class_private_field_get$R(this, _resizeObserver$1).destroy();
    if (containerParentElement && _class_private_field_get$R(this, _container$1)) {
      containerParentElement.removeChild(_class_private_field_get$R(this, _container$1));
    }
  }
  /**
  * Initializes the comment editor, builds its DOM structure, and attaches the resize observer.
  */
  constructor(rootDocument, isRtl2, rootPortalElement) {
    _class_private_field_init$R(this, _rootDocument$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _rootPortalElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _isRtl$3, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _container$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _editor$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _editorStyle, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _hidden, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$R(this, _resizeObserver$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$R(this, _isRtl$3, false);
    _class_private_field_set$R(this, _container$1, null);
    _class_private_field_set$R(this, _editor$1, null);
    _class_private_field_set$R(this, _editorStyle, null);
    _class_private_field_set$R(this, _hidden, true);
    _class_private_field_set$R(this, _resizeObserver$1, new EditorResizeObserver());
    _class_private_field_set$R(this, _rootDocument$1, rootDocument);
    _class_private_field_set$R(this, _rootPortalElement, rootPortalElement);
    _class_private_field_set$R(this, _isRtl$3, isRtl2);
    _class_private_field_set$R(this, _editor$1, this.createEditor());
    _class_private_field_set$R(this, _editorStyle, _class_private_field_get$R(this, _editor$1).style);
    _class_private_field_get$R(this, _resizeObserver$1).setObservedElement(this.getInputElement());
    _class_private_field_get$R(this, _resizeObserver$1).addLocalHook("resize", (...args) => {
      this.runLocalHooks("resize", ...args);
    });
    this.hide();
  }
}
mixin(CommentEditor, localHooks);
const DEFAULT_DISPLAY_DELAY = 250;
const DEFAULT_HIDE_DELAY = 250;
class DisplaySwitch {
  /**
  * Responsible for hiding comment after proper delay.
  */
  hide() {
    this.wasLastActionShow = false;
    this.hidingTimer = setTimeout(() => {
      if (this.wasLastActionShow === false) {
        this.runLocalHooks("hide");
      }
    }, DEFAULT_HIDE_DELAY);
  }
  /**
  * Responsible for showing comment after proper delay.
  *
  * @param {object} range Coordinates of selected cell.
  */
  show(range) {
    this.wasLastActionShow = true;
    this.showDebounced?.(range);
  }
  /**
  * Cancel hiding comment.
  */
  cancelHiding() {
    this.wasLastActionShow = true;
    clearTimeout(this.hidingTimer ?? void 0);
    this.hidingTimer = null;
  }
  /**
  * Update the switch settings.
  *
  * @param {number} displayDelay Delay of showing the comments (in milliseconds).
  */
  updateDelay(displayDelay = DEFAULT_DISPLAY_DELAY) {
    this.showDebounced = debounce((range) => {
      if (this.wasLastActionShow) {
        const r = range;
        this.runLocalHooks("show", r.from.row, r.from.col);
      }
    }, displayDelay);
  }
  /**
  * Destroy the switcher.
  */
  destroy() {
    this.clearLocalHooks();
  }
  /**
  * Initializes the display switch and configures the debounced show delay.
  */
  constructor(displayDelay) {
    this.wasLastActionShow = true;
    this.showDebounced = null;
    this.hidingTimer = null;
    this.updateDelay(displayDelay);
  }
}
mixin(DisplaySwitch, localHooks);
function getEditorAnchorWidth(metaColspan, TD, renderableColumnWidth) {
  if (metaColspan > 1) {
    return outerWidth(TD);
  }
  return renderableColumnWidth;
}
const VIEWPORT_MARGIN = 8;
function shrinkSizeToViewport(size, viewport, margin = VIEWPORT_MARGIN) {
  const { innerWidth: innerWidth2, innerHeight: innerHeight2, verticalScrollbarWidth = 0, horizontalScrollbarWidth = 0 } = viewport;
  const maxWidth = Math.max(0, innerWidth2 - verticalScrollbarWidth - 2 * margin);
  const maxHeight = Math.max(0, innerHeight2 - horizontalScrollbarWidth - 2 * margin);
  return {
    width: Math.min(size.width, maxWidth),
    height: Math.min(size.height, maxHeight)
  };
}
function clampPositionToViewport(rect, viewport, margin = VIEWPORT_MARGIN) {
  const { innerWidth: innerWidth2, innerHeight: innerHeight2, scrollX, scrollY, verticalScrollbarWidth = 0, horizontalScrollbarWidth = 0 } = viewport;
  const leftEdge = scrollX;
  const topEdge = scrollY;
  const rightEdge = scrollX + innerWidth2 - verticalScrollbarWidth;
  const bottomEdge = scrollY + innerHeight2 - horizontalScrollbarWidth;
  let { x, y } = rect;
  if (x < leftEdge) {
    x = leftEdge + margin;
  } else if (x + rect.width > rightEdge) {
    x = Math.max(leftEdge + margin, rightEdge - rect.width - margin);
  }
  if (y < topEdge) {
    y = topEdge + margin;
  } else if (y + rect.height > bottomEdge) {
    y = Math.max(topEdge + margin, bottomEdge - rect.height - margin);
  }
  return {
    x,
    y
  };
}
function prepareVerticalAlignClass(className, alignment) {
  if (className.indexOf(alignment) !== -1) {
    return className;
  }
  const replacedClassName = className.replace("htTop", "").replace("htMiddle", "").replace("htBottom", "").replace("  ", "");
  return `${replacedClassName} ${alignment}`;
}
function prepareHorizontalAlignClass(className, alignment) {
  if (className.indexOf(alignment) !== -1) {
    return className;
  }
  const replacedClassName = className.replace("htLeft", "").replace("htCenter", "").replace("htRight", "").replace("htJustify", "").replace("  ", "");
  return `${replacedClassName} ${alignment}`;
}
function getAlignmentClasses(ranges, callback) {
  const classes = {};
  arrayEach(ranges, (range) => {
    range.forAll((row, col) => {
      if (row >= 0 && col >= 0) {
        if (!classes[row]) {
          classes[row] = [];
        }
        classes[row][col] = callback(row, col);
      }
    });
  });
  return classes;
}
function align(ranges, type, alignment, cellDescriptor, propertySetter) {
  arrayEach(ranges, (range) => {
    range.forAll((row, col) => {
      if (row >= 0 && col >= 0) {
        applyAlignClassName(row, col, type, alignment, cellDescriptor, propertySetter);
      }
    });
  });
}
function applyAlignClassName(row, col, type, alignment, cellDescriptor, propertySetter) {
  const cellMeta = cellDescriptor(row, col);
  let className = alignment;
  if (cellMeta.className) {
    if (type === "vertical") {
      className = prepareVerticalAlignClass(cellMeta.className, alignment);
    } else {
      className = prepareHorizontalAlignClass(cellMeta.className, alignment);
    }
  }
  propertySetter(row, col, "className", className);
}
function markLabelAsSelected(label) {
  return `<span class="selected">${String.fromCharCode(10003)}</span>${label}`;
}
function checkSelectionConsistency(ranges, comparator) {
  let result = false;
  if (Array.isArray(ranges)) {
    arrayEach(ranges, (range) => {
      range.forAll((row, col) => {
        if (row >= 0 && col >= 0 && comparator(row, col)) {
          result = true;
          return false;
        }
      });
      return result;
    });
  }
  return result;
}
function getDocumentOffsetByElement(elementToCheck, baseDocument) {
  const offset2 = {
    top: 0,
    left: 0
  };
  if (baseDocument !== elementToCheck.ownerDocument) {
    const { frameElement } = baseDocument.defaultView;
    const { top: top2, left: left2 } = frameElement.getBoundingClientRect();
    offset2.top = top2;
    offset2.left = left2;
  }
  return offset2;
}
const KEY$c = "---------";
function separatorItem() {
  return {
    name: KEY$c
  };
}
const KEY$b = "alignment";
function alignmentItem() {
  return {
    key: KEY$b,
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT);
    },
    disabled() {
      if (this.countRows() === 0 || this.countCols() === 0) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      return !(this.getSelectedRange() && !this.selection.isSelectedByCorner());
    },
    submenu: {
      items: [
        {
          key: `${KEY$b}:left`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_LEFT);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "horizontal";
            const alignment = "htLeft";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        },
        {
          key: `${KEY$b}:center`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_CENTER);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "horizontal";
            const alignment = "htCenter";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        },
        {
          key: `${KEY$b}:right`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_RIGHT);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "horizontal";
            const alignment = "htRight";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        },
        {
          key: `${KEY$b}:justify`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_JUSTIFY);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "horizontal";
            const alignment = "htJustify";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        },
        {
          name: KEY$c
        },
        {
          key: `${KEY$b}:top`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_TOP);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "vertical";
            const alignment = "htTop";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        },
        {
          key: `${KEY$b}:middle`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_MIDDLE);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "vertical";
            const alignment = "htMiddle";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        },
        {
          key: `${KEY$b}:bottom`,
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ALIGNMENT_BOTTOM);
          },
          callback() {
            const selectedRange = this.getSelectedRange() ?? [];
            const stateBefore = getAlignmentClasses(selectedRange, (row, col) => this.getCellMeta(row, col).className);
            const type = "vertical";
            const alignment = "htBottom";
            this.runHooks("beforeCellAlignment", stateBefore, selectedRange, type, alignment);
            align(selectedRange, type, alignment, (row, col) => this.getCellMeta(row, col), (row, col, key, value) => this.setCellMeta(row, col, key, value));
            this.render();
          },
          disabled: false
        }
      ]
    }
  };
}
const KEY$a = "clear_column";
function clearColumnItem() {
  return {
    key: KEY$a,
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_CLEAR_COLUMN);
    },
    callback(key, selection) {
      const startColumn = selection[0].start.col;
      const endColumn = selection[0].end.col;
      if (this.countRows()) {
        this.populateFromArray(0, startColumn, [
          [
            null
          ]
        ], Math.max(selection[0].start.row, selection[0].end.row), endColumn, "ContextMenu.clearColumn");
      }
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range || range.isSingleHeader() && (range.highlight.col === null || range.highlight.col < 0) || !this.selection.isSelectedByColumnHeader()) {
        return true;
      }
      let atLeastOneNonReadOnly = false;
      range.forAll((row, col) => {
        if (row < 0 || col < 0) {
          return true;
        }
        const { readOnly } = this.getCellMeta(row, col);
        if (!readOnly) {
          atLeastOneNonReadOnly = true;
          return false;
        }
        return true;
      });
      return !atLeastOneNonReadOnly;
    }
  };
}
const KEY$9 = "col_left";
function columnLeftItem() {
  return {
    key: KEY$9,
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_INSERT_LEFT);
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return;
      }
      const activeSelection = range.getTopLeftCorner();
      const alterAction = this.isRtl() ? "insert_col_end" : "insert_col_start";
      if (activeSelection.col === null) {
        return;
      }
      this.alter(alterAction, activeSelection.col, 1, "ContextMenu.columnLeft");
    },
    disabled() {
      if (!this.isColumnModificationAllowed()) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range || this.selection.isSelectedByRowHeader() || range.isSingleHeader() && (range.highlight.col ?? 0) < 0 || this.countSourceCols() >= (this.getSettings().maxCols ?? Infinity)) {
        return true;
      }
      if (this.selection.isSelectedByCorner()) {
        return this.countCols() === 0;
      }
      return false;
    },
    hidden() {
      return !this.getSettings().allowInsertColumn;
    }
  };
}
const KEY$8 = "col_right";
function columnRightItem() {
  return {
    key: KEY$8,
    name() {
      const label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_INSERT_RIGHT);
      return label;
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return;
      }
      const activeSelection = range.getTopRightCorner();
      const alterAction = this.isRtl() ? "insert_col_start" : "insert_col_end";
      if (activeSelection.col === null) {
        return;
      }
      this.alter(alterAction, activeSelection.col, 1, "ContextMenu.columnRight");
    },
    disabled() {
      if (!this.isColumnModificationAllowed()) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range || this.selection.isSelectedByRowHeader() || range.isSingleHeader() && (range.highlight.col ?? 0) < 0 || this.countSourceCols() >= (this.getSettings().maxCols ?? Infinity)) {
        return true;
      }
      return false;
    },
    hidden() {
      return !this.getSettings().allowInsertColumn;
    }
  };
}
const KEY$7 = "make_read_only";
function readOnlyItem() {
  return {
    key: KEY$7,
    checkable: true,
    ariaChecked() {
      const atLeastOneReadOnly = checkSelectionConsistency(this.getSelectedRange() ?? [], (row, col) => Boolean(this.getCellMeta(row, col).readOnly));
      return atLeastOneReadOnly;
    },
    ariaLabel() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_READ_ONLY);
    },
    name() {
      let label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_READ_ONLY);
      const atLeastOneReadOnly = checkSelectionConsistency(this.getSelectedRange() ?? [], (row, col) => Boolean(this.getCellMeta(row, col).readOnly));
      if (atLeastOneReadOnly) {
        label = markLabelAsSelected(label);
      }
      return label;
    },
    callback() {
      const ranges = this.getSelectedRange() ?? [];
      const atLeastOneReadOnly = checkSelectionConsistency(ranges, (row, col) => Boolean(this.getCellMeta(row, col).readOnly));
      for (const range of ranges) {
        range.forAll((row, col) => {
          if (row >= 0 && col >= 0) {
            this.setCellMeta(row, col, "readOnly", !atLeastOneReadOnly);
          }
        });
      }
      this.render();
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      if (this.selection.isSelectedByCorner()) {
        return true;
      }
      if (this.countRows() === 0 || this.countCols() === 0) {
        return true;
      }
      if (!this.getSelectedRange()?.length) {
        return true;
      }
      return false;
    }
  };
}
const KEY$6 = "redo";
function redoItem() {
  return {
    key: KEY$6,
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_REDO);
    },
    callback() {
      this.getPlugin("undoRedo").redo();
    },
    hidden() {
      const undoRedoPlugin = this.getPlugin("undoRedo");
      return !undoRedoPlugin || !undoRedoPlugin.isEnabled();
    },
    disabled() {
      return !this.getPlugin("undoRedo").isRedoAvailable();
    }
  };
}
const KEY$5 = "remove_col";
function removeColumnItem() {
  return {
    key: KEY$5,
    name() {
      const selection = this.getSelected();
      let pluralForm = 0;
      if (selection) {
        if (selection.length > 1) {
          pluralForm = 1;
        } else {
          const [, fromColumn, , toColumn] = selection[0];
          if (fromColumn - toColumn !== 0) {
            pluralForm = 1;
          }
        }
      }
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_REMOVE_COLUMN, pluralForm);
    },
    callback() {
      this.alter("remove_col", transformSelectionToColumnDistance(this), void 0, "ContextMenu.removeColumn");
    },
    disabled() {
      if (!this.isColumnModificationAllowed()) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader() && range.highlight.col !== null && range.highlight.col < 0) {
        return true;
      }
      const totalColumns = this.countCols();
      if (this.selection.isSelectedByCorner()) {
        return totalColumns === 0;
      }
      return this.selection.isSelectedByRowHeader() || totalColumns === 0;
    },
    hidden() {
      return !this.getSettings().allowRemoveColumn;
    }
  };
}
const KEY$4 = "remove_row";
function removeRowItem() {
  return {
    key: KEY$4,
    name() {
      const selection = this.getSelected();
      let pluralForm = 0;
      if (selection) {
        if (selection.length > 1) {
          pluralForm = 1;
        } else {
          const [fromRow, , toRow] = selection[0];
          if (fromRow - toRow !== 0) {
            pluralForm = 1;
          }
        }
      }
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_REMOVE_ROW, pluralForm);
    },
    callback() {
      this.alter("remove_row", transformSelectionToRowDistance(this), 1, "ContextMenu.removeRow");
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader() && range.highlight.row !== null && range.highlight.row < 0) {
        return true;
      }
      const totalRows = this.countRows();
      if (this.selection.isSelectedByCorner()) {
        return totalRows === 0;
      }
      return this.selection.isSelectedByColumnHeader() || totalRows === 0;
    },
    hidden() {
      return !this.getSettings().allowRemoveRow;
    }
  };
}
const KEY$3 = "row_above";
function rowAboveItem() {
  return {
    key: KEY$3,
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ROW_ABOVE);
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return;
      }
      const activeSelection = range.getTopLeftCorner();
      if (activeSelection.row === null) {
        return;
      }
      this.alter("insert_row_above", activeSelection.row, 1, "ContextMenu.rowAbove");
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range || this.selection.isSelectedByColumnHeader() || range.isSingleHeader() && range.highlight.row !== null && range.highlight.row < 0 || this.countSourceRows() >= (this.getSettings().maxRows ?? Infinity)) {
        return true;
      }
      if (this.selection.isSelectedByCorner()) {
        return this.countRows() === 0;
      }
      return false;
    },
    hidden() {
      return !this.getSettings().allowInsertRow;
    }
  };
}
const KEY$2 = "row_below";
function rowBelowItem() {
  return {
    key: KEY$2,
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ROW_BELOW);
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return;
      }
      const activeSelection = range.getBottomRightCorner();
      if (activeSelection.row === null) {
        return;
      }
      this.alter("insert_row_below", activeSelection.row, 1, "ContextMenu.rowBelow");
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range || this.selection.isSelectedByColumnHeader() || range.isSingleHeader() && range.highlight.row !== null && range.highlight.row < 0 || this.countSourceRows() >= (this.getSettings().maxRows ?? Infinity)) {
        return true;
      }
      return false;
    },
    hidden() {
      return !this.getSettings().allowInsertRow;
    }
  };
}
const KEY$1 = "no_items";
function noItemsItem() {
  return {
    key: KEY$1,
    name() {
      const phrase = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_NO_ITEMS);
      return phrase;
    },
    disabled: true,
    isCommand: false
  };
}
const KEY = "undo";
function undoItem() {
  return {
    key: KEY,
    name() {
      const phrase = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_UNDO);
      return phrase;
    },
    callback() {
      this.getPlugin("undoRedo").undo();
    },
    hidden() {
      const undoRedoPlugin = this.getPlugin("undoRedo");
      return !undoRedoPlugin || !undoRedoPlugin.isEnabled();
    },
    disabled() {
      return !this.getPlugin("undoRedo").isUndoAvailable();
    }
  };
}
const ITEMS = [
  KEY$3,
  KEY$2,
  KEY$9,
  KEY$8,
  KEY$a,
  KEY$4,
  KEY$5,
  KEY,
  KEY$6,
  KEY$7,
  KEY$b,
  KEY$c,
  KEY$1
];
const _predefinedItems = {
  [KEY$c]: separatorItem,
  [KEY$1]: noItemsItem,
  [KEY$3]: rowAboveItem,
  [KEY$2]: rowBelowItem,
  [KEY$9]: columnLeftItem,
  [KEY$8]: columnRightItem,
  [KEY$a]: clearColumnItem,
  [KEY$4]: removeRowItem,
  [KEY$5]: removeColumnItem,
  [KEY]: undoItem,
  [KEY$6]: redoItem,
  [KEY$7]: readOnlyItem,
  [KEY$b]: alignmentItem
};
function predefinedItems() {
  const items = {};
  objectEach(_predefinedItems, (itemFactory, key) => {
    items[key] = itemFactory();
  });
  return items;
}
function addEditCommentItem(plugin) {
  return {
    key: "commentsAddEdit",
    name() {
      const highlight = this.getSelectedRangeActive()?.highlight;
      if (highlight?.isCell() && highlight.row !== null && highlight.col !== null && plugin.getCommentAtCell(highlight.row, highlight.col)) {
        return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_EDIT_COMMENT);
      }
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_ADD_COMMENT);
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (range) {
        plugin.setRange({
          from: range.from,
          to: range.to
        });
      }
      plugin.show();
      plugin.focusEditor();
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range || range.highlight.isHeader() || this.selection.isEntireRowSelected() && this.selection.isEntireColumnSelected() || this.countRenderedRows() === 0 || this.countRenderedCols() === 0) {
        return true;
      }
      return false;
    }
  };
}
function removeCommentItem(plugin) {
  return {
    key: "commentsRemove",
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_REMOVE_COMMENT);
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return;
      }
      range.forAll((row, column) => {
        if (row >= 0 && column >= 0) {
          plugin.removeCommentAtCell(row, column, false);
        }
      });
      this.render();
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range || range.highlight.isHeader() || this.selection.isEntireRowSelected() && this.selection.isEntireColumnSelected() || this.countRenderedRows() === 0 || this.countRenderedCols() === 0) {
        return true;
      }
      return false;
    }
  };
}
function readOnlyCommentItem(plugin) {
  return {
    key: "commentsReadOnly",
    name() {
      const label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_READ_ONLY_COMMENT);
      const areReadOnly = checkSelectionConsistency(this.getSelectedRange() ?? [], (row, col) => {
        return !!plugin.getCommentMeta(row, col, META_READONLY);
      });
      return areReadOnly ? markLabelAsSelected(label) : label;
    },
    callback() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return;
      }
      range.forAll((row, column) => {
        if (row >= 0 && column >= 0) {
          const currentState = !!plugin.getCommentMeta(row, column, META_READONLY);
          plugin.updateCommentMeta(row, column, {
            [META_READONLY]: !currentState
          });
        }
      });
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range || range.highlight.isHeader() || !plugin.getCommentAtCell(range.highlight.row, range.highlight.col) || this.selection.isEntireRowSelected() && this.selection.isEntireColumnSelected() || this.countRenderedRows() === 0 || this.countRenderedCols() === 0) {
        return true;
      }
      return false;
    }
  };
}
function _check_private_redeclaration$_(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$Q(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$Q(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$Q(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$Q(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$Q(receiver, privateMap, "get");
  return _class_apply_descriptor_get$Q(receiver, descriptor);
}
function _class_private_field_init$Q(obj, privateMap, value) {
  _check_private_redeclaration$_(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$Q(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$Q(receiver, privateMap, "set");
  _class_apply_descriptor_set$Q(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$G(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$G(obj, privateSet) {
  _check_private_redeclaration$_(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$v = "comments";
const PLUGIN_PRIORITY$v = 60;
const META_COMMENT = "comment";
const META_COMMENT_VALUE = "value";
const META_STYLE = "style";
const META_READONLY = "readOnly";
function isCommentMeta(value) {
  return value !== null && typeof value === "object";
}
const SHORTCUTS_GROUP$b = PLUGIN_KEY$v;
const SHORTCUTS_CONTEXT_NAME$4 = `plugin:${PLUGIN_KEY$v}`;
var _editor = /* @__PURE__ */ new WeakMap(), _displaySwitch = /* @__PURE__ */ new WeakMap(), _preventEditorAutoSwitch = /* @__PURE__ */ new WeakMap(), _preventEditorHiding = /* @__PURE__ */ new WeakMap(), _preventEditorSaveOnBlur = /* @__PURE__ */ new WeakMap(), _cellBelowCursor = /* @__PURE__ */ new WeakMap(), _commentValueBeforeSave = /* @__PURE__ */ new WeakMap(), _onMouseDown$2 = /* @__PURE__ */ new WeakMap(), _onInputElementMouseDown = /* @__PURE__ */ new WeakMap(), _onMouseOver$2 = /* @__PURE__ */ new WeakMap(), _onMouseUp$4 = /* @__PURE__ */ new WeakSet(), _onAfterRenderer = /* @__PURE__ */ new WeakSet(), _onEditorBlur = /* @__PURE__ */ new WeakSet(), _onEditorFocus = /* @__PURE__ */ new WeakSet(), _onEditorKeyDown = /* @__PURE__ */ new WeakMap(), _onEditorResize = /* @__PURE__ */ new WeakSet(), _onAfterDocumentKeyDown = /* @__PURE__ */ new WeakMap(), _onAfterScroll$1 = /* @__PURE__ */ new WeakMap(), _getRangeCoords = /* @__PURE__ */ new WeakSet();
class Comments extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$v;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$v;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      displayDelay: 250
    };
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link Comments#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$v];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    if (!_class_private_field_get$Q(this, _editor)) {
      _class_private_field_set$Q(this, _editor, new CommentEditor(this.hot.rootDocument, this.hot.isRtl(), this.hot.rootPortalElement));
      _class_private_field_get$Q(this, _editor)?.addLocalHook("resize", (width, height) => _class_private_method_get$G(this, _onEditorResize, onEditorResize).call(this, width, height));
      this.hot.addHook("afterSetTheme", (themeName, firstRun) => {
        if (!firstRun) {
          this.hide();
        }
      });
    }
    if (!_class_private_field_get$Q(this, _displaySwitch)) {
      _class_private_field_set$Q(this, _displaySwitch, new DisplaySwitch(this.getSetting("displayDelay")));
    }
    this.addHook("afterContextMenuDefaultOptions", (options) => this.addToContextMenu(options));
    this.addHook("afterRenderer", (TD, row, col, prop, value, cellProperties) => _class_private_method_get$G(this, _onAfterRenderer, onAfterRenderer).call(this, TD, cellProperties));
    this.addHook("afterScroll", _class_private_field_get$Q(this, _onAfterScroll$1));
    this.addHook("afterBeginEditing", () => this.hide());
    this.addHook("afterDocumentKeyDown", _class_private_field_get$Q(this, _onAfterDocumentKeyDown));
    this.addHook("beforeCompositionStart", _class_private_field_get$Q(this, _onAfterDocumentKeyDown));
    _class_private_field_get$Q(this, _displaySwitch)?.addLocalHook("hide", () => this.hide());
    _class_private_field_get$Q(this, _displaySwitch)?.addLocalHook("show", (row, col) => this.showAtCell(row, col));
    this.registerShortcuts();
    this.registerListeners();
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *   - [`comments`](@/api/options.md#comments)
  */
  updatePlugin() {
    _class_private_field_get$Q(this, _displaySwitch)?.updateDelay(this.getSetting("displayDelay"));
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.unregisterShortcuts();
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for toggling context menu.
  *
  * @private
  */
  registerShortcuts() {
    const manager = this.hot.getShortcutManager();
    const gridContext = manager.getContext("grid");
    const pluginContext = manager.addContext(SHORTCUTS_CONTEXT_NAME$4);
    gridContext?.addShortcut({
      keys: [
        [
          "Control",
          "Alt",
          "M"
        ]
      ],
      callback: () => {
        const range = this.hot.getSelectedRangeActive();
        _class_private_field_set$Q(this, _preventEditorHiding, true);
        this.hot.scrollToFocusedCell(() => {
          if (range) {
            this.setRange(range);
          }
          this.show();
          this.focusEditor();
          manager.setActiveContextName(SHORTCUTS_CONTEXT_NAME$4);
          this.hot._registerTimeout(() => {
            _class_private_field_set$Q(this, _preventEditorHiding, false);
          });
        });
      },
      stopPropagation: true,
      runOnlyIf: () => !!this.hot.getSelectedRangeActive()?.highlight.isCell(),
      group: SHORTCUTS_GROUP$b
    });
    pluginContext.addShortcut({
      keys: [
        [
          "Escape"
        ]
      ],
      callback: () => {
        _class_private_field_get$Q(this, _editor)?.setValue(_class_private_field_get$Q(this, _commentValueBeforeSave));
        this.hide();
        manager.setActiveContextName("grid");
      },
      runOnlyIf: () => !!(_class_private_field_get$Q(this, _editor)?.isVisible() && _class_private_field_get$Q(this, _editor)?.isFocused()),
      group: SHORTCUTS_GROUP$b
    });
    pluginContext.addShortcut({
      keys: [
        [
          "Control/Meta",
          "Enter"
        ]
      ],
      callback: () => {
        this.hide();
        manager.setActiveContextName("grid");
      },
      runOnlyIf: () => !!(_class_private_field_get$Q(this, _editor)?.isVisible() && _class_private_field_get$Q(this, _editor)?.isFocused()),
      group: SHORTCUTS_GROUP$b
    });
    pluginContext.addShortcut({
      keys: [
        [
          "Shift",
          "Tab"
        ],
        [
          "Tab"
        ]
      ],
      forwardToContext: manager.getContext("grid"),
      callback: () => {
        _class_private_field_set$Q(this, _preventEditorSaveOnBlur, true);
        _class_private_field_get$Q(this, _editor)?.setValue(_class_private_field_get$Q(this, _editor)?.getValue());
        this.setComment();
        this.hide();
        manager.setActiveContextName("grid");
      },
      group: SHORTCUTS_GROUP$b
    });
  }
  /**
  * Unregister shortcuts responsible for toggling context menu.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$b);
  }
  /**
  * Registers all necessary DOM listeners.
  *
  * @private
  */
  registerListeners() {
    const { rootDocument } = this.hot;
    const editorElement = this.getEditorInputElement();
    this.eventManager.addEventListener(rootDocument, "mouseover", _class_private_field_get$Q(this, _onMouseOver$2));
    this.eventManager.addEventListener(rootDocument, "mousedown", _class_private_field_get$Q(this, _onMouseDown$2));
    this.eventManager.addEventListener(rootDocument, "mouseup", () => _class_private_method_get$G(this, _onMouseUp$4, onMouseUp$4).call(this));
    if (editorElement) {
      this.eventManager.addEventListener(editorElement, "focus", () => _class_private_method_get$G(this, _onEditorFocus, onEditorFocus).call(this));
      this.eventManager.addEventListener(editorElement, "blur", () => _class_private_method_get$G(this, _onEditorBlur, onEditorBlur).call(this));
      this.eventManager.addEventListener(editorElement, "keydown", _class_private_field_get$Q(this, _onEditorKeyDown));
    }
    const inputElement = this.getEditorInputElement();
    if (inputElement) {
      this.eventManager.addEventListener(inputElement, "mousedown", _class_private_field_get$Q(this, _onInputElementMouseDown));
    }
  }
  /**
  * Sets the current cell range to be able to use general methods like {@link Comments#setComment}, {@link Comments#removeComment}, {@link Comments#show}.
  *
  * @param {object} range Object with `from` property, each with `row` and `col` properties.
  */
  setRange(range) {
    this.range = range;
  }
  /**
  * Clears the currently selected cell.
  */
  clearRange() {
    this.range = {};
  }
  /**
  * Checks if the event target is a cell containing a comment.
  *
  * @private
  * @param {Event} event DOM event.
  * @returns {boolean}
  */
  targetIsCellWithComment(event) {
    const closestCell = closest(eventTargetEl(event), [
      "TD"
    ]);
    return !!(closestCell && hasClass(closestCell, "htCommentCell") && closest(closestCell, [
      this.hot.rootElement
    ]));
  }
  /**
  * Checks if the event target is a comment textarea.
  *
  * @private
  * @param {Event} event DOM event.
  * @returns {boolean}
  */
  targetIsCommentTextArea(event) {
    return this.getEditorInputElement() === event.target;
  }
  /**
  * Sets a comment for a cell according to the previously set range (see {@link Comments#setRange}).
  *
  * @param {string} value Comment contents.
  */
  setComment(value) {
    if (!this.range.from) {
      throwWithCause('Before using this method, first set cell range (hot.getPlugin("comment").setRange())');
    }
    const editorValue = _class_private_field_get$Q(this, _editor)?.getValue();
    let comment = "";
    if (value !== null && value !== void 0) {
      comment = value;
    } else if (editorValue !== null && editorValue !== void 0) {
      comment = editorValue;
    }
    const { row, col } = _class_private_method_get$G(this, _getRangeCoords, getRangeCoords).call(this);
    this.updateCommentMeta(row, col, {
      [META_COMMENT_VALUE]: comment
    });
    this.hot.render();
  }
  /**
  * Sets a comment for a specified cell.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string} value Comment contents.
  */
  setCommentAtCell(row, column, value) {
    this.setRange({
      from: this.hot._createCellCoords(row, column)
    });
    this.setComment(value);
  }
  /**
  * Removes a comment from a cell according to previously set range (see {@link Comments#setRange}).
  *
  * @param {boolean} [forceRender=true] If set to `true`, the table will be re-rendered at the end of the operation.
  */
  removeComment(forceRender = true) {
    if (!this.range.from) {
      throwWithCause('Before using this method, first set cell range (hot.getPlugin("comment").setRange())');
    }
    const { row, col } = _class_private_method_get$G(this, _getRangeCoords, getRangeCoords).call(this);
    this.hot.setCellMeta(row, col, META_COMMENT, void 0);
    if (forceRender) {
      this.hot.render();
    }
    this.hide();
  }
  /**
  * Removes a comment from a specified cell.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {boolean} [forceRender=true] If `true`, the table will be re-rendered at the end of the operation.
  */
  removeCommentAtCell(row, column, forceRender = true) {
    this.setRange({
      from: this.hot._createCellCoords(row, column)
    });
    this.removeComment(forceRender);
  }
  /**
  * Gets comment from a cell according to previously set range (see {@link Comments#setRange}).
  *
  * @returns {string|undefined} Returns a content of the comment.
  */
  getComment() {
    const { row, col } = _class_private_method_get$G(this, _getRangeCoords, getRangeCoords).call(this);
    return this.getCommentMeta(row, col, META_COMMENT_VALUE);
  }
  /**
  * Gets comment from a cell at the provided coordinates.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @returns {string|undefined} Returns a content of the comment.
  */
  getCommentAtCell(row, column) {
    return this.getCommentMeta(row, column, META_COMMENT_VALUE);
  }
  /**
  * Shows the comment editor accordingly to the previously set range (see {@link Comments#setRange}).
  *
  * @returns {boolean} Returns `true` if comment editor was shown.
  */
  show() {
    if (!this.range.from) {
      throwWithCause('Before using this method, first set cell range (hot.getPlugin("comment").setRange())');
    }
    const { row, col } = _class_private_method_get$G(this, _getRangeCoords, getRangeCoords).call(this);
    if (row < 0 || row > this.hot.countRows() - 1 || col < 0 || col > this.hot.countCols() - 1) {
      return false;
    }
    const meta = this.hot.getCellMeta(row, col);
    _class_private_field_get$Q(this, _displaySwitch)?.cancelHiding();
    const commentMeta = meta[META_COMMENT];
    _class_private_field_get$Q(this, _editor)?.setValue((commentMeta ? commentMeta[META_COMMENT_VALUE] : null) ?? "");
    _class_private_field_get$Q(this, _editor)?.show();
    this.refreshEditor(true);
    return true;
  }
  /**
  * Shows comment editor according to cell coordinates.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @returns {boolean} Returns `true` if comment editor was shown.
  */
  showAtCell(row, column) {
    this.setRange({
      from: this.hot._createCellCoords(row, column)
    });
    return this.show();
  }
  /**
  * Hides the comment editor.
  */
  hide() {
    _class_private_field_get$Q(this, _editor)?.hide();
  }
  /**
  * Refreshes comment editor position and styling.
  *
  * @param {boolean} [force=false] If `true` then recalculation will be forced.
  */
  refreshEditor(force = false) {
    if (!force && (!this.range.from || !_class_private_field_get$Q(this, _editor)?.isVisible())) {
      return;
    }
    if (!_class_private_field_get$Q(this, _editor)) {
      return;
    }
    const { rowIndexMapper, columnIndexMapper } = this.hot;
    const { row: visualRow, col: visualColumn } = _class_private_method_get$G(this, _getRangeCoords, getRangeCoords).call(this);
    let renderableRow = rowIndexMapper.getRenderableFromVisualIndex(visualRow);
    let renderableColumn = columnIndexMapper.getRenderableFromVisualIndex(visualColumn);
    const targetingPreviousRow = renderableRow === null;
    _class_private_field_get$Q(this, _editor).setPosition(0, 0);
    if (renderableRow === null) {
      const nearestRow = rowIndexMapper.getNearestNotHiddenIndex(visualRow, -1);
      renderableRow = nearestRow !== null ? rowIndexMapper.getRenderableFromVisualIndex(nearestRow) : null;
    }
    if (renderableColumn === null) {
      const nearestCol = columnIndexMapper.getNearestNotHiddenIndex(visualColumn, -1);
      renderableColumn = nearestCol !== null ? columnIndexMapper.getRenderableFromVisualIndex(nearestCol) : null;
    }
    const isBeforeRenderedRows = renderableRow === null;
    const isBeforeRenderedColumns = renderableColumn === null;
    renderableRow = renderableRow ?? 0;
    renderableColumn = renderableColumn ?? 0;
    const { rootWindow, view: { _wt: wt } } = this.hot;
    const { wtTable } = wt;
    const TD = wt.getCell({
      row: renderableRow,
      col: renderableColumn
    }, true);
    const cellMeta = this.hot.getCellMeta(visualRow, visualColumn);
    const metaColspan = cellMeta.colspan ?? 1;
    const commentStyle = this.getCommentMeta(visualRow, visualColumn, META_STYLE);
    if (commentStyle) {
      _class_private_field_get$Q(this, _editor).setSize(commentStyle.width, commentStyle.height);
    } else {
      _class_private_field_get$Q(this, _editor).resetSize();
    }
    const lastColWidth = isBeforeRenderedColumns ? 0 : getEditorAnchorWidth(metaColspan, TD, wtTable.getColumnWidth(renderableColumn));
    const lastRowHeight = targetingPreviousRow && !isBeforeRenderedRows ? outerHeight(TD) : 0;
    const { left: left2, top: top2, width: cellWidth, height: cellHeight } = TD.getBoundingClientRect();
    const { width: editorWidth, height: editorHeight } = _class_private_field_get$Q(this, _editor).getSize();
    const { innerWidth: innerWidth2, innerHeight: innerHeight2 } = this.hot.rootWindow;
    const documentElement = this.hot.rootDocument.documentElement;
    const scrollbarWidth = getScrollbarWidth(this.hot.rootDocument);
    const verticalScrollbarWidth = hasVerticalScrollbar(this.hot.rootWindow) ? scrollbarWidth : 0;
    const horizontalScrollbarWidth = hasHorizontalScrollbar(this.hot.rootWindow) ? scrollbarWidth : 0;
    const mergedBorderCompensation = metaColspan > 1 ? 1 : 0;
    let x = left2 + rootWindow.scrollX + lastColWidth - mergedBorderCompensation;
    let y = top2 + rootWindow.scrollY + lastRowHeight;
    if (this.hot.isRtl()) {
      x -= editorWidth + lastColWidth;
    }
    if (this.hot.isLtr() && left2 + cellWidth + editorWidth > innerWidth2 - verticalScrollbarWidth) {
      x = left2 + rootWindow.scrollX - editorWidth - 1;
    } else if (this.hot.isRtl() && x < -(documentElement.scrollWidth - documentElement.clientWidth)) {
      x = left2 + rootWindow.scrollX + lastColWidth + 1;
    }
    if (top2 + editorHeight > innerHeight2 - horizontalScrollbarWidth) {
      y -= editorHeight - cellHeight + 1;
    }
    const shrunk = shrinkSizeToViewport({
      width: editorWidth,
      height: editorHeight
    }, {
      innerWidth: innerWidth2,
      innerHeight: innerHeight2,
      verticalScrollbarWidth,
      horizontalScrollbarWidth
    });
    if (shrunk.width !== editorWidth || shrunk.height !== editorHeight) {
      _class_private_field_get$Q(this, _editor).setSize(shrunk.width, shrunk.height);
    }
    const clamped = clampPositionToViewport({
      x,
      y,
      width: shrunk.width,
      height: shrunk.height
    }, {
      innerWidth: innerWidth2,
      innerHeight: innerHeight2,
      scrollX: rootWindow.scrollX,
      scrollY: rootWindow.scrollY,
      verticalScrollbarWidth,
      horizontalScrollbarWidth
    });
    _class_private_field_get$Q(this, _editor).setPosition(clamped.x, clamped.y);
    _class_private_field_get$Q(this, _editor).setReadOnlyState(this.getCommentMeta(visualRow, visualColumn, META_READONLY) ?? false);
    _class_private_field_get$Q(this, _editor).observeSize();
  }
  /**
  * Focuses the comments editor element.
  */
  focusEditor() {
    _class_private_field_get$Q(this, _editor)?.focus();
  }
  /**
  * Sets or update the comment-related cell meta.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {object} metaObject Object defining all the comment-related meta information.
  */
  updateCommentMeta(row, column, metaObject) {
    const oldComment = this.hot.getCellMeta(row, column)[META_COMMENT];
    let newComment;
    if (oldComment) {
      newComment = deepClone(oldComment);
      deepExtend(newComment, metaObject);
    } else {
      newComment = metaObject;
    }
    this.hot.setCellMeta(row, column, META_COMMENT, newComment);
  }
  /**
  * Returns the value of a specific meta property from the comment attached to the given cell.
  */
  getCommentMeta(row, column, property) {
    const cellMeta = this.hot.getCellMeta(row, column);
    const comment = cellMeta[META_COMMENT];
    if (!comment) {
      return void 0;
    }
    return comment[property];
  }
  /**
  * Add Comments plugin options to the Context Menu.
  *
  * @private
  * @param {object} options The menu options.
  */
  addToContextMenu(options) {
    options.items.push({
      name: KEY$c
    }, addEditCommentItem(this), removeCommentItem(this), readOnlyCommentItem(this));
  }
  /**
  * Gets the editors input element.
  *
  * @private
  * @returns {HTMLTextAreaElement}
  */
  getEditorInputElement() {
    return _class_private_field_get$Q(this, _editor)?.getInputElement() ?? null;
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$Q(this, _editor)?.destroy();
    _class_private_field_get$Q(this, _displaySwitch)?.destroy();
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$G(this, _onMouseUp$4), _class_private_method_init$G(this, _onAfterRenderer), _class_private_method_init$G(this, _onEditorBlur), _class_private_method_init$G(this, _onEditorFocus), _class_private_method_init$G(this, _onEditorResize), _class_private_method_init$G(this, _getRangeCoords), _class_private_field_init$Q(this, _editor, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _displaySwitch, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _preventEditorAutoSwitch, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _preventEditorHiding, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _preventEditorSaveOnBlur, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _cellBelowCursor, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _commentValueBeforeSave, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _onMouseDown$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _onInputElementMouseDown, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _onMouseOver$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _onEditorKeyDown, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _onAfterDocumentKeyDown, {
      writable: true,
      value: void 0
    }), _class_private_field_init$Q(this, _onAfterScroll$1, {
      writable: true,
      value: void 0
    }), /**
    * Current cell range, an object with `from` property, with `row` and `col` properties (e.q. `{from: {row: 1, col: 6}}`).
    *
    * @type {object}
    */
    this.range = {}, _class_private_field_set$Q(this, _editor, null), _class_private_field_set$Q(this, _displaySwitch, null), _class_private_field_set$Q(this, _preventEditorAutoSwitch, false), _class_private_field_set$Q(this, _preventEditorHiding, false), _class_private_field_set$Q(this, _preventEditorSaveOnBlur, false), _class_private_field_set$Q(this, _cellBelowCursor, null), _class_private_field_set$Q(this, _commentValueBeforeSave, ""), _class_private_field_set$Q(this, _onMouseDown$2, (event) => {
      if (!this.hot.view || !this.hot.view._wt) {
        return;
      }
      if (!_class_private_field_get$Q(this, _preventEditorAutoSwitch) && !this.targetIsCommentTextArea(event)) {
        const eventCell = closest(eventTargetEl(event), [
          "TD"
        ]);
        let coordinates = null;
        if (eventCell) {
          coordinates = this.hot.getCoords(eventCell);
        }
        if (!eventCell || this.range.from && coordinates && (this.range.from.row !== coordinates.row || this.range.from.col !== coordinates.col)) {
          this.hide();
        }
      }
    }), _class_private_field_set$Q(this, _onInputElementMouseDown, (event) => {
      event.stopPropagation();
    }), _class_private_field_set$Q(this, _onMouseOver$2, (event) => {
      const { rootDocument } = this.hot;
      const target = eventTargetEl(event);
      if (_class_private_field_get$Q(this, _preventEditorAutoSwitch) || _class_private_field_get$Q(this, _editor)?.isFocused() || hasClass(target, "wtBorder") || _class_private_field_get$Q(this, _cellBelowCursor) === target || !_class_private_field_get$Q(this, _editor)) {
        return;
      }
      _class_private_field_set$Q(this, _cellBelowCursor, rootDocument.elementFromPoint(event.clientX, event.clientY));
      if (this.targetIsCellWithComment(event)) {
        const coords = this.hot.getCoords(target);
        if (coords) {
          const range = this.hot._createCellRange(coords);
          _class_private_field_get$Q(this, _displaySwitch)?.show(range);
        }
      } else if (isChildOf(target, rootDocument) && !this.targetIsCommentTextArea(event)) {
        _class_private_field_get$Q(this, _displaySwitch)?.hide();
      }
    }), _class_private_field_set$Q(this, _onEditorKeyDown, (event) => {
      if (!_class_private_field_get$Q(this, _editor)?.isVisible()) {
        return;
      }
      if (!this.hot.getShortcutManager().hasEventShortcut(SHORTCUTS_CONTEXT_NAME$4, event)) {
        event.stopPropagation();
      }
    }), _class_private_field_set$Q(this, _onAfterDocumentKeyDown, (event) => {
      if (_class_private_field_get$Q(this, _editor)?.isFocused()) {
        stopImmediatePropagation(event);
      }
    }), _class_private_field_set$Q(this, _onAfterScroll$1, () => {
      if (!_class_private_field_get$Q(this, _preventEditorHiding)) {
        this.hide();
      }
    });
  }
}
function onMouseUp$4() {
  _class_private_field_set$Q(this, _preventEditorAutoSwitch, false);
}
function onAfterRenderer(TD, cellProperties) {
  const rawComment = cellProperties[META_COMMENT];
  if (isCommentMeta(rawComment) && rawComment[META_COMMENT_VALUE]) {
    const className = cellProperties.commentedCellClassName;
    if (typeof className === "string") {
      addClass(TD, className);
    }
  }
}
function onEditorBlur() {
  if (_class_private_field_get$Q(this, _preventEditorSaveOnBlur)) {
    _class_private_field_set$Q(this, _preventEditorSaveOnBlur, false);
    return;
  }
  _class_private_field_set$Q(this, _commentValueBeforeSave, "");
  this.hot.getShortcutManager().setActiveContextName("grid");
  this.setComment();
}
function onEditorFocus() {
  _class_private_field_set$Q(this, _commentValueBeforeSave, this.getComment() ?? "");
  this.hot.listen();
  this.hot.getShortcutManager().setActiveContextName(SHORTCUTS_CONTEXT_NAME$4);
}
function onEditorResize(width, height) {
  const { row, col } = _class_private_method_get$G(this, _getRangeCoords, getRangeCoords).call(this);
  this.updateCommentMeta(row, col, {
    [META_STYLE]: {
      width,
      height
    }
  });
}
function getRangeCoords() {
  if (this.range instanceof CellRange) {
    const { row, col } = this.range.highlight;
    return {
      row: row ?? 0,
      col: col ?? 0
    };
  }
  return {
    row: this.range.from.row ?? 0,
    col: this.range.from.col ?? 0
  };
}
class CommandExecutor {
  /**
  * Register command.
  *
  * @param {string} name Command name.
  * @param {object} commandDescriptor Command descriptor object with properties like `key` (command id),
  *                                   `callback` (task to execute), `name` (command name), `disabled` (command availability).
  */
  registerCommand(name, commandDescriptor) {
    this.commands[name] = commandDescriptor;
  }
  /**
  * Set common callback which will be trigger on every executed command.
  *
  * @param {Function} callback Function which will be fired on every command execute.
  */
  setCommonCallback(callback) {
    this.commonCallback = callback;
  }
  /**
  * Execute command by its name.
  *
  * @param {string} commandName Command id.
  * @param {*} params Arguments passed to command task.
  */
  execute(commandName, ...params) {
    const commandSplit = commandName.split(":");
    const commandNamePrimary = commandSplit[0];
    const subCommandName = commandSplit.length === 2 ? commandSplit[1] : null;
    let command2 = this.commands[commandNamePrimary];
    if (!command2) {
      throwWithCause(`Menu command '${commandNamePrimary}' not exists.`);
    }
    if (subCommandName && command2.submenu) {
      command2 = findSubCommand(subCommandName, command2.submenu.items);
    }
    if (command2.disabled === true) {
      return;
    }
    if (typeof command2.disabled === "function" && command2.disabled.call(this.hot) === true) {
      return;
    }
    if (hasOwnProperty(command2, "submenu")) {
      return;
    }
    const callbacks = [];
    if (typeof command2.callback === "function") {
      callbacks.push(command2.callback);
    }
    if (typeof this.commonCallback === "function") {
      callbacks.push(this.commonCallback);
    }
    params.unshift(commandSplit.join(":"));
    arrayEach(callbacks, (callback) => callback.apply(this.hot, params));
  }
  /**
  * Initializes the command executor with a reference to the Handsontable instance.
  */
  constructor(hotInstance) {
    this.commands = {};
    this.commonCallback = null;
    this.hot = hotInstance;
  }
}
function findSubCommand(subCommandName, subCommands) {
  let command2;
  arrayEach(subCommands, (cmd) => {
    const cmds = cmd.key ? cmd.key.split(":") : null;
    if (Array.isArray(cmds) && cmds[1] === subCommandName) {
      command2 = cmd;
      return false;
    }
  });
  return command2;
}
class ItemsFactory {
  /**
  * Set predefined items.
  *
  * @param {Array} predefinedItemsCollection Array of predefined items.
  */
  setPredefinedItems(predefinedItemsCollection) {
    const items = {};
    this.defaultOrderPattern.length = 0;
    objectEach(predefinedItemsCollection, (val, key) => {
      const value = val;
      let menuItemKey = "";
      if (value.name === KEY$c) {
        items[KEY$c] = value;
        menuItemKey = KEY$c;
      } else if (isNaN(parseInt(key, 10))) {
        value.key = value.key === void 0 ? key : value.key;
        items[key] = value;
        menuItemKey = String(value.key ?? "");
      } else {
        const itemKey = String(value.key ?? "");
        if (items[itemKey]) {
          extend(items[itemKey], value);
          return;
        }
        items[itemKey] = value;
        menuItemKey = itemKey;
      }
      this.defaultOrderPattern.push(menuItemKey);
    });
    this.predefinedItems = items;
  }
  /**
  * Get all menu items based on pattern.
  *
  * @param {Array|object|boolean} pattern Pattern which you can define by displaying menu items order. If `true` default
  *                                       pattern will be used.
  * @returns {Array}
  */
  getItems(pattern = null) {
    return getItems(pattern, this.defaultOrderPattern, this.predefinedItems);
  }
  /**
  * Initializes the items factory with a Handsontable instance and an optional default ordering pattern for menu items.
  */
  constructor(hotInstance, orderPattern = null) {
    this.predefinedItems = predefinedItems();
    this.hot = hotInstance;
    this.defaultOrderPattern = orderPattern || [];
  }
}
function getItems(itemsPattern = null, defaultPattern = [], items = {}) {
  const result = [];
  let pattern = itemsPattern;
  if (pattern && pattern.items) {
    pattern = pattern.items;
  } else if (!Array.isArray(pattern)) {
    pattern = defaultPattern;
  }
  if (isObject$1(pattern)) {
    objectEach(pattern, (value, key) => {
      let item = items[typeof value === "string" ? value : key];
      if (!item) {
        item = value;
      }
      if (isObject$1(value)) {
        extend(item, value);
      } else if (typeof item === "string") {
        item = {
          name: item
        };
      }
      if (item.key === void 0) {
        item.key = key;
      }
      result.push(item);
    });
  } else {
    arrayEach(pattern, (name, key) => {
      let item = items[name];
      if (!item && ITEMS.indexOf(name) >= 0) {
        return;
      }
      if (!item) {
        item = {
          name,
          key: `${key}`
        };
      }
      if (isObject$1(name)) {
        extend(item, name);
      }
      if (item.key === void 0) {
        item.key = key;
      }
      result.push(item);
    });
  }
  return result;
}
class Cursor {
  /**
  * Get source type name.
  *
  * @param {*} object Event or Object with coordinates.
  * @returns {string} Returns one of this values: `'literal'`, `'event'`.
  */
  getSourceType(object) {
    let type = "literal";
    if (object instanceof Event) {
      type = "event";
    }
    return type;
  }
  /**
  * Checks if element can be placed above the cursor.
  *
  * @param {HTMLElement} element Element to check if it's size will fit above the cursor.
  * @returns {boolean}
  */
  fitsAbove(element) {
    return this.topRelative >= element.offsetHeight;
  }
  /**
  * Checks if element can be placed below the cursor.
  *
  * @param {HTMLElement} element Element to check if it's size will fit below the cursor.
  * @param {number} [viewportHeight] The viewport height.
  * @returns {boolean}
  */
  fitsBelow(element, viewportHeight = this.rootWindow.innerHeight) {
    return this.topRelative + element.offsetHeight <= viewportHeight;
  }
  /**
  * Checks if element can be placed on the right of the cursor.
  *
  * @param {HTMLElement} element Element to check if it's size will fit on the right of the cursor.
  * @param {number} [viewportWidth] The viewport width.
  * @returns {boolean}
  */
  fitsOnRight(element, viewportWidth = this.rootWindow.document.documentElement.clientWidth) {
    return this.leftRelative + this.cellWidth + element.offsetWidth <= viewportWidth;
  }
  /**
  * Checks if element can be placed on the left on the cursor.
  *
  * @param {HTMLElement} element Element to check if it's size will fit on the left of the cursor.
  * @returns {boolean}
  */
  fitsOnLeft(element) {
    return this.leftRelative >= element.offsetWidth;
  }
  /**
  * Initializes the cursor position by computing coordinates from either a literal object or a DOM event.
  */
  constructor(object, rootWindow) {
    const windowScrollTop = rootWindow.scrollY;
    const windowScrollLeft = rootWindow.scrollX;
    let top2 = 0;
    let topRelative = 0;
    let left2 = 0;
    let leftRelative = 0;
    let cellHeight = 0;
    let cellWidth = 0;
    this.rootWindow = rootWindow;
    this.type = this.getSourceType(object);
    if (this.type === "literal") {
      const literal = object;
      top2 = parseInt(String(literal.top), 10);
      left2 = parseInt(String(literal.left), 10);
      cellHeight = literal.height || 0;
      cellWidth = literal.width || 0;
      topRelative = top2;
      leftRelative = left2;
      top2 += windowScrollTop;
      left2 += windowScrollLeft;
    } else if (this.type === "event") {
      const evt = object;
      top2 = parseInt(String(evt.pageY), 10);
      left2 = parseInt(String(evt.pageX), 10);
      cellHeight = eventTargetEl(evt).clientHeight;
      cellWidth = eventTargetEl(evt).clientWidth;
      topRelative = top2 - windowScrollTop;
      leftRelative = left2 - windowScrollLeft;
    }
    this.top = top2;
    this.topRelative = topRelative;
    this.left = left2;
    this.leftRelative = leftRelative;
    this.scrollTop = windowScrollTop;
    this.scrollLeft = windowScrollLeft;
    this.cellHeight = cellHeight;
    this.cellWidth = cellWidth;
  }
}
function _check_private_redeclaration$Z(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$P(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$P(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$P(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$P(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$P(receiver, privateMap, "get");
  return _class_apply_descriptor_get$P(receiver, descriptor);
}
function _class_private_field_init$P(obj, privateMap, value) {
  _check_private_redeclaration$Z(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$P(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$P(receiver, privateMap, "set");
  _class_apply_descriptor_set$P(receiver, descriptor, value);
  return value;
}
var _container = /* @__PURE__ */ new WeakMap(), _parentContainer = /* @__PURE__ */ new WeakMap(), _cursor = /* @__PURE__ */ new WeakMap(), _keepInViewport = /* @__PURE__ */ new WeakMap(), _offset = /* @__PURE__ */ new WeakMap();
class Positioner {
  /**
  * Sets offset position for specified directions (`above`, `below`, `left` or `right`).
  *
  * @param {'above' | 'below' | 'left' | 'right'} direction A direction name.
  * @param {number} [offset=0] Offset value.
  * @returns {Positioner}
  */
  setOffset(direction, offset2 = 0) {
    _class_private_field_get$P(this, _offset)[direction] = offset2;
    return this;
  }
  /**
  * Sets the menu element to work with. The element can be owned by the main menu or the submenu.
  *
  * @param {HTMLElement} container The menu container element.
  * @returns {Positioner}
  */
  setElement(container) {
    _class_private_field_set$P(this, _container, container);
    return this;
  }
  /**
  * Sets the parent menu element to work with.
  *
  * @param {HTMLElement} container The parent menu container element.
  * @returns {Positioner}
  */
  setParentElement(container) {
    _class_private_field_set$P(this, _parentContainer, container);
    return this;
  }
  /**
  * Updates the menu position.
  *
  * @param {object|MouseEvent} coords The literal object with `top`, `left`, `width` and `height` props or a
  * mouse event object.
  */
  updatePosition(coords) {
    _class_private_field_set$P(this, _cursor, new Cursor(coords, _class_private_field_get$P(this, _container).ownerDocument.defaultView));
    if (_class_private_field_get$P(this, _keepInViewport)) {
      if (_class_private_field_get$P(this, _cursor).fitsBelow(_class_private_field_get$P(this, _container))) {
        this.setPositionBelowCursor();
      } else if (_class_private_field_get$P(this, _cursor).fitsAbove(_class_private_field_get$P(this, _container))) {
        this.setPositionAboveCursor();
      } else {
        this.setPositionBelowCursor();
      }
      this.updateHorizontalPosition();
    } else {
      this.setPositionBelowCursor();
      this.setPositionOnRightOfCursor();
    }
  }
  /**
  * Updates the menu horizontal position.
  */
  updateHorizontalPosition() {
    if (_class_private_field_get$P(this, _container).dir === "rtl") {
      if (_class_private_field_get$P(this, _cursor).fitsOnLeft(_class_private_field_get$P(this, _container))) {
        this.setPositionOnLeftOfCursor();
      } else {
        this.setPositionOnRightOfCursor();
      }
    } else if (_class_private_field_get$P(this, _cursor).fitsOnRight(_class_private_field_get$P(this, _container))) {
      this.setPositionOnRightOfCursor();
    } else {
      this.setPositionOnLeftOfCursor();
    }
  }
  /**
  * Sets the menu position above the cursor object.
  */
  setPositionAboveCursor() {
    let top2 = _class_private_field_get$P(this, _offset).above + _class_private_field_get$P(this, _cursor).top - _class_private_field_get$P(this, _container).offsetHeight;
    if (_class_private_field_get$P(this, _parentContainer)) {
      const rootWindow = _class_private_field_get$P(this, _parentContainer).ownerDocument.defaultView;
      const style = rootWindow.getComputedStyle(_class_private_field_get$P(this, _parentContainer).querySelector(".ht_master"));
      const paddingTop = Number.parseInt(style.paddingTop, 10);
      const borderTop = Number.parseInt(style.borderTop, 10);
      top2 = _class_private_field_get$P(this, _cursor).top + _class_private_field_get$P(this, _cursor).cellHeight - _class_private_field_get$P(this, _container).scrollHeight + paddingTop + borderTop;
    }
    _class_private_field_get$P(this, _container).style.top = `${top2}px`;
  }
  /**
  * Sets the menu position below the cursor object.
  */
  setPositionBelowCursor() {
    let top2 = _class_private_field_get$P(this, _offset).below + _class_private_field_get$P(this, _cursor).top + 1;
    if (_class_private_field_get$P(this, _parentContainer)) {
      const rootWindow = _class_private_field_get$P(this, _parentContainer).ownerDocument.defaultView;
      const style = rootWindow.getComputedStyle(_class_private_field_get$P(this, _parentContainer).querySelector(".ht_master"));
      const paddingTop = Number.parseInt(style.paddingTop, 10);
      const borderTop = Number.parseInt(style.borderTop, 10);
      top2 = _class_private_field_get$P(this, _cursor).top - paddingTop - borderTop;
    }
    _class_private_field_get$P(this, _container).style.top = `${top2}px`;
  }
  /**
  * Sets the menu position on the right of the cursor object.
  */
  setPositionOnRightOfCursor() {
    let left2 = _class_private_field_get$P(this, _cursor).left;
    if (_class_private_field_get$P(this, _parentContainer)) {
      const rootWindow = _class_private_field_get$P(this, _parentContainer).ownerDocument.defaultView;
      const borderRightWidth = Number.parseInt(rootWindow.getComputedStyle(_class_private_field_get$P(this, _parentContainer).querySelector(".htCore")).borderRightWidth, 10);
      left2 += _class_private_field_get$P(this, _cursor).cellWidth + borderRightWidth;
    } else {
      left2 += _class_private_field_get$P(this, _offset).right;
    }
    _class_private_field_get$P(this, _container).style.left = `${left2}px`;
  }
  /**
  * Sets the menu position on the left of the cursor object.
  */
  setPositionOnLeftOfCursor() {
    let left2 = _class_private_field_get$P(this, _offset).left + _class_private_field_get$P(this, _cursor).left - _class_private_field_get$P(this, _container).offsetWidth;
    if (_class_private_field_get$P(this, _parentContainer)) {
      const rootWindow = _class_private_field_get$P(this, _parentContainer).ownerDocument.defaultView;
      const borderLeftWidth = Number.parseInt(rootWindow.getComputedStyle(_class_private_field_get$P(this, _parentContainer).querySelector(".htCore")).borderLeftWidth, 10);
      left2 -= borderLeftWidth;
    }
    _class_private_field_get$P(this, _container).style.left = `${left2}px`;
  }
  /**
  * Initializes the positioner with a flag indicating whether the menu should be kept within the viewport boundaries.
  */
  constructor(keepInViewport) {
    _class_private_field_init$P(this, _container, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$P(this, _parentContainer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$P(this, _cursor, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$P(this, _keepInViewport, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$P(this, _offset, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$P(this, _container, null);
    _class_private_field_set$P(this, _parentContainer, null);
    _class_private_field_set$P(this, _cursor, null);
    _class_private_field_set$P(this, _keepInViewport, false);
    _class_private_field_set$P(this, _offset, {
      above: 0,
      below: 0,
      left: 0,
      right: 0
    });
    _class_private_field_set$P(this, _keepInViewport, keepInViewport);
  }
}
function createPaginator({ initialPage = -1, size = () => 0, onItemSelect = () => {
}, onClear = () => {
} }) {
  const visitedPages = /* @__PURE__ */ new Set();
  let currentIndex = clamp(initialPage, -1, getSize() - 1);
  function _updateState(newIndex, direction) {
    const lastIndex = getSize() - 1;
    if (newIndex < 0) {
      newIndex = lastIndex;
    }
    if (newIndex > lastIndex) {
      newIndex = 0;
    }
    if (visitedPages.has(newIndex)) {
      return -1;
    }
    visitedPages.add(newIndex);
    const changeProceed = onItemSelect(newIndex, false);
    if (changeProceed === false) {
      newIndex = _updateState(direction === 1 ? ++newIndex : --newIndex, direction);
    }
    return newIndex;
  }
  function setCurrentPage2(index2) {
    if (index2 > -1 && index2 < getSize() && onItemSelect(index2, true) !== false) {
      currentIndex = index2;
    }
  }
  function setPageCursorAt(index2) {
    if (index2 > -1 && index2 < getSize()) {
      currentIndex = index2;
    }
  }
  function getCurrentPage() {
    return currentIndex;
  }
  function toFirstItem() {
    if (getSize() > 0) {
      visitedPages.clear();
      currentIndex = _updateState(0, 1);
    }
  }
  function toLastItem() {
    if (getSize() > 0) {
      visitedPages.clear();
      currentIndex = _updateState(getSize() - 1, -1);
    }
  }
  function toNextItem() {
    if (getSize() > 0) {
      visitedPages.clear();
      currentIndex = _updateState(++currentIndex, 1);
    }
  }
  function toPreviousItem() {
    if (getSize() > 0) {
      visitedPages.clear();
      currentIndex = _updateState(--currentIndex, -1);
    }
  }
  function getSize() {
    return Math.max(size(), 0);
  }
  function clear() {
    visitedPages.clear();
    currentIndex = initialPage;
    onClear();
  }
  return {
    setCurrentPage: setCurrentPage2,
    setPageCursorAt,
    getCurrentPage,
    toFirstItem,
    toLastItem,
    toNextItem,
    toPreviousItem,
    getSize,
    clear
  };
}
function normalizeSelection(selRanges) {
  return arrayMap(selRanges, (range) => ({
    start: range.getTopStartCorner(),
    end: range.getBottomEndCorner()
  }));
}
function isItemSubMenu(itemToTest) {
  return hasOwnProperty(itemToTest, "submenu");
}
function isItemSeparator(itemToTest) {
  return new RegExp(KEY$c, "i").test(itemToTest.name ?? "");
}
function isItemDisabled(itemToTest, hot) {
  return itemToTest.disabled === true || typeof itemToTest.disabled === "function" && itemToTest.disabled.call(hot) === true;
}
function isItemSelectionDisabled(itemToTest) {
  return hasOwnProperty(itemToTest, "disableSelection");
}
function isSeparator(cell) {
  return hasClass(cell, "htSeparator");
}
function hasSubMenu(cell) {
  return hasClass(cell, "htSubmenu");
}
function isDisabled(cell) {
  return hasClass(cell, "htDisabled");
}
function isSelectionDisabled(cell) {
  return hasClass(cell, "htSelectionDisabled");
}
function isItemHidden(item, instance) {
  return !item.hidden || !(typeof item.hidden === "function" && item.hidden.call(instance));
}
function shiftSeparators(items, separator) {
  const result = items.slice(0);
  for (let i = 0; i < result.length; ) {
    if (result[i].name === separator) {
      result.shift();
    } else {
      break;
    }
  }
  return result;
}
function popSeparators(items, separator) {
  let result = items.slice(0);
  result.reverse();
  result = shiftSeparators(result, separator);
  result.reverse();
  return result;
}
function removeDuplicatedSeparators(items) {
  const result = [];
  arrayEach(items, (value, index2) => {
    const item = value;
    if (index2 > 0) {
      if (result[result.length - 1].name !== item.name) {
        result.push(item);
      }
    } else {
      result.push(item);
    }
  });
  return result;
}
function filterSeparators(items, separator = KEY$c) {
  let result = items.slice(0);
  result = shiftSeparators(result, separator);
  result = popSeparators(result, separator);
  result = removeDuplicatedSeparators(result);
  return result;
}
function isItemCheckable(itemToTest) {
  return itemToTest.checkable === true;
}
function createMenuNavigator(hotMenu) {
  return createPaginator({
    size: () => hotMenu.countRows(),
    onItemSelect(currentItem, directItemChange) {
      const cell = hotMenu.getCell(currentItem, 0);
      if (!cell || isSeparator(cell) || isDisabled(cell) || isSelectionDisabled(cell)) {
        return false;
      }
      hotMenu.selectCell(currentItem, 0, ...directItemChange ? [
        currentItem,
        0,
        false,
        false
      ] : []);
    },
    onClear() {
      hotMenu.deselectCell();
    }
  });
}
function createDefaultShortcutsList(menu) {
  const hot = menu.hot;
  const hotMenu = menu.hotMenu;
  const gridContext = hot.getShortcutManager().getContext("grid");
  return [
    {
      keys: [
        [
          "Control/Meta",
          "A"
        ]
      ],
      ...gridContext ? {
        forwardToContext: gridContext
      } : {},
      callback: () => menu.close(true)
    },
    {
      keys: [
        [
          "Tab"
        ],
        [
          "Shift",
          "Tab"
        ]
      ],
      callback: (event, keys2) => {
        const settings = hot.getSettings();
        const tabMoves = typeof settings.tabMoves === "function" ? settings.tabMoves(event) : settings.tabMoves;
        if (tabMoves) {
          if (keys2?.includes("shift")) {
            hot.selection.transformStart(-tabMoves.row, -tabMoves.col);
          } else {
            hot.selection.transformStart(tabMoves.row, tabMoves.col);
          }
        }
        menu.close(true);
      }
    },
    {
      keys: [
        [
          "Escape"
        ]
      ],
      callback: () => menu.close()
    },
    {
      keys: [
        [
          "ArrowDown"
        ]
      ],
      callback: () => menu.getNavigator()?.toNextItem()
    },
    {
      keys: [
        [
          "ArrowUp"
        ]
      ],
      callback: () => menu.getNavigator()?.toPreviousItem()
    },
    {
      keys: [
        [
          hot.isRtl() ? "ArrowLeft" : "ArrowRight"
        ]
      ],
      callback: () => {
        const selection = hotMenu?.getSelectedActive();
        if (selection) {
          const subMenu = menu.openSubMenu(selection[0]);
          if (subMenu) {
            subMenu.getNavigator()?.toFirstItem();
          }
        }
      }
    },
    {
      keys: [
        [
          hot.isRtl() ? "ArrowRight" : "ArrowLeft"
        ]
      ],
      callback: () => {
        const selection = hotMenu?.getSelectedActive();
        if (selection && menu.isSubMenu()) {
          menu.close();
          if (menu.isSubMenu()) {
            menu.parentMenu?.hotMenu?.listen();
          }
        }
      }
    },
    {
      keys: [
        [
          "Control/Meta",
          "ArrowUp"
        ],
        [
          "Home"
        ]
      ],
      callback: () => menu.getNavigator()?.toFirstItem()
    },
    {
      keys: [
        [
          "Control/Meta",
          "ArrowDown"
        ],
        [
          "End"
        ]
      ],
      callback: () => menu.getNavigator()?.toLastItem()
    },
    {
      keys: [
        [
          "Enter"
        ],
        [
          "Space"
        ]
      ],
      callback: (event) => {
        const selection = hotMenu?.getSelectedActive();
        if (!selection) {
          return;
        }
        if (hotMenu?.getSourceDataAtRow(selection[0])?.submenu) {
          const subMenu = menu.openSubMenu(selection[0]);
          if (subMenu) {
            subMenu.getNavigator()?.toFirstItem();
          }
        } else {
          menu.executeCommand(event);
          menu.close(true);
        }
      }
    },
    {
      keys: [
        [
          "PageUp"
        ]
      ],
      callback: () => {
        const selection = hotMenu?.getSelectedActive();
        if (selection) {
          hotMenu?.selection.transformStart(-hotMenu.countVisibleRows(), 0);
        } else {
          menu.getNavigator()?.toFirstItem();
        }
      }
    },
    {
      keys: [
        [
          "PageDown"
        ]
      ],
      callback: () => {
        const selection = hotMenu?.getSelectedActive();
        if (selection) {
          hotMenu?.selection.transformStart(hotMenu.countVisibleRows(), 0);
        } else {
          menu.getNavigator()?.toLastItem();
        }
      }
    }
  ];
}
const SHORTCUTS_CONTEXT = "menu";
const SHORTCUTS_GROUP$a = SHORTCUTS_CONTEXT;
function createKeyboardShortcutsCtrl(menu, customKeyboardShortcuts = []) {
  const customShortcuts = [];
  _addShortcuts(createDefaultShortcutsList(menu));
  customKeyboardShortcuts.forEach(({ shortcuts, contextName }) => {
    addCustomShortcuts2(shortcuts, contextName);
  });
  function _addShortcuts(shortcuts, contextName) {
    getContext(contextName).addShortcuts(shortcuts, {
      group: SHORTCUTS_CONTEXT
    });
  }
  function addCustomShortcuts2(shortcuts, contextName) {
    const context = getContext(contextName);
    shortcuts.forEach(({ keys: keys2 }) => {
      keys2.forEach((k) => context.removeShortcutsByKeys(k));
    });
    customShortcuts.push({
      shortcuts,
      contextName: contextName ?? SHORTCUTS_CONTEXT
    });
    _addShortcuts(shortcuts, contextName);
  }
  function getCustomShortcuts() {
    return [
      ...customShortcuts
    ];
  }
  function _getContextName(contextName) {
    return contextName ? `${SHORTCUTS_GROUP$a}:${contextName}` : SHORTCUTS_GROUP$a;
  }
  function getContext(contextName) {
    const manager = menu.hotMenu.getShortcutManager();
    const name = _getContextName(contextName);
    return manager.getContext(name) ?? manager.addContext(name);
  }
  function listen(contextName) {
    menu.hotMenu.getShortcutManager().setActiveContextName(_getContextName(contextName));
  }
  return {
    addCustomShortcuts: addCustomShortcuts2,
    getCustomShortcuts,
    getContext,
    listen
  };
}
function createMenuItemRenderer(mainTableHot) {
  return (menuHot, TD, row, col, prop, value, cellProperties) => {
    const item = menuHot.getSourceDataAtRow(row);
    const wrapper = mainTableHot.rootDocument.createElement("div");
    const itemValue = typeof value === "function" ? value.call(mainTableHot) : value;
    const ariaLabel = typeof item.ariaLabel === "function" ? item.ariaLabel.call(mainTableHot) : item.ariaLabel;
    const ariaChecked = typeof item.ariaChecked === "function" ? item.ariaChecked.call(mainTableHot) : item.ariaChecked;
    cellProperties.readOnlyCellClassName = "";
    empty$1(TD);
    addClass(wrapper, "htItemWrapper");
    if (mainTableHot.getSettings().ariaTags) {
      const isFocusable = !isItemDisabled(item, mainTableHot) && !isItemSelectionDisabled(item) && !isItemSeparator(item);
      setAttribute(TD, [
        ...isItemCheckable(item) ? [
          A11Y_MENU_ITEM_CHECKBOX(),
          A11Y_LABEL(ariaLabel),
          A11Y_CHECKED(ariaChecked)
        ] : [
          A11Y_MENU_ITEM(),
          A11Y_LABEL(itemValue)
        ],
        ...isFocusable ? [
          A11Y_TABINDEX(-1)
        ] : [],
        ...isItemDisabled(item, mainTableHot) ? [
          A11Y_DISABLED()
        ] : [],
        ...isItemSubMenu(item) ? [
          A11Y_EXPANDED(false)
        ] : []
      ]);
    }
    TD.className = "";
    TD.appendChild(wrapper);
    if (isItemSeparator(item)) {
      addClass(TD, "htSeparator");
    } else if (typeof item.renderer === "function") {
      addClass(TD, "htCustomMenuRenderer");
      TD.appendChild(item.renderer(menuHot, wrapper, row, col, prop, itemValue));
    } else {
      const sanitizer = mainTableHot.getSettings().sanitizer;
      const itemStr = String(itemValue);
      fastInnerHTML(wrapper, itemStr, sanitizer, "contextMenu", mainTableHot.rootElement);
    }
    if (isItemDisabled(item, mainTableHot)) {
      addClass(TD, "htDisabled");
    } else if (isItemSelectionDisabled(item)) {
      addClass(TD, "htSelectionDisabled");
    } else if (isItemSubMenu(item)) {
      addClass(TD, "htSubmenu");
    }
  };
}
function _check_private_redeclaration$Y(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$O(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$O(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$O(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$O(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$O(receiver, privateMap, "get");
  return _class_apply_descriptor_get$O(receiver, descriptor);
}
function _class_private_field_init$O(obj, privateMap, value) {
  _check_private_redeclaration$Y(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$O(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$O(receiver, privateMap, "set");
  _class_apply_descriptor_set$O(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$F(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$F(obj, privateSet) {
  _check_private_redeclaration$Y(obj, privateSet);
  privateSet.add(obj);
}
const MIN_WIDTH = 215;
function hasName(value) {
  return typeof value === "object" && value !== null && "name" in value;
}
var _navigator = /* @__PURE__ */ new WeakMap(), _shortcutsCtrl = /* @__PURE__ */ new WeakMap(), _tableBorderWidth = /* @__PURE__ */ new WeakMap(), _getSourceDataAtRow = /* @__PURE__ */ new WeakSet();
class Menu {
  /**
  * Getter for the table border width.
  * This getter retrieves the border width of the table used in the menu.
  *
  * @returns {number} The border width of the table in pixels.
  */
  get tableBorderWidth() {
    if (_class_private_field_get$O(this, _tableBorderWidth) === void 0 && this.hotMenu) {
      _class_private_field_set$O(this, _tableBorderWidth, parseInt(this.hotMenu.rootWindow.getComputedStyle(this.hotMenu.view._wt.wtTable.TABLE).borderWidth, 10));
    }
    return _class_private_field_get$O(this, _tableBorderWidth);
  }
  /**
  * Register event listeners.
  *
  * @private
  */
  registerEvents() {
    let frame = this.hot.rootWindow;
    while (frame) {
      this.eventManager.addEventListener(frame.document, "mousedown", (event) => this.onDocumentMouseDown(event));
      this.eventManager.addEventListener(frame.document, "touchstart", (event) => this.onDocumentMouseDown(event));
      this.eventManager.addEventListener(frame.document, "contextmenu", (event) => this.onDocumentContextMenu(event));
      frame = getParentWindow(frame);
    }
  }
  /**
  * Set array of objects which defines menu items.
  *
  * @param {Array} menuItems Menu items to display.
  */
  setMenuItems(menuItems) {
    this.menuItems = menuItems;
  }
  /**
  * Gets the controller object that allows modifying the the menu item selection.
  *
  * @returns {Paginator | undefined}
  */
  getNavigator() {
    return _class_private_field_get$O(this, _navigator);
  }
  /**
  * Gets the controller object that allows extending the keyboard shortcuts of the menu.
  *
  * @returns {KeyboardShortcutsMenuController | undefined}
  */
  getKeyboardShortcutsCtrl() {
    return _class_private_field_get$O(this, _shortcutsCtrl);
  }
  /**
  * Returns currently selected menu item. Returns `null` if no item was selected.
  *
  * @returns {object|null}
  */
  getSelectedItem() {
    if (!this.hasSelectedItem()) {
      return null;
    }
    const rowIndex = this.hotMenu.getSelectedActive()[0];
    return _class_private_method_get$F(this, _getSourceDataAtRow, getSourceDataAtRow).call(this, rowIndex);
  }
  /**
  * Returns the position (row index) of the menu item identified by the provided `key` within the
  * currently rendered menu. Before rendering, `filterSeparators()` and the hidden-item filter run
  * over `menuItems`, so the rendered list can differ from the raw `menuItems` collection - callers
  * that need an index matching the rendered rows must use this method instead of reading
  * `menuItems` directly. Falls back to `menuItems` when the menu has not been rendered yet.
  *
  * @param {string} key The menu item key to look up.
  * @returns {number} The item row index, or `-1` when the item is not found.
  */
  getItemPositionByKey(key) {
    const items = this.hotMenu?.getSourceData() ?? this.menuItems ?? [];
    return items.findIndex((item) => item.key === key);
  }
  /**
  * Checks if the menu has selected (highlighted) any item from the menu list.
  *
  * @returns {boolean}
  */
  hasSelectedItem() {
    return Array.isArray(this.hotMenu.getSelectedActive());
  }
  /**
  * Check if menu is using as sub-menu.
  *
  * @returns {boolean}
  */
  isSubMenu() {
    return this.parentMenu !== null;
  }
  /**
  * Open menu.
  *
  * @fires Hooks#beforeContextMenuShow
  * @fires Hooks#afterContextMenuShow
  */
  open() {
    this.runLocalHooks("beforeOpen");
    this.container.removeAttribute("style");
    this.container.style.display = "block";
    const delayedOpenSubMenu = debounce((...args) => this.openSubMenu(args[0]), 300);
    const minWidthOfMenu = Number(this.options.minWidth) || MIN_WIDTH;
    let noItemsDefined = false;
    let filteredItems = arrayFilter(this.menuItems, (item) => {
      if (item.key === KEY$1) {
        noItemsDefined = true;
      }
      return isItemHidden(item, this.hot);
    });
    if (filteredItems.length < 1 && !noItemsDefined) {
      filteredItems.push(predefinedItems()[KEY$1]);
    } else if (filteredItems.length === 0) {
      return;
    }
    filteredItems = filterSeparators(filteredItems);
    let shouldAutoCloseMenu = false;
    const settings = {
      data: filteredItems,
      colHeaders: false,
      autoColumnSize: true,
      autoWrapRow: false,
      modifyColWidth(width) {
        if (isDefined(width) && width < minWidthOfMenu) {
          return minWidthOfMenu;
        }
        return width;
      },
      autoRowSize: false,
      readOnly: true,
      editor: false,
      copyPaste: false,
      hiddenRows: true,
      maxCols: 1,
      columns: [
        {
          data: "name",
          renderer: createMenuItemRenderer(this.hot)
        }
      ],
      renderAllRows: true,
      fragmentSelection: false,
      outsideClickDeselects: false,
      disableVisualSelection: "area",
      layoutDirection: this.hot.isRtl() ? "rtl" : "ltr",
      ariaTags: false,
      themeName: this.hot.getCurrentThemeName(),
      modifyRowHeight: (rowHeight, visualRowIndex) => {
        const item = _class_private_method_get$F(this, _getSourceDataAtRow, getSourceDataAtRow).call(this, visualRowIndex);
        return item && item.name === KEY$c ? 1 : rowHeight;
      },
      beforeRefreshDimensions: () => false,
      beforeOnCellMouseOver: (event, coords) => {
        _class_private_field_get$O(this, _navigator).setPageCursorAt(coords.row);
      },
      afterOnCellMouseOver: (event, coords) => {
        if (this.isAllSubMenusClosed()) {
          delayedOpenSubMenu(coords.row);
        } else {
          this.openSubMenu(coords.row);
        }
      },
      afterOnCellContextMenu: (event) => {
        event.preventDefault();
        if (isWindowsOS() && shouldAutoCloseMenu && this.hasSelectedItem()) {
          this.close(true);
        }
      },
      afterSelection: (row, column, row2, column2, preventScrolling) => {
        if (this.hotMenu.view.isMouseDown()) {
          preventScrolling.value = true;
        }
        this.runLocalHooks("afterSelectionChange", this.getSelectedItem());
      },
      beforeOnCellMouseUp: (event) => {
        if (this.hasSelectedItem()) {
          shouldAutoCloseMenu = !this.isCommandPassive(this.getSelectedItem());
          this.executeCommand(event);
        }
      },
      afterOnCellMouseUp: (event) => {
        if ((!isWindowsOS() || !isRightClick(event)) && shouldAutoCloseMenu && this.hasSelectedItem()) {
          if (isMobileBrowser() || isIpadOS()) {
            this.hot._registerTimeout(() => this.close(true), 325);
          } else {
            this.close(true);
          }
        }
      },
      afterUnlisten: () => {
        if (!this.hasSelectedItem() && this.isOpened()) {
          this.hotMenu.listen();
        }
      }
    };
    this.origOutsideClickDeselects = this.hot.getSettings().outsideClickDeselects;
    this.hot.getSettings().outsideClickDeselects = false;
    this.hotMenu = new this.hot.constructor(this.container, settings);
    this.hotMenu.addHook("afterInit", () => this.onAfterInit());
    this.hotMenu.init();
    _class_private_field_set$O(this, _navigator, createMenuNavigator(this.hotMenu));
    _class_private_field_set$O(this, _shortcutsCtrl, createKeyboardShortcutsCtrl(this));
    _class_private_field_get$O(this, _shortcutsCtrl).listen();
    this.focus();
    if (this.isSubMenu()) {
      this.addLocalHook("afterOpen", () => this.parentMenu.runLocalHooks("afterSubmenuOpen", this));
    }
    this.runLocalHooks("afterOpen", this);
  }
  /**
  * Close menu.
  *
  * @param {boolean} [closeParent=false] If `true` try to close parent menu if exists.
  */
  close(closeParent = false) {
    if (!this.isOpened()) {
      return;
    }
    if (closeParent && this.isSubMenu()) {
      this.parentMenu.close();
    } else {
      _class_private_field_get$O(this, _navigator).clear();
      this.closeAllSubMenus();
      this.container.style.display = "none";
      this.hotMenu.destroy();
      this.hotMenu = null;
      this.hot.getSettings().outsideClickDeselects = this.origOutsideClickDeselects;
      this.runLocalHooks("afterClose");
      if (this.isSubMenu()) {
        if (this.hot.getSettings().ariaTags) {
          const selection = this.parentMenu.hotMenu.getSelectedActive();
          if (selection) {
            const cell = this.parentMenu.hotMenu.getCell(selection[0], 0);
            if (cell) {
              setAttribute(cell, [
                A11Y_EXPANDED(false)
              ]);
            }
          }
        }
        this.parentMenu.hotMenu.listen();
      }
    }
  }
  /**
  * Open sub menu at the provided row index.
  *
  * @param {number} row Row index.
  * @returns {Menu|boolean} Returns created menu or `false` if no one menu was created.
  */
  openSubMenu(row) {
    if (!this.hotMenu) {
      return false;
    }
    const cell = this.hotMenu.getCell(row, 0);
    this.closeAllSubMenus();
    if (!cell || !hasSubMenu(cell)) {
      return false;
    }
    const dataItem = _class_private_method_get$F(this, _getSourceDataAtRow, getSourceDataAtRow).call(this, row);
    const subMenu = new Menu(this.hot, {
      parent: this,
      name: typeof dataItem.name === "function" ? dataItem.name.call(this.hot) : dataItem.name,
      className: this.options.className,
      keepInViewport: true,
      container: this.options.container
    });
    subMenu.setMenuItems(dataItem.submenu.items);
    subMenu.open();
    subMenu.setPosition(cell.getBoundingClientRect());
    this.hotSubMenus[dataItem.key] = subMenu;
    if (this.hot.getSettings().ariaTags) {
      setAttribute(cell, [
        A11Y_EXPANDED(true)
      ]);
    }
    return subMenu;
  }
  /**
  * Close sub menu at row index.
  *
  * @param {number} row Row index.
  */
  closeSubMenu(row) {
    const dataItem = _class_private_method_get$F(this, _getSourceDataAtRow, getSourceDataAtRow).call(this, row);
    const menus = this.hotSubMenus[dataItem.key];
    if (menus) {
      menus.destroy();
      delete this.hotSubMenus[dataItem.key];
      const cell = this.hotMenu.getCell(row, 0);
      if (cell && this.hot.getSettings().ariaTags) {
        setAttribute(cell, [
          A11Y_EXPANDED(false)
        ]);
      }
    }
  }
  /**
  * Close all opened sub menus.
  */
  closeAllSubMenus() {
    arrayEach(this.hotMenu.getData(), (value, row) => this.closeSubMenu(row));
  }
  /**
  * Checks if all created and opened sub menus are closed.
  *
  * @returns {boolean}
  */
  isAllSubMenusClosed() {
    return Object.keys(this.hotSubMenus).length === 0;
  }
  /**
  * Focus the menu so all keyboard shortcuts become active.
  */
  focus() {
    if (this.isOpened()) {
      this.hotMenu.rootElement.focus({
        preventScroll: true
      });
      this.getKeyboardShortcutsCtrl().listen();
      this.hotMenu.listen();
    }
  }
  /**
  * Destroy instance.
  */
  destroy() {
    const menuContainerParentElement = this.container.parentNode;
    this.clearLocalHooks();
    this.close();
    this.parentMenu = null;
    this.eventManager.destroy();
    if (menuContainerParentElement) {
      menuContainerParentElement.removeChild(this.container);
    }
  }
  /**
  * Checks if menu was opened.
  *
  * @returns {boolean} Returns `true` if menu was opened.
  */
  isOpened() {
    return this.hotMenu !== null;
  }
  /**
  * Execute menu command.
  *
  * The `executeCommand()` method works only for selected cells.
  *
  * When no cells are selected, `executeCommand()` doesn't do anything.
  *
  * @param {Event} [event] The mouse event object.
  */
  executeCommand(event) {
    if (!this.isOpened() || !this.hasSelectedItem()) {
      return;
    }
    const selectedItem = this.getSelectedItem();
    this.runLocalHooks("select", selectedItem, event);
    if (this.isCommandPassive(selectedItem)) {
      return;
    }
    const selRanges = this.hot.getSelectedRange();
    const normalizedSelection = selRanges ? normalizeSelection(selRanges) : [];
    this.runLocalHooks("executeCommand", selectedItem.key, normalizedSelection, event);
    if (this.isSubMenu()) {
      this.parentMenu.runLocalHooks("executeCommand", selectedItem.key, normalizedSelection, event);
    }
  }
  /**
  * Checks if the passed command is passive or not. The command is passive when it's marked as
  * disabled, the descriptor object contains `isCommand` property set to `false`, command
  * is a separator, or the item is recognized as submenu. For passive items the menu is not
  * closed automatically after the user trigger the command through the UI.
  *
  * @param {object} commandDescriptor Selected menu item from the menu data source.
  * @returns {boolean}
  */
  isCommandPassive(commandDescriptor) {
    return commandDescriptor.isCommand === false || isItemSeparator(commandDescriptor) || isItemDisabled(commandDescriptor, this.hot) || isItemSubMenu(commandDescriptor);
  }
  /**
  * Set offset menu position for specified area (`above`, `below`, `left` or `right`).
  *
  * @param {string} area Specified area name (`above`, `below`, `left` or `right`).
  * @param {number} offset Offset value.
  */
  setOffset(area, offset2 = 0) {
    this.positioner.setOffset(area, offset2);
  }
  /**
  * Set menu position based on dom event or based on literal object.
  *
  * @param {Event|object} coords Event or literal Object with coordinates.
  */
  setPosition(coords) {
    if (this.isSubMenu()) {
      this.positioner.setParentElement(this.parentMenu.container);
    }
    this.positioner.setElement(this.container).updatePosition(coords);
  }
  /**
  * Updates the dimensions of the menu based on its content.
  * This method calculates the real height of the menu by summing up the heights of its items,
  * and adjusts the width and height of the menu's holder and hider elements accordingly.
  */
  updateMenuDimensions() {
    const { wtTable } = this.hotMenu.view._wt;
    const data = this.hotMenu.getSettings().data;
    const hiderStyle = wtTable.hider.style;
    const holderStyle = wtTable.holder.style;
    const currentHiderWidth = parseInt(hiderStyle.width, 10);
    const realHeight = arrayReduce(data ?? [], (accumulator, value, index2) => {
      const itemCell = this.hotMenu.getCell(index2, 0);
      const currentRowHeight = itemCell ? outerHeight(itemCell) : 0;
      const isSeparator2 = hasName(value) && value.name === KEY$c;
      return accumulator + (isSeparator2 ? 1 : currentRowHeight);
    }, 0);
    holderStyle.width = `${currentHiderWidth}px`;
    holderStyle.height = `${realHeight}px`;
    hiderStyle.height = holderStyle.height;
  }
  /**
  * Create container/wrapper for handsontable.
  *
  * @private
  * @param {string} [name] Class name.
  * @returns {HTMLElement}
  */
  createContainer(name = null) {
    const menuContainer = this.options.container;
    const doc = menuContainer.ownerDocument;
    let className = name;
    let container = null;
    if (className) {
      className = className.replace(/[^A-Za-z0-9]/g, "_");
      className = `${this.options.className}Sub_${className}`;
      container = doc.querySelector(`.${this.options.className}.${className}`);
    }
    if (!container) {
      container = doc.createElement("div");
      addClass(container, `htMenu handsontable ${this.options.className}`);
      if (className) {
        addClass(container, className);
      }
      menuContainer.appendChild(container);
    }
    return container;
  }
  /**
  * On after init listener.
  *
  * @private
  */
  onAfterInit() {
    this.updateMenuDimensions();
    if (this.hot.getSettings().ariaTags) {
      setAttribute(this.hotMenu.rootElement, [
        A11Y_MENU(),
        A11Y_TABINDEX(-1)
      ]);
    }
  }
  /**
  * Document mouse down listener.
  *
  * @private
  * @param {Event} event The mouse event object.
  */
  onDocumentMouseDown(event) {
    if (!this.isOpened()) {
      return;
    }
    if (this.options.standalone && this.hotMenu && !isChildOf(eventTargetEl(event), this.hotMenu.rootElement)) {
      this.close(true);
    } else if ((this.isAllSubMenusClosed() || this.isSubMenu()) && !isChildOf(eventTargetEl(event), ".htMenu")) {
      this.close(true);
    }
  }
  /**
  * Document's contextmenu listener.
  *
  * @private
  * @param {MouseEvent} event The mouse event object.
  */
  onDocumentContextMenu(event) {
    if (!this.isOpened()) {
      return;
    }
    if (hasClass(eventTargetEl(event), "htCore") && isChildOf(eventTargetEl(event), this.hotMenu.rootElement)) {
      event.preventDefault();
    }
  }
  /**
  * @param {Core} hotInstance Handsontable instance.
  * @param {MenuOptions} [options] Menu options.
  */
  constructor(hotInstance, options) {
    _class_private_method_init$F(this, _getSourceDataAtRow);
    _class_private_field_init$O(this, _navigator, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$O(this, _shortcutsCtrl, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$O(this, _tableBorderWidth, {
      writable: true,
      value: void 0
    });
    this.hotMenu = null;
    this.hotSubMenus = {};
    this.menuItems = null;
    this.origOutsideClickDeselects = void 0;
    _class_private_field_set$O(this, _navigator, null);
    _class_private_field_set$O(this, _shortcutsCtrl, null);
    this.hot = hotInstance;
    this.options = {
      parent: null,
      name: null,
      className: "",
      keepInViewport: true,
      standalone: false,
      minWidth: MIN_WIDTH,
      container: this.hot.rootPortalElement,
      ...options
    };
    this.container = this.createContainer(this.options.name);
    this.positioner = new Positioner(this.options.keepInViewport);
    this.parentMenu = this.options.parent || null;
    this.eventManager = new EventManager(this);
    this.registerEvents();
    if (this.isSubMenu()) {
      this.addLocalHook("afterSelectionChange", (...args) => this.parentMenu.runLocalHooks("afterSelectionChange", ...args));
    }
    this.hot.addHook("afterSetTheme", (themeName, firstRun) => {
      if (this.options.container !== this.hot.rootPortalElement) {
        const menuContainer = this.options.container;
        removeClass(menuContainer, /ht-theme-.*/g);
        addClass(menuContainer, themeName);
      }
      if (!firstRun) {
        this.close();
      }
    });
  }
}
function getSourceDataAtRow(row) {
  const data = this.hotMenu?.getSourceDataAtRow(row);
  return data ? data : null;
}
mixin(Menu, localHooks);
function _check_private_redeclaration$X(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$N(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$N(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$N(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$N(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$N(receiver, privateMap, "get");
  return _class_apply_descriptor_get$N(receiver, descriptor);
}
function _class_private_field_init$N(obj, privateMap, value) {
  _check_private_redeclaration$X(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$N(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$N(receiver, privateMap, "set");
  _class_apply_descriptor_set$N(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$u = "contextMenu";
const PLUGIN_PRIORITY$u = 70;
const SHORTCUTS_GROUP$9 = PLUGIN_KEY$u;
Hooks.getSingleton().register("afterContextMenuDefaultOptions");
Hooks.getSingleton().register("beforeContextMenuShow");
Hooks.getSingleton().register("afterContextMenuShow");
Hooks.getSingleton().register("afterContextMenuHide");
Hooks.getSingleton().register("afterContextMenuExecute");
var _onAfterOnCellContextMenu = /* @__PURE__ */ new WeakMap(), _onMenuAfterOpen$1 = /* @__PURE__ */ new WeakMap(), _onMenuAfterClose$1 = /* @__PURE__ */ new WeakMap();
class ContextMenu extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$u;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$u;
  }
  /**
  * Returns the list of plugin dependencies required before this plugin can be initialized.
  */
  static get PLUGIN_DEPS() {
    return [
      "plugin:AutoColumnSize"
    ];
  }
  /**
  * Context menu default items order when `contextMenu` options is set as `true`.
  *
  * @returns {string[]}
  */
  static get DEFAULT_ITEMS() {
    return [
      KEY$3,
      KEY$2,
      KEY$c,
      KEY$9,
      KEY$8,
      KEY$c,
      KEY$4,
      KEY$5,
      KEY$c,
      KEY,
      KEY$6,
      KEY$c,
      KEY$7,
      KEY$c,
      KEY$b
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ContextMenu#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$u];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const settings = this.hot.getSettings()[PLUGIN_KEY$u];
    const settingsObj = typeof settings === "object" && settings !== null && !Array.isArray(settings) ? settings : null;
    if (settingsObj && typeof settingsObj.callback === "function") {
      this.commandExecutor.setCommonCallback(settingsObj.callback);
    }
    this.menu = new Menu(this.hot, {
      className: "htContextMenu",
      keepInViewport: true,
      container: settingsObj?.uiContainer || this.hot.rootPortalElement
    });
    this.menu.addLocalHook("afterOpen", _class_private_field_get$N(this, _onMenuAfterOpen$1));
    this.menu.addLocalHook("afterClose", _class_private_field_get$N(this, _onMenuAfterClose$1));
    this.menu.addLocalHook("executeCommand", (...params) => {
      this.executeCommand.call(this, ...params);
    });
    this.addHook("afterOnCellContextMenu", _class_private_field_get$N(this, _onAfterOnCellContextMenu));
    this.addHook("beforeDialogShow", () => this.close());
    this.registerShortcuts();
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`contextMenu`](@/api/options.md#contextmenu)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.close();
    if (this.menu) {
      this.menu.destroy();
      this.menu = null;
    }
    this.unregisterShortcuts();
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for toggling context menu.
  *
  * @private
  */
  registerShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.addShortcut({
      keys: [
        [
          "Control/Meta",
          "Shift",
          "Backslash"
        ],
        [
          "Shift",
          "F10"
        ]
      ],
      callback: () => {
        const activeRange = this.hot.getSelectedRangeActive();
        if (!activeRange) {
          return;
        }
        const { highlight } = activeRange;
        if (highlight.row === null || highlight.col === null) {
          return;
        }
        this.hot.scrollToFocusedCell();
        const cell = this.hot.getCell(highlight.row, highlight.col, true);
        if (!cell) {
          return;
        }
        const rect = cell.getBoundingClientRect();
        const offset2 = getDocumentOffsetByElement(this.menu.container, this.hot.rootDocument);
        this.open({
          left: rect.left + offset2.left,
          top: rect.top + offset2.top - 1 + rect.height
        }, {
          left: rect.width,
          above: -rect.height
        });
        this.menu.getNavigator().toFirstItem();
      },
      runOnlyIf: () => {
        const highlight = this.hot.getSelectedRangeActive()?.highlight;
        return !!highlight && this.hot.selection.isCellVisible(highlight) && !this.menu.isOpened();
      },
      group: SHORTCUTS_GROUP$9
    });
  }
  /**
  * Unregister shortcuts responsible for toggling context menu.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$9);
  }
  /**
  * Opens the menu and positions it based on the passed coordinates.
  *
  * @param {{ top: number, left: number }|Event} position An object with `top` and `left` properties
  * (coordinates relative to the browser viewport, without scroll offsets), or a native browser
  * `Event` instance (e.g., a `MouseEvent`).
  * @param {{ above: number, below: number, left: number, right: number }} offset An object that applies
  * an offset to the menu position.
  * @fires Hooks#beforeContextMenuShow
  * @fires Hooks#afterContextMenuShow
  * @example
  * ```js
  * const menu = hot.getPlugin('contextMenu');
  *
  * hot.selectCell(0, 0);
  * menu.open({ top: 50, left: 50 });
  * ```
  */
  open(position, offset2 = {
    above: 0,
    below: 0,
    left: 0,
    right: 0
  }) {
    if (this.menu?.isOpened()) {
      return;
    }
    this.hot.runHooks("beforeContextMenuShow", this);
    this.prepareMenuItems();
    this.menu.open();
    objectEach(offset2, (value, key) => {
      this.menu.setOffset(key, value);
    });
    this.menu.setPosition(position);
  }
  /**
  * Closes the menu.
  */
  close() {
    this.menu?.close();
    this.itemsFactory = null;
  }
  /**
  * Execute context menu command.
  *
  * The `executeCommand()` method works only for selected cells.
  *
  * When no cells are selected, `executeCommand()` doesn't do anything.
  *
  * You can execute all predefined commands:
  *  * `'row_above'` - Insert row above
  *  * `'row_below'` - Insert row below
  *  * `'col_left'` - Insert column left
  *  * `'col_right'` - Insert column right
  *  * `'clear_column'` - Clear selected column
  *  * `'remove_row'` - Remove row
  *  * `'remove_col'` - Remove column
  *  * `'undo'` - Undo last action
  *  * `'redo'` - Redo last action
  *  * `'make_read_only'` - Make cell read only
  *  * `'alignment:left'` - Alignment to the left
  *  * `'alignment:top'` - Alignment to the top
  *  * `'alignment:right'` - Alignment to the right
  *  * `'alignment:bottom'` - Alignment to the bottom
  *  * `'alignment:middle'` - Alignment to the middle
  *  * `'alignment:center'` - Alignment to the center (justify).
  *
  * Or you can execute command registered in settings where `key` is your command name.
  *
  * @param {string} commandName The command name to be executed.
  * @param {*} params Additional parameters passed to command executor module.
  */
  executeCommand(commandName, ...params) {
    if (this.itemsFactory === null) {
      this.prepareMenuItems();
    }
    this.commandExecutor.execute(commandName, ...params);
  }
  /**
  * Prepares available contextMenu's items list and registers them in commandExecutor.
  *
  * @private
  * @fires Hooks#afterContextMenuDefaultOptions
  * @fires Hooks#beforeContextMenuSetItems
  */
  prepareMenuItems() {
    this.itemsFactory = new ItemsFactory(this.hot, ContextMenu.DEFAULT_ITEMS);
    const settings = this.hot.getSettings()[PLUGIN_KEY$u];
    const predefinedItems2 = {
      items: this.itemsFactory.getItems(settings)
    };
    this.hot.runHooks("afterContextMenuDefaultOptions", predefinedItems2);
    this.itemsFactory.setPredefinedItems(predefinedItems2.items);
    const menuItems = this.itemsFactory.getItems(settings);
    this.hot.runHooks("beforeContextMenuSetItems", menuItems);
    this.menu.setMenuItems(menuItems);
    arrayEach(menuItems, (command2) => {
      this.commandExecutor.registerCommand(String(command2.key ?? ""), command2);
    });
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    this.close();
    if (this.menu) {
      this.menu.destroy();
    }
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$N(this, _onAfterOnCellContextMenu, {
      writable: true,
      value: void 0
    }), _class_private_field_init$N(this, _onMenuAfterOpen$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$N(this, _onMenuAfterClose$1, {
      writable: true,
      value: void 0
    }), /**
    * Instance of {@link CommandExecutor}.
    *
    * @private
    * @type {CommandExecutor}
    */
    this.commandExecutor = new CommandExecutor(this.hot), /**
    * Instance of {@link ItemsFactory}.
    *
    * @private
    * @type {ItemsFactory}
    */
    this.itemsFactory = null, /**
    * Instance of {@link Menu}.
    *
    * @private
    * @type {Menu}
    */
    this.menu = null, _class_private_field_set$N(this, _onAfterOnCellContextMenu, (event) => {
      const settings = this.hot.getSettings();
      const showRowHeaders = settings.rowHeaders;
      const showColHeaders = settings.colHeaders;
      function isValidElement(element2) {
        const parent = element2.parentNode;
        return element2.nodeName === "TD" || isHTMLElement(parent) && parent.nodeName === "TD";
      }
      const element = eventTargetEl(event);
      this.close();
      if (hasClass(element, "handsontableInput")) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (!(showRowHeaders || showColHeaders)) {
        if (!isValidElement(element) && !(hasClass(element, "current") && hasClass(element, "wtBorder"))) {
          return;
        }
      }
      const offset2 = getDocumentOffsetByElement(this.menu.container, this.hot.rootDocument);
      this.open({
        top: event.clientY + offset2.top,
        left: event.clientX + offset2.left
      });
    }), _class_private_field_set$N(this, _onMenuAfterOpen$1, () => {
      this.hot.runHooks("afterContextMenuShow", this);
    }), _class_private_field_set$N(this, _onMenuAfterClose$1, () => {
      this.hot.listen();
      this.hot.runHooks("afterContextMenuHide", this);
    });
  }
}
ContextMenu.SEPARATOR = {
  name: KEY$c
};
function copyItem(copyPastePlugin) {
  return {
    key: "copy",
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_COPY);
    },
    callback() {
      copyPastePlugin.copyCellsOnly();
    },
    disabled() {
      if (this.countRows() === 0 || this.countCols() === 0) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      const selected = this.getSelected();
      if (!selected || selected.length > 1) {
        return true;
      }
      return false;
    },
    hidden: false
  };
}
function copyColumnHeadersOnlyItem(copyPastePlugin) {
  return {
    key: "copy_column_headers_only",
    name() {
      const activeSelectedRange = this.getSelectedRangeActive();
      const nounForm = activeSelectedRange ? clamp(activeSelectedRange.getWidth() - 1, 0, 1) : 0;
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_COPY_COLUMN_HEADERS_ONLY, nounForm);
    },
    callback() {
      copyPastePlugin.copyColumnHeadersOnly();
    },
    disabled() {
      if (!this.hasColHeaders()) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      const selected = this.getSelected();
      if (!selected || selected.length > 1) {
        return true;
      }
      return false;
    },
    hidden: false
  };
}
function copyWithColumnGroupHeadersItem(copyPastePlugin) {
  return {
    key: "copy_with_column_group_headers",
    name() {
      const activeSelectedRange = this.getSelectedRangeActive();
      const nounForm = activeSelectedRange ? clamp(activeSelectedRange.getWidth() - 1, 0, 1) : 0;
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_GROUP_HEADERS, nounForm);
    },
    callback() {
      copyPastePlugin.copyWithAllColumnHeaders();
    },
    disabled() {
      if (!this.hasColHeaders() || !this.getSettings().nestedHeaders) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      const selected = this.getSelected();
      if (!selected || selected.length > 1) {
        return true;
      }
      return false;
    },
    hidden: false
  };
}
function copyWithColumnHeadersItem(copyPastePlugin) {
  return {
    key: "copy_with_column_headers",
    name() {
      const activeSelectedRange = this.getSelectedRangeActive();
      const nounForm = activeSelectedRange ? clamp(activeSelectedRange.getWidth() - 1, 0, 1) : 0;
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_HEADERS, nounForm);
    },
    callback() {
      copyPastePlugin.copyWithColumnHeaders();
    },
    disabled() {
      if (!this.hasColHeaders()) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      const selected = this.getSelected();
      if (!selected || selected.length > 1) {
        return true;
      }
      return false;
    },
    hidden: false
  };
}
function cutItem(copyPastePlugin) {
  return {
    key: "cut",
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_CUT);
    },
    callback() {
      copyPastePlugin.cut();
    },
    disabled() {
      if (this.countRows() === 0 || this.countCols() === 0) {
        return true;
      }
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      const selected = this.getSelected();
      if (!selected || selected.length > 1) {
        return true;
      }
      return false;
    },
    hidden: false
  };
}
class ClipboardData {
  /**
  * Stores a value in the clipboard data under the given MIME type key.
  */
  setData(type, value) {
    this.data[type] = value;
  }
  /**
  * Returns the clipboard data stored under the given MIME type key, or `undefined` if absent.
  */
  getData(type) {
    return this.data[type] || void 0;
  }
  /**
  * Initializes the clipboard data store as an empty object.
  */
  constructor() {
    this.data = {};
  }
}
class PasteEvent {
  /**
  * No-op implementation of `preventDefault` to satisfy the event interface contract.
  */
  preventDefault() {
  }
  /**
  * Returns an empty array as a stub for the composed path of this synthetic event.
  */
  composedPath() {
    return [];
  }
  /**
  * Initializes the paste event with an empty `ClipboardData` instance.
  */
  constructor() {
    this.clipboardData = new ClipboardData();
  }
}
function _check_private_redeclaration$W(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$M(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$M(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$M(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$M(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$M(receiver, privateMap, "get");
  return _class_apply_descriptor_get$M(receiver, descriptor);
}
function _class_private_field_init$M(obj, privateMap, value) {
  _check_private_redeclaration$W(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$M(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$M(receiver, privateMap, "set");
  _class_apply_descriptor_set$M(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$E(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$E(obj, privateSet) {
  _check_private_redeclaration$W(obj, privateSet);
  privateSet.add(obj);
}
var _selectedRange = /* @__PURE__ */ new WeakMap(), _countRows = /* @__PURE__ */ new WeakMap(), _countColumns = /* @__PURE__ */ new WeakMap(), _rowsLimit = /* @__PURE__ */ new WeakMap(), _columnsLimit$1 = /* @__PURE__ */ new WeakMap(), _countColumnHeaders = /* @__PURE__ */ new WeakMap(), _trimColumnsRange = /* @__PURE__ */ new WeakSet(), _trimRowsRange = /* @__PURE__ */ new WeakSet();
class CopyableRangesFactory {
  /**
  * Sets the selection range to be processed.
  *
  * @param {CellRange} selectedRange The selection range represented by the CellRange class.
  */
  setSelectedRange(selectedRange) {
    _class_private_field_set$M(this, _selectedRange, selectedRange);
  }
  /**
  * Returns a new coords object within the dataset range (cells) with `startRow`, `startCol`, `endRow`
  * and `endCol` keys.
  *
  * @returns {{startRow: number, startCol: number, endRow: number, endCol: number} | null}
  */
  getCellsRange() {
    if (_class_private_field_get$M(this, _countRows).call(this) === 0 || _class_private_field_get$M(this, _countColumns).call(this) === 0) {
      return null;
    }
    const { row: startRow, col: startCol } = _class_private_field_get$M(this, _selectedRange).getTopStartCorner();
    const { row: endRow, col: endCol } = _class_private_field_get$M(this, _selectedRange).getBottomEndCorner();
    if (startRow === null || startCol === null || endRow === null || endCol === null) {
      return null;
    }
    const finalEndRow = _class_private_method_get$E(this, _trimRowsRange, trimRowsRange).call(this, startRow, endRow);
    const finalEndCol = _class_private_method_get$E(this, _trimColumnsRange, trimColumnsRange).call(this, startCol, endCol);
    const isRangeTrimmed = endRow !== finalEndRow || endCol !== finalEndCol;
    return {
      isRangeTrimmed,
      startRow,
      startCol,
      endRow: finalEndRow,
      endCol: finalEndCol
    };
  }
  /**
  * Returns a new coords object within the most-bottom column headers range with `startRow`,
  * `startCol`, `endRow` and `endCol` keys.
  *
  * @returns {{startRow: number, startCol: number, endRow: number, endCol: number} | null}
  */
  getMostBottomColumnHeadersRange() {
    if (_class_private_field_get$M(this, _countColumns).call(this) === 0 || _class_private_field_get$M(this, _countColumnHeaders).call(this) === 0) {
      return null;
    }
    const { col: startCol } = _class_private_field_get$M(this, _selectedRange).getTopStartCorner();
    const { col: endCol } = _class_private_field_get$M(this, _selectedRange).getBottomEndCorner();
    if (startCol === null || endCol === null) {
      return null;
    }
    const finalEndCol = _class_private_method_get$E(this, _trimColumnsRange, trimColumnsRange).call(this, startCol, endCol);
    const isRangeTrimmed = endCol !== finalEndCol;
    return {
      isRangeTrimmed,
      startRow: -1,
      startCol,
      endRow: -1,
      endCol: finalEndCol
    };
  }
  /**
  * Returns a new coords object within all column headers layers (including nested headers) range with
  * `startRow`, `startCol`, `endRow` and `endCol` keys.
  *
  * @returns {{startRow: number, startCol: number, endRow: number, endCol: number} | null}
  */
  getAllColumnHeadersRange() {
    if (_class_private_field_get$M(this, _countColumns).call(this) === 0 || _class_private_field_get$M(this, _countColumnHeaders).call(this) === 0) {
      return null;
    }
    const { col: startCol } = _class_private_field_get$M(this, _selectedRange).getTopStartCorner();
    const { col: endCol } = _class_private_field_get$M(this, _selectedRange).getBottomEndCorner();
    if (startCol === null || endCol === null) {
      return null;
    }
    const finalEndCol = _class_private_method_get$E(this, _trimColumnsRange, trimColumnsRange).call(this, startCol, endCol);
    const isRangeTrimmed = endCol !== finalEndCol;
    return {
      isRangeTrimmed,
      startRow: -_class_private_field_get$M(this, _countColumnHeaders).call(this),
      startCol,
      endRow: -1,
      endCol: finalEndCol
    };
  }
  /**
  * @param {{
  *   countRows: function(): number,
  *   countColumns: function(): number,
  *   rowsLimit: function(): number,
  *   columnsLimit: function(): number,
  *   countColumnHeaders: function(): number
  * }} dependencies The utils class dependencies.
  */
  constructor({ countRows, countColumns, rowsLimit, columnsLimit, countColumnHeaders }) {
    _class_private_method_init$E(this, _trimColumnsRange);
    _class_private_method_init$E(this, _trimRowsRange);
    _class_private_field_init$M(this, _selectedRange, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$M(this, _countRows, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$M(this, _countColumns, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$M(this, _rowsLimit, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$M(this, _columnsLimit$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$M(this, _countColumnHeaders, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$M(this, _countRows, countRows);
    _class_private_field_set$M(this, _countColumns, countColumns);
    _class_private_field_set$M(this, _rowsLimit, rowsLimit);
    _class_private_field_set$M(this, _columnsLimit$1, columnsLimit);
    _class_private_field_set$M(this, _countColumnHeaders, countColumnHeaders);
  }
}
function trimColumnsRange(startColumn, endColumn) {
  return Math.min(endColumn, Math.max(startColumn + _class_private_field_get$M(this, _columnsLimit$1).call(this) - 1, startColumn));
}
function trimRowsRange(startRow, endRow) {
  return Math.min(endRow, Math.max(startRow + _class_private_field_get$M(this, _rowsLimit).call(this) - 1, startRow));
}
function normalizeRanges(ranges) {
  const rows = [];
  const columns = [];
  arrayEach(ranges, (range) => {
    const r = range;
    const minRow = Math.min(r.startRow, r.endRow);
    const maxRow = Math.max(r.startRow, r.endRow);
    rangeEach(minRow, maxRow, (row) => {
      if (rows.indexOf(row) === -1) {
        rows.push(row);
      }
    });
    const minColumn = Math.min(r.startCol, r.endCol);
    const maxColumn = Math.max(r.startCol, r.endCol);
    rangeEach(minColumn, maxColumn, (column) => {
      if (columns.indexOf(column) === -1) {
        columns.push(column);
      }
    });
  });
  return {
    rows,
    columns
  };
}
function _check_private_redeclaration$V(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$L(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$L(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$L(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$L(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$L(receiver, privateMap, "get");
  return _class_apply_descriptor_get$L(receiver, descriptor);
}
function _class_private_field_init$L(obj, privateMap, value) {
  _check_private_redeclaration$V(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$L(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$L(receiver, privateMap, "set");
  _class_apply_descriptor_set$L(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$D(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$D(obj, privateSet) {
  _check_private_redeclaration$V(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("afterCopyLimit");
Hooks.getSingleton().register("modifyCopyableRange");
Hooks.getSingleton().register("beforeCut");
Hooks.getSingleton().register("afterCut");
Hooks.getSingleton().register("beforePaste");
Hooks.getSingleton().register("afterPaste");
Hooks.getSingleton().register("beforeCopy");
Hooks.getSingleton().register("afterCopy");
const PLUGIN_KEY$t = "copyPaste";
const PLUGIN_PRIORITY$t = 80;
const SETTING_KEYS$1 = [
  "fragmentSelection"
];
const SOURCE_DATA_HTML_MIME_TYPE = "application/ht-source-data-json-html";
const META_HEAD = [
  '<meta name="generator" content="Handsontable"/>',
  '<style type="text/css">td{white-space:normal}br{mso-data-placement:same-cell}</style>'
].join("");
var _enableCopyColumnHeaders = /* @__PURE__ */ new WeakMap(), _enableCopyColumnGroupHeaders = /* @__PURE__ */ new WeakMap(), _enableCopyColumnHeadersOnly = /* @__PURE__ */ new WeakMap(), _copyMode = /* @__PURE__ */ new WeakMap(), _isTriggeredByCopy = /* @__PURE__ */ new WeakMap(), _isTriggeredByCut = /* @__PURE__ */ new WeakMap(), _copyableRangesFactory = /* @__PURE__ */ new WeakMap(), _preventViewportScrollOnPaste = /* @__PURE__ */ new WeakMap(), _ensureClipboardEventsGetTriggered = /* @__PURE__ */ new WeakSet(), _countCopiedHeaders = /* @__PURE__ */ new WeakSet(), _addContentEditableToHighlightedCell = /* @__PURE__ */ new WeakSet(), _removeContentEditableFromHighlightedCell = /* @__PURE__ */ new WeakSet(), _readClipboardData = /* @__PURE__ */ new WeakSet(), _setClipboardData = /* @__PURE__ */ new WeakSet(), _onAfterContextMenuDefaultOptions$5 = /* @__PURE__ */ new WeakMap(), _onAfterSelection$1 = /* @__PURE__ */ new WeakMap(), _onAfterSelectionEnd$1 = /* @__PURE__ */ new WeakMap(), _onSafariMouseEnter = /* @__PURE__ */ new WeakMap(), _onSafariMouseLeave = /* @__PURE__ */ new WeakMap(), _onSafariAfterSelection = /* @__PURE__ */ new WeakMap();
class CopyPaste extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$t;
  }
  /**
  * Returns the setting keys that trigger a plugin update when changed via `updateSettings`.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$t,
      ...SETTING_KEYS$1
    ];
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$t;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      pasteMode: "overwrite",
      rowsLimit: Infinity,
      columnsLimit: Infinity,
      copyColumnHeaders: false,
      copyColumnGroupHeaders: false,
      copyColumnHeadersOnly: false
    };
  }
  /**
  * Checks if the [`CopyPaste`](#copypaste) plugin is enabled.
  *
  * This method gets called by Handsontable's [`beforeInit`](@/api/hooks.md#beforeinit) hook.
  * If it returns `true`, the [`enablePlugin()`](#enableplugin) method gets called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$t];
  }
  /**
  * Enables the [`CopyPaste`](#copypaste) plugin for your Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.pasteMode = this.getSetting("pasteMode") ?? this.pasteMode;
    this.rowsLimit = isNaN(this.getSetting("rowsLimit")) ? this.rowsLimit : this.getSetting("rowsLimit");
    this.columnsLimit = isNaN(this.getSetting("columnsLimit")) ? this.columnsLimit : this.getSetting("columnsLimit");
    _class_private_field_set$L(this, _enableCopyColumnHeaders, this.getSetting("copyColumnHeaders"));
    _class_private_field_set$L(this, _enableCopyColumnGroupHeaders, this.getSetting("copyColumnGroupHeaders"));
    _class_private_field_set$L(this, _enableCopyColumnHeadersOnly, this.getSetting("copyColumnHeadersOnly"));
    this.uiContainer = this.getSetting("uiContainer") ?? this.uiContainer;
    this.addHook("afterContextMenuDefaultOptions", _class_private_field_get$L(this, _onAfterContextMenuDefaultOptions$5));
    this.addHook("afterSelection", _class_private_field_get$L(this, _onAfterSelection$1));
    this.addHook("afterSelectionEnd", _class_private_field_get$L(this, _onAfterSelectionEnd$1));
    this.eventManager.addEventListener(this.hot.rootDocument, "copy", (e) => this.onCopy(e));
    this.eventManager.addEventListener(this.hot.rootDocument, "cut", (e) => this.onCut(e));
    this.eventManager.addEventListener(this.hot.rootDocument, "paste", (e) => this.onPaste(e));
    if (isSafari()) {
      this.eventManager.addEventListener(this.hot.rootDocument.body, "mouseenter", _class_private_field_get$L(this, _onSafariMouseEnter));
      this.eventManager.addEventListener(this.hot.rootDocument.body, "mouseleave", _class_private_field_get$L(this, _onSafariMouseLeave));
      this.addHook("afterSelection", _class_private_field_get$L(this, _onSafariAfterSelection));
    }
    super.enablePlugin();
  }
  /**
  * Updates the state of the [`CopyPaste`](#copypaste) plugin.
  *
  * Gets called when [`updateSettings()`](@/api/core.md#updatesettings)
  * is invoked with any of the following configuration options:
  *  - [`copyPaste`](@/api/options.md#copypaste)
  *  - [`fragmentSelection`](@/api/options.md#fragmentselection)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the [`CopyPaste`](#copypaste) plugin for your Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
  }
  /**
  * Copies the contents of the selected cells (and/or their related column headers) to the system clipboard.
  *
  * Takes an optional parameter (`copyMode`) that defines the scope of copying:
  *
  * | `copyMode` value              | Description                                                     |
  * | ----------------------------- | --------------------------------------------------------------- |
  * | `'cells-only'` (default)      | Copy the selected cells                                         |
  * | `'with-column-headers'`       | - Copy the selected cells<br>- Copy the nearest column headers  |
  * | `'with-column-group-headers'` | - Copy the selected cells<br>- Copy all related columns headers |
  * | `'column-headers-only'`       | Copy the nearest column headers (without copying cells)         |
  *
  * @param {string} [copyMode='cells-only'] Copy mode.
  */
  copy(copyMode = "cells-only") {
    _class_private_field_set$L(this, _copyMode, copyMode);
    _class_private_field_set$L(this, _isTriggeredByCopy, true);
    _class_private_method_get$D(this, _ensureClipboardEventsGetTriggered, ensureClipboardEventsGetTriggered).call(this, "copy");
  }
  /**
  * Copies the contents of the selected cells.
  */
  copyCellsOnly() {
    this.copy("cells-only");
  }
  /**
  * Copies the contents of column headers that are nearest to the selected cells.
  */
  copyColumnHeadersOnly() {
    this.copy("column-headers-only");
  }
  /**
  * Copies the contents of the selected cells and all their related column headers.
  */
  copyWithAllColumnHeaders() {
    this.copy("with-column-group-headers");
  }
  /**
  * Copies the contents of the selected cells and their nearest column headers.
  */
  copyWithColumnHeaders() {
    this.copy("with-column-headers");
  }
  /**
  * Cuts the contents of the selected cells to the system clipboard.
  */
  cut() {
    _class_private_field_set$L(this, _isTriggeredByCut, true);
    _class_private_method_get$D(this, _ensureClipboardEventsGetTriggered, ensureClipboardEventsGetTriggered).call(this, "cut");
  }
  /**
  * Converts the contents of multiple ranges (`ranges`) into a single string.
  *
  * @param {Array<{startRow: number, startCol: number, endRow: number, endCol: number}>} ranges Array of objects with properties `startRow`, `endRow`, `startCol` and `endCol`.
  * @returns {string} A string that will be copied to the clipboard.
  */
  getRangedCopyableData(ranges) {
    return stringify(this.getRangedData(ranges));
  }
  /**
  * Converts the contents of multiple ranges (`ranges`) into an array of arrays.
  *
  * @param {Array<{startRow: number, startCol: number, endRow: number, endCol: number}>} ranges Array of objects with properties `startRow`, `startCol`, `endRow` and `endCol`.
  * @param {boolean} [useSourceData=false] Whether to use the source data instead of the data. This will stringify objects as JSON.
  * @returns {Array[]} An array of arrays that will be copied to the clipboard.
  */
  getRangedData(ranges, useSourceData = false) {
    const data = [];
    const { rows, columns } = normalizeRanges(ranges);
    arrayEach(rows, (row) => {
      const rowSet = [];
      arrayEach(columns, (column) => {
        if (row < 0) {
          rowSet.push(this.hot.getColHeader(column, row));
        } else {
          let copyableCellData = useSourceData ? this.hot.getCopyableSourceData(row, column) : this.hot.getCopyableData(row, column);
          if (useSourceData && (isObject$1(copyableCellData) || Array.isArray(copyableCellData))) {
            copyableCellData = JSON.stringify(copyableCellData);
          }
          rowSet.push(copyableCellData);
        }
      });
      data.push(rowSet);
    });
    return data;
  }
  /**
  * Simulates the paste action.
  *
  * For security reasons, modern browsers don't allow reading from the system clipboard.
  *
  * @param {string} pastableText The value to paste, as a raw string.
  * @param {string} [pastableHtml=''] The value to paste, as HTML.
  */
  paste(pastableText = "", pastableHtml = pastableText) {
    if (!pastableText && !pastableHtml) {
      return;
    }
    const pasteData = new PasteEvent();
    if (pastableText) {
      pasteData.clipboardData.setData("text/plain", pastableText);
    }
    if (pastableHtml) {
      pasteData.clipboardData.setData("text/html", pastableHtml);
    }
    this.onPaste(pasteData);
  }
  /**
  * Prepares copyable text from the cells selection in the invisible textarea.
  */
  setCopyableText() {
    const selectionRange = this.hot.getSelectedRangeActive();
    if (!selectionRange) {
      return;
    }
    if (selectionRange.isSingleHeader()) {
      this.copyableRanges = [];
      return;
    }
    _class_private_field_get$L(this, _copyableRangesFactory).setSelectedRange(selectionRange);
    const groupedRanges = /* @__PURE__ */ new Map([
      [
        "headers",
        null
      ],
      [
        "cells",
        null
      ]
    ]);
    if (_class_private_field_get$L(this, _copyMode) === "column-headers-only") {
      groupedRanges.set("headers", _class_private_field_get$L(this, _copyableRangesFactory).getMostBottomColumnHeadersRange());
    } else {
      if (_class_private_field_get$L(this, _copyMode) === "with-column-headers") {
        groupedRanges.set("headers", _class_private_field_get$L(this, _copyableRangesFactory).getMostBottomColumnHeadersRange());
      } else if (_class_private_field_get$L(this, _copyMode) === "with-column-group-headers") {
        groupedRanges.set("headers", _class_private_field_get$L(this, _copyableRangesFactory).getAllColumnHeadersRange());
      }
      groupedRanges.set("cells", _class_private_field_get$L(this, _copyableRangesFactory).getCellsRange());
    }
    this.copyableRanges = Array.from(groupedRanges.values()).filter((range) => range !== null).map(({ startRow, startCol, endRow, endCol }) => ({
      startRow,
      startCol,
      endRow,
      endCol
    }));
    this.copyableRanges = this.hot.runHooks("modifyCopyableRange", this.copyableRanges);
    const cellsRange = groupedRanges.get("cells");
    if (cellsRange !== null && cellsRange !== void 0 && cellsRange.isRangeTrimmed) {
      const { startRow, startCol, endRow, endCol } = cellsRange;
      this.hot.runHooks("afterCopyLimit", endRow - startRow + 1, endCol - startCol + 1, this.rowsLimit, this.columnsLimit);
    }
  }
  /**
  * Verifies if editor exists and is open.
  *
  * @private
  * @returns {boolean}
  */
  isEditorOpened() {
    return this.hot.getActiveEditor()?.isOpened();
  }
  /**
  * Prepares new values to populate them into datasource.
  *
  * @private
  * @param {object} pasteData An object with the data to populate.
  * @param {object} pasteData.plainData The plain data to populate.
  * @param {object} pasteData.sourceData The source data to populate.
  * @param {object} pasteData.originalPlainData The original plain data before user modifications in beforePaste.
  * @returns {number[]} Range coordinates after populate data.
  */
  populateValues({ plainData, originalPlainData, sourceData }) {
    if (!plainData.length) {
      return [
        null,
        null,
        null,
        null
      ];
    }
    const selection = this.hot.getSelectedRangeActive();
    const populatedRowsLength = plainData.length;
    const populatedColumnsLength = plainData[0].length;
    const newRows = [];
    if (!selection) {
      return [
        null,
        null,
        null,
        null
      ];
    }
    const { row: startRow, col: startColumn } = selection.getTopStartCorner();
    const { row: endRowFromSelection, col: endColumnFromSelection } = selection.getBottomEndCorner();
    if (startRow === null || startColumn === null || endRowFromSelection === null || endColumnFromSelection === null) {
      return [
        null,
        null,
        null,
        null
      ];
    }
    let visualRowForPopulatedData = startRow;
    let visualColumnForPopulatedData = startColumn;
    let lastVisualRow = startRow;
    let lastVisualColumn = startColumn;
    while (newRows.length < populatedRowsLength || visualRowForPopulatedData <= endRowFromSelection) {
      const { skipRowOnPaste, visualRow } = this.hot.getCellMeta(visualRowForPopulatedData, startColumn);
      visualRowForPopulatedData = visualRow + 1;
      if (skipRowOnPaste === true) {
        continue;
      }
      lastVisualRow = visualRow;
      visualColumnForPopulatedData = startColumn;
      const newRow = [];
      const insertedRow = newRows.length % populatedRowsLength;
      while (newRow.length < populatedColumnsLength || visualColumnForPopulatedData <= endColumnFromSelection) {
        const { skipColumnOnPaste, visualCol, parsePastedValue } = this.hot.getCellMeta(visualRow, visualColumnForPopulatedData);
        this.hot.getSourceDataAtCell(visualRow, visualColumnForPopulatedData);
        const insertedColumn = newRow.length % populatedColumnsLength;
        visualColumnForPopulatedData = visualCol + 1;
        if (skipColumnOnPaste === true) {
          continue;
        }
        lastVisualColumn = visualCol;
        const sourceCellValue = sourceData?.[insertedRow]?.[insertedColumn];
        const originalCellValue = originalPlainData?.[insertedRow]?.[insertedColumn];
        let cellValue = plainData[insertedRow][insertedColumn];
        if (parsePastedValue && sourceData && isJSON(sourceCellValue) && cellValue === originalCellValue) {
          const parsedCellValue = JSON.parse(sourceCellValue);
          cellValue = parsedCellValue;
        }
        newRow.push(cellValue);
      }
      newRows.push(newRow);
    }
    _class_private_field_set$L(this, _preventViewportScrollOnPaste, true);
    this.hot.populateFromArray(startRow, startColumn, newRows, void 0, void 0, "CopyPaste.paste", this.pasteMode);
    return [
      startRow,
      startColumn,
      lastVisualRow,
      lastVisualColumn
    ];
  }
  /**
  * `copy` event callback on textarea element.
  *
  * @param {Event} event ClipboardEvent.
  * @private
  */
  onCopy(event) {
    const eventTarget = event.composedPath()[0];
    const focusedElement = this.hot.getFocusManager().getRefocusElement();
    const isHotInput = isHTMLElement(eventTarget) && "hotInput" in eventTarget.dataset;
    if (!this.hot.isListening() && !_class_private_field_get$L(this, _isTriggeredByCopy) || this.isEditorOpened() || isHTMLElement(eventTarget) && (isHotInput && eventTarget !== focusedElement || !isHotInput && eventTarget !== this.hot.rootDocument.body && !isInternalElement(eventTarget, this.hot.rootElement))) {
      return;
    }
    event.preventDefault();
    this.setCopyableText();
    _class_private_field_set$L(this, _isTriggeredByCopy, false);
    const rangedData = this.getRangedData(this.copyableRanges);
    const rangedSourceData = this.getRangedData(this.copyableRanges, true);
    const copiedHeadersCount = _class_private_method_get$D(this, _countCopiedHeaders, countCopiedHeaders).call(this, this.copyableRanges);
    const allowCopying = !!this.hot.runHooks("beforeCopy", rangedData, this.copyableRanges, copiedHeadersCount);
    if (allowCopying) {
      _class_private_method_get$D(this, _setClipboardData, setClipboardData).call(this, event, rangedData, rangedSourceData);
      this.hot.runHooks("afterCopy", rangedData, this.copyableRanges, copiedHeadersCount);
    }
    _class_private_field_set$L(this, _copyMode, "cells-only");
  }
  /**
  * `cut` event callback on textarea element.
  *
  * @param {Event} event ClipboardEvent.
  * @private
  */
  onCut(event) {
    const eventTarget = event.composedPath()[0];
    const focusedElement = this.hot.getFocusManager().getRefocusElement();
    const isHotInput = isHTMLElement(eventTarget) && "hotInput" in eventTarget.dataset;
    if (!this.hot.isListening() && !_class_private_field_get$L(this, _isTriggeredByCut) || this.isEditorOpened() || isHTMLElement(eventTarget) && (isHotInput && eventTarget !== focusedElement || !isHotInput && eventTarget !== this.hot.rootDocument.body && !isInternalElement(eventTarget, this.hot.rootElement))) {
      return;
    }
    event.preventDefault();
    this.setCopyableText();
    _class_private_field_set$L(this, _isTriggeredByCut, false);
    const rangedData = this.getRangedData(this.copyableRanges);
    const rangedSourceData = this.getRangedData(this.copyableRanges, true);
    const allowCuttingOut = !!this.hot.runHooks("beforeCut", rangedData, this.copyableRanges);
    if (allowCuttingOut) {
      _class_private_method_get$D(this, _setClipboardData, setClipboardData).call(this, event, rangedData, rangedSourceData);
      this.hot.emptySelectedCells("CopyPaste.cut");
      this.hot.runHooks("afterCut", rangedData, this.copyableRanges);
    }
  }
  /**
  * `paste` event callback on textarea element.
  *
  * @param {Event} event ClipboardEvent or pseudo ClipboardEvent, if paste was called manually.
  * @private
  */
  onPaste(event) {
    const eventTarget = event.composedPath()[0];
    const focusedElement = this.hot.getFocusManager().getRefocusElement();
    const isHotInput = isHTMLElement(eventTarget) && "hotInput" in eventTarget.dataset;
    if (!this.hot.isListening() || this.isEditorOpened() || !this.hot.getSelected() || isHTMLElement(eventTarget) && (isHotInput && eventTarget !== focusedElement || !isHotInput && eventTarget !== this.hot.rootDocument.body && !isInternalElement(eventTarget, this.hot.rootElement))) {
      return;
    }
    event.preventDefault?.();
    const clipboardResult = _class_private_method_get$D(this, _readClipboardData, readClipboardData).call(this, event);
    const { pastedSourceData } = clipboardResult;
    let { pastedData } = clipboardResult;
    if (typeof pastedData === "string") {
      pastedData = parse(pastedData);
    }
    if (pastedData === void 0 || Array.isArray(pastedData) && pastedData.length === 0) {
      return;
    }
    const originalPastedData = deepClone(pastedData);
    if (this.hot.runHooks("beforePaste", pastedData, this.copyableRanges) === false) {
      return;
    }
    const [startRow, startColumn, endRow, endColumn] = this.populateValues({
      plainData: pastedData,
      sourceData: pastedSourceData,
      originalPlainData: originalPastedData
    });
    if (startRow !== null && startColumn !== null && endRow !== null && endColumn !== null) {
      this.hot.selectCell(startRow, startColumn, Math.min(this.hot.countRows() - 1, endRow), Math.min(this.hot.countCols() - 1, endColumn));
    }
    this.hot.runHooks("afterPaste", pastedData, this.copyableRanges);
  }
  /**
  * Destroys the `CopyPaste` plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$D(this, _ensureClipboardEventsGetTriggered), _class_private_method_init$D(this, _countCopiedHeaders), _class_private_method_init$D(this, _addContentEditableToHighlightedCell), _class_private_method_init$D(this, _removeContentEditableFromHighlightedCell), _class_private_method_init$D(this, _readClipboardData), _class_private_method_init$D(this, _setClipboardData), _class_private_field_init$L(this, _enableCopyColumnHeaders, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _enableCopyColumnGroupHeaders, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _enableCopyColumnHeadersOnly, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _copyMode, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _isTriggeredByCopy, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _isTriggeredByCut, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _copyableRangesFactory, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _preventViewportScrollOnPaste, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _onAfterContextMenuDefaultOptions$5, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _onAfterSelection$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _onAfterSelectionEnd$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _onSafariMouseEnter, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _onSafariMouseLeave, {
      writable: true,
      value: void 0
    }), _class_private_field_init$L(this, _onSafariAfterSelection, {
      writable: true,
      value: void 0
    }), /**
    * The maximum number of columns than can be copied to the clipboard.
    *
    * @type {number}
    * @default Infinity
    */
    this.columnsLimit = Infinity, /**
    * The maximum number of rows than can be copied to the clipboard.
    *
    * @type {number}
    * @default Infinity
    */
    this.rowsLimit = Infinity, /**
    * When pasting:
    * - `'overwrite'` - overwrite the currently-selected cells
    * - `'shift_down'` - move currently-selected cells down
    * - `'shift_right'` - move currently-selected cells to the right
    *
    * @type {string}
    * @default 'overwrite'
    */
    this.pasteMode = "overwrite", /**
    * The UI container for the secondary focusable element.
    *
    * @type {HTMLElement}
    */
    this.uiContainer = this.hot.rootDocument.body, _class_private_field_set$L(this, _enableCopyColumnHeaders, false), _class_private_field_set$L(this, _enableCopyColumnGroupHeaders, false), _class_private_field_set$L(this, _enableCopyColumnHeadersOnly, false), _class_private_field_set$L(this, _copyMode, "cells-only"), _class_private_field_set$L(this, _isTriggeredByCopy, false), _class_private_field_set$L(this, _isTriggeredByCut, false), _class_private_field_set$L(this, _copyableRangesFactory, new CopyableRangesFactory({
      countRows: () => this.hot.countRows(),
      countColumns: () => this.hot.countCols(),
      rowsLimit: () => this.rowsLimit,
      columnsLimit: () => this.columnsLimit,
      countColumnHeaders: () => this.hot.view.getColumnHeadersCount()
    })), _class_private_field_set$L(this, _preventViewportScrollOnPaste, false), /**
    * Ranges of the cells coordinates, which should be used to copy/cut/paste actions.
    *
    * @private
    * @type {Array<{startRow: number, startCol: number, endRow: number, endCol: number}>}
    */
    this.copyableRanges = [], _class_private_field_set$L(this, _onAfterContextMenuDefaultOptions$5, (options) => {
      options.items.push({
        name: "---------"
      }, copyItem(this));
      if (_class_private_field_get$L(this, _enableCopyColumnHeaders)) {
        options.items.push(copyWithColumnHeadersItem(this));
      }
      if (_class_private_field_get$L(this, _enableCopyColumnGroupHeaders)) {
        options.items.push(copyWithColumnGroupHeadersItem(this));
      }
      if (_class_private_field_get$L(this, _enableCopyColumnHeadersOnly)) {
        options.items.push(copyColumnHeadersOnlyItem(this));
      }
      options.items.push(cutItem(this));
    }), _class_private_field_set$L(this, _onAfterSelection$1, (fromRow, fromColumn, toRow, toColumn, preventScrolling) => {
      if (_class_private_field_get$L(this, _preventViewportScrollOnPaste)) {
        preventScrolling.value = true;
      }
      _class_private_field_set$L(this, _preventViewportScrollOnPaste, false);
    }), _class_private_field_set$L(this, _onAfterSelectionEnd$1, () => {
      if (this.isEditorOpened()) {
        return;
      }
      if (this.hot.getSettings().fragmentSelection) {
        return;
      }
      this.setCopyableText();
    }), _class_private_field_set$L(this, _onSafariMouseEnter, () => {
      _class_private_method_get$D(this, _removeContentEditableFromHighlightedCell, removeContentEditableFromHighlightedCell).call(this);
    }), _class_private_field_set$L(this, _onSafariMouseLeave, () => {
      _class_private_method_get$D(this, _addContentEditableToHighlightedCell, addContentEditableToHighlightedCell).call(this);
    }), _class_private_field_set$L(this, _onSafariAfterSelection, () => {
      _class_private_method_get$D(this, _removeContentEditableFromHighlightedCell, removeContentEditableFromHighlightedCell).call(this);
    });
  }
}
function ensureClipboardEventsGetTriggered(eventName) {
  if (isSafari()) {
    const activeSelectedRange = this.hot.getSelectedRangeActive();
    if (activeSelectedRange) {
      const { row: highlightRow, col: highlightColumn } = activeSelectedRange.highlight;
      if (highlightRow !== null && highlightColumn !== null) {
        const currentlySelectedCell = this.hot.getCell(highlightRow, highlightColumn, true);
        if (currentlySelectedCell) {
          runWithSelectedContendEditableElement(currentlySelectedCell, () => {
            this.hot.rootDocument.execCommand(eventName);
          });
        }
      }
    }
  } else {
    this.hot.rootDocument.execCommand(eventName);
  }
}
function countCopiedHeaders(ranges) {
  const { rows } = normalizeRanges(ranges);
  let columnHeadersCount = 0;
  for (let row = 0; row < rows.length; row++) {
    if (rows[row] >= 0) {
      break;
    }
    columnHeadersCount += 1;
  }
  return {
    columnHeadersCount
  };
}
function addContentEditableToHighlightedCell() {
  if (this.hot.isListening()) {
    const activeSelectedRange = this.hot.getSelectedRangeActive();
    if (activeSelectedRange) {
      const { row: highlightRow, col: highlightColumn } = activeSelectedRange.highlight;
      if (highlightRow === null || highlightColumn === null) {
        return;
      }
      const currentlySelectedCell = this.hot.getCell(highlightRow, highlightColumn, true);
      if (currentlySelectedCell) {
        makeElementContentEditableAndSelectItsContent(currentlySelectedCell);
      }
    }
  }
}
function removeContentEditableFromHighlightedCell() {
  if (this.hot.isListening()) {
    const activeSelectedRange = this.hot.getSelectedRangeActive();
    if (activeSelectedRange) {
      const { row: highlightRow, col: highlightColumn } = activeSelectedRange.highlight;
      if (highlightRow === null || highlightColumn === null) {
        return;
      }
      const currentlySelectedCell = this.hot.getCell(highlightRow, highlightColumn, true);
      if (currentlySelectedCell?.hasAttribute("contenteditable")) {
        removeContentEditableFromElementAndDeselect(currentlySelectedCell);
      }
    }
  }
}
function readClipboardData(event) {
  let pastedData;
  let pastedSourceData;
  if (event && typeof event.clipboardData !== "undefined") {
    const clipboardData = event.clipboardData;
    const sourceDataHTML = clipboardData.getData(SOURCE_DATA_HTML_MIME_TYPE);
    if (sourceDataHTML) {
      const parsedSourceConfig = htmlToGridSettings(sourceDataHTML, this.hot.rootDocument);
      pastedSourceData = parsedSourceConfig?.data;
    }
    const rawTextHTML = clipboardData.getData("text/html") ?? "";
    const customSanitizer = this.hot.getSettings().sanitizer;
    if (rawTextHTML && typeof customSanitizer !== "function") {
      warnOnce(this.hot.rootElement, SANITIZER_WARN_KEY, 'HTML content is being pasted to the DOM without a sanitizer. Configure the "sanitizer" option to prevent XSS vulnerabilities.');
    }
    const textHTML = typeof customSanitizer === "function" ? customSanitizer(rawTextHTML, "CopyPaste.paste") : rawTextHTML;
    if (textHTML && /(<table)|(<TABLE)/g.test(textHTML)) {
      const parsedConfig = htmlToGridSettings(textHTML, this.hot.rootDocument);
      pastedData = parsedConfig?.data;
    } else {
      pastedData = clipboardData.getData("text/plain");
      if (typeof pastedData === "string") {
        pastedData = pastedData.replace(/(\r\n|\r|\n)$/, "");
      }
    }
  } else if (typeof ClipboardEvent === "undefined" && typeof this.hot.rootWindow.clipboardData !== "undefined") {
    pastedData = this.hot.rootWindow.clipboardData.getData("Text");
  }
  return {
    pastedData,
    pastedSourceData
  };
}
function setClipboardData(event, rangedData, rangedSourceData) {
  const textPlain = stringify(rangedData);
  if (event && event.clipboardData) {
    const textHTML = _dataToHTML(rangedData);
    const textSourceDataHTML = _dataToHTML(rangedSourceData);
    event.clipboardData.setData("text/plain", textPlain);
    event.clipboardData.setData("text/html", [
      META_HEAD,
      textHTML
    ].join(""));
    event.clipboardData.setData(SOURCE_DATA_HTML_MIME_TYPE, [
      META_HEAD,
      textSourceDataHTML
    ].join(""));
  } else if (typeof ClipboardEvent === "undefined") {
    this.hot.rootWindow.clipboardData.setData("Text", textPlain);
  }
}
function createId(row, col) {
  return `border_row${row}col${col}`;
}
function createDefaultCustomBorder() {
  return {
    width: 1,
    color: "#000"
  };
}
function createSingleEmptyBorder() {
  return {
    hide: true
  };
}
function createDefaultHtBorder() {
  return {
    width: 1,
    color: "#000",
    cornerVisible: false
  };
}
function normalizeBorder(border) {
  const b = border;
  if (isDefined(b.start) || isDefined(b.left)) {
    b.start = b.start ?? b.left;
  }
  if (isDefined(b.end) || isDefined(b.right)) {
    b.end = b.end ?? b.right;
  }
  delete b.left;
  delete b.right;
  return border;
}
function denormalizeBorder(border) {
  const b = border;
  if (isDefined(b.start)) {
    b.left = b.start;
  }
  if (isDefined(b.end)) {
    b.right = b.end;
  }
  return border;
}
function createEmptyBorders(row, col) {
  return {
    id: createId(row, col),
    border: createDefaultHtBorder(),
    row,
    col,
    top: createSingleEmptyBorder(),
    bottom: createSingleEmptyBorder(),
    start: createSingleEmptyBorder(),
    end: createSingleEmptyBorder()
  };
}
function applyBorderSide(defaultBorder, customBorder, side) {
  if (!hasOwnProperty(customBorder, side) || !isDefined(customBorder[side])) {
    return;
  }
  if (customBorder[side]) {
    if (!isObject$1(customBorder[side])) {
      customBorder[side] = createDefaultCustomBorder();
    }
    defaultBorder[side] = customBorder[side];
  } else {
    customBorder[side] = createSingleEmptyBorder();
    defaultBorder[side] = customBorder[side];
  }
}
function extendDefaultBorder(defaultBorder, customBorder) {
  if (hasOwnProperty(customBorder, "border") && customBorder.border) {
    defaultBorder.border = customBorder.border;
  }
  applyBorderSide(defaultBorder, customBorder, "top");
  applyBorderSide(defaultBorder, customBorder, "bottom");
  applyBorderSide(defaultBorder, customBorder, "start");
  applyBorderSide(defaultBorder, customBorder, "end");
  return defaultBorder;
}
function checkSelectionBorders(hot, direction) {
  let atLeastOneHasBorder = false;
  arrayEach(hot.getSelectedRange() ?? [], (range) => {
    range.forAll((r, c) => {
      if (r < 0 || c < 0) {
        return;
      }
      const metaBorders = hot.getCellMeta(r, c).borders;
      if (metaBorders) {
        if (direction) {
          const mb = metaBorders;
          if (!hasOwnProperty(mb[direction], "hide") || mb[direction].hide === false) {
            atLeastOneHasBorder = true;
            return false;
          }
        } else {
          atLeastOneHasBorder = true;
          return false;
        }
      }
    });
  });
  return atLeastOneHasBorder;
}
function markSelected(label) {
  return `<span class="selected">${String.fromCharCode(10003)}</span>${label}`;
}
function hasLeftRightTypeOptions(borders) {
  return borders.some((border) => isDefined(border.left) || isDefined(border.right));
}
function hasStartEndTypeOptions(borders) {
  return borders.some((border) => isDefined(border.start) || isDefined(border.end));
}
const physicalToInlinePropNames = /* @__PURE__ */ new Map([
  [
    "left",
    "start"
  ],
  [
    "right",
    "end"
  ]
]);
function toInlinePropName(propName) {
  return physicalToInlinePropNames.get(propName) ?? propName;
}
function bottom(customBordersPlugin) {
  return {
    key: "borders:bottom",
    name() {
      let label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_BORDERS_BOTTOM);
      const hasBorder = checkSelectionBorders(this, "bottom");
      if (hasBorder) {
        label = markSelected(label);
      }
      return label;
    },
    callback(key, selected) {
      const hasBorder = checkSelectionBorders(this, "bottom");
      customBordersPlugin.prepareBorder(selected, "bottom", hasBorder);
    }
  };
}
function left(customBordersPlugin) {
  const borderDirection = customBordersPlugin.hot.isRtl() ? "end" : "start";
  return {
    key: "borders:left",
    name() {
      let label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_BORDERS_LEFT);
      const hasBorder = checkSelectionBorders(this, borderDirection);
      if (hasBorder) {
        label = markSelected(label);
      }
      return label;
    },
    callback(key, selected) {
      const hasBorder = checkSelectionBorders(this, borderDirection);
      customBordersPlugin.prepareBorder(selected, borderDirection, hasBorder);
    }
  };
}
function noBorders(customBordersPlugin) {
  return {
    key: "borders:no_borders",
    name() {
      const label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_REMOVE_BORDERS);
      return label;
    },
    callback(key, selected) {
      customBordersPlugin.prepareBorder(selected, "noBorders", void 0);
    },
    disabled() {
      return !checkSelectionBorders(this);
    }
  };
}
function right(customBordersPlugin) {
  const borderDirection = customBordersPlugin.hot.isRtl() ? "start" : "end";
  return {
    key: "borders:right",
    name() {
      let label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_BORDERS_RIGHT);
      const hasBorder = checkSelectionBorders(this, borderDirection);
      if (hasBorder) {
        label = markSelected(label);
      }
      return label;
    },
    callback(key, selected) {
      const hasBorder = checkSelectionBorders(this, borderDirection);
      customBordersPlugin.prepareBorder(selected, borderDirection, hasBorder);
    }
  };
}
function top(customBordersPlugin) {
  return {
    key: "borders:top",
    name() {
      let label = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_BORDERS_TOP);
      const hasBorder = checkSelectionBorders(this, "top");
      if (hasBorder) {
        label = markSelected(label);
      }
      return label;
    },
    callback(key, selected) {
      const hasBorder = checkSelectionBorders(this, "top");
      customBordersPlugin.prepareBorder(selected, "top", hasBorder);
    }
  };
}
function _check_private_redeclaration$U(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$C(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$C(obj, privateSet) {
  _check_private_redeclaration$U(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$s = "customBorders";
const PLUGIN_PRIORITY$s = 90;
function isRecord(value) {
  return typeof value === "object" && value !== null;
}
function isBorderObject(value) {
  return isRecord(value) && typeof value.id === "string" && typeof value.row === "number" && typeof value.col === "number";
}
function isCellCoord(value) {
  return isRecord(value) && typeof value.row === "number" && typeof value.col === "number";
}
function isBorderSide(value) {
  return value === "top" || value === "bottom" || value === "start" || value === "end";
}
const SUPPORTED_STYLES = [
  "dashed",
  "dotted",
  "solid"
];
var _validateStyleSettings = /* @__PURE__ */ new WeakSet(), _onAfterContextMenuDefaultOptions$4 = /* @__PURE__ */ new WeakSet(), _onAfterInit$4 = /* @__PURE__ */ new WeakSet();
class CustomBorders extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$s;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$s;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link CustomBorders#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$s];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("afterContextMenuDefaultOptions", (options) => _class_private_method_get$C(this, _onAfterContextMenuDefaultOptions$4, onAfterContextMenuDefaultOptions).call(this, options));
    this.addHook("init", () => _class_private_method_get$C(this, _onAfterInit$4, onAfterInit).call(this));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.hideBorders();
    super.disablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`customBorders`](@/api/options.md#customborders)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    this.changeBorderSettings();
    super.updatePlugin();
  }
  /**
  * Set custom borders.
  *
  * @example
  * ```js
  * const customBordersPlugin = hot.getPlugin('customBorders');
  *
  * // Using an array of arrays (produced by `.getSelected()` method).
  * customBordersPlugin.setBorders([[1, 1, 2, 2], [6, 2, 0, 2]], {start: {width: 2, color: 'blue'}});
  *
  * // Using an array of CellRange objects (produced by `.getSelectedRange()` method).
  * //  Selecting a cell range.
  * hot.selectCell(0, 0, 2, 2);
  * // Returning selected cells' range with the getSelectedRange method.
  * customBordersPlugin.setBorders(hot.getSelectedRange(), {start: {hide: false, width: 2, color: 'blue'}});
  * ```
  *
  * @param {Array[]|CellRange[]} selectionRanges Array of selection ranges.
  * @param {object} borderObject Object with `top`, `right`, `bottom` and `start` properties.
  */
  setBorders(selectionRanges, borderObject) {
    let borderKeys = [
      "top",
      "bottom",
      "start",
      "end"
    ];
    let normBorder = null;
    if (borderObject) {
      this.checkSettingsCohesion([
        borderObject
      ]);
      borderKeys = Object.keys(borderObject);
      normBorder = normalizeBorder(borderObject);
    }
    const selectionType = detectSelectionType(selectionRanges);
    const selectionSchemaNormalizer = normalizeSelectionFactory(selectionType, {
      createCellCoords: this.hot._createCellCoords.bind(this.hot),
      createCellRange: this.hot._createCellRange.bind(this.hot)
    });
    arrayEach(selectionRanges, (selection) => {
      selectionSchemaNormalizer(selection).forAll((row, col) => {
        arrayEach(borderKeys, (borderKey) => {
          this.prepareBorderFromCustomAdded(row, col, normBorder, toInlinePropName(borderKey));
        });
        return true;
      });
    });
    this.hot.view.render();
  }
  /**
  * Get custom borders.
  *
  * @example
  * ```js
  * const customBordersPlugin = hot.getPlugin('customBorders');
  *
  * // Using an array of arrays (produced by `.getSelected()` method).
  * customBordersPlugin.getBorders([[1, 1, 2, 2], [6, 2, 0, 2]]);
  * // Using an array of CellRange objects (produced by `.getSelectedRange()` method).
  * customBordersPlugin.getBorders(hot.getSelectedRange());
  * // Using without param - return all customBorders.
  * customBordersPlugin.getBorders();
  * ```
  *
  * @param {Array[]|CellRange[]} selectionRanges Array of selection ranges.
  * @returns {object[]} Returns array of border objects.
  */
  getBorders(selectionRanges) {
    if (!Array.isArray(selectionRanges)) {
      return this.savedBorders;
    }
    const selectionType = detectSelectionType(selectionRanges);
    const selectionSchemaNormalizer = normalizeSelectionFactory(selectionType, {
      createCellCoords: this.hot._createCellCoords.bind(this.hot),
      createCellRange: this.hot._createCellRange.bind(this.hot)
    });
    const selectedBorders = [];
    arrayEach(selectionRanges, (selection) => {
      selectionSchemaNormalizer(selection).forAll((row, col) => {
        arrayEach(this.savedBorders, (border) => {
          if (border.row === row && border.col === col) {
            selectedBorders.push(denormalizeBorder(border));
          }
        });
        return true;
      });
    });
    return selectedBorders;
  }
  /**
  * Clear custom borders.
  *
  * @example
  * ```js
  * const customBordersPlugin = hot.getPlugin('customBorders');
  *
  * // Using an array of arrays (produced by `.getSelected()` method).
  * customBordersPlugin.clearBorders([[1, 1, 2, 2], [6, 2, 0, 2]]);
  * // Using an array of CellRange objects (produced by `.getSelectedRange()` method).
  * customBordersPlugin.clearBorders(hot.getSelectedRange());
  * // Using without param - clear all customBorders.
  * customBordersPlugin.clearBorders();
  * ```
  *
  * @param {Array[]|CellRange[]} selectionRanges Array of selection ranges.
  */
  clearBorders(selectionRanges) {
    if (selectionRanges) {
      this.setBorders(selectionRanges);
    } else {
      arrayEach(this.savedBorders, (border) => {
        this.clearBordersFromSelectionSettings(border.id);
        this.clearNullCellRange();
        this.hot.removeCellMeta(border.row, border.col, "borders");
      });
      this.savedBorders.length = 0;
    }
  }
  /**
  * Insert WalkontableSelection instance into Walkontable settings.
  *
  * @private
  * @param {object} border Object with `row` and `col`, `start`, `end`, `top` and `bottom`, `id` and `border` ({Object} with `color`, `width` and `cornerVisible` property) properties.
  * @param {string} [place] Coordinate where add/remove border - `top`, `bottom`, `start`, `end`.
  */
  insertBorderIntoSettings(border, place) {
    const hasSavedBorders = this.checkSavedBorders(border);
    if (!hasSavedBorders) {
      this.savedBorders.push(border);
    }
    const borderCoords = this.hot._createCellCoords(border.row, border.col);
    const visualCellRange = this.hot._createCellRange(borderCoords, borderCoords, borderCoords);
    const hasCustomSelections = this.checkCustomSelections(border, visualCellRange, place);
    if (!hasCustomSelections) {
      this.hot.selection.highlight.addCustomSelection({
        border,
        visualCellRange
      });
    }
  }
  /**
  * Prepare borders from setting (single cell).
  *
  * @private
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {object} borderDescriptor Object with `row` and `col`, `start`, `end`, `top` and `bottom` properties.
  * @param {string} [place] Coordinate where add/remove border - `top`, `bottom`, `start`, `end`.
  */
  prepareBorderFromCustomAdded(row, column, borderDescriptor, place) {
    const nrOfRows = this.hot.countRows();
    const nrOfColumns = this.hot.countCols();
    if (row >= nrOfRows || column >= nrOfColumns) {
      return;
    }
    let border = createEmptyBorders(row, column);
    if (borderDescriptor) {
      border = extendDefaultBorder(border, borderDescriptor);
      arrayEach(this.hot.selection.highlight.customSelections, (customSelection) => {
        const { settings } = customSelection;
        if (border.id === settings.id) {
          Object.assign(settings, borderDescriptor);
          const s = settings;
          border.id = s.id;
          border.top = s.top;
          border.bottom = s.bottom;
          border.start = s.start;
          border.end = s.end;
          return false;
        }
      });
    }
    this.hot.setCellMeta(row, column, "borders", denormalizeBorder(border));
    this.insertBorderIntoSettings(border, place);
  }
  /**
  * Prepare borders from setting (object).
  *
  * @private
  * @param {object} range {CellRange} The CellRange object.
  * @param {object} customBorder Object with `start`, `end`, `top` and `bottom` properties.
  */
  prepareBorderFromCustomAddedRange(range, customBorder) {
    const lastRowIndex = Math.min(range.to.row, this.hot.countRows() - 1);
    const lastColumnIndex = Math.min(range.to.col, this.hot.countCols() - 1);
    rangeEach(range.from.row, lastRowIndex, (rowIndex) => {
      rangeEach(range.from.col, lastColumnIndex, (colIndex) => {
        const border = createEmptyBorders(rowIndex, colIndex);
        let add2 = 0;
        if (rowIndex === range.from.row) {
          if (hasOwnProperty(customBorder, "top")) {
            add2 += 1;
            border.top = customBorder.top;
          }
        }
        if (rowIndex === range.to.row) {
          if (hasOwnProperty(customBorder, "bottom")) {
            add2 += 1;
            border.bottom = customBorder.bottom;
          }
        }
        if (colIndex === range.from.col) {
          if (hasOwnProperty(customBorder, "start")) {
            add2 += 1;
            border.start = customBorder.start;
          }
        }
        if (colIndex === range.to.col) {
          if (hasOwnProperty(customBorder, "end")) {
            add2 += 1;
            border.end = customBorder.end;
          }
        }
        if (add2 > 0) {
          this.hot.setCellMeta(rowIndex, colIndex, "borders", denormalizeBorder(border));
          this.insertBorderIntoSettings(border, void 0);
        }
      });
    });
  }
  /**
  * Remove border (triggered from context menu).
  *
  * @private
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  */
  removeAllBorders(row, column) {
    const borderId = createId(row, column);
    this.spliceBorder(borderId);
    this.clearBordersFromSelectionSettings(borderId);
    this.clearNullCellRange();
    this.hot.removeCellMeta(row, column, "borders");
  }
  /**
  * Set borders for each cell re. To border position.
  *
  * @private
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {string} place Coordinate where add/remove border - `top`, `bottom`, `start`, `end` and `noBorders`.
  * @param {boolean} remove True when remove borders, and false when add borders.
  */
  setBorder(row, column, place, remove) {
    const meta = this.hot.getCellMeta(row, column).borders;
    let bordersMeta;
    if (isBorderObject(meta)) {
      bordersMeta = normalizeBorder(meta);
    } else {
      bordersMeta = createEmptyBorders(row, column);
    }
    if (remove) {
      bordersMeta[place] = createSingleEmptyBorder();
      const hideCount = this.countHide(bordersMeta);
      if (hideCount === 4) {
        this.removeAllBorders(row, column);
      } else {
        const customSelectionsChecker = this.checkCustomSelectionsFromContextMenu(bordersMeta, place, remove);
        if (!customSelectionsChecker) {
          this.insertBorderIntoSettings(bordersMeta, void 0);
        }
        this.hot.setCellMeta(row, column, "borders", denormalizeBorder(bordersMeta));
      }
    } else {
      bordersMeta[place] = createDefaultCustomBorder();
      const customSelectionsChecker = this.checkCustomSelectionsFromContextMenu(bordersMeta, place, remove);
      if (!customSelectionsChecker) {
        this.insertBorderIntoSettings(bordersMeta, void 0);
      }
      this.hot.setCellMeta(row, column, "borders", denormalizeBorder(bordersMeta));
    }
  }
  /**
  * Prepare borders based on cell and border position.
  *
  * @private
  * @param {CellRange[]} selected An array of CellRange objects.
  * @param {string} place Coordinate where add/remove border - `top`, `bottom`, `left`, `right` and `noBorders`.
  * @param {boolean} remove True when remove borders, and false when add borders.
  */
  prepareBorder(selected, place, remove) {
    arrayEach(selected, (item) => {
      if (!isCellCoord(item.start) || !isCellCoord(item.end)) {
        return;
      }
      const { start, end } = {
        start: item.start,
        end: item.end
      };
      if (start.row === end.row && start.col === end.col) {
        if (place === "noBorders") {
          this.removeAllBorders(start.row, start.col);
        } else {
          this.setBorder(start.row, start.col, place, remove);
        }
      } else {
        switch (place) {
          case "noBorders":
            rangeEach(start.col, end.col, (colIndex) => {
              rangeEach(start.row, end.row, (rowIndex) => {
                this.removeAllBorders(rowIndex, colIndex);
              });
            });
            break;
          case "top":
            rangeEach(start.col, end.col, (topCol) => {
              this.setBorder(start.row, topCol, place, remove);
            });
            break;
          case "bottom":
            rangeEach(start.col, end.col, (bottomCol) => {
              this.setBorder(end.row, bottomCol, place, remove);
            });
            break;
          case "start":
            rangeEach(start.row, end.row, (rowStart) => {
              this.setBorder(rowStart, start.col, place, remove);
            });
            break;
          case "end":
            rangeEach(start.row, end.row, (rowEnd) => {
              this.setBorder(rowEnd, end.col, place, remove);
            });
            break;
        }
      }
    });
  }
  /**
  * Create borders from settings.
  *
  * @private
  * @param {Array} customBorders Object with `row` and `col`, `start`, `end`, `top` and `bottom` properties.
  */
  createCustomBorders(customBorders) {
    arrayEach(customBorders, (customBorder) => {
      const normCustomBorder = normalizeBorder(customBorder);
      if (normCustomBorder.range) {
        this.prepareBorderFromCustomAddedRange(normCustomBorder.range, normCustomBorder);
      } else {
        this.prepareBorderFromCustomAdded(normCustomBorder.row ?? 0, normCustomBorder.col ?? 0, normCustomBorder, void 0);
      }
    });
  }
  /**
  * Count hide property in border object.
  *
  * @private
  * @param {object} border Object with `row` and `col`, `start`, `end`, `top` and `bottom`, `id` and
  *                        `border` ({Object} with `color`, `width` and `cornerVisible` property) properties.
  * @returns {number}
  */
  countHide(border) {
    const { top: top2, bottom: bottom2, start, end } = border;
    const values2 = [
      top2,
      bottom2,
      start,
      end
    ];
    return arrayReduce(values2, (accumulator, value) => {
      let result = accumulator;
      if (value && value.hide) {
        result += 1;
      }
      return result;
    }, 0);
  }
  /**
  * Clear borders settings from custom selections.
  *
  * @private
  * @param {string} borderId Border id name as string.
  */
  clearBordersFromSelectionSettings(borderId) {
    const index2 = arrayMap(this.hot.selection.highlight.customSelections, (customSelection) => customSelection.settings.id).indexOf(borderId);
    if (index2 > -1) {
      this.hot.selection.highlight.customSelections[index2].clear();
    }
  }
  /**
  * Clear cellRange with null value.
  *
  * @private
  */
  clearNullCellRange() {
    arrayEach(this.hot.selection.highlight.customSelections, (customSelection, index2) => {
      if (customSelection.cellRange === null) {
        customSelection.destroy();
        this.hot.selection.highlight.customSelections.splice(index2, 1);
        return false;
      }
    });
  }
  /**
  * Hide custom borders.
  *
  * @private
  */
  hideBorders() {
    arrayEach(this.savedBorders, (border) => {
      this.clearBordersFromSelectionSettings(border.id);
      this.clearNullCellRange();
    });
  }
  /**
  * Splice border from savedBorders.
  *
  * @private
  * @param {string} borderId Border id name as string.
  */
  spliceBorder(borderId) {
    const index2 = arrayMap(this.savedBorders, (border) => border.id).indexOf(borderId);
    if (index2 > -1) {
      this.savedBorders.splice(index2, 1);
    }
  }
  /**
  * Check if an border already exists in the savedBorders array, and if true update border in savedBorders.
  *
  * @private
  * @param {object} border Object with `row` and `col`, `start`, `end`, `top` and `bottom`, `id` and
  *                        `border` ({Object} with `color`, `width` and `cornerVisible` property) properties.
  *
  * @returns {boolean}
  */
  checkSavedBorders(border) {
    let check = false;
    const hideCount = this.countHide(border);
    if (hideCount === 4) {
      this.spliceBorder(border.id);
      check = true;
    } else {
      arrayEach(this.savedBorders, (savedBorder, index2) => {
        if (border.id === savedBorder.id) {
          this.savedBorders[index2] = border;
          check = true;
          return false;
        }
      });
    }
    return check;
  }
  /**
  * Check if an border already exists in the customSelections, and if true call toggleHiddenClass method.
  *
  * @private
  * @param {object} border Object with `row` and `col`, `start`, `end`, `top` and `bottom`, `id` and
  *                        `border` ({Object} with `color`, `width` and `cornerVisible` property) properties.
  * @param {string} place Coordinate where add/remove border - `top`, `bottom`, `start`, `end` and `noBorders`.
  * @param {boolean} remove True when remove borders, and false when add borders.
  *
  * @returns {boolean}
  */
  checkCustomSelectionsFromContextMenu(border, place, remove) {
    let check = false;
    const customSelections = this.hot.selection.highlight.customSelections;
    arrayEach(customSelections, (customSelection) => {
      if (border.id === customSelection.settings.id) {
        const borders = this.hot.view._wt.selectionManager.getBorderInstances(customSelection);
        if (isBorderSide(place)) {
          arrayEach(borders, (borderObject) => {
            borderObject.toggleHiddenClass(place, remove ?? false);
          });
        }
        check = true;
        return false;
      }
    });
    return check;
  }
  /**
  * Check if an border already exists in the customSelections, and if true reset cellRange.
  *
  * @private
  * @param {object} border Object with `row` and `col`, `start`, `end`, `top` and `bottom`, `id` and
  *                        `border` ({Object} with `color`, `width` and `cornerVisible` property) properties.
  * @param {CellRange} cellRange The selection range to check.
  * @param {string} [place] Coordinate where add/remove border - `top`, `bottom`, `start`, `end`.
  * @returns {boolean}
  */
  checkCustomSelections(border, cellRange, place) {
    const hideCount = this.countHide(border);
    let check = false;
    if (hideCount === 4) {
      this.removeAllBorders(border.row, border.col);
      check = true;
    } else {
      arrayEach(this.hot.selection.highlight.customSelections, (customSelection) => {
        if (border.id === customSelection.settings.id) {
          customSelection.visualCellRange = cellRange;
          customSelection.commit();
          if (place && isBorderSide(place)) {
            const borders = this.hot.view._wt.selectionManager.getBorderInstances(customSelection);
            arrayEach(borders, (borderObject) => {
              borderObject.changeBorderStyle(place, border);
            });
          }
          check = true;
          return false;
        }
      });
    }
    return check;
  }
  /**
  * Change borders from settings.
  *
  * @private
  */
  changeBorderSettings() {
    const customBorders = this.hot.getSettings()[PLUGIN_KEY$s];
    if (Array.isArray(customBorders)) {
      const bordersClone = deepClone(customBorders.filter(isRecord));
      this.checkSettingsCohesion(bordersClone);
      if (!bordersClone.length) {
        this.savedBorders = [];
      }
      this.createCustomBorders(bordersClone);
    } else if (customBorders !== void 0) {
      this.createCustomBorders(this.savedBorders);
    }
  }
  /**
  * Checks the settings cohesion. The properties such like "left"/"right" are supported only
  * in the LTR mode and the "left"/"right" options can not be used together with "start"/"end" properties.
  *
  * @private
  * @param {object[]} customBorders The user defined custom border objects array.
  */
  checkSettingsCohesion(customBorders) {
    const hasLeftOrRight = hasLeftRightTypeOptions(customBorders);
    const hasStartOrEnd = hasStartEndTypeOptions(customBorders);
    if (hasLeftOrRight && hasStartOrEnd) {
      throwWithCause('The "left"/"right" and "start"/"end" options should not be used together. Please use only the option "start"/"end".');
    }
    if (this.hot.isRtl() && hasLeftOrRight) {
      throwWithCause('The "left"/"right" properties are not supported for RTL. Please use option "start"/"end".');
    }
    _class_private_method_get$C(this, _validateStyleSettings, validateStyleSettings).call(this, customBorders);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$C(this, _validateStyleSettings), _class_private_method_init$C(this, _onAfterContextMenuDefaultOptions$4), _class_private_method_init$C(this, _onAfterInit$4), /**
    * Saved borders.
    *
    * @private
    * @type {Array}
    */
    this.savedBorders = [];
  }
}
function validateStyleSettings(customBorders) {
  customBorders.forEach((customBorder) => {
    Object.keys(customBorder).forEach((key) => {
      const side = customBorder[key];
      if (!isRecord(side)) {
        return;
      }
      const { style } = side;
      if (isDefined(style) && typeof style === "string" && !SUPPORTED_STYLES.includes(style)) {
        warn$1(`The "${style}" border style is not supported. Please use one of the following styles: ${SUPPORTED_STYLES.join(", ")}.
The border style will be ignored.`);
        delete side.style;
      } else if (isDefined(style) && style === "solid") {
        delete side.style;
      }
    });
  });
}
function onAfterContextMenuDefaultOptions(rawOptions) {
  if (!this.hot.getSettings()[PLUGIN_KEY$s]) {
    return;
  }
  if (typeof rawOptions !== "object" || rawOptions === null) {
    return;
  }
  const defaultOptions = rawOptions;
  const { items } = defaultOptions;
  if (!Array.isArray(items)) {
    return;
  }
  items.push({
    name: "---------"
  }, {
    key: "borders",
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_BORDERS);
    },
    disabled() {
      const range = this.getSelectedRangeActive();
      if (!range) {
        return true;
      }
      if (range.isSingleHeader()) {
        return true;
      }
      return this.selection.isSelectedByCorner();
    },
    submenu: {
      items: [
        top(this),
        right(this),
        bottom(this),
        left(this),
        noBorders(this)
      ]
    }
  });
}
function onAfterInit() {
  this.changeBorderSettings();
}
const PLUGIN_KEY$r = "dataProvider";
const PLUGIN_PRIORITY$r = 950;
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_SETTINGS$1 = {
  rowId: void 0,
  fetchRows: void 0,
  onRowsCreate: void 0,
  onRowsUpdate: void 0,
  onRowsRemove: void 0
};
const SETTINGS_VALIDATORS = {
  rowId: (value) => typeof value === "string" || isFunction$1(value),
  fetchRows: (value) => isFunction$1(value),
  onRowsCreate: (value) => isFunction$1(value),
  onRowsUpdate: (value) => isFunction$1(value),
  onRowsRemove: (value) => isFunction$1(value)
};
const ABORT_REASON_MESSAGE = "DataProvider fetch superseded by a newer request";
const INITIAL_QUERY_PARAMETERS = Object.freeze({
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  sort: null,
  filters: null
});
const DATA_PROVIDER_BATCH_UPDATE_SOURCES = /* @__PURE__ */ new Set([
  "edit",
  void 0,
  "CopyPaste.paste",
  "CopyPaste.cut",
  "Autofill.fill",
  "ContextMenu.clearColumn",
  /** Revert after failed `onRowsUpdate`; skipped for server enqueue and omitted from undo stack. */
  "DataProvider.revert"
]);
const DATA_PROVIDER_ERROR_UPDATE_MISSING_ROW_ID = "DataProvider: cannot send row update because `rowId` resolves to null or undefined for that row.";
function dataProviderErrorRemoveMissingRowId(visualIndex) {
  return `DataProvider: cannot remove row at visual index ${visualIndex} because \`rowId\` resolves to null or undefined.`;
}
const DATA_PROVIDER_ERROR_UPDATE_ROWS_MISSING_ID = "DataProvider: `updateRows` requires every entry to include a non-null `id`.";
const DATA_PROVIDER_ERROR_REMOVE_ROWS_MISSING_ID = "DataProvider: `removeRows` requires every id to be non-null.";
function runBeforeRowsMutation(hot, operation, payload) {
  if (hot.runHooks("beforeRowsMutation", operation, payload) === false) {
    return false;
  }
  return void 0;
}
function runAfterRowsMutation(hot, operation, payload) {
  hot.runHooks("afterRowsMutation", operation, payload);
}
function runAfterRowsMutationError(hot, operation, err, payload) {
  hot.runHooks("afterRowsMutationError", operation, err, payload);
}
function enqueueMutation(state, fn) {
  const mutationPromise = state.tail.then(fn);
  state.tail = mutationPromise.catch(() => {
  });
  return mutationPromise;
}
function getRowIdFromRowData(rowData, rowIdOption) {
  if (rowIdOption === void 0 || rowIdOption === null) {
    return void 0;
  }
  if (isFunction$1(rowIdOption)) {
    return rowIdOption(rowData);
  }
  if (typeof rowIdOption === "string") {
    return getProperty(rowData, rowIdOption);
  }
  return void 0;
}
function getRowIdByVisualRow(hot, rowIdOption, visualRow) {
  return getRowIdFromRowData(hot.getSourceDataAtRow(hot.toPhysicalRow(visualRow)), rowIdOption);
}
function isMissingRowId(id) {
  return id === void 0 || id === null;
}
function findVisualRowById(hot, rowIdOption, rowId) {
  for (let row = 0; row < hot.countRows(); row += 1) {
    if (getRowIdByVisualRow(hot, rowIdOption, row) === rowId) {
      return row;
    }
  }
  return -1;
}
function rowIdsFromAlterRemove(hot, rowIdOption, index2, amount) {
  const ids = [];
  const n2 = () => hot.countRows();
  const pushRange = (start, amt) => {
    for (let r = 0; r < amt; r += 1) {
      const v = start + r;
      if (v >= 0 && v < n2()) {
        const id = getRowIdByVisualRow(hot, rowIdOption, v);
        if (isMissingRowId(id)) {
          throwWithCause(dataProviderErrorRemoveMissingRowId(v));
        }
        ids.push(id);
      }
    }
  };
  if (Array.isArray(index2)) {
    index2.forEach(([gi, ga]) => {
      const start = gi === void 0 || gi === null ? Math.max(0, n2() - (ga ?? 1)) : Math.max(0, gi);
      pushRange(start, ga ?? 1);
    });
  } else {
    const amt = typeof amount === "number" && amount >= 1 ? amount : 1;
    const start = index2 === void 0 || index2 === null ? Math.max(0, n2() - amt) : Math.max(0, index2);
    pushRange(start, amt);
  }
  return ids;
}
function buildChangesAndRowData(hot, rowChanges) {
  const visualRow = rowChanges[0][0];
  const rowData = hot.getSourceDataAtRow(hot.toPhysicalRow(visualRow));
  const isObj = rowData && typeof rowData === "object" && !Array.isArray(rowData);
  const changesObj = {};
  rowChanges.forEach(([, prop, , nv]) => {
    const col = typeof prop === "number" ? prop : hot.propToCol(prop);
    const key = isObj ? hot.colToProp(col) : col;
    changesObj[key] = nv;
  });
  let rowDataWithChanges;
  if (Array.isArray(rowData)) {
    rowDataWithChanges = [
      ...rowData
    ];
    rowChanges.forEach(([, prop, , nv]) => {
      const col = typeof prop === "number" ? prop : hot.propToCol(prop);
      rowDataWithChanges[col] = nv;
    });
  } else if (isObj) {
    rowDataWithChanges = {
      ...rowData,
      ...changesObj
    };
  } else {
    rowDataWithChanges = {
      ...changesObj
    };
  }
  return {
    changesObj,
    rowData: rowDataWithChanges
  };
}
function revertChangeTuples(hot, changeTuples) {
  if (!changeTuples?.length) {
    return;
  }
  hot.batch(() => {
    changeTuples.forEach(([row, prop, oldVal]) => {
      hot.setDataAtRowProp(row, prop, oldVal, "DataProvider.revert");
    });
  });
}
function validateRowChanges(hot, visualRow, changes) {
  const entries = Object.entries(changes);
  if (entries.length === 0) {
    return Promise.resolve(true);
  }
  return new Promise((resolve) => {
    let pending = entries.length;
    let valid = true;
    const done = () => {
      pending -= 1;
      if (pending === 0) {
        resolve(valid);
      }
    };
    entries.forEach(([prop, value]) => {
      const col = hot.propToCol(prop);
      if (col === void 0 || col < 0) {
        done();
        return;
      }
      const cellMeta = hot.getCellMeta(visualRow, col);
      if (!hot.getCellValidator(cellMeta)) {
        done();
        return;
      }
      hot.validateCell(value, cellMeta, (result) => {
        if (result === false && cellMeta.allowInvalid === false) {
          valid = false;
        }
        done();
      }, "DataProvider.updateRows");
    });
  });
}
function shouldIgnoreAfterChangeForServerUpdate(hasOnRowsUpdate, changes, source) {
  if (!hasOnRowsUpdate || !changes?.length) {
    return true;
  }
  if (source === "DataProvider.revert") {
    return true;
  }
  if (!DATA_PROVIDER_BATCH_UPDATE_SOURCES.has(source)) {
    return true;
  }
  return false;
}
function filterChangesForBatchedServerUpdate(hot, changes) {
  if (!changes) {
    return [];
  }
  const tuples = changes;
  const real = tuples.filter((c) => c[2] !== c[3]);
  if (real.length === 0) {
    return [];
  }
  return real.filter((c) => {
    const col = hot.propToCol(c[1]);
    if (col === void 0 || col < 0) {
      return false;
    }
    return hot.getCellMeta(c[0], col).valid !== false;
  });
}
function buildManualUpdateRowPayloads(hot, rowIdOption, rows) {
  return rows.map((p) => {
    const visualRow = findVisualRowById(hot, rowIdOption, p.id);
    let rowData;
    if (visualRow >= 0) {
      rowData = hot.getSourceDataAtRow(hot.toPhysicalRow(visualRow));
    } else if (p.rowData !== void 0) {
      rowData = p.rowData;
    } else {
      rowData = {};
    }
    return {
      id: p.id,
      changes: p.changes,
      rowData: rowData && typeof rowData === "object" ? rowData : {}
    };
  });
}
async function commitRowsUpdate$1(hot, callbacks, rowPayloads, options = {}) {
  const onRowsUpdate = callbacks.getOnRowsUpdate();
  if (!isFunction$1(onRowsUpdate)) {
    return;
  }
  const payload = {
    rows: rowPayloads
  };
  const { revertOptimistic } = options;
  const { onRequestFailed } = callbacks;
  try {
    await onRowsUpdate(rowPayloads);
  } catch (err) {
    runAfterRowsMutationError(hot, "update", err, payload);
    callbacks.logError("Row update failed:", err);
    if (isFunction$1(revertOptimistic)) {
      revertOptimistic();
    }
    hot.render();
    onRequestFailed?.("update", err);
    return;
  }
  try {
    runAfterRowsMutation(hot, "update", payload);
    await callbacks.fetchData();
  } catch (err) {
    runAfterRowsMutationError(hot, "update", err, payload);
    callbacks.logError("Data reload failed:", err);
    if (isFunction$1(revertOptimistic)) {
      revertOptimistic();
    }
    hot.render();
  }
}
async function runManualUpdateRowsMutation(hot, ctx, rowPayloads) {
  const { getRowIdOption: getRowIdOption2, commitRowsUpdate: commitUpdate } = ctx;
  const payload = {
    rows: rowPayloads
  };
  if (runBeforeRowsMutation(hot, "update", payload) === false) {
    return;
  }
  const rowIdOption = getRowIdOption2();
  const validationResults = await Promise.all(rowPayloads.map(async (p) => {
    const visualRow = findVisualRowById(hot, rowIdOption, p.id);
    if (visualRow < 0) {
      return true;
    }
    return validateRowChanges(hot, visualRow, p.changes ?? {});
  }));
  if (validationResults.some((ok) => !ok)) {
    runAfterRowsMutationError(hot, "update", new Error("Row update validation failed"), payload);
    error("Row update failed: validation failed for one or more cells");
    return;
  }
  await commitUpdate(rowPayloads);
}
async function runUpdateFromChanges(hot, ctx, changes) {
  const { getRowIdOption: getRowIdOption2, commitRowsUpdate: commitFn } = ctx;
  const byRow = /* @__PURE__ */ new Map();
  changes.forEach((ch) => {
    const vr = ch[0];
    if (!byRow.has(vr)) {
      byRow.set(vr, []);
    }
    byRow.get(vr).push(ch);
  });
  const sortedRows = [
    ...byRow.keys()
  ].sort((a, b) => a - b);
  const rowIdOption = getRowIdOption2();
  const rowPayloads = sortedRows.map((vr) => {
    const { changesObj, rowData } = buildChangesAndRowData(hot, byRow.get(vr));
    return {
      id: getRowIdByVisualRow(hot, rowIdOption, vr),
      changes: changesObj,
      rowData
    };
  });
  const payload = {
    rows: rowPayloads
  };
  const revert = () => revertChangeTuples(hot, changes);
  if (rowPayloads.some((p) => isMissingRowId(p.id))) {
    revert();
    runAfterRowsMutationError(hot, "update", new Error(DATA_PROVIDER_ERROR_UPDATE_MISSING_ROW_ID), payload);
    error("Row update failed:", DATA_PROVIDER_ERROR_UPDATE_MISSING_ROW_ID);
    hot.render();
    return;
  }
  if (runBeforeRowsMutation(hot, "update", payload) === false) {
    revert();
    return;
  }
  const ok = await Promise.all(sortedRows.map((vr, i) => validateRowChanges(hot, vr, rowPayloads[i].changes)));
  if (ok.some((v) => !v)) {
    revert();
    runAfterRowsMutationError(hot, "update", new Error("Row update validation failed"), payload);
    error("Row update failed: validation failed for one or more cells");
    hot.render();
    return;
  }
  await commitFn(rowPayloads, {
    revertOptimistic: revert
  });
}
function queueCrud(ctx, operation, payload, userPromiseFn, onSuccess) {
  const { enqueueMutation: enqueue, runBeforeRowsMutation: beforeMut, runAfterRowsMutation: afterMut, runAfterRowsMutationError: afterMutErr, logError: logErr, onRequestFailed } = ctx;
  return enqueue(async () => {
    if (beforeMut(operation, payload) === false) {
      return;
    }
    const mutationLabel = operation === "create" ? "Row create" : "Row remove";
    try {
      await userPromiseFn();
    } catch (err) {
      afterMutErr(operation, err, payload);
      logErr(`${mutationLabel} failed:`, err);
      onRequestFailed?.(operation, err);
      return;
    }
    try {
      afterMut(operation, payload);
      await onSuccess();
    } catch (err) {
      afterMutErr(operation, err, payload);
      logErr("Data reload failed:", err);
    }
  });
}
function handleInsertRowAlterForCrud(ctx, action, index2, amount) {
  const { hot, getOnRowsCreate: getOnRowsCreate2, getRowId, createRows } = ctx;
  if (!isFunction$1(getOnRowsCreate2())) {
    return;
  }
  const n2 = hot.countSourceRows();
  if (hot.getSettings().maxRows === n2) {
    return;
  }
  const position = action === "insert_row_below" ? "below" : "above";
  const visualIndex = index2 ?? (position === "below" ? n2 : 0);
  void createRows({
    position,
    referenceRowId: typeof visualIndex === "number" && visualIndex >= 0 ? getRowId(visualIndex) : void 0,
    rowsAmount: typeof amount === "number" && amount >= 1 ? amount : 1
  });
  return false;
}
function handleRemoveRowAlterForCrud(ctx, index2, amount) {
  const { hot, getOnRowsRemove: getOnRowsRemove2, getRowIdOption: getRowIdOption2, removeRows } = ctx;
  if (!isFunction$1(getOnRowsRemove2())) {
    return;
  }
  const rowIds = rowIdsFromAlterRemove(hot, getRowIdOption2(), index2, amount);
  if (rowIds.length === 0) {
    return;
  }
  void removeRows(rowIds);
  return false;
}
function handleBeforeAlterForCrud(ctx, action, index2, amount) {
  if (action === "insert_row_above" || action === "insert_row_below") {
    return handleInsertRowAlterForCrud(ctx, action, index2, amount);
  }
  if (action === "remove_row") {
    return handleRemoveRowAlterForCrud(ctx, index2, amount);
  }
}
const FILTERS_PLUGIN_KEY = "filters";
function cloneDataProviderFiltersPayload(filters) {
  if (filters === null) {
    return null;
  }
  return filters.map((col) => ({
    prop: col.prop,
    operation: col.operation,
    conditions: (col.conditions || []).map((c) => ({
      name: c.name,
      args: Array.isArray(c.args) ? [
        ...c.args
      ] : []
    }))
  }));
}
function conditionsStackToFiltersPayload(hot, conditionsStack) {
  if (!Array.isArray(conditionsStack) || conditionsStack.length === 0) {
    return null;
  }
  const payload = [];
  for (let i = 0; i < conditionsStack.length; i++) {
    const stack = conditionsStack[i];
    const visualCol = hot.toVisualColumn(stack.column);
    const prop = hot.colToProp(visualCol);
    if (prop === null || prop === void 0) {
      continue;
    }
    payload.push({
      prop: String(prop),
      operation: stack.operation,
      conditions: stack.conditions.map((c) => ({
        name: c.name,
        args: Array.isArray(c.args) ? [
          ...c.args
        ] : []
      }))
    });
  }
  return payload.length === 0 ? null : payload;
}
function filtersPayloadToConditionsStack(hot, filtersPayload) {
  if (filtersPayload === null || filtersPayload === void 0) {
    return [];
  }
  if (!Array.isArray(filtersPayload) || filtersPayload.length === 0) {
    return [];
  }
  const stack = [];
  for (let i = 0; i < filtersPayload.length; i++) {
    const col = filtersPayload[i];
    const visualCol = hot.propToCol(col.prop);
    if (visualCol === null || visualCol === void 0 || visualCol < 0) {
      continue;
    }
    const physicalColumn = hot.toPhysicalColumn(visualCol);
    stack.push({
      column: physicalColumn,
      operation: col.operation,
      conditions: (col.conditions || []).map((c) => ({
        name: c.name ?? "",
        args: Array.isArray(c.args) ? [
          ...c.args
        ] : []
      }))
    });
  }
  return stack;
}
function applyFiltersFromFiltersPluginToQueryParameters(hot, queryParameters, getFetchFn2) {
  if (!isFunction$1(getFetchFn2())) {
    return;
  }
  const filtersPlugin = hot.getPlugin(FILTERS_PLUGIN_KEY);
  if (!filtersPlugin || !filtersPlugin.enabled) {
    return;
  }
  const filtersForProvider = conditionsStackToFiltersPayload(hot, filtersPlugin.exportConditions());
  queryParameters.filters = filtersForProvider ?? null;
}
function handleBeforeFilterForServer(ctx, conditionsStack) {
  const { hot, hasFetchFn, applyFiltersAndRefetch } = ctx;
  if (!hasFetchFn()) {
    return;
  }
  const filtersForProvider = conditionsStackToFiltersPayload(hot, conditionsStack);
  applyFiltersAndRefetch(filtersForProvider);
  return false;
}
const PAGINATION_PLUGIN_KEY = "pagination";
function applyPaginationToQueryParameters(paginationPlugin, queryParameters) {
  if (!paginationPlugin?.enabled) {
    return;
  }
  const currentPageSize = typeof paginationPlugin.getCurrentPageSize === "function" ? paginationPlugin.getCurrentPageSize() : void 0;
  const settingsPageSize = paginationPlugin.getSetting("pageSize");
  const initialPage = paginationPlugin.getSetting("initialPage");
  const currentPage = typeof paginationPlugin.getCurrentPage === "function" ? paginationPlugin.getCurrentPage() : void 0;
  if (typeof currentPageSize === "number") {
    queryParameters.pageSize = currentPageSize;
  } else if (typeof settingsPageSize === "number") {
    queryParameters.pageSize = settingsPageSize;
  }
  if (typeof currentPage === "number" && currentPage >= 1) {
    queryParameters.page = currentPage;
  } else if (typeof initialPage === "number" && initialPage >= 1) {
    queryParameters.page = initialPage;
  }
}
function normalizeExternalPaginationPageSize(newPageSize, fallbackPageSize) {
  if (newPageSize === "auto" || typeof newPageSize !== "number" || !Number.isFinite(newPageSize) || newPageSize < 1) {
    return fallbackPageSize;
  }
  return newPageSize;
}
function applyPaginationToQueryFromPlugin(hot, queryParameters) {
  applyPaginationToQueryParameters(hot.getPlugin(PAGINATION_PLUGIN_KEY), queryParameters);
}
function getPagedRowHeaderIndex(queryParameters, visualRowIndex, fallbackPageSize = DEFAULT_PAGE_SIZE) {
  const { page, pageSize } = queryParameters;
  const ps = typeof pageSize === "number" && pageSize >= 1 ? pageSize : fallbackPageSize;
  return (page - 1) * ps + visualRowIndex;
}
function handleAfterPageChangeExternalPagination(ctx, oldPage, newPage) {
  const { hot, getQueryPage, goToPage } = ctx;
  const paginationPlugin = hot.getPlugin(PAGINATION_PLUGIN_KEY);
  if (!paginationPlugin?.enabled) {
    return;
  }
  if (newPage === getQueryPage()) {
    return;
  }
  goToPage(newPage).catch(() => {
    const p = hot.getPlugin(PAGINATION_PLUGIN_KEY);
    if (p?.enabled) {
      p.revertPageTo(oldPage);
    }
  });
}
function handleAfterPageSizeChangeExternalPagination(ctx, oldPageSize, newPageSize) {
  const { hot, getQueryPage, getQueryPageSize, setPageSize } = ctx;
  const paginationPlugin = hot.getPlugin(PAGINATION_PLUGIN_KEY);
  if (!paginationPlugin?.enabled) {
    return;
  }
  const ps = normalizeExternalPaginationPageSize(newPageSize, DEFAULT_PAGE_SIZE);
  if (ps === getQueryPageSize() && getQueryPage() === 1) {
    return;
  }
  setPageSize(ps).catch(() => {
    const p = hot.getPlugin(PAGINATION_PLUGIN_KEY);
    if (p?.enabled) {
      p.revertPageSizeTo(oldPageSize);
    }
  });
}
const COLUMN_SORTING_PLUGIN_KEY = "columnSorting";
function normalizeSortToQueryFormat(sort2, colToProp) {
  if (sort2 === null || sort2 === void 0 || typeof sort2 !== "object") {
    return null;
  }
  const s = sort2;
  if (typeof s.column === "number" && typeof colToProp === "function") {
    return {
      prop: colToProp(s.column),
      order: s.sortOrder
    };
  }
  const order = s.order ?? s.sortOrder;
  if (typeof s.prop === "string" && (order === "asc" || order === "desc")) {
    return {
      prop: s.prop,
      order
    };
  }
  return null;
}
function querySortToPluginSort(sort2, propToCol) {
  if (sort2 === null || sort2 === void 0 || typeof sort2 !== "object") {
    return null;
  }
  const s = sort2;
  if (typeof s.prop !== "string") {
    return null;
  }
  const order = s.order ?? s.sortOrder;
  if (order !== "asc" && order !== "desc") {
    return null;
  }
  if (typeof propToCol !== "function") {
    return null;
  }
  const column = propToCol(s.prop);
  if (typeof column !== "number") {
    return null;
  }
  return {
    column,
    sortOrder: order
  };
}
function applyColumnSortingToQueryParameters(columnSortingPlugin, queryParameters, colToProp) {
  if (!columnSortingPlugin?.enabled || typeof colToProp !== "function") {
    return;
  }
  const sortConfig = columnSortingPlugin.getSortConfig();
  const first2 = Array.isArray(sortConfig) ? sortConfig[0] : sortConfig;
  if (first2 && typeof first2.column === "number") {
    queryParameters.sort = {
      prop: colToProp(first2.column),
      order: first2.sortOrder
    };
  } else {
    queryParameters.sort = null;
  }
}
function applyColumnSortToQueryFromPlugin(hot, queryParameters) {
  applyColumnSortingToQueryParameters(hot.getPlugin(COLUMN_SORTING_PLUGIN_KEY), queryParameters, (column) => String(hot.colToProp(column)));
}
function normalizeSortInFetchParams(params, hot) {
  params.sort = normalizeSortToQueryFormat(params.sort, (col) => String(hot.colToProp(col)));
}
function sortingPayloadToSort(hot, sortingPayload) {
  const pluginSort = querySortToPluginSort(sortingPayload, (prop) => hot.propToCol(prop));
  return pluginSort && typeof pluginSort === "object" && "column" in pluginSort ? pluginSort : [];
}
function handleBeforeColumnSortForServer(ctx, _currentSortConfig, destinationSortConfigs, sortPossible) {
  const { hot, hasFetchFn, applyQueryParametersFromPlugins: applyQueryParametersFromPlugins2, fetchData } = ctx;
  if (!hasFetchFn() || !sortPossible) {
    return;
  }
  const columnSorting = hot.getPlugin(COLUMN_SORTING_PLUGIN_KEY);
  columnSorting.setSortConfig(destinationSortConfigs);
  applyQueryParametersFromPlugins2();
  void fetchData({
    skipLoading: true
  });
  return false;
}
function isCompleteDataProviderConfig(c) {
  if (!c || typeof c !== "object" || Array.isArray(c)) {
    return false;
  }
  const record = c;
  return Object.keys(SETTINGS_VALIDATORS).every((key) => SETTINGS_VALIDATORS[key](record[key]));
}
function isBareHttpStatusText(s) {
  return typeof s === "string" && /^\d{3}$/.test(s.trim());
}
function pushStringCandidate(candidates, value) {
  if (typeof value === "string") {
    const t = value.trim();
    if (t) {
      candidates.push(t);
    }
  }
}
function collectStringsFromApiPayload(obj, candidates) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return;
  }
  const record = obj;
  pushStringCandidate(candidates, record.message);
  pushStringCandidate(candidates, record.error);
  if (typeof record.detail === "string") {
    pushStringCandidate(candidates, record.detail);
  }
}
function getDataProviderRequestErrorDescription(err) {
  const candidates = [];
  if (err === void 0 || err === null) {
    return "Unknown error";
  }
  if (typeof err === "string") {
    const t = err.trim();
    return t || "Unknown error";
  }
  if (typeof err !== "object") {
    return String(err);
  }
  const errRecord = err;
  const responseData = errRecord.response;
  const nested = responseData?.data ?? errRecord.data ?? errRecord.body;
  if (nested !== void 0 && nested !== null) {
    if (typeof nested === "string") {
      try {
        collectStringsFromApiPayload(JSON.parse(nested), candidates);
      } catch {
        pushStringCandidate(candidates, nested);
      }
    } else {
      collectStringsFromApiPayload(nested, candidates);
    }
  }
  if (typeof errRecord.error === "string") {
    pushStringCandidate(candidates, errRecord.error);
  }
  if (typeof errRecord.message === "string") {
    pushStringCandidate(candidates, errRecord.message);
  }
  const preferred = candidates.find((c) => !isBareHttpStatusText(c));
  if (preferred) {
    return preferred;
  }
  if (candidates.length > 0) {
    return candidates[0];
  }
  return String(err);
}
function clampDataProviderPageToTotalRows(page, pageSize, totalRows) {
  const ps = typeof pageSize === "number" && pageSize >= 1 ? pageSize : DEFAULT_PAGE_SIZE;
  const totalPages = Math.max(1, Math.ceil(totalRows / ps));
  return Math.max(1, Math.min(page, totalPages));
}
function _check_private_redeclaration$T(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$K(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$K(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$K(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$K(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$K(receiver, privateMap, "get");
  return _class_apply_descriptor_get$K(receiver, descriptor);
}
function _class_private_field_init$K(obj, privateMap, value) {
  _check_private_redeclaration$T(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$K(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$K(receiver, privateMap, "set");
  _class_apply_descriptor_set$K(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$B(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$B(obj, privateSet) {
  _check_private_redeclaration$T(obj, privateSet);
  privateSet.add(obj);
}
registerConflict("dataProvider", [
  "manualRowMove",
  "manualColumnMove",
  "trimRows",
  "multiColumnSorting"
]);
var _queryParameters = /* @__PURE__ */ new WeakMap(), _abortController = /* @__PURE__ */ new WeakMap(), _mutationQueue = /* @__PURE__ */ new WeakMap(), _getConfig = /* @__PURE__ */ new WeakSet(), _getRowIdOption = /* @__PURE__ */ new WeakSet(), _getFetchFn = /* @__PURE__ */ new WeakSet(), _getOnRowsCreate = /* @__PURE__ */ new WeakSet(), _getOnRowsUpdate = /* @__PURE__ */ new WeakSet(), _getOnRowsRemove = /* @__PURE__ */ new WeakSet(), _snapshotQueryParameters = /* @__PURE__ */ new WeakSet(), _applyQueryParametersFromPlugins = /* @__PURE__ */ new WeakSet(), _abortInFlightFetch = /* @__PURE__ */ new WeakSet(), _mergeAndNormalizeFetchParams = /* @__PURE__ */ new WeakSet(), _createFetchAbortController = /* @__PURE__ */ new WeakSet(), _runAfterDataProviderFetchAbort = /* @__PURE__ */ new WeakSet(), _resetAbortController = /* @__PURE__ */ new WeakSet(), _enqueueMutation = /* @__PURE__ */ new WeakSet(), _showDataProviderRequestErrorNotification = /* @__PURE__ */ new WeakSet(), _commitRowsUpdate = /* @__PURE__ */ new WeakSet(), _queueCrud = /* @__PURE__ */ new WeakSet(), _onHasExternalDataSource = /* @__PURE__ */ new WeakMap(), _onAfterInit$3 = /* @__PURE__ */ new WeakMap(), _onAfterPageChangeExternalPagination = /* @__PURE__ */ new WeakMap(), _onAfterPageSizeChangeExternalPagination = /* @__PURE__ */ new WeakMap(), _onBeforeFilter$1 = /* @__PURE__ */ new WeakMap(), _onBeforeColumnSort = /* @__PURE__ */ new WeakMap(), _onModifyRowHeader = /* @__PURE__ */ new WeakMap(), _onBeforeUndoStackChange = /* @__PURE__ */ new WeakMap(), _onAfterChangeForServerUpdate = /* @__PURE__ */ new WeakMap(), _onBeforeAlter = /* @__PURE__ */ new WeakMap();
let DataProvider$1 = class DataProvider extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$r;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$r;
  }
  /**
  * Returns the setting keys that trigger a plugin update when changed via `updateSettings`.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$r
    ];
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return DEFAULT_SETTINGS$1;
  }
  /**
  * Returns validator functions for each plugin setting to verify their values are valid before applying them.
  */
  static get SETTINGS_VALIDATORS() {
    return SETTINGS_VALIDATORS;
  }
  /**
  * Check if the plugin is enabled in the handsontable settings.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$r];
  }
  /**
  * Enables the plugin, syncs query parameters from Pagination, ColumnSorting, and Filters, and registers hooks.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_method_get$B(this, _applyQueryParametersFromPlugins, applyQueryParametersFromPlugins).call(this);
    this.addHook("hasExternalDataSource", _class_private_field_get$K(this, _onHasExternalDataSource));
    this.addHook("afterInit", _class_private_field_get$K(this, _onAfterInit$3));
    this.addHook("modifyRowHeader", _class_private_field_get$K(this, _onModifyRowHeader));
    this.addHook("beforeColumnSort", _class_private_field_get$K(this, _onBeforeColumnSort));
    this.addHook("beforeUndoStackChange", _class_private_field_get$K(this, _onBeforeUndoStackChange));
    this.addHook("afterChange", _class_private_field_get$K(this, _onAfterChangeForServerUpdate));
    this.addHook("beforeAlter", _class_private_field_get$K(this, _onBeforeAlter));
    this.addHook("afterPageChange", _class_private_field_get$K(this, _onAfterPageChangeExternalPagination));
    this.addHook("afterPageSizeChange", _class_private_field_get$K(this, _onAfterPageSizeChangeExternalPagination));
    this.addHook("beforeFilter", _class_private_field_get$K(this, _onBeforeFilter$1));
    super.enablePlugin();
  }
  /**
  * Re-applies settings and refetches when the instance is already initialized.
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    if (this.hot.view) {
      void this.fetchData();
    }
    super.updatePlugin();
  }
  /**
  * Disables the plugin, aborts fetch, resets query state.
  * Hook listeners registered with `addHook` are removed by `super.disablePlugin()` via `clearHooks()`.
  * The constructor registers [[Hooks#hasExternalDataSource]] for the period before the first `enablePlugin()`;
  * `enablePlugin()` registers it again so it survives each `updatePlugin()` cycle.
  */
  disablePlugin() {
    _class_private_method_get$B(this, _resetAbortController, resetAbortController).call(this);
    _class_private_field_set$K(this, _queryParameters, {
      ...INITIAL_QUERY_PARAMETERS
    });
    super.disablePlugin();
  }
  /**
  * @returns {DataProviderQueryParameters} Copy of current query parameters (`sort` and `filters` are cloned when non-null).
  */
  getQueryParameters() {
    return _class_private_method_get$B(this, _snapshotQueryParameters, snapshotQueryParameters).call(this, _class_private_field_get$K(this, _queryParameters));
  }
  /**
  * @param {number} visualRow Visual row index.
  * @returns {*} Row id from `rowId` option, or undefined.
  */
  getRowId(visualRow) {
    return getRowIdByVisualRow(this.hot, _class_private_method_get$B(this, _getRowIdOption, getRowIdOption).call(this), visualRow);
  }
  /**
  * Fetches rows from `fetchRows` with current or overridden query parameters.
  *
  * @param {object} [overrides] Partial query overrides (e.g. `{ page: 2 }`, `{ pageSize: 20, page: 1 }`, `{ sort }`, `{ filters }`).
  * Pass `{ skipLoading: true }` to mark internal refetches (for example sort or CRUD); [[Hooks#beforeDataProviderFetch]] receives it, and it is not passed to `fetchRows`.
  * Numeric `page` is clamped to at least 1.
  * When the response `totalRows` implies fewer pages than the requested `page`, fetches again at the last valid page without applying the out-of-range result (avoids redundant `afterPageChange` loads and aborted duplicate requests after row removal on the last page).
  * @returns {Promise<{ rows: Array<*>, totalRows: number }|null>}
  *
  * @fires Hooks#afterDataProviderFetch when data loads.
  * @fires Hooks#afterDataProviderFetchError when `fetchRows` throws a non-abort error.
  * @fires Hooks#afterDataProviderFetchAbort when the request is superseded, aborted, or ends with `AbortError`.
  */
  async fetchData(overrides = {}) {
    const fetchFn = _class_private_method_get$B(this, _getFetchFn, getFetchFn).call(this);
    if (!isFunction$1(fetchFn)) {
      this.hot.render();
      return null;
    }
    const params = _class_private_method_get$B(this, _mergeAndNormalizeFetchParams, mergeAndNormalizeFetchParams).call(this, overrides);
    const controller = _class_private_method_get$B(this, _createFetchAbortController, createFetchAbortController).call(this);
    const { signal } = controller;
    if (this.hot.runHooks("beforeDataProviderFetch", params) === false) {
      _class_private_field_set$K(this, _abortController, null);
      this.hot.render();
      return null;
    }
    const fetchRowsParams = _class_private_method_get$B(this, _snapshotQueryParameters, snapshotQueryParameters).call(this, params);
    try {
      const result = await fetchFn(fetchRowsParams, {
        signal
      });
      if (signal.aborted) {
        _class_private_method_get$B(this, _runAfterDataProviderFetchAbort, runAfterDataProviderFetchAbort).call(this, params, void 0);
        return null;
      }
      const rows = Array.isArray(result?.rows) ? result.rows : [];
      const totalRows = typeof result?.totalRows === "number" && result.totalRows >= 0 ? result.totalRows : rows.length;
      const persistedParams = _class_private_method_get$B(this, _snapshotQueryParameters, snapshotQueryParameters).call(this, params);
      const clampedPage = clampDataProviderPageToTotalRows(persistedParams.page, persistedParams.pageSize, totalRows);
      if (clampedPage !== persistedParams.page) {
        return this.fetchData({
          ...overrides,
          page: clampedPage,
          skipLoading: overrides.skipLoading
        });
      }
      _class_private_field_set$K(this, _queryParameters, persistedParams);
      this.hot.loadData(rows, PLUGIN_KEY$r);
      const columnSortConfig = sortingPayloadToSort(this.hot, persistedParams.sort ?? null);
      const filtersConditionsStack = filtersPayloadToConditionsStack(this.hot, persistedParams.filters ?? null);
      this.hot.runHooks("afterDataProviderFetch", {
        ...result,
        rows,
        totalRows,
        queryParameters: persistedParams,
        columnSortConfig,
        filtersConditionsStack
      });
      this.hot.render();
      return {
        rows,
        totalRows
      };
    } catch (err) {
      if (signal.aborted || err instanceof Error && err.name === "AbortError") {
        _class_private_method_get$B(this, _runAfterDataProviderFetchAbort, runAfterDataProviderFetchAbort).call(this, params, err);
        return null;
      }
      this.hot.runHooks("afterDataProviderFetchError", err, _class_private_method_get$B(this, _snapshotQueryParameters, snapshotQueryParameters).call(this, params));
      _class_private_method_get$B(this, _showDataProviderRequestErrorNotification, showDataProviderRequestErrorNotification).call(this, "fetch", err);
      throw err;
    } finally {
      if (_class_private_field_get$K(this, _abortController) === controller) {
        _class_private_field_set$K(this, _abortController, null);
      }
    }
  }
  /**
  * Server create via `onRowsCreate`. Use `rowsAmount` to insert more than one row in one call.
  *
  * @param {object} [options] `position`, `referenceRowId`, `rowsAmount`.
  * @returns {Promise<void>}
  */
  async createRows(options = {}) {
    const onRowsCreate = _class_private_method_get$B(this, _getOnRowsCreate, getOnRowsCreate).call(this);
    if (!isFunction$1(onRowsCreate)) {
      return;
    }
    const rowsCreatePayload = {
      position: options.position ?? "below",
      referenceRowId: options.referenceRowId,
      rowsAmount: options.rowsAmount ?? 1
    };
    const payload = {
      rowsCreate: rowsCreatePayload
    };
    return _class_private_method_get$B(this, _queueCrud, queueCrud1).call(this, "create", payload, () => Promise.resolve(onRowsCreate(rowsCreatePayload)), async () => {
      await this.fetchData({
        skipLoading: true
      });
    });
  }
  /**
  * Server remove via `onRowsRemove`. Pass one row id or an array of ids.
  *
  * After a successful `onRowsRemove`, refetches from the server. When the remove clears every row currently
  * loaded (typical when emptying the last page) and the current page is greater than 1, loads the previous page
  * in one request. Otherwise refetches the current page, then loads the previous page when that response is empty
  * and the current page is still greater than 1.
  *
  * @param {Array<*>|*} rowIds Row id or ids.
  * @returns {Promise<void>}
  * @throws {Error} When any id is `null` or `undefined`.
  */
  async removeRows(rowIds) {
    const onRowsRemove = _class_private_method_get$B(this, _getOnRowsRemove, getOnRowsRemove).call(this);
    if (!isFunction$1(onRowsRemove)) {
      return;
    }
    const ids = Array.isArray(rowIds) ? rowIds : [
      rowIds
    ];
    ids.forEach((id) => {
      if (isMissingRowId(id)) {
        throwWithCause(DATA_PROVIDER_ERROR_REMOVE_ROWS_MISSING_ID);
      }
    });
    const payload = {
      rowsRemove: ids
    };
    return _class_private_method_get$B(this, _queueCrud, queueCrud1).call(this, "remove", payload, () => onRowsRemove(ids), async () => {
      const pageBeforeFetch = _class_private_field_get$K(this, _queryParameters).page;
      const rowsLoaded = this.hot.countRows();
      const removesEveryLoadedRow = ids.length >= rowsLoaded && rowsLoaded >= 1;
      if (removesEveryLoadedRow && pageBeforeFetch > 1) {
        await this.fetchData({
          page: pageBeforeFetch - 1,
          skipLoading: true
        });
        return;
      }
      const result = await this.fetchData({
        skipLoading: true
      });
      if (result?.rows.length === 0 && pageBeforeFetch > 1) {
        await this.fetchData({
          page: pageBeforeFetch - 1,
          skipLoading: true
        });
      }
    });
  }
  /**
  * Server update via `onRowsUpdate`. Pass an array of `{ id, changes, rowData? }` (same shape as `onRowsUpdate`).
  *
  * @param {object[]} rows Row update payloads (one or more).
  * @returns {Promise<void>}
  * @throws {Error} When any payload omits `id` or `id` is `null`.
  */
  async updateRows(rows) {
    if (!isFunction$1(_class_private_method_get$B(this, _getOnRowsUpdate, getOnRowsUpdate).call(this)) || !Array.isArray(rows) || rows.length === 0) {
      return;
    }
    rows.forEach((p) => {
      if (isMissingRowId(p.id)) {
        throwWithCause(DATA_PROVIDER_ERROR_UPDATE_ROWS_MISSING_ID);
      }
    });
    const rowPayloads = buildManualUpdateRowPayloads(this.hot, _class_private_method_get$B(this, _getRowIdOption, getRowIdOption).call(this), rows);
    return _class_private_method_get$B(this, _enqueueMutation, enqueueMutation1).call(this, () => runManualUpdateRowsMutation(this.hot, {
      getRowIdOption: () => _class_private_method_get$B(this, _getRowIdOption, getRowIdOption).call(this),
      commitRowsUpdate: (payloads) => _class_private_method_get$B(this, _commitRowsUpdate, commitRowsUpdate).call(this, payloads)
    }, rowPayloads));
  }
  /**
  * Destroys the plugin.
  */
  destroy() {
    _class_private_method_get$B(this, _resetAbortController, resetAbortController).call(this);
    super.destroy();
  }
  /**
  * @param {object} hotInstance Handsontable instance.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$B(this, _getConfig), _class_private_method_init$B(this, _getRowIdOption), _class_private_method_init$B(this, _getFetchFn), _class_private_method_init$B(this, _getOnRowsCreate), _class_private_method_init$B(this, _getOnRowsUpdate), _class_private_method_init$B(this, _getOnRowsRemove), _class_private_method_init$B(this, _snapshotQueryParameters), _class_private_method_init$B(this, _applyQueryParametersFromPlugins), _class_private_method_init$B(this, _abortInFlightFetch), _class_private_method_init$B(this, _mergeAndNormalizeFetchParams), _class_private_method_init$B(this, _createFetchAbortController), _class_private_method_init$B(this, _runAfterDataProviderFetchAbort), _class_private_method_init$B(this, _resetAbortController), _class_private_method_init$B(this, _enqueueMutation), _class_private_method_init$B(this, _showDataProviderRequestErrorNotification), _class_private_method_init$B(this, _commitRowsUpdate), _class_private_method_init$B(this, _queueCrud), _class_private_field_init$K(this, _queryParameters, {
      writable: true,
      value: void 0
    }), _class_private_field_init$K(this, _abortController, {
      writable: true,
      value: void 0
    }), /**
    * Serializes create/update/remove mutations so they run one after another.
    *
    * @type {{ tail: Promise<void> }}
    */
    _class_private_field_init$K(this, _mutationQueue, {
      writable: true,
      value: void 0
    }), /**
    * Default handler for [[Hooks#hasExternalDataSource]]: `true` when this instance has a complete server-backed
    * `dataProvider` configuration. Registered in the constructor (early lifecycle) and in `enablePlugin()` after each
    * `disablePlugin()` clears `addHook` listeners.
    *
    * @returns {boolean}
    */
    _class_private_field_init$K(this, _onHasExternalDataSource, {
      writable: true,
      value: void 0
    }), /**
    * @returns {void}
    */
    _class_private_field_init$K(this, _onAfterInit$3, {
      writable: true,
      value: void 0
    }), /**
    * Loads the requested page when Pagination runs in external paged mode.
    * Skips when `#queryParameters` already matches the Pagination UI (e.g. right after a successful fetch).
    *
    * @param {number} oldPage Previous 1-based page.
    * @param {number} newPage New 1-based page.
    * @returns {void}
    */
    _class_private_field_init$K(this, _onAfterPageChangeExternalPagination, {
      writable: true,
      value: void 0
    }), /**
    * Loads page 1 with the new page size when Pagination runs in external paged mode.
    * Skips when `#queryParameters` already match (e.g. duplicate `afterPageSizeChange` from Pagination sync).
    *
    * @param {number | 'auto'} oldPageSize Previous page size.
    * @param {number | 'auto'} newPageSize New page size.
    * @returns {void}
    */
    _class_private_field_init$K(this, _onAfterPageSizeChangeExternalPagination, {
      writable: true,
      value: void 0
    }), /**
    * Intercepts filter action when `fetchRows` is set: applies server-side filters and refetches; returns false so Filters skip client-side trimming.
    * Without `fetchRows`, returns nothing so Filters run client-side trimming (same guard pattern as [[#onBeforeColumnSort]]).
    *
    * @param {Array} conditionsStack Exported filter conditions (column = physical index).
    * @returns {boolean|void} False when filtering is handled server-side.
    */
    _class_private_field_init$K(this, _onBeforeFilter$1, {
      writable: true,
      value: void 0
    }), /**
    * @param {Array} currentSortConfig Current sort config.
    * @param {Array} destinationSortConfigs Destination sort config.
    * @param {boolean} sortPossible Whether sort is allowed.
    * @returns {boolean|undefined}
    */
    _class_private_field_init$K(this, _onBeforeColumnSort, {
      writable: true,
      value: void 0
    }), /**
    * @param {number} visualRowIndex Visual row index.
    * @returns {number} Global row index for headers.
    */
    _class_private_field_init$K(this, _onModifyRowHeader, {
      writable: true,
      value: void 0
    }), /**
    * Skips the local undo stack for edits that batch to `onRowsUpdate` (same sources as `shouldIgnoreAfterChangeForServerUpdate`).
    *
    * @param {Array} doneActionsCopy Snapshot of the undo stack before the new action.
    * @param {string} [source] Change source for the action being pushed onto the stack.
    * @returns {boolean|void} Return `false` to block stacking (see [[Hooks#beforeUndoStackChange]]).
    */
    _class_private_field_init$K(this, _onBeforeUndoStackChange, {
      writable: true,
      value: void 0
    }), /**
    * After a valid edit applies locally, queues `onRowsUpdate`. On failure, cells revert to previous values.
    *
    * @param {Array} changes `[visualRow, prop, oldVal, newVal][]`.
    * @param {string} [source] Change source.
    * @returns {void}
    */
    _class_private_field_init$K(this, _onAfterChangeForServerUpdate, {
      writable: true,
      value: void 0
    }), /**
    * @param {string} action Alter action name.
    * @param {number|Array} index Row index or index groups.
    * @param {number} amount Row count.
    * @returns {boolean|undefined}
    */
    _class_private_field_init$K(this, _onBeforeAlter, {
      writable: true,
      value: void 0
    }), _class_private_field_set$K(this, _queryParameters, {
      ...INITIAL_QUERY_PARAMETERS
    }), _class_private_field_set$K(this, _abortController, null), _class_private_field_set$K(this, _mutationQueue, {
      tail: Promise.resolve()
    }), _class_private_field_set$K(this, _onHasExternalDataSource, () => isCompleteDataProviderConfig(this.hot.getSettings().dataProvider)), _class_private_field_set$K(this, _onAfterInit$3, () => {
      void this.fetchData();
    }), _class_private_field_set$K(this, _onAfterPageChangeExternalPagination, (oldPage, newPage) => {
      handleAfterPageChangeExternalPagination({
        hot: this.hot,
        getQueryPage: () => _class_private_field_get$K(this, _queryParameters).page,
        goToPage: async (page) => {
          await this.fetchData({
            page
          });
        }
      }, oldPage, newPage);
    }), _class_private_field_set$K(this, _onAfterPageSizeChangeExternalPagination, (oldPageSize, newPageSize) => {
      handleAfterPageSizeChangeExternalPagination({
        hot: this.hot,
        getQueryPage: () => _class_private_field_get$K(this, _queryParameters).page,
        getQueryPageSize: () => _class_private_field_get$K(this, _queryParameters).pageSize,
        setPageSize: async (pageSize) => {
          await this.fetchData({
            pageSize,
            page: 1
          });
        }
      }, oldPageSize, newPageSize);
    }), _class_private_field_set$K(this, _onBeforeFilter$1, (conditionsStack) => handleBeforeFilterForServer({
      hot: this.hot,
      hasFetchFn: () => isFunction$1(_class_private_method_get$B(this, _getFetchFn, getFetchFn).call(this)),
      applyFiltersAndRefetch: (filtersForProvider) => {
        _class_private_field_get$K(this, _queryParameters).filters = filtersForProvider ?? null;
        _class_private_field_get$K(this, _queryParameters).page = 1;
        void this.fetchData();
      }
    }, conditionsStack)), _class_private_field_set$K(this, _onBeforeColumnSort, (currentSortConfig, destinationSortConfigs, sortPossible) => handleBeforeColumnSortForServer({
      hot: this.hot,
      hasFetchFn: () => isFunction$1(_class_private_method_get$B(this, _getFetchFn, getFetchFn).call(this)),
      applyQueryParametersFromPlugins: () => _class_private_method_get$B(this, _applyQueryParametersFromPlugins, applyQueryParametersFromPlugins).call(this),
      fetchData: (overrides) => this.fetchData(overrides)
    }, currentSortConfig, destinationSortConfigs, sortPossible)), _class_private_field_set$K(this, _onModifyRowHeader, (visualRowIndex) => getPagedRowHeaderIndex(_class_private_field_get$K(this, _queryParameters), visualRowIndex)), _class_private_field_set$K(this, _onBeforeUndoStackChange, (doneActionsCopy, source) => {
      if (!isFunction$1(_class_private_method_get$B(this, _getOnRowsUpdate, getOnRowsUpdate).call(this))) {
        return;
      }
      if (!DATA_PROVIDER_BATCH_UPDATE_SOURCES.has(source)) {
        return;
      }
      return false;
    }), _class_private_field_set$K(this, _onAfterChangeForServerUpdate, (changes, source) => {
      if (shouldIgnoreAfterChangeForServerUpdate(isFunction$1(_class_private_method_get$B(this, _getOnRowsUpdate, getOnRowsUpdate).call(this)), changes, source)) {
        return;
      }
      const valid = filterChangesForBatchedServerUpdate(this.hot, changes);
      if (valid.length === 0) {
        return;
      }
      void _class_private_method_get$B(this, _enqueueMutation, enqueueMutation1).call(this, () => runUpdateFromChanges(this.hot, {
        getRowIdOption: () => _class_private_method_get$B(this, _getRowIdOption, getRowIdOption).call(this),
        commitRowsUpdate: (payloads, opts) => _class_private_method_get$B(this, _commitRowsUpdate, commitRowsUpdate).call(this, payloads, opts)
      }, valid));
    }), _class_private_field_set$K(this, _onBeforeAlter, (action, index2, amount) => handleBeforeAlterForCrud({
      hot: this.hot,
      getOnRowsCreate: () => _class_private_method_get$B(this, _getOnRowsCreate, getOnRowsCreate).call(this),
      getOnRowsRemove: () => _class_private_method_get$B(this, _getOnRowsRemove, getOnRowsRemove).call(this),
      getRowIdOption: () => _class_private_method_get$B(this, _getRowIdOption, getRowIdOption).call(this),
      getRowId: (vr) => this.getRowId(vr),
      createRows: (opts) => this.createRows(opts),
      removeRows: (ids) => this.removeRows(ids)
    }, action, index2, amount));
    this.addHook("hasExternalDataSource", _class_private_field_get$K(this, _onHasExternalDataSource));
  }
};
function getConfig() {
  const c = this.hot.getSettings()[PLUGIN_KEY$r];
  return c && typeof c === "object" ? c : void 0;
}
function getRowIdOption() {
  const c = _class_private_method_get$B(this, _getConfig, getConfig).call(this);
  return c ? c.rowId : void 0;
}
function getFetchFn() {
  const c = _class_private_method_get$B(this, _getConfig, getConfig).call(this);
  return c && isFunction$1(c.fetchRows) ? c.fetchRows : void 0;
}
function getOnRowsCreate() {
  const c = _class_private_method_get$B(this, _getConfig, getConfig).call(this);
  return c && isFunction$1(c.onRowsCreate) ? c.onRowsCreate : void 0;
}
function getOnRowsUpdate() {
  const c = _class_private_method_get$B(this, _getConfig, getConfig).call(this);
  return c && isFunction$1(c.onRowsUpdate) ? c.onRowsUpdate : void 0;
}
function getOnRowsRemove() {
  const c = _class_private_method_get$B(this, _getConfig, getConfig).call(this);
  return c && isFunction$1(c.onRowsRemove) ? c.onRowsRemove : void 0;
}
function snapshotQueryParameters(p) {
  return {
    page: p.page,
    pageSize: p.pageSize,
    sort: p.sort === null ? null : {
      ...p.sort
    },
    filters: cloneDataProviderFiltersPayload(p.filters)
  };
}
function applyQueryParametersFromPlugins() {
  applyPaginationToQueryFromPlugin(this.hot, _class_private_field_get$K(this, _queryParameters));
  applyColumnSortToQueryFromPlugin(this.hot, _class_private_field_get$K(this, _queryParameters));
  applyFiltersFromFiltersPluginToQueryParameters(this.hot, _class_private_field_get$K(this, _queryParameters), () => _class_private_method_get$B(this, _getFetchFn, getFetchFn).call(this));
}
function abortInFlightFetch() {
  if (!_class_private_field_get$K(this, _abortController)) {
    return;
  }
  const reason = new Error(ABORT_REASON_MESSAGE);
  reason.name = "AbortError";
  _class_private_field_get$K(this, _abortController).abort(reason);
}
function mergeAndNormalizeFetchParams(overrides) {
  const params = {
    ..._class_private_field_get$K(this, _queryParameters),
    ...overrides
  };
  normalizeSortInFetchParams(params, this.hot);
  if (typeof params.page === "number" && !Number.isNaN(params.page)) {
    params.page = Math.max(1, params.page);
  }
  return params;
}
function createFetchAbortController() {
  _class_private_method_get$B(this, _abortInFlightFetch, abortInFlightFetch).call(this);
  const controller = new AbortController();
  _class_private_field_set$K(this, _abortController, controller);
  return controller;
}
function runAfterDataProviderFetchAbort(params, reason) {
  const queryParameters = _class_private_method_get$B(this, _snapshotQueryParameters, snapshotQueryParameters).call(this, params);
  this.hot.runHooks("afterDataProviderFetchAbort", queryParameters, reason);
}
function resetAbortController() {
  _class_private_field_get$K(this, _abortController)?.abort();
  _class_private_field_set$K(this, _abortController, null);
}
function enqueueMutation1(fn) {
  return enqueueMutation(_class_private_field_get$K(this, _mutationQueue), fn);
}
function showDataProviderRequestErrorNotification(kind, err) {
  const notificationPlugin = this.hot.getPlugin("notification");
  if (!notificationPlugin?.enabled) {
    return;
  }
  const titleKeys = {
    fetch: DATA_PROVIDER_ERRORS_FETCH,
    create: DATA_PROVIDER_ERRORS_CREATE,
    update: DATA_PROVIDER_ERRORS_UPDATE,
    remove: DATA_PROVIDER_ERRORS_REMOVE
  };
  const title = this.hot.getTranslatedPhrase(titleKeys[kind] ?? DATA_PROVIDER_ERRORS_REQUEST_FAILED);
  const message = getDataProviderRequestErrorDescription(err);
  let toastId = "";
  const options = {
    variant: "error",
    title,
    message
  };
  if (kind === "fetch") {
    options.duration = 0;
    options.actions = [
      {
        label: this.hot.getTranslatedPhrase(DATA_PROVIDER_BUTTONS_REFETCH),
        type: "primary",
        callback: () => {
          if (toastId) {
            notificationPlugin.hide(toastId);
          }
          void this.fetchData();
        }
      }
    ];
  }
  toastId = notificationPlugin.showMessage(options);
}
function commitRowsUpdate(rowPayloads, options = {}) {
  return commitRowsUpdate$1(this.hot, {
    getOnRowsUpdate: () => _class_private_method_get$B(this, _getOnRowsUpdate, getOnRowsUpdate).call(this),
    fetchData: () => this.fetchData({
      skipLoading: true
    }),
    logError: error,
    onRequestFailed: (kind, err) => _class_private_method_get$B(this, _showDataProviderRequestErrorNotification, showDataProviderRequestErrorNotification).call(this, kind, err)
  }, rowPayloads, options);
}
function queueCrud1(operation, payload, userPromiseFn, onSuccess) {
  return queueCrud({
    enqueueMutation: (fn) => _class_private_method_get$B(this, _enqueueMutation, enqueueMutation1).call(this, fn),
    runBeforeRowsMutation: (op, p) => runBeforeRowsMutation(this.hot, op, p),
    runAfterRowsMutation: (op, p) => runAfterRowsMutation(this.hot, op, p),
    runAfterRowsMutationError: (op, err, p) => runAfterRowsMutationError(this.hot, op, err, p),
    logError: error,
    onRequestFailed: (kind, err) => _class_private_method_get$B(this, _showDataProviderRequestErrorNotification, showDataProviderRequestErrorNotification).call(this, kind, err)
  }, operation, payload, userPromiseFn, onSuccess);
}
function calculateInterval(distance, intervalRange, rampDistance, logScale = 200) {
  const clampedDistance = Math.min(Math.abs(distance), rampDistance);
  const ratio = clampedDistance / rampDistance;
  const range = intervalRange.max - intervalRange.min;
  return Math.round(intervalRange.max - Math.log(1 + ratio * logScale) / Math.log(1 + logScale) * range);
}
function _check_private_redeclaration$S(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$J(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$J(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$J(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$J(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$J(receiver, privateMap, "get");
  return _class_apply_descriptor_get$J(receiver, descriptor);
}
function _class_private_field_init$J(obj, privateMap, value) {
  _check_private_redeclaration$S(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$J(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$J(receiver, privateMap, "set");
  _class_apply_descriptor_set$J(receiver, descriptor, value);
  return value;
}
var _timerId = /* @__PURE__ */ new WeakMap(), _distance = /* @__PURE__ */ new WeakMap(), _settings = /* @__PURE__ */ new WeakMap(), _registerTimeout = /* @__PURE__ */ new WeakMap(), _tick = /* @__PURE__ */ new WeakMap();
class ScrollTimer {
  /**
  * Whether the timer is currently active.
  *
  * @type {boolean}
  */
  get isActive() {
    return _class_private_field_get$J(this, _timerId) !== null;
  }
  /**
  * Configures the scroll timing settings.
  *
  * @param {object} settings Timer settings.
  * @param {object} settings.intervalRange Interval range in ms.
  * @param {number} settings.intervalRange.min Minimum interval in ms.
  * @param {number} settings.intervalRange.max Maximum interval in ms.
  * @param {number} settings.rampDistance Distance at which interval reaches minimum.
  */
  configure(settings) {
    _class_private_field_set$J(this, _settings, settings);
  }
  /**
  * Updates the timer state. Starts or stops based on distance value.
  *
  * @param {number} distance Distance from viewport edge (0 = inside viewport, N > 0 = outside viewport).
  */
  update(distance) {
    _class_private_field_set$J(this, _distance, distance);
    if (distance === 0) {
      this.stop();
    } else if (!this.isActive) {
      _class_private_field_get$J(this, _tick).call(this);
    }
  }
  /**
  * Stops the timer.
  */
  stop() {
    if (_class_private_field_get$J(this, _timerId) !== null) {
      clearTimeout(_class_private_field_get$J(this, _timerId));
      _class_private_field_set$J(this, _timerId, null);
    }
    _class_private_field_set$J(this, _distance, 0);
  }
  /**
  * @param {Function} registerTimeout Timeout registration function for cleanup tracking.
  */
  constructor(registerTimeout) {
    _class_private_field_init$J(this, _timerId, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$J(this, _distance, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$J(this, _settings, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$J(this, _registerTimeout, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$J(this, _tick, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$J(this, _timerId, null);
    _class_private_field_set$J(this, _distance, 0);
    _class_private_field_set$J(this, _settings, null);
    _class_private_field_set$J(this, _tick, () => {
      this.runLocalHooks("tick", _class_private_field_get$J(this, _distance));
      if (_class_private_field_get$J(this, _distance) === 0) {
        return;
      }
      const interval = calculateInterval(_class_private_field_get$J(this, _distance), _class_private_field_get$J(this, _settings).intervalRange, _class_private_field_get$J(this, _settings).rampDistance);
      _class_private_field_set$J(this, _timerId, _class_private_field_get$J(this, _registerTimeout).call(this, _class_private_field_get$J(this, _tick), interval));
    });
    _class_private_field_set$J(this, _registerTimeout, registerTimeout);
  }
}
mixin(ScrollTimer, localHooks);
function _check_private_redeclaration$R(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$I(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$I(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$I(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$I(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$I(receiver, privateMap, "get");
  return _class_apply_descriptor_get$I(receiver, descriptor);
}
function _class_private_field_init$I(obj, privateMap, value) {
  _check_private_redeclaration$R(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$I(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$I(receiver, privateMap, "set");
  _class_apply_descriptor_set$I(receiver, descriptor, value);
  return value;
}
var _horizontal = /* @__PURE__ */ new WeakMap(), _vertical = /* @__PURE__ */ new WeakMap();
class AutoScroller {
  /**
  * Whether any axis is currently scrolling.
  *
  * @type {boolean}
  */
  get isActive() {
    return _class_private_field_get$I(this, _horizontal).isActive || _class_private_field_get$I(this, _vertical).isActive;
  }
  /**
  * Whether the horizontal axis is currently scrolling.
  *
  * @type {boolean}
  */
  get isHorizontalActive() {
    return _class_private_field_get$I(this, _horizontal).isActive;
  }
  /**
  * Whether the vertical axis is currently scrolling.
  *
  * @type {boolean}
  */
  get isVerticalActive() {
    return _class_private_field_get$I(this, _vertical).isActive;
  }
  /**
  * Configures scroll timing settings for both axes.
  *
  * @param {object} settings Scroll settings.
  * @param {object} settings.intervalRange Interval range in milliseconds.
  * @param {object} settings.intervalRange.min Minimum interval in milliseconds.
  * @param {object} settings.intervalRange.max Maximum interval in milliseconds.
  * @param {number} settings.rampDistance Distance at which interval reaches minimum.
  */
  configure(settings) {
    _class_private_field_get$I(this, _horizontal).configure(settings);
    _class_private_field_get$I(this, _vertical).configure(settings);
  }
  /**
  * Updates scroll state based on cursor overflow from viewport boundaries.
  *
  * @param {{ x: number, y: number }} overflow Distance past viewport edges (0 = inside, N >0 || N < 0 = pixels outside).
  */
  update({ x, y }) {
    _class_private_field_get$I(this, _horizontal).update(x);
    _class_private_field_get$I(this, _vertical).update(y);
  }
  /**
  * Stops all scrolling.
  */
  stop() {
    _class_private_field_get$I(this, _horizontal).stop();
    _class_private_field_get$I(this, _vertical).stop();
  }
  /**
  * Stops the horizontal axis scrolling only.
  */
  stopHorizontal() {
    _class_private_field_get$I(this, _horizontal).stop();
  }
  /**
  * Stops the vertical axis scrolling only.
  */
  stopVertical() {
    _class_private_field_get$I(this, _vertical).stop();
  }
  /**
  * Destroys the scroll looper.
  */
  destroy() {
    this.stop();
    _class_private_field_set$I(this, _horizontal, null);
    _class_private_field_set$I(this, _vertical, null);
  }
  /**
  * @param {Function} registerTimeout Timeout registration function (typically `hot._registerTimeout`).
  */
  constructor(registerTimeout) {
    _class_private_field_init$I(this, _horizontal, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$I(this, _vertical, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$I(this, _horizontal, new ScrollTimer(registerTimeout));
    _class_private_field_set$I(this, _vertical, new ScrollTimer(registerTimeout));
    _class_private_field_get$I(this, _horizontal).addLocalHook("tick", (distance) => this.runLocalHooks("scrollHorizontal", distance));
    _class_private_field_get$I(this, _vertical).addLocalHook("tick", (distance) => this.runLocalHooks("scrollVertical", distance));
  }
}
mixin(AutoScroller, localHooks);
function _check_private_redeclaration$Q(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$H(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$H(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$H(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$H(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$H(receiver, privateMap, "get");
  return _class_apply_descriptor_get$H(receiver, descriptor);
}
function _class_private_field_init$H(obj, privateMap, value) {
  _check_private_redeclaration$Q(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$H(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$H(receiver, privateMap, "set");
  _class_apply_descriptor_set$H(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$A(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$A(obj, privateSet) {
  _check_private_redeclaration$Q(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$q = "dragToScroll";
const PLUGIN_PRIORITY$q = 100;
var _autoScroller = /* @__PURE__ */ new WeakMap(), _isOutsideViewport = /* @__PURE__ */ new WeakMap(), _activeDragKind = /* @__PURE__ */ new WeakMap(), _lastClientX = /* @__PURE__ */ new WeakMap(), _lastClientY = /* @__PURE__ */ new WeakMap(), _mouseDownController = /* @__PURE__ */ new WeakMap(), _setupListening = /* @__PURE__ */ new WeakSet(), _scrollHorizontal = /* @__PURE__ */ new WeakSet(), _scrollVertical = /* @__PURE__ */ new WeakSet(), _onAfterSelection = /* @__PURE__ */ new WeakMap(), _onMouseMove$4 = /* @__PURE__ */ new WeakSet(), _onAfterScroll = /* @__PURE__ */ new WeakMap();
class DragToScroll extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$q;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$q;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      interval: {
        min: 20,
        max: 500
      },
      rampDistance: 120
    };
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link DragToScroll#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$q];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_get$H(this, _autoScroller).configure({
      intervalRange: this.getSetting("interval"),
      rampDistance: this.getSetting("rampDistance")
    });
    this.addHook("beforeOnCellMouseDown", (event, _coords, _TD, controller) => {
      const typedController = typeof controller === "object" && controller !== null ? controller : null;
      _class_private_method_get$A(this, _setupListening, setupListening).call(this, "cell", event, typedController);
    });
    this.addHook("afterOnCellCornerMouseDown", (event) => _class_private_method_get$A(this, _setupListening, setupListening).call(this, "corner", event));
    this.addHook("afterSelection", _class_private_field_get$H(this, _onAfterSelection));
    this.addHook("afterScroll", _class_private_field_get$H(this, _onAfterScroll));
    this.registerEvents();
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`dragToScroll`](@/api/options.md#dragtoscroll)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    _class_private_field_get$H(this, _autoScroller).stop();
    this.unregisterEvents();
    super.disablePlugin();
  }
  /**
  * Sets the boundaries/dimensions of the scrollable viewport.
  *
  * @param {DOMRect|{left: number, right: number, top: number, bottom: number}} [boundaries] An object with
  * coordinates. Contains the window boundaries by default. The object is compatible with DOMRect.
  */
  setBoundaries(boundaries = {
    left: 0,
    right: this.hot.rootWindow.innerWidth,
    top: 0,
    bottom: this.hot.rootWindow.innerHeight
  }) {
    this.boundaries = boundaries;
  }
  /**
  * Changes callback function.
  *
  * @param {Function} callback The callback function.
  */
  setCallback(callback) {
    this.callback = callback;
  }
  /**
  * Checks if the mouse position (X, Y) is outside the viewport and fires a callback with calculated X an Y diffs
  * between passed boundaries.
  *
  * @param {number} x Mouse X coordinate to check.
  * @param {number} y Mouse Y coordinate to check.
  */
  check(x, y) {
    let diffX = 0;
    let diffY = 0;
    const { boundaries } = this;
    if (boundaries) {
      if (y < boundaries.top) {
        diffY = y - boundaries.top;
      } else if (y > boundaries.bottom) {
        diffY = y - boundaries.bottom;
      }
      if (x < boundaries.left) {
        diffX = x - boundaries.left;
      } else if (x > boundaries.right) {
        diffX = x - boundaries.right;
      }
    }
    _class_private_field_set$H(this, _isOutsideViewport, diffY !== 0 || diffX !== 0);
    if (this.callback) {
      this.callback(diffX, diffY);
    }
  }
  /**
  * Enables listening on `mousemove` event.
  *
  * @private
  */
  listen() {
    this.listening = true;
  }
  /**
  * Disables listening on `mousemove` event.
  *
  * @private
  */
  unlisten() {
    this.listening = false;
    _class_private_field_set$H(this, _activeDragKind, null);
    _class_private_field_set$H(this, _lastClientX, null);
    _class_private_field_set$H(this, _lastClientY, null);
    _class_private_field_set$H(this, _isOutsideViewport, false);
    _class_private_field_set$H(this, _mouseDownController, null);
    _class_private_field_get$H(this, _autoScroller).stop();
  }
  /**
  * Returns current state of listening.
  *
  * @private
  * @returns {boolean}
  */
  isListening() {
    return this.listening;
  }
  /**
  * Registers dom listeners.
  *
  * @private
  */
  registerEvents() {
    const { rootWindow } = this.hot;
    let frame = rootWindow;
    while (frame) {
      this.eventManager.addEventListener(frame.document, "contextmenu", () => this.unlisten());
      this.eventManager.addEventListener(frame.document, "mouseup", () => this.unlisten());
      this.eventManager.addEventListener(frame.document, "mousemove", (event) => {
        _class_private_method_get$A(this, _onMouseMove$4, onMouseMove$4).call(this, event);
      });
      frame = getParentWindow(frame);
    }
  }
  /**
  * Unbinds the events used by the plugin.
  *
  * @private
  */
  unregisterEvents() {
    this.eventManager.clear();
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$H(this, _autoScroller).destroy();
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$A(this, _setupListening), _class_private_method_init$A(this, _scrollHorizontal), _class_private_method_init$A(this, _scrollVertical), _class_private_method_init$A(this, _onMouseMove$4), _class_private_field_init$H(this, _autoScroller, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _isOutsideViewport, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _activeDragKind, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _lastClientX, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _lastClientY, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _mouseDownController, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _onAfterSelection, {
      writable: true,
      value: void 0
    }), _class_private_field_init$H(this, _onAfterScroll, {
      writable: true,
      value: void 0
    }), /**
    * Size of an element and its position relative to the viewport,
    * e.g. {bottom: 449, height: 441, left: 8, right: 814, top: 8, width: 806, x: 8, y:8}.
    *
    * @type {DOMRect}
    */
    this.boundaries = null, /**
    * Callback function.
    *
    * @private
    * @type {Function}
    */
    this.callback = null, /**
    * Flag indicates mouseDown/mouseUp.
    *
    * @private
    * @type {boolean}
    */
    this.listening = false, _class_private_field_set$H(this, _autoScroller, new AutoScroller((fn, delay) => this.hot._registerTimeout(fn, delay)).addLocalHook("scrollHorizontal", (distance) => _class_private_method_get$A(this, _scrollHorizontal, scrollHorizontal).call(this, distance)).addLocalHook("scrollVertical", (distance) => _class_private_method_get$A(this, _scrollVertical, scrollVertical).call(this, distance))), _class_private_field_set$H(this, _isOutsideViewport, false), _class_private_field_set$H(this, _activeDragKind, null), _class_private_field_set$H(this, _lastClientX, null), _class_private_field_set$H(this, _lastClientY, null), _class_private_field_set$H(this, _mouseDownController, null), _class_private_field_set$H(this, _onAfterSelection, (row, column, endRow, endColumn, preventScrolling) => {
      if (this.listening && _class_private_field_get$H(this, _isOutsideViewport)) {
        preventScrolling.value = true;
      }
    }), _class_private_field_set$H(this, _onAfterScroll, () => {
      if (_class_private_field_get$H(this, _activeDragKind) !== "cell") {
        return;
      }
      if (!_class_private_field_get$H(this, _isOutsideViewport)) {
        return;
      }
      if (_class_private_field_get$H(this, _lastClientX) === null || _class_private_field_get$H(this, _lastClientY) === null) {
        return;
      }
      if (this.hot.getSettings().selectionMode === "single") {
        return;
      }
      if (_class_private_field_get$H(this, _mouseDownController)?.row || _class_private_field_get$H(this, _mouseDownController)?.column) {
        return;
      }
      const { selection, view } = this.hot;
      const edgeCell = getCellCoordsFromMousePosition(this.hot, _class_private_field_get$H(this, _lastClientX), _class_private_field_get$H(this, _lastClientY));
      if (!edgeCell) {
        return;
      }
      let targetRow = edgeCell.row ?? 0;
      let targetCol = edgeCell.col ?? 0;
      const firstFullyVisibleRow = view.getFirstFullyVisibleRow() ?? 0;
      const lastFullyVisibleRow = view.getLastFullyVisibleRow() ?? 0;
      const firstFullyVisibleColumn = view.getFirstFullyVisibleColumn() ?? 0;
      const lastFullyVisibleColumn = view.getLastFullyVisibleColumn() ?? 0;
      if (targetRow > lastFullyVisibleRow) {
        targetRow = lastFullyVisibleRow;
      } else if (targetRow < firstFullyVisibleRow) {
        targetRow = firstFullyVisibleRow;
      }
      if (targetCol > lastFullyVisibleColumn) {
        targetCol = lastFullyVisibleColumn;
      } else if (targetCol < firstFullyVisibleColumn) {
        targetCol = firstFullyVisibleColumn;
      }
      if (selection.isSelectedByRowHeader()) {
        targetCol = this.hot.countCols() - 1;
      }
      if (selection.isSelectedByColumnHeader()) {
        targetRow = this.hot.countRows() - 1;
      }
      const target = this.hot._createCellCoords(targetRow, targetCol);
      const currentRange = this.hot.getSelectedRangeLast();
      if (currentRange && currentRange.to.row === target.row && currentRange.to.col === target.col) {
        return;
      }
      selection.setRangeEnd(target);
    });
  }
}
function setupListening(kind, event, controller = null) {
  if (isRightClick(event)) {
    return;
  }
  if (kind === "cell" && this.hot.getSettings().selectionMode === "single") {
    return;
  }
  _class_private_field_set$H(this, _activeDragKind, kind);
  _class_private_field_set$H(this, _mouseDownController, controller);
  const scrollHandler = this.hot.view._wt.wtOverlays.topOverlay.mainTableScrollableElement;
  if (scrollHandler === this.hot.rootWindow) {
    this.setBoundaries();
  } else {
    const boundaries = scrollHandler.getBoundingClientRect();
    this.setBoundaries({
      left: boundaries.left + this.hot.view.getRowHeaderWidth(),
      right: boundaries.right,
      top: boundaries.top + this.hot.view.getColumnHeaderHeight(),
      bottom: boundaries.bottom
    });
  }
  this.setCallback((scrollX, scrollY) => {
    const { selection } = this.hot;
    const x = selection.isSelectedByRowHeader() ? 0 : scrollX;
    const y = selection.isSelectedByColumnHeader() ? 0 : scrollY;
    _class_private_field_get$H(this, _autoScroller).update({
      x,
      y
    });
  });
  this.listen();
}
function scrollHorizontal(distance) {
  const shouldAdvance = this.hot.isRtl() ? distance < 0 : distance > 0;
  const scrollColumn = shouldAdvance ? this.hot.getLastFullyVisibleColumn() + 1 : this.hot.getFirstPartiallyVisibleColumn() - 1;
  const isScrolled = this.hot.scrollViewportTo({
    col: scrollColumn
  }, () => {
  });
  if (!isScrolled) {
    _class_private_field_get$H(this, _autoScroller).stopHorizontal();
  }
}
function scrollVertical(distance) {
  const firstVisibleRow = this.hot.getFirstFullyVisibleRow();
  const lastVisibleRow = this.hot.getLastFullyVisibleRow();
  const scrollRow = distance > 0 ? lastVisibleRow + 1 : firstVisibleRow - 1;
  const isScrolled = this.hot.scrollViewportTo({
    row: scrollRow
  }, () => {
  });
  if (!isScrolled) {
    _class_private_field_get$H(this, _autoScroller).stopVertical();
  }
}
function onMouseMove$4(event) {
  if (!this.isListening()) {
    return;
  }
  _class_private_field_set$H(this, _lastClientX, event.clientX);
  _class_private_field_set$H(this, _lastClientY, event.clientY);
  this.check(event.clientX, event.clientY);
}
function _check_private_redeclaration$P(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$G(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$G(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$G(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$G(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$G(receiver, privateMap, "get");
  return _class_apply_descriptor_get$G(receiver, descriptor);
}
function _class_private_field_init$G(obj, privateMap, value) {
  _check_private_redeclaration$P(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$G(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$G(receiver, privateMap, "set");
  _class_apply_descriptor_set$G(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$z(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$z(obj, privateSet) {
  _check_private_redeclaration$P(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("afterDropdownMenuDefaultOptions");
Hooks.getSingleton().register("beforeDropdownMenuShow");
Hooks.getSingleton().register("afterDropdownMenuShow");
Hooks.getSingleton().register("afterDropdownMenuHide");
Hooks.getSingleton().register("afterDropdownMenuExecute");
const PLUGIN_KEY$p = "dropdownMenu";
const PLUGIN_PRIORITY$p = 230;
const BUTTON_CLASS_NAME = "changeType";
const SHORTCUTS_GROUP$8 = PLUGIN_KEY$p;
var _isButtonClicked = /* @__PURE__ */ new WeakMap(), _addCustomShortcuts = /* @__PURE__ */ new WeakSet(), _onTableClick = /* @__PURE__ */ new WeakSet(), _getButtonRect = /* @__PURE__ */ new WeakSet(), _onAfterGetColHeader$2 = /* @__PURE__ */ new WeakMap(), _onMenuAfterOpen = /* @__PURE__ */ new WeakSet(), _onSubMenuAfterOpen = /* @__PURE__ */ new WeakSet(), _onMenuAfterClose = /* @__PURE__ */ new WeakSet(), _onBeforeViewportScrollHorizontally$1 = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseDown$4 = /* @__PURE__ */ new WeakMap();
class DropdownMenu extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$p;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$p;
  }
  /**
  * Returns the list of plugin dependencies required before this plugin can be initialized.
  */
  static get PLUGIN_DEPS() {
    return [
      "plugin:AutoColumnSize"
    ];
  }
  /**
  * Default menu items order when `dropdownMenu` is enabled by setting the config item to `true`.
  *
  * @returns {Array}
  */
  static get DEFAULT_ITEMS() {
    return [
      KEY$9,
      KEY$8,
      KEY$c,
      KEY$5,
      KEY$c,
      KEY$a,
      KEY$c,
      KEY$7,
      KEY$c,
      KEY$b
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link DropdownMenu#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$p];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  *
  * @fires Hooks#afterDropdownMenuDefaultOptions
  * @fires Hooks#beforeDropdownMenuSetItems
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.itemsFactory = new ItemsFactory(this.hot, DropdownMenu.DEFAULT_ITEMS);
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$G(this, _onBeforeOnCellMouseDown$4));
    this.addHook("beforeViewportScrollHorizontally", _class_private_field_get$G(this, _onBeforeViewportScrollHorizontally$1));
    this.addHook("beforeDialogShow", () => this.close());
    const settings = this.hot.getSettings()[PLUGIN_KEY$p];
    const settingsObj = settings;
    const predefinedItems2 = {
      items: this.itemsFactory.getItems(settings)
    };
    this.registerEvents();
    if (typeof settingsObj.callback === "function") {
      this.commandExecutor.setCommonCallback(settingsObj.callback);
    }
    this.registerShortcuts();
    super.enablePlugin();
    this.callOnPluginsReady(() => {
      this.hot.runHooks("afterDropdownMenuDefaultOptions", predefinedItems2);
      this.itemsFactory.setPredefinedItems(predefinedItems2.items);
      const menuItems = this.itemsFactory.getItems(settings);
      if (this.menu) {
        this.menu.destroy();
      }
      this.menu = new Menu(this.hot, {
        className: "htDropdownMenu",
        keepInViewport: true,
        container: (typeof settings === "object" ? settingsObj.uiContainer : null) || this.hot.rootPortalElement
      });
      this.hot.runHooks("beforeDropdownMenuSetItems", menuItems);
      this.menu.setMenuItems(menuItems);
      this.menu.addLocalHook("afterOpen", () => _class_private_method_get$z(this, _onMenuAfterOpen, onMenuAfterOpen).call(this));
      this.menu.addLocalHook("afterSubmenuOpen", (subMenuInstance) => _class_private_method_get$z(this, _onSubMenuAfterOpen, onSubMenuAfterOpen).call(this, subMenuInstance));
      this.menu.addLocalHook("afterClose", () => _class_private_method_get$z(this, _onMenuAfterClose, onMenuAfterClose).call(this));
      this.menu.addLocalHook("executeCommand", (commandName, ...params) => this.executeCommand(commandName, ...params));
      arrayEach(menuItems, (command2) => {
        const cmd = command2;
        this.commandExecutor.registerCommand(cmd.key, command2);
      });
    });
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`dropdownMenu`](@/api/options.md#dropdownmenu)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.close();
    if (this.menu) {
      this.menu.destroy();
    }
    this.unregisterShortcuts();
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for toggling dropdown menu.
  *
  * @private
  */
  registerShortcuts() {
    const gridContext = this.hot.getShortcutManager().getContext("grid");
    const callback = () => {
      const activeRange = this.hot.getSelectedRangeActive();
      if (!activeRange) {
        return;
      }
      const { highlight } = activeRange;
      const highlightedHeaderElement = highlight.isHeader() ? this.hot.getCell(highlight.row ?? 0, highlight.col ?? 0, true) : null;
      const isBottomMostHeaderSelected = highlight.isHeader() && (highlight.col ?? -1) >= 0 && !!highlightedHeaderElement && isBottomMostColumnHeader(highlightedHeaderElement);
      const isHiddenNestedPlaceholderSelected = highlight.isHeader() && (highlight.col ?? -1) >= 0 && highlightedHeaderElement && hasClass(highlightedHeaderElement, "hiddenHeader");
      const isValidSelection = isBottomMostHeaderSelected || isHiddenNestedPlaceholderSelected || highlight.isCell();
      if (isValidSelection && (highlight.col ?? -1) >= 0) {
        let headerRow = isBottomMostHeaderSelected || isHiddenNestedPlaceholderSelected ? highlight.row ?? -1 : -1;
        this.hot.selectColumns(highlight.col ?? 0, highlight.col ?? 0, headerRow);
        const refreshedRange = this.hot.getSelectedRangeActive();
        if (!refreshedRange) {
          return;
        }
        const { from } = refreshedRange;
        const offset2 = getDocumentOffsetByElement(this.menu?.container ?? this.hot.rootElement, this.hot.rootDocument);
        let target = this.hot.getCell(headerRow, from.col ?? 0, true)?.querySelector(`.${BUTTON_CLASS_NAME}`);
        if (!target) {
          for (let row = -this.hot.view.getColumnHeadersCount(); row <= -1; row++) {
            const candidate = this.hot.getCell(row, from.col ?? 0, true)?.querySelector(`.${BUTTON_CLASS_NAME}`);
            if (candidate) {
              target = candidate;
              headerRow = row;
              this.hot.selectColumns(highlight.col ?? 0, highlight.col ?? 0, headerRow);
              break;
            }
          }
        }
        if (!target && isHiddenNestedPlaceholderSelected) {
          for (let column = (from.col ?? 0) - 1; column >= 0; column--) {
            const candidateHeader = this.hot.getCell(headerRow, column, true);
            if (!candidateHeader || hasClass(candidateHeader, "hiddenHeader")) {
              continue;
            }
            const candidateButton = candidateHeader?.querySelector(`.${BUTTON_CLASS_NAME}`);
            if (candidateButton) {
              target = candidateButton;
              this.hot.selectColumns(column, column, headerRow);
            }
            break;
          }
        }
        if (!target) {
          return;
        }
        if (!isHTMLElement(target)) {
          return;
        }
        const buttonRect = _class_private_method_get$z(this, _getButtonRect, getButtonRect).call(this, target);
        const th = target.closest("th");
        const isRowspanned = th && Number.parseInt(th.getAttribute("rowspan") ?? "1", 10) > 1;
        const menuTop = isRowspanned ? th.getBoundingClientRect().top + th.clientHeight : buttonRect.bottom;
        this.open({
          left: buttonRect.left + offset2.left,
          top: menuTop + offset2.top
        }, {
          left: buttonRect.width,
          right: 0,
          above: 0,
          below: isRowspanned ? -1 : 3
        });
        this.menu?.getNavigator()?.toFirstItem();
      }
    };
    gridContext?.addShortcuts([
      {
        keys: [
          [
            "Shift",
            "Alt",
            "ArrowDown"
          ],
          [
            "Control/Meta",
            "Enter"
          ]
        ],
        callback,
        runOnlyIf: () => {
          const highlight = this.hot.getSelectedRangeActive()?.highlight;
          const highlightedHeaderElement = highlight?.isHeader() ? this.hot.getCell(highlight.row ?? 0, highlight.col ?? 0, true) : null;
          const isHiddenNestedPlaceholderSelected = highlight?.isHeader() && (highlight.col ?? -1) >= 0 && highlightedHeaderElement && hasClass(highlightedHeaderElement, "hiddenHeader");
          return !!(highlight && !this.menu?.isOpened() && highlight.isHeader() && (this.hot.selection.isCellVisible(highlight) || isHiddenNestedPlaceholderSelected));
        },
        captureCtrl: true,
        group: SHORTCUTS_GROUP$8
      },
      {
        keys: [
          [
            "Shift",
            "Alt",
            "ArrowDown"
          ]
        ],
        callback,
        runOnlyIf: () => {
          const highlight = this.hot.getSelectedRangeActive()?.highlight;
          return !!(highlight && this.hot.selection.isCellVisible(highlight) && highlight.isCell() && !this.menu?.isOpened());
        },
        group: SHORTCUTS_GROUP$8
      }
    ]);
  }
  /**
  * Unregister shortcuts responsible for toggling dropdown menu.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$8);
  }
  /**
  * Registers the DOM listeners.
  *
  * @private
  */
  registerEvents() {
    this.eventManager.addEventListener(this.hot.rootElement, "click", (event) => _class_private_method_get$z(this, _onTableClick, onTableClick).call(this, event));
  }
  /**
  * Opens the menu and positions it based on the passed coordinates.
  *
  * @param {{ top: number, left: number }|Event} position An object with `top` and `left` properties
  * (coordinates relative to the browser viewport, without scroll offsets), or a native browser
  * `Event` instance (e.g., a `MouseEvent`).
  * @param {{ above: number, below: number, left: number, right: number }} offset An object that applies
  * an offset to the menu position.
  * @fires Hooks#beforeDropdownMenuShow
  * @fires Hooks#afterDropdownMenuShow
  * @example
  * ```js
  * const menu = hot.getPlugin('dropdownMenu');
  *
  * hot.selectCell(0, 0);
  * menu.open({ top: 50, left: 50 });
  * ```
  */
  open(position, offset2 = {
    above: 0,
    below: 0,
    left: 0,
    right: 0
  }) {
    if (this.menu?.isOpened()) {
      return;
    }
    this.hot.runHooks("beforeDropdownMenuShow", this);
    this.menu?.open();
    objectEach(offset2, (value, key) => {
      this.menu?.setOffset(key, value);
    });
    this.menu?.setPosition(position);
  }
  /**
  * Closes dropdown menu.
  */
  close() {
    this.menu?.close();
  }
  /**
  * Executes context menu command.
  *
  * The `executeCommand()` method works only for selected cells.
  *
  * When no cells are selected, `executeCommand()` doesn't do anything.
  *
  * You can execute all predefined commands:
  *  * `'col_left'` - Insert column left
  *  * `'col_right'` - Insert column right
  *  * `'clear_column'` - Clear selected column
  *  * `'remove_col'` - Remove column
  *  * `'undo'` - Undo last action
  *  * `'redo'` - Redo last action
  *  * `'make_read_only'` - Make cell read only
  *  * `'alignment:left'` - Alignment to the left
  *  * `'alignment:top'` - Alignment to the top
  *  * `'alignment:right'` - Alignment to the right
  *  * `'alignment:bottom'` - Alignment to the bottom
  *  * `'alignment:middle'` - Alignment to the middle
  *  * `'alignment:center'` - Alignment to the center (justify).
  *
  * Or you can execute command registered in settings where `key` is your command name.
  *
  * @param {string} commandName Command name to execute.
  * @param {*} params Additional parameters passed to the command executor.
  */
  executeCommand(commandName, ...params) {
    this.commandExecutor.execute(commandName, ...params);
  }
  /**
  * Turns on / off listening on dropdown menu.
  *
  * @private
  * @param {boolean} listen Turn on listening when value is set to true, otherwise turn it off.
  */
  setListening(listen = true) {
    if (this.menu?.isOpened()) {
      const hotMenu = this.menu.hotMenu;
      if (listen) {
        hotMenu.listen();
      } else {
        hotMenu.unlisten();
      }
    }
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    this.close();
    if (this.menu) {
      this.menu.destroy();
    }
    super.destroy();
  }
  /**
  * Initializes the plugin and registers the column header hook needed to inject the dropdown button.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$z(this, _addCustomShortcuts), _class_private_method_init$z(this, _onTableClick), _class_private_method_init$z(this, _getButtonRect), _class_private_method_init$z(this, _onMenuAfterOpen), _class_private_method_init$z(this, _onSubMenuAfterOpen), _class_private_method_init$z(this, _onMenuAfterClose), _class_private_field_init$G(this, _isButtonClicked, {
      writable: true,
      value: void 0
    }), _class_private_field_init$G(this, _onAfterGetColHeader$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$G(this, _onBeforeViewportScrollHorizontally$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$G(this, _onBeforeOnCellMouseDown$4, {
      writable: true,
      value: void 0
    }), /**
    * Instance of {@link CommandExecutor}.
    *
    * @private
    * @type {CommandExecutor}
    */
    this.commandExecutor = new CommandExecutor(this.hot), /**
    * Instance of {@link ItemsFactory}.
    *
    * @private
    * @type {ItemsFactory}
    */
    this.itemsFactory = null, /**
    * Instance of {@link Menu}.
    *
    * @private
    * @type {Menu}
    */
    this.menu = null, _class_private_field_set$G(this, _isButtonClicked, false), _class_private_field_set$G(this, _onAfterGetColHeader$2, (col, TH) => {
      if (col < 0 || !isBottomMostColumnHeader(TH)) {
        return;
      }
      const existingButton = TH.querySelector(`.${BUTTON_CLASS_NAME}`);
      if (this.enabled && existingButton) {
        return;
      }
      if (!this.enabled) {
        if (existingButton) {
          existingButton.parentNode?.removeChild(existingButton);
        }
        return;
      }
      const button = this.hot.rootDocument.createElement("button");
      button.className = BUTTON_CLASS_NAME;
      button.type = "button";
      button.tabIndex = -1;
      if (this.hot.getSettings().ariaTags) {
        setAttribute(button, [
          A11Y_HIDDEN(),
          A11Y_LABEL(" ")
        ]);
        setAttribute(TH, [
          A11Y_HASPOPUP("menu")
        ]);
      }
      button.onclick = function() {
        return false;
      };
      const relativeContainer = TH.firstChild;
      if (!relativeContainer) {
        return;
      }
      const colHeaderSpan = relativeContainer.querySelector(".colHeader");
      if (colHeaderSpan) {
        relativeContainer.insertBefore(button, colHeaderSpan.nextSibling);
      } else {
        relativeContainer.appendChild(button);
      }
    }), _class_private_field_set$G(this, _onBeforeViewportScrollHorizontally$1, (visualColumn) => {
      return _class_private_field_get$G(this, _isButtonClicked) ? null : visualColumn;
    }), _class_private_field_set$G(this, _onBeforeOnCellMouseDown$4, (event) => {
      if (hasClass(eventTargetEl(event), BUTTON_CLASS_NAME)) {
        _class_private_field_set$G(this, _isButtonClicked, true);
      }
    });
    this.hot.addHook("afterGetColHeader", _class_private_field_get$G(this, _onAfterGetColHeader$2));
  }
}
function addCustomShortcuts(menuInstance) {
  menuInstance.getKeyboardShortcutsCtrl()?.addCustomShortcuts([
    {
      keys: [
        [
          "Control/Meta",
          "A"
        ]
      ],
      callback: () => false
    }
  ]);
}
function onTableClick(event) {
  const target = eventTargetEl(event);
  if (hasClass(target, BUTTON_CLASS_NAME)) {
    const offset2 = getDocumentOffsetByElement(this.menu?.container ?? this.hot.rootElement, this.hot.rootDocument);
    const buttonRect = _class_private_method_get$z(this, _getButtonRect, getButtonRect).call(this, target);
    event.stopPropagation();
    _class_private_field_set$G(this, _isButtonClicked, false);
    this.open({
      left: buttonRect.left + offset2.left,
      top: buttonRect.bottom + offset2.top
    }, {
      left: buttonRect.width,
      right: 0,
      above: 0,
      below: 3
    });
  }
}
function getButtonRect(button) {
  const rect = button.getBoundingClientRect();
  const beforeStyle = this.hot.rootWindow.getComputedStyle(button, "::before");
  const iconSize = Number.parseFloat(beforeStyle.width);
  if (Number.isFinite(iconSize) && rect.width >= iconSize && rect.height >= iconSize) {
    const left2 = rect.left + (rect.width - iconSize) / 2;
    const top2 = rect.top + (rect.height - iconSize) / 2;
    return {
      top: top2,
      left: left2,
      right: left2 + iconSize,
      bottom: top2 + iconSize,
      width: iconSize,
      height: iconSize
    };
  }
  return {
    top: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
    height: rect.height
  };
}
function onMenuAfterOpen() {
  this.hot.runHooks("afterDropdownMenuShow", this);
  _class_private_method_get$z(this, _addCustomShortcuts, addCustomShortcuts).call(this, this.menu);
}
function onSubMenuAfterOpen(subMenuInstance) {
  _class_private_method_get$z(this, _addCustomShortcuts, addCustomShortcuts).call(this, subMenuInstance);
}
function onMenuAfterClose() {
  this.hot.listen();
  this.hot.runHooks("afterDropdownMenuHide", this);
}
DropdownMenu.SEPARATOR = {
  name: KEY$c
};
class DataProvider2 {
  /**
  * Set options for data provider.
  *
  * @param {object} options Object with specified options.
  */
  setOptions(options) {
    if (options && "columnHeaders" in options && !("colHeaders" in options)) {
      this.options = {
        ...options,
        colHeaders: options.columnHeaders
      };
      return;
    }
    this.options = options;
  }
  /**
  * Builds a 2D array by calling `getCellValue(rowIndex, colIndex)` for every visible
  * cell in the export range, honouring hidden-row and hidden-column exclusions.
  *
  * @private
  * @param {Function} getCellValue Called for each visible cell; its return value is
  *   pushed into the row array.
  * @returns {Array[]}
  */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _extractDataMatrix(getCellValue2) {
    const { startRow, startCol, endRow, endCol } = this._getDataRange();
    const options = this.options;
    const data = [];
    for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
      if (options.exportHiddenRows === false && this._isHiddenRow(rowIndex)) {
        continue;
      }
      const row = [];
      for (let colIndex = startCol; colIndex <= endCol; colIndex++) {
        if (options.exportHiddenColumns === false && this._isHiddenColumn(colIndex)) {
          continue;
        }
        row.push(getCellValue2(rowIndex, colIndex));
      }
      data.push(row);
    }
    return data;
  }
  /**
  * Get table data based on provided settings to the class constructor.
  *
  * @returns {Array}
  */
  getData() {
    return this._extractDataMatrix((row, col) => this.hot.getDataAtCell(row, col));
  }
  /**
  * Gets list of row headers.
  *
  * @returns {Array}
  */
  getRowHeaders() {
    const headers = [];
    if (this.options.rowHeaders) {
      const { startRow, endRow } = this._getDataRange();
      const rowHeaders = this.hot.getRowHeader();
      for (let row = startRow; row <= endRow; row++) {
        if (this.options.exportHiddenRows === false && this._isHiddenRow(row)) {
          continue;
        }
        headers.push(rowHeaders[row]);
      }
    }
    return headers;
  }
  /**
  * Gets list of columns headers.
  *
  * @returns {Array}
  */
  getColumnHeaders() {
    const headers = [];
    if (this.options.colHeaders) {
      const { startCol, endCol } = this._getDataRange();
      const colHeaders = this.hot.getColHeader();
      for (let column = startCol; column <= endCol; column++) {
        if (this.options.exportHiddenColumns === false && this._isHiddenColumn(column)) {
          continue;
        }
        headers.push(colHeaders[column]);
      }
    }
    return headers;
  }
  /**
  * Get data range object based on settings provided in the class constructor.
  *
  * @private
  * @returns {object} Returns object with keys `startRow`, `startCol`, `endRow` and `endCol`.
  */
  _getDataRange() {
    const cols = this.hot.countCols() - 1;
    const rows = this.hot.countRows() - 1;
    let [startRow = 0, startCol = 0, endRow = rows, endCol = cols] = this.options.range;
    startRow = Math.max(startRow, 0);
    startCol = Math.max(startCol, 0);
    endRow = Math.min(endRow, rows);
    endCol = Math.min(endCol, cols);
    return {
      startRow,
      startCol,
      endRow,
      endCol
    };
  }
  /**
  * Get raw source data (formulas) based on provided settings to the class constructor.
  *
  * Mirrors {@link DataProvider#getData} but uses `getSourceDataAtCell` so that cells
  * containing HyperFormula formulas return the raw formula string (e.g. `'=SUM(A1:A3)'`)
  * rather than the calculated value.
  *
  * @returns {Array}
  */
  getSourceData() {
    return this._extractDataMatrix((row, col) => this.hot.getSourceDataAtCell(row, col));
  }
  /**
  * Returns the set of physical HOT row indices that are hidden and excluded from the
  * exported data matrix (i.e. `exportHiddenRows` is `false` and the row is hidden).
  *
  * Returns an empty set when `exportHiddenRows` is `true` or `'hide'`, because in
  * those cases all rows are included in the data matrix and no formula-offset
  * adjustment is needed.
  *
  * Used by the formula normalizer to adjust per-reference row offsets when building
  * live Excel formulas from HyperFormula formula strings.
  *
  * @returns {Set<number>}
  */
  getExcludedHiddenRows() {
    const result = /* @__PURE__ */ new Set();
    if (this.options.exportHiddenRows !== false) {
      return result;
    }
    const { startRow, endRow } = this._getDataRange();
    for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
      if (this._isHiddenRow(rowIndex)) {
        result.add(this.hot.toPhysicalRow(rowIndex));
      }
    }
    return result;
  }
  /**
  * Returns the set of physical HOT column indices that are hidden and excluded from the
  * exported data matrix (i.e. `exportHiddenColumns` is `false` and the column is hidden).
  *
  * Returns an empty set when `exportHiddenColumns` is `true` or `'hide'`, because in
  * those cases all columns are included in the data matrix and no formula-offset
  * adjustment is needed.
  *
  * Used by the formula normalizer to adjust per-reference column offsets when building
  * live Excel formulas from HyperFormula formula strings.
  *
  * @returns {Set<number>}
  */
  getExcludedHiddenColumns() {
    const result = /* @__PURE__ */ new Set();
    if (this.options.exportHiddenColumns !== false) {
      return result;
    }
    const { startCol, endCol } = this._getDataRange();
    for (let colIndex = startCol; colIndex <= endCol; colIndex++) {
      if (this._isHiddenColumn(colIndex)) {
        result.add(this.hot.toPhysicalColumn(colIndex));
      }
    }
    return result;
  }
  /**
  * Returns the 0-based data-array row indices for rows that are hidden in
  * Handsontable and are included in the exported data matrix.
  *
  * Only returns a non-empty array when `exportHiddenRows` is `'hide'`.
  * When `true`, all rows are visible in Excel. When `false`, hidden rows
  * are omitted entirely and there is nothing to mark as hidden.
  *
  * @returns {number[]}
  */
  getHiddenRowDataIndices() {
    if (this.options.exportHiddenRows !== "hide") {
      return [];
    }
    const { startRow, endRow } = this._getDataRange();
    const result = [];
    let dataIndex = 0;
    for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
      if (this._isHiddenRow(rowIndex)) {
        result.push(dataIndex);
      }
      dataIndex += 1;
    }
    return result;
  }
  /**
  * Returns the 0-based data-array column indices for columns that are hidden in
  * Handsontable and are included in the exported data matrix.
  *
  * Only returns a non-empty array when `exportHiddenColumns` is `'hide'`.
  * When `true`, all columns are visible in Excel. When `false`, hidden columns
  * are omitted entirely and there is nothing to mark as hidden.
  *
  * @returns {number[]}
  */
  getHiddenColumnDataIndices() {
    if (this.options.exportHiddenColumns !== "hide") {
      return [];
    }
    const { startCol, endCol } = this._getDataRange();
    const result = [];
    let dataIndex = 0;
    for (let colIndex = startCol; colIndex <= endCol; colIndex++) {
      if (this._isHiddenColumn(colIndex)) {
        result.push(dataIndex);
      }
      dataIndex += 1;
    }
    return result;
  }
  /**
  * Gets the function argument separator used by the HyperFormula engine, if active.
  *
  * Returns `','` when the Formulas plugin is absent or disabled, since that is the
  * separator OOXML (Excel) always expects.
  *
  * @returns {string}
  */
  getFormulasSeparator() {
    const formulasPlugin = this.hot.getPlugin("formulas");
    if (!formulasPlugin || !formulasPlugin.isEnabled()) {
      return ",";
    }
    return formulasPlugin.engine?.getConfig()?.functionArgSeparator ?? ",";
  }
  /**
  * Gets cell meta for all cells in the export range.
  *
  * Returns a 2D array of cell meta objects with the same structure as {@link DataProvider#getData}.
  * Each entry corresponds to the cell at the same position in the data array.
  *
  * @returns {Array}
  */
  getCellsMeta() {
    return this._extractDataMatrix((row, col) => this.hot.getCellMeta(row, col));
  }
  /**
  * Gets rendered DOM elements for all cells in the export range.
  *
  * Returns a 2D array of `HTMLElement | null` values with the same structure as
  * {@link DataProvider#getCellsMeta}. An entry is `null` when the cell is outside
  * the rendered viewport (virtualised grid).
  *
  * @returns {Array}
  */
  getCellElements() {
    return this._extractDataMatrix((row, col) => this.hot.getCell(row, col));
  }
  /**
  * Gets the merged cells configuration filtered to the current export range.
  *
  * Returned coordinates are 0-based data-array indices (matching the same coordinate
  * space as {@link DataProvider#getData}). Hidden rows/columns excluded from the export
  * are accounted for: the row/col offsets are compressed and the rowspan/colspan values
  * are reduced to cover only the exported cells within the merge span.
  *
  * Merges whose top-left cell is excluded, or that collapse to a single cell after
  * exclusion, are omitted from the result.
  *
  * @returns {Array}
  */
  getMergeCells() {
    const { startRow, startCol, endRow, endCol } = this._getDataRange();
    const mergeCellsPlugin = this.hot.getPlugin("mergeCells");
    if (!mergeCellsPlugin || !mergeCellsPlugin.isEnabled()) {
      return [];
    }
    const mergedCells = mergeCellsPlugin.mergedCellsCollection.mergedCells;
    const result = [];
    const excludeHiddenRows = this.options.exportHiddenRows === false;
    const excludeHiddenCols = this.options.exportHiddenColumns === false;
    const rowIncluded = (r) => !excludeHiddenRows || !this._isHiddenRow(r);
    const colIncluded = (c) => !excludeHiddenCols || !this._isHiddenColumn(c);
    mergedCells.forEach((merge2) => {
      const mergeEndRow = merge2.row + merge2.rowspan - 1;
      const mergeEndCol = merge2.col + merge2.colspan - 1;
      if (merge2.row < startRow || mergeEndRow > endRow || merge2.col < startCol || mergeEndCol > endCol) {
        return;
      }
      if (!rowIncluded(merge2.row) || !colIncluded(merge2.col)) {
        return;
      }
      const dataRow = this._countVisibleBefore(merge2.row, startRow, rowIncluded);
      const dataCol = this._countVisibleBefore(merge2.col, startCol, colIncluded);
      const dataRowspan = this._countVisibleBefore(mergeEndRow + 1, merge2.row, rowIncluded);
      const dataColspan = this._countVisibleBefore(mergeEndCol + 1, merge2.col, colIncluded);
      if (dataRowspan <= 1 && dataColspan <= 1) {
        return;
      }
      result.push({
        row: dataRow,
        col: dataCol,
        rowspan: dataRowspan,
        colspan: dataColspan
      });
    });
    return result;
  }
  /**
  * Gets widths (in pixels) for all visible columns in the export range.
  *
  * Returns values in the same column order as {@link DataProvider#getData}.
  *
  * @returns {Array}
  */
  getColumnsWidths() {
    const { startCol, endCol } = this._getDataRange();
    const options = this.options;
    const widths = [];
    for (let colIndex = startCol; colIndex <= endCol; colIndex++) {
      if (options.exportHiddenColumns === false && this._isHiddenColumn(colIndex)) {
        continue;
      }
      const width = this._isHiddenColumn(colIndex) ? this._getNaturalColWidth(colIndex) : this.hot.getColWidth(colIndex);
      widths.push(width);
    }
    return widths;
  }
  /**
  * Gets heights (in pixels) for all visible rows in the export range.
  *
  * Returns values in the same row order as {@link DataProvider#getData}.
  *
  * @returns {Array}
  */
  getRowsHeights() {
    const { startRow, endRow } = this._getDataRange();
    const options = this.options;
    const heights = [];
    for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
      if (options.exportHiddenRows === false && this._isHiddenRow(rowIndex)) {
        continue;
      }
      const height = this._isHiddenRow(rowIndex) ? this._getNaturalRowHeight(rowIndex) : this.hot.getRowHeight(rowIndex);
      heights.push(height);
    }
    return heights;
  }
  /**
  * Gets the number of frozen rows (`fixedRowsTop` setting).
  *
  * @returns {number}
  */
  getFrozenRows() {
    return this.hot.getSettings().fixedRowsTop || 0;
  }
  /**
  * Gets the number of frozen columns (`fixedColumnsStart` setting).
  *
  * @returns {number}
  */
  getFrozenColumns() {
    return this.hot.getSettings().fixedColumnsStart || 0;
  }
  /**
  * Gets nested column header data from the NestedHeaders plugin for the current export range.
  *
  * Returns `null` when the NestedHeaders plugin is not enabled. Otherwise returns an array
  * of layers, where each layer is an array of `{ label, colspan, className }` objects
  * representing the visible column headers in that layer. Hidden columns (when
  * `exportHiddenColumns` is `false`) are excluded and their colspan contribution is removed
  * from spanning headers.
  *
  * @returns {Array[]|null}
  */
  getNestedColumnHeaders() {
    const nestedHeadersPlugin = this.hot.getPlugin("nestedHeaders");
    if (!nestedHeadersPlugin || !nestedHeadersPlugin.isEnabled()) {
      return null;
    }
    const layersCount = nestedHeadersPlugin.getLayersCount();
    const { startCol, endCol } = this._getDataRange();
    const options = this.options;
    const includeHidden = !!options.exportHiddenColumns;
    const layers = [];
    for (let layer = 0; layer < layersCount; layer++) {
      const layerHeaders = [];
      let col = startCol;
      while (col <= endCol) {
        if (!includeHidden && this._isHiddenColumn(col)) {
          col += 1;
          continue;
        }
        if (includeHidden) {
          col = this._appendNestedHeaderWithHidden(nestedHeadersPlugin, layer, col, endCol, layerHeaders);
        } else {
          col = this._appendNestedHeaderWithoutHidden(nestedHeadersPlugin, layer, col, endCol, layerHeaders);
        }
      }
      layers.push(layerHeaders);
    }
    return layers;
  }
  /**
  * Appends a nested header entry for a single column when hidden columns are included in the export.
  *
  * @param {object} nestedHeadersPlugin The NestedHeaders plugin instance.
  * @param {number} layer The header layer index.
  * @param {number} col The current column index.
  * @param {number} endCol The last column index of the export range.
  * @param {Array} layerHeaders The array to push the header entry into.
  * @returns {number} The next column index to process.
  */
  _appendNestedHeaderWithHidden(nestedHeadersPlugin, layer, col, endCol, layerHeaders) {
    const treeNodeData = nestedHeadersPlugin.getStateManager().getHeaderTreeNodeData(layer, col);
    if (!treeNodeData || treeNodeData.columnIndex === col) {
      const origColspan = treeNodeData?.origColspan ?? 1;
      const effectiveColspan = Math.min(origColspan, endCol - col + 1);
      const className = (treeNodeData?.headerClassNames ?? []).join(" ");
      layerHeaders.push({
        label: treeNodeData?.label ?? "",
        colspan: effectiveColspan,
        className
      });
      return col + origColspan;
    }
    layerHeaders.push({
      label: "",
      colspan: 1,
      className: ""
    });
    return col + 1;
  }
  /**
  * Appends a nested header entry for a single column when hidden columns are excluded from the export.
  *
  * @param {object} nestedHeadersPlugin The NestedHeaders plugin instance.
  * @param {number} layer The header layer index.
  * @param {number} col The current column index.
  * @param {number} endCol The last column index of the export range.
  * @param {Array} layerHeaders The array to push the header entry into.
  * @returns {number} The next column index to process.
  */
  _appendNestedHeaderWithoutHidden(nestedHeadersPlugin, layer, col, endCol, layerHeaders) {
    const settings = nestedHeadersPlugin.getHeaderSettings(layer, col);
    if (!settings || settings.isRoot) {
      const spanColspan = settings?.colspan ?? 1;
      let visibleColspan = 0;
      for (let spanCol = col; spanCol < col + spanColspan && spanCol <= endCol; spanCol++) {
        if (!this._isHiddenColumn(spanCol)) {
          visibleColspan += 1;
        }
      }
      const className = (settings?.headerClassNames ?? []).join(" ");
      layerHeaders.push({
        label: settings?.label ?? "",
        colspan: visibleColspan,
        className
      });
      return col + spanColspan;
    }
    layerHeaders.push({
      label: "",
      colspan: 1,
      className: ""
    });
    return col + 1;
  }
  /**
  * Gets `headerClassName` values for all visible column headers in the export range.
  *
  * Returns values in the same column order as {@link DataProvider#getColumnHeaders}.
  * An empty string is returned for columns that have no `headerClassName` configured.
  *
  * @returns {string[]}
  */
  getColumnHeadersClassNames() {
    if (!this.options.colHeaders) {
      return [];
    }
    const { startCol, endCol } = this._getDataRange();
    const options = this.options;
    const classNames = [];
    for (let col = startCol; col <= endCol; col++) {
      if (options.exportHiddenColumns === false && this._isHiddenColumn(col)) {
        continue;
      }
      const headerClassName = this.hot.getColumnMeta(col).headerClassName;
      let resolvedClassName = "";
      if (Array.isArray(headerClassName)) {
        resolvedClassName = headerClassName.join(" ");
      } else if (typeof headerClassName === "string") {
        resolvedClassName = headerClassName;
      }
      classNames.push(resolvedClassName);
    }
    return classNames;
  }
  /**
  * Gets the layout direction of the Handsontable instance.
  *
  * @returns {'ltr'|'rtl'}
  */
  getLayoutDirection() {
    return this.hot.getSettings().layoutDirection === "rtl" ? "rtl" : "ltr";
  }
  /**
  * Gets column summary endpoint descriptors from the ColumnSummary plugin, translated
  * into the coordinate space of the exported data array.
  *
  * Returns an empty array when the plugin is absent or disabled.
  * Each descriptor contains:
  *
  * - `destRow` / `destCol` — 0-based indices into `getData()` identifying the destination cell.
  * - `type` — lowercase summary type (`'sum'`, `'min'`, `'max'`, `'count'`, `'average'`, `'custom'`).
  * - `sourceCol` — 0-based data-array column index of the source column.
  * - `sourceRanges` — array of `[startDataRow, endDataRow]` pairs (inclusive, 0-based) covering
  *   the source rows after hidden-row exclusion and range clamping.
  *
  * @returns {Array}
  */
  getColumnSummaries() {
    const plugin = this.hot.getPlugin("columnSummary");
    if (!plugin || !plugin.isEnabled()) {
      return [];
    }
    const { startRow, startCol, endRow, endCol } = this._getDataRange();
    const allEndpoints = plugin.endpoints.getAllEndpoints();
    const allDestRows = /* @__PURE__ */ new Set();
    allEndpoints.forEach((endpoint) => {
      if (endpoint.destinationRow === void 0) {
        return;
      }
      const destRow = this._physicalRowToDataIndex(endpoint.destinationRow, startRow, endRow);
      if (destRow !== null) {
        allDestRows.add(destRow);
      }
    });
    const summaries = [];
    allEndpoints.forEach((endpoint) => {
      const summary = this._transformEndpointToSummary(endpoint, startRow, endRow, startCol, endCol, allDestRows);
      if (summary !== null) {
        summaries.push(summary);
      }
    });
    return summaries;
  }
  /**
  * Translates a single ColumnSummary endpoint into an export-coordinate summary descriptor.
  *
  * Converts physical row/column indices to 0-based data-array positions, builds the
  * compacted source-range array (merging consecutive indices), and excludes all
  * destination rows supplied in `allDestRows` to prevent circular Excel formula chains.
  *
  * Returns `null` when the endpoint falls outside the export range or produces no
  * valid source rows after filtering.
  *
  * @private
  * @param {object} endpoint ColumnSummary endpoint object from `getAllEndpoints()`.
  * @param {number} startRow First visual row of the export range.
  * @param {number} endRow Last visual row of the export range.
  * @param {number} startCol First visual column of the export range.
  * @param {number} endCol Last visual column of the export range.
  * @param {Set<number>} allDestRows Data-array row indices of all summary destinations.
  * @returns {object|null}
  */
  _transformEndpointToSummary(endpoint, startRow, endRow, startCol, endCol, allDestRows) {
    if (endpoint.destinationRow === void 0 || endpoint.destinationColumn === void 0) {
      return null;
    }
    const destRow = this._physicalRowToDataIndex(endpoint.destinationRow, startRow, endRow);
    const destCol = this._physicalColToDataIndex(endpoint.destinationColumn, startCol, endCol);
    if (destRow === null || destCol === null) {
      return null;
    }
    const physSourceCol = endpoint.sourceColumn ?? endpoint.destinationColumn;
    const sourceCol = this._physicalColToDataIndex(physSourceCol, startCol, endCol);
    if (sourceCol === null) {
      return null;
    }
    const physRanges = endpoint.ranges || [
      [
        0,
        this.hot.countRows() - 1
      ]
    ];
    const sourceRanges = [];
    physRanges.forEach((range) => {
      const physStart = range[0];
      const physEnd = range[1] !== void 0 ? range[1] : range[0];
      for (let physRow = physStart; physRow <= physEnd; physRow++) {
        const dataIdx = this._physicalRowToDataIndex(physRow, startRow, endRow);
        if (dataIdx === null || allDestRows.has(dataIdx)) {
          continue;
        }
        if (sourceRanges.length > 0) {
          const lastRange = sourceRanges[sourceRanges.length - 1];
          if (lastRange[1] + 1 === dataIdx) {
            lastRange[1] = dataIdx;
            continue;
          }
        }
        sourceRanges.push([
          dataIdx,
          dataIdx
        ]);
      }
    });
    if (sourceRanges.length === 0) {
      return null;
    }
    return {
      destRow,
      destCol,
      type: String(endpoint.type || "sum").toLowerCase(),
      sourceCol,
      sourceRanges
    };
  }
  /**
  * Counts the number of indices in `[start, end)` for which `isIncluded` returns `true`.
  *
  * Used by {@link DataProvider#_physicalRowToDataIndex} and
  * {@link DataProvider#_physicalColToDataIndex} to compute the 0-based data-array
  * position of a visual index by counting the visible indices that precede it.
  *
  * @private
  * @param {number} end Exclusive upper bound (the target visual index).
  * @param {number} start Inclusive lower bound of the export range.
  * @param {Function} isIncluded Returns `true` for indices that appear in the exported data.
  * @returns {number}
  */
  _countVisibleBefore(end, start, isIncluded) {
    let count = 0;
    for (let i = start; i < end; i++) {
      if (isIncluded(i)) {
        count += 1;
      }
    }
    return count;
  }
  /**
  * Converts a physical row index to a 0-based index into the exported data array.
  *
  * Returns `null` if the row is outside the export range, is hidden and hidden rows
  * are not being exported, or has no visual equivalent.
  *
  * @private
  * @param {number} physRow Physical row index.
  * @param {number} startRow First visual row of the export range.
  * @param {number} endRow Last visual row of the export range.
  * @returns {number|null}
  */
  _physicalRowToDataIndex(physRow, startRow, endRow) {
    const visualRow = this.hot.toVisualRow(physRow);
    if (visualRow === null || visualRow < startRow || visualRow > endRow) {
      return null;
    }
    if (this.options.exportHiddenRows === false && this._isHiddenRow(visualRow)) {
      return null;
    }
    return this._countVisibleBefore(visualRow, startRow, (r) => this.options.exportHiddenRows !== false || !this._isHiddenRow(r));
  }
  /**
  * Converts a physical column index to a 0-based index into the exported data array.
  *
  * Returns `null` if the column is outside the export range, is hidden and hidden
  * columns are not being exported, or has no visual equivalent.
  *
  * @private
  * @param {number} physCol Physical column index.
  * @param {number} startCol First visual column of the export range.
  * @param {number} endCol Last visual column of the export range.
  * @returns {number|null}
  */
  _physicalColToDataIndex(physCol, startCol, endCol) {
    const visualCol = this.hot.toVisualColumn(physCol);
    if (visualCol === null || visualCol < startCol || visualCol > endCol) {
      return null;
    }
    if (this.options.exportHiddenColumns === false && this._isHiddenColumn(visualCol)) {
      return null;
    }
    return this._countVisibleBefore(visualCol, startCol, (c) => this.options.exportHiddenColumns !== false || !this._isHiddenColumn(c));
  }
  /**
  * Returns the natural (pre-hiding) width in pixels for a hidden column.
  *
  * `getColWidth()` returns 0 for hidden columns because the HiddenColumns plugin
  * overrides the `modifyColWidth` hook. This method reads the configured width
  * from column meta or the `colWidths` setting, bypassing that hook.
  *
  * @private
  * @param {number} colIndex Visual column index.
  * @returns {number}
  */
  _getNaturalColWidth(colIndex) {
    const settings = this.hot.getSettings();
    const metaWidth = this.hot.getColumnMeta(colIndex).width;
    if (metaWidth !== null && metaWidth !== void 0) {
      return metaWidth;
    }
    const { colWidths, defaultColumnWidth } = settings;
    const fallback = defaultColumnWidth ?? 50;
    if (Array.isArray(colWidths)) {
      return colWidths[colIndex] ?? fallback;
    } else if (typeof colWidths === "function") {
      return colWidths(colIndex) ?? fallback;
    } else if (typeof colWidths === "number") {
      return colWidths;
    }
    return fallback;
  }
  /**
  * Returns the natural (pre-hiding) height in pixels for a hidden row.
  *
  * `getRowHeight()` returns 0 for hidden rows because the HiddenRows plugin
  * overrides the `modifyRowHeight` hook. This method reads the configured height
  * directly from the `rowHeights` setting, bypassing that hook.
  *
  * @private
  * @param {number} rowIndex Visual row index.
  * @returns {number}
  */
  _getNaturalRowHeight(rowIndex) {
    const settings = this.hot.getSettings();
    const { rowHeights, defaultRowHeight } = settings;
    const fallback = defaultRowHeight ?? 23;
    if (Array.isArray(rowHeights)) {
      return rowHeights[rowIndex] ?? fallback;
    } else if (typeof rowHeights === "function") {
      return rowHeights(rowIndex) ?? fallback;
    } else if (typeof rowHeights === "number") {
      return rowHeights;
    }
    return fallback;
  }
  /**
  * Check if row at specified row index is hidden.
  *
  * @private
  * @param {number} row Row index.
  * @returns {boolean}
  */
  _isHiddenRow(row) {
    return this.hot.rowIndexMapper.isHidden(this.hot.toPhysicalRow(row));
  }
  /**
  * Check if column at specified column index is hidden.
  *
  * @private
  * @param {number} column Visual column index.
  * @returns {boolean}
  */
  _isHiddenColumn(column) {
    return this.hot.columnIndexMapper.isHidden(this.hot.toPhysicalColumn(column));
  }
  /**
  * Initializes the data provider with a reference to the Handsontable instance used to retrieve data for export.
  */
  constructor(hotInstance) {
    this.options = {};
    this.hot = hotInstance;
  }
}
class BaseType {
  /**
  * Default options.
  *
  * @returns {object}
  */
  static get DEFAULT_OPTIONS() {
    return {
      mimeType: "text/plain",
      fileExtension: "txt",
      filename: "Handsontable [YYYY]-[MM]-[DD]",
      encoding: "utf-8",
      bom: false,
      colHeaders: false,
      rowHeaders: false,
      exportHiddenColumns: false,
      exportHiddenRows: false,
      range: []
    };
  }
  /**
  * Whether the format produces binary (asynchronous) output.
  *
  * @returns {boolean}
  */
  get binary() {
    return false;
  }
  /**
  * Type predicate: narrows this formatter to a binary (asynchronous) one.
  *
  * @returns {boolean}
  */
  isBinary() {
    return this.binary;
  }
  /**
  * Type predicate: narrows this formatter to a text (synchronous) one.
  *
  * @returns {boolean}
  */
  isText() {
    return !this.binary;
  }
  /**
  * Performs the actual export and returns the data as a string or a Promise.
  */
  export() {
    throwWithCause("export() must be implemented by subclass");
  }
  /**
  * Merge options provided by users with defaults.
  *
  * @param {object} options An object with options to merge with.
  * @returns {object} Returns new options object.
  */
  _mergeOptions(options) {
    const ctorDefaults = this.constructor.DEFAULT_OPTIONS;
    let _options = clone(ctorDefaults);
    const date = /* @__PURE__ */ new Date();
    _options = extend(clone(BaseType.DEFAULT_OPTIONS), _options);
    if (options && "columnHeaders" in options && !("colHeaders" in options)) {
      options = {
        ...options,
        colHeaders: options.columnHeaders
      };
    }
    _options = extend(_options, options);
    _options.filename = substitute(_options.filename, {
      YYYY: date.getFullYear(),
      MM: `${date.getMonth() + 1}`.padStart(2, "0"),
      DD: `${date.getDate()}`.padStart(2, "0")
    });
    return _options;
  }
  /**
  * Initializes the export type with the data provider and merges the given options with the class defaults.
  */
  constructor(dataProvider, options) {
    this.dataProvider = dataProvider;
    this.options = this._mergeOptions(options);
    this.dataProvider.setOptions(this.options);
  }
}
function _check_private_redeclaration$O(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$y(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$y(obj, privateSet) {
  _check_private_redeclaration$O(obj, privateSet);
  privateSet.add(obj);
}
const CHAR_CARRIAGE_RETURN = String.fromCharCode(13);
const CHAR_DOUBLE_QUOTES = String.fromCharCode(34);
const CHAR_LINE_FEED = String.fromCharCode(10);
const CHAR_EQUAL = String.fromCharCode(61);
const CHAR_PLUS = String.fromCharCode(43);
const CHAR_MINUS = String.fromCharCode(45);
const CHAR_AT = String.fromCharCode(64);
const CHAR_TAB = String.fromCharCode(9);
var _sanitizeValueWithOWASP = /* @__PURE__ */ new WeakSet(), _sanitizeValueWithRegExp = /* @__PURE__ */ new WeakSet();
class Csv extends BaseType {
  /**
  * Default options for exporting CSV format.
  *
  * @returns {object}
  */
  static get DEFAULT_OPTIONS() {
    return {
      mimeType: "text/csv",
      fileExtension: "csv",
      bom: true,
      columnDelimiter: ",",
      rowDelimiter: "\r\n",
      sanitizeValues: false
    };
  }
  /**
  * Merge options, normalizing XLSX-only values that are not applicable to CSV.
  *
  * The `'hide'` value for `exportHiddenRows` and `exportHiddenColumns` is only
  * meaningful for Excel exports (it marks rows/columns as hidden in the workbook).
  * For CSV the only sensible fallback is `false` — omit those rows/columns entirely.
  *
  * @param {object} options User-supplied options.
  * @returns {object}
  */
  _mergeOptions(options) {
    const merged = super._mergeOptions(options);
    const overrides = {};
    if (merged.exportHiddenRows === "hide") {
      overrides.exportHiddenRows = false;
    }
    if (merged.exportHiddenColumns === "hide") {
      overrides.exportHiddenColumns = false;
    }
    return Object.keys(overrides).length > 0 ? extend(merged, overrides) : merged;
  }
  /**
  * Create string body in desired format.
  *
  * @returns {string}
  */
  export() {
    const options = this.options;
    const data = this.dataProvider.getData();
    let columnHeaders = this.dataProvider.getColumnHeaders();
    const hasColumnHeaders = columnHeaders.length > 0;
    const rowHeaders = this.dataProvider.getRowHeaders();
    const hasRowHeaders = rowHeaders.length > 0;
    let result = options.bom ? String.fromCharCode(65279) : "";
    if (hasColumnHeaders) {
      columnHeaders = columnHeaders.map((value) => this._escapeCell(value, {
        force: true,
        sanitizeValue: options.sanitizeValues
      }));
      if (hasRowHeaders) {
        result += options.columnDelimiter;
      }
      result += columnHeaders.join(options.columnDelimiter);
      result += options.rowDelimiter;
    }
    data.forEach((value, index2) => {
      if (index2 > 0) {
        result += options.rowDelimiter;
      }
      if (hasRowHeaders) {
        result += this._escapeCell(rowHeaders[index2], {
          sanitizeValue: options.sanitizeValues
        });
        result += options.columnDelimiter;
      }
      const escapedValue = value.map((cellValue) => this._escapeCell(cellValue, {
        sanitizeValue: options.sanitizeValues
      })).join(options.columnDelimiter);
      result += escapedValue;
    });
    return result;
  }
  /**
  * Escape cell value.
  *
  * @param {*} value Cell value.
  * @param {object} options Options.
  * @param {boolean} [options.force=false] Indicates if cell value will be escaped forcefully.
  * @param {boolean|RegExp|Function} [options.sanitizeValue=false] Controls the sanitization of cell value.
  * @returns {string}
  */
  _escapeCell(value, { force = false, sanitizeValue = false } = {}) {
    let returnValue = stringify$1(value);
    if (returnValue === "") {
      return returnValue;
    }
    if (sanitizeValue) {
      force = true;
    }
    if (sanitizeValue instanceof RegExp) {
      returnValue = _class_private_method_get$y(this, _sanitizeValueWithRegExp, sanitizeValueWithRegExp).call(this, returnValue, sanitizeValue);
    } else if (typeof sanitizeValue === "function") {
      returnValue = sanitizeValue(returnValue);
    } else if (sanitizeValue) {
      returnValue = _class_private_method_get$y(this, _sanitizeValueWithOWASP, sanitizeValueWithOWASP).call(this, returnValue);
    }
    if (force || returnValue.indexOf(CHAR_CARRIAGE_RETURN) >= 0 || returnValue.indexOf(CHAR_DOUBLE_QUOTES) >= 0 || returnValue.indexOf(CHAR_LINE_FEED) >= 0 || returnValue.indexOf(this.options.columnDelimiter) >= 0) {
      returnValue = returnValue.replaceAll('"', '""');
      returnValue = `"${returnValue}"`;
    }
    return returnValue;
  }
  constructor(...args) {
    super(...args), _class_private_method_init$y(this, _sanitizeValueWithOWASP), _class_private_method_init$y(this, _sanitizeValueWithRegExp);
  }
}
function sanitizeValueWithOWASP(value) {
  if (value.startsWith(CHAR_EQUAL) || value.startsWith(CHAR_PLUS) || value.startsWith(CHAR_MINUS) || value.startsWith(CHAR_AT) || value.startsWith(CHAR_TAB) || value.startsWith(CHAR_CARRIAGE_RETURN)) {
    return `'${value}`;
  }
  return value;
}
function sanitizeValueWithRegExp(value, regexp) {
  return regexp.test(value) ? `'${value}` : value;
}
const SUMMARY_TYPE_TO_EXCEL_FN = {
  sum: "SUM",
  min: "MIN",
  max: "MAX",
  count: "COUNT",
  average: "AVERAGE"
};
function colIndexToLetter(colIndex) {
  let letter = "";
  let n2 = colIndex;
  while (n2 > 0) {
    const remainder = (n2 - 1) % 26;
    letter = String.fromCharCode(65 + remainder) + letter;
    n2 = Math.floor((n2 - 1) / 26);
  }
  return letter;
}
function colLetterToIndex(letters) {
  let index2 = 0;
  for (let i = 0; i < letters.length; i++) {
    index2 = index2 * 26 + (letters.charCodeAt(i) - 64);
  }
  return index2;
}
function isFormulaValue(value) {
  return typeof value === "string" && value.startsWith("=");
}
function buildSummaryFormula(summary, dataRowOffset, dataColOffset) {
  const excelFn = SUMMARY_TYPE_TO_EXCEL_FN[summary.type];
  if (!excelFn) {
    return null;
  }
  const colLetter = colIndexToLetter(summary.sourceCol + dataColOffset);
  const rangeRefs = summary.sourceRanges.map(([start, end]) => {
    const startExcelRow = start + dataRowOffset;
    const endExcelRow = end + dataRowOffset;
    return startExcelRow === endExcelRow ? `${colLetter}${startExcelRow}` : `${colLetter}${startExcelRow}:${colLetter}${endExcelRow}`;
  });
  return {
    formula: `${excelFn}(${rangeRefs.join(",")})`
  };
}
function replaceSeparatorOutsideStrings(str, from, to) {
  let result = "";
  let inString = false;
  let stringChar = "";
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (inString) {
      result += ch;
      if (ch === stringChar) {
        if (str[i + 1] === stringChar) {
          result += str[i + 1];
          i += 1;
        } else {
          inString = false;
        }
      }
    } else if (ch === '"' || ch === "'") {
      inString = true;
      stringChar = ch;
      result += ch;
    } else if (str.startsWith(from, i)) {
      result += to;
      i += from.length - 1;
    } else {
      result += ch;
    }
  }
  return result;
}
function countBelow(set, threshold) {
  let count = 0;
  set.forEach((value) => {
    if (value < threshold) {
      count += 1;
    }
  });
  return count;
}
function normalizeFormula(formulaStr, separator, rowOffset, colOffset, excludedHiddenRows, excludedHiddenCols) {
  let formula = formulaStr.startsWith("=") ? formulaStr.slice(1) : formulaStr;
  const hasRowExclusions = (excludedHiddenRows?.size ?? 0) > 0;
  const hasColExclusions = (excludedHiddenCols?.size ?? 0) > 0;
  if (rowOffset !== 0 || colOffset !== 0 || hasRowExclusions || hasColExclusions) {
    formula = formula.replace(new RegExp(`("(?:[^"]|"")*"|'[^']*')|(?<!\\d)(\\$?)([A-Z]{1,3})(\\$?)(\\d{1,7})(?!\\()`, "g"), (match, strLiteral, colAbs, colLetters, rowAbs, rowStr) => {
      if (strLiteral !== void 0) {
        return strLiteral;
      }
      const hotPhysCol = colLetterToIndex(colLetters) - 1;
      const hotPhysRow = Number.parseInt(rowStr, 10) - 1;
      const hiddenColsBefore = hasColExclusions && excludedHiddenCols ? countBelow(excludedHiddenCols, hotPhysCol) : 0;
      const hiddenRowsBefore = hasRowExclusions && excludedHiddenRows ? countBelow(excludedHiddenRows, hotPhysRow) : 0;
      const newCol = colLetterToIndex(colLetters) + colOffset - hiddenColsBefore;
      const newRow = Number.parseInt(rowStr, 10) + rowOffset - hiddenRowsBefore;
      return `${colAbs}${colIndexToLetter(newCol)}${rowAbs}${newRow}`;
    });
  }
  if (separator && separator !== ",") {
    formula = replaceSeparatorOutsideStrings(formula, separator, ",");
  }
  return formula;
}
const READ_ONLY_BG_ARGB = "FFF0F0F0";
const READ_ONLY_TEXT_ARGB = "FF808080";
function normalizeClassNames(className) {
  if (Array.isArray(className)) {
    return className.filter((c) => typeof c === "string" && c.length > 0);
  }
  if (typeof className === "string") {
    return className.split(" ").filter((c) => c.length > 0);
  }
  return [];
}
const backgroundColorByDoc = /* @__PURE__ */ new WeakMap();
const cssStyleProbeByDoc = /* @__PURE__ */ new WeakMap();
function clearStyleCaches(doc) {
  backgroundColorByDoc.delete(doc);
  cssStyleProbeByDoc.delete(doc);
}
const ALIGNMENT_CLASS_NAMES = /* @__PURE__ */ new Set([
  "htLeft",
  "htRight",
  "htCenter",
  "htJustify",
  "htTop",
  "htMiddle",
  "htBottom"
]);
function rgbComputedToHex(rgbStr) {
  if (!rgbStr) {
    return null;
  }
  const m = rgbStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (!m) {
    return null;
  }
  const alpha = isDefined(m[4]) ? Number.parseFloat(m[4]) : 1;
  if (alpha === 0) {
    return null;
  }
  const r = Number.parseInt(m[1], 10).toString(16).padStart(2, "0");
  const g = Number.parseInt(m[2], 10).toString(16).padStart(2, "0");
  const b = Number.parseInt(m[3], 10).toString(16).padStart(2, "0");
  return `#${r}${g}${b}`.toUpperCase();
}
function detectExplicitBackgroundColor(doc, metaClasses, view) {
  const cacheKey = metaClasses.join(" ");
  let docCache = backgroundColorByDoc.get(doc);
  if (!docCache) {
    docCache = /* @__PURE__ */ new Map();
    backgroundColorByDoc.set(doc, docCache);
  }
  if (docCache.has(cacheKey)) {
    return docCache.get(cacheKey) ?? null;
  }
  const probe = doc.createElement("div");
  probe.className = "handsontable";
  probe.style.cssText = "position:absolute;top:-99999px;left:-99999px;visibility:hidden;pointer-events:none;";
  const table = doc.createElement("table");
  const tbody = doc.createElement("tbody");
  const tr = doc.createElement("tr");
  const tdFull = doc.createElement("td");
  tdFull.className = cacheKey;
  const tdBase = doc.createElement("td");
  tdBase.className = metaClasses.filter((c) => ALIGNMENT_CLASS_NAMES.has(c)).join(" ");
  tr.appendChild(tdFull);
  tr.appendChild(tdBase);
  tbody.appendChild(tr);
  table.appendChild(tbody);
  probe.appendChild(table);
  doc.body.appendChild(probe);
  const bgFull = view.getComputedStyle(tdFull).backgroundColor;
  const bgBase = view.getComputedStyle(tdBase).backgroundColor;
  doc.body.removeChild(probe);
  const result = bgFull !== bgBase ? rgbComputedToHex(bgFull) : null;
  docCache.set(cacheKey, result);
  return result;
}
function getCssStyleFromProbe(doc, view, metaClasses) {
  const cacheKey = metaClasses.join(" ");
  let docCache = cssStyleProbeByDoc.get(doc);
  if (!docCache) {
    docCache = /* @__PURE__ */ new Map();
    cssStyleProbeByDoc.set(doc, docCache);
  }
  if (docCache.has(cacheKey)) {
    return docCache.get(cacheKey);
  }
  const probe = doc.createElement("div");
  probe.className = "handsontable";
  probe.style.cssText = "position:absolute;top:-99999px;left:-99999px;visibility:hidden;pointer-events:none;";
  const table = doc.createElement("table");
  const tbody = doc.createElement("tbody");
  const tr = doc.createElement("tr");
  const tdFull = doc.createElement("td");
  tdFull.className = cacheKey;
  const tdBase = doc.createElement("td");
  tdBase.className = metaClasses.filter((c) => ALIGNMENT_CLASS_NAMES.has(c)).join(" ");
  tr.appendChild(tdFull);
  tr.appendChild(tdBase);
  tbody.appendChild(tr);
  table.appendChild(tbody);
  probe.appendChild(table);
  doc.body.appendChild(probe);
  const styleFull = view.getComputedStyle(tdFull);
  const styleBase = view.getComputedStyle(tdBase);
  const bgFull = styleFull.backgroundColor;
  const bgBase = styleBase.backgroundColor;
  const colorFull = styleFull.color;
  const colorBase = styleBase.color;
  doc.body.removeChild(probe);
  const result = {
    fontBold: Number.parseInt(styleFull.fontWeight, 10) >= 700 || styleFull.fontWeight === "bold",
    fontItalic: styleFull.fontStyle === "italic",
    fontUnderline: (styleFull.textDecorationLine || styleFull.textDecoration || "").includes("underline"),
    fontColor: colorFull !== colorBase ? rgbComputedToHex(colorFull) : null,
    backgroundColor: bgFull !== bgBase ? rgbComputedToHex(bgFull) : null
  };
  docCache.set(cacheKey, result);
  return result;
}
function getCssStyleFromElement(element, className, rootDocument = null, rootWindow = null) {
  if (!element) {
    if (!rootDocument || !rootWindow) {
      return null;
    }
    const metaClasses2 = normalizeClassNames(className);
    if (!metaClasses2.some((c) => !ALIGNMENT_CLASS_NAMES.has(c))) {
      return null;
    }
    return getCssStyleFromProbe(rootDocument, rootWindow, metaClasses2);
  }
  const view = element.ownerDocument?.defaultView;
  if (!view) {
    return null;
  }
  const style = view.getComputedStyle(element);
  const metaClasses = normalizeClassNames(className);
  const hasCustomClass = metaClasses.some((c) => !ALIGNMENT_CLASS_NAMES.has(c));
  return {
    fontBold: Number.parseInt(style.fontWeight, 10) >= 700 || style.fontWeight === "bold",
    fontItalic: style.fontStyle === "italic",
    fontUnderline: (style.textDecorationLine || style.textDecoration || "").includes("underline"),
    fontColor: hasCustomClass ? rgbComputedToHex(style.color) : null,
    backgroundColor: hasCustomClass ? detectExplicitBackgroundColor(element.ownerDocument, metaClasses, view) : null
  };
}
function cssColorToArgb(color) {
  if (!color || typeof color !== "string") {
    return "FF000000";
  }
  const hex = color.startsWith("#") ? color.slice(1) : color;
  if (hex.length === 3) {
    const r = hex[0] + hex[0];
    const g = hex[1] + hex[1];
    const b = hex[2] + hex[2];
    return `FF${r}${g}${b}`.toUpperCase();
  }
  if (hex.length === 6) {
    return `FF${hex}`.toUpperCase();
  }
  if (hex.length === 8) {
    return hex.toUpperCase();
  }
  return "FF000000";
}
function getAlignmentFromClassName(className) {
  if (!className) {
    return null;
  }
  return getAlignmentFromMeta({
    className
  });
}
function getAlignmentFromMeta(meta) {
  if (!meta?.className) {
    return null;
  }
  const classes = normalizeClassNames(meta.className);
  const alignment = {};
  if (classes.includes("htLeft")) {
    alignment.horizontal = "left";
  } else if (classes.includes("htCenter")) {
    alignment.horizontal = "center";
  } else if (classes.includes("htRight")) {
    alignment.horizontal = "right";
  } else if (classes.includes("htJustify")) {
    alignment.horizontal = "justify";
  }
  if (classes.includes("htTop")) {
    alignment.vertical = "top";
  } else if (classes.includes("htMiddle")) {
    alignment.vertical = "middle";
  } else if (classes.includes("htBottom")) {
    alignment.vertical = "bottom";
  }
  return Object.keys(alignment).length > 0 ? alignment : null;
}
function borderWidthToExcelStyle(width) {
  if (width >= 3) {
    return "thick";
  }
  if (width === 2) {
    return "medium";
  }
  return "thin";
}
function getBorderFromMeta(meta) {
  if (!meta?.borders) {
    return null;
  }
  const { borders } = meta;
  const excelBorder = {};
  [
    "top",
    "bottom",
    "left",
    "right"
  ].forEach((side) => {
    if (borders[side] && borders[side].width > 0) {
      excelBorder[side] = {
        style: borderWidthToExcelStyle(borders[side].width),
        color: {
          argb: cssColorToArgb(borders[side].color)
        }
      };
    }
  });
  return Object.keys(excelBorder).length > 0 ? excelBorder : null;
}
function getFontFromMeta(meta, cssStyle = null) {
  const isReadOnly = meta?.readOnly === true;
  const bold = cssStyle?.fontBold || false;
  const italic = cssStyle?.fontItalic || false;
  const underline = cssStyle?.fontUnderline || false;
  const colorHex = cssStyle?.fontColor ?? null;
  if (!bold && !italic && !underline && !colorHex && !isReadOnly) {
    return null;
  }
  const font = {};
  if (bold) {
    font.bold = true;
  }
  if (italic) {
    font.italic = true;
  }
  if (underline) {
    font.underline = true;
  }
  if (colorHex) {
    font.color = {
      argb: cssColorToArgb(colorHex)
    };
  } else if (isReadOnly) {
    font.color = {
      argb: READ_ONLY_TEXT_ARGB
    };
  }
  return Object.keys(font).length > 0 ? font : null;
}
function getFillFromMeta(meta, cssStyle = null) {
  let bgColor = null;
  if (cssStyle?.backgroundColor) {
    bgColor = cssColorToArgb(cssStyle.backgroundColor);
  } else if (meta?.readOnly === true) {
    bgColor = READ_ONLY_BG_ARGB;
  }
  if (!bgColor) {
    return null;
  }
  return {
    type: "pattern",
    pattern: "solid",
    fgColor: {
      argb: bgColor
    }
  };
}
function getDropdownValidation(meta, rangeRef) {
  if (!meta || !rangeRef) {
    return null;
  }
  const isDropdownType = meta.type === "dropdown" || meta.type === "autocomplete";
  if (!isDropdownType || !Array.isArray(meta.source)) {
    return null;
  }
  return {
    type: "list",
    allowBlank: true,
    formulae: [
      rangeRef
    ]
  };
}
const EXCEL_EPOCH_UTC = Date.UTC(1899, 11, 30);
const MS_PER_DAY = 864e5;
function toExcelDateSerial(date) {
  const localDateUtc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.round((localDateUtc - EXCEL_EPOCH_UTC) / MS_PER_DAY);
}
function parseIsoStringToSerial(value) {
  if (!value) {
    return null;
  }
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return null;
  }
  const year = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);
  const date = new Date(year, month - 1, day);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return toExcelDateSerial(date);
}
function parseTimeStringToSerial(value) {
  if (!value) {
    return null;
  }
  const str = String(value).trim();
  const match24 = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (match24) {
    const hours = parseInt(match24[1], 10);
    const minutes = parseInt(match24[2], 10);
    const seconds = match24[3] ? parseInt(match24[3], 10) : 0;
    if (hours > 23 || minutes > 59 || seconds > 59) {
      return null;
    }
    return (hours * 3600 + minutes * 60 + seconds) / 86400;
  }
  const match12 = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i);
  if (match12) {
    let hours = parseInt(match12[1], 10);
    const minutes = parseInt(match12[2], 10);
    const seconds = match12[3] ? parseInt(match12[3], 10) : 0;
    const period = match12[4].toUpperCase();
    if (hours > 12 || minutes > 59 || seconds > 59) {
      return null;
    }
    if (period === "AM" && hours === 12) {
      hours = 0;
    } else if (period === "PM" && hours !== 12) {
      hours += 12;
    }
    return (hours * 3600 + minutes * 60 + seconds) / 86400;
  }
  return null;
}
function getDateNumFmt() {
  return "mm-dd-yy";
}
function getTimeNumFmt() {
  return "h:mm:ss";
}
function getCurrencyInfo(currency, locale) {
  try {
    const parts = new Intl.NumberFormat(locale || "en", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).formatToParts(0);
    const symbol = parts.find((p) => p.type === "currency")?.value ?? currency;
    const currencyIndex = parts.findIndex((p) => p.type === "currency");
    const integerIndex = parts.findIndex((p) => p.type === "integer");
    const isPrefix = currencyIndex < integerIndex;
    return {
      symbol,
      isPrefix
    };
  } catch {
    return {
      symbol: currency,
      isPrefix: true
    };
  }
}
function intlNumFormatToExcelNumFmt(numericFormat, locale) {
  if (!numericFormat) {
    return null;
  }
  const { style, currency, minimumFractionDigits = 0, maximumFractionDigits, useGrouping = true } = numericFormat;
  const fractionDigits = maximumFractionDigits ?? minimumFractionDigits;
  const decimalPart = fractionDigits > 0 ? `.${"0".repeat(fractionDigits)}` : "";
  const intPart = useGrouping !== false ? "#,##0" : "0";
  if (style === "percent") {
    return `${intPart}${decimalPart}%`;
  }
  if (style === "currency" && currency) {
    const { symbol, isPrefix } = getCurrencyInfo(currency, locale);
    return isPrefix ? `${symbol}${intPart}${decimalPart}` : `${intPart}${decimalPart}${symbol}`;
  }
  return `${intPart}${decimalPart}`;
}
function _check_private_redeclaration$N(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$x(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$x(obj, privateSet) {
  _check_private_redeclaration$N(obj, privateSet);
  privateSet.add(obj);
}
const PIXELS_PER_EXCEL_COLUMN_WIDTH_UNIT = 7;
const PIXELS_TO_POINTS_RATIO = 0.75;
const ROW_HEADER_DEFAULT_WIDTH = 5;
var _populateWorksheet = /* @__PURE__ */ new WeakSet(), _writeDataRows = /* @__PURE__ */ new WeakSet(), _writeRowCells = /* @__PURE__ */ new WeakSet(), _writeCellStyling = /* @__PURE__ */ new WeakSet(), _resolveCellValue = /* @__PURE__ */ new WeakSet(), _getCellValue = /* @__PURE__ */ new WeakSet(), _getCheckboxValue = /* @__PURE__ */ new WeakSet(), _getMultiSelectExportValue = /* @__PURE__ */ new WeakSet(), _buildHeaderFill = /* @__PURE__ */ new WeakSet(), _buildHeaderBorder = /* @__PURE__ */ new WeakSet(), _getWriteOptions = /* @__PURE__ */ new WeakSet(), _applyConditionalFormatting = /* @__PURE__ */ new WeakSet(), _buildRangeRef = /* @__PURE__ */ new WeakSet(), _applyColumnWidths = /* @__PURE__ */ new WeakSet(), _applyHiddenColumns = /* @__PURE__ */ new WeakSet(), _applyHiddenRows = /* @__PURE__ */ new WeakSet(), _applyWorksheetViews = /* @__PURE__ */ new WeakSet(), _writeColumnHeaders = /* @__PURE__ */ new WeakSet(), _writeNestedColumnHeaders = /* @__PURE__ */ new WeakSet(), _applyNestedHeaderMerges = /* @__PURE__ */ new WeakSet(), _buildValidationSheet = /* @__PURE__ */ new WeakSet();
class Xlsx extends BaseType {
  /**
  * Marks this formatter as binary (non-stringifiable).
  *
  * @returns {boolean}
  */
  static get BINARY() {
    return true;
  }
  /**
  * Returns true to indicate that XLSX data should be treated as binary output.
  */
  get binary() {
    return true;
  }
  /**
  * Default options for exporting XLSX format.
  *
  * @returns {object}
  */
  static get DEFAULT_OPTIONS() {
    return {
      mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      fileExtension: "xlsx",
      bom: false,
      engine: null,
      // DEFLATE compression: true = level 6, number 1–9 = that level, falsy = no compression.
      compression: null,
      // Array of { rows?, cols?, rules } conditional formatting descriptors.
      conditionalFormatting: [],
      // When true, HyperFormula formula cells and ColumnSummary destinations are exported as live
      // Excel formulas. When false (default) the pre-calculated static values are exported.
      exportFormulas: false,
      // Style applied to column and row header cells. `backgroundColor` accepts any CSS hex color
      // string. `border` sets the border style on all four sides; set to `null` to suppress it.
      // Set the whole option to `null` to export headers with no styling at all.
      headerStyle: {
        backgroundColor: "#F2F2F2",
        border: {
          style: "thin"
        }
      }
    };
  }
  /**
  * Builds an XLSX workbook and returns its binary buffer.
  *
  * When the `sheets` option is provided the workbook contains one worksheet per entry,
  * each driven by its own Handsontable instance. Otherwise a single worksheet named
  * `'Sheet1'` is produced from the primary DataProvider.
  *
  * @returns {Promise<Uint8Array>}
  */
  async export() {
    const engine = this.options.engine;
    if (!engine || typeof engine.Workbook !== "function") {
      throwWithCause("Missing or invalid ExcelJS engine. Pass the ExcelJS module via the `engines` option in the exportFile plugin settings: `exportFile: { engines: { xlsx: ExcelJS } }`.");
    }
    const sheets = this.options.sheets;
    const docsToClear = sheets && sheets.length > 0 ? new Set(sheets.map((s) => s.instance.rootDocument)) : /* @__PURE__ */ new Set([
      this.dataProvider.hot.rootDocument
    ]);
    docsToClear.forEach((doc) => clearStyleCaches(doc));
    const workbook = new engine.Workbook();
    if (sheets && sheets.length > 0) {
      const usedSheetNames = /* @__PURE__ */ new Set();
      sheets.forEach((sheetConfig) => {
        const dp = new DataProvider2(sheetConfig.instance);
        const normalizedSheetConfig = "columnHeaders" in sheetConfig && !("colHeaders" in sheetConfig) ? {
          ...sheetConfig,
          colHeaders: sheetConfig.columnHeaders
        } : sheetConfig;
        const sheetOptions = {
          ...this.options,
          ...normalizedSheetConfig
        };
        dp.setOptions(sheetOptions);
        const baseName = sheetConfig.name || "Sheet";
        let name = baseName;
        let suffix = 1;
        while (usedSheetNames.has(name)) {
          name = `${baseName}${suffix}`;
          suffix += 1;
        }
        usedSheetNames.add(name);
        const worksheet = workbook.addWorksheet(name);
        _class_private_method_get$x(this, _populateWorksheet, populateWorksheet).call(this, workbook, worksheet, dp, sheetOptions);
      });
    } else {
      const worksheet = workbook.addWorksheet("Sheet1");
      _class_private_method_get$x(this, _populateWorksheet, populateWorksheet).call(this, workbook, worksheet, this.dataProvider, this.options);
    }
    return workbook.xlsx.writeBuffer(_class_private_method_get$x(this, _getWriteOptions, getWriteOptions).call(this));
  }
  constructor(...args) {
    super(...args), _class_private_method_init$x(this, _populateWorksheet), _class_private_method_init$x(this, _writeDataRows), _class_private_method_init$x(this, _writeRowCells), _class_private_method_init$x(this, _writeCellStyling), _class_private_method_init$x(this, _resolveCellValue), _class_private_method_init$x(this, _getCellValue), _class_private_method_init$x(this, _getCheckboxValue), _class_private_method_init$x(this, _getMultiSelectExportValue), _class_private_method_init$x(this, _buildHeaderFill), _class_private_method_init$x(this, _buildHeaderBorder), _class_private_method_init$x(this, _getWriteOptions), _class_private_method_init$x(this, _applyConditionalFormatting), _class_private_method_init$x(this, _buildRangeRef), _class_private_method_init$x(this, _applyColumnWidths), _class_private_method_init$x(this, _applyHiddenColumns), _class_private_method_init$x(this, _applyHiddenRows), _class_private_method_init$x(this, _applyWorksheetViews), _class_private_method_init$x(this, _writeColumnHeaders), _class_private_method_init$x(this, _writeNestedColumnHeaders), _class_private_method_init$x(this, _applyNestedHeaderMerges), _class_private_method_init$x(this, _buildValidationSheet);
  }
}
function populateWorksheet(workbook, worksheet, dataProvider, options) {
  const data = dataProvider.getData();
  const cellsMeta = dataProvider.getCellsMeta();
  const validationMap = _class_private_method_get$x(this, _buildValidationSheet, buildValidationSheet).call(this, workbook, cellsMeta);
  const cellElements = dataProvider.getCellElements();
  const columnHeaders = dataProvider.getColumnHeaders();
  const columnHeadersClassNames = dataProvider.getColumnHeadersClassNames();
  const rowHeaders = dataProvider.getRowHeaders();
  const columnsWidths = dataProvider.getColumnsWidths();
  const rowsHeights = dataProvider.getRowsHeights();
  const mergeCells = dataProvider.getMergeCells();
  const frozenRows = dataProvider.getFrozenRows();
  const frozenColumns = dataProvider.getFrozenColumns();
  const nestedColumnHeaders = dataProvider.getNestedColumnHeaders();
  const isRtl2 = dataProvider.getLayoutDirection() === "rtl";
  const exportFormulas = options.exportFormulas ?? false;
  const summaryMap = /* @__PURE__ */ new Map();
  const columnSummaries = dataProvider.getColumnSummaries();
  columnSummaries.forEach((summaryRaw) => {
    const summary = summaryRaw;
    summaryMap.set(`${summary.destRow}:${summary.destCol}`, summary);
  });
  const sourceData = exportFormulas ? dataProvider.getSourceData() : null;
  const formulasSeparator = exportFormulas ? dataProvider.getFormulasSeparator() : ",";
  const hasColumnHeaders = columnHeaders.length > 0;
  const hasRowHeaders = rowHeaders.length > 0;
  const useNestedHeaders = nestedColumnHeaders !== null && hasColumnHeaders;
  let headerRowCount = 0;
  if (useNestedHeaders) {
    headerRowCount = nestedColumnHeaders.length;
  } else if (hasColumnHeaders) {
    headerRowCount = 1;
  }
  const dataRowOffset = headerRowCount + 1;
  const dataColOffset = hasRowHeaders ? 2 : 1;
  const excludedHiddenRows = exportFormulas ? dataProvider.getExcludedHiddenRows() : null;
  const excludedHiddenCols = exportFormulas ? dataProvider.getExcludedHiddenColumns() : null;
  const hiddenRowIndices = dataProvider.getHiddenRowDataIndices();
  const hiddenColIndices = dataProvider.getHiddenColumnDataIndices();
  const { rootDocument, rootWindow } = dataProvider.hot;
  _class_private_method_get$x(this, _applyColumnWidths, applyColumnWidths).call(this, worksheet, columnsWidths, hasRowHeaders);
  if (hiddenColIndices.length > 0) {
    _class_private_method_get$x(this, _applyHiddenColumns, applyHiddenColumns).call(this, worksheet, hiddenColIndices, hasRowHeaders);
  }
  _class_private_method_get$x(this, _applyWorksheetViews, applyWorksheetViews).call(this, worksheet, frozenRows, frozenColumns, headerRowCount, hasRowHeaders, isRtl2);
  const headerFill = _class_private_method_get$x(this, _buildHeaderFill, buildHeaderFill).call(this, options.headerStyle);
  const headerBorder = _class_private_method_get$x(this, _buildHeaderBorder, buildHeaderBorder).call(this, options.headerStyle);
  if (useNestedHeaders) {
    _class_private_method_get$x(this, _writeNestedColumnHeaders, writeNestedColumnHeaders).call(this, worksheet, nestedColumnHeaders, hasRowHeaders, dataColOffset, headerFill, headerBorder);
    _class_private_method_get$x(this, _applyNestedHeaderMerges, applyNestedHeaderMerges).call(this, worksheet, nestedColumnHeaders, hasRowHeaders, dataColOffset);
  } else if (hasColumnHeaders) {
    _class_private_method_get$x(this, _writeColumnHeaders, writeColumnHeaders).call(this, worksheet, columnHeaders, columnHeadersClassNames, hasRowHeaders, dataColOffset, headerFill, headerBorder);
  }
  const hasColumnSummary = summaryMap.size > 0;
  const hasReadOnlyCells = !hasColumnSummary && cellsMeta.some((row) => row.some((meta) => meta?.readOnly === true));
  const context = {
    exportFormulas,
    formulasSeparator,
    dataRowOffset,
    dataColOffset,
    excludedHiddenRows,
    excludedHiddenCols,
    summaryMap,
    sourceData,
    hasRowHeaders,
    headerFill,
    headerBorder,
    hasReadOnlyCells,
    rootDocument,
    rootWindow,
    validationMap,
    cellsMeta,
    cellElements,
    rowHeaders,
    rowsHeights
  };
  _class_private_method_get$x(this, _writeDataRows, writeDataRows).call(this, worksheet, data, context);
  if (hiddenRowIndices.length > 0) {
    _class_private_method_get$x(this, _applyHiddenRows, applyHiddenRows).call(this, worksheet, hiddenRowIndices, dataRowOffset);
  }
  if (hasReadOnlyCells) {
    worksheet.protect("", {
      selectLockedCells: true,
      selectUnlockedCells: true,
      formatColumns: true,
      formatRows: true,
      sort: true,
      autoFilter: true
    });
  }
  mergeCells.forEach((merge2) => {
    const startRow = merge2.row + dataRowOffset;
    const startCol = merge2.col + dataColOffset;
    const endRow = startRow + merge2.rowspan - 1;
    const endCol = startCol + merge2.colspan - 1;
    worksheet.mergeCells(startRow, startCol, endRow, endCol);
  });
  const { conditionalFormatting } = options;
  if (conditionalFormatting && conditionalFormatting.length > 0) {
    _class_private_method_get$x(this, _applyConditionalFormatting, applyConditionalFormatting).call(this, worksheet, conditionalFormatting, dataRowOffset, dataColOffset, data.length, data[0]?.length ?? 0);
  }
  return data.length;
}
function writeDataRows(worksheet, data, context) {
  for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
    const rowData = data[rowIndex];
    const excelRowNumber = rowIndex + context.dataRowOffset;
    const row = worksheet.getRow(excelRowNumber);
    if (isDefined(context.rowsHeights[rowIndex])) {
      row.height = context.rowsHeights[rowIndex] * PIXELS_TO_POINTS_RATIO;
    }
    if (context.hasRowHeaders) {
      const rowHeaderCell = row.getCell(1);
      rowHeaderCell.value = context.rowHeaders[rowIndex] ?? null;
      if (context.headerFill) {
        rowHeaderCell.fill = context.headerFill;
      }
      if (context.headerBorder) {
        rowHeaderCell.border = context.headerBorder;
      }
    }
    _class_private_method_get$x(this, _writeRowCells, writeRowCells).call(this, row, rowData, rowIndex, context);
    row.commit();
  }
}
function writeRowCells(row, rowData, rowIndex, context) {
  for (let colIndex = 0; colIndex < rowData.length; colIndex++) {
    const cellValue = rowData[colIndex];
    const cell = row.getCell(colIndex + context.dataColOffset);
    const meta = context.cellsMeta[rowIndex][colIndex];
    const summary = context.summaryMap.get(`${rowIndex}:${colIndex}`);
    const sourceValue = context.sourceData?.[rowIndex][colIndex];
    const { value, numFmt } = _class_private_method_get$x(this, _resolveCellValue, resolveCellValue).call(this, cellValue, meta, sourceValue, summary, context);
    cell.value = value;
    if (numFmt) {
      cell.numFmt = numFmt;
    }
    const cssStyle = getCssStyleFromElement(context.cellElements[rowIndex][colIndex], meta.className, context.rootDocument, context.rootWindow);
    _class_private_method_get$x(this, _writeCellStyling, writeCellStyling).call(this, cell, meta, cssStyle, context);
    if (context.hasReadOnlyCells) {
      cell.protection = {
        locked: meta.readOnly === true
      };
    }
  }
}
function writeCellStyling(cell, meta, cssStyle, context) {
  const alignment = getAlignmentFromMeta(meta);
  if (alignment) {
    cell.alignment = alignment;
  }
  const border = getBorderFromMeta(meta);
  if (border) {
    cell.border = border;
  }
  const font = getFontFromMeta(meta, cssStyle);
  if (font) {
    cell.font = font;
  }
  const fill = getFillFromMeta(meta, cssStyle);
  if (fill) {
    cell.fill = fill;
  }
  const rangeRef = Array.isArray(meta.source) ? context.validationMap.get(JSON.stringify(meta.source)) ?? null : null;
  const dropdownValidation = getDropdownValidation(meta, rangeRef);
  if (dropdownValidation) {
    cell.dataValidation = dropdownValidation;
  }
  if (meta.comment?.value) {
    cell.note = String(meta.comment.value);
  }
}
function resolveCellValue(cellValue, meta, sourceValue, summary, context) {
  const { exportFormulas, formulasSeparator, dataRowOffset, dataColOffset, excludedHiddenRows, excludedHiddenCols } = context;
  if (summary && exportFormulas) {
    const formula = buildSummaryFormula(summary, dataRowOffset, dataColOffset);
    const fallback = _class_private_method_get$x(this, _getCellValue, getCellValue).call(this, cellValue, meta);
    return {
      value: formula ? {
        ...formula,
        result: cellValue
      } : fallback,
      numFmt: null
    };
  }
  if (exportFormulas && isFormulaValue(sourceValue)) {
    return {
      value: {
        formula: normalizeFormula(sourceValue, formulasSeparator, dataRowOffset - 1, dataColOffset - 1, excludedHiddenRows ?? void 0, excludedHiddenCols ?? void 0)
      },
      numFmt: null
    };
  }
  if (meta.type === "date" || meta.type === "intl-date") {
    const serial = parseIsoStringToSerial(cellValue);
    if (serial !== null) {
      return {
        value: serial,
        numFmt: getDateNumFmt()
      };
    }
  }
  if (meta.type === "time" || meta.type === "intl-time") {
    const serial = parseTimeStringToSerial(cellValue);
    if (serial !== null) {
      return {
        value: serial,
        numFmt: getTimeNumFmt()
      };
    }
  }
  if (meta.type === "checkbox") {
    return {
      value: _class_private_method_get$x(this, _getCheckboxValue, getCheckboxValue).call(this, cellValue, meta),
      numFmt: null
    };
  }
  if (meta.type === "multiselect") {
    return {
      value: _class_private_method_get$x(this, _getMultiSelectExportValue, getMultiSelectExportValue).call(this, cellValue),
      numFmt: null
    };
  }
  if (meta.type === "numeric") {
    return {
      value: _class_private_method_get$x(this, _getCellValue, getCellValue).call(this, cellValue, meta),
      numFmt: intlNumFormatToExcelNumFmt(meta.numericFormat, meta.locale)
    };
  }
  return {
    value: _class_private_method_get$x(this, _getCellValue, getCellValue).call(this, cellValue, meta),
    numFmt: null
  };
}
function getCellValue(value, meta) {
  if (value === null || value === void 0) {
    return null;
  }
  if (meta.type === "numeric") {
    if (typeof value === "number") {
      return value;
    }
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? stringify$1(value) : numericValue;
  }
  return stringify$1(value);
}
function getCheckboxValue(value, meta) {
  const checkedTemplate = meta.checkedTemplate ?? true;
  return value === checkedTemplate;
}
function getMultiSelectExportValue(value) {
  if (!Array.isArray(value)) {
    return value === null || value === void 0 ? null : stringify$1(value);
  }
  if (value.length === 0) {
    return null;
  }
  return value.map((item) => item !== null && typeof item === "object" ? String(item.value) : String(item)).join(", ");
}
function buildHeaderFill(headerStyle) {
  if (!headerStyle?.backgroundColor) {
    return null;
  }
  return {
    type: "pattern",
    pattern: "solid",
    fgColor: {
      argb: cssColorToArgb(headerStyle.backgroundColor)
    }
  };
}
function buildHeaderBorder(headerStyle) {
  if (!headerStyle?.border) {
    return null;
  }
  const { style = "thin", color } = headerStyle.border;
  const side = color ? {
    style,
    color: {
      argb: cssColorToArgb(color)
    }
  } : {
    style
  };
  return {
    top: side,
    bottom: side,
    left: side,
    right: side
  };
}
function getWriteOptions() {
  const { compression } = this.options;
  let level = null;
  if (compression === true) {
    level = 6;
  } else if (typeof compression === "number" && compression >= 1 && compression <= 9) {
    level = compression;
  }
  if (level === null) {
    return {};
  }
  return {
    zip: {
      compression: "DEFLATE",
      compressionOptions: {
        level
      }
    }
  };
}
function applyConditionalFormatting(worksheet, cfRules, dataRowOffset, dataColOffset, dataRows, dataCols) {
  if (dataRows === 0 || dataCols === 0) {
    return;
  }
  cfRules.forEach(({ rows, cols, rules }) => {
    if (!rules || rules.length === 0) {
      return;
    }
    const startRow = (rows ? rows[0] : 0) + dataRowOffset;
    const endRow = (rows ? rows[1] : dataRows - 1) + dataRowOffset;
    const startCol = (cols ? cols[0] : 0) + dataColOffset;
    const endCol = (cols ? cols[1] : dataCols - 1) + dataColOffset;
    worksheet.addConditionalFormatting({
      ref: _class_private_method_get$x(this, _buildRangeRef, buildRangeRef).call(this, startRow, startCol, endRow, endCol),
      rules
    });
  });
}
function buildRangeRef(startRow, startCol, endRow, endCol) {
  return `${colIndexToLetter(startCol)}${startRow}:${colIndexToLetter(endCol)}${endRow}`;
}
function applyColumnWidths(worksheet, widths, hasRowHeaders) {
  if (hasRowHeaders) {
    worksheet.getColumn(1).width = ROW_HEADER_DEFAULT_WIDTH;
  }
  const offset2 = hasRowHeaders ? 1 : 0;
  for (let index2 = 0; index2 < widths.length; index2++) {
    worksheet.getColumn(index2 + 1 + offset2).width = Math.max(widths[index2] / PIXELS_PER_EXCEL_COLUMN_WIDTH_UNIT, 1);
  }
}
function applyHiddenColumns(worksheet, hiddenColIndices, hasRowHeaders) {
  const offset2 = hasRowHeaders ? 1 : 0;
  hiddenColIndices.forEach((dataColIndex) => {
    worksheet.getColumn(dataColIndex + 1 + offset2).hidden = true;
  });
}
function applyHiddenRows(worksheet, hiddenRowIndices, dataRowOffset) {
  hiddenRowIndices.forEach((dataRowIndex) => {
    worksheet.getRow(dataRowIndex + dataRowOffset).hidden = true;
  });
}
function applyWorksheetViews(worksheet, frozenRows, frozenColumns, headerRowCount, hasRowHeaders, isRtl2) {
  const hasFrozenPanes = frozenRows > 0 || frozenColumns > 0;
  if (!hasFrozenPanes && !isRtl2) {
    return;
  }
  const view = {};
  if (isRtl2) {
    view.rightToLeft = true;
  }
  if (hasFrozenPanes) {
    view.state = "frozen";
    view.xSplit = frozenColumns + (hasRowHeaders ? 1 : 0);
    view.ySplit = frozenRows + headerRowCount;
  }
  worksheet.views = [
    view
  ];
}
function writeColumnHeaders(worksheet, columnHeaders, classNames, hasRowHeaders, dataColOffset, headerFill, headerBorder) {
  const headerRow = worksheet.getRow(1);
  if (hasRowHeaders) {
    const cornerCell = headerRow.getCell(1);
    cornerCell.value = "";
    if (headerFill) {
      cornerCell.fill = headerFill;
    }
    if (headerBorder) {
      cornerCell.border = headerBorder;
    }
  }
  for (let index2 = 0; index2 < columnHeaders.length; index2++) {
    const cell = headerRow.getCell(index2 + dataColOffset);
    cell.value = columnHeaders[index2] ?? null;
    const alignment = getAlignmentFromClassName(classNames[index2]);
    if (alignment) {
      cell.alignment = alignment;
    }
    if (headerFill) {
      cell.fill = headerFill;
    }
    if (headerBorder) {
      cell.border = headerBorder;
    }
  }
  headerRow.commit();
}
function writeNestedColumnHeaders(worksheet, nestedColumnHeaders, hasRowHeaders, dataColOffset, headerFill, headerBorder) {
  for (let layerIndex = 0; layerIndex < nestedColumnHeaders.length; layerIndex++) {
    const layerHeaders = nestedColumnHeaders[layerIndex];
    const row = worksheet.getRow(layerIndex + 1);
    if (hasRowHeaders && layerIndex === 0) {
      const cornerCell = row.getCell(1);
      cornerCell.value = "";
      if (headerFill) {
        cornerCell.fill = headerFill;
      }
      if (headerBorder) {
        cornerCell.border = headerBorder;
      }
    }
    let colPos = dataColOffset;
    layerHeaders.forEach((header) => {
      const cell = row.getCell(colPos);
      cell.value = header.label ?? null;
      const alignment = getAlignmentFromClassName(header.className);
      if (alignment) {
        cell.alignment = alignment;
      }
      if (headerFill) {
        cell.fill = headerFill;
      }
      if (headerBorder) {
        cell.border = headerBorder;
      }
      colPos += header.colspan;
    });
    row.commit();
  }
}
function applyNestedHeaderMerges(worksheet, nestedColumnHeaders, hasRowHeaders, dataColOffset) {
  if (hasRowHeaders && nestedColumnHeaders.length > 1) {
    worksheet.mergeCells(1, 1, nestedColumnHeaders.length, 1);
  }
  for (let layerIndex = 0; layerIndex < nestedColumnHeaders.length; layerIndex++) {
    const layerHeaders = nestedColumnHeaders[layerIndex];
    const excelRow = layerIndex + 1;
    let colPos = dataColOffset;
    layerHeaders.forEach((header) => {
      if (header.colspan > 1) {
        worksheet.mergeCells(excelRow, colPos, excelRow, colPos + header.colspan - 1);
      }
      colPos += header.colspan;
    });
  }
}
function buildValidationSheet(workbook, cellsMeta) {
  const sourceMap = /* @__PURE__ */ new Map();
  for (let rowIndex = 0; rowIndex < cellsMeta.length; rowIndex++) {
    for (let colIndex = 0; colIndex < cellsMeta[rowIndex].length; colIndex++) {
      const meta = cellsMeta[rowIndex][colIndex];
      const isDropdown = meta.type === "dropdown" || meta.type === "autocomplete";
      if (isDropdown && Array.isArray(meta.source) && meta.source.length > 0) {
        const key = JSON.stringify(meta.source);
        if (!sourceMap.has(key)) {
          sourceMap.set(key, meta.source);
        }
      }
    }
  }
  if (sourceMap.size === 0) {
    return /* @__PURE__ */ new Map();
  }
  const existingNames = new Set(workbook.worksheets.map((ws) => ws.name));
  let sheetName = "_HotValidation";
  let suffix = 1;
  while (existingNames.has(sheetName)) {
    sheetName = `_HotValidation${suffix}`;
    suffix += 1;
  }
  const validationSheet = workbook.addWorksheet(sheetName);
  validationSheet.state = "veryHidden";
  const validationMap = /* @__PURE__ */ new Map();
  let colNumber = 1;
  sourceMap.forEach((source, key) => {
    for (let rowNumber = 0; rowNumber < source.length; rowNumber++) {
      const item = source[rowNumber];
      validationSheet.getCell(rowNumber + 1, colNumber).value = isKeyValueObject(item) ? String(item.value) : String(item);
    }
    const colLetter = colIndexToLetter(colNumber);
    const escapedName = sheetName.replaceAll("'", "''");
    const rangeRef = `'${escapedName}'!$${colLetter}$1:$${colLetter}$${source.length}`;
    validationMap.set(key, rangeRef);
    colNumber += 1;
  });
  return validationMap;
}
const TYPE_CSV = "csv";
const TYPE_XLSX = "xlsx";
const EXPORT_TYPES = {
  [TYPE_CSV]: Csv,
  [TYPE_XLSX]: Xlsx
};
function typeFactory(type, dataProvider, options) {
  const ExportType = EXPORT_TYPES[type];
  if (typeof ExportType === "function") {
    return new ExportType(dataProvider, options);
  }
  return null;
}
function getExportOptions(hot) {
  const settings = hot.getSettings();
  const colHeaders = !!(settings.colHeaders || settings.nestedHeaders);
  const rowHeaders = !!settings.rowHeaders;
  const range = hot.getSelectedRangeLast();
  const opts = {
    colHeaders,
    rowHeaders
  };
  if (!range || range.isSingleCell() || (range.from.row ?? 0) < 0 && (range.from.col ?? 0) < 0) {
    return opts;
  }
  return {
    ...opts,
    range: [
      Math.max(0, Math.min(range.from.row ?? 0, range.to.row ?? 0)),
      Math.max(0, Math.min(range.from.col ?? 0, range.to.col ?? 0)),
      Math.max(range.from.row ?? 0, range.to.row ?? 0),
      Math.max(range.from.col ?? 0, range.to.col ?? 0)
    ]
  };
}
function exportItem(exportFilePlugin) {
  return {
    key: "export_file",
    name() {
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_EXPORT);
    },
    hidden() {
      return this.getSettings()[PLUGIN_KEY$o] === void 0;
    },
    submenu: {
      items: [
        {
          key: "export_file:csv",
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_EXPORT_FILE_CSV);
          },
          callback() {
            exportFilePlugin.downloadFile("csv", getExportOptions(this));
          },
          disabled: false
        },
        {
          key: "export_file:xlsx",
          name() {
            return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_EXPORT_FILE_XLSX);
          },
          callback() {
            exportFilePlugin.downloadFileAsync("xlsx", getExportOptions(this)).catch((err) => {
              error("ExportFile: XLSX export failed.", err);
            });
          },
          hidden() {
            return !exportFilePlugin.supportsExportFormat("xlsx");
          }
        }
      ]
    }
  };
}
function buildExportDialogContent(title) {
  const { fragment } = html`
    <div class="${LOADING_CLASS_NAME}__content">
      <i class="${LOADING_CLASS_NAME}__icon">
        <svg class="${LOADING_CLASS_NAME}__icon-svg"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
          <path stroke="currentColor" stroke-width="2" d="M15 8a7 7 0 1 1-3.5-6.062"></path>
        </svg>
      </i>
      <div class="${LOADING_CLASS_NAME}__text">
        <h2 class="${LOADING_CLASS_NAME}__title">${title}</h2>
      </div>
    </div>
  `;
  return fragment;
}
function _check_private_redeclaration$M(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$F(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$F(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$F(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$F(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$F(receiver, privateMap, "get");
  return _class_apply_descriptor_get$F(receiver, descriptor);
}
function _class_private_field_init$F(obj, privateMap, value) {
  _check_private_redeclaration$M(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$F(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$F(receiver, privateMap, "set");
  _class_apply_descriptor_set$F(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$w(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$w(obj, privateSet) {
  _check_private_redeclaration$M(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$o = "exportFile";
const PLUGIN_PRIORITY$o = 240;
function isExportFileSettings(v) {
  return isObject$1(v);
}
function getPluginSettings(settings) {
  return isExportFileSettings(settings) ? settings : void 0;
}
var _onAfterContextMenuDefaultOptions$3 = /* @__PURE__ */ new WeakMap(), _triggerDownload = /* @__PURE__ */ new WeakSet();
class ExportFile extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$o;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$o;
  }
  /**
  * Returns the setting keys that trigger a plugin update when changed via `updateSettings`.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$o
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ExportFile#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return true;
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("afterContextMenuDefaultOptions", _class_private_field_get$F(this, _onAfterContextMenuDefaultOptions$3));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
  }
  /**
  * Exports table data as a string.
  *
  * This method is only supported for text-based formats such as CSV.
  * Calling it with a binary format (e.g. `'xlsx'`) throws an error.
  *
  * @param {string} format Export format type eq. `'csv'`.
  * @param {object} options Export options.
  * @param {string} [options.mimeType] MIME type (e.g. `'text/csv'` for CSV). Default depends on format.
  * @param {string} [options.fileExtension] File extension (e.g. `'csv'`). Default depends on format.
  * @param {string} [options.filename='Handsontable [YYYY]-[MM]-[DD]'] File name. Placeholders `[YYYY]`, `[MM]`, `[DD]` are replaced with the current date.
  * @param {string} [options.encoding='utf-8'] Character encoding.
  * @param {boolean} [options.bom] Include BOM signature. Default depends on format (e.g. `true` for CSV).
  * @param {string} [options.columnDelimiter=','] Column delimiter (CSV only).
  * @param {string} [options.rowDelimiter='\r\n'] Row delimiter (CSV only).
  * @param {boolean} [options.colHeaders=false] Include column headers in the exported file.
  * @param {boolean} [options.rowHeaders=false] Include row headers in the exported file.
  * @param {boolean|string} [options.exportHiddenColumns=false] Controls how hidden columns are handled. `true` exports them as normal visible columns. `false` omits them entirely. `'hide'` exports them and marks them as hidden in Excel (XLSX only).
  * @param {boolean|string} [options.exportHiddenRows=false] Controls how hidden rows are handled. `true` exports them as normal visible rows. `false` omits them entirely. `'hide'` exports them and marks them as hidden in Excel (XLSX only).
  * @param {number[]} [options.range=[]] Cell range to export: `[startRow, startColumn, endRow, endColumn]` (visual indexes).
  * @param {boolean|RegExp|Function} [options.sanitizeValues=false] Controls the sanitization of cell values (CSV only).
  * @returns {string}
  */
  exportAsString(format2, options = {}) {
    const formatter = this._createTypeFormatter(format2, options);
    if (formatter.binary) {
      throwWithCause(`Export format type "${format2}" cannot be exported as a string (binary format).`);
    }
    return formatter.export();
  }
  /**
  * Exports table data as a blob object.
  *
  * This method is only supported for text-based formats such as CSV.
  * Calling it with a binary format (e.g. `'xlsx'`) throws an error — use
  * [[ExportFile#exportAsBlobAsync]] instead.
  *
  * @param {string} format Export format type e.g. `'csv'`.
  * @param {object} options Export options.
  * @param {string} [options.mimeType] MIME type. Default depends on format.
  * @param {string} [options.fileExtension] File extension. Default depends on format.
  * @param {string} [options.filename='Handsontable [YYYY]-[MM]-[DD]'] File name.
  * @param {string} [options.encoding='utf-8'] Character encoding.
  * @param {boolean} [options.bom] Include BOM signature. Default depends on format (e.g. `true` for CSV).
  * @param {string} [options.columnDelimiter=','] Column delimiter (CSV only).
  * @param {string} [options.rowDelimiter='\r\n'] Row delimiter (CSV only).
  * @param {boolean} [options.colHeaders=false] Include column headers.
  * @param {boolean} [options.rowHeaders=false] Include row headers.
  * @param {boolean} [options.exportHiddenColumns=false] Include hidden columns.
  * @param {boolean} [options.exportHiddenRows=false] Include hidden rows.
  * @param {number[]} [options.range=[]] Cell range: `[startRow, startColumn, endRow, endColumn]`.
  * @param {boolean|RegExp|Function} [options.sanitizeValues=false] Sanitization (CSV only).
  * @returns {Blob}
  */
  exportAsBlob(format2, options = {}) {
    const formatter = this._createTypeFormatter(format2, options);
    if (formatter.binary) {
      throwWithCause(`exportAsBlob() does not support binary formats such as "${format2}". Use exportAsBlobAsync() instead.`);
    }
    return this._createBlob(formatter);
  }
  /**
  * Exports table data as a blob object, asynchronously.
  *
  * Supports all export formats. For text-based formats (e.g. `'csv'`),
  * the `Promise` resolves immediately. For binary formats (e.g. `'xlsx'`),
  * the export runs asynchronously.
  *
  * @param {string} format Export format type e.g. `'csv'` or `'xlsx'`.
  * @param {object} options Export options.
  * @param {string} [options.mimeType] MIME type. Default depends on format.
  * @param {string} [options.fileExtension] File extension. Default depends on format.
  * @param {string} [options.filename='Handsontable [YYYY]-[MM]-[DD]'] File name.
  * @param {string} [options.encoding='utf-8'] Character encoding (text formats only).
  * @param {boolean} [options.bom] Include BOM signature (text formats only).
  * @param {string} [options.columnDelimiter=','] Column delimiter (CSV only).
  * @param {string} [options.rowDelimiter='\r\n'] Row delimiter (CSV only).
  * @param {boolean} [options.colHeaders=false] Include column headers.
  * @param {boolean} [options.rowHeaders=false] Include row headers.
  * @param {boolean} [options.exportHiddenColumns=false] Include hidden columns.
  * @param {boolean} [options.exportHiddenRows=false] Include hidden rows.
  * @param {number[]} [options.range=[]] Cell range: `[startRow, startColumn, endRow, endColumn]`.
  * @param {boolean|RegExp|Function} [options.sanitizeValues=false] Sanitization (CSV only).
  * @param {boolean} [options.exportFormulas=false] Export cell formulas instead of their computed values (XLSX only).
  * @param {boolean|number} [options.compression] Enable DEFLATE compression: `true` uses level 6; a number 1–9 sets a specific level. Omit or pass a falsy value to use no compression (XLSX only).
  * @param {ConditionalFormattingDescriptor[]} [options.conditionalFormatting=[]] Conditional formatting rules to apply to the exported file (XLSX only).
  * @param {SheetOptions[]} [options.sheets=[]] Configuration for multi-sheet export. Each entry defines one worksheet (XLSX only).
  * @returns {Promise<Blob>}
  * @since 17.1.0
  */
  async exportAsBlobAsync(format2, options = {}) {
    return this._createBlob(this._createTypeFormatter(format2, options));
  }
  /**
  * Triggers a synchronous file download for text-based export formats (e.g. `'csv'`).
  *
  * Calling this method with a binary format (e.g. `'xlsx'`) throws an error — use
  * [[ExportFile#downloadFileAsync]] instead.
  *
  * @param {string} format Export format type e.g. `'csv'`.
  * @param {object} options Export options.
  * @param {string} [options.mimeType] MIME type. Default depends on format.
  * @param {string} [options.fileExtension] File extension. Default depends on format.
  * @param {string} [options.filename='Handsontable [YYYY]-[MM]-[DD]'] File name.
  * @param {string} [options.encoding='utf-8'] Character encoding.
  * @param {boolean} [options.bom] Include BOM signature. Default depends on format.
  * @param {string} [options.columnDelimiter=','] Column delimiter (CSV only).
  * @param {string} [options.rowDelimiter='\r\n'] Row delimiter (CSV only).
  * @param {boolean} [options.colHeaders=false] Include column headers.
  * @param {boolean} [options.rowHeaders=false] Include row headers.
  * @param {boolean} [options.exportHiddenColumns=false] Include hidden columns.
  * @param {boolean} [options.exportHiddenRows=false] Include hidden rows.
  * @param {number[]} [options.range=[]] Cell range: `[startRow, startColumn, endRow, endColumn]`.
  * @param {boolean|RegExp|Function} [options.sanitizeValues=false] Sanitization (CSV only).
  * @returns {void}
  */
  downloadFile(format2, options = {}) {
    const formatter = this._createTypeFormatter(format2, options);
    if (formatter.binary) {
      throwWithCause(`downloadFile() does not support binary formats such as "${format2}". Use downloadFileAsync() instead.`);
    }
    const name = `${formatter.options.filename}.${formatter.options.fileExtension}`;
    _class_private_method_get$w(this, _triggerDownload, triggerDownload).call(this, this._createBlob(formatter), name);
  }
  /**
  * Triggers an asynchronous file download. Supports all export formats.
  *
  * For text-based formats (e.g. `'csv'`), the download is triggered immediately
  * and the returned `Promise` resolves right away.
  * For binary formats (e.g. `'xlsx'`), the export runs asynchronously. When the
  * `dialog` plugin is enabled, a progress overlay is shown for the duration of the export.
  *
  * @param {string} format Export format type e.g. `'csv'` or `'xlsx'`.
  * @param {object} options Export options.
  * @param {string} [options.mimeType] MIME type. Default depends on format.
  * @param {string} [options.fileExtension] File extension. Default depends on format.
  * @param {string} [options.filename='Handsontable [YYYY]-[MM]-[DD]'] File name.
  * @param {string} [options.encoding='utf-8'] Character encoding (text formats only).
  * @param {boolean} [options.bom] Include BOM signature (text formats only).
  * @param {string} [options.columnDelimiter=','] Column delimiter (CSV only).
  * @param {string} [options.rowDelimiter='\r\n'] Row delimiter (CSV only).
  * @param {boolean} [options.colHeaders=false] Include column headers.
  * @param {boolean} [options.rowHeaders=false] Include row headers.
  * @param {boolean} [options.exportHiddenColumns=false] Include hidden columns.
  * @param {boolean} [options.exportHiddenRows=false] Include hidden rows.
  * @param {number[]} [options.range=[]] Cell range: `[startRow, startColumn, endRow, endColumn]`.
  * @param {boolean|RegExp|Function} [options.sanitizeValues=false] Sanitization (CSV only).
  * @param {boolean} [options.exportFormulas=false] Export cell formulas instead of their computed values (XLSX only).
  * @param {boolean|number} [options.compression] Enable DEFLATE compression: `true` uses level 6; a number 1–9 sets a specific level. Omit or pass a falsy value to use no compression (XLSX only).
  * @param {ConditionalFormattingDescriptor[]} [options.conditionalFormatting=[]] Conditional formatting rules to apply to the exported file (XLSX only).
  * @param {SheetOptions[]} [options.sheets=[]] Configuration for multi-sheet export. Each entry defines one worksheet (XLSX only).
  * @returns {Promise<void>}
  * @since 17.1.0
  */
  async downloadFileAsync(format2, options = {}) {
    const formatter = this._createTypeFormatter(format2, options);
    const dialogPlugin = this.hot.getPlugin("dialog");
    const hasDialog = dialogPlugin?.isEnabled();
    const { rootWindow } = this.hot;
    const name = `${formatter.options.filename}.${formatter.options.fileExtension}`;
    const runExport = async () => {
      const blob = await Promise.resolve(this._createBlob(formatter));
      _class_private_method_get$w(this, _triggerDownload, triggerDownload).call(this, blob, name);
    };
    if (hasDialog && formatter.binary) {
      dialogPlugin.show({
        content: buildExportDialogContent(this.hot.getTranslatedPhrase(EXPORT_FILE_DIALOG_TITLE)),
        customClassName: LOADING_CLASS_NAME,
        background: "semi-transparent",
        closable: false,
        animation: false
      });
      await new Promise((resolve) => {
        rootWindow.requestAnimationFrame(() => {
          rootWindow.requestAnimationFrame(resolve);
        });
      });
      try {
        await runExport();
      } finally {
        dialogPlugin.hide();
      }
      return;
    }
    await runExport();
  }
  /**
  * Returns `true` when the plugin can produce an export in the given format.
  *
  * For text-based formats such as `'csv'`, no extra setup is required and the
  * method always returns `true`.
  * For binary formats such as `'xlsx'`, the method returns `true` only when the
  * corresponding engine has been provided in the plugin's `engines` map.
  *
  * @param {string} format Export format — `'csv'` or `'xlsx'`.
  * @returns {boolean}
  */
  supportsExportFormat(format2) {
    if (!EXPORT_TYPES[format2]) {
      return false;
    }
    if (format2 === "xlsx") {
      const settings = getPluginSettings(this.hot.getSettings()[PLUGIN_KEY$o]);
      return settings !== void 0 && isObject$1(settings.engines) && Boolean(settings.engines?.xlsx);
    }
    return true;
  }
  /**
  * Creates and returns a class formatter for the specified export type.
  *
  * The engine for the requested format is looked up from the plugin's `engines`
  * map and merged as a default so that per-call options can override it if needed.
  *
  * @private
  * @param {string} format Export format type eq. `'csv'` or `'xlsx'`.
  * @param {object} options Export options.
  * @returns {BaseType}
  */
  _createTypeFormatter(format2, options = {}) {
    if (!EXPORT_TYPES[format2]) {
      throwWithCause(`Export format type "${format2}" is not supported.`);
    }
    const pluginSettings = getPluginSettings(this.hot.getSettings()[PLUGIN_KEY$o]);
    const engines = pluginSettings && isObject$1(pluginSettings.engines) ? pluginSettings.engines : void 0;
    const engineFromSettings = engines?.[format2];
    const mergedOptions = engineFromSettings !== void 0 ? {
      engine: engineFromSettings,
      ...options
    } : options;
    const formatter = typeFactory(format2, new DataProvider2(this.hot), mergedOptions);
    if (formatter === null) {
      throwWithCause(`Export format type "${format2}" is not supported.`);
    }
    return formatter;
  }
  /**
  * Creates a blob object from the provided type formatter.
  *
  * For synchronous formatters (e.g. CSV), returns a `Blob` directly.
  * For asynchronous formatters (e.g. XLSX), returns a `Promise<Blob>`.
  *
  * @private
  * @param {BaseType} typeFormatter The instance of the specific formatter/exporter.
  * @returns {Blob|Promise<Blob>}
  */
  _createBlob(typeFormatter) {
    if (typeof Blob === "undefined") {
      throwWithCause("Blob is not available in this environment.");
    }
    const exported = typeFormatter.export();
    const { mimeType, encoding } = typeFormatter.options;
    if (exported instanceof Promise) {
      return exported.then((buffer) => new Blob([
        buffer
      ], {
        type: mimeType
      }));
    }
    return new Blob([
      exported
    ], {
      type: `${mimeType};charset=${encoding}`
    });
  }
  constructor(...args) {
    super(...args), _class_private_method_init$w(this, _triggerDownload), _class_private_field_init$F(this, _onAfterContextMenuDefaultOptions$3, {
      writable: true,
      value: void 0
    }), _class_private_field_set$F(this, _onAfterContextMenuDefaultOptions$3, (rawOptions) => {
      if (typeof rawOptions !== "object" || rawOptions === null) {
        return;
      }
      const options = rawOptions;
      options.items.push({
        name: "---------"
      }, exportItem(this));
    });
  }
}
function triggerDownload(blob, name) {
  const { rootDocument, rootWindow } = this.hot;
  const URL = rootWindow.URL || rootWindow.webkitURL;
  const url = URL.createObjectURL(blob);
  const a = rootDocument.createElement("a");
  a.style.display = "none";
  a.setAttribute("href", url);
  a.setAttribute("download", name);
  rootDocument.body.appendChild(a);
  a.dispatchEvent(new MouseEvent("click"));
  rootDocument.body.removeChild(a);
  this.hot._registerTimeout(() => {
    URL.revokeObjectURL(url);
  }, 100);
}
class BaseComponent {
  /**
  * Gets the list of elements from which the component is built.
  *
  * @returns {BaseUI[]}
  */
  getElements() {
    return this.elements;
  }
  /**
  * Reset elements to its initial state.
  */
  reset() {
    arrayEach(this.elements, (ui) => ui.reset());
  }
  /**
  * Hide component.
  */
  hide() {
    this.hidden = true;
  }
  /**
  * Show component.
  */
  show() {
    this.hidden = false;
  }
  /**
  * Check if component is hidden.
  *
  * @returns {boolean}
  */
  isHidden() {
    return this.hot === null || this.hidden;
  }
  /**
  * Restores the component state from the given physical column index. The method
  * internally calls the `setState` method. The state then is individually processed
  * by each component.
  *
  * @param {number} physicalColumn The physical column index.
  */
  restoreState(physicalColumn) {
    if (this.state) {
      this.setState(this.state.getValueAtIndex(physicalColumn));
    }
  }
  /**
  * The custom logic for component state restoring.
  */
  setState(_value) {
    throwWithCause("The state setting logic is not implemented");
  }
  /**
  * Saves the component state to the given physical column index. The method
  * internally calls the `getState` method, which returns the current state of
  * the component.
  *
  * @param {number} physicalColumn The physical column index.
  */
  saveState(physicalColumn) {
    if (this.state) {
      this.state.setValueAtIndex(physicalColumn, this.getState());
    }
  }
  /**
  * The custom logic for component state gathering (for stateful components).
  */
  getState() {
    throwWithCause("The state gathering logic is not implemented");
    return {};
  }
  /**
  * Returns the menu item descriptor for this component (used to add it to the dropdown menu).
  *
  * @returns {object}
  */
  getMenuItemDescriptor() {
    throwWithCause("The menu item descriptor logic is not implemented");
    return {};
  }
  /**
  * Destroy element.
  */
  destroy() {
    this.hot?.columnIndexMapper.unregisterMap(this.stateId);
    this.clearLocalHooks();
    arrayEach(this.elements, (ui) => ui.destroy());
    this.state = null;
    this.elements.length = 0;
    this.hot = null;
  }
  /**
  * Initializes the filter component with a Handsontable instance, assigns the component ID, and optionally registers a column index map for stateful components.
  */
  constructor(hotInstance, { id, stateless = true }) {
    this.elements = [];
    this.hidden = false;
    this.stateId = "";
    this.hot = hotInstance;
    this.id = id;
    this.stateId = `Filters.component.${this.id}`;
    this.state = stateless ? null : this.hot.columnIndexMapper.registerMap(this.stateId, new LinkedPhysicalIndexToValueMap());
  }
}
mixin(BaseComponent, localHooks);
const conditions = {};
function getCondition(name, args) {
  if (!conditions[name]) {
    throwWithCause(`Filter condition "${name}" does not exist.`);
  }
  const { condition: condition2, descriptor } = conditions[name];
  let conditionArguments = args;
  if (descriptor.inputValuesDecorator) {
    const decorator = descriptor.inputValuesDecorator;
    conditionArguments = decorator(conditionArguments);
  }
  return function(dataRow) {
    return condition2.apply(dataRow.meta.instance, [
      dataRow,
      conditionArguments
    ]);
  };
}
function getConditionDescriptor(name) {
  if (!conditions[name]) {
    throwWithCause(`Filter condition "${name}" does not exist.`);
  }
  return conditions[name].descriptor;
}
function registerCondition(name, condition2, descriptor) {
  descriptor.key = name;
  conditions[name] = {
    condition: condition2,
    descriptor
  };
}
const CONDITION_NAME$B = "none";
function condition$B() {
  return true;
}
registerCondition(CONDITION_NAME$B, condition$B, {
  name: FILTERS_CONDITIONS_NONE,
  inputsCount: 0,
  showOperators: false
});
const CONDITION_NAME$A = "empty";
function condition$A(dataRow) {
  return isEmpty$1(dataRow.value);
}
registerCondition(CONDITION_NAME$A, condition$A, {
  name: FILTERS_CONDITIONS_EMPTY,
  inputsCount: 0,
  showOperators: true
});
const CONDITION_NAME$z = "not_empty";
function condition$z(dataRow, inputValues) {
  return !getCondition(CONDITION_NAME$A, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME$z, condition$z, {
  name: FILTERS_CONDITIONS_NOT_EMPTY,
  inputsCount: 0,
  showOperators: true
});
const CONDITION_NAME$y = "eq";
function condition$y(dataRow, [value]) {
  return localeLowerCase(stringify$1(dataRow.value), dataRow.meta.locale) === stringify$1(value);
}
registerCondition(CONDITION_NAME$y, condition$y, {
  name: FILTERS_CONDITIONS_EQUAL,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$x = "neq";
function condition$x(dataRow, inputValues) {
  return !getCondition(CONDITION_NAME$y, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME$x, condition$x, {
  name: FILTERS_CONDITIONS_NOT_EQUAL,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$w = "gt";
function condition$w(dataRow, [value]) {
  let conditionValue = value;
  if (dataRow.meta.type === "numeric") {
    conditionValue = parseFloat(conditionValue);
  }
  return dataRow.value > conditionValue;
}
registerCondition(CONDITION_NAME$w, condition$w, {
  name: FILTERS_CONDITIONS_GREATER_THAN,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$v = "gte";
function condition$v(dataRow, [value]) {
  let conditionValue = value;
  if (dataRow.meta.type === "numeric") {
    conditionValue = parseFloat(conditionValue);
  }
  return dataRow.value >= conditionValue;
}
registerCondition(CONDITION_NAME$v, condition$v, {
  name: FILTERS_CONDITIONS_GREATER_THAN_OR_EQUAL,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$u = "lt";
function condition$u(dataRow, [value]) {
  let conditionValue = value;
  if (dataRow.meta.type === "numeric") {
    conditionValue = parseFloat(conditionValue);
  }
  return dataRow.value < conditionValue;
}
registerCondition(CONDITION_NAME$u, condition$u, {
  name: FILTERS_CONDITIONS_LESS_THAN,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$t = "lte";
function condition$t(dataRow, [value]) {
  let conditionValue = value;
  if (dataRow.meta.type === "numeric") {
    conditionValue = Number.parseFloat(conditionValue);
  }
  return dataRow.value <= conditionValue;
}
registerCondition(CONDITION_NAME$t, condition$t, {
  name: FILTERS_CONDITIONS_LESS_THAN_OR_EQUAL,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$s = "between";
function condition$s(dataRow, [from, to]) {
  let fromValue = from;
  let toValue = to;
  if (dataRow.meta.type === "numeric") {
    const _from = parseFloat(fromValue);
    const _to = parseFloat(toValue);
    fromValue = Math.min(_from, _to);
    toValue = Math.max(_from, _to);
  } else if (dataRow.meta.type === "date") {
    const date = parseToLocalDate(dataRow.value);
    const fromDate = parseToLocalDate(fromValue);
    const toDate = parseToLocalDate(toValue);
    if (date === null || fromDate === null || toDate === null) {
      return false;
    }
    return date.getTime() >= fromDate.getTime() && date.getTime() <= toDate.getTime();
  }
  return dataRow.value >= fromValue && dataRow.value <= toValue;
}
registerCondition(CONDITION_NAME$s, condition$s, {
  name: FILTERS_CONDITIONS_BETWEEN,
  inputsCount: 2,
  showOperators: true
});
const CONDITION_NAME$r = "not_between";
function condition$r(dataRow, inputValues) {
  return !getCondition(CONDITION_NAME$s, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME$r, condition$r, {
  name: FILTERS_CONDITIONS_NOT_BETWEEN,
  inputsCount: 2,
  showOperators: true
});
const CONDITION_NAME$q = "begins_with";
function condition$q(dataRow, [value]) {
  return localeLowerCase(stringify$1(dataRow.value), dataRow.meta.locale).startsWith(stringify$1(value));
}
registerCondition(CONDITION_NAME$q, condition$q, {
  name: FILTERS_CONDITIONS_BEGINS_WITH,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$p = "ends_with";
function condition$p(dataRow, [value]) {
  return localeLowerCase(stringify$1(dataRow.value), dataRow.meta.locale).endsWith(stringify$1(value));
}
registerCondition(CONDITION_NAME$p, condition$p, {
  name: FILTERS_CONDITIONS_ENDS_WITH,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$o = "contains";
function condition$o(dataRow, [value]) {
  return localeLowerCase(stringify$1(dataRow.value), dataRow.meta.locale).indexOf(stringify$1(value)) >= 0;
}
registerCondition(CONDITION_NAME$o, condition$o, {
  name: FILTERS_CONDITIONS_CONTAINS,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$n = "not_contains";
function condition$n(dataRow, inputValues) {
  return !getCondition(CONDITION_NAME$o, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME$n, condition$n, {
  name: FILTERS_CONDITIONS_NOT_CONTAIN,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$m = "date_before";
function condition$m(dataRow, [value]) {
  const date = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (date === null || inputDate === null) {
    return false;
  }
  return date.getTime() < inputDate.getTime();
}
registerCondition(CONDITION_NAME$m, condition$m, {
  name: FILTERS_CONDITIONS_BEFORE,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$l = "date_before_or_equal";
function condition$l(dataRow, [value]) {
  const date = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (date === null || inputDate === null) {
    return false;
  }
  return date.getTime() <= inputDate.getTime();
}
registerCondition(CONDITION_NAME$l, condition$l, {
  name: FILTERS_CONDITIONS_BEFORE_OR_EQUAL,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$k = "date_after";
function condition$k(dataRow, [value]) {
  const date = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (date === null || inputDate === null) {
    return false;
  }
  return date.getTime() > inputDate.getTime();
}
registerCondition(CONDITION_NAME$k, condition$k, {
  name: FILTERS_CONDITIONS_AFTER,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$j = "date_after_or_equal";
function condition$j(dataRow, [value]) {
  const date = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (date === null || inputDate === null) {
    return false;
  }
  return date.getTime() >= inputDate.getTime();
}
registerCondition(CONDITION_NAME$j, condition$j, {
  name: FILTERS_CONDITIONS_AFTER_OR_EQUAL,
  inputsCount: 1,
  showOperators: true
});
const CONDITION_NAME$i = "date_tomorrow";
function condition$i(dataRow) {
  const date = parseToLocalDate(dataRow.value);
  if (date === null) {
    return false;
  }
  return isSameLocalDay(date, getRelativeLocalDate(1));
}
registerCondition(CONDITION_NAME$i, condition$i, {
  name: FILTERS_CONDITIONS_TOMORROW,
  inputsCount: 0
});
const CONDITION_NAME$h = "date_today";
function condition$h(dataRow) {
  const date = parseToLocalDate(dataRow.value);
  if (date === null) {
    return false;
  }
  return isSameLocalDay(date, getTodayLocalDate());
}
registerCondition(CONDITION_NAME$h, condition$h, {
  name: FILTERS_CONDITIONS_TODAY,
  inputsCount: 0
});
const CONDITION_NAME$g = "date_yesterday";
function condition$g(dataRow) {
  const date = parseToLocalDate(dataRow.value);
  if (date === null) {
    return false;
  }
  return isSameLocalDay(date, getRelativeLocalDate(-1));
}
registerCondition(CONDITION_NAME$g, condition$g, {
  name: FILTERS_CONDITIONS_YESTERDAY,
  inputsCount: 0
});
const CONDITION_NAME$f = "intl_date_before";
function condition$f(dataRow, [value]) {
  const dataDate = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (dataDate === null || inputDate === null) {
    return false;
  }
  return dataDate < inputDate;
}
registerCondition(CONDITION_NAME$f, condition$f, {
  name: FILTERS_CONDITIONS_BEFORE,
  inputsCount: 1,
  showOperators: true,
  inputType: "date"
});
const CONDITION_NAME$e = "intl_date_before_or_equal";
function condition$e(dataRow, [value]) {
  const dataDate = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (dataDate === null || inputDate === null) {
    return false;
  }
  return dataDate <= inputDate;
}
registerCondition(CONDITION_NAME$e, condition$e, {
  name: FILTERS_CONDITIONS_BEFORE_OR_EQUAL,
  inputsCount: 1,
  showOperators: true,
  inputType: "date"
});
const CONDITION_NAME$d = "intl_date_after";
function condition$d(dataRow, [value]) {
  const dataDate = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (dataDate === null || inputDate === null) {
    return false;
  }
  return dataDate > inputDate;
}
registerCondition(CONDITION_NAME$d, condition$d, {
  name: FILTERS_CONDITIONS_AFTER,
  inputsCount: 1,
  showOperators: true,
  inputType: "date"
});
const CONDITION_NAME$c = "intl_date_after_or_equal";
function condition$c(dataRow, [value]) {
  const dataDate = parseToLocalDate(dataRow.value);
  const inputDate = parseToLocalDate(value);
  if (dataDate === null || inputDate === null) {
    return false;
  }
  return dataDate >= inputDate;
}
registerCondition(CONDITION_NAME$c, condition$c, {
  name: FILTERS_CONDITIONS_AFTER_OR_EQUAL,
  inputsCount: 1,
  showOperators: true,
  inputType: "date"
});
const CONDITION_NAME$b = "intl_date_between";
function condition$b(dataRow, [from, to]) {
  const dataDate = parseToLocalDate(dataRow.value);
  const fromDate = parseToLocalDate(from);
  const toDate = parseToLocalDate(to);
  if (dataDate === null || fromDate === null || toDate === null) {
    return false;
  }
  return dataDate >= fromDate && dataDate <= toDate;
}
registerCondition(CONDITION_NAME$b, condition$b, {
  name: FILTERS_CONDITIONS_BETWEEN,
  inputsCount: 2,
  showOperators: true,
  inputType: "date"
});
const CONDITION_NAME$a = "intl_date_tomorrow";
function condition$a(dataRow) {
  const dataDate = parseToLocalDate(dataRow.value);
  if (dataDate === null) {
    return false;
  }
  const tomorrow = /* @__PURE__ */ new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return dataDate.getFullYear() === tomorrow.getFullYear() && dataDate.getMonth() === tomorrow.getMonth() && dataDate.getDate() === tomorrow.getDate();
}
registerCondition(CONDITION_NAME$a, condition$a, {
  name: FILTERS_CONDITIONS_TOMORROW,
  inputsCount: 0,
  inputType: "date"
});
const CONDITION_NAME$9 = "intl_date_today";
function condition$9(dataRow) {
  const dataDate = parseToLocalDate(dataRow.value);
  if (dataDate === null) {
    return false;
  }
  const now = /* @__PURE__ */ new Date();
  return dataDate.getFullYear() === now.getFullYear() && dataDate.getMonth() === now.getMonth() && dataDate.getDate() === now.getDate();
}
registerCondition(CONDITION_NAME$9, condition$9, {
  name: FILTERS_CONDITIONS_TODAY,
  inputsCount: 0,
  inputType: "date"
});
const CONDITION_NAME$8 = "intl_date_yesterday";
function condition$8(dataRow) {
  const dataDate = parseToLocalDate(dataRow.value);
  if (dataDate === null) {
    return false;
  }
  const yesterday = /* @__PURE__ */ new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return dataDate.getFullYear() === yesterday.getFullYear() && dataDate.getMonth() === yesterday.getMonth() && dataDate.getDate() === yesterday.getDate();
}
registerCondition(CONDITION_NAME$8, condition$8, {
  name: FILTERS_CONDITIONS_YESTERDAY,
  inputsCount: 0,
  inputType: "date"
});
const CONDITION_NAME$7 = "intl_time_before";
function condition$7(dataRow, [value]) {
  const dataTime = parseToLocalTime(dataRow.value);
  const inputTime = parseToLocalTime(value);
  if (dataTime === null || inputTime === null) {
    return false;
  }
  return dataTime < inputTime;
}
registerCondition(CONDITION_NAME$7, condition$7, {
  name: FILTERS_CONDITIONS_BEFORE,
  inputsCount: 1,
  showOperators: true,
  inputType: "time"
});
const CONDITION_NAME$6 = "intl_time_before_or_equal";
function condition$6(dataRow, [value]) {
  const dataTime = parseToLocalTime(dataRow.value);
  const inputTime = parseToLocalTime(value);
  if (dataTime === null || inputTime === null) {
    return false;
  }
  return dataTime <= inputTime;
}
registerCondition(CONDITION_NAME$6, condition$6, {
  name: FILTERS_CONDITIONS_BEFORE_OR_EQUAL,
  inputsCount: 1,
  showOperators: true,
  inputType: "time"
});
const CONDITION_NAME$5 = "intl_time_after";
function condition$5(dataRow, [value]) {
  const dataTime = parseToLocalTime(dataRow.value);
  const inputTime = parseToLocalTime(value);
  if (dataTime === null || inputTime === null) {
    return false;
  }
  return dataTime > inputTime;
}
registerCondition(CONDITION_NAME$5, condition$5, {
  name: FILTERS_CONDITIONS_AFTER,
  inputsCount: 1,
  showOperators: true,
  inputType: "time"
});
const CONDITION_NAME$4 = "intl_time_after_or_equal";
function condition$4(dataRow, [value]) {
  const dataTime = parseToLocalTime(dataRow.value);
  const inputTime = parseToLocalTime(value);
  if (dataTime === null || inputTime === null) {
    return false;
  }
  return dataTime >= inputTime;
}
registerCondition(CONDITION_NAME$4, condition$4, {
  name: FILTERS_CONDITIONS_AFTER_OR_EQUAL,
  inputsCount: 1,
  showOperators: true,
  inputType: "time"
});
const CONDITION_NAME$3 = "intl_time_between";
function condition$3(dataRow, [from, to]) {
  const dataTime = parseToLocalTime(dataRow.value);
  const fromTime = parseToLocalTime(from);
  const toTime = parseToLocalTime(to);
  if (dataTime === null || fromTime === null || toTime === null) {
    return false;
  }
  return dataTime >= fromTime && dataTime <= toTime;
}
registerCondition(CONDITION_NAME$3, condition$3, {
  name: FILTERS_CONDITIONS_BETWEEN,
  inputsCount: 2,
  showOperators: true,
  inputType: "time"
});
const CONDITION_NAME$2 = "false";
function condition$2() {
  return false;
}
registerCondition(CONDITION_NAME$2, condition$2, {
  name: "False"
});
getComparisonFunction();
function toVisualValue(value, defaultEmptyValue) {
  let visualValue = value;
  if (visualValue === "") {
    visualValue = `(${defaultEmptyValue})`;
  }
  return visualValue;
}
function createArrayAssertion(initialData) {
  const dataset = new Set(initialData);
  return function(value) {
    return dataset.has(value);
  };
}
function toEmptyString(value) {
  return value === null || value === void 0 ? "" : value;
}
function unifyColumnValues(values2, comparator) {
  const defaultComparator = (a, b) => {
    if (typeof a === "number" && typeof b === "number") {
      return a - b;
    }
    if (a === b) {
      return 0;
    }
    return a > b ? 1 : -1;
  };
  return Array.from(new Set(values2)).map((value) => toEmptyString(value)).sort(comparator ?? defaultComparator);
}
function intersectValues(base, selected, defaultEmptyValue, callback) {
  const result = [];
  const same = base === selected;
  let selectedItemsAssertion;
  if (!same) {
    selectedItemsAssertion = createArrayAssertion(selected);
  }
  base.forEach((value) => {
    let checked = false;
    if (same || selectedItemsAssertion(value)) {
      checked = true;
    }
    const item = {
      checked,
      value,
      visualValue: toVisualValue(value, defaultEmptyValue)
    };
    if (callback) {
      callback(item);
    }
    result.push(item);
  });
  return result;
}
const CONDITION_NAME$1 = "by_value";
function condition$1(dataRow, [value]) {
  return value(dataRow.value);
}
registerCondition(CONDITION_NAME$1, condition$1, {
  name: "By value",
  inputsCount: 0,
  inputValuesDecorator([data]) {
    return [
      createArrayAssertion(data)
    ];
  },
  showOperators: false
});
const CONDITION_NAME = "true";
function condition() {
  return true;
}
registerCondition(CONDITION_NAME, condition, {
  name: "True"
});
const operations = {};
function getOperationFunc(id) {
  if (!operations[id]) {
    throwWithCause(`Operation with id "${id}" does not exist.`);
  }
  const func = operations[id].func;
  return function(conditions2, value) {
    return func(conditions2, value);
  };
}
function getOperationName(id) {
  return operations[id].name;
}
function registerOperation(id, name, func) {
  operations[id] = {
    name,
    func
  };
}
const OPERATION_ID$2 = "conjunction";
const SHORT_NAME_FOR_COMPONENT$2 = FILTERS_LABELS_CONJUNCTION;
function operationResult$2(conditions2, value) {
  return conditions2.every((condition2) => condition2.func(value));
}
registerOperation(OPERATION_ID$2, SHORT_NAME_FOR_COMPONENT$2, operationResult$2);
const OPERATION_ID$1 = "disjunction";
const SHORT_NAME_FOR_COMPONENT$1 = FILTERS_LABELS_DISJUNCTION;
function operationResult$1(conditions2, value) {
  return conditions2.some((condition2) => condition2.func(value));
}
registerOperation(OPERATION_ID$1, SHORT_NAME_FOR_COMPONENT$1, operationResult$1);
const OPERATION_ID = "disjunctionWithExtraCondition";
const SHORT_NAME_FOR_COMPONENT = FILTERS_LABELS_DISJUNCTION;
function operationResult(conditions2, value) {
  if (conditions2.length < 3) {
    throwWithCause("Operation doesn't work on less then three conditions.");
  }
  const lastCondition = conditions2[conditions2.length - 1];
  const otherConditions = conditions2.slice(0, conditions2.length - 1);
  return otherConditions.some((condition2) => Boolean(condition2.func(value))) && Boolean(lastCondition.func(value));
}
registerOperation(OPERATION_ID, SHORT_NAME_FOR_COMPONENT, operationResult);
const TYPE_NUMERIC = "numeric";
const TYPE_TEXT = "text";
const TYPE_DATE = "date";
const TYPE_INTL_DATE = "intl-date";
const TYPE_INTL_TIME = "intl-time";
const TYPES = {
  [TYPE_NUMERIC]: [
    CONDITION_NAME$B,
    KEY$c,
    CONDITION_NAME$A,
    CONDITION_NAME$z,
    KEY$c,
    CONDITION_NAME$y,
    CONDITION_NAME$x,
    KEY$c,
    CONDITION_NAME$w,
    CONDITION_NAME$v,
    CONDITION_NAME$u,
    CONDITION_NAME$t,
    CONDITION_NAME$s,
    CONDITION_NAME$r
  ],
  [TYPE_TEXT]: [
    CONDITION_NAME$B,
    KEY$c,
    CONDITION_NAME$A,
    CONDITION_NAME$z,
    KEY$c,
    CONDITION_NAME$y,
    CONDITION_NAME$x,
    KEY$c,
    CONDITION_NAME$q,
    CONDITION_NAME$p,
    KEY$c,
    CONDITION_NAME$o,
    CONDITION_NAME$n
  ],
  [TYPE_DATE]: [
    CONDITION_NAME$B,
    KEY$c,
    CONDITION_NAME$A,
    CONDITION_NAME$z,
    KEY$c,
    CONDITION_NAME$y,
    CONDITION_NAME$x,
    KEY$c,
    CONDITION_NAME$m,
    CONDITION_NAME$l,
    CONDITION_NAME$k,
    CONDITION_NAME$j,
    CONDITION_NAME$s,
    KEY$c,
    CONDITION_NAME$i,
    CONDITION_NAME$h,
    CONDITION_NAME$g
  ],
  [TYPE_INTL_DATE]: [
    CONDITION_NAME$B,
    KEY$c,
    CONDITION_NAME$A,
    CONDITION_NAME$z,
    KEY$c,
    CONDITION_NAME$y,
    CONDITION_NAME$x,
    KEY$c,
    CONDITION_NAME$f,
    CONDITION_NAME$e,
    CONDITION_NAME$d,
    CONDITION_NAME$c,
    CONDITION_NAME$b,
    KEY$c,
    CONDITION_NAME$a,
    CONDITION_NAME$9,
    CONDITION_NAME$8
  ],
  [TYPE_INTL_TIME]: [
    CONDITION_NAME$B,
    KEY$c,
    CONDITION_NAME$A,
    CONDITION_NAME$z,
    KEY$c,
    CONDITION_NAME$y,
    CONDITION_NAME$x,
    KEY$c,
    CONDITION_NAME$q,
    CONDITION_NAME$p,
    KEY$c,
    CONDITION_NAME$o,
    CONDITION_NAME$n,
    KEY$c,
    CONDITION_NAME$7,
    CONDITION_NAME$6,
    CONDITION_NAME$5,
    CONDITION_NAME$4,
    CONDITION_NAME$3
  ]
};
function getOptionsList(type) {
  const items = [];
  let typeName = type;
  if (!TYPES[typeName]) {
    typeName = TYPE_TEXT;
  }
  arrayEach(TYPES[typeName], (typeValue) => {
    let option;
    if (typeValue === KEY$c) {
      option = {
        name: KEY$c
      };
    } else {
      option = {
        ...getConditionDescriptor(typeValue)
      };
    }
    items.push(option);
  });
  return items;
}
const STATE_BUILT$2 = "built";
const STATE_BUILDING = "building";
const EVENTS_TO_REGISTER = [
  "click",
  "input",
  "keydown",
  "keypress",
  "keyup",
  "focus",
  "blur",
  "change"
];
let BaseUI$3 = class BaseUI {
  /**
  * Returns the default configuration options applied to a new UI component instance.
  */
  static get DEFAULTS() {
    return clone({
      className: "",
      value: "",
      tagName: "div",
      children: [],
      wrapIt: true
    });
  }
  /**
  * Set the element value.
  *
  * @param {*} value Set the component value.
  */
  setValue(value) {
    this.options.value = value;
    this.update();
  }
  /**
  * Get the element value.
  *
  * @returns {*}
  */
  getValue() {
    return this.options.value;
  }
  /**
  * Get element as a DOM object.
  *
  * @returns {Element}
  */
  get element() {
    if (this.buildState === STATE_BUILDING) {
      return this._element;
    }
    if (this.buildState === STATE_BUILT$2) {
      this.update();
      return this._element;
    }
    this.buildState = STATE_BUILDING;
    this.build();
    this.buildState = STATE_BUILT$2;
    return this._element;
  }
  /**
  * Check if element was built (built whole DOM structure).
  *
  * @returns {boolean}
  */
  isBuilt() {
    return this.buildState === STATE_BUILT$2;
  }
  /**
  * Translate value if it is possible. It's checked if value belongs to namespace of translated phrases.
  *
  * @param {*} value Value which will may be translated.
  * @returns {*} Translated value if translation was possible, original value otherwise.
  */
  translateIfPossible(value) {
    if (typeof value === "string" && value.startsWith(FILTERS_NAMESPACE)) {
      return this.hot?.getTranslatedPhrase(value) ?? value;
    }
    return value;
  }
  /**
  * Build DOM structure.
  */
  build() {
    if (!this._element || !this.hot) {
      return;
    }
    const rootElement = this._element;
    const { eventManager } = this;
    const registerEvent = (element, eventName) => {
      eventManager?.addEventListener(element, eventName, (event) => this.runLocalHooks(eventName, event, this));
    };
    if (!this.buildState) {
      this.buildState = STATE_BUILDING;
    }
    rootElement.dataset.hotInput = "true";
    if (this.options.tabIndex !== void 0) {
      rootElement.setAttribute("tabindex", String(this.options.tabIndex));
    }
    if (this.options.role !== void 0) {
      rootElement.setAttribute("role", this.options.role);
    }
    if (this.options.className) {
      addClass(rootElement, this.options.className);
    }
    if (this.options.children?.length) {
      arrayEach(this.options.children, (element) => {
        const el = element.element;
        if (el) {
          rootElement.appendChild(el);
        }
      });
    } else if (this.options.wrapIt) {
      const element = this.hot.rootDocument.createElement(this.options.tagName ?? "div");
      element.dataset.hotInput = "true";
      objectEach(this.options, (value, key) => {
        if (element[key] !== void 0 && key !== "className" && key !== "tagName" && key !== "children") {
          element[key] = this.translateIfPossible(value);
        }
      });
      rootElement.appendChild(element);
      arrayEach(EVENTS_TO_REGISTER, (eventName) => registerEvent(element, eventName));
    } else {
      arrayEach(EVENTS_TO_REGISTER, (eventName) => registerEvent(rootElement, eventName));
    }
  }
  /**
  * Update DOM structure.
  */
  update() {
  }
  /**
  * Reset to initial state.
  */
  reset() {
    this.options.value = "";
    this.update();
  }
  /**
  * Show element.
  */
  show() {
    const el = this.element;
    if (el) {
      el.style.display = "";
    }
  }
  /**
  * Hide element.
  */
  hide() {
    const el = this.element;
    if (el) {
      el.style.display = "none";
    }
  }
  /**
  * Focus element.
  */
  focus() {
  }
  /**
  * Destroys the UI component by releasing the event manager, nulling references, and removing the element from the DOM.
  */
  destroy() {
    this.eventManager?.destroy();
    this.eventManager = null;
    this.hot = null;
    if (this._element?.parentNode) {
      this._element.parentNode.removeChild(this._element);
    }
    this._element = null;
  }
  /**
  * Initializes the UI component with the Handsontable instance and merged configuration options.
  */
  constructor(hotInstance, options) {
    this.eventManager = new EventManager(this);
    this.hot = hotInstance;
    this.options = extend(BaseUI.DEFAULTS, options);
    this._element = hotInstance.rootDocument.createElement(this.options.wrapIt ? "div" : this.options.tagName ?? "div");
  }
};
mixin(BaseUI$3, localHooks);
function _check_private_redeclaration$L(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$E(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$E(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$E(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$E(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$E(receiver, privateMap, "get");
  return _class_apply_descriptor_get$E(receiver, descriptor);
}
function _class_private_field_init$E(obj, privateMap, value) {
  _check_private_redeclaration$L(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$E(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$E(receiver, privateMap, "set");
  _class_apply_descriptor_set$E(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$v(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$v(obj, privateSet) {
  _check_private_redeclaration$L(obj, privateSet);
  privateSet.add(obj);
}
var _input$1 = /* @__PURE__ */ new WeakMap(), _onKeyup = /* @__PURE__ */ new WeakSet();
class InputUI extends BaseUI$3 {
  /**
  * Returns the default configuration options for the input UI component, including placeholder, type, and tab index.
  */
  static get DEFAULTS() {
    return clone({
      placeholder: "",
      type: "text",
      tagName: "input",
      tabIndex: -1
    });
  }
  /**
  * Register all necessary hooks.
  */
  registerHooks() {
    this.addLocalHook("keyup", (event) => _class_private_method_get$v(this, _onKeyup, onKeyup).call(this, event));
  }
  /**
  * Build DOM structure.
  */
  build() {
    super.build();
    if (!this._element || !this.hot) {
      return;
    }
    const icon2 = this.hot.rootDocument.createElement("div");
    _class_private_field_set$E(this, _input$1, this._element.firstChild);
    addClass(this._element, "htUIInput");
    addClass(icon2, "htUIInputIcon");
    this._element.appendChild(icon2);
    this.update();
  }
  /**
  * Update element.
  */
  update() {
    if (!this.isBuilt()) {
      return;
    }
    if (_class_private_field_get$E(this, _input$1)) {
      _class_private_field_get$E(this, _input$1).type = String(this.options.type ?? "text");
      _class_private_field_get$E(this, _input$1).placeholder = String(this.translateIfPossible(this.options.placeholder) ?? "");
      _class_private_field_get$E(this, _input$1).value = String(this.translateIfPossible(this.options.value) ?? "");
    }
  }
  /**
  * Focus element.
  */
  focus() {
    if (this.isBuilt()) {
      _class_private_field_get$E(this, _input$1)?.focus();
    }
  }
  /**
  * Initializes the input UI component and registers event hooks for keyboard interaction.
  */
  constructor(hotInstance, options) {
    super(hotInstance, extend(InputUI.DEFAULTS, options)), _class_private_method_init$v(this, _onKeyup), _class_private_field_init$E(this, _input$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$E(this, _input$1, null);
    this.registerHooks();
  }
}
function onKeyup(event) {
  this.options.value = eventTargetEl(event).value;
}
function _check_private_redeclaration$K(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$D(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$D(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$D(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$D(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$D(receiver, privateMap, "get");
  return _class_apply_descriptor_get$D(receiver, descriptor);
}
function _class_private_field_init$D(obj, privateMap, value) {
  _check_private_redeclaration$K(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$D(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$D(receiver, privateMap, "set");
  _class_apply_descriptor_set$D(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$u(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$u(obj, privateSet) {
  _check_private_redeclaration$K(obj, privateSet);
  privateSet.add(obj);
}
var _menu = /* @__PURE__ */ new WeakMap(), _items$1 = /* @__PURE__ */ new WeakMap(), _caption = /* @__PURE__ */ new WeakMap(), _captionElement = /* @__PURE__ */ new WeakMap(), _dropdown = /* @__PURE__ */ new WeakMap(), _onMenuSelect = /* @__PURE__ */ new WeakSet(), _onMenuClosed = /* @__PURE__ */ new WeakSet(), _onClick = /* @__PURE__ */ new WeakSet();
class SelectUI extends BaseUI$3 {
  /**
  * Returns the default configuration options for the select UI component.
  */
  static get DEFAULTS() {
    return clone({
      className: "htUISelect",
      wrapIt: false,
      tabIndex: -1
    });
  }
  /**
  * Gets the instance of the Menu.
  *
  * @returns {Menu}
  */
  getMenu() {
    return _class_private_field_get$D(this, _menu);
  }
  /**
  * Register all necessary hooks.
  */
  registerHooks() {
    this.addLocalHook("click", () => _class_private_method_get$u(this, _onClick, onClick).call(this));
  }
  /**
  * Set options which can be selected in the list.
  *
  * @param {Array} items Array of objects with required keys `key` and `name`.
  */
  setItems(items) {
    _class_private_field_set$D(this, _items$1, this.translateNames(items));
    if (_class_private_field_get$D(this, _menu)) {
      _class_private_field_get$D(this, _menu).setMenuItems(_class_private_field_get$D(this, _items$1));
    }
  }
  /**
  * Translate names of menu items.
  *
  * @param {Array} items Array of objects with required keys `key` and `name`.
  * @returns {Array} Items with translated `name` keys.
  */
  translateNames(items) {
    arrayEach(items, (item) => {
      const menuItem = item;
      menuItem.name = this.translateIfPossible(menuItem.name);
    });
    return items;
  }
  /**
  * Build DOM structure.
  */
  build() {
    super.build();
    if (!this.hot || !this._element) {
      return;
    }
    const hot = this.hot;
    const rootElement = this._element;
    _class_private_field_set$D(this, _menu, new Menu(hot, {
      className: "htSelectUI htFiltersConditionsMenu",
      keepInViewport: false,
      standalone: true,
      container: this.options.menuContainer
    }));
    _class_private_field_get$D(this, _menu).setMenuItems(_class_private_field_get$D(this, _items$1));
    const caption = new BaseUI$3(hot, {
      className: "htUISelectCaption"
    });
    const dropdown = new BaseUI$3(hot, {
      className: "htUISelectDropdown"
    });
    _class_private_field_set$D(this, _caption, caption);
    _class_private_field_set$D(this, _captionElement, caption.element);
    _class_private_field_set$D(this, _dropdown, dropdown);
    if (hot.getSettings().ariaTags) {
      const dropdownEl = dropdown.element;
      if (dropdownEl) {
        setAttribute(dropdownEl, [
          A11Y_HIDDEN()
        ]);
      }
      setAttribute(rootElement, [
        A11Y_LISTBOX()
      ]);
    }
    arrayEach([
      caption,
      dropdown
    ], (element) => {
      const el = element.element;
      if (el) {
        rootElement.appendChild(el);
      }
    });
    _class_private_field_get$D(this, _menu).addLocalHook("select", (command2) => _class_private_method_get$u(this, _onMenuSelect, onMenuSelect).call(this, command2));
    _class_private_field_get$D(this, _menu).addLocalHook("afterClose", () => _class_private_method_get$u(this, _onMenuClosed, onMenuClosed).call(this));
    this.update();
  }
  /**
  * Update DOM structure.
  */
  update() {
    if (!this.isBuilt()) {
      return;
    }
    let conditionName;
    if (this.options.value) {
      conditionName = this.options.value.name;
    } else {
      conditionName = _class_private_field_get$D(this, _menu)?.hot?.getTranslatedPhrase(FILTERS_CONDITIONS_NONE);
    }
    if (_class_private_field_get$D(this, _captionElement)) {
      _class_private_field_get$D(this, _captionElement).textContent = conditionName ?? null;
    }
    super.update();
  }
  /**
  * Open select dropdown menu with available options.
  */
  openOptions() {
    const el = this.element;
    if (!el) {
      return;
    }
    const rect = el.getBoundingClientRect();
    if (_class_private_field_get$D(this, _menu)) {
      _class_private_field_get$D(this, _menu).open();
      _class_private_field_get$D(this, _menu).setPosition({
        left: this.hot?.isLtr() ? rect.left - 5 : rect.left - 31,
        top: rect.top - 1,
        width: rect.width,
        height: rect.height
      });
      _class_private_field_get$D(this, _menu)?.getNavigator()?.toFirstItem();
      _class_private_field_get$D(this, _menu)?.getKeyboardShortcutsCtrl()?.addCustomShortcuts([
        {
          keys: [
            [
              "Tab"
            ],
            [
              "Shift",
              "Tab"
            ]
          ],
          callback: (event) => {
            this.closeOptions();
            this.runLocalHooks("tabKeydown", event);
          }
        },
        {
          keys: [
            [
              "Control/Meta",
              "A"
            ]
          ],
          callback: () => false
        }
      ]);
    }
  }
  /**
  * Close select dropdown menu.
  */
  closeOptions() {
    if (_class_private_field_get$D(this, _menu)) {
      _class_private_field_get$D(this, _menu).close();
    }
  }
  /**
  * Focus element.
  */
  focus() {
    if (this.isBuilt()) {
      this.element?.focus();
    }
  }
  /**
  * Destroy instance.
  */
  destroy() {
    if (_class_private_field_get$D(this, _menu)) {
      _class_private_field_get$D(this, _menu).destroy();
      _class_private_field_set$D(this, _menu, null);
    }
    if (_class_private_field_get$D(this, _caption)) {
      _class_private_field_get$D(this, _caption).destroy();
    }
    if (_class_private_field_get$D(this, _dropdown)) {
      _class_private_field_get$D(this, _dropdown).destroy();
    }
    super.destroy();
  }
  /**
  * Initializes the select UI component and registers event hooks for dropdown interaction.
  */
  constructor(hotInstance, options) {
    super(hotInstance, extend(SelectUI.DEFAULTS, options)), _class_private_method_init$u(this, _onMenuSelect), _class_private_method_init$u(this, _onMenuClosed), _class_private_method_init$u(this, _onClick), _class_private_field_init$D(this, _menu, {
      writable: true,
      value: void 0
    }), _class_private_field_init$D(this, _items$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$D(this, _caption, {
      writable: true,
      value: void 0
    }), _class_private_field_init$D(this, _captionElement, {
      writable: true,
      value: void 0
    }), _class_private_field_init$D(this, _dropdown, {
      writable: true,
      value: void 0
    }), _class_private_field_set$D(this, _menu, null), _class_private_field_set$D(this, _items$1, []), _class_private_field_set$D(this, _caption, null), _class_private_field_set$D(this, _captionElement, null), _class_private_field_set$D(this, _dropdown, null);
    this.registerHooks();
  }
}
function onMenuSelect(command2) {
  if (command2.name !== KEY$c) {
    this.options.value = command2;
    this.update();
    this.runLocalHooks("select", this.options.value);
  }
}
function onMenuClosed() {
  this.runLocalHooks("afterClose");
}
function onClick() {
  this.openOptions();
}
function _check_private_redeclaration$J(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$t(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$t(obj, privateSet) {
  _check_private_redeclaration$J(obj, privateSet);
  privateSet.add(obj);
}
var _onConditionSelect = /* @__PURE__ */ new WeakSet(), _onInputKeyDown$2 = /* @__PURE__ */ new WeakSet();
class ConditionComponent extends BaseComponent {
  /**
  * Register all necessary hooks.
  *
  * @private
  */
  registerHooks() {
    this.getSelectElement().addLocalHook("select", (command2) => _class_private_method_get$t(this, _onConditionSelect, onConditionSelect).call(this, command2)).addLocalHook("afterClose", () => this.runLocalHooks("afterClose")).addLocalHook("tabKeydown", (event) => this.runLocalHooks("selectTabKeydown", event));
    arrayEach(this.getInputElements(), (input) => {
      input.addLocalHook("keydown", (event) => _class_private_method_get$t(this, _onInputKeyDown$2, onInputKeyDown$2).call(this, event));
    });
  }
  /**
  * Set state of the component.
  *
  * @param {object} value State to restore.
  */
  setState(value) {
    this.reset();
    if (!value) {
      return;
    }
    const copyOfCommand = clone(value.command);
    if (typeof copyOfCommand.name === "string" && copyOfCommand.name.startsWith(FILTERS_CONDITIONS_NAMESPACE)) {
      copyOfCommand.name = this.hot?.getTranslatedPhrase(copyOfCommand.name) ?? copyOfCommand.name;
    }
    this.getSelectElement().setValue(copyOfCommand);
    arrayEach(value.args, (arg, index2) => {
      if (index2 > (copyOfCommand.inputsCount ?? 0) - 1) {
        return false;
      }
      const element = this.getInputElement(index2);
      element.setValue(arg);
      element[(copyOfCommand.inputsCount ?? 0) > index2 ? "show" : "hide"]();
      if (!index2) {
        this.hot?._registerTimeout(() => element.focus(), 10);
      }
    });
  }
  /**
  * Export state of the component (get selected filter and filter arguments).
  *
  * @returns {object} Returns object where `command` key keeps used condition filter and `args` key its arguments.
  */
  getState() {
    const command2 = this.getSelectElement().getValue() || getConditionDescriptor(CONDITION_NAME$B);
    const args = [];
    arrayEach(this.getInputElements(), (element, index2) => {
      if ((command2.inputsCount ?? 0) > index2) {
        args.push(element.getValue());
      }
    });
    return {
      command: command2,
      args
    };
  }
  /**
  * Update state of component.
  *
  * @param {object} condition The condition object.
  * @param {object} condition.command The command object with condition name as `key` property.
  * @param {Array} condition.args An array of values to compare.
  * @param {number} column Physical column index.
  */
  updateState(condition2, column) {
    const command2 = condition2 ? getConditionDescriptor(condition2.name) : getConditionDescriptor(CONDITION_NAME$B);
    this.state?.setValueAtIndex(column, {
      command: command2,
      args: condition2 ? condition2.args : []
    });
    if (!condition2) {
      arrayEach(this.getInputElements(), (element) => element.setValue(null));
    }
  }
  /**
  * Get select element.
  *
  * @returns {SelectUI}
  */
  getSelectElement() {
    return this.elements.find((element) => element instanceof SelectUI);
  }
  /**
  * Get input element.
  *
  * @param {number} index Index an array of elements.
  * @returns {InputUI}
  */
  getInputElement(index2 = 0) {
    return this.getInputElements()[index2];
  }
  /**
  * Get input elements.
  *
  * @returns {Array}
  */
  getInputElements() {
    return this.elements.filter((element) => element instanceof InputUI);
  }
  /**
  * Get menu object descriptor.
  *
  * @returns {object}
  */
  getMenuItemDescriptor() {
    return {
      key: this.id,
      name: this.name,
      isCommand: false,
      disableSelection: true,
      hidden: () => this.isHidden(),
      renderer: (hot, wrapper, row, col, prop, value) => {
        if (isHTMLElement(wrapper.parentNode)) {
          addClass(wrapper.parentNode, "htFiltersMenuCondition");
          if (this.addSeparator) {
            addClass(wrapper.parentNode, "border");
          }
        }
        const label = this.hot?.rootDocument.createElement("div") ?? wrapper.ownerDocument.createElement("div");
        addClass(label, "htFiltersMenuLabel");
        label.textContent = value;
        wrapper.appendChild(label);
        if (!wrapper.parentElement?.hasAttribute("ghost-table")) {
          arrayEach(this.elements, (ui) => {
            const el = ui.element;
            if (el) {
              wrapper.appendChild(el);
            }
          });
        }
        return wrapper;
      }
    };
  }
  /**
  * Reset elements to their initial state.
  */
  reset() {
    const selectedColumn = this.hot?.getPlugin("filters").getSelectedColumn() ?? null;
    let items = [
      getConditionDescriptor(CONDITION_NAME$B)
    ];
    if (selectedColumn !== null) {
      const { visualIndex } = selectedColumn;
      items = getOptionsList(this.hot?.getDataType(0, visualIndex, this.hot.countRows(), visualIndex) ?? "text");
    }
    arrayEach(this.getInputElements(), (element) => element.hide());
    this.getSelectElement().setItems(items);
    super.reset();
    this.getSelectElement().setValue(items[0]);
  }
  /**
  * Initializes the condition component with the given ID, display name, separator flag, and optional menu container.
  */
  constructor(hotInstance, options) {
    super(hotInstance, {
      id: options.id,
      stateless: false
    }), _class_private_method_init$t(this, _onConditionSelect), _class_private_method_init$t(this, _onInputKeyDown$2), /**
    * The name of the component.
    *
    * @type {string}
    */
    this.name = "", /**
    * @type {boolean}
    */
    this.addSeparator = false;
    this.name = options.name;
    this.addSeparator = options.addSeparator;
    this.elements.push(new SelectUI(hotInstance, {
      menuContainer: options.menuContainer
    }));
    this.elements.push(new InputUI(hotInstance, {
      placeholder: FILTERS_BUTTONS_PLACEHOLDER_VALUE
    }));
    this.elements.push(new InputUI(hotInstance, {
      placeholder: FILTERS_BUTTONS_PLACEHOLDER_SECOND_VALUE
    }));
    this.registerHooks();
  }
}
function onConditionSelect(command2) {
  arrayEach(this.getInputElements(), (element, index2) => {
    element[(command2.inputsCount ?? 0) > index2 ? "show" : "hide"]();
    if (index2 === 0) {
      this.hot?._registerTimeout(() => element.focus(), 10);
    }
  });
  this.runLocalHooks("change", command2);
}
function onInputKeyDown$2(event) {
  if (isKey(event.keyCode, "ESCAPE")) {
    this.runLocalHooks("cancel");
    stopImmediatePropagation(event);
  }
}
function _check_private_redeclaration$I(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$C(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$C(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$C(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$C(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$C(receiver, privateMap, "get");
  return _class_apply_descriptor_get$C(receiver, descriptor);
}
function _class_private_field_init$C(obj, privateMap, value) {
  _check_private_redeclaration$I(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$C(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$C(receiver, privateMap, "set");
  _class_apply_descriptor_set$C(receiver, descriptor, value);
  return value;
}
var _input = /* @__PURE__ */ new WeakMap(), _label = /* @__PURE__ */ new WeakMap();
class RadioInputUI extends BaseUI$3 {
  /**
  * Returns the default configuration options for the radio input UI component, including type, tag name, and CSS class.
  */
  static get DEFAULTS() {
    return clone({
      type: "radio",
      tagName: "input",
      className: "htUIRadio",
      label: {}
    });
  }
  /**
  * Build DOM structure.
  */
  build() {
    super.build();
    if (!this.hot || !this._element) {
      return;
    }
    const label = this.hot.rootDocument.createElement("label");
    const labelOpts = this.options.label;
    label.textContent = String(this.translateIfPossible(labelOpts.textContent) ?? "");
    label.htmlFor = String(this.translateIfPossible(labelOpts.htmlFor) ?? "");
    _class_private_field_set$C(this, _label, label);
    _class_private_field_set$C(this, _input, this._element.firstChild);
    _class_private_field_get$C(this, _input).checked = this.options.checked;
    this._element.appendChild(label);
    this.update();
  }
  /**
  * Update element.
  */
  update() {
    if (!this.isBuilt()) {
      return;
    }
    const labelOpts = this.options.label;
    if (_class_private_field_get$C(this, _label)) {
      _class_private_field_get$C(this, _label).textContent = String(this.translateIfPossible(labelOpts.textContent) ?? "");
    }
  }
  /**
  * Check if radio button is checked.
  *
  * @returns {boolean}
  */
  isChecked() {
    return this.isBuilt() && _class_private_field_get$C(this, _input) ? _class_private_field_get$C(this, _input).checked : false;
  }
  /**
  * Set input checked attribute.
  *
  * @param {boolean} value Set the component state.
  */
  setChecked(value = true) {
    if (this.isBuilt() && _class_private_field_get$C(this, _input)) {
      _class_private_field_get$C(this, _input).checked = value;
    }
  }
  /**
  * Focus element.
  */
  focus() {
    if (this.isBuilt()) {
      _class_private_field_get$C(this, _input)?.focus();
    }
  }
  /**
  * Initializes the radio input UI component with the Handsontable instance and merged configuration options.
  */
  constructor(hotInstance, options) {
    super(hotInstance, extend(RadioInputUI.DEFAULTS, options)), _class_private_field_init$C(this, _input, {
      writable: true,
      value: void 0
    }), _class_private_field_init$C(this, _label, {
      writable: true,
      value: void 0
    }), _class_private_field_set$C(this, _input, null), _class_private_field_set$C(this, _label, null);
  }
}
function _check_private_redeclaration$H(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$s(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$s(obj, privateSet) {
  _check_private_redeclaration$H(obj, privateSet);
  privateSet.add(obj);
}
const SELECTED_AT_START_ELEMENT_INDEX = 0;
var _onRadioInputChange = /* @__PURE__ */ new WeakSet();
class OperatorsComponent extends BaseComponent {
  /**
  * Get menu object descriptor.
  *
  * @returns {object}
  */
  getMenuItemDescriptor() {
    return {
      key: this.id,
      name: this.name,
      isCommand: false,
      disableSelection: true,
      hidden: () => this.isHidden(),
      renderer: (hot, wrapper) => {
        if (isHTMLElement(wrapper.parentNode)) {
          addClass(wrapper.parentNode, "htFiltersMenuOperators");
        }
        arrayEach(this.elements, (ui) => {
          const el = ui.element;
          if (el) {
            wrapper.appendChild(el);
          }
        });
        return wrapper;
      }
    };
  }
  /**
  * Add RadioInputUI elements to component.
  *
  * @private
  */
  buildOperatorsElement(hotInstance) {
    const operationKeys = [
      OPERATION_ID$2,
      OPERATION_ID$1
    ];
    arrayEach(operationKeys, (operation) => {
      const radioInput = new RadioInputUI(hotInstance, {
        name: "operator",
        label: {
          htmlFor: operation,
          textContent: getOperationName(operation)
        },
        value: operation,
        checked: operation === operationKeys[SELECTED_AT_START_ELEMENT_INDEX],
        id: operation
      });
      radioInput.addLocalHook("change", (event) => _class_private_method_get$s(this, _onRadioInputChange, onRadioInputChange).call(this, event));
      this.elements.push(radioInput);
    });
  }
  /**
  * Set state of operators component to check radio input at specific `index`.
  *
  * @param {number} searchedIndex Index of radio input to check.
  */
  setChecked(searchedIndex) {
    if (this.elements.length < searchedIndex) {
      throwWithCause(toSingleLine`Radio button with index ${searchedIndex} doesn't exist.`);
    }
    arrayEach(this.elements, (element, index2) => {
      element.setChecked(index2 === searchedIndex);
    });
  }
  /**
  * Get `id` of active operator.
  *
  * @returns {string}
  */
  getActiveOperationId() {
    const operationElement = this.elements.find((element) => element instanceof RadioInputUI && element.isChecked());
    if (operationElement) {
      return String(operationElement.getValue() ?? OPERATION_ID$2);
    }
    return OPERATION_ID$2;
  }
  /**
  * Export state of the component (get selected operator).
  *
  * @returns {string} Returns `id` of selected operator.
  */
  getState() {
    return this.getActiveOperationId();
  }
  /**
  * Set state of the component.
  *
  * @param {object} value State to restore.
  */
  setState(value) {
    this.reset();
    if (value && this.getActiveOperationId() !== value) {
      arrayEach(this.elements, (element) => {
        element.setChecked(element.getValue() === value);
      });
    }
  }
  /**
  * Update state of component.
  *
  * @param {string} [operationId='conjunction'] Id of selected operation.
  * @param {number} column Physical column index.
  */
  updateState(operationId = OPERATION_ID$2, column) {
    let selectedOperationId = operationId;
    if (selectedOperationId === OPERATION_ID) {
      selectedOperationId = OPERATION_ID$1;
    }
    this.state?.setValueAtIndex(column, selectedOperationId);
  }
  /**
  * Reset elements to their initial state.
  */
  reset() {
    this.setChecked(SELECTED_AT_START_ELEMENT_INDEX);
  }
  /**
  * Initializes the operators component with the given ID and display name, and builds the operators UI element.
  */
  constructor(hotInstance, options) {
    super(hotInstance, {
      id: options.id,
      stateless: false
    }), _class_private_method_init$s(this, _onRadioInputChange), /**
    * The name of the component.
    *
    * @type {string}
    */
    this.name = "";
    this.name = options.name;
    this.buildOperatorsElement(hotInstance);
  }
}
function onRadioInputChange(event) {
  this.setState(eventTargetEl(event).value);
}
function createISODateSortComparator() {
  return (aVal, bVal) => {
    const a = aVal;
    const b = bVal;
    if (a === "" && b === "") {
      return 0;
    }
    if (a === "") {
      return -1;
    }
    if (b === "") {
      return 1;
    }
    const dateA = parseToLocalDate(a);
    const dateB = parseToLocalDate(b);
    if (dateA === null && dateB === null) {
      return 0;
    }
    if (dateA === null) {
      return 1;
    }
    if (dateB === null) {
      return -1;
    }
    return dateA - dateB;
  };
}
function getSortComparatorForMeta(meta) {
  if (!meta) {
    return void 0;
  }
  if (meta.type === "date" || meta.type === "intl-date") {
    return createISODateSortComparator();
  }
  return void 0;
}
function _check_private_redeclaration$G(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$B(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$B(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$B(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$B(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$B(receiver, privateMap, "get");
  return _class_apply_descriptor_get$B(receiver, descriptor);
}
function _class_private_field_init$B(obj, privateMap, value) {
  _check_private_redeclaration$G(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$B(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$B(receiver, privateMap, "set");
  _class_apply_descriptor_set$B(receiver, descriptor, value);
  return value;
}
var _link = /* @__PURE__ */ new WeakMap();
class LinkUI extends BaseUI$3 {
  /**
  * Returns the default configuration options for the link UI component, including href, tag name, and tab index.
  */
  static get DEFAULTS() {
    return clone({
      href: "#",
      tagName: "a",
      tabIndex: -1,
      role: "button"
    });
  }
  /**
  * Build DOM structure.
  */
  build() {
    super.build();
    if (this._element) {
      _class_private_field_set$B(this, _link, this._element.firstChild);
    }
  }
  /**
  * Update element.
  */
  update() {
    if (!this.isBuilt()) {
      return;
    }
    const text = this.options.textContent;
    if (_class_private_field_get$B(this, _link)) {
      _class_private_field_get$B(this, _link).textContent = String(this.translateIfPossible(text));
    }
  }
  /**
  * Focus element.
  */
  focus() {
    if (this.isBuilt() && _class_private_field_get$B(this, _link)) {
      _class_private_field_get$B(this, _link).focus();
    }
  }
  /**
  * Activate the element.
  */
  activate() {
    _class_private_field_get$B(this, _link)?.click();
  }
  /**
  * Initializes the link UI component with the Handsontable instance and merged configuration options.
  */
  constructor(hotInstance, options) {
    super(hotInstance, extend(LinkUI.DEFAULTS, options)), _class_private_field_init$B(this, _link, {
      writable: true,
      value: void 0
    }), _class_private_field_set$B(this, _link, null);
  }
}
function _check_private_redeclaration$F(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$A(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$A(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$A(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$A(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$A(receiver, privateMap, "get");
  return _class_apply_descriptor_get$A(receiver, descriptor);
}
function _class_private_field_init$A(obj, privateMap, value) {
  _check_private_redeclaration$F(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$A(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$A(receiver, privateMap, "set");
  _class_apply_descriptor_set$A(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$r(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$r(obj, privateSet) {
  _check_private_redeclaration$F(obj, privateSet);
  privateSet.add(obj);
}
const SHORTCUTS_GROUP$7 = "multipleSelect.itemBox";
var _items = /* @__PURE__ */ new WeakMap(), _itemsBox = /* @__PURE__ */ new WeakMap(), _locale = /* @__PURE__ */ new WeakMap(), _searchInput = /* @__PURE__ */ new WeakMap(), _selectAllUI = /* @__PURE__ */ new WeakMap(), _clearAllUI = /* @__PURE__ */ new WeakMap(), _onInput = /* @__PURE__ */ new WeakSet(), _onInputKeyDown$1 = /* @__PURE__ */ new WeakSet(), _onSelectAllClick = /* @__PURE__ */ new WeakSet(), _onClearAllClick = /* @__PURE__ */ new WeakSet();
class MultipleSelectUI extends BaseUI$3 {
  /**
  * Returns the default configuration options for the multiple select UI component.
  */
  static get DEFAULTS() {
    return clone({
      className: "htUIMultipleSelect",
      value: []
    });
  }
  /**
  * Gets the instance of the internal Handsontable that acts here as a listbox component.
  *
  * @returns {Handsontable}
  */
  getItemsBox() {
    return _class_private_field_get$A(this, _itemsBox);
  }
  /**
  * Register all necessary hooks.
  */
  registerHooks() {
    _class_private_field_get$A(this, _searchInput)?.addLocalHook("keydown", (event) => _class_private_method_get$r(this, _onInputKeyDown$1, onInputKeyDown$1).call(this, event));
    _class_private_field_get$A(this, _searchInput)?.addLocalHook("input", (event) => _class_private_method_get$r(this, _onInput, onInput).call(this, event));
    _class_private_field_get$A(this, _selectAllUI)?.addLocalHook("click", (event) => _class_private_method_get$r(this, _onSelectAllClick, onSelectAllClick).call(this, event));
    _class_private_field_get$A(this, _clearAllUI)?.addLocalHook("click", (event) => _class_private_method_get$r(this, _onClearAllClick, onClearAllClick).call(this, event));
  }
  /**
  * Set available options.
  *
  * @param {Array} items Array of objects with `checked` and `label` property.
  */
  setItems(items) {
    _class_private_field_set$A(this, _items, items);
    _class_private_field_get$A(this, _itemsBox)?.loadData(_class_private_field_get$A(this, _items));
  }
  /**
  * Set a locale for the component.
  *
  * @param {string} locale Locale used for filter actions performed on data, ie. `en-US`.
  */
  setLocale(locale) {
    _class_private_field_set$A(this, _locale, locale);
  }
  /**
  * Get a locale for the component.
  *
  * @returns {string}
  */
  getLocale() {
    return _class_private_field_get$A(this, _locale);
  }
  /**
  * Get all available options.
  *
  * @returns {Array}
  */
  getItems() {
    return [
      ..._class_private_field_get$A(this, _items)
    ];
  }
  /**
  * Get element value.
  *
  * @returns {Array} Array of selected values.
  */
  getValue() {
    return itemsToValue(_class_private_field_get$A(this, _items));
  }
  /**
  * Gets the instance of the search input element.
  *
  * @returns {InputUI}
  */
  getSearchInputElement() {
    return _class_private_field_get$A(this, _searchInput);
  }
  /**
  * Gets the instance of the "select all" link element.
  *
  * @returns {LinkUI}
  */
  getSelectAllElement() {
    return _class_private_field_get$A(this, _selectAllUI);
  }
  /**
  * Gets the instance of the "clear" link element.
  *
  * @returns {LinkUI}
  */
  getClearAllElement() {
    return _class_private_field_get$A(this, _clearAllUI);
  }
  /**
  * Check if all values listed in element are selected.
  *
  * @returns {boolean}
  */
  isSelectedAllValues() {
    return _class_private_field_get$A(this, _items).length === this.getValue().length;
  }
  /**
  * Build DOM structure.
  */
  build() {
    super.build();
    if (!this.hot || !this._element) {
      return;
    }
    const hot = this.hot;
    const rootElement = this._element;
    const { rootDocument } = hot;
    const itemsBoxWrapper = rootDocument.createElement("div");
    const selectionControl = new BaseUI$3(hot, {
      className: "htUISelectionControls",
      children: [
        _class_private_field_get$A(this, _selectAllUI),
        _class_private_field_get$A(this, _clearAllUI)
      ].filter((x) => x !== null)
    });
    const searchEl = _class_private_field_get$A(this, _searchInput)?.element;
    const selectionEl = selectionControl.element;
    if (searchEl) {
      rootElement.appendChild(searchEl);
    }
    if (selectionEl) {
      rootElement.appendChild(selectionEl);
    }
    rootElement.appendChild(itemsBoxWrapper);
    _class_private_field_get$A(this, _itemsBox)?.destroy();
    addClass(itemsBoxWrapper, "htUIMultipleSelectHot");
    _class_private_field_set$A(this, _itemsBox, new hot.constructor(itemsBoxWrapper, {
      data: [
        []
      ],
      columns: [
        {
          data: "checked",
          type: "checkbox",
          label: {
            property: "visualValue",
            position: "after"
          }
        }
      ],
      beforeRenderer: (TD, row, col, prop, value, cellProperties) => {
        const cp = cellProperties;
        TD.title = cp.instance.getDataAtRowProp(row, cp.label.property);
      },
      afterListen: () => {
        this.runLocalHooks("focus", this);
      },
      beforeOnCellMouseUp: () => {
        _class_private_field_get$A(this, _itemsBox)?.listen();
      },
      modifyColWidth: (width) => {
        const minWidth = (_class_private_field_get$A(this, _itemsBox)?.container.scrollWidth ?? 0) - getScrollbarWidth(rootDocument);
        if (width !== void 0 && width < minWidth) {
          return minWidth;
        }
        return width;
      },
      autoColumnSize: true,
      autoRowSize: false,
      hiddenRows: true,
      maxCols: 1,
      autoWrapCol: true,
      height: 110,
      copyPaste: false,
      disableVisualSelection: "area",
      fillHandle: false,
      fragmentSelection: "cell",
      tabMoves: {
        row: 1,
        col: 0
      },
      themeName: hot.getCurrentThemeName(),
      layoutDirection: hot.isRtl() ? "rtl" : "ltr"
    }));
    _class_private_field_get$A(this, _itemsBox).init();
    const shortcutManager = _class_private_field_get$A(this, _itemsBox).getShortcutManager();
    const gridContext = shortcutManager.getContext("grid");
    if (!gridContext) {
      return;
    }
    gridContext.removeShortcutsByKeys([
      "Tab"
    ]);
    gridContext.removeShortcutsByKeys([
      "Shift",
      "Tab"
    ]);
    gridContext.addShortcut({
      keys: [
        [
          "Escape"
        ]
      ],
      callback: (event) => {
        this.runLocalHooks("keydown", event, this);
      },
      group: SHORTCUTS_GROUP$7
    });
    gridContext.addShortcut({
      keys: [
        [
          "Tab"
        ],
        [
          "Shift",
          "Tab"
        ]
      ],
      callback: (event) => {
        _class_private_field_get$A(this, _itemsBox)?.deselectCell();
        this.runLocalHooks("keydown", event, this);
        this.runLocalHooks("listTabKeydown", event, this);
      },
      group: SHORTCUTS_GROUP$7
    });
  }
  /**
  * Focus element.
  */
  focus() {
    if (this.isBuilt()) {
      _class_private_field_get$A(this, _itemsBox)?.listen();
    }
  }
  /**
  * Reset DOM structure.
  */
  reset() {
    _class_private_field_get$A(this, _searchInput)?.reset();
    _class_private_field_get$A(this, _selectAllUI)?.reset();
    _class_private_field_get$A(this, _clearAllUI)?.reset();
  }
  /**
  * Update DOM structure.
  */
  update() {
    if (!this.isBuilt() || !_class_private_field_get$A(this, _itemsBox) || _class_private_field_get$A(this, _itemsBox).rootElement.offsetHeight === 0) {
      return;
    }
    _class_private_field_get$A(this, _itemsBox).updateSettings({
      data: valueToItems(_class_private_field_get$A(this, _items), this.options.value)
    });
    super.update();
  }
  /**
  * Destroy instance.
  */
  destroy() {
    _class_private_field_get$A(this, _itemsBox)?.destroy();
    _class_private_field_get$A(this, _searchInput)?.destroy();
    _class_private_field_get$A(this, _clearAllUI)?.destroy();
    _class_private_field_get$A(this, _selectAllUI)?.destroy();
    _class_private_field_set$A(this, _searchInput, null);
    _class_private_field_set$A(this, _clearAllUI, null);
    _class_private_field_set$A(this, _selectAllUI, null);
    _class_private_field_set$A(this, _itemsBox, null);
    _class_private_field_get$A(this, _items).length = 0;
    super.destroy();
  }
  /**
  * Initializes the multiple select UI component, creates child input and link components, and registers event hooks.
  */
  constructor(hotInstance, options) {
    super(hotInstance, extend(MultipleSelectUI.DEFAULTS, options)), _class_private_method_init$r(this, _onInput), _class_private_method_init$r(this, _onInputKeyDown$1), _class_private_method_init$r(this, _onSelectAllClick), _class_private_method_init$r(this, _onClearAllClick), _class_private_field_init$A(this, _items, {
      writable: true,
      value: void 0
    }), _class_private_field_init$A(this, _itemsBox, {
      writable: true,
      value: void 0
    }), _class_private_field_init$A(this, _locale, {
      writable: true,
      value: void 0
    }), _class_private_field_init$A(this, _searchInput, {
      writable: true,
      value: void 0
    }), _class_private_field_init$A(this, _selectAllUI, {
      writable: true,
      value: void 0
    }), _class_private_field_init$A(this, _clearAllUI, {
      writable: true,
      value: void 0
    }), _class_private_field_set$A(this, _items, []), _class_private_field_set$A(this, _itemsBox, null), _class_private_field_set$A(this, _locale, ""), _class_private_field_set$A(this, _searchInput, null), _class_private_field_set$A(this, _selectAllUI, null), _class_private_field_set$A(this, _clearAllUI, null);
    _class_private_field_set$A(this, _searchInput, new InputUI(hotInstance, {
      placeholder: FILTERS_BUTTONS_PLACEHOLDER_SEARCH,
      className: "htUIMultipleSelectSearch"
    }));
    _class_private_field_set$A(this, _selectAllUI, new LinkUI(hotInstance, {
      textContent: FILTERS_BUTTONS_SELECT_ALL,
      className: "htUISelectAll"
    }));
    _class_private_field_set$A(this, _clearAllUI, new LinkUI(hotInstance, {
      textContent: FILTERS_BUTTONS_CLEAR,
      className: "htUIClearAll"
    }));
    this.registerHooks();
  }
}
function onInput(event) {
  const trimmed = eventTargetEl(event).value.trim();
  const value = localeLowerCase(trimmed, this.getLocale());
  if (this.options.searchMode === "apply") {
    const hiddenRows = _class_private_field_get$A(this, _itemsBox)?.getPlugin("hiddenRows");
    const rowsToHide = [];
    if (hiddenRows) {
      hiddenRows.showRows(hiddenRows.getHiddenRows());
    }
    _class_private_field_get$A(this, _items).forEach((item, index2) => {
      item.checked = localeLowerCase(`${item.value}`, this.getLocale()).indexOf(value) >= 0;
      if (!item.checked) {
        rowsToHide.push(index2);
      }
    });
    if (hiddenRows) {
      hiddenRows.hideRows(rowsToHide);
    }
    _class_private_field_get$A(this, _itemsBox)?.view.adjustElementsSize();
    _class_private_field_get$A(this, _itemsBox)?.render();
  } else {
    let filteredItems;
    if (value === "") {
      filteredItems = [
        ..._class_private_field_get$A(this, _items)
      ];
    } else {
      filteredItems = _class_private_field_get$A(this, _items).filter((item) => localeLowerCase(`${item.value}`, this.getLocale()).indexOf(value) >= 0);
    }
    _class_private_field_get$A(this, _itemsBox)?.loadData(filteredItems);
  }
}
function onInputKeyDown$1(event) {
  this.runLocalHooks("keydown", event, this);
  if (isKey(event.keyCode, "ARROW_DOWN")) {
    event.preventDefault();
    stopImmediatePropagation(event);
    _class_private_field_get$A(this, _itemsBox)?.listen();
    _class_private_field_get$A(this, _itemsBox)?.selectCell(0, 0);
  }
}
function onSelectAllClick(event) {
  const changes = [];
  event.preventDefault();
  if (!_class_private_field_get$A(this, _itemsBox)) {
    return;
  }
  _class_private_field_get$A(this, _itemsBox).getSourceData().forEach((row, rowIndex) => {
    row.checked = true;
    changes.push(dataRowToChangesArray(row, rowIndex)[0]);
  });
  _class_private_field_get$A(this, _itemsBox).setSourceDataAtCell(changes);
}
function onClearAllClick(event) {
  const changes = [];
  event.preventDefault();
  if (!_class_private_field_get$A(this, _itemsBox)) {
    return;
  }
  _class_private_field_get$A(this, _itemsBox).getSourceData().forEach((row, rowIndex) => {
    row.checked = false;
    changes.push(dataRowToChangesArray(row, rowIndex)[0]);
  });
  _class_private_field_get$A(this, _itemsBox).setSourceDataAtCell(changes);
}
function valueToItems(availableItems, selectedValue) {
  const arrayAssertion = createArrayAssertion(selectedValue);
  return availableItems.map((item) => {
    item.checked = arrayAssertion(item.value);
    return item;
  });
}
function itemsToValue(availableItems) {
  const items = [];
  availableItems.forEach((item) => {
    if (item.checked) {
      items.push(item.value);
    }
  });
  return items;
}
function _check_private_redeclaration$E(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$q(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$q(obj, privateSet) {
  _check_private_redeclaration$E(obj, privateSet);
  privateSet.add(obj);
}
var _onInputKeyDown = /* @__PURE__ */ new WeakSet(), _triggerModifyMultipleSelectionValueHook = /* @__PURE__ */ new WeakSet(), _onModifyDisplayedValue = /* @__PURE__ */ new WeakSet();
class ValueComponent extends BaseComponent {
  /**
  * Register all necessary hooks.
  *
  * @private
  */
  registerHooks() {
    this.getMultipleSelectElement().addLocalHook("keydown", (event) => _class_private_method_get$q(this, _onInputKeyDown, onInputKeyDown).call(this, event)).addLocalHook("listTabKeydown", (event) => this.runLocalHooks("listTabKeydown", event));
    this.hot?.addHook("modifyFiltersMultiSelectValue", (value, meta) => _class_private_method_get$q(this, _onModifyDisplayedValue, onModifyDisplayedValue).call(this, value, meta));
  }
  /**
  * Gets the list of elements from which the component is built.
  *
  * @returns {BaseUI[]}
  */
  getElements() {
    const selectElement = this.getMultipleSelectElement();
    return [
      selectElement.getSearchInputElement(),
      selectElement.getSelectAllElement(),
      selectElement.getClearAllElement(),
      this.getMultipleSelectElement()
    ];
  }
  /**
  * Set state of the component.
  *
  * @param {object} value The component value.
  */
  setState(value) {
    this.reset();
    if (value && value.command.key === CONDITION_NAME$1) {
      const select = this.getMultipleSelectElement();
      select.setItems(value.itemsSnapshot);
      select.setValue(value.args[0]);
      select.setLocale(value.locale);
    }
  }
  /**
  * Export state of the component (get selected filter and filter arguments).
  *
  * @returns {object} Returns object where `command` key keeps used condition filter and `args` key its arguments.
  */
  getState() {
    const select = this.getMultipleSelectElement();
    const availableItems = select.getItems();
    return {
      command: {
        key: select.isSelectedAllValues() || !availableItems.length ? CONDITION_NAME$B : CONDITION_NAME$1
      },
      args: [
        select.getValue()
      ],
      itemsSnapshot: availableItems
    };
  }
  /**
  * Update state of component.
  *
  * @param {object} stateInfo Information about state containing stack of edited column,
  * stack of dependent conditions, data factory and optional condition arguments change. It's described by object containing keys:
  * `editedConditionStack`, `dependentConditionStacks`, `visibleDataFactory` and `conditionArgsChange`.
  */
  updateState(stateInfo) {
    const updateColumnState = (physicalColumn, conditions2, conditionArgsChange, filteredRowsFactory, conditionsStack) => {
      const [firstByValueCondition] = arrayFilter(conditions2, (condition2) => condition2.name === CONDITION_NAME$1);
      const state = {};
      const defaultBlankCellValue = this.hot?.getTranslatedPhrase(FILTERS_VALUES_BLANK_CELLS) ?? "";
      if (firstByValueCondition) {
        const filteredRows = filteredRowsFactory(physicalColumn, conditionsStack);
        const rowValues = arrayMap(filteredRows, (row) => row.value);
        const rowMetaMap = new Map(filteredRows.map((row) => [
          row.value,
          this.hot?.getCellMeta(row.meta.visualRow, row.meta.visualCol)
        ]));
        const columnMeta = filteredRows[0]?.meta;
        const comparator = getSortComparatorForMeta(columnMeta);
        const unifiedRowValues = unifyColumnValues(rowValues, comparator);
        if (conditionArgsChange) {
          firstByValueCondition.args[0] = conditionArgsChange;
        }
        const selectedValues = [];
        const itemsSnapshot = intersectValues(unifiedRowValues, firstByValueCondition.args[0], defaultBlankCellValue, (item) => {
          if (item.checked) {
            selectedValues.push(item.value);
          }
          _class_private_method_get$q(this, _triggerModifyMultipleSelectionValueHook, triggerModifyMultipleSelectionValueHook).call(this, item, rowMetaMap);
        });
        const column = stateInfo.editedConditionStack.column;
        state.locale = this.hot?.getCellMeta(0, column).locale;
        state.args = [
          selectedValues
        ];
        state.command = getConditionDescriptor(CONDITION_NAME$1);
        state.itemsSnapshot = itemsSnapshot;
      } else {
        state.args = [];
        state.command = getConditionDescriptor(CONDITION_NAME$B);
      }
      this.state?.setValueAtIndex(physicalColumn, state);
    };
    updateColumnState(stateInfo.editedConditionStack.column, stateInfo.editedConditionStack.conditions, stateInfo.conditionArgsChange, stateInfo.filteredRowsFactory);
    if (stateInfo.dependentConditionStacks.length) {
      updateColumnState(stateInfo.dependentConditionStacks[0].column, stateInfo.dependentConditionStacks[0].conditions, void 0, stateInfo.filteredRowsFactory, stateInfo.editedConditionStack);
    }
  }
  /**
  * Get multiple select element.
  *
  * @returns {MultipleSelectUI}
  */
  getMultipleSelectElement() {
    return this.elements.find((element) => element instanceof MultipleSelectUI);
  }
  /**
  * Get object descriptor for menu item entry.
  *
  * @returns {object}
  */
  getMenuItemDescriptor() {
    return {
      key: this.id,
      name: this.name,
      isCommand: false,
      disableSelection: true,
      hidden: () => this.isHidden() || typeof this.hiddenWhen === "function" && this.hiddenWhen(),
      renderer: (hot, wrapper, row, col, prop, value) => {
        if (isHTMLElement(wrapper.parentNode)) {
          addClass(wrapper.parentNode, "htFiltersMenuValue");
        }
        const label = this.hot?.rootDocument.createElement("div") ?? wrapper.ownerDocument.createElement("div");
        addClass(label, "htFiltersMenuLabel");
        label.textContent = value;
        wrapper.appendChild(label);
        if (!wrapper.parentElement?.hasAttribute("ghost-table")) {
          arrayEach(this.elements, (ui) => {
            const el = ui.element;
            if (el) {
              wrapper.appendChild(el);
            }
          });
        }
        return wrapper;
      }
    };
  }
  /**
  * Reset elements to their initial state.
  */
  reset() {
    const defaultBlankCellValue = this.hot?.getTranslatedPhrase(FILTERS_VALUES_BLANK_CELLS) ?? "";
    const rowEntries = this._getColumnVisibleValues();
    const rowValues = rowEntries.map((entry) => entry.value);
    const rowMetaMap = new Map(rowEntries.map((row) => [
      row.value,
      row.meta
    ]));
    const columnMeta = rowEntries[0]?.meta;
    const comparator = getSortComparatorForMeta(columnMeta);
    const values2 = unifyColumnValues(rowValues, comparator);
    const items = intersectValues(values2, values2, defaultBlankCellValue, (item) => {
      _class_private_method_get$q(this, _triggerModifyMultipleSelectionValueHook, triggerModifyMultipleSelectionValueHook).call(this, item, rowMetaMap);
    });
    this.getMultipleSelectElement().setItems(items);
    super.reset();
    this.getMultipleSelectElement().setValue(values2);
    const selectedColumn = this.hot?.getPlugin("filters").getSelectedColumn() ?? null;
    if (selectedColumn !== null) {
      this.getMultipleSelectElement().setLocale(this.hot?.getCellMeta(0, selectedColumn.visualIndex).locale);
    }
  }
  /**
  * Get data for currently selected column.
  *
  * @returns {Array}
  * @private
  */
  _getColumnVisibleValues() {
    const selectedColumn = this.hot?.getPlugin("filters").getSelectedColumn() ?? null;
    if (selectedColumn === null) {
      return [];
    }
    return arrayMap(this.hot?.getDataAtCol(selectedColumn.visualIndex) ?? [], (v, rowIndex) => {
      return {
        value: toEmptyString(v),
        meta: this.hot?.getCellMeta(rowIndex, selectedColumn.visualIndex) ?? {}
      };
    });
  }
  /**
  * Initializes the value component with the given ID, display name, search mode, and optional visibility predicate.
  */
  constructor(hotInstance, options) {
    super(hotInstance, {
      id: options.id,
      stateless: false
    }), _class_private_method_init$q(this, _onInputKeyDown), _class_private_method_init$q(this, _triggerModifyMultipleSelectionValueHook), _class_private_method_init$q(this, _onModifyDisplayedValue), /**
    * The name of the component.
    *
    * @type {string}
    */
    this.name = "";
    this.name = options.name;
    this.searchMode = options.searchMode;
    this.hiddenWhen = options.hiddenWhen;
    this.elements.push(new MultipleSelectUI(hotInstance, {
      searchMode: this.searchMode
    }));
    this.registerHooks();
  }
}
function onInputKeyDown(event) {
  if (isKey(event.keyCode, "ESCAPE")) {
    this.runLocalHooks("cancel");
    stopImmediatePropagation(event);
  }
  if (isKey(event.keyCode, "ENTER")) {
    if (this.searchMode === "apply") {
      this.runLocalHooks("accept");
    }
    stopImmediatePropagation(event);
  }
}
function triggerModifyMultipleSelectionValueHook(item, metaMap) {
  if (this.hot?.hasHook("modifyFiltersMultiSelectValue")) {
    item.visualValue = this.hot?.runHooks("modifyFiltersMultiSelectValue", item.visualValue, metaMap.get(item.value));
  }
}
function onModifyDisplayedValue(value, meta) {
  if (meta.valueFormatter) {
    return meta.valueFormatter(value, meta);
  }
  return value;
}
function _check_private_redeclaration$D(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$p(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$p(obj, privateSet) {
  _check_private_redeclaration$D(obj, privateSet);
  privateSet.add(obj);
}
var _onButtonClick = /* @__PURE__ */ new WeakSet();
class ActionBarComponent extends BaseComponent {
  /**
  * Returns the identifier string for the OK action button.
  */
  static get BUTTON_OK() {
    return "ok";
  }
  /**
  * Returns the identifier string for the Cancel action button.
  */
  static get BUTTON_CANCEL() {
    return "cancel";
  }
  /**
  * Register all necessary hooks.
  *
  * @private
  */
  registerHooks() {
    arrayEach(this.elements, (element) => {
      element.addLocalHook("click", (event, button) => _class_private_method_get$p(this, _onButtonClick, onButtonClick).call(this, event, button));
    });
  }
  /**
  * Get menu object descriptor.
  *
  * @returns {object}
  */
  getMenuItemDescriptor() {
    return {
      key: this.id,
      name: this.name,
      isCommand: false,
      disableSelection: true,
      hidden: () => this.isHidden(),
      renderer: (hot, wrapper) => {
        if (isHTMLElement(wrapper.parentNode)) {
          addClass(wrapper.parentNode, "htFiltersMenuActionBar");
        }
        arrayEach(this.elements, (ui) => {
          const el = ui.element;
          if (el) {
            wrapper.appendChild(el);
          }
        });
        return wrapper;
      }
    };
  }
  /**
  * Fire accept event.
  */
  accept() {
    this.runLocalHooks("accept");
  }
  /**
  * Fire cancel event.
  */
  cancel() {
    this.runLocalHooks("cancel");
  }
  /**
  * Initializes the action bar component with OK and Cancel buttons.
  */
  constructor(hotInstance, options) {
    super(hotInstance, {
      id: options.id,
      stateless: true
    }), _class_private_method_init$p(this, _onButtonClick), /**
    * The name of the component.
    *
    * @type {string}
    */
    this.name = "";
    this.name = options.name;
    this.elements.push(new InputUI(hotInstance, {
      type: "button",
      value: FILTERS_BUTTONS_OK,
      className: "htUIButton htUIButtonOK",
      identifier: ActionBarComponent.BUTTON_OK
    }));
    this.elements.push(new InputUI(hotInstance, {
      type: "button",
      value: FILTERS_BUTTONS_CANCEL,
      className: "htUIButton htUIButtonCancel",
      identifier: ActionBarComponent.BUTTON_CANCEL
    }));
    this.registerHooks();
  }
}
function onButtonClick(event, button) {
  if (button.options.identifier === ActionBarComponent.BUTTON_OK) {
    this.accept();
  } else {
    this.cancel();
  }
}
const MAP_NAME = "ConditionCollection.filteringStates";
class ConditionCollection {
  /**
  * Check if condition collection is empty (so no needed to filter data).
  *
  * @returns {boolean}
  */
  isEmpty() {
    return this.getFilteredColumns().length === 0;
  }
  /**
  * Check if value is matched to the criteria of conditions chain.
  *
  * @param {object} value Object with `value` and `meta` keys.
  * @param {number} column The physical column index.
  * @returns {boolean}
  */
  isMatch(value, column) {
    const stateForColumn = this.filteringStates.getValueAtIndex(column);
    const conditions2 = stateForColumn?.conditions ?? [];
    const operation = stateForColumn?.operation;
    return this.isMatchInConditions(conditions2, value, operation);
  }
  /**
  * Check if the value is matches the conditions.
  *
  * @param {Array} conditions List of conditions.
  * @param {object} value Object with `value` and `meta` keys.
  * @param {string} [operationType='conjunction'] Type of conditions operation.
  * @returns {boolean}
  */
  isMatchInConditions(conditions2, value, operationType = OPERATION_ID$2) {
    if (conditions2.length) {
      return getOperationFunc(operationType)(conditions2, value);
    }
    return true;
  }
  /**
  * Add condition to the collection.
  *
  * @param {number} column The physical column index.
  * @param {object} conditionDefinition Object with keys:
  *  * `command` Object, Command object with condition name as `key` property.
  *  * `args` Array, Condition arguments.
  * @param {string} [operation='conjunction'] Type of conditions operation.
  * @param {number} [position] Position to which condition will be added. When argument is undefined
  * the condition will be processed as the last condition.
  * @fires ConditionCollection#beforeAdd
  * @fires ConditionCollection#afterAdd
  */
  addCondition(column, conditionDefinition, operation = OPERATION_ID$2, position) {
    const localeForColumn = this.hot.getCellMeta(0, column).locale;
    const args = conditionDefinition.args.map((v) => typeof v === "string" ? localeLowerCase(v, localeForColumn) : v);
    const name = conditionDefinition.name || conditionDefinition.command.key;
    this.runLocalHooks("beforeAdd", column);
    const columnType = this.getOperation(column);
    if (columnType) {
      if (columnType !== operation) {
        throwWithCause(toSingleLine`The column of index ${column} has been already applied with a \`${columnType}\`\x20
        filter operation. Use \`removeConditions\` to clear the current conditions and then add new ones.\x20
        Mind that you cannot mix different types of operations (for instance, if you use \`conjunction\`,\x20
        use it consequently for a particular column).`);
      }
    } else if (isUndefined$1(operations[operation])) {
      throwWithCause(toSingleLine`Unexpected operation named \`${operation}\`. Possible ones are\x20
        \`disjunction\` and \`conjunction\`.`);
    }
    const conditionsForColumn = this.getConditions(column);
    if (conditionsForColumn.length === 0) {
      this.filteringStates.setValueAtIndex(column, {
        operation,
        conditions: [
          {
            name,
            args,
            func: getCondition(name, args)
          }
        ]
      }, position);
    } else {
      conditionsForColumn.push({
        name,
        args,
        func: getCondition(name, args)
      });
    }
    this.runLocalHooks("afterAdd", column);
  }
  /**
  * Get all added conditions from the collection at specified column index.
  *
  * @param {number} column The physical column index.
  * @returns {Array} Returns conditions collection as an array.
  */
  getConditions(column) {
    return this.filteringStates.getValueAtIndex(column)?.conditions ?? [];
  }
  /**
  * Get operation for particular column.
  *
  * @param {number} column The physical column index.
  * @returns {string|undefined}
  */
  getOperation(column) {
    return this.filteringStates.getValueAtIndex(column)?.operation;
  }
  /**
  * Get all filtered physical columns in the order in which actions are performed.
  *
  * @returns {Array}
  */
  getFilteredColumns() {
    return this.filteringStates.getEntries().map(([physicalColumn]) => physicalColumn);
  }
  /**
  * Gets position in the filtering states stack for the specific column.
  *
  * @param {number} column The physical column index.
  * @returns {number} Returns -1 when the column doesn't exist in the stack.
  */
  getColumnStackPosition(column) {
    return this.getFilteredColumns().indexOf(column);
  }
  /**
  * Export all previously added conditions.
  *
  * @returns {Array}
  */
  exportAllConditions() {
    return this.filteringStates.getEntries().reduce((allConditions, [column, stateValue]) => {
      const { operation, conditions: conditions2 } = stateValue;
      allConditions.push({
        column,
        operation,
        conditions: conditions2.map(({ name, args }) => ({
          name,
          args: [
            ...args
          ]
        }))
      });
      return allConditions;
    }, []);
  }
  /**
  * Import conditions to the collection.
  *
  * @param {Array} conditions The collection of the conditions.
  */
  importAllConditions(conditions2) {
    this.clean();
    conditions2.forEach((stack) => {
      stack.conditions.forEach((condition2) => {
        this.addCondition(stack.column, condition2, stack.operation);
      });
    });
  }
  /**
  * Remove conditions at given column index.
  *
  * @param {number} column The physical column index.
  * @fires ConditionCollection#beforeRemove
  * @fires ConditionCollection#afterRemove
  */
  removeConditions(column) {
    this.runLocalHooks("beforeRemove", column);
    this.filteringStates.clearValue(column);
    this.runLocalHooks("afterRemove", column);
  }
  /**
  * Clean all conditions collection and reset order stack.
  *
  * @fires ConditionCollection#beforeClean
  * @fires ConditionCollection#afterClean
  */
  clean() {
    this.runLocalHooks("beforeClean");
    this.filteringStates.clear();
    this.runLocalHooks("afterClean");
  }
  /**
  * Check if at least one condition was added at specified column index. And if second parameter is passed then additionally
  * check if condition exists under its name.
  *
  * @param {number} column The physical column index.
  * @param {string} [name] Condition name.
  * @returns {boolean}
  */
  hasConditions(column, name) {
    const conditions2 = this.getConditions(column);
    if (name) {
      return conditions2.some((condition2) => condition2.name === name);
    }
    return conditions2.length > 0;
  }
  /**
  * Destroy object.
  */
  destroy() {
    if (this.isMapRegistrable) {
      this.hot.columnIndexMapper.unregisterMap(MAP_NAME);
    }
    this.clearLocalHooks();
    this.filteringStates = null;
  }
  /**
  * Initializes the condition collection with the Handsontable instance, optionally registering the filtering states index map on the column index mapper.
  */
  constructor(hot, isMapRegistrable = true) {
    this.filteringStates = new LinkedPhysicalIndexToValueMap();
    this.hot = hot;
    this.isMapRegistrable = isMapRegistrable;
    if (this.isMapRegistrable === true) {
      this.hot.columnIndexMapper.registerMap(MAP_NAME, this.filteringStates);
    } else {
      this.filteringStates.init(this.hot.columnIndexMapper.getNumberOfIndexes());
    }
  }
}
mixin(ConditionCollection, localHooks);
class DataFilter {
  /**
  * Filter data based on the conditions collection.
  *
  * @returns {Array}
  */
  filter() {
    let filteredData = [];
    arrayEach(this.conditionCollection.getFilteredColumns(), (physicalColumn, index2) => {
      let columnData = this.columnDataFactory(physicalColumn);
      if (index2) {
        columnData = this._getIntersectData(columnData, filteredData);
      }
      filteredData = this.filterByColumn(physicalColumn, columnData);
    });
    return filteredData;
  }
  /**
  * Filter data based on specified physical column index.
  *
  * @param {number} column The physical column index.
  * @param {Array} [dataSource] Data source as array of objects with `value` and `meta` keys (e.g. `{value: 'foo', meta: {}}`).
  * @returns {Array} Returns filtered data.
  */
  filterByColumn(column, dataSource = []) {
    const filteredData = [];
    arrayEach(dataSource, (dataRow) => {
      if (dataRow !== void 0 && this.conditionCollection.isMatch(dataRow, column)) {
        filteredData.push(dataRow);
      }
    });
    return filteredData;
  }
  /**
  * Intersect data.
  *
  * @private
  * @param {Array} data The data to intersect.
  * @param {Array} needles The collection intersected rows with the data.
  * @returns {Array}
  */
  _getIntersectData(data, needles) {
    const result = [];
    arrayEach(needles, (needleRow) => {
      const row = needleRow.meta.row;
      if (data[row] !== void 0) {
        result[row] = data[row];
      }
    });
    return result;
  }
  /**
  * Initializes the data filter with a condition collection that provides filtering logic and a factory function that supplies column source data.
  */
  constructor(conditionCollection, columnDataFactory = () => []) {
    this.conditionCollection = conditionCollection;
    this.columnDataFactory = columnDataFactory;
  }
}
function _check_private_redeclaration$C(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$o(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$o(obj, privateSet) {
  _check_private_redeclaration$C(obj, privateSet);
  privateSet.add(obj);
}
var _onConditionBeforeModify = /* @__PURE__ */ new WeakSet(), _onConditionBeforeClean = /* @__PURE__ */ new WeakSet(), _onConditionAfterClean = /* @__PURE__ */ new WeakSet();
class ConditionUpdateObserver {
  /**
  * Enable grouping changes. Grouping is helpful in situations when a lot of conditions is added in one moment. Instead of
  * trigger `update` hook for every condition by adding/removing you can group this changes and call `flush` method to trigger
  * it once.
  */
  groupChanges() {
    this.grouping = true;
  }
  /**
  * Flush all collected changes. This trigger `update` hook for every previously collected change from condition collection.
  */
  flush() {
    this.grouping = false;
    arrayEach(this.changes, (column) => {
      this.updateStatesAtColumn(column);
    });
    this.changes.length = 0;
  }
  /**
  * Update all related states which should be changed after invoking changes applied to current column.
  *
  * @param {number} column The column index.
  * @param {object} conditionArgsChange Object describing condition changes which can be handled by filters on `update` hook.
  * It contains keys `conditionKey` and `conditionValue` which refers to change specified key of condition to specified value
  * based on referred keys.
  */
  updateStatesAtColumn(column, conditionArgsChange) {
    if (this.grouping) {
      if (this.changes.indexOf(column) === -1) {
        this.changes.push(column);
      }
      return;
    }
    const allConditions = this.conditionCollection.exportAllConditions();
    let editedColumnPosition = this.conditionCollection.getColumnStackPosition(column);
    if (editedColumnPosition === -1) {
      editedColumnPosition = this.latestEditedColumnPosition;
    }
    const conditionsBefore = allConditions.slice(0, editedColumnPosition);
    const conditionsAfter = allConditions.slice(editedColumnPosition);
    if (conditionsAfter.length && conditionsAfter[0].column === column) {
      conditionsAfter.shift();
    }
    const visibleDataFactory = curry((curriedConditionsBefore, curriedColumn, conditionsStack = []) => {
      const splitConditionCollection = new ConditionCollection(this.hot, false);
      const curriedConditionsBeforeArray = [].concat(curriedConditionsBefore, conditionsStack);
      splitConditionCollection.importAllConditions(curriedConditionsBeforeArray);
      const allRows = this.columnDataFactory(Number(curriedColumn));
      let visibleRows;
      if (splitConditionCollection.isEmpty()) {
        visibleRows = allRows;
      } else {
        visibleRows = new DataFilter(splitConditionCollection, this.columnDataFactory).filter();
      }
      visibleRows = arrayMap(visibleRows, (rowData) => rowData.meta.visualRow);
      const visibleRowsAssertion = createArrayAssertion(visibleRows);
      splitConditionCollection.destroy();
      return arrayFilter(allRows, (rowData) => {
        return visibleRowsAssertion(rowData.meta.visualRow);
      });
    })(conditionsBefore);
    const editedConditions = [
      ...this.conditionCollection.getConditions(column)
    ];
    this.runLocalHooks("update", {
      editedConditionStack: {
        column,
        conditions: editedConditions
      },
      dependentConditionStacks: conditionsAfter,
      filteredRowsFactory: visibleDataFactory,
      conditionArgsChange
    });
  }
  /**
  * Destroy instance.
  */
  destroy() {
    this.clearLocalHooks();
    objectEach(this, (_value, property) => {
      this[property] = null;
    });
  }
  /**
  * Initializes the observer with the Handsontable instance, a condition collection to watch, and an optional factory for column source data.
  */
  constructor(hot, conditionCollection, columnDataFactory = () => []) {
    _class_private_method_init$o(this, _onConditionBeforeModify);
    _class_private_method_init$o(this, _onConditionBeforeClean);
    _class_private_method_init$o(this, _onConditionAfterClean);
    this.changes = [];
    this.grouping = false;
    this.latestEditedColumnPosition = -1;
    this.latestOrderStack = [];
    this.hot = hot;
    this.conditionCollection = conditionCollection;
    this.columnDataFactory = columnDataFactory;
    this.conditionCollection.addLocalHook("beforeRemove", (column) => _class_private_method_get$o(this, _onConditionBeforeModify, onConditionBeforeModify).call(this, column));
    this.conditionCollection.addLocalHook("afterRemove", (column) => this.updateStatesAtColumn(column));
    this.conditionCollection.addLocalHook("afterAdd", (column) => this.updateStatesAtColumn(column));
    this.conditionCollection.addLocalHook("beforeClean", () => _class_private_method_get$o(this, _onConditionBeforeClean, onConditionBeforeClean).call(this));
    this.conditionCollection.addLocalHook("afterClean", () => _class_private_method_get$o(this, _onConditionAfterClean, onConditionAfterClean).call(this));
  }
}
function onConditionBeforeModify(column) {
  this.latestEditedColumnPosition = this.conditionCollection.getColumnStackPosition(column);
}
function onConditionBeforeClean() {
  this.latestOrderStack = this.conditionCollection.getFilteredColumns();
}
function onConditionAfterClean() {
  arrayEach(this.latestOrderStack, (column) => {
    this.updateStatesAtColumn(column);
  });
}
mixin(ConditionUpdateObserver, localHooks);
function createFocusNavigator(elements) {
  const navigator2 = createPaginator({
    initialPage: 0,
    size: () => elements.length,
    onItemSelect: (currentIndex, directItemChange) => {
      const element = elements[currentIndex];
      if (element instanceof MultipleSelectUI) {
        return directItemChange;
      }
      const elementRecord = element;
      if (isHTMLElement(elementRecord.element) && !isVisible(elementRecord.element)) {
        return false;
      }
      element.focus();
    }
  });
  return navigator2;
}
const SHORTCUTS_MENU_CONTEXT = "filters";
function createMenuFocusController(mainMenu, menuItems) {
  let lastSelectedMenuItem = -1;
  let menuInstance;
  const focusNavigator = createFocusNavigator(menuItems);
  const updateNavigatorPosition = (element) => () => {
    if (menuInstance.isOpened()) {
      menuInstance.getKeyboardShortcutsCtrl().listen(SHORTCUTS_MENU_CONTEXT);
    }
    focusNavigator.setCurrentPage(menuItems.indexOf(element));
  };
  menuItems.forEach((element) => {
    if (element instanceof BaseUI$3) {
      element.addLocalHook("click", updateNavigatorPosition(element));
      element.addLocalHook("focus", updateNavigatorPosition(element));
      element.addLocalHook("afterClose", updateNavigatorPosition(element));
    }
  });
  setMenu(mainMenu);
  function addKeyboardShortcuts(menu) {
    const mainMenuShortcutsCtrl = menuInstance.getKeyboardShortcutsCtrl();
    const currentMenuShortcutsCtrl = menu.getKeyboardShortcutsCtrl();
    focusNavigator.clear();
    currentMenuShortcutsCtrl.addCustomShortcuts([
      {
        keys: [
          [
            "Tab"
          ],
          [
            "Shift",
            "Tab"
          ]
        ],
        forwardToContext: mainMenuShortcutsCtrl.getContext(SHORTCUTS_MENU_CONTEXT),
        callback: () => {
          if (menu.isSubMenu()) {
            menu.close();
          }
          mainMenuShortcutsCtrl.listen(SHORTCUTS_MENU_CONTEXT);
        }
      }
    ]);
    if (menu.isSubMenu()) {
      return;
    }
    mainMenuShortcutsCtrl.addCustomShortcuts([
      {
        keys: [
          [
            "Tab"
          ],
          [
            "Shift",
            "Tab"
          ]
        ],
        callback: (event) => {
          const menuNavigator = menuInstance.getNavigator();
          if (menuNavigator.getCurrentPage() > -1) {
            lastSelectedMenuItem = menuNavigator.getCurrentPage();
          }
          menuNavigator.clear();
          if (event.shiftKey) {
            focusNavigator.toPreviousItem();
          } else {
            focusNavigator.toNextItem();
          }
        }
      },
      {
        keys: [
          [
            "Escape"
          ]
        ],
        callback: () => {
          menuInstance.close();
        }
      },
      {
        keys: [
          [
            "Enter"
          ],
          [
            "Space"
          ]
        ],
        preventDefault: false,
        callback: (event) => {
          const element = menuItems[focusNavigator.getCurrentPage()];
          if (element instanceof SelectUI) {
            element.openOptions();
            event.preventDefault();
          }
          if (element instanceof LinkUI) {
            element.activate();
            event.preventDefault();
          }
          if (!(element instanceof BaseUI$3)) {
            event.preventDefault();
          }
        }
      }
    ], SHORTCUTS_MENU_CONTEXT);
  }
  function listen() {
    menuInstance.focus();
    menuInstance.getKeyboardShortcutsCtrl().listen(SHORTCUTS_MENU_CONTEXT);
  }
  function setMenu(menu) {
    menu.addLocalHook("afterSelectionChange", (selectedItem) => {
      if (!selectedItem.key.startsWith("filter_")) {
        focusNavigator.clear();
      }
    });
    menu.addLocalHook("afterSubmenuOpen", addKeyboardShortcuts);
    menu.addLocalHook("afterOpen", addKeyboardShortcuts);
    menuInstance = menu;
  }
  function getMenu() {
    return menuInstance;
  }
  function getLastMenuPage() {
    return lastSelectedMenuItem;
  }
  return {
    ...focusNavigator,
    listen,
    setMenu,
    getMenu,
    getLastMenuPage
  };
}
function _check_private_redeclaration$B(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$z(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$z(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$z(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$z(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$z(receiver, privateMap, "get");
  return _class_apply_descriptor_get$z(receiver, descriptor);
}
function _class_private_field_init$z(obj, privateMap, value) {
  _check_private_redeclaration$B(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$z(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$z(receiver, privateMap, "set");
  _class_apply_descriptor_set$z(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$n(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$n(obj, privateSet) {
  _check_private_redeclaration$B(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$n = "filters";
const PLUGIN_PRIORITY$n = 250;
const SHORTCUTS_GROUP$6 = PLUGIN_KEY$n;
var _menuFocusNavigator = /* @__PURE__ */ new WeakMap(), _dropdownMenuTraces = /* @__PURE__ */ new WeakMap(), _previousConditionStack = /* @__PURE__ */ new WeakMap(), _dataProviderFilterRollbackStack = /* @__PURE__ */ new WeakMap(), _isDataProviderActive$1 = /* @__PURE__ */ new WeakMap(), _getConditionComponent = /* @__PURE__ */ new WeakSet(), _getOperatorsComponent = /* @__PURE__ */ new WeakSet(), _getValueComponent = /* @__PURE__ */ new WeakSet(), _onAfterChange$2 = /* @__PURE__ */ new WeakMap(), _onAfterUpdateData = /* @__PURE__ */ new WeakMap(), _onAfterDataProviderFetch$1 = /* @__PURE__ */ new WeakMap(), _onAfterDataProviderFetchError = /* @__PURE__ */ new WeakMap(), _onAfterDropdownMenuShow = /* @__PURE__ */ new WeakMap(), _onAfterDropdownMenuHide = /* @__PURE__ */ new WeakMap(), _onBeforeDropdownMenuShow = /* @__PURE__ */ new WeakMap(), _onAfterDropdownMenuDefaultOptions = /* @__PURE__ */ new WeakMap(), _onActionBarSubmit = /* @__PURE__ */ new WeakSet(), _onComponentChange = /* @__PURE__ */ new WeakSet(), _onSelectUIClosed = /* @__PURE__ */ new WeakSet(), _onAfterGetColHeader$1 = /* @__PURE__ */ new WeakMap(), _updateComponents = /* @__PURE__ */ new WeakSet();
class Filters extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$n;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$n;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      searchMode: "show"
    };
  }
  /**
  * Returns validator functions for each plugin setting to verify their values are valid before applying them.
  */
  static get SETTINGS_VALIDATORS() {
    return {
      searchMode: (value) => typeof value === "string" && [
        "show",
        "apply"
      ].includes(value)
    };
  }
  /**
  * Returns the list of plugin dependencies required before this plugin can be initialized.
  */
  static get PLUGIN_DEPS() {
    return [
      "plugin:DropdownMenu",
      "plugin:HiddenRows",
      "cell-type:checkbox"
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link Filters#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return this.hot.getSettings()[PLUGIN_KEY$n] ? true : false;
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_set$z(this, _isDataProviderActive$1, this.hot.runHooks("hasExternalDataSource") === true);
    this.filtersRowsMap = this.hot.rowIndexMapper.registerMap(this.pluginName ?? "", new TrimmingMap());
    this.dropdownMenuPlugin = this.hot.getPlugin("dropdownMenu");
    const dropdownSettings = this.hot.getSettings().dropdownMenu;
    const uiContainerCandidate = typeof dropdownSettings === "object" ? dropdownSettings.uiContainer : null;
    const menuContainer = isHTMLElement(uiContainerCandidate) ? uiContainerCandidate : this.hot.rootPortalElement;
    const addConfirmationHooks = (component) => {
      component.addLocalHook("accept", () => _class_private_method_get$n(this, _onActionBarSubmit, onActionBarSubmit).call(this, "accept"));
      component.addLocalHook("cancel", () => _class_private_method_get$n(this, _onActionBarSubmit, onActionBarSubmit).call(this, "cancel"));
      component.addLocalHook("change", (command2) => _class_private_method_get$n(this, _onComponentChange, onComponentChange).call(this, component, command2));
      return component;
    };
    const filterByConditionLabel = () => `${this.hot.getTranslatedPhrase(FILTERS_DIVS_FILTER_BY_CONDITION)}:`;
    const filterValueLabel = () => `${this.hot.getTranslatedPhrase(FILTERS_DIVS_FILTER_BY_VALUE)}:`;
    if (!this.components.get("filter_by_condition")) {
      const conditionComponent = new ConditionComponent(this.hot, {
        id: "filter_by_condition",
        name: filterByConditionLabel,
        addSeparator: false,
        menuContainer
      });
      conditionComponent.addLocalHook("afterClose", () => _class_private_method_get$n(this, _onSelectUIClosed, onSelectUIClosed).call(this));
      this.components.set("filter_by_condition", addConfirmationHooks(conditionComponent));
    }
    if (!this.components.get("filter_operators")) {
      this.components.set("filter_operators", new OperatorsComponent(this.hot, {
        id: "filter_operators",
        name: "Operators"
      }));
    }
    if (!this.components.get("filter_by_condition2")) {
      const conditionComponent = new ConditionComponent(this.hot, {
        id: "filter_by_condition2",
        name: "",
        addSeparator: true,
        menuContainer
      });
      conditionComponent.addLocalHook("afterClose", () => _class_private_method_get$n(this, _onSelectUIClosed, onSelectUIClosed).call(this));
      this.components.set("filter_by_condition2", addConfirmationHooks(conditionComponent));
    }
    if (!this.components.get("filter_by_value")) {
      const searchMode = this.getSetting("searchMode");
      this.components.set("filter_by_value", addConfirmationHooks(new ValueComponent(this.hot, {
        id: "filter_by_value",
        name: filterValueLabel,
        searchMode,
        hiddenWhen: () => _class_private_field_get$z(this, _isDataProviderActive$1)
      })));
    }
    if (!this.components.get("filter_action_bar")) {
      this.components.set("filter_action_bar", addConfirmationHooks(new ActionBarComponent(this.hot, {
        id: "filter_action_bar",
        name: "Action bar"
      })));
    }
    if (!this.conditionCollection) {
      this.conditionCollection = new ConditionCollection(this.hot);
    }
    if (!this.conditionUpdateObserver) {
      this.conditionUpdateObserver = new ConditionUpdateObserver(this.hot, this.conditionCollection, (physicalColumn) => this.getDataMapAtColumn(physicalColumn));
      this.conditionUpdateObserver.addLocalHook("update", (conditionState) => _class_private_method_get$n(this, _updateComponents, updateComponents).call(this, conditionState));
    }
    this.components.forEach((component) => component?.show());
    this.addHook("afterDropdownMenuDefaultOptions", _class_private_field_get$z(this, _onAfterDropdownMenuDefaultOptions));
    this.addHook("beforeDropdownMenuShow", _class_private_field_get$z(this, _onBeforeDropdownMenuShow));
    this.addHook("afterDropdownMenuShow", _class_private_field_get$z(this, _onAfterDropdownMenuShow));
    this.addHook("afterDropdownMenuHide", _class_private_field_get$z(this, _onAfterDropdownMenuHide));
    this.addHook("afterChange", _class_private_field_get$z(this, _onAfterChange$2));
    this.addHook("afterUpdateData", _class_private_field_get$z(this, _onAfterUpdateData));
    this.addHook("afterDataProviderFetch", _class_private_field_get$z(this, _onAfterDataProviderFetch$1));
    this.addHook("afterDataProviderFetchError", _class_private_field_get$z(this, _onAfterDataProviderFetchError));
    if (this.hot.getSettings().dropdownMenu && this.dropdownMenuPlugin) {
      this.dropdownMenuPlugin.disablePlugin();
      this.dropdownMenuPlugin.enablePlugin();
    }
    if (!_class_private_field_get$z(this, _menuFocusNavigator) && this.dropdownMenuPlugin?.enabled) {
      const focusableItems = [
        // A fake menu item that once focused allows escaping from the focus navigation (using Tab keys)
        // to the menu navigation using arrow keys.
        {
          focus: () => {
            const navigator2 = _class_private_field_get$z(this, _menuFocusNavigator);
            if (!navigator2) {
              return;
            }
            const menu = navigator2.getMenu();
            const menuNavigator = menu.getNavigator();
            const lastSelectedMenuItem = navigator2.getLastMenuPage();
            menu.focus();
            if (lastSelectedMenuItem > 0) {
              menuNavigator?.setCurrentPage(lastSelectedMenuItem);
            } else {
              menuNavigator?.toFirstItem();
            }
          }
        },
        ...Array.from(this.components).map(([, component]) => component?.getElements() ?? []).flat()
      ];
      _class_private_field_set$z(this, _menuFocusNavigator, createMenuFocusController(this.dropdownMenuPlugin.menu, focusableItems));
      const forwardToFocusNavigation = (event) => {
        _class_private_field_get$z(this, _menuFocusNavigator)?.listen();
        event.preventDefault();
        if (isKey(event.keyCode, "TAB")) {
          if (event.shiftKey) {
            _class_private_field_get$z(this, _menuFocusNavigator)?.toPreviousItem();
          } else {
            _class_private_field_get$z(this, _menuFocusNavigator)?.toNextItem();
          }
        }
      };
      this.components.get("filter_by_value")?.addLocalHook("listTabKeydown", forwardToFocusNavigation);
      this.components.get("filter_by_condition")?.addLocalHook("selectTabKeydown", forwardToFocusNavigation);
    }
    this.registerShortcuts();
    super.enablePlugin();
  }
  /**
  * Update plugin state after Handsontable settings update.
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    if (this.enabled) {
      if (this.dropdownMenuPlugin?.enabled) {
        this.dropdownMenuPlugin.menu?.clearLocalHooks();
      }
      this.components.forEach((component, key) => {
        component?.destroy();
        this.components.set(key, null);
      });
      this.conditionCollection?.destroy();
      this.conditionCollection = null;
      this.hot.rowIndexMapper.unregisterMap(this.pluginName ?? "");
    }
    this.unregisterShortcuts();
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for clearing the filters.
  *
  * @private
  */
  registerShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.addShortcut({
      keys: [
        [
          "Alt",
          "A"
        ]
      ],
      stopPropagation: true,
      callback: () => {
        const selection = this.hot.getSelected();
        this.clearConditions();
        this.filter();
        if (selection) {
          this.hot.selectCells(selection);
        }
      },
      group: SHORTCUTS_GROUP$6
    });
  }
  /**
  * Unregister shortcuts responsible for clearing the filters.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$6);
  }
  /**
  * @memberof Filters#
  * @function addCondition
  * @description
  * Adds condition to the conditions collection at specified column index.
  *
  * Possible predefined conditions:
  *
  * | Condition | Description | Expected `args` |
  * |---|---|---|
  * | `begins_with` | Begins with | `[value: string]`, e.g. `['de']` |
  * | `between` | Between | `[from: number\|string, to: number\|string]`, e.g. `[10, 50]` |
  * | `by_value` | By value | `[[...values: Array]]`, e.g. `[['ing', 'ed', 'as']]`. The outer array wraps a single inner array that contains all values to **keep** (show) after filtering. |
  * | `contains` | Contains | `[value: string]`, e.g. `['ing']` |
  * | `date_after` | After a date (exclusive) | `[dateString: string]`, e.g. `['1/1/2023']`. The format must match the column's `dateFormat` option. |
  * | `date_after_or_equal` | After or equal to a date (inclusive) | `[dateString: string]`, e.g. `['1/1/2023']`. The format must match the column's `dateFormat` option. |
  * | `date_before` | Before a date (exclusive) | `[dateString: string]`, e.g. `['1/1/2023']`. The format must match the column's `dateFormat` option. |
  * | `date_before_or_equal` | Before or equal to a date (inclusive) | `[dateString: string]`, e.g. `['1/1/2023']`. The format must match the column's `dateFormat` option. |
  * | `date_today` | Today | `[]` |
  * | `date_tomorrow` | Tomorrow | `[]` |
  * | `date_yesterday` | Yesterday | `[]` |
  * | `empty` | Empty | `[]` |
  * | `ends_with` | Ends with | `[value: string]`, e.g. `['ing']` |
  * | `eq` | Equal | `[value: string\|number]`, e.g. `['John']` |
  * | `gt` | Greater than | `[value: number]`, e.g. `[95]` |
  * | `gte` | Greater than or equal | `[value: number]`, e.g. `[95]` |
  * | `intl_date_after` | After a date, exclusive (locale-aware) | `[dateString: string]`, e.g. `['2023-01-01']` |
  * | `intl_date_after_or_equal` | After or equal to a date, inclusive (locale-aware) | `[dateString: string]`, e.g. `['2023-01-01']` |
  * | `intl_date_before` | Before a date, exclusive (locale-aware) | `[dateString: string]`, e.g. `['2023-01-01']` |
  * | `intl_date_before_or_equal` | Before or equal to a date, inclusive (locale-aware) | `[dateString: string]`, e.g. `['2023-01-01']` |
  * | `intl_date_between` | Between dates (locale-aware) | `[fromDateString: string, toDateString: string]`, e.g. `['2023-01-01', '2023-12-31']` |
  * | `intl_date_today` | Today (locale-aware) | `[]` |
  * | `intl_date_tomorrow` | Tomorrow (locale-aware) | `[]` |
  * | `intl_date_yesterday` | Yesterday (locale-aware) | `[]` |
  * | `intl_time_after` | After a time (locale-aware) | `[timeString: string]`, e.g. `['12:00']` |
  * | `intl_time_before` | Before a time (locale-aware) | `[timeString: string]`, e.g. `['08:00']` |
  * | `intl_time_between` | Between times (locale-aware) | `[fromTimeString: string, toTimeString: string]`, e.g. `['08:00', '12:00']` |
  * | `lt` | Less than | `[value: number]`, e.g. `[10]` |
  * | `lte` | Less than or equal | `[value: number]`, e.g. `[10]` |
  * | `none` | None (no filter) | `[]` |
  * | `not_between` | Not between | `[from: number\|string, to: number\|string]`, e.g. `[10, 50]` |
  * | `not_contains` | Not contains | `[value: string]`, e.g. `['ing']` |
  * | `not_empty` | Not empty | `[]` |
  * | `neq` | Not equal | `[value: string\|number]`, e.g. `['John']` |
  *
  * Possible operations on collection of conditions:
  *  * `conjunction` - [**Conjunction**](https://en.wikipedia.org/wiki/Logical_conjunction) on conditions collection (by default), i.e. for such operation: <br/> c1 AND c2 AND c3 AND c4 ... AND cn === TRUE, where c1 ... cn are conditions.
  *  * `disjunction` - [**Disjunction**](https://en.wikipedia.org/wiki/Logical_disjunction) on conditions collection, i.e. for such operation: <br/> c1 OR c2 OR c3 OR c4 ... OR cn === TRUE, where c1, c2, c3, c4 ... cn are conditions.
  *  * `disjunctionWithExtraCondition` - **Disjunction** on first `n - 1`\* conditions from collection with an extra requirement computed from the last condition, i.e. for such operation: <br/> c1 OR c2 OR c3 OR c4 ... OR cn-1 AND cn === TRUE, where c1, c2, c3, c4 ... cn are conditions.
  *
  * \* when `n` is collection size; it's used i.e. for one operation introduced from UI (when choosing from filter's drop-down menu two conditions with OR operator between them, mixed with choosing values from the multiple choice select)
  *
  * **Note**: Mind that you cannot mix different types of operations (for instance, if you use `conjunction`, use it consequently for a particular column).
  *
  * **Note**: If the number of conditions added programmatically via `addCondition()` exceeds the capacity of the
  * filter's dropdown UI (at most 2 regular conditions and 1 `by_value` condition per column), the extra conditions
  * will be applied to the data but will not be visible or editable in the dropdown menu.
  *
  * @example
  * ::: only-for javascript
  * ```js
  * const container = document.getElementById('example');
  * const hot = new Handsontable(container, {
  *   data: getData(),
  *   filters: true
  * });
  *
  * // access to filters plugin instance
  * const filtersPlugin = hot.getPlugin('filters');
  *
  * // add filter "Begins with" with value "de" to column at index 1
  * filtersPlugin.addCondition(1, 'begins_with', ['de']);
  * filtersPlugin.filter();
  *
  * // add filter "Between" 10 and 50 to column at index 1
  * filtersPlugin.addCondition(1, 'between', [10, 50]);
  * filtersPlugin.filter();
  *
  * // add filter "By value" to column at index 1
  * // in this case all values that don't match will be filtered
  * filtersPlugin.addCondition(1, 'by_value', [['ing', 'ed', 'as', 'on']]);
  * filtersPlugin.filter();
  *
  * // add filter "Contains" with value "ing" to column at index 1
  * filtersPlugin.addCondition(1, 'contains', ['ing']);
  * filtersPlugin.filter();
  *
  * // add filter "After a date" with value "1/1/2023" to column at index 1
  * filtersPlugin.addCondition(1, 'date_after', ['1/1/2023']);
  * filtersPlugin.filter();
  *
  * // add filter "Before a date" with value "1/1/2023" to column at index 1
  * filtersPlugin.addCondition(1, 'date_before', ['1/1/2023']);
  * filtersPlugin.filter();
  *
  * // add filter "Today" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'date_today', []);
  * filtersPlugin.filter();
  *
  * // add filter "Tomorrow" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'date_tomorrow', []);
  * filtersPlugin.filter();
  *
  * // add filter "Yesterday" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'date_yesterday', []);
  * filtersPlugin.filter();
  *
  * // add filter "Empty" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'empty', []);
  * filtersPlugin.filter();
  *
  * // add filter "Ends with" with value "ing" to column at index 1
  * filtersPlugin.addCondition(1, 'ends_with', ['ing']);
  * filtersPlugin.filter();
  *
  * // add filter "Equal" with value "John" to column at index 1
  * filtersPlugin.addCondition(1, 'eq', ['John']);
  * filtersPlugin.filter();
  *
  * // add filter "Greater than" 95 to column at index 1
  * filtersPlugin.addCondition(1, 'gt', [95]);
  * filtersPlugin.filter();
  *
  * // add filter "Greater than or equal" 95 to column at index 1
  * filtersPlugin.addCondition(1, 'gte', [95]);
  * filtersPlugin.filter();
  *
  * // add filter "Less than" 10 to column at index 1
  * filtersPlugin.addCondition(1, 'lt', [10]);
  * filtersPlugin.filter();
  *
  * // add filter "Less than or equal" 10 to column at index 1
  * filtersPlugin.addCondition(1, 'lte', [10]);
  * filtersPlugin.filter();
  *
  * // add filter "None" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'none', []);
  * filtersPlugin.filter();
  *
  * // add filter "Not between" 10 and 50 to column at index 1
  * filtersPlugin.addCondition(1, 'not_between', [10, 50]);
  * filtersPlugin.filter();
  *
  * // add filter "Not contains" with value "ing" to column at index 1
  * filtersPlugin.addCondition(1, 'not_contains', ['ing']);
  * filtersPlugin.filter();
  *
  * // add filter "Not empty" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'not_empty', []);
  * filtersPlugin.filter();
  *
  * // add filter "Not equal" with value "John" to column at index 1
  * filtersPlugin.addCondition(1, 'neq', ['John']);
  * filtersPlugin.filter();
  * ```
  * :::
  *
  * ::: only-for react
  * ```jsx
  * const hotRef = useRef(null);
  *
  * ...
  *
  * <HotTable
  *   ref={hotRef}
  *   data={getData()}
  *   filters={true}
  * />
  *
  * // access to filters plugin instance
  * const hot = hotRef.current.hotInstance;
  * const filtersPlugin = hot.getPlugin('filters');
  *
  * // add filter "Begins with" with value "de" to column at index 1
  * filtersPlugin.addCondition(1, 'begins_with', ['de']);
  * filtersPlugin.filter();
  *
  * // add filter "Between" 10 and 50 to column at index 1
  * filtersPlugin.addCondition(1, 'between', [10, 50]);
  * filtersPlugin.filter();
  *
  * // add filter "By value" to column at index 1
  * // in this case all values that don't match will be filtered
  * filtersPlugin.addCondition(1, 'by_value', [['ing', 'ed', 'as', 'on']]);
  * filtersPlugin.filter();
  *
  * // add filter "Contains" with value "ing" to column at index 1
  * filtersPlugin.addCondition(1, 'contains', ['ing']);
  * filtersPlugin.filter();
  *
  * // add filter "After a date" with value "1/1/2023" to column at index 1
  * filtersPlugin.addCondition(1, 'date_after', ['1/1/2023']);
  * filtersPlugin.filter();
  *
  * // add filter "Before a date" with value "1/1/2023" to column at index 1
  * filtersPlugin.addCondition(1, 'date_before', ['1/1/2023']);
  * filtersPlugin.filter();
  *
  * // add filter "Today" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'date_today', []);
  * filtersPlugin.filter();
  *
  * // add filter "Tomorrow" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'date_tomorrow', []);
  * filtersPlugin.filter();
  *
  * // add filter "Yesterday" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'date_yesterday', []);
  * filtersPlugin.filter();
  *
  * // add filter "Empty" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'empty', []);
  * filtersPlugin.filter();
  *
  * // add filter "Ends with" with value "ing" to column at index 1
  * filtersPlugin.addCondition(1, 'ends_with', ['ing']);
  * filtersPlugin.filter();
  *
  * // add filter "Equal" with value "John" to column at index 1
  * filtersPlugin.addCondition(1, 'eq', ['John']);
  * filtersPlugin.filter();
  *
  * // add filter "Greater than" 95 to column at index 1
  * filtersPlugin.addCondition(1, 'gt', [95]);
  * filtersPlugin.filter();
  *
  * // add filter "Greater than or equal" 95 to column at index 1
  * filtersPlugin.addCondition(1, 'gte', [95]);
  * filtersPlugin.filter();
  *
  * // add filter "Less than" 10 to column at index 1
  * filtersPlugin.addCondition(1, 'lt', [10]);
  * filtersPlugin.filter();
  *
  * // add filter "Less than or equal" 10 to column at index 1
  * filtersPlugin.addCondition(1, 'lte', [10]);
  * filtersPlugin.filter();
  *
  * // add filter "None" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'none', []);
  * filtersPlugin.filter();
  *
  * // add filter "Not between" 10 and 50 to column at index 1
  * filtersPlugin.addCondition(1, 'not_between', [10, 50]);
  * filtersPlugin.filter();
  *
  * // add filter "Not contains" with value "ing" to column at index 1
  * filtersPlugin.addCondition(1, 'not_contains', ['ing']);
  * filtersPlugin.filter();
  *
  * // add filter "Not empty" with no arguments to column at index 1
  * filtersPlugin.addCondition(1, 'not_empty', []);
  * filtersPlugin.filter();
  *
  * // add filter "Not equal" with value "John" to column at index 1
  * filtersPlugin.addCondition(1, 'neq', ['John']);
  * filtersPlugin.filter();
  * ```
  * :::
  *
  * ::: only-for angular
  * ```ts
  * import { AfterViewInit, Component, ViewChild } from "@angular/core";
  * import {
  *   GridSettings,
  *   HotTableModule,
  *   HotTableComponent,
  * } from "@handsontable/angular-wrapper";
  *
  * `@Component`({
  *   selector: "app-example",
  *   standalone: true,
  *   imports: [HotTableModule],
  *   template: ` <div>
  *     <hot-table [settings]="gridSettings" />
  *   </div>`,
  * })
  * export class ExampleComponent implements AfterViewInit {
  *   `@ViewChild`(HotTableComponent, { static: false })
  *   readonly hotTable!: HotTableComponent;
  *
  *   readonly gridSettings = <GridSettings>{
  *     data: this.getData(),
  *     filters: true,
  *   };
  *
  *   ngAfterViewInit(): void {
  *     // Access to filters plugin instance
  *     const hot = this.hotTable.hotInstance;
  *     const filtersPlugin = hot.getPlugin("filters");
  *
  *     // Add filter "Begins with" with value "de" to column at index 1
  *     filtersPlugin.addCondition(1, "begins_with", ["de"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Between" 10 and 50 to column at index 1
  *     filtersPlugin.addCondition(1, "between", [10, 50]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "By value" to column at index 1
  *     // In this case, all values that don't match will be filtered.
  *     filtersPlugin.addCondition(1, "by_value", [["ing", "ed", "as", "on"]]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Contains" with value "ing" to column at index 1
  *     filtersPlugin.addCondition(1, "contains", ["ing"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "After a date" with value "1/1/2023" to column at index 1
  *     filtersPlugin.addCondition(1, "date_after", ["1/1/2023"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Before a date" with value "1/1/2023" to column at index 1
  *     filtersPlugin.addCondition(1, "date_before", ["1/1/2023"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Today" with no arguments to column at index 1
  *     filtersPlugin.addCondition(1, "date_today", []);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Tomorrow" with no arguments to column at index 1
  *     filtersPlugin.addCondition(1, "date_tomorrow", []);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Yesterday" with no arguments to column at index 1
  *     filtersPlugin.addCondition(1, "date_yesterday", []);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Empty" with no arguments to column at index 1
  *     filtersPlugin.addCondition(1, "empty", []);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Ends with" with value "ing" to column at index 1
  *     filtersPlugin.addCondition(1, "ends_with", ["ing"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Equal" with value "John" to column at index 1
  *     filtersPlugin.addCondition(1, "eq", ["John"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Greater than" 95 to column at index 1
  *     filtersPlugin.addCondition(1, "gt", [95]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Greater than or equal" 95 to column at index 1
  *     filtersPlugin.addCondition(1, "gte", [95]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Less than" 10 to column at index 1
  *     filtersPlugin.addCondition(1, "lt", [10]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Less than or equal" 10 to column at index 1
  *     filtersPlugin.addCondition(1, "lte", [10]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "None" with no arguments to column at index 1
  *     filtersPlugin.addCondition(1, "none", []);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Not between" 10 and 50 to column at index 1
  *     filtersPlugin.addCondition(1, "not_between", [10, 50]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Not contains" with value "ing" to column at index 1
  *     filtersPlugin.addCondition(1, "not_contains", ["ing"]);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Not empty" with no arguments to column at index 1
  *     filtersPlugin.addCondition(1, "not_empty", []);
  *     filtersPlugin.filter();
  *
  *     // Add filter "Not equal" with value "John" to column at index 1
  *     filtersPlugin.addCondition(1, "neq", ["John"]);
  *     filtersPlugin.filter();
  *   }
  *
  *   private getData(): Array<*> {
  *     // Get some data
  *   }
  * }
  * ```
  * :::
  *
  * @param {number} column Visual column index.
  * @param {string} name Condition short name.
  * @param {Array} args Condition arguments. The expected format depends on the condition - see the table above for details.
  * @param {string} [operationId=conjunction] `id` of operation which is performed on the column.
  */
  addCondition(column, name, args, operationId = OPERATION_ID$2) {
    if (name === CONDITION_NAME$1 && _class_private_field_get$z(this, _isDataProviderActive$1)) {
      return;
    }
    const physicalColumn = this.hot.toPhysicalColumn(column);
    this.conditionCollection?.addCondition(physicalColumn, {
      command: {
        key: name
      },
      args
    }, operationId);
  }
  /**
  * Removes conditions at specified column index.
  *
  * @param {number} column Visual column index.
  */
  removeConditions(column) {
    const physicalColumn = this.hot.toPhysicalColumn(column);
    this.conditionCollection?.removeConditions(physicalColumn);
  }
  /**
  * Clears all conditions previously added to the collection for the specified column index or, if the column index
  * was not passed, clear the conditions for all columns.
  *
  * @param {number} [column] Visual column index.
  */
  clearConditions(column) {
    if (column === void 0) {
      this.conditionCollection?.clean();
    } else {
      const physicalColumn = this.hot.toPhysicalColumn(column);
      this.conditionCollection?.removeConditions(physicalColumn);
    }
  }
  /**
  * Imports filter conditions to all columns to the plugin. The method accepts
  * the array of conditions with the same structure as the {@link Filters#exportConditions} method returns.
  * Importing conditions will replace the current conditions. Once replaced, the state of the condition
  * will be reflected in the UI. To apply the changes and filter the table, call
  * the {@link Filters#filter} method eventually.
  *
  * @param {Array} conditions Array of conditions.
  */
  importConditions(conditions2) {
    this.conditionCollection?.importAllConditions(conditions2);
  }
  /**
  * Exports filter conditions for all columns from the plugin.
  * The array represents the filter state for each column. For example:
  *
  * ```js
  * [
  *   {
  *     column: 1,
  *     operation: 'conjunction',
  *     conditions: [
  *       { name: 'gt', args: [95] },
  *     ]
  *   },
  *   {
  *     column: 7,
  *     operation: 'conjunction',
  *     conditions: [
  *       { name: 'contains', args: ['mike'] },
  *       { name: 'begins_with', args: ['m'] },
  *     ]
  *   },
  * ]
  * ```
  *
  * @returns {Array}
  */
  exportConditions() {
    return this.conditionCollection?.exportAllConditions() ?? [];
  }
  /**
  * Filters data based on added filter conditions.
  *
  * @fires Hooks#beforeFilter
  * @fires Hooks#afterFilter
  */
  filter() {
    const { navigableHeaders } = this.hot.getSettings();
    const needToFilter = !this.conditionCollection?.isEmpty();
    const conditions2 = this.exportConditions();
    if (_class_private_field_get$z(this, _isDataProviderActive$1)) {
      _class_private_field_set$z(this, _dataProviderFilterRollbackStack, deepClone(_class_private_field_get$z(this, _previousConditionStack)));
    }
    const allowFiltering = this.hot.runHooks("beforeFilter", conditions2, _class_private_field_get$z(this, _previousConditionStack));
    if (allowFiltering !== false && needToFilter) {
      const trimmedRows = [];
      const dataFilter = this._createDataFilter();
      const rowIndexesToShow = arrayMap(dataFilter.filter(), (rowData) => rowData.meta.row);
      const rowIndexesToShowAssertion = createArrayAssertion(rowIndexesToShow);
      this.hot.batchExecution(() => {
        this.filtersRowsMap?.clear();
        rangeEach(this.hot.countSourceRows() - 1, (row) => {
          if (!rowIndexesToShowAssertion(row)) {
            trimmedRows.push(row);
          }
        });
        arrayEach(trimmedRows, (physicalRow) => {
          this.filtersRowsMap?.setValueAtIndex(physicalRow, true);
        });
      }, true);
      if (!navigableHeaders && !rowIndexesToShow.length) {
        this.hot.deselectCell();
      }
      _class_private_field_set$z(this, _previousConditionStack, this.exportConditions());
    } else if (allowFiltering !== false && !needToFilter) {
      _class_private_field_set$z(this, _previousConditionStack, this.exportConditions());
      this.filtersRowsMap?.clear();
    } else if (_class_private_field_get$z(this, _isDataProviderActive$1)) {
      _class_private_field_set$z(this, _previousConditionStack, this.exportConditions());
    } else {
      this.importConditions(_class_private_field_get$z(this, _previousConditionStack));
    }
    if (this.hot.selection.isSelected()) {
      const highlightCol = this.hot.getSelectedRangeActive()?.highlight.col;
      if (highlightCol !== null && highlightCol !== void 0) {
        this.hot.selectCell(navigableHeaders ? -1 : 0, highlightCol);
      }
    }
    if (allowFiltering !== false) {
      this.hot.runHooks("afterFilter", conditions2);
      this.hot.view.adjustElementsSize();
      this.hot.render();
    }
  }
  /**
  * Gets last selected column index.
  *
  * @returns {{visualIndex: number, physicalIndex: number} | null} Returns `null` when a column is
  * not selected. Otherwise, returns an object with `visualIndex` and `physicalIndex` properties containing
  * the index of the column.
  */
  getSelectedColumn() {
    const highlight = this.hot.getSelectedRangeActive()?.highlight;
    if (!highlight || highlight.col === null) {
      return null;
    }
    return {
      visualIndex: highlight.col,
      physicalIndex: this.hot.toPhysicalColumn(highlight.col)
    };
  }
  /**
  * Returns the full dataset for a column with cell meta for each row. The dataset is independent of
  * any index mapper - no matter if the data is filtered, sorted, or otherwise transformed all rows
  * are included.
  *
  * @param {number} physicalColumn The physical column index.
  * @returns {Array<{meta: CellProperties, value: *}>} Array of objects with `meta` and `value`, one per source row.
  */
  getDataMapAtColumn(physicalColumn) {
    const countSourceRows = this.hot.countSourceRows();
    const visualColumn = this.hot.toVisualColumn(physicalColumn);
    const data = [];
    for (let physicalRow = 0; physicalRow < countSourceRows; physicalRow++) {
      const cellMeta = this.hot._getMetaManager().getCellMeta(physicalRow, physicalColumn, {
        visualRow: physicalRow,
        visualColumn: physicalColumn,
        skipMetaExtension: true
      });
      let value = getValueGetterValue(this.hot.getSourceDataAtCell(physicalRow, visualColumn), cellMeta);
      if (this.hot.hasHook("modifyData")) {
        const valueHolder = createObjectPropListener(value);
        this.hot.runHooks("modifyData", physicalRow, physicalColumn, valueHolder, "get");
        if (valueHolder.isTouched()) {
          value = valueHolder.value;
        }
      }
      data.push({
        meta: cellMeta,
        value: toEmptyString(value)
      });
    }
    return data;
  }
  /**
  * Update the condition of ValueComponent, based on the handled changes.
  *
  * @private
  * @param {number} columnIndex Physical column index of handled ValueComponent condition.
  */
  updateValueComponentCondition(columnIndex) {
    const visualColumnIndex = this.hot.toVisualColumn(columnIndex);
    const dataAtCol = this.hot.getDataAtCol(visualColumnIndex);
    const columnMeta = this.hot.countRows() > 0 ? this.hot.getCellMeta(0, visualColumnIndex) : null;
    const comparator = getSortComparatorForMeta(columnMeta);
    const selectedValues = unifyColumnValues(dataAtCol, comparator);
    this.conditionUpdateObserver?.updateStatesAtColumn(columnIndex, selectedValues);
  }
  /**
  * Restores components to its saved state.
  *
  * @private
  * @param {Array} components List of components.
  */
  restoreComponents(components) {
    const physicalIndex = this.getSelectedColumn()?.physicalIndex ?? -1;
    components.forEach((component) => {
      if (component.isHidden()) {
        return;
      }
      component.restoreState(physicalIndex);
    });
    this.updateDependentComponentsVisibility();
  }
  /**
  * Get an operation, based on the number and types of arguments (where arguments are states of components).
  *
  * @param {string} suggestedOperation Operation which was chosen by user from UI.
  * @param {object} byConditionState1 State of first condition component.
  * @param {object} byConditionState2 State of second condition component.
  * @param {object} byValueState State of value component.
  * @private
  * @returns {string}
  */
  getOperationBasedOnArguments(suggestedOperation, byConditionState1, byConditionState2, byValueState) {
    let operation = suggestedOperation;
    const cmd1 = byConditionState1.command?.key;
    const cmd2 = byConditionState2.command?.key;
    const cmdV = byValueState.command?.key;
    if (operation === OPERATION_ID$1 && cmd1 !== CONDITION_NAME$B && cmd2 !== CONDITION_NAME$B && cmdV !== CONDITION_NAME$B) {
      operation = OPERATION_ID;
    } else if (cmdV !== CONDITION_NAME$B) {
      if (cmd1 === CONDITION_NAME$B || cmd2 === CONDITION_NAME$B) {
        operation = OPERATION_ID$2;
      }
    }
    return operation;
  }
  /**
  * Listen to the keyboard input on document body and forward events to instance of Handsontable
  * created by DropdownMenu plugin.
  *
  * @private
  */
  setListeningDropdownMenu() {
    if (this.dropdownMenuPlugin) {
      this.dropdownMenuPlugin.setListening();
    }
  }
  /**
  * Updates visibility of some of the components, based on the state of the parent component.
  *
  * @private
  */
  updateDependentComponentsVisibility() {
    const component = _class_private_method_get$n(this, _getConditionComponent, getConditionComponent).call(this, "filter_by_condition");
    const defaultState = {
      command: {}
    };
    const state = component?.getState() ?? defaultState;
    const command2 = state.command;
    const componentsToShow = [
      this.components.get("filter_by_condition2"),
      this.components.get("filter_operators")
    ].filter((c) => c !== null && c !== void 0);
    if (command2?.showOperators) {
      this.showComponents(...componentsToShow);
    } else {
      this.hideComponents(...componentsToShow);
    }
  }
  /**
  * Creates DataFilter instance based on condition collection.
  *
  * @private
  * @param {ConditionCollection} conditionCollection Condition collection object.
  * @returns {DataFilter}
  */
  _createDataFilter(conditionCollection = this.conditionCollection) {
    if (!conditionCollection) {
      conditionCollection = new ConditionCollection(this.hot, false);
    }
    return new DataFilter(conditionCollection, (physicalColumn) => this.getDataMapAtColumn(physicalColumn));
  }
  /**
  * Returns indexes of passed components inside list of `dropdownMenu` items.
  *
  * @private
  * @param {...BaseComponent} components List of components.
  * @returns {Array}
  */
  getIndexesOfComponents(...components) {
    const menu = this.dropdownMenuPlugin?.menu;
    if (!menu) {
      return [];
    }
    return components.map((component) => menu.getItemPositionByKey(String(component.getMenuItemDescriptor().key))).filter((index2) => index2 !== -1);
  }
  /**
  * Changes visibility of component.
  *
  * @private
  * @param {boolean} visible Determine if components should be visible.
  * @param {...BaseComponent} components List of components.
  */
  changeComponentsVisibility(visible = true, ...components) {
    if (!this.dropdownMenuPlugin) {
      return;
    }
    const menu = this.dropdownMenuPlugin.menu;
    if (!menu) {
      return;
    }
    const hotMenu = menu.hotMenu;
    if (!hotMenu) {
      return;
    }
    const hiddenRows = hotMenu.getPlugin("hiddenRows");
    const indexes = this.getIndexesOfComponents(...components);
    if (visible) {
      hiddenRows.showRows(indexes);
    } else {
      hiddenRows.hideRows(indexes);
    }
    hotMenu.render();
  }
  /**
  * Hides components of filters `dropdownMenu`.
  *
  * @private
  * @param {...BaseComponent} components List of components.
  */
  hideComponents(...components) {
    this.changeComponentsVisibility(false, ...components);
  }
  /**
  * Shows components of filters `dropdownMenu`.
  *
  * @private
  * @param {...BaseComponent} components List of components.
  */
  showComponents(...components) {
    this.changeComponentsVisibility(true, ...components);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    if (this.enabled) {
      this.components.forEach((component, key) => {
        if (component !== null) {
          component.destroy();
          this.components.set(key, null);
        }
      });
      this.conditionCollection?.destroy();
      this.conditionUpdateObserver?.destroy();
      this.hot.rowIndexMapper.unregisterMap(this.pluginName ?? "");
    }
    super.destroy();
  }
  /**
  * Initializes the plugin and registers the column header hook needed to inject the filter UI.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$n(this, _getConditionComponent), _class_private_method_init$n(this, _getOperatorsComponent), _class_private_method_init$n(this, _getValueComponent), _class_private_method_init$n(this, _onActionBarSubmit), _class_private_method_init$n(this, _onComponentChange), _class_private_method_init$n(this, _onSelectUIClosed), _class_private_method_init$n(this, _updateComponents), _class_private_field_init$z(this, _menuFocusNavigator, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _dropdownMenuTraces, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _previousConditionStack, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _dataProviderFilterRollbackStack, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _isDataProviderActive$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterChange$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterUpdateData, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterDataProviderFetch$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterDataProviderFetchError, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterDropdownMenuShow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterDropdownMenuHide, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onBeforeDropdownMenuShow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterDropdownMenuDefaultOptions, {
      writable: true,
      value: void 0
    }), _class_private_field_init$z(this, _onAfterGetColHeader$1, {
      writable: true,
      value: void 0
    }), /**
    * Instance of {@link DropdownMenu}.
    *
    * @private
    * @type {DropdownMenu}
    */
    this.dropdownMenuPlugin = null, /**
    * Instance of {@link ConditionCollection}.
    *
    * @private
    * @type {ConditionCollection}
    */
    this.conditionCollection = null, /**
    * Instance of {@link ConditionUpdateObserver}.
    *
    * @private
    * @type {ConditionUpdateObserver}
    */
    this.conditionUpdateObserver = null, /**
    * Map, where key is component identifier and value represent `BaseComponent` element or it derivatives.
    *
    * @private
    * @type {Map}
    */
    this.components = /* @__PURE__ */ new Map([
      [
        "filter_by_condition",
        null
      ],
      [
        "filter_operators",
        null
      ],
      [
        "filter_by_condition2",
        null
      ],
      [
        "filter_by_value",
        null
      ],
      [
        "filter_action_bar",
        null
      ]
    ]), /**
    * Map of skipped rows by plugin.
    *
    * @private
    * @type {null|TrimmingMap}
    */
    this.filtersRowsMap = null, _class_private_field_set$z(this, _dropdownMenuTraces, /* @__PURE__ */ new WeakSet()), _class_private_field_set$z(this, _previousConditionStack, []), _class_private_field_set$z(this, _dataProviderFilterRollbackStack, []), _class_private_field_set$z(this, _isDataProviderActive$1, false), _class_private_field_set$z(this, _onAfterChange$2, (changes) => {
      if (changes) {
        arrayEach(changes, (change) => {
          const [, prop] = change;
          const visualColumnIndex = this.hot.propToCol(prop);
          const physicalColumnIndex = this.hot.toPhysicalColumn(visualColumnIndex);
          if (this.conditionCollection?.hasConditions(physicalColumnIndex)) {
            this.updateValueComponentCondition(physicalColumnIndex);
          }
        });
      }
    }), _class_private_field_set$z(this, _onAfterUpdateData, (_data2, firstRun) => {
      if (firstRun || _class_private_field_get$z(this, _isDataProviderActive$1) || !this.conditionCollection) {
        return;
      }
      const filteredColumns = this.conditionCollection?.getFilteredColumns() ?? [];
      if (filteredColumns.length === 0) {
        return;
      }
      arrayEach(filteredColumns, (physicalColumn) => {
        this.conditionUpdateObserver?.updateStatesAtColumn(physicalColumn);
      });
    }), _class_private_field_set$z(this, _onAfterDataProviderFetch$1, (result) => {
      this.importConditions(result?.filtersConditionsStack ?? []);
    }), _class_private_field_set$z(this, _onAfterDataProviderFetchError, () => {
      this.importConditions(_class_private_field_get$z(this, _dataProviderFilterRollbackStack));
    }), _class_private_field_set$z(this, _onAfterDropdownMenuShow, () => {
      const menu = this.dropdownMenuPlugin?.menu;
      if (!menu) {
        return;
      }
      this.restoreComponents(Array.from(this.components.values()).filter((c) => c !== null));
      menu.updateMenuDimensions();
    }), _class_private_field_set$z(this, _onAfterDropdownMenuHide, () => {
      this.components.get("filter_by_condition")?.getSelectElement()?.closeOptions();
      this.components.get("filter_by_condition2")?.getSelectElement()?.closeOptions();
    }), _class_private_field_set$z(this, _onBeforeDropdownMenuShow, () => {
      const mainMenu = this.dropdownMenuPlugin?.menu;
      if (!mainMenu) {
        return;
      }
      if (!_class_private_field_get$z(this, _dropdownMenuTraces).has(mainMenu)) {
        _class_private_field_get$z(this, _menuFocusNavigator)?.setMenu(mainMenu);
      }
      _class_private_field_get$z(this, _dropdownMenuTraces).add(mainMenu);
    }), _class_private_field_set$z(this, _onAfterDropdownMenuDefaultOptions, (defaultOptions) => {
      defaultOptions.items.push({
        name: KEY$c
      });
      this.components.forEach((component) => {
        if (component) {
          defaultOptions.items.push(component.getMenuItemDescriptor());
        }
      });
    }), _class_private_field_set$z(this, _onAfterGetColHeader$1, (col, TH) => {
      const physicalColumn = this.hot.toPhysicalColumn(col);
      if (this.enabled && this.conditionCollection?.hasConditions(physicalColumn) && isBottomMostColumnHeader(TH)) {
        addClass(TH, "htFiltersActive");
      } else {
        removeClass(TH, "htFiltersActive");
      }
    });
    this.hot.addHook("afterGetColHeader", _class_private_field_get$z(this, _onAfterGetColHeader$1));
  }
}
function getConditionComponent(id) {
  return this.components.get(id) ?? null;
}
function getOperatorsComponent() {
  return this.components.get("filter_operators") ?? null;
}
function getValueComponent() {
  return this.components.get("filter_by_value") ?? null;
}
function onActionBarSubmit(submitType) {
  if (submitType === "accept") {
    const selectedColumn = this.getSelectedColumn();
    if (selectedColumn === null) {
      this.dropdownMenuPlugin?.close();
      return;
    }
    const { physicalIndex } = selectedColumn;
    const noneState = {
      command: {
        key: CONDITION_NAME$B
      },
      args: []
    };
    const byConditionState1 = _class_private_method_get$n(this, _getConditionComponent, getConditionComponent).call(this, "filter_by_condition")?.getState() ?? noneState;
    const byConditionState2 = _class_private_method_get$n(this, _getConditionComponent, getConditionComponent).call(this, "filter_by_condition2")?.getState() ?? noneState;
    const byValueState = _class_private_method_get$n(this, _getValueComponent, getValueComponent).call(this)?.getState() ?? noneState;
    const operation = this.getOperationBasedOnArguments(_class_private_method_get$n(this, _getOperatorsComponent, getOperatorsComponent).call(this)?.getActiveOperationId() ?? OPERATION_ID$2, byConditionState1, byConditionState2, byValueState);
    this.conditionUpdateObserver?.groupChanges();
    let columnStackPosition = this.conditionCollection?.getColumnStackPosition(physicalIndex);
    if (columnStackPosition === void 0 || columnStackPosition === -1) {
      columnStackPosition = void 0;
    }
    this.conditionCollection?.removeConditions(physicalIndex);
    const cmd1 = byConditionState1.command?.key;
    const cmd2 = byConditionState2.command?.key;
    const cmdV = byValueState.command?.key;
    if (cmd1 !== CONDITION_NAME$B) {
      this.conditionCollection?.addCondition(physicalIndex, byConditionState1, operation, columnStackPosition);
      if (cmd2 !== CONDITION_NAME$B) {
        this.conditionCollection?.addCondition(physicalIndex, byConditionState2, operation, columnStackPosition);
      }
    }
    if (cmdV !== CONDITION_NAME$B && !_class_private_field_get$z(this, _isDataProviderActive$1)) {
      this.conditionCollection?.addCondition(physicalIndex, byValueState, operation, columnStackPosition);
    }
    this.conditionUpdateObserver?.flush();
    this.components.forEach((component) => component?.saveState(physicalIndex));
    this.filter();
  }
  this.dropdownMenuPlugin?.close();
}
function onComponentChange(component, command2) {
  const menu = this.dropdownMenuPlugin?.menu;
  this.updateDependentComponentsVisibility();
  if (component.constructor === ConditionComponent && !command2.inputsCount) {
    this.setListeningDropdownMenu();
  }
  menu?.updateMenuDimensions();
}
function onSelectUIClosed() {
  this.setListeningDropdownMenu();
}
function updateComponents(conditionsState) {
  if (!this.dropdownMenuPlugin?.enabled) {
    return;
  }
  const editedStack = conditionsState.editedConditionStack;
  const conditions2 = editedStack.conditions;
  const column = editedStack.column;
  const conditionArgsChange = conditionsState.conditionArgsChange;
  if (Array.isArray(conditionArgsChange)) {
    _class_private_field_set$z(this, _previousConditionStack, _class_private_field_get$z(this, _previousConditionStack).map((stack) => {
      if (stack.column === column && conditions2.length > 0) {
        stack.conditions.forEach((condition2) => {
          if (condition2.name === "by_value") {
            condition2.args = [
              [
                ...conditionArgsChange
              ]
            ];
          }
        });
      }
      return stack;
    }));
  }
  const conditionsByValue = conditions2.filter((condition2) => condition2.name === CONDITION_NAME$1);
  const conditionsWithoutByValue = conditions2.filter((condition2) => condition2.name !== CONDITION_NAME$1);
  if (conditionsByValue.length >= 2 || conditionsWithoutByValue.length >= 3) {
    warn$1(toSingleLine`The filter conditions have been applied properly, but couldn’t be displayed visually.\x20
        The dropdown menu supports at most 2 regular conditions and 1 'filter by value' condition per column,\x20
        but more were provided. For more details see the documentation.`);
  } else {
    const operationType = this.conditionCollection?.getOperation(column);
    _class_private_method_get$n(this, _getConditionComponent, getConditionComponent).call(this, "filter_by_condition")?.updateState(conditionsWithoutByValue[0], column);
    _class_private_method_get$n(this, _getConditionComponent, getConditionComponent).call(this, "filter_by_condition2")?.updateState(conditionsWithoutByValue[1], column);
    _class_private_method_get$n(this, _getOperatorsComponent, getOperatorsComponent).call(this)?.updateState(operationType ?? OPERATION_ID$2, column);
    _class_private_method_get$n(this, _getValueComponent, getValueComponent).call(this)?.updateState(conditionsState);
  }
}
const DEFAULT_LICENSE_KEY = "internal-use-in-handsontable";
const DEFAULT_SETTINGS = {
  licenseKey: DEFAULT_LICENSE_KEY,
  useArrayArithmetic: true,
  useColumnIndex: false,
  useStats: false,
  evaluateNullToZero: true,
  precisionEpsilon: 1e-13,
  precisionRounding: 14,
  smartRounding: true,
  leapYear1900: false,
  nullDate: {
    year: 1899,
    month: 12,
    day: 30
  },
  nullYear: 30,
  dateFormats: [
    "YYYY-MM-DD"
  ],
  timeFormats: [
    "hh:mm",
    "hh:mm:ss",
    "hh:mm:ss.sss"
  ],
  matchWholeCell: true,
  useRegularExpressions: false,
  useWildcards: true,
  functionArgSeparator: ",",
  thousandSeparator: "",
  decimalSeparator: ".",
  language: "enGB"
};
function getEngineSettingsOverrides(hotSettings) {
  const pluginSetting = hotSettings[PLUGIN_KEY$m];
  return {
    maxColumns: hotSettings.maxColumns,
    maxRows: hotSettings.maxRows,
    language: pluginSetting?.language?.langCode
  };
}
function cleanEngineSettings(pluginSettings) {
  return Object.keys(pluginSettings).reduce((obj, key) => {
    if (key !== "hyperformula") {
      obj[key] = pluginSettings[key];
    }
    return obj;
  }, {});
}
function getEngineSettingsWithDefaultsAndOverrides(hotSettings) {
  const pluginSettings = hotSettings[PLUGIN_KEY$m];
  const engine = pluginSettings?.engine;
  const userSettings = cleanEngineSettings(engine?.hyperformula ? engine : {});
  const overrides = getEngineSettingsOverrides(hotSettings);
  return {
    ...DEFAULT_SETTINGS,
    ...userSettings,
    ...overrides
  };
}
function getEngineSettingsWithOverrides(hotSettings) {
  const pluginSettings = hotSettings[PLUGIN_KEY$m];
  const engine = pluginSettings?.engine;
  const userSettings = cleanEngineSettings(engine?.hyperformula ? engine : {});
  const overrides = getEngineSettingsOverrides(hotSettings);
  return {
    ...userSettings,
    ...overrides
  };
}
function haveEngineSettingsChanged(currentEngineSettings, newEngineSettings) {
  return Object.keys(newEngineSettings).some((settingOption) => {
    return newEngineSettings[settingOption] !== void 0 && newEngineSettings[settingOption] !== currentEngineSettings[settingOption];
  });
}
function getEngineRelationshipRegistry() {
  const registryKey = "engine_relationship";
  const pluginStaticRegistry = staticRegister(PLUGIN_KEY$m);
  if (!pluginStaticRegistry.hasItem(registryKey)) {
    pluginStaticRegistry.register(registryKey, /* @__PURE__ */ new Map());
  }
  return pluginStaticRegistry.getItem(registryKey);
}
function getSharedEngineUsageRegistry() {
  const registryKey = "shared_engine_usage";
  const pluginStaticRegistry = staticRegister(PLUGIN_KEY$m);
  if (!pluginStaticRegistry.hasItem(registryKey)) {
    pluginStaticRegistry.register(registryKey, /* @__PURE__ */ new Map());
  }
  return pluginStaticRegistry.getItem(registryKey);
}
function setupEngine(hotInstance) {
  const hotSettings = hotInstance.getSettings();
  const pluginSettings = hotSettings[PLUGIN_KEY$m];
  if (!pluginSettings || pluginSettings === true) {
    return null;
  }
  const engineConfigItem = pluginSettings?.engine;
  if (engineConfigItem === void 0) {
    return null;
  }
  if (typeof engineConfigItem.hyperformula === "function") {
    return registerEngine(engineConfigItem.hyperformula, hotSettings, hotInstance);
  }
  if (typeof engineConfigItem === "function") {
    return registerEngine(engineConfigItem, hotSettings, hotInstance);
  } else if (typeof engineConfigItem === "object" && isUndefined$1(engineConfigItem.hyperformula)) {
    const engineRelationship = getEngineRelationshipRegistry();
    const sharedEngineUsage = getSharedEngineUsageRegistry().get(engineConfigItem);
    if (!engineRelationship.has(engineConfigItem)) {
      engineRelationship.set(engineConfigItem, []);
    }
    engineRelationship.get(engineConfigItem).push(hotInstance);
    if (sharedEngineUsage) {
      sharedEngineUsage.push(hotInstance.guid);
    }
    if (!engineConfigItem.getConfig().licenseKey) {
      engineConfigItem.updateConfig({
        licenseKey: DEFAULT_LICENSE_KEY
      });
    }
    if (engineConfigItem.getConfig().leapYear1900 !== DEFAULT_SETTINGS.leapYear1900 || isObjectEqual(engineConfigItem.getConfig().nullDate, DEFAULT_SETTINGS.nullDate) === false) {
      warn$1(toSingleLine`If you use HyperFormula with Handsontable, keep the default \`leapYear1900\` and \`nullDate\` 
      settings. Otherwise, HyperFormula's dates may not sync correctly with Handsontable's dates.`);
    }
    return engineConfigItem;
  }
  return null;
}
function registerEngine(engineClass, hotSettings, hotInstance) {
  const pluginSettings = hotSettings[PLUGIN_KEY$m];
  const engineSettings = getEngineSettingsWithDefaultsAndOverrides(hotSettings);
  const engineRegistry = getEngineRelationshipRegistry();
  const sharedEngineRegistry = getSharedEngineUsageRegistry();
  registerCustomFunctions(engineClass, pluginSettings.functions);
  registerLanguage(engineClass, pluginSettings.language);
  const engineInstance = engineClass.buildEmpty(engineSettings);
  engineRegistry.set(engineInstance, [
    hotInstance
  ]);
  sharedEngineRegistry.set(engineInstance, [
    hotInstance.guid
  ]);
  registerNamedExpressions(engineInstance, pluginSettings.namedExpressions);
  engineInstance.on("sheetAdded", () => {
    engineInstance.rebuildAndRecalculate();
  });
  engineInstance.on("sheetRemoved", () => {
    engineInstance.rebuildAndRecalculate();
  });
  return engineInstance;
}
function getRegisteredHotInstances(engine) {
  const engineRegistry = getEngineRelationshipRegistry();
  const hotInstances = engineRegistry.size === 0 ? [] : Array.from(engineRegistry.get(engine) ?? []);
  return new Map(hotInstances.map((hot) => {
    const hotInstance = hot;
    return [
      hotInstance.getPlugin("formulas").sheetId,
      hotInstance
    ];
  }));
}
function unregisterEngine(engine, hotInstance) {
  if (engine) {
    const engineRegistry = getEngineRelationshipRegistry();
    const engineHotRelationship = engineRegistry.get(engine);
    const sharedEngineRegistry = getSharedEngineUsageRegistry();
    const sharedEngineUsage = sharedEngineRegistry.get(engine);
    if (engineHotRelationship && engineHotRelationship.includes(hotInstance)) {
      engineHotRelationship.splice(engineHotRelationship.indexOf(hotInstance), 1);
      if (engineHotRelationship.length === 0) {
        engineRegistry.delete(engine);
      }
    }
    if (sharedEngineUsage && sharedEngineUsage.includes(hotInstance.guid)) {
      sharedEngineUsage.splice(sharedEngineUsage.indexOf(hotInstance.guid), 1);
      if (sharedEngineUsage.length === 0) {
        sharedEngineRegistry.delete(engine);
        engine.destroy();
      }
    }
  }
}
function registerCustomFunctions(engineClass, customFunctions) {
  if (customFunctions) {
    customFunctions.forEach((func) => {
      const { name, plugin, translations } = func;
      try {
        engineClass.registerFunction(name, plugin, translations);
      } catch (e) {
        warn$1(e instanceof Error ? e.message : String(e));
      }
    });
  }
}
function registerLanguage(engineClass, languageSetting) {
  if (languageSetting) {
    const { langCode } = languageSetting;
    try {
      engineClass.registerLanguage(langCode, languageSetting);
    } catch (e) {
      warn$1(e instanceof Error ? e.message : String(e));
    }
  }
}
function registerNamedExpressions(engineInstance, namedExpressions) {
  if (namedExpressions) {
    engineInstance.suspendEvaluation();
    namedExpressions.forEach((namedExp) => {
      const { name, expression, scope, options } = namedExp;
      try {
        engineInstance.addNamedExpression(name, expression, scope, options);
      } catch (e) {
        warn$1(e instanceof Error ? e.message : String(e));
      }
    });
    engineInstance.resumeEvaluation();
  }
}
function setupSheet(engineInstance, sheetName) {
  if (isUndefined$1(sheetName) || !engineInstance.doesSheetExist(sheetName)) {
    sheetName = engineInstance.addSheet(sheetName);
  }
  return sheetName;
}
function isEscapedFormulaExpression(expression) {
  return typeof expression === "string" && expression.charAt(0) === "'" && expression.charAt(1) === "=";
}
function unescapeFormulaExpression(expression) {
  return typeof expression === "string" && isEscapedFormulaExpression(expression) ? expression.substr(1) : expression;
}
function isFormula(value) {
  return typeof value === "string" && value.startsWith("=");
}
function isDate(value, cellType) {
  return typeof value === "string" && cellType === "date";
}
function isDateValid(date) {
  return isValidISODate(date);
}
function getDateInHfFormat(date) {
  return date;
}
function getDateInHotFormat(date) {
  return date;
}
function getTimeFromHfTimeFraction(numericTime) {
  const SECONDS_IN_DAY = 86400;
  const dayFraction = numericTime - Math.floor(numericTime);
  const totalSeconds = Math.round(dayFraction * SECONDS_IN_DAY);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const hhmm = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  return seconds > 0 ? `${hhmm}:${String(seconds).padStart(2, "0")}` : hhmm;
}
function getDateFromExcelDate(numericDate) {
  const epochMs = Date.UTC(1899, 11, 30);
  const dateMs = epochMs + numericDate * 864e5;
  const d = new Date(dateMs);
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function normalizeValueForFormulaEngine(value) {
  if (Array.isArray(value)) {
    return valueGetter(value);
  }
  return value;
}
function getMoveLine(movedIndexes, finalIndex, numberOfIndexes) {
  const notMovedElements = Array.from(Array(numberOfIndexes).keys()).filter((index2) => movedIndexes.includes(index2) === false);
  if (finalIndex === 0) {
    return notMovedElements[finalIndex] ?? 0;
  }
  return notMovedElements[finalIndex - 1] + 1;
}
function getInitiallyCalculatedMoves(movedIndexes, moveLine) {
  const moves = [];
  movedIndexes.forEach((movedIndex) => {
    const move = {
      from: movedIndex,
      to: moveLine
    };
    moves.forEach((previouslyMovedIndex) => {
      const isMovingFromEndToStart = previouslyMovedIndex.from > previouslyMovedIndex.to;
      const isMovingElementBefore = previouslyMovedIndex.to <= move.from;
      const isMovingAfterElement = previouslyMovedIndex.from > move.from;
      if (isMovingAfterElement && isMovingElementBefore && isMovingFromEndToStart) {
        move.from += 1;
      }
    });
    if (move.from >= moveLine) {
      moveLine += 1;
    }
    moves.push(move);
  });
  return moves;
}
function adjustedCalculatedMoves(moves) {
  moves.forEach((move, index2) => {
    const nextMoved = moves.slice(index2 + 1);
    nextMoved.forEach((nextMovedIndex) => {
      const isMovingFromStartToEnd = nextMovedIndex.from < nextMovedIndex.to;
      if (nextMovedIndex.from > move.from && isMovingFromStartToEnd) {
        nextMovedIndex.from -= 1;
      }
    });
  });
  return moves;
}
function getMoves(movedIndexes, finalIndex, numberOfIndexes) {
  const moves = getInitiallyCalculatedMoves(movedIndexes, getMoveLine(movedIndexes, finalIndex, numberOfIndexes));
  return adjustedCalculatedMoves(moves);
}
function _check_private_redeclaration$A(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$y(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$y(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$y(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$y(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$y(receiver, privateMap, "get");
  return _class_apply_descriptor_get$y(receiver, descriptor);
}
function _class_private_field_init$y(obj, privateMap, value) {
  _check_private_redeclaration$A(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$y(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$y(receiver, privateMap, "set");
  _class_apply_descriptor_set$y(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$m(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$m(obj, privateSet) {
  _check_private_redeclaration$A(obj, privateSet);
  privateSet.add(obj);
}
var _axis = /* @__PURE__ */ new WeakMap(), _indexMapper = /* @__PURE__ */ new WeakMap(), _indexSyncer = /* @__PURE__ */ new WeakMap(), _indexesSequence = /* @__PURE__ */ new WeakMap(), _movedIndexes = /* @__PURE__ */ new WeakMap(), _finalIndex = /* @__PURE__ */ new WeakMap(), _removedIndexes = /* @__PURE__ */ new WeakMap(), _syncInitialOrder = /* @__PURE__ */ new WeakSet();
class AxisSyncer {
  /**
  * Sets removed HF indexes (it should be done right before performing move on HOT).
  *
  * @param {Array<number>} removedIndexes List of removed physical indexes.
  * @returns {Array<number>} List of removed visual indexes.
  */
  setRemovedHfIndexes(removedIndexes) {
    _class_private_field_set$y(this, _removedIndexes, removedIndexes.map((physicalIndex) => {
      const visualIndex = _class_private_field_get$y(this, _indexMapper).getVisualFromPhysicalIndex(physicalIndex);
      return this.getHfIndexFromVisualIndex(visualIndex ?? -1);
    }));
    return _class_private_field_get$y(this, _removedIndexes);
  }
  /**
  * Gets removed HF indexes (right before performing removal on HOT).
  *
  * @returns {Array<number>} List of removed HF indexes.
  */
  getRemovedHfIndexes() {
    return _class_private_field_get$y(this, _removedIndexes);
  }
  /**
  * Gets corresponding HyperFormula index for particular visual index. It's respecting the idea that HF's engine
  * is fed also with trimmed indexes (business requirements for formula result calculation also for trimmed elements).
  *
  * @param {number} visualIndex Visual index.
  * @returns {number}
  */
  getHfIndexFromVisualIndex(visualIndex) {
    const indexesSequence = _class_private_field_get$y(this, _indexMapper).getIndexesSequence();
    const notTrimmedIndexes = _class_private_field_get$y(this, _indexMapper).getNotTrimmedIndexes();
    return indexesSequence.indexOf(notTrimmedIndexes[visualIndex], visualIndex);
  }
  /**
  * Gets corresponding visual index for a HyperFormula index. Inverse of {@link getHfIndexFromVisualIndex}.
  * Returns -1 when the HF index points to a trimmed element (not visible to the user).
  *
  * @param {number} hfIndex HyperFormula index.
  * @returns {number}
  */
  getVisualIndexFromHfIndex(hfIndex) {
    const indexesSequence = _class_private_field_get$y(this, _indexMapper).getIndexesSequence();
    const notTrimmedIndexes = _class_private_field_get$y(this, _indexMapper).getNotTrimmedIndexes();
    const physicalIndex = indexesSequence[hfIndex];
    if (physicalIndex === void 0) {
      return -1;
    }
    return notTrimmedIndexes.indexOf(physicalIndex);
  }
  /**
  * Synchronizes moves done on HOT to HF engine (based on previously calculated positions).
  *
  * @private
  * @param {Array<{from: number, to: number}>} moves Calculated HF's move positions.
  */
  syncMoves(moves) {
    const NUMBER_OF_MOVED_INDEXES = 1;
    const SYNC_MOVE_METHOD_NAME = `move${toUpperCaseFirst(_class_private_field_get$y(this, _axis))}s`;
    const engine = _class_private_field_get$y(this, _indexSyncer).getEngine();
    if (!engine) {
      return;
    }
    engine.batch(() => {
      moves.forEach((move) => {
        const moveToTheSamePosition = move.from !== move.to;
        const anotherMoveWithoutEffect = move.from + 1 !== move.to;
        if (moveToTheSamePosition && anotherMoveWithoutEffect) {
          engine[SYNC_MOVE_METHOD_NAME](_class_private_field_get$y(this, _indexSyncer).getSheetId(), move.from, NUMBER_OF_MOVED_INDEXES, move.to);
        }
      });
    });
  }
  /**
  * Stores information about performed HOT moves for purpose of calculating where to move HF elements.
  *
  * @param {Array<number>} movedVisualIndexes Sequence of moved visual indexes for certain axis.
  * @param {number} visualFinalIndex Final visual place where to move HOT indexes.
  * @param {boolean} movePossible Indicates if it's possible to move HOT indexes to the desired position.
  */
  storeMovesInformation(movedVisualIndexes, visualFinalIndex, movePossible) {
    if (movePossible === false) {
      return;
    }
    _class_private_field_set$y(this, _movedIndexes, movedVisualIndexes.map((index2) => this.getHfIndexFromVisualIndex(index2)));
    _class_private_field_set$y(this, _finalIndex, this.getHfIndexFromVisualIndex(visualFinalIndex));
  }
  /**
  * Calculating where to move HF elements and performing already calculated moves.
  *
  * @param {boolean} movePossible Indicates if it was possible to move HOT indexes to the desired position.
  * @param {boolean} orderChanged Indicates if order of HOT indexes was changed by move.
  */
  calculateAndSyncMoves(movePossible, orderChanged) {
    if (_class_private_field_get$y(this, _indexSyncer).isPerformingUndoRedo()) {
      return;
    }
    if (movePossible === false || orderChanged === false) {
      return;
    }
    const calculatedMoves = getMoves(_class_private_field_get$y(this, _movedIndexes), _class_private_field_get$y(this, _finalIndex) ?? 0, _class_private_field_get$y(this, _indexMapper).getNumberOfIndexes());
    if (_class_private_field_get$y(this, _indexSyncer).getSheetId() === null) {
      _class_private_field_get$y(this, _indexSyncer).getPostponeAction(() => this.syncMoves(calculatedMoves));
    } else {
      this.syncMoves(calculatedMoves);
    }
  }
  /**
  * Gets callback for hook triggered after performing change of indexes order.
  *
  * @returns {Function}
  */
  getIndexesChangeSyncMethod() {
    const SYNC_ORDER_CHANGE_METHOD_NAME = `set${toUpperCaseFirst(_class_private_field_get$y(this, _axis))}Order`;
    return (source) => {
      if (_class_private_field_get$y(this, _indexSyncer).isPerformingUndoRedo()) {
        return;
      }
      const newSequence = _class_private_field_get$y(this, _indexMapper).getIndexesSequence();
      if (source === "update" && newSequence.length > 0) {
        const relativeTransformation = _class_private_field_get$y(this, _indexesSequence).map((index2) => newSequence.indexOf(index2));
        const sheetDimensions = _class_private_field_get$y(this, _indexSyncer).getEngine().getSheetDimensions(_class_private_field_get$y(this, _indexSyncer).getSheetId());
        let sizeForAxis;
        if (_class_private_field_get$y(this, _axis) === "row") {
          sizeForAxis = sheetDimensions.height;
        } else {
          sizeForAxis = sheetDimensions.width;
        }
        const numberOfReorganisedIndexes = relativeTransformation.length;
        for (let i = numberOfReorganisedIndexes; i < sizeForAxis; i += 1) {
          relativeTransformation.push(i);
        }
        _class_private_field_get$y(this, _indexSyncer).getEngine()[SYNC_ORDER_CHANGE_METHOD_NAME](_class_private_field_get$y(this, _indexSyncer).getSheetId(), relativeTransformation);
      }
      _class_private_field_set$y(this, _indexesSequence, newSequence);
    };
  }
  /**
  * Initialize the AxisSyncer.
  */
  init() {
    _class_private_method_get$m(this, _syncInitialOrder, syncInitialOrder).call(this);
    _class_private_field_set$y(this, _indexesSequence, _class_private_field_get$y(this, _indexMapper).getIndexesSequence());
  }
  /**
  * Initializes the axis syncer for the given axis with the corresponding index mapper and parent index syncer references.
  */
  constructor(axis, indexMapper, indexSyncer) {
    _class_private_method_init$m(this, _syncInitialOrder);
    _class_private_field_init$y(this, _axis, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$y(this, _indexMapper, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$y(this, _indexSyncer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$y(this, _indexesSequence, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$y(this, _movedIndexes, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$y(this, _finalIndex, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$y(this, _removedIndexes, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$y(this, _indexesSequence, []);
    _class_private_field_set$y(this, _movedIndexes, []);
    _class_private_field_set$y(this, _removedIndexes, []);
    _class_private_field_set$y(this, _axis, axis);
    _class_private_field_set$y(this, _indexMapper, indexMapper);
    _class_private_field_set$y(this, _indexSyncer, indexSyncer);
  }
}
function syncInitialOrder() {
  const sequence = _class_private_field_get$y(this, _indexMapper).getIndexesSequence();
  const isIdentity = sequence.every((value, index2) => value === index2);
  if (isIdentity || sequence.length === 0) {
    return;
  }
  const engine = _class_private_field_get$y(this, _indexSyncer).getEngine();
  const sheetId = _class_private_field_get$y(this, _indexSyncer).getSheetId();
  if (engine === null || sheetId === null) {
    _class_private_field_get$y(this, _indexSyncer).getPostponeAction()(() => _class_private_method_get$m(this, _syncInitialOrder, syncInitialOrder).call(this));
    return;
  }
  const SYNC_ORDER_CHANGE_METHOD_NAME = `set${toUpperCaseFirst(_class_private_field_get$y(this, _axis))}Order`;
  const sheetDimensions = engine.getSheetDimensions(sheetId);
  const sizeForAxis = _class_private_field_get$y(this, _axis) === "row" ? sheetDimensions.height : sheetDimensions.width;
  const transformation = Array.from({
    length: sequence.length
  }, (_, i) => sequence.indexOf(i));
  for (let i = transformation.length; i < sizeForAxis; i += 1) {
    transformation.push(i);
  }
  engine[SYNC_ORDER_CHANGE_METHOD_NAME](sheetId, transformation);
}
function _check_private_redeclaration$z(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$x(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$x(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$x(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$x(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$x(receiver, privateMap, "get");
  return _class_apply_descriptor_get$x(receiver, descriptor);
}
function _class_private_field_init$x(obj, privateMap, value) {
  _check_private_redeclaration$z(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$x(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$x(receiver, privateMap, "set");
  _class_apply_descriptor_set$x(receiver, descriptor, value);
  return value;
}
var _rowIndexSyncer = /* @__PURE__ */ new WeakMap(), _columnIndexSyncer = /* @__PURE__ */ new WeakMap(), _postponeAction = /* @__PURE__ */ new WeakMap(), _isPerformingUndo = /* @__PURE__ */ new WeakMap(), _isPerformingRedo = /* @__PURE__ */ new WeakMap(), _engine = /* @__PURE__ */ new WeakMap(), _sheetId = /* @__PURE__ */ new WeakMap();
class IndexSyncer {
  /**
  * Gets index synchronizer for a particular axis.
  *
  * @param {'row'|'column'} indexType Type of indexes.
  * @returns {AxisSyncer}
  */
  getForAxis(indexType) {
    if (indexType === "row") {
      return _class_private_field_get$x(this, _rowIndexSyncer);
    }
    return _class_private_field_get$x(this, _columnIndexSyncer);
  }
  /**
  * Sets flag informing whether an undo action is already performed (we don't execute synchronization in such case).
  *
  * @param {boolean} flagValue Boolean value for the flag.
  */
  setPerformUndo(flagValue) {
    _class_private_field_set$x(this, _isPerformingUndo, flagValue);
  }
  /**
  * Sets flag informing whether a redo action is already performed (we don't execute synchronization in such case).
  *
  * @param {boolean} flagValue Boolean value for the flag.
  */
  setPerformRedo(flagValue) {
    _class_private_field_set$x(this, _isPerformingRedo, flagValue);
  }
  /**
  * Gets information whether redo or undo action is already performed (we don't execute synchronization in such case).
  *
  * @private
  * @returns {boolean}
  */
  isPerformingUndoRedo() {
    return _class_private_field_get$x(this, _isPerformingUndo) || _class_private_field_get$x(this, _isPerformingRedo);
  }
  /**
  * Gets HyperFormula's sheet id.
  *
  * @returns {number|null}
  */
  getSheetId() {
    return _class_private_field_get$x(this, _sheetId);
  }
  /**
  * Gets engine instance that will be used for handled instance of Handsontable.
  *
  * @type {HyperFormula|null}
  */
  getEngine() {
    return _class_private_field_get$x(this, _engine);
  }
  /**
  * Gets method which will postpone execution of some action (needed when synchronization endpoint isn't setup yet).
  *
  * @returns {Function}
  */
  getPostponeAction() {
    return _class_private_field_get$x(this, _postponeAction);
  }
  /**
  * Setups a synchronization endpoint.
  *
  * @param {HyperFormula|null} engine The HF's engine instance which will be synced.
  * @param {string|null} sheetId HyperFormula's sheet name.
  */
  setupSyncEndpoint(engine, sheetId) {
    _class_private_field_set$x(this, _engine, engine);
    _class_private_field_set$x(this, _sheetId, sheetId);
    _class_private_field_get$x(this, _rowIndexSyncer).init();
    _class_private_field_get$x(this, _columnIndexSyncer).init();
  }
  /**
  * Initializes the index syncer by creating row and column axis syncers and storing the deferred action callback.
  */
  constructor(rowIndexMapper, columnIndexMapper, postponeAction) {
    _class_private_field_init$x(this, _rowIndexSyncer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$x(this, _columnIndexSyncer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$x(this, _postponeAction, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$x(this, _isPerformingUndo, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$x(this, _isPerformingRedo, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$x(this, _engine, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$x(this, _sheetId, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$x(this, _isPerformingUndo, false);
    _class_private_field_set$x(this, _isPerformingRedo, false);
    _class_private_field_set$x(this, _engine, null);
    _class_private_field_set$x(this, _sheetId, null);
    _class_private_field_set$x(this, _rowIndexSyncer, new AxisSyncer("row", rowIndexMapper, this));
    _class_private_field_set$x(this, _columnIndexSyncer, new AxisSyncer("column", columnIndexMapper, this));
    _class_private_field_set$x(this, _postponeAction, postponeAction);
  }
}
function _check_private_redeclaration$y(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$w(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$w(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$w(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$w(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$w(receiver, privateMap, "get");
  return _class_apply_descriptor_get$w(receiver, descriptor);
}
function _class_private_field_init$w(obj, privateMap, value) {
  _check_private_redeclaration$y(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$w(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$w(receiver, privateMap, "set");
  _class_apply_descriptor_set$w(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$l(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$l(obj, privateSet) {
  _check_private_redeclaration$y(obj, privateSet);
  privateSet.add(obj);
}
function isHFCellChange(value) {
  return typeof value === "object" && value !== null;
}
function isFormulasSettingsObject(value) {
  return typeof value === "object" && value !== null;
}
function hasValueProperty(candidate) {
  return typeof candidate === "object" && candidate !== null && "value" in candidate;
}
const PLUGIN_KEY$m = "formulas";
const SETTING_KEYS = [
  "maxRows",
  "maxColumns",
  "language"
];
const PLUGIN_PRIORITY$m = 260;
Hooks.getSingleton().register("afterNamedExpressionAdded");
Hooks.getSingleton().register("afterNamedExpressionRemoved");
Hooks.getSingleton().register("afterSheetAdded");
Hooks.getSingleton().register("afterSheetRemoved");
Hooks.getSingleton().register("afterSheetRenamed");
Hooks.getSingleton().register("afterFormulasValuesUpdate");
const isBlockedSource = (source) => source === "UndoRedo.undo" || source === "UndoRedo.redo" || source === "auto";
var _internalOperationPending = /* @__PURE__ */ new WeakMap(), _hotWasInitializedWithEmptyData = /* @__PURE__ */ new WeakMap(), _exportChangeValue = /* @__PURE__ */ new WeakSet(), _onEngineValuesUpdated = /* @__PURE__ */ new WeakMap(), _onEngineNamedExpressionsAdded = /* @__PURE__ */ new WeakMap(), _onEngineNamedExpressionsRemoved = /* @__PURE__ */ new WeakMap(), _onEngineSheetAdded = /* @__PURE__ */ new WeakMap(), _onEngineSheetRenamed = /* @__PURE__ */ new WeakMap(), _onEngineSheetRemoved = /* @__PURE__ */ new WeakMap(), _engineListeners = /* @__PURE__ */ new WeakMap(), _updateSheetNameAndSheetId = /* @__PURE__ */ new WeakSet(), _getValueGetterValue = /* @__PURE__ */ new WeakSet(), _getProcessedSourceDataArray = /* @__PURE__ */ new WeakSet(), _onBeforeValidate = /* @__PURE__ */ new WeakMap(), _onBeforeAutofill = /* @__PURE__ */ new WeakMap(), _onBeforeLoadData$1 = /* @__PURE__ */ new WeakMap(), _onAfterCellMetaReset = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$3 = /* @__PURE__ */ new WeakMap(), _onModifyData = /* @__PURE__ */ new WeakMap(), _onModifySourceData = /* @__PURE__ */ new WeakMap(), _onAfterSetDataAtCell = /* @__PURE__ */ new WeakMap(), _onAfterSetSourceDataAtCell = /* @__PURE__ */ new WeakMap(), _onBeforeCreateRow = /* @__PURE__ */ new WeakMap(), _onBeforeCreateCol = /* @__PURE__ */ new WeakMap(), _onBeforeRemoveRow$1 = /* @__PURE__ */ new WeakMap(), _onBeforeRemoveCol = /* @__PURE__ */ new WeakMap(), _onAfterCreateRow$2 = /* @__PURE__ */ new WeakMap(), _onAfterCreateCol$2 = /* @__PURE__ */ new WeakMap(), _onAfterRemoveRow$2 = /* @__PURE__ */ new WeakMap(), _onAfterRemoveCol$2 = /* @__PURE__ */ new WeakMap(), _onAfterDetachChild$1 = /* @__PURE__ */ new WeakMap();
class Formulas extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$m;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$m;
  }
  /**
  * Returns the list of settings keys observed by the plugin for configuration changes.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$m,
      ...SETTING_KEYS
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link Formulas#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return this.hot.getSettings()[PLUGIN_KEY$m] ? true : false;
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.engine = setupEngine(this.hot) ?? this.engine;
    if (!this.engine) {
      warn$1("Missing the required `engine` key in the Formulas settings. Please fill it with either an engine class or an engine instance.");
      return;
    }
    if (this.sheetName !== null && !this.engine.doesSheetExist(this.sheetName)) {
      const newSheetName = this.addSheet(this.sheetName, _class_private_method_get$l(this, _getProcessedSourceDataArray, getProcessedSourceDataArray).call(this));
      if (typeof newSheetName === "string") {
        _class_private_method_get$l(this, _updateSheetNameAndSheetId, updateSheetNameAndSheetId).call(this, newSheetName);
      }
    }
    this.addHook("beforeLoadData", _class_private_field_get$w(this, _onBeforeLoadData$1));
    this.addHook("afterLoadData", _class_private_field_get$w(this, _onAfterLoadData$3));
    this.addHook("beforeUpdateData", _class_private_field_get$w(this, _onBeforeLoadData$1));
    this.addHook("afterUpdateData", _class_private_field_get$w(this, _onAfterLoadData$3));
    this.addHook("modifyData", _class_private_field_get$w(this, _onModifyData));
    this.addHook("modifySourceData", _class_private_field_get$w(this, _onModifySourceData));
    this.addHook("beforeValidate", _class_private_field_get$w(this, _onBeforeValidate));
    this.addHook("afterSetSourceDataAtCell", _class_private_field_get$w(this, _onAfterSetSourceDataAtCell));
    this.addHook("afterSetDataAtCell", _class_private_field_get$w(this, _onAfterSetDataAtCell));
    this.addHook("afterSetDataAtRowProp", _class_private_field_get$w(this, _onAfterSetDataAtCell));
    this.addHook("beforeCreateRow", _class_private_field_get$w(this, _onBeforeCreateRow));
    this.addHook("beforeCreateCol", _class_private_field_get$w(this, _onBeforeCreateCol));
    this.addHook("afterCreateRow", _class_private_field_get$w(this, _onAfterCreateRow$2));
    this.addHook("afterCreateCol", _class_private_field_get$w(this, _onAfterCreateCol$2));
    this.addHook("beforeRemoveRow", _class_private_field_get$w(this, _onBeforeRemoveRow$1));
    this.addHook("beforeRemoveCol", _class_private_field_get$w(this, _onBeforeRemoveCol));
    this.addHook("afterRemoveRow", _class_private_field_get$w(this, _onAfterRemoveRow$2));
    this.addHook("afterRemoveCol", _class_private_field_get$w(this, _onAfterRemoveCol$2));
    this.indexSyncer = new IndexSyncer(this.hot.rowIndexMapper, this.hot.columnIndexMapper, (postponedAction) => {
      this.hot.addHookOnce("init", () => {
        postponedAction();
      });
    });
    this.rowAxisSyncer = this.indexSyncer.getForAxis("row");
    this.columnAxisSyncer = this.indexSyncer.getForAxis("column");
    this.hot.addHook("afterRowSequenceChange", this.rowAxisSyncer.getIndexesChangeSyncMethod());
    this.hot.addHook("afterColumnSequenceChange", this.columnAxisSyncer.getIndexesChangeSyncMethod());
    this.hot.addHook("beforeRowMove", (movedRows, finalIndex, _dropIndex, movePossible) => {
      this.rowAxisSyncer.storeMovesInformation(movedRows, finalIndex, movePossible);
    });
    this.hot.addHook("beforeColumnMove", (movedColumns, finalIndex, _dropIndex, movePossible) => {
      this.columnAxisSyncer.storeMovesInformation(movedColumns, finalIndex, movePossible);
    });
    this.hot.addHook("afterRowMove", (_movedRows, _finalIndex2, _dropIndex, movePossible, orderChanged) => {
      this.rowAxisSyncer.calculateAndSyncMoves(movePossible, orderChanged);
    });
    this.hot.addHook("afterColumnMove", (_movedColumns, _finalIndex2, _dropIndex, movePossible, orderChanged) => {
      this.columnAxisSyncer.calculateAndSyncMoves(movePossible, orderChanged);
    });
    this.hot.addHook("beforeColumnFreeze", (column, freezePerformed) => {
      const fixedColumnsStart = this.hot.getSettings().fixedColumnsStart;
      this.columnAxisSyncer.storeMovesInformation([
        column
      ], fixedColumnsStart, freezePerformed);
    });
    this.hot.addHook("afterColumnFreeze", (_column, freezePerformed) => {
      this.columnAxisSyncer.calculateAndSyncMoves(freezePerformed, freezePerformed);
    });
    this.hot.addHook("beforeColumnUnfreeze", (column, unfreezePerformed) => {
      const fixedColumnsStart = this.hot.getSettings().fixedColumnsStart;
      this.columnAxisSyncer.storeMovesInformation([
        column
      ], fixedColumnsStart - 1, unfreezePerformed);
    });
    this.hot.addHook("afterColumnUnfreeze", (_column, unfreezePerformed) => {
      this.columnAxisSyncer.calculateAndSyncMoves(unfreezePerformed, unfreezePerformed);
    });
    this.addHook("afterCellMetaReset", _class_private_field_get$w(this, _onAfterCellMetaReset));
    this.addHook("beforeUndo", () => {
      this.indexSyncer.setPerformUndo(true);
      this.engine.undo();
    });
    this.addHook("beforeRedo", () => {
      this.indexSyncer.setPerformRedo(true);
      this.engine.redo();
    });
    this.addHook("afterUndo", () => {
      this.indexSyncer.setPerformUndo(false);
    });
    this.addHook("afterUndo", () => {
      this.indexSyncer.setPerformRedo(false);
    });
    this.addHook("afterDetachChild", _class_private_field_get$w(this, _onAfterDetachChild$1));
    this.addHook("beforeAutofill", _class_private_field_get$w(this, _onBeforeAutofill));
    _class_private_field_get$w(this, _engineListeners)?.forEach(([eventName, listener]) => this.engine.on(eventName, listener));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    _class_private_field_get$w(this, _engineListeners)?.forEach(([eventName, listener]) => this.engine?.off(eventName, listener));
    if (this.engine) {
      unregisterEngine(this.engine, this.hot);
    }
    this.engine = null;
    super.disablePlugin();
  }
  /**
  * Triggered on `updateSettings`.
  *
  * @private
  * @param {object} newSettings New set of settings passed to the `updateSettings` method.
  */
  updatePlugin(newSettings) {
    const newEngineSettings = getEngineSettingsWithOverrides(this.hot.getSettings());
    if (this.engine && haveEngineSettingsChanged(this.engine.getConfig(), newEngineSettings)) {
      this.engine.updateConfig(newEngineSettings);
    }
    const pluginSettings = this.hot.getSettings()[PLUGIN_KEY$m];
    if (pluginSettings !== void 0 && typeof pluginSettings !== "boolean" && pluginSettings.sheetName !== void 0 && pluginSettings.sheetName !== this.sheetName) {
      this.switchSheet(pluginSettings.sheetName);
    }
    if (!newSettings.data && this.sheetName === null) {
      const formulasSettings = this.hot.getSettings()[PLUGIN_KEY$m];
      const sheetName = isFormulasSettingsObject(formulasSettings) ? formulasSettings.sheetName : void 0;
      if (sheetName && this.engine?.doesSheetExist(sheetName)) {
        this.switchSheet(sheetName);
      } else {
        const newSheetName = this.addSheet(sheetName ?? void 0, _class_private_method_get$l(this, _getProcessedSourceDataArray, getProcessedSourceDataArray).call(this));
        if (typeof newSheetName === "string") {
          _class_private_method_get$l(this, _updateSheetNameAndSheetId, updateSheetNameAndSheetId).call(this, newSheetName);
        }
      }
    }
    super.updatePlugin(newSettings);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$w(this, _engineListeners)?.forEach(([eventName, listener]) => this.engine?.off(eventName, listener));
    _class_private_field_set$w(this, _engineListeners, null);
    if (this.engine) {
      unregisterEngine(this.engine, this.hot);
    }
    this.engine = null;
    super.destroy();
  }
  /**
  * Add a sheet to the shared HyperFormula instance.
  *
  * @param {string|null} [sheetName] The new sheet name. If not provided (or a null is passed), will be
  * auto-generated by HyperFormula.
  * @param {Array} [sheetData] Data passed to the shared HyperFormula instance. Has to be declared as an array of
  * arrays - array of objects is not supported in this scenario.
  * @returns {boolean|string} `false` if the data format is unusable or it is impossible to add a new sheet to the
  * engine, the created sheet name otherwise.
  */
  addSheet(sheetName, sheetData) {
    if (isDefined(sheetData) && !isArrayOfArrays(sheetData)) {
      warn$1("The provided data should be an array of arrays.");
      return false;
    }
    if (sheetName !== void 0 && sheetName !== null && this.engine?.doesSheetExist(sheetName)) {
      warn$1("Sheet with the provided name already exists.");
      return false;
    }
    try {
      const actualSheetName = this.engine.addSheet(sheetName ?? void 0);
      if (sheetData) {
        this.engine.setSheetContent(this.engine.getSheetId(actualSheetName), sheetData);
      }
      return actualSheetName;
    } catch (e) {
      warn$1(e instanceof Error ? e.message : String(e));
      return false;
    }
  }
  /**
  * Switch the sheet used as data in the Handsontable instance (it loads the data from the shared HyperFormula
  * instance).
  *
  * @param {string} sheetName Sheet name used in the shared HyperFormula instance.
  */
  switchSheet(sheetName) {
    if (!this.engine?.doesSheetExist(sheetName)) {
      error(`The sheet named \`${sheetName}\` does not exist, switch aborted.`);
      return;
    }
    _class_private_method_get$l(this, _updateSheetNameAndSheetId, updateSheetNameAndSheetId).call(this, sheetName);
    const serialized = this.engine.getSheetSerialized(this.sheetId);
    if (serialized.length > 0) {
      this.hot.loadData(serialized, `${toUpperCaseFirst(PLUGIN_KEY$m)}.switchSheet`);
    }
  }
  /**
  * Get the cell type under specified visual coordinates.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {number} [sheet] The target sheet id, defaults to the current sheet.
  * @returns {string} Possible values: 'FORMULA' | 'VALUE' | 'ARRAYFORMULA' | 'EMPTY'.
  */
  getCellType(row, column, sheet = this.sheetId) {
    const physicalRow = this.hot.toPhysicalRow(row);
    const physicalColumn = this.hot.toPhysicalColumn(column);
    if (physicalRow !== null && physicalColumn !== null) {
      return this.engine.getCellType({
        sheet,
        row: this.rowAxisSyncer.getHfIndexFromVisualIndex(row),
        col: this.columnAxisSyncer.getHfIndexFromVisualIndex(column)
      });
    } else {
      return "EMPTY";
    }
  }
  /**
  * Returns `true` if under specified visual coordinates is formula.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {number} [sheet] The target sheet id, defaults to the current sheet.
  * @returns {boolean}
  */
  isFormulaCellType(row, column, sheet = this.sheetId) {
    return this.engine.doesCellHaveFormula({
      sheet,
      row: this.rowAxisSyncer.getHfIndexFromVisualIndex(row),
      col: this.columnAxisSyncer.getHfIndexFromVisualIndex(column)
    });
  }
  /**
  * Renders dependent sheets (handsontable instances) based on the changes - list of the
  * recalculated dependent cells.
  *
  * @private
  * @param {object[]} dependentCells The values and location of applied changes within HF engine.
  * @param {boolean} [renderSelf] `true` if it's supposed to render itself, `false` otherwise.
  */
  renderDependentSheets(dependentCells, renderSelf = false) {
    const affectedSheetIds = /* @__PURE__ */ new Set();
    dependentCells.forEach((change) => {
      const sheetId = isHFCellChange(change) ? change.address?.sheet : void 0;
      if (sheetId !== void 0 && !affectedSheetIds.has(sheetId)) {
        affectedSheetIds.add(sheetId);
      }
    });
    if (!this.engine) {
      return;
    }
    getRegisteredHotInstances(this.engine).forEach((relatedHot, sheetId) => {
      if ((renderSelf || sheetId !== this.sheetId) && affectedSheetIds.has(sheetId)) {
        relatedHot.render();
        relatedHot.view?.adjustElementsSize();
      }
    });
  }
  /**
  * Validates dependent cells based on the cells that are modified by the change.
  *
  * @private
  * @param {object[]} dependentCells The values and location of applied changes within HF engine.
  * @param {object[]} [changedCells] The values and location of applied changes by developer (through API or UI).
  */
  validateDependentCells(dependentCells, changedCells = []) {
    const stringifyAddress = (change) => {
      const address = isHFCellChange(change) ? change.address : void 0;
      const { row, col, sheet } = address ?? {};
      return isDefined(sheet) ? `${sheet}:${row}x${col}` : "";
    };
    const changedCellsSet = new Set(changedCells.map((change) => stringifyAddress(change)));
    dependentCells.forEach((change) => {
      const address = isHFCellChange(change) ? change.address : void 0;
      const { row, col, sheet: sheetId } = address ?? {};
      if (row === void 0 || col === void 0 || row >= this.hot.countRows() || col >= this.hot.countCols()) {
        return;
      }
      const addressId = stringifyAddress(change);
      if (sheetId !== void 0 && !changedCellsSet.has(addressId) && this.engine) {
        const boundHot = getRegisteredHotInstances(this.engine).get(sheetId);
        if (!boundHot) {
          return;
        }
        boundHot.validateCell(boundHot.getDataAtCell(row, col), boundHot.getCellMeta(row, col), () => {
        });
      }
    });
  }
  /**
  * Sync a change from the change-related hooks with the engine.
  *
  * @private
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @param {Handsontable.CellValue} newValue New value.
  * @returns {Array} Array of changes exported from the engine.
  */
  syncChangeWithEngine(row, column, newValue) {
    const address = {
      row: this.rowAxisSyncer.getHfIndexFromVisualIndex(row),
      col: this.columnAxisSyncer.getHfIndexFromVisualIndex(column),
      sheet: this.sheetId
    };
    if (!this.engine?.isItPossibleToSetCellContents(address)) {
      warn$1(`Not possible to set cell data at ${JSON.stringify(address)}`);
      return;
    }
    const cellMeta = this.hot.getCellMeta(row, column);
    if (isDate(newValue, cellMeta.type)) {
      if (isDateValid(newValue)) {
        newValue = getDateInHfFormat(newValue);
      } else if (isFormula(newValue) === false) {
        newValue = `'${newValue}`;
      }
    }
    return this.engine?.setCellContents(address, newValue);
  }
  constructor(...args) {
    super(...args), _class_private_method_init$l(this, _exportChangeValue), _class_private_method_init$l(this, _updateSheetNameAndSheetId), _class_private_method_init$l(this, _getValueGetterValue), _class_private_method_init$l(this, _getProcessedSourceDataArray), _class_private_field_init$w(this, _internalOperationPending, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _hotWasInitializedWithEmptyData, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onEngineValuesUpdated, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onEngineNamedExpressionsAdded, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onEngineNamedExpressionsRemoved, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onEngineSheetAdded, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onEngineSheetRenamed, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onEngineSheetRemoved, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _engineListeners, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeValidate, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeAutofill, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeLoadData$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterCellMetaReset, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterLoadData$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onModifyData, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onModifySourceData, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterSetDataAtCell, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterSetSourceDataAtCell, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeCreateRow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeCreateCol, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeRemoveRow$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onBeforeRemoveCol, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterCreateRow$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterCreateCol$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterRemoveRow$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterRemoveCol$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$w(this, _onAfterDetachChild$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$w(this, _internalOperationPending, false), _class_private_field_set$w(this, _hotWasInitializedWithEmptyData, false), _class_private_field_set$w(this, _onEngineValuesUpdated, (changes) => {
      const exportedChanges = changes.map((change) => _class_private_method_get$l(this, _exportChangeValue, exportChangeValue).call(this, change));
      this.hot.runHooks("afterFormulasValuesUpdate", exportedChanges);
    }), _class_private_field_set$w(this, _onEngineNamedExpressionsAdded, (namedExpressionName, changes) => {
      this.hot.runHooks("afterNamedExpressionAdded", namedExpressionName, changes);
    }), _class_private_field_set$w(this, _onEngineNamedExpressionsRemoved, (namedExpressionName, changes) => {
      this.hot.runHooks("afterNamedExpressionRemoved", namedExpressionName, changes);
    }), _class_private_field_set$w(this, _onEngineSheetAdded, (addedSheetDisplayName) => {
      this.hot.runHooks("afterSheetAdded", addedSheetDisplayName);
    }), _class_private_field_set$w(this, _onEngineSheetRenamed, (oldDisplayName, newDisplayName) => {
      _class_private_method_get$l(this, _updateSheetNameAndSheetId, updateSheetNameAndSheetId).call(this, newDisplayName);
      this.hot.runHooks("afterSheetRenamed", oldDisplayName, newDisplayName);
    }), _class_private_field_set$w(this, _onEngineSheetRemoved, (removedSheetDisplayName, changes) => {
      this.hot.runHooks("afterSheetRemoved", removedSheetDisplayName, changes);
    }), _class_private_field_set$w(this, _engineListeners, [
      [
        "valuesUpdated",
        _class_private_field_get$w(this, _onEngineValuesUpdated)
      ],
      [
        "namedExpressionAdded",
        _class_private_field_get$w(this, _onEngineNamedExpressionsAdded)
      ],
      [
        "namedExpressionRemoved",
        _class_private_field_get$w(this, _onEngineNamedExpressionsRemoved)
      ],
      [
        "sheetAdded",
        _class_private_field_get$w(this, _onEngineSheetAdded)
      ],
      [
        "sheetRenamed",
        _class_private_field_get$w(this, _onEngineSheetRenamed)
      ],
      [
        "sheetRemoved",
        _class_private_field_get$w(this, _onEngineSheetRemoved)
      ]
    ]), /**
    * Static register used to set up one global HyperFormula instance.
    * TODO: currently used in tests, might be removed later.
    *
    * @private
    * @type {object}
    */
    this.staticRegister = staticRegister("formulas"), /**
    * The engine instance that will be used for this instance of Handsontable.
    *
    * @type {HyperFormula|null}
    */
    this.engine = null, /**
    * HyperFormula's sheet id.
    *
    * @type {number|null}
    */
    this.sheetId = null, /**
    * HyperFormula's sheet name.
    *
    * @type {string|null}
    */
    this.sheetName = null, /**
    * Index synchronizer responsible for manipulating with some general options related to indexes synchronization.
    *
    * @type {IndexSyncer|null}
    */
    this.indexSyncer = null, /**
    * Index synchronizer responsible for syncing the order of HOT and HF's data for the axis of the rows.
    *
    * @type {AxisSyncer|null}
    */
    this.rowAxisSyncer = null, /**
    * Index synchronizer responsible for syncing the order of HOT and HF's data for the axis of the columns.
    *
    * @type {AxisSyncer|null}
    */
    this.columnAxisSyncer = null, _class_private_field_set$w(this, _onBeforeValidate, (value, visualRow, prop) => {
      const visualColumn = this.hot.propToCol(prop);
      if (this.isFormulaCellType(visualRow, visualColumn)) {
        const address = {
          row: this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow),
          col: this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn),
          sheet: this.sheetId
        };
        const cellMeta = this.hot.getCellMeta(visualRow, visualColumn);
        let cellValue = this.engine.getCellValue(address);
        if (cellMeta.type === "date" && isNumeric(cellValue)) {
          cellValue = getDateFromExcelDate(cellValue);
        } else if (cellMeta.type === "time" && isNumeric(cellValue)) {
          cellValue = getTimeFromHfTimeFraction(cellValue);
        }
        return hasValueProperty(cellValue) ? cellValue.value : cellValue;
      }
      return value;
    }), _class_private_field_set$w(this, _onBeforeAutofill, (fillData, sourceRange, targetRange) => {
      const { row: sourceTopStartRow, col: sourceTopStartColumn } = sourceRange.getTopStartCorner();
      const { row: sourceBottomEndRow, col: sourceBottomEndColumn } = sourceRange.getBottomEndCorner();
      const { row: targetTopStartRow, col: targetTopStartColumn } = targetRange.getTopStartCorner();
      const { row: targetBottomEndRow, col: targetBottomEndColumn } = targetRange.getBottomEndCorner();
      if (sourceTopStartRow === null || sourceTopStartColumn === null || sourceBottomEndRow === null || sourceBottomEndColumn === null || targetTopStartRow === null || targetTopStartColumn === null || targetBottomEndRow === null || targetBottomEndColumn === null) {
        return;
      }
      const hfSourceStartRow = this.rowAxisSyncer.getHfIndexFromVisualIndex(sourceTopStartRow);
      const hfSourceStartCol = this.columnAxisSyncer.getHfIndexFromVisualIndex(sourceTopStartColumn);
      const hfSourceEndRow = this.rowAxisSyncer.getHfIndexFromVisualIndex(sourceBottomEndRow);
      const hfSourceEndCol = this.columnAxisSyncer.getHfIndexFromVisualIndex(sourceBottomEndColumn);
      const hfTargetStartRow = this.rowAxisSyncer.getHfIndexFromVisualIndex(targetTopStartRow);
      const hfTargetStartCol = this.columnAxisSyncer.getHfIndexFromVisualIndex(targetTopStartColumn);
      const hfTargetEndRow = this.rowAxisSyncer.getHfIndexFromVisualIndex(targetBottomEndRow);
      const hfTargetEndCol = this.columnAxisSyncer.getHfIndexFromVisualIndex(targetBottomEndColumn);
      if (hfSourceStartRow === null || hfSourceStartCol === null || hfSourceEndRow === null || hfSourceEndCol === null || hfTargetStartRow === null || hfTargetStartCol === null || hfTargetEndRow === null || hfTargetEndCol === null) {
        return;
      }
      const engineSourceRange = {
        start: {
          row: hfSourceStartRow,
          col: hfSourceStartCol,
          sheet: this.sheetId
        },
        end: {
          row: hfSourceEndRow,
          col: hfSourceEndCol,
          sheet: this.sheetId
        }
      };
      const engineTargetRange = {
        start: {
          row: hfTargetStartRow,
          col: hfTargetStartCol,
          sheet: this.sheetId
        },
        end: {
          row: hfTargetEndRow,
          col: hfTargetEndCol,
          sheet: this.sheetId
        }
      };
      if (this.engine.isItPossibleToSetCellContents(engineTargetRange) === false) {
        return false;
      }
      const fillRangeData = this.engine.getFillRangeData(engineSourceRange, engineTargetRange);
      const { row: sourceStartRow, col: sourceStartColumn } = engineSourceRange.start;
      const { row: sourceEndRow, col: sourceEndColumn } = engineSourceRange.end;
      const populationRowLength = sourceEndRow - sourceStartRow + 1;
      const populationColumnLength = sourceEndColumn - sourceStartColumn + 1;
      for (let populatedRowIndex = 0; populatedRowIndex < fillRangeData.length; populatedRowIndex += 1) {
        for (let populatedColumnIndex = 0; populatedColumnIndex < fillRangeData[populatedRowIndex].length; populatedColumnIndex += 1) {
          const populatedValue = fillRangeData[populatedRowIndex][populatedColumnIndex];
          const sourceRow = sourceStartRow + populatedRowIndex % populationRowLength;
          const sourceColumn = sourceStartColumn + populatedColumnIndex % populationColumnLength;
          const sourceCellMeta = this.hot.getCellMeta(sourceRow, sourceColumn);
          if (isDate(populatedValue, sourceCellMeta.type)) {
            if (populatedValue.startsWith("'")) {
              fillRangeData[populatedRowIndex][populatedColumnIndex] = populatedValue.slice(1);
            } else if (this.isFormulaCellType(sourceRow, sourceColumn, this.sheetId) === false) {
              fillRangeData[populatedRowIndex][populatedColumnIndex] = getDateInHotFormat(populatedValue);
            }
          }
        }
      }
      return fillRangeData;
    }), _class_private_field_set$w(this, _onBeforeLoadData$1, (sourceData, initialLoad, source = "") => {
      if (source.includes(toUpperCaseFirst(PLUGIN_KEY$m))) {
        return;
      }
      _class_private_field_set$w(this, _hotWasInitializedWithEmptyData, isUndefined$1(this.hot.getSettings().data));
    }), _class_private_field_set$w(this, _onAfterCellMetaReset, () => {
      if (_class_private_field_get$w(this, _hotWasInitializedWithEmptyData)) {
        if (this.sheetName !== null) {
          this.switchSheet(this.sheetName);
        }
        return;
      }
      const sourceDataArray = _class_private_method_get$l(this, _getProcessedSourceDataArray, getProcessedSourceDataArray).call(this);
      sourceDataArray.forEach((rowData, rowIndex) => {
        rowData.forEach((cellValue, columnIndex) => {
          const cellMeta = this.hot.getCellMeta(rowIndex, columnIndex, {
            skipMetaExtension: true
          });
          if (isDate(cellValue, cellMeta.type)) {
            if (isDateValid(cellValue)) {
              sourceDataArray[rowIndex][columnIndex] = getDateInHfFormat(cellValue);
            } else if (!cellValue.startsWith("=")) {
              sourceDataArray[rowIndex][columnIndex] = `'${cellValue}`;
            }
          }
        });
      });
      _class_private_field_set$w(this, _internalOperationPending, true);
      const dependentCells = this.engine.setSheetContent(this.sheetId, sourceDataArray);
      this.indexSyncer.setupSyncEndpoint(this.engine, this.sheetId);
      this.renderDependentSheets(dependentCells);
      _class_private_field_set$w(this, _internalOperationPending, false);
    }), _class_private_field_set$w(this, _onAfterLoadData$3, (sourceData, initialLoad, source = "") => {
      if (source.includes(toUpperCaseFirst(PLUGIN_KEY$m))) {
        return;
      }
      if (!this.engine) {
        return;
      }
      const formulasSettings = this.hot.getSettings()[PLUGIN_KEY$m];
      const settingsSheetName = isFormulasSettingsObject(formulasSettings) ? formulasSettings.sheetName : void 0;
      const sheetName = setupSheet(this.engine, settingsSheetName);
      _class_private_method_get$l(this, _updateSheetNameAndSheetId, updateSheetNameAndSheetId).call(this, sheetName);
      if (source === "updateSettings") {
        return;
      }
      if (!_class_private_field_get$w(this, _hotWasInitializedWithEmptyData)) {
        const sourceDataArray = _class_private_method_get$l(this, _getProcessedSourceDataArray, getProcessedSourceDataArray).call(this);
        if (this.engine.isItPossibleToReplaceSheetContent(this.sheetId, sourceDataArray)) {
          _class_private_field_set$w(this, _internalOperationPending, true);
          const dependentCells = this.engine.setSheetContent(this.sheetId, sourceDataArray);
          this.indexSyncer.setupSyncEndpoint(this.engine, this.sheetId);
          this.renderDependentSheets(dependentCells);
          _class_private_field_set$w(this, _internalOperationPending, false);
        }
      } else if (this.sheetName !== null) {
        this.switchSheet(this.sheetName);
      }
    }), _class_private_field_set$w(this, _onModifyData, (visualRow, visualColumn, valueHolder, ioMode) => {
      if (ioMode !== "get" || _class_private_field_get$w(this, _internalOperationPending) || this.sheetName === null || !this.engine?.doesSheetExist(this.sheetName)) {
        return;
      }
      if (visualRow === null || visualColumn === null) {
        return;
      }
      const cellType = this.getCellType(visualRow, visualColumn);
      if (cellType === "VALUE" || cellType === "EMPTY") {
        valueHolder.value = unescapeFormulaExpression(valueHolder.value);
        return;
      }
      const address = {
        row: this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow),
        col: this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn),
        sheet: this.sheetId
      };
      let cellValue = this.engine.getCellValue(address);
      const cellMeta = this.hot.getCellMeta(visualRow, visualColumn, {
        skipMetaExtension: true
      });
      if (cellMeta.type === "date" && isNumeric(cellValue)) {
        cellValue = getDateFromExcelDate(cellValue);
      } else if (cellMeta.type === "time" && isNumeric(cellValue)) {
        cellValue = getTimeFromHfTimeFraction(cellValue);
      }
      valueHolder.value = hasValueProperty(cellValue) ? cellValue.value : cellValue;
    }), _class_private_field_set$w(this, _onModifySourceData, (row, columnOrProp, valueHolder, ioMode) => {
      if (ioMode !== "get" || _class_private_field_get$w(this, _internalOperationPending) || this.sheetName === null || !this.engine?.doesSheetExist(this.sheetName)) {
        return;
      }
      const visualRow = this.hot.toVisualRow(row);
      const visualColumn = this.hot.propToCol(columnOrProp);
      if (visualRow === null || visualColumn === null) {
        return;
      }
      const cellType = this.getCellType(visualRow, visualColumn);
      if (cellType === "VALUE" || cellType === "EMPTY") {
        return;
      }
      const dimensions = this.engine.getSheetDimensions(this.engine.getSheetId(this.sheetName));
      if (dimensions.width === 0 && dimensions.height === 0) {
        return;
      }
      const address = {
        row: this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow),
        col: this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn),
        sheet: this.sheetId
      };
      valueHolder.value = this.engine.getCellSerialized(address);
    }), _class_private_field_set$w(this, _onAfterSetDataAtCell, (changes, source) => {
      if (isBlockedSource(source)) {
        return;
      }
      if (!changes?.length) {
        return;
      }
      const outOfBoundsChanges = [];
      const changedCells = [];
      const dependentCells = this.engine.batch(() => {
        changes.forEach(([visualRow, prop, , newValue]) => {
          if (typeof prop !== "string" && typeof prop !== "number") {
            return;
          }
          const visualColumn = this.hot.propToCol(prop);
          const physicalRow = this.hot.toPhysicalRow(visualRow);
          const physicalColumn = this.hot.toPhysicalColumn(visualColumn);
          const address = {
            row: this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow),
            col: this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn),
            sheet: this.sheetId
          };
          newValue = _class_private_method_get$l(this, _getValueGetterValue, getValueGetterValue1).call(this, physicalRow, physicalColumn, newValue);
          if (physicalRow !== null && physicalColumn !== null) {
            this.syncChangeWithEngine(visualRow, visualColumn, newValue);
          } else {
            outOfBoundsChanges.push([
              visualRow,
              visualColumn,
              newValue
            ]);
          }
          changedCells.push({
            address
          });
        });
      });
      if (outOfBoundsChanges.length) {
        this.hot.addHookOnce("afterChange", () => {
          const outOfBoundsDependentCells = this.engine.batch(() => {
            outOfBoundsChanges.forEach(([row, column, newValue]) => {
              this.syncChangeWithEngine(row, column, newValue);
            });
          });
          this.renderDependentSheets(outOfBoundsDependentCells, true);
        });
      }
      this.renderDependentSheets(dependentCells);
      this.validateDependentCells(dependentCells, changedCells);
    }), _class_private_field_set$w(this, _onAfterSetSourceDataAtCell, (changes, source) => {
      if (isBlockedSource(source)) {
        return;
      }
      const dependentCells = [];
      const changedCells = [];
      changes.forEach(([visualRow, prop, , newValue]) => {
        if (typeof prop !== "string" && typeof prop !== "number") {
          return;
        }
        const visualColumn = this.hot.propToCol(prop);
        if (!isNumeric(visualColumn)) {
          return;
        }
        const address = {
          row: this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow),
          col: this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn),
          sheet: this.sheetId
        };
        if (!this.engine?.isItPossibleToSetCellContents(address)) {
          warn$1(`Not possible to set source cell data at ${JSON.stringify(address)}`);
          return;
        }
        newValue = normalizeValueForFormulaEngine(newValue);
        changedCells.push({
          address
        });
        dependentCells.push(...this.engine.setCellContents(address, newValue));
      });
      this.renderDependentSheets(dependentCells);
      this.validateDependentCells(dependentCells, changedCells);
    }), _class_private_field_set$w(this, _onBeforeCreateRow, (visualRow, amount) => {
      let hfRowIndex = this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow);
      if (visualRow >= this.hot.countRows()) {
        hfRowIndex = visualRow;
      }
      if (this.sheetId === null || !this.engine?.doesSheetExist(this.sheetName) || !this.engine?.isItPossibleToAddRows(this.sheetId, [
        hfRowIndex,
        amount
      ])) {
        return false;
      }
    }), _class_private_field_set$w(this, _onBeforeCreateCol, (visualColumn, amount) => {
      let hfColumnIndex = this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn);
      if (visualColumn >= this.hot.countCols()) {
        hfColumnIndex = visualColumn;
      }
      if (this.sheetId === null || !this.engine?.doesSheetExist(this.sheetName) || !this.engine?.isItPossibleToAddColumns(this.sheetId, [
        hfColumnIndex,
        amount
      ])) {
        return false;
      }
    }), _class_private_field_set$w(this, _onBeforeRemoveRow$1, (row, amount, physicalRows) => {
      const hfRows = this.rowAxisSyncer.setRemovedHfIndexes(physicalRows);
      const possible = hfRows.every((hfRow) => {
        return this.engine?.isItPossibleToRemoveRows(this.sheetId, [
          hfRow,
          1
        ]);
      });
      return possible === false ? false : void 0;
    }), _class_private_field_set$w(this, _onBeforeRemoveCol, (col, amount, physicalColumns) => {
      const hfColumns = this.columnAxisSyncer.setRemovedHfIndexes(physicalColumns);
      const possible = hfColumns.every((hfColumn) => {
        return this.engine?.isItPossibleToRemoveColumns(this.sheetId, [
          hfColumn,
          1
        ]);
      });
      return possible === false ? false : void 0;
    }), _class_private_field_set$w(this, _onAfterCreateRow$2, (visualRow, amount, source) => {
      if (isBlockedSource(source)) {
        return;
      }
      const changes = this.engine.addRows(this.sheetId, [
        this.rowAxisSyncer.getHfIndexFromVisualIndex(visualRow),
        amount
      ]);
      this.renderDependentSheets(changes);
    }), _class_private_field_set$w(this, _onAfterCreateCol$2, (visualColumn, amount, source) => {
      if (isBlockedSource(source)) {
        return;
      }
      const changes = this.engine.addColumns(this.sheetId, [
        this.columnAxisSyncer.getHfIndexFromVisualIndex(visualColumn),
        amount
      ]);
      this.renderDependentSheets(changes);
    }), _class_private_field_set$w(this, _onAfterRemoveRow$2, (row, amount, physicalRows, source) => {
      if (isBlockedSource(source)) {
        return;
      }
      const descendingHfRows = this.rowAxisSyncer.getRemovedHfIndexes().sort((a, b) => b - a);
      const changes = this.engine.batch(() => {
        descendingHfRows.forEach((hfRow) => {
          this.engine.removeRows(this.sheetId, [
            hfRow,
            1
          ]);
        });
      });
      this.renderDependentSheets(changes);
    }), _class_private_field_set$w(this, _onAfterRemoveCol$2, (col, amount, physicalColumns, source) => {
      if (isBlockedSource(source)) {
        return;
      }
      const descendingHfColumns = this.columnAxisSyncer.getRemovedHfIndexes().sort((a, b) => b - a);
      const changes = this.engine.batch(() => {
        descendingHfColumns.forEach((hfColumn) => {
          this.engine.removeColumns(this.sheetId, [
            hfColumn,
            1
          ]);
        });
      });
      this.renderDependentSheets(changes);
    }), _class_private_field_set$w(this, _onAfterDetachChild$1, (parent, element, finalElementRowIndex) => {
      _class_private_field_set$w(this, _internalOperationPending, true);
      const children = element.__children;
      const childrenCount = Array.isArray(children) ? children.length : 0;
      const rowsData = _class_private_method_get$l(this, _getProcessedSourceDataArray, getProcessedSourceDataArray).call(this, finalElementRowIndex, 0, finalElementRowIndex + childrenCount, this.hot.countSourceCols());
      _class_private_field_set$w(this, _internalOperationPending, false);
      rowsData.forEach((row, relativeRowIndex) => {
        row.forEach((value, colIndex) => {
          this.engine?.setCellContents({
            col: colIndex,
            row: finalElementRowIndex + relativeRowIndex,
            sheet: this.sheetId
          }, [
            [
              value
            ]
          ]);
        });
      });
    });
  }
}
function exportChangeValue(change) {
  if (!change.address || change.address.sheet !== this.sheetId || typeof change.newValue !== "number") {
    return change;
  }
  const visualRow = this.rowAxisSyncer.getVisualIndexFromHfIndex(change.address.row);
  const visualColumn = this.columnAxisSyncer.getVisualIndexFromHfIndex(change.address.col);
  if (visualRow < 0 || visualColumn < 0) {
    return change;
  }
  const cellMeta = this.hot.getCellMeta(visualRow, visualColumn, {
    skipMetaExtension: true
  });
  let newValue;
  if (cellMeta.type === "date") {
    newValue = getDateFromExcelDate(change.newValue);
  } else if (cellMeta.type === "time") {
    newValue = getTimeFromHfTimeFraction(change.newValue);
  } else {
    return change;
  }
  const clone2 = Object.assign(Object.create(Object.getPrototypeOf(change)), change);
  clone2.newValue = newValue;
  return clone2;
}
function updateSheetNameAndSheetId(sheetName) {
  this.sheetName = sheetName;
  this.sheetId = this.engine?.getSheetId(this.sheetName) ?? null;
}
function getValueGetterValue1(row, column, value) {
  if (isObject$1(value) && value !== null) {
    const visualRow = this.hot.toVisualRow(row);
    const visualColumn = this.hot.toVisualColumn(column);
    const cellMeta = this.hot.getCellMeta(visualRow, visualColumn);
    cellMeta.valueGetter;
    value = getValueGetterValue(value, this.hot.getCellMeta(visualRow, visualColumn));
    if (value !== null && value !== void 0) {
      value = Object(value).toString();
    }
  }
  return normalizeValueForFormulaEngine(value);
}
function getProcessedSourceDataArray(row, column, row2, column2) {
  const dataArray = this.hot.getSourceDataArray(row, column, row2, column2);
  const visibleColumnCount = this.hot.countCols();
  const physicalColumnCount = this.hot.countSourceCols();
  const isAoAWithSkippedColumns = visibleColumnCount < physicalColumnCount && isArrayOfArrays(this.hot.getSourceData());
  if (!isAoAWithSkippedColumns) {
    return dataArray.map((rowObject, rowIndex) => {
      const rowArray = Array.isArray(rowObject) ? rowObject : [];
      return rowArray.map((value, columnIndex) => {
        return _class_private_method_get$l(this, _getValueGetterValue, getValueGetterValue1).call(this, rowIndex, columnIndex, value);
      });
    });
  }
  const columnOffset = column ?? 0;
  return dataArray.map((rowArray, rowIndex) => {
    const projected = [];
    for (let visualCol = 0; visualCol < visibleColumnCount; visualCol++) {
      const physicalCol = this.hot.colToProp(visualCol);
      if (typeof physicalCol !== "number") {
        continue;
      }
      const arrayIndex = physicalCol - columnOffset;
      if (arrayIndex < 0 || arrayIndex >= rowArray.length) {
        continue;
      }
      projected.push(_class_private_method_get$l(this, _getValueGetterValue, getValueGetterValue1).call(this, rowIndex, visualCol, rowArray[arrayIndex]));
    }
    return projected;
  });
}
function hideColumnItem(hiddenColumnsPlugin) {
  return {
    key: "hidden_columns_hide",
    name() {
      const selection = this.getSelectedActive();
      let pluralForm = 0;
      if (Array.isArray(selection)) {
        const [, fromColumn, , toColumn] = selection;
        if (fromColumn - toColumn !== 0) {
          pluralForm = 1;
        }
      }
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_HIDE_COLUMN, pluralForm);
    },
    callback() {
      const selectedRange = this.getSelectedRangeActive();
      if (!selectedRange) {
        return;
      }
      const { from, to } = selectedRange;
      if (from.col === null || to.col === null) {
        return;
      }
      const start = Math.max(Math.min(from.col, to.col), 0);
      const end = Math.max(from.col, to.col);
      const columnsToHide = [];
      for (let visualColumn = start; visualColumn <= end; visualColumn += 1) {
        columnsToHide.push(visualColumn);
      }
      hiddenColumnsPlugin.hideColumns(columnsToHide);
      const lastHiddenColumn = columnsToHide[columnsToHide.length - 1];
      const columnToSelect = this.columnIndexMapper.getNearestNotHiddenIndex(lastHiddenColumn, 1, true);
      if (columnToSelect !== null && Number.isInteger(columnToSelect) && columnToSelect >= 0) {
        this.selectColumns(columnToSelect);
      } else {
        this.deselectCell();
      }
      this.view.adjustElementsSize();
      this.render();
    },
    disabled: false,
    hidden() {
      return !(this.selection.isSelectedByColumnHeader() || this.selection.isSelectedByCorner());
    }
  };
}
function showColumnItem(hiddenColumnsPlugin) {
  const columns = [];
  return {
    key: "hidden_columns_show",
    name() {
      const pluralForm = columns.length > 1 ? 1 : 0;
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_SHOW_COLUMN, pluralForm);
    },
    callback() {
      if (columns.length === 0) {
        return;
      }
      let startVisualColumn = columns[0];
      let endVisualColumn = columns[columns.length - 1];
      startVisualColumn = this.columnIndexMapper.getNearestNotHiddenIndex(startVisualColumn - 1, -1) ?? 0;
      endVisualColumn = this.columnIndexMapper.getNearestNotHiddenIndex(endVisualColumn + 1, 1) ?? this.countCols() - 1;
      hiddenColumnsPlugin.showColumns(columns);
      this.view.adjustElementsSize();
      this.render();
      const allColumnsSelected = endVisualColumn - startVisualColumn + 1 === this.countCols();
      if (!allColumnsSelected) {
        this.selectColumns(startVisualColumn, endVisualColumn);
      }
    },
    disabled: false,
    hidden() {
      const hiddenPhysicalColumns = arrayMap(hiddenColumnsPlugin.getHiddenColumns(), (visualColumnIndex) => {
        return this.toPhysicalColumn(visualColumnIndex);
      });
      if (!(this.selection.isSelectedByColumnHeader() || this.selection.isSelectedByCorner()) || hiddenPhysicalColumns.length < 1) {
        return true;
      }
      columns.length = 0;
      const selectedRangeActive = this.getSelectedRangeActive();
      if (!selectedRangeActive) {
        return true;
      }
      const visualStartColumn = selectedRangeActive.getTopStartCorner().col;
      const visualEndColumn = selectedRangeActive.getBottomEndCorner().col;
      const columnIndexMapper = this.columnIndexMapper;
      const renderableStartColumn = visualStartColumn !== null ? columnIndexMapper.getRenderableFromVisualIndex(visualStartColumn) : null;
      const renderableEndColumn = visualEndColumn !== null ? columnIndexMapper.getRenderableFromVisualIndex(visualEndColumn) : null;
      const notTrimmedColumnIndexes = columnIndexMapper.getNotTrimmedIndexes();
      const physicalColumnIndexes = [];
      if (visualStartColumn !== visualEndColumn) {
        if (visualStartColumn === null || visualEndColumn === null) {
          return true;
        }
        const visualColumnsInRange = visualEndColumn - visualStartColumn + 1;
        const renderedColumnsInRange = (renderableEndColumn ?? 0) - (renderableStartColumn ?? 0) + 1;
        if (visualColumnsInRange > renderedColumnsInRange) {
          const physicalIndexesInRange = notTrimmedColumnIndexes.slice(visualStartColumn, visualEndColumn + 1);
          physicalColumnIndexes.push(...physicalIndexesInRange.filter((physicalIndex) => hiddenPhysicalColumns.includes(physicalIndex)));
        }
      } else if (renderableStartColumn === 0 && visualStartColumn !== null && renderableStartColumn < visualStartColumn) {
        physicalColumnIndexes.push(...notTrimmedColumnIndexes.slice(0, visualStartColumn));
      } else if (renderableStartColumn === null) {
        physicalColumnIndexes.push(...notTrimmedColumnIndexes.slice(0, this.countCols()));
      } else {
        const lastVisualIndex = this.countCols() - 1;
        const nearestNotHidden = columnIndexMapper.getNearestNotHiddenIndex(lastVisualIndex, -1);
        const lastRenderableIndex = nearestNotHidden !== null ? columnIndexMapper.getRenderableFromVisualIndex(nearestNotHidden) : null;
        if (renderableEndColumn !== null && visualEndColumn !== null && renderableEndColumn === lastRenderableIndex && lastVisualIndex > visualEndColumn) {
          physicalColumnIndexes.push(...notTrimmedColumnIndexes.slice(visualEndColumn + 1));
        }
      }
      arrayEach(physicalColumnIndexes, (physicalColumnIndex) => {
        columns.push(this.toVisualColumn(physicalColumnIndex));
      });
      return columns.length === 0;
    }
  };
}
function _check_private_redeclaration$x(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$v(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$v(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$v(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$v(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$v(receiver, privateMap, "get");
  return _class_apply_descriptor_get$v(receiver, descriptor);
}
function _class_private_field_init$v(obj, privateMap, value) {
  _check_private_redeclaration$x(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$v(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$v(receiver, privateMap, "set");
  _class_apply_descriptor_set$v(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$k(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$k(obj, privateSet) {
  _check_private_redeclaration$x(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("beforeHideColumns");
Hooks.getSingleton().register("afterHideColumns");
Hooks.getSingleton().register("beforeUnhideColumns");
Hooks.getSingleton().register("afterUnhideColumns");
const PLUGIN_KEY$l = "hiddenColumns";
const PLUGIN_PRIORITY$l = 310;
const SKIP_COLUMN_ON_PASTE_BY_PLUGIN = /* @__PURE__ */ Symbol("skipColumnOnPasteByHiddenColumns");
var _hiddenColumnsMap = /* @__PURE__ */ new WeakMap(), _onModifyColWidth$3 = /* @__PURE__ */ new WeakMap(), _onAfterGetCellMeta$2 = /* @__PURE__ */ new WeakMap(), _onModifyCopyableRange$1 = /* @__PURE__ */ new WeakMap(), _onAfterGetColHeader = /* @__PURE__ */ new WeakMap(), _onAfterContextMenuDefaultOptions$2 = /* @__PURE__ */ new WeakMap(), _onMapInit$4 = /* @__PURE__ */ new WeakSet();
class HiddenColumns extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$l;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$l;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      copyPasteEnabled: true,
      indicators: false,
      columns: []
    };
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link HiddenColumns#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$l];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_set$v(this, _hiddenColumnsMap, new HidingMap());
    _class_private_field_get$v(this, _hiddenColumnsMap).addLocalHook("init", () => _class_private_method_get$k(this, _onMapInit$4, onMapInit$3).call(this));
    this.hot.columnIndexMapper.registerMap(this.pluginName ?? "", _class_private_field_get$v(this, _hiddenColumnsMap));
    this.addHook("afterContextMenuDefaultOptions", _class_private_field_get$v(this, _onAfterContextMenuDefaultOptions$2));
    this.addHook("afterGetCellMeta", _class_private_field_get$v(this, _onAfterGetCellMeta$2));
    this.addHook("modifyColWidth", _class_private_field_get$v(this, _onModifyColWidth$3), 2);
    this.addHook("afterGetColHeader", _class_private_field_get$v(this, _onAfterGetColHeader));
    this.addHook("modifyCopyableRange", _class_private_field_get$v(this, _onModifyCopyableRange$1));
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`hiddenColumns`](@/api/options.md#hiddencolumns)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
    this.hot.columnIndexMapper.unregisterMap(this.pluginName ?? "");
    this.resetCellsMeta();
  }
  /**
  * Shows the provided columns.
  *
  * @param {number[]} columns Array of visual column indexes.
  */
  showColumns(columns) {
    const currentHideConfig = this.getHiddenColumns();
    const isValidConfig = this.isValidConfig(columns);
    let destinationHideConfig = currentHideConfig;
    const hidingMapValues = _class_private_field_get$v(this, _hiddenColumnsMap).getValues().slice();
    const isAnyColumnShowed = columns.length > 0;
    if (isValidConfig && isAnyColumnShowed) {
      const physicalColumns = columns.map((visualColumn) => this.hot.toPhysicalColumn(visualColumn));
      arrayEach(physicalColumns, (physicalColumn) => {
        hidingMapValues[physicalColumn] = false;
      });
      destinationHideConfig = arrayReduce(hidingMapValues, (hiddenIndexes, isHidden, physicalIndex) => {
        if (isHidden) {
          hiddenIndexes.push(this.hot.toVisualColumn(physicalIndex));
        }
        return hiddenIndexes;
      }, []);
    }
    const continueHiding = this.hot.runHooks("beforeUnhideColumns", currentHideConfig, destinationHideConfig, isValidConfig && isAnyColumnShowed);
    if (continueHiding === false) {
      return;
    }
    if (isValidConfig && isAnyColumnShowed) {
      _class_private_field_get$v(this, _hiddenColumnsMap).setValues(hidingMapValues);
    }
    this.hot.view.adjustElementsSize();
    this.hot.runHooks("afterUnhideColumns", currentHideConfig, destinationHideConfig, isValidConfig && isAnyColumnShowed, isValidConfig && destinationHideConfig.length < currentHideConfig.length);
  }
  /**
  * Shows a single column.
  *
  * @param {...number} column Visual column index.
  */
  showColumn(...column) {
    this.showColumns(column);
  }
  /**
  * Hides the columns provided in the array.
  *
  * @param {number[]} columns Array of visual column indexes.
  */
  hideColumns(columns) {
    const currentHideConfig = this.getHiddenColumns();
    const isConfigValid = this.isValidConfig(columns);
    let destinationHideConfig = currentHideConfig;
    if (isConfigValid) {
      destinationHideConfig = Array.from(new Set(currentHideConfig.concat(columns)));
    }
    const continueHiding = this.hot.runHooks("beforeHideColumns", currentHideConfig, destinationHideConfig, isConfigValid);
    if (continueHiding === false) {
      return;
    }
    if (isConfigValid) {
      this.hot.batchExecution(() => {
        arrayEach(columns, (visualColumn) => {
          _class_private_field_get$v(this, _hiddenColumnsMap).setValueAtIndex(this.hot.toPhysicalColumn(visualColumn), true);
        });
      }, true);
    }
    this.hot.runHooks("afterHideColumns", currentHideConfig, destinationHideConfig, isConfigValid, isConfigValid && destinationHideConfig.length > currentHideConfig.length);
  }
  /**
  * Hides a single column.
  *
  * @param {...number} column Visual column index.
  */
  hideColumn(...column) {
    this.hideColumns(column);
  }
  /**
  * Returns an array of visual indexes of hidden columns.
  *
  * @returns {number[]}
  */
  getHiddenColumns() {
    return arrayMap(_class_private_field_get$v(this, _hiddenColumnsMap).getHiddenIndexes(), (physicalColumnIndex) => {
      return this.hot.toVisualColumn(physicalColumnIndex);
    });
  }
  /**
  * Checks if the provided column is hidden.
  *
  * @param {number} column Visual column index.
  * @returns {boolean}
  */
  isHidden(column) {
    return _class_private_field_get$v(this, _hiddenColumnsMap).getValueAtIndex(this.hot.toPhysicalColumn(column)) || false;
  }
  /**
  * Get if trim config is valid. Check whether all of the provided column indexes are within the bounds of the table.
  *
  * @param {Array} hiddenColumns List of hidden column indexes.
  * @returns {boolean}
  */
  isValidConfig(hiddenColumns) {
    const nrOfColumns = this.hot.countCols();
    if (Array.isArray(hiddenColumns) && hiddenColumns.length > 0) {
      return hiddenColumns.every((visualColumn) => Number.isInteger(visualColumn) && visualColumn >= 0 && visualColumn < nrOfColumns);
    }
    return false;
  }
  /**
  * Reset all rendered cells meta.
  *
  * @private
  */
  resetCellsMeta() {
    arrayEach(this.hot.getCellsMeta(), (meta) => {
      const cellMeta = meta;
      if (cellMeta[SKIP_COLUMN_ON_PASTE_BY_PLUGIN]) {
        delete cellMeta.skipColumnOnPaste;
        delete cellMeta[SKIP_COLUMN_ON_PASTE_BY_PLUGIN];
      }
    });
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_set$v(this, _hiddenColumnsMap, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$k(this, _onMapInit$4), _class_private_field_init$v(this, _hiddenColumnsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$v(this, _onModifyColWidth$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$v(this, _onAfterGetCellMeta$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$v(this, _onModifyCopyableRange$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$v(this, _onAfterGetColHeader, {
      writable: true,
      value: void 0
    }), _class_private_field_init$v(this, _onAfterContextMenuDefaultOptions$2, {
      writable: true,
      value: void 0
    }), _class_private_field_set$v(this, _hiddenColumnsMap, null), _class_private_field_set$v(this, _onModifyColWidth$3, (width, column) => {
      if (this.isHidden(column)) {
        return 0;
      }
      if (this.getSetting("indicators") && (this.isHidden(column + 1) || this.isHidden(column - 1))) {
        if (typeof width === "number" && this.hot.hasColHeaders()) {
          return width + 15;
        }
      }
    }), _class_private_field_set$v(this, _onAfterGetCellMeta$2, (row, column, cellProperties) => {
      if (this.getSetting("copyPasteEnabled") === false) {
        const cellPropsWithMarker = cellProperties;
        if (this.isHidden(column)) {
          if (cellProperties.skipColumnOnPaste !== true) {
            cellProperties.skipColumnOnPaste = true;
            cellPropsWithMarker[SKIP_COLUMN_ON_PASTE_BY_PLUGIN] = true;
          }
        } else if (cellPropsWithMarker[SKIP_COLUMN_ON_PASTE_BY_PLUGIN]) {
          delete cellProperties.skipColumnOnPaste;
          delete cellPropsWithMarker[SKIP_COLUMN_ON_PASTE_BY_PLUGIN];
        }
      }
      if (this.isHidden(column - 1)) {
        cellProperties.className = cellProperties.className || "";
        if (cellProperties.className.indexOf("afterHiddenColumn") === -1) {
          cellProperties.className += " afterHiddenColumn";
        }
      } else if (cellProperties.className) {
        const classArr = cellProperties.className.split(" ");
        if (classArr.length > 0) {
          const containAfterHiddenColumn = classArr.indexOf("afterHiddenColumn");
          if (containAfterHiddenColumn > -1) {
            classArr.splice(containAfterHiddenColumn, 1);
          }
          cellProperties.className = classArr.join(" ");
        }
      }
    }), _class_private_field_set$v(this, _onModifyCopyableRange$1, (ranges) => {
      if (this.getSetting("copyPasteEnabled")) {
        return ranges;
      }
      const newRanges = [];
      const pushRange = (startRow, endRow, startCol, endCol) => {
        newRanges.push({
          startRow,
          endRow,
          startCol,
          endCol
        });
      };
      arrayEach(ranges, (rangeItem) => {
        const range = rangeItem;
        let isHidden = true;
        let rangeStart = 0;
        rangeEach(range.startCol, range.endCol, (visualColumn) => {
          if (this.isHidden(visualColumn)) {
            if (!isHidden) {
              pushRange(range.startRow, range.endRow, rangeStart, visualColumn - 1);
            }
            isHidden = true;
          } else {
            if (isHidden) {
              rangeStart = visualColumn;
            }
            if (visualColumn === range.endCol) {
              pushRange(range.startRow, range.endRow, rangeStart, visualColumn);
            }
            isHidden = false;
          }
        });
      });
      return newRanges;
    }), _class_private_field_set$v(this, _onAfterGetColHeader, (column, TH) => {
      if (!this.getSetting("indicators") || column < 0) {
        return;
      }
      const classList = [];
      if (column >= 1 && this.isHidden(column - 1)) {
        classList.push("afterHiddenColumn");
      }
      if (column < this.hot.countCols() - 1 && this.isHidden(column + 1)) {
        classList.push("beforeHiddenColumn");
      }
      addClass(TH, classList);
    }), _class_private_field_set$v(this, _onAfterContextMenuDefaultOptions$2, (options) => {
      options.items.push({
        name: KEY$c
      }, hideColumnItem(this), showColumnItem(this));
    });
  }
}
function onMapInit$3() {
  const columns = this.getSetting("columns");
  if (Array.isArray(columns)) {
    this.hideColumns(columns);
  }
}
function hideRowItem(hiddenRowsPlugin) {
  return {
    key: "hidden_rows_hide",
    name() {
      const selection = this.getSelectedActive();
      let pluralForm = 0;
      if (Array.isArray(selection)) {
        const [fromRow, , toRow] = selection;
        if (fromRow - toRow !== 0) {
          pluralForm = 1;
        }
      }
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_HIDE_ROW, pluralForm);
    },
    callback() {
      const selectedRange = this.getSelectedRangeActive();
      if (!selectedRange) {
        return;
      }
      const { from, to } = selectedRange;
      if (from.row === null || to.row === null) {
        return;
      }
      const start = Math.max(Math.min(from.row, to.row), 0);
      const end = Math.max(from.row, to.row);
      const rowsToHide = [];
      for (let visualRow = start; visualRow <= end; visualRow += 1) {
        rowsToHide.push(visualRow);
      }
      hiddenRowsPlugin.hideRows(rowsToHide);
      const lastHiddenRow = rowsToHide[rowsToHide.length - 1];
      const rowToSelect = this.rowIndexMapper.getNearestNotHiddenIndex(lastHiddenRow, 1, true);
      if (rowToSelect !== null && Number.isInteger(rowToSelect) && rowToSelect >= 0) {
        this.selectRows(rowToSelect);
      } else {
        this.deselectCell();
      }
      this.view.adjustElementsSize();
      this.render();
    },
    disabled: false,
    hidden() {
      return !(this.selection.isSelectedByRowHeader() || this.selection.isSelectedByCorner());
    }
  };
}
function showRowItem(hiddenRowsPlugin) {
  const rows = [];
  return {
    key: "hidden_rows_show",
    name() {
      const pluralForm = rows.length > 1 ? 1 : 0;
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_SHOW_ROW, pluralForm);
    },
    callback() {
      if (rows.length === 0) {
        return;
      }
      let startVisualRow = rows[0];
      let endVisualRow = rows[rows.length - 1];
      startVisualRow = this.rowIndexMapper.getNearestNotHiddenIndex(startVisualRow - 1, -1) ?? 0;
      endVisualRow = this.rowIndexMapper.getNearestNotHiddenIndex(endVisualRow + 1, 1) ?? this.countRows() - 1;
      hiddenRowsPlugin.showRows(rows);
      this.view.adjustElementsSize();
      this.render();
      const allRowsSelected = endVisualRow - startVisualRow + 1 === this.countRows();
      if (!allRowsSelected) {
        this.selectRows(startVisualRow, endVisualRow);
      }
    },
    disabled: false,
    hidden() {
      const hiddenPhysicalRows = arrayMap(hiddenRowsPlugin.getHiddenRows(), (visualRowIndex) => {
        return this.toPhysicalRow(visualRowIndex);
      });
      if (!(this.selection.isSelectedByRowHeader() || this.selection.isSelectedByCorner()) || hiddenPhysicalRows.length < 1) {
        return true;
      }
      rows.length = 0;
      const selectedRangeActive = this.getSelectedRangeActive();
      if (!selectedRangeActive) {
        return true;
      }
      const visualStartRow = selectedRangeActive.getTopStartCorner().row;
      const visualEndRow = selectedRangeActive.getBottomEndCorner().row;
      const rowIndexMapper = this.rowIndexMapper;
      const renderableStartRow = visualStartRow !== null ? rowIndexMapper.getRenderableFromVisualIndex(visualStartRow) : null;
      const renderableEndRow = visualEndRow !== null ? rowIndexMapper.getRenderableFromVisualIndex(visualEndRow) : null;
      const notTrimmedRowIndexes = rowIndexMapper.getNotTrimmedIndexes();
      const physicalRowIndexes = [];
      if (visualStartRow !== visualEndRow) {
        if (visualStartRow === null || visualEndRow === null) {
          return true;
        }
        const visualRowsInRange = visualEndRow - visualStartRow + 1;
        const renderedRowsInRange = (renderableEndRow ?? 0) - (renderableStartRow ?? 0) + 1;
        if (visualRowsInRange > renderedRowsInRange) {
          const physicalIndexesInRange = notTrimmedRowIndexes.slice(visualStartRow, visualEndRow + 1);
          physicalRowIndexes.push(...physicalIndexesInRange.filter((physicalIndex) => hiddenPhysicalRows.includes(physicalIndex)));
        }
      } else if (renderableStartRow === 0 && visualStartRow !== null && renderableStartRow < visualStartRow) {
        physicalRowIndexes.push(...notTrimmedRowIndexes.slice(0, visualStartRow));
      } else if (renderableStartRow === null) {
        physicalRowIndexes.push(...notTrimmedRowIndexes.slice(0, this.countRows()));
      } else {
        const lastVisualIndex = this.countRows() - 1;
        const lastRenderableIndex = rowIndexMapper.getRenderableFromVisualIndex(rowIndexMapper.getNearestNotHiddenIndex(lastVisualIndex, -1) ?? lastVisualIndex);
        if (renderableEndRow === null) {
          return true;
        }
        if (visualEndRow !== null && renderableEndRow === lastRenderableIndex && lastVisualIndex > visualEndRow) {
          physicalRowIndexes.push(...notTrimmedRowIndexes.slice(visualEndRow + 1));
        }
      }
      arrayEach(physicalRowIndexes, (physicalRowIndex) => {
        rows.push(this.toVisualRow(physicalRowIndex));
      });
      return rows.length === 0;
    }
  };
}
function _check_private_redeclaration$w(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$u(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$u(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$u(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$u(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$u(receiver, privateMap, "get");
  return _class_apply_descriptor_get$u(receiver, descriptor);
}
function _class_private_field_init$u(obj, privateMap, value) {
  _check_private_redeclaration$w(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$u(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$u(receiver, privateMap, "set");
  _class_apply_descriptor_set$u(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$j(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$j(obj, privateSet) {
  _check_private_redeclaration$w(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("beforeHideRows");
Hooks.getSingleton().register("afterHideRows");
Hooks.getSingleton().register("beforeUnhideRows");
Hooks.getSingleton().register("afterUnhideRows");
const PLUGIN_KEY$k = "hiddenRows";
const PLUGIN_PRIORITY$k = 320;
const SKIP_ROW_ON_PASTE_BY_PLUGIN = /* @__PURE__ */ Symbol("skipRowOnPasteByHiddenRows");
var _hiddenRowsMap = /* @__PURE__ */ new WeakMap(), _onModifyRowHeight$1 = /* @__PURE__ */ new WeakMap(), _onAfterGetCellMeta$1 = /* @__PURE__ */ new WeakMap(), _onModifyCopyableRange = /* @__PURE__ */ new WeakMap(), _onAfterGetRowHeader$1 = /* @__PURE__ */ new WeakMap(), _onAfterContextMenuDefaultOptions$1 = /* @__PURE__ */ new WeakMap(), _onMapInit$3 = /* @__PURE__ */ new WeakSet();
class HiddenRows extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$k;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$k;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      copyPasteEnabled: true,
      indicators: false,
      rows: []
    };
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link HiddenRows#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$k];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_set$u(this, _hiddenRowsMap, new HidingMap());
    _class_private_field_get$u(this, _hiddenRowsMap).addLocalHook("init", () => _class_private_method_get$j(this, _onMapInit$3, onMapInit$2).call(this));
    this.hot.rowIndexMapper.registerMap(this.pluginName, _class_private_field_get$u(this, _hiddenRowsMap));
    this.addHook("afterContextMenuDefaultOptions", _class_private_field_get$u(this, _onAfterContextMenuDefaultOptions$1));
    this.addHook("afterGetCellMeta", _class_private_field_get$u(this, _onAfterGetCellMeta$1));
    this.addHook("modifyRowHeight", _class_private_field_get$u(this, _onModifyRowHeight$1));
    this.addHook("afterGetRowHeader", _class_private_field_get$u(this, _onAfterGetRowHeader$1));
    this.addHook("modifyCopyableRange", _class_private_field_get$u(this, _onModifyCopyableRange));
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`hiddenRows`](@/api/options.md#hiddenrows)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
    this.hot.rowIndexMapper.unregisterMap(this.pluginName);
    this.resetCellsMeta();
  }
  /**
  * Shows the rows provided in the array.
  *
  * @param {number[]} rows Array of visual row indexes.
  */
  showRows(rows) {
    const currentHideConfig = this.getHiddenRows();
    const isValidConfig = this.isValidConfig(rows);
    let destinationHideConfig = currentHideConfig;
    const hidingMapValues = _class_private_field_get$u(this, _hiddenRowsMap).getValues().slice();
    const isAnyRowShowed = rows.length > 0;
    if (isValidConfig && isAnyRowShowed) {
      const physicalRows = rows.map((visualRow) => this.hot.toPhysicalRow(visualRow));
      arrayEach(physicalRows, (physicalRow) => {
        hidingMapValues[physicalRow] = false;
      });
      destinationHideConfig = arrayReduce(hidingMapValues, (hiddenIndexes, isHidden, physicalIndex) => {
        if (isHidden) {
          hiddenIndexes.push(this.hot.toVisualRow(physicalIndex));
        }
        return hiddenIndexes;
      }, []);
    }
    const continueHiding = this.hot.runHooks("beforeUnhideRows", currentHideConfig, destinationHideConfig, isValidConfig && isAnyRowShowed);
    if (continueHiding === false) {
      return;
    }
    if (isValidConfig && isAnyRowShowed) {
      _class_private_field_get$u(this, _hiddenRowsMap).setValues(hidingMapValues);
    }
    this.hot.runHooks("afterUnhideRows", currentHideConfig, destinationHideConfig, isValidConfig && isAnyRowShowed, isValidConfig && destinationHideConfig.length < currentHideConfig.length);
  }
  /**
  * Shows the row provided as row index (counting from 0).
  *
  * @param {...number} row Visual row index.
  */
  showRow(...row) {
    this.showRows(row);
  }
  /**
  * Hides the rows provided in the array.
  *
  * @param {number[]} rows Array of visual row indexes.
  */
  hideRows(rows) {
    const currentHideConfig = this.getHiddenRows();
    const isConfigValid = this.isValidConfig(rows);
    let destinationHideConfig = currentHideConfig;
    if (isConfigValid) {
      destinationHideConfig = Array.from(new Set(currentHideConfig.concat(rows)));
    }
    const continueHiding = this.hot.runHooks("beforeHideRows", currentHideConfig, destinationHideConfig, isConfigValid);
    if (continueHiding === false) {
      return;
    }
    if (isConfigValid) {
      this.hot.batchExecution(() => {
        arrayEach(rows, (visualRow) => {
          _class_private_field_get$u(this, _hiddenRowsMap).setValueAtIndex(this.hot.toPhysicalRow(visualRow), true);
        });
      }, true);
    }
    this.hot.runHooks("afterHideRows", currentHideConfig, destinationHideConfig, isConfigValid, isConfigValid && destinationHideConfig.length > currentHideConfig.length);
  }
  /**
  * Hides the row provided as row index (counting from 0).
  *
  * @param {...number} row Visual row index.
  */
  hideRow(...row) {
    this.hideRows(row);
  }
  /**
  * Returns an array of visual indexes of hidden rows.
  *
  * @returns {number[]}
  */
  getHiddenRows() {
    return arrayMap(_class_private_field_get$u(this, _hiddenRowsMap).getHiddenIndexes(), (physicalRowIndex) => {
      return this.hot.toVisualRow(physicalRowIndex);
    });
  }
  /**
  * Checks if the provided row is hidden.
  *
  * @param {number} row Visual row index.
  * @returns {boolean}
  */
  isHidden(row) {
    return _class_private_field_get$u(this, _hiddenRowsMap).getValueAtIndex(this.hot.toPhysicalRow(row)) || false;
  }
  /**
  * Checks whether all of the provided row indexes are within the bounds of the table.
  *
  * @param {Array} hiddenRows List of hidden visual row indexes.
  * @returns {boolean}
  */
  isValidConfig(hiddenRows) {
    const nrOfRows = this.hot.countRows();
    if (Array.isArray(hiddenRows) && hiddenRows.length > 0) {
      return hiddenRows.every((visualRow) => Number.isInteger(visualRow) && visualRow >= 0 && visualRow < nrOfRows);
    }
    return false;
  }
  /**
  * Resets all rendered cells meta.
  *
  * @private
  */
  resetCellsMeta() {
    arrayEach(this.hot.getCellsMeta(), (meta) => {
      const cellMeta = meta;
      if (cellMeta[SKIP_ROW_ON_PASTE_BY_PLUGIN]) {
        delete cellMeta.skipRowOnPaste;
        delete cellMeta[SKIP_ROW_ON_PASTE_BY_PLUGIN];
      }
    });
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_set$u(this, _hiddenRowsMap, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$j(this, _onMapInit$3), _class_private_field_init$u(this, _hiddenRowsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$u(this, _onModifyRowHeight$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$u(this, _onAfterGetCellMeta$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$u(this, _onModifyCopyableRange, {
      writable: true,
      value: void 0
    }), _class_private_field_init$u(this, _onAfterGetRowHeader$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$u(this, _onAfterContextMenuDefaultOptions$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$u(this, _hiddenRowsMap, null), _class_private_field_set$u(this, _onModifyRowHeight$1, (height, row) => {
      if (this.isHidden(row)) {
        return 0;
      }
      return height;
    }), _class_private_field_set$u(this, _onAfterGetCellMeta$1, (row, column, cellProperties) => {
      if (this.getSetting("copyPasteEnabled") === false) {
        const cellPropsWithMarker = cellProperties;
        if (this.isHidden(row)) {
          if (cellProperties.skipRowOnPaste !== true) {
            cellProperties.skipRowOnPaste = true;
            cellPropsWithMarker[SKIP_ROW_ON_PASTE_BY_PLUGIN] = true;
          }
        } else if (cellPropsWithMarker[SKIP_ROW_ON_PASTE_BY_PLUGIN]) {
          delete cellProperties.skipRowOnPaste;
          delete cellPropsWithMarker[SKIP_ROW_ON_PASTE_BY_PLUGIN];
        }
      }
      if (this.isHidden(row - 1)) {
        cellProperties.className = cellProperties.className || "";
        if (cellProperties.className.indexOf("afterHiddenRow") === -1) {
          cellProperties.className += " afterHiddenRow";
        }
      } else if (cellProperties.className) {
        const classArr = cellProperties.className.split(" ");
        if (classArr.length > 0) {
          const containAfterHiddenRow = classArr.indexOf("afterHiddenRow");
          if (containAfterHiddenRow > -1) {
            classArr.splice(containAfterHiddenRow, 1);
          }
          cellProperties.className = classArr.join(" ");
        }
      }
    }), _class_private_field_set$u(this, _onModifyCopyableRange, (ranges) => {
      if (this.getSetting("copyPasteEnabled")) {
        return ranges;
      }
      const newRanges = [];
      const pushRange = (startRow, endRow, startCol, endCol) => {
        newRanges.push({
          startRow,
          endRow,
          startCol,
          endCol
        });
      };
      arrayEach(ranges, (range) => {
        const r = range;
        let isHidden = true;
        let rangeStart = 0;
        rangeEach(r.startRow, r.endRow, (visualRow) => {
          if (this.isHidden(visualRow)) {
            if (!isHidden) {
              pushRange(rangeStart, visualRow - 1, r.startCol, r.endCol);
            }
            isHidden = true;
          } else {
            if (isHidden) {
              rangeStart = visualRow;
            }
            if (visualRow === r.endRow) {
              pushRange(rangeStart, visualRow, r.startCol, r.endCol);
            }
            isHidden = false;
          }
        });
      });
      return newRanges;
    }), _class_private_field_set$u(this, _onAfterGetRowHeader$1, (row, TH) => {
      if (!this.getSetting("indicators") || row < 0) {
        return;
      }
      const classList = [];
      if (row >= 1 && this.isHidden(row - 1)) {
        classList.push("afterHiddenRow");
      }
      if (row < this.hot.countRows() - 1 && this.isHidden(row + 1)) {
        classList.push("beforeHiddenRow");
      }
      addClass(TH, classList);
    }), _class_private_field_set$u(this, _onAfterContextMenuDefaultOptions$1, (options) => {
      options.items.push({
        name: KEY$c
      }, hideRowItem(this), showRowItem(this));
    });
  }
}
function onMapInit$2() {
  const rows = this.getSetting("rows");
  if (Array.isArray(rows)) {
    this.hideRows(rows);
  }
}
function freezeColumnItem(manualColumnFreezePlugin) {
  return {
    key: "freeze_column",
    name() {
      const phrase = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_FREEZE_COLUMN);
      return phrase;
    },
    callback(key, selected) {
      const [{ start: { col: selectedColumn } }] = selected;
      manualColumnFreezePlugin.freezeColumn(selectedColumn);
      this.view.adjustElementsSize();
      this.render();
    },
    hidden() {
      const selection = this.getSelectedRange();
      let hide2 = false;
      if (selection === void 0) {
        hide2 = true;
      } else if (selection.length > 1) {
        hide2 = true;
      } else if (selection[0].from.col !== selection[0].to.col || selection[0].from.col <= (this.getSettings().fixedColumnsStart ?? 0) - 1) {
        hide2 = true;
      }
      return hide2;
    }
  };
}
function unfreezeColumnItem(manualColumnFreezePlugin) {
  return {
    key: "unfreeze_column",
    name() {
      const phrase = this.getTranslatedPhrase(CONTEXTMENU_ITEMS_UNFREEZE_COLUMN);
      return phrase;
    },
    callback(key, selected) {
      const [{ start: { col: selectedColumn } }] = selected;
      manualColumnFreezePlugin.unfreezeColumn(selectedColumn);
      this.view.adjustElementsSize();
      this.render();
    },
    hidden() {
      const selection = this.getSelectedRange();
      let hide2 = false;
      if (selection === void 0) {
        hide2 = true;
      } else if (selection.length > 1) {
        hide2 = true;
      } else {
        const fromCol = selection[0].from.col;
        const toCol = selection[0].to.col;
        const fixedColumnsStart = this.getSettings().fixedColumnsStart ?? 0;
        if (fromCol !== toCol || fromCol !== null && fromCol >= fixedColumnsStart) {
          hide2 = true;
        }
      }
      return hide2;
    }
  };
}
function _check_private_redeclaration$v(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$t(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$t(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$t(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$t(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$t(receiver, privateMap, "get");
  return _class_apply_descriptor_get$t(receiver, descriptor);
}
function _class_private_field_init$t(obj, privateMap, value) {
  _check_private_redeclaration$v(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$t(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$t(receiver, privateMap, "set");
  _class_apply_descriptor_set$t(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$i(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$i(obj, privateSet) {
  _check_private_redeclaration$v(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("beforeColumnFreeze");
Hooks.getSingleton().register("afterColumnFreeze");
Hooks.getSingleton().register("beforeColumnUnfreeze");
Hooks.getSingleton().register("afterColumnUnfreeze");
const PLUGIN_KEY$j = "manualColumnFreeze";
const PLUGIN_PRIORITY$j = 110;
var _afterFirstUse = /* @__PURE__ */ new WeakMap(), _addContextMenuEntry = /* @__PURE__ */ new WeakSet(), _onBeforeColumnMove$1 = /* @__PURE__ */ new WeakMap();
class ManualColumnFreeze extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$j;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$j;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ManualColumnFreeze#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$j];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("afterContextMenuDefaultOptions", (options) => {
      _class_private_method_get$i(this, _addContextMenuEntry, addContextMenuEntry).call(this, options);
    });
    this.addHook("beforeColumnMove", _class_private_field_get$t(this, _onBeforeColumnMove$1));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    _class_private_field_set$t(this, _afterFirstUse, false);
    super.disablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`manualColumnFreeze`](@/api/options.md#manualcolumnfreeze)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Freezes the specified column (adds it to fixed columns).
  *
  * `freezeColumn()` doesn't re-render the table,
  * so you need to call the `render()` method afterward.
  *
  * @param {number} column Visual column index.
  */
  freezeColumn(column) {
    const settings = this.hot.getSettings();
    const freezePerformed = (settings.fixedColumnsStart ?? 0) < this.hot.countCols() && column > (settings.fixedColumnsStart ?? 0) - 1;
    if (!_class_private_field_get$t(this, _afterFirstUse)) {
      _class_private_field_set$t(this, _afterFirstUse, true);
    }
    const beforeColumnFreezeHook = this.hot.runHooks("beforeColumnFreeze", column, freezePerformed);
    if (beforeColumnFreezeHook === false) {
      return;
    }
    if (freezePerformed) {
      this.hot.columnIndexMapper.moveIndexes(column, settings.fixedColumnsStart ?? 0);
      settings._fixedColumnsStart += 1;
    }
    this.hot.runHooks("afterColumnFreeze", column, freezePerformed);
  }
  /**
  * Unfreezes the given column (remove it from fixed columns and bring to it's previous position).
  *
  * @param {number} column Visual column index.
  */
  unfreezeColumn(column) {
    const settings = this.hot.getSettings();
    const fixedStart = settings.fixedColumnsStart ?? 0;
    const unfreezePerformed = fixedStart > 0 && column <= fixedStart - 1;
    if (!_class_private_field_get$t(this, _afterFirstUse)) {
      _class_private_field_set$t(this, _afterFirstUse, true);
    }
    const beforeColumnUnfreezeHook = this.hot.runHooks("beforeColumnUnfreeze", column, unfreezePerformed);
    if (beforeColumnUnfreezeHook === false) {
      return;
    }
    if (unfreezePerformed) {
      settings._fixedColumnsStart -= 1;
      this.hot.columnIndexMapper.moveIndexes(column, settings.fixedColumnsStart ?? 0);
    }
    this.hot.runHooks("afterColumnUnfreeze", column, unfreezePerformed);
  }
  constructor(...args) {
    super(...args), _class_private_method_init$i(this, _addContextMenuEntry), _class_private_field_init$t(this, _afterFirstUse, {
      writable: true,
      value: void 0
    }), _class_private_field_init$t(this, _onBeforeColumnMove$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$t(this, _afterFirstUse, false), _class_private_field_set$t(this, _onBeforeColumnMove$1, (columns, finalIndex) => {
      if (_class_private_field_get$t(this, _afterFirstUse)) {
        const freezeLine = this.hot.getSettings().fixedColumnsStart ?? 0;
        if (finalIndex < freezeLine) {
          return false;
        }
        if (columns.some((column) => column < freezeLine)) {
          return false;
        }
      }
    });
  }
}
function addContextMenuEntry(options) {
  options.items.push({
    name: "---------"
  }, freezeColumnItem(this), unfreezeColumnItem(this));
}
const STATE_INITIALIZED$1 = 0;
const STATE_BUILT$1 = 1;
const STATE_APPENDED$1 = 2;
const UNIT$1 = "px";
let BaseUI$2 = class BaseUI2 {
  /**
  * Add created UI elements to table.
  *
  * @param {HTMLElement} wrapper Element which are parent for our UI element.
  */
  appendTo(wrapper) {
    wrapper.appendChild(this._element);
    this.state = STATE_APPENDED$1;
  }
  /**
  * Method for create UI element. Only create, without append to table.
  */
  build() {
    if (this.state !== STATE_INITIALIZED$1) {
      return;
    }
    this._element = this.hot.rootDocument.createElement("div");
    this.state = STATE_BUILT$1;
  }
  /**
  * Method for remove UI element.
  */
  destroy() {
    if (this.isAppended()) {
      this._element.parentElement?.removeChild(this._element);
    }
    this._element = null;
    this.state = STATE_INITIALIZED$1;
  }
  /**
  * Check if UI element are appended.
  *
  * @returns {boolean}
  */
  isAppended() {
    return this.state === STATE_APPENDED$1;
  }
  /**
  * Check if UI element are built.
  *
  * @returns {boolean}
  */
  isBuilt() {
    return this.state >= STATE_BUILT$1;
  }
  /**
  * Setter for position.
  *
  * @param {number} top New top position of the element.
  * @param {number} inlinePosition New left/right (depends on LTR/RTL document mode) position of the element.
  */
  setPosition(top2, inlinePosition) {
    if (isNumeric(top2)) {
      this._element.style.top = top2 + UNIT$1;
    }
    if (isNumeric(inlinePosition)) {
      this._element.style[this.inlineProperty] = inlinePosition + UNIT$1;
    }
  }
  /**
  * Getter for the element position.
  *
  * @returns {object} Object contains left and top position of the element.
  */
  getPosition() {
    const style = this._element.style;
    return {
      top: style.top ? Number.parseInt(style.top, 10) : 0,
      start: style[this.inlineProperty] ? Number.parseInt(style[this.inlineProperty], 10) : 0
    };
  }
  /**
  * Setter for the element size.
  *
  * @param {number} width New width of the element.
  * @param {number} height New height of the element.
  */
  setSize(width, height) {
    if (isNumeric(width)) {
      this._element.style.width = width + UNIT$1;
    }
    if (isNumeric(height)) {
      this._element.style.height = height + UNIT$1;
    }
  }
  /**
  * Getter for the element position.
  *
  * @returns {object} Object contains height and width of the element.
  */
  getSize() {
    return {
      width: this._element.style.width ? Number.parseInt(this._element.style.width, 10) : 0,
      height: this._element.style.height ? Number.parseInt(this._element.style.height, 10) : 0
    };
  }
  /**
  * Setter for the element offset. Offset means marginTop and marginLeft of the element.
  *
  * @param {number} top New margin top of the element.
  * @param {number} inlineOffset New margin left/right (depends on LTR/RTL document mode) of the element.
  */
  setOffset(top2, inlineOffset) {
    if (isNumeric(top2)) {
      this._element.style.marginTop = top2 + UNIT$1;
    }
    if (isNumeric(inlineOffset)) {
      const marginProp = `margin${toUpperCaseFirst(this.inlineProperty)}`;
      this._element.style[marginProp] = inlineOffset + UNIT$1;
    }
  }
  /**
  * Getter for the element offset.
  *
  * @returns {object} Object contains top and left offset of the element.
  */
  getOffset() {
    const style = this._element.style;
    const inlineProp = `margin${toUpperCaseFirst(this.inlineProperty)}`;
    return {
      top: style.marginTop ? Number.parseInt(style.marginTop, 10) : 0,
      start: style[inlineProp] ? Number.parseInt(style[inlineProp], 10) : 0
    };
  }
  /**
  * Initializes the base UI element with the Handsontable instance and sets the inline CSS property name based on the document layout direction.
  */
  constructor(hotInstance) {
    this._element = null;
    this.state = STATE_INITIALIZED$1;
    this.hot = hotInstance;
    this.inlineProperty = hotInstance.isRtl() ? "right" : "left";
  }
};
const CSS_CLASSNAME$3 = "ht__manualColumnMove--backlight";
let BacklightUI$1 = class BacklightUI extends BaseUI$2 {
  /**
  * Custom className on build process.
  */
  build() {
    super.build();
    addClass(this._element, CSS_CLASSNAME$3);
  }
};
const CSS_CLASSNAME$2 = "ht__manualColumnMove--guideline";
let GuidelineUI$1 = class GuidelineUI extends BaseUI$2 {
  /**
  * Custom className on build process.
  */
  build() {
    super.build();
    addClass(this._element, CSS_CLASSNAME$2);
  }
};
function _check_private_redeclaration$u(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$s(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$s(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$s(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$s(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$s(receiver, privateMap, "get");
  return _class_apply_descriptor_get$s(receiver, descriptor);
}
function _class_private_field_init$s(obj, privateMap, value) {
  _check_private_redeclaration$u(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$s(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$s(receiver, privateMap, "set");
  _class_apply_descriptor_set$s(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$h(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$h(obj, privateSet) {
  _check_private_redeclaration$u(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("beforeColumnMove");
Hooks.getSingleton().register("afterColumnMove");
const PLUGIN_KEY$i = "manualColumnMove";
const PLUGIN_PRIORITY$i = 120;
const CSS_PLUGIN$1 = "ht__manualColumnMove";
const CSS_SHOW_UI$1 = "show-ui";
const CSS_ON_MOVING$1 = "on-moving--columns";
const CSS_AFTER_SELECTION$1 = "after-selection--columns";
var _backlight$1 = /* @__PURE__ */ new WeakMap(), _guideline$1 = /* @__PURE__ */ new WeakMap(), _columnsToMove = /* @__PURE__ */ new WeakMap(), _countCols = /* @__PURE__ */ new WeakMap(), _pressed$3 = /* @__PURE__ */ new WeakMap(), _target$1 = /* @__PURE__ */ new WeakMap(), _cachedDropIndex$1 = /* @__PURE__ */ new WeakMap(), _hoveredColumn = /* @__PURE__ */ new WeakMap(), _rootElementOffset = /* @__PURE__ */ new WeakMap(), _hasRowHeaders = /* @__PURE__ */ new WeakMap(), _fixedColumnsStart = /* @__PURE__ */ new WeakMap(), _calculateMouseOffsetStart = /* @__PURE__ */ new WeakSet(), _calculateTargetCol = /* @__PURE__ */ new WeakSet(), _onBeforeOnCellMouseDown$3 = /* @__PURE__ */ new WeakMap(), _onMouseMove$3 = /* @__PURE__ */ new WeakSet(), _onBeforeOnCellMouseOver$2 = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseOverOutside$1 = /* @__PURE__ */ new WeakSet(), _onMouseUp$3 = /* @__PURE__ */ new WeakSet(), _onAfterScrollVertically = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$2 = /* @__PURE__ */ new WeakMap();
class ManualColumnMove extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$i;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$i;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ManualColumnMove#enablePlugin} method is called.
  * When [[Options#dataProvider]] is a complete server-backed configuration, the DataProvider plugin blocks this plugin from enabling.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$i];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$s(this, _onBeforeOnCellMouseDown$3));
    this.addHook("beforeOnCellMouseOver", _class_private_field_get$s(this, _onBeforeOnCellMouseOver$2));
    this.addHook("beforeOnCellMouseOverOutside", (event, coords, TD, controller) => _class_private_method_get$h(this, _onBeforeOnCellMouseOverOutside$1, onBeforeOnCellMouseOverOutside$1).call(this, controller));
    this.addHook("afterScrollVertically", _class_private_field_get$s(this, _onAfterScrollVertically));
    this.addHook("afterLoadData", _class_private_field_get$s(this, _onAfterLoadData$2));
    this.buildPluginUI();
    this.registerEvents();
    addClass(this.hot.rootElement, CSS_PLUGIN$1);
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`manualColumnMove`](@/api/options.md#manualcolumnmove)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    this.moveBySettingsOrLoad();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    removeClass(this.hot.rootElement, CSS_PLUGIN$1);
    this.unregisterEvents();
    _class_private_field_get$s(this, _backlight$1).destroy();
    _class_private_field_get$s(this, _guideline$1).destroy();
    super.disablePlugin();
  }
  /**
  * Moves a single column.
  *
  * @param {number} column Visual column index to be moved.
  * @param {number} finalIndex Visual column index, being a start index for the moved columns. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/columns/column-moving/column-moving.md#drag-and-move-actions-of-manualcolumnmove-plugin).
  * @fires Hooks#beforeColumnMove
  * @fires Hooks#afterColumnMove
  * @returns {boolean}
  */
  moveColumn(column, finalIndex) {
    return this.moveColumns([
      column
    ], finalIndex);
  }
  /**
  * Moves a multiple columns.
  *
  * @param {Array} columns Array of visual column indexes to be moved.
  * @param {number} finalIndex Visual column index, being a start index for the moved columns. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/columns/column-moving/column-moving.md#drag-and-move-actions-of-manualcolumnmove-plugin).
  * @fires Hooks#beforeColumnMove
  * @fires Hooks#afterColumnMove
  * @returns {boolean}
  */
  moveColumns(columns, finalIndex) {
    const dropIndex = _class_private_field_get$s(this, _cachedDropIndex$1);
    const movePossible = this.isMovePossible(columns, finalIndex);
    const beforeMoveHook = this.hot.runHooks("beforeColumnMove", columns, finalIndex, dropIndex, movePossible);
    _class_private_field_set$s(this, _cachedDropIndex$1, void 0);
    if (beforeMoveHook === false) {
      return false;
    }
    if (movePossible) {
      this.hot.columnIndexMapper.moveIndexes(columns, finalIndex);
    }
    const movePerformed = movePossible && this.isColumnOrderChanged(columns, finalIndex);
    this.hot.runHooks("afterColumnMove", columns, finalIndex, dropIndex, movePossible, movePerformed);
    return movePerformed;
  }
  /**
  * Drag a single column to drop index position.
  *
  * @param {number} column Visual column index to be dragged.
  * @param {number} dropIndex Visual column index, being a drop index for the moved columns. Points to where we are going to drop the moved elements.
  * To check visualization of drop index please take a look at [documentation](@/guides/columns/column-moving/column-moving.md#drag-and-move-actions-of-manualcolumnmove-plugin).
  * @fires Hooks#beforeColumnMove
  * @fires Hooks#afterColumnMove
  * @returns {boolean}
  */
  dragColumn(column, dropIndex) {
    return this.dragColumns([
      column
    ], dropIndex);
  }
  /**
  * Drag multiple columns to drop index position.
  *
  * @param {Array} columns Array of visual column indexes to be dragged.
  * @param {number} dropIndex Visual column index, being a drop index for the moved columns. Points to where we are going to drop the moved elements.
  * To check visualization of drop index please take a look at [documentation](@/guides/columns/column-moving/column-moving.md#drag-and-move-actions-of-manualcolumnmove-plugin).
  * @fires Hooks#beforeColumnMove
  * @fires Hooks#afterColumnMove
  * @returns {boolean}
  */
  dragColumns(columns, dropIndex) {
    const finalIndex = this.countFinalIndex(columns, dropIndex);
    _class_private_field_set$s(this, _cachedDropIndex$1, dropIndex);
    return this.moveColumns(columns, finalIndex);
  }
  /**
  * Indicates if it's possible to move columns to the desired position. Some of the actions aren't
  * possible, i.e. You can’t move more than one element to the last position.
  *
  * @param {Array} movedColumns Array of visual column indexes to be moved.
  * @param {number} finalIndex Visual column index, being a start index for the moved columns. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/columns/column-moving/column-moving.md#drag-and-move-actions-of-manualcolumnmove-plugin).
  * @returns {boolean}
  */
  isMovePossible(movedColumns, finalIndex) {
    const length = this.hot.columnIndexMapper.getNotTrimmedIndexesLength();
    const tooHighDestinationIndex = movedColumns.length + finalIndex > length;
    const tooLowDestinationIndex = finalIndex < 0;
    const tooLowMovedColumnIndex = movedColumns.some((movedColumn) => movedColumn < 0);
    const tooHighMovedColumnIndex = movedColumns.some((movedColumn) => movedColumn >= length);
    if (tooHighDestinationIndex || tooLowDestinationIndex || tooLowMovedColumnIndex || tooHighMovedColumnIndex) {
      return false;
    }
    return true;
  }
  /**
  * Indicates if order of columns was changed.
  *
  * @private
  * @param {Array} movedColumns Array of visual column indexes to be moved.
  * @param {number} finalIndex Visual column index, being a start index for the moved columns. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/columns/column-moving/column-moving.md#drag-and-move-actions-of-manualcolumnmove-plugin).
  * @returns {boolean}
  */
  isColumnOrderChanged(movedColumns, finalIndex) {
    return movedColumns.some((column, nrOfMovedElement) => column - nrOfMovedElement !== finalIndex);
  }
  /**
  * Count the final column index from the drop index.
  *
  * @private
  * @param {Array} movedColumns Array of visual column indexes to be moved.
  * @param {number} dropIndex Visual column index, being a drop index for the moved columns.
  * @returns {number} Visual column index, being a start index for the moved columns.
  */
  countFinalIndex(movedColumns, dropIndex) {
    const numberOfColumnsLowerThanDropIndex = arrayReduce(movedColumns, (numberOfColumns, currentColumnIndex) => {
      if (currentColumnIndex < dropIndex) {
        return numberOfColumns + 1;
      }
      return numberOfColumns;
    }, 0);
    return dropIndex - numberOfColumnsLowerThanDropIndex;
  }
  /**
  * Gets the sum of the widths of columns in the provided range.
  *
  * @private
  * @param {number} fromColumn Visual column index.
  * @param {number} toColumn Visual column index.
  * @returns {number}
  */
  getColumnsWidth(fromColumn, toColumn) {
    const columnMapper = this.hot.columnIndexMapper;
    let columnsWidth = 0;
    for (let visualColumnIndex = fromColumn; visualColumnIndex <= toColumn; visualColumnIndex += 1) {
      const renderableIndex = columnMapper.getRenderableFromVisualIndex(visualColumnIndex);
      if (visualColumnIndex < 0) {
        columnsWidth += this.hot.view._wt.wtViewport.getRowHeaderWidth() || 0;
      } else if (renderableIndex !== null) {
        columnsWidth += this.hot.view._wt.wtTable.getColumnWidth(renderableIndex) || 0;
      }
    }
    return columnsWidth;
  }
  /**
  * Loads initial settings when state was saved (e.g. via hooks) or when plugin was initialized as an array.
  *
  * @private
  */
  moveBySettingsOrLoad() {
    const pluginSettings = this.hot.getSettings()[PLUGIN_KEY$i];
    if (Array.isArray(pluginSettings)) {
      this.moveColumns(pluginSettings, 0);
    }
  }
  /**
  * Checks if the provided column is in the fixedColumnsTop section.
  *
  * @private
  * @param {number} column Visual column index to check.
  * @returns {boolean}
  */
  isFixedColumnsStart(column) {
    return column < (this.hot.getSettings().fixedColumnsStart ?? 0);
  }
  /**
  * Prepares an array of indexes based on actual selection.
  *
  * @private
  * @param {number} start The start index.
  * @param {number} end The end index.
  * @returns {Array}
  */
  prepareColumnsToMoving(start, end) {
    const selectedColumns = [];
    rangeEach(start, end, (i) => {
      selectedColumns.push(i);
    });
    return selectedColumns;
  }
  /**
  * Update the UI visual position.
  *
  * @private
  */
  refreshPositions() {
    const firstVisible = this.hot.view.getFirstFullyVisibleColumn() ?? 0;
    const hoveredColumn = _class_private_field_get$s(this, _hoveredColumn) ?? 0;
    const fixedColumnsStart = _class_private_field_get$s(this, _fixedColumnsStart) ?? 0;
    const rootElementOffset = _class_private_field_get$s(this, _rootElementOffset) ?? 0;
    if (this.isFixedColumnsStart(hoveredColumn) && firstVisible > 0) {
      this.hot.scrollViewportTo({
        col: this.hot.columnIndexMapper.getNearestNotHiddenIndex(firstVisible - 1, -1) ?? void 0
      });
    }
    const wtTable = this.hot.view._wt.wtTable;
    const scrollableElement = this.hot.view._wt.wtOverlays.scrollableElement;
    const scrollStart = scrollableElement instanceof Window ? scrollableElement.scrollX : scrollableElement.scrollLeft;
    let tdOffsetStart = this.hot.view.THEAD.offsetLeft + this.getColumnsWidth(0, hoveredColumn - 1);
    const hiderWidth = wtTable.hider.offsetWidth;
    const tbodyOffsetLeft = wtTable.TBODY?.offsetLeft ?? 0;
    const backlightElemMarginStart = _class_private_field_get$s(this, _backlight$1).getOffset().start;
    const backlightElemWidth = _class_private_field_get$s(this, _backlight$1).getSize().width;
    let rowHeaderWidth = 0;
    const mouseOffsetStart = _class_private_method_get$h(this, _calculateMouseOffsetStart, calculateMouseOffsetStart).call(this, scrollableElement, scrollStart, rootElementOffset);
    if (_class_private_field_get$s(this, _hasRowHeaders)) {
      const inlineClone = this.hot.view._wt.wtOverlays.inlineStartOverlay.clone;
      rowHeaderWidth = inlineClone?.wtTable.getColumnHeader(-1)?.offsetWidth ?? 0;
    }
    if (this.isFixedColumnsStart(hoveredColumn)) {
      tdOffsetStart += scrollStart;
    }
    tdOffsetStart += rowHeaderWidth;
    tdOffsetStart = _class_private_method_get$h(this, _calculateTargetCol, calculateTargetCol).call(this, hoveredColumn, tdOffsetStart, mouseOffsetStart, firstVisible, fixedColumnsStart);
    let backlightStart = mouseOffsetStart;
    let guidelineStart = tdOffsetStart;
    if (mouseOffsetStart + backlightElemWidth + backlightElemMarginStart >= hiderWidth) {
      backlightStart = hiderWidth - backlightElemWidth - backlightElemMarginStart;
    } else if (mouseOffsetStart + backlightElemMarginStart < tbodyOffsetLeft + rowHeaderWidth) {
      backlightStart = tbodyOffsetLeft + rowHeaderWidth + Math.abs(backlightElemMarginStart);
    }
    if (tdOffsetStart >= hiderWidth - 1) {
      guidelineStart = hiderWidth - 1;
    } else if (guidelineStart === 0) {
      guidelineStart = 1;
    } else if (scrollableElement instanceof Window && hoveredColumn < fixedColumnsStart) {
      guidelineStart -= rootElementOffset <= scrollableElement.scrollX ? rootElementOffset : 0;
    }
    _class_private_field_get$s(this, _backlight$1).setPosition(void 0, backlightStart);
    _class_private_field_get$s(this, _guideline$1).setPosition(void 0, guidelineStart);
  }
  /**
  * Binds the events used by the plugin.
  *
  * @private
  */
  registerEvents() {
    const { documentElement } = this.hot.rootDocument;
    this.eventManager.addEventListener(documentElement, "mousemove", (event) => _class_private_method_get$h(this, _onMouseMove$3, onMouseMove$3).call(this, event));
    this.eventManager.addEventListener(documentElement, "mouseup", () => _class_private_method_get$h(this, _onMouseUp$3, onMouseUp$3).call(this));
  }
  /**
  * Unbinds the events used by the plugin.
  *
  * @private
  */
  unregisterEvents() {
    this.eventManager.clear();
  }
  /**
  * Builds the plugin's UI.
  *
  * @private
  */
  buildPluginUI() {
    _class_private_field_get$s(this, _backlight$1).build();
    _class_private_field_get$s(this, _guideline$1).build();
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$s(this, _backlight$1).destroy();
    _class_private_field_get$s(this, _guideline$1).destroy();
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$h(this, _calculateMouseOffsetStart), _class_private_method_init$h(this, _calculateTargetCol), _class_private_method_init$h(this, _onMouseMove$3), _class_private_method_init$h(this, _onBeforeOnCellMouseOverOutside$1), _class_private_method_init$h(this, _onMouseUp$3), /**
    * Backlight UI object.
    *
    * @type {object}
    */
    _class_private_field_init$s(this, _backlight$1, {
      writable: true,
      value: void 0
    }), /**
    * Guideline UI object.
    *
    * @type {object}
    */
    _class_private_field_init$s(this, _guideline$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _columnsToMove, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _countCols, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _pressed$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _target$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _cachedDropIndex$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _hoveredColumn, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _rootElementOffset, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _hasRowHeaders, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _fixedColumnsStart, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _onBeforeOnCellMouseDown$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _onBeforeOnCellMouseOver$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _onAfterScrollVertically, {
      writable: true,
      value: void 0
    }), _class_private_field_init$s(this, _onAfterLoadData$2, {
      writable: true,
      value: void 0
    }), _class_private_field_set$s(this, _backlight$1, new BacklightUI$1(this.hot)), _class_private_field_set$s(this, _guideline$1, new GuidelineUI$1(this.hot)), _class_private_field_set$s(this, _columnsToMove, []), _class_private_field_set$s(this, _countCols, 0), _class_private_field_set$s(this, _pressed$3, false), _class_private_field_set$s(this, _target$1, {}), _class_private_field_set$s(this, _onBeforeOnCellMouseDown$3, (event, coords, TD, controller) => {
      const wtTable = this.hot.view._wt.wtTable;
      const isHeaderSelection = this.hot.selection.isSelectedByColumnHeader();
      const selection = this.hot.getSelectedRangeActive();
      const isSortingElement = hasClass(eventTargetEl(event), "sortAction");
      if (!selection || !isHeaderSelection || _class_private_field_get$s(this, _pressed$3) || event.button !== 0 || isSortingElement) {
        _class_private_field_set$s(this, _pressed$3, false);
        _class_private_field_get$s(this, _columnsToMove).length = 0;
        removeClass(this.hot.rootElement, [
          CSS_ON_MOVING$1,
          CSS_SHOW_UI$1
        ]);
        return;
      }
      const guidelineIsNotReady = _class_private_field_get$s(this, _guideline$1).isBuilt() && !_class_private_field_get$s(this, _guideline$1).isAppended();
      const backlightIsNotReady = _class_private_field_get$s(this, _backlight$1).isBuilt() && !_class_private_field_get$s(this, _backlight$1).isAppended();
      if (guidelineIsNotReady && backlightIsNotReady) {
        _class_private_field_get$s(this, _guideline$1).appendTo(wtTable.hider);
        _class_private_field_get$s(this, _backlight$1).appendTo(wtTable.hider);
      }
      const { from, to } = selection;
      const start = Math.min(from.col ?? 0, to.col ?? 0);
      const end = Math.max(from.col ?? 0, to.col ?? 0);
      if (coords.row < 0 && coords.col >= start && coords.col <= end) {
        controller.column = true;
        _class_private_field_set$s(this, _pressed$3, true);
        const eventOffsetX = TD.firstChild ? offsetRelativeTo(event, TD.firstChild).x : event.offsetX;
        _class_private_field_get$s(this, _target$1).eventPageX = event.pageX;
        _class_private_field_set$s(this, _hoveredColumn, coords.col);
        _class_private_field_get$s(this, _target$1).TD = TD;
        _class_private_field_get$s(this, _target$1).col = coords.col;
        _class_private_field_set$s(this, _columnsToMove, this.prepareColumnsToMoving(start, end));
        _class_private_field_set$s(this, _hasRowHeaders, !!this.hot.getSettings().rowHeaders);
        _class_private_field_set$s(this, _countCols, this.hot.countCols());
        _class_private_field_set$s(this, _fixedColumnsStart, this.hot.getSettings().fixedColumnsStart);
        _class_private_field_set$s(this, _rootElementOffset, offset(this.hot.rootElement).left);
        const countColumnsFrom = _class_private_field_get$s(this, _hasRowHeaders) ? -1 : 0;
        const topPos = wtTable.holder.scrollTop + wtTable.getColumnHeaderHeight(0) + 1;
        const fixedColumnsStart = coords.col < (_class_private_field_get$s(this, _fixedColumnsStart) ?? 0);
        const horizontalScrollPosition = this.hot.view._wt.wtOverlays.inlineStartOverlay.getOverlayOffset();
        const offsetX = Math.abs(eventOffsetX - (this.hot.isRtl() ? TD.offsetWidth : 0));
        const inlineOffset = this.getColumnsWidth(start, coords.col - 1) + offsetX;
        const inlinePos = this.getColumnsWidth(countColumnsFrom, start - 1) + (fixedColumnsStart ? horizontalScrollPosition : 0) + inlineOffset;
        _class_private_field_get$s(this, _backlight$1).setPosition(topPos, inlinePos);
        _class_private_field_get$s(this, _backlight$1).setSize(this.getColumnsWidth(start, end), wtTable.hider.offsetHeight - topPos);
        _class_private_field_get$s(this, _backlight$1).setOffset(0, -inlineOffset);
        addClass(this.hot.rootElement, CSS_ON_MOVING$1);
      } else {
        removeClass(this.hot.rootElement, CSS_AFTER_SELECTION$1);
        _class_private_field_set$s(this, _pressed$3, false);
        _class_private_field_get$s(this, _columnsToMove).length = 0;
      }
    }), _class_private_field_set$s(this, _onBeforeOnCellMouseOver$2, (event, coords, TD, controller) => {
      const selectedRange = this.hot.getSelectedRangeActive();
      if (!selectedRange || !_class_private_field_get$s(this, _pressed$3)) {
        return;
      }
      if (_class_private_field_get$s(this, _columnsToMove).indexOf(coords.col) > -1) {
        removeClass(this.hot.rootElement, CSS_SHOW_UI$1);
      } else {
        addClass(this.hot.rootElement, CSS_SHOW_UI$1);
      }
      controller.row = true;
      controller.column = true;
      controller.cell = true;
      _class_private_field_set$s(this, _hoveredColumn, coords.col);
      _class_private_field_get$s(this, _target$1).TD = TD;
    }), _class_private_field_set$s(this, _onAfterScrollVertically, () => {
      const wtTable = this.hot.view._wt.wtTable;
      const headerHeight = wtTable.getColumnHeaderHeight(0) + 1;
      const scrollTop = wtTable.holder.scrollTop;
      const posTop = headerHeight + scrollTop;
      _class_private_field_get$s(this, _backlight$1).setPosition(posTop);
      _class_private_field_get$s(this, _backlight$1).setSize(void 0, wtTable.hider.offsetHeight - posTop);
    }), _class_private_field_set$s(this, _onAfterLoadData$2, () => {
      this.moveBySettingsOrLoad();
    });
  }
}
function calculateMouseOffsetStart(scrollableElement, scrollStart, rootElementOffset) {
  if (this.hot.isRtl()) {
    const rootWindow = this.hot.rootWindow;
    const containerWidth = outerWidth(this.hot.rootElement);
    const gridMostRightPos = rootWindow.innerWidth - rootElementOffset - containerWidth;
    return rootWindow.innerWidth - _class_private_field_get$s(this, _target$1).eventPageX - gridMostRightPos - (!(scrollableElement instanceof Window) ? scrollStart : 0);
  }
  return _class_private_field_get$s(this, _target$1).eventPageX - (rootElementOffset - (!(scrollableElement instanceof Window) ? scrollStart : 0));
}
function calculateTargetCol(hoveredColumn, tdOffsetStart, mouseOffsetStart, firstVisible, fixedColumnsStart) {
  if (hoveredColumn < 0) {
    if (fixedColumnsStart > 0) {
      _class_private_field_get$s(this, _target$1).col = 0;
    } else {
      _class_private_field_get$s(this, _target$1).col = firstVisible > 0 ? firstVisible - 1 : firstVisible;
    }
  } else if (_class_private_field_get$s(this, _target$1).TD.offsetWidth / 2 + tdOffsetStart <= mouseOffsetStart) {
    const newCoordsCol = hoveredColumn >= _class_private_field_get$s(this, _countCols) ? _class_private_field_get$s(this, _countCols) - 1 : hoveredColumn;
    _class_private_field_get$s(this, _target$1).col = newCoordsCol + 1;
    tdOffsetStart += _class_private_field_get$s(this, _target$1).TD.offsetWidth;
  } else {
    _class_private_field_get$s(this, _target$1).col = hoveredColumn;
  }
  return tdOffsetStart;
}
function onMouseMove$3(event) {
  if (!_class_private_field_get$s(this, _pressed$3)) {
    return;
  }
  _class_private_field_get$s(this, _target$1).eventPageX = event.pageX;
  this.refreshPositions();
}
function onBeforeOnCellMouseOverOutside$1(controller) {
  if (!_class_private_field_get$s(this, _pressed$3)) {
    return;
  }
  controller.row = true;
  controller.column = true;
  controller.cell = true;
}
function onMouseUp$3() {
  const target = _class_private_field_get$s(this, _target$1).col;
  const columnsLen = _class_private_field_get$s(this, _columnsToMove).length;
  _class_private_field_set$s(this, _hoveredColumn, void 0);
  _class_private_field_set$s(this, _pressed$3, false);
  removeClass(this.hot.rootElement, [
    CSS_ON_MOVING$1,
    CSS_SHOW_UI$1,
    CSS_AFTER_SELECTION$1
  ]);
  if (this.hot.selection.isSelectedByColumnHeader()) {
    addClass(this.hot.rootElement, CSS_AFTER_SELECTION$1);
  }
  if (columnsLen < 1 || target === void 0) {
    return;
  }
  const firstMovedVisualColumn = _class_private_field_get$s(this, _columnsToMove)[0];
  const firstMovedPhysicalColumn = this.hot.toPhysicalColumn(firstMovedVisualColumn);
  const movePerformed = this.dragColumns(_class_private_field_get$s(this, _columnsToMove), target);
  _class_private_field_get$s(this, _columnsToMove).length = 0;
  if (movePerformed === true) {
    this.hot.view.adjustElementsSize();
    this.hot.render();
    const selectionStart = this.hot.toVisualColumn(firstMovedPhysicalColumn);
    const selectionEnd = selectionStart + columnsLen - 1;
    this.hot.selectColumns(selectionStart, selectionEnd);
  }
}
function getElementScaleFactor(element, axis = "horizontal") {
  const boundingRect = element.getBoundingClientRect();
  const transformedSize = axis === "vertical" ? boundingRect.height : boundingRect.width;
  const unscaledSize = axis === "vertical" ? element.offsetHeight : element.offsetWidth;
  if (!Number.isFinite(transformedSize) || !Number.isFinite(unscaledSize) || transformedSize <= 0 || unscaledSize <= 0) {
    return 1;
  }
  if (transformedSize >= unscaledSize && transformedSize - unscaledSize <= 1) {
    return 1;
  }
  const scaleFactor = transformedSize / unscaledSize;
  return Number.isFinite(scaleFactor) && scaleFactor > 0 ? scaleFactor : 1;
}
function normalizeVisualDelta(visualDelta, scaleFactor) {
  if (!Number.isFinite(scaleFactor) || scaleFactor <= 0) {
    return visualDelta;
  }
  return Math.round(visualDelta / scaleFactor);
}
function shouldSkipResizeHandlePositioning(header, resizeClickCount) {
  return !header.parentNode || resizeClickCount > 1;
}
function shouldRefreshHandleAfterAutoResize(header, resizeClickCount) {
  return !!header?.parentNode && resizeClickCount >= 2;
}
function _check_private_redeclaration$t(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$r(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$r(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$r(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$r(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$r(receiver, privateMap, "get");
  return _class_apply_descriptor_get$r(receiver, descriptor);
}
function _class_private_field_init$r(obj, privateMap, value) {
  _check_private_redeclaration$t(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$r(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$r(receiver, privateMap, "set");
  _class_apply_descriptor_set$r(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$g(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$g(obj, privateSet) {
  _check_private_redeclaration$t(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$h = "manualColumnResize";
const PLUGIN_PRIORITY$h = 130;
var _currentTH$1 = /* @__PURE__ */ new WeakMap(), _currentCol = /* @__PURE__ */ new WeakMap(), _selectedCols = /* @__PURE__ */ new WeakMap(), _currentWidth = /* @__PURE__ */ new WeakMap(), _newSize$1 = /* @__PURE__ */ new WeakMap(), _startY$1 = /* @__PURE__ */ new WeakMap(), _startWidth = /* @__PURE__ */ new WeakMap(), _startOffset$1 = /* @__PURE__ */ new WeakMap(), _horizontalScaleFactor = /* @__PURE__ */ new WeakMap(), _handle$1 = /* @__PURE__ */ new WeakMap(), _guide$1 = /* @__PURE__ */ new WeakMap(), _pressed$2 = /* @__PURE__ */ new WeakMap(), _isTriggeredByRMB$1 = /* @__PURE__ */ new WeakMap(), _dblclick$1 = /* @__PURE__ */ new WeakMap(), _autoresizeTimeout$1 = /* @__PURE__ */ new WeakMap(), _columnWidthsMap = /* @__PURE__ */ new WeakMap(), _disposeMapObserver$1 = /* @__PURE__ */ new WeakMap(), _config$1 = /* @__PURE__ */ new WeakMap(), _onMapInit$2 = /* @__PURE__ */ new WeakSet(), _onMouseOver$1 = /* @__PURE__ */ new WeakSet(), _onMouseDown$1 = /* @__PURE__ */ new WeakSet(), _onMouseMove$2 = /* @__PURE__ */ new WeakSet(), _onMouseUp$2 = /* @__PURE__ */ new WeakSet(), _onContextMenu$1 = /* @__PURE__ */ new WeakSet(), _onModifyColWidth$2 = /* @__PURE__ */ new WeakMap(), _onBeforeStretchingColumnWidth = /* @__PURE__ */ new WeakMap(), _onBeforeColumnResize = /* @__PURE__ */ new WeakMap();
class ManualColumnResize extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$h;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$h;
  }
  /**
  * @private
  * @returns {string}
  */
  get inlineDir() {
    return this.hot.isRtl() ? "right" : "left";
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ManualColumnResize#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$h];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_set$r(this, _columnWidthsMap, new PhysicalIndexToValueMap());
    _class_private_field_get$r(this, _columnWidthsMap).addLocalHook("init", () => _class_private_method_get$g(this, _onMapInit$2, onMapInit$1).call(this));
    this.hot.columnIndexMapper.registerMap(this.pluginName, _class_private_field_get$r(this, _columnWidthsMap));
    _class_private_field_set$r(this, _disposeMapObserver$1, this.hot.columnIndexMapper.observeMapChange(_class_private_field_get$r(this, _columnWidthsMap), () => {
      this.hot.view?.invalidateColumnWidthCache();
    }));
    this.addHook("modifyColWidth", _class_private_field_get$r(this, _onModifyColWidth$2), 1);
    this.addHook("beforeStretchingColumnWidth", _class_private_field_get$r(this, _onBeforeStretchingColumnWidth), 1);
    this.addHook("beforeColumnResize", _class_private_field_get$r(this, _onBeforeColumnResize));
    this.bindEvents();
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`manualColumnResize`](@/api/options.md#manualcolumnresize)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    if (_class_private_field_get$r(this, _disposeMapObserver$1)) {
      _class_private_field_get$r(this, _disposeMapObserver$1).call(this);
      _class_private_field_set$r(this, _disposeMapObserver$1, null);
    }
    _class_private_field_set$r(this, _config$1, _class_private_field_get$r(this, _columnWidthsMap).getValues());
    this.hot.columnIndexMapper.unregisterMap(this.pluginName);
    super.disablePlugin();
  }
  /**
  * Deprecated. The `PersistentState` plugin has been removed. This method is a no-op and will be removed in a
  * future major release.
  *
  * @deprecated
  */
  saveManualColumnWidths() {
    deprecatedWarn("`saveManualColumnWidths()` is deprecated and will be removed in a future major release. The PersistentState plugin has been removed.");
  }
  /**
  * Deprecated. The `PersistentState` plugin has been removed. This method is a no-op and will be removed in a
  * future major release.
  *
  * @deprecated
  * @returns {Array}
  */
  loadManualColumnWidths() {
    deprecatedWarn("`loadManualColumnWidths()` is deprecated and will be removed in a future major release. The PersistentState plugin has been removed.");
    return [];
  }
  /**
  * Sets the new width for specified column index.
  *
  * @param {number} column Visual column index.
  * @param {number} width Column width (no less than 20px).
  * @returns {number} Returns new width.
  */
  setManualSize(column, width) {
    const newWidth = Math.max(width, 20);
    const physicalColumn = this.hot.toPhysicalColumn(column);
    _class_private_field_get$r(this, _columnWidthsMap).setValueAtIndex(physicalColumn, newWidth);
    return newWidth;
  }
  /**
  * Clears the cache for the specified column index.
  *
  * @param {number} column Visual column index.
  */
  clearManualSize(column) {
    const physicalColumn = this.hot.toPhysicalColumn(column);
    _class_private_field_get$r(this, _columnWidthsMap).setValueAtIndex(physicalColumn, null);
  }
  /**
  * Set the resize handle position.
  *
  * @private
  * @param {HTMLCellElement} TH TH HTML element.
  */
  setupHandlePosition(TH) {
    if (shouldSkipResizeHandlePositioning(TH, _class_private_field_get$r(this, _dblclick$1))) {
      return;
    }
    _class_private_field_set$r(this, _currentTH$1, TH);
    const { _wt: wt } = this.hot.view;
    const cellCoords = wt.wtTable.getCoords(_class_private_field_get$r(this, _currentTH$1));
    if (!cellCoords) {
      return;
    }
    const col = cellCoords.col;
    if (col === null || col < 0) {
      return;
    }
    const headerHeight = outerHeight(_class_private_field_get$r(this, _currentTH$1));
    const fixedColumn = col < wt.getSetting("fixedColumnsStart");
    let relativeHeaderPosition;
    const coordRow = cellCoords.row ?? 0;
    const coordCol = cellCoords.col ?? 0;
    if (fixedColumn) {
      relativeHeaderPosition = wt.wtOverlays.topInlineStartCornerOverlay.getRelativeCellPosition(_class_private_field_get$r(this, _currentTH$1), coordRow, coordCol);
    }
    if (!relativeHeaderPosition) {
      relativeHeaderPosition = wt.wtOverlays.topOverlay.getRelativeCellPosition(_class_private_field_get$r(this, _currentTH$1), coordRow, coordCol);
    }
    _class_private_field_set$r(this, _currentCol, this.hot.columnIndexMapper.getVisualFromRenderableIndex(col));
    _class_private_field_set$r(this, _selectedCols, []);
    const isFullColumnSelected = this.hot.selection.isSelectedByCorner() || this.hot.selection.isSelectedByColumnHeader();
    if (this.hot.selection.isSelected() && isFullColumnSelected) {
      const selectionRanges = this.hot.getSelectedRange() ?? [];
      arrayEach(selectionRanges, (selectionRange) => {
        const fromColumn = selectionRange.getTopStartCorner().col;
        const toColumn = selectionRange.getBottomEndCorner().col;
        if (fromColumn === null || toColumn === null) {
          return;
        }
        rangeEach(fromColumn, toColumn, (columnIndex) => {
          if (!_class_private_field_get$r(this, _selectedCols).includes(columnIndex)) {
            _class_private_field_get$r(this, _selectedCols).push(columnIndex);
          }
        });
      });
    }
    if (_class_private_field_get$r(this, _currentCol) === null) {
      return;
    }
    if (!_class_private_field_get$r(this, _selectedCols).includes(_class_private_field_get$r(this, _currentCol))) {
      _class_private_field_set$r(this, _selectedCols, [
        _class_private_field_get$r(this, _currentCol)
      ]);
    }
    if (!relativeHeaderPosition) {
      return;
    }
    _class_private_field_set$r(this, _startOffset$1, relativeHeaderPosition.start - 6);
    _class_private_field_set$r(this, _startWidth, outerWidth(_class_private_field_get$r(this, _currentTH$1)));
    _class_private_field_set$r(this, _horizontalScaleFactor, getElementScaleFactor(_class_private_field_get$r(this, _currentTH$1)));
    _class_private_field_get$r(this, _handle$1).style.top = `${relativeHeaderPosition.top}px`;
    _class_private_field_get$r(this, _handle$1).style[this.inlineDir] = `${_class_private_field_get$r(this, _startOffset$1) + _class_private_field_get$r(this, _startWidth)}px`;
    _class_private_field_get$r(this, _handle$1).style.height = `${headerHeight}px`;
    this.hot.rootElement.appendChild(_class_private_field_get$r(this, _handle$1));
  }
  /**
  * Refresh the resize handle position.
  *
  * @private
  */
  refreshHandlePosition() {
    _class_private_field_get$r(this, _handle$1).style[this.inlineDir] = `${(_class_private_field_get$r(this, _startOffset$1) ?? 0) + (_class_private_field_get$r(this, _currentWidth) ?? 0)}px`;
  }
  /**
  * Sets the resize guide position.
  *
  * @private
  */
  setupGuidePosition() {
    const handleHeight = outerHeight(_class_private_field_get$r(this, _handle$1));
    const handleBottomPosition = Number.parseInt(_class_private_field_get$r(this, _handle$1).style.top, 10) + handleHeight;
    const tableHeight = this.hot.view.getTableHeight();
    addClass(_class_private_field_get$r(this, _handle$1), "active");
    addClass(_class_private_field_get$r(this, _guide$1), "active");
    _class_private_field_get$r(this, _guide$1).style.top = `${handleBottomPosition}px`;
    this.refreshGuidePosition();
    _class_private_field_get$r(this, _guide$1).style.height = `${tableHeight - handleHeight}px`;
    this.hot.rootElement.appendChild(_class_private_field_get$r(this, _guide$1));
  }
  /**
  * Refresh the resize guide position.
  *
  * @private
  */
  refreshGuidePosition() {
    _class_private_field_get$r(this, _guide$1).style[this.inlineDir] = _class_private_field_get$r(this, _handle$1).style[this.inlineDir];
  }
  /**
  * Hides both the resize handle and resize guide.
  *
  * @private
  */
  hideHandleAndGuide() {
    removeClass(_class_private_field_get$r(this, _handle$1), "active");
    removeClass(_class_private_field_get$r(this, _guide$1), "active");
  }
  /**
  * Checks if provided element is considered a column header.
  *
  * @private
  * @param {HTMLElement} element HTML element.
  * @returns {boolean}
  */
  checkIfColumnHeader(element) {
    const thead = closest(element, [
      "THEAD"
    ], this.hot.rootElement);
    const { topOverlay, topInlineStartCornerOverlay } = this.hot.view._wt.wtOverlays;
    return [
      topOverlay.clone.wtTable.THEAD,
      topInlineStartCornerOverlay.clone.wtTable.THEAD
    ].includes(thead);
  }
  /**
  * Gets the TH element from the provided element.
  *
  * @private
  * @param {HTMLElement} element HTML element.
  * @returns {HTMLElement}
  */
  getClosestTHParent(element) {
    if (element.tagName !== "TABLE") {
      if (element.tagName === "TH") {
        return element;
      }
      return this.getClosestTHParent(element.parentNode);
    }
    return null;
  }
  /**
  * Auto-size row after doubleclick - callback.
  *
  * @private
  * @fires Hooks#beforeColumnResize
  * @fires Hooks#afterColumnResize
  */
  afterMouseDownTimeout() {
    const shouldRefreshHandlePosition = shouldRefreshHandleAfterAutoResize(_class_private_field_get$r(this, _currentTH$1), _class_private_field_get$r(this, _dblclick$1));
    const render = () => {
      this.hot.view.adjustElementsSize();
      this.hot.render();
    };
    const resize = (column, forceRender) => {
      const hookNewSize = this.hot.runHooks("beforeColumnResize", _class_private_field_get$r(this, _newSize$1), column, true);
      if (hookNewSize === false) {
        return;
      }
      if (typeof hookNewSize === "number") {
        _class_private_field_set$r(this, _newSize$1, hookNewSize);
      }
      this.setManualSize(column, _class_private_field_get$r(this, _newSize$1) ?? 0);
      this.hot.runHooks("afterColumnResize", _class_private_field_get$r(this, _newSize$1), column, true);
      if (forceRender) {
        render();
      }
    };
    if (_class_private_field_get$r(this, _dblclick$1) >= 2) {
      const selectedColsLength = _class_private_field_get$r(this, _selectedCols).length;
      if (selectedColsLength > 1) {
        arrayEach(_class_private_field_get$r(this, _selectedCols), (selectedCol) => {
          resize(selectedCol);
        });
        render();
      } else {
        arrayEach(_class_private_field_get$r(this, _selectedCols), (selectedCol) => {
          resize(selectedCol, true);
        });
      }
    }
    _class_private_field_set$r(this, _autoresizeTimeout$1, null);
    _class_private_field_set$r(this, _dblclick$1, 0);
    if (shouldRefreshHandlePosition && _class_private_field_get$r(this, _currentTH$1)) {
      this.setupHandlePosition(_class_private_field_get$r(this, _currentTH$1));
    }
  }
  /**
  * Binds the mouse events.
  *
  * @private
  */
  bindEvents() {
    const { rootWindow, rootElement } = this.hot;
    this.eventManager.addEventListener(rootElement, "mouseover", (e) => _class_private_method_get$g(this, _onMouseOver$1, onMouseOver$1).call(this, e));
    this.eventManager.addEventListener(rootElement, "mousedown", (e) => _class_private_method_get$g(this, _onMouseDown$1, onMouseDown$1).call(this, e));
    this.eventManager.addEventListener(rootWindow, "mousemove", (e) => _class_private_method_get$g(this, _onMouseMove$2, onMouseMove$2).call(this, e));
    this.eventManager.addEventListener(rootWindow, "mouseup", () => _class_private_method_get$g(this, _onMouseUp$2, onMouseUp$2).call(this));
    this.eventManager.addEventListener(_class_private_field_get$r(this, _handle$1), "contextmenu", () => _class_private_method_get$g(this, _onContextMenu$1, onContextMenu$1).call(this));
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  /**
  * Initializes the plugin and applies CSS classes to the resize handle and guide elements.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$g(this, _onMapInit$2), _class_private_method_init$g(this, _onMouseOver$1), _class_private_method_init$g(this, _onMouseDown$1), _class_private_method_init$g(this, _onMouseMove$2), _class_private_method_init$g(this, _onMouseUp$2), _class_private_method_init$g(this, _onContextMenu$1), _class_private_field_init$r(this, _currentTH$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _currentCol, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _selectedCols, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _currentWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _newSize$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _startY$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _startWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _startOffset$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _horizontalScaleFactor, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _handle$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _guide$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _pressed$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _isTriggeredByRMB$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _dblclick$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _autoresizeTimeout$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _columnWidthsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _disposeMapObserver$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _config$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _onModifyColWidth$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _onBeforeStretchingColumnWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$r(this, _onBeforeColumnResize, {
      writable: true,
      value: void 0
    }), _class_private_field_set$r(this, _currentTH$1, null), _class_private_field_set$r(this, _currentCol, null), _class_private_field_set$r(this, _selectedCols, []), _class_private_field_set$r(this, _currentWidth, null), _class_private_field_set$r(this, _newSize$1, null), _class_private_field_set$r(this, _startY$1, null), _class_private_field_set$r(this, _startWidth, null), _class_private_field_set$r(this, _startOffset$1, null), _class_private_field_set$r(this, _horizontalScaleFactor, 1), _class_private_field_set$r(this, _handle$1, this.hot.rootDocument.createElement("DIV")), _class_private_field_set$r(this, _guide$1, this.hot.rootDocument.createElement("DIV")), _class_private_field_set$r(this, _pressed$2, null), _class_private_field_set$r(this, _isTriggeredByRMB$1, false), _class_private_field_set$r(this, _dblclick$1, 0), _class_private_field_set$r(this, _autoresizeTimeout$1, null), _class_private_field_set$r(this, _disposeMapObserver$1, null), _class_private_field_set$r(this, _onModifyColWidth$2, (width, column) => {
      let newWidth = width;
      if (this.enabled) {
        const physicalColumn = this.hot.toPhysicalColumn(column);
        const columnWidth = _class_private_field_get$r(this, _columnWidthsMap).getValueAtIndex(physicalColumn);
        if (this.hot.getSettings()[PLUGIN_KEY$h] && columnWidth) {
          newWidth = columnWidth;
        }
      }
      return newWidth;
    }), _class_private_field_set$r(this, _onBeforeStretchingColumnWidth, (stretchedWidth, column) => {
      const width = _class_private_field_get$r(this, _columnWidthsMap).getValueAtIndex(this.hot.toPhysicalColumn(column));
      if (typeof width === "number") {
        return width;
      }
      return stretchedWidth;
    }), _class_private_field_set$r(this, _onBeforeColumnResize, () => {
      this.hot.view._wt.wtViewport.resetHasOversizedColumnHeadersMarked();
    });
    addClass(_class_private_field_get$r(this, _handle$1), "manualColumnResizer");
    addClass(_class_private_field_get$r(this, _guide$1), "manualColumnResizerGuide");
  }
}
function onMapInit$1() {
  const initialSetting = this.hot.getSettings()[PLUGIN_KEY$h];
  if (Array.isArray(initialSetting)) {
    this.hot.batchExecution(() => {
      initialSetting.forEach((width, physicalIndex) => {
        _class_private_field_get$r(this, _columnWidthsMap).setValueAtIndex(physicalIndex, width);
      });
    }, true);
    _class_private_field_set$r(this, _config$1, initialSetting);
  } else if (initialSetting === true && Array.isArray(_class_private_field_get$r(this, _config$1))) {
    this.hot.batchExecution(() => {
      _class_private_field_get$r(this, _config$1).forEach((width, physicalIndex) => {
        _class_private_field_get$r(this, _columnWidthsMap).setValueAtIndex(physicalIndex, width);
      });
    }, true);
  }
}
function onMouseOver$1(event) {
  if (isDetached(eventTargetEl(event))) {
    return;
  }
  if (_class_private_field_get$r(this, _isTriggeredByRMB$1) === true) {
    return;
  }
  if (this.checkIfColumnHeader(eventTargetEl(event))) {
    const th = this.getClosestTHParent(eventTargetEl(event));
    if (!th) {
      return;
    }
    const colspan = th.getAttribute("colspan");
    if (th && (colspan === null || colspan === "1")) {
      if (!_class_private_field_get$r(this, _pressed$2)) {
        this.setupHandlePosition(th);
      }
    }
  }
}
function onMouseDown$1(event) {
  if (eventTargetEl(event).parentNode !== this.hot.rootElement) {
    return;
  }
  if (hasClass(eventTargetEl(event), "manualColumnResizer") && _class_private_field_get$r(this, _currentTH$1)) {
    this.setupHandlePosition(_class_private_field_get$r(this, _currentTH$1));
    this.setupGuidePosition();
    _class_private_field_set$r(this, _pressed$2, true);
    if (_class_private_field_get$r(this, _autoresizeTimeout$1) === null) {
      _class_private_field_set$r(this, _autoresizeTimeout$1, this.hot._registerTimeout(() => this.afterMouseDownTimeout(), 500));
    }
    _class_private_field_set$r(this, _dblclick$1, _class_private_field_get$r(this, _dblclick$1) + 1);
    this.startX = event.pageX;
    _class_private_field_set$r(this, _newSize$1, _class_private_field_get$r(this, _startWidth));
  }
}
function onMouseMove$2(event) {
  if (_class_private_field_get$r(this, _pressed$2)) {
    const visualChange = (event.pageX - this.startX) * this.hot.getDirectionFactor();
    const change = normalizeVisualDelta(visualChange, _class_private_field_get$r(this, _horizontalScaleFactor));
    _class_private_field_set$r(this, _currentWidth, (_class_private_field_get$r(this, _startWidth) ?? 0) + change);
    arrayEach(_class_private_field_get$r(this, _selectedCols), (selectedCol) => {
      _class_private_field_set$r(this, _newSize$1, this.setManualSize(selectedCol, _class_private_field_get$r(this, _currentWidth) ?? 0));
    });
    this.refreshHandlePosition();
    this.refreshGuidePosition();
  }
}
function onMouseUp$2() {
  const render = () => {
    this.hot.view.adjustElementsSize();
    this.hot.render();
  };
  const resize = (column, forceRender) => {
    const hookNewSize = this.hot.runHooks("beforeColumnResize", _class_private_field_get$r(this, _newSize$1), column, false);
    if (hookNewSize === false) {
      this.setManualSize(column, _class_private_field_get$r(this, _startWidth) ?? 0);
      _class_private_field_set$r(this, _newSize$1, _class_private_field_get$r(this, _startWidth));
    } else if (typeof hookNewSize === "number") {
      _class_private_field_set$r(this, _newSize$1, hookNewSize);
      this.setManualSize(column, _class_private_field_get$r(this, _newSize$1));
    }
    if (forceRender) {
      render();
    }
    if (hookNewSize !== false) {
      this.hot.runHooks("afterColumnResize", _class_private_field_get$r(this, _newSize$1), column, false);
    }
  };
  if (_class_private_field_get$r(this, _pressed$2)) {
    this.hideHandleAndGuide();
    _class_private_field_set$r(this, _pressed$2, false);
    if (_class_private_field_get$r(this, _newSize$1) !== _class_private_field_get$r(this, _startWidth)) {
      const selectedColsLength = _class_private_field_get$r(this, _selectedCols).length;
      if (selectedColsLength > 1) {
        arrayEach(_class_private_field_get$r(this, _selectedCols), (selectedCol) => {
          resize(selectedCol);
        });
        render();
      } else {
        arrayEach(_class_private_field_get$r(this, _selectedCols), (selectedCol) => {
          resize(selectedCol, true);
        });
      }
    }
    if (_class_private_field_get$r(this, _currentTH$1)) {
      this.setupHandlePosition(_class_private_field_get$r(this, _currentTH$1));
    }
  }
}
function onContextMenu$1() {
  this.hideHandleAndGuide();
  this.hot.rootElement.removeChild(_class_private_field_get$r(this, _handle$1));
  this.hot.rootElement.removeChild(_class_private_field_get$r(this, _guide$1));
  _class_private_field_set$r(this, _pressed$2, false);
  _class_private_field_set$r(this, _isTriggeredByRMB$1, true);
  this.hot._registerMicrotask(() => {
    _class_private_field_set$r(this, _isTriggeredByRMB$1, false);
  });
}
const STATE_INITIALIZED = 0;
const STATE_BUILT = 1;
const STATE_APPENDED = 2;
const UNIT = "px";
let BaseUI$1 = class BaseUI3 {
  /**
  * Add created UI elements to table.
  *
  * @param {HTMLElement} wrapper Element which are parent for our UI element.
  */
  appendTo(wrapper) {
    wrapper.appendChild(this._element);
    this.state = STATE_APPENDED;
  }
  /**
  * Method for create UI element. Only create, without append to table.
  */
  build() {
    if (this.state !== STATE_INITIALIZED) {
      return;
    }
    this._element = this.hot.rootDocument.createElement("div");
    this.state = STATE_BUILT;
  }
  /**
  * Method for remove UI element.
  */
  destroy() {
    if (this.isAppended()) {
      this._element.parentElement?.removeChild(this._element);
    }
    this._element = null;
    this.state = STATE_INITIALIZED;
  }
  /**
  * Check if UI element are appended.
  *
  * @returns {boolean}
  */
  isAppended() {
    return this.state === STATE_APPENDED;
  }
  /**
  * Check if UI element are built.
  *
  * @returns {boolean}
  */
  isBuilt() {
    return this.state >= STATE_BUILT;
  }
  /**
  * Setter for position.
  *
  * @param {number} top New top position of the element.
  * @param {number} left New left position of the element.
  */
  setPosition(top2, left2) {
    if (top2 !== null && top2 !== void 0) {
      this._element.style.top = top2 + UNIT;
    }
    if (left2 !== null && left2 !== void 0) {
      this._element.style.left = left2 + UNIT;
    }
  }
  /**
  * Getter for the element position.
  *
  * @returns {object} Object contains left and top position of the element.
  */
  getPosition() {
    return {
      top: this._element.style.top ? Number.parseInt(this._element.style.top, 10) : 0,
      left: this._element.style.left ? Number.parseInt(this._element.style.left, 10) : 0
    };
  }
  /**
  * Setter for the element size.
  *
  * @param {number} width New width of the element.
  * @param {number} height New height of the element.
  */
  setSize(width, height) {
    if (width) {
      this._element.style.width = width + UNIT;
    }
    if (height) {
      this._element.style.height = height + UNIT;
    }
  }
  /**
  * Getter for the element position.
  *
  * @returns {object} Object contains height and width of the element.
  */
  getSize() {
    return {
      width: this._element.style.width ? Number.parseInt(this._element.style.width, 10) : 0,
      height: this._element.style.height ? Number.parseInt(this._element.style.height, 10) : 0
    };
  }
  /**
  * Setter for the element offset. Offset means marginTop and marginLeft of the element.
  *
  * @param {number} top New margin top of the element.
  * @param {number} left New margin left of the element.
  */
  setOffset(top2, left2) {
    if (top2) {
      this._element.style.marginTop = top2 + UNIT;
    }
    if (left2) {
      this._element.style.marginLeft = left2 + UNIT;
    }
  }
  /**
  * Getter for the element offset.
  *
  * @returns {object} Object contains top and left offset of the element.
  */
  getOffset() {
    return {
      top: this._element.style.marginTop ? Number.parseInt(this._element.style.marginTop, 10) : 0,
      left: this._element.style.marginLeft ? Number.parseInt(this._element.style.marginLeft, 10) : 0
    };
  }
  /**
  * Initializes the base row-move UI element with a reference to the Handsontable instance.
  */
  constructor(hotInstance) {
    this._element = null;
    this.state = STATE_INITIALIZED;
    this.hot = hotInstance;
  }
};
const CSS_CLASSNAME$1 = "ht__manualRowMove--backlight";
class BacklightUI2 extends BaseUI$1 {
  /**
  * Custom className on build process.
  */
  build() {
    super.build();
    addClass(this._element, CSS_CLASSNAME$1);
  }
}
const CSS_CLASSNAME = "ht__manualRowMove--guideline";
class GuidelineUI2 extends BaseUI$1 {
  /**
  * Custom className on build process.
  */
  build() {
    super.build();
    addClass(this._element, CSS_CLASSNAME);
  }
}
function _check_private_redeclaration$s(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$q(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$q(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$q(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$q(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$q(receiver, privateMap, "get");
  return _class_apply_descriptor_get$q(receiver, descriptor);
}
function _class_private_field_init$q(obj, privateMap, value) {
  _check_private_redeclaration$s(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$q(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$q(receiver, privateMap, "set");
  _class_apply_descriptor_set$q(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$f(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$f(obj, privateSet) {
  _check_private_redeclaration$s(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("beforeRowMove");
Hooks.getSingleton().register("afterRowMove");
const PLUGIN_KEY$g = "manualRowMove";
const PLUGIN_PRIORITY$g = 140;
const CSS_PLUGIN = "ht__manualRowMove";
const CSS_SHOW_UI = "show-ui";
const CSS_ON_MOVING = "on-moving--rows";
const CSS_AFTER_SELECTION = "after-selection--rows";
var _backlight = /* @__PURE__ */ new WeakMap(), _guideline = /* @__PURE__ */ new WeakMap(), _rowsToMove = /* @__PURE__ */ new WeakMap(), _pressed$1 = /* @__PURE__ */ new WeakMap(), _target = /* @__PURE__ */ new WeakMap(), _cachedDropIndex = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseDown$2 = /* @__PURE__ */ new WeakMap(), _onMouseMove$1 = /* @__PURE__ */ new WeakSet(), _onBeforeOnCellMouseOver$1 = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseOverOutside = /* @__PURE__ */ new WeakSet(), _onMouseUp$1 = /* @__PURE__ */ new WeakSet(), _onAfterScrollHorizontally = /* @__PURE__ */ new WeakMap(), _onAfterLoadData$1 = /* @__PURE__ */ new WeakMap();
class ManualRowMove extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$g;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$g;
  }
  /**
  * Returns the list of settings keys observed by the plugin for configuration changes.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$g
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ManualRowMove#enablePlugin} method is called.
  * When [[Options#dataProvider]] is a complete server-backed configuration, the DataProvider plugin blocks this plugin from enabling.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$g];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$q(this, _onBeforeOnCellMouseDown$2));
    this.addHook("beforeOnCellMouseOver", _class_private_field_get$q(this, _onBeforeOnCellMouseOver$1));
    this.addHook("beforeOnCellMouseOverOutside", (event, coords, TD, controller) => _class_private_method_get$f(this, _onBeforeOnCellMouseOverOutside, onBeforeOnCellMouseOverOutside).call(this, controller));
    this.addHook("afterScrollHorizontally", _class_private_field_get$q(this, _onAfterScrollHorizontally));
    this.addHook("afterLoadData", _class_private_field_get$q(this, _onAfterLoadData$1));
    this.buildPluginUI();
    this.registerEvents();
    addClass(this.hot.rootElement, CSS_PLUGIN);
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`manualRowMove`](@/api/options.md#manualrowmove)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    this.moveBySettingsOrLoad();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    removeClass(this.hot.rootElement, CSS_PLUGIN);
    this.unregisterEvents();
    _class_private_field_get$q(this, _backlight).destroy();
    _class_private_field_get$q(this, _guideline).destroy();
    super.disablePlugin();
  }
  /**
  * Moves a single row.
  *
  * To see the outcome, rerender your grid by calling [`render()`](@/api/core.md#render).
  *
  * @param {number} row Visual row index to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/rows/row-moving/row-moving.md#drag-and-move-actions-of-manualrowmove-plugin).
  * @fires Hooks#beforeRowMove
  * @fires Hooks#afterRowMove
  * @returns {boolean}
  */
  moveRow(row, finalIndex) {
    return this.moveRows([
      row
    ], finalIndex);
  }
  /**
  * Moves multiple rows.
  *
  * To see the outcome, rerender your grid by calling [`render()`](@/api/core.md#render).
  *
  * @param {Array} rows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/rows/row-moving/row-moving.md#drag-and-move-actions-of-manualrowmove-plugin).
  * @fires Hooks#beforeRowMove
  * @fires Hooks#afterRowMove
  * @returns {boolean}
  */
  moveRows(rows, finalIndex) {
    const dropIndex = _class_private_field_get$q(this, _cachedDropIndex);
    const movePossible = this.isMovePossible(rows, finalIndex);
    const beforeMoveHook = this.hot.runHooks("beforeRowMove", rows, finalIndex, dropIndex, movePossible);
    _class_private_field_set$q(this, _cachedDropIndex, void 0);
    if (beforeMoveHook === false) {
      return false;
    }
    if (movePossible) {
      this.hot.rowIndexMapper.moveIndexes(rows, finalIndex);
    }
    const movePerformed = movePossible && this.isRowOrderChanged(rows, finalIndex);
    this.hot.runHooks("afterRowMove", rows, finalIndex, dropIndex, movePossible, movePerformed);
    return movePerformed;
  }
  /**
  * Drag a single row to drop index position.
  *
  * @param {number} row Visual row index to be dragged.
  * @param {number} dropIndex Visual row index, being a drop index for the moved rows. Points to where we are going to drop the moved elements.
  * To check visualization of drop index please take a look at [documentation](@/guides/rows/row-moving/row-moving.md#drag-and-move-actions-of-manualrowmove-plugin).
  * @fires Hooks#beforeRowMove
  * @fires Hooks#afterRowMove
  * @returns {boolean}
  */
  dragRow(row, dropIndex) {
    return this.dragRows([
      row
    ], dropIndex);
  }
  /**
  * Drag multiple rows to drop index position.
  *
  * @param {Array} rows Array of visual row indexes to be dragged.
  * @param {number} dropIndex Visual row index, being a drop index for the moved rows. Points to where we are going to drop the moved elements.
  * To check visualization of drop index please take a look at [documentation](@/guides/rows/row-moving/row-moving.md#drag-and-move-actions-of-manualrowmove-plugin).
  * @fires Hooks#beforeRowMove
  * @fires Hooks#afterRowMove
  * @returns {boolean}
  */
  dragRows(rows, dropIndex) {
    const finalIndex = this.countFinalIndex(rows, dropIndex);
    _class_private_field_set$q(this, _cachedDropIndex, dropIndex);
    return this.moveRows(rows, finalIndex);
  }
  /**
  * Indicates if it's possible to move rows to the desired position. Some of the actions aren't possible, i.e. You can’t move more than one element to the last position.
  *
  * @param {Array} movedRows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/rows/row-moving/row-moving.md#drag-and-move-actions-of-manualrowmove-plugin).
  * @returns {boolean}
  */
  isMovePossible(movedRows, finalIndex) {
    const length = this.hot.rowIndexMapper.getNotTrimmedIndexesLength();
    const tooHighDestinationIndex = movedRows.length + finalIndex > length;
    const tooLowDestinationIndex = finalIndex < 0;
    const tooLowMovedRowIndex = movedRows.some((movedRow) => movedRow < 0);
    const tooHighMovedRowIndex = movedRows.some((movedRow) => movedRow >= length);
    if (tooHighDestinationIndex || tooLowDestinationIndex || tooLowMovedRowIndex || tooHighMovedRowIndex) {
      return false;
    }
    return true;
  }
  /**
  * Indicates if order of rows was changed.
  *
  * @private
  * @param {Array} movedRows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows. Points to where the elements will be placed after the moving action.
  * To check the visualization of the final index, please take a look at [documentation](@/guides/rows/row-moving/row-moving.md#drag-and-move-actions-of-manualrowmove-plugin).
  * @returns {boolean}
  */
  isRowOrderChanged(movedRows, finalIndex) {
    return movedRows.some((row, nrOfMovedElement) => row - nrOfMovedElement !== finalIndex);
  }
  /**
  * Count the final row index from the drop index.
  *
  * @private
  * @param {Array} movedRows Array of visual row indexes to be moved.
  * @param {number} dropIndex Visual row index, being a drop index for the moved rows.
  * @returns {number} Visual row index, being a start index for the moved rows.
  */
  countFinalIndex(movedRows, dropIndex) {
    const numberOfRowsLowerThanDropIndex = arrayReduce(movedRows, (acc, currentRowIndex) => {
      if (currentRowIndex < dropIndex) {
        return acc + 1;
      }
      return acc;
    }, 0);
    return dropIndex - numberOfRowsLowerThanDropIndex;
  }
  /**
  * Gets the sum of the heights of rows in the provided range.
  *
  * @private
  * @param {number} fromRow Visual row index.
  * @param {number} toRow Visual row index.
  * @returns {number}
  */
  getRowsHeight(fromRow, toRow) {
    const rowMapper = this.hot.rowIndexMapper;
    let rowsHeight = 0;
    for (let visualRowIndex = fromRow; visualRowIndex <= toRow; visualRowIndex++) {
      const renderableIndex = rowMapper.getRenderableFromVisualIndex(visualRowIndex);
      if (renderableIndex !== null) {
        const wt = this.hot.view._wt;
        const wtRowHeight = wt?.wtTable?.getRowHeight(renderableIndex);
        const rowHeight = wtRowHeight !== null && wtRowHeight !== void 0 ? wtRowHeight : 0;
        rowsHeight += rowHeight || (this.hot.stylesHandler.getDefaultRowHeight() ?? 0);
      }
    }
    return rowsHeight;
  }
  /**
  * Moves rows when the plugin was initialized as an array of row positions.
  *
  * @private
  */
  moveBySettingsOrLoad() {
    const pluginSettings = this.hot.getSettings()[PLUGIN_KEY$g];
    if (Array.isArray(pluginSettings)) {
      this.moveRows(pluginSettings, 0);
    }
  }
  /**
  * Checks if the provided row is in the fixedRowsTop section.
  *
  * @private
  * @param {number} row Visual row index to check.
  * @returns {boolean}
  */
  isFixedRowTop(row) {
    return row < (this.hot.getSettings().fixedRowsTop ?? 0);
  }
  /**
  * Checks if the provided row is in the fixedRowsBottom section.
  *
  * @private
  * @param {number} row Visual row index to check.
  * @returns {boolean}
  */
  isFixedRowBottom(row) {
    return row > this.hot.countRows() - 1 - (this.hot.getSettings().fixedRowsBottom ?? 0);
  }
  /**
  * Prepares an array of indexes based on actual selection.
  *
  * @private
  * @returns {Array}
  */
  prepareRowsToMoving() {
    const selection = this.hot.getSelectedRangeActive();
    const selectedRows = [];
    if (!selection) {
      return selectedRows;
    }
    const { from, to } = selection;
    const start = Math.min(from.row ?? 0, to.row ?? 0);
    const end = Math.max(from.row ?? 0, to.row ?? 0);
    rangeEach(start, end, (i) => {
      selectedRows.push(i);
    });
    return selectedRows;
  }
  /**
  * Update the UI visual position.
  *
  * @private
  */
  refreshPositions() {
    const coords = _class_private_field_get$q(this, _target).coords;
    const TD = _class_private_field_get$q(this, _target).TD;
    if (!coords || !TD) {
      return;
    }
    const firstVisible = this.hot.getFirstFullyVisibleRow();
    const lastVisible = this.hot.getLastFullyVisibleRow();
    const countRows = this.hot.countRows();
    if (this.isFixedRowTop(coords.row) && firstVisible > 0) {
      const nearestTop = this.hot.rowIndexMapper.getNearestNotHiddenIndex(firstVisible - 1, -1);
      if (nearestTop !== null) {
        this.hot.scrollViewportTo(nearestTop);
      }
    }
    if (this.isFixedRowBottom(coords.row) && lastVisible < countRows) {
      const nearestBottom = this.hot.rowIndexMapper.getNearestNotHiddenIndex(lastVisible + 1, 1);
      if (nearestBottom !== null) {
        this.hot.scrollViewportTo(nearestBottom, void 0, true);
      }
    }
    const wtTable = this.hot.view._wt.wtTable;
    const rootElement = this.hot.rootElement;
    const rootElementOffset = offset(rootElement);
    const trimmingContainer = getTrimmingContainer(rootElement);
    const tableScroll = wtTable.holder.scrollTop;
    const trimmingContainerScroll = trimmingContainer instanceof HTMLElement ? trimmingContainer.scrollTop : 0;
    const pixelsAbove = rootElementOffset.top - trimmingContainerScroll;
    const pixelsRelToTableStart = (_class_private_field_get$q(this, _target).eventPageY ?? 0) - pixelsAbove + tableScroll;
    const hiderHeight = wtTable.hider.offsetHeight;
    const tbodyOffsetTop = wtTable.TBODY?.offsetTop ?? 0;
    const backlightElemMarginTop = _class_private_field_get$q(this, _backlight).getOffset().top;
    const backlightElemHeight = _class_private_field_get$q(this, _backlight).getSize().height;
    const tdMiddle = TD.offsetHeight / 2;
    const tdHeight = TD.offsetHeight;
    let tdStartPixel = this.hot.view.THEAD.offsetHeight + this.getRowsHeight(0, coords.row - 1);
    const isBelowTable = pixelsRelToTableStart >= tdStartPixel + tdMiddle;
    if (this.isFixedRowTop(coords.row)) {
      tdStartPixel += this.hot.view._wt.wtOverlays.topOverlay.getOverlayOffset();
    }
    if (coords.row < 0) {
      _class_private_field_get$q(this, _target).row = firstVisible > 0 ? firstVisible - 1 : firstVisible;
    } else if (isBelowTable) {
      _class_private_field_get$q(this, _target).row = coords.row + 1;
      tdStartPixel += coords.row === 0 ? tdHeight - 1 : tdHeight;
    } else {
      _class_private_field_get$q(this, _target).row = coords.row;
    }
    let backlightTop = pixelsRelToTableStart;
    let guidelineTop = tdStartPixel;
    if (pixelsRelToTableStart + backlightElemHeight + backlightElemMarginTop >= hiderHeight) {
      backlightTop = hiderHeight - backlightElemHeight - backlightElemMarginTop;
    } else if (pixelsRelToTableStart + backlightElemMarginTop < tbodyOffsetTop) {
      backlightTop = tbodyOffsetTop + Math.abs(backlightElemMarginTop);
    }
    if (tdStartPixel >= hiderHeight - 1) {
      guidelineTop = hiderHeight - 1;
    }
    _class_private_field_get$q(this, _backlight).setPosition(backlightTop);
    _class_private_field_get$q(this, _guideline).setPosition(guidelineTop);
  }
  /**
  * Binds the events used by the plugin.
  *
  * @private
  */
  registerEvents() {
    const { documentElement } = this.hot.rootDocument;
    this.eventManager.addEventListener(documentElement, "mousemove", (event) => _class_private_method_get$f(this, _onMouseMove$1, onMouseMove$1).call(this, event));
    this.eventManager.addEventListener(documentElement, "mouseup", () => _class_private_method_get$f(this, _onMouseUp$1, onMouseUp$1).call(this));
  }
  /**
  * Unbinds the events used by the plugin.
  *
  * @private
  */
  unregisterEvents() {
    this.eventManager.clear();
  }
  /**
  * Builds the plugin's UI.
  *
  * @private
  */
  buildPluginUI() {
    _class_private_field_get$q(this, _backlight).build();
    _class_private_field_get$q(this, _guideline).build();
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$q(this, _backlight).destroy();
    _class_private_field_get$q(this, _guideline).destroy();
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$f(this, _onMouseMove$1), _class_private_method_init$f(this, _onBeforeOnCellMouseOverOutside), _class_private_method_init$f(this, _onMouseUp$1), /**
    * Backlight UI object.
    *
    * @type {object}
    */
    _class_private_field_init$q(this, _backlight, {
      writable: true,
      value: void 0
    }), /**
    * Guideline UI object.
    *
    * @type {object}
    */
    _class_private_field_init$q(this, _guideline, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _rowsToMove, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _pressed$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _target, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _cachedDropIndex, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _onBeforeOnCellMouseDown$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _onBeforeOnCellMouseOver$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _onAfterScrollHorizontally, {
      writable: true,
      value: void 0
    }), _class_private_field_init$q(this, _onAfterLoadData$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$q(this, _backlight, new BacklightUI2(this.hot)), _class_private_field_set$q(this, _guideline, new GuidelineUI2(this.hot)), _class_private_field_set$q(this, _rowsToMove, []), _class_private_field_set$q(this, _target, {}), _class_private_field_set$q(this, _onBeforeOnCellMouseDown$2, (event, coords, TD, controller) => {
      const { wtTable, wtViewport } = this.hot.view._wt;
      const isHeaderSelection = this.hot.selection.isSelectedByRowHeader();
      const selection = this.hot.getSelectedRangeActive();
      if (!selection || !isHeaderSelection || _class_private_field_get$q(this, _pressed$1) || event.button !== 0) {
        _class_private_field_set$q(this, _pressed$1, false);
        _class_private_field_get$q(this, _rowsToMove).length = 0;
        removeClass(this.hot.rootElement, [
          CSS_ON_MOVING,
          CSS_SHOW_UI
        ]);
        return;
      }
      const guidelineIsNotReady = _class_private_field_get$q(this, _guideline).isBuilt() && !_class_private_field_get$q(this, _guideline).isAppended();
      const backlightIsNotReady = _class_private_field_get$q(this, _backlight).isBuilt() && !_class_private_field_get$q(this, _backlight).isAppended();
      if (guidelineIsNotReady && backlightIsNotReady) {
        _class_private_field_get$q(this, _guideline).appendTo(wtTable.hider);
        _class_private_field_get$q(this, _backlight).appendTo(wtTable.hider);
      }
      const { from, to } = selection;
      const start = Math.min(from.row ?? 0, to.row ?? 0);
      const end = Math.max(from.row ?? 0, to.row ?? 0);
      if (coords.col < 0 && coords.row >= start && coords.row <= end) {
        controller.row = true;
        _class_private_field_set$q(this, _pressed$1, true);
        _class_private_field_get$q(this, _target).eventPageY = event.pageY;
        _class_private_field_get$q(this, _target).coords = coords;
        _class_private_field_get$q(this, _target).TD = TD;
        _class_private_field_set$q(this, _rowsToMove, this.prepareRowsToMoving());
        const leftPos = wtTable.holder.scrollLeft + wtViewport.getRowHeaderWidth();
        const topOffset = this.getRowsHeight(start, coords.row - 1) + (event.clientY - TD.getBoundingClientRect().top);
        _class_private_field_get$q(this, _backlight).setPosition(null, leftPos);
        _class_private_field_get$q(this, _backlight).setSize(wtTable.hider.offsetWidth - leftPos, this.getRowsHeight(start, end));
        _class_private_field_get$q(this, _backlight).setOffset(-topOffset, null);
        addClass(this.hot.rootElement, CSS_ON_MOVING);
        this.refreshPositions();
      } else {
        removeClass(this.hot.rootElement, CSS_AFTER_SELECTION);
        _class_private_field_set$q(this, _pressed$1, false);
        _class_private_field_get$q(this, _rowsToMove).length = 0;
      }
    }), _class_private_field_set$q(this, _onBeforeOnCellMouseOver$1, (_event, coords, TD, controller) => {
      const selectedRange = this.hot.getSelectedRangeActive();
      if (!selectedRange || !_class_private_field_get$q(this, _pressed$1)) {
        return;
      }
      if (_class_private_field_get$q(this, _rowsToMove).indexOf(coords.row) > -1) {
        removeClass(this.hot.rootElement, CSS_SHOW_UI);
      } else {
        addClass(this.hot.rootElement, CSS_SHOW_UI);
      }
      controller.row = true;
      controller.column = true;
      controller.cell = true;
      _class_private_field_get$q(this, _target).coords = coords;
      _class_private_field_get$q(this, _target).TD = TD;
    }), _class_private_field_set$q(this, _onAfterScrollHorizontally, () => {
      const wtTable = this.hot.view._wt.wtTable;
      const headerWidth = this.hot.view._wt.wtViewport.getRowHeaderWidth();
      const scrollLeft = wtTable.holder.scrollLeft;
      const posLeft = headerWidth + scrollLeft;
      _class_private_field_get$q(this, _backlight).setPosition(null, posLeft);
      _class_private_field_get$q(this, _backlight).setSize(wtTable.hider.offsetWidth - posLeft);
    }), _class_private_field_set$q(this, _onAfterLoadData$1, () => {
      this.moveBySettingsOrLoad();
    });
  }
}
function onMouseMove$1(event) {
  if (!_class_private_field_get$q(this, _pressed$1)) {
    return;
  }
  _class_private_field_get$q(this, _target).eventPageY = event.pageY;
  this.refreshPositions();
}
function onBeforeOnCellMouseOverOutside(controller) {
  if (!_class_private_field_get$q(this, _pressed$1)) {
    return;
  }
  controller.row = true;
  controller.column = true;
  controller.cell = true;
}
function onMouseUp$1() {
  const target = _class_private_field_get$q(this, _target).row;
  const rowsLen = _class_private_field_get$q(this, _rowsToMove).length;
  _class_private_field_set$q(this, _pressed$1, false);
  removeClass(this.hot.rootElement, [
    CSS_ON_MOVING,
    CSS_SHOW_UI,
    CSS_AFTER_SELECTION
  ]);
  if (this.hot.selection.isSelectedByRowHeader()) {
    addClass(this.hot.rootElement, CSS_AFTER_SELECTION);
  }
  if (rowsLen < 1 || target === void 0) {
    return;
  }
  const firstMovedVisualRow = _class_private_field_get$q(this, _rowsToMove)[0];
  const firstMovedPhysicalRow = this.hot.toPhysicalRow(firstMovedVisualRow);
  const movePerformed = this.dragRows(_class_private_field_get$q(this, _rowsToMove), target);
  _class_private_field_get$q(this, _rowsToMove).length = 0;
  if (movePerformed === true) {
    this.hot.view.adjustElementsSize();
    this.hot.render();
    const selectionStart = this.hot.toVisualRow(firstMovedPhysicalRow);
    const selectionEnd = selectionStart + rowsLen - 1;
    this.hot.selectRows(selectionStart, selectionEnd);
  }
}
function _check_private_redeclaration$r(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$p(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$p(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$p(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$p(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$p(receiver, privateMap, "get");
  return _class_apply_descriptor_get$p(receiver, descriptor);
}
function _class_private_field_init$p(obj, privateMap, value) {
  _check_private_redeclaration$r(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$p(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$p(receiver, privateMap, "set");
  _class_apply_descriptor_set$p(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$e(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$e(obj, privateSet) {
  _check_private_redeclaration$r(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$f = "manualRowResize";
const PLUGIN_PRIORITY$f = 30;
var _currentTH = /* @__PURE__ */ new WeakMap(), _currentRow = /* @__PURE__ */ new WeakMap(), _selectedRows = /* @__PURE__ */ new WeakMap(), _currentHeight = /* @__PURE__ */ new WeakMap(), _newSize = /* @__PURE__ */ new WeakMap(), _startY = /* @__PURE__ */ new WeakMap(), _startHeight = /* @__PURE__ */ new WeakMap(), _startOffset = /* @__PURE__ */ new WeakMap(), _verticalScaleFactor = /* @__PURE__ */ new WeakMap(), _handle = /* @__PURE__ */ new WeakMap(), _guide = /* @__PURE__ */ new WeakMap(), _pressed = /* @__PURE__ */ new WeakMap(), _isTriggeredByRMB = /* @__PURE__ */ new WeakMap(), _dblclick = /* @__PURE__ */ new WeakMap(), _autoresizeTimeout = /* @__PURE__ */ new WeakMap(), _rowHeightsMap = /* @__PURE__ */ new WeakMap(), _disposeMapObserver = /* @__PURE__ */ new WeakMap(), _config = /* @__PURE__ */ new WeakMap(), _onMouseOver = /* @__PURE__ */ new WeakSet(), _onMouseDown = /* @__PURE__ */ new WeakSet(), _onMouseMove = /* @__PURE__ */ new WeakSet(), _onMouseUp = /* @__PURE__ */ new WeakSet(), _onContextMenu = /* @__PURE__ */ new WeakSet(), _onModifyRowHeight = /* @__PURE__ */ new WeakMap(), _onMapInit$1 = /* @__PURE__ */ new WeakSet();
class ManualRowResize extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$f;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$f;
  }
  /**
  * @private
  * @returns {string}
  */
  get inlineDir() {
    return this.hot.isRtl() ? "right" : "left";
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link ManualRowResize#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$f];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_set$p(this, _rowHeightsMap, new PhysicalIndexToValueMap());
    _class_private_field_get$p(this, _rowHeightsMap).addLocalHook("init", () => _class_private_method_get$e(this, _onMapInit$1, onMapInit).call(this));
    this.hot.rowIndexMapper.registerMap(this.pluginName, _class_private_field_get$p(this, _rowHeightsMap));
    _class_private_field_set$p(this, _disposeMapObserver, this.hot.rowIndexMapper.observeMapChange(_class_private_field_get$p(this, _rowHeightsMap), () => {
      this.hot.view?.invalidateRowHeightCache();
    }));
    this.addHook("modifyRowHeight", _class_private_field_get$p(this, _onModifyRowHeight));
    this.bindEvents();
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`manualRowResize`](@/api/options.md#manualrowresize)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    if (_class_private_field_get$p(this, _disposeMapObserver)) {
      _class_private_field_get$p(this, _disposeMapObserver).call(this);
      _class_private_field_set$p(this, _disposeMapObserver, null);
    }
    _class_private_field_set$p(this, _config, _class_private_field_get$p(this, _rowHeightsMap).getValues());
    this.hot.rowIndexMapper.unregisterMap(this.pluginName);
    super.disablePlugin();
  }
  /**
  * Deprecated. The `PersistentState` plugin has been removed. This method is a no-op and will be removed in a
  * future major release.
  *
  * @deprecated
  */
  saveManualRowHeights() {
    deprecatedWarn("`saveManualRowHeights()` is deprecated and will be removed in a future major release. The PersistentState plugin has been removed.");
  }
  /**
  * Deprecated. The `PersistentState` plugin has been removed. This method is a no-op and will be removed in a
  * future major release.
  *
  * @deprecated
  * @returns {Array}
  */
  loadManualRowHeights() {
    deprecatedWarn("`loadManualRowHeights()` is deprecated and will be removed in a future major release. The PersistentState plugin has been removed.");
    return [];
  }
  /**
  * Sets the new height for specified row index.
  *
  * @param {number} row Visual row index.
  * @param {number} height Row height.
  * @returns {number} Returns new height.
  */
  setManualSize(row, height) {
    const physicalRow = this.hot.toPhysicalRow(row);
    const newHeight = Math.max(height, this.hot.stylesHandler.getDefaultRowHeight() ?? 0);
    if (physicalRow !== null) {
      _class_private_field_get$p(this, _rowHeightsMap).setValueAtIndex(physicalRow, newHeight);
    }
    return newHeight;
  }
  /**
  * Returns the last desired row height set manually with the resize handle.
  *
  * @returns {number} The last desired row height.
  */
  getLastDesiredRowHeight() {
    return _class_private_field_get$p(this, _currentHeight) ?? 0;
  }
  /**
  * Sets the resize handle position.
  *
  * @private
  * @param {HTMLCellElement} TH TH HTML element.
  */
  setupHandlePosition(TH) {
    if (shouldSkipResizeHandlePositioning(TH, _class_private_field_get$p(this, _dblclick))) {
      return;
    }
    _class_private_field_set$p(this, _currentTH, TH);
    const { view } = this.hot;
    const { _wt: wt } = view;
    const cellCoords = wt.wtTable.getCoords(_class_private_field_get$p(this, _currentTH));
    if (!cellCoords) {
      return;
    }
    const row = cellCoords.row;
    if (row === null || row < 0) {
      return;
    }
    const headerWidth = outerWidth(_class_private_field_get$p(this, _currentTH));
    const fixedRowTop = row < wt.getSetting("fixedRowsTop");
    const fixedRowBottom = row >= view.countNotHiddenRowIndexes(0, 1) - wt.getSetting("fixedRowsBottom");
    let relativeHeaderPosition;
    const coordRow = cellCoords.row ?? 0;
    const coordCol = cellCoords.col ?? 0;
    if (fixedRowTop) {
      relativeHeaderPosition = wt.wtOverlays.topInlineStartCornerOverlay.getRelativeCellPosition(_class_private_field_get$p(this, _currentTH), coordRow, coordCol);
    } else if (fixedRowBottom) {
      relativeHeaderPosition = wt.wtOverlays.bottomInlineStartCornerOverlay.getRelativeCellPosition(_class_private_field_get$p(this, _currentTH), coordRow, coordCol);
    }
    if (!relativeHeaderPosition) {
      relativeHeaderPosition = wt.wtOverlays.inlineStartOverlay.getRelativeCellPosition(_class_private_field_get$p(this, _currentTH), coordRow, coordCol);
    }
    _class_private_field_set$p(this, _currentRow, this.hot.rowIndexMapper.getVisualFromRenderableIndex(row));
    _class_private_field_set$p(this, _selectedRows, []);
    const isFullRowSelected = this.hot.selection.isSelectedByCorner() || this.hot.selection.isSelectedByRowHeader();
    if (this.hot.selection.isSelected() && isFullRowSelected) {
      const selectionRanges = this.hot.getSelectedRange() ?? [];
      arrayEach(selectionRanges, (selectionRange) => {
        const fromRow = selectionRange.getTopStartCorner().row;
        const toRow = selectionRange.getBottomStartCorner().row;
        if (fromRow === null || toRow === null) {
          return;
        }
        rangeEach(fromRow, toRow, (rowIndex) => {
          if (!_class_private_field_get$p(this, _selectedRows).includes(rowIndex)) {
            _class_private_field_get$p(this, _selectedRows).push(rowIndex);
          }
        });
      });
    }
    if (_class_private_field_get$p(this, _currentRow) === null) {
      return;
    }
    if (!_class_private_field_get$p(this, _selectedRows).includes(_class_private_field_get$p(this, _currentRow))) {
      _class_private_field_set$p(this, _selectedRows, [
        _class_private_field_get$p(this, _currentRow)
      ]);
    }
    if (!relativeHeaderPosition) {
      return;
    }
    _class_private_field_set$p(this, _startOffset, relativeHeaderPosition.top - 6);
    _class_private_field_set$p(this, _startHeight, outerHeight(_class_private_field_get$p(this, _currentTH)));
    _class_private_field_set$p(this, _verticalScaleFactor, getElementScaleFactor(_class_private_field_get$p(this, _currentTH), "vertical"));
    _class_private_field_get$p(this, _handle).style.top = `${_class_private_field_get$p(this, _startOffset) + _class_private_field_get$p(this, _startHeight)}px`;
    _class_private_field_get$p(this, _handle).style[this.inlineDir] = `${relativeHeaderPosition.start}px`;
    _class_private_field_get$p(this, _handle).style.width = `${headerWidth}px`;
    this.hot.rootElement.appendChild(_class_private_field_get$p(this, _handle));
  }
  /**
  * Refresh the resize handle position.
  *
  * @private
  */
  refreshHandlePosition() {
    _class_private_field_get$p(this, _handle).style.top = `${(_class_private_field_get$p(this, _startOffset) ?? 0) + (_class_private_field_get$p(this, _currentHeight) ?? 0)}px`;
  }
  /**
  * Sets the resize guide position.
  *
  * @private
  */
  setupGuidePosition() {
    const handleWidth = outerWidth(_class_private_field_get$p(this, _handle));
    const handleEndPosition = Number.parseInt(_class_private_field_get$p(this, _handle).style[this.inlineDir], 10) + handleWidth;
    const tableWidth = this.hot.view.getTableWidth();
    addClass(_class_private_field_get$p(this, _handle), "active");
    addClass(_class_private_field_get$p(this, _guide), "active");
    _class_private_field_get$p(this, _guide).style.top = _class_private_field_get$p(this, _handle).style.top;
    _class_private_field_get$p(this, _guide).style[this.inlineDir] = `${handleEndPosition}px`;
    _class_private_field_get$p(this, _guide).style.width = `${tableWidth - handleWidth}px`;
    this.hot.rootElement.appendChild(_class_private_field_get$p(this, _guide));
  }
  /**
  * Refresh the resize guide position.
  *
  * @private
  */
  refreshGuidePosition() {
    _class_private_field_get$p(this, _guide).style.top = _class_private_field_get$p(this, _handle).style.top;
  }
  /**
  * Hides both the resize handle and resize guide.
  *
  * @private
  */
  hideHandleAndGuide() {
    removeClass(_class_private_field_get$p(this, _handle), "active");
    removeClass(_class_private_field_get$p(this, _guide), "active");
  }
  /**
  * Checks if provided element is considered as a row header.
  *
  * @private
  * @param {HTMLElement} element HTML element.
  * @returns {boolean}
  */
  checkIfRowHeader(element) {
    const tbody = closest(element, [
      "TBODY"
    ], this.hot.rootElement);
    const { inlineStartOverlay, topInlineStartCornerOverlay, bottomInlineStartCornerOverlay } = this.hot.view._wt.wtOverlays;
    return [
      inlineStartOverlay.clone?.wtTable.TBODY,
      topInlineStartCornerOverlay.clone?.wtTable.TBODY,
      bottomInlineStartCornerOverlay.clone?.wtTable.TBODY
    ].includes(tbody);
  }
  /**
  * Gets the TH element from the provided element.
  *
  * @private
  * @param {HTMLElement} element HTML element.
  * @returns {HTMLElement}
  */
  getClosestTHParent(element) {
    if (element.tagName !== "TABLE") {
      if (element.tagName === "TH") {
        return element;
      }
      return this.getClosestTHParent(element.parentNode);
    }
    return null;
  }
  /**
  * Returns the actual height for the provided row index.
  *
  * @private
  * @param {number} row Visual row index.
  * @returns {number} Actual row height.
  */
  getActualRowHeight(row) {
    const walkontableHeight = this.hot.view._wt.wtTable.getRowHeight(row);
    if (walkontableHeight !== void 0 && _class_private_field_get$p(this, _newSize) !== null && _class_private_field_get$p(this, _newSize) < walkontableHeight) {
      return walkontableHeight;
    }
    return _class_private_field_get$p(this, _newSize);
  }
  /**
  * Auto-size row after doubleclick - callback.
  *
  * @private
  * @fires Hooks#beforeRowResize
  * @fires Hooks#afterRowResize
  */
  afterMouseDownTimeout() {
    const shouldRefreshHandlePosition = shouldRefreshHandleAfterAutoResize(_class_private_field_get$p(this, _currentTH), _class_private_field_get$p(this, _dblclick));
    const render = () => {
      this.hot.view.adjustElementsSize();
      this.hot.render();
    };
    const resize = (row, forceRender) => {
      const hookNewSize = this.hot.runHooks("beforeRowResize", this.getActualRowHeight(row), row, true);
      if (hookNewSize === false) {
        return;
      }
      if (typeof hookNewSize === "number") {
        _class_private_field_set$p(this, _newSize, hookNewSize);
      }
      this.setManualSize(row, _class_private_field_get$p(this, _newSize));
      this.hot.runHooks("afterRowResize", this.getActualRowHeight(row), row, true);
      if (forceRender) {
        render();
      }
    };
    if (_class_private_field_get$p(this, _dblclick) >= 2) {
      const selectedRowsLength = _class_private_field_get$p(this, _selectedRows).length;
      if (selectedRowsLength > 1) {
        arrayEach(_class_private_field_get$p(this, _selectedRows), (selectedRow) => {
          resize(selectedRow);
        });
        render();
      } else {
        arrayEach(_class_private_field_get$p(this, _selectedRows), (selectedRow) => {
          resize(selectedRow, true);
        });
      }
    }
    _class_private_field_set$p(this, _autoresizeTimeout, null);
    _class_private_field_set$p(this, _dblclick, 0);
    if (shouldRefreshHandlePosition && _class_private_field_get$p(this, _currentTH)) {
      this.setupHandlePosition(_class_private_field_get$p(this, _currentTH));
    }
  }
  /**
  * Binds the mouse events.
  *
  * @private
  */
  bindEvents() {
    const { rootElement, rootWindow } = this.hot;
    this.eventManager.addEventListener(rootElement, "mouseover", (e) => _class_private_method_get$e(this, _onMouseOver, onMouseOver).call(this, e));
    this.eventManager.addEventListener(rootElement, "mousedown", (e) => _class_private_method_get$e(this, _onMouseDown, onMouseDown).call(this, e));
    this.eventManager.addEventListener(rootWindow, "mousemove", (e) => _class_private_method_get$e(this, _onMouseMove, onMouseMove).call(this, e));
    this.eventManager.addEventListener(rootWindow, "mouseup", () => _class_private_method_get$e(this, _onMouseUp, onMouseUp).call(this));
    this.eventManager.addEventListener(_class_private_field_get$p(this, _handle), "contextmenu", () => _class_private_method_get$e(this, _onContextMenu, onContextMenu).call(this));
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  /**
  * Initializes the plugin and applies CSS classes to the resize handle and guide elements.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_method_init$e(this, _onMouseOver), _class_private_method_init$e(this, _onMouseDown), _class_private_method_init$e(this, _onMouseMove), _class_private_method_init$e(this, _onMouseUp), _class_private_method_init$e(this, _onContextMenu), _class_private_method_init$e(this, _onMapInit$1), _class_private_field_init$p(this, _currentTH, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _currentRow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _selectedRows, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _currentHeight, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _newSize, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _startY, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _startHeight, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _startOffset, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _verticalScaleFactor, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _handle, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _guide, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _pressed, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _isTriggeredByRMB, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _dblclick, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _autoresizeTimeout, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _rowHeightsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _disposeMapObserver, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _config, {
      writable: true,
      value: void 0
    }), _class_private_field_init$p(this, _onModifyRowHeight, {
      writable: true,
      value: void 0
    }), _class_private_field_set$p(this, _currentTH, null), _class_private_field_set$p(this, _currentRow, null), _class_private_field_set$p(this, _selectedRows, []), _class_private_field_set$p(this, _currentHeight, null), _class_private_field_set$p(this, _newSize, null), _class_private_field_set$p(this, _startY, null), _class_private_field_set$p(this, _startHeight, null), _class_private_field_set$p(this, _startOffset, null), _class_private_field_set$p(this, _verticalScaleFactor, 1), _class_private_field_set$p(this, _handle, this.hot.rootDocument.createElement("DIV")), _class_private_field_set$p(this, _guide, this.hot.rootDocument.createElement("DIV")), _class_private_field_set$p(this, _pressed, false), _class_private_field_set$p(this, _isTriggeredByRMB, false), _class_private_field_set$p(this, _dblclick, 0), _class_private_field_set$p(this, _autoresizeTimeout, null), _class_private_field_set$p(this, _disposeMapObserver, null), _class_private_field_set$p(this, _onModifyRowHeight, (height, row) => {
      let newHeight = height;
      if (this.enabled) {
        const physicalRow = this.hot.toPhysicalRow(row);
        const rowHeight = _class_private_field_get$p(this, _rowHeightsMap).getValueAtIndex(physicalRow);
        if (this.hot.getSettings()[PLUGIN_KEY$f] && rowHeight) {
          if (this.hot.getPlugin("autoRowSize")?.isEnabled()) {
            newHeight = Math.max(rowHeight, newHeight ?? 0);
          } else {
            newHeight = rowHeight;
          }
        }
      }
      return newHeight;
    });
    addClass(_class_private_field_get$p(this, _handle), "manualRowResizer");
    addClass(_class_private_field_get$p(this, _guide), "manualRowResizerGuide");
  }
}
function onMouseOver(event) {
  if (isDetached(eventTargetEl(event))) {
    return;
  }
  if (_class_private_field_get$p(this, _isTriggeredByRMB) === true) {
    return;
  }
  if (this.checkIfRowHeader(eventTargetEl(event))) {
    const th = this.getClosestTHParent(eventTargetEl(event));
    if (th) {
      if (!_class_private_field_get$p(this, _pressed)) {
        this.setupHandlePosition(th);
      }
    }
  }
}
function onMouseDown(event) {
  if (eventTargetEl(event).parentNode !== this.hot.rootElement) {
    return;
  }
  if (hasClass(eventTargetEl(event), "manualRowResizer")) {
    this.setupHandlePosition(_class_private_field_get$p(this, _currentTH));
    this.setupGuidePosition();
    _class_private_field_set$p(this, _pressed, true);
    if (_class_private_field_get$p(this, _autoresizeTimeout) === null) {
      _class_private_field_set$p(this, _autoresizeTimeout, this.hot._registerTimeout(() => this.afterMouseDownTimeout(), 500));
    }
    _class_private_field_set$p(this, _dblclick, _class_private_field_get$p(this, _dblclick) + 1);
    _class_private_field_set$p(this, _startY, event.pageY);
    _class_private_field_set$p(this, _newSize, _class_private_field_get$p(this, _startHeight));
  }
}
function onMouseMove(event) {
  if (_class_private_field_get$p(this, _pressed)) {
    const visualChange = event.pageY - (_class_private_field_get$p(this, _startY) ?? 0);
    const change = normalizeVisualDelta(visualChange, _class_private_field_get$p(this, _verticalScaleFactor));
    _class_private_field_set$p(this, _currentHeight, (_class_private_field_get$p(this, _startHeight) ?? 0) + change);
    arrayEach(_class_private_field_get$p(this, _selectedRows), (selectedRow) => {
      _class_private_field_set$p(this, _newSize, this.setManualSize(selectedRow, _class_private_field_get$p(this, _currentHeight)));
    });
    this.refreshHandlePosition();
    this.refreshGuidePosition();
  }
}
function onMouseUp() {
  const render = () => {
    this.hot.view.adjustElementsSize();
    this.hot.render();
  };
  const runHooks = (row, forceRender) => {
    const hookNewSize = this.hot.runHooks("beforeRowResize", this.getActualRowHeight(row), row, false);
    if (hookNewSize === false) {
      this.setManualSize(row, _class_private_field_get$p(this, _startHeight));
      _class_private_field_set$p(this, _newSize, _class_private_field_get$p(this, _startHeight));
    } else if (typeof hookNewSize === "number") {
      _class_private_field_set$p(this, _newSize, hookNewSize);
      this.setManualSize(row, _class_private_field_get$p(this, _newSize));
    }
    if (forceRender) {
      render();
    }
    if (hookNewSize !== false) {
      this.hot.runHooks("afterRowResize", this.getActualRowHeight(row), row, false);
    }
  };
  if (_class_private_field_get$p(this, _pressed)) {
    this.hideHandleAndGuide();
    _class_private_field_set$p(this, _pressed, false);
    if (_class_private_field_get$p(this, _newSize) !== _class_private_field_get$p(this, _startHeight)) {
      const selectedRowsLength = _class_private_field_get$p(this, _selectedRows).length;
      if (selectedRowsLength > 1) {
        arrayEach(_class_private_field_get$p(this, _selectedRows), (selectedRow) => {
          runHooks(selectedRow);
        });
        render();
      } else {
        arrayEach(_class_private_field_get$p(this, _selectedRows), (selectedRow) => {
          runHooks(selectedRow, true);
        });
      }
    }
    this.setupHandlePosition(_class_private_field_get$p(this, _currentTH));
  }
}
function onContextMenu() {
  this.hideHandleAndGuide();
  this.hot.rootElement.removeChild(_class_private_field_get$p(this, _handle));
  this.hot.rootElement.removeChild(_class_private_field_get$p(this, _guide));
  _class_private_field_set$p(this, _pressed, false);
  _class_private_field_set$p(this, _isTriggeredByRMB, true);
  this.hot._registerMicrotask(() => {
    _class_private_field_set$p(this, _isTriggeredByRMB, false);
  });
}
function onMapInit() {
  const initialSetting = this.hot.getSettings()[PLUGIN_KEY$f];
  this.hot.batchExecution(() => {
    if (Array.isArray(initialSetting)) {
      initialSetting.forEach((height, index2) => {
        _class_private_field_get$p(this, _rowHeightsMap).setValueAtIndex(index2, height);
      });
      _class_private_field_set$p(this, _config, initialSetting);
    } else if (initialSetting === true && Array.isArray(_class_private_field_get$p(this, _config))) {
      _class_private_field_get$p(this, _config).forEach((height, index2) => {
        _class_private_field_get$p(this, _rowHeightsMap).setValueAtIndex(index2, height);
      });
    }
  }, true);
}
function _check_private_redeclaration$q(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$o(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$o(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$o(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$o(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$o(receiver, privateMap, "get");
  return _class_apply_descriptor_get$o(receiver, descriptor);
}
function _class_private_field_init$o(obj, privateMap, value) {
  _check_private_redeclaration$q(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$o(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$o(receiver, privateMap, "set");
  _class_apply_descriptor_set$o(receiver, descriptor, value);
  return value;
}
var _cellRange = /* @__PURE__ */ new WeakMap();
class MergedCellCoords {
  /**
  * Get a warning message for when the declared merged cell data contains negative values.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {string}
  */
  static NEGATIVE_VALUES_WARNING({ row, col, rowspan, colspan }) {
    return toSingleLine`The merged cell declared with {row: ${row}, col: ${col},\x20
      rowspan: ${rowspan}, colspan: ${colspan}} contains negative values, which is\x20
      not supported. It will not be added to the collection.`;
  }
  /**
  * Get a warning message for when the declared merged cell data contains values exceeding the table limits.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {string}
  */
  static IS_OUT_OF_BOUNDS_WARNING({ row, col }) {
    return toSingleLine`The merged cell declared at [${row}, ${col}] is positioned\x20
      (or positioned partially) outside of the table range. It was not added to the table, please fix your setup.`;
  }
  /**
  * Get a warning message for when the declared merged cell data represents a single cell.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {string}
  */
  static IS_SINGLE_CELL({ row, col }) {
    return toSingleLine`The merged cell declared at [${row}, ${col}] has both "rowspan"\x20
      and "colspan" declared as "1", which makes it a single cell. It cannot be added to the collection.`;
  }
  /**
  * Get a warning message for when the declared merged cell data contains "colspan" or "rowspan", that equals 0.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {string}
  */
  static ZERO_SPAN_WARNING({ row, col }) {
    return toSingleLine`The merged cell declared at [${row}, ${col}] has "rowspan"\x20
      or "colspan" declared as "0", which is not supported. It cannot be added to the collection.`;
  }
  /**
  * Check whether the values provided for a merged cell contain any negative values.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {boolean}
  */
  static containsNegativeValues({ row, col, rowspan, colspan }) {
    return row < 0 || col < 0 || rowspan < 0 || colspan < 0;
  }
  /**
  * Check whether the provided merged cell information object represents a single cell.
  *
  * @private
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {boolean}
  */
  static isSingleCell({ rowspan, colspan }) {
    return colspan === 1 && rowspan === 1;
  }
  /**
  * Check whether the provided merged cell information object contains a rowspan or colspan of 0.
  *
  * @private
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {boolean}
  */
  static containsZeroSpan({ rowspan, colspan }) {
    return colspan === 0 || rowspan === 0;
  }
  /**
  * Check whether the provided merged cell object is to be declared out of bounds of the table.
  *
  * @param {object} mergeCell Object containing the `row`, `col`, `rowspan` and `colspan` properties.
  * @param {number} rowCount Number of rows in the table.
  * @param {number} columnCount Number of rows in the table.
  * @returns {boolean}
  */
  static isOutOfBounds(mergeCell, rowCount, columnCount) {
    return mergeCell.row < 0 || mergeCell.col < 0 || mergeCell.row >= rowCount || mergeCell.row + mergeCell.rowspan - 1 >= rowCount || mergeCell.col >= columnCount || mergeCell.col + mergeCell.colspan - 1 >= columnCount;
  }
  /**
  * Sanitize (prevent from going outside the boundaries) the merged cell.
  *
  * @param {Core} hotInstance The Handsontable instance.
  */
  normalize(hotInstance) {
    const totalRows = hotInstance.countRows();
    const totalColumns = hotInstance.countCols();
    if (this.row < 0) {
      this.row = 0;
    } else if (this.row > totalRows - 1) {
      this.row = totalRows - 1;
    }
    if (this.col < 0) {
      this.col = 0;
    } else if (this.col > totalColumns - 1) {
      this.col = totalColumns - 1;
    }
    if (this.row + this.rowspan > totalRows - 1) {
      this.rowspan = totalRows - this.row;
    }
    if (this.col + this.colspan > totalColumns - 1) {
      this.colspan = totalColumns - this.col;
    }
    _class_private_field_set$o(this, _cellRange, null);
  }
  /**
  * Returns `true` if the provided coordinates are inside the merged cell.
  *
  * @param {number} row The row index.
  * @param {number} column The column index.
  * @returns {boolean}
  */
  includes(row, column) {
    return this.row <= row && this.col <= column && this.row + this.rowspan - 1 >= row && this.col + this.colspan - 1 >= column;
  }
  /**
  * Returns `true` if the provided `column` property is within the column span of the merged cell.
  *
  * @param {number} column The column index.
  * @returns {boolean}
  */
  includesHorizontally(column) {
    return this.col <= column && this.col + this.colspan - 1 >= column;
  }
  /**
  * Returns `true` if the provided `row` property is within the row span of the merged cell.
  *
  * @param {number} row Row index.
  * @returns {boolean}
  */
  includesVertically(row) {
    return this.row <= row && this.row + this.rowspan - 1 >= row;
  }
  /**
  * Shift (and possibly resize, if needed) the merged cell.
  *
  * @param {Array} shiftVector 2-element array containing the information on the shifting in the `x` and `y` axis.
  * @param {number} indexOfChange Index of the preceding change.
  * @returns {boolean} Returns `false` if the whole merged cell was removed.
  */
  shift(shiftVector, indexOfChange) {
    const shiftValue = shiftVector[0] || shiftVector[1];
    const shiftedIndex = indexOfChange + Math.abs(shiftVector[0] || shiftVector[1]) - 1;
    const span = shiftVector[0] ? "colspan" : "rowspan";
    const index2 = shiftVector[0] ? "col" : "row";
    const changeStart = Math.min(indexOfChange, shiftedIndex);
    const changeEnd = Math.max(indexOfChange, shiftedIndex);
    const mergeStart = this[index2];
    const mergeEnd = this[index2] + this[span] - 1;
    if (mergeStart >= indexOfChange) {
      this[index2] += shiftValue;
    }
    if (shiftValue > 0) {
      if (indexOfChange <= mergeEnd && indexOfChange > mergeStart) {
        this[span] += shiftValue;
      }
    } else if (shiftValue < 0) {
      if (changeStart <= mergeStart && changeEnd >= mergeEnd) {
        this.removed = true;
        _class_private_field_set$o(this, _cellRange, null);
        return false;
      } else if (mergeStart >= changeStart && mergeStart <= changeEnd) {
        const removedOffset = changeEnd - mergeStart + 1;
        const preRemovedOffset = Math.abs(shiftValue) - removedOffset;
        this[index2] -= preRemovedOffset + shiftValue;
        this[span] -= removedOffset;
      } else if (mergeStart <= changeStart && mergeEnd >= changeEnd) {
        this[span] += shiftValue;
      } else if (mergeStart <= changeStart && mergeEnd >= changeStart && mergeEnd < changeEnd) {
        const removedPart = mergeEnd - changeStart + 1;
        this[span] -= removedPart;
      }
    }
    _class_private_field_set$o(this, _cellRange, null);
    return true;
  }
  /**
  * Check if the second provided merged cell is "farther" in the provided direction.
  *
  * @param {MergedCellCoords} mergedCell The merged cell to check.
  * @param {string} direction Drag direction.
  * @returns {boolean|null} `true` if the second provided merged cell is "farther".
  */
  isFarther(mergedCell, direction) {
    if (!mergedCell) {
      return true;
    }
    if (direction === "down") {
      return mergedCell.row + mergedCell.rowspan - 1 < this.row + this.rowspan - 1;
    } else if (direction === "up") {
      return mergedCell.row > this.row;
    } else if (direction === "right") {
      return mergedCell.col + mergedCell.colspan - 1 < this.col + this.colspan - 1;
    } else if (direction === "left") {
      return mergedCell.col > this.col;
    }
    return null;
  }
  /**
  * Get the bottom row index of the merged cell.
  *
  * @returns {number}
  */
  getLastRow() {
    return this.row + this.rowspan - 1;
  }
  /**
  * Get the rightmost column index of the merged cell.
  *
  * @returns {number}
  */
  getLastColumn() {
    return this.col + this.colspan - 1;
  }
  /**
  * Get the range coordinates of the merged cell.
  *
  * @returns {CellRange}
  */
  getRange() {
    if (!_class_private_field_get$o(this, _cellRange)) {
      _class_private_field_set$o(this, _cellRange, this.cellRangeFactory(this.cellCoordsFactory(this.row, this.col), this.cellCoordsFactory(this.row, this.col), this.cellCoordsFactory(this.getLastRow(), this.getLastColumn())));
    }
    return _class_private_field_get$o(this, _cellRange);
  }
  /**
  * Initializes the merged cell coordinates with its top-left position, span dimensions, and factories for creating cell coordinate and range objects.
  */
  constructor(row, column, rowspan, colspan, cellCoordsFactory, cellRangeFactory) {
    _class_private_field_init$o(this, _cellRange, {
      writable: true,
      value: void 0
    });
    this.removed = false;
    _class_private_field_set$o(this, _cellRange, null);
    this.row = row;
    this.col = column;
    this.rowspan = rowspan;
    this.colspan = colspan;
    this.cellCoordsFactory = cellCoordsFactory;
    this.cellRangeFactory = cellRangeFactory;
  }
}
function _check_private_redeclaration$p(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$d(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$d(obj, privateSet) {
  _check_private_redeclaration$p(obj, privateSet);
  privateSet.add(obj);
}
var _getNonIntersectingIndexes = /* @__PURE__ */ new WeakSet(), _addMergedCellToMatrix = /* @__PURE__ */ new WeakSet(), _removeMergedCellFromMatrix = /* @__PURE__ */ new WeakSet();
class MergedCellsCollection {
  /**
  * Get a warning message for when the declared merged cell data overlaps already existing merged cells.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCell Object containing information
  * about the merged cells that was about to be added.
  * @returns {string}
  */
  static IS_OVERLAPPING_WARNING({ row, col }) {
    return toSingleLine`The merged cell declared at [${row}, ${col}], overlaps\x20
      with the other declared merged cell. The overlapping merged cell was not added to the table, please\x20
      fix your setup.`;
  }
  /**
  * Get a merged cell from the container, based on the provided arguments. You can provide either the "starting coordinates"
  * of a merged cell, or any coordinates from the body of the merged cell.
  *
  * @param {number} row Row index.
  * @param {number} column Column index.
  * @returns {MergedCellCoords|boolean} Returns a wanted merged cell on success and `false` on failure.
  */
  get(row, column) {
    if (!this.mergedCellsMatrix.has(row)) {
      return false;
    }
    return this.mergedCellsMatrix.get(row).get(column) ?? false;
  }
  /**
  * Get the first-found merged cell containing the provided range.
  *
  * @param {CellRange} range The range to search merged cells for.
  * @returns {MergedCellCoords | false}
  */
  getByRange(range) {
    const { row: rowStart, col: columnStart } = range.getTopStartCorner();
    const { row: rowEnd, col: columnEnd } = range.getBottomEndCorner();
    if (rowStart === null || rowEnd === null || columnStart === null || columnEnd === null) {
      return false;
    }
    const mergedCellsLength = this.mergedCells.length;
    let result = false;
    for (let i = 0; i < mergedCellsLength; i++) {
      const mergedCell = this.mergedCells[i];
      const { row, col, rowspan, colspan } = mergedCell;
      if (row >= rowStart && row + rowspan - 1 <= rowEnd && col >= columnStart && col + colspan - 1 <= columnEnd) {
        result = mergedCell;
        break;
      }
    }
    return result;
  }
  /**
  * Filters merge cells objects provided by users from overlapping cells.
  *
  * @param {{ row: number, col: number, rowspan: number, colspan: number }} mergedCellsInfo The merged cell information object.
  * Has to contain `row`, `col`, `colspan` and `rowspan` properties.
  * @returns {Array<{ row: number, col: number, rowspan: number, colspan: number }>}
  */
  filterOverlappingMergeCells(mergedCellsInfo) {
    const occupiedCells = /* @__PURE__ */ new Set();
    this.mergedCells.forEach((mergedCell) => {
      const { row, col, colspan, rowspan } = mergedCell;
      for (let r = row; r < row + rowspan; r++) {
        for (let c = col; c < col + colspan; c++) {
          occupiedCells.add(`r${r},c${c}`);
        }
      }
    });
    const filteredMergeCells = mergedCellsInfo.filter((mergedCell) => {
      const { row, col, colspan, rowspan } = mergedCell;
      const localOccupiedCells = /* @__PURE__ */ new Set();
      let isOverlapping = false;
      for (let r = row; r < row + rowspan; r++) {
        for (let c = col; c < col + colspan; c++) {
          const cellId = `r${r},c${c}`;
          if (occupiedCells.has(cellId)) {
            warn$1(MergedCellsCollection.IS_OVERLAPPING_WARNING(mergedCell));
            isOverlapping = true;
            break;
          }
          localOccupiedCells.add(cellId);
        }
        if (isOverlapping) {
          break;
        }
      }
      if (!isOverlapping) {
        localOccupiedCells.forEach((cell) => occupiedCells.add(cell));
      }
      return !isOverlapping;
    });
    return filteredMergeCells;
  }
  /**
  * Get a merged cell contained in the provided range.
  *
  * @param {CellRange} range The range to search merged cells in.
  * @param {boolean} [countPartials=false] If set to `true`, all the merged cells overlapping the range will be taken into calculation.
  * @returns {MergedCellCoords[]} Array of found merged cells.
  */
  getWithinRange(range, countPartials = false) {
    const { row: rowStart, col: columnStart } = range.getTopStartCorner();
    const { row: rowEnd, col: columnEnd } = range.getBottomEndCorner();
    if (rowStart === null || rowEnd === null || columnStart === null || columnEnd === null) {
      return [];
    }
    const result = [];
    for (let row = rowStart; row <= rowEnd; row++) {
      for (let column = columnStart; column <= columnEnd; column++) {
        const mergedCell = this.get(row, column);
        if (mergedCell && (countPartials || !countPartials && mergedCell.row === row && mergedCell.col === column)) {
          result.push(mergedCell);
        }
      }
    }
    return result;
  }
  /**
  * Add a merged cell to the container.
  *
  * @param {object} mergedCellInfo The merged cell information object. Has to contain `row`, `col`, `colspan` and `rowspan` properties.
  * @param {boolean} [auto=false] `true` if called internally by the plugin (usually in batch).
  * @returns {MergedCellCoords|boolean} Returns the new merged cell on success and `false` on failure.
  */
  add(mergedCellInfo, auto = false) {
    const row = mergedCellInfo.row;
    const column = mergedCellInfo.col;
    const rowspan = mergedCellInfo.rowspan;
    const colspan = mergedCellInfo.colspan;
    const newMergedCell = new MergedCellCoords(row, column, rowspan, colspan, this.hot._createCellCoords, this.hot._createCellRange);
    const alreadyExists = this.get(row, column);
    const isOverlapping = auto ? false : this.isOverlapping(newMergedCell);
    if (!alreadyExists && !isOverlapping) {
      if (this.hot) {
        newMergedCell.normalize(this.hot);
      }
      this.mergedCells.push(newMergedCell);
      _class_private_method_get$d(this, _addMergedCellToMatrix, addMergedCellToMatrix).call(this, newMergedCell);
      return newMergedCell;
    }
    if (isOverlapping) {
      warn$1(MergedCellsCollection.IS_OVERLAPPING_WARNING(newMergedCell));
    }
    return false;
  }
  /**
  * Remove a merged cell from the container. You can provide either the "starting coordinates"
  * of a merged cell, or any coordinates from the body of the merged cell.
  *
  * @param {number} row Row index.
  * @param {number} column Column index.
  * @returns {MergedCellCoords|boolean} Returns the removed merged cell on success and `false` on failure.
  */
  remove(row, column) {
    const mergedCell = this.get(row, column);
    const mergedCellIndex = mergedCell ? this.mergedCells.indexOf(mergedCell) : -1;
    if (mergedCell && mergedCellIndex !== -1) {
      this.mergedCells.splice(mergedCellIndex, 1);
      _class_private_method_get$d(this, _removeMergedCellFromMatrix, removeMergedCellFromMatrix).call(this, mergedCell);
      return mergedCell;
    }
    return false;
  }
  /**
  * Clear all the merged cells.
  */
  clear() {
    arrayEach(this.mergedCells, ({ row, col, rowspan, colspan }) => {
      rangeEach(row, row + rowspan, (r) => {
        rangeEach(col, col + colspan, (c) => {
          const TD = this.hot.getCell(r, c);
          if (TD) {
            TD.removeAttribute("rowspan");
            TD.removeAttribute("colspan");
            TD.style.display = "";
          }
        });
      });
    });
    this.mergedCells.length = 0;
    this.mergedCellsMatrix = /* @__PURE__ */ new Map();
  }
  /**
  * Check if the provided merged cell overlaps with the others already added.
  *
  * @param {MergedCellCoords} mergedCell The merged cell to check against all others in the container.
  * @returns {boolean} `true` if the provided merged cell overlaps with the others, `false` otherwise.
  */
  isOverlapping(mergedCell) {
    const mergedCellRange = mergedCell.getRange();
    if (!mergedCellRange) {
      return false;
    }
    for (let i = 0; i < this.mergedCells.length; i++) {
      const otherMergedCell = this.mergedCells[i];
      const otherMergedCellRange = otherMergedCell.getRange();
      const overlappingRange = otherMergedCellRange;
      if (otherMergedCellRange && overlappingRange.overlaps(mergedCellRange)) {
        return true;
      }
    }
    return false;
  }
  /**
  * Check whether the provided row/col coordinates direct to a first not hidden cell within merge area.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @returns {boolean}
  */
  isFirstRenderableMergedCell(row, column) {
    const mergeParent = this.get(row, column);
    if (!mergeParent) {
      return false;
    }
    const { row: mergeRow, col: mergeColumn, rowspan, colspan } = mergeParent;
    const overlayName = this.hot.view.getActiveOverlayName();
    const firstRenderedRow = [
      "top",
      "top_inline_start_corner"
    ].includes(overlayName) ? 0 : this.hot.getFirstRenderedVisibleRow();
    const firstRenderedColumn = [
      "inline_start",
      "top_inline_start_corner",
      "bottom_inline_start_corner"
    ].includes(overlayName) ? 0 : this.hot.getFirstRenderedVisibleColumn();
    const mergeCellsTopRow = clamp(firstRenderedRow, mergeRow, mergeRow + rowspan - 1);
    const mergeCellsStartColumn = clamp(firstRenderedColumn, mergeColumn, mergeColumn + colspan - 1);
    return this.hot.rowIndexMapper.getNearestNotHiddenIndex(mergeCellsTopRow, 1) === row && this.hot.columnIndexMapper.getNearestNotHiddenIndex(mergeCellsStartColumn, 1) === column;
  }
  /**
  * Get the first renderable coords of the merged cell at the provided coordinates.
  *
  * @param {number} row Visual row index.
  * @param {number} column Visual column index.
  * @returns {CellCoords} A `CellCoords` object with the coordinates to the first renderable cell within the
  *                        merged cell.
  */
  getFirstRenderableCoords(row, column) {
    const mergeParent = this.get(row, column);
    if (!mergeParent || this.isFirstRenderableMergedCell(row, column)) {
      return this.hot._createCellCoords(row, column);
    }
    const firstRenderableRow = this.hot.rowIndexMapper.getNearestNotHiddenIndex(mergeParent.row, 1) ?? mergeParent.row;
    const firstRenderableColumn = this.hot.columnIndexMapper.getNearestNotHiddenIndex(mergeParent.col, 1) ?? mergeParent.col;
    return this.hot._createCellCoords(firstRenderableRow, firstRenderableColumn);
  }
  /**
  * Gets the start-most visual column index that do not intersect with other merged cells within the provided range.
  *
  * @param {CellRange} range The range to search within.
  * @param {number} visualColumnIndex The visual column index to start the search from.
  * @returns {number}
  */
  getStartMostColumnIndex(range, visualColumnIndex) {
    const indexes = _class_private_method_get$d(this, _getNonIntersectingIndexes, getNonIntersectingIndexes).call(this, range, "col", -1);
    let startMostIndex = visualColumnIndex;
    for (let i = 0; i < indexes.length; i++) {
      if (indexes[i] <= visualColumnIndex) {
        startMostIndex = indexes[i];
        break;
      }
    }
    return startMostIndex;
  }
  /**
  * Gets the end-most visual column index that do not intersect with other merged cells within the provided range.
  *
  * @param {CellRange} range The range to search within.
  * @param {number} visualColumnIndex The visual column index to start the search from.
  * @returns {number}
  */
  getEndMostColumnIndex(range, visualColumnIndex) {
    const indexes = _class_private_method_get$d(this, _getNonIntersectingIndexes, getNonIntersectingIndexes).call(this, range, "col", 1);
    let endMostIndex = visualColumnIndex;
    for (let i = 0; i < indexes.length; i++) {
      if (indexes[i] >= visualColumnIndex) {
        endMostIndex = indexes[i];
        break;
      }
    }
    return endMostIndex;
  }
  /**
  * Gets the top-most visual row index that do not intersect with other merged cells within the provided range.
  *
  * @param {CellRange} range The range to search within.
  * @param {number} visualRowIndex The visual row index to start the search from.
  * @returns {number}
  */
  getTopMostRowIndex(range, visualRowIndex) {
    const indexes = _class_private_method_get$d(this, _getNonIntersectingIndexes, getNonIntersectingIndexes).call(this, range, "row", -1);
    let topMostIndex = visualRowIndex;
    for (let i = 0; i < indexes.length; i++) {
      if (indexes[i] <= visualRowIndex) {
        topMostIndex = indexes[i];
        break;
      }
    }
    return topMostIndex;
  }
  /**
  * Gets the bottom-most visual row index that do not intersect with other merged cells within the provided range.
  *
  * @param {CellRange} range The range to search within.
  * @param {number} visualRowIndex The visual row index to start the search from.
  * @returns {number}
  */
  getBottomMostRowIndex(range, visualRowIndex) {
    const indexes = _class_private_method_get$d(this, _getNonIntersectingIndexes, getNonIntersectingIndexes).call(this, range, "row", 1);
    let bottomMostIndex = visualRowIndex;
    for (let i = 0; i < indexes.length; i++) {
      if (indexes[i] >= visualRowIndex) {
        bottomMostIndex = indexes[i];
        break;
      }
    }
    return bottomMostIndex;
  }
  /**
  * Shift the merged cell in the direction and by an offset defined in the arguments.
  *
  * @param {string} direction `right`, `left`, `up` or `down`.
  * @param {number} index Index where the change, which caused the shifting took place.
  * @param {number} count Number of rows/columns added/removed in the preceding action.
  */
  shiftCollections(direction, index2, count) {
    const shiftVector = [
      0,
      0
    ];
    switch (direction) {
      case "right":
        shiftVector[0] += count;
        break;
      case "left":
        shiftVector[0] -= count;
        break;
      case "down":
        shiftVector[1] += count;
        break;
      case "up":
        shiftVector[1] -= count;
        break;
    }
    const removedMergedCells = [];
    this.mergedCells.forEach((currentMerge) => {
      currentMerge.shift(shiftVector, index2);
      if (currentMerge.removed) {
        removedMergedCells.push(currentMerge);
      }
    });
    removedMergedCells.forEach((removedMerge) => {
      this.mergedCells.splice(this.mergedCells.indexOf(removedMerge), 1);
    });
    this.mergedCellsMatrix.clear();
    this.mergedCells.forEach((currentMerge) => {
      _class_private_method_get$d(this, _addMergedCellToMatrix, addMergedCellToMatrix).call(this, currentMerge);
    });
  }
  /**
  * Capture the physical indexes covered by every merged cell along an axis.
  *
  * Used by the manual row/column move and column freeze integrations to translate
  * merges through a reorder: the captured spans pin each merge to the underlying
  * data so the merge can be repositioned (and split, if a non-contiguous run
  * results) after the visual sequence changes.
  *
  * @param {'column' | 'row'} axis Which axis the upcoming reorder targets.
  * @returns {Map<MergedCellCoords, number[]>} Map of merge -> physical indexes along the axis.
  */
  capturePhysicalSpans(axis) {
    const isColumn = axis === "column";
    const indexProp = isColumn ? "col" : "row";
    const spanProp = isColumn ? "colspan" : "rowspan";
    const toPhysical = isColumn ? (visualIndex) => this.hot.toPhysicalColumn(visualIndex) : (visualIndex) => this.hot.toPhysicalRow(visualIndex);
    const snapshot = /* @__PURE__ */ new Map();
    this.mergedCells.forEach((merge2) => {
      const physicals = [];
      for (let i = 0; i < merge2[spanProp]; i++) {
        physicals.push(toPhysical(merge2[indexProp] + i));
      }
      snapshot.set(merge2, physicals);
    });
    return snapshot;
  }
  /**
  * Group an ascending list of integers into contiguous runs.
  *
  * @param {number[]} sortedAscending Already-sorted ascending visual indexes.
  * @returns {Array<{ start: number, length: number }>}
  */
  static detectContiguousRuns(sortedAscending) {
    if (sortedAscending.length === 0) {
      return [];
    }
    const runs = [];
    let runStart = sortedAscending[0];
    let runLength = 1;
    for (let i = 1; i < sortedAscending.length; i++) {
      if (sortedAscending[i] === sortedAscending[i - 1] + 1) {
        runLength += 1;
      } else {
        runs.push({
          start: runStart,
          length: runLength
        });
        runStart = sortedAscending[i];
        runLength = 1;
      }
    }
    runs.push({
      start: runStart,
      length: runLength
    });
    return runs;
  }
  /**
  * Translate the merged cells collection after a manual row/column reorder, splitting
  * merges whose physical indexes are no longer contiguous in the new visual order.
  *
  * Note: single-cell fragments (`colspan === 1 && rowspan === 1`) are dropped because
  * they no longer represent a merge. The user-facing behavior (auto-split + silent drop
  * of singletons) is documented in `docs/content/guides/cell-features/merge-cells/merge-cells.md`
  * under "Behavior during row/column reorder and column freeze".
  *
  * @param {'column' | 'row'} axis Axis that was reordered.
  * @param {Map<MergedCellCoords, number[]>} snapshot Snapshot taken before the reorder.
  */
  translateAfterAxisMove(axis, snapshot) {
    const isColumn = axis === "column";
    const indexProp = isColumn ? "col" : "row";
    const spanProp = isColumn ? "colspan" : "rowspan";
    const otherIndexProp = isColumn ? "row" : "col";
    const otherSpanProp = isColumn ? "rowspan" : "colspan";
    const toVisual = isColumn ? (physicalIndex) => this.hot.toVisualColumn(physicalIndex) : (physicalIndex) => this.hot.toVisualRow(physicalIndex);
    const replacements = [];
    this.mergedCells.forEach((merge2) => {
      const physicals = snapshot.get(merge2);
      if (!physicals) {
        replacements.push({
          row: merge2.row,
          col: merge2.col,
          rowspan: merge2.rowspan,
          colspan: merge2.colspan
        });
        return;
      }
      const newVisuals = physicals.map(toVisual).filter((visualIndex) => visualIndex !== null && visualIndex >= 0).sort((a, b) => a - b);
      if (newVisuals.length === 0) {
        return;
      }
      MergedCellsCollection.detectContiguousRuns(newVisuals).forEach((run) => {
        const replacement = {
          [indexProp]: run.start,
          [spanProp]: run.length,
          [otherIndexProp]: merge2[otherIndexProp],
          [otherSpanProp]: merge2[otherSpanProp]
        };
        if (replacement.colspan === 1 && replacement.rowspan === 1) {
          return;
        }
        replacements.push(replacement);
      });
    });
    this.mergedCells.length = 0;
    this.mergedCellsMatrix.clear();
    replacements.forEach((info) => {
      this.add(info, true);
    });
  }
  /**
  * Initializes the cells collection with references to the MergeCells plugin and the Handsontable instance.
  */
  constructor(mergeCellsPlugin) {
    _class_private_method_init$d(this, _getNonIntersectingIndexes);
    _class_private_method_init$d(this, _addMergedCellToMatrix);
    _class_private_method_init$d(this, _removeMergedCellFromMatrix);
    this.mergedCells = [];
    this.mergedCellsMatrix = /* @__PURE__ */ new Map();
    this.plugin = mergeCellsPlugin;
    this.hot = mergeCellsPlugin.hot;
  }
}
function getNonIntersectingIndexes(range, axis, scanDirection = 1) {
  const indexes = /* @__PURE__ */ new Map();
  const from = scanDirection === 1 ? range.getTopStartCorner() : range.getBottomEndCorner();
  const to = scanDirection === 1 ? range.getBottomEndCorner() : range.getTopStartCorner();
  const fromRow = from.row ?? 0;
  const fromCol = from.col ?? 0;
  const toRow = to.row ?? 0;
  const toCol = to.col ?? 0;
  for (let row = fromRow; scanDirection === 1 ? row <= toRow : row >= toRow; row += scanDirection) {
    for (let column = fromCol; scanDirection === 1 ? column <= toCol : column >= toCol; column += scanDirection) {
      const index2 = axis === "row" ? row : column;
      const mergedCell = this.get(row, column);
      let lastIndex = index2;
      if (mergedCell) {
        lastIndex = scanDirection === 1 ? mergedCell[axis] + mergedCell[`${axis}span`] - 1 : mergedCell[axis];
      }
      if (!indexes.has(index2)) {
        indexes.set(index2, /* @__PURE__ */ new Set());
      }
      indexes.get(index2).add(lastIndex);
    }
  }
  return Array.from(new Set(Array.from(indexes.entries()).filter(([, set]) => set.size === 1).flatMap(([, set]) => Array.from(set))));
}
function addMergedCellToMatrix(mergedCell) {
  for (let row = mergedCell.row; row < mergedCell.row + mergedCell.rowspan; row++) {
    for (let col = mergedCell.col; col < mergedCell.col + mergedCell.colspan; col++) {
      if (!this.mergedCellsMatrix.has(row)) {
        this.mergedCellsMatrix.set(row, /* @__PURE__ */ new Map());
      }
      this.mergedCellsMatrix.get(row).set(col, mergedCell);
    }
  }
}
function removeMergedCellFromMatrix(mergedCell) {
  for (let row = mergedCell.row; row < mergedCell.row + mergedCell.rowspan; row++) {
    for (let col = mergedCell.col; col < mergedCell.col + mergedCell.colspan; col++) {
      this.mergedCellsMatrix.get(row)?.delete(col);
    }
  }
}
class AutofillCalculations {
  /**
  * Get the direction of the autofill process.
  *
  * @param {Array} baseArea The selection area.
  * @param {Array} fullArea The final area (base + drag).
  * @returns {string} `up`, `down`, `left` or `right`.
  */
  getDirection(baseArea, fullArea) {
    let direction = null;
    if (fullArea[0] === baseArea[0] && fullArea[1] === baseArea[1] && fullArea[3] === baseArea[3]) {
      direction = "down";
    } else if (fullArea[2] === baseArea[2] && fullArea[1] === baseArea[1] && fullArea[3] === baseArea[3]) {
      direction = "up";
    } else if (fullArea[1] === baseArea[1] && fullArea[2] === baseArea[2]) {
      direction = "right";
    } else {
      direction = "left";
    }
    return direction;
  }
  /**
  * Snap the drag area to the farthest merged cell, so it won't clip any of the merged cells.
  *
  * @param {Array} baseArea The base selected area.
  * @param {Array} fullArea The drag area.
  * @param {string} dragDirection The autofill drag direction.
  * @param {Array} foundMergedCells MergeCellCoords found in the base selection area.
  * @returns {Array} The new drag area.
  */
  snapDragArea(baseArea, fullArea, dragDirection, foundMergedCells) {
    const newDragArea = fullArea.slice(0);
    const fillSize = this.getAutofillSize(baseArea, fullArea, dragDirection);
    const [baseAreaStartRow, baseAreaStartColumn, baseAreaEndRow, baseAreaEndColumn] = baseArea;
    const verticalDirection = [
      "up",
      "down"
    ].indexOf(dragDirection) > -1;
    const fullCycle = verticalDirection ? baseAreaEndRow - baseAreaStartRow + 1 : baseAreaEndColumn - baseAreaStartColumn + 1;
    const fulls = Math.floor(fillSize / fullCycle) * fullCycle;
    const partials = fillSize - fulls;
    const farthestCollection = this.getFarthestCollection(baseArea, fullArea, dragDirection, foundMergedCells);
    if (farthestCollection) {
      if (dragDirection === "down") {
        const fill = farthestCollection.row + farthestCollection.rowspan - baseAreaStartRow - partials;
        const newLimit = newDragArea[2] + fill;
        if (newLimit >= this.plugin.hot.countRows()) {
          newDragArea[2] -= partials;
        } else {
          newDragArea[2] += partials ? fill : 0;
        }
      } else if (dragDirection === "right") {
        const fill = farthestCollection.col + farthestCollection.colspan - baseAreaStartColumn - partials;
        const newLimit = newDragArea[3] + fill;
        if (newLimit >= this.plugin.hot.countCols()) {
          newDragArea[3] -= partials;
        } else {
          newDragArea[3] += partials ? fill : 0;
        }
      } else if (dragDirection === "up") {
        const fill = baseAreaEndRow - partials - farthestCollection.row + 1;
        const newLimit = newDragArea[0] + fill;
        if (newLimit < 0) {
          newDragArea[0] += partials;
        } else {
          newDragArea[0] -= partials ? fill : 0;
        }
      } else if (dragDirection === "left") {
        const fill = baseAreaEndColumn - partials - farthestCollection.col + 1;
        const newLimit = newDragArea[1] + fill;
        if (newLimit < 0) {
          newDragArea[1] += partials;
        } else {
          newDragArea[1] -= partials ? fill : 0;
        }
      }
    }
    this.updateCurrentFillCache({
      baseArea,
      dragDirection,
      foundMergedCells,
      fillSize,
      dragArea: newDragArea,
      cycleLength: fullCycle
    });
    return newDragArea;
  }
  /**
  * Update the current fill cache with the provided object.
  *
  * @private
  * @param {object} updateObject The current filled object cache.
  */
  updateCurrentFillCache(updateObject) {
    if (!this.currentFillData) {
      this.currentFillData = {};
    }
    extend(this.currentFillData, updateObject);
  }
  /**
  * Get the "length" of the drag area.
  *
  * @private
  * @param {Array} baseArea The base selection area.
  * @param {Array} fullArea The drag area (containing the base area).
  * @param {string} direction The drag direction.
  * @returns {number} The "length" (height or width, depending on the direction) of the drag.
  */
  getAutofillSize(baseArea, fullArea, direction) {
    const [baseAreaStartRow, baseAreaStartColumn, baseAreaEndRow, baseAreaEndColumn] = baseArea;
    const [dragAreaStartRow, dragAreaStartColumn, dragAreaEndRow, dragAreaEndColumn] = fullArea;
    switch (direction) {
      case "up":
        return baseAreaStartRow - dragAreaStartRow;
      case "down":
        return dragAreaEndRow - baseAreaEndRow;
      case "left":
        return baseAreaStartColumn - dragAreaStartColumn;
      case "right":
        return dragAreaEndColumn - baseAreaEndColumn;
      default:
        return 0;
    }
  }
  /**
  * Trim the default drag area (containing the selection area) to the drag-only area.
  *
  * @private
  * @param {Array} baseArea The base selection area.
  * @param {Array} fullArea The base selection area extended by the drag area.
  * @param {string} direction Drag direction.
  * @returns {Array} Array representing the drag area coordinates.
  */
  getDragArea(baseArea, fullArea, direction) {
    const [baseAreaStartRow, baseAreaStartColumn, baseAreaEndRow, baseAreaEndColumn] = baseArea;
    const [fullAreaStartRow, fullAreaStartColumn, fullAreaEndRow, fullAreaEndColumn] = fullArea;
    switch (direction) {
      case "up":
        return [
          fullAreaStartRow,
          fullAreaStartColumn,
          baseAreaStartRow - 1,
          baseAreaEndColumn
        ];
      case "down": {
        const mergedCell = this.mergedCellsCollection.get(fullAreaEndRow, baseAreaEndColumn);
        const rowShift = mergedCell ? mergedCell.rowspan - 1 : 0;
        return [
          baseAreaEndRow + 1,
          baseAreaStartColumn,
          fullAreaEndRow + rowShift,
          baseAreaEndColumn
        ];
      }
      case "left":
        return [
          fullAreaStartRow,
          fullAreaStartColumn,
          baseAreaEndRow,
          baseAreaStartColumn - 1
        ];
      case "right": {
        const mergedCell = this.mergedCellsCollection.get(fullAreaEndRow, baseAreaEndColumn);
        const columnShift = mergedCell ? mergedCell.colspan - 1 : 0;
        return [
          baseAreaStartRow,
          baseAreaEndColumn + columnShift,
          fullAreaEndRow,
          fullAreaEndColumn
        ];
      }
      default:
        return [
          0,
          0,
          0,
          0
        ];
    }
  }
  /**
  * Get the to-be-farthest merged cell in the newly filled area.
  *
  * @private
  * @param {Array} baseArea The base selection area.
  * @param {Array} fullArea The drag area (containing the base area).
  * @param {string} direction The drag direction.
  * @param {Array} mergedCellArray Array of the merged cells found in the base area.
  * @returns {MergedCellCoords|null}
  */
  getFarthestCollection(baseArea, fullArea, direction, mergedCellArray) {
    const [baseAreaStartRow, baseAreaStartColumn, baseAreaEndRow, baseAreaEndColumn] = baseArea;
    const verticalDirection = [
      "up",
      "down"
    ].indexOf(direction) > -1;
    const baseEnd = verticalDirection ? baseAreaEndRow : baseAreaEndColumn;
    const baseStart = verticalDirection ? baseAreaStartRow : baseAreaStartColumn;
    const fillSize = this.getAutofillSize(baseArea, fullArea, direction);
    const fullCycle = verticalDirection ? baseAreaEndRow - baseAreaStartRow + 1 : baseAreaEndColumn - baseAreaStartColumn + 1;
    const fulls = Math.floor(fillSize / fullCycle) * fullCycle;
    const partials = fillSize - fulls;
    let inclusionFunctionName = null;
    let farthestCollection = null;
    let endOfDragRecreationIndex = null;
    switch (direction) {
      case "up":
        inclusionFunctionName = "includesVertically";
        endOfDragRecreationIndex = baseEnd - partials + 1;
        break;
      case "left":
        inclusionFunctionName = "includesHorizontally";
        endOfDragRecreationIndex = baseEnd - partials + 1;
        break;
      case "down":
        inclusionFunctionName = "includesVertically";
        endOfDragRecreationIndex = baseStart + partials - 1;
        break;
      case "right":
        inclusionFunctionName = "includesHorizontally";
        endOfDragRecreationIndex = baseStart + partials - 1;
        break;
    }
    arrayEach(mergedCellArray, (currentCollection) => {
      const mc = currentCollection;
      if (mc[inclusionFunctionName](endOfDragRecreationIndex) && mc.isFarther(farthestCollection, direction)) {
        farthestCollection = mc;
      }
    });
    return farthestCollection;
  }
  /**
  * Recreate the merged cells after the autofill process.
  *
  * @param {Array} changes Changes made.
  */
  recreateAfterDataPopulation(changes) {
    if (!this.currentFillData) {
      return;
    }
    const fillRange = this.getRangeFromChanges(changes);
    const foundMergedCells = this.currentFillData.foundMergedCells;
    const dragDirection = this.currentFillData.dragDirection;
    const inBounds = (current2, offset2) => {
      switch (dragDirection) {
        case "up":
          return current2.row - offset2 >= fillRange.from.row;
        case "down":
          return current2.row + current2.rowspan - 1 + offset2 <= fillRange.to.row;
        case "left":
          return current2.col - offset2 >= fillRange.from.column;
        case "right":
          return current2.col + current2.colspan - 1 + offset2 <= fillRange.to.column;
        default:
          return null;
      }
    };
    let fillOffset = 0;
    let current = null;
    let multiplier = 1;
    do {
      for (let j = 0; j < foundMergedCells.length; j += 1) {
        current = foundMergedCells[j];
        fillOffset = multiplier * this.currentFillData.cycleLength;
        if (inBounds(current, fillOffset)) {
          switch (dragDirection) {
            case "up":
              this.plugin.mergedCellsCollection.add({
                row: current.row - fillOffset,
                rowspan: current.rowspan,
                col: current.col,
                colspan: current.colspan
              }, true);
              break;
            case "down":
              this.plugin.mergedCellsCollection.add({
                row: current.row + fillOffset,
                rowspan: current.rowspan,
                col: current.col,
                colspan: current.colspan
              }, true);
              break;
            case "left":
              this.plugin.mergedCellsCollection.add({
                row: current.row,
                rowspan: current.rowspan,
                col: current.col - fillOffset,
                colspan: current.colspan
              }, true);
              break;
            case "right":
              this.plugin.mergedCellsCollection.add({
                row: current.row,
                rowspan: current.rowspan,
                col: current.col + fillOffset,
                colspan: current.colspan
              }, true);
              break;
          }
        }
        if (j === foundMergedCells.length - 1) {
          multiplier += 1;
        }
      }
    } while (current !== null && inBounds(current, fillOffset));
    this.currentFillData = null;
    this.plugin.hot.render();
    if (foundMergedCells.length > 0) {
      this.plugin.ifChromeForceRepaint();
    }
  }
  /**
  * Get the drag range from the changes made.
  *
  * @private
  * @param {Array} changes The changes made.
  * @returns {object} Object with `from` and `to` properties, both containing `row` and `column` keys.
  */
  getRangeFromChanges(changes) {
    let rowMin = null;
    let rowMax = null;
    let colMin = null;
    let colMax = null;
    arrayEach(changes, (change) => {
      const changeArr = change;
      const rowIndex = changeArr[0];
      const columnIndex = this.plugin.hot.propToCol(changeArr[1]);
      if (rowMin === null || rowIndex < rowMin) {
        rowMin = rowIndex;
      }
      if (rowMax === null || rowIndex > rowMax) {
        rowMax = rowIndex;
      }
      if (colMin === null || columnIndex < colMin) {
        colMin = columnIndex;
      }
      if (colMax === null || columnIndex > colMax) {
        colMax = columnIndex;
      }
    });
    return {
      from: {
        row: rowMin ?? 0,
        column: colMin ?? 0
      },
      to: {
        row: rowMax ?? 0,
        column: colMax ?? 0
      }
    };
  }
  /**
  * Check if the drag area contains any merged cells.
  *
  * @param {Array} baseArea The base selection area.
  * @param {Array} fullArea The base area extended by the drag area.
  * @param {string} direction Drag direction.
  * @returns {boolean}
  */
  dragAreaOverlapsCollections(baseArea, fullArea, direction) {
    const dragArea = this.getDragArea(baseArea, fullArea, direction);
    const [dragAreaStartRow, dragAreaStartColumn, dragAreaEndRow, dragAreaEndColumn] = dragArea;
    const topLeft = this.plugin.hot._createCellCoords(dragAreaStartRow, dragAreaStartColumn);
    const bottomRight = this.plugin.hot._createCellCoords(dragAreaEndRow, dragAreaEndColumn);
    const dragRange = this.plugin.hot._createCellRange(topLeft, topLeft, bottomRight);
    const mergedCellsWithPartials = this.mergedCellsCollection.getWithinRange(dragRange, true);
    if (mergedCellsWithPartials.length === 0) {
      return false;
    }
    const mergedCellsWithoutPartials = this.mergedCellsCollection.getWithinRange(dragRange, false);
    if (mergedCellsWithoutPartials.length === 0) {
      return true;
    }
    if (direction === "up" || direction === "down") {
      return !mergedCellsWithoutPartials.every(({ colspan }) => colspan === dragRange.getWidth());
    }
    return !mergedCellsWithoutPartials.every(({ rowspan }) => rowspan === dragRange.getHeight());
  }
  /**
  * Initializes the autofill calculations helper with a reference to the MergeCells plugin and its merged cells collection.
  */
  constructor(plugin) {
    this.currentFillData = null;
    this.plugin = plugin;
    this.mergedCellsCollection = this.plugin.mergedCellsCollection;
  }
}
class SelectionCalculations {
  /**
  * Generate an additional class name for the entirely-selected merged cells.
  *
  * @param {number} currentRow Visual row index of the currently processed cell.
  * @param {number} currentColumn Visual column index of the currently cell.
  * @param {Array} cornersOfSelection Array of the current selection in a form of `[startRow, startColumn, endRow, endColumn]`.
  * @param {number|undefined} layerLevel Number indicating which layer of selection is currently processed.
  * @returns {string|undefined} A `String`, which will act as an additional `className` to be added to the currently processed cell.
  */
  getSelectedMergedCellClassName(currentRow, currentColumn, cornersOfSelection, layerLevel) {
    const startRow = Math.min(cornersOfSelection[0], cornersOfSelection[2]);
    const startColumn = Math.min(cornersOfSelection[1], cornersOfSelection[3]);
    const endRow = Math.max(cornersOfSelection[0], cornersOfSelection[2]);
    const endColumn = Math.max(cornersOfSelection[1], cornersOfSelection[3]);
    if (layerLevel === void 0) {
      return;
    }
    const mergedCellsCollection = this.plugin.mergedCellsCollection;
    const isFirstRenderableMergedCell = mergedCellsCollection.isFirstRenderableMergedCell(currentRow, currentColumn);
    if (!isFirstRenderableMergedCell) {
      return;
    }
    const mergedCell = mergedCellsCollection.get(currentRow, currentColumn);
    if (!mergedCell) {
      return;
    }
    const mergeRowEnd = mergedCell.getLastRow();
    const mergeColumnEnd = mergedCell.getLastColumn();
    const fullMergeAreaWithinSelection = startRow <= mergedCell.row && startColumn <= mergedCell.col && endRow >= mergeRowEnd && endColumn >= mergeColumnEnd;
    if (fullMergeAreaWithinSelection) {
      return `${this.fullySelectedMergedCellClassName}-${layerLevel}`;
    } else if (this.isMergeCellFullySelected(mergedCell, this.hot.getSelectedRange())) {
      return `${this.fullySelectedMergedCellClassName}-multiple`;
    }
  }
  /**
  * Check if the provided merged cell is fully selected (by one or many layers of selection).
  *
  * @param {MergedCellCoords} mergedCell The merged cell to be processed.
  * @param {CellRange[]} selectionRangesArray Array of selection ranges.
  * @returns {boolean}
  */
  isMergeCellFullySelected(mergedCell, selectionRangesArray) {
    const mergedCellIndividualCoords = [];
    if (!selectionRangesArray || !mergedCell) {
      return false;
    }
    for (let r = 0; r < mergedCell.rowspan; r += 1) {
      for (let c = 0; c < mergedCell.colspan; c += 1) {
        mergedCellIndividualCoords.push(this.hot._createCellCoords(mergedCell.row + r, mergedCell.col + c));
      }
    }
    for (let i = 0; i < mergedCellIndividualCoords.length; i += 1) {
      const insideSelections = [];
      for (let s = 0; s < selectionRangesArray.length; s += 1) {
        insideSelections[s] = selectionRangesArray[s].includes(mergedCellIndividualCoords[i]);
      }
      if (!insideSelections.includes(true)) {
        return false;
      }
    }
    return true;
  }
  /**
  * Generate an array of the entirely-selected merged cells' class names.
  *
  * @returns {string[]} An `Array` of `String`s. Each of these strings will act like class names to be removed from all the cells in the table.
  */
  getSelectedMergedCellClassNameToRemove() {
    const classNames = [];
    for (let i = 0; i <= 7; i += 1) {
      classNames.push(`${this.fullySelectedMergedCellClassName}-${i}`);
    }
    classNames.push(`${this.fullySelectedMergedCellClassName}-multiple`);
    return classNames;
  }
  /**
  * Initializes the selection calculations helper with a reference to the MergeCells plugin instance.
  */
  constructor(plugin) {
    this.fullySelectedMergedCellClassName = "fullySelectedMergedCell";
    this.plugin = plugin;
    this.hot = plugin.hot;
  }
}
function toggleMergeItem(plugin) {
  return {
    key: "mergeCells",
    name() {
      const selection = this.getSelectedActive();
      if (selection && plugin.mergedCellsCollection) {
        const info = plugin.mergedCellsCollection.get(selection[0], selection[1]);
        if (info !== false && info.row === selection[0] && info.col === selection[1] && info.row + info.rowspan - 1 === selection[2] && info.col + info.colspan - 1 === selection[3]) {
          return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_UNMERGE_CELLS);
        }
      }
      return this.getTranslatedPhrase(CONTEXTMENU_ITEMS_MERGE_CELLS);
    },
    callback() {
      const activeRange = this.getSelectedRangeActive();
      if (!activeRange) {
        return;
      }
      activeRange.setDirection(this.isRtl() ? "NE-SW" : "NW-SE");
      const { from, to } = activeRange;
      plugin.toggleMerge(activeRange);
      if (from.row !== null && from.col !== null && to.row !== null && to.col !== null) {
        this.selectCell(from.row, from.col, to.row, to.col, false);
      }
    },
    disabled() {
      const selection = this.getSelectedActive();
      if (!selection) {
        return true;
      }
      const isSingleCell = MergedCellCoords.isSingleCell({
        row: selection[0],
        col: selection[1],
        rowspan: selection[2] - selection[0] + 1,
        colspan: selection[3] - selection[1] + 1
      });
      return isSingleCell || this.selection.isSelectedByCorner();
    },
    hidden: false
  };
}
class NodeStructure {
  /**
  * Initializes the node with the given data value.
  */
  constructor(data) {
    this.next = null;
    this.prev = null;
    this.data = data;
  }
}
class LinkedList {
  /**
  * Add data to the end of linked list.
  *
  * @param {object} data Data which should be added.
  * @returns {NodeStructure} Returns the node which has been added.
  */
  push(data) {
    const node = new NodeStructure(data);
    if (this.first === null) {
      this.first = node;
      this.last = node;
    } else {
      const temp = this.last;
      this.last = node;
      node.prev = temp;
      temp.next = node;
    }
    return node;
  }
  /**
  * Add data to the beginning of linked list.
  *
  * @param {object} data Data which should be added.
  */
  unshift(data) {
    const node = new NodeStructure(data);
    if (this.first === null) {
      this.first = node;
      this.last = node;
    } else {
      const temp = this.first;
      this.first = node;
      node.next = temp;
      temp.prev = node;
    }
  }
  /**
  * In order traversal of the linked list.
  *
  * @param {Function} callback Callback which should be executed on each node.
  */
  inorder(callback) {
    let temp = this.first;
    while (temp) {
      const interrupt = callback(temp);
      if (temp === this.last || interrupt === true) {
        break;
      }
      temp = temp.next;
    }
  }
  /**
  * Remove data from the linked list.
  *
  * @param {object} data Data which should be removed.
  * @returns {boolean} Returns true if data has been removed.
  */
  remove(data) {
    if (this.first === null) {
      return false;
    }
    let temp = this.first;
    let next;
    let prev;
    while (temp) {
      if (temp.data === data) {
        next = temp.next;
        prev = temp.prev;
        if (next) {
          next.prev = prev;
        }
        if (prev) {
          prev.next = next;
        }
        if (temp === this.first) {
          this.first = next;
        }
        if (temp === this.last) {
          this.last = prev;
        }
        return true;
      }
      temp = temp.next;
    }
    return false;
  }
  /**
  * Check if linked list contains cycle.
  *
  * @returns {boolean} Returns true if linked list contains cycle.
  */
  hasCycle() {
    let fast = this.first;
    let slow = this.first;
    while (true) {
      if (fast === null) {
        return false;
      }
      fast = fast.next;
      if (fast === null) {
        return false;
      }
      fast = fast.next;
      slow = slow.next;
      if (fast === slow) {
        return true;
      }
    }
  }
  /**
  * Return last node from the linked list.
  *
  * @returns {NodeStructure} Last node.
  */
  pop() {
    if (this.last === null) {
      return null;
    }
    const temp = this.last;
    this.last = this.last.prev;
    return temp;
  }
  /**
  * Return first node from the linked list.
  *
  * @returns {NodeStructure} First node.
  */
  shift() {
    if (this.first === null) {
      return null;
    }
    const temp = this.first;
    this.first = this.first.next;
    return temp;
  }
  /**
  * Reverses the linked list recursively.
  */
  recursiveReverse() {
    function inverse(current, next) {
      if (!next) {
        return;
      }
      inverse(next, next.next);
      next.next = current;
    }
    if (!this.first) {
      return;
    }
    inverse(this.first, this.first.next);
    this.first.next = null;
    const temp = this.first;
    this.first = this.last;
    this.last = temp;
  }
  /**
  * Reverses the linked list iteratively.
  */
  reverse() {
    if (!this.first || !this.first.next) {
      return;
    }
    let current = this.first.next;
    let prev = this.first;
    let temp = null;
    while (current) {
      temp = current.next;
      current.next = prev;
      prev.prev = current;
      prev = current;
      current = temp;
    }
    this.first.next = null;
    this.last.prev = null;
    temp = this.first;
    this.first = prev;
    this.last = temp;
  }
  constructor() {
    this.first = null;
    this.last = null;
  }
}
function _check_private_redeclaration$o(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$n(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$n(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$n(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$n(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$n(receiver, privateMap, "get");
  return _class_apply_descriptor_get$n(receiver, descriptor);
}
function _class_private_field_init$n(obj, privateMap, value) {
  _check_private_redeclaration$o(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$n(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$n(receiver, privateMap, "set");
  _class_apply_descriptor_set$n(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$c(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$c(obj, privateSet) {
  _check_private_redeclaration$o(obj, privateSet);
  privateSet.add(obj);
}
var _cellsHorizontalOrder = /* @__PURE__ */ new WeakMap(), _cellsVerticalOrder = /* @__PURE__ */ new WeakMap(), _currentHorizontalLinkedNode = /* @__PURE__ */ new WeakMap(), _currentVerticalLinkedNode = /* @__PURE__ */ new WeakMap(), _mergedCellsGetter = /* @__PURE__ */ new WeakMap(), _rowIndexMapper = /* @__PURE__ */ new WeakMap(), _columnIndexMapper = /* @__PURE__ */ new WeakMap(), _pushOrderNode = /* @__PURE__ */ new WeakSet();
class FocusOrder {
  /**
  * Gets the currently selected node data from the vertical focus order list.
  *
  * @returns {NodeStructure}
  */
  getCurrentVerticalNode() {
    return _class_private_field_get$n(this, _currentVerticalLinkedNode)?.data;
  }
  /**
  * Gets the first node data from the vertical focus order list.
  *
  * @returns {NodeStructure}
  */
  getFirstVerticalNode() {
    return _class_private_field_get$n(this, _cellsVerticalOrder).first?.data;
  }
  /**
  * Gets the next selected node data from the vertical focus order list.
  *
  * @returns {FocusNodeData}
  */
  getNextVerticalNode() {
    return _class_private_field_get$n(this, _currentVerticalLinkedNode)?.next?.data;
  }
  /**
  * Gets the previous selected node data from the vertical focus order list.
  *
  * @returns {FocusNodeData}
  */
  getPrevVerticalNode() {
    return _class_private_field_get$n(this, _currentVerticalLinkedNode)?.prev?.data;
  }
  /**
  * Gets the currently selected node data from the horizontal focus order list.
  *
  * @returns {NodeStructure}
  */
  getCurrentHorizontalNode() {
    return _class_private_field_get$n(this, _currentHorizontalLinkedNode)?.data;
  }
  /**
  * Gets the first node data from the horizontal focus order list.
  *
  * @returns {NodeStructure}
  */
  getFirstHorizontalNode() {
    return _class_private_field_get$n(this, _cellsHorizontalOrder).first?.data;
  }
  /**
  * Gets the next selected node data from the horizontal focus order list.
  *
  * @returns {FocusNodeData}
  */
  getNextHorizontalNode() {
    return _class_private_field_get$n(this, _currentHorizontalLinkedNode)?.next?.data;
  }
  /**
  * Gets the previous selected node data from the horizontal focus order list.
  *
  * @returns {FocusNodeData}
  */
  getPrevHorizontalNode() {
    return _class_private_field_get$n(this, _currentHorizontalLinkedNode)?.prev?.data;
  }
  /**
  * Sets the previous node from the vertical focus order list as active.
  */
  setPrevNodeAsActive() {
    if (_class_private_field_get$n(this, _currentVerticalLinkedNode)) {
      _class_private_field_set$n(this, _currentVerticalLinkedNode, _class_private_field_get$n(this, _currentVerticalLinkedNode).prev);
    }
    if (_class_private_field_get$n(this, _currentHorizontalLinkedNode)) {
      _class_private_field_set$n(this, _currentHorizontalLinkedNode, _class_private_field_get$n(this, _currentHorizontalLinkedNode).prev);
    }
  }
  /**
  * Sets the previous node from the horizontal focus order list as active.
  */
  setNextNodeAsActive() {
    if (_class_private_field_get$n(this, _currentVerticalLinkedNode)) {
      _class_private_field_set$n(this, _currentVerticalLinkedNode, _class_private_field_get$n(this, _currentVerticalLinkedNode).next);
    }
    if (_class_private_field_get$n(this, _currentHorizontalLinkedNode)) {
      _class_private_field_set$n(this, _currentHorizontalLinkedNode, _class_private_field_get$n(this, _currentHorizontalLinkedNode).next);
    }
  }
  /**
  * Rebuilds the focus order list based on the provided selection.
  *
  * @param {CellRange[]} selectedRanges The selected ranges to build the focus order for.
  */
  buildFocusOrder(selectedRanges) {
    _class_private_field_set$n(this, _cellsHorizontalOrder, new LinkedList());
    selectedRanges.forEach((range, selectionLayer) => {
      const visitedHorizontalCells = /* @__PURE__ */ new WeakSet();
      const topStart = range.getTopStartCorner();
      const bottomEnd = range.getBottomEndCorner();
      const rowFrom = topStart.row ?? 0;
      const rowTo = bottomEnd.row ?? 0;
      const colFrom = topStart.col ?? 0;
      const colTo = bottomEnd.col ?? 0;
      for (let r = rowFrom; r <= rowTo; r++) {
        if (_class_private_field_get$n(this, _rowIndexMapper).isHidden(r)) {
          continue;
        }
        for (let c = colFrom; c <= colTo; c++) {
          if (_class_private_field_get$n(this, _columnIndexMapper).isHidden(c)) {
            continue;
          }
          const node = _class_private_method_get$c(this, _pushOrderNode, pushOrderNode).call(this, {
            selectedRange: range,
            selectionLayer,
            listOrder: _class_private_field_get$n(this, _cellsHorizontalOrder),
            mergeCellsVisitor: visitedHorizontalCells,
            row: r,
            column: c
          });
          if (node) {
            _class_private_field_set$n(this, _currentHorizontalLinkedNode, node);
          }
        }
      }
    });
    if (_class_private_field_get$n(this, _cellsHorizontalOrder).first && _class_private_field_get$n(this, _cellsHorizontalOrder).last) {
      _class_private_field_get$n(this, _cellsHorizontalOrder).first.prev = _class_private_field_get$n(this, _cellsHorizontalOrder).last;
      _class_private_field_get$n(this, _cellsHorizontalOrder).last.next = _class_private_field_get$n(this, _cellsHorizontalOrder).first;
    }
    _class_private_field_set$n(this, _cellsVerticalOrder, new LinkedList());
    selectedRanges.forEach((range, selectionLayer) => {
      const visitedVerticalCells = /* @__PURE__ */ new WeakSet();
      const topStart = range.getTopStartCorner();
      const bottomEnd = range.getBottomEndCorner();
      const rowFrom = topStart.row ?? 0;
      const rowTo = bottomEnd.row ?? 0;
      const colFrom = topStart.col ?? 0;
      const colTo = bottomEnd.col ?? 0;
      for (let c = colFrom; c <= colTo; c++) {
        if (_class_private_field_get$n(this, _columnIndexMapper).isHidden(c)) {
          continue;
        }
        for (let r = rowFrom; r <= rowTo; r++) {
          if (_class_private_field_get$n(this, _rowIndexMapper).isHidden(r)) {
            continue;
          }
          const node = _class_private_method_get$c(this, _pushOrderNode, pushOrderNode).call(this, {
            selectedRange: range,
            selectionLayer,
            listOrder: _class_private_field_get$n(this, _cellsVerticalOrder),
            mergeCellsVisitor: visitedVerticalCells,
            row: r,
            column: c
          });
          if (node) {
            _class_private_field_set$n(this, _currentVerticalLinkedNode, node);
          }
        }
      }
    });
    if (_class_private_field_get$n(this, _cellsVerticalOrder).first && _class_private_field_get$n(this, _cellsVerticalOrder).last) {
      _class_private_field_get$n(this, _cellsVerticalOrder).first.prev = _class_private_field_get$n(this, _cellsVerticalOrder).last;
      _class_private_field_get$n(this, _cellsVerticalOrder).last.next = _class_private_field_get$n(this, _cellsVerticalOrder).first;
    }
  }
  /**
  * Sets the active node based on the provided row and column.
  *
  * @param {number} row The visual row index.
  * @param {number} column The visual column index.
  * @param {number} selectionLayerIndex The index of the selection layer to which the focus should be marked as active.
  * @returns {FocusOrder}
  */
  setActiveNode(row, column, selectionLayerIndex) {
    _class_private_field_get$n(this, _cellsHorizontalOrder).inorder((node) => {
      const { selectionLayer, rowStart, rowEnd, colStart, colEnd } = node.data;
      if (selectionLayer === selectionLayerIndex && row >= rowStart && row <= rowEnd && column >= colStart && column <= colEnd) {
        _class_private_field_set$n(this, _currentHorizontalLinkedNode, node);
        return true;
      }
    });
    _class_private_field_get$n(this, _cellsVerticalOrder).inorder((node) => {
      const { selectionLayer, rowStart, rowEnd, colStart, colEnd } = node.data;
      if (selectionLayer === selectionLayerIndex && row >= rowStart && row <= rowEnd && column >= colStart && column <= colEnd) {
        _class_private_field_set$n(this, _currentVerticalLinkedNode, node);
        return true;
      }
    });
    return this;
  }
  /**
  * Initializes the focus order manager with the merged cell getter and row and column index mappers used to navigate focus through merged regions.
  */
  constructor({ mergedCellsGetter, rowIndexMapper, columnIndexMapper }) {
    _class_private_method_init$c(this, _pushOrderNode);
    _class_private_field_init$n(this, _cellsHorizontalOrder, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$n(this, _cellsVerticalOrder, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$n(this, _currentHorizontalLinkedNode, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$n(this, _currentVerticalLinkedNode, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$n(this, _mergedCellsGetter, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$n(this, _rowIndexMapper, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$n(this, _columnIndexMapper, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$n(this, _cellsHorizontalOrder, new LinkedList());
    _class_private_field_set$n(this, _cellsVerticalOrder, new LinkedList());
    _class_private_field_set$n(this, _currentHorizontalLinkedNode, null);
    _class_private_field_set$n(this, _currentVerticalLinkedNode, null);
    _class_private_field_set$n(this, _mergedCellsGetter, mergedCellsGetter);
    _class_private_field_set$n(this, _rowIndexMapper, rowIndexMapper);
    _class_private_field_set$n(this, _columnIndexMapper, columnIndexMapper);
  }
}
function pushOrderNode({ selectedRange, selectionLayer, listOrder, mergeCellsVisitor, row, column }) {
  const topStart = selectedRange.getTopStartCorner();
  const bottomEnd = selectedRange.getBottomEndCorner();
  const topStartRow = topStart.row ?? 0;
  const topStartCol = topStart.col ?? 0;
  const bottomEndRow = bottomEnd.row ?? 0;
  const bottomEndCol = bottomEnd.col ?? 0;
  const highlight = selectedRange.highlight.clone().normalize();
  const highlightRow = highlight.row ?? 0;
  const highlightCol = highlight.col ?? 0;
  const mergeParent = _class_private_field_get$n(this, _mergedCellsGetter).call(this, row, column);
  if (mergeParent && mergeCellsVisitor.has(mergeParent)) {
    return null;
  }
  const node = {
    selectionLayer,
    colStart: column,
    colEnd: column,
    rowStart: row,
    rowEnd: row
  };
  if (mergeParent) {
    mergeCellsVisitor.add(mergeParent);
    if (mergeParent.row < topStartRow || mergeParent.row + mergeParent.rowspan - 1 > bottomEndRow || mergeParent.col < topStartCol || mergeParent.col + mergeParent.colspan - 1 > bottomEndCol) {
      return null;
    }
    node.colStart = mergeParent.col;
    node.colEnd = mergeParent.col + mergeParent.colspan - 1;
    node.rowStart = mergeParent.row;
    node.rowEnd = mergeParent.row + mergeParent.rowspan - 1;
  }
  const linkedNode = listOrder.push(node);
  if (row === highlightRow && column === highlightCol || mergeParent && highlightRow >= mergeParent.row && highlightRow <= mergeParent.row + mergeParent.rowspan - 1 && highlightCol >= mergeParent.col && highlightCol <= mergeParent.col + mergeParent.colspan - 1) {
    return linkedNode;
  }
  return null;
}
function sumCellsHeights(hotInstance, row, rowspan) {
  const { rowIndexMapper, stylesHandler } = hotInstance;
  let height = 0;
  for (let i = row; i < row + rowspan; i++) {
    if (!rowIndexMapper.isHidden(i)) {
      height += hotInstance.getRowHeight(i) ?? stylesHandler.getDefaultRowHeight(i);
    }
  }
  return height;
}
function clampToVirtualViewport(hot, notHiddenRow, notHiddenColumn) {
  const overlayName = hot.view.getActiveOverlayName();
  if (![
    "top",
    "top_inline_start_corner"
  ].includes(overlayName)) {
    const firstRenderedVisibleRow = hot.getFirstRenderedVisibleRow();
    if (notHiddenRow !== null && firstRenderedVisibleRow !== null) {
      notHiddenRow = Math.max(notHiddenRow, firstRenderedVisibleRow);
    }
  }
  if (![
    "inline_start",
    "top_inline_start_corner",
    "bottom_inline_start_corner"
  ].includes(overlayName)) {
    const firstRenderedVisibleColumn = hot.getFirstRenderedVisibleColumn();
    if (notHiddenColumn !== null && firstRenderedVisibleColumn !== null) {
      notHiddenColumn = Math.max(notHiddenColumn, firstRenderedVisibleColumn);
    }
  }
  return [
    notHiddenRow,
    notHiddenColumn
  ];
}
function createMergeCellRenderer(plugin) {
  const hot = plugin.hot;
  const { rowIndexMapper: rowMapper, columnIndexMapper: columnMapper } = hot;
  const updateNextCellsHeight = /* @__PURE__ */ new Map();
  function before() {
  }
  function after(TD, row, col) {
    const mergedCell = plugin.mergedCellsCollection.get(row, col);
    if (mergedCell === false) {
      TD.removeAttribute("rowspan");
      TD.removeAttribute("colspan");
      if (updateNextCellsHeight.has(row) && !hot.getSettings().rowHeaders) {
        TD.style.height = `${updateNextCellsHeight.get(row)}px`;
        updateNextCellsHeight.delete(row);
      }
      TD.style.display = "";
      return;
    }
    const { row: origRow, col: origColumn, colspan: origColspan, rowspan: origRowspan } = mergedCell;
    const [lastMergedRowIndex, lastMergedColumnIndex] = plugin.translateMergedCellToRenderable(origRow, origRowspan, origColumn, origColspan);
    const isVirtualRenderingEnabled = plugin.getSetting("virtualized");
    if (origColumn === 0 && !hot.getSettings().rowHeaders) {
      const rowHeights = hot._getRowHeightFromSettings(row);
      if (rowHeights !== void 0) {
        const borderBoxSizing = hot.stylesHandler.areCellsBorderBox();
        const borderCompensation = borderBoxSizing ? 0 : 1;
        updateNextCellsHeight.set(row, rowHeights - borderCompensation);
      } else if (isSafari()) {
        const height = sumCellsHeights(hot, origRow, origRowspan);
        updateNextCellsHeight.set(row, height / origRowspan);
      }
    }
    const renderedRowIndex = rowMapper.getRenderableFromVisualIndex(row) ?? 0;
    const renderedColumnIndex = columnMapper.getRenderableFromVisualIndex(col) ?? 0;
    const maxRowSpan = lastMergedRowIndex - renderedRowIndex + 1;
    const maxColSpan = lastMergedColumnIndex - renderedColumnIndex + 1;
    let notHiddenRow = rowMapper.getNearestNotHiddenIndex(origRow, 1);
    let notHiddenColumn = columnMapper.getNearestNotHiddenIndex(origColumn, 1);
    if (isVirtualRenderingEnabled) {
      [notHiddenRow, notHiddenColumn] = clampToVirtualViewport(hot, notHiddenRow, notHiddenColumn);
    }
    const notHiddenRowspan = Math.min(origRowspan, maxRowSpan);
    const notHiddenColspan = Math.min(origColspan, maxColSpan);
    if (notHiddenRow === row && notHiddenColumn === col) {
      TD.setAttribute("rowspan", String(notHiddenRowspan));
      TD.setAttribute("colspan", String(notHiddenColspan));
    } else {
      TD.removeAttribute("rowspan");
      TD.removeAttribute("colspan");
      TD.style.display = "none";
    }
  }
  return {
    before,
    after
  };
}
function _check_private_redeclaration$n(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$m(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$m(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$m(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$m(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$m(receiver, privateMap, "get");
  return _class_apply_descriptor_get$m(receiver, descriptor);
}
function _class_private_field_init$m(obj, privateMap, value) {
  _check_private_redeclaration$n(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$m(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$m(receiver, privateMap, "set");
  _class_apply_descriptor_set$m(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$b(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$b(obj, privateSet) {
  _check_private_redeclaration$n(obj, privateSet);
  privateSet.add(obj);
}
Hooks.getSingleton().register("beforeMergeCells");
Hooks.getSingleton().register("afterMergeCells");
Hooks.getSingleton().register("beforeUnmergeCells");
Hooks.getSingleton().register("afterUnmergeCells");
const PLUGIN_KEY$e = "mergeCells";
const PLUGIN_PRIORITY$e = 150;
const SHORTCUTS_GROUP$5 = PLUGIN_KEY$e;
var _lastSelectedFocus = /* @__PURE__ */ new WeakMap(), _lastFocusDelta = /* @__PURE__ */ new WeakMap(), _focusOrder = /* @__PURE__ */ new WeakMap(), _cellRenderer = /* @__PURE__ */ new WeakMap(), _columnMoveSnapshot = /* @__PURE__ */ new WeakMap(), _rowMoveSnapshot = /* @__PURE__ */ new WeakMap(), _initialized = /* @__PURE__ */ new WeakMap(), _onAfterInit$2 = /* @__PURE__ */ new WeakMap(), _onAfterIsMultipleSelection = /* @__PURE__ */ new WeakMap(), _onModifyTransformFocus = /* @__PURE__ */ new WeakMap(), _onModifyTransformStart$1 = /* @__PURE__ */ new WeakMap(), _onModifyTransformEnd = /* @__PURE__ */ new WeakMap(), _onBeforeSelectionHighlightSet$2 = /* @__PURE__ */ new WeakMap(), _onModifyGetCellCoords = /* @__PURE__ */ new WeakMap(), _addMergeActionsToContextMenu = /* @__PURE__ */ new WeakSet(), _onBeforeSetRangeStart = /* @__PURE__ */ new WeakMap(), _onBeforeSelectionFocusSet = /* @__PURE__ */ new WeakMap(), _onAfterSelectionFocusSet = /* @__PURE__ */ new WeakMap(), _onAfterSelectionEnd = /* @__PURE__ */ new WeakMap(), _onAfterGetCellMeta = /* @__PURE__ */ new WeakMap(), _onAfterViewportRowCalculatorOverride = /* @__PURE__ */ new WeakMap(), _onAfterViewportColumnCalculatorOverride$1 = /* @__PURE__ */ new WeakMap(), _onModifyAutofillRange = /* @__PURE__ */ new WeakMap(), _onAfterCreateCol$1 = /* @__PURE__ */ new WeakMap(), _onAfterRemoveCol$1 = /* @__PURE__ */ new WeakMap(), _onAfterCreateRow$1 = /* @__PURE__ */ new WeakMap(), _onAfterRemoveRow$1 = /* @__PURE__ */ new WeakMap(), _onBeforeColumnMove = /* @__PURE__ */ new WeakMap(), _onAfterColumnMove = /* @__PURE__ */ new WeakMap(), _onBeforeRowMove$1 = /* @__PURE__ */ new WeakMap(), _onAfterRowMove = /* @__PURE__ */ new WeakMap(), _onBeforeColumnFreeze = /* @__PURE__ */ new WeakMap(), _onAfterColumnFreeze = /* @__PURE__ */ new WeakMap(), _onAfterChange$1 = /* @__PURE__ */ new WeakMap(), _onBeforeDrawAreaBorders = /* @__PURE__ */ new WeakMap(), _onAfterDrawSelection = /* @__PURE__ */ new WeakMap(), _onBeforeRemoveCellClassNames = /* @__PURE__ */ new WeakMap(), _onBeforeBeginEditing = /* @__PURE__ */ new WeakMap(), _onModifyRowHeightByOverlayName = /* @__PURE__ */ new WeakMap();
class MergeCells extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$e;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$e;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    const cells = [];
    return {
      [defaultMainSettingSymbol]: "cells",
      virtualized: false,
      cells
    };
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link MergeCells#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$e];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.mergedCellsCollection = new MergedCellsCollection(this);
    this.autofillCalculations = new AutofillCalculations(this);
    this.selectionCalculations = new SelectionCalculations(this);
    this.addHook("afterInit", _class_private_field_get$m(this, _onAfterInit$2));
    this.addHook("modifyTransformFocus", _class_private_field_get$m(this, _onModifyTransformFocus));
    this.addHook("modifyTransformStart", _class_private_field_get$m(this, _onModifyTransformStart$1));
    this.addHook("modifyTransformEnd", _class_private_field_get$m(this, _onModifyTransformEnd));
    this.addHook("beforeSelectionHighlightSet", _class_private_field_get$m(this, _onBeforeSelectionHighlightSet$2));
    this.addHook("beforeSetRangeStart", _class_private_field_get$m(this, _onBeforeSetRangeStart));
    this.addHook("beforeSetRangeStartOnly", _class_private_field_get$m(this, _onBeforeSetRangeStart));
    this.addHook("beforeSelectionFocusSet", _class_private_field_get$m(this, _onBeforeSelectionFocusSet));
    this.addHook("afterSelectionFocusSet", _class_private_field_get$m(this, _onAfterSelectionFocusSet));
    this.addHook("afterSelectionEnd", _class_private_field_get$m(this, _onAfterSelectionEnd));
    this.addHook("modifyGetCellCoords", _class_private_field_get$m(this, _onModifyGetCellCoords));
    this.addHook("modifyGetCoordsElement", _class_private_field_get$m(this, _onModifyGetCellCoords));
    this.addHook("afterIsMultipleSelection", _class_private_field_get$m(this, _onAfterIsMultipleSelection));
    this.addHook("afterRenderer", (TD, row, col) => _class_private_field_get$m(this, _cellRenderer).after(TD, row, col));
    this.addHook("afterContextMenuDefaultOptions", (defaultOptions) => _class_private_method_get$b(this, _addMergeActionsToContextMenu, addMergeActionsToContextMenu).call(this, defaultOptions));
    this.addHook("afterGetCellMeta", _class_private_field_get$m(this, _onAfterGetCellMeta));
    this.addHook("afterViewportRowCalculatorOverride", _class_private_field_get$m(this, _onAfterViewportRowCalculatorOverride));
    this.addHook("afterViewportColumnCalculatorOverride", _class_private_field_get$m(this, _onAfterViewportColumnCalculatorOverride$1));
    this.addHook("modifyAutofillRange", _class_private_field_get$m(this, _onModifyAutofillRange));
    this.addHook("afterCreateCol", _class_private_field_get$m(this, _onAfterCreateCol$1));
    this.addHook("afterRemoveCol", _class_private_field_get$m(this, _onAfterRemoveCol$1));
    this.addHook("afterCreateRow", _class_private_field_get$m(this, _onAfterCreateRow$1));
    this.addHook("afterRemoveRow", _class_private_field_get$m(this, _onAfterRemoveRow$1));
    this.addHook("beforeColumnMove", _class_private_field_get$m(this, _onBeforeColumnMove));
    this.addHook("afterColumnMove", _class_private_field_get$m(this, _onAfterColumnMove));
    this.addHook("beforeRowMove", _class_private_field_get$m(this, _onBeforeRowMove$1));
    this.addHook("afterRowMove", _class_private_field_get$m(this, _onAfterRowMove));
    this.addHook("beforeColumnFreeze", _class_private_field_get$m(this, _onBeforeColumnFreeze));
    this.addHook("afterColumnFreeze", _class_private_field_get$m(this, _onAfterColumnFreeze));
    this.addHook("beforeColumnUnfreeze", _class_private_field_get$m(this, _onBeforeColumnFreeze));
    this.addHook("afterColumnUnfreeze", _class_private_field_get$m(this, _onAfterColumnFreeze));
    this.addHook("afterChange", _class_private_field_get$m(this, _onAfterChange$1));
    this.addHook("beforeDrawBorders", _class_private_field_get$m(this, _onBeforeDrawAreaBorders));
    this.addHook("afterDrawSelection", _class_private_field_get$m(this, _onAfterDrawSelection));
    this.addHook("beforeRemoveCellClassNames", _class_private_field_get$m(this, _onBeforeRemoveCellClassNames));
    this.addHook("beforeBeginEditing", _class_private_field_get$m(this, _onBeforeBeginEditing));
    this.addHook("modifyRowHeightByOverlayName", _class_private_field_get$m(this, _onModifyRowHeightByOverlayName));
    this.addHook("beforeUndoStackChange", (action, source) => {
      if (source === "MergeCells") {
        return false;
      }
    });
    this.registerShortcuts();
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.clearCollections();
    this.unregisterShortcuts();
    this.hot.render();
    _class_private_field_set$m(this, _initialized, false);
    super.disablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the
  * following configuration options:
  *  - [`mergeCells`](@/api/options.md#mergecells)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    this.generateFromSettings();
    _class_private_field_set$m(this, _initialized, true);
    super.updatePlugin();
  }
  /**
  * If the browser is recognized as Chrome, force an additional repaint to prevent showing the effects of a Chrome bug.
  *
  * Issue described in https://github.com/handsontable/dev-handsontable/issues/521.
  *
  * @private
  */
  ifChromeForceRepaint() {
    if (!isChrome()) {
      return;
    }
    const rowsToRefresh = [];
    let rowIndexesToRefresh = [];
    this.mergedCellsCollection.mergedCells.forEach((mergedCell) => {
      const { row, rowspan } = mergedCell;
      for (let r = row + 1; r < row + rowspan; r++) {
        rowIndexesToRefresh.push(r);
      }
    });
    rowIndexesToRefresh = [
      ...new Set(rowIndexesToRefresh)
    ];
    rowIndexesToRefresh.forEach((rowIndex) => {
      const renderableRowIndex = this.hot.rowIndexMapper.getRenderableFromVisualIndex(rowIndex);
      if (renderableRowIndex === null) {
        return;
      }
      this.hot.view._wt.wtOverlays.getOverlays(true).map((overlay) => overlay.name === "master" ? overlay : overlay.clone.wtTable).forEach((wtTableRef) => {
        const rowToRefresh = wtTableRef.getRow(renderableRowIndex);
        if (rowToRefresh) {
          rowToRefresh.style.background = getStyle(rowToRefresh, "backgroundColor")?.replace(")", ", 0.99)") ?? "";
          rowsToRefresh.push(rowToRefresh);
        }
      });
    });
    this.hot._registerTimeout(() => {
      rowsToRefresh.forEach((rowElement) => {
        rowElement.style.background = getStyle(rowElement, "backgroundColor")?.replace(", 0.99)", "") ?? "";
      });
    }, 1);
  }
  /**
  * Validates a single setting object, represented by a single merged cell information object.
  *
  * @private
  * @param {object} setting An object with `row`, `col`, `rowspan` and `colspan` properties.
  * @returns {boolean}
  */
  validateSetting(setting) {
    if (!setting) {
      return false;
    }
    if (MergedCellCoords.containsNegativeValues(setting)) {
      warn$1(MergedCellCoords.NEGATIVE_VALUES_WARNING(setting));
      return false;
    }
    if (MergedCellCoords.isOutOfBounds(setting, this.hot.countRows(), this.hot.countCols())) {
      warn$1(MergedCellCoords.IS_OUT_OF_BOUNDS_WARNING(setting));
      return false;
    }
    if (MergedCellCoords.isSingleCell(setting)) {
      warn$1(MergedCellCoords.IS_SINGLE_CELL(setting));
      return false;
    }
    if (MergedCellCoords.containsZeroSpan(setting)) {
      warn$1(MergedCellCoords.ZERO_SPAN_WARNING(setting));
      return false;
    }
    return true;
  }
  /**
  * Generates the merged cells from the settings provided to the plugin.
  *
  * @private
  */
  generateFromSettings() {
    const validSettings = this.getSetting("cells").filter((mergeCellInfo) => this.validateSetting(mergeCellInfo));
    const nonOverlappingSettings = this.mergedCellsCollection.filterOverlappingMergeCells(validSettings);
    const populatedNulls = [];
    nonOverlappingSettings.forEach((mergeCellInfo) => {
      const { row, col, rowspan, colspan } = mergeCellInfo;
      const from = this.hot._createCellCoords(row, col);
      const to = this.hot._createCellCoords(row + rowspan - 1, col + colspan - 1);
      const mergeRange = this.hot._createCellRange(from, from, to);
      this.mergeRange(mergeRange, true, true);
      for (let r = row; r < row + rowspan; r++) {
        for (let c = col; c < col + colspan; c++) {
          if (r !== row || c !== col) {
            populatedNulls.push([
              r,
              c,
              null
            ]);
          }
        }
      }
    });
    if (populatedNulls.length === 0) {
      return;
    }
    this.hot.setDataAtCell(populatedNulls, void 0, void 0, this.pluginName ?? void 0);
  }
  /**
  * Clears the merged cells from the merged cell container.
  */
  clearCollections() {
    this.mergedCellsCollection.clear();
  }
  /**
  * Returns `true` if a range is mergeable.
  *
  * @private
  * @param {object} newMergedCellInfo Merged cell information object to test.
  * @param {boolean} [auto=false] `true` if triggered at initialization.
  * @returns {boolean}
  */
  canMergeRange(newMergedCellInfo, auto = false) {
    return auto ? true : this.validateSetting(newMergedCellInfo);
  }
  /**
  * Merges the selection provided as a cell range.
  *
  * @param {CellRange} [cellRange] Selection cell range.
  */
  mergeSelection(cellRange = this.hot.getSelectedRangeActive()) {
    if (!cellRange) {
      return;
    }
    cellRange.setDirection(this.hot.isRtl() ? "NE-SW" : "NW-SE");
    const { from, to } = cellRange;
    this.unmergeRange(cellRange, true);
    this.mergeRange(cellRange);
    if (from.row !== null && from.col !== null && to.row !== null && to.col !== null) {
      this.hot.selectCell(from.row, from.col, to.row, to.col, false);
    }
  }
  /**
  * Unmerges the selection provided as a cell range.
  *
  * @param {CellRange} [cellRange] Selection cell range.
  */
  unmergeSelection(cellRange = this.hot.getSelectedRangeActive()) {
    if (!cellRange) {
      return;
    }
    const { from, to } = cellRange;
    this.unmergeRange(cellRange, true);
    if (from.row !== null && from.col !== null && to.row !== null && to.col !== null) {
      this.hot.selectCell(from.row, from.col, to.row, to.col, false);
    }
  }
  /**
  * Merges cells in the provided cell range.
  *
  * @private
  * @param {CellRange} cellRange Cell range to merge.
  * @param {boolean} [auto=false] `true` if is called automatically, e.g. At initialization.
  * @param {boolean} [preventPopulation=false] `true`, if the method should not run `populateFromArray` at the end,
  *   but rather return its arguments.
  * @returns {Array|boolean} Returns an array of [row, column, dataUnderCollection] if preventPopulation is set to
  *   true. If the the merging process went successful, it returns `true`, otherwise - `false`.
  * @fires Hooks#beforeMergeCells
  * @fires Hooks#afterMergeCells
  */
  mergeRange(cellRange, auto = false, preventPopulation = false) {
    const topStart = cellRange.getTopStartCorner();
    const bottomEnd = cellRange.getBottomEndCorner();
    if (topStart.row === null || topStart.col === null || bottomEnd.row === null || bottomEnd.col === null) {
      return false;
    }
    const mergeParent = {
      row: topStart.row,
      col: topStart.col,
      rowspan: bottomEnd.row - topStart.row + 1,
      colspan: bottomEnd.col - topStart.col + 1
    };
    const clearedData = [];
    let populationInfo = null;
    if (!this.canMergeRange(mergeParent, auto)) {
      return false;
    }
    this.hot.runHooks("beforeMergeCells", cellRange, auto);
    rangeEach(0, mergeParent.rowspan - 1, (i) => {
      rangeEach(0, mergeParent.colspan - 1, (j) => {
        let clearedValue = null;
        if (!clearedData[i]) {
          clearedData[i] = [];
        }
        if (i === 0 && j === 0) {
          clearedValue = this.hot.getSourceDataAtCell(this.hot.toPhysicalRow(mergeParent.row), this.hot.toPhysicalColumn(mergeParent.col));
        } else {
          this.hot.setCellMeta(mergeParent.row + i, mergeParent.col + j, "hidden", true);
        }
        clearedData[i][j] = clearedValue;
      });
    });
    this.hot.setCellMeta(mergeParent.row, mergeParent.col, "spanned", true);
    const mergedCellAdded = this.mergedCellsCollection.add(mergeParent, auto);
    if (mergedCellAdded) {
      if (preventPopulation) {
        populationInfo = [
          mergeParent.row,
          mergeParent.col,
          clearedData
        ];
      } else {
        this.hot.populateFromArray(mergeParent.row, mergeParent.col, clearedData, void 0, void 0, this.pluginName ?? void 0);
      }
      if (!auto) {
        this.ifChromeForceRepaint();
      }
      this.hot.runHooks("afterMergeCells", cellRange, mergeParent, auto);
      return populationInfo;
    }
    return true;
  }
  /**
  * Unmerges the selection provided as a cell range. If no cell range is provided, it uses the current selection.
  *
  * @private
  * @param {CellRange} cellRange Selection cell range.
  * @param {boolean} [auto=false] `true` if called automatically by the plugin.
  *
  * @fires Hooks#beforeUnmergeCells
  * @fires Hooks#afterUnmergeCells
  */
  unmergeRange(cellRange, auto = false) {
    const mergedCells = this.mergedCellsCollection.getWithinRange(cellRange);
    if (mergedCells.length === 0) {
      return;
    }
    this.hot.runHooks("beforeUnmergeCells", cellRange, auto);
    arrayEach(mergedCells, (currentCollection) => {
      this.mergedCellsCollection.remove(currentCollection.row, currentCollection.col);
      rangeEach(0, currentCollection.rowspan - 1, (i) => {
        rangeEach(0, currentCollection.colspan - 1, (j) => {
          this.hot.removeCellMeta(currentCollection.row + i, currentCollection.col + j, "hidden");
          this.hot.removeCellMeta(currentCollection.row + i, currentCollection.col + j, "copyable");
        });
      });
      this.hot.removeCellMeta(currentCollection.row, currentCollection.col, "spanned");
    });
    this.hot.runHooks("afterUnmergeCells", cellRange, auto);
    this.hot.render();
  }
  /**
  * Merges or unmerges, based on the cell range provided as `cellRange`.
  *
  * @private
  * @param {CellRange} cellRange The cell range to merge or unmerged.
  */
  toggleMerge(cellRange) {
    const { from, to } = cellRange.clone().normalize();
    if (from.row === null || from.col === null || to.row === null || to.col === null) {
      return;
    }
    const mergedCell = this.mergedCellsCollection.get(from.row, from.col);
    const mergedCellCoversWholeRange = mergedCell !== false && mergedCell.row === from.row && mergedCell.col === from.col && mergedCell.row + mergedCell.rowspan - 1 === to.row && mergedCell.col + mergedCell.colspan - 1 === to.col;
    if (mergedCellCoversWholeRange) {
      this.unmergeRange(cellRange);
    } else {
      this.mergeSelection(cellRange);
    }
  }
  /**
  * Merges the specified range.
  *
  * @param {number} startRow Start row of the merged cell.
  * @param {number} startColumn Start column of the merged cell.
  * @param {number} endRow End row of the merged cell.
  * @param {number} endColumn End column of the merged cell.
  * @fires Hooks#beforeMergeCells
  * @fires Hooks#afterMergeCells
  */
  merge(startRow, startColumn, endRow, endColumn) {
    const start = this.hot._createCellCoords(startRow, startColumn);
    const end = this.hot._createCellCoords(endRow, endColumn);
    this.mergeRange(this.hot._createCellRange(start, start, end));
  }
  /**
  * Unmerges the merged cell in the provided range.
  *
  * @param {number} startRow Start row of the merged cell.
  * @param {number} startColumn Start column of the merged cell.
  * @param {number} endRow End row of the merged cell.
  * @param {number} endColumn End column of the merged cell.
  * @fires Hooks#beforeUnmergeCells
  * @fires Hooks#afterUnmergeCells
  */
  unmerge(startRow, startColumn, endRow, endColumn) {
    const start = this.hot._createCellCoords(startRow, startColumn);
    const end = this.hot._createCellCoords(endRow, endColumn);
    this.unmergeRange(this.hot._createCellRange(start, start, end));
  }
  /**
  * Register shortcuts responsible for toggling a merge.
  *
  * @private
  */
  registerShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const gridContext = shortcutManager.getContext("grid");
    if (!gridContext) {
      return;
    }
    gridContext.addShortcut({
      keys: [
        [
          "Control",
          "m"
        ]
      ],
      callback: () => {
        const range = this.hot.getSelectedRangeActive();
        if (range && !range.isSingleHeader()) {
          this.toggleMerge(range);
          this.hot.render();
        }
      },
      runOnlyIf: (event) => !event?.altKey,
      group: SHORTCUTS_GROUP$5
    });
  }
  /**
  * Unregister shortcuts responsible for toggling a merge.
  *
  * @private
  */
  unregisterShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const gridContext = shortcutManager.getContext("grid");
    gridContext?.removeShortcutsByGroup(SHORTCUTS_GROUP$5);
  }
  /**
  * Modify viewport start when needed.
  *
  * @private
  * @param {object} calc The row calculator object.
  * @param {number} nrOfColumns Number of visual columns.
  */
  modifyViewportRowStart(calc, nrOfColumns) {
    const rowMapper = this.hot.rowIndexMapper;
    const visualStartRow = rowMapper.getVisualFromRenderableIndex(calc.startRow) ?? 0;
    for (let visualColumnIndex = 0; visualColumnIndex < nrOfColumns; visualColumnIndex += 1) {
      const mergeParentForViewportStart = this.mergedCellsCollection.get(visualStartRow, visualColumnIndex);
      if (mergeParentForViewportStart !== false) {
        const nearestNotHiddenRow = rowMapper.getNearestNotHiddenIndex(mergeParentForViewportStart.row, 1);
        const renderableIndexAtMergeStart = nearestNotHiddenRow !== null ? rowMapper.getRenderableFromVisualIndex(nearestNotHiddenRow) : null;
        if (renderableIndexAtMergeStart !== null && renderableIndexAtMergeStart < calc.startRow) {
          calc.startRow = renderableIndexAtMergeStart;
          this.modifyViewportRowStart(calc, nrOfColumns);
          return;
        }
      }
    }
  }
  /**
  * Modify viewport end when needed.
  *
  * @private
  * @param {object} calc The row calculator object.
  * @param {number} nrOfColumns Number of visual columns.
  */
  modifyViewportRowEnd(calc, nrOfColumns) {
    const rowMapper = this.hot.rowIndexMapper;
    const visualEndRow = rowMapper.getVisualFromRenderableIndex(calc.endRow) ?? 0;
    for (let visualColumnIndex = 0; visualColumnIndex < nrOfColumns; visualColumnIndex += 1) {
      const mergeParentForViewportEnd = this.mergedCellsCollection.get(visualEndRow, visualColumnIndex);
      if (mergeParentForViewportEnd !== false) {
        const mergeEnd = mergeParentForViewportEnd.row + mergeParentForViewportEnd.rowspan - 1;
        const nearestRow = rowMapper.getNearestNotHiddenIndex(mergeEnd, -1);
        if (nearestRow !== null) {
          const renderableIndexAtMergeEnd = rowMapper.getRenderableFromVisualIndex(nearestRow);
          if (renderableIndexAtMergeEnd !== null && renderableIndexAtMergeEnd > calc.endRow) {
            calc.endRow = renderableIndexAtMergeEnd;
            this.modifyViewportRowEnd(calc, nrOfColumns);
            return;
          }
        }
      }
    }
  }
  /**
  * Modify viewport start when needed.
  *
  * @private
  * @param {object} calc The column calculator object.
  * @param {number} nrOfRows Number of visual rows.
  */
  modifyViewportColumnStart(calc, nrOfRows) {
    const columnMapper = this.hot.columnIndexMapper;
    const visualStartCol = columnMapper.getVisualFromRenderableIndex(calc.startColumn) ?? 0;
    for (let visualRowIndex = 0; visualRowIndex < nrOfRows; visualRowIndex += 1) {
      const mergeParentForViewportStart = this.mergedCellsCollection.get(visualRowIndex, visualStartCol);
      if (mergeParentForViewportStart !== false) {
        const nearestCol = columnMapper.getNearestNotHiddenIndex(mergeParentForViewportStart.col, 1);
        if (nearestCol !== null) {
          const renderableIndexAtMergeStart = columnMapper.getRenderableFromVisualIndex(nearestCol);
          if (renderableIndexAtMergeStart !== null && renderableIndexAtMergeStart < calc.startColumn) {
            calc.startColumn = renderableIndexAtMergeStart;
            this.modifyViewportColumnStart(calc, nrOfRows);
            return;
          }
        }
      }
    }
  }
  /**
  * Modify viewport end when needed.
  *
  * @private
  * @param {object} calc The column calculator object.
  * @param {number} nrOfRows Number of visual rows.
  */
  modifyViewportColumnEnd(calc, nrOfRows) {
    const columnMapper = this.hot.columnIndexMapper;
    const visualEndCol = columnMapper.getVisualFromRenderableIndex(calc.endColumn) ?? 0;
    for (let visualRowIndex = 0; visualRowIndex < nrOfRows; visualRowIndex += 1) {
      const mergeParentForViewportEnd = this.mergedCellsCollection.get(visualRowIndex, visualEndCol);
      if (mergeParentForViewportEnd !== false) {
        const mergeEnd = mergeParentForViewportEnd.col + mergeParentForViewportEnd.colspan - 1;
        const nearestCol = columnMapper.getNearestNotHiddenIndex(mergeEnd, -1);
        if (nearestCol !== null) {
          const renderableIndexAtMergeEnd = columnMapper.getRenderableFromVisualIndex(nearestCol);
          if (renderableIndexAtMergeEnd !== null && renderableIndexAtMergeEnd > calc.endColumn) {
            calc.endColumn = renderableIndexAtMergeEnd;
            this.modifyViewportColumnEnd(calc, nrOfRows);
            return;
          }
        }
      }
    }
  }
  /**
  * Translates merged cell coordinates to renderable indexes.
  *
  * @private
  * @param {number} parentRow Visual row index.
  * @param {number} rowspan Rowspan.
  * @param {number} parentColumn Visual column index.
  * @param {number} colspan Colspan.
  * @returns {Array<number>} A two-element array of `[renderableRow, renderableColumn]`.
  */
  translateMergedCellToRenderable(parentRow, rowspan, parentColumn, colspan) {
    const { rowIndexMapper: rowMapper, columnIndexMapper: columnMapper } = this.hot;
    let firstNonHiddenRow;
    let firstNonHiddenColumn;
    if (rowspan === 0) {
      firstNonHiddenRow = rowMapper.getNearestNotHiddenIndex(parentRow, 1);
    } else {
      firstNonHiddenRow = rowMapper.getNearestNotHiddenIndex(parentRow + rowspan - 1, -1);
    }
    if (colspan === 0) {
      firstNonHiddenColumn = columnMapper.getNearestNotHiddenIndex(parentColumn, 1);
    } else {
      firstNonHiddenColumn = columnMapper.getNearestNotHiddenIndex(parentColumn + colspan - 1, -1);
    }
    const renderableRow = parentRow >= 0 && firstNonHiddenRow !== null ? rowMapper.getRenderableFromVisualIndex(firstNonHiddenRow) ?? parentRow : parentRow;
    const renderableColumn = parentColumn >= 0 && firstNonHiddenColumn !== null ? columnMapper.getRenderableFromVisualIndex(firstNonHiddenColumn) ?? parentColumn : parentColumn;
    return [
      renderableRow,
      renderableColumn
    ];
  }
  constructor(...args) {
    super(...args), _class_private_method_init$b(this, _addMergeActionsToContextMenu), _class_private_field_init$m(this, _lastSelectedFocus, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _lastFocusDelta, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _focusOrder, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _cellRenderer, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _columnMoveSnapshot, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _rowMoveSnapshot, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _initialized, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterInit$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterIsMultipleSelection, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onModifyTransformFocus, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onModifyTransformStart$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onModifyTransformEnd, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeSelectionHighlightSet$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onModifyGetCellCoords, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeSetRangeStart, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeSelectionFocusSet, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterSelectionFocusSet, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterSelectionEnd, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterGetCellMeta, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterViewportRowCalculatorOverride, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterViewportColumnCalculatorOverride$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onModifyAutofillRange, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterCreateCol$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterRemoveCol$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterCreateRow$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterRemoveRow$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeColumnMove, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterColumnMove, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeRowMove$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterRowMove, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeColumnFreeze, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterColumnFreeze, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterChange$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeDrawAreaBorders, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onAfterDrawSelection, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeRemoveCellClassNames, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onBeforeBeginEditing, {
      writable: true,
      value: void 0
    }), _class_private_field_init$m(this, _onModifyRowHeightByOverlayName, {
      writable: true,
      value: void 0
    }), _class_private_field_set$m(this, _lastSelectedFocus, null), _class_private_field_set$m(this, _lastFocusDelta, {
      row: 0,
      col: 0
    }), _class_private_field_set$m(this, _focusOrder, new FocusOrder({
      mergedCellsGetter: (row, column) => this.mergedCellsCollection.get(row, column),
      rowIndexMapper: this.hot.rowIndexMapper,
      columnIndexMapper: this.hot.columnIndexMapper
    })), _class_private_field_set$m(this, _cellRenderer, createMergeCellRenderer(this)), _class_private_field_set$m(this, _columnMoveSnapshot, null), _class_private_field_set$m(this, _rowMoveSnapshot, null), _class_private_field_set$m(this, _initialized, false), _class_private_field_set$m(this, _onAfterInit$2, () => {
      this.generateFromSettings();
      this.hot.render();
      _class_private_field_set$m(this, _initialized, true);
    }), _class_private_field_set$m(this, _onAfterIsMultipleSelection, (isMultiple) => {
      if (isMultiple) {
        const mergedCells = this.mergedCellsCollection.mergedCells;
        const selectionRange = this.hot.getSelectedRangeActive();
        if (!selectionRange) {
          return isMultiple;
        }
        const topStartCoords = selectionRange.getTopStartCorner();
        const bottomEndCoords = selectionRange.getBottomEndCorner();
        for (let group = 0; group < mergedCells.length; group += 1) {
          if (topStartCoords.row === mergedCells[group].row && topStartCoords.col === mergedCells[group].col && bottomEndCoords.row === mergedCells[group].row + mergedCells[group].rowspan - 1 && bottomEndCoords.col === mergedCells[group].col + mergedCells[group].colspan - 1) {
            return false;
          }
        }
      }
      return isMultiple;
    }), _class_private_field_set$m(this, _onModifyTransformFocus, (delta) => {
      _class_private_field_get$m(this, _lastFocusDelta).row = delta.row;
      _class_private_field_get$m(this, _lastFocusDelta).col = delta.col;
    }), _class_private_field_set$m(this, _onModifyTransformStart$1, (delta) => {
      const selectedRange = this.hot.getSelectedRangeActive();
      if (!selectedRange) {
        return;
      }
      const { highlight } = selectedRange;
      const { columnIndexMapper, rowIndexMapper } = this.hot;
      if (_class_private_field_get$m(this, _lastSelectedFocus)) {
        if (_class_private_field_get$m(this, _lastSelectedFocus).row !== null && rowIndexMapper.getRenderableFromVisualIndex(_class_private_field_get$m(this, _lastSelectedFocus).row) !== null) {
          highlight.row = _class_private_field_get$m(this, _lastSelectedFocus).row;
        }
        if (_class_private_field_get$m(this, _lastSelectedFocus).col !== null && columnIndexMapper.getRenderableFromVisualIndex(_class_private_field_get$m(this, _lastSelectedFocus).col) !== null) {
          highlight.col = _class_private_field_get$m(this, _lastSelectedFocus).col;
        }
        _class_private_field_set$m(this, _lastSelectedFocus, null);
      }
      if (highlight.row === null || highlight.col === null) {
        return;
      }
      const mergedParent = this.mergedCellsCollection.get(highlight.row, highlight.col);
      if (!mergedParent) {
        return;
      }
      const visualColumnIndexStart = mergedParent.col;
      const visualColumnIndexEnd = mergedParent.col + mergedParent.colspan - 1;
      if (delta.col < 0) {
        const nextColumn = highlight.col >= visualColumnIndexStart && highlight.col <= visualColumnIndexEnd ? visualColumnIndexStart - 1 : visualColumnIndexEnd;
        const notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(nextColumn, -1);
        if (notHiddenColumnIndex === null) {
          delta.col = -this.hot.view.countRenderableColumnsInRange(0, highlight.col);
        } else {
          delta.col = -Math.max(this.hot.view.countRenderableColumnsInRange(notHiddenColumnIndex, highlight.col) - 1, 1);
        }
      } else if (delta.col > 0) {
        const nextColumn = highlight.col >= visualColumnIndexStart && highlight.col <= visualColumnIndexEnd ? visualColumnIndexEnd + 1 : visualColumnIndexStart;
        const notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(nextColumn, 1);
        if (notHiddenColumnIndex === null) {
          delta.col = this.hot.view.countRenderableColumnsInRange(highlight.col, this.hot.countCols());
        } else {
          delta.col = Math.max(this.hot.view.countRenderableColumnsInRange(highlight.col, notHiddenColumnIndex) - 1, 1);
        }
      }
      const visualRowIndexStart = mergedParent.row;
      const visualRowIndexEnd = mergedParent.row + mergedParent.rowspan - 1;
      if (delta.row < 0) {
        const nextRow = highlight.row >= visualRowIndexStart && highlight.row <= visualRowIndexEnd ? visualRowIndexStart - 1 : visualRowIndexEnd;
        const notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(nextRow, -1);
        if (notHiddenRowIndex === null) {
          delta.row = -this.hot.view.countRenderableRowsInRange(0, highlight.row);
        } else {
          delta.row = -Math.max(this.hot.view.countRenderableRowsInRange(notHiddenRowIndex, highlight.row) - 1, 1);
        }
      } else if (delta.row > 0) {
        const nextRow = highlight.row >= visualRowIndexStart && highlight.row <= visualRowIndexEnd ? visualRowIndexEnd + 1 : visualRowIndexStart;
        const notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(nextRow, 1);
        if (notHiddenRowIndex === null) {
          delta.row = this.hot.view.countRenderableRowsInRange(highlight.row, this.hot.countRows());
        } else {
          delta.row = Math.max(this.hot.view.countRenderableRowsInRange(highlight.row, notHiddenRowIndex) - 1, 1);
        }
      }
    }), _class_private_field_set$m(this, _onModifyTransformEnd, (delta) => {
      const selectedRange = this.hot.getSelectedRangeActive();
      if (!selectedRange) {
        return;
      }
      const cloneRange = selectedRange.clone();
      const { to } = selectedRange;
      const toRow = to.row ?? 0;
      const toCol = to.col ?? 0;
      const { columnIndexMapper, rowIndexMapper } = this.hot;
      const expandCloneRange = (row, col) => {
        cloneRange.expand(this.hot._createCellCoords(row, col));
        for (let i = 0; i < this.mergedCellsCollection.mergedCells.length; i += 1) {
          const range = this.mergedCellsCollection.mergedCells[i].getRange();
          if (range) {
            cloneRange.expandByRange(range);
          }
        }
      };
      if (delta.col < 0) {
        let nextColumn = this.mergedCellsCollection.getStartMostColumnIndex(selectedRange, toCol) + delta.col;
        expandCloneRange(toRow, nextColumn);
        if (selectedRange.getHorizontalDirection() === "E-W" && cloneRange.getHorizontalDirection() === "E-W") {
          nextColumn = cloneRange.getTopStartCorner().col ?? nextColumn;
        }
        const notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(nextColumn, 1);
        if (notHiddenColumnIndex !== null) {
          delta.col = -Math.max(this.hot.view.countRenderableColumnsInRange(notHiddenColumnIndex, toCol) - 1, 1);
        }
      } else if (delta.col > 0) {
        let nextColumn = this.mergedCellsCollection.getEndMostColumnIndex(selectedRange, toCol) + delta.col;
        expandCloneRange(toRow, nextColumn);
        if (selectedRange.getHorizontalDirection() === "W-E" && cloneRange.getHorizontalDirection() === "W-E") {
          nextColumn = cloneRange.getBottomEndCorner().col ?? nextColumn;
        }
        const notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(nextColumn, -1);
        if (notHiddenColumnIndex !== null) {
          delta.col = Math.max(this.hot.view.countRenderableColumnsInRange(toCol, notHiddenColumnIndex) - 1, 1);
        }
      }
      if (delta.row < 0) {
        let nextRow = this.mergedCellsCollection.getTopMostRowIndex(selectedRange, toRow) + delta.row;
        expandCloneRange(nextRow, toCol);
        if (selectedRange.getVerticalDirection() === "S-N" && cloneRange.getVerticalDirection() === "S-N") {
          nextRow = cloneRange.getTopStartCorner().row ?? nextRow;
        }
        const notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(nextRow, 1);
        if (notHiddenRowIndex !== null) {
          delta.row = -Math.max(this.hot.view.countRenderableRowsInRange(notHiddenRowIndex, toRow) - 1, 1);
        }
      } else if (delta.row > 0) {
        let nextRow = this.mergedCellsCollection.getBottomMostRowIndex(selectedRange, toRow) + delta.row;
        expandCloneRange(nextRow, toCol);
        if (selectedRange.getVerticalDirection() === "N-S" && cloneRange.getVerticalDirection() === "N-S") {
          nextRow = cloneRange.getBottomStartCorner().row ?? nextRow;
        }
        const notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(nextRow, -1);
        if (notHiddenRowIndex !== null) {
          delta.row = Math.max(this.hot.view.countRenderableRowsInRange(toRow, notHiddenRowIndex) - 1, 1);
        }
      }
    }), _class_private_field_set$m(this, _onBeforeSelectionHighlightSet$2, () => {
      const selectedRange = this.hot.getSelectedRangeLast();
      if (!selectedRange) {
        return;
      }
      const { highlight } = selectedRange;
      if (this.hot.selection.isSelectedByColumnHeader() || this.hot.selection.isSelectedByRowHeader()) {
        _class_private_field_set$m(this, _lastSelectedFocus, highlight.clone());
        return;
      }
      for (let i = 0; i < this.mergedCellsCollection.mergedCells.length; i += 1) {
        const range = this.mergedCellsCollection.mergedCells[i].getRange();
        if (range) {
          selectedRange.expandByRange(range, false);
        }
      }
      for (let i = 0; i < this.mergedCellsCollection.mergedCells.length; i += 1) {
        const range = this.mergedCellsCollection.mergedCells[i].getRange();
        if (range) {
          selectedRange.expandByRange(range, false);
        }
      }
      if (highlight.row === null || highlight.col === null) {
        return;
      }
      const mergedParent = this.mergedCellsCollection.get(highlight.row, highlight.col);
      _class_private_field_set$m(this, _lastSelectedFocus, highlight.clone());
      if (mergedParent) {
        highlight.assign(mergedParent);
      }
    }), _class_private_field_set$m(this, _onModifyGetCellCoords, (row, column, topmost, source) => {
      if (row < 0 || column < 0) {
        return;
      }
      const mergeParent = this.mergedCellsCollection.get(row, column);
      if (!mergeParent) {
        return;
      }
      const { row: mergeRow, col: mergeColumn, colspan, rowspan } = mergeParent;
      const topStartRow = mergeRow;
      const topStartColumn = mergeColumn;
      const bottomEndRow = mergeRow + rowspan - 1;
      const bottomEndColumn = mergeColumn + colspan - 1;
      if (source === "render" && this.getSetting("virtualized")) {
        const overlayName = this.hot.view.getActiveOverlayName();
        const firstRenderedRow = [
          "top",
          "top_inline_start_corner"
        ].includes(overlayName) ? 0 : this.hot.getFirstRenderedVisibleRow();
        const firstRenderedColumn = [
          "inline_start",
          "top_inline_start_corner",
          "bottom_inline_start_corner"
        ].includes(overlayName) ? 0 : this.hot.getFirstRenderedVisibleColumn();
        return [
          clamp(firstRenderedRow, topStartRow, bottomEndRow),
          clamp(firstRenderedColumn, topStartColumn, bottomEndColumn),
          clamp(this.hot.getLastRenderedVisibleRow(), topStartRow, bottomEndRow),
          clamp(this.hot.getLastRenderedVisibleColumn(), topStartColumn, bottomEndColumn)
        ];
      }
      return [
        topStartRow,
        topStartColumn,
        bottomEndRow,
        bottomEndColumn
      ];
    }), _class_private_field_set$m(this, _onBeforeSetRangeStart, () => {
      _class_private_field_set$m(this, _lastSelectedFocus, null);
    }), _class_private_field_set$m(this, _onBeforeSelectionFocusSet, () => {
      if (!_class_private_field_get$m(this, _lastSelectedFocus) || _class_private_field_get$m(this, _lastSelectedFocus).isCell()) {
        return;
      }
      const selectedRange = this.hot.getSelectedRangeActive();
      if (!selectedRange) {
        return;
      }
      const verticalDir = selectedRange.getVerticalDirection();
      const horizontalDir = selectedRange.getHorizontalDirection();
      const focusCoords = _class_private_field_get$m(this, _lastSelectedFocus).clone().normalize();
      if (focusCoords.row === null || focusCoords.col === null) {
        return;
      }
      _class_private_field_get$m(this, _focusOrder).setActiveNode(focusCoords.row, focusCoords.col);
      if (_class_private_field_get$m(this, _lastFocusDelta).row > 0 || _class_private_field_get$m(this, _lastFocusDelta).col > 0) {
        _class_private_field_get$m(this, _focusOrder).setPrevNodeAsActive();
      } else if (horizontalDir === "E-W" && _class_private_field_get$m(this, _lastFocusDelta).col < 0 || verticalDir === "S-N" && _class_private_field_get$m(this, _lastFocusDelta).row < 0) {
        _class_private_field_get$m(this, _focusOrder).setNextNodeAsActive();
      }
    }), _class_private_field_set$m(this, _onAfterSelectionFocusSet, (row, column) => {
      const { columnIndexMapper, rowIndexMapper } = this.hot;
      let activeSelectionLayerIndex = this.hot.getActiveSelectionLayerIndex();
      let notHiddenRowIndex = null;
      let notHiddenColumnIndex = null;
      if (_class_private_field_get$m(this, _lastFocusDelta).col < 0) {
        const { rowEnd, colEnd, selectionLayer } = _class_private_field_get$m(this, _focusOrder).getPrevHorizontalNode();
        notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(colEnd, -1);
        notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(rowEnd, -1);
        activeSelectionLayerIndex = selectionLayer;
      } else if (_class_private_field_get$m(this, _lastFocusDelta).col > 0) {
        const { rowStart, colStart, selectionLayer } = _class_private_field_get$m(this, _focusOrder).getNextHorizontalNode();
        notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(colStart, 1);
        notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(rowStart, 1);
        activeSelectionLayerIndex = selectionLayer;
      } else if (_class_private_field_get$m(this, _lastFocusDelta).row < 0) {
        const { rowEnd, colEnd, selectionLayer } = _class_private_field_get$m(this, _focusOrder).getPrevVerticalNode();
        notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(colEnd, -1);
        notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(rowEnd, -1);
        activeSelectionLayerIndex = selectionLayer;
      } else if (_class_private_field_get$m(this, _lastFocusDelta).row > 0) {
        const { rowStart, colStart, selectionLayer } = _class_private_field_get$m(this, _focusOrder).getNextVerticalNode();
        notHiddenColumnIndex = columnIndexMapper.getNearestNotHiddenIndex(colStart, 1);
        notHiddenRowIndex = rowIndexMapper.getNearestNotHiddenIndex(rowStart, 1);
        activeSelectionLayerIndex = selectionLayer;
      }
      if (notHiddenRowIndex !== null || notHiddenColumnIndex !== null) {
        this.hot.selection.setActiveSelectionLayerIndex(activeSelectionLayerIndex);
        const selectedRange = this.hot.getSelectedRangeActive();
        const resolvedRow = notHiddenRowIndex ?? 0;
        const resolvedCol = notHiddenColumnIndex ?? 0;
        const coords = this.hot._createCellCoords(resolvedRow, resolvedCol);
        const mergeParent = this.mergedCellsCollection.get(resolvedRow, resolvedCol);
        const focusHighlight = this.hot.selection.highlight.getFocus();
        row = resolvedRow;
        column = resolvedCol;
        if (selectedRange) {
          if (mergeParent) {
            selectedRange.highlight.assign({
              row: this.hot.rowIndexMapper.getNearestNotHiddenIndex(mergeParent.row, 1) ?? void 0,
              col: this.hot.columnIndexMapper.getNearestNotHiddenIndex(mergeParent.col, 1) ?? void 0
            });
          } else {
            selectedRange.highlight.assign(coords);
          }
        }
        focusHighlight.clear();
        focusHighlight.add(coords).commit();
      }
      _class_private_field_get$m(this, _focusOrder).setActiveNode(row, column, activeSelectionLayerIndex);
      _class_private_field_set$m(this, _lastFocusDelta, {
        row: 0,
        col: 0
      });
    }), _class_private_field_set$m(this, _onAfterSelectionEnd, () => {
      const selectedRanges = this.hot.getSelectedRange();
      if (selectedRanges) {
        _class_private_field_get$m(this, _focusOrder).buildFocusOrder(selectedRanges);
      }
    }), _class_private_field_set$m(this, _onAfterGetCellMeta, (row, col, cellProperties) => {
      const mergeParent = this.mergedCellsCollection.get(row, col);
      if (mergeParent) {
        if (mergeParent.row !== row || mergeParent.col !== col) {
          cellProperties.copyable = false;
          cellProperties.hidden = true;
        } else {
          cellProperties.rowspan = mergeParent.rowspan;
          cellProperties.colspan = mergeParent.colspan;
          cellProperties.spanned = true;
        }
      }
    }), _class_private_field_set$m(this, _onAfterViewportRowCalculatorOverride, (calc) => {
      if (this.getSetting("virtualized")) {
        return;
      }
      const nrOfColumns = this.hot.countCols();
      this.modifyViewportRowStart(calc, nrOfColumns);
      this.modifyViewportRowEnd(calc, nrOfColumns);
    }), _class_private_field_set$m(this, _onAfterViewportColumnCalculatorOverride$1, (calc) => {
      if (this.getSetting("virtualized")) {
        return;
      }
      const nrOfRows = this.hot.countRows();
      this.modifyViewportColumnStart(calc, nrOfRows);
      this.modifyViewportColumnEnd(calc, nrOfRows);
    }), _class_private_field_set$m(this, _onModifyAutofillRange, (fullArea, baseArea) => {
      const dragDirection = this.autofillCalculations.getDirection(baseArea, fullArea);
      if (this.autofillCalculations.dragAreaOverlapsCollections(baseArea, fullArea, dragDirection)) {
        return baseArea;
      }
      const from = this.hot._createCellCoords(baseArea[0], baseArea[1]);
      const to = this.hot._createCellCoords(baseArea[2], baseArea[3]);
      const range = this.hot._createCellRange(from, from, to);
      const mergedCellsWithinSelectionArea = this.mergedCellsCollection.getWithinRange(range);
      if (mergedCellsWithinSelectionArea.length === 0) {
        return fullArea;
      }
      return this.autofillCalculations.snapDragArea(baseArea, fullArea, dragDirection, mergedCellsWithinSelectionArea);
    }), _class_private_field_set$m(this, _onAfterCreateCol$1, (column, count) => {
      this.mergedCellsCollection.shiftCollections("right", column, count);
    }), _class_private_field_set$m(this, _onAfterRemoveCol$1, (column, count) => {
      this.mergedCellsCollection.shiftCollections("left", column, count);
    }), _class_private_field_set$m(this, _onAfterCreateRow$1, (row, count, source) => {
      if (source === "auto") {
        return;
      }
      this.mergedCellsCollection.shiftCollections("down", row, count);
    }), _class_private_field_set$m(this, _onAfterRemoveRow$1, (row, count) => {
      this.mergedCellsCollection.shiftCollections("up", row, count);
    }), _class_private_field_set$m(this, _onBeforeColumnMove, (_columns, _finalIndex2, _dropIndex, movePossible) => {
      if (!movePossible || !_class_private_field_get$m(this, _initialized)) {
        _class_private_field_set$m(this, _columnMoveSnapshot, null);
        return;
      }
      _class_private_field_set$m(this, _columnMoveSnapshot, this.mergedCellsCollection.capturePhysicalSpans("column"));
    }), _class_private_field_set$m(this, _onAfterColumnMove, (_columns, _finalIndex2, _dropIndex, _movePossible, orderChanged) => {
      const snapshot = _class_private_field_get$m(this, _columnMoveSnapshot);
      _class_private_field_set$m(this, _columnMoveSnapshot, null);
      if (!orderChanged || !snapshot) {
        return;
      }
      this.mergedCellsCollection.translateAfterAxisMove("column", snapshot);
      this.hot.render();
    }), _class_private_field_set$m(this, _onBeforeRowMove$1, (_rows, _finalIndex2, _dropIndex, movePossible) => {
      if (!movePossible || !_class_private_field_get$m(this, _initialized)) {
        _class_private_field_set$m(this, _rowMoveSnapshot, null);
        return;
      }
      _class_private_field_set$m(this, _rowMoveSnapshot, this.mergedCellsCollection.capturePhysicalSpans("row"));
    }), _class_private_field_set$m(this, _onAfterRowMove, (_rows, _finalIndex2, _dropIndex, _movePossible, orderChanged) => {
      const snapshot = _class_private_field_get$m(this, _rowMoveSnapshot);
      _class_private_field_set$m(this, _rowMoveSnapshot, null);
      if (!orderChanged || !snapshot) {
        return;
      }
      this.mergedCellsCollection.translateAfterAxisMove("row", snapshot);
      this.hot.render();
    }), _class_private_field_set$m(this, _onBeforeColumnFreeze, (_column, performed) => {
      if (!performed || !_class_private_field_get$m(this, _initialized)) {
        _class_private_field_set$m(this, _columnMoveSnapshot, null);
        return;
      }
      _class_private_field_set$m(this, _columnMoveSnapshot, this.mergedCellsCollection.capturePhysicalSpans("column"));
    }), _class_private_field_set$m(this, _onAfterColumnFreeze, (_column, performed) => {
      const snapshot = _class_private_field_get$m(this, _columnMoveSnapshot);
      _class_private_field_set$m(this, _columnMoveSnapshot, null);
      if (!performed || !snapshot) {
        return;
      }
      this.mergedCellsCollection.translateAfterAxisMove("column", snapshot);
      this.hot.render();
    }), _class_private_field_set$m(this, _onAfterChange$1, (changes, source) => {
      if (source !== "Autofill.fill") {
        return;
      }
      this.autofillCalculations.recreateAfterDataPopulation(changes);
    }), _class_private_field_set$m(this, _onBeforeDrawAreaBorders, (corners, className) => {
      if (className && className === "area") {
        const selectedRange = this.hot.getSelectedRangeActive();
        if (!selectedRange) {
          return;
        }
        const mergedCellsWithinRange = this.mergedCellsCollection.getWithinRange(selectedRange);
        arrayEach(mergedCellsWithinRange, (mergedCell) => {
          if (selectedRange.getBottomEndCorner().row === mergedCell.getLastRow() && selectedRange.getBottomEndCorner().col === mergedCell.getLastColumn()) {
            corners[2] = mergedCell.row;
            corners[3] = mergedCell.col;
          }
        });
      }
    }), _class_private_field_set$m(this, _onAfterDrawSelection, (currentRow, currentColumn, cornersOfSelection, layerLevel) => {
      if (!cornersOfSelection) {
        return;
      }
      return this.selectionCalculations.getSelectedMergedCellClassName(currentRow, currentColumn, cornersOfSelection, layerLevel);
    }), _class_private_field_set$m(this, _onBeforeRemoveCellClassNames, () => {
      return this.selectionCalculations.getSelectedMergedCellClassNameToRemove();
    }), _class_private_field_set$m(this, _onBeforeBeginEditing, (row, column, initialValue, event) => {
      if (!(event instanceof MouseEvent)) {
        return;
      }
      const selection = this.hot.getSelectedRangeActive();
      if (!selection) {
        return;
      }
      const mergeCell = this.mergedCellsCollection.getByRange(selection);
      if (!mergeCell) {
        return;
      }
      const from = this.hot._createCellCoords(mergeCell.row, mergeCell.col);
      const to = this.hot._createCellCoords(mergeCell.row + mergeCell.rowspan - 1, mergeCell.col + mergeCell.colspan - 1);
      return this.hot.selection.getLayerLevel() === 0 && selection.isEqual(this.hot._createCellRange(from, from, to));
    }), _class_private_field_set$m(this, _onModifyRowHeightByOverlayName, (height, row, overlayType) => {
      if (this.hot.getSettings().rowHeaders || // merged cells do not work with the bottom overlays
      overlayType === "bottom" || overlayType === "bottom_inline_start_corner") {
        return height;
      }
      let firstColumn;
      let lastColumn;
      if (overlayType === "master") {
        firstColumn = this.hot.getFirstRenderedVisibleColumn();
        lastColumn = this.hot.getLastRenderedVisibleColumn();
      } else {
        const activeOverlay = this.hot.view.getOverlayByName(overlayType);
        const overlayWtTable = activeOverlay?.clone?.wtTable;
        if (!overlayWtTable) {
          return height;
        }
        firstColumn = this.hot.columnIndexMapper.getVisualFromRenderableIndex(overlayWtTable.getFirstRenderedColumn());
        lastColumn = this.hot.columnIndexMapper.getVisualFromRenderableIndex(overlayWtTable.getLastRenderedColumn());
      }
      if (firstColumn === null || firstColumn === void 0) {
        return height;
      }
      const firstMergedCellInRow = this.mergedCellsCollection.get(row, firstColumn);
      if (!firstMergedCellInRow) {
        return height;
      }
      const from = this.hot._createCellCoords(row, firstColumn);
      const to = this.hot._createCellCoords(row, lastColumn ?? firstColumn);
      const viewportRange = this.hot._createCellRange(from, from, to);
      const mergedCellsWithinRange = this.mergedCellsCollection.getWithinRange(viewportRange, true);
      const maxRowspan = mergedCellsWithinRange.reduce((acc, { rowspan }) => Math.max(acc, rowspan), 1);
      let rowspanCorrection = 0;
      if (mergedCellsWithinRange.length > 1 && mergedCellsWithinRange[0].rowspan < maxRowspan) {
        rowspanCorrection = maxRowspan - mergedCellsWithinRange[0].rowspan;
      }
      mergedCellsWithinRange.forEach(({ rowspan }) => {
        let rowspanAfterCorrection = 0;
        if (overlayType === "top" || overlayType === "top_inline_start_corner") {
          rowspanAfterCorrection = Math.min(maxRowspan, this.hot.view.countNotHiddenFixedRowsTop() - row);
        } else {
          rowspanAfterCorrection = rowspan - rowspanCorrection;
        }
        height = Math.max(height ?? 0, sumCellsHeights(this.hot, row, rowspanAfterCorrection));
      });
      return height;
    });
  }
}
function addMergeActionsToContextMenu(defaultOptions) {
  defaultOptions.items.push({
    name: "---------"
  }, toggleMergeItem(this));
}
function rootComparator(sortingOrders, columnMetas) {
  return function(rowIndexWithValues, nextRowIndexWithValues) {
    const [, ...values2] = rowIndexWithValues;
    const [, ...nextValues] = nextRowIndexWithValues;
    return (function getCompareResult(column) {
      const sortingOrder = sortingOrders[column];
      const columnMeta = columnMetas[column];
      const value = values2[column];
      const nextValue = nextValues[column];
      const pluginSettings = columnMeta.multiColumnSorting;
      const compareFunctionFactory2 = pluginSettings.compareFunctionFactory ? pluginSettings.compareFunctionFactory : getCompareFunctionFactory(columnMeta.type);
      const compareResult = compareFunctionFactory2(sortingOrder, columnMeta, pluginSettings)(value, nextValue);
      if (compareResult === DO_NOT_SWAP) {
        const nextSortedColumn = column + 1;
        if (typeof columnMetas[nextSortedColumn] !== "undefined") {
          return getCompareResult(nextSortedColumn);
        }
      }
      return compareResult;
    })(0);
  };
}
const COLUMN_ORDER_PREFIX = "sort";
function getClassesToAdd(columnStatesManager, column, showSortIndicator) {
  const cssClasses = [];
  if (showSortIndicator === false) {
    return cssClasses;
  }
  if (columnStatesManager.isColumnSorted(column) && columnStatesManager.getNumberOfSortedColumns() > 1) {
    cssClasses.push(`${COLUMN_ORDER_PREFIX}-${columnStatesManager.getIndexOfColumnInSortQueue(column) + 1}`);
  }
  return cssClasses;
}
function getClassesToRemove(htmlElement) {
  const cssClasses = htmlElement.className.split(" ");
  const sortSequenceRegExp = new RegExp(`^${COLUMN_ORDER_PREFIX}-[0-9]{1,2}$`);
  return cssClasses.filter((cssClass) => sortSequenceRegExp.test(cssClass));
}
const PLUGIN_KEY$d = "multiColumnSorting";
const PLUGIN_PRIORITY$d = 170;
const SHORTCUTS_GROUP$4 = PLUGIN_KEY$d;
registerRootComparator(PLUGIN_KEY$d, rootComparator);
class MultiColumnSorting extends ColumnSorting {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$d;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$d;
  }
  /**
  * Returns the list of settings keys observed by the plugin for configuration changes.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$d
    ];
  }
  /**
  * Checks if the plugin is enabled in the Handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link MultiColumnSorting#enablePlugin} method is called.
  * When [[Options#dataProvider]] is a complete server-backed configuration, the DataProvider plugin blocks this plugin from enabling.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[this.pluginKey];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
  }
  /**
  * Register shortcuts responsible for toggling column sorting functionality.
  *
  * @private
  */
  registerShortcuts() {
    super.registerShortcuts();
    this.hot.getShortcutManager().getContext("grid")?.addShortcut({
      keys: [
        [
          "Shift",
          "Enter"
        ]
      ],
      callback: () => {
        const activeRange = this.hot.getSelectedRangeActive();
        if (activeRange) {
          const { highlight } = activeRange;
          if ((highlight.row ?? 0) === -1 && (highlight.col ?? 0) >= 0) {
            const sortConfig = this.getNextSortConfig(highlight.col ?? 0, APPEND_COLUMN_CONFIG_STRATEGY);
            this.sort(sortConfig);
          }
        }
        return false;
      },
      runOnlyIf: () => {
        const highlight = this.hot.getSelectedRangeActive()?.highlight;
        return !!(highlight && this.hot.getSelectedRangeActive()?.isSingle() && this.hot.selection.isCellVisible(highlight) && highlight.isHeader());
      },
      relativeToGroup: EDITOR_EDIT_GROUP,
      position: "before",
      group: SHORTCUTS_GROUP$4
    });
  }
  /**
  * Unregister shortcuts responsible for toggling column sorting functionality.
  *
  * @private
  */
  unregisterShortcuts() {
    super.unregisterShortcuts();
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$4);
  }
  /**
  * Sorts the table by chosen columns and orders.
  *
  * @param {undefined|object|Array} sortConfig Single column sort configuration or full sort configuration (for all sorted columns).
  * The configuration object contains `column` and `sortOrder` properties. First of them contains visual column index, the second one contains
  * sort order (`asc` for ascending, `desc` for descending).
  *
  * **Note**: Please keep in mind that every call of `sort` function set an entirely new sort order. Previous sort configs aren't preserved.
  *
  * @example
  * ```js
  * // sort ascending first visual column
  * hot.getPlugin('multiColumnSorting').sort({ column: 0, sortOrder: 'asc' });
  *
  * // sort first two visual column in the defined sequence
  * hot.getPlugin('multiColumnSorting').sort([{
  *   column: 1, sortOrder: 'asc'
  * }, {
  *   column: 0, sortOrder: 'desc'
  * }]);
  * ```
  *
  * @fires Hooks#beforeColumnSort
  * @fires Hooks#afterColumnSort
  */
  sort(sortConfig) {
    super.sort(sortConfig);
  }
  /**
  * Clear the sort performed on the table.
  */
  clearSort() {
    super.clearSort();
  }
  /**
  * Checks if the table is sorted (any column have to be sorted).
  *
  * @returns {boolean}
  */
  isSorted() {
    return super.isSorted();
  }
  /**
  * Get sort configuration for particular column or for all sorted columns. Objects contain `column` and `sortOrder` properties.
  *
  * **Note**: Please keep in mind that returned objects expose **visual** column index under the `column` key. They are handled by the `sort` function.
  *
  * @param {number} [column] Visual column index.
  * @returns {undefined|object|Array}
  */
  getSortConfig(column) {
    return super.getSortConfig(column);
  }
  /**
  * @description
  * Warn: Useful mainly for providing server side sort implementation (see in the example below). It doesn't sort the data set. It just sets sort configuration for all sorted columns.
  * Note: Please keep in mind that this method doesn't re-render the table.
  *
  * @example
  * ```js
  * beforeColumnSort: function(currentSortConfig, destinationSortConfigs) {
  *   const columnSortPlugin = this.getPlugin('multiColumnSorting');
  *
  *   columnSortPlugin.setSortConfig(destinationSortConfigs);
  *
  *   // const newData = ... // Calculated data set, ie. from an AJAX call.
  *
  *   this.updateData(newData); // Update data set and re-render the table.
  *
  *   return false; // The blockade for the default sort action.
  * }
  * ```
  *
  * @param {undefined|object|Array} sortConfig Single column sort configuration or full sort configuration (for all sorted columns).
  * The configuration object contains `column` and `sortOrder` properties. First of them contains visual column index, the second one contains
  * sort order (`asc` for ascending, `desc` for descending).
  */
  setSortConfig(sortConfig) {
    super.setSortConfig(sortConfig);
  }
  /**
  * Get normalized sort configs.
  *
  * @private
  * @param {object|Array} [sortConfig=[]] Single column sort configuration or full sort configuration (for all sorted columns).
  * The configuration object contains `column` and `sortOrder` properties. First of them contains visual column index, the second one contains
  * sort order (`asc` for ascending, `desc` for descending).
  * @returns {Array}
  */
  getNormalizedSortConfigs(sortConfig) {
    if (Array.isArray(sortConfig)) {
      return sortConfig;
    }
    return sortConfig !== void 0 ? [
      sortConfig
    ] : [];
  }
  /**
  * Update header classes.
  *
  * @private
  * @param {HTMLElement} headerSpanElement Header span element.
  * @param {...*} args Extra arguments for helpers.
  */
  updateHeaderClasses(headerSpanElement, columnStatesManager, column, showSortIndicator, headerActionEnabled) {
    super.updateHeaderClasses(headerSpanElement, columnStatesManager, column, showSortIndicator, headerActionEnabled);
    removeClass(headerSpanElement, getClassesToRemove(headerSpanElement));
    if (this.enabled !== false && columnStatesManager !== void 0 && column !== void 0) {
      addClass(headerSpanElement, getClassesToAdd(columnStatesManager, column, showSortIndicator ?? false));
    }
  }
  /**
  * Callback for the `onAfterOnCellMouseDown` hook.
  *
  * @private
  * @param {Event} event Event which are provided by hook.
  * @param {CellCoords} coords Visual coords of the selected cell.
  */
  onAfterOnCellMouseDown(event, coords) {
    if (wasHeaderClickedProperly(coords.row, coords.col, event) === false) {
      return;
    }
    if (this.wasClickableHeaderClicked(event, coords.col)) {
      if (this.hot.getShortcutManager().isCtrlPressed()) {
        this.hot.deselectCell();
        this.hot.selectColumns(coords.col);
        this.sort(this.getNextSortConfig(coords.col, APPEND_COLUMN_CONFIG_STRATEGY));
      } else {
        this.sort(this.getColumnNextConfig(coords.col));
      }
    }
  }
  constructor(...args) {
    super(...args), /**
    * Main settings key designed for the plugin.
    *
    * @private
    * @type {string}
    */
    this.pluginKey = PLUGIN_KEY$d;
  }
}
const PLUGIN_KEY$c = "multipleSelectionHandles";
const PLUGIN_PRIORITY$c = 160;
class MultipleSelectionHandles extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$c;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$c;
  }
  /**
  * Check if the plugin is enabled in the handsontable settings.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return isMobileBrowser();
  }
  /**
  * Enable plugin for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.registerListeners();
    super.enablePlugin();
  }
  /**
  * Bind the touch events.
  *
  * @private
  */
  registerListeners() {
    const { rootElement } = this.hot;
    const removeFromDragged = (query) => {
      if (this.dragged.length === 1) {
        this.dragged.splice(0, this.dragged.length);
        return true;
      }
      const entryPosition = this.dragged.indexOf(query);
      if (entryPosition === -1) {
        return false;
      } else if (entryPosition === 0) {
        this.dragged = this.dragged.slice(0, 1);
      } else if (entryPosition === 1) {
        this.dragged = this.dragged.slice(-1);
      }
    };
    this.eventManager.addEventListener(rootElement, "touchstart", (event) => {
      let selectedRange;
      const target = eventTargetEl(event);
      if (hasClass(target, "topSelectionHandle-HitArea")) {
        selectedRange = this.hot.getSelectedRangeActive();
        if (!selectedRange) {
          return false;
        }
        this.dragged.push("top");
        this.touchStartRange = {
          width: selectedRange.getWidth(),
          height: selectedRange.getHeight(),
          direction: selectedRange.getDirection()
        };
        event.preventDefault();
        return false;
      } else if (hasClass(target, "bottomSelectionHandle-HitArea")) {
        selectedRange = this.hot.getSelectedRangeActive();
        if (!selectedRange) {
          return false;
        }
        this.dragged.push("bottom");
        this.touchStartRange = {
          width: selectedRange.getWidth(),
          height: selectedRange.getHeight(),
          direction: selectedRange.getDirection()
        };
        event.preventDefault();
        return false;
      }
    });
    this.eventManager.addEventListener(rootElement, "touchend", (event) => {
      const target = eventTargetEl(event);
      if (hasClass(target, "topSelectionHandle-HitArea")) {
        removeFromDragged("top");
        this.touchStartRange = void 0;
        event.preventDefault();
        return false;
      } else if (hasClass(target, "bottomSelectionHandle-HitArea")) {
        removeFromDragged("bottom");
        this.touchStartRange = void 0;
        event.preventDefault();
        return false;
      }
    });
    this.eventManager.addEventListener(rootElement, "touchmove", (event) => {
      const { rootDocument } = this.hot;
      let targetCoords;
      let selectedRange;
      let rangeWidth;
      let rangeHeight;
      let rangeDirection;
      let newRangeCoords;
      if (this.dragged.length === 0) {
        return;
      }
      const te = event.touches[0];
      const endTarget = rootDocument.elementFromPoint(te.clientX, te.clientY);
      if (!endTarget || endTarget === this.lastSetCell) {
        return;
      }
      if (endTarget.nodeName === "TD" || endTarget.nodeName === "TH") {
        targetCoords = this.hot.getCoords(endTarget);
        if (!targetCoords) {
          return;
        }
        if (targetCoords.col === -1) {
          targetCoords.col = 0;
        }
        selectedRange = this.hot.getSelectedRangeActive();
        if (!selectedRange) {
          return;
        }
        rangeWidth = selectedRange.getWidth();
        rangeHeight = selectedRange.getHeight();
        rangeDirection = selectedRange.getDirection();
        if (rangeWidth === 1 && rangeHeight === 1) {
          this.hot.selection.setRangeEnd(targetCoords);
        }
        newRangeCoords = this.getCurrentRangeCoords(selectedRange, targetCoords, this.touchStartRange.direction, rangeDirection, this.dragged[0]);
        if (newRangeCoords.start !== null) {
          this.hot.selection.setRangeStart(newRangeCoords.start);
        }
        this.hot.selection.setRangeEnd(newRangeCoords.end);
        this.lastSetCell = endTarget;
      }
      event.preventDefault();
    });
  }
  /**
  * Calculates the new selection range coordinates after dragging a touch handle, accounting for drag direction and handle position.
  */
  getCurrentRangeCoords(selectedRange, currentTouch, touchStartDirection, currentDirection, draggedHandle) {
    const topStartCorner = selectedRange.getTopStartCorner();
    const bottomEndCorner = selectedRange.getBottomEndCorner();
    const bottomStartCorner = selectedRange.getBottomStartCorner();
    const topEndCorner = selectedRange.getTopEndCorner();
    let newCoords = {
      start: null,
      end: null
    };
    switch (touchStartDirection) {
      case "NE-SW":
        switch (currentDirection) {
          case "NE-SW":
          case "NW-SE":
            if (draggedHandle === "top") {
              newCoords = {
                start: this.hot._createCellCoords(currentTouch.row ?? 0, selectedRange.highlight.col ?? 0),
                end: this.hot._createCellCoords(bottomStartCorner.row ?? 0, currentTouch.col ?? 0)
              };
            } else {
              newCoords = {
                start: this.hot._createCellCoords(selectedRange.highlight.row ?? 0, currentTouch.col ?? 0),
                end: this.hot._createCellCoords(currentTouch.row ?? 0, topStartCorner.col ?? 0)
              };
            }
            break;
          case "SE-NW":
            if (draggedHandle === "bottom") {
              newCoords = {
                start: this.hot._createCellCoords(bottomEndCorner.row ?? 0, currentTouch.col ?? 0),
                end: this.hot._createCellCoords(currentTouch.row ?? 0, topStartCorner.col ?? 0)
              };
            }
            break;
        }
        break;
      case "NW-SE":
        switch (currentDirection) {
          case "NE-SW":
            if (draggedHandle === "top") {
              newCoords = {
                start: currentTouch,
                end: bottomStartCorner
              };
            } else {
              newCoords.end = currentTouch;
            }
            break;
          case "NW-SE":
            if (draggedHandle === "top") {
              newCoords = {
                start: currentTouch,
                end: bottomEndCorner
              };
            } else {
              newCoords.end = currentTouch;
            }
            break;
          case "SE-NW":
            if (draggedHandle === "top") {
              newCoords = {
                start: currentTouch,
                end: topStartCorner
              };
            } else {
              newCoords.end = currentTouch;
            }
            break;
          case "SW-NE":
            if (draggedHandle === "top") {
              newCoords = {
                start: currentTouch,
                end: topEndCorner
              };
            } else {
              newCoords.end = currentTouch;
            }
            break;
        }
        break;
      case "SW-NE":
        switch (currentDirection) {
          case "NW-SE":
            if (draggedHandle === "bottom") {
              newCoords = {
                start: this.hot._createCellCoords(currentTouch.row ?? 0, topStartCorner.col ?? 0),
                end: this.hot._createCellCoords(bottomStartCorner.row ?? 0, currentTouch.col ?? 0)
              };
            } else {
              newCoords = {
                start: this.hot._createCellCoords(topStartCorner.row ?? 0, currentTouch.col ?? 0),
                end: this.hot._createCellCoords(currentTouch.row ?? 0, bottomEndCorner.col ?? 0)
              };
            }
            break;
          // case 'NE-SW':
          //
          //  break;
          case "SW-NE":
            if (draggedHandle === "top") {
              newCoords = {
                start: this.hot._createCellCoords(selectedRange.highlight.row ?? 0, currentTouch.col ?? 0),
                end: this.hot._createCellCoords(currentTouch.row ?? 0, bottomEndCorner.col ?? 0)
              };
            } else {
              newCoords = {
                start: this.hot._createCellCoords(currentTouch.row ?? 0, topStartCorner.col ?? 0),
                end: this.hot._createCellCoords(topStartCorner.row ?? 0, currentTouch.col ?? 0)
              };
            }
            break;
          case "SE-NW":
            if (draggedHandle === "bottom") {
              newCoords = {
                start: this.hot._createCellCoords(currentTouch.row ?? 0, topEndCorner.col ?? 0),
                end: this.hot._createCellCoords(topStartCorner.row ?? 0, currentTouch.col ?? 0)
              };
            } else if (draggedHandle === "top") {
              newCoords = {
                start: bottomStartCorner,
                end: currentTouch
              };
            }
            break;
        }
        break;
      case "SE-NW":
        switch (currentDirection) {
          case "NW-SE":
          case "NE-SW":
          case "SW-NE":
            if (draggedHandle === "top") {
              newCoords.end = currentTouch;
            }
            break;
          case "SE-NW":
            if (draggedHandle === "top") {
              newCoords.end = currentTouch;
            } else {
              newCoords = {
                start: currentTouch,
                end: topStartCorner
              };
            }
            break;
        }
        break;
    }
    return newCoords;
  }
  /**
  * Check if user is currently dragging the handle.
  *
  * @returns {boolean} Dragging state.
  */
  isDragged() {
    return this.dragged.length > 0;
  }
  constructor(...args) {
    super(...args), /**
    * @type {Array}
    */
    this.dragged = [], /**
    * @type {null}
    */
    this.lastSetCell = null;
  }
}
function createDefaultHeaderSettings({ label = "", colspan = 1, origColspan = 1, rowspan = 1, origRowspan = 1, collapsible = false, crossHiddenColumns = [], isCollapsed = false, isHidden = false, isRoot = false, isPlaceholder = false, isRowspanPlaceholder = false, headerClassNames = [], visibleWhen } = {}) {
  return {
    label,
    colspan,
    origColspan,
    rowspan,
    origRowspan,
    collapsible,
    isCollapsed,
    crossHiddenColumns,
    isHidden,
    isRoot,
    isPlaceholder,
    isRowspanPlaceholder,
    headerClassNames,
    visibleWhen
  };
}
function createPlaceholderHeaderSettings() {
  return {
    label: "",
    isPlaceholder: true
  };
}
const VISIBLE_WHEN_VALUES = [
  "collapsed",
  "expanded",
  "always"
];
function normalizeSettings(sourceSettings, columnsLimit = Infinity) {
  const normalizedSettings = [];
  const rowspanCoverageMap = [];
  if (columnsLimit === 0) {
    return normalizedSettings;
  }
  const isExplicitEmptySlotPlaceholder = (sourceHeaderSettings) => {
    if (sourceHeaderSettings === "") {
      return true;
    }
    if (!isObject$1(sourceHeaderSettings)) {
      return false;
    }
    const { label, colspan, rowspan, headerClassName, visibleWhen } = sourceHeaderSettings;
    return stringify$1(label) === "" && (colspan === void 0 || colspan === 1) && (rowspan === void 0 || rowspan === 1) && headerClassName === void 0 && visibleWhen === void 0;
  };
  const normalizeHeaderSettings = (sourceHeaderSettings) => {
    const headerSettings = createDefaultHeaderSettings();
    if (isObject$1(sourceHeaderSettings)) {
      const { label, colspan, rowspan, headerClassName, visibleWhen } = sourceHeaderSettings;
      headerSettings.label = stringify$1(label);
      if (typeof colspan === "number" && colspan > 1) {
        headerSettings.colspan = colspan;
        headerSettings.origColspan = colspan;
      }
      if (typeof rowspan === "number" && rowspan > 1) {
        headerSettings.rowspan = rowspan;
        headerSettings.origRowspan = rowspan;
      }
      if (typeof headerClassName === "string") {
        headerSettings.headerClassNames = [
          ...headerClassName.split(" ")
        ];
      }
      if (typeof visibleWhen === "string" && VISIBLE_WHEN_VALUES.includes(visibleWhen)) {
        headerSettings.visibleWhen = visibleWhen;
      }
    } else {
      headerSettings.label = stringify$1(sourceHeaderSettings);
    }
    return headerSettings;
  };
  arrayEach(sourceSettings, (headersSettings = []) => {
    const columns = [];
    let sourceSettingsIndex = 0;
    let visualColumnIndex = 0;
    normalizedSettings.push(columns);
    while (sourceSettingsIndex < headersSettings.length || rowspanCoverageMap[visualColumnIndex] > 0) {
      if (visualColumnIndex >= columnsLimit) {
        break;
      }
      const sourceHeaderSettings = headersSettings[sourceSettingsIndex];
      const isCoveredByRowspan = rowspanCoverageMap[visualColumnIndex] > 0;
      if (isCoveredByRowspan) {
        if (isExplicitEmptySlotPlaceholder(sourceHeaderSettings)) {
          sourceSettingsIndex += 1;
        }
        columns.push(createDefaultHeaderSettings());
        rowspanCoverageMap[visualColumnIndex] -= 1;
        visualColumnIndex += 1;
        continue;
      }
      if (sourceSettingsIndex >= headersSettings.length) {
        break;
      }
      const headerSettings = normalizeHeaderSettings(sourceHeaderSettings);
      let headerWidth = headerSettings.origColspan;
      if (visualColumnIndex + headerWidth >= columnsLimit) {
        headerWidth -= visualColumnIndex + headerWidth - columnsLimit;
        headerSettings.colspan = headerWidth;
        headerSettings.origColspan = headerWidth;
      }
      if (headerSettings.origRowspan > 1) {
        for (let i = 0; i < headerWidth; i++) {
          rowspanCoverageMap[visualColumnIndex + i] = Math.max(rowspanCoverageMap[visualColumnIndex + i] ?? 0, headerSettings.origRowspan - 1);
        }
      }
      columns.push(headerSettings);
      if (headerSettings.colspan > 1) {
        for (let i = 0; i < headerSettings.colspan - 1; i++) {
          columns.push(createPlaceholderHeaderSettings());
        }
      }
      visualColumnIndex += headerWidth;
      sourceSettingsIndex += 1;
    }
  });
  const columnsLength = Math.max(...arrayMap(normalizedSettings, (headersSettings) => headersSettings.length));
  arrayEach(normalizedSettings, (headersSettings) => {
    const headers = headersSettings;
    if (headers.length < columnsLength) {
      const defaultSettings = arrayMap(new Array(columnsLength - headers.length), () => createDefaultHeaderSettings());
      headers.splice(headers.length, 0, ...defaultSettings);
    }
  });
  return normalizedSettings;
}
function _check_private_redeclaration$m(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$l(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$l(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$l(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$l(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$l(receiver, privateMap, "get");
  return _class_apply_descriptor_get$l(receiver, descriptor);
}
function _class_private_field_init$l(obj, privateMap, value) {
  _check_private_redeclaration$m(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$l(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$l(receiver, privateMap, "set");
  _class_apply_descriptor_set$l(receiver, descriptor, value);
  return value;
}
const HEADER_CONFIGURABLE_PROPS = [
  "label",
  "collapsible"
];
var _data = /* @__PURE__ */ new WeakMap(), _dataLength = /* @__PURE__ */ new WeakMap(), _columnsLimit = /* @__PURE__ */ new WeakMap();
class SourceSettings {
  /**
  * Sets columns limit to the source settings will be trimmed.
  *
  * @param {number} columnsCount The number of columns to limit to.
  */
  setColumnsLimit(columnsCount) {
    _class_private_field_set$l(this, _columnsLimit, columnsCount);
  }
  /**
  * Sets a new nested header configuration.
  *
  * @param {Array[]} [nestedHeadersSettings=[]] The user-defined nested headers settings.
  */
  setData(nestedHeadersSettings = []) {
    _class_private_field_set$l(this, _data, normalizeSettings(nestedHeadersSettings, _class_private_field_get$l(this, _columnsLimit)));
    _class_private_field_set$l(this, _dataLength, _class_private_field_get$l(this, _data).length);
  }
  /**
  * Gets normalized source settings.
  *
  * @returns {Array[]}
  */
  getData() {
    return _class_private_field_get$l(this, _data);
  }
  /**
  * Merges settings with current source settings.
  *
  * @param {object[]} additionalSettings An array of objects with `row`, `col` and additional
  *                                      properties to merge with current source settings.
  */
  mergeWith(additionalSettings) {
    arrayEach(additionalSettings, ({ row, col, ...rest }) => {
      const headerSettings = this.getHeaderSettings(row, col);
      if (headerSettings !== null) {
        extend(headerSettings, rest, HEADER_CONFIGURABLE_PROPS);
      }
    });
  }
  /**
  * Maps the current state with a callback.
  *
  * @param {Function} callback A function that is called for every header settings.
  */
  map(callback) {
    arrayEach(_class_private_field_get$l(this, _data), (header) => {
      arrayEach(header, (headerSettings) => {
        const propsToExtend = callback({
          ...headerSettings
        });
        if (isObject$1(propsToExtend)) {
          extend(headerSettings, propsToExtend, HEADER_CONFIGURABLE_PROPS);
        }
      });
    });
  }
  /**
  * Gets source column header settings for a specified header.
  *
  * @param {number} headerLevel Header level (0 = most distant to the table).
  * @param {number} columnIndex A visual column index.
  * @returns {object|null}
  */
  getHeaderSettings(headerLevel, columnIndex) {
    if (headerLevel >= _class_private_field_get$l(this, _dataLength) || headerLevel < 0) {
      return null;
    }
    const headersSettings = _class_private_field_get$l(this, _data)[headerLevel];
    if (Array.isArray(headersSettings) === false || columnIndex >= headersSettings.length) {
      return null;
    }
    return headersSettings[columnIndex] ?? null;
  }
  /**
  * Gets source of column headers settings for specified headers.
  *
  * @param {number} headerLevel Header level (0 = most distant to the table).
  * @param {number} columnIndex A visual column index from which the settings will be extracted.
  * @param {number} [columnsLength=1] The number of columns involved in the extraction of settings.
  * @returns {object}
  */
  getHeadersSettings(headerLevel, columnIndex, columnsLength = 1) {
    const headersSettingsChunks = [];
    if (headerLevel >= _class_private_field_get$l(this, _dataLength) || headerLevel < 0) {
      return headersSettingsChunks;
    }
    const headersSettings = _class_private_field_get$l(this, _data)[headerLevel];
    let currentLength = 0;
    for (let i = columnIndex; i < headersSettings.length; i++) {
      const headerSettings = headersSettings[i];
      if (headerSettings.isPlaceholder) {
        throwWithCause("The first column settings cannot overlap the other header layers");
      }
      currentLength += headerSettings.colspan;
      headersSettingsChunks.push(headerSettings);
      if (headerSettings.colspan > 1) {
        i += headerSettings.colspan - 1;
      }
      if (currentLength === columnsLength) {
        break;
      }
      if (currentLength > columnsLength) {
        throwWithCause("The last column settings cannot overlap the other header layers");
      }
    }
    return headersSettingsChunks;
  }
  /**
  * Inserts `amount` columns into the normalized settings starting at the visual `columnIndex`.
  *
  * The behavior mirrors the MergeCells plugin: a column inserted strictly inside a header's span
  * extends that header (and every ancestor that also spans the point), while a column inserted at a
  * header's left boundary (or before/after the whole structure) is added as a standalone header.
  * In the normalized representation "strictly inside a span" is exactly "the cell at the insert
  * index is a placeholder".
  *
  * @param {number} columnIndex A visual column index at which the new columns are inserted.
  * @param {number} amount The number of columns to insert.
  */
  insertColumns(columnIndex, amount) {
    arrayEach(_class_private_field_get$l(this, _data), (cells) => {
      if (columnIndex > 0 && columnIndex < cells.length && cells[columnIndex].isPlaceholder) {
        let headerIndex = columnIndex - 1;
        while (headerIndex > 0 && cells[headerIndex].isPlaceholder) {
          headerIndex -= 1;
        }
        cells[headerIndex].colspan = (cells[headerIndex].colspan ?? 1) + amount;
        cells[headerIndex].origColspan = (cells[headerIndex].origColspan ?? 1) + amount;
        const placeholders = [];
        for (let i = 0; i < amount; i++) {
          placeholders.push(createPlaceholderHeaderSettings());
        }
        cells.splice(columnIndex, 0, ...placeholders);
      } else {
        const defaults2 = [];
        for (let i = 0; i < amount; i++) {
          defaults2.push(createDefaultHeaderSettings());
        }
        cells.splice(Math.min(columnIndex, cells.length), 0, ...defaults2);
      }
    });
  }
  /**
  * Removes `amount` columns from the normalized settings starting at the visual `columnIndex`.
  *
  * Every header that overlaps the removed range is shrunk by the number of removed columns it
  * covered. A header that loses all its columns is dropped; a header whose leftmost (labeled)
  * column is removed but which still has surviving columns is re-anchored to the first surviving
  * column, keeping its label and configurable properties.
  *
  * @param {number} columnIndex A visual column index from which the columns are removed.
  * @param {number} amount The number of columns to remove.
  */
  removeColumns(columnIndex, amount) {
    const endIndex = columnIndex + amount;
    _class_private_field_set$l(this, _data, _class_private_field_get$l(this, _data).map((cells) => {
      const newCells = [];
      let cellIndex = 0;
      while (cellIndex < cells.length) {
        const cell = cells[cellIndex];
        const span = cell.isPlaceholder ? 1 : cell.origColspan ?? 1;
        const segmentEnd = cellIndex + span - 1;
        let survivingColumns = 0;
        for (let column = cellIndex; column <= segmentEnd; column++) {
          if (column < columnIndex || column >= endIndex) {
            survivingColumns += 1;
          }
        }
        if (survivingColumns > 0) {
          newCells.push(createDefaultHeaderSettings({
            ...cell,
            colspan: survivingColumns,
            origColspan: survivingColumns,
            isPlaceholder: false
          }));
          for (let i = 1; i < survivingColumns; i++) {
            newCells.push(createPlaceholderHeaderSettings());
          }
        }
        cellIndex = segmentEnd + 1;
      }
      return newCells;
    }));
  }
  /**
  * Gets a total number of headers levels.
  *
  * @returns {number}
  */
  getLayersCount() {
    return _class_private_field_get$l(this, _dataLength);
  }
  /**
  * Gets a total number of columns count.
  *
  * @returns {number}
  */
  getColumnsCount() {
    return _class_private_field_get$l(this, _dataLength) > 0 ? _class_private_field_get$l(this, _data)[0].length : 0;
  }
  /**
  * Clears the data.
  */
  clear() {
    _class_private_field_set$l(this, _data, []);
    _class_private_field_set$l(this, _dataLength, 0);
  }
  constructor() {
    _class_private_field_init$l(this, _data, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$l(this, _dataLength, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$l(this, _columnsLimit, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$l(this, _data, []);
    _class_private_field_set$l(this, _dataLength, 0);
    _class_private_field_set$l(this, _columnsLimit, Infinity);
  }
}
const TRAVERSAL_DF_PRE = "DF-pre-order";
function depthFirstPreOrder(callback, context) {
  let continueTraverse = callback.call(context, this);
  for (let i = 0; i < this.childs.length; i++) {
    if (continueTraverse === false) {
      return false;
    }
    continueTraverse = depthFirstPreOrder.call(this.childs[i], callback, context);
  }
  return continueTraverse;
}
const TRAVERSAL_DF_POST = "DF-post-order";
function depthFirstPostOrder(callback, context) {
  for (let i = 0; i < this.childs.length; i++) {
    const continueTraverse = depthFirstPostOrder.call(this.childs[i], callback, context);
    if (continueTraverse === false) {
      return false;
    }
  }
  return callback.call(context, this);
}
const TRAVERSAL_BF = "BF";
function breadthFirst(callback, context) {
  const queue = [
    this
  ];
  function process2() {
    if (queue.length === 0) {
      return;
    }
    const node = queue.shift();
    queue.push(...node.childs);
    if (callback.call(context, node) !== false) {
      process2();
    }
  }
  process2();
}
const DEFAULT_TRAVERSAL_STRATEGY = TRAVERSAL_BF;
const TRAVERSAL_STRATEGIES = /* @__PURE__ */ new Map([
  [
    TRAVERSAL_DF_PRE,
    depthFirstPreOrder
  ],
  [
    TRAVERSAL_DF_POST,
    depthFirstPostOrder
  ],
  [
    TRAVERSAL_BF,
    breadthFirst
  ]
]);
class TreeNode {
  /**
  * Adds a node to tree leaves. Added node is linked with the parent node through "parent" property.
  *
  * @param {TreeNode} node A TreeNode to add.
  */
  addChild(node) {
    node.parent = this;
    this.childs.push(node);
  }
  /**
  * @memberof TreeNode#
  * @function cloneTree
  *
  * Clones a tree structure deeply.
  *
  * For example, for giving a tree structure:
  *      .--(B1)--.
  *   .-(C1)   .-(C2)-.----.
  *  (D1)     (D2)   (D3) (D4)
  *
  * Cloning a tree starting from C2 node creates a mirrored tree structure.
  *     .-(C2')-.-----.
  *    (D2')   (D3') (D4')
  *
  * The cloned tree can be safely modified without affecting the original structure.
  * After modification, the clone can be merged with a tree using the "replaceTreeWith" method.
  *
  * @param {TreeNode} [nodeTree=this] A TreeNode to clone.
  * @returns {TreeNode}
  */
  cloneTree(nodeTree = this) {
    const clonedNode = new TreeNode({
      ...nodeTree.data
    });
    for (let i = 0; i < nodeTree.childs.length; i++) {
      clonedNode.addChild(this.cloneTree(nodeTree.childs[i]));
    }
    return clonedNode;
  }
  /**
  * Replaces the current node with a passed tree structure.
  *
  * @param {TreeNode} nodeTree A TreeNode to replace with.
  */
  replaceTreeWith(nodeTree) {
    this.data = {
      ...nodeTree.data
    };
    this.childs = [];
    for (let i = 0; i < nodeTree.childs.length; i++) {
      this.addChild(nodeTree.childs[i]);
    }
  }
  /**
  * Traverses the tree structure through node childs. The walk down traversing supports
  * a three different strategies.
  *  - Depth-first pre-order strategy (https://en.wikipedia.org/wiki/Tree_traversal#Pre-order_(NLR));
  *  - Depth-first post-order strategy (https://en.wikipedia.org/wiki/Tree_traversal#Post-order_(NLR));
  *  - Breadth-first traversal strategy (https://en.wikipedia.org/wiki/Tree_traversal#Breadth-first_search_/_level_order).
  *
  * @param {Function} callback The callback function which will be called for each node.
  * @param {string} [traversalStrategy=DEFAULT_TRAVERSAL_STRATEGY] Traversing strategy.
  */
  walkDown(callback, traversalStrategy = DEFAULT_TRAVERSAL_STRATEGY) {
    if (!TRAVERSAL_STRATEGIES.has(traversalStrategy)) {
      throwWithCause(`Traversal strategy "${traversalStrategy}" does not exist`);
    }
    TRAVERSAL_STRATEGIES.get(traversalStrategy).call(this, callback, this);
  }
  /**
  * Traverses the tree structure through node parents.
  *
  * @param {Function} callback The callback function which will be called for each node.
  */
  walkUp(callback) {
    const process2 = (node) => {
      const continueTraverse = callback.call(this, node);
      if (continueTraverse !== false && node.parent !== null) {
        process2(node.parent);
      }
    };
    process2(this);
  }
  /**
  * Initializes the tree node with the provided data object.
  */
  constructor(data) {
    this.parent = null;
    this.childs = [];
    this.data = data;
  }
}
function _check_private_redeclaration$l(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$k(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$k(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$k(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$k(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$k(receiver, privateMap, "get");
  return _class_apply_descriptor_get$k(receiver, descriptor);
}
function _class_private_field_init$k(obj, privateMap, value) {
  _check_private_redeclaration$l(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$k(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$k(receiver, privateMap, "set");
  _class_apply_descriptor_set$k(receiver, descriptor, value);
  return value;
}
var _rootNodes = /* @__PURE__ */ new WeakMap(), _rootsIndex = /* @__PURE__ */ new WeakMap(), _sourceSettings$1 = /* @__PURE__ */ new WeakMap();
class HeadersTree {
  /**
  * Gets an array of the all root nodes.
  *
  * @returns {TreeNode[]}
  */
  getRoots() {
    return Array.from(_class_private_field_get$k(this, _rootNodes).values());
  }
  /**
  * Gets a root node by specified visual column index.
  *
  * @param {number} columnIndex A visual column index.
  * @returns {TreeNode|undefined}
  */
  getRootByColumn(columnIndex) {
    let node;
    if (_class_private_field_get$k(this, _rootsIndex).has(columnIndex)) {
      node = _class_private_field_get$k(this, _rootNodes).get(_class_private_field_get$k(this, _rootsIndex).get(columnIndex));
    }
    return node;
  }
  /**
  * Gets a tree node by its position in the grid settings.
  *
  * @param {number} headerLevel Header level index.
  * @param {number} columnIndex A visual column index.
  * @returns {TreeNode|undefined}
  */
  getNode(headerLevel, columnIndex) {
    const rootNode = this.getRootByColumn(columnIndex);
    if (!rootNode) {
      return;
    }
    const normColumnIndex = columnIndex - _class_private_field_get$k(this, _rootsIndex).get(columnIndex);
    let columnCursor = 0;
    let treeNode;
    rootNode.walkDown((node) => {
      const { origColspan, headerLevel: nodeHeaderLevel } = node.data;
      if (headerLevel === nodeHeaderLevel) {
        if (normColumnIndex >= columnCursor && normColumnIndex <= columnCursor + origColspan - 1) {
          treeNode = node;
          treeNode.data.isRoot = columnIndex === treeNode.data.columnIndex;
          return false;
        }
        columnCursor += origColspan;
      }
    });
    return treeNode;
  }
  /**
  * Builds (or rebuilds if called again) root nodes indexes.
  */
  rebuildTreeIndex() {
    let columnIndex = 0;
    _class_private_field_get$k(this, _rootsIndex).clear();
    arrayEach(_class_private_field_get$k(this, _rootNodes), ([, node]) => {
      const { colspan } = node.data;
      for (let i = columnIndex; i < columnIndex + colspan; i++) {
        _class_private_field_get$k(this, _rootsIndex).set(i, columnIndex);
      }
      columnIndex += colspan;
    });
  }
  /**
  * Builds trees based on SourceSettings class.
  */
  buildTree() {
    this.clear();
    const columnsCount = _class_private_field_get$k(this, _sourceSettings$1).getColumnsCount();
    let columnIndex = 0;
    while (columnIndex < columnsCount) {
      const columnSettings = _class_private_field_get$k(this, _sourceSettings$1).getHeaderSettings(0, columnIndex);
      const rootNode = new TreeNode({
        ...createDefaultHeaderSettings(),
        headerLevel: 0,
        columnIndex
      });
      _class_private_field_get$k(this, _rootNodes).set(columnIndex, rootNode);
      this.buildLeaves(rootNode, columnIndex, 0, columnSettings.origColspan);
      columnIndex += columnSettings.origColspan;
    }
    this.rebuildTreeIndex();
  }
  /**
  * Builds leaves for specified tree node.
  *
  * @param {TreeNode} parentNode A node to which the leaves applies.
  * @param {number} columnIndex A visual column index.
  * @param {number} headerLevel Currently processed header level.
  * @param {number} [extractionLength=1] Determines column extraction length for node children.
  */
  buildLeaves(parentNode, columnIndex, headerLevel, extractionLength = 1) {
    const columnsSettings = _class_private_field_get$k(this, _sourceSettings$1).getHeadersSettings(headerLevel, columnIndex, extractionLength);
    headerLevel += 1;
    arrayEach(columnsSettings, (rawColumnSettings) => {
      const columnSettings = rawColumnSettings;
      const nodeData = {
        ...columnSettings,
        /**
        * The header level (tree node depth level).
        *
        * @type {number}
        */
        headerLevel: headerLevel - 1,
        /**
        * A visual column index.
        *
        * @type {number}
        */
        columnIndex
      };
      let node;
      if (headerLevel === 1) {
        parentNode.data = nodeData;
        node = parentNode;
      } else {
        node = new TreeNode(nodeData);
        parentNode.addChild(node);
      }
      if (headerLevel < _class_private_field_get$k(this, _sourceSettings$1).getLayersCount()) {
        this.buildLeaves(node, columnIndex, headerLevel, columnSettings.origColspan);
      }
      columnIndex += columnSettings.origColspan;
    });
  }
  /**
  * Clears the tree to the initial state.
  */
  clear() {
    _class_private_field_get$k(this, _rootNodes).clear();
    _class_private_field_get$k(this, _rootsIndex).clear();
  }
  /**
  * Initializes the headers tree with the given source settings used to build the nested header structure.
  */
  constructor(sourceSettings) {
    _class_private_field_init$k(this, _rootNodes, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$k(this, _rootsIndex, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$k(this, _sourceSettings$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$k(this, _rootNodes, /* @__PURE__ */ new Map());
    _class_private_field_set$k(this, _rootsIndex, /* @__PURE__ */ new Map());
    _class_private_field_set$k(this, _sourceSettings$1, null);
    _class_private_field_set$k(this, _sourceSettings$1, sourceSettings);
  }
}
function traverseExposedColumnIndexes(node, callback) {
  const { data, childs } = node;
  if (data.isCollapsed) {
    if (childs.length > 0) {
      const representative = childs.find(({ data: childData }) => !childData.isHidden);
      if (representative) {
        traverseExposedColumnIndexes(representative, callback);
      }
    } else {
      for (let i = 0; i < data.colspan; i++) {
        callback(data.columnIndex + i);
      }
    }
    return;
  }
  if (childs.length === 0) {
    for (let i = 0; i < data.origColspan; i++) {
      callback(data.columnIndex + i);
    }
    return;
  }
  childs.forEach((child) => traverseExposedColumnIndexes(child, callback));
}
function isDeclarativeGroup(node) {
  return node.childs.length > 0 && node.childs.some(({ data }) => data.visibleWhen !== void 0);
}
function getFirstChildProperty({ childs }, propertyName) {
  if (childs.length === 0) {
    return;
  }
  return childs[0].data[propertyName];
}
function isNodeReflectsFirstChildColspan(node) {
  return getFirstChildProperty(node, "origColspan") === node.data.origColspan;
}
function expandNode(nodeToProcess) {
  const { data: nodeData, childs: nodeChilds } = nodeToProcess;
  if (!nodeData.isCollapsed || nodeData.isHidden || nodeData.origColspan <= 1) {
    return {
      rollbackModification: () => {
      },
      affectedColumns: [],
      colspanCompensation: 0
    };
  }
  if (isDeclarativeGroup(nodeToProcess)) {
    nodeData.isCollapsed = false;
    return {
      rollbackModification: () => collapseNode(nodeToProcess),
      affectedColumns: [],
      colspanCompensation: 0
    };
  }
  const isNodeReflected = isNodeReflectsFirstChildColspan(nodeToProcess);
  if (isNodeReflected) {
    return expandNode(nodeChilds[0]);
  }
  nodeData.isCollapsed = false;
  const childsToRestore = nodeChilds.filter(({ data }) => data.clonedTree);
  const affectedColumns = /* @__PURE__ */ new Set();
  let colspanCompensation = 0;
  if (childsToRestore.length > 0) {
    arrayEach(childsToRestore, (treeNode) => {
      const clonedTree = treeNode.data.clonedTree;
      treeNode.replaceTreeWith(clonedTree);
      const leafData = treeNode.data;
      leafData.clonedTree = null;
      colspanCompensation += leafData.colspan;
      traverseExposedColumnIndexes(treeNode, (gridColumnIndex) => {
        affectedColumns.add(gridColumnIndex);
      });
    });
  } else if (nodeChilds.length === 0) {
    const { colspan, origColspan, columnIndex } = nodeData;
    colspanCompensation = origColspan - colspan;
    for (let i = 1; i < origColspan; i++) {
      affectedColumns.add(columnIndex + i);
    }
  }
  nodeToProcess.walkUp((node) => {
    const { data } = node;
    data.colspan += colspanCompensation;
    if (data.colspan >= data.origColspan) {
      data.colspan = data.origColspan;
      data.isCollapsed = false;
    } else if (isNodeReflectsFirstChildColspan(node)) {
      data.isCollapsed = getFirstChildProperty(node, "isCollapsed");
    }
  });
  return {
    rollbackModification: () => collapseNode(nodeToProcess),
    affectedColumns: Array.from(affectedColumns),
    colspanCompensation
  };
}
function collapseNode(nodeToProcess) {
  const { data: nodeData, childs: nodeChilds } = nodeToProcess;
  if (nodeData.isCollapsed || nodeData.isHidden || nodeData.origColspan <= 1) {
    return {
      rollbackModification: () => {
      },
      affectedColumns: [],
      colspanCompensation: 0
    };
  }
  if (isDeclarativeGroup(nodeToProcess)) {
    nodeData.isCollapsed = true;
    return {
      rollbackModification: () => expandNode(nodeToProcess),
      affectedColumns: [],
      colspanCompensation: 0
    };
  }
  const isNodeReflected = isNodeReflectsFirstChildColspan(nodeToProcess);
  if (isNodeReflected) {
    return collapseNode(nodeChilds[0]);
  }
  const affectedColumns = /* @__PURE__ */ new Set();
  let colspanCompensation = 0;
  if (nodeChilds.length > 0) {
    const firstVisibleChildIndex = nodeChilds.findIndex(({ data }) => !data.isHidden);
    const childsToHide = nodeChilds.filter((_, index2) => index2 > firstVisibleChildIndex);
    if (firstVisibleChildIndex === -1 || childsToHide.length === 0) {
      return {
        rollbackModification: () => {
        },
        affectedColumns: [],
        colspanCompensation: 0
      };
    }
    arrayEach(childsToHide, (treeNode) => {
      traverseExposedColumnIndexes(treeNode, (gridColumnIndex) => {
        affectedColumns.add(gridColumnIndex);
      });
      treeNode.data.clonedTree = treeNode.cloneTree();
      treeNode.walkDown(({ data }) => {
        data.isHidden = true;
      });
    });
    colspanCompensation = nodeData.colspan - nodeChilds[firstVisibleChildIndex].data.colspan;
  } else {
    const { origColspan, columnIndex } = nodeData;
    const hiddenColumns = new Set(nodeData.crossHiddenColumns);
    const visibleColumns = [];
    for (let i = columnIndex; i < columnIndex + origColspan; i++) {
      if (!hiddenColumns.has(i)) {
        visibleColumns.push(i);
      }
    }
    if (visibleColumns.length <= 1) {
      return {
        rollbackModification: () => {
        },
        affectedColumns: [],
        colspanCompensation: 0
      };
    }
    arrayEach(visibleColumns.slice(1), (gridColumnIndex) => {
      affectedColumns.add(gridColumnIndex);
    });
    colspanCompensation = visibleColumns.length - 1;
  }
  nodeData.isCollapsed = true;
  nodeToProcess.walkUp((node) => {
    const { data } = node;
    data.colspan -= colspanCompensation;
    if (data.colspan <= 1) {
      data.colspan = 1;
      data.isCollapsed = true;
    } else if (isNodeReflectsFirstChildColspan(node)) {
      data.isCollapsed = getFirstChildProperty(node, "isCollapsed");
    }
  });
  return {
    rollbackModification: () => expandNode(nodeToProcess),
    affectedColumns: Array.from(affectedColumns),
    colspanCompensation
  };
}
const availableModifiers = /* @__PURE__ */ new Map([
  [
    "collapse",
    collapseNode
  ],
  [
    "expand",
    expandNode
  ]
]);
function triggerNodeModification(actionName, nodeToProcess, gridColumnIndex) {
  const modifier = availableModifiers.get(actionName);
  if (!modifier) {
    throwWithCause(`The node modifier action ("${actionName}") does not exist.`);
  }
  return modifier(nodeToProcess, gridColumnIndex);
}
function generateMatrix(headerRoots) {
  const matrix = [];
  arrayEach(headerRoots, (rootNode) => {
    rootNode.walkDown((node) => {
      const nodeData = node.data;
      const { origColspan, columnIndex, headerLevel, crossHiddenColumns } = nodeData;
      const colspanHeaderLayer = createNestedArrayIfNecessary(matrix, headerLevel);
      let isRootSettingsFound = false;
      for (let i = columnIndex; i < columnIndex + origColspan; i++) {
        const isColumnHidden = crossHiddenColumns.includes(i);
        if (isColumnHidden || isRootSettingsFound) {
          colspanHeaderLayer.push(createPlaceholderHeaderSettings());
        } else {
          const headerRootSettings = createHeaderSettings(nodeData);
          headerRootSettings.isRoot = true;
          colspanHeaderLayer.push(headerRootSettings);
          isRootSettingsFound = true;
        }
      }
    });
  });
  applyRowspanToMatrix(matrix);
  return matrix;
}
function applyRowspanToMatrix(matrix) {
  for (let level = 0; level < matrix.length; level++) {
    const row = matrix[level];
    for (let col = 0; col < row.length; col++) {
      const settings = row[col];
      if (!settings || !settings.isRoot || !settings.origRowspan || settings.origRowspan <= 1) {
        continue;
      }
      const effectiveRowspan = Math.min(settings.origRowspan, matrix.length - level);
      const colspanWidth = settings.origColspan || 1;
      for (let r = 1; r < effectiveRowspan; r++) {
        const targetLevel = level + r;
        if (!matrix[targetLevel]) {
          continue;
        }
        for (let c = col; c < col + colspanWidth && c < matrix[targetLevel].length; c++) {
          matrix[targetLevel][c] = {
            label: "",
            isPlaceholder: true,
            isRowspanPlaceholder: true
          };
        }
      }
    }
  }
}
function createHeaderSettings(nodeData) {
  const { crossHiddenColumns, ...headerRootSettings } = createDefaultHeaderSettings(nodeData);
  return headerRootSettings;
}
function createNestedArrayIfNecessary(array, index2) {
  let subArray;
  if (Array.isArray(array[index2])) {
    subArray = array[index2];
  } else {
    subArray = [];
    array[index2] = subArray;
  }
  return subArray;
}
function syncVisibilityOnTree(roots, columnVisibility) {
  roots.forEach((rootNode) => {
    rootNode.walkDown((node) => {
      const data = node.data;
      const { columnIndex, origColspan } = data;
      const crossHiddenColumns = [];
      for (let i = columnIndex; i < columnIndex + origColspan; i++) {
        if (!columnVisibility.isVisible(i)) {
          crossHiddenColumns.push(i);
        }
      }
      data.crossHiddenColumns = crossHiddenColumns;
      data.colspan = origColspan - crossHiddenColumns.length;
      data.isHidden = data.colspan === 0;
    });
  });
}
function _check_private_redeclaration$k(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$j(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$j(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$j(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$j(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$j(receiver, privateMap, "get");
  return _class_apply_descriptor_get$j(receiver, descriptor);
}
function _class_private_field_init$j(obj, privateMap, value) {
  _check_private_redeclaration$k(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$j(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$j(receiver, privateMap, "set");
  _class_apply_descriptor_set$j(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$a(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$a(obj, privateSet) {
  _check_private_redeclaration$k(obj, privateSet);
  privateSet.add(obj);
}
var _sourceSettings = /* @__PURE__ */ new WeakMap(), _headersTree = /* @__PURE__ */ new WeakMap(), _stateMatrix = /* @__PURE__ */ new WeakMap(), _lastColumnVisibility = /* @__PURE__ */ new WeakMap(), _rebuildPreservingCollapse = /* @__PURE__ */ new WeakSet(), _snapshotCollapsedNodes = /* @__PURE__ */ new WeakSet(), _reapplyCollapsedNodes = /* @__PURE__ */ new WeakSet(), _applySyncVisibility = /* @__PURE__ */ new WeakSet(), _deriveVisibility = /* @__PURE__ */ new WeakSet();
class StateManager {
  /**
  * Sets a new state for the nested headers plugin based on settings passed
  * directly to the plugin.
  *
  * @param {Array[]} nestedHeadersSettings The user-defined settings.
  * @returns {boolean} Returns `true` if the settings are processed correctly, `false` otherwise.
  */
  setState(nestedHeadersSettings) {
    _class_private_field_get$j(this, _sourceSettings).setData(nestedHeadersSettings);
    let hasError = false;
    try {
      _class_private_field_get$j(this, _headersTree).buildTree();
    } catch (ex) {
      _class_private_field_get$j(this, _headersTree).clear();
      _class_private_field_get$j(this, _sourceSettings).clear();
      hasError = true;
    }
    _class_private_method_get$a(this, _applySyncVisibility, applySyncVisibility).call(this);
    return hasError;
  }
  /**
  * Sets columns limit to the state will be trimmed.
  *
  * @param {number} columnsCount The number of columns to limit to.
  */
  setColumnsLimit(columnsCount) {
    _class_private_field_get$j(this, _sourceSettings).setColumnsLimit(columnsCount);
  }
  /**
  * Merges settings with current plugin state.
  *
  * @param {object[]} settings An array of objects to merge with the current source settings.
  */
  mergeStateWith(settings) {
    const transformedSettings = arrayMap(settings, ({ row, ...rest }) => {
      return {
        row: row < 0 ? this.rowCoordsToLevel(row) ?? row : row,
        ...rest
      };
    });
    _class_private_method_get$a(this, _rebuildPreservingCollapse, rebuildPreservingCollapse).call(this, () => _class_private_field_get$j(this, _sourceSettings).mergeWith(transformedSettings), (columnIndex) => columnIndex);
  }
  /**
  * Maps the current state with a callback.
  *
  * @param {Function} callback A function that is called for every header source settings.
  */
  mapState(callback) {
    _class_private_method_get$a(this, _rebuildPreservingCollapse, rebuildPreservingCollapse).call(this, () => _class_private_field_get$j(this, _sourceSettings).map(callback), (columnIndex) => columnIndex);
  }
  /**
  * Inserts `amount` columns into the source settings at the visual `columnIndex`, then rebuilds
  * the tree and re-derives visibility. Headers spanning the insertion point are extended; columns
  * inserted at a header boundary become standalone headers.
  *
  * @param {number} columnIndex A visual column index at which the new columns are inserted.
  * @param {number} amount The number of columns to insert.
  */
  insertColumns(columnIndex, amount) {
    _class_private_method_get$a(this, _rebuildPreservingCollapse, rebuildPreservingCollapse).call(this, () => _class_private_field_get$j(this, _sourceSettings).insertColumns(columnIndex, amount), (c) => c >= columnIndex ? c + amount : c);
  }
  /**
  * Removes `amount` columns from the source settings starting at the visual `columnIndex`, then
  * rebuilds the tree and re-derives visibility. Headers overlapping the removed range are shrunk,
  * re-anchored, or dropped when they lose all their columns.
  *
  * @param {number} columnIndex A visual column index from which the columns are removed.
  * @param {number} amount The number of columns to remove.
  */
  removeColumns(columnIndex, amount) {
    const endIndex = columnIndex + amount;
    _class_private_method_get$a(this, _rebuildPreservingCollapse, rebuildPreservingCollapse).call(this, () => _class_private_field_get$j(this, _sourceSettings).removeColumns(columnIndex, amount), (c) => {
      if (c < columnIndex) {
        return c;
      }
      return c >= endIndex ? c - amount : columnIndex;
    });
  }
  /**
  * Maps the current tree nodes with a callback.
  *
  * @param {Function} callback A function that is called for every tree node.
  * @returns {Array}
  */
  mapNodes(callback) {
    return arrayReduce(_class_private_field_get$j(this, _headersTree).getRoots(), (acc, rootNode) => {
      rootNode.walkDown((node) => {
        const result = callback(node.data);
        if (result !== void 0) {
          acc.push(result);
        }
      });
      return acc;
    }, []);
  }
  /**
  * Triggers an action from the NodeModifiers module.
  *
  * @param {string} action An action name to trigger.
  * @param {number} headerLevel Header level index.
  * @param {number} columnIndex A visual column index.
  * @returns {object|undefined}
  */
  triggerNodeModification(action, headerLevel, columnIndex) {
    if (headerLevel < 0) {
      headerLevel = this.rowCoordsToLevel(headerLevel) ?? 0;
    }
    const nodeToProcess = _class_private_field_get$j(this, _headersTree).getNode(headerLevel, columnIndex);
    let actionResult;
    if (nodeToProcess) {
      actionResult = triggerNodeModification(action, nodeToProcess, columnIndex);
      _class_private_field_set$j(this, _stateMatrix, generateMatrix(_class_private_field_get$j(this, _headersTree).getRoots()));
    }
    return actionResult ?? void 0;
  }
  /**
  * Triggers an action from the NodeModifiers module starting from the lowest header.
  *
  * @param {string} action An action name to trigger.
  * @param {number} columnIndex A visual column index.
  * @returns {object|undefined}
  */
  triggerColumnModification(action, columnIndex) {
    return this.triggerNodeModification(action, -1, columnIndex);
  }
  /**
  * Derives tree-node visibility state (colspan, crossHiddenColumns, isHidden) from an external
  * ColumnVisibility port, then regenerates the state matrix. Call this whenever the hiding map
  * changes (HiddenColumns, CollapsibleColumns) or after column sequence changes.
  *
  * @param {ColumnVisibility} columnVisibility The visibility port.
  */
  syncVisibility(columnVisibility) {
    _class_private_field_set$j(this, _lastColumnVisibility, columnVisibility);
    syncVisibilityOnTree(_class_private_field_get$j(this, _headersTree).getRoots(), columnVisibility);
    _class_private_field_set$j(this, _stateMatrix, generateMatrix(_class_private_field_get$j(this, _headersTree).getRoots()));
  }
  /**
  * @memberof StateManager#
  * @function rowCoordsToLevel
  *
  * Translates row coordinates into header level.
  *
  * @param {number} rowIndex A visual row index.
  * @returns {number|null} Returns unsigned number.
  */
  rowCoordsToLevel(rowIndex) {
    if (rowIndex >= 0) {
      return null;
    }
    const headerLevel = rowIndex + Math.max(this.getLayersCount(), 1);
    if (headerLevel < 0) {
      return null;
    }
    return headerLevel;
  }
  /**
  * @memberof StateManager#
  * @function levelToRowCoords
  *
  * Translates header level into row coordinates.
  *
  * @param {number} headerLevel Header level index.
  * @returns {number} Returns negative number.
  */
  levelToRowCoords(headerLevel) {
    if (headerLevel < 0) {
      return null;
    }
    const rowIndex = headerLevel - Math.max(this.getLayersCount(), 1);
    if (rowIndex >= 0) {
      return null;
    }
    return rowIndex;
  }
  /**
  * Gets column header settings for a specified column and header index.
  *
  * @param {number} headerLevel Header level.
  * @param {number} columnIndex A visual column index.
  * @returns {object|null}
  */
  getHeaderSettings(headerLevel, columnIndex) {
    if (headerLevel < 0) {
      headerLevel = this.rowCoordsToLevel(headerLevel) ?? 0;
    }
    if (headerLevel === null || headerLevel >= this.getLayersCount()) {
      return null;
    }
    return _class_private_field_get$j(this, _stateMatrix)[headerLevel]?.[columnIndex] ?? null;
  }
  /**
  * Gets tree data that is connected to the column header.
  *
  * @param {number} headerLevel Header level.
  * @param {number} columnIndex A visual column index.
  * @returns {object|null}
  */
  getHeaderTreeNodeData(headerLevel, columnIndex) {
    const node = this.getHeaderTreeNode(headerLevel, columnIndex);
    if (!node) {
      return null;
    }
    return {
      ...node.data
    };
  }
  /**
  * Gets tree node that is connected to the column header.
  *
  * @param {number} headerLevel Header level.
  * @param {number} columnIndex A visual column index.
  * @returns {TreeNode|null}
  */
  getHeaderTreeNode(headerLevel, columnIndex) {
    let resolvedLevel = headerLevel;
    if (headerLevel < 0) {
      resolvedLevel = this.rowCoordsToLevel(headerLevel);
    }
    if (resolvedLevel === null || resolvedLevel >= this.getLayersCount()) {
      return null;
    }
    const node = _class_private_field_get$j(this, _headersTree).getNode(resolvedLevel, columnIndex);
    if (!node) {
      return null;
    }
    return node;
  }
  /**
  * Finds the most top header level of the column header.
  *
  * @param {number} columnIndexFrom A visual column index.
  * @param {number} [columnIndexTo] A visual column index.
  * @returns {number} Returns a header level in format -1 to -N.
  */
  findTopMostEntireHeaderLevel(columnIndexFrom, columnIndexTo = columnIndexFrom) {
    const columnsWidth = columnIndexTo - columnIndexFrom + 1;
    let atLeastOneRootFound = false;
    let headerLevel = null;
    for (let columnIndex = columnIndexFrom; columnIndex <= columnIndexTo; columnIndex++) {
      const rootNode = _class_private_field_get$j(this, _headersTree).getRootByColumn(columnIndex);
      if (!rootNode) {
        break;
      }
      atLeastOneRootFound = true;
      rootNode.walkDown((node) => {
        const { columnIndex: nodeColumnIndex, headerLevel: nodeHeaderLevel, origColspan, isHidden } = node.data;
        if (isHidden) {
          return;
        }
        if (origColspan <= columnsWidth && nodeColumnIndex >= columnIndexFrom && nodeColumnIndex + origColspan - 1 <= columnIndexTo && (headerLevel === null || nodeHeaderLevel < headerLevel)) {
          headerLevel = nodeHeaderLevel;
        }
      }, TRAVERSAL_DF_PRE);
    }
    if (atLeastOneRootFound && headerLevel === null) {
      return -1;
    }
    return this.levelToRowCoords(headerLevel ?? 0);
  }
  /**
  * Finds the left-most column index where the nested header begins.
  *
  * @param {number} headerLevel Header level.
  * @param {number} columnIndex A visual column index.
  * @returns {number}
  */
  findLeftMostColumnIndex(headerLevel, columnIndex) {
    const { isRoot } = this.getHeaderSettings(headerLevel, columnIndex) ?? {
      isRoot: true
    };
    if (isRoot) {
      return columnIndex;
    }
    let stepBackColumn = columnIndex - 1;
    while (stepBackColumn >= 0) {
      const { isRoot: isRootNode } = this.getHeaderSettings(headerLevel, stepBackColumn) ?? {
        isRoot: true
      };
      if (isRootNode) {
        break;
      }
      stepBackColumn -= 1;
    }
    return stepBackColumn;
  }
  /**
  * Finds the right-most column index where the nested header ends.
  *
  * @param {number} headerLevel Header level.
  * @param {number} columnIndex A visual column index.
  * @returns {number}
  */
  findRightMostColumnIndex(headerLevel, columnIndex) {
    const { isRoot, origColspan } = this.getHeaderSettings(headerLevel, columnIndex) ?? {
      isRoot: true,
      origColspan: 1
    };
    if (isRoot) {
      return columnIndex + origColspan - 1;
    }
    let stepForthColumn = columnIndex + 1;
    while (stepForthColumn < this.getColumnsCount()) {
      const { isRoot: isRootNode } = this.getHeaderSettings(headerLevel, stepForthColumn) ?? {
        isRoot: true
      };
      if (isRootNode) {
        break;
      }
      stepForthColumn += 1;
    }
    return stepForthColumn - 1;
  }
  /**
  * Gets a total number of headers levels.
  *
  * @returns {number}
  */
  getLayersCount() {
    return _class_private_field_get$j(this, _sourceSettings).getLayersCount();
  }
  /**
  * Gets a total number of columns count.
  *
  * @returns {number}
  */
  getColumnsCount() {
    return _class_private_field_get$j(this, _sourceSettings).getColumnsCount();
  }
  /**
  * Computes the visual column indexes that should be hidden purely by the `visibleWhen` rules of
  * declarative collapsible groups (issue #10243), given each group's current `isCollapsed` state.
  *
  * A group is "declarative" when at least one of its direct children declares an explicit
  * `visibleWhen` ('collapsed', 'expanded', or 'always'); legacy groups (no markers) are left to the
  * regular first-visible-child collapse path and are skipped here. Within a declarative group a child
  * with no marker defaults to `'expanded'` - it is hidden when the group collapses, matching the
  * default collapse behavior; `'always'` is the explicit opt-in for staying visible in both states.
  * Only `collapsible` groups are considered. At least one column per group always stays visible so the
  * group's collapse indicator survives. The result is a pure function of the tree shape, the markers,
  * and the `isCollapsed` flags, so it stays correct across tree rebuilds.
  *
  * @returns {number[]} Visual column indexes to hide.
  */
  getVisibleWhenHiddenColumns() {
    const columnsToHide = [];
    _class_private_field_get$j(this, _headersTree).getRoots().forEach((rootNode) => {
      rootNode.walkDown((node) => {
        const childNodes = node.childs;
        if (node.data.collapsible !== true || childNodes.length === 0) {
          return;
        }
        if (!isDeclarativeGroup(node)) {
          return;
        }
        const isGroupCollapsed = node.data.isCollapsed === true;
        const childrenToHide = childNodes.filter((childNode) => {
          const visibility = childNode.data.visibleWhen ?? "expanded";
          return visibility === "expanded" && isGroupCollapsed || visibility === "collapsed" && !isGroupCollapsed;
        });
        if (childrenToHide.length === childNodes.length) {
          childrenToHide.shift();
        }
        childrenToHide.forEach(({ data: { columnIndex, origColspan } }) => {
          for (let i = 0; i < origColspan; i++) {
            columnsToHide.push(columnIndex + i);
          }
        });
      });
    });
    return columnsToHide;
  }
  /**
  * Clears the column state manager to the initial state.
  */
  clear() {
    _class_private_field_set$j(this, _stateMatrix, []);
    _class_private_field_get$j(this, _sourceSettings).clear();
    _class_private_field_get$j(this, _headersTree).clear();
    _class_private_field_set$j(this, _lastColumnVisibility, null);
  }
  constructor() {
    _class_private_method_init$a(this, _rebuildPreservingCollapse);
    _class_private_method_init$a(this, _snapshotCollapsedNodes);
    _class_private_method_init$a(this, _reapplyCollapsedNodes);
    _class_private_method_init$a(this, _applySyncVisibility);
    _class_private_method_init$a(this, _deriveVisibility);
    _class_private_field_init$j(this, _sourceSettings, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$j(this, _headersTree, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$j(this, _stateMatrix, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$j(this, _lastColumnVisibility, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$j(this, _sourceSettings, new SourceSettings());
    _class_private_field_set$j(this, _headersTree, new HeadersTree(_class_private_field_get$j(this, _sourceSettings)));
    _class_private_field_set$j(this, _stateMatrix, [
      []
    ]);
    _class_private_field_set$j(this, _lastColumnVisibility, null);
  }
}
function rebuildPreservingCollapse(mutate, shiftColumnIndex) {
  const collapsedNodes = _class_private_method_get$a(this, _snapshotCollapsedNodes, snapshotCollapsedNodes).call(this);
  mutate();
  _class_private_field_get$j(this, _headersTree).buildTree();
  _class_private_method_get$a(this, _deriveVisibility, deriveVisibility).call(this);
  _class_private_method_get$a(this, _reapplyCollapsedNodes, reapplyCollapsedNodes).call(this, collapsedNodes, shiftColumnIndex);
  _class_private_method_get$a(this, _applySyncVisibility, applySyncVisibility).call(this);
}
function snapshotCollapsedNodes() {
  const collapsedNodes = [];
  _class_private_field_get$j(this, _headersTree).getRoots().forEach((rootNode) => {
    rootNode.walkDown((node) => {
      const data = node.data;
      if (data.isCollapsed) {
        collapsedNodes.push({
          headerLevel: data.headerLevel,
          columnIndex: data.columnIndex
        });
      }
    });
  });
  return collapsedNodes;
}
function reapplyCollapsedNodes(collapsedNodes, shiftColumnIndex) {
  collapsedNodes.forEach(({ headerLevel, columnIndex }) => {
    this.triggerNodeModification("collapse", headerLevel, shiftColumnIndex(columnIndex));
  });
}
function applySyncVisibility() {
  _class_private_method_get$a(this, _deriveVisibility, deriveVisibility).call(this);
  _class_private_field_set$j(this, _stateMatrix, generateMatrix(_class_private_field_get$j(this, _headersTree).getRoots()));
}
function deriveVisibility() {
  if (_class_private_field_get$j(this, _lastColumnVisibility)) {
    syncVisibilityOnTree(_class_private_field_get$j(this, _headersTree).getRoots(), _class_private_field_get$j(this, _lastColumnVisibility));
  }
}
function createColumnVisibilityAdapter(hot) {
  return {
    isVisible(visualColumnIndex) {
      const physicalIndex = hot.columnIndexMapper.getPhysicalFromVisualIndex(visualColumnIndex);
      if (physicalIndex === null) {
        return false;
      }
      return !hot.columnIndexMapper.isHidden(physicalIndex);
    }
  };
}
function _check_private_redeclaration$j(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_method_get$9(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$9(obj, privateSet) {
  _check_private_redeclaration$j(obj, privateSet);
  privateSet.add(obj);
}
var _getCollapsedPhysicalColumns = /* @__PURE__ */ new WeakSet(), _buildGhostTable = /* @__PURE__ */ new WeakSet(), _buildRenderedTableHTML = /* @__PURE__ */ new WeakSet(), _buildHeaderLabelHTML = /* @__PURE__ */ new WeakSet();
class GhostTable2 {
  /**
  * Sets the number of nested headers layers count.
  *
  * @param {number} layersCount Total number of headers levels.
  * @returns {GhostTable}
  */
  setLayersCount(layersCount) {
    this.layersCount = layersCount;
    return this;
  }
  /**
  * Gets the column width based on the visual column index (as rendered in the main table).
  *
  * @param {number} visualColumn Visual column index.
  * @returns {number|null}
  */
  getWidth(visualColumn) {
    return this.widthsMap.getValueAtIndex(this.hot.toPhysicalColumn(visualColumn));
  }
  /**
  * Build cache of the headers widths.
  */
  buildWidthsMap() {
    const collapsedPhysicalColumns = _class_private_method_get$9(this, _getCollapsedPhysicalColumns, getCollapsedPhysicalColumns).call(this);
    const hasCollapsedGroups = collapsedPhysicalColumns.size > 0;
    const currentThemeName = this.hot.getCurrentThemeName();
    const previousWidthsByPhysical = /* @__PURE__ */ new Map();
    if (hasCollapsedGroups) {
      collapsedPhysicalColumns.forEach((physCol) => {
        const prevWidth = this.widthsMap.getValueAtIndex(physCol);
        if (prevWidth !== null && prevWidth !== void 0) {
          previousWidthsByPhysical.set(physCol, prevWidth);
        }
      });
    }
    this.container = this.hot.rootDocument.createElement("div");
    this.container.classList.add("handsontable", "htGhostTable", "htAutoSize", "htNestedHeaders");
    if (currentThemeName) {
      this.container.classList.add(currentThemeName);
    }
    _class_private_method_get$9(this, _buildGhostTable, buildGhostTable).call(this, this.container);
    this.hot.rootDocument.body.appendChild(this.container);
    const renderedTable = this.container.querySelector('[data-ghost-table="rendered"]');
    if (!renderedTable) {
      this.container.remove();
      this.container = null;
      return;
    }
    const allColumns = renderedTable.querySelectorAll("th[data-column]");
    const columnElementByVisual = /* @__PURE__ */ new Map();
    for (let i = 0; i < allColumns.length; i++) {
      const th = allColumns[i];
      if (th.colSpan > 1) {
        continue;
      }
      if (th.dataset.column === void 0) {
        continue;
      }
      const visCol = Number.parseInt(th.dataset.column, 10);
      columnElementByVisual.set(visCol, th);
    }
    this.widthsMap.clear();
    columnElementByVisual.forEach((thElement, visualColumnIndex) => {
      const physicalColumnIndex = this.hot.toPhysicalColumn(visualColumnIndex);
      if (this.hot.columnIndexMapper.isHidden(physicalColumnIndex)) {
        return;
      }
      let width;
      if (hasCollapsedGroups && collapsedPhysicalColumns.has(physicalColumnIndex)) {
        width = previousWidthsByPhysical.get(physicalColumnIndex);
      }
      if (width === void 0 || width === null) {
        width = thElement.getBoundingClientRect().width;
      }
      this.widthsMap.setValueAtIndex(physicalColumnIndex, width);
    });
    this.container.remove();
    this.container = null;
  }
  /**
  * Clear the widths cache.
  */
  clear() {
    this.widthsMap.clear();
    this.container = null;
  }
  /**
  * Initializes the ghost table with the Handsontable instance and headers state manager, and registers the widths index map.
  */
  constructor({ hot, headersStateManager }) {
    _class_private_method_init$9(this, _getCollapsedPhysicalColumns);
    _class_private_method_init$9(this, _buildGhostTable);
    _class_private_method_init$9(this, _buildRenderedTableHTML);
    _class_private_method_init$9(this, _buildHeaderLabelHTML);
    this.layersCount = 0;
    this.hot = hot;
    this.headersStateManager = headersStateManager;
    this.widthsMap = this.hot.columnIndexMapper.createAndRegisterIndexMap("nestedHeaders.widthsMap", "physicalIndexToValue");
  }
}
function getCollapsedPhysicalColumns() {
  const collapsedPhysicals = /* @__PURE__ */ new Set();
  const maxColumnsCount = this.hot.countCols();
  for (let col = 0; col < maxColumnsCount; col++) {
    const treeNode = this.headersStateManager.getHeaderTreeNode(-1, col);
    if (!treeNode) {
      continue;
    }
    let found = false;
    treeNode.walkUp((node) => {
      if (node.data.isCollapsed === true) {
        found = true;
        return false;
      }
    });
    if (found) {
      collapsedPhysicals.add(this.hot.toPhysicalColumn(col));
    }
  }
  return collapsedPhysicals;
}
function buildGhostTable(container) {
  const settings = this.hot.getSettings();
  const isDropdownEnabled = !!settings.dropdownMenu;
  const isCollapsibleEnabled = !!settings.collapsibleColumns;
  const maxColumnsCount = this.hot.countCols();
  const sanitizer = settings.sanitizer;
  container.innerHTML = _class_private_method_get$9(this, _buildRenderedTableHTML, buildRenderedTableHTML).call(this, maxColumnsCount, isDropdownEnabled, isCollapsibleEnabled, sanitizer);
}
function buildRenderedTableHTML(maxColumnsCount, isDropdownEnabled, isCollapsibleEnabled, sanitizer) {
  let rowsHTML = "";
  for (let row = 0; row < this.layersCount; row++) {
    let cellsHTML = "";
    for (let col = 0; col < maxColumnsCount; col++) {
      const headerSettings = this.headersStateManager.getHeaderSettings(row, col);
      if (headerSettings && !headerSettings.isPlaceholder && !headerSettings.isHidden && !headerSettings.isRowspanPlaceholder) {
        const rowspanAttr = (headerSettings.rowspan ?? 0) > 1 ? ` rowspan="${headerSettings.rowspan}"` : "";
        cellsHTML += `<th data-column="${col}" colspan="${headerSettings.colspan}"${rowspanAttr}>${_class_private_method_get$9(this, _buildHeaderLabelHTML, buildHeaderLabelHTML).call(this, headerSettings, isDropdownEnabled, isCollapsibleEnabled, sanitizer)}</th>`;
      }
    }
    rowsHTML += `<tr>${cellsHTML}</tr>`;
  }
  return `<table data-ghost-table="rendered"><thead>${rowsHTML}</thead></table>`;
}
function buildHeaderLabelHTML(headerSettings, isDropdownEnabled, isCollapsibleEnabled, sanitizer) {
  const label = typeof sanitizer === "function" ? sanitizer(headerSettings.label, "innerHTML") : headerSettings.label;
  const dropdownHtml = isDropdownEnabled ? '<button class="changeType"></button>' : "";
  const hasCollapsibleControl = isCollapsibleEnabled && (headerSettings.origColspan > 1 || headerSettings.colspan > 1);
  const indicatorHtml = hasCollapsibleControl ? '<div class="collapsibleIndicator expanded">-</div>' : "";
  return `<div class="relative"><span class="colHeader">${label}</span>${dropdownHtml}${indicatorHtml}</div>`;
}
function resolveRowspanNavigationContextRow(currentHeaderRow, targetColumn, topMostHeaderRow, getHeaderSettings) {
  if (currentHeaderRow <= topMostHeaderRow) {
    return currentHeaderRow;
  }
  for (let row = currentHeaderRow + 1; row <= -1; row++) {
    const headerSettings = getHeaderSettings(row, targetColumn);
    if (!headerSettings) {
      continue;
    }
    const { isPlaceholder, isRowspanPlaceholder, isHidden } = headerSettings;
    if (!isPlaceholder && !isRowspanPlaceholder && !isHidden) {
      return row;
    }
  }
  return currentHeaderRow;
}
function _check_private_redeclaration$i(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$i(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$i(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$i(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$i(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$i(receiver, privateMap, "get");
  return _class_apply_descriptor_get$i(receiver, descriptor);
}
function _class_private_field_init$i(obj, privateMap, value) {
  _check_private_redeclaration$i(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$i(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$i(receiver, privateMap, "set");
  _class_apply_descriptor_set$i(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$8(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$8(obj, privateSet) {
  _check_private_redeclaration$i(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$b = "nestedHeaders";
const PLUGIN_PRIORITY$b = 280;
var _stateManager = /* @__PURE__ */ new WeakMap(), _onColumnIndexMapperCacheUpdated = /* @__PURE__ */ new WeakMap(), _focusInitialCoords = /* @__PURE__ */ new WeakMap(), _isColumnsSelectionInProgress = /* @__PURE__ */ new WeakMap(), _recentlyHighlightCoords = /* @__PURE__ */ new WeakMap(), _rowspanHeaderNavigationContextRow = /* @__PURE__ */ new WeakMap(), _expectedNextKeyboardHighlightCoords = /* @__PURE__ */ new WeakMap(), _updateWidthsMap = /* @__PURE__ */ new WeakMap(), _hasRowspanHeaders = /* @__PURE__ */ new WeakMap(), _applyColspan = /* @__PURE__ */ new WeakSet(), _applyRowspan = /* @__PURE__ */ new WeakSet(), _updateFocusHighlightPosition = /* @__PURE__ */ new WeakMap(), _findRenderableHeaderRow = /* @__PURE__ */ new WeakSet(), _getRootHeaderRowspan = /* @__PURE__ */ new WeakSet(), _isNavigableHeaderCell = /* @__PURE__ */ new WeakSet(), _findNearestNavigableHeaderColumn = /* @__PURE__ */ new WeakSet(), _onBeforeViewportScrollHorizontally = /* @__PURE__ */ new WeakMap(), _onBeforeHighlightingColumnHeader = /* @__PURE__ */ new WeakMap(), _onBeforeCopy = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseDown$1 = /* @__PURE__ */ new WeakMap(), _onAfterOnCellMouseDown = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseOver = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseUp = /* @__PURE__ */ new WeakMap(), _onBeforeSelectionHighlightSet$1 = /* @__PURE__ */ new WeakMap(), _onModifyTransformStart = /* @__PURE__ */ new WeakMap(), _onBeforeSelectColumns = /* @__PURE__ */ new WeakMap(), _onAfterGetColumnHeaderRenderers = /* @__PURE__ */ new WeakMap(), _onAfterViewportColumnCalculatorOverride = /* @__PURE__ */ new WeakMap(), _onModifyColWidth$1 = /* @__PURE__ */ new WeakMap(), _onModifyColumnHeaderHeight = /* @__PURE__ */ new WeakMap(), _onModifyColumnHeaderValue = /* @__PURE__ */ new WeakMap(), _onModifyFocusedElement = /* @__PURE__ */ new WeakMap(), _onInit$1 = /* @__PURE__ */ new WeakMap(), _onAfterLoadData = /* @__PURE__ */ new WeakMap(), _onAfterCreateCol = /* @__PURE__ */ new WeakMap(), _onAfterRemoveCol = /* @__PURE__ */ new WeakMap(), _onBeforeViewRender$1 = /* @__PURE__ */ new WeakMap();
class NestedHeaders extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$b;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$b;
  }
  /**
  * Returns whether the plugin is enabled based on the presence of the `nestedHeaders` settings key.
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$b];
  }
  /**
  * Enables the plugin by registering all required hooks and initializing the header state.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const { nestedHeaders } = this.hot.getSettings();
    if (!Array.isArray(nestedHeaders) || !Array.isArray(nestedHeaders[0])) {
      warn$1(toSingleLine`Your Nested Headers plugin configuration is invalid. The settings has to be\x20
                        passed as an array of arrays e.q. [['A1', { label: 'A2', colspan: 2 }]]`);
    }
    this.addHook("init", _class_private_field_get$i(this, _onInit$1));
    this.addHook("afterLoadData", _class_private_field_get$i(this, _onAfterLoadData));
    this.addHook("afterCreateCol", _class_private_field_get$i(this, _onAfterCreateCol));
    this.addHook("afterRemoveCol", _class_private_field_get$i(this, _onAfterRemoveCol));
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$i(this, _onBeforeOnCellMouseDown$1));
    this.addHook("afterOnCellMouseDown", _class_private_field_get$i(this, _onAfterOnCellMouseDown));
    this.addHook("beforeOnCellMouseOver", _class_private_field_get$i(this, _onBeforeOnCellMouseOver));
    this.addHook("beforeOnCellMouseUp", _class_private_field_get$i(this, _onBeforeOnCellMouseUp));
    this.addHook("beforeSelectionHighlightSet", _class_private_field_get$i(this, _onBeforeSelectionHighlightSet$1));
    this.addHook("modifyTransformStart", _class_private_field_get$i(this, _onModifyTransformStart));
    this.addHook("afterSelection", _class_private_field_get$i(this, _updateFocusHighlightPosition));
    this.addHook("afterSelectionFocusSet", _class_private_field_get$i(this, _updateFocusHighlightPosition));
    this.addHook("beforeViewportScrollHorizontally", _class_private_field_get$i(this, _onBeforeViewportScrollHorizontally));
    this.addHook("afterGetColumnHeaderRenderers", _class_private_field_get$i(this, _onAfterGetColumnHeaderRenderers));
    this.addHook("modifyColWidth", _class_private_field_get$i(this, _onModifyColWidth$1));
    this.addHook("modifyColumnHeaderHeight", _class_private_field_get$i(this, _onModifyColumnHeaderHeight));
    this.addHook("modifyColumnHeaderValue", _class_private_field_get$i(this, _onModifyColumnHeaderValue));
    this.addHook("beforeHighlightingColumnHeader", _class_private_field_get$i(this, _onBeforeHighlightingColumnHeader));
    this.addHook("beforeCopy", _class_private_field_get$i(this, _onBeforeCopy));
    this.addHook("beforeSelectColumns", _class_private_field_get$i(this, _onBeforeSelectColumns));
    this.addHook("beforeViewRender", _class_private_field_get$i(this, _onBeforeViewRender$1));
    this.addHook("afterViewportColumnCalculatorOverride", _class_private_field_get$i(this, _onAfterViewportColumnCalculatorOverride));
    this.addHook("modifyFocusedElement", _class_private_field_get$i(this, _onModifyFocusedElement));
    this.hot.columnIndexMapper.addLocalHook("cacheUpdated", _class_private_field_get$i(this, _onColumnIndexMapperCacheUpdated));
    this.hot.columnIndexMapper.addLocalHook("cacheUpdated", _class_private_field_get$i(this, _updateFocusHighlightPosition));
    this.hot.rowIndexMapper.addLocalHook("cacheUpdated", _class_private_field_get$i(this, _updateFocusHighlightPosition));
    super.enablePlugin();
    this.updatePlugin();
  }
  /**
  * Updates the plugin state when Handsontable settings change, rebuilding the header tree and refreshing column widths.
  */
  updatePlugin() {
    if (!this.hot.view) {
      return;
    }
    const { nestedHeaders } = this.hot.getSettings();
    _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, null);
    _class_private_field_set$i(this, _expectedNextKeyboardHighlightCoords, null);
    _class_private_field_get$i(this, _stateManager).setColumnsLimit(this.hot.countCols());
    if (Array.isArray(nestedHeaders)) {
      this.detectedOverlappedHeaders = _class_private_field_get$i(this, _stateManager).setState(nestedHeaders);
    }
    _class_private_field_set$i(this, _hasRowspanHeaders, _class_private_field_get$i(this, _stateManager).mapNodes(({ origRowspan }) => origRowspan > 1 ? true : void 0).length > 0);
    if (_class_private_field_get$i(this, _hasRowspanHeaders)) {
      addClass(this.hot.rootElement, "htHasRowspanHeaders");
    } else {
      removeClass(this.hot.rootElement, "htHasRowspanHeaders");
    }
    if (this.detectedOverlappedHeaders) {
      warn$1(toSingleLine`Your Nested Headers plugin setup contains overlapping headers. This kind of configuration\x20
                        is currently not supported.`);
    }
    if (this.enabled) {
      _class_private_field_get$i(this, _stateManager).syncVisibility(createColumnVisibilityAdapter(this.hot));
    }
    _class_private_field_set$i(this, _updateWidthsMap, true);
    super.updatePlugin();
  }
  /**
  * Disables the plugin by removing all registered hooks, clearing header state, and resetting visual indicators.
  */
  disablePlugin() {
    this.hot.rowIndexMapper.removeLocalHook("cacheUpdated", _class_private_field_get$i(this, _updateFocusHighlightPosition));
    this.hot.columnIndexMapper.removeLocalHook("cacheUpdated", _class_private_field_get$i(this, _updateFocusHighlightPosition));
    this.hot.columnIndexMapper.removeLocalHook("cacheUpdated", _class_private_field_get$i(this, _onColumnIndexMapperCacheUpdated));
    this.clearColspans();
    _class_private_field_get$i(this, _stateManager).clear();
    _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, null);
    _class_private_field_set$i(this, _expectedNextKeyboardHighlightCoords, null);
    removeClass(this.hot.rootElement, "htHasRowspanHeaders");
    this.ghostTable.clear();
    super.disablePlugin();
  }
  /**
  * Returns the internal state manager that tracks the nested header spans and their layout configuration.
  */
  getStateManager() {
    return _class_private_field_get$i(this, _stateManager);
  }
  /**
  * Returns the number of nested header rows currently configured in the plugin.
  */
  getLayersCount() {
    return _class_private_field_get$i(this, _stateManager).getLayersCount();
  }
  /**
  * Returns the header settings node for the specified header level and column index.
  */
  getHeaderSettings(headerLevel, columnIndex) {
    return _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerLevel, columnIndex);
  }
  /**
  * Removes all colspan and rowspan attributes from the rendered header cells in all overlays.
  */
  clearColspans() {
    if (!this.hot.view) {
      return;
    }
    const { _wt: wt } = this.hot.view;
    const headerLevels = wt.getSetting("columnHeaders").length;
    const mainHeaders = wt.wtTable.THEAD;
    const topHeaders = wt.wtOverlays.topOverlay.clone?.wtTable.THEAD;
    const topLeftCornerHeaders = wt.wtOverlays.topInlineStartCornerOverlay?.clone?.wtTable.THEAD ?? null;
    if (!mainHeaders || !topHeaders) {
      return;
    }
    for (let i = 0; i < headerLevels; i++) {
      const masterLevel = mainHeaders.childNodes[i];
      if (!masterLevel) {
        break;
      }
      const topLevel = topHeaders.childNodes[i];
      const topLeftCornerLevel = topLeftCornerHeaders ? topLeftCornerHeaders.childNodes[i] : null;
      for (let j = 0, masterNodes = masterLevel.childNodes.length; j < masterNodes; j++) {
        const masterChild = masterLevel.childNodes[j];
        masterChild.removeAttribute("colspan");
        masterChild.removeAttribute("rowspan");
        masterChild.style.display = "";
        removeClass(masterChild, "hiddenHeader");
        if (topLevel && topLevel.childNodes[j]) {
          const topChild = topLevel.childNodes[j];
          topChild.removeAttribute("colspan");
          topChild.removeAttribute("rowspan");
          topChild.style.display = "";
          removeClass(topChild, "hiddenHeader");
        }
        if (topLeftCornerHeaders && topLeftCornerLevel && topLeftCornerLevel.childNodes[j]) {
          const cornerChild = topLeftCornerLevel.childNodes[j];
          cornerChild.removeAttribute("colspan");
          cornerChild.removeAttribute("rowspan");
          cornerChild.style.display = "";
          removeClass(cornerChild, "hiddenHeader");
        }
      }
    }
  }
  /**
  * Creates and returns a header renderer function for the specified header layer level.
  */
  headerRendererFactory(headerLevel) {
    const fixedColumnsStart = this.hot.view._wt.getSetting("fixedColumnsStart");
    return (renderedColumnIndex, TH) => {
      const { columnIndexMapper } = this.hot;
      let visualColumnIndex = columnIndexMapper.getVisualFromRenderableIndex(renderedColumnIndex);
      if (visualColumnIndex === null) {
        visualColumnIndex = renderedColumnIndex;
      }
      TH.removeAttribute("colspan");
      TH.removeAttribute("rowspan");
      TH.style.display = "";
      removeClass(TH, "hiddenHeader");
      removeClass(TH, "hiddenHeaderText");
      removeClass(TH, "htRowspanHeader");
      removeClass(TH, "htRowspanBottomLevel");
      const rendererHeaderSettings = _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerLevel, visualColumnIndex) ?? {};
      const { colspan, rowspan, isHidden, isPlaceholder, isRowspanPlaceholder, headerClassNames } = rendererHeaderSettings;
      if (isRowspanPlaceholder) {
        addClass(TH, "hiddenHeader");
        TH.style.display = "none";
      } else if (isPlaceholder || isHidden) {
        addClass(TH, "hiddenHeader");
      } else {
        _class_private_method_get$8(this, _applyColspan, applyColspan).call(this, TH, colspan, visualColumnIndex, renderedColumnIndex, fixedColumnsStart);
        _class_private_method_get$8(this, _applyRowspan, applyRowspan).call(this, TH, rowspan, headerLevel);
      }
      this.hot.view.appendColHeader(visualColumnIndex, TH, (colIndex, level) => this.getColumnHeaderValue(colIndex, level), headerLevel);
      const reachesCells = headerLevel + (rowspan ?? 1) === this.getLayersCount();
      if (!reachesCells) {
        removeClass(TH, [
          "beforeHiddenColumn",
          "afterHiddenColumn"
        ]);
      }
      if (!isPlaceholder && !isHidden && !isRowspanPlaceholder) {
        const innerHeaderDiv = TH.querySelector("div.relative");
        if (innerHeaderDiv && headerClassNames && headerClassNames.length > 0) {
          removeClass(innerHeaderDiv, this.hot.getColumnMeta(visualColumnIndex).headerClassName ?? []);
          addClass(innerHeaderDiv, headerClassNames);
        }
      }
    };
  }
  /**
  * Returns the display value for a nested header cell at the given visual column index and header level.
  */
  getColumnHeaderValue(visualColumnIndex, headerLevel) {
    const { isHidden, isPlaceholder, isRowspanPlaceholder } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerLevel, visualColumnIndex) ?? {};
    if (isPlaceholder || isHidden || isRowspanPlaceholder) {
      return "";
    }
    return this.hot.getColHeader(visualColumnIndex, headerLevel);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$i(this, _stateManager).clear();
    removeClass(this.hot.rootElement, "htHasRowspanHeaders");
    super.destroy();
  }
  /**
  * Returns the header tree node data for the given coordinates, or undefined if the coordinates do not point to a header cell.
  */
  _getHeaderTreeNodeDataByCoords(coords) {
    if (coords.row >= 0 || coords.col < 0) {
      return;
    }
    return _class_private_field_get$i(this, _stateManager).getHeaderTreeNodeData(coords.row, coords.col);
  }
  constructor(...args) {
    super(...args), _class_private_method_init$8(this, _applyColspan), _class_private_method_init$8(this, _applyRowspan), _class_private_method_init$8(this, _findRenderableHeaderRow), _class_private_method_init$8(this, _getRootHeaderRowspan), _class_private_method_init$8(this, _isNavigableHeaderCell), _class_private_method_init$8(this, _findNearestNavigableHeaderColumn), _class_private_field_init$i(this, _stateManager, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onColumnIndexMapperCacheUpdated, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _focusInitialCoords, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _isColumnsSelectionInProgress, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _recentlyHighlightCoords, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _rowspanHeaderNavigationContextRow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _expectedNextKeyboardHighlightCoords, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _updateWidthsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _hasRowspanHeaders, {
      writable: true,
      value: void 0
    }), /**
    * Updates the focus highlight position in the selection model to reflect the current nested header layout.
    */
    _class_private_field_init$i(this, _updateFocusHighlightPosition, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeViewportScrollHorizontally, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeHighlightingColumnHeader, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeCopy, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeOnCellMouseDown$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onAfterOnCellMouseDown, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeOnCellMouseOver, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeOnCellMouseUp, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeSelectionHighlightSet$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onModifyTransformStart, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeSelectColumns, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onAfterGetColumnHeaderRenderers, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onAfterViewportColumnCalculatorOverride, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onModifyColWidth$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onModifyColumnHeaderHeight, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onModifyColumnHeaderValue, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onModifyFocusedElement, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onInit$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onAfterLoadData, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onAfterCreateCol, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onAfterRemoveCol, {
      writable: true,
      value: void 0
    }), _class_private_field_init$i(this, _onBeforeViewRender$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$i(this, _stateManager, new StateManager()), _class_private_field_set$i(this, _onColumnIndexMapperCacheUpdated, ({ hiddenIndexesChanged }) => {
      if (!this.enabled) {
        return;
      }
      _class_private_field_get$i(this, _stateManager).syncVisibility(createColumnVisibilityAdapter(this.hot));
      if (hiddenIndexesChanged) {
        this.ghostTable.buildWidthsMap();
      }
    }), _class_private_field_set$i(this, _focusInitialCoords, null), _class_private_field_set$i(this, _isColumnsSelectionInProgress, false), _class_private_field_set$i(this, _recentlyHighlightCoords, null), _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, null), _class_private_field_set$i(this, _expectedNextKeyboardHighlightCoords, null), _class_private_field_set$i(this, _updateWidthsMap, false), /**
    * Custom helper for getting widths of the nested headers.
    */
    // @TODO This should be changed after refactor handsontable/utils/ghostTable.
    this.ghostTable = new GhostTable2({
      hot: this.hot,
      headersStateManager: _class_private_field_get$i(this, _stateManager)
    }), /**
    * The flag which determines that the nested header settings contains overlapping headers
    * configuration.
    */
    this.detectedOverlappedHeaders = false, _class_private_field_set$i(this, _hasRowspanHeaders, false), _class_private_field_set$i(this, _updateFocusHighlightPosition, () => {
      const selection = this.hot?.getSelectedRangeActive();
      if (!selection) {
        return;
      }
      const { highlight } = selection;
      const isNestedHeadersRange = highlight.row !== null && highlight.col !== null && highlight.isHeader() && highlight.col >= 0;
      if (isNestedHeadersRange && highlight.row !== null && highlight.col !== null) {
        const { isRowspanPlaceholder } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(highlight.row, highlight.col) ?? {};
        const normalizedHighlightRow = isRowspanPlaceholder ? _class_private_method_get$8(this, _findRenderableHeaderRow, findRenderableHeaderRow).call(this, highlight.row, highlight.col) : highlight.row;
        const columnIndex = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(normalizedHighlightRow, highlight.col);
        const focusHighlight = this.hot.selection.highlight.getFocus();
        const focusVisualCellRange = focusHighlight.visualCellRange;
        if (focusVisualCellRange === null) {
          return;
        }
        focusVisualCellRange.highlight.row = normalizedHighlightRow;
        focusVisualCellRange.highlight.col = columnIndex;
        focusVisualCellRange.from.row = normalizedHighlightRow;
        focusVisualCellRange.from.col = columnIndex;
        focusVisualCellRange.to.row = normalizedHighlightRow;
        focusVisualCellRange.to.col = columnIndex;
        focusHighlight.commit();
      }
    }), _class_private_field_set$i(this, _onBeforeViewportScrollHorizontally, (visualColumn, snapping) => {
      const selection = this.hot.getSelectedRangeActive();
      if (!selection) {
        return visualColumn;
      }
      const { highlight } = selection;
      const { navigableHeaders } = this.hot.getSettings();
      const isSelectedByColumnHeader = this.hot.selection.isSelectedByColumnHeader();
      const highlightRow = navigableHeaders ? highlight.row : _class_private_field_get$i(this, _recentlyHighlightCoords)?.row;
      const highlightColumn = isSelectedByColumnHeader ? visualColumn : highlight.col;
      const isNestedHeadersRange = highlightRow !== null && highlightRow !== void 0 && highlightColumn !== null && highlightColumn !== void 0 && highlightRow < 0 && highlightColumn >= 0;
      _class_private_field_set$i(this, _recentlyHighlightCoords, null);
      if (!isNestedHeadersRange || highlightRow === null || highlightRow === void 0 || highlightColumn === null || highlightColumn === void 0) {
        return visualColumn;
      }
      const firstVisibleColumn = this.hot.getFirstFullyVisibleColumn();
      const lastVisibleColumn = this.hot.getLastFullyVisibleColumn();
      const viewportWidth = lastVisibleColumn - firstVisibleColumn + 1;
      const mostLeftColumnIndex = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(highlightRow, highlightColumn);
      const mostRightColumnIndex = _class_private_field_get$i(this, _stateManager).findRightMostColumnIndex(highlightRow, highlightColumn);
      const headerWidth = mostRightColumnIndex - mostLeftColumnIndex + 1;
      if (mostLeftColumnIndex < firstVisibleColumn && mostRightColumnIndex > lastVisibleColumn) {
        return mostLeftColumnIndex;
      }
      if (isSelectedByColumnHeader) {
        let scrollColumnIndex = null;
        if (mostLeftColumnIndex >= firstVisibleColumn && mostRightColumnIndex > lastVisibleColumn) {
          if (headerWidth > viewportWidth) {
            snapping.value = "start";
            scrollColumnIndex = mostLeftColumnIndex;
          } else {
            snapping.value = "end";
            scrollColumnIndex = mostRightColumnIndex;
          }
        } else if (mostLeftColumnIndex < firstVisibleColumn && mostRightColumnIndex <= lastVisibleColumn) {
          if (headerWidth > viewportWidth) {
            snapping.value = "end";
            scrollColumnIndex = mostRightColumnIndex;
          } else {
            snapping.value = "start";
            scrollColumnIndex = mostLeftColumnIndex;
          }
        }
        return scrollColumnIndex;
      }
      return mostLeftColumnIndex <= firstVisibleColumn ? mostLeftColumnIndex : mostRightColumnIndex;
    }), _class_private_field_set$i(this, _onBeforeHighlightingColumnHeader, (visualColumn, headerLevel, highlightMeta) => {
      const headerNodeData = _class_private_field_get$i(this, _stateManager).getHeaderTreeNodeData(headerLevel, visualColumn);
      if (!headerNodeData) {
        return visualColumn;
      }
      const { columnCursor, selectionType, selectionWidth } = highlightMeta;
      const { isRoot, colspan = 1 } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerLevel, visualColumn) ?? {};
      if (selectionType === HEADER_TYPE) {
        if (!isRoot) {
          return headerNodeData.columnIndex;
        }
      } else if (selectionType === ACTIVE_HEADER_TYPE) {
        if (colspan > selectionWidth - columnCursor || !isRoot) {
          return null;
        }
      }
      return visualColumn;
    }), _class_private_field_set$i(this, _onBeforeCopy, (data, copyableRanges, { columnHeadersCount }) => {
      if (columnHeadersCount === 0) {
        return;
      }
      for (let rangeIndex = 0; rangeIndex < copyableRanges.length; rangeIndex++) {
        const { startRow, startCol, endRow, endCol } = copyableRanges[rangeIndex];
        const rowsCount = endRow - startRow + 1;
        const columnsCount = startCol - endCol + 1;
        if (startRow >= 0 || columnsCount === 1) {
          break;
        }
        for (let column = startCol; column <= endCol; column++) {
          for (let row = startRow; row <= endRow; row++) {
            const zeroBasedColumnHeaderLevel = rowsCount + row;
            const zeroBasedColumnIndex = column - startCol;
            if (zeroBasedColumnIndex === 0) {
              continue;
            }
            const isRoot = _class_private_field_get$i(this, _stateManager).getHeaderTreeNodeData(row, column)?.isRoot;
            if (isRoot === false) {
              data[zeroBasedColumnHeaderLevel][zeroBasedColumnIndex] = "";
            }
          }
        }
      }
    }), _class_private_field_set$i(this, _onBeforeOnCellMouseDown$1, (event, coords, TD, controller) => {
      _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, null);
      _class_private_field_set$i(this, _expectedNextKeyboardHighlightCoords, null);
      const headerNodeData = this._getHeaderTreeNodeDataByCoords(coords);
      if (headerNodeData) {
        controller.column = true;
      }
    }), _class_private_field_set$i(this, _onAfterOnCellMouseDown, (event, coords) => {
      if (coords.row === null || coords.col === null) {
        return;
      }
      const narrowedCoords = {
        row: coords.row,
        col: coords.col
      };
      const headerNodeData = this._getHeaderTreeNodeDataByCoords(narrowedCoords);
      if (!headerNodeData) {
        return;
      }
      _class_private_field_set$i(this, _focusInitialCoords, {
        row: coords.row,
        col: coords.col,
        clone: () => coords.clone()
      });
      _class_private_field_set$i(this, _isColumnsSelectionInProgress, true);
      const { selection } = this.hot;
      const currentSelection = selection.isSelected() ? selection.getSelectedRange().current() : null;
      let columnsToSelect = null;
      const { columnIndex, origColspan } = headerNodeData;
      const allowRightClickSelection = !selection.inInSelection(coords);
      if (event.shiftKey && currentSelection) {
        if ((coords.col ?? 0) < (currentSelection.from.col ?? 0)) {
          columnsToSelect = [
            currentSelection.getTopEndCorner().col ?? 0,
            columnIndex,
            coords.row ?? 0
          ];
        } else if ((coords.col ?? 0) > (currentSelection.from.col ?? 0)) {
          columnsToSelect = [
            currentSelection.getTopStartCorner().col ?? 0,
            columnIndex + origColspan - 1,
            coords.row ?? 0
          ];
        } else {
          columnsToSelect = [
            columnIndex,
            columnIndex + origColspan - 1,
            coords.row ?? 0
          ];
        }
      } else if (isLeftClick(event) || isRightClick(event) && allowRightClickSelection || isTouchEvent(event)) {
        columnsToSelect = [
          columnIndex,
          columnIndex + origColspan - 1,
          coords.row
        ];
      }
      if (columnsToSelect !== null) {
        selection.selectColumns(...columnsToSelect);
      }
    }), _class_private_field_set$i(this, _onBeforeOnCellMouseOver, (event, coords, TD, controller) => {
      if (!this.hot.view.isMouseDown() || controller.column) {
        return;
      }
      const headerNodeData = this._getHeaderTreeNodeDataByCoords(coords);
      if (!headerNodeData) {
        return;
      }
      const { columnIndex, origColspan } = headerNodeData;
      const selectedRange = this.hot.getSelectedRangeActive();
      if (!selectedRange) {
        return;
      }
      const topStartCoords = selectedRange.getTopStartCorner();
      const bottomEndCoords = selectedRange.getBottomEndCorner();
      const { from } = selectedRange;
      controller.column = true;
      controller.cell = true;
      const headerLevel = clamp(coords.row ?? 0, -Infinity, -1);
      let columnsToSelect;
      if ((coords.col ?? 0) < (from.col ?? 0)) {
        columnsToSelect = [
          bottomEndCoords.col ?? 0,
          columnIndex,
          headerLevel
        ];
      } else if ((coords.col ?? 0) > (from.col ?? 0)) {
        columnsToSelect = [
          topStartCoords.col ?? 0,
          columnIndex + origColspan - 1,
          headerLevel
        ];
      } else {
        columnsToSelect = [
          columnIndex,
          columnIndex + origColspan - 1,
          headerLevel
        ];
      }
      this.hot.selection.selectColumns(...columnsToSelect);
    }), _class_private_field_set$i(this, _onBeforeOnCellMouseUp, () => {
      _class_private_field_set$i(this, _isColumnsSelectionInProgress, false);
    }), _class_private_field_set$i(this, _onBeforeSelectionHighlightSet$1, () => {
      const { navigableHeaders } = this.hot.getSettings();
      if (!this.hot.view.isMouseDown() || !_class_private_field_get$i(this, _isColumnsSelectionInProgress) || !navigableHeaders) {
        return;
      }
      const selectedRange = this.hot.getSelectedRangeLast();
      if (!selectedRange) {
        return;
      }
      const columnStart = selectedRange.getTopStartCorner().col;
      const columnEnd = selectedRange.getBottomEndCorner().col;
      const headerNodeData = _class_private_field_get$i(this, _stateManager).getHeaderTreeNodeData(_class_private_field_get$i(this, _focusInitialCoords).row, _class_private_field_get$i(this, _focusInitialCoords).col);
      if (!headerNodeData) {
        return;
      }
      const { columnIndex, origColspan } = headerNodeData;
      selectedRange.setHighlight(_class_private_field_get$i(this, _focusInitialCoords));
      if (columnStart !== null && columnEnd !== null && (origColspan > selectedRange.getWidth() || columnIndex < columnStart || columnIndex + origColspan - 1 > columnEnd)) {
        const headerLevel = _class_private_field_get$i(this, _stateManager).findTopMostEntireHeaderLevel(clamp(columnStart, columnIndex, columnIndex + origColspan - 1), clamp(columnEnd, columnIndex, columnIndex + origColspan - 1));
        selectedRange.highlight.row = headerLevel;
        selectedRange.highlight.col = selectedRange.from.col;
      }
    }), _class_private_field_set$i(this, _onModifyTransformStart, (delta) => {
      const activeRange = this.hot.getSelectedRangeActive();
      if (!activeRange) {
        return;
      }
      const { highlight } = activeRange;
      const { row: expectedRow, col: expectedColumn } = _class_private_field_get$i(this, _expectedNextKeyboardHighlightCoords) ?? {};
      if (Number.isInteger(expectedRow) && Number.isInteger(expectedColumn)) {
        if (highlight.row !== expectedRow || highlight.col !== expectedColumn) {
          _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, null);
        }
      }
      const highlightRow = highlight.row ?? 0;
      const highlightCol = highlight.col ?? 0;
      const initialDeltaRow = delta.row;
      const initialDeltaColumn = delta.col;
      let targetColumn = highlightCol + delta.col;
      let targetRow = highlightRow + delta.row;
      if (delta.row !== 0 && targetColumn >= 0) {
        const rowDirection = Math.sign(delta.row);
        const lowestHeaderRow = -1;
        const highestHeaderRow = -this.getLayersCount();
        let adjustedNextRow = targetRow;
        while (adjustedNextRow <= lowestHeaderRow && adjustedNextRow >= highestHeaderRow) {
          const { isRowspanPlaceholder } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(adjustedNextRow, targetColumn) ?? {};
          if (!isRowspanPlaceholder) {
            break;
          }
          adjustedNextRow += rowDirection;
        }
        delta.row = adjustedNextRow - highlightRow;
        targetRow = adjustedNextRow;
      }
      if (initialDeltaRow === 0 && initialDeltaColumn !== 0 && highlightRow < 0) {
        if (_class_private_field_get$i(this, _rowspanHeaderNavigationContextRow) !== null) {
          const contextTargetColumn = _class_private_method_get$8(this, _findNearestNavigableHeaderColumn, findNearestNavigableHeaderColumn).call(this, _class_private_field_get$i(this, _rowspanHeaderNavigationContextRow), targetColumn, Math.sign(initialDeltaColumn));
          if (contextTargetColumn !== null) {
            targetColumn = contextTargetColumn;
            targetRow = _class_private_field_get$i(this, _rowspanHeaderNavigationContextRow);
          }
        }
        if (targetColumn < 0 && initialDeltaColumn < 0 && _class_private_field_get$i(this, _rowspanHeaderNavigationContextRow) !== null) {
          targetRow = _class_private_field_get$i(this, _rowspanHeaderNavigationContextRow);
        }
        const currentHeaderStartColumn = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(highlightRow, highlightCol);
        const currentHeaderEndColumn = _class_private_field_get$i(this, _stateManager).findRightMostColumnIndex(highlightRow, highlightCol);
        const { isRowspanPlaceholder: isTargetRowspanPlaceholder } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(targetRow, targetColumn) ?? {};
        const isTargetInsideCurrentHeader = targetRow === highlightRow && targetColumn >= currentHeaderStartColumn && targetColumn <= currentHeaderEndColumn;
        const shouldKeepLogicalRowForRowspan = targetRow === highlightRow && isTargetRowspanPlaceholder && initialDeltaColumn > 0 && highlightRow < -1;
        if (!isTargetInsideCurrentHeader && !shouldKeepLogicalRowForRowspan) {
          targetRow = _class_private_method_get$8(this, _findRenderableHeaderRow, findRenderableHeaderRow).call(this, targetRow, targetColumn);
        }
        delta.row = targetRow - highlightRow;
        const targetHeaderRowspan = _class_private_method_get$8(this, _getRootHeaderRowspan, getRootHeaderRowspan).call(this, targetRow, targetColumn);
        if (targetHeaderRowspan > 1 && !Number.isInteger(_class_private_field_get$i(this, _rowspanHeaderNavigationContextRow))) {
          _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, resolveRowspanNavigationContextRow(highlightRow, targetColumn, -this.getLayersCount(), (headerRow, visualColumn) => {
            const settings = _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerRow, visualColumn);
            return settings ? {
              ...settings,
              isRowspanPlaceholder: settings.isRowspanPlaceholder ?? false
            } : null;
          }));
        }
      }
      const nextCoords = this.hot._createCellCoords(targetRow, targetColumn);
      const isNestedHeadersRange = nextCoords.isHeader() && (nextCoords.col ?? -1) >= 0;
      if (!isNestedHeadersRange || initialDeltaRow !== 0) {
        _class_private_field_set$i(this, _rowspanHeaderNavigationContextRow, null);
      }
      if (isNestedHeadersRange && highlight.row !== null && highlight.col !== null && nextCoords.row !== null && nextCoords.col !== null) {
        const { isRowspanPlaceholder: isCurrentHeaderRowspanPlaceholderForBounds } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(highlight.row, highlight.col) ?? {};
        const { isRowspanPlaceholder: isNextHeaderRowspanPlaceholderForBounds } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(nextCoords.row, nextCoords.col) ?? {};
        let visualColumnIndexStart = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(nextCoords.row, nextCoords.col);
        let visualColumnIndexEnd = _class_private_field_get$i(this, _stateManager).findRightMostColumnIndex(nextCoords.row, nextCoords.col);
        if (isNextHeaderRowspanPlaceholderForBounds) {
          const renderableNextHeaderRow = _class_private_method_get$8(this, _findRenderableHeaderRow, findRenderableHeaderRow).call(this, nextCoords.row, nextCoords.col);
          visualColumnIndexStart = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(renderableNextHeaderRow, nextCoords.col);
          visualColumnIndexEnd = _class_private_field_get$i(this, _stateManager).findRightMostColumnIndex(renderableNextHeaderRow, nextCoords.col);
        }
        if (isCurrentHeaderRowspanPlaceholderForBounds) {
          const renderableCurrentHeaderRow = _class_private_method_get$8(this, _findRenderableHeaderRow, findRenderableHeaderRow).call(this, highlight.row, highlight.col);
          visualColumnIndexStart = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(renderableCurrentHeaderRow, highlight.col);
          visualColumnIndexEnd = _class_private_field_get$i(this, _stateManager).findRightMostColumnIndex(renderableCurrentHeaderRow, highlight.col);
          if (initialDeltaColumn < 0) {
            visualColumnIndexStart = Math.max(visualColumnIndexStart, Math.min(highlight.col, nextCoords.col));
          } else if (initialDeltaColumn > 0) {
            visualColumnIndexEnd = Math.min(visualColumnIndexEnd, Math.max(highlight.col, nextCoords.col));
          }
        }
        if (delta.col < 0) {
          const nextColumn = highlight.col >= visualColumnIndexStart && highlight.col <= visualColumnIndexEnd ? visualColumnIndexStart - 1 : visualColumnIndexEnd;
          const notHiddenColumnIndex = this.hot.columnIndexMapper.getNearestNotHiddenIndex(nextColumn, -1);
          if (notHiddenColumnIndex === null) {
            delta.col = -this.hot.view.countRenderableColumnsInRange(0, highlight.col);
          } else {
            delta.col = -Math.max(this.hot.view.countRenderableColumnsInRange(notHiddenColumnIndex, highlight.col) - 1, 1);
          }
        } else if (delta.col > 0) {
          const nextColumn = highlight.col >= visualColumnIndexStart && highlight.col <= visualColumnIndexEnd ? visualColumnIndexEnd + 1 : visualColumnIndexStart;
          const notHiddenColumnIndex = this.hot.columnIndexMapper.getNearestNotHiddenIndex(nextColumn, 1);
          if (notHiddenColumnIndex === null) {
            delta.col = this.hot.view.countRenderableColumnsInRange(highlight.col, this.hot.countCols());
            if (isCurrentHeaderRowspanPlaceholderForBounds) {
              delta.col += 1;
              if (highlight.row < -1) {
                delta.row = 1;
                delta.col = -(highlight.col + 1);
              }
            }
          } else {
            delta.col = Math.max(this.hot.view.countRenderableColumnsInRange(highlight.col, notHiddenColumnIndex) - 1, 1);
          }
        }
      }
      _class_private_field_set$i(this, _expectedNextKeyboardHighlightCoords, {
        row: highlightRow + delta.row,
        col: highlightCol + delta.col
      });
    }), _class_private_field_set$i(this, _onBeforeSelectColumns, (from, to, highlight) => {
      const headerLevel = from.row;
      const startNodeData = this._getHeaderTreeNodeDataByCoords({
        row: headerLevel,
        col: from.col
      });
      const endNodeData = this._getHeaderTreeNodeDataByCoords({
        row: headerLevel,
        col: to.col
      });
      _class_private_field_set$i(this, _recentlyHighlightCoords, highlight.clone());
      if (to.col < from.col) {
        if (startNodeData) {
          from.col = startNodeData.columnIndex + startNodeData.origColspan - 1;
        }
        if (endNodeData) {
          to.col = endNodeData.columnIndex;
        }
      } else if (to.col >= from.col) {
        if (startNodeData) {
          from.col = startNodeData.columnIndex;
        }
        if (endNodeData) {
          to.col = endNodeData.columnIndex + endNodeData.origColspan - 1;
        }
      }
    }), _class_private_field_set$i(this, _onAfterGetColumnHeaderRenderers, (renderersArray) => {
      if (_class_private_field_get$i(this, _stateManager).getLayersCount() > 0) {
        renderersArray.length = 0;
        for (let headerLayer = 0; headerLayer < _class_private_field_get$i(this, _stateManager).getLayersCount(); headerLayer++) {
          renderersArray.push(this.headerRendererFactory(headerLayer));
        }
      }
    }), _class_private_field_set$i(this, _onAfterViewportColumnCalculatorOverride, (calc) => {
      const headerLayersCount = _class_private_field_get$i(this, _stateManager).getLayersCount();
      let newStartColumn = calc.startColumn;
      let nonRenderable = !!headerLayersCount;
      for (let headerLayer = 0; headerLayer < headerLayersCount; headerLayer++) {
        const startColumn = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(headerLayer, calc.startColumn);
        const renderedStartColumn = this.hot.columnIndexMapper.getRenderableFromVisualIndex(startColumn);
        if (startColumn >= 0) {
          nonRenderable = false;
        }
        if (isNumeric(renderedStartColumn) && renderedStartColumn !== null && renderedStartColumn < calc.startColumn) {
          newStartColumn = renderedStartColumn;
          break;
        }
      }
      calc.startColumn = nonRenderable ? _class_private_field_get$i(this, _stateManager).getHeaderTreeNodeData(0, newStartColumn)?.columnIndex ?? newStartColumn : newStartColumn;
    }), _class_private_field_set$i(this, _onModifyColWidth$1, (width, column) => {
      if (this.hot.getSettings().autoColumnSize === false) {
        return width;
      }
      const cachedWidth = this.ghostTable.getWidth(column) ?? 0;
      return width > cachedWidth ? width : cachedWidth;
    }), _class_private_field_set$i(this, _onModifyColumnHeaderHeight, () => {
      if (!_class_private_field_get$i(this, _hasRowspanHeaders)) {
        return;
      }
      const computedStyle = this.hot.rootWindow.getComputedStyle(this.hot.rootElement);
      const cellVerticalPadding = Number.parseFloat(computedStyle.getPropertyValue("--ht-cell-vertical-padding"));
      const lineHeight = Number.parseFloat(computedStyle.getPropertyValue("--ht-line-height"));
      const baseHeaderHeight = Math.round(cellVerticalPadding * 2 + lineHeight + 1);
      if (!Number.isFinite(baseHeaderHeight)) {
        return;
      }
      return new Array(this.getLayersCount()).fill(baseHeaderHeight);
    }), _class_private_field_set$i(this, _onModifyColumnHeaderValue, (value, visualColumnIndex, headerLevel) => {
      const { label } = _class_private_field_get$i(this, _stateManager).getHeaderTreeNodeData(headerLevel, visualColumnIndex) ?? {
        label: ""
      };
      return label;
    }), _class_private_field_set$i(this, _onModifyFocusedElement, (row, column) => {
      if (row < 0) {
        return this.hot.getCell(row, _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(row, column), true) ?? void 0;
      }
    }), _class_private_field_set$i(this, _onInit$1, () => {
      this.updatePlugin();
    }), _class_private_field_set$i(this, _onAfterLoadData, (sourceData, initialLoad) => {
      if (!initialLoad) {
        this.updatePlugin();
      }
    }), _class_private_field_set$i(this, _onAfterCreateCol, (visualColumnIndex, amount) => {
      _class_private_field_get$i(this, _stateManager).insertColumns(visualColumnIndex, amount);
      _class_private_field_set$i(this, _updateWidthsMap, true);
    }), _class_private_field_set$i(this, _onAfterRemoveCol, (visualColumnIndex, amount) => {
      _class_private_field_get$i(this, _stateManager).removeColumns(visualColumnIndex, amount);
      _class_private_field_set$i(this, _updateWidthsMap, true);
    }), _class_private_field_set$i(this, _onBeforeViewRender$1, () => {
      if (_class_private_field_get$i(this, _updateWidthsMap)) {
        this.ghostTable.setLayersCount(this.getLayersCount()).buildWidthsMap();
        _class_private_field_set$i(this, _updateWidthsMap, false);
      }
    });
  }
}
function applyColspan(TH, colspan, visualColumnIndex, renderedColumnIndex, fixedColumnsStart) {
  if (colspan === void 0 || colspan <= 1) {
    return;
  }
  const { wtOverlays } = this.hot.view._wt;
  const isTopInlineStartOverlay = wtOverlays.topInlineStartCornerOverlay?.clone?.wtTable.THEAD?.contains(TH);
  const isInlineStartOverlay = wtOverlays.inlineStartOverlay?.clone?.wtTable.THEAD?.contains(TH);
  const isTopOverlay = wtOverlays.topOverlay?.clone?.wtTable.THEAD?.contains(TH);
  if (isTopOverlay && visualColumnIndex < fixedColumnsStart) {
    addClass(TH, "hiddenHeaderText");
  }
  const correctedColspan = isTopInlineStartOverlay || isInlineStartOverlay ? Math.min(colspan, fixedColumnsStart - renderedColumnIndex) : colspan;
  if (correctedColspan > 1) {
    TH.setAttribute("colspan", String(correctedColspan));
  }
}
function applyRowspan(TH, rowspan, headerLevel) {
  if (rowspan === void 0 || rowspan <= 1) {
    return;
  }
  const isBottomMostRowspanHeader = headerLevel + rowspan === this.getLayersCount();
  addClass(TH, "htRowspanHeader");
  if (isBottomMostRowspanHeader) {
    addClass(TH, "htRowspanBottomLevel");
  }
  TH.setAttribute("rowspan", String(rowspan));
}
function findRenderableHeaderRow(headerRow, visualColumnIndex) {
  const highestHeaderRow = -this.getLayersCount();
  for (let row = headerRow; row >= highestHeaderRow; row--) {
    const { isRowspanPlaceholder } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(row, visualColumnIndex) ?? {};
    if (!isRowspanPlaceholder) {
      return row;
    }
  }
  return headerRow;
}
function getRootHeaderRowspan(headerRow, visualColumnIndex) {
  const rootColumnIndex = _class_private_field_get$i(this, _stateManager).findLeftMostColumnIndex(headerRow, visualColumnIndex);
  const { rowspan = 1 } = _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerRow, rootColumnIndex) ?? {};
  return rowspan;
}
function isNavigableHeaderCell(headerRow, visualColumnIndex) {
  const headerSettings = _class_private_field_get$i(this, _stateManager).getHeaderSettings(headerRow, visualColumnIndex);
  if (!headerSettings) {
    return false;
  }
  const { isPlaceholder, isRowspanPlaceholder, isHidden } = headerSettings;
  if (isRowspanPlaceholder) {
    return headerRow < -1;
  }
  return !isPlaceholder && !isRowspanPlaceholder && !isHidden;
}
function findNearestNavigableHeaderColumn(headerRow, visualColumnIndex, direction) {
  if (![
    -1,
    1
  ].includes(direction)) {
    return null;
  }
  for (let column = visualColumnIndex; column >= 0 && column < this.hot.countCols(); column += direction) {
    if (_class_private_method_get$8(this, _isNavigableHeaderCell, isNavigableHeaderCell).call(this, headerRow, column)) {
      return column;
    }
  }
  return null;
}
class DataManager {
  /**
  * Set the data for the manager.
  *
  * @param {Handsontable.CellValue[][]|Handsontable.RowObject[]} data Data for the manager.
  */
  setData(data) {
    this.data = data;
  }
  /**
  * Get the data cached in the manager.
  *
  * @returns {Handsontable.CellValue[][]|Handsontable.RowObject[]}
  */
  getData() {
    return this.data;
  }
  /**
  * Load the "raw" source data, without NestedRows' modifications.
  *
  * @returns {Handsontable.CellValue[][]|Handsontable.RowObject[]}
  */
  getRawSourceData() {
    let rawSourceData = null;
    this.plugin.disableCoreAPIModifiers();
    rawSourceData = this.hot.getSourceData();
    this.plugin.enableCoreAPIModifiers();
    return rawSourceData;
  }
  /**
  * Update the Data Manager with new data and refresh cache.
  *
  * @param {Handsontable.CellValue[][]|Handsontable.RowObject[]} data Data for the manager.
  */
  updateWithData(data) {
    this.setData(data);
    this.rewriteCache();
  }
  /**
  * Rewrite the nested structure cache.
  *
  * @private
  */
  rewriteCache() {
    this.cache = {
      levels: [],
      levelCount: 0,
      rows: [],
      nodeInfo: /* @__PURE__ */ new WeakMap()
    };
    rangeEach(0, this.data.length - 1, (i) => {
      this.cacheNode(this.data[i], 0, null);
    });
  }
  /**
  * Cache a data node.
  *
  * @private
  * @param {object} node Node to cache.
  * @param {number} level Level of the node.
  * @param {object} parent Parent of the node.
  */
  cacheNode(node, level, parent) {
    if (!node || typeof node !== "object") {
      return;
    }
    if (!this.cache.levels[level]) {
      this.cache.levels[level] = [];
      this.cache.levelCount += 1;
    }
    this.cache.levels[level].push(node);
    this.cache.rows.push(node);
    this.cache.nodeInfo.set(node, {
      parent,
      row: this.cache.rows.length - 1,
      level
    });
    if (this.hasChildren(node) && node.__children) {
      arrayEach(node.__children, (elem) => {
        this.cacheNode(elem, level + 1, node);
      });
    }
  }
  /**
  * Get the date for the provided visual row number.
  *
  * @param {number} row Row index.
  * @returns {object}
  */
  getDataObject(row) {
    if (row === null || row === void 0) {
      return null;
    }
    return this.cache.rows[row];
  }
  /**
  * Read the row tree in search for a specific row index or row object.
  *
  * @private
  * @param {object} parent The initial parent object.
  * @param {number} readCount Number of read nodes.
  * @param {number} neededIndex The row index we search for.
  * @param {object} neededObject The row object we search for.
  * @returns {number|object}
  */
  readTreeNodes(parent, readCount, neededIndex, neededObject) {
    let rootLevel = false;
    let readNodesCount = readCount;
    if (typeof readNodesCount !== "number") {
      return readNodesCount;
    }
    let parentObj = parent;
    if (!parentObj) {
      parentObj = {
        __children: this.data
      };
      rootLevel = true;
      readNodesCount -= 1;
    }
    if (neededIndex !== null && neededIndex !== void 0 && readNodesCount === neededIndex) {
      return {
        result: parentObj,
        end: true
      };
    }
    if (neededObject !== null && neededObject !== void 0 && parentObj === neededObject) {
      return {
        result: readNodesCount,
        end: true
      };
    }
    readNodesCount += 1;
    if (parentObj.__children) {
      arrayEach(parentObj.__children, (val) => {
        this.parentReference.set(val, rootLevel ? null : parentObj);
        readNodesCount = this.readTreeNodes(val, readNodesCount, neededIndex, neededObject);
        if (typeof readNodesCount !== "number") {
          return false;
        }
      });
    }
    return readNodesCount;
  }
  /**
  * Mock a parent node.
  *
  * @private
  * @returns {*}
  */
  mockParent() {
    const fakeParent = this.mockNode();
    fakeParent.__children = this.data;
    return fakeParent;
  }
  /**
  * Mock a data node.
  *
  * @private
  * @returns {{}}
  */
  mockNode() {
    const fakeNode = {};
    objectEach(this.data[0], (val, key) => {
      fakeNode[key] = null;
    });
    return fakeNode;
  }
  /**
  * Get the row index for the provided row object.
  *
  * @param {object} rowObj The row object.
  * @returns {number} Row index.
  */
  getRowIndex(rowObj) {
    if (rowObj === null || rowObj === void 0 || typeof rowObj !== "object") {
      return null;
    }
    return this.cache.nodeInfo.get(rowObj).row;
  }
  /**
  * Get the index of the provided row index/row object within its parent.
  *
  * @param {number|object} row Row index / row object.
  * @returns {number}
  */
  getRowIndexWithinParent(row) {
    let rowObj = null;
    if (typeof row !== "number") {
      rowObj = row;
    } else {
      rowObj = this.getDataObject(row);
    }
    const parent = this.getRowParent(row);
    if (parent === null || parent === void 0) {
      return this.data.indexOf(rowObj);
    }
    return parent.__children.indexOf(rowObj);
  }
  /**
  * Count all rows (including all parents and children).
  *
  * @returns {number}
  */
  countAllRows() {
    const rootNodeMock = {
      __children: this.data
    };
    return this.countChildren(rootNodeMock);
  }
  /**
  * Count children of the provided parent.
  *
  * @param {object|number} parent Parent node.
  * @returns {number} Children count.
  */
  countChildren(parent) {
    let rowCount = 0;
    const parentNode = typeof parent === "number" ? this.getDataObject(parent) : parent;
    if (!parentNode || !parentNode.__children) {
      return 0;
    }
    arrayEach(parentNode.__children, (elem) => {
      rowCount += 1;
      if (elem.__children) {
        rowCount += this.countChildren(elem);
      }
    });
    return rowCount;
  }
  /**
  * Get the parent of the row at the provided index.
  *
  * @param {number|object} row Physical row index.
  * @returns {object}
  */
  getRowParent(row) {
    let rowObject;
    if (typeof row !== "number") {
      rowObject = row;
    } else {
      rowObject = this.getDataObject(row);
    }
    return this.getRowObjectParent(rowObject);
  }
  /**
  * Get the parent of the provided row object.
  *
  * @private
  * @param {object} rowObject The row object (tree node).
  * @returns {object|null}
  */
  getRowObjectParent(rowObject) {
    if (!rowObject || typeof rowObject !== "object") {
      return null;
    }
    return this.cache.nodeInfo.get(rowObject).parent;
  }
  /**
  * Get the nesting level for the row with the provided row index.
  *
  * @param {number} row Row index.
  * @returns {number|null} Row level or null, when row doesn't exist.
  */
  getRowLevel(row) {
    let rowObject = null;
    if (typeof row !== "number") {
      rowObject = row;
    } else {
      rowObject = this.getDataObject(row);
    }
    return rowObject ? this.getRowObjectLevel(rowObject) : null;
  }
  /**
  * Get the nesting level for the row with the provided row index.
  *
  * @private
  * @param {object} rowObject Row object.
  * @returns {number} Row level.
  */
  getRowObjectLevel(rowObject) {
    if (rowObject === null || rowObject === void 0 || typeof rowObject !== "object") {
      return null;
    }
    return this.cache.nodeInfo.get(rowObject).level;
  }
  /**
  * Check if the provided row/row element has children.
  *
  * @param {number|object} row Row number or row element.
  * @returns {boolean}
  */
  hasChildren(row) {
    const rowObj = typeof row === "number" ? this.getDataObject(row) : row;
    return !!(rowObj && rowObj.__children && rowObj.__children.length);
  }
  /**
  * Returns `true` if the row at the provided index has a parent.
  *
  * @param {number} index Row index.
  * @returns {boolean} `true` if the row at the provided index has a parent, `false` otherwise.
  */
  isChild(index2) {
    return this.getRowParent(index2) !== null;
  }
  /**
  * Get child at a provided index from the parent element.
  *
  * @param {object} parent The parent row object.
  * @param {number} index Index of the child element to be retrieved.
  * @returns {object|null} The child element or `null` if the child doesn't exist.
  */
  getChild(parent, index2) {
    return parent.__children?.[index2] || null;
  }
  /**
  * Return `true` of the row at the provided index is located at the topmost level.
  *
  * @param {number} index Row index.
  * @returns {boolean} `true` of the row at the provided index is located at the topmost level, `false` otherwise.
  */
  isRowHighestLevel(index2) {
    return !this.isChild(index2);
  }
  /**
  * Return `true` if the provided row index / row object represents a parent in the nested structure.
  *
  * @param {number|object} row Row index / row object.
  * @returns {boolean} `true` if the row is a parent, `false` otherwise.
  */
  isParent(row) {
    const rowObj = typeof row === "number" ? this.getDataObject(row) : row;
    return !!(rowObj && rowObj.__children && rowObj.__children.length !== 0);
  }
  /**
  * Add a child to the provided parent. It's optional to add a row object as the "element".
  *
  * @param {object} parent The parent row object.
  * @param {object} [element] The element to add as a child.
  */
  addChild(parent, element) {
    let childElement = element;
    this.hot.runHooks("beforeAddChild", parent, childElement);
    let parentIndex = null;
    if (parent) {
      parentIndex = this.getRowIndex(parent);
    }
    this.hot.runHooks("beforeCreateRow", parentIndex + this.countChildren(parent) + 1, 1);
    let functionalParent = parent;
    if (!parent) {
      functionalParent = this.mockParent();
    }
    if (!functionalParent.__children) {
      functionalParent.__children = [];
    }
    if (!childElement) {
      childElement = this.mockNode();
    }
    functionalParent.__children.push(childElement);
    this.rewriteCache();
    const newRowIndex = this.getRowIndex(childElement) ?? 0;
    this.hot.rowIndexMapper.insertIndexes(newRowIndex, 1);
    this.hot.runHooks("afterCreateRow", newRowIndex, 1);
    this.hot.runHooks("afterAddChild", parent, childElement);
  }
  /**
  * Add a child node to the provided parent at a specified index.
  *
  * @param {object} parent Parent node.
  * @param {number} index Index to insert the child element at.
  * @param {object} [element] Element (node) to insert.
  */
  addChildAtIndex(parent, index2, element) {
    let childElement = element;
    let flattenedIndex;
    if (!childElement) {
      childElement = this.mockNode();
    }
    this.hot.runHooks("beforeAddChild", parent, childElement, index2);
    if (parent) {
      const parentIndex = this.getRowIndex(parent) ?? 0;
      const finalChildIndex = parentIndex + index2 + 1;
      this.hot.runHooks("beforeCreateRow", finalChildIndex, 1);
      parent.__children.splice(index2, 0, childElement);
      this.rewriteCache();
      this.plugin.disableCoreAPIModifiers();
      this.hot.setSourceDataAtCell(parentIndex, "__children", parent.__children, "NestedRows.addChildAtIndex");
      this.hot.rowIndexMapper.insertIndexes(finalChildIndex, 1);
      this.plugin.enableCoreAPIModifiers();
      this.hot.runHooks("afterCreateRow", finalChildIndex, 1);
      flattenedIndex = finalChildIndex;
    } else {
      this.plugin.disableCoreAPIModifiers();
      this.hot.alter("insert_row_above", index2, 1, "NestedRows.addChildAtIndex");
      this.plugin.enableCoreAPIModifiers();
      flattenedIndex = this.getRowIndex(this.data[index2]) ?? 0;
    }
    childElement = this.getDataObject(flattenedIndex) ?? null;
    this.hot.runHooks("afterAddChild", parent, childElement, index2);
  }
  /**
  * Add a sibling element at the specified index.
  *
  * @param {number} index New element sibling's index.
  * @param {('above'|'below')} where Direction in which the sibling is to be created.
  */
  addSibling(index2, where = "below") {
    const translatedIndex = this.translateTrimmedRow(index2);
    const parent = this.getRowParent(translatedIndex);
    const indexWithinParent = this.getRowIndexWithinParent(translatedIndex);
    switch (where) {
      case "below":
        this.addChildAtIndex(parent, indexWithinParent + 1, null);
        break;
      case "above":
        this.addChildAtIndex(parent, indexWithinParent, null);
        break;
    }
  }
  /**
  * Detach the provided element from its parent and add it right after it.
  *
  * @param {object|Array} elements Row object or an array of selected coordinates.
  * @param {boolean} [forceRender=true] If true (default), it triggers render after finished.
  */
  detachFromParent(elements, forceRender = true) {
    let element = null;
    const rowObjects = [];
    if (Array.isArray(elements)) {
      rangeEach(elements[0], elements[2], (i) => {
        const translatedIndex = this.translateTrimmedRow(i);
        rowObjects.push(this.getDataObject(translatedIndex));
      });
      rangeEach(0, rowObjects.length - 2, (i) => {
        const rowObj = rowObjects[i];
        if (rowObj !== null && rowObj !== void 0) {
          this.detachFromParent(rowObj, false);
        }
      });
      element = rowObjects[rowObjects.length - 1] ?? null;
    } else {
      element = elements;
    }
    if (!element) {
      return;
    }
    const childRowIndex = this.getRowIndex(element) ?? 0;
    const childCount = this.countChildren(element);
    const indexWithinParent = this.getRowIndexWithinParent(element);
    const parent = this.getRowParent(element);
    const grandparent = this.getRowParent(parent);
    const grandparentRowIndex = this.getRowIndex(grandparent) ?? 0;
    let movedElementRowIndex = null;
    this.hot.runHooks("beforeDetachChild", parent, element);
    if (indexWithinParent !== null && indexWithinParent !== void 0) {
      const removedRowIndexes = Array.from(new Array(childRowIndex + childCount + 1).keys()).splice(-1 * (childCount + 1));
      this.hot.runHooks("beforeRemoveRow", childRowIndex, childCount + 1, removedRowIndexes, this.plugin.pluginName);
      parent.__children.splice(indexWithinParent, 1);
      this.rewriteCache();
      this.hot.runHooks("afterRemoveRow", childRowIndex, childCount + 1, removedRowIndexes, this.plugin.pluginName);
      if (grandparent) {
        movedElementRowIndex = grandparentRowIndex + this.countChildren(grandparent);
        const lastGrandparentChild = this.getChild(grandparent, this.countChildren(grandparent) - 1);
        const lastGrandparentChildIndex = this.getRowIndex(lastGrandparentChild) ?? 0;
        this.hot.runHooks("beforeCreateRow", lastGrandparentChildIndex + 1, childCount + 1, this.plugin.pluginName);
        grandparent.__children.push(element);
      } else {
        movedElementRowIndex = this.hot.countRows() + 1;
        this.hot.runHooks("beforeCreateRow", movedElementRowIndex - 2, childCount + 1, this.plugin.pluginName);
        this.data.push(element);
      }
    }
    this.rewriteCache();
    this.hot.runHooks("afterCreateRow", movedElementRowIndex - 2, childCount + 1, this.plugin.pluginName);
    this.hot.runHooks("afterDetachChild", parent, element, this.getRowIndex(element));
    if (forceRender) {
      this.hot.render();
    }
  }
  /**
  * Filter the data by the `logicRows` array.
  *
  * @private
  * @param {number} index Index of the first row to remove.
  * @param {number} amount Number of elements to remove.
  * @param {Array} logicRows Array of indexes to remove.
  */
  filterData(index2, amount, logicRows) {
    const elementsToRemove = [];
    arrayEach(logicRows, (elem) => {
      const elemObj = this.getDataObject(elem);
      if (elemObj !== null && elemObj !== void 0) {
        elementsToRemove.push(elemObj);
      }
    });
    arrayEach(elementsToRemove, (elem) => {
      const indexWithinParent = this.getRowIndexWithinParent(elem);
      const tempParent = this.getRowParent(elem);
      if (tempParent === null) {
        this.data.splice(indexWithinParent, 1);
      } else {
        tempParent.__children.splice(indexWithinParent, 1);
      }
    });
    this.rewriteCache();
  }
  /**
  * Used to splice the source data. Needed to properly modify the nested structure, which wouldn't work with the
  * default script.
  *
  * @private
  * @param {number} index Physical index of the element at the splice beginning.
  * @param {number} amount Number of elements to be removed.
  * @param {object[]} elements Array of row objects to add.
  */
  spliceData(index2, amount, elements) {
    const previousElement = this.getDataObject(index2 - 1);
    let newRowParent = null;
    let indexWithinParent = index2;
    if (previousElement && previousElement.__children && previousElement.__children.length === 0) {
      newRowParent = previousElement;
      indexWithinParent = 0;
    } else if (index2 < this.countAllRows()) {
      newRowParent = this.getRowParent(index2);
      indexWithinParent = this.getRowIndexWithinParent(index2);
    }
    if (newRowParent) {
      if (elements) {
        newRowParent.__children.splice(indexWithinParent, amount, ...elements);
      } else {
        newRowParent.__children.splice(indexWithinParent, amount);
      }
    } else if (elements) {
      this.data.splice(indexWithinParent, amount, ...elements);
    } else {
      this.data.splice(indexWithinParent, amount);
    }
    this.rewriteCache();
  }
  /**
  * Update the `__children` key of the upmost parent of the provided row object.
  *
  * @private
  * @param {object} rowElement Row object.
  */
  syncRowWithRawSource(rowElement) {
    let upmostParent = rowElement;
    let tempParent = upmostParent;
    do {
      tempParent = this.getRowParent(tempParent);
      if (tempParent !== null) {
        upmostParent = tempParent;
      }
    } while (tempParent !== null);
    this.plugin.disableCoreAPIModifiers();
    this.hot.setSourceDataAtCell(this.getRowIndexWithinParent(upmostParent), "__children", upmostParent.__children, "NestedRows.syncRowWithRawSource");
    this.plugin.enableCoreAPIModifiers();
  }
  /* eslint-disable jsdoc/require-param */
  /**
  * Move a single row.
  *
  * @param {number} fromIndex Index of the row to be moved.
  * @param {number} toIndex Index of the destination.
  * @param {boolean} moveToCollapsed `true` if moving a row to a collapsed parent.
  * @param {boolean} moveToLastChild `true` if moving a row to be a last child of the new parent.
  */
  /* eslint-enable jsdoc/require-param */
  /**
  *
  */
  moveRow(fromIndex, toIndex, moveToCollapsed, moveToLastChild) {
    const moveToLastRow = toIndex === this.hot.countRows();
    const fromParent = this.getRowParent(fromIndex);
    const indexInFromParent = this.getRowIndexWithinParent(fromIndex);
    const elemToMove = fromParent.__children.slice(indexInFromParent, indexInFromParent + 1);
    const movingUp = fromIndex > toIndex;
    let toParent = moveToLastRow ? this.getRowParent(toIndex - 1) : this.getRowParent(toIndex);
    if (toParent === null || toParent === void 0) {
      toParent = this.getRowParent(toIndex - 1);
    }
    if (toParent === null || toParent === void 0) {
      toParent = this.getDataObject(toIndex - 1);
    }
    if (!toParent) {
      toParent = this.getDataObject(toIndex);
      toParent.__children = [];
    } else if (!toParent.__children) {
      toParent.__children = [];
    }
    const indexInTargetParent = moveToLastRow || moveToCollapsed || moveToLastChild ? toParent.__children.length : this.getRowIndexWithinParent(toIndex);
    const sameParent = fromParent === toParent;
    toParent.__children.splice(indexInTargetParent, 0, elemToMove[0]);
    fromParent.__children.splice(indexInFromParent + (movingUp && sameParent ? 1 : 0), 1);
    this.syncRowWithRawSource(fromParent);
    if (!sameParent) {
      this.syncRowWithRawSource(toParent);
    }
  }
  /**
  * Translate the visual row index to the physical index, taking into consideration the state of collapsed rows.
  *
  * @private
  * @param {number} row Row index.
  * @returns {number}
  */
  translateTrimmedRow(row) {
    if (this.plugin.collapsingUI) {
      return this.plugin.collapsingUI.translateTrimmedRow(row);
    }
    return row;
  }
  /**
  * Translate the physical row index to the visual index, taking into consideration the state of collapsed rows.
  *
  * @private
  * @param {number} row Row index.
  * @returns {number}
  */
  untranslateTrimmedRow(row) {
    if (this.plugin.collapsingUI) {
      return this.plugin.collapsingUI.untranslateTrimmedRow(row);
    }
    return row;
  }
  /**
  * Initializes the data manager with references to the NestedRows plugin and the Handsontable instance.
  */
  constructor(nestedRowsPlugin, hotInstance) {
    this.data = null;
    this.parentReference = /* @__PURE__ */ new WeakMap();
    this.cache = {
      levels: [],
      levelCount: 0,
      rows: [],
      nodeInfo: /* @__PURE__ */ new WeakMap()
    };
    this.hot = hotInstance;
    this.plugin = nestedRowsPlugin;
  }
}
class BaseUI4 {
  /**
  * Initializes the base UI component with references to the NestedRows plugin instance and the Handsontable instance.
  */
  constructor(pluginInstance, hotInstance) {
    this.hot = hotInstance;
    this.plugin = pluginInstance;
  }
}
class HeadersUI extends BaseUI4 {
  /**
  * CSS classes used in the row headers.
  *
  * @type {object}
  */
  static get CSS_CLASSES() {
    return {
      indicatorContainer: "ht_nestingLevels",
      parent: "ht_nestingParent",
      indicator: "ht_nestingLevel",
      emptyIndicator: "ht_nestingLevel_empty",
      button: "ht_nestingButton",
      expandButton: "ht_nestingExpand",
      collapseButton: "ht_nestingCollapse"
    };
  }
  /**
  * Append nesting indicators and buttons to the row headers.
  *
  * @private
  * @param {number} row Row index.
  * @param {HTMLElement} TH TH 3element.
  */
  appendLevelIndicators(row, TH) {
    const rowIndex = this.hot.toPhysicalRow(row);
    const rowObject = this.dataManager.getDataObject(rowIndex);
    if (!rowObject) {
      return;
    }
    const rowLevel = this.dataManager.getRowLevel(rowIndex);
    const innerDiv = TH.getElementsByTagName("DIV")[0];
    const innerSpan = innerDiv.querySelector("span.rowHeader");
    const previousIndicators = innerDiv.querySelectorAll('[class^="ht_nesting"]');
    const ariaEnabled = this.hot.getSettings().ariaTags;
    arrayEach(previousIndicators, (elem) => {
      if (elem) {
        innerDiv.removeChild(elem);
      }
    });
    addClass(TH, HeadersUI.CSS_CLASSES.indicatorContainer);
    if (rowLevel) {
      const { rootDocument } = this.hot;
      const initialContent = innerSpan.cloneNode(true);
      innerDiv.innerHTML = "";
      rangeEach(0, rowLevel - 1, () => {
        const levelIndicator = rootDocument.createElement("SPAN");
        addClass(levelIndicator, HeadersUI.CSS_CLASSES.emptyIndicator);
        innerDiv.appendChild(levelIndicator);
      });
      innerDiv.appendChild(initialContent);
    }
    if (this.dataManager.hasChildren(rowObject)) {
      const buttonsContainer = this.hot.rootDocument.createElement("DIV");
      if (ariaEnabled) {
        setAttribute(buttonsContainer, [
          A11Y_HIDDEN()
        ]);
      }
      addClass(TH, HeadersUI.CSS_CLASSES.parent);
      if (this.collapsingUI.areChildrenCollapsed(rowIndex)) {
        addClass(buttonsContainer, `${HeadersUI.CSS_CLASSES.button} ${HeadersUI.CSS_CLASSES.expandButton}`);
        if (ariaEnabled) {
          setAttribute(TH, [
            A11Y_EXPANDED(false)
          ]);
        }
      } else {
        addClass(buttonsContainer, `${HeadersUI.CSS_CLASSES.button} ${HeadersUI.CSS_CLASSES.collapseButton}`);
        if (ariaEnabled) {
          setAttribute(TH, [
            A11Y_EXPANDED(true)
          ]);
        }
      }
      innerDiv.appendChild(buttonsContainer);
    }
  }
  /**
  * Update the row header width according to number of levels in the dataset.
  *
  * @private
  * @param {number} deepestLevel Cached deepest level of nesting.
  */
  updateRowHeaderWidth(deepestLevel) {
    let deepestLevelIndex = deepestLevel;
    if (!deepestLevelIndex) {
      deepestLevelIndex = this.dataManager.cache.levelCount;
    }
    let completeVerticalPadding = 11;
    const verticalPadding = this.hot.stylesHandler.getCSSVariableValue("cell-horizontal-padding");
    completeVerticalPadding = verticalPadding * 2;
    this.rowHeaderWidthCache = Math.max(50, completeVerticalPadding + 10 * deepestLevelIndex + 25);
    this.hot.render();
  }
  /**
  * Initializes the headers UI component and sets up the data manager reference used to determine nesting levels for each row header.
  */
  constructor(nestedRowsPlugin, hotInstance) {
    super(nestedRowsPlugin, hotInstance);
    this.dataManager = this.plugin.dataManager;
    this.collapsingUI = this.plugin.collapsingUI;
    this.rowHeaderWidthCache = null;
  }
}
class CollapsingUI extends BaseUI4 {
  /**
  * Collapse the children of the row passed as an argument.
  *
  * @param {number|object} row The parent row.
  * @param {boolean} [forceRender=true] Whether to render the table after the function ends.
  * @param {boolean} [doTrimming=true] I determine whether collapsing should envolve trimming rows.
  * @returns {Array}
  */
  collapseChildren(row, forceRender = true, doTrimming = true) {
    const rowsToCollapse = [];
    let rowObject = null;
    let rowIndex = null;
    let rowsToTrim = null;
    if (isNaN(row)) {
      rowObject = row;
      rowIndex = this.dataManager.getRowIndex(rowObject);
    } else {
      rowObject = this.dataManager.getDataObject(row);
      rowIndex = row;
    }
    if (rowObject && this.dataManager.hasChildren(rowObject)) {
      arrayEach(rowObject.__children, (elem) => {
        rowsToCollapse.push(this.dataManager.getRowIndex(elem) ?? -1);
      });
    }
    rowsToTrim = this.collapseRows(rowsToCollapse, true, false);
    if (doTrimming) {
      this.trimRows(rowsToTrim);
    }
    if (forceRender) {
      this.renderAndAdjust();
    }
    if (this.collapsedRows.indexOf(rowIndex) === -1) {
      this.collapsedRows.push(rowIndex);
    }
    return rowsToTrim;
  }
  /**
  * Collapse multiple children.
  *
  * @param {Array} rows Rows to collapse (including their children).
  * @param {boolean} [forceRender=true] `true` if the table should be rendered after finishing the function.
  * @param {boolean} [doTrimming=true] I determine whether collapsing should envolve trimming rows.
  */
  collapseMultipleChildren(rows, forceRender = true, doTrimming = true) {
    const rowsToTrim = [];
    arrayEach(rows, (elem) => {
      rowsToTrim.push(...this.collapseChildren(elem, false, false));
    });
    if (doTrimming) {
      this.trimRows(rowsToTrim);
    }
    if (forceRender) {
      this.renderAndAdjust();
    }
  }
  /**
  * Collapse a single row.
  *
  * @param {number} rowIndex Index of the row to collapse.
  * @param {boolean} [recursive=true] `true` if it should collapse the row's children.
  */
  collapseRow(rowIndex, recursive = true) {
    this.collapseRows([
      rowIndex
    ], recursive);
  }
  /**
  * Collapse multiple rows.
  *
  * @param {Array} rowIndexes Array of row indexes to collapse.
  * @param {boolean} [recursive=true] `true` if it should collapse the rows' children.
  * @param {boolean} [doTrimming=true] I determine whether collapsing should envolve trimming rows.
  * @returns {Array} Rows prepared for trimming (or trimmed, if doTrimming == true).
  */
  collapseRows(rowIndexes, recursive = true, doTrimming = false) {
    const rowsToTrim = [];
    arrayEach(rowIndexes, (elem) => {
      rowsToTrim.push(elem);
      if (recursive) {
        this.collapseChildRows(elem, rowsToTrim);
      }
    });
    if (doTrimming) {
      this.trimRows(rowsToTrim);
    }
    return rowsToTrim;
  }
  /**
  * Collapse child rows of the row at the provided index.
  *
  * @param {number} parentIndex Index of the parent node.
  * @param {Array} [rowsToTrim=[]] Array of rows to trim. Defaults to an empty array.
  * @param {boolean} [recursive] `true` if the collapsing process should be recursive.
  * @param {boolean} [doTrimming=true] I determine whether collapsing should envolve trimming rows.
  */
  collapseChildRows(parentIndex, rowsToTrim = [], recursive, doTrimming = false) {
    if (this.dataManager.hasChildren(parentIndex)) {
      const parentObject = this.dataManager.getDataObject(parentIndex);
      arrayEach(parentObject.__children ?? [], (elem) => {
        const elemIndex = this.dataManager.getRowIndex(elem) ?? -1;
        rowsToTrim.push(elemIndex);
        this.collapseChildRows(elemIndex, rowsToTrim);
      });
    }
    if (doTrimming) {
      this.trimRows(rowsToTrim);
    }
  }
  /**
  * Expand a single row.
  *
  * @param {number} rowIndex Index of the row to expand.
  * @param {boolean} [recursive=true] `true` if it should expand the row's children recursively.
  */
  expandRow(rowIndex, recursive = true) {
    this.expandRows([
      rowIndex
    ], recursive);
  }
  /**
  * Expand multiple rows.
  *
  * @param {Array} rowIndexes Array of indexes of the rows to expand.
  * @param {boolean} [recursive=true] `true` if it should expand the rows' children recursively.
  * @param {boolean} [doTrimming=true] I determine whether collapsing should envolve trimming rows.
  * @returns {Array} Array of row indexes to be untrimmed.
  */
  expandRows(rowIndexes, recursive = true, doTrimming = false) {
    const rowsToUntrim = [];
    arrayEach(rowIndexes, (elem) => {
      rowsToUntrim.push(elem);
      if (recursive) {
        this.expandChildRows(elem, rowsToUntrim);
      }
    });
    if (doTrimming) {
      this.untrimRows(rowsToUntrim);
    }
    return rowsToUntrim;
  }
  /**
  * Expand child rows of the provided index.
  *
  * @param {number} parentIndex Index of the parent row.
  * @param {Array} [rowsToUntrim=[]] Array of the rows to be untrimmed.
  * @param {boolean} [recursive] `true` if it should expand the rows' children recursively.
  * @param {boolean} [doTrimming=false] I determine whether collapsing should envolve trimming rows.
  */
  expandChildRows(parentIndex, rowsToUntrim = [], recursive, doTrimming = false) {
    if (this.dataManager.hasChildren(parentIndex)) {
      const parentObject = this.dataManager.getDataObject(parentIndex);
      arrayEach(parentObject.__children ?? [], (elem) => {
        if (!this.isAnyParentCollapsed(elem)) {
          const elemIndex = this.dataManager.getRowIndex(elem) ?? -1;
          rowsToUntrim.push(elemIndex);
          this.expandChildRows(elemIndex, rowsToUntrim);
        }
      });
    }
    if (doTrimming) {
      this.untrimRows(rowsToUntrim);
    }
  }
  /**
  * Expand the children of the row passed as an argument.
  *
  * @param {number|object} row Parent row.
  * @param {boolean} [forceRender=true] Whether to render the table after the function ends.
  * @param {boolean} [doTrimming=true] If set to `true`, the trimming will be applied when the function finishes.
  * @returns {number[]}
  */
  expandChildren(row, forceRender = true, doTrimming = true) {
    const rowsToExpand = [];
    let rowObject = null;
    let rowIndex = null;
    let rowsToUntrim = null;
    if (isNaN(row)) {
      rowObject = row;
      rowIndex = this.dataManager.getRowIndex(row);
    } else {
      rowObject = this.dataManager.getDataObject(row);
      rowIndex = row;
    }
    this.collapsedRows.splice(this.collapsedRows.indexOf(rowIndex), 1);
    if (rowObject && this.dataManager.hasChildren(rowObject)) {
      arrayEach(rowObject.__children, (elem) => {
        const childIndex = this.dataManager.getRowIndex(elem) ?? -1;
        rowsToExpand.push(childIndex);
      });
    }
    rowsToUntrim = this.expandRows(rowsToExpand, true, false);
    if (doTrimming) {
      this.untrimRows(rowsToUntrim);
    }
    if (forceRender) {
      this.renderAndAdjust();
    }
    return rowsToUntrim;
  }
  /**
  * Expand multiple rows' children.
  *
  * @param {Array} rows Array of rows which children are about to be expanded.
  * @param {boolean} [forceRender=true] `true` if the table should render after finishing the function.
  * @param {boolean} [doTrimming=true] `true` if the rows should be untrimmed after finishing the function.
  */
  expandMultipleChildren(rows, forceRender = true, doTrimming = true) {
    const rowsToUntrim = [];
    arrayEach(rows, (elem) => {
      rowsToUntrim.push(...this.expandChildren(elem, false, false));
    });
    if (doTrimming) {
      this.untrimRows(rowsToUntrim);
    }
    if (forceRender) {
      this.renderAndAdjust();
    }
  }
  /**
  * Collapse all collapsable rows.
  */
  collapseAll() {
    const data = this.dataManager.getData();
    const parentsToCollapse = [];
    arrayEach(data, (elem) => {
      if (this.dataManager.hasChildren(elem)) {
        parentsToCollapse.push(elem);
      }
    });
    this.collapseMultipleChildren(parentsToCollapse);
    this.renderAndAdjust();
  }
  /**
  * Expand all collapsable rows.
  */
  expandAll() {
    const data = this.dataManager.getData();
    const parentsToExpand = [];
    arrayEach(data, (elem) => {
      if (this.dataManager.hasChildren(elem)) {
        parentsToExpand.push(elem);
      }
    });
    this.expandMultipleChildren(parentsToExpand);
    this.renderAndAdjust();
  }
  /**
  * Trim rows.
  *
  * @param {Array} rows Physical row indexes.
  */
  trimRows(rows) {
    this.hot.batchExecution(() => {
      arrayEach(rows, (physicalRow) => {
        this.plugin.collapsedRowsMap.setValueAtIndex(physicalRow, true);
      });
    }, true);
  }
  /**
  * Untrim rows.
  *
  * @param {Array} rows Physical row indexes.
  */
  untrimRows(rows) {
    this.hot.batchExecution(() => {
      arrayEach(rows, (physicalRow) => {
        this.plugin.collapsedRowsMap.setValueAtIndex(physicalRow, false);
      });
    }, true);
  }
  /**
  * Check if all child rows are collapsed.
  *
  * @private
  * @param {number|object|null} row The parent row. `null` for the top level.
  * @returns {boolean}
  */
  areChildrenCollapsed(row) {
    let rowObj = isNaN(row) ? row : this.dataManager.getDataObject(row);
    let allCollapsed = true;
    if (rowObj === null || rowObj === void 0) {
      rowObj = {
        __children: this.dataManager.data
      };
    }
    if (rowObj && this.dataManager.hasChildren(rowObj)) {
      arrayEach(rowObj.__children, (elem) => {
        const rowIndex = this.dataManager.getRowIndex(elem) ?? -1;
        if (!this.plugin.collapsedRowsMap.getValueAtIndex(rowIndex)) {
          allCollapsed = false;
          return false;
        }
      });
    }
    return allCollapsed;
  }
  /**
  * Check if any of the row object parents are collapsed.
  *
  * @private
  * @param {object} rowObj Row object.
  * @returns {boolean}
  */
  isAnyParentCollapsed(rowObj) {
    let parent = rowObj;
    while (parent !== null) {
      parent = this.dataManager.getRowParent(parent);
      const parentIndex = this.dataManager.getRowIndex(parent) ?? -1;
      if (this.collapsedRows.indexOf(parentIndex) > -1) {
        return true;
      }
    }
    return false;
  }
  /**
  * Toggle collapsed state. Callback for the `beforeOnCellMousedown` hook.
  *
  * @private
  * @param {MouseEvent} event `mousedown` event.
  * @param {object} coords Coordinates of the clicked cell/header.
  */
  toggleState(event, coords, _TD) {
    if (coords.col >= 0) {
      return;
    }
    const row = this.translateTrimmedRow(coords.row);
    if (hasClass(eventTargetEl(event), HeadersUI.CSS_CLASSES.button)) {
      if (this.areChildrenCollapsed(row)) {
        this.expandChildren(row);
      } else {
        this.collapseChildren(row);
      }
      stopImmediatePropagation(event);
    }
  }
  /**
  * Translate visual row after trimming to physical base row index.
  *
  * @private
  * @param {number} row Row index.
  * @returns {number} Base row index.
  */
  translateTrimmedRow(row) {
    return this.hot.toPhysicalRow(row);
  }
  /**
  * Translate physical row after trimming to visual base row index.
  *
  * @private
  * @param {number} row Row index.
  * @returns {number} Base row index.
  */
  untranslateTrimmedRow(row) {
    return this.hot.toVisualRow(row);
  }
  /**
  * Helper function to render the table and call the `adjustElementsSize` method.
  *
  * @private
  */
  renderAndAdjust() {
    this.hot.view.adjustElementsSize();
    this.hot.render();
  }
  /**
  * Initializes the collapsing UI component and sets up the stash mechanism for preserving collapsed row state across operations.
  */
  constructor(nestedRowsPlugin, hotInstance) {
    super(nestedRowsPlugin, hotInstance);
    this.dataManager = this.plugin.dataManager;
    this.collapsedRows = [];
    this.collapsedRowsStash = {
      stash: (forceRender = false) => {
        this.lastCollapsedRows = this.collapsedRows.slice(0);
        this.expandMultipleChildren(this.lastCollapsedRows ?? [], forceRender);
      },
      shiftStash: (baseIndex, targetIndex = void 0, delta = 1) => {
        const targetIdx = targetIndex === null || targetIndex === void 0 ? Infinity : targetIndex;
        arrayEach(this.lastCollapsedRows ?? [], (elem, i) => {
          if (elem >= baseIndex && elem < targetIdx) {
            this.lastCollapsedRows[i] = elem + delta;
          }
        });
      },
      applyStash: (forceRender = true) => {
        this.collapseMultipleChildren(this.lastCollapsedRows ?? [], forceRender);
        this.lastCollapsedRows = void 0;
      },
      trimStash: (realElementIndex, amount) => {
        rangeEach(realElementIndex, realElementIndex + amount - 1, (i) => {
          const indexOfElement = this.lastCollapsedRows.indexOf(i);
          if (indexOfElement > -1) {
            this.lastCollapsedRows.splice(indexOfElement, 1);
          }
        });
      }
    };
  }
}
function _check_private_redeclaration$h(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$h(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$h(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$h(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$h(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$h(receiver, privateMap, "get");
  return _class_apply_descriptor_get$h(receiver, descriptor);
}
function _class_private_field_init$h(obj, privateMap, value) {
  _check_private_redeclaration$h(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$h(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$h(receiver, privateMap, "set");
  _class_apply_descriptor_set$h(receiver, descriptor, value);
  return value;
}
var _menuEntries = /* @__PURE__ */ new WeakMap();
class ContextMenuUI extends BaseUI4 {
  /**
  * Append options to the context menu. (Propagated from the `afterContextMenuDefaultOptions` hook callback)
  * f.
  *
  * @private
  * @param {object} defaultOptions Default context menu options.
  * @returns {*}
  */
  appendOptions(defaultOptions) {
    const newEntries = [
      {
        key: "add_child",
        name() {
          return String(this.getTranslatedPhrase(CONTEXTMENU_ITEMS_NESTED_ROWS_INSERT_CHILD));
        },
        callback: () => {
          const selectedActive = this.hot.getSelectedActive();
          const translatedRowIndex = this.dataManager.translateTrimmedRow(selectedActive?.[0] ?? 0);
          const parent = this.dataManager.getDataObject(translatedRowIndex);
          this.dataManager.addChild(parent);
        },
        disabled: () => {
          const selected = this.hot.getSelectedActive();
          return !selected || (selected[0] ?? 0) < 0 || this.hot.selection.isSelectedByColumnHeader() || this.hot.countRows() >= (this.hot.getSettings().maxRows ?? Infinity);
        }
      },
      {
        key: "detach_from_parent",
        name() {
          return String(this.getTranslatedPhrase(CONTEXTMENU_ITEMS_NESTED_ROWS_DETACH_CHILD));
        },
        callback: () => {
          this.dataManager.detachFromParent(this.hot.getSelectedActive() ?? []);
        },
        disabled: () => {
          const selected = this.hot.getSelectedActive();
          const translatedRowIndex = this.dataManager.translateTrimmedRow(selected?.[0] ?? 0);
          const parent = this.dataManager.getRowParent(translatedRowIndex);
          return !parent || !selected || (selected[0] ?? 0) < 0 || this.hot.selection.isSelectedByColumnHeader() || this.hot.countRows() >= (this.hot.getSettings().maxRows ?? Infinity);
        }
      },
      {
        name: "---------"
      }
    ];
    rangeEach(0, defaultOptions.items.length - 1, (i) => {
      if (i === 0) {
        arrayEach(newEntries, (val, j) => {
          defaultOptions.items.splice(i + j, 0, val);
        });
        return false;
      }
    });
    return this.modifyRowInsertingOptions(defaultOptions);
  }
  /**
  * Modify how the row inserting options work.
  *
  * @private
  * @param {object} defaultOptions Default context menu items.
  * @returns {*}
  */
  modifyRowInsertingOptions(defaultOptions) {
    rangeEach(0, defaultOptions.items.length - 1, (i) => {
      const option = _class_private_field_get$h(this, _menuEntries)[defaultOptions.items[i].key];
      if (option !== null && option !== void 0) {
        defaultOptions.items[i].callback = option;
      }
    });
    return defaultOptions;
  }
  constructor(...args) {
    super(...args), _class_private_field_init$h(this, _menuEntries, {
      writable: true,
      value: void 0
    }), /**
    * Reference to the DataManager instance connected with the Nested Rows plugin.
    *
    * @type {DataManager}
    */
    this.dataManager = this.plugin.dataManager, _class_private_field_set$h(this, _menuEntries, {
      row_above: (key, selection) => {
        const lastSelection = selection[selection.length - 1];
        this.dataManager.addSibling(lastSelection.start.row, "above");
      },
      row_below: (key, selection) => {
        const lastSelection = selection[selection.length - 1];
        this.dataManager.addSibling(lastSelection.start.row, "below");
      }
    });
  }
}
function isValidDataSource(data) {
  return Array.isArray(data) && (data.length === 0 || isArrayOfObjects(data));
}
class RowMoveController {
  /**
  * `beforeRowMove` hook callback.
  *
  * @param {Array} rows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows. Points to where the elements
  *   will be placed after the moving action. To check the visualization of the final index, please take a look at
  *   [documentation](@/guides/rows/row-moving/row-moving.md).
  * @param {undefined|number} dropIndex Visual row index, being a drop index for the moved rows. Points to where we
  *   are going to drop the moved elements. To check visualization of drop index please take a look at
  *   [documentation](@/guides/rows/row-moving/row-moving.md).
  * @param {boolean} movePossible Indicates if it's possible to move rows to the desired position.
  * @fires Hooks#afterRowMove
  * @returns {boolean}
  */
  onBeforeRowMove(rows, finalIndex, dropIndex, movePossible) {
    const improperUsage = this.displayAPICompatibilityWarning({
      rows,
      finalIndex,
      dropIndex,
      movePossible
    });
    if (improperUsage) {
      return false;
    }
    this.movedToCollapsed = false;
    const dropToLastRow = dropIndex === this.hot.countRows();
    const physicalDropIndex = dropToLastRow ? this.hot.countSourceRows() : this.dataManager.translateTrimmedRow(dropIndex ?? 0);
    let allowMove = true;
    const physicalStartIndexes = rows.map((rowIndex) => {
      if (!allowMove) {
        return -1;
      }
      const physicalRowIndex = this.dataManager.translateTrimmedRow(rowIndex);
      allowMove = this.shouldAllowMoving(physicalRowIndex, physicalDropIndex);
      return physicalRowIndex;
    });
    const willDataChange = physicalStartIndexes.indexOf(physicalDropIndex) === -1;
    if (!allowMove) {
      return false;
    }
    if (!willDataChange) {
      return;
    }
    const baseParent = this.getBaseParent(physicalStartIndexes);
    const targetParent = this.getTargetParent(dropToLastRow, physicalDropIndex);
    const sameParent = baseParent === targetParent;
    this.movedToCollapsed = this.collapsingUI.areChildrenCollapsed(targetParent);
    this.collapsingUI.collapsedRowsStash.stash();
    this.shiftCollapsibleParentsLocations(physicalStartIndexes, physicalDropIndex, sameParent);
    this.moveRows(physicalStartIndexes, physicalDropIndex, targetParent);
    this.dataManager.rewriteCache();
    this.moveCellsMeta(physicalStartIndexes, physicalDropIndex);
    this.collapsingUI.collapsedRowsStash.applyStash(false);
    this.hot.runHooks("afterRowMove", rows, finalIndex, dropIndex, movePossible, movePossible && this.isRowOrderChanged(rows, finalIndex));
    this.hot.render();
    this.selectCells(rows, dropIndex);
    return false;
  }
  /**
  * Display a `dragRows`/`moveRows` method compatibility warning if needed.
  *
  * @param {object} beforeMoveRowHookArgs A set of arguments from the `beforeMoveRow` hook.
  * @returns {boolean} `true` if is a result of an improper usage of the moving API.
  */
  displayAPICompatibilityWarning(beforeMoveRowHookArgs) {
    const { rows, finalIndex, dropIndex, movePossible } = beforeMoveRowHookArgs;
    let shouldTerminate = false;
    if (isUndefined$1(dropIndex)) {
      warn$1(toSingleLine`Since version 8.0.0 of the Handsontable the 'moveRows' method isn't used for moving rows\x20
      when the NestedRows plugin is enabled. Please use the 'dragRows' method instead.`);
      this.hot.runHooks("afterRowMove", rows, finalIndex, dropIndex, movePossible, false);
      shouldTerminate = true;
    }
    return shouldTerminate;
  }
  /**
  * Check if the moving action should be allowed.
  *
  * @param {number} physicalRowIndex Physical start row index.
  * @param {number} physicalDropIndex Physical drop index.
  * @returns {boolean} `true` if it should continue with the moving action.
  */
  shouldAllowMoving(physicalRowIndex, physicalDropIndex) {
    return !(this.dataManager.isParent(physicalRowIndex) || this.dataManager.isRowHighestLevel(physicalRowIndex) || physicalRowIndex === physicalDropIndex || physicalDropIndex === 0);
  }
  /**
  * Get the base row parent.
  *
  * @param {number} physicalStartIndexes Physical start row index.
  * @returns {object|null} The base row parent.
  */
  getBaseParent(physicalStartIndexes) {
    return this.dataManager.getRowParent(physicalStartIndexes[0]);
  }
  /**
  * Get the target row parent.
  *
  * @param {boolean} dropToLastRow `true` if the row is moved to the last row of the table.
  * @param {number} physicalDropIndex Physical drop row index.
  * @returns {object|null} The target row parent.
  */
  getTargetParent(dropToLastRow, physicalDropIndex) {
    let targetParent = this.dataManager.getRowParent(dropToLastRow ? physicalDropIndex - 1 : physicalDropIndex);
    if (targetParent === null || targetParent === void 0) {
      targetParent = this.dataManager.getRowParent(physicalDropIndex - 1);
    }
    return targetParent;
  }
  /**
  * Shift the cached collapsible rows position according to the move action.
  *
  * @param {number[]} physicalStartIndexes Physical start row indexes.
  * @param {number} physicalDropIndex Physical drop index.
  * @param {boolean} sameParent `true` if the row's being moved between siblings of the same parent.
  */
  shiftCollapsibleParentsLocations(physicalStartIndexes, physicalDropIndex, sameParent) {
    if (!sameParent) {
      if (Math.max(...physicalStartIndexes) <= physicalDropIndex) {
        this.collapsingUI.collapsedRowsStash.shiftStash(physicalStartIndexes[0], physicalDropIndex, -1 * physicalStartIndexes.length);
      } else {
        this.collapsingUI.collapsedRowsStash.shiftStash(physicalDropIndex, physicalStartIndexes[0], physicalStartIndexes.length);
      }
    }
  }
  /**
  * Move the rows at the provided coordinates.
  *
  * @param {number[]} physicalStartIndexes Physical indexes of the rows about to be moved.
  * @param {number} physicalDropIndex Physical drop index.
  * @param {object} targetParent Parent of the destination row.
  */
  moveRows(physicalStartIndexes, physicalDropIndex, targetParent) {
    const moveToLastChild = physicalDropIndex === this.dataManager.getRowIndex(targetParent) + this.dataManager.countChildren(targetParent) + 1;
    this.hot.batchRender(() => {
      physicalStartIndexes.forEach((physicalStartIndex) => {
        this.dataManager.moveRow(physicalStartIndex, physicalDropIndex, this.movedToCollapsed, moveToLastChild);
      });
    });
  }
  /**
  * Move the cell meta for multiple rows.
  *
  * @param {number[]} baseIndexes Array of indexes for the rows being moved.
  * @param {number} targetIndex Index of the destination of the move.
  */
  moveCellsMeta(baseIndexes, targetIndex) {
    const rowsOfMeta = [];
    const movingDown = Math.max(...baseIndexes) < targetIndex;
    baseIndexes.forEach((baseIndex) => {
      rowsOfMeta.push(this.hot.getCellMetaAtRow(baseIndex));
    });
    this.hot.spliceCellsMeta(baseIndexes[0], baseIndexes.length);
    this.hot.spliceCellsMeta(targetIndex - (movingDown ? rowsOfMeta.length : 0), 0, ...rowsOfMeta);
  }
  /**
  * Select cells after the move.
  *
  * @param {Array} rows Array of visual row indexes to be moved.
  * @param {undefined|number} dropIndex Visual row index, being a drop index for the moved rows. Points to where we
  *   are going to drop the moved elements. To check visualization of drop index please take a look at
  *   [documentation](@/guides/rows/row-moving/row-moving.md).
  */
  selectCells(rows, dropIndex) {
    const rowsLen = rows.length;
    let startRow = 0;
    let endRow = 0;
    if (this.movedToCollapsed) {
      let physicalDropIndex = null;
      const safeDropIndex = dropIndex ?? 0;
      if ((rows[rowsLen - 1] ?? 0) < safeDropIndex) {
        physicalDropIndex = this.dataManager.translateTrimmedRow(safeDropIndex - rowsLen);
      } else {
        physicalDropIndex = this.dataManager.translateTrimmedRow(safeDropIndex);
      }
      const parentObject = this.dataManager.getRowParent(physicalDropIndex === null ? this.hot.countSourceRows() - 1 : physicalDropIndex - 1);
      const parentIndex = this.dataManager.getRowIndex(parentObject) ?? 0;
      startRow = this.dataManager.untranslateTrimmedRow(parentIndex);
      endRow = startRow;
    } else if ((rows[rowsLen - 1] ?? 0) < (dropIndex ?? 0)) {
      endRow = (dropIndex ?? 0) - 1;
      startRow = endRow - rowsLen + 1;
    } else {
      startRow = dropIndex ?? 0;
      endRow = startRow + rowsLen - 1;
    }
    this.hot.selectCells([
      [
        startRow,
        0,
        endRow,
        this.hot.countCols() - 1
      ]
    ], false);
  }
  // TODO: Reimplementation of function which is inside the `ManualRowMove` plugin.
  /**
  * Indicates if order of rows was changed.
  *
  * @param {Array} movedRows Array of visual row indexes to be moved.
  * @param {number} finalIndex Visual row index, being a start index for the moved rows. Points to where the elements
  *   will be placed after the moving action. To check the visualization of the final index, please take a look at
  *   [documentation](@/guides/rows/row-moving/row-moving.md).
  * @returns {boolean}
  */
  isRowOrderChanged(movedRows, finalIndex) {
    return movedRows.some((row, nrOfMovedElement) => row - nrOfMovedElement !== finalIndex);
  }
  /**
  * Initializes the row move controller with references to the NestedRows plugin, the Handsontable instance, the data manager, and the collapsing UI.
  */
  constructor(plugin) {
    this.movedToCollapsed = false;
    this.plugin = plugin;
    this.hot = plugin.hot;
    this.dataManager = plugin.dataManager;
    this.collapsingUI = plugin.collapsingUI;
  }
}
function _check_private_redeclaration$g(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$g(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$g(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$g(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$g(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$g(receiver, privateMap, "get");
  return _class_apply_descriptor_get$g(receiver, descriptor);
}
function _class_private_field_init$g(obj, privateMap, value) {
  _check_private_redeclaration$g(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$g(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$g(receiver, privateMap, "set");
  _class_apply_descriptor_set$g(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$a = "nestedRows";
const PLUGIN_PRIORITY$a = 300;
const SHORTCUTS_GROUP$3 = PLUGIN_KEY$a;
const WRONG_DATA_TYPE_ERROR = "The Nested Rows plugin requires an Array of Objects as a dataset to be provided. The plugin has been disabled.";
var _skipRender = /* @__PURE__ */ new WeakMap(), _skipCoreAPIModifiers = /* @__PURE__ */ new WeakMap(), _isFirstRender = /* @__PURE__ */ new WeakMap(), _onBeforeRowMove = /* @__PURE__ */ new WeakMap(), _onBeforeOnCellMouseDown = /* @__PURE__ */ new WeakMap(), _onFilterData = /* @__PURE__ */ new WeakMap(), _onAfterContextMenuDefaultOptions = /* @__PURE__ */ new WeakMap(), _onAfterGetRowHeader = /* @__PURE__ */ new WeakMap(), _onModifyRowHeaderWidth = /* @__PURE__ */ new WeakMap(), _onAfterRemoveRow = /* @__PURE__ */ new WeakMap(), _onBeforeRemoveRow = /* @__PURE__ */ new WeakMap(), _onBeforeAddChild = /* @__PURE__ */ new WeakMap(), _onAfterAddChild = /* @__PURE__ */ new WeakMap(), _onBeforeDetachChild = /* @__PURE__ */ new WeakMap(), _onAfterDetachChild = /* @__PURE__ */ new WeakMap(), _onAfterCreateRow = /* @__PURE__ */ new WeakMap(), _onAfterInit$1 = /* @__PURE__ */ new WeakMap(), _onAfterRender$1 = /* @__PURE__ */ new WeakMap(), _onBeforeViewRender = /* @__PURE__ */ new WeakMap(), _onBeforeLoadData = /* @__PURE__ */ new WeakMap();
class NestedRows extends BasePlugin {
  /**
  * Returns the plugin key used to identify and access this plugin within Handsontable.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$a;
  }
  /**
  * Returns the priority value that determines the plugin's initialization order relative to other plugins.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$a;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link NestedRows#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$a];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.collapsedRowsMap = this.hot.rowIndexMapper.registerMap("nestedRows", new TrimmingMap());
    this.dataManager = new DataManager(this, this.hot);
    this.collapsingUI = new CollapsingUI(this, this.hot);
    this.headersUI = new HeadersUI(this, this.hot);
    this.contextMenuUI = new ContextMenuUI(this, this.hot);
    this.rowMoveController = new RowMoveController(this);
    this.addHook("afterInit", _class_private_field_get$g(this, _onAfterInit$1));
    this.addHook("afterRender", _class_private_field_get$g(this, _onAfterRender$1));
    this.addHook("beforeViewRender", _class_private_field_get$g(this, _onBeforeViewRender));
    this.addHook("modifyRowData", this.onModifyRowData.bind(this));
    this.addHook("modifySourceLength", this.onModifySourceLength.bind(this));
    this.addHook("beforeDataSplice", this.onBeforeDataSplice.bind(this));
    this.addHook("filterData", _class_private_field_get$g(this, _onFilterData));
    this.addHook("afterContextMenuDefaultOptions", _class_private_field_get$g(this, _onAfterContextMenuDefaultOptions));
    this.addHook("afterGetRowHeader", _class_private_field_get$g(this, _onAfterGetRowHeader));
    this.addHook("beforeOnCellMouseDown", _class_private_field_get$g(this, _onBeforeOnCellMouseDown));
    this.addHook("beforeRemoveRow", _class_private_field_get$g(this, _onBeforeRemoveRow));
    this.addHook("afterRemoveRow", _class_private_field_get$g(this, _onAfterRemoveRow));
    this.addHook("beforeAddChild", _class_private_field_get$g(this, _onBeforeAddChild));
    this.addHook("afterAddChild", _class_private_field_get$g(this, _onAfterAddChild));
    this.addHook("beforeDetachChild", _class_private_field_get$g(this, _onBeforeDetachChild));
    this.addHook("afterDetachChild", _class_private_field_get$g(this, _onAfterDetachChild));
    this.addHook("modifyRowHeaderWidth", _class_private_field_get$g(this, _onModifyRowHeaderWidth));
    this.addHook("afterCreateRow", _class_private_field_get$g(this, _onAfterCreateRow));
    this.addHook("beforeRowMove", _class_private_field_get$g(this, _onBeforeRowMove));
    this.addHook("beforeLoadData", _class_private_field_get$g(this, _onBeforeLoadData));
    this.addHook("beforeUpdateData", _class_private_field_get$g(this, _onBeforeLoadData));
    this.registerShortcuts();
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.hot.rowIndexMapper.unregisterMap("nestedRows");
    this.unregisterShortcuts();
    super.disablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`nestedRows`](@/api/options.md#nestedrows)
  */
  updatePlugin() {
    this.disablePlugin();
    const currentSourceData = this.dataManager.getData();
    this.enablePlugin();
    this.dataManager.updateWithData(currentSourceData);
    super.updatePlugin();
  }
  /**
  * Register shortcuts responsible for toggling collapsible columns.
  *
  * @private
  */
  registerShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.addShortcut({
      keys: [
        [
          "Enter"
        ]
      ],
      callback: () => {
        const activeRange = this.hot.getSelectedRangeActive();
        if (!activeRange) {
          return false;
        }
        const { highlight } = activeRange;
        const row = this.collapsingUI.translateTrimmedRow(highlight.row ?? 0);
        if (this.collapsingUI.areChildrenCollapsed(row)) {
          this.collapsingUI.expandChildren(row);
        } else {
          this.collapsingUI.collapseChildren(row);
        }
        return false;
      },
      runOnlyIf: () => {
        const highlight = this.hot.getSelectedRangeActive()?.highlight;
        return !!(highlight && this.hot.getSelectedRangeActive()?.isSingle() && this.hot.selection.isCellVisible(highlight) && highlight.col === -1 && highlight.row !== null && highlight.row >= 0);
      },
      group: SHORTCUTS_GROUP$3,
      relativeToGroup: EDITOR_EDIT_GROUP,
      position: "before"
    });
  }
  /**
  * Unregister shortcuts responsible for toggling collapsible columns.
  *
  * @private
  */
  unregisterShortcuts() {
    this.hot.getShortcutManager().getContext("grid")?.removeShortcutsByGroup(SHORTCUTS_GROUP$3);
  }
  /**
  * Enable the modify hook skipping flag - allows retrieving the data from Handsontable without this plugin's
  * modifications.
  *
  * @private
  */
  disableCoreAPIModifiers() {
    _class_private_field_set$g(this, _skipCoreAPIModifiers, true);
  }
  /**
  * Disable the modify hook skipping flag.
  *
  * @private
  */
  enableCoreAPIModifiers() {
    _class_private_field_set$g(this, _skipCoreAPIModifiers, false);
  }
  /**
  * The modifyRowData hook callback.
  *
  * @private
  * @param {number} row Visual row index.
  * @returns {boolean}
  */
  onModifyRowData(row) {
    if (_class_private_field_get$g(this, _skipCoreAPIModifiers)) {
      return;
    }
    return this.dataManager.getDataObject(row);
  }
  /**
  * Modify the source data length to match the length of the nested structure.
  *
  * @private
  * @returns {number}
  */
  onModifySourceLength() {
    if (_class_private_field_get$g(this, _skipCoreAPIModifiers)) {
      return;
    }
    return this.dataManager.countAllRows();
  }
  /**
  * @private
  * @param {number} index The index where the data was spliced.
  * @param {number} amount An amount of items to remove.
  * @param {object} element An element to add.
  * @returns {boolean}
  */
  onBeforeDataSplice(index2, amount, element) {
    if (_class_private_field_get$g(this, _skipCoreAPIModifiers) || this.dataManager.isRowHighestLevel(index2)) {
      return true;
    }
    this.dataManager.spliceData(index2, amount, [
      element
    ]);
    return false;
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$g(this, _skipRender, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _skipCoreAPIModifiers, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _isFirstRender, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeRowMove, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeOnCellMouseDown, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onFilterData, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterContextMenuDefaultOptions, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterGetRowHeader, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onModifyRowHeaderWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterRemoveRow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeRemoveRow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeAddChild, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterAddChild, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeDetachChild, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterDetachChild, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterCreateRow, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterInit$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onAfterRender$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeViewRender, {
      writable: true,
      value: void 0
    }), _class_private_field_init$g(this, _onBeforeLoadData, {
      writable: true,
      value: void 0
    }), /**
    * Reference to the DataManager instance.
    *
    * @private
    * @type {object}
    */
    this.dataManager = null, /**
    * Reference to the HeadersUI instance.
    *
    * @private
    * @type {object}
    */
    this.headersUI = null, /**
    * Reference to the CollapsingUI instance.
    *
    * @private
    * @type {object}
    */
    this.collapsingUI = null, /**
    * Reference to the ContextMenuUI instance.
    *
    * @private
    * @type {object}
    */
    this.contextMenuUI = null, /**
    * Reference to the RowMoveController instance.
    *
    * @private
    * @type {object}
    */
    this.rowMoveController = null, /**
    * Map of skipped rows by plugin.
    *
    * @private
    * @type {null|TrimmingMap}
    */
    this.collapsedRowsMap = null, _class_private_field_set$g(this, _skipRender, false), _class_private_field_set$g(this, _skipCoreAPIModifiers, false), _class_private_field_set$g(this, _isFirstRender, true), _class_private_field_set$g(this, _onBeforeRowMove, (rows, finalIndex, dropIndex, movePossible) => {
      return this.rowMoveController.onBeforeRowMove(rows, finalIndex, dropIndex, movePossible);
    }), _class_private_field_set$g(this, _onBeforeOnCellMouseDown, (event, coords, TD) => {
      this.collapsingUI.toggleState(event, coords, TD);
    }), _class_private_field_set$g(this, _onFilterData, (index2, amount, physicalRows) => {
      this.collapsingUI.collapsedRowsStash.stash();
      this.collapsingUI.collapsedRowsStash.trimStash(physicalRows[0], amount);
      this.collapsingUI.collapsedRowsStash.shiftStash(physicalRows[0], null, -1 * amount);
      this.dataManager.filterData(index2, amount, physicalRows);
      _class_private_field_set$g(this, _skipRender, true);
      return this.dataManager.getData().slice();
    }), _class_private_field_set$g(this, _onAfterContextMenuDefaultOptions, (defaultOptions) => {
      return this.contextMenuUI.appendOptions(defaultOptions);
    }), _class_private_field_set$g(this, _onAfterGetRowHeader, (row, TH) => {
      this.headersUI.appendLevelIndicators(row, TH);
    }), _class_private_field_set$g(this, _onModifyRowHeaderWidth, (rowHeaderWidth) => {
      return Math.max(this.headersUI.rowHeaderWidthCache ?? 0, rowHeaderWidth);
    }), _class_private_field_set$g(this, _onAfterRemoveRow, (index2, amount, logicRows, source) => {
      if (source === this.pluginName) {
        return;
      }
      this.hot._registerTimeout(() => {
        _class_private_field_set$g(this, _skipRender, false);
        this.headersUI.updateRowHeaderWidth();
        this.collapsingUI.collapsedRowsStash.applyStash();
      });
    }), _class_private_field_set$g(this, _onBeforeRemoveRow, (index2, amount, physicalRows) => {
      const modifiedPhysicalRows = Array.from(physicalRows.reduce((removedRows, physicalIndex) => {
        if (this.dataManager.isParent(physicalIndex)) {
          const children = this.dataManager.getDataObject(physicalIndex)?.__children;
          removedRows.add(physicalIndex);
          if (Array.isArray(children)) {
            children.forEach((child) => {
              const childRowIndex = this.dataManager.getRowIndex(child);
              if (childRowIndex !== null) {
                removedRows.add(childRowIndex);
              }
            });
          }
          return removedRows;
        }
        return removedRows.add(physicalIndex);
      }, /* @__PURE__ */ new Set()));
      physicalRows.length = 0;
      physicalRows.push(...modifiedPhysicalRows);
    }), _class_private_field_set$g(this, _onBeforeAddChild, () => {
      this.collapsingUI.collapsedRowsStash.stash();
    }), _class_private_field_set$g(this, _onAfterAddChild, (parent, element) => {
      const newChildRowIndex = this.dataManager.getRowIndex(element);
      if (newChildRowIndex !== null) {
        this.collapsingUI.collapsedRowsStash.shiftStash(newChildRowIndex);
      }
      this.collapsingUI.collapsedRowsStash.applyStash();
      this.headersUI.updateRowHeaderWidth(void 0);
    }), _class_private_field_set$g(this, _onBeforeDetachChild, () => {
      this.collapsingUI.collapsedRowsStash.stash();
    }), _class_private_field_set$g(this, _onAfterDetachChild, (parent, element, finalElementRowIndex) => {
      this.collapsingUI.collapsedRowsStash.shiftStash(finalElementRowIndex, null, -1);
      this.collapsingUI.collapsedRowsStash.applyStash();
      this.headersUI.updateRowHeaderWidth(void 0);
    }), _class_private_field_set$g(this, _onAfterCreateRow, () => {
      this.dataManager.rewriteCache();
    }), _class_private_field_set$g(this, _onAfterInit$1, () => {
      this.headersUI.updateRowHeaderWidth(void 0);
    }), _class_private_field_set$g(this, _onAfterRender$1, () => {
      if (_class_private_field_get$g(this, _isFirstRender) && this.hot.view) {
        _class_private_field_set$g(this, _isFirstRender, false);
        this.hot.rootWindow.requestAnimationFrame(() => {
          if (this.hot && this.hot.view && !this.hot.isDestroyed) {
            this.hot.view.adjustElementsSize(true);
          }
        });
      }
    }), _class_private_field_set$g(this, _onBeforeViewRender, (force, skipRender) => {
      if (_class_private_field_get$g(this, _skipRender)) {
        skipRender.skipRender = true;
      }
    }), _class_private_field_set$g(this, _onBeforeLoadData, (data) => {
      if (!isValidDataSource(data)) {
        error(WRONG_DATA_TYPE_ERROR);
        this.hot.getSettings()[PLUGIN_KEY$a] = false;
        this.disablePlugin();
        return;
      }
      this.dataManager.setData(data);
      this.dataManager.rewriteCache();
    });
  }
}
function _check_private_redeclaration$f(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$f(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$f(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$f(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$f(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$f(receiver, privateMap, "get");
  return _class_apply_descriptor_get$f(receiver, descriptor);
}
function _class_private_field_init$f(obj, privateMap, value) {
  _check_private_redeclaration$f(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$f(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$f(receiver, privateMap, "set");
  _class_apply_descriptor_set$f(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$7(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$7(obj, privateSet) {
  _check_private_redeclaration$f(obj, privateSet);
  privateSet.add(obj);
}
const TEMPLATE$1 = `
<div data-ref="container" class="ht-pagination handsontable">
  <div class="ht-pagination__inner">
    <div data-ref="pageSizeSection" class="ht-page-size-section">
      <span data-ref="pageSizeLabel" class="ht-page-size-section__label"></span>
      <div class="ht-page-size-section__select-wrapper">
        <select data-ref="pageSizeSelect" name="pageSize" data-hot-input></select>
      </div>
    </div>
    <div data-ref="pageCounterSection" class="ht-page-counter-section"></div>
    <nav data-ref="pageNavSection" class="ht-page-navigation-section">
      <button data-ref="first" class="ht-page-navigation-section__button ht-page-first"></button>
      <button data-ref="prev" class="ht-page-navigation-section__button ht-page-prev"></button>
      <span data-ref="pageNavLabel" class="ht-page-navigation-section__label"></span>
      <button data-ref="next" class="ht-page-navigation-section__button ht-page-next"></button>
      <button data-ref="last" class="ht-page-navigation-section__button ht-page-last"></button>
    </nav>
  </div>
</div>
`;
var _rootElement = /* @__PURE__ */ new WeakMap(), _uiContainer = /* @__PURE__ */ new WeakMap(), _isRtl$2 = /* @__PURE__ */ new WeakMap(), _refs$2 = /* @__PURE__ */ new WeakMap(), _themeName = /* @__PURE__ */ new WeakMap(), _phraseTranslator = /* @__PURE__ */ new WeakMap(), _a11yAnnouncer = /* @__PURE__ */ new WeakMap(), _updateContainerVisibility = /* @__PURE__ */ new WeakSet();
class PaginationUI {
  /**
  * Creates the pagination UI elements and sets up event listeners.
  */
  install() {
    if (_class_private_field_get$f(this, _refs$2)?.container) {
      return;
    }
    const elements = html`${TEMPLATE$1}`;
    const { container, first: first2, prev, next, last: last2, pageSizeSelect } = elements.refs;
    _class_private_field_set$f(this, _refs$2, elements.refs);
    container.setAttribute("dir", _class_private_field_get$f(this, _isRtl$2) ? "rtl" : "ltr");
    container.tabIndex = -1;
    const isDisabled2 = (event) => event.currentTarget.disabled;
    const addClickListener = (eventName, element, callback) => {
      element.addEventListener(eventName, (event) => {
        if (!isDisabled2(event)) {
          callback();
        }
      });
    };
    addClickListener("click", first2, () => this.runLocalHooks("firstPageClick"));
    addClickListener("click", prev, () => this.runLocalHooks("prevPageClick"));
    addClickListener("click", next, () => this.runLocalHooks("nextPageClick"));
    addClickListener("click", last2, () => this.runLocalHooks("lastPageClick"));
    pageSizeSelect.addEventListener("change", () => {
      const value = pageSizeSelect.value === "auto" ? "auto" : Number.parseInt(pageSizeSelect.value, 10);
      this.runLocalHooks("pageSizeChange", value);
    });
    this.setCounterSectionVisibility(false);
    this.setNavigationSectionVisibility(false);
    this.setPageSizeSectionVisibility(false);
    if (_class_private_field_get$f(this, _uiContainer)) {
      _class_private_field_get$f(this, _uiContainer).appendChild(elements.fragment);
      addClass(container, [
        _class_private_field_get$f(this, _themeName) ?? "",
        "handsontable"
      ]);
    }
  }
  /**
  * Gets the pagination element.
  *
  * @returns {HTMLElement} The pagination element.
  */
  getContainer() {
    return _class_private_field_get$f(this, _refs$2).container;
  }
  /**
  * Gets the focusable elements.
  *
  * @returns {HTMLElement[]} The focusable elements.
  */
  getFocusableElements() {
    const { first: first2, prev, next, last: last2, pageSizeSelect } = _class_private_field_get$f(this, _refs$2);
    return [
      pageSizeSelect,
      first2,
      prev,
      next,
      last2
    ].filter((element) => !element.disabled);
  }
  /**
  * Updates the theme of the pagination container.
  *
  * @param {string | false | undefined} themeName The name of the theme to use.
  * @returns {PaginationUI} The instance of the PaginationUI for method chaining.
  */
  updateTheme(themeName) {
    _class_private_field_set$f(this, _themeName, themeName);
    if (_class_private_field_get$f(this, _uiContainer)) {
      const { container } = _class_private_field_get$f(this, _refs$2);
      removeClass(container, /ht-theme-.*/g);
      if (_class_private_field_get$f(this, _themeName)) {
        addClass(container, _class_private_field_get$f(this, _themeName));
      }
    }
    return this;
  }
  /**
  * Gets the height of the pagination container element.
  *
  * @returns {number}
  */
  getHeight() {
    return _class_private_field_get$f(this, _refs$2).container.offsetHeight;
  }
  /**
  * Updates the state of the pagination UI.
  *
  * @param {object} state The pagination state.
  * @param {number} state.currentPage The current page number.
  * @param {number} state.totalPages The total number of pages.
  * @param {number} state.firstVisibleRowIndex The index of the first visible row on the current page.
  * @param {number} state.lastVisibleRowIndex The index of the last visible row on the current page.
  * @param {number} state.totalRenderedRows The total number of renderable rows.
  * @param {Array<number | 'auto'>} state.pageSizeList The list of available page sizes.
  * @param {number} state.pageSize The current page size.
  * @param {boolean} state.autoPageSize Indicates if the page size is set to 'auto'.
  * @param {number} [state.counterStartRow] Optional 1-based start row for the counter (e.g. dataProvider mode).
  * @param {number} [state.counterEndRow] Optional 1-based end row for the counter (e.g. dataProvider mode).
  * @returns {PaginationUI} The instance of the PaginationUI for method chaining.
  */
  updateState({ currentPage, totalPages, firstVisibleRowIndex, lastVisibleRowIndex, totalRenderedRows, pageSizeList, pageSize, autoPageSize, counterStartRow, counterEndRow }) {
    const { first: first2, prev, next, last: last2, pageCounterSection, pageNavSection, pageNavLabel, pageSizeSelect, pageSizeLabel } = _class_private_field_get$f(this, _refs$2);
    const counterStart = counterStartRow ?? firstVisibleRowIndex + 1;
    const counterEnd = counterEndRow ?? lastVisibleRowIndex + 1;
    const counterSectionText = _class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_COUNTER_SECTION, {
      start: counterStart,
      end: counterEnd,
      total: totalRenderedRows
    });
    const navLabelText = _class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_NAV_SECTION, {
      currentPage,
      totalPages
    });
    const pageSizeLabelText = _class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_PAGE_SIZE_SECTION);
    pageCounterSection.textContent = counterSectionText;
    pageNavLabel.textContent = navLabelText;
    pageSizeSelect.textContent = "";
    pageSizeLabel.textContent = `${pageSizeLabelText}:`;
    setAttribute(pageNavSection, [
      ...[
        A11Y_LABEL(_class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_SECTION))
      ]
    ]);
    setAttribute(pageSizeSelect, [
      ...[
        A11Y_LABEL(_class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_PAGE_SIZE_SECTION))
      ]
    ]);
    _class_private_field_get$f(this, _a11yAnnouncer).call(this, navLabelText);
    pageSizeList.forEach((pageSizeItem) => {
      const label = pageSizeItem === "auto" ? _class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_PAGE_SIZE_AUTO) : pageSizeItem;
      const option = new Option(String(label ?? ""), String(pageSizeItem ?? ""));
      if (autoPageSize && pageSizeItem === "auto" || !autoPageSize && pageSizeItem === pageSize) {
        option.selected = true;
      }
      pageSizeSelect.add(option);
    });
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;
    if (pageNavSection.style.display !== "none") {
      const activeElement = _class_private_field_get$f(this, _rootElement).ownerDocument.activeElement;
      if (isFirstPage) {
        addClass(first2, "ht-page-navigation-section__button--disabled");
        addClass(prev, "ht-page-navigation-section__button--disabled");
        first2.disabled = true;
        prev.disabled = true;
      } else {
        removeClass(first2, "ht-page-navigation-section__button--disabled");
        removeClass(prev, "ht-page-navigation-section__button--disabled");
        first2.disabled = false;
        prev.disabled = false;
      }
      if (isLastPage) {
        addClass(next, "ht-page-navigation-section__button--disabled");
        addClass(last2, "ht-page-navigation-section__button--disabled");
        next.disabled = true;
        last2.disabled = true;
      } else {
        removeClass(next, "ht-page-navigation-section__button--disabled");
        removeClass(last2, "ht-page-navigation-section__button--disabled");
        next.disabled = false;
        last2.disabled = false;
      }
      if ([
        first2,
        prev,
        next,
        last2
      ].includes(activeElement)) {
        if (prev.disabled) {
          next.focus();
        } else if (next.disabled) {
          prev.focus();
        }
      }
    }
    setAttribute(first2, [
      ...[
        A11Y_LABEL(_class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_FIRST_PAGE))
      ],
      ...[
        A11Y_DISABLED(isFirstPage)
      ]
    ]);
    setAttribute(prev, [
      ...[
        A11Y_LABEL(_class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_PREV_PAGE))
      ],
      ...[
        A11Y_DISABLED(isFirstPage)
      ]
    ]);
    setAttribute(next, [
      ...[
        A11Y_LABEL(_class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_NEXT_PAGE))
      ],
      ...[
        A11Y_DISABLED(isLastPage)
      ]
    ]);
    setAttribute(last2, [
      ...[
        A11Y_LABEL(_class_private_field_get$f(this, _phraseTranslator).call(this, PAGINATION_LAST_PAGE))
      ],
      ...[
        A11Y_DISABLED(isLastPage)
      ]
    ]);
    return this;
  }
  /**
  * Sets the visibility of the page size section.
  *
  * @param {boolean} isVisible True to show the page size section, false to hide it.
  * @returns {PaginationUI} The instance of the PaginationUI for method chaining.
  */
  setPageSizeSectionVisibility(isVisible2) {
    const { pageSizeSection, pageSizeSelect } = _class_private_field_get$f(this, _refs$2);
    pageSizeSection.style.display = isVisible2 ? "" : "none";
    pageSizeSelect.disabled = !isVisible2;
    _class_private_method_get$7(this, _updateContainerVisibility, updateContainerVisibility).call(this);
    return this;
  }
  /**
  * Sets the visibility of the page counter section.
  *
  * @param {boolean} isVisible True to show the page size section, false to hide it.
  * @returns {PaginationUI} The instance of the PaginationUI for method chaining.
  */
  setCounterSectionVisibility(isVisible2) {
    _class_private_field_get$f(this, _refs$2).pageCounterSection.style.display = isVisible2 ? "" : "none";
    _class_private_method_get$7(this, _updateContainerVisibility, updateContainerVisibility).call(this);
    return this;
  }
  /**
  * Sets the visibility of the page navigation section.
  *
  * @param {boolean} isVisible True to show the page size section, false to hide it.
  * @returns {PaginationUI} The instance of the PaginationUI for method chaining.
  */
  setNavigationSectionVisibility(isVisible2) {
    const { pageNavSection, first: first2, prev, next, last: last2 } = _class_private_field_get$f(this, _refs$2);
    pageNavSection.style.display = isVisible2 ? "" : "none";
    first2.disabled = !isVisible2;
    prev.disabled = !isVisible2;
    next.disabled = !isVisible2;
    last2.disabled = !isVisible2;
    _class_private_method_get$7(this, _updateContainerVisibility, updateContainerVisibility).call(this);
    return this;
  }
  /**
  * Removes the pagination UI elements from the DOM and clears the refs.
  */
  destroy() {
    _class_private_field_get$f(this, _refs$2)?.container.remove();
    _class_private_field_set$f(this, _refs$2, null);
  }
  /**
  * Initializes the pagination UI by creating DOM elements, applying layout settings, and registering event listeners.
  */
  constructor({ rootElement, uiContainer, isRtl: isRtl2, themeName, phraseTranslator, a11yAnnouncer }) {
    _class_private_method_init$7(this, _updateContainerVisibility);
    _class_private_field_init$f(this, _rootElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$f(this, _uiContainer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$f(this, _isRtl$2, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$f(this, _refs$2, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$f(this, _themeName, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$f(this, _phraseTranslator, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$f(this, _a11yAnnouncer, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$f(this, _isRtl$2, false);
    _class_private_field_set$f(this, _refs$2, null);
    _class_private_field_set$f(this, _rootElement, rootElement);
    _class_private_field_set$f(this, _uiContainer, uiContainer);
    _class_private_field_set$f(this, _isRtl$2, isRtl2);
    _class_private_field_set$f(this, _themeName, themeName);
    _class_private_field_set$f(this, _phraseTranslator, phraseTranslator);
    _class_private_field_set$f(this, _a11yAnnouncer, a11yAnnouncer);
    this.install();
  }
}
function updateContainerVisibility() {
  const { container, pageSizeSection, pageCounterSection, pageNavSection } = _class_private_field_get$f(this, _refs$2);
  const isSectionVisible = pageSizeSection.style.display !== "none" || pageCounterSection.style.display !== "none" || pageNavSection.style.display !== "none";
  if (!_class_private_field_get$f(this, _uiContainer)) {
    if (isSectionVisible) {
      addClass(_class_private_field_get$f(this, _rootElement).querySelector(".ht-wrapper"), "htPagination");
    } else {
      removeClass(_class_private_field_get$f(this, _rootElement).querySelector(".ht-wrapper"), "htPagination");
    }
  }
  container.style.display = isSectionVisible ? "" : "none";
}
mixin(PaginationUI, localHooks);
class FixedPageSizeStrategy {
  /**
  * Calculates the state of pagination.
  *
  * @param {object} options Options for pagination calculation.
  * @param {number} options.pageSize The fixed number of items per page.
  * @param {number} options.totalItems The total number of items in the dataset.
  */
  calculate({ pageSize, totalItems }) {
    this.pageSize = Math.max(pageSize, 1);
    this.totalItems = totalItems;
    this.totalPages = Math.max(1, Math.ceil(this.totalItems / this.pageSize));
  }
  /**
  * Gets the total number of pages.
  *
  * @returns {number} The total number of pages.
  */
  getTotalPages() {
    return this.totalPages;
  }
  /**
  * Gets the state of a specific page.
  *
  * @param {number} currentPage The current page number (1-based index).
  * @returns {PageInfo | undefined}
  */
  getState(currentPage) {
    currentPage -= 1;
    if (currentPage < 0 || currentPage >= this.getTotalPages()) {
      return;
    }
    const startIndex = currentPage * this.pageSize;
    const endIndex = Math.max(0, Math.min(startIndex + this.pageSize - 1, this.totalItems - 1));
    return {
      startIndex,
      endIndex,
      pageSize: this.pageSize
    };
  }
  constructor() {
    this.pageSize = 1;
    this.totalItems = 0;
    this.totalPages = 0;
  }
}
class AutoPageSizeStrategy {
  /**
  * Calculates the state of pagination.
  *
  * @param {object} options Options for pagination calculation.
  * @param {function(): number[]} options.itemsSizeProvider A function that returns an array of item sizes.
  * @param {function(): number} options.viewportSizeProvider A function that returns the size of the viewport in pixels.
  */
  calculate({ itemsSizeProvider, viewportSizeProvider }) {
    const itemSizes = itemsSizeProvider();
    const viewportSize = viewportSizeProvider();
    const pages = [];
    let startIndex = 0;
    let totalSize = 0;
    let pageSize = 0;
    for (let index2 = 0; index2 < itemSizes.length; index2++) {
      const itemSize = itemSizes[index2];
      if (pageSize > 0 && totalSize + itemSize >= viewportSize) {
        pages.push({
          startIndex,
          endIndex: index2 - 1,
          pageSize
        });
        startIndex = index2;
        totalSize = 0;
        pageSize = 0;
      }
      totalSize += itemSize;
      pageSize += 1;
    }
    pages.push({
      startIndex,
      endIndex: Math.max(0, itemSizes.length - 1),
      pageSize
    });
    this.pages = pages;
  }
  /**
  * Gets the total number of pages.
  *
  * @returns {number} The total number of pages.
  */
  getTotalPages() {
    return this.pages.length;
  }
  /**
  * Gets the state of a specific page.
  *
  * @param {number} currentPage The current page number (1-based index).
  * @returns {PageInfo | undefined}
  */
  getState(currentPage) {
    currentPage -= 1;
    if (currentPage < 0 || currentPage >= this.getTotalPages()) {
      return;
    }
    return this.pages[currentPage];
  }
  constructor() {
    this.pages = [];
  }
}
const strategies = /* @__PURE__ */ new Map([
  [
    "fixed",
    FixedPageSizeStrategy
  ],
  [
    "auto",
    AutoPageSizeStrategy
  ]
]);
function createPaginatorStrategy(strategyType) {
  if (!strategies.has(strategyType)) {
    throwWithCause(`Unknown pagination strategy type: ${strategyType}`);
  }
  const Strategy = strategies.get(strategyType);
  return new Strategy();
}
function _check_private_redeclaration$e(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$e(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$e(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$e(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$e(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$e(receiver, privateMap, "get");
  return _class_apply_descriptor_get$e(receiver, descriptor);
}
function _class_private_field_init$e(obj, privateMap, value) {
  _check_private_redeclaration$e(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$e(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$e(receiver, privateMap, "set");
  _class_apply_descriptor_set$e(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$6(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$6(obj, privateSet) {
  _check_private_redeclaration$e(obj, privateSet);
  privateSet.add(obj);
}
registerConflict("pagination", [
  "nestedRows",
  "mergeCells",
  "fixedRowsTop",
  "fixedRowsBottom"
]);
const PLUGIN_KEY$9 = "pagination";
const PLUGIN_PRIORITY$9 = 900;
const SHORTCUTS_CONTEXT_NAME$3 = `plugin:${PLUGIN_KEY$9}`;
const LAYOUT_WEIGHT = 100;
const AUTO_PAGE_SIZE_WARNING = toSingleLine`The \`auto\` page size setting requires the \`autoRowSize\`\x20
  plugin to be enabled. Set the \`autoRowSize: true\` in the configuration to ensure correct behavior.`;
var _pagedRowsMap = /* @__PURE__ */ new WeakMap(), _currentPage = /* @__PURE__ */ new WeakMap(), _pageSize = /* @__PURE__ */ new WeakMap(), _ui$3 = /* @__PURE__ */ new WeakMap(), _calcStrategy = /* @__PURE__ */ new WeakMap(), _internalExecutionCall = /* @__PURE__ */ new WeakMap(), _internalRenderCall = /* @__PURE__ */ new WeakMap(), _isDataProviderActive = /* @__PURE__ */ new WeakMap(), _serverSideTotalCount = /* @__PURE__ */ new WeakMap(), _onAfterDataProviderFetch = /* @__PURE__ */ new WeakMap(), _setCurrentPage = /* @__PURE__ */ new WeakSet(), _setPageSizeValue = /* @__PURE__ */ new WeakSet(), _refreshUI = /* @__PURE__ */ new WeakSet(), _updateSectionsVisibilityState = /* @__PURE__ */ new WeakSet(), _computeAndApplyState = /* @__PURE__ */ new WeakSet(), _registerFocusScope$3 = /* @__PURE__ */ new WeakSet(), _unregisterFocusScope$3 = /* @__PURE__ */ new WeakSet(), _onBeforeSelectAllRows = /* @__PURE__ */ new WeakMap(), _onBeforeSetRangeEnd = /* @__PURE__ */ new WeakMap(), _onBeforeSelectionHighlightSet = /* @__PURE__ */ new WeakMap(), _onBeforePaste = /* @__PURE__ */ new WeakMap(), _onAfterViewRender$2 = /* @__PURE__ */ new WeakMap(), _onBeforeHeightChange = /* @__PURE__ */ new WeakMap(), _onInit = /* @__PURE__ */ new WeakMap(), _onAfterLanguageChange = /* @__PURE__ */ new WeakMap(), _onAfterSetTheme = /* @__PURE__ */ new WeakMap(), _onIndexCacheUpdate = /* @__PURE__ */ new WeakMap();
class Pagination extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$9;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$9;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      pageSize: 10,
      pageSizeList: [
        "auto",
        5,
        10,
        20,
        50,
        100
      ],
      initialPage: 1,
      showPageSize: true,
      showCounter: true,
      showNavigation: true,
      uiContainer: null
    };
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` than the {@link Pagination#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$9];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const settings = this.hot.getSettings()[PLUGIN_KEY$9];
    if (settings?.initialPage !== void 0) {
      _class_private_field_set$e(this, _currentPage, this.getSetting("initialPage"));
    }
    if (settings?.pageSize !== void 0) {
      _class_private_field_set$e(this, _pageSize, this.getSetting("pageSize"));
    }
    _class_private_field_set$e(this, _isDataProviderActive, this.hot.runHooks("hasExternalDataSource") === true);
    _class_private_field_set$e(this, _serverSideTotalCount, null);
    _class_private_field_set$e(this, _pagedRowsMap, this.hot.rowIndexMapper.createAndRegisterIndexMap(this.pluginName, "hiding", false));
    if (_class_private_field_get$e(this, _pageSize) === "auto" && !this.hot.getPlugin("autoRowSize")?.enabled) {
      warn$1(AUTO_PAGE_SIZE_WARNING);
    }
    _class_private_field_set$e(this, _calcStrategy, createPaginatorStrategy(_class_private_field_get$e(this, _pageSize) === "auto" ? "auto" : "fixed"));
    if (!_class_private_field_get$e(this, _ui$3)) {
      _class_private_field_set$e(this, _ui$3, new PaginationUI({
        rootElement: this.hot.rootGridElement,
        uiContainer: this.getSetting("uiContainer"),
        isRtl: this.hot.isRtl(),
        themeName: this.hot.getCurrentThemeName(),
        phraseTranslator: (key, extraArguments) => this.hot.getTranslatedPhrase(key, extraArguments),
        a11yAnnouncer: (message) => announce(String(message ?? ""))
      }));
      _class_private_method_get$6(this, _updateSectionsVisibilityState, updateSectionsVisibilityState).call(this);
      _class_private_field_get$e(this, _ui$3).addLocalHook("firstPageClick", () => this.firstPage()).addLocalHook("prevPageClick", () => this.prevPage()).addLocalHook("nextPageClick", () => this.nextPage()).addLocalHook("lastPageClick", () => this.lastPage()).addLocalHook("pageSizeChange", (pageSize) => this.setPageSize(pageSize));
    }
    if (isRootInstance(this.hot) && !this.getSetting("uiContainer")) {
      this.hot.getLayoutManager().register(PLUGIN_KEY$9, _class_private_field_get$e(this, _ui$3).getContainer(), {
        side: "bottom",
        weight: LAYOUT_WEIGHT
      });
    }
    this.addHook("init", _class_private_field_get$e(this, _onInit), -1);
    this.addHook("beforeSelectAll", _class_private_field_get$e(this, _onBeforeSelectAllRows));
    this.addHook("beforeSelectColumns", _class_private_field_get$e(this, _onBeforeSelectAllRows));
    this.addHook("beforeSetRangeEnd", _class_private_field_get$e(this, _onBeforeSetRangeEnd));
    this.addHook("beforeSelectionHighlightSet", _class_private_field_get$e(this, _onBeforeSelectionHighlightSet));
    this.addHook("beforePaste", _class_private_field_get$e(this, _onBeforePaste));
    this.addHook("afterViewRender", _class_private_field_get$e(this, _onAfterViewRender$2));
    this.addHook("afterLanguageChange", _class_private_field_get$e(this, _onAfterLanguageChange));
    this.addHook("beforeHeightChange", _class_private_field_get$e(this, _onBeforeHeightChange));
    this.addHook("afterSetTheme", _class_private_field_get$e(this, _onAfterSetTheme));
    this.addHook("afterDataProviderFetch", _class_private_field_get$e(this, _onAfterDataProviderFetch), -1);
    this.hot.rowIndexMapper.addLocalHook("cacheUpdated", _class_private_field_get$e(this, _onIndexCacheUpdate));
    _class_private_method_get$6(this, _registerFocusScope$3, registerFocusScope$3).call(this);
    super.enablePlugin();
  }
  /**
  * Restores the page after a failed external load.
  *
  * @param {number} previousPage Page to restore (1-based).
  * @category Pagination
  */
  revertPageTo(previousPage) {
    const attemptedPage = _class_private_field_get$e(this, _currentPage);
    _class_private_method_get$6(this, _setCurrentPage, setCurrentPage).call(this, previousPage);
    this.hot.scrollViewportTo({
      row: 0
    });
    _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    this.hot.runHooks("afterPageChange", attemptedPage, previousPage);
  }
  /**
  * Restores the page size after a failed external load.
  *
  * @param {number | 'auto'} previousPageSize Previous page size.
  * @category Pagination
  */
  revertPageSizeTo(previousPageSize) {
    const attemptedPageSize = _class_private_field_get$e(this, _pageSize);
    _class_private_method_get$6(this, _setPageSizeValue, setPageSizeValue).call(this, previousPageSize);
    _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    this.hot.runHooks("afterPageSizeChange", attemptedPageSize, previousPageSize);
  }
  /**
  * Updates the plugin state. This method is executed when {@link Core#updateSettings} is invoked.
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.hot.rowIndexMapper.removeLocalHook("cacheUpdated", _class_private_field_get$e(this, _onIndexCacheUpdate)).unregisterMap(this.pluginName);
    _class_private_method_get$6(this, _unregisterFocusScope$3, unregisterFocusScope$3).call(this);
    if (isRootInstance(this.hot)) {
      this.hot.getLayoutManager().unregister(PLUGIN_KEY$9, "bottom");
    }
    _class_private_field_get$e(this, _ui$3)?.destroy();
    _class_private_field_set$e(this, _ui$3, null);
    super.disablePlugin();
  }
  /**
  * Gets the pagination current state. Returns an object with the following properties:
  *  - `currentPage`: The current page number.
  *  - `totalPages`: The total number of pages.
  *  - `pageSize`: The page size.
  *  - `pageSizeList`: The list of page sizes.
  *  - `autoPageSize`: Whether the page size is calculated automatically.
  *  - `numberOfRenderedRows`: The number of rendered rows.
  *  - `firstVisibleRowIndex`: The index of the first visible row.
  *  - `lastVisibleRowIndex`: The index of the last visible row.
  *
  * @returns {{
  *   currentPage: number,
  *   totalPages: number,
  *   pageSize: number,
  *   pageSizeList: Array<number | 'auto'>,
  *   autoPageSize: boolean,
  *   numberOfRenderedRows: number,
  *   firstVisibleRowIndex: number,
  *   lastVisibleRowIndex: number
  * }}
  */
  getPaginationData() {
    const totalPages = _class_private_field_get$e(this, _calcStrategy)?.getTotalPages() ?? 0;
    let firstVisibleRowIndex = -1;
    let lastVisibleRowIndex = -1;
    if (_class_private_field_get$e(this, _isDataProviderActive)) {
      const countRows = this.hot.countRows();
      if (countRows > 0) {
        firstVisibleRowIndex = 0;
        lastVisibleRowIndex = countRows - 1;
      }
    } else {
      const state = _class_private_field_get$e(this, _calcStrategy)?.getState(_class_private_field_get$e(this, _currentPage));
      if (!state) {
        return {
          currentPage: _class_private_field_get$e(this, _currentPage),
          totalPages: 0,
          pageSize: 0,
          pageSizeList: [],
          autoPageSize: false,
          numberOfRenderedRows: 0,
          firstVisibleRowIndex,
          lastVisibleRowIndex
        };
      }
      const { pageSize, startIndex } = state;
      const countRows = this.hot.countRows();
      let visibleCount = 0;
      let rowIndex = startIndex;
      while (visibleCount < pageSize) {
        if (rowIndex >= countRows) {
          break;
        }
        if (this.hot.rowIndexMapper.isHidden(this.hot.toPhysicalRow(rowIndex))) {
          rowIndex += 1;
          continue;
        }
        if (firstVisibleRowIndex === -1) {
          firstVisibleRowIndex = rowIndex;
        }
        lastVisibleRowIndex = rowIndex;
        visibleCount += 1;
        rowIndex += 1;
      }
    }
    const stateForReturn = _class_private_field_get$e(this, _calcStrategy)?.getState(_class_private_field_get$e(this, _currentPage));
    return {
      currentPage: _class_private_field_get$e(this, _currentPage),
      totalPages,
      pageSize: stateForReturn?.pageSize ?? _class_private_field_get$e(this, _pageSize),
      pageSizeList: [
        ...this.getSetting("pageSizeList") ?? []
      ],
      autoPageSize: _class_private_field_get$e(this, _pageSize) === "auto",
      numberOfRenderedRows: this.hot.rowIndexMapper.getRenderableIndexesLength(),
      firstVisibleRowIndex,
      lastVisibleRowIndex
    };
  }
  /**
  * Returns the current 1-based page index from internal pagination state.
  *
  * @returns {number} Current page (at least 1).
  */
  getCurrentPage() {
    return _class_private_field_get$e(this, _currentPage);
  }
  /**
  * Returns the current page size from internal pagination state. May be `'auto'`.
  *
  * @returns {number | 'auto'} Current page size or `'auto'`.
  */
  getCurrentPageSize() {
    return _class_private_field_get$e(this, _pageSize);
  }
  /**
  * Allows changing the page for specified page number.
  *
  * @param {number} pageNumber The page number to set (from 1 to N). If `0` is passed, it
  * will be transformed to `1`.
  * @fires Hooks#beforePageChange
  * @fires Hooks#afterPageChange
  */
  setPage(pageNumber) {
    const oldPage = _class_private_field_get$e(this, _currentPage);
    const shouldProceed = this.hot.runHooks("beforePageChange", oldPage, pageNumber);
    if (shouldProceed === false) {
      return;
    }
    _class_private_method_get$6(this, _setCurrentPage, setCurrentPage).call(this, pageNumber);
    _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    this.hot.scrollViewportTo({
      row: 0
    });
    this.hot.runHooks("afterPageChange", oldPage, _class_private_field_get$e(this, _currentPage));
  }
  /**
  * Resets the current page to the initial page (`initialValue`) defined in the settings.
  */
  resetPage() {
    this.setPage(this.getSetting("initialPage"));
  }
  /**
  * Changes the page size for the pagination. The method recalculates the state based
  * on the new page size and re-renders the table. If `'auto'` is passed, the plugin will
  * calculate the page size based on the viewport size and row heights to make sure
  * that there will be no vertical scrollbar in the table.
  *
  * @param {number | 'auto'} pageSize The page size to set.
  * @fires Hooks#beforePageSizeChange
  * @fires Hooks#afterPageSizeChange
  */
  setPageSize(pageSize) {
    const oldPageSize = _class_private_field_get$e(this, _pageSize);
    const shouldProceed = this.hot.runHooks("beforePageSizeChange", oldPageSize, pageSize);
    if (shouldProceed === false) {
      return;
    }
    if (pageSize === "auto" && !this.hot.getPlugin("autoRowSize")?.enabled) {
      warn$1(AUTO_PAGE_SIZE_WARNING);
    }
    _class_private_method_get$6(this, _setPageSizeValue, setPageSizeValue).call(this, pageSize);
    _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    this.hot.runHooks("afterPageSizeChange", oldPageSize, _class_private_field_get$e(this, _pageSize));
  }
  /**
  * Resets the page size to the initial value (`pageSize`) defined in the settings.
  */
  resetPageSize() {
    this.setPageSize(this.getSetting("pageSize"));
  }
  /**
  * Resets the pagination state to the initial values defined in the settings.
  */
  resetPagination() {
    this.resetPage();
    this.resetPageSize();
    _class_private_method_get$6(this, _updateSectionsVisibilityState, updateSectionsVisibilityState).call(this);
  }
  /**
  * Switches the page to the next one.
  */
  nextPage() {
    this.setPage(_class_private_field_get$e(this, _currentPage) + 1);
  }
  /**
  * Switches the page to the previous one.
  */
  prevPage() {
    this.setPage(_class_private_field_get$e(this, _currentPage) - 1);
  }
  /**
  * Switches the page to the first one.
  */
  firstPage() {
    this.setPage(1);
  }
  /**
  * Switches the page to the last one.
  */
  lastPage() {
    this.setPage(_class_private_field_get$e(this, _calcStrategy)?.getTotalPages() ?? 1);
  }
  /**
  * Checks, based on the current internal state, if there is a previous page.
  *
  * @returns {boolean}
  */
  hasPreviousPage() {
    return _class_private_field_get$e(this, _currentPage) > 1;
  }
  /**
  * Checks, based on the current internal state, if there is a next page.
  *
  * @returns {boolean}
  */
  hasNextPage() {
    return _class_private_field_get$e(this, _currentPage) < (_class_private_field_get$e(this, _calcStrategy)?.getTotalPages() ?? 0);
  }
  /**
  * Gets the visual data for the current page. The returned data may be longer than the defined
  * page size as the data may contain hidden rows (rows that are not rendered in the table).
  *
  * @returns {Array<Array>} Returns the data for the current page.
  */
  getCurrentPageData() {
    const { firstVisibleRowIndex, lastVisibleRowIndex } = this.getPaginationData();
    if (firstVisibleRowIndex === -1 || lastVisibleRowIndex === -1) {
      return [];
    }
    return this.hot.getData(firstVisibleRowIndex, 0, lastVisibleRowIndex, this.hot.countCols() - 1);
  }
  /**
  * Shows the page size section in the pagination UI.
  *
  * @fires Hooks#afterPageSizeVisibilityChange
  */
  showPageSizeSection() {
    _class_private_field_get$e(this, _ui$3)?.setPageSizeSectionVisibility(true);
    this.hot.runHooks("afterPageSizeVisibilityChange", true);
  }
  /**
  * Hides the page size section in the pagination UI.
  *
  * @fires Hooks#afterPageSizeVisibilityChange
  */
  hidePageSizeSection() {
    _class_private_field_get$e(this, _ui$3)?.setPageSizeSectionVisibility(false);
    this.hot.runHooks("afterPageSizeVisibilityChange", false);
  }
  /**
  * Shows the page counter section in the pagination UI.
  *
  * @fires Hooks#afterPageCounterVisibilityChange
  */
  showPageCounterSection() {
    _class_private_field_get$e(this, _ui$3)?.setCounterSectionVisibility(true);
    this.hot.runHooks("afterPageCounterVisibilityChange", true);
  }
  /**
  * Hides the page counter section in the pagination UI.
  *
  * @fires Hooks#afterPageCounterVisibilityChange
  */
  hidePageCounterSection() {
    _class_private_field_get$e(this, _ui$3)?.setCounterSectionVisibility(false);
    this.hot.runHooks("afterPageCounterVisibilityChange", false);
  }
  /**
  * Shows the page navigation section in the pagination UI.
  *
  * @fires Hooks#afterPageNavigationVisibilityChange
  */
  showPageNavigationSection() {
    _class_private_field_get$e(this, _ui$3)?.setNavigationSectionVisibility(true);
    this.hot.runHooks("afterPageNavigationVisibilityChange", true);
  }
  /**
  * Hides the page navigation section in the pagination UI.
  *
  * @fires Hooks#afterPageNavigationVisibilityChange
  */
  hidePageNavigationSection() {
    _class_private_field_get$e(this, _ui$3)?.setNavigationSectionVisibility(false);
    this.hot.runHooks("afterPageNavigationVisibilityChange", false);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_set$e(this, _pagedRowsMap, null);
    _class_private_field_set$e(this, _calcStrategy, null);
    _class_private_field_get$e(this, _ui$3)?.destroy();
    _class_private_field_set$e(this, _ui$3, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$6(this, _setCurrentPage), _class_private_method_init$6(this, _setPageSizeValue), _class_private_method_init$6(this, _refreshUI), _class_private_method_init$6(this, _updateSectionsVisibilityState), _class_private_method_init$6(this, _computeAndApplyState), _class_private_method_init$6(this, _registerFocusScope$3), _class_private_method_init$6(this, _unregisterFocusScope$3), _class_private_field_init$e(this, _pagedRowsMap, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _currentPage, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _pageSize, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _ui$3, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _calcStrategy, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _internalExecutionCall, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _internalRenderCall, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _isDataProviderActive, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _serverSideTotalCount, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onAfterDataProviderFetch, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onBeforeSelectAllRows, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onBeforeSetRangeEnd, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onBeforeSelectionHighlightSet, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onBeforePaste, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onAfterViewRender$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onBeforeHeightChange, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onInit, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onAfterLanguageChange, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onAfterSetTheme, {
      writable: true,
      value: void 0
    }), _class_private_field_init$e(this, _onIndexCacheUpdate, {
      writable: true,
      value: void 0
    }), _class_private_field_set$e(this, _pagedRowsMap, null), _class_private_field_set$e(this, _currentPage, 1), _class_private_field_set$e(this, _pageSize, 10), _class_private_field_set$e(this, _ui$3, null), _class_private_field_set$e(this, _calcStrategy, null), _class_private_field_set$e(this, _internalExecutionCall, false), _class_private_field_set$e(this, _internalRenderCall, false), _class_private_field_set$e(this, _isDataProviderActive, false), _class_private_field_set$e(this, _serverSideTotalCount, null), _class_private_field_set$e(this, _onAfterDataProviderFetch, ({ queryParameters, totalRows }) => {
      if (!_class_private_field_get$e(this, _isDataProviderActive)) {
        return;
      }
      const oldPage = _class_private_field_get$e(this, _currentPage);
      const oldPageSize = _class_private_field_get$e(this, _pageSize);
      const { page, pageSize } = queryParameters;
      if (typeof page === "number" && page >= 1) {
        _class_private_method_get$6(this, _setCurrentPage, setCurrentPage).call(this, page);
      }
      if (pageSize === "auto") {
        _class_private_method_get$6(this, _setPageSizeValue, setPageSizeValue).call(this, "auto");
      } else if (typeof pageSize === "number" && pageSize >= 1) {
        _class_private_method_get$6(this, _setPageSizeValue, setPageSizeValue).call(this, pageSize);
      }
      if (_class_private_field_get$e(this, _isDataProviderActive) && typeof totalRows === "number" && totalRows >= 0) {
        _class_private_field_set$e(this, _serverSideTotalCount, totalRows);
      }
      _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
      if (oldPage !== _class_private_field_get$e(this, _currentPage)) {
        this.hot.runHooks("afterPageChange", oldPage, _class_private_field_get$e(this, _currentPage));
      }
      if (oldPageSize !== _class_private_field_get$e(this, _pageSize)) {
        this.hot.runHooks("afterPageSizeChange", oldPageSize, _class_private_field_get$e(this, _pageSize));
      }
    }), _class_private_field_set$e(this, _onBeforeSelectAllRows, (from, to) => {
      const { firstVisibleRowIndex, lastVisibleRowIndex } = this.getPaginationData();
      if (_class_private_field_get$e(this, _currentPage) > 1 || from.row >= 0) {
        from.row = firstVisibleRowIndex;
      }
      to.row = lastVisibleRowIndex;
    }), _class_private_field_set$e(this, _onBeforeSetRangeEnd, (coords) => {
      if (this.hot.selection.isSelectedByColumnHeader()) {
        const { lastVisibleRowIndex } = this.getPaginationData();
        coords.row = lastVisibleRowIndex;
      }
    }), _class_private_field_set$e(this, _onBeforeSelectionHighlightSet, () => {
      if (!this.hot.getSettings().navigableHeaders) {
        return;
      }
      const selectedRange = this.hot.getSelectedRangeLast();
      if (!selectedRange) {
        return;
      }
      if (!selectedRange.isSingle()) {
        const { highlight } = selectedRange;
        const topRow = selectedRange.getTopStartCorner().row;
        const bottomRow = selectedRange.getBottomEndCorner().row;
        if (highlight.row !== null && topRow !== null && bottomRow !== null) {
          highlight.row = clamp(highlight.row, topRow, bottomRow);
        }
      }
    }), _class_private_field_set$e(this, _onBeforePaste, (pastedData, ranges) => {
      const { firstVisibleRowIndex, lastVisibleRowIndex } = this.getPaginationData();
      if (firstVisibleRowIndex === -1 || lastVisibleRowIndex === -1) {
        return false;
      }
      ranges.forEach(({ startRow }) => {
        if (pastedData.length === 0) {
          return;
        }
        const rowsToRemove = Math.min(pastedData.length - (lastVisibleRowIndex - startRow + 1), pastedData.length);
        pastedData.splice(0, rowsToRemove);
      });
    }), _class_private_field_set$e(this, _onAfterViewRender$2, () => {
      if (_class_private_field_get$e(this, _pageSize) !== "auto" || _class_private_field_get$e(this, _internalRenderCall)) {
        _class_private_field_set$e(this, _internalRenderCall, false);
        return;
      }
      _class_private_field_set$e(this, _internalRenderCall, true);
      _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    }), _class_private_field_set$e(this, _onBeforeHeightChange, (height) => {
      if (this.getSetting("uiContainer")) {
        return height;
      }
      const isPixelValue = typeof height === "number" || typeof height === "string" && /^\d+$/.test(height) || typeof height === "string" && height.endsWith("px");
      if (!isPixelValue) {
        return height;
      }
      const heightValue = typeof height === "string" && height.endsWith("px") ? height : `${height}px`;
      return `calc(${heightValue} - ${_class_private_field_get$e(this, _ui$3)?.getHeight()}px)`;
    }), _class_private_field_set$e(this, _onInit, () => {
      if (_class_private_field_get$e(this, _pageSize) === "auto") {
        return;
      }
      _class_private_method_get$6(this, _computeAndApplyState, computeAndApplyState).call(this);
    }), _class_private_field_set$e(this, _onAfterLanguageChange, () => {
      _class_private_method_get$6(this, _refreshUI, refreshUI).call(this);
    }), _class_private_field_set$e(this, _onAfterSetTheme, (themeName) => {
      _class_private_field_get$e(this, _ui$3)?.updateTheme(themeName);
    }), _class_private_field_set$e(this, _onIndexCacheUpdate, () => {
      if (!_class_private_field_get$e(this, _internalExecutionCall) && this.hot?.view) {
        _class_private_method_get$6(this, _computeAndApplyState, computeAndApplyState).call(this);
      }
    });
  }
}
function setCurrentPage(page) {
  _class_private_field_set$e(this, _currentPage, page);
}
function setPageSizeValue(pageSize) {
  _class_private_field_set$e(this, _calcStrategy, createPaginatorStrategy(pageSize === "auto" ? "auto" : "fixed"));
  _class_private_field_set$e(this, _pageSize, pageSize);
}
function refreshUI() {
  _class_private_method_get$6(this, _computeAndApplyState, computeAndApplyState).call(this);
  this.hot.view.adjustElementsSize();
  this.hot.render();
}
function updateSectionsVisibilityState() {
  if (this.getSetting("showPageSize")) {
    this.showPageSizeSection();
  } else {
    this.hidePageSizeSection();
  }
  if (this.getSetting("showCounter")) {
    this.showPageCounterSection();
  } else {
    this.hidePageCounterSection();
  }
  if (this.getSetting("showNavigation")) {
    this.showPageNavigationSection();
  } else {
    this.hidePageNavigationSection();
  }
}
function computeAndApplyState() {
  _class_private_field_set$e(this, _internalExecutionCall, true);
  _class_private_field_get$e(this, _pagedRowsMap)?.clear();
  const renderableIndexes = this.hot.rowIndexMapper.getRenderableIndexes();
  const renderableRowsLength = renderableIndexes.length;
  const { stylesHandler } = this.hot;
  const externalPagedMode = _class_private_field_get$e(this, _isDataProviderActive);
  const totalItems = externalPagedMode ? _class_private_field_get$e(this, _serverSideTotalCount) ?? renderableRowsLength : renderableRowsLength;
  _class_private_field_get$e(this, _calcStrategy)?.calculate({
    pageSize: _class_private_field_get$e(this, _pageSize),
    totalItems,
    viewportSizeProvider: () => {
      const view = this.hot.view;
      if (view.isVerticallyScrollableByWindow()) {
        const bodyStyle = getComputedStyle(this.hot.rootDocument.body);
        const margin = Number.parseInt(bodyStyle.marginTop, 10) + Number.parseInt(bodyStyle.marginBottom, 10);
        const columnHeaderHeight = this.hot.hasColHeaders() ? view._wt.wtViewport.getColumnHeaderHeight() : 0;
        const paginationContainerHeight = _class_private_field_get$e(this, _ui$3)?.getHeight();
        const workspaceHeight = view.getWorkspaceHeight();
        return workspaceHeight - (paginationContainerHeight ?? 0) - columnHeaderHeight - margin;
      }
      const scrollbarWidth = view.hasHorizontalScroll() ? getScrollbarWidth() : 0;
      return view.getViewportHeight() - scrollbarWidth;
    },
    itemsSizeProvider: () => {
      const rowHeights = this.hot.rowIndexMapper.getRenderableIndexes().map((physicalIndex) => {
        const visualRowIndex = this.hot.toVisualRow(physicalIndex);
        return this.hot.getRowHeight(visualRowIndex) ?? stylesHandler.getDefaultRowHeight(visualRowIndex);
      });
      return rowHeights;
    }
  });
  const totalPages = _class_private_field_get$e(this, _calcStrategy)?.getTotalPages();
  _class_private_field_set$e(this, _currentPage, clamp(_class_private_field_get$e(this, _currentPage), 1, totalPages ?? 1));
  if (!externalPagedMode && renderableIndexes.length > 0) {
    const pageState = _class_private_field_get$e(this, _calcStrategy)?.getState(_class_private_field_get$e(this, _currentPage));
    if (pageState) {
      const { startIndex, pageSize } = pageState;
      renderableIndexes.splice(startIndex, pageSize);
    }
  }
  if (!externalPagedMode && renderableIndexes.length > 0) {
    this.hot.batchExecution(() => {
      renderableIndexes.forEach((index2) => _class_private_field_get$e(this, _pagedRowsMap)?.setValueAtIndex(index2, true));
    }, true);
  } else if (!externalPagedMode) {
    this.hot.rowIndexMapper.updateCache(true);
  }
  _class_private_field_set$e(this, _internalExecutionCall, false);
  const paginationData = this.getPaginationData();
  const uiState = {
    ...paginationData,
    totalRenderedRows: externalPagedMode ? totalItems : renderableRowsLength
  };
  if (externalPagedMode) {
    const totalRows = totalItems;
    const pageSize = _class_private_field_get$e(this, _calcStrategy)?.getState(_class_private_field_get$e(this, _currentPage))?.pageSize ?? _class_private_field_get$e(this, _pageSize);
    uiState.counterStartRow = (_class_private_field_get$e(this, _currentPage) - 1) * pageSize + 1;
    uiState.counterEndRow = Math.min(_class_private_field_get$e(this, _currentPage) * pageSize, totalRows);
  }
  _class_private_field_get$e(this, _ui$3)?.updateState(uiState);
}
function registerFocusScope$3() {
  const container = _class_private_field_get$e(this, _ui$3)?.getContainer();
  if (!container) {
    return;
  }
  this.hot.getFocusScopeManager().registerScope(PLUGIN_KEY$9, container, {
    shortcutsContextName: SHORTCUTS_CONTEXT_NAME$3,
    runOnlyIf: () => Boolean(this.getSetting("showPageSize")) || Boolean(this.getSetting("showNavigation")),
    onActivate: (focusSource) => {
      const focusableElements = _class_private_field_get$e(this, _ui$3)?.getFocusableElements();
      if (focusableElements && focusableElements.length > 0) {
        if (focusSource === "tab_from_above") {
          focusableElements.at(0)?.focus();
        } else if (focusSource === "tab_from_below") {
          focusableElements.at(-1)?.focus();
        }
      }
    }
  });
}
function unregisterFocusScope$3() {
  this.hot.getFocusScopeManager().unregisterScope(PLUGIN_KEY$9);
}
function _check_private_redeclaration$d(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$d(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$d(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$d(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$d(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$d(receiver, privateMap, "get");
  return _class_apply_descriptor_get$d(receiver, descriptor);
}
function _class_private_field_init$d(obj, privateMap, value) {
  _check_private_redeclaration$d(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$d(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$d(receiver, privateMap, "set");
  _class_apply_descriptor_set$d(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$8 = "search";
const PLUGIN_PRIORITY$8 = 190;
const DEFAULT_SEARCH_RESULT_CLASS = "htSearchResult";
const DEFAULT_CALLBACK = function(instance, row, col, data, testResult) {
  instance.getCellMeta(row, col).isSearchResult = testResult;
};
const DEFAULT_QUERY_METHOD = function(query, value, cellProperties) {
  if (isUndefined$1(query) || query === null || !query.toLocaleLowerCase || query.length === 0) {
    return false;
  }
  if (isUndefined$1(value) || value === null) {
    return false;
  }
  const locale = cellProperties.locale;
  return localeLowerCase(String(value), locale).indexOf(localeLowerCase(query, locale)) !== -1;
};
var _onBeforeRenderer = /* @__PURE__ */ new WeakMap();
class Search extends BasePlugin {
  /**
  * Returns the plugin key used to identify and access this plugin within Handsontable.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$8;
  }
  /**
  * Returns the priority value that determines the plugin's initialization order relative to other plugins.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$8;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link AutoRowSize#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$8];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    const searchSettings = this.hot.getSettings()[PLUGIN_KEY$8];
    this.updatePluginSettings(searchSettings);
    this.addHook("beforeRenderer", _class_private_field_get$d(this, _onBeforeRenderer));
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    const beforeRendererCallback = (td, row, col, prop, value, cellProperties) => _class_private_field_get$d(this, _onBeforeRenderer).call(this, td, row, col, prop, value, cellProperties);
    this.hot.addHook("beforeRenderer", beforeRendererCallback);
    this.hot.addHookOnce("afterViewRender", () => {
      this.hot.removeHook("beforeRenderer", beforeRendererCallback);
    });
    super.disablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`search`](@/api/options.md#search)
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Makes the query.
  *
  * @param {string} queryStr Value to be search.
  * @param {Function} [callback] Callback function performed on cells with values which matches to the searched query.
  * @param {Function} [queryMethod] Query function responsible for determining whether a query matches the value stored in a cell.
  * @returns {object[]} Return an array of objects with `row`, `col`, `data` properties or empty array.
  */
  query(queryStr, callback = this.getCallback(), queryMethod = this.getQueryMethod()) {
    const rowCount = this.hot.countRows();
    const colCount = this.hot.countCols();
    const queryResult = [];
    const instance = this.hot;
    rangeEach(0, rowCount - 1, (rowIndex) => {
      rangeEach(0, colCount - 1, (colIndex) => {
        const cellData = this.hot.getDataAtCell(rowIndex, colIndex);
        const cellProperties = this.hot.getCellMeta(rowIndex, colIndex);
        const cellSearch = cellProperties.search;
        const cellCallback = cellSearch?.callback ?? callback;
        const cellQueryMethod = cellSearch?.queryMethod ?? queryMethod;
        const testResult = cellQueryMethod(queryStr, cellData, cellProperties);
        if (testResult) {
          const singleResult = {
            row: rowIndex,
            col: colIndex,
            data: cellData
          };
          queryResult.push(singleResult);
        }
        if (cellCallback) {
          cellCallback(instance, rowIndex, colIndex, cellData, testResult);
        }
      });
    });
    return queryResult;
  }
  /**
  * Gets the callback function.
  *
  * @returns {Function} Return the callback function.
  */
  getCallback() {
    return this.callback;
  }
  /**
  * Sets the callback function. This function will be called during querying for each cell.
  *
  * @param {Function} newCallback A callback function.
  */
  setCallback(newCallback) {
    this.callback = newCallback;
  }
  /**
  * Gets the query method function.
  *
  * @returns {Function} Return the query method.
  */
  getQueryMethod() {
    return this.queryMethod;
  }
  /**
  * Sets the query method function. The function is responsible for determining whether a query matches the value stored in a cell.
  *
  * @param {Function} newQueryMethod A function with specific match logic.
  */
  setQueryMethod(newQueryMethod) {
    this.queryMethod = newQueryMethod;
  }
  /**
  * Gets search result cells class name.
  *
  * @returns {string} Return the cell class name.
  */
  getSearchResultClass() {
    return this.searchResultClass;
  }
  /**
  * Sets search result cells class name. This class name will be added to each cell that belongs to the searched query.
  *
  * @param {string} newElementClass CSS class name.
  */
  setSearchResultClass(newElementClass) {
    this.searchResultClass = newElementClass;
  }
  /**
  * Updates the settings of the plugin.
  *
  * @param {object} searchSettings The plugin settings, taken from Handsontable configuration.
  * @private
  */
  updatePluginSettings(searchSettings) {
    if (isObject$1(searchSettings)) {
      if (searchSettings.searchResultClass) {
        this.setSearchResultClass(String(searchSettings.searchResultClass));
      }
      if (searchSettings.queryMethod) {
        this.setQueryMethod(searchSettings.queryMethod);
      }
      if (searchSettings.callback) {
        this.setCallback(searchSettings.callback);
      }
    }
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$d(this, _onBeforeRenderer, {
      writable: true,
      value: void 0
    }), /**
    * Function called during querying for each cell from the {@link DataMap}.
    *
    * @private
    * @type {Function}
    */
    this.callback = DEFAULT_CALLBACK, /**
    * Query function is responsible for determining whether a query matches the value stored in a cell.
    *
    * @private
    * @type {Function}
    */
    this.queryMethod = DEFAULT_QUERY_METHOD, /**
    * Class name added to each cell that belongs to the searched query.
    *
    * @private
    * @type {string}
    */
    this.searchResultClass = DEFAULT_SEARCH_RESULT_CLASS, _class_private_field_set$d(this, _onBeforeRenderer, (TD, row, col, prop, value, cellProperties) => {
      const className = cellProperties.className || [];
      let classArray = [];
      if (typeof className === "string") {
        classArray = className.split(" ");
      } else if (Array.isArray(className)) {
        classArray.push(...className);
      }
      if (this.isEnabled() && cellProperties.isSearchResult) {
        if (!classArray.includes(this.searchResultClass)) {
          classArray.push(`${this.searchResultClass}`);
        }
      } else if (classArray.includes(this.searchResultClass)) {
        classArray.splice(classArray.indexOf(this.searchResultClass), 1);
      }
      cellProperties.className = classArray.join(" ");
    });
  }
}
class StretchStrategy {
  /**
  * Prepares the strategy for the calculation.
  *
  * @param {StretchStrategyCalcArgs} calcArgs The calculation arguments.
  */
  prepare({ viewportWidth }) {
    this.viewportWidth = viewportWidth;
    this.baseWidths.clear();
    this.stretchedWidths.clear();
  }
  /**
  * Sets the base widths of the columns with which the strategy will work with.
  *
  * @param {number} columnVisualIndex The visual index of the column.
  * @param {number} columnWidth The width of the column.
  */
  setColumnBaseWidth(columnVisualIndex, columnWidth) {
    this.baseWidths.set(columnVisualIndex, columnWidth);
  }
  /**
  * Calculates the width of the column.
  */
  calculate() {
  }
  /**
  * Gets the calculated stretched column widths.
  *
  * @returns {Array<number[]>}
  */
  getWidths() {
    return Array.from(this.stretchedWidths);
  }
  /**
  * Initializes the stretch strategy with a function that overrides individual column widths during the stretch calculation.
  */
  constructor(overwriteColumnWidthFn2) {
    this.viewportWidth = 0;
    this.baseWidths = /* @__PURE__ */ new Map();
    this.stretchedWidths = /* @__PURE__ */ new Map();
    this.overwriteColumnWidthFn = overwriteColumnWidthFn2;
  }
}
class StretchAllStrategy extends StretchStrategy {
  /**
  * Calculates the columns widths.
  */
  calculate() {
    const allColumnsWidth = Array.from(this.baseWidths).reduce((sum2, [, width]) => sum2 + width, 0);
    const remainingViewportWidth = this.viewportWidth - allColumnsWidth;
    if (remainingViewportWidth < 0) {
      this.stretchedWidths.clear();
      return;
    }
    const initialStretchRatio = this.viewportWidth / allColumnsWidth;
    const stretchedWidths = [];
    const fixedColumns = [];
    let viewportWidth = this.viewportWidth;
    let allStretchedColumnsWidth = 0;
    this.baseWidths.forEach((columnWidth, columnVisualIndex) => {
      const stretchedWidth = Math.round(columnWidth * initialStretchRatio);
      const finalWidth = this.overwriteColumnWidthFn(stretchedWidth, columnVisualIndex);
      if (stretchedWidth === finalWidth && stretchedWidth >= DEFAULT_COLUMN_WIDTH) {
        stretchedWidths.push([
          columnVisualIndex,
          finalWidth
        ]);
        allStretchedColumnsWidth += finalWidth;
      } else if (stretchedWidth !== finalWidth) {
        stretchedWidths.push([
          columnVisualIndex,
          finalWidth
        ]);
        fixedColumns.push(columnVisualIndex);
        viewportWidth -= finalWidth;
      }
    });
    if (viewportWidth <= DEFAULT_COLUMN_WIDTH) {
      this.stretchedWidths.clear();
      return;
    }
    const finalStretchRatio = viewportWidth / allStretchedColumnsWidth;
    let lastColumnIndex = -1;
    let sumColumnsWithoutLastOne = 0;
    stretchedWidths.forEach(([columnVisualIndex, columnWidth], index2) => {
      let newWidth = columnWidth;
      if (!fixedColumns.includes(columnVisualIndex)) {
        newWidth = Math.round(columnWidth * finalStretchRatio);
      }
      this.stretchedWidths.set(columnVisualIndex, newWidth);
      lastColumnIndex = columnVisualIndex;
      if (index2 < stretchedWidths.length - 1) {
        sumColumnsWithoutLastOne += newWidth;
      }
    });
    if (this.stretchedWidths.size > 1) {
      this.stretchedWidths.set(lastColumnIndex, Math.round(this.viewportWidth - sumColumnsWithoutLastOne));
    }
  }
}
function _check_private_redeclaration$c(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$c(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$c(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$c(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$c(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$c(receiver, privateMap, "get");
  return _class_apply_descriptor_get$c(receiver, descriptor);
}
function _class_private_field_init$c(obj, privateMap, value) {
  _check_private_redeclaration$c(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$c(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$c(receiver, privateMap, "set");
  _class_apply_descriptor_set$c(receiver, descriptor, value);
  return value;
}
var _lastColumnWidth = /* @__PURE__ */ new WeakMap(), _lastColumnIndex = /* @__PURE__ */ new WeakMap();
class StretchLastStrategy extends StretchStrategy {
  /**
  * Prepares the strategy for the calculation.
  *
  * @param {StretchStrategyCalcArgs} calcArgs The calculation arguments.
  */
  prepare(calcArgs) {
    super.prepare(calcArgs);
    _class_private_field_set$c(this, _lastColumnWidth, 0);
    _class_private_field_set$c(this, _lastColumnIndex, -1);
  }
  /**
  * Sets the base widths of the columns with which the strategy will work with.
  *
  * @param {number} columnVisualIndex The visual index of the column.
  * @param {number} columnWidth The width of the column.
  */
  setColumnBaseWidth(columnVisualIndex, columnWidth) {
    super.setColumnBaseWidth(columnVisualIndex, columnWidth);
    _class_private_field_set$c(this, _lastColumnIndex, columnVisualIndex);
    _class_private_field_set$c(this, _lastColumnWidth, columnWidth);
  }
  /**
  * Calculates the columns widths.
  */
  calculate() {
    if (_class_private_field_get$c(this, _lastColumnIndex) === -1) {
      return;
    }
    const allColumnsWidth = Array.from(this.baseWidths).reduce((sum2, [, width]) => sum2 + width, 0);
    const lastColumnWidth = this.viewportWidth - allColumnsWidth + _class_private_field_get$c(this, _lastColumnWidth);
    if (lastColumnWidth < _class_private_field_get$c(this, _lastColumnWidth)) {
      this.stretchedWidths.clear();
      return;
    }
    this.stretchedWidths.set(_class_private_field_get$c(this, _lastColumnIndex), lastColumnWidth);
  }
  constructor(...args) {
    super(...args), _class_private_field_init$c(this, _lastColumnWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$c(this, _lastColumnIndex, {
      writable: true,
      value: void 0
    }), _class_private_field_set$c(this, _lastColumnWidth, 0), _class_private_field_set$c(this, _lastColumnIndex, -1);
  }
}
function _check_private_redeclaration$b(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$b(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$b(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$b(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$b(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$b(receiver, privateMap, "get");
  return _class_apply_descriptor_get$b(receiver, descriptor);
}
function _class_private_field_init$b(obj, privateMap, value) {
  _check_private_redeclaration$b(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$b(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$b(receiver, privateMap, "set");
  _class_apply_descriptor_set$b(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$5(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$5(obj, privateSet) {
  _check_private_redeclaration$b(obj, privateSet);
  privateSet.add(obj);
}
const STRETCH_WIDTH_MAP_NAME = "stretchColumns";
var _hot = /* @__PURE__ */ new WeakMap(), _widthsMap = /* @__PURE__ */ new WeakMap(), _stretchStrategies = /* @__PURE__ */ new WeakMap(), _activeStrategy = /* @__PURE__ */ new WeakMap(), _willVerticalScrollAppear = /* @__PURE__ */ new WeakSet(), _getWidthWithoutStretching = /* @__PURE__ */ new WeakSet(), _overwriteColumnWidthFn = /* @__PURE__ */ new WeakSet();
class StretchCalculator {
  /**
  * Sets the active stretch strategy.
  *
  * @param {'all' | 'last' | 'none'} strategyName The stretch strategy to use.
  */
  useStrategy(strategyName) {
    _class_private_field_set$b(this, _activeStrategy, typeof strategyName === "string" && _class_private_field_get$b(this, _stretchStrategies).has(strategyName) ? strategyName : "none");
  }
  /**
  * Recalculates the column widths.
  */
  refreshStretching() {
    if (_class_private_field_get$b(this, _activeStrategy) === "none") {
      _class_private_field_get$b(this, _widthsMap).clear();
      return;
    }
    _class_private_field_get$b(this, _hot).batchExecution(() => {
      _class_private_field_get$b(this, _widthsMap).clear();
      const stretchStrategy = _class_private_field_get$b(this, _stretchStrategies).get(_class_private_field_get$b(this, _activeStrategy));
      if (!stretchStrategy) {
        return;
      }
      const view = _class_private_field_get$b(this, _hot).view;
      let viewportWidth = view.getViewportWidth();
      if (_class_private_method_get$5(this, _willVerticalScrollAppear, willVerticalScrollAppear).call(this)) {
        viewportWidth -= getScrollbarWidth(_class_private_field_get$b(this, _hot).rootDocument);
      }
      stretchStrategy.prepare({
        viewportWidth
      });
      for (let columnIndex = 0; columnIndex < _class_private_field_get$b(this, _hot).countCols(); columnIndex++) {
        if (!_class_private_field_get$b(this, _hot).columnIndexMapper.isHidden(_class_private_field_get$b(this, _hot).toPhysicalColumn(columnIndex))) {
          stretchStrategy.setColumnBaseWidth(columnIndex, _class_private_method_get$5(this, _getWidthWithoutStretching, getWidthWithoutStretching).call(this, columnIndex));
        }
      }
      stretchStrategy.calculate();
      stretchStrategy.getWidths().forEach(([columnIndex, width]) => {
        _class_private_field_get$b(this, _widthsMap).setValueAtIndex(_class_private_field_get$b(this, _hot).toPhysicalColumn(columnIndex), width);
      });
    }, true);
  }
  /**
  * Gets the calculated column width.
  *
  * @param {number} columnVisualIndex Column visual index.
  * @returns {number | null}
  */
  getStretchedWidth(columnVisualIndex) {
    return _class_private_field_get$b(this, _widthsMap).getValueAtIndex(_class_private_field_get$b(this, _hot).toPhysicalColumn(columnVisualIndex));
  }
  /**
  * Initializes the stretch columns calculator with the Handsontable instance and registers the stretch widths index map.
  */
  constructor(hotInstance) {
    _class_private_method_init$5(this, _willVerticalScrollAppear);
    _class_private_method_init$5(this, _getWidthWithoutStretching);
    _class_private_method_init$5(this, _overwriteColumnWidthFn);
    _class_private_field_init$b(this, _hot, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$b(this, _widthsMap, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$b(this, _stretchStrategies, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$b(this, _activeStrategy, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$b(this, _stretchStrategies, /* @__PURE__ */ new Map([
      [
        "all",
        new StretchAllStrategy(_class_private_method_get$5(this, _overwriteColumnWidthFn, overwriteColumnWidthFn).bind(this))
      ],
      [
        "last",
        new StretchLastStrategy(_class_private_method_get$5(this, _overwriteColumnWidthFn, overwriteColumnWidthFn).bind(this))
      ]
    ]));
    _class_private_field_set$b(this, _activeStrategy, "none");
    _class_private_field_set$b(this, _hot, hotInstance);
    _class_private_field_set$b(this, _widthsMap, _class_private_field_get$b(this, _hot).columnIndexMapper.createAndRegisterIndexMap(STRETCH_WIDTH_MAP_NAME, "physicalIndexToValue"));
  }
}
function willVerticalScrollAppear() {
  const { view, stylesHandler } = _class_private_field_get$b(this, _hot);
  if (view.isVerticallyScrollableByWindow()) {
    return false;
  }
  const viewportHeight = view.getViewportHeight();
  const totalRows = _class_private_field_get$b(this, _hot).countRows();
  const defaultRowHeight = stylesHandler.getDefaultRowHeight();
  let totalHeight = 0;
  let hasVerticalScroll = false;
  for (let row = 0; row < totalRows; row++) {
    if (_class_private_field_get$b(this, _hot).rowIndexMapper.isHidden(_class_private_field_get$b(this, _hot).toPhysicalRow(row))) {
      continue;
    }
    totalHeight += _class_private_field_get$b(this, _hot).getRowHeight(row) ?? defaultRowHeight;
    if (totalHeight > viewportHeight) {
      hasVerticalScroll = true;
      break;
    }
  }
  return hasVerticalScroll;
}
function getWidthWithoutStretching(columnVisualIndex) {
  return _class_private_field_get$b(this, _hot).getColWidth(columnVisualIndex, "StretchColumns") ?? DEFAULT_COLUMN_WIDTH;
}
function overwriteColumnWidthFn(columnWidth, columnVisualIndex) {
  return _class_private_field_get$b(this, _hot).runHooks("beforeStretchingColumnWidth", columnWidth, columnVisualIndex);
}
function _check_private_redeclaration$a(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$a(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$a(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$a(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$a(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$a(receiver, privateMap, "get");
  return _class_apply_descriptor_get$a(receiver, descriptor);
}
function _class_private_field_init$a(obj, privateMap, value) {
  _check_private_redeclaration$a(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$a(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$a(receiver, privateMap, "set");
  _class_apply_descriptor_set$a(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$7 = "stretchColumns";
const PLUGIN_PRIORITY$7 = 155;
var _stretchCalculator = /* @__PURE__ */ new WeakMap(), _previousTableWidth = /* @__PURE__ */ new WeakMap(), _resizeObserver = /* @__PURE__ */ new WeakMap(), _onModifyColWidth = /* @__PURE__ */ new WeakMap(), _onBeforeRender = /* @__PURE__ */ new WeakMap();
class StretchColumns extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$7;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$7;
  }
  /**
  * Returns whether the plugin handles its own settings keys without a dedicated key list.
  */
  static get SETTING_KEYS() {
    return true;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link #enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return [
      "all",
      "last"
    ].includes(this.hot.getSettings().stretchH ?? "");
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    _class_private_field_get$a(this, _stretchCalculator).useStrategy(this.hot.getSettings().stretchH);
    _class_private_field_get$a(this, _resizeObserver).observe(this.hot.rootElement);
    this.addHook("beforeRender", _class_private_field_get$a(this, _onBeforeRender));
    this.addHook("modifyColWidth", _class_private_field_get$a(this, _onModifyColWidth), 10);
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state. This method is executed when {@link Core#updateSettings} is invoked.
  */
  updatePlugin() {
    _class_private_field_get$a(this, _stretchCalculator).useStrategy(this.hot.getSettings().stretchH);
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
    _class_private_field_get$a(this, _resizeObserver).unobserve(this.hot.rootElement);
  }
  /**
  * Gets the calculated column width based on the stretching
  * strategy defined by {@link Options#stretchH} option.
  *
  * @param {number} columnVisualIndex The visual index of the column.
  * @returns {number | null}
  */
  getColumnWidth(columnVisualIndex) {
    return _class_private_field_get$a(this, _stretchCalculator).getStretchedWidth(columnVisualIndex);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    _class_private_field_get$a(this, _resizeObserver).disconnect();
    _class_private_field_set$a(this, _resizeObserver, null);
    _class_private_field_set$a(this, _stretchCalculator, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$a(this, _stretchCalculator, {
      writable: true,
      value: void 0
    }), _class_private_field_init$a(this, _previousTableWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$a(this, _resizeObserver, {
      writable: true,
      value: void 0
    }), _class_private_field_init$a(this, _onModifyColWidth, {
      writable: true,
      value: void 0
    }), _class_private_field_init$a(this, _onBeforeRender, {
      writable: true,
      value: void 0
    }), _class_private_field_set$a(this, _stretchCalculator, new StretchCalculator(this.hot)), _class_private_field_set$a(this, _previousTableWidth, null), _class_private_field_set$a(this, _resizeObserver, new ResizeObserver((entries) => {
      requestAnimationFrame(() => {
        if (!this.hot?.view?.isHorizontallyScrollableByWindow()) {
          return;
        }
        entries.forEach(({ contentRect }) => {
          if (_class_private_field_get$a(this, _previousTableWidth) !== null && _class_private_field_get$a(this, _previousTableWidth) !== contentRect.width) {
            this.hot?.view?.adjustElementsSize();
            this.hot?.refreshDimensions();
          }
          _class_private_field_set$a(this, _previousTableWidth, contentRect.width);
        });
      });
    })), _class_private_field_set$a(this, _onModifyColWidth, (width, column, source) => {
      if (source === this.pluginName) {
        return;
      }
      const newWidth = this.getColumnWidth(column);
      if (typeof newWidth === "number") {
        return newWidth;
      }
      return width;
    }), _class_private_field_set$a(this, _onBeforeRender, (fullRender) => {
      if (fullRender) {
        _class_private_field_get$a(this, _stretchCalculator).refreshStretching();
      }
    });
  }
}
function _check_private_redeclaration$9(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$9(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$9(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$9(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$9(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$9(receiver, privateMap, "get");
  return _class_apply_descriptor_get$9(receiver, descriptor);
}
function _class_private_field_init$9(obj, privateMap, value) {
  _check_private_redeclaration$9(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$9(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$9(receiver, privateMap, "set");
  _class_apply_descriptor_set$9(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$6 = "touchScroll";
const PLUGIN_PRIORITY$6 = 200;
var _onAfterViewRender$1 = /* @__PURE__ */ new WeakMap(), _onBeforeTouchScroll = /* @__PURE__ */ new WeakMap(), _onAfterMomentumScroll = /* @__PURE__ */ new WeakMap();
class TouchScroll extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$6;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$6;
  }
  /**
  * Returns whether the plugin handles its own settings keys without a dedicated key list.
  */
  static get SETTING_KEYS() {
    return true;
  }
  /**
  * Check if plugin is enabled.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return isTouchSupported();
  }
  /**
  * Enable the plugin.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("afterViewRender", _class_private_field_get$9(this, _onAfterViewRender$1));
    this.registerEvents();
    super.enablePlugin();
  }
  /**
  * Updates the plugin to use the latest options you have specified.
  */
  updatePlugin() {
    this.lockedCollection = false;
    super.updatePlugin();
  }
  /**
  * Disable plugin for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
  }
  /**
  * Register all necessary events.
  *
  * @private
  */
  registerEvents() {
    this.addHook("beforeTouchScroll", _class_private_field_get$9(this, _onBeforeTouchScroll));
    this.addHook("afterMomentumScroll", _class_private_field_get$9(this, _onAfterMomentumScroll));
  }
  constructor(...args) {
    super(...args), _class_private_field_init$9(this, _onAfterViewRender$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$9(this, _onBeforeTouchScroll, {
      writable: true,
      value: void 0
    }), _class_private_field_init$9(this, _onAfterMomentumScroll, {
      writable: true,
      value: void 0
    }), /**
    * Collection of scrollbars to update.
    *
    * @type {Array}
    */
    this.scrollbars = [], /**
    * Collection of overlays to update.
    *
    * @type {Array}
    */
    this.clones = [], /**
    * Flag which determines if collection of overlays should be refilled on every table render.
    *
    * @type {boolean}
    * @default false
    */
    this.lockedCollection = false, /**
    * Flag which determines if walkontable should freeze overlays while scrolling.
    *
    * @type {boolean}
    * @default false
    */
    this.freezeOverlays = false, _class_private_field_set$9(this, _onAfterViewRender$1, () => {
      if (this.lockedCollection) {
        return;
      }
      const { topOverlay, bottomOverlay, inlineStartOverlay, topInlineStartCornerOverlay, bottomInlineStartCornerOverlay } = this.hot.view._wt.wtOverlays;
      this.lockedCollection = true;
      this.scrollbars.length = 0;
      this.scrollbars.push(topOverlay);
      if (bottomOverlay.clone) {
        this.scrollbars.push(bottomOverlay);
      }
      this.scrollbars.push(inlineStartOverlay);
      if (topInlineStartCornerOverlay) {
        this.scrollbars.push(topInlineStartCornerOverlay);
      }
      if (bottomInlineStartCornerOverlay && bottomInlineStartCornerOverlay.clone) {
        this.scrollbars.push(bottomInlineStartCornerOverlay);
      }
      this.clones = [];
      if (topOverlay.needFullRender) {
        this.clones.push(topOverlay.clone?.wtTable.holder.parentNode);
      }
      if (bottomOverlay.needFullRender) {
        this.clones.push(bottomOverlay.clone?.wtTable.holder.parentNode);
      }
      if (inlineStartOverlay.needFullRender) {
        this.clones.push(inlineStartOverlay.clone?.wtTable.holder.parentNode);
      }
      if (topInlineStartCornerOverlay) {
        this.clones.push(topInlineStartCornerOverlay.clone?.wtTable.holder.parentNode);
      }
      if (bottomInlineStartCornerOverlay && bottomInlineStartCornerOverlay.clone) {
        this.clones.push(bottomInlineStartCornerOverlay.clone.wtTable.holder.parentNode);
      }
    }), _class_private_field_set$9(this, _onBeforeTouchScroll, () => {
      this.freezeOverlays = true;
      arrayEach(this.clones, (clone2) => {
        addClass(clone2, "hide-tween");
      });
    }), _class_private_field_set$9(this, _onAfterMomentumScroll, () => {
      this.freezeOverlays = false;
      arrayEach(this.clones, (clone2) => {
        removeClass(clone2, "hide-tween");
        addClass(clone2, "show-tween");
      });
      this.hot._registerTimeout(() => {
        arrayEach(this.clones, (clone2) => {
          removeClass(clone2, "show-tween");
        });
      }, 400);
      arrayEach(this.scrollbars, (scrollbar) => {
        scrollbar.refresh();
        scrollbar.resetFixedPosition();
      });
      this.hot.view._wt.wtOverlays.syncScrollWithMaster();
    });
  }
}
function _check_private_redeclaration$8(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$8(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$8(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$8(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$8(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$8(receiver, privateMap, "get");
  return _class_apply_descriptor_get$8(receiver, descriptor);
}
function _class_private_field_init$8(obj, privateMap, value) {
  _check_private_redeclaration$8(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$8(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$8(receiver, privateMap, "set");
  _class_apply_descriptor_set$8(receiver, descriptor, value);
  return value;
}
const PLUGIN_KEY$5 = "trimRows";
const PLUGIN_PRIORITY$5 = 330;
var _onMapInit = /* @__PURE__ */ new WeakMap();
class TrimRows extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$5;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$5;
  }
  /**
  * Returns the list of settings keys observed by the plugin for configuration changes.
  */
  static get SETTING_KEYS() {
    return [
      PLUGIN_KEY$5
    ];
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link TrimRows#enablePlugin} method is called.
  * When [[Options#dataProvider]] is a complete server-backed configuration, the DataProvider plugin blocks this plugin from enabling.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$5];
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.trimmedRowsMap = this.hot.rowIndexMapper.registerMap("trimRows", new TrimmingMap());
    this.trimmedRowsMap.addLocalHook("init", _class_private_field_get$8(this, _onMapInit));
    super.enablePlugin();
  }
  /**
  * Updates the plugin's state.
  *
  * This method is executed when [`updateSettings()`](@/api/core.md#updatesettings) is invoked with any of the following configuration options:
  *  - [`trimRows`](@/api/options.md#trimrows)
  */
  updatePlugin() {
    const trimmedRows = this.hot.getSettings()[PLUGIN_KEY$5];
    if (Array.isArray(trimmedRows)) {
      this.hot.batchExecution(() => {
        this.trimmedRowsMap.clear();
        arrayEach(trimmedRows, (physicalRow) => {
          this.trimmedRowsMap.setValueAtIndex(physicalRow, true);
        });
      }, true);
    }
    super.updatePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    this.hot.rowIndexMapper.unregisterMap("trimRows");
    super.disablePlugin();
  }
  /**
  * Get list of trimmed rows.
  *
  * @returns {Array} Physical rows.
  */
  getTrimmedRows() {
    return this.trimmedRowsMap.getTrimmedIndexes();
  }
  /**
  * Trims the rows provided in the array.
  *
  * @param {number[]} rows Array of physical row indexes.
  * @fires Hooks#beforeTrimRow
  * @fires Hooks#afterTrimRow
  */
  trimRows(rows) {
    const currentTrimConfig = this.getTrimmedRows();
    const isValidConfig = this.isValidConfig(rows);
    let destinationTrimConfig = currentTrimConfig;
    if (isValidConfig) {
      destinationTrimConfig = Array.from(new Set(currentTrimConfig.concat(rows)));
    }
    const allowTrimRow = this.hot.runHooks("beforeTrimRow", currentTrimConfig, destinationTrimConfig, isValidConfig);
    if (allowTrimRow === false) {
      return;
    }
    if (isValidConfig) {
      this.hot.batchExecution(() => {
        arrayEach(rows, (physicalRow) => {
          this.trimmedRowsMap.setValueAtIndex(physicalRow, true);
        });
      }, true);
    }
    this.hot.runHooks("afterTrimRow", currentTrimConfig, destinationTrimConfig, isValidConfig, isValidConfig && destinationTrimConfig.length > currentTrimConfig.length);
  }
  /**
  * Trims the row provided as a physical row index (counting from 0).
  *
  * @param {...number} row Physical row index.
  */
  trimRow(...row) {
    this.trimRows(row);
  }
  /**
  * Untrims the rows provided in the array.
  *
  * @param {number[]} rows Array of physical row indexes.
  * @fires Hooks#beforeUntrimRow
  * @fires Hooks#afterUntrimRow
  */
  untrimRows(rows) {
    const currentTrimConfig = this.getTrimmedRows();
    const isValidConfig = this.isValidConfig(rows);
    let destinationTrimConfig = currentTrimConfig;
    const trimmingMapValues = this.trimmedRowsMap.getValues().slice();
    const isAnyRowUntrimmed = rows.length > 0;
    if (isValidConfig && isAnyRowUntrimmed) {
      arrayEach(rows, (physicalRow) => {
        trimmingMapValues[physicalRow] = false;
      });
      destinationTrimConfig = arrayReduce(trimmingMapValues, (trimmedIndexes, isTrimmed, physicalIndex) => {
        if (isTrimmed) {
          trimmedIndexes.push(physicalIndex);
        }
        return trimmedIndexes;
      }, []);
    }
    const allowUntrimRow = this.hot.runHooks("beforeUntrimRow", currentTrimConfig, destinationTrimConfig, isValidConfig && isAnyRowUntrimmed);
    if (allowUntrimRow === false) {
      return;
    }
    if (isValidConfig && isAnyRowUntrimmed) {
      this.trimmedRowsMap.setValues(trimmingMapValues);
    }
    this.hot.runHooks("afterUntrimRow", currentTrimConfig, destinationTrimConfig, isValidConfig && isAnyRowUntrimmed, isValidConfig && destinationTrimConfig.length < currentTrimConfig.length);
  }
  /**
  * Untrims the row provided as a physical row index (counting from 0).
  *
  * @param {...number} row Physical row index.
  */
  untrimRow(...row) {
    this.untrimRows(row);
  }
  /**
  * Checks if given row is hidden.
  *
  * @param {number} physicalRow Physical row index.
  * @returns {boolean}
  */
  isTrimmed(physicalRow) {
    return this.trimmedRowsMap.getValueAtIndex(physicalRow) || false;
  }
  /**
  * Untrims all trimmed rows.
  */
  untrimAll() {
    this.untrimRows(this.getTrimmedRows());
  }
  /**
  * Get if trim config is valid. Check whether all of the provided physical row indexes are within source data.
  *
  * @param {Array} trimmedRows List of physical row indexes.
  * @returns {boolean}
  */
  isValidConfig(trimmedRows) {
    const sourceRows = this.hot.countSourceRows();
    return trimmedRows.every((trimmedRow) => Number.isInteger(trimmedRow) && trimmedRow >= 0 && trimmedRow < sourceRows);
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_field_init$8(this, _onMapInit, {
      writable: true,
      value: void 0
    }), /**
    * Map of skipped rows by the plugin.
    *
    * @private
    * @type {null|TrimmingMap}
    */
    this.trimmedRowsMap = null, _class_private_field_set$8(this, _onMapInit, () => {
      const trimmedRows = this.hot.getSettings()[PLUGIN_KEY$5];
      if (Array.isArray(trimmedRows)) {
        this.hot.batchExecution(() => {
          arrayEach(trimmedRows, (physicalRow) => {
            this.trimmedRowsMap.setValueAtIndex(physicalRow, true);
          });
        }, true);
      }
    });
  }
}
class BaseAction {
  /**
  * Reverts the action, restoring the previous state. Subclasses must override this method.
  */
  undo(..._args) {
    throwWithCause("Not implemented");
  }
  /**
  * Reapplies the action after it has been undone. Subclasses must override this method.
  */
  redo(..._args) {
    throwWithCause("Not implemented");
  }
  /**
  * Initializes the action with the given action type identifier.
  */
  constructor(actionType) {
    this.actionType = "";
    this.actionType = actionType;
  }
}
class CellAlignmentAction extends BaseAction {
  /**
  * Registers the `beforeCellAlignment` hook listener that records a new CellAlignmentAction whenever alignment changes.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeCellAlignment", (stateBefore, range, type, alignment) => {
      undoRedoPlugin.done(() => new CellAlignmentAction({
        stateBefore,
        range,
        type,
        alignment
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    arrayEach(this.range, (range) => {
      range.forAll((row, col) => {
        if (row >= 0 && col >= 0) {
          hot.setCellMeta(row, col, "className", this.stateBefore[row][col] || " htLeft");
        }
        return true;
      });
    });
    hot.addHookOnce("afterViewRender", undoneCallback);
    hot.render();
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    align(this.range, this.type, this.alignment, (row, col) => hot.getCellMeta(row, col), (row, col, key, value) => hot.setCellMeta(row, col, key, value));
    hot.addHookOnce("afterViewRender", redoneCallback);
    hot.render();
  }
  /**
  * Initializes the cell alignment action with the previous state, cell range, alignment axis, and CSS alignment class.
  */
  constructor({ stateBefore, range, type, alignment }) {
    super("cell_alignment");
    this.stateBefore = stateBefore;
    this.range = range;
    this.type = type;
    this.alignment = alignment;
  }
}
class ColumnMoveAction extends BaseAction {
  /**
  * Registers the `beforeColumnMove` hook listener that records a new ColumnMoveAction whenever columns are moved.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeColumnMove", (columns, finalIndex) => {
      if (columns === false) {
        return;
      }
      undoRedoPlugin.done(() => new ColumnMoveAction({
        columns,
        finalIndex
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const manualColumnMove = hot.getPlugin("manualColumnMove");
    hot.addHookOnce("afterViewRender", undoneCallback);
    const columnMoves = getMoves(this.columns, this.finalColumnIndex, hot.columnIndexMapper.getNumberOfIndexes());
    columnMoves.reverse().forEach(({ from, to }) => {
      if (from < to) {
        to -= 1;
      }
      manualColumnMove.moveColumn(to, from);
    });
    hot.render();
    hot.deselectCell();
    hot.selectColumns(this.columns[0], this.columns[0] + this.columns.length - 1);
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const manualColumnMove = hot.getPlugin("manualColumnMove");
    hot.addHookOnce("afterViewRender", redoneCallback);
    manualColumnMove.moveColumns(this.columns.slice(), this.finalColumnIndex);
    hot.render();
    hot.deselectCell();
    hot.selectColumns(this.finalColumnIndex, this.finalColumnIndex + this.columns.length - 1);
  }
  /**
  * Initializes the column move action with the array of moved column indexes and their destination index.
  */
  constructor({ columns, finalIndex }) {
    super("col_move");
    this.columns = columns.slice();
    this.finalColumnIndex = finalIndex;
  }
}
class ColumnSortAction extends BaseAction {
  /**
  * Registers the `beforeColumnSort` hook listener that records a new ColumnSortAction whenever sorting changes.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeColumnSort", (currentSortState, newSortState, sortPossible) => {
      if (!sortPossible) {
        return;
      }
      undoRedoPlugin.done(() => new ColumnSortAction({
        currentSortState,
        newSortState
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const sortPlugin = hot.getPlugin("columnSorting");
    const multiSortPlugin = hot.getPlugin("multiColumnSorting");
    const enabledSortPlugin = multiSortPlugin.isEnabled() ? multiSortPlugin : sortPlugin;
    if (this.previousSortState.length) {
      enabledSortPlugin.sort(this.previousSortState);
    } else {
      enabledSortPlugin.clearSort();
    }
    undoneCallback();
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const sortPlugin = hot.getPlugin("columnSorting");
    const multiSortPlugin = hot.getPlugin("multiColumnSorting");
    const enabledSortPlugin = multiSortPlugin.isEnabled() ? multiSortPlugin : sortPlugin;
    enabledSortPlugin.sort(this.nextSortState);
    redoneCallback();
  }
  /**
  * Initializes the column sort action with the previous and next sort state snapshots.
  */
  constructor({ currentSortState, newSortState }) {
    super("col_sort");
    this.previousSortState = currentSortState;
    this.nextSortState = newSortState;
  }
}
class CreateColumnAction extends BaseAction {
  /**
  * Registers the `afterCreateCol` hook listener that records a new CreateColumnAction after columns are inserted.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("afterCreateCol", (index2, amount, source) => {
      undoRedoPlugin.done(() => new CreateColumnAction({
        index: index2,
        amount
      }), source);
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    hot.addHookOnce("afterRemoveCol", undoneCallback);
    hot.alter("remove_col", this.index, this.amount, "UndoRedo.undo");
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    hot.addHookOnce("afterCreateCol", redoneCallback);
    hot.alter("insert_col_start", this.index, this.amount, "UndoRedo.redo");
  }
  /**
  * Initializes the create column action with the visual insertion index and the number of columns created.
  */
  constructor({ index: index2, amount }) {
    super("insert_col");
    this.index = index2;
    this.amount = amount;
  }
}
class CreateRowAction extends BaseAction {
  /**
  * Registers the `afterCreateRow` hook listener that records a new CreateRowAction after rows are inserted.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("afterCreateRow", (index2, amount, source) => {
      undoRedoPlugin.done(() => new CreateRowAction({
        index: index2,
        amount
      }), source);
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const rowCount = hot.countRows();
    const minSpareRows = hot.getSettings().minSpareRows;
    if (this.index >= rowCount && this.index - (minSpareRows ?? 0) < rowCount) {
      this.index -= minSpareRows ?? 0;
    }
    hot.addHookOnce("afterRemoveRow", undoneCallback);
    hot.alter("remove_row", this.index, this.amount, "UndoRedo.undo");
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    hot.addHookOnce("afterCreateRow", redoneCallback);
    hot.alter("insert_row_above", this.index, this.amount, "UndoRedo.redo");
  }
  /**
  * Initializes the create row action with the visual insertion index and the number of rows created.
  */
  constructor({ index: index2, amount }) {
    super("insert_row");
    this.index = index2;
    this.amount = amount;
  }
}
class DataChangeAction extends BaseAction {
  /**
  * Registers the `beforeChange` hook listener that captures effective cell value changes and records them as DataChangeActions.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    const plugin = undoRedoPlugin;
    hot.addHook("beforeChange", function(changes, source) {
      const changesLen = changes && changes.length;
      if (!changesLen) {
        return;
      }
      const effectiveChanges = changes.filter((change) => change !== null && change !== void 0 && Array.isArray(change));
      if (effectiveChanges.length === 0) {
        return;
      }
      effectiveChanges.find((change) => {
        const [, , oldValue, newValue] = change;
        return oldValue !== newValue;
      });
      const effectiveLen = effectiveChanges.length;
      const wrappedAction = () => {
        const clonedChanges = effectiveChanges.map((change) => [
          ...change
        ]);
        clonedChanges.forEach((change) => {
          change[1] = hot.propToCol(change[1]);
        });
        const selected = effectiveLen > 1 ? this.getSelected() : [
          [
            clonedChanges[0][0],
            clonedChanges[0][1]
          ]
        ];
        return new DataChangeAction({
          changes: clonedChanges,
          selected,
          countCols: hot.countCols(),
          countRows: hot.countRows()
        });
      };
      plugin.done(wrappedAction, source);
    }, 1e3);
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const data = deepClone(this.changes);
    for (let i = 0, len = data.length; i < len; i++) {
      data[i].splice(3, 1);
    }
    hot.addHookOnce("afterChange", () => {
      const rowsToRemove = hot.countRows() - this.countRows;
      if (rowsToRemove > 0) {
        hot.alter("remove_row", void 0, rowsToRemove, "UndoRedo.undo");
      }
      const columnsToRemove = hot.countCols() - this.countCols;
      if (columnsToRemove > 0 && hot.isColumnModificationAllowed()) {
        hot.alter("remove_col", void 0, columnsToRemove, "UndoRedo.undo");
      }
      hot.scrollToFocusedCell();
      hot.selectCells(this.selected, false, false);
      undoneCallback();
    });
    hot.setDataAtCell(data, null, null, "UndoRedo.undo");
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const data = deepClone(this.changes);
    for (let i = 0, len = data.length; i < len; i++) {
      data[i].splice(2, 1);
    }
    hot.addHookOnce("afterChange", () => {
      hot.selectCells(this.selected, false, false);
      redoneCallback();
    });
    hot.setDataAtCell(data, null, null, "UndoRedo.redo");
  }
  /**
  * Initializes the data change action with the recorded cell changes, selection state, and grid dimensions at the time of the change.
  */
  constructor({ changes, selected, countCols, countRows }) {
    super("change");
    this.changes = changes;
    this.selected = selected;
    this.countCols = countCols;
    this.countRows = countRows;
  }
}
class FiltersAction extends BaseAction {
  /**
  * Registers the `beforeFilter` hook listener that records a new FiltersAction whenever filter conditions change.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeFilter", (conditionsStack, previousConditionsStack) => {
      undoRedoPlugin.done(() => new FiltersAction({
        conditionsStack,
        previousConditionsStack
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const filters = hot.getPlugin("filters");
    hot.addHookOnce("afterViewRender", undoneCallback);
    filters.importConditions(this.previousConditionsStack);
    filters.filter();
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const filters = hot.getPlugin("filters");
    hot.addHookOnce("afterViewRender", redoneCallback);
    filters.importConditions(this.conditionsStack);
    filters.filter();
  }
  /**
  * Initializes the filters action with the current and previous filter condition stacks.
  */
  constructor({ conditionsStack, previousConditionsStack }) {
    super("filter");
    this.conditionsStack = conditionsStack;
    this.previousConditionsStack = previousConditionsStack;
  }
}
class MergeCellsAction extends BaseAction {
  /**
  * Registers the hooks needed to capture merge and unmerge events so they can be tracked for undo and redo.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeMergeCells", (cellRange, auto) => {
      if (auto) {
        return;
      }
      const typedCellRange = cellRange;
      const topStartCorner = typedCellRange.getTopStartCorner();
      const bottomEndCorner = typedCellRange.getBottomEndCorner();
      const data = hot.getData(topStartCorner.row ?? void 0, topStartCorner.col ?? void 0, bottomEndCorner.row ?? void 0, bottomEndCorner.col ?? void 0);
      undoRedoPlugin.done(() => new MergeCellsAction({
        data,
        cellRange: typedCellRange
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const mergeCellsPlugin = hot.getPlugin("mergeCells");
    hot.addHookOnce("afterViewRender", undoneCallback);
    mergeCellsPlugin.unmergeRange(this.cellRange, true);
    const topStartCorner = this.cellRange.getTopStartCorner();
    hot.populateFromArray(topStartCorner.row ?? 0, topStartCorner.col ?? 0, this.data, void 0, void 0, "MergeCells");
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const mergeCellsPlugin = hot.getPlugin("mergeCells");
    hot.addHookOnce("afterViewRender", redoneCallback);
    mergeCellsPlugin.mergeRange(this.cellRange);
  }
  /**
  * Initializes the merge cells action with the affected cell range and the original cell data.
  */
  constructor({ data, cellRange }) {
    super("merge_cells");
    this.cellRange = cellRange;
    this.data = data;
  }
}
function getCellMetas(hot, fromRow, toRow, fromColumn, toColumn) {
  const cellMetas = [];
  rangeEach(fromColumn, toColumn, (columnIndex) => {
    rangeEach(fromRow, toRow, (rowIndex) => {
      const cellMeta = hot.getCellMeta(rowIndex, columnIndex);
      cellMetas.push([
        cellMeta.visualRow,
        cellMeta.visualCol,
        cellMeta
      ]);
    });
  });
  return cellMetas;
}
class RemoveColumnAction extends BaseAction {
  /**
  * Registers the `beforeRemoveCol` hook listener that captures removed column data and records a RemoveColumnAction.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeRemoveCol", (index2, amount, logicColumns, source) => {
      const wrappedAction = () => {
        const originalData = hot.getSourceDataArray();
        const columnIndex = (hot.countCols() + index2) % hot.countCols();
        const lastColumnIndex = columnIndex + amount - 1;
        const removedData = [];
        const headers = [];
        const indexes = [];
        const collectColumnData = (origRow, colFrom, colTo) => {
          const column = [];
          rangeEach(colFrom, colTo, (j) => {
            column.push(origRow[hot.toPhysicalColumn(j)]);
          });
          return column;
        };
        rangeEach(originalData.length - 1, (i) => {
          removedData.push(collectColumnData(originalData[i], columnIndex, lastColumnIndex));
        });
        rangeEach(amount - 1, (i) => {
          indexes.push(hot.toPhysicalColumn(columnIndex + i));
        });
        if (Array.isArray(hot.getSettings().colHeaders)) {
          const colHeadersArr = hot.getSettings().colHeaders;
          rangeEach(amount - 1, (i) => {
            headers.push(colHeadersArr[hot.toPhysicalColumn(columnIndex + i)] || null);
          });
        }
        return new RemoveColumnAction({
          index: columnIndex,
          indexes,
          data: removedData,
          amount,
          headers,
          columnPositions: hot.columnIndexMapper.getIndexesSequence(),
          rowPositions: hot.rowIndexMapper.getIndexesSequence(),
          fixedColumnsStart: hot.getSettings().fixedColumnsStart ?? 0,
          removedCellMetas: getCellMetas(hot, 0, hot.countRows(), columnIndex, lastColumnIndex)
        });
      };
      undoRedoPlugin.done(wrappedAction, source);
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const settings = hot.getSettings();
    settings.fixedColumnsStart = this.fixedColumnsStart;
    const ascendingIndexes = this.indexes.slice(0).sort((a, b) => a - b);
    const sortByIndexes = (elem, j, arr) => arr[this.indexes.indexOf(ascendingIndexes[j])];
    const removedDataLength = this.data.length;
    const sortedData = [];
    for (let rowIndex = 0; rowIndex < removedDataLength; rowIndex++) {
      sortedData.push(arrayMap(this.data[rowIndex], sortByIndexes));
    }
    const sortedHeaders = arrayMap(this.headers, sortByIndexes);
    const changes = [];
    hot.columnIndexMapper.setIndexesSequence(this.columnPositions);
    hot.alter("insert_col_start", hot.toVisualColumn(this.indexes[0]), this.indexes.length, "UndoRedo.undo");
    hot.batchExecution(() => {
      hot.rowIndexMapper.setIndexesSequence(this.rowPositions);
      hot.columnIndexMapper.setIndexesSequence(this.columnPositions);
    }, true);
    arrayEach(hot.getSourceDataArray(), (rowData, rowIndex) => {
      const rowArr = rowData;
      arrayEach(ascendingIndexes, (changedIndex, contiquesIndex) => {
        rowArr[changedIndex] = sortedData[rowIndex][contiquesIndex];
        changes.push([
          rowIndex,
          changedIndex,
          rowArr[changedIndex]
        ]);
      });
    });
    if (typeof this.headers !== "undefined") {
      arrayEach(sortedHeaders, (headerData, columnIndex) => {
        hot.getSettings().colHeaders[ascendingIndexes[columnIndex]] = headerData;
      });
    }
    this.removedCellMetas.forEach((entry) => {
      const [rowIndex, columnIndex, cellMeta] = entry;
      hot.setCellMetaObject(rowIndex, columnIndex, cellMeta);
    });
    hot.addHookOnce("afterViewRender", undoneCallback);
    hot.setSourceDataAtCell(changes, void 0, void 0, "UndoRedo.undo");
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    hot.addHookOnce("afterRemoveCol", redoneCallback);
    hot.alter("remove_col", this.index, this.amount, "UndoRedo.redo");
  }
  /**
  * Initializes the remove column action with the removed data, column indexes, headers, position sequences, and cell meta backup.
  */
  constructor({ index: index2, indexes, data, amount, headers, columnPositions, rowPositions, fixedColumnsStart, removedCellMetas }) {
    super("remove_col");
    this.index = index2;
    this.indexes = indexes;
    this.data = data;
    this.amount = amount;
    this.headers = headers;
    this.columnPositions = columnPositions.slice(0);
    this.rowPositions = rowPositions.slice(0);
    this.fixedColumnsStart = fixedColumnsStart;
    this.removedCellMetas = removedCellMetas;
  }
}
class RemoveRowAction extends BaseAction {
  /**
  * Registers the `beforeRemoveRow` hook listener that captures removed row data and records a RemoveRowAction.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeRemoveRow", (index2, amount, logicRows, source) => {
      const wrappedAction = () => {
        const physicalRowIndex = hot.toPhysicalRow(index2);
        const lastRowIndex = physicalRowIndex + amount - 1;
        const removedData = [];
        for (let i = 0; i < amount; i++) {
          const rowData = deepClone(hot.getSourceDataAtRow(physicalRowIndex + i));
          if (rowData && typeof rowData === "object" && !Array.isArray(rowData)) {
            delete rowData.__children;
          }
          removedData.push(rowData);
        }
        return new RemoveRowAction({
          index: physicalRowIndex,
          data: removedData,
          fixedRowsBottom: hot.getSettings().fixedRowsBottom ?? 0,
          fixedRowsTop: hot.getSettings().fixedRowsTop ?? 0,
          rowIndexesSequence: hot.rowIndexMapper.getIndexesSequence(),
          removedCellMetas: getCellMetas(hot, physicalRowIndex, lastRowIndex, 0, hot.countCols() - 1),
          removedMergedCells: collectAffectedMergedCells(hot, index2, amount)
        });
      };
      undoRedoPlugin.done(wrappedAction, source);
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const settings = hot.getSettings();
    const changes = [];
    settings.fixedRowsBottom = this.fixedRowsBottom;
    settings.fixedRowsTop = this.fixedRowsTop;
    this.data.forEach((row, rowIndexDelta) => {
      const dataRow = row;
      Object.keys(dataRow).forEach((columnProp) => {
        const columnIndex = Number.parseInt(columnProp, 10);
        changes.push([
          this.index + rowIndexDelta,
          isNaN(columnIndex) ? columnProp : columnIndex,
          dataRow[columnProp]
        ]);
      });
    });
    hot.rowIndexMapper.setIndexesSequence(this.rowIndexesSequence);
    hot.alter("insert_row_above", hot.toVisualRow(this.index), this.data.length, "UndoRedo.undo");
    hot.rowIndexMapper.setIndexesSequence(this.rowIndexesSequence);
    this.removedCellMetas.forEach((entry) => {
      const [rowIndex, columnIndex, cellMeta] = entry;
      hot.setCellMetaObject(rowIndex, columnIndex, cellMeta);
    });
    restoreMergedCells(hot, this.removedMergedCells);
    hot.addHookOnce("afterViewRender", undoneCallback);
    hot.setSourceDataAtCell(changes, void 0, void 0, "UndoRedo.undo");
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    hot.addHookOnce("afterRemoveRow", redoneCallback);
    hot.alter("remove_row", hot.toVisualRow(this.index), this.data.length, "UndoRedo.redo");
  }
  /**
  * Initializes the remove row action with the removed data, row index sequence, fixed-row counts, cell meta backup, and affected merged cells.
  */
  constructor({ index: index2, data, fixedRowsBottom, fixedRowsTop, rowIndexesSequence, removedCellMetas, removedMergedCells }) {
    super("remove_row");
    this.index = index2;
    this.data = data;
    this.fixedRowsBottom = fixedRowsBottom;
    this.fixedRowsTop = fixedRowsTop;
    this.rowIndexesSequence = rowIndexesSequence;
    this.removedCellMetas = removedCellMetas;
    this.removedMergedCells = removedMergedCells;
  }
}
function collectAffectedMergedCells(hot, visualRow, amount) {
  const mergeCellsPlugin = hot.getPlugin("mergeCells");
  if (!mergeCellsPlugin?.enabled) {
    return [];
  }
  const lastVisualRow = visualRow + amount - 1;
  const affected = [];
  mergeCellsPlugin.mergedCellsCollection?.mergedCells.forEach(({ row, col, rowspan, colspan }) => {
    const mergeStart = row;
    const mergeEnd = row + rowspan - 1;
    if (mergeStart <= lastVisualRow && mergeEnd >= visualRow) {
      affected.push({
        row,
        col,
        rowspan,
        colspan
      });
    }
  });
  return affected;
}
function restoreMergedCells(hot, mergedCells) {
  if (!mergedCells || mergedCells.length === 0) {
    return;
  }
  const mergeCellsPlugin = hot.getPlugin("mergeCells");
  if (!mergeCellsPlugin?.enabled) {
    return;
  }
  mergedCells.forEach(({ row, col, rowspan, colspan }) => {
    const endRow = row + rowspan - 1;
    const endCol = col + colspan - 1;
    const start = hot._createCellCoords(row, col);
    const end = hot._createCellCoords(endRow, endCol);
    const range = hot._createCellRange(start, start, end);
    mergeCellsPlugin.unmergeRange(range, true);
    mergeCellsPlugin.merge(row, col, endRow, endCol);
  });
}
class RowMoveAction extends BaseAction {
  /**
  * Registers the `beforeRowMove` hook listener that records a new RowMoveAction whenever rows are moved.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("beforeRowMove", (rows, finalIndex) => {
      if (rows === false) {
        return;
      }
      undoRedoPlugin.done(() => new RowMoveAction({
        rows,
        finalIndex
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const manualRowMove = hot.getPlugin("manualRowMove");
    hot.addHookOnce("afterViewRender", undoneCallback);
    const rowMoves = getMoves(this.rows, this.finalRowIndex, hot.rowIndexMapper.getNumberOfIndexes());
    rowMoves.reverse().forEach(({ from, to }) => {
      if (from < to) {
        to -= 1;
      }
      manualRowMove.moveRow(to, from);
    });
    hot.render();
    hot.deselectCell();
    hot.selectRows(this.rows[0], this.rows[0] + this.rows.length - 1);
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const manualRowMove = hot.getPlugin("manualRowMove");
    hot.addHookOnce("afterViewRender", redoneCallback);
    manualRowMove.moveRows(this.rows.slice(), this.finalRowIndex);
    hot.render();
    hot.deselectCell();
    hot.selectRows(this.finalRowIndex, this.finalRowIndex + this.rows.length - 1);
  }
  /**
  * Initializes the row move action with the array of moved row indexes and their destination index.
  */
  constructor({ rows, finalIndex }) {
    super("row_move");
    this.rows = rows.slice();
    this.finalRowIndex = finalIndex;
  }
}
class UnmergeCellsAction extends BaseAction {
  /**
  * Registers the `afterUnmergeCells` hook listener that records a new UnmergeCellsAction after cells are manually unmerged.
  */
  static startRegisteringEvents(hot, undoRedoPlugin) {
    hot.addHook("afterUnmergeCells", (cellRange, auto) => {
      if (auto) {
        return;
      }
      undoRedoPlugin.done(() => new UnmergeCellsAction({
        cellRange
      }));
    });
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} undoneCallback The callback to be called after the action is undone.
  */
  undo(hot, undoneCallback) {
    const mergeCellsPlugin = hot.getPlugin("mergeCells");
    hot.addHookOnce("afterViewRender", undoneCallback);
    mergeCellsPlugin.mergeRange(this.cellRange, true);
  }
  /**
  * @param {Core} hot The Handsontable instance.
  * @param {function(): void} redoneCallback The callback to be called after the action is redone.
  */
  redo(hot, redoneCallback) {
    const mergeCellsPlugin = hot.getPlugin("mergeCells");
    hot.addHookOnce("afterViewRender", redoneCallback);
    mergeCellsPlugin.unmergeRange(this.cellRange, true);
    hot.render();
  }
  /**
  * Initializes the unmerge cells action with the cell range that was unmerged.
  */
  constructor({ cellRange }) {
    super("unmerge_cells");
    this.cellRange = cellRange;
  }
}
function registerActions(hot, undoRedoPlugin) {
  [
    CellAlignmentAction,
    ColumnMoveAction,
    ColumnSortAction,
    CreateColumnAction,
    CreateRowAction,
    DataChangeAction,
    FiltersAction,
    MergeCellsAction,
    RemoveColumnAction,
    RemoveRowAction,
    RowMoveAction,
    UnmergeCellsAction
  ].forEach((action) => action.startRegisteringEvents(hot, undoRedoPlugin));
}
function _check_private_redeclaration$7(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$7(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$7(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$7(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$7(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$7(receiver, privateMap, "get");
  return _class_apply_descriptor_get$7(receiver, descriptor);
}
function _class_private_field_init$7(obj, privateMap, value) {
  _check_private_redeclaration$7(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$7(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$7(receiver, privateMap, "set");
  _class_apply_descriptor_set$7(receiver, descriptor, value);
  return value;
}
const SHORTCUTS_GROUP$2 = "undoRedo";
const PLUGIN_KEY$4 = "undoRedo";
const PLUGIN_PRIORITY$4 = 1e3;
Hooks.getSingleton().register("beforeUndo");
Hooks.getSingleton().register("afterUndo");
Hooks.getSingleton().register("beforeRedo");
Hooks.getSingleton().register("afterRedo");
var _onAfterChange = /* @__PURE__ */ new WeakMap();
class UndoRedo2 extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$4;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$4;
  }
  /**
  * Returns whether the plugin handles its own settings keys without a dedicated key list.
  */
  static get SETTING_KEYS() {
    return true;
  }
  /**
  * Checks if the plugin is enabled in the handsontable settings. This method is executed in {@link Hooks#beforeInit}
  * hook and if it returns `true` then the {@link UndoRedo#enablePlugin} method is called.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings().undo;
  }
  /**
  * Enables the plugin functionality for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    this.addHook("afterChange", _class_private_field_get$7(this, _onAfterChange));
    this.registerShortcuts();
    super.enablePlugin();
  }
  /**
  * Disables the plugin functionality for this Handsontable instance.
  */
  disablePlugin() {
    super.disablePlugin();
    this.clear();
    this.unregisterShortcuts();
  }
  /**
  * Registers shortcuts responsible for performing undo/redo.
  *
  * @private
  */
  registerShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const gridContext = shortcutManager.getContext("grid");
    const runOnlyIf = (event) => {
      return !event?.altKey;
    };
    const config = {
      runOnlyIf,
      group: SHORTCUTS_GROUP$2
    };
    gridContext?.addShortcuts([
      {
        keys: [
          [
            "Control/Meta",
            "z"
          ]
        ],
        callback: () => {
          this.undo();
        }
      },
      {
        keys: [
          [
            "Control/Meta",
            "y"
          ],
          [
            "Control/Meta",
            "Shift",
            "z"
          ]
        ],
        callback: () => {
          this.redo();
        }
      }
    ], {
      ...config
    });
  }
  /**
  * Unregister shortcuts responsible for performing undo/redo.
  *
  * @private
  */
  unregisterShortcuts() {
    const shortcutManager = this.hot.getShortcutManager();
    const gridContext = shortcutManager.getContext("grid");
    gridContext?.removeShortcutsByGroup(SHORTCUTS_GROUP$2);
  }
  /**
  * Stash information about performed actions.
  *
  * @fires Hooks#beforeUndoStackChange
  * @fires Hooks#afterUndoStackChange
  * @fires Hooks#beforeRedoStackChange
  * @fires Hooks#afterRedoStackChange
  * @param {Function} wrappedAction The action descriptor wrapped in a closure.
  * @param {string} [source] Source of the action. It is defined just for more general actions (not related to plugins).
  */
  done(wrappedAction, source) {
    if (this.ignoreNewActions) {
      return;
    }
    const isBlockedByDefault = source === "UndoRedo.undo" || source === "UndoRedo.redo" || source === "auto";
    if (isBlockedByDefault) {
      return;
    }
    const doneActionsCopy = this.doneActions.slice();
    const continueAction = this.hot.runHooks("beforeUndoStackChange", doneActionsCopy, source);
    if (continueAction === false) {
      return;
    }
    const newAction = wrappedAction();
    const undoneActionsCopy = this.undoneActions.slice();
    if (newAction !== null) {
      this.doneActions.push(newAction);
    }
    this.hot.runHooks("afterUndoStackChange", doneActionsCopy, this.doneActions.slice());
    this.hot.runHooks("beforeRedoStackChange", undoneActionsCopy);
    this.undoneActions.length = 0;
    this.hot.runHooks("afterRedoStackChange", undoneActionsCopy, this.undoneActions.slice());
  }
  /**
  * Undo the last action performed to the table.
  *
  * @fires Hooks#beforeUndoStackChange
  * @fires Hooks#afterUndoStackChange
  * @fires Hooks#beforeRedoStackChange
  * @fires Hooks#afterRedoStackChange
  * @fires Hooks#beforeUndo
  * @fires Hooks#afterUndo
  */
  undo() {
    if (!this.isUndoAvailable()) {
      return;
    }
    const doneActionsCopy = this.doneActions.slice();
    this.hot.runHooks("beforeUndoStackChange", doneActionsCopy);
    const action = this.doneActions.pop();
    this.hot.runHooks("afterUndoStackChange", doneActionsCopy, this.doneActions.slice());
    const actionClone = deepClone(action);
    const continueAction = this.hot.runHooks("beforeUndo", actionClone);
    if (continueAction === false) {
      return;
    }
    this.ignoreNewActions = true;
    const undoneActionsCopy = this.undoneActions.slice();
    this.hot.runHooks("beforeRedoStackChange", undoneActionsCopy);
    action.undo(this.hot, () => {
      this.ignoreNewActions = false;
      this.undoneActions.push(action);
    });
    this.hot.runHooks("afterRedoStackChange", undoneActionsCopy, this.undoneActions.slice());
    this.hot.runHooks("afterUndo", actionClone);
  }
  /**
  * Redo the previous action performed to the table (used to reverse an undo).
  *
  * @fires Hooks#beforeUndoStackChange
  * @fires Hooks#afterUndoStackChange
  * @fires Hooks#beforeRedoStackChange
  * @fires Hooks#afterRedoStackChange
  * @fires Hooks#beforeRedo
  * @fires Hooks#afterRedo
  */
  redo() {
    if (!this.isRedoAvailable()) {
      return;
    }
    const undoneActionsCopy = this.undoneActions.slice();
    this.hot.runHooks("beforeRedoStackChange", undoneActionsCopy);
    const action = this.undoneActions.pop();
    this.hot.runHooks("afterRedoStackChange", undoneActionsCopy, this.undoneActions.slice());
    const actionClone = deepClone(action);
    const continueAction = this.hot.runHooks("beforeRedo", actionClone);
    if (continueAction === false) {
      return;
    }
    this.ignoreNewActions = true;
    const doneActionsCopy = this.doneActions.slice();
    this.hot.runHooks("beforeUndoStackChange", doneActionsCopy);
    action.redo(this.hot, () => {
      this.ignoreNewActions = false;
      this.doneActions.push(action);
    });
    this.hot.runHooks("afterUndoStackChange", doneActionsCopy, this.doneActions.slice());
    this.hot.runHooks("afterRedo", actionClone);
  }
  /**
  * Checks if undo action is available.
  *
  * @returns {boolean} Return `true` if undo can be performed, `false` otherwise.
  */
  isUndoAvailable() {
    return this.doneActions.length > 0;
  }
  /**
  * Checks if redo action is available.
  *
  * @returns {boolean} Return `true` if redo can be performed, `false` otherwise.
  */
  isRedoAvailable() {
    return this.undoneActions.length > 0;
  }
  /**
  * Clears undo and redo history.
  */
  clear() {
    this.doneActions.length = 0;
    this.undoneActions.length = 0;
  }
  /**
  * Destroys the plugin instance.
  */
  destroy() {
    this.clear();
    this.doneActions = [];
    this.undoneActions = [];
    super.destroy();
  }
  /**
  * Initializes the plugin and registers all built-in undo/redo action handlers for the given Handsontable instance.
  */
  constructor(hotInstance) {
    super(hotInstance), _class_private_field_init$7(this, _onAfterChange, {
      writable: true,
      value: void 0
    }), /**
    * The list of registered action do undo.
    *
    * @private
    * @type {Array}
    */
    this.doneActions = [], /**
    * The list of registered action do redo.
    *
    * @private
    * @type {Array}
    */
    this.undoneActions = [], /**
    * The flag that determines if new actions should be ignored.
    *
    * @private
    * @type {boolean}
    */
    this.ignoreNewActions = false, _class_private_field_set$7(this, _onAfterChange, (changes, source) => {
      if (source === "loadData") {
        this.clear();
      }
    });
    registerActions(hotInstance, this);
  }
}
const DIALOG_CLASS_NAME = "ht-dialog";
function baseTemplate() {
  function template() {
    return `
      <div data-ref="contentElement" class="${DIALOG_CLASS_NAME}__content"></div>
    `;
  }
  let fragment = null;
  const refs = {};
  function compile() {
    const elements = html`${template()}`;
    Object.assign(refs, elements.refs);
    fragment = elements.fragment;
    return elements;
  }
  function focusableElements() {
    if (fragment === null) {
      throwWithCause("Compile the template first.");
    }
    return [];
  }
  return {
    TEMPLATE_NAME: "base",
    dialogA11YOptions() {
      return {
        role: "dialog"
      };
    },
    compile,
    focusableElements
  };
}
function confirmTemplate({ id = "", title = "", description = "", buttons = [] }) {
  function template() {
    return `
      <div tabindex="-1" data-ref="contentElement" class="${DIALOG_CLASS_NAME}__content-wrapper-inner">
        <div class="${DIALOG_CLASS_NAME}__content">
          <h2
            id="${id}-dialog-confirm-title"
            class="${DIALOG_CLASS_NAME}__title">${stripTags(title)}</h2>
          <p
            id="${id}-dialog-confirm-description"
            class="${DIALOG_CLASS_NAME}__description">${stripTags(description)}</p>
        </div>
        ${buttons.length > 0 ? `
          <div data-ref="buttonsContainer" class="${DIALOG_CLASS_NAME}__buttons">
            ${buttons.map((button) => `
              <button class="ht-button ht-button--${button.type}">${stripTags(button.text)}</button>
            `).join("")}
          </div>
        ` : ""}
      </div>
    `;
  }
  let fragment = null;
  const refs = {};
  function compile() {
    const elements = html`${template()}`;
    Object.assign(refs, elements.refs);
    fragment = elements.fragment;
    return elements;
  }
  function focusableElements() {
    if (fragment === null) {
      throwWithCause("Compile the template first.");
    }
    const { contentElement, buttonsContainer } = refs;
    const elements = [];
    if (buttonsContainer) {
      elements.push(...Array.from(buttonsContainer.children));
    } else {
      elements.push(contentElement);
    }
    return elements;
  }
  return {
    TEMPLATE_NAME: "confirm",
    dialogA11YOptions() {
      return {
        role: "alertdialog",
        ariaLabelledby: `${id}-dialog-confirm-title`,
        ariaDescribedby: description ? `${id}-dialog-confirm-description` : void 0
      };
    },
    compile,
    focusableElements
  };
}
const TEMPLATES = /* @__PURE__ */ new Map([
  [
    "base",
    baseTemplate
  ],
  [
    "confirm",
    confirmTemplate
  ]
]);
function _check_private_redeclaration$6(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$6(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$6(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$6(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$6(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$6(receiver, privateMap, "get");
  return _class_apply_descriptor_get$6(receiver, descriptor);
}
function _class_private_field_init$6(obj, privateMap, value) {
  _check_private_redeclaration$6(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$6(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$6(receiver, privateMap, "set");
  _class_apply_descriptor_set$6(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$4(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$4(obj, privateSet) {
  _check_private_redeclaration$6(obj, privateSet);
  privateSet.add(obj);
}
const CONTAINER_TEMPLATE = `
<div data-ref="dialogElement" class="${DIALOG_CLASS_NAME}">
  <div data-ref="dialogWrapperElement" class="${DIALOG_CLASS_NAME}__content-wrapper">
</div>
`;
var _overlayContainer = /* @__PURE__ */ new WeakMap(), _refs$1 = /* @__PURE__ */ new WeakMap(), _isRtl$1 = /* @__PURE__ */ new WeakMap(), _animationStarted = /* @__PURE__ */ new WeakMap(), _template = /* @__PURE__ */ new WeakMap(), _templateButtonCallbacks = /* @__PURE__ */ new WeakMap(), _sanitizer$1 = /* @__PURE__ */ new WeakMap(), _onTransitionEnd = /* @__PURE__ */ new WeakSet(), _onTransitionStart = /* @__PURE__ */ new WeakSet();
class DialogUI {
  /**
  * Uses the specified template for the dialog.
  *
  * @param {string} templateName The name of the template to use.
  * @param {object} templateVars The variables to use for the template.
  */
  useTemplate(templateName, templateVars = {}) {
    if (!TEMPLATES.has(templateName) || templateName === "base") {
      const validTemplates = Array.from(TEMPLATES.keys()).filter((template) => template !== "base").join(", ");
      throwWithCause(toSingleLine`Invalid template: ${templateName}.\x20
        Valid templates are: ${validTemplates}.`);
    }
    _class_private_field_set$6(this, _template, TEMPLATES.get(templateName)(templateVars));
    _class_private_field_set$6(this, _templateButtonCallbacks, (templateVars.buttons ?? []).map((button) => button.callback));
  }
  /**
  * Uses the default template for the dialog for the `content` option.
  */
  useDefaultTemplate() {
    _class_private_field_set$6(this, _template, TEMPLATES.get("base")());
    _class_private_field_set$6(this, _templateButtonCallbacks, []);
  }
  /**
  * Creates the dialog UI elements and sets up the structure.
  */
  install() {
    if (_class_private_field_get$6(this, _refs$1)?.dialogElement) {
      return;
    }
    const elements = html`${CONTAINER_TEMPLATE}`;
    _class_private_field_set$6(this, _refs$1, elements.refs);
    const { dialogElement } = _class_private_field_get$6(this, _refs$1);
    setAttribute(dialogElement, [
      A11Y_MODAL(),
      [
        "dir",
        _class_private_field_get$6(this, _isRtl$1) ? "rtl" : "ltr"
      ]
    ]);
    dialogElement.addEventListener("transitionstart", () => _class_private_method_get$4(this, _onTransitionStart, onTransitionStart).call(this));
    dialogElement.addEventListener("transitionend", () => _class_private_method_get$4(this, _onTransitionEnd, onTransitionEnd).call(this));
    if (_class_private_field_get$6(this, _overlayContainer)) {
      _class_private_field_get$6(this, _overlayContainer).appendChild(elements.fragment);
    }
  }
  /**
  * Returns the dialog element.
  *
  * @returns {HTMLElement} The dialog element.
  */
  getContainer() {
    return _class_private_field_get$6(this, _refs$1).dialogElement;
  }
  /**
  * Gets the focusable elements.
  *
  * @returns {HTMLElement[]} The focusable elements.
  */
  getFocusableElements() {
    return _class_private_field_get$6(this, _template).focusableElements();
  }
  /**
  * Updates the dialog content and class name.
  *
  * @param {object} options - Class name update options.
  * @param {boolean} options.isVisible - Whether the dialog is visible.
  * @param {string|HTMLElement} options.content - The content to render in the dialog.
  * @param {string} options.customClassName - The custom class name to add to the dialog.
  * @param {string} options.background - The background to add to the dialog.
  * @param {boolean} options.contentBackground - Whether to show content background.
  * @param {boolean} options.animation - Whether to add the animation class to the dialog.
  * @param {object} options.a11y - The accessibility options for the dialog.
  *
  * @returns {DialogUI} The instance of the DialogUI.
  */
  updateDialog({ isVisible: isVisible2, content, customClassName, background, contentBackground, animation, a11y }) {
    const elements = _class_private_field_get$6(this, _template).compile();
    const { dialogElement, dialogWrapperElement } = _class_private_field_get$6(this, _refs$1);
    const typedA11y = a11y;
    dialogWrapperElement.innerHTML = "";
    dialogWrapperElement.appendChild(elements.fragment);
    Object.assign(_class_private_field_get$6(this, _refs$1), elements.refs);
    const { contentElement, buttonsContainer } = _class_private_field_get$6(this, _refs$1);
    if (_class_private_field_get$6(this, _template).TEMPLATE_NAME !== "base") {
      Object.assign(typedA11y, _class_private_field_get$6(this, _template).dialogA11YOptions());
    }
    const customClass = customClassName ? ` ${customClassName}` : "";
    const backgroundClass = background ? ` ${DIALOG_CLASS_NAME}--background-${background}` : "";
    const animationClass = animation ? ` ${DIALOG_CLASS_NAME}--animation` : "";
    const showClass = isVisible2 ? ` ${DIALOG_CLASS_NAME}--show` : "";
    dialogElement.className = [
      DIALOG_CLASS_NAME,
      `${DIALOG_CLASS_NAME}--${_class_private_field_get$6(this, _template).TEMPLATE_NAME}`,
      "handsontable",
      customClass,
      backgroundClass,
      animationClass,
      showClass
    ].join(" ");
    if (_class_private_field_get$6(this, _template).TEMPLATE_NAME === "base") {
      setAttribute(dialogElement, [
        A11Y_TABINDEX(-1)
      ]);
    }
    setAttribute(dialogElement, [
      typedA11y.role === "alertdialog" ? A11Y_ALERTDIALOG() : A11Y_DIALOG()
    ]);
    if (typedA11y.ariaLabel && !typedA11y.ariaLabelledby) {
      setAttribute(dialogElement, [
        A11Y_LABEL(typedA11y.ariaLabel)
      ]);
    } else {
      removeAttribute(dialogElement, "aria-label");
    }
    if (typedA11y.ariaLabelledby) {
      setAttribute(dialogElement, [
        A11Y_LABELED_BY(typedA11y.ariaLabelledby)
      ]);
    } else {
      removeAttribute(dialogElement, "aria-labelledby");
    }
    if (typedA11y.ariaDescribedby) {
      setAttribute(dialogElement, [
        A11Y_DESCRIBED_BY(typedA11y.ariaDescribedby)
      ]);
    } else {
      removeAttribute(dialogElement, "aria-describedby");
    }
    const contentBackgroundClass = contentBackground ? ` ${DIALOG_CLASS_NAME}__content--background` : "";
    addClass(contentElement, `${DIALOG_CLASS_NAME}__content${contentBackgroundClass}`);
    if (_class_private_field_get$6(this, _template).TEMPLATE_NAME === "base") {
      contentElement.innerHTML = "";
      if (typeof content === "string") {
        fastInnerHTML(contentElement, content, _class_private_field_get$6(this, _sanitizer$1) ? (html2, ctx) => _class_private_field_get$6(this, _sanitizer$1).call(this, html2) ?? html2 : void 0, "dialog", _class_private_field_get$6(this, _overlayContainer));
      } else if (isHTMLElement(content) || content instanceof DocumentFragment) {
        contentElement.appendChild(content);
      }
    } else if (buttonsContainer) {
      Array.from(buttonsContainer.children).forEach((button, index2) => {
        const callback = _class_private_field_get$6(this, _templateButtonCallbacks)[index2];
        if (callback) {
          button.addEventListener("click", callback);
        }
      });
    }
    return this;
  }
  /**
  * Shows the dialog with optional animation.
  *
  * @param {boolean} animation - Whether to add the animation class to the dialog.
  * @returns {DialogUI} The instance of the DialogUI.
  */
  showDialog(animation) {
    const { dialogElement } = _class_private_field_get$6(this, _refs$1);
    dialogElement.style.display = "block";
    if (animation) {
      dialogElement.offsetHeight;
    }
    addClass(dialogElement, `${DIALOG_CLASS_NAME}--show`);
    _class_private_field_set$6(this, _animationStarted, false);
    return this;
  }
  /**
  * Hides the dialog with optional animation.
  *
  * @param {boolean} animation - Whether to add the animation class to the dialog.
  * @returns {DialogUI} The instance of the DialogUI.
  */
  hideDialog(animation) {
    const { dialogElement } = _class_private_field_get$6(this, _refs$1);
    removeClass(dialogElement, `${DIALOG_CLASS_NAME}--show`);
    if (animation && !_class_private_field_get$6(this, _animationStarted) || !animation) {
      dialogElement.style.display = "none";
    }
    _class_private_field_set$6(this, _animationStarted, false);
    return this;
  }
  /**
  * Focuses the dialog element.
  */
  focusDialog() {
    _class_private_field_get$6(this, _refs$1).dialogElement.focus();
  }
  /**
  * Updates the width of the dialog container to the same size as the table.
  *
  * @param {number} width - The width of the table.
  * @returns {DialogUI} The instance of the DialogUI.
  */
  updateWidth(width) {
    _class_private_field_get$6(this, _refs$1).dialogElement.style.width = `${width}px`;
    return this;
  }
  /**
  * Removes the dialog UI elements from the DOM and clears the refs.
  */
  destroyDialog() {
    _class_private_field_get$6(this, _refs$1)?.dialogElement.remove();
    _class_private_field_set$6(this, _refs$1, void 0);
  }
  /**
  * Initializes the dialog UI with an overlay container, RTL layout flag, and an optional HTML sanitizer, then installs the DOM structure.
  */
  constructor({ overlayContainer, isRtl: isRtl2, sanitizer }) {
    _class_private_method_init$4(this, _onTransitionEnd);
    _class_private_method_init$4(this, _onTransitionStart);
    _class_private_field_init$6(this, _overlayContainer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$6(this, _refs$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$6(this, _isRtl$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$6(this, _animationStarted, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$6(this, _template, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$6(this, _templateButtonCallbacks, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$6(this, _sanitizer$1, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$6(this, _isRtl$1, false);
    _class_private_field_set$6(this, _animationStarted, false);
    _class_private_field_set$6(this, _template, TEMPLATES.get("base")());
    _class_private_field_set$6(this, _templateButtonCallbacks, []);
    _class_private_field_set$6(this, _overlayContainer, overlayContainer);
    _class_private_field_set$6(this, _isRtl$1, isRtl2);
    _class_private_field_set$6(this, _sanitizer$1, sanitizer);
    this.install();
  }
}
function onTransitionEnd() {
  const { dialogElement } = _class_private_field_get$6(this, _refs$1);
  if (!hasClass(dialogElement, `${DIALOG_CLASS_NAME}--show`)) {
    dialogElement.style.display = "none";
  }
}
function onTransitionStart() {
  _class_private_field_set$6(this, _animationStarted, true);
}
mixin(DialogUI, localHooks);
function _check_private_redeclaration$5(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$5(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$5(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$5(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$5(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$5(receiver, privateMap, "get");
  return _class_apply_descriptor_get$5(receiver, descriptor);
}
function _class_private_field_init$5(obj, privateMap, value) {
  _check_private_redeclaration$5(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$5(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$5(receiver, privateMap, "set");
  _class_apply_descriptor_set$5(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$3(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$3(obj, privateSet) {
  _check_private_redeclaration$5(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$3 = "dialog";
const PLUGIN_PRIORITY$3 = 360;
const SHORTCUTS_GROUP$1 = PLUGIN_KEY$3;
const SHORTCUTS_CONTEXT_NAME$2 = `plugin:${PLUGIN_KEY$3}`;
var _ui$2 = /* @__PURE__ */ new WeakMap(), _isVisible$1 = /* @__PURE__ */ new WeakMap(), _selectionState$1 = /* @__PURE__ */ new WeakMap(), _registerShortcuts = /* @__PURE__ */ new WeakSet(), _unregisterShortcuts = /* @__PURE__ */ new WeakSet(), _registerFocusScope$2 = /* @__PURE__ */ new WeakSet(), _unregisterFocusScope$2 = /* @__PURE__ */ new WeakSet(), _onAfterViewRender = /* @__PURE__ */ new WeakSet();
class Dialog extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$3;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$3;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      template: null,
      content: "",
      customClassName: "",
      background: "solid",
      contentBackground: false,
      animation: true,
      closable: false,
      a11y: {
        role: "dialog",
        ariaLabel: "Dialog",
        ariaLabelledby: "",
        ariaDescribedby: ""
      }
    };
  }
  /**
  * Returns validator functions for each plugin setting to verify their values are valid before applying them.
  */
  static get SETTINGS_VALIDATORS() {
    return {
      template: (value) => isPlainObject$1(value) && typeof [
        "alert",
        "confirm"
      ].includes(String(value.type)) && typeof value.title === "string" && (typeof value?.description === "undefined" || typeof value?.description === "string") && (typeof value?.buttons === "undefined" || Array.isArray(value?.buttons) && value.buttons.every((item) => isPlainObject$1(item) && typeof item.text === "string" && [
        "primary",
        "secondary"
      ].includes(String(item.type)) && (typeof item.callback === "undefined" || typeof item.callback === "function"))),
      content: (value) => typeof value === "string" || isHTMLElement(value) || typeof DocumentFragment !== "undefined" && value instanceof DocumentFragment,
      customClassName: (value) => typeof value === "string",
      background: (value) => typeof value === "string" && [
        "solid",
        "semi-transparent"
      ].includes(value),
      contentBackground: (value) => typeof value === "boolean",
      animation: (value) => typeof value === "boolean",
      closable: (value) => typeof value === "boolean",
      a11y: (value) => isPlainObject$1(value) && (typeof value?.role === "undefined" || typeof value?.role === "string" && [
        "dialog",
        "alertdialog"
      ].includes(value.role)) && (typeof value?.ariaLabel === "undefined" || typeof value?.ariaLabel === "string") && (typeof value?.ariaLabelledby === "undefined" || typeof value?.ariaLabelledby === "string") && (typeof value?.ariaDescribedby === "undefined" || typeof value?.ariaDescribedby === "string")
    };
  }
  /**
  * Check if the plugin is enabled in the handsontable settings.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$3];
  }
  /**
  * Enable plugin for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    if (!_class_private_field_get$5(this, _ui$2)) {
      _class_private_field_set$5(this, _ui$2, new DialogUI({
        overlayContainer: this.hot.rootOverlaysElement,
        sanitizer: this.hot.getSettings().sanitizer,
        isRtl: this.hot.isRtl()
      }));
    }
    _class_private_method_get$3(this, _registerShortcuts, registerShortcuts).call(this);
    _class_private_method_get$3(this, _registerFocusScope$2, registerFocusScope$2).call(this);
    this.addHook("afterViewRender", () => _class_private_method_get$3(this, _onAfterViewRender, onAfterViewRender).call(this));
    super.enablePlugin();
  }
  /**
  * Update plugin state after Handsontable settings update.
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disable plugin for this Handsontable instance.
  */
  disablePlugin() {
    this.hide();
    _class_private_method_get$3(this, _unregisterShortcuts, unregisterShortcuts).call(this);
    _class_private_method_get$3(this, _unregisterFocusScope$2, unregisterFocusScope$2).call(this);
    _class_private_field_get$5(this, _ui$2)?.destroyDialog();
    _class_private_field_set$5(this, _ui$2, null);
    super.disablePlugin();
  }
  /**
  * Check if the dialog is currently visible.
  *
  * @returns {boolean} True if the dialog is visible, false otherwise.
  */
  isVisible() {
    return _class_private_field_get$5(this, _isVisible$1);
  }
  /**
  * Show dialog with given configuration.
  * Displays the dialog with the specified content and options.
  *
  * @param {object} options Dialog configuration object containing content and display options.
  * @param {object} options.template The template to use for the dialog (default: `null`). The error will be thrown when
  * the template is provided together with the `content` option.
  * @param {'confirm'} options.template.type The type of the template ('confirm').
  * @param {string} options.template.title The title of the dialog.
  * @param {string} options.template.description The description of the dialog. Default: ''.
  * @param {object[]} options.template.buttons The buttons to display in the dialog. Default: [].
  * @param {string} options.template.buttons.text The text of the button.
  * @param {'primary' | 'secondary'} options.template.buttons.type The type of the button.
  * @param {function(MouseEvent)} options.template.buttons.callback The callback to trigger when the button is clicked.
  * @param {string|HTMLElement|DocumentFragment} options.content The content to display in the dialog. Can be a string, HTMLElement, or DocumentFragment. Default: ''
  * @param {string} options.customClassName Custom CSS class name to apply to the dialog container. Default: ''
  * @param {'solid'|'semi-transparent'} options.background Dialog background variant. Default: 'solid'.
  * @param {boolean} options.contentBackground Whether to show content background. Default: false.
  * @param {boolean} options.animation Whether to enable animations when showing/hiding the dialog. Default: true.
  * @param {boolean} options.closable Whether the dialog can be closed by user interaction. Default: false.
  * @param {object} options.a11y Object with accessibility options.
  * @param {string} options.a11y.role The role of the dialog. Default: 'dialog'.
  * @param {string} options.a11y.ariaLabel The label of the dialog. Default: 'Dialog'.
  * @param {string} options.a11y.ariaLabelledby The ID of the element that labels the dialog. Default: ''.
  * @param {string} options.a11y.ariaDescribedby The ID of the element that describes the dialog. Default: ''.
  */
  show(options = {}) {
    if (!this.enabled) {
      return;
    }
    if (this.isVisible()) {
      this.update(options);
      return;
    }
    this.hot.runHooks("beforeDialogShow");
    this.update(options);
    _class_private_field_get$5(this, _ui$2).showDialog(this.getSetting("animation"));
    _class_private_field_set$5(this, _isVisible$1, true);
    this.hot.getFocusScopeManager().activateScope(PLUGIN_KEY$3);
    _class_private_field_set$5(this, _selectionState$1, this.hot.selection.exportSelection());
    this.hot.deselectCell();
    this.hot.runHooks("afterDialogShow");
  }
  /**
  * Hide the currently open dialog.
  * Closes the dialog and restores the focus to the table.
  */
  hide() {
    if (!this.isVisible()) {
      return;
    }
    this.hot.runHooks("beforeDialogHide");
    _class_private_field_get$5(this, _ui$2).hideDialog(this.getSetting("animation"));
    _class_private_field_set$5(this, _isVisible$1, false);
    this.hot.getFocusScopeManager().deactivateScope(PLUGIN_KEY$3);
    if (_class_private_field_get$5(this, _selectionState$1) && _class_private_field_get$5(this, _selectionState$1).ranges.length > 0 && _class_private_field_get$5(this, _selectionState$1).activeRange) {
      const state = _class_private_field_get$5(this, _selectionState$1);
      this.hot.selection.importSelection({
        ranges: state.ranges,
        activeRange: state.activeRange,
        activeSelectionLayer: state.activeSelectionLayer,
        selectedByRowHeader: state.selectedByRowHeader,
        selectedByColumnHeader: state.selectedByColumnHeader,
        disableHeadersHighlight: state.disableHeadersHighlight
      });
      this.hot.view.render();
      _class_private_field_set$5(this, _selectionState$1, null);
    } else {
      this.hot.view.render();
      _class_private_field_set$5(this, _selectionState$1, null);
    }
    this.hot.runHooks("afterDialogHide");
  }
  /**
  * Update the dialog configuration.
  *
  * @param {object} options Dialog configuration object containing content and display options.
  * @param {object} options.template The template to use for the dialog (default: `null`). The error will be thrown when
  * the template is provided together with the `content` option.
  * @param {'confirm'} options.template.type The type of the template ('confirm').
  * @param {string} options.template.title The title of the dialog.
  * @param {string} options.template.description The description of the dialog. Default: ''.
  * @param {object[]} options.template.buttons The buttons to display in the dialog. Default: [].
  * @param {string} options.template.buttons.text The text of the button.
  * @param {'primary' | 'secondary'} options.template.buttons.type The type of the button.
  * @param {function(MouseEvent)} options.template.buttons.callback The callback to trigger when the button is clicked.
  * @param {string|HTMLElement|DocumentFragment} options.content The content to display in the dialog. Can be a string, HTMLElement, or DocumentFragment. Default: ''
  * @param {string} options.customClassName Custom CSS class name to apply to the dialog container. Default: ''
  * @param {'solid'|'semi-transparent'} options.background Dialog background variant. Default: 'solid'.
  * @param {boolean} options.contentBackground Whether to show content background. Default: false.
  * @param {boolean} options.animation Whether to enable animations when showing/hiding the dialog. Default: true.
  * @param {boolean} options.closable Whether the dialog can be closed by user interaction. Default: false.
  * @param {object} options.a11y Object with accessibility options.
  * @param {string} options.a11y.role The role of the dialog. Default: 'dialog'.
  * @param {string} options.a11y.ariaLabel The label of the dialog. Default: 'Dialog'.
  * @param {string} options.a11y.ariaLabelledby The ID of the element that labels the dialog. Default: ''.
  * @param {string} options.a11y.ariaDescribedby The ID of the element that describes the dialog. Default: ''.
  */
  update(options) {
    if (!this.enabled) {
      return;
    }
    this.updatePluginSettings(options);
    const templateValue = this.getSetting("template");
    if (templateValue !== Dialog.DEFAULT_SETTINGS.template && this.getSetting("content") !== Dialog.DEFAULT_SETTINGS.content) {
      throwWithCause("The `template` option cannot be used together with the `content` option.");
    }
    if (templateValue) {
      const template = templateValue;
      _class_private_field_get$5(this, _ui$2).useTemplate(template.type, {
        id: this.hot.guid,
        ...template
      });
    } else {
      _class_private_field_get$5(this, _ui$2).useDefaultTemplate();
    }
    _class_private_field_get$5(this, _ui$2).updateDialog({
      isVisible: this.isVisible(),
      content: this.getSetting("content"),
      customClassName: this.getSetting("customClassName"),
      background: this.getSetting("background"),
      contentBackground: this.getSetting("contentBackground"),
      animation: this.getSetting("animation"),
      a11y: this.getSetting("a11y")
    });
  }
  /**
  * Displays the alert dialog with the specified content.
  *
  * @param {string | { title: string, description: string }} message The message to display in the dialog.
  * Can be a string or an object with `title` and `description` properties.
  * @param {function(MouseEvent): void} [callback] The callback to trigger when the button is clicked.
  */
  showAlert(message, callback) {
    const { title = "Alert", description } = isObject$1(message) ? message : {
      title: message
    };
    this.show({
      template: {
        type: "confirm",
        title,
        description,
        buttons: [
          {
            text: this.hot.getTranslatedPhrase(OK),
            type: "primary",
            callback: (...args) => callback?.(...args)
          }
        ]
      },
      contentBackground: false,
      background: "solid",
      animation: true,
      closable: false
    });
  }
  /**
  * Displays the confirm dialog with the specified content and options.
  *
  * @param {string | { title: string, description: string }} message The message to display in the dialog.
  * Can be a string or an object with `title` and `description` properties.
  * @param {function(MouseEvent): void} [onOk] The callback to trigger when the OK button is clicked.
  * @param {function(MouseEvent): void} [onCancel] The callback to trigger when the Cancel button is clicked.
  */
  showConfirm(message, onOk, onCancel) {
    const { title = "Confirm", description } = isObject$1(message) ? message : {
      title: message
    };
    this.show({
      template: {
        type: "confirm",
        title,
        description,
        buttons: [
          {
            text: this.hot.getTranslatedPhrase(CANCEL),
            type: "secondary",
            callback: (...args) => onCancel?.(...args)
          },
          {
            text: this.hot.getTranslatedPhrase(OK),
            type: "primary",
            callback: (...args) => onOk?.(...args)
          }
        ]
      },
      contentBackground: true,
      background: "semi-transparent",
      animation: true,
      closable: false
    });
  }
  /**
  * Focus the dialog.
  */
  focus() {
    _class_private_field_get$5(this, _ui$2).focusDialog();
  }
  /**
  * Destroy dialog and reset plugin state.
  */
  destroy() {
    _class_private_field_get$5(this, _ui$2)?.destroyDialog();
    _class_private_field_set$5(this, _ui$2, null);
    _class_private_field_set$5(this, _isVisible$1, false);
    _class_private_field_set$5(this, _selectionState$1, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$3(this, _registerShortcuts), _class_private_method_init$3(this, _unregisterShortcuts), _class_private_method_init$3(this, _registerFocusScope$2), _class_private_method_init$3(this, _unregisterFocusScope$2), _class_private_method_init$3(this, _onAfterViewRender), _class_private_field_init$5(this, _ui$2, {
      writable: true,
      value: void 0
    }), _class_private_field_init$5(this, _isVisible$1, {
      writable: true,
      value: void 0
    }), _class_private_field_init$5(this, _selectionState$1, {
      writable: true,
      value: void 0
    }), _class_private_field_set$5(this, _ui$2, null), _class_private_field_set$5(this, _isVisible$1, false), _class_private_field_set$5(this, _selectionState$1, null);
  }
}
function registerShortcuts() {
  const manager = this.hot.getShortcutManager();
  const pluginContext = manager.getContext(SHORTCUTS_CONTEXT_NAME$2) ?? manager.addContext(SHORTCUTS_CONTEXT_NAME$2);
  pluginContext.addShortcut({
    keys: [
      [
        "Escape"
      ]
    ],
    callback: () => {
      this.hide();
    },
    runOnlyIf: () => _class_private_field_get$5(this, _isVisible$1) && Boolean(this.getSetting("closable")),
    group: SHORTCUTS_GROUP$1
  });
  pluginContext.addShortcut({
    keys: [
      [
        "Shift",
        "Tab"
      ],
      [
        "Tab"
      ]
    ],
    preventDefault: false,
    callback: (event) => {
      this.hot._registerTimeout(() => {
        if (event.shiftKey) {
          this.hot.runHooks("dialogFocusPreviousElement");
        } else {
          this.hot.runHooks("dialogFocusNextElement");
        }
      });
    },
    group: SHORTCUTS_GROUP$1
  });
}
function unregisterShortcuts() {
  const shortcutManager = this.hot.getShortcutManager();
  const pluginContext = shortcutManager.getContext(SHORTCUTS_CONTEXT_NAME$2);
  pluginContext?.removeShortcutsByGroup(SHORTCUTS_GROUP$1);
}
function registerFocusScope$2() {
  this.hot.getFocusScopeManager().registerScope(PLUGIN_KEY$3, _class_private_field_get$5(this, _ui$2).getContainer(), {
    shortcutsContextName: SHORTCUTS_CONTEXT_NAME$2,
    type: "modal",
    runOnlyIf: () => this.isVisible(),
    onActivate: (focusSource) => {
      const isListening = this.hot.isListening();
      const focusableElements = _class_private_field_get$5(this, _ui$2).getFocusableElements();
      if (focusableElements.length > 0) {
        if (focusSource === "tab_from_above") {
          focusableElements.at(0)?.focus();
        } else if (focusSource === "tab_from_below") {
          focusableElements.at(-1)?.focus();
        }
      } else if (focusSource !== "tab_from_above" && focusSource !== "tab_from_below" && isListening && !_class_private_field_get$5(this, _ui$2).getContainer().contains(this.hot.rootDocument.activeElement)) {
        _class_private_field_get$5(this, _ui$2).getContainer().focus();
      }
      if (isListening) {
        this.hot.runHooks("afterDialogFocus", focusSource === "unknown" ? "show" : focusSource);
      }
    }
  });
}
function unregisterFocusScope$2() {
  this.hot.getFocusScopeManager().unregisterScope(PLUGIN_KEY$3);
}
function onAfterViewRender() {
  const { view } = this.hot;
  const width = view.isHorizontallyScrollableByWindow() ? view.getTotalTableWidth() : view.getWorkspaceWidth();
  _class_private_field_get$5(this, _ui$2).updateWidth(width);
}
function loadingContent({ id, icon: icon2, title, description }) {
  return `
    <div class="${LOADING_CLASS_NAME}__content">
      <i class="${LOADING_CLASS_NAME}__icon">${icon2}</i>
      <div class="${LOADING_CLASS_NAME}__text">
        <h2 id="${id}-${PLUGIN_KEY$2}-title" class="${LOADING_CLASS_NAME}__title">${title}</h2>
        ${description ? `<p id="${id}-${PLUGIN_KEY$2}-description" class="${LOADING_CLASS_NAME}__description">${description}</p>` : ""}
      </div>
    </div>
  `;
}
function _check_private_redeclaration$4(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$4(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$4(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$4(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$4(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$4(receiver, privateMap, "get");
  return _class_apply_descriptor_get$4(receiver, descriptor);
}
function _class_private_field_init$4(obj, privateMap, value) {
  _check_private_redeclaration$4(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$4(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$4(receiver, privateMap, "set");
  _class_apply_descriptor_set$4(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$2(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$2(obj, privateSet) {
  _check_private_redeclaration$4(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$2 = "loading";
const PLUGIN_PRIORITY$2 = 350;
var _dialogPlugin = /* @__PURE__ */ new WeakMap(), _onAfterDialogFocus = /* @__PURE__ */ new WeakSet();
class Loading extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$2;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$2;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      // eslint-disable-next-line max-len
      icon: `<svg class="${LOADING_CLASS_NAME}__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-width="2" d="M15 8a7 7 0 1 1-3.5-6.062"></path></svg>`,
      title: void 0,
      description: ""
    };
  }
  /**
  * Returns an object of validator functions used to type-check each settings property at runtime.
  */
  static get SETTINGS_VALIDATORS() {
    return {
      icon: (value) => typeof value === "string",
      title: (value) => typeof value === "string",
      description: (value) => typeof value === "string"
    };
  }
  /**
  * Check if the plugin is enabled in the handsontable settings.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$2];
  }
  /**
  * Enable plugin for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    if (_class_private_field_get$4(this, _dialogPlugin) === null) {
      _class_private_field_set$4(this, _dialogPlugin, this.hot.getPlugin("dialog"));
      if (!_class_private_field_get$4(this, _dialogPlugin)?.isEnabled()) {
        this.hot.getSettings().dialog = true;
      }
      this.hot.addHook("afterDialogFocus", () => _class_private_method_get$2(this, _onAfterDialogFocus, onAfterDialogFocus).call(this));
    }
    super.enablePlugin();
  }
  /**
  * Update plugin state after Handsontable settings update.
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Disable plugin for this Handsontable instance.
  */
  disablePlugin() {
    this.hide();
    super.disablePlugin();
  }
  /**
  * Check if loading dialog is currently visible.
  *
  * @returns {boolean}
  */
  isVisible() {
    return _class_private_field_get$4(this, _dialogPlugin)?.isVisible() ?? false;
  }
  /**
  * Show loading dialog with optional custom options.
  *
  * @param {object} options Custom loading options.
  * @param {string} options.icon Custom loading icon.
  * @param {string} options.title Custom loading title.
  * @param {string} options.description Custom loading description.
  */
  show(options = {}) {
    if (!this.isEnabled() || !_class_private_field_get$4(this, _dialogPlugin) || !_class_private_field_get$4(this, _dialogPlugin)?.isEnabled()) {
      return;
    }
    if (this.isVisible()) {
      this.update(options);
      return;
    }
    const shouldProceed = this.hot.runHooks("beforeLoadingShow");
    if (shouldProceed === false) {
      return;
    }
    this.update(options);
    _class_private_field_get$4(this, _dialogPlugin).show();
    this.hot.runHooks("afterLoadingShow");
  }
  /**
  * Hide loading dialog.
  */
  hide() {
    if (!_class_private_field_get$4(this, _dialogPlugin) || !_class_private_field_get$4(this, _dialogPlugin)?.isEnabled() || !this.isVisible()) {
      return;
    }
    const shouldProceed = this.hot.runHooks("beforeLoadingHide");
    if (shouldProceed === false) {
      return;
    }
    _class_private_field_get$4(this, _dialogPlugin).hide();
    this.hot.runHooks("afterLoadingHide");
  }
  /**
  * Update loading description without hiding/showing the dialog.
  *
  * @param {object} options Custom loading options.
  * @param {string} options.icon Custom loading icon.
  * @param {string} options.title Custom loading title.
  * @param {string} options.description Custom loading description.
  */
  update(options) {
    if (!this.isEnabled() || !_class_private_field_get$4(this, _dialogPlugin) || !_class_private_field_get$4(this, _dialogPlugin)?.isEnabled()) {
      return;
    }
    this.updatePluginSettings(options);
    const id = this.hot.guid;
    const icon2 = this.getSetting("icon");
    const title = this.getSetting("title") ?? this.hot.getTranslatedPhrase(LOADING_TITLE);
    const description = this.getSetting("description");
    const content = loadingContent({
      id,
      icon: icon2,
      title,
      description
    });
    _class_private_field_get$4(this, _dialogPlugin).update({
      content,
      customClassName: LOADING_CLASS_NAME,
      background: this.hot.countSourceRows() === 0 ? "solid" : "semi-transparent",
      a11y: {
        role: "alertdialog",
        ariaLabelledby: `${id}-${PLUGIN_KEY$2}-title`,
        ariaDescribedby: description ? `${id}-${PLUGIN_KEY$2}-description` : void 0
      }
    });
  }
  /**
  * Destroy plugin instance.
  */
  destroy() {
    _class_private_field_set$4(this, _dialogPlugin, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$2(this, _onAfterDialogFocus), _class_private_field_init$4(this, _dialogPlugin, {
      writable: true,
      value: void 0
    }), _class_private_field_set$4(this, _dialogPlugin, null);
  }
}
function onAfterDialogFocus() {
  _class_private_field_get$4(this, _dialogPlugin).focus();
}
const NOTIFICATION_CLASS_NAME = "ht-notification";
const NOTIFICATION_POSITIONS = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
const NOTIFICATION_VARIANTS = [
  "info",
  "success",
  "warning",
  "error"
];
function _check_private_redeclaration$3(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$3(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$3(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$3(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$3(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$3(receiver, privateMap, "get");
  return _class_apply_descriptor_get$3(receiver, descriptor);
}
function _class_private_field_init$3(obj, privateMap, value) {
  _check_private_redeclaration$3(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$3(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$3(receiver, privateMap, "set");
  _class_apply_descriptor_set$3(receiver, descriptor, value);
  return value;
}
var _overlayElement = /* @__PURE__ */ new WeakMap(), _sanitizer = /* @__PURE__ */ new WeakMap(), _isRtl = /* @__PURE__ */ new WeakMap(), _host = /* @__PURE__ */ new WeakMap(), _stacks = /* @__PURE__ */ new WeakMap();
class NotificationUI {
  /**
  * Creates the notification host and four corner stack elements inside the overlays layer (`ht-overlay`).
  */
  install() {
    if (_class_private_field_get$3(this, _host)) {
      return;
    }
    const doc = _class_private_field_get$3(this, _overlayElement).ownerDocument;
    const host = doc.createElement("div");
    host.className = `${NOTIFICATION_CLASS_NAME} handsontable`;
    host.setAttribute("dir", _class_private_field_get$3(this, _isRtl) ? "rtl" : "ltr");
    NOTIFICATION_POSITIONS.forEach((position) => {
      const stack = doc.createElement("div");
      stack.className = `${NOTIFICATION_CLASS_NAME}__stack ${NOTIFICATION_CLASS_NAME}__stack--${position}`;
      stack.dataset.htNotificationPosition = position;
      stack.tabIndex = -1;
      host.appendChild(stack);
      _class_private_field_get$3(this, _stacks).set(position, stack);
    });
    _class_private_field_get$3(this, _overlayElement).appendChild(host);
    _class_private_field_set$3(this, _host, host);
  }
  /**
  * @returns {HTMLElement | null}
  */
  getHost() {
    return _class_private_field_get$3(this, _host);
  }
  /**
  * @param {string} position Stack key.
  * @returns {HTMLElement | undefined}
  */
  getStack(position) {
    return _class_private_field_get$3(this, _stacks).get(position);
  }
  /**
  * Updates RTL direction on the host.
  *
  * @param {boolean} isRtl Whether the grid uses RTL layout.
  */
  setRtl(isRtl2) {
    _class_private_field_set$3(this, _isRtl, isRtl2);
    if (_class_private_field_get$3(this, _host)) {
      _class_private_field_get$3(this, _host).setAttribute("dir", isRtl2 ? "rtl" : "ltr");
    }
  }
  /**
  * Updates the HTML sanitizer used for string notification messages.
  *
  * @param {function(string, string): string | undefined} sanitizer Sanitizer from Handsontable settings, if any.
  */
  setSanitizer(sanitizer) {
    _class_private_field_set$3(this, _sanitizer, sanitizer);
  }
  /**
  * Builds a toast element from normalized options.
  *
  * @param {object} options Normalized notification options (id, variant, title, message, closable, actions).
  * @param {string} closeLabel Translated label for the close control.
  * @param {boolean} animation Whether enter animation is enabled.
  * @returns {{ element: HTMLElement }}
  */
  createToastElement(options, closeLabel, animation) {
    const doc = _class_private_field_get$3(this, _overlayElement).ownerDocument;
    const element = doc.createElement("div");
    const isError2 = options.variant === "error";
    element.className = `${NOTIFICATION_CLASS_NAME}__toast ${NOTIFICATION_CLASS_NAME}__toast--${options.variant}`;
    element.dataset.htNotificationId = options.id;
    element.setAttribute("role", isError2 ? "alert" : "status");
    element.setAttribute("aria-live", isError2 ? "assertive" : "polite");
    element.setAttribute("aria-atomic", "true");
    if (animation) {
      element.classList.add(`${NOTIFICATION_CLASS_NAME}__toast--animate`);
      element.classList.add(options.position.startsWith("top") ? `${NOTIFICATION_CLASS_NAME}__toast--stack-top` : `${NOTIFICATION_CLASS_NAME}__toast--stack-bottom`);
    }
    const inner = doc.createElement("div");
    inner.className = `${NOTIFICATION_CLASS_NAME}__toast-inner`;
    const accent = doc.createElement("div");
    accent.className = `${NOTIFICATION_CLASS_NAME}__accent`;
    accent.setAttribute("aria-hidden", "true");
    inner.appendChild(accent);
    const body = doc.createElement("div");
    body.className = `${NOTIFICATION_CLASS_NAME}__body`;
    if (options.title) {
      const titleEl = doc.createElement("div");
      titleEl.className = `${NOTIFICATION_CLASS_NAME}__title`;
      titleEl.textContent = stripTags(options.title);
      body.appendChild(titleEl);
    }
    const messageEl = doc.createElement("div");
    messageEl.className = `${NOTIFICATION_CLASS_NAME}__message`;
    if (typeof options.message === "string") {
      fastInnerHTML(messageEl, options.message, _class_private_field_get$3(this, _sanitizer), "notification", _class_private_field_get$3(this, _overlayElement));
    } else {
      messageEl.appendChild(options.message);
    }
    body.appendChild(messageEl);
    if (options.actions?.length) {
      const actionsRow = doc.createElement("div");
      actionsRow.className = `${NOTIFICATION_CLASS_NAME}__actions`;
      options.actions.forEach((action, index2) => {
        const btn = doc.createElement("button");
        btn.type = "button";
        btn.className = `ht-button ht-button--${action.type === "primary" ? "primary" : "secondary"}`;
        btn.textContent = stripTags(action.label);
        btn.dataset.htNotificationAction = String(index2);
        actionsRow.appendChild(btn);
      });
      body.appendChild(actionsRow);
    }
    inner.appendChild(body);
    if (options.closable) {
      const closeBtn = doc.createElement("button");
      closeBtn.type = "button";
      closeBtn.className = `${NOTIFICATION_CLASS_NAME}__close`;
      closeBtn.setAttribute("aria-label", closeLabel);
      inner.appendChild(closeBtn);
    }
    element.appendChild(inner);
    element.tabIndex = -1;
    inner.querySelectorAll("button").forEach((btn) => {
      btn.tabIndex = -1;
    });
    const win = _class_private_field_get$3(this, _overlayElement).ownerDocument.defaultView;
    if (animation) {
      win.requestAnimationFrame(() => {
        win.requestAnimationFrame(() => {
          element.classList.add(`${NOTIFICATION_CLASS_NAME}__toast--visible`);
        });
      });
    } else {
      element.classList.add(`${NOTIFICATION_CLASS_NAME}__toast--visible`);
    }
    return {
      element
    };
  }
  /**
  * @param {HTMLElement} toastEl Toast root element.
  * @returns {HTMLElement[]}
  */
  static getFocusables(toastEl) {
    const buttons = Array.from(toastEl.querySelectorAll("button")).filter((btn) => !btn.disabled);
    if (buttons.length > 0) {
      return buttons;
    }
    return [
      toastEl
    ];
  }
  /**
  * Enables or disables sequential keyboard focus for notification controls. When disabled, controls stay
  * out of the tab order so opening a toast does not move focus; screen readers still receive `aria-live` updates.
  *
  * @param {HTMLElement | null} host Notification plugin host element.
  * @param {boolean} enabled Whether controls participate in tab navigation.
  */
  static setSequentialFocusWithinHost(host, enabled) {
    if (!host) {
      return;
    }
    const tabIndex = enabled ? 0 : -1;
    host.querySelectorAll(`.${NOTIFICATION_CLASS_NAME}__toast`).forEach((toast) => {
      const toastEl = toast;
      const buttons = Array.from(toastEl.querySelectorAll("button")).filter((btn) => !btn.disabled);
      buttons.forEach((btn) => {
        btn.tabIndex = tabIndex;
      });
      if (buttons.length === 0) {
        toastEl.tabIndex = tabIndex;
      } else {
        toastEl.tabIndex = -1;
      }
    });
  }
  /**
  * Detaches the host from the DOM and clears internal stack references.
  */
  destroy() {
    _class_private_field_get$3(this, _host)?.remove();
    _class_private_field_set$3(this, _host, null);
    _class_private_field_get$3(this, _stacks).clear();
  }
  /**
  * @param {object} params Constructor parameters.
  * @param {HTMLElement} params.overlayElement Handsontable root overlays layer element.
  * @param {function(string, string): string | undefined} params.sanitizer Sanitizer for HTML strings.
  * @param {boolean} params.isRtl Whether the grid uses RTL layout.
  */
  constructor({ overlayElement, sanitizer, isRtl: isRtl2 }) {
    _class_private_field_init$3(this, _overlayElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$3(this, _sanitizer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$3(this, _isRtl, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$3(this, _host, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$3(this, _stacks, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$3(this, _isRtl, false);
    _class_private_field_set$3(this, _host, null);
    _class_private_field_set$3(this, _stacks, /* @__PURE__ */ new Map());
    _class_private_field_set$3(this, _overlayElement, overlayElement);
    _class_private_field_set$3(this, _sanitizer, sanitizer);
    _class_private_field_set$3(this, _isRtl, isRtl2);
  }
}
function _check_private_redeclaration$2(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$2(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$2(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$2(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$2(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$2(receiver, privateMap, "get");
  return _class_apply_descriptor_get$2(receiver, descriptor);
}
function _class_private_field_init$2(obj, privateMap, value) {
  _check_private_redeclaration$2(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$2(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$2(receiver, privateMap, "set");
  _class_apply_descriptor_set$2(receiver, descriptor, value);
  return value;
}
function _class_private_method_get$1(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init$1(obj, privateSet) {
  _check_private_redeclaration$2(obj, privateSet);
  privateSet.add(obj);
}
const PLUGIN_KEY$1 = "notification";
const PLUGIN_PRIORITY$1 = 375;
const SHORTCUTS_CONTEXT_NAME$1 = `plugin:${PLUGIN_KEY$1}`;
const SHORTCUTS_GLOBAL_CONTEXT_NAME = `plugin:${PLUGIN_KEY$1}:global`;
const SHORTCUTS_GROUP = PLUGIN_KEY$1;
const POSITION_SET = new Set(NOTIFICATION_POSITIONS);
const VARIANT_SET = new Set(NOTIFICATION_VARIANTS);
const TICK_MS = 200;
var _ui$1 = /* @__PURE__ */ new WeakMap(), _toasts = /* @__PURE__ */ new WeakMap(), _queues = /* @__PURE__ */ new WeakMap(), _focusBeforeRegion = /* @__PURE__ */ new WeakMap(), _regionTabOrderActive = /* @__PURE__ */ new WeakMap(), _tickQueued = /* @__PURE__ */ new WeakMap(), _focusScopeActive = /* @__PURE__ */ new WeakMap(), _notificationDeactivateRestorePrior = /* @__PURE__ */ new WeakMap(), _lastEffectiveNotificationOptions = /* @__PURE__ */ new WeakMap(), _captureEffectiveNotificationOptions = /* @__PURE__ */ new WeakSet(), _effectiveNotificationOptionsEqual = /* @__PURE__ */ new WeakSet(), _onAfterUpdateSettings = /* @__PURE__ */ new WeakMap(), _normalizeOptions = /* @__PURE__ */ new WeakSet(), _countVisibleAt = /* @__PURE__ */ new WeakSet(), _mountToast = /* @__PURE__ */ new WeakSet(), _bindToastEvents = /* @__PURE__ */ new WeakSet(), _onToastClick = /* @__PURE__ */ new WeakSet(), _clearNotificationRegionTabOrder = /* @__PURE__ */ new WeakSet(), _reapplySequentialTabOrderInNotificationHost = /* @__PURE__ */ new WeakSet(), _enterNotificationRegion = /* @__PURE__ */ new WeakSet(), _ensureGridScopeActiveForShortcuts = /* @__PURE__ */ new WeakSet(), _leaveNotificationRegionRestoringPriorFocus = /* @__PURE__ */ new WeakSet(), _exitNotificationRegion = /* @__PURE__ */ new WeakSet(), _registerFocusScope$1 = /* @__PURE__ */ new WeakSet(), _registerNotificationShortcuts = /* @__PURE__ */ new WeakSet(), _unregisterNotificationShortcuts = /* @__PURE__ */ new WeakSet(), _onDocumentFocusInForNotificationTabOrder = /* @__PURE__ */ new WeakMap(), _getAllFocusablesInNotificationRegion = /* @__PURE__ */ new WeakSet(), _getFirstFocusableInNotificationRegion = /* @__PURE__ */ new WeakSet(), _getNotificationRegionFocusableContext = /* @__PURE__ */ new WeakSet(), _shouldHandleTabForwardExitFromNotificationRegion = /* @__PURE__ */ new WeakSet(), _shouldHandleShiftTabExitFromNotificationRegion = /* @__PURE__ */ new WeakSet(), _onTabForwardExitNotificationRegionToGrid = /* @__PURE__ */ new WeakSet(), _unregisterFocusScope$1 = /* @__PURE__ */ new WeakSet(), _removeToastState = /* @__PURE__ */ new WeakSet(), _isElementInsideNotificationHost = /* @__PURE__ */ new WeakSet(), _isActiveInsideAnyRemainingToast = /* @__PURE__ */ new WeakSet(), _refocusFirstOpenToastAfterPartialHide = /* @__PURE__ */ new WeakSet(), _focusFirstInNotificationRegionUnlessAlreadyFocused = /* @__PURE__ */ new WeakSet(), _shouldThisInstanceHandleF6ForActiveElement = /* @__PURE__ */ new WeakSet(), _shouldRunNotificationF6Shortcut = /* @__PURE__ */ new WeakSet(), _restoreFocusAfterLastToastLikeEscape = /* @__PURE__ */ new WeakSet(), _restoreFocusIfIdle = /* @__PURE__ */ new WeakSet(), _drainQueueForPosition = /* @__PURE__ */ new WeakSet(), _removeFromQueue = /* @__PURE__ */ new WeakSet(), _queueTick = /* @__PURE__ */ new WeakSet(), _runTick = /* @__PURE__ */ new WeakSet(), _hasActiveCountdowns = /* @__PURE__ */ new WeakSet();
class Notification extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY$1;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY$1;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      stackLimit: 10,
      animation: true
    };
  }
  /**
  * Returns an object of validator functions used to type-check each settings property at runtime.
  */
  static get SETTINGS_VALIDATORS() {
    return {
      stackLimit: (value) => typeof value === "number" && value > 0 && Number.isInteger(value),
      animation: (value) => typeof value === "boolean"
    };
  }
  /**
  * Returns whether the `notification` setting is enabled for this instance.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY$1];
  }
  /**
  * Installs the notification host, document `focusin` listener (tab order + prior-focus for click paths), shortcuts
  * (**F6** via grid + global shortcut contexts, Escape, Tab, Shift+Tab), and the focus scope.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    if (!_class_private_field_get$2(this, _ui$1)) {
      _class_private_field_set$2(this, _ui$1, new NotificationUI({
        overlayElement: this.hot.rootOverlaysElement,
        sanitizer: this.hot.getSettings().sanitizer,
        isRtl: this.hot.isRtl()
      }));
    }
    _class_private_field_get$2(this, _ui$1).install();
    _class_private_method_get$1(this, _registerFocusScope$1, registerFocusScope$1).call(this);
    _class_private_method_get$1(this, _registerNotificationShortcuts, registerNotificationShortcuts).call(this);
    this.eventManager.addEventListener(this.hot.rootDocument, "focusin", _class_private_field_get$2(this, _onDocumentFocusInForNotificationTabOrder), true);
    this.addHook("afterUpdateSettings", _class_private_field_get$2(this, _onAfterUpdateSettings));
    this.eventManager.addEventListener(this.hot.rootDocument, "visibilitychange", () => {
      if (_class_private_method_get$1(this, _hasActiveCountdowns, hasActiveCountdowns).call(this)) {
        _class_private_method_get$1(this, _queueTick, queueTick).call(this);
      }
    });
    super.enablePlugin();
    _class_private_field_set$2(this, _lastEffectiveNotificationOptions, _class_private_method_get$1(this, _captureEffectiveNotificationOptions, captureEffectiveNotificationOptions).call(this));
  }
  /**
  * Rebuilds the plugin after settings change when notification options actually change.
  *
  * @param {object} [newSettings] Settings object passed to `updateSettings` (partial).
  */
  updatePlugin(newSettings) {
    const nextEffective = _class_private_method_get$1(this, _captureEffectiveNotificationOptions, captureEffectiveNotificationOptions).call(this);
    const notificationKeyPresent = newSettings && typeof newSettings === "object" && Object.prototype.hasOwnProperty.call(newSettings, PLUGIN_KEY$1);
    if (notificationKeyPresent && _class_private_field_get$2(this, _lastEffectiveNotificationOptions) !== null && _class_private_method_get$1(this, _effectiveNotificationOptionsEqual, effectiveNotificationOptionsEqual).call(this, _class_private_field_get$2(this, _lastEffectiveNotificationOptions), nextEffective)) {
      super.updatePlugin();
      return;
    }
    this.disablePlugin();
    this.enablePlugin();
    super.updatePlugin();
  }
  /**
  * Hides all toasts, removes shortcuts and listeners, and destroys the UI host.
  *
  * `hideAll()` must run before `super.disablePlugin()` because `BasePlugin.disablePlugin()` clears
  * `this.enabled` first, and `hideAll()` relies on the plugin still being enabled. The superclass
  * call then removes hooks and clears the shared `EventManager`.
  */
  disablePlugin() {
    this.hideAll();
    _class_private_method_get$1(this, _unregisterNotificationShortcuts, unregisterNotificationShortcuts).call(this);
    _class_private_method_get$1(this, _unregisterFocusScope$1, unregisterFocusScope$1).call(this);
    super.disablePlugin();
    _class_private_field_get$2(this, _ui$1)?.destroy();
    _class_private_field_set$2(this, _ui$1, null);
    _class_private_field_set$2(this, _focusBeforeRegion, null);
    _class_private_field_set$2(this, _regionTabOrderActive, false);
    _class_private_field_set$2(this, _lastEffectiveNotificationOptions, null);
  }
  /**
  * Displays a toast. Returns the toast id, or an empty string when the toast is not shown.
  *
  * @param {object} options Toast options.
  * @param {'info' | 'success' | 'warning' | 'error'} [options.variant] Visual variant.
  * @param {string} [options.title] Optional title.
  * @param {string | HTMLElement} options.message Main message body.
  * @param {number} [options.duration] Auto-dismiss delay in ms. `0` keeps the toast until dismissed manually.
  * @param {'top-start' | 'top-end' | 'bottom-start' | 'bottom-end'} [options.position] Corner stack.
  * @param {boolean} [options.closable] Whether the close control is shown.
  * @param {NotificationActionSpec[]} [options.actions] Action buttons.
  * @returns {string}
  * @throws {Error} When `options` is invalid or actions are malformed.
  */
  showMessage(options) {
    if (!this.enabled) {
      return "";
    }
    const normalized = _class_private_method_get$1(this, _normalizeOptions, normalizeOptions).call(this, options);
    if (this.hot.runHooks("beforeNotificationShow", normalized) === false) {
      return "";
    }
    const limit = this.getSetting("stackLimit");
    const visibleAtPosition = _class_private_method_get$1(this, _countVisibleAt, countVisibleAt).call(this, normalized.position);
    if (visibleAtPosition >= limit) {
      _class_private_field_get$2(this, _queues)[normalized.position].push(normalized);
      return normalized.id;
    }
    _class_private_method_get$1(this, _mountToast, mountToast).call(this, normalized);
    return normalized.id;
  }
  /**
  * Hides a toast by id.
  *
  * @param {string} id Toast id returned from {@link Notification#showMessage}.
  */
  hide(id) {
    if (!this.enabled || !id) {
      return;
    }
    const state = _class_private_field_get$2(this, _toasts).get(id);
    if (!state) {
      _class_private_method_get$1(this, _removeFromQueue, removeFromQueue).call(this, id);
      return;
    }
    if (this.hot.runHooks("beforeNotificationHide", id) === false) {
      if (state.durationMs > 0 && state.remainingMs <= 0) {
        state.remainingMs = state.durationMs;
      }
      return;
    }
    const doc = this.hot.rootDocument;
    const activeBeforeRemove = doc.activeElement;
    const focusInClosingToast = activeBeforeRemove instanceof this.hot.rootWindow.HTMLElement && state.element.contains(activeBeforeRemove);
    _class_private_method_get$1(this, _removeToastState, removeToastState).call(this, state, true);
    this.hot.runHooks("afterNotificationHide", id);
    _class_private_method_get$1(this, _drainQueueForPosition, drainQueueForPosition).call(this, state.options.position);
    _class_private_method_get$1(this, _restoreFocusIfIdle, restoreFocusIfIdle).call(this, focusInClosingToast);
  }
  /**
  * Hides every visible toast and clears all per-position queues.
  */
  hideAll() {
    if (!this.enabled) {
      return;
    }
    NOTIFICATION_POSITIONS.forEach((p) => {
      _class_private_field_get$2(this, _queues)[p].length = 0;
    });
    const ids = [
      ..._class_private_field_get$2(this, _toasts).keys()
    ];
    ids.forEach((toastId) => this.hide(toastId));
  }
  /**
  * Returns whether a toast is visible, or whether any toast is visible when `id` is omitted.
  *
  * @param {string} [id] Toast id.
  * @returns {boolean}
  */
  isVisible(id) {
    if (id === void 0) {
      return _class_private_field_get$2(this, _toasts).size > 0;
    }
    return _class_private_field_get$2(this, _toasts).has(id);
  }
  /**
  * Returns how many toasts are waiting in per-position queues.
  *
  * @returns {number}
  */
  getQueueSize() {
    return NOTIFICATION_POSITIONS.reduce((sum2, p) => sum2 + _class_private_field_get$2(this, _queues)[p].length, 0);
  }
  /**
  * Clears queues and toast state, unregisters shortcuts and focus scope, and removes the host from the DOM.
  */
  destroy() {
    NOTIFICATION_POSITIONS.forEach((p) => {
      _class_private_field_get$2(this, _queues)[p].length = 0;
    });
    _class_private_field_get$2(this, _toasts).clear();
    _class_private_method_get$1(this, _unregisterNotificationShortcuts, unregisterNotificationShortcuts).call(this);
    _class_private_method_get$1(this, _unregisterFocusScope$1, unregisterFocusScope$1).call(this);
    _class_private_field_get$2(this, _ui$1)?.destroy();
    _class_private_field_set$2(this, _ui$1, null);
    _class_private_field_set$2(this, _focusBeforeRegion, null);
    _class_private_field_set$2(this, _regionTabOrderActive, false);
    _class_private_field_set$2(this, _lastEffectiveNotificationOptions, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init$1(this, _captureEffectiveNotificationOptions), _class_private_method_init$1(this, _effectiveNotificationOptionsEqual), _class_private_method_init$1(this, _normalizeOptions), _class_private_method_init$1(this, _countVisibleAt), _class_private_method_init$1(this, _mountToast), _class_private_method_init$1(this, _bindToastEvents), _class_private_method_init$1(this, _onToastClick), _class_private_method_init$1(this, _clearNotificationRegionTabOrder), _class_private_method_init$1(this, _reapplySequentialTabOrderInNotificationHost), _class_private_method_init$1(this, _enterNotificationRegion), _class_private_method_init$1(this, _ensureGridScopeActiveForShortcuts), _class_private_method_init$1(this, _leaveNotificationRegionRestoringPriorFocus), _class_private_method_init$1(this, _exitNotificationRegion), _class_private_method_init$1(this, _registerFocusScope$1), _class_private_method_init$1(this, _registerNotificationShortcuts), _class_private_method_init$1(this, _unregisterNotificationShortcuts), _class_private_method_init$1(this, _getAllFocusablesInNotificationRegion), _class_private_method_init$1(this, _getFirstFocusableInNotificationRegion), _class_private_method_init$1(this, _getNotificationRegionFocusableContext), _class_private_method_init$1(this, _shouldHandleTabForwardExitFromNotificationRegion), _class_private_method_init$1(this, _shouldHandleShiftTabExitFromNotificationRegion), _class_private_method_init$1(this, _onTabForwardExitNotificationRegionToGrid), _class_private_method_init$1(this, _unregisterFocusScope$1), _class_private_method_init$1(this, _removeToastState), _class_private_method_init$1(this, _isElementInsideNotificationHost), _class_private_method_init$1(this, _isActiveInsideAnyRemainingToast), _class_private_method_init$1(this, _refocusFirstOpenToastAfterPartialHide), _class_private_method_init$1(this, _focusFirstInNotificationRegionUnlessAlreadyFocused), _class_private_method_init$1(this, _shouldThisInstanceHandleF6ForActiveElement), _class_private_method_init$1(this, _shouldRunNotificationF6Shortcut), _class_private_method_init$1(this, _restoreFocusAfterLastToastLikeEscape), _class_private_method_init$1(this, _restoreFocusIfIdle), _class_private_method_init$1(this, _drainQueueForPosition), _class_private_method_init$1(this, _removeFromQueue), _class_private_method_init$1(this, _queueTick), _class_private_method_init$1(this, _runTick), _class_private_method_init$1(this, _hasActiveCountdowns), _class_private_field_init$2(this, _ui$1, {
      writable: true,
      value: void 0
    }), /**
    * @type {Map<string, object>}
    */
    _class_private_field_init$2(this, _toasts, {
      writable: true,
      value: void 0
    }), /**
    * @type {Record<string, object[]>}
    */
    _class_private_field_init$2(this, _queues, {
      writable: true,
      value: void 0
    }), _class_private_field_init$2(this, _focusBeforeRegion, {
      writable: true,
      value: void 0
    }), _class_private_field_init$2(this, _regionTabOrderActive, {
      writable: true,
      value: void 0
    }), _class_private_field_init$2(this, _tickQueued, {
      writable: true,
      value: void 0
    }), _class_private_field_init$2(this, _focusScopeActive, {
      writable: true,
      value: void 0
    }), _class_private_field_init$2(this, _notificationDeactivateRestorePrior, {
      writable: true,
      value: void 0
    }), _class_private_field_init$2(this, _lastEffectiveNotificationOptions, {
      writable: true,
      value: void 0
    }), /**
    * Aligns toast host `dir` and message sanitizer with the grid after any `updateSettings` call.
    */
    _class_private_field_init$2(this, _onAfterUpdateSettings, {
      writable: true,
      value: void 0
    }), /**
    * Document-level `focusin` (capture): (1) when focus moves **into** the notification host from elsewhere in the
    * wrapper, stores `#focusBeforeRegion` using `FocusEvent.relatedTarget` so **Escape** can restore after a
    * click-focused control. `FocusScopeManager` skips forwarding `focusin` while `mousedown` is down, and
    * programmatic `onActivate` from `click` runs after `activeElement` already moved into the host, so neither path
    * exposes `relatedTarget`. (2) when focus lands **outside** the host, clears sequential tab order (host `focusout`
    * misses moves via the grid in the same wrapper).
    *
    * @param {FocusEvent} event Focusin event on the root document (capture phase).
    */
    _class_private_field_init$2(this, _onDocumentFocusInForNotificationTabOrder, {
      writable: true,
      value: void 0
    }), _class_private_field_set$2(this, _ui$1, null), _class_private_field_set$2(this, _toasts, /* @__PURE__ */ new Map()), _class_private_field_set$2(this, _queues, {
      "top-start": [],
      "top-end": [],
      "bottom-start": [],
      "bottom-end": []
    }), _class_private_field_set$2(this, _focusBeforeRegion, null), _class_private_field_set$2(this, _regionTabOrderActive, false), _class_private_field_set$2(this, _tickQueued, false), _class_private_field_set$2(this, _focusScopeActive, false), _class_private_field_set$2(this, _notificationDeactivateRestorePrior, false), _class_private_field_set$2(this, _lastEffectiveNotificationOptions, null), _class_private_field_set$2(this, _onAfterUpdateSettings, () => {
      if (!this.enabled || !_class_private_field_get$2(this, _ui$1)) {
        return;
      }
      const root = this.hot.rootElement;
      const dirAttr = root.getAttribute("dir");
      if (dirAttr === "rtl" || dirAttr === "ltr") {
        _class_private_field_get$2(this, _ui$1).setRtl(dirAttr === "rtl");
      } else {
        _class_private_field_get$2(this, _ui$1).setRtl(this.hot.isRtl());
      }
      _class_private_field_get$2(this, _ui$1).setSanitizer(this.hot.getSettings().sanitizer);
    }), _class_private_field_set$2(this, _onDocumentFocusInForNotificationTabOrder, (event) => {
      if (_class_private_field_get$2(this, _toasts).size === 0) {
        return;
      }
      const host = _class_private_field_get$2(this, _ui$1)?.getHost();
      const target = event.target;
      if (!(target instanceof this.hot.rootWindow.HTMLElement) || !host) {
        return;
      }
      if (host.contains(target)) {
        if (_class_private_field_get$2(this, _focusBeforeRegion) !== null) {
          return;
        }
        const related = event.relatedTarget;
        if (related instanceof this.hot.rootWindow.HTMLElement && this.hot.rootWrapperElement.contains(related) && !host.contains(related)) {
          _class_private_field_set$2(this, _focusBeforeRegion, related);
        }
        return;
      }
      _class_private_method_get$1(this, _clearNotificationRegionTabOrder, clearNotificationRegionTabOrder).call(this);
    });
  }
}
function captureEffectiveNotificationOptions() {
  return {
    stackLimit: this.getSetting("stackLimit"),
    animation: this.getSetting("animation")
  };
}
function effectiveNotificationOptionsEqual(a, b) {
  return a.stackLimit === b.stackLimit && a.animation === b.animation;
}
function normalizeOptions(raw) {
  if (!isObject$1(raw) || typeof raw.message !== "string" && !(typeof HTMLElement !== "undefined" && raw.message instanceof HTMLElement)) {
    throwWithCause("Notification.showMessage expects an object with a `message` string or HTMLElement.");
  }
  const id = `htn-${randomString()}`;
  const variant = raw.variant && VARIANT_SET.has(raw.variant) ? raw.variant : "info";
  const position = raw.position && POSITION_SET.has(raw.position) ? raw.position : "bottom-end";
  const duration = typeof raw.duration === "number" && raw.duration >= 0 ? raw.duration : 4e3;
  const closable = typeof raw.closable === "boolean" ? raw.closable : true;
  const actions = Array.isArray(raw.actions) ? raw.actions.map((a) => {
    if (!isObject$1(a) || typeof a.label !== "string" || typeof a.callback !== "function") {
      throwWithCause("Each notification action needs `label` (string) and `callback` (function).");
    }
    const type = a.type === "primary" ? "primary" : "secondary";
    return {
      label: a.label,
      type,
      callback: a.callback
    };
  }) : [];
  return {
    id,
    variant,
    title: typeof raw.title === "string" ? raw.title : void 0,
    message: raw.message,
    duration,
    position,
    closable,
    actions
  };
}
function countVisibleAt(position) {
  let n2 = 0;
  _class_private_field_get$2(this, _toasts).forEach((state) => {
    if (state.options.position === position) {
      n2 += 1;
    }
  });
  return n2;
}
function mountToast(normalized) {
  const closeLabel = this.hot.getTranslatedPhrase(NOTIFICATION_BUTTONS_CLOSE);
  const animation = this.getSetting("animation");
  const { element } = _class_private_field_get$2(this, _ui$1).createToastElement(normalized, closeLabel, animation);
  const stack = _class_private_field_get$2(this, _ui$1).getStack(normalized.position);
  if (!stack) {
    throwWithCause(`Unknown notification position "${normalized.position}".`);
  }
  if (normalized.position.startsWith("top")) {
    stack.prepend(element);
  } else {
    stack.appendChild(element);
  }
  if (normalized.position.startsWith("bottom")) {
    const win = this.hot.rootWindow;
    win.requestAnimationFrame(() => {
      if (!this.enabled) {
        return;
      }
      stack.scrollTop = stack.scrollHeight;
    });
  }
  const durationMs = normalized.duration;
  const state = {
    id: normalized.id,
    options: normalized,
    element,
    durationMs,
    remainingMs: durationMs,
    paused: false
  };
  _class_private_field_get$2(this, _toasts).set(normalized.id, state);
  _class_private_method_get$1(this, _bindToastEvents, bindToastEvents).call(this, state);
  if (_class_private_field_get$2(this, _regionTabOrderActive)) {
    _class_private_method_get$1(this, _reapplySequentialTabOrderInNotificationHost, reapplySequentialTabOrderInNotificationHost).call(this);
  }
  this.hot.runHooks("afterNotificationShow", normalized.id, normalized);
  if (durationMs > 0) {
    _class_private_method_get$1(this, _queueTick, queueTick).call(this);
  }
}
function bindToastEvents(state) {
  state.toastEventDisposers = [
    this.eventManager.addEventListener(state.element, "click", (event) => {
      _class_private_method_get$1(this, _onToastClick, onToastClick).call(this, event, state);
    }),
    this.eventManager.addEventListener(state.element, "mouseenter", () => {
      state.paused = true;
    }),
    this.eventManager.addEventListener(state.element, "mouseleave", () => {
      state.paused = false;
      if (state.durationMs > 0 && !this.hot.rootDocument.hidden) {
        _class_private_method_get$1(this, _queueTick, queueTick).call(this);
      }
    })
  ];
}
function onToastClick(event, state) {
  const target = event.target;
  if (!(target instanceof this.hot.rootWindow.HTMLElement)) {
    return;
  }
  if (target.closest(`.${NOTIFICATION_CLASS_NAME}__close`)) {
    this.hide(state.id);
    return;
  }
  const actionHost = target.closest("[data-ht-notification-action]");
  if (!actionHost || !state.element.contains(actionHost)) {
    return;
  }
  const index2 = Number.parseInt(actionHost.dataset.htNotificationAction ?? "", 10);
  const action = state.options.actions[index2];
  if (action) {
    action.callback();
  }
}
function clearNotificationRegionTabOrder() {
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (host) {
    NotificationUI.setSequentialFocusWithinHost(host, false);
  }
  _class_private_field_set$2(this, _regionTabOrderActive, false);
}
function reapplySequentialTabOrderInNotificationHost() {
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!host || _class_private_field_get$2(this, _toasts).size === 0) {
    return;
  }
  NotificationUI.setSequentialFocusWithinHost(host, true);
  _class_private_field_set$2(this, _regionTabOrderActive, true);
}
function enterNotificationRegion() {
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!host || _class_private_field_get$2(this, _toasts).size === 0) {
    return;
  }
  const doc = this.hot.rootDocument;
  const active = doc.activeElement;
  if (active instanceof this.hot.rootWindow.HTMLElement && !host.contains(active)) {
    _class_private_field_set$2(this, _focusBeforeRegion, active);
  }
  this.hot.listen();
  this.hot.getFocusScopeManager().activateScope(PLUGIN_KEY$1);
}
function ensureGridScopeActiveForShortcuts() {
  const fsm = this.hot.getFocusScopeManager();
  if (fsm.getActiveScopeId() !== GRID_SCOPE) {
    fsm.activateScope(GRID_SCOPE);
  }
}
function leaveNotificationRegionRestoringPriorFocus() {
  const fsm = this.hot.getFocusScopeManager();
  _class_private_field_set$2(this, _notificationDeactivateRestorePrior, true);
  if (fsm.getActiveScopeId() === PLUGIN_KEY$1) {
    fsm.deactivateScope(PLUGIN_KEY$1);
  } else {
    _class_private_field_set$2(this, _notificationDeactivateRestorePrior, false);
    _class_private_method_get$1(this, _clearNotificationRegionTabOrder, clearNotificationRegionTabOrder).call(this);
    const prev = _class_private_field_get$2(this, _focusBeforeRegion);
    _class_private_field_set$2(this, _focusBeforeRegion, null);
    if (prev?.isConnected) {
      this.hot.getFocusManager().focusElement(prev, {
        preventScroll: true
      });
    }
    _class_private_method_get$1(this, _ensureGridScopeActiveForShortcuts, ensureGridScopeActiveForShortcuts).call(this);
  }
}
function exitNotificationRegion() {
  const doc = this.hot.rootDocument;
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!host?.contains(doc.activeElement)) {
    return;
  }
  _class_private_method_get$1(this, _leaveNotificationRegionRestoringPriorFocus, leaveNotificationRegionRestoringPriorFocus).call(this);
}
function registerFocusScope$1() {
  if (_class_private_field_get$2(this, _focusScopeActive)) {
    return;
  }
  this.hot.getFocusScopeManager().registerScope(PLUGIN_KEY$1, _class_private_field_get$2(this, _ui$1).getHost(), {
    shortcutsContextName: SHORTCUTS_CONTEXT_NAME$1,
    runOnlyIf: () => _class_private_field_get$2(this, _toasts).size > 0,
    enableFocusCatchers: false,
    onActivate: () => {
      const host = _class_private_field_get$2(this, _ui$1)?.getHost();
      if (!host) {
        return;
      }
      _class_private_method_get$1(this, _reapplySequentialTabOrderInNotificationHost, reapplySequentialTabOrderInNotificationHost).call(this);
      _class_private_method_get$1(this, _focusFirstInNotificationRegionUnlessAlreadyFocused, focusFirstInNotificationRegionUnlessAlreadyFocused).call(this);
    },
    onDeactivate: () => {
      _class_private_method_get$1(this, _clearNotificationRegionTabOrder, clearNotificationRegionTabOrder).call(this);
      const restorePrior = _class_private_field_get$2(this, _notificationDeactivateRestorePrior);
      if (restorePrior) {
        _class_private_field_set$2(this, _notificationDeactivateRestorePrior, false);
        const prev = _class_private_field_get$2(this, _focusBeforeRegion);
        _class_private_field_set$2(this, _focusBeforeRegion, null);
        if (prev?.isConnected) {
          this.hot.getFocusManager().focusElement(prev, {
            preventScroll: true
          });
        }
        _class_private_method_get$1(this, _ensureGridScopeActiveForShortcuts, ensureGridScopeActiveForShortcuts).call(this);
      }
    }
  });
  _class_private_field_set$2(this, _focusScopeActive, true);
}
function registerNotificationShortcuts() {
  const manager = this.hot.getShortcutManager();
  const pluginContext = manager.getContext(SHORTCUTS_CONTEXT_NAME$1) ?? manager.addContext(SHORTCUTS_CONTEXT_NAME$1);
  const globalContext = manager.getOrCreateContext(SHORTCUTS_GLOBAL_CONTEXT_NAME, "global");
  const gridContext = manager.getContext(GRID_SCOPE);
  const f6Shortcut = {
    keys: [
      [
        "f6"
      ]
    ],
    preventDefault: true,
    callback: () => {
      _class_private_method_get$1(this, _enterNotificationRegion, enterNotificationRegion).call(this);
    },
    runOnlyIf: () => _class_private_method_get$1(this, _shouldRunNotificationF6Shortcut, shouldRunNotificationF6Shortcut).call(this),
    group: SHORTCUTS_GROUP
  };
  globalContext.addShortcut(f6Shortcut);
  if (gridContext) {
    gridContext.addShortcut(f6Shortcut);
  }
  pluginContext.addShortcut({
    keys: [
      [
        "Escape"
      ]
    ],
    callback: () => _class_private_method_get$1(this, _exitNotificationRegion, exitNotificationRegion).call(this),
    runOnlyIf: () => _class_private_field_get$2(this, _ui$1)?.getHost()?.contains(this.hot.rootDocument.activeElement) === true,
    group: SHORTCUTS_GROUP
  });
  pluginContext.addShortcut({
    keys: [
      [
        "Tab"
      ]
    ],
    preventDefault: true,
    callback: () => _class_private_method_get$1(this, _onTabForwardExitNotificationRegionToGrid, onTabForwardExitNotificationRegionToGrid).call(this),
    runOnlyIf: () => _class_private_method_get$1(this, _shouldHandleTabForwardExitFromNotificationRegion, shouldHandleTabForwardExitFromNotificationRegion).call(this),
    group: SHORTCUTS_GROUP
  });
  pluginContext.addShortcut({
    keys: [
      [
        "Shift",
        "Tab"
      ]
    ],
    preventDefault: true,
    callback: () => _class_private_method_get$1(this, _exitNotificationRegion, exitNotificationRegion).call(this),
    runOnlyIf: () => _class_private_method_get$1(this, _shouldHandleShiftTabExitFromNotificationRegion, shouldHandleShiftTabExitFromNotificationRegion).call(this),
    group: SHORTCUTS_GROUP
  });
}
function unregisterNotificationShortcuts() {
  const sm = this.hot.getShortcutManager();
  sm.getContext(SHORTCUTS_CONTEXT_NAME$1)?.removeShortcutsByGroup(SHORTCUTS_GROUP);
  sm.getContext(SHORTCUTS_GLOBAL_CONTEXT_NAME)?.removeShortcutsByGroup(SHORTCUTS_GROUP);
  sm.getContext(GRID_SCOPE)?.removeShortcutsByGroup(SHORTCUTS_GROUP);
}
function getAllFocusablesInNotificationRegion() {
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!host) {
    return [];
  }
  const toasts = [
    ...host.querySelectorAll(`.${NOTIFICATION_CLASS_NAME}__toast`)
  ];
  const results = [];
  for (let i = 0; i < toasts.length; i += 1) {
    results.push(...NotificationUI.getFocusables(toasts[i]));
  }
  return results;
}
function getFirstFocusableInNotificationRegion() {
  const all = _class_private_method_get$1(this, _getAllFocusablesInNotificationRegion, getAllFocusablesInNotificationRegion).call(this);
  return all[0];
}
function getNotificationRegionFocusableContext() {
  if (_class_private_field_get$2(this, _toasts).size === 0) {
    return null;
  }
  const active = this.hot.rootDocument.activeElement;
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!(active instanceof this.hot.rootWindow.HTMLElement) || !host?.contains(active)) {
    return null;
  }
  const list = _class_private_method_get$1(this, _getAllFocusablesInNotificationRegion, getAllFocusablesInNotificationRegion).call(this);
  if (list.length === 0) {
    return null;
  }
  const idx = list.indexOf(active);
  if (idx === -1) {
    return null;
  }
  if (!_class_private_field_get$2(this, _regionTabOrderActive)) {
    _class_private_method_get$1(this, _reapplySequentialTabOrderInNotificationHost, reapplySequentialTabOrderInNotificationHost).call(this);
  }
  return {
    list,
    idx
  };
}
function shouldHandleTabForwardExitFromNotificationRegion() {
  const ctx = _class_private_method_get$1(this, _getNotificationRegionFocusableContext, getNotificationRegionFocusableContext).call(this);
  return ctx !== null && ctx.idx === ctx.list.length - 1;
}
function shouldHandleShiftTabExitFromNotificationRegion() {
  const ctx = _class_private_method_get$1(this, _getNotificationRegionFocusableContext, getNotificationRegionFocusableContext).call(this);
  return ctx !== null && ctx.idx === 0;
}
function onTabForwardExitNotificationRegionToGrid() {
  const fsm = this.hot.getFocusScopeManager();
  _class_private_field_set$2(this, _notificationDeactivateRestorePrior, false);
  if (fsm.getActiveScopeId() === PLUGIN_KEY$1) {
    fsm.deactivateScope(PLUGIN_KEY$1);
  } else {
    _class_private_method_get$1(this, _clearNotificationRegionTabOrder, clearNotificationRegionTabOrder).call(this);
  }
  this.hot.listen();
  fsm.activateScope(GRID_SCOPE, FOCUS_SOURCES.TAB_FROM_ABOVE);
  _class_private_field_set$2(this, _focusBeforeRegion, null);
}
function unregisterFocusScope$1() {
  if (!_class_private_field_get$2(this, _focusScopeActive)) {
    return;
  }
  this.hot.getFocusScopeManager().unregisterScope(PLUGIN_KEY$1);
  _class_private_field_set$2(this, _focusScopeActive, false);
}
function removeToastState(state, removeDom) {
  if (state.toastEventDisposers) {
    state.toastEventDisposers.forEach((dispose) => dispose());
    state.toastEventDisposers = null;
  }
  _class_private_field_get$2(this, _toasts).delete(state.id);
  if (removeDom) {
    state.element.remove();
  }
}
function isElementInsideNotificationHost(node) {
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!host) {
    return false;
  }
  return node instanceof this.hot.rootWindow.HTMLElement && host.contains(node);
}
function isActiveInsideAnyRemainingToast(active) {
  let inside = false;
  _class_private_field_get$2(this, _toasts).forEach((state) => {
    if (state.element.contains(active)) {
      inside = true;
    }
  });
  return inside;
}
function refocusFirstOpenToastAfterPartialHide() {
  this.hot.listen();
  const fsm = this.hot.getFocusScopeManager();
  if (fsm.getActiveScopeId() === PLUGIN_KEY$1) {
    fsm.deactivateScope(PLUGIN_KEY$1);
  }
  fsm.activateScope(PLUGIN_KEY$1);
}
function focusFirstInNotificationRegionUnlessAlreadyFocused() {
  const doc = this.hot.rootDocument;
  if (!this.enabled || _class_private_field_get$2(this, _toasts).size === 0) {
    return;
  }
  if (_class_private_method_get$1(this, _isActiveInsideAnyRemainingToast, isActiveInsideAnyRemainingToast).call(this, doc.activeElement)) {
    return;
  }
  const first2 = _class_private_method_get$1(this, _getFirstFocusableInNotificationRegion, getFirstFocusableInNotificationRegion).call(this);
  if (first2) {
    this.hot.getFocusManager().focusElement(first2);
  }
}
function shouldThisInstanceHandleF6ForActiveElement(active) {
  if (!(active instanceof this.hot.rootWindow.HTMLElement)) {
    return false;
  }
  const ownerWrapper = active.closest(".ht-root-wrapper");
  if (ownerWrapper !== null) {
    return ownerWrapper === this.hot.rootWrapperElement;
  }
  const roots = this.hot.rootDocument.querySelectorAll(".ht-root-wrapper");
  return roots.length <= 1;
}
function shouldRunNotificationF6Shortcut() {
  if (!this.enabled || _class_private_field_get$2(this, _toasts).size === 0) {
    return false;
  }
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  if (!host) {
    return false;
  }
  const active = this.hot.rootDocument.activeElement;
  if (active instanceof this.hot.rootWindow.HTMLElement && host.contains(active)) {
    return false;
  }
  return _class_private_method_get$1(this, _shouldThisInstanceHandleF6ForActiveElement, shouldThisInstanceHandleF6ForActiveElement).call(this, active);
}
function restoreFocusAfterLastToastLikeEscape() {
  _class_private_method_get$1(this, _leaveNotificationRegionRestoringPriorFocus, leaveNotificationRegionRestoringPriorFocus).call(this);
}
function restoreFocusIfIdle(focusInClosingToast = false) {
  const doc = this.hot.rootDocument;
  const host = _class_private_field_get$2(this, _ui$1)?.getHost();
  const active = doc.activeElement;
  if (_class_private_field_get$2(this, _toasts).size > 0) {
    const activeInHost = active instanceof this.hot.rootWindow.HTMLElement && host?.contains(active) === true;
    if (activeInHost && !_class_private_method_get$1(this, _isActiveInsideAnyRemainingToast, isActiveInsideAnyRemainingToast).call(this, active)) {
      _class_private_method_get$1(this, _refocusFirstOpenToastAfterPartialHide, refocusFirstOpenToastAfterPartialHide).call(this);
    } else if (!activeInHost && focusInClosingToast) {
      _class_private_method_get$1(this, _refocusFirstOpenToastAfterPartialHide, refocusFirstOpenToastAfterPartialHide).call(this);
    }
    return;
  }
  const hadRegionFocus = _class_private_field_get$2(this, _regionTabOrderActive);
  const focusStillInNotificationChrome = _class_private_method_get$1(this, _isElementInsideNotificationHost, isElementInsideNotificationHost).call(this, doc.activeElement);
  const shouldRestoreLikeEscape = hadRegionFocus || focusInClosingToast || focusStillInNotificationChrome;
  if (!shouldRestoreLikeEscape) {
    return;
  }
  _class_private_method_get$1(this, _restoreFocusAfterLastToastLikeEscape, restoreFocusAfterLastToastLikeEscape).call(this);
}
function drainQueueForPosition(position) {
  const limit = this.getSetting("stackLimit");
  const pos = position;
  while (_class_private_field_get$2(this, _queues)[pos].length > 0 && _class_private_method_get$1(this, _countVisibleAt, countVisibleAt).call(this, position) < limit) {
    const next = _class_private_field_get$2(this, _queues)[pos].shift();
    _class_private_method_get$1(this, _mountToast, mountToast).call(this, next);
  }
}
function removeFromQueue(toastId) {
  NOTIFICATION_POSITIONS.forEach((p) => {
    const q = _class_private_field_get$2(this, _queues)[p];
    const idx = q.findIndex((entry) => entry.id === toastId);
    if (idx >= 0) {
      q.splice(idx, 1);
    }
  });
}
function queueTick() {
  if (_class_private_field_get$2(this, _tickQueued) || !this.enabled) {
    return;
  }
  _class_private_field_set$2(this, _tickQueued, true);
  this.hot._registerTimeout(() => {
    _class_private_field_set$2(this, _tickQueued, false);
    if (!this.enabled) {
      return;
    }
    _class_private_method_get$1(this, _runTick, runTick).call(this);
    if (_class_private_method_get$1(this, _hasActiveCountdowns, hasActiveCountdowns).call(this)) {
      _class_private_method_get$1(this, _queueTick, queueTick).call(this);
    }
  }, TICK_MS);
}
function runTick() {
  const doc = this.hot.rootDocument;
  const tabActive = !doc.hidden;
  const toHide = [];
  _class_private_field_get$2(this, _toasts).forEach((state) => {
    if (state.durationMs <= 0) {
      return;
    }
    if (state.paused || !tabActive) {
      return;
    }
    state.remainingMs -= TICK_MS;
    if (state.remainingMs <= 0) {
      toHide.push(state.id);
    }
  });
  toHide.forEach((id) => this.hide(id));
}
function hasActiveCountdowns() {
  const doc = this.hot.rootDocument;
  if (doc.hidden) {
    return false;
  }
  let active = false;
  _class_private_field_get$2(this, _toasts).forEach((s) => {
    if (s.durationMs > 0 && !s.paused) {
      active = true;
    }
  });
  return active;
}
function _check_private_redeclaration$1(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get$1(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set$1(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor$1(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get$1(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor$1(receiver, privateMap, "get");
  return _class_apply_descriptor_get$1(receiver, descriptor);
}
function _class_private_field_init$1(obj, privateMap, value) {
  _check_private_redeclaration$1(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set$1(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor$1(receiver, privateMap, "set");
  _class_apply_descriptor_set$1(receiver, descriptor, value);
  return value;
}
const EMPTY_DATA_STATE_CLASS_NAME = "ht-empty-data-state";
const MIN_HEIGHT = 150;
const TEMPLATE = `<div data-ref="emptyDataStateElement" class="${EMPTY_DATA_STATE_CLASS_NAME} handsontable">
  <div class="${EMPTY_DATA_STATE_CLASS_NAME}__content-wrapper">
    <div data-ref="emptyDataStateInner" class="${EMPTY_DATA_STATE_CLASS_NAME}__content-wrapper-inner"></div>
  </div>
</div>`;
const templateContent = ({ title, description, buttons }, isLoading = false) => {
  const spinnerBlock = isLoading ? `<div class="${EMPTY_DATA_STATE_CLASS_NAME}__spinner" aria-hidden="true"></div>` : "";
  return `
  ${spinnerBlock}
  <div class="${EMPTY_DATA_STATE_CLASS_NAME}__content">
    ${title ? `<h2 class="${EMPTY_DATA_STATE_CLASS_NAME}__title">${stripTags(title)}</h2>` : ""}
    ${description ? `<p class="${EMPTY_DATA_STATE_CLASS_NAME}__description">${stripTags(description)}</p>` : ""}
  </div>
  <div
    data-ref="emptyDataStateButtons"
    class="${EMPTY_DATA_STATE_CLASS_NAME}__buttons${buttons?.length && buttons.length > 0 ? ` ${EMPTY_DATA_STATE_CLASS_NAME}__buttons--has-buttons` : ""}"
  >${!isLoading && buttons?.length && buttons.length > 0 ? buttons.map((button) => `<button class="ht-button ht-button--${button.type}">${stripTags(button.text)}</button>`).join("") : ""}</div>`;
};
function syncEmptyDataStatePlaceholder(rootDocument, view, rows, classNamePrefix, placeholderState) {
  if (rows !== 0) {
    placeholderState.element?.remove();
    placeholderState.element = null;
    return;
  }
  if (!placeholderState.element) {
    placeholderState.element = rootDocument.createElement("div");
    placeholderState.element.classList.add(`${classNamePrefix}-placeholder`);
    view._wt.wtTable.holder.appendChild(placeholderState.element);
  }
  placeholderState.element.style.width = "100%";
  placeholderState.element.style.height = `${MIN_HEIGHT}px`;
}
function computeEmptyDataStateWidth(view, cols, treatAsPopulatedRowsForSizing) {
  let width = view.getWorkspaceWidth();
  if (view.isHorizontallyScrollableByWindow()) {
    if (cols > 0) {
      width = view.getTotalTableWidth();
    } else if (treatAsPopulatedRowsForSizing) {
      width = view.getViewportWidth();
    }
  } else if (view.getTableWidth() - view.getRowHeaderWidth() < view.getViewportWidth() && cols > 0) {
    width = view.getTableWidth();
  }
  return width;
}
function computeEmptyDataStateHeight(view, cols, headerCols, scrollbarSize) {
  let height = view.getTableHeight();
  if (view.isVerticallyScrollableByWindow() || view.hasVerticalScroll()) {
    if (cols > 0) {
      height = view.hot.getTableHeight() - view.getColumnHeaderHeight();
    } else {
      height = view.hot.getTableHeight();
    }
  } else if (headerCols > 0 && cols > 0) {
    height = view.getViewportHeight() - scrollbarSize;
  } else if (headerCols > 0 && cols === 0) {
    height = view.getWorkspaceHeight() - scrollbarSize;
  }
  return height;
}
var _gridContainer = /* @__PURE__ */ new WeakMap(), _rootDocument = /* @__PURE__ */ new WeakMap(), _refs = /* @__PURE__ */ new WeakMap(), _placeholderElement = /* @__PURE__ */ new WeakMap();
class EmptyDataStateUI {
  /**
  * Creates the emptyDataState UI elements and sets up the structure.
  */
  install() {
    if (_class_private_field_get$1(this, _refs)?.emptyDataStateElement) {
      return;
    }
    const elements = html`${TEMPLATE}`;
    _class_private_field_set$1(this, _refs, elements.refs);
    const { emptyDataStateInner, emptyDataStateElement } = _class_private_field_get$1(this, _refs);
    setAttribute(emptyDataStateInner, [
      A11Y_TABINDEX(-1)
    ]);
    setAttribute(emptyDataStateElement, [
      A11Y_TABINDEX(-1)
    ]);
    if (_class_private_field_get$1(this, _gridContainer)) {
      _class_private_field_get$1(this, _gridContainer).appendChild(elements.fragment);
    }
  }
  /**
  * Gets the emptyDataState element.
  *
  * @returns {HTMLElement} The empty data state element.
  */
  getElement() {
    return _class_private_field_get$1(this, _refs)?.emptyDataStateElement;
  }
  /**
  * Gets the focusable elements of the emptyDataState element.
  *
  * @returns {HTMLElement[]} The focusable elements.
  */
  getFocusableElements() {
    const { emptyDataStateButtons, emptyDataStateInner } = _class_private_field_get$1(this, _refs);
    const emptyDataStateButtonsElements = Array.from(emptyDataStateButtons?.children ?? []);
    if (emptyDataStateButtonsElements.length === 0) {
      return [
        emptyDataStateInner
      ];
    }
    return emptyDataStateButtonsElements;
  }
  /**
  * Shows the emptyDataState element.
  */
  show() {
    if (!_class_private_field_get$1(this, _refs)?.emptyDataStateElement) {
      return;
    }
    _class_private_field_get$1(this, _refs).emptyDataStateElement.style.display = "block";
  }
  /**
  * Hides the emptyDataState element.
  */
  hide() {
    if (!_class_private_field_get$1(this, _refs)?.emptyDataStateElement) {
      return;
    }
    _class_private_field_get$1(this, _placeholderElement)?.remove();
    _class_private_field_set$1(this, _placeholderElement, null);
    _class_private_field_get$1(this, _refs).emptyDataStateElement.style.display = "none";
  }
  /**
  * Updates the content of the emptyDataState element.
  *
  * @param {string | object} message - The message to update.
  * @param {boolean} isLoading - When `true`, shows a loading spinner.
  * @returns {void}
  */
  updateContent(message, isLoading = false) {
    const { emptyDataStateElement, emptyDataStateInner } = _class_private_field_get$1(this, _refs);
    let content;
    if (typeof message === "string") {
      content = {
        title: message
      };
    } else {
      content = {
        title: message?.title,
        description: message?.description,
        buttons: message?.buttons
      };
    }
    const template = html`${templateContent(content, isLoading)}`;
    if (isLoading) {
      addClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--loading`);
      setAttribute(emptyDataStateInner, [
        A11Y_BUSY()
      ]);
    } else {
      removeClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--loading`);
      removeAttribute(emptyDataStateInner, A11Y_BUSY()[0]);
    }
    _class_private_field_set$1(this, _refs, {
      ..._class_private_field_get$1(this, _refs),
      ...template.refs
    });
    emptyDataStateInner.innerHTML = "";
    emptyDataStateInner.appendChild(template.fragment);
    if (!isLoading && content.buttons?.length && content.buttons.length > 0) {
      Array.from(_class_private_field_get$1(this, _refs).emptyDataStateButtons.children).forEach((button, index2) => {
        button.addEventListener("click", content.buttons[index2].callback);
      });
    }
  }
  /**
  * Updates the class names of the emptyDataState element.
  *
  * @param {View} view - The view instance.
  */
  updateClassNames(view) {
    const { emptyDataStateElement } = _class_private_field_get$1(this, _refs);
    if (view.countRenderableColumns() > 0 && view.getColumnHeadersCount() > 0) {
      addClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--disable-top-border`);
    } else {
      removeClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--disable-top-border`);
    }
    if (view.countRenderableRows() > 0 && view.getRowHeadersCount() > 0) {
      addClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--disable-inline-border`);
    } else {
      removeClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--disable-inline-border`);
    }
    if (view.hasHorizontalScroll() && !view.isHorizontallyScrollableByWindow()) {
      addClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--disable-bottom-border`);
    } else {
      removeClass(emptyDataStateElement, `${EMPTY_DATA_STATE_CLASS_NAME}--disable-bottom-border`);
    }
  }
  /**
  * Updates the size of the emptyDataState element.
  *
  * @param {View} view - The view instance.
  * @param {boolean} [isLoading] - When `true` and the grid has renderable columns, use the same
  *   workspace sizing as when renderable rows exist (e.g. DataProvider fetch while a page is still shown).
  */
  updateSize(view, isLoading = false) {
    const { emptyDataStateElement } = _class_private_field_get$1(this, _refs);
    const scrollbarSize = view.hasHorizontalScroll() ? getScrollbarWidth(view.hot.rootDocument) : 0;
    const rows = view.countRenderableRows();
    const cols = view.countRenderableColumns();
    const headerCols = view.getColumnHeadersCount();
    const extendLayoutForLoading = isLoading === true && cols > 0;
    const treatAsPopulatedRowsForSizing = rows > 0 || extendLayoutForLoading;
    emptyDataStateElement.style.top = cols > 0 ? `${view.getColumnHeaderHeight()}px` : "0px";
    emptyDataStateElement.style.insetInlineStart = "0px";
    const placeholderState = {
      element: _class_private_field_get$1(this, _placeholderElement)
    };
    syncEmptyDataStatePlaceholder(_class_private_field_get$1(this, _rootDocument), view, rows, EMPTY_DATA_STATE_CLASS_NAME, placeholderState);
    _class_private_field_set$1(this, _placeholderElement, placeholderState.element);
    const width = computeEmptyDataStateWidth(view, cols, treatAsPopulatedRowsForSizing);
    const height = computeEmptyDataStateHeight(view, cols, headerCols, scrollbarSize);
    emptyDataStateElement.style.width = `${width}px`;
    emptyDataStateElement.style.height = `${height}px`;
  }
  /**
  * Removes the emptyDataState UI elements from the DOM and clears the refs.
  */
  destroy() {
    _class_private_field_get$1(this, _refs)?.emptyDataStateElement?.remove();
    _class_private_field_get$1(this, _placeholderElement)?.remove();
    _class_private_field_set$1(this, _placeholderElement, null);
    _class_private_field_set$1(this, _refs, null);
  }
  /**
  * Initializes the empty data state UI with the grid container and document, then builds and inserts the DOM structure.
  */
  constructor({ gridContainer, rootDocument }) {
    _class_private_field_init$1(this, _gridContainer, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1(this, _rootDocument, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1(this, _refs, {
      writable: true,
      value: void 0
    });
    _class_private_field_init$1(this, _placeholderElement, {
      writable: true,
      value: void 0
    });
    _class_private_field_set$1(this, _refs, null);
    _class_private_field_set$1(this, _placeholderElement, null);
    _class_private_field_set$1(this, _gridContainer, gridContainer);
    _class_private_field_set$1(this, _rootDocument, rootDocument);
    this.install();
  }
}
function _check_private_redeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_apply_descriptor_get(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
  return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
  _check_private_redeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
  _class_apply_descriptor_set(receiver, descriptor, value);
  return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _class_private_method_init(obj, privateSet) {
  _check_private_redeclaration(obj, privateSet);
  privateSet.add(obj);
}
function isPlainRecord(v) {
  return isObject$1(v);
}
const PLUGIN_KEY = "emptyDataState";
const PLUGIN_PRIORITY = 370;
const SOURCE = Object.freeze({
  UNKNOWN: "unknown",
  FILTERS: "filters",
  LOADING: "loading"
});
const SHORTCUTS_CONTEXT_NAME = `plugin:${PLUGIN_KEY}`;
var _isVisible = /* @__PURE__ */ new WeakMap(), _ui = /* @__PURE__ */ new WeakMap(), _hasFilterConditions = /* @__PURE__ */ new WeakMap(), _selectionState = /* @__PURE__ */ new WeakMap(), _loadingActive = /* @__PURE__ */ new WeakMap(), _registerEvents = /* @__PURE__ */ new WeakSet(), _setLoadingActive = /* @__PURE__ */ new WeakSet(), _clearLoadingActive = /* @__PURE__ */ new WeakSet(), _registerFocusScope = /* @__PURE__ */ new WeakSet(), _unregisterFocusScope = /* @__PURE__ */ new WeakSet(), _getMessage = /* @__PURE__ */ new WeakSet(), _toggleEmptyDataState = /* @__PURE__ */ new WeakSet(), _show = /* @__PURE__ */ new WeakSet(), _update = /* @__PURE__ */ new WeakSet(), _hide = /* @__PURE__ */ new WeakSet(), _onMouseWheel = /* @__PURE__ */ new WeakSet(), _onAfterInit = /* @__PURE__ */ new WeakMap(), _onAfterRender = /* @__PURE__ */ new WeakMap(), _onBeforeFilter = /* @__PURE__ */ new WeakMap();
class EmptyDataState extends BasePlugin {
  /**
  * Returns the plugin key used to identify this plugin in Handsontable settings.
  */
  static get PLUGIN_KEY() {
    return PLUGIN_KEY;
  }
  /**
  * Returns the priority order used to determine the order in which plugins are initialized.
  */
  static get PLUGIN_PRIORITY() {
    return PLUGIN_PRIORITY;
  }
  /**
  * Returns the default settings applied when the plugin is enabled without explicit configuration.
  */
  static get DEFAULT_SETTINGS() {
    return {
      message: void 0
    };
  }
  /**
  * Returns validator functions for each plugin setting to verify their values are valid before applying them.
  */
  static get SETTINGS_VALIDATORS() {
    return {
      message: (value) => {
        if (typeof value === "string" || typeof value === "function" || value === void 0) {
          return true;
        }
        if (!isPlainRecord(value)) {
          return false;
        }
        return (typeof value.title === "undefined" || typeof value.title === "string") && (typeof value.description === "undefined" || typeof value.description === "string") && (typeof value.buttons === "undefined" || Array.isArray(value.buttons) && value.buttons.every((item) => typeof item === "object" && typeof item.text === "string" && typeof item.type === "string" && [
          "primary",
          "secondary"
        ].includes(item.type) && typeof item.callback === "function"));
      }
    };
  }
  /**
  * Check if the plugin is enabled in the handsontable settings.
  *
  * @returns {boolean}
  */
  isEnabled() {
    return !!this.hot.getSettings()[PLUGIN_KEY];
  }
  /**
  * Enable plugin for this Handsontable instance.
  */
  enablePlugin() {
    if (this.enabled) {
      return;
    }
    if (!_class_private_field_get(this, _ui)) {
      _class_private_field_set(this, _ui, new EmptyDataStateUI({
        gridContainer: this.hot.rootGridElement,
        rootDocument: this.hot.rootDocument
      }));
      _class_private_method_get(this, _registerFocusScope, registerFocusScope).call(this);
      _class_private_method_get(this, _registerEvents, registerEvents).call(this);
    }
    this.addHook("afterInit", _class_private_field_get(this, _onAfterInit));
    this.addHook("afterRender", _class_private_field_get(this, _onAfterRender));
    this.addHook("afterRowSequenceCacheUpdate", () => {
      _class_private_method_get(this, _toggleEmptyDataState, toggleEmptyDataState).call(this);
    });
    this.addHook("afterColumnSequenceCacheUpdate", () => {
      _class_private_method_get(this, _toggleEmptyDataState, toggleEmptyDataState).call(this);
    });
    this.addHook("beforeFilter", _class_private_field_get(this, _onBeforeFilter));
    this.addHook("beforeDataProviderFetch", (queryParameters) => {
      if (!queryParameters.skipLoading) {
        _class_private_method_get(this, _setLoadingActive, setLoadingActive).call(this);
      }
    });
    this.addHook("afterDataProviderFetch", () => _class_private_method_get(this, _clearLoadingActive, clearLoadingActive).call(this));
    this.addHook("afterDataProviderFetchError", () => _class_private_method_get(this, _clearLoadingActive, clearLoadingActive).call(this));
    super.enablePlugin();
    _class_private_method_get(this, _toggleEmptyDataState, toggleEmptyDataState).call(this);
  }
  /**
  * Update plugin state after Handsontable settings update.
  */
  updatePlugin() {
    this.disablePlugin();
    this.enablePlugin();
    _class_private_method_get(this, _update, update).call(this);
    if (this.isVisible()) {
      _class_private_field_get(this, _ui)?.show();
    }
    super.updatePlugin();
  }
  /**
  * Disable plugin for this Handsontable instance.
  */
  disablePlugin() {
    _class_private_field_set(this, _loadingActive, false);
    _class_private_method_get(this, _unregisterFocusScope, unregisterFocusScope).call(this);
    _class_private_field_get(this, _ui)?.destroy();
    _class_private_field_set(this, _ui, null);
    super.disablePlugin();
  }
  /**
  * Check if the plugin is currently visible.
  *
  * @returns {boolean}
  */
  isVisible() {
    return _class_private_field_get(this, _isVisible);
  }
  /**
  * Destroy plugin instance.
  */
  destroy() {
    _class_private_field_set(this, _loadingActive, false);
    _class_private_field_set(this, _isVisible, false);
    _class_private_field_get(this, _ui)?.destroy();
    _class_private_field_set(this, _ui, null);
    _class_private_field_set(this, _hasFilterConditions, false);
    _class_private_field_set(this, _selectionState, null);
    super.destroy();
  }
  constructor(...args) {
    super(...args), _class_private_method_init(this, _registerEvents), _class_private_method_init(this, _setLoadingActive), _class_private_method_init(this, _clearLoadingActive), _class_private_method_init(this, _registerFocusScope), _class_private_method_init(this, _unregisterFocusScope), _class_private_method_init(this, _getMessage), _class_private_method_init(this, _toggleEmptyDataState), _class_private_method_init(this, _show), _class_private_method_init(this, _update), _class_private_method_init(this, _hide), _class_private_method_init(this, _onMouseWheel), _class_private_field_init(this, _isVisible, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _ui, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _hasFilterConditions, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _selectionState, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _loadingActive, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _onAfterInit, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _onAfterRender, {
      writable: true,
      value: void 0
    }), _class_private_field_init(this, _onBeforeFilter, {
      writable: true,
      value: void 0
    }), _class_private_field_set(this, _isVisible, false), _class_private_field_set(this, _ui, null), _class_private_field_set(this, _hasFilterConditions, false), _class_private_field_set(this, _selectionState, null), _class_private_field_set(this, _loadingActive, false), _class_private_field_set(this, _onAfterInit, () => {
      _class_private_method_get(this, _toggleEmptyDataState, toggleEmptyDataState).call(this);
      this.hot.render();
    }), _class_private_field_set(this, _onAfterRender, () => {
      if (_class_private_field_get(this, _ui)?.getElement() && this.isVisible() && this.hot.view) {
        _class_private_field_get(this, _ui).updateSize(this.hot.view, _class_private_field_get(this, _loadingActive));
        _class_private_field_get(this, _ui).updateClassNames(this.hot.view);
      }
    }), _class_private_field_set(this, _onBeforeFilter, (conditions2) => {
      _class_private_field_set(this, _hasFilterConditions, conditions2?.length > 0);
      if (this.isVisible()) {
        _class_private_method_get(this, _update, update).call(this);
      }
    });
  }
}
function registerEvents() {
  this.eventManager.addEventListener(_class_private_field_get(this, _ui).getElement(), "wheel", (event) => {
    _class_private_method_get(this, _onMouseWheel, onMouseWheel).call(this, event);
  });
}
function setLoadingActive() {
  if (_class_private_field_get(this, _loadingActive)) {
    return;
  }
  _class_private_field_set(this, _loadingActive, true);
  _class_private_method_get(this, _toggleEmptyDataState, toggleEmptyDataState).call(this);
}
function clearLoadingActive() {
  if (!_class_private_field_get(this, _loadingActive)) {
    return;
  }
  _class_private_field_set(this, _loadingActive, false);
  _class_private_method_get(this, _hide, hide).call(this);
  _class_private_method_get(this, _toggleEmptyDataState, toggleEmptyDataState).call(this);
  this.hot.render();
}
function registerFocusScope() {
  this.hot.getFocusScopeManager().registerScope(PLUGIN_KEY, _class_private_field_get(this, _ui).getElement(), {
    shortcutsContextName: SHORTCUTS_CONTEXT_NAME,
    runOnlyIf: () => this.isVisible(),
    onActivate: (focusSource) => {
      const focusableElements = _class_private_field_get(this, _ui)?.getFocusableElements() ?? [];
      if (focusableElements.length > 0) {
        if (focusSource === "tab_from_above") {
          focusableElements.at(0)?.focus();
        } else if (focusSource === "tab_from_below") {
          focusableElements.at(-1)?.focus();
        }
      }
    }
  });
}
function unregisterFocusScope() {
  this.hot.getFocusScopeManager().unregisterScope(PLUGIN_KEY);
}
function getMessage(source) {
  const messageSetting = this.getSetting("message");
  let message;
  if (typeof messageSetting === "function") {
    message = messageSetting(source);
  } else {
    message = messageSetting;
  }
  if (typeof message === "string") {
    message = {
      title: message
    };
  }
  if (!message?.title && !message?.description && !message?.buttons) {
    const result = {};
    if (source === SOURCE.FILTERS) {
      result.title = this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_TITLE_FILTERS);
      result.description = this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_DESCRIPTION_FILTERS);
      result.buttons = [
        {
          text: this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_BUTTONS_FILTERS_RESET),
          type: "secondary",
          callback: () => {
            const filtersPlugin = this.hot.getPlugin("filters");
            if (filtersPlugin) {
              filtersPlugin.clearConditions();
              filtersPlugin.filter();
            }
          }
        }
      ];
    } else if (source === SOURCE.LOADING) {
      result.title = this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_TITLE_LOADING);
      result.description = this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_DESCRIPTION_LOADING);
    } else {
      result.title = this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_TITLE);
      result.description = this.hot.getTranslatedPhrase(EMPTY_DATA_STATE_DESCRIPTION);
    }
    return result;
  }
  return message;
}
function toggleEmptyDataState() {
  if (!this.hot.view) {
    return;
  }
  if (_class_private_field_get(this, _loadingActive)) {
    if (_class_private_field_get(this, _isVisible)) {
      _class_private_method_get(this, _update, update).call(this);
    } else {
      _class_private_method_get(this, _show, show).call(this);
    }
    return;
  }
  if (this.hot.view.countRenderableColumns() === 0 || this.hot.view.countRenderableRows() === 0) {
    _class_private_method_get(this, _show, show).call(this);
  } else {
    _class_private_method_get(this, _hide, hide).call(this);
  }
}
function show() {
  if (_class_private_field_get(this, _isVisible)) {
    return;
  }
  this.hot.runHooks("beforeEmptyDataStateShow");
  _class_private_method_get(this, _update, update).call(this);
  _class_private_field_get(this, _ui)?.show();
  _class_private_field_set(this, _isVisible, true);
  _class_private_field_set(this, _selectionState, this.hot.selection.exportSelection());
  this.hot.getFocusScopeManager().activateScope(PLUGIN_KEY);
  this.hot.runHooks("afterEmptyDataStateShow");
}
function update() {
  if (_class_private_field_get(this, _loadingActive)) {
    _class_private_field_get(this, _ui)?.updateContent(_class_private_method_get(this, _getMessage, getMessage).call(this, SOURCE.LOADING), true);
  } else if (_class_private_field_get(this, _hasFilterConditions)) {
    _class_private_field_get(this, _ui)?.updateContent(_class_private_method_get(this, _getMessage, getMessage).call(this, SOURCE.FILTERS), false);
  } else {
    _class_private_field_get(this, _ui)?.updateContent(_class_private_method_get(this, _getMessage, getMessage).call(this, SOURCE.UNKNOWN), false);
  }
}
function hide() {
  if (!_class_private_field_get(this, _isVisible)) {
    return;
  }
  this.hot.runHooks("beforeEmptyDataStateHide");
  _class_private_field_get(this, _ui)?.hide();
  _class_private_field_set(this, _isVisible, false);
  this.hot.getFocusScopeManager().deactivateScope(PLUGIN_KEY);
  if (_class_private_field_get(this, _selectionState) && _class_private_field_get(this, _selectionState).ranges.length > 0) {
    this.hot.selection.importSelection({
      ..._class_private_field_get(this, _selectionState),
      activeRange: _class_private_field_get(this, _selectionState).activeRange
    });
    this.hot.view.render();
    _class_private_field_set(this, _selectionState, null);
  } else {
    this.hot.selectCell(0, 0, void 0, void 0, false);
  }
  this.hot.runHooks("afterEmptyDataStateHide");
}
function onMouseWheel(event) {
  const extendedEvent = event;
  const wheelDeltaX = extendedEvent.wheelDeltaX ?? 0;
  const deltaX = Number.isNaN(event.deltaX) ? -1 * wheelDeltaX : event.deltaX;
  if (deltaX !== 0 && this.hot.view.hasHorizontalScroll() && !this.hot.view.isHorizontallyScrollableByWindow()) {
    this.hot.view.setTableScrollPosition({
      left: this.hot.view.getTableScrollPosition().left + deltaX
    });
    event.preventDefault();
  }
}
function registerAllPlugins() {
  registerPlugin(AutoColumnSize);
  registerPlugin(Autofill);
  registerPlugin(AutoRowSize);
  registerPlugin(BindRowsWithHeaders);
  registerPlugin(CollapsibleColumns);
  registerPlugin(ColumnSorting);
  registerPlugin(ColumnSummary);
  registerPlugin(Comments);
  registerPlugin(ContextMenu);
  registerPlugin(CopyPaste);
  registerPlugin(CustomBorders);
  registerPlugin(DataProvider$1);
  registerPlugin(DragToScroll);
  registerPlugin(DropdownMenu);
  registerPlugin(ExportFile);
  registerPlugin(Filters);
  registerPlugin(Formulas);
  registerPlugin(HiddenColumns);
  registerPlugin(HiddenRows);
  registerPlugin(ManualColumnFreeze);
  registerPlugin(ManualColumnMove);
  registerPlugin(ManualColumnResize);
  registerPlugin(ManualRowMove);
  registerPlugin(ManualRowResize);
  registerPlugin(MergeCells);
  registerPlugin(MultiColumnSorting);
  registerPlugin(MultipleSelectionHandles);
  registerPlugin(NestedHeaders);
  registerPlugin(NestedRows);
  registerPlugin(Pagination);
  registerPlugin(Search);
  registerPlugin(StretchColumns);
  registerPlugin(TouchScroll);
  registerPlugin(TrimRows);
  registerPlugin(UndoRedo2);
  registerPlugin(Dialog);
  registerPlugin(Loading);
  registerPlugin(Notification);
  registerPlugin(EmptyDataState);
}
function registerAllModules() {
  registerAllEditors();
  registerAllRenderers();
  registerAllValidators();
  registerAllCellTypes();
  registerAllPlugins();
}
registerAllModules();
const spreadsheet = React__default.memo(function SpreadsheetRenderer(props) {
  let { id, SVs, actions, callAction } = useDoenetRenderer(props);
  const { darkMode } = useContext(DocContext) || {};
  const ref = useRef(null);
  useRecordVisibilityChanges(ref, callAction, actions);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      id,
      style: {
        margin: getBlockMarginWithOptionalTopSuppression({
          suppressTopMargin: !!SVs.renderInlineForListItem
        })
      },
      ref,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        HotTable,
        {
          licenseKey: "non-commercial-and-evaluation",
          theme: darkMode === "dark" ? "ht-theme-classic-dark" : "ht-theme-classic",
          ariaTags: false,
          data: SVs.cells.map((x) => [...x]),
          colHeaders: SVs.columnHeaders,
          rowHeaders: SVs.rowHeaders,
          width: sizeToCSS(SVs.width),
          height: sizeToCSS(SVs.height),
          afterChange: (changes, source) => callAction({
            action: actions.onChange,
            args: { changes, source }
          }),
          formulas: {
            engine: HyperFormula
          },
          fixedRowsTop: SVs.fixedRowsTop,
          fixedColumnsLeft: SVs.fixedColumnsLeft,
          hiddenColumns: {
            columns: SVs.hiddenColumns.map((x) => x - 1),
            indicators: false
          },
          hiddenRows: {
            rows: SVs.hiddenRows.map((x) => x - 1),
            indicators: false
          },
          readOnly: SVs.disabled,
          disableVisualSelection: SVs.disabled,
          stretchH: "all"
        }
      )
    }
  );
});
export {
  spreadsheet as default
};
